(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './components-resources-library.js', './androidx-compose-runtime-runtime.js', './coil-root-coil-compose.js', './compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose.js', './projects-core-koin-core-viewmodel.js', './projects-compose-koin-compose.js', './kotlinx-coroutines-core.js', './supabase-kt-postgrest-kt.js', './kotlinx-serialization-kotlinx-serialization-json.js', './supabase-kt-auth-kt.js', './ktor-ktor-client-content-negotiation.js', './ktor-ktor-serialization-kotlinx-json.js', './kotlinx-serialization-kotlinx-serialization-core.js', './ktor-ktor-client-core.js', './ktor-ktor-http.js', './ktor-ktor-utils.js', './projects-core-koin-core.js', './supabase-kt-supabase-kt.js', './supabase-kt-storage-kt.js', './supabase-kt-functions-kt.js', './supabase-kt-realtime-kt.js', './androidx-lifecycle-lifecycle-viewmodel-savedstate.js', './androidx-lifecycle-lifecycle-viewmodel.js', './androidx-compose-runtime-runtime-saveable.js', './compose-multiplatform-core-compose-material3-adaptive-adaptive.js', './compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite.js', './compose-multiplatform-core-compose-material-material-icons-core.js', './compose-multiplatform-core-compose-material-material-icons-extended.js', './compose-multiplatform-core-compose-ui-ui-graphics.js', './compose-multiplatform-core-compose-material3-material3.js', './compose-multiplatform-core-compose-ui-ui-unit.js', './compose-multiplatform-core-compose-ui-ui-text.js', './compose-multiplatform-core-compose-animation-animation-core.js', './compose-multiplatform-core-compose-animation-animation.js', './compose-multiplatform-core-compose-ui-ui.js', './compose-multiplatform-core-compose-foundation-foundation-layout.js', './androidx-navigation3-navigation3-runtime.js', './compose-multiplatform-core-compose-foundation-foundation.js', './compose-multiplatform-core-navigation3-navigation3-ui.js', './Kotlin-DateTime-library-kotlinx-datetime.js', './androidx-window-window-core.js', './compose-imageLoader-image-loader-singleton.js', './compose-imageLoader-image-loader.js', './compose-multiplatform-core-compose-ui-ui-geometry.js', './androidx-lifecycle-lifecycle-runtime-compose.js', './androidx-lifecycle-lifecycle-common.js', './coil-root-coil-core.js', './coil-root-coil-network-ktor3.js', './okio-parent-okio.js', './skiko-kjs.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./components-resources-library.js'), require('./androidx-compose-runtime-runtime.js'), require('./coil-root-coil-compose.js'), require('./compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose.js'), require('./projects-core-koin-core-viewmodel.js'), require('./projects-compose-koin-compose.js'), require('./kotlinx-coroutines-core.js'), require('./supabase-kt-postgrest-kt.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./supabase-kt-auth-kt.js'), require('./ktor-ktor-client-content-negotiation.js'), require('./ktor-ktor-serialization-kotlinx-json.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./ktor-ktor-client-core.js'), require('./ktor-ktor-http.js'), require('./ktor-ktor-utils.js'), require('./projects-core-koin-core.js'), require('./supabase-kt-supabase-kt.js'), require('./supabase-kt-storage-kt.js'), require('./supabase-kt-functions-kt.js'), require('./supabase-kt-realtime-kt.js'), require('./androidx-lifecycle-lifecycle-viewmodel-savedstate.js'), require('./androidx-lifecycle-lifecycle-viewmodel.js'), require('./androidx-compose-runtime-runtime-saveable.js'), require('./compose-multiplatform-core-compose-material3-adaptive-adaptive.js'), require('./compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite.js'), require('./compose-multiplatform-core-compose-material-material-icons-core.js'), require('./compose-multiplatform-core-compose-material-material-icons-extended.js'), require('./compose-multiplatform-core-compose-ui-ui-graphics.js'), require('./compose-multiplatform-core-compose-material3-material3.js'), require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./compose-multiplatform-core-compose-ui-ui-text.js'), require('./compose-multiplatform-core-compose-animation-animation-core.js'), require('./compose-multiplatform-core-compose-animation-animation.js'), require('./compose-multiplatform-core-compose-ui-ui.js'), require('./compose-multiplatform-core-compose-foundation-foundation-layout.js'), require('./androidx-navigation3-navigation3-runtime.js'), require('./compose-multiplatform-core-compose-foundation-foundation.js'), require('./compose-multiplatform-core-navigation3-navigation3-ui.js'), require('./Kotlin-DateTime-library-kotlinx-datetime.js'), require('./androidx-window-window-core.js'), require('./compose-imageLoader-image-loader-singleton.js'), require('./compose-imageLoader-image-loader.js'), require('./compose-multiplatform-core-compose-ui-ui-geometry.js'), require('./androidx-lifecycle-lifecycle-runtime-compose.js'), require('./androidx-lifecycle-lifecycle-common.js'), require('./coil-root-coil-core.js'), require('./coil-root-coil-network-ktor3.js'), require('./okio-parent-okio.js'), require('./skiko-kjs.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['components-resources-library'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'components-resources-library' was not found. Please, check whether 'components-resources-library' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['coil-root-coil-compose'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'coil-root-coil-compose' was not found. Please, check whether 'coil-root-coil-compose' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose' was not found. Please, check whether 'compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['projects-core-koin-core-viewmodel'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'projects-core-koin-core-viewmodel' was not found. Please, check whether 'projects-core-koin-core-viewmodel' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['projects-compose-koin-compose'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'projects-compose-koin-compose' was not found. Please, check whether 'projects-compose-koin-compose' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['supabase-kt-postgrest-kt'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'supabase-kt-postgrest-kt' was not found. Please, check whether 'supabase-kt-postgrest-kt' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['supabase-kt-auth-kt'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'supabase-kt-auth-kt' was not found. Please, check whether 'supabase-kt-auth-kt' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['ktor-ktor-client-content-negotiation'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'ktor-ktor-client-content-negotiation' was not found. Please, check whether 'ktor-ktor-client-content-negotiation' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['ktor-ktor-serialization-kotlinx-json'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'ktor-ktor-serialization-kotlinx-json' was not found. Please, check whether 'ktor-ktor-serialization-kotlinx-json' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['projects-core-koin-core'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'projects-core-koin-core' was not found. Please, check whether 'projects-core-koin-core' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['supabase-kt-supabase-kt'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'supabase-kt-supabase-kt' was not found. Please, check whether 'supabase-kt-supabase-kt' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['supabase-kt-storage-kt'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'supabase-kt-storage-kt' was not found. Please, check whether 'supabase-kt-storage-kt' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['supabase-kt-functions-kt'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'supabase-kt-functions-kt' was not found. Please, check whether 'supabase-kt-functions-kt' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['supabase-kt-realtime-kt'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'supabase-kt-realtime-kt' was not found. Please, check whether 'supabase-kt-realtime-kt' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-viewmodel-savedstate'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'androidx-lifecycle-lifecycle-viewmodel-savedstate' was not found. Please, check whether 'androidx-lifecycle-lifecycle-viewmodel-savedstate' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-viewmodel'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'androidx-lifecycle-lifecycle-viewmodel' was not found. Please, check whether 'androidx-lifecycle-lifecycle-viewmodel' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime-saveable'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'androidx-compose-runtime-runtime-saveable' was not found. Please, check whether 'androidx-compose-runtime-runtime-saveable' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-material3-adaptive-adaptive'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-material3-adaptive-adaptive' was not found. Please, check whether 'compose-multiplatform-core-compose-material3-adaptive-adaptive' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite' was not found. Please, check whether 'compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-material-material-icons-core'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-material-material-icons-core' was not found. Please, check whether 'compose-multiplatform-core-compose-material-material-icons-core' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-material-material-icons-extended'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-material-material-icons-extended' was not found. Please, check whether 'compose-multiplatform-core-compose-material-material-icons-extended' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-ui-ui-graphics' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-graphics' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-material3-material3'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-material3-material3' was not found. Please, check whether 'compose-multiplatform-core-compose-material3-material3' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-text'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-ui-ui-text' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-text' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-animation-animation-core'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-animation-animation-core' was not found. Please, check whether 'compose-multiplatform-core-compose-animation-animation-core' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-animation-animation'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-animation-animation' was not found. Please, check whether 'compose-multiplatform-core-compose-animation-animation' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-foundation-foundation-layout'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-foundation-foundation-layout' was not found. Please, check whether 'compose-multiplatform-core-compose-foundation-foundation-layout' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['androidx-navigation3-navigation3-runtime'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'androidx-navigation3-navigation3-runtime' was not found. Please, check whether 'androidx-navigation3-navigation3-runtime' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-foundation-foundation'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-foundation-foundation' was not found. Please, check whether 'compose-multiplatform-core-compose-foundation-foundation' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-navigation3-navigation3-ui'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-navigation3-navigation3-ui' was not found. Please, check whether 'compose-multiplatform-core-navigation3-navigation3-ui' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['Kotlin-DateTime-library-kotlinx-datetime'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'Kotlin-DateTime-library-kotlinx-datetime' was not found. Please, check whether 'Kotlin-DateTime-library-kotlinx-datetime' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['androidx-window-window-core'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'androidx-window-window-core' was not found. Please, check whether 'androidx-window-window-core' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-imageLoader-image-loader-singleton'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-imageLoader-image-loader-singleton' was not found. Please, check whether 'compose-imageLoader-image-loader-singleton' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-imageLoader-image-loader'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-imageLoader-image-loader' was not found. Please, check whether 'compose-imageLoader-image-loader' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-geometry'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'compose-multiplatform-core-compose-ui-ui-geometry' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-geometry' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-runtime-compose'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'androidx-lifecycle-lifecycle-runtime-compose' was not found. Please, check whether 'androidx-lifecycle-lifecycle-runtime-compose' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-common'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'androidx-lifecycle-lifecycle-common' was not found. Please, check whether 'androidx-lifecycle-lifecycle-common' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['coil-root-coil-core'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'coil-root-coil-core' was not found. Please, check whether 'coil-root-coil-core' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['coil-root-coil-network-ktor3'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'coil-root-coil-network-ktor3' was not found. Please, check whether 'coil-root-coil-network-ktor3' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['okio-parent-okio'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'okio-parent-okio' was not found. Please, check whether 'okio-parent-okio' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    if (typeof globalThis['skiko-kjs'] === 'undefined') {
      throw new Error("Error loading module 'Hadaya_client_web-shared'. Its dependency 'skiko-kjs' was not found. Please, check whether 'skiko-kjs' is loaded prior to 'Hadaya_client_web-shared'.");
    }
    globalThis['Hadaya_client_web-shared'] = factory(typeof globalThis['Hadaya_client_web-shared'] === 'undefined' ? {} : globalThis['Hadaya_client_web-shared'], globalThis['kotlin-kotlin-stdlib'], globalThis['components-resources-library'], globalThis['androidx-compose-runtime-runtime'], globalThis['coil-root-coil-compose'], globalThis['compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose'], globalThis['projects-core-koin-core-viewmodel'], globalThis['projects-compose-koin-compose'], globalThis['kotlinx-coroutines-core'], globalThis['supabase-kt-postgrest-kt'], globalThis['kotlinx-serialization-kotlinx-serialization-json'], globalThis['supabase-kt-auth-kt'], globalThis['ktor-ktor-client-content-negotiation'], globalThis['ktor-ktor-serialization-kotlinx-json'], globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['ktor-ktor-client-core'], globalThis['ktor-ktor-http'], globalThis['ktor-ktor-utils'], globalThis['projects-core-koin-core'], globalThis['supabase-kt-supabase-kt'], globalThis['supabase-kt-storage-kt'], globalThis['supabase-kt-functions-kt'], globalThis['supabase-kt-realtime-kt'], globalThis['androidx-lifecycle-lifecycle-viewmodel-savedstate'], globalThis['androidx-lifecycle-lifecycle-viewmodel'], globalThis['androidx-compose-runtime-runtime-saveable'], globalThis['compose-multiplatform-core-compose-material3-adaptive-adaptive'], globalThis['compose-multiplatform-core-compose-material3-material3-adaptive-navigation-suite'], globalThis['compose-multiplatform-core-compose-material-material-icons-core'], globalThis['compose-multiplatform-core-compose-material-material-icons-extended'], globalThis['compose-multiplatform-core-compose-ui-ui-graphics'], globalThis['compose-multiplatform-core-compose-material3-material3'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['compose-multiplatform-core-compose-ui-ui-text'], globalThis['compose-multiplatform-core-compose-animation-animation-core'], globalThis['compose-multiplatform-core-compose-animation-animation'], globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['compose-multiplatform-core-compose-foundation-foundation-layout'], globalThis['androidx-navigation3-navigation3-runtime'], globalThis['compose-multiplatform-core-compose-foundation-foundation'], globalThis['compose-multiplatform-core-navigation3-navigation3-ui'], globalThis['Kotlin-DateTime-library-kotlinx-datetime'], globalThis['androidx-window-window-core'], globalThis['compose-imageLoader-image-loader-singleton'], globalThis['compose-imageLoader-image-loader'], globalThis['compose-multiplatform-core-compose-ui-ui-geometry'], globalThis['androidx-lifecycle-lifecycle-runtime-compose'], globalThis['androidx-lifecycle-lifecycle-common'], globalThis['coil-root-coil-core'], globalThis['coil-root-coil-network-ktor3'], globalThis['okio-parent-okio'], globalThis['skiko-kjs']);
  }
}(function (_, kotlin_kotlin, kotlin_components_resources_library, kotlin_androidx_compose_runtime_runtime, kotlin_io_coil_kt_coil3_coil_compose, kotlin_org_jetbrains_androidx_lifecycle_lifecycle_viewmodel_compose, kotlin_io_insert_koin_koin_core_viewmodel, kotlin_io_insert_koin_koin_compose, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_io_github_jan_tennert_supabase_postgrest_kt, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_io_github_jan_tennert_supabase_auth_kt, kotlin_io_ktor_ktor_client_content_negotiation, kotlin_io_ktor_ktor_serialization_kotlinx_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_utils, kotlin_io_insert_koin_koin_core, kotlin_io_github_jan_tennert_supabase_supabase_kt, kotlin_io_github_jan_tennert_supabase_storage_kt, kotlin_io_github_jan_tennert_supabase_functions_kt, kotlin_io_github_jan_tennert_supabase_realtime_kt, kotlin_androidx_lifecycle_lifecycle_viewmodel_savedstate, kotlin_androidx_lifecycle_lifecycle_viewmodel, kotlin_androidx_compose_runtime_runtime_saveable, kotlin_org_jetbrains_compose_material3_adaptive_adaptive, kotlin_org_jetbrains_compose_material3_material3_adaptive_navigation_suite, kotlin_org_jetbrains_compose_material_material_icons_core, kotlin_org_jetbrains_compose_material_material_icons_extended, kotlin_org_jetbrains_compose_ui_ui_graphics, kotlin_org_jetbrains_compose_material3_material3, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_org_jetbrains_compose_ui_ui_text, kotlin_org_jetbrains_compose_animation_animation_core, kotlin_org_jetbrains_compose_animation_animation, kotlin_org_jetbrains_compose_ui_ui, kotlin_org_jetbrains_compose_foundation_foundation_layout, kotlin_androidx_navigation3_navigation3_runtime, kotlin_org_jetbrains_compose_foundation_foundation, kotlin_org_jetbrains_androidx_navigation3_navigation3_ui, kotlin_org_jetbrains_kotlinx_kotlinx_datetime, kotlin_androidx_window_window_core, kotlin_io_github_qdsfdhvh_image_loader_singleton, kotlin_io_github_qdsfdhvh_image_loader, kotlin_org_jetbrains_compose_ui_ui_geometry, kotlin_androidx_lifecycle_lifecycle_runtime_compose, kotlin_androidx_lifecycle_lifecycle_common, kotlin_io_coil_kt_coil3_coil_core, kotlin_io_coil_kt_coil3_coil_network_ktor3, kotlin_com_squareup_okio_okio, kotlin_org_jetbrains_skiko_skiko) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var emptySet = kotlin_kotlin.$_$.e9;
  var Long = kotlin_kotlin.$_$.kn;
  var ResourceItem = kotlin_components_resources_library.$_$.g;
  var setOf = kotlin_kotlin.$_$.rb;
  var DrawableResource = kotlin_components_resources_library.$_$.c;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var lazy = kotlin_kotlin.$_$.to;
  var FontResource = kotlin_components_resources_library.$_$.d;
  var LanguageQualifier = kotlin_components_resources_library.$_$.f;
  var setOf_0 = kotlin_kotlin.$_$.sb;
  var StringResource = kotlin_components_resources_library.$_$.h;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var sourceInformation = kotlin_androidx_compose_runtime_runtime.$_$.k2;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var sourceInformationMarkerStart = kotlin_androidx_compose_runtime_runtime.$_$.j2;
  var Companion_getInstance = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var sourceInformationMarkerEnd = kotlin_androidx_compose_runtime_runtime.$_$.i2;
  var traceEventStart = kotlin_androidx_compose_runtime_runtime.$_$.p2;
  var isTraceInProgress = kotlin_androidx_compose_runtime_runtime.$_$.s1;
  var setSingletonImageLoaderFactory = kotlin_io_coil_kt_coil3_coil_compose.$_$.a;
  var LocalViewModelStoreOwner_getInstance = kotlin_org_jetbrains_androidx_lifecycle_lifecycle_viewmodel_compose.$_$.b;
  var androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter = kotlin_org_jetbrains_androidx_lifecycle_lifecycle_viewmodel_compose.$_$.a;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var defaultExtras = kotlin_io_insert_koin_koin_core_viewmodel.$_$.a;
  var currentKoinScope = kotlin_io_insert_koin_koin_compose.$_$.a;
  var getKClass = kotlin_kotlin.$_$.si;
  var resolveViewModel = kotlin_io_insert_koin_koin_core_viewmodel.$_$.b;
  var collectAsState = kotlin_androidx_compose_runtime_runtime.$_$.h1;
  var LaunchedEffect = kotlin_androidx_compose_runtime_runtime.$_$.s;
  var LaunchedEffect_0 = kotlin_androidx_compose_runtime_runtime.$_$.r;
  var rememberComposableLambda = kotlin_androidx_compose_runtime_runtime.$_$.c;
  var traceEventEnd = kotlin_androidx_compose_runtime_runtime.$_$.o2;
  var KProperty0 = kotlin_kotlin.$_$.xi;
  var getLocalDelegateReference = kotlin_kotlin.$_$.wf;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var isInterface = kotlin_kotlin.$_$.rg;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var VOID = kotlin_kotlin.$_$.d;
  var updateChangedFlags = kotlin_androidx_compose_runtime_runtime.$_$.q2;
  var MutableStateFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s1;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var FlowCollector = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p1;
  var Companion_getInstance_0 = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.c;
  var SelectRequestBuilder = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.h;
  var PostgrestFilterBuilder = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.f;
  var _Columns___get_value__impl__haxhww = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.a;
  var listOf = kotlin_kotlin.$_$.sa;
  var mapToFirstValue = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.q;
  var SelectRequest = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.m;
  var RestRequestExecutor_instance = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.b;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var KtList = kotlin_kotlin.$_$.e7;
  var arrayOf = kotlin_kotlin.$_$.fo;
  var createKType = kotlin_kotlin.$_$.qi;
  var createInvariantKTypeProjection = kotlin_kotlin.$_$.oi;
  var firstOrNull = kotlin_kotlin.$_$.k9;
  var get_jsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.r;
  var Exception = kotlin_kotlin.$_$.gn;
  var split = kotlin_kotlin.$_$.cl;
  var lastOrNull = kotlin_kotlin.$_$.ka;
  var contains = kotlin_kotlin.$_$.nj;
  var SessionStatus = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.j;
  var Unit = kotlin_kotlin.$_$.co;
  var flowOf = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b2;
  var NotAuthenticated = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.i;
  var flow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d2;
  var Authenticated = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.h;
  var emitAll = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q;
  var Google_getInstance = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.d;
  var get_ContentNegotiation = kotlin_io_ktor_ktor_client_content_negotiation.$_$.a;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.l;
  var json = kotlin_io_ktor_ktor_serialization_kotlinx_json.$_$.a;
  var JsonObjectBuilder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
  var put = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.v;
  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var get_jsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.q;
  var IDToken_instance = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.c;
  var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
  var JsonElement = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f3;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var get_jsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.p;
  var UpsertRequestBuilder = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.i;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.z3;
  var flatten = kotlin_kotlin.$_$.r9;
  var distinct = kotlin_kotlin.$_$.z8;
  var joinToString = kotlin_kotlin.$_$.aa;
  var InsertRequest = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.l;
  var getString = kotlin_components_resources_library.$_$.b;
  var Exception_init_$Create$ = kotlin_kotlin.$_$.i5;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var isCharSequence = kotlin_kotlin.$_$.ng;
  var trim = kotlin_kotlin.$_$.mm;
  var Email_instance = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.b;
  var put_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.w;
  var PostgrestRequestBuilder = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.j;
  var UpdateRequest = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.n;
  var InsertRequestBuilder = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.g;
  var HttpRequestBuilder = kotlin_io_ktor_ktor_client_core.$_$.q;
  var Companion_getInstance_1 = kotlin_io_ktor_ktor_http.$_$.h;
  var url_0 = kotlin_io_ktor_ktor_client_core.$_$.w;
  var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
  var contentType = kotlin_io_ktor_ktor_http.$_$.o1;
  var header = kotlin_io_ktor_ktor_client_core.$_$.u;
  var TypeInfo = kotlin_io_ktor_ktor_utils.$_$.l;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.t;
  var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
  var HttpStatement = kotlin_io_ktor_ktor_client_core.$_$.z;
  var isSuccess = kotlin_io_ktor_ktor_http.$_$.w1;
  var removeSurrounding = kotlin_kotlin.$_$.tk;
  var isBlank = kotlin_kotlin.$_$.dk;
  var System_instance = kotlin_kotlin.$_$.c3;
  var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h;
  var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g3;
  var CoroutineScope_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x2;
  var onEach = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g2;
  var Companion_getInstance_2 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.e;
  var stateIn = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j2;
  var MutableSharedFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.r1;
  var combine = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x1;
  var transformLatest = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.k2;
  var HttpClient = kotlin_io_ktor_ktor_client_core.$_$.c1;
  var parseSessionFromUrl = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.n;
  var equals = kotlin_kotlin.$_$.sf;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.a4;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var Collection = kotlin_kotlin.$_$.y6;
  var DeleteRequest = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.k;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var withContext = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a1;
  var numberRangeToNumber = kotlin_kotlin.$_$.yg;
  var Default_getInstance_0 = kotlin_kotlin.$_$.z2;
  var random = kotlin_kotlin.$_$.ii;
  var takeLast = kotlin_kotlin.$_$.ql;
  var emptyList = kotlin_kotlin.$_$.c9;
  var emptyFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.z1;
  var first = kotlin_kotlin.$_$.o9;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.b3;
  var println = kotlin_kotlin.$_$.de;
  var printStackTrace = kotlin_kotlin.$_$.wo;
  var Companion_getInstance_3 = kotlin_io_ktor_ktor_http.$_$.f;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var getString_0 = kotlin_components_resources_library.$_$.a;
  var put_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.u;
  var from = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.p;
  var Order_DESCENDING_getInstance = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.e;
  var Mutex = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o2;
  var onStart = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h2;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g2;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a1;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a2;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var SerializableWith = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w2;
  var JsonElementSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.b;
  var get_doubleOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.o;
  var toDoubleOrNull = kotlin_kotlin.$_$.ul;
  var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.k;
  var hashCode = kotlin_kotlin.$_$.bg;
  var getNumberHashCode = kotlin_kotlin.$_$.xf;
  var startsWith = kotlin_kotlin.$_$.dl;
  var endsWith = kotlin_kotlin.$_$.vj;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var toList = kotlin_kotlin.$_$.jc;
  var plus = kotlin_kotlin.$_$.ib;
  var numberToLong = kotlin_kotlin.$_$.we;
  var DOUBLE_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i1;
  var readRawBytes = kotlin_io_ktor_ktor_client_core.$_$.g;
  var plus_0 = kotlin_kotlin.$_$.jb;
  var toSet = kotlin_kotlin.$_$.tc;
  var contains_0 = kotlin_kotlin.$_$.c8;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var Flow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q1;
  var startKoin = kotlin_io_insert_koin_koin_core.$_$.f;
  var module_0 = kotlin_io_insert_koin_koin_core.$_$.o;
  var Companion_getInstance_4 = kotlin_io_insert_koin_koin_core.$_$.a;
  var Kind_Singleton_getInstance = kotlin_io_insert_koin_koin_core.$_$.e;
  var SupabaseClient = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.y;
  var BeanDefinition = kotlin_io_insert_koin_koin_core.$_$.g;
  var SingleInstanceFactory = kotlin_io_insert_koin_koin_core.$_$.j;
  var KoinDefinition = kotlin_io_insert_koin_koin_core.$_$.h;
  var Auth = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.l;
  var Postgrest = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.o;
  var Storage = kotlin_io_github_jan_tennert_supabase_storage_kt.$_$.b;
  var Functions = kotlin_io_github_jan_tennert_supabase_functions_kt.$_$.b;
  var Kind_Factory_getInstance = kotlin_io_insert_koin_koin_core.$_$.d;
  var FactoryInstanceFactory = kotlin_io_insert_koin_koin_core.$_$.i;
  var SupabaseClientBuilder = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.x;
  var Companion_getInstance_5 = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.e;
  var Companion_getInstance_6 = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.d;
  var Companion_getInstance_7 = kotlin_io_github_jan_tennert_supabase_realtime_kt.$_$.a;
  var Companion_getInstance_8 = kotlin_io_github_jan_tennert_supabase_storage_kt.$_$.a;
  var Companion_getInstance_9 = kotlin_io_github_jan_tennert_supabase_functions_kt.$_$.a;
  var KotlinXSerializer = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.w;
  var get_auth = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.m;
  var get_postgrest = kotlin_io_github_jan_tennert_supabase_postgrest_kt.$_$.r;
  var get_storage = kotlin_io_github_jan_tennert_supabase_storage_kt.$_$.c;
  var get_functions = kotlin_io_github_jan_tennert_supabase_functions_kt.$_$.c;
  var SavedStateHandle = kotlin_androidx_lifecycle_lifecycle_viewmodel_savedstate.$_$.b;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.v3;
  var lazy_0 = kotlin_kotlin.$_$.so;
  var DoubleSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var ByteSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y1;
  var FloatSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
  var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d2;
  var throwArrayMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m2;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.h5;
  var captureStack = kotlin_kotlin.$_$.gf;
  var createAnnotatedEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i2;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
  var Enum = kotlin_kotlin.$_$.en;
  var JsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.d;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.y2;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
  var ListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
  var JsonDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.e;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j2;
  var get_booleanOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.n;
  var checkIndexOverflow = kotlin_kotlin.$_$.a8;
  var mapCapacity = kotlin_kotlin.$_$.ua;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.i4;
  var compare = kotlin_kotlin.$_$.je;
  var get_viewModelScope = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.f;
  var ViewModel = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.e;
  var ViewModel_init_$Init$ = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.k;
  var asStateFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.v1;
  var asSharedFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.u1;
  var ObjectSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var SealedClassSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var rememberSaveable = kotlin_androidx_compose_runtime_runtime_saveable.$_$.j;
  var mutableStateOf = kotlin_androidx_compose_runtime_runtime.$_$.b2;
  var currentWindowAdaptiveInfo = kotlin_org_jetbrains_compose_material3_adaptive_adaptive.$_$.a;
  var Companion_getInstance_10 = kotlin_org_jetbrains_compose_material3_material3_adaptive_navigation_suite.$_$.b;
  var Icons_getInstance = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.z;
  var get_Store = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.i1;
  var stringResource = kotlin_components_resources_library.$_$.j;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.w1;
  var _Color___init__impl__r6cqi2 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.u2;
  var Icon = kotlin_org_jetbrains_compose_material3_material3.$_$.s;
  var _TextUnit___init__impl__r5fj1s = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h3;
  var _TextOverflow___init__impl__obguoe = kotlin_org_jetbrains_compose_ui_ui_text.$_$.n2;
  var Text = kotlin_org_jetbrains_compose_material3_material3.$_$.t1;
  var get_ShoppingCart = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.u;
  var get_Person = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.p;
  var composableLambdaInstance = kotlin_androidx_compose_runtime_runtime.$_$.b;
  var toMutableStateList = kotlin_androidx_compose_runtime_runtime.$_$.n2;
  var mutableStateListOf = kotlin_androidx_compose_runtime_runtime.$_$.y1;
  var KMutableProperty0 = kotlin_kotlin.$_$.vi;
  var throwKotlinNothingValueException = kotlin_kotlin.$_$.bp;
  var get_FastOutSlowInEasing = kotlin_org_jetbrains_compose_animation_animation_core.$_$.k;
  var tween = kotlin_org_jetbrains_compose_animation_animation_core.$_$.z1;
  var slideInHorizontally = kotlin_org_jetbrains_compose_animation_animation.$_$.p;
  var fadeIn = kotlin_org_jetbrains_compose_animation_animation.$_$.k;
  var slideOutHorizontally = kotlin_org_jetbrains_compose_animation_animation.$_$.r;
  var fadeOut = kotlin_org_jetbrains_compose_animation_animation.$_$.l;
  var togetherWith = kotlin_org_jetbrains_compose_animation_animation.$_$.u;
  var Companion_instance = kotlin_org_jetbrains_compose_ui_ui.$_$.ec;
  var fillMaxSize = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.q;
  var Companion_getInstance_11 = kotlin_org_jetbrains_compose_ui_ui.$_$.dc;
  var maybeCachedBoxMeasurePolicy = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.v;
  var get_currentCompositeKeyHashCode = kotlin_androidx_compose_runtime_runtime.$_$.l1;
  var materialize = kotlin_org_jetbrains_compose_ui_ui.$_$.wa;
  var Companion_getInstance_12 = kotlin_org_jetbrains_compose_ui_ui.$_$.vb;
  var invalidApplier = kotlin_androidx_compose_runtime_runtime.$_$.r1;
  var Applier = kotlin_androidx_compose_runtime_runtime.$_$.h;
  var _Updater___init__impl__rbfxm8 = kotlin_androidx_compose_runtime_runtime.$_$.r2;
  var Updater__set_impl_v7kwss = kotlin_androidx_compose_runtime_runtime.$_$.t2;
  var Updater__reconcile_impl_1mfi6g = kotlin_androidx_compose_runtime_runtime.$_$.s2;
  var BoxScopeInstance_instance = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.b2;
  var Arrangement_getInstance = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.a2;
  var columnMeasurePolicy = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.l;
  var ColumnScopeInstance_instance = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.c2;
  var MaterialTheme_instance = kotlin_org_jetbrains_compose_material3_material3.$_$.z2;
  var _Dp___init__impl__ms3zkb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h2;
  var height = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.t;
  var Spacer = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.f;
  var Button = kotlin_org_jetbrains_compose_material3_material3.$_$.e;
  var last = kotlin_kotlin.$_$.na;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var NavEntry = kotlin_androidx_navigation3_navigation3_runtime.$_$.b;
  var background = kotlin_org_jetbrains_compose_foundation_foundation.$_$.f2;
  var fillMaxHeight = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.p;
  var widthIn = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.r1;
  var NavDisplay = kotlin_org_jetbrains_androidx_navigation3_navigation3_ui.$_$.a;
  var padding = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.b1;
  var NavigationSuiteScaffold = kotlin_org_jetbrains_compose_material3_material3_adaptive_navigation_suite.$_$.a;
  var _FabPosition___init__impl__9ib2hj = kotlin_org_jetbrains_compose_material3_material3.$_$.t2;
  var Scaffold = kotlin_org_jetbrains_compose_material3_material3.$_$.f1;
  var Saver = kotlin_androidx_compose_runtime_runtime_saveable.$_$.d;
  var rememberScrollState = kotlin_org_jetbrains_compose_foundation_foundation.$_$.s2;
  var verticalScroll = kotlin_org_jetbrains_compose_foundation_foundation.$_$.t2;
  var padding_0 = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.a1;
  var size = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.o1;
  var painterResource = kotlin_components_resources_library.$_$.i;
  var Companion_getInstance_13 = kotlin_org_jetbrains_compose_ui_ui.$_$.ub;
  var androidx_compose_ui_graphics_painter_Painter$stableprop_getter = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.j;
  var Image = kotlin_org_jetbrains_compose_foundation_foundation.$_$.a2;
  var fillMaxWidth = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.r;
  var ButtonDefaults_getInstance = kotlin_org_jetbrains_compose_material3_material3.$_$.u2;
  var Companion_getInstance_14 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.g4;
  var TextButton = kotlin_org_jetbrains_compose_material3_material3.$_$.r1;
  var _StrokeCap___init__impl__kfgr27 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.u3;
  var CircularProgressIndicator = kotlin_org_jetbrains_compose_material3_material3.$_$.j;
  var OutlinedTextField = kotlin_org_jetbrains_compose_material3_material3.$_$.b1;
  var PasswordVisualTransformation = kotlin_org_jetbrains_compose_ui_ui_text.$_$.p;
  var padding_1 = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.c1;
  var OutlinedButton = kotlin_org_jetbrains_compose_material3_material3.$_$.a1;
  var Companion_getInstance_15 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.q3;
  var padding_2 = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.d1;
  var replace = kotlin_kotlin.$_$.xk;
  var SnackbarHostState = kotlin_org_jetbrains_compose_material3_material3.$_$.l1;
  var get_LocalUriHandler = kotlin_org_jetbrains_compose_ui_ui.$_$.f7;
  var rowMeasurePolicy = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.j1;
  var RowScopeInstance_instance = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.d2;
  var width = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.t1;
  var get_sp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.q1;
  var Companion_getInstance_16 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.b3;
  var Builder = kotlin_org_jetbrains_compose_ui_ui.$_$.b1;
  var Color = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.x;
  var SolidColor = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.q1;
  var get_DefaultStrokeLineCap = kotlin_org_jetbrains_compose_ui_ui.$_$.x;
  var get_DefaultStrokeLineJoin = kotlin_org_jetbrains_compose_ui_ui.$_$.y;
  var get_DefaultFillType = kotlin_org_jetbrains_compose_ui_ui.$_$.w;
  var PathBuilder = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.m;
  var SnackbarHost = kotlin_org_jetbrains_compose_material3_material3.$_$.m1;
  var Filled_instance = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.y;
  var get_VisibilityOff = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.p1;
  var get_Visibility = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.o1;
  var IconButton = kotlin_org_jetbrains_compose_material3_material3.$_$.r;
  var RoundedCornerShape = kotlin_org_jetbrains_compose_foundation_foundation.$_$.o1;
  var OutlinedTextFieldDefaults_getInstance = kotlin_org_jetbrains_compose_material3_material3.$_$.g3;
  var Companion_getInstance_17 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.i3;
  var clickable = kotlin_org_jetbrains_compose_foundation_foundation.$_$.j2;
  var Checkbox = kotlin_org_jetbrains_compose_material3_material3.$_$.i;
  var Builder_0 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.g1;
  var Companion_getInstance_18 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.r3;
  var SpanStyle_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.h4;
  var TextLinkStyles = kotlin_org_jetbrains_compose_ui_ui_text.$_$.s1;
  var Url = kotlin_org_jetbrains_compose_ui_ui_text.$_$.j1;
  var Text_0 = kotlin_org_jetbrains_compose_material3_material3.$_$.u1;
  var HorizontalDivider = kotlin_org_jetbrains_compose_material3_material3.$_$.q;
  var BorderStroke = kotlin_org_jetbrains_compose_foundation_foundation.$_$.x1;
  var AnimatedContent = kotlin_org_jetbrains_compose_animation_animation.$_$.b;
  var Surface = kotlin_org_jetbrains_compose_material3_material3.$_$.n1;
  var TopAppBarDefaults_getInstance = kotlin_org_jetbrains_compose_material3_material3.$_$.m3;
  var WindowInsets = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.g;
  var TopAppBar = kotlin_org_jetbrains_compose_material3_material3.$_$.w1;
  var get_CircleShape = kotlin_org_jetbrains_compose_foundation_foundation.$_$.l1;
  var AlertDialog = kotlin_org_jetbrains_compose_material3_material3.$_$.a;
  var Filled_instance_0 = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.w;
  var get_ArrowBack = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.a;
  var get_WifiOff = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.q1;
  var get_DeleteOutline = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.n;
  var get_Add = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.d;
  var PaddingValues = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.e;
  var LazyColumn = kotlin_org_jetbrains_compose_foundation_foundation.$_$.d1;
  var RoundedCornerShape_0 = kotlin_org_jetbrains_compose_foundation_foundation.$_$.p1;
  var shadow = kotlin_org_jetbrains_compose_ui_ui.$_$.o;
  var stringResource_0 = kotlin_components_resources_library.$_$.k;
  var get_Remove = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.g1;
  var clip = kotlin_org_jetbrains_compose_ui_ui.$_$.h;
  var Color__copy$default_impl_ectz3s = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.x3;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var collectLatest = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p;
  var Dp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.p;
  var _Dp___get_value__impl__geb1vb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l2;
  var DisposableEffect = kotlin_androidx_compose_runtime_runtime.$_$.q;
  var _DisplayMode___init__impl__gfd230 = kotlin_org_jetbrains_compose_material3_material3.$_$.s2;
  var rememberDatePickerState = kotlin_org_jetbrains_compose_material3_material3.$_$.o2;
  var alpha = kotlin_org_jetbrains_compose_ui_ui.$_$.f;
  var zIndex = kotlin_org_jetbrains_compose_ui_ui.$_$.xa;
  var pointerInput = kotlin_org_jetbrains_compose_ui_ui.$_$.u2;
  var Surface_0 = kotlin_org_jetbrains_compose_material3_material3.$_$.o1;
  var Box = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.b;
  var DatePickerDialog = kotlin_org_jetbrains_compose_material3_material3.$_$.k;
  var get_FavoriteBorder = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.l;
  var get_Favorite = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.k;
  var get_Share = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.t;
  var get_CalendarMonth = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.g;
  var Card = kotlin_org_jetbrains_compose_material3_material3.$_$.g;
  var PointerInputEventHandler = kotlin_org_jetbrains_compose_ui_ui.$_$.g2;
  var delay = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x;
  var AwaitPointerEventScope = kotlin_org_jetbrains_compose_ui_ui.$_$.e2;
  var PointerEventPass_Initial_getInstance = kotlin_org_jetbrains_compose_ui_ui.$_$.hc;
  var PointerInputScope = kotlin_org_jetbrains_compose_ui_ui.$_$.h2;
  var get_Fullscreen = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.r;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.q2;
  var get_Save = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.h1;
  var createCompositionCoroutineScope = kotlin_androidx_compose_runtime_runtime.$_$.k1;
  var heightIn = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.s;
  var PaddingValues_0 = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.c;
  var Companion_getInstance_19 = kotlin_kotlin.$_$.e3;
  var Companion_getInstance_20 = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.c;
  var toLocalDateTime = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.p;
  var DatePicker = kotlin_org_jetbrains_compose_material3_material3.$_$.l;
  var rememberPagerState = kotlin_org_jetbrains_compose_foundation_foundation.$_$.h1;
  var mutableIntStateOf = kotlin_androidx_compose_runtime_runtime.$_$.w1;
  var HorizontalPager = kotlin_org_jetbrains_compose_foundation_foundation.$_$.g1;
  var LazyRow = kotlin_org_jetbrains_compose_foundation_foundation.$_$.e1;
  var border = kotlin_org_jetbrains_compose_foundation_foundation.$_$.h2;
  var get_PlayCircle = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.d1;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var Companion_getInstance_21 = kotlin_androidx_window_window_core.$_$.b;
  var get_LocalShipping = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.w;
  var get_CreditCard = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.m;
  var get_Redeem = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.f1;
  var Companion_instance_0 = kotlin_kotlin.$_$.j3;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var createFailure = kotlin_kotlin.$_$.ko;
  var to = kotlin_kotlin.$_$.ip;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.b1;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.d1;
  var launchIn = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.e2;
  var Color_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.y;
  var _Color___get_value__impl__1pls5m = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d3;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.x1;
  var get_Verified = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.m1;
  var ExposedDropdownMenuBox = kotlin_org_jetbrains_compose_material3_material3.$_$.n;
  var ExposedDropdownMenuDefaults_getInstance = kotlin_org_jetbrains_compose_material3_material3.$_$.y2;
  var DropdownMenuItem = kotlin_org_jetbrains_compose_material3_material3.$_$.m;
  var Companion_getInstance_22 = kotlin_org_jetbrains_compose_material3_material3.$_$.x2;
  var androidx_compose_material3_ExposedDropdownMenuBoxScope$stableprop_getter = kotlin_org_jetbrains_compose_material3_material3.$_$.a2;
  var get_Refresh = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.r;
  var get_Money = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.x;
  var RadioButtonDefaults_instance = kotlin_org_jetbrains_compose_material3_material3.$_$.h3;
  var RadioButton = kotlin_org_jetbrains_compose_material3_material3.$_$.e1;
  var get_Lock = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.o;
  var get_Chat = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.b;
  var get_Email = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.j;
  var get_Edit = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.i;
  var sortedWith = kotlin_kotlin.$_$.yb;
  var CardDefaults_instance = kotlin_org_jetbrains_compose_material3_material3.$_$.v2;
  var Card_0 = kotlin_org_jetbrains_compose_material3_material3.$_$.f;
  var get_Close = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.g;
  var DialogProperties_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui.$_$.wc;
  var BasicAlertDialog = kotlin_org_jetbrains_compose_material3_material3.$_$.d;
  var Comparator = kotlin_kotlin.$_$.bn;
  var compareValues = kotlin_kotlin.$_$.ad;
  var get_CameraAlt = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.i;
  var get_CheckCircle = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.f;
  var Companion_getInstance_23 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.t3;
  var Companion_instance_1 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.e4;
  var listOf_0 = kotlin_kotlin.$_$.ta;
  var background_0 = kotlin_org_jetbrains_compose_foundation_foundation.$_$.g2;
  var rememberImageAction = kotlin_io_github_qdsfdhvh_image_loader_singleton.$_$.a;
  var _FilterQuality___init__impl__nv51aq = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.f3;
  var rememberImagePainter = kotlin_io_github_qdsfdhvh_image_loader_singleton.$_$.b;
  var Loading = kotlin_io_github_qdsfdhvh_image_loader.$_$.j;
  var get_ImageNotSupported = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.t;
  var Failure = kotlin_io_github_qdsfdhvh_image_loader.$_$.i;
  var get_AccountCircle = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.c;
  var Animatable = kotlin_org_jetbrains_compose_animation_animation_core.$_$.a;
  var Companion_getInstance_24 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.l1;
  var Offset = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c;
  var get_VectorConverter = kotlin_org_jetbrains_compose_animation_animation_core.$_$.w;
  var Animatable_0 = kotlin_org_jetbrains_compose_animation_animation_core.$_$.b;
  var Companion_getInstance_25 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g4;
  var IntSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t;
  var clipToBounds = kotlin_org_jetbrains_compose_ui_ui.$_$.g;
  var onSizeChanged = kotlin_org_jetbrains_compose_ui_ui.$_$.r4;
  var Companion_getInstance_26 = kotlin_org_jetbrains_compose_ui_ui.$_$.pb;
  var onPointerEvent = kotlin_org_jetbrains_compose_ui_ui.$_$.s2;
  var graphicsLayer = kotlin_org_jetbrains_compose_ui_ui.$_$.h1;
  var awaitFirstDown = kotlin_org_jetbrains_compose_foundation_foundation.$_$.c3;
  var awaitEachGesture = kotlin_org_jetbrains_compose_foundation_foundation.$_$.b3;
  var _Offset___get_packedValue__impl__xh2k8q = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.y;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var convertToInt = kotlin_kotlin.$_$.le;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var floatFromBits = kotlin_kotlin.$_$.uf;
  var coerceIn = kotlin_kotlin.$_$.di;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var toRawBits = kotlin_kotlin.$_$.fp;
  var fromInt = kotlin_kotlin.$_$.pe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var _Offset___init__impl__c168vi = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.r;
  var _IntSize___get_packedValue__impl__uho7jf = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f3;
  var Offset__times_impl_jz1mli = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.a1;
  var detectTapGestures = kotlin_org_jetbrains_compose_foundation_foundation.$_$.e3;
  var calculateZoom = kotlin_org_jetbrains_compose_foundation_foundation.$_$.h;
  var calculatePan = kotlin_org_jetbrains_compose_foundation_foundation.$_$.g;
  var Offset__plus_impl_c78cg0 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.z;
  var calculateCentroid = kotlin_org_jetbrains_compose_foundation_foundation.$_$.f;
  var Offset__getDistance_impl_pclvxn = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.v;
  var positionChanged = kotlin_org_jetbrains_compose_ui_ui.$_$.y2;
  var enumEntries = kotlin_kotlin.$_$.ae;
  var get_LocalClipboard = kotlin_org_jetbrains_compose_ui_ui.$_$.r6;
  var TabRow = kotlin_org_jetbrains_compose_material3_material3.$_$.p1;
  var get_Info = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.m;
  var get_ContentCopy = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.l;
  var TabRowDefaults_getInstance = kotlin_org_jetbrains_compose_material3_material3.$_$.k3;
  var Tab = kotlin_org_jetbrains_compose_material3_material3.$_$.q1;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var padStart = kotlin_kotlin.$_$.qk;
  var BoxWithConstraints = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.a;
  var Dp__compareTo_impl_tlg3dl = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.i2;
  var Fixed = kotlin_org_jetbrains_compose_foundation_foundation.$_$.y;
  var LazyVerticalGrid = kotlin_org_jetbrains_compose_foundation_foundation.$_$.b1;
  var charCodeAt = kotlin_kotlin.$_$.jf;
  var toString_1 = kotlin_kotlin.$_$.y;
  var substring = kotlin_kotlin.$_$.ol;
  var get_Delete = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.h;
  var FloatingActionButton = kotlin_org_jetbrains_compose_material3_material3.$_$.p;
  var PaddingValues_1 = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.d;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var toArgb = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.p2;
  var take = kotlin_kotlin.$_$.rl;
  var Offset__toString_impl_4ffbou = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.b1;
  var Color__toString_impl_hpzmaq = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.c3;
  var Offset__hashCode_impl_hbql41 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.w;
  var Color__hashCode_impl_vjyivj = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a3;
  var coerceAtLeast = kotlin_kotlin.$_$.wh;
  var ImageBitmap = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a1;
  var Canvas = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.s;
  var CanvasDrawScope = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a;
  var Density = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k;
  var LayoutDirection_Ltr_getInstance = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k4;
  var _Size___init__impl__aywn0g = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c1;
  var _IntOffset___init__impl__rq8h7b = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.v2;
  var Companion_getInstance_27 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.i4;
  var Companion_instance_2 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.h4;
  var _ColorMatrix___init__impl__3gytx1 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.e3;
  var LaunchedEffect_1 = kotlin_androidx_compose_runtime_runtime.$_$.t;
  var SmallFloatingActionButton = kotlin_org_jetbrains_compose_material3_material3.$_$.k1;
  var AutoMirrored_getInstance = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.x;
  var get_Backspace = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.a;
  var get_AddAPhoto = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.e;
  var SnackbarResult_ActionPerformed_getInstance = kotlin_org_jetbrains_compose_material3_material3.$_$.p3;
  var toMutableMap = kotlin_kotlin.$_$.rc;
  var mutableStateListOf_0 = kotlin_androidx_compose_runtime_runtime.$_$.z1;
  var get_LocalDensity = kotlin_org_jetbrains_compose_ui_ui.$_$.t6;
  var rememberTextMeasurer = kotlin_org_jetbrains_compose_ui_ui.$_$.ha;
  var get_LocalLayoutDirection = kotlin_org_jetbrains_compose_ui_ui.$_$.a7;
  var androidx_compose_runtime_ProvidedValue$stableprop_getter = kotlin_androidx_compose_runtime_runtime.$_$.f1;
  var CompositionLocalProvider = kotlin_androidx_compose_runtime_runtime.$_$.l;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.u4;
  var substring_0 = kotlin_kotlin.$_$.pl;
  var AnnotatedString_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.e4;
  var charSequenceGet = kotlin_kotlin.$_$.kf;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x;
  var TooltipDefaults_getInstance = kotlin_org_jetbrains_compose_material3_material3.$_$.l3;
  var rememberTooltipState = kotlin_org_jetbrains_compose_material3_material3.$_$.q2;
  var TooltipBox = kotlin_org_jetbrains_compose_material3_material3.$_$.v1;
  var _Color___get_red__impl__cwrsk6 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.b3;
  var _Color___get_green__impl__bta9rs = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.z2;
  var _Color___get_blue__impl__xwez13 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.w2;
  var Triple = kotlin_kotlin.$_$.tn;
  var LayoutDirection_Rtl_getInstance = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l4;
  var Companion_getInstance_28 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.z2;
  var Companion_getInstance_29 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.s3;
  var TextStyle_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.j4;
  var drawText = kotlin_org_jetbrains_compose_ui_ui_text.$_$.y1;
  var coerceAtMost = kotlin_kotlin.$_$.zh;
  var yield_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d1;
  var removeAll = kotlin_kotlin.$_$.lb;
  var get_Layers = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.v;
  var get_CenterFocusStrong = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.j;
  var get_FitScreen = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.p;
  var get_Flip = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.q;
  var get_RotateLeft = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.c;
  var get_RotateRight = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.d;
  var horizontalScroll = kotlin_org_jetbrains_compose_foundation_foundation.$_$.m2;
  var FilterChip = kotlin_org_jetbrains_compose_material3_material3.$_$.o;
  var rangeTo = kotlin_kotlin.$_$.ji;
  var Slider = kotlin_org_jetbrains_compose_material3_material3.$_$.j1;
  var Offset__div_impl_eaxtg1 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.t;
  var detectTransformGestures = kotlin_org_jetbrains_compose_foundation_foundation.$_$.f3;
  var _Size___get_packedValue__impl__7rlt1o = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.g1;
  var Stroke = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.c;
  var _Constraints___get_maxWidth__impl__uuyqc = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c2;
  var _Constraints___get_maxHeight__impl__dt3e8z = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b2;
  var size_0 = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.m1;
  var aspectRatio = kotlin_org_jetbrains_compose_foundation_foundation_layout.$_$.i;
  var Image_0 = kotlin_org_jetbrains_compose_foundation_foundation.$_$.z1;
  var Canvas_0 = kotlin_org_jetbrains_compose_foundation_foundation.$_$.y1;
  var get_TextFields = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.l1;
  var get_PhotoLibrary = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.c1;
  var get_PhotoCamera = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.b1;
  var VisualTransformation = kotlin_org_jetbrains_compose_ui_ui_text.$_$.y;
  var Companion_getInstance_30 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.g3;
  var TransformedText = kotlin_org_jetbrains_compose_ui_ui_text.$_$.x;
  var TextField = kotlin_org_jetbrains_compose_material3_material3.$_$.s1;
  var PlainTooltip = kotlin_org_jetbrains_compose_material3_material3.$_$.d1;
  var Color_1 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.w;
  var detectDragGestures = kotlin_org_jetbrains_compose_foundation_foundation.$_$.d3;
  var Dialog = kotlin_org_jetbrains_compose_ui_ui.$_$.ja;
  var parametersOf = kotlin_io_insert_koin_koin_core.$_$.m;
  var rememberSaveable_0 = kotlin_androidx_compose_runtime_runtime_saveable.$_$.i;
  var get_AddShoppingCart = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.f;
  var Pair = kotlin_kotlin.$_$.pn;
  var subtract = kotlin_kotlin.$_$.af;
  var multiply = kotlin_kotlin.$_$.ue;
  var plus_1 = kotlin_kotlin.$_$.gb;
  var minus = kotlin_kotlin.$_$.bb;
  var get_LocalLifecycleOwner = kotlin_androidx_lifecycle_lifecycle_runtime_compose.$_$.a;
  var SecondaryTabRow = kotlin_org_jetbrains_compose_material3_material3.$_$.g1;
  var LifecycleEventObserver = kotlin_androidx_lifecycle_lifecycle_common.$_$.a;
  var Event_ON_RESUME_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.h;
  var get_NotificationsNone = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.a1;
  var get_NotificationsActive = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.z;
  var CenterAlignedTopAppBar = kotlin_org_jetbrains_compose_material3_material3.$_$.h;
  var get_CalendarToday = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.h;
  var get_LocationOn = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.n;
  var get_Phone = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.q;
  var get_Work = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.r1;
  var get_MyLocation = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.y;
  var Companion_getInstance_31 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.f3;
  var KeyboardOptions = kotlin_org_jetbrains_compose_foundation_foundation.$_$.w1;
  var get_SupportAgent = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.j1;
  var get_History = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.s;
  var get_ConfirmationNumber = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.k;
  var get_Policy = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.e1;
  var get_ExitToApp = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.b;
  var get_Check = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.e;
  var isDigit = kotlin_kotlin.$_$.ek;
  var get_lastIndex = kotlin_kotlin.$_$.kk;
  var get_Language = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.u;
  var get_ViewInAr = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.n1;
  var rememberModalBottomSheetState = kotlin_org_jetbrains_compose_material3_material3.$_$.p2;
  var animateColorAsState = kotlin_org_jetbrains_compose_animation_animation.$_$.h;
  var ModalBottomSheet = kotlin_org_jetbrains_compose_material3_material3.$_$.u;
  var get_Search = kotlin_org_jetbrains_compose_material_material_icons_core.$_$.s;
  var get_FilterList = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.o;
  var Badge = kotlin_org_jetbrains_compose_material3_material3.$_$.c;
  var BadgedBox = kotlin_org_jetbrains_compose_material3_material3.$_$.b;
  var GridItemSpan = kotlin_org_jetbrains_compose_foundation_foundation.$_$.z;
  var GridItemSpan_0 = kotlin_org_jetbrains_compose_foundation_foundation.$_$.a1;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.j4;
  var isSystemInDarkTheme = kotlin_org_jetbrains_compose_foundation_foundation.$_$.p2;
  var MaterialTheme = kotlin_org_jetbrains_compose_material3_material3.$_$.t;
  var lightColorScheme = kotlin_org_jetbrains_compose_material3_material3.$_$.n2;
  var darkColorScheme = kotlin_org_jetbrains_compose_material3_material3.$_$.m2;
  var _TextDirection___get_value__impl__ka7r45 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.m2;
  var get_sp_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.p1;
  var Typography_init_$Create$ = kotlin_org_jetbrains_compose_material3_material3.$_$.r3;
  var _FontStyle___init__impl__jcnduf = kotlin_org_jetbrains_compose_ui_ui_text.$_$.b2;
  var Font = kotlin_components_resources_library.$_$.e;
  var FontFamily = kotlin_org_jetbrains_compose_ui_ui_text.$_$.a;
  var get_SystemUpdate = kotlin_org_jetbrains_compose_material_material_icons_extended.$_$.k1;
  var Builder_init_$Create$ = kotlin_io_coil_kt_coil3_coil_core.$_$.m;
  var Builder_init_$Create$_0 = kotlin_io_coil_kt_coil3_coil_core.$_$.l;
  var KtorNetworkFetcherFactory = kotlin_io_coil_kt_coil3_coil_network_ktor3.$_$.a;
  var Uri = kotlin_io_coil_kt_coil3_coil_core.$_$.h;
  var DebugLogger = kotlin_io_coil_kt_coil3_coil_core.$_$.d;
  var CachePolicy_ENABLED_getInstance = kotlin_io_coil_kt_coil3_coil_core.$_$.k;
  var CachePolicy_DISABLED_getInstance = kotlin_io_coil_kt_coil3_coil_core.$_$.j;
  var crossfade = kotlin_io_coil_kt_coil3_coil_core.$_$.c;
  var Builder_1 = kotlin_io_coil_kt_coil3_coil_core.$_$.b;
  var Builder_2 = kotlin_io_coil_kt_coil3_coil_core.$_$.a;
  var Companion_getInstance_32 = kotlin_com_squareup_okio_okio.$_$.b;
  var Char = kotlin_kotlin.$_$.ym;
  var replace_0 = kotlin_kotlin.$_$.yk;
  var roundToLong = kotlin_kotlin.$_$.lh;
  var divide = kotlin_kotlin.$_$.ne;
  var modulo = kotlin_kotlin.$_$.te;
  var contentEquals = kotlin_kotlin.$_$.f8;
  var contentHashCode = kotlin_kotlin.$_$.j8;
  var findAnyOf = kotlin_kotlin.$_$.xj;
  var substringBefore = kotlin_kotlin.$_$.ll;
  var Companion_instance_3 = kotlin_org_jetbrains_compose_ui_ui.$_$.wb;
  var UserSession = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.k;
  var asSkiaBitmap = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.z1;
  var Bitmap_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.v4;
  var Canvas_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.w4;
  var Companion_getInstance_33 = kotlin_org_jetbrains_skiko_skiko.$_$.n;
  var Companion_instance_4 = kotlin_org_jetbrains_skiko_skiko.$_$.q;
  var toComposeImageBitmap = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.q2;
  var EncodedImageFormat_PNG_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.h3;
  var EncodedImageFormat_JPEG_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.g3;
  var ImageBitmap_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.b1;
  var onGloballyPositioned = kotlin_org_jetbrains_compose_ui_ui.$_$.q4;
  var SideEffect = kotlin_androidx_compose_runtime_runtime.$_$.d1;
  var positionInWindow = kotlin_org_jetbrains_compose_ui_ui.$_$.t4;
  //endregion
  //region block: pre-declaration
  initMetadataForObject(drawable, 'drawable');
  initMetadataForObject(string, 'string');
  initMetadataForObject(font, 'font');
  initMetadataForInterface(IAnalyticsHelper, 'IAnalyticsHelper');
  initMetadataForLambda(App$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(App$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(App$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(App$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForClass(LanguageStorage, 'LanguageStorage', LanguageStorage);
  initMetadataForLambda(AuthRepositoryImpl$currentUser$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AuthRepositoryImpl$language$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AuthRepositoryImpl$currentUser$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(AuthRepositoryImpl$currentUser$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($loginWithGoogleCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($loginCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($checkFirstLoginCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($registerCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($signOutCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($deleteAccountCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($deleteAccountByTokenCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($fetchProfileCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($updateAvatarCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($deleteAvatarCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($updateProfileCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($updatePasswordCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($updateFcmTokenCOROUTINE$, CoroutineImpl);
  initMetadataForInterface(IAuthRepository, 'IAuthRepository', VOID, VOID, VOID, [2, 1, 0]);
  initMetadataForClass(AuthRepositoryImpl, 'AuthRepositoryImpl', VOID, VOID, [IAuthRepository], [2, 1, 0]);
  initMetadataForLambda(CartRepositoryImpl$addToCart$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartRepositoryImpl$syncCart$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($updateCartItemCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($deleteCartItemCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($clearCartCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($clearLocalCartCOROUTINE$, CoroutineImpl);
  initMetadataForInterface(ICartRepository, 'ICartRepository', VOID, VOID, VOID, [1, 0]);
  initMetadataForClass(CartRepositoryImpl, 'CartRepositoryImpl', VOID, VOID, [ICartRepository], [1, 0]);
  initMetadataForCoroutine($getCouponCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($markCouponAsUsedCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($createWelcomeCouponCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getUserCouponsCOROUTINE$, CoroutineImpl);
  initMetadataForInterface(ICouponRepository, 'ICouponRepository', VOID, VOID, VOID, [1, 2]);
  initMetadataForClass(CouponRepositoryImpl, 'CouponRepositoryImpl', VOID, VOID, [ICouponRepository], [1, 2]);
  initMetadataForLambda(FavoriteRepositoryImpl$isFavorite$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(FavoriteRepositoryImpl$getFavoriteProducts$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($toggleFavoriteCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($syncFavoritesCOROUTINE$, CoroutineImpl);
  initMetadataForInterface(IFavoriteRepository, 'IFavoriteRepository', VOID, VOID, VOID, [1, 0]);
  initMetadataForClass(FavoriteRepositoryImpl, 'FavoriteRepositoryImpl', VOID, VOID, [IFavoriteRepository], [1, 0]);
  initMetadataForCoroutine($getFriendsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($addFriendCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($updateFriendCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($deleteFriendCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($uploadAvatarCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($deleteAvatarCOROUTINE$_0, CoroutineImpl);
  initMetadataForInterface(IFriendRepository, 'IFriendRepository', VOID, VOID, VOID, [0, 1, 2]);
  initMetadataForClass(FriendRepositoryImpl, 'FriendRepositoryImpl', VOID, VOID, [IFriendRepository], [0, 1, 2]);
  initMetadataForCoroutine($notifyAdminCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($sendNotificationCOROUTINE$, CoroutineImpl);
  function notifyAdmin$default(title, body, orderId, status, link, imageUrl, $completion, $super) {
    orderId = orderId === VOID ? null : orderId;
    status = status === VOID ? null : status;
    link = link === VOID ? null : link;
    imageUrl = imageUrl === VOID ? null : imageUrl;
    return $super === VOID ? this.xzb(title, body, orderId, status, link, imageUrl, $completion) : $super.xzb.call(this, title, body, orderId, status, link, imageUrl, $completion);
  }
  initMetadataForInterface(INotificationRepository, 'INotificationRepository', VOID, VOID, VOID, [6, 1]);
  initMetadataForClass(NotificationRepositoryImpl, 'NotificationRepositoryImpl', VOID, VOID, [INotificationRepository], [6, 1]);
  initMetadataForCoroutine($placeOrderCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getOrderHistoryCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getOrderByIdCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($notifyAdminsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($requestReturnCOROUTINE$, CoroutineImpl);
  initMetadataForInterface(IOrderRepository, 'IOrderRepository', VOID, VOID, VOID, [1, 2]);
  initMetadataForClass(OrderRepositoryImpl, 'OrderRepositoryImpl', VOID, VOID, [IOrderRepository], [1, 2]);
  initMetadataForLambda(ProductRepositoryImpl$getProducts$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductRepositoryImpl$getBanners$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductRepositoryImpl$getProducts$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductRepositoryImpl$getBanners$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($refreshProductsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($refreshBannersCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getProductByIdCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getCardsByIdsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getBoxesByIdsCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($clearLocalDataCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($recordProductViewCOROUTINE$, CoroutineImpl);
  initMetadataForInterface(IProductRepository, 'IProductRepository', VOID, VOID, VOID, [0, 1, 3]);
  initMetadataForClass(ProductRepositoryImpl, 'ProductRepositoryImpl', VOID, VOID, [IProductRepository], [0, 1, 3]);
  initMetadataForCompanion(Companion);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ProductViewRequest, 'ProductViewRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForCompanion(Companion_0);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AppSetting, 'AppSetting', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  initMetadataForCoroutine($getShippingCostCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getWelcomeCouponValueCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getMinAppVersionCOROUTINE$, CoroutineImpl);
  initMetadataForInterface(ISettingsRepository, 'ISettingsRepository', VOID, VOID, VOID, [1, 0]);
  initMetadataForClass(SettingsRepositoryImpl, 'SettingsRepositoryImpl', VOID, VOID, [ISettingsRepository], [1, 0]);
  initMetadataForObject(DoubleOrNullSerializer, 'DoubleOrNullSerializer', VOID, VOID, [KSerializer]);
  initMetadataForLambda(StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(StockReminderRepositoryImpl$getStockReminders$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(StockReminderRepositoryImpl$getStockReminders$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(StockReminderRepositoryImpl$isStockReminderSet$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(StockReminderRepositoryImpl$isStockReminderSet$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(StockReminderRepositoryImpl$getStockReminders$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(StockReminderRepositoryImpl$getStockReminders$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($toggleStockReminderCOROUTINE$, CoroutineImpl);
  initMetadataForInterface(IStockReminderRepository, 'IStockReminderRepository', VOID, VOID, VOID, [1]);
  initMetadataForClass(StockReminderRepositoryImpl, 'StockReminderRepositoryImpl', VOID, VOID, [IStockReminderRepository], [1]);
  initMetadataForCoroutine($uploadDesignImageCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($downloadDesignImageCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($downloadExternalImageCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($deleteDesignImageCOROUTINE$, CoroutineImpl);
  initMetadataForInterface(IStorageRepository, 'IStorageRepository', VOID, VOID, VOID, [2, 1]);
  initMetadataForClass(StorageRepositoryImpl, 'StorageRepositoryImpl', VOID, VOID, [IStorageRepository], [2, 1]);
  initMetadataForClass(AppDatabase, 'AppDatabase');
  initMetadataForInterface(BannerDao, 'BannerDao', VOID, VOID, VOID, [1, 0]);
  initMetadataForInterface(CartDao, 'CartDao', VOID, VOID, VOID, [0, 1]);
  initMetadataForInterface(FavoriteDao, 'FavoriteDao', VOID, VOID, VOID, [2, 1]);
  initMetadataForClass(MemoryAppDatabase, 'MemoryAppDatabase', MemoryAppDatabase, AppDatabase);
  initMetadataForClass(MemoryCartDao, 'MemoryCartDao', MemoryCartDao, VOID, [CartDao], [0, 1]);
  initMetadataForInterface(ProductDao, 'ProductDao', VOID, VOID, VOID, [1, 0]);
  initMetadataForClass(MemoryProductDao, 'MemoryProductDao', MemoryProductDao, VOID, [ProductDao], [1, 0]);
  initMetadataForClass(MemoryBannerDao, 'MemoryBannerDao', MemoryBannerDao, VOID, [BannerDao], [1, 0]);
  initMetadataForLambda(MemoryFavoriteDao$getAllFavorites$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$, CoroutineImpl);
  initMetadataForLambda(MemoryFavoriteDao$isFavorite$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(MemoryFavoriteDao$getAllFavorites$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(MemoryFavoriteDao$getFavoriteProducts$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForClass(MemoryFavoriteDao$isFavorite$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($replaceFavoritesCOROUTINE$, CoroutineImpl);
  initMetadataForClass(MemoryFavoriteDao, 'MemoryFavoriteDao', VOID, VOID, [FavoriteDao], [2, 1]);
  initMetadataForCompanion(Companion_1);
  initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Banner, 'Banner', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  initMetadataForCompanion(Companion_2);
  initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Box_0, 'Box', Box_0, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  initMetadataForCompanion(Companion_3);
  initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Card_1, 'Card', Card_1, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  initMetadataForCompanion(Companion_4);
  initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DesignLayer, 'DesignLayer', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  initMetadataForCompanion(Companion_5);
  initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CartItem, 'CartItem', CartItem, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  initMetadataForCompanion(Companion_6);
  initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Coupon, 'Coupon', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  initMetadataForClass(CouponAlreadyUsedException, 'CouponAlreadyUsedException', CouponAlreadyUsedException, Exception);
  initMetadataForCompanion(Companion_7, VOID, [SerializerFactory]);
  initMetadataForClass(DiscountType, 'DiscountType', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_42});
  initMetadataForCompanion(Companion_8);
  initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(FavoriteProduct, 'FavoriteProduct', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  initMetadataForObject(FlexibleListSerializer, 'FlexibleListSerializer', VOID, VOID, [KSerializer]);
  initMetadataForCompanion(Companion_9);
  initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Friend, 'Friend', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
  initMetadataForCompanion(Companion_10);
  initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Notification, 'Notification', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
  initMetadataForCompanion(Companion_11);
  initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Order, 'Order', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
  initMetadataForCompanion(Companion_12, VOID, [SerializerFactory]);
  initMetadataForClass(PaymentMethod, 'PaymentMethod', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_47});
  initMetadataForCompanion(Companion_13, VOID, [SerializerFactory]);
  initMetadataForClass(OrderStatus, 'OrderStatus', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_48});
  initMetadataForCompanion(Companion_14);
  initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Product, 'Product', Product, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
  initMetadataForCompanion(Companion_15);
  initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OptionValue, 'OptionValue', OptionValue, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
  initMetadataForCompanion(Companion_16, VOID, [SerializerFactory]);
  initMetadataForClass(ProductKind, 'ProductKind', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_51});
  initMetadataForCompanion(Companion_17, VOID, [SerializerFactory]);
  initMetadataForClass(TargetAudience, 'TargetAudience', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_52});
  initMetadataForCompanion(Companion_18);
  initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ProductOption, 'ProductOption', ProductOption, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
  initMetadataForCompanion(Companion_19);
  initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Profile, 'Profile', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
  initMetadataForCompanion(Companion_20);
  initMetadataForObject($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(StockReminder, 'StockReminder', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
  initMetadataForClass(ApplyCouponUseCase, 'ApplyCouponUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(CreateWelcomeCouponUseCase, 'CreateWelcomeCouponUseCase', VOID, VOID, VOID, [2]);
  initMetadataForClass(FetchProfileUseCase, 'FetchProfileUseCase', VOID, VOID, VOID, [0]);
  initMetadataForClass(GetBannersUseCase, 'GetBannersUseCase', VOID, VOID, VOID, [0]);
  initMetadataForClass(GetCurrentUserUseCase, 'GetCurrentUserUseCase');
  initMetadataForClass(GetCurrentUserValueUseCase, 'GetCurrentUserValueUseCase');
  initMetadataForClass(GetFavoriteProductsUseCase, 'GetFavoriteProductsUseCase');
  initMetadataForClass(GetProductsUseCase, 'GetProductsUseCase', VOID, VOID, VOID, [0]);
  initMetadataForClass(GetUserCouponsUseCase, 'GetUserCouponsUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(HandleRecoveryLinkUseCase, 'HandleRecoveryLinkUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(LoginUseCase, 'LoginUseCase', VOID, VOID, VOID, [2]);
  initMetadataForClass(LoginWithGoogleUseCase, 'LoginWithGoogleUseCase', VOID, VOID, VOID, [2]);
  initMetadataForClass(MarkCouponAsUsedUseCase, 'MarkCouponAsUsedUseCase', VOID, VOID, VOID, [2]);
  initMetadataForClass(NotifyAdminUseCase, 'NotifyAdminUseCase', VOID, VOID, VOID, [6]);
  initMetadataForClass(RegisterUseCase, 'RegisterUseCase', VOID, VOID, VOID, [2]);
  initMetadataForClass(ResetPasswordUseCase, 'ResetPasswordUseCase', VOID, VOID, VOID, [2]);
  initMetadataForClass(UpdateFcmTokenUseCase, 'UpdateFcmTokenUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(UpdatePasswordUseCase, 'UpdatePasswordUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(UpdateProfileUseCase, 'UpdateProfileUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(AddToCartUseCase, 'AddToCartUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(ClearCartUseCase, 'ClearCartUseCase', VOID, VOID, VOID, [0]);
  initMetadataForClass(GetCartItemByIdUseCase, 'GetCartItemByIdUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(GetCartItemsUseCase, 'GetCartItemsUseCase');
  initMetadataForClass(RemoveFromCartUseCase, 'RemoveFromCartUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(SyncCartUseCase, 'SyncCartUseCase', VOID, VOID, VOID, [0]);
  initMetadataForClass(UpdateCartQuantityUseCase, 'UpdateCartQuantityUseCase', VOID, VOID, VOID, [2]);
  initMetadataForClass(SyncFavoritesUseCase, 'SyncFavoritesUseCase', VOID, VOID, VOID, [0]);
  initMetadataForClass(ToggleFavoriteUseCase, 'ToggleFavoriteUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(AddFriendUseCase, 'AddFriendUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(DeleteFriendAvatarUseCase, 'DeleteFriendAvatarUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(DeleteFriendUseCase, 'DeleteFriendUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(GetFriendsUseCase, 'GetFriendsUseCase', VOID, VOID, VOID, [0]);
  initMetadataForClass(UpdateFriendUseCase, 'UpdateFriendUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(UploadFriendAvatarUseCase, 'UploadFriendAvatarUseCase', VOID, VOID, VOID, [2]);
  initMetadataForClass(GetLanguageUseCase, 'GetLanguageUseCase');
  initMetadataForClass(SetLanguageUseCase, 'SetLanguageUseCase');
  initMetadataForClass(IsConnectedUseCase, 'IsConnectedUseCase');
  initMetadataForClass(GetOrderByIdUseCase, 'GetOrderByIdUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(GetOrderHistoryUseCase, 'GetOrderHistoryUseCase', VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($invokeCOROUTINE$, CoroutineImpl);
  initMetadataForClass(PlaceOrderUseCase, 'PlaceOrderUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(RequestReturnUseCase, 'RequestReturnUseCase', VOID, VOID, VOID, [2]);
  initMetadataForClass(GetProductByIdUseCase, 'GetProductByIdUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(GetStockRemindersUseCase, 'GetStockRemindersUseCase');
  initMetadataForClass(ToggleStockReminderUseCase, 'ToggleStockReminderUseCase', VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($invokeCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(CheckUpdateUseCase, 'CheckUpdateUseCase', VOID, VOID, VOID, [0]);
  initMetadataForClass(GetShippingCostUseCase, 'GetShippingCostUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(DownloadDesignImageUseCase, 'DownloadDesignImageUseCase', VOID, VOID, VOID, [1]);
  initMetadataForClass(UploadDesignImageUseCase, 'UploadDesignImageUseCase', VOID, VOID, VOID, [2]);
  initMetadataForLambda(AppViewModel$checkUpdate$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AppViewModel$handleDeepLink$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AppViewModel$handleOrderDeepLink$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AppViewModel$navigateToAuth$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AppViewModel$syncData$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(AppViewModel, 'AppViewModel', VOID, ViewModel, VOID, [0]);
  initMetadataForCompanion(Companion_21);
  initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_22);
  initMetadataForObject($serializer_17, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_23);
  initMetadataForObject($serializer_18, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_24);
  initMetadataForObject($serializer_19, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_25);
  initMetadataForObject($serializer_20, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_26);
  initMetadataForObject($serializer_21, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_27);
  initMetadataForObject($serializer_22, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_28);
  initMetadataForObject($serializer_23, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_29);
  initMetadataForObject($serializer_24, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_30);
  initMetadataForObject($serializer_25, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_31);
  initMetadataForObject($serializer_26, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_32);
  initMetadataForObject($serializer_27, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_33);
  initMetadataForObject($serializer_28, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_34);
  initMetadataForObject($serializer_29, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_35);
  initMetadataForObject($serializer_30, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_36);
  initMetadataForObject($serializer_31, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForInterface(Screen, 'Screen', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_72});
  initMetadataForObject(Shopping, 'Shopping', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: Shopping_getInstance});
  initMetadataForObject(Profile_0, 'Profile', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: Profile_getInstance});
  initMetadataForObject(Cart, 'Cart', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: Cart_getInstance});
  initMetadataForClass(ProductDetails, 'ProductDetails', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_16});
  initMetadataForClass(BeadsProductDetails, 'BeadsProductDetails', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_17});
  initMetadataForClass(CustomMugDetails, 'CustomMugDetails', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_18});
  initMetadataForClass(CustomMagicMugDetails, 'CustomMagicMugDetails', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_19});
  initMetadataForObject(Checkout, 'Checkout', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: Checkout_getInstance});
  initMetadataForObject(Friends, 'Friends', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: Friends_getInstance});
  initMetadataForObject(Favorites, 'Favorites', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: Favorites_getInstance});
  initMetadataForObject(Coupons, 'Coupons', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: Coupons_getInstance});
  initMetadataForObject(StockReminders, 'StockReminders', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: StockReminders_getInstance});
  initMetadataForObject(Update, 'Update', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: Update_getInstance});
  initMetadataForObject(CustomMug, 'CustomMug', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: CustomMug_getInstance});
  initMetadataForClass(Auth_0, 'Auth', Auth_0, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_20});
  initMetadataForClass(Error_0, 'Error', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_21});
  initMetadataForClass(Model3D, 'Model3D', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_22});
  initMetadataForClass(EditDesign, 'EditDesign', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_23});
  initMetadataForClass(EditCustomMagicMug, 'EditCustomMagicMug', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_24});
  initMetadataForClass(CartNormalProductDetails, 'CartNormalProductDetails', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_25});
  initMetadataForClass(CartMugProductDetails, 'CartMugProductDetails', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_26});
  initMetadataForClass(CartMagicMugProductDetails, 'CartMagicMugProductDetails', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_27});
  initMetadataForClass(MugDesignerEditor, 'MugDesignerEditor', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_28});
  initMetadataForClass(OrderDetails, 'OrderDetails', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_29});
  initMetadataForClass(PastOrderDetails, 'PastOrderDetails', VOID, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_30});
  initMetadataForObject(OrderHistory, 'OrderHistory', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: OrderHistory_getInstance});
  initMetadataForObject(AccountManagement, 'AccountManagement', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: AccountManagement_getInstance});
  initMetadataForClass(DeleteAccountStandalone, 'DeleteAccountStandalone', DeleteAccountStandalone, VOID, [Screen], VOID, VOID, {0: $serializer_getInstance_31});
  initMetadataForObject(DeleteAccountSuccess, 'DeleteAccountSuccess', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: DeleteAccountSuccess_getInstance});
  initMetadataForObject(ResetPasswordSuccess, 'ResetPasswordSuccess', VOID, VOID, [Screen, SerializerFactory], VOID, VOID, {0: ResetPasswordSuccess_getInstance});
  initMetadataForCompanion(Companion_37, VOID, [SerializerFactory]);
  initMetadataForObject(ComposableSingletons$HomeNavHostKt, 'ComposableSingletons$HomeNavHostKt');
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_1, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(HomeNavHost$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(HomeNavHost$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(HomeNavHost$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(HomeNavHost$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(HomeNavHost$slambda$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(HomeNavHost$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(HomeNavHost$slambda$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(HomeNavHost$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(HomeNavHost$slambda_7, CoroutineImpl, VOID, [1]);
  initMetadataForObject(ComposableSingletons$AccountManagementScreenKt, 'ComposableSingletons$AccountManagementScreenKt');
  initMetadataForLambda(DeleteAccountStandaloneScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_2, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(DeleteAccountStandaloneScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DeleteAccountStandaloneScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($deleteAccountCOROUTINE$_0, CoroutineImpl);
  initMetadataForCoroutine($deleteAccountWithTokenCOROUTINE$, CoroutineImpl);
  initMetadataForClass(BaseMviViewModel, 'BaseMviViewModel', VOID, ViewModel, VOID, [1]);
  initMetadataForClass(AccountManagementViewModel, 'AccountManagementViewModel', VOID, BaseMviViewModel, VOID, [1, 2]);
  initMetadataForClass(AccountManagementState, 'AccountManagementState', AccountManagementState);
  initMetadataForInterface(AccountManagementIntent, 'AccountManagementIntent');
  initMetadataForClass(DeleteAccount, 'DeleteAccount', VOID, VOID, [AccountManagementIntent]);
  initMetadataForClass(DeleteAccountWithToken, 'DeleteAccountWithToken', VOID, VOID, [AccountManagementIntent]);
  initMetadataForInterface(AccountManagementSideEffect, 'AccountManagementSideEffect');
  initMetadataForClass(ShowError, 'ShowError', VOID, VOID, [AccountManagementSideEffect]);
  initMetadataForObject(NavigateToSuccess, 'NavigateToSuccess', VOID, VOID, [AccountManagementSideEffect]);
  initMetadataForClass(AuthState, 'AuthState', AuthState);
  initMetadataForInterface(AuthIntent, 'AuthIntent');
  initMetadataForClass(EmailChanged, 'EmailChanged', VOID, VOID, [AuthIntent]);
  initMetadataForClass(PasswordChanged, 'PasswordChanged', VOID, VOID, [AuthIntent]);
  initMetadataForClass(ConfirmPasswordChanged, 'ConfirmPasswordChanged', VOID, VOID, [AuthIntent]);
  initMetadataForClass(RecoveryUrlReceived, 'RecoveryUrlReceived', VOID, VOID, [AuthIntent]);
  initMetadataForObject(LoginClicked, 'LoginClicked', VOID, VOID, [AuthIntent]);
  initMetadataForClass(GoogleLoginClicked, 'GoogleLoginClicked', VOID, VOID, [AuthIntent]);
  initMetadataForObject(RegisterClicked, 'RegisterClicked', VOID, VOID, [AuthIntent]);
  initMetadataForObject(ForgetPasswordClicked, 'ForgetPasswordClicked', VOID, VOID, [AuthIntent]);
  initMetadataForObject(SetPasswordClicked, 'SetPasswordClicked', VOID, VOID, [AuthIntent]);
  initMetadataForClass(TogglePrivacyPolicy, 'TogglePrivacyPolicy', VOID, VOID, [AuthIntent]);
  initMetadataForClass(ToggleKeepLogin, 'ToggleKeepLogin', VOID, VOID, [AuthIntent]);
  initMetadataForClass(NavigateTo, 'NavigateTo', VOID, VOID, [AuthIntent]);
  initMetadataForInterface(AuthSideEffect, 'AuthSideEffect');
  initMetadataForObject(NavigateToHome, 'NavigateToHome', VOID, VOID, [AuthSideEffect]);
  initMetadataForClass(ShowError_0, 'ShowError', VOID, VOID, [AuthSideEffect]);
  initMetadataForClass(ShowMessage, 'ShowMessage', VOID, VOID, [AuthSideEffect]);
  initMetadataForObject(Login, 'Login');
  initMetadataForObject(Register, 'Register');
  initMetadataForObject(ForgetPassword, 'ForgetPassword');
  initMetadataForObject(SetPassword, 'SetPassword');
  function openAuthentication$default(recoveryUrl, $super) {
    recoveryUrl = recoveryUrl === VOID ? null : recoveryUrl;
    var tmp;
    if ($super === VOID) {
      this.d10m(recoveryUrl);
      tmp = Unit_instance;
    } else {
      tmp = $super.d10m.call(this, recoveryUrl);
    }
    return tmp;
  }
  initMetadataForInterface(AuthNavigator, 'AuthNavigator');
  initMetadataForClass(AuthNavigatorImpl, 'AuthNavigatorImpl', VOID, VOID, [AuthNavigator]);
  initMetadataForObject(ComposableSingletons$AuthScreenKt, 'ComposableSingletons$AuthScreenKt');
  initMetadataForLambda(AuthScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AuthScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AuthScreen$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_3, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(AuthContent$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AuthContent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_0, CoroutineImpl);
  initMetadataForCoroutine($loginCOROUTINE$_0, CoroutineImpl);
  initMetadataForCoroutine($loginWithGoogleCOROUTINE$_0, CoroutineImpl);
  initMetadataForCoroutine($registerCOROUTINE$_0, CoroutineImpl);
  initMetadataForCoroutine($forgetPasswordCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($setPasswordCOROUTINE$, CoroutineImpl);
  initMetadataForClass(AuthViewModel, 'AuthViewModel', VOID, BaseMviViewModel, VOID, [1, 0, 2]);
  initMetadataForClass(CartState, 'CartState', CartState);
  initMetadataForInterface(CartIntent, 'CartIntent');
  initMetadataForObject(LoadCart, 'LoadCart', VOID, VOID, [CartIntent]);
  initMetadataForClass(UpdateQuantity, 'UpdateQuantity', VOID, VOID, [CartIntent]);
  initMetadataForClass(RemoveItem, 'RemoveItem', VOID, VOID, [CartIntent]);
  initMetadataForObject(Checkout_0, 'Checkout', VOID, VOID, [CartIntent]);
  initMetadataForObject(ClearCart, 'ClearCart', VOID, VOID, [CartIntent]);
  initMetadataForInterface(CartSideEffect, 'CartSideEffect');
  initMetadataForClass(ShowError_1, 'ShowError', VOID, VOID, [CartSideEffect]);
  initMetadataForObject(NavigateToCheckout, 'NavigateToCheckout', VOID, VOID, [CartSideEffect]);
  initMetadataForObject(NavigateToAuth, 'NavigateToAuth', VOID, VOID, [CartSideEffect]);
  initMetadataForObject(ComposableSingletons$CartScreenKt, 'ComposableSingletons$CartScreenKt');
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_4, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(CartScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartViewModel$observeLanguage$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartViewModel$observeNetwork$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartViewModel$observeAuth$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartViewModel$observeCart$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartViewModel$observeCart$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_5, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_6, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_7, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(CartViewModel$observeLanguage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartViewModel$observeNetwork$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartViewModel$syncCart$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartViewModel$observeAuth$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartViewModel$observeCart$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_1, CoroutineImpl);
  initMetadataForClass(CartViewModel, 'CartViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForClass(CartMagicMugProductDetailsState, 'CartMagicMugProductDetailsState', CartMagicMugProductDetailsState);
  initMetadataForInterface(CartMagicMugProductDetailsIntent, 'CartMagicMugProductDetailsIntent');
  initMetadataForClass(LoadItem, 'LoadItem', VOID, VOID, [CartMagicMugProductDetailsIntent]);
  initMetadataForObject(ComposableSingletons$CartMagicMugProductDetailsScreenKt, 'ComposableSingletons$CartMagicMugProductDetailsScreenKt');
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(CartMagicMugProductDetailsScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMagicMugProductDetailsScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_8, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(CartMagicMugProductDetailsScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMagicMugProductDetailsScreen$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMagicMugProductDetailsScreen$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CartMagicMugProductDetailsScreen$$inlined$let$4$1);
  initMetadataForLambda(CartMagicMugProductDetailsScreen$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMagicMugProductDetailsScreen$slambda_7, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMagicMugProductDetailsScreen$lambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMagicMugProductDetailsScreen$slambda_9, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMagicMugProductDetailsViewModel$observeLanguage$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMagicMugProductDetailsViewModel$observeLanguage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_2, CoroutineImpl);
  initMetadataForClass(CartMagicMugProductDetailsViewModel, 'CartMagicMugProductDetailsViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForClass(CartMugProductDetailsState, 'CartMugProductDetailsState', CartMugProductDetailsState);
  initMetadataForInterface(CartMugProductDetailsIntent, 'CartMugProductDetailsIntent');
  initMetadataForClass(LoadItem_0, 'LoadItem', VOID, VOID, [CartMugProductDetailsIntent]);
  initMetadataForObject(ComposableSingletons$CartMugProductDetailsScreenKt, 'ComposableSingletons$CartMugProductDetailsScreenKt');
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(CartMugProductDetailsScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMugProductDetailsScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_9, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(CartMugProductDetailsScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMugProductDetailsScreen$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMugProductDetailsScreen$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CartMugProductDetailsScreen$$inlined$let$4$1);
  initMetadataForLambda(CartMugProductDetailsScreen$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMugProductDetailsScreen$slambda_7, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMugProductDetailsScreen$lambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMugProductDetailsScreen$slambda_9, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMugProductDetailsViewModel$observeLanguage$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartMugProductDetailsViewModel$observeLanguage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_3, CoroutineImpl);
  initMetadataForClass(CartMugProductDetailsViewModel, 'CartMugProductDetailsViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForClass(CartNormalProductDetailsState, 'CartNormalProductDetailsState', CartNormalProductDetailsState);
  initMetadataForInterface(CartNormalProductDetailsIntent, 'CartNormalProductDetailsIntent');
  initMetadataForClass(LoadItem_1, 'LoadItem', VOID, VOID, [CartNormalProductDetailsIntent]);
  initMetadataForObject(ComposableSingletons$CartNormalProductDetailsScreenKt, 'ComposableSingletons$CartNormalProductDetailsScreenKt');
  initMetadataForLambda(CartNormalProductDetailsScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartNormalProductDetailsScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_10, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(CartNormalProductDetailsScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartNormalProductDetailsScreen$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartNormalProductDetailsScreen$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartNormalProductDetailsScreen$lambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartNormalProductDetailsViewModel$observeLanguage$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CartNormalProductDetailsViewModel$observeLanguage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CartNormalProductDetailsViewModel, 'CartNormalProductDetailsViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForClass(CheckoutState, 'CheckoutState', CheckoutState);
  initMetadataForInterface(CheckoutIntent, 'CheckoutIntent');
  initMetadataForObject(LoadData, 'LoadData', VOID, VOID, [CheckoutIntent]);
  initMetadataForObject(Retry, 'Retry', VOID, VOID, [CheckoutIntent]);
  initMetadataForClass(ToggleShippingType, 'ToggleShippingType', VOID, VOID, [CheckoutIntent]);
  initMetadataForClass(SelectFriend, 'SelectFriend', VOID, VOID, [CheckoutIntent]);
  initMetadataForClass(UpdateMyAddress, 'UpdateMyAddress', VOID, VOID, [CheckoutIntent]);
  initMetadataForClass(UpdateMyPhone, 'UpdateMyPhone', VOID, VOID, [CheckoutIntent]);
  initMetadataForClass(UpdateMyFirstName, 'UpdateMyFirstName', VOID, VOID, [CheckoutIntent]);
  initMetadataForClass(UpdateMyLastName, 'UpdateMyLastName', VOID, VOID, [CheckoutIntent]);
  initMetadataForClass(UpdateMyGovernorate, 'UpdateMyGovernorate', VOID, VOID, [CheckoutIntent]);
  initMetadataForClass(SelectPaymentMethod, 'SelectPaymentMethod', VOID, VOID, [CheckoutIntent]);
  initMetadataForObject(PlaceOrder, 'PlaceOrder', VOID, VOID, [CheckoutIntent]);
  initMetadataForObject(RetryShippingFetch, 'RetryShippingFetch', VOID, VOID, [CheckoutIntent]);
  initMetadataForClass(AddFriend, 'AddFriend', VOID, VOID, [CheckoutIntent]);
  initMetadataForClass(ToggleAddFriendDialog, 'ToggleAddFriendDialog', VOID, VOID, [CheckoutIntent]);
  initMetadataForClass(UpdateCouponCode, 'UpdateCouponCode', VOID, VOID, [CheckoutIntent]);
  initMetadataForObject(ApplyCoupon, 'ApplyCoupon', VOID, VOID, [CheckoutIntent]);
  initMetadataForInterface(CheckoutSideEffect, 'CheckoutSideEffect');
  initMetadataForClass(ShowError_2, 'ShowError', VOID, VOID, [CheckoutSideEffect]);
  initMetadataForClass(OrderPlaced, 'OrderPlaced', VOID, VOID, [CheckoutSideEffect]);
  initMetadataForObject(FriendAdded, 'FriendAdded', VOID, VOID, [CheckoutSideEffect]);
  initMetadataForObject(ComposableSingletons$CheckoutScreenKt, 'ComposableSingletons$CheckoutScreenKt');
  initMetadataForLambda(CheckoutScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_11, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(CheckoutScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CheckoutScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DeliverySection$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CheckoutViewModel$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CheckoutViewModel$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CheckoutViewModel$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CheckoutViewModel$handleIntent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CheckoutViewModel$handleIntent$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_4, CoroutineImpl);
  initMetadataForCoroutine($fetchShippingCostCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($validateCOROUTINE$, CoroutineImpl);
  initMetadataForClass(CheckoutViewModel, 'CheckoutViewModel', VOID, BaseMviViewModel, VOID, [1, 0]);
  initMetadataForObject(ComposableSingletons$CouponSectionKt, 'ComposableSingletons$CouponSectionKt');
  initMetadataForObject(ComposableSingletons$DeliveryDetailsSectionKt, 'ComposableSingletons$DeliveryDetailsSectionKt');
  initMetadataForObject(ComposableSingletons$GovernorateDropdownKt, 'ComposableSingletons$GovernorateDropdownKt');
  initMetadataForObject(ComposableSingletons$OrderSummarySectionKt, 'ComposableSingletons$OrderSummarySectionKt');
  initMetadataForObject(ComposableSingletons$ContactUsSectionKt, 'ComposableSingletons$ContactUsSectionKt');
  initMetadataForObject(ComposableSingletons$GiftSelectionKt, 'ComposableSingletons$GiftSelectionKt');
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForObject(ComposableSingletons$HadayaImageKt, 'ComposableSingletons$HadayaImageKt');
  initMetadataForObject(ComposableSingletons$LoginRequiredScreenKt, 'ComposableSingletons$LoginRequiredScreenKt');
  initMetadataForObject(ComposableSingletons$ProductMediaGallerySectionKt, 'ComposableSingletons$ProductMediaGallerySectionKt');
  initMetadataForLambda(ProductMediaGallerySection$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(ZoomableMediaView$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ZoomableMediaView$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ZoomableMediaView$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ZoomableMediaView$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ZoomableAsyncImage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ZoomableAsyncImage$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ZoomableAsyncImage$slambda$lambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ZoomableAsyncImage$slambda$lambda$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ZoomableAsyncImage$slambda$lambda$slambda$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ZoomableAsyncImage$slambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ZoomableAsyncImage$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ZoomableAsyncImage$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ZoomableAsyncImage$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ZoomableAsyncImage$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CouponsState, 'CouponsState', CouponsState);
  initMetadataForInterface(CouponsIntent, 'CouponsIntent');
  initMetadataForObject(LoadCoupons, 'LoadCoupons', VOID, VOID, [CouponsIntent]);
  initMetadataForClass(ChangeFilter, 'ChangeFilter', VOID, VOID, [CouponsIntent]);
  initMetadataForClass(CouponFilterType, 'CouponFilterType', VOID, Enum);
  initMetadataForObject(ComposableSingletons$CouponsScreenKt, 'ComposableSingletons$CouponsScreenKt');
  initMetadataForLambda(CouponsScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CouponsScreen$lambda$lambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CouponsViewModel$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_5, CoroutineImpl);
  initMetadataForClass(CouponsViewModel, 'CouponsViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForClass(FavoritesState, 'FavoritesState', FavoritesState);
  initMetadataForInterface(FavoritesIntent, 'FavoritesIntent');
  initMetadataForObject(LoadFavorites, 'LoadFavorites', VOID, VOID, [FavoritesIntent]);
  initMetadataForClass(ToggleFavorite, 'ToggleFavorite', VOID, VOID, [FavoritesIntent]);
  initMetadataForObject(ComposableSingletons$FavoritesScreenKt, 'ComposableSingletons$FavoritesScreenKt');
  initMetadataForLambda(FavoritesViewModel$observeLanguage$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(FavoritesViewModel$observeFavorites$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(FavoritesViewModel$syncFavorites$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(FavoritesViewModel$observeLanguage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(FavoritesViewModel$observeFavorites$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_6, CoroutineImpl);
  initMetadataForClass(FavoritesViewModel, 'FavoritesViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForObject(ComposableSingletons$FriendComponentsKt, 'ComposableSingletons$FriendComponentsKt');
  initMetadataForClass(FriendsState, 'FriendsState', FriendsState);
  initMetadataForInterface(FriendsIntent, 'FriendsIntent');
  initMetadataForObject(LoadFriends, 'LoadFriends', VOID, VOID, [FriendsIntent]);
  initMetadataForClass(AddFriend_0, 'AddFriend', VOID, VOID, [FriendsIntent]);
  initMetadataForClass(UpdateFriend, 'UpdateFriend', VOID, VOID, [FriendsIntent]);
  initMetadataForClass(DeleteFriend, 'DeleteFriend', VOID, VOID, [FriendsIntent]);
  initMetadataForClass(ToggleAddFriendDialog_0, 'ToggleAddFriendDialog', VOID, VOID, [FriendsIntent]);
  initMetadataForClass(ShowEditFriendDialog, 'ShowEditFriendDialog', VOID, VOID, [FriendsIntent]);
  initMetadataForClass(ShowDeleteFriendDialog, 'ShowDeleteFriendDialog', VOID, VOID, [FriendsIntent]);
  initMetadataForInterface(FriendsSideEffect, 'FriendsSideEffect');
  initMetadataForClass(ShowError_3, 'ShowError', VOID, VOID, [FriendsSideEffect]);
  initMetadataForObject(FriendAdded_0, 'FriendAdded', VOID, VOID, [FriendsSideEffect]);
  initMetadataForObject(FriendUpdated, 'FriendUpdated', VOID, VOID, [FriendsSideEffect]);
  initMetadataForObject(FriendDeleted, 'FriendDeleted', VOID, VOID, [FriendsSideEffect]);
  initMetadataForObject(ComposableSingletons$FriendsScreenKt, 'ComposableSingletons$FriendsScreenKt');
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_12, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(FriendsScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(FriendsScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(FriendsViewModel$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(FriendsViewModel$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_7, CoroutineImpl);
  initMetadataForClass(FriendsViewModel, 'FriendsViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForObject(ComposableSingletons$EditMagicMugDesignScreenKt, 'ComposableSingletons$EditMagicMugDesignScreenKt');
  initMetadataForLambda(EditCustomMagicMugScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(EditCustomMagicMugScreen$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_13, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(EditCustomMagicMugScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(EditCustomMagicMugScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForClass(EditMugDesignState, 'EditMugDesignState', EditMugDesignState);
  initMetadataForInterface(EditMugDesignIntent, 'EditMugDesignIntent');
  initMetadataForClass(LoadCartItem, 'LoadCartItem', VOID, VOID, [EditMugDesignIntent]);
  initMetadataForClass(Model3D_0, 'Model3D', VOID, VOID, [EditMugDesignIntent]);
  initMetadataForClass(UpdateMugDesign, 'UpdateMugDesign', UpdateMugDesign, VOID, [EditMugDesignIntent]);
  initMetadataForInterface(EditMugDesignSideEffect, 'EditMugDesignSideEffect');
  initMetadataForClass(ShowMessage_0, 'ShowMessage', VOID, VOID, [EditMugDesignSideEffect]);
  initMetadataForObject(NavigateBack, 'NavigateBack', VOID, VOID, [EditMugDesignSideEffect]);
  initMetadataForClass(NavigateToEditor, 'NavigateToEditor', VOID, VOID, [EditMugDesignSideEffect]);
  initMetadataForClass(Model3D_1, 'Model3D', VOID, VOID, [EditMugDesignSideEffect]);
  initMetadataForObject(ComposableSingletons$EditMugDesignScreenKt, 'ComposableSingletons$EditMugDesignScreenKt');
  initMetadataForLambda(EditMugDesignScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(EditMugDesignScreen$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_14, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(EditMugDesignScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(EditMugDesignScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(EditMugDesignViewModel$observeLanguage$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(EditMugDesignViewModel$observeLanguage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(EditMugDesignViewModel$handleIntent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_8, CoroutineImpl);
  initMetadataForClass(EditMugDesignViewModel, 'EditMugDesignViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForClass(EditorImageElement, 'EditorImageElement');
  initMetadataForClass(FilterType, 'FilterType', VOID, Enum);
  initMetadataForClass(Model3DState, 'Model3DState', Model3DState);
  initMetadataForInterface(ModelMugIntent, 'ModelMugIntent');
  initMetadataForClass(LoadProduct, 'LoadProduct', VOID, VOID, [ModelMugIntent]);
  initMetadataForClass(ImagePicked, 'ImagePicked', VOID, VOID, [ModelMugIntent]);
  initMetadataForClass(CustomImageApplied, 'CustomImageApplied', VOID, VOID, [ModelMugIntent]);
  initMetadataForClass(UpdateElements, 'UpdateElements', VOID, VOID, [ModelMugIntent]);
  initMetadataForObject(AddToCart, 'AddToCart', VOID, VOID, [ModelMugIntent]);
  initMetadataForObject(RemoveCustomization, 'RemoveCustomization', VOID, VOID, [ModelMugIntent]);
  initMetadataForObject(OpenEditor, 'OpenEditor', VOID, VOID, [ModelMugIntent]);
  initMetadataForObject(CloseEditor, 'CloseEditor', VOID, VOID, [ModelMugIntent]);
  initMetadataForClass(CardSelected, 'CardSelected', VOID, VOID, [ModelMugIntent]);
  initMetadataForClass(CardMessageChanged, 'CardMessageChanged', VOID, VOID, [ModelMugIntent]);
  initMetadataForClass(CardBirthdayChanged, 'CardBirthdayChanged', VOID, VOID, [ModelMugIntent]);
  initMetadataForClass(BoxSelected, 'BoxSelected', VOID, VOID, [ModelMugIntent]);
  initMetadataForClass(BoxMessageChanged, 'BoxMessageChanged', VOID, VOID, [ModelMugIntent]);
  initMetadataForClass(BoxBirthdayChanged, 'BoxBirthdayChanged', VOID, VOID, [ModelMugIntent]);
  initMetadataForClass(SizeSelected, 'SizeSelected', VOID, VOID, [ModelMugIntent]);
  initMetadataForClass(ColorSelected, 'ColorSelected', VOID, VOID, [ModelMugIntent]);
  initMetadataForClass(OptionSelected, 'OptionSelected', VOID, VOID, [ModelMugIntent]);
  initMetadataForClass(ProductCommentChanged, 'ProductCommentChanged', VOID, VOID, [ModelMugIntent]);
  initMetadataForInterface(Model3DSideEffect, 'Model3DSideEffect');
  initMetadataForClass(ShowMessage_1, 'ShowMessage', VOID, VOID, [Model3DSideEffect]);
  initMetadataForObject(NavigateBack_0, 'NavigateBack', VOID, VOID, [Model3DSideEffect]);
  initMetadataForObject(NavigateToAuth_0, 'NavigateToAuth', VOID, VOID, [Model3DSideEffect]);
  initMetadataForObject(ComposableSingletons$ModelMugScreenKt, 'ComposableSingletons$ModelMugScreenKt');
  initMetadataForLambda(ModelMugScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_15, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(ModelMugScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ModelMugScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ModelMugViewModel$observeLanguage$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ModelMugViewModel$observeCurrentUser$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ModelMugViewModel$handleAddToCart$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ModelMugViewModel$handleAddToCart$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ModelMugViewModel$observeLanguage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ModelMugViewModel$observeCurrentUser$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ModelMugViewModel$handleAddToCart$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_9, CoroutineImpl);
  initMetadataForCoroutine($handleAddToCartCOROUTINE$, CoroutineImpl);
  initMetadataForClass(ModelMugViewModel, 'ModelMugViewModel', VOID, BaseMviViewModel, VOID, [1, 0]);
  initMetadataForLambda(MugDesignerEditorScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_16, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(MugDesignerEditorScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(MugDesignerEditorScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForObject(ComposableSingletons$MugImageEditorScreenKt, 'ComposableSingletons$MugImageEditorScreenKt');
  initMetadataForLambda(BaseMugImageEditorScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BaseMugImageEditorScreen$lambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BaseMugImageEditorScreen$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BaseMugImageEditorScreen$lambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BaseMugImageEditorScreen$lambda$lambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BaseMugImageEditorScreen$lambda$lambda$lambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$androidx_compose_ui_text_input_VisualTransformation$0, 'sam$androidx_compose_ui_text_input_VisualTransformation$0', VOID, VOID, [VisualTransformation, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(SimpleColorPickerDialog$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(SimpleColorPickerDialog$lambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(SimpleColorPickerDialog$lambda$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(SimpleColorPickerDialog$lambda$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForObject(ComposableSingletons$Model3DViewerSectionKt, 'ComposableSingletons$Model3DViewerSectionKt');
  initMetadataForObject(ComposableSingletons$ModelMugScreenContentKt, 'ComposableSingletons$ModelMugScreenContentKt');
  initMetadataForLambda(BaseMviViewModel$container$o$intent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(BaseMviViewModel$container$1);
  initMetadataForClass(OrderState, 'OrderState');
  initMetadataForInterface(OrderIntent, 'OrderIntent');
  initMetadataForClass(SetOrder, 'SetOrder', VOID, VOID, [OrderIntent]);
  initMetadataForClass(UpdateComment, 'UpdateComment', VOID, VOID, [OrderIntent]);
  initMetadataForObject(ConfirmOrder, 'ConfirmOrder', VOID, VOID, [OrderIntent]);
  initMetadataForInterface(OrderSideEffect, 'OrderSideEffect');
  initMetadataForClass(ShowError_4, 'ShowError', VOID, VOID, [OrderSideEffect]);
  initMetadataForObject(NavigateToHome_0, 'NavigateToHome', VOID, VOID, [OrderSideEffect]);
  initMetadataForObject(ComposableSingletons$OrderScreenKt, 'ComposableSingletons$OrderScreenKt');
  initMetadataForLambda(OrderScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_17, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(OrderScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(OrderScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_10, CoroutineImpl);
  initMetadataForClass(OrderViewModel, 'OrderViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForClass(OrderDetailsState, 'OrderDetailsState');
  initMetadataForInterface(OrderDetailsIntent, 'OrderDetailsIntent');
  initMetadataForClass(ReAddToCart, 'ReAddToCart', VOID, VOID, [OrderDetailsIntent]);
  initMetadataForClass(RequestReturn, 'RequestReturn', VOID, VOID, [OrderDetailsIntent]);
  initMetadataForClass(ToggleFavorite_0, 'ToggleFavorite', VOID, VOID, [OrderDetailsIntent]);
  initMetadataForClass(ToggleStockReminder, 'ToggleStockReminder', VOID, VOID, [OrderDetailsIntent]);
  initMetadataForInterface(OrderDetailsSideEffect, 'OrderDetailsSideEffect');
  initMetadataForClass(ShowMessage_2, 'ShowMessage', VOID, VOID, [OrderDetailsSideEffect]);
  initMetadataForClass(ShowStockDialog, 'ShowStockDialog', VOID, VOID, [OrderDetailsSideEffect]);
  initMetadataForObject(NavigateBack_1, 'NavigateBack', VOID, VOID, [OrderDetailsSideEffect]);
  initMetadataForObject(ComposableSingletons$OrderDetailsScreenKt, 'ComposableSingletons$OrderDetailsScreenKt');
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_18, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(OrderDetailsScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(OrderDetailsScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(OrderDetailsViewModel$handleIntent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(OrderDetailsViewModel$handleIntent$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_11, CoroutineImpl);
  initMetadataForClass(OrderDetailsViewModel, 'OrderDetailsViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForClass(OrderHistoryState, 'OrderHistoryState', OrderHistoryState);
  initMetadataForInterface(OrderHistoryIntent, 'OrderHistoryIntent');
  initMetadataForObject(LoadOrders, 'LoadOrders', VOID, VOID, [OrderHistoryIntent]);
  initMetadataForClass(FilterChanged, 'FilterChanged', VOID, VOID, [OrderHistoryIntent]);
  initMetadataForInterface(OrderHistorySideEffect, 'OrderHistorySideEffect');
  initMetadataForClass(ShowError_5, 'ShowError', VOID, VOID, [OrderHistorySideEffect]);
  initMetadataForClass(OrderFilter, 'OrderFilter', VOID, Enum);
  initMetadataForObject(ComposableSingletons$OrderHistoryScreenKt, 'ComposableSingletons$OrderHistoryScreenKt');
  initMetadataForClass(sam$androidx_lifecycle_LifecycleEventObserver$0, 'sam$androidx_lifecycle_LifecycleEventObserver$0', VOID, VOID, [LifecycleEventObserver, FunctionAdapter]);
  initMetadataForClass(OrderHistoryScreen$$inlined$cache$1$2);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_19, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(OrderHistoryScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(OrderHistoryScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForLambda(OrderHistoryViewModel$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_12, CoroutineImpl);
  initMetadataForClass(OrderHistoryViewModel, 'OrderHistoryViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForClass(BeadsProductDetailsState, 'BeadsProductDetailsState', BeadsProductDetailsState);
  initMetadataForInterface(BeadsProductDetailsIntent, 'BeadsProductDetailsIntent');
  initMetadataForClass(LoadProduct_0, 'LoadProduct', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForObject(AddToCart_0, 'AddToCart', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForObject(ToggleStockReminder_0, 'ToggleStockReminder', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(QuantityChanged, 'QuantityChanged', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForObject(ToggleFavorite_1, 'ToggleFavorite', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(KindChanged, 'KindChanged', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(TargetAudienceChanged, 'TargetAudienceChanged', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(CardSelected_0, 'CardSelected', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(CardMessageChanged_0, 'CardMessageChanged', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(CardBirthdayChanged_0, 'CardBirthdayChanged', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(BoxSelected_0, 'BoxSelected', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(BoxMessageChanged_0, 'BoxMessageChanged', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(BoxBirthdayChanged_0, 'BoxBirthdayChanged', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(SizeSelected_0, 'SizeSelected', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(ColorSelected_0, 'ColorSelected', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(OptionSelected_0, 'OptionSelected', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(ProductCommentChanged_0, 'ProductCommentChanged', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForClass(BraceletNameChanged, 'BraceletNameChanged', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForObject(ShareProduct, 'ShareProduct', VOID, VOID, [BeadsProductDetailsIntent]);
  initMetadataForInterface(BeadsProductDetailsSideEffect, 'BeadsProductDetailsSideEffect');
  initMetadataForClass(ShowMessage_3, 'ShowMessage', VOID, VOID, [BeadsProductDetailsSideEffect]);
  initMetadataForClass(ShowToast, 'ShowToast', VOID, VOID, [BeadsProductDetailsSideEffect]);
  initMetadataForObject(NavigateToAuth_1, 'NavigateToAuth', VOID, VOID, [BeadsProductDetailsSideEffect]);
  initMetadataForObject(ComposableSingletons$BeadsProductDetailsScreenKt, 'ComposableSingletons$BeadsProductDetailsScreenKt');
  initMetadataForLambda(BeadsProductDetailsScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_20, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(BeadsProductDetailsScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BeadsProductDetailsScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BeadsProductDetailsScreen$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BeadsProductDetailsViewModel$observeLanguage$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BeadsProductDetailsViewModel$observeFavorite$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BeadsProductDetailsViewModel$observeStockReminder$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BeadsProductDetailsViewModel$observeLanguage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BeadsProductDetailsViewModel$observeFavorite$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BeadsProductDetailsViewModel$observeStockReminder$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BeadsProductDetailsViewModel$handleIntent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BeadsProductDetailsViewModel$handleIntent$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(BeadsProductDetailsViewModel$handleIntent$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_13, CoroutineImpl);
  initMetadataForClass(BeadsProductDetailsViewModel, 'BeadsProductDetailsViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForObject(ComposableSingletons$CustomMagicMugDetailsScreenKt, 'ComposableSingletons$CustomMagicMugDetailsScreenKt');
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(CustomMagicMugDetailsScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_21, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(CustomMagicMugDetailsScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomMagicMugDetailsScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomMagicMugDetailsScreen$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CustomMagicMugDetailsScreen$$inlined$cache$4$1);
  initMetadataForLambda(CustomMagicMugDetailsScreen$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomMagicMugDetailsScreen$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomMagicMugDetailsScreen$slambda_7, CoroutineImpl, VOID, [1]);
  initMetadataForObject(ComposableSingletons$CustomMugDetailsScreenKt, 'ComposableSingletons$CustomMugDetailsScreenKt');
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(CustomMugDetailsScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_22, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(CustomMugDetailsScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomMugDetailsScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomMugDetailsScreen$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CustomMugDetailsScreen$$inlined$cache$4$1);
  initMetadataForLambda(CustomMugDetailsScreen$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomMugDetailsScreen$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomMugDetailsScreen$slambda_7, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CustomProductDetailsState, 'CustomProductDetailsState', CustomProductDetailsState);
  initMetadataForInterface(CustomProductDetailsIntent, 'CustomProductDetailsIntent');
  initMetadataForClass(LoadProduct_1, 'LoadProduct', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForObject(AddToCart_1, 'AddToCart', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForObject(ToggleStockReminder_1, 'ToggleStockReminder', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(QuantityChanged_0, 'QuantityChanged', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForObject(ToggleFavorite_2, 'ToggleFavorite', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForObject(OpenEditor_0, 'OpenEditor', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForObject(CloseEditor_0, 'CloseEditor', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(CustomImageApplied_0, 'CustomImageApplied', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(UpdateElements_0, 'UpdateElements', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForObject(RemoveCustomization_0, 'RemoveCustomization', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(KindChanged_0, 'KindChanged', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(TargetAudienceChanged_0, 'TargetAudienceChanged', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(CardSelected_1, 'CardSelected', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(CardMessageChanged_1, 'CardMessageChanged', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(CardBirthdayChanged_1, 'CardBirthdayChanged', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(BoxSelected_1, 'BoxSelected', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(BoxMessageChanged_1, 'BoxMessageChanged', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(BoxBirthdayChanged_1, 'BoxBirthdayChanged', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(SizeSelected_1, 'SizeSelected', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(ColorSelected_1, 'ColorSelected', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(OptionSelected_1, 'OptionSelected', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForClass(ProductCommentChanged_1, 'ProductCommentChanged', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForObject(ShareProduct_0, 'ShareProduct', VOID, VOID, [CustomProductDetailsIntent]);
  initMetadataForInterface(CustomProductDetailsSideEffect, 'CustomProductDetailsSideEffect');
  initMetadataForClass(ShowMessage_4, 'ShowMessage', VOID, VOID, [CustomProductDetailsSideEffect]);
  initMetadataForClass(ShowToast_0, 'ShowToast', VOID, VOID, [CustomProductDetailsSideEffect]);
  initMetadataForObject(NavigateToAuth_2, 'NavigateToAuth', VOID, VOID, [CustomProductDetailsSideEffect]);
  initMetadataForObject(NavigateBack_2, 'NavigateBack', VOID, VOID, [CustomProductDetailsSideEffect]);
  initMetadataForLambda(CustomProductDetailsViewModel$observeLanguage$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$observeCurrentUser$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$observeFavorite$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$observeStockReminder$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$handleIntent$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$handleAddToCart$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$handleAddToCart$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$observeLanguage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$observeCurrentUser$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$observeFavorite$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$observeStockReminder$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$handleIntent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$handleIntent$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$handleIntent$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$handleIntent$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CustomProductDetailsViewModel$handleAddToCart$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_14, CoroutineImpl);
  initMetadataForCoroutine($handleAddToCartCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(CustomProductDetailsViewModel, 'CustomProductDetailsViewModel', VOID, BaseMviViewModel, VOID, [1, 0]);
  initMetadataForClass(ProductDetailsState, 'ProductDetailsState', ProductDetailsState);
  initMetadataForInterface(ProductDetailsIntent, 'ProductDetailsIntent');
  initMetadataForClass(LoadProduct_2, 'LoadProduct', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForObject(AddToCart_2, 'AddToCart', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForObject(ToggleStockReminder_2, 'ToggleStockReminder', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(QuantityChanged_1, 'QuantityChanged', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForObject(ToggleFavorite_3, 'ToggleFavorite', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(KindChanged_1, 'KindChanged', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(TargetAudienceChanged_1, 'TargetAudienceChanged', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(CardSelected_2, 'CardSelected', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(CardMessageChanged_2, 'CardMessageChanged', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(CardBirthdayChanged_2, 'CardBirthdayChanged', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(BoxSelected_2, 'BoxSelected', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(BoxMessageChanged_2, 'BoxMessageChanged', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(BoxBirthdayChanged_2, 'BoxBirthdayChanged', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(SizeSelected_2, 'SizeSelected', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(ColorSelected_2, 'ColorSelected', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(OptionSelected_2, 'OptionSelected', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(ProductCommentChanged_2, 'ProductCommentChanged', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForClass(BraceletNameChanged_0, 'BraceletNameChanged', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForObject(ShareProduct_1, 'ShareProduct', VOID, VOID, [ProductDetailsIntent]);
  initMetadataForInterface(ProductDetailsSideEffect, 'ProductDetailsSideEffect');
  initMetadataForClass(ShowMessage_5, 'ShowMessage', VOID, VOID, [ProductDetailsSideEffect]);
  initMetadataForClass(ShowToast_1, 'ShowToast', VOID, VOID, [ProductDetailsSideEffect]);
  initMetadataForObject(NavigateToAuth_3, 'NavigateToAuth', VOID, VOID, [ProductDetailsSideEffect]);
  initMetadataForObject(ComposableSingletons$ProductDetailsScreenKt, 'ComposableSingletons$ProductDetailsScreenKt');
  initMetadataForLambda(ProductDetailsScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_23, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(ProductDetailsScreen$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductDetailsScreen$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductDetailsScreen$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductDetailsViewModel$observeLanguage$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductDetailsViewModel$observeFavorite$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductDetailsViewModel$observeStockReminder$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductDetailsViewModel$observeLanguage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductDetailsViewModel$observeFavorite$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductDetailsViewModel$observeStockReminder$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductDetailsViewModel$handleIntent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductDetailsViewModel$handleIntent$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProductDetailsViewModel$handleIntent$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_15, CoroutineImpl);
  initMetadataForClass(ProductDetailsViewModel, 'ProductDetailsViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForObject(ComposableSingletons$FullScreen3DDialogKt, 'ComposableSingletons$FullScreen3DDialogKt');
  initMetadataForObject(ComposableSingletons$ProfileScreenKt, 'ComposableSingletons$ProfileScreenKt');
  initMetadataForLambda(ProfileScreen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProfileScreen$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProfileScreen$lambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProfileScreen$lambda$lambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProfileScreen$lambda$lambda$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProfileScreen$lambda$lambda$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProfileScreen$lambda$lambda$slambda_7, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProfileScreen$lambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProfileScreen$lambda$lambda$slambda_9, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProfileScreen$lambda$lambda$slambda_11, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProfileScreen$lambda$lambda$slambda_13, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProfileScreen$lambda$lambda$slambda_15, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProfileScreen$lambda$lambda$slambda_17, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ProfileScreen$lambda$lambda$slambda_19, CoroutineImpl, VOID, [1]);
  initMetadataForClass(StockRemindersState, 'StockRemindersState', StockRemindersState);
  initMetadataForInterface(StockRemindersIntent, 'StockRemindersIntent');
  initMetadataForObject(LoadReminders, 'LoadReminders', VOID, VOID, [StockRemindersIntent]);
  initMetadataForClass(RemoveReminder, 'RemoveReminder', VOID, VOID, [StockRemindersIntent]);
  initMetadataForObject(ComposableSingletons$StockRemindersScreenKt, 'ComposableSingletons$StockRemindersScreenKt');
  initMetadataForLambda(StockRemindersViewModel$observeLanguage$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(StockRemindersViewModel$loadReminders$slambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(StockRemindersViewModel$loadReminders$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(StockRemindersViewModel$observeLanguage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(StockRemindersViewModel$loadReminders$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($handleIntentCOROUTINE$_16, CoroutineImpl);
  initMetadataForClass(StockRemindersViewModel, 'StockRemindersViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForObject(ComposableSingletons$CustomMugScreenKt, 'ComposableSingletons$CustomMugScreenKt');
  initMetadataForClass(ShoppingState, 'ShoppingState', ShoppingState);
  initMetadataForInterface(ShoppingIntent, 'ShoppingIntent');
  initMetadataForObject(LoadProducts, 'LoadProducts', VOID, VOID, [ShoppingIntent]);
  initMetadataForClass(SearchChanged, 'SearchChanged', VOID, VOID, [ShoppingIntent]);
  initMetadataForClass(PriceFilterChanged, 'PriceFilterChanged', VOID, VOID, [ShoppingIntent]);
  initMetadataForClass(AgeFilterChanged, 'AgeFilterChanged', VOID, VOID, [ShoppingIntent]);
  initMetadataForClass(CustomFilterChanged, 'CustomFilterChanged', VOID, VOID, [ShoppingIntent]);
  initMetadataForClass(RatingFilterChanged, 'RatingFilterChanged', VOID, VOID, [ShoppingIntent]);
  initMetadataForClass(SortOrderChanged, 'SortOrderChanged', VOID, VOID, [ShoppingIntent]);
  initMetadataForObject(RefreshData, 'RefreshData', VOID, VOID, [ShoppingIntent]);
  initMetadataForClass(ToggleFavorite_4, 'ToggleFavorite', VOID, VOID, [ShoppingIntent]);
  initMetadataForObject(ToggleLanguage, 'ToggleLanguage', VOID, VOID, [ShoppingIntent]);
  initMetadataForInterface(ShoppingSideEffect, 'ShoppingSideEffect');
  initMetadataForClass(ShowError_6, 'ShowError', VOID, VOID, [ShoppingSideEffect]);
  initMetadataForClass(ProductSortOrder, 'ProductSortOrder', VOID, Enum);
  initMetadataForClass(GiftTab, 'GiftTab', VOID, Enum);
  initMetadataForObject(ComposableSingletons$ShoppingScreenKt, 'ComposableSingletons$ShoppingScreenKt');
  initMetadataForLambda(ShoppingRoot$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingRoot$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingViewModel$observeConnection$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingViewModel$observeCart$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingViewModel$observeFavorites$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingViewModel$observeLanguage$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingViewModel$observeAuthChanges$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingViewModel$loadProducts$slambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(ShoppingViewModel$loadProducts$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForLambda(ShoppingViewModel$observeConnection$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingViewModel$observeCart$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingViewModel$observeFavorites$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingViewModel$observeLanguage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingViewModel$observeAuthChanges$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingViewModel$handleIntent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingViewModel$refreshData$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ShoppingViewModel$loadProducts$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ShoppingViewModel, 'ShoppingViewModel', VOID, BaseMviViewModel, VOID, [1]);
  initMetadataForObject(ComposableSingletons$UpdateScreenKt, 'ComposableSingletons$UpdateScreenKt');
  initMetadataForClass(Governorate, 'Governorate');
  initMetadataForCompanion(Companion_38);
  initMetadataForObject($serializer_32, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LatLng, 'LatLng', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_32});
  initMetadataForInterface(NetworkObserver, 'NetworkObserver');
  function asString($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.m30(-2031656808);
    sourceInformation($composer_0, 'C(asString):UiText.kt#6xrusq');
    if (isTraceInProgress()) {
      traceEventStart(-2031656808, $changed, -1, 'client.fstech.hadaya.util.UiText.asString (UiText.kt:28)');
    }
    var tmp;
    if (this instanceof DynamicString) {
      $composer_0.m30(1787929949);
      $composer_0.n30();
      tmp = this.k14w_1;
    } else {
      if (this instanceof ResourceString) {
        $composer_0.m30(1787931223);
        sourceInformation($composer_0, '31@1080L31');
        var tmp1_group = stringResource_0(this.l14w_1, this.m14w_1.slice(), $composer_0, 0);
        $composer_0.n30();
        tmp = tmp1_group;
      } else {
        $composer_0.m30(1787928598);
        $composer_0.n30();
        noWhenBranchMatchedException();
      }
    }
    var tmp0 = tmp;
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    $composer_0.n30();
    return tmp0;
  }
  function asStringNonComposable($completion) {
    var tmp = new $asStringNonComposableCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  initMetadataForInterface(UiText, 'UiText', VOID, VOID, VOID, [0]);
  initMetadataForClass(DynamicString, 'DynamicString', VOID, VOID, [UiText], [0]);
  initMetadataForClass(ResourceString, 'ResourceString', VOID, VOID, [UiText], [0]);
  initMetadataForCoroutine($asStringNonComposableCOROUTINE$, CoroutineImpl);
  initMetadataForClass(WebAnalyticsHelper, 'WebAnalyticsHelper', WebAnalyticsHelper, VOID, [IAnalyticsHelper]);
  initMetadataForClass(LanguageSwitcher, 'LanguageSwitcher', LanguageSwitcher);
  initMetadataForClass(JsNetworkObserver, 'JsNetworkObserver', JsNetworkObserver, VOID, [NetworkObserver]);
  initMetadataForClass(JsPlatform, 'JsPlatform', JsPlatform);
  initMetadataForClass(SupabaseSessionManager, 'SupabaseSessionManager', SupabaseSessionManager, VOID, VOID, [1, 0]);
  initMetadataForClass(rememberImagePickerLauncher$1);
  initMetadataForClass(HtmlView$$inlined$Box$1$1);
  initMetadataForClass(rememberImagePickerLauncher$1_0);
  initMetadataForClass(rememberLocationPickerLauncher$1);
  //endregion
  var compose_multiplatform$delegate;
  function get_logo(_this__u8e3s4) {
    _init_properties_Drawable0_commonMain_kt__plv2f4();
    var tmp0 = logo$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('logo', 1, tmp, _get_logo_$ref_1uc64x(), null);
    return tmp0.u1();
  }
  var logo$delegate;
  function compose_multiplatform$delegate$lambda() {
    _init_properties_Drawable0_commonMain_kt__plv2f4();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new DrawableResource('drawable:compose_multiplatform', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/drawable/compose-multiplatform.xml', new Long(-1, -1), new Long(-1, -1))));
  }
  function logo$delegate$lambda() {
    _init_properties_Drawable0_commonMain_kt__plv2f4();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new DrawableResource('drawable:logo', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/drawable/logo.png', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_logo_$ref_1uc64x() {
    return constructCallableReference(function (p0) {
      return get_logo(p0);
    }, 1, 0, 561);
  }
  var properties_initialized_Drawable0_commonMain_kt_e3wo9q;
  function _init_properties_Drawable0_commonMain_kt__plv2f4() {
    if (!properties_initialized_Drawable0_commonMain_kt_e3wo9q) {
      properties_initialized_Drawable0_commonMain_kt_e3wo9q = true;
      compose_multiplatform$delegate = lazy(compose_multiplatform$delegate$lambda);
      logo$delegate = lazy(logo$delegate$lambda);
    }
  }
  function get_almarai_bold(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = almarai_bold$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('almarai_bold', 1, tmp, _get_almarai_bold_$ref_3ye23z(), null);
    return tmp0.u1();
  }
  var almarai_bold$delegate;
  function get_almarai_regular(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = almarai_regular$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('almarai_regular', 1, tmp, _get_almarai_regular_$ref_89e1k8(), null);
    return tmp0.u1();
  }
  var almarai_regular$delegate;
  function get_amiri_bold(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = amiri_bold$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('amiri_bold', 1, tmp, _get_amiri_bold_$ref_fh8som(), null);
    return tmp0.u1();
  }
  var amiri_bold$delegate;
  function get_amiri_regular(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = amiri_regular$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('amiri_regular', 1, tmp, _get_amiri_regular_$ref_2fwx0x(), null);
    return tmp0.u1();
  }
  var amiri_regular$delegate;
  function get_cairo_bold(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = cairo_bold$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('cairo_bold', 1, tmp, _get_cairo_bold_$ref_rfsh9a(), null);
    return tmp0.u1();
  }
  var cairo_bold$delegate;
  function get_cairo_regular(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = cairo_regular$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('cairo_regular', 1, tmp, _get_cairo_regular_$ref_zp6ez(), null);
    return tmp0.u1();
  }
  var cairo_regular$delegate;
  function get_ibm_plex_sans_arabic_bold(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = ibm_plex_sans_arabic_bold$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ibm_plex_sans_arabic_bold', 1, tmp, _get_ibm_plex_sans_arabic_bold_$ref_5ob7ld(), null);
    return tmp0.u1();
  }
  var ibm_plex_sans_arabic_bold$delegate;
  function get_ibm_plex_sans_arabic_regular(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = ibm_plex_sans_arabic_regular$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ibm_plex_sans_arabic_regular', 1, tmp, _get_ibm_plex_sans_arabic_regular_$ref_jpur12(), null);
    return tmp0.u1();
  }
  var ibm_plex_sans_arabic_regular$delegate;
  function get_noto_color_emoji(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = noto_color_emoji$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('noto_color_emoji', 1, tmp, _get_noto_color_emoji_$ref_ib72er(), null);
    return tmp0.u1();
  }
  var noto_color_emoji$delegate;
  function get_noto_sans_arabic_bold(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = noto_sans_arabic_bold$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('noto_sans_arabic_bold', 1, tmp, _get_noto_sans_arabic_bold_$ref_ovv3db(), null);
    return tmp0.u1();
  }
  var noto_sans_arabic_bold$delegate;
  function get_noto_sans_arabic_regular(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = noto_sans_arabic_regular$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('noto_sans_arabic_regular', 1, tmp, _get_noto_sans_arabic_regular_$ref_2ftdrs(), null);
    return tmp0.u1();
  }
  var noto_sans_arabic_regular$delegate;
  function get_readex_pro_bold(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = readex_pro_bold$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('readex_pro_bold', 1, tmp, _get_readex_pro_bold_$ref_d5w6i5(), null);
    return tmp0.u1();
  }
  var readex_pro_bold$delegate;
  function get_readex_pro_regular(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = readex_pro_regular$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('readex_pro_regular', 1, tmp, _get_readex_pro_regular_$ref_1cw6w6(), null);
    return tmp0.u1();
  }
  var readex_pro_regular$delegate;
  function get_tajawal_bold(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = tajawal_bold$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('tajawal_bold', 1, tmp, _get_tajawal_bold_$ref_t7aeuk(), null);
    return tmp0.u1();
  }
  var tajawal_bold$delegate;
  function get_tajawal_regular(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = tajawal_regular$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('tajawal_regular', 1, tmp, _get_tajawal_regular_$ref_fldnnp(), null);
    return tmp0.u1();
  }
  var tajawal_regular$delegate;
  function get_vazirmatn_bold(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = vazirmatn_bold$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('vazirmatn_bold', 1, tmp, _get_vazirmatn_bold_$ref_8yvhrw(), null);
    return tmp0.u1();
  }
  var vazirmatn_bold$delegate;
  function get_vazirmatn_regular(_this__u8e3s4) {
    _init_properties_Font0_commonMain_kt__nis4s1();
    var tmp0 = vazirmatn_regular$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('vazirmatn_regular', 1, tmp, _get_vazirmatn_regular_$ref_uaczmr(), null);
    return tmp0.u1();
  }
  var vazirmatn_regular$delegate;
  function almarai_bold$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:almarai_bold', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/almarai_bold.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_almarai_bold_$ref_3ye23z() {
    return constructCallableReference(function (p0) {
      return get_almarai_bold(p0);
    }, 1, 0, 562);
  }
  function almarai_regular$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:almarai_regular', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/almarai_regular.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_almarai_regular_$ref_89e1k8() {
    return constructCallableReference(function (p0) {
      return get_almarai_regular(p0);
    }, 1, 0, 563);
  }
  function amiri_bold$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:amiri_bold', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/amiri_bold.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_amiri_bold_$ref_fh8som() {
    return constructCallableReference(function (p0) {
      return get_amiri_bold(p0);
    }, 1, 0, 564);
  }
  function amiri_regular$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:amiri_regular', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/amiri_regular.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_amiri_regular_$ref_2fwx0x() {
    return constructCallableReference(function (p0) {
      return get_amiri_regular(p0);
    }, 1, 0, 565);
  }
  function cairo_bold$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:cairo_bold', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/cairo_bold.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_cairo_bold_$ref_rfsh9a() {
    return constructCallableReference(function (p0) {
      return get_cairo_bold(p0);
    }, 1, 0, 566);
  }
  function cairo_regular$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:cairo_regular', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/cairo_regular.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_cairo_regular_$ref_zp6ez() {
    return constructCallableReference(function (p0) {
      return get_cairo_regular(p0);
    }, 1, 0, 567);
  }
  function ibm_plex_sans_arabic_bold$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:ibm_plex_sans_arabic_bold', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/ibm_plex_sans_arabic_bold.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_ibm_plex_sans_arabic_bold_$ref_5ob7ld() {
    return constructCallableReference(function (p0) {
      return get_ibm_plex_sans_arabic_bold(p0);
    }, 1, 0, 568);
  }
  function ibm_plex_sans_arabic_regular$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:ibm_plex_sans_arabic_regular', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/ibm_plex_sans_arabic_regular.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_ibm_plex_sans_arabic_regular_$ref_jpur12() {
    return constructCallableReference(function (p0) {
      return get_ibm_plex_sans_arabic_regular(p0);
    }, 1, 0, 569);
  }
  function noto_color_emoji$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:noto_color_emoji', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/noto_color_emoji.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_noto_color_emoji_$ref_ib72er() {
    return constructCallableReference(function (p0) {
      return get_noto_color_emoji(p0);
    }, 1, 0, 570);
  }
  function noto_sans_arabic_bold$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:noto_sans_arabic_bold', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/noto_sans_arabic_bold.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_noto_sans_arabic_bold_$ref_ovv3db() {
    return constructCallableReference(function (p0) {
      return get_noto_sans_arabic_bold(p0);
    }, 1, 0, 571);
  }
  function noto_sans_arabic_regular$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:noto_sans_arabic_regular', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/noto_sans_arabic_regular.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_noto_sans_arabic_regular_$ref_2ftdrs() {
    return constructCallableReference(function (p0) {
      return get_noto_sans_arabic_regular(p0);
    }, 1, 0, 572);
  }
  function readex_pro_bold$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:readex_pro_bold', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/readex_pro_bold.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_readex_pro_bold_$ref_d5w6i5() {
    return constructCallableReference(function (p0) {
      return get_readex_pro_bold(p0);
    }, 1, 0, 573);
  }
  function readex_pro_regular$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:readex_pro_regular', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/readex_pro_regular.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_readex_pro_regular_$ref_1cw6w6() {
    return constructCallableReference(function (p0) {
      return get_readex_pro_regular(p0);
    }, 1, 0, 574);
  }
  function tajawal_bold$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:tajawal_bold', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/tajawal_bold.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_tajawal_bold_$ref_t7aeuk() {
    return constructCallableReference(function (p0) {
      return get_tajawal_bold(p0);
    }, 1, 0, 575);
  }
  function tajawal_regular$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:tajawal_regular', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/tajawal_regular.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_tajawal_regular_$ref_fldnnp() {
    return constructCallableReference(function (p0) {
      return get_tajawal_regular(p0);
    }, 1, 0, 576);
  }
  function vazirmatn_bold$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:vazirmatn_bold', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/vazirmatn_bold.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_vazirmatn_bold_$ref_8yvhrw() {
    return constructCallableReference(function (p0) {
      return get_vazirmatn_bold(p0);
    }, 1, 0, 577);
  }
  function vazirmatn_regular$delegate$lambda() {
    _init_properties_Font0_commonMain_kt__nis4s1();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new FontResource('font:vazirmatn_regular', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/font/vazirmatn_regular.ttf', new Long(-1, -1), new Long(-1, -1))));
  }
  function _get_vazirmatn_regular_$ref_uaczmr() {
    return constructCallableReference(function (p0) {
      return get_vazirmatn_regular(p0);
    }, 1, 0, 578);
  }
  var properties_initialized_Font0_commonMain_kt_5t7hjh;
  function _init_properties_Font0_commonMain_kt__nis4s1() {
    if (!properties_initialized_Font0_commonMain_kt_5t7hjh) {
      properties_initialized_Font0_commonMain_kt_5t7hjh = true;
      almarai_bold$delegate = lazy(almarai_bold$delegate$lambda);
      almarai_regular$delegate = lazy(almarai_regular$delegate$lambda);
      amiri_bold$delegate = lazy(amiri_bold$delegate$lambda);
      amiri_regular$delegate = lazy(amiri_regular$delegate$lambda);
      cairo_bold$delegate = lazy(cairo_bold$delegate$lambda);
      cairo_regular$delegate = lazy(cairo_regular$delegate$lambda);
      ibm_plex_sans_arabic_bold$delegate = lazy(ibm_plex_sans_arabic_bold$delegate$lambda);
      ibm_plex_sans_arabic_regular$delegate = lazy(ibm_plex_sans_arabic_regular$delegate$lambda);
      noto_color_emoji$delegate = lazy(noto_color_emoji$delegate$lambda);
      noto_sans_arabic_bold$delegate = lazy(noto_sans_arabic_bold$delegate$lambda);
      noto_sans_arabic_regular$delegate = lazy(noto_sans_arabic_regular$delegate$lambda);
      readex_pro_bold$delegate = lazy(readex_pro_bold$delegate$lambda);
      readex_pro_regular$delegate = lazy(readex_pro_regular$delegate$lambda);
      tajawal_bold$delegate = lazy(tajawal_bold$delegate$lambda);
      tajawal_regular$delegate = lazy(tajawal_regular$delegate$lambda);
      vazirmatn_bold$delegate = lazy(vazirmatn_bold$delegate$lambda);
      vazirmatn_regular$delegate = lazy(vazirmatn_regular$delegate$lambda);
    }
  }
  var _3d_model_viewer_custom$delegate;
  var _3d_model_viewer_name$delegate;
  function get__3d_preview(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = _3d_preview$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('_3d_preview', 1, tmp, _get__3d_preview_$ref_v21wyh(), null);
    return tmp0.u1();
  }
  var _3d_preview$delegate;
  var accept_privacy_policy$delegate;
  function get_accept_privacy_policy_prefix(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = accept_privacy_policy_prefix$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('accept_privacy_policy_prefix', 1, tmp, _get_accept_privacy_policy_prefix_$ref_fwwfwp(), null);
    return tmp0.u1();
  }
  var accept_privacy_policy_prefix$delegate;
  function get_add(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = add$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('add', 1, tmp, _get_add_$ref_e6fo5b(), null);
    return tmp0.u1();
  }
  var add$delegate;
  function get_add_comment_optional_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = add_comment_optional_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('add_comment_optional_label', 1, tmp, _get_add_comment_optional_label_$ref_tu9ohz(), null);
    return tmp0.u1();
  }
  var add_comment_optional_label$delegate;
  function get_add_custom_mug_to_cart(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = add_custom_mug_to_cart$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('add_custom_mug_to_cart', 1, tmp, _get_add_custom_mug_to_cart_$ref_5dchae(), null);
    return tmp0.u1();
  }
  var add_custom_mug_to_cart$delegate;
  function get_add_custom_text(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = add_custom_text$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('add_custom_text', 1, tmp, _get_add_custom_text_$ref_rcgrgd(), null);
    return tmp0.u1();
  }
  var add_custom_text$delegate;
  function get_add_friend_desc(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = add_friend_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('add_friend_desc', 1, tmp, _get_add_friend_desc_$ref_j7zu9g(), null);
    return tmp0.u1();
  }
  var add_friend_desc$delegate;
  var add_gift_message_header$delegate;
  function get_add_image(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = add_image$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('add_image', 1, tmp, _get_add_image_$ref_f10n6l(), null);
    return tmp0.u1();
  }
  var add_image$delegate;
  var add_image_desc$delegate;
  var add_image_title$delegate;
  var add_new$delegate;
  function get_add_new_friend_title(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = add_new_friend_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('add_new_friend_title', 1, tmp, _get_add_new_friend_title_$ref_ichs2i(), null);
    return tmp0.u1();
  }
  var add_new_friend_title$delegate;
  function get_add_product_comment_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = add_product_comment_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('add_product_comment_label', 1, tmp, _get_add_product_comment_label_$ref_ijatwa(), null);
    return tmp0.u1();
  }
  var add_product_comment_label$delegate;
  function get_add_text_title(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = add_text_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('add_text_title', 1, tmp, _get_add_text_title_$ref_ksbc2e(), null);
    return tmp0.u1();
  }
  var add_text_title$delegate;
  function get_add_to_cart(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = add_to_cart$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('add_to_cart', 1, tmp, _get_add_to_cart_$ref_t4gd1i(), null);
    return tmp0.u1();
  }
  var add_to_cart$delegate;
  var add_to_favorites$delegate;
  function get_added_to_cart(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = added_to_cart$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('added_to_cart', 1, tmp, _get_added_to_cart_$ref_qbhfph(), null);
    return tmp0.u1();
  }
  var added_to_cart$delegate;
  function get_adding_to_cart_dialog_msg(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = adding_to_cart_dialog_msg$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('adding_to_cart_dialog_msg', 1, tmp, _get_adding_to_cart_dialog_msg_$ref_2zfed9(), null);
    return tmp0.u1();
  }
  var adding_to_cart_dialog_msg$delegate;
  function get_adding_to_cart_dialog_msg_custom(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = adding_to_cart_dialog_msg_custom$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('adding_to_cart_dialog_msg_custom', 1, tmp, _get_adding_to_cart_dialog_msg_custom_$ref_s9ks3x(), null);
    return tmp0.u1();
  }
  var adding_to_cart_dialog_msg_custom$delegate;
  function get_adding_to_cart_dialog_title(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = adding_to_cart_dialog_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('adding_to_cart_dialog_title', 1, tmp, _get_adding_to_cart_dialog_title_$ref_ww3xl2(), null);
    return tmp0.u1();
  }
  var adding_to_cart_dialog_title$delegate;
  function get_address_label_required(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = address_label_required$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('address_label_required', 1, tmp, _get_address_label_required_$ref_oto7s5(), null);
    return tmp0.u1();
  }
  var address_label_required$delegate;
  function get_age_group_for_prefix(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = age_group_for_prefix$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('age_group_for_prefix', 1, tmp, _get_age_group_for_prefix_$ref_7zdbea(), null);
    return tmp0.u1();
  }
  var age_group_for_prefix$delegate;
  function get_age_group_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = age_group_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('age_group_label', 1, tmp, _get_age_group_label_$ref_h52pro(), null);
    return tmp0.u1();
  }
  var age_group_label$delegate;
  function get_all_coupons_tab(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = all_coupons_tab$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('all_coupons_tab', 1, tmp, _get_all_coupons_tab_$ref_bqqd5x(), null);
    return tmp0.u1();
  }
  var all_coupons_tab$delegate;
  function get_all_gifts(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = all_gifts$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('all_gifts', 1, tmp, _get_all_gifts_$ref_4o06nv(), null);
    return tmp0.u1();
  }
  var all_gifts$delegate;
  function get_already_have_account_hint(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = already_have_account_hint$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('already_have_account_hint', 1, tmp, _get_already_have_account_hint_$ref_e8pe15(), null);
    return tmp0.u1();
  }
  var already_have_account_hint$delegate;
  function get_app_name(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = app_name$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('app_name', 1, tmp, _get_app_name_$ref_hjq233(), null);
    return tmp0.u1();
  }
  var app_name$delegate;
  function get_apple_pay_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = apple_pay_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('apple_pay_label', 1, tmp, _get_apple_pay_label_$ref_r1bfqw(), null);
    return tmp0.u1();
  }
  var apple_pay_label$delegate;
  function get_apply_btn(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = apply_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('apply_btn', 1, tmp, _get_apply_btn_$ref_ecdnkl(), null);
    return tmp0.u1();
  }
  var apply_btn$delegate;
  var apply_changes_desc$delegate;
  var apply_changes_title$delegate;
  function get_apply_coupon_btn(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = apply_coupon_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('apply_coupon_btn', 1, tmp, _get_apply_coupon_btn_$ref_ho3b7q(), null);
    return tmp0.u1();
  }
  var apply_coupon_btn$delegate;
  var apply_filters_btn$delegate;
  var available_coupons_header$delegate;
  function get_available_coupons_tab(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = available_coupons_tab$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('available_coupons_tab', 1, tmp, _get_available_coupons_tab_$ref_kgqrn7(), null);
    return tmp0.u1();
  }
  var available_coupons_tab$delegate;
  function get_back(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = back$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('back', 1, tmp, _get_back_$ref_ozi3m5(), null);
    return tmp0.u1();
  }
  var back$delegate;
  var back_to_3d_preview$delegate;
  function get_back_to_home_btn(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = back_to_home_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('back_to_home_btn', 1, tmp, _get_back_to_home_btn_$ref_1xv5n6(), null);
    return tmp0.u1();
  }
  var back_to_home_btn$delegate;
  function get_base_color(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = base_color$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('base_color', 1, tmp, _get_base_color_$ref_zcnhr9(), null);
    return tmp0.u1();
  }
  var base_color$delegate;
  function get_birthday_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = birthday_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('birthday_label', 1, tmp, _get_birthday_label_$ref_z2ezg8(), null);
    return tmp0.u1();
  }
  var birthday_label$delegate;
  function get_birthday_prefix_pattern(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = birthday_prefix_pattern$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('birthday_prefix_pattern', 1, tmp, _get_birthday_prefix_pattern_$ref_bsk7uj(), null);
    return tmp0.u1();
  }
  var birthday_prefix_pattern$delegate;
  function get_birthday_yyyy_mm_dd_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = birthday_yyyy_mm_dd_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('birthday_yyyy_mm_dd_label', 1, tmp, _get_birthday_yyyy_mm_dd_label_$ref_om39cn(), null);
    return tmp0.u1();
  }
  var birthday_yyyy_mm_dd_label$delegate;
  function get_box_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = box_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('box_label', 1, tmp, _get_box_label_$ref_xjjlts(), null);
    return tmp0.u1();
  }
  var box_label$delegate;
  function get_bracelet_name_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = bracelet_name_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('bracelet_name_label', 1, tmp, _get_bracelet_name_label_$ref_fnvwcp(), null);
    return tmp0.u1();
  }
  var bracelet_name_label$delegate;
  var bracelet_name_placeholder$delegate;
  function get_building_no_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = building_no_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('building_no_label', 1, tmp, _get_building_no_label_$ref_2j2am7(), null);
    return tmp0.u1();
  }
  var building_no_label$delegate;
  function get_bulk_discount_info(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = bulk_discount_info$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('bulk_discount_info', 1, tmp, _get_bulk_discount_info_$ref_pgmvvf(), null);
    return tmp0.u1();
  }
  var bulk_discount_info$delegate;
  function get_cancel(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = cancel$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('cancel', 1, tmp, _get_cancel_$ref_dashfk(), null);
    return tmp0.u1();
  }
  var cancel$delegate;
  function get_card_birthday_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = card_birthday_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('card_birthday_label', 1, tmp, _get_card_birthday_label_$ref_l03cpt(), null);
    return tmp0.u1();
  }
  var card_birthday_label$delegate;
  function get_card_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = card_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('card_label', 1, tmp, _get_card_label_$ref_ee4t91(), null);
    return tmp0.u1();
  }
  var card_label$delegate;
  function get_card_message_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = card_message_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('card_message_label', 1, tmp, _get_card_message_label_$ref_bjb619(), null);
    return tmp0.u1();
  }
  var card_message_label$delegate;
  function get_cart_empty_desc(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = cart_empty_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('cart_empty_desc', 1, tmp, _get_cart_empty_desc_$ref_4hwmbm(), null);
    return tmp0.u1();
  }
  var cart_empty_desc$delegate;
  function get_cart_empty_title(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = cart_empty_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('cart_empty_title', 1, tmp, _get_cart_empty_title_$ref_atkqqb(), null);
    return tmp0.u1();
  }
  var cart_empty_title$delegate;
  function get_cart_offline_mode(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = cart_offline_mode$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('cart_offline_mode', 1, tmp, _get_cart_offline_mode_$ref_pud96m(), null);
    return tmp0.u1();
  }
  var cart_offline_mode$delegate;
  function get_cart_title(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = cart_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('cart_title', 1, tmp, _get_cart_title_$ref_oj37j3(), null);
    return tmp0.u1();
  }
  var cart_title$delegate;
  function get_cart_total_amount(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = cart_total_amount$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('cart_total_amount', 1, tmp, _get_cart_total_amount_$ref_ym1h8u(), null);
    return tmp0.u1();
  }
  var cart_total_amount$delegate;
  function get_cash_on_delivery_deposit_msg(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = cash_on_delivery_deposit_msg$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('cash_on_delivery_deposit_msg', 1, tmp, _get_cash_on_delivery_deposit_msg_$ref_d6fyj3(), null);
    return tmp0.u1();
  }
  var cash_on_delivery_deposit_msg$delegate;
  function get_cash_on_delivery_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = cash_on_delivery_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('cash_on_delivery_label', 1, tmp, _get_cash_on_delivery_label_$ref_d59659(), null);
    return tmp0.u1();
  }
  var cash_on_delivery_label$delegate;
  function get_category_general_gifts(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = category_general_gifts$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('category_general_gifts', 1, tmp, _get_category_general_gifts_$ref_tai8q7(), null);
    return tmp0.u1();
  }
  var category_general_gifts$delegate;
  var category_girls_gifts$delegate;
  var category_mens_gifts$delegate;
  var center_setting$delegate;
  function get_change_avatar_desc(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = change_avatar_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('change_avatar_desc', 1, tmp, _get_change_avatar_desc_$ref_4ir8eq(), null);
    return tmp0.u1();
  }
  var change_avatar_desc$delegate;
  function get_change_language_btn_pattern(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = change_language_btn_pattern$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('change_language_btn_pattern', 1, tmp, _get_change_language_btn_pattern_$ref_jnh6c5(), null);
    return tmp0.u1();
  }
  var change_language_btn_pattern$delegate;
  var change_language_desc$delegate;
  function get_change_password_btn(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = change_password_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('change_password_btn', 1, tmp, _get_change_password_btn_$ref_vp7ssn(), null);
    return tmp0.u1();
  }
  var change_password_btn$delegate;
  function get_change_pic_desc(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = change_pic_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('change_pic_desc', 1, tmp, _get_change_pic_desc_$ref_dap03v(), null);
    return tmp0.u1();
  }
  var change_pic_desc$delegate;
  var change_text_pattern$delegate;
  function get_checkout_no_internet(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = checkout_no_internet$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('checkout_no_internet', 1, tmp, _get_checkout_no_internet_$ref_tyncp8(), null);
    return tmp0.u1();
  }
  var checkout_no_internet$delegate;
  function get_checkout_required_fields_error(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = checkout_required_fields_error$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('checkout_required_fields_error', 1, tmp, _get_checkout_required_fields_error_$ref_xtizsh(), null);
    return tmp0.u1();
  }
  var checkout_required_fields_error$delegate;
  function get_checkout_select_friend_error(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = checkout_select_friend_error$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('checkout_select_friend_error', 1, tmp, _get_checkout_select_friend_error_$ref_ezq27r(), null);
    return tmp0.u1();
  }
  var checkout_select_friend_error$delegate;
  function get_checkout_title(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = checkout_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('checkout_title', 1, tmp, _get_checkout_title_$ref_ms8kzp(), null);
    return tmp0.u1();
  }
  var checkout_title$delegate;
  var choose_wrapping_style_header$delegate;
  function get_city_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = city_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('city_label', 1, tmp, _get_city_label_$ref_hdazae(), null);
    return tmp0.u1();
  }
  var city_label$delegate;
  var classic_red$delegate;
  function get_clear_all(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = clear_all$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('clear_all', 1, tmp, _get_clear_all_$ref_h31k7j(), null);
    return tmp0.u1();
  }
  var clear_all$delegate;
  function get_close(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = close$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('close', 1, tmp, _get_close_$ref_erjia0(), null);
    return tmp0.u1();
  }
  var close$delegate;
  var code_copied$delegate;
  var color_blue$delegate;
  var color_green$delegate;
  function get_color_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = color_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('color_label', 1, tmp, _get_color_label_$ref_jhgxzs(), null);
    return tmp0.u1();
  }
  var color_label$delegate;
  var color_red$delegate;
  function get_color_setting(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = color_setting$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('color_setting', 1, tmp, _get_color_setting_$ref_63d4fo(), null);
    return tmp0.u1();
  }
  var color_setting$delegate;
  function get_comment_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = comment_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('comment_label', 1, tmp, _get_comment_label_$ref_bs0w2c(), null);
    return tmp0.u1();
  }
  var comment_label$delegate;
  function get_confirm_password_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = confirm_password_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('confirm_password_label', 1, tmp, _get_confirm_password_label_$ref_klaq0b(), null);
    return tmp0.u1();
  }
  var confirm_password_label$delegate;
  function get_confirm_pay_btn(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = confirm_pay_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('confirm_pay_btn', 1, tmp, _get_confirm_pay_btn_$ref_9lrvju(), null);
    return tmp0.u1();
  }
  var confirm_pay_btn$delegate;
  function get_confirm_place_order_btn(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = confirm_place_order_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('confirm_place_order_btn', 1, tmp, _get_confirm_place_order_btn_$ref_emil70(), null);
    return tmp0.u1();
  }
  var confirm_place_order_btn$delegate;
  function get_connect_internet_to_add_cart(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = connect_internet_to_add_cart$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('connect_internet_to_add_cart', 1, tmp, _get_connect_internet_to_add_cart_$ref_knilun(), null);
    return tmp0.u1();
  }
  var connect_internet_to_add_cart$delegate;
  function get_contact_support_whatsapp_btn(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = contact_support_whatsapp_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('contact_support_whatsapp_btn', 1, tmp, _get_contact_support_whatsapp_btn_$ref_71of18(), null);
    return tmp0.u1();
  }
  var contact_support_whatsapp_btn$delegate;
  function get_contact_us(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = contact_us$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('contact_us', 1, tmp, _get_contact_us_$ref_1oaigt(), null);
    return tmp0.u1();
  }
  var contact_us$delegate;
  function get_contact_us_whatsapp(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = contact_us_whatsapp$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('contact_us_whatsapp', 1, tmp, _get_contact_us_whatsapp_$ref_3cgfsk(), null);
    return tmp0.u1();
  }
  var contact_us_whatsapp$delegate;
  function get_content_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = content_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('content_label', 1, tmp, _get_content_label_$ref_c8oy8i(), null);
    return tmp0.u1();
  }
  var content_label$delegate;
  function get_copy_code(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = copy_code$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('copy_code', 1, tmp, _get_copy_code_$ref_s92nd(), null);
    return tmp0.u1();
  }
  var copy_code$delegate;
  function get_country_label(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = country_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('country_label', 1, tmp, _get_country_label_$ref_ojrx91(), null);
    return tmp0.u1();
  }
  var country_label$delegate;
  function get_coupon_already_used_error(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = coupon_already_used_error$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('coupon_already_used_error', 1, tmp, _get_coupon_already_used_error_$ref_bx9jly(), null);
    return tmp0.u1();
  }
  var coupon_already_used_error$delegate;
  function get_coupon_applied_success(_this__u8e3s4) {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp0 = coupon_applied_success$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('coupon_applied_success', 1, tmp, _get_coupon_applied_success_$ref_i42g5u(), null);
    return tmp0.u1();
  }
  var coupon_applied_success$delegate;
  function _3d_model_viewer_custom$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(85, 0), new Long(155, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:_3d_model_viewer_custom', '_3d_model_viewer_custom', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(45, 0), new Long(95, 0))]));
  }
  function _3d_model_viewer_name$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(241, 0), new Long(93, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:_3d_model_viewer_name', '_3d_model_viewer_name', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(141, 0), new Long(57, 0))]));
  }
  function _3d_preview$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10, 0), new Long(74, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:_3d_preview', '_3d_preview', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10, 0), new Long(34, 0))]));
  }
  function _get__3d_preview_$ref_v21wyh() {
    return constructCallableReference(function (p0) {
      return get__3d_preview(p0);
    }, 1, 0, 579);
  }
  function accept_privacy_policy$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(396, 0), new Long(89, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:accept_privacy_policy', 'accept_privacy_policy', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(248, 0), new Long(65, 0))]));
  }
  function accept_privacy_policy_prefix$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(335, 0), new Long(60, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:accept_privacy_policy_prefix', 'accept_privacy_policy_prefix', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(199, 0), new Long(48, 0))]));
  }
  function _get_accept_privacy_policy_prefix_$ref_fwwfwp() {
    return constructCallableReference(function (p0) {
      return get_accept_privacy_policy_prefix(p0);
    }, 1, 0, 580);
  }
  function add$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1832, 0), new Long(27, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add', 'add', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1296, 0), new Long(15, 0))]));
  }
  function _get_add_$ref_e6fo5b() {
    return constructCallableReference(function (p0) {
      return get_add(p0);
    }, 1, 0, 581);
  }
  function add_comment_optional_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(486, 0), new Long(86, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_comment_optional_label', 'add_comment_optional_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(314, 0), new Long(66, 0))]));
  }
  function _get_add_comment_optional_label_$ref_tu9ohz() {
    return constructCallableReference(function (p0) {
      return get_add_comment_optional_label(p0);
    }, 1, 0, 582);
  }
  function add_custom_mug_to_cart$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(573, 0), new Long(86, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_custom_mug_to_cart', 'add_custom_mug_to_cart', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(381, 0), new Long(62, 0))]));
  }
  function _get_add_custom_mug_to_cart_$ref_5dchae() {
    return constructCallableReference(function (p0) {
      return get_add_custom_mug_to_cart(p0);
    }, 1, 0, 583);
  }
  function add_custom_text$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(660, 0), new Long(55, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_custom_text', 'add_custom_text', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(444, 0), new Long(43, 0))]));
  }
  function _get_add_custom_text_$ref_rcgrgd() {
    return constructCallableReference(function (p0) {
      return get_add_custom_text(p0);
    }, 1, 0, 584);
  }
  function add_friend_desc$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(716, 0), new Long(51, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_friend_desc', 'add_friend_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(488, 0), new Long(39, 0))]));
  }
  function _get_add_friend_desc_$ref_j7zu9g() {
    return constructCallableReference(function (p0) {
      return get_add_friend_desc(p0);
    }, 1, 0, 585);
  }
  function add_gift_message_header$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(768, 0), new Long(75, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_gift_message_header', 'add_gift_message_header', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(528, 0), new Long(55, 0))]));
  }
  function add_image$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(963, 0), new Long(45, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_image', 'add_image', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(687, 0), new Long(29, 0))]));
  }
  function _get_add_image_$ref_f10n6l() {
    return constructCallableReference(function (p0) {
      return get_add_image(p0);
    }, 1, 0, 586);
  }
  function add_image_desc$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(844, 0), new Long(66, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_image_desc', 'add_image_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(584, 0), new Long(66, 0))]));
  }
  function add_image_title$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(911, 0), new Long(51, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_image_title', 'add_image_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(651, 0), new Long(35, 0))]));
  }
  function add_new$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1078, 0), new Long(43, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_new', 'add_new', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(766, 0), new Long(27, 0))]));
  }
  function add_new_friend_title$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1009, 0), new Long(68, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_new_friend_title', 'add_new_friend_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(717, 0), new Long(48, 0))]));
  }
  function _get_add_new_friend_title_$ref_ichs2i() {
    return constructCallableReference(function (p0) {
      return get_add_new_friend_title(p0);
    }, 1, 0, 587);
  }
  function add_product_comment_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1122, 0), new Long(93, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_product_comment_label', 'add_product_comment_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(794, 0), new Long(73, 0))]));
  }
  function _get_add_product_comment_label_$ref_ijatwa() {
    return constructCallableReference(function (p0) {
      return get_add_product_comment_label(p0);
    }, 1, 0, 588);
  }
  function add_text_title$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1216, 0), new Long(42, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_text_title', 'add_text_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(868, 0), new Long(34, 0))]));
  }
  function _get_add_text_title_$ref_ksbc2e() {
    return constructCallableReference(function (p0) {
      return get_add_text_title(p0);
    }, 1, 0, 589);
  }
  function add_to_cart$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1259, 0), new Long(59, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_to_cart', 'add_to_cart', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(903, 0), new Long(35, 0))]));
  }
  function _get_add_to_cart_$ref_t4gd1i() {
    return constructCallableReference(function (p0) {
      return get_add_to_cart(p0);
    }, 1, 0, 590);
  }
  function add_to_favorites$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1319, 0), new Long(68, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:add_to_favorites', 'add_to_favorites', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(939, 0), new Long(48, 0))]));
  }
  function added_to_cart$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1388, 0), new Long(77, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:added_to_cart', 'added_to_cart', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(988, 0), new Long(41, 0))]));
  }
  function _get_added_to_cart_$ref_qbhfph() {
    return constructCallableReference(function (p0) {
      return get_added_to_cart(p0);
    }, 1, 0, 591);
  }
  function adding_to_cart_dialog_msg$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1607, 0), new Long(73, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:adding_to_cart_dialog_msg', 'adding_to_cart_dialog_msg', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1139, 0), new Long(53, 0))]));
  }
  function _get_adding_to_cart_dialog_msg_$ref_2zfed9() {
    return constructCallableReference(function (p0) {
      return get_adding_to_cart_dialog_msg(p0);
    }, 1, 0, 592);
  }
  function adding_to_cart_dialog_msg_custom$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1466, 0), new Long(140, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:adding_to_cart_dialog_msg_custom', 'adding_to_cart_dialog_msg_custom', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1030, 0), new Long(108, 0))]));
  }
  function _get_adding_to_cart_dialog_msg_custom_$ref_s9ks3x() {
    return constructCallableReference(function (p0) {
      return get_adding_to_cart_dialog_msg_custom(p0);
    }, 1, 0, 593);
  }
  function adding_to_cart_dialog_title$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1681, 0), new Long(95, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:adding_to_cart_dialog_title', 'adding_to_cart_dialog_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1193, 0), new Long(59, 0))]));
  }
  function _get_adding_to_cart_dialog_title_$ref_ww3xl2() {
    return constructCallableReference(function (p0) {
      return get_adding_to_cart_dialog_title(p0);
    }, 1, 0, 594);
  }
  function address_label_required$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1777, 0), new Long(54, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:address_label_required', 'address_label_required', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1253, 0), new Long(42, 0))]));
  }
  function _get_address_label_required_$ref_oto7s5() {
    return constructCallableReference(function (p0) {
      return get_address_label_required(p0);
    }, 1, 0, 595);
  }
  function age_group_for_prefix$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1860, 0), new Long(76, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:age_group_for_prefix', 'age_group_for_prefix', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1312, 0), new Long(56, 0))]));
  }
  function _get_age_group_for_prefix_$ref_7zdbea() {
    return constructCallableReference(function (p0) {
      return get_age_group_for_prefix(p0);
    }, 1, 0, 596);
  }
  function age_group_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1937, 0), new Long(59, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:age_group_label', 'age_group_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1369, 0), new Long(35, 0))]));
  }
  function _get_age_group_label_$ref_h52pro() {
    return constructCallableReference(function (p0) {
      return get_age_group_label(p0);
    }, 1, 0, 597);
  }
  function all_coupons_tab$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(1997, 0), new Long(35, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:all_coupons_tab', 'all_coupons_tab', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1405, 0), new Long(27, 0))]));
  }
  function _get_all_coupons_tab_$ref_bqqd5x() {
    return constructCallableReference(function (p0) {
      return get_all_coupons_tab(p0);
    }, 1, 0, 598);
  }
  function all_gifts$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2033, 0), new Long(45, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:all_gifts', 'all_gifts', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1433, 0), new Long(29, 0))]));
  }
  function _get_all_gifts_$ref_4o06nv() {
    return constructCallableReference(function (p0) {
      return get_all_gifts(p0);
    }, 1, 0, 599);
  }
  function already_have_account_hint$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2079, 0), new Long(77, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:already_have_account_hint', 'already_have_account_hint', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1463, 0), new Long(69, 0))]));
  }
  function _get_already_have_account_hint_$ref_e8pe15() {
    return constructCallableReference(function (p0) {
      return get_already_have_account_hint(p0);
    }, 1, 0, 600);
  }
  function app_name$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2157, 0), new Long(32, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:app_name', 'app_name', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1533, 0), new Long(24, 0))]));
  }
  function _get_app_name_$ref_hjq233() {
    return constructCallableReference(function (p0) {
      return get_app_name(p0);
    }, 1, 0, 601);
  }
  function apple_pay_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2190, 0), new Long(43, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:apple_pay_label', 'apple_pay_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1558, 0), new Long(35, 0))]));
  }
  function _get_apple_pay_label_$ref_r1bfqw() {
    return constructCallableReference(function (p0) {
      return get_apple_pay_label(p0);
    }, 1, 0, 602);
  }
  function apply_btn$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2234, 0), new Long(33, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:apply_btn', 'apply_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1594, 0), new Long(25, 0))]));
  }
  function _get_apply_btn_$ref_ecdnkl() {
    return constructCallableReference(function (p0) {
      return get_apply_btn(p0);
    }, 1, 0, 603);
  }
  function apply_changes_desc$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2268, 0), new Long(158, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:apply_changes_desc', 'apply_changes_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1620, 0), new Long(106, 0))]));
  }
  function apply_changes_title$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2427, 0), new Long(71, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:apply_changes_title', 'apply_changes_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1727, 0), new Long(47, 0))]));
  }
  function apply_coupon_btn$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2499, 0), new Long(40, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:apply_coupon_btn', 'apply_coupon_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1775, 0), new Long(32, 0))]));
  }
  function _get_apply_coupon_btn_$ref_ho3b7q() {
    return constructCallableReference(function (p0) {
      return get_apply_coupon_btn(p0);
    }, 1, 0, 604);
  }
  function apply_filters_btn$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2540, 0), new Long(61, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:apply_filters_btn', 'apply_filters_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1808, 0), new Long(45, 0))]));
  }
  function available_coupons_header$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2602, 0), new Long(76, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:available_coupons_header', 'available_coupons_header', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1854, 0), new Long(56, 0))]));
  }
  function available_coupons_tab$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2679, 0), new Long(49, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:available_coupons_tab', 'available_coupons_tab', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1911, 0), new Long(41, 0))]));
  }
  function _get_available_coupons_tab_$ref_kgqrn7() {
    return constructCallableReference(function (p0) {
      return get_available_coupons_tab(p0);
    }, 1, 0, 605);
  }
  function back$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2897, 0), new Long(24, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:back', 'back', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2045, 0), new Long(20, 0))]));
  }
  function _get_back_$ref_ozi3m5() {
    return constructCallableReference(function (p0) {
      return get_back(p0);
    }, 1, 0, 606);
  }
  function back_to_3d_preview$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2729, 0), new Long(102, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:back_to_3d_preview', 'back_to_3d_preview', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(1953, 0), new Long(50, 0))]));
  }
  function back_to_home_btn$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2832, 0), new Long(64, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:back_to_home_btn', 'back_to_home_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2004, 0), new Long(40, 0))]));
  }
  function _get_back_to_home_btn_$ref_1xv5n6() {
    return constructCallableReference(function (p0) {
      return get_back_to_home_btn(p0);
    }, 1, 0, 607);
  }
  function base_color$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2922, 0), new Long(54, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:base_color', 'base_color', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2066, 0), new Long(34, 0))]));
  }
  function _get_base_color_$ref_zcnhr9() {
    return constructCallableReference(function (p0) {
      return get_base_color(p0);
    }, 1, 0, 608);
  }
  function birthday_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(2977, 0), new Long(58, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:birthday_label', 'birthday_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2101, 0), new Long(34, 0))]));
  }
  function _get_birthday_label_$ref_z2ezg8() {
    return constructCallableReference(function (p0) {
      return get_birthday_label(p0);
    }, 1, 0, 609);
  }
  function birthday_prefix_pattern$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3036, 0), new Long(75, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:birthday_prefix_pattern', 'birthday_prefix_pattern', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2136, 0), new Long(51, 0))]));
  }
  function _get_birthday_prefix_pattern_$ref_bsk7uj() {
    return constructCallableReference(function (p0) {
      return get_birthday_prefix_pattern(p0);
    }, 1, 0, 610);
  }
  function birthday_yyyy_mm_dd_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3112, 0), new Long(85, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:birthday_yyyy_mm_dd_label', 'birthday_yyyy_mm_dd_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2188, 0), new Long(61, 0))]));
  }
  function _get_birthday_yyyy_mm_dd_label_$ref_om39cn() {
    return constructCallableReference(function (p0) {
      return get_birthday_yyyy_mm_dd_label(p0);
    }, 1, 0, 611);
  }
  function box_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3198, 0), new Long(37, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:box_label', 'box_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2250, 0), new Long(21, 0))]));
  }
  function _get_box_label_$ref_xjjlts() {
    return constructCallableReference(function (p0) {
      return get_box_label(p0);
    }, 1, 0, 612);
  }
  function bracelet_name_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3236, 0), new Long(71, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:bracelet_name_label', 'bracelet_name_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2272, 0), new Long(47, 0))]));
  }
  function _get_bracelet_name_label_$ref_fnvwcp() {
    return constructCallableReference(function (p0) {
      return get_bracelet_name_label(p0);
    }, 1, 0, 613);
  }
  function bracelet_name_placeholder$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3308, 0), new Long(69, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:bracelet_name_placeholder', 'bracelet_name_placeholder', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2320, 0), new Long(53, 0))]));
  }
  function building_no_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3378, 0), new Long(53, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:building_no_label', 'building_no_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2374, 0), new Long(41, 0))]));
  }
  function _get_building_no_label_$ref_2j2am7() {
    return constructCallableReference(function (p0) {
      return get_building_no_label(p0);
    }, 1, 0, 614);
  }
  function bulk_discount_info$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3432, 0), new Long(86, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:bulk_discount_info', 'bulk_discount_info', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2416, 0), new Long(70, 0))]));
  }
  function _get_bulk_discount_info_$ref_pgmvvf() {
    return constructCallableReference(function (p0) {
      return get_bulk_discount_info(p0);
    }, 1, 0, 615);
  }
  function cancel$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3519, 0), new Long(30, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:cancel', 'cancel', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2487, 0), new Long(22, 0))]));
  }
  function _get_cancel_$ref_dashfk() {
    return constructCallableReference(function (p0) {
      return get_cancel(p0);
    }, 1, 0, 616);
  }
  function card_birthday_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3550, 0), new Long(83, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:card_birthday_label', 'card_birthday_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2510, 0), new Long(55, 0))]));
  }
  function _get_card_birthday_label_$ref_l03cpt() {
    return constructCallableReference(function (p0) {
      return get_card_birthday_label(p0);
    }, 1, 0, 617);
  }
  function card_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3634, 0), new Long(38, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:card_label', 'card_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2566, 0), new Long(26, 0))]));
  }
  function _get_card_label_$ref_ee4t91() {
    return constructCallableReference(function (p0) {
      return get_card_label(p0);
    }, 1, 0, 618);
  }
  function card_message_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3673, 0), new Long(62, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:card_message_label', 'card_message_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2593, 0), new Long(42, 0))]));
  }
  function _get_card_message_label_$ref_bjb619() {
    return constructCallableReference(function (p0) {
      return get_card_message_label(p0);
    }, 1, 0, 619);
  }
  function cart_empty_desc$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3736, 0), new Long(91, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:cart_empty_desc', 'cart_empty_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2636, 0), new Long(83, 0))]));
  }
  function _get_cart_empty_desc_$ref_4hwmbm() {
    return constructCallableReference(function (p0) {
      return get_cart_empty_desc(p0);
    }, 1, 0, 620);
  }
  function cart_empty_title$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3828, 0), new Long(52, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:cart_empty_title', 'cart_empty_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2720, 0), new Long(48, 0))]));
  }
  function _get_cart_empty_title_$ref_atkqqb() {
    return constructCallableReference(function (p0) {
      return get_cart_empty_title(p0);
    }, 1, 0, 621);
  }
  function cart_offline_mode$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(3881, 0), new Long(121, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:cart_offline_mode', 'cart_offline_mode', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2769, 0), new Long(65, 0))]));
  }
  function _get_cart_offline_mode_$ref_pud96m() {
    return constructCallableReference(function (p0) {
      return get_cart_offline_mode(p0);
    }, 1, 0, 622);
  }
  function cart_title$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4003, 0), new Long(70, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:cart_title', 'cart_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2835, 0), new Long(42, 0))]));
  }
  function _get_cart_title_$ref_oj37j3() {
    return constructCallableReference(function (p0) {
      return get_cart_title(p0);
    }, 1, 0, 623);
  }
  function cart_total_amount$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4074, 0), new Long(61, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:cart_total_amount', 'cart_total_amount', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2878, 0), new Long(41, 0))]));
  }
  function _get_cart_total_amount_$ref_ym1h8u() {
    return constructCallableReference(function (p0) {
      return get_cart_total_amount(p0);
    }, 1, 0, 624);
  }
  function cash_on_delivery_deposit_msg$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4136, 0), new Long(92, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:cash_on_delivery_deposit_msg', 'cash_on_delivery_deposit_msg', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2920, 0), new Long(64, 0))]));
  }
  function _get_cash_on_delivery_deposit_msg_$ref_d6fyj3() {
    return constructCallableReference(function (p0) {
      return get_cash_on_delivery_deposit_msg(p0);
    }, 1, 0, 625);
  }
  function cash_on_delivery_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4229, 0), new Long(78, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:cash_on_delivery_label', 'cash_on_delivery_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(2985, 0), new Long(54, 0))]));
  }
  function _get_cash_on_delivery_label_$ref_d59659() {
    return constructCallableReference(function (p0) {
      return get_cash_on_delivery_label(p0);
    }, 1, 0, 626);
  }
  function category_general_gifts$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4308, 0), new Long(58, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:category_general_gifts', 'category_general_gifts', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3040, 0), new Long(50, 0))]));
  }
  function _get_category_general_gifts_$ref_tai8q7() {
    return constructCallableReference(function (p0) {
      return get_category_general_gifts(p0);
    }, 1, 0, 627);
  }
  function category_girls_gifts$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4367, 0), new Long(60, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:category_girls_gifts', 'category_girls_gifts', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3091, 0), new Long(48, 0))]));
  }
  function category_mens_gifts$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4428, 0), new Long(59, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:category_mens_gifts', 'category_mens_gifts', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3140, 0), new Long(43, 0))]));
  }
  function center_setting$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4488, 0), new Long(38, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:center_setting', 'center_setting', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3184, 0), new Long(30, 0))]));
  }
  function change_avatar_desc$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4527, 0), new Long(78, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:change_avatar_desc', 'change_avatar_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3215, 0), new Long(46, 0))]));
  }
  function _get_change_avatar_desc_$ref_4ir8eq() {
    return constructCallableReference(function (p0) {
      return get_change_avatar_desc(p0);
    }, 1, 0, 628);
  }
  function change_language_btn_pattern$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4606, 0), new Long(75, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:change_language_btn_pattern', 'change_language_btn_pattern', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3262, 0), new Long(67, 0))]));
  }
  function _get_change_language_btn_pattern_$ref_jnh6c5() {
    return constructCallableReference(function (p0) {
      return get_change_language_btn_pattern(p0);
    }, 1, 0, 629);
  }
  function change_language_desc$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4682, 0), new Long(56, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:change_language_desc', 'change_language_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3330, 0), new Long(48, 0))]));
  }
  function change_password_btn$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4739, 0), new Long(71, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:change_password_btn', 'change_password_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3379, 0), new Long(47, 0))]));
  }
  function _get_change_password_btn_$ref_vp7ssn() {
    return constructCallableReference(function (p0) {
      return get_change_password_btn(p0);
    }, 1, 0, 630);
  }
  function change_pic_desc$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4811, 0), new Long(55, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:change_pic_desc', 'change_pic_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3427, 0), new Long(43, 0))]));
  }
  function _get_change_pic_desc_$ref_dap03v() {
    return constructCallableReference(function (p0) {
      return get_change_pic_desc(p0);
    }, 1, 0, 631);
  }
  function change_text_pattern$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4867, 0), new Long(63, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:change_text_pattern', 'change_text_pattern', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3471, 0), new Long(51, 0))]));
  }
  function checkout_no_internet$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(4931, 0), new Long(176, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:checkout_no_internet', 'checkout_no_internet', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3523, 0), new Long(128, 0))]));
  }
  function _get_checkout_no_internet_$ref_tyncp8() {
    return constructCallableReference(function (p0) {
      return get_checkout_no_internet(p0);
    }, 1, 0, 632);
  }
  function checkout_required_fields_error$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5108, 0), new Long(114, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:checkout_required_fields_error', 'checkout_required_fields_error', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3652, 0), new Long(86, 0))]));
  }
  function _get_checkout_required_fields_error_$ref_xtizsh() {
    return constructCallableReference(function (p0) {
      return get_checkout_required_fields_error(p0);
    }, 1, 0, 633);
  }
  function checkout_select_friend_error$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5223, 0), new Long(76, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:checkout_select_friend_error', 'checkout_select_friend_error', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3739, 0), new Long(68, 0))]));
  }
  function _get_checkout_select_friend_error_$ref_ezq27r() {
    return constructCallableReference(function (p0) {
      return get_checkout_select_friend_error(p0);
    }, 1, 0, 634);
  }
  function checkout_title$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5300, 0), new Long(50, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:checkout_title', 'checkout_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3808, 0), new Long(34, 0))]));
  }
  function _get_checkout_title_$ref_ms8kzp() {
    return constructCallableReference(function (p0) {
      return get_checkout_title(p0);
    }, 1, 0, 635);
  }
  function choose_wrapping_style_header$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5351, 0), new Long(76, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:choose_wrapping_style_header', 'choose_wrapping_style_header', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3843, 0), new Long(64, 0))]));
  }
  function city_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5428, 0), new Long(38, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:city_label', 'city_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3908, 0), new Long(26, 0))]));
  }
  function _get_city_label_$ref_hdazae() {
    return constructCallableReference(function (p0) {
      return get_city_label(p0);
    }, 1, 0, 636);
  }
  function classic_red$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5467, 0), new Long(51, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:classic_red', 'classic_red', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3935, 0), new Long(35, 0))]));
  }
  function clear_all$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5519, 0), new Long(37, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:clear_all', 'clear_all', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(3971, 0), new Long(29, 0))]));
  }
  function _get_clear_all_$ref_h31k7j() {
    return constructCallableReference(function (p0) {
      return get_clear_all(p0);
    }, 1, 0, 637);
  }
  function close$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5557, 0), new Long(29, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:close', 'close', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4001, 0), new Long(21, 0))]));
  }
  function _get_close_$ref_erjia0() {
    return constructCallableReference(function (p0) {
      return get_close(p0);
    }, 1, 0, 638);
  }
  function code_copied$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5587, 0), new Long(51, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:code_copied', 'code_copied', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4023, 0), new Long(51, 0))]));
  }
  function color_blue$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5639, 0), new Long(38, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:color_blue', 'color_blue', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4075, 0), new Long(34, 0))]));
  }
  function color_green$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5678, 0), new Long(39, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:color_green', 'color_green', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4110, 0), new Long(35, 0))]));
  }
  function color_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5718, 0), new Long(35, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:color_label', 'color_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4146, 0), new Long(27, 0))]));
  }
  function _get_color_label_$ref_jhgxzs() {
    return constructCallableReference(function (p0) {
      return get_color_label(p0);
    }, 1, 0, 639);
  }
  function color_red$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5754, 0), new Long(37, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:color_red', 'color_red', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4174, 0), new Long(29, 0))]));
  }
  function color_setting$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5792, 0), new Long(37, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:color_setting', 'color_setting', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4204, 0), new Long(29, 0))]));
  }
  function _get_color_setting_$ref_63d4fo() {
    return constructCallableReference(function (p0) {
      return get_color_setting(p0);
    }, 1, 0, 640);
  }
  function comment_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5830, 0), new Long(37, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:comment_label', 'comment_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4234, 0), new Long(33, 0))]));
  }
  function _get_comment_label_$ref_bs0w2c() {
    return constructCallableReference(function (p0) {
      return get_comment_label(p0);
    }, 1, 0, 641);
  }
  function confirm_password_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5868, 0), new Long(74, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:confirm_password_label', 'confirm_password_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4268, 0), new Long(54, 0))]));
  }
  function _get_confirm_password_label_$ref_klaq0b() {
    return constructCallableReference(function (p0) {
      return get_confirm_password_label(p0);
    }, 1, 0, 642);
  }
  function confirm_pay_btn$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5943, 0), new Long(55, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:confirm_pay_btn', 'confirm_pay_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4323, 0), new Long(43, 0))]));
  }
  function _get_confirm_pay_btn_$ref_9lrvju() {
    return constructCallableReference(function (p0) {
      return get_confirm_pay_btn(p0);
    }, 1, 0, 643);
  }
  function confirm_place_order_btn$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(5999, 0), new Long(59, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:confirm_place_order_btn', 'confirm_place_order_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4367, 0), new Long(63, 0))]));
  }
  function _get_confirm_place_order_btn_$ref_emil70() {
    return constructCallableReference(function (p0) {
      return get_confirm_place_order_btn(p0);
    }, 1, 0, 644);
  }
  function connect_internet_to_add_cart$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(6059, 0), new Long(156, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:connect_internet_to_add_cart', 'connect_internet_to_add_cart', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4431, 0), new Long(104, 0))]));
  }
  function _get_connect_internet_to_add_cart_$ref_knilun() {
    return constructCallableReference(function (p0) {
      return get_connect_internet_to_add_cart(p0);
    }, 1, 0, 645);
  }
  function contact_support_whatsapp_btn$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(6216, 0), new Long(100, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:contact_support_whatsapp_btn', 'contact_support_whatsapp_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4536, 0), new Long(76, 0))]));
  }
  function _get_contact_support_whatsapp_btn_$ref_71of18() {
    return constructCallableReference(function (p0) {
      return get_contact_support_whatsapp_btn(p0);
    }, 1, 0, 646);
  }
  function contact_us$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(6381, 0), new Long(46, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:contact_us', 'contact_us', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4669, 0), new Long(34, 0))]));
  }
  function _get_contact_us_$ref_1oaigt() {
    return constructCallableReference(function (p0) {
      return get_contact_us(p0);
    }, 1, 0, 647);
  }
  function contact_us_whatsapp$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(6317, 0), new Long(63, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:contact_us_whatsapp', 'contact_us_whatsapp', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4613, 0), new Long(55, 0))]));
  }
  function _get_contact_us_whatsapp_$ref_3cgfsk() {
    return constructCallableReference(function (p0) {
      return get_contact_us_whatsapp(p0);
    }, 1, 0, 648);
  }
  function content_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:content_label', 'content_label', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4704, 0), new Long(33, 0))));
  }
  function _get_content_label_$ref_c8oy8i() {
    return constructCallableReference(function (p0) {
      return get_content_label(p0);
    }, 1, 0, 649);
  }
  function copy_code$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(6428, 0), new Long(41, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:copy_code', 'copy_code', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4738, 0), new Long(29, 0))]));
  }
  function _get_copy_code_$ref_s92nd() {
    return constructCallableReference(function (p0) {
      return get_copy_code(p0);
    }, 1, 0, 650);
  }
  function country_label$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(6470, 0), new Long(37, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:country_label', 'country_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4768, 0), new Long(33, 0))]));
  }
  function _get_country_label_$ref_ojrx91() {
    return constructCallableReference(function (p0) {
      return get_country_label(p0);
    }, 1, 0, 651);
  }
  function coupon_already_used_error$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(6508, 0), new Long(117, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:coupon_already_used_error', 'coupon_already_used_error', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4802, 0), new Long(73, 0))]));
  }
  function _get_coupon_already_used_error_$ref_bx9jly() {
    return constructCallableReference(function (p0) {
      return get_coupon_already_used_error(p0);
    }, 1, 0, 652);
  }
  function coupon_applied_success$delegate$lambda() {
    _init_properties_String0_commonMain_kt__qq9t1p();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(6626, 0), new Long(90, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:coupon_applied_success', 'coupon_applied_success', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4876, 0), new Long(70, 0))]));
  }
  function _get_coupon_applied_success_$ref_i42g5u() {
    return constructCallableReference(function (p0) {
      return get_coupon_applied_success(p0);
    }, 1, 0, 653);
  }
  var properties_initialized_String0_commonMain_kt_eece2d;
  function _init_properties_String0_commonMain_kt__qq9t1p() {
    if (!properties_initialized_String0_commonMain_kt_eece2d) {
      properties_initialized_String0_commonMain_kt_eece2d = true;
      _3d_model_viewer_custom$delegate = lazy(_3d_model_viewer_custom$delegate$lambda);
      _3d_model_viewer_name$delegate = lazy(_3d_model_viewer_name$delegate$lambda);
      _3d_preview$delegate = lazy(_3d_preview$delegate$lambda);
      accept_privacy_policy$delegate = lazy(accept_privacy_policy$delegate$lambda);
      accept_privacy_policy_prefix$delegate = lazy(accept_privacy_policy_prefix$delegate$lambda);
      add$delegate = lazy(add$delegate$lambda);
      add_comment_optional_label$delegate = lazy(add_comment_optional_label$delegate$lambda);
      add_custom_mug_to_cart$delegate = lazy(add_custom_mug_to_cart$delegate$lambda);
      add_custom_text$delegate = lazy(add_custom_text$delegate$lambda);
      add_friend_desc$delegate = lazy(add_friend_desc$delegate$lambda);
      add_gift_message_header$delegate = lazy(add_gift_message_header$delegate$lambda);
      add_image$delegate = lazy(add_image$delegate$lambda);
      add_image_desc$delegate = lazy(add_image_desc$delegate$lambda);
      add_image_title$delegate = lazy(add_image_title$delegate$lambda);
      add_new$delegate = lazy(add_new$delegate$lambda);
      add_new_friend_title$delegate = lazy(add_new_friend_title$delegate$lambda);
      add_product_comment_label$delegate = lazy(add_product_comment_label$delegate$lambda);
      add_text_title$delegate = lazy(add_text_title$delegate$lambda);
      add_to_cart$delegate = lazy(add_to_cart$delegate$lambda);
      add_to_favorites$delegate = lazy(add_to_favorites$delegate$lambda);
      added_to_cart$delegate = lazy(added_to_cart$delegate$lambda);
      adding_to_cart_dialog_msg$delegate = lazy(adding_to_cart_dialog_msg$delegate$lambda);
      adding_to_cart_dialog_msg_custom$delegate = lazy(adding_to_cart_dialog_msg_custom$delegate$lambda);
      adding_to_cart_dialog_title$delegate = lazy(adding_to_cart_dialog_title$delegate$lambda);
      address_label_required$delegate = lazy(address_label_required$delegate$lambda);
      age_group_for_prefix$delegate = lazy(age_group_for_prefix$delegate$lambda);
      age_group_label$delegate = lazy(age_group_label$delegate$lambda);
      all_coupons_tab$delegate = lazy(all_coupons_tab$delegate$lambda);
      all_gifts$delegate = lazy(all_gifts$delegate$lambda);
      already_have_account_hint$delegate = lazy(already_have_account_hint$delegate$lambda);
      app_name$delegate = lazy(app_name$delegate$lambda);
      apple_pay_label$delegate = lazy(apple_pay_label$delegate$lambda);
      apply_btn$delegate = lazy(apply_btn$delegate$lambda);
      apply_changes_desc$delegate = lazy(apply_changes_desc$delegate$lambda);
      apply_changes_title$delegate = lazy(apply_changes_title$delegate$lambda);
      apply_coupon_btn$delegate = lazy(apply_coupon_btn$delegate$lambda);
      apply_filters_btn$delegate = lazy(apply_filters_btn$delegate$lambda);
      available_coupons_header$delegate = lazy(available_coupons_header$delegate$lambda);
      available_coupons_tab$delegate = lazy(available_coupons_tab$delegate$lambda);
      back$delegate = lazy(back$delegate$lambda);
      back_to_3d_preview$delegate = lazy(back_to_3d_preview$delegate$lambda);
      back_to_home_btn$delegate = lazy(back_to_home_btn$delegate$lambda);
      base_color$delegate = lazy(base_color$delegate$lambda);
      birthday_label$delegate = lazy(birthday_label$delegate$lambda);
      birthday_prefix_pattern$delegate = lazy(birthday_prefix_pattern$delegate$lambda);
      birthday_yyyy_mm_dd_label$delegate = lazy(birthday_yyyy_mm_dd_label$delegate$lambda);
      box_label$delegate = lazy(box_label$delegate$lambda);
      bracelet_name_label$delegate = lazy(bracelet_name_label$delegate$lambda);
      bracelet_name_placeholder$delegate = lazy(bracelet_name_placeholder$delegate$lambda);
      building_no_label$delegate = lazy(building_no_label$delegate$lambda);
      bulk_discount_info$delegate = lazy(bulk_discount_info$delegate$lambda);
      cancel$delegate = lazy(cancel$delegate$lambda);
      card_birthday_label$delegate = lazy(card_birthday_label$delegate$lambda);
      card_label$delegate = lazy(card_label$delegate$lambda);
      card_message_label$delegate = lazy(card_message_label$delegate$lambda);
      cart_empty_desc$delegate = lazy(cart_empty_desc$delegate$lambda);
      cart_empty_title$delegate = lazy(cart_empty_title$delegate$lambda);
      cart_offline_mode$delegate = lazy(cart_offline_mode$delegate$lambda);
      cart_title$delegate = lazy(cart_title$delegate$lambda);
      cart_total_amount$delegate = lazy(cart_total_amount$delegate$lambda);
      cash_on_delivery_deposit_msg$delegate = lazy(cash_on_delivery_deposit_msg$delegate$lambda);
      cash_on_delivery_label$delegate = lazy(cash_on_delivery_label$delegate$lambda);
      category_general_gifts$delegate = lazy(category_general_gifts$delegate$lambda);
      category_girls_gifts$delegate = lazy(category_girls_gifts$delegate$lambda);
      category_mens_gifts$delegate = lazy(category_mens_gifts$delegate$lambda);
      center_setting$delegate = lazy(center_setting$delegate$lambda);
      change_avatar_desc$delegate = lazy(change_avatar_desc$delegate$lambda);
      change_language_btn_pattern$delegate = lazy(change_language_btn_pattern$delegate$lambda);
      change_language_desc$delegate = lazy(change_language_desc$delegate$lambda);
      change_password_btn$delegate = lazy(change_password_btn$delegate$lambda);
      change_pic_desc$delegate = lazy(change_pic_desc$delegate$lambda);
      change_text_pattern$delegate = lazy(change_text_pattern$delegate$lambda);
      checkout_no_internet$delegate = lazy(checkout_no_internet$delegate$lambda);
      checkout_required_fields_error$delegate = lazy(checkout_required_fields_error$delegate$lambda);
      checkout_select_friend_error$delegate = lazy(checkout_select_friend_error$delegate$lambda);
      checkout_title$delegate = lazy(checkout_title$delegate$lambda);
      choose_wrapping_style_header$delegate = lazy(choose_wrapping_style_header$delegate$lambda);
      city_label$delegate = lazy(city_label$delegate$lambda);
      classic_red$delegate = lazy(classic_red$delegate$lambda);
      clear_all$delegate = lazy(clear_all$delegate$lambda);
      close$delegate = lazy(close$delegate$lambda);
      code_copied$delegate = lazy(code_copied$delegate$lambda);
      color_blue$delegate = lazy(color_blue$delegate$lambda);
      color_green$delegate = lazy(color_green$delegate$lambda);
      color_label$delegate = lazy(color_label$delegate$lambda);
      color_red$delegate = lazy(color_red$delegate$lambda);
      color_setting$delegate = lazy(color_setting$delegate$lambda);
      comment_label$delegate = lazy(comment_label$delegate$lambda);
      confirm_password_label$delegate = lazy(confirm_password_label$delegate$lambda);
      confirm_pay_btn$delegate = lazy(confirm_pay_btn$delegate$lambda);
      confirm_place_order_btn$delegate = lazy(confirm_place_order_btn$delegate$lambda);
      connect_internet_to_add_cart$delegate = lazy(connect_internet_to_add_cart$delegate$lambda);
      contact_support_whatsapp_btn$delegate = lazy(contact_support_whatsapp_btn$delegate$lambda);
      contact_us$delegate = lazy(contact_us$delegate$lambda);
      contact_us_whatsapp$delegate = lazy(contact_us_whatsapp$delegate$lambda);
      content_label$delegate = lazy(content_label$delegate$lambda);
      copy_code$delegate = lazy(copy_code$delegate$lambda);
      country_label$delegate = lazy(country_label$delegate$lambda);
      coupon_already_used_error$delegate = lazy(coupon_already_used_error$delegate$lambda);
      coupon_applied_success$delegate = lazy(coupon_applied_success$delegate$lambda);
    }
  }
  function get_coupon_caution_message(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = coupon_caution_message$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('coupon_caution_message', 1, tmp, _get_coupon_caution_message_$ref_vb3gww(), null);
    return tmp0.u1();
  }
  var coupon_caution_message$delegate;
  function get_coupon_caution_title(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = coupon_caution_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('coupon_caution_title', 1, tmp, _get_coupon_caution_title_$ref_9nufzj(), null);
    return tmp0.u1();
  }
  var coupon_caution_title$delegate;
  function get_coupon_code_label(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = coupon_code_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('coupon_code_label', 1, tmp, _get_coupon_code_label_$ref_guho05(), null);
    return tmp0.u1();
  }
  var coupon_code_label$delegate;
  function get_coupon_code_prefix(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = coupon_code_prefix$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('coupon_code_prefix', 1, tmp, _get_coupon_code_prefix_$ref_d20ucx(), null);
    return tmp0.u1();
  }
  var coupon_code_prefix$delegate;
  function get_coupon_created_at(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = coupon_created_at$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('coupon_created_at', 1, tmp, _get_coupon_created_at_$ref_1npkoz(), null);
    return tmp0.u1();
  }
  var coupon_created_at$delegate;
  function get_coupon_discount_prefix(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = coupon_discount_prefix$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('coupon_discount_prefix', 1, tmp, _get_coupon_discount_prefix_$ref_v9u17n(), null);
    return tmp0.u1();
  }
  var coupon_discount_prefix$delegate;
  function get_coupon_used_at(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = coupon_used_at$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('coupon_used_at', 1, tmp, _get_coupon_used_at_$ref_nok1zy(), null);
    return tmp0.u1();
  }
  var coupon_used_at$delegate;
  function get_create_account(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = create_account$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('create_account', 1, tmp, _get_create_account_$ref_pp6q4w(), null);
    return tmp0.u1();
  }
  var create_account$delegate;
  var custom_products$delegate;
  function get_custom_products_only(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = custom_products_only$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('custom_products_only', 1, tmp, _get_custom_products_only_$ref_vypxc1(), null);
    return tmp0.u1();
  }
  var custom_products_only$delegate;
  var custom_text_placeholder$delegate;
  function get_customize_btn(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = customize_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('customize_btn', 1, tmp, _get_customize_btn_$ref_jgo9s(), null);
    return tmp0.u1();
  }
  var customize_btn$delegate;
  function get_decrease_quantity_desc(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = decrease_quantity_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('decrease_quantity_desc', 1, tmp, _get_decrease_quantity_desc_$ref_wfw45y(), null);
    return tmp0.u1();
  }
  var decrease_quantity_desc$delegate;
  function get_default_selection(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = default_selection$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('default_selection', 1, tmp, _get_default_selection_$ref_fq74he(), null);
    return tmp0.u1();
  }
  var default_selection$delegate;
  function get_delete(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = delete$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('delete', 1, tmp, _get_delete_$ref_kqle3z(), null);
    return tmp0.u1();
  }
  var delete$delegate;
  function get_delete_account_btn(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = delete_account_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('delete_account_btn', 1, tmp, _get_delete_account_btn_$ref_wwyz98(), null);
    return tmp0.u1();
  }
  var delete_account_btn$delegate;
  function get_delete_account_confirm(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = delete_account_confirm$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('delete_account_confirm', 1, tmp, _get_delete_account_confirm_$ref_o6qbfk(), null);
    return tmp0.u1();
  }
  var delete_account_confirm$delegate;
  function get_delete_account_failed(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = delete_account_failed$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('delete_account_failed', 1, tmp, _get_delete_account_failed_$ref_5o9wn1(), null);
    return tmp0.u1();
  }
  var delete_account_failed$delegate;
  function get_delete_account_success_message(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = delete_account_success_message$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('delete_account_success_message', 1, tmp, _get_delete_account_success_message_$ref_qmtpcb(), null);
    return tmp0.u1();
  }
  var delete_account_success_message$delegate;
  function get_delete_account_success_title(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = delete_account_success_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('delete_account_success_title', 1, tmp, _get_delete_account_success_title_$ref_fcwq6c(), null);
    return tmp0.u1();
  }
  var delete_account_success_title$delegate;
  function get_delete_friend_confirm_pattern(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = delete_friend_confirm_pattern$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('delete_friend_confirm_pattern', 1, tmp, _get_delete_friend_confirm_pattern_$ref_7ig9tw(), null);
    return tmp0.u1();
  }
  var delete_friend_confirm_pattern$delegate;
  function get_delete_friend_title(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = delete_friend_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('delete_friend_title', 1, tmp, _get_delete_friend_title_$ref_r2h38r(), null);
    return tmp0.u1();
  }
  var delete_friend_title$delegate;
  var delete_image_desc$delegate;
  var delete_image_title$delegate;
  function get_delete_with_google(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = delete_with_google$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('delete_with_google', 1, tmp, _get_delete_with_google_$ref_tl6xl0(), null);
    return tmp0.u1();
  }
  var delete_with_google$delegate;
  function get_delivery_address_label(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = delivery_address_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('delivery_address_label', 1, tmp, _get_delivery_address_label_$ref_jf4bj0(), null);
    return tmp0.u1();
  }
  var delivery_address_label$delegate;
  function get_delivery_details_header(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = delivery_details_header$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('delivery_details_header', 1, tmp, _get_delivery_details_header_$ref_p6dcy3(), null);
    return tmp0.u1();
  }
  var delivery_details_header$delegate;
  var description$delegate;
  function get_design_studio(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = design_studio$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('design_studio', 1, tmp, _get_design_studio_$ref_1rqkt3(), null);
    return tmp0.u1();
  }
  var design_studio$delegate;
  function get_design_updated_cart(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = design_updated_cart$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('design_updated_cart', 1, tmp, _get_design_updated_cart_$ref_kb8rvf(), null);
    return tmp0.u1();
  }
  var design_updated_cart$delegate;
  function get_design_your_item(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = design_your_item$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('design_your_item', 1, tmp, _get_design_your_item_$ref_z5v9ng(), null);
    return tmp0.u1();
  }
  var design_your_item$delegate;
  function get_discard_btn(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = discard_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('discard_btn', 1, tmp, _get_discard_btn_$ref_pcphgl(), null);
    return tmp0.u1();
  }
  var discard_btn$delegate;
  function get_discard_design_msg(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = discard_design_msg$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('discard_design_msg', 1, tmp, _get_discard_design_msg_$ref_sg08iv(), null);
    return tmp0.u1();
  }
  var discard_design_msg$delegate;
  function get_discard_design_title(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = discard_design_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('discard_design_title', 1, tmp, _get_discard_design_title_$ref_i0l5wi(), null);
    return tmp0.u1();
  }
  var discard_design_title$delegate;
  function get_discard_order_msg(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = discard_order_msg$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('discard_order_msg', 1, tmp, _get_discard_order_msg_$ref_8hj4a9(), null);
    return tmp0.u1();
  }
  var discard_order_msg$delegate;
  function get_discard_order_title(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = discard_order_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('discard_order_title', 1, tmp, _get_discard_order_title_$ref_661cna(), null);
    return tmp0.u1();
  }
  var discard_order_title$delegate;
  function get_done_btn(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = done_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('done_btn', 1, tmp, _get_done_btn_$ref_lno9yz(), null);
    return tmp0.u1();
  }
  var done_btn$delegate;
  function get_dont_have_account_hint(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = dont_have_account_hint$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('dont_have_account_hint', 1, tmp, _get_dont_have_account_hint_$ref_69c63s(), null);
    return tmp0.u1();
  }
  var dont_have_account_hint$delegate;
  function get_edit(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = edit$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('edit', 1, tmp, _get_edit_$ref_6wahw0(), null);
    return tmp0.u1();
  }
  var edit$delegate;
  function get_edit_design(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = edit_design$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('edit_design', 1, tmp, _get_edit_design_$ref_uyuur(), null);
    return tmp0.u1();
  }
  var edit_design$delegate;
  var edit_design_btn$delegate;
  function get_edit_friend_title(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = edit_friend_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('edit_friend_title', 1, tmp, _get_edit_friend_title_$ref_twxcgc(), null);
    return tmp0.u1();
  }
  var edit_friend_title$delegate;
  function get_edit_profile(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = edit_profile$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('edit_profile', 1, tmp, _get_edit_profile_$ref_oi56ii(), null);
    return tmp0.u1();
  }
  var edit_profile$delegate;
  function get_edit_text_place_holder(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = edit_text_place_holder$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('edit_text_place_holder', 1, tmp, _get_edit_text_place_holder_$ref_vyt50n(), null);
    return tmp0.u1();
  }
  var edit_text_place_holder$delegate;
  function get_edit_text_title(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = edit_text_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('edit_text_title', 1, tmp, _get_edit_text_title_$ref_qgt7ph(), null);
    return tmp0.u1();
  }
  var edit_text_title$delegate;
  var edit_your_design$delegate;
  function get_email_contact(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = email_contact$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('email_contact', 1, tmp, _get_email_contact_$ref_6rnrj1(), null);
    return tmp0.u1();
  }
  var email_contact$delegate;
  function get_email_label(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = email_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('email_label', 1, tmp, _get_email_label_$ref_m1g8pb(), null);
    return tmp0.u1();
  }
  var email_label$delegate;
  var email_verified_title$delegate;
  function get_enter_text_placeholder(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = enter_text_placeholder$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('enter_text_placeholder', 1, tmp, _get_enter_text_placeholder_$ref_xoiff6(), null);
    return tmp0.u1();
  }
  var enter_text_placeholder$delegate;
  var error_expired_link$delegate;
  var error_invalid_email$delegate;
  var error_loading_image$delegate;
  var exit_full_screen$delegate;
  function get_failed_add_to_cart(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = failed_add_to_cart$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('failed_add_to_cart', 1, tmp, _get_failed_add_to_cart_$ref_h6g3t6(), null);
    return tmp0.u1();
  }
  var failed_add_to_cart$delegate;
  function get_failed_load_product(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = failed_load_product$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('failed_load_product', 1, tmp, _get_failed_load_product_$ref_eq3l94(), null);
    return tmp0.u1();
  }
  var failed_load_product$delegate;
  function get_failed_load_product_design(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = failed_load_product_design$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('failed_load_product_design', 1, tmp, _get_failed_load_product_design_$ref_jzxgnp(), null);
    return tmp0.u1();
  }
  var failed_load_product_design$delegate;
  var failed_send_reset$delegate;
  function get_failed_to_save(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = failed_to_save$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('failed_to_save', 1, tmp, _get_failed_to_save_$ref_tm0wr(), null);
    return tmp0.u1();
  }
  var failed_to_save$delegate;
  function get_failed_to_update_password(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = failed_to_update_password$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('failed_to_update_password', 1, tmp, _get_failed_to_update_password_$ref_93xhv3(), null);
    return tmp0.u1();
  }
  var failed_to_update_password$delegate;
  function get_favorite_products(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = favorite_products$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('favorite_products', 1, tmp, _get_favorite_products_$ref_txyzcp(), null);
    return tmp0.u1();
  }
  var favorite_products$delegate;
  function get_favorite_products_btn(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = favorite_products_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('favorite_products_btn', 1, tmp, _get_favorite_products_btn_$ref_vd1c78(), null);
    return tmp0.u1();
  }
  var favorite_products_btn$delegate;
  function get_favorites_title(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = favorites_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('favorites_title', 1, tmp, _get_favorites_title_$ref_oe41kg(), null);
    return tmp0.u1();
  }
  var favorites_title$delegate;
  var fill_setting$delegate;
  function get_filter_all(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = filter_all$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('filter_all', 1, tmp, _get_filter_all_$ref_lgt9eo(), null);
    return tmp0.u1();
  }
  var filter_all$delegate;
  function get_filter_btn(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = filter_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('filter_btn', 1, tmp, _get_filter_btn_$ref_qlh539(), null);
    return tmp0.u1();
  }
  var filter_btn$delegate;
  var filter_grayscale$delegate;
  var filter_invert$delegate;
  var filter_none$delegate;
  function get_filter_orders(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = filter_orders$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('filter_orders', 1, tmp, _get_filter_orders_$ref_pq7gzw(), null);
    return tmp0.u1();
  }
  var filter_orders$delegate;
  function get_filter_returns(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = filter_returns$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('filter_returns', 1, tmp, _get_filter_returns_$ref_beet1a(), null);
    return tmp0.u1();
  }
  var filter_returns$delegate;
  var filter_sepia$delegate;
  function get_filters_label(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = filters_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('filters_label', 1, tmp, _get_filters_label_$ref_y402nk(), null);
    return tmp0.u1();
  }
  var filters_label$delegate;
  function get_first_name_label(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = first_name_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('first_name_label', 1, tmp, _get_first_name_label_$ref_8rgdij(), null);
    return tmp0.u1();
  }
  var first_name_label$delegate;
  var fit_setting$delegate;
  var flip_h$delegate;
  var flip_v$delegate;
  var font_cursive$delegate;
  var font_default$delegate;
  var font_monospace$delegate;
  var font_sans_serif$delegate;
  var font_serif$delegate;
  function get_font_setting(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = font_setting$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('font_setting', 1, tmp, _get_font_setting_$ref_hyv2ai(), null);
    return tmp0.u1();
  }
  var font_setting$delegate;
  function get_forgot_password(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = forgot_password$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('forgot_password', 1, tmp, _get_forgot_password_$ref_lc5efr(), null);
    return tmp0.u1();
  }
  var forgot_password$delegate;
  function get_free(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = free$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('free', 1, tmp, _get_free_$ref_gsmfgu(), null);
    return tmp0.u1();
  }
  var free$delegate;
  var friend$delegate;
  function get_friend_added_successfully(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = friend_added_successfully$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('friend_added_successfully', 1, tmp, _get_friend_added_successfully_$ref_6m13tz(), null);
    return tmp0.u1();
  }
  var friend_added_successfully$delegate;
  function get_friend_deleted_successfully(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = friend_deleted_successfully$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('friend_deleted_successfully', 1, tmp, _get_friend_deleted_successfully_$ref_eto71u(), null);
    return tmp0.u1();
  }
  var friend_deleted_successfully$delegate;
  function get_friend_pic_desc(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = friend_pic_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('friend_pic_desc', 1, tmp, _get_friend_pic_desc_$ref_47rnzt(), null);
    return tmp0.u1();
  }
  var friend_pic_desc$delegate;
  function get_friend_pic_selected_desc(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = friend_pic_selected_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('friend_pic_selected_desc', 1, tmp, _get_friend_pic_selected_desc_$ref_iijpdn(), null);
    return tmp0.u1();
  }
  var friend_pic_selected_desc$delegate;
  function get_friend_updated_successfully(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = friend_updated_successfully$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('friend_updated_successfully', 1, tmp, _get_friend_updated_successfully_$ref_s1hfpw(), null);
    return tmp0.u1();
  }
  var friend_updated_successfully$delegate;
  function get_friends_title(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = friends_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('friends_title', 1, tmp, _get_friends_title_$ref_me8vki(), null);
    return tmp0.u1();
  }
  var friends_title$delegate;
  function get_full_gallery(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = full_gallery$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('full_gallery', 1, tmp, _get_full_gallery_$ref_aji9ug(), null);
    return tmp0.u1();
  }
  var full_gallery$delegate;
  function get_full_wrap_label(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = full_wrap_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('full_wrap_label', 1, tmp, _get_full_wrap_label_$ref_jv4nm7(), null);
    return tmp0.u1();
  }
  var full_wrap_label$delegate;
  function get_gift_message_placeholder(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = gift_message_placeholder$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('gift_message_placeholder', 1, tmp, _get_gift_message_placeholder_$ref_lfblrm(), null);
    return tmp0.u1();
  }
  var gift_message_placeholder$delegate;
  var gift_wrapping_desc$delegate;
  var gift_wrapping_label$delegate;
  var gifting_options_header$delegate;
  function get_girls_gifts(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = girls_gifts$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('girls_gifts', 1, tmp, _get_girls_gifts_$ref_lmd7yd(), null);
    return tmp0.u1();
  }
  var girls_gifts$delegate;
  function get_google_pay_label(_this__u8e3s4) {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp0 = google_pay_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('google_pay_label', 1, tmp, _get_google_pay_label_$ref_9gue83(), null);
    return tmp0.u1();
  }
  var google_pay_label$delegate;
  function coupon_caution_message$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(6717, 0), new Long(406, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:coupon_caution_message', 'coupon_caution_message', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(4947, 0), new Long(250, 0))]));
  }
  function _get_coupon_caution_message_$ref_vb3gww() {
    return constructCallableReference(function (p0) {
      return get_coupon_caution_message(p0);
    }, 1, 0, 654);
  }
  function coupon_caution_title$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7124, 0), new Long(44, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:coupon_caution_title', 'coupon_caution_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5198, 0), new Long(40, 0))]));
  }
  function _get_coupon_caution_title_$ref_9nufzj() {
    return constructCallableReference(function (p0) {
      return get_coupon_caution_title(p0);
    }, 1, 0, 655);
  }
  function coupon_code_label$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7169, 0), new Long(49, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:coupon_code_label', 'coupon_code_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5239, 0), new Long(41, 0))]));
  }
  function _get_coupon_code_label_$ref_guho05() {
    return constructCallableReference(function (p0) {
      return get_coupon_code_label(p0);
    }, 1, 0, 656);
  }
  function coupon_code_prefix$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7219, 0), new Long(50, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:coupon_code_prefix', 'coupon_code_prefix', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5281, 0), new Long(42, 0))]));
  }
  function _get_coupon_code_prefix_$ref_d20ucx() {
    return constructCallableReference(function (p0) {
      return get_coupon_code_prefix(p0);
    }, 1, 0, 657);
  }
  function coupon_created_at$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7270, 0), new Long(53, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:coupon_created_at', 'coupon_created_at', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5324, 0), new Long(49, 0))]));
  }
  function _get_coupon_created_at_$ref_1npkoz() {
    return constructCallableReference(function (p0) {
      return get_coupon_created_at(p0);
    }, 1, 0, 658);
  }
  function coupon_discount_prefix$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7324, 0), new Long(54, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:coupon_discount_prefix', 'coupon_discount_prefix', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5374, 0), new Long(50, 0))]));
  }
  function _get_coupon_discount_prefix_$ref_v9u17n() {
    return constructCallableReference(function (p0) {
      return get_coupon_discount_prefix(p0);
    }, 1, 0, 659);
  }
  function coupon_used_at$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7379, 0), new Long(54, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:coupon_used_at', 'coupon_used_at', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5425, 0), new Long(42, 0))]));
  }
  function _get_coupon_used_at_$ref_nok1zy() {
    return constructCallableReference(function (p0) {
      return get_coupon_used_at(p0);
    }, 1, 0, 660);
  }
  function create_account$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7434, 0), new Long(50, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:create_account', 'create_account', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5468, 0), new Long(42, 0))]));
  }
  function _get_create_account_$ref_pp6q4w() {
    return constructCallableReference(function (p0) {
      return get_create_account(p0);
    }, 1, 0, 661);
  }
  function custom_products$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7546, 0), new Long(55, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:custom_products', 'custom_products', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5560, 0), new Long(43, 0))]));
  }
  function custom_products_only$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7485, 0), new Long(60, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:custom_products_only', 'custom_products_only', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5511, 0), new Long(48, 0))]));
  }
  function _get_custom_products_only_$ref_vypxc1() {
    return constructCallableReference(function (p0) {
      return get_custom_products_only(p0);
    }, 1, 0, 662);
  }
  function custom_text_placeholder$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7602, 0), new Long(91, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:custom_text_placeholder', 'custom_text_placeholder', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5604, 0), new Long(63, 0))]));
  }
  function customize_btn$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7694, 0), new Long(37, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:customize_btn', 'customize_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5668, 0), new Long(33, 0))]));
  }
  function _get_customize_btn_$ref_jgo9s() {
    return constructCallableReference(function (p0) {
      return get_customize_btn(p0);
    }, 1, 0, 663);
  }
  function decrease_quantity_desc$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7732, 0), new Long(62, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:decrease_quantity_desc', 'decrease_quantity_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5702, 0), new Long(42, 0))]));
  }
  function _get_decrease_quantity_desc_$ref_wfw45y() {
    return constructCallableReference(function (p0) {
      return get_decrease_quantity_desc(p0);
    }, 1, 0, 664);
  }
  function default_selection$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7795, 0), new Long(45, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:default_selection', 'default_selection', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5745, 0), new Long(37, 0))]));
  }
  function _get_default_selection_$ref_fq74he() {
    return constructCallableReference(function (p0) {
      return get_default_selection(p0);
    }, 1, 0, 665);
  }
  function delete$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(8995, 0), new Long(22, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:delete', 'delete', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6705, 0), new Long(22, 0))]));
  }
  function _get_delete_$ref_kqle3z() {
    return constructCallableReference(function (p0) {
      return get_delete(p0);
    }, 1, 0, 666);
  }
  function delete_account_btn$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7841, 0), new Long(54, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:delete_account_btn', 'delete_account_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5783, 0), new Long(46, 0))]));
  }
  function _get_delete_account_btn_$ref_wwyz98() {
    return constructCallableReference(function (p0) {
      return get_delete_account_btn(p0);
    }, 1, 0, 667);
  }
  function delete_account_confirm$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(7896, 0), new Long(246, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:delete_account_confirm', 'delete_account_confirm', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(5830, 0), new Long(182, 0))]));
  }
  function _get_delete_account_confirm_$ref_o6qbfk() {
    return constructCallableReference(function (p0) {
      return get_delete_account_confirm(p0);
    }, 1, 0, 668);
  }
  function delete_account_failed$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(8143, 0), new Long(133, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:delete_account_failed', 'delete_account_failed', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6013, 0), new Long(101, 0))]));
  }
  function _get_delete_account_failed_$ref_5o9wn1() {
    return constructCallableReference(function (p0) {
      return get_delete_account_failed(p0);
    }, 1, 0, 669);
  }
  function delete_account_success_message$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(8277, 0), new Long(226, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:delete_account_success_message', 'delete_account_success_message', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6115, 0), new Long(190, 0))]));
  }
  function _get_delete_account_success_message_$ref_qmtpcb() {
    return constructCallableReference(function (p0) {
      return get_delete_account_success_message(p0);
    }, 1, 0, 670);
  }
  function delete_account_success_title$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(8504, 0), new Long(68, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:delete_account_success_title', 'delete_account_success_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6306, 0), new Long(56, 0))]));
  }
  function _get_delete_account_success_title_$ref_fcwq6c() {
    return constructCallableReference(function (p0) {
      return get_delete_account_success_title(p0);
    }, 1, 0, 671);
  }
  function delete_friend_confirm_pattern$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(8573, 0), new Long(109, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:delete_friend_confirm_pattern', 'delete_friend_confirm_pattern', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6363, 0), new Long(89, 0))]));
  }
  function _get_delete_friend_confirm_pattern_$ref_7ig9tw() {
    return constructCallableReference(function (p0) {
      return get_delete_friend_confirm_pattern(p0);
    }, 1, 0, 672);
  }
  function delete_friend_title$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(8683, 0), new Long(55, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:delete_friend_title', 'delete_friend_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6453, 0), new Long(47, 0))]));
  }
  function _get_delete_friend_title_$ref_r2h38r() {
    return constructCallableReference(function (p0) {
      return get_delete_friend_title(p0);
    }, 1, 0, 673);
  }
  function delete_image_desc$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(8739, 0), new Long(129, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:delete_image_desc', 'delete_image_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6501, 0), new Long(105, 0))]));
  }
  function delete_image_title$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(8869, 0), new Long(54, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:delete_image_title', 'delete_image_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6607, 0), new Long(46, 0))]));
  }
  function delete_with_google$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(8924, 0), new Long(70, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:delete_with_google', 'delete_with_google', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6654, 0), new Long(50, 0))]));
  }
  function _get_delete_with_google_$ref_tl6xl0() {
    return constructCallableReference(function (p0) {
      return get_delete_with_google(p0);
    }, 1, 0, 674);
  }
  function delivery_address_label$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9018, 0), new Long(66, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:delivery_address_label', 'delivery_address_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6728, 0), new Long(54, 0))]));
  }
  function _get_delivery_address_label_$ref_jf4bj0() {
    return constructCallableReference(function (p0) {
      return get_delivery_address_label(p0);
    }, 1, 0, 675);
  }
  function delivery_details_header$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9085, 0), new Long(67, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:delivery_details_header', 'delivery_details_header', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6783, 0), new Long(55, 0))]));
  }
  function _get_delivery_details_header_$ref_p6dcy3() {
    return constructCallableReference(function (p0) {
      return get_delivery_details_header(p0);
    }, 1, 0, 676);
  }
  function description$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9153, 0), new Long(35, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:description', 'description', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6839, 0), new Long(35, 0))]));
  }
  function design_studio$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9189, 0), new Long(61, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:design_studio', 'design_studio', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6875, 0), new Long(41, 0))]));
  }
  function _get_design_studio_$ref_1rqkt3() {
    return constructCallableReference(function (p0) {
      return get_design_studio(p0);
    }, 1, 0, 677);
  }
  function design_updated_cart$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9251, 0), new Long(91, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:design_updated_cart', 'design_updated_cart', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6917, 0), new Long(59, 0))]));
  }
  function _get_design_updated_cart_$ref_kb8rvf() {
    return constructCallableReference(function (p0) {
      return get_design_updated_cart(p0);
    }, 1, 0, 678);
  }
  function design_your_item$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9343, 0), new Long(48, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:design_your_item', 'design_your_item', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(6977, 0), new Long(48, 0))]));
  }
  function _get_design_your_item_$ref_z5v9ng() {
    return constructCallableReference(function (p0) {
      return get_design_your_item(p0);
    }, 1, 0, 679);
  }
  function discard_btn$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9392, 0), new Long(35, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:discard_btn', 'discard_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7026, 0), new Long(31, 0))]));
  }
  function _get_discard_btn_$ref_pcphgl() {
    return constructCallableReference(function (p0) {
      return get_discard_btn(p0);
    }, 1, 0, 680);
  }
  function discard_design_msg$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9428, 0), new Long(170, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:discard_design_msg', 'discard_design_msg', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7058, 0), new Long(134, 0))]));
  }
  function _get_discard_design_msg_$ref_sg08iv() {
    return constructCallableReference(function (p0) {
      return get_discard_design_msg(p0);
    }, 1, 0, 681);
  }
  function discard_design_title$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9599, 0), new Long(84, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:discard_design_title', 'discard_design_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7193, 0), new Long(48, 0))]));
  }
  function _get_discard_design_title_$ref_i0l5wi() {
    return constructCallableReference(function (p0) {
      return get_discard_design_title(p0);
    }, 1, 0, 682);
  }
  function discard_order_msg$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9684, 0), new Long(125, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:discard_order_msg', 'discard_order_msg', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7242, 0), new Long(101, 0))]));
  }
  function _get_discard_order_msg_$ref_8hj4a9() {
    return constructCallableReference(function (p0) {
      return get_discard_order_msg(p0);
    }, 1, 0, 683);
  }
  function discard_order_title$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9810, 0), new Long(79, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:discard_order_title', 'discard_order_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7344, 0), new Long(47, 0))]));
  }
  function _get_discard_order_title_$ref_661cna() {
    return constructCallableReference(function (p0) {
      return get_discard_order_title(p0);
    }, 1, 0, 684);
  }
  function done_btn$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9890, 0), new Long(24, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:done_btn', 'done_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7392, 0), new Long(24, 0))]));
  }
  function _get_done_btn_$ref_lno9yz() {
    return constructCallableReference(function (p0) {
      return get_done_btn(p0);
    }, 1, 0, 685);
  }
  function dont_have_account_hint$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9915, 0), new Long(66, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:dont_have_account_hint', 'dont_have_account_hint', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7417, 0), new Long(62, 0))]));
  }
  function _get_dont_have_account_hint_$ref_69c63s() {
    return constructCallableReference(function (p0) {
      return get_dont_have_account_hint(p0);
    }, 1, 0, 686);
  }
  function edit$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10425, 0), new Long(28, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:edit', 'edit', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7783, 0), new Long(20, 0))]));
  }
  function _get_edit_$ref_6wahw0() {
    return constructCallableReference(function (p0) {
      return get_edit(p0);
    }, 1, 0, 687);
  }
  function edit_design$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10042, 0), new Long(55, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:edit_design', 'edit_design', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7520, 0), new Long(35, 0))]));
  }
  function _get_edit_design_$ref_uyuur() {
    return constructCallableReference(function (p0) {
      return get_edit_design(p0);
    }, 1, 0, 688);
  }
  function edit_design_btn$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(9982, 0), new Long(59, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:edit_design_btn', 'edit_design_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7480, 0), new Long(39, 0))]));
  }
  function edit_friend_title$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10098, 0), new Long(57, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:edit_friend_title', 'edit_friend_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7556, 0), new Long(41, 0))]));
  }
  function _get_edit_friend_title_$ref_twxcgc() {
    return constructCallableReference(function (p0) {
      return get_edit_friend_title(p0);
    }, 1, 0, 689);
  }
  function edit_profile$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10156, 0), new Long(68, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:edit_profile', 'edit_profile', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7598, 0), new Long(36, 0))]));
  }
  function _get_edit_profile_$ref_oi56ii() {
    return constructCallableReference(function (p0) {
      return get_edit_profile(p0);
    }, 1, 0, 690);
  }
  function edit_text_place_holder$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10225, 0), new Long(90, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:edit_text_place_holder', 'edit_text_place_holder', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7635, 0), new Long(62, 0))]));
  }
  function _get_edit_text_place_holder_$ref_vyt50n() {
    return constructCallableReference(function (p0) {
      return get_edit_text_place_holder(p0);
    }, 1, 0, 691);
  }
  function edit_text_title$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10316, 0), new Long(51, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:edit_text_title', 'edit_text_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7698, 0), new Long(35, 0))]));
  }
  function _get_edit_text_title_$ref_qgt7ph() {
    return constructCallableReference(function (p0) {
      return get_edit_text_title(p0);
    }, 1, 0, 692);
  }
  function edit_your_design$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10368, 0), new Long(56, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:edit_your_design', 'edit_your_design', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7734, 0), new Long(48, 0))]));
  }
  function email_contact$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10454, 0), new Long(89, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:email_contact', 'email_contact', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7804, 0), new Long(41, 0))]));
  }
  function _get_email_contact_$ref_6rnrj1() {
    return constructCallableReference(function (p0) {
      return get_email_contact(p0);
    }, 1, 0, 693);
  }
  function email_label$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10544, 0), new Long(63, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:email_label', 'email_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7846, 0), new Long(27, 0))]));
  }
  function _get_email_label_$ref_m1g8pb() {
    return constructCallableReference(function (p0) {
      return get_email_label(p0);
    }, 1, 0, 694);
  }
  function email_verified_title$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10608, 0), new Long(80, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:email_verified_title', 'email_verified_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7874, 0), new Long(64, 0))]));
  }
  function enter_text_placeholder$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10689, 0), new Long(58, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:enter_text_placeholder', 'enter_text_placeholder', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7939, 0), new Long(50, 0))]));
  }
  function _get_enter_text_placeholder_$ref_xoiff6() {
    return constructCallableReference(function (p0) {
      return get_enter_text_placeholder(p0);
    }, 1, 0, 695);
  }
  function error_expired_link$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10748, 0), new Long(154, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:error_expired_link', 'error_expired_link', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(7990, 0), new Long(110, 0))]));
  }
  function error_invalid_email$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(10903, 0), new Long(103, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:error_invalid_email', 'error_invalid_email', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8101, 0), new Long(75, 0))]));
  }
  function error_loading_image$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11007, 0), new Long(75, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:error_loading_image', 'error_loading_image', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8177, 0), new Long(55, 0))]));
  }
  function exit_full_screen$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11083, 0), new Long(68, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:exit_full_screen', 'exit_full_screen', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8233, 0), new Long(48, 0))]));
  }
  function failed_add_to_cart$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11152, 0), new Long(90, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:failed_add_to_cart', 'failed_add_to_cart', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8282, 0), new Long(62, 0))]));
  }
  function _get_failed_add_to_cart_$ref_h6g3t6() {
    return constructCallableReference(function (p0) {
      return get_failed_add_to_cart(p0);
    }, 1, 0, 696);
  }
  function failed_load_product$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11334, 0), new Long(67, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:failed_load_product', 'failed_load_product', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8420, 0), new Long(59, 0))]));
  }
  function _get_failed_load_product_$ref_eq3l94() {
    return constructCallableReference(function (p0) {
      return get_failed_load_product(p0);
    }, 1, 0, 697);
  }
  function failed_load_product_design$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11243, 0), new Long(90, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:failed_load_product_design', 'failed_load_product_design', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8345, 0), new Long(74, 0))]));
  }
  function _get_failed_load_product_design_$ref_jzxgnp() {
    return constructCallableReference(function (p0) {
      return get_failed_load_product_design(p0);
    }, 1, 0, 698);
  }
  function failed_send_reset$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11402, 0), new Long(97, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:failed_send_reset', 'failed_send_reset', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8480, 0), new Long(61, 0))]));
  }
  function failed_to_save$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11500, 0), new Long(46, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:failed_to_save', 'failed_to_save', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8542, 0), new Long(42, 0))]));
  }
  function _get_failed_to_save_$ref_tm0wr() {
    return constructCallableReference(function (p0) {
      return get_failed_to_save(p0);
    }, 1, 0, 699);
  }
  function failed_to_update_password$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11547, 0), new Long(85, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:failed_to_update_password', 'failed_to_update_password', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8585, 0), new Long(69, 0))]));
  }
  function _get_failed_to_update_password_$ref_93xhv3() {
    return constructCallableReference(function (p0) {
      return get_failed_to_update_password(p0);
    }, 1, 0, 700);
  }
  function favorite_products$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11707, 0), new Long(69, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:favorite_products', 'favorite_products', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8709, 0), new Long(49, 0))]));
  }
  function _get_favorite_products_$ref_txyzcp() {
    return constructCallableReference(function (p0) {
      return get_favorite_products(p0);
    }, 1, 0, 701);
  }
  function favorite_products_btn$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11633, 0), new Long(73, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:favorite_products_btn', 'favorite_products_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8655, 0), new Long(53, 0))]));
  }
  function _get_favorite_products_btn_$ref_vd1c78() {
    return constructCallableReference(function (p0) {
      return get_favorite_products_btn(p0);
    }, 1, 0, 702);
  }
  function favorites_title$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11777, 0), new Long(67, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:favorites_title', 'favorites_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8759, 0), new Long(47, 0))]));
  }
  function _get_favorites_title_$ref_oe41kg() {
    return constructCallableReference(function (p0) {
      return get_favorites_title(p0);
    }, 1, 0, 703);
  }
  function fill_setting$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11845, 0), new Long(28, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:fill_setting', 'fill_setting', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8807, 0), new Long(28, 0))]));
  }
  function filter_all$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11874, 0), new Long(30, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:filter_all', 'filter_all', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8836, 0), new Long(22, 0))]));
  }
  function _get_filter_all_$ref_lgt9eo() {
    return constructCallableReference(function (p0) {
      return get_filter_all(p0);
    }, 1, 0, 704);
  }
  function filter_btn$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11905, 0), new Long(34, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:filter_btn', 'filter_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8859, 0), new Long(26, 0))]));
  }
  function _get_filter_btn_$ref_qlh539() {
    return constructCallableReference(function (p0) {
      return get_filter_btn(p0);
    }, 1, 0, 705);
  }
  function filter_grayscale$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:filter_grayscale', 'filter_grayscale', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8886, 0), new Long(36, 0))));
  }
  function filter_invert$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:filter_invert', 'filter_invert', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8923, 0), new Long(29, 0))));
  }
  function filter_none$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:filter_none', 'filter_none', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8953, 0), new Long(27, 0))));
  }
  function filter_orders$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11940, 0), new Long(41, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:filter_orders', 'filter_orders', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(8981, 0), new Long(29, 0))]));
  }
  function _get_filter_orders_$ref_pq7gzw() {
    return constructCallableReference(function (p0) {
      return get_filter_orders(p0);
    }, 1, 0, 706);
  }
  function filter_returns$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(11982, 0), new Long(42, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:filter_returns', 'filter_returns', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9011, 0), new Long(34, 0))]));
  }
  function _get_filter_returns_$ref_beet1a() {
    return constructCallableReference(function (p0) {
      return get_filter_returns(p0);
    }, 1, 0, 707);
  }
  function filter_sepia$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:filter_sepia', 'filter_sepia', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9046, 0), new Long(28, 0))));
  }
  function filters_label$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12025, 0), new Long(41, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:filters_label', 'filters_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9075, 0), new Long(33, 0))]));
  }
  function _get_filters_label_$ref_y402nk() {
    return constructCallableReference(function (p0) {
      return get_filters_label(p0);
    }, 1, 0, 708);
  }
  function first_name_label$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12067, 0), new Long(52, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:first_name_label', 'first_name_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9109, 0), new Long(40, 0))]));
  }
  function _get_first_name_label_$ref_8rgdij() {
    return constructCallableReference(function (p0) {
      return get_first_name_label(p0);
    }, 1, 0, 709);
  }
  function fit_setting$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12120, 0), new Long(35, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:fit_setting', 'fit_setting', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9150, 0), new Long(23, 0))]));
  }
  function flip_h$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12156, 0), new Long(34, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:flip_h', 'flip_h', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9174, 0), new Long(22, 0))]));
  }
  function flip_v$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12191, 0), new Long(34, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:flip_v', 'flip_v', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9197, 0), new Long(22, 0))]));
  }
  function font_cursive$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:font_cursive', 'font_cursive', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9220, 0), new Long(32, 0))));
  }
  function font_default$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:font_default', 'font_default', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9253, 0), new Long(32, 0))));
  }
  function font_monospace$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:font_monospace', 'font_monospace', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9286, 0), new Long(34, 0))));
  }
  function font_sans_serif$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:font_sans_serif', 'font_sans_serif', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9321, 0), new Long(39, 0))));
  }
  function font_serif$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:font_serif', 'font_serif', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9361, 0), new Long(26, 0))));
  }
  function font_setting$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12226, 0), new Long(32, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:font_setting', 'font_setting', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9388, 0), new Long(28, 0))]));
  }
  function _get_font_setting_$ref_hyv2ai() {
    return constructCallableReference(function (p0) {
      return get_font_setting(p0);
    }, 1, 0, 710);
  }
  function forgot_password$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12259, 0), new Long(75, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:forgot_password', 'forgot_password', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9417, 0), new Long(47, 0))]));
  }
  function _get_forgot_password_$ref_lc5efr() {
    return constructCallableReference(function (p0) {
      return get_forgot_password(p0);
    }, 1, 0, 711);
  }
  function free$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12335, 0), new Long(28, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:free', 'free', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9465, 0), new Long(20, 0))]));
  }
  function _get_free_$ref_gsmfgu() {
    return constructCallableReference(function (p0) {
      return get_free(p0);
    }, 1, 0, 712);
  }
  function friend$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12825, 0), new Long(26, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:friend', 'friend', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9847, 0), new Long(22, 0))]));
  }
  function friend_added_successfully$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12364, 0), new Long(89, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:friend_added_successfully', 'friend_added_successfully', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9486, 0), new Long(69, 0))]));
  }
  function _get_friend_added_successfully_$ref_6m13tz() {
    return constructCallableReference(function (p0) {
      return get_friend_added_successfully(p0);
    }, 1, 0, 713);
  }
  function friend_deleted_successfully$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12454, 0), new Long(83, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:friend_deleted_successfully', 'friend_deleted_successfully', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9556, 0), new Long(71, 0))]));
  }
  function _get_friend_deleted_successfully_$ref_eto71u() {
    return constructCallableReference(function (p0) {
      return get_friend_deleted_successfully(p0);
    }, 1, 0, 714);
  }
  function friend_pic_desc$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12538, 0), new Long(51, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:friend_pic_desc', 'friend_pic_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9628, 0), new Long(43, 0))]));
  }
  function _get_friend_pic_desc_$ref_47rnzt() {
    return constructCallableReference(function (p0) {
      return get_friend_pic_desc(p0);
    }, 1, 0, 715);
  }
  function friend_pic_selected_desc$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12590, 0), new Long(84, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:friend_pic_selected_desc', 'friend_pic_selected_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9672, 0), new Long(64, 0))]));
  }
  function _get_friend_pic_selected_desc_$ref_iijpdn() {
    return constructCallableReference(function (p0) {
      return get_friend_pic_selected_desc(p0);
    }, 1, 0, 716);
  }
  function friend_updated_successfully$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12675, 0), new Long(107, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:friend_updated_successfully', 'friend_updated_successfully', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9737, 0), new Long(71, 0))]));
  }
  function _get_friend_updated_successfully_$ref_s1hfpw() {
    return constructCallableReference(function (p0) {
      return get_friend_updated_successfully(p0);
    }, 1, 0, 717);
  }
  function friends_title$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12783, 0), new Long(41, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:friends_title', 'friends_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9809, 0), new Long(37, 0))]));
  }
  function _get_friends_title_$ref_me8vki() {
    return constructCallableReference(function (p0) {
      return get_friends_title(p0);
    }, 1, 0, 718);
  }
  function full_gallery$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12852, 0), new Long(56, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:full_gallery', 'full_gallery', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9870, 0), new Long(36, 0))]));
  }
  function _get_full_gallery_$ref_aji9ug() {
    return constructCallableReference(function (p0) {
      return get_full_gallery(p0);
    }, 1, 0, 719);
  }
  function full_wrap_label$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12909, 0), new Long(71, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:full_wrap_label', 'full_wrap_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9907, 0), new Long(55, 0))]));
  }
  function _get_full_wrap_label_$ref_jv4nm7() {
    return constructCallableReference(function (p0) {
      return get_full_wrap_label(p0);
    }, 1, 0, 720);
  }
  function gift_message_placeholder$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(12981, 0), new Long(132, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:gift_message_placeholder', 'gift_message_placeholder', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(9963, 0), new Long(96, 0))]));
  }
  function _get_gift_message_placeholder_$ref_lfblrm() {
    return constructCallableReference(function (p0) {
      return get_gift_message_placeholder(p0);
    }, 1, 0, 721);
  }
  function gift_wrapping_desc$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(13114, 0), new Long(78, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:gift_wrapping_desc', 'gift_wrapping_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10060, 0), new Long(70, 0))]));
  }
  function gift_wrapping_label$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(13193, 0), new Long(91, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:gift_wrapping_label', 'gift_wrapping_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10131, 0), new Long(55, 0))]));
  }
  function gifting_options_header$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(13285, 0), new Long(66, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:gifting_options_header', 'gifting_options_header', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10187, 0), new Long(50, 0))]));
  }
  function girls_gifts$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(13352, 0), new Long(51, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:girls_gifts', 'girls_gifts', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10238, 0), new Long(39, 0))]));
  }
  function _get_girls_gifts_$ref_lmd7yd() {
    return constructCallableReference(function (p0) {
      return get_girls_gifts(p0);
    }, 1, 0, 722);
  }
  function google_pay_label$delegate$lambda() {
    _init_properties_String1_commonMain_kt__z68bqm();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(13404, 0), new Long(44, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:google_pay_label', 'google_pay_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10278, 0), new Long(40, 0))]));
  }
  function _get_google_pay_label_$ref_9gue83() {
    return constructCallableReference(function (p0) {
      return get_google_pay_label(p0);
    }, 1, 0, 723);
  }
  var properties_initialized_String1_commonMain_kt_aj7ocs;
  function _init_properties_String1_commonMain_kt__z68bqm() {
    if (!properties_initialized_String1_commonMain_kt_aj7ocs) {
      properties_initialized_String1_commonMain_kt_aj7ocs = true;
      coupon_caution_message$delegate = lazy(coupon_caution_message$delegate$lambda);
      coupon_caution_title$delegate = lazy(coupon_caution_title$delegate$lambda);
      coupon_code_label$delegate = lazy(coupon_code_label$delegate$lambda);
      coupon_code_prefix$delegate = lazy(coupon_code_prefix$delegate$lambda);
      coupon_created_at$delegate = lazy(coupon_created_at$delegate$lambda);
      coupon_discount_prefix$delegate = lazy(coupon_discount_prefix$delegate$lambda);
      coupon_used_at$delegate = lazy(coupon_used_at$delegate$lambda);
      create_account$delegate = lazy(create_account$delegate$lambda);
      custom_products$delegate = lazy(custom_products$delegate$lambda);
      custom_products_only$delegate = lazy(custom_products_only$delegate$lambda);
      custom_text_placeholder$delegate = lazy(custom_text_placeholder$delegate$lambda);
      customize_btn$delegate = lazy(customize_btn$delegate$lambda);
      decrease_quantity_desc$delegate = lazy(decrease_quantity_desc$delegate$lambda);
      default_selection$delegate = lazy(default_selection$delegate$lambda);
      delete$delegate = lazy(delete$delegate$lambda);
      delete_account_btn$delegate = lazy(delete_account_btn$delegate$lambda);
      delete_account_confirm$delegate = lazy(delete_account_confirm$delegate$lambda);
      delete_account_failed$delegate = lazy(delete_account_failed$delegate$lambda);
      delete_account_success_message$delegate = lazy(delete_account_success_message$delegate$lambda);
      delete_account_success_title$delegate = lazy(delete_account_success_title$delegate$lambda);
      delete_friend_confirm_pattern$delegate = lazy(delete_friend_confirm_pattern$delegate$lambda);
      delete_friend_title$delegate = lazy(delete_friend_title$delegate$lambda);
      delete_image_desc$delegate = lazy(delete_image_desc$delegate$lambda);
      delete_image_title$delegate = lazy(delete_image_title$delegate$lambda);
      delete_with_google$delegate = lazy(delete_with_google$delegate$lambda);
      delivery_address_label$delegate = lazy(delivery_address_label$delegate$lambda);
      delivery_details_header$delegate = lazy(delivery_details_header$delegate$lambda);
      description$delegate = lazy(description$delegate$lambda);
      design_studio$delegate = lazy(design_studio$delegate$lambda);
      design_updated_cart$delegate = lazy(design_updated_cart$delegate$lambda);
      design_your_item$delegate = lazy(design_your_item$delegate$lambda);
      discard_btn$delegate = lazy(discard_btn$delegate$lambda);
      discard_design_msg$delegate = lazy(discard_design_msg$delegate$lambda);
      discard_design_title$delegate = lazy(discard_design_title$delegate$lambda);
      discard_order_msg$delegate = lazy(discard_order_msg$delegate$lambda);
      discard_order_title$delegate = lazy(discard_order_title$delegate$lambda);
      done_btn$delegate = lazy(done_btn$delegate$lambda);
      dont_have_account_hint$delegate = lazy(dont_have_account_hint$delegate$lambda);
      edit$delegate = lazy(edit$delegate$lambda);
      edit_design$delegate = lazy(edit_design$delegate$lambda);
      edit_design_btn$delegate = lazy(edit_design_btn$delegate$lambda);
      edit_friend_title$delegate = lazy(edit_friend_title$delegate$lambda);
      edit_profile$delegate = lazy(edit_profile$delegate$lambda);
      edit_text_place_holder$delegate = lazy(edit_text_place_holder$delegate$lambda);
      edit_text_title$delegate = lazy(edit_text_title$delegate$lambda);
      edit_your_design$delegate = lazy(edit_your_design$delegate$lambda);
      email_contact$delegate = lazy(email_contact$delegate$lambda);
      email_label$delegate = lazy(email_label$delegate$lambda);
      email_verified_title$delegate = lazy(email_verified_title$delegate$lambda);
      enter_text_placeholder$delegate = lazy(enter_text_placeholder$delegate$lambda);
      error_expired_link$delegate = lazy(error_expired_link$delegate$lambda);
      error_invalid_email$delegate = lazy(error_invalid_email$delegate$lambda);
      error_loading_image$delegate = lazy(error_loading_image$delegate$lambda);
      exit_full_screen$delegate = lazy(exit_full_screen$delegate$lambda);
      failed_add_to_cart$delegate = lazy(failed_add_to_cart$delegate$lambda);
      failed_load_product$delegate = lazy(failed_load_product$delegate$lambda);
      failed_load_product_design$delegate = lazy(failed_load_product_design$delegate$lambda);
      failed_send_reset$delegate = lazy(failed_send_reset$delegate$lambda);
      failed_to_save$delegate = lazy(failed_to_save$delegate$lambda);
      failed_to_update_password$delegate = lazy(failed_to_update_password$delegate$lambda);
      favorite_products$delegate = lazy(favorite_products$delegate$lambda);
      favorite_products_btn$delegate = lazy(favorite_products_btn$delegate$lambda);
      favorites_title$delegate = lazy(favorites_title$delegate$lambda);
      fill_setting$delegate = lazy(fill_setting$delegate$lambda);
      filter_all$delegate = lazy(filter_all$delegate$lambda);
      filter_btn$delegate = lazy(filter_btn$delegate$lambda);
      filter_grayscale$delegate = lazy(filter_grayscale$delegate$lambda);
      filter_invert$delegate = lazy(filter_invert$delegate$lambda);
      filter_none$delegate = lazy(filter_none$delegate$lambda);
      filter_orders$delegate = lazy(filter_orders$delegate$lambda);
      filter_returns$delegate = lazy(filter_returns$delegate$lambda);
      filter_sepia$delegate = lazy(filter_sepia$delegate$lambda);
      filters_label$delegate = lazy(filters_label$delegate$lambda);
      first_name_label$delegate = lazy(first_name_label$delegate$lambda);
      fit_setting$delegate = lazy(fit_setting$delegate$lambda);
      flip_h$delegate = lazy(flip_h$delegate$lambda);
      flip_v$delegate = lazy(flip_v$delegate$lambda);
      font_cursive$delegate = lazy(font_cursive$delegate$lambda);
      font_default$delegate = lazy(font_default$delegate$lambda);
      font_monospace$delegate = lazy(font_monospace$delegate$lambda);
      font_sans_serif$delegate = lazy(font_sans_serif$delegate$lambda);
      font_serif$delegate = lazy(font_serif$delegate$lambda);
      font_setting$delegate = lazy(font_setting$delegate$lambda);
      forgot_password$delegate = lazy(forgot_password$delegate$lambda);
      free$delegate = lazy(free$delegate$lambda);
      friend$delegate = lazy(friend$delegate$lambda);
      friend_added_successfully$delegate = lazy(friend_added_successfully$delegate$lambda);
      friend_deleted_successfully$delegate = lazy(friend_deleted_successfully$delegate$lambda);
      friend_pic_desc$delegate = lazy(friend_pic_desc$delegate$lambda);
      friend_pic_selected_desc$delegate = lazy(friend_pic_selected_desc$delegate$lambda);
      friend_updated_successfully$delegate = lazy(friend_updated_successfully$delegate$lambda);
      friends_title$delegate = lazy(friends_title$delegate$lambda);
      full_gallery$delegate = lazy(full_gallery$delegate$lambda);
      full_wrap_label$delegate = lazy(full_wrap_label$delegate$lambda);
      gift_message_placeholder$delegate = lazy(gift_message_placeholder$delegate$lambda);
      gift_wrapping_desc$delegate = lazy(gift_wrapping_desc$delegate$lambda);
      gift_wrapping_label$delegate = lazy(gift_wrapping_label$delegate$lambda);
      gifting_options_header$delegate = lazy(gifting_options_header$delegate$lambda);
      girls_gifts$delegate = lazy(girls_gifts$delegate$lambda);
      google_pay_label$delegate = lazy(google_pay_label$delegate$lambda);
    }
  }
  function get_gradient_end(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = gradient_end$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('gradient_end', 1, tmp, _get_gradient_end_$ref_a6ds7m(), null);
    return tmp0.u1();
  }
  var gradient_end$delegate;
  function get_gradient_start(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = gradient_start$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('gradient_start', 1, tmp, _get_gradient_start_$ref_dms24n(), null);
    return tmp0.u1();
  }
  var gradient_start$delegate;
  function get_height_label(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = height_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('height_label', 1, tmp, _get_height_label_$ref_x7iv6m(), null);
    return tmp0.u1();
  }
  var height_label$delegate;
  function get_hide_password(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = hide_password$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('hide_password', 1, tmp, _get_hide_password_$ref_d145k(), null);
    return tmp0.u1();
  }
  var hide_password$delegate;
  function get_image_settings(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = image_settings$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('image_settings', 1, tmp, _get_image_settings_$ref_6ptlm5(), null);
    return tmp0.u1();
  }
  var image_settings$delegate;
  function get_in_stock_pattern(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = in_stock_pattern$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('in_stock_pattern', 1, tmp, _get_in_stock_pattern_$ref_sopdv7(), null);
    return tmp0.u1();
  }
  var in_stock_pattern$delegate;
  function get_increase_quantity_desc(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = increase_quantity_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('increase_quantity_desc', 1, tmp, _get_increase_quantity_desc_$ref_philu6(), null);
    return tmp0.u1();
  }
  var increase_quantity_desc$delegate;
  var information_is_loaded_from_your_profile_To_change_it_please_go_to_your_profile_settings$delegate;
  function get_instapay(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = instapay$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('instapay', 1, tmp, _get_instapay_$ref_a1tht9(), null);
    return tmp0.u1();
  }
  var instapay$delegate;
  var interactive_3d_preview$delegate;
  function get_invalid_birthday_date(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = invalid_birthday_date$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('invalid_birthday_date', 1, tmp, _get_invalid_birthday_date_$ref_xyxl7s(), null);
    return tmp0.u1();
  }
  var invalid_birthday_date$delegate;
  function get_invalid_birthday_format(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = invalid_birthday_format$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('invalid_birthday_format', 1, tmp, _get_invalid_birthday_format_$ref_gft029(), null);
    return tmp0.u1();
  }
  var invalid_birthday_format$delegate;
  function get_invalid_coupon_error(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = invalid_coupon_error$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('invalid_coupon_error', 1, tmp, _get_invalid_coupon_error_$ref_sq94v1(), null);
    return tmp0.u1();
  }
  var invalid_coupon_error$delegate;
  function get_invalid_credentials(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = invalid_credentials$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('invalid_credentials', 1, tmp, _get_invalid_credentials_$ref_twz8z8(), null);
    return tmp0.u1();
  }
  var invalid_credentials$delegate;
  function get_invalid_email_format(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = invalid_email_format$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('invalid_email_format', 1, tmp, _get_invalid_email_format_$ref_jestag(), null);
    return tmp0.u1();
  }
  var invalid_email_format$delegate;
  function get_invalid_format_use_yyyy_mm_dd(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = invalid_format_use_yyyy_mm_dd$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('invalid_format_use_yyyy_mm_dd', 1, tmp, _get_invalid_format_use_yyyy_mm_dd_$ref_smwwqw(), null);
    return tmp0.u1();
  }
  var invalid_format_use_yyyy_mm_dd$delegate;
  function get_invalid_phone_format(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = invalid_phone_format$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('invalid_phone_format', 1, tmp, _get_invalid_phone_format_$ref_t2fa0m(), null);
    return tmp0.u1();
  }
  var invalid_phone_format$delegate;
  function get_invalid_phone_number_format(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = invalid_phone_number_format$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('invalid_phone_number_format', 1, tmp, _get_invalid_phone_number_format_$ref_tllyvo(), null);
    return tmp0.u1();
  }
  var invalid_phone_number_format$delegate;
  function get_invalid_phone_personal(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = invalid_phone_personal$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('invalid_phone_personal', 1, tmp, _get_invalid_phone_personal_$ref_abmsdb(), null);
    return tmp0.u1();
  }
  var invalid_phone_personal$delegate;
  function get_invalid_phone_work(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = invalid_phone_work$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('invalid_phone_work', 1, tmp, _get_invalid_phone_work_$ref_jq833k(), null);
    return tmp0.u1();
  }
  var invalid_phone_work$delegate;
  function get_keep_login_label(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = keep_login_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('keep_login_label', 1, tmp, _get_keep_login_label_$ref_21yjme(), null);
    return tmp0.u1();
  }
  var keep_login_label$delegate;
  function get_kids_label(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = kids_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('kids_label', 1, tmp, _get_kids_label_$ref_xtnkbc(), null);
    return tmp0.u1();
  }
  var kids_label$delegate;
  function get_lang_ar(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = lang_ar$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('lang_ar', 1, tmp, _get_lang_ar_$ref_2iwmu6(), null);
    return tmp0.u1();
  }
  var lang_ar$delegate;
  function get_lang_en(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = lang_en$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('lang_en', 1, tmp, _get_lang_en_$ref_bosrtm(), null);
    return tmp0.u1();
  }
  var lang_en$delegate;
  function get_language_arabic(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = language_arabic$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('language_arabic', 1, tmp, _get_language_arabic_$ref_971r0z(), null);
    return tmp0.u1();
  }
  var language_arabic$delegate;
  function get_language_english(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = language_english$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('language_english', 1, tmp, _get_language_english_$ref_7w9ynj(), null);
    return tmp0.u1();
  }
  var language_english$delegate;
  function get_last_name_label(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = last_name_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('last_name_label', 1, tmp, _get_last_name_label_$ref_niiquh(), null);
    return tmp0.u1();
  }
  var last_name_label$delegate;
  function get_location_lat_long_label(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = location_lat_long_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('location_lat_long_label', 1, tmp, _get_location_lat_long_label_$ref_x05q4l(), null);
    return tmp0.u1();
  }
  var location_lat_long_label$delegate;
  function get_login(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = login$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('login', 1, tmp, _get_login_$ref_jyg3g7(), null);
    return tmp0.u1();
  }
  var login$delegate;
  function get_login_btn(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = login_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('login_btn', 1, tmp, _get_login_btn_$ref_wwzshm(), null);
    return tmp0.u1();
  }
  var login_btn$delegate;
  var login_failed$delegate;
  var login_required_details$delegate;
  function get_login_required_profile(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = login_required_profile$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('login_required_profile', 1, tmp, _get_login_required_profile_$ref_sn6bet(), null);
    return tmp0.u1();
  }
  var login_required_profile$delegate;
  function get_login_with_google(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = login_with_google$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('login_with_google', 1, tmp, _get_login_with_google_$ref_vlw6kk(), null);
    return tmp0.u1();
  }
  var login_with_google$delegate;
  function get_logo_0(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = logo$delegate_0;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('logo', 1, tmp, _get_logo_$ref_1uc64x_0(), null);
    return tmp0.u1();
  }
  var logo$delegate_0;
  function get_logout_btn(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = logout_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('logout_btn', 1, tmp, _get_logout_btn_$ref_crtxrn(), null);
    return tmp0.u1();
  }
  var logout_btn$delegate;
  var manage_friends_btn$delegate;
  function get_mastercard_label(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = mastercard_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('mastercard_label', 1, tmp, _get_mastercard_label_$ref_tma2j1(), null);
    return tmp0.u1();
  }
  var mastercard_label$delegate;
  function get_max_price_label(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = max_price_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('max_price_label', 1, tmp, _get_max_price_label_$ref_5mi37n(), null);
    return tmp0.u1();
  }
  var max_price_label$delegate;
  function get_men_s_gifts(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = men_s_gifts$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('men_s_gifts', 1, tmp, _get_men_s_gifts_$ref_w8qa1a(), null);
    return tmp0.u1();
  }
  var men_s_gifts$delegate;
  function get_message_label(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = message_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('message_label', 1, tmp, _get_message_label_$ref_hyftvo(), null);
    return tmp0.u1();
  }
  var message_label$delegate;
  function get_min_price_label(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = min_price_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('min_price_label', 1, tmp, _get_min_price_label_$ref_nhin01(), null);
    return tmp0.u1();
  }
  var min_price_label$delegate;
  var minimalist_white$delegate;
  function get_mug_designer_title(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = mug_designer_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('mug_designer_title', 1, tmp, _get_mug_designer_title_$ref_itezuy(), null);
    return tmp0.u1();
  }
  var mug_designer_title$delegate;
  function get_mug_interactive_engine(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = mug_interactive_engine$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('mug_interactive_engine', 1, tmp, _get_mug_interactive_engine_$ref_kii1gl(), null);
    return tmp0.u1();
  }
  var mug_interactive_engine$delegate;
  function get_mug_size(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = mug_size$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('mug_size', 1, tmp, _get_mug_size_$ref_mx57s7(), null);
    return tmp0.u1();
  }
  var mug_size$delegate;
  function get_mug_size_11_oz(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = mug_size_11_oz$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('mug_size_11_oz', 1, tmp, _get_mug_size_11_oz_$ref_rxlyha(), null);
    return tmp0.u1();
  }
  var mug_size_11_oz$delegate;
  function get_mug_size_15_oz(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = mug_size_15_oz$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('mug_size_15_oz', 1, tmp, _get_mug_size_15_oz_$ref_klq2pa(), null);
    return tmp0.u1();
  }
  var mug_size_15_oz$delegate;
  function get_mug_size_20_oz(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = mug_size_20_oz$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('mug_size_20_oz', 1, tmp, _get_mug_size_20_oz_$ref_gge1hw(), null);
    return tmp0.u1();
  }
  var mug_size_20_oz$delegate;
  var mug_viewer$delegate;
  function get_my_coupons_title(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = my_coupons_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('my_coupons_title', 1, tmp, _get_my_coupons_title_$ref_tolj5l(), null);
    return tmp0.u1();
  }
  var my_coupons_title$delegate;
  function get_name_label_required(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = name_label_required$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('name_label_required', 1, tmp, _get_name_label_required_$ref_3ripry(), null);
    return tmp0.u1();
  }
  var name_label_required$delegate;
  function get_nav_cart(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = nav_cart$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('nav_cart', 1, tmp, _get_nav_cart_$ref_npwc8y(), null);
    return tmp0.u1();
  }
  var nav_cart$delegate;
  function get_nav_profile(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = nav_profile$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('nav_profile', 1, tmp, _get_nav_profile_$ref_t2w237(), null);
    return tmp0.u1();
  }
  var nav_profile$delegate;
  function get_nav_shop(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = nav_shop$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('nav_shop', 1, tmp, _get_nav_shop_$ref_8zvk6g(), null);
    return tmp0.u1();
  }
  var nav_shop$delegate;
  function get_neighbourhood_label(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = neighbourhood_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('neighbourhood_label', 1, tmp, _get_neighbourhood_label_$ref_bgqrpu(), null);
    return tmp0.u1();
  }
  var neighbourhood_label$delegate;
  function get_network_error(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = network_error$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('network_error', 1, tmp, _get_network_error_$ref_aj2uxj(), null);
    return tmp0.u1();
  }
  var network_error$delegate;
  function get_new_password_label(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = new_password_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('new_password_label', 1, tmp, _get_new_password_label_$ref_8u0zv(), null);
    return tmp0.u1();
  }
  var new_password_label$delegate;
  function get_no_coupons_found(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = no_coupons_found$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('no_coupons_found', 1, tmp, _get_no_coupons_found_$ref_yq1ie0(), null);
    return tmp0.u1();
  }
  var no_coupons_found$delegate;
  function get_no_description(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = no_description$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('no_description', 1, tmp, _get_no_description_$ref_4bxr5o(), null);
    return tmp0.u1();
  }
  var no_description$delegate;
  function get_no_favorites_yet(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = no_favorites_yet$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('no_favorites_yet', 1, tmp, _get_no_favorites_yet_$ref_vzb4ag(), null);
    return tmp0.u1();
  }
  var no_favorites_yet$delegate;
  var no_friends_saved$delegate;
  function get_no_friends_yet(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = no_friends_yet$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('no_friends_yet', 1, tmp, _get_no_friends_yet_$ref_uwzarq(), null);
    return tmp0.u1();
  }
  var no_friends_yet$delegate;
  function get_no_internet_connection(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = no_internet_connection$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('no_internet_connection', 1, tmp, _get_no_internet_connection_$ref_ek8oo4(), null);
    return tmp0.u1();
  }
  var no_internet_connection$delegate;
  function get_no_internet_custom_mug(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = no_internet_custom_mug$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('no_internet_custom_mug', 1, tmp, _get_no_internet_custom_mug_$ref_49vcif(), null);
    return tmp0.u1();
  }
  var no_internet_custom_mug$delegate;
  function get_no_orders_found(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = no_orders_found$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('no_orders_found', 1, tmp, _get_no_orders_found_$ref_x7qvqe(), null);
    return tmp0.u1();
  }
  var no_orders_found$delegate;
  var no_products_found$delegate;
  function get_no_reminders_yet(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = no_reminders_yet$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('no_reminders_yet', 1, tmp, _get_no_reminders_yet_$ref_detrn6(), null);
    return tmp0.u1();
  }
  var no_reminders_yet$delegate;
  var no_search_results$delegate;
  var no_text_error$delegate;
  function get_not_available(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = not_available$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('not_available', 1, tmp, _get_not_available_$ref_7d22v7(), null);
    return tmp0.u1();
  }
  var not_available$delegate;
  function get_not_set(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = not_set$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('not_set', 1, tmp, _get_not_set_$ref_kaz9l6(), null);
    return tmp0.u1();
  }
  var not_set$delegate;
  var notification_channel_description$delegate;
  var notification_channel_name$delegate;
  function get_notification_new_order_body(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = notification_new_order_body$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('notification_new_order_body', 1, tmp, _get_notification_new_order_body_$ref_llcet6(), null);
    return tmp0.u1();
  }
  var notification_new_order_body$delegate;
  function get_notification_new_order_title(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = notification_new_order_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('notification_new_order_title', 1, tmp, _get_notification_new_order_title_$ref_dy6xl2(), null);
    return tmp0.u1();
  }
  var notification_new_order_title$delegate;
  function get_notification_return_requested_body(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = notification_return_requested_body$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('notification_return_requested_body', 1, tmp, _get_notification_return_requested_body_$ref_4s96bw(), null);
    return tmp0.u1();
  }
  var notification_return_requested_body$delegate;
  function get_notification_return_requested_title(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = notification_return_requested_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('notification_return_requested_title', 1, tmp, _get_notification_return_requested_title_$ref_9vszgs(), null);
    return tmp0.u1();
  }
  var notification_return_requested_title$delegate;
  function get_ok(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = ok$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ok', 1, tmp, _get_ok_$ref_dwl57i(), null);
    return tmp0.u1();
  }
  var ok$delegate;
  function get_old_label(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = old_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('old_label', 1, tmp, _get_old_label_$ref_w9alr0(), null);
    return tmp0.u1();
  }
  var old_label$delegate;
  var options_label$delegate;
  function get_or_label(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = or_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('or_label', 1, tmp, _get_or_label_$ref_p8wlsu(), null);
    return tmp0.u1();
  }
  var or_label$delegate;
  function get_order_details_title(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_details_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_details_title', 1, tmp, _get_order_details_title_$ref_1otnl6(), null);
    return tmp0.u1();
  }
  var order_details_title$delegate;
  function get_order_discount(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_discount$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_discount', 1, tmp, _get_order_discount_$ref_tvyh7s(), null);
    return tmp0.u1();
  }
  var order_discount$delegate;
  function get_order_execution_disclaimer(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_execution_disclaimer$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_execution_disclaimer', 1, tmp, _get_order_execution_disclaimer_$ref_svchi1(), null);
    return tmp0.u1();
  }
  var order_execution_disclaimer$delegate;
  var order_history_btn$delegate;
  function get_order_history_title(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_history_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_history_title', 1, tmp, _get_order_history_title_$ref_bdgfyc(), null);
    return tmp0.u1();
  }
  var order_history_title$delegate;
  function get_order_id_prefix_pattern(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_id_prefix_pattern$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_id_prefix_pattern', 1, tmp, _get_order_id_prefix_pattern_$ref_95ei5m(), null);
    return tmp0.u1();
  }
  var order_id_prefix_pattern$delegate;
  function get_order_items_count_pattern(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_items_count_pattern$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_items_count_pattern', 1, tmp, _get_order_items_count_pattern_$ref_jam9lc(), null);
    return tmp0.u1();
  }
  var order_items_count_pattern$delegate;
  var order_placed_success_desc$delegate;
  function get_order_placed_title(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_placed_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_placed_title', 1, tmp, _get_order_placed_title_$ref_8xyo1f(), null);
    return tmp0.u1();
  }
  var order_placed_title$delegate;
  function get_order_quantity_pattern(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_quantity_pattern$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_quantity_pattern', 1, tmp, _get_order_quantity_pattern_$ref_bb9qel(), null);
    return tmp0.u1();
  }
  var order_quantity_pattern$delegate;
  function get_order_shipping_cost(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_shipping_cost$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_shipping_cost', 1, tmp, _get_order_shipping_cost_$ref_76m1rh(), null);
    return tmp0.u1();
  }
  var order_shipping_cost$delegate;
  function get_order_status_archived(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_status_archived$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_status_archived', 1, tmp, _get_order_status_archived_$ref_34qeea(), null);
    return tmp0.u1();
  }
  var order_status_archived$delegate;
  function get_order_status_completed(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_status_completed$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_status_completed', 1, tmp, _get_order_status_completed_$ref_a2ls8l(), null);
    return tmp0.u1();
  }
  var order_status_completed$delegate;
  function get_order_status_failed(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_status_failed$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_status_failed', 1, tmp, _get_order_status_failed_$ref_7acqc9(), null);
    return tmp0.u1();
  }
  var order_status_failed$delegate;
  function get_order_status_money_returned(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_status_money_returned$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_status_money_returned', 1, tmp, _get_order_status_money_returned_$ref_w6711y(), null);
    return tmp0.u1();
  }
  var order_status_money_returned$delegate;
  function get_order_status_on_the_way(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_status_on_the_way$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_status_on_the_way', 1, tmp, _get_order_status_on_the_way_$ref_s4tbdp(), null);
    return tmp0.u1();
  }
  var order_status_on_the_way$delegate;
  function get_order_status_preparing(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_status_preparing$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_status_preparing', 1, tmp, _get_order_status_preparing_$ref_nj2h0y(), null);
    return tmp0.u1();
  }
  var order_status_preparing$delegate;
  function get_order_status_received(_this__u8e3s4) {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp0 = order_status_received$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_status_received', 1, tmp, _get_order_status_received_$ref_qbvl19(), null);
    return tmp0.u1();
  }
  var order_status_received$delegate;
  function gradient_end$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(13449, 0), new Long(52, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:gradient_end', 'gradient_end', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10319, 0), new Long(36, 0))]));
  }
  function _get_gradient_end_$ref_a6ds7m() {
    return constructCallableReference(function (p0) {
      return get_gradient_end(p0);
    }, 1, 0, 724);
  }
  function gradient_start$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(13502, 0), new Long(54, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:gradient_start', 'gradient_start', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10356, 0), new Long(42, 0))]));
  }
  function _get_gradient_start_$ref_dms24n() {
    return constructCallableReference(function (p0) {
      return get_gradient_start(p0);
    }, 1, 0, 725);
  }
  function height_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(13557, 0), new Long(36, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:height_label', 'height_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10399, 0), new Long(28, 0))]));
  }
  function _get_height_label_$ref_x7iv6m() {
    return constructCallableReference(function (p0) {
      return get_height_label(p0);
    }, 1, 0, 726);
  }
  function hide_password$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(13594, 0), new Long(65, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:hide_password', 'hide_password', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10428, 0), new Long(41, 0))]));
  }
  function _get_hide_password_$ref_d145k() {
    return constructCallableReference(function (p0) {
      return get_hide_password(p0);
    }, 1, 0, 727);
  }
  function image_settings$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:image_settings', 'image_settings', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10470, 0), new Long(42, 0))));
  }
  function _get_image_settings_$ref_6ptlm5() {
    return constructCallableReference(function (p0) {
      return get_image_settings(p0);
    }, 1, 0, 728);
  }
  function in_stock_pattern$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(13660, 0), new Long(60, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:in_stock_pattern', 'in_stock_pattern', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10513, 0), new Long(60, 0))]));
  }
  function _get_in_stock_pattern_$ref_sopdv7() {
    return constructCallableReference(function (p0) {
      return get_in_stock_pattern(p0);
    }, 1, 0, 729);
  }
  function increase_quantity_desc$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(13721, 0), new Long(62, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:increase_quantity_desc', 'increase_quantity_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10574, 0), new Long(42, 0))]));
  }
  function _get_increase_quantity_desc_$ref_philu6() {
    return constructCallableReference(function (p0) {
      return get_increase_quantity_desc(p0);
    }, 1, 0, 730);
  }
  function information_is_loaded_from_your_profile_To_change_it_please_go_to_your_profile_settings$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(13784, 0), new Long(299, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:information_is_loaded_from_your_profile_To_change_it_please_go_to_your_profile_settings', 'information_is_loaded_from_your_profile_To_change_it_please_go_to_your_profile_settings', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10617, 0), new Long(215, 0))]));
  }
  function instapay$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(14084, 0), new Long(40, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:instapay', 'instapay', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10833, 0), new Long(28, 0))]));
  }
  function _get_instapay_$ref_a1tht9() {
    return constructCallableReference(function (p0) {
      return get_instapay(p0);
    }, 1, 0, 731);
  }
  function interactive_3d_preview$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(14125, 0), new Long(106, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:interactive_3d_preview', 'interactive_3d_preview', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10862, 0), new Long(62, 0))]));
  }
  function invalid_birthday_date$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(14232, 0), new Long(89, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:invalid_birthday_date', 'invalid_birthday_date', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10925, 0), new Long(65, 0))]));
  }
  function _get_invalid_birthday_date_$ref_xyxl7s() {
    return constructCallableReference(function (p0) {
      return get_invalid_birthday_date(p0);
    }, 1, 0, 732);
  }
  function invalid_birthday_format$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(14322, 0), new Long(151, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:invalid_birthday_format', 'invalid_birthday_format', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(10991, 0), new Long(95, 0))]));
  }
  function _get_invalid_birthday_format_$ref_gft029() {
    return constructCallableReference(function (p0) {
      return get_invalid_birthday_format(p0);
    }, 1, 0, 733);
  }
  function invalid_coupon_error$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(14474, 0), new Long(116, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:invalid_coupon_error', 'invalid_coupon_error', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11087, 0), new Long(64, 0))]));
  }
  function _get_invalid_coupon_error_$ref_sq94v1() {
    return constructCallableReference(function (p0) {
      return get_invalid_coupon_error(p0);
    }, 1, 0, 734);
  }
  function invalid_credentials$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(14591, 0), new Long(135, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:invalid_credentials', 'invalid_credentials', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11152, 0), new Long(63, 0))]));
  }
  function _get_invalid_credentials_$ref_twz8z8() {
    return constructCallableReference(function (p0) {
      return get_invalid_credentials(p0);
    }, 1, 0, 735);
  }
  function invalid_email_format$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(14727, 0), new Long(104, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:invalid_email_format', 'invalid_email_format', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11216, 0), new Long(76, 0))]));
  }
  function _get_invalid_email_format_$ref_jestag() {
    return constructCallableReference(function (p0) {
      return get_invalid_email_format(p0);
    }, 1, 0, 736);
  }
  function invalid_format_use_yyyy_mm_dd$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(14832, 0), new Long(105, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:invalid_format_use_yyyy_mm_dd', 'invalid_format_use_yyyy_mm_dd', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11293, 0), new Long(77, 0))]));
  }
  function _get_invalid_format_use_yyyy_mm_dd_$ref_smwwqw() {
    return constructCallableReference(function (p0) {
      return get_invalid_format_use_yyyy_mm_dd(p0);
    }, 1, 0, 737);
  }
  function invalid_phone_format$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(14938, 0), new Long(92, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:invalid_phone_format', 'invalid_phone_format', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11371, 0), new Long(56, 0))]));
  }
  function _get_invalid_phone_format_$ref_t2fa0m() {
    return constructCallableReference(function (p0) {
      return get_invalid_phone_format(p0);
    }, 1, 0, 738);
  }
  function invalid_phone_number_format$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(15031, 0), new Long(99, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:invalid_phone_number_format', 'invalid_phone_number_format', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11428, 0), new Long(71, 0))]));
  }
  function _get_invalid_phone_number_format_$ref_tllyvo() {
    return constructCallableReference(function (p0) {
      return get_invalid_phone_number_format(p0);
    }, 1, 0, 739);
  }
  function invalid_phone_personal$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(15131, 0), new Long(98, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:invalid_phone_personal', 'invalid_phone_personal', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11500, 0), new Long(70, 0))]));
  }
  function _get_invalid_phone_personal_$ref_abmsdb() {
    return constructCallableReference(function (p0) {
      return get_invalid_phone_personal(p0);
    }, 1, 0, 740);
  }
  function invalid_phone_work$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(15230, 0), new Long(86, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:invalid_phone_work', 'invalid_phone_work', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11571, 0), new Long(62, 0))]));
  }
  function _get_invalid_phone_work_$ref_jq833k() {
    return constructCallableReference(function (p0) {
      return get_invalid_phone_work(p0);
    }, 1, 0, 741);
  }
  function keep_login_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(15317, 0), new Long(60, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:keep_login_label', 'keep_login_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11634, 0), new Long(48, 0))]));
  }
  function _get_keep_login_label_$ref_21yjme() {
    return constructCallableReference(function (p0) {
      return get_keep_login_label(p0);
    }, 1, 0, 742);
  }
  function kids_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(15378, 0), new Long(54, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:kids_label', 'kids_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11683, 0), new Long(42, 0))]));
  }
  function _get_kids_label_$ref_xtnkbc() {
    return constructCallableReference(function (p0) {
      return get_kids_label(p0);
    }, 1, 0, 743);
  }
  function lang_ar$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(15433, 0), new Long(19, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:lang_ar', 'lang_ar', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11726, 0), new Long(19, 0))]));
  }
  function _get_lang_ar_$ref_2iwmu6() {
    return constructCallableReference(function (p0) {
      return get_lang_ar(p0);
    }, 1, 0, 744);
  }
  function lang_en$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(15453, 0), new Long(19, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:lang_en', 'lang_en', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11746, 0), new Long(19, 0))]));
  }
  function _get_lang_en_$ref_bosrtm() {
    return constructCallableReference(function (p0) {
      return get_lang_en(p0);
    }, 1, 0, 745);
  }
  function language_arabic$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:language_arabic', 'language_arabic', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11766, 0), new Long(31, 0))));
  }
  function _get_language_arabic_$ref_971r0z() {
    return constructCallableReference(function (p0) {
      return get_language_arabic(p0);
    }, 1, 0, 746);
  }
  function language_english$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:language_english', 'language_english', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11798, 0), new Long(36, 0))));
  }
  function _get_language_english_$ref_7w9ynj() {
    return constructCallableReference(function (p0) {
      return get_language_english(p0);
    }, 1, 0, 747);
  }
  function last_name_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(15473, 0), new Long(51, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:last_name_label', 'last_name_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11835, 0), new Long(35, 0))]));
  }
  function _get_last_name_label_$ref_niiquh() {
    return constructCallableReference(function (p0) {
      return get_last_name_label(p0);
    }, 1, 0, 748);
  }
  function location_lat_long_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(15525, 0), new Long(95, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:location_lat_long_label', 'location_lat_long_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11871, 0), new Long(59, 0))]));
  }
  function _get_location_lat_long_label_$ref_x05q4l() {
    return constructCallableReference(function (p0) {
      return get_location_lat_long_label(p0);
    }, 1, 0, 749);
  }
  function login$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16160, 0), new Long(45, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:login', 'login', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12274, 0), new Long(21, 0))]));
  }
  function _get_login_$ref_jyg3g7() {
    return constructCallableReference(function (p0) {
      return get_login(p0);
    }, 1, 0, 750);
  }
  function login_btn$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(15621, 0), new Long(49, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:login_btn', 'login_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11931, 0), new Long(25, 0))]));
  }
  function _get_login_btn_$ref_wwzshm() {
    return constructCallableReference(function (p0) {
      return get_login_btn(p0);
    }, 1, 0, 751);
  }
  function login_failed$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(15671, 0), new Long(120, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:login_failed', 'login_failed', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(11957, 0), new Long(80, 0))]));
  }
  function login_required_details$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(15792, 0), new Long(138, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:login_required_details', 'login_required_details', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12038, 0), new Long(74, 0))]));
  }
  function login_required_profile$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(15931, 0), new Long(154, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:login_required_profile', 'login_required_profile', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12113, 0), new Long(110, 0))]));
  }
  function _get_login_required_profile_$ref_sn6bet() {
    return constructCallableReference(function (p0) {
      return get_login_required_profile(p0);
    }, 1, 0, 752);
  }
  function login_with_google$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16086, 0), new Long(73, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:login_with_google', 'login_with_google', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12224, 0), new Long(49, 0))]));
  }
  function _get_login_with_google_$ref_vlw6kk() {
    return constructCallableReference(function (p0) {
      return get_login_with_google(p0);
    }, 1, 0, 753);
  }
  function logo$delegate$lambda_0() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16257, 0), new Long(28, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:logo', 'logo', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12323, 0), new Long(20, 0))]));
  }
  function _get_logo_$ref_1uc64x_0() {
    return constructCallableReference(function (p0) {
      return get_logo_0(p0);
    }, 1, 0, 754);
  }
  function logout_btn$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16206, 0), new Long(50, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:logout_btn', 'logout_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12296, 0), new Long(26, 0))]));
  }
  function _get_logout_btn_$ref_crtxrn() {
    return constructCallableReference(function (p0) {
      return get_logout_btn(p0);
    }, 1, 0, 755);
  }
  function manage_friends_btn$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16286, 0), new Long(62, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:manage_friends_btn', 'manage_friends_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12344, 0), new Long(46, 0))]));
  }
  function mastercard_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16349, 0), new Long(48, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:mastercard_label', 'mastercard_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12391, 0), new Long(40, 0))]));
  }
  function _get_mastercard_label_$ref_tma2j1() {
    return constructCallableReference(function (p0) {
      return get_mastercard_label(p0);
    }, 1, 0, 756);
  }
  function max_price_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16398, 0), new Long(43, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:max_price_label', 'max_price_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12432, 0), new Long(35, 0))]));
  }
  function _get_max_price_label_$ref_5mi37n() {
    return constructCallableReference(function (p0) {
      return get_max_price_label(p0);
    }, 1, 0, 757);
  }
  function men_s_gifts$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16442, 0), new Long(51, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:men_s_gifts', 'men_s_gifts', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12468, 0), new Long(35, 0))]));
  }
  function _get_men_s_gifts_$ref_w8qa1a() {
    return constructCallableReference(function (p0) {
      return get_men_s_gifts(p0);
    }, 1, 0, 758);
  }
  function message_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16494, 0), new Long(41, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:message_label', 'message_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12504, 0), new Long(33, 0))]));
  }
  function _get_message_label_$ref_hyftvo() {
    return constructCallableReference(function (p0) {
      return get_message_label(p0);
    }, 1, 0, 759);
  }
  function min_price_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16536, 0), new Long(43, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:min_price_label', 'min_price_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12538, 0), new Long(35, 0))]));
  }
  function _get_min_price_label_$ref_nhin01() {
    return constructCallableReference(function (p0) {
      return get_min_price_label(p0);
    }, 1, 0, 760);
  }
  function minimalist_white$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16580, 0), new Long(48, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:minimalist_white', 'minimalist_white', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12574, 0), new Long(48, 0))]));
  }
  function mug_designer_title$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16629, 0), new Long(50, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:mug_designer_title', 'mug_designer_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12623, 0), new Long(42, 0))]));
  }
  function _get_mug_designer_title_$ref_itezuy() {
    return constructCallableReference(function (p0) {
      return get_mug_designer_title(p0);
    }, 1, 0, 761);
  }
  function mug_interactive_engine$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16680, 0), new Long(122, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:mug_interactive_engine', 'mug_interactive_engine', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12666, 0), new Long(82, 0))]));
  }
  function _get_mug_interactive_engine_$ref_kii1gl() {
    return constructCallableReference(function (p0) {
      return get_mug_interactive_engine(p0);
    }, 1, 0, 762);
  }
  function mug_size$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16932, 0), new Long(36, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:mug_size', 'mug_size', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12842, 0), new Long(28, 0))]));
  }
  function _get_mug_size_$ref_mx57s7() {
    return constructCallableReference(function (p0) {
      return get_mug_size(p0);
    }, 1, 0, 763);
  }
  function mug_size_11_oz$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16803, 0), new Long(42, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:mug_size_11_oz', 'mug_size_11_oz', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12749, 0), new Long(30, 0))]));
  }
  function _get_mug_size_11_oz_$ref_rxlyha() {
    return constructCallableReference(function (p0) {
      return get_mug_size_11_oz(p0);
    }, 1, 0, 764);
  }
  function mug_size_15_oz$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16846, 0), new Long(42, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:mug_size_15_oz', 'mug_size_15_oz', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12780, 0), new Long(30, 0))]));
  }
  function _get_mug_size_15_oz_$ref_klq2pa() {
    return constructCallableReference(function (p0) {
      return get_mug_size_15_oz(p0);
    }, 1, 0, 765);
  }
  function mug_size_20_oz$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16889, 0), new Long(42, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:mug_size_20_oz', 'mug_size_20_oz', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12811, 0), new Long(30, 0))]));
  }
  function _get_mug_size_20_oz_$ref_gge1hw() {
    return constructCallableReference(function (p0) {
      return get_mug_size_20_oz(p0);
    }, 1, 0, 766);
  }
  function mug_viewer$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(16969, 0), new Long(38, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:mug_viewer', 'mug_viewer', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12871, 0), new Long(34, 0))]));
  }
  function my_coupons_title$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17008, 0), new Long(84, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:my_coupons_title', 'my_coupons_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12906, 0), new Long(40, 0))]));
  }
  function _get_my_coupons_title_$ref_tolj5l() {
    return constructCallableReference(function (p0) {
      return get_my_coupons_title(p0);
    }, 1, 0, 767);
  }
  function name_label_required$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17093, 0), new Long(43, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:name_label_required', 'name_label_required', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12947, 0), new Long(35, 0))]));
  }
  function _get_name_label_required_$ref_3ripry() {
    return constructCallableReference(function (p0) {
      return get_name_label_required(p0);
    }, 1, 0, 768);
  }
  function nav_cart$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17137, 0), new Long(32, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:nav_cart', 'nav_cart', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(12983, 0), new Long(24, 0))]));
  }
  function _get_nav_cart_$ref_npwc8y() {
    return constructCallableReference(function (p0) {
      return get_nav_cart(p0);
    }, 1, 0, 769);
  }
  function nav_profile$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17170, 0), new Long(51, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:nav_profile', 'nav_profile', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13008, 0), new Long(31, 0))]));
  }
  function _get_nav_profile_$ref_t2w237() {
    return constructCallableReference(function (p0) {
      return get_nav_profile(p0);
    }, 1, 0, 770);
  }
  function nav_shop$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17222, 0), new Long(32, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:nav_shop', 'nav_shop', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13040, 0), new Long(24, 0))]));
  }
  function _get_nav_shop_$ref_8zvk6g() {
    return constructCallableReference(function (p0) {
      return get_nav_shop(p0);
    }, 1, 0, 771);
  }
  function neighbourhood_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17255, 0), new Long(39, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:neighbourhood_label', 'neighbourhood_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13065, 0), new Long(47, 0))]));
  }
  function _get_neighbourhood_label_$ref_bgqrpu() {
    return constructCallableReference(function (p0) {
      return get_neighbourhood_label(p0);
    }, 1, 0, 772);
  }
  function network_error$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17295, 0), new Long(129, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:network_error', 'network_error', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13113, 0), new Long(93, 0))]));
  }
  function _get_network_error_$ref_aj2uxj() {
    return constructCallableReference(function (p0) {
      return get_network_error(p0);
    }, 1, 0, 773);
  }
  function new_password_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17425, 0), new Long(74, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:new_password_label', 'new_password_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13207, 0), new Long(42, 0))]));
  }
  function _get_new_password_label_$ref_8u0zv() {
    return constructCallableReference(function (p0) {
      return get_new_password_label(p0);
    }, 1, 0, 774);
  }
  function no_coupons_found$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17500, 0), new Long(104, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:no_coupons_found', 'no_coupons_found', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13250, 0), new Long(76, 0))]));
  }
  function _get_no_coupons_found_$ref_yq1ie0() {
    return constructCallableReference(function (p0) {
      return get_no_coupons_found(p0);
    }, 1, 0, 775);
  }
  function no_description$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17605, 0), new Long(62, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:no_description', 'no_description', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13327, 0), new Long(58, 0))]));
  }
  function _get_no_description_$ref_4bxr5o() {
    return constructCallableReference(function (p0) {
      return get_no_description(p0);
    }, 1, 0, 776);
  }
  function no_favorites_yet$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17668, 0), new Long(84, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:no_favorites_yet', 'no_favorites_yet', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13386, 0), new Long(56, 0))]));
  }
  function _get_no_favorites_yet_$ref_vzb4ag() {
    return constructCallableReference(function (p0) {
      return get_no_favorites_yet(p0);
    }, 1, 0, 777);
  }
  function no_friends_saved$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17753, 0), new Long(92, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:no_friends_saved', 'no_friends_saved', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13443, 0), new Long(52, 0))]));
  }
  function no_friends_yet$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17846, 0), new Long(110, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:no_friends_yet', 'no_friends_yet', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13496, 0), new Long(58, 0))]));
  }
  function _get_no_friends_yet_$ref_uwzarq() {
    return constructCallableReference(function (p0) {
      return get_no_friends_yet(p0);
    }, 1, 0, 778);
  }
  function no_internet_connection$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(17957, 0), new Long(90, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:no_internet_connection', 'no_internet_connection', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13555, 0), new Long(62, 0))]));
  }
  function _get_no_internet_connection_$ref_ek8oo4() {
    return constructCallableReference(function (p0) {
      return get_no_internet_connection(p0);
    }, 1, 0, 779);
  }
  function no_internet_custom_mug$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(18048, 0), new Long(154, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:no_internet_custom_mug', 'no_internet_custom_mug', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13618, 0), new Long(102, 0))]));
  }
  function _get_no_internet_custom_mug_$ref_49vcif() {
    return constructCallableReference(function (p0) {
      return get_no_internet_custom_mug(p0);
    }, 1, 0, 780);
  }
  function no_orders_found$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(18203, 0), new Long(55, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:no_orders_found', 'no_orders_found', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13721, 0), new Long(43, 0))]));
  }
  function _get_no_orders_found_$ref_x7qvqe() {
    return constructCallableReference(function (p0) {
      return get_no_orders_found(p0);
    }, 1, 0, 781);
  }
  function no_products_found$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(18259, 0), new Long(61, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:no_products_found', 'no_products_found', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13765, 0), new Long(49, 0))]));
  }
  function no_reminders_yet$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(18321, 0), new Long(84, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:no_reminders_yet', 'no_reminders_yet', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13815, 0), new Long(56, 0))]));
  }
  function _get_no_reminders_yet_$ref_detrn6() {
    return constructCallableReference(function (p0) {
      return get_no_reminders_yet(p0);
    }, 1, 0, 782);
  }
  function no_search_results$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(18406, 0), new Long(89, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:no_search_results', 'no_search_results', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13872, 0), new Long(65, 0))]));
  }
  function no_text_error$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(18496, 0), new Long(45, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:no_text_error', 'no_text_error', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13938, 0), new Long(41, 0))]));
  }
  function not_available$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(18542, 0), new Long(41, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:not_available', 'not_available', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(13980, 0), new Long(25, 0))]));
  }
  function _get_not_available_$ref_7d22v7() {
    return constructCallableReference(function (p0) {
      return get_not_available(p0);
    }, 1, 0, 783);
  }
  function not_set$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(18584, 0), new Long(35, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:not_set', 'not_set', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14006, 0), new Long(27, 0))]));
  }
  function _get_not_set_$ref_kaz9l6() {
    return constructCallableReference(function (p0) {
      return get_not_set(p0);
    }, 1, 0, 784);
  }
  function notification_channel_description$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(18620, 0), new Long(108, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:notification_channel_description', 'notification_channel_description', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14034, 0), new Long(88, 0))]));
  }
  function notification_channel_name$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(18729, 0), new Long(65, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:notification_channel_name', 'notification_channel_name', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14123, 0), new Long(61, 0))]));
  }
  function notification_new_order_body$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(18795, 0), new Long(119, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:notification_new_order_body', 'notification_new_order_body', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14185, 0), new Long(87, 0))]));
  }
  function _get_notification_new_order_body_$ref_llcet6() {
    return constructCallableReference(function (p0) {
      return get_notification_new_order_body(p0);
    }, 1, 0, 785);
  }
  function notification_new_order_title$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(18915, 0), new Long(72, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:notification_new_order_title', 'notification_new_order_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14273, 0), new Long(60, 0))]));
  }
  function _get_notification_new_order_title_$ref_dy6xl2() {
    return constructCallableReference(function (p0) {
      return get_notification_new_order_title(p0);
    }, 1, 0, 786);
  }
  function notification_return_requested_body$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(18988, 0), new Long(134, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:notification_return_requested_body', 'notification_return_requested_body', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14334, 0), new Long(110, 0))]));
  }
  function _get_notification_return_requested_body_$ref_4s96bw() {
    return constructCallableReference(function (p0) {
      return get_notification_return_requested_body(p0);
    }, 1, 0, 787);
  }
  function notification_return_requested_title$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19123, 0), new Long(91, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:notification_return_requested_title', 'notification_return_requested_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14445, 0), new Long(75, 0))]));
  }
  function _get_notification_return_requested_title_$ref_9vszgs() {
    return constructCallableReference(function (p0) {
      return get_notification_return_requested_title(p0);
    }, 1, 0, 788);
  }
  function ok$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19215, 0), new Long(26, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:ok', 'ok', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14521, 0), new Long(14, 0))]));
  }
  function _get_ok_$ref_dwl57i() {
    return constructCallableReference(function (p0) {
      return get_ok(p0);
    }, 1, 0, 789);
  }
  function old_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19242, 0), new Long(77, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:old_label', 'old_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14536, 0), new Long(45, 0))]));
  }
  function _get_old_label_$ref_w9alr0() {
    return constructCallableReference(function (p0) {
      return get_old_label(p0);
    }, 1, 0, 790);
  }
  function options_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:options_label', 'options_label', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14582, 0), new Long(33, 0))));
  }
  function or_label$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19320, 0), new Long(24, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:or_label', 'or_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14616, 0), new Long(24, 0))]));
  }
  function _get_or_label_$ref_p8wlsu() {
    return constructCallableReference(function (p0) {
      return get_or_label(p0);
    }, 1, 0, 791);
  }
  function order_details_title$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19345, 0), new Long(59, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_details_title', 'order_details_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14641, 0), new Long(47, 0))]));
  }
  function _get_order_details_title_$ref_1otnl6() {
    return constructCallableReference(function (p0) {
      return get_order_details_title(p0);
    }, 1, 0, 792);
  }
  function order_discount$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19405, 0), new Long(38, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_discount', 'order_discount', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14689, 0), new Long(34, 0))]));
  }
  function _get_order_discount_$ref_tvyh7s() {
    return constructCallableReference(function (p0) {
      return get_order_discount(p0);
    }, 1, 0, 793);
  }
  function order_execution_disclaimer$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19444, 0), new Long(170, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_execution_disclaimer', 'order_execution_disclaimer', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14724, 0), new Long(114, 0))]));
  }
  function _get_order_execution_disclaimer_$ref_svchi1() {
    return constructCallableReference(function (p0) {
      return get_order_execution_disclaimer(p0);
    }, 1, 0, 794);
  }
  function order_history_btn$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19615, 0), new Long(53, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_history_btn', 'order_history_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14839, 0), new Long(45, 0))]));
  }
  function order_history_title$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19669, 0), new Long(55, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_history_title', 'order_history_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14885, 0), new Long(47, 0))]));
  }
  function _get_order_history_title_$ref_bdgfyc() {
    return constructCallableReference(function (p0) {
      return get_order_history_title(p0);
    }, 1, 0, 795);
  }
  function order_id_prefix_pattern$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19725, 0), new Long(55, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_id_prefix_pattern', 'order_id_prefix_pattern', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14933, 0), new Long(47, 0))]));
  }
  function _get_order_id_prefix_pattern_$ref_95ei5m() {
    return constructCallableReference(function (p0) {
      return get_order_id_prefix_pattern(p0);
    }, 1, 0, 796);
  }
  function order_items_count_pattern$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19781, 0), new Long(57, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_items_count_pattern', 'order_items_count_pattern', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(14981, 0), new Long(49, 0))]));
  }
  function _get_order_items_count_pattern_$ref_jam9lc() {
    return constructCallableReference(function (p0) {
      return get_order_items_count_pattern(p0);
    }, 1, 0, 797);
  }
  function order_placed_success_desc$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19839, 0), new Long(81, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_placed_success_desc', 'order_placed_success_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15031, 0), new Long(89, 0))]));
  }
  function order_placed_title$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19921, 0), new Long(62, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_placed_title', 'order_placed_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15121, 0), new Long(42, 0))]));
  }
  function _get_order_placed_title_$ref_8xyo1f() {
    return constructCallableReference(function (p0) {
      return get_order_placed_title(p0);
    }, 1, 0, 798);
  }
  function order_quantity_pattern$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(19984, 0), new Long(54, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_quantity_pattern', 'order_quantity_pattern', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15164, 0), new Long(50, 0))]));
  }
  function _get_order_quantity_pattern_$ref_bb9qel() {
    return constructCallableReference(function (p0) {
      return get_order_quantity_pattern(p0);
    }, 1, 0, 799);
  }
  function order_shipping_cost$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20039, 0), new Long(59, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_shipping_cost', 'order_shipping_cost', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15215, 0), new Long(47, 0))]));
  }
  function _get_order_shipping_cost_$ref_76m1rh() {
    return constructCallableReference(function (p0) {
      return get_order_shipping_cost(p0);
    }, 1, 0, 800);
  }
  function order_status_archived$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20099, 0), new Long(45, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_status_archived', 'order_status_archived', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15263, 0), new Long(41, 0))]));
  }
  function _get_order_status_archived_$ref_34qeea() {
    return constructCallableReference(function (p0) {
      return get_order_status_archived(p0);
    }, 1, 0, 801);
  }
  function order_status_completed$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20145, 0), new Long(46, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_status_completed', 'order_status_completed', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15305, 0), new Long(42, 0))]));
  }
  function _get_order_status_completed_$ref_a2ls8l() {
    return constructCallableReference(function (p0) {
      return get_order_status_completed(p0);
    }, 1, 0, 802);
  }
  function order_status_failed$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20192, 0), new Long(35, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_status_failed', 'order_status_failed', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15348, 0), new Long(35, 0))]));
  }
  function _get_order_status_failed_$ref_7acqc9() {
    return constructCallableReference(function (p0) {
      return get_order_status_failed(p0);
    }, 1, 0, 803);
  }
  function order_status_money_returned$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20228, 0), new Long(79, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_status_money_returned', 'order_status_money_returned', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15384, 0), new Long(55, 0))]));
  }
  function _get_order_status_money_returned_$ref_w6711y() {
    return constructCallableReference(function (p0) {
      return get_order_status_money_returned(p0);
    }, 1, 0, 804);
  }
  function order_status_on_the_way$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20308, 0), new Long(63, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_status_on_the_way', 'order_status_on_the_way', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15440, 0), new Long(47, 0))]));
  }
  function _get_order_status_on_the_way_$ref_s4tbdp() {
    return constructCallableReference(function (p0) {
      return get_order_status_on_the_way(p0);
    }, 1, 0, 805);
  }
  function order_status_preparing$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20372, 0), new Long(58, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_status_preparing', 'order_status_preparing', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15488, 0), new Long(42, 0))]));
  }
  function _get_order_status_preparing_$ref_nj2h0y() {
    return constructCallableReference(function (p0) {
      return get_order_status_preparing(p0);
    }, 1, 0, 806);
  }
  function order_status_received$delegate$lambda() {
    _init_properties_String2_commonMain_kt__rex7jl();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20431, 0), new Long(69, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_status_received', 'order_status_received', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15531, 0), new Long(49, 0))]));
  }
  function _get_order_status_received_$ref_qbvl19() {
    return constructCallableReference(function (p0) {
      return get_order_status_received(p0);
    }, 1, 0, 807);
  }
  var properties_initialized_String2_commonMain_kt_zgrqrx;
  function _init_properties_String2_commonMain_kt__rex7jl() {
    if (!properties_initialized_String2_commonMain_kt_zgrqrx) {
      properties_initialized_String2_commonMain_kt_zgrqrx = true;
      gradient_end$delegate = lazy(gradient_end$delegate$lambda);
      gradient_start$delegate = lazy(gradient_start$delegate$lambda);
      height_label$delegate = lazy(height_label$delegate$lambda);
      hide_password$delegate = lazy(hide_password$delegate$lambda);
      image_settings$delegate = lazy(image_settings$delegate$lambda);
      in_stock_pattern$delegate = lazy(in_stock_pattern$delegate$lambda);
      increase_quantity_desc$delegate = lazy(increase_quantity_desc$delegate$lambda);
      information_is_loaded_from_your_profile_To_change_it_please_go_to_your_profile_settings$delegate = lazy(information_is_loaded_from_your_profile_To_change_it_please_go_to_your_profile_settings$delegate$lambda);
      instapay$delegate = lazy(instapay$delegate$lambda);
      interactive_3d_preview$delegate = lazy(interactive_3d_preview$delegate$lambda);
      invalid_birthday_date$delegate = lazy(invalid_birthday_date$delegate$lambda);
      invalid_birthday_format$delegate = lazy(invalid_birthday_format$delegate$lambda);
      invalid_coupon_error$delegate = lazy(invalid_coupon_error$delegate$lambda);
      invalid_credentials$delegate = lazy(invalid_credentials$delegate$lambda);
      invalid_email_format$delegate = lazy(invalid_email_format$delegate$lambda);
      invalid_format_use_yyyy_mm_dd$delegate = lazy(invalid_format_use_yyyy_mm_dd$delegate$lambda);
      invalid_phone_format$delegate = lazy(invalid_phone_format$delegate$lambda);
      invalid_phone_number_format$delegate = lazy(invalid_phone_number_format$delegate$lambda);
      invalid_phone_personal$delegate = lazy(invalid_phone_personal$delegate$lambda);
      invalid_phone_work$delegate = lazy(invalid_phone_work$delegate$lambda);
      keep_login_label$delegate = lazy(keep_login_label$delegate$lambda);
      kids_label$delegate = lazy(kids_label$delegate$lambda);
      lang_ar$delegate = lazy(lang_ar$delegate$lambda);
      lang_en$delegate = lazy(lang_en$delegate$lambda);
      language_arabic$delegate = lazy(language_arabic$delegate$lambda);
      language_english$delegate = lazy(language_english$delegate$lambda);
      last_name_label$delegate = lazy(last_name_label$delegate$lambda);
      location_lat_long_label$delegate = lazy(location_lat_long_label$delegate$lambda);
      login$delegate = lazy(login$delegate$lambda);
      login_btn$delegate = lazy(login_btn$delegate$lambda);
      login_failed$delegate = lazy(login_failed$delegate$lambda);
      login_required_details$delegate = lazy(login_required_details$delegate$lambda);
      login_required_profile$delegate = lazy(login_required_profile$delegate$lambda);
      login_with_google$delegate = lazy(login_with_google$delegate$lambda);
      logo$delegate_0 = lazy(logo$delegate$lambda_0);
      logout_btn$delegate = lazy(logout_btn$delegate$lambda);
      manage_friends_btn$delegate = lazy(manage_friends_btn$delegate$lambda);
      mastercard_label$delegate = lazy(mastercard_label$delegate$lambda);
      max_price_label$delegate = lazy(max_price_label$delegate$lambda);
      men_s_gifts$delegate = lazy(men_s_gifts$delegate$lambda);
      message_label$delegate = lazy(message_label$delegate$lambda);
      min_price_label$delegate = lazy(min_price_label$delegate$lambda);
      minimalist_white$delegate = lazy(minimalist_white$delegate$lambda);
      mug_designer_title$delegate = lazy(mug_designer_title$delegate$lambda);
      mug_interactive_engine$delegate = lazy(mug_interactive_engine$delegate$lambda);
      mug_size$delegate = lazy(mug_size$delegate$lambda);
      mug_size_11_oz$delegate = lazy(mug_size_11_oz$delegate$lambda);
      mug_size_15_oz$delegate = lazy(mug_size_15_oz$delegate$lambda);
      mug_size_20_oz$delegate = lazy(mug_size_20_oz$delegate$lambda);
      mug_viewer$delegate = lazy(mug_viewer$delegate$lambda);
      my_coupons_title$delegate = lazy(my_coupons_title$delegate$lambda);
      name_label_required$delegate = lazy(name_label_required$delegate$lambda);
      nav_cart$delegate = lazy(nav_cart$delegate$lambda);
      nav_profile$delegate = lazy(nav_profile$delegate$lambda);
      nav_shop$delegate = lazy(nav_shop$delegate$lambda);
      neighbourhood_label$delegate = lazy(neighbourhood_label$delegate$lambda);
      network_error$delegate = lazy(network_error$delegate$lambda);
      new_password_label$delegate = lazy(new_password_label$delegate$lambda);
      no_coupons_found$delegate = lazy(no_coupons_found$delegate$lambda);
      no_description$delegate = lazy(no_description$delegate$lambda);
      no_favorites_yet$delegate = lazy(no_favorites_yet$delegate$lambda);
      no_friends_saved$delegate = lazy(no_friends_saved$delegate$lambda);
      no_friends_yet$delegate = lazy(no_friends_yet$delegate$lambda);
      no_internet_connection$delegate = lazy(no_internet_connection$delegate$lambda);
      no_internet_custom_mug$delegate = lazy(no_internet_custom_mug$delegate$lambda);
      no_orders_found$delegate = lazy(no_orders_found$delegate$lambda);
      no_products_found$delegate = lazy(no_products_found$delegate$lambda);
      no_reminders_yet$delegate = lazy(no_reminders_yet$delegate$lambda);
      no_search_results$delegate = lazy(no_search_results$delegate$lambda);
      no_text_error$delegate = lazy(no_text_error$delegate$lambda);
      not_available$delegate = lazy(not_available$delegate$lambda);
      not_set$delegate = lazy(not_set$delegate$lambda);
      notification_channel_description$delegate = lazy(notification_channel_description$delegate$lambda);
      notification_channel_name$delegate = lazy(notification_channel_name$delegate$lambda);
      notification_new_order_body$delegate = lazy(notification_new_order_body$delegate$lambda);
      notification_new_order_title$delegate = lazy(notification_new_order_title$delegate$lambda);
      notification_return_requested_body$delegate = lazy(notification_return_requested_body$delegate$lambda);
      notification_return_requested_title$delegate = lazy(notification_return_requested_title$delegate$lambda);
      ok$delegate = lazy(ok$delegate$lambda);
      old_label$delegate = lazy(old_label$delegate$lambda);
      options_label$delegate = lazy(options_label$delegate$lambda);
      or_label$delegate = lazy(or_label$delegate$lambda);
      order_details_title$delegate = lazy(order_details_title$delegate$lambda);
      order_discount$delegate = lazy(order_discount$delegate$lambda);
      order_execution_disclaimer$delegate = lazy(order_execution_disclaimer$delegate$lambda);
      order_history_btn$delegate = lazy(order_history_btn$delegate$lambda);
      order_history_title$delegate = lazy(order_history_title$delegate$lambda);
      order_id_prefix_pattern$delegate = lazy(order_id_prefix_pattern$delegate$lambda);
      order_items_count_pattern$delegate = lazy(order_items_count_pattern$delegate$lambda);
      order_placed_success_desc$delegate = lazy(order_placed_success_desc$delegate$lambda);
      order_placed_title$delegate = lazy(order_placed_title$delegate$lambda);
      order_quantity_pattern$delegate = lazy(order_quantity_pattern$delegate$lambda);
      order_shipping_cost$delegate = lazy(order_shipping_cost$delegate$lambda);
      order_status_archived$delegate = lazy(order_status_archived$delegate$lambda);
      order_status_completed$delegate = lazy(order_status_completed$delegate$lambda);
      order_status_failed$delegate = lazy(order_status_failed$delegate$lambda);
      order_status_money_returned$delegate = lazy(order_status_money_returned$delegate$lambda);
      order_status_on_the_way$delegate = lazy(order_status_on_the_way$delegate$lambda);
      order_status_preparing$delegate = lazy(order_status_preparing$delegate$lambda);
      order_status_received$delegate = lazy(order_status_received$delegate$lambda);
    }
  }
  function get_order_status_return_delivery(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = order_status_return_delivery$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_status_return_delivery', 1, tmp, _get_order_status_return_delivery_$ref_gizwab(), null);
    return tmp0.u1();
  }
  var order_status_return_delivery$delegate;
  function get_order_status_return_requested(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = order_status_return_requested$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_status_return_requested', 1, tmp, _get_order_status_return_requested_$ref_y7xbqz(), null);
    return tmp0.u1();
  }
  var order_status_return_requested$delegate;
  function get_order_status_returned(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = order_status_returned$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_status_returned', 1, tmp, _get_order_status_returned_$ref_horkvf(), null);
    return tmp0.u1();
  }
  var order_status_returned$delegate;
  function get_order_subtotal(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = order_subtotal$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_subtotal', 1, tmp, _get_order_subtotal_$ref_3ty9tn(), null);
    return tmp0.u1();
  }
  var order_subtotal$delegate;
  function get_order_summary_header(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = order_summary_header$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_summary_header', 1, tmp, _get_order_summary_header_$ref_oou11f(), null);
    return tmp0.u1();
  }
  var order_summary_header$delegate;
  function get_order_total_price(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = order_total_price$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('order_total_price', 1, tmp, _get_order_total_price_$ref_py6d6l(), null);
    return tmp0.u1();
  }
  var order_total_price$delegate;
  function get_ordered_items_header(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = ordered_items_header$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ordered_items_header', 1, tmp, _get_ordered_items_header_$ref_a5r5do(), null);
    return tmp0.u1();
  }
  var ordered_items_header$delegate;
  function get_out_of_stock(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = out_of_stock$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('out_of_stock', 1, tmp, _get_out_of_stock_$ref_f7opzv(), null);
    return tmp0.u1();
  }
  var out_of_stock$delegate;
  function get_password_label(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = password_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('password_label', 1, tmp, _get_password_label_$ref_ft6sru(), null);
    return tmp0.u1();
  }
  var password_label$delegate;
  function get_password_length_error(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = password_length_error$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('password_length_error', 1, tmp, _get_password_length_error_$ref_9rcrxv(), null);
    return tmp0.u1();
  }
  var password_length_error$delegate;
  function get_password_reset_sent(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = password_reset_sent$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('password_reset_sent', 1, tmp, _get_password_reset_sent_$ref_axwe98(), null);
    return tmp0.u1();
  }
  var password_reset_sent$delegate;
  function get_password_updated(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = password_updated$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('password_updated', 1, tmp, _get_password_updated_$ref_fcgygz(), null);
    return tmp0.u1();
  }
  var password_updated$delegate;
  function get_passwords_dont_match(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = passwords_dont_match$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('passwords_dont_match', 1, tmp, _get_passwords_dont_match_$ref_wawm7w(), null);
    return tmp0.u1();
  }
  var passwords_dont_match$delegate;
  function get_payment_method_header(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = payment_method_header$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('payment_method_header', 1, tmp, _get_payment_method_header_$ref_yz5e1a(), null);
    return tmp0.u1();
  }
  var payment_method_header$delegate;
  function get_phone_number_label(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = phone_number_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('phone_number_label', 1, tmp, _get_phone_number_label_$ref_y5x0vf(), null);
    return tmp0.u1();
  }
  var phone_number_label$delegate;
  function get_phone_personal_label_required(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = phone_personal_label_required$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('phone_personal_label_required', 1, tmp, _get_phone_personal_label_required_$ref_5cxobc(), null);
    return tmp0.u1();
  }
  var phone_personal_label_required$delegate;
  function get_phone_personal_prefix_pattern(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = phone_personal_prefix_pattern$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('phone_personal_prefix_pattern', 1, tmp, _get_phone_personal_prefix_pattern_$ref_h0152n(), null);
    return tmp0.u1();
  }
  var phone_personal_prefix_pattern$delegate;
  function get_phone_verified_call_support(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = phone_verified_call_support$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('phone_verified_call_support', 1, tmp, _get_phone_verified_call_support_$ref_j0rjbg(), null);
    return tmp0.u1();
  }
  var phone_verified_call_support$delegate;
  function get_phone_work_label(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = phone_work_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('phone_work_label', 1, tmp, _get_phone_work_label_$ref_60nowz(), null);
    return tmp0.u1();
  }
  var phone_work_label$delegate;
  function get_phone_work_prefix_pattern(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = phone_work_prefix_pattern$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('phone_work_prefix_pattern', 1, tmp, _get_phone_work_prefix_pattern_$ref_y2sri8(), null);
    return tmp0.u1();
  }
  var phone_work_prefix_pattern$delegate;
  function get_pick_birthday_desc(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = pick_birthday_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('pick_birthday_desc', 1, tmp, _get_pick_birthday_desc_$ref_fpzza3(), null);
    return tmp0.u1();
  }
  var pick_birthday_desc$delegate;
  function get_pick_date(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = pick_date$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('pick_date', 1, tmp, _get_pick_date_$ref_v4dznw(), null);
    return tmp0.u1();
  }
  var pick_date$delegate;
  function get_pick_location_desc(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = pick_location_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('pick_location_desc', 1, tmp, _get_pick_location_desc_$ref_j4xy5f(), null);
    return tmp0.u1();
  }
  var pick_location_desc$delegate;
  function get_please_login_to_add_items_to_cart(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = please_login_to_add_items_to_cart$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('please_login_to_add_items_to_cart', 1, tmp, _get_please_login_to_add_items_to_cart_$ref_l0s3ri(), null);
    return tmp0.u1();
  }
  var please_login_to_add_items_to_cart$delegate;
  var premium_black$delegate;
  function get_price_egp(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = price_egp$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('price_egp', 1, tmp, _get_price_egp_$ref_mbhrxk(), null);
    return tmp0.u1();
  }
  var price_egp$delegate;
  function get_price_range_label(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = price_range_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('price_range_label', 1, tmp, _get_price_range_label_$ref_wsl32c(), null);
    return tmp0.u1();
  }
  var price_range_label$delegate;
  function get_privacy_policy_btn(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = privacy_policy_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('privacy_policy_btn', 1, tmp, _get_privacy_policy_btn_$ref_5k9wic(), null);
    return tmp0.u1();
  }
  var privacy_policy_btn$delegate;
  function get_privacy_policy_required(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = privacy_policy_required$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('privacy_policy_required', 1, tmp, _get_privacy_policy_required_$ref_seg2ff(), null);
    return tmp0.u1();
  }
  var privacy_policy_required$delegate;
  function get_proceed_to_checkout(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = proceed_to_checkout$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('proceed_to_checkout', 1, tmp, _get_proceed_to_checkout_$ref_wjzt21(), null);
    return tmp0.u1();
  }
  var proceed_to_checkout$delegate;
  function get_product(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = product$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('product', 1, tmp, _get_product_$ref_rfruof(), null);
    return tmp0.u1();
  }
  var product$delegate;
  function get_product_info_missing(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = product_info_missing$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('product_info_missing', 1, tmp, _get_product_info_missing_$ref_m3xrcl(), null);
    return tmp0.u1();
  }
  var product_info_missing$delegate;
  var product_kind$delegate;
  function get_products_found(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = products_found$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('products_found', 1, tmp, _get_products_found_$ref_jpiqz1(), null);
    return tmp0.u1();
  }
  var products_found$delegate;
  function get_profile_pic_desc(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = profile_pic_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('profile_pic_desc', 1, tmp, _get_profile_pic_desc_$ref_3z5hha(), null);
    return tmp0.u1();
  }
  var profile_pic_desc$delegate;
  function get_profile_title(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = profile_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('profile_title', 1, tmp, _get_profile_title_$ref_hync5a(), null);
    return tmp0.u1();
  }
  var profile_title$delegate;
  var promotion_banner_desc$delegate;
  function get_quantity_label(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = quantity_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('quantity_label', 1, tmp, _get_quantity_label_$ref_w7hlx6(), null);
    return tmp0.u1();
  }
  var quantity_label$delegate;
  var rating_desc$delegate;
  function get_re_add_to_cart(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = re_add_to_cart$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('re_add_to_cart', 1, tmp, _get_re_add_to_cart_$ref_wyqigw(), null);
    return tmp0.u1();
  }
  var re_add_to_cart$delegate;
  var receiver_address_label$delegate;
  var receiver_info_header$delegate;
  function get_receiver_name_label(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = receiver_name_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('receiver_name_label', 1, tmp, _get_receiver_name_label_$ref_qo70c0(), null);
    return tmp0.u1();
  }
  var receiver_name_label$delegate;
  var receiver_payment_label$delegate;
  var receiver_phone_label$delegate;
  var refresh_data$delegate;
  var registration_failed$delegate;
  function get_registration_successful(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = registration_successful$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('registration_successful', 1, tmp, _get_registration_successful_$ref_xny734(), null);
    return tmp0.u1();
  }
  var registration_successful$delegate;
  function get_relationship_label(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = relationship_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('relationship_label', 1, tmp, _get_relationship_label_$ref_ybmsr7(), null);
    return tmp0.u1();
  }
  var relationship_label$delegate;
  function get_relationship_not_specified(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = relationship_not_specified$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('relationship_not_specified', 1, tmp, _get_relationship_not_specified_$ref_41xbab(), null);
    return tmp0.u1();
  }
  var relationship_not_specified$delegate;
  function get_remind_me(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = remind_me$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('remind_me', 1, tmp, _get_remind_me_$ref_eq6rrm(), null);
    return tmp0.u1();
  }
  var remind_me$delegate;
  function get_reminder_set(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = reminder_set$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('reminder_set', 1, tmp, _get_reminder_set_$ref_6roxtn(), null);
    return tmp0.u1();
  }
  var reminder_set$delegate;
  function get_remove_design_desc(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = remove_design_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('remove_design_desc', 1, tmp, _get_remove_design_desc_$ref_wfk8gt(), null);
    return tmp0.u1();
  }
  var remove_design_desc$delegate;
  function get_remove_design_title(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = remove_design_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('remove_design_title', 1, tmp, _get_remove_design_title_$ref_2seo1e(), null);
    return tmp0.u1();
  }
  var remove_design_title$delegate;
  function get_remove_from_favorites(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = remove_from_favorites$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('remove_from_favorites', 1, tmp, _get_remove_from_favorites_$ref_mquw1p(), null);
    return tmp0.u1();
  }
  var remove_from_favorites$delegate;
  var remove_from_favorites_desc$delegate;
  function get_remove_image(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = remove_image$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('remove_image', 1, tmp, _get_remove_image_$ref_jrljc6(), null);
    return tmp0.u1();
  }
  var remove_image$delegate;
  function get_remove_item_confirm(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = remove_item_confirm$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('remove_item_confirm', 1, tmp, _get_remove_item_confirm_$ref_i86wvl(), null);
    return tmp0.u1();
  }
  var remove_item_confirm$delegate;
  function get_remove_item_desc(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = remove_item_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('remove_item_desc', 1, tmp, _get_remove_item_desc_$ref_gsmgnc(), null);
    return tmp0.u1();
  }
  var remove_item_desc$delegate;
  function get_remove_item_title(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = remove_item_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('remove_item_title', 1, tmp, _get_remove_item_title_$ref_f943hj(), null);
    return tmp0.u1();
  }
  var remove_item_title$delegate;
  function get_remove_reminder_confirm(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = remove_reminder_confirm$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('remove_reminder_confirm', 1, tmp, _get_remove_reminder_confirm_$ref_s9kwz6(), null);
    return tmp0.u1();
  }
  var remove_reminder_confirm$delegate;
  function get_remove_reminder_title(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = remove_reminder_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('remove_reminder_title', 1, tmp, _get_remove_reminder_title_$ref_hi19qy(), null);
    return tmp0.u1();
  }
  var remove_reminder_title$delegate;
  function get_reset_filters_btn(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = reset_filters_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('reset_filters_btn', 1, tmp, _get_reset_filters_btn_$ref_m6p8d4(), null);
    return tmp0.u1();
  }
  var reset_filters_btn$delegate;
  function get_reset_password(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = reset_password$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('reset_password', 1, tmp, _get_reset_password_$ref_snxbyn(), null);
    return tmp0.u1();
  }
  var reset_password$delegate;
  function get_reset_password_complete_steps(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = reset_password_complete_steps$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('reset_password_complete_steps', 1, tmp, _get_reset_password_complete_steps_$ref_791xmz(), null);
    return tmp0.u1();
  }
  var reset_password_complete_steps$delegate;
  var reset_password_final_success$delegate;
  function get_reset_password_success_title(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = reset_password_success_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('reset_password_success_title', 1, tmp, _get_reset_password_success_title_$ref_j7560e(), null);
    return tmp0.u1();
  }
  var reset_password_success_title$delegate;
  var reset_setting$delegate;
  function get_retry(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = retry$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('retry', 1, tmp, _get_retry_$ref_u1ih08(), null);
    return tmp0.u1();
  }
  var retry$delegate;
  function get_return_order_btn(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = return_order_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('return_order_btn', 1, tmp, _get_return_order_btn_$ref_ko5k2q(), null);
    return tmp0.u1();
  }
  var return_order_btn$delegate;
  function get_return_reason_dialog_title(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = return_reason_dialog_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('return_reason_dialog_title', 1, tmp, _get_return_reason_dialog_title_$ref_16lj3h(), null);
    return tmp0.u1();
  }
  var return_reason_dialog_title$delegate;
  function get_return_reason_placeholder(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = return_reason_placeholder$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('return_reason_placeholder', 1, tmp, _get_return_reason_placeholder_$ref_4v1rnr(), null);
    return tmp0.u1();
  }
  var return_reason_placeholder$delegate;
  var return_request_submitted$delegate;
  function get_review_order_title(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = review_order_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('review_order_title', 1, tmp, _get_review_order_title_$ref_eyifcq(), null);
    return tmp0.u1();
  }
  var review_order_title$delegate;
  var rose_gold$delegate;
  function get_rotate_label(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = rotate_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('rotate_label', 1, tmp, _get_rotate_label_$ref_jfdis6(), null);
    return tmp0.u1();
  }
  var rotate_label$delegate;
  function get_save(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = save$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('save', 1, tmp, _get_save_$ref_r0beql(), null);
    return tmp0.u1();
  }
  var save$delegate;
  function get_saved_successfully(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = saved_successfully$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('saved_successfully', 1, tmp, _get_saved_successfully_$ref_9570fv(), null);
    return tmp0.u1();
  }
  var saved_successfully$delegate;
  var scroll_for_more$delegate;
  function get_search_placeholder(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = search_placeholder$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('search_placeholder', 1, tmp, _get_search_placeholder_$ref_kpeqqq(), null);
    return tmp0.u1();
  }
  var search_placeholder$delegate;
  var select_birthday$delegate;
  function get_select_box(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = select_box$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('select_box', 1, tmp, _get_select_box_$ref_iqgfta(), null);
    return tmp0.u1();
  }
  var select_box$delegate;
  function get_select_card(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = select_card$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('select_card', 1, tmp, _get_select_card_$ref_ig2efn(), null);
    return tmp0.u1();
  }
  var select_card$delegate;
  function get_select_color(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = select_color$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('select_color', 1, tmp, _get_select_color_$ref_hltrve(), null);
    return tmp0.u1();
  }
  var select_color$delegate;
  var select_friend_header$delegate;
  function get_select_language_title(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = select_language_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('select_language_title', 1, tmp, _get_select_language_title_$ref_4wilws(), null);
    return tmp0.u1();
  }
  var select_language_title$delegate;
  function get_select_size(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = select_size$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('select_size', 1, tmp, _get_select_size_$ref_66eyg4(), null);
    return tmp0.u1();
  }
  var select_size$delegate;
  function get_send_reset_link_btn(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = send_reset_link_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('send_reset_link_btn', 1, tmp, _get_send_reset_link_btn_$ref_mbq7oe(), null);
    return tmp0.u1();
  }
  var send_reset_link_btn$delegate;
  var set_new_password_title$delegate;
  function get_share_product(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = share_product$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('share_product', 1, tmp, _get_share_product_$ref_26oep(), null);
    return tmp0.u1();
  }
  var share_product$delegate;
  var shipping_for_friend$delegate;
  var shipping_for_friend_prepayment_note$delegate;
  var shipping_for_me$delegate;
  function get_show_password(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = show_password$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('show_password', 1, tmp, _get_show_password_$ref_afmg8z(), null);
    return tmp0.u1();
  }
  var show_password$delegate;
  function get_sign_up_btn(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = sign_up_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('sign_up_btn', 1, tmp, _get_sign_up_btn_$ref_qbtl8m(), null);
    return tmp0.u1();
  }
  var sign_up_btn$delegate;
  function get_size_label(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = size_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('size_label', 1, tmp, _get_size_label_$ref_pm070k(), null);
    return tmp0.u1();
  }
  var size_label$delegate;
  function get_sort_by_label(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = sort_by_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('sort_by_label', 1, tmp, _get_sort_by_label_$ref_o8k3sd(), null);
    return tmp0.u1();
  }
  var sort_by_label$delegate;
  function get_sort_name_asc(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = sort_name_asc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('sort_name_asc', 1, tmp, _get_sort_name_asc_$ref_ap2532(), null);
    return tmp0.u1();
  }
  var sort_name_asc$delegate;
  function get_sort_name_desc(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = sort_name_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('sort_name_desc', 1, tmp, _get_sort_name_desc_$ref_3t2yqy(), null);
    return tmp0.u1();
  }
  var sort_name_desc$delegate;
  function get_sort_newest(_this__u8e3s4) {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp0 = sort_newest$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('sort_newest', 1, tmp, _get_sort_newest_$ref_azq2ex(), null);
    return tmp0.u1();
  }
  var sort_newest$delegate;
  function order_status_return_delivery$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20501, 0), new Long(84, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_status_return_delivery', 'order_status_return_delivery', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15581, 0), new Long(60, 0))]));
  }
  function _get_order_status_return_delivery_$ref_gizwab() {
    return constructCallableReference(function (p0) {
      return get_order_status_return_delivery(p0);
    }, 1, 0, 808);
  }
  function order_status_return_requested$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20586, 0), new Long(61, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_status_return_requested', 'order_status_return_requested', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15642, 0), new Long(61, 0))]));
  }
  function _get_order_status_return_requested_$ref_y7xbqz() {
    return constructCallableReference(function (p0) {
      return get_order_status_return_requested(p0);
    }, 1, 0, 809);
  }
  function order_status_returned$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20648, 0), new Long(57, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_status_returned', 'order_status_returned', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15704, 0), new Long(41, 0))]));
  }
  function _get_order_status_returned_$ref_horkvf() {
    return constructCallableReference(function (p0) {
      return get_order_status_returned(p0);
    }, 1, 0, 810);
  }
  function order_subtotal$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20706, 0), new Long(58, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_subtotal', 'order_subtotal', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15746, 0), new Long(34, 0))]));
  }
  function _get_order_subtotal_$ref_3ty9tn() {
    return constructCallableReference(function (p0) {
      return get_order_subtotal(p0);
    }, 1, 0, 811);
  }
  function order_summary_header$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20765, 0), new Long(56, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_summary_header', 'order_summary_header', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15781, 0), new Long(48, 0))]));
  }
  function _get_order_summary_header_$ref_oou11f() {
    return constructCallableReference(function (p0) {
      return get_order_summary_header(p0);
    }, 1, 0, 812);
  }
  function order_total_price$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20822, 0), new Long(61, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:order_total_price', 'order_total_price', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15830, 0), new Long(41, 0))]));
  }
  function _get_order_total_price_$ref_py6d6l() {
    return constructCallableReference(function (p0) {
      return get_order_total_price(p0);
    }, 1, 0, 813);
  }
  function ordered_items_header$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20884, 0), new Long(72, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:ordered_items_header', 'ordered_items_header', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15872, 0), new Long(48, 0))]));
  }
  function _get_ordered_items_header_$ref_a5r5do() {
    return constructCallableReference(function (p0) {
      return get_ordered_items_header(p0);
    }, 1, 0, 814);
  }
  function out_of_stock$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(20957, 0), new Long(44, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:out_of_stock', 'out_of_stock', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15921, 0), new Long(36, 0))]));
  }
  function _get_out_of_stock_$ref_f7opzv() {
    return constructCallableReference(function (p0) {
      return get_out_of_stock(p0);
    }, 1, 0, 815);
  }
  function password_label$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(21002, 0), new Long(50, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:password_label', 'password_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15958, 0), new Long(34, 0))]));
  }
  function _get_password_label_$ref_ft6sru() {
    return constructCallableReference(function (p0) {
      return get_password_label(p0);
    }, 1, 0, 816);
  }
  function password_length_error$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(21053, 0), new Long(125, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:password_length_error', 'password_length_error', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(15993, 0), new Long(81, 0))]));
  }
  function _get_password_length_error_$ref_9rcrxv() {
    return constructCallableReference(function (p0) {
      return get_password_length_error(p0);
    }, 1, 0, 817);
  }
  function password_reset_sent$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(21179, 0), new Long(123, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:password_reset_sent', 'password_reset_sent', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16075, 0), new Long(63, 0))]));
  }
  function _get_password_reset_sent_$ref_axwe98() {
    return constructCallableReference(function (p0) {
      return get_password_reset_sent(p0);
    }, 1, 0, 818);
  }
  function password_updated$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(21303, 0), new Long(88, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:password_updated', 'password_updated', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16139, 0), new Long(64, 0))]));
  }
  function _get_password_updated_$ref_fcgygz() {
    return constructCallableReference(function (p0) {
      return get_password_updated(p0);
    }, 1, 0, 819);
  }
  function passwords_dont_match$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(21392, 0), new Long(96, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:passwords_dont_match', 'passwords_dont_match', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16204, 0), new Long(60, 0))]));
  }
  function _get_passwords_dont_match_$ref_wawm7w() {
    return constructCallableReference(function (p0) {
      return get_passwords_dont_match(p0);
    }, 1, 0, 820);
  }
  function payment_method_header$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(21489, 0), new Long(57, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:payment_method_header', 'payment_method_header', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16265, 0), new Long(49, 0))]));
  }
  function _get_payment_method_header_$ref_yz5e1a() {
    return constructCallableReference(function (p0) {
      return get_payment_method_header(p0);
    }, 1, 0, 821);
  }
  function phone_number_label$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(21547, 0), new Long(54, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:phone_number_label', 'phone_number_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16315, 0), new Long(42, 0))]));
  }
  function _get_phone_number_label_$ref_y5x0vf() {
    return constructCallableReference(function (p0) {
      return get_phone_number_label(p0);
    }, 1, 0, 822);
  }
  function phone_personal_label_required$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(21602, 0), new Long(73, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:phone_personal_label_required', 'phone_personal_label_required', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16358, 0), new Long(61, 0))]));
  }
  function _get_phone_personal_label_required_$ref_5cxobc() {
    return constructCallableReference(function (p0) {
      return get_phone_personal_label_required(p0);
    }, 1, 0, 823);
  }
  function phone_personal_prefix_pattern$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(21676, 0), new Long(57, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:phone_personal_prefix_pattern', 'phone_personal_prefix_pattern', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16420, 0), new Long(57, 0))]));
  }
  function _get_phone_personal_prefix_pattern_$ref_h0152n() {
    return constructCallableReference(function (p0) {
      return get_phone_personal_prefix_pattern(p0);
    }, 1, 0, 824);
  }
  function phone_verified_call_support$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(21734, 0), new Long(163, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:phone_verified_call_support', 'phone_verified_call_support', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16478, 0), new Long(135, 0))]));
  }
  function _get_phone_verified_call_support_$ref_j0rjbg() {
    return constructCallableReference(function (p0) {
      return get_phone_verified_call_support(p0);
    }, 1, 0, 825);
  }
  function phone_work_label$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(21898, 0), new Long(52, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:phone_work_label', 'phone_work_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16614, 0), new Long(40, 0))]));
  }
  function _get_phone_work_label_$ref_60nowz() {
    return constructCallableReference(function (p0) {
      return get_phone_work_label(p0);
    }, 1, 0, 826);
  }
  function phone_work_prefix_pattern$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(21951, 0), new Long(49, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:phone_work_prefix_pattern', 'phone_work_prefix_pattern', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16655, 0), new Long(49, 0))]));
  }
  function _get_phone_work_prefix_pattern_$ref_y2sri8() {
    return constructCallableReference(function (p0) {
      return get_phone_work_prefix_pattern(p0);
    }, 1, 0, 827);
  }
  function pick_birthday_desc$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22001, 0), new Long(74, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:pick_birthday_desc', 'pick_birthday_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16705, 0), new Long(46, 0))]));
  }
  function _get_pick_birthday_desc_$ref_fpzza3() {
    return constructCallableReference(function (p0) {
      return get_pick_birthday_desc(p0);
    }, 1, 0, 828);
  }
  function pick_date$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22076, 0), new Long(49, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:pick_date', 'pick_date', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16752, 0), new Long(29, 0))]));
  }
  function _get_pick_date_$ref_v4dznw() {
    return constructCallableReference(function (p0) {
      return get_pick_date(p0);
    }, 1, 0, 829);
  }
  function pick_location_desc$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22126, 0), new Long(54, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:pick_location_desc', 'pick_location_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16782, 0), new Long(46, 0))]));
  }
  function _get_pick_location_desc_$ref_j4xy5f() {
    return constructCallableReference(function (p0) {
      return get_pick_location_desc(p0);
    }, 1, 0, 830);
  }
  function please_login_to_add_items_to_cart$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22181, 0), new Long(149, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:please_login_to_add_items_to_cart', 'please_login_to_add_items_to_cart', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16829, 0), new Long(85, 0))]));
  }
  function _get_please_login_to_add_items_to_cart_$ref_l0s3ri() {
    return constructCallableReference(function (p0) {
      return get_please_login_to_add_items_to_cart(p0);
    }, 1, 0, 831);
  }
  function premium_black$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22331, 0), new Long(45, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:premium_black', 'premium_black', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16915, 0), new Long(41, 0))]));
  }
  function price_egp$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22377, 0), new Long(37, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:price_egp', 'price_egp', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16957, 0), new Long(29, 0))]));
  }
  function _get_price_egp_$ref_mbhrxk() {
    return constructCallableReference(function (p0) {
      return get_price_egp(p0);
    }, 1, 0, 832);
  }
  function price_range_label$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22415, 0), new Long(53, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:price_range_label', 'price_range_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(16987, 0), new Long(41, 0))]));
  }
  function _get_price_range_label_$ref_wsl32c() {
    return constructCallableReference(function (p0) {
      return get_price_range_label(p0);
    }, 1, 0, 833);
  }
  function privacy_policy_btn$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22469, 0), new Long(62, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:privacy_policy_btn', 'privacy_policy_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17029, 0), new Long(46, 0))]));
  }
  function _get_privacy_policy_btn_$ref_5k9wic() {
    return constructCallableReference(function (p0) {
      return get_privacy_policy_btn(p0);
    }, 1, 0, 834);
  }
  function privacy_policy_required$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22532, 0), new Long(131, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:privacy_policy_required', 'privacy_policy_required', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17076, 0), new Long(95, 0))]));
  }
  function _get_privacy_policy_required_$ref_seg2ff() {
    return constructCallableReference(function (p0) {
      return get_privacy_policy_required(p0);
    }, 1, 0, 835);
  }
  function proceed_to_checkout$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22664, 0), new Long(67, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:proceed_to_checkout', 'proceed_to_checkout', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17172, 0), new Long(55, 0))]));
  }
  function _get_proceed_to_checkout_$ref_wjzt21() {
    return constructCallableReference(function (p0) {
      return get_proceed_to_checkout(p0);
    }, 1, 0, 836);
  }
  function product$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22949, 0), new Long(27, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:product', 'product', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17389, 0), new Long(27, 0))]));
  }
  function _get_product_$ref_rfruof() {
    return constructCallableReference(function (p0) {
      return get_product(p0);
    }, 1, 0, 837);
  }
  function product_info_missing$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22732, 0), new Long(96, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:product_info_missing', 'product_info_missing', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17228, 0), new Long(80, 0))]));
  }
  function _get_product_info_missing_$ref_m3xrcl() {
    return constructCallableReference(function (p0) {
      return get_product_info_missing(p0);
    }, 1, 0, 838);
  }
  function product_kind$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22829, 0), new Long(48, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:product_kind', 'product_kind', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17309, 0), new Long(36, 0))]));
  }
  function products_found$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22878, 0), new Long(70, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:products_found', 'products_found', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17346, 0), new Long(42, 0))]));
  }
  function _get_products_found_$ref_jpiqz1() {
    return constructCallableReference(function (p0) {
      return get_products_found(p0);
    }, 1, 0, 839);
  }
  function profile_pic_desc$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(22977, 0), new Long(68, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:profile_pic_desc', 'profile_pic_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17417, 0), new Long(44, 0))]));
  }
  function _get_profile_pic_desc_$ref_3z5hha() {
    return constructCallableReference(function (p0) {
      return get_profile_pic_desc(p0);
    }, 1, 0, 840);
  }
  function profile_title$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23046, 0), new Long(53, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:profile_title', 'profile_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17462, 0), new Long(33, 0))]));
  }
  function _get_profile_title_$ref_hync5a() {
    return constructCallableReference(function (p0) {
      return get_profile_title(p0);
    }, 1, 0, 841);
  }
  function promotion_banner_desc$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23100, 0), new Long(61, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:promotion_banner_desc', 'promotion_banner_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17496, 0), new Long(53, 0))]));
  }
  function quantity_label$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23162, 0), new Long(38, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:quantity_label', 'quantity_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17550, 0), new Long(34, 0))]));
  }
  function _get_quantity_label_$ref_w7hlx6() {
    return constructCallableReference(function (p0) {
      return get_quantity_label(p0);
    }, 1, 0, 842);
  }
  function rating_desc$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23201, 0), new Long(39, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:rating_desc', 'rating_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17585, 0), new Long(27, 0))]));
  }
  function re_add_to_cart$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23241, 0), new Long(70, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:re_add_to_cart', 're_add_to_cart', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17613, 0), new Long(42, 0))]));
  }
  function _get_re_add_to_cart_$ref_wyqigw() {
    return constructCallableReference(function (p0) {
      return get_re_add_to_cart(p0);
    }, 1, 0, 843);
  }
  function receiver_address_label$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23312, 0), new Long(50, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:receiver_address_label', 'receiver_address_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17656, 0), new Long(42, 0))]));
  }
  function receiver_info_header$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23363, 0), new Long(64, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:receiver_info_header', 'receiver_info_header', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17699, 0), new Long(56, 0))]));
  }
  function receiver_name_label$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23428, 0), new Long(43, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:receiver_name_label', 'receiver_name_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17756, 0), new Long(35, 0))]));
  }
  function _get_receiver_name_label_$ref_qo70c0() {
    return constructCallableReference(function (p0) {
      return get_receiver_name_label(p0);
    }, 1, 0, 844);
  }
  function receiver_payment_label$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23472, 0), new Long(46, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:receiver_payment_label', 'receiver_payment_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17792, 0), new Long(42, 0))]));
  }
  function receiver_phone_label$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23519, 0), new Long(44, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:receiver_phone_label', 'receiver_phone_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17835, 0), new Long(36, 0))]));
  }
  function refresh_data$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23564, 0), new Long(56, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:refresh_data', 'refresh_data', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17872, 0), new Long(36, 0))]));
  }
  function registration_failed$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23621, 0), new Long(67, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:registration_failed', 'registration_failed', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17909, 0), new Long(55, 0))]));
  }
  function registration_successful$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23689, 0), new Long(167, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:registration_successful', 'registration_successful', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(17965, 0), new Long(99, 0))]));
  }
  function _get_registration_successful_$ref_xny734() {
    return constructCallableReference(function (p0) {
      return get_registration_successful(p0);
    }, 1, 0, 845);
  }
  function relationship_label$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23857, 0), new Long(46, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:relationship_label', 'relationship_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18065, 0), new Long(42, 0))]));
  }
  function _get_relationship_label_$ref_ybmsr7() {
    return constructCallableReference(function (p0) {
      return get_relationship_label(p0);
    }, 1, 0, 846);
  }
  function relationship_not_specified$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23904, 0), new Long(78, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:relationship_not_specified', 'relationship_not_specified', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18108, 0), new Long(70, 0))]));
  }
  function _get_relationship_not_specified_$ref_41xbab() {
    return constructCallableReference(function (p0) {
      return get_relationship_not_specified(p0);
    }, 1, 0, 847);
  }
  function remind_me$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(23983, 0), new Long(33, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:remind_me', 'remind_me', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18179, 0), new Long(29, 0))]));
  }
  function _get_remind_me_$ref_eq6rrm() {
    return constructCallableReference(function (p0) {
      return get_remind_me(p0);
    }, 1, 0, 848);
  }
  function reminder_set$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(24017, 0), new Long(56, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:reminder_set', 'reminder_set', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18209, 0), new Long(36, 0))]));
  }
  function _get_reminder_set_$ref_6roxtn() {
    return constructCallableReference(function (p0) {
      return get_reminder_set(p0);
    }, 1, 0, 849);
  }
  function remove_design_desc$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(24074, 0), new Long(118, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:remove_design_desc', 'remove_design_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18246, 0), new Long(94, 0))]));
  }
  function _get_remove_design_desc_$ref_wfk8gt() {
    return constructCallableReference(function (p0) {
      return get_remove_design_desc(p0);
    }, 1, 0, 850);
  }
  function remove_design_title$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(24193, 0), new Long(63, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:remove_design_title', 'remove_design_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18341, 0), new Long(47, 0))]));
  }
  function _get_remove_design_title_$ref_2seo1e() {
    return constructCallableReference(function (p0) {
      return get_remove_design_title(p0);
    }, 1, 0, 851);
  }
  function remove_from_favorites$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(24332, 0), new Long(69, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:remove_from_favorites', 'remove_from_favorites', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18452, 0), new Long(57, 0))]));
  }
  function _get_remove_from_favorites_$ref_mquw1p() {
    return constructCallableReference(function (p0) {
      return get_remove_from_favorites(p0);
    }, 1, 0, 852);
  }
  function remove_from_favorites_desc$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(24257, 0), new Long(74, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:remove_from_favorites_desc', 'remove_from_favorites_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18389, 0), new Long(62, 0))]));
  }
  function remove_image$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(24402, 0), new Long(52, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:remove_image', 'remove_image', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18510, 0), new Long(36, 0))]));
  }
  function _get_remove_image_$ref_jrljc6() {
    return constructCallableReference(function (p0) {
      return get_remove_image(p0);
    }, 1, 0, 853);
  }
  function remove_item_confirm$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(24455, 0), new Long(131, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:remove_item_confirm', 'remove_item_confirm', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18547, 0), new Long(103, 0))]));
  }
  function _get_remove_item_confirm_$ref_i86wvl() {
    return constructCallableReference(function (p0) {
      return get_remove_item_confirm(p0);
    }, 1, 0, 854);
  }
  function remove_item_desc$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(24587, 0), new Long(56, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:remove_item_desc', 'remove_item_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18651, 0), new Long(40, 0))]));
  }
  function _get_remove_item_desc_$ref_gsmgnc() {
    return constructCallableReference(function (p0) {
      return get_remove_item_desc(p0);
    }, 1, 0, 855);
  }
  function remove_item_title$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(24644, 0), new Long(57, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:remove_item_title', 'remove_item_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18692, 0), new Long(41, 0))]));
  }
  function _get_remove_item_title_$ref_f943hj() {
    return constructCallableReference(function (p0) {
      return get_remove_item_title(p0);
    }, 1, 0, 856);
  }
  function remove_reminder_confirm$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(24702, 0), new Long(139, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:remove_reminder_confirm', 'remove_reminder_confirm', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18734, 0), new Long(123, 0))]));
  }
  function _get_remove_reminder_confirm_$ref_s9kwz6() {
    return constructCallableReference(function (p0) {
      return get_remove_reminder_confirm(p0);
    }, 1, 0, 857);
  }
  function remove_reminder_title$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(24842, 0), new Long(65, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:remove_reminder_title', 'remove_reminder_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18858, 0), new Long(49, 0))]));
  }
  function _get_remove_reminder_title_$ref_hi19qy() {
    return constructCallableReference(function (p0) {
      return get_remove_reminder_title(p0);
    }, 1, 0, 858);
  }
  function reset_filters_btn$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(24908, 0), new Long(49, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:reset_filters_btn', 'reset_filters_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18908, 0), new Long(33, 0))]));
  }
  function _get_reset_filters_btn_$ref_m6p8d4() {
    return constructCallableReference(function (p0) {
      return get_reset_filters_btn(p0);
    }, 1, 0, 859);
  }
  function reset_password$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(25394, 0), new Long(82, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:reset_password', 'reset_password', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19254, 0), new Long(42, 0))]));
  }
  function _get_reset_password_$ref_snxbyn() {
    return constructCallableReference(function (p0) {
      return get_reset_password(p0);
    }, 1, 0, 860);
  }
  function reset_password_complete_steps$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(24958, 0), new Long(257, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:reset_password_complete_steps', 'reset_password_complete_steps', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(18942, 0), new Long(157, 0))]));
  }
  function _get_reset_password_complete_steps_$ref_791xmz() {
    return constructCallableReference(function (p0) {
      return get_reset_password_complete_steps(p0);
    }, 1, 0, 861);
  }
  function reset_password_final_success$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(25216, 0), new Long(104, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:reset_password_final_success', 'reset_password_final_success', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19100, 0), new Long(92, 0))]));
  }
  function reset_password_success_title$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(25321, 0), new Long(72, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:reset_password_success_title', 'reset_password_success_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19193, 0), new Long(60, 0))]));
  }
  function _get_reset_password_success_title_$ref_j7560e() {
    return constructCallableReference(function (p0) {
      return get_reset_password_success_title(p0);
    }, 1, 0, 862);
  }
  function reset_setting$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(25477, 0), new Long(45, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:reset_setting', 'reset_setting', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19297, 0), new Long(29, 0))]));
  }
  function retry$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(25523, 0), new Long(49, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:retry', 'retry', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19327, 0), new Long(21, 0))]));
  }
  function _get_retry_$ref_u1ih08() {
    return constructCallableReference(function (p0) {
      return get_retry(p0);
    }, 1, 0, 863);
  }
  function return_order_btn$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(25573, 0), new Long(52, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:return_order_btn', 'return_order_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19349, 0), new Long(40, 0))]));
  }
  function _get_return_order_btn_$ref_ko5k2q() {
    return constructCallableReference(function (p0) {
      return get_return_order_btn(p0);
    }, 1, 0, 864);
  }
  function return_reason_dialog_title$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(25626, 0), new Long(62, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:return_reason_dialog_title', 'return_reason_dialog_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19390, 0), new Long(58, 0))]));
  }
  function _get_return_reason_dialog_title_$ref_16lj3h() {
    return constructCallableReference(function (p0) {
      return get_return_reason_dialog_title(p0);
    }, 1, 0, 865);
  }
  function return_reason_placeholder$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(25689, 0), new Long(133, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:return_reason_placeholder', 'return_reason_placeholder', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19449, 0), new Long(101, 0))]));
  }
  function _get_return_reason_placeholder_$ref_4v1rnr() {
    return constructCallableReference(function (p0) {
      return get_return_reason_placeholder(p0);
    }, 1, 0, 866);
  }
  function return_request_submitted$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(25823, 0), new Long(100, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:return_request_submitted', 'return_request_submitted', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19551, 0), new Long(84, 0))]));
  }
  function review_order_title$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(25924, 0), new Long(58, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:review_order_title', 'review_order_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19636, 0), new Long(42, 0))]));
  }
  function _get_review_order_title_$ref_eyifcq() {
    return constructCallableReference(function (p0) {
      return get_review_order_title(p0);
    }, 1, 0, 867);
  }
  function rose_gold$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(25983, 0), new Long(41, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:rose_gold', 'rose_gold', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19679, 0), new Long(29, 0))]));
  }
  function rotate_label$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26025, 0), new Long(36, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:rotate_label', 'rotate_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19709, 0), new Long(28, 0))]));
  }
  function _get_rotate_label_$ref_jfdis6() {
    return constructCallableReference(function (p0) {
      return get_rotate_label(p0);
    }, 1, 0, 868);
  }
  function save$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26125, 0), new Long(20, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:save', 'save', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19789, 0), new Long(20, 0))]));
  }
  function _get_save_$ref_r0beql() {
    return constructCallableReference(function (p0) {
      return get_save(p0);
    }, 1, 0, 869);
  }
  function saved_successfully$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26062, 0), new Long(62, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:saved_successfully', 'saved_successfully', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19738, 0), new Long(50, 0))]));
  }
  function _get_saved_successfully_$ref_9570fv() {
    return constructCallableReference(function (p0) {
      return get_saved_successfully(p0);
    }, 1, 0, 870);
  }
  function scroll_for_more$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26146, 0), new Long(71, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:scroll_for_more', 'scroll_for_more', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19810, 0), new Long(43, 0))]));
  }
  function search_placeholder$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26218, 0), new Long(38, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:search_placeholder', 'search_placeholder', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19854, 0), new Long(38, 0))]));
  }
  function _get_search_placeholder_$ref_kpeqqq() {
    return constructCallableReference(function (p0) {
      return get_search_placeholder(p0);
    }, 1, 0, 871);
  }
  function select_birthday$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26257, 0), new Long(71, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:select_birthday', 'select_birthday', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19893, 0), new Long(51, 0))]));
  }
  function select_box$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26329, 0), new Long(58, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:select_box', 'select_box', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19945, 0), new Long(34, 0))]));
  }
  function _get_select_box_$ref_iqgfta() {
    return constructCallableReference(function (p0) {
      return get_select_box(p0);
    }, 1, 0, 872);
  }
  function select_card$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26388, 0), new Long(59, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:select_card', 'select_card', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(19980, 0), new Long(39, 0))]));
  }
  function _get_select_card_$ref_ig2efn() {
    return constructCallableReference(function (p0) {
      return get_select_card(p0);
    }, 1, 0, 873);
  }
  function select_color$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26448, 0), new Long(48, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:select_color', 'select_color', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20020, 0), new Long(36, 0))]));
  }
  function _get_select_color_$ref_hltrve() {
    return constructCallableReference(function (p0) {
      return get_select_color(p0);
    }, 1, 0, 874);
  }
  function select_friend_header$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26497, 0), new Long(56, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:select_friend_header', 'select_friend_header', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20057, 0), new Long(48, 0))]));
  }
  function select_language_title$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26554, 0), new Long(57, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:select_language_title', 'select_language_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20106, 0), new Long(49, 0))]));
  }
  function _get_select_language_title_$ref_4wilws() {
    return constructCallableReference(function (p0) {
      return get_select_language_title(p0);
    }, 1, 0, 875);
  }
  function select_size$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26612, 0), new Long(47, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:select_size', 'select_size', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20156, 0), new Long(35, 0))]));
  }
  function _get_select_size_$ref_66eyg4() {
    return constructCallableReference(function (p0) {
      return get_select_size(p0);
    }, 1, 0, 876);
  }
  function send_reset_link_btn$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26660, 0), new Long(87, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:send_reset_link_btn', 'send_reset_link_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20192, 0), new Long(47, 0))]));
  }
  function _get_send_reset_link_btn_$ref_mbq7oe() {
    return constructCallableReference(function (p0) {
      return get_send_reset_link_btn(p0);
    }, 1, 0, 877);
  }
  function set_new_password_title$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26748, 0), new Long(82, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:set_new_password_title', 'set_new_password_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20240, 0), new Long(54, 0))]));
  }
  function share_product$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26831, 0), new Long(37, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:share_product', 'share_product', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20295, 0), new Long(29, 0))]));
  }
  function _get_share_product_$ref_26oep() {
    return constructCallableReference(function (p0) {
      return get_share_product(p0);
    }, 1, 0, 878);
  }
  function shipping_for_friend$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27177, 0), new Long(43, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:shipping_for_friend', 'shipping_for_friend', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20525, 0), new Long(43, 0))]));
  }
  function shipping_for_friend_prepayment_note$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(26869, 0), new Long(307, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:shipping_for_friend_prepayment_note', 'shipping_for_friend_prepayment_note', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20325, 0), new Long(199, 0))]));
  }
  function shipping_for_me$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27221, 0), new Long(31, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:shipping_for_me', 'shipping_for_me', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20569, 0), new Long(31, 0))]));
  }
  function show_password$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27253, 0), new Long(65, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:show_password', 'show_password', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20601, 0), new Long(41, 0))]));
  }
  function _get_show_password_$ref_afmg8z() {
    return constructCallableReference(function (p0) {
      return get_show_password(p0);
    }, 1, 0, 879);
  }
  function sign_up_btn$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27319, 0), new Long(47, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:sign_up_btn', 'sign_up_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20643, 0), new Long(31, 0))]));
  }
  function _get_sign_up_btn_$ref_qbtl8m() {
    return constructCallableReference(function (p0) {
      return get_sign_up_btn(p0);
    }, 1, 0, 880);
  }
  function size_label$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27367, 0), new Long(34, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:size_label', 'size_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20675, 0), new Long(26, 0))]));
  }
  function _get_size_label_$ref_pm070k() {
    return constructCallableReference(function (p0) {
      return get_size_label(p0);
    }, 1, 0, 881);
  }
  function sort_by_label$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27402, 0), new Long(45, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:sort_by_label', 'sort_by_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20702, 0), new Long(33, 0))]));
  }
  function _get_sort_by_label_$ref_o8k3sd() {
    return constructCallableReference(function (p0) {
      return get_sort_by_label(p0);
    }, 1, 0, 882);
  }
  function sort_name_asc$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27448, 0), new Long(45, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:sort_name_asc', 'sort_name_asc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20736, 0), new Long(37, 0))]));
  }
  function _get_sort_name_asc_$ref_ap2532() {
    return constructCallableReference(function (p0) {
      return get_sort_name_asc(p0);
    }, 1, 0, 883);
  }
  function sort_name_desc$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27494, 0), new Long(46, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:sort_name_desc', 'sort_name_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20774, 0), new Long(38, 0))]));
  }
  function _get_sort_name_desc_$ref_3t2yqy() {
    return constructCallableReference(function (p0) {
      return get_sort_name_desc(p0);
    }, 1, 0, 884);
  }
  function sort_newest$delegate$lambda() {
    _init_properties_String3_commonMain_kt__iyyouo();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27541, 0), new Long(35, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:sort_newest', 'sort_newest', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20813, 0), new Long(27, 0))]));
  }
  function _get_sort_newest_$ref_azq2ex() {
    return constructCallableReference(function (p0) {
      return get_sort_newest(p0);
    }, 1, 0, 885);
  }
  var properties_initialized_String3_commonMain_kt_ams8s2;
  function _init_properties_String3_commonMain_kt__iyyouo() {
    if (!properties_initialized_String3_commonMain_kt_ams8s2) {
      properties_initialized_String3_commonMain_kt_ams8s2 = true;
      order_status_return_delivery$delegate = lazy(order_status_return_delivery$delegate$lambda);
      order_status_return_requested$delegate = lazy(order_status_return_requested$delegate$lambda);
      order_status_returned$delegate = lazy(order_status_returned$delegate$lambda);
      order_subtotal$delegate = lazy(order_subtotal$delegate$lambda);
      order_summary_header$delegate = lazy(order_summary_header$delegate$lambda);
      order_total_price$delegate = lazy(order_total_price$delegate$lambda);
      ordered_items_header$delegate = lazy(ordered_items_header$delegate$lambda);
      out_of_stock$delegate = lazy(out_of_stock$delegate$lambda);
      password_label$delegate = lazy(password_label$delegate$lambda);
      password_length_error$delegate = lazy(password_length_error$delegate$lambda);
      password_reset_sent$delegate = lazy(password_reset_sent$delegate$lambda);
      password_updated$delegate = lazy(password_updated$delegate$lambda);
      passwords_dont_match$delegate = lazy(passwords_dont_match$delegate$lambda);
      payment_method_header$delegate = lazy(payment_method_header$delegate$lambda);
      phone_number_label$delegate = lazy(phone_number_label$delegate$lambda);
      phone_personal_label_required$delegate = lazy(phone_personal_label_required$delegate$lambda);
      phone_personal_prefix_pattern$delegate = lazy(phone_personal_prefix_pattern$delegate$lambda);
      phone_verified_call_support$delegate = lazy(phone_verified_call_support$delegate$lambda);
      phone_work_label$delegate = lazy(phone_work_label$delegate$lambda);
      phone_work_prefix_pattern$delegate = lazy(phone_work_prefix_pattern$delegate$lambda);
      pick_birthday_desc$delegate = lazy(pick_birthday_desc$delegate$lambda);
      pick_date$delegate = lazy(pick_date$delegate$lambda);
      pick_location_desc$delegate = lazy(pick_location_desc$delegate$lambda);
      please_login_to_add_items_to_cart$delegate = lazy(please_login_to_add_items_to_cart$delegate$lambda);
      premium_black$delegate = lazy(premium_black$delegate$lambda);
      price_egp$delegate = lazy(price_egp$delegate$lambda);
      price_range_label$delegate = lazy(price_range_label$delegate$lambda);
      privacy_policy_btn$delegate = lazy(privacy_policy_btn$delegate$lambda);
      privacy_policy_required$delegate = lazy(privacy_policy_required$delegate$lambda);
      proceed_to_checkout$delegate = lazy(proceed_to_checkout$delegate$lambda);
      product$delegate = lazy(product$delegate$lambda);
      product_info_missing$delegate = lazy(product_info_missing$delegate$lambda);
      product_kind$delegate = lazy(product_kind$delegate$lambda);
      products_found$delegate = lazy(products_found$delegate$lambda);
      profile_pic_desc$delegate = lazy(profile_pic_desc$delegate$lambda);
      profile_title$delegate = lazy(profile_title$delegate$lambda);
      promotion_banner_desc$delegate = lazy(promotion_banner_desc$delegate$lambda);
      quantity_label$delegate = lazy(quantity_label$delegate$lambda);
      rating_desc$delegate = lazy(rating_desc$delegate$lambda);
      re_add_to_cart$delegate = lazy(re_add_to_cart$delegate$lambda);
      receiver_address_label$delegate = lazy(receiver_address_label$delegate$lambda);
      receiver_info_header$delegate = lazy(receiver_info_header$delegate$lambda);
      receiver_name_label$delegate = lazy(receiver_name_label$delegate$lambda);
      receiver_payment_label$delegate = lazy(receiver_payment_label$delegate$lambda);
      receiver_phone_label$delegate = lazy(receiver_phone_label$delegate$lambda);
      refresh_data$delegate = lazy(refresh_data$delegate$lambda);
      registration_failed$delegate = lazy(registration_failed$delegate$lambda);
      registration_successful$delegate = lazy(registration_successful$delegate$lambda);
      relationship_label$delegate = lazy(relationship_label$delegate$lambda);
      relationship_not_specified$delegate = lazy(relationship_not_specified$delegate$lambda);
      remind_me$delegate = lazy(remind_me$delegate$lambda);
      reminder_set$delegate = lazy(reminder_set$delegate$lambda);
      remove_design_desc$delegate = lazy(remove_design_desc$delegate$lambda);
      remove_design_title$delegate = lazy(remove_design_title$delegate$lambda);
      remove_from_favorites$delegate = lazy(remove_from_favorites$delegate$lambda);
      remove_from_favorites_desc$delegate = lazy(remove_from_favorites_desc$delegate$lambda);
      remove_image$delegate = lazy(remove_image$delegate$lambda);
      remove_item_confirm$delegate = lazy(remove_item_confirm$delegate$lambda);
      remove_item_desc$delegate = lazy(remove_item_desc$delegate$lambda);
      remove_item_title$delegate = lazy(remove_item_title$delegate$lambda);
      remove_reminder_confirm$delegate = lazy(remove_reminder_confirm$delegate$lambda);
      remove_reminder_title$delegate = lazy(remove_reminder_title$delegate$lambda);
      reset_filters_btn$delegate = lazy(reset_filters_btn$delegate$lambda);
      reset_password$delegate = lazy(reset_password$delegate$lambda);
      reset_password_complete_steps$delegate = lazy(reset_password_complete_steps$delegate$lambda);
      reset_password_final_success$delegate = lazy(reset_password_final_success$delegate$lambda);
      reset_password_success_title$delegate = lazy(reset_password_success_title$delegate$lambda);
      reset_setting$delegate = lazy(reset_setting$delegate$lambda);
      retry$delegate = lazy(retry$delegate$lambda);
      return_order_btn$delegate = lazy(return_order_btn$delegate$lambda);
      return_reason_dialog_title$delegate = lazy(return_reason_dialog_title$delegate$lambda);
      return_reason_placeholder$delegate = lazy(return_reason_placeholder$delegate$lambda);
      return_request_submitted$delegate = lazy(return_request_submitted$delegate$lambda);
      review_order_title$delegate = lazy(review_order_title$delegate$lambda);
      rose_gold$delegate = lazy(rose_gold$delegate$lambda);
      rotate_label$delegate = lazy(rotate_label$delegate$lambda);
      save$delegate = lazy(save$delegate$lambda);
      saved_successfully$delegate = lazy(saved_successfully$delegate$lambda);
      scroll_for_more$delegate = lazy(scroll_for_more$delegate$lambda);
      search_placeholder$delegate = lazy(search_placeholder$delegate$lambda);
      select_birthday$delegate = lazy(select_birthday$delegate$lambda);
      select_box$delegate = lazy(select_box$delegate$lambda);
      select_card$delegate = lazy(select_card$delegate$lambda);
      select_color$delegate = lazy(select_color$delegate$lambda);
      select_friend_header$delegate = lazy(select_friend_header$delegate$lambda);
      select_language_title$delegate = lazy(select_language_title$delegate$lambda);
      select_size$delegate = lazy(select_size$delegate$lambda);
      send_reset_link_btn$delegate = lazy(send_reset_link_btn$delegate$lambda);
      set_new_password_title$delegate = lazy(set_new_password_title$delegate$lambda);
      share_product$delegate = lazy(share_product$delegate$lambda);
      shipping_for_friend$delegate = lazy(shipping_for_friend$delegate$lambda);
      shipping_for_friend_prepayment_note$delegate = lazy(shipping_for_friend_prepayment_note$delegate$lambda);
      shipping_for_me$delegate = lazy(shipping_for_me$delegate$lambda);
      show_password$delegate = lazy(show_password$delegate$lambda);
      sign_up_btn$delegate = lazy(sign_up_btn$delegate$lambda);
      size_label$delegate = lazy(size_label$delegate$lambda);
      sort_by_label$delegate = lazy(sort_by_label$delegate$lambda);
      sort_name_asc$delegate = lazy(sort_name_asc$delegate$lambda);
      sort_name_desc$delegate = lazy(sort_name_desc$delegate$lambda);
      sort_newest$delegate = lazy(sort_newest$delegate$lambda);
    }
  }
  function get_sort_oldest(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = sort_oldest$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('sort_oldest', 1, tmp, _get_sort_oldest_$ref_t97fi8(), null);
    return tmp0.u1();
  }
  var sort_oldest$delegate;
  function get_sort_price_high_low(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = sort_price_high_low$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('sort_price_high_low', 1, tmp, _get_sort_price_high_low_$ref_6odifm(), null);
    return tmp0.u1();
  }
  var sort_price_high_low$delegate;
  function get_sort_price_low_high(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = sort_price_low_high$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('sort_price_low_high', 1, tmp, _get_sort_price_low_high_$ref_2s9738(), null);
    return tmp0.u1();
  }
  var sort_price_low_high$delegate;
  var source_camera$delegate;
  var source_gallery$delegate;
  function get_standard_products_label(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = standard_products_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('standard_products_label', 1, tmp, _get_standard_products_label_$ref_zd3wzf(), null);
    return tmp0.u1();
  }
  var standard_products_label$delegate;
  function get_stock_reminders(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = stock_reminders$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('stock_reminders', 1, tmp, _get_stock_reminders_$ref_ok544o(), null);
    return tmp0.u1();
  }
  var stock_reminders$delegate;
  function get_street_label(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = street_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('street_label', 1, tmp, _get_street_label_$ref_hrhloe(), null);
    return tmp0.u1();
  }
  var street_label$delegate;
  function get_success(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = success$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('success', 1, tmp, _get_success_$ref_g12onx(), null);
    return tmp0.u1();
  }
  var success$delegate;
  function get_support_whatsapp_url(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = support_whatsapp_url$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('support_whatsapp_url', 1, tmp, _get_support_whatsapp_url_$ref_6pkwug(), null);
    return tmp0.u1();
  }
  var support_whatsapp_url$delegate;
  function get_tap_to_select_file(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = tap_to_select_file$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('tap_to_select_file', 1, tmp, _get_tap_to_select_file_$ref_eiyjfh(), null);
    return tmp0.u1();
  }
  var tap_to_select_file$delegate;
  var target_audience$delegate;
  function get_text_cannot_be_empty(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = text_cannot_be_empty$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('text_cannot_be_empty', 1, tmp, _get_text_cannot_be_empty_$ref_8v2d9b(), null);
    return tmp0.u1();
  }
  var text_cannot_be_empty$delegate;
  function get_text_settings(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = text_settings$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('text_settings', 1, tmp, _get_text_settings_$ref_rnqil1(), null);
    return tmp0.u1();
  }
  var text_settings$delegate;
  function get_texture_desc(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = texture_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('texture_desc', 1, tmp, _get_texture_desc_$ref_6kccwr(), null);
    return tmp0.u1();
  }
  var texture_desc$delegate;
  function get_thumbnail_index(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = thumbnail_index$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('thumbnail_index', 1, tmp, _get_thumbnail_index_$ref_w8clb3(), null);
    return tmp0.u1();
  }
  var thumbnail_index$delegate;
  function get_tooltip_add_photo(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = tooltip_add_photo$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('tooltip_add_photo', 1, tmp, _get_tooltip_add_photo_$ref_hszyzs(), null);
    return tmp0.u1();
  }
  var tooltip_add_photo$delegate;
  function get_tooltip_add_text(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = tooltip_add_text$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('tooltip_add_text', 1, tmp, _get_tooltip_add_text_$ref_lf7u3x(), null);
    return tmp0.u1();
  }
  var tooltip_add_text$delegate;
  var tooltip_center$delegate;
  var tooltip_decrease_height$delegate;
  var tooltip_decrease_width$delegate;
  var tooltip_delete$delegate;
  var tooltip_edit_text$delegate;
  var tooltip_fit$delegate;
  var tooltip_flip_h$delegate;
  var tooltip_flip_v$delegate;
  var tooltip_increase_height$delegate;
  var tooltip_increase_width$delegate;
  var tooltip_reset$delegate;
  var tooltip_rotate_left$delegate;
  var tooltip_rotate_right$delegate;
  var tooltip_send_to_back$delegate;
  function get_tooltip_take_photo(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = tooltip_take_photo$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('tooltip_take_photo', 1, tmp, _get_tooltip_take_photo_$ref_xug7lo(), null);
    return tmp0.u1();
  }
  var tooltip_take_photo$delegate;
  function get_total_price_label(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = total_price_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('total_price_label', 1, tmp, _get_total_price_label_$ref_egxrq5(), null);
    return tmp0.u1();
  }
  var total_price_label$delegate;
  function get_unexpected_error(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = unexpected_error$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('unexpected_error', 1, tmp, _get_unexpected_error_$ref_mgbog(), null);
    return tmp0.u1();
  }
  var unexpected_error$delegate;
  function get_unknown_error(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = unknown_error$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('unknown_error', 1, tmp, _get_unknown_error_$ref_jr3tmb(), null);
    return tmp0.u1();
  }
  var unknown_error$delegate;
  function get_update(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = update$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('update', 1, tmp, _get_update_$ref_tt3041(), null);
    return tmp0.u1();
  }
  var update$delegate;
  function get_update_app_btn(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = update_app_btn$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('update_app_btn', 1, tmp, _get_update_app_btn_$ref_bgn7hu(), null);
    return tmp0.u1();
  }
  var update_app_btn$delegate;
  function get_update_app_desc(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = update_app_desc$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('update_app_desc', 1, tmp, _get_update_app_desc_$ref_pi2wor(), null);
    return tmp0.u1();
  }
  var update_app_desc$delegate;
  function get_update_app_title(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = update_app_title$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('update_app_title', 1, tmp, _get_update_app_title_$ref_heped2(), null);
    return tmp0.u1();
  }
  var update_app_title$delegate;
  function get_update_failed_e_message(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = update_failed_e_message$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('update_failed_e_message', 1, tmp, _get_update_failed_e_message_$ref_75vykf(), null);
    return tmp0.u1();
  }
  var update_failed_e_message$delegate;
  function get_upload_texture_image(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = upload_texture_image$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('upload_texture_image', 1, tmp, _get_upload_texture_image_$ref_lzy9en(), null);
    return tmp0.u1();
  }
  var upload_texture_image$delegate;
  var used_coupons_header$delegate;
  function get_used_coupons_tab(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = used_coupons_tab$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('used_coupons_tab', 1, tmp, _get_used_coupons_tab_$ref_s3pwjr(), null);
    return tmp0.u1();
  }
  var used_coupons_tab$delegate;
  var user$delegate;
  function get_user_already_registered(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = user_already_registered$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('user_already_registered', 1, tmp, _get_user_already_registered_$ref_v27msd(), null);
    return tmp0.u1();
  }
  var user_already_registered$delegate;
  function get_user_banned_error(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = user_banned_error$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('user_banned_error', 1, tmp, _get_user_banned_error_$ref_pt0ttx(), null);
    return tmp0.u1();
  }
  var user_banned_error$delegate;
  function get_user_comment_label(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = user_comment_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('user_comment_label', 1, tmp, _get_user_comment_label_$ref_vqjqsa(), null);
    return tmp0.u1();
  }
  var user_comment_label$delegate;
  function get_user_not_found(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = user_not_found$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('user_not_found', 1, tmp, _get_user_not_found_$ref_3c0u1k(), null);
    return tmp0.u1();
  }
  var user_not_found$delegate;
  function get_user_not_logged_in(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = user_not_logged_in$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('user_not_logged_in', 1, tmp, _get_user_not_logged_in_$ref_e0ioew(), null);
    return tmp0.u1();
  }
  var user_not_logged_in$delegate;
  function get_verified_phone(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = verified_phone$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('verified_phone', 1, tmp, _get_verified_phone_$ref_u80wgt(), null);
    return tmp0.u1();
  }
  var verified_phone$delegate;
  function get_video_thumbnail(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = video_thumbnail$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('video_thumbnail', 1, tmp, _get_video_thumbnail_$ref_9aoqso(), null);
    return tmp0.u1();
  }
  var video_thumbnail$delegate;
  function get_visa_label(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = visa_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('visa_label', 1, tmp, _get_visa_label_$ref_g85ynw(), null);
    return tmp0.u1();
  }
  var visa_label$delegate;
  function get_wallet(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = wallet$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('wallet', 1, tmp, _get_wallet_$ref_q19wrl(), null);
    return tmp0.u1();
  }
  var wallet$delegate;
  function get_weak_password(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = weak_password$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('weak_password', 1, tmp, _get_weak_password_$ref_jiw4ci(), null);
    return tmp0.u1();
  }
  var weak_password$delegate;
  function get_welcome_back(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = welcome_back$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('welcome_back', 1, tmp, _get_welcome_back_$ref_9frmui(), null);
    return tmp0.u1();
  }
  var welcome_back$delegate;
  function get_whatsapp_contact(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = whatsapp_contact$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('whatsapp_contact', 1, tmp, _get_whatsapp_contact_$ref_78kh21(), null);
    return tmp0.u1();
  }
  var whatsapp_contact$delegate;
  function get_width_label(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = width_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('width_label', 1, tmp, _get_width_label_$ref_wjimvv(), null);
    return tmp0.u1();
  }
  var width_label$delegate;
  function get_with_templates_label(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = with_templates_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('with_templates_label', 1, tmp, _get_with_templates_label_$ref_78ivbv(), null);
    return tmp0.u1();
  }
  var with_templates_label$delegate;
  function get_without_templates_label(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = without_templates_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('without_templates_label', 1, tmp, _get_without_templates_label_$ref_2ma713(), null);
    return tmp0.u1();
  }
  var without_templates_label$delegate;
  function get_your_order_has_been_placed_successfully(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = your_order_has_been_placed_successfully$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('your_order_has_been_placed_successfully', 1, tmp, _get_your_order_has_been_placed_successfully_$ref_ifpzjs(), null);
    return tmp0.u1();
  }
  var your_order_has_been_placed_successfully$delegate;
  function get_youth_label(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = youth_label$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('youth_label', 1, tmp, _get_youth_label_$ref_t22w6w(), null);
    return tmp0.u1();
  }
  var youth_label$delegate;
  function get_yyyy_mm_dd_placeholder(_this__u8e3s4) {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp0 = yyyy_mm_dd_placeholder$delegate;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('yyyy_mm_dd_placeholder', 1, tmp, _get_yyyy_mm_dd_placeholder_$ref_1rgarq(), null);
    return tmp0.u1();
  }
  var yyyy_mm_dd_placeholder$delegate;
  function sort_oldest$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27577, 0), new Long(35, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:sort_oldest', 'sort_oldest', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20841, 0), new Long(27, 0))]));
  }
  function _get_sort_oldest_$ref_t97fi8() {
    return constructCallableReference(function (p0) {
      return get_sort_oldest(p0);
    }, 1, 0, 886);
  }
  function sort_price_high_low$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27613, 0), new Long(83, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:sort_price_high_low', 'sort_price_high_low', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20869, 0), new Long(51, 0))]));
  }
  function _get_sort_price_high_low_$ref_6odifm() {
    return constructCallableReference(function (p0) {
      return get_sort_price_high_low(p0);
    }, 1, 0, 887);
  }
  function sort_price_low_high$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27697, 0), new Long(83, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:sort_price_low_high', 'sort_price_low_high', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20921, 0), new Long(51, 0))]));
  }
  function _get_sort_price_low_high_$ref_2s9738() {
    return constructCallableReference(function (p0) {
      return get_sort_price_low_high(p0);
    }, 1, 0, 888);
  }
  function source_camera$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27781, 0), new Long(45, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:source_camera', 'source_camera', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(20973, 0), new Long(29, 0))]));
  }
  function source_gallery$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27827, 0), new Long(38, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:source_gallery', 'source_gallery', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21003, 0), new Long(34, 0))]));
  }
  function standard_products_label$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27866, 0), new Long(63, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:standard_products_label', 'standard_products_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21038, 0), new Long(55, 0))]));
  }
  function _get_standard_products_label_$ref_zd3wzf() {
    return constructCallableReference(function (p0) {
      return get_standard_products_label(p0);
    }, 1, 0, 889);
  }
  function stock_reminders$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27930, 0), new Long(59, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:stock_reminders', 'stock_reminders', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21094, 0), new Long(43, 0))]));
  }
  function _get_stock_reminders_$ref_ok544o() {
    return constructCallableReference(function (p0) {
      return get_stock_reminders(p0);
    }, 1, 0, 890);
  }
  function street_label$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(27990, 0), new Long(36, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:street_label', 'street_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21138, 0), new Long(28, 0))]));
  }
  function _get_street_label_$ref_hrhloe() {
    return constructCallableReference(function (p0) {
      return get_street_label(p0);
    }, 1, 0, 891);
  }
  function success$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28027, 0), new Long(39, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:success', 'success', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21167, 0), new Long(27, 0))]));
  }
  function _get_success_$ref_g12onx() {
    return constructCallableReference(function (p0) {
      return get_success(p0);
    }, 1, 0, 892);
  }
  function support_whatsapp_url$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28067, 0), new Long(64, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:support_whatsapp_url', 'support_whatsapp_url', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21195, 0), new Long(64, 0))]));
  }
  function _get_support_whatsapp_url_$ref_6pkwug() {
    return constructCallableReference(function (p0) {
      return get_support_whatsapp_url(p0);
    }, 1, 0, 893);
  }
  function tap_to_select_file$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28132, 0), new Long(66, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tap_to_select_file', 'tap_to_select_file', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21260, 0), new Long(54, 0))]));
  }
  function _get_tap_to_select_file_$ref_eiyjfh() {
    return constructCallableReference(function (p0) {
      return get_tap_to_select_file(p0);
    }, 1, 0, 894);
  }
  function target_audience$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28199, 0), new Long(67, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:target_audience', 'target_audience', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21315, 0), new Long(43, 0))]));
  }
  function text_cannot_be_empty$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:text_cannot_be_empty', 'text_cannot_be_empty', setOf(new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21359, 0), new Long(56, 0))));
  }
  function _get_text_cannot_be_empty_$ref_8v2d9b() {
    return constructCallableReference(function (p0) {
      return get_text_cannot_be_empty(p0);
    }, 1, 0, 895);
  }
  function text_settings$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28267, 0), new Long(53, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:text_settings', 'text_settings', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21416, 0), new Long(41, 0))]));
  }
  function _get_text_settings_$ref_rnqil1() {
    return constructCallableReference(function (p0) {
      return get_text_settings(p0);
    }, 1, 0, 896);
  }
  function texture_desc$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28321, 0), new Long(36, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:texture_desc', 'texture_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21458, 0), new Long(32, 0))]));
  }
  function _get_texture_desc_$ref_6kccwr() {
    return constructCallableReference(function (p0) {
      return get_texture_desc(p0);
    }, 1, 0, 897);
  }
  function thumbnail_index$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28358, 0), new Long(55, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:thumbnail_index', 'thumbnail_index', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21491, 0), new Long(43, 0))]));
  }
  function _get_thumbnail_index_$ref_w8clb3() {
    return constructCallableReference(function (p0) {
      return get_thumbnail_index(p0);
    }, 1, 0, 898);
  }
  function tooltip_add_photo$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28414, 0), new Long(53, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_add_photo', 'tooltip_add_photo', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21535, 0), new Long(37, 0))]));
  }
  function _get_tooltip_add_photo_$ref_hszyzs() {
    return constructCallableReference(function (p0) {
      return get_tooltip_add_photo(p0);
    }, 1, 0, 899);
  }
  function tooltip_add_text$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28468, 0), new Long(44, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_add_text', 'tooltip_add_text', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21573, 0), new Long(36, 0))]));
  }
  function _get_tooltip_add_text_$ref_lf7u3x() {
    return constructCallableReference(function (p0) {
      return get_tooltip_add_text(p0);
    }, 1, 0, 900);
  }
  function tooltip_center$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28513, 0), new Long(38, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_center', 'tooltip_center', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21610, 0), new Long(30, 0))]));
  }
  function tooltip_decrease_height$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28552, 0), new Long(59, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_decrease_height', 'tooltip_decrease_height', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21641, 0), new Long(51, 0))]));
  }
  function tooltip_decrease_width$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28612, 0), new Long(58, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_decrease_width', 'tooltip_decrease_width', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21693, 0), new Long(50, 0))]));
  }
  function tooltip_delete$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28671, 0), new Long(30, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_delete', 'tooltip_delete', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21744, 0), new Long(30, 0))]));
  }
  function tooltip_edit_text$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28702, 0), new Long(53, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_edit_text', 'tooltip_edit_text', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21775, 0), new Long(37, 0))]));
  }
  function tooltip_fit$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28756, 0), new Long(59, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_fit', 'tooltip_fit', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21813, 0), new Long(39, 0))]));
  }
  function tooltip_flip_h$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28816, 0), new Long(42, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_flip_h', 'tooltip_flip_h', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21853, 0), new Long(42, 0))]));
  }
  function tooltip_flip_v$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28859, 0), new Long(42, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_flip_v', 'tooltip_flip_v', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21896, 0), new Long(42, 0))]));
  }
  function tooltip_increase_height$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28902, 0), new Long(59, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_increase_height', 'tooltip_increase_height', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21939, 0), new Long(51, 0))]));
  }
  function tooltip_increase_width$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(28962, 0), new Long(58, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_increase_width', 'tooltip_increase_width', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(21991, 0), new Long(50, 0))]));
  }
  function tooltip_reset$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(29021, 0), new Long(45, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_reset', 'tooltip_reset', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22042, 0), new Long(29, 0))]));
  }
  function tooltip_rotate_left$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(29067, 0), new Long(79, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_rotate_left', 'tooltip_rotate_left', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22072, 0), new Long(51, 0))]));
  }
  function tooltip_rotate_right$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(29147, 0), new Long(80, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_rotate_right', 'tooltip_rotate_right', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22124, 0), new Long(52, 0))]));
  }
  function tooltip_send_to_back$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(29228, 0), new Long(56, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_send_to_back', 'tooltip_send_to_back', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22177, 0), new Long(44, 0))]));
  }
  function tooltip_take_photo$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(29285, 0), new Long(54, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:tooltip_take_photo', 'tooltip_take_photo', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22222, 0), new Long(42, 0))]));
  }
  function _get_tooltip_take_photo_$ref_xug7lo() {
    return constructCallableReference(function (p0) {
      return get_tooltip_take_photo(p0);
    }, 1, 0, 901);
  }
  function total_price_label$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(29340, 0), new Long(57, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:total_price_label', 'total_price_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22265, 0), new Long(41, 0))]));
  }
  function _get_total_price_label_$ref_egxrq5() {
    return constructCallableReference(function (p0) {
      return get_total_price_label(p0);
    }, 1, 0, 902);
  }
  function unexpected_error$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(29398, 0), new Long(124, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:unexpected_error', 'unexpected_error', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22307, 0), new Long(88, 0))]));
  }
  function _get_unexpected_error_$ref_mgbog() {
    return constructCallableReference(function (p0) {
      return get_unexpected_error(p0);
    }, 1, 0, 903);
  }
  function unknown_error$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(29523, 0), new Long(53, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:unknown_error', 'unknown_error', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22396, 0), new Long(41, 0))]));
  }
  function _get_unknown_error_$ref_jr3tmb() {
    return constructCallableReference(function (p0) {
      return get_unknown_error(p0);
    }, 1, 0, 904);
  }
  function update$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(29985, 0), new Long(30, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:update', 'update', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22722, 0), new Long(22, 0))]));
  }
  function _get_update_$ref_tt3041() {
    return constructCallableReference(function (p0) {
      return get_update(p0);
    }, 1, 0, 905);
  }
  function update_app_btn$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(29577, 0), new Long(50, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:update_app_btn', 'update_app_btn', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22438, 0), new Long(38, 0))]));
  }
  function _get_update_app_btn_$ref_bgn7hu() {
    return constructCallableReference(function (p0) {
      return get_update_app_btn(p0);
    }, 1, 0, 906);
  }
  function update_app_desc$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(29628, 0), new Long(219, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:update_app_desc', 'update_app_desc', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22477, 0), new Long(139, 0))]));
  }
  function _get_update_app_desc_$ref_pi2wor() {
    return constructCallableReference(function (p0) {
      return get_update_app_desc(p0);
    }, 1, 0, 907);
  }
  function update_app_title$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(29848, 0), new Long(68, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:update_app_title', 'update_app_title', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22617, 0), new Long(48, 0))]));
  }
  function _get_update_app_title_$ref_heped2() {
    return constructCallableReference(function (p0) {
      return get_update_app_title(p0);
    }, 1, 0, 908);
  }
  function update_failed_e_message$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(29917, 0), new Long(67, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:update_failed_e_message', 'update_failed_e_message', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22666, 0), new Long(55, 0))]));
  }
  function _get_update_failed_e_message_$ref_75vykf() {
    return constructCallableReference(function (p0) {
      return get_update_failed_e_message(p0);
    }, 1, 0, 909);
  }
  function upload_texture_image$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30016, 0), new Long(68, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:upload_texture_image', 'upload_texture_image', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22745, 0), new Long(56, 0))]));
  }
  function _get_upload_texture_image_$ref_lzy9en() {
    return constructCallableReference(function (p0) {
      return get_upload_texture_image(p0);
    }, 1, 0, 910);
  }
  function used_coupons_header$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30085, 0), new Long(79, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:used_coupons_header', 'used_coupons_header', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22802, 0), new Long(43, 0))]));
  }
  function used_coupons_tab$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30165, 0), new Long(48, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:used_coupons_tab', 'used_coupons_tab', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22846, 0), new Long(32, 0))]));
  }
  function _get_used_coupons_tab_$ref_s3pwjr() {
    return constructCallableReference(function (p0) {
      return get_used_coupons_tab(p0);
    }, 1, 0, 911);
  }
  function user$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30713, 0), new Long(28, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:user', 'user', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23210, 0), new Long(20, 0))]));
  }
  function user_already_registered$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30214, 0), new Long(115, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:user_already_registered', 'user_already_registered', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22879, 0), new Long(75, 0))]));
  }
  function _get_user_already_registered_$ref_v27msd() {
    return constructCallableReference(function (p0) {
      return get_user_already_registered(p0);
    }, 1, 0, 912);
  }
  function user_banned_error$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30330, 0), new Long(113, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:user_banned_error', 'user_banned_error', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(22955, 0), new Long(97, 0))]));
  }
  function _get_user_banned_error_$ref_pt0ttx() {
    return constructCallableReference(function (p0) {
      return get_user_banned_error(p0);
    }, 1, 0, 913);
  }
  function user_comment_label$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30444, 0), new Long(62, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:user_comment_label', 'user_comment_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23053, 0), new Long(42, 0))]));
  }
  function _get_user_comment_label_$ref_vqjqsa() {
    return constructCallableReference(function (p0) {
      return get_user_comment_label(p0);
    }, 1, 0, 914);
  }
  function user_not_found$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30507, 0), new Long(118, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:user_not_found', 'user_not_found', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23096, 0), new Long(62, 0))]));
  }
  function _get_user_not_found_$ref_3c0u1k() {
    return constructCallableReference(function (p0) {
      return get_user_not_found(p0);
    }, 1, 0, 915);
  }
  function user_not_logged_in$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30626, 0), new Long(86, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:user_not_logged_in', 'user_not_logged_in', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23159, 0), new Long(50, 0))]));
  }
  function _get_user_not_logged_in_$ref_e0ioew() {
    return constructCallableReference(function (p0) {
      return get_user_not_logged_in(p0);
    }, 1, 0, 916);
  }
  function verified_phone$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30742, 0), new Long(54, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:verified_phone', 'verified_phone', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23231, 0), new Long(42, 0))]));
  }
  function _get_verified_phone_$ref_u80wgt() {
    return constructCallableReference(function (p0) {
      return get_verified_phone(p0);
    }, 1, 0, 917);
  }
  function video_thumbnail$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30797, 0), new Long(43, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:video_thumbnail', 'video_thumbnail', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23274, 0), new Long(39, 0))]));
  }
  function _get_video_thumbnail_$ref_9aoqso() {
    return constructCallableReference(function (p0) {
      return get_video_thumbnail(p0);
    }, 1, 0, 918);
  }
  function visa_label$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30841, 0), new Long(30, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:visa_label', 'visa_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23314, 0), new Long(26, 0))]));
  }
  function _get_visa_label_$ref_g85ynw() {
    return constructCallableReference(function (p0) {
      return get_visa_label(p0);
    }, 1, 0, 919);
  }
  function wallet$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30872, 0), new Long(30, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:wallet', 'wallet', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23341, 0), new Long(22, 0))]));
  }
  function _get_wallet_$ref_q19wrl() {
    return constructCallableReference(function (p0) {
      return get_wallet(p0);
    }, 1, 0, 920);
  }
  function weak_password$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(30903, 0), new Long(137, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:weak_password', 'weak_password', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23364, 0), new Long(85, 0))]));
  }
  function _get_weak_password_$ref_jiw4ci() {
    return constructCallableReference(function (p0) {
      return get_weak_password(p0);
    }, 1, 0, 921);
  }
  function welcome_back$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(31041, 0), new Long(56, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:welcome_back', 'welcome_back', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23450, 0), new Long(36, 0))]));
  }
  function _get_welcome_back_$ref_9frmui() {
    return constructCallableReference(function (p0) {
      return get_welcome_back(p0);
    }, 1, 0, 922);
  }
  function whatsapp_contact$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(31098, 0), new Long(64, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:whatsapp_contact', 'whatsapp_contact', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23487, 0), new Long(48, 0))]));
  }
  function _get_whatsapp_contact_$ref_78kh21() {
    return constructCallableReference(function (p0) {
      return get_whatsapp_contact(p0);
    }, 1, 0, 923);
  }
  function width_label$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(31163, 0), new Long(35, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:width_label', 'width_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23536, 0), new Long(27, 0))]));
  }
  function _get_width_label_$ref_wjimvv() {
    return constructCallableReference(function (p0) {
      return get_width_label(p0);
    }, 1, 0, 924);
  }
  function with_templates_label$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(31199, 0), new Long(60, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:with_templates_label', 'with_templates_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23564, 0), new Long(56, 0))]));
  }
  function _get_with_templates_label_$ref_78ivbv() {
    return constructCallableReference(function (p0) {
      return get_with_templates_label(p0);
    }, 1, 0, 925);
  }
  function without_templates_label$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(31260, 0), new Long(59, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:without_templates_label', 'without_templates_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23621, 0), new Long(55, 0))]));
  }
  function _get_without_templates_label_$ref_2ma713() {
    return constructCallableReference(function (p0) {
      return get_without_templates_label(p0);
    }, 1, 0, 926);
  }
  function your_order_has_been_placed_successfully$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(31320, 0), new Long(95, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:your_order_has_been_placed_successfully', 'your_order_has_been_placed_successfully', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23677, 0), new Long(103, 0))]));
  }
  function _get_your_order_has_been_placed_successfully_$ref_ifpzjs() {
    return constructCallableReference(function (p0) {
      return get_your_order_has_been_placed_successfully(p0);
    }, 1, 0, 927);
  }
  function youth_label$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(31416, 0), new Long(55, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:youth_label', 'youth_label', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23781, 0), new Long(47, 0))]));
  }
  function _get_youth_label_$ref_t22w6w() {
    return constructCallableReference(function (p0) {
      return get_youth_label(p0);
    }, 1, 0, 928);
  }
  function yyyy_mm_dd_placeholder$delegate$lambda() {
    _init_properties_String4_commonMain_kt__aj065r();
    var tmp = new ResourceItem(setOf(new LanguageQualifier('ar')), 'composeResources/hadaya_client_web.shared.generated.resources/values-ar/strings.commonMain.cvr', new Long(31472, 0), new Long(46, 0));
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$0 = emptySet();
    return new StringResource('string:yyyy_mm_dd_placeholder', 'yyyy_mm_dd_placeholder', setOf_0([tmp, new ResourceItem(tmp$ret$0, 'composeResources/hadaya_client_web.shared.generated.resources/values/strings.commonMain.cvr', new Long(23829, 0), new Long(46, 0))]));
  }
  function _get_yyyy_mm_dd_placeholder_$ref_1rgarq() {
    return constructCallableReference(function (p0) {
      return get_yyyy_mm_dd_placeholder(p0);
    }, 1, 0, 929);
  }
  var properties_initialized_String4_commonMain_kt_eartn3;
  function _init_properties_String4_commonMain_kt__aj065r() {
    if (!properties_initialized_String4_commonMain_kt_eartn3) {
      properties_initialized_String4_commonMain_kt_eartn3 = true;
      sort_oldest$delegate = lazy(sort_oldest$delegate$lambda);
      sort_price_high_low$delegate = lazy(sort_price_high_low$delegate$lambda);
      sort_price_low_high$delegate = lazy(sort_price_low_high$delegate$lambda);
      source_camera$delegate = lazy(source_camera$delegate$lambda);
      source_gallery$delegate = lazy(source_gallery$delegate$lambda);
      standard_products_label$delegate = lazy(standard_products_label$delegate$lambda);
      stock_reminders$delegate = lazy(stock_reminders$delegate$lambda);
      street_label$delegate = lazy(street_label$delegate$lambda);
      success$delegate = lazy(success$delegate$lambda);
      support_whatsapp_url$delegate = lazy(support_whatsapp_url$delegate$lambda);
      tap_to_select_file$delegate = lazy(tap_to_select_file$delegate$lambda);
      target_audience$delegate = lazy(target_audience$delegate$lambda);
      text_cannot_be_empty$delegate = lazy(text_cannot_be_empty$delegate$lambda);
      text_settings$delegate = lazy(text_settings$delegate$lambda);
      texture_desc$delegate = lazy(texture_desc$delegate$lambda);
      thumbnail_index$delegate = lazy(thumbnail_index$delegate$lambda);
      tooltip_add_photo$delegate = lazy(tooltip_add_photo$delegate$lambda);
      tooltip_add_text$delegate = lazy(tooltip_add_text$delegate$lambda);
      tooltip_center$delegate = lazy(tooltip_center$delegate$lambda);
      tooltip_decrease_height$delegate = lazy(tooltip_decrease_height$delegate$lambda);
      tooltip_decrease_width$delegate = lazy(tooltip_decrease_width$delegate$lambda);
      tooltip_delete$delegate = lazy(tooltip_delete$delegate$lambda);
      tooltip_edit_text$delegate = lazy(tooltip_edit_text$delegate$lambda);
      tooltip_fit$delegate = lazy(tooltip_fit$delegate$lambda);
      tooltip_flip_h$delegate = lazy(tooltip_flip_h$delegate$lambda);
      tooltip_flip_v$delegate = lazy(tooltip_flip_v$delegate$lambda);
      tooltip_increase_height$delegate = lazy(tooltip_increase_height$delegate$lambda);
      tooltip_increase_width$delegate = lazy(tooltip_increase_width$delegate$lambda);
      tooltip_reset$delegate = lazy(tooltip_reset$delegate$lambda);
      tooltip_rotate_left$delegate = lazy(tooltip_rotate_left$delegate$lambda);
      tooltip_rotate_right$delegate = lazy(tooltip_rotate_right$delegate$lambda);
      tooltip_send_to_back$delegate = lazy(tooltip_send_to_back$delegate$lambda);
      tooltip_take_photo$delegate = lazy(tooltip_take_photo$delegate$lambda);
      total_price_label$delegate = lazy(total_price_label$delegate$lambda);
      unexpected_error$delegate = lazy(unexpected_error$delegate$lambda);
      unknown_error$delegate = lazy(unknown_error$delegate$lambda);
      update$delegate = lazy(update$delegate$lambda);
      update_app_btn$delegate = lazy(update_app_btn$delegate$lambda);
      update_app_desc$delegate = lazy(update_app_desc$delegate$lambda);
      update_app_title$delegate = lazy(update_app_title$delegate$lambda);
      update_failed_e_message$delegate = lazy(update_failed_e_message$delegate$lambda);
      upload_texture_image$delegate = lazy(upload_texture_image$delegate$lambda);
      used_coupons_header$delegate = lazy(used_coupons_header$delegate$lambda);
      used_coupons_tab$delegate = lazy(used_coupons_tab$delegate$lambda);
      user$delegate = lazy(user$delegate$lambda);
      user_already_registered$delegate = lazy(user_already_registered$delegate$lambda);
      user_banned_error$delegate = lazy(user_banned_error$delegate$lambda);
      user_comment_label$delegate = lazy(user_comment_label$delegate$lambda);
      user_not_found$delegate = lazy(user_not_found$delegate$lambda);
      user_not_logged_in$delegate = lazy(user_not_logged_in$delegate$lambda);
      verified_phone$delegate = lazy(verified_phone$delegate$lambda);
      video_thumbnail$delegate = lazy(video_thumbnail$delegate$lambda);
      visa_label$delegate = lazy(visa_label$delegate$lambda);
      wallet$delegate = lazy(wallet$delegate$lambda);
      weak_password$delegate = lazy(weak_password$delegate$lambda);
      welcome_back$delegate = lazy(welcome_back$delegate$lambda);
      whatsapp_contact$delegate = lazy(whatsapp_contact$delegate$lambda);
      width_label$delegate = lazy(width_label$delegate$lambda);
      with_templates_label$delegate = lazy(with_templates_label$delegate$lambda);
      without_templates_label$delegate = lazy(without_templates_label$delegate$lambda);
      your_order_has_been_placed_successfully$delegate = lazy(your_order_has_been_placed_successfully$delegate$lambda);
      youth_label$delegate = lazy(youth_label$delegate$lambda);
      yyyy_mm_dd_placeholder$delegate = lazy(yyyy_mm_dd_placeholder$delegate$lambda);
    }
  }
  var hadaya_client_web_shared_generated_resources_Res_drawable$stable;
  var hadaya_client_web_shared_generated_resources_Res_string$stable;
  var hadaya_client_web_shared_generated_resources_Res_array$stable;
  var hadaya_client_web_shared_generated_resources_Res_plurals$stable;
  var hadaya_client_web_shared_generated_resources_Res_font$stable;
  var hadaya_client_web_shared_generated_resources_Res$stable;
  function drawable() {
  }
  var drawable_instance;
  function drawable_getInstance() {
    return drawable_instance;
  }
  function string() {
  }
  var string_instance;
  function string_getInstance() {
    return string_instance;
  }
  function font() {
  }
  var font_instance;
  function font_getInstance() {
    return font_instance;
  }
  var client_fstech_hadaya_shared_BuildConfig$stable;
  function IAnalyticsHelper() {
  }
  function App(onRequireNotificationPermission, fcmToken, deepLinkProductId, deepLinkOrderId, backStack, $composer, $changed, $default) {
    var onRequireNotificationPermission_0 = {_v: onRequireNotificationPermission};
    var fcmToken_0 = {_v: fcmToken};
    var deepLinkProductId_0 = {_v: deepLinkProductId};
    var deepLinkOrderId_0 = {_v: deepLinkOrderId};
    var backStack_0 = {_v: backStack};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(94507098);
    sourceInformation($composer_0, 'C(App)P(4,3,2,1)20@792L2,26@986L55,26@955L86,30@1077L15,31@1132L16,32@1194L16,34@1257L16,36@1317L93,36@1279L131,42@1450L114,42@1416L148,48@1602L115,48@1570L147,54@1751L98,54@1723L126,60@1888L241,60@1855L274:App.kt#7tj4na');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onRequireNotificationPermission_0._v) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(fcmToken_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(deepLinkProductId_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(deepLinkOrderId_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(backStack_0._v) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        sourceInformationMarkerStart($composer_0, 627009852, 'CC(remember):App.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = App$lambda;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var tmp0_group = tmp;
        sourceInformationMarkerEnd($composer_0);
        onRequireNotificationPermission_0._v = tmp0_group;
      }
      if (!(($default & 2) === 0)) {
        fcmToken_0._v = null;
      }
      if (!(($default & 4) === 0)) {
        deepLinkProductId_0._v = null;
      }
      if (!(($default & 8) === 0)) {
        deepLinkOrderId_0._v = null;
      }
      if (!(($default & 16) === 0)) {
        backStack_0._v = null;
      }
      if (isTraceInProgress()) {
        traceEventStart(94507098, $dirty, -1, 'client.fstech.hadaya.App (App.kt:25)');
      }
      sourceInformationMarkerStart($composer_0, 627016113, 'CC(remember):App.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = App$lambda_0;
        this_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      setSingletonImageLoaderFactory(tmp1_group, $composer_0, 6);
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp_1;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(AppViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var language$delegate = collectAsState(viewModel.fyj_1, null, $composer_0, 0, 1);
      var needsUpdate$delegate = collectAsState(viewModel.hyj_1, null, $composer_0, 0, 1);
      var currentUser$delegate = collectAsState(viewModel.eyj_1, null, $composer_0, 0, 1);
      var tmp_2 = fcmToken_0._v;
      var tmp_3 = App$lambda_3(currentUser$delegate);
      sourceInformationMarkerStart($composer_0, 627026743, 'CC(remember):App.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!($composer_0.k31(currentUser$delegate) | $composer_0.q31(viewModel)) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_0.i31();
      var tmp_4;
      if (invalid || it_1 === Companion_getInstance().f30_1) {
        var value_1 = App$slambda_0(viewModel, fcmToken_0, currentUser$delegate, null);
        tmp0_0.j31(value_1);
        tmp_4 = value_1;
      } else {
        tmp_4 = it_1;
      }
      var tmp2_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect(tmp_2, tmp_3, tmp2_group, $composer_0, 14 & $dirty >> 3);
      var tmp_5 = deepLinkProductId_0._v;
      sourceInformationMarkerStart($composer_0, 627031020, 'CC(remember):App.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(($dirty & 896) === 256 | $composer_0.q31(viewModel));
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_1.i31();
      var tmp_6;
      if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = App$slambda_2(deepLinkProductId_0, viewModel, null);
        tmp0_1.j31(value_2);
        tmp_6 = value_2;
      } else {
        tmp_6 = it_2;
      }
      var tmp3_group = tmp_6;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_5, tmp3_group, $composer_0, 14 & $dirty >> 6);
      var tmp_7 = deepLinkOrderId_0._v;
      sourceInformationMarkerStart($composer_0, 627035885, 'CC(remember):App.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(($dirty & 7168) === 2048 | $composer_0.q31(viewModel));
      // Inline function 'kotlin.let' call
      var it_3 = tmp0_2.i31();
      var tmp_8;
      if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = App$slambda_4(deepLinkOrderId_0, viewModel, null);
        tmp0_2.j31(value_3);
        tmp_8 = value_3;
      } else {
        tmp_8 = it_3;
      }
      var tmp4_group = tmp_8;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_7, tmp4_group, $composer_0, 14 & $dirty >> 9);
      var tmp_9 = App$lambda_3(currentUser$delegate);
      sourceInformationMarkerStart($composer_0, 627040636, 'CC(remember):App.kt#9igjgp');
      var tmp0_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = !!($composer_0.k31(currentUser$delegate) | ($dirty & 14) === 4);
      // Inline function 'kotlin.let' call
      var it_4 = tmp0_3.i31();
      var tmp_10;
      if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = App$slambda_6(onRequireNotificationPermission_0, currentUser$delegate, null);
        tmp0_3.j31(value_4);
        tmp_10 = value_4;
      } else {
        tmp_10 = it_4;
      }
      var tmp5_group = tmp_10;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_9, tmp5_group, $composer_0, 0);
      var tmp_11 = App$lambda_1(language$delegate);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1118919204, true, App$lambda_4(backStack_0, needsUpdate$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = $composer_2.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_5 = $composer_2.i31();
      var tmp_12;
      if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
        var value_5 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_2.j31(value_5);
        tmp_12 = value_5;
      } else {
        tmp_12 = it_5;
      }
      var tmp$ret$26 = tmp_12;
      HadayaTheme(false, tmp_11, tmp$ret$26, $composer_0, 384, 1);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp6_safe_receiver = $composer_0.t30();
    if (tmp6_safe_receiver == null)
      null;
    else {
      tmp6_safe_receiver.p3c(App$lambda_5(onRequireNotificationPermission_0, fcmToken_0, deepLinkProductId_0, deepLinkOrderId_0, backStack_0, $changed, $default));
    }
  }
  function App$lambda() {
    return Unit_instance;
  }
  function App$lambda_0(context) {
    return getAsyncImageLoader(context);
  }
  function App$lambda_1($language$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('language', KProperty0, false);
    return $language$delegate.u1();
  }
  function App$lambda_2($needsUpdate$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('needsUpdate', KProperty0, false);
    return $needsUpdate$delegate.u1();
  }
  function App$lambda_3($currentUser$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('currentUser', KProperty0, false);
    return $currentUser$delegate.u1();
  }
  function App$slambda($viewModel, $fcmToken, $currentUser$delegate, resultContinuation) {
    this.ayk_1 = $viewModel;
    this.byk_1 = $fcmToken;
    this.cyk_1 = $currentUser$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(App$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(App$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(App$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          if (!(App$lambda_3(this.cyk_1) == null)) {
            this.ayk_1.eyk(this.byk_1._v);
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(App$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new App$slambda(this.ayk_1, this.byk_1, this.cyk_1, completion);
    i.dyk_1 = $this$LaunchedEffect;
    return i;
  };
  function App$slambda_0($viewModel, $fcmToken, $currentUser$delegate, resultContinuation) {
    var i = new App$slambda($viewModel, $fcmToken, $currentUser$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function App$slambda_1($deepLinkProductId, $viewModel, resultContinuation) {
    this.nyk_1 = $deepLinkProductId;
    this.oyk_1 = $viewModel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(App$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(App$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(App$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          if (!(this.nyk_1._v == null)) {
            this.oyk_1.qyk(this.nyk_1._v);
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(App$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new App$slambda_1(this.nyk_1, this.oyk_1, completion);
    i.pyk_1 = $this$LaunchedEffect;
    return i;
  };
  function App$slambda_2($deepLinkProductId, $viewModel, resultContinuation) {
    var i = new App$slambda_1($deepLinkProductId, $viewModel, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function App$slambda_3($deepLinkOrderId, $viewModel, resultContinuation) {
    this.zyk_1 = $deepLinkOrderId;
    this.ayl_1 = $viewModel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(App$slambda_3).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(App$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(App$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          if (!(this.zyk_1._v == null)) {
            this.ayl_1.cyl(this.zyk_1._v);
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(App$slambda_3).q24 = function ($this$LaunchedEffect, completion) {
    var i = new App$slambda_3(this.zyk_1, this.ayl_1, completion);
    i.byl_1 = $this$LaunchedEffect;
    return i;
  };
  function App$slambda_4($deepLinkOrderId, $viewModel, resultContinuation) {
    var i = new App$slambda_3($deepLinkOrderId, $viewModel, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function App$slambda_5($onRequireNotificationPermission, $currentUser$delegate, resultContinuation) {
    this.lyl_1 = $onRequireNotificationPermission;
    this.myl_1 = $currentUser$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(App$slambda_5).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(App$slambda_5).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(App$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          if (!(App$lambda_3(this.myl_1) == null)) {
            this.lyl_1._v();
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(App$slambda_5).q24 = function ($this$LaunchedEffect, completion) {
    var i = new App$slambda_5(this.lyl_1, this.myl_1, completion);
    i.nyl_1 = $this$LaunchedEffect;
    return i;
  };
  function App$slambda_6($onRequireNotificationPermission, $currentUser$delegate, resultContinuation) {
    var i = new App$slambda_5($onRequireNotificationPermission, $currentUser$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function App$lambda_4($backStack, $needsUpdate$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:App.kt#7tj4na');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1118919204, $changed, -1, 'client.fstech.hadaya.App.<anonymous> (App.kt:61)');
        }
        if (App$lambda_2($needsUpdate$delegate)) {
          $composer_0.m30(-480794144);
          sourceInformation($composer_0, '62@1929L14');
          UpdateScreen($composer_0, 0);
          $composer_0.n30();
        } else {
          $composer_0.m30(-480746590);
          sourceInformation($composer_0, '');
          if (!($backStack._v == null)) {
            $composer_0.m30(-480712924);
            sourceInformation($composer_0, '65@2014L34');
            HomeNavHost($backStack._v, $composer_0, 0, 0);
            $composer_0.n30();
          } else {
            $composer_0.m30(-480642151);
            sourceInformation($composer_0, '67@2086L13');
            HomeNavHost(null, $composer_0, 0, 1);
            $composer_0.n30();
          }
          $composer_0.n30();
        }
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref(p0) {
    return constructCallableReference(function (p0_0, p1) {
      p0.t50(p0_0, p1);
      return Unit_instance;
    }, 2, 0, 17, VOID, [p0]);
  }
  function App$lambda_5($onRequireNotificationPermission, $fcmToken, $deepLinkProductId, $deepLinkOrderId, $backStack, $$changed, $$default) {
    return function ($composer, $force) {
      App($onRequireNotificationPermission._v, $fcmToken._v, $deepLinkProductId._v, $deepLinkOrderId._v, $backStack._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_data_local_datastore_LanguageStorage$stable;
  function LanguageStorage(initialLanguage) {
    initialLanguage = initialLanguage === VOID ? 'en' : initialLanguage;
    this.oyl_1 = MutableStateFlow(initialLanguage);
    this.pyl_1 = this.oyl_1;
  }
  protoOf(LanguageStorage).qyl = function (lang) {
    if (this.oyl_1.u1() === lang)
      return Unit_instance;
    this.oyl_1.s21(lang);
  };
  var client_fstech_hadaya_data_repository_AuthRepositoryImpl$stable;
  function AuthRepositoryImpl$currentUser$slambda$slambda($status, this$0, resultContinuation) {
    this.zyl_1 = $status;
    this.aym_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthRepositoryImpl$currentUser$slambda$slambda).dym = function ($this$flow, $completion) {
    var tmp = this.eym($this$flow, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl$currentUser$slambda$slambda).ja = function (p1, $completion) {
    return this.dym((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthRepositoryImpl$currentUser$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            var tmp0_safe_receiver = this.zyl_1.nvz_1.vvw_1;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.nwk_1;
            var userId = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
            var tmp_0 = this;
            var tmp2_safe_receiver = this.zyl_1.nvz_1.vvw_1;
            tmp_0.cym_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.kwk_1;
            this.o9_1 = 3;
            var this_0 = this.aym_1.gym_1.xwu('profiles');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('id', userId);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            var profile = firstOrNull(tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Profile), arrayOf([]), false))]), false), value_0));
            var tmp3_safe_receiver = this.zyl_1.nvz_1.vvw_1;
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.fwk_1;
            var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.je('provider');
            var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : get_jsonPrimitive(tmp5_safe_receiver);
            var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.rj3();
            var provider = tmp7_elvis_lhs == null ? 'email' : tmp7_elvis_lhs;
            this.n9_1 = 2;
            var tmp9_elvis_lhs = profile == null ? null : profile.uyn(VOID, this.cym_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, provider);
            var tmp_1;
            if (tmp9_elvis_lhs == null) {
              var tmp10_safe_receiver = this.zyl_1.nvz_1.vvw_1;
              tmp_1 = tmp10_safe_receiver == null ? null : toProfile(tmp10_safe_receiver);
            } else {
              tmp_1 = tmp9_elvis_lhs;
            }

            suspendResult = this.bym_1.a1v(tmp_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Exception) {
              var e = this.q9_1;
              this.n9_1 = 4;
              var tmp11_safe_receiver = this.zyl_1.nvz_1.vvw_1;
              suspendResult = this.bym_1.a1v(tmp11_safe_receiver == null ? null : toProfile(tmp11_safe_receiver), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(AuthRepositoryImpl$currentUser$slambda$slambda).eym = function ($this$flow, completion) {
    var i = new AuthRepositoryImpl$currentUser$slambda$slambda(this.zyl_1, this.aym_1, completion);
    i.bym_1 = $this$flow;
    return i;
  };
  function AuthRepositoryImpl$currentUser$slambda$slambda_0($status, this$0, resultContinuation) {
    var i = new AuthRepositoryImpl$currentUser$slambda$slambda($status, this$0, resultContinuation);
    return constructCallableReference(function ($this$flow, $completion) {
      return i.dym($this$flow, $completion);
    }, 1);
  }
  function checkFirstLogin($this, userId, $completion) {
    var tmp = new $checkFirstLoginCOROUTINE$($this, userId, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function getAvatarPathFromUrl($this, url) {
    var tmp;
    if (contains(url, '/storage/v1/object/public/avatars/')) {
      tmp = lastOrNull(split(url, ['/storage/v1/object/public/avatars/']));
    } else {
      tmp = null;
    }
    return tmp;
  }
  function AuthRepositoryImpl$language$slambda(this$0, resultContinuation) {
    this.nyo_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthRepositoryImpl$language$slambda).pyo = function (lang, $completion) {
    var tmp = this.um9(lang, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl$language$slambda).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthRepositoryImpl$language$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.nyo_1.iym_1.qyl(this.oyo_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(AuthRepositoryImpl$language$slambda).um9 = function (lang, completion) {
    var i = new AuthRepositoryImpl$language$slambda(this.nyo_1, completion);
    i.oyo_1 = lang;
    return i;
  };
  function AuthRepositoryImpl$language$slambda_0(this$0, resultContinuation) {
    var i = new AuthRepositoryImpl$language$slambda(this$0, resultContinuation);
    return constructCallableReference(function (lang, $completion) {
      return i.pyo(lang, $completion);
    }, 1);
  }
  function AuthRepositoryImpl$currentUser$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthRepositoryImpl$currentUser$slambda).ayp = function (status, _unused_var__etf5q3, $completion) {
    var tmp = this.byp(status, _unused_var__etf5q3, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl$currentUser$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, SessionStatus) : false) ? p1 : THROW_CCE();
    return this.ayp(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(AuthRepositoryImpl$currentUser$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return this.yyo_1;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(AuthRepositoryImpl$currentUser$slambda).byp = function (status, _unused_var__etf5q3, completion) {
    var i = new AuthRepositoryImpl$currentUser$slambda(completion);
    i.yyo_1 = status;
    i.zyo_1 = _unused_var__etf5q3;
    return i;
  };
  function AuthRepositoryImpl$currentUser$slambda_0(resultContinuation) {
    var i = new AuthRepositoryImpl$currentUser$slambda(resultContinuation);
    return constructCallableReference(function (status, _unused_var__etf5q3, $completion) {
      return i.ayp(status, _unused_var__etf5q3, $completion);
    }, 2);
  }
  function AuthRepositoryImpl$currentUser$slambda_1(this$0, resultContinuation) {
    this.kyp_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthRepositoryImpl$currentUser$slambda_1).nyp = function ($this$transformLatest, it, $completion) {
    var tmp = this.oyp($this$transformLatest, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl$currentUser$slambda_1).ha = function (p1, p2, $completion) {
    return this.nyp((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), p2, $completion);
  };
  protoOf(AuthRepositoryImpl$currentUser$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var status = this.myp_1;
            var tmp_0;
            if (status instanceof Authenticated) {
              tmp_0 = flow(AuthRepositoryImpl$currentUser$slambda$slambda_0(status, this.kyp_1, null));
            } else {
              if (status instanceof NotAuthenticated) {
                tmp_0 = flowOf(null);
              } else {
                var tmp1_safe_receiver = this.kyp_1.fym_1.qvz();
                tmp_0 = flowOf(tmp1_safe_receiver == null ? null : toProfile(tmp1_safe_receiver));
              }
            }

            suspendResult = emitAll(this.lyp_1, tmp_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AuthRepositoryImpl$currentUser$slambda_1).oyp = function ($this$transformLatest, it, completion) {
    var i = new AuthRepositoryImpl$currentUser$slambda_1(this.kyp_1, completion);
    i.lyp_1 = $this$transformLatest;
    i.myp_1 = it;
    return i;
  };
  function AuthRepositoryImpl$currentUser$slambda_2(this$0, resultContinuation) {
    var i = new AuthRepositoryImpl$currentUser$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function ($this$transformLatest, it, $completion) {
      return i.nyp($this$transformLatest, it, $completion);
    }, 2);
  }
  function AuthRepositoryImpl$loginWithGoogle$lambda($idToken, $accessToken) {
    return function ($this$signInWith) {
      $this$signInWith.swo_1 = $idToken;
      $this$signInWith.uwo_1 = $accessToken;
      $this$signInWith.two_1 = Google_getInstance();
      return Unit_instance;
    };
  }
  function AuthRepositoryImpl$login$lambda($trimmedEmail, $password) {
    return function ($this$signInWith) {
      $this$signInWith.kwo_1 = $trimmedEmail;
      $this$signInWith.lwo_1 = $password;
      return Unit_instance;
    };
  }
  function AuthRepositoryImpl$register$lambda($trimmedEmail, $password) {
    return function ($this$signUpWith) {
      $this$signUpWith.kwo_1 = $trimmedEmail;
      $this$signUpWith.lwo_1 = $password;
      return Unit_instance;
    };
  }
  function AuthRepositoryImpl$httpClient$lambda($this$HttpClient) {
    var tmp = get_ContentNegotiation();
    $this$HttpClient.ett(tmp, AuthRepositoryImpl$httpClient$lambda$lambda);
    return Unit_instance;
  }
  function AuthRepositoryImpl$httpClient$lambda$lambda($this$install) {
    json($this$install, Json(VOID, AuthRepositoryImpl$httpClient$lambda$lambda$lambda));
    return Unit_instance;
  }
  function AuthRepositoryImpl$httpClient$lambda$lambda$lambda($this$Json) {
    $this$Json.fmh_1 = true;
    return Unit_instance;
  }
  function AuthRepositoryImpl$deleteAccount$lambda($email, $password) {
    return function ($this$signInWith) {
      $this$signInWith.kwo_1 = $email;
      $this$signInWith.lwo_1 = $password;
      return Unit_instance;
    };
  }
  function AuthRepositoryImpl$updateAvatar$lambda($this$upload) {
    $this$upload.xx5_1 = true;
    return Unit_instance;
  }
  function AuthRepositoryImpl$updateAvatar$lambda_0($publicUrl) {
    return function ($this$updateUser) {
      var tmp = $this$updateUser;
      // Inline function 'kotlinx.serialization.json.buildJsonObject' call
      var builder = new JsonObjectBuilder();
      put(builder, 'avatar_url', $publicUrl);
      tmp.uwq_1 = builder.wmh();
      return Unit_instance;
    };
  }
  function AuthRepositoryImpl$deleteAvatar$lambda($this$updateUser) {
    var tmp = $this$updateUser;
    // Inline function 'kotlinx.serialization.json.buildJsonObject' call
    var builder = new JsonObjectBuilder();
    put(builder, 'avatar_url', (null == null ? true : typeof null === 'string') ? null : THROW_CCE());
    tmp.uwq_1 = builder.wmh();
    return Unit_instance;
  }
  function AuthRepositoryImpl$updateProfile$lambda($profile) {
    return function ($this$updateUser) {
      $this$updateUser.uwq_1 = get_jsonObject(Default_getInstance().lmg(Companion_instance_25.amj(), $profile));
      return Unit_instance;
    };
  }
  function AuthRepositoryImpl$updatePassword$lambda($newPassword) {
    return function ($this$updateUser) {
      $this$updateUser.rwq_1 = $newPassword;
      return Unit_instance;
    };
  }
  function $loginWithGoogleCOROUTINE$(_this__u8e3s4, idToken, accessToken, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xyp_1 = _this__u8e3s4;
    this.yyp_1 = idToken;
    this.zyp_1 = accessToken;
  }
  protoOf($loginWithGoogleCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 11;
            this.n9_1 = 1;
            var tmp_0 = IDToken_instance;
            suspendResult = this.xyp_1.fym_1.xvy(tmp_0, VOID, AuthRepositoryImpl$loginWithGoogle$lambda(this.yyp_1, this.zyp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.cyq_1 = this.xyp_1.fym_1.qvz();
            if (!(this.cyq_1 == null)) {
              this.o9_1 = 4;
              this.n9_1 = 2;
              suspendResult = checkFirstLogin(this.xyp_1, this.cyq_1.nwk_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 2:
            var tmp0 = this.xyp_1.gym_1.xwu('profiles');
            var builder = new JsonObjectBuilder();
            put(builder, 'id', this.cyq_1.nwk_1);
            put(builder, 'email', this.cyq_1.kwk_1);
            put(builder, 'provider', 'google');
            var value = builder.wmh();
            var values = listOf(value);
            var this_0 = tmp0.owx_1.rvz();
            var tmp0_0 = Default_getInstance();
            var string = this_0.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(JsonObject), arrayOf([]), false))]), false), values);
            var this_1 = tmp0_0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(JsonElement), arrayOf([]), false));
            var body = get_jsonArray(tmp0_0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string));
            var requestBuilder = new UpsertRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(body, 10));
            var _iterator__ex2g4s = body.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              destination.j1(get_jsonObject(item).x2());
            }

            var columns = distinct(flatten(destination));
            if (!columns.r()) {
              var tmp0_1 = requestBuilder.vwx_1;
              var value_0 = listOf(joinToString(columns, ','));
              tmp0_1.z2('columns', value_0);
            }

            var tmp0_safe_receiver = requestBuilder.iwz_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              var tmp0_2 = requestBuilder.vwx_1;
              var tmp2 = 'on_conflict';
              var value_1 = listOf(tmp0_safe_receiver);
              tmp0_2.z2(tmp2, value_1);
            }

            var tmp1_returning = requestBuilder.uwx_1;
            var tmp2_count = requestBuilder.twx_1;
            var tmp3_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp4_defaultToNull = requestBuilder.vwy_1;
            var tmp5_ignoreDuplicates = requestBuilder.jwz_1;
            var tmp6_schema = tmp0.qwx_1;
            var tmp7_headers = requestBuilder.wwx_1.g3d();
            var insertRequest = new InsertRequest(true, tmp1_returning, tmp2_count, tmp5_ignoreDuplicates, tmp4_defaultToNull, body, tmp3_urlParams, tmp6_schema, tmp7_headers);
            this.n9_1 = 3;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, insertRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.byq_1 = suspendResult;
            this.o9_1 = 11;
            this.n9_1 = 5;
            continue $sm;
          case 4:
            this.o9_1 = 11;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Exception) {
              var e = this.q9_1;
              var tmp_2 = this;
              tmp_2.byq_1 = Unit_instance;
              this.n9_1 = 5;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 5:
            this.o9_1 = 11;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.ayq_1 = this.xyp_1.sym_1.u1();
            var tmp0_safe_receiver_0 = this.ayq_1;
            if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.myn_1) === true) {
              this.n9_1 = 9;
              suspendResult = this.xyp_1.fym_1.evz(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 7:
            this.n9_1 = 8;
            suspendResult = this.xyp_1.rym_1.a1v(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            return this.ayq_1;
          case 9:
            this.n9_1 = 10;
            suspendResult = getString(get_user_banned_error(string_instance), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            var ARGUMENT = suspendResult;
            throw Exception_init_$Create$(ARGUMENT);
          case 11:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 11) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $loginCOROUTINE$(_this__u8e3s4, email, password, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lyq_1 = _this__u8e3s4;
    this.myq_1 = email;
    this.nyq_1 = password;
  }
  protoOf($loginCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 11;
            var tmp_0 = this;
            var this_0 = this.myq_1;
            tmp_0.qyq_1 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
            this.n9_1 = 1;
            var tmp_1 = Email_instance;
            suspendResult = this.lyq_1.fym_1.xvy(tmp_1, VOID, AuthRepositoryImpl$login$lambda(this.qyq_1, this.nyq_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ryq_1 = this.lyq_1.fym_1.qvz();
            if (!(this.ryq_1 == null)) {
              this.o9_1 = 4;
              this.n9_1 = 2;
              suspendResult = checkFirstLogin(this.lyq_1, this.ryq_1.nwk_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 2:
            var tmp0 = this.lyq_1.gym_1.xwu('profiles');
            var builder = new JsonObjectBuilder();
            put(builder, 'id', this.ryq_1.nwk_1);
            put(builder, 'email', this.qyq_1);
            put(builder, 'provider', 'email');
            var value = builder.wmh();
            var values = listOf(value);
            var this_1 = tmp0.owx_1.rvz();
            var tmp0_0 = Default_getInstance();
            var string = this_1.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(JsonObject), arrayOf([]), false))]), false), values);
            var this_2 = tmp0_0.c75();
            var this_3 = serializer(this_2, createKType(getKClass(JsonElement), arrayOf([]), false));
            var body = get_jsonArray(tmp0_0.c72(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), string));
            var requestBuilder = new UpsertRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(body, 10));
            var _iterator__ex2g4s = body.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              destination.j1(get_jsonObject(item).x2());
            }

            var columns = distinct(flatten(destination));
            if (!columns.r()) {
              var tmp0_1 = requestBuilder.vwx_1;
              var value_0 = listOf(joinToString(columns, ','));
              tmp0_1.z2('columns', value_0);
            }

            var tmp0_safe_receiver = requestBuilder.iwz_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              var tmp0_2 = requestBuilder.vwx_1;
              var tmp2 = 'on_conflict';
              var value_1 = listOf(tmp0_safe_receiver);
              tmp0_2.z2(tmp2, value_1);
            }

            var tmp1_returning = requestBuilder.uwx_1;
            var tmp2_count = requestBuilder.twx_1;
            var tmp3_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp4_defaultToNull = requestBuilder.vwy_1;
            var tmp5_ignoreDuplicates = requestBuilder.jwz_1;
            var tmp6_schema = tmp0.qwx_1;
            var tmp7_headers = requestBuilder.wwx_1.g3d();
            var insertRequest = new InsertRequest(true, tmp1_returning, tmp2_count, tmp5_ignoreDuplicates, tmp4_defaultToNull, body, tmp3_urlParams, tmp6_schema, tmp7_headers);
            this.n9_1 = 3;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, insertRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.pyq_1 = suspendResult;
            this.o9_1 = 11;
            this.n9_1 = 5;
            continue $sm;
          case 4:
            this.o9_1 = 11;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Exception) {
              var e = this.q9_1;
              var tmp_3 = this;
              tmp_3.pyq_1 = Unit_instance;
              this.n9_1 = 5;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 5:
            this.o9_1 = 11;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.oyq_1 = this.lyq_1.sym_1.u1();
            var tmp0_safe_receiver_0 = this.oyq_1;
            if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.myn_1) === true) {
              this.n9_1 = 9;
              suspendResult = this.lyq_1.fym_1.evz(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 7:
            this.n9_1 = 8;
            suspendResult = this.lyq_1.rym_1.a1v(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            return this.oyq_1;
          case 9:
            this.n9_1 = 10;
            suspendResult = getString(get_user_banned_error(string_instance), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            var ARGUMENT = suspendResult;
            throw Exception_init_$Create$(ARGUMENT);
          case 11:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 11) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $checkFirstLoginCOROUTINE$(_this__u8e3s4, userId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dyo_1 = _this__u8e3s4;
    this.eyo_1 = userId;
  }
  protoOf($checkFirstLoginCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.o9_1 = 7;
            var this_0 = this.dyo_1.gym_1.xwu('profiles');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('id', this.eyo_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            var profile = firstOrNull(tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Profile), arrayOf([]), false))]), false), value_0));
            if ((profile == null ? null : profile.pyn_1) === true) {
              this.n9_1 = 2;
              suspendResult = this.dyo_1.mym_1.syq(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 2:
            var welcomeSetting = suspendResult;
            if (welcomeSetting === 1.0) {
              this.n9_1 = 3;
              suspendResult = this.dyo_1.nym_1.uyq(this.eyo_1, 10.0, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            var tmp0_1 = this.dyo_1.gym_1.xwu('profiles');
            var builder = new JsonObjectBuilder();
            put_0(builder, 'is_first_login', false);
            var body = builder.wmh();
            var this_3 = new PostgrestRequestBuilder(tmp0_1.owx_1.ebw().nwu_1);
            var filter_0 = new PostgrestFilterBuilder(this_3.swx_1, this_3.vwx_1);
            filter_0.nwy('id', this.eyo_1);
            var requestBuilder_0 = this_3;
            var tmp0_returning = requestBuilder_0.uwx_1;
            var tmp1_count = requestBuilder_0.twx_1;
            var tmp2_urlParams = mapToFirstValue(requestBuilder_0.vwx_1);
            var tmp3_schema = tmp0_1.qwx_1;
            var tmp4_headers = requestBuilder_0.wwx_1.g3d();
            var updateRequest = new UpdateRequest(tmp0_returning, tmp1_count, tmp2_urlParams, body, tmp3_schema, tmp4_headers);
            this.n9_1 = 5;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0_1.owx_1, tmp0_1.pwx_1, updateRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.o9_1 = 8;
            this.n9_1 = 9;
            continue $sm;
          case 7:
            this.o9_1 = 8;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 9;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 8:
            throw this.q9_1;
          case 9:
            this.o9_1 = 8;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $registerCOROUTINE$(_this__u8e3s4, email, password, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dyr_1 = _this__u8e3s4;
    this.eyr_1 = email;
    this.fyr_1 = password;
  }
  protoOf($registerCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            var tmp_0 = this;
            var this_0 = this.eyr_1;
            tmp_0.iyr_1 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
            this.n9_1 = 1;
            var tmp_1 = Email_instance;
            suspendResult = this.dyr_1.fym_1.vvy(tmp_1, VOID, AuthRepositoryImpl$register$lambda(this.iyr_1, this.fyr_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.gyr_1 = this.dyr_1.fym_1.qvz();
            if (!(this.gyr_1 == null)) {
              var initialProfile = new Profile(this.gyr_1.nwk_1, this.iyr_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, 'normal', VOID, VOID, VOID, true, VOID, VOID, VOID, 'email');
              this.o9_1 = 3;
              var tmp0 = this.dyr_1.gym_1.xwu('profiles');
              var values = listOf(initialProfile);
              var this_1 = tmp0.owx_1.rvz();
              var tmp0_0 = Default_getInstance();
              var string = this_1.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Profile), arrayOf([]), false))]), false), values);
              var this_2 = tmp0_0.c75();
              var this_3 = serializer(this_2, createKType(getKClass(JsonElement), arrayOf([]), false));
              var body = get_jsonArray(tmp0_0.c72(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), string));
              var requestBuilder = new InsertRequestBuilder(tmp0.owx_1.ebw().nwu_1);
              var destination = ArrayList_init_$Create$(collectionSizeOrDefault(body, 10));
              var _iterator__ex2g4s = body.t();
              while (_iterator__ex2g4s.u()) {
                var item = _iterator__ex2g4s.v();
                destination.j1(get_jsonObject(item).x2());
              }
              var columns = distinct(flatten(destination));
              if (!columns.r()) {
                var tmp0_1 = requestBuilder.vwx_1;
                var value = listOf(joinToString(columns, ','));
                tmp0_1.z2('columns', value);
              }
              var tmp0_returning = requestBuilder.uwx_1;
              var tmp1_count = requestBuilder.twx_1;
              var tmp2_urlParams = mapToFirstValue(requestBuilder.vwx_1);
              var tmp3_schema = tmp0.qwx_1;
              var tmp4_headers = requestBuilder.wwx_1.g3d();
              var tmp5_defaultToNull = requestBuilder.vwy_1;
              var insertRequest = new InsertRequest(VOID, tmp0_returning, tmp1_count, VOID, tmp5_defaultToNull, body, tmp2_urlParams, tmp3_schema, tmp4_headers);
              this.n9_1 = 2;
              suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, insertRequest, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 2:
            this.hyr_1 = suspendResult;
            this.o9_1 = 8;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.o9_1 = 8;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Exception) {
              var e = this.q9_1;
              var tmp_3 = this;
              tmp_3.hyr_1 = Unit_instance;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 8;
            this.n9_1 = 5;
            suspendResult = checkFirstLogin(this.dyr_1, this.gyr_1.nwk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.n9_1 = 7;
            suspendResult = this.dyr_1.rym_1.a1v(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            return this.dyr_1.sym_1.u1();
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 8) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $signOutCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ryr_1 = _this__u8e3s4;
  }
  protoOf($signOutCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            suspendResult = this.ryr_1.kym_1.syr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.ryr_1.lym_1.tyr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.ryr_1.fym_1.evz(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $deleteAccountCOROUTINE$(_this__u8e3s4, password, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cys_1 = _this__u8e3s4;
    this.dys_1 = password;
  }
  protoOf($deleteAccountCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.o9_1 = 7;
            var tmp0_elvis_lhs = this.cys_1.fym_1.qvz();
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return false;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var user = tmp_0;
            var tmp_1 = this;
            var tmp1_elvis_lhs = user.kwk_1;
            var tmp_2;
            if (tmp1_elvis_lhs == null) {
              return false;
            } else {
              tmp_2 = tmp1_elvis_lhs;
            }

            tmp_1.gys_1 = tmp_2;
            var tmp_3 = this;
            var tmp2_safe_receiver = user.fwk_1;
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.je('provider');
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : get_jsonPrimitive(tmp3_safe_receiver);
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.rj3();
            tmp_3.fys_1 = tmp5_elvis_lhs == null ? 'email' : tmp5_elvis_lhs;
            if (this.fys_1 === 'email') {
              if (this.dys_1 == null)
                return false;
              this.n9_1 = 1;
              var tmp_4 = Email_instance;
              suspendResult = this.cys_1.fym_1.xvy(tmp_4, VOID, AuthRepositoryImpl$deleteAccount$lambda(this.gys_1, this.dys_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var functionUrl = this.fys_1 === 'google' ? 'https://obujqoowtjzxwqpyqinh.supabase.co/functions/v1/supabase-functions-delete-user-index-ts' : 'https://obujqoowtjzxwqpyqinh.supabase.co/functions/v1/delete-google_account';
            var this_0 = this.cys_1.tym_1;
            var builder = new HttpRequestBuilder();
            builder.ztr_1 = Companion_getInstance_1().ft2_1;
            url_0(builder, functionUrl);
            contentType(builder, Application_getInstance().ksv_1);
            header(builder, 'Authorization', 'Bearer sb_publishable_UOeck9hhXwMgZOxCYGRMsQ_gWQAFz9a');
            header(builder, 'apikey', 'sb_publishable_UOeck9hhXwMgZOxCYGRMsQ_gWQAFz9a');
            var builder_0 = new JsonObjectBuilder();
            put(builder_0, 'email', this.gys_1);
            if (!(this.dys_1 == null)) {
              put(builder_0, 'password', this.dys_1);
            }

            put(builder_0, 'provider', this.fys_1);
            var body = builder_0.wmh();
            if (body == null) {
              builder.bts_1 = NullBody_instance;
              var tmp_5 = getKClass(JsonObject);
              var tmp_6;
              try {
                tmp_6 = createKType(getKClass(JsonObject), arrayOf([]), false);
              } catch ($p) {
                var tmp_7;
                if ($p instanceof Error) {
                  var _unused_var__etf5q3 = $p;
                  tmp_7 = null;
                } else {
                  throw $p;
                }
                tmp_6 = tmp_7;
              }
              builder.qtx(new TypeInfo(tmp_5, tmp_6));
            } else {
              if (body instanceof OutgoingContent) {
                builder.bts_1 = body;
                builder.qtx(null);
              } else {
                builder.bts_1 = body;
                var tmp_8 = getKClass(JsonObject);
                var tmp_9;
                try {
                  tmp_9 = createKType(getKClass(JsonObject), arrayOf([]), false);
                } catch ($p_0) {
                  var tmp_10;
                  if ($p_0 instanceof Error) {
                    var _unused_var__etf5q3_0 = $p_0;
                    tmp_10 = null;
                  } else {
                    throw $p_0;
                  }
                  tmp_9 = tmp_10;
                }
                builder.qtx(new TypeInfo(tmp_8, tmp_9));
              }
            }

            builder.ztr_1 = Companion_getInstance_1().ft2_1;
            this.n9_1 = 3;
            suspendResult = (new HttpStatement(builder, this_0)).pv2(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var response = suspendResult;
            if (!isSuccess(response.zbq()))
              return false;
            this.n9_1 = 4;
            suspendResult = this.cys_1.fym_1.evz(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.n9_1 = 5;
            suspendResult = this.cys_1.kym_1.syr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.n9_1 = 6;
            suspendResult = this.cys_1.lym_1.tyr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.eys_1 = true;
            this.o9_1 = 8;
            this.n9_1 = 9;
            continue $sm;
          case 7:
            this.o9_1 = 8;
            var tmp_11 = this.q9_1;
            if (tmp_11 instanceof Exception) {
              var e = this.q9_1;
              var tmp_12 = this;
              tmp_12.eys_1 = false;
              this.n9_1 = 9;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 8:
            throw this.q9_1;
          case 9:
            this.o9_1 = 8;
            return this.eys_1;
        }
      } catch ($p_1) {
        var e_0 = $p_1;
        if (this.o9_1 === 8) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $deleteAccountByTokenCOROUTINE$(_this__u8e3s4, token, email, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pys_1 = _this__u8e3s4;
    this.qys_1 = token;
    this.rys_1 = email;
  }
  protoOf($deleteAccountByTokenCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            this.o9_1 = 6;
            var tmp0 = this.pys_1.tym_1;
            var urlString = 'https://obujqoowtjzxwqpyqinh.supabase.co/functions/v1/supabase-functions-delete-user-index-ts';
            var builder = new HttpRequestBuilder();
            builder.ztr_1 = Companion_getInstance_1().ft2_1;
            url_0(builder, urlString);
            contentType(builder, Application_getInstance().ksv_1);
            header(builder, 'Authorization', 'Bearer ' + this.qys_1);
            header(builder, 'apikey', 'sb_publishable_UOeck9hhXwMgZOxCYGRMsQ_gWQAFz9a');
            var builder_0 = new JsonObjectBuilder();
            put(builder_0, 'email', this.rys_1);
            var body = builder_0.wmh();
            if (body == null) {
              builder.bts_1 = NullBody_instance;
              var tmp_0 = getKClass(JsonObject);
              var tmp_1;
              try {
                tmp_1 = createKType(getKClass(JsonObject), arrayOf([]), false);
              } catch ($p) {
                var tmp_2;
                if ($p instanceof Error) {
                  var _unused_var__etf5q3 = $p;
                  tmp_2 = null;
                } else {
                  throw $p;
                }
                tmp_1 = tmp_2;
              }
              builder.qtx(new TypeInfo(tmp_0, tmp_1));
            } else {
              if (body instanceof OutgoingContent) {
                builder.bts_1 = body;
                builder.qtx(null);
              } else {
                builder.bts_1 = body;
                var tmp_3 = getKClass(JsonObject);
                var tmp_4;
                try {
                  tmp_4 = createKType(getKClass(JsonObject), arrayOf([]), false);
                } catch ($p_0) {
                  var tmp_5;
                  if ($p_0 instanceof Error) {
                    var _unused_var__etf5q3_0 = $p_0;
                    tmp_5 = null;
                  } else {
                    throw $p_0;
                  }
                  tmp_4 = tmp_5;
                }
                builder.qtx(new TypeInfo(tmp_3, tmp_4));
              }
            }

            builder.ztr_1 = Companion_getInstance_1().ft2_1;
            this.n9_1 = 1;
            suspendResult = (new HttpStatement(builder, tmp0)).pv2(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var response = suspendResult;
            if (isSuccess(response.zbq())) {
              this.n9_1 = 2;
              suspendResult = this.pys_1.fym_1.evz(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_6 = this;
              tmp_6.tys_1 = false;
              this.n9_1 = 5;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            suspendResult = this.pys_1.kym_1.syr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.n9_1 = 4;
            suspendResult = this.pys_1.lym_1.tyr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.tys_1 = true;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.sys_1 = this.tys_1;
            this.o9_1 = 7;
            this.n9_1 = 8;
            continue $sm;
          case 6:
            this.o9_1 = 7;
            var tmp_7 = this.q9_1;
            if (tmp_7 instanceof Exception) {
              var e = this.q9_1;
              var tmp_8 = this;
              tmp_8.sys_1 = false;
              this.n9_1 = 8;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 7:
            throw this.q9_1;
          case 8:
            this.o9_1 = 7;
            return this.sys_1;
        }
      } catch ($p_1) {
        var e_0 = $p_1;
        if (this.o9_1 === 7) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $fetchProfileCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cyt_1 = _this__u8e3s4;
  }
  protoOf($fetchProfileCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.cyt_1.fym_1.qvz();
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.dyt_1 = tmp_1;
            var this_0 = this.cyt_1.gym_1.xwu('profiles');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('id', this.dyt_1.nwk_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            var profile = firstOrNull(tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Profile), arrayOf([]), false))]), false), value_0));
            var tmp2_elvis_lhs = profile == null ? null : profile.uyn(VOID, this.dyt_1.kwk_1);
            return tmp2_elvis_lhs == null ? toProfile(this.dyt_1) : tmp2_elvis_lhs;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $updateAvatarCOROUTINE$(_this__u8e3s4, imageBytes, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.myt_1 = _this__u8e3s4;
    this.nyt_1 = imageBytes;
  }
  protoOf($updateAvatarCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 11;
            this.o9_1 = 10;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.myt_1.fym_1.qvz();
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.qyt_1 = tmp_1;
            var tmp1_safe_receiver = this.qyt_1.twk_1;
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.je('avatar_url');
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : toString(tmp2_safe_receiver);
            var oldAvatarUrl = tmp3_safe_receiver == null ? null : removeSurrounding(tmp3_safe_receiver, '"');
            if (!(oldAvatarUrl == null || isBlank(oldAvatarUrl))) {
              var tmp4_safe_receiver = getAvatarPathFromUrl(this.myt_1, oldAvatarUrl);
              if (tmp4_safe_receiver == null) {
                this.tyt_1 = null;
                this.n9_1 = 4;
                continue $sm;
              } else {
                this.o9_1 = 2;
                this.n9_1 = 1;
                suspendResult = this.myt_1.hym_1.xwu('avatars').yx4([tmp4_safe_receiver], this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 1:
            this.o9_1 = 10;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.o9_1 = 10;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Exception) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 3;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            this.o9_1 = 10;
            var tmp_3 = this;
            tmp_3.tyt_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            var timestamp = System_instance.fp().wp();
            var fileName = 'avatar_' + timestamp.toString() + '.jpg';
            this.ryt_1 = this.qyt_1.nwk_1 + '/' + fileName;
            this.syt_1 = this.myt_1.hym_1.xwu('avatars');
            this.n9_1 = 6;
            var tmp_4 = toNativeByteArray(this.nyt_1);
            suspendResult = this.syt_1.vx4(this.ryt_1, tmp_4, AuthRepositoryImpl$updateAvatar$lambda, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.pyt_1 = this.syt_1.dx5(this.ryt_1);
            var tmp0 = this.myt_1.gym_1.xwu('profiles');
            var builder = new JsonObjectBuilder();
            put(builder, 'avatar_url', this.pyt_1);
            var body = builder.wmh();
            var this_0 = new PostgrestRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_0.swx_1, this_0.vwx_1);
            filter.nwy('id', this.qyt_1.nwk_1);
            var requestBuilder = this_0;
            var tmp0_returning = requestBuilder.uwx_1;
            var tmp1_count = requestBuilder.twx_1;
            var tmp2_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp3_schema = tmp0.qwx_1;
            var tmp4_headers = requestBuilder.wwx_1.g3d();
            var updateRequest = new UpdateRequest(tmp0_returning, tmp1_count, tmp2_urlParams, body, tmp3_schema, tmp4_headers);
            this.n9_1 = 7;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, updateRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.n9_1 = 8;
            suspendResult = this.myt_1.fym_1.zvy(VOID, VOID, AuthRepositoryImpl$updateAvatar$lambda_0(this.pyt_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.n9_1 = 9;
            suspendResult = this.myt_1.rym_1.a1v(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            this.oyt_1 = this.pyt_1;
            this.o9_1 = 11;
            this.n9_1 = 12;
            continue $sm;
          case 10:
            this.o9_1 = 11;
            var tmp_5 = this.q9_1;
            if (tmp_5 instanceof Exception) {
              var _unused_var__etf5q3_0 = this.q9_1;
              var tmp_6 = this;
              tmp_6.oyt_1 = null;
              this.n9_1 = 12;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 11:
            throw this.q9_1;
          case 12:
            this.o9_1 = 11;
            return this.oyt_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 11) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $deleteAvatarCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cyu_1 = _this__u8e3s4;
  }
  protoOf($deleteAvatarCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 10;
            this.o9_1 = 9;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.cyu_1.fym_1.qvz();
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return false;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.eyu_1 = tmp_1;
            var tmp1_safe_receiver = this.eyu_1.twk_1;
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.je('avatar_url');
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : toString(tmp2_safe_receiver);
            var avatarUrl = tmp3_safe_receiver == null ? null : removeSurrounding(tmp3_safe_receiver, '"');
            if (!(avatarUrl == null || isBlank(avatarUrl))) {
              var tmp4_safe_receiver = getAvatarPathFromUrl(this.cyu_1, avatarUrl);
              if (tmp4_safe_receiver == null) {
                this.fyu_1 = null;
                this.n9_1 = 4;
                continue $sm;
              } else {
                this.o9_1 = 2;
                this.n9_1 = 1;
                suspendResult = this.cyu_1.hym_1.xwu('avatars').yx4([tmp4_safe_receiver], this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 1:
            this.o9_1 = 9;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.o9_1 = 9;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Exception) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 3;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            this.o9_1 = 9;
            var tmp_3 = this;
            tmp_3.fyu_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            var tmp0 = this.cyu_1.gym_1.xwu('profiles');
            var builder = new JsonObjectBuilder();
            put(builder, 'avatar_url', (null == null ? true : typeof null === 'string') ? null : THROW_CCE());
            var body = builder.wmh();
            var this_0 = new PostgrestRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_0.swx_1, this_0.vwx_1);
            filter.nwy('id', this.eyu_1.nwk_1);
            var requestBuilder = this_0;
            var tmp0_returning = requestBuilder.uwx_1;
            var tmp1_count = requestBuilder.twx_1;
            var tmp2_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp3_schema = tmp0.qwx_1;
            var tmp4_headers = requestBuilder.wwx_1.g3d();
            var updateRequest = new UpdateRequest(tmp0_returning, tmp1_count, tmp2_urlParams, body, tmp3_schema, tmp4_headers);
            this.n9_1 = 6;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, updateRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.n9_1 = 7;
            suspendResult = this.cyu_1.fym_1.zvy(VOID, VOID, AuthRepositoryImpl$deleteAvatar$lambda, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.n9_1 = 8;
            suspendResult = this.cyu_1.rym_1.a1v(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.dyu_1 = true;
            this.o9_1 = 10;
            this.n9_1 = 11;
            continue $sm;
          case 9:
            this.o9_1 = 10;
            var tmp_4 = this.q9_1;
            if (tmp_4 instanceof Exception) {
              var e = this.q9_1;
              var tmp_5 = this;
              tmp_5.dyu_1 = false;
              this.n9_1 = 11;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 10:
            throw this.q9_1;
          case 11:
            this.o9_1 = 10;
            return this.dyu_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 10) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $updateProfileCOROUTINE$(_this__u8e3s4, profile, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.oyu_1 = _this__u8e3s4;
    this.pyu_1 = profile;
  }
  protoOf($updateProfileCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.o9_1 = 4;
            var tmp0_elvis_lhs = this.oyu_1.fym_1.qvz();
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return false;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var user = tmp_0;
            var tmp0 = this.oyu_1.gym_1.xwu('profiles');
            var value = this.pyu_1;
            var this_0 = tmp0.owx_1.rvz();
            var tmp0_0 = Default_getInstance();
            var string = this_0.avo(createKType(getKClass(Profile), arrayOf([]), false), value);
            var this_1 = tmp0_0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(JsonElement), arrayOf([]), false));
            var body = tmp0_0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string);
            var this_3 = new PostgrestRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_3.swx_1, this_3.vwx_1);
            filter.nwy('id', user.nwk_1);
            var requestBuilder = this_3;
            var tmp0_returning = requestBuilder.uwx_1;
            var tmp1_count = requestBuilder.twx_1;
            var tmp2_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp3_schema = tmp0.qwx_1;
            var tmp4_headers = requestBuilder.wwx_1.g3d();
            var updateRequest = new UpdateRequest(tmp0_returning, tmp1_count, tmp2_urlParams, body, tmp3_schema, tmp4_headers);
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, updateRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.oyu_1.fym_1.zvy(VOID, VOID, AuthRepositoryImpl$updateProfile$lambda(this.pyu_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.oyu_1.rym_1.a1v(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.qyu_1 = true;
            this.o9_1 = 5;
            this.n9_1 = 6;
            continue $sm;
          case 4:
            this.o9_1 = 5;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Exception) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_2 = this;
              tmp_2.qyu_1 = false;
              this.n9_1 = 6;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 5:
            throw this.q9_1;
          case 6:
            this.o9_1 = 5;
            return this.qyu_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $updatePasswordCOROUTINE$(_this__u8e3s4, newPassword, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zyu_1 = _this__u8e3s4;
    this.ayv_1 = newPassword;
  }
  protoOf($updatePasswordCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.zyu_1.fym_1.zvy(VOID, VOID, AuthRepositoryImpl$updatePassword$lambda(this.ayv_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.byv_1 = true;
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_1 = this;
              tmp_1.byv_1 = false;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.byv_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $updateFcmTokenCOROUTINE$(_this__u8e3s4, token, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kyv_1 = _this__u8e3s4;
    this.lyv_1 = token;
  }
  protoOf($updateFcmTokenCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.o9_1 = 3;
            var tmp0_elvis_lhs = this.kyv_1.fym_1.qvz();
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return false;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var user = tmp_0;
            var tmp0 = this.kyv_1.gym_1.xwu('profiles');
            var builder = new JsonObjectBuilder();
            put(builder, 'fcm_token', this.lyv_1);
            put(builder, 'email', user.kwk_1);
            var body = builder.wmh();
            var this_0 = new PostgrestRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_0.swx_1, this_0.vwx_1);
            filter.nwy('id', user.nwk_1);
            var requestBuilder = this_0;
            var tmp0_returning = requestBuilder.uwx_1;
            var tmp1_count = requestBuilder.twx_1;
            var tmp2_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp3_schema = tmp0.qwx_1;
            var tmp4_headers = requestBuilder.wwx_1.g3d();
            var updateRequest = new UpdateRequest(tmp0_returning, tmp1_count, tmp2_urlParams, body, tmp3_schema, tmp4_headers);
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, updateRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.kyv_1.rym_1.a1v(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.myv_1 = true;
            this.o9_1 = 4;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 4;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Exception) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_2 = this;
              tmp_2.myv_1 = false;
              this.n9_1 = 5;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            throw this.q9_1;
          case 5:
            this.o9_1 = 4;
            return this.myv_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function AuthRepositoryImpl(auth, postgrest, storage, languageSwitcher, languageStorage, cartRepository, productRepository, settingsRepository, createWelcomeCouponUseCase, functions) {
    this.fym_1 = auth;
    this.gym_1 = postgrest;
    this.hym_1 = storage;
    this.iym_1 = languageSwitcher;
    this.jym_1 = languageStorage;
    this.kym_1 = cartRepository;
    this.lym_1 = productRepository;
    this.mym_1 = settingsRepository;
    this.nym_1 = createWelcomeCouponUseCase;
    this.oym_1 = functions;
    this.pym_1 = CoroutineScope_0(Dispatchers_getInstance().i1h_1.xj(SupervisorJob()));
    var tmp = this;
    tmp.qym_1 = stateIn(onEach(this.jym_1.pyl_1, AuthRepositoryImpl$language$slambda_0(this, null)), this.pym_1, Companion_getInstance_2().s1z_1, this.iym_1.nyv());
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_0 = MutableSharedFlow(1);
    this_0.i1z(Unit_instance);
    tmp_0.rym_1 = this_0;
    var tmp_1 = this;
    var tmp_2 = this.fym_1.svy();
    // Inline function 'kotlinx.coroutines.flow.flatMapLatest' call
    var this_1 = combine(tmp_2, this.rym_1, AuthRepositoryImpl$currentUser$slambda_0(null));
    var tmp$ret$2 = transformLatest(this_1, AuthRepositoryImpl$currentUser$slambda_2(this, null));
    tmp_1.sym_1 = stateIn(tmp$ret$2, this.pym_1, Companion_getInstance_2().s1z_1, null);
    var tmp_3 = this;
    tmp_3.tym_1 = HttpClient(AuthRepositoryImpl$httpClient$lambda);
  }
  protoOf(AuthRepositoryImpl).n8m = function () {
    return this.qym_1;
  };
  protoOf(AuthRepositoryImpl).oyv = function () {
    return this.sym_1;
  };
  protoOf(AuthRepositoryImpl).pyv = function (idToken, accessToken, $completion) {
    var tmp = new $loginWithGoogleCOROUTINE$(this, idToken, accessToken, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl).qyv = function (email, password, $completion) {
    var tmp = new $loginCOROUTINE$(this, email, password, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl).ryv = function (email, password, $completion) {
    var tmp = new $registerCOROUTINE$(this, email, password, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl).syv = function (email, redirectTo, $completion) {
    // Inline function 'kotlin.text.trim' call
    var tmp$ret$0 = toString(trim(isCharSequence(email) ? email : THROW_CCE()));
    return this.fym_1.bvz(tmp$ret$0, redirectTo, VOID, $completion);
  };
  protoOf(AuthRepositoryImpl).tyv = function (url, $completion) {
    var session = parseSessionFromUrl(this.fym_1, url);
    return this.fym_1.gvz(session, VOID, VOID, $completion);
  };
  protoOf(AuthRepositoryImpl).uyv = function ($completion) {
    var tmp = new $signOutCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl).vyv = function (password, $completion) {
    var tmp = new $deleteAccountCOROUTINE$(this, password, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl).wyv = function (token, email, $completion) {
    var tmp = new $deleteAccountByTokenCOROUTINE$(this, token, email, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl).xyv = function () {
    var tmp0_safe_receiver = this.fym_1.qvz();
    return tmp0_safe_receiver == null ? null : toProfile(tmp0_safe_receiver);
  };
  protoOf(AuthRepositoryImpl).yyv = function ($completion) {
    var tmp = new $fetchProfileCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl).zyv = function (imageBytes, $completion) {
    var tmp = new $updateAvatarCOROUTINE$(this, imageBytes, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl).ayw = function ($completion) {
    var tmp = new $deleteAvatarCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl).byw = function (profile, $completion) {
    var tmp = new $updateProfileCOROUTINE$(this, profile, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl).cyw = function (newPassword, $completion) {
    var tmp = new $updatePasswordCOROUTINE$(this, newPassword, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl).dyw = function (token, $completion) {
    var tmp = new $updateFcmTokenCOROUTINE$(this, token, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthRepositoryImpl).nyv = function () {
    return this.iym_1.nyv();
  };
  protoOf(AuthRepositoryImpl).eyw = function (lang) {
    var tmp;
    try {
      this.jym_1.qyl(lang);
      this.iym_1.qyl(lang);
      tmp = true;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var e = $p;
        tmp_0 = false;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  var client_fstech_hadaya_data_repository_CartRepositoryImpl$stable;
  function toRemote($this, $receiver) {
    var tmp0_safe_receiver = $receiver.tyw_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver, 10));
      var _iterator__ex2g4s = tmp0_safe_receiver.t();
      while (_iterator__ex2g4s.u()) {
        var item = _iterator__ex2g4s.v();
        var tmp$ret$2 = item.iyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null);
        destination.j1(tmp$ret$2);
      }
      tmp = destination;
    }
    var tmp1_designLayers = tmp;
    return $receiver.jyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_designLayers, VOID, VOID, VOID, null);
  }
  function CartRepositoryImpl$addToCart$slambda(this$0, $cartItem, resultContinuation) {
    this.syy_1 = this$0;
    this.tyy_1 = $cartItem;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartRepositoryImpl$addToCart$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartRepositoryImpl$addToCart$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartRepositoryImpl$addToCart$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            this.o9_1 = 11;
            var user = this.syy_1.ayz_1.qvz();
            var tmp_0 = this;
            tmp_0.wyy_1 = user == null ? null : user.nwk_1;
            var tmp_1 = this;
            var tmp_2;
            if (!(this.wyy_1 == null)) {
              tmp_2 = this.tyy_1.jyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.wyy_1);
            } else {
              tmp_2 = this.tyy_1.jyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null);
            }

            tmp_1.yyy_1 = tmp_2;
            this.n9_1 = 1;
            suspendResult = this.syy_1.byz_1.fyz(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0 = suspendResult;
            var tmp$ret$0 = Unit_instance;
            l$ret$1: do {
              var _iterator__ex2g4s = tmp0.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                var tmp_3;
                var tmp_4;
                var tmp_5;
                var tmp_6;
                var tmp_7;
                var tmp_8;
                var tmp_9;
                var tmp_10;
                var tmp_11;
                var tmp_12;
                var tmp_13;
                var tmp_14;
                var tmp_15;
                var tmp_16;
                var tmp_17;
                if (equals(element.gyw_1, this.yyy_1.gyw_1)) {
                  var tmp0_safe_receiver = element.dyx_1;
                  var tmp_18 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gyz_1;
                  var tmp1_safe_receiver = this.yyy_1.dyx_1;
                  tmp_17 = equals(tmp_18, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.gyz_1);
                } else {
                  tmp_17 = false;
                }
                if (tmp_17) {
                  var tmp2_safe_receiver = element.gyx_1;
                  var tmp_19 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.ryz_1;
                  var tmp3_safe_receiver = this.yyy_1.gyx_1;
                  tmp_16 = equals(tmp_19, tmp3_safe_receiver == null ? null : tmp3_safe_receiver.ryz_1);
                } else {
                  tmp_16 = false;
                }
                if (tmp_16) {
                  tmp_15 = element.eyx_1 == this.yyy_1.eyx_1;
                } else {
                  tmp_15 = false;
                }
                if (tmp_15) {
                  tmp_14 = element.fyx_1 == this.yyy_1.fyx_1;
                } else {
                  tmp_14 = false;
                }
                if (tmp_14) {
                  tmp_13 = element.hyx_1 == this.yyy_1.hyx_1;
                } else {
                  tmp_13 = false;
                }
                if (tmp_13) {
                  tmp_12 = element.iyx_1 == this.yyy_1.iyx_1;
                } else {
                  tmp_12 = false;
                }
                if (tmp_12) {
                  tmp_11 = element.syw_1 == this.yyy_1.syw_1;
                } else {
                  tmp_11 = false;
                }
                if (tmp_11) {
                  tmp_10 = equals(element.tyw_1, this.yyy_1.tyw_1);
                } else {
                  tmp_10 = false;
                }
                if (tmp_10) {
                  tmp_9 = element.jyx_1 == this.yyy_1.jyx_1;
                } else {
                  tmp_9 = false;
                }
                if (tmp_9) {
                  tmp_8 = element.kyx_1 == this.yyy_1.kyx_1;
                } else {
                  tmp_8 = false;
                }
                if (tmp_8) {
                  tmp_7 = equals(element.lyx_1, this.yyy_1.lyx_1);
                } else {
                  tmp_7 = false;
                }
                if (tmp_7) {
                  tmp_6 = element.myx_1 == this.yyy_1.myx_1;
                } else {
                  tmp_6 = false;
                }
                if (tmp_6) {
                  tmp_5 = element.qyx_1 == this.yyy_1.qyx_1;
                } else {
                  tmp_5 = false;
                }
                if (tmp_5) {
                  tmp_4 = element.cyx_1.equals(this.yyy_1.cyx_1);
                } else {
                  tmp_4 = false;
                }
                if (tmp_4) {
                  tmp_3 = element.uyw_1 == this.yyy_1.uyw_1;
                } else {
                  tmp_3 = false;
                }
                if (tmp_3) {
                  tmp$ret$0 = element;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = null;
            }
             while (false);
            var existingItem = tmp$ret$0;
            if (!(existingItem == null)) {
              this.vyy_1 = existingItem.jyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, existingItem.ryw_1 + this.tyy_1.ryw_1 | 0);
              this.n9_1 = 7;
              suspendResult = this.syy_1.byz_1.dz0(this.vyy_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = this.syy_1.byz_1.cz0(this.yyy_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            if (!(this.wyy_1 == null)) {
              this.o9_1 = 4;
              var tmp0_0 = this.syy_1.zyy_1.xwu('cart_items');
              var value = toRemote(this.syy_1, this.yyy_1);
              var values = listOf(value);
              var this_0 = tmp0_0.owx_1.rvz();
              var tmp0_1 = Default_getInstance();
              var string = this_0.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CartItem), arrayOf([]), false))]), false), values);
              var this_1 = tmp0_1.c75();
              var this_2 = serializer(this_1, createKType(getKClass(JsonElement), arrayOf([]), false));
              var body = get_jsonArray(tmp0_1.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string));
              var requestBuilder = new UpsertRequestBuilder(tmp0_0.owx_1.ebw().nwu_1);
              var destination = ArrayList_init_$Create$(collectionSizeOrDefault(body, 10));
              var _iterator__ex2g4s_0 = body.t();
              while (_iterator__ex2g4s_0.u()) {
                var item = _iterator__ex2g4s_0.v();
                destination.j1(get_jsonObject(item).x2());
              }
              var columns = distinct(flatten(destination));
              if (!columns.r()) {
                var tmp0_2 = requestBuilder.vwx_1;
                var value_0 = listOf(joinToString(columns, ','));
                tmp0_2.z2('columns', value_0);
              }
              var tmp0_safe_receiver_0 = requestBuilder.iwz_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                var tmp0_3 = requestBuilder.vwx_1;
                var tmp2 = 'on_conflict';
                var value_1 = listOf(tmp0_safe_receiver_0);
                tmp0_3.z2(tmp2, value_1);
              }
              var tmp1_returning = requestBuilder.uwx_1;
              var tmp2_count = requestBuilder.twx_1;
              var tmp3_urlParams = mapToFirstValue(requestBuilder.vwx_1);
              var tmp4_defaultToNull = requestBuilder.vwy_1;
              var tmp5_ignoreDuplicates = requestBuilder.jwz_1;
              var tmp6_schema = tmp0_0.qwx_1;
              var tmp7_headers = requestBuilder.wwx_1.g3d();
              var insertRequest = new InsertRequest(true, tmp1_returning, tmp2_count, tmp5_ignoreDuplicates, tmp4_defaultToNull, body, tmp3_urlParams, tmp6_schema, tmp7_headers);
              this.n9_1 = 3;
              suspendResult = RestRequestExecutor_instance.hwx(tmp0_0.owx_1, tmp0_0.pwx_1, insertRequest, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 3:
            this.xyy_1 = suspendResult;
            this.o9_1 = 11;
            this.n9_1 = 5;
            continue $sm;
          case 4:
            this.o9_1 = 11;
            var tmp_20 = this.q9_1;
            if (tmp_20 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_21 = this;
              tmp_21.xyy_1 = Unit_instance;
              this.n9_1 = 5;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 5:
            this.o9_1 = 11;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.n9_1 = 10;
            continue $sm;
          case 7:
            if (!(this.wyy_1 == null)) {
              var tmp0_4 = this.syy_1.zyy_1.xwu('cart_items');
              var value_2 = toRemote(this.syy_1, this.vyy_1);
              var values_0 = listOf(value_2);
              var this_3 = tmp0_4.owx_1.rvz();
              var tmp0_5 = Default_getInstance();
              var string_0 = this_3.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CartItem), arrayOf([]), false))]), false), values_0);
              var this_4 = tmp0_5.c75();
              var this_5 = serializer(this_4, createKType(getKClass(JsonElement), arrayOf([]), false));
              var body_0 = get_jsonArray(tmp0_5.c72(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), string_0));
              var requestBuilder_0 = new UpsertRequestBuilder(tmp0_4.owx_1.ebw().nwu_1);
              var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(body_0, 10));
              var _iterator__ex2g4s_1 = body_0.t();
              while (_iterator__ex2g4s_1.u()) {
                var item_0 = _iterator__ex2g4s_1.v();
                destination_0.j1(get_jsonObject(item_0).x2());
              }
              var columns_0 = distinct(flatten(destination_0));
              if (!columns_0.r()) {
                var tmp0_6 = requestBuilder_0.vwx_1;
                var value_3 = listOf(joinToString(columns_0, ','));
                tmp0_6.z2('columns', value_3);
              }
              var tmp0_safe_receiver_1 = requestBuilder_0.iwz_1;
              if (tmp0_safe_receiver_1 == null)
                null;
              else {
                var tmp0_7 = requestBuilder_0.vwx_1;
                var tmp2_0 = 'on_conflict';
                var value_4 = listOf(tmp0_safe_receiver_1);
                tmp0_7.z2(tmp2_0, value_4);
              }
              var tmp1_returning_0 = requestBuilder_0.uwx_1;
              var tmp2_count_0 = requestBuilder_0.twx_1;
              var tmp3_urlParams_0 = mapToFirstValue(requestBuilder_0.vwx_1);
              var tmp4_defaultToNull_0 = requestBuilder_0.vwy_1;
              var tmp5_ignoreDuplicates_0 = requestBuilder_0.jwz_1;
              var tmp6_schema_0 = tmp0_4.qwx_1;
              var tmp7_headers_0 = requestBuilder_0.wwx_1.g3d();
              var insertRequest_0 = new InsertRequest(true, tmp1_returning_0, tmp2_count_0, tmp5_ignoreDuplicates_0, tmp4_defaultToNull_0, body_0, tmp3_urlParams_0, tmp6_schema_0, tmp7_headers_0);
              this.n9_1 = 8;
              suspendResult = RestRequestExecutor_instance.hwx(tmp0_4.owx_1, tmp0_4.pwx_1, insertRequest_0, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 9;
              continue $sm;
            }

          case 8:
            this.n9_1 = 9;
            continue $sm;
          case 9:
            this.n9_1 = 10;
            continue $sm;
          case 10:
            this.o9_1 = 12;
            this.n9_1 = 13;
            continue $sm;
          case 11:
            this.o9_1 = 12;
            var tmp_22 = this.q9_1;
            if (tmp_22 instanceof Error) {
              var _unused_var__etf5q3_0 = this.q9_1;
              this.n9_1 = 13;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 12:
            throw this.q9_1;
          case 13:
            this.o9_1 = 12;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 12) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartRepositoryImpl$addToCart$slambda).q24 = function ($this$launch, completion) {
    var i = new CartRepositoryImpl$addToCart$slambda(this.syy_1, this.tyy_1, completion);
    i.uyy_1 = $this$launch;
    return i;
  };
  function CartRepositoryImpl$addToCart$slambda_0(this$0, $cartItem, resultContinuation) {
    var i = new CartRepositoryImpl$addToCart$slambda(this$0, $cartItem, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CartRepositoryImpl$syncCart$slambda(this$0, resultContinuation) {
    this.mz0_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartRepositoryImpl$syncCart$slambda).p24 = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartRepositoryImpl$syncCart$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartRepositoryImpl$syncCart$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 20;
            this.o9_1 = 19;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.mz0_1.ayz_1.qvz();
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.rz0_1 = tmp_1;
            this.n9_1 = 1;
            suspendResult = this.mz0_1.byz_1.fyz(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var localItems = suspendResult;
            var destination = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s = localItems.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              var this_0 = element.uyw_1;
              if (this_0 == null || charSequenceLength(this_0) === 0) {
                destination.j1(element);
              }
            }

            this.uz0_1 = destination.t();
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!this.uz0_1.u()) {
              this.n9_1 = 7;
              continue $sm;
            }

            var element_0 = this.uz0_1.v();
            this.o9_1 = 5;
            this.tz0_1 = element_0.jyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.rz0_1.nwk_1);
            var tmp0 = this.mz0_1.zyy_1.xwu('cart_items');
            var value = toRemote(this.mz0_1, this.tz0_1);
            var values = listOf(value);
            var this_1 = tmp0.owx_1.rvz();
            var tmp0_0 = Default_getInstance();
            var string = this_1.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CartItem), arrayOf([]), false))]), false), values);
            var this_2 = tmp0_0.c75();
            var this_3 = serializer(this_2, createKType(getKClass(JsonElement), arrayOf([]), false));
            var body = get_jsonArray(tmp0_0.c72(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), string));
            var requestBuilder = new UpsertRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(body, 10));
            var _iterator__ex2g4s_0 = body.t();
            while (_iterator__ex2g4s_0.u()) {
              var item = _iterator__ex2g4s_0.v();
              destination_0.j1(get_jsonObject(item).x2());
            }

            var columns = distinct(flatten(destination_0));
            if (!columns.r()) {
              var tmp0_1 = requestBuilder.vwx_1;
              var value_0 = listOf(joinToString(columns, ','));
              tmp0_1.z2('columns', value_0);
            }

            var tmp0_safe_receiver = requestBuilder.iwz_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              var tmp0_2 = requestBuilder.vwx_1;
              var tmp2 = 'on_conflict';
              var value_1 = listOf(tmp0_safe_receiver);
              tmp0_2.z2(tmp2, value_1);
            }

            var tmp1_returning = requestBuilder.uwx_1;
            var tmp2_count = requestBuilder.twx_1;
            var tmp3_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp4_defaultToNull = requestBuilder.vwy_1;
            var tmp5_ignoreDuplicates = requestBuilder.jwz_1;
            var tmp6_schema = tmp0.qwx_1;
            var tmp7_headers = requestBuilder.wwx_1.g3d();
            var insertRequest = new InsertRequest(true, tmp1_returning, tmp2_count, tmp5_ignoreDuplicates, tmp4_defaultToNull, body, tmp3_urlParams, tmp6_schema, tmp7_headers);
            this.n9_1 = 3;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, insertRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.n9_1 = 4;
            suspendResult = this.mz0_1.byz_1.dz0(this.tz0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.o9_1 = 19;
            this.n9_1 = 6;
            continue $sm;
          case 5:
            this.o9_1 = 19;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Exception) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 6;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 6:
            this.o9_1 = 19;
            this.n9_1 = 2;
            continue $sm;
          case 7:
            var this_4 = this.mz0_1.zyy_1.xwu('cart_items');
            var columns_0 = Companion_getInstance_0().iwx_1;
            var this_5 = new SelectRequestBuilder(this_4.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_5.swx_1, this_5.vwx_1);
            filter.nwy('user_id', this.rz0_1.nwk_1);
            var tmp0_3 = this_5.vwx_1;
            var value_2 = listOf(_Columns___get_value__impl__haxhww(columns_0));
            tmp0_3.z2('select', value_2);
            var requestBuilder_0 = this_5;
            var selectRequest = new SelectRequest(requestBuilder_0.bwz_1, requestBuilder_0.twx_1, mapToFirstValue(requestBuilder_0.vwx_1), this_4.qwx_1, requestBuilder_0.wwx_1.g3d());
            this.n9_1 = 8;
            suspendResult = RestRequestExecutor_instance.hwx(this_4.owx_1, this_4.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            var tmp_3 = this;
            var this_6 = suspendResult;
            var tmp0_4 = this_6.wx0_1.rvz();
            var value_3 = this_6.ux0_1;
            tmp_3.pz0_1 = tmp0_4.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CartItem), arrayOf([]), false))]), false), value_3);
            this.sz0_1 = this.pz0_1.t();
            this.n9_1 = 9;
            continue $sm;
          case 9:
            if (!this.sz0_1.u()) {
              this.n9_1 = 11;
              continue $sm;
            }

            var element_1 = this.sz0_1.v();
            this.n9_1 = 10;
            suspendResult = this.mz0_1.byz_1.cz0(element_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            this.n9_1 = 9;
            continue $sm;
          case 11:
            this.n9_1 = 12;
            suspendResult = this.mz0_1.byz_1.fyz(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            var updatedLocalItems = suspendResult;
            var destination_1 = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s_1 = updatedLocalItems.t();
            while (_iterator__ex2g4s_1.u()) {
              var element_2 = _iterator__ex2g4s_1.v();
              if (element_2.uyw_1 === this.rz0_1.nwk_1) {
                destination_1.j1(element_2);
              }
            }

            this.qz0_1 = destination_1.t();
            this.n9_1 = 13;
            continue $sm;
          case 13:
            if (!this.qz0_1.u()) {
              this.n9_1 = 18;
              continue $sm;
            }

            var element_3 = this.qz0_1.v();
            var tmp0_5 = this.pz0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var tmp_4;
              if (isInterface(tmp0_5, Collection)) {
                tmp_4 = tmp0_5.r();
              } else {
                tmp_4 = false;
              }
              if (tmp_4) {
                tmp$ret$0 = true;
                break l$ret$1;
              }
              var _iterator__ex2g4s_2 = tmp0_5.t();
              while (_iterator__ex2g4s_2.u()) {
                var element_4 = _iterator__ex2g4s_2.v();
                if (element_4.fyw_1 === element_3.fyw_1) {
                  tmp$ret$0 = false;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = true;
            }
             while (false);
            if (tmp$ret$0) {
              this.o9_1 = 15;
              var tmp0_6 = this.mz0_1.zyy_1.xwu('cart_items');
              var value_4 = toRemote(this.mz0_1, element_3);
              var values_0 = listOf(value_4);
              var this_7 = tmp0_6.owx_1.rvz();
              var tmp0_7 = Default_getInstance();
              var string_0 = this_7.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CartItem), arrayOf([]), false))]), false), values_0);
              var this_8 = tmp0_7.c75();
              var this_9 = serializer(this_8, createKType(getKClass(JsonElement), arrayOf([]), false));
              var body_0 = get_jsonArray(tmp0_7.c72(isInterface(this_9, KSerializer) ? this_9 : THROW_CCE(), string_0));
              var requestBuilder_1 = new UpsertRequestBuilder(tmp0_6.owx_1.ebw().nwu_1);
              var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(body_0, 10));
              var _iterator__ex2g4s_3 = body_0.t();
              while (_iterator__ex2g4s_3.u()) {
                var item_0 = _iterator__ex2g4s_3.v();
                destination_2.j1(get_jsonObject(item_0).x2());
              }
              var columns_1 = distinct(flatten(destination_2));
              if (!columns_1.r()) {
                var tmp0_8 = requestBuilder_1.vwx_1;
                var value_5 = listOf(joinToString(columns_1, ','));
                tmp0_8.z2('columns', value_5);
              }
              var tmp0_safe_receiver_0 = requestBuilder_1.iwz_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                var tmp0_9 = requestBuilder_1.vwx_1;
                var tmp2_0 = 'on_conflict';
                var value_6 = listOf(tmp0_safe_receiver_0);
                tmp0_9.z2(tmp2_0, value_6);
              }
              var tmp1_returning_0 = requestBuilder_1.uwx_1;
              var tmp2_count_0 = requestBuilder_1.twx_1;
              var tmp3_urlParams_0 = mapToFirstValue(requestBuilder_1.vwx_1);
              var tmp4_defaultToNull_0 = requestBuilder_1.vwy_1;
              var tmp5_ignoreDuplicates_0 = requestBuilder_1.jwz_1;
              var tmp6_schema_0 = tmp0_6.qwx_1;
              var tmp7_headers_0 = requestBuilder_1.wwx_1.g3d();
              var insertRequest_0 = new InsertRequest(true, tmp1_returning_0, tmp2_count_0, tmp5_ignoreDuplicates_0, tmp4_defaultToNull_0, body_0, tmp3_urlParams_0, tmp6_schema_0, tmp7_headers_0);
              this.n9_1 = 14;
              suspendResult = RestRequestExecutor_instance.hwx(tmp0_6.owx_1, tmp0_6.pwx_1, insertRequest_0, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 17;
              continue $sm;
            }

          case 14:
            this.oz0_1 = suspendResult;
            this.o9_1 = 19;
            this.n9_1 = 16;
            continue $sm;
          case 15:
            this.o9_1 = 19;
            var tmp_5 = this.q9_1;
            if (tmp_5 instanceof Exception) {
              var _unused_var__etf5q3_0 = this.q9_1;
              var tmp_6 = this;
              tmp_6.oz0_1 = Unit_instance;
              this.n9_1 = 16;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 16:
            this.o9_1 = 19;
            this.n9_1 = 17;
            continue $sm;
          case 17:
            this.n9_1 = 13;
            continue $sm;
          case 18:
            this.o9_1 = 20;
            this.n9_1 = 21;
            continue $sm;
          case 19:
            this.o9_1 = 20;
            var tmp_7 = this.q9_1;
            if (tmp_7 instanceof Error) {
              var _unused_var__etf5q3_1 = this.q9_1;
              this.n9_1 = 21;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 20:
            throw this.q9_1;
          case 21:
            this.o9_1 = 20;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 20) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartRepositoryImpl$syncCart$slambda).q24 = function ($this$withContext, completion) {
    var i = new CartRepositoryImpl$syncCart$slambda(this.mz0_1, completion);
    i.nz0_1 = $this$withContext;
    return i;
  };
  function CartRepositoryImpl$syncCart$slambda_0(this$0, resultContinuation) {
    var i = new CartRepositoryImpl$syncCart$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.p24($this$withContext, $completion);
    }, 1);
  }
  function $updateCartItemCOROUTINE$(_this__u8e3s4, cartItem, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dz1_1 = _this__u8e3s4;
    this.ez1_1 = cartItem;
  }
  protoOf($updateCartItemCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            if (!this.dz1_1.dyz_1.fz1().u1()) {
              throw Exception_init_$Create$('Please go online to update your cart');
            }

            this.o9_1 = 4;
            this.n9_1 = 1;
            suspendResult = this.dz1_1.byz_1.dz0(this.ez1_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var user = this.dz1_1.ayz_1.qvz();
            if (!(user == null)) {
              var tmp0 = this.dz1_1.zyy_1.xwu('cart_items');
              var value = toRemote(this.dz1_1, this.ez1_1.jyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, user.nwk_1));
              var values = listOf(value);
              var this_0 = tmp0.owx_1.rvz();
              var tmp0_0 = Default_getInstance();
              var string = this_0.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CartItem), arrayOf([]), false))]), false), values);
              var this_1 = tmp0_0.c75();
              var this_2 = serializer(this_1, createKType(getKClass(JsonElement), arrayOf([]), false));
              var body = get_jsonArray(tmp0_0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string));
              var requestBuilder = new UpsertRequestBuilder(tmp0.owx_1.ebw().nwu_1);
              var destination = ArrayList_init_$Create$(collectionSizeOrDefault(body, 10));
              var _iterator__ex2g4s = body.t();
              while (_iterator__ex2g4s.u()) {
                var item = _iterator__ex2g4s.v();
                destination.j1(get_jsonObject(item).x2());
              }
              var columns = distinct(flatten(destination));
              if (!columns.r()) {
                var tmp0_1 = requestBuilder.vwx_1;
                var value_0 = listOf(joinToString(columns, ','));
                tmp0_1.z2('columns', value_0);
              }
              var tmp0_safe_receiver = requestBuilder.iwz_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                var tmp0_2 = requestBuilder.vwx_1;
                var tmp2 = 'on_conflict';
                var value_1 = listOf(tmp0_safe_receiver);
                tmp0_2.z2(tmp2, value_1);
              }
              var tmp1_returning = requestBuilder.uwx_1;
              var tmp2_count = requestBuilder.twx_1;
              var tmp3_urlParams = mapToFirstValue(requestBuilder.vwx_1);
              var tmp4_defaultToNull = requestBuilder.vwy_1;
              var tmp5_ignoreDuplicates = requestBuilder.jwz_1;
              var tmp6_schema = tmp0.qwx_1;
              var tmp7_headers = requestBuilder.wwx_1.g3d();
              var insertRequest = new InsertRequest(true, tmp1_returning, tmp2_count, tmp5_ignoreDuplicates, tmp4_defaultToNull, body, tmp3_urlParams, tmp6_schema, tmp7_headers);
              this.n9_1 = 2;
              suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, insertRequest, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            this.n9_1 = 6;
            continue $sm;
          case 4:
            this.o9_1 = 5;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 6;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 5:
            throw this.q9_1;
          case 6:
            this.o9_1 = 5;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $deleteCartItemCOROUTINE$(_this__u8e3s4, cartItem, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.oz1_1 = _this__u8e3s4;
    this.pz1_1 = cartItem;
  }
  protoOf($deleteCartItemCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            if (!this.oz1_1.dyz_1.fz1().u1()) {
              throw Exception_init_$Create$('Please go online to delete items from your cart');
            }

            this.o9_1 = 6;
            var tmp0_safe_receiver = this.pz1_1.syw_1;
            if (tmp0_safe_receiver == null) {
              this.qz1_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = this.oz1_1.cyz_1.rz1(tmp0_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_0 = this;
            tmp_0.qz1_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.oz1_1.byz_1.sz1(this.pz1_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var user = this.oz1_1.ayz_1.qvz();
            if (!(user == null)) {
              var this_0 = this.oz1_1.zyy_1.xwu('cart_items');
              var this_1 = new PostgrestRequestBuilder(this_0.owx_1.ebw().nwu_1);
              var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
              filter.nwy('user_id', user.nwk_1);
              filter.nwy('id', this.pz1_1.fyw_1);
              var requestBuilder = this_1;
              var deleteRequest = new DeleteRequest(requestBuilder.uwx_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
              this.n9_1 = 4;
              suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, deleteRequest, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 7;
            this.n9_1 = 8;
            continue $sm;
          case 6:
            this.o9_1 = 7;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 8;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 7:
            throw this.q9_1;
          case 8:
            this.o9_1 = 7;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $clearCartCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bz2_1 = _this__u8e3s4;
  }
  protoOf($clearCartCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.bz2_1.byz_1.cz2(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o9_1 = 9;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.o9_1 = 9;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 3;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            this.o9_1 = 9;
            if (this.bz2_1.dyz_1.fz1().u1()) {
              this.o9_1 = 6;
              var user = this.bz2_1.ayz_1.qvz();
              if (!(user == null)) {
                var this_0 = this.bz2_1.zyy_1.xwu('cart_items');
                var this_1 = new PostgrestRequestBuilder(this_0.owx_1.ebw().nwu_1);
                var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
                filter.nwy('user_id', user.nwk_1);
                var requestBuilder = this_1;
                var deleteRequest = new DeleteRequest(requestBuilder.uwx_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
                this.n9_1 = 4;
                suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, deleteRequest, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 5;
                continue $sm;
              }
            } else {
              this.n9_1 = 8;
              continue $sm;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 9;
            this.n9_1 = 7;
            continue $sm;
          case 6:
            this.o9_1 = 9;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var _unused_var__etf5q3_0 = this.q9_1;
              this.n9_1 = 7;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 7:
            this.o9_1 = 9;
            this.n9_1 = 8;
            continue $sm;
          case 8:
            return Unit_instance;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 9) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $clearLocalCartCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lz2_1 = _this__u8e3s4;
  }
  protoOf($clearLocalCartCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.lz2_1.byz_1.cz2(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function CartRepositoryImpl(postgrest, auth, cartDao, storageRepository, networkObserver) {
    this.zyy_1 = postgrest;
    this.ayz_1 = auth;
    this.byz_1 = cartDao;
    this.cyz_1 = storageRepository;
    this.dyz_1 = networkObserver;
    this.eyz_1 = CoroutineScope_0(SupervisorJob().xj(Dispatchers_getInstance().i1h_1));
  }
  protoOf(CartRepositoryImpl).mz2 = function () {
    return this.byz_1.mz2();
  };
  protoOf(CartRepositoryImpl).nz2 = function (id, $completion) {
    return this.byz_1.nz2(id, $completion);
  };
  protoOf(CartRepositoryImpl).oz2 = function (cartItem, $completion) {
    launch(this.eyz_1, VOID, VOID, CartRepositoryImpl$addToCart$slambda_0(this, cartItem, null));
    return Unit_instance;
  };
  protoOf(CartRepositoryImpl).pz2 = function ($completion) {
    var tmp = Dispatchers_getInstance().i1h_1;
    return withContext(tmp, CartRepositoryImpl$syncCart$slambda_0(this, null), $completion);
  };
  protoOf(CartRepositoryImpl).dz0 = function (cartItem, $completion) {
    var tmp = new $updateCartItemCOROUTINE$(this, cartItem, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartRepositoryImpl).sz1 = function (cartItem, $completion) {
    var tmp = new $deleteCartItemCOROUTINE$(this, cartItem, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartRepositoryImpl).cz2 = function ($completion) {
    var tmp = new $clearCartCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartRepositoryImpl).syr = function ($completion) {
    var tmp = new $clearLocalCartCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  var client_fstech_hadaya_data_repository_CouponRepositoryImpl$stable;
  function $getCouponCOROUTINE$(_this__u8e3s4, code, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yz2_1 = _this__u8e3s4;
    this.zz2_1 = code;
  }
  protoOf($getCouponCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            var this_0 = this.yz2_1.bz3_1.xwu('coupons');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('code', this.zz2_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            tmp_0.az3_1 = firstOrNull(tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Coupon), arrayOf([]), false))]), false), value_0));
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_2 = this;
              tmp_2.az3_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.az3_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $markCouponAsUsedCOROUTINE$(_this__u8e3s4, couponId, userId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kz3_1 = _this__u8e3s4;
    this.lz3_1 = couponId;
    this.mz3_1 = userId;
  }
  protoOf($markCouponAsUsedCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.o9_1 = 3;
            var now = System_instance.fp().toString();
            var tmp0 = this.kz3_1.bz3_1.xwu('coupons');
            var builder = new JsonObjectBuilder();
            put_0(builder, 'is_used', true);
            put(builder, 'used_by', this.mz3_1);
            put(builder, 'used_at', now);
            var body = builder.wmh();
            var this_0 = new PostgrestRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_0.swx_1, this_0.vwx_1);
            filter.nwy('id', this.lz3_1);
            filter.nwy('is_used', false);
            this_0.ywx();
            var requestBuilder = this_0;
            var tmp0_returning = requestBuilder.uwx_1;
            var tmp1_count = requestBuilder.twx_1;
            var tmp2_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp3_schema = tmp0.qwx_1;
            var tmp4_headers = requestBuilder.wwx_1.g3d();
            var updateRequest = new UpdateRequest(tmp0_returning, tmp1_count, tmp2_urlParams, body, tmp3_schema, tmp4_headers);
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, updateRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_1 = suspendResult;
            var tmp0_0 = this_1.wx0_1.rvz();
            var value = this_1.ux0_1;
            var response = firstOrNull(tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Coupon), arrayOf([]), false))]), false), value));
            if (response == null) {
              throw new CouponAlreadyUsedException();
            }

            this.o9_1 = 4;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 4;
            return Unit_instance;
          case 3:
            this.o9_1 = 4;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var e = this.q9_1;
              throw e;
            } else {
              throw this.q9_1;
            }

          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 4) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $createWelcomeCouponCOROUTINE$(_this__u8e3s4, userId, discountValue, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vz3_1 = _this__u8e3s4;
    this.wz3_1 = userId;
    this.xz3_1 = discountValue;
  }
  protoOf($createWelcomeCouponCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            var this_0 = numberRangeToNumber(1000, 9999);
            var tmp_0 = random(this_0, Default_getInstance_0());
            var this_1 = takeLast(this.wz3_1, 4);
            var welcomeCoupon = new Coupon(VOID, 'WELCOME-' + tmp_0 + '-' + this_1.toUpperCase(), DiscountType_PERCENT_getInstance(), 10.0, false, VOID, VOID, this.wz3_1, System_instance.fp().toString());
            var tmp0 = this.vz3_1.bz3_1.xwu('coupons');
            var values = listOf(welcomeCoupon);
            var this_2 = tmp0.owx_1.rvz();
            var tmp0_0 = Default_getInstance();
            var string = this_2.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Coupon), arrayOf([]), false))]), false), values);
            var this_3 = tmp0_0.c75();
            var this_4 = serializer(this_3, createKType(getKClass(JsonElement), arrayOf([]), false));
            var body = get_jsonArray(tmp0_0.c72(isInterface(this_4, KSerializer) ? this_4 : THROW_CCE(), string));
            var requestBuilder = new InsertRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(body, 10));
            var _iterator__ex2g4s = body.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              destination.j1(get_jsonObject(item).x2());
            }

            var columns = distinct(flatten(destination));
            if (!columns.r()) {
              var tmp0_1 = requestBuilder.vwx_1;
              var value = listOf(joinToString(columns, ','));
              tmp0_1.z2('columns', value);
            }

            var tmp0_returning = requestBuilder.uwx_1;
            var tmp1_count = requestBuilder.twx_1;
            var tmp2_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp3_schema = tmp0.qwx_1;
            var tmp4_headers = requestBuilder.wwx_1.g3d();
            var tmp5_defaultToNull = requestBuilder.vwy_1;
            var insertRequest = new InsertRequest(VOID, tmp0_returning, tmp1_count, VOID, tmp5_defaultToNull, body, tmp2_urlParams, tmp3_schema, tmp4_headers);
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, insertRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.yz3_1 = suspendResult;
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_2 = this;
              tmp_2.yz3_1 = Unit_instance;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $getUserCouponsCOROUTINE$(_this__u8e3s4, userId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hz4_1 = _this__u8e3s4;
    this.iz4_1 = userId;
  }
  protoOf($getUserCouponsCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            var this_0 = this.hz4_1.bz3_1.xwu('coupons');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('created_by', this.iz4_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            tmp_0.jz4_1 = tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Coupon), arrayOf([]), false))]), false), value_0);
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var e = this.q9_1;
              var tmp_2 = this;
              tmp_2.jz4_1 = emptyList();
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.jz4_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 3) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function CouponRepositoryImpl(postgrest) {
    this.bz3_1 = postgrest;
  }
  protoOf(CouponRepositoryImpl).kz4 = function (code, $completion) {
    var tmp = new $getCouponCOROUTINE$(this, code, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CouponRepositoryImpl).lz4 = function (couponId, userId, $completion) {
    var tmp = new $markCouponAsUsedCOROUTINE$(this, couponId, userId, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CouponRepositoryImpl).mz4 = function (userId, discountValue, $completion) {
    var tmp = new $createWelcomeCouponCOROUTINE$(this, userId, discountValue, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CouponRepositoryImpl).nz4 = function (userId, $completion) {
    var tmp = new $getUserCouponsCOROUTINE$(this, userId, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  var client_fstech_hadaya_data_repository_FavoriteRepositoryImpl$stable;
  function FavoriteRepositoryImpl$isFavorite$slambda(this$0, $productId, resultContinuation) {
    this.wz4_1 = this$0;
    this.xz4_1 = $productId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FavoriteRepositoryImpl$isFavorite$slambda).nyp = function ($this$transformLatest, it, $completion) {
    var tmp = this.oyp($this$transformLatest, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FavoriteRepositoryImpl$isFavorite$slambda).ha = function (p1, p2, $completion) {
    return this.nyp((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), p2, $completion);
  };
  protoOf(FavoriteRepositoryImpl$isFavorite$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp0_safe_receiver = this.zz4_1;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.uym_1;
            var tmp_0;
            if (tmp1_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp_0 = this.wz4_1.az5_1.dz5(this.xz4_1, tmp1_safe_receiver);
            }

            var tmp2_elvis_lhs = tmp_0;
            suspendResult = emitAll(this.yz4_1, tmp2_elvis_lhs == null ? emptyFlow() : tmp2_elvis_lhs, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FavoriteRepositoryImpl$isFavorite$slambda).oyp = function ($this$transformLatest, it, completion) {
    var i = new FavoriteRepositoryImpl$isFavorite$slambda(this.wz4_1, this.xz4_1, completion);
    i.yz4_1 = $this$transformLatest;
    i.zz4_1 = it;
    return i;
  };
  function FavoriteRepositoryImpl$isFavorite$slambda_0(this$0, $productId, resultContinuation) {
    var i = new FavoriteRepositoryImpl$isFavorite$slambda(this$0, $productId, resultContinuation);
    return constructCallableReference(function ($this$transformLatest, it, $completion) {
      return i.nyp($this$transformLatest, it, $completion);
    }, 2);
  }
  function FavoriteRepositoryImpl$getFavoriteProducts$slambda(this$0, resultContinuation) {
    this.mz5_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FavoriteRepositoryImpl$getFavoriteProducts$slambda).nyp = function ($this$transformLatest, it, $completion) {
    var tmp = this.oyp($this$transformLatest, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FavoriteRepositoryImpl$getFavoriteProducts$slambda).ha = function (p1, p2, $completion) {
    return this.nyp((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), p2, $completion);
  };
  protoOf(FavoriteRepositoryImpl$getFavoriteProducts$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp0_safe_receiver = this.oz5_1;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.uym_1;
            var tmp_0;
            if (tmp1_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp_0 = this.mz5_1.az5_1.pz5(tmp1_safe_receiver);
            }

            var tmp2_elvis_lhs = tmp_0;
            suspendResult = emitAll(this.nz5_1, tmp2_elvis_lhs == null ? emptyFlow() : tmp2_elvis_lhs, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FavoriteRepositoryImpl$getFavoriteProducts$slambda).oyp = function ($this$transformLatest, it, completion) {
    var i = new FavoriteRepositoryImpl$getFavoriteProducts$slambda(this.mz5_1, completion);
    i.nz5_1 = $this$transformLatest;
    i.oz5_1 = it;
    return i;
  };
  function FavoriteRepositoryImpl$getFavoriteProducts$slambda_0(this$0, resultContinuation) {
    var i = new FavoriteRepositoryImpl$getFavoriteProducts$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$transformLatest, it, $completion) {
      return i.nyp($this$transformLatest, it, $completion);
    }, 2);
  }
  function $toggleFavoriteCOROUTINE$(_this__u8e3s4, productId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yz5_1 = _this__u8e3s4;
    this.zz5_1 = productId;
  }
  protoOf($toggleFavoriteCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 11;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.yz5_1.bz5_1.xyv();
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.uym_1;
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            tmp_0.cz6_1 = tmp_1;
            this.n9_1 = 1;
            suspendResult = this.yz5_1.az5_1.fz6(this.zz5_1, this.cz6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              this.n9_1 = 6;
              suspendResult = this.yz5_1.az5_1.hz6(this.zz5_1, this.cz6_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.ez6_1 = new FavoriteProduct(this.zz5_1, this.cz6_1);
              this.n9_1 = 2;
              suspendResult = this.yz5_1.az5_1.gz6(this.ez6_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.o9_1 = 4;
            var tmp0 = this.yz5_1.cz5_1.xwu('favorite_products');
            var value = this.ez6_1;
            var values = listOf(value);
            var this_0 = tmp0.owx_1.rvz();
            var tmp0_0 = Default_getInstance();
            var string = this_0.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(FavoriteProduct), arrayOf([]), false))]), false), values);
            var this_1 = tmp0_0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(JsonElement), arrayOf([]), false));
            var body = get_jsonArray(tmp0_0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string));
            var requestBuilder = new UpsertRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(body, 10));
            var _iterator__ex2g4s = body.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              destination.j1(get_jsonObject(item).x2());
            }

            var columns = distinct(flatten(destination));
            if (!columns.r()) {
              var tmp0_1 = requestBuilder.vwx_1;
              var value_0 = listOf(joinToString(columns, ','));
              tmp0_1.z2('columns', value_0);
            }

            var tmp0_safe_receiver_0 = requestBuilder.iwz_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              var tmp0_2 = requestBuilder.vwx_1;
              var tmp2 = 'on_conflict';
              var value_1 = listOf(tmp0_safe_receiver_0);
              tmp0_2.z2(tmp2, value_1);
            }

            var tmp1_returning = requestBuilder.uwx_1;
            var tmp2_count = requestBuilder.twx_1;
            var tmp3_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp4_defaultToNull = requestBuilder.vwy_1;
            var tmp5_ignoreDuplicates = requestBuilder.jwz_1;
            var tmp6_schema = tmp0.qwx_1;
            var tmp7_headers = requestBuilder.wwx_1.g3d();
            var insertRequest = new InsertRequest(true, tmp1_returning, tmp2_count, tmp5_ignoreDuplicates, tmp4_defaultToNull, body, tmp3_urlParams, tmp6_schema, tmp7_headers);
            this.n9_1 = 3;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, insertRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.dz6_1 = suspendResult;
            this.o9_1 = 11;
            this.n9_1 = 5;
            continue $sm;
          case 4:
            this.o9_1 = 11;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_3 = this;
              tmp_3.dz6_1 = Unit_instance;
              this.n9_1 = 5;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 5:
            this.o9_1 = 11;
            this.az6_1 = this.dz6_1;
            this.n9_1 = 10;
            continue $sm;
          case 6:
            this.o9_1 = 8;
            var this_3 = this.yz5_1.cz5_1.xwu('favorite_products');
            var this_4 = new PostgrestRequestBuilder(this_3.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_4.swx_1, this_4.vwx_1);
            filter.nwy('product_id', this.zz5_1);
            filter.nwy('user_id', this.cz6_1);
            var requestBuilder_0 = this_4;
            var deleteRequest = new DeleteRequest(requestBuilder_0.uwx_1, requestBuilder_0.twx_1, mapToFirstValue(requestBuilder_0.vwx_1), this_3.qwx_1, requestBuilder_0.wwx_1.g3d());
            this.n9_1 = 7;
            suspendResult = RestRequestExecutor_instance.hwx(this_3.owx_1, this_3.pwx_1, deleteRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.bz6_1 = suspendResult;
            this.o9_1 = 11;
            this.n9_1 = 9;
            continue $sm;
          case 8:
            this.o9_1 = 11;
            var tmp_4 = this.q9_1;
            if (tmp_4 instanceof Error) {
              var _unused_var__etf5q3_0 = this.q9_1;
              var tmp_5 = this;
              tmp_5.bz6_1 = Unit_instance;
              this.n9_1 = 9;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 9:
            this.o9_1 = 11;
            this.az6_1 = this.bz6_1;
            this.n9_1 = 10;
            continue $sm;
          case 10:
            return Unit_instance;
          case 11:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 11) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $syncFavoritesCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qz6_1 = _this__u8e3s4;
  }
  protoOf($syncFavoritesCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.qz6_1.bz5_1.xyv();
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.uym_1;
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            tmp_0.rz6_1 = tmp_1;
            this.o9_1 = 3;
            var this_0 = this.qz6_1.cz5_1.xwu('favorite_products');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('user_id', this.rz6_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            var remoteFavorites = tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(FavoriteProduct), arrayOf([]), false))]), false), value_0);
            this.n9_1 = 2;
            suspendResult = this.qz6_1.az5_1.sz6(this.rz6_1, remoteFavorites, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 4;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 4;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 5;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            throw this.q9_1;
          case 5:
            this.o9_1 = 4;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function FavoriteRepositoryImpl(favoriteDao, authRepository, postgrest) {
    this.az5_1 = favoriteDao;
    this.bz5_1 = authRepository;
    this.cz5_1 = postgrest;
  }
  protoOf(FavoriteRepositoryImpl).tz6 = function (productId) {
    // Inline function 'kotlinx.coroutines.flow.flatMapLatest' call
    var this_0 = this.bz5_1.oyv();
    return transformLatest(this_0, FavoriteRepositoryImpl$isFavorite$slambda_0(this, productId, null));
  };
  protoOf(FavoriteRepositoryImpl).uz6 = function () {
    // Inline function 'kotlinx.coroutines.flow.flatMapLatest' call
    var this_0 = this.bz5_1.oyv();
    return transformLatest(this_0, FavoriteRepositoryImpl$getFavoriteProducts$slambda_0(this, null));
  };
  protoOf(FavoriteRepositoryImpl).vz6 = function (productId, $completion) {
    var tmp = new $toggleFavoriteCOROUTINE$(this, productId, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FavoriteRepositoryImpl).wz6 = function ($completion) {
    var tmp = new $syncFavoritesCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  var client_fstech_hadaya_data_repository_FriendRepositoryImpl$stable;
  function FriendRepositoryImpl$uploadAvatar$lambda($this$upload) {
    $this$upload.xx5_1 = true;
    return Unit_instance;
  }
  function $getFriendsCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fz7_1 = _this__u8e3s4;
  }
  protoOf($getFriendsCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0_safe_receiver = this.fz7_1.hz7_1.qvz();
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.nwk_1;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              return emptyList();
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }

            var currentUserId = tmp_0;
            var this_0 = this.fz7_1.gz7_1.xwu('friends');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('userId', currentUserId);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            return tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Friend), arrayOf([]), false))]), false), value_0);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $addFriendCOROUTINE$(_this__u8e3s4, friend, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rz7_1 = _this__u8e3s4;
    this.sz7_1 = friend;
  }
  protoOf($addFriendCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0_safe_receiver = this.rz7_1.hz7_1.qvz();
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.nwk_1;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              throw IllegalStateException_init_$Create$('User not logged in');
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }

            var currentUserId = tmp_0;
            var friendWithUserId = this.sz7_1.gz8(VOID, currentUserId);
            var tmp0 = this.rz7_1.gz7_1.xwu('friends');
            var values = listOf(friendWithUserId);
            var this_0 = tmp0.owx_1.rvz();
            var tmp0_0 = Default_getInstance();
            var string = this_0.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Friend), arrayOf([]), false))]), false), values);
            var this_1 = tmp0_0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(JsonElement), arrayOf([]), false));
            var body = get_jsonArray(tmp0_0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string));
            var this_3 = new InsertRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            this_3.ywx();
            var requestBuilder = this_3;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(body, 10));
            var _iterator__ex2g4s = body.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              destination.j1(get_jsonObject(item).x2());
            }

            var columns = distinct(flatten(destination));
            if (!columns.r()) {
              var tmp0_1 = requestBuilder.vwx_1;
              var value = listOf(joinToString(columns, ','));
              tmp0_1.z2('columns', value);
            }

            var tmp0_returning = requestBuilder.uwx_1;
            var tmp1_count = requestBuilder.twx_1;
            var tmp2_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp3_schema = tmp0.qwx_1;
            var tmp4_headers = requestBuilder.wwx_1.g3d();
            var tmp5_defaultToNull = requestBuilder.vwy_1;
            var insertRequest = new InsertRequest(VOID, tmp0_returning, tmp1_count, VOID, tmp5_defaultToNull, body, tmp2_urlParams, tmp3_schema, tmp4_headers);
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, insertRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_4 = suspendResult;
            var tmp0_2 = this_4.wx0_1.rvz();
            var value_0 = this_4.ux0_1;
            return first(tmp0_2.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Friend), arrayOf([]), false))]), false), value_0));
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $updateFriendCOROUTINE$(_this__u8e3s4, friend, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pz8_1 = _this__u8e3s4;
    this.qz8_1 = friend;
  }
  protoOf($updateFriendCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0_elvis_lhs = this.qz8_1.tz7_1;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              throw IllegalArgumentException_init_$Create$('Friend ID cannot be null for update');
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var friendId = tmp_0;
            var tmp0 = this.pz8_1.gz7_1.xwu('friends');
            var value = this.qz8_1;
            var this_0 = tmp0.owx_1.rvz();
            var tmp0_0 = Default_getInstance();
            var string = this_0.avo(createKType(getKClass(Friend), arrayOf([]), false), value);
            var this_1 = tmp0_0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(JsonElement), arrayOf([]), false));
            var body = tmp0_0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string);
            var this_3 = new PostgrestRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_3.swx_1, this_3.vwx_1);
            filter.nwy('id', friendId);
            var requestBuilder = this_3;
            var tmp0_returning = requestBuilder.uwx_1;
            var tmp1_count = requestBuilder.twx_1;
            var tmp2_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp3_schema = tmp0.qwx_1;
            var tmp4_headers = requestBuilder.wwx_1.g3d();
            var updateRequest = new UpdateRequest(tmp0_returning, tmp1_count, tmp2_urlParams, body, tmp3_schema, tmp4_headers);
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, updateRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $deleteFriendCOROUTINE$(_this__u8e3s4, friendId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zz8_1 = _this__u8e3s4;
    this.az9_1 = friendId;
  }
  protoOf($deleteFriendCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var this_0 = this.zz8_1.gz7_1.xwu('friends');
            var this_1 = new PostgrestRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('id', this.az9_1);
            var requestBuilder = this_1;
            var deleteRequest = new DeleteRequest(requestBuilder.uwx_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, deleteRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $uploadAvatarCOROUTINE$(_this__u8e3s4, friendId, imageBytes, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jz9_1 = _this__u8e3s4;
    this.kz9_1 = friendId;
    this.lz9_1 = imageBytes;
  }
  protoOf($uploadAvatarCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            this.oz9_1 = this.jz9_1.iz7_1.xwu('avatars');
            var fileName = 'avatar_' + System_instance.fp().wp().toString() + '.jpg';
            var tmp_0 = this;
            var tmp0_safe_receiver = this.jz9_1.hz7_1.qvz();
            tmp_0.nz9_1 = '' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.nwk_1) + '/friends/' + fileName;
            this.n9_1 = 1;
            var tmp_1 = toNativeByteArray(this.lz9_1);
            suspendResult = this.oz9_1.vx4(this.nz9_1, tmp_1, FriendRepositoryImpl$uploadAvatar$lambda, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.mz9_1 = this.oz9_1.dx5(this.nz9_1);
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_3 = this;
              tmp_3.mz9_1 = '';
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.mz9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $deleteAvatarCOROUTINE$_0(_this__u8e3s4, url, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xz9_1 = _this__u8e3s4;
    this.yz9_1 = url;
  }
  protoOf($deleteAvatarCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            this.o9_1 = 6;
            this.zz9_1 = lastOrNull(split(this.yz9_1, ['/storage/v1/object/public/avatars/']));
            if (!(this.zz9_1 == null)) {
              this.aza_1 = this.xz9_1.iz7_1.xwu('avatars');
              var deletedPath = 'deleted/' + this.zz9_1;
              this.o9_1 = 2;
              this.n9_1 = 1;
              suspendResult = this.aza_1.ax5(this.zz9_1, deletedPath, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 1:
            this.o9_1 = 6;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var e = this.q9_1;
              this.n9_1 = 3;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            this.o9_1 = 6;
            this.n9_1 = 4;
            suspendResult = this.aza_1.yx4([this.zz9_1], this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 7;
            this.n9_1 = 8;
            continue $sm;
          case 6:
            this.o9_1 = 7;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var e_0 = this.q9_1;
              this.n9_1 = 8;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 7:
            throw this.q9_1;
          case 8:
            this.o9_1 = 7;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 7) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  function FriendRepositoryImpl(postgrest, auth, storage) {
    this.gz7_1 = postgrest;
    this.hz7_1 = auth;
    this.iz7_1 = storage;
  }
  protoOf(FriendRepositoryImpl).bza = function ($completion) {
    var tmp = new $getFriendsCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FriendRepositoryImpl).cza = function (friend, $completion) {
    var tmp = new $addFriendCOROUTINE$(this, friend, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FriendRepositoryImpl).dza = function (friend, $completion) {
    var tmp = new $updateFriendCOROUTINE$(this, friend, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FriendRepositoryImpl).eza = function (friendId, $completion) {
    var tmp = new $deleteFriendCOROUTINE$(this, friendId, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FriendRepositoryImpl).fza = function (friendId, imageBytes, $completion) {
    var tmp = new $uploadAvatarCOROUTINE$(this, friendId, imageBytes, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FriendRepositoryImpl).gza = function (url, $completion) {
    var tmp = new $deleteAvatarCOROUTINE$_0(this, url, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  var client_fstech_hadaya_data_repository_NotificationRepositoryImpl$stable;
  function NotificationRepositoryImpl$sendNotification$lambda($headers, $region, $this, $body, $region$1) {
    return function ($this$request) {
      $this$request.ztr_1 = Companion_getInstance_1().ft2_1;
      $this$request.ats_1.gsq($headers);
      header($this$request, 'x-region', $region.lxa_1);
      var tmp0 = $this.jxb_1;
      // Inline function 'io.github.jan.supabase.encode' call
      var value = $body;
      // Inline function 'io.ktor.client.request.setBody' call
      var body = tmp0.avo(createKType(getKClass(JsonObject), arrayOf([]), false), value);
      if (body == null) {
        $this$request.bts_1 = NullBody_instance;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp = PrimitiveClasses_getInstance().rc();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_0;
        try {
          tmp_0 = createKType(PrimitiveClasses_getInstance().rc(), arrayOf([]), false);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp_0 = tmp_1;
        }
        var tmp$ret$5 = tmp_0;
        var tmp$ret$4 = new TypeInfo(tmp, tmp$ret$5);
        $this$request.qtx(tmp$ret$4);
      } else {
        if (body instanceof OutgoingContent) {
          $this$request.bts_1 = body;
          $this$request.qtx(null);
        } else {
          $this$request.bts_1 = body;
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp_2 = PrimitiveClasses_getInstance().rc();
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_3;
          try {
            tmp_3 = createKType(PrimitiveClasses_getInstance().rc(), arrayOf([]), false);
          } catch ($p_0) {
            var tmp_4;
            if ($p_0 instanceof Error) {
              var _unused_var__etf5q3_0 = $p_0;
              tmp_4 = null;
            } else {
              throw $p_0;
            }
            tmp_3 = tmp_4;
          }
          var tmp$ret$7 = tmp_3;
          var tmp$ret$6 = new TypeInfo(tmp_2, tmp$ret$7);
          $this$request.qtx(tmp$ret$6);
        }
      }
      header($this$request, 'x-region', $region$1.lxa_1);
      return Unit_instance;
    };
  }
  function $notifyAdminCOROUTINE$(_this__u8e3s4, title, body, orderId, status, link, imageUrl, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pza_1 = _this__u8e3s4;
    this.qza_1 = title;
    this.rza_1 = body;
    this.sza_1 = orderId;
    this.tza_1 = status;
    this.uza_1 = link;
    this.vza_1 = imageUrl;
  }
  protoOf($notifyAdminCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            var tmp0_safe_receiver = this.pza_1.yza_1.qvz();
            var userId = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.nwk_1;
            var now = System_instance.fp().wp().toString();
            var tmp1_elvis_lhs = this.tza_1;
            var tmp2_status = tmp1_elvis_lhs == null ? 'ADMIN_NOTICE' : tmp1_elvis_lhs;
            var notification = new Notification(VOID, this.qza_1, this.rza_1, now, userId, userId, 'admin', this.sza_1, tmp2_status, this.uza_1, this.vza_1);
            this.n9_1 = 1;
            suspendResult = this.pza_1.zza(notification, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var e = this.q9_1;
              println('notifyAdmin preparation error: ' + e.message);
              printStackTrace(e);
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 3) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $sendNotificationCOROUTINE$(_this__u8e3s4, notification, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.izb_1 = _this__u8e3s4;
    this.jzb_1 = notification;
  }
  protoOf($sendNotificationCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.o9_1 = 2;
            var tmp0 = this.izb_1.wza_1.xwu('notifications');
            var value = this.jzb_1;
            var values = listOf(value);
            var this_0 = tmp0.owx_1.rvz();
            var tmp0_0 = Default_getInstance();
            var string = this_0.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Notification), arrayOf([]), false))]), false), values);
            var this_1 = tmp0_0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(JsonElement), arrayOf([]), false));
            var body = get_jsonArray(tmp0_0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string));
            var requestBuilder = new InsertRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(body, 10));
            var _iterator__ex2g4s = body.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              destination.j1(get_jsonObject(item).x2());
            }

            var columns = distinct(flatten(destination));
            if (!columns.r()) {
              var tmp0_1 = requestBuilder.vwx_1;
              var value_0 = listOf(joinToString(columns, ','));
              tmp0_1.z2('columns', value_0);
            }

            var tmp0_returning = requestBuilder.uwx_1;
            var tmp1_count = requestBuilder.twx_1;
            var tmp2_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp3_schema = tmp0.qwx_1;
            var tmp4_headers = requestBuilder.wwx_1.g3d();
            var tmp5_defaultToNull = requestBuilder.vwy_1;
            var insertRequest = new InsertRequest(VOID, tmp0_returning, tmp1_count, VOID, tmp5_defaultToNull, body, tmp2_urlParams, tmp3_schema, tmp4_headers);
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, insertRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.lzb_1 = suspendResult;
            this.o9_1 = 6;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var e = this.q9_1;
              var tmp_1 = this;
              println('Database notification error: ' + e.message);
              tmp_1.lzb_1 = Unit_instance;
              this.n9_1 = 3;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            this.o9_1 = 6;
            this.o9_1 = 5;
            var tmp0_2 = this.izb_1.xza_1;
            var tmp2 = 'notify-admins';
            var builder = new JsonObjectBuilder();
            put(builder, 'title', this.jzb_1.nzb_1);
            put(builder, 'body', this.jzb_1.ozb_1);
            var builder_0 = new JsonObjectBuilder();
            var tmp0_safe_receiver = this.jzb_1.rzb_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              put(builder_0, 'sender_id', tmp0_safe_receiver);
            }

            var tmp1_safe_receiver = this.jzb_1.szb_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              put(builder_0, 'receiver_id', tmp1_safe_receiver);
            }

            var tmp2_safe_receiver = this.jzb_1.uzb_1;
            if (tmp2_safe_receiver == null)
              null;
            else {
              put(builder_0, 'status', tmp2_safe_receiver);
            }

            var tmp3_safe_receiver = this.jzb_1.tzb_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              put(builder_0, 'orderId', tmp3_safe_receiver.toString());
            }

            var tmp4_safe_receiver = this.jzb_1.vzb_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              put(builder_0, 'link', tmp4_safe_receiver);
            }

            var tmp5_safe_receiver = this.jzb_1.wzb_1;
            if (tmp5_safe_receiver == null)
              null;
            else {
              put(builder_0, 'imageUrl', tmp5_safe_receiver);
            }

            var tmp6_safe_receiver = this.jzb_1.pzb_1;
            if (tmp6_safe_receiver == null)
              null;
            else {
              put(builder_0, 'created_at', tmp6_safe_receiver);
            }

            builder.gmj('data', builder_0.wmh());
            var body_0 = builder.wmh();
            var region = tmp0_2.hxb_1.pxa_1;
            var headers = Companion_getInstance_3().yt1_1;
            var region_0 = tmp0_2.hxb_1.pxa_1;
            var this_3 = tmp0_2.kxb_1;
            this.n9_1 = 4;
            suspendResult = this_3.wvm(tmp2, NotificationRepositoryImpl$sendNotification$lambda(headers, region, tmp0_2, body_0, region_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.kzb_1 = suspendResult;
            this.o9_1 = 6;
            this.n9_1 = 7;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Error) {
              var e_0 = this.q9_1;
              var tmp_3 = this;
              var tmp0_elvis_lhs = e_0.message;
              var message = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
              if (contains(message, 'fetch', true) || contains(message, 'NetworkError', true)) {
                println('Push notification trigger failed (likely CORS or network issue): ' + message);
                println('Ensure the Edge Function handles OPTIONS requests and returns Access-Control-Allow-Origin headers.');
                println("Current environment might need 'http://localhost:XXXX' added to Supabase CORS settings.");
              } else {
                println('Edge Function invocation error: ' + message);
                printStackTrace(e_0);
              }
              tmp_3.kzb_1 = Unit_instance;
              this.n9_1 = 7;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 6:
            throw this.q9_1;
          case 7:
            this.o9_1 = 6;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 6) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  function NotificationRepositoryImpl(postgrest, functions, auth) {
    this.wza_1 = postgrest;
    this.xza_1 = functions;
    this.yza_1 = auth;
  }
  protoOf(NotificationRepositoryImpl).xzb = function (title, body, orderId, status, link, imageUrl, $completion) {
    var tmp = new $notifyAdminCOROUTINE$(this, title, body, orderId, status, link, imageUrl, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(NotificationRepositoryImpl).zza = function (notification, $completion) {
    var tmp = new $sendNotificationCOROUTINE$(this, notification, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  var client_fstech_hadaya_data_repository_OrderRepositoryImpl$stable;
  function $placeOrderCOROUTINE$(_this__u8e3s4, order, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hzc_1 = _this__u8e3s4;
    this.izc_1 = order;
  }
  protoOf($placeOrderCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.o9_1 = 3;
            var now = System_instance.fp().wp();
            var tmp0_elvis_lhs = this.izc_1.fzd_1;
            var tmp_0 = tmp0_elvis_lhs == null ? now : tmp0_elvis_lhs;
            var tmp1_elvis_lhs = this.izc_1.izd_1;
            var orderToPlace = this.izc_1.jzd(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, now, VOID, tmp1_elvis_lhs == null ? getPlatform().m() : tmp1_elvis_lhs);
            var tmp0 = this.hzc_1.kzd_1.xwu('orders');
            var values = listOf(orderToPlace);
            var this_0 = tmp0.owx_1.rvz();
            var tmp0_0 = Default_getInstance();
            var string = this_0.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Order), arrayOf([]), false))]), false), values);
            var this_1 = tmp0_0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(JsonElement), arrayOf([]), false));
            var body = get_jsonArray(tmp0_0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string));
            var this_3 = new InsertRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            this_3.ywx();
            var requestBuilder = this_3;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(body, 10));
            var _iterator__ex2g4s = body.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              destination.j1(get_jsonObject(item).x2());
            }

            var columns = distinct(flatten(destination));
            if (!columns.r()) {
              var tmp0_1 = requestBuilder.vwx_1;
              var value = listOf(joinToString(columns, ','));
              tmp0_1.z2('columns', value);
            }

            var tmp0_returning = requestBuilder.uwx_1;
            var tmp1_count = requestBuilder.twx_1;
            var tmp2_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp3_schema = tmp0.qwx_1;
            var tmp4_headers = requestBuilder.wwx_1.g3d();
            var tmp5_defaultToNull = requestBuilder.vwy_1;
            var insertRequest = new InsertRequest(VOID, tmp0_returning, tmp1_count, VOID, tmp5_defaultToNull, body, tmp2_urlParams, tmp3_schema, tmp4_headers);
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, insertRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_1 = this;
            var this_4 = suspendResult;
            var tmp0_2 = this_4.wx0_1.rvz();
            var value_0 = this_4.ux0_1;
            tmp_1.kzc_1 = first(tmp0_2.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Order), arrayOf([]), false))]), false), value_0));
            this.n9_1 = 2;
            suspendResult = this.hzc_1.mzd(this.kzc_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.jzc_1 = this.kzc_1;
            this.o9_1 = 4;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 4;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Error) {
              var e = this.q9_1;
              var tmp_3 = this;
              throw e;
            } else {
              throw this.q9_1;
            }

          case 4:
            throw this.q9_1;
          case 5:
            this.o9_1 = 4;
            return this.jzc_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 4) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $getOrderHistoryCOROUTINE$(_this__u8e3s4, userId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vzd_1 = _this__u8e3s4;
    this.wzd_1 = userId;
  }
  protoOf($getOrderHistoryCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            var this_0 = this.vzd_1.kzd_1.xwu('orders');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('user_id', this.wzd_1);
            filter.owy('status', 'archived');
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            tmp_0.xzd_1 = tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Order), arrayOf([]), false))]), false), value_0);
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var e = this.q9_1;
              var tmp_2 = this;
              throw e;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.xzd_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 3) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $getOrderByIdCOROUTINE$(_this__u8e3s4, orderId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gze_1 = _this__u8e3s4;
    this.hze_1 = orderId;
  }
  protoOf($getOrderByIdCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            var this_0 = this.gze_1.kzd_1.xwu('orders');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('id', this.hze_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            tmp_0.ize_1 = firstOrNull(tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Order), arrayOf([]), false))]), false), value_0));
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_2 = this;
              tmp_2.ize_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.ize_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $notifyAdminsCOROUTINE$(_this__u8e3s4, order, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rze_1 = _this__u8e3s4;
    this.sze_1 = order;
  }
  protoOf($notifyAdminsCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.o9_1 = 4;
            this.n9_1 = 1;
            suspendResult = getString(get_notification_new_order_title(string_instance), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.tze_1 = suspendResult;
            this.n9_1 = 2;
            suspendResult = getString_0(get_notification_new_order_body(string_instance), [this.sze_1.qzc_1, this.sze_1.yzc_1.toString(), toString_0(this.sze_1.lzc_1)], this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var body = suspendResult;
            this.n9_1 = 3;
            suspendResult = this.rze_1.lzd_1.yzb(this.tze_1, body, this.sze_1.lzc_1, 'RECEIVED', VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.o9_1 = 5;
            this.n9_1 = 6;
            continue $sm;
          case 4:
            this.o9_1 = 5;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var e = this.q9_1;
              println('Error in notifyAdmins: ' + e.message);
              printStackTrace(e);
              this.n9_1 = 6;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 5:
            throw this.q9_1;
          case 6:
            this.o9_1 = 5;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 5) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $requestReturnCOROUTINE$(_this__u8e3s4, orderId, reason, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.czf_1 = _this__u8e3s4;
    this.dzf_1 = orderId;
    this.ezf_1 = reason;
  }
  protoOf($requestReturnCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            this.o9_1 = 6;
            var tmp0 = this.czf_1.kzd_1.xwu('orders');
            var builder = new JsonObjectBuilder();
            put(builder, 'status', 'RETURN_REQUESTED');
            put(builder, 'user_comment', this.ezf_1);
            put_1(builder, 'updated_at', System_instance.fp().wp());
            var body = builder.wmh();
            var this_0 = new PostgrestRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_0.swx_1, this_0.vwx_1);
            filter.nwy('id', this.dzf_1);
            this_0.ywx();
            var requestBuilder = this_0;
            var tmp0_returning = requestBuilder.uwx_1;
            var tmp1_count = requestBuilder.twx_1;
            var tmp2_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp3_schema = tmp0.qwx_1;
            var tmp4_headers = requestBuilder.wwx_1.g3d();
            var updateRequest = new UpdateRequest(tmp0_returning, tmp1_count, tmp2_urlParams, body, tmp3_schema, tmp4_headers);
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, updateRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            var this_1 = suspendResult;
            var tmp0_0 = this_1.wx0_1.rvz();
            var value = this_1.ux0_1;
            tmp_0.fzf_1 = first(tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Order), arrayOf([]), false))]), false), value));
            this.n9_1 = 2;
            suspendResult = getString(get_notification_return_requested_title(string_instance), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.gzf_1 = suspendResult;
            this.n9_1 = 3;
            suspendResult = getString_0(get_notification_return_requested_body(string_instance), [toString_0(this.fzf_1.lzc_1), this.fzf_1.qzc_1, this.ezf_1], this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var body_0 = suspendResult;
            this.n9_1 = 4;
            suspendResult = this.czf_1.lzd_1.yzb(this.gzf_1, body_0, this.fzf_1.lzc_1, 'RETURNED', VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.o9_1 = 7;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 7;
            return Unit_instance;
          case 6:
            this.o9_1 = 7;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var e = this.q9_1;
              throw e;
            } else {
              throw this.q9_1;
            }

          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 7) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function OrderRepositoryImpl(postgrest, notificationRepository) {
    this.kzd_1 = postgrest;
    this.lzd_1 = notificationRepository;
  }
  protoOf(OrderRepositoryImpl).hzf = function (order, $completion) {
    var tmp = new $placeOrderCOROUTINE$(this, order, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderRepositoryImpl).izf = function (userId, $completion) {
    var tmp = new $getOrderHistoryCOROUTINE$(this, userId, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderRepositoryImpl).jzf = function (orderId, $completion) {
    var tmp = new $getOrderByIdCOROUTINE$(this, orderId, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderRepositoryImpl).mzd = function (order, $completion) {
    var tmp = new $notifyAdminsCOROUTINE$(this, order, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderRepositoryImpl).kzf = function (orderId, reason, $completion) {
    var tmp = new $requestReturnCOROUTINE$(this, orderId, reason, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  var client_fstech_hadaya_data_repository_ProductViewRequest_$serializer$stable;
  var client_fstech_hadaya_data_repository_ProductViewRequest$stable;
  var client_fstech_hadaya_data_repository_ProductRepositoryImpl$stable;
  function ProductRepositoryImpl$getProducts$slambda$slambda(this$0, resultContinuation) {
    this.tzf_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductRepositoryImpl$getProducts$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductRepositoryImpl$getProducts$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductRepositoryImpl$getProducts$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.tzf_1.bzg(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProductRepositoryImpl$getProducts$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new ProductRepositoryImpl$getProducts$slambda$slambda(this.tzf_1, completion);
    i.uzf_1 = $this$launch;
    return i;
  };
  function ProductRepositoryImpl$getProducts$slambda$slambda_0(this$0, resultContinuation) {
    var i = new ProductRepositoryImpl$getProducts$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProductRepositoryImpl$getBanners$slambda$slambda(this$0, resultContinuation) {
    this.kzg_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductRepositoryImpl$getBanners$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductRepositoryImpl$getBanners$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductRepositoryImpl$getBanners$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.kzg_1.mzg(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProductRepositoryImpl$getBanners$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new ProductRepositoryImpl$getBanners$slambda$slambda(this.kzg_1, completion);
    i.lzg_1 = $this$launch;
    return i;
  };
  function ProductRepositoryImpl$getBanners$slambda$slambda_0(this$0, resultContinuation) {
    var i = new ProductRepositoryImpl$getBanners$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProductRepositoryImpl$getProducts$slambda(this$0, resultContinuation) {
    this.vzg_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductRepositoryImpl$getProducts$slambda).xzg = function ($this$onStart, $completion) {
    var tmp = this.yzg($this$onStart, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductRepositoryImpl$getProducts$slambda).ja = function (p1, $completion) {
    return this.xzg((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductRepositoryImpl$getProducts$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          launch(this.vzg_1.yzf_1, VOID, VOID, ProductRepositoryImpl$getProducts$slambda$slambda_0(this.vzg_1, null));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ProductRepositoryImpl$getProducts$slambda).yzg = function ($this$onStart, completion) {
    var i = new ProductRepositoryImpl$getProducts$slambda(this.vzg_1, completion);
    i.wzg_1 = $this$onStart;
    return i;
  };
  function ProductRepositoryImpl$getProducts$slambda_0(this$0, resultContinuation) {
    var i = new ProductRepositoryImpl$getProducts$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$onStart, $completion) {
      return i.xzg($this$onStart, $completion);
    }, 1);
  }
  function ProductRepositoryImpl$getBanners$slambda(this$0, resultContinuation) {
    this.hzh_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductRepositoryImpl$getBanners$slambda).jzh = function ($this$onStart, $completion) {
    var tmp = this.kzh($this$onStart, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductRepositoryImpl$getBanners$slambda).ja = function (p1, $completion) {
    return this.jzh((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductRepositoryImpl$getBanners$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          launch(this.hzh_1.yzf_1, VOID, VOID, ProductRepositoryImpl$getBanners$slambda$slambda_0(this.hzh_1, null));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ProductRepositoryImpl$getBanners$slambda).kzh = function ($this$onStart, completion) {
    var i = new ProductRepositoryImpl$getBanners$slambda(this.hzh_1, completion);
    i.izh_1 = $this$onStart;
    return i;
  };
  function ProductRepositoryImpl$getBanners$slambda_0(this$0, resultContinuation) {
    var i = new ProductRepositoryImpl$getBanners$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$onStart, $completion) {
      return i.jzh($this$onStart, $completion);
    }, 1);
  }
  function $refreshProductsCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tzh_1 = _this__u8e3s4;
  }
  protoOf($refreshProductsCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 10;
            this.vzh_1 = this.tzh_1.zzf_1;
            this.uzh_1 = null;
            this.n9_1 = 1;
            suspendResult = this.vzh_1.o2u(this.uzh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.wzh_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 8;
            this.o9_1 = 6;
            var this_0 = from(this.tzh_1.xzf_1, 'products');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('is_archived', false);
            this_1.awy('created_at', Order_DESCENDING_getInstance());
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 3;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            var remoteProducts = tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Product), arrayOf([]), false))]), false), value_0);
            if (!remoteProducts.r()) {
              this.n9_1 = 4;
              suspendResult = this.tzh_1.vzf_1.xzh(remoteProducts, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 8;
            this.n9_1 = 7;
            continue $sm;
          case 6:
            this.o9_1 = 8;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 7;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 7:
            this.o9_1 = 8;
            this.wzh_1 = Unit_instance;
            this.o9_1 = 10;
            this.n9_1 = 9;
            continue $sm;
          case 8:
            this.o9_1 = 10;
            var t = this.q9_1;
            this.vzh_1.q2u(this.uzh_1);
            throw t;
          case 9:
            this.wzh_1;
            this.o9_1 = 10;
            this.vzh_1.q2u(this.uzh_1);
            return Unit_instance;
          case 10:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 10) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $refreshBannersCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gzi_1 = _this__u8e3s4;
  }
  protoOf($refreshBannersCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 10;
            this.izi_1 = this.gzi_1.azg_1;
            this.hzi_1 = null;
            this.n9_1 = 1;
            suspendResult = this.izi_1.o2u(this.hzi_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.jzi_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 8;
            this.o9_1 = 6;
            var this_0 = from(this.gzi_1.xzf_1, 'banners');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 3;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            var remoteBanners = tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Banner), arrayOf([]), false))]), false), value_0);
            if (!remoteBanners.r()) {
              this.n9_1 = 4;
              suspendResult = this.gzi_1.wzf_1.kzi(remoteBanners, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 8;
            this.n9_1 = 7;
            continue $sm;
          case 6:
            this.o9_1 = 8;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 7;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 7:
            this.o9_1 = 8;
            this.jzi_1 = Unit_instance;
            this.o9_1 = 10;
            this.n9_1 = 9;
            continue $sm;
          case 8:
            this.o9_1 = 10;
            var t = this.q9_1;
            this.izi_1.q2u(this.hzi_1);
            throw t;
          case 9:
            this.jzi_1;
            this.o9_1 = 10;
            this.izi_1.q2u(this.hzi_1);
            return Unit_instance;
          case 10:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 10) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $getProductByIdCOROUTINE$(_this__u8e3s4, id, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tzi_1 = _this__u8e3s4;
    this.uzi_1 = id;
  }
  protoOf($getProductByIdCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.o9_1 = 5;
            this.n9_1 = 1;
            suspendResult = this.tzi_1.vzf_1.yzi(this.uzi_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var local = suspendResult;
            if (!(local == null))
              return local;
            var this_0 = from(this.tzi_1.xzf_1, 'products');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('id', this.uzi_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 2;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            var tmp0_safe_receiver = firstOrNull(tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Product), arrayOf([]), false))]), false), value_0));
            if (tmp0_safe_receiver == null) {
              this.wzi_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              this.xzi_1 = tmp0_safe_receiver;
              var it = this.xzi_1;
              this.n9_1 = 3;
              suspendResult = this.tzi_1.vzf_1.zzi(listOf(it), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.wzi_1 = this.xzi_1;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.vzi_1 = this.wzi_1;
            this.o9_1 = 6;
            this.n9_1 = 7;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_1 = this;
              tmp_1.vzi_1 = null;
              this.n9_1 = 7;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 6:
            throw this.q9_1;
          case 7:
            this.o9_1 = 6;
            return this.vzi_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $getCardsByIdsCOROUTINE$(_this__u8e3s4, ids, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.izj_1 = _this__u8e3s4;
    this.jzj_1 = ids;
  }
  protoOf($getCardsByIdsCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.jzj_1.r())
              return emptyList();
            this.o9_1 = 2;
            var this_0 = from(this.izj_1.xzf_1, 'cards');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.pwy('id', this.jzj_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            tmp_0.kzj_1 = tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Card_1), arrayOf([]), false))]), false), value_0);
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_2 = this;
              tmp_2.kzj_1 = emptyList();
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.kzj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $getBoxesByIdsCOROUTINE$(_this__u8e3s4, ids, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tzj_1 = _this__u8e3s4;
    this.uzj_1 = ids;
  }
  protoOf($getBoxesByIdsCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.uzj_1.r())
              return emptyList();
            this.o9_1 = 2;
            var this_0 = from(this.tzj_1.xzf_1, 'boxes');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.pwy('id', this.uzj_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            tmp_0.vzj_1 = tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Box_0), arrayOf([]), false))]), false), value_0);
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_2 = this;
              tmp_2.vzj_1 = emptyList();
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.vzj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $clearLocalDataCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ezk_1 = _this__u8e3s4;
  }
  protoOf($clearLocalDataCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.ezk_1.vzf_1.fzk(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.ezk_1.wzf_1.fzk(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $recordProductViewCOROUTINE$(_this__u8e3s4, productId, userId, platform, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ozk_1 = _this__u8e3s4;
    this.pzk_1 = productId;
    this.qzk_1 = userId;
    this.rzk_1 = platform;
  }
  protoOf($recordProductViewCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            var tmp0 = from(this.ozk_1.xzf_1, 'product_views');
            var value = new ProductViewRequest(this.pzk_1, this.qzk_1, this.rzk_1);
            var values = listOf(value);
            var this_0 = tmp0.owx_1.rvz();
            var tmp0_0 = Default_getInstance();
            var string = this_0.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ProductViewRequest), arrayOf([]), false))]), false), values);
            var this_1 = tmp0_0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(JsonElement), arrayOf([]), false));
            var body = get_jsonArray(tmp0_0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string));
            var requestBuilder = new InsertRequestBuilder(tmp0.owx_1.ebw().nwu_1);
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(body, 10));
            var _iterator__ex2g4s = body.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              destination.j1(get_jsonObject(item).x2());
            }

            var columns = distinct(flatten(destination));
            if (!columns.r()) {
              var tmp0_1 = requestBuilder.vwx_1;
              var value_0 = listOf(joinToString(columns, ','));
              tmp0_1.z2('columns', value_0);
            }

            var tmp0_returning = requestBuilder.uwx_1;
            var tmp1_count = requestBuilder.twx_1;
            var tmp2_urlParams = mapToFirstValue(requestBuilder.vwx_1);
            var tmp3_schema = tmp0.qwx_1;
            var tmp4_headers = requestBuilder.wwx_1.g3d();
            var tmp5_defaultToNull = requestBuilder.vwy_1;
            var insertRequest = new InsertRequest(VOID, tmp0_returning, tmp1_count, VOID, tmp5_defaultToNull, body, tmp2_urlParams, tmp3_schema, tmp4_headers);
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(tmp0.owx_1, tmp0.pwx_1, insertRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.szk_1 = suspendResult;
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var e = this.q9_1;
              var tmp_1 = this;
              tmp_1.szk_1 = Unit_instance;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 3) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function ProductRepositoryImpl(productDao, bannerDao, supabase) {
    this.vzf_1 = productDao;
    this.wzf_1 = bannerDao;
    this.xzf_1 = supabase;
    this.yzf_1 = CoroutineScope_0(SupervisorJob().xj(Dispatchers_getInstance().i1h_1));
    this.zzf_1 = Mutex();
    this.azg_1 = Mutex();
  }
  protoOf(ProductRepositoryImpl).tzk = function () {
    var tmp = this.vzf_1.uzk();
    return onStart(tmp, ProductRepositoryImpl$getProducts$slambda_0(this, null));
  };
  protoOf(ProductRepositoryImpl).bzg = function ($completion) {
    var tmp = new $refreshProductsCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductRepositoryImpl).vzk = function () {
    var tmp = this.wzf_1.wzk();
    return onStart(tmp, ProductRepositoryImpl$getBanners$slambda_0(this, null));
  };
  protoOf(ProductRepositoryImpl).mzg = function ($completion) {
    var tmp = new $refreshBannersCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductRepositoryImpl).yzi = function (id, $completion) {
    var tmp = new $getProductByIdCOROUTINE$(this, id, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductRepositoryImpl).xzk = function (ids, $completion) {
    var tmp = new $getCardsByIdsCOROUTINE$(this, ids, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductRepositoryImpl).yzk = function (ids, $completion) {
    var tmp = new $getBoxesByIdsCOROUTINE$(this, ids, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductRepositoryImpl).tyr = function ($completion) {
    var tmp = new $clearLocalDataCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductRepositoryImpl).zzk = function (productId, userId, platform, $completion) {
    var tmp = new $recordProductViewCOROUTINE$(this, productId, userId, platform, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function Companion() {
  }
  var Companion_instance_5;
  function Companion_getInstance_34() {
    return Companion_instance_5;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.data.repository.ProductViewRequest', this, 3);
    tmp0_serialDesc.a7c('product_id', false);
    tmp0_serialDesc.a7c('user_id', true);
    tmp0_serialDesc.a7c('platform', false);
    this.azl_1 = tmp0_serialDesc;
  }
  protoOf($serializer).bzl = function (encoder, value) {
    var tmp0_desc = this.azl_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.y75(tmp0_desc, 0, value.czl_1);
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.dzl_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.dzl_1);
    }
    tmp1_output.c76(tmp0_desc, 2, value.ezl_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer).z70 = function (encoder, value) {
    return this.bzl(encoder, value instanceof ProductViewRequest ? value : THROW_CCE());
  };
  protoOf($serializer).a71 = function (decoder) {
    var tmp0_desc = this.azl_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.n74(tmp0_desc);
    if (tmp7_input.d75()) {
      tmp4_local0 = tmp7_input.t74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.x74(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.t74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.x74(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.o74(tmp0_desc);
    return ProductViewRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer).y70 = function () {
    return this.azl_1;
  };
  protoOf($serializer).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function ProductViewRequest_init_$Init$(seen0, productId, userId, platform, serializationConstructorMarker, $this) {
    if (!(5 === (5 & seen0))) {
      throwMissingFieldException(seen0, 5, $serializer_getInstance().azl_1);
    }
    $this.czl_1 = productId;
    if (0 === (seen0 & 2))
      $this.dzl_1 = null;
    else
      $this.dzl_1 = userId;
    $this.ezl_1 = platform;
    return $this;
  }
  function ProductViewRequest_init_$Create$(seen0, productId, userId, platform, serializationConstructorMarker) {
    return ProductViewRequest_init_$Init$(seen0, productId, userId, platform, serializationConstructorMarker, objectCreate(protoOf(ProductViewRequest)));
  }
  function ProductViewRequest(productId, userId, platform) {
    userId = userId === VOID ? null : userId;
    this.czl_1 = productId;
    this.dzl_1 = userId;
    this.ezl_1 = platform;
  }
  protoOf(ProductViewRequest).toString = function () {
    return 'ProductViewRequest(productId=' + this.czl_1.toString() + ', userId=' + this.dzl_1 + ', platform=' + this.ezl_1 + ')';
  };
  protoOf(ProductViewRequest).hashCode = function () {
    var result = this.czl_1.hashCode();
    result = imul(result, 31) + (this.dzl_1 == null ? 0 : getStringHashCode(this.dzl_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.ezl_1) | 0;
    return result;
  };
  protoOf(ProductViewRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductViewRequest))
      return false;
    if (!equalsLong(this.czl_1, other.czl_1))
      return false;
    if (!(this.dzl_1 == other.dzl_1))
      return false;
    if (!(this.ezl_1 === other.ezl_1))
      return false;
    return true;
  };
  var client_fstech_hadaya_data_repository_DoubleOrNullSerializer$stable;
  var client_fstech_hadaya_data_repository_SettingsRepositoryImpl_AppSetting_$serializer$stable;
  var client_fstech_hadaya_data_repository_SettingsRepositoryImpl$stable;
  function Companion_0() {
  }
  var Companion_instance_6;
  function Companion_getInstance_35() {
    return Companion_instance_6;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.data.repository.SettingsRepositoryImpl.AppSetting', this, 3);
    tmp0_serialDesc.a7c('key', false);
    tmp0_serialDesc.a7c('value', true);
    tmp0_serialDesc.a7c('numeric_value', true);
    this.fzl_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).gzl = function (encoder, value) {
    var tmp0_desc = this.fzl_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.c76(tmp0_desc, 0, value.hzl_1);
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.izl_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, JsonElementSerializer_getInstance(), value.izl_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.jzl_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, DoubleOrNullSerializer_getInstance(), value.jzl_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_0).z70 = function (encoder, value) {
    return this.gzl(encoder, value instanceof AppSetting ? value : THROW_CCE());
  };
  protoOf($serializer_0).a71 = function (decoder) {
    var tmp0_desc = this.fzl_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.n74(tmp0_desc);
    if (tmp7_input.d75()) {
      tmp4_local0 = tmp7_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b75(tmp0_desc, 1, JsonElementSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b75(tmp0_desc, 2, DoubleOrNullSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b75(tmp0_desc, 1, JsonElementSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b75(tmp0_desc, 2, DoubleOrNullSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.o74(tmp0_desc);
    return AppSetting_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_0).y70 = function () {
    return this.fzl_1;
  };
  protoOf($serializer_0).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(JsonElementSerializer_getInstance()), get_nullable(DoubleOrNullSerializer_getInstance())];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function AppSetting_init_$Init$(seen0, key, value, numeric_value, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_0().fzl_1);
    }
    $this.hzl_1 = key;
    if (0 === (seen0 & 2))
      $this.izl_1 = null;
    else
      $this.izl_1 = value;
    if (0 === (seen0 & 4))
      $this.jzl_1 = null;
    else
      $this.jzl_1 = numeric_value;
    return $this;
  }
  function AppSetting_init_$Create$(seen0, key, value, numeric_value, serializationConstructorMarker) {
    return AppSetting_init_$Init$(seen0, key, value, numeric_value, serializationConstructorMarker, objectCreate(protoOf(AppSetting)));
  }
  function AppSetting(key, value, numeric_value) {
    value = value === VOID ? null : value;
    numeric_value = numeric_value === VOID ? null : numeric_value;
    this.hzl_1 = key;
    this.izl_1 = value;
    this.jzl_1 = numeric_value;
  }
  protoOf(AppSetting).kzl = function () {
    var tmp0_elvis_lhs = this.jzl_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = this.izl_1;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_1;
        if (tmp1_safe_receiver instanceof JsonPrimitive) {
          var tmp0_elvis_lhs_0 = get_doubleOrNull(tmp1_safe_receiver);
          tmp_1 = tmp0_elvis_lhs_0 == null ? toDoubleOrNull(tmp1_safe_receiver.rj3()) : tmp0_elvis_lhs_0;
        } else {
          tmp_1 = null;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AppSetting).toString = function () {
    return 'AppSetting(key=' + this.hzl_1 + ', value=' + toString_0(this.izl_1) + ', numeric_value=' + this.jzl_1 + ')';
  };
  protoOf(AppSetting).hashCode = function () {
    var result = getStringHashCode(this.hzl_1);
    result = imul(result, 31) + (this.izl_1 == null ? 0 : hashCode(this.izl_1)) | 0;
    result = imul(result, 31) + (this.jzl_1 == null ? 0 : getNumberHashCode(this.jzl_1)) | 0;
    return result;
  };
  protoOf(AppSetting).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AppSetting))
      return false;
    if (!(this.hzl_1 === other.hzl_1))
      return false;
    if (!equals(this.izl_1, other.izl_1))
      return false;
    if (!equals(this.jzl_1, other.jzl_1))
      return false;
    return true;
  };
  function SettingsRepositoryImpl$getShippingCost$lambda(it) {
    return joinToString(it.yh_1, ',', VOID, VOID, VOID, VOID, SettingsRepositoryImpl$getShippingCost$lambda$lambda(it));
  }
  function SettingsRepositoryImpl$getShippingCost$lambda$lambda($it) {
    return function (filter) {
      var isLogicalOperator = startsWith(filter, '(') && endsWith(filter, ')');
      return $it.xh_1 + (isLogicalOperator ? '' : '.') + filter;
    };
  }
  function $getShippingCostCOROUTINE$(_this__u8e3s4, governorate, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tzl_1 = _this__u8e3s4;
    this.uzl_1 = governorate;
  }
  protoOf($getShippingCostCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            this.o9_1 = 6;
            var this_0 = this.tzl_1.yzl_1.xwu('app_settings');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('key', this.uzl_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            var setting = firstOrNull(tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(AppSetting), arrayOf([]), false))]), false), value_0));
            var tmp1_elvis_lhs = setting == null ? null : setting.kzl();
            if (tmp1_elvis_lhs == null) {
              this.o9_1 = 3;
              var this_3 = this.tzl_1.yzl_1.xwu('app_settings');
              var columns_0 = Companion_getInstance_0().iwx_1;
              var this_4 = new SelectRequestBuilder(this_3.owx_1.ebw().nwu_1);
              var filter_0 = new PostgrestFilterBuilder(this_4.swx_1, this_4.vwx_1);
              l$ret$1: do {
                var this_5 = StringBuilder_init_$Create$();
                if (false) {
                  this_5.q('not.');
                }
                if (!(null == null)) {
                  this_5.q(null + '.');
                }
                var prefix = this_5.toString();
                var this_6 = new PostgrestFilterBuilder(filter_0.hwy_1, VOID, true);
                this_6.nwy('key', 'Other');
                this_6.nwy('key', 'shipping_cost');
                var params = this_6.kwy();
                var tmp_0 = toList(params);
                var formattedFilter = joinToString(tmp_0, ',', VOID, VOID, VOID, VOID, SettingsRepositoryImpl$getShippingCost$lambda);
                var joiningFilter = '(' + formattedFilter + ')';
                if (joiningFilter === '()') {
                  break l$ret$1;
                }
                var tmp0_1 = filter_0.iwy_1;
                var tmp2 = prefix + 'or';
                var tmp_1 = listOf(joiningFilter);
                var tmp_2;
                if (filter_0.jwy_1) {
                  var tmp0_elvis_lhs = filter_0.iwy_1.w2(prefix + 'or');
                  tmp_2 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
                } else {
                  tmp_2 = emptyList();
                }
                var value_1 = plus(tmp_1, tmp_2);
                tmp0_1.z2(tmp2, value_1);
              }
               while (false);
              var tmp0_2 = this_4.vwx_1;
              var value_2 = listOf(_Columns___get_value__impl__haxhww(columns_0));
              tmp0_2.z2('select', value_2);
              var requestBuilder_0 = this_4;
              var selectRequest_0 = new SelectRequest(requestBuilder_0.bwz_1, requestBuilder_0.twx_1, mapToFirstValue(requestBuilder_0.vwx_1), this_3.qwx_1, requestBuilder_0.wwx_1.g3d());
              this.n9_1 = 2;
              suspendResult = RestRequestExecutor_instance.hwx(this_3.owx_1, this_3.pwx_1, selectRequest_0, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.wzl_1 = tmp1_elvis_lhs;
              this.n9_1 = 5;
              continue $sm;
            }

          case 2:
            var this_7 = suspendResult;
            var tmp0_3 = this_7.wx0_1.rvz();
            var value_3 = this_7.ux0_1;
            var fallbackSetting = firstOrNull(tmp0_3.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(AppSetting), arrayOf([]), false))]), false), value_3));
            var tmp_3 = this;
            tmp_3.xzl_1 = fallbackSetting == null ? null : fallbackSetting.kzl();
            this.o9_1 = 6;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_4 = this.q9_1;
            if (tmp_4 instanceof Error) {
              var e = this.q9_1;
              var tmp_5 = this;
              tmp_5.xzl_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 6;
            this.wzl_1 = this.xzl_1;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.vzl_1 = this.wzl_1;
            this.o9_1 = 7;
            this.n9_1 = 8;
            continue $sm;
          case 6:
            this.o9_1 = 7;
            var tmp_6 = this.q9_1;
            if (tmp_6 instanceof Error) {
              var e_0 = this.q9_1;
              var tmp_7 = this;
              tmp_7.vzl_1 = null;
              this.n9_1 = 8;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 7:
            throw this.q9_1;
          case 8:
            this.o9_1 = 7;
            return this.vzl_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 7) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  function $getWelcomeCouponValueCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hzm_1 = _this__u8e3s4;
  }
  protoOf($getWelcomeCouponValueCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            var this_0 = this.hzm_1.yzl_1.xwu('app_settings');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('key', 'coupon_new_user');
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            var setting = firstOrNull(tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(AppSetting), arrayOf([]), false))]), false), value_0));
            var tmp_0 = this;
            tmp_0.izm_1 = setting == null ? null : setting.kzl();
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var e = this.q9_1;
              var tmp_2 = this;
              tmp_2.izm_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.izm_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 3) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $getMinAppVersionCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rzm_1 = _this__u8e3s4;
  }
  protoOf($getMinAppVersionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            var platform = getPlatform().m();
            var key = contains(platform, 'Android', true) ? 'min_app_version_android' : 'min_app_version_ios';
            var this_0 = this.rzm_1.yzl_1.xwu('app_settings');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('key', key);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            var setting = firstOrNull(tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(AppSetting), arrayOf([]), false))]), false), value_0));
            var tmp_0 = this;
            var tmp1_safe_receiver = setting == null ? null : setting.kzl();
            tmp_0.szm_1 = tmp1_safe_receiver == null ? null : numberToLong(tmp1_safe_receiver);
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var e = this.q9_1;
              var tmp_2 = this;
              tmp_2.szm_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.szm_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 3) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function SettingsRepositoryImpl(postgrest) {
    this.yzl_1 = postgrest;
  }
  protoOf(SettingsRepositoryImpl).tzm = function (governorate, $completion) {
    var tmp = new $getShippingCostCOROUTINE$(this, governorate, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SettingsRepositoryImpl).syq = function ($completion) {
    var tmp = new $getWelcomeCouponValueCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SettingsRepositoryImpl).uzm = function ($completion) {
    var tmp = new $getMinAppVersionCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function DoubleOrNullSerializer() {
    DoubleOrNullSerializer_instance = this;
    this.vzm_1 = PrimitiveSerialDescriptor('DoubleOrNull', DOUBLE_getInstance());
  }
  protoOf(DoubleOrNullSerializer).y70 = function () {
    return this.vzm_1;
  };
  protoOf(DoubleOrNullSerializer).wzm = function (encoder, value) {
    if (value == null) {
      encoder.i75();
    } else {
      encoder.p75(value);
    }
  };
  protoOf(DoubleOrNullSerializer).z70 = function (encoder, value) {
    return this.wzm(encoder, (value == null ? true : typeof value === 'number') ? value : THROW_CCE());
  };
  protoOf(DoubleOrNullSerializer).a71 = function (decoder) {
    var tmp;
    try {
      tmp = decoder.g74();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var e = $p;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  var DoubleOrNullSerializer_instance;
  function DoubleOrNullSerializer_getInstance() {
    if (DoubleOrNullSerializer_instance == null)
      new DoubleOrNullSerializer();
    return DoubleOrNullSerializer_instance;
  }
  var client_fstech_hadaya_data_repository_StockReminderRepositoryImpl$stable;
  function StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda).gzn = function ($this$flow, $completion) {
    var tmp = this.hzn($this$flow, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda).ja = function (p1, $completion) {
    return this.gzn((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.fzn_1.a1v(false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda).hzn = function ($this$flow, completion) {
    var i = new StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda(completion);
    i.fzn_1 = $this$flow;
    return i;
  };
  function StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda_0(resultContinuation) {
    var i = new StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda(resultContinuation);
    return constructCallableReference(function ($this$flow, $completion) {
      return i.gzn($this$flow, $completion);
    }, 1);
  }
  function StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda_1(this$0, $productId, $userId, resultContinuation) {
    this.qzn_1 = this$0;
    this.rzn_1 = $productId;
    this.szn_1 = $userId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda_1).gzn = function ($this$flow, $completion) {
    var tmp = this.hzn($this$flow, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda_1).ja = function (p1, $completion) {
    return this.gzn((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.o9_1 = 3;
            var this_0 = this.qzn_1.vzn_1.xwu('stock_reminders');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('product_id', this.rzn_1);
            filter.nwy('user_id', this.szn_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            var exists = !tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(StockReminder), arrayOf([]), false))]), false), value_0).r();
            this.n9_1 = 2;
            suspendResult = this.tzn_1.a1v(exists, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var e = this.q9_1;
              this.n9_1 = 4;
              suspendResult = this.tzn_1.a1v(false, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda_1).hzn = function ($this$flow, completion) {
    var i = new StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda_1(this.qzn_1, this.rzn_1, this.szn_1, completion);
    i.tzn_1 = $this$flow;
    return i;
  };
  function StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda_2(this$0, $productId, $userId, resultContinuation) {
    var i = new StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda_1(this$0, $productId, $userId, resultContinuation);
    return constructCallableReference(function ($this$flow, $completion) {
      return i.gzn($this$flow, $completion);
    }, 1);
  }
  function StockReminderRepositoryImpl$getStockReminders$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda$slambda).gzo = function ($this$flow, $completion) {
    var tmp = this.hzo($this$flow, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda$slambda).ja = function (p1, $completion) {
    return this.gzo((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.fzo_1.a1v(emptyList(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda$slambda).hzo = function ($this$flow, completion) {
    var i = new StockReminderRepositoryImpl$getStockReminders$slambda$slambda(completion);
    i.fzo_1 = $this$flow;
    return i;
  };
  function StockReminderRepositoryImpl$getStockReminders$slambda$slambda_0(resultContinuation) {
    var i = new StockReminderRepositoryImpl$getStockReminders$slambda$slambda(resultContinuation);
    return constructCallableReference(function ($this$flow, $completion) {
      return i.gzo($this$flow, $completion);
    }, 1);
  }
  function StockReminderRepositoryImpl$getStockReminders$slambda$slambda_1(this$0, $userId, resultContinuation) {
    this.qzo_1 = this$0;
    this.rzo_1 = $userId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda$slambda_1).gzo = function ($this$flow, $completion) {
    var tmp = this.hzo($this$flow, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda$slambda_1).ja = function (p1, $completion) {
    return this.gzo((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.o9_1 = 3;
            var this_0 = this.qzo_1.vzn_1.xwu('stock_reminders');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('user_id', this.rzo_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            var list = tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(StockReminder), arrayOf([]), false))]), false), value_0);
            this.n9_1 = 2;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(list, 10));
            var _iterator__ex2g4s = list.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              destination.j1(item.tzo_1);
            }

            suspendResult = this.szo_1.a1v(destination, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var e = this.q9_1;
              this.n9_1 = 4;
              suspendResult = this.szo_1.a1v(emptyList(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda$slambda_1).hzo = function ($this$flow, completion) {
    var i = new StockReminderRepositoryImpl$getStockReminders$slambda$slambda_1(this.qzo_1, this.rzo_1, completion);
    i.szo_1 = $this$flow;
    return i;
  };
  function StockReminderRepositoryImpl$getStockReminders$slambda$slambda_2(this$0, $userId, resultContinuation) {
    var i = new StockReminderRepositoryImpl$getStockReminders$slambda$slambda_1(this$0, $userId, resultContinuation);
    return constructCallableReference(function ($this$flow, $completion) {
      return i.gzo($this$flow, $completion);
    }, 1);
  }
  function StockReminderRepositoryImpl$isStockReminderSet$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda).gzp = function (profile, _unused_var__etf5q3, $completion) {
    var tmp = this.hzp(profile, _unused_var__etf5q3, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda).ha = function (p1, p2, $completion) {
    var tmp = (p1 == null ? true : p1 instanceof Profile) ? p1 : THROW_CCE();
    return this.gzp(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return this.ezp_1;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda).hzp = function (profile, _unused_var__etf5q3, completion) {
    var i = new StockReminderRepositoryImpl$isStockReminderSet$slambda(completion);
    i.ezp_1 = profile;
    i.fzp_1 = _unused_var__etf5q3;
    return i;
  };
  function StockReminderRepositoryImpl$isStockReminderSet$slambda_0(resultContinuation) {
    var i = new StockReminderRepositoryImpl$isStockReminderSet$slambda(resultContinuation);
    return constructCallableReference(function (profile, _unused_var__etf5q3, $completion) {
      return i.gzp(profile, _unused_var__etf5q3, $completion);
    }, 2);
  }
  function StockReminderRepositoryImpl$isStockReminderSet$slambda_1(this$0, $productId, resultContinuation) {
    this.qzp_1 = this$0;
    this.rzp_1 = $productId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda_1).nyp = function ($this$transformLatest, it, $completion) {
    var tmp = this.oyp($this$transformLatest, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda_1).ha = function (p1, p2, $completion) {
    return this.nyp((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), p2, $completion);
  };
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp0 = this.tzp_1;
            var tmp$ret$0;
            l$ret$1: do {
              var tmp1_elvis_lhs = tmp0 == null ? null : tmp0.uym_1;
              var tmp_0;
              if (tmp1_elvis_lhs == null) {
                tmp$ret$0 = flow(StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda_0(null));
                break l$ret$1;
              } else {
                tmp_0 = tmp1_elvis_lhs;
              }
              var userId = tmp_0;
              tmp$ret$0 = flow(StockReminderRepositoryImpl$isStockReminderSet$slambda$slambda_2(this.qzp_1, this.rzp_1, userId, null));
            }
             while (false);
            suspendResult = emitAll(this.szp_1, tmp$ret$0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(StockReminderRepositoryImpl$isStockReminderSet$slambda_1).oyp = function ($this$transformLatest, it, completion) {
    var i = new StockReminderRepositoryImpl$isStockReminderSet$slambda_1(this.qzp_1, this.rzp_1, completion);
    i.szp_1 = $this$transformLatest;
    i.tzp_1 = it;
    return i;
  };
  function StockReminderRepositoryImpl$isStockReminderSet$slambda_2(this$0, $productId, resultContinuation) {
    var i = new StockReminderRepositoryImpl$isStockReminderSet$slambda_1(this$0, $productId, resultContinuation);
    return constructCallableReference(function ($this$transformLatest, it, $completion) {
      return i.nyp($this$transformLatest, it, $completion);
    }, 2);
  }
  function StockReminderRepositoryImpl$getStockReminders$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda).gzp = function (profile, _unused_var__etf5q3, $completion) {
    var tmp = this.hzp(profile, _unused_var__etf5q3, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda).ha = function (p1, p2, $completion) {
    var tmp = (p1 == null ? true : p1 instanceof Profile) ? p1 : THROW_CCE();
    return this.gzp(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return this.czq_1;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda).hzp = function (profile, _unused_var__etf5q3, completion) {
    var i = new StockReminderRepositoryImpl$getStockReminders$slambda(completion);
    i.czq_1 = profile;
    i.dzq_1 = _unused_var__etf5q3;
    return i;
  };
  function StockReminderRepositoryImpl$getStockReminders$slambda_0(resultContinuation) {
    var i = new StockReminderRepositoryImpl$getStockReminders$slambda(resultContinuation);
    return constructCallableReference(function (profile, _unused_var__etf5q3, $completion) {
      return i.gzp(profile, _unused_var__etf5q3, $completion);
    }, 2);
  }
  function StockReminderRepositoryImpl$getStockReminders$slambda_1(this$0, resultContinuation) {
    this.mzq_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda_1).nyp = function ($this$transformLatest, it, $completion) {
    var tmp = this.oyp($this$transformLatest, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda_1).ha = function (p1, p2, $completion) {
    return this.nyp((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), p2, $completion);
  };
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp0 = this.ozq_1;
            var tmp$ret$0;
            l$ret$1: do {
              var tmp1_elvis_lhs = tmp0 == null ? null : tmp0.uym_1;
              var tmp_0;
              if (tmp1_elvis_lhs == null) {
                tmp$ret$0 = flow(StockReminderRepositoryImpl$getStockReminders$slambda$slambda_0(null));
                break l$ret$1;
              } else {
                tmp_0 = tmp1_elvis_lhs;
              }
              var userId = tmp_0;
              tmp$ret$0 = flow(StockReminderRepositoryImpl$getStockReminders$slambda$slambda_2(this.mzq_1, userId, null));
            }
             while (false);
            suspendResult = emitAll(this.nzq_1, tmp$ret$0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(StockReminderRepositoryImpl$getStockReminders$slambda_1).oyp = function ($this$transformLatest, it, completion) {
    var i = new StockReminderRepositoryImpl$getStockReminders$slambda_1(this.mzq_1, completion);
    i.nzq_1 = $this$transformLatest;
    i.ozq_1 = it;
    return i;
  };
  function StockReminderRepositoryImpl$getStockReminders$slambda_2(this$0, resultContinuation) {
    var i = new StockReminderRepositoryImpl$getStockReminders$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function ($this$transformLatest, it, $completion) {
      return i.nyp($this$transformLatest, it, $completion);
    }, 2);
  }
  function $toggleStockReminderCOROUTINE$(_this__u8e3s4, productId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xzq_1 = _this__u8e3s4;
    this.yzq_1 = productId;
  }
  protoOf($toggleStockReminderCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            var currentUser = this.xzq_1.uzn_1.xyv();
            var tmp_0 = this;
            tmp_0.azr_1 = currentUser == null ? null : currentUser.uym_1;
            if (this.azr_1 == null) {
              return Unit_instance;
            }

            this.o9_1 = 6;
            var this_0 = this.xzq_1.vzn_1.xwu('stock_reminders');
            var columns = Companion_getInstance_0().iwx_1;
            var this_1 = new SelectRequestBuilder(this_0.owx_1.ebw().nwu_1);
            var filter = new PostgrestFilterBuilder(this_1.swx_1, this_1.vwx_1);
            filter.nwy('product_id', this.yzq_1);
            filter.nwy('user_id', this.azr_1);
            var tmp0 = this_1.vwx_1;
            var value = listOf(_Columns___get_value__impl__haxhww(columns));
            tmp0.z2('select', value);
            var requestBuilder = this_1;
            var selectRequest = new SelectRequest(requestBuilder.bwz_1, requestBuilder.twx_1, mapToFirstValue(requestBuilder.vwx_1), this_0.qwx_1, requestBuilder.wwx_1.g3d());
            this.n9_1 = 1;
            suspendResult = RestRequestExecutor_instance.hwx(this_0.owx_1, this_0.pwx_1, selectRequest, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_2 = suspendResult;
            var tmp0_0 = this_2.wx0_1.rvz();
            var value_0 = this_2.ux0_1;
            var exists = !tmp0_0.bvo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(StockReminder), arrayOf([]), false))]), false), value_0).r();
            if (exists) {
              var this_3 = this.xzq_1.vzn_1.xwu('stock_reminders');
              var this_4 = new PostgrestRequestBuilder(this_3.owx_1.ebw().nwu_1);
              var filter_0 = new PostgrestFilterBuilder(this_4.swx_1, this_4.vwx_1);
              filter_0.nwy('product_id', this.yzq_1);
              filter_0.nwy('user_id', this.azr_1);
              var requestBuilder_0 = this_4;
              var deleteRequest = new DeleteRequest(requestBuilder_0.uwx_1, requestBuilder_0.twx_1, mapToFirstValue(requestBuilder_0.vwx_1), this_3.qwx_1, requestBuilder_0.wwx_1.g3d());
              this.n9_1 = 3;
              suspendResult = RestRequestExecutor_instance.hwx(this_3.owx_1, this_3.pwx_1, deleteRequest, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var reminder = new StockReminder(this.yzq_1, this.azr_1);
              var tmp0_1 = this.xzq_1.vzn_1.xwu('stock_reminders');
              var values = listOf(reminder);
              var this_5 = tmp0_1.owx_1.rvz();
              var tmp0_2 = Default_getInstance();
              var string = this_5.avo(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(StockReminder), arrayOf([]), false))]), false), values);
              var this_6 = tmp0_2.c75();
              var this_7 = serializer(this_6, createKType(getKClass(JsonElement), arrayOf([]), false));
              var body = get_jsonArray(tmp0_2.c72(isInterface(this_7, KSerializer) ? this_7 : THROW_CCE(), string));
              var requestBuilder_1 = new InsertRequestBuilder(tmp0_1.owx_1.ebw().nwu_1);
              var destination = ArrayList_init_$Create$(collectionSizeOrDefault(body, 10));
              var _iterator__ex2g4s = body.t();
              while (_iterator__ex2g4s.u()) {
                var item = _iterator__ex2g4s.v();
                destination.j1(get_jsonObject(item).x2());
              }
              var columns_0 = distinct(flatten(destination));
              if (!columns_0.r()) {
                var tmp0_3 = requestBuilder_1.vwx_1;
                var value_1 = listOf(joinToString(columns_0, ','));
                tmp0_3.z2('columns', value_1);
              }
              var tmp0_returning = requestBuilder_1.uwx_1;
              var tmp1_count = requestBuilder_1.twx_1;
              var tmp2_urlParams = mapToFirstValue(requestBuilder_1.vwx_1);
              var tmp3_schema = tmp0_1.qwx_1;
              var tmp4_headers = requestBuilder_1.wwx_1.g3d();
              var tmp5_defaultToNull = requestBuilder_1.vwy_1;
              var insertRequest = new InsertRequest(VOID, tmp0_returning, tmp1_count, VOID, tmp5_defaultToNull, body, tmp2_urlParams, tmp3_schema, tmp4_headers);
              this.n9_1 = 2;
              suspendResult = RestRequestExecutor_instance.hwx(tmp0_1.owx_1, tmp0_1.pwx_1, insertRequest, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.zzq_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.zzq_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 5;
            suspendResult = this.xzq_1.wzn_1.a1v(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.o9_1 = 7;
            this.n9_1 = 8;
            continue $sm;
          case 6:
            this.o9_1 = 7;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 8;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 7:
            throw this.q9_1;
          case 8:
            this.o9_1 = 7;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function StockReminderRepositoryImpl(authRepository, postgrest) {
    this.uzn_1 = authRepository;
    this.vzn_1 = postgrest;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = MutableSharedFlow(1);
    this_0.i1z(Unit_instance);
    tmp.wzn_1 = this_0;
  }
  protoOf(StockReminderRepositoryImpl).bzr = function (productId, $completion) {
    var tmp = new $toggleStockReminderCOROUTINE$(this, productId, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockReminderRepositoryImpl).czr = function (productId) {
    var tmp = this.uzn_1.oyv();
    // Inline function 'kotlinx.coroutines.flow.flatMapLatest' call
    var this_0 = combine(tmp, this.wzn_1, StockReminderRepositoryImpl$isStockReminderSet$slambda_0(null));
    return transformLatest(this_0, StockReminderRepositoryImpl$isStockReminderSet$slambda_2(this, productId, null));
  };
  protoOf(StockReminderRepositoryImpl).dzr = function () {
    var tmp = this.uzn_1.oyv();
    // Inline function 'kotlinx.coroutines.flow.flatMapLatest' call
    var this_0 = combine(tmp, this.wzn_1, StockReminderRepositoryImpl$getStockReminders$slambda_0(null));
    return transformLatest(this_0, StockReminderRepositoryImpl$getStockReminders$slambda_2(this, null));
  };
  var client_fstech_hadaya_data_repository_StorageRepositoryImpl$stable;
  function StorageRepositoryImpl$uploadDesignImage$lambda($this$upload) {
    $this$upload.xx5_1 = true;
    return Unit_instance;
  }
  function $uploadDesignImageCOROUTINE$(_this__u8e3s4, bytes, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mzr_1 = _this__u8e3s4;
    this.nzr_1 = bytes;
    this.ozr_1 = path;
  }
  protoOf($uploadDesignImageCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            this.qzr_1 = this.mzr_1.rzr_1.xwu('custom_designs');
            this.n9_1 = 1;
            var tmp_0 = toNativeByteArray(this.nzr_1);
            suspendResult = this.qzr_1.vx4(this.ozr_1, tmp_0, StorageRepositoryImpl$uploadDesignImage$lambda, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.pzr_1 = this.qzr_1.dx5(this.ozr_1);
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_2 = this;
              tmp_2.pzr_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.pzr_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $downloadDesignImageCOROUTINE$(_this__u8e3s4, url, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bzs_1 = _this__u8e3s4;
    this.czs_1 = url;
  }
  protoOf($downloadDesignImageCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.o9_1 = 5;
            if (contains(this.czs_1, '/custom_designs/')) {
              var tmp0_elvis_lhs = lastOrNull(split(this.czs_1, ['/custom_designs/']));
              var tmp_0;
              if (tmp0_elvis_lhs == null) {
                return null;
              } else {
                tmp_0 = tmp0_elvis_lhs;
              }
              var path = tmp_0;
              this.n9_1 = 3;
              suspendResult = this.bzs_1.rzr_1.xwu('custom_designs').cx5(path, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (startsWith(this.czs_1, 'http')) {
                this.n9_1 = 2;
                suspendResult = this.bzs_1.fzs(this.czs_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 1;
                suspendResult = this.bzs_1.rzr_1.xwu('custom_designs').cx5(this.czs_1, VOID, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 1:
            var ARGUMENT = suspendResult;
            this.ezs_1 = toSerializableList(ARGUMENT);
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.ezs_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            var ARGUMENT_0 = suspendResult;
            this.ezs_1 = toSerializableList(ARGUMENT_0);
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.dzs_1 = this.ezs_1;
            this.o9_1 = 6;
            this.n9_1 = 7;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_2 = this;
              tmp_2.dzs_1 = null;
              this.n9_1 = 7;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 6:
            throw this.q9_1;
          case 7:
            this.o9_1 = 6;
            return this.dzs_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $downloadExternalImageCOROUTINE$(_this__u8e3s4, url, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ozs_1 = _this__u8e3s4;
    this.pzs_1 = url;
  }
  protoOf($downloadExternalImageCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.o9_1 = 3;
            var tmp0 = this.ozs_1.szr_1;
            var urlString = this.pzs_1;
            var this_0 = new HttpRequestBuilder();
            url_0(this_0, urlString);
            this_0.ztr_1 = Companion_getInstance_1().et2_1;
            this.n9_1 = 1;
            suspendResult = (new HttpStatement(this_0, tmp0)).pv2(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = readRawBytes(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            this.qzs_1 = toSerializableList(ARGUMENT_0);
            this.o9_1 = 4;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 4;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_1 = this;
              tmp_1.qzs_1 = null;
              this.n9_1 = 5;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            throw this.q9_1;
          case 5:
            this.o9_1 = 4;
            return this.qzs_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $deleteDesignImageCOROUTINE$(_this__u8e3s4, url, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zzs_1 = _this__u8e3s4;
    this.azt_1 = url;
  }
  protoOf($deleteDesignImageCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            var tmp0_elvis_lhs = lastOrNull(split(this.azt_1, ['/custom_designs/']));
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var path = tmp_0;
            this.n9_1 = 1;
            suspendResult = this.zzs_1.rzr_1.xwu('custom_designs').yx4([path], this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function StorageRepositoryImpl(storage, httpClient) {
    httpClient = httpClient === VOID ? HttpClient() : httpClient;
    this.rzr_1 = storage;
    this.szr_1 = httpClient;
  }
  protoOf(StorageRepositoryImpl).bzt = function (bytes, path, $completion) {
    var tmp = new $uploadDesignImageCOROUTINE$(this, bytes, path, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StorageRepositoryImpl).czt = function (url, $completion) {
    var tmp = new $downloadDesignImageCOROUTINE$(this, url, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StorageRepositoryImpl).fzs = function (url, $completion) {
    var tmp = new $downloadExternalImageCOROUTINE$(this, url, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StorageRepositoryImpl).rz1 = function (url, $completion) {
    var tmp = new $deleteDesignImageCOROUTINE$(this, url, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  var client_fstech_hadaya_data_source_local_AppDatabase$stable;
  function AppDatabase() {
  }
  function BannerDao() {
  }
  function CartDao() {
  }
  var client_fstech_hadaya_data_source_local_Converters$stable;
  function FavoriteDao() {
  }
  var client_fstech_hadaya_data_source_local_MemoryCartDao$stable;
  var client_fstech_hadaya_data_source_local_MemoryProductDao$stable;
  var client_fstech_hadaya_data_source_local_MemoryBannerDao$stable;
  var client_fstech_hadaya_data_source_local_MemoryFavoriteDao$stable;
  var client_fstech_hadaya_data_source_local_MemoryAppDatabase$stable;
  function MemoryAppDatabase() {
    AppDatabase.call(this);
    this.hzt_1 = new MemoryCartDao();
    this.izt_1 = new MemoryProductDao();
    this.jzt_1 = new MemoryBannerDao();
    this.kzt_1 = new MemoryFavoriteDao(this.izt_1);
  }
  protoOf(MemoryAppDatabase).ezt = function () {
    return this.hzt_1;
  };
  protoOf(MemoryAppDatabase).dzt = function () {
    return this.izt_1;
  };
  protoOf(MemoryAppDatabase).fzt = function () {
    return this.jzt_1;
  };
  protoOf(MemoryAppDatabase).gzt = function () {
    return this.kzt_1;
  };
  function MemoryCartDao() {
    this.lzt_1 = MutableStateFlow(emptyList());
  }
  protoOf(MemoryCartDao).mz2 = function () {
    return this.lzt_1;
  };
  protoOf(MemoryCartDao).fyz = function ($completion) {
    return this.lzt_1.u1();
  };
  protoOf(MemoryCartDao).cz0 = function (cartItem, $completion) {
    this.lzt_1.s21(plus_0(this.lzt_1.u1(), cartItem));
    return new Long(1, 0);
  };
  protoOf(MemoryCartDao).dz0 = function (cartItem, $completion) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.lzt_1.u1();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = item.fyw_1 === cartItem.fyw_1 ? cartItem : item;
      destination.j1(tmp$ret$2);
    }
    this.lzt_1.s21(destination);
    return Unit_instance;
  };
  protoOf(MemoryCartDao).sz1 = function (cartItem, $completion) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.lzt_1.u1();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (!(element.fyw_1 === cartItem.fyw_1)) {
        destination.j1(element);
      }
    }
    this.lzt_1.s21(destination);
    return Unit_instance;
  };
  protoOf(MemoryCartDao).cz2 = function ($completion) {
    this.lzt_1.s21(emptyList());
    return Unit_instance;
  };
  protoOf(MemoryCartDao).nz2 = function (productId, $completion) {
    // Inline function 'kotlin.collections.find' call
    var tmp0 = this.lzt_1.u1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.fyw_1 === productId) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  function MemoryProductDao() {
    this.mzt_1 = MutableStateFlow(emptyList());
  }
  protoOf(MemoryProductDao).uzk = function () {
    return this.mzt_1;
  };
  protoOf(MemoryProductDao).yzi = function (id, $completion) {
    // Inline function 'kotlin.collections.find' call
    var tmp0 = this.mzt_1.u1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (equals(element.nzt_1, id)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  protoOf(MemoryProductDao).zzi = function (newProducts, $completion) {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = this.mzt_1.u1();
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp0_safe_receiver = element.nzt_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.j1(tmp0_safe_receiver);
      }
    }
    var existingIds = toSet(destination);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_0 = newProducts.t();
    while (_iterator__ex2g4s_0.u()) {
      var element_0 = _iterator__ex2g4s_0.v();
      if (!contains_0(existingIds, element_0.nzt_1)) {
        destination_0.j1(element_0);
      }
    }
    var uniqueNew = destination_0;
    this.mzt_1.s21(plus(this.mzt_1.u1(), uniqueNew));
    return Unit_instance;
  };
  protoOf(MemoryProductDao).fzk = function ($completion) {
    this.mzt_1.s21(emptyList());
    return Unit_instance;
  };
  protoOf(MemoryProductDao).xzh = function (newProducts, $completion) {
    this.mzt_1.s21(newProducts);
    return Unit_instance;
  };
  function MemoryBannerDao() {
    this.xzu_1 = MutableStateFlow(emptyList());
  }
  protoOf(MemoryBannerDao).wzk = function () {
    return this.xzu_1;
  };
  protoOf(MemoryBannerDao).fzk = function ($completion) {
    this.xzu_1.s21(emptyList());
    return Unit_instance;
  };
  protoOf(MemoryBannerDao).kzi = function (newBanners, $completion) {
    this.xzu_1.s21(newBanners);
    return Unit_instance;
  };
  function MemoryFavoriteDao$getAllFavorites$o$collect$slambda($$this$unsafeFlow, $userId, resultContinuation) {
    this.gzv_1 = $$this$unsafeFlow;
    this.hzv_1 = $userId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MemoryFavoriteDao$getAllFavorites$o$collect$slambda).o2k = function (value, $completion) {
    var tmp = this.p2k(value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MemoryFavoriteDao$getAllFavorites$o$collect$slambda).ja = function (p1, $completion) {
    return this.o2k(p1, $completion);
  };
  protoOf(MemoryFavoriteDao$getAllFavorites$o$collect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.gzv_1;
            var value = this.izv_1;
            this.n9_1 = 1;
            var destination = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s = value.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              if (element.kzv_1 === this.hzv_1) {
                destination.j1(element);
              }
            }

            suspendResult = tmp0.a1v(destination, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(MemoryFavoriteDao$getAllFavorites$o$collect$slambda).p2k = function (value, completion) {
    var i = new MemoryFavoriteDao$getAllFavorites$o$collect$slambda(this.gzv_1, this.hzv_1, completion);
    i.izv_1 = value;
    return i;
  };
  function MemoryFavoriteDao$getAllFavorites$o$collect$slambda_0($$this$unsafeFlow, $userId, resultContinuation) {
    var i = new MemoryFavoriteDao$getAllFavorites$o$collect$slambda($$this$unsafeFlow, $userId, resultContinuation);
    return constructCallableReference(function (value, $completion) {
      return i.o2k(value, $completion);
    }, 1);
  }
  function $collectCOROUTINE$(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.uzv_1 = _this__u8e3s4;
    this.vzv_1 = collector;
  }
  protoOf($collectCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var $this$unsafeFlow = this.vzv_1;
            this.n9_1 = 1;
            var tmp_0 = MemoryFavoriteDao$getAllFavorites$o$collect$slambda_0($this$unsafeFlow, this.uzv_1.xzv_1, null);
            suspendResult = this.uzv_1.wzv_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function MemoryFavoriteDao$isFavorite$o$collect$slambda($$this$unsafeFlow, $productId, $userId, resultContinuation) {
    this.gzw_1 = $$this$unsafeFlow;
    this.hzw_1 = $productId;
    this.izw_1 = $userId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MemoryFavoriteDao$isFavorite$o$collect$slambda).o2k = function (value, $completion) {
    var tmp = this.p2k(value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MemoryFavoriteDao$isFavorite$o$collect$slambda).ja = function (p1, $completion) {
    return this.o2k(p1, $completion);
  };
  protoOf(MemoryFavoriteDao$isFavorite$o$collect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.gzw_1;
            var value = this.jzw_1;
            this.n9_1 = 1;
            var tmp$ret$0;
            l$ret$1: do {
              var tmp_0;
              if (isInterface(value, Collection)) {
                tmp_0 = value.r();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$0 = false;
                break l$ret$1;
              }
              var _iterator__ex2g4s = value.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (equalsLong(element.jzv_1, this.hzw_1) && element.kzv_1 === this.izw_1) {
                  tmp$ret$0 = true;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = false;
            }
             while (false);
            suspendResult = tmp0.a1v(tmp$ret$0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(MemoryFavoriteDao$isFavorite$o$collect$slambda).p2k = function (value, completion) {
    var i = new MemoryFavoriteDao$isFavorite$o$collect$slambda(this.gzw_1, this.hzw_1, this.izw_1, completion);
    i.jzw_1 = value;
    return i;
  };
  function MemoryFavoriteDao$isFavorite$o$collect$slambda_0($$this$unsafeFlow, $productId, $userId, resultContinuation) {
    var i = new MemoryFavoriteDao$isFavorite$o$collect$slambda($$this$unsafeFlow, $productId, $userId, resultContinuation);
    return constructCallableReference(function (value, $completion) {
      return i.o2k(value, $completion);
    }, 1);
  }
  function $collectCOROUTINE$_0(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.szw_1 = _this__u8e3s4;
    this.tzw_1 = collector;
  }
  protoOf($collectCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var $this$unsafeFlow = this.tzw_1;
            this.n9_1 = 1;
            var tmp_0 = MemoryFavoriteDao$isFavorite$o$collect$slambda_0($this$unsafeFlow, this.szw_1.vzw_1, this.szw_1.wzw_1, null);
            suspendResult = this.szw_1.uzw_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.xzw_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a1v = function (value, $completion) {
    return this.xzw_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).q3 = function () {
    return this.xzw_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_0(function_0) {
    this.yzw_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).a1v = function (value, $completion) {
    return this.yzw_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).q3 = function () {
    return this.yzw_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function MemoryFavoriteDao$getAllFavorites$$inlined$map$1($this, $userId) {
    this.wzv_1 = $this;
    this.xzv_1 = $userId;
  }
  protoOf(MemoryFavoriteDao$getAllFavorites$$inlined$map$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MemoryFavoriteDao$getAllFavorites$$inlined$map$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function MemoryFavoriteDao$getFavoriteProducts$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MemoryFavoriteDao$getFavoriteProducts$slambda).jzx = function (favs, prods, $completion) {
    var tmp = this.kzx(favs, prods, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MemoryFavoriteDao$getFavoriteProducts$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE();
    return this.jzx(tmp, (!(p2 == null) ? isInterface(p2, KtList) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(MemoryFavoriteDao$getFavoriteProducts$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var this_0 = this.hzx_1;
          var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.t();
          while (_iterator__ex2g4s.u()) {
            var item = _iterator__ex2g4s.v();
            destination.j1(item.jzv_1);
          }
          var favIds = toSet(destination);
          var tmp0 = this.izx_1;
          var destination_0 = ArrayList_init_$Create$_0();
          var _iterator__ex2g4s_0 = tmp0.t();
          while (_iterator__ex2g4s_0.u()) {
            var element = _iterator__ex2g4s_0.v();
            if (contains_0(favIds, element.nzt_1)) {
              destination_0.j1(element);
            }
          }
          return destination_0;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(MemoryFavoriteDao$getFavoriteProducts$slambda).kzx = function (favs, prods, completion) {
    var i = new MemoryFavoriteDao$getFavoriteProducts$slambda(completion);
    i.hzx_1 = favs;
    i.izx_1 = prods;
    return i;
  };
  function MemoryFavoriteDao$getFavoriteProducts$slambda_0(resultContinuation) {
    var i = new MemoryFavoriteDao$getFavoriteProducts$slambda(resultContinuation);
    return constructCallableReference(function (favs, prods, $completion) {
      return i.jzx(favs, prods, $completion);
    }, 2);
  }
  function MemoryFavoriteDao$isFavorite$$inlined$map$1($this, $productId, $userId) {
    this.uzw_1 = $this;
    this.vzw_1 = $productId;
    this.wzw_1 = $userId;
  }
  protoOf(MemoryFavoriteDao$isFavorite$$inlined$map$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_0(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MemoryFavoriteDao$isFavorite$$inlined$map$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function $replaceFavoritesCOROUTINE$(_this__u8e3s4, userId, newFavorites, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tzx_1 = _this__u8e3s4;
    this.uzx_1 = userId;
    this.vzx_1 = newFavorites;
  }
  protoOf($replaceFavoritesCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.tzx_1.yzx(this.uzx_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.tzx_1.xzx_1.s21(plus(this.tzx_1.xzx_1.u1(), this.vzx_1));
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function MemoryFavoriteDao(productDao) {
    this.wzx_1 = productDao;
    this.xzx_1 = MutableStateFlow(emptyList());
  }
  protoOf(MemoryFavoriteDao).zzx = function (userId) {
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = this.xzx_1;
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new MemoryFavoriteDao$getAllFavorites$$inlined$map$1(this_0, userId);
  };
  protoOf(MemoryFavoriteDao).pz5 = function (userId) {
    var tmp = this.zzx(userId);
    var tmp_0 = this.wzx_1.uzk();
    return combine(tmp, tmp_0, MemoryFavoriteDao$getFavoriteProducts$slambda_0(null));
  };
  protoOf(MemoryFavoriteDao).dz5 = function (productId, userId) {
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = this.xzx_1;
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new MemoryFavoriteDao$isFavorite$$inlined$map$1(this_0, productId, userId);
  };
  protoOf(MemoryFavoriteDao).fz6 = function (productId, userId, $completion) {
    var tmp0 = this.xzx_1.u1();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (equalsLong(element.jzv_1, productId) && element.kzv_1 === userId) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
  protoOf(MemoryFavoriteDao).gz6 = function (favorite, $completion) {
    this.xzx_1.s21(plus_0(this.xzx_1.u1(), favorite));
    return Unit_instance;
  };
  protoOf(MemoryFavoriteDao).hz6 = function (productId, userId, $completion) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.xzx_1.u1();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (!equalsLong(element.jzv_1, productId) || !(element.kzv_1 === userId)) {
        destination.j1(element);
      }
    }
    this.xzx_1.s21(destination);
    return Unit_instance;
  };
  protoOf(MemoryFavoriteDao).yzx = function (userId, $completion) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.xzx_1.u1();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (!(element.kzv_1 === userId)) {
        destination.j1(element);
      }
    }
    this.xzx_1.s21(destination);
    return Unit_instance;
  };
  protoOf(MemoryFavoriteDao).sz6 = function (userId, newFavorites, $completion) {
    var tmp = new $replaceFavoritesCOROUTINE$(this, userId, newFavorites, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function ProductDao() {
  }
  function initKoin() {
    return initKoin_0(initKoin$lambda);
  }
  function initKoin_0(appDeclaration) {
    var tmp;
    if (appDeclaration === VOID) {
      tmp = initKoin$lambda_0;
    } else {
      tmp = appDeclaration;
    }
    appDeclaration = tmp;
    return startKoin(initKoin$lambda_1(appDeclaration));
  }
  function commonModule() {
    return module_0(VOID, commonModule$lambda);
  }
  function initKoin$lambda($this$initKoin) {
    return Unit_instance;
  }
  function initKoin$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function initKoin$lambda_1($appDeclaration) {
    return function ($this$startKoin) {
      $appDeclaration($this$startKoin);
      $this$startKoin.ds3([commonModule(), platformModule()]);
      return Unit_instance;
    };
  }
  function commonModule$lambda($this$module) {
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition = commonModule$lambda$lambda;
    var scopeQualifier = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind = Kind_Singleton_getInstance();
    var secondaryTypes = emptyList();
    var def = new BeanDefinition(scopeQualifier, getKClass(SupabaseClient), null, definition, kind, secondaryTypes);
    var factory = new SingleInstanceFactory(def);
    $this$module.ns5(factory);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory);
    }
    new KoinDefinition($this$module, factory);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_0 = commonModule$lambda$lambda_0;
    var scopeQualifier_0 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_0 = Kind_Singleton_getInstance();
    var secondaryTypes_0 = emptyList();
    var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(Auth), null, definition_0, kind_0, secondaryTypes_0);
    var factory_0 = new SingleInstanceFactory(def_0);
    $this$module.ns5(factory_0);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_0);
    }
    new KoinDefinition($this$module, factory_0);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_1 = commonModule$lambda$lambda_1;
    var scopeQualifier_1 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_1 = Kind_Singleton_getInstance();
    var secondaryTypes_1 = emptyList();
    var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(Postgrest), null, definition_1, kind_1, secondaryTypes_1);
    var factory_1 = new SingleInstanceFactory(def_1);
    $this$module.ns5(factory_1);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_1);
    }
    new KoinDefinition($this$module, factory_1);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_2 = commonModule$lambda$lambda_2;
    var scopeQualifier_2 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_2 = Kind_Singleton_getInstance();
    var secondaryTypes_2 = emptyList();
    var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(Storage), null, definition_2, kind_2, secondaryTypes_2);
    var factory_2 = new SingleInstanceFactory(def_2);
    $this$module.ns5(factory_2);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_2);
    }
    new KoinDefinition($this$module, factory_2);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_3 = commonModule$lambda$lambda_3;
    var scopeQualifier_3 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_3 = Kind_Singleton_getInstance();
    var secondaryTypes_3 = emptyList();
    var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(Functions), null, definition_3, kind_3, secondaryTypes_3);
    var factory_3 = new SingleInstanceFactory(def_3);
    $this$module.ns5(factory_3);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_3);
    }
    new KoinDefinition($this$module, factory_3);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4 = commonModule$lambda$lambda_4;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_4 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_4 = Kind_Factory_getInstance();
    var secondaryTypes_4 = emptyList();
    var def_4 = new BeanDefinition(scopeQualifier_4, getKClass(SupabaseSessionManager), null, tmp4, kind_4, secondaryTypes_4);
    var factory_4 = new FactoryInstanceFactory(def_4);
    $this$module.ns5(factory_4);
    new KoinDefinition($this$module, factory_4);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_4 = commonModule$lambda$lambda_5;
    var scopeQualifier_5 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_5 = Kind_Singleton_getInstance();
    var secondaryTypes_5 = emptyList();
    var def_5 = new BeanDefinition(scopeQualifier_5, getKClass(ProductDao), null, definition_4, kind_5, secondaryTypes_5);
    var factory_5 = new SingleInstanceFactory(def_5);
    $this$module.ns5(factory_5);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_5);
    }
    new KoinDefinition($this$module, factory_5);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_5 = commonModule$lambda$lambda_6;
    var scopeQualifier_6 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_6 = Kind_Singleton_getInstance();
    var secondaryTypes_6 = emptyList();
    var def_6 = new BeanDefinition(scopeQualifier_6, getKClass(CartDao), null, definition_5, kind_6, secondaryTypes_6);
    var factory_6 = new SingleInstanceFactory(def_6);
    $this$module.ns5(factory_6);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_6);
    }
    new KoinDefinition($this$module, factory_6);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_6 = commonModule$lambda$lambda_7;
    var scopeQualifier_7 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_7 = Kind_Singleton_getInstance();
    var secondaryTypes_7 = emptyList();
    var def_7 = new BeanDefinition(scopeQualifier_7, getKClass(BannerDao), null, definition_6, kind_7, secondaryTypes_7);
    var factory_7 = new SingleInstanceFactory(def_7);
    $this$module.ns5(factory_7);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_7);
    }
    new KoinDefinition($this$module, factory_7);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_7 = commonModule$lambda$lambda_8;
    var scopeQualifier_8 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_8 = Kind_Singleton_getInstance();
    var secondaryTypes_8 = emptyList();
    var def_8 = new BeanDefinition(scopeQualifier_8, getKClass(FavoriteDao), null, definition_7, kind_8, secondaryTypes_8);
    var factory_8 = new SingleInstanceFactory(def_8);
    $this$module.ns5(factory_8);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_8);
    }
    new KoinDefinition($this$module, factory_8);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_8 = commonModule$lambda$lambda_9;
    var scopeQualifier_9 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_9 = Kind_Singleton_getInstance();
    var secondaryTypes_9 = emptyList();
    var def_9 = new BeanDefinition(scopeQualifier_9, getKClass(IProductRepository), null, definition_8, kind_9, secondaryTypes_9);
    var factory_9 = new SingleInstanceFactory(def_9);
    $this$module.ns5(factory_9);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_9);
    }
    new KoinDefinition($this$module, factory_9);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_9 = commonModule$lambda$lambda_10;
    var scopeQualifier_10 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_10 = Kind_Singleton_getInstance();
    var secondaryTypes_10 = emptyList();
    var def_10 = new BeanDefinition(scopeQualifier_10, getKClass(ICartRepository), null, definition_9, kind_10, secondaryTypes_10);
    var factory_10 = new SingleInstanceFactory(def_10);
    $this$module.ns5(factory_10);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_10);
    }
    new KoinDefinition($this$module, factory_10);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_10 = commonModule$lambda$lambda_11;
    var scopeQualifier_11 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_11 = Kind_Singleton_getInstance();
    var secondaryTypes_11 = emptyList();
    var def_11 = new BeanDefinition(scopeQualifier_11, getKClass(IFavoriteRepository), null, definition_10, kind_11, secondaryTypes_11);
    var factory_11 = new SingleInstanceFactory(def_11);
    $this$module.ns5(factory_11);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_11);
    }
    new KoinDefinition($this$module, factory_11);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_11 = commonModule$lambda$lambda_12;
    var scopeQualifier_12 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_12 = Kind_Singleton_getInstance();
    var secondaryTypes_12 = emptyList();
    var def_12 = new BeanDefinition(scopeQualifier_12, getKClass(IAuthRepository), null, definition_11, kind_12, secondaryTypes_12);
    var factory_12 = new SingleInstanceFactory(def_12);
    $this$module.ns5(factory_12);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_12);
    }
    new KoinDefinition($this$module, factory_12);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_12 = commonModule$lambda$lambda_13;
    var scopeQualifier_13 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_13 = Kind_Singleton_getInstance();
    var secondaryTypes_13 = emptyList();
    var def_13 = new BeanDefinition(scopeQualifier_13, getKClass(IFriendRepository), null, definition_12, kind_13, secondaryTypes_13);
    var factory_13 = new SingleInstanceFactory(def_13);
    $this$module.ns5(factory_13);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_13);
    }
    new KoinDefinition($this$module, factory_13);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_13 = commonModule$lambda$lambda_14;
    var scopeQualifier_14 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_14 = Kind_Singleton_getInstance();
    var secondaryTypes_14 = emptyList();
    var def_14 = new BeanDefinition(scopeQualifier_14, getKClass(IStorageRepository), null, definition_13, kind_14, secondaryTypes_14);
    var factory_14 = new SingleInstanceFactory(def_14);
    $this$module.ns5(factory_14);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_14);
    }
    new KoinDefinition($this$module, factory_14);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_14 = commonModule$lambda$lambda_15;
    var scopeQualifier_15 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_15 = Kind_Singleton_getInstance();
    var secondaryTypes_15 = emptyList();
    var def_15 = new BeanDefinition(scopeQualifier_15, getKClass(INotificationRepository), null, definition_14, kind_15, secondaryTypes_15);
    var factory_15 = new SingleInstanceFactory(def_15);
    $this$module.ns5(factory_15);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_15);
    }
    new KoinDefinition($this$module, factory_15);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_15 = commonModule$lambda$lambda_16;
    var scopeQualifier_16 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_16 = Kind_Singleton_getInstance();
    var secondaryTypes_16 = emptyList();
    var def_16 = new BeanDefinition(scopeQualifier_16, getKClass(IOrderRepository), null, definition_15, kind_16, secondaryTypes_16);
    var factory_16 = new SingleInstanceFactory(def_16);
    $this$module.ns5(factory_16);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_16);
    }
    new KoinDefinition($this$module, factory_16);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_16 = commonModule$lambda$lambda_17;
    var scopeQualifier_17 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_17 = Kind_Singleton_getInstance();
    var secondaryTypes_17 = emptyList();
    var def_17 = new BeanDefinition(scopeQualifier_17, getKClass(ISettingsRepository), null, definition_16, kind_17, secondaryTypes_17);
    var factory_17 = new SingleInstanceFactory(def_17);
    $this$module.ns5(factory_17);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_17);
    }
    new KoinDefinition($this$module, factory_17);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_17 = commonModule$lambda$lambda_18;
    var scopeQualifier_18 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_18 = Kind_Singleton_getInstance();
    var secondaryTypes_18 = emptyList();
    var def_18 = new BeanDefinition(scopeQualifier_18, getKClass(ICouponRepository), null, definition_17, kind_18, secondaryTypes_18);
    var factory_18 = new SingleInstanceFactory(def_18);
    $this$module.ns5(factory_18);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_18);
    }
    new KoinDefinition($this$module, factory_18);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_18 = commonModule$lambda$lambda_19;
    var scopeQualifier_19 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_19 = Kind_Singleton_getInstance();
    var secondaryTypes_19 = emptyList();
    var def_19 = new BeanDefinition(scopeQualifier_19, getKClass(IStockReminderRepository), null, definition_18, kind_19, secondaryTypes_19);
    var factory_19 = new SingleInstanceFactory(def_19);
    $this$module.ns5(factory_19);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_19);
    }
    new KoinDefinition($this$module, factory_19);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_0 = commonModule$lambda$lambda_20;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_20 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_20 = Kind_Factory_getInstance();
    var secondaryTypes_20 = emptyList();
    var def_20 = new BeanDefinition(scopeQualifier_20, getKClass(GetProductsUseCase), null, tmp4_0, kind_20, secondaryTypes_20);
    var factory_20 = new FactoryInstanceFactory(def_20);
    $this$module.ns5(factory_20);
    new KoinDefinition($this$module, factory_20);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_1 = commonModule$lambda$lambda_21;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_21 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_21 = Kind_Factory_getInstance();
    var secondaryTypes_21 = emptyList();
    var def_21 = new BeanDefinition(scopeQualifier_21, getKClass(GetProductByIdUseCase), null, tmp4_1, kind_21, secondaryTypes_21);
    var factory_21 = new FactoryInstanceFactory(def_21);
    $this$module.ns5(factory_21);
    new KoinDefinition($this$module, factory_21);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_2 = commonModule$lambda$lambda_22;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_22 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_22 = Kind_Factory_getInstance();
    var secondaryTypes_22 = emptyList();
    var def_22 = new BeanDefinition(scopeQualifier_22, getKClass(GetBannersUseCase), null, tmp4_2, kind_22, secondaryTypes_22);
    var factory_22 = new FactoryInstanceFactory(def_22);
    $this$module.ns5(factory_22);
    new KoinDefinition($this$module, factory_22);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_3 = commonModule$lambda$lambda_23;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_23 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_23 = Kind_Factory_getInstance();
    var secondaryTypes_23 = emptyList();
    var def_23 = new BeanDefinition(scopeQualifier_23, getKClass(GetFavoriteProductsUseCase), null, tmp4_3, kind_23, secondaryTypes_23);
    var factory_23 = new FactoryInstanceFactory(def_23);
    $this$module.ns5(factory_23);
    new KoinDefinition($this$module, factory_23);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_4 = commonModule$lambda$lambda_24;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_24 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_24 = Kind_Factory_getInstance();
    var secondaryTypes_24 = emptyList();
    var def_24 = new BeanDefinition(scopeQualifier_24, getKClass(ToggleFavoriteUseCase), null, tmp4_4, kind_24, secondaryTypes_24);
    var factory_24 = new FactoryInstanceFactory(def_24);
    $this$module.ns5(factory_24);
    new KoinDefinition($this$module, factory_24);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_5 = commonModule$lambda$lambda_25;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_25 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_25 = Kind_Factory_getInstance();
    var secondaryTypes_25 = emptyList();
    var def_25 = new BeanDefinition(scopeQualifier_25, getKClass(SyncFavoritesUseCase), null, tmp4_5, kind_25, secondaryTypes_25);
    var factory_25 = new FactoryInstanceFactory(def_25);
    $this$module.ns5(factory_25);
    new KoinDefinition($this$module, factory_25);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_6 = commonModule$lambda$lambda_26;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_26 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_26 = Kind_Factory_getInstance();
    var secondaryTypes_26 = emptyList();
    var def_26 = new BeanDefinition(scopeQualifier_26, getKClass(LoginUseCase), null, tmp4_6, kind_26, secondaryTypes_26);
    var factory_26 = new FactoryInstanceFactory(def_26);
    $this$module.ns5(factory_26);
    new KoinDefinition($this$module, factory_26);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_7 = commonModule$lambda$lambda_27;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_27 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_27 = Kind_Factory_getInstance();
    var secondaryTypes_27 = emptyList();
    var def_27 = new BeanDefinition(scopeQualifier_27, getKClass(LoginWithGoogleUseCase), null, tmp4_7, kind_27, secondaryTypes_27);
    var factory_27 = new FactoryInstanceFactory(def_27);
    $this$module.ns5(factory_27);
    new KoinDefinition($this$module, factory_27);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_8 = commonModule$lambda$lambda_28;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_28 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_28 = Kind_Factory_getInstance();
    var secondaryTypes_28 = emptyList();
    var def_28 = new BeanDefinition(scopeQualifier_28, getKClass(RegisterUseCase), null, tmp4_8, kind_28, secondaryTypes_28);
    var factory_28 = new FactoryInstanceFactory(def_28);
    $this$module.ns5(factory_28);
    new KoinDefinition($this$module, factory_28);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_9 = commonModule$lambda$lambda_29;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_29 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_29 = Kind_Factory_getInstance();
    var secondaryTypes_29 = emptyList();
    var def_29 = new BeanDefinition(scopeQualifier_29, getKClass(ResetPasswordUseCase), null, tmp4_9, kind_29, secondaryTypes_29);
    var factory_29 = new FactoryInstanceFactory(def_29);
    $this$module.ns5(factory_29);
    new KoinDefinition($this$module, factory_29);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_10 = commonModule$lambda$lambda_30;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_30 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_30 = Kind_Factory_getInstance();
    var secondaryTypes_30 = emptyList();
    var def_30 = new BeanDefinition(scopeQualifier_30, getKClass(UpdatePasswordUseCase), null, tmp4_10, kind_30, secondaryTypes_30);
    var factory_30 = new FactoryInstanceFactory(def_30);
    $this$module.ns5(factory_30);
    new KoinDefinition($this$module, factory_30);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_11 = commonModule$lambda$lambda_31;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_31 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_31 = Kind_Factory_getInstance();
    var secondaryTypes_31 = emptyList();
    var def_31 = new BeanDefinition(scopeQualifier_31, getKClass(HandleRecoveryLinkUseCase), null, tmp4_11, kind_31, secondaryTypes_31);
    var factory_31 = new FactoryInstanceFactory(def_31);
    $this$module.ns5(factory_31);
    new KoinDefinition($this$module, factory_31);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_12 = commonModule$lambda$lambda_32;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_32 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_32 = Kind_Factory_getInstance();
    var secondaryTypes_32 = emptyList();
    var def_32 = new BeanDefinition(scopeQualifier_32, getKClass(GetLanguageUseCase), null, tmp4_12, kind_32, secondaryTypes_32);
    var factory_32 = new FactoryInstanceFactory(def_32);
    $this$module.ns5(factory_32);
    new KoinDefinition($this$module, factory_32);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_13 = commonModule$lambda$lambda_33;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_33 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_33 = Kind_Factory_getInstance();
    var secondaryTypes_33 = emptyList();
    var def_33 = new BeanDefinition(scopeQualifier_33, getKClass(SetLanguageUseCase), null, tmp4_13, kind_33, secondaryTypes_33);
    var factory_33 = new FactoryInstanceFactory(def_33);
    $this$module.ns5(factory_33);
    new KoinDefinition($this$module, factory_33);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_14 = commonModule$lambda$lambda_34;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_34 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_34 = Kind_Factory_getInstance();
    var secondaryTypes_34 = emptyList();
    var def_34 = new BeanDefinition(scopeQualifier_34, getKClass(IsConnectedUseCase), null, tmp4_14, kind_34, secondaryTypes_34);
    var factory_34 = new FactoryInstanceFactory(def_34);
    $this$module.ns5(factory_34);
    new KoinDefinition($this$module, factory_34);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_15 = commonModule$lambda$lambda_35;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_35 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_35 = Kind_Factory_getInstance();
    var secondaryTypes_35 = emptyList();
    var def_35 = new BeanDefinition(scopeQualifier_35, getKClass(GetCurrentUserUseCase), null, tmp4_15, kind_35, secondaryTypes_35);
    var factory_35 = new FactoryInstanceFactory(def_35);
    $this$module.ns5(factory_35);
    new KoinDefinition($this$module, factory_35);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_16 = commonModule$lambda$lambda_36;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_36 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_36 = Kind_Factory_getInstance();
    var secondaryTypes_36 = emptyList();
    var def_36 = new BeanDefinition(scopeQualifier_36, getKClass(GetCurrentUserValueUseCase), null, tmp4_16, kind_36, secondaryTypes_36);
    var factory_36 = new FactoryInstanceFactory(def_36);
    $this$module.ns5(factory_36);
    new KoinDefinition($this$module, factory_36);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_17 = commonModule$lambda$lambda_37;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_37 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_37 = Kind_Factory_getInstance();
    var secondaryTypes_37 = emptyList();
    var def_37 = new BeanDefinition(scopeQualifier_37, getKClass(FetchProfileUseCase), null, tmp4_17, kind_37, secondaryTypes_37);
    var factory_37 = new FactoryInstanceFactory(def_37);
    $this$module.ns5(factory_37);
    new KoinDefinition($this$module, factory_37);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_18 = commonModule$lambda$lambda_38;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_38 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_38 = Kind_Factory_getInstance();
    var secondaryTypes_38 = emptyList();
    var def_38 = new BeanDefinition(scopeQualifier_38, getKClass(UpdateProfileUseCase), null, tmp4_18, kind_38, secondaryTypes_38);
    var factory_38 = new FactoryInstanceFactory(def_38);
    $this$module.ns5(factory_38);
    new KoinDefinition($this$module, factory_38);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_19 = commonModule$lambda$lambda_39;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_39 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_39 = Kind_Factory_getInstance();
    var secondaryTypes_39 = emptyList();
    var def_39 = new BeanDefinition(scopeQualifier_39, getKClass(UpdateFcmTokenUseCase), null, tmp4_19, kind_39, secondaryTypes_39);
    var factory_39 = new FactoryInstanceFactory(def_39);
    $this$module.ns5(factory_39);
    new KoinDefinition($this$module, factory_39);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_20 = commonModule$lambda$lambda_40;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_40 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_40 = Kind_Factory_getInstance();
    var secondaryTypes_40 = emptyList();
    var def_40 = new BeanDefinition(scopeQualifier_40, getKClass(NotifyAdminUseCase), null, tmp4_20, kind_40, secondaryTypes_40);
    var factory_40 = new FactoryInstanceFactory(def_40);
    $this$module.ns5(factory_40);
    new KoinDefinition($this$module, factory_40);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_21 = commonModule$lambda$lambda_41;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_41 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_41 = Kind_Factory_getInstance();
    var secondaryTypes_41 = emptyList();
    var def_41 = new BeanDefinition(scopeQualifier_41, getKClass(AddToCartUseCase), null, tmp4_21, kind_41, secondaryTypes_41);
    var factory_41 = new FactoryInstanceFactory(def_41);
    $this$module.ns5(factory_41);
    new KoinDefinition($this$module, factory_41);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_22 = commonModule$lambda$lambda_42;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_42 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_42 = Kind_Factory_getInstance();
    var secondaryTypes_42 = emptyList();
    var def_42 = new BeanDefinition(scopeQualifier_42, getKClass(GetCartItemsUseCase), null, tmp4_22, kind_42, secondaryTypes_42);
    var factory_42 = new FactoryInstanceFactory(def_42);
    $this$module.ns5(factory_42);
    new KoinDefinition($this$module, factory_42);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_23 = commonModule$lambda$lambda_43;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_43 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_43 = Kind_Factory_getInstance();
    var secondaryTypes_43 = emptyList();
    var def_43 = new BeanDefinition(scopeQualifier_43, getKClass(SyncCartUseCase), null, tmp4_23, kind_43, secondaryTypes_43);
    var factory_43 = new FactoryInstanceFactory(def_43);
    $this$module.ns5(factory_43);
    new KoinDefinition($this$module, factory_43);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_24 = commonModule$lambda$lambda_44;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_44 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_44 = Kind_Factory_getInstance();
    var secondaryTypes_44 = emptyList();
    var def_44 = new BeanDefinition(scopeQualifier_44, getKClass(UpdateCartQuantityUseCase), null, tmp4_24, kind_44, secondaryTypes_44);
    var factory_44 = new FactoryInstanceFactory(def_44);
    $this$module.ns5(factory_44);
    new KoinDefinition($this$module, factory_44);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_25 = commonModule$lambda$lambda_45;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_45 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_45 = Kind_Factory_getInstance();
    var secondaryTypes_45 = emptyList();
    var def_45 = new BeanDefinition(scopeQualifier_45, getKClass(RemoveFromCartUseCase), null, tmp4_25, kind_45, secondaryTypes_45);
    var factory_45 = new FactoryInstanceFactory(def_45);
    $this$module.ns5(factory_45);
    new KoinDefinition($this$module, factory_45);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_26 = commonModule$lambda$lambda_46;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_46 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_46 = Kind_Factory_getInstance();
    var secondaryTypes_46 = emptyList();
    var def_46 = new BeanDefinition(scopeQualifier_46, getKClass(ClearCartUseCase), null, tmp4_26, kind_46, secondaryTypes_46);
    var factory_46 = new FactoryInstanceFactory(def_46);
    $this$module.ns5(factory_46);
    new KoinDefinition($this$module, factory_46);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_27 = commonModule$lambda$lambda_47;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_47 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_47 = Kind_Factory_getInstance();
    var secondaryTypes_47 = emptyList();
    var def_47 = new BeanDefinition(scopeQualifier_47, getKClass(GetCartItemByIdUseCase), null, tmp4_27, kind_47, secondaryTypes_47);
    var factory_47 = new FactoryInstanceFactory(def_47);
    $this$module.ns5(factory_47);
    new KoinDefinition($this$module, factory_47);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_28 = commonModule$lambda$lambda_48;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_48 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_48 = Kind_Factory_getInstance();
    var secondaryTypes_48 = emptyList();
    var def_48 = new BeanDefinition(scopeQualifier_48, getKClass(GetFriendsUseCase), null, tmp4_28, kind_48, secondaryTypes_48);
    var factory_48 = new FactoryInstanceFactory(def_48);
    $this$module.ns5(factory_48);
    new KoinDefinition($this$module, factory_48);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_29 = commonModule$lambda$lambda_49;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_49 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_49 = Kind_Factory_getInstance();
    var secondaryTypes_49 = emptyList();
    var def_49 = new BeanDefinition(scopeQualifier_49, getKClass(AddFriendUseCase), null, tmp4_29, kind_49, secondaryTypes_49);
    var factory_49 = new FactoryInstanceFactory(def_49);
    $this$module.ns5(factory_49);
    new KoinDefinition($this$module, factory_49);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_30 = commonModule$lambda$lambda_50;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_50 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_50 = Kind_Factory_getInstance();
    var secondaryTypes_50 = emptyList();
    var def_50 = new BeanDefinition(scopeQualifier_50, getKClass(UpdateFriendUseCase), null, tmp4_30, kind_50, secondaryTypes_50);
    var factory_50 = new FactoryInstanceFactory(def_50);
    $this$module.ns5(factory_50);
    new KoinDefinition($this$module, factory_50);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_31 = commonModule$lambda$lambda_51;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_51 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_51 = Kind_Factory_getInstance();
    var secondaryTypes_51 = emptyList();
    var def_51 = new BeanDefinition(scopeQualifier_51, getKClass(DeleteFriendUseCase), null, tmp4_31, kind_51, secondaryTypes_51);
    var factory_51 = new FactoryInstanceFactory(def_51);
    $this$module.ns5(factory_51);
    new KoinDefinition($this$module, factory_51);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_32 = commonModule$lambda$lambda_52;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_52 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_52 = Kind_Factory_getInstance();
    var secondaryTypes_52 = emptyList();
    var def_52 = new BeanDefinition(scopeQualifier_52, getKClass(UploadFriendAvatarUseCase), null, tmp4_32, kind_52, secondaryTypes_52);
    var factory_52 = new FactoryInstanceFactory(def_52);
    $this$module.ns5(factory_52);
    new KoinDefinition($this$module, factory_52);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_33 = commonModule$lambda$lambda_53;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_53 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_53 = Kind_Factory_getInstance();
    var secondaryTypes_53 = emptyList();
    var def_53 = new BeanDefinition(scopeQualifier_53, getKClass(DeleteFriendAvatarUseCase), null, tmp4_33, kind_53, secondaryTypes_53);
    var factory_53 = new FactoryInstanceFactory(def_53);
    $this$module.ns5(factory_53);
    new KoinDefinition($this$module, factory_53);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_34 = commonModule$lambda$lambda_54;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_54 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_54 = Kind_Factory_getInstance();
    var secondaryTypes_54 = emptyList();
    var def_54 = new BeanDefinition(scopeQualifier_54, getKClass(UploadDesignImageUseCase), null, tmp4_34, kind_54, secondaryTypes_54);
    var factory_54 = new FactoryInstanceFactory(def_54);
    $this$module.ns5(factory_54);
    new KoinDefinition($this$module, factory_54);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_35 = commonModule$lambda$lambda_55;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_55 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_55 = Kind_Factory_getInstance();
    var secondaryTypes_55 = emptyList();
    var def_55 = new BeanDefinition(scopeQualifier_55, getKClass(DownloadDesignImageUseCase), null, tmp4_35, kind_55, secondaryTypes_55);
    var factory_55 = new FactoryInstanceFactory(def_55);
    $this$module.ns5(factory_55);
    new KoinDefinition($this$module, factory_55);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_19 = commonModule$lambda$lambda_56;
    var scopeQualifier_56 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_56 = Kind_Singleton_getInstance();
    var secondaryTypes_56 = emptyList();
    var def_56 = new BeanDefinition(scopeQualifier_56, getKClass(LanguageSwitcher), null, definition_19, kind_56, secondaryTypes_56);
    var factory_56 = new SingleInstanceFactory(def_56);
    $this$module.ns5(factory_56);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_56);
    }
    new KoinDefinition($this$module, factory_56);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_20 = commonModule$lambda$lambda_57;
    var scopeQualifier_57 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_57 = Kind_Singleton_getInstance();
    var secondaryTypes_57 = emptyList();
    var def_57 = new BeanDefinition(scopeQualifier_57, getKClass(LanguageStorage), null, definition_20, kind_57, secondaryTypes_57);
    var factory_57 = new SingleInstanceFactory(def_57);
    $this$module.ns5(factory_57);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_57);
    }
    new KoinDefinition($this$module, factory_57);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_21 = commonModule$lambda$lambda_58;
    var scopeQualifier_58 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_58 = Kind_Singleton_getInstance();
    var secondaryTypes_58 = emptyList();
    var def_58 = new BeanDefinition(scopeQualifier_58, getKClass(AuthNavigator), null, definition_21, kind_58, secondaryTypes_58);
    var factory_58 = new SingleInstanceFactory(def_58);
    $this$module.ns5(factory_58);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_58);
    }
    new KoinDefinition($this$module, factory_58);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_36 = commonModule$lambda$lambda_59;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_59 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_59 = Kind_Factory_getInstance();
    var secondaryTypes_59 = emptyList();
    var def_59 = new BeanDefinition(scopeQualifier_59, getKClass(PlaceOrderUseCase), null, tmp4_36, kind_59, secondaryTypes_59);
    var factory_59 = new FactoryInstanceFactory(def_59);
    $this$module.ns5(factory_59);
    new KoinDefinition($this$module, factory_59);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_37 = commonModule$lambda$lambda_60;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_60 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_60 = Kind_Factory_getInstance();
    var secondaryTypes_60 = emptyList();
    var def_60 = new BeanDefinition(scopeQualifier_60, getKClass(GetOrderHistoryUseCase), null, tmp4_37, kind_60, secondaryTypes_60);
    var factory_60 = new FactoryInstanceFactory(def_60);
    $this$module.ns5(factory_60);
    new KoinDefinition($this$module, factory_60);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_38 = commonModule$lambda$lambda_61;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_61 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_61 = Kind_Factory_getInstance();
    var secondaryTypes_61 = emptyList();
    var def_61 = new BeanDefinition(scopeQualifier_61, getKClass(GetOrderByIdUseCase), null, tmp4_38, kind_61, secondaryTypes_61);
    var factory_61 = new FactoryInstanceFactory(def_61);
    $this$module.ns5(factory_61);
    new KoinDefinition($this$module, factory_61);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_39 = commonModule$lambda$lambda_62;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_62 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_62 = Kind_Factory_getInstance();
    var secondaryTypes_62 = emptyList();
    var def_62 = new BeanDefinition(scopeQualifier_62, getKClass(RequestReturnUseCase), null, tmp4_39, kind_62, secondaryTypes_62);
    var factory_62 = new FactoryInstanceFactory(def_62);
    $this$module.ns5(factory_62);
    new KoinDefinition($this$module, factory_62);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_40 = commonModule$lambda$lambda_63;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_63 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_63 = Kind_Factory_getInstance();
    var secondaryTypes_63 = emptyList();
    var def_63 = new BeanDefinition(scopeQualifier_63, getKClass(GetShippingCostUseCase), null, tmp4_40, kind_63, secondaryTypes_63);
    var factory_63 = new FactoryInstanceFactory(def_63);
    $this$module.ns5(factory_63);
    new KoinDefinition($this$module, factory_63);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_41 = commonModule$lambda$lambda_64;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_64 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_64 = Kind_Factory_getInstance();
    var secondaryTypes_64 = emptyList();
    var def_64 = new BeanDefinition(scopeQualifier_64, getKClass(CheckUpdateUseCase), null, tmp4_41, kind_64, secondaryTypes_64);
    var factory_64 = new FactoryInstanceFactory(def_64);
    $this$module.ns5(factory_64);
    new KoinDefinition($this$module, factory_64);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_42 = commonModule$lambda$lambda_65;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_65 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_65 = Kind_Factory_getInstance();
    var secondaryTypes_65 = emptyList();
    var def_65 = new BeanDefinition(scopeQualifier_65, getKClass(ApplyCouponUseCase), null, tmp4_42, kind_65, secondaryTypes_65);
    var factory_65 = new FactoryInstanceFactory(def_65);
    $this$module.ns5(factory_65);
    new KoinDefinition($this$module, factory_65);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_43 = commonModule$lambda$lambda_66;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_66 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_66 = Kind_Factory_getInstance();
    var secondaryTypes_66 = emptyList();
    var def_66 = new BeanDefinition(scopeQualifier_66, getKClass(MarkCouponAsUsedUseCase), null, tmp4_43, kind_66, secondaryTypes_66);
    var factory_66 = new FactoryInstanceFactory(def_66);
    $this$module.ns5(factory_66);
    new KoinDefinition($this$module, factory_66);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_44 = commonModule$lambda$lambda_67;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_67 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_67 = Kind_Factory_getInstance();
    var secondaryTypes_67 = emptyList();
    var def_67 = new BeanDefinition(scopeQualifier_67, getKClass(GetUserCouponsUseCase), null, tmp4_44, kind_67, secondaryTypes_67);
    var factory_67 = new FactoryInstanceFactory(def_67);
    $this$module.ns5(factory_67);
    new KoinDefinition($this$module, factory_67);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_45 = commonModule$lambda$lambda_68;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_68 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_68 = Kind_Factory_getInstance();
    var secondaryTypes_68 = emptyList();
    var def_68 = new BeanDefinition(scopeQualifier_68, getKClass(CreateWelcomeCouponUseCase), null, tmp4_45, kind_68, secondaryTypes_68);
    var factory_68 = new FactoryInstanceFactory(def_68);
    $this$module.ns5(factory_68);
    new KoinDefinition($this$module, factory_68);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_46 = commonModule$lambda$lambda_69;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_69 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_69 = Kind_Factory_getInstance();
    var secondaryTypes_69 = emptyList();
    var def_69 = new BeanDefinition(scopeQualifier_69, getKClass(ToggleStockReminderUseCase), null, tmp4_46, kind_69, secondaryTypes_69);
    var factory_69 = new FactoryInstanceFactory(def_69);
    $this$module.ns5(factory_69);
    new KoinDefinition($this$module, factory_69);
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_47 = commonModule$lambda$lambda_70;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_70 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_70 = Kind_Factory_getInstance();
    var secondaryTypes_70 = emptyList();
    var def_70 = new BeanDefinition(scopeQualifier_70, getKClass(GetStockRemindersUseCase), null, tmp4_47, kind_70, secondaryTypes_70);
    var factory_70 = new FactoryInstanceFactory(def_70);
    $this$module.ns5(factory_70);
    new KoinDefinition($this$module, factory_70);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_22 = commonModule$lambda$lambda_71;
    var scopeQualifier_71 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_71 = Kind_Singleton_getInstance();
    var secondaryTypes_71 = emptyList();
    var def_71 = new BeanDefinition(scopeQualifier_71, getKClass(AppViewModel), null, definition_22, kind_71, secondaryTypes_71);
    var factory_71 = new SingleInstanceFactory(def_71);
    $this$module.ns5(factory_71);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_71);
    }
    new KoinDefinition($this$module, factory_71);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_48 = commonModule$lambda$lambda_72;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_72 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_72 = Kind_Factory_getInstance();
    var secondaryTypes_72 = emptyList();
    var def_72 = new BeanDefinition(scopeQualifier_72, getKClass(ShoppingViewModel), null, tmp4_48, kind_72, secondaryTypes_72);
    var factory_72 = new FactoryInstanceFactory(def_72);
    $this$module.ns5(factory_72);
    new KoinDefinition($this$module, factory_72);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_49 = commonModule$lambda$lambda_73;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_73 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_73 = Kind_Factory_getInstance();
    var secondaryTypes_73 = emptyList();
    var def_73 = new BeanDefinition(scopeQualifier_73, getKClass(AuthViewModel), null, tmp4_49, kind_73, secondaryTypes_73);
    var factory_73 = new FactoryInstanceFactory(def_73);
    $this$module.ns5(factory_73);
    new KoinDefinition($this$module, factory_73);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_50 = commonModule$lambda$lambda_74;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_74 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_74 = Kind_Factory_getInstance();
    var secondaryTypes_74 = emptyList();
    var def_74 = new BeanDefinition(scopeQualifier_74, getKClass(CartViewModel), null, tmp4_50, kind_74, secondaryTypes_74);
    var factory_74 = new FactoryInstanceFactory(def_74);
    $this$module.ns5(factory_74);
    new KoinDefinition($this$module, factory_74);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_51 = commonModule$lambda$lambda_75;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_75 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_75 = Kind_Factory_getInstance();
    var secondaryTypes_75 = emptyList();
    var def_75 = new BeanDefinition(scopeQualifier_75, getKClass(CartNormalProductDetailsViewModel), null, tmp4_51, kind_75, secondaryTypes_75);
    var factory_75 = new FactoryInstanceFactory(def_75);
    $this$module.ns5(factory_75);
    new KoinDefinition($this$module, factory_75);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_52 = commonModule$lambda$lambda_76;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_76 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_76 = Kind_Factory_getInstance();
    var secondaryTypes_76 = emptyList();
    var def_76 = new BeanDefinition(scopeQualifier_76, getKClass(CartMugProductDetailsViewModel), null, tmp4_52, kind_76, secondaryTypes_76);
    var factory_76 = new FactoryInstanceFactory(def_76);
    $this$module.ns5(factory_76);
    new KoinDefinition($this$module, factory_76);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_53 = commonModule$lambda$lambda_77;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_77 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_77 = Kind_Factory_getInstance();
    var secondaryTypes_77 = emptyList();
    var def_77 = new BeanDefinition(scopeQualifier_77, getKClass(CartMagicMugProductDetailsViewModel), null, tmp4_53, kind_77, secondaryTypes_77);
    var factory_77 = new FactoryInstanceFactory(def_77);
    $this$module.ns5(factory_77);
    new KoinDefinition($this$module, factory_77);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_54 = commonModule$lambda$lambda_78;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_78 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_78 = Kind_Factory_getInstance();
    var secondaryTypes_78 = emptyList();
    var def_78 = new BeanDefinition(scopeQualifier_78, getKClass(FavoritesViewModel), null, tmp4_54, kind_78, secondaryTypes_78);
    var factory_78 = new FactoryInstanceFactory(def_78);
    $this$module.ns5(factory_78);
    new KoinDefinition($this$module, factory_78);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_55 = commonModule$lambda$lambda_79;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_79 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_79 = Kind_Factory_getInstance();
    var secondaryTypes_79 = emptyList();
    var def_79 = new BeanDefinition(scopeQualifier_79, getKClass(StockRemindersViewModel), null, tmp4_55, kind_79, secondaryTypes_79);
    var factory_79 = new FactoryInstanceFactory(def_79);
    $this$module.ns5(factory_79);
    new KoinDefinition($this$module, factory_79);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_56 = commonModule$lambda$lambda_80;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_80 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_80 = Kind_Factory_getInstance();
    var secondaryTypes_80 = emptyList();
    var def_80 = new BeanDefinition(scopeQualifier_80, getKClass(ProductDetailsViewModel), null, tmp4_56, kind_80, secondaryTypes_80);
    var factory_80 = new FactoryInstanceFactory(def_80);
    $this$module.ns5(factory_80);
    new KoinDefinition($this$module, factory_80);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_57 = commonModule$lambda$lambda_81;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_81 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_81 = Kind_Factory_getInstance();
    var secondaryTypes_81 = emptyList();
    var def_81 = new BeanDefinition(scopeQualifier_81, getKClass(BeadsProductDetailsViewModel), null, tmp4_57, kind_81, secondaryTypes_81);
    var factory_81 = new FactoryInstanceFactory(def_81);
    $this$module.ns5(factory_81);
    new KoinDefinition($this$module, factory_81);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_58 = commonModule$lambda$lambda_82;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_82 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_82 = Kind_Factory_getInstance();
    var secondaryTypes_82 = emptyList();
    var def_82 = new BeanDefinition(scopeQualifier_82, getKClass(CustomProductDetailsViewModel), null, tmp4_58, kind_82, secondaryTypes_82);
    var factory_82 = new FactoryInstanceFactory(def_82);
    $this$module.ns5(factory_82);
    new KoinDefinition($this$module, factory_82);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_59 = commonModule$lambda$lambda_83;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_83 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_83 = Kind_Factory_getInstance();
    var secondaryTypes_83 = emptyList();
    var def_83 = new BeanDefinition(scopeQualifier_83, getKClass(CheckoutViewModel), null, tmp4_59, kind_83, secondaryTypes_83);
    var factory_83 = new FactoryInstanceFactory(def_83);
    $this$module.ns5(factory_83);
    new KoinDefinition($this$module, factory_83);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_60 = commonModule$lambda$lambda_84;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_84 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_84 = Kind_Factory_getInstance();
    var secondaryTypes_84 = emptyList();
    var def_84 = new BeanDefinition(scopeQualifier_84, getKClass(CouponsViewModel), null, tmp4_60, kind_84, secondaryTypes_84);
    var factory_84 = new FactoryInstanceFactory(def_84);
    $this$module.ns5(factory_84);
    new KoinDefinition($this$module, factory_84);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_61 = commonModule$lambda$lambda_85;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_85 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_85 = Kind_Factory_getInstance();
    var secondaryTypes_85 = emptyList();
    var def_85 = new BeanDefinition(scopeQualifier_85, getKClass(FriendsViewModel), null, tmp4_61, kind_85, secondaryTypes_85);
    var factory_85 = new FactoryInstanceFactory(def_85);
    $this$module.ns5(factory_85);
    new KoinDefinition($this$module, factory_85);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_62 = commonModule$lambda$lambda_86;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_86 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_86 = Kind_Factory_getInstance();
    var secondaryTypes_86 = emptyList();
    var def_86 = new BeanDefinition(scopeQualifier_86, getKClass(ModelMugViewModel), null, tmp4_62, kind_86, secondaryTypes_86);
    var factory_86 = new FactoryInstanceFactory(def_86);
    $this$module.ns5(factory_86);
    new KoinDefinition($this$module, factory_86);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_63 = commonModule$lambda$lambda_87;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_87 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_87 = Kind_Factory_getInstance();
    var secondaryTypes_87 = emptyList();
    var def_87 = new BeanDefinition(scopeQualifier_87, getKClass(OrderViewModel), null, tmp4_63, kind_87, secondaryTypes_87);
    var factory_87 = new FactoryInstanceFactory(def_87);
    $this$module.ns5(factory_87);
    new KoinDefinition($this$module, factory_87);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_64 = commonModule$lambda$lambda_88;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_88 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_88 = Kind_Factory_getInstance();
    var secondaryTypes_88 = emptyList();
    var def_88 = new BeanDefinition(scopeQualifier_88, getKClass(OrderDetailsViewModel), null, tmp4_64, kind_88, secondaryTypes_88);
    var factory_88 = new FactoryInstanceFactory(def_88);
    $this$module.ns5(factory_88);
    new KoinDefinition($this$module, factory_88);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_65 = commonModule$lambda$lambda_89;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_89 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_89 = Kind_Factory_getInstance();
    var secondaryTypes_89 = emptyList();
    var def_89 = new BeanDefinition(scopeQualifier_89, getKClass(OrderHistoryViewModel), null, tmp4_65, kind_89, secondaryTypes_89);
    var factory_89 = new FactoryInstanceFactory(def_89);
    $this$module.ns5(factory_89);
    new KoinDefinition($this$module, factory_89);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_66 = commonModule$lambda$lambda_90;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_90 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_90 = Kind_Factory_getInstance();
    var secondaryTypes_90 = emptyList();
    var def_90 = new BeanDefinition(scopeQualifier_90, getKClass(AccountManagementViewModel), null, tmp4_66, kind_90, secondaryTypes_90);
    var factory_90 = new FactoryInstanceFactory(def_90);
    $this$module.ns5(factory_90);
    new KoinDefinition($this$module, factory_90);
    // Inline function 'org.koin.core.module.dsl.viewModel' call
    // Inline function 'org.koin.core.module.Module.factory' call
    var tmp4_67 = commonModule$lambda$lambda_91;
    // Inline function 'org.koin.core.module.Module.factory' call
    // Inline function 'org.koin.core.module._factoryInstanceFactory' call
    var scopeQualifier_91 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_91 = Kind_Factory_getInstance();
    var secondaryTypes_91 = emptyList();
    var def_91 = new BeanDefinition(scopeQualifier_91, getKClass(EditMugDesignViewModel), null, tmp4_67, kind_91, secondaryTypes_91);
    var factory_91 = new FactoryInstanceFactory(def_91);
    $this$module.ns5(factory_91);
    new KoinDefinition($this$module, factory_91);
    return Unit_instance;
  }
  function commonModule$lambda$lambda($this$single, it) {
    var tmp0 = 'https://obujqoowtjzxwqpyqinh.supabase.co';
    // Inline function 'io.github.jan.supabase.createSupabaseClient' call
    var supabaseKey = 'sb_publishable_UOeck9hhXwMgZOxCYGRMsQ_gWQAFz9a';
    // Inline function 'kotlin.apply' call
    var this_0 = new SupabaseClientBuilder(tmp0, supabaseKey);
    var tmp = Companion_getInstance_5();
    this_0.nvl(tmp, commonModule$lambda$lambda$lambda($this$single));
    this_0.qvl(Companion_getInstance_6());
    this_0.qvl(Companion_getInstance_7());
    this_0.qvl(Companion_getInstance_8());
    this_0.qvl(Companion_getInstance_9());
    var tmp_0 = this_0;
    tmp_0.evl_1 = new KotlinXSerializer(Json(VOID, commonModule$lambda$lambda$lambda_0));
    return this_0.lvl();
  }
  function commonModule$lambda$lambda$lambda($this_single) {
    return function ($this$install) {
      var tmp = $this$install;
      // Inline function 'org.koin.core.scope.Scope.get' call
      tmp.evx_1 = $this_single.ss6(getKClass(SupabaseSessionManager), null, null);
      return Unit_instance;
    };
  }
  function commonModule$lambda$lambda$lambda_0($this$Json) {
    $this$Json.fmh_1 = true;
    $this$Json.emh_1 = false;
    $this$Json.dmh_1 = true;
    return Unit_instance;
  }
  function commonModule$lambda$lambda_0($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.ss6(getKClass(SupabaseClient), null, null);
    return get_auth(tmp$ret$0);
  }
  function commonModule$lambda$lambda_1($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.ss6(getKClass(SupabaseClient), null, null);
    return get_postgrest(tmp$ret$0);
  }
  function commonModule$lambda$lambda_2($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.ss6(getKClass(SupabaseClient), null, null);
    return get_storage(tmp$ret$0);
  }
  function commonModule$lambda$lambda_3($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.ss6(getKClass(SupabaseClient), null, null);
    return get_functions(tmp$ret$0);
  }
  function commonModule$lambda$lambda_4($this$factory, it) {
    return new SupabaseSessionManager();
  }
  function commonModule$lambda$lambda_5($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    return $this$single.ss6(getKClass(AppDatabase), null, null).dzt();
  }
  function commonModule$lambda$lambda_6($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    return $this$single.ss6(getKClass(AppDatabase), null, null).ezt();
  }
  function commonModule$lambda$lambda_7($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    return $this$single.ss6(getKClass(AppDatabase), null, null).fzt();
  }
  function commonModule$lambda$lambda_8($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    return $this$single.ss6(getKClass(AppDatabase), null, null).gzt();
  }
  function commonModule$lambda$lambda_9($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$single.ss6(getKClass(ProductDao), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$single.ss6(getKClass(BannerDao), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$2 = $this$single.ss6(getKClass(SupabaseClient), null, null);
    return new ProductRepositoryImpl(tmp, tmp_0, tmp$ret$2);
  }
  function commonModule$lambda$lambda_10($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$single.ss6(getKClass(Postgrest), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$single.ss6(getKClass(Auth), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$single.ss6(getKClass(CartDao), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$single.ss6(getKClass(IStorageRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$4 = $this$single.ss6(getKClass(NetworkObserver), null, null);
    return new CartRepositoryImpl(tmp, tmp_0, tmp_1, tmp_2, tmp$ret$4);
  }
  function commonModule$lambda$lambda_11($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$single.ss6(getKClass(FavoriteDao), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$single.ss6(getKClass(IAuthRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$2 = $this$single.ss6(getKClass(Postgrest), null, null);
    return new FavoriteRepositoryImpl(tmp, tmp_0, tmp$ret$2);
  }
  function commonModule$lambda$lambda_12($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$single.ss6(getKClass(Auth), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$single.ss6(getKClass(Postgrest), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$single.ss6(getKClass(Storage), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$single.ss6(getKClass(LanguageSwitcher), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$single.ss6(getKClass(LanguageStorage), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_4 = $this$single.ss6(getKClass(ICartRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_5 = $this$single.ss6(getKClass(IProductRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_6 = $this$single.ss6(getKClass(ISettingsRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_7 = $this$single.ss6(getKClass(CreateWelcomeCouponUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$9 = $this$single.ss6(getKClass(Functions), null, null);
    return new AuthRepositoryImpl(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp$ret$9);
  }
  function commonModule$lambda$lambda_13($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$single.ss6(getKClass(Postgrest), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$single.ss6(getKClass(Auth), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$2 = $this$single.ss6(getKClass(Storage), null, null);
    return new FriendRepositoryImpl(tmp, tmp_0, tmp$ret$2);
  }
  function commonModule$lambda$lambda_14($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.ss6(getKClass(Storage), null, null);
    return new StorageRepositoryImpl(tmp$ret$0);
  }
  function commonModule$lambda$lambda_15($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$single.ss6(getKClass(Postgrest), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$single.ss6(getKClass(Functions), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$2 = $this$single.ss6(getKClass(Auth), null, null);
    return new NotificationRepositoryImpl(tmp, tmp_0, tmp$ret$2);
  }
  function commonModule$lambda$lambda_16($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$single.ss6(getKClass(Postgrest), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$1 = $this$single.ss6(getKClass(INotificationRepository), null, null);
    return new OrderRepositoryImpl(tmp, tmp$ret$1);
  }
  function commonModule$lambda$lambda_17($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.ss6(getKClass(Postgrest), null, null);
    return new SettingsRepositoryImpl(tmp$ret$0);
  }
  function commonModule$lambda$lambda_18($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.ss6(getKClass(Postgrest), null, null);
    return new CouponRepositoryImpl(tmp$ret$0);
  }
  function commonModule$lambda$lambda_19($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$single.ss6(getKClass(IAuthRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$1 = $this$single.ss6(getKClass(Postgrest), null, null);
    return new StockReminderRepositoryImpl(tmp, tmp$ret$1);
  }
  function commonModule$lambda$lambda_20($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IProductRepository), null, null);
    return new GetProductsUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_21($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IProductRepository), null, null);
    return new GetProductByIdUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_22($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IProductRepository), null, null);
    return new GetBannersUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_23($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IFavoriteRepository), null, null);
    return new GetFavoriteProductsUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_24($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IFavoriteRepository), null, null);
    return new ToggleFavoriteUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_25($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IFavoriteRepository), null, null);
    return new SyncFavoritesUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_26($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IAuthRepository), null, null);
    return new LoginUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_27($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IAuthRepository), null, null);
    return new LoginWithGoogleUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_28($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IAuthRepository), null, null);
    return new RegisterUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_29($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IAuthRepository), null, null);
    return new ResetPasswordUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_30($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IAuthRepository), null, null);
    return new UpdatePasswordUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_31($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IAuthRepository), null, null);
    return new HandleRecoveryLinkUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_32($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IAuthRepository), null, null);
    return new GetLanguageUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_33($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IAuthRepository), null, null);
    return new SetLanguageUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_34($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(NetworkObserver), null, null);
    return new IsConnectedUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_35($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IAuthRepository), null, null);
    return new GetCurrentUserUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_36($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IAuthRepository), null, null);
    return new GetCurrentUserValueUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_37($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IAuthRepository), null, null);
    return new FetchProfileUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_38($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IAuthRepository), null, null);
    return new UpdateProfileUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_39($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IAuthRepository), null, null);
    return new UpdateFcmTokenUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_40($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(INotificationRepository), null, null);
    return new NotifyAdminUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_41($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(ICartRepository), null, null);
    return new AddToCartUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_42($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(ICartRepository), null, null);
    return new GetCartItemsUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_43($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(ICartRepository), null, null);
    return new SyncCartUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_44($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(ICartRepository), null, null);
    return new UpdateCartQuantityUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_45($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(ICartRepository), null, null);
    return new RemoveFromCartUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_46($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(ICartRepository), null, null);
    return new ClearCartUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_47($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(ICartRepository), null, null);
    return new GetCartItemByIdUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_48($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IFriendRepository), null, null);
    return new GetFriendsUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_49($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IFriendRepository), null, null);
    return new AddFriendUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_50($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IFriendRepository), null, null);
    return new UpdateFriendUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_51($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IFriendRepository), null, null);
    return new DeleteFriendUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_52($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IFriendRepository), null, null);
    return new UploadFriendAvatarUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_53($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IFriendRepository), null, null);
    return new DeleteFriendAvatarUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_54($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IStorageRepository), null, null);
    return new UploadDesignImageUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_55($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IStorageRepository), null, null);
    return new DownloadDesignImageUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_56($this$single, it) {
    return new LanguageSwitcher();
  }
  function commonModule$lambda$lambda_57($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.ss6(getKClass(LanguageSwitcher), null, null);
    return new LanguageStorage(tmp$ret$0.nyv());
  }
  function commonModule$lambda$lambda_58($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$single.ss6(getKClass(AppViewModel), null, null);
    return new AuthNavigatorImpl(tmp$ret$0);
  }
  function commonModule$lambda$lambda_59($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$factory.ss6(getKClass(IOrderRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$factory.ss6(getKClass(MarkCouponAsUsedUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$2 = $this$factory.ss6(getKClass(UploadDesignImageUseCase), null, null);
    return new PlaceOrderUseCase(tmp, tmp_0, tmp$ret$2);
  }
  function commonModule$lambda$lambda_60($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IOrderRepository), null, null);
    return new GetOrderHistoryUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_61($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IOrderRepository), null, null);
    return new GetOrderByIdUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_62($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IOrderRepository), null, null);
    return new RequestReturnUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_63($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(ISettingsRepository), null, null);
    return new GetShippingCostUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_64($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(ISettingsRepository), null, null);
    return new CheckUpdateUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_65($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(ICouponRepository), null, null);
    return new ApplyCouponUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_66($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(ICouponRepository), null, null);
    return new MarkCouponAsUsedUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_67($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(ICouponRepository), null, null);
    return new GetUserCouponsUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_68($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(ICouponRepository), null, null);
    return new CreateWelcomeCouponUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_69($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IStockReminderRepository), null, null);
    return new ToggleStockReminderUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_70($this$factory, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$factory.ss6(getKClass(IStockReminderRepository), null, null);
    return new GetStockRemindersUseCase(tmp$ret$0);
  }
  function commonModule$lambda$lambda_71($this$single, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$single.ss6(getKClass(GetCurrentUserUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$single.ss6(getKClass(SyncCartUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$single.ss6(getKClass(UpdateFcmTokenUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$single.ss6(getKClass(GetProductByIdUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$single.ss6(getKClass(GetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_4 = $this$single.ss6(getKClass(GetCurrentUserValueUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_5 = $this$single.ss6(getKClass(CheckUpdateUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_6 = $this$single.ss6(getKClass(GetCartItemsUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$8 = $this$single.ss6(getKClass(GetOrderByIdUseCase), null, null);
    return new AppViewModel(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp$ret$8);
  }
  function commonModule$lambda$lambda_72($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(GetProductsUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(GetBannersUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$viewModel.ss6(getKClass(GetCartItemsUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$viewModel.ss6(getKClass(GetCurrentUserUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_4 = $this$viewModel.ss6(getKClass(GetFavoriteProductsUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_5 = $this$viewModel.ss6(getKClass(ToggleFavoriteUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_6 = $this$viewModel.ss6(getKClass(SyncFavoritesUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_7 = $this$viewModel.ss6(getKClass(SetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$9 = $this$viewModel.ss6(getKClass(IsConnectedUseCase), null, null);
    return new ShoppingViewModel(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp$ret$9);
  }
  function commonModule$lambda$lambda_73($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(LoginUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(LoginWithGoogleUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(RegisterUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$viewModel.ss6(getKClass(ResetPasswordUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$viewModel.ss6(getKClass(SyncCartUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_4 = $this$viewModel.ss6(getKClass(UpdatePasswordUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$6 = $this$viewModel.ss6(getKClass(HandleRecoveryLinkUseCase), null, null);
    return new AuthViewModel(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp$ret$6);
  }
  function commonModule$lambda$lambda_74($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(GetCartItemsUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(SyncCartUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(UpdateCartQuantityUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$viewModel.ss6(getKClass(RemoveFromCartUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$viewModel.ss6(getKClass(ClearCartUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_4 = $this$viewModel.ss6(getKClass(GetCurrentUserUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_5 = $this$viewModel.ss6(getKClass(GetCurrentUserValueUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_6 = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$8 = $this$viewModel.ss6(getKClass(IsConnectedUseCase), null, null);
    return new CartViewModel(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp$ret$8);
  }
  function commonModule$lambda$lambda_75($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    return new CartNormalProductDetailsViewModel(tmp$ret$0);
  }
  function commonModule$lambda$lambda_76($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(DownloadDesignImageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$2 = $this$viewModel.ss6(getKClass(NetworkObserver), null, null);
    return new CartMugProductDetailsViewModel(tmp, tmp_0, tmp$ret$2);
  }
  function commonModule$lambda$lambda_77($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(DownloadDesignImageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$2 = $this$viewModel.ss6(getKClass(NetworkObserver), null, null);
    return new CartMagicMugProductDetailsViewModel(tmp, tmp_0, tmp$ret$2);
  }
  function commonModule$lambda$lambda_78($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(GetFavoriteProductsUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(ToggleFavoriteUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(SyncFavoritesUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$3 = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    return new FavoritesViewModel(tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  function commonModule$lambda$lambda_79($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(GetStockRemindersUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(ToggleStockReminderUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(GetProductsUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$3 = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    return new StockRemindersViewModel(tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  function commonModule$lambda$lambda_80($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(AddToCartUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(GetCurrentUserValueUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$viewModel.ss6(getKClass(IFavoriteRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$viewModel.ss6(getKClass(ToggleStockReminderUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_4 = $this$viewModel.ss6(getKClass(IStockReminderRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$6 = $this$viewModel.ss6(getKClass(IProductRepository), null, null);
    return new ProductDetailsViewModel(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp$ret$6);
  }
  function commonModule$lambda$lambda_81($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(AddToCartUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(GetCurrentUserValueUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$viewModel.ss6(getKClass(IFavoriteRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$viewModel.ss6(getKClass(ToggleStockReminderUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_4 = $this$viewModel.ss6(getKClass(IStockReminderRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$6 = $this$viewModel.ss6(getKClass(IProductRepository), null, null);
    return new BeadsProductDetailsViewModel(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp$ret$6);
  }
  function commonModule$lambda$lambda_82($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(AddToCartUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(GetCurrentUserValueUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$viewModel.ss6(getKClass(IFavoriteRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$viewModel.ss6(getKClass(DownloadDesignImageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_4 = $this$viewModel.ss6(getKClass(UploadDesignImageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_5 = $this$viewModel.ss6(getKClass(NetworkObserver), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_6 = $this$viewModel.ss6(getKClass(ToggleStockReminderUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_7 = $this$viewModel.ss6(getKClass(IStockReminderRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_8 = $this$viewModel.ss6(getKClass(IProductRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$10 = $this$viewModel.ss6(getKClass(IAuthRepository), null, null);
    return new CustomProductDetailsViewModel(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp$ret$10);
  }
  function commonModule$lambda$lambda_83($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(SavedStateHandle), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(GetCurrentUserValueUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(FetchProfileUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$viewModel.ss6(getKClass(UpdateProfileUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$viewModel.ss6(getKClass(GetFriendsUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_4 = $this$viewModel.ss6(getKClass(AddFriendUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_5 = $this$viewModel.ss6(getKClass(UploadFriendAvatarUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_6 = $this$viewModel.ss6(getKClass(UpdateFriendUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_7 = $this$viewModel.ss6(getKClass(ClearCartUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_8 = $this$viewModel.ss6(getKClass(GetCartItemsUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_9 = $this$viewModel.ss6(getKClass(IsConnectedUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_10 = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_11 = $this$viewModel.ss6(getKClass(GetShippingCostUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$13 = $this$viewModel.ss6(getKClass(ApplyCouponUseCase), null, null);
    return new CheckoutViewModel(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp$ret$13);
  }
  function commonModule$lambda$lambda_84($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(GetCurrentUserValueUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$1 = $this$viewModel.ss6(getKClass(GetUserCouponsUseCase), null, null);
    return new CouponsViewModel(tmp, tmp$ret$1);
  }
  function commonModule$lambda$lambda_85($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(GetFriendsUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(AddFriendUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(UploadFriendAvatarUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$viewModel.ss6(getKClass(UpdateFriendUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$viewModel.ss6(getKClass(DeleteFriendUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_4 = $this$viewModel.ss6(getKClass(DeleteFriendAvatarUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_5 = $this$viewModel.ss6(getKClass(GetCurrentUserValueUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$7 = $this$viewModel.ss6(getKClass(IAuthRepository), null, null);
    return new FriendsViewModel(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp$ret$7);
  }
  function commonModule$lambda$lambda_86($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(AddToCartUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(DownloadDesignImageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(UploadDesignImageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$viewModel.ss6(getKClass(GetCurrentUserValueUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_4 = $this$viewModel.ss6(getKClass(NetworkObserver), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_5 = $this$viewModel.ss6(getKClass(IProductRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$7 = $this$viewModel.ss6(getKClass(IAuthRepository), null, null);
    return new ModelMugViewModel(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp$ret$7);
  }
  function commonModule$lambda$lambda_87($this$viewModel, _destruct__k2r9zo) {
    // Inline function 'org.koin.core.parameter.ParametersHolder.component1' call
    var order = _destruct__k2r9zo.ws5(0, getKClass(Order));
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(SavedStateHandle), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(PlaceOrderUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(ClearCartUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$viewModel.ss6(getKClass(GetCurrentUserValueUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$6 = $this$viewModel.ss6(getKClass(IsConnectedUseCase), null, null);
    return new OrderViewModel(order, tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp$ret$6);
  }
  function commonModule$lambda$lambda_88($this$viewModel, _destruct__k2r9zo) {
    // Inline function 'org.koin.core.parameter.ParametersHolder.component1' call
    var order = _destruct__k2r9zo.ws5(0, getKClass(Order));
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(AddToCartUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(RequestReturnUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$viewModel.ss6(getKClass(IsConnectedUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$viewModel.ss6(getKClass(GetProductByIdUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_4 = $this$viewModel.ss6(getKClass(ToggleFavoriteUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$7 = $this$viewModel.ss6(getKClass(ToggleStockReminderUseCase), null, null);
    return new OrderDetailsViewModel(order, tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp$ret$7);
  }
  function commonModule$lambda$lambda_89($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(GetOrderHistoryUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$1 = $this$viewModel.ss6(getKClass(GetCurrentUserValueUseCase), null, null);
    return new OrderHistoryViewModel(tmp, tmp$ret$1);
  }
  function commonModule$lambda$lambda_90($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$0 = $this$viewModel.ss6(getKClass(IAuthRepository), null, null);
    return new AccountManagementViewModel(tmp$ret$0);
  }
  function commonModule$lambda$lambda_91($this$viewModel, it) {
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp = $this$viewModel.ss6(getKClass(GetCartItemByIdUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_0 = $this$viewModel.ss6(getKClass(ICartRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_1 = $this$viewModel.ss6(getKClass(DownloadDesignImageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_2 = $this$viewModel.ss6(getKClass(UploadDesignImageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_3 = $this$viewModel.ss6(getKClass(GetCurrentUserValueUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_4 = $this$viewModel.ss6(getKClass(GetLanguageUseCase), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_5 = $this$viewModel.ss6(getKClass(NetworkObserver), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp_6 = $this$viewModel.ss6(getKClass(IProductRepository), null, null);
    // Inline function 'org.koin.core.scope.Scope.get' call
    var tmp$ret$8 = $this$viewModel.ss6(getKClass(IAuthRepository), null, null);
    return new EditMugDesignViewModel(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp$ret$8);
  }
  var client_fstech_hadaya_domain_model_Banner_$serializer$stable;
  var client_fstech_hadaya_domain_model_Banner$stable;
  function Banner$Companion$$childSerializers$_anonymous__99vhmm() {
    return Companion_getInstance_51().amj();
  }
  function Companion_1() {
    Companion_instance_7 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.bzy_1 = [null, null, null, null, null, null, lazy_0(tmp_0, Banner$Companion$$childSerializers$_anonymous__99vhmm), null];
  }
  var Companion_instance_7;
  function Companion_getInstance_36() {
    if (Companion_instance_7 == null)
      new Companion_1();
    return Companion_instance_7;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.Banner', this, 8);
    tmp0_serialDesc.a7c('id', false);
    tmp0_serialDesc.a7c('image_url_arabic', true);
    tmp0_serialDesc.a7c('image_url_english', true);
    tmp0_serialDesc.a7c('title_arabic', true);
    tmp0_serialDesc.a7c('title_english', true);
    tmp0_serialDesc.a7c('link', true);
    tmp0_serialDesc.a7c('kind', true);
    tmp0_serialDesc.a7c('target_product_id', true);
    this.czy_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).dzy = function (encoder, value) {
    var tmp0_desc = this.czy_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_36().bzy_1;
    tmp1_output.y75(tmp0_desc, 0, value.ezy_1);
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.fzy_1 === '')) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.fzy_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.gzy_1 === '')) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.gzy_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.hzy_1 === '')) {
      tmp1_output.g76(tmp0_desc, 3, StringSerializer_getInstance(), value.hzy_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.izy_1 === '')) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.izy_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.jzy_1 == null)) {
      tmp1_output.g76(tmp0_desc, 5, StringSerializer_getInstance(), value.jzy_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !value.kzy_1.equals(ProductKind_NORMAL_getInstance())) {
      tmp1_output.e76(tmp0_desc, 6, tmp2_cached[6].u1(), value.kzy_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.lzy_1 == null)) {
      tmp1_output.g76(tmp0_desc, 7, LongSerializer_getInstance(), value.lzy_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_1).z70 = function (encoder, value) {
    return this.dzy(encoder, value instanceof Banner ? value : THROW_CCE());
  };
  protoOf($serializer_1).a71 = function (decoder) {
    var tmp0_desc = this.czy_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.n74(tmp0_desc);
    var tmp13_cached = Companion_getInstance_36().bzy_1;
    if (tmp12_input.d75()) {
      tmp4_local0 = tmp12_input.t74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.z74(tmp0_desc, 6, tmp13_cached[6].u1(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.b75(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.t74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.z74(tmp0_desc, 6, tmp13_cached[6].u1(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.b75(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.o74(tmp0_desc);
    return Banner_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_1).y70 = function () {
    return this.czy_1;
  };
  protoOf($serializer_1).t7c = function () {
    var tmp0_cached = Companion_getInstance_36().bzy_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[6].u1(), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function Banner_init_$Init$(seen0, id, imageUrlArabic, imageUrlEnglish, titleArabic, titleEnglish, link, kind, targetProductId, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_1().czy_1);
    }
    $this.ezy_1 = id;
    if (0 === (seen0 & 2))
      $this.fzy_1 = '';
    else
      $this.fzy_1 = imageUrlArabic;
    if (0 === (seen0 & 4))
      $this.gzy_1 = '';
    else
      $this.gzy_1 = imageUrlEnglish;
    if (0 === (seen0 & 8))
      $this.hzy_1 = '';
    else
      $this.hzy_1 = titleArabic;
    if (0 === (seen0 & 16))
      $this.izy_1 = '';
    else
      $this.izy_1 = titleEnglish;
    if (0 === (seen0 & 32))
      $this.jzy_1 = null;
    else
      $this.jzy_1 = link;
    if (0 === (seen0 & 64))
      $this.kzy_1 = ProductKind_NORMAL_getInstance();
    else
      $this.kzy_1 = kind;
    if (0 === (seen0 & 128))
      $this.lzy_1 = null;
    else
      $this.lzy_1 = targetProductId;
    return $this;
  }
  function Banner_init_$Create$(seen0, id, imageUrlArabic, imageUrlEnglish, titleArabic, titleEnglish, link, kind, targetProductId, serializationConstructorMarker) {
    return Banner_init_$Init$(seen0, id, imageUrlArabic, imageUrlEnglish, titleArabic, titleEnglish, link, kind, targetProductId, serializationConstructorMarker, objectCreate(protoOf(Banner)));
  }
  function Banner(id, imageUrlArabic, imageUrlEnglish, titleArabic, titleEnglish, link, kind, targetProductId) {
    Companion_getInstance_36();
    imageUrlArabic = imageUrlArabic === VOID ? '' : imageUrlArabic;
    imageUrlEnglish = imageUrlEnglish === VOID ? '' : imageUrlEnglish;
    titleArabic = titleArabic === VOID ? '' : titleArabic;
    titleEnglish = titleEnglish === VOID ? '' : titleEnglish;
    link = link === VOID ? null : link;
    kind = kind === VOID ? ProductKind_NORMAL_getInstance() : kind;
    targetProductId = targetProductId === VOID ? null : targetProductId;
    this.ezy_1 = id;
    this.fzy_1 = imageUrlArabic;
    this.gzy_1 = imageUrlEnglish;
    this.hzy_1 = titleArabic;
    this.izy_1 = titleEnglish;
    this.jzy_1 = link;
    this.kzy_1 = kind;
    this.lzy_1 = targetProductId;
  }
  protoOf(Banner).toString = function () {
    return 'Banner(id=' + this.ezy_1.toString() + ', imageUrlArabic=' + this.fzy_1 + ', imageUrlEnglish=' + this.gzy_1 + ', titleArabic=' + this.hzy_1 + ', titleEnglish=' + this.izy_1 + ', link=' + this.jzy_1 + ', kind=' + this.kzy_1.toString() + ', targetProductId=' + toString_0(this.lzy_1) + ')';
  };
  protoOf(Banner).hashCode = function () {
    var result = this.ezy_1.hashCode();
    result = imul(result, 31) + (this.fzy_1 == null ? 0 : getStringHashCode(this.fzy_1)) | 0;
    result = imul(result, 31) + (this.gzy_1 == null ? 0 : getStringHashCode(this.gzy_1)) | 0;
    result = imul(result, 31) + (this.hzy_1 == null ? 0 : getStringHashCode(this.hzy_1)) | 0;
    result = imul(result, 31) + (this.izy_1 == null ? 0 : getStringHashCode(this.izy_1)) | 0;
    result = imul(result, 31) + (this.jzy_1 == null ? 0 : getStringHashCode(this.jzy_1)) | 0;
    result = imul(result, 31) + this.kzy_1.hashCode() | 0;
    result = imul(result, 31) + (this.lzy_1 == null ? 0 : this.lzy_1.hashCode()) | 0;
    return result;
  };
  protoOf(Banner).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Banner))
      return false;
    if (!equalsLong(this.ezy_1, other.ezy_1))
      return false;
    if (!(this.fzy_1 == other.fzy_1))
      return false;
    if (!(this.gzy_1 == other.gzy_1))
      return false;
    if (!(this.hzy_1 == other.hzy_1))
      return false;
    if (!(this.izy_1 == other.izy_1))
      return false;
    if (!(this.jzy_1 == other.jzy_1))
      return false;
    if (!this.kzy_1.equals(other.kzy_1))
      return false;
    if (!equals(this.lzy_1, other.lzy_1))
      return false;
    return true;
  };
  var client_fstech_hadaya_domain_model_Box_$serializer$stable;
  var client_fstech_hadaya_domain_model_Box$stable;
  function Companion_2() {
  }
  var Companion_instance_8;
  function Companion_getInstance_37() {
    return Companion_instance_8;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.Box', this, 11);
    tmp0_serialDesc.a7c('id', true);
    tmp0_serialDesc.a7c('name_english', true);
    tmp0_serialDesc.a7c('name_arabic', true);
    tmp0_serialDesc.a7c('image_url', true);
    tmp0_serialDesc.a7c('video_url', true);
    tmp0_serialDesc.a7c('price', true);
    tmp0_serialDesc.a7c('stock', true);
    tmp0_serialDesc.a7c('is_archived', true);
    tmp0_serialDesc.a7c('is_comment', true);
    tmp0_serialDesc.a7c('is_birthday', true);
    tmp0_serialDesc.a7c('created_at', true);
    this.mzy_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).nzy = function (encoder, value) {
    var tmp0_desc = this.mzy_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.ryz_1 == null)) {
      tmp1_output.g76(tmp0_desc, 0, LongSerializer_getInstance(), value.ryz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.syz_1 === '')) {
      tmp1_output.c76(tmp0_desc, 1, value.syz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.tyz_1 === '')) {
      tmp1_output.c76(tmp0_desc, 2, value.tyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.uyz_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, FlexibleListSerializer_getInstance(), value.uyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.vyz_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, FlexibleListSerializer_getInstance(), value.vyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !equals(value.wyz_1, 0.0)) {
      tmp1_output.a76(tmp0_desc, 5, value.wyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.xyz_1 === 0)) {
      tmp1_output.x75(tmp0_desc, 6, value.xyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.yyz_1 === false)) {
      tmp1_output.u75(tmp0_desc, 7, value.yyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !(value.zyz_1 === false)) {
      tmp1_output.u75(tmp0_desc, 8, value.zyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !(value.az0_1 === false)) {
      tmp1_output.u75(tmp0_desc, 9, value.az0_1);
    }
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.bz0_1 == null)) {
      tmp1_output.g76(tmp0_desc, 10, StringSerializer_getInstance(), value.bz0_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_2).z70 = function (encoder, value) {
    return this.nzy(encoder, value instanceof Box_0 ? value : THROW_CCE());
  };
  protoOf($serializer_2).a71 = function (decoder) {
    var tmp0_desc = this.mzy_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0.0;
    var tmp10_local6 = 0;
    var tmp11_local7 = false;
    var tmp12_local8 = false;
    var tmp13_local9 = false;
    var tmp14_local10 = null;
    var tmp15_input = decoder.n74(tmp0_desc);
    if (tmp15_input.d75()) {
      tmp4_local0 = tmp15_input.b75(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.x74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.x74(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.b75(tmp0_desc, 3, FlexibleListSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.b75(tmp0_desc, 4, FlexibleListSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.v74(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.s74(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.p74(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.p74(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.p74(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.b75(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.x74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.x74(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.b75(tmp0_desc, 3, FlexibleListSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.b75(tmp0_desc, 4, FlexibleListSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.v74(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.s74(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.p74(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.p74(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.p74(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.o74(tmp0_desc);
    return Box_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_2).y70 = function () {
    return this.mzy_1;
  };
  protoOf($serializer_2).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(FlexibleListSerializer_getInstance()), get_nullable(FlexibleListSerializer_getInstance()), DoubleSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function Box_init_$Init$(seen0, id, nameEnglish, nameArabic, imageUrl, videoUrl, price, stock, isArchived, isComment, isBirthday, createdAt, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_2().mzy_1);
    }
    if (0 === (seen0 & 1))
      $this.ryz_1 = null;
    else
      $this.ryz_1 = id;
    if (0 === (seen0 & 2))
      $this.syz_1 = '';
    else
      $this.syz_1 = nameEnglish;
    if (0 === (seen0 & 4))
      $this.tyz_1 = '';
    else
      $this.tyz_1 = nameArabic;
    if (0 === (seen0 & 8))
      $this.uyz_1 = null;
    else
      $this.uyz_1 = imageUrl;
    if (0 === (seen0 & 16))
      $this.vyz_1 = null;
    else
      $this.vyz_1 = videoUrl;
    if (0 === (seen0 & 32))
      $this.wyz_1 = 0.0;
    else
      $this.wyz_1 = price;
    if (0 === (seen0 & 64))
      $this.xyz_1 = 0;
    else
      $this.xyz_1 = stock;
    if (0 === (seen0 & 128))
      $this.yyz_1 = false;
    else
      $this.yyz_1 = isArchived;
    if (0 === (seen0 & 256))
      $this.zyz_1 = false;
    else
      $this.zyz_1 = isComment;
    if (0 === (seen0 & 512))
      $this.az0_1 = false;
    else
      $this.az0_1 = isBirthday;
    if (0 === (seen0 & 1024))
      $this.bz0_1 = null;
    else
      $this.bz0_1 = createdAt;
    return $this;
  }
  function Box_init_$Create$(seen0, id, nameEnglish, nameArabic, imageUrl, videoUrl, price, stock, isArchived, isComment, isBirthday, createdAt, serializationConstructorMarker) {
    return Box_init_$Init$(seen0, id, nameEnglish, nameArabic, imageUrl, videoUrl, price, stock, isArchived, isComment, isBirthday, createdAt, serializationConstructorMarker, objectCreate(protoOf(Box_0)));
  }
  function Box_0(id, nameEnglish, nameArabic, imageUrl, videoUrl, price, stock, isArchived, isComment, isBirthday, createdAt) {
    id = id === VOID ? null : id;
    nameEnglish = nameEnglish === VOID ? '' : nameEnglish;
    nameArabic = nameArabic === VOID ? '' : nameArabic;
    imageUrl = imageUrl === VOID ? null : imageUrl;
    videoUrl = videoUrl === VOID ? null : videoUrl;
    price = price === VOID ? 0.0 : price;
    stock = stock === VOID ? 0 : stock;
    isArchived = isArchived === VOID ? false : isArchived;
    isComment = isComment === VOID ? false : isComment;
    isBirthday = isBirthday === VOID ? false : isBirthday;
    createdAt = createdAt === VOID ? null : createdAt;
    this.ryz_1 = id;
    this.syz_1 = nameEnglish;
    this.tyz_1 = nameArabic;
    this.uyz_1 = imageUrl;
    this.vyz_1 = videoUrl;
    this.wyz_1 = price;
    this.xyz_1 = stock;
    this.yyz_1 = isArchived;
    this.zyz_1 = isComment;
    this.az0_1 = isBirthday;
    this.bz0_1 = createdAt;
  }
  protoOf(Box_0).toString = function () {
    return 'Box(id=' + toString_0(this.ryz_1) + ', nameEnglish=' + this.syz_1 + ', nameArabic=' + this.tyz_1 + ', imageUrl=' + toString_0(this.uyz_1) + ', videoUrl=' + toString_0(this.vyz_1) + ', price=' + this.wyz_1 + ', stock=' + this.xyz_1 + ', isArchived=' + this.yyz_1 + ', isComment=' + this.zyz_1 + ', isBirthday=' + this.az0_1 + ', createdAt=' + this.bz0_1 + ')';
  };
  protoOf(Box_0).hashCode = function () {
    var result = this.ryz_1 == null ? 0 : this.ryz_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.syz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.tyz_1) | 0;
    result = imul(result, 31) + (this.uyz_1 == null ? 0 : hashCode(this.uyz_1)) | 0;
    result = imul(result, 31) + (this.vyz_1 == null ? 0 : hashCode(this.vyz_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.wyz_1) | 0;
    result = imul(result, 31) + this.xyz_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.yyz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.zyz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.az0_1) | 0;
    result = imul(result, 31) + (this.bz0_1 == null ? 0 : getStringHashCode(this.bz0_1)) | 0;
    return result;
  };
  protoOf(Box_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Box_0))
      return false;
    if (!equals(this.ryz_1, other.ryz_1))
      return false;
    if (!(this.syz_1 === other.syz_1))
      return false;
    if (!(this.tyz_1 === other.tyz_1))
      return false;
    if (!equals(this.uyz_1, other.uyz_1))
      return false;
    if (!equals(this.vyz_1, other.vyz_1))
      return false;
    if (!equals(this.wyz_1, other.wyz_1))
      return false;
    if (!(this.xyz_1 === other.xyz_1))
      return false;
    if (!(this.yyz_1 === other.yyz_1))
      return false;
    if (!(this.zyz_1 === other.zyz_1))
      return false;
    if (!(this.az0_1 === other.az0_1))
      return false;
    if (!(this.bz0_1 == other.bz0_1))
      return false;
    return true;
  };
  var client_fstech_hadaya_domain_model_Card_$serializer$stable;
  var client_fstech_hadaya_domain_model_Card$stable;
  function Companion_3() {
  }
  var Companion_instance_9;
  function Companion_getInstance_38() {
    return Companion_instance_9;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.Card', this, 11);
    tmp0_serialDesc.a7c('id', true);
    tmp0_serialDesc.a7c('name_english', true);
    tmp0_serialDesc.a7c('name_arabic', true);
    tmp0_serialDesc.a7c('image_url', true);
    tmp0_serialDesc.a7c('video_url', true);
    tmp0_serialDesc.a7c('price', true);
    tmp0_serialDesc.a7c('stock', true);
    tmp0_serialDesc.a7c('is_archived', true);
    tmp0_serialDesc.a7c('is_comment', true);
    tmp0_serialDesc.a7c('is_birthday', true);
    tmp0_serialDesc.a7c('created_at', true);
    this.ozy_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).pzy = function (encoder, value) {
    var tmp0_desc = this.ozy_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.gyz_1 == null)) {
      tmp1_output.g76(tmp0_desc, 0, LongSerializer_getInstance(), value.gyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.hyz_1 === '')) {
      tmp1_output.c76(tmp0_desc, 1, value.hyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.iyz_1 === '')) {
      tmp1_output.c76(tmp0_desc, 2, value.iyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.jyz_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, FlexibleListSerializer_getInstance(), value.jyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.kyz_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, FlexibleListSerializer_getInstance(), value.kyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !equals(value.lyz_1, 0.0)) {
      tmp1_output.a76(tmp0_desc, 5, value.lyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.myz_1 === 0)) {
      tmp1_output.x75(tmp0_desc, 6, value.myz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.nyz_1 === false)) {
      tmp1_output.u75(tmp0_desc, 7, value.nyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !(value.oyz_1 === false)) {
      tmp1_output.u75(tmp0_desc, 8, value.oyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !(value.pyz_1 === false)) {
      tmp1_output.u75(tmp0_desc, 9, value.pyz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.qyz_1 == null)) {
      tmp1_output.g76(tmp0_desc, 10, StringSerializer_getInstance(), value.qyz_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_3).z70 = function (encoder, value) {
    return this.pzy(encoder, value instanceof Card_1 ? value : THROW_CCE());
  };
  protoOf($serializer_3).a71 = function (decoder) {
    var tmp0_desc = this.ozy_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0.0;
    var tmp10_local6 = 0;
    var tmp11_local7 = false;
    var tmp12_local8 = false;
    var tmp13_local9 = false;
    var tmp14_local10 = null;
    var tmp15_input = decoder.n74(tmp0_desc);
    if (tmp15_input.d75()) {
      tmp4_local0 = tmp15_input.b75(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.x74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.x74(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.b75(tmp0_desc, 3, FlexibleListSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.b75(tmp0_desc, 4, FlexibleListSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.v74(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.s74(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.p74(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.p74(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.p74(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.b75(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.x74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.x74(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.b75(tmp0_desc, 3, FlexibleListSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.b75(tmp0_desc, 4, FlexibleListSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.v74(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.s74(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.p74(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.p74(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.p74(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.o74(tmp0_desc);
    return Card_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_3).y70 = function () {
    return this.ozy_1;
  };
  protoOf($serializer_3).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(FlexibleListSerializer_getInstance()), get_nullable(FlexibleListSerializer_getInstance()), DoubleSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function Card_init_$Init$(seen0, id, nameEnglish, nameArabic, imageUrl, videoUrl, price, stock, isArchived, isComment, isBirthday, createdAt, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_3().ozy_1);
    }
    if (0 === (seen0 & 1))
      $this.gyz_1 = null;
    else
      $this.gyz_1 = id;
    if (0 === (seen0 & 2))
      $this.hyz_1 = '';
    else
      $this.hyz_1 = nameEnglish;
    if (0 === (seen0 & 4))
      $this.iyz_1 = '';
    else
      $this.iyz_1 = nameArabic;
    if (0 === (seen0 & 8))
      $this.jyz_1 = null;
    else
      $this.jyz_1 = imageUrl;
    if (0 === (seen0 & 16))
      $this.kyz_1 = null;
    else
      $this.kyz_1 = videoUrl;
    if (0 === (seen0 & 32))
      $this.lyz_1 = 0.0;
    else
      $this.lyz_1 = price;
    if (0 === (seen0 & 64))
      $this.myz_1 = 0;
    else
      $this.myz_1 = stock;
    if (0 === (seen0 & 128))
      $this.nyz_1 = false;
    else
      $this.nyz_1 = isArchived;
    if (0 === (seen0 & 256))
      $this.oyz_1 = false;
    else
      $this.oyz_1 = isComment;
    if (0 === (seen0 & 512))
      $this.pyz_1 = false;
    else
      $this.pyz_1 = isBirthday;
    if (0 === (seen0 & 1024))
      $this.qyz_1 = null;
    else
      $this.qyz_1 = createdAt;
    return $this;
  }
  function Card_init_$Create$(seen0, id, nameEnglish, nameArabic, imageUrl, videoUrl, price, stock, isArchived, isComment, isBirthday, createdAt, serializationConstructorMarker) {
    return Card_init_$Init$(seen0, id, nameEnglish, nameArabic, imageUrl, videoUrl, price, stock, isArchived, isComment, isBirthday, createdAt, serializationConstructorMarker, objectCreate(protoOf(Card_1)));
  }
  function Card_1(id, nameEnglish, nameArabic, imageUrl, videoUrl, price, stock, isArchived, isComment, isBirthday, createdAt) {
    id = id === VOID ? null : id;
    nameEnglish = nameEnglish === VOID ? '' : nameEnglish;
    nameArabic = nameArabic === VOID ? '' : nameArabic;
    imageUrl = imageUrl === VOID ? null : imageUrl;
    videoUrl = videoUrl === VOID ? null : videoUrl;
    price = price === VOID ? 0.0 : price;
    stock = stock === VOID ? 0 : stock;
    isArchived = isArchived === VOID ? false : isArchived;
    isComment = isComment === VOID ? false : isComment;
    isBirthday = isBirthday === VOID ? false : isBirthday;
    createdAt = createdAt === VOID ? null : createdAt;
    this.gyz_1 = id;
    this.hyz_1 = nameEnglish;
    this.iyz_1 = nameArabic;
    this.jyz_1 = imageUrl;
    this.kyz_1 = videoUrl;
    this.lyz_1 = price;
    this.myz_1 = stock;
    this.nyz_1 = isArchived;
    this.oyz_1 = isComment;
    this.pyz_1 = isBirthday;
    this.qyz_1 = createdAt;
  }
  protoOf(Card_1).toString = function () {
    return 'Card(id=' + toString_0(this.gyz_1) + ', nameEnglish=' + this.hyz_1 + ', nameArabic=' + this.iyz_1 + ', imageUrl=' + toString_0(this.jyz_1) + ', videoUrl=' + toString_0(this.kyz_1) + ', price=' + this.lyz_1 + ', stock=' + this.myz_1 + ', isArchived=' + this.nyz_1 + ', isComment=' + this.oyz_1 + ', isBirthday=' + this.pyz_1 + ', createdAt=' + this.qyz_1 + ')';
  };
  protoOf(Card_1).hashCode = function () {
    var result = this.gyz_1 == null ? 0 : this.gyz_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.hyz_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.iyz_1) | 0;
    result = imul(result, 31) + (this.jyz_1 == null ? 0 : hashCode(this.jyz_1)) | 0;
    result = imul(result, 31) + (this.kyz_1 == null ? 0 : hashCode(this.kyz_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.lyz_1) | 0;
    result = imul(result, 31) + this.myz_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.nyz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.oyz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.pyz_1) | 0;
    result = imul(result, 31) + (this.qyz_1 == null ? 0 : getStringHashCode(this.qyz_1)) | 0;
    return result;
  };
  protoOf(Card_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Card_1))
      return false;
    if (!equals(this.gyz_1, other.gyz_1))
      return false;
    if (!(this.hyz_1 === other.hyz_1))
      return false;
    if (!(this.iyz_1 === other.iyz_1))
      return false;
    if (!equals(this.jyz_1, other.jyz_1))
      return false;
    if (!equals(this.kyz_1, other.kyz_1))
      return false;
    if (!equals(this.lyz_1, other.lyz_1))
      return false;
    if (!(this.myz_1 === other.myz_1))
      return false;
    if (!(this.nyz_1 === other.nyz_1))
      return false;
    if (!(this.oyz_1 === other.oyz_1))
      return false;
    if (!(this.pyz_1 === other.pyz_1))
      return false;
    if (!(this.qyz_1 == other.qyz_1))
      return false;
    return true;
  };
  var client_fstech_hadaya_domain_model_DesignLayer_$serializer$stable;
  var client_fstech_hadaya_domain_model_DesignLayer$stable;
  var client_fstech_hadaya_domain_model_CartItem_$serializer$stable;
  var client_fstech_hadaya_domain_model_CartItem$stable;
  function DesignLayer$Companion$$childSerializers$_anonymous__4csfyh() {
    return new ArrayListSerializer(ByteSerializer_getInstance());
  }
  function Companion_4() {
    Companion_instance_10 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.qzy_1 = [null, null, null, null, null, null, null, null, null, null, null, null, null, lazy_0(tmp_0, DesignLayer$Companion$$childSerializers$_anonymous__4csfyh), null, null, null];
  }
  var Companion_instance_10;
  function Companion_getInstance_39() {
    if (Companion_instance_10 == null)
      new Companion_4();
    return Companion_instance_10;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.DesignLayer', this, 17);
    tmp0_serialDesc.a7c('id', false);
    tmp0_serialDesc.a7c('image_url', true);
    tmp0_serialDesc.a7c('x', true);
    tmp0_serialDesc.a7c('y', true);
    tmp0_serialDesc.a7c('scale_x', true);
    tmp0_serialDesc.a7c('scale_y', true);
    tmp0_serialDesc.a7c('rotation', true);
    tmp0_serialDesc.a7c('filter', true);
    tmp0_serialDesc.a7c('flip_x', true);
    tmp0_serialDesc.a7c('flip_y', true);
    tmp0_serialDesc.a7c('text', true);
    tmp0_serialDesc.a7c('text_color', true);
    tmp0_serialDesc.a7c('font_family', true);
    tmp0_serialDesc.a7c('imageBytes', true);
    tmp0_serialDesc.a7c('user_image_url', true);
    tmp0_serialDesc.a7c('width', true);
    tmp0_serialDesc.a7c('height', true);
    this.rzy_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).szy = function (encoder, value) {
    var tmp0_desc = this.rzy_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_39().qzy_1;
    tmp1_output.y75(tmp0_desc, 0, value.ryx_1);
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.syx_1 === '')) {
      tmp1_output.c76(tmp0_desc, 1, value.syx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !equals(value.tyx_1, 0.0)) {
      tmp1_output.z75(tmp0_desc, 2, value.tyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !equals(value.uyx_1, 0.0)) {
      tmp1_output.z75(tmp0_desc, 3, value.uyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !equals(value.vyx_1, 1.0)) {
      tmp1_output.z75(tmp0_desc, 4, value.vyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !equals(value.wyx_1, 1.0)) {
      tmp1_output.z75(tmp0_desc, 5, value.wyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !equals(value.xyx_1, 0.0)) {
      tmp1_output.z75(tmp0_desc, 6, value.xyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.yyx_1 === 'None')) {
      tmp1_output.c76(tmp0_desc, 7, value.yyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !(value.zyx_1 === false)) {
      tmp1_output.u75(tmp0_desc, 8, value.zyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !(value.ayy_1 === false)) {
      tmp1_output.u75(tmp0_desc, 9, value.ayy_1);
    }
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.byy_1 == null)) {
      tmp1_output.g76(tmp0_desc, 10, StringSerializer_getInstance(), value.byy_1);
    }
    if (tmp1_output.k76(tmp0_desc, 11) ? true : !(value.cyy_1 == null)) {
      tmp1_output.g76(tmp0_desc, 11, LongSerializer_getInstance(), value.cyy_1);
    }
    if (tmp1_output.k76(tmp0_desc, 12) ? true : !(value.dyy_1 == null)) {
      tmp1_output.g76(tmp0_desc, 12, StringSerializer_getInstance(), value.dyy_1);
    }
    if (tmp1_output.k76(tmp0_desc, 13) ? true : !(value.eyy_1 == null)) {
      tmp1_output.g76(tmp0_desc, 13, tmp2_cached[13].u1(), value.eyy_1);
    }
    if (tmp1_output.k76(tmp0_desc, 14) ? true : !(value.fyy_1 == null)) {
      tmp1_output.g76(tmp0_desc, 14, StringSerializer_getInstance(), value.fyy_1);
    }
    if (tmp1_output.k76(tmp0_desc, 15) ? true : !(value.gyy_1 === 0)) {
      tmp1_output.x75(tmp0_desc, 15, value.gyy_1);
    }
    if (tmp1_output.k76(tmp0_desc, 16) ? true : !(value.hyy_1 === 0)) {
      tmp1_output.x75(tmp0_desc, 16, value.hyy_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_4).z70 = function (encoder, value) {
    return this.szy(encoder, value instanceof DesignLayer ? value : THROW_CCE());
  };
  protoOf($serializer_4).a71 = function (decoder) {
    var tmp0_desc = this.rzy_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0.0;
    var tmp10_local6 = 0.0;
    var tmp11_local7 = null;
    var tmp12_local8 = false;
    var tmp13_local9 = false;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = 0;
    var tmp20_local16 = 0;
    var tmp21_input = decoder.n74(tmp0_desc);
    var tmp22_cached = Companion_getInstance_39().qzy_1;
    if (tmp21_input.d75()) {
      tmp4_local0 = tmp21_input.t74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp21_input.x74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp21_input.u74(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp21_input.u74(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp21_input.u74(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp21_input.u74(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp21_input.u74(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp21_input.x74(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp21_input.p74(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp21_input.p74(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp21_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp21_input.b75(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp21_input.b75(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp21_input.b75(tmp0_desc, 13, tmp22_cached[13].u1(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp21_input.b75(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp21_input.s74(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp21_input.s74(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp21_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp21_input.t74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp21_input.x74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp21_input.u74(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp21_input.u74(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp21_input.u74(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp21_input.u74(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp21_input.u74(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp21_input.x74(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp21_input.p74(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp21_input.p74(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp21_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp21_input.b75(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp21_input.b75(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp21_input.b75(tmp0_desc, 13, tmp22_cached[13].u1(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp21_input.b75(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp21_input.s74(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp21_input.s74(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp21_input.o74(tmp0_desc);
    return DesignLayer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, null);
  };
  protoOf($serializer_4).y70 = function () {
    return this.rzy_1;
  };
  protoOf($serializer_4).t7c = function () {
    var tmp0_cached = Companion_getInstance_39().qzy_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), StringSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[13].u1()), get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function DesignLayer_init_$Init$(seen0, id, imageUrl, x, y, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamily, imageBytes, userImageUrl, width, height, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_4().rzy_1);
    }
    $this.ryx_1 = id;
    if (0 === (seen0 & 2))
      $this.syx_1 = '';
    else
      $this.syx_1 = imageUrl;
    if (0 === (seen0 & 4))
      $this.tyx_1 = 0.0;
    else
      $this.tyx_1 = x;
    if (0 === (seen0 & 8))
      $this.uyx_1 = 0.0;
    else
      $this.uyx_1 = y;
    if (0 === (seen0 & 16))
      $this.vyx_1 = 1.0;
    else
      $this.vyx_1 = scaleX;
    if (0 === (seen0 & 32))
      $this.wyx_1 = 1.0;
    else
      $this.wyx_1 = scaleY;
    if (0 === (seen0 & 64))
      $this.xyx_1 = 0.0;
    else
      $this.xyx_1 = rotation;
    if (0 === (seen0 & 128))
      $this.yyx_1 = 'None';
    else
      $this.yyx_1 = filter;
    if (0 === (seen0 & 256))
      $this.zyx_1 = false;
    else
      $this.zyx_1 = flipX;
    if (0 === (seen0 & 512))
      $this.ayy_1 = false;
    else
      $this.ayy_1 = flipY;
    if (0 === (seen0 & 1024))
      $this.byy_1 = null;
    else
      $this.byy_1 = text;
    if (0 === (seen0 & 2048))
      $this.cyy_1 = null;
    else
      $this.cyy_1 = textColor;
    if (0 === (seen0 & 4096))
      $this.dyy_1 = null;
    else
      $this.dyy_1 = fontFamily;
    if (0 === (seen0 & 8192))
      $this.eyy_1 = null;
    else
      $this.eyy_1 = imageBytes;
    if (0 === (seen0 & 16384))
      $this.fyy_1 = null;
    else
      $this.fyy_1 = userImageUrl;
    if (0 === (seen0 & 32768))
      $this.gyy_1 = 0;
    else
      $this.gyy_1 = width;
    if (0 === (seen0 & 65536))
      $this.hyy_1 = 0;
    else
      $this.hyy_1 = height;
    return $this;
  }
  function DesignLayer_init_$Create$(seen0, id, imageUrl, x, y, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamily, imageBytes, userImageUrl, width, height, serializationConstructorMarker) {
    return DesignLayer_init_$Init$(seen0, id, imageUrl, x, y, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamily, imageBytes, userImageUrl, width, height, serializationConstructorMarker, objectCreate(protoOf(DesignLayer)));
  }
  function DesignLayer(id, imageUrl, x, y, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamily, imageBytes, userImageUrl, width, height) {
    Companion_getInstance_39();
    imageUrl = imageUrl === VOID ? '' : imageUrl;
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    rotation = rotation === VOID ? 0.0 : rotation;
    filter = filter === VOID ? 'None' : filter;
    flipX = flipX === VOID ? false : flipX;
    flipY = flipY === VOID ? false : flipY;
    text = text === VOID ? null : text;
    textColor = textColor === VOID ? null : textColor;
    fontFamily = fontFamily === VOID ? null : fontFamily;
    imageBytes = imageBytes === VOID ? null : imageBytes;
    userImageUrl = userImageUrl === VOID ? null : userImageUrl;
    width = width === VOID ? 0 : width;
    height = height === VOID ? 0 : height;
    this.ryx_1 = id;
    this.syx_1 = imageUrl;
    this.tyx_1 = x;
    this.uyx_1 = y;
    this.vyx_1 = scaleX;
    this.wyx_1 = scaleY;
    this.xyx_1 = rotation;
    this.yyx_1 = filter;
    this.zyx_1 = flipX;
    this.ayy_1 = flipY;
    this.byy_1 = text;
    this.cyy_1 = textColor;
    this.dyy_1 = fontFamily;
    this.eyy_1 = imageBytes;
    this.fyy_1 = userImageUrl;
    this.gyy_1 = width;
    this.hyy_1 = height;
  }
  protoOf(DesignLayer).tzy = function (id, imageUrl, x, y, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamily, imageBytes, userImageUrl, width, height) {
    return new DesignLayer(id, imageUrl, x, y, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamily, imageBytes, userImageUrl, width, height);
  };
  protoOf(DesignLayer).iyy = function (id, imageUrl, x, y, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamily, imageBytes, userImageUrl, width, height, $super) {
    id = id === VOID ? this.ryx_1 : id;
    imageUrl = imageUrl === VOID ? this.syx_1 : imageUrl;
    x = x === VOID ? this.tyx_1 : x;
    y = y === VOID ? this.uyx_1 : y;
    scaleX = scaleX === VOID ? this.vyx_1 : scaleX;
    scaleY = scaleY === VOID ? this.wyx_1 : scaleY;
    rotation = rotation === VOID ? this.xyx_1 : rotation;
    filter = filter === VOID ? this.yyx_1 : filter;
    flipX = flipX === VOID ? this.zyx_1 : flipX;
    flipY = flipY === VOID ? this.ayy_1 : flipY;
    text = text === VOID ? this.byy_1 : text;
    textColor = textColor === VOID ? this.cyy_1 : textColor;
    fontFamily = fontFamily === VOID ? this.dyy_1 : fontFamily;
    imageBytes = imageBytes === VOID ? this.eyy_1 : imageBytes;
    userImageUrl = userImageUrl === VOID ? this.fyy_1 : userImageUrl;
    width = width === VOID ? this.gyy_1 : width;
    height = height === VOID ? this.hyy_1 : height;
    return $super === VOID ? this.tzy(id, imageUrl, x, y, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamily, imageBytes, userImageUrl, width, height) : $super.tzy.call(this, id, imageUrl, x, y, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamily, imageBytes, userImageUrl, width, height);
  };
  protoOf(DesignLayer).toString = function () {
    return 'DesignLayer(id=' + this.ryx_1.toString() + ', imageUrl=' + this.syx_1 + ', x=' + this.tyx_1 + ', y=' + this.uyx_1 + ', scaleX=' + this.vyx_1 + ', scaleY=' + this.wyx_1 + ', rotation=' + this.xyx_1 + ', filter=' + this.yyx_1 + ', flipX=' + this.zyx_1 + ', flipY=' + this.ayy_1 + ', text=' + this.byy_1 + ', textColor=' + toString_0(this.cyy_1) + ', fontFamily=' + this.dyy_1 + ', imageBytes=' + toString_0(this.eyy_1) + ', userImageUrl=' + this.fyy_1 + ', width=' + this.gyy_1 + ', height=' + this.hyy_1 + ')';
  };
  protoOf(DesignLayer).hashCode = function () {
    var result = this.ryx_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.syx_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.tyx_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.uyx_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.vyx_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.wyx_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.xyx_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yyx_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.zyx_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ayy_1) | 0;
    result = imul(result, 31) + (this.byy_1 == null ? 0 : getStringHashCode(this.byy_1)) | 0;
    result = imul(result, 31) + (this.cyy_1 == null ? 0 : this.cyy_1.hashCode()) | 0;
    result = imul(result, 31) + (this.dyy_1 == null ? 0 : getStringHashCode(this.dyy_1)) | 0;
    result = imul(result, 31) + (this.eyy_1 == null ? 0 : hashCode(this.eyy_1)) | 0;
    result = imul(result, 31) + (this.fyy_1 == null ? 0 : getStringHashCode(this.fyy_1)) | 0;
    result = imul(result, 31) + this.gyy_1 | 0;
    result = imul(result, 31) + this.hyy_1 | 0;
    return result;
  };
  protoOf(DesignLayer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DesignLayer))
      return false;
    if (!equalsLong(this.ryx_1, other.ryx_1))
      return false;
    if (!(this.syx_1 === other.syx_1))
      return false;
    if (!equals(this.tyx_1, other.tyx_1))
      return false;
    if (!equals(this.uyx_1, other.uyx_1))
      return false;
    if (!equals(this.vyx_1, other.vyx_1))
      return false;
    if (!equals(this.wyx_1, other.wyx_1))
      return false;
    if (!equals(this.xyx_1, other.xyx_1))
      return false;
    if (!(this.yyx_1 === other.yyx_1))
      return false;
    if (!(this.zyx_1 === other.zyx_1))
      return false;
    if (!(this.ayy_1 === other.ayy_1))
      return false;
    if (!(this.byy_1 == other.byy_1))
      return false;
    if (!equals(this.cyy_1, other.cyy_1))
      return false;
    if (!(this.dyy_1 == other.dyy_1))
      return false;
    if (!equals(this.eyy_1, other.eyy_1))
      return false;
    if (!(this.fyy_1 == other.fyy_1))
      return false;
    if (!(this.gyy_1 === other.gyy_1))
      return false;
    if (!(this.hyy_1 === other.hyy_1))
      return false;
    return true;
  };
  function CartItem$Companion$$childSerializers$_anonymous__f44sa1() {
    return new ArrayListSerializer($serializer_getInstance_4());
  }
  function CartItem$Companion$$childSerializers$_anonymous__f44sa1_0() {
    return new ArrayListSerializer(ByteSerializer_getInstance());
  }
  function CartItem$Companion$$childSerializers$_anonymous__f44sa1_1() {
    return Companion_getInstance_51().amj();
  }
  function CartItem$Companion$$childSerializers$_anonymous__f44sa1_2() {
    return Companion_getInstance_52().amj();
  }
  function CartItem$Companion$$childSerializers$_anonymous__f44sa1_3() {
    return new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_12());
  }
  function Companion_5() {
    Companion_instance_11 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, CartItem$Companion$$childSerializers$_anonymous__f44sa1);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy_0(tmp_2, CartItem$Companion$$childSerializers$_anonymous__f44sa1_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy_0(tmp_4, CartItem$Companion$$childSerializers$_anonymous__f44sa1_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_7 = lazy_0(tmp_6, CartItem$Companion$$childSerializers$_anonymous__f44sa1_2);
    var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.vzy_1 = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, tmp_1, null, null, null, tmp_3, tmp_5, null, null, null, tmp_7, null, null, null, null, null, null, null, null, lazy_0(tmp_8, CartItem$Companion$$childSerializers$_anonymous__f44sa1_3), null, null, null, null, null];
  }
  var Companion_instance_11;
  function Companion_getInstance_40() {
    if (Companion_instance_11 == null)
      new Companion_5();
    return Companion_instance_11;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.CartItem', this, 38);
    tmp0_serialDesc.a7c('id', true);
    tmp0_serialDesc.a7c('product_id', true);
    tmp0_serialDesc.a7c('name_english', true);
    tmp0_serialDesc.a7c('name_arabic', true);
    tmp0_serialDesc.a7c('description_english', true);
    tmp0_serialDesc.a7c('description_arabic', true);
    tmp0_serialDesc.a7c('price', true);
    tmp0_serialDesc.a7c('discount', true);
    tmp0_serialDesc.a7c('discount_percent', true);
    tmp0_serialDesc.a7c('rating', true);
    tmp0_serialDesc.a7c('stock', true);
    tmp0_serialDesc.a7c('image_url', true);
    tmp0_serialDesc.a7c('quantity', true);
    tmp0_serialDesc.a7c('custom_image_url', true);
    tmp0_serialDesc.a7c('design_layers', true);
    tmp0_serialDesc.a7c('user_id', true);
    tmp0_serialDesc.a7c('created_at', true);
    tmp0_serialDesc.a7c('video_url', true);
    tmp0_serialDesc.a7c('custom_image_bytes', true);
    tmp0_serialDesc.a7c('kind', true);
    tmp0_serialDesc.a7c('category', true);
    tmp0_serialDesc.a7c('category_name_english', true);
    tmp0_serialDesc.a7c('category_name_arabic', true);
    tmp0_serialDesc.a7c('target_audience', true);
    tmp0_serialDesc.a7c('selected_card', true);
    tmp0_serialDesc.a7c('card_message', true);
    tmp0_serialDesc.a7c('card_birthday', true);
    tmp0_serialDesc.a7c('selected_box', true);
    tmp0_serialDesc.a7c('box_message', true);
    tmp0_serialDesc.a7c('box_birthday', true);
    tmp0_serialDesc.a7c('selected_size', true);
    tmp0_serialDesc.a7c('selected_color', true);
    tmp0_serialDesc.a7c('selected_options', true);
    tmp0_serialDesc.a7c('product_comment', true);
    tmp0_serialDesc.a7c('is_kids', true);
    tmp0_serialDesc.a7c('is_youth', true);
    tmp0_serialDesc.a7c('is_old', true);
    tmp0_serialDesc.a7c('bracelet_name', true);
    this.wzy_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).xzy = function (encoder, value) {
    var tmp0_desc = this.wzy_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_40().vzy_1;
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.fyw_1 === randomUUID())) {
      tmp1_output.c76(tmp0_desc, 0, value.fyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.gyw_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, LongSerializer_getInstance(), value.gyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.hyw_1 === '')) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.hyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.iyw_1 === '')) {
      tmp1_output.g76(tmp0_desc, 3, StringSerializer_getInstance(), value.iyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.jyw_1 === '')) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.jyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.kyw_1 === '')) {
      tmp1_output.g76(tmp0_desc, 5, StringSerializer_getInstance(), value.kyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !equals(value.lyw_1, 0.0)) {
      tmp1_output.g76(tmp0_desc, 6, DoubleSerializer_getInstance(), value.lyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !equals(value.myw_1, 0.0)) {
      tmp1_output.g76(tmp0_desc, 7, DoubleSerializer_getInstance(), value.myw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !equals(value.nyw_1, 0.0)) {
      tmp1_output.g76(tmp0_desc, 8, DoubleSerializer_getInstance(), value.nyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !equals(value.oyw_1, 0.0)) {
      tmp1_output.g76(tmp0_desc, 9, DoubleSerializer_getInstance(), value.oyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.pyw_1 === 0)) {
      tmp1_output.g76(tmp0_desc, 10, IntSerializer_getInstance(), value.pyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 11) ? true : !(value.qyw_1 == null)) {
      tmp1_output.g76(tmp0_desc, 11, FlexibleListSerializer_getInstance(), value.qyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 12) ? true : !(value.ryw_1 === 1)) {
      tmp1_output.x75(tmp0_desc, 12, value.ryw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 13) ? true : !(value.syw_1 == null)) {
      tmp1_output.g76(tmp0_desc, 13, StringSerializer_getInstance(), value.syw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 14) ? true : !(value.tyw_1 == null)) {
      tmp1_output.g76(tmp0_desc, 14, tmp2_cached[14].u1(), value.tyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 15) ? true : !(value.uyw_1 == null)) {
      tmp1_output.g76(tmp0_desc, 15, StringSerializer_getInstance(), value.uyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 16) ? true : !(value.vyw_1 == null)) {
      tmp1_output.g76(tmp0_desc, 16, StringSerializer_getInstance(), value.vyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 17) ? true : !(value.wyw_1 == null)) {
      tmp1_output.g76(tmp0_desc, 17, FlexibleListSerializer_getInstance(), value.wyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 18) ? true : !(value.xyw_1 == null)) {
      tmp1_output.g76(tmp0_desc, 18, tmp2_cached[18].u1(), value.xyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 19) ? true : !value.yyw_1.equals(ProductKind_NORMAL_getInstance())) {
      tmp1_output.e76(tmp0_desc, 19, tmp2_cached[19].u1(), value.yyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 20) ? true : !(value.zyw_1 === '')) {
      tmp1_output.c76(tmp0_desc, 20, value.zyw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 21) ? true : !(value.ayx_1 === '')) {
      tmp1_output.g76(tmp0_desc, 21, StringSerializer_getInstance(), value.ayx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 22) ? true : !(value.byx_1 === '')) {
      tmp1_output.g76(tmp0_desc, 22, StringSerializer_getInstance(), value.byx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 23) ? true : !value.cyx_1.equals(TargetAudience_BOTH_getInstance())) {
      tmp1_output.e76(tmp0_desc, 23, tmp2_cached[23].u1(), value.cyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 24) ? true : !(value.dyx_1 == null)) {
      tmp1_output.g76(tmp0_desc, 24, $serializer_getInstance_3(), value.dyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 25) ? true : !(value.eyx_1 == null)) {
      tmp1_output.g76(tmp0_desc, 25, StringSerializer_getInstance(), value.eyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 26) ? true : !(value.fyx_1 == null)) {
      tmp1_output.g76(tmp0_desc, 26, StringSerializer_getInstance(), value.fyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 27) ? true : !(value.gyx_1 == null)) {
      tmp1_output.g76(tmp0_desc, 27, $serializer_getInstance_2(), value.gyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 28) ? true : !(value.hyx_1 == null)) {
      tmp1_output.g76(tmp0_desc, 28, StringSerializer_getInstance(), value.hyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 29) ? true : !(value.iyx_1 == null)) {
      tmp1_output.g76(tmp0_desc, 29, StringSerializer_getInstance(), value.iyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 30) ? true : !(value.jyx_1 == null)) {
      tmp1_output.g76(tmp0_desc, 30, StringSerializer_getInstance(), value.jyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 31) ? true : !(value.kyx_1 == null)) {
      tmp1_output.g76(tmp0_desc, 31, StringSerializer_getInstance(), value.kyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 32) ? true : !(value.lyx_1 == null)) {
      tmp1_output.g76(tmp0_desc, 32, tmp2_cached[32].u1(), value.lyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 33) ? true : !(value.myx_1 == null)) {
      tmp1_output.g76(tmp0_desc, 33, StringSerializer_getInstance(), value.myx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 34) ? true : !(value.nyx_1 === false)) {
      tmp1_output.u75(tmp0_desc, 34, value.nyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 35) ? true : !(value.oyx_1 === false)) {
      tmp1_output.u75(tmp0_desc, 35, value.oyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 36) ? true : !(value.pyx_1 === false)) {
      tmp1_output.u75(tmp0_desc, 36, value.pyx_1);
    }
    if (tmp1_output.k76(tmp0_desc, 37) ? true : !(value.qyx_1 == null)) {
      tmp1_output.g76(tmp0_desc, 37, StringSerializer_getInstance(), value.qyx_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_5).z70 = function (encoder, value) {
    return this.xzy(encoder, value instanceof CartItem ? value : THROW_CCE());
  };
  protoOf($serializer_5).a71 = function (decoder) {
    var tmp0_desc = this.wzy_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_bitMask1 = 0;
    var tmp5_local0 = null;
    var tmp6_local1 = null;
    var tmp7_local2 = null;
    var tmp8_local3 = null;
    var tmp9_local4 = null;
    var tmp10_local5 = null;
    var tmp11_local6 = null;
    var tmp12_local7 = null;
    var tmp13_local8 = null;
    var tmp14_local9 = null;
    var tmp15_local10 = null;
    var tmp16_local11 = null;
    var tmp17_local12 = 0;
    var tmp18_local13 = null;
    var tmp19_local14 = null;
    var tmp20_local15 = null;
    var tmp21_local16 = null;
    var tmp22_local17 = null;
    var tmp23_local18 = null;
    var tmp24_local19 = null;
    var tmp25_local20 = null;
    var tmp26_local21 = null;
    var tmp27_local22 = null;
    var tmp28_local23 = null;
    var tmp29_local24 = null;
    var tmp30_local25 = null;
    var tmp31_local26 = null;
    var tmp32_local27 = null;
    var tmp33_local28 = null;
    var tmp34_local29 = null;
    var tmp35_local30 = null;
    var tmp36_local31 = null;
    var tmp37_local32 = null;
    var tmp38_local33 = null;
    var tmp39_local34 = false;
    var tmp40_local35 = false;
    var tmp41_local36 = false;
    var tmp42_local37 = null;
    var tmp43_input = decoder.n74(tmp0_desc);
    var tmp44_cached = Companion_getInstance_40().vzy_1;
    if (tmp43_input.d75()) {
      tmp5_local0 = tmp43_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp6_local1 = tmp43_input.b75(tmp0_desc, 1, LongSerializer_getInstance(), tmp6_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp7_local2 = tmp43_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp7_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp8_local3 = tmp43_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp8_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp9_local4 = tmp43_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp9_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp10_local5 = tmp43_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp10_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp11_local6 = tmp43_input.b75(tmp0_desc, 6, DoubleSerializer_getInstance(), tmp11_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp12_local7 = tmp43_input.b75(tmp0_desc, 7, DoubleSerializer_getInstance(), tmp12_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp13_local8 = tmp43_input.b75(tmp0_desc, 8, DoubleSerializer_getInstance(), tmp13_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp14_local9 = tmp43_input.b75(tmp0_desc, 9, DoubleSerializer_getInstance(), tmp14_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp15_local10 = tmp43_input.b75(tmp0_desc, 10, IntSerializer_getInstance(), tmp15_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp16_local11 = tmp43_input.b75(tmp0_desc, 11, FlexibleListSerializer_getInstance(), tmp16_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp17_local12 = tmp43_input.s74(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp18_local13 = tmp43_input.b75(tmp0_desc, 13, StringSerializer_getInstance(), tmp18_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp19_local14 = tmp43_input.b75(tmp0_desc, 14, tmp44_cached[14].u1(), tmp19_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp20_local15 = tmp43_input.b75(tmp0_desc, 15, StringSerializer_getInstance(), tmp20_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp21_local16 = tmp43_input.b75(tmp0_desc, 16, StringSerializer_getInstance(), tmp21_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp22_local17 = tmp43_input.b75(tmp0_desc, 17, FlexibleListSerializer_getInstance(), tmp22_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp23_local18 = tmp43_input.b75(tmp0_desc, 18, tmp44_cached[18].u1(), tmp23_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp24_local19 = tmp43_input.z74(tmp0_desc, 19, tmp44_cached[19].u1(), tmp24_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp25_local20 = tmp43_input.x74(tmp0_desc, 20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp26_local21 = tmp43_input.b75(tmp0_desc, 21, StringSerializer_getInstance(), tmp26_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp27_local22 = tmp43_input.b75(tmp0_desc, 22, StringSerializer_getInstance(), tmp27_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp28_local23 = tmp43_input.z74(tmp0_desc, 23, tmp44_cached[23].u1(), tmp28_local23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
      tmp29_local24 = tmp43_input.b75(tmp0_desc, 24, $serializer_getInstance_3(), tmp29_local24);
      tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
      tmp30_local25 = tmp43_input.b75(tmp0_desc, 25, StringSerializer_getInstance(), tmp30_local25);
      tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
      tmp31_local26 = tmp43_input.b75(tmp0_desc, 26, StringSerializer_getInstance(), tmp31_local26);
      tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
      tmp32_local27 = tmp43_input.b75(tmp0_desc, 27, $serializer_getInstance_2(), tmp32_local27);
      tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
      tmp33_local28 = tmp43_input.b75(tmp0_desc, 28, StringSerializer_getInstance(), tmp33_local28);
      tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
      tmp34_local29 = tmp43_input.b75(tmp0_desc, 29, StringSerializer_getInstance(), tmp34_local29);
      tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
      tmp35_local30 = tmp43_input.b75(tmp0_desc, 30, StringSerializer_getInstance(), tmp35_local30);
      tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
      tmp36_local31 = tmp43_input.b75(tmp0_desc, 31, StringSerializer_getInstance(), tmp36_local31);
      tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
      tmp37_local32 = tmp43_input.b75(tmp0_desc, 32, tmp44_cached[32].u1(), tmp37_local32);
      tmp4_bitMask1 = tmp4_bitMask1 | 1;
      tmp38_local33 = tmp43_input.b75(tmp0_desc, 33, StringSerializer_getInstance(), tmp38_local33);
      tmp4_bitMask1 = tmp4_bitMask1 | 2;
      tmp39_local34 = tmp43_input.p74(tmp0_desc, 34);
      tmp4_bitMask1 = tmp4_bitMask1 | 4;
      tmp40_local35 = tmp43_input.p74(tmp0_desc, 35);
      tmp4_bitMask1 = tmp4_bitMask1 | 8;
      tmp41_local36 = tmp43_input.p74(tmp0_desc, 36);
      tmp4_bitMask1 = tmp4_bitMask1 | 16;
      tmp42_local37 = tmp43_input.b75(tmp0_desc, 37, StringSerializer_getInstance(), tmp42_local37);
      tmp4_bitMask1 = tmp4_bitMask1 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp43_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp5_local0 = tmp43_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp6_local1 = tmp43_input.b75(tmp0_desc, 1, LongSerializer_getInstance(), tmp6_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp7_local2 = tmp43_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp7_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp8_local3 = tmp43_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp8_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp9_local4 = tmp43_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp9_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp10_local5 = tmp43_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp10_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp11_local6 = tmp43_input.b75(tmp0_desc, 6, DoubleSerializer_getInstance(), tmp11_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp12_local7 = tmp43_input.b75(tmp0_desc, 7, DoubleSerializer_getInstance(), tmp12_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp13_local8 = tmp43_input.b75(tmp0_desc, 8, DoubleSerializer_getInstance(), tmp13_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp14_local9 = tmp43_input.b75(tmp0_desc, 9, DoubleSerializer_getInstance(), tmp14_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp15_local10 = tmp43_input.b75(tmp0_desc, 10, IntSerializer_getInstance(), tmp15_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp16_local11 = tmp43_input.b75(tmp0_desc, 11, FlexibleListSerializer_getInstance(), tmp16_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp17_local12 = tmp43_input.s74(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp18_local13 = tmp43_input.b75(tmp0_desc, 13, StringSerializer_getInstance(), tmp18_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp19_local14 = tmp43_input.b75(tmp0_desc, 14, tmp44_cached[14].u1(), tmp19_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp20_local15 = tmp43_input.b75(tmp0_desc, 15, StringSerializer_getInstance(), tmp20_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp21_local16 = tmp43_input.b75(tmp0_desc, 16, StringSerializer_getInstance(), tmp21_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp22_local17 = tmp43_input.b75(tmp0_desc, 17, FlexibleListSerializer_getInstance(), tmp22_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp23_local18 = tmp43_input.b75(tmp0_desc, 18, tmp44_cached[18].u1(), tmp23_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp24_local19 = tmp43_input.z74(tmp0_desc, 19, tmp44_cached[19].u1(), tmp24_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp25_local20 = tmp43_input.x74(tmp0_desc, 20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp26_local21 = tmp43_input.b75(tmp0_desc, 21, StringSerializer_getInstance(), tmp26_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp27_local22 = tmp43_input.b75(tmp0_desc, 22, StringSerializer_getInstance(), tmp27_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp28_local23 = tmp43_input.z74(tmp0_desc, 23, tmp44_cached[23].u1(), tmp28_local23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          case 24:
            tmp29_local24 = tmp43_input.b75(tmp0_desc, 24, $serializer_getInstance_3(), tmp29_local24);
            tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
            break;
          case 25:
            tmp30_local25 = tmp43_input.b75(tmp0_desc, 25, StringSerializer_getInstance(), tmp30_local25);
            tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
            break;
          case 26:
            tmp31_local26 = tmp43_input.b75(tmp0_desc, 26, StringSerializer_getInstance(), tmp31_local26);
            tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
            break;
          case 27:
            tmp32_local27 = tmp43_input.b75(tmp0_desc, 27, $serializer_getInstance_2(), tmp32_local27);
            tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
            break;
          case 28:
            tmp33_local28 = tmp43_input.b75(tmp0_desc, 28, StringSerializer_getInstance(), tmp33_local28);
            tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
            break;
          case 29:
            tmp34_local29 = tmp43_input.b75(tmp0_desc, 29, StringSerializer_getInstance(), tmp34_local29);
            tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
            break;
          case 30:
            tmp35_local30 = tmp43_input.b75(tmp0_desc, 30, StringSerializer_getInstance(), tmp35_local30);
            tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
            break;
          case 31:
            tmp36_local31 = tmp43_input.b75(tmp0_desc, 31, StringSerializer_getInstance(), tmp36_local31);
            tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
            break;
          case 32:
            tmp37_local32 = tmp43_input.b75(tmp0_desc, 32, tmp44_cached[32].u1(), tmp37_local32);
            tmp4_bitMask1 = tmp4_bitMask1 | 1;
            break;
          case 33:
            tmp38_local33 = tmp43_input.b75(tmp0_desc, 33, StringSerializer_getInstance(), tmp38_local33);
            tmp4_bitMask1 = tmp4_bitMask1 | 2;
            break;
          case 34:
            tmp39_local34 = tmp43_input.p74(tmp0_desc, 34);
            tmp4_bitMask1 = tmp4_bitMask1 | 4;
            break;
          case 35:
            tmp40_local35 = tmp43_input.p74(tmp0_desc, 35);
            tmp4_bitMask1 = tmp4_bitMask1 | 8;
            break;
          case 36:
            tmp41_local36 = tmp43_input.p74(tmp0_desc, 36);
            tmp4_bitMask1 = tmp4_bitMask1 | 16;
            break;
          case 37:
            tmp42_local37 = tmp43_input.b75(tmp0_desc, 37, StringSerializer_getInstance(), tmp42_local37);
            tmp4_bitMask1 = tmp4_bitMask1 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp43_input.o74(tmp0_desc);
    return CartItem_init_$Create$(tmp3_bitMask0, tmp4_bitMask1, tmp5_local0, tmp6_local1, tmp7_local2, tmp8_local3, tmp9_local4, tmp10_local5, tmp11_local6, tmp12_local7, tmp13_local8, tmp14_local9, tmp15_local10, tmp16_local11, tmp17_local12, tmp18_local13, tmp19_local14, tmp20_local15, tmp21_local16, tmp22_local17, tmp23_local18, tmp24_local19, tmp25_local20, tmp26_local21, tmp27_local22, tmp28_local23, tmp29_local24, tmp30_local25, tmp31_local26, tmp32_local27, tmp33_local28, tmp34_local29, tmp35_local30, tmp36_local31, tmp37_local32, tmp38_local33, tmp39_local34, tmp40_local35, tmp41_local36, tmp42_local37, null);
  };
  protoOf($serializer_5).y70 = function () {
    return this.wzy_1;
  };
  protoOf($serializer_5).t7c = function () {
    var tmp0_cached = Companion_getInstance_40().vzy_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(FlexibleListSerializer_getInstance()), IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[14].u1()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(FlexibleListSerializer_getInstance()), get_nullable(tmp0_cached[18].u1()), tmp0_cached[19].u1(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[23].u1(), get_nullable($serializer_getInstance_3()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_2()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[32].u1()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_5;
  function $serializer_getInstance_5() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function CartItem_init_$Init$(seen0, seen1, id, productId, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, quantity, customImageUrl, designLayers, userId, createdAt, videoUrl, customImageBytes, kind, category, categoryNameEnglish, categoryNameArabic, targetAudience, selectedCard, cardMessage, cardBirthday, selectedBox, boxMessage, boxBirthday, selectedSize, selectedColor, selectedOptions, productComment, isKids, isYouth, isOld, braceletName, serializationConstructorMarker, $this) {
    if (!!(!(0 === (0 & seen0)) | !(0 === (0 & seen1)))) {
      // Inline function 'kotlin.intArrayOf' call
      var tmp = new Int32Array([seen0, seen1]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$1 = new Int32Array([0, 0]);
      throwArrayMissingFieldException(tmp, tmp$ret$1, $serializer_getInstance_5().wzy_1);
    }
    if (0 === (seen0 & 1))
      $this.fyw_1 = randomUUID();
    else
      $this.fyw_1 = id;
    if (0 === (seen0 & 2))
      $this.gyw_1 = null;
    else
      $this.gyw_1 = productId;
    if (0 === (seen0 & 4))
      $this.hyw_1 = '';
    else
      $this.hyw_1 = nameEnglish;
    if (0 === (seen0 & 8))
      $this.iyw_1 = '';
    else
      $this.iyw_1 = nameArabic;
    if (0 === (seen0 & 16))
      $this.jyw_1 = '';
    else
      $this.jyw_1 = descriptionEnglish;
    if (0 === (seen0 & 32))
      $this.kyw_1 = '';
    else
      $this.kyw_1 = descriptionArabic;
    if (0 === (seen0 & 64))
      $this.lyw_1 = 0.0;
    else
      $this.lyw_1 = price;
    if (0 === (seen0 & 128))
      $this.myw_1 = 0.0;
    else
      $this.myw_1 = discount;
    if (0 === (seen0 & 256))
      $this.nyw_1 = 0.0;
    else
      $this.nyw_1 = discountPercent;
    if (0 === (seen0 & 512))
      $this.oyw_1 = 0.0;
    else
      $this.oyw_1 = rating;
    if (0 === (seen0 & 1024))
      $this.pyw_1 = 0;
    else
      $this.pyw_1 = stock;
    if (0 === (seen0 & 2048))
      $this.qyw_1 = null;
    else
      $this.qyw_1 = imageUrl;
    if (0 === (seen0 & 4096))
      $this.ryw_1 = 1;
    else
      $this.ryw_1 = quantity;
    if (0 === (seen0 & 8192))
      $this.syw_1 = null;
    else
      $this.syw_1 = customImageUrl;
    if (0 === (seen0 & 16384))
      $this.tyw_1 = null;
    else
      $this.tyw_1 = designLayers;
    if (0 === (seen0 & 32768))
      $this.uyw_1 = null;
    else
      $this.uyw_1 = userId;
    if (0 === (seen0 & 65536))
      $this.vyw_1 = null;
    else
      $this.vyw_1 = createdAt;
    if (0 === (seen0 & 131072))
      $this.wyw_1 = null;
    else
      $this.wyw_1 = videoUrl;
    if (0 === (seen0 & 262144))
      $this.xyw_1 = null;
    else
      $this.xyw_1 = customImageBytes;
    if (0 === (seen0 & 524288))
      $this.yyw_1 = ProductKind_NORMAL_getInstance();
    else
      $this.yyw_1 = kind;
    if (0 === (seen0 & 1048576))
      $this.zyw_1 = '';
    else
      $this.zyw_1 = category;
    if (0 === (seen0 & 2097152))
      $this.ayx_1 = '';
    else
      $this.ayx_1 = categoryNameEnglish;
    if (0 === (seen0 & 4194304))
      $this.byx_1 = '';
    else
      $this.byx_1 = categoryNameArabic;
    if (0 === (seen0 & 8388608))
      $this.cyx_1 = TargetAudience_BOTH_getInstance();
    else
      $this.cyx_1 = targetAudience;
    if (0 === (seen0 & 16777216))
      $this.dyx_1 = null;
    else
      $this.dyx_1 = selectedCard;
    if (0 === (seen0 & 33554432))
      $this.eyx_1 = null;
    else
      $this.eyx_1 = cardMessage;
    if (0 === (seen0 & 67108864))
      $this.fyx_1 = null;
    else
      $this.fyx_1 = cardBirthday;
    if (0 === (seen0 & 134217728))
      $this.gyx_1 = null;
    else
      $this.gyx_1 = selectedBox;
    if (0 === (seen0 & 268435456))
      $this.hyx_1 = null;
    else
      $this.hyx_1 = boxMessage;
    if (0 === (seen0 & 536870912))
      $this.iyx_1 = null;
    else
      $this.iyx_1 = boxBirthday;
    if (0 === (seen0 & 1073741824))
      $this.jyx_1 = null;
    else
      $this.jyx_1 = selectedSize;
    if (0 === (seen0 & -2147483648))
      $this.kyx_1 = null;
    else
      $this.kyx_1 = selectedColor;
    if (0 === (seen1 & 1))
      $this.lyx_1 = null;
    else
      $this.lyx_1 = selectedOptions;
    if (0 === (seen1 & 2))
      $this.myx_1 = null;
    else
      $this.myx_1 = productComment;
    if (0 === (seen1 & 4))
      $this.nyx_1 = false;
    else
      $this.nyx_1 = isKids;
    if (0 === (seen1 & 8))
      $this.oyx_1 = false;
    else
      $this.oyx_1 = isYouth;
    if (0 === (seen1 & 16))
      $this.pyx_1 = false;
    else
      $this.pyx_1 = isOld;
    if (0 === (seen1 & 32))
      $this.qyx_1 = null;
    else
      $this.qyx_1 = braceletName;
    return $this;
  }
  function CartItem_init_$Create$(seen0, seen1, id, productId, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, quantity, customImageUrl, designLayers, userId, createdAt, videoUrl, customImageBytes, kind, category, categoryNameEnglish, categoryNameArabic, targetAudience, selectedCard, cardMessage, cardBirthday, selectedBox, boxMessage, boxBirthday, selectedSize, selectedColor, selectedOptions, productComment, isKids, isYouth, isOld, braceletName, serializationConstructorMarker) {
    return CartItem_init_$Init$(seen0, seen1, id, productId, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, quantity, customImageUrl, designLayers, userId, createdAt, videoUrl, customImageBytes, kind, category, categoryNameEnglish, categoryNameArabic, targetAudience, selectedCard, cardMessage, cardBirthday, selectedBox, boxMessage, boxBirthday, selectedSize, selectedColor, selectedOptions, productComment, isKids, isYouth, isOld, braceletName, serializationConstructorMarker, objectCreate(protoOf(CartItem)));
  }
  function CartItem(id, productId, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, quantity, customImageUrl, designLayers, userId, createdAt, videoUrl, customImageBytes, kind, category, categoryNameEnglish, categoryNameArabic, targetAudience, selectedCard, cardMessage, cardBirthday, selectedBox, boxMessage, boxBirthday, selectedSize, selectedColor, selectedOptions, productComment, isKids, isYouth, isOld, braceletName) {
    Companion_getInstance_40();
    id = id === VOID ? randomUUID() : id;
    productId = productId === VOID ? null : productId;
    nameEnglish = nameEnglish === VOID ? '' : nameEnglish;
    nameArabic = nameArabic === VOID ? '' : nameArabic;
    descriptionEnglish = descriptionEnglish === VOID ? '' : descriptionEnglish;
    descriptionArabic = descriptionArabic === VOID ? '' : descriptionArabic;
    price = price === VOID ? 0.0 : price;
    discount = discount === VOID ? 0.0 : discount;
    discountPercent = discountPercent === VOID ? 0.0 : discountPercent;
    rating = rating === VOID ? 0.0 : rating;
    stock = stock === VOID ? 0 : stock;
    imageUrl = imageUrl === VOID ? null : imageUrl;
    quantity = quantity === VOID ? 1 : quantity;
    customImageUrl = customImageUrl === VOID ? null : customImageUrl;
    designLayers = designLayers === VOID ? null : designLayers;
    userId = userId === VOID ? null : userId;
    createdAt = createdAt === VOID ? null : createdAt;
    videoUrl = videoUrl === VOID ? null : videoUrl;
    customImageBytes = customImageBytes === VOID ? null : customImageBytes;
    kind = kind === VOID ? ProductKind_NORMAL_getInstance() : kind;
    category = category === VOID ? '' : category;
    categoryNameEnglish = categoryNameEnglish === VOID ? '' : categoryNameEnglish;
    categoryNameArabic = categoryNameArabic === VOID ? '' : categoryNameArabic;
    targetAudience = targetAudience === VOID ? TargetAudience_BOTH_getInstance() : targetAudience;
    selectedCard = selectedCard === VOID ? null : selectedCard;
    cardMessage = cardMessage === VOID ? null : cardMessage;
    cardBirthday = cardBirthday === VOID ? null : cardBirthday;
    selectedBox = selectedBox === VOID ? null : selectedBox;
    boxMessage = boxMessage === VOID ? null : boxMessage;
    boxBirthday = boxBirthday === VOID ? null : boxBirthday;
    selectedSize = selectedSize === VOID ? null : selectedSize;
    selectedColor = selectedColor === VOID ? null : selectedColor;
    selectedOptions = selectedOptions === VOID ? null : selectedOptions;
    productComment = productComment === VOID ? null : productComment;
    isKids = isKids === VOID ? false : isKids;
    isYouth = isYouth === VOID ? false : isYouth;
    isOld = isOld === VOID ? false : isOld;
    braceletName = braceletName === VOID ? null : braceletName;
    this.fyw_1 = id;
    this.gyw_1 = productId;
    this.hyw_1 = nameEnglish;
    this.iyw_1 = nameArabic;
    this.jyw_1 = descriptionEnglish;
    this.kyw_1 = descriptionArabic;
    this.lyw_1 = price;
    this.myw_1 = discount;
    this.nyw_1 = discountPercent;
    this.oyw_1 = rating;
    this.pyw_1 = stock;
    this.qyw_1 = imageUrl;
    this.ryw_1 = quantity;
    this.syw_1 = customImageUrl;
    this.tyw_1 = designLayers;
    this.uyw_1 = userId;
    this.vyw_1 = createdAt;
    this.wyw_1 = videoUrl;
    this.xyw_1 = customImageBytes;
    this.yyw_1 = kind;
    this.zyw_1 = category;
    this.ayx_1 = categoryNameEnglish;
    this.byx_1 = categoryNameArabic;
    this.cyx_1 = targetAudience;
    this.dyx_1 = selectedCard;
    this.eyx_1 = cardMessage;
    this.fyx_1 = cardBirthday;
    this.gyx_1 = selectedBox;
    this.hyx_1 = boxMessage;
    this.iyx_1 = boxBirthday;
    this.jyx_1 = selectedSize;
    this.kyx_1 = selectedColor;
    this.lyx_1 = selectedOptions;
    this.myx_1 = productComment;
    this.nyx_1 = isKids;
    this.oyx_1 = isYouth;
    this.pyx_1 = isOld;
    this.qyx_1 = braceletName;
  }
  protoOf(CartItem).yzy = function (id, productId, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, quantity, customImageUrl, designLayers, userId, createdAt, videoUrl, customImageBytes, kind, category, categoryNameEnglish, categoryNameArabic, targetAudience, selectedCard, cardMessage, cardBirthday, selectedBox, boxMessage, boxBirthday, selectedSize, selectedColor, selectedOptions, productComment, isKids, isYouth, isOld, braceletName) {
    return new CartItem(id, productId, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, quantity, customImageUrl, designLayers, userId, createdAt, videoUrl, customImageBytes, kind, category, categoryNameEnglish, categoryNameArabic, targetAudience, selectedCard, cardMessage, cardBirthday, selectedBox, boxMessage, boxBirthday, selectedSize, selectedColor, selectedOptions, productComment, isKids, isYouth, isOld, braceletName);
  };
  protoOf(CartItem).jyy = function (id, productId, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, quantity, customImageUrl, designLayers, userId, createdAt, videoUrl, customImageBytes, kind, category, categoryNameEnglish, categoryNameArabic, targetAudience, selectedCard, cardMessage, cardBirthday, selectedBox, boxMessage, boxBirthday, selectedSize, selectedColor, selectedOptions, productComment, isKids, isYouth, isOld, braceletName, $super) {
    id = id === VOID ? this.fyw_1 : id;
    productId = productId === VOID ? this.gyw_1 : productId;
    nameEnglish = nameEnglish === VOID ? this.hyw_1 : nameEnglish;
    nameArabic = nameArabic === VOID ? this.iyw_1 : nameArabic;
    descriptionEnglish = descriptionEnglish === VOID ? this.jyw_1 : descriptionEnglish;
    descriptionArabic = descriptionArabic === VOID ? this.kyw_1 : descriptionArabic;
    price = price === VOID ? this.lyw_1 : price;
    discount = discount === VOID ? this.myw_1 : discount;
    discountPercent = discountPercent === VOID ? this.nyw_1 : discountPercent;
    rating = rating === VOID ? this.oyw_1 : rating;
    stock = stock === VOID ? this.pyw_1 : stock;
    imageUrl = imageUrl === VOID ? this.qyw_1 : imageUrl;
    quantity = quantity === VOID ? this.ryw_1 : quantity;
    customImageUrl = customImageUrl === VOID ? this.syw_1 : customImageUrl;
    designLayers = designLayers === VOID ? this.tyw_1 : designLayers;
    userId = userId === VOID ? this.uyw_1 : userId;
    createdAt = createdAt === VOID ? this.vyw_1 : createdAt;
    videoUrl = videoUrl === VOID ? this.wyw_1 : videoUrl;
    customImageBytes = customImageBytes === VOID ? this.xyw_1 : customImageBytes;
    kind = kind === VOID ? this.yyw_1 : kind;
    category = category === VOID ? this.zyw_1 : category;
    categoryNameEnglish = categoryNameEnglish === VOID ? this.ayx_1 : categoryNameEnglish;
    categoryNameArabic = categoryNameArabic === VOID ? this.byx_1 : categoryNameArabic;
    targetAudience = targetAudience === VOID ? this.cyx_1 : targetAudience;
    selectedCard = selectedCard === VOID ? this.dyx_1 : selectedCard;
    cardMessage = cardMessage === VOID ? this.eyx_1 : cardMessage;
    cardBirthday = cardBirthday === VOID ? this.fyx_1 : cardBirthday;
    selectedBox = selectedBox === VOID ? this.gyx_1 : selectedBox;
    boxMessage = boxMessage === VOID ? this.hyx_1 : boxMessage;
    boxBirthday = boxBirthday === VOID ? this.iyx_1 : boxBirthday;
    selectedSize = selectedSize === VOID ? this.jyx_1 : selectedSize;
    selectedColor = selectedColor === VOID ? this.kyx_1 : selectedColor;
    selectedOptions = selectedOptions === VOID ? this.lyx_1 : selectedOptions;
    productComment = productComment === VOID ? this.myx_1 : productComment;
    isKids = isKids === VOID ? this.nyx_1 : isKids;
    isYouth = isYouth === VOID ? this.oyx_1 : isYouth;
    isOld = isOld === VOID ? this.pyx_1 : isOld;
    braceletName = braceletName === VOID ? this.qyx_1 : braceletName;
    return $super === VOID ? this.yzy(id, productId, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, quantity, customImageUrl, designLayers, userId, createdAt, videoUrl, customImageBytes, kind, category, categoryNameEnglish, categoryNameArabic, targetAudience, selectedCard, cardMessage, cardBirthday, selectedBox, boxMessage, boxBirthday, selectedSize, selectedColor, selectedOptions, productComment, isKids, isYouth, isOld, braceletName) : $super.yzy.call(this, id, productId, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, quantity, customImageUrl, designLayers, userId, createdAt, videoUrl, customImageBytes, kind, category, categoryNameEnglish, categoryNameArabic, targetAudience, selectedCard, cardMessage, cardBirthday, selectedBox, boxMessage, boxBirthday, selectedSize, selectedColor, selectedOptions, productComment, isKids, isYouth, isOld, braceletName);
  };
  protoOf(CartItem).toString = function () {
    return 'CartItem(id=' + this.fyw_1 + ', productId=' + toString_0(this.gyw_1) + ', nameEnglish=' + this.hyw_1 + ', nameArabic=' + this.iyw_1 + ', descriptionEnglish=' + this.jyw_1 + ', descriptionArabic=' + this.kyw_1 + ', price=' + this.lyw_1 + ', discount=' + this.myw_1 + ', discountPercent=' + this.nyw_1 + ', rating=' + this.oyw_1 + ', stock=' + this.pyw_1 + ', imageUrl=' + toString_0(this.qyw_1) + ', quantity=' + this.ryw_1 + ', customImageUrl=' + this.syw_1 + ', designLayers=' + toString_0(this.tyw_1) + ', userId=' + this.uyw_1 + ', createdAt=' + this.vyw_1 + ', videoUrl=' + toString_0(this.wyw_1) + ', customImageBytes=' + toString_0(this.xyw_1) + ', kind=' + this.yyw_1.toString() + ', category=' + this.zyw_1 + ', categoryNameEnglish=' + this.ayx_1 + ', categoryNameArabic=' + this.byx_1 + ', targetAudience=' + this.cyx_1.toString() + ', selectedCard=' + toString_0(this.dyx_1) + ', cardMessage=' + this.eyx_1 + ', cardBirthday=' + this.fyx_1 + ', selectedBox=' + toString_0(this.gyx_1) + ', boxMessage=' + this.hyx_1 + ', boxBirthday=' + this.iyx_1 + ', selectedSize=' + this.jyx_1 + ', selectedColor=' + this.kyx_1 + ', selectedOptions=' + toString_0(this.lyx_1) + ', productComment=' + this.myx_1 + ', isKids=' + this.nyx_1 + ', isYouth=' + this.oyx_1 + ', isOld=' + this.pyx_1 + ', braceletName=' + this.qyx_1 + ')';
  };
  protoOf(CartItem).hashCode = function () {
    var result = getStringHashCode(this.fyw_1);
    result = imul(result, 31) + (this.gyw_1 == null ? 0 : this.gyw_1.hashCode()) | 0;
    result = imul(result, 31) + (this.hyw_1 == null ? 0 : getStringHashCode(this.hyw_1)) | 0;
    result = imul(result, 31) + (this.iyw_1 == null ? 0 : getStringHashCode(this.iyw_1)) | 0;
    result = imul(result, 31) + (this.jyw_1 == null ? 0 : getStringHashCode(this.jyw_1)) | 0;
    result = imul(result, 31) + (this.kyw_1 == null ? 0 : getStringHashCode(this.kyw_1)) | 0;
    result = imul(result, 31) + (this.lyw_1 == null ? 0 : getNumberHashCode(this.lyw_1)) | 0;
    result = imul(result, 31) + (this.myw_1 == null ? 0 : getNumberHashCode(this.myw_1)) | 0;
    result = imul(result, 31) + (this.nyw_1 == null ? 0 : getNumberHashCode(this.nyw_1)) | 0;
    result = imul(result, 31) + (this.oyw_1 == null ? 0 : getNumberHashCode(this.oyw_1)) | 0;
    result = imul(result, 31) + (this.pyw_1 == null ? 0 : this.pyw_1) | 0;
    result = imul(result, 31) + (this.qyw_1 == null ? 0 : hashCode(this.qyw_1)) | 0;
    result = imul(result, 31) + this.ryw_1 | 0;
    result = imul(result, 31) + (this.syw_1 == null ? 0 : getStringHashCode(this.syw_1)) | 0;
    result = imul(result, 31) + (this.tyw_1 == null ? 0 : hashCode(this.tyw_1)) | 0;
    result = imul(result, 31) + (this.uyw_1 == null ? 0 : getStringHashCode(this.uyw_1)) | 0;
    result = imul(result, 31) + (this.vyw_1 == null ? 0 : getStringHashCode(this.vyw_1)) | 0;
    result = imul(result, 31) + (this.wyw_1 == null ? 0 : hashCode(this.wyw_1)) | 0;
    result = imul(result, 31) + (this.xyw_1 == null ? 0 : hashCode(this.xyw_1)) | 0;
    result = imul(result, 31) + this.yyw_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.zyw_1) | 0;
    result = imul(result, 31) + (this.ayx_1 == null ? 0 : getStringHashCode(this.ayx_1)) | 0;
    result = imul(result, 31) + (this.byx_1 == null ? 0 : getStringHashCode(this.byx_1)) | 0;
    result = imul(result, 31) + this.cyx_1.hashCode() | 0;
    result = imul(result, 31) + (this.dyx_1 == null ? 0 : this.dyx_1.hashCode()) | 0;
    result = imul(result, 31) + (this.eyx_1 == null ? 0 : getStringHashCode(this.eyx_1)) | 0;
    result = imul(result, 31) + (this.fyx_1 == null ? 0 : getStringHashCode(this.fyx_1)) | 0;
    result = imul(result, 31) + (this.gyx_1 == null ? 0 : this.gyx_1.hashCode()) | 0;
    result = imul(result, 31) + (this.hyx_1 == null ? 0 : getStringHashCode(this.hyx_1)) | 0;
    result = imul(result, 31) + (this.iyx_1 == null ? 0 : getStringHashCode(this.iyx_1)) | 0;
    result = imul(result, 31) + (this.jyx_1 == null ? 0 : getStringHashCode(this.jyx_1)) | 0;
    result = imul(result, 31) + (this.kyx_1 == null ? 0 : getStringHashCode(this.kyx_1)) | 0;
    result = imul(result, 31) + (this.lyx_1 == null ? 0 : hashCode(this.lyx_1)) | 0;
    result = imul(result, 31) + (this.myx_1 == null ? 0 : getStringHashCode(this.myx_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.nyx_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.oyx_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.pyx_1) | 0;
    result = imul(result, 31) + (this.qyx_1 == null ? 0 : getStringHashCode(this.qyx_1)) | 0;
    return result;
  };
  protoOf(CartItem).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CartItem))
      return false;
    if (!(this.fyw_1 === other.fyw_1))
      return false;
    if (!equals(this.gyw_1, other.gyw_1))
      return false;
    if (!(this.hyw_1 == other.hyw_1))
      return false;
    if (!(this.iyw_1 == other.iyw_1))
      return false;
    if (!(this.jyw_1 == other.jyw_1))
      return false;
    if (!(this.kyw_1 == other.kyw_1))
      return false;
    if (!equals(this.lyw_1, other.lyw_1))
      return false;
    if (!equals(this.myw_1, other.myw_1))
      return false;
    if (!equals(this.nyw_1, other.nyw_1))
      return false;
    if (!equals(this.oyw_1, other.oyw_1))
      return false;
    if (!(this.pyw_1 == other.pyw_1))
      return false;
    if (!equals(this.qyw_1, other.qyw_1))
      return false;
    if (!(this.ryw_1 === other.ryw_1))
      return false;
    if (!(this.syw_1 == other.syw_1))
      return false;
    if (!equals(this.tyw_1, other.tyw_1))
      return false;
    if (!(this.uyw_1 == other.uyw_1))
      return false;
    if (!(this.vyw_1 == other.vyw_1))
      return false;
    if (!equals(this.wyw_1, other.wyw_1))
      return false;
    if (!equals(this.xyw_1, other.xyw_1))
      return false;
    if (!this.yyw_1.equals(other.yyw_1))
      return false;
    if (!(this.zyw_1 === other.zyw_1))
      return false;
    if (!(this.ayx_1 == other.ayx_1))
      return false;
    if (!(this.byx_1 == other.byx_1))
      return false;
    if (!this.cyx_1.equals(other.cyx_1))
      return false;
    if (!equals(this.dyx_1, other.dyx_1))
      return false;
    if (!(this.eyx_1 == other.eyx_1))
      return false;
    if (!(this.fyx_1 == other.fyx_1))
      return false;
    if (!equals(this.gyx_1, other.gyx_1))
      return false;
    if (!(this.hyx_1 == other.hyx_1))
      return false;
    if (!(this.iyx_1 == other.iyx_1))
      return false;
    if (!(this.jyx_1 == other.jyx_1))
      return false;
    if (!(this.kyx_1 == other.kyx_1))
      return false;
    if (!equals(this.lyx_1, other.lyx_1))
      return false;
    if (!(this.myx_1 == other.myx_1))
      return false;
    if (!(this.nyx_1 === other.nyx_1))
      return false;
    if (!(this.oyx_1 === other.oyx_1))
      return false;
    if (!(this.pyx_1 === other.pyx_1))
      return false;
    if (!(this.qyx_1 == other.qyx_1))
      return false;
    return true;
  };
  var client_fstech_hadaya_domain_model_Category_$serializer$stable;
  var client_fstech_hadaya_domain_model_Category$stable;
  var client_fstech_hadaya_domain_model_Coupon_$serializer$stable;
  var client_fstech_hadaya_domain_model_Coupon$stable;
  var client_fstech_hadaya_domain_model_CouponAlreadyUsedException$stable;
  function Coupon$Companion$$childSerializers$_anonymous__inu77g() {
    return Companion_getInstance_42().amj();
  }
  function Companion_6() {
    Companion_instance_12 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.azz_1 = [null, null, lazy_0(tmp_0, Coupon$Companion$$childSerializers$_anonymous__inu77g), null, null, null, null, null, null, null];
  }
  var Companion_instance_12;
  function Companion_getInstance_41() {
    if (Companion_instance_12 == null)
      new Companion_6();
    return Companion_instance_12;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.Coupon', this, 10);
    tmp0_serialDesc.a7c('id', true);
    tmp0_serialDesc.a7c('code', false);
    tmp0_serialDesc.a7c('discount_type', false);
    tmp0_serialDesc.a7c('discount_value', false);
    tmp0_serialDesc.a7c('is_used', true);
    tmp0_serialDesc.a7c('expiry_date', true);
    tmp0_serialDesc.a7c('used_by', true);
    tmp0_serialDesc.a7c('created_by', true);
    tmp0_serialDesc.a7c('created_at', true);
    tmp0_serialDesc.a7c('used_at', true);
    this.bzz_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).czz = function (encoder, value) {
    var tmp0_desc = this.bzz_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_41().azz_1;
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.dzz_1 == null)) {
      tmp1_output.g76(tmp0_desc, 0, LongSerializer_getInstance(), value.dzz_1);
    }
    tmp1_output.c76(tmp0_desc, 1, value.ezz_1);
    tmp1_output.e76(tmp0_desc, 2, tmp2_cached[2].u1(), value.fzz_1);
    tmp1_output.a76(tmp0_desc, 3, value.gzz_1);
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.hzz_1 === false)) {
      tmp1_output.u75(tmp0_desc, 4, value.hzz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.izz_1 == null)) {
      tmp1_output.g76(tmp0_desc, 5, StringSerializer_getInstance(), value.izz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.jzz_1 == null)) {
      tmp1_output.g76(tmp0_desc, 6, StringSerializer_getInstance(), value.jzz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.kzz_1 == null)) {
      tmp1_output.g76(tmp0_desc, 7, StringSerializer_getInstance(), value.kzz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !(value.lzz_1 == null)) {
      tmp1_output.g76(tmp0_desc, 8, StringSerializer_getInstance(), value.lzz_1);
    }
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !(value.mzz_1 == null)) {
      tmp1_output.g76(tmp0_desc, 9, StringSerializer_getInstance(), value.mzz_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_6).z70 = function (encoder, value) {
    return this.czz(encoder, value instanceof Coupon ? value : THROW_CCE());
  };
  protoOf($serializer_6).a71 = function (decoder) {
    var tmp0_desc = this.bzz_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_input = decoder.n74(tmp0_desc);
    var tmp15_cached = Companion_getInstance_41().azz_1;
    if (tmp14_input.d75()) {
      tmp4_local0 = tmp14_input.b75(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.x74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.z74(tmp0_desc, 2, tmp15_cached[2].u1(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.v74(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.p74(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.b75(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.b75(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.x74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.z74(tmp0_desc, 2, tmp15_cached[2].u1(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.v74(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.p74(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.b75(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.o74(tmp0_desc);
    return Coupon_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_6).y70 = function () {
    return this.bzz_1;
  };
  protoOf($serializer_6).t7c = function () {
    var tmp0_cached = Companion_getInstance_41().azz_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[2].u1(), DoubleSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_6;
  function $serializer_getInstance_6() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function Coupon_init_$Init$(seen0, id, code, discountType, discountValue, isUsed, expiryDate, usedBy, createdBy, createdAt, usedAt, serializationConstructorMarker, $this) {
    if (!(14 === (14 & seen0))) {
      throwMissingFieldException(seen0, 14, $serializer_getInstance_6().bzz_1);
    }
    if (0 === (seen0 & 1))
      $this.dzz_1 = null;
    else
      $this.dzz_1 = id;
    $this.ezz_1 = code;
    $this.fzz_1 = discountType;
    $this.gzz_1 = discountValue;
    if (0 === (seen0 & 16))
      $this.hzz_1 = false;
    else
      $this.hzz_1 = isUsed;
    if (0 === (seen0 & 32))
      $this.izz_1 = null;
    else
      $this.izz_1 = expiryDate;
    if (0 === (seen0 & 64))
      $this.jzz_1 = null;
    else
      $this.jzz_1 = usedBy;
    if (0 === (seen0 & 128))
      $this.kzz_1 = null;
    else
      $this.kzz_1 = createdBy;
    if (0 === (seen0 & 256))
      $this.lzz_1 = null;
    else
      $this.lzz_1 = createdAt;
    if (0 === (seen0 & 512))
      $this.mzz_1 = null;
    else
      $this.mzz_1 = usedAt;
    return $this;
  }
  function Coupon_init_$Create$(seen0, id, code, discountType, discountValue, isUsed, expiryDate, usedBy, createdBy, createdAt, usedAt, serializationConstructorMarker) {
    return Coupon_init_$Init$(seen0, id, code, discountType, discountValue, isUsed, expiryDate, usedBy, createdBy, createdAt, usedAt, serializationConstructorMarker, objectCreate(protoOf(Coupon)));
  }
  function Coupon(id, code, discountType, discountValue, isUsed, expiryDate, usedBy, createdBy, createdAt, usedAt) {
    Companion_getInstance_41();
    id = id === VOID ? null : id;
    isUsed = isUsed === VOID ? false : isUsed;
    expiryDate = expiryDate === VOID ? null : expiryDate;
    usedBy = usedBy === VOID ? null : usedBy;
    createdBy = createdBy === VOID ? null : createdBy;
    createdAt = createdAt === VOID ? null : createdAt;
    usedAt = usedAt === VOID ? null : usedAt;
    this.dzz_1 = id;
    this.ezz_1 = code;
    this.fzz_1 = discountType;
    this.gzz_1 = discountValue;
    this.hzz_1 = isUsed;
    this.izz_1 = expiryDate;
    this.jzz_1 = usedBy;
    this.kzz_1 = createdBy;
    this.lzz_1 = createdAt;
    this.mzz_1 = usedAt;
  }
  protoOf(Coupon).toString = function () {
    return 'Coupon(id=' + toString_0(this.dzz_1) + ', code=' + this.ezz_1 + ', discountType=' + this.fzz_1.toString() + ', discountValue=' + this.gzz_1 + ', isUsed=' + this.hzz_1 + ', expiryDate=' + this.izz_1 + ', usedBy=' + this.jzz_1 + ', createdBy=' + this.kzz_1 + ', createdAt=' + this.lzz_1 + ', usedAt=' + this.mzz_1 + ')';
  };
  protoOf(Coupon).hashCode = function () {
    var result = this.dzz_1 == null ? 0 : this.dzz_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.ezz_1) | 0;
    result = imul(result, 31) + this.fzz_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.gzz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.hzz_1) | 0;
    result = imul(result, 31) + (this.izz_1 == null ? 0 : getStringHashCode(this.izz_1)) | 0;
    result = imul(result, 31) + (this.jzz_1 == null ? 0 : getStringHashCode(this.jzz_1)) | 0;
    result = imul(result, 31) + (this.kzz_1 == null ? 0 : getStringHashCode(this.kzz_1)) | 0;
    result = imul(result, 31) + (this.lzz_1 == null ? 0 : getStringHashCode(this.lzz_1)) | 0;
    result = imul(result, 31) + (this.mzz_1 == null ? 0 : getStringHashCode(this.mzz_1)) | 0;
    return result;
  };
  protoOf(Coupon).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Coupon))
      return false;
    if (!equals(this.dzz_1, other.dzz_1))
      return false;
    if (!(this.ezz_1 === other.ezz_1))
      return false;
    if (!this.fzz_1.equals(other.fzz_1))
      return false;
    if (!equals(this.gzz_1, other.gzz_1))
      return false;
    if (!(this.hzz_1 === other.hzz_1))
      return false;
    if (!(this.izz_1 == other.izz_1))
      return false;
    if (!(this.jzz_1 == other.jzz_1))
      return false;
    if (!(this.kzz_1 == other.kzz_1))
      return false;
    if (!(this.lzz_1 == other.lzz_1))
      return false;
    if (!(this.mzz_1 == other.mzz_1))
      return false;
    return true;
  };
  function CouponAlreadyUsedException(message) {
    message = message === VOID ? 'Coupon is already used or invalid.' : message;
    Exception_init_$Init$(message, this);
    captureStack(this, CouponAlreadyUsedException);
  }
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.zzy_1.u1();
  }
  function DiscountType$Companion$_anonymous__cq9w7g() {
    var tmp = values();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = ['percent', 'amount'];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [null, null];
    return createAnnotatedEnumSerializer('client.fstech.hadaya.domain.model.DiscountType', tmp, tmp_0, tmp$ret$3, null);
  }
  var DiscountType_PERCENT_instance;
  var DiscountType_AMOUNT_instance;
  function values() {
    return [DiscountType_PERCENT_getInstance(), DiscountType_AMOUNT_getInstance()];
  }
  function Companion_7() {
    Companion_instance_13 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.zzy_1 = lazy_0(tmp_0, DiscountType$Companion$_anonymous__cq9w7g);
  }
  protoOf(Companion_7).amj = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion_7).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  var Companion_instance_13;
  function Companion_getInstance_42() {
    DiscountType_initEntries();
    if (Companion_instance_13 == null)
      new Companion_7();
    return Companion_instance_13;
  }
  var DiscountType_entriesInitialized;
  function DiscountType_initEntries() {
    if (DiscountType_entriesInitialized)
      return Unit_instance;
    DiscountType_entriesInitialized = true;
    DiscountType_PERCENT_instance = new DiscountType('PERCENT', 0);
    DiscountType_AMOUNT_instance = new DiscountType('AMOUNT', 1);
    Companion_getInstance_42();
  }
  function DiscountType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function DiscountType_PERCENT_getInstance() {
    DiscountType_initEntries();
    return DiscountType_PERCENT_instance;
  }
  function DiscountType_AMOUNT_getInstance() {
    DiscountType_initEntries();
    return DiscountType_AMOUNT_instance;
  }
  var client_fstech_hadaya_domain_model_FavoriteProduct_$serializer$stable;
  var client_fstech_hadaya_domain_model_FavoriteProduct$stable;
  function Companion_8() {
  }
  var Companion_instance_14;
  function Companion_getInstance_43() {
    return Companion_instance_14;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.FavoriteProduct', this, 3);
    tmp0_serialDesc.a7c('product_id', false);
    tmp0_serialDesc.a7c('user_id', false);
    tmp0_serialDesc.a7c('added_at', true);
    this.nzz_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ozz = function (encoder, value) {
    var tmp0_desc = this.nzz_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.y75(tmp0_desc, 0, value.jzv_1);
    tmp1_output.c76(tmp0_desc, 1, value.kzv_1);
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !equalsLong(value.lzv_1, System_instance.fp().wp())) {
      tmp1_output.y75(tmp0_desc, 2, value.lzv_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_7).z70 = function (encoder, value) {
    return this.ozz(encoder, value instanceof FavoriteProduct ? value : THROW_CCE());
  };
  protoOf($serializer_7).a71 = function (decoder) {
    var tmp0_desc = this.nzz_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.n74(tmp0_desc);
    if (tmp7_input.d75()) {
      tmp4_local0 = tmp7_input.t74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.x74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.t74(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.t74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.x74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.t74(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.o74(tmp0_desc);
    return FavoriteProduct_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_7).y70 = function () {
    return this.nzz_1;
  };
  protoOf($serializer_7).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_7;
  function $serializer_getInstance_7() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function FavoriteProduct_init_$Init$(seen0, productId, userId, addedAt, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_7().nzz_1);
    }
    $this.jzv_1 = productId;
    $this.kzv_1 = userId;
    if (0 === (seen0 & 4))
      $this.lzv_1 = System_instance.fp().wp();
    else
      $this.lzv_1 = addedAt;
    return $this;
  }
  function FavoriteProduct_init_$Create$(seen0, productId, userId, addedAt, serializationConstructorMarker) {
    return FavoriteProduct_init_$Init$(seen0, productId, userId, addedAt, serializationConstructorMarker, objectCreate(protoOf(FavoriteProduct)));
  }
  function FavoriteProduct(productId, userId, addedAt) {
    addedAt = addedAt === VOID ? System_instance.fp().wp() : addedAt;
    this.jzv_1 = productId;
    this.kzv_1 = userId;
    this.lzv_1 = addedAt;
  }
  protoOf(FavoriteProduct).toString = function () {
    return 'FavoriteProduct(productId=' + this.jzv_1.toString() + ', userId=' + this.kzv_1 + ', addedAt=' + this.lzv_1.toString() + ')';
  };
  protoOf(FavoriteProduct).hashCode = function () {
    var result = this.jzv_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.kzv_1) | 0;
    result = imul(result, 31) + this.lzv_1.hashCode() | 0;
    return result;
  };
  protoOf(FavoriteProduct).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FavoriteProduct))
      return false;
    if (!equalsLong(this.jzv_1, other.jzv_1))
      return false;
    if (!(this.kzv_1 === other.kzv_1))
      return false;
    if (!equalsLong(this.lzv_1, other.lzv_1))
      return false;
    return true;
  };
  var client_fstech_hadaya_domain_model_FlexibleListSerializer$stable;
  function deserialize$extractStrings(input, result, element) {
    if (element instanceof JsonArray) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = element.t();
      while (_iterator__ex2g4s.u()) {
        var element_0 = _iterator__ex2g4s.v();
        deserialize$extractStrings(input, result, element_0);
      }
    } else {
      if (element instanceof JsonPrimitive) {
        if (element.vmi()) {
          var content = element.rj3();
          var tmp;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(content) === 0) {
            tmp = true;
          } else {
            tmp = startsWith(content, 'CREATE POLICY');
          }
          if (tmp)
            return Unit_instance;
          var tmp_0;
          // Inline function 'kotlin.text.trim' call
          var tmp$ret$3 = toString(trim(isCharSequence(content) ? content : THROW_CCE()));
          if (startsWith(tmp$ret$3, '[')) {
            // Inline function 'kotlin.text.trim' call
            var tmp$ret$4 = toString(trim(isCharSequence(content) ? content : THROW_CCE()));
            tmp_0 = endsWith(tmp$ret$4, ']');
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            try {
              var nestedElement = input.pmi().nmg(content);
              deserialize$extractStrings(input, result, nestedElement);
            } catch ($p) {
              if ($p instanceof Exception) {
                var _unused_var__etf5q3 = $p;
                result.j1(content);
              } else {
                throw $p;
              }
            }
          } else {
            result.j1(content);
          }
        }
      }
    }
  }
  function FlexibleListSerializer() {
    FlexibleListSerializer_instance = this;
    this.pzz_1 = ListSerializer(serializer_0(StringCompanionObject_instance));
    this.qzz_1 = this.pzz_1.y70();
  }
  protoOf(FlexibleListSerializer).y70 = function () {
    return this.qzz_1;
  };
  protoOf(FlexibleListSerializer).a71 = function (decoder) {
    var tmp0_elvis_lhs = isInterface(decoder, JsonDecoder) ? decoder : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this.pzz_1.a71(decoder);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var input = tmp;
    var rootElement = input.qmi();
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$_0();
    deserialize$extractStrings(input, result, rootElement);
    return distinct(result);
  };
  protoOf(FlexibleListSerializer).rzz = function (encoder, value) {
    this.pzz_1.z70(encoder, value);
  };
  protoOf(FlexibleListSerializer).z70 = function (encoder, value) {
    return this.rzz(encoder, (!(value == null) ? isInterface(value, KtList) : false) ? value : THROW_CCE());
  };
  var FlexibleListSerializer_instance;
  function FlexibleListSerializer_getInstance() {
    if (FlexibleListSerializer_instance == null)
      new FlexibleListSerializer();
    return FlexibleListSerializer_instance;
  }
  var client_fstech_hadaya_domain_model_Friend_$serializer$stable;
  var client_fstech_hadaya_domain_model_Friend$stable;
  function Companion_9() {
  }
  var Companion_instance_15;
  function Companion_getInstance_44() {
    return Companion_instance_15;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.Friend', this, 13);
    tmp0_serialDesc.a7c('id', true);
    tmp0_serialDesc.a7c('userId', false);
    tmp0_serialDesc.a7c('name', false);
    tmp0_serialDesc.a7c('relationship', false);
    tmp0_serialDesc.a7c('buildingNo', true);
    tmp0_serialDesc.a7c('street', true);
    tmp0_serialDesc.a7c('neighbourhood', true);
    tmp0_serialDesc.a7c('city', true);
    tmp0_serialDesc.a7c('country', true);
    tmp0_serialDesc.a7c('personalPhoneNumber', false);
    tmp0_serialDesc.a7c('workPhoneNumber', true);
    tmp0_serialDesc.a7c('dateOfBirthday', true);
    tmp0_serialDesc.a7c('avatarUrl', true);
    this.szz_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).tzz = function (encoder, value) {
    var tmp0_desc = this.szz_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.tz7_1 == null)) {
      tmp1_output.g76(tmp0_desc, 0, StringSerializer_getInstance(), value.tz7_1);
    }
    tmp1_output.c76(tmp0_desc, 1, value.uz7_1);
    tmp1_output.c76(tmp0_desc, 2, value.vz7_1);
    tmp1_output.g76(tmp0_desc, 3, StringSerializer_getInstance(), value.wz7_1);
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.xz7_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.xz7_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.yz7_1 == null)) {
      tmp1_output.g76(tmp0_desc, 5, StringSerializer_getInstance(), value.yz7_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.zz7_1 == null)) {
      tmp1_output.g76(tmp0_desc, 6, StringSerializer_getInstance(), value.zz7_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.az8_1 == null)) {
      tmp1_output.g76(tmp0_desc, 7, StringSerializer_getInstance(), value.az8_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !(value.bz8_1 == null)) {
      tmp1_output.g76(tmp0_desc, 8, StringSerializer_getInstance(), value.bz8_1);
    }
    tmp1_output.c76(tmp0_desc, 9, value.cz8_1);
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.dz8_1 == null)) {
      tmp1_output.g76(tmp0_desc, 10, StringSerializer_getInstance(), value.dz8_1);
    }
    if (tmp1_output.k76(tmp0_desc, 11) ? true : !(value.ez8_1 == null)) {
      tmp1_output.g76(tmp0_desc, 11, LongSerializer_getInstance(), value.ez8_1);
    }
    if (tmp1_output.k76(tmp0_desc, 12) ? true : !(value.fz8_1 == null)) {
      tmp1_output.g76(tmp0_desc, 12, StringSerializer_getInstance(), value.fz8_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_8).z70 = function (encoder, value) {
    return this.tzz(encoder, value instanceof Friend ? value : THROW_CCE());
  };
  protoOf($serializer_8).a71 = function (decoder) {
    var tmp0_desc = this.szz_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_input = decoder.n74(tmp0_desc);
    if (tmp17_input.d75()) {
      tmp4_local0 = tmp17_input.b75(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp17_input.x74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp17_input.x74(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp17_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp17_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp17_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp17_input.b75(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp17_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp17_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp17_input.x74(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp17_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp17_input.b75(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp17_input.b75(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp17_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp17_input.b75(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp17_input.x74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp17_input.x74(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp17_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp17_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp17_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp17_input.b75(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp17_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp17_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp17_input.x74(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp17_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp17_input.b75(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp17_input.b75(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp17_input.o74(tmp0_desc);
    return Friend_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
  };
  protoOf($serializer_8).y70 = function () {
    return this.szz_1;
  };
  protoOf($serializer_8).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_8;
  function $serializer_getInstance_8() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function Friend_init_$Init$(seen0, id, userId, name, relationship, buildingNo, street, neighbourhood, city, country, personalPhoneNumber, workPhoneNumber, dateOfBirthday, avatarUrl, serializationConstructorMarker, $this) {
    if (!(526 === (526 & seen0))) {
      throwMissingFieldException(seen0, 526, $serializer_getInstance_8().szz_1);
    }
    if (0 === (seen0 & 1))
      $this.tz7_1 = null;
    else
      $this.tz7_1 = id;
    $this.uz7_1 = userId;
    $this.vz7_1 = name;
    $this.wz7_1 = relationship;
    if (0 === (seen0 & 16))
      $this.xz7_1 = null;
    else
      $this.xz7_1 = buildingNo;
    if (0 === (seen0 & 32))
      $this.yz7_1 = null;
    else
      $this.yz7_1 = street;
    if (0 === (seen0 & 64))
      $this.zz7_1 = null;
    else
      $this.zz7_1 = neighbourhood;
    if (0 === (seen0 & 128))
      $this.az8_1 = null;
    else
      $this.az8_1 = city;
    if (0 === (seen0 & 256))
      $this.bz8_1 = null;
    else
      $this.bz8_1 = country;
    $this.cz8_1 = personalPhoneNumber;
    if (0 === (seen0 & 1024))
      $this.dz8_1 = null;
    else
      $this.dz8_1 = workPhoneNumber;
    if (0 === (seen0 & 2048))
      $this.ez8_1 = null;
    else
      $this.ez8_1 = dateOfBirthday;
    if (0 === (seen0 & 4096))
      $this.fz8_1 = null;
    else
      $this.fz8_1 = avatarUrl;
    return $this;
  }
  function Friend_init_$Create$(seen0, id, userId, name, relationship, buildingNo, street, neighbourhood, city, country, personalPhoneNumber, workPhoneNumber, dateOfBirthday, avatarUrl, serializationConstructorMarker) {
    return Friend_init_$Init$(seen0, id, userId, name, relationship, buildingNo, street, neighbourhood, city, country, personalPhoneNumber, workPhoneNumber, dateOfBirthday, avatarUrl, serializationConstructorMarker, objectCreate(protoOf(Friend)));
  }
  function Friend(id, userId, name, relationship, buildingNo, street, neighbourhood, city, country, personalPhoneNumber, workPhoneNumber, dateOfBirthday, avatarUrl) {
    id = id === VOID ? null : id;
    buildingNo = buildingNo === VOID ? null : buildingNo;
    street = street === VOID ? null : street;
    neighbourhood = neighbourhood === VOID ? null : neighbourhood;
    city = city === VOID ? null : city;
    country = country === VOID ? null : country;
    workPhoneNumber = workPhoneNumber === VOID ? null : workPhoneNumber;
    dateOfBirthday = dateOfBirthday === VOID ? null : dateOfBirthday;
    avatarUrl = avatarUrl === VOID ? null : avatarUrl;
    this.tz7_1 = id;
    this.uz7_1 = userId;
    this.vz7_1 = name;
    this.wz7_1 = relationship;
    this.xz7_1 = buildingNo;
    this.yz7_1 = street;
    this.zz7_1 = neighbourhood;
    this.az8_1 = city;
    this.bz8_1 = country;
    this.cz8_1 = personalPhoneNumber;
    this.dz8_1 = workPhoneNumber;
    this.ez8_1 = dateOfBirthday;
    this.fz8_1 = avatarUrl;
  }
  protoOf(Friend).uzz = function () {
    var tmp0_elvis_lhs = this.xz7_1;
    var tmp = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = this.yz7_1;
    var tmp_0 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = this.zz7_1;
    var tmp_1 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
    var tmp3_elvis_lhs = this.az8_1;
    var tmp_2 = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
    var tmp4_elvis_lhs = this.bz8_1;
    // Inline function 'kotlin.text.trim' call
    var this_0 = tmp + ' ' + tmp_0 + ' ' + tmp_1 + ' ' + tmp_2 + ' ' + (tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs);
    return toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  };
  protoOf(Friend).vzz = function (id, userId, name, relationship, buildingNo, street, neighbourhood, city, country, personalPhoneNumber, workPhoneNumber, dateOfBirthday, avatarUrl) {
    return new Friend(id, userId, name, relationship, buildingNo, street, neighbourhood, city, country, personalPhoneNumber, workPhoneNumber, dateOfBirthday, avatarUrl);
  };
  protoOf(Friend).gz8 = function (id, userId, name, relationship, buildingNo, street, neighbourhood, city, country, personalPhoneNumber, workPhoneNumber, dateOfBirthday, avatarUrl, $super) {
    id = id === VOID ? this.tz7_1 : id;
    userId = userId === VOID ? this.uz7_1 : userId;
    name = name === VOID ? this.vz7_1 : name;
    relationship = relationship === VOID ? this.wz7_1 : relationship;
    buildingNo = buildingNo === VOID ? this.xz7_1 : buildingNo;
    street = street === VOID ? this.yz7_1 : street;
    neighbourhood = neighbourhood === VOID ? this.zz7_1 : neighbourhood;
    city = city === VOID ? this.az8_1 : city;
    country = country === VOID ? this.bz8_1 : country;
    personalPhoneNumber = personalPhoneNumber === VOID ? this.cz8_1 : personalPhoneNumber;
    workPhoneNumber = workPhoneNumber === VOID ? this.dz8_1 : workPhoneNumber;
    dateOfBirthday = dateOfBirthday === VOID ? this.ez8_1 : dateOfBirthday;
    avatarUrl = avatarUrl === VOID ? this.fz8_1 : avatarUrl;
    return $super === VOID ? this.vzz(id, userId, name, relationship, buildingNo, street, neighbourhood, city, country, personalPhoneNumber, workPhoneNumber, dateOfBirthday, avatarUrl) : $super.vzz.call(this, id, userId, name, relationship, buildingNo, street, neighbourhood, city, country, personalPhoneNumber, workPhoneNumber, dateOfBirthday, avatarUrl);
  };
  protoOf(Friend).toString = function () {
    return 'Friend(id=' + this.tz7_1 + ', userId=' + this.uz7_1 + ', name=' + this.vz7_1 + ', relationship=' + this.wz7_1 + ', buildingNo=' + this.xz7_1 + ', street=' + this.yz7_1 + ', neighbourhood=' + this.zz7_1 + ', city=' + this.az8_1 + ', country=' + this.bz8_1 + ', personalPhoneNumber=' + this.cz8_1 + ', workPhoneNumber=' + this.dz8_1 + ', dateOfBirthday=' + toString_0(this.ez8_1) + ', avatarUrl=' + this.fz8_1 + ')';
  };
  protoOf(Friend).hashCode = function () {
    var result = this.tz7_1 == null ? 0 : getStringHashCode(this.tz7_1);
    result = imul(result, 31) + getStringHashCode(this.uz7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vz7_1) | 0;
    result = imul(result, 31) + (this.wz7_1 == null ? 0 : getStringHashCode(this.wz7_1)) | 0;
    result = imul(result, 31) + (this.xz7_1 == null ? 0 : getStringHashCode(this.xz7_1)) | 0;
    result = imul(result, 31) + (this.yz7_1 == null ? 0 : getStringHashCode(this.yz7_1)) | 0;
    result = imul(result, 31) + (this.zz7_1 == null ? 0 : getStringHashCode(this.zz7_1)) | 0;
    result = imul(result, 31) + (this.az8_1 == null ? 0 : getStringHashCode(this.az8_1)) | 0;
    result = imul(result, 31) + (this.bz8_1 == null ? 0 : getStringHashCode(this.bz8_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.cz8_1) | 0;
    result = imul(result, 31) + (this.dz8_1 == null ? 0 : getStringHashCode(this.dz8_1)) | 0;
    result = imul(result, 31) + (this.ez8_1 == null ? 0 : this.ez8_1.hashCode()) | 0;
    result = imul(result, 31) + (this.fz8_1 == null ? 0 : getStringHashCode(this.fz8_1)) | 0;
    return result;
  };
  protoOf(Friend).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Friend))
      return false;
    if (!(this.tz7_1 == other.tz7_1))
      return false;
    if (!(this.uz7_1 === other.uz7_1))
      return false;
    if (!(this.vz7_1 === other.vz7_1))
      return false;
    if (!(this.wz7_1 == other.wz7_1))
      return false;
    if (!(this.xz7_1 == other.xz7_1))
      return false;
    if (!(this.yz7_1 == other.yz7_1))
      return false;
    if (!(this.zz7_1 == other.zz7_1))
      return false;
    if (!(this.az8_1 == other.az8_1))
      return false;
    if (!(this.bz8_1 == other.bz8_1))
      return false;
    if (!(this.cz8_1 === other.cz8_1))
      return false;
    if (!(this.dz8_1 == other.dz8_1))
      return false;
    if (!equals(this.ez8_1, other.ez8_1))
      return false;
    if (!(this.fz8_1 == other.fz8_1))
      return false;
    return true;
  };
  var client_fstech_hadaya_domain_model_Notification_$serializer$stable;
  var client_fstech_hadaya_domain_model_Notification$stable;
  function Companion_10() {
  }
  var Companion_instance_16;
  function Companion_getInstance_45() {
    return Companion_instance_16;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.Notification', this, 11);
    tmp0_serialDesc.a7c('id', true);
    tmp0_serialDesc.a7c('title', false);
    tmp0_serialDesc.a7c('body', false);
    tmp0_serialDesc.a7c('created_at', true);
    tmp0_serialDesc.a7c('user_id', true);
    tmp0_serialDesc.a7c('sender_id', true);
    tmp0_serialDesc.a7c('receiver_id', true);
    tmp0_serialDesc.a7c('order_id', true);
    tmp0_serialDesc.a7c('status', true);
    tmp0_serialDesc.a7c('link', true);
    tmp0_serialDesc.a7c('image_url', true);
    this.wzz_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).xzz = function (encoder, value) {
    var tmp0_desc = this.wzz_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.mzb_1 === randomUUID())) {
      tmp1_output.c76(tmp0_desc, 0, value.mzb_1);
    }
    tmp1_output.c76(tmp0_desc, 1, value.nzb_1);
    tmp1_output.c76(tmp0_desc, 2, value.ozb_1);
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.pzb_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, StringSerializer_getInstance(), value.pzb_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.qzb_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.qzb_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.rzb_1 == null)) {
      tmp1_output.g76(tmp0_desc, 5, StringSerializer_getInstance(), value.rzb_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.szb_1 == null)) {
      tmp1_output.g76(tmp0_desc, 6, StringSerializer_getInstance(), value.szb_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.tzb_1 == null)) {
      tmp1_output.g76(tmp0_desc, 7, LongSerializer_getInstance(), value.tzb_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !(value.uzb_1 == null)) {
      tmp1_output.g76(tmp0_desc, 8, StringSerializer_getInstance(), value.uzb_1);
    }
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !(value.vzb_1 == null)) {
      tmp1_output.g76(tmp0_desc, 9, StringSerializer_getInstance(), value.vzb_1);
    }
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.wzb_1 == null)) {
      tmp1_output.g76(tmp0_desc, 10, StringSerializer_getInstance(), value.wzb_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_9).z70 = function (encoder, value) {
    return this.xzz(encoder, value instanceof Notification ? value : THROW_CCE());
  };
  protoOf($serializer_9).a71 = function (decoder) {
    var tmp0_desc = this.wzz_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_input = decoder.n74(tmp0_desc);
    if (tmp15_input.d75()) {
      tmp4_local0 = tmp15_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.x74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.x74(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.b75(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.b75(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.x74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.x74(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.b75(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.b75(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.o74(tmp0_desc);
    return Notification_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_9).y70 = function () {
    return this.wzz_1;
  };
  protoOf($serializer_9).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_9;
  function $serializer_getInstance_9() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function Notification_init_$Init$(seen0, id, title, body, createdAt, userId, senderId, receiverId, orderId, status, link, imageUrl, serializationConstructorMarker, $this) {
    if (!(6 === (6 & seen0))) {
      throwMissingFieldException(seen0, 6, $serializer_getInstance_9().wzz_1);
    }
    if (0 === (seen0 & 1))
      $this.mzb_1 = randomUUID();
    else
      $this.mzb_1 = id;
    $this.nzb_1 = title;
    $this.ozb_1 = body;
    if (0 === (seen0 & 8))
      $this.pzb_1 = null;
    else
      $this.pzb_1 = createdAt;
    if (0 === (seen0 & 16))
      $this.qzb_1 = null;
    else
      $this.qzb_1 = userId;
    if (0 === (seen0 & 32))
      $this.rzb_1 = null;
    else
      $this.rzb_1 = senderId;
    if (0 === (seen0 & 64))
      $this.szb_1 = null;
    else
      $this.szb_1 = receiverId;
    if (0 === (seen0 & 128))
      $this.tzb_1 = null;
    else
      $this.tzb_1 = orderId;
    if (0 === (seen0 & 256))
      $this.uzb_1 = null;
    else
      $this.uzb_1 = status;
    if (0 === (seen0 & 512))
      $this.vzb_1 = null;
    else
      $this.vzb_1 = link;
    if (0 === (seen0 & 1024))
      $this.wzb_1 = null;
    else
      $this.wzb_1 = imageUrl;
    return $this;
  }
  function Notification_init_$Create$(seen0, id, title, body, createdAt, userId, senderId, receiverId, orderId, status, link, imageUrl, serializationConstructorMarker) {
    return Notification_init_$Init$(seen0, id, title, body, createdAt, userId, senderId, receiverId, orderId, status, link, imageUrl, serializationConstructorMarker, objectCreate(protoOf(Notification)));
  }
  function Notification(id, title, body, createdAt, userId, senderId, receiverId, orderId, status, link, imageUrl) {
    id = id === VOID ? randomUUID() : id;
    createdAt = createdAt === VOID ? null : createdAt;
    userId = userId === VOID ? null : userId;
    senderId = senderId === VOID ? null : senderId;
    receiverId = receiverId === VOID ? null : receiverId;
    orderId = orderId === VOID ? null : orderId;
    status = status === VOID ? null : status;
    link = link === VOID ? null : link;
    imageUrl = imageUrl === VOID ? null : imageUrl;
    this.mzb_1 = id;
    this.nzb_1 = title;
    this.ozb_1 = body;
    this.pzb_1 = createdAt;
    this.qzb_1 = userId;
    this.rzb_1 = senderId;
    this.szb_1 = receiverId;
    this.tzb_1 = orderId;
    this.uzb_1 = status;
    this.vzb_1 = link;
    this.wzb_1 = imageUrl;
  }
  protoOf(Notification).toString = function () {
    return 'Notification(id=' + this.mzb_1 + ', title=' + this.nzb_1 + ', body=' + this.ozb_1 + ', createdAt=' + this.pzb_1 + ', userId=' + this.qzb_1 + ', senderId=' + this.rzb_1 + ', receiverId=' + this.szb_1 + ', orderId=' + toString_0(this.tzb_1) + ', status=' + this.uzb_1 + ', link=' + this.vzb_1 + ', imageUrl=' + this.wzb_1 + ')';
  };
  protoOf(Notification).hashCode = function () {
    var result = getStringHashCode(this.mzb_1);
    result = imul(result, 31) + getStringHashCode(this.nzb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ozb_1) | 0;
    result = imul(result, 31) + (this.pzb_1 == null ? 0 : getStringHashCode(this.pzb_1)) | 0;
    result = imul(result, 31) + (this.qzb_1 == null ? 0 : getStringHashCode(this.qzb_1)) | 0;
    result = imul(result, 31) + (this.rzb_1 == null ? 0 : getStringHashCode(this.rzb_1)) | 0;
    result = imul(result, 31) + (this.szb_1 == null ? 0 : getStringHashCode(this.szb_1)) | 0;
    result = imul(result, 31) + (this.tzb_1 == null ? 0 : this.tzb_1.hashCode()) | 0;
    result = imul(result, 31) + (this.uzb_1 == null ? 0 : getStringHashCode(this.uzb_1)) | 0;
    result = imul(result, 31) + (this.vzb_1 == null ? 0 : getStringHashCode(this.vzb_1)) | 0;
    result = imul(result, 31) + (this.wzb_1 == null ? 0 : getStringHashCode(this.wzb_1)) | 0;
    return result;
  };
  protoOf(Notification).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Notification))
      return false;
    if (!(this.mzb_1 === other.mzb_1))
      return false;
    if (!(this.nzb_1 === other.nzb_1))
      return false;
    if (!(this.ozb_1 === other.ozb_1))
      return false;
    if (!(this.pzb_1 == other.pzb_1))
      return false;
    if (!(this.qzb_1 == other.qzb_1))
      return false;
    if (!(this.rzb_1 == other.rzb_1))
      return false;
    if (!(this.szb_1 == other.szb_1))
      return false;
    if (!equals(this.tzb_1, other.tzb_1))
      return false;
    if (!(this.uzb_1 == other.uzb_1))
      return false;
    if (!(this.vzb_1 == other.vzb_1))
      return false;
    if (!(this.wzb_1 == other.wzb_1))
      return false;
    return true;
  };
  var client_fstech_hadaya_domain_model_Order_$serializer$stable;
  var client_fstech_hadaya_domain_model_Order$stable;
  function Order$Companion$$childSerializers$_anonymous__jb336s() {
    return new ArrayListSerializer($serializer_getInstance_5());
  }
  function Order$Companion$$childSerializers$_anonymous__jb336s_0() {
    return Companion_getInstance_47().amj();
  }
  function Order$Companion$$childSerializers$_anonymous__jb336s_1() {
    return Companion_getInstance_48().amj();
  }
  function Companion_11() {
    Companion_instance_17 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, Order$Companion$$childSerializers$_anonymous__jb336s);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy_0(tmp_2, Order$Companion$$childSerializers$_anonymous__jb336s_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a100_1 = [null, null, null, null, null, null, null, null, null, tmp_1, null, null, null, null, tmp_3, lazy_0(tmp_4, Order$Companion$$childSerializers$_anonymous__jb336s_1), null, null, null, null, null, null, null, null];
  }
  var Companion_instance_17;
  function Companion_getInstance_46() {
    if (Companion_instance_17 == null)
      new Companion_11();
    return Companion_instance_17;
  }
  function $serializer_10() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.Order', this, 24);
    tmp0_serialDesc.a7c('id', true);
    tmp0_serialDesc.a7c('user_id', true);
    tmp0_serialDesc.a7c('sender_name', true);
    tmp0_serialDesc.a7c('is_for_friend', true);
    tmp0_serialDesc.a7c('friend_id', true);
    tmp0_serialDesc.a7c('receiver_name', false);
    tmp0_serialDesc.a7c('address', false);
    tmp0_serialDesc.a7c('latLng', false);
    tmp0_serialDesc.a7c('phone', false);
    tmp0_serialDesc.a7c('items', false);
    tmp0_serialDesc.a7c('subtotal', false);
    tmp0_serialDesc.a7c('discount', true);
    tmp0_serialDesc.a7c('shipping_cost', true);
    tmp0_serialDesc.a7c('total_price', false);
    tmp0_serialDesc.a7c('payment_method', true);
    tmp0_serialDesc.a7c('status', true);
    tmp0_serialDesc.a7c('notes', true);
    tmp0_serialDesc.a7c('user_comment', true);
    tmp0_serialDesc.a7c('card_message', true);
    tmp0_serialDesc.a7c('card_birthday', true);
    tmp0_serialDesc.a7c('created_at', true);
    tmp0_serialDesc.a7c('updated_at', true);
    tmp0_serialDesc.a7c('coupon_id', true);
    tmp0_serialDesc.a7c('platform', true);
    this.b100_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).c100 = function (encoder, value) {
    var tmp0_desc = this.b100_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_46().a100_1;
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.lzc_1 == null)) {
      tmp1_output.g76(tmp0_desc, 0, LongSerializer_getInstance(), value.lzc_1);
    }
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.mzc_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.mzc_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.nzc_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.nzc_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.ozc_1 === false)) {
      tmp1_output.u75(tmp0_desc, 3, value.ozc_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.pzc_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.pzc_1);
    }
    tmp1_output.c76(tmp0_desc, 5, value.qzc_1);
    tmp1_output.c76(tmp0_desc, 6, value.rzc_1);
    tmp1_output.c76(tmp0_desc, 7, value.szc_1);
    tmp1_output.c76(tmp0_desc, 8, value.tzc_1);
    tmp1_output.e76(tmp0_desc, 9, tmp2_cached[9].u1(), value.uzc_1);
    tmp1_output.a76(tmp0_desc, 10, value.vzc_1);
    if (tmp1_output.k76(tmp0_desc, 11) ? true : !equals(value.wzc_1, 0.0)) {
      tmp1_output.a76(tmp0_desc, 11, value.wzc_1);
    }
    if (tmp1_output.k76(tmp0_desc, 12) ? true : !equals(value.xzc_1, 0.0)) {
      tmp1_output.a76(tmp0_desc, 12, value.xzc_1);
    }
    tmp1_output.a76(tmp0_desc, 13, value.yzc_1);
    if (tmp1_output.k76(tmp0_desc, 14) ? true : !value.zzc_1.equals(PaymentMethod_CASH_ON_DELIVERY_getInstance())) {
      tmp1_output.e76(tmp0_desc, 14, tmp2_cached[14].u1(), value.zzc_1);
    }
    if (tmp1_output.k76(tmp0_desc, 15) ? true : !value.azd_1.equals(OrderStatus_RECEIVED_getInstance())) {
      tmp1_output.e76(tmp0_desc, 15, tmp2_cached[15].u1(), value.azd_1);
    }
    if (tmp1_output.k76(tmp0_desc, 16) ? true : !(value.bzd_1 == null)) {
      tmp1_output.g76(tmp0_desc, 16, StringSerializer_getInstance(), value.bzd_1);
    }
    if (tmp1_output.k76(tmp0_desc, 17) ? true : !(value.czd_1 == null)) {
      tmp1_output.g76(tmp0_desc, 17, StringSerializer_getInstance(), value.czd_1);
    }
    if (tmp1_output.k76(tmp0_desc, 18) ? true : !(value.dzd_1 == null)) {
      tmp1_output.g76(tmp0_desc, 18, StringSerializer_getInstance(), value.dzd_1);
    }
    if (tmp1_output.k76(tmp0_desc, 19) ? true : !(value.ezd_1 == null)) {
      tmp1_output.g76(tmp0_desc, 19, StringSerializer_getInstance(), value.ezd_1);
    }
    if (tmp1_output.k76(tmp0_desc, 20) ? true : !(value.fzd_1 == null)) {
      tmp1_output.g76(tmp0_desc, 20, LongSerializer_getInstance(), value.fzd_1);
    }
    if (tmp1_output.k76(tmp0_desc, 21) ? true : !(value.gzd_1 == null)) {
      tmp1_output.g76(tmp0_desc, 21, LongSerializer_getInstance(), value.gzd_1);
    }
    if (tmp1_output.k76(tmp0_desc, 22) ? true : !(value.hzd_1 == null)) {
      tmp1_output.g76(tmp0_desc, 22, LongSerializer_getInstance(), value.hzd_1);
    }
    if (tmp1_output.k76(tmp0_desc, 23) ? true : !(value.izd_1 == null)) {
      tmp1_output.g76(tmp0_desc, 23, StringSerializer_getInstance(), value.izd_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_10).z70 = function (encoder, value) {
    return this.c100(encoder, value instanceof Order ? value : THROW_CCE());
  };
  protoOf($serializer_10).a71 = function (decoder) {
    var tmp0_desc = this.b100_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = 0.0;
    var tmp15_local11 = 0.0;
    var tmp16_local12 = 0.0;
    var tmp17_local13 = 0.0;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = null;
    var tmp25_local21 = null;
    var tmp26_local22 = null;
    var tmp27_local23 = null;
    var tmp28_input = decoder.n74(tmp0_desc);
    var tmp29_cached = Companion_getInstance_46().a100_1;
    if (tmp28_input.d75()) {
      tmp4_local0 = tmp28_input.b75(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp28_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp28_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp28_input.p74(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp28_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp28_input.x74(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp28_input.x74(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp28_input.x74(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp28_input.x74(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp28_input.z74(tmp0_desc, 9, tmp29_cached[9].u1(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp28_input.v74(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp28_input.v74(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp28_input.v74(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp28_input.v74(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp28_input.z74(tmp0_desc, 14, tmp29_cached[14].u1(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp28_input.z74(tmp0_desc, 15, tmp29_cached[15].u1(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp28_input.b75(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp28_input.b75(tmp0_desc, 17, StringSerializer_getInstance(), tmp21_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp28_input.b75(tmp0_desc, 18, StringSerializer_getInstance(), tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp28_input.b75(tmp0_desc, 19, StringSerializer_getInstance(), tmp23_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp28_input.b75(tmp0_desc, 20, LongSerializer_getInstance(), tmp24_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp28_input.b75(tmp0_desc, 21, LongSerializer_getInstance(), tmp25_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp28_input.b75(tmp0_desc, 22, LongSerializer_getInstance(), tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp28_input.b75(tmp0_desc, 23, StringSerializer_getInstance(), tmp27_local23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp28_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp28_input.b75(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp28_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp28_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp28_input.p74(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp28_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp28_input.x74(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp28_input.x74(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp28_input.x74(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp28_input.x74(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp28_input.z74(tmp0_desc, 9, tmp29_cached[9].u1(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp28_input.v74(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp28_input.v74(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp28_input.v74(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp28_input.v74(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp28_input.z74(tmp0_desc, 14, tmp29_cached[14].u1(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp28_input.z74(tmp0_desc, 15, tmp29_cached[15].u1(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp28_input.b75(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp28_input.b75(tmp0_desc, 17, StringSerializer_getInstance(), tmp21_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp28_input.b75(tmp0_desc, 18, StringSerializer_getInstance(), tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp28_input.b75(tmp0_desc, 19, StringSerializer_getInstance(), tmp23_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp28_input.b75(tmp0_desc, 20, LongSerializer_getInstance(), tmp24_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp28_input.b75(tmp0_desc, 21, LongSerializer_getInstance(), tmp25_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp28_input.b75(tmp0_desc, 22, LongSerializer_getInstance(), tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp28_input.b75(tmp0_desc, 23, StringSerializer_getInstance(), tmp27_local23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp28_input.o74(tmp0_desc);
    return Order_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, null);
  };
  protoOf($serializer_10).y70 = function () {
    return this.b100_1;
  };
  protoOf($serializer_10).t7c = function () {
    var tmp0_cached = Companion_getInstance_46().a100_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[9].u1(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), tmp0_cached[14].u1(), tmp0_cached[15].u1(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_10;
  function $serializer_getInstance_10() {
    if ($serializer_instance_10 == null)
      new $serializer_10();
    return $serializer_instance_10;
  }
  function Order_init_$Init$(seen0, id, userId, senderName, isForFriend, friendId, receiverName, address, latLng, phone, items, subtotal, discount, shippingCost, totalPrice, paymentMethod, status, notes, userComment, cardMessage, cardBirthday, createdAt, updatedAt, couponId, platform, serializationConstructorMarker, $this) {
    if (!(10208 === (10208 & seen0))) {
      throwMissingFieldException(seen0, 10208, $serializer_getInstance_10().b100_1);
    }
    if (0 === (seen0 & 1))
      $this.lzc_1 = null;
    else
      $this.lzc_1 = id;
    if (0 === (seen0 & 2))
      $this.mzc_1 = null;
    else
      $this.mzc_1 = userId;
    if (0 === (seen0 & 4))
      $this.nzc_1 = null;
    else
      $this.nzc_1 = senderName;
    if (0 === (seen0 & 8))
      $this.ozc_1 = false;
    else
      $this.ozc_1 = isForFriend;
    if (0 === (seen0 & 16))
      $this.pzc_1 = null;
    else
      $this.pzc_1 = friendId;
    $this.qzc_1 = receiverName;
    $this.rzc_1 = address;
    $this.szc_1 = latLng;
    $this.tzc_1 = phone;
    $this.uzc_1 = items;
    $this.vzc_1 = subtotal;
    if (0 === (seen0 & 2048))
      $this.wzc_1 = 0.0;
    else
      $this.wzc_1 = discount;
    if (0 === (seen0 & 4096))
      $this.xzc_1 = 0.0;
    else
      $this.xzc_1 = shippingCost;
    $this.yzc_1 = totalPrice;
    if (0 === (seen0 & 16384))
      $this.zzc_1 = PaymentMethod_CASH_ON_DELIVERY_getInstance();
    else
      $this.zzc_1 = paymentMethod;
    if (0 === (seen0 & 32768))
      $this.azd_1 = OrderStatus_RECEIVED_getInstance();
    else
      $this.azd_1 = status;
    if (0 === (seen0 & 65536))
      $this.bzd_1 = null;
    else
      $this.bzd_1 = notes;
    if (0 === (seen0 & 131072))
      $this.czd_1 = null;
    else
      $this.czd_1 = userComment;
    if (0 === (seen0 & 262144))
      $this.dzd_1 = null;
    else
      $this.dzd_1 = cardMessage;
    if (0 === (seen0 & 524288))
      $this.ezd_1 = null;
    else
      $this.ezd_1 = cardBirthday;
    if (0 === (seen0 & 1048576))
      $this.fzd_1 = null;
    else
      $this.fzd_1 = createdAt;
    if (0 === (seen0 & 2097152))
      $this.gzd_1 = null;
    else
      $this.gzd_1 = updatedAt;
    if (0 === (seen0 & 4194304))
      $this.hzd_1 = null;
    else
      $this.hzd_1 = couponId;
    if (0 === (seen0 & 8388608))
      $this.izd_1 = null;
    else
      $this.izd_1 = platform;
    return $this;
  }
  function Order_init_$Create$(seen0, id, userId, senderName, isForFriend, friendId, receiverName, address, latLng, phone, items, subtotal, discount, shippingCost, totalPrice, paymentMethod, status, notes, userComment, cardMessage, cardBirthday, createdAt, updatedAt, couponId, platform, serializationConstructorMarker) {
    return Order_init_$Init$(seen0, id, userId, senderName, isForFriend, friendId, receiverName, address, latLng, phone, items, subtotal, discount, shippingCost, totalPrice, paymentMethod, status, notes, userComment, cardMessage, cardBirthday, createdAt, updatedAt, couponId, platform, serializationConstructorMarker, objectCreate(protoOf(Order)));
  }
  function Order(id, userId, senderName, isForFriend, friendId, receiverName, address, latLng, phone, items, subtotal, discount, shippingCost, totalPrice, paymentMethod, status, notes, userComment, cardMessage, cardBirthday, createdAt, updatedAt, couponId, platform) {
    Companion_getInstance_46();
    id = id === VOID ? null : id;
    userId = userId === VOID ? null : userId;
    senderName = senderName === VOID ? null : senderName;
    isForFriend = isForFriend === VOID ? false : isForFriend;
    friendId = friendId === VOID ? null : friendId;
    discount = discount === VOID ? 0.0 : discount;
    shippingCost = shippingCost === VOID ? 0.0 : shippingCost;
    paymentMethod = paymentMethod === VOID ? PaymentMethod_CASH_ON_DELIVERY_getInstance() : paymentMethod;
    status = status === VOID ? OrderStatus_RECEIVED_getInstance() : status;
    notes = notes === VOID ? null : notes;
    userComment = userComment === VOID ? null : userComment;
    cardMessage = cardMessage === VOID ? null : cardMessage;
    cardBirthday = cardBirthday === VOID ? null : cardBirthday;
    createdAt = createdAt === VOID ? null : createdAt;
    updatedAt = updatedAt === VOID ? null : updatedAt;
    couponId = couponId === VOID ? null : couponId;
    platform = platform === VOID ? null : platform;
    this.lzc_1 = id;
    this.mzc_1 = userId;
    this.nzc_1 = senderName;
    this.ozc_1 = isForFriend;
    this.pzc_1 = friendId;
    this.qzc_1 = receiverName;
    this.rzc_1 = address;
    this.szc_1 = latLng;
    this.tzc_1 = phone;
    this.uzc_1 = items;
    this.vzc_1 = subtotal;
    this.wzc_1 = discount;
    this.xzc_1 = shippingCost;
    this.yzc_1 = totalPrice;
    this.zzc_1 = paymentMethod;
    this.azd_1 = status;
    this.bzd_1 = notes;
    this.czd_1 = userComment;
    this.dzd_1 = cardMessage;
    this.ezd_1 = cardBirthday;
    this.fzd_1 = createdAt;
    this.gzd_1 = updatedAt;
    this.hzd_1 = couponId;
    this.izd_1 = platform;
  }
  protoOf(Order).d100 = function (id, userId, senderName, isForFriend, friendId, receiverName, address, latLng, phone, items, subtotal, discount, shippingCost, totalPrice, paymentMethod, status, notes, userComment, cardMessage, cardBirthday, createdAt, updatedAt, couponId, platform) {
    return new Order(id, userId, senderName, isForFriend, friendId, receiverName, address, latLng, phone, items, subtotal, discount, shippingCost, totalPrice, paymentMethod, status, notes, userComment, cardMessage, cardBirthday, createdAt, updatedAt, couponId, platform);
  };
  protoOf(Order).jzd = function (id, userId, senderName, isForFriend, friendId, receiverName, address, latLng, phone, items, subtotal, discount, shippingCost, totalPrice, paymentMethod, status, notes, userComment, cardMessage, cardBirthday, createdAt, updatedAt, couponId, platform, $super) {
    id = id === VOID ? this.lzc_1 : id;
    userId = userId === VOID ? this.mzc_1 : userId;
    senderName = senderName === VOID ? this.nzc_1 : senderName;
    isForFriend = isForFriend === VOID ? this.ozc_1 : isForFriend;
    friendId = friendId === VOID ? this.pzc_1 : friendId;
    receiverName = receiverName === VOID ? this.qzc_1 : receiverName;
    address = address === VOID ? this.rzc_1 : address;
    latLng = latLng === VOID ? this.szc_1 : latLng;
    phone = phone === VOID ? this.tzc_1 : phone;
    items = items === VOID ? this.uzc_1 : items;
    subtotal = subtotal === VOID ? this.vzc_1 : subtotal;
    discount = discount === VOID ? this.wzc_1 : discount;
    shippingCost = shippingCost === VOID ? this.xzc_1 : shippingCost;
    totalPrice = totalPrice === VOID ? this.yzc_1 : totalPrice;
    paymentMethod = paymentMethod === VOID ? this.zzc_1 : paymentMethod;
    status = status === VOID ? this.azd_1 : status;
    notes = notes === VOID ? this.bzd_1 : notes;
    userComment = userComment === VOID ? this.czd_1 : userComment;
    cardMessage = cardMessage === VOID ? this.dzd_1 : cardMessage;
    cardBirthday = cardBirthday === VOID ? this.ezd_1 : cardBirthday;
    createdAt = createdAt === VOID ? this.fzd_1 : createdAt;
    updatedAt = updatedAt === VOID ? this.gzd_1 : updatedAt;
    couponId = couponId === VOID ? this.hzd_1 : couponId;
    platform = platform === VOID ? this.izd_1 : platform;
    return $super === VOID ? this.d100(id, userId, senderName, isForFriend, friendId, receiverName, address, latLng, phone, items, subtotal, discount, shippingCost, totalPrice, paymentMethod, status, notes, userComment, cardMessage, cardBirthday, createdAt, updatedAt, couponId, platform) : $super.d100.call(this, id, userId, senderName, isForFriend, friendId, receiverName, address, latLng, phone, items, subtotal, discount, shippingCost, totalPrice, paymentMethod, status, notes, userComment, cardMessage, cardBirthday, createdAt, updatedAt, couponId, platform);
  };
  protoOf(Order).toString = function () {
    return 'Order(id=' + toString_0(this.lzc_1) + ', userId=' + this.mzc_1 + ', senderName=' + this.nzc_1 + ', isForFriend=' + this.ozc_1 + ', friendId=' + this.pzc_1 + ', receiverName=' + this.qzc_1 + ', address=' + this.rzc_1 + ', latLng=' + this.szc_1 + ', phone=' + this.tzc_1 + ', items=' + toString(this.uzc_1) + ', subtotal=' + this.vzc_1 + ', discount=' + this.wzc_1 + ', shippingCost=' + this.xzc_1 + ', totalPrice=' + this.yzc_1 + ', paymentMethod=' + this.zzc_1.toString() + ', status=' + this.azd_1.toString() + ', notes=' + this.bzd_1 + ', userComment=' + this.czd_1 + ', cardMessage=' + this.dzd_1 + ', cardBirthday=' + this.ezd_1 + ', createdAt=' + toString_0(this.fzd_1) + ', updatedAt=' + toString_0(this.gzd_1) + ', couponId=' + toString_0(this.hzd_1) + ', platform=' + this.izd_1 + ')';
  };
  protoOf(Order).hashCode = function () {
    var result = this.lzc_1 == null ? 0 : this.lzc_1.hashCode();
    result = imul(result, 31) + (this.mzc_1 == null ? 0 : getStringHashCode(this.mzc_1)) | 0;
    result = imul(result, 31) + (this.nzc_1 == null ? 0 : getStringHashCode(this.nzc_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ozc_1) | 0;
    result = imul(result, 31) + (this.pzc_1 == null ? 0 : getStringHashCode(this.pzc_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.qzc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rzc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.szc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.tzc_1) | 0;
    result = imul(result, 31) + hashCode(this.uzc_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.vzc_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.wzc_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.xzc_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.yzc_1) | 0;
    result = imul(result, 31) + this.zzc_1.hashCode() | 0;
    result = imul(result, 31) + this.azd_1.hashCode() | 0;
    result = imul(result, 31) + (this.bzd_1 == null ? 0 : getStringHashCode(this.bzd_1)) | 0;
    result = imul(result, 31) + (this.czd_1 == null ? 0 : getStringHashCode(this.czd_1)) | 0;
    result = imul(result, 31) + (this.dzd_1 == null ? 0 : getStringHashCode(this.dzd_1)) | 0;
    result = imul(result, 31) + (this.ezd_1 == null ? 0 : getStringHashCode(this.ezd_1)) | 0;
    result = imul(result, 31) + (this.fzd_1 == null ? 0 : this.fzd_1.hashCode()) | 0;
    result = imul(result, 31) + (this.gzd_1 == null ? 0 : this.gzd_1.hashCode()) | 0;
    result = imul(result, 31) + (this.hzd_1 == null ? 0 : this.hzd_1.hashCode()) | 0;
    result = imul(result, 31) + (this.izd_1 == null ? 0 : getStringHashCode(this.izd_1)) | 0;
    return result;
  };
  protoOf(Order).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Order))
      return false;
    if (!equals(this.lzc_1, other.lzc_1))
      return false;
    if (!(this.mzc_1 == other.mzc_1))
      return false;
    if (!(this.nzc_1 == other.nzc_1))
      return false;
    if (!(this.ozc_1 === other.ozc_1))
      return false;
    if (!(this.pzc_1 == other.pzc_1))
      return false;
    if (!(this.qzc_1 === other.qzc_1))
      return false;
    if (!(this.rzc_1 === other.rzc_1))
      return false;
    if (!(this.szc_1 === other.szc_1))
      return false;
    if (!(this.tzc_1 === other.tzc_1))
      return false;
    if (!equals(this.uzc_1, other.uzc_1))
      return false;
    if (!equals(this.vzc_1, other.vzc_1))
      return false;
    if (!equals(this.wzc_1, other.wzc_1))
      return false;
    if (!equals(this.xzc_1, other.xzc_1))
      return false;
    if (!equals(this.yzc_1, other.yzc_1))
      return false;
    if (!this.zzc_1.equals(other.zzc_1))
      return false;
    if (!this.azd_1.equals(other.azd_1))
      return false;
    if (!(this.bzd_1 == other.bzd_1))
      return false;
    if (!(this.czd_1 == other.czd_1))
      return false;
    if (!(this.dzd_1 == other.dzd_1))
      return false;
    if (!(this.ezd_1 == other.ezd_1))
      return false;
    if (!equals(this.fzd_1, other.fzd_1))
      return false;
    if (!equals(this.gzd_1, other.gzd_1))
      return false;
    if (!equals(this.hzd_1, other.hzd_1))
      return false;
    if (!(this.izd_1 == other.izd_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_0($this) {
    return $this.yzz_1.u1();
  }
  function PaymentMethod$Companion$_anonymous__lsin48() {
    return createSimpleEnumSerializer('client.fstech.hadaya.domain.model.PaymentMethod', values_0());
  }
  var PaymentMethod_CASH_ON_DELIVERY_instance;
  var PaymentMethod_INSTAPAY_instance;
  var PaymentMethod_WALLET_instance;
  var PaymentMethod_VISA_instance;
  var PaymentMethod_MASTERCARD_instance;
  var PaymentMethod_APPLE_PAY_instance;
  var PaymentMethod_GOOGLE_PAY_instance;
  function values_0() {
    return [PaymentMethod_CASH_ON_DELIVERY_getInstance(), PaymentMethod_INSTAPAY_getInstance(), PaymentMethod_WALLET_getInstance(), PaymentMethod_VISA_getInstance(), PaymentMethod_MASTERCARD_getInstance(), PaymentMethod_APPLE_PAY_getInstance(), PaymentMethod_GOOGLE_PAY_getInstance()];
  }
  function Companion_12() {
    Companion_instance_18 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.yzz_1 = lazy_0(tmp_0, PaymentMethod$Companion$_anonymous__lsin48);
  }
  protoOf(Companion_12).amj = function () {
    return _get_$cachedSerializer__te6jhj_0(this);
  };
  protoOf(Companion_12).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  var Companion_instance_18;
  function Companion_getInstance_47() {
    PaymentMethod_initEntries();
    if (Companion_instance_18 == null)
      new Companion_12();
    return Companion_instance_18;
  }
  var PaymentMethod_entriesInitialized;
  function PaymentMethod_initEntries() {
    if (PaymentMethod_entriesInitialized)
      return Unit_instance;
    PaymentMethod_entriesInitialized = true;
    PaymentMethod_CASH_ON_DELIVERY_instance = new PaymentMethod('CASH_ON_DELIVERY', 0);
    PaymentMethod_INSTAPAY_instance = new PaymentMethod('INSTAPAY', 1);
    PaymentMethod_WALLET_instance = new PaymentMethod('WALLET', 2);
    PaymentMethod_VISA_instance = new PaymentMethod('VISA', 3);
    PaymentMethod_MASTERCARD_instance = new PaymentMethod('MASTERCARD', 4);
    PaymentMethod_APPLE_PAY_instance = new PaymentMethod('APPLE_PAY', 5);
    PaymentMethod_GOOGLE_PAY_instance = new PaymentMethod('GOOGLE_PAY', 6);
    Companion_getInstance_47();
  }
  function PaymentMethod(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function _get_$cachedSerializer__te6jhj_1($this) {
    return $this.zzz_1.u1();
  }
  function OrderStatus$Companion$_anonymous__kwqzv5() {
    return createSimpleEnumSerializer('client.fstech.hadaya.domain.model.OrderStatus', values_1());
  }
  var OrderStatus_RECEIVED_instance;
  var OrderStatus_PREPARING_instance;
  var OrderStatus_ON_THE_WAY_instance;
  var OrderStatus_FAILED_instance;
  var OrderStatus_COMPLETED_instance;
  var OrderStatus_RETURN_REQUESTED_instance;
  var OrderStatus_RETURN_DELIVERY_instance;
  var OrderStatus_RETURNED_instance;
  var OrderStatus_MONEY_RETURNED_instance;
  var OrderStatus_ARCHIVED_instance;
  function values_1() {
    return [OrderStatus_RECEIVED_getInstance(), OrderStatus_PREPARING_getInstance(), OrderStatus_ON_THE_WAY_getInstance(), OrderStatus_FAILED_getInstance(), OrderStatus_COMPLETED_getInstance(), OrderStatus_RETURN_REQUESTED_getInstance(), OrderStatus_RETURN_DELIVERY_getInstance(), OrderStatus_RETURNED_getInstance(), OrderStatus_MONEY_RETURNED_getInstance(), OrderStatus_ARCHIVED_getInstance()];
  }
  function Companion_13() {
    Companion_instance_19 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.zzz_1 = lazy_0(tmp_0, OrderStatus$Companion$_anonymous__kwqzv5);
  }
  protoOf(Companion_13).amj = function () {
    return _get_$cachedSerializer__te6jhj_1(this);
  };
  protoOf(Companion_13).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  var Companion_instance_19;
  function Companion_getInstance_48() {
    OrderStatus_initEntries();
    if (Companion_instance_19 == null)
      new Companion_13();
    return Companion_instance_19;
  }
  var OrderStatus_entriesInitialized;
  function OrderStatus_initEntries() {
    if (OrderStatus_entriesInitialized)
      return Unit_instance;
    OrderStatus_entriesInitialized = true;
    OrderStatus_RECEIVED_instance = new OrderStatus('RECEIVED', 0);
    OrderStatus_PREPARING_instance = new OrderStatus('PREPARING', 1);
    OrderStatus_ON_THE_WAY_instance = new OrderStatus('ON_THE_WAY', 2);
    OrderStatus_FAILED_instance = new OrderStatus('FAILED', 3);
    OrderStatus_COMPLETED_instance = new OrderStatus('COMPLETED', 4);
    OrderStatus_RETURN_REQUESTED_instance = new OrderStatus('RETURN_REQUESTED', 5);
    OrderStatus_RETURN_DELIVERY_instance = new OrderStatus('RETURN_DELIVERY', 6);
    OrderStatus_RETURNED_instance = new OrderStatus('RETURNED', 7);
    OrderStatus_MONEY_RETURNED_instance = new OrderStatus('MONEY_RETURNED', 8);
    OrderStatus_ARCHIVED_instance = new OrderStatus('ARCHIVED', 9);
    Companion_getInstance_48();
  }
  function OrderStatus(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PaymentMethod_CASH_ON_DELIVERY_getInstance() {
    PaymentMethod_initEntries();
    return PaymentMethod_CASH_ON_DELIVERY_instance;
  }
  function PaymentMethod_INSTAPAY_getInstance() {
    PaymentMethod_initEntries();
    return PaymentMethod_INSTAPAY_instance;
  }
  function PaymentMethod_WALLET_getInstance() {
    PaymentMethod_initEntries();
    return PaymentMethod_WALLET_instance;
  }
  function PaymentMethod_VISA_getInstance() {
    PaymentMethod_initEntries();
    return PaymentMethod_VISA_instance;
  }
  function PaymentMethod_MASTERCARD_getInstance() {
    PaymentMethod_initEntries();
    return PaymentMethod_MASTERCARD_instance;
  }
  function PaymentMethod_APPLE_PAY_getInstance() {
    PaymentMethod_initEntries();
    return PaymentMethod_APPLE_PAY_instance;
  }
  function PaymentMethod_GOOGLE_PAY_getInstance() {
    PaymentMethod_initEntries();
    return PaymentMethod_GOOGLE_PAY_instance;
  }
  function OrderStatus_RECEIVED_getInstance() {
    OrderStatus_initEntries();
    return OrderStatus_RECEIVED_instance;
  }
  function OrderStatus_PREPARING_getInstance() {
    OrderStatus_initEntries();
    return OrderStatus_PREPARING_instance;
  }
  function OrderStatus_ON_THE_WAY_getInstance() {
    OrderStatus_initEntries();
    return OrderStatus_ON_THE_WAY_instance;
  }
  function OrderStatus_FAILED_getInstance() {
    OrderStatus_initEntries();
    return OrderStatus_FAILED_instance;
  }
  function OrderStatus_COMPLETED_getInstance() {
    OrderStatus_initEntries();
    return OrderStatus_COMPLETED_instance;
  }
  function OrderStatus_RETURN_REQUESTED_getInstance() {
    OrderStatus_initEntries();
    return OrderStatus_RETURN_REQUESTED_instance;
  }
  function OrderStatus_RETURN_DELIVERY_getInstance() {
    OrderStatus_initEntries();
    return OrderStatus_RETURN_DELIVERY_instance;
  }
  function OrderStatus_RETURNED_getInstance() {
    OrderStatus_initEntries();
    return OrderStatus_RETURNED_instance;
  }
  function OrderStatus_MONEY_RETURNED_getInstance() {
    OrderStatus_initEntries();
    return OrderStatus_MONEY_RETURNED_instance;
  }
  function OrderStatus_ARCHIVED_getInstance() {
    OrderStatus_initEntries();
    return OrderStatus_ARCHIVED_instance;
  }
  var client_fstech_hadaya_domain_model_OptionValue_$serializer$stable;
  var client_fstech_hadaya_domain_model_OptionValue$stable;
  var client_fstech_hadaya_domain_model_ProductOption_$serializer$stable;
  var client_fstech_hadaya_domain_model_ProductOption$stable;
  var client_fstech_hadaya_domain_model_Product_$serializer$stable;
  var client_fstech_hadaya_domain_model_Product$stable;
  function Product$Companion$$childSerializers$_anonymous__yyvvy3() {
    return Companion_getInstance_51().amj();
  }
  function Product$Companion$$childSerializers$_anonymous__yyvvy3_0() {
    return new ArrayListSerializer($serializer_getInstance_4());
  }
  function Product$Companion$$childSerializers$_anonymous__yyvvy3_1() {
    return Companion_getInstance_52().amj();
  }
  function Product$Companion$$childSerializers$_anonymous__yyvvy3_2() {
    return new ArrayListSerializer(LongSerializer_getInstance());
  }
  function Product$Companion$$childSerializers$_anonymous__yyvvy3_3() {
    return new ArrayListSerializer(LongSerializer_getInstance());
  }
  function Product$Companion$$childSerializers$_anonymous__yyvvy3_4() {
    return new ArrayListSerializer($serializer_getInstance_13());
  }
  function Companion_14() {
    Companion_instance_20 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, Product$Companion$$childSerializers$_anonymous__yyvvy3);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy_0(tmp_2, Product$Companion$$childSerializers$_anonymous__yyvvy3_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_5 = lazy_0(tmp_4, Product$Companion$$childSerializers$_anonymous__yyvvy3_1);
    var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_7 = lazy_0(tmp_6, Product$Companion$$childSerializers$_anonymous__yyvvy3_2);
    var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_9 = lazy_0(tmp_8, Product$Companion$$childSerializers$_anonymous__yyvvy3_3);
    var tmp_10 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e100_1 = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, tmp_1, null, null, null, tmp_3, null, null, tmp_5, tmp_7, tmp_9, null, null, lazy_0(tmp_10, Product$Companion$$childSerializers$_anonymous__yyvvy3_4), null, null, null, null, null, null, null, null, null];
  }
  var Companion_instance_20;
  function Companion_getInstance_49() {
    if (Companion_instance_20 == null)
      new Companion_14();
    return Companion_instance_20;
  }
  function $serializer_11() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.Product', this, 36);
    tmp0_serialDesc.a7c('id', true);
    tmp0_serialDesc.a7c('name_english', true);
    tmp0_serialDesc.a7c('name_arabic', true);
    tmp0_serialDesc.a7c('description_english', true);
    tmp0_serialDesc.a7c('description_arabic', true);
    tmp0_serialDesc.a7c('price', true);
    tmp0_serialDesc.a7c('discount', true);
    tmp0_serialDesc.a7c('discount_percent', true);
    tmp0_serialDesc.a7c('rating', true);
    tmp0_serialDesc.a7c('stock', true);
    tmp0_serialDesc.a7c('image_url', true);
    tmp0_serialDesc.a7c('video_url', true);
    tmp0_serialDesc.a7c('created_at', true);
    tmp0_serialDesc.a7c('updated_at', true);
    tmp0_serialDesc.a7c('kind', true);
    tmp0_serialDesc.a7c('category_id', true);
    tmp0_serialDesc.a7c('category_name_english', true);
    tmp0_serialDesc.a7c('category_name_arabic', true);
    tmp0_serialDesc.a7c('design_layers', true);
    tmp0_serialDesc.a7c('custom_image_url', true);
    tmp0_serialDesc.a7c('card_message', true);
    tmp0_serialDesc.a7c('target_audience', true);
    tmp0_serialDesc.a7c('card_ids', true);
    tmp0_serialDesc.a7c('box_ids', true);
    tmp0_serialDesc.a7c('sizes', true);
    tmp0_serialDesc.a7c('colors', true);
    tmp0_serialDesc.a7c('additional_options', true);
    tmp0_serialDesc.a7c('templates', true);
    tmp0_serialDesc.a7c('views', true);
    tmp0_serialDesc.a7c('is_archived', true);
    tmp0_serialDesc.a7c('is_kids', true);
    tmp0_serialDesc.a7c('is_youth', true);
    tmp0_serialDesc.a7c('is_old', true);
    tmp0_serialDesc.a7c('beads_name_length', true);
    tmp0_serialDesc.a7c('beads_name_hint_en', true);
    tmp0_serialDesc.a7c('beads_name_hint_ar', true);
    this.f100_1 = tmp0_serialDesc;
  }
  protoOf($serializer_11).g100 = function (encoder, value) {
    var tmp0_desc = this.f100_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_49().e100_1;
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.nzt_1 == null)) {
      tmp1_output.g76(tmp0_desc, 0, LongSerializer_getInstance(), value.nzt_1);
    }
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.ozt_1 === '')) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.ozt_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.pzt_1 === '')) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.pzt_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.qzt_1 === '')) {
      tmp1_output.g76(tmp0_desc, 3, StringSerializer_getInstance(), value.qzt_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.rzt_1 === '')) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.rzt_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !equals(value.szt_1, 0.0)) {
      tmp1_output.g76(tmp0_desc, 5, DoubleSerializer_getInstance(), value.szt_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !equals(value.tzt_1, 0.0)) {
      tmp1_output.g76(tmp0_desc, 6, DoubleSerializer_getInstance(), value.tzt_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !equals(value.uzt_1, 0.0)) {
      tmp1_output.g76(tmp0_desc, 7, DoubleSerializer_getInstance(), value.uzt_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !equals(value.vzt_1, 0.0)) {
      tmp1_output.g76(tmp0_desc, 8, DoubleSerializer_getInstance(), value.vzt_1);
    }
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !(value.wzt_1 === 0)) {
      tmp1_output.g76(tmp0_desc, 9, IntSerializer_getInstance(), value.wzt_1);
    }
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.xzt_1 == null)) {
      tmp1_output.g76(tmp0_desc, 10, FlexibleListSerializer_getInstance(), value.xzt_1);
    }
    if (tmp1_output.k76(tmp0_desc, 11) ? true : !(value.yzt_1 == null)) {
      tmp1_output.g76(tmp0_desc, 11, FlexibleListSerializer_getInstance(), value.yzt_1);
    }
    if (tmp1_output.k76(tmp0_desc, 12) ? true : !(value.zzt_1 == null)) {
      tmp1_output.g76(tmp0_desc, 12, StringSerializer_getInstance(), value.zzt_1);
    }
    if (tmp1_output.k76(tmp0_desc, 13) ? true : !(value.azu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 13, StringSerializer_getInstance(), value.azu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 14) ? true : !equals(value.bzu_1, ProductKind_NORMAL_getInstance())) {
      tmp1_output.g76(tmp0_desc, 14, tmp2_cached[14].u1(), value.bzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 15) ? true : !(value.czu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 15, StringSerializer_getInstance(), value.czu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 16) ? true : !(value.dzu_1 === '')) {
      tmp1_output.g76(tmp0_desc, 16, StringSerializer_getInstance(), value.dzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 17) ? true : !(value.ezu_1 === '')) {
      tmp1_output.g76(tmp0_desc, 17, StringSerializer_getInstance(), value.ezu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 18) ? true : !(value.fzu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 18, tmp2_cached[18].u1(), value.fzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 19) ? true : !(value.gzu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 19, StringSerializer_getInstance(), value.gzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 20) ? true : !(value.hzu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 20, StringSerializer_getInstance(), value.hzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 21) ? true : !equals(value.izu_1, TargetAudience_BOTH_getInstance())) {
      tmp1_output.g76(tmp0_desc, 21, tmp2_cached[21].u1(), value.izu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 22) ? true : !(value.jzu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 22, tmp2_cached[22].u1(), value.jzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 23) ? true : !(value.kzu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 23, tmp2_cached[23].u1(), value.kzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 24) ? true : !(value.lzu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 24, FlexibleListSerializer_getInstance(), value.lzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 25) ? true : !(value.mzu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 25, FlexibleListSerializer_getInstance(), value.mzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 26) ? true : !(value.nzu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 26, tmp2_cached[26].u1(), value.nzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 27) ? true : !(value.ozu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 27, FlexibleListSerializer_getInstance(), value.ozu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 28) ? true : !(value.pzu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 28, LongSerializer_getInstance(), value.pzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 29) ? true : !(value.qzu_1 === false)) {
      tmp1_output.u75(tmp0_desc, 29, value.qzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 30) ? true : !(value.rzu_1 === false)) {
      tmp1_output.u75(tmp0_desc, 30, value.rzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 31) ? true : !(value.szu_1 === false)) {
      tmp1_output.u75(tmp0_desc, 31, value.szu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 32) ? true : !(value.tzu_1 === false)) {
      tmp1_output.u75(tmp0_desc, 32, value.tzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 33) ? true : !(value.uzu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 33, IntSerializer_getInstance(), value.uzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 34) ? true : !(value.vzu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 34, StringSerializer_getInstance(), value.vzu_1);
    }
    if (tmp1_output.k76(tmp0_desc, 35) ? true : !(value.wzu_1 == null)) {
      tmp1_output.g76(tmp0_desc, 35, StringSerializer_getInstance(), value.wzu_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_11).z70 = function (encoder, value) {
    return this.g100(encoder, value instanceof Product ? value : THROW_CCE());
  };
  protoOf($serializer_11).a71 = function (decoder) {
    var tmp0_desc = this.f100_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_bitMask1 = 0;
    var tmp5_local0 = null;
    var tmp6_local1 = null;
    var tmp7_local2 = null;
    var tmp8_local3 = null;
    var tmp9_local4 = null;
    var tmp10_local5 = null;
    var tmp11_local6 = null;
    var tmp12_local7 = null;
    var tmp13_local8 = null;
    var tmp14_local9 = null;
    var tmp15_local10 = null;
    var tmp16_local11 = null;
    var tmp17_local12 = null;
    var tmp18_local13 = null;
    var tmp19_local14 = null;
    var tmp20_local15 = null;
    var tmp21_local16 = null;
    var tmp22_local17 = null;
    var tmp23_local18 = null;
    var tmp24_local19 = null;
    var tmp25_local20 = null;
    var tmp26_local21 = null;
    var tmp27_local22 = null;
    var tmp28_local23 = null;
    var tmp29_local24 = null;
    var tmp30_local25 = null;
    var tmp31_local26 = null;
    var tmp32_local27 = null;
    var tmp33_local28 = null;
    var tmp34_local29 = false;
    var tmp35_local30 = false;
    var tmp36_local31 = false;
    var tmp37_local32 = false;
    var tmp38_local33 = null;
    var tmp39_local34 = null;
    var tmp40_local35 = null;
    var tmp41_input = decoder.n74(tmp0_desc);
    var tmp42_cached = Companion_getInstance_49().e100_1;
    if (tmp41_input.d75()) {
      tmp5_local0 = tmp41_input.b75(tmp0_desc, 0, LongSerializer_getInstance(), tmp5_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp6_local1 = tmp41_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp6_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp7_local2 = tmp41_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp7_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp8_local3 = tmp41_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp8_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp9_local4 = tmp41_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp9_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp10_local5 = tmp41_input.b75(tmp0_desc, 5, DoubleSerializer_getInstance(), tmp10_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp11_local6 = tmp41_input.b75(tmp0_desc, 6, DoubleSerializer_getInstance(), tmp11_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp12_local7 = tmp41_input.b75(tmp0_desc, 7, DoubleSerializer_getInstance(), tmp12_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp13_local8 = tmp41_input.b75(tmp0_desc, 8, DoubleSerializer_getInstance(), tmp13_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp14_local9 = tmp41_input.b75(tmp0_desc, 9, IntSerializer_getInstance(), tmp14_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp15_local10 = tmp41_input.b75(tmp0_desc, 10, FlexibleListSerializer_getInstance(), tmp15_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp16_local11 = tmp41_input.b75(tmp0_desc, 11, FlexibleListSerializer_getInstance(), tmp16_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp17_local12 = tmp41_input.b75(tmp0_desc, 12, StringSerializer_getInstance(), tmp17_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp18_local13 = tmp41_input.b75(tmp0_desc, 13, StringSerializer_getInstance(), tmp18_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp19_local14 = tmp41_input.b75(tmp0_desc, 14, tmp42_cached[14].u1(), tmp19_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp20_local15 = tmp41_input.b75(tmp0_desc, 15, StringSerializer_getInstance(), tmp20_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp21_local16 = tmp41_input.b75(tmp0_desc, 16, StringSerializer_getInstance(), tmp21_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp22_local17 = tmp41_input.b75(tmp0_desc, 17, StringSerializer_getInstance(), tmp22_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp23_local18 = tmp41_input.b75(tmp0_desc, 18, tmp42_cached[18].u1(), tmp23_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp24_local19 = tmp41_input.b75(tmp0_desc, 19, StringSerializer_getInstance(), tmp24_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp25_local20 = tmp41_input.b75(tmp0_desc, 20, StringSerializer_getInstance(), tmp25_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp26_local21 = tmp41_input.b75(tmp0_desc, 21, tmp42_cached[21].u1(), tmp26_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp27_local22 = tmp41_input.b75(tmp0_desc, 22, tmp42_cached[22].u1(), tmp27_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp28_local23 = tmp41_input.b75(tmp0_desc, 23, tmp42_cached[23].u1(), tmp28_local23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
      tmp29_local24 = tmp41_input.b75(tmp0_desc, 24, FlexibleListSerializer_getInstance(), tmp29_local24);
      tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
      tmp30_local25 = tmp41_input.b75(tmp0_desc, 25, FlexibleListSerializer_getInstance(), tmp30_local25);
      tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
      tmp31_local26 = tmp41_input.b75(tmp0_desc, 26, tmp42_cached[26].u1(), tmp31_local26);
      tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
      tmp32_local27 = tmp41_input.b75(tmp0_desc, 27, FlexibleListSerializer_getInstance(), tmp32_local27);
      tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
      tmp33_local28 = tmp41_input.b75(tmp0_desc, 28, LongSerializer_getInstance(), tmp33_local28);
      tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
      tmp34_local29 = tmp41_input.p74(tmp0_desc, 29);
      tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
      tmp35_local30 = tmp41_input.p74(tmp0_desc, 30);
      tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
      tmp36_local31 = tmp41_input.p74(tmp0_desc, 31);
      tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
      tmp37_local32 = tmp41_input.p74(tmp0_desc, 32);
      tmp4_bitMask1 = tmp4_bitMask1 | 1;
      tmp38_local33 = tmp41_input.b75(tmp0_desc, 33, IntSerializer_getInstance(), tmp38_local33);
      tmp4_bitMask1 = tmp4_bitMask1 | 2;
      tmp39_local34 = tmp41_input.b75(tmp0_desc, 34, StringSerializer_getInstance(), tmp39_local34);
      tmp4_bitMask1 = tmp4_bitMask1 | 4;
      tmp40_local35 = tmp41_input.b75(tmp0_desc, 35, StringSerializer_getInstance(), tmp40_local35);
      tmp4_bitMask1 = tmp4_bitMask1 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp41_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp5_local0 = tmp41_input.b75(tmp0_desc, 0, LongSerializer_getInstance(), tmp5_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp6_local1 = tmp41_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp6_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp7_local2 = tmp41_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp7_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp8_local3 = tmp41_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp8_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp9_local4 = tmp41_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp9_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp10_local5 = tmp41_input.b75(tmp0_desc, 5, DoubleSerializer_getInstance(), tmp10_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp11_local6 = tmp41_input.b75(tmp0_desc, 6, DoubleSerializer_getInstance(), tmp11_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp12_local7 = tmp41_input.b75(tmp0_desc, 7, DoubleSerializer_getInstance(), tmp12_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp13_local8 = tmp41_input.b75(tmp0_desc, 8, DoubleSerializer_getInstance(), tmp13_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp14_local9 = tmp41_input.b75(tmp0_desc, 9, IntSerializer_getInstance(), tmp14_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp15_local10 = tmp41_input.b75(tmp0_desc, 10, FlexibleListSerializer_getInstance(), tmp15_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp16_local11 = tmp41_input.b75(tmp0_desc, 11, FlexibleListSerializer_getInstance(), tmp16_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp17_local12 = tmp41_input.b75(tmp0_desc, 12, StringSerializer_getInstance(), tmp17_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp18_local13 = tmp41_input.b75(tmp0_desc, 13, StringSerializer_getInstance(), tmp18_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp19_local14 = tmp41_input.b75(tmp0_desc, 14, tmp42_cached[14].u1(), tmp19_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp20_local15 = tmp41_input.b75(tmp0_desc, 15, StringSerializer_getInstance(), tmp20_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp21_local16 = tmp41_input.b75(tmp0_desc, 16, StringSerializer_getInstance(), tmp21_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp22_local17 = tmp41_input.b75(tmp0_desc, 17, StringSerializer_getInstance(), tmp22_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp23_local18 = tmp41_input.b75(tmp0_desc, 18, tmp42_cached[18].u1(), tmp23_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp24_local19 = tmp41_input.b75(tmp0_desc, 19, StringSerializer_getInstance(), tmp24_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp25_local20 = tmp41_input.b75(tmp0_desc, 20, StringSerializer_getInstance(), tmp25_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp26_local21 = tmp41_input.b75(tmp0_desc, 21, tmp42_cached[21].u1(), tmp26_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp27_local22 = tmp41_input.b75(tmp0_desc, 22, tmp42_cached[22].u1(), tmp27_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp28_local23 = tmp41_input.b75(tmp0_desc, 23, tmp42_cached[23].u1(), tmp28_local23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          case 24:
            tmp29_local24 = tmp41_input.b75(tmp0_desc, 24, FlexibleListSerializer_getInstance(), tmp29_local24);
            tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
            break;
          case 25:
            tmp30_local25 = tmp41_input.b75(tmp0_desc, 25, FlexibleListSerializer_getInstance(), tmp30_local25);
            tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
            break;
          case 26:
            tmp31_local26 = tmp41_input.b75(tmp0_desc, 26, tmp42_cached[26].u1(), tmp31_local26);
            tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
            break;
          case 27:
            tmp32_local27 = tmp41_input.b75(tmp0_desc, 27, FlexibleListSerializer_getInstance(), tmp32_local27);
            tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
            break;
          case 28:
            tmp33_local28 = tmp41_input.b75(tmp0_desc, 28, LongSerializer_getInstance(), tmp33_local28);
            tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
            break;
          case 29:
            tmp34_local29 = tmp41_input.p74(tmp0_desc, 29);
            tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
            break;
          case 30:
            tmp35_local30 = tmp41_input.p74(tmp0_desc, 30);
            tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
            break;
          case 31:
            tmp36_local31 = tmp41_input.p74(tmp0_desc, 31);
            tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
            break;
          case 32:
            tmp37_local32 = tmp41_input.p74(tmp0_desc, 32);
            tmp4_bitMask1 = tmp4_bitMask1 | 1;
            break;
          case 33:
            tmp38_local33 = tmp41_input.b75(tmp0_desc, 33, IntSerializer_getInstance(), tmp38_local33);
            tmp4_bitMask1 = tmp4_bitMask1 | 2;
            break;
          case 34:
            tmp39_local34 = tmp41_input.b75(tmp0_desc, 34, StringSerializer_getInstance(), tmp39_local34);
            tmp4_bitMask1 = tmp4_bitMask1 | 4;
            break;
          case 35:
            tmp40_local35 = tmp41_input.b75(tmp0_desc, 35, StringSerializer_getInstance(), tmp40_local35);
            tmp4_bitMask1 = tmp4_bitMask1 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp41_input.o74(tmp0_desc);
    return Product_init_$Create$(tmp3_bitMask0, tmp4_bitMask1, tmp5_local0, tmp6_local1, tmp7_local2, tmp8_local3, tmp9_local4, tmp10_local5, tmp11_local6, tmp12_local7, tmp13_local8, tmp14_local9, tmp15_local10, tmp16_local11, tmp17_local12, tmp18_local13, tmp19_local14, tmp20_local15, tmp21_local16, tmp22_local17, tmp23_local18, tmp24_local19, tmp25_local20, tmp26_local21, tmp27_local22, tmp28_local23, tmp29_local24, tmp30_local25, tmp31_local26, tmp32_local27, tmp33_local28, tmp34_local29, tmp35_local30, tmp36_local31, tmp37_local32, tmp38_local33, tmp39_local34, tmp40_local35, null);
  };
  protoOf($serializer_11).y70 = function () {
    return this.f100_1;
  };
  protoOf($serializer_11).t7c = function () {
    var tmp0_cached = Companion_getInstance_49().e100_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(FlexibleListSerializer_getInstance()), get_nullable(FlexibleListSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[14].u1()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[18].u1()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[21].u1()), get_nullable(tmp0_cached[22].u1()), get_nullable(tmp0_cached[23].u1()), get_nullable(FlexibleListSerializer_getInstance()), get_nullable(FlexibleListSerializer_getInstance()), get_nullable(tmp0_cached[26].u1()), get_nullable(FlexibleListSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_11;
  function $serializer_getInstance_11() {
    if ($serializer_instance_11 == null)
      new $serializer_11();
    return $serializer_instance_11;
  }
  function Product_init_$Init$(seen0, seen1, id, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, videoUrl, createdAt, updatedAt, kind, categoryId, categoryNameEnglish, categoryNameArabic, designLayers, customImageUrl, cardMessage, targetAudience, cardIds, boxIds, sizes, colors, additionalOptions, templates, views, isArchived, isKids, isYouth, isOld, BEADSNameLength, BEADSNameHintEn, BEADSNameHintAr, serializationConstructorMarker, $this) {
    if (!!(!(0 === (0 & seen0)) | !(0 === (0 & seen1)))) {
      // Inline function 'kotlin.intArrayOf' call
      var tmp = new Int32Array([seen0, seen1]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$1 = new Int32Array([0, 0]);
      throwArrayMissingFieldException(tmp, tmp$ret$1, $serializer_getInstance_11().f100_1);
    }
    if (0 === (seen0 & 1))
      $this.nzt_1 = null;
    else
      $this.nzt_1 = id;
    if (0 === (seen0 & 2))
      $this.ozt_1 = '';
    else
      $this.ozt_1 = nameEnglish;
    if (0 === (seen0 & 4))
      $this.pzt_1 = '';
    else
      $this.pzt_1 = nameArabic;
    if (0 === (seen0 & 8))
      $this.qzt_1 = '';
    else
      $this.qzt_1 = descriptionEnglish;
    if (0 === (seen0 & 16))
      $this.rzt_1 = '';
    else
      $this.rzt_1 = descriptionArabic;
    if (0 === (seen0 & 32))
      $this.szt_1 = 0.0;
    else
      $this.szt_1 = price;
    if (0 === (seen0 & 64))
      $this.tzt_1 = 0.0;
    else
      $this.tzt_1 = discount;
    if (0 === (seen0 & 128))
      $this.uzt_1 = 0.0;
    else
      $this.uzt_1 = discountPercent;
    if (0 === (seen0 & 256))
      $this.vzt_1 = 0.0;
    else
      $this.vzt_1 = rating;
    if (0 === (seen0 & 512))
      $this.wzt_1 = 0;
    else
      $this.wzt_1 = stock;
    if (0 === (seen0 & 1024))
      $this.xzt_1 = null;
    else
      $this.xzt_1 = imageUrl;
    if (0 === (seen0 & 2048))
      $this.yzt_1 = null;
    else
      $this.yzt_1 = videoUrl;
    if (0 === (seen0 & 4096))
      $this.zzt_1 = null;
    else
      $this.zzt_1 = createdAt;
    if (0 === (seen0 & 8192))
      $this.azu_1 = null;
    else
      $this.azu_1 = updatedAt;
    if (0 === (seen0 & 16384))
      $this.bzu_1 = ProductKind_NORMAL_getInstance();
    else
      $this.bzu_1 = kind;
    if (0 === (seen0 & 32768))
      $this.czu_1 = null;
    else
      $this.czu_1 = categoryId;
    if (0 === (seen0 & 65536))
      $this.dzu_1 = '';
    else
      $this.dzu_1 = categoryNameEnglish;
    if (0 === (seen0 & 131072))
      $this.ezu_1 = '';
    else
      $this.ezu_1 = categoryNameArabic;
    if (0 === (seen0 & 262144))
      $this.fzu_1 = null;
    else
      $this.fzu_1 = designLayers;
    if (0 === (seen0 & 524288))
      $this.gzu_1 = null;
    else
      $this.gzu_1 = customImageUrl;
    if (0 === (seen0 & 1048576))
      $this.hzu_1 = null;
    else
      $this.hzu_1 = cardMessage;
    if (0 === (seen0 & 2097152))
      $this.izu_1 = TargetAudience_BOTH_getInstance();
    else
      $this.izu_1 = targetAudience;
    if (0 === (seen0 & 4194304))
      $this.jzu_1 = null;
    else
      $this.jzu_1 = cardIds;
    if (0 === (seen0 & 8388608))
      $this.kzu_1 = null;
    else
      $this.kzu_1 = boxIds;
    if (0 === (seen0 & 16777216))
      $this.lzu_1 = null;
    else
      $this.lzu_1 = sizes;
    if (0 === (seen0 & 33554432))
      $this.mzu_1 = null;
    else
      $this.mzu_1 = colors;
    if (0 === (seen0 & 67108864))
      $this.nzu_1 = null;
    else
      $this.nzu_1 = additionalOptions;
    if (0 === (seen0 & 134217728))
      $this.ozu_1 = null;
    else
      $this.ozu_1 = templates;
    if (0 === (seen0 & 268435456))
      $this.pzu_1 = null;
    else
      $this.pzu_1 = views;
    if (0 === (seen0 & 536870912))
      $this.qzu_1 = false;
    else
      $this.qzu_1 = isArchived;
    if (0 === (seen0 & 1073741824))
      $this.rzu_1 = false;
    else
      $this.rzu_1 = isKids;
    if (0 === (seen0 & -2147483648))
      $this.szu_1 = false;
    else
      $this.szu_1 = isYouth;
    if (0 === (seen1 & 1))
      $this.tzu_1 = false;
    else
      $this.tzu_1 = isOld;
    if (0 === (seen1 & 2))
      $this.uzu_1 = null;
    else
      $this.uzu_1 = BEADSNameLength;
    if (0 === (seen1 & 4))
      $this.vzu_1 = null;
    else
      $this.vzu_1 = BEADSNameHintEn;
    if (0 === (seen1 & 8))
      $this.wzu_1 = null;
    else
      $this.wzu_1 = BEADSNameHintAr;
    return $this;
  }
  function Product_init_$Create$(seen0, seen1, id, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, videoUrl, createdAt, updatedAt, kind, categoryId, categoryNameEnglish, categoryNameArabic, designLayers, customImageUrl, cardMessage, targetAudience, cardIds, boxIds, sizes, colors, additionalOptions, templates, views, isArchived, isKids, isYouth, isOld, BEADSNameLength, BEADSNameHintEn, BEADSNameHintAr, serializationConstructorMarker) {
    return Product_init_$Init$(seen0, seen1, id, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, videoUrl, createdAt, updatedAt, kind, categoryId, categoryNameEnglish, categoryNameArabic, designLayers, customImageUrl, cardMessage, targetAudience, cardIds, boxIds, sizes, colors, additionalOptions, templates, views, isArchived, isKids, isYouth, isOld, BEADSNameLength, BEADSNameHintEn, BEADSNameHintAr, serializationConstructorMarker, objectCreate(protoOf(Product)));
  }
  function Product(id, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, videoUrl, createdAt, updatedAt, kind, categoryId, categoryNameEnglish, categoryNameArabic, designLayers, customImageUrl, cardMessage, targetAudience, cardIds, boxIds, sizes, colors, additionalOptions, templates, views, isArchived, isKids, isYouth, isOld, BEADSNameLength, BEADSNameHintEn, BEADSNameHintAr) {
    Companion_getInstance_49();
    id = id === VOID ? null : id;
    nameEnglish = nameEnglish === VOID ? '' : nameEnglish;
    nameArabic = nameArabic === VOID ? '' : nameArabic;
    descriptionEnglish = descriptionEnglish === VOID ? '' : descriptionEnglish;
    descriptionArabic = descriptionArabic === VOID ? '' : descriptionArabic;
    price = price === VOID ? 0.0 : price;
    discount = discount === VOID ? 0.0 : discount;
    discountPercent = discountPercent === VOID ? 0.0 : discountPercent;
    rating = rating === VOID ? 0.0 : rating;
    stock = stock === VOID ? 0 : stock;
    imageUrl = imageUrl === VOID ? null : imageUrl;
    videoUrl = videoUrl === VOID ? null : videoUrl;
    createdAt = createdAt === VOID ? null : createdAt;
    updatedAt = updatedAt === VOID ? null : updatedAt;
    kind = kind === VOID ? ProductKind_NORMAL_getInstance() : kind;
    categoryId = categoryId === VOID ? null : categoryId;
    categoryNameEnglish = categoryNameEnglish === VOID ? '' : categoryNameEnglish;
    categoryNameArabic = categoryNameArabic === VOID ? '' : categoryNameArabic;
    designLayers = designLayers === VOID ? null : designLayers;
    customImageUrl = customImageUrl === VOID ? null : customImageUrl;
    cardMessage = cardMessage === VOID ? null : cardMessage;
    targetAudience = targetAudience === VOID ? TargetAudience_BOTH_getInstance() : targetAudience;
    cardIds = cardIds === VOID ? null : cardIds;
    boxIds = boxIds === VOID ? null : boxIds;
    sizes = sizes === VOID ? null : sizes;
    colors = colors === VOID ? null : colors;
    additionalOptions = additionalOptions === VOID ? null : additionalOptions;
    templates = templates === VOID ? null : templates;
    views = views === VOID ? null : views;
    isArchived = isArchived === VOID ? false : isArchived;
    isKids = isKids === VOID ? false : isKids;
    isYouth = isYouth === VOID ? false : isYouth;
    isOld = isOld === VOID ? false : isOld;
    BEADSNameLength = BEADSNameLength === VOID ? null : BEADSNameLength;
    BEADSNameHintEn = BEADSNameHintEn === VOID ? null : BEADSNameHintEn;
    BEADSNameHintAr = BEADSNameHintAr === VOID ? null : BEADSNameHintAr;
    this.nzt_1 = id;
    this.ozt_1 = nameEnglish;
    this.pzt_1 = nameArabic;
    this.qzt_1 = descriptionEnglish;
    this.rzt_1 = descriptionArabic;
    this.szt_1 = price;
    this.tzt_1 = discount;
    this.uzt_1 = discountPercent;
    this.vzt_1 = rating;
    this.wzt_1 = stock;
    this.xzt_1 = imageUrl;
    this.yzt_1 = videoUrl;
    this.zzt_1 = createdAt;
    this.azu_1 = updatedAt;
    this.bzu_1 = kind;
    this.czu_1 = categoryId;
    this.dzu_1 = categoryNameEnglish;
    this.ezu_1 = categoryNameArabic;
    this.fzu_1 = designLayers;
    this.gzu_1 = customImageUrl;
    this.hzu_1 = cardMessage;
    this.izu_1 = targetAudience;
    this.jzu_1 = cardIds;
    this.kzu_1 = boxIds;
    this.lzu_1 = sizes;
    this.mzu_1 = colors;
    this.nzu_1 = additionalOptions;
    this.ozu_1 = templates;
    this.pzu_1 = views;
    this.qzu_1 = isArchived;
    this.rzu_1 = isKids;
    this.szu_1 = isYouth;
    this.tzu_1 = isOld;
    this.uzu_1 = BEADSNameLength;
    this.vzu_1 = BEADSNameHintEn;
    this.wzu_1 = BEADSNameHintAr;
  }
  protoOf(Product).h100 = function (id, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, videoUrl, createdAt, updatedAt, kind, categoryId, categoryNameEnglish, categoryNameArabic, designLayers, customImageUrl, cardMessage, targetAudience, cardIds, boxIds, sizes, colors, additionalOptions, templates, views, isArchived, isKids, isYouth, isOld, BEADSNameLength, BEADSNameHintEn, BEADSNameHintAr) {
    return new Product(id, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, videoUrl, createdAt, updatedAt, kind, categoryId, categoryNameEnglish, categoryNameArabic, designLayers, customImageUrl, cardMessage, targetAudience, cardIds, boxIds, sizes, colors, additionalOptions, templates, views, isArchived, isKids, isYouth, isOld, BEADSNameLength, BEADSNameHintEn, BEADSNameHintAr);
  };
  protoOf(Product).i100 = function (id, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, videoUrl, createdAt, updatedAt, kind, categoryId, categoryNameEnglish, categoryNameArabic, designLayers, customImageUrl, cardMessage, targetAudience, cardIds, boxIds, sizes, colors, additionalOptions, templates, views, isArchived, isKids, isYouth, isOld, BEADSNameLength, BEADSNameHintEn, BEADSNameHintAr, $super) {
    id = id === VOID ? this.nzt_1 : id;
    nameEnglish = nameEnglish === VOID ? this.ozt_1 : nameEnglish;
    nameArabic = nameArabic === VOID ? this.pzt_1 : nameArabic;
    descriptionEnglish = descriptionEnglish === VOID ? this.qzt_1 : descriptionEnglish;
    descriptionArabic = descriptionArabic === VOID ? this.rzt_1 : descriptionArabic;
    price = price === VOID ? this.szt_1 : price;
    discount = discount === VOID ? this.tzt_1 : discount;
    discountPercent = discountPercent === VOID ? this.uzt_1 : discountPercent;
    rating = rating === VOID ? this.vzt_1 : rating;
    stock = stock === VOID ? this.wzt_1 : stock;
    imageUrl = imageUrl === VOID ? this.xzt_1 : imageUrl;
    videoUrl = videoUrl === VOID ? this.yzt_1 : videoUrl;
    createdAt = createdAt === VOID ? this.zzt_1 : createdAt;
    updatedAt = updatedAt === VOID ? this.azu_1 : updatedAt;
    kind = kind === VOID ? this.bzu_1 : kind;
    categoryId = categoryId === VOID ? this.czu_1 : categoryId;
    categoryNameEnglish = categoryNameEnglish === VOID ? this.dzu_1 : categoryNameEnglish;
    categoryNameArabic = categoryNameArabic === VOID ? this.ezu_1 : categoryNameArabic;
    designLayers = designLayers === VOID ? this.fzu_1 : designLayers;
    customImageUrl = customImageUrl === VOID ? this.gzu_1 : customImageUrl;
    cardMessage = cardMessage === VOID ? this.hzu_1 : cardMessage;
    targetAudience = targetAudience === VOID ? this.izu_1 : targetAudience;
    cardIds = cardIds === VOID ? this.jzu_1 : cardIds;
    boxIds = boxIds === VOID ? this.kzu_1 : boxIds;
    sizes = sizes === VOID ? this.lzu_1 : sizes;
    colors = colors === VOID ? this.mzu_1 : colors;
    additionalOptions = additionalOptions === VOID ? this.nzu_1 : additionalOptions;
    templates = templates === VOID ? this.ozu_1 : templates;
    views = views === VOID ? this.pzu_1 : views;
    isArchived = isArchived === VOID ? this.qzu_1 : isArchived;
    isKids = isKids === VOID ? this.rzu_1 : isKids;
    isYouth = isYouth === VOID ? this.szu_1 : isYouth;
    isOld = isOld === VOID ? this.tzu_1 : isOld;
    BEADSNameLength = BEADSNameLength === VOID ? this.uzu_1 : BEADSNameLength;
    BEADSNameHintEn = BEADSNameHintEn === VOID ? this.vzu_1 : BEADSNameHintEn;
    BEADSNameHintAr = BEADSNameHintAr === VOID ? this.wzu_1 : BEADSNameHintAr;
    return $super === VOID ? this.h100(id, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, videoUrl, createdAt, updatedAt, kind, categoryId, categoryNameEnglish, categoryNameArabic, designLayers, customImageUrl, cardMessage, targetAudience, cardIds, boxIds, sizes, colors, additionalOptions, templates, views, isArchived, isKids, isYouth, isOld, BEADSNameLength, BEADSNameHintEn, BEADSNameHintAr) : $super.h100.call(this, id, nameEnglish, nameArabic, descriptionEnglish, descriptionArabic, price, discount, discountPercent, rating, stock, imageUrl, videoUrl, createdAt, updatedAt, kind, categoryId, categoryNameEnglish, categoryNameArabic, designLayers, customImageUrl, cardMessage, targetAudience, cardIds, boxIds, sizes, colors, additionalOptions, templates, views, isArchived, isKids, isYouth, isOld, BEADSNameLength, BEADSNameHintEn, BEADSNameHintAr);
  };
  protoOf(Product).toString = function () {
    return 'Product(id=' + toString_0(this.nzt_1) + ', nameEnglish=' + this.ozt_1 + ', nameArabic=' + this.pzt_1 + ', descriptionEnglish=' + this.qzt_1 + ', descriptionArabic=' + this.rzt_1 + ', price=' + this.szt_1 + ', discount=' + this.tzt_1 + ', discountPercent=' + this.uzt_1 + ', rating=' + this.vzt_1 + ', stock=' + this.wzt_1 + ', imageUrl=' + toString_0(this.xzt_1) + ', videoUrl=' + toString_0(this.yzt_1) + ', createdAt=' + this.zzt_1 + ', updatedAt=' + this.azu_1 + ', kind=' + toString_0(this.bzu_1) + ', categoryId=' + this.czu_1 + ', categoryNameEnglish=' + this.dzu_1 + ', categoryNameArabic=' + this.ezu_1 + ', designLayers=' + toString_0(this.fzu_1) + ', customImageUrl=' + this.gzu_1 + ', cardMessage=' + this.hzu_1 + ', targetAudience=' + toString_0(this.izu_1) + ', cardIds=' + toString_0(this.jzu_1) + ', boxIds=' + toString_0(this.kzu_1) + ', sizes=' + toString_0(this.lzu_1) + ', colors=' + toString_0(this.mzu_1) + ', additionalOptions=' + toString_0(this.nzu_1) + ', templates=' + toString_0(this.ozu_1) + ', views=' + toString_0(this.pzu_1) + ', isArchived=' + this.qzu_1 + ', isKids=' + this.rzu_1 + ', isYouth=' + this.szu_1 + ', isOld=' + this.tzu_1 + ', BEADSNameLength=' + this.uzu_1 + ', BEADSNameHintEn=' + this.vzu_1 + ', BEADSNameHintAr=' + this.wzu_1 + ')';
  };
  protoOf(Product).hashCode = function () {
    var result = this.nzt_1 == null ? 0 : this.nzt_1.hashCode();
    result = imul(result, 31) + (this.ozt_1 == null ? 0 : getStringHashCode(this.ozt_1)) | 0;
    result = imul(result, 31) + (this.pzt_1 == null ? 0 : getStringHashCode(this.pzt_1)) | 0;
    result = imul(result, 31) + (this.qzt_1 == null ? 0 : getStringHashCode(this.qzt_1)) | 0;
    result = imul(result, 31) + (this.rzt_1 == null ? 0 : getStringHashCode(this.rzt_1)) | 0;
    result = imul(result, 31) + (this.szt_1 == null ? 0 : getNumberHashCode(this.szt_1)) | 0;
    result = imul(result, 31) + (this.tzt_1 == null ? 0 : getNumberHashCode(this.tzt_1)) | 0;
    result = imul(result, 31) + (this.uzt_1 == null ? 0 : getNumberHashCode(this.uzt_1)) | 0;
    result = imul(result, 31) + (this.vzt_1 == null ? 0 : getNumberHashCode(this.vzt_1)) | 0;
    result = imul(result, 31) + (this.wzt_1 == null ? 0 : this.wzt_1) | 0;
    result = imul(result, 31) + (this.xzt_1 == null ? 0 : hashCode(this.xzt_1)) | 0;
    result = imul(result, 31) + (this.yzt_1 == null ? 0 : hashCode(this.yzt_1)) | 0;
    result = imul(result, 31) + (this.zzt_1 == null ? 0 : getStringHashCode(this.zzt_1)) | 0;
    result = imul(result, 31) + (this.azu_1 == null ? 0 : getStringHashCode(this.azu_1)) | 0;
    result = imul(result, 31) + (this.bzu_1 == null ? 0 : this.bzu_1.hashCode()) | 0;
    result = imul(result, 31) + (this.czu_1 == null ? 0 : getStringHashCode(this.czu_1)) | 0;
    result = imul(result, 31) + (this.dzu_1 == null ? 0 : getStringHashCode(this.dzu_1)) | 0;
    result = imul(result, 31) + (this.ezu_1 == null ? 0 : getStringHashCode(this.ezu_1)) | 0;
    result = imul(result, 31) + (this.fzu_1 == null ? 0 : hashCode(this.fzu_1)) | 0;
    result = imul(result, 31) + (this.gzu_1 == null ? 0 : getStringHashCode(this.gzu_1)) | 0;
    result = imul(result, 31) + (this.hzu_1 == null ? 0 : getStringHashCode(this.hzu_1)) | 0;
    result = imul(result, 31) + (this.izu_1 == null ? 0 : this.izu_1.hashCode()) | 0;
    result = imul(result, 31) + (this.jzu_1 == null ? 0 : hashCode(this.jzu_1)) | 0;
    result = imul(result, 31) + (this.kzu_1 == null ? 0 : hashCode(this.kzu_1)) | 0;
    result = imul(result, 31) + (this.lzu_1 == null ? 0 : hashCode(this.lzu_1)) | 0;
    result = imul(result, 31) + (this.mzu_1 == null ? 0 : hashCode(this.mzu_1)) | 0;
    result = imul(result, 31) + (this.nzu_1 == null ? 0 : hashCode(this.nzu_1)) | 0;
    result = imul(result, 31) + (this.ozu_1 == null ? 0 : hashCode(this.ozu_1)) | 0;
    result = imul(result, 31) + (this.pzu_1 == null ? 0 : this.pzu_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.qzu_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.rzu_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.szu_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.tzu_1) | 0;
    result = imul(result, 31) + (this.uzu_1 == null ? 0 : this.uzu_1) | 0;
    result = imul(result, 31) + (this.vzu_1 == null ? 0 : getStringHashCode(this.vzu_1)) | 0;
    result = imul(result, 31) + (this.wzu_1 == null ? 0 : getStringHashCode(this.wzu_1)) | 0;
    return result;
  };
  protoOf(Product).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Product))
      return false;
    if (!equals(this.nzt_1, other.nzt_1))
      return false;
    if (!(this.ozt_1 == other.ozt_1))
      return false;
    if (!(this.pzt_1 == other.pzt_1))
      return false;
    if (!(this.qzt_1 == other.qzt_1))
      return false;
    if (!(this.rzt_1 == other.rzt_1))
      return false;
    if (!equals(this.szt_1, other.szt_1))
      return false;
    if (!equals(this.tzt_1, other.tzt_1))
      return false;
    if (!equals(this.uzt_1, other.uzt_1))
      return false;
    if (!equals(this.vzt_1, other.vzt_1))
      return false;
    if (!(this.wzt_1 == other.wzt_1))
      return false;
    if (!equals(this.xzt_1, other.xzt_1))
      return false;
    if (!equals(this.yzt_1, other.yzt_1))
      return false;
    if (!(this.zzt_1 == other.zzt_1))
      return false;
    if (!(this.azu_1 == other.azu_1))
      return false;
    if (!equals(this.bzu_1, other.bzu_1))
      return false;
    if (!(this.czu_1 == other.czu_1))
      return false;
    if (!(this.dzu_1 == other.dzu_1))
      return false;
    if (!(this.ezu_1 == other.ezu_1))
      return false;
    if (!equals(this.fzu_1, other.fzu_1))
      return false;
    if (!(this.gzu_1 == other.gzu_1))
      return false;
    if (!(this.hzu_1 == other.hzu_1))
      return false;
    if (!equals(this.izu_1, other.izu_1))
      return false;
    if (!equals(this.jzu_1, other.jzu_1))
      return false;
    if (!equals(this.kzu_1, other.kzu_1))
      return false;
    if (!equals(this.lzu_1, other.lzu_1))
      return false;
    if (!equals(this.mzu_1, other.mzu_1))
      return false;
    if (!equals(this.nzu_1, other.nzu_1))
      return false;
    if (!equals(this.ozu_1, other.ozu_1))
      return false;
    if (!equals(this.pzu_1, other.pzu_1))
      return false;
    if (!(this.qzu_1 === other.qzu_1))
      return false;
    if (!(this.rzu_1 === other.rzu_1))
      return false;
    if (!(this.szu_1 === other.szu_1))
      return false;
    if (!(this.tzu_1 === other.tzu_1))
      return false;
    if (!(this.uzu_1 == other.uzu_1))
      return false;
    if (!(this.vzu_1 == other.vzu_1))
      return false;
    if (!(this.wzu_1 == other.wzu_1))
      return false;
    return true;
  };
  function OptionValue$Companion$$childSerializers$_anonymous__iqk9ym() {
    return new ArrayListSerializer(StringSerializer_getInstance());
  }
  function OptionValue$Companion$$childSerializers$_anonymous__iqk9ym_0() {
    return new ArrayListSerializer(StringSerializer_getInstance());
  }
  function OptionValue$Companion$$childSerializers$_anonymous__iqk9ym_1() {
    return new ArrayListSerializer(StringSerializer_getInstance());
  }
  function Companion_15() {
    Companion_instance_21 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, OptionValue$Companion$$childSerializers$_anonymous__iqk9ym);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy_0(tmp_2, OptionValue$Companion$$childSerializers$_anonymous__iqk9ym_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j100_1 = [null, null, null, null, null, null, null, null, tmp_1, tmp_3, null, null, null, null, null, null, null, null, null, null, null, lazy_0(tmp_4, OptionValue$Companion$$childSerializers$_anonymous__iqk9ym_1)];
  }
  var Companion_instance_21;
  function Companion_getInstance_50() {
    if (Companion_instance_21 == null)
      new Companion_15();
    return Companion_instance_21;
  }
  function $serializer_12() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.OptionValue', this, 22);
    tmp0_serialDesc.a7c('name_en', true);
    tmp0_serialDesc.a7c('name_ar', true);
    tmp0_serialDesc.a7c('description_en', true);
    tmp0_serialDesc.a7c('description_ar', true);
    tmp0_serialDesc.a7c('price', true);
    tmp0_serialDesc.a7c('discount', true);
    tmp0_serialDesc.a7c('stock', true);
    tmp0_serialDesc.a7c('priority', true);
    tmp0_serialDesc.a7c('image_urls', true);
    tmp0_serialDesc.a7c('video_urls', true);
    tmp0_serialDesc.a7c('has_birthday', true);
    tmp0_serialDesc.a7c('birthday_hint_en', true);
    tmp0_serialDesc.a7c('birthday_hint_ar', true);
    tmp0_serialDesc.a7c('has_message', true);
    tmp0_serialDesc.a7c('message_hint_en', true);
    tmp0_serialDesc.a7c('message_hint_ar', true);
    tmp0_serialDesc.a7c('has_image', true);
    tmp0_serialDesc.a7c('image_hint_en', true);
    tmp0_serialDesc.a7c('image_hint_ar', true);
    tmp0_serialDesc.a7c('user_birthday', true);
    tmp0_serialDesc.a7c('user_message', true);
    tmp0_serialDesc.a7c('user_image_urls', true);
    this.k100_1 = tmp0_serialDesc;
  }
  protoOf($serializer_12).l100 = function (encoder, value) {
    var tmp0_desc = this.k100_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_50().j100_1;
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.m100_1 === '')) {
      tmp1_output.c76(tmp0_desc, 0, value.m100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.n100_1 === '')) {
      tmp1_output.c76(tmp0_desc, 1, value.n100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.o100_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.o100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.p100_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, StringSerializer_getInstance(), value.p100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !equals(value.q100_1, 0.0)) {
      tmp1_output.g76(tmp0_desc, 4, DoubleSerializer_getInstance(), value.q100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !equals(value.r100_1, 0.0)) {
      tmp1_output.g76(tmp0_desc, 5, DoubleSerializer_getInstance(), value.r100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.s100_1 === 0)) {
      tmp1_output.g76(tmp0_desc, 6, IntSerializer_getInstance(), value.s100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.t100_1 === 0)) {
      tmp1_output.x75(tmp0_desc, 7, value.t100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !(value.u100_1 == null)) {
      tmp1_output.g76(tmp0_desc, 8, tmp2_cached[8].u1(), value.u100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !(value.v100_1 == null)) {
      tmp1_output.g76(tmp0_desc, 9, tmp2_cached[9].u1(), value.v100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.w100_1 === false)) {
      tmp1_output.u75(tmp0_desc, 10, value.w100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 11) ? true : !(value.x100_1 == null)) {
      tmp1_output.g76(tmp0_desc, 11, StringSerializer_getInstance(), value.x100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 12) ? true : !(value.y100_1 == null)) {
      tmp1_output.g76(tmp0_desc, 12, StringSerializer_getInstance(), value.y100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 13) ? true : !(value.z100_1 === false)) {
      tmp1_output.u75(tmp0_desc, 13, value.z100_1);
    }
    if (tmp1_output.k76(tmp0_desc, 14) ? true : !(value.a101_1 == null)) {
      tmp1_output.g76(tmp0_desc, 14, StringSerializer_getInstance(), value.a101_1);
    }
    if (tmp1_output.k76(tmp0_desc, 15) ? true : !(value.b101_1 == null)) {
      tmp1_output.g76(tmp0_desc, 15, StringSerializer_getInstance(), value.b101_1);
    }
    if (tmp1_output.k76(tmp0_desc, 16) ? true : !(value.c101_1 === false)) {
      tmp1_output.u75(tmp0_desc, 16, value.c101_1);
    }
    if (tmp1_output.k76(tmp0_desc, 17) ? true : !(value.d101_1 == null)) {
      tmp1_output.g76(tmp0_desc, 17, StringSerializer_getInstance(), value.d101_1);
    }
    if (tmp1_output.k76(tmp0_desc, 18) ? true : !(value.e101_1 == null)) {
      tmp1_output.g76(tmp0_desc, 18, StringSerializer_getInstance(), value.e101_1);
    }
    if (tmp1_output.k76(tmp0_desc, 19) ? true : !(value.f101_1 == null)) {
      tmp1_output.g76(tmp0_desc, 19, StringSerializer_getInstance(), value.f101_1);
    }
    if (tmp1_output.k76(tmp0_desc, 20) ? true : !(value.g101_1 == null)) {
      tmp1_output.g76(tmp0_desc, 20, StringSerializer_getInstance(), value.g101_1);
    }
    if (tmp1_output.k76(tmp0_desc, 21) ? true : !(value.h101_1 == null)) {
      tmp1_output.g76(tmp0_desc, 21, tmp2_cached[21].u1(), value.h101_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_12).z70 = function (encoder, value) {
    return this.l100(encoder, value instanceof OptionValue ? value : THROW_CCE());
  };
  protoOf($serializer_12).a71 = function (decoder) {
    var tmp0_desc = this.k100_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = 0;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = false;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = false;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = false;
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = null;
    var tmp25_local21 = null;
    var tmp27_input = decoder.n74(tmp0_desc);
    var tmp28_cached = Companion_getInstance_50().j100_1;
    if (tmp27_input.d75()) {
      tmp4_local0 = tmp27_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp27_input.x74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp27_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp27_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp27_input.b75(tmp0_desc, 4, DoubleSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp27_input.b75(tmp0_desc, 5, DoubleSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp27_input.b75(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp27_input.s74(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp27_input.b75(tmp0_desc, 8, tmp28_cached[8].u1(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp27_input.b75(tmp0_desc, 9, tmp28_cached[9].u1(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp27_input.p74(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp27_input.b75(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp27_input.b75(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp27_input.p74(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp27_input.b75(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp27_input.b75(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp27_input.p74(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp27_input.b75(tmp0_desc, 17, StringSerializer_getInstance(), tmp21_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp27_input.b75(tmp0_desc, 18, StringSerializer_getInstance(), tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp27_input.b75(tmp0_desc, 19, StringSerializer_getInstance(), tmp23_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp27_input.b75(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp27_input.b75(tmp0_desc, 21, tmp28_cached[21].u1(), tmp25_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp27_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp27_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp27_input.x74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp27_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp27_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp27_input.b75(tmp0_desc, 4, DoubleSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp27_input.b75(tmp0_desc, 5, DoubleSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp27_input.b75(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp27_input.s74(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp27_input.b75(tmp0_desc, 8, tmp28_cached[8].u1(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp27_input.b75(tmp0_desc, 9, tmp28_cached[9].u1(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp27_input.p74(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp27_input.b75(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp27_input.b75(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp27_input.p74(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp27_input.b75(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp27_input.b75(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp27_input.p74(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp27_input.b75(tmp0_desc, 17, StringSerializer_getInstance(), tmp21_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp27_input.b75(tmp0_desc, 18, StringSerializer_getInstance(), tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp27_input.b75(tmp0_desc, 19, StringSerializer_getInstance(), tmp23_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp27_input.b75(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp27_input.b75(tmp0_desc, 21, tmp28_cached[21].u1(), tmp25_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp27_input.o74(tmp0_desc);
    return OptionValue_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, null);
  };
  protoOf($serializer_12).y70 = function () {
    return this.k100_1;
  };
  protoOf($serializer_12).t7c = function () {
    var tmp0_cached = Companion_getInstance_50().j100_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), IntSerializer_getInstance(), get_nullable(tmp0_cached[8].u1()), get_nullable(tmp0_cached[9].u1()), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[21].u1())];
  };
  var $serializer_instance_12;
  function $serializer_getInstance_12() {
    if ($serializer_instance_12 == null)
      new $serializer_12();
    return $serializer_instance_12;
  }
  function OptionValue_init_$Init$(seen0, nameEn, nameAr, descriptionEn, descriptionAr, price, discount, stock, priority, imageUrls, videoUrls, hasBirthday, birthdayHintEn, birthdayHintAr, hasMessage, messageHintEn, messageHintAr, hasImage, imageHintEn, imageHintAr, userBirthday, userMessage, userImageUrls, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_12().k100_1);
    }
    if (0 === (seen0 & 1))
      $this.m100_1 = '';
    else
      $this.m100_1 = nameEn;
    if (0 === (seen0 & 2))
      $this.n100_1 = '';
    else
      $this.n100_1 = nameAr;
    if (0 === (seen0 & 4))
      $this.o100_1 = null;
    else
      $this.o100_1 = descriptionEn;
    if (0 === (seen0 & 8))
      $this.p100_1 = null;
    else
      $this.p100_1 = descriptionAr;
    if (0 === (seen0 & 16))
      $this.q100_1 = 0.0;
    else
      $this.q100_1 = price;
    if (0 === (seen0 & 32))
      $this.r100_1 = 0.0;
    else
      $this.r100_1 = discount;
    if (0 === (seen0 & 64))
      $this.s100_1 = 0;
    else
      $this.s100_1 = stock;
    if (0 === (seen0 & 128))
      $this.t100_1 = 0;
    else
      $this.t100_1 = priority;
    if (0 === (seen0 & 256))
      $this.u100_1 = null;
    else
      $this.u100_1 = imageUrls;
    if (0 === (seen0 & 512))
      $this.v100_1 = null;
    else
      $this.v100_1 = videoUrls;
    if (0 === (seen0 & 1024))
      $this.w100_1 = false;
    else
      $this.w100_1 = hasBirthday;
    if (0 === (seen0 & 2048))
      $this.x100_1 = null;
    else
      $this.x100_1 = birthdayHintEn;
    if (0 === (seen0 & 4096))
      $this.y100_1 = null;
    else
      $this.y100_1 = birthdayHintAr;
    if (0 === (seen0 & 8192))
      $this.z100_1 = false;
    else
      $this.z100_1 = hasMessage;
    if (0 === (seen0 & 16384))
      $this.a101_1 = null;
    else
      $this.a101_1 = messageHintEn;
    if (0 === (seen0 & 32768))
      $this.b101_1 = null;
    else
      $this.b101_1 = messageHintAr;
    if (0 === (seen0 & 65536))
      $this.c101_1 = false;
    else
      $this.c101_1 = hasImage;
    if (0 === (seen0 & 131072))
      $this.d101_1 = null;
    else
      $this.d101_1 = imageHintEn;
    if (0 === (seen0 & 262144))
      $this.e101_1 = null;
    else
      $this.e101_1 = imageHintAr;
    if (0 === (seen0 & 524288))
      $this.f101_1 = null;
    else
      $this.f101_1 = userBirthday;
    if (0 === (seen0 & 1048576))
      $this.g101_1 = null;
    else
      $this.g101_1 = userMessage;
    if (0 === (seen0 & 2097152))
      $this.h101_1 = null;
    else
      $this.h101_1 = userImageUrls;
    $this.i101_1 = null;
    return $this;
  }
  function OptionValue_init_$Create$(seen0, nameEn, nameAr, descriptionEn, descriptionAr, price, discount, stock, priority, imageUrls, videoUrls, hasBirthday, birthdayHintEn, birthdayHintAr, hasMessage, messageHintEn, messageHintAr, hasImage, imageHintEn, imageHintAr, userBirthday, userMessage, userImageUrls, serializationConstructorMarker) {
    return OptionValue_init_$Init$(seen0, nameEn, nameAr, descriptionEn, descriptionAr, price, discount, stock, priority, imageUrls, videoUrls, hasBirthday, birthdayHintEn, birthdayHintAr, hasMessage, messageHintEn, messageHintAr, hasImage, imageHintEn, imageHintAr, userBirthday, userMessage, userImageUrls, serializationConstructorMarker, objectCreate(protoOf(OptionValue)));
  }
  function OptionValue(nameEn, nameAr, descriptionEn, descriptionAr, price, discount, stock, priority, imageUrls, videoUrls, hasBirthday, birthdayHintEn, birthdayHintAr, hasMessage, messageHintEn, messageHintAr, hasImage, imageHintEn, imageHintAr, userBirthday, userMessage, userImageUrls, userImageBytes) {
    Companion_getInstance_50();
    nameEn = nameEn === VOID ? '' : nameEn;
    nameAr = nameAr === VOID ? '' : nameAr;
    descriptionEn = descriptionEn === VOID ? null : descriptionEn;
    descriptionAr = descriptionAr === VOID ? null : descriptionAr;
    price = price === VOID ? 0.0 : price;
    discount = discount === VOID ? 0.0 : discount;
    stock = stock === VOID ? 0 : stock;
    priority = priority === VOID ? 0 : priority;
    imageUrls = imageUrls === VOID ? null : imageUrls;
    videoUrls = videoUrls === VOID ? null : videoUrls;
    hasBirthday = hasBirthday === VOID ? false : hasBirthday;
    birthdayHintEn = birthdayHintEn === VOID ? null : birthdayHintEn;
    birthdayHintAr = birthdayHintAr === VOID ? null : birthdayHintAr;
    hasMessage = hasMessage === VOID ? false : hasMessage;
    messageHintEn = messageHintEn === VOID ? null : messageHintEn;
    messageHintAr = messageHintAr === VOID ? null : messageHintAr;
    hasImage = hasImage === VOID ? false : hasImage;
    imageHintEn = imageHintEn === VOID ? null : imageHintEn;
    imageHintAr = imageHintAr === VOID ? null : imageHintAr;
    userBirthday = userBirthday === VOID ? null : userBirthday;
    userMessage = userMessage === VOID ? null : userMessage;
    userImageUrls = userImageUrls === VOID ? null : userImageUrls;
    userImageBytes = userImageBytes === VOID ? null : userImageBytes;
    this.m100_1 = nameEn;
    this.n100_1 = nameAr;
    this.o100_1 = descriptionEn;
    this.p100_1 = descriptionAr;
    this.q100_1 = price;
    this.r100_1 = discount;
    this.s100_1 = stock;
    this.t100_1 = priority;
    this.u100_1 = imageUrls;
    this.v100_1 = videoUrls;
    this.w100_1 = hasBirthday;
    this.x100_1 = birthdayHintEn;
    this.y100_1 = birthdayHintAr;
    this.z100_1 = hasMessage;
    this.a101_1 = messageHintEn;
    this.b101_1 = messageHintAr;
    this.c101_1 = hasImage;
    this.d101_1 = imageHintEn;
    this.e101_1 = imageHintAr;
    this.f101_1 = userBirthday;
    this.g101_1 = userMessage;
    this.h101_1 = userImageUrls;
    this.i101_1 = userImageBytes;
  }
  protoOf(OptionValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OptionValue))
      return false;
    if (!(this.m100_1 === other.m100_1))
      return false;
    if (!(this.n100_1 === other.n100_1))
      return false;
    if (!(this.o100_1 == other.o100_1))
      return false;
    if (!(this.p100_1 == other.p100_1))
      return false;
    if (!(this.q100_1 == other.q100_1))
      return false;
    if (!(this.r100_1 == other.r100_1))
      return false;
    if (!(this.s100_1 == other.s100_1))
      return false;
    if (!(this.t100_1 === other.t100_1))
      return false;
    if (!equals(this.u100_1, other.u100_1))
      return false;
    if (!equals(this.v100_1, other.v100_1))
      return false;
    if (!(this.w100_1 === other.w100_1))
      return false;
    if (!(this.x100_1 == other.x100_1))
      return false;
    if (!(this.y100_1 == other.y100_1))
      return false;
    if (!(this.z100_1 === other.z100_1))
      return false;
    if (!(this.a101_1 == other.a101_1))
      return false;
    if (!(this.b101_1 == other.b101_1))
      return false;
    if (!(this.c101_1 === other.c101_1))
      return false;
    if (!(this.d101_1 == other.d101_1))
      return false;
    if (!(this.e101_1 == other.e101_1))
      return false;
    if (!(this.f101_1 == other.f101_1))
      return false;
    if (!(this.g101_1 == other.g101_1))
      return false;
    if (!equals(this.h101_1, other.h101_1))
      return false;
    if (!equals(this.i101_1, other.i101_1))
      return false;
    return true;
  };
  protoOf(OptionValue).hashCode = function () {
    var result = getStringHashCode(this.m100_1);
    result = imul(31, result) + getStringHashCode(this.n100_1) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.o100_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp2_safe_receiver = this.p100_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : getStringHashCode(tmp2_safe_receiver);
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_1 = imul(31, result);
    var tmp4_safe_receiver = this.q100_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : getNumberHashCode(tmp4_safe_receiver);
    result = tmp_1 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    var tmp_2 = imul(31, result);
    var tmp6_safe_receiver = this.r100_1;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : getNumberHashCode(tmp6_safe_receiver);
    result = tmp_2 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0;
    var tmp_3 = imul(31, result);
    var tmp8_safe_receiver = this.s100_1;
    var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : tmp8_safe_receiver;
    result = tmp_3 + (tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs) | 0;
    result = imul(31, result) + this.t100_1 | 0;
    var tmp_4 = imul(31, result);
    var tmp10_safe_receiver = this.u100_1;
    var tmp11_elvis_lhs = tmp10_safe_receiver == null ? null : hashCode(tmp10_safe_receiver);
    result = tmp_4 + (tmp11_elvis_lhs == null ? 0 : tmp11_elvis_lhs) | 0;
    var tmp_5 = imul(31, result);
    var tmp12_safe_receiver = this.v100_1;
    var tmp13_elvis_lhs = tmp12_safe_receiver == null ? null : hashCode(tmp12_safe_receiver);
    result = tmp_5 + (tmp13_elvis_lhs == null ? 0 : tmp13_elvis_lhs) | 0;
    result = imul(31, result) + getBooleanHashCode(this.w100_1) | 0;
    var tmp_6 = imul(31, result);
    var tmp14_safe_receiver = this.x100_1;
    var tmp15_elvis_lhs = tmp14_safe_receiver == null ? null : getStringHashCode(tmp14_safe_receiver);
    result = tmp_6 + (tmp15_elvis_lhs == null ? 0 : tmp15_elvis_lhs) | 0;
    var tmp_7 = imul(31, result);
    var tmp16_safe_receiver = this.y100_1;
    var tmp17_elvis_lhs = tmp16_safe_receiver == null ? null : getStringHashCode(tmp16_safe_receiver);
    result = tmp_7 + (tmp17_elvis_lhs == null ? 0 : tmp17_elvis_lhs) | 0;
    result = imul(31, result) + getBooleanHashCode(this.z100_1) | 0;
    var tmp_8 = imul(31, result);
    var tmp18_safe_receiver = this.a101_1;
    var tmp19_elvis_lhs = tmp18_safe_receiver == null ? null : getStringHashCode(tmp18_safe_receiver);
    result = tmp_8 + (tmp19_elvis_lhs == null ? 0 : tmp19_elvis_lhs) | 0;
    var tmp_9 = imul(31, result);
    var tmp20_safe_receiver = this.b101_1;
    var tmp21_elvis_lhs = tmp20_safe_receiver == null ? null : getStringHashCode(tmp20_safe_receiver);
    result = tmp_9 + (tmp21_elvis_lhs == null ? 0 : tmp21_elvis_lhs) | 0;
    result = imul(31, result) + getBooleanHashCode(this.c101_1) | 0;
    var tmp_10 = imul(31, result);
    var tmp22_safe_receiver = this.d101_1;
    var tmp23_elvis_lhs = tmp22_safe_receiver == null ? null : getStringHashCode(tmp22_safe_receiver);
    result = tmp_10 + (tmp23_elvis_lhs == null ? 0 : tmp23_elvis_lhs) | 0;
    var tmp_11 = imul(31, result);
    var tmp24_safe_receiver = this.e101_1;
    var tmp25_elvis_lhs = tmp24_safe_receiver == null ? null : getStringHashCode(tmp24_safe_receiver);
    result = tmp_11 + (tmp25_elvis_lhs == null ? 0 : tmp25_elvis_lhs) | 0;
    var tmp_12 = imul(31, result);
    var tmp26_safe_receiver = this.f101_1;
    var tmp27_elvis_lhs = tmp26_safe_receiver == null ? null : getStringHashCode(tmp26_safe_receiver);
    result = tmp_12 + (tmp27_elvis_lhs == null ? 0 : tmp27_elvis_lhs) | 0;
    var tmp_13 = imul(31, result);
    var tmp28_safe_receiver = this.g101_1;
    var tmp29_elvis_lhs = tmp28_safe_receiver == null ? null : getStringHashCode(tmp28_safe_receiver);
    result = tmp_13 + (tmp29_elvis_lhs == null ? 0 : tmp29_elvis_lhs) | 0;
    var tmp_14 = imul(31, result);
    var tmp30_safe_receiver = this.h101_1;
    var tmp31_elvis_lhs = tmp30_safe_receiver == null ? null : hashCode(tmp30_safe_receiver);
    result = tmp_14 + (tmp31_elvis_lhs == null ? 0 : tmp31_elvis_lhs) | 0;
    var tmp_15 = imul(31, result);
    var tmp32_safe_receiver = this.i101_1;
    var tmp33_elvis_lhs = tmp32_safe_receiver == null ? null : hashCode(tmp32_safe_receiver);
    result = tmp_15 + (tmp33_elvis_lhs == null ? 0 : tmp33_elvis_lhs) | 0;
    return result;
  };
  protoOf(OptionValue).j101 = function (nameEn, nameAr, descriptionEn, descriptionAr, price, discount, stock, priority, imageUrls, videoUrls, hasBirthday, birthdayHintEn, birthdayHintAr, hasMessage, messageHintEn, messageHintAr, hasImage, imageHintEn, imageHintAr, userBirthday, userMessage, userImageUrls, userImageBytes) {
    return new OptionValue(nameEn, nameAr, descriptionEn, descriptionAr, price, discount, stock, priority, imageUrls, videoUrls, hasBirthday, birthdayHintEn, birthdayHintAr, hasMessage, messageHintEn, messageHintAr, hasImage, imageHintEn, imageHintAr, userBirthday, userMessage, userImageUrls, userImageBytes);
  };
  protoOf(OptionValue).k101 = function (nameEn, nameAr, descriptionEn, descriptionAr, price, discount, stock, priority, imageUrls, videoUrls, hasBirthday, birthdayHintEn, birthdayHintAr, hasMessage, messageHintEn, messageHintAr, hasImage, imageHintEn, imageHintAr, userBirthday, userMessage, userImageUrls, userImageBytes, $super) {
    nameEn = nameEn === VOID ? this.m100_1 : nameEn;
    nameAr = nameAr === VOID ? this.n100_1 : nameAr;
    descriptionEn = descriptionEn === VOID ? this.o100_1 : descriptionEn;
    descriptionAr = descriptionAr === VOID ? this.p100_1 : descriptionAr;
    price = price === VOID ? this.q100_1 : price;
    discount = discount === VOID ? this.r100_1 : discount;
    stock = stock === VOID ? this.s100_1 : stock;
    priority = priority === VOID ? this.t100_1 : priority;
    imageUrls = imageUrls === VOID ? this.u100_1 : imageUrls;
    videoUrls = videoUrls === VOID ? this.v100_1 : videoUrls;
    hasBirthday = hasBirthday === VOID ? this.w100_1 : hasBirthday;
    birthdayHintEn = birthdayHintEn === VOID ? this.x100_1 : birthdayHintEn;
    birthdayHintAr = birthdayHintAr === VOID ? this.y100_1 : birthdayHintAr;
    hasMessage = hasMessage === VOID ? this.z100_1 : hasMessage;
    messageHintEn = messageHintEn === VOID ? this.a101_1 : messageHintEn;
    messageHintAr = messageHintAr === VOID ? this.b101_1 : messageHintAr;
    hasImage = hasImage === VOID ? this.c101_1 : hasImage;
    imageHintEn = imageHintEn === VOID ? this.d101_1 : imageHintEn;
    imageHintAr = imageHintAr === VOID ? this.e101_1 : imageHintAr;
    userBirthday = userBirthday === VOID ? this.f101_1 : userBirthday;
    userMessage = userMessage === VOID ? this.g101_1 : userMessage;
    userImageUrls = userImageUrls === VOID ? this.h101_1 : userImageUrls;
    userImageBytes = userImageBytes === VOID ? this.i101_1 : userImageBytes;
    return $super === VOID ? this.j101(nameEn, nameAr, descriptionEn, descriptionAr, price, discount, stock, priority, imageUrls, videoUrls, hasBirthday, birthdayHintEn, birthdayHintAr, hasMessage, messageHintEn, messageHintAr, hasImage, imageHintEn, imageHintAr, userBirthday, userMessage, userImageUrls, userImageBytes) : $super.j101.call(this, nameEn, nameAr, descriptionEn, descriptionAr, price, discount, stock, priority, imageUrls, videoUrls, hasBirthday, birthdayHintEn, birthdayHintAr, hasMessage, messageHintEn, messageHintAr, hasImage, imageHintEn, imageHintAr, userBirthday, userMessage, userImageUrls, userImageBytes);
  };
  protoOf(OptionValue).toString = function () {
    return 'OptionValue(nameEn=' + this.m100_1 + ', nameAr=' + this.n100_1 + ', descriptionEn=' + this.o100_1 + ', descriptionAr=' + this.p100_1 + ', price=' + this.q100_1 + ', discount=' + this.r100_1 + ', stock=' + this.s100_1 + ', priority=' + this.t100_1 + ', imageUrls=' + toString_0(this.u100_1) + ', videoUrls=' + toString_0(this.v100_1) + ', hasBirthday=' + this.w100_1 + ', birthdayHintEn=' + this.x100_1 + ', birthdayHintAr=' + this.y100_1 + ', hasMessage=' + this.z100_1 + ', messageHintEn=' + this.a101_1 + ', messageHintAr=' + this.b101_1 + ', hasImage=' + this.c101_1 + ', imageHintEn=' + this.d101_1 + ', imageHintAr=' + this.e101_1 + ', userBirthday=' + this.f101_1 + ', userMessage=' + this.g101_1 + ', userImageUrls=' + toString_0(this.h101_1) + ', userImageBytes=' + toString_0(this.i101_1) + ')';
  };
  function _get_$cachedSerializer__te6jhj_2($this) {
    return $this.azy_1.u1();
  }
  function ProductKind$Companion$_anonymous__9xwges() {
    var tmp = values_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = ['NORMAL', 'MUG', 'TSHIRT', 'NOTE', 'MAGIC_MUG', 'BEADS'];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [null, null, null, null, null, null];
    return createAnnotatedEnumSerializer('client.fstech.hadaya.domain.model.ProductKind', tmp, tmp_0, tmp$ret$3, null);
  }
  var ProductKind_NORMAL_instance;
  var ProductKind_MUG_instance;
  var ProductKind_TSHIRT_instance;
  var ProductKind_NOTE_instance;
  var ProductKind_MAGIC_MUG_instance;
  var ProductKind_BEADS_instance;
  function values_2() {
    return [ProductKind_NORMAL_getInstance(), ProductKind_MUG_getInstance(), ProductKind_TSHIRT_getInstance(), ProductKind_NOTE_getInstance(), ProductKind_MAGIC_MUG_getInstance(), ProductKind_BEADS_getInstance()];
  }
  function Companion_16() {
    Companion_instance_22 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.azy_1 = lazy_0(tmp_0, ProductKind$Companion$_anonymous__9xwges);
  }
  protoOf(Companion_16).amj = function () {
    return _get_$cachedSerializer__te6jhj_2(this);
  };
  protoOf(Companion_16).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  var Companion_instance_22;
  function Companion_getInstance_51() {
    ProductKind_initEntries();
    if (Companion_instance_22 == null)
      new Companion_16();
    return Companion_instance_22;
  }
  var ProductKind_entriesInitialized;
  function ProductKind_initEntries() {
    if (ProductKind_entriesInitialized)
      return Unit_instance;
    ProductKind_entriesInitialized = true;
    ProductKind_NORMAL_instance = new ProductKind('NORMAL', 0);
    ProductKind_MUG_instance = new ProductKind('MUG', 1);
    ProductKind_TSHIRT_instance = new ProductKind('TSHIRT', 2);
    ProductKind_NOTE_instance = new ProductKind('NOTE', 3);
    ProductKind_MAGIC_MUG_instance = new ProductKind('MAGIC_MUG', 4);
    ProductKind_BEADS_instance = new ProductKind('BEADS', 5);
    Companion_getInstance_51();
  }
  function ProductKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function _get_$cachedSerializer__te6jhj_3($this) {
    return $this.uzy_1.u1();
  }
  function TargetAudience$Companion$_anonymous__7zq3kq() {
    var tmp = values_3();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = ['BOTH', 'MENS', 'GIRLS'];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [null, null, null];
    return createAnnotatedEnumSerializer('client.fstech.hadaya.domain.model.TargetAudience', tmp, tmp_0, tmp$ret$3, null);
  }
  var TargetAudience_BOTH_instance;
  var TargetAudience_MENS_instance;
  var TargetAudience_GIRLS_instance;
  function values_3() {
    return [TargetAudience_BOTH_getInstance(), TargetAudience_MENS_getInstance(), TargetAudience_GIRLS_getInstance()];
  }
  function Companion_17() {
    Companion_instance_23 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.uzy_1 = lazy_0(tmp_0, TargetAudience$Companion$_anonymous__7zq3kq);
  }
  protoOf(Companion_17).amj = function () {
    return _get_$cachedSerializer__te6jhj_3(this);
  };
  protoOf(Companion_17).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  var Companion_instance_23;
  function Companion_getInstance_52() {
    TargetAudience_initEntries();
    if (Companion_instance_23 == null)
      new Companion_17();
    return Companion_instance_23;
  }
  var TargetAudience_entriesInitialized;
  function TargetAudience_initEntries() {
    if (TargetAudience_entriesInitialized)
      return Unit_instance;
    TargetAudience_entriesInitialized = true;
    TargetAudience_BOTH_instance = new TargetAudience('BOTH', 0);
    TargetAudience_MENS_instance = new TargetAudience('MENS', 1);
    TargetAudience_GIRLS_instance = new TargetAudience('GIRLS', 2);
    Companion_getInstance_52();
  }
  function TargetAudience(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ProductOption$Companion$$childSerializers$_anonymous__9n9716() {
    return new ArrayListSerializer($serializer_getInstance_12());
  }
  function Companion_18() {
    Companion_instance_24 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l101_1 = [null, null, null, null, lazy_0(tmp_0, ProductOption$Companion$$childSerializers$_anonymous__9n9716)];
  }
  var Companion_instance_24;
  function Companion_getInstance_53() {
    if (Companion_instance_24 == null)
      new Companion_18();
    return Companion_instance_24;
  }
  function $serializer_13() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.ProductOption', this, 5);
    tmp0_serialDesc.a7c('name_en', true);
    tmp0_serialDesc.a7c('name_ar', true);
    tmp0_serialDesc.a7c('is_archived', true);
    tmp0_serialDesc.a7c('key', true);
    tmp0_serialDesc.a7c('values', true);
    this.m101_1 = tmp0_serialDesc;
  }
  protoOf($serializer_13).n101 = function (encoder, value) {
    var tmp0_desc = this.m101_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_53().l101_1;
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.o101_1 === '')) {
      tmp1_output.c76(tmp0_desc, 0, value.o101_1);
    }
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.p101_1 === '')) {
      tmp1_output.c76(tmp0_desc, 1, value.p101_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.q101_1 === false)) {
      tmp1_output.u75(tmp0_desc, 2, value.q101_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.r101_1 === '')) {
      tmp1_output.c76(tmp0_desc, 3, value.r101_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !equals(value.s101_1, emptyList())) {
      tmp1_output.e76(tmp0_desc, 4, tmp2_cached[4].u1(), value.s101_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_13).z70 = function (encoder, value) {
    return this.n101(encoder, value instanceof ProductOption ? value : THROW_CCE());
  };
  protoOf($serializer_13).a71 = function (decoder) {
    var tmp0_desc = this.m101_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.n74(tmp0_desc);
    var tmp10_cached = Companion_getInstance_53().l101_1;
    if (tmp9_input.d75()) {
      tmp4_local0 = tmp9_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.x74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.p74(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.x74(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.z74(tmp0_desc, 4, tmp10_cached[4].u1(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.x74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.p74(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.x74(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.z74(tmp0_desc, 4, tmp10_cached[4].u1(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.o74(tmp0_desc);
    return ProductOption_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_13).y70 = function () {
    return this.m101_1;
  };
  protoOf($serializer_13).t7c = function () {
    var tmp0_cached = Companion_getInstance_53().l101_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4].u1()];
  };
  var $serializer_instance_13;
  function $serializer_getInstance_13() {
    if ($serializer_instance_13 == null)
      new $serializer_13();
    return $serializer_instance_13;
  }
  function ProductOption_init_$Init$(seen0, nameEn, nameAr, isArchived, key, values, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_13().m101_1);
    }
    if (0 === (seen0 & 1))
      $this.o101_1 = '';
    else
      $this.o101_1 = nameEn;
    if (0 === (seen0 & 2))
      $this.p101_1 = '';
    else
      $this.p101_1 = nameAr;
    if (0 === (seen0 & 4))
      $this.q101_1 = false;
    else
      $this.q101_1 = isArchived;
    if (0 === (seen0 & 8))
      $this.r101_1 = '';
    else
      $this.r101_1 = key;
    if (0 === (seen0 & 16))
      $this.s101_1 = emptyList();
    else
      $this.s101_1 = values;
    return $this;
  }
  function ProductOption_init_$Create$(seen0, nameEn, nameAr, isArchived, key, values, serializationConstructorMarker) {
    return ProductOption_init_$Init$(seen0, nameEn, nameAr, isArchived, key, values, serializationConstructorMarker, objectCreate(protoOf(ProductOption)));
  }
  function ProductOption(nameEn, nameAr, isArchived, key, values) {
    Companion_getInstance_53();
    nameEn = nameEn === VOID ? '' : nameEn;
    nameAr = nameAr === VOID ? '' : nameAr;
    isArchived = isArchived === VOID ? false : isArchived;
    key = key === VOID ? '' : key;
    values = values === VOID ? emptyList() : values;
    this.o101_1 = nameEn;
    this.p101_1 = nameAr;
    this.q101_1 = isArchived;
    this.r101_1 = key;
    this.s101_1 = values;
  }
  protoOf(ProductOption).toString = function () {
    return 'ProductOption(nameEn=' + this.o101_1 + ', nameAr=' + this.p101_1 + ', isArchived=' + this.q101_1 + ', key=' + this.r101_1 + ', values=' + toString(this.s101_1) + ')';
  };
  protoOf(ProductOption).hashCode = function () {
    var result = getStringHashCode(this.o101_1);
    result = imul(result, 31) + getStringHashCode(this.p101_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q101_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r101_1) | 0;
    result = imul(result, 31) + hashCode(this.s101_1) | 0;
    return result;
  };
  protoOf(ProductOption).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductOption))
      return false;
    if (!(this.o101_1 === other.o101_1))
      return false;
    if (!(this.p101_1 === other.p101_1))
      return false;
    if (!(this.q101_1 === other.q101_1))
      return false;
    if (!(this.r101_1 === other.r101_1))
      return false;
    if (!equals(this.s101_1, other.s101_1))
      return false;
    return true;
  };
  function ProductKind_NORMAL_getInstance() {
    ProductKind_initEntries();
    return ProductKind_NORMAL_instance;
  }
  function ProductKind_MUG_getInstance() {
    ProductKind_initEntries();
    return ProductKind_MUG_instance;
  }
  function ProductKind_TSHIRT_getInstance() {
    ProductKind_initEntries();
    return ProductKind_TSHIRT_instance;
  }
  function ProductKind_NOTE_getInstance() {
    ProductKind_initEntries();
    return ProductKind_NOTE_instance;
  }
  function ProductKind_MAGIC_MUG_getInstance() {
    ProductKind_initEntries();
    return ProductKind_MAGIC_MUG_instance;
  }
  function ProductKind_BEADS_getInstance() {
    ProductKind_initEntries();
    return ProductKind_BEADS_instance;
  }
  function TargetAudience_BOTH_getInstance() {
    TargetAudience_initEntries();
    return TargetAudience_BOTH_instance;
  }
  function TargetAudience_MENS_getInstance() {
    TargetAudience_initEntries();
    return TargetAudience_MENS_instance;
  }
  function TargetAudience_GIRLS_getInstance() {
    TargetAudience_initEntries();
    return TargetAudience_GIRLS_instance;
  }
  var client_fstech_hadaya_domain_model_Profile_$serializer$stable;
  var client_fstech_hadaya_domain_model_Profile$stable;
  function Companion_19() {
  }
  protoOf(Companion_19).amj = function () {
    return $serializer_getInstance_14();
  };
  var Companion_instance_25;
  function Companion_getInstance_54() {
    return Companion_instance_25;
  }
  function $serializer_14() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.Profile', this, 26);
    tmp0_serialDesc.a7c('id', false);
    tmp0_serialDesc.a7c('email', true);
    tmp0_serialDesc.a7c('first_name', true);
    tmp0_serialDesc.a7c('last_name', true);
    tmp0_serialDesc.a7c('birthday', true);
    tmp0_serialDesc.a7c('building_no', true);
    tmp0_serialDesc.a7c('street', true);
    tmp0_serialDesc.a7c('neighbourhood', true);
    tmp0_serialDesc.a7c('city', true);
    tmp0_serialDesc.a7c('country', true);
    tmp0_serialDesc.a7c('location', true);
    tmp0_serialDesc.a7c('avatar_url', true);
    tmp0_serialDesc.a7c('personal_phone_number', true);
    tmp0_serialDesc.a7c('work_phone_number', true);
    tmp0_serialDesc.a7c('latitude', true);
    tmp0_serialDesc.a7c('longitude', true);
    tmp0_serialDesc.a7c('fcm_token', true);
    tmp0_serialDesc.a7c('role', true);
    tmp0_serialDesc.a7c('is_banned', true);
    tmp0_serialDesc.a7c('ban_until', true);
    tmp0_serialDesc.a7c('ban_reason', true);
    tmp0_serialDesc.a7c('is_first_login', true);
    tmp0_serialDesc.a7c('can_change_phone', true);
    tmp0_serialDesc.a7c('changed_by_admin', true);
    tmp0_serialDesc.a7c('changed_by_admin_date', true);
    tmp0_serialDesc.a7c('provider', true);
    this.t101_1 = tmp0_serialDesc;
  }
  protoOf($serializer_14).u101 = function (encoder, value) {
    var tmp0_desc = this.t101_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.c76(tmp0_desc, 0, value.uym_1);
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.vym_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.vym_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.wym_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.wym_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.xym_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, StringSerializer_getInstance(), value.xym_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.yym_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.yym_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.zym_1 == null)) {
      tmp1_output.g76(tmp0_desc, 5, StringSerializer_getInstance(), value.zym_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.ayn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 6, StringSerializer_getInstance(), value.ayn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.byn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 7, StringSerializer_getInstance(), value.byn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !(value.cyn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 8, StringSerializer_getInstance(), value.cyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !(value.dyn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 9, StringSerializer_getInstance(), value.dyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.eyn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 10, StringSerializer_getInstance(), value.eyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 11) ? true : !(value.fyn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 11, StringSerializer_getInstance(), value.fyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 12) ? true : !(value.gyn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 12, StringSerializer_getInstance(), value.gyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 13) ? true : !(value.hyn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 13, StringSerializer_getInstance(), value.hyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 14) ? true : !(value.iyn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 14, DoubleSerializer_getInstance(), value.iyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 15) ? true : !(value.jyn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 15, DoubleSerializer_getInstance(), value.jyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 16) ? true : !(value.kyn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 16, StringSerializer_getInstance(), value.kyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 17) ? true : !(value.lyn_1 === 'normal')) {
      tmp1_output.g76(tmp0_desc, 17, StringSerializer_getInstance(), value.lyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 18) ? true : !(value.myn_1 === false)) {
      tmp1_output.g76(tmp0_desc, 18, BooleanSerializer_getInstance(), value.myn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 19) ? true : !(value.nyn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 19, StringSerializer_getInstance(), value.nyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 20) ? true : !(value.oyn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 20, StringSerializer_getInstance(), value.oyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 21) ? true : !(value.pyn_1 === true)) {
      tmp1_output.g76(tmp0_desc, 21, BooleanSerializer_getInstance(), value.pyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 22) ? true : !(value.qyn_1 === true)) {
      tmp1_output.g76(tmp0_desc, 22, BooleanSerializer_getInstance(), value.qyn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 23) ? true : !(value.ryn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 23, StringSerializer_getInstance(), value.ryn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 24) ? true : !(value.syn_1 == null)) {
      tmp1_output.g76(tmp0_desc, 24, StringSerializer_getInstance(), value.syn_1);
    }
    if (tmp1_output.k76(tmp0_desc, 25) ? true : !(value.tyn_1 === 'email')) {
      tmp1_output.g76(tmp0_desc, 25, StringSerializer_getInstance(), value.tyn_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_14).z70 = function (encoder, value) {
    return this.u101(encoder, value instanceof Profile ? value : THROW_CCE());
  };
  protoOf($serializer_14).a71 = function (decoder) {
    var tmp0_desc = this.t101_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = null;
    var tmp25_local21 = null;
    var tmp26_local22 = null;
    var tmp27_local23 = null;
    var tmp28_local24 = null;
    var tmp29_local25 = null;
    var tmp30_input = decoder.n74(tmp0_desc);
    if (tmp30_input.d75()) {
      tmp4_local0 = tmp30_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp30_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp30_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp30_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp30_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp30_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp30_input.b75(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp30_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp30_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp30_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp30_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp30_input.b75(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp30_input.b75(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp30_input.b75(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp30_input.b75(tmp0_desc, 14, DoubleSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp30_input.b75(tmp0_desc, 15, DoubleSerializer_getInstance(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp30_input.b75(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp30_input.b75(tmp0_desc, 17, StringSerializer_getInstance(), tmp21_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp30_input.b75(tmp0_desc, 18, BooleanSerializer_getInstance(), tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp30_input.b75(tmp0_desc, 19, StringSerializer_getInstance(), tmp23_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp30_input.b75(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp30_input.b75(tmp0_desc, 21, BooleanSerializer_getInstance(), tmp25_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp30_input.b75(tmp0_desc, 22, BooleanSerializer_getInstance(), tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp30_input.b75(tmp0_desc, 23, StringSerializer_getInstance(), tmp27_local23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
      tmp28_local24 = tmp30_input.b75(tmp0_desc, 24, StringSerializer_getInstance(), tmp28_local24);
      tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
      tmp29_local25 = tmp30_input.b75(tmp0_desc, 25, StringSerializer_getInstance(), tmp29_local25);
      tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp30_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp30_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp30_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp30_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp30_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp30_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp30_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp30_input.b75(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp30_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp30_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp30_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp30_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp30_input.b75(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp30_input.b75(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp30_input.b75(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp30_input.b75(tmp0_desc, 14, DoubleSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp30_input.b75(tmp0_desc, 15, DoubleSerializer_getInstance(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp30_input.b75(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp30_input.b75(tmp0_desc, 17, StringSerializer_getInstance(), tmp21_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp30_input.b75(tmp0_desc, 18, BooleanSerializer_getInstance(), tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp30_input.b75(tmp0_desc, 19, StringSerializer_getInstance(), tmp23_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp30_input.b75(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp30_input.b75(tmp0_desc, 21, BooleanSerializer_getInstance(), tmp25_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp30_input.b75(tmp0_desc, 22, BooleanSerializer_getInstance(), tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp30_input.b75(tmp0_desc, 23, StringSerializer_getInstance(), tmp27_local23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          case 24:
            tmp28_local24 = tmp30_input.b75(tmp0_desc, 24, StringSerializer_getInstance(), tmp28_local24);
            tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
            break;
          case 25:
            tmp29_local25 = tmp30_input.b75(tmp0_desc, 25, StringSerializer_getInstance(), tmp29_local25);
            tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp30_input.o74(tmp0_desc);
    return Profile_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, tmp29_local25, null);
  };
  protoOf($serializer_14).y70 = function () {
    return this.t101_1;
  };
  protoOf($serializer_14).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_14;
  function $serializer_getInstance_14() {
    if ($serializer_instance_14 == null)
      new $serializer_14();
    return $serializer_instance_14;
  }
  function Profile_init_$Init$(seen0, id, email, firstName, lastName, birthday, buildingNo, street, neighbourhood, city, country, location, avatarUrl, personalPhoneNumber, workPhoneNumber, latitude, longitude, fcmToken, role, isBanned, banUntil, banReason, isFirstLogin, canChangePhone, changedByAdmin, changedByAdminDate, provider, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_14().t101_1);
    }
    $this.uym_1 = id;
    if (0 === (seen0 & 2))
      $this.vym_1 = null;
    else
      $this.vym_1 = email;
    if (0 === (seen0 & 4))
      $this.wym_1 = null;
    else
      $this.wym_1 = firstName;
    if (0 === (seen0 & 8))
      $this.xym_1 = null;
    else
      $this.xym_1 = lastName;
    if (0 === (seen0 & 16))
      $this.yym_1 = null;
    else
      $this.yym_1 = birthday;
    if (0 === (seen0 & 32))
      $this.zym_1 = null;
    else
      $this.zym_1 = buildingNo;
    if (0 === (seen0 & 64))
      $this.ayn_1 = null;
    else
      $this.ayn_1 = street;
    if (0 === (seen0 & 128))
      $this.byn_1 = null;
    else
      $this.byn_1 = neighbourhood;
    if (0 === (seen0 & 256))
      $this.cyn_1 = null;
    else
      $this.cyn_1 = city;
    if (0 === (seen0 & 512))
      $this.dyn_1 = null;
    else
      $this.dyn_1 = country;
    if (0 === (seen0 & 1024))
      $this.eyn_1 = null;
    else
      $this.eyn_1 = location;
    if (0 === (seen0 & 2048))
      $this.fyn_1 = null;
    else
      $this.fyn_1 = avatarUrl;
    if (0 === (seen0 & 4096))
      $this.gyn_1 = null;
    else
      $this.gyn_1 = personalPhoneNumber;
    if (0 === (seen0 & 8192))
      $this.hyn_1 = null;
    else
      $this.hyn_1 = workPhoneNumber;
    if (0 === (seen0 & 16384))
      $this.iyn_1 = null;
    else
      $this.iyn_1 = latitude;
    if (0 === (seen0 & 32768))
      $this.jyn_1 = null;
    else
      $this.jyn_1 = longitude;
    if (0 === (seen0 & 65536))
      $this.kyn_1 = null;
    else
      $this.kyn_1 = fcmToken;
    if (0 === (seen0 & 131072))
      $this.lyn_1 = 'normal';
    else
      $this.lyn_1 = role;
    if (0 === (seen0 & 262144))
      $this.myn_1 = false;
    else
      $this.myn_1 = isBanned;
    if (0 === (seen0 & 524288))
      $this.nyn_1 = null;
    else
      $this.nyn_1 = banUntil;
    if (0 === (seen0 & 1048576))
      $this.oyn_1 = null;
    else
      $this.oyn_1 = banReason;
    if (0 === (seen0 & 2097152))
      $this.pyn_1 = true;
    else
      $this.pyn_1 = isFirstLogin;
    if (0 === (seen0 & 4194304))
      $this.qyn_1 = true;
    else
      $this.qyn_1 = canChangePhone;
    if (0 === (seen0 & 8388608))
      $this.ryn_1 = null;
    else
      $this.ryn_1 = changedByAdmin;
    if (0 === (seen0 & 16777216))
      $this.syn_1 = null;
    else
      $this.syn_1 = changedByAdminDate;
    if (0 === (seen0 & 33554432))
      $this.tyn_1 = 'email';
    else
      $this.tyn_1 = provider;
    return $this;
  }
  function Profile_init_$Create$(seen0, id, email, firstName, lastName, birthday, buildingNo, street, neighbourhood, city, country, location, avatarUrl, personalPhoneNumber, workPhoneNumber, latitude, longitude, fcmToken, role, isBanned, banUntil, banReason, isFirstLogin, canChangePhone, changedByAdmin, changedByAdminDate, provider, serializationConstructorMarker) {
    return Profile_init_$Init$(seen0, id, email, firstName, lastName, birthday, buildingNo, street, neighbourhood, city, country, location, avatarUrl, personalPhoneNumber, workPhoneNumber, latitude, longitude, fcmToken, role, isBanned, banUntil, banReason, isFirstLogin, canChangePhone, changedByAdmin, changedByAdminDate, provider, serializationConstructorMarker, objectCreate(protoOf(Profile)));
  }
  function Profile(id, email, firstName, lastName, birthday, buildingNo, street, neighbourhood, city, country, location, avatarUrl, personalPhoneNumber, workPhoneNumber, latitude, longitude, fcmToken, role, isBanned, banUntil, banReason, isFirstLogin, canChangePhone, changedByAdmin, changedByAdminDate, provider) {
    email = email === VOID ? null : email;
    firstName = firstName === VOID ? null : firstName;
    lastName = lastName === VOID ? null : lastName;
    birthday = birthday === VOID ? null : birthday;
    buildingNo = buildingNo === VOID ? null : buildingNo;
    street = street === VOID ? null : street;
    neighbourhood = neighbourhood === VOID ? null : neighbourhood;
    city = city === VOID ? null : city;
    country = country === VOID ? null : country;
    location = location === VOID ? null : location;
    avatarUrl = avatarUrl === VOID ? null : avatarUrl;
    personalPhoneNumber = personalPhoneNumber === VOID ? null : personalPhoneNumber;
    workPhoneNumber = workPhoneNumber === VOID ? null : workPhoneNumber;
    latitude = latitude === VOID ? null : latitude;
    longitude = longitude === VOID ? null : longitude;
    fcmToken = fcmToken === VOID ? null : fcmToken;
    role = role === VOID ? 'normal' : role;
    isBanned = isBanned === VOID ? false : isBanned;
    banUntil = banUntil === VOID ? null : banUntil;
    banReason = banReason === VOID ? null : banReason;
    isFirstLogin = isFirstLogin === VOID ? true : isFirstLogin;
    canChangePhone = canChangePhone === VOID ? true : canChangePhone;
    changedByAdmin = changedByAdmin === VOID ? null : changedByAdmin;
    changedByAdminDate = changedByAdminDate === VOID ? null : changedByAdminDate;
    provider = provider === VOID ? 'email' : provider;
    this.uym_1 = id;
    this.vym_1 = email;
    this.wym_1 = firstName;
    this.xym_1 = lastName;
    this.yym_1 = birthday;
    this.zym_1 = buildingNo;
    this.ayn_1 = street;
    this.byn_1 = neighbourhood;
    this.cyn_1 = city;
    this.dyn_1 = country;
    this.eyn_1 = location;
    this.fyn_1 = avatarUrl;
    this.gyn_1 = personalPhoneNumber;
    this.hyn_1 = workPhoneNumber;
    this.iyn_1 = latitude;
    this.jyn_1 = longitude;
    this.kyn_1 = fcmToken;
    this.lyn_1 = role;
    this.myn_1 = isBanned;
    this.nyn_1 = banUntil;
    this.oyn_1 = banReason;
    this.pyn_1 = isFirstLogin;
    this.qyn_1 = canChangePhone;
    this.ryn_1 = changedByAdmin;
    this.syn_1 = changedByAdminDate;
    this.tyn_1 = provider;
  }
  protoOf(Profile).v101 = function () {
    return !(this.iyn_1 == null) && !(this.jyn_1 == null) ? '' + this.iyn_1 + ', ' + this.jyn_1 : '';
  };
  protoOf(Profile).w101 = function (id, email, firstName, lastName, birthday, buildingNo, street, neighbourhood, city, country, location, avatarUrl, personalPhoneNumber, workPhoneNumber, latitude, longitude, fcmToken, role, isBanned, banUntil, banReason, isFirstLogin, canChangePhone, changedByAdmin, changedByAdminDate, provider) {
    return new Profile(id, email, firstName, lastName, birthday, buildingNo, street, neighbourhood, city, country, location, avatarUrl, personalPhoneNumber, workPhoneNumber, latitude, longitude, fcmToken, role, isBanned, banUntil, banReason, isFirstLogin, canChangePhone, changedByAdmin, changedByAdminDate, provider);
  };
  protoOf(Profile).uyn = function (id, email, firstName, lastName, birthday, buildingNo, street, neighbourhood, city, country, location, avatarUrl, personalPhoneNumber, workPhoneNumber, latitude, longitude, fcmToken, role, isBanned, banUntil, banReason, isFirstLogin, canChangePhone, changedByAdmin, changedByAdminDate, provider, $super) {
    id = id === VOID ? this.uym_1 : id;
    email = email === VOID ? this.vym_1 : email;
    firstName = firstName === VOID ? this.wym_1 : firstName;
    lastName = lastName === VOID ? this.xym_1 : lastName;
    birthday = birthday === VOID ? this.yym_1 : birthday;
    buildingNo = buildingNo === VOID ? this.zym_1 : buildingNo;
    street = street === VOID ? this.ayn_1 : street;
    neighbourhood = neighbourhood === VOID ? this.byn_1 : neighbourhood;
    city = city === VOID ? this.cyn_1 : city;
    country = country === VOID ? this.dyn_1 : country;
    location = location === VOID ? this.eyn_1 : location;
    avatarUrl = avatarUrl === VOID ? this.fyn_1 : avatarUrl;
    personalPhoneNumber = personalPhoneNumber === VOID ? this.gyn_1 : personalPhoneNumber;
    workPhoneNumber = workPhoneNumber === VOID ? this.hyn_1 : workPhoneNumber;
    latitude = latitude === VOID ? this.iyn_1 : latitude;
    longitude = longitude === VOID ? this.jyn_1 : longitude;
    fcmToken = fcmToken === VOID ? this.kyn_1 : fcmToken;
    role = role === VOID ? this.lyn_1 : role;
    isBanned = isBanned === VOID ? this.myn_1 : isBanned;
    banUntil = banUntil === VOID ? this.nyn_1 : banUntil;
    banReason = banReason === VOID ? this.oyn_1 : banReason;
    isFirstLogin = isFirstLogin === VOID ? this.pyn_1 : isFirstLogin;
    canChangePhone = canChangePhone === VOID ? this.qyn_1 : canChangePhone;
    changedByAdmin = changedByAdmin === VOID ? this.ryn_1 : changedByAdmin;
    changedByAdminDate = changedByAdminDate === VOID ? this.syn_1 : changedByAdminDate;
    provider = provider === VOID ? this.tyn_1 : provider;
    return $super === VOID ? this.w101(id, email, firstName, lastName, birthday, buildingNo, street, neighbourhood, city, country, location, avatarUrl, personalPhoneNumber, workPhoneNumber, latitude, longitude, fcmToken, role, isBanned, banUntil, banReason, isFirstLogin, canChangePhone, changedByAdmin, changedByAdminDate, provider) : $super.w101.call(this, id, email, firstName, lastName, birthday, buildingNo, street, neighbourhood, city, country, location, avatarUrl, personalPhoneNumber, workPhoneNumber, latitude, longitude, fcmToken, role, isBanned, banUntil, banReason, isFirstLogin, canChangePhone, changedByAdmin, changedByAdminDate, provider);
  };
  protoOf(Profile).toString = function () {
    return 'Profile(id=' + this.uym_1 + ', email=' + this.vym_1 + ', firstName=' + this.wym_1 + ', lastName=' + this.xym_1 + ', birthday=' + this.yym_1 + ', buildingNo=' + this.zym_1 + ', street=' + this.ayn_1 + ', neighbourhood=' + this.byn_1 + ', city=' + this.cyn_1 + ', country=' + this.dyn_1 + ', location=' + this.eyn_1 + ', avatarUrl=' + this.fyn_1 + ', personalPhoneNumber=' + this.gyn_1 + ', workPhoneNumber=' + this.hyn_1 + ', latitude=' + this.iyn_1 + ', longitude=' + this.jyn_1 + ', fcmToken=' + this.kyn_1 + ', role=' + this.lyn_1 + ', isBanned=' + this.myn_1 + ', banUntil=' + this.nyn_1 + ', banReason=' + this.oyn_1 + ', isFirstLogin=' + this.pyn_1 + ', canChangePhone=' + this.qyn_1 + ', changedByAdmin=' + this.ryn_1 + ', changedByAdminDate=' + this.syn_1 + ', provider=' + this.tyn_1 + ')';
  };
  protoOf(Profile).hashCode = function () {
    var result = getStringHashCode(this.uym_1);
    result = imul(result, 31) + (this.vym_1 == null ? 0 : getStringHashCode(this.vym_1)) | 0;
    result = imul(result, 31) + (this.wym_1 == null ? 0 : getStringHashCode(this.wym_1)) | 0;
    result = imul(result, 31) + (this.xym_1 == null ? 0 : getStringHashCode(this.xym_1)) | 0;
    result = imul(result, 31) + (this.yym_1 == null ? 0 : getStringHashCode(this.yym_1)) | 0;
    result = imul(result, 31) + (this.zym_1 == null ? 0 : getStringHashCode(this.zym_1)) | 0;
    result = imul(result, 31) + (this.ayn_1 == null ? 0 : getStringHashCode(this.ayn_1)) | 0;
    result = imul(result, 31) + (this.byn_1 == null ? 0 : getStringHashCode(this.byn_1)) | 0;
    result = imul(result, 31) + (this.cyn_1 == null ? 0 : getStringHashCode(this.cyn_1)) | 0;
    result = imul(result, 31) + (this.dyn_1 == null ? 0 : getStringHashCode(this.dyn_1)) | 0;
    result = imul(result, 31) + (this.eyn_1 == null ? 0 : getStringHashCode(this.eyn_1)) | 0;
    result = imul(result, 31) + (this.fyn_1 == null ? 0 : getStringHashCode(this.fyn_1)) | 0;
    result = imul(result, 31) + (this.gyn_1 == null ? 0 : getStringHashCode(this.gyn_1)) | 0;
    result = imul(result, 31) + (this.hyn_1 == null ? 0 : getStringHashCode(this.hyn_1)) | 0;
    result = imul(result, 31) + (this.iyn_1 == null ? 0 : getNumberHashCode(this.iyn_1)) | 0;
    result = imul(result, 31) + (this.jyn_1 == null ? 0 : getNumberHashCode(this.jyn_1)) | 0;
    result = imul(result, 31) + (this.kyn_1 == null ? 0 : getStringHashCode(this.kyn_1)) | 0;
    result = imul(result, 31) + (this.lyn_1 == null ? 0 : getStringHashCode(this.lyn_1)) | 0;
    result = imul(result, 31) + (this.myn_1 == null ? 0 : getBooleanHashCode(this.myn_1)) | 0;
    result = imul(result, 31) + (this.nyn_1 == null ? 0 : getStringHashCode(this.nyn_1)) | 0;
    result = imul(result, 31) + (this.oyn_1 == null ? 0 : getStringHashCode(this.oyn_1)) | 0;
    result = imul(result, 31) + (this.pyn_1 == null ? 0 : getBooleanHashCode(this.pyn_1)) | 0;
    result = imul(result, 31) + (this.qyn_1 == null ? 0 : getBooleanHashCode(this.qyn_1)) | 0;
    result = imul(result, 31) + (this.ryn_1 == null ? 0 : getStringHashCode(this.ryn_1)) | 0;
    result = imul(result, 31) + (this.syn_1 == null ? 0 : getStringHashCode(this.syn_1)) | 0;
    result = imul(result, 31) + (this.tyn_1 == null ? 0 : getStringHashCode(this.tyn_1)) | 0;
    return result;
  };
  protoOf(Profile).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Profile))
      return false;
    if (!(this.uym_1 === other.uym_1))
      return false;
    if (!(this.vym_1 == other.vym_1))
      return false;
    if (!(this.wym_1 == other.wym_1))
      return false;
    if (!(this.xym_1 == other.xym_1))
      return false;
    if (!(this.yym_1 == other.yym_1))
      return false;
    if (!(this.zym_1 == other.zym_1))
      return false;
    if (!(this.ayn_1 == other.ayn_1))
      return false;
    if (!(this.byn_1 == other.byn_1))
      return false;
    if (!(this.cyn_1 == other.cyn_1))
      return false;
    if (!(this.dyn_1 == other.dyn_1))
      return false;
    if (!(this.eyn_1 == other.eyn_1))
      return false;
    if (!(this.fyn_1 == other.fyn_1))
      return false;
    if (!(this.gyn_1 == other.gyn_1))
      return false;
    if (!(this.hyn_1 == other.hyn_1))
      return false;
    if (!equals(this.iyn_1, other.iyn_1))
      return false;
    if (!equals(this.jyn_1, other.jyn_1))
      return false;
    if (!(this.kyn_1 == other.kyn_1))
      return false;
    if (!(this.lyn_1 == other.lyn_1))
      return false;
    if (!(this.myn_1 == other.myn_1))
      return false;
    if (!(this.nyn_1 == other.nyn_1))
      return false;
    if (!(this.oyn_1 == other.oyn_1))
      return false;
    if (!(this.pyn_1 == other.pyn_1))
      return false;
    if (!(this.qyn_1 == other.qyn_1))
      return false;
    if (!(this.ryn_1 == other.ryn_1))
      return false;
    if (!(this.syn_1 == other.syn_1))
      return false;
    if (!(this.tyn_1 == other.tyn_1))
      return false;
    return true;
  };
  function toProfile(_this__u8e3s4, profile) {
    profile = profile === VOID ? null : profile;
    var userMeta = _this__u8e3s4.twk_1;
    var appMeta = _this__u8e3s4.fwk_1;
    var tmp1_elvis_lhs = profile == null ? null : profile.wym_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp3_safe_receiver = userMeta == null ? null : userMeta.je('first_name');
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : get_jsonPrimitive(tmp3_safe_receiver);
      tmp = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.rj3();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var tmp_0 = tmp;
    var tmp6_elvis_lhs = profile == null ? null : profile.xym_1;
    var tmp_1;
    if (tmp6_elvis_lhs == null) {
      var tmp8_safe_receiver = userMeta == null ? null : userMeta.je('last_name');
      var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : get_jsonPrimitive(tmp8_safe_receiver);
      tmp_1 = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.rj3();
    } else {
      tmp_1 = tmp6_elvis_lhs;
    }
    var tmp_2 = tmp_1;
    var tmp11_elvis_lhs = profile == null ? null : profile.yym_1;
    var tmp_3;
    if (tmp11_elvis_lhs == null) {
      var tmp13_safe_receiver = userMeta == null ? null : userMeta.je('birthday');
      var tmp14_safe_receiver = tmp13_safe_receiver == null ? null : get_jsonPrimitive(tmp13_safe_receiver);
      tmp_3 = tmp14_safe_receiver == null ? null : tmp14_safe_receiver.rj3();
    } else {
      tmp_3 = tmp11_elvis_lhs;
    }
    var tmp_4 = tmp_3;
    var tmp16_elvis_lhs = profile == null ? null : profile.zym_1;
    var tmp_5;
    if (tmp16_elvis_lhs == null) {
      var tmp18_safe_receiver = userMeta == null ? null : userMeta.je('building_no');
      var tmp19_safe_receiver = tmp18_safe_receiver == null ? null : get_jsonPrimitive(tmp18_safe_receiver);
      tmp_5 = tmp19_safe_receiver == null ? null : tmp19_safe_receiver.rj3();
    } else {
      tmp_5 = tmp16_elvis_lhs;
    }
    var tmp_6 = tmp_5;
    var tmp21_elvis_lhs = profile == null ? null : profile.ayn_1;
    var tmp_7;
    if (tmp21_elvis_lhs == null) {
      var tmp23_safe_receiver = userMeta == null ? null : userMeta.je('street');
      var tmp24_safe_receiver = tmp23_safe_receiver == null ? null : get_jsonPrimitive(tmp23_safe_receiver);
      tmp_7 = tmp24_safe_receiver == null ? null : tmp24_safe_receiver.rj3();
    } else {
      tmp_7 = tmp21_elvis_lhs;
    }
    var tmp_8 = tmp_7;
    var tmp26_elvis_lhs = profile == null ? null : profile.byn_1;
    var tmp_9;
    if (tmp26_elvis_lhs == null) {
      var tmp28_safe_receiver = userMeta == null ? null : userMeta.je('neighbourhood');
      var tmp29_safe_receiver = tmp28_safe_receiver == null ? null : get_jsonPrimitive(tmp28_safe_receiver);
      tmp_9 = tmp29_safe_receiver == null ? null : tmp29_safe_receiver.rj3();
    } else {
      tmp_9 = tmp26_elvis_lhs;
    }
    var tmp_10 = tmp_9;
    var tmp31_elvis_lhs = profile == null ? null : profile.cyn_1;
    var tmp_11;
    if (tmp31_elvis_lhs == null) {
      var tmp33_safe_receiver = userMeta == null ? null : userMeta.je('city');
      var tmp34_safe_receiver = tmp33_safe_receiver == null ? null : get_jsonPrimitive(tmp33_safe_receiver);
      tmp_11 = tmp34_safe_receiver == null ? null : tmp34_safe_receiver.rj3();
    } else {
      tmp_11 = tmp31_elvis_lhs;
    }
    var tmp_12 = tmp_11;
    var tmp36_elvis_lhs = profile == null ? null : profile.dyn_1;
    var tmp_13;
    if (tmp36_elvis_lhs == null) {
      var tmp38_safe_receiver = userMeta == null ? null : userMeta.je('country');
      var tmp39_safe_receiver = tmp38_safe_receiver == null ? null : get_jsonPrimitive(tmp38_safe_receiver);
      tmp_13 = tmp39_safe_receiver == null ? null : tmp39_safe_receiver.rj3();
    } else {
      tmp_13 = tmp36_elvis_lhs;
    }
    var tmp_14 = tmp_13;
    var tmp41_elvis_lhs = profile == null ? null : profile.eyn_1;
    var tmp_15;
    if (tmp41_elvis_lhs == null) {
      var tmp43_safe_receiver = userMeta == null ? null : userMeta.je('location');
      var tmp44_safe_receiver = tmp43_safe_receiver == null ? null : get_jsonPrimitive(tmp43_safe_receiver);
      tmp_15 = tmp44_safe_receiver == null ? null : tmp44_safe_receiver.rj3();
    } else {
      tmp_15 = tmp41_elvis_lhs;
    }
    var tmp_16 = tmp_15;
    var tmp46_elvis_lhs = profile == null ? null : profile.fyn_1;
    var tmp_17;
    if (tmp46_elvis_lhs == null) {
      var tmp48_safe_receiver = userMeta == null ? null : userMeta.je('avatar_url');
      var tmp49_safe_receiver = tmp48_safe_receiver == null ? null : get_jsonPrimitive(tmp48_safe_receiver);
      tmp_17 = tmp49_safe_receiver == null ? null : tmp49_safe_receiver.rj3();
    } else {
      tmp_17 = tmp46_elvis_lhs;
    }
    var tmp_18 = tmp_17;
    var tmp51_elvis_lhs = profile == null ? null : profile.gyn_1;
    var tmp_19;
    if (tmp51_elvis_lhs == null) {
      var tmp53_safe_receiver = userMeta == null ? null : userMeta.je('personal_phone_number');
      var tmp54_safe_receiver = tmp53_safe_receiver == null ? null : get_jsonPrimitive(tmp53_safe_receiver);
      tmp_19 = tmp54_safe_receiver == null ? null : tmp54_safe_receiver.rj3();
    } else {
      tmp_19 = tmp51_elvis_lhs;
    }
    var tmp_20 = tmp_19;
    var tmp56_elvis_lhs = profile == null ? null : profile.hyn_1;
    var tmp_21;
    if (tmp56_elvis_lhs == null) {
      var tmp58_safe_receiver = userMeta == null ? null : userMeta.je('work_phone_number');
      var tmp59_safe_receiver = tmp58_safe_receiver == null ? null : get_jsonPrimitive(tmp58_safe_receiver);
      tmp_21 = tmp59_safe_receiver == null ? null : tmp59_safe_receiver.rj3();
    } else {
      tmp_21 = tmp56_elvis_lhs;
    }
    var tmp_22 = tmp_21;
    var tmp61_elvis_lhs = profile == null ? null : profile.iyn_1;
    var tmp_23;
    if (tmp61_elvis_lhs == null) {
      var tmp63_safe_receiver = userMeta == null ? null : userMeta.je('latitude');
      var tmp64_safe_receiver = tmp63_safe_receiver == null ? null : get_jsonPrimitive(tmp63_safe_receiver);
      var tmp65_safe_receiver = tmp64_safe_receiver == null ? null : tmp64_safe_receiver.rj3();
      tmp_23 = tmp65_safe_receiver == null ? null : toDoubleOrNull(tmp65_safe_receiver);
    } else {
      tmp_23 = tmp61_elvis_lhs;
    }
    var tmp_24 = tmp_23;
    var tmp67_elvis_lhs = profile == null ? null : profile.jyn_1;
    var tmp_25;
    if (tmp67_elvis_lhs == null) {
      var tmp69_safe_receiver = userMeta == null ? null : userMeta.je('longitude');
      var tmp70_safe_receiver = tmp69_safe_receiver == null ? null : get_jsonPrimitive(tmp69_safe_receiver);
      var tmp71_safe_receiver = tmp70_safe_receiver == null ? null : tmp70_safe_receiver.rj3();
      tmp_25 = tmp71_safe_receiver == null ? null : toDoubleOrNull(tmp71_safe_receiver);
    } else {
      tmp_25 = tmp67_elvis_lhs;
    }
    var tmp_26 = tmp_25;
    var tmp73_elvis_lhs = profile == null ? null : profile.kyn_1;
    var tmp_27;
    if (tmp73_elvis_lhs == null) {
      var tmp75_safe_receiver = userMeta == null ? null : userMeta.je('fcm_token');
      var tmp76_safe_receiver = tmp75_safe_receiver == null ? null : get_jsonPrimitive(tmp75_safe_receiver);
      tmp_27 = tmp76_safe_receiver == null ? null : tmp76_safe_receiver.rj3();
    } else {
      tmp_27 = tmp73_elvis_lhs;
    }
    var tmp_28 = tmp_27;
    var tmp78_safe_receiver = appMeta == null ? null : appMeta.je('role');
    var tmp79_safe_receiver = tmp78_safe_receiver == null ? null : get_jsonPrimitive(tmp78_safe_receiver);
    var tmp80_elvis_lhs = tmp79_safe_receiver == null ? null : tmp79_safe_receiver.rj3();
    var tmp_29;
    if (tmp80_elvis_lhs == null) {
      tmp_29 = profile == null ? null : profile.lyn_1;
    } else {
      tmp_29 = tmp80_elvis_lhs;
    }
    var tmp82_elvis_lhs = tmp_29;
    var tmp_30 = tmp82_elvis_lhs == null ? 'normal' : tmp82_elvis_lhs;
    var tmp84_safe_receiver = appMeta == null ? null : appMeta.je('is_banned');
    var tmp85_safe_receiver = tmp84_safe_receiver == null ? null : get_jsonPrimitive(tmp84_safe_receiver);
    var tmp86_elvis_lhs = tmp85_safe_receiver == null ? null : get_booleanOrNull(tmp85_safe_receiver);
    var tmp_31;
    if (tmp86_elvis_lhs == null) {
      tmp_31 = profile == null ? null : profile.myn_1;
    } else {
      tmp_31 = tmp86_elvis_lhs;
    }
    var tmp88_elvis_lhs = tmp_31;
    var tmp_32 = tmp88_elvis_lhs == null ? false : tmp88_elvis_lhs;
    var tmp90_elvis_lhs = profile == null ? null : profile.pyn_1;
    var tmp_33;
    if (tmp90_elvis_lhs == null) {
      var tmp92_safe_receiver = userMeta == null ? null : userMeta.je('is_first_login');
      var tmp93_safe_receiver = tmp92_safe_receiver == null ? null : get_jsonPrimitive(tmp92_safe_receiver);
      tmp_33 = tmp93_safe_receiver == null ? null : get_booleanOrNull(tmp93_safe_receiver);
    } else {
      tmp_33 = tmp90_elvis_lhs;
    }
    var tmp94_elvis_lhs = tmp_33;
    var tmp_34 = tmp94_elvis_lhs == null ? true : tmp94_elvis_lhs;
    var tmp96_safe_receiver = appMeta == null ? null : appMeta.je('can_change_phone');
    var tmp97_safe_receiver = tmp96_safe_receiver == null ? null : get_jsonPrimitive(tmp96_safe_receiver);
    var tmp98_elvis_lhs = tmp97_safe_receiver == null ? null : get_booleanOrNull(tmp97_safe_receiver);
    var tmp_35;
    if (tmp98_elvis_lhs == null) {
      tmp_35 = profile == null ? null : profile.qyn_1;
    } else {
      tmp_35 = tmp98_elvis_lhs;
    }
    var tmp100_elvis_lhs = tmp_35;
    var tmp_36 = tmp100_elvis_lhs == null ? true : tmp100_elvis_lhs;
    var tmp102_elvis_lhs = profile == null ? null : profile.ryn_1;
    var tmp_37;
    if (tmp102_elvis_lhs == null) {
      var tmp104_safe_receiver = userMeta == null ? null : userMeta.je('changed_by_admin');
      var tmp105_safe_receiver = tmp104_safe_receiver == null ? null : get_jsonPrimitive(tmp104_safe_receiver);
      tmp_37 = tmp105_safe_receiver == null ? null : tmp105_safe_receiver.rj3();
    } else {
      tmp_37 = tmp102_elvis_lhs;
    }
    var tmp_38 = tmp_37;
    var tmp107_elvis_lhs = profile == null ? null : profile.syn_1;
    var tmp_39;
    if (tmp107_elvis_lhs == null) {
      var tmp109_safe_receiver = userMeta == null ? null : userMeta.je('changed_by_admin_date');
      var tmp110_safe_receiver = tmp109_safe_receiver == null ? null : get_jsonPrimitive(tmp109_safe_receiver);
      tmp_39 = tmp110_safe_receiver == null ? null : tmp110_safe_receiver.rj3();
    } else {
      tmp_39 = tmp107_elvis_lhs;
    }
    var tmp_40 = tmp_39;
    var tmp112_safe_receiver = appMeta == null ? null : appMeta.je('provider');
    var tmp113_safe_receiver = tmp112_safe_receiver == null ? null : get_jsonPrimitive(tmp112_safe_receiver);
    var tmp114_elvis_lhs = tmp113_safe_receiver == null ? null : tmp113_safe_receiver.rj3();
    var tmp_41;
    if (tmp114_elvis_lhs == null) {
      tmp_41 = profile == null ? null : profile.tyn_1;
    } else {
      tmp_41 = tmp114_elvis_lhs;
    }
    var tmp116_elvis_lhs = tmp_41;
    var tmp_42;
    if (tmp116_elvis_lhs == null) {
      var tmp117_safe_receiver = _this__u8e3s4.twk_1;
      var tmp118_safe_receiver = tmp117_safe_receiver == null ? null : tmp117_safe_receiver.je('provider');
      var tmp119_safe_receiver = tmp118_safe_receiver == null ? null : get_jsonPrimitive(tmp118_safe_receiver);
      tmp_42 = tmp119_safe_receiver == null ? null : tmp119_safe_receiver.rj3();
    } else {
      tmp_42 = tmp116_elvis_lhs;
    }
    var tmp120_elvis_lhs = tmp_42;
    return new Profile(_this__u8e3s4.nwk_1, _this__u8e3s4.kwk_1, tmp_0, tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, tmp_26, tmp_28, tmp_30, tmp_32, VOID, VOID, tmp_34, tmp_36, tmp_38, tmp_40, tmp120_elvis_lhs == null ? 'email' : tmp120_elvis_lhs);
  }
  var client_fstech_hadaya_domain_model_StockReminder_$serializer$stable;
  var client_fstech_hadaya_domain_model_StockReminder$stable;
  function Companion_20() {
  }
  var Companion_instance_26;
  function Companion_getInstance_55() {
    return Companion_instance_26;
  }
  function $serializer_15() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.domain.model.StockReminder', this, 3);
    tmp0_serialDesc.a7c('product_id', false);
    tmp0_serialDesc.a7c('user_id', false);
    tmp0_serialDesc.a7c('created_at', true);
    this.x101_1 = tmp0_serialDesc;
  }
  protoOf($serializer_15).y101 = function (encoder, value) {
    var tmp0_desc = this.x101_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.y75(tmp0_desc, 0, value.tzo_1);
    tmp1_output.c76(tmp0_desc, 1, value.uzo_1);
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !equalsLong(value.vzo_1, System_instance.fp().wp())) {
      tmp1_output.y75(tmp0_desc, 2, value.vzo_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_15).z70 = function (encoder, value) {
    return this.y101(encoder, value instanceof StockReminder ? value : THROW_CCE());
  };
  protoOf($serializer_15).a71 = function (decoder) {
    var tmp0_desc = this.x101_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.n74(tmp0_desc);
    if (tmp7_input.d75()) {
      tmp4_local0 = tmp7_input.t74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.x74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.t74(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.t74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.x74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.t74(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.o74(tmp0_desc);
    return StockReminder_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_15).y70 = function () {
    return this.x101_1;
  };
  protoOf($serializer_15).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_15;
  function $serializer_getInstance_15() {
    if ($serializer_instance_15 == null)
      new $serializer_15();
    return $serializer_instance_15;
  }
  function StockReminder_init_$Init$(seen0, productId, userId, createdAt, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_15().x101_1);
    }
    $this.tzo_1 = productId;
    $this.uzo_1 = userId;
    if (0 === (seen0 & 4))
      $this.vzo_1 = System_instance.fp().wp();
    else
      $this.vzo_1 = createdAt;
    return $this;
  }
  function StockReminder_init_$Create$(seen0, productId, userId, createdAt, serializationConstructorMarker) {
    return StockReminder_init_$Init$(seen0, productId, userId, createdAt, serializationConstructorMarker, objectCreate(protoOf(StockReminder)));
  }
  function StockReminder(productId, userId, createdAt) {
    createdAt = createdAt === VOID ? System_instance.fp().wp() : createdAt;
    this.tzo_1 = productId;
    this.uzo_1 = userId;
    this.vzo_1 = createdAt;
  }
  protoOf(StockReminder).toString = function () {
    return 'StockReminder(productId=' + this.tzo_1.toString() + ', userId=' + this.uzo_1 + ', createdAt=' + this.vzo_1.toString() + ')';
  };
  protoOf(StockReminder).hashCode = function () {
    var result = this.tzo_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.uzo_1) | 0;
    result = imul(result, 31) + this.vzo_1.hashCode() | 0;
    return result;
  };
  protoOf(StockReminder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StockReminder))
      return false;
    if (!equalsLong(this.tzo_1, other.tzo_1))
      return false;
    if (!(this.uzo_1 === other.uzo_1))
      return false;
    if (!equalsLong(this.vzo_1, other.vzo_1))
      return false;
    return true;
  };
  function IAuthRepository() {
  }
  function ICartRepository() {
  }
  function ICouponRepository() {
  }
  function IFavoriteRepository() {
  }
  function IFriendRepository() {
  }
  function INotificationRepository() {
  }
  function IOrderRepository() {
  }
  function IProductRepository() {
  }
  function ISettingsRepository() {
  }
  function IStockReminderRepository() {
  }
  function IStorageRepository() {
  }
  var client_fstech_hadaya_domain_usecase_ApplyCouponUseCase$stable;
  function ApplyCouponUseCase(couponRepository) {
    this.z101_1 = couponRepository;
  }
  protoOf(ApplyCouponUseCase).a102 = function (code, $completion) {
    return this.z101_1.kz4(code, $completion);
  };
  var client_fstech_hadaya_domain_usecase_CreateWelcomeCouponUseCase$stable;
  function CreateWelcomeCouponUseCase(couponRepository) {
    this.tyq_1 = couponRepository;
  }
  protoOf(CreateWelcomeCouponUseCase).uyq = function (userId, discountValue, $completion) {
    return this.tyq_1.mz4(userId, discountValue, $completion);
  };
  var client_fstech_hadaya_domain_usecase_FetchProfileUseCase$stable;
  function FetchProfileUseCase(repository) {
    this.b102_1 = repository;
  }
  protoOf(FetchProfileUseCase).c102 = function ($completion) {
    return this.b102_1.yyv($completion);
  };
  var client_fstech_hadaya_domain_usecase_GetBannersUseCase$stable;
  function GetBannersUseCase(repository) {
    this.d102_1 = repository;
  }
  protoOf(GetBannersUseCase).ynu = function () {
    return this.d102_1.vzk();
  };
  protoOf(GetBannersUseCase).e102 = function ($completion) {
    return this.d102_1.mzg($completion);
  };
  var client_fstech_hadaya_domain_usecase_GetCurrentUserUseCase$stable;
  function GetCurrentUserUseCase(repository) {
    this.f102_1 = repository;
  }
  protoOf(GetCurrentUserUseCase).ynu = function () {
    return this.f102_1.oyv();
  };
  var client_fstech_hadaya_domain_usecase_GetCurrentUserValueUseCase$stable;
  function GetCurrentUserValueUseCase(repository) {
    this.g102_1 = repository;
  }
  protoOf(GetCurrentUserValueUseCase).ynu = function () {
    return this.g102_1.xyv();
  };
  var client_fstech_hadaya_domain_usecase_GetFavoriteProductsUseCase$stable;
  function GetFavoriteProductsUseCase(repository) {
    this.h102_1 = repository;
  }
  protoOf(GetFavoriteProductsUseCase).ynu = function () {
    return this.h102_1.uz6();
  };
  var client_fstech_hadaya_domain_usecase_GetProductsUseCase$stable;
  function GetProductsUseCase(repository) {
    this.i102_1 = repository;
  }
  protoOf(GetProductsUseCase).ynu = function () {
    return this.i102_1.tzk();
  };
  protoOf(GetProductsUseCase).e102 = function ($completion) {
    return this.i102_1.bzg($completion);
  };
  var client_fstech_hadaya_domain_usecase_GetUserCouponsUseCase$stable;
  function GetUserCouponsUseCase(couponRepository) {
    this.j102_1 = couponRepository;
  }
  protoOf(GetUserCouponsUseCase).k102 = function (userId, $completion) {
    return this.j102_1.nz4(userId, $completion);
  };
  var client_fstech_hadaya_domain_usecase_HandleRecoveryLinkUseCase$stable;
  function HandleRecoveryLinkUseCase(repository) {
    this.l102_1 = repository;
  }
  protoOf(HandleRecoveryLinkUseCase).pyo = function (url, $completion) {
    return this.l102_1.tyv(url, $completion);
  };
  var client_fstech_hadaya_domain_usecase_LoginUseCase$stable;
  function LoginUseCase(repository) {
    this.m102_1 = repository;
  }
  protoOf(LoginUseCase).n102 = function (email, password, $completion) {
    return this.m102_1.qyv(email, password, $completion);
  };
  var client_fstech_hadaya_domain_usecase_LoginWithGoogleUseCase$stable;
  function LoginWithGoogleUseCase(repository) {
    this.o102_1 = repository;
  }
  protoOf(LoginWithGoogleUseCase).p102 = function (idToken, accessToken, $completion) {
    return this.o102_1.pyv(idToken, accessToken, $completion);
  };
  var client_fstech_hadaya_domain_usecase_MarkCouponAsUsedUseCase$stable;
  function MarkCouponAsUsedUseCase(couponRepository) {
    this.q102_1 = couponRepository;
  }
  protoOf(MarkCouponAsUsedUseCase).r102 = function (couponId, userId, $completion) {
    return this.q102_1.lz4(couponId, userId, $completion);
  };
  var client_fstech_hadaya_domain_usecase_NotifyAdminUseCase$stable;
  function NotifyAdminUseCase(repository) {
    this.s102_1 = repository;
  }
  var client_fstech_hadaya_domain_usecase_RegisterUseCase$stable;
  function RegisterUseCase(repository) {
    this.t102_1 = repository;
  }
  protoOf(RegisterUseCase).n102 = function (email, password, $completion) {
    return this.t102_1.ryv(email, password, $completion);
  };
  var client_fstech_hadaya_domain_usecase_ResetPasswordUseCase$stable;
  function ResetPasswordUseCase(repository) {
    this.u102_1 = repository;
  }
  protoOf(ResetPasswordUseCase).v102 = function (email, redirectTo, $completion) {
    return this.u102_1.syv(email, redirectTo, $completion);
  };
  var client_fstech_hadaya_domain_usecase_UpdateFcmTokenUseCase$stable;
  function UpdateFcmTokenUseCase(repository) {
    this.w102_1 = repository;
  }
  protoOf(UpdateFcmTokenUseCase).x102 = function (token, $completion) {
    return this.w102_1.dyw(token, $completion);
  };
  var client_fstech_hadaya_domain_usecase_UpdatePasswordUseCase$stable;
  function UpdatePasswordUseCase(repository) {
    this.y102_1 = repository;
  }
  protoOf(UpdatePasswordUseCase).x102 = function (password, $completion) {
    return this.y102_1.cyw(password, $completion);
  };
  var client_fstech_hadaya_domain_usecase_UpdateProfileUseCase$stable;
  function UpdateProfileUseCase(repository) {
    this.z102_1 = repository;
  }
  protoOf(UpdateProfileUseCase).a103 = function (profile, $completion) {
    return this.z102_1.byw(profile, $completion);
  };
  var client_fstech_hadaya_domain_usecase_cart_AddToCartUseCase$stable;
  function AddToCartUseCase(repository) {
    this.b103_1 = repository;
  }
  protoOf(AddToCartUseCase).c103 = function (cartItem, $completion) {
    return this.b103_1.oz2(cartItem, $completion);
  };
  var client_fstech_hadaya_domain_usecase_cart_ClearCartUseCase$stable;
  function ClearCartUseCase(repository) {
    this.d103_1 = repository;
  }
  protoOf(ClearCartUseCase).r2b = function ($completion) {
    return this.d103_1.cz2($completion);
  };
  var client_fstech_hadaya_domain_usecase_cart_GetCartItemByIdUseCase$stable;
  function GetCartItemByIdUseCase(repository) {
    this.e103_1 = repository;
  }
  protoOf(GetCartItemByIdUseCase).f103 = function (id, $completion) {
    return this.e103_1.nz2(id, $completion);
  };
  var client_fstech_hadaya_domain_usecase_cart_GetCartItemsUseCase$stable;
  function GetCartItemsUseCase(repository) {
    this.g103_1 = repository;
  }
  protoOf(GetCartItemsUseCase).ynu = function () {
    return this.g103_1.mz2();
  };
  var client_fstech_hadaya_domain_usecase_cart_RemoveFromCartUseCase$stable;
  function RemoveFromCartUseCase(repository) {
    this.h103_1 = repository;
  }
  protoOf(RemoveFromCartUseCase).c103 = function (cartItem, $completion) {
    return this.h103_1.sz1(cartItem, $completion);
  };
  var client_fstech_hadaya_domain_usecase_cart_SyncCartUseCase$stable;
  function SyncCartUseCase(repository) {
    this.i103_1 = repository;
  }
  protoOf(SyncCartUseCase).r2b = function ($completion) {
    return this.i103_1.pz2($completion);
  };
  var client_fstech_hadaya_domain_usecase_cart_UpdateCartQuantityUseCase$stable;
  function UpdateCartQuantityUseCase(repository) {
    this.j103_1 = repository;
  }
  protoOf(UpdateCartQuantityUseCase).k103 = function (cartItem, newQuantity, $completion) {
    return this.j103_1.dz0(cartItem.jyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, newQuantity), $completion);
  };
  var client_fstech_hadaya_domain_usecase_favorites_SyncFavoritesUseCase$stable;
  function SyncFavoritesUseCase(repository) {
    this.l103_1 = repository;
  }
  protoOf(SyncFavoritesUseCase).r2b = function ($completion) {
    return this.l103_1.wz6($completion);
  };
  var client_fstech_hadaya_domain_usecase_favorites_ToggleFavoriteUseCase$stable;
  function ToggleFavoriteUseCase(repository) {
    this.m103_1 = repository;
  }
  protoOf(ToggleFavoriteUseCase).vdf = function (productId, $completion) {
    return this.m103_1.vz6(productId, $completion);
  };
  var client_fstech_hadaya_domain_usecase_friends_AddFriendUseCase$stable;
  function AddFriendUseCase(repository) {
    this.n103_1 = repository;
  }
  protoOf(AddFriendUseCase).o103 = function (friend, $completion) {
    return this.n103_1.cza(friend, $completion);
  };
  var client_fstech_hadaya_domain_usecase_friends_DeleteFriendAvatarUseCase$stable;
  function DeleteFriendAvatarUseCase(repository) {
    this.p103_1 = repository;
  }
  protoOf(DeleteFriendAvatarUseCase).pyo = function (url, $completion) {
    return this.p103_1.gza(url, $completion);
  };
  var client_fstech_hadaya_domain_usecase_friends_DeleteFriendUseCase$stable;
  function DeleteFriendUseCase(repository) {
    this.q103_1 = repository;
  }
  protoOf(DeleteFriendUseCase).pyo = function (friendId, $completion) {
    return this.q103_1.eza(friendId, $completion);
  };
  var client_fstech_hadaya_domain_usecase_friends_GetFriendsUseCase$stable;
  function GetFriendsUseCase(repository) {
    this.r103_1 = repository;
  }
  protoOf(GetFriendsUseCase).s103 = function ($completion) {
    return this.r103_1.bza($completion);
  };
  var client_fstech_hadaya_domain_usecase_friends_UpdateFriendUseCase$stable;
  function UpdateFriendUseCase(repository) {
    this.t103_1 = repository;
  }
  protoOf(UpdateFriendUseCase).u103 = function (friend, $completion) {
    return this.t103_1.dza(friend, $completion);
  };
  var client_fstech_hadaya_domain_usecase_friends_UploadFriendAvatarUseCase$stable;
  function UploadFriendAvatarUseCase(repository) {
    this.v103_1 = repository;
  }
  protoOf(UploadFriendAvatarUseCase).w103 = function (friendId, imageBytes, $completion) {
    return this.v103_1.fza(friendId, imageBytes, $completion);
  };
  var client_fstech_hadaya_domain_usecase_language_GetLanguageUseCase$stable;
  function GetLanguageUseCase(repository) {
    this.x103_1 = repository;
  }
  protoOf(GetLanguageUseCase).ynu = function () {
    return this.x103_1.nyv();
  };
  protoOf(GetLanguageUseCase).y103 = function () {
    return this.x103_1.n8m();
  };
  var client_fstech_hadaya_domain_usecase_language_SetLanguageUseCase$stable;
  function SetLanguageUseCase(repository) {
    this.z103_1 = repository;
  }
  protoOf(SetLanguageUseCase).a104 = function (lang) {
    return this.z103_1.eyw(lang);
  };
  var client_fstech_hadaya_domain_usecase_network_IsConnectedUseCase$stable;
  function IsConnectedUseCase(networkObserver) {
    this.b104_1 = networkObserver;
  }
  protoOf(IsConnectedUseCase).ynu = function () {
    return this.b104_1.fz1().u1();
  };
  protoOf(IsConnectedUseCase).y103 = function () {
    return this.b104_1.fz1();
  };
  var client_fstech_hadaya_domain_usecase_order_GetOrderByIdUseCase$stable;
  function GetOrderByIdUseCase(repository) {
    this.c104_1 = repository;
  }
  protoOf(GetOrderByIdUseCase).d104 = function (orderId, $completion) {
    return this.c104_1.jzf(orderId, $completion);
  };
  var client_fstech_hadaya_domain_usecase_order_GetOrderHistoryUseCase$stable;
  function GetOrderHistoryUseCase(repository) {
    this.e104_1 = repository;
  }
  protoOf(GetOrderHistoryUseCase).f104 = function (userId, $completion) {
    return this.e104_1.izf(userId, $completion);
  };
  var client_fstech_hadaya_domain_usecase_order_PlaceOrderUseCase$stable;
  function $invokeCOROUTINE$(_this__u8e3s4, order, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o104_1 = _this__u8e3s4;
    this.p104_1 = order;
  }
  protoOf($invokeCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 14;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.p104_1.mzc_1;
            tmp_0.b105_1 = tmp0_elvis_lhs == null ? 'anonymous' : tmp0_elvis_lhs;
            this.a105_1 = System_instance.fp().wp();
            var this_0 = this.p104_1.uzc_1;
            this.s104_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            this.e105_1 = 0;
            this.f105_1 = this_0.t();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!this.f105_1.u()) {
              this.n9_1 = 9;
              continue $sm;
            }

            var item = this.f105_1.v();
            var _unary__edvuaz = this.e105_1;
            this.e105_1 = _unary__edvuaz + 1 | 0;
            this.z104_1 = checkIndexOverflow(_unary__edvuaz);
            this.d105_1 = item;
            this.t104_1 = this.d105_1;
            var customImageBytes = this.d105_1.xyw_1;
            if (!(customImageBytes == null) && this.d105_1.syw_1 == null) {
              var fileName = 'custom_designs/' + this.b105_1 + '/final_' + this.a105_1.toString() + '_' + this.z104_1 + '.png';
              this.n9_1 = 2;
              suspendResult = this.o104_1.i105_1.k105(customImageBytes, fileName, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(this.d105_1.syw_1 == null)) {
                this.t104_1 = this.t104_1.jyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null);
                this.n9_1 = 3;
                continue $sm;
              } else {
                this.n9_1 = 3;
                continue $sm;
              }
            }

          case 2:
            var url = suspendResult;
            if (!(url == null)) {
              this.t104_1 = this.t104_1.jyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, url, VOID, VOID, VOID, VOID, null);
            }

            this.n9_1 = 3;
            continue $sm;
          case 3:
            var tmp0_safe_receiver = this.d105_1.tyw_1;
            var tmp_1;
            if (tmp0_safe_receiver == null) {
              tmp_1 = null;
            } else {
              var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver, 10));
              var _iterator__ex2g4s = tmp0_safe_receiver.t();
              while (_iterator__ex2g4s.u()) {
                var item_0 = _iterator__ex2g4s.v();
                destination.j1(item_0.iyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null));
              }
              tmp_1 = destination;
            }

            var updatedLayers = tmp_1;
            if (!(updatedLayers == null)) {
              this.t104_1 = this.t104_1.jyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, updatedLayers);
            }

            var tmp1_safe_receiver = this.d105_1.lyx_1;
            if (tmp1_safe_receiver == null) {
              this.u104_1 = null;
              this.n9_1 = 8;
              continue $sm;
            } else {
              var destination_0 = LinkedHashMap_init_$Create$(mapCapacity(tmp1_safe_receiver.n1()));
              var this_1 = tmp1_safe_receiver.s1();
              this.v104_1 = destination_0;
              this.c105_1 = this_1.t();
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            if (!this.c105_1.u()) {
              this.n9_1 = 7;
              continue $sm;
            }

            var element = this.c105_1.v();
            var tmp_2 = this;
            tmp_2.w104_1 = element.t1();
            var key = element.t1();
            var tmp_3 = this;
            tmp_3.y104_1 = element.u1();
            var imageBytes = this.y104_1.i101_1;
            if (!(imageBytes == null)) {
              var fileName_0 = 'option_designs/' + this.b105_1 + '/opt_' + this.a105_1.toString() + '_' + this.z104_1 + '_' + key + '.png';
              this.n9_1 = 5;
              suspendResult = this.o104_1.i105_1.k105(imageBytes, fileName_0, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_4 = this;
              tmp_4.x104_1 = this.y104_1.k101(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null);
              this.n9_1 = 6;
              continue $sm;
            }

          case 5:
            var url_0 = suspendResult;
            var tmp_5 = this;
            var tmp_6;
            if (!(url_0 == null)) {
              tmp_6 = this.y104_1.k101(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, listOf(url_0), null);
            } else {
              tmp_6 = this.y104_1.k101(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null);
            }

            tmp_5.x104_1 = tmp_6;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var ARGUMENT = this.x104_1;
            this.v104_1.z2(this.w104_1, ARGUMENT);
            this.n9_1 = 4;
            continue $sm;
          case 7:
            this.u104_1 = this.v104_1;
            this.n9_1 = 8;
            continue $sm;
          case 8:
            var updatedOptions = this.u104_1;
            if (!(updatedOptions == null)) {
              this.t104_1 = this.t104_1.jyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, updatedOptions);
            }

            var ARGUMENT_0 = this.t104_1;
            this.s104_1.j1(ARGUMENT_0);
            this.n9_1 = 1;
            continue $sm;
          case 9:
            var updatedItems = this.s104_1;
            this.q104_1 = this.p104_1.jzd(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, updatedItems, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, System_instance.fp().wp());
            var tmp1_safe_receiver_0 = this.p104_1.hzd_1;
            if (tmp1_safe_receiver_0 == null) {
              this.r104_1 = null;
              this.n9_1 = 12;
              continue $sm;
            } else {
              if (!(this.p104_1.mzc_1 == null)) {
                this.n9_1 = 10;
                suspendResult = this.o104_1.h105_1.r102(tmp1_safe_receiver_0, this.p104_1.mzc_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 11;
                continue $sm;
              }
            }

          case 10:
            this.n9_1 = 11;
            continue $sm;
          case 11:
            var tmp_7 = this;
            tmp_7.r104_1 = Unit_instance;
            this.n9_1 = 12;
            continue $sm;
          case 12:
            this.n9_1 = 13;
            suspendResult = this.o104_1.g105_1.hzf(this.q104_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 13:
            return suspendResult;
          case 14:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 14) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function PlaceOrderUseCase(repository, markCouponAsUsedUseCase, uploadDesignImageUseCase) {
    this.g105_1 = repository;
    this.h105_1 = markCouponAsUsedUseCase;
    this.i105_1 = uploadDesignImageUseCase;
  }
  protoOf(PlaceOrderUseCase).l105 = function (order, $completion) {
    var tmp = new $invokeCOROUTINE$(this, order, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  var client_fstech_hadaya_domain_usecase_order_RequestReturnUseCase$stable;
  function RequestReturnUseCase(repository) {
    this.m105_1 = repository;
  }
  protoOf(RequestReturnUseCase).r102 = function (orderId, reason, $completion) {
    return this.m105_1.kzf(orderId, reason, $completion);
  };
  var client_fstech_hadaya_domain_usecase_products_GetProductByIdUseCase$stable;
  function GetProductByIdUseCase(repository) {
    this.n105_1 = repository;
  }
  protoOf(GetProductByIdUseCase).o105 = function (id, $completion) {
    return this.n105_1.yzi(id, $completion);
  };
  var client_fstech_hadaya_domain_usecase_products_GetStockRemindersUseCase$stable;
  function GetStockRemindersUseCase(repository) {
    this.p105_1 = repository;
  }
  protoOf(GetStockRemindersUseCase).ynu = function () {
    return this.p105_1.dzr();
  };
  var client_fstech_hadaya_domain_usecase_products_ToggleStockReminderUseCase$stable;
  function ToggleStockReminderUseCase(repository) {
    this.q105_1 = repository;
  }
  protoOf(ToggleStockReminderUseCase).vdf = function (productId, $completion) {
    return this.q105_1.bzr(productId, $completion);
  };
  var client_fstech_hadaya_domain_usecase_settings_CheckUpdateUseCase$stable;
  function $invokeCOROUTINE$_0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z105_1 = _this__u8e3s4;
  }
  protoOf($invokeCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.z105_1.b106_1.uzm(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var minVersion = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
            var currentVersion = getPlatform().c106();
            this.a106_1 = compare(currentVersion, minVersion) < 0;
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              var tmp_1 = this;
              var tmp1_elvis_lhs = e.message;
              showToast(tmp1_elvis_lhs == null ? 'Error checking for updates' : tmp1_elvis_lhs);
              tmp_1.a106_1 = false;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.a106_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 3) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function CheckUpdateUseCase(repository) {
    this.b106_1 = repository;
  }
  protoOf(CheckUpdateUseCase).d106 = function ($completion) {
    var tmp = new $invokeCOROUTINE$_0(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  var client_fstech_hadaya_domain_usecase_settings_GetShippingCostUseCase$stable;
  function GetShippingCostUseCase(repository) {
    this.e106_1 = repository;
  }
  protoOf(GetShippingCostUseCase).f106 = function (governorateName, $completion) {
    return this.e106_1.tzm(governorateName, $completion);
  };
  var client_fstech_hadaya_domain_usecase_storage_DownloadDesignImageUseCase$stable;
  function DownloadDesignImageUseCase(repository) {
    this.g106_1 = repository;
  }
  protoOf(DownloadDesignImageUseCase).h106 = function (url, $completion) {
    return this.g106_1.czt(url, $completion);
  };
  var client_fstech_hadaya_domain_usecase_storage_UploadDesignImageUseCase$stable;
  function UploadDesignImageUseCase(repository) {
    this.j105_1 = repository;
  }
  protoOf(UploadDesignImageUseCase).k105 = function (bytes, path, $completion) {
    return this.j105_1.bzt(bytes, path, $completion);
  };
  var client_fstech_hadaya_presentation_AppViewModel$stable;
  function checkUpdate($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, AppViewModel$checkUpdate$slambda_0($this, null));
  }
  function AppViewModel$checkUpdate$slambda(this$0, resultContinuation) {
    this.q106_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AppViewModel$checkUpdate$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AppViewModel$checkUpdate$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AppViewModel$checkUpdate$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.s106_1 = this.q106_1.gyj_1;
            this.n9_1 = 1;
            suspendResult = this.q106_1.byj_1.d106(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.s106_1.s21(ARGUMENT);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AppViewModel$checkUpdate$slambda).q24 = function ($this$launch, completion) {
    var i = new AppViewModel$checkUpdate$slambda(this.q106_1, completion);
    i.r106_1 = $this$launch;
    return i;
  };
  function AppViewModel$checkUpdate$slambda_0(this$0, resultContinuation) {
    var i = new AppViewModel$checkUpdate$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AppViewModel$handleDeepLink$slambda(this$0, $productId, resultContinuation) {
    this.b107_1 = this$0;
    this.c107_1 = $productId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AppViewModel$handleDeepLink$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AppViewModel$handleDeepLink$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AppViewModel$handleDeepLink$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            suspendResult = this.b107_1.yyi_1.o105(this.c107_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var product = suspendResult;
            if (!(product == null)) {
              this.n9_1 = 3;
              suspendResult = this.b107_1.kyj_1.a1v(product, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = this.b107_1.oyj_1.a1v('Product not found', this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AppViewModel$handleDeepLink$slambda).q24 = function ($this$launch, completion) {
    var i = new AppViewModel$handleDeepLink$slambda(this.b107_1, this.c107_1, completion);
    i.d107_1 = $this$launch;
    return i;
  };
  function AppViewModel$handleDeepLink$slambda_0(this$0, $productId, resultContinuation) {
    var i = new AppViewModel$handleDeepLink$slambda(this$0, $productId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AppViewModel$handleOrderDeepLink$slambda(this$0, $orderId, resultContinuation) {
    this.m107_1 = this$0;
    this.n107_1 = $orderId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AppViewModel$handleOrderDeepLink$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AppViewModel$handleOrderDeepLink$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AppViewModel$handleOrderDeepLink$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            suspendResult = this.m107_1.dyj_1.d104(this.n107_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var order = suspendResult;
            if (!(order == null)) {
              this.n9_1 = 3;
              suspendResult = this.m107_1.myj_1.a1v(order, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = this.m107_1.oyj_1.a1v('Order not found', this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AppViewModel$handleOrderDeepLink$slambda).q24 = function ($this$launch, completion) {
    var i = new AppViewModel$handleOrderDeepLink$slambda(this.m107_1, this.n107_1, completion);
    i.o107_1 = $this$launch;
    return i;
  };
  function AppViewModel$handleOrderDeepLink$slambda_0(this$0, $orderId, resultContinuation) {
    var i = new AppViewModel$handleOrderDeepLink$slambda(this$0, $orderId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AppViewModel$navigateToAuth$slambda(this$0, $recoveryUrl, resultContinuation) {
    this.x107_1 = this$0;
    this.y107_1 = $recoveryUrl;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AppViewModel$navigateToAuth$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AppViewModel$navigateToAuth$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AppViewModel$navigateToAuth$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.x107_1.qyj_1.a1v(this.y107_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AppViewModel$navigateToAuth$slambda).q24 = function ($this$launch, completion) {
    var i = new AppViewModel$navigateToAuth$slambda(this.x107_1, this.y107_1, completion);
    i.z107_1 = $this$launch;
    return i;
  };
  function AppViewModel$navigateToAuth$slambda_0(this$0, $recoveryUrl, resultContinuation) {
    var i = new AppViewModel$navigateToAuth$slambda(this$0, $recoveryUrl, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AppViewModel$syncData$slambda(this$0, $fcmToken, resultContinuation) {
    this.i108_1 = this$0;
    this.j108_1 = $fcmToken;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AppViewModel$syncData$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AppViewModel$syncData$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AppViewModel$syncData$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var user = this.i108_1.eyj_1.u1();
            if (!(user == null)) {
              this.n9_1 = 1;
              suspendResult = this.i108_1.wyi_1.r2b(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 1:
            if (!(this.j108_1 == null)) {
              this.n9_1 = 2;
              suspendResult = this.i108_1.xyi_1.x102(this.j108_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AppViewModel$syncData$slambda).q24 = function ($this$launch, completion) {
    var i = new AppViewModel$syncData$slambda(this.i108_1, this.j108_1, completion);
    i.k108_1 = $this$launch;
    return i;
  };
  function AppViewModel$syncData$slambda_0(this$0, $fcmToken, resultContinuation) {
    var i = new AppViewModel$syncData$slambda(this$0, $fcmToken, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AppViewModel(getCurrentUserUseCase, syncCartUseCase, updateFcmTokenUseCase, getProductByIdUseCase, getLanguageUseCase, getCurrentUserValueUseCase, checkUpdateUseCase, getCartItemsUseCase, getOrderByIdUseCase) {
    ViewModel_init_$Init$(this);
    this.wyi_1 = syncCartUseCase;
    this.xyi_1 = updateFcmTokenUseCase;
    this.yyi_1 = getProductByIdUseCase;
    this.zyi_1 = getLanguageUseCase;
    this.ayj_1 = getCurrentUserValueUseCase;
    this.byj_1 = checkUpdateUseCase;
    this.cyj_1 = getCartItemsUseCase;
    this.dyj_1 = getOrderByIdUseCase;
    this.eyj_1 = getCurrentUserUseCase.ynu();
    this.fyj_1 = this.zyi_1.y103();
    this.gyj_1 = MutableStateFlow(false);
    this.hyj_1 = asStateFlow(this.gyj_1);
    this.iyj_1 = MutableStateFlow(false);
    this.jyj_1 = asStateFlow(this.iyj_1);
    checkUpdate(this);
    this.kyj_1 = MutableSharedFlow(1);
    this.lyj_1 = asSharedFlow(this.kyj_1);
    this.myj_1 = MutableSharedFlow(1);
    this.nyj_1 = asSharedFlow(this.myj_1);
    this.oyj_1 = MutableSharedFlow(1);
    this.pyj_1 = asSharedFlow(this.oyj_1);
    this.qyj_1 = MutableSharedFlow();
    this.ryj_1 = asSharedFlow(this.qyj_1);
  }
  protoOf(AppViewModel).l108 = function (hasChanges) {
    this.iyj_1.s21(hasChanges);
  };
  protoOf(AppViewModel).qyk = function (productId) {
    var tmp = get_viewModelScope(this);
    launch(tmp, VOID, VOID, AppViewModel$handleDeepLink$slambda_0(this, productId, null));
  };
  protoOf(AppViewModel).cyl = function (orderId) {
    var tmp = get_viewModelScope(this);
    launch(tmp, VOID, VOID, AppViewModel$handleOrderDeepLink$slambda_0(this, orderId, null));
  };
  protoOf(AppViewModel).m108 = function () {
    this.kyj_1.m1z();
    this.myj_1.m1z();
    this.oyj_1.m1z();
  };
  protoOf(AppViewModel).n108 = function (recoveryUrl) {
    var tmp = get_viewModelScope(this);
    launch(tmp, VOID, VOID, AppViewModel$navigateToAuth$slambda_0(this, recoveryUrl, null));
  };
  protoOf(AppViewModel).eyk = function (fcmToken) {
    var tmp = get_viewModelScope(this);
    launch(tmp, VOID, VOID, AppViewModel$syncData$slambda_0(this, fcmToken, null));
  };
  var ScreenStateSaver;
  function get_ScreenListSaver() {
    _init_properties_HomeNavHost_kt__sz1o0q();
    return ScreenListSaver;
  }
  var ScreenListSaver;
  var client_fstech_hadaya_presentation_Screen_Shopping$stable;
  var client_fstech_hadaya_presentation_Screen_Profile$stable;
  var client_fstech_hadaya_presentation_Screen_Cart$stable;
  var client_fstech_hadaya_presentation_Screen_ProductDetails_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_ProductDetails$stable;
  var client_fstech_hadaya_presentation_Screen_BeadsProductDetails_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_BeadsProductDetails$stable;
  var client_fstech_hadaya_presentation_Screen_CustomMugDetails_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_CustomMugDetails$stable;
  var client_fstech_hadaya_presentation_Screen_CustomMagicMugDetails_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_CustomMagicMugDetails$stable;
  var client_fstech_hadaya_presentation_Screen_Checkout$stable;
  var client_fstech_hadaya_presentation_Screen_Friends$stable;
  var client_fstech_hadaya_presentation_Screen_Favorites$stable;
  var client_fstech_hadaya_presentation_Screen_Coupons$stable;
  var client_fstech_hadaya_presentation_Screen_StockReminders$stable;
  var client_fstech_hadaya_presentation_Screen_Update$stable;
  var client_fstech_hadaya_presentation_Screen_CustomMug$stable;
  var client_fstech_hadaya_presentation_Screen_Auth_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_Auth$stable;
  var client_fstech_hadaya_presentation_Screen_Error_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_Error$stable;
  var client_fstech_hadaya_presentation_Screen_Model3D_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_Model3D$stable;
  var client_fstech_hadaya_presentation_Screen_EditDesign_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_EditDesign$stable;
  var client_fstech_hadaya_presentation_Screen_EditCustomMagicMug_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_EditCustomMagicMug$stable;
  var client_fstech_hadaya_presentation_Screen_CartNormalProductDetails_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_CartNormalProductDetails$stable;
  var client_fstech_hadaya_presentation_Screen_CartMugProductDetails_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_CartMugProductDetails$stable;
  var client_fstech_hadaya_presentation_Screen_CartMagicMugProductDetails_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_CartMagicMugProductDetails$stable;
  var client_fstech_hadaya_presentation_Screen_MugDesignerEditor_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_MugDesignerEditor$stable;
  var client_fstech_hadaya_presentation_Screen_OrderDetails_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_OrderDetails$stable;
  var client_fstech_hadaya_presentation_Screen_PastOrderDetails_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_PastOrderDetails$stable;
  var client_fstech_hadaya_presentation_Screen_OrderHistory$stable;
  var client_fstech_hadaya_presentation_Screen_AccountManagement$stable;
  var client_fstech_hadaya_presentation_Screen_DeleteAccountStandalone_$serializer$stable;
  var client_fstech_hadaya_presentation_Screen_DeleteAccountStandalone$stable;
  var client_fstech_hadaya_presentation_Screen_DeleteAccountSuccess$stable;
  var client_fstech_hadaya_presentation_Screen_ResetPasswordSuccess$stable;
  function _get_$cachedSerializer__te6jhj_4($this) {
    return $this.o108_1.u1();
  }
  function Screen$Shopping$_anonymous__15bgrt() {
    var tmp = Shopping_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Shopping', tmp, tmp$ret$0);
  }
  function _get_$cachedSerializer__te6jhj_5($this) {
    return $this.p108_1.u1();
  }
  function Screen$Profile$_anonymous__1nbpbu() {
    var tmp = Profile_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Profile', tmp, tmp$ret$0);
  }
  function _get_$cachedSerializer__te6jhj_6($this) {
    return $this.q108_1.u1();
  }
  function Screen$Cart$_anonymous__rg9axr() {
    var tmp = Cart_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Cart', tmp, tmp$ret$0);
  }
  function Screen$ProductDetails$Companion$$childSerializers$_anonymous__24lutd() {
    return new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_12());
  }
  function Companion_21() {
    Companion_instance_27 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r108_1 = [null, null, null, lazy_0(tmp_0, Screen$ProductDetails$Companion$$childSerializers$_anonymous__24lutd), null, null, null, null, null, null, null];
  }
  var Companion_instance_27;
  function Companion_getInstance_56() {
    if (Companion_instance_27 == null)
      new Companion_21();
    return Companion_instance_27;
  }
  function $serializer_16() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.ProductDetails', this, 11);
    tmp0_serialDesc.a7c('product', false);
    tmp0_serialDesc.a7c('initialSize', true);
    tmp0_serialDesc.a7c('initialColor', true);
    tmp0_serialDesc.a7c('initialOptions', true);
    tmp0_serialDesc.a7c('initialComment', true);
    tmp0_serialDesc.a7c('initialCard', true);
    tmp0_serialDesc.a7c('initialBox', true);
    tmp0_serialDesc.a7c('initialCardMessage', true);
    tmp0_serialDesc.a7c('initialCardBirthday', true);
    tmp0_serialDesc.a7c('initialBoxMessage', true);
    tmp0_serialDesc.a7c('initialBoxBirthday', true);
    this.s108_1 = tmp0_serialDesc;
  }
  protoOf($serializer_16).t108 = function (encoder, value) {
    var tmp0_desc = this.s108_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_56().r108_1;
    tmp1_output.e76(tmp0_desc, 0, $serializer_getInstance_11(), value.u108_1);
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.v108_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.v108_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.w108_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.w108_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.x108_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, tmp2_cached[3].u1(), value.x108_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.y108_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.y108_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.z108_1 == null)) {
      tmp1_output.g76(tmp0_desc, 5, $serializer_getInstance_3(), value.z108_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.a109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 6, $serializer_getInstance_2(), value.a109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.b109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 7, StringSerializer_getInstance(), value.b109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !(value.c109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 8, StringSerializer_getInstance(), value.c109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !(value.d109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 9, StringSerializer_getInstance(), value.d109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.e109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 10, StringSerializer_getInstance(), value.e109_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_16).z70 = function (encoder, value) {
    return this.t108(encoder, value instanceof ProductDetails ? value : THROW_CCE());
  };
  protoOf($serializer_16).a71 = function (decoder) {
    var tmp0_desc = this.s108_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_input = decoder.n74(tmp0_desc);
    var tmp16_cached = Companion_getInstance_56().r108_1;
    if (tmp15_input.d75()) {
      tmp4_local0 = tmp15_input.z74(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.b75(tmp0_desc, 3, tmp16_cached[3].u1(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.b75(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.b75(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.z74(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.b75(tmp0_desc, 3, tmp16_cached[3].u1(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.b75(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.b75(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.o74(tmp0_desc);
    return ProductDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_16).y70 = function () {
    return this.s108_1;
  };
  protoOf($serializer_16).t7c = function () {
    var tmp0_cached = Companion_getInstance_56().r108_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_11(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3].u1()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_3()), get_nullable($serializer_getInstance_2()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_16;
  function $serializer_getInstance_16() {
    if ($serializer_instance_16 == null)
      new $serializer_16();
    return $serializer_instance_16;
  }
  function ProductDetails_init_$Init$(seen0, product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_16().s108_1);
    }
    $this.u108_1 = product;
    if (0 === (seen0 & 2))
      $this.v108_1 = null;
    else
      $this.v108_1 = initialSize;
    if (0 === (seen0 & 4))
      $this.w108_1 = null;
    else
      $this.w108_1 = initialColor;
    if (0 === (seen0 & 8))
      $this.x108_1 = null;
    else
      $this.x108_1 = initialOptions;
    if (0 === (seen0 & 16))
      $this.y108_1 = null;
    else
      $this.y108_1 = initialComment;
    if (0 === (seen0 & 32))
      $this.z108_1 = null;
    else
      $this.z108_1 = initialCard;
    if (0 === (seen0 & 64))
      $this.a109_1 = null;
    else
      $this.a109_1 = initialBox;
    if (0 === (seen0 & 128))
      $this.b109_1 = null;
    else
      $this.b109_1 = initialCardMessage;
    if (0 === (seen0 & 256))
      $this.c109_1 = null;
    else
      $this.c109_1 = initialCardBirthday;
    if (0 === (seen0 & 512))
      $this.d109_1 = null;
    else
      $this.d109_1 = initialBoxMessage;
    if (0 === (seen0 & 1024))
      $this.e109_1 = null;
    else
      $this.e109_1 = initialBoxBirthday;
    return $this;
  }
  function ProductDetails_init_$Create$(seen0, product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, serializationConstructorMarker) {
    return ProductDetails_init_$Init$(seen0, product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, serializationConstructorMarker, objectCreate(protoOf(ProductDetails)));
  }
  function Screen$BeadsProductDetails$Companion$$childSerializers$_anonymous__vr5hdu() {
    return new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_12());
  }
  function Companion_22() {
    Companion_instance_28 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f109_1 = [null, null, null, lazy_0(tmp_0, Screen$BeadsProductDetails$Companion$$childSerializers$_anonymous__vr5hdu), null, null, null, null, null, null, null, null];
  }
  var Companion_instance_28;
  function Companion_getInstance_57() {
    if (Companion_instance_28 == null)
      new Companion_22();
    return Companion_instance_28;
  }
  function $serializer_17() {
    $serializer_instance_17 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.BeadsProductDetails', this, 12);
    tmp0_serialDesc.a7c('product', false);
    tmp0_serialDesc.a7c('initialSize', true);
    tmp0_serialDesc.a7c('initialColor', true);
    tmp0_serialDesc.a7c('initialOptions', true);
    tmp0_serialDesc.a7c('initialComment', true);
    tmp0_serialDesc.a7c('initialCard', true);
    tmp0_serialDesc.a7c('initialBox', true);
    tmp0_serialDesc.a7c('initialCardMessage', true);
    tmp0_serialDesc.a7c('initialCardBirthday', true);
    tmp0_serialDesc.a7c('initialBoxMessage', true);
    tmp0_serialDesc.a7c('initialBoxBirthday', true);
    tmp0_serialDesc.a7c('initialBraceletName', true);
    this.g109_1 = tmp0_serialDesc;
  }
  protoOf($serializer_17).h109 = function (encoder, value) {
    var tmp0_desc = this.g109_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_57().f109_1;
    tmp1_output.e76(tmp0_desc, 0, $serializer_getInstance_11(), value.i109_1);
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.j109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.j109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.k109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.k109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.l109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, tmp2_cached[3].u1(), value.l109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.m109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.m109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.n109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 5, $serializer_getInstance_3(), value.n109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.o109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 6, $serializer_getInstance_2(), value.o109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.p109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 7, StringSerializer_getInstance(), value.p109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !(value.q109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 8, StringSerializer_getInstance(), value.q109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !(value.r109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 9, StringSerializer_getInstance(), value.r109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.s109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 10, StringSerializer_getInstance(), value.s109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 11) ? true : !(value.t109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 11, StringSerializer_getInstance(), value.t109_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_17).z70 = function (encoder, value) {
    return this.h109(encoder, value instanceof BeadsProductDetails ? value : THROW_CCE());
  };
  protoOf($serializer_17).a71 = function (decoder) {
    var tmp0_desc = this.g109_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_input = decoder.n74(tmp0_desc);
    var tmp17_cached = Companion_getInstance_57().f109_1;
    if (tmp16_input.d75()) {
      tmp4_local0 = tmp16_input.z74(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp16_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp16_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp16_input.b75(tmp0_desc, 3, tmp17_cached[3].u1(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp16_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp16_input.b75(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp16_input.b75(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp16_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp16_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp16_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp16_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp16_input.b75(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp16_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp16_input.z74(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp16_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp16_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp16_input.b75(tmp0_desc, 3, tmp17_cached[3].u1(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp16_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp16_input.b75(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp16_input.b75(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp16_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp16_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp16_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp16_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp16_input.b75(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp16_input.o74(tmp0_desc);
    return BeadsProductDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
  };
  protoOf($serializer_17).y70 = function () {
    return this.g109_1;
  };
  protoOf($serializer_17).t7c = function () {
    var tmp0_cached = Companion_getInstance_57().f109_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_11(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3].u1()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_3()), get_nullable($serializer_getInstance_2()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_17;
  function $serializer_getInstance_17() {
    if ($serializer_instance_17 == null)
      new $serializer_17();
    return $serializer_instance_17;
  }
  function BeadsProductDetails_init_$Init$(seen0, product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, initialBraceletName, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_17().g109_1);
    }
    $this.i109_1 = product;
    if (0 === (seen0 & 2))
      $this.j109_1 = null;
    else
      $this.j109_1 = initialSize;
    if (0 === (seen0 & 4))
      $this.k109_1 = null;
    else
      $this.k109_1 = initialColor;
    if (0 === (seen0 & 8))
      $this.l109_1 = null;
    else
      $this.l109_1 = initialOptions;
    if (0 === (seen0 & 16))
      $this.m109_1 = null;
    else
      $this.m109_1 = initialComment;
    if (0 === (seen0 & 32))
      $this.n109_1 = null;
    else
      $this.n109_1 = initialCard;
    if (0 === (seen0 & 64))
      $this.o109_1 = null;
    else
      $this.o109_1 = initialBox;
    if (0 === (seen0 & 128))
      $this.p109_1 = null;
    else
      $this.p109_1 = initialCardMessage;
    if (0 === (seen0 & 256))
      $this.q109_1 = null;
    else
      $this.q109_1 = initialCardBirthday;
    if (0 === (seen0 & 512))
      $this.r109_1 = null;
    else
      $this.r109_1 = initialBoxMessage;
    if (0 === (seen0 & 1024))
      $this.s109_1 = null;
    else
      $this.s109_1 = initialBoxBirthday;
    if (0 === (seen0 & 2048))
      $this.t109_1 = null;
    else
      $this.t109_1 = initialBraceletName;
    return $this;
  }
  function BeadsProductDetails_init_$Create$(seen0, product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, initialBraceletName, serializationConstructorMarker) {
    return BeadsProductDetails_init_$Init$(seen0, product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, initialBraceletName, serializationConstructorMarker, objectCreate(protoOf(BeadsProductDetails)));
  }
  function Screen$CustomMugDetails$Companion$$childSerializers$_anonymous__kmd4ji() {
    return new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_12());
  }
  function Companion_23() {
    Companion_instance_29 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u109_1 = [null, null, null, lazy_0(tmp_0, Screen$CustomMugDetails$Companion$$childSerializers$_anonymous__kmd4ji), null, null, null, null, null, null, null];
  }
  var Companion_instance_29;
  function Companion_getInstance_58() {
    if (Companion_instance_29 == null)
      new Companion_23();
    return Companion_instance_29;
  }
  function $serializer_18() {
    $serializer_instance_18 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.CustomMugDetails', this, 11);
    tmp0_serialDesc.a7c('product', false);
    tmp0_serialDesc.a7c('initialSize', true);
    tmp0_serialDesc.a7c('initialColor', true);
    tmp0_serialDesc.a7c('initialOptions', true);
    tmp0_serialDesc.a7c('initialComment', true);
    tmp0_serialDesc.a7c('initialCard', true);
    tmp0_serialDesc.a7c('initialBox', true);
    tmp0_serialDesc.a7c('initialCardMessage', true);
    tmp0_serialDesc.a7c('initialCardBirthday', true);
    tmp0_serialDesc.a7c('initialBoxMessage', true);
    tmp0_serialDesc.a7c('initialBoxBirthday', true);
    this.v109_1 = tmp0_serialDesc;
  }
  protoOf($serializer_18).w109 = function (encoder, value) {
    var tmp0_desc = this.v109_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_58().u109_1;
    tmp1_output.e76(tmp0_desc, 0, $serializer_getInstance_11(), value.x109_1);
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.y109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.y109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.z109_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.z109_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.a10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, tmp2_cached[3].u1(), value.a10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.b10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.b10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.c10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 5, $serializer_getInstance_3(), value.c10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.d10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 6, $serializer_getInstance_2(), value.d10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.e10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 7, StringSerializer_getInstance(), value.e10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !(value.f10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 8, StringSerializer_getInstance(), value.f10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !(value.g10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 9, StringSerializer_getInstance(), value.g10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.h10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 10, StringSerializer_getInstance(), value.h10a_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_18).z70 = function (encoder, value) {
    return this.w109(encoder, value instanceof CustomMugDetails ? value : THROW_CCE());
  };
  protoOf($serializer_18).a71 = function (decoder) {
    var tmp0_desc = this.v109_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_input = decoder.n74(tmp0_desc);
    var tmp16_cached = Companion_getInstance_58().u109_1;
    if (tmp15_input.d75()) {
      tmp4_local0 = tmp15_input.z74(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.b75(tmp0_desc, 3, tmp16_cached[3].u1(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.b75(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.b75(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.z74(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.b75(tmp0_desc, 3, tmp16_cached[3].u1(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.b75(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.b75(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.o74(tmp0_desc);
    return CustomMugDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_18).y70 = function () {
    return this.v109_1;
  };
  protoOf($serializer_18).t7c = function () {
    var tmp0_cached = Companion_getInstance_58().u109_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_11(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3].u1()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_3()), get_nullable($serializer_getInstance_2()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_18;
  function $serializer_getInstance_18() {
    if ($serializer_instance_18 == null)
      new $serializer_18();
    return $serializer_instance_18;
  }
  function CustomMugDetails_init_$Init$(seen0, product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_18().v109_1);
    }
    $this.x109_1 = product;
    if (0 === (seen0 & 2))
      $this.y109_1 = null;
    else
      $this.y109_1 = initialSize;
    if (0 === (seen0 & 4))
      $this.z109_1 = null;
    else
      $this.z109_1 = initialColor;
    if (0 === (seen0 & 8))
      $this.a10a_1 = null;
    else
      $this.a10a_1 = initialOptions;
    if (0 === (seen0 & 16))
      $this.b10a_1 = null;
    else
      $this.b10a_1 = initialComment;
    if (0 === (seen0 & 32))
      $this.c10a_1 = null;
    else
      $this.c10a_1 = initialCard;
    if (0 === (seen0 & 64))
      $this.d10a_1 = null;
    else
      $this.d10a_1 = initialBox;
    if (0 === (seen0 & 128))
      $this.e10a_1 = null;
    else
      $this.e10a_1 = initialCardMessage;
    if (0 === (seen0 & 256))
      $this.f10a_1 = null;
    else
      $this.f10a_1 = initialCardBirthday;
    if (0 === (seen0 & 512))
      $this.g10a_1 = null;
    else
      $this.g10a_1 = initialBoxMessage;
    if (0 === (seen0 & 1024))
      $this.h10a_1 = null;
    else
      $this.h10a_1 = initialBoxBirthday;
    return $this;
  }
  function CustomMugDetails_init_$Create$(seen0, product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, serializationConstructorMarker) {
    return CustomMugDetails_init_$Init$(seen0, product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, serializationConstructorMarker, objectCreate(protoOf(CustomMugDetails)));
  }
  function Screen$CustomMagicMugDetails$Companion$$childSerializers$_anonymous__ca4g83() {
    return new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_12());
  }
  function Companion_24() {
    Companion_instance_30 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i10a_1 = [null, null, null, lazy_0(tmp_0, Screen$CustomMagicMugDetails$Companion$$childSerializers$_anonymous__ca4g83), null, null, null, null, null, null, null];
  }
  var Companion_instance_30;
  function Companion_getInstance_59() {
    if (Companion_instance_30 == null)
      new Companion_24();
    return Companion_instance_30;
  }
  function $serializer_19() {
    $serializer_instance_19 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.CustomMagicMugDetails', this, 11);
    tmp0_serialDesc.a7c('product', false);
    tmp0_serialDesc.a7c('initialSize', true);
    tmp0_serialDesc.a7c('initialColor', true);
    tmp0_serialDesc.a7c('initialOptions', true);
    tmp0_serialDesc.a7c('initialComment', true);
    tmp0_serialDesc.a7c('initialCard', true);
    tmp0_serialDesc.a7c('initialBox', true);
    tmp0_serialDesc.a7c('initialCardMessage', true);
    tmp0_serialDesc.a7c('initialCardBirthday', true);
    tmp0_serialDesc.a7c('initialBoxMessage', true);
    tmp0_serialDesc.a7c('initialBoxBirthday', true);
    this.j10a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_19).k10a = function (encoder, value) {
    var tmp0_desc = this.j10a_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_59().i10a_1;
    tmp1_output.e76(tmp0_desc, 0, $serializer_getInstance_11(), value.l10a_1);
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.m10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.m10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.n10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.n10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.o10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, tmp2_cached[3].u1(), value.o10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.p10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.p10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.q10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 5, $serializer_getInstance_3(), value.q10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.r10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 6, $serializer_getInstance_2(), value.r10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.s10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 7, StringSerializer_getInstance(), value.s10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 8) ? true : !(value.t10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 8, StringSerializer_getInstance(), value.t10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !(value.u10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 9, StringSerializer_getInstance(), value.u10a_1);
    }
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.v10a_1 == null)) {
      tmp1_output.g76(tmp0_desc, 10, StringSerializer_getInstance(), value.v10a_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_19).z70 = function (encoder, value) {
    return this.k10a(encoder, value instanceof CustomMagicMugDetails ? value : THROW_CCE());
  };
  protoOf($serializer_19).a71 = function (decoder) {
    var tmp0_desc = this.j10a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_input = decoder.n74(tmp0_desc);
    var tmp16_cached = Companion_getInstance_59().i10a_1;
    if (tmp15_input.d75()) {
      tmp4_local0 = tmp15_input.z74(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.b75(tmp0_desc, 3, tmp16_cached[3].u1(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.b75(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.b75(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.z74(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.b75(tmp0_desc, 3, tmp16_cached[3].u1(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.b75(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.b75(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.b75(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.b75(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.b75(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.b75(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.o74(tmp0_desc);
    return CustomMagicMugDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_19).y70 = function () {
    return this.j10a_1;
  };
  protoOf($serializer_19).t7c = function () {
    var tmp0_cached = Companion_getInstance_59().i10a_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_11(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3].u1()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_3()), get_nullable($serializer_getInstance_2()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_19;
  function $serializer_getInstance_19() {
    if ($serializer_instance_19 == null)
      new $serializer_19();
    return $serializer_instance_19;
  }
  function CustomMagicMugDetails_init_$Init$(seen0, product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_19().j10a_1);
    }
    $this.l10a_1 = product;
    if (0 === (seen0 & 2))
      $this.m10a_1 = null;
    else
      $this.m10a_1 = initialSize;
    if (0 === (seen0 & 4))
      $this.n10a_1 = null;
    else
      $this.n10a_1 = initialColor;
    if (0 === (seen0 & 8))
      $this.o10a_1 = null;
    else
      $this.o10a_1 = initialOptions;
    if (0 === (seen0 & 16))
      $this.p10a_1 = null;
    else
      $this.p10a_1 = initialComment;
    if (0 === (seen0 & 32))
      $this.q10a_1 = null;
    else
      $this.q10a_1 = initialCard;
    if (0 === (seen0 & 64))
      $this.r10a_1 = null;
    else
      $this.r10a_1 = initialBox;
    if (0 === (seen0 & 128))
      $this.s10a_1 = null;
    else
      $this.s10a_1 = initialCardMessage;
    if (0 === (seen0 & 256))
      $this.t10a_1 = null;
    else
      $this.t10a_1 = initialCardBirthday;
    if (0 === (seen0 & 512))
      $this.u10a_1 = null;
    else
      $this.u10a_1 = initialBoxMessage;
    if (0 === (seen0 & 1024))
      $this.v10a_1 = null;
    else
      $this.v10a_1 = initialBoxBirthday;
    return $this;
  }
  function CustomMagicMugDetails_init_$Create$(seen0, product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, serializationConstructorMarker) {
    return CustomMagicMugDetails_init_$Init$(seen0, product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, serializationConstructorMarker, objectCreate(protoOf(CustomMagicMugDetails)));
  }
  function _get_$cachedSerializer__te6jhj_7($this) {
    return $this.w10a_1.u1();
  }
  function Screen$Checkout$_anonymous__hk75a1() {
    var tmp = Checkout_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Checkout', tmp, tmp$ret$0);
  }
  function _get_$cachedSerializer__te6jhj_8($this) {
    return $this.x10a_1.u1();
  }
  function Screen$Friends$_anonymous__2zcoii() {
    var tmp = Friends_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Friends', tmp, tmp$ret$0);
  }
  function _get_$cachedSerializer__te6jhj_9($this) {
    return $this.y10a_1.u1();
  }
  function Screen$Favorites$_anonymous__3wgwuw() {
    var tmp = Favorites_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Favorites', tmp, tmp$ret$0);
  }
  function _get_$cachedSerializer__te6jhj_10($this) {
    return $this.z10a_1.u1();
  }
  function Screen$Coupons$_anonymous__7oppr6() {
    var tmp = Coupons_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Coupons', tmp, tmp$ret$0);
  }
  function _get_$cachedSerializer__te6jhj_11($this) {
    return $this.a10b_1.u1();
  }
  function Screen$StockReminders$_anonymous__1h9nqs() {
    var tmp = StockReminders_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.StockReminders', tmp, tmp$ret$0);
  }
  function _get_$cachedSerializer__te6jhj_12($this) {
    return $this.b10b_1.u1();
  }
  function Screen$Update$_anonymous__9otj06() {
    var tmp = Update_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Update', tmp, tmp$ret$0);
  }
  function _get_$cachedSerializer__te6jhj_13($this) {
    return $this.c10b_1.u1();
  }
  function Screen$CustomMug$_anonymous__alsodb() {
    var tmp = CustomMug_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.CustomMug', tmp, tmp$ret$0);
  }
  function Companion_25() {
  }
  var Companion_instance_31;
  function Companion_getInstance_60() {
    return Companion_instance_31;
  }
  function $serializer_20() {
    $serializer_instance_20 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.Auth', this, 2);
    tmp0_serialDesc.a7c('page', true);
    tmp0_serialDesc.a7c('recoveryUrl', true);
    this.d10b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_20).e10b = function (encoder, value) {
    var tmp0_desc = this.d10b_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.f10b_1 === 'login')) {
      tmp1_output.c76(tmp0_desc, 0, value.f10b_1);
    }
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.g10b_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.g10b_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_20).z70 = function (encoder, value) {
    return this.e10b(encoder, value instanceof Auth_0 ? value : THROW_CCE());
  };
  protoOf($serializer_20).a71 = function (decoder) {
    var tmp0_desc = this.d10b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.n74(tmp0_desc);
    if (tmp6_input.d75()) {
      tmp4_local0 = tmp6_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.o74(tmp0_desc);
    return Auth_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_20).y70 = function () {
    return this.d10b_1;
  };
  protoOf($serializer_20).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_20;
  function $serializer_getInstance_20() {
    if ($serializer_instance_20 == null)
      new $serializer_20();
    return $serializer_instance_20;
  }
  function Auth_init_$Init$(seen0, page, recoveryUrl, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_20().d10b_1);
    }
    if (0 === (seen0 & 1))
      $this.f10b_1 = 'login';
    else
      $this.f10b_1 = page;
    if (0 === (seen0 & 2))
      $this.g10b_1 = null;
    else
      $this.g10b_1 = recoveryUrl;
    return $this;
  }
  function Auth_init_$Create$(seen0, page, recoveryUrl, serializationConstructorMarker) {
    return Auth_init_$Init$(seen0, page, recoveryUrl, serializationConstructorMarker, objectCreate(protoOf(Auth_0)));
  }
  function Companion_26() {
  }
  var Companion_instance_32;
  function Companion_getInstance_61() {
    return Companion_instance_32;
  }
  function $serializer_21() {
    $serializer_instance_21 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.Error', this, 1);
    tmp0_serialDesc.a7c('message', false);
    this.h10b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_21).i10b = function (encoder, value) {
    var tmp0_desc = this.h10b_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.c76(tmp0_desc, 0, value.j10b_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_21).z70 = function (encoder, value) {
    return this.i10b(encoder, value instanceof Error_0 ? value : THROW_CCE());
  };
  protoOf($serializer_21).a71 = function (decoder) {
    var tmp0_desc = this.h10b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.n74(tmp0_desc);
    if (tmp5_input.d75()) {
      tmp4_local0 = tmp5_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.o74(tmp0_desc);
    return Error_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_21).y70 = function () {
    return this.h10b_1;
  };
  protoOf($serializer_21).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_21;
  function $serializer_getInstance_21() {
    if ($serializer_instance_21 == null)
      new $serializer_21();
    return $serializer_instance_21;
  }
  function Error_init_$Init$(seen0, message, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_21().h10b_1);
    }
    $this.j10b_1 = message;
    return $this;
  }
  function Error_init_$Create$(seen0, message, serializationConstructorMarker) {
    return Error_init_$Init$(seen0, message, serializationConstructorMarker, objectCreate(protoOf(Error_0)));
  }
  function Screen$Model3D$Companion$$childSerializers$_anonymous__mxk4rs() {
    return new ArrayListSerializer(ByteSerializer_getInstance());
  }
  function Screen$Model3D$Companion$$childSerializers$_anonymous__mxk4rs_0() {
    return new ArrayListSerializer($serializer_getInstance_4());
  }
  function Companion_27() {
    Companion_instance_33 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy_0(tmp_0, Screen$Model3D$Companion$$childSerializers$_anonymous__mxk4rs);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k10b_1 = [null, null, tmp_1, lazy_0(tmp_2, Screen$Model3D$Companion$$childSerializers$_anonymous__mxk4rs_0), null];
  }
  var Companion_instance_33;
  function Companion_getInstance_62() {
    if (Companion_instance_33 == null)
      new Companion_27();
    return Companion_instance_33;
  }
  function $serializer_22() {
    $serializer_instance_22 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.Model3D', this, 5);
    tmp0_serialDesc.a7c('productId', false);
    tmp0_serialDesc.a7c('product', true);
    tmp0_serialDesc.a7c('initialImageBytes', true);
    tmp0_serialDesc.a7c('designLayers', true);
    tmp0_serialDesc.a7c('customImageUrl', true);
    this.l10b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_22).m10b = function (encoder, value) {
    var tmp0_desc = this.l10b_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_62().k10b_1;
    tmp1_output.y75(tmp0_desc, 0, value.n10b_1);
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.o10b_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, $serializer_getInstance_11(), value.o10b_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.p10b_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, tmp2_cached[2].u1(), value.p10b_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.q10b_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, tmp2_cached[3].u1(), value.q10b_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.r10b_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.r10b_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_22).z70 = function (encoder, value) {
    return this.m10b(encoder, value instanceof Model3D ? value : THROW_CCE());
  };
  protoOf($serializer_22).a71 = function (decoder) {
    var tmp0_desc = this.l10b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.n74(tmp0_desc);
    var tmp10_cached = Companion_getInstance_62().k10b_1;
    if (tmp9_input.d75()) {
      tmp4_local0 = tmp9_input.t74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b75(tmp0_desc, 1, $serializer_getInstance_11(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.b75(tmp0_desc, 2, tmp10_cached[2].u1(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.b75(tmp0_desc, 3, tmp10_cached[3].u1(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.t74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b75(tmp0_desc, 1, $serializer_getInstance_11(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.b75(tmp0_desc, 2, tmp10_cached[2].u1(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.b75(tmp0_desc, 3, tmp10_cached[3].u1(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.o74(tmp0_desc);
    return Model3D_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_22).y70 = function () {
    return this.l10b_1;
  };
  protoOf($serializer_22).t7c = function () {
    var tmp0_cached = Companion_getInstance_62().k10b_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), get_nullable($serializer_getInstance_11()), get_nullable(tmp0_cached[2].u1()), get_nullable(tmp0_cached[3].u1()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_22;
  function $serializer_getInstance_22() {
    if ($serializer_instance_22 == null)
      new $serializer_22();
    return $serializer_instance_22;
  }
  function Model3D_init_$Init$(seen0, productId, product, initialImageBytes, designLayers, customImageUrl, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_22().l10b_1);
    }
    $this.n10b_1 = productId;
    if (0 === (seen0 & 2))
      $this.o10b_1 = null;
    else
      $this.o10b_1 = product;
    if (0 === (seen0 & 4))
      $this.p10b_1 = null;
    else
      $this.p10b_1 = initialImageBytes;
    if (0 === (seen0 & 8))
      $this.q10b_1 = null;
    else
      $this.q10b_1 = designLayers;
    if (0 === (seen0 & 16))
      $this.r10b_1 = null;
    else
      $this.r10b_1 = customImageUrl;
    return $this;
  }
  function Model3D_init_$Create$(seen0, productId, product, initialImageBytes, designLayers, customImageUrl, serializationConstructorMarker) {
    return Model3D_init_$Init$(seen0, productId, product, initialImageBytes, designLayers, customImageUrl, serializationConstructorMarker, objectCreate(protoOf(Model3D)));
  }
  function Companion_28() {
  }
  var Companion_instance_34;
  function Companion_getInstance_63() {
    return Companion_instance_34;
  }
  function $serializer_23() {
    $serializer_instance_23 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.EditDesign', this, 1);
    tmp0_serialDesc.a7c('cartItemId', false);
    this.s10b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_23).t10b = function (encoder, value) {
    var tmp0_desc = this.s10b_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.c76(tmp0_desc, 0, value.u10b_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_23).z70 = function (encoder, value) {
    return this.t10b(encoder, value instanceof EditDesign ? value : THROW_CCE());
  };
  protoOf($serializer_23).a71 = function (decoder) {
    var tmp0_desc = this.s10b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.n74(tmp0_desc);
    if (tmp5_input.d75()) {
      tmp4_local0 = tmp5_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.o74(tmp0_desc);
    return EditDesign_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_23).y70 = function () {
    return this.s10b_1;
  };
  protoOf($serializer_23).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_23;
  function $serializer_getInstance_23() {
    if ($serializer_instance_23 == null)
      new $serializer_23();
    return $serializer_instance_23;
  }
  function EditDesign_init_$Init$(seen0, cartItemId, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_23().s10b_1);
    }
    $this.u10b_1 = cartItemId;
    return $this;
  }
  function EditDesign_init_$Create$(seen0, cartItemId, serializationConstructorMarker) {
    return EditDesign_init_$Init$(seen0, cartItemId, serializationConstructorMarker, objectCreate(protoOf(EditDesign)));
  }
  function Companion_29() {
  }
  var Companion_instance_35;
  function Companion_getInstance_64() {
    return Companion_instance_35;
  }
  function $serializer_24() {
    $serializer_instance_24 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.EditCustomMagicMug', this, 1);
    tmp0_serialDesc.a7c('cartItemId', false);
    this.v10b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_24).w10b = function (encoder, value) {
    var tmp0_desc = this.v10b_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.c76(tmp0_desc, 0, value.x10b_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_24).z70 = function (encoder, value) {
    return this.w10b(encoder, value instanceof EditCustomMagicMug ? value : THROW_CCE());
  };
  protoOf($serializer_24).a71 = function (decoder) {
    var tmp0_desc = this.v10b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.n74(tmp0_desc);
    if (tmp5_input.d75()) {
      tmp4_local0 = tmp5_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.o74(tmp0_desc);
    return EditCustomMagicMug_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_24).y70 = function () {
    return this.v10b_1;
  };
  protoOf($serializer_24).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_24;
  function $serializer_getInstance_24() {
    if ($serializer_instance_24 == null)
      new $serializer_24();
    return $serializer_instance_24;
  }
  function EditCustomMagicMug_init_$Init$(seen0, cartItemId, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_24().v10b_1);
    }
    $this.x10b_1 = cartItemId;
    return $this;
  }
  function EditCustomMagicMug_init_$Create$(seen0, cartItemId, serializationConstructorMarker) {
    return EditCustomMagicMug_init_$Init$(seen0, cartItemId, serializationConstructorMarker, objectCreate(protoOf(EditCustomMagicMug)));
  }
  function Companion_30() {
  }
  var Companion_instance_36;
  function Companion_getInstance_65() {
    return Companion_instance_36;
  }
  function $serializer_25() {
    $serializer_instance_25 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.CartNormalProductDetails', this, 1);
    tmp0_serialDesc.a7c('cartItem', false);
    this.y10b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_25).z10b = function (encoder, value) {
    var tmp0_desc = this.y10b_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.e76(tmp0_desc, 0, $serializer_getInstance_5(), value.a10c_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_25).z70 = function (encoder, value) {
    return this.z10b(encoder, value instanceof CartNormalProductDetails ? value : THROW_CCE());
  };
  protoOf($serializer_25).a71 = function (decoder) {
    var tmp0_desc = this.y10b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.n74(tmp0_desc);
    if (tmp5_input.d75()) {
      tmp4_local0 = tmp5_input.z74(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.z74(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.o74(tmp0_desc);
    return CartNormalProductDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_25).y70 = function () {
    return this.y10b_1;
  };
  protoOf($serializer_25).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_5()];
  };
  var $serializer_instance_25;
  function $serializer_getInstance_25() {
    if ($serializer_instance_25 == null)
      new $serializer_25();
    return $serializer_instance_25;
  }
  function CartNormalProductDetails_init_$Init$(seen0, cartItem, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_25().y10b_1);
    }
    $this.a10c_1 = cartItem;
    return $this;
  }
  function CartNormalProductDetails_init_$Create$(seen0, cartItem, serializationConstructorMarker) {
    return CartNormalProductDetails_init_$Init$(seen0, cartItem, serializationConstructorMarker, objectCreate(protoOf(CartNormalProductDetails)));
  }
  function Companion_31() {
  }
  var Companion_instance_37;
  function Companion_getInstance_66() {
    return Companion_instance_37;
  }
  function $serializer_26() {
    $serializer_instance_26 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.CartMugProductDetails', this, 1);
    tmp0_serialDesc.a7c('cartItem', false);
    this.b10c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_26).c10c = function (encoder, value) {
    var tmp0_desc = this.b10c_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.e76(tmp0_desc, 0, $serializer_getInstance_5(), value.d10c_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_26).z70 = function (encoder, value) {
    return this.c10c(encoder, value instanceof CartMugProductDetails ? value : THROW_CCE());
  };
  protoOf($serializer_26).a71 = function (decoder) {
    var tmp0_desc = this.b10c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.n74(tmp0_desc);
    if (tmp5_input.d75()) {
      tmp4_local0 = tmp5_input.z74(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.z74(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.o74(tmp0_desc);
    return CartMugProductDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_26).y70 = function () {
    return this.b10c_1;
  };
  protoOf($serializer_26).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_5()];
  };
  var $serializer_instance_26;
  function $serializer_getInstance_26() {
    if ($serializer_instance_26 == null)
      new $serializer_26();
    return $serializer_instance_26;
  }
  function CartMugProductDetails_init_$Init$(seen0, cartItem, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_26().b10c_1);
    }
    $this.d10c_1 = cartItem;
    return $this;
  }
  function CartMugProductDetails_init_$Create$(seen0, cartItem, serializationConstructorMarker) {
    return CartMugProductDetails_init_$Init$(seen0, cartItem, serializationConstructorMarker, objectCreate(protoOf(CartMugProductDetails)));
  }
  function Companion_32() {
  }
  var Companion_instance_38;
  function Companion_getInstance_67() {
    return Companion_instance_38;
  }
  function $serializer_27() {
    $serializer_instance_27 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.CartMagicMugProductDetails', this, 1);
    tmp0_serialDesc.a7c('cartItem', false);
    this.e10c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_27).f10c = function (encoder, value) {
    var tmp0_desc = this.e10c_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.e76(tmp0_desc, 0, $serializer_getInstance_5(), value.g10c_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_27).z70 = function (encoder, value) {
    return this.f10c(encoder, value instanceof CartMagicMugProductDetails ? value : THROW_CCE());
  };
  protoOf($serializer_27).a71 = function (decoder) {
    var tmp0_desc = this.e10c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.n74(tmp0_desc);
    if (tmp5_input.d75()) {
      tmp4_local0 = tmp5_input.z74(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.z74(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.o74(tmp0_desc);
    return CartMagicMugProductDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_27).y70 = function () {
    return this.e10c_1;
  };
  protoOf($serializer_27).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_5()];
  };
  var $serializer_instance_27;
  function $serializer_getInstance_27() {
    if ($serializer_instance_27 == null)
      new $serializer_27();
    return $serializer_instance_27;
  }
  function CartMagicMugProductDetails_init_$Init$(seen0, cartItem, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_27().e10c_1);
    }
    $this.g10c_1 = cartItem;
    return $this;
  }
  function CartMagicMugProductDetails_init_$Create$(seen0, cartItem, serializationConstructorMarker) {
    return CartMagicMugProductDetails_init_$Init$(seen0, cartItem, serializationConstructorMarker, objectCreate(protoOf(CartMagicMugProductDetails)));
  }
  function Companion_33() {
  }
  var Companion_instance_39;
  function Companion_getInstance_68() {
    return Companion_instance_39;
  }
  function $serializer_28() {
    $serializer_instance_28 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.MugDesignerEditor', this, 1);
    tmp0_serialDesc.a7c('cartItemId', false);
    this.h10c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_28).i10c = function (encoder, value) {
    var tmp0_desc = this.h10c_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.c76(tmp0_desc, 0, value.j10c_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_28).z70 = function (encoder, value) {
    return this.i10c(encoder, value instanceof MugDesignerEditor ? value : THROW_CCE());
  };
  protoOf($serializer_28).a71 = function (decoder) {
    var tmp0_desc = this.h10c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.n74(tmp0_desc);
    if (tmp5_input.d75()) {
      tmp4_local0 = tmp5_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.o74(tmp0_desc);
    return MugDesignerEditor_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_28).y70 = function () {
    return this.h10c_1;
  };
  protoOf($serializer_28).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_28;
  function $serializer_getInstance_28() {
    if ($serializer_instance_28 == null)
      new $serializer_28();
    return $serializer_instance_28;
  }
  function MugDesignerEditor_init_$Init$(seen0, cartItemId, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_28().h10c_1);
    }
    $this.j10c_1 = cartItemId;
    return $this;
  }
  function MugDesignerEditor_init_$Create$(seen0, cartItemId, serializationConstructorMarker) {
    return MugDesignerEditor_init_$Init$(seen0, cartItemId, serializationConstructorMarker, objectCreate(protoOf(MugDesignerEditor)));
  }
  function Companion_34() {
  }
  var Companion_instance_40;
  function Companion_getInstance_69() {
    return Companion_instance_40;
  }
  function $serializer_29() {
    $serializer_instance_29 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.OrderDetails', this, 1);
    tmp0_serialDesc.a7c('order', false);
    this.k10c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_29).l10c = function (encoder, value) {
    var tmp0_desc = this.k10c_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.e76(tmp0_desc, 0, $serializer_getInstance_10(), value.m10c_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_29).z70 = function (encoder, value) {
    return this.l10c(encoder, value instanceof OrderDetails ? value : THROW_CCE());
  };
  protoOf($serializer_29).a71 = function (decoder) {
    var tmp0_desc = this.k10c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.n74(tmp0_desc);
    if (tmp5_input.d75()) {
      tmp4_local0 = tmp5_input.z74(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.z74(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.o74(tmp0_desc);
    return OrderDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_29).y70 = function () {
    return this.k10c_1;
  };
  protoOf($serializer_29).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_10()];
  };
  var $serializer_instance_29;
  function $serializer_getInstance_29() {
    if ($serializer_instance_29 == null)
      new $serializer_29();
    return $serializer_instance_29;
  }
  function OrderDetails_init_$Init$(seen0, order, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_29().k10c_1);
    }
    $this.m10c_1 = order;
    return $this;
  }
  function OrderDetails_init_$Create$(seen0, order, serializationConstructorMarker) {
    return OrderDetails_init_$Init$(seen0, order, serializationConstructorMarker, objectCreate(protoOf(OrderDetails)));
  }
  function Companion_35() {
  }
  var Companion_instance_41;
  function Companion_getInstance_70() {
    return Companion_instance_41;
  }
  function $serializer_30() {
    $serializer_instance_30 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.PastOrderDetails', this, 1);
    tmp0_serialDesc.a7c('order', false);
    this.n10c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_30).o10c = function (encoder, value) {
    var tmp0_desc = this.n10c_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.e76(tmp0_desc, 0, $serializer_getInstance_10(), value.p10c_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_30).z70 = function (encoder, value) {
    return this.o10c(encoder, value instanceof PastOrderDetails ? value : THROW_CCE());
  };
  protoOf($serializer_30).a71 = function (decoder) {
    var tmp0_desc = this.n10c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.n74(tmp0_desc);
    if (tmp5_input.d75()) {
      tmp4_local0 = tmp5_input.z74(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.z74(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.o74(tmp0_desc);
    return PastOrderDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_30).y70 = function () {
    return this.n10c_1;
  };
  protoOf($serializer_30).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_10()];
  };
  var $serializer_instance_30;
  function $serializer_getInstance_30() {
    if ($serializer_instance_30 == null)
      new $serializer_30();
    return $serializer_instance_30;
  }
  function PastOrderDetails_init_$Init$(seen0, order, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_30().n10c_1);
    }
    $this.p10c_1 = order;
    return $this;
  }
  function PastOrderDetails_init_$Create$(seen0, order, serializationConstructorMarker) {
    return PastOrderDetails_init_$Init$(seen0, order, serializationConstructorMarker, objectCreate(protoOf(PastOrderDetails)));
  }
  function _get_$cachedSerializer__te6jhj_14($this) {
    return $this.q10c_1.u1();
  }
  function Screen$OrderHistory$_anonymous__2uol09() {
    var tmp = OrderHistory_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.OrderHistory', tmp, tmp$ret$0);
  }
  function _get_$cachedSerializer__te6jhj_15($this) {
    return $this.r10c_1.u1();
  }
  function Screen$AccountManagement$_anonymous__8nzg9t() {
    var tmp = AccountManagement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.AccountManagement', tmp, tmp$ret$0);
  }
  function Companion_36() {
  }
  var Companion_instance_42;
  function Companion_getInstance_71() {
    return Companion_instance_42;
  }
  function $serializer_31() {
    $serializer_instance_31 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.presentation.Screen.DeleteAccountStandalone', this, 2);
    tmp0_serialDesc.a7c('token', true);
    tmp0_serialDesc.a7c('email', true);
    this.s10c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_31).t10c = function (encoder, value) {
    var tmp0_desc = this.s10c_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.u10c_1 == null)) {
      tmp1_output.g76(tmp0_desc, 0, StringSerializer_getInstance(), value.u10c_1);
    }
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.v10c_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.v10c_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_31).z70 = function (encoder, value) {
    return this.t10c(encoder, value instanceof DeleteAccountStandalone ? value : THROW_CCE());
  };
  protoOf($serializer_31).a71 = function (decoder) {
    var tmp0_desc = this.s10c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.n74(tmp0_desc);
    if (tmp6_input.d75()) {
      tmp4_local0 = tmp6_input.b75(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b75(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.o74(tmp0_desc);
    return DeleteAccountStandalone_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_31).y70 = function () {
    return this.s10c_1;
  };
  protoOf($serializer_31).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_31;
  function $serializer_getInstance_31() {
    if ($serializer_instance_31 == null)
      new $serializer_31();
    return $serializer_instance_31;
  }
  function DeleteAccountStandalone_init_$Init$(seen0, token, email, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_31().s10c_1);
    }
    if (0 === (seen0 & 1))
      $this.u10c_1 = null;
    else
      $this.u10c_1 = token;
    if (0 === (seen0 & 2))
      $this.v10c_1 = null;
    else
      $this.v10c_1 = email;
    return $this;
  }
  function DeleteAccountStandalone_init_$Create$(seen0, token, email, serializationConstructorMarker) {
    return DeleteAccountStandalone_init_$Init$(seen0, token, email, serializationConstructorMarker, objectCreate(protoOf(DeleteAccountStandalone)));
  }
  function _get_$cachedSerializer__te6jhj_16($this) {
    return $this.w10c_1.u1();
  }
  function Screen$DeleteAccountSuccess$_anonymous__qskwbi() {
    var tmp = DeleteAccountSuccess_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.DeleteAccountSuccess', tmp, tmp$ret$0);
  }
  function _get_$cachedSerializer__te6jhj_17($this) {
    return $this.x10c_1.u1();
  }
  function Screen$ResetPasswordSuccess$_anonymous__ydfzxi() {
    var tmp = ResetPasswordSuccess_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [];
    return ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.ResetPasswordSuccess', tmp, tmp$ret$0);
  }
  function Shopping() {
    Shopping_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o108_1 = lazy_0(tmp_0, Screen$Shopping$_anonymous__15bgrt);
  }
  protoOf(Shopping).amj = function () {
    return _get_$cachedSerializer__te6jhj_4(this);
  };
  protoOf(Shopping).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(Shopping).toString = function () {
    return 'Shopping';
  };
  protoOf(Shopping).hashCode = function () {
    return -151492738;
  };
  protoOf(Shopping).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Shopping))
      return false;
    return true;
  };
  var Shopping_instance;
  function Shopping_getInstance() {
    if (Shopping_instance == null)
      new Shopping();
    return Shopping_instance;
  }
  function Profile_0() {
    Profile_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p108_1 = lazy_0(tmp_0, Screen$Profile$_anonymous__1nbpbu);
  }
  protoOf(Profile_0).amj = function () {
    return _get_$cachedSerializer__te6jhj_5(this);
  };
  protoOf(Profile_0).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(Profile_0).toString = function () {
    return 'Profile';
  };
  protoOf(Profile_0).hashCode = function () {
    return 666630355;
  };
  protoOf(Profile_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Profile_0))
      return false;
    return true;
  };
  var Profile_instance;
  function Profile_getInstance() {
    if (Profile_instance == null)
      new Profile_0();
    return Profile_instance;
  }
  function Cart() {
    Cart_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q108_1 = lazy_0(tmp_0, Screen$Cart$_anonymous__rg9axr);
  }
  protoOf(Cart).amj = function () {
    return _get_$cachedSerializer__te6jhj_6(this);
  };
  protoOf(Cart).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(Cart).toString = function () {
    return 'Cart';
  };
  protoOf(Cart).hashCode = function () {
    return 1801022518;
  };
  protoOf(Cart).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Cart))
      return false;
    return true;
  };
  var Cart_instance;
  function Cart_getInstance() {
    if (Cart_instance == null)
      new Cart();
    return Cart_instance;
  }
  function ProductDetails(product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday) {
    Companion_getInstance_56();
    initialSize = initialSize === VOID ? null : initialSize;
    initialColor = initialColor === VOID ? null : initialColor;
    initialOptions = initialOptions === VOID ? null : initialOptions;
    initialComment = initialComment === VOID ? null : initialComment;
    initialCard = initialCard === VOID ? null : initialCard;
    initialBox = initialBox === VOID ? null : initialBox;
    initialCardMessage = initialCardMessage === VOID ? null : initialCardMessage;
    initialCardBirthday = initialCardBirthday === VOID ? null : initialCardBirthday;
    initialBoxMessage = initialBoxMessage === VOID ? null : initialBoxMessage;
    initialBoxBirthday = initialBoxBirthday === VOID ? null : initialBoxBirthday;
    this.u108_1 = product;
    this.v108_1 = initialSize;
    this.w108_1 = initialColor;
    this.x108_1 = initialOptions;
    this.y108_1 = initialComment;
    this.z108_1 = initialCard;
    this.a109_1 = initialBox;
    this.b109_1 = initialCardMessage;
    this.c109_1 = initialCardBirthday;
    this.d109_1 = initialBoxMessage;
    this.e109_1 = initialBoxBirthday;
  }
  protoOf(ProductDetails).toString = function () {
    return 'ProductDetails(product=' + this.u108_1.toString() + ', initialSize=' + this.v108_1 + ', initialColor=' + this.w108_1 + ', initialOptions=' + toString_0(this.x108_1) + ', initialComment=' + this.y108_1 + ', initialCard=' + toString_0(this.z108_1) + ', initialBox=' + toString_0(this.a109_1) + ', initialCardMessage=' + this.b109_1 + ', initialCardBirthday=' + this.c109_1 + ', initialBoxMessage=' + this.d109_1 + ', initialBoxBirthday=' + this.e109_1 + ')';
  };
  protoOf(ProductDetails).hashCode = function () {
    var result = this.u108_1.hashCode();
    result = imul(result, 31) + (this.v108_1 == null ? 0 : getStringHashCode(this.v108_1)) | 0;
    result = imul(result, 31) + (this.w108_1 == null ? 0 : getStringHashCode(this.w108_1)) | 0;
    result = imul(result, 31) + (this.x108_1 == null ? 0 : hashCode(this.x108_1)) | 0;
    result = imul(result, 31) + (this.y108_1 == null ? 0 : getStringHashCode(this.y108_1)) | 0;
    result = imul(result, 31) + (this.z108_1 == null ? 0 : this.z108_1.hashCode()) | 0;
    result = imul(result, 31) + (this.a109_1 == null ? 0 : this.a109_1.hashCode()) | 0;
    result = imul(result, 31) + (this.b109_1 == null ? 0 : getStringHashCode(this.b109_1)) | 0;
    result = imul(result, 31) + (this.c109_1 == null ? 0 : getStringHashCode(this.c109_1)) | 0;
    result = imul(result, 31) + (this.d109_1 == null ? 0 : getStringHashCode(this.d109_1)) | 0;
    result = imul(result, 31) + (this.e109_1 == null ? 0 : getStringHashCode(this.e109_1)) | 0;
    return result;
  };
  protoOf(ProductDetails).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductDetails))
      return false;
    if (!this.u108_1.equals(other.u108_1))
      return false;
    if (!(this.v108_1 == other.v108_1))
      return false;
    if (!(this.w108_1 == other.w108_1))
      return false;
    if (!equals(this.x108_1, other.x108_1))
      return false;
    if (!(this.y108_1 == other.y108_1))
      return false;
    if (!equals(this.z108_1, other.z108_1))
      return false;
    if (!equals(this.a109_1, other.a109_1))
      return false;
    if (!(this.b109_1 == other.b109_1))
      return false;
    if (!(this.c109_1 == other.c109_1))
      return false;
    if (!(this.d109_1 == other.d109_1))
      return false;
    if (!(this.e109_1 == other.e109_1))
      return false;
    return true;
  };
  function BeadsProductDetails(product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, initialBraceletName) {
    Companion_getInstance_57();
    initialSize = initialSize === VOID ? null : initialSize;
    initialColor = initialColor === VOID ? null : initialColor;
    initialOptions = initialOptions === VOID ? null : initialOptions;
    initialComment = initialComment === VOID ? null : initialComment;
    initialCard = initialCard === VOID ? null : initialCard;
    initialBox = initialBox === VOID ? null : initialBox;
    initialCardMessage = initialCardMessage === VOID ? null : initialCardMessage;
    initialCardBirthday = initialCardBirthday === VOID ? null : initialCardBirthday;
    initialBoxMessage = initialBoxMessage === VOID ? null : initialBoxMessage;
    initialBoxBirthday = initialBoxBirthday === VOID ? null : initialBoxBirthday;
    initialBraceletName = initialBraceletName === VOID ? null : initialBraceletName;
    this.i109_1 = product;
    this.j109_1 = initialSize;
    this.k109_1 = initialColor;
    this.l109_1 = initialOptions;
    this.m109_1 = initialComment;
    this.n109_1 = initialCard;
    this.o109_1 = initialBox;
    this.p109_1 = initialCardMessage;
    this.q109_1 = initialCardBirthday;
    this.r109_1 = initialBoxMessage;
    this.s109_1 = initialBoxBirthday;
    this.t109_1 = initialBraceletName;
  }
  protoOf(BeadsProductDetails).toString = function () {
    return 'BeadsProductDetails(product=' + this.i109_1.toString() + ', initialSize=' + this.j109_1 + ', initialColor=' + this.k109_1 + ', initialOptions=' + toString_0(this.l109_1) + ', initialComment=' + this.m109_1 + ', initialCard=' + toString_0(this.n109_1) + ', initialBox=' + toString_0(this.o109_1) + ', initialCardMessage=' + this.p109_1 + ', initialCardBirthday=' + this.q109_1 + ', initialBoxMessage=' + this.r109_1 + ', initialBoxBirthday=' + this.s109_1 + ', initialBraceletName=' + this.t109_1 + ')';
  };
  protoOf(BeadsProductDetails).hashCode = function () {
    var result = this.i109_1.hashCode();
    result = imul(result, 31) + (this.j109_1 == null ? 0 : getStringHashCode(this.j109_1)) | 0;
    result = imul(result, 31) + (this.k109_1 == null ? 0 : getStringHashCode(this.k109_1)) | 0;
    result = imul(result, 31) + (this.l109_1 == null ? 0 : hashCode(this.l109_1)) | 0;
    result = imul(result, 31) + (this.m109_1 == null ? 0 : getStringHashCode(this.m109_1)) | 0;
    result = imul(result, 31) + (this.n109_1 == null ? 0 : this.n109_1.hashCode()) | 0;
    result = imul(result, 31) + (this.o109_1 == null ? 0 : this.o109_1.hashCode()) | 0;
    result = imul(result, 31) + (this.p109_1 == null ? 0 : getStringHashCode(this.p109_1)) | 0;
    result = imul(result, 31) + (this.q109_1 == null ? 0 : getStringHashCode(this.q109_1)) | 0;
    result = imul(result, 31) + (this.r109_1 == null ? 0 : getStringHashCode(this.r109_1)) | 0;
    result = imul(result, 31) + (this.s109_1 == null ? 0 : getStringHashCode(this.s109_1)) | 0;
    result = imul(result, 31) + (this.t109_1 == null ? 0 : getStringHashCode(this.t109_1)) | 0;
    return result;
  };
  protoOf(BeadsProductDetails).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BeadsProductDetails))
      return false;
    if (!this.i109_1.equals(other.i109_1))
      return false;
    if (!(this.j109_1 == other.j109_1))
      return false;
    if (!(this.k109_1 == other.k109_1))
      return false;
    if (!equals(this.l109_1, other.l109_1))
      return false;
    if (!(this.m109_1 == other.m109_1))
      return false;
    if (!equals(this.n109_1, other.n109_1))
      return false;
    if (!equals(this.o109_1, other.o109_1))
      return false;
    if (!(this.p109_1 == other.p109_1))
      return false;
    if (!(this.q109_1 == other.q109_1))
      return false;
    if (!(this.r109_1 == other.r109_1))
      return false;
    if (!(this.s109_1 == other.s109_1))
      return false;
    if (!(this.t109_1 == other.t109_1))
      return false;
    return true;
  };
  function CustomMugDetails(product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday) {
    Companion_getInstance_58();
    initialSize = initialSize === VOID ? null : initialSize;
    initialColor = initialColor === VOID ? null : initialColor;
    initialOptions = initialOptions === VOID ? null : initialOptions;
    initialComment = initialComment === VOID ? null : initialComment;
    initialCard = initialCard === VOID ? null : initialCard;
    initialBox = initialBox === VOID ? null : initialBox;
    initialCardMessage = initialCardMessage === VOID ? null : initialCardMessage;
    initialCardBirthday = initialCardBirthday === VOID ? null : initialCardBirthday;
    initialBoxMessage = initialBoxMessage === VOID ? null : initialBoxMessage;
    initialBoxBirthday = initialBoxBirthday === VOID ? null : initialBoxBirthday;
    this.x109_1 = product;
    this.y109_1 = initialSize;
    this.z109_1 = initialColor;
    this.a10a_1 = initialOptions;
    this.b10a_1 = initialComment;
    this.c10a_1 = initialCard;
    this.d10a_1 = initialBox;
    this.e10a_1 = initialCardMessage;
    this.f10a_1 = initialCardBirthday;
    this.g10a_1 = initialBoxMessage;
    this.h10a_1 = initialBoxBirthday;
  }
  protoOf(CustomMugDetails).toString = function () {
    return 'CustomMugDetails(product=' + this.x109_1.toString() + ', initialSize=' + this.y109_1 + ', initialColor=' + this.z109_1 + ', initialOptions=' + toString_0(this.a10a_1) + ', initialComment=' + this.b10a_1 + ', initialCard=' + toString_0(this.c10a_1) + ', initialBox=' + toString_0(this.d10a_1) + ', initialCardMessage=' + this.e10a_1 + ', initialCardBirthday=' + this.f10a_1 + ', initialBoxMessage=' + this.g10a_1 + ', initialBoxBirthday=' + this.h10a_1 + ')';
  };
  protoOf(CustomMugDetails).hashCode = function () {
    var result = this.x109_1.hashCode();
    result = imul(result, 31) + (this.y109_1 == null ? 0 : getStringHashCode(this.y109_1)) | 0;
    result = imul(result, 31) + (this.z109_1 == null ? 0 : getStringHashCode(this.z109_1)) | 0;
    result = imul(result, 31) + (this.a10a_1 == null ? 0 : hashCode(this.a10a_1)) | 0;
    result = imul(result, 31) + (this.b10a_1 == null ? 0 : getStringHashCode(this.b10a_1)) | 0;
    result = imul(result, 31) + (this.c10a_1 == null ? 0 : this.c10a_1.hashCode()) | 0;
    result = imul(result, 31) + (this.d10a_1 == null ? 0 : this.d10a_1.hashCode()) | 0;
    result = imul(result, 31) + (this.e10a_1 == null ? 0 : getStringHashCode(this.e10a_1)) | 0;
    result = imul(result, 31) + (this.f10a_1 == null ? 0 : getStringHashCode(this.f10a_1)) | 0;
    result = imul(result, 31) + (this.g10a_1 == null ? 0 : getStringHashCode(this.g10a_1)) | 0;
    result = imul(result, 31) + (this.h10a_1 == null ? 0 : getStringHashCode(this.h10a_1)) | 0;
    return result;
  };
  protoOf(CustomMugDetails).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CustomMugDetails))
      return false;
    if (!this.x109_1.equals(other.x109_1))
      return false;
    if (!(this.y109_1 == other.y109_1))
      return false;
    if (!(this.z109_1 == other.z109_1))
      return false;
    if (!equals(this.a10a_1, other.a10a_1))
      return false;
    if (!(this.b10a_1 == other.b10a_1))
      return false;
    if (!equals(this.c10a_1, other.c10a_1))
      return false;
    if (!equals(this.d10a_1, other.d10a_1))
      return false;
    if (!(this.e10a_1 == other.e10a_1))
      return false;
    if (!(this.f10a_1 == other.f10a_1))
      return false;
    if (!(this.g10a_1 == other.g10a_1))
      return false;
    if (!(this.h10a_1 == other.h10a_1))
      return false;
    return true;
  };
  function CustomMagicMugDetails(product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday) {
    Companion_getInstance_59();
    initialSize = initialSize === VOID ? null : initialSize;
    initialColor = initialColor === VOID ? null : initialColor;
    initialOptions = initialOptions === VOID ? null : initialOptions;
    initialComment = initialComment === VOID ? null : initialComment;
    initialCard = initialCard === VOID ? null : initialCard;
    initialBox = initialBox === VOID ? null : initialBox;
    initialCardMessage = initialCardMessage === VOID ? null : initialCardMessage;
    initialCardBirthday = initialCardBirthday === VOID ? null : initialCardBirthday;
    initialBoxMessage = initialBoxMessage === VOID ? null : initialBoxMessage;
    initialBoxBirthday = initialBoxBirthday === VOID ? null : initialBoxBirthday;
    this.l10a_1 = product;
    this.m10a_1 = initialSize;
    this.n10a_1 = initialColor;
    this.o10a_1 = initialOptions;
    this.p10a_1 = initialComment;
    this.q10a_1 = initialCard;
    this.r10a_1 = initialBox;
    this.s10a_1 = initialCardMessage;
    this.t10a_1 = initialCardBirthday;
    this.u10a_1 = initialBoxMessage;
    this.v10a_1 = initialBoxBirthday;
  }
  protoOf(CustomMagicMugDetails).toString = function () {
    return 'CustomMagicMugDetails(product=' + this.l10a_1.toString() + ', initialSize=' + this.m10a_1 + ', initialColor=' + this.n10a_1 + ', initialOptions=' + toString_0(this.o10a_1) + ', initialComment=' + this.p10a_1 + ', initialCard=' + toString_0(this.q10a_1) + ', initialBox=' + toString_0(this.r10a_1) + ', initialCardMessage=' + this.s10a_1 + ', initialCardBirthday=' + this.t10a_1 + ', initialBoxMessage=' + this.u10a_1 + ', initialBoxBirthday=' + this.v10a_1 + ')';
  };
  protoOf(CustomMagicMugDetails).hashCode = function () {
    var result = this.l10a_1.hashCode();
    result = imul(result, 31) + (this.m10a_1 == null ? 0 : getStringHashCode(this.m10a_1)) | 0;
    result = imul(result, 31) + (this.n10a_1 == null ? 0 : getStringHashCode(this.n10a_1)) | 0;
    result = imul(result, 31) + (this.o10a_1 == null ? 0 : hashCode(this.o10a_1)) | 0;
    result = imul(result, 31) + (this.p10a_1 == null ? 0 : getStringHashCode(this.p10a_1)) | 0;
    result = imul(result, 31) + (this.q10a_1 == null ? 0 : this.q10a_1.hashCode()) | 0;
    result = imul(result, 31) + (this.r10a_1 == null ? 0 : this.r10a_1.hashCode()) | 0;
    result = imul(result, 31) + (this.s10a_1 == null ? 0 : getStringHashCode(this.s10a_1)) | 0;
    result = imul(result, 31) + (this.t10a_1 == null ? 0 : getStringHashCode(this.t10a_1)) | 0;
    result = imul(result, 31) + (this.u10a_1 == null ? 0 : getStringHashCode(this.u10a_1)) | 0;
    result = imul(result, 31) + (this.v10a_1 == null ? 0 : getStringHashCode(this.v10a_1)) | 0;
    return result;
  };
  protoOf(CustomMagicMugDetails).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CustomMagicMugDetails))
      return false;
    if (!this.l10a_1.equals(other.l10a_1))
      return false;
    if (!(this.m10a_1 == other.m10a_1))
      return false;
    if (!(this.n10a_1 == other.n10a_1))
      return false;
    if (!equals(this.o10a_1, other.o10a_1))
      return false;
    if (!(this.p10a_1 == other.p10a_1))
      return false;
    if (!equals(this.q10a_1, other.q10a_1))
      return false;
    if (!equals(this.r10a_1, other.r10a_1))
      return false;
    if (!(this.s10a_1 == other.s10a_1))
      return false;
    if (!(this.t10a_1 == other.t10a_1))
      return false;
    if (!(this.u10a_1 == other.u10a_1))
      return false;
    if (!(this.v10a_1 == other.v10a_1))
      return false;
    return true;
  };
  function Checkout() {
    Checkout_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w10a_1 = lazy_0(tmp_0, Screen$Checkout$_anonymous__hk75a1);
  }
  protoOf(Checkout).amj = function () {
    return _get_$cachedSerializer__te6jhj_7(this);
  };
  protoOf(Checkout).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(Checkout).toString = function () {
    return 'Checkout';
  };
  protoOf(Checkout).hashCode = function () {
    return 1729872732;
  };
  protoOf(Checkout).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Checkout))
      return false;
    return true;
  };
  var Checkout_instance;
  function Checkout_getInstance() {
    if (Checkout_instance == null)
      new Checkout();
    return Checkout_instance;
  }
  function Friends() {
    Friends_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x10a_1 = lazy_0(tmp_0, Screen$Friends$_anonymous__2zcoii);
  }
  protoOf(Friends).amj = function () {
    return _get_$cachedSerializer__te6jhj_8(this);
  };
  protoOf(Friends).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(Friends).toString = function () {
    return 'Friends';
  };
  protoOf(Friends).hashCode = function () {
    return 375961791;
  };
  protoOf(Friends).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Friends))
      return false;
    return true;
  };
  var Friends_instance;
  function Friends_getInstance() {
    if (Friends_instance == null)
      new Friends();
    return Friends_instance;
  }
  function Favorites() {
    Favorites_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y10a_1 = lazy_0(tmp_0, Screen$Favorites$_anonymous__3wgwuw);
  }
  protoOf(Favorites).amj = function () {
    return _get_$cachedSerializer__te6jhj_9(this);
  };
  protoOf(Favorites).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(Favorites).toString = function () {
    return 'Favorites';
  };
  protoOf(Favorites).hashCode = function () {
    return -98191615;
  };
  protoOf(Favorites).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Favorites))
      return false;
    return true;
  };
  var Favorites_instance;
  function Favorites_getInstance() {
    if (Favorites_instance == null)
      new Favorites();
    return Favorites_instance;
  }
  function Coupons() {
    Coupons_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.z10a_1 = lazy_0(tmp_0, Screen$Coupons$_anonymous__7oppr6);
  }
  protoOf(Coupons).amj = function () {
    return _get_$cachedSerializer__te6jhj_10(this);
  };
  protoOf(Coupons).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(Coupons).toString = function () {
    return 'Coupons';
  };
  protoOf(Coupons).hashCode = function () {
    return 1933941815;
  };
  protoOf(Coupons).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Coupons))
      return false;
    return true;
  };
  var Coupons_instance;
  function Coupons_getInstance() {
    if (Coupons_instance == null)
      new Coupons();
    return Coupons_instance;
  }
  function StockReminders() {
    StockReminders_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a10b_1 = lazy_0(tmp_0, Screen$StockReminders$_anonymous__1h9nqs);
  }
  protoOf(StockReminders).amj = function () {
    return _get_$cachedSerializer__te6jhj_11(this);
  };
  protoOf(StockReminders).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(StockReminders).toString = function () {
    return 'StockReminders';
  };
  protoOf(StockReminders).hashCode = function () {
    return 1593253217;
  };
  protoOf(StockReminders).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StockReminders))
      return false;
    return true;
  };
  var StockReminders_instance;
  function StockReminders_getInstance() {
    if (StockReminders_instance == null)
      new StockReminders();
    return StockReminders_instance;
  }
  function Update() {
    Update_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b10b_1 = lazy_0(tmp_0, Screen$Update$_anonymous__9otj06);
  }
  protoOf(Update).amj = function () {
    return _get_$cachedSerializer__te6jhj_12(this);
  };
  protoOf(Update).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(Update).toString = function () {
    return 'Update';
  };
  protoOf(Update).hashCode = function () {
    return 439565407;
  };
  protoOf(Update).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Update))
      return false;
    return true;
  };
  var Update_instance;
  function Update_getInstance() {
    if (Update_instance == null)
      new Update();
    return Update_instance;
  }
  function CustomMug() {
    CustomMug_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c10b_1 = lazy_0(tmp_0, Screen$CustomMug$_anonymous__alsodb);
  }
  protoOf(CustomMug).amj = function () {
    return _get_$cachedSerializer__te6jhj_13(this);
  };
  protoOf(CustomMug).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(CustomMug).toString = function () {
    return 'CustomMug';
  };
  protoOf(CustomMug).hashCode = function () {
    return -996380872;
  };
  protoOf(CustomMug).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CustomMug))
      return false;
    return true;
  };
  var CustomMug_instance;
  function CustomMug_getInstance() {
    if (CustomMug_instance == null)
      new CustomMug();
    return CustomMug_instance;
  }
  function Auth_0(page, recoveryUrl) {
    page = page === VOID ? 'login' : page;
    recoveryUrl = recoveryUrl === VOID ? null : recoveryUrl;
    this.f10b_1 = page;
    this.g10b_1 = recoveryUrl;
  }
  protoOf(Auth_0).toString = function () {
    return 'Auth(page=' + this.f10b_1 + ', recoveryUrl=' + this.g10b_1 + ')';
  };
  protoOf(Auth_0).hashCode = function () {
    var result = getStringHashCode(this.f10b_1);
    result = imul(result, 31) + (this.g10b_1 == null ? 0 : getStringHashCode(this.g10b_1)) | 0;
    return result;
  };
  protoOf(Auth_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Auth_0))
      return false;
    if (!(this.f10b_1 === other.f10b_1))
      return false;
    if (!(this.g10b_1 == other.g10b_1))
      return false;
    return true;
  };
  function Error_0(message) {
    this.j10b_1 = message;
  }
  protoOf(Error_0).toString = function () {
    return 'Error(message=' + this.j10b_1 + ')';
  };
  protoOf(Error_0).hashCode = function () {
    return getStringHashCode(this.j10b_1);
  };
  protoOf(Error_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Error_0))
      return false;
    if (!(this.j10b_1 === other.j10b_1))
      return false;
    return true;
  };
  function Model3D(productId, product, initialImageBytes, designLayers, customImageUrl) {
    Companion_getInstance_62();
    product = product === VOID ? null : product;
    initialImageBytes = initialImageBytes === VOID ? null : initialImageBytes;
    designLayers = designLayers === VOID ? null : designLayers;
    customImageUrl = customImageUrl === VOID ? null : customImageUrl;
    this.n10b_1 = productId;
    this.o10b_1 = product;
    this.p10b_1 = initialImageBytes;
    this.q10b_1 = designLayers;
    this.r10b_1 = customImageUrl;
  }
  protoOf(Model3D).toString = function () {
    return 'Model3D(productId=' + this.n10b_1.toString() + ', product=' + toString_0(this.o10b_1) + ', initialImageBytes=' + toString_0(this.p10b_1) + ', designLayers=' + toString_0(this.q10b_1) + ', customImageUrl=' + this.r10b_1 + ')';
  };
  protoOf(Model3D).hashCode = function () {
    var result = this.n10b_1.hashCode();
    result = imul(result, 31) + (this.o10b_1 == null ? 0 : this.o10b_1.hashCode()) | 0;
    result = imul(result, 31) + (this.p10b_1 == null ? 0 : hashCode(this.p10b_1)) | 0;
    result = imul(result, 31) + (this.q10b_1 == null ? 0 : hashCode(this.q10b_1)) | 0;
    result = imul(result, 31) + (this.r10b_1 == null ? 0 : getStringHashCode(this.r10b_1)) | 0;
    return result;
  };
  protoOf(Model3D).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Model3D))
      return false;
    if (!equalsLong(this.n10b_1, other.n10b_1))
      return false;
    if (!equals(this.o10b_1, other.o10b_1))
      return false;
    if (!equals(this.p10b_1, other.p10b_1))
      return false;
    if (!equals(this.q10b_1, other.q10b_1))
      return false;
    if (!(this.r10b_1 == other.r10b_1))
      return false;
    return true;
  };
  function EditDesign(cartItemId) {
    this.u10b_1 = cartItemId;
  }
  protoOf(EditDesign).toString = function () {
    return 'EditDesign(cartItemId=' + this.u10b_1 + ')';
  };
  protoOf(EditDesign).hashCode = function () {
    return getStringHashCode(this.u10b_1);
  };
  protoOf(EditDesign).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EditDesign))
      return false;
    if (!(this.u10b_1 === other.u10b_1))
      return false;
    return true;
  };
  function EditCustomMagicMug(cartItemId) {
    this.x10b_1 = cartItemId;
  }
  protoOf(EditCustomMagicMug).toString = function () {
    return 'EditCustomMagicMug(cartItemId=' + this.x10b_1 + ')';
  };
  protoOf(EditCustomMagicMug).hashCode = function () {
    return getStringHashCode(this.x10b_1);
  };
  protoOf(EditCustomMagicMug).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EditCustomMagicMug))
      return false;
    if (!(this.x10b_1 === other.x10b_1))
      return false;
    return true;
  };
  function CartNormalProductDetails(cartItem) {
    this.a10c_1 = cartItem;
  }
  protoOf(CartNormalProductDetails).toString = function () {
    return 'CartNormalProductDetails(cartItem=' + this.a10c_1.toString() + ')';
  };
  protoOf(CartNormalProductDetails).hashCode = function () {
    return this.a10c_1.hashCode();
  };
  protoOf(CartNormalProductDetails).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CartNormalProductDetails))
      return false;
    if (!this.a10c_1.equals(other.a10c_1))
      return false;
    return true;
  };
  function CartMugProductDetails(cartItem) {
    this.d10c_1 = cartItem;
  }
  protoOf(CartMugProductDetails).toString = function () {
    return 'CartMugProductDetails(cartItem=' + this.d10c_1.toString() + ')';
  };
  protoOf(CartMugProductDetails).hashCode = function () {
    return this.d10c_1.hashCode();
  };
  protoOf(CartMugProductDetails).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CartMugProductDetails))
      return false;
    if (!this.d10c_1.equals(other.d10c_1))
      return false;
    return true;
  };
  function CartMagicMugProductDetails(cartItem) {
    this.g10c_1 = cartItem;
  }
  protoOf(CartMagicMugProductDetails).toString = function () {
    return 'CartMagicMugProductDetails(cartItem=' + this.g10c_1.toString() + ')';
  };
  protoOf(CartMagicMugProductDetails).hashCode = function () {
    return this.g10c_1.hashCode();
  };
  protoOf(CartMagicMugProductDetails).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CartMagicMugProductDetails))
      return false;
    if (!this.g10c_1.equals(other.g10c_1))
      return false;
    return true;
  };
  function MugDesignerEditor(cartItemId) {
    this.j10c_1 = cartItemId;
  }
  protoOf(MugDesignerEditor).toString = function () {
    return 'MugDesignerEditor(cartItemId=' + this.j10c_1 + ')';
  };
  protoOf(MugDesignerEditor).hashCode = function () {
    return getStringHashCode(this.j10c_1);
  };
  protoOf(MugDesignerEditor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MugDesignerEditor))
      return false;
    if (!(this.j10c_1 === other.j10c_1))
      return false;
    return true;
  };
  function OrderDetails(order) {
    this.m10c_1 = order;
  }
  protoOf(OrderDetails).toString = function () {
    return 'OrderDetails(order=' + this.m10c_1.toString() + ')';
  };
  protoOf(OrderDetails).hashCode = function () {
    return this.m10c_1.hashCode();
  };
  protoOf(OrderDetails).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrderDetails))
      return false;
    if (!this.m10c_1.equals(other.m10c_1))
      return false;
    return true;
  };
  function PastOrderDetails(order) {
    this.p10c_1 = order;
  }
  protoOf(PastOrderDetails).toString = function () {
    return 'PastOrderDetails(order=' + this.p10c_1.toString() + ')';
  };
  protoOf(PastOrderDetails).hashCode = function () {
    return this.p10c_1.hashCode();
  };
  protoOf(PastOrderDetails).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PastOrderDetails))
      return false;
    if (!this.p10c_1.equals(other.p10c_1))
      return false;
    return true;
  };
  function OrderHistory() {
    OrderHistory_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q10c_1 = lazy_0(tmp_0, Screen$OrderHistory$_anonymous__2uol09);
  }
  protoOf(OrderHistory).amj = function () {
    return _get_$cachedSerializer__te6jhj_14(this);
  };
  protoOf(OrderHistory).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(OrderHistory).toString = function () {
    return 'OrderHistory';
  };
  protoOf(OrderHistory).hashCode = function () {
    return 936918140;
  };
  protoOf(OrderHistory).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrderHistory))
      return false;
    return true;
  };
  var OrderHistory_instance;
  function OrderHistory_getInstance() {
    if (OrderHistory_instance == null)
      new OrderHistory();
    return OrderHistory_instance;
  }
  function AccountManagement() {
    AccountManagement_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r10c_1 = lazy_0(tmp_0, Screen$AccountManagement$_anonymous__8nzg9t);
  }
  protoOf(AccountManagement).amj = function () {
    return _get_$cachedSerializer__te6jhj_15(this);
  };
  protoOf(AccountManagement).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(AccountManagement).toString = function () {
    return 'AccountManagement';
  };
  protoOf(AccountManagement).hashCode = function () {
    return 186567930;
  };
  protoOf(AccountManagement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AccountManagement))
      return false;
    return true;
  };
  var AccountManagement_instance;
  function AccountManagement_getInstance() {
    if (AccountManagement_instance == null)
      new AccountManagement();
    return AccountManagement_instance;
  }
  function DeleteAccountStandalone(token, email) {
    token = token === VOID ? null : token;
    email = email === VOID ? null : email;
    this.u10c_1 = token;
    this.v10c_1 = email;
  }
  protoOf(DeleteAccountStandalone).toString = function () {
    return 'DeleteAccountStandalone(token=' + this.u10c_1 + ', email=' + this.v10c_1 + ')';
  };
  protoOf(DeleteAccountStandalone).hashCode = function () {
    var result = this.u10c_1 == null ? 0 : getStringHashCode(this.u10c_1);
    result = imul(result, 31) + (this.v10c_1 == null ? 0 : getStringHashCode(this.v10c_1)) | 0;
    return result;
  };
  protoOf(DeleteAccountStandalone).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeleteAccountStandalone))
      return false;
    if (!(this.u10c_1 == other.u10c_1))
      return false;
    if (!(this.v10c_1 == other.v10c_1))
      return false;
    return true;
  };
  function DeleteAccountSuccess() {
    DeleteAccountSuccess_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.w10c_1 = lazy_0(tmp_0, Screen$DeleteAccountSuccess$_anonymous__qskwbi);
  }
  protoOf(DeleteAccountSuccess).amj = function () {
    return _get_$cachedSerializer__te6jhj_16(this);
  };
  protoOf(DeleteAccountSuccess).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(DeleteAccountSuccess).toString = function () {
    return 'DeleteAccountSuccess';
  };
  protoOf(DeleteAccountSuccess).hashCode = function () {
    return 959611063;
  };
  protoOf(DeleteAccountSuccess).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeleteAccountSuccess))
      return false;
    return true;
  };
  var DeleteAccountSuccess_instance;
  function DeleteAccountSuccess_getInstance() {
    if (DeleteAccountSuccess_instance == null)
      new DeleteAccountSuccess();
    return DeleteAccountSuccess_instance;
  }
  function ResetPasswordSuccess() {
    ResetPasswordSuccess_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x10c_1 = lazy_0(tmp_0, Screen$ResetPasswordSuccess$_anonymous__ydfzxi);
  }
  protoOf(ResetPasswordSuccess).amj = function () {
    return _get_$cachedSerializer__te6jhj_17(this);
  };
  protoOf(ResetPasswordSuccess).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  protoOf(ResetPasswordSuccess).toString = function () {
    return 'ResetPasswordSuccess';
  };
  protoOf(ResetPasswordSuccess).hashCode = function () {
    return 1148813487;
  };
  protoOf(ResetPasswordSuccess).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ResetPasswordSuccess))
      return false;
    return true;
  };
  var ResetPasswordSuccess_instance;
  function ResetPasswordSuccess_getInstance() {
    if (ResetPasswordSuccess_instance == null)
      new ResetPasswordSuccess();
    return ResetPasswordSuccess_instance;
  }
  function Companion_37() {
  }
  protoOf(Companion_37).amj = function () {
    var tmp = getKClass(Screen);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AccountManagement), getKClass(Auth_0), getKClass(BeadsProductDetails), getKClass(Cart), getKClass(CartMagicMugProductDetails), getKClass(CartMugProductDetails), getKClass(CartNormalProductDetails), getKClass(Checkout), getKClass(Coupons), getKClass(CustomMagicMugDetails), getKClass(CustomMug), getKClass(CustomMugDetails), getKClass(DeleteAccountStandalone), getKClass(DeleteAccountSuccess), getKClass(EditCustomMagicMug), getKClass(EditDesign), getKClass(Error_0), getKClass(Favorites), getKClass(Friends), getKClass(Model3D), getKClass(MugDesignerEditor), getKClass(OrderDetails), getKClass(OrderHistory), getKClass(PastOrderDetails), getKClass(ProductDetails), getKClass(Profile_0), getKClass(ResetPasswordSuccess), getKClass(Shopping), getKClass(StockReminders), getKClass(Update)];
    var tmp_1 = AccountManagement_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_2 = ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.AccountManagement', tmp_1, tmp$ret$3);
    var tmp_3 = $serializer_getInstance_20();
    var tmp_4 = $serializer_getInstance_17();
    var tmp_5 = Cart_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_6 = ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Cart', tmp_5, tmp$ret$6);
    var tmp_7 = $serializer_getInstance_27();
    var tmp_8 = $serializer_getInstance_26();
    var tmp_9 = $serializer_getInstance_25();
    var tmp_10 = Checkout_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_11 = ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Checkout', tmp_10, tmp$ret$9);
    var tmp_12 = Coupons_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_13 = ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Coupons', tmp_12, tmp$ret$12);
    var tmp_14 = $serializer_getInstance_19();
    var tmp_15 = CustomMug_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_16 = ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.CustomMug', tmp_15, tmp$ret$15);
    var tmp_17 = $serializer_getInstance_18();
    var tmp_18 = $serializer_getInstance_31();
    var tmp_19 = DeleteAccountSuccess_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    var tmp_20 = ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.DeleteAccountSuccess', tmp_19, tmp$ret$18);
    var tmp_21 = $serializer_getInstance_24();
    var tmp_22 = $serializer_getInstance_23();
    var tmp_23 = $serializer_getInstance_21();
    var tmp_24 = Favorites_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [];
    var tmp_25 = ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Favorites', tmp_24, tmp$ret$21);
    var tmp_26 = Friends_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    var tmp_27 = ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Friends', tmp_26, tmp$ret$24);
    var tmp_28 = $serializer_getInstance_22();
    var tmp_29 = $serializer_getInstance_28();
    var tmp_30 = $serializer_getInstance_29();
    var tmp_31 = OrderHistory_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$27 = [];
    var tmp_32 = ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.OrderHistory', tmp_31, tmp$ret$27);
    var tmp_33 = $serializer_getInstance_30();
    var tmp_34 = $serializer_getInstance_16();
    var tmp_35 = Profile_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$30 = [];
    var tmp_36 = ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Profile', tmp_35, tmp$ret$30);
    var tmp_37 = ResetPasswordSuccess_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$33 = [];
    var tmp_38 = ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.ResetPasswordSuccess', tmp_37, tmp$ret$33);
    var tmp_39 = Shopping_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$36 = [];
    var tmp_40 = ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Shopping', tmp_39, tmp$ret$36);
    var tmp_41 = StockReminders_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$39 = [];
    var tmp_42 = ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.StockReminders', tmp_41, tmp$ret$39);
    var tmp_43 = Update_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$42 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_44 = [tmp_2, tmp_3, tmp_4, tmp_6, tmp_7, tmp_8, tmp_9, tmp_11, tmp_13, tmp_14, tmp_16, tmp_17, tmp_18, tmp_20, tmp_21, tmp_22, tmp_23, tmp_25, tmp_27, tmp_28, tmp_29, tmp_30, tmp_32, tmp_33, tmp_34, tmp_36, tmp_38, tmp_40, tmp_42, ObjectSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen.Update', tmp_43, tmp$ret$42)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$48 = [];
    return SealedClassSerializer_init_$Create$('client.fstech.hadaya.presentation.Screen', tmp, tmp_0, tmp_44, tmp$ret$48);
  };
  protoOf(Companion_37).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  var Companion_instance_43;
  function Companion_getInstance_72() {
    return Companion_instance_43;
  }
  function Screen() {
  }
  function HomeNavHost(backStack, $composer, $changed, $default) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    var backStack_0 = {_v: backStack};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-511575445);
    sourceInformation($composer_0, 'C(HomeNavHost)299@11355L12,300@11405L15,301@11463L16,302@11540L16,303@11601L33,309@11893L794,327@12714L1656,327@12693L1677,368@14397L167,368@14376L188,375@14591L164,375@14570L185,382@14782L341,382@14761L362,393@15148L27,401@15488L16,403@15538L244,403@15510L272,412@15821L36957,412@15788L36990:HomeNavHost.kt#v8axby');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | (($default & 1) === 0 && $composer_0.k31(backStack_0._v) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      $composer_0.q30();
      sourceInformation($composer_0, '295@11252L59,295@11210L101');
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 1) === 0)) {
          var tmp = get_ScreenListSaver();
          sourceInformationMarkerStart($composer_0, -1997727578, 'CC(remember):HomeNavHost.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var this_0 = $composer_0;
          // Inline function 'kotlin.let' call
          var it = this_0.i31();
          var tmp_0;
          if (false || it === Companion_getInstance().f30_1) {
            var value = HomeNavHost$lambda;
            this_0.j31(value);
            tmp_0 = value;
          } else {
            tmp_0 = it;
          }
          var tmp0_group = tmp_0;
          sourceInformationMarkerEnd($composer_0);
          backStack_0._v = rememberSaveable([], tmp, tmp0_group, $composer_0, 384);
          $dirty = $dirty & -15;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 1) === 0))
          $dirty = $dirty & -15;
      }
      $composer_0.r30();
      if (isTraceInProgress()) {
        traceEventStart(-511575445, $dirty, -1, 'client.fstech.hadaya.presentation.HomeNavHost (HomeNavHost.kt:298)');
      }
      // Inline function 'org.koin.compose.koinInject' call
      var qualifier = null;
      var scope = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -1168520582, 'CC(koinInject)88@2750L18,90@2787L73:Inject.kt#8jjlyv');
      if (!((3 & 1) === 0))
        qualifier = null;
      if (!((3 & 2) === 0))
        scope = currentKoinScope($composer_1, 0);
      sourceInformationMarkerStart($composer_1, -1961811197, 'CC(remember):Inject.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_1.k31(qualifier) | $composer_1.k31(scope));
      // Inline function 'kotlin.let' call
      var it_0 = $composer_1.i31();
      var tmp_1;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = scope.ts6(getKClass(AuthNavigator), qualifier);
        $composer_1.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp1_group = tmp_1;
      sourceInformationMarkerEnd($composer_1);
      sourceInformationMarkerEnd($composer_1);
      var authNavigator = tmp1_group;
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier_0 = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope_0 = null;
      var parameters = null;
      var $composer_2 = $composer_0;
      sourceInformationMarkerStart($composer_2, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier_0 = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_2, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp_2;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope_0 = currentKoinScope($composer_2, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(AppViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier_0, scope_0, parameters);
      sourceInformationMarkerEnd($composer_2);
      var appViewModel = tmp0;
      var language$delegate = collectAsState(appViewModel.fyj_1, null, $composer_0, 0, 1);
      var hasUnsavedChanges$delegate = collectAsState(appViewModel.jyj_1, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, -1997716436, 'CC(remember):HomeNavHost.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_1.i31();
      var tmp_3;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = mutableStateOf(null);
        this_1.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp1_group_0 = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      var pendingNavigation$delegate = tmp1_group_0;
      var tmp0_elvis_lhs_0 = lastOrNull(backStack_0._v);
      var currentKey = tmp0_elvis_lhs_0 == null ? Shopping_getInstance() : tmp0_elvis_lhs_0;
      var tmp_4;
      if (!(currentKey instanceof Update)) {
        tmp_4 = !(currentKey instanceof MugDesignerEditor);
      } else {
        tmp_4 = false;
      }
      var showNavigation = tmp_4;
      sourceInformationMarkerStart($composer_0, -1997706331, 'CC(remember):HomeNavHost.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_0.k31(currentKey);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_0.i31();
      var tmp_5;
      if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
        var tmp_6;
        var tmp_7;
        var tmp_8;
        if (currentKey instanceof Shopping) {
          tmp_8 = true;
        } else {
          var tmp_9;
          if (currentKey instanceof ProductDetails) {
            tmp_9 = true;
          } else {
            tmp_9 = currentKey instanceof BeadsProductDetails;
          }
          tmp_8 = tmp_9;
        }
        if (tmp_8) {
          tmp_7 = true;
        } else {
          var tmp_10;
          if (currentKey instanceof CustomMugDetails) {
            tmp_10 = true;
          } else {
            var tmp_11;
            if (currentKey instanceof CustomMagicMugDetails) {
              tmp_11 = true;
            } else {
              tmp_11 = currentKey instanceof Model3D;
            }
            tmp_10 = tmp_11;
          }
          tmp_7 = tmp_10;
        }
        if (tmp_7) {
          tmp_6 = Shopping_getInstance();
        } else {
          var tmp_12;
          var tmp_13;
          var tmp_14;
          if (currentKey instanceof Cart) {
            tmp_14 = true;
          } else {
            tmp_14 = currentKey instanceof Checkout;
          }
          if (tmp_14) {
            tmp_13 = true;
          } else {
            var tmp_15;
            if (currentKey instanceof OrderDetails) {
              tmp_15 = true;
            } else {
              tmp_15 = currentKey instanceof PastOrderDetails;
            }
            tmp_13 = tmp_15;
          }
          if (tmp_13) {
            tmp_12 = true;
          } else {
            var tmp_16;
            var tmp_17;
            if (currentKey instanceof EditDesign) {
              tmp_17 = true;
            } else {
              tmp_17 = currentKey instanceof EditCustomMagicMug;
            }
            if (tmp_17) {
              tmp_16 = true;
            } else {
              var tmp_18;
              if (currentKey instanceof CartNormalProductDetails) {
                tmp_18 = true;
              } else {
                var tmp_19;
                if (currentKey instanceof CartMugProductDetails) {
                  tmp_19 = true;
                } else {
                  tmp_19 = currentKey instanceof CartMagicMugProductDetails;
                }
                tmp_18 = tmp_19;
              }
              tmp_16 = tmp_18;
            }
            tmp_12 = tmp_16;
          }
          if (tmp_12) {
            tmp_6 = Cart_getInstance();
          } else {
            var tmp_20;
            var tmp_21;
            if (currentKey instanceof Profile_0) {
              tmp_21 = true;
            } else {
              var tmp_22;
              if (currentKey instanceof OrderHistory) {
                tmp_22 = true;
              } else {
                tmp_22 = currentKey instanceof Friends;
              }
              tmp_21 = tmp_22;
            }
            if (tmp_21) {
              tmp_20 = true;
            } else {
              var tmp_23;
              if (currentKey instanceof Favorites) {
                tmp_23 = true;
              } else {
                var tmp_24;
                if (currentKey instanceof Coupons) {
                  tmp_24 = true;
                } else {
                  tmp_24 = currentKey instanceof StockReminders;
                }
                tmp_23 = tmp_24;
              }
              tmp_20 = tmp_23;
            }
            if (tmp_20) {
              tmp_6 = Profile_getInstance();
            } else {
              tmp_6 = Shopping_getInstance();
            }
          }
        }
        var value_2 = tmp_6;
        tmp0_0.j31(value_2);
        tmp_5 = value_2;
      } else {
        tmp_5 = it_2;
      }
      var tmp2_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      var selectedTab = tmp2_group;
      sourceInformationMarkerStart($composer_0, -1997679197, 'CC(remember):HomeNavHost.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!($composer_0.q31(appViewModel) | (($dirty & 14 ^ 6) > 4 && $composer_0.k31(backStack_0._v) || ($dirty & 6) === 4));
      // Inline function 'kotlin.let' call
      var it_3 = tmp0_1.i31();
      var tmp_25;
      if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = HomeNavHost$slambda_0(appViewModel, backStack_0, null);
        tmp0_1.j31(value_3);
        tmp_25 = value_3;
      } else {
        tmp_25 = it_3;
      }
      var tmp3_group = tmp_25;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(Unit_instance, tmp3_group, $composer_0, 6);
      sourceInformationMarkerStart($composer_0, -1997626830, 'CC(remember):HomeNavHost.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = !!($composer_0.q31(appViewModel) | (($dirty & 14 ^ 6) > 4 && $composer_0.k31(backStack_0._v) || ($dirty & 6) === 4));
      // Inline function 'kotlin.let' call
      var it_4 = tmp0_2.i31();
      var tmp_26;
      if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = HomeNavHost$slambda_2(appViewModel, backStack_0, null);
        tmp0_2.j31(value_4);
        tmp_26 = value_4;
      } else {
        tmp_26 = it_4;
      }
      var tmp4_group = tmp_26;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(Unit_instance, tmp4_group, $composer_0, 6);
      sourceInformationMarkerStart($composer_0, -1997620625, 'CC(remember):HomeNavHost.kt#9igjgp');
      var tmp0_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = !!($composer_0.q31(appViewModel) | (($dirty & 14 ^ 6) > 4 && $composer_0.k31(backStack_0._v) || ($dirty & 6) === 4));
      // Inline function 'kotlin.let' call
      var it_5 = tmp0_3.i31();
      var tmp_27;
      if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
        var value_5 = HomeNavHost$slambda_4(appViewModel, backStack_0, null);
        tmp0_3.j31(value_5);
        tmp_27 = value_5;
      } else {
        tmp_27 = it_5;
      }
      var tmp5_group = tmp_27;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(Unit_instance, tmp5_group, $composer_0, 6);
      sourceInformationMarkerStart($composer_0, -1997614336, 'CC(remember):HomeNavHost.kt#9igjgp');
      var tmp0_4 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_4 = !!($composer_0.q31(appViewModel) | (($dirty & 14 ^ 6) > 4 && $composer_0.k31(backStack_0._v) || ($dirty & 6) === 4));
      // Inline function 'kotlin.let' call
      var it_6 = tmp0_4.i31();
      var tmp_28;
      if (invalid_4 || it_6 === Companion_getInstance().f30_1) {
        var value_6 = HomeNavHost$slambda_6(appViewModel, backStack_0, null);
        tmp0_4.j31(value_6);
        tmp_28 = value_6;
      } else {
        tmp_28 = it_6;
      }
      var tmp6_group = tmp_28;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(Unit_instance, tmp6_group, $composer_0, 6);
      var adaptiveInfo = currentWindowAdaptiveInfo(false, $composer_0, 0, 1);
      var isDesktop = adaptiveInfo.bxm_1.xxl(840);
      var tmp_29;
      if (isDesktop) {
        tmp_29 = Companion_getInstance_10().txm_1;
      } else {
        tmp_29 = Companion_getInstance_10().sxm_1;
      }
      var layoutType = tmp_29;
      var currentUser$delegate = collectAsState(appViewModel.eyj_1, null, $composer_0, 0, 1);
      var tmp_30 = HomeNavHost$lambda_4(currentUser$delegate);
      sourceInformationMarkerStart($composer_0, -1997590241, 'CC(remember):HomeNavHost.kt#9igjgp');
      var tmp0_5 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_5 = !!($composer_0.k31(currentUser$delegate) | (($dirty & 14 ^ 6) > 4 && $composer_0.k31(backStack_0._v) || ($dirty & 6) === 4));
      // Inline function 'kotlin.let' call
      var it_7 = tmp0_5.i31();
      var tmp_31;
      if (invalid_5 || it_7 === Companion_getInstance().f30_1) {
        var value_7 = HomeNavHost$slambda_8(backStack_0, currentUser$delegate, null);
        tmp0_5.j31(value_7);
        tmp_31 = value_7;
      } else {
        tmp_31 = it_7;
      }
      var tmp7_group = tmp_31;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_30, tmp7_group, $composer_0, 0);
      var tmp_32 = HomeNavHost$lambda_0(language$delegate);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(1616852845, true, HomeNavHost$lambda_5(appViewModel, pendingNavigation$delegate, showNavigation, layoutType, selectedTab, backStack_0, hasUnsavedChanges$delegate, authNavigator, language$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_6 = $composer_3.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_8 = $composer_3.i31();
      var tmp_33;
      if (invalid_6 || it_8 === Companion_getInstance().f30_1) {
        var value_8 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_3.j31(value_8);
        tmp_33 = value_8;
      } else {
        tmp_33 = it_8;
      }
      var tmp$ret$39 = tmp_33;
      HadayaTheme(false, tmp_32, tmp$ret$39, $composer_0, 384, 1);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp8_safe_receiver = $composer_0.t30();
    if (tmp8_safe_receiver == null)
      null;
    else {
      tmp8_safe_receiver.p3c(HomeNavHost$lambda_6(backStack_0, $changed, $default));
    }
  }
  function ComposableSingletons$HomeNavHostKt$lambda$27040361$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C446@17352L35,446@17305L83:HomeNavHost.kt#v8axby');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(27040361, $changed, -1, 'client.fstech.hadaya.presentation.ComposableSingletons$HomeNavHostKt.lambda$27040361.<anonymous> (HomeNavHost.kt:446)');
      }
      var tmp = get_Store(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_nav_shop(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$HomeNavHostKt$lambda$_200475322$lambda_tdtrly($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C447@17431L35,447@17426L41:HomeNavHost.kt#v8axby');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-200475322, $changed, -1, 'client.fstech.hadaya.presentation.ComposableSingletons$HomeNavHostKt.lambda$-200475322.<anonymous> (HomeNavHost.kt:447)');
      }
      var tmp = stringResource(get_nav_shop(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$HomeNavHostKt$lambda$_307279342$lambda_6jxwsi($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C469@18575L35,469@18521L90:HomeNavHost.kt#v8axby');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-307279342, $changed, -1, 'client.fstech.hadaya.presentation.ComposableSingletons$HomeNavHostKt.lambda$-307279342.<anonymous> (HomeNavHost.kt:469)');
      }
      var tmp = get_ShoppingCart(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_nav_cart(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$HomeNavHostKt$lambda$93481391$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C470@18654L35,470@18649L41:HomeNavHost.kt#v8axby');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(93481391, $changed, -1, 'client.fstech.hadaya.presentation.ComposableSingletons$HomeNavHostKt.lambda$93481391.<anonymous> (HomeNavHost.kt:470)');
      }
      var tmp = stringResource(get_nav_cart(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$HomeNavHostKt$lambda$893862001$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C492@19807L38,492@19759L87:HomeNavHost.kt#v8axby');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(893862001, $changed, -1, 'client.fstech.hadaya.presentation.ComposableSingletons$HomeNavHostKt.lambda$893862001.<anonymous> (HomeNavHost.kt:492)');
      }
      var tmp = get_Person(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_nav_profile(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$HomeNavHostKt$lambda$1294622734$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C493@19889L38,493@19884L44:HomeNavHost.kt#v8axby');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1294622734, $changed, -1, 'client.fstech.hadaya.presentation.ComposableSingletons$HomeNavHostKt.lambda$1294622734.<anonymous> (HomeNavHost.kt:493)');
      }
      var tmp = stringResource(get_nav_profile(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableLambda$invoke$ref_0(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function ComposableSingletons$HomeNavHostKt$lambda$_1259352135$lambda_az9f8r(it, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1001@47413L14:HomeNavHost.kt#v8axby');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1259352135, $changed, -1, 'client.fstech.hadaya.presentation.ComposableSingletons$HomeNavHostKt.lambda$-1259352135.<anonymous> (HomeNavHost.kt:1001)');
      }
      UpdateScreen($composer_0, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableLambda$invoke$ref_1(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function ComposableSingletons$HomeNavHostKt$lambda$_975671578$lambda_g1y6po($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1022@48583L18:HomeNavHost.kt#v8axby');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-975671578, $changed, -1, 'client.fstech.hadaya.presentation.ComposableSingletons$HomeNavHostKt.lambda$-975671578.<anonymous> (HomeNavHost.kt:1022)');
      }
      var tmp = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_0 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextOverflow___init__impl__obguoe(0);
      Text('Go to Home', null, tmp, null, tmp_0, null, null, null, tmp_1, null, null, tmp_2, tmp_3, false, 0, 0, null, null, $composer_0, 6, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$HomeNavHostKt() {
    ComposableSingletons$HomeNavHostKt_instance = this;
    var tmp = this;
    tmp.y10c_1 = ComposableLambda$invoke$ref(composableLambdaInstance(27040361, false, ComposableSingletons$HomeNavHostKt$lambda$27040361$lambda));
    var tmp_0 = this;
    tmp_0.z10c_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-200475322, false, ComposableSingletons$HomeNavHostKt$lambda$_200475322$lambda_tdtrly));
    var tmp_1 = this;
    tmp_1.a10d_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-307279342, false, ComposableSingletons$HomeNavHostKt$lambda$_307279342$lambda_6jxwsi));
    var tmp_2 = this;
    tmp_2.b10d_1 = ComposableLambda$invoke$ref(composableLambdaInstance(93481391, false, ComposableSingletons$HomeNavHostKt$lambda$93481391$lambda));
    var tmp_3 = this;
    tmp_3.c10d_1 = ComposableLambda$invoke$ref(composableLambdaInstance(893862001, false, ComposableSingletons$HomeNavHostKt$lambda$893862001$lambda));
    var tmp_4 = this;
    tmp_4.d10d_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1294622734, false, ComposableSingletons$HomeNavHostKt$lambda$1294622734$lambda));
    var tmp_5 = this;
    tmp_5.e10d_1 = ComposableLambda$invoke$ref_0(composableLambdaInstance(-1259352135, false, ComposableSingletons$HomeNavHostKt$lambda$_1259352135$lambda_az9f8r));
    var tmp_6 = this;
    tmp_6.f10d_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-975671578, false, ComposableSingletons$HomeNavHostKt$lambda$_975671578$lambda_g1y6po));
  }
  var ComposableSingletons$HomeNavHostKt_instance;
  function ComposableSingletons$HomeNavHostKt_getInstance() {
    if (ComposableSingletons$HomeNavHostKt_instance == null)
      new ComposableSingletons$HomeNavHostKt();
    return ComposableSingletons$HomeNavHostKt_instance;
  }
  function ScreenStateSaver$lambda($this$Saver, it) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    var tmp;
    try {
      var tmp0 = Default_getInstance();
      // Inline function 'kotlinx.serialization.json.Json.encodeToString' call
      var value = it.u1();
      // Inline function 'kotlinx.serialization.serializer' call
      var this_0 = tmp0.c75();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_1 = serializer(this_0, createKType(getKClass(Screen), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
      tmp = tmp0.b72(tmp$ret$1, value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var e = $p;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function ScreenStateSaver$lambda_0(it) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    var tmp;
    try {
      // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
      var this_0 = Default_getInstance();
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.c75();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(Screen), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      var tmp$ret$0 = this_0.c72(tmp$ret$1, it);
      tmp = mutableStateOf(tmp$ret$0);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var e = $p;
        tmp_0 = mutableStateOf(Shopping_getInstance());
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function ScreenListSaver$lambda($this$Saver, it) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    var tmp;
    try {
      var tmp0 = Default_getInstance();
      // Inline function 'kotlinx.serialization.json.Json.encodeToString' call
      var value = it.s5c();
      // Inline function 'kotlinx.serialization.serializer' call
      var this_0 = tmp0.c75();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_1 = serializer(this_0, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Screen), arrayOf([]), false))]), false));
      var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
      tmp = tmp0.b72(tmp$ret$1, value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var e = $p;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function ScreenListSaver$lambda_0(it) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    var tmp;
    try {
      // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
      var this_0 = Default_getInstance();
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.c75();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Screen), arrayOf([]), false))]), false));
      var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      var tmp$ret$0 = this_0.c72(tmp$ret$1, it);
      tmp = toMutableStateList(tmp$ret$0);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var e = $p;
        tmp_0 = mutableStateListOf([Shopping_getInstance()]);
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function HomeNavHost$lambda() {
    _init_properties_HomeNavHost_kt__sz1o0q();
    return mutableStateListOf([Shopping_getInstance()]);
  }
  function HomeNavHost$lambda_0($language$delegate) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('language', KProperty0, false);
    return $language$delegate.u1();
  }
  function HomeNavHost$lambda_1($hasUnsavedChanges$delegate) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('hasUnsavedChanges', KProperty0, false);
    return $hasUnsavedChanges$delegate.u1();
  }
  function HomeNavHost$lambda_2($pendingNavigation$delegate) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('pendingNavigation', KMutableProperty0, true);
    return $pendingNavigation$delegate.u1();
  }
  function HomeNavHost$lambda_3($pendingNavigation$delegate, _set____db54di) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('pendingNavigation', KMutableProperty0, true);
    $pendingNavigation$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_1(function_0) {
    this.g10d_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).a1v = function (value, $completion) {
    return this.g10d_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).q3 = function () {
    return this.g10d_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function HomeNavHost$slambda$slambda($backStack, $appViewModel, resultContinuation) {
    this.p10d_1 = $backStack;
    this.q10d_1 = $appViewModel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HomeNavHost$slambda$slambda).s10d = function (product, $completion) {
    var tmp = this.t10d(product, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HomeNavHost$slambda$slambda).ja = function (p1, $completion) {
    return this.s10d(p1 instanceof Product ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HomeNavHost$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0 = this.p10d_1._v;
          var tmp$ret$0;
          l$ret$1: do {
            var tmp_0;
            if (isInterface(tmp0, Collection)) {
              tmp_0 = tmp0.r();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$0 = false;
              break l$ret$1;
            }
            var _iterator__ex2g4s = tmp0.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              var tmp_1;
              var tmp_2;
              var tmp_3;
              var tmp_4;
              if (element instanceof ProductDetails) {
                tmp_4 = equals(element.u108_1.nzt_1, this.r10d_1.nzt_1);
              } else {
                tmp_4 = false;
              }
              if (tmp_4) {
                tmp_3 = true;
              } else {
                var tmp_5;
                if (element instanceof CustomMugDetails) {
                  tmp_5 = equals(element.x109_1.nzt_1, this.r10d_1.nzt_1);
                } else {
                  tmp_5 = false;
                }
                tmp_3 = tmp_5;
              }
              if (tmp_3) {
                tmp_2 = true;
              } else {
                var tmp_6;
                if (element instanceof CustomMagicMugDetails) {
                  tmp_6 = equals(element.l10a_1.nzt_1, this.r10d_1.nzt_1);
                } else {
                  tmp_6 = false;
                }
                tmp_2 = tmp_6;
              }
              if (tmp_2) {
                tmp_1 = true;
              } else {
                var tmp_7;
                if (element instanceof BeadsProductDetails) {
                  tmp_7 = equals(element.i109_1.nzt_1, this.r10d_1.nzt_1);
                } else {
                  tmp_7 = false;
                }
                tmp_1 = tmp_7;
              }
              if (tmp_1) {
                tmp$ret$0 = true;
                break l$ret$1;
              }
            }
            tmp$ret$0 = false;
          }
           while (false);
          var isAlreadyOpen = tmp$ret$0;
          if (isAlreadyOpen) {
            this.q10d_1.m108();
            return Unit_instance;
          }
          var tmp0_subject = this.r10d_1.bzu_1;
          switch (tmp0_subject == null ? -1 : tmp0_subject.a1_1) {
            case 4:
              this.p10d_1._v.zz(new CustomMagicMugDetails(this.r10d_1));
              break;
            case 1:
            case 2:
            case 3:
              this.p10d_1._v.zz(new CustomMugDetails(this.r10d_1));
              break;
            case 5:
              this.p10d_1._v.zz(new BeadsProductDetails(this.r10d_1));
              break;
            case 0:
              this.p10d_1._v.zz(new ProductDetails(this.r10d_1));
              break;
            default:
              this.p10d_1._v.zz(new ProductDetails(this.r10d_1));
              break;
          }
          this.q10d_1.m108();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(HomeNavHost$slambda$slambda).t10d = function (product, completion) {
    var i = new HomeNavHost$slambda$slambda(this.p10d_1, this.q10d_1, completion);
    i.r10d_1 = product;
    return i;
  };
  function HomeNavHost$slambda$slambda_0($backStack, $appViewModel, resultContinuation) {
    var i = new HomeNavHost$slambda$slambda($backStack, $appViewModel, resultContinuation);
    return constructCallableReference(function (product, $completion) {
      return i.s10d(product, $completion);
    }, 1);
  }
  function HomeNavHost$slambda($appViewModel, $backStack, resultContinuation) {
    this.c10e_1 = $appViewModel;
    this.d10e_1 = $backStack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HomeNavHost$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HomeNavHost$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HomeNavHost$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = HomeNavHost$slambda$slambda_0(this.d10e_1, this.c10e_1, null);
            suspendResult = this.c10e_1.lyj_1.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_1(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HomeNavHost$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new HomeNavHost$slambda(this.c10e_1, this.d10e_1, completion);
    i.e10e_1 = $this$LaunchedEffect;
    return i;
  };
  function HomeNavHost$slambda_0($appViewModel, $backStack, resultContinuation) {
    var i = new HomeNavHost$slambda($appViewModel, $backStack, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function HomeNavHost$slambda$slambda_1($backStack, $appViewModel, resultContinuation) {
    this.n10e_1 = $backStack;
    this.o10e_1 = $appViewModel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HomeNavHost$slambda$slambda_1).q10e = function (order, $completion) {
    var tmp = this.r10e(order, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HomeNavHost$slambda$slambda_1).ja = function (p1, $completion) {
    return this.q10e(p1 instanceof Order ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HomeNavHost$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.n10e_1._v.zz(new OrderDetails(this.p10e_1));
          this.o10e_1.m108();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(HomeNavHost$slambda$slambda_1).r10e = function (order, completion) {
    var i = new HomeNavHost$slambda$slambda_1(this.n10e_1, this.o10e_1, completion);
    i.p10e_1 = order;
    return i;
  };
  function HomeNavHost$slambda$slambda_2($backStack, $appViewModel, resultContinuation) {
    var i = new HomeNavHost$slambda$slambda_1($backStack, $appViewModel, resultContinuation);
    return constructCallableReference(function (order, $completion) {
      return i.q10e(order, $completion);
    }, 1);
  }
  function HomeNavHost$slambda_1($appViewModel, $backStack, resultContinuation) {
    this.a10f_1 = $appViewModel;
    this.b10f_1 = $backStack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HomeNavHost$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HomeNavHost$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HomeNavHost$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = HomeNavHost$slambda$slambda_2(this.b10f_1, this.a10f_1, null);
            suspendResult = this.a10f_1.nyj_1.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_1(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HomeNavHost$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new HomeNavHost$slambda_1(this.a10f_1, this.b10f_1, completion);
    i.c10f_1 = $this$LaunchedEffect;
    return i;
  };
  function HomeNavHost$slambda_2($appViewModel, $backStack, resultContinuation) {
    var i = new HomeNavHost$slambda_1($appViewModel, $backStack, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function HomeNavHost$slambda$slambda_3($backStack, $appViewModel, resultContinuation) {
    this.l10f_1 = $backStack;
    this.m10f_1 = $appViewModel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HomeNavHost$slambda$slambda_3).pyo = function (message, $completion) {
    var tmp = this.um9(message, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HomeNavHost$slambda$slambda_3).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HomeNavHost$slambda$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.l10f_1._v.zz(new Error_0(this.n10f_1));
          this.m10f_1.m108();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(HomeNavHost$slambda$slambda_3).um9 = function (message, completion) {
    var i = new HomeNavHost$slambda$slambda_3(this.l10f_1, this.m10f_1, completion);
    i.n10f_1 = message;
    return i;
  };
  function HomeNavHost$slambda$slambda_4($backStack, $appViewModel, resultContinuation) {
    var i = new HomeNavHost$slambda$slambda_3($backStack, $appViewModel, resultContinuation);
    return constructCallableReference(function (message, $completion) {
      return i.pyo(message, $completion);
    }, 1);
  }
  function HomeNavHost$slambda_3($appViewModel, $backStack, resultContinuation) {
    this.w10f_1 = $appViewModel;
    this.x10f_1 = $backStack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HomeNavHost$slambda_3).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HomeNavHost$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HomeNavHost$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = HomeNavHost$slambda$slambda_4(this.x10f_1, this.w10f_1, null);
            suspendResult = this.w10f_1.pyj_1.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_1(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HomeNavHost$slambda_3).q24 = function ($this$LaunchedEffect, completion) {
    var i = new HomeNavHost$slambda_3(this.w10f_1, this.x10f_1, completion);
    i.y10f_1 = $this$LaunchedEffect;
    return i;
  };
  function HomeNavHost$slambda_4($appViewModel, $backStack, resultContinuation) {
    var i = new HomeNavHost$slambda_3($appViewModel, $backStack, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function HomeNavHost$slambda$slambda_5($backStack, resultContinuation) {
    this.h10g_1 = $backStack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HomeNavHost$slambda$slambda_5).j10g = function (recoveryUrl, $completion) {
    var tmp = this.hwm(recoveryUrl, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HomeNavHost$slambda$slambda_5).ja = function (p1, $completion) {
    return this.j10g((p1 == null ? true : typeof p1 === 'string') ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HomeNavHost$slambda$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0 = lastOrNull(this.h10g_1._v);
          if (!(tmp_0 instanceof Auth_0)) {
            this.h10g_1._v.zz(new Auth_0(!(this.i10g_1 == null) ? 'reset-password' : 'login', this.i10g_1));
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(HomeNavHost$slambda$slambda_5).hwm = function (recoveryUrl, completion) {
    var i = new HomeNavHost$slambda$slambda_5(this.h10g_1, completion);
    i.i10g_1 = recoveryUrl;
    return i;
  };
  function HomeNavHost$slambda$slambda_6($backStack, resultContinuation) {
    var i = new HomeNavHost$slambda$slambda_5($backStack, resultContinuation);
    return constructCallableReference(function (recoveryUrl, $completion) {
      return i.j10g(recoveryUrl, $completion);
    }, 1);
  }
  function HomeNavHost$slambda_5($appViewModel, $backStack, resultContinuation) {
    this.s10g_1 = $appViewModel;
    this.t10g_1 = $backStack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HomeNavHost$slambda_5).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HomeNavHost$slambda_5).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HomeNavHost$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = HomeNavHost$slambda$slambda_6(this.t10g_1, null);
            suspendResult = this.s10g_1.ryj_1.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_1(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HomeNavHost$slambda_5).q24 = function ($this$LaunchedEffect, completion) {
    var i = new HomeNavHost$slambda_5(this.s10g_1, this.t10g_1, completion);
    i.u10g_1 = $this$LaunchedEffect;
    return i;
  };
  function HomeNavHost$slambda_6($appViewModel, $backStack, resultContinuation) {
    var i = new HomeNavHost$slambda_5($appViewModel, $backStack, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function HomeNavHost$lambda_4($currentUser$delegate) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('currentUser', KProperty0, false);
    return $currentUser$delegate.u1();
  }
  function HomeNavHost$slambda_7($backStack, $currentUser$delegate, resultContinuation) {
    this.d10h_1 = $backStack;
    this.e10h_1 = $currentUser$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HomeNavHost$slambda_7).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HomeNavHost$slambda_7).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HomeNavHost$slambda_7).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0;
          if (!(HomeNavHost$lambda_4(this.e10h_1) == null)) {
            var tmp_1 = lastOrNull(this.d10h_1._v);
            tmp_0 = tmp_1 instanceof Auth_0;
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            this.d10h_1._v.h3(this.d10h_1._v.n1() - 1 | 0);
            if (this.d10h_1._v.r()) {
              this.d10h_1._v.zz(Shopping_getInstance());
            }
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(HomeNavHost$slambda_7).q24 = function ($this$LaunchedEffect, completion) {
    var i = new HomeNavHost$slambda_7(this.d10h_1, this.e10h_1, completion);
    i.f10h_1 = $this$LaunchedEffect;
    return i;
  };
  function HomeNavHost$slambda_8($backStack, $currentUser$delegate, resultContinuation) {
    var i = new HomeNavHost$slambda_7($backStack, $currentUser$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function HomeNavHost$lambda$lambda($appViewModel, $pendingNavigation$delegate) {
    return function () {
      $appViewModel.l108(false);
      var tmp0_safe_receiver = HomeNavHost$lambda_2($pendingNavigation$delegate);
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver();
      HomeNavHost$lambda_3($pendingNavigation$delegate, null);
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda_0($pendingNavigation$delegate) {
    return function () {
      HomeNavHost$lambda_3($pendingNavigation$delegate, null);
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda($selectedTab, $backStack) {
    return function () {
      var tmp;
      if (!equals($selectedTab, Shopping_getInstance())) {
        $backStack._v.c3();
        $backStack._v.zz(Shopping_getInstance());
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda($selectedTab, $backStack, $hasUnsavedChanges$delegate, $pendingNavigation$delegate) {
    return function () {
      var navAction = HomeNavHost$lambda$lambda$lambda$lambda$lambda($selectedTab, $backStack);
      var tmp;
      if (HomeNavHost$lambda_1($hasUnsavedChanges$delegate)) {
        HomeNavHost$lambda_3($pendingNavigation$delegate, navAction);
        tmp = Unit_instance;
      } else {
        tmp = navAction();
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_0($selectedTab, $backStack) {
    return function () {
      var tmp;
      if (!equals($selectedTab, Cart_getInstance())) {
        var tmp0 = $backStack._v;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_0;
          if (isInterface(tmp0, Collection)) {
            tmp_0 = tmp0.r();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            if (element instanceof Cart) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        if (tmp$ret$0) {
          while (!equals(lastOrNull($backStack._v), Cart_getInstance())) {
            $backStack._v.h3($backStack._v.n1() - 1 | 0);
          }
        } else {
          $backStack._v.zz(Cart_getInstance());
        }
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda_0($selectedTab, $backStack, $hasUnsavedChanges$delegate, $pendingNavigation$delegate) {
    return function () {
      var navAction = HomeNavHost$lambda$lambda$lambda$lambda$lambda_0($selectedTab, $backStack);
      var tmp;
      if (HomeNavHost$lambda_1($hasUnsavedChanges$delegate)) {
        HomeNavHost$lambda_3($pendingNavigation$delegate, navAction);
        tmp = Unit_instance;
      } else {
        tmp = navAction();
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_1($selectedTab, $backStack) {
    return function () {
      var tmp;
      if (!equals($selectedTab, Profile_getInstance())) {
        var tmp0 = $backStack._v;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_0;
          if (isInterface(tmp0, Collection)) {
            tmp_0 = tmp0.r();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            if (element instanceof Profile_0) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        if (tmp$ret$0) {
          while (!equals(lastOrNull($backStack._v), Profile_getInstance())) {
            $backStack._v.h3($backStack._v.n1() - 1 | 0);
          }
        } else {
          $backStack._v.zz(Profile_getInstance());
        }
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda_1($selectedTab, $backStack, $hasUnsavedChanges$delegate, $pendingNavigation$delegate) {
    return function () {
      var navAction = HomeNavHost$lambda$lambda$lambda$lambda$lambda_1($selectedTab, $backStack);
      var tmp;
      if (HomeNavHost$lambda_1($hasUnsavedChanges$delegate)) {
        HomeNavHost$lambda_3($pendingNavigation$delegate, navAction);
        tmp = Unit_instance;
      } else {
        tmp = navAction();
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda($selectedTab, $backStack, $hasUnsavedChanges$delegate, $pendingNavigation$delegate) {
    return function ($this$NavigationSuiteScaffold) {
      var tmp = equals($selectedTab, Shopping_getInstance());
      $this$NavigationSuiteScaffold.jxn(tmp, HomeNavHost$lambda$lambda$lambda$lambda($selectedTab, $backStack, $hasUnsavedChanges$delegate, $pendingNavigation$delegate), ComposableSingletons$HomeNavHostKt_getInstance().y10c_1, VOID, VOID, ComposableSingletons$HomeNavHostKt_getInstance().z10c_1);
      var tmp_0 = equals($selectedTab, Cart_getInstance());
      $this$NavigationSuiteScaffold.jxn(tmp_0, HomeNavHost$lambda$lambda$lambda$lambda_0($selectedTab, $backStack, $hasUnsavedChanges$delegate, $pendingNavigation$delegate), ComposableSingletons$HomeNavHostKt_getInstance().a10d_1, VOID, VOID, ComposableSingletons$HomeNavHostKt_getInstance().b10d_1);
      var tmp_1 = equals($selectedTab, Profile_getInstance());
      $this$NavigationSuiteScaffold.jxn(tmp_1, HomeNavHost$lambda$lambda$lambda$lambda_1($selectedTab, $backStack, $hasUnsavedChanges$delegate, $pendingNavigation$delegate), ComposableSingletons$HomeNavHostKt_getInstance().c10d_1, VOID, VOID, ComposableSingletons$HomeNavHostKt_getInstance().d10d_1);
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda_2($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda_3($this$NavDisplay) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    var tmp0_animationSpec = tween(300, VOID, get_FastOutSlowInEasing());
    var tmp = slideInHorizontally(tmp0_animationSpec, HomeNavHost$lambda$lambda$lambda$lambda$lambda_2).rf3(fadeIn(tween(300)));
    var tmp1_animationSpec = tween(300, VOID, get_FastOutSlowInEasing());
    return togetherWith(tmp, slideOutHorizontally(tmp1_animationSpec, HomeNavHost$lambda$lambda$lambda$lambda$lambda_3).jf4(fadeOut(tween(300))));
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_2(it) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    return it;
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_3(it) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    return -it | 0;
  }
  function HomeNavHost$lambda$lambda$lambda$lambda_4($this$NavDisplay) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    var tmp0_animationSpec = tween(300, VOID, get_FastOutSlowInEasing());
    var tmp = slideInHorizontally(tmp0_animationSpec, HomeNavHost$lambda$lambda$lambda$lambda$lambda_4).rf3(fadeIn(tween(300)));
    var tmp1_animationSpec = tween(300, VOID, get_FastOutSlowInEasing());
    return togetherWith(tmp, slideOutHorizontally(tmp1_animationSpec, HomeNavHost$lambda$lambda$lambda$lambda$lambda_5).jf4(fadeOut(tween(300))));
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_4(it) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    return -it | 0;
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_5(it) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    return it;
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda($backStack) {
    return function () {
      $backStack._v.zz(Profile_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_0($backStack) {
    return function (product) {
      var tmp0_subject = product.bzu_1;
      switch (tmp0_subject == null ? -1 : tmp0_subject.a1_1) {
        case 4:
          $backStack._v.zz(new CustomMagicMugDetails(product));
          break;
        case 1:
          $backStack._v.zz(new CustomMugDetails(product));
          break;
        case 5:
          $backStack._v.zz(new BeadsProductDetails(product));
          break;
        case 0:
          $backStack._v.zz(new ProductDetails(product));
          break;
        default:
          $backStack._v.zz(Update_getInstance());
          break;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_1($backStack) {
    return function () {
      $backStack._v.zz(Cart_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_2($backStack) {
    return function (productId) {
      var tmp = $backStack._v;
      tmp.zz(new Model3D(productId == null ? new Long(0, 0) : productId));
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_6($backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C538@22176L109,541@22352L1538,568@23947L106,571@24115L151,537@22104L2196:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1581751002, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:537)');
        }
        sourceInformationMarkerStart($composer_0, -355706361, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -355699300, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_0($backStack);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -355649692, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_2 = $composer_0.i31();
        var tmp_2;
        if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
          var value_1 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_1($backStack);
          $composer_0.j31(value_1);
          tmp_2 = value_1;
        } else {
          tmp_2 = it_2;
        }
        var tmp2_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -355644271, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_3 = $composer_0.i31();
        var tmp_3;
        if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
          var value_2 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_2($backStack);
          $composer_0.j31(value_2);
          tmp_3 = value_2;
        } else {
          tmp_3 = it_3;
        }
        var tmp3_group = tmp_3;
        sourceInformationMarkerEnd($composer_0);
        ShoppingRoot(tmp0_group, tmp1_group, tmp2_group, tmp3_group, $composer_0, 0);
        var tmp_4;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_4 = Unit_instance;
        }
        tmp = tmp_4;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_3($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_4($authNavigator) {
    return function () {
      $authNavigator.g10h();
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_5() {
    _init_properties_HomeNavHost_kt__sz1o0q();
    return Unit_instance;
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_6($backStack) {
    return function () {
      $backStack._v.zz(OrderHistory_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_7($backStack) {
    return function () {
      $backStack._v.zz(Favorites_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_8($backStack) {
    return function () {
      $backStack._v.zz(Coupons_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_9($backStack) {
    return function () {
      $backStack._v.zz(StockReminders_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_10($backStack) {
    return function () {
      $backStack._v.zz(AccountManagement_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_7($backStack, $authNavigator) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C581@24538L230,586@24817L114,589@24991L112,592@25168L114,595@25344L111,598@25515L109,601@25691L116,604@25877L119,580@24478L1552:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1760949073, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:580)');
        }
        sourceInformationMarkerStart($composer_0, 54947767, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_3($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 54956579, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31($authNavigator);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_4($authNavigator);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 54962145, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_2 = $composer_0.i31();
        var tmp_2;
        if (false || it_2 === Companion_getInstance().f30_1) {
          var value_1 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_5;
          $composer_0.j31(value_1);
          tmp_2 = value_1;
        } else {
          tmp_2 = it_2;
        }
        var tmp2_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 54967811, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_3 = $composer_0.i31();
        var tmp_3;
        if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
          var value_2 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_6($backStack);
          $composer_0.j31(value_2);
          tmp_3 = value_2;
        } else {
          tmp_3 = it_3;
        }
        var tmp3_group = tmp_3;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 54973440, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_0.i31();
        var tmp_4;
        if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
          var value_3 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_7($backStack);
          $composer_0.j31(value_3);
          tmp_4 = value_3;
        } else {
          tmp_4 = it_4;
        }
        var tmp4_group = tmp_4;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 54978910, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_5 = $composer_0.i31();
        var tmp_5;
        if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
          var value_4 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_8($backStack);
          $composer_0.j31(value_4);
          tmp_5 = value_4;
        } else {
          tmp_5 = it_5;
        }
        var tmp5_group = tmp_5;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 54984549, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_6 = $composer_0.i31();
        var tmp_6;
        if (invalid_4 || it_6 === Companion_getInstance().f30_1) {
          var value_5 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_9($backStack);
          $composer_0.j31(value_5);
          tmp_6 = value_5;
        } else {
          tmp_6 = it_6;
        }
        var tmp6_group = tmp_6;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 54990504, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_7 = $composer_0.i31();
        var tmp_7;
        if (invalid_5 || it_7 === Companion_getInstance().f30_1) {
          var value_6 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_10($backStack);
          $composer_0.j31(value_6);
          tmp_7 = value_6;
        } else {
          tmp_7 = it_7;
        }
        var tmp7_group = tmp_7;
        sourceInformationMarkerEnd($composer_0);
        ProfileScreen(tmp0_group, tmp1_group, tmp2_group, tmp3_group, tmp4_group, tmp5_group, tmp6_group, tmp7_group, $composer_0, 384, 0);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_11($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_12($backStack) {
    return function (product) {
      var tmp0_subject = product.bzu_1;
      switch (tmp0_subject == null ? -1 : tmp0_subject.a1_1) {
        case 4:
          $backStack._v.zz(new CustomMagicMugDetails(product));
          break;
        case 1:
          $backStack._v.zz(new CustomMugDetails(product));
          break;
        case 5:
          $backStack._v.zz(new BeadsProductDetails(product));
          break;
        case 0:
          $backStack._v.zz(new ProductDetails(product));
          break;
        default:
          $backStack._v.zz(Update_getInstance());
          break;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_8($backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C614@26272L66,615@26405L1538,613@26210L1767:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2028493970, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:613)');
        }
        sourceInformationMarkerStart($composer_0, -532444076, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_11($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -532438348, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_12($backStack);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        FavoritesScreen(tmp0_group, tmp1_group, $composer_0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_13($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_9($backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C649@28215L66,648@28155L160:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1998928429, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:648)');
        }
        sourceInformationMarkerStart($composer_0, -1119835883, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_13($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        CouponsScreen(tmp0_group, $composer_0, 0);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_14($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_15($backStack) {
    return function (product) {
      var tmp0_subject = product.bzu_1;
      switch (tmp0_subject == null ? -1 : tmp0_subject.a1_1) {
        case 4:
          $backStack._v.zz(new CustomMagicMugDetails(product));
          break;
        case 1:
          $backStack._v.zz(new CustomMugDetails(product));
          break;
        case 5:
          $backStack._v.zz(new BeadsProductDetails(product));
          break;
        case 0:
          $backStack._v.zz(new ProductDetails(product));
          break;
        default:
          $backStack._v.zz(Update_getInstance());
          break;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_10($backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C657@28611L66,658@28744L1538,656@28544L1772:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1731383532, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:656)');
        }
        sourceInformationMarkerStart($composer_0, -1707225994, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_14($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -1707220266, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_15($backStack);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        StockRemindersScreen(tmp0_group, tmp1_group, $composer_0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_16($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_17($backStack) {
    return function (order) {
      $backStack._v.zz(new PastOrderDetails(order));
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_11($backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C692@30564L66,693@30695L134,691@30499L364:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1463838635, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:691)');
        }
        sourceInformationMarkerStart($composer_0, 2000348087, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_16($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 2000352347, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_17($backStack);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        OrderHistoryScreen(tmp0_group, tmp1_group, $composer_0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_18($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_19($backStack) {
    return function () {
      $backStack._v.zz(Checkout_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_20($authNavigator) {
    return function () {
      $authNavigator.g10h();
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_21($backStack) {
    return function (cartItem) {
      $backStack._v.zz(new CartNormalProductDetails(cartItem));
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_22($backStack) {
    return function (cartItem) {
      $backStack._v.zz(new CartMugProductDetails(cartItem));
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_23($backStack) {
    return function (cartItem) {
      $backStack._v.zz(new CartMagicMugProductDetails(cartItem));
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_24($backStack) {
    return function () {
      $backStack._v.zz(Update_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_12($backStack, $authNavigator) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C703@31095L230,708@31386L110,711@31553L114,714@31744L148,717@31966L145,720@32190L150,723@32399L108,702@31038L1503:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1196293738, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:702)');
        }
        sourceInformationMarkerStart($composer_0, 1412956252, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_18($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 1412965444, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_19($backStack);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 1412970792, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_0.q31($authNavigator);
        // Inline function 'kotlin.let' call
        var it_2 = $composer_0.i31();
        var tmp_2;
        if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
          var value_1 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_20($authNavigator);
          $composer_0.j31(value_1);
          tmp_2 = value_1;
        } else {
          tmp_2 = it_2;
        }
        var tmp2_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 1412976938, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_3 = $composer_0.i31();
        var tmp_3;
        if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
          var value_2 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_21($backStack);
          $composer_0.j31(value_2);
          tmp_3 = value_2;
        } else {
          tmp_3 = it_3;
        }
        var tmp3_group = tmp_3;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 1412984039, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_0.i31();
        var tmp_4;
        if (invalid_3 || it_4 === Companion_getInstance().f30_1) {
          var value_3 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_22($backStack);
          $composer_0.j31(value_3);
          tmp_4 = value_3;
        } else {
          tmp_4 = it_4;
        }
        var tmp4_group = tmp_4;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 1412991212, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_5 = $composer_0.i31();
        var tmp_5;
        if (invalid_4 || it_5 === Companion_getInstance().f30_1) {
          var value_4 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_23($backStack);
          $composer_0.j31(value_4);
          tmp_5 = value_4;
        } else {
          tmp_5 = it_5;
        }
        var tmp5_group = tmp_5;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 1412997858, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_6 = $composer_0.i31();
        var tmp_6;
        if (invalid_5 || it_6 === Companion_getInstance().f30_1) {
          var value_5 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_24($backStack);
          $composer_0.j31(value_5);
          tmp_6 = value_5;
        } else {
          tmp_6 = it_6;
        }
        var tmp6_group = tmp_6;
        sourceInformationMarkerEnd($composer_0);
        CartScreen(tmp0_group, tmp1_group, tmp2_group, tmp3_group, tmp4_group, tmp5_group, tmp6_group, $composer_0, 0);
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_25($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_26($authNavigator) {
    return function () {
      $authNavigator.g10h();
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_13($key, $backStack, $authNavigator) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C734@32877L66,735@33000L38,732@32739L333:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-928748841, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:732)');
        }
        sourceInformationMarkerStart($composer_0, 825566937, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_25($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 825570845, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31($authNavigator);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_26($authNavigator);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        CartNormalProductDetailsScreen($key.a10c_1, tmp0_group, tmp1_group, $composer_0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_27($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_28($authNavigator) {
    return function () {
      $authNavigator.g10h();
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_14($key, $backStack, $authNavigator, $paddingValues) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C744@33402L66,745@33525L38,742@33267L508:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-661203944, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:742)');
        }
        sourceInformationMarkerStart($composer_0, 238175098, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_27($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 238179006, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31($authNavigator);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_28($authNavigator);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        CartMugProductDetailsScreen($key.d10c_1, tmp0_group, tmp1_group, $paddingValues.fdw(), $paddingValues.gdw(), $composer_0, 0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_29($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_30($authNavigator) {
    return function () {
      $authNavigator.g10h();
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_15($key, $backStack, $authNavigator, $paddingValues) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C756@34115L66,757@34238L38,754@33975L513:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-393659047, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:754)');
        }
        sourceInformationMarkerStart($composer_0, -349216485, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_29($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -349212577, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31($authNavigator);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_30($authNavigator);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        CartMagicMugProductDetailsScreen($key.g10c_1, tmp0_group, tmp1_group, $paddingValues.fdw(), $paddingValues.gdw(), $composer_0, 0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_31($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_32($authNavigator) {
    return function () {
      $authNavigator.g10h();
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_16($key, $backStack, $authNavigator) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C768@34802L142,771@35001L114,766@34676L1211:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1765944041, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:766)');
        }
        sourceInformationMarkerStart($composer_0, -560136219, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_31($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -560129879, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31($authNavigator);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_32($authNavigator);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        ProductDetailsScreen($key.u108_1, tmp0_group, tmp1_group, $key.v108_1, $key.w108_1, $key.x108_1, $key.y108_1, $key.z108_1, $key.a109_1, $key.b109_1, $key.c109_1, $key.d109_1, $key.e109_1, $composer_0, 0, 0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_33($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_34($authNavigator) {
    return function () {
      $authNavigator.g10h();
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_17($key, $backStack, $authNavigator) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C792@36261L142,795@36460L114,790@36130L1299:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1498399144, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:790)');
        }
        sourceInformationMarkerStart($composer_0, -1147526202, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_33($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -1147519862, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31($authNavigator);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_34($authNavigator);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        BeadsProductDetailsScreen($key.i109_1, tmp0_group, tmp1_group, $key.j109_1, $key.k109_1, $key.l109_1, $key.m109_1, $key.n109_1, $key.o109_1, $key.p109_1, $key.q109_1, $key.r109_1, $key.s109_1, $key.t109_1, $composer_0, 0, 0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_35($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_36($authNavigator) {
    return function () {
      $authNavigator.g10h();
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_18($key, $backStack, $authNavigator, $paddingValues) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C817@37747L142,820@37946L114,815@37619L1391:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1230854247, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:815)');
        }
        sourceInformationMarkerStart($composer_0, -1734919641, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_35($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -1734913301, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31($authNavigator);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_36($authNavigator);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        CustomMugDetailsScreen($key.x109_1, tmp0_group, tmp1_group, $key.y109_1, $key.z109_1, $key.a10a_1, $key.b10a_1, $key.c10a_1, $key.d10a_1, $key.e10a_1, $key.f10a_1, $key.g10a_1, $key.h10a_1, $paddingValues.fdw(), $paddingValues.gdw(), $composer_0, 0, 0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_37($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_38($authNavigator) {
    return function () {
      $authNavigator.g10h();
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_19($key, $backStack, $authNavigator, $paddingValues) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C843@39338L142,846@39537L114,841@39205L1396:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-963309350, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:841)');
        }
        sourceInformationMarkerStart($composer_0, 1972656072, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_37($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 1972662412, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31($authNavigator);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_38($authNavigator);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        CustomMagicMugDetailsScreen($key.l10a_1, tmp0_group, tmp1_group, $key.m10a_1, $key.n10a_1, $key.o10a_1, $key.p10a_1, $key.q10a_1, $key.r10a_1, $key.s10a_1, $key.t10a_1, $key.u10a_1, $key.v10a_1, $paddingValues.fdw(), $paddingValues.gdw(), $composer_0, 0, 0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_39($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_40($backStack) {
    return function (order) {
      var tmp;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!$backStack._v.r()) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      $backStack._v.zz(new OrderDetails(order));
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_20($backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C868@40844L66,869@40965L325,867@40783L541:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-695764453, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:867)');
        }
        sourceInformationMarkerStart($composer_0, 1385261949, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_39($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 1385266080, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_40($backStack);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        CheckoutScreen(tmp0_group, tmp1_group, $composer_0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_41($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_42($backStack) {
    return function () {
      $l$loop: while (true) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!!$backStack._v.r()) {
          break $l$loop;
        }
        $backStack._v.h3(0);
      }
      $backStack._v.zz(Shopping_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_21($key, $backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C883@41623L230,888@41908L396,881@41510L828:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-428219556, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:881)');
        }
        sourceInformationMarkerStart($composer_0, 797872034, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_41($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 797881320, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_42($backStack);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        OrderScreen($key.m10c_1, tmp0_group, tmp1_group, $composer_0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_43($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_22($key, $backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C903@42648L230,901@42528L384:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-160674659, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:901)');
        }
        sourceInformationMarkerStart($composer_0, 210480515, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_43($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        OrderDetailsScreen($key.p10c_1, tmp0_group, $composer_0, 0);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_44($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_23($backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C914@43113L212,914@43090L236:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(106870238, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:914)');
        }
        sourceInformationMarkerStart($composer_0, -376914350, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_44($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        FriendsScreen(tmp0_group, $composer_0, 0);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_45($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_46(text, color, size, image) {
    _init_properties_HomeNavHost_kt__sz1o0q();
    return Unit_instance;
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_24($backStack, $language$delegate) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C926@43625L66,927@43743L216,924@43506L487:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(374415135, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:924)');
        }
        var tmp_0 = HomeNavHost$lambda_0($language$delegate);
        sourceInformationMarkerStart($composer_0, -964303167, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_1;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_45($backStack);
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it_0;
        }
        var tmp0_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -964299241, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_2;
        if (false || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_46;
          $composer_0.j31(value_0);
          tmp_2 = value_0;
        } else {
          tmp_2 = it_1;
        }
        var tmp1_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        CustomMugScreen(null, tmp_0, tmp0_group, tmp1_group, $composer_0, 3072, 1);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_47($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_48($authNavigator) {
    return function () {
      $authNavigator.g10h();
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_25($backStack, $authNavigator, $key) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C937@44235L230,942@44522L114,936@44174L841:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(641960032, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:936)');
        }
        sourceInformationMarkerStart($composer_0, -1551696602, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_47($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -1551687534, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31($authNavigator);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_48($authNavigator);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        ModelMugScreen(tmp0_group, tmp1_group, $key.n10b_1, $key.o10b_1, $key.p10b_1, $key.q10b_1, $key.r10b_1, null, false, null, $composer_0, 0, 896);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_49($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_50($backStack) {
    return function (id) {
      $backStack._v.zz(new MugDesignerEditor(id));
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_26($key, $backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C958@45330L230,963@45619L129,956@45199L583:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2061986826, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:956)');
        }
        sourceInformationMarkerStart($composer_0, -1589410820, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_49($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -1589401673, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_50($backStack);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        EditMugDesignScreen($key.u10b_1, tmp0_group, tmp1_group, $composer_0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_51($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_52($backStack) {
    return function (id) {
      $backStack._v.zz(new MugDesignerEditor(id));
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_27($key, $backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C974@46152L230,979@46441L129,972@46016L588:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1794441929, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:972)');
        }
        sourceInformationMarkerStart($composer_0, 2118166237, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_51($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 2118175384, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_52($backStack);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        EditCustomMagicMugScreen($key.x10b_1, tmp0_group, tmp1_group, $composer_0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_53($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_28($key, $backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C990@46972L230,988@46837L399:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1526897032, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:988)');
        }
        sourceInformationMarkerStart($composer_0, 1530774462, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_53($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        MugDesignerEditorScreen($key.j10c_1, tmp0_group, $composer_0, 0);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_54($backStack) {
    return function () {
      $backStack._v.c3();
      $backStack._v.zz(Shopping_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_29($key, $backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1007@47606L1109:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-991807238, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:1007)');
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = fillMaxSize(Companion_instance);
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((4 & 1) === 0))
          modifier = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 1546267596, 'C1011@47826L855:HomeNavHost.kt#v8axby');
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_1 = null;
        var verticalArrangement = null;
        var horizontalAlignment = Companion_getInstance_11().x8t_1;
        var $composer_6 = $composer_5;
        if (!((3 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((3 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((3 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_1 = $composer_8.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, -1621716287, 'C1014@48063L10,1015@48156L11,1012@47927L288,1017@48256L41,1018@48355L180,1018@48338L305:HomeNavHost.kt#v8axby');
        var tmp0_text = $key.j10b_1;
        var tmp1_style = MaterialTheme_instance.jog($composer_10, 6).jof_1;
        var tmp2_color = MaterialTheme_instance.unz($composer_10, 6).to0_1;
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp2_color, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, tmp1_style, $composer_10, 0, 0, 131066);
        var tmp_6 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$12 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_6, tmp$ret$12), $composer_10, 6);
        sourceInformationMarkerStart($composer_10, -1437773590, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_10.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_10.i31();
        var tmp_7;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_54($backStack);
          $composer_10.j31(value);
          tmp_7 = value;
        } else {
          tmp_7 = it_0;
        }
        var tmp0_group = tmp_7;
        sourceInformationMarkerEnd($composer_10);
        Button(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$HomeNavHostKt_getInstance().f10d_1, $composer_10, 805306368, 510);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_55($backStack) {
    return function (newPage) {
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!$backStack._v.r()) {
        var tmp_1 = last($backStack._v);
        tmp_0 = tmp_1 instanceof Auth_0;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var tmp_2 = last($backStack._v);
        var current = tmp_2 instanceof Auth_0 ? tmp_2 : THROW_CCE();
        var tmp_3;
        if (!(current.f10b_1 === newPage)) {
          $backStack._v.h3($backStack._v.n1() - 1 | 0);
          $backStack._v.zz(new Auth_0(newPage));
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_56($backStack) {
    return function () {
      $backStack._v.c3();
      $backStack._v.zz(Shopping_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_30($key, $backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1034@49084L579,1043@49720L168,1031@48893L1029:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-724262341, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:1031)');
        }
        sourceInformationMarkerStart($composer_0, -231399970, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_55($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -231380029, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_56($backStack);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        AuthScreen($key.f10b_1, $key.g10b_1, tmp0_group, tmp1_group, $composer_0, 0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_57($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_58($backStack) {
    return function () {
      $backStack._v.zz(new Auth_0('forgot-password'));
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_59($backStack) {
    return function () {
      $backStack._v.zz(new DeleteAccountStandalone());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_31($backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1054@50188L66,1055@50320L49,1056@50435L51,1053@50110L410:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-456717444, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:1053)');
        }
        sourceInformationMarkerStart($composer_0, -818795842, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_57($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -818791635, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_58($backStack);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -818787953, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_2 = $composer_0.i31();
        var tmp_2;
        if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
          var value_1 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_59($backStack);
          $composer_0.j31(value_1);
          tmp_2 = value_1;
        } else {
          tmp_2 = it_2;
        }
        var tmp2_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        AccountManagementScreen(tmp0_group, tmp1_group, tmp2_group, $composer_0, 0);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_60($backStack) {
    return function () {
      $backStack._v.c3();
      $backStack._v.zz(DeleteAccountSuccess_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_61($backStack) {
    return function () {
      var tmp;
      if ($backStack._v.n1() > 1) {
        $backStack._v.h3($backStack._v.n1() - 1 | 0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_32($key, $backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1066@50923L180,1070@51150L66,1063@50717L533:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-189172547, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:1063)');
        }
        sourceInformationMarkerStart($composer_0, -1406183375, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_60($backStack);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -1406176225, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_61($backStack);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_1;
        }
        var tmp1_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        DeleteAccountStandaloneScreen($key.u10c_1, $key.v10c_1, tmp0_group, tmp1_group, $composer_0, 0, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_62($backStack) {
    return function () {
      $backStack._v.c3();
      $backStack._v.zz(Shopping_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_33($backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1078@51513L55,1079@51616L57,1079@51682L46,1080@51775L168,1077@51441L536:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(78372350, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:1077)');
        }
        var tmp_0 = stringResource(get_delete_account_success_title(string_instance), $composer_0, 0);
        var tmp_1 = stringResource(get_delete_account_success_message(string_instance), $composer_0, 0) + ' ' + stringResource(get_contact_us_whatsapp(string_instance), $composer_0, 0);
        sourceInformationMarkerStart($composer_0, -1993571034, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_2;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_62($backStack);
          $composer_0.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it_0;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        AccountActionSuccessScreen(tmp_0, tmp_1, tmp0_group, $composer_0, 0);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_63($backStack) {
    return function () {
      $backStack._v.c3();
      $backStack._v.zz(Shopping_getInstance());
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda$lambda_34($backStack) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1091@52240L55,1092@52343L56,1093@52446L168,1090@52168L480:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(345917247, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:1090)');
        }
        var tmp_0 = stringResource(get_reset_password_success_title(string_instance), $composer_0, 0);
        var tmp_1 = stringResource(get_reset_password_complete_steps(string_instance), $composer_0, 0);
        sourceInformationMarkerStart($composer_0, 1714002727, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_2;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda$lambda$lambda_63($backStack);
          $composer_0.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it_0;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        AccountActionSuccessScreen(tmp_0, tmp_1, tmp0_group, $composer_0, 0);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda$lambda$lambda_5($backStack, $authNavigator, $paddingValues, $language$delegate) {
    return function (key) {
      var tmp;
      if (equals(key, Shopping_getInstance())) {
        tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(1581751002, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_6($backStack))));
      } else {
        if (equals(key, Profile_getInstance())) {
          tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(1760949073, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_7($backStack, $authNavigator))));
        } else {
          if (equals(key, Favorites_getInstance())) {
            tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(2028493970, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_8($backStack))));
          } else {
            if (equals(key, Coupons_getInstance())) {
              tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-1998928429, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_9($backStack))));
            } else {
              if (equals(key, StockReminders_getInstance())) {
                tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-1731383532, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_10($backStack))));
              } else {
                if (equals(key, OrderHistory_getInstance())) {
                  tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-1463838635, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_11($backStack))));
                } else {
                  if (equals(key, Cart_getInstance())) {
                    tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-1196293738, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_12($backStack, $authNavigator))));
                  } else {
                    if (key instanceof CartNormalProductDetails) {
                      tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-928748841, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_13(key, $backStack, $authNavigator))));
                    } else {
                      if (key instanceof CartMugProductDetails) {
                        tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-661203944, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_14(key, $backStack, $authNavigator, $paddingValues))));
                      } else {
                        if (key instanceof CartMagicMugProductDetails) {
                          tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-393659047, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_15(key, $backStack, $authNavigator, $paddingValues))));
                        } else {
                          if (key instanceof ProductDetails) {
                            tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-1765944041, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_16(key, $backStack, $authNavigator))));
                          } else {
                            if (key instanceof BeadsProductDetails) {
                              tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-1498399144, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_17(key, $backStack, $authNavigator))));
                            } else {
                              if (key instanceof CustomMugDetails) {
                                tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-1230854247, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_18(key, $backStack, $authNavigator, $paddingValues))));
                              } else {
                                if (key instanceof CustomMagicMugDetails) {
                                  tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-963309350, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_19(key, $backStack, $authNavigator, $paddingValues))));
                                } else {
                                  if (key instanceof Checkout) {
                                    tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-695764453, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_20($backStack))));
                                  } else {
                                    if (key instanceof OrderDetails) {
                                      tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-428219556, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_21(key, $backStack))));
                                    } else {
                                      if (key instanceof PastOrderDetails) {
                                        tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-160674659, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_22(key, $backStack))));
                                      } else {
                                        if (equals(key, Friends_getInstance())) {
                                          tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(106870238, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_23($backStack))));
                                        } else {
                                          if (equals(key, CustomMug_getInstance())) {
                                            tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(374415135, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_24($backStack, $language$delegate))));
                                          } else {
                                            if (key instanceof Model3D) {
                                              tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(641960032, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_25($backStack, $authNavigator, key))));
                                            } else {
                                              if (key instanceof EditDesign) {
                                                tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-2061986826, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_26(key, $backStack))));
                                              } else {
                                                if (key instanceof EditCustomMagicMug) {
                                                  tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-1794441929, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_27(key, $backStack))));
                                                } else {
                                                  if (key instanceof MugDesignerEditor) {
                                                    tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-1526897032, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_28(key, $backStack))));
                                                  } else {
                                                    if (equals(key, Update_getInstance())) {
                                                      tmp = new NavEntry(key, VOID, VOID, ComposableSingletons$HomeNavHostKt_getInstance().e10d_1);
                                                    } else {
                                                      if (key instanceof Error_0) {
                                                        tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-991807238, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_29(key, $backStack))));
                                                      } else {
                                                        if (key instanceof Auth_0) {
                                                          tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-724262341, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_30(key, $backStack))));
                                                        } else {
                                                          if (equals(key, AccountManagement_getInstance())) {
                                                            tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-456717444, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_31($backStack))));
                                                          } else {
                                                            if (key instanceof DeleteAccountStandalone) {
                                                              tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(-189172547, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_32(key, $backStack))));
                                                            } else {
                                                              if (equals(key, DeleteAccountSuccess_getInstance())) {
                                                                tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(78372350, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_33($backStack))));
                                                              } else {
                                                                if (equals(key, ResetPasswordSuccess_getInstance())) {
                                                                  tmp = new NavEntry(key, VOID, VOID, ComposableLambda$invoke$ref_0(composableLambdaInstance(345917247, true, HomeNavHost$lambda$lambda$lambda$lambda$lambda_34($backStack))));
                                                                } else {
                                                                  noWhenBranchMatchedException();
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      return tmp;
    };
  }
  function HomeNavHost$lambda$lambda$lambda_0($backStack, $authNavigator, $paddingValues, $language$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C500@20137L11,497@20003L32765:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(91750900, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous>.<anonymous> (HomeNavHost.kt:497)');
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = background(fillMaxSize(Companion_instance), MaterialTheme_instance.unz($composer_0, 6).ko0_1);
        var contentAlignment = Companion_getInstance_11().l8t_1;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((4 & 1) === 0))
          modifier = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 1517282872, 'C503@20261L32497:HomeNavHost.kt#v8axby');
        var tmp_1 = fillMaxHeight(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$6 = _Dp___init__impl__ms3zkb(1200);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = widthIn(tmp_1, VOID, tmp$ret$6);
        var contentAlignment_0 = null;
        var propagateMinConstraints_0 = false;
        var $composer_6 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_2 = $composer_8.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 1371238210, 'C510@20555L198,515@20796L538,524@21380L538,533@21941L30803,508@20455L32289:HomeNavHost.kt#v8axby');
        var tmp_3 = $backStack._v;
        sourceInformationMarkerStart($composer_10, -1618363386, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_10.k31($backStack._v);
        // Inline function 'kotlin.let' call
        var it = $composer_10.i31();
        var tmp_4;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda$lambda_2($backStack);
          $composer_10.j31(value);
          tmp_4 = value;
        } else {
          tmp_4 = it;
        }
        var tmp0_group = tmp_4;
        sourceInformationMarkerEnd($composer_10);
        sourceInformationMarkerStart($composer_10, -1618355334, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_0 = $composer_10.i31();
        var tmp_5;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var value_0 = HomeNavHost$lambda$lambda$lambda$lambda_3;
          $composer_10.j31(value_0);
          tmp_5 = value_0;
        } else {
          tmp_5 = it_0;
        }
        var tmp1_group = tmp_5;
        sourceInformationMarkerEnd($composer_10);
        sourceInformationMarkerStart($composer_10, -1618336646, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_1 = $composer_10.i31();
        var tmp_6;
        if (false || it_1 === Companion_getInstance().f30_1) {
          var value_1 = HomeNavHost$lambda$lambda$lambda$lambda_4;
          $composer_10.j31(value_1);
          tmp_6 = value_1;
        } else {
          tmp_6 = it_1;
        }
        var tmp2_group = tmp_6;
        sourceInformationMarkerEnd($composer_10);
        sourceInformationMarkerStart($composer_10, -1618288429, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = !!(!!(!!($composer_10.k31($backStack._v) | $composer_10.q31($authNavigator)) | $composer_10.k31($paddingValues)) | $composer_10.k31($language$delegate));
        // Inline function 'kotlin.let' call
        var it_2 = $composer_10.i31();
        var tmp_7;
        if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
          var value_2 = HomeNavHost$lambda$lambda$lambda$lambda_5($backStack, $authNavigator, $paddingValues, $language$delegate);
          $composer_10.j31(value_2);
          tmp_7 = value_2;
        } else {
          tmp_7 = it_2;
        }
        var tmp3_group = tmp_7;
        sourceInformationMarkerEnd($composer_10);
        NavDisplay(tmp_3, null, null, tmp0_group, null, null, null, null, null, tmp1_group, tmp2_group, null, tmp3_group, $composer_10, 805306368, 6, 2550);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda$lambda_1($showNavigation, $layoutType, $selectedTab, $backStack, $hasUnsavedChanges$delegate, $pendingNavigation$delegate, $authNavigator, $language$delegate) {
    return function (paddingValues, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C430@16587L3383,496@19985L32789,427@16372L36402:HomeNavHost.kt#v8axby');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31(paddingValues) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-770667396, $dirty, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous>.<anonymous> (HomeNavHost.kt:427)');
        }
        var tmp0_modifier = padding(Companion_instance, paddingValues);
        var tmp1_layoutType = $showNavigation ? $layoutType : Companion_getInstance_10().vxm_1;
        sourceInformationMarkerStart($composer_0, -1876981389, 'CC(remember):HomeNavHost.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.q31($selectedTab) | $composer_0.k31($backStack._v)) | $composer_0.k31($hasUnsavedChanges$delegate));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = HomeNavHost$lambda$lambda$lambda($selectedTab, $backStack, $hasUnsavedChanges$delegate, $pendingNavigation$delegate);
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp0_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(91750900, true, HomeNavHost$lambda$lambda$lambda_0($backStack, $authNavigator, paddingValues, $language$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_4;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_0;
        }
        var tmp$ret$4 = tmp_4;
        NavigationSuiteScaffold(tmp0_group, tmp0_modifier, tmp1_layoutType, null, tmp_2, tmp_3, null, tmp$ret$4, $composer_0, 12582912, 120);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp_0 = tmp_5;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_2(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function HomeNavHost$lambda_5($appViewModel, $pendingNavigation$delegate, $showNavigation, $layoutType, $selectedTab, $backStack, $hasUnsavedChanges$delegate, $authNavigator, $language$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C426@16341L36435,426@16332L36444:HomeNavHost.kt#v8axby');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1616852845, $changed, -1, 'client.fstech.hadaya.presentation.HomeNavHost.<anonymous> (HomeNavHost.kt:413)');
        }
        if (!(HomeNavHost$lambda_2($pendingNavigation$delegate) == null)) {
          $composer_0.m30(-395064311);
          sourceInformation($composer_0, '415@15919L46,416@15993L44,417@16067L173,422@16270L28,414@15876L436');
          var tmp_0 = stringResource(get_discard_order_title(string_instance), $composer_0, 0);
          var tmp_1 = stringResource(get_discard_order_msg(string_instance), $composer_0, 0);
          sourceInformationMarkerStart($composer_0, -982569062, 'CC(remember):HomeNavHost.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_0.q31($appViewModel);
          // Inline function 'kotlin.let' call
          var it = $composer_0.i31();
          var tmp_2;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = HomeNavHost$lambda$lambda($appViewModel, $pendingNavigation$delegate);
            $composer_0.j31(value);
            tmp_2 = value;
          } else {
            tmp_2 = it;
          }
          var tmp0_group = tmp_2;
          sourceInformationMarkerEnd($composer_0);
          sourceInformationMarkerStart($composer_0, -982562711, 'CC(remember):HomeNavHost.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_0 = $composer_0.i31();
          var tmp_3;
          if (false || it_0 === Companion_getInstance().f30_1) {
            var value_0 = HomeNavHost$lambda$lambda_0($pendingNavigation$delegate);
            $composer_0.j31(value_0);
            tmp_3 = value_0;
          } else {
            tmp_3 = it_0;
          }
          var tmp1_group = tmp_3;
          sourceInformationMarkerEnd($composer_0);
          HadayaAlertDialog(tmp_0, tmp_1, null, null, tmp0_group, tmp1_group, $composer_0, 196608, 12);
          $composer_0.n30();
        } else {
          $composer_0.m30(-394622251);
          $composer_0.n30();
        }
        var tmp_4 = _FabPosition___init__impl__9ib2hj(0);
        var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-770667396, true, HomeNavHost$lambda$lambda_1($showNavigation, $layoutType, $selectedTab, $backStack, $hasUnsavedChanges$delegate, $pendingNavigation$delegate, $authNavigator, $language$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_1.i31();
        var tmp_7;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_1 = ComposableLambda$invoke$ref_2(dispatchReceiver);
          $composer_1.j31(value_1);
          tmp_7 = value_1;
        } else {
          tmp_7 = it_1;
        }
        var tmp$ret$8 = tmp_7;
        Scaffold(null, null, null, null, null, tmp_4, tmp_5, tmp_6, null, tmp$ret$8, $composer_0, 805306368, 511);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HomeNavHost$lambda_6($backStack, $$changed, $$default) {
    return function ($composer, $force) {
      HomeNavHost($backStack._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var properties_initialized_HomeNavHost_kt_7au48s;
  function _init_properties_HomeNavHost_kt__sz1o0q() {
    if (!properties_initialized_HomeNavHost_kt_7au48s) {
      properties_initialized_HomeNavHost_kt_7au48s = true;
      var tmp = ScreenStateSaver$lambda;
      ScreenStateSaver = Saver(tmp, ScreenStateSaver$lambda_0);
      var tmp_0 = ScreenListSaver$lambda;
      ScreenListSaver = Saver(tmp_0, ScreenListSaver$lambda_0);
      client_fstech_hadaya_presentation_Screen_Shopping$stable = 0;
      client_fstech_hadaya_presentation_Screen_Profile$stable = 0;
      client_fstech_hadaya_presentation_Screen_Cart$stable = 0;
      client_fstech_hadaya_presentation_Screen_ProductDetails_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_ProductDetails$stable = 0;
      client_fstech_hadaya_presentation_Screen_BeadsProductDetails_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_BeadsProductDetails$stable = 0;
      client_fstech_hadaya_presentation_Screen_CustomMugDetails_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_CustomMugDetails$stable = 0;
      client_fstech_hadaya_presentation_Screen_CustomMagicMugDetails_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_CustomMagicMugDetails$stable = 0;
      client_fstech_hadaya_presentation_Screen_Checkout$stable = 0;
      client_fstech_hadaya_presentation_Screen_Friends$stable = 0;
      client_fstech_hadaya_presentation_Screen_Favorites$stable = 0;
      client_fstech_hadaya_presentation_Screen_Coupons$stable = 0;
      client_fstech_hadaya_presentation_Screen_StockReminders$stable = 0;
      client_fstech_hadaya_presentation_Screen_Update$stable = 0;
      client_fstech_hadaya_presentation_Screen_CustomMug$stable = 0;
      client_fstech_hadaya_presentation_Screen_Auth_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_Auth$stable = 0;
      client_fstech_hadaya_presentation_Screen_Error_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_Error$stable = 0;
      client_fstech_hadaya_presentation_Screen_Model3D_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_Model3D$stable = 0;
      client_fstech_hadaya_presentation_Screen_EditDesign_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_EditDesign$stable = 0;
      client_fstech_hadaya_presentation_Screen_EditCustomMagicMug_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_EditCustomMagicMug$stable = 0;
      client_fstech_hadaya_presentation_Screen_CartNormalProductDetails_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_CartNormalProductDetails$stable = 8;
      client_fstech_hadaya_presentation_Screen_CartMugProductDetails_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_CartMugProductDetails$stable = 8;
      client_fstech_hadaya_presentation_Screen_CartMagicMugProductDetails_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_CartMagicMugProductDetails$stable = 8;
      client_fstech_hadaya_presentation_Screen_MugDesignerEditor_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_MugDesignerEditor$stable = 0;
      client_fstech_hadaya_presentation_Screen_OrderDetails_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_OrderDetails$stable = 8;
      client_fstech_hadaya_presentation_Screen_PastOrderDetails_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_PastOrderDetails$stable = 8;
      client_fstech_hadaya_presentation_Screen_OrderHistory$stable = 0;
      client_fstech_hadaya_presentation_Screen_AccountManagement$stable = 0;
      client_fstech_hadaya_presentation_Screen_DeleteAccountStandalone_$serializer$stable = 0;
      client_fstech_hadaya_presentation_Screen_DeleteAccountStandalone$stable = 0;
      client_fstech_hadaya_presentation_Screen_DeleteAccountSuccess$stable = 0;
      client_fstech_hadaya_presentation_Screen_ResetPasswordSuccess$stable = 0;
    }
  }
  function AccountManagementScreen(onNavigateBack, onNavigateToResetPassword, onNavigateToDeleteAccount, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1220373464);
    sourceInformation($composer_0, 'C(AccountManagementScreen)P(!1,2)33@1289L21,30@1198L1400:AccountManagementScreen.kt#8c7j0c');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateBack) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToResetPassword) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToDeleteAccount) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1220373464, $dirty, -1, 'client.fstech.hadaya.presentation.accountmanagement.AccountManagementScreen (AccountManagementScreen.kt:29)');
      }
      var tmp = fillMaxSize(Companion_instance);
      var tmp_0 = verticalScroll(tmp, rememberScrollState(0, $composer_0, 0, 1));
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = padding_0(tmp_0, tmp$ret$0);
      var verticalArrangement = null;
      var horizontalAlignment = Companion_getInstance_11().x8t_1;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier = Companion_instance;
      if (!((2 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((2 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 384 >> 3 | 112 & 384 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -650204807, 'C37@1416L323,45@1748L41,46@1803L35,46@1862L10,46@1798L89,47@1896L41,48@1946L179,54@2143L41,57@2286L40,55@2193L292,62@2494L98:AccountManagementScreen.kt#8c7j0c');
      var tmp_2 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(150);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_1 = size(tmp_2, tmp$ret$7);
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_6 = $composer_5;
      if (!((4 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((4 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((4 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_3 = $composer_8.g30();
      if (!isInterface(tmp_3, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_0);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, -1091224649, 'C39@1538L34,38@1505L224:AccountManagementScreen.kt#8c7j0c');
      var tmp_4 = painterResource(get_logo(drawable_instance), $composer_10, 0);
      var tmp_5 = fillMaxSize(Companion_instance);
      var tmp_6 = Companion_getInstance_13().r96_1;
      Image(tmp_4, null, tmp_5, null, tmp_6, 0.0, null, $composer_10, 25008 | androidx_compose_ui_graphics_painter_Painter$stableprop_getter(), 104);
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      var tmp_7 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$14 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_7, tmp$ret$14), $composer_5, 6);
      var tmp_8 = stringResource(get_app_name(string_instance), $composer_5, 0);
      var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_13 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_8, null, tmp_9, null, tmp_10, null, null, null, tmp_11, null, null, tmp_12, tmp_13, false, 0, 0, null, MaterialTheme_instance.jog($composer_5, 6).iof_1, $composer_5, 0, 0, 131070);
      var tmp_14 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$15 = _Dp___init__impl__ms3zkb(24);
      Spacer(height(tmp_14, tmp$ret$15), $composer_5, 6);
      var tmp_15 = fillMaxWidth(Companion_instance, 0.8);
      ContactUsSection(null, tmp_15, null, true, onNavigateToResetPassword, false, null, false, $composer_5, 3120 | 57344 & $dirty << 9, 229);
      var tmp_16 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$16 = _Dp___init__impl__ms3zkb(12);
      Spacer(height(tmp_16, tmp$ret$16), $composer_5, 6);
      var tmp_17 = ButtonDefaults_getInstance();
      var tmp_18 = Companion_getInstance_14().n6b_1;
      var tmp_19 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_20 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp0_colors = tmp_17.ao9(tmp_18, tmp_19, tmp_20, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24582, 14);
      var tmp1_modifier = fillMaxWidth(Companion_instance, 0.8);
      Button(onNavigateToDeleteAccount, tmp1_modifier, false, null, tmp0_colors, null, null, null, null, ComposableSingletons$AccountManagementScreenKt_getInstance().h10h_1, $composer_5, 805306416 | 14 & $dirty >> 6, 492);
      TextButton(onNavigateBack, null, false, null, null, null, null, null, null, ComposableSingletons$AccountManagementScreenKt_getInstance().i10h_1, $composer_5, 805306368 | 14 & $dirty, 510);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(AccountManagementScreen$lambda(onNavigateBack, onNavigateToResetPassword, onNavigateToDeleteAccount, $changed));
    }
  }
  function DeleteAccountStandaloneScreen(token, emailFromUrl, onNavigateToSuccess, onBack, $composer, $changed, $default) {
    var token_0 = {_v: token};
    var emailFromUrl_0 = {_v: emailFromUrl};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1312917789);
    sourceInformation($composer_0, 'C(DeleteAccountStandaloneScreen)P(3!1,2)75@2822L15,76@2881L16,77@2915L47,78@2983L31,79@3032L31,81@3091L154,81@3069L176,87@3298L312,87@3251L359,100@3735L21,96@3616L3058:AccountManagementScreen.kt#8c7j0c');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(token_0._v) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(emailFromUrl_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToSuccess) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        token_0._v = null;
      }
      if (!(($default & 2) === 0)) {
        emailFromUrl_0._v = null;
      }
      if (isTraceInProgress()) {
        traceEventStart(1312917789, $dirty, -1, 'client.fstech.hadaya.presentation.accountmanagement.DeleteAccountStandaloneScreen (AccountManagementScreen.kt:74)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(AccountManagementViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, -1006380116, 'CC(remember):AccountManagementScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance().f30_1) {
        var tmp0_elvis_lhs_0 = emailFromUrl_0._v;
        var value = mutableStateOf(tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0);
        this_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var email$delegate = tmp0_group;
      sourceInformationMarkerStart($composer_0, -1006377956, 'CC(remember):AccountManagementScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_2;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = mutableStateOf('');
        this_1.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      var password$delegate = tmp1_group;
      sourceInformationMarkerStart($composer_0, -1006376388, 'CC(remember):AccountManagementScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_2.i31();
      var tmp_3;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = mutableStateOf('');
        this_2.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp2_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      var error$delegate = tmp2_group;
      var tmp_4 = token_0._v;
      sourceInformationMarkerStart($composer_0, -1006374377, 'CC(remember):AccountManagementScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!(($dirty & 14) === 4 | $composer_0.q31(viewModel)) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_0.i31();
      var tmp_5;
      if (invalid || it_2 === Companion_getInstance().f30_1) {
        var value_2 = DeleteAccountStandaloneScreen$slambda_0(token_0, viewModel, emailFromUrl_0, null);
        tmp0_0.j31(value_2);
        tmp_5 = value_2;
      } else {
        tmp_5 = it_2;
      }
      var tmp3_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_4, tmp3_group, $composer_0, 14 & $dirty);
      var tmp_6 = viewModel.s10h().t10h();
      sourceInformationMarkerStart($composer_0, -1006367595, 'CC(remember):AccountManagementScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.q31(viewModel) | ($dirty & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_3 = tmp0_1.i31();
      var tmp_7;
      if (invalid_0 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = DeleteAccountStandaloneScreen$slambda_2(viewModel, onNavigateToSuccess, error$delegate, null);
        tmp0_1.j31(value_3);
        tmp_7 = value_3;
      } else {
        tmp_7 = it_3;
      }
      var tmp4_group = tmp_7;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_6, tmp4_group, $composer_0, 0);
      var tmp_8 = fillMaxSize(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$22 = _Dp___init__impl__ms3zkb(16);
      var tmp_9 = padding_0(tmp_8, tmp$ret$22);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = verticalScroll(tmp_9, rememberScrollState(0, $composer_0, 0, 1));
      var verticalArrangement = null;
      var horizontalAlignment = Companion_getInstance_11().x8t_1;
      var $composer_2 = $composer_0;
      if (!((2 & 1) === 0))
        modifier = Companion_instance;
      if (!((2 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((2 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_2, 14 & 384 >> 3 | 112 & 384 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_3 = $composer_2;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_0);
      var tmp0_2 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_10 = $composer_4.g30();
      if (!isInterface(tmp_10, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_2);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_5 = $composer_4;
      var $composer_6 = $composer_5;
      sourceInformationMarkerStart($composer_6, 508199338, 'C103@3839L45,103@3908L10,103@3834L100,104@3943L41,161@6578L90:AccountManagementScreen.kt#8c7j0c');
      var tmp_11 = stringResource(get_delete_account_btn(string_instance), $composer_6, 0);
      var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_15 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_16 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_11, null, tmp_12, null, tmp_13, null, null, null, tmp_14, null, null, tmp_15, tmp_16, false, 0, 0, null, MaterialTheme_instance.jog($composer_6, 6).jof_1, $composer_6, 0, 0, 131070);
      var tmp_17 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$29 = _Dp___init__impl__ms3zkb(20);
      Spacer(height(tmp_17, tmp$ret$29), $composer_6, 6);
      if (token_0._v == null) {
        $composer_6.m30(508372348);
        sourceInformation($composer_6, '109@4117L14,107@4035L240,113@4288L41,116@4427L17,114@4342L320,124@4869L41,129@5121L40,126@4957L122,132@5276L298,125@4923L651,139@5587L41,141@5683L561,140@5641L801');
        var tmp0_value = DeleteAccountStandaloneScreen$lambda_0(email$delegate);
        var tmp1_modifier = fillMaxWidth(Companion_instance, 0.8);
        sourceInformationMarkerStart($composer_6, -2061810219, 'CC(remember):AccountManagementScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_4 = $composer_6.i31();
        var tmp_18;
        if (false || it_4 === Companion_getInstance().f30_1) {
          var value_4 = DeleteAccountStandaloneScreen$lambda_6(email$delegate);
          $composer_6.j31(value_4);
          tmp_18 = value_4;
        } else {
          tmp_18 = it_4;
        }
        var tmp0_group_0 = tmp_18;
        sourceInformationMarkerEnd($composer_6);
        var tmp_19 = ComposableSingletons$AccountManagementScreenKt_getInstance().j10h_1;
        OutlinedTextField(tmp0_value, tmp0_group_0, tmp1_modifier, false, false, null, tmp_19, null, null, null, null, null, null, false, null, null, null, false, 0, 0, null, null, null, $composer_6, 1573296, 0, 0, 8388536);
        var tmp_20 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$34 = _Dp___init__impl__ms3zkb(10);
        Spacer(height(tmp_20, tmp$ret$34), $composer_6, 6);
        var tmp2_value = DeleteAccountStandaloneScreen$lambda_2(password$delegate);
        var tmp3_visualTransformation = new PasswordVisualTransformation();
        var tmp4_modifier = fillMaxWidth(Companion_instance, 0.8);
        sourceInformationMarkerStart($composer_6, -2061800296, 'CC(remember):AccountManagementScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_5 = $composer_6.i31();
        var tmp_21;
        if (false || it_5 === Companion_getInstance().f30_1) {
          var value_5 = DeleteAccountStandaloneScreen$lambda_7(password$delegate);
          $composer_6.j31(value_5);
          tmp_21 = value_5;
        } else {
          tmp_21 = it_5;
        }
        var tmp1_group_0 = tmp_21;
        sourceInformationMarkerEnd($composer_6);
        var tmp_22 = ComposableSingletons$AccountManagementScreenKt_getInstance().k10h_1;
        OutlinedTextField(tmp2_value, tmp1_group_0, tmp4_modifier, false, false, null, tmp_22, null, null, null, null, null, null, false, tmp3_visualTransformation, null, null, false, 0, 0, null, null, null, $composer_6, 1573296, 0, 0, 8372152);
        var tmp_23;
        // Inline function 'kotlin.text.isNotEmpty' call
        var this_3 = DeleteAccountStandaloneScreen$lambda_4(error$delegate);
        if (charSequenceLength(this_3) > 0) {
          tmp_23 = true;
        } else {
          tmp_23 = !(DeleteAccountStandaloneScreen$lambda(state$delegate).v10h_1 == null);
        }
        if (tmp_23) {
          $composer_6.m30(509013397);
          sourceInformation($composer_6, '122@4740L102');
          // Inline function 'kotlin.text.ifEmpty' call
          var this_4 = DeleteAccountStandaloneScreen$lambda_4(error$delegate);
          var tmp_24;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(this_4) === 0) {
            var tmp0_elvis_lhs_1 = DeleteAccountStandaloneScreen$lambda(state$delegate).v10h_1;
            tmp_24 = tmp0_elvis_lhs_1 == null ? '' : tmp0_elvis_lhs_1;
          } else {
            tmp_24 = this_4;
          }
          var tmp5_text = tmp_24;
          var tmp6_color = Companion_getInstance_14().n6b_1;
          var tmp_25 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$43 = _Dp___init__impl__ms3zkb(10);
          var tmp7_modifier = padding_1(tmp_25, VOID, tmp$ret$43);
          var tmp_26 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_27 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_28 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_29 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp5_text, tmp7_modifier, tmp6_color, null, tmp_26, null, null, null, tmp_27, null, null, tmp_28, tmp_29, false, 0, 0, null, null, $composer_6, 432, 0, 262136);
          $composer_6.n30();
        } else {
          $composer_6.m30(509125307);
          $composer_6.n30();
        }
        var tmp_30 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$44 = _Dp___init__impl__ms3zkb(20);
        Spacer(height(tmp_30, tmp$ret$44), $composer_6, 6);
        var tmp_31 = ButtonDefaults_getInstance();
        var tmp_32 = Companion_getInstance_14().n6b_1;
        var tmp_33 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_34 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp8_colors = tmp_31.ao9(tmp_32, tmp_33, tmp_34, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_6, 24582, 14);
        var tmp9_modifier = fillMaxWidth(Companion_instance, 0.8);
        var tmp10_enabled = !DeleteAccountStandaloneScreen$lambda(state$delegate).u10h_1;
        sourceInformationMarkerStart($composer_6, -2061783231, 'CC(remember):AccountManagementScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_6.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_6 = $composer_6.i31();
        var tmp_35;
        if (invalid_1 || it_6 === Companion_getInstance().f30_1) {
          var value_6 = DeleteAccountStandaloneScreen$lambda_8(viewModel, email$delegate, password$delegate);
          $composer_6.j31(value_6);
          tmp_35 = value_6;
        } else {
          tmp_35 = it_6;
        }
        var tmp2_group_0 = tmp_35;
        sourceInformationMarkerEnd($composer_6);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1987405508, true, DeleteAccountStandaloneScreen$lambda_9(state$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_7 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_7.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_7 = $composer_7.i31();
        var tmp_36;
        if (invalid_2 || it_7 === Companion_getInstance().f30_1) {
          var value_7 = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_7.j31(value_7);
          tmp_36 = value_7;
        } else {
          tmp_36 = it_7;
        }
        var tmp$ret$49 = tmp_36;
        Button(tmp2_group_0, tmp9_modifier, tmp10_enabled, null, tmp8_colors, null, null, null, null, tmp$ret$49, $composer_6, 805306416, 488);
        var tmp_37 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$56 = _Dp___init__impl__ms3zkb(10);
        Spacer(height(tmp_37, tmp$ret$56), $composer_6, 6);
        sourceInformationMarkerStart($composer_6, -2061759560, 'CC(remember):AccountManagementScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_8 = $composer_6.i31();
        var tmp_38;
        if (false || it_8 === Companion_getInstance().f30_1) {
          var value_8 = DeleteAccountStandaloneScreen$lambda_10(email$delegate, error$delegate);
          $composer_6.j31(value_8);
          tmp_38 = value_8;
        } else {
          tmp_38 = it_8;
        }
        var tmp3_group_0 = tmp_38;
        sourceInformationMarkerEnd($composer_6);
        var tmp_39 = fillMaxWidth(Companion_instance, 0.8);
        var tmp_40 = !DeleteAccountStandaloneScreen$lambda(state$delegate).u10h_1;
        OutlinedButton(tmp3_group_0, tmp_39, tmp_40, null, null, null, null, null, null, ComposableSingletons$AccountManagementScreenKt_getInstance().l10h_1, $composer_6, 805306422, 504);
        $composer_6.n30();
      } else {
        $composer_6.m30(510717653);
        sourceInformation($composer_6, '157@6472L27,158@6512L38');
        var tmp_41 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_42 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_43 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_44 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_41, tmp_42, tmp_43, tmp_44, _Dp___init__impl__ms3zkb(0.0), $composer_6, 0, 63);
        var tmp_45 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_46 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_47 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_48 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_49 = _TextOverflow___init__impl__obguoe(0);
        Text('Processing account deletion...', null, tmp_45, null, tmp_46, null, null, null, tmp_47, null, null, tmp_48, tmp_49, false, 0, 0, null, null, $composer_6, 6, 0, 262142);
        $composer_6.n30();
      }
      TextButton(onBack, null, false, null, null, null, null, null, null, ComposableSingletons$AccountManagementScreenKt_getInstance().m10h_1, $composer_6, 805306368 | 14 & $dirty >> 9, 510);
      sourceInformationMarkerEnd($composer_6);
      $composer_4.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp5_safe_receiver = $composer_0.t30();
    if (tmp5_safe_receiver == null)
      null;
    else {
      tmp5_safe_receiver.p3c(DeleteAccountStandaloneScreen$lambda_11(token_0, emailFromUrl_0, onNavigateToSuccess, onBack, $changed, $default));
    }
  }
  function AccountActionSuccessScreen(title, message, onBack, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1737194708);
    sourceInformation($composer_0, 'C(AccountActionSuccessScreen)P(2)175@6933L21,173@6793L855:AccountManagementScreen.kt#8c7j0c');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(title) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(message) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1737194708, $dirty, -1, 'client.fstech.hadaya.presentation.accountmanagement.AccountActionSuccessScreen (AccountManagementScreen.kt:172)');
      }
      var tmp0_horizontalAlignment = Companion_getInstance_11().x8t_1;
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
      var tmp_0 = fillMaxSize(padding_0(tmp, tmp$ret$0));
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = verticalScroll(tmp_0, rememberScrollState(0, $composer_0, 0, 1));
      var verticalArrangement = null;
      var horizontalAlignment = tmp0_horizontalAlignment;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier = Companion_instance;
      if (!((2 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((2 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 384 >> 3 | 112 & 384 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 805987547, 'C177@6972L41,180@7081L10,178@7022L136,183@7167L41,186@7278L10,184@7217L194,190@7420L41,191@7470L172:AccountManagementScreen.kt#8c7j0c');
      var tmp_2 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(40);
      Spacer(height(tmp_2, tmp$ret$7), $composer_5, 6);
      var tmp0_style = MaterialTheme_instance.jog($composer_5, 6).jof_1;
      var tmp1_textAlign = Companion_getInstance_15().d7v_1;
      var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_7 = _TextOverflow___init__impl__obguoe(0);
      Text(title, null, tmp_3, null, tmp_4, null, null, null, tmp_5, null, tmp1_textAlign, tmp_6, tmp_7, false, 0, 0, null, tmp0_style, $composer_5, 14 & $dirty, 0, 130046);
      var tmp_8 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$8 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_8, tmp$ret$8), $composer_5, 6);
      var tmp2_style = MaterialTheme_instance.jog($composer_5, 6).oof_1;
      var tmp3_textAlign = Companion_getInstance_15().d7v_1;
      var tmp_9 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$9 = _Dp___init__impl__ms3zkb(16);
      var tmp4_modifier = padding_2(tmp_9, tmp$ret$9);
      var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_14 = _TextOverflow___init__impl__obguoe(0);
      Text(message, tmp4_modifier, tmp_10, null, tmp_11, null, null, null, tmp_12, null, tmp3_textAlign, tmp_13, tmp_14, false, 0, 0, null, tmp2_style, $composer_5, 48 | 14 & $dirty >> 3, 0, 130044);
      var tmp_15 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$10 = _Dp___init__impl__ms3zkb(32);
      Spacer(height(tmp_15, tmp$ret$10), $composer_5, 6);
      var tmp_16 = fillMaxWidth(Companion_instance, 0.8);
      Button(onBack, tmp_16, false, null, null, null, null, null, null, ComposableSingletons$AccountManagementScreenKt_getInstance().n10h_1, $composer_5, 805306416 | 14 & $dirty >> 6, 508);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(AccountActionSuccessScreen$lambda(title, message, onBack, $changed));
    }
  }
  function ComposableSingletons$AccountManagementScreenKt$lambda$739947650$lambda($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C60@2408L45,60@2403L72:AccountManagementScreen.kt#8c7j0c');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(739947650, $changed, -1, 'client.fstech.hadaya.presentation.accountmanagement.ComposableSingletons$AccountManagementScreenKt.lambda$739947650.<anonymous> (AccountManagementScreen.kt:60)');
      }
      var tmp = stringResource(get_delete_account_btn(string_instance), $composer_0, 0);
      var tmp_0 = Companion_getInstance_14().m6b_1;
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 384, 0, 262138);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$AccountManagementScreenKt$lambda$472122709$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C63@2550L31,63@2545L37:AccountManagementScreen.kt#8c7j0c');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(472122709, $changed, -1, 'client.fstech.hadaya.presentation.accountmanagement.ComposableSingletons$AccountManagementScreenKt.lambda$472122709.<anonymous> (AccountManagementScreen.kt:63)');
      }
      var tmp = stringResource(get_back(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$AccountManagementScreenKt$lambda$1339969874$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C110@4164L38,110@4159L44:AccountManagementScreen.kt#8c7j0c');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1339969874, $changed, -1, 'client.fstech.hadaya.presentation.accountmanagement.ComposableSingletons$AccountManagementScreenKt.lambda$1339969874.<anonymous> (AccountManagementScreen.kt:110)');
      }
      var tmp = stringResource(get_email_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$AccountManagementScreenKt$lambda$1696995707$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C117@4477L41,117@4472L47:AccountManagementScreen.kt#8c7j0c');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1696995707, $changed, -1, 'client.fstech.hadaya.presentation.accountmanagement.ComposableSingletons$AccountManagementScreenKt.lambda$1696995707.<anonymous> (AccountManagementScreen.kt:117)');
      }
      var tmp = stringResource(get_password_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$AccountManagementScreenKt$lambda$_163771654$lambda_jahqjt($this$OutlinedButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C154@6382L45,154@6377L51:AccountManagementScreen.kt#8c7j0c');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-163771654, $changed, -1, 'client.fstech.hadaya.presentation.accountmanagement.ComposableSingletons$AccountManagementScreenKt.lambda$-163771654.<anonymous> (AccountManagementScreen.kt:154)');
      }
      var tmp = stringResource(get_delete_with_google(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$AccountManagementScreenKt$lambda$_318953974$lambda_9kdd00($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C162@6626L31,162@6621L37:AccountManagementScreen.kt#8c7j0c');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-318953974, $changed, -1, 'client.fstech.hadaya.presentation.accountmanagement.ComposableSingletons$AccountManagementScreenKt.lambda$-318953974.<anonymous> (AccountManagementScreen.kt:162)');
      }
      var tmp = stringResource(get_back(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$AccountManagementScreenKt$lambda$612158138$lambda($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C195@7588L43,195@7583L49:AccountManagementScreen.kt#8c7j0c');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(612158138, $changed, -1, 'client.fstech.hadaya.presentation.accountmanagement.ComposableSingletons$AccountManagementScreenKt.lambda$612158138.<anonymous> (AccountManagementScreen.kt:195)');
      }
      var tmp = stringResource(get_back_to_home_btn(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$AccountManagementScreenKt() {
    ComposableSingletons$AccountManagementScreenKt_instance = this;
    var tmp = this;
    tmp.h10h_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(739947650, false, ComposableSingletons$AccountManagementScreenKt$lambda$739947650$lambda));
    var tmp_0 = this;
    tmp_0.i10h_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(472122709, false, ComposableSingletons$AccountManagementScreenKt$lambda$472122709$lambda));
    var tmp_1 = this;
    tmp_1.j10h_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1339969874, false, ComposableSingletons$AccountManagementScreenKt$lambda$1339969874$lambda));
    var tmp_2 = this;
    tmp_2.k10h_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1696995707, false, ComposableSingletons$AccountManagementScreenKt$lambda$1696995707$lambda));
    var tmp_3 = this;
    tmp_3.l10h_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-163771654, false, ComposableSingletons$AccountManagementScreenKt$lambda$_163771654$lambda_jahqjt));
    var tmp_4 = this;
    tmp_4.m10h_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-318953974, false, ComposableSingletons$AccountManagementScreenKt$lambda$_318953974$lambda_9kdd00));
    var tmp_5 = this;
    tmp_5.n10h_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(612158138, false, ComposableSingletons$AccountManagementScreenKt$lambda$612158138$lambda));
  }
  var ComposableSingletons$AccountManagementScreenKt_instance;
  function ComposableSingletons$AccountManagementScreenKt_getInstance() {
    if (ComposableSingletons$AccountManagementScreenKt_instance == null)
      new ComposableSingletons$AccountManagementScreenKt();
    return ComposableSingletons$AccountManagementScreenKt_instance;
  }
  function AccountManagementScreen$lambda($onNavigateBack, $onNavigateToResetPassword, $onNavigateToDeleteAccount, $$changed) {
    return function ($composer, $force) {
      AccountManagementScreen($onNavigateBack, $onNavigateToResetPassword, $onNavigateToDeleteAccount, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function DeleteAccountStandaloneScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function DeleteAccountStandaloneScreen$lambda_0($email$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('email', KMutableProperty0, true);
    return $email$delegate.u1();
  }
  function DeleteAccountStandaloneScreen$lambda_1($email$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('email', KMutableProperty0, true);
    $email$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function DeleteAccountStandaloneScreen$lambda_2($password$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('password', KMutableProperty0, true);
    return $password$delegate.u1();
  }
  function DeleteAccountStandaloneScreen$lambda_3($password$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('password', KMutableProperty0, true);
    $password$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function DeleteAccountStandaloneScreen$lambda_4($error$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('error', KMutableProperty0, true);
    return $error$delegate.u1();
  }
  function DeleteAccountStandaloneScreen$lambda_5($error$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('error', KMutableProperty0, true);
    $error$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function DeleteAccountStandaloneScreen$slambda($token, $viewModel, $emailFromUrl, resultContinuation) {
    this.f10i_1 = $token;
    this.g10i_1 = $viewModel;
    this.h10i_1 = $emailFromUrl;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DeleteAccountStandaloneScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DeleteAccountStandaloneScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DeleteAccountStandaloneScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          if (!(this.f10i_1._v == null)) {
            this.g10i_1.s10h().j10i(new DeleteAccountWithToken(this.f10i_1._v, this.h10i_1._v));
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(DeleteAccountStandaloneScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new DeleteAccountStandaloneScreen$slambda(this.f10i_1, this.g10i_1, this.h10i_1, completion);
    i.i10i_1 = $this$LaunchedEffect;
    return i;
  };
  function DeleteAccountStandaloneScreen$slambda_0($token, $viewModel, $emailFromUrl, resultContinuation) {
    var i = new DeleteAccountStandaloneScreen$slambda($token, $viewModel, $emailFromUrl, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_2(function_0) {
    this.k10i_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).a1v = function (value, $completion) {
    return this.k10i_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).q3 = function () {
    return this.k10i_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).hashCode = function () {
    return hashCode(this.q3());
  };
  function DeleteAccountStandaloneScreen$slambda$slambda($onNavigateToSuccess, $error$delegate, resultContinuation) {
    this.t10i_1 = $onNavigateToSuccess;
    this.u10i_1 = $error$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DeleteAccountStandaloneScreen$slambda$slambda).w10i = function (effect, $completion) {
    var tmp = this.x10i(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DeleteAccountStandaloneScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.w10i((!(p1 == null) ? isInterface(p1, AccountManagementSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DeleteAccountStandaloneScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_subject = this.v10i_1;
            if (equals(tmp0_subject, NavigateToSuccess_instance)) {
              this.t10i_1();
              this.n9_1 = 2;
              continue $sm;
            } else {
              if (tmp0_subject instanceof ShowError) {
                this.n9_1 = 1;
                suspendResult = this.v10i_1.y10i_1.z10i(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                noWhenBranchMatchedException();
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            DeleteAccountStandaloneScreen$lambda_5(this.u10i_1, ARGUMENT);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DeleteAccountStandaloneScreen$slambda$slambda).x10i = function (effect, completion) {
    var i = new DeleteAccountStandaloneScreen$slambda$slambda(this.t10i_1, this.u10i_1, completion);
    i.v10i_1 = effect;
    return i;
  };
  function DeleteAccountStandaloneScreen$slambda$slambda_0($onNavigateToSuccess, $error$delegate, resultContinuation) {
    var i = new DeleteAccountStandaloneScreen$slambda$slambda($onNavigateToSuccess, $error$delegate, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.w10i(effect, $completion);
    }, 1);
  }
  function DeleteAccountStandaloneScreen$slambda_1($viewModel, $onNavigateToSuccess, $error$delegate, resultContinuation) {
    this.i10j_1 = $viewModel;
    this.j10j_1 = $onNavigateToSuccess;
    this.k10j_1 = $error$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DeleteAccountStandaloneScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DeleteAccountStandaloneScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DeleteAccountStandaloneScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.i10j_1.s10h().t10h();
            var tmp_1 = DeleteAccountStandaloneScreen$slambda$slambda_0(this.j10j_1, this.k10j_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_2(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DeleteAccountStandaloneScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new DeleteAccountStandaloneScreen$slambda_1(this.i10j_1, this.j10j_1, this.k10j_1, completion);
    i.l10j_1 = $this$LaunchedEffect;
    return i;
  };
  function DeleteAccountStandaloneScreen$slambda_2($viewModel, $onNavigateToSuccess, $error$delegate, resultContinuation) {
    var i = new DeleteAccountStandaloneScreen$slambda_1($viewModel, $onNavigateToSuccess, $error$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function DeleteAccountStandaloneScreen$lambda_6($email$delegate) {
    return function (it) {
      DeleteAccountStandaloneScreen$lambda_1($email$delegate, it);
      return Unit_instance;
    };
  }
  function DeleteAccountStandaloneScreen$lambda_7($password$delegate) {
    return function (it) {
      DeleteAccountStandaloneScreen$lambda_3($password$delegate, it);
      return Unit_instance;
    };
  }
  function DeleteAccountStandaloneScreen$lambda_8($viewModel, $email$delegate, $password$delegate) {
    return function () {
      $viewModel.s10h().j10i(new DeleteAccount(DeleteAccountStandaloneScreen$lambda_0($email$delegate), DeleteAccountStandaloneScreen$lambda_2($password$delegate)));
      return Unit_instance;
    };
  }
  function DeleteAccountStandaloneScreen$lambda_9($state$delegate) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:AccountManagementScreen.kt#8c7j0c');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1987405508, $changed, -1, 'client.fstech.hadaya.presentation.accountmanagement.DeleteAccountStandaloneScreen.<anonymous>.<anonymous> (AccountManagementScreen.kt:133)');
        }
        if (DeleteAccountStandaloneScreen$lambda($state$delegate).u10h_1) {
          $composer_0.m30(-673270469);
          sourceInformation($composer_0, '134@5337L99');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          var tmp_2 = Companion_getInstance_14().m6b_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_3 = _Dp___init__impl__ms3zkb(2);
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_0, 438, 56);
          $composer_0.n30();
        } else {
          $composer_0.m30(-673127838);
          sourceInformation($composer_0, '136@5487L33,136@5482L60');
          var tmp_6 = stringResource(get_delete(string_instance), $composer_0, 0);
          var tmp_7 = Companion_getInstance_14().m6b_1;
          var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_11 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_6, null, tmp_7, null, tmp_8, null, null, null, tmp_9, null, null, tmp_10, tmp_11, false, 0, 0, null, null, $composer_0, 384, 0, 262138);
          $composer_0.n30();
        }
        var tmp_12;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_12 = Unit_instance;
        }
        tmp = tmp_12;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DeleteAccountStandaloneScreen$lambda_10($email$delegate, $error$delegate) {
    return function () {
      var tmp;
      if (isBlank(DeleteAccountStandaloneScreen$lambda_0($email$delegate))) {
        DeleteAccountStandaloneScreen$lambda_5($error$delegate, 'Email is required for Google delete');
        return Unit_instance;
      }
      var encodedEmail = replace(DeleteAccountStandaloneScreen$lambda_0($email$delegate), '@', '%40');
      var redirectUrl = getOrigin() + '/accountmanagement?action=delete&email=' + encodedEmail;
      var googleDeleteUrl = 'https://obujqoowtjzxwqpyqinh.supabase.co/auth/v1/authorize?provider=google&redirect_to=' + redirectUrl;
      openUrl(googleDeleteUrl);
      return Unit_instance;
    };
  }
  function DeleteAccountStandaloneScreen$lambda_11($token, $emailFromUrl, $onNavigateToSuccess, $onBack, $$changed, $$default) {
    return function ($composer, $force) {
      DeleteAccountStandaloneScreen($token._v, $emailFromUrl._v, $onNavigateToSuccess, $onBack, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function AccountActionSuccessScreen$lambda($title, $message, $onBack, $$changed) {
    return function ($composer, $force) {
      AccountActionSuccessScreen($title, $message, $onBack, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_accountmanagement_AccountManagementState$stable;
  var client_fstech_hadaya_presentation_accountmanagement_AccountManagementIntent_DeleteAccount$stable;
  var client_fstech_hadaya_presentation_accountmanagement_AccountManagementIntent_DeleteAccountWithToken$stable;
  var client_fstech_hadaya_presentation_accountmanagement_AccountManagementSideEffect_ShowError$stable;
  var client_fstech_hadaya_presentation_accountmanagement_AccountManagementSideEffect_NavigateToSuccess$stable;
  var client_fstech_hadaya_presentation_accountmanagement_AccountManagementViewModel$stable;
  function deleteAccount($this, email, password, $completion) {
    var tmp = new $deleteAccountCOROUTINE$_0($this, email, password, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function deleteAccountWithToken($this, token, email, $completion) {
    var tmp = new $deleteAccountWithTokenCOROUTINE$($this, token, email, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function AccountManagementViewModel$deleteAccount$lambda($this$updateState) {
    return $this$updateState.i10k(true, null);
  }
  function AccountManagementViewModel$deleteAccount$lambda_0($this$updateState) {
    return $this$updateState.i10k(VOID, 'Failed to delete account');
  }
  function AccountManagementViewModel$deleteAccount$lambda_1($e) {
    return function ($this$updateState) {
      return $this$updateState.i10k(VOID, $e.message);
    };
  }
  function AccountManagementViewModel$deleteAccount$lambda_2($this$updateState) {
    return $this$updateState.i10k(false);
  }
  function AccountManagementViewModel$deleteAccountWithToken$lambda($this$updateState) {
    return $this$updateState.i10k(true, null);
  }
  function AccountManagementViewModel$deleteAccountWithToken$lambda_0($this$updateState) {
    return $this$updateState.i10k(VOID, 'Failed to delete account with token');
  }
  function AccountManagementViewModel$deleteAccountWithToken$lambda_1($e) {
    return function ($this$updateState) {
      return $this$updateState.i10k(VOID, $e.message);
    };
  }
  function AccountManagementViewModel$deleteAccountWithToken$lambda_2($this$updateState) {
    return $this$updateState.i10k(false);
  }
  function $handleIntentCOROUTINE$(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r10k_1 = _this__u8e3s4;
    this.s10k_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp0_subject = this.s10k_1;
            if (tmp0_subject instanceof DeleteAccount) {
              this.n9_1 = 2;
              suspendResult = deleteAccount(this.r10k_1, this.s10k_1.v10k_1, this.s10k_1.w10k_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof DeleteAccountWithToken) {
                this.n9_1 = 1;
                suspendResult = deleteAccountWithToken(this.r10k_1, this.s10k_1.t10k_1, this.s10k_1.u10k_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                noWhenBranchMatchedException();
              }
            }

            break;
          case 1:
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $deleteAccountCOROUTINE$_0(_this__u8e3s4, email, password, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u10j_1 = _this__u8e3s4;
    this.v10j_1 = email;
    this.w10j_1 = password;
  }
  protoOf($deleteAccountCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.u10j_1.x10k(AccountManagementViewModel$deleteAccount$lambda);
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 6;
            this.o9_1 = 5;
            this.n9_1 = 2;
            suspendResult = this.u10j_1.c10l_1.vyv(this.w10j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var success = suspendResult;
            if (success) {
              this.n9_1 = 3;
              suspendResult = this.u10j_1.d10l(NavigateToSuccess_instance, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.u10j_1.x10k(AccountManagementViewModel$deleteAccount$lambda_0);
              this.n9_1 = 4;
              continue $sm;
            }

          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.o9_1 = 8;
            this.n9_1 = 7;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.u10j_1.x10k(AccountManagementViewModel$deleteAccount$lambda_1(e));
              this.o9_1 = 8;
              this.n9_1 = 7;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 6:
            this.o9_1 = 8;
            var t = this.q9_1;
            this.u10j_1.x10k(AccountManagementViewModel$deleteAccount$lambda_2);
            throw t;
          case 7:
            this.o9_1 = 8;
            this.u10j_1.x10k(AccountManagementViewModel$deleteAccount$lambda_2);
            return Unit_instance;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 8) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $deleteAccountWithTokenCOROUTINE$(_this__u8e3s4, token, email, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f10k_1 = _this__u8e3s4;
    this.g10k_1 = token;
    this.h10k_1 = email;
  }
  protoOf($deleteAccountWithTokenCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.f10k_1.x10k(AccountManagementViewModel$deleteAccountWithToken$lambda);
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 6;
            this.o9_1 = 5;
            this.n9_1 = 2;
            suspendResult = this.f10k_1.c10l_1.wyv(this.g10k_1, this.h10k_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var success = suspendResult;
            if (success) {
              this.n9_1 = 3;
              suspendResult = this.f10k_1.d10l(NavigateToSuccess_instance, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.f10k_1.x10k(AccountManagementViewModel$deleteAccountWithToken$lambda_0);
              this.n9_1 = 4;
              continue $sm;
            }

          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.o9_1 = 8;
            this.n9_1 = 7;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.f10k_1.x10k(AccountManagementViewModel$deleteAccountWithToken$lambda_1(e));
              this.o9_1 = 8;
              this.n9_1 = 7;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 6:
            this.o9_1 = 8;
            var t = this.q9_1;
            this.f10k_1.x10k(AccountManagementViewModel$deleteAccountWithToken$lambda_2);
            throw t;
          case 7:
            this.o9_1 = 8;
            this.f10k_1.x10k(AccountManagementViewModel$deleteAccountWithToken$lambda_2);
            return Unit_instance;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 8) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function AccountManagementViewModel(authRepository) {
    BaseMviViewModel.call(this, new AccountManagementState());
    this.c10l_1 = authRepository;
  }
  protoOf(AccountManagementViewModel).e10l = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AccountManagementViewModel).f10l = function (intent, $completion) {
    return this.e10l(isInterface(intent, AccountManagementIntent) ? intent : THROW_CCE(), $completion);
  };
  function AccountManagementState(isLoading, error, success) {
    isLoading = isLoading === VOID ? false : isLoading;
    error = error === VOID ? null : error;
    success = success === VOID ? false : success;
    this.u10h_1 = isLoading;
    this.v10h_1 = error;
    this.w10h_1 = success;
  }
  protoOf(AccountManagementState).g10l = function (isLoading, error, success) {
    return new AccountManagementState(isLoading, error, success);
  };
  protoOf(AccountManagementState).i10k = function (isLoading, error, success, $super) {
    isLoading = isLoading === VOID ? this.u10h_1 : isLoading;
    error = error === VOID ? this.v10h_1 : error;
    success = success === VOID ? this.w10h_1 : success;
    return $super === VOID ? this.g10l(isLoading, error, success) : $super.g10l.call(this, isLoading, error, success);
  };
  protoOf(AccountManagementState).toString = function () {
    return 'AccountManagementState(isLoading=' + this.u10h_1 + ', error=' + this.v10h_1 + ', success=' + this.w10h_1 + ')';
  };
  protoOf(AccountManagementState).hashCode = function () {
    var result = getBooleanHashCode(this.u10h_1);
    result = imul(result, 31) + (this.v10h_1 == null ? 0 : getStringHashCode(this.v10h_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w10h_1) | 0;
    return result;
  };
  protoOf(AccountManagementState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AccountManagementState))
      return false;
    if (!(this.u10h_1 === other.u10h_1))
      return false;
    if (!(this.v10h_1 == other.v10h_1))
      return false;
    if (!(this.w10h_1 === other.w10h_1))
      return false;
    return true;
  };
  function DeleteAccount(email, password) {
    this.v10k_1 = email;
    this.w10k_1 = password;
  }
  protoOf(DeleteAccount).toString = function () {
    return 'DeleteAccount(email=' + this.v10k_1 + ', password=' + this.w10k_1 + ')';
  };
  protoOf(DeleteAccount).hashCode = function () {
    var result = getStringHashCode(this.v10k_1);
    result = imul(result, 31) + getStringHashCode(this.w10k_1) | 0;
    return result;
  };
  protoOf(DeleteAccount).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeleteAccount))
      return false;
    if (!(this.v10k_1 === other.v10k_1))
      return false;
    if (!(this.w10k_1 === other.w10k_1))
      return false;
    return true;
  };
  function DeleteAccountWithToken(token, email) {
    this.t10k_1 = token;
    this.u10k_1 = email;
  }
  protoOf(DeleteAccountWithToken).toString = function () {
    return 'DeleteAccountWithToken(token=' + this.t10k_1 + ', email=' + this.u10k_1 + ')';
  };
  protoOf(DeleteAccountWithToken).hashCode = function () {
    var result = getStringHashCode(this.t10k_1);
    result = imul(result, 31) + (this.u10k_1 == null ? 0 : getStringHashCode(this.u10k_1)) | 0;
    return result;
  };
  protoOf(DeleteAccountWithToken).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeleteAccountWithToken))
      return false;
    if (!(this.t10k_1 === other.t10k_1))
      return false;
    if (!(this.u10k_1 == other.u10k_1))
      return false;
    return true;
  };
  function AccountManagementIntent() {
  }
  function ShowError() {
  }
  function NavigateToSuccess() {
  }
  protoOf(NavigateToSuccess).toString = function () {
    return 'NavigateToSuccess';
  };
  protoOf(NavigateToSuccess).hashCode = function () {
    return 562799031;
  };
  protoOf(NavigateToSuccess).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateToSuccess))
      return false;
    return true;
  };
  var NavigateToSuccess_instance;
  function NavigateToSuccess_getInstance() {
    return NavigateToSuccess_instance;
  }
  function AccountManagementSideEffect() {
  }
  var client_fstech_hadaya_presentation_auth_AuthState$stable;
  var client_fstech_hadaya_presentation_auth_AuthPage_Login$stable;
  var client_fstech_hadaya_presentation_auth_AuthPage_Register$stable;
  var client_fstech_hadaya_presentation_auth_AuthPage_ForgetPassword$stable;
  var client_fstech_hadaya_presentation_auth_AuthPage_SetPassword$stable;
  var client_fstech_hadaya_presentation_auth_AuthIntent_EmailChanged$stable;
  var client_fstech_hadaya_presentation_auth_AuthIntent_PasswordChanged$stable;
  var client_fstech_hadaya_presentation_auth_AuthIntent_ConfirmPasswordChanged$stable;
  var client_fstech_hadaya_presentation_auth_AuthIntent_RecoveryUrlReceived$stable;
  var client_fstech_hadaya_presentation_auth_AuthIntent_LoginClicked$stable;
  var client_fstech_hadaya_presentation_auth_AuthIntent_GoogleLoginClicked$stable;
  var client_fstech_hadaya_presentation_auth_AuthIntent_RegisterClicked$stable;
  var client_fstech_hadaya_presentation_auth_AuthIntent_ForgetPasswordClicked$stable;
  var client_fstech_hadaya_presentation_auth_AuthIntent_SetPasswordClicked$stable;
  var client_fstech_hadaya_presentation_auth_AuthIntent_TogglePrivacyPolicy$stable;
  var client_fstech_hadaya_presentation_auth_AuthIntent_ToggleKeepLogin$stable;
  var client_fstech_hadaya_presentation_auth_AuthIntent_NavigateTo$stable;
  var client_fstech_hadaya_presentation_auth_AuthSideEffect_NavigateToHome$stable;
  var client_fstech_hadaya_presentation_auth_AuthSideEffect_ShowError$stable;
  var client_fstech_hadaya_presentation_auth_AuthSideEffect_ShowMessage$stable;
  function AuthState(email, password, confirmPassword, accessToken, isLoading, currentPage, acceptedPrivacyPolicy, keepLogin, error) {
    email = email === VOID ? '' : email;
    password = password === VOID ? '' : password;
    confirmPassword = confirmPassword === VOID ? '' : confirmPassword;
    accessToken = accessToken === VOID ? null : accessToken;
    isLoading = isLoading === VOID ? false : isLoading;
    currentPage = currentPage === VOID ? Login_instance : currentPage;
    acceptedPrivacyPolicy = acceptedPrivacyPolicy === VOID ? false : acceptedPrivacyPolicy;
    keepLogin = keepLogin === VOID ? true : keepLogin;
    error = error === VOID ? null : error;
    this.h10l_1 = email;
    this.i10l_1 = password;
    this.j10l_1 = confirmPassword;
    this.k10l_1 = accessToken;
    this.l10l_1 = isLoading;
    this.m10l_1 = currentPage;
    this.n10l_1 = acceptedPrivacyPolicy;
    this.o10l_1 = keepLogin;
    this.p10l_1 = error;
  }
  protoOf(AuthState).q10l = function (email, password, confirmPassword, accessToken, isLoading, currentPage, acceptedPrivacyPolicy, keepLogin, error) {
    return new AuthState(email, password, confirmPassword, accessToken, isLoading, currentPage, acceptedPrivacyPolicy, keepLogin, error);
  };
  protoOf(AuthState).r10l = function (email, password, confirmPassword, accessToken, isLoading, currentPage, acceptedPrivacyPolicy, keepLogin, error, $super) {
    email = email === VOID ? this.h10l_1 : email;
    password = password === VOID ? this.i10l_1 : password;
    confirmPassword = confirmPassword === VOID ? this.j10l_1 : confirmPassword;
    accessToken = accessToken === VOID ? this.k10l_1 : accessToken;
    isLoading = isLoading === VOID ? this.l10l_1 : isLoading;
    currentPage = currentPage === VOID ? this.m10l_1 : currentPage;
    acceptedPrivacyPolicy = acceptedPrivacyPolicy === VOID ? this.n10l_1 : acceptedPrivacyPolicy;
    keepLogin = keepLogin === VOID ? this.o10l_1 : keepLogin;
    error = error === VOID ? this.p10l_1 : error;
    return $super === VOID ? this.q10l(email, password, confirmPassword, accessToken, isLoading, currentPage, acceptedPrivacyPolicy, keepLogin, error) : $super.q10l.call(this, email, password, confirmPassword, accessToken, isLoading, currentPage, acceptedPrivacyPolicy, keepLogin, error);
  };
  protoOf(AuthState).toString = function () {
    return 'AuthState(email=' + this.h10l_1 + ', password=' + this.i10l_1 + ', confirmPassword=' + this.j10l_1 + ', accessToken=' + this.k10l_1 + ', isLoading=' + this.l10l_1 + ', currentPage=' + toString(this.m10l_1) + ', acceptedPrivacyPolicy=' + this.n10l_1 + ', keepLogin=' + this.o10l_1 + ', error=' + this.p10l_1 + ')';
  };
  protoOf(AuthState).hashCode = function () {
    var result = getStringHashCode(this.h10l_1);
    result = imul(result, 31) + getStringHashCode(this.i10l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j10l_1) | 0;
    result = imul(result, 31) + (this.k10l_1 == null ? 0 : getStringHashCode(this.k10l_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l10l_1) | 0;
    result = imul(result, 31) + hashCode(this.m10l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n10l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o10l_1) | 0;
    result = imul(result, 31) + (this.p10l_1 == null ? 0 : getStringHashCode(this.p10l_1)) | 0;
    return result;
  };
  protoOf(AuthState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AuthState))
      return false;
    if (!(this.h10l_1 === other.h10l_1))
      return false;
    if (!(this.i10l_1 === other.i10l_1))
      return false;
    if (!(this.j10l_1 === other.j10l_1))
      return false;
    if (!(this.k10l_1 == other.k10l_1))
      return false;
    if (!(this.l10l_1 === other.l10l_1))
      return false;
    if (!equals(this.m10l_1, other.m10l_1))
      return false;
    if (!(this.n10l_1 === other.n10l_1))
      return false;
    if (!(this.o10l_1 === other.o10l_1))
      return false;
    if (!(this.p10l_1 == other.p10l_1))
      return false;
    return true;
  };
  function EmailChanged(email) {
    this.s10l_1 = email;
  }
  protoOf(EmailChanged).toString = function () {
    return 'EmailChanged(email=' + this.s10l_1 + ')';
  };
  protoOf(EmailChanged).hashCode = function () {
    return getStringHashCode(this.s10l_1);
  };
  protoOf(EmailChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EmailChanged))
      return false;
    if (!(this.s10l_1 === other.s10l_1))
      return false;
    return true;
  };
  function PasswordChanged(password) {
    this.t10l_1 = password;
  }
  protoOf(PasswordChanged).toString = function () {
    return 'PasswordChanged(password=' + this.t10l_1 + ')';
  };
  protoOf(PasswordChanged).hashCode = function () {
    return getStringHashCode(this.t10l_1);
  };
  protoOf(PasswordChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PasswordChanged))
      return false;
    if (!(this.t10l_1 === other.t10l_1))
      return false;
    return true;
  };
  function ConfirmPasswordChanged(password) {
    this.u10l_1 = password;
  }
  protoOf(ConfirmPasswordChanged).toString = function () {
    return 'ConfirmPasswordChanged(password=' + this.u10l_1 + ')';
  };
  protoOf(ConfirmPasswordChanged).hashCode = function () {
    return getStringHashCode(this.u10l_1);
  };
  protoOf(ConfirmPasswordChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConfirmPasswordChanged))
      return false;
    if (!(this.u10l_1 === other.u10l_1))
      return false;
    return true;
  };
  function RecoveryUrlReceived(url) {
    this.v10l_1 = url;
  }
  protoOf(RecoveryUrlReceived).toString = function () {
    return 'RecoveryUrlReceived(url=' + this.v10l_1 + ')';
  };
  protoOf(RecoveryUrlReceived).hashCode = function () {
    return getStringHashCode(this.v10l_1);
  };
  protoOf(RecoveryUrlReceived).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RecoveryUrlReceived))
      return false;
    if (!(this.v10l_1 === other.v10l_1))
      return false;
    return true;
  };
  function LoginClicked() {
  }
  protoOf(LoginClicked).toString = function () {
    return 'LoginClicked';
  };
  protoOf(LoginClicked).hashCode = function () {
    return 822039342;
  };
  protoOf(LoginClicked).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoginClicked))
      return false;
    return true;
  };
  var LoginClicked_instance;
  function LoginClicked_getInstance() {
    return LoginClicked_instance;
  }
  function GoogleLoginClicked(idToken, accessToken) {
    accessToken = accessToken === VOID ? null : accessToken;
    this.w10l_1 = idToken;
    this.x10l_1 = accessToken;
  }
  protoOf(GoogleLoginClicked).toString = function () {
    return 'GoogleLoginClicked(idToken=' + this.w10l_1 + ', accessToken=' + this.x10l_1 + ')';
  };
  protoOf(GoogleLoginClicked).hashCode = function () {
    var result = getStringHashCode(this.w10l_1);
    result = imul(result, 31) + (this.x10l_1 == null ? 0 : getStringHashCode(this.x10l_1)) | 0;
    return result;
  };
  protoOf(GoogleLoginClicked).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GoogleLoginClicked))
      return false;
    if (!(this.w10l_1 === other.w10l_1))
      return false;
    if (!(this.x10l_1 == other.x10l_1))
      return false;
    return true;
  };
  function RegisterClicked() {
  }
  protoOf(RegisterClicked).toString = function () {
    return 'RegisterClicked';
  };
  protoOf(RegisterClicked).hashCode = function () {
    return -777782444;
  };
  protoOf(RegisterClicked).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RegisterClicked))
      return false;
    return true;
  };
  var RegisterClicked_instance;
  function RegisterClicked_getInstance() {
    return RegisterClicked_instance;
  }
  function ForgetPasswordClicked() {
  }
  protoOf(ForgetPasswordClicked).toString = function () {
    return 'ForgetPasswordClicked';
  };
  protoOf(ForgetPasswordClicked).hashCode = function () {
    return -162927953;
  };
  protoOf(ForgetPasswordClicked).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ForgetPasswordClicked))
      return false;
    return true;
  };
  var ForgetPasswordClicked_instance;
  function ForgetPasswordClicked_getInstance() {
    return ForgetPasswordClicked_instance;
  }
  function SetPasswordClicked() {
  }
  protoOf(SetPasswordClicked).toString = function () {
    return 'SetPasswordClicked';
  };
  protoOf(SetPasswordClicked).hashCode = function () {
    return -464022790;
  };
  protoOf(SetPasswordClicked).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetPasswordClicked))
      return false;
    return true;
  };
  var SetPasswordClicked_instance;
  function SetPasswordClicked_getInstance() {
    return SetPasswordClicked_instance;
  }
  function TogglePrivacyPolicy(accepted) {
    this.y10l_1 = accepted;
  }
  protoOf(TogglePrivacyPolicy).toString = function () {
    return 'TogglePrivacyPolicy(accepted=' + this.y10l_1 + ')';
  };
  protoOf(TogglePrivacyPolicy).hashCode = function () {
    return getBooleanHashCode(this.y10l_1);
  };
  protoOf(TogglePrivacyPolicy).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TogglePrivacyPolicy))
      return false;
    if (!(this.y10l_1 === other.y10l_1))
      return false;
    return true;
  };
  function ToggleKeepLogin(keep) {
    this.z10l_1 = keep;
  }
  protoOf(ToggleKeepLogin).toString = function () {
    return 'ToggleKeepLogin(keep=' + this.z10l_1 + ')';
  };
  protoOf(ToggleKeepLogin).hashCode = function () {
    return getBooleanHashCode(this.z10l_1);
  };
  protoOf(ToggleKeepLogin).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ToggleKeepLogin))
      return false;
    if (!(this.z10l_1 === other.z10l_1))
      return false;
    return true;
  };
  function NavigateTo(page) {
    this.a10m_1 = page;
  }
  protoOf(NavigateTo).toString = function () {
    return 'NavigateTo(page=' + toString(this.a10m_1) + ')';
  };
  protoOf(NavigateTo).hashCode = function () {
    return hashCode(this.a10m_1);
  };
  protoOf(NavigateTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateTo))
      return false;
    if (!equals(this.a10m_1, other.a10m_1))
      return false;
    return true;
  };
  function AuthIntent() {
  }
  function NavigateToHome() {
  }
  protoOf(NavigateToHome).toString = function () {
    return 'NavigateToHome';
  };
  protoOf(NavigateToHome).hashCode = function () {
    return 1507468751;
  };
  protoOf(NavigateToHome).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateToHome))
      return false;
    return true;
  };
  var NavigateToHome_instance;
  function NavigateToHome_getInstance() {
    return NavigateToHome_instance;
  }
  function ShowError_0(message) {
    this.b10m_1 = message;
  }
  protoOf(ShowError_0).toString = function () {
    return 'ShowError(message=' + toString(this.b10m_1) + ')';
  };
  protoOf(ShowError_0).hashCode = function () {
    return hashCode(this.b10m_1);
  };
  protoOf(ShowError_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowError_0))
      return false;
    if (!equals(this.b10m_1, other.b10m_1))
      return false;
    return true;
  };
  function ShowMessage(message) {
    this.c10m_1 = message;
  }
  protoOf(ShowMessage).toString = function () {
    return 'ShowMessage(message=' + toString(this.c10m_1) + ')';
  };
  protoOf(ShowMessage).hashCode = function () {
    return hashCode(this.c10m_1);
  };
  protoOf(ShowMessage).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowMessage))
      return false;
    if (!equals(this.c10m_1, other.c10m_1))
      return false;
    return true;
  };
  function AuthSideEffect() {
  }
  function Login() {
  }
  protoOf(Login).toString = function () {
    return 'Login';
  };
  protoOf(Login).hashCode = function () {
    return -1188260628;
  };
  protoOf(Login).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Login))
      return false;
    return true;
  };
  var Login_instance;
  function Login_getInstance() {
    return Login_instance;
  }
  function Register() {
  }
  protoOf(Register).toString = function () {
    return 'Register';
  };
  protoOf(Register).hashCode = function () {
    return 1230173760;
  };
  protoOf(Register).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Register))
      return false;
    return true;
  };
  var Register_instance;
  function Register_getInstance() {
    return Register_instance;
  }
  function ForgetPassword() {
  }
  protoOf(ForgetPassword).toString = function () {
    return 'ForgetPassword';
  };
  protoOf(ForgetPassword).hashCode = function () {
    return 1172676997;
  };
  protoOf(ForgetPassword).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ForgetPassword))
      return false;
    return true;
  };
  var ForgetPassword_instance;
  function ForgetPassword_getInstance() {
    return ForgetPassword_instance;
  }
  function SetPassword() {
  }
  protoOf(SetPassword).toString = function () {
    return 'SetPassword';
  };
  protoOf(SetPassword).hashCode = function () {
    return 195268704;
  };
  protoOf(SetPassword).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetPassword))
      return false;
    return true;
  };
  var SetPassword_instance;
  function SetPassword_getInstance() {
    return SetPassword_instance;
  }
  function AuthNavigator() {
  }
  var client_fstech_hadaya_presentation_auth_AuthNavigatorImpl$stable;
  function AuthNavigatorImpl(appViewModel) {
    this.e10m_1 = appViewModel;
  }
  protoOf(AuthNavigatorImpl).d10m = function (recoveryUrl) {
    this.e10m_1.n108(recoveryUrl);
  };
  function AuthScreen(initialPage, recoveryUrl, onPageChanged, onNavigateToHome, $composer, $changed, $default) {
    var initialPage_0 = {_v: initialPage};
    var recoveryUrl_0 = {_v: recoveryUrl};
    var onPageChanged_0 = {_v: onPageChanged};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1818866763);
    sourceInformation($composer_0, 'C(AuthScreen)P(!1,3,2)55@2402L2,58@2478L15,59@2537L16,61@2587L119,61@2559L147,67@2740L386,67@2712L414,79@3166L287,79@3132L321,91@3518L34,89@3463L193:AuthScreen.kt#5jzhp0');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(initialPage_0._v) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(recoveryUrl_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onPageChanged_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToHome) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        initialPage_0._v = null;
      }
      if (!(($default & 2) === 0)) {
        recoveryUrl_0._v = null;
      }
      if (!(($default & 4) === 0)) {
        sourceInformationMarkerStart($composer_0, -120726387, 'CC(remember):AuthScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = AuthScreen$lambda;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var tmp0_group = tmp;
        sourceInformationMarkerEnd($composer_0);
        onPageChanged_0._v = tmp0_group;
      }
      if (isTraceInProgress()) {
        traceEventStart(1818866763, $dirty, -1, 'client.fstech.hadaya.presentation.auth.AuthScreen (AuthScreen.kt:57)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp_0;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(AuthViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_1 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_1, null, $composer_0, 0, 1);
      var tmp_2 = recoveryUrl_0._v;
      sourceInformationMarkerStart($composer_0, -120720350, 'CC(remember):AuthScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(($dirty & 112) === 32 | $composer_0.q31(viewModel));
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_0.i31();
      var tmp_3;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = AuthScreen$slambda_0(recoveryUrl_0, viewModel, null);
        tmp0_0.j31(value_0);
        tmp_3 = value_0;
      } else {
        tmp_3 = it_0;
      }
      var tmp1_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_2, tmp1_group, $composer_0, 14 & $dirty >> 3);
      var tmp_4 = initialPage_0._v;
      sourceInformationMarkerStart($composer_0, -120715187, 'CC(remember):AuthScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(!!(!!(($dirty & 14) === 4 | $composer_0.k31(state$delegate)) | ($dirty & 112) === 32) | $composer_0.q31(viewModel));
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_1.i31();
      var tmp_5;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = AuthScreen$slambda_2(initialPage_0, recoveryUrl_0, viewModel, state$delegate, null);
        tmp0_1.j31(value_1);
        tmp_5 = value_1;
      } else {
        tmp_5 = it_1;
      }
      var tmp2_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_4, tmp2_group, $composer_0, 14 & $dirty);
      var tmp_6 = AuthScreen$lambda_0(state$delegate).m10l_1;
      sourceInformationMarkerStart($composer_0, -120701654, 'CC(remember):AuthScreen.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!($composer_0.k31(state$delegate) | ($dirty & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_2.i31();
      var tmp_7;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = AuthScreen$slambda_4(onPageChanged_0, state$delegate, null);
        tmp0_2.j31(value_2);
        tmp_7 = value_2;
      } else {
        tmp_7 = it_2;
      }
      var tmp3_group = tmp_7;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_6, tmp3_group, $composer_0, 0);
      var tmp_8 = AuthScreen$lambda_0(state$delegate);
      sourceInformationMarkerStart($composer_0, -120690643, 'CC(remember):AuthScreen.kt#9igjgp');
      var tmp0_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_3 = tmp0_3.i31();
      var tmp_9;
      if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = AuthScreen$lambda_1(viewModel);
        tmp0_3.j31(value_3);
        tmp_9 = value_3;
      } else {
        tmp_9 = it_3;
      }
      var tmp4_group = tmp_9;
      sourceInformationMarkerEnd($composer_0);
      AuthContent(tmp_8, tmp4_group, onNavigateToHome, viewModel.s10h().t10h(), $composer_0, 896 & $dirty >> 3, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp5_safe_receiver = $composer_0.t30();
    if (tmp5_safe_receiver == null)
      null;
    else {
      tmp5_safe_receiver.p3c(AuthScreen$lambda_2(initialPage_0, recoveryUrl_0, onPageChanged_0, onNavigateToHome, $changed, $default));
    }
  }
  function AuthContent(state, onIntent, onNavigateToHome, sideEffect, $composer, $changed, $default) {
    var sideEffect_0 = {_v: sideEffect};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-918707603);
    sourceInformation($composer_0, 'C(AuthContent)P(3)104@3858L32,105@3928L7,106@3963L34,108@4030L408,108@4003L435,119@4477L35,120@4553L11,121@4582L22232,118@4444L22370:AuthScreen.kt#5jzhp0');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onIntent) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToHome) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ((($changed & 4096) === 0 ? $composer_0.k31(sideEffect_0._v) : $composer_0.q31(sideEffect_0._v)) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        sideEffect_0._v = null;
      }
      if (isTraceInProgress()) {
        traceEventStart(-918707603, $dirty, -1, 'client.fstech.hadaya.presentation.auth.AuthContent (AuthScreen.kt:103)');
      }
      sourceInformationMarkerStart($composer_0, 1885262477, 'CC(remember):AuthScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = new SnackbarHostState();
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp0_group;
      var tmp0 = get_LocalUriHandler();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var uriHandler = $composer_1.u31(tmp0);
      sourceInformationMarkerStart($composer_0, 1885265839, 'CC(remember):AuthScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = mutableStateOf(false);
        this_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      var passwordVisible$delegate = tmp1_group;
      var tmp_1 = sideEffect_0._v;
      sourceInformationMarkerStart($composer_0, 1885268357, 'CC(remember):AuthScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!((($dirty & 7168) === 2048 || (!(($dirty & 4096) === 0) && $composer_0.q31(sideEffect_0._v))) | ($dirty & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_0.i31();
      var tmp_2;
      if (invalid || it_1 === Companion_getInstance().f30_1) {
        var value_1 = AuthContent$slambda_0(sideEffect_0, onNavigateToHome, snackbarHostState, null);
        tmp0_0.j31(value_1);
        tmp_2 = value_1;
      } else {
        tmp_2 = it_1;
      }
      var tmp2_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_1, tmp2_group, $composer_0, 14 & $dirty >> 9);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1988621261, true, AuthContent$lambda_1(snackbarHostState), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_2.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_2 = $composer_2.i31();
      var tmp_3;
      if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_2.j31(value_2);
        tmp_3 = value_2;
      } else {
        tmp_3 = it_2;
      }
      var tmp_4 = tmp_3;
      var tmp_5 = _FabPosition___init__impl__9ib2hj(0);
      var tmp_6 = MaterialTheme_instance.unz($composer_0, 6).ko0_1;
      var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      // Inline function 'kotlin.run' call
      var dispatchReceiver_0 = rememberComposableLambda(1391490172, true, AuthContent$lambda_2(uriHandler, state, onIntent, passwordVisible$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_3.k31(dispatchReceiver_0);
      // Inline function 'kotlin.let' call
      var it_3 = $composer_3.i31();
      var tmp_8;
      if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = ComposableLambda$invoke$ref_2(dispatchReceiver_0);
        $composer_3.j31(value_3);
        tmp_8 = value_3;
      } else {
        tmp_8 = it_3;
      }
      var tmp$ret$20 = tmp_8;
      Scaffold(null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, null, tmp$ret$20, $composer_0, 805309440, 439);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp3_safe_receiver = $composer_0.t30();
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.p3c(AuthContent$lambda_3(state, onIntent, onNavigateToHome, sideEffect_0, $changed, $default));
    }
  }
  function ComposableSingletons$AuthScreenKt$lambda$_1875734560$lambda_xlyqef($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C196@8182L45,196@8177L51:AuthScreen.kt#5jzhp0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1875734560, $changed, -1, 'client.fstech.hadaya.presentation.auth.ComposableSingletons$AuthScreenKt.lambda$-1875734560.<anonymous> (AuthScreen.kt:196)');
      }
      var tmp = stringResource(get_new_password_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$AuthScreenKt$lambda$1584215383$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C221@9988L49,221@9983L55:AuthScreen.kt#5jzhp0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1584215383, $changed, -1, 'client.fstech.hadaya.presentation.auth.ComposableSingletons$AuthScreenKt.lambda$1584215383.<anonymous> (AuthScreen.kt:221)');
      }
      var tmp = stringResource(get_confirm_password_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$AuthScreenKt$lambda$_744468951$lambda_y7c1ab($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C236@11089L38,236@11084L44:AuthScreen.kt#5jzhp0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-744468951, $changed, -1, 'client.fstech.hadaya.presentation.auth.ComposableSingletons$AuthScreenKt.lambda$-744468951.<anonymous> (AuthScreen.kt:236)');
      }
      var tmp = stringResource(get_email_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$AuthScreenKt$lambda$_153965180$lambda_m55par($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C252@12171L41,252@12166L47:AuthScreen.kt#5jzhp0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-153965180, $changed, -1, 'client.fstech.hadaya.presentation.auth.ComposableSingletons$AuthScreenKt.lambda$-153965180.<anonymous> (AuthScreen.kt:252)');
      }
      var tmp = stringResource(get_password_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$AuthScreenKt$lambda$505501233$lambda($this$OutlinedButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C429@23213L1037:AuthScreen.kt#5jzhp0');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(505501233, $changed, -1, 'client.fstech.hadaya.presentation.auth.ComposableSingletons$AuthScreenKt.lambda$505501233.<anonymous> (AuthScreen.kt:429)');
      }
      var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = null;
      var horizontalArrangement = Arrangement_getInstance().udp_1;
      var verticalAlignment = tmp0_verticalAlignment;
      var $composer_1 = $composer_0;
      if (!((1 & 1) === 0))
        modifier = Companion_instance;
      if (!((1 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((1 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1655849295, 'C433@23469L340,439@23850L40,441@23988L44,440@23931L281:AuthScreen.kt#5jzhp0');
      var tmp_0 = get_GoogleLogoVector();
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(20);
      Icon(tmp_0, null, size(tmp_1, tmp$ret$6), Companion_getInstance_14().u6b_1, $composer_5, 3504, 0);
      var tmp_2 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(12);
      Spacer(width(tmp_2, tmp$ret$7), $composer_5, 6);
      var tmp_3 = stringResource(get_login_with_google(string_instance), $composer_5, 0);
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = get_sp(16);
      var tmp_6 = Companion_getInstance_16().c7z_1;
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_3, null, tmp_4, null, tmp_5, null, tmp_6, null, tmp_7, null, null, tmp_8, tmp_9, false, 0, 0, null, null, $composer_5, 1597440, 0, 262062);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$AuthScreenKt() {
    ComposableSingletons$AuthScreenKt_instance = this;
    var tmp = this;
    tmp.f10m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1875734560, false, ComposableSingletons$AuthScreenKt$lambda$_1875734560$lambda_xlyqef));
    var tmp_0 = this;
    tmp_0.g10m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1584215383, false, ComposableSingletons$AuthScreenKt$lambda$1584215383$lambda));
    var tmp_1 = this;
    tmp_1.h10m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-744468951, false, ComposableSingletons$AuthScreenKt$lambda$_744468951$lambda_y7c1ab));
    var tmp_2 = this;
    tmp_2.i10m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-153965180, false, ComposableSingletons$AuthScreenKt$lambda$_153965180$lambda_m55par));
    var tmp_3 = this;
    tmp_3.j10m_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(505501233, false, ComposableSingletons$AuthScreenKt$lambda$505501233$lambda));
  }
  var ComposableSingletons$AuthScreenKt_instance;
  function ComposableSingletons$AuthScreenKt_getInstance() {
    if (ComposableSingletons$AuthScreenKt_instance == null)
      new ComposableSingletons$AuthScreenKt();
    return ComposableSingletons$AuthScreenKt_instance;
  }
  function get_GoogleLogoVector() {
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp = _Dp___init__impl__ms3zkb(24);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$1 = _Dp___init__impl__ms3zkb(24);
    // Inline function 'kotlin.apply' call
    var this_0 = new Builder('GoogleLogo', tmp, tmp$ret$1, 24.0, 24.0);
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var fill = new SolidColor(Color(new Long(-12417548, 0)));
    var strokeLineCap = get_DefaultStrokeLineCap();
    var strokeLineJoin = get_DefaultStrokeLineJoin();
    var pathFillType = get_DefaultFillType();
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with = new PathBuilder();
    $this$with.i5s(23.49, 12.27);
    $this$with.i6u(23.49, 11.48, 23.42, 10.73, 23.3, 10.0);
    $this$with.k5s(12.0, 10.0);
    $this$with.h6u(4.51);
    $this$with.f6u(6.51);
    $this$with.i6u(18.19, 15.86, 17.08, 17.55, 15.36, 18.73);
    $this$with.h6u(2.98);
    $this$with.f6u(3.02);
    $this$with.i6u(21.52, 18.42, 23.49, 15.65, 23.49, 12.27);
    $this$with.b6u();
    var tmp$ret$5 = $this$with.a6u();
    this_0.n9n(tmp$ret$5, pathFillType, '', fill, 1.0, null, 1.0, 0.0, strokeLineCap, strokeLineJoin, 4.0);
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var fill_0 = new SolidColor(Color(new Long(-13326253, 0)));
    var strokeLineCap_0 = get_DefaultStrokeLineCap();
    var strokeLineJoin_0 = get_DefaultStrokeLineJoin();
    var pathFillType_0 = get_DefaultFillType();
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with_0 = new PathBuilder();
    $this$with_0.i5s(12.0, 24.0);
    $this$with_0.i6u(15.24, 24.0, 17.96, 22.92, 19.88, 21.09);
    $this$with_0.d6u(-3.02, -2.98);
    $this$with_0.i6u(15.75, 18.79, 14.28, 19.51, 12.0, 19.51);
    $this$with_0.i6u(8.87, 19.51, 6.22, 17.4, 5.27, 14.54);
    $this$with_0.e6u(2.18);
    $this$with_0.h6u(2.34);
    $this$with_0.i6u(4.16, 20.84, 7.85, 24.0, 12.0, 24.0);
    $this$with_0.b6u();
    var tmp$ret$10 = $this$with_0.a6u();
    this_0.n9n(tmp$ret$10, pathFillType_0, '', fill_0, 1.0, null, 1.0, 0.0, strokeLineCap_0, strokeLineJoin_0, 4.0);
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var fill_1 = new SolidColor(Color(new Long(-279547, 0)));
    var strokeLineCap_1 = get_DefaultStrokeLineCap();
    var strokeLineJoin_1 = get_DefaultStrokeLineJoin();
    var pathFillType_1 = get_DefaultFillType();
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with_1 = new PathBuilder();
    $this$with_1.i5s(5.27, 14.54);
    $this$with_1.i6u(5.02, 13.81, 4.88, 13.02, 4.88, 12.22);
    $this$with_1.i6u(4.88, 11.42, 5.02, 10.63, 5.27, 9.9);
    $this$with_1.g6u(7.56);
    $this$with_1.e6u(2.18);
    $this$with_1.i6u(1.36, 9.17, 0.89, 10.99, 0.89, 12.92);
    $this$with_1.i6u(0.89, 14.85, 1.36, 16.67, 2.18, 18.28);
    $this$with_1.d6u(3.09, -2.4);
    $this$with_1.j6u(0.0, -0.44, 0.0, -0.89, 0.0, -1.34);
    $this$with_1.b6u();
    var tmp$ret$15 = $this$with_1.a6u();
    this_0.n9n(tmp$ret$15, pathFillType_1, '', fill_1, 1.0, null, 1.0, 0.0, strokeLineCap_1, strokeLineJoin_1, 4.0);
    // Inline function 'androidx.compose.ui.graphics.vector.path' call
    var fill_2 = new SolidColor(Color(new Long(-1424587, 0)));
    var strokeLineCap_2 = get_DefaultStrokeLineCap();
    var strokeLineJoin_2 = get_DefaultStrokeLineJoin();
    var pathFillType_2 = get_DefaultFillType();
    // Inline function 'androidx.compose.ui.graphics.vector.PathData' call
    // Inline function 'kotlin.with' call
    var $this$with_2 = new PathBuilder();
    $this$with_2.i5s(12.0, 4.88);
    $this$with_2.i6u(13.81, 4.88, 15.42, 5.51, 16.71, 6.74);
    $this$with_2.d6u(3.26, -3.26);
    $this$with_2.i6u(17.95, 1.34, 15.24, 0.0, 12.0, 0.0);
    $this$with_2.i6u(7.85, 0.0, 4.16, 3.16, 2.18, 7.16);
    $this$with_2.d6u(3.09, 2.4);
    $this$with_2.i6u(6.22, 6.6, 8.87, 4.88, 12.0, 4.88);
    $this$with_2.b6u();
    var tmp$ret$20 = $this$with_2.a6u();
    this_0.n9n(tmp$ret$20, pathFillType_2, '', fill_2, 1.0, null, 1.0, 0.0, strokeLineCap_2, strokeLineJoin_2, 4.0);
    return this_0.g3d();
  }
  function AuthScreen$lambda(it) {
    return Unit_instance;
  }
  function AuthScreen$lambda_0($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function AuthScreen$slambda($recoveryUrl, $viewModel, resultContinuation) {
    this.s10m_1 = $recoveryUrl;
    this.t10m_1 = $viewModel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0_safe_receiver = this.s10m_1._v;
          if (tmp0_safe_receiver == null)
            null;
          else {
            this.t10m_1.s10h().j10i(new RecoveryUrlReceived(tmp0_safe_receiver));
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(AuthScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new AuthScreen$slambda(this.s10m_1, this.t10m_1, completion);
    i.u10m_1 = $this$LaunchedEffect;
    return i;
  };
  function AuthScreen$slambda_0($recoveryUrl, $viewModel, resultContinuation) {
    var i = new AuthScreen$slambda($recoveryUrl, $viewModel, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function AuthScreen$slambda_1($initialPage, $recoveryUrl, $viewModel, $state$delegate, resultContinuation) {
    this.d10n_1 = $initialPage;
    this.e10n_1 = $recoveryUrl;
    this.f10n_1 = $viewModel;
    this.g10n_1 = $state$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var page;
          switch (this.d10n_1._v) {
            case 'signup':
              page = Register_instance;
              break;
            case 'forgot-password':
              page = ForgetPassword_instance;
              break;
            case 'reset-password':
              page = SetPassword_instance;
              break;
            default:
              page = Login_instance;
              break;
          }
          if (!equals(AuthScreen$lambda_0(this.g10n_1).m10l_1, page) && this.e10n_1._v == null) {
            this.f10n_1.s10h().j10i(new NavigateTo(page));
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(AuthScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new AuthScreen$slambda_1(this.d10n_1, this.e10n_1, this.f10n_1, this.g10n_1, completion);
    i.h10n_1 = $this$LaunchedEffect;
    return i;
  };
  function AuthScreen$slambda_2($initialPage, $recoveryUrl, $viewModel, $state$delegate, resultContinuation) {
    var i = new AuthScreen$slambda_1($initialPage, $recoveryUrl, $viewModel, $state$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function AuthScreen$slambda_3($onPageChanged, $state$delegate, resultContinuation) {
    this.q10n_1 = $onPageChanged;
    this.r10n_1 = $state$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthScreen$slambda_3).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthScreen$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthScreen$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0_subject = AuthScreen$lambda_0(this.r10n_1).m10l_1;
          var tmp_0;
          if (equals(tmp0_subject, Register_instance)) {
            tmp_0 = 'signup';
          } else if (equals(tmp0_subject, ForgetPassword_instance)) {
            tmp_0 = 'forgot-password';
          } else if (equals(tmp0_subject, SetPassword_instance)) {
            tmp_0 = 'reset-password';
          } else if (equals(tmp0_subject, Login_instance)) {
            tmp_0 = 'login';
          } else {
            noWhenBranchMatchedException();
          }
          var pageStr = tmp_0;
          this.q10n_1._v(pageStr);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(AuthScreen$slambda_3).q24 = function ($this$LaunchedEffect, completion) {
    var i = new AuthScreen$slambda_3(this.q10n_1, this.r10n_1, completion);
    i.s10n_1 = $this$LaunchedEffect;
    return i;
  };
  function AuthScreen$slambda_4($onPageChanged, $state$delegate, resultContinuation) {
    var i = new AuthScreen$slambda_3($onPageChanged, $state$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function AuthScreen$lambda_1($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(it);
      return Unit_instance;
    };
  }
  function AuthScreen$lambda_2($initialPage, $recoveryUrl, $onPageChanged, $onNavigateToHome, $$changed, $$default) {
    return function ($composer, $force) {
      AuthScreen($initialPage._v, $recoveryUrl._v, $onPageChanged._v, $onNavigateToHome, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function AuthContent$lambda($passwordVisible$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('passwordVisible', KMutableProperty0, true);
    return $passwordVisible$delegate.u1();
  }
  function AuthContent$lambda_0($passwordVisible$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('passwordVisible', KMutableProperty0, true);
    $passwordVisible$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_3(function_0) {
    this.t10n_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).a1v = function (value, $completion) {
    return this.t10n_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).q3 = function () {
    return this.t10n_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).hashCode = function () {
    return hashCode(this.q3());
  };
  function AuthContent$slambda$slambda($onNavigateToHome, $snackbarHostState, resultContinuation) {
    this.c10o_1 = $onNavigateToHome;
    this.d10o_1 = $snackbarHostState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthContent$slambda$slambda).g10o = function (effect, $completion) {
    var tmp = this.h10o(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthContent$slambda$slambda).ja = function (p1, $completion) {
    return this.g10o((!(p1 == null) ? isInterface(p1, AuthSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthContent$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp0_subject = this.e10o_1;
            if (tmp0_subject instanceof NavigateToHome) {
              this.f10o_1 = this.c10o_1();
              this.n9_1 = 6;
              continue $sm;
            } else {
              if (tmp0_subject instanceof ShowError_0) {
                this.n9_1 = 3;
                suspendResult = this.e10o_1.b10m_1.z10i(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (tmp0_subject instanceof ShowMessage) {
                  this.n9_1 = 1;
                  suspendResult = this.e10o_1.c10m_1.z10i(this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.d10o_1.dqm(ARGUMENT, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f10o_1 = suspendResult;
            this.n9_1 = 6;
            continue $sm;
          case 3:
            var ARGUMENT_0 = suspendResult;
            this.n9_1 = 4;
            suspendResult = this.d10o_1.dqm(ARGUMENT_0, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.f10o_1 = suspendResult;
            this.n9_1 = 6;
            continue $sm;
          case 5:
            throw this.q9_1;
          case 6:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AuthContent$slambda$slambda).h10o = function (effect, completion) {
    var i = new AuthContent$slambda$slambda(this.c10o_1, this.d10o_1, completion);
    i.e10o_1 = effect;
    return i;
  };
  function AuthContent$slambda$slambda_0($onNavigateToHome, $snackbarHostState, resultContinuation) {
    var i = new AuthContent$slambda$slambda($onNavigateToHome, $snackbarHostState, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.g10o(effect, $completion);
    }, 1);
  }
  function AuthContent$slambda($sideEffect, $onNavigateToHome, $snackbarHostState, resultContinuation) {
    this.q10o_1 = $sideEffect;
    this.r10o_1 = $onNavigateToHome;
    this.s10o_1 = $snackbarHostState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthContent$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthContent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthContent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_safe_receiver = this.q10o_1._v;
            if (tmp0_safe_receiver == null) {
              this.u10o_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              var tmp_0 = AuthContent$slambda$slambda_0(this.r10o_1, this.s10o_1, null);
              suspendResult = tmp0_safe_receiver.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_3(tmp_0), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_1 = this;
            tmp_1.u10o_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AuthContent$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new AuthContent$slambda(this.q10o_1, this.r10o_1, this.s10o_1, completion);
    i.t10o_1 = $this$LaunchedEffect;
    return i;
  };
  function AuthContent$slambda_0($sideEffect, $onNavigateToHome, $snackbarHostState, resultContinuation) {
    var i = new AuthContent$slambda($sideEffect, $onNavigateToHome, $snackbarHostState, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function AuthContent$lambda_1($snackbarHostState) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C119@4479L31:AuthScreen.kt#5jzhp0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1988621261, $changed, -1, 'client.fstech.hadaya.presentation.auth.AuthContent.<anonymous> (AuthScreen.kt:119)');
        }
        SnackbarHost($snackbarHostState, null, null, $composer_0, 6, 6);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda($uriHandler) {
    return function () {
      $uriHandler.qdd('https://abdallabadreldin.github.io/hadaya_special_links/');
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda($this$AnimatedContent) {
    return togetherWith(fadeIn(tween(300)), fadeOut(tween(300)));
  }
  function AuthContent$lambda$lambda$lambda$lambda($onIntent) {
    return function (it) {
      $onIntent(new PasswordChanged(it));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda$lambda($passwordVisible$delegate) {
    return function () {
      AuthContent$lambda_0($passwordVisible$delegate, !AuthContent$lambda($passwordVisible$delegate));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda$lambda_0($passwordVisible$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C200@8575L368:AuthScreen.kt#5jzhp0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1742808417, $changed, -1, 'client.fstech.hadaya.presentation.auth.AuthContent.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (AuthScreen.kt:200)');
        }
        var tmp_0 = AuthContent$lambda($passwordVisible$delegate) ? get_Visibility(Filled_instance) : get_VisibilityOff(Filled_instance);
        var tmp_1;
        if (AuthContent$lambda($passwordVisible$delegate)) {
          $composer_0.m30(198365767);
          sourceInformation($composer_0, '202@8811L40');
          var tmp0_group = stringResource(get_hide_password(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_1 = tmp0_group;
        } else {
          $composer_0.m30(198367239);
          sourceInformation($composer_0, '202@8857L40');
          var tmp1_group = stringResource(get_show_password(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_1 = tmp1_group;
        }
        var tmp_2 = tmp_1;
        Icon(tmp_0, tmp_2, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_0($passwordVisible$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C199@8489L38,199@8529L456,199@8468L517:AuthScreen.kt#5jzhp0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-269890051, $changed, -1, 'client.fstech.hadaya.presentation.auth.AuthContent.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (AuthScreen.kt:199)');
        }
        sourceInformationMarkerStart($composer_0, -1666299197, 'CC(remember):AuthScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = AuthContent$lambda$lambda$lambda$lambda$lambda($passwordVisible$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1742808417, true, AuthContent$lambda$lambda$lambda$lambda$lambda_0($passwordVisible$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_1;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_0;
        }
        var tmp$ret$4 = tmp_1;
        IconButton(tmp0_group, null, false, null, null, null, tmp$ret$4, $composer_0, 1572870, 62);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_1($onIntent) {
    return function (it) {
      $onIntent(new ConfirmPasswordChanged(it));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_2($onIntent) {
    return function (it) {
      $onIntent(new EmailChanged(it));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_3($onIntent) {
    return function (it) {
      $onIntent(new PasswordChanged(it));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda$lambda_1($passwordVisible$delegate) {
    return function () {
      AuthContent$lambda_0($passwordVisible$delegate, !AuthContent$lambda($passwordVisible$delegate));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda$lambda_2($passwordVisible$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C256@12576L380:AuthScreen.kt#5jzhp0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1176254141, $changed, -1, 'client.fstech.hadaya.presentation.auth.AuthContent.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (AuthScreen.kt:256)');
        }
        var tmp_0 = AuthContent$lambda($passwordVisible$delegate) ? get_Visibility(Filled_instance) : get_VisibilityOff(Filled_instance);
        var tmp_1;
        if (AuthContent$lambda($passwordVisible$delegate)) {
          $composer_0.m30(-803821205);
          sourceInformation($composer_0, '258@12820L40');
          var tmp0_group = stringResource(get_hide_password(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_1 = tmp0_group;
        } else {
          $composer_0.m30(-803819733);
          sourceInformation($composer_0, '258@12866L40');
          var tmp1_group = stringResource(get_show_password(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_1 = tmp1_group;
        }
        var tmp_2 = tmp_1;
        Icon(tmp_0, tmp_2, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_4($passwordVisible$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C255@12486L38,255@12526L476,255@12465L537:AuthScreen.kt#5jzhp0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(237797025, $changed, -1, 'client.fstech.hadaya.presentation.auth.AuthContent.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (AuthScreen.kt:255)');
        }
        sourceInformationMarkerStart($composer_0, 889676519, 'CC(remember):AuthScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = AuthContent$lambda$lambda$lambda$lambda$lambda_1($passwordVisible$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1176254141, true, AuthContent$lambda$lambda$lambda$lambda$lambda_2($passwordVisible$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_1;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_0;
        }
        var tmp$ret$4 = tmp_1;
        IconButton(tmp0_group, null, false, null, null, null, tmp$ret$4, $composer_0, 1572870, 62);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_5($onIntent) {
    return function () {
      $onIntent(new NavigateTo(ForgetPassword_instance));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_6($onIntent) {
    return function (it) {
      $onIntent(new ToggleKeepLogin(it));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_7($onIntent, $state) {
    return function () {
      $onIntent(new ToggleKeepLogin(!$state.o10l_1));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_8($onIntent) {
    return function (it) {
      $onIntent(new ToggleKeepLogin(it));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_9($onIntent, $state) {
    return function () {
      $onIntent(new ToggleKeepLogin(!$state.o10l_1));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_10($onIntent) {
    return function (it) {
      $onIntent(new TogglePrivacyPolicy(it));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_11($page, $onIntent) {
    return function () {
      var tmp0_subject = $page;
      var tmp;
      if (equals(tmp0_subject, Login_instance)) {
        tmp = $onIntent(LoginClicked_instance);
      } else if (equals(tmp0_subject, Register_instance)) {
        tmp = $onIntent(RegisterClicked_instance);
      } else if (equals(tmp0_subject, ForgetPassword_instance)) {
        tmp = $onIntent(ForgetPasswordClicked_instance);
      } else if (equals(tmp0_subject, SetPassword_instance)) {
        tmp = $onIntent(SetPasswordClicked_instance);
      } else {
        noWhenBranchMatchedException();
      }
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_12($state, $page) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:AuthScreen.kt#5jzhp0');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2098418853, $changed, -1, 'client.fstech.hadaya.presentation.auth.AuthContent.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (AuthScreen.kt:374)');
        }
        if ($state.l10l_1) {
          $composer_0.m30(-746991682);
          sourceInformation($composer_0, '375@19927L257');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          var tmp_2 = Companion_getInstance_14().m6b_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_3 = _Dp___init__impl__ms3zkb(2);
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_0, 438, 56);
          $composer_0.n30();
        } else {
          $composer_0.m30(-746645784);
          sourceInformation($composer_0, '381@20262L695');
          var tmp0_subject = $page;
          var tmp_6;
          if (equals(tmp0_subject, Login_instance)) {
            $composer_0.m30(2054129247);
            sourceInformation($composer_0, '383@20391L36');
            var tmp0_group = stringResource(get_login_btn(string_instance), $composer_0, 0);
            $composer_0.n30();
            tmp_6 = tmp0_group;
          } else if (equals(tmp0_subject, Register_instance)) {
            $composer_0.m30(2054132513);
            sourceInformation($composer_0, '384@20493L38');
            var tmp1_group = stringResource(get_sign_up_btn(string_instance), $composer_0, 0);
            $composer_0.n30();
            tmp_6 = tmp1_group;
          } else if (equals(tmp0_subject, ForgetPassword_instance)) {
            $composer_0.m30(2054136041);
            sourceInformation($composer_0, '385@20603L46');
            var tmp2_group = stringResource(get_send_reset_link_btn(string_instance), $composer_0, 0);
            $composer_0.n30();
            tmp_6 = tmp2_group;
          } else if (equals(tmp0_subject, SetPassword_instance)) {
            $composer_0.m30(2054139706);
            sourceInformation($composer_0, '386@20718L31');
            var tmp3_group = stringResource(get_save(string_instance), $composer_0, 0);
            $composer_0.n30();
            tmp_6 = tmp3_group;
          } else {
            $composer_0.m30(2054127255);
            $composer_0.n30();
            noWhenBranchMatchedException();
          }
          var tmp_7 = tmp_6;
          var tmp_8 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_9 = get_sp(16);
          var tmp_10 = Companion_getInstance_16().e7z_1;
          var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_13 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_7, null, tmp_8, null, tmp_9, null, tmp_10, null, tmp_11, null, null, tmp_12, tmp_13, false, 0, 0, null, null, $composer_0, 1597440, 0, 262062);
          $composer_0.n30();
        }
        var tmp_14;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_14 = Unit_instance;
        }
        tmp = tmp_14;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda$lambda_3($onIntent) {
    return function (idToken) {
      $onIntent(new GoogleLoginClicked(idToken));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_13($onIntent) {
    return function () {
      triggerGoogleLogin('696246114214-oe5ktork8tnejv7qi1s2ahujc1d4h9jo.apps.googleusercontent.com', AuthContent$lambda$lambda$lambda$lambda$lambda_3($onIntent));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda$lambda_14($page, $onIntent) {
    return function () {
      var tmp0_subject = $page;
      var nextPage = equals(tmp0_subject, Login_instance) ? Register_instance : equals(tmp0_subject, SetPassword_instance) ? Login_instance : Login_instance;
      $onIntent(new NavigateTo(nextPage));
      return Unit_instance;
    };
  }
  function AuthContent$lambda$lambda$lambda_0($state, $onIntent, $passwordVisible$delegate) {
    return function ($this$AnimatedContent, page, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C173@6776L19968:AuthScreen.kt#5jzhp0');
      var $dirty = $changed;
      var tmp;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(page) : $composer_0.q31(page)) ? 32 : 16);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(816739061, $dirty, -1, 'client.fstech.hadaya.presentation.auth.AuthContent.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (AuthScreen.kt:173)');
        }
        var tmp_1 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = padding_0(tmp_1, tmp$ret$0);
        var verticalArrangement = null;
        var horizontalAlignment = Companion_getInstance_11().x8t_1;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance;
        if (!((2 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((2 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 390 >> 3 | 112 & 390 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_2 = $composer_3.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -716562190, 'C188@7728L11,179@7064L792,354@18680L41,370@19690L11,369@19609L134,357@18801L527,373@19834L1187,356@18751L2270,449@24344L41,451@24415L1906,483@26351L41,485@26422L62,487@26514L204:AuthScreen.kt#5jzhp0');
        var tmp_3;
        if (equals(page, Login_instance)) {
          $composer_5.m30(-1685698894);
          sourceInformation($composer_5, '181@7177L39');
          var tmp0_group = stringResource(get_welcome_back(string_instance), $composer_5, 0);
          $composer_5.n30();
          tmp_3 = tmp0_group;
        } else if (equals(page, Register_instance)) {
          $composer_5.m30(-1685695788);
          sourceInformation($composer_5, '182@7274L41');
          var tmp1_group = stringResource(get_create_account(string_instance), $composer_5, 0);
          $composer_5.n30();
          tmp_3 = tmp1_group;
        } else if (equals(page, ForgetPassword_instance)) {
          $composer_5.m30(-1685692428);
          sourceInformation($composer_5, '183@7379L41');
          var tmp2_group = stringResource(get_reset_password(string_instance), $composer_5, 0);
          $composer_5.n30();
          tmp_3 = tmp2_group;
        } else if (equals(page, SetPassword_instance)) {
          $composer_5.m30(-1685689164);
          sourceInformation($composer_5, '184@7481L41');
          var tmp3_group = stringResource(get_reset_password(string_instance), $composer_5, 0);
          $composer_5.n30();
          tmp_3 = tmp3_group;
        } else {
          $composer_5.m30(-1685700662);
          $composer_5.n30();
          noWhenBranchMatchedException();
        }
        var tmp1_text = tmp_3;
        var tmp2_fontSize = get_sp(20);
        var tmp3_fontWeight = Companion_getInstance_16().d7z_1;
        var tmp4_color = MaterialTheme_instance.unz($composer_5, 6).no0_1;
        var tmp_4 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
        var tmp5_modifier = padding_1(tmp_4, VOID, VOID, VOID, tmp$ret$7);
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp1_text, tmp5_modifier, tmp4_color, null, tmp2_fontSize, null, tmp3_fontWeight, null, tmp_5, null, null, tmp_6, tmp_7, false, 0, 0, null, null, $composer_5, 1597488, 0, 262056);
        if (equals(page, SetPassword_instance)) {
          $composer_5.m30(-716232196);
          sourceInformation($composer_5, '209@9322L11,210@9420L11,208@9239L245,195@8085L44,198@8426L597,193@7954L1683,216@9671L41,226@10482L11,227@10580L11,225@10399L245,220@9884L51,218@9746L1051');
          var tmp6_value = $state.i10l_1;
          var tmp7_visualTransformation = AuthContent$lambda($passwordVisible$delegate) ? Companion_getInstance_17().o8d_1 : new PasswordVisualTransformation();
          var tmp8_modifier = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$8 = _Dp___init__impl__ms3zkb(12);
          var tmp9_shape = RoundedCornerShape(tmp$ret$8);
          var tmp_8 = OutlinedTextFieldDefaults_getInstance();
          var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_13 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_14 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_15 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_16 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_17 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_18 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_19 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
          var tmp_20 = MaterialTheme_instance.unz($composer_5, 6).oo0_1;
          var tmp_21 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_22 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_23 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_24 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_25 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_26 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_27 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_28 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_29 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_30 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_31 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_32 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_33 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_34 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_35 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_36 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_37 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_38 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_39 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_40 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_41 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_42 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_43 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_44 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_45 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_46 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_47 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_48 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_49 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp10_colors = tmp_8.np9(tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, null, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, tmp_43, tmp_44, tmp_45, tmp_46, tmp_47, tmp_48, tmp_49, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 0, 0, 0, 0, 3072, 2147477503, 4095);
          var tmp11_enabled = !$state.l10l_1;
          sourceInformationMarkerStart($composer_5, -1685669833, 'CC(remember):AuthScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_5.k31($onIntent);
          // Inline function 'kotlin.let' call
          var it = $composer_5.i31();
          var tmp_50;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = AuthContent$lambda$lambda$lambda$lambda($onIntent);
            $composer_5.j31(value);
            tmp_50 = value;
          } else {
            tmp_50 = it;
          }
          var tmp4_group = tmp_50;
          sourceInformationMarkerEnd($composer_5);
          var tmp_51 = ComposableSingletons$AuthScreenKt_getInstance().f10m_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-269890051, true, AuthContent$lambda$lambda$lambda$lambda_0($passwordVisible$delegate), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_6 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = $composer_6.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_0 = $composer_6.i31();
          var tmp_52;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_6.j31(value_0);
            tmp_52 = value_0;
          } else {
            tmp_52 = it_0;
          }
          var tmp_53 = tmp_52;
          OutlinedTextField(tmp6_value, tmp4_group, tmp8_modifier, tmp11_enabled, false, null, tmp_51, null, null, tmp_53, null, null, null, false, tmp7_visualTransformation, null, null, true, 0, 0, null, tmp9_shape, tmp10_colors, $composer_5, 806879616, 12582912, 0, 1949104);
          var tmp_54 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$20 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_54, tmp$ret$20), $composer_5, 6);
          var tmp12_value = $state.j10l_1;
          var tmp13_visualTransformation = AuthContent$lambda($passwordVisible$delegate) ? Companion_getInstance_17().o8d_1 : new PasswordVisualTransformation();
          var tmp14_modifier = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$21 = _Dp___init__impl__ms3zkb(12);
          var tmp15_shape = RoundedCornerShape(tmp$ret$21);
          var tmp_55 = OutlinedTextFieldDefaults_getInstance();
          var tmp_56 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_57 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_58 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_59 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_60 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_61 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_62 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_63 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_64 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_65 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_66 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
          var tmp_67 = MaterialTheme_instance.unz($composer_5, 6).oo0_1;
          var tmp_68 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_69 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_70 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_71 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_72 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_73 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_74 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_75 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_76 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_77 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_78 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_79 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_80 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_81 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_82 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_83 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_84 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_85 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_86 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_87 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_88 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_89 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_90 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_91 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_92 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_93 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_94 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_95 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_96 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp16_colors = tmp_55.np9(tmp_56, tmp_57, tmp_58, tmp_59, tmp_60, tmp_61, tmp_62, tmp_63, tmp_64, tmp_65, null, tmp_66, tmp_67, tmp_68, tmp_69, tmp_70, tmp_71, tmp_72, tmp_73, tmp_74, tmp_75, tmp_76, tmp_77, tmp_78, tmp_79, tmp_80, tmp_81, tmp_82, tmp_83, tmp_84, tmp_85, tmp_86, tmp_87, tmp_88, tmp_89, tmp_90, tmp_91, tmp_92, tmp_93, tmp_94, tmp_95, tmp_96, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 0, 0, 0, 0, 3072, 2147477503, 4095);
          var tmp17_enabled = !$state.l10l_1;
          sourceInformationMarkerStart($composer_5, -1685612258, 'CC(remember):AuthScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_1 = $composer_5.k31($onIntent);
          // Inline function 'kotlin.let' call
          var it_1 = $composer_5.i31();
          var tmp_97;
          if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
            var value_1 = AuthContent$lambda$lambda$lambda$lambda_1($onIntent);
            $composer_5.j31(value_1);
            tmp_97 = value_1;
          } else {
            tmp_97 = it_1;
          }
          var tmp5_group = tmp_97;
          sourceInformationMarkerEnd($composer_5);
          var tmp_98 = ComposableSingletons$AuthScreenKt_getInstance().g10m_1;
          OutlinedTextField(tmp12_value, tmp5_group, tmp14_modifier, tmp17_enabled, false, null, tmp_98, null, null, null, null, null, null, false, tmp13_visualTransformation, null, null, true, 0, 0, null, tmp15_shape, tmp16_colors, $composer_5, 1573248, 12582912, 0, 1949616);
          $composer_5.n30();
        } else {
          $composer_5.m30(-713341942);
          sourceInformation($composer_5, '240@11429L11,241@11527L11,239@11346L245,235@10995L41,233@10867L877');
          var tmp18_value = $state.h10l_1;
          var tmp19_modifier = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$26 = _Dp___init__impl__ms3zkb(12);
          var tmp20_shape = RoundedCornerShape(tmp$ret$26);
          var tmp_99 = OutlinedTextFieldDefaults_getInstance();
          var tmp_100 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_101 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_102 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_103 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_104 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_105 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_106 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_107 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_108 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_109 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_110 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
          var tmp_111 = MaterialTheme_instance.unz($composer_5, 6).oo0_1;
          var tmp_112 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_113 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_114 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_115 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_116 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_117 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_118 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_119 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_120 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_121 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_122 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_123 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_124 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_125 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_126 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_127 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_128 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_129 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_130 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_131 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_132 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_133 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_134 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_135 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_136 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_137 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_138 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_139 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_140 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp21_colors = tmp_99.np9(tmp_100, tmp_101, tmp_102, tmp_103, tmp_104, tmp_105, tmp_106, tmp_107, tmp_108, tmp_109, null, tmp_110, tmp_111, tmp_112, tmp_113, tmp_114, tmp_115, tmp_116, tmp_117, tmp_118, tmp_119, tmp_120, tmp_121, tmp_122, tmp_123, tmp_124, tmp_125, tmp_126, tmp_127, tmp_128, tmp_129, tmp_130, tmp_131, tmp_132, tmp_133, tmp_134, tmp_135, tmp_136, tmp_137, tmp_138, tmp_139, tmp_140, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 0, 0, 0, 0, 3072, 2147477503, 4095);
          var tmp22_enabled = !$state.l10l_1;
          sourceInformationMarkerStart($composer_5, -1685576716, 'CC(remember):AuthScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_2 = $composer_5.k31($onIntent);
          // Inline function 'kotlin.let' call
          var it_2 = $composer_5.i31();
          var tmp_141;
          if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
            var value_2 = AuthContent$lambda$lambda$lambda$lambda_2($onIntent);
            $composer_5.j31(value_2);
            tmp_141 = value_2;
          } else {
            tmp_141 = it_2;
          }
          var tmp6_group = tmp_141;
          sourceInformationMarkerEnd($composer_5);
          var tmp_142 = ComposableSingletons$AuthScreenKt_getInstance().h10m_1;
          OutlinedTextField(tmp18_value, tmp6_group, tmp19_modifier, tmp22_enabled, false, null, tmp_142, null, null, null, null, null, null, false, null, null, null, true, 0, 0, null, tmp20_shape, tmp21_colors, $composer_5, 1573248, 12582912, 0, 1966000);
          if (!equals(page, ForgetPassword_instance)) {
            $composer_5.m30(-712399170);
            sourceInformation($composer_5, '248@11853L41,265@13359L11,266@13461L11,264@13272L257,251@12070L44,254@12419L625,249@11931L1763');
            var tmp_143 = Companion_instance;
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$31 = _Dp___init__impl__ms3zkb(16);
            Spacer(height(tmp_143, tmp$ret$31), $composer_5, 6);
            var tmp23_value = $state.i10l_1;
            var tmp24_visualTransformation = AuthContent$lambda($passwordVisible$delegate) ? Companion_getInstance_17().o8d_1 : new PasswordVisualTransformation();
            var tmp25_modifier = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$32 = _Dp___init__impl__ms3zkb(12);
            var tmp26_shape = RoundedCornerShape(tmp$ret$32);
            var tmp_144 = OutlinedTextFieldDefaults_getInstance();
            var tmp_145 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_146 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_147 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_148 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_149 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_150 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_151 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_152 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_153 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_154 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_155 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
            var tmp_156 = MaterialTheme_instance.unz($composer_5, 6).oo0_1;
            var tmp_157 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_158 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_159 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_160 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_161 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_162 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_163 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_164 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_165 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_166 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_167 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_168 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_169 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_170 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_171 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_172 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_173 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_174 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_175 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_176 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_177 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_178 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_179 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_180 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_181 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_182 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_183 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_184 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_185 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp27_colors = tmp_144.np9(tmp_145, tmp_146, tmp_147, tmp_148, tmp_149, tmp_150, tmp_151, tmp_152, tmp_153, tmp_154, null, tmp_155, tmp_156, tmp_157, tmp_158, tmp_159, tmp_160, tmp_161, tmp_162, tmp_163, tmp_164, tmp_165, tmp_166, tmp_167, tmp_168, tmp_169, tmp_170, tmp_171, tmp_172, tmp_173, tmp_174, tmp_175, tmp_176, tmp_177, tmp_178, tmp_179, tmp_180, tmp_181, tmp_182, tmp_183, tmp_184, tmp_185, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 0, 0, 0, 0, 3072, 2147477503, 4095);
            var tmp28_enabled = !$state.l10l_1;
            sourceInformationMarkerStart($composer_5, -1685542313, 'CC(remember):AuthScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_3 = $composer_5.k31($onIntent);
            // Inline function 'kotlin.let' call
            var it_3 = $composer_5.i31();
            var tmp_186;
            if (invalid_3 || it_3 === Companion_getInstance().f30_1) {
              var value_3 = AuthContent$lambda$lambda$lambda$lambda_3($onIntent);
              $composer_5.j31(value_3);
              tmp_186 = value_3;
            } else {
              tmp_186 = it_3;
            }
            var tmp7_group = tmp_186;
            sourceInformationMarkerEnd($composer_5);
            var tmp_187 = ComposableSingletons$AuthScreenKt_getInstance().i10m_1;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_0 = rememberComposableLambda(237797025, true, AuthContent$lambda$lambda$lambda$lambda_4($passwordVisible$delegate), $composer_5, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_7 = $composer_5;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_4 = $composer_7.k31(dispatchReceiver_0);
            // Inline function 'kotlin.let' call
            var it_4 = $composer_7.i31();
            var tmp_188;
            if (invalid_4 || it_4 === Companion_getInstance().f30_1) {
              var value_4 = ComposableLambda$invoke$ref(dispatchReceiver_0);
              $composer_7.j31(value_4);
              tmp_188 = value_4;
            } else {
              tmp_188 = it_4;
            }
            var tmp_189 = tmp_188;
            OutlinedTextField(tmp23_value, tmp7_group, tmp25_modifier, tmp28_enabled, false, null, tmp_187, null, null, tmp_189, null, null, null, false, tmp24_visualTransformation, null, null, true, 0, 0, null, tmp26_shape, tmp27_colors, $composer_5, 806879616, 12582912, 0, 1949104);
            $composer_5.n30();
          } else {
            $composer_5.m30(-710560777);
            $composer_5.n30();
          }
          $composer_5.n30();
        }
        if (equals(page, Login_instance)) {
          $composer_5.m30(-710418921);
          sourceInformation($composer_5, '276@13899L42,277@14001L11,283@14363L60,275@13850L673,287@14589L957');
          var tmp29_text = stringResource(get_forgot_password(string_instance), $composer_5, 0);
          var tmp30_color = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
          var tmp31_fontSize = get_sp(14);
          var tmp32_textAlign = Companion_getInstance_15().g7v_1;
          var tmp_190 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$44 = _Dp___init__impl__ms3zkb(8);
          var tmp_191 = padding_1(tmp_190, VOID, tmp$ret$44);
          sourceInformationMarkerStart($composer_5, -1685468921, 'CC(remember):AuthScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_5 = $composer_5.k31($onIntent);
          // Inline function 'kotlin.let' call
          var it_5 = $composer_5.i31();
          var tmp_192;
          if (invalid_5 || it_5 === Companion_getInstance().f30_1) {
            var value_5 = AuthContent$lambda$lambda$lambda$lambda_5($onIntent);
            $composer_5.j31(value_5);
            tmp_192 = value_5;
          } else {
            tmp_192 = it_5;
          }
          var tmp8_group = tmp_192;
          sourceInformationMarkerEnd($composer_5);
          var tmp_193 = clickable(tmp_191, VOID, VOID, VOID, VOID, tmp8_group);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$49 = _Dp___init__impl__ms3zkb(4);
          var tmp33_modifier = padding_2(tmp_193, VOID, tmp$ret$49);
          var tmp_194 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_195 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_196 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp29_text, tmp33_modifier, tmp30_color, null, tmp31_fontSize, null, null, null, tmp_194, null, tmp32_textAlign, tmp_195, tmp_196, false, 0, 0, null, null, $composer_5, 24576, 0, 261096);
          var tmp_197 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$50 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_1 = padding_1(tmp_197, VOID, tmp$ret$50);
          var horizontalArrangement = null;
          var verticalAlignment = Companion_getInstance_11().u8t_1;
          var $composer_8 = $composer_5;
          if (!((2 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((2 & 2) === 0))
            horizontalArrangement = Arrangement_getInstance().qdp_1;
          if (!((2 & 4) === 0))
            verticalAlignment = Companion_getInstance_11().t8t_1;
          var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_8, 14 & 390 >> 3 | 112 & 390 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_9 = $composer_8;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_9, 0).hashCode();
          var localMap_0 = $composer_9.t31();
          var materialized_0 = materialize($composer_9, modifier_2);
          var tmp0_0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_10 = $composer_9;
          var tmp_198 = $composer_10.g30();
          if (!isInterface(tmp_198, Applier)) {
            invalidApplier();
          }
          $composer_10.b31();
          if ($composer_10.h30()) {
            $composer_10.c31(tmp0_0);
          } else {
            $composer_10.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_10);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_11 = $composer_10;
          var $composer_12 = $composer_11;
          sourceInformationMarkerStart($composer_12, 1135622723, 'C293@14976L44,291@14841L285,297@15216L43,298@15323L10,299@15416L58,296@15163L349:AuthScreen.kt#5jzhp0');
          sourceInformationMarkerStart($composer_12, 1145015341, 'CC(remember):AuthScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_6 = $composer_12.k31($onIntent);
          // Inline function 'kotlin.let' call
          var it_6 = $composer_12.i31();
          var tmp_199;
          if (invalid_6 || it_6 === Companion_getInstance().f30_1) {
            var value_6 = AuthContent$lambda$lambda$lambda$lambda_6($onIntent);
            $composer_12.j31(value_6);
            tmp_199 = value_6;
          } else {
            tmp_199 = it_6;
          }
          var tmp0_group_0 = tmp_199;
          sourceInformationMarkerEnd($composer_12);
          var tmp_200 = !$state.l10l_1;
          Checkbox($state.o10l_1, tmp0_group_0, null, tmp_200, null, null, $composer_12, 0, 52);
          var tmp0_text = stringResource(get_keep_login_label(string_instance), $composer_12, 0);
          var tmp1_style = MaterialTheme_instance.jog($composer_12, 6).pof_1;
          var tmp_201 = Companion_instance;
          sourceInformationMarkerStart($composer_12, 1145029435, 'CC(remember):AuthScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_7 = !!($composer_12.k31($onIntent) | $composer_12.q31($state));
          // Inline function 'kotlin.let' call
          var it_7 = $composer_12.i31();
          var tmp_202;
          if (invalid_7 || it_7 === Companion_getInstance().f30_1) {
            var value_7 = AuthContent$lambda$lambda$lambda$lambda_7($onIntent, $state);
            $composer_12.j31(value_7);
            tmp_202 = value_7;
          } else {
            tmp_202 = it_7;
          }
          var tmp1_group_0 = tmp_202;
          sourceInformationMarkerEnd($composer_12);
          var tmp2_modifier = clickable(tmp_201, VOID, VOID, VOID, VOID, tmp1_group_0);
          var tmp_203 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_204 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_205 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_206 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_207 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, tmp2_modifier, tmp_203, null, tmp_204, null, null, null, tmp_205, null, null, tmp_206, tmp_207, false, 0, 0, null, tmp1_style, $composer_12, 0, 0, 131068);
          sourceInformationMarkerEnd($composer_12);
          $composer_10.e31();
          $composer_5.n30();
        } else {
          $composer_5.m30(-708727561);
          $composer_5.n30();
        }
        if (equals(page, Register_instance)) {
          $composer_5.m30(-708573646);
          sourceInformation($composer_5, '305@15671L41,306@15745L937,322@16748L1872');
          var tmp_208 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$65 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_208, tmp$ret$65), $composer_5, 6);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_3 = fillMaxWidth(Companion_instance);
          var horizontalArrangement_0 = null;
          var verticalAlignment_0 = Companion_getInstance_11().u8t_1;
          var $composer_13 = $composer_5;
          if (!((2 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((2 & 2) === 0))
            horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
          if (!((2 & 4) === 0))
            verticalAlignment_0 = Companion_getInstance_11().t8t_1;
          var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_13, 14 & 390 >> 3 | 112 & 390 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_14 = $composer_13;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_14, 0).hashCode();
          var localMap_1 = $composer_14.t31();
          var materialized_1 = materialize($composer_14, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_15 = $composer_14;
          var tmp_209 = $composer_15.g30();
          if (!isInterface(tmp_209, Applier)) {
            invalidApplier();
          }
          $composer_15.b31();
          if ($composer_15.h30()) {
            $composer_15.c31(tmp0_1);
          } else {
            $composer_15.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_15);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_16 = $composer_15;
          var $composer_17 = $composer_16;
          sourceInformationMarkerStart($composer_17, 1843648994, 'C312@16112L44,310@15977L285,316@16352L43,317@16459L10,318@16552L58,315@16299L349:AuthScreen.kt#5jzhp0');
          sourceInformationMarkerStart($composer_17, 1029307566, 'CC(remember):AuthScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_8 = $composer_17.k31($onIntent);
          // Inline function 'kotlin.let' call
          var it_8 = $composer_17.i31();
          var tmp_210;
          if (invalid_8 || it_8 === Companion_getInstance().f30_1) {
            var value_8 = AuthContent$lambda$lambda$lambda$lambda_8($onIntent);
            $composer_17.j31(value_8);
            tmp_210 = value_8;
          } else {
            tmp_210 = it_8;
          }
          var tmp0_group_1 = tmp_210;
          sourceInformationMarkerEnd($composer_17);
          var tmp_211 = !$state.l10l_1;
          Checkbox($state.o10l_1, tmp0_group_1, null, tmp_211, null, null, $composer_17, 0, 52);
          var tmp0_text_0 = stringResource(get_keep_login_label(string_instance), $composer_17, 0);
          var tmp1_style_0 = MaterialTheme_instance.jog($composer_17, 6).pof_1;
          var tmp_212 = Companion_instance;
          sourceInformationMarkerStart($composer_17, 1029321660, 'CC(remember):AuthScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_9 = !!($composer_17.k31($onIntent) | $composer_17.q31($state));
          // Inline function 'kotlin.let' call
          var it_9 = $composer_17.i31();
          var tmp_213;
          if (invalid_9 || it_9 === Companion_getInstance().f30_1) {
            var value_9 = AuthContent$lambda$lambda$lambda$lambda_9($onIntent, $state);
            $composer_17.j31(value_9);
            tmp_213 = value_9;
          } else {
            tmp_213 = it_9;
          }
          var tmp1_group_1 = tmp_213;
          sourceInformationMarkerEnd($composer_17);
          var tmp2_modifier_0 = clickable(tmp_212, VOID, VOID, VOID, VOID, tmp1_group_1);
          var tmp_214 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_215 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_216 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_217 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_218 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text_0, tmp2_modifier_0, tmp_214, null, tmp_215, null, null, null, tmp_216, null, null, tmp_217, tmp_218, false, 0, 0, null, tmp1_style_0, $composer_17, 0, 0, 131068);
          sourceInformationMarkerEnd($composer_17);
          $composer_15.e31();
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_5 = fillMaxWidth(Companion_instance);
          var horizontalArrangement_1 = null;
          var verticalAlignment_1 = Companion_getInstance_11().u8t_1;
          var $composer_18 = $composer_5;
          if (!((2 & 1) === 0))
            modifier_5 = Companion_instance;
          if (!((2 & 2) === 0))
            horizontalArrangement_1 = Arrangement_getInstance().qdp_1;
          if (!((2 & 4) === 0))
            verticalAlignment_1 = Companion_getInstance_11().t8t_1;
          var measurePolicy_2 = rowMeasurePolicy(horizontalArrangement_1, verticalAlignment_1, $composer_18, 14 & 390 >> 3 | 112 & 390 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_6 = modifier_5;
          var $composer_19 = $composer_18;
          if (!((0 & 2) === 0))
            modifier_6 = Companion_instance;
          var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_19, 0).hashCode();
          var localMap_2 = $composer_19.t31();
          var materialized_2 = materialize($composer_19, modifier_6);
          var tmp0_2 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_20 = $composer_19;
          var tmp_219 = $composer_20.g30();
          if (!isInterface(tmp_219, Applier)) {
            invalidApplier();
          }
          $composer_20.b31();
          if ($composer_20.h30()) {
            $composer_20.c31(tmp0_2);
          } else {
            $composer_20.d31();
          }
          var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_20);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
          var $composer_21 = $composer_20;
          var $composer_22 = $composer_21;
          sourceInformationMarkerStart($composer_22, -229100924, 'C328@17127L48,326@16980L301,332@17368L55,333@17475L45,349@18477L10,349@18526L11,347@18345L241:AuthScreen.kt#5jzhp0');
          sourceInformationMarkerStart($composer_22, -561576535, 'CC(remember):AuthScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_10 = $composer_22.k31($onIntent);
          // Inline function 'kotlin.let' call
          var it_10 = $composer_22.i31();
          var tmp_220;
          if (invalid_10 || it_10 === Companion_getInstance().f30_1) {
            var value_10 = AuthContent$lambda$lambda$lambda$lambda_10($onIntent);
            $composer_22.j31(value_10);
            tmp_220 = value_10;
          } else {
            tmp_220 = it_10;
          }
          var tmp0_group_2 = tmp_220;
          sourceInformationMarkerEnd($composer_22);
          var tmp_221 = !$state.l10l_1;
          Checkbox($state.n10l_1, tmp0_group_2, null, tmp_221, null, null, $composer_22, 0, 52);
          var prefix = stringResource(get_accept_privacy_policy_prefix(string_instance), $composer_22, 0);
          var linkText = stringResource(get_privacy_policy_btn(string_instance), $composer_22, 0);
          // Inline function 'androidx.compose.ui.text.buildAnnotatedString' call
          // Inline function 'kotlin.apply' call
          var this_0 = new Builder_0();
          this_0.f7q(prefix);
          // Inline function 'androidx.compose.ui.text.withLink' call
          var link = new Url('https://abdallabadreldin.github.io/Hadaya_privacy_policy/', new TextLinkStyles(SpanStyle_init_$Create$(Companion_getInstance_14().p6b_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_18().b80_1)));
          var index = this_0.m7q(link);
          try {
            this_0.f7q(linkText);
          }finally {
            this_0.o7q(index);
          }
          var annotatedString = this_0.p7q();
          var tmp_222 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_223 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_224 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_225 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_226 = _TextOverflow___init__impl__obguoe(0);
          Text_0(annotatedString, null, tmp_222, null, tmp_223, null, null, null, tmp_224, null, null, tmp_225, tmp_226, false, 0, 0, null, null, MaterialTheme_instance.jog($composer_22, 6).pof_1.b82(MaterialTheme_instance.unz($composer_22, 6).no0_1), $composer_22, 0, 0, 262142);
          sourceInformationMarkerEnd($composer_22);
          $composer_20.e31();
          $composer_5.n30();
        } else {
          $composer_5.m30(-705678153);
          $composer_5.n30();
        }
        var tmp_227 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$95 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_227, tmp$ret$95), $composer_5, 6);
        var tmp_228 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$96 = _Dp___init__impl__ms3zkb(50);
        var tmp34_modifier = height(tmp_228, tmp$ret$96);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$97 = _Dp___init__impl__ms3zkb(12);
        var tmp35_shape = RoundedCornerShape(tmp$ret$97);
        var tmp_229 = ButtonDefaults_getInstance();
        var tmp_230 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
        var tmp_231 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_232 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp36_colors = tmp_229.ao9(tmp_230, tmp_231, tmp_232, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
        var tmp37_enabled = !$state.l10l_1;
        sourceInformationMarkerStart($composer_5, -1685326438, 'CC(remember):AuthScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_11 = !!((($dirty & 112) === 32 || (!(($dirty & 64) === 0) && $composer_0.q31(page))) | $composer_0.k31($onIntent));
        // Inline function 'kotlin.let' call
        var it_11 = $composer_5.i31();
        var tmp_233;
        if (invalid_11 || it_11 === Companion_getInstance().f30_1) {
          var value_11 = AuthContent$lambda$lambda$lambda$lambda_11(page, $onIntent);
          $composer_5.j31(value_11);
          tmp_233 = value_11;
        } else {
          tmp_233 = it_11;
        }
        var tmp9_group = tmp_233;
        sourceInformationMarkerEnd($composer_5);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(-2098418853, true, AuthContent$lambda$lambda$lambda$lambda_12($state, page), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_23 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_12 = $composer_23.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_12 = $composer_23.i31();
        var tmp_234;
        if (invalid_12 || it_12 === Companion_getInstance().f30_1) {
          var value_12 = ComposableLambda$invoke$ref_1(dispatchReceiver_1);
          $composer_23.j31(value_12);
          tmp_234 = value_12;
        } else {
          tmp_234 = it_12;
        }
        var tmp$ret$102 = tmp_234;
        Button(tmp9_group, tmp34_modifier, tmp37_enabled, tmp35_shape, tmp36_colors, null, null, null, null, tmp$ret$102, $composer_5, 805306416, 480);
        if (!equals(page, ForgetPassword_instance) && !equals(page, SetPassword_instance)) {
          $composer_5.m30(-703128899);
          sourceInformation($composer_5, '395@21154L41,397@21229L828,411@22091L41,423@22844L11,425@23017L11,424@22926L150,414@22228L297,413@22166L2118');
          var tmp_235 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$109 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_235, tmp$ret$109), $composer_5, 6);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_7 = fillMaxWidth(Companion_instance);
          var horizontalArrangement_2 = null;
          var verticalAlignment_2 = Companion_getInstance_11().u8t_1;
          var $composer_24 = $composer_5;
          if (!((2 & 1) === 0))
            modifier_7 = Companion_instance;
          if (!((2 & 2) === 0))
            horizontalArrangement_2 = Arrangement_getInstance().qdp_1;
          if (!((2 & 4) === 0))
            verticalAlignment_2 = Companion_getInstance_11().t8t_1;
          var measurePolicy_3 = rowMeasurePolicy(horizontalArrangement_2, verticalAlignment_2, $composer_24, 14 & 390 >> 3 | 112 & 390 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_8 = modifier_7;
          var $composer_25 = $composer_24;
          if (!((0 & 2) === 0))
            modifier_8 = Companion_instance;
          var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_25, 0).hashCode();
          var localMap_3 = $composer_25.t31();
          var materialized_3 = materialize($composer_25, modifier_8);
          var tmp0_3 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_26 = $composer_25;
          var tmp_236 = $composer_26.g30();
          if (!isInterface(tmp_236, Applier)) {
            invalidApplier();
          }
          $composer_26.b31();
          if ($composer_26.h30()) {
            $composer_26.c31(tmp0_3);
          } else {
            $composer_26.d31();
          }
          var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_26);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
          var $composer_27 = $composer_26;
          var $composer_28 = $composer_27;
          sourceInformationMarkerStart($composer_28, -1743295410, 'C401@21461L49,403@21600L35,405@21787L10,406@21871L11,402@21547L390,408@21974L49:AuthScreen.kt#5jzhp0');
          var tmp_237 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
          var tmp_238 = _Dp___init__impl__ms3zkb(0.0);
          HorizontalDivider(tmp_237, tmp_238, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_28, 0, 6);
          var tmp0_text_1 = stringResource(get_or_label(string_instance), $composer_28, 0);
          var tmp_239 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$116 = _Dp___init__impl__ms3zkb(8);
          var tmp1_modifier = padding_2(tmp_239, tmp$ret$116);
          var tmp2_style = MaterialTheme_instance.jog($composer_28, 6).qof_1;
          var tmp3_color = MaterialTheme_instance.unz($composer_28, 6).po0_1;
          var tmp_240 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_241 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_242 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_243 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text_1, tmp1_modifier, tmp3_color, null, tmp_240, null, null, null, tmp_241, null, null, tmp_242, tmp_243, false, 0, 0, null, tmp2_style, $composer_28, 48, 0, 131064);
          var tmp_244 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
          var tmp_245 = _Dp___init__impl__ms3zkb(0.0);
          HorizontalDivider(tmp_244, tmp_245, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_28, 0, 6);
          sourceInformationMarkerEnd($composer_28);
          $composer_26.e31();
          var tmp_246 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$117 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_246, tmp$ret$117), $composer_5, 6);
          var tmp_247 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$118 = _Dp___init__impl__ms3zkb(50);
          var tmp38_modifier = height(tmp_247, tmp$ret$118);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$119 = _Dp___init__impl__ms3zkb(12);
          var tmp39_shape = RoundedCornerShape(tmp$ret$119);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$120 = _Dp___init__impl__ms3zkb(1);
          var tmp40_border = BorderStroke(tmp$ret$120, MaterialTheme_instance.unz($composer_5, 6).xo0_1);
          var tmp_248 = ButtonDefaults_getInstance();
          var tmp_249 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_250 = MaterialTheme_instance.unz($composer_5, 6).no0_1;
          var tmp_251 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp41_colors = tmp_248.pob(tmp_249, tmp_250, tmp_251, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 13);
          var tmp42_enabled = !$state.l10l_1;
          sourceInformationMarkerStart($composer_5, -1685217004, 'CC(remember):AuthScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_13 = $composer_5.k31($onIntent);
          // Inline function 'kotlin.let' call
          var it_13 = $composer_5.i31();
          var tmp_252;
          if (invalid_13 || it_13 === Companion_getInstance().f30_1) {
            var value_13 = AuthContent$lambda$lambda$lambda$lambda_13($onIntent);
            $composer_5.j31(value_13);
            tmp_252 = value_13;
          } else {
            tmp_252 = it_13;
          }
          var tmp10_group = tmp_252;
          sourceInformationMarkerEnd($composer_5);
          OutlinedButton(tmp10_group, tmp38_modifier, tmp42_enabled, tmp39_shape, tmp41_colors, null, tmp40_border, null, null, ComposableSingletons$AuthScreenKt_getInstance().j10m_1, $composer_5, 805306416, 416);
          $composer_5.n30();
        } else {
          $composer_5.m30(-700059465);
          $composer_5.n30();
        }
        var tmp_253 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$125 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_253, tmp$ret$125), $composer_5, 6);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_9 = fillMaxWidth(Companion_instance);
        var horizontalArrangement_3 = Arrangement_getInstance().udp_1;
        var verticalAlignment_3 = null;
        var $composer_29 = $composer_5;
        if (!((4 & 1) === 0))
          modifier_9 = Companion_instance;
        if (!((4 & 2) === 0))
          horizontalArrangement_3 = Arrangement_getInstance().qdp_1;
        if (!((4 & 4) === 0))
          verticalAlignment_3 = Companion_getInstance_11().t8t_1;
        var measurePolicy_4 = rowMeasurePolicy(horizontalArrangement_3, verticalAlignment_3, $composer_29, 14 & 54 >> 3 | 112 & 54 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_10 = modifier_9;
        var $composer_30 = $composer_29;
        if (!((0 & 2) === 0))
          modifier_10 = Companion_instance;
        var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_30, 0).hashCode();
        var localMap_4 = $composer_30.t31();
        var materialized_4 = materialize($composer_30, modifier_10);
        var tmp0_4 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_31 = $composer_30;
        var tmp_254 = $composer_31.g30();
        if (!isInterface(tmp_254, Applier)) {
          invalidApplier();
        }
        $composer_31.b31();
        if ($composer_31.h30()) {
          $composer_31.c31(tmp0_4);
        } else {
          $composer_31.d31();
        }
        var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_31);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
        var $composer_32 = $composer_31;
        var $composer_33 = $composer_32;
        sourceInformationMarkerStart($composer_33, 1154108180, 'C460@24996L11,455@24627L485,469@25588L11,472@25795L462,463@25145L1146:AuthScreen.kt#5jzhp0');
        var tmp_255;
        if (equals(page, Login_instance)) {
          $composer_33.m30(-1071147104);
          sourceInformation($composer_33, '457@24748L49');
          var tmp0_group_3 = stringResource(get_dont_have_account_hint(string_instance), $composer_33, 0);
          $composer_33.n30();
          tmp_255 = tmp0_group_3;
        } else {
          $composer_33.m30(-1071143965);
          sourceInformation($composer_33, '458@24846L52');
          var tmp1_group_2 = stringResource(get_already_have_account_hint(string_instance), $composer_33, 0);
          $composer_33.n30();
          tmp_255 = tmp1_group_2;
        }
        var tmp_256 = tmp_255;
        var tmp_257 = MaterialTheme_instance.unz($composer_33, 6).po0_1;
        var tmp_258 = get_sp(14);
        var tmp_259 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_260 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_261 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_256, null, tmp_257, null, tmp_258, null, null, null, tmp_259, null, null, tmp_260, tmp_261, false, 0, 0, null, null, $composer_33, 24576, 0, 262122);
        var tmp_262;
        if (equals(page, Login_instance)) {
          $composer_33.m30(-1071130539);
          sourceInformation($composer_33, '465@25266L38');
          var tmp2_group_0 = stringResource(get_sign_up_btn(string_instance), $composer_33, 0);
          $composer_33.n30();
          tmp_262 = tmp2_group_0;
        } else if (equals(page, SetPassword_instance)) {
          $composer_33.m30(-1071127245);
          sourceInformation($composer_33, '466@25369L36');
          var tmp3_group_0 = stringResource(get_login_btn(string_instance), $composer_33, 0);
          $composer_33.n30();
          tmp_262 = tmp3_group_0;
        } else {
          $composer_33.m30(-1071124525);
          sourceInformation($composer_33, '467@25454L36');
          var tmp4_group_0 = stringResource(get_login_btn(string_instance), $composer_33, 0);
          $composer_33.n30();
          tmp_262 = tmp4_group_0;
        }
        var tmp2_text = tmp_262;
        var tmp3_color_0 = MaterialTheme_instance.unz($composer_33, 6).xnz_1;
        var tmp4_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp5_fontSize = get_sp(14);
        var tmp_263 = Companion_instance;
        sourceInformationMarkerStart($composer_33, -1071113187, 'CC(remember):AuthScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_14 = !!((($dirty & 112) === 32 || (!(($dirty & 64) === 0) && $composer_0.q31(page))) | $composer_0.k31($onIntent));
        // Inline function 'kotlin.let' call
        var it_14 = $composer_33.i31();
        var tmp_264;
        if (invalid_14 || it_14 === Companion_getInstance().f30_1) {
          var value_14 = AuthContent$lambda$lambda$lambda$lambda_14(page, $onIntent);
          $composer_33.j31(value_14);
          tmp_264 = value_14;
        } else {
          tmp_264 = it_14;
        }
        var tmp5_group_0 = tmp_264;
        sourceInformationMarkerEnd($composer_33);
        var tmp6_modifier = clickable(tmp_263, VOID, VOID, VOID, VOID, tmp5_group_0);
        var tmp_265 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_266 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_267 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp2_text, tmp6_modifier, tmp3_color_0, null, tmp5_fontSize, null, tmp4_fontWeight, null, tmp_265, null, null, tmp_266, tmp_267, false, 0, 0, null, null, $composer_33, 1597440, 0, 262056);
        sourceInformationMarkerEnd($composer_33);
        $composer_31.e31();
        var tmp_268 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$136 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_268, tmp$ret$136), $composer_5, 6);
        var tmp_269 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$137 = _Dp___init__impl__ms3zkb(16);
        var tmp_270 = padding_1(tmp_269, VOID, VOID, VOID, tmp$ret$137);
        var tmp_271 = _Dp___init__impl__ms3zkb(0.0);
        HorizontalDivider(tmp_270, tmp_271, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 6, 6);
        var tmp_272 = fillMaxWidth(Companion_instance);
        var tmp_273 = Companion_getInstance_11().x8t_1;
        ContactUsSection(null, tmp_272, tmp_273, false, null, false, null, false, $composer_5, 432, 249);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_274;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_274 = Unit_instance;
        }
        tmp_0 = tmp_274;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_3(p0) {
    return constructCallableReference(function (p0_0, p1, p2, p3) {
      p0.v50(p0_0, p1, p2, p3);
      return Unit_instance;
    }, 4, 0, 255, VOID, [p0]);
  }
  function AuthContent$lambda$lambda_0($state, $onIntent, $passwordVisible$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C168@6529L139,172@6742L20024,166@6414L20352:AuthScreen.kt#5jzhp0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1610550075, $changed, -1, 'client.fstech.hadaya.presentation.auth.AuthContent.<anonymous>.<anonymous>.<anonymous>.<anonymous> (AuthScreen.kt:166)');
        }
        sourceInformationMarkerStart($composer_0, -1550390992, 'CC(remember):AuthScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = AuthContent$lambda$lambda$lambda;
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(816739061, true, AuthContent$lambda$lambda$lambda_0($state, $onIntent, $passwordVisible$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_1;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_3(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_0;
        }
        var tmp$ret$4 = tmp_1;
        AnimatedContent($state.m10l_1, null, tmp0_group, null, 'Auth transition', null, tmp$ret$4, $composer_0, 1597824, 42);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AuthContent$lambda_2($uriHandler, $state, $onIntent, $passwordVisible$delegate) {
    return function (padding_0, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C122@4603L22205:AuthScreen.kt#5jzhp0');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31(padding_0) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1391490172, $dirty, -1, 'client.fstech.hadaya.presentation.auth.AuthContent.<anonymous> (AuthScreen.kt:122)');
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = padding(fillMaxSize(Companion_instance), padding_0);
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((4 & 1) === 0))
          modifier = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -293392567, 'C131@4894L21,128@4778L22020:AuthScreen.kt#5jzhp0');
        var tmp_2 = fillMaxWidth(Companion_instance);
        var tmp_3 = verticalScroll(tmp_2, rememberScrollState(0, $composer_5, 0, 1));
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_4 = _Dp___init__impl__ms3zkb(32);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_1 = padding_2(tmp_3, tmp_4, tmp$ret$7);
        var verticalArrangement = null;
        var horizontalAlignment = Companion_getInstance_11().x8t_1;
        var $composer_6 = $composer_5;
        if (!((2 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((2 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((2 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_5 = $composer_8.g30();
        if (!isInterface(tmp_5, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 640027358, 'C138@5245L126,136@5115L979,162@6247L11,165@6392L20392,160@6141L20643:AuthScreen.kt#5jzhp0');
        var tmp0_horizontalAlignment = Companion_getInstance_11().x8t_1;
        var tmp_6 = Companion_instance;
        sourceInformationMarkerStart($composer_10, 1406101982, 'CC(remember):AuthScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_10.q31($uriHandler);
        // Inline function 'kotlin.let' call
        var it = $composer_10.i31();
        var tmp_7;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = AuthContent$lambda$lambda($uriHandler);
          $composer_10.j31(value);
          tmp_7 = value;
        } else {
          tmp_7 = it;
        }
        var tmp0_group = tmp_7;
        sourceInformationMarkerEnd($composer_10);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_3 = clickable(tmp_6, VOID, VOID, VOID, VOID, tmp0_group);
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = tmp0_horizontalAlignment;
        var $composer_11 = $composer_10;
        if (!((2 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((2 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((2 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_1 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_11, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_12 = $composer_11;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
        var localMap_1 = $composer_12.t31();
        var materialized_1 = materialize($composer_12, modifier_4);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_13 = $composer_12;
        var tmp_8 = $composer_13.g30();
        if (!isInterface(tmp_8, Applier)) {
          invalidApplier();
        }
        $composer_13.b31();
        if ($composer_13.h30()) {
          $composer_13.c31(tmp0_1);
        } else {
          $composer_13.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_14 = $composer_13;
        var $composer_15 = $composer_14;
        sourceInformationMarkerStart($composer_15, 757662241, 'C146@5593L34,147@5674L31,142@5412L316,151@5787L35,154@5966L11,150@5750L326:AuthScreen.kt#5jzhp0');
        var tmp_9 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$24 = _Dp___init__impl__ms3zkb(120);
        var tmp_10 = size(tmp_9, tmp$ret$24);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$25 = _Dp___init__impl__ms3zkb(16);
        var tmp0_modifier = padding_1(tmp_10, VOID, VOID, VOID, tmp$ret$25);
        var tmp1_painter = painterResource(get_logo(drawable_instance), $composer_15, 0);
        var tmp2_contentDescription = stringResource(get_logo_0(string_instance), $composer_15, 0);
        Image(tmp1_painter, tmp2_contentDescription, tmp0_modifier, null, null, 0.0, null, $composer_15, 384 | androidx_compose_ui_graphics_painter_Painter$stableprop_getter(), 120);
        var tmp3_text = stringResource(get_app_name(string_instance), $composer_15, 0);
        var tmp4_fontSize = get_sp(32);
        var tmp5_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp6_color = MaterialTheme_instance.unz($composer_15, 6).xnz_1;
        var tmp_11 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$26 = _Dp___init__impl__ms3zkb(32);
        var tmp7_modifier = padding_1(tmp_11, VOID, VOID, VOID, tmp$ret$26);
        var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_14 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp3_text, tmp7_modifier, tmp6_color, null, tmp4_fontSize, null, tmp5_fontWeight, null, tmp_12, null, null, tmp_13, tmp_14, false, 0, 0, null, null, $composer_15, 1597488, 0, 262056);
        sourceInformationMarkerEnd($composer_15);
        $composer_13.e31();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$27 = _Dp___init__impl__ms3zkb(24);
        var tmp2_shape = RoundedCornerShape(tmp$ret$27);
        var tmp3_color = MaterialTheme_instance.unz($composer_10, 6).mo0_1;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp4_shadowElevation = _Dp___init__impl__ms3zkb(8);
        var tmp_15 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$29 = _Dp___init__impl__ms3zkb(500);
        var tmp5_modifier = widthIn(tmp_15, VOID, tmp$ret$29);
        var tmp_16 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_17 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1610550075, true, AuthContent$lambda$lambda_0($state, $onIntent, $passwordVisible$delegate), $composer_10, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_16 = $composer_10;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_16.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_16.i31();
        var tmp_18;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_16.j31(value_0);
          tmp_18 = value_0;
        } else {
          tmp_18 = it_0;
        }
        var tmp$ret$30 = tmp_18;
        Surface(tmp5_modifier, tmp2_shape, tmp3_color, tmp_16, tmp_17, tmp4_shadowElevation, null, tmp$ret$30, $composer_10, 12779526, 88);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_19;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_19 = Unit_instance;
        }
        tmp_0 = tmp_19;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AuthContent$lambda_3($state, $onIntent, $onNavigateToHome, $sideEffect, $$changed, $$default) {
    return function ($composer, $force) {
      AuthContent($state, $onIntent, $onNavigateToHome, $sideEffect._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_auth_AuthViewModel$stable;
  function login($this, $completion) {
    var tmp = new $loginCOROUTINE$_0($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function loginWithGoogle($this, idToken, accessToken, $completion) {
    var tmp = new $loginWithGoogleCOROUTINE$_0($this, idToken, accessToken, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function register($this, $completion) {
    var tmp = new $registerCOROUTINE$_0($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function forgetPassword($this, $completion) {
    var tmp = new $forgetPasswordCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function setPassword($this, $completion) {
    var tmp = new $setPasswordCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function mapAuthError($this, e) {
    var tmp0_elvis_lhs = e.message;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return new ResourceString(get_unexpected_error(string_instance), []);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var message = tmp;
    return contains(message, 'invalid login credentials', true) ? new ResourceString(get_invalid_credentials(string_instance), []) : contains(message, 'user already registered', true) ? new ResourceString(get_user_already_registered(string_instance), []) : contains(message, 'should be at least 6 characters', true) ? new ResourceString(get_weak_password(string_instance), []) : contains(message, 'invalid format', true) ? new ResourceString(get_invalid_email_format(string_instance), []) : contains(message, 'user not found', true) ? new ResourceString(get_user_not_found(string_instance), []) : contains(message, 'network', true) || contains(message, 'timeout', true) ? new ResourceString(get_network_error(string_instance), []) : new ResourceString(get_unexpected_error(string_instance), []);
  }
  function AuthViewModel$handleIntent$lambda($intent) {
    return function ($this$updateState) {
      // Inline function 'kotlin.text.trim' call
      var this_0 = $intent.s10l_1;
      var tmp$ret$0 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      return $this$updateState.r10l(tmp$ret$0);
    };
  }
  function AuthViewModel$handleIntent$lambda_0($intent) {
    return function ($this$updateState) {
      return $this$updateState.r10l(VOID, $intent.t10l_1);
    };
  }
  function AuthViewModel$handleIntent$lambda_1($intent) {
    return function ($this$updateState) {
      return $this$updateState.r10l(VOID, VOID, $intent.u10l_1);
    };
  }
  function AuthViewModel$handleIntent$lambda_2($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, VOID, SetPassword_instance);
  }
  function AuthViewModel$handleIntent$lambda_3($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, VOID, Login_instance);
  }
  function AuthViewModel$handleIntent$lambda_4($intent) {
    return function ($this$updateState) {
      return $this$updateState.r10l(VOID, VOID, VOID, VOID, VOID, VOID, $intent.y10l_1);
    };
  }
  function AuthViewModel$handleIntent$lambda_5($intent) {
    return function ($this$updateState) {
      return $this$updateState.r10l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.z10l_1);
    };
  }
  function AuthViewModel$handleIntent$lambda_6($intent) {
    return function ($this$updateState) {
      return $this$updateState.r10l(VOID, VOID, VOID, VOID, VOID, $intent.a10m_1, VOID, VOID, null);
    };
  }
  function AuthViewModel$login$lambda($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, true, VOID, VOID, VOID, null);
  }
  function AuthViewModel$login$lambda_0($e) {
    return function ($this$updateState) {
      return $this$updateState.r10l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $e.message);
    };
  }
  function AuthViewModel$login$lambda_1($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, false);
  }
  function AuthViewModel$loginWithGoogle$lambda($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, true, VOID, VOID, VOID, null);
  }
  function AuthViewModel$loginWithGoogle$lambda_0($e) {
    return function ($this$updateState) {
      return $this$updateState.r10l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $e.message);
    };
  }
  function AuthViewModel$loginWithGoogle$lambda_1($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, false);
  }
  function AuthViewModel$register$lambda($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, true, VOID, VOID, VOID, null);
  }
  function AuthViewModel$register$lambda_0($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, VOID, Login_instance);
  }
  function AuthViewModel$register$lambda_1($e) {
    return function ($this$updateState) {
      return $this$updateState.r10l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $e.message);
    };
  }
  function AuthViewModel$register$lambda_2($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, false);
  }
  function AuthViewModel$forgetPassword$lambda($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, true, VOID, VOID, VOID, null);
  }
  function AuthViewModel$forgetPassword$lambda_0($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, VOID, Login_instance);
  }
  function AuthViewModel$forgetPassword$lambda_1($e) {
    return function ($this$updateState) {
      return $this$updateState.r10l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $e.message);
    };
  }
  function AuthViewModel$forgetPassword$lambda_2($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, false);
  }
  function AuthViewModel$setPassword$lambda($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, true, VOID, VOID, VOID, null);
  }
  function AuthViewModel$setPassword$lambda_0($e) {
    return function ($this$updateState) {
      return $this$updateState.r10l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $e.message);
    };
  }
  function AuthViewModel$setPassword$lambda_1($this$updateState) {
    return $this$updateState.r10l(VOID, VOID, VOID, VOID, false);
  }
  function $handleIntentCOROUTINE$_0(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z10q_1 = _this__u8e3s4;
    this.a10r_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 13;
            var tmp0_subject = this.a10r_1;
            if (tmp0_subject instanceof EmailChanged) {
              this.z10q_1.x10k(AuthViewModel$handleIntent$lambda(this.a10r_1));
              this.n9_1 = 12;
              continue $sm;
            } else {
              if (tmp0_subject instanceof PasswordChanged) {
                this.z10q_1.x10k(AuthViewModel$handleIntent$lambda_0(this.a10r_1));
                this.n9_1 = 12;
                continue $sm;
              } else {
                if (tmp0_subject instanceof ConfirmPasswordChanged) {
                  this.z10q_1.x10k(AuthViewModel$handleIntent$lambda_1(this.a10r_1));
                  this.n9_1 = 12;
                  continue $sm;
                } else {
                  if (tmp0_subject instanceof RecoveryUrlReceived) {
                    this.o9_1 = 9;
                    this.n9_1 = 6;
                    suspendResult = this.z10q_1.l10r_1.pyo(this.a10r_1.v10l_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (equals(tmp0_subject, LoginClicked_instance)) {
                      this.n9_1 = 5;
                      suspendResult = login(this.z10q_1, this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      if (tmp0_subject instanceof GoogleLoginClicked) {
                        this.n9_1 = 4;
                        suspendResult = loginWithGoogle(this.z10q_1, this.a10r_1.w10l_1, this.a10r_1.x10l_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        if (equals(tmp0_subject, RegisterClicked_instance)) {
                          this.n9_1 = 3;
                          suspendResult = register(this.z10q_1, this);
                          if (suspendResult === get_COROUTINE_SUSPENDED()) {
                            return suspendResult;
                          }
                          continue $sm;
                        } else {
                          if (equals(tmp0_subject, ForgetPasswordClicked_instance)) {
                            this.n9_1 = 2;
                            suspendResult = forgetPassword(this.z10q_1, this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) {
                              return suspendResult;
                            }
                            continue $sm;
                          } else {
                            if (equals(tmp0_subject, SetPasswordClicked_instance)) {
                              this.n9_1 = 1;
                              suspendResult = setPassword(this.z10q_1, this);
                              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                                return suspendResult;
                              }
                              continue $sm;
                            } else {
                              if (tmp0_subject instanceof TogglePrivacyPolicy) {
                                this.z10q_1.x10k(AuthViewModel$handleIntent$lambda_4(this.a10r_1));
                                this.n9_1 = 12;
                                continue $sm;
                              } else {
                                if (tmp0_subject instanceof ToggleKeepLogin) {
                                  this.z10q_1.x10k(AuthViewModel$handleIntent$lambda_5(this.a10r_1));
                                  this.n9_1 = 12;
                                  continue $sm;
                                } else {
                                  if (tmp0_subject instanceof NavigateTo) {
                                    this.z10q_1.x10k(AuthViewModel$handleIntent$lambda_6(this.a10r_1));
                                    this.n9_1 = 12;
                                    continue $sm;
                                  } else {
                                    noWhenBranchMatchedException();
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            break;
          case 1:
            this.n9_1 = 12;
            continue $sm;
          case 2:
            this.n9_1 = 12;
            continue $sm;
          case 3:
            this.n9_1 = 12;
            continue $sm;
          case 4:
            this.n9_1 = 12;
            continue $sm;
          case 5:
            this.n9_1 = 12;
            continue $sm;
          case 6:
            if (contains(this.a10r_1.v10l_1, 'type=recovery') || contains(this.a10r_1.v10l_1, 'reset-password')) {
              this.z10q_1.x10k(AuthViewModel$handleIntent$lambda_2);
              this.n9_1 = 8;
              continue $sm;
            } else {
              if (contains(this.a10r_1.v10l_1, 'type=signup') || contains(this.a10r_1.v10l_1, 'verify')) {
                this.n9_1 = 7;
                suspendResult = this.z10q_1.d10l(NavigateToHome_instance, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.z10q_1.x10k(AuthViewModel$handleIntent$lambda_3);
                this.n9_1 = 8;
                continue $sm;
              }
            }

          case 7:
            this.n9_1 = 8;
            continue $sm;
          case 8:
            this.o9_1 = 13;
            this.n9_1 = 11;
            continue $sm;
          case 9:
            this.o9_1 = 13;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.n9_1 = 10;
              suspendResult = this.z10q_1.d10l(new ShowError_0(new DynamicString('Invalid or expired recovery link')), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 10:
            this.n9_1 = 11;
            continue $sm;
          case 11:
            this.o9_1 = 13;
            this.n9_1 = 12;
            continue $sm;
          case 12:
            return Unit_instance;
          case 13:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 13) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $loginCOROUTINE$_0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d10p_1 = _this__u8e3s4;
  }
  protoOf($loginCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            this.d10p_1.x10k(AuthViewModel$login$lambda);
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 8;
            this.o9_1 = 5;
            setSessionPersistence(this.d10p_1.s10h().ajg().u1().o10l_1);
            this.n9_1 = 2;
            suspendResult = this.d10p_1.f10r_1.n102(this.d10p_1.s10h().ajg().u1().h10l_1, this.d10p_1.s10h().ajg().u1().i10l_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.d10p_1.j10r_1.r2b(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.n9_1 = 4;
            suspendResult = this.d10p_1.d10l(NavigateToHome_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.o9_1 = 9;
            this.n9_1 = 7;
            continue $sm;
          case 5:
            this.o9_1 = 8;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.d10p_1.x10k(AuthViewModel$login$lambda_0(e));
              this.n9_1 = 6;
              suspendResult = this.d10p_1.d10l(new ShowError_0(mapAuthError(this.d10p_1, e)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 6:
            this.o9_1 = 9;
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.o9_1 = 9;
            this.d10p_1.x10k(AuthViewModel$login$lambda_1);
            return Unit_instance;
          case 8:
            this.o9_1 = 9;
            var t = this.q9_1;
            this.d10p_1.x10k(AuthViewModel$login$lambda_1);
            throw t;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 9) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $loginWithGoogleCOROUTINE$_0(_this__u8e3s4, idToken, accessToken, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m10p_1 = _this__u8e3s4;
    this.n10p_1 = idToken;
    this.o10p_1 = accessToken;
  }
  protoOf($loginWithGoogleCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            this.m10p_1.x10k(AuthViewModel$loginWithGoogle$lambda);
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 8;
            this.o9_1 = 5;
            setSessionPersistence(this.m10p_1.s10h().ajg().u1().o10l_1);
            this.n9_1 = 2;
            suspendResult = this.m10p_1.g10r_1.p102(this.n10p_1, this.o10p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.m10p_1.j10r_1.r2b(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.n9_1 = 4;
            suspendResult = this.m10p_1.d10l(NavigateToHome_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.o9_1 = 9;
            this.n9_1 = 7;
            continue $sm;
          case 5:
            this.o9_1 = 8;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.m10p_1.x10k(AuthViewModel$loginWithGoogle$lambda_0(e));
              this.n9_1 = 6;
              suspendResult = this.m10p_1.d10l(new ShowError_0(mapAuthError(this.m10p_1, e)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 6:
            this.o9_1 = 9;
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.o9_1 = 9;
            this.m10p_1.x10k(AuthViewModel$loginWithGoogle$lambda_1);
            return Unit_instance;
          case 8:
            this.o9_1 = 9;
            var t = this.q9_1;
            this.m10p_1.x10k(AuthViewModel$loginWithGoogle$lambda_1);
            throw t;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 9) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $registerCOROUTINE$_0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x10p_1 = _this__u8e3s4;
  }
  protoOf($registerCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 10;
            if (!this.x10p_1.s10h().ajg().u1().n10l_1) {
              this.n9_1 = 9;
              suspendResult = this.x10p_1.d10l(new ShowError_0(new ResourceString(get_privacy_policy_required(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              continue $sm;
            }

          case 1:
            this.x10p_1.x10k(AuthViewModel$register$lambda);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 8;
            this.o9_1 = 5;
            setSessionPersistence(this.x10p_1.s10h().ajg().u1().o10l_1);
            this.n9_1 = 3;
            suspendResult = this.x10p_1.h10r_1.n102(this.x10p_1.s10h().ajg().u1().h10l_1, this.x10p_1.s10h().ajg().u1().i10l_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.n9_1 = 4;
            suspendResult = this.x10p_1.d10l(new ShowMessage(new ResourceString(get_registration_successful(string_instance), [])), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.x10p_1.x10k(AuthViewModel$register$lambda_0);
            this.o9_1 = 10;
            this.n9_1 = 7;
            continue $sm;
          case 5:
            this.o9_1 = 8;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.x10p_1.x10k(AuthViewModel$register$lambda_1(e));
              this.n9_1 = 6;
              suspendResult = this.x10p_1.d10l(new ShowError_0(mapAuthError(this.x10p_1, e)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 6:
            this.o9_1 = 10;
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.o9_1 = 10;
            this.x10p_1.x10k(AuthViewModel$register$lambda_2);
            return Unit_instance;
          case 8:
            this.o9_1 = 10;
            var t = this.q9_1;
            this.x10p_1.x10k(AuthViewModel$register$lambda_2);
            throw t;
          case 9:
            return Unit_instance;
          case 10:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 10) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $forgetPasswordCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g10q_1 = _this__u8e3s4;
  }
  protoOf($forgetPasswordCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.g10q_1.x10k(AuthViewModel$forgetPassword$lambda);
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 7;
            this.o9_1 = 4;
            this.n9_1 = 2;
            suspendResult = this.g10q_1.i10r_1.v102(this.g10q_1.s10h().ajg().u1().h10l_1, getOrigin(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.g10q_1.d10l(new ShowMessage(new ResourceString(get_password_reset_sent(string_instance), [])), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.g10q_1.x10k(AuthViewModel$forgetPassword$lambda_0);
            this.o9_1 = 8;
            this.n9_1 = 6;
            continue $sm;
          case 4:
            this.o9_1 = 7;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.g10q_1.x10k(AuthViewModel$forgetPassword$lambda_1(e));
              this.n9_1 = 5;
              suspendResult = this.g10q_1.d10l(new ShowError_0(mapAuthError(this.g10q_1, e)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 5:
            this.o9_1 = 8;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.o9_1 = 8;
            this.g10q_1.x10k(AuthViewModel$forgetPassword$lambda_2);
            return Unit_instance;
          case 7:
            this.o9_1 = 8;
            var t = this.q9_1;
            this.g10q_1.x10k(AuthViewModel$forgetPassword$lambda_2);
            throw t;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 8) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $setPasswordCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.p10q_1 = _this__u8e3s4;
  }
  protoOf($setPasswordCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 13;
            this.q10q_1 = this.p10q_1.s10h().ajg().u1();
            if (this.q10q_1.i10l_1.length < 6) {
              this.n9_1 = 12;
              suspendResult = this.p10q_1.d10l(new ShowError_0(new ResourceString(get_weak_password(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              continue $sm;
            }

          case 1:
            if (!(this.q10q_1.i10l_1 === this.q10q_1.j10l_1)) {
              this.n9_1 = 11;
              suspendResult = this.p10q_1.d10l(new ShowError_0(new ResourceString(get_passwords_dont_match(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            this.p10q_1.x10k(AuthViewModel$setPassword$lambda);
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 10;
            this.o9_1 = 7;
            this.n9_1 = 4;
            suspendResult = this.p10q_1.k10r_1.x102(this.q10q_1.i10l_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.n9_1 = 5;
            suspendResult = this.p10q_1.d10l(new ShowMessage(new ResourceString(get_password_updated(string_instance), [])), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.n9_1 = 6;
            suspendResult = this.p10q_1.d10l(NavigateToHome_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.o9_1 = 13;
            this.n9_1 = 9;
            continue $sm;
          case 7:
            this.o9_1 = 10;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.p10q_1.x10k(AuthViewModel$setPassword$lambda_0(e));
              this.n9_1 = 8;
              suspendResult = this.p10q_1.d10l(new ShowError_0(mapAuthError(this.p10q_1, e)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 8:
            this.o9_1 = 13;
            this.n9_1 = 9;
            continue $sm;
          case 9:
            this.o9_1 = 13;
            this.p10q_1.x10k(AuthViewModel$setPassword$lambda_1);
            return Unit_instance;
          case 10:
            this.o9_1 = 13;
            var t = this.q9_1;
            this.p10q_1.x10k(AuthViewModel$setPassword$lambda_1);
            throw t;
          case 11:
            return Unit_instance;
          case 12:
            return Unit_instance;
          case 13:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 13) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function AuthViewModel(loginUseCase, loginWithGoogleUseCase, registerUseCase, resetPasswordUseCase, syncCartUseCase, updatePasswordUseCase, handleRecoveryLinkUseCase) {
    BaseMviViewModel.call(this, new AuthState());
    this.f10r_1 = loginUseCase;
    this.g10r_1 = loginWithGoogleUseCase;
    this.h10r_1 = registerUseCase;
    this.i10r_1 = resetPasswordUseCase;
    this.j10r_1 = syncCartUseCase;
    this.k10r_1 = updatePasswordUseCase;
    this.l10r_1 = handleRecoveryLinkUseCase;
  }
  protoOf(AuthViewModel).m10r = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_0(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthViewModel).f10l = function (intent, $completion) {
    return this.m10r(isInterface(intent, AuthIntent) ? intent : THROW_CCE(), $completion);
  };
  var client_fstech_hadaya_presentation_cart_CartState$stable;
  var client_fstech_hadaya_presentation_cart_CartIntent_LoadCart$stable;
  var client_fstech_hadaya_presentation_cart_CartIntent_UpdateQuantity$stable;
  var client_fstech_hadaya_presentation_cart_CartIntent_RemoveItem$stable;
  var client_fstech_hadaya_presentation_cart_CartIntent_Checkout$stable;
  var client_fstech_hadaya_presentation_cart_CartIntent_ClearCart$stable;
  var client_fstech_hadaya_presentation_cart_CartSideEffect_ShowError$stable;
  var client_fstech_hadaya_presentation_cart_CartSideEffect_NavigateToCheckout$stable;
  var client_fstech_hadaya_presentation_cart_CartSideEffect_NavigateToAuth$stable;
  function CartState(cartItems, isLoading, isAuthChecking, totalPrice, isLoggedIn, language, isConnected) {
    cartItems = cartItems === VOID ? emptyList() : cartItems;
    isLoading = isLoading === VOID ? false : isLoading;
    isAuthChecking = isAuthChecking === VOID ? true : isAuthChecking;
    totalPrice = totalPrice === VOID ? 0.0 : totalPrice;
    isLoggedIn = isLoggedIn === VOID ? false : isLoggedIn;
    language = language === VOID ? 'en' : language;
    isConnected = isConnected === VOID ? true : isConnected;
    this.n10r_1 = cartItems;
    this.o10r_1 = isLoading;
    this.p10r_1 = isAuthChecking;
    this.q10r_1 = totalPrice;
    this.r10r_1 = isLoggedIn;
    this.s10r_1 = language;
    this.t10r_1 = isConnected;
  }
  protoOf(CartState).u10r = function (cartItems, isLoading, isAuthChecking, totalPrice, isLoggedIn, language, isConnected) {
    return new CartState(cartItems, isLoading, isAuthChecking, totalPrice, isLoggedIn, language, isConnected);
  };
  protoOf(CartState).v10r = function (cartItems, isLoading, isAuthChecking, totalPrice, isLoggedIn, language, isConnected, $super) {
    cartItems = cartItems === VOID ? this.n10r_1 : cartItems;
    isLoading = isLoading === VOID ? this.o10r_1 : isLoading;
    isAuthChecking = isAuthChecking === VOID ? this.p10r_1 : isAuthChecking;
    totalPrice = totalPrice === VOID ? this.q10r_1 : totalPrice;
    isLoggedIn = isLoggedIn === VOID ? this.r10r_1 : isLoggedIn;
    language = language === VOID ? this.s10r_1 : language;
    isConnected = isConnected === VOID ? this.t10r_1 : isConnected;
    return $super === VOID ? this.u10r(cartItems, isLoading, isAuthChecking, totalPrice, isLoggedIn, language, isConnected) : $super.u10r.call(this, cartItems, isLoading, isAuthChecking, totalPrice, isLoggedIn, language, isConnected);
  };
  protoOf(CartState).toString = function () {
    return 'CartState(cartItems=' + toString(this.n10r_1) + ', isLoading=' + this.o10r_1 + ', isAuthChecking=' + this.p10r_1 + ', totalPrice=' + this.q10r_1 + ', isLoggedIn=' + this.r10r_1 + ', language=' + this.s10r_1 + ', isConnected=' + this.t10r_1 + ')';
  };
  protoOf(CartState).hashCode = function () {
    var result = hashCode(this.n10r_1);
    result = imul(result, 31) + getBooleanHashCode(this.o10r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p10r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q10r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r10r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s10r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t10r_1) | 0;
    return result;
  };
  protoOf(CartState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CartState))
      return false;
    if (!equals(this.n10r_1, other.n10r_1))
      return false;
    if (!(this.o10r_1 === other.o10r_1))
      return false;
    if (!(this.p10r_1 === other.p10r_1))
      return false;
    if (!equals(this.q10r_1, other.q10r_1))
      return false;
    if (!(this.r10r_1 === other.r10r_1))
      return false;
    if (!(this.s10r_1 === other.s10r_1))
      return false;
    if (!(this.t10r_1 === other.t10r_1))
      return false;
    return true;
  };
  function LoadCart() {
  }
  protoOf(LoadCart).toString = function () {
    return 'LoadCart';
  };
  protoOf(LoadCart).hashCode = function () {
    return 1095053526;
  };
  protoOf(LoadCart).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadCart))
      return false;
    return true;
  };
  var LoadCart_instance;
  function LoadCart_getInstance() {
    return LoadCart_instance;
  }
  function UpdateQuantity(cartItem, newQuantity) {
    this.w10r_1 = cartItem;
    this.x10r_1 = newQuantity;
  }
  protoOf(UpdateQuantity).toString = function () {
    return 'UpdateQuantity(cartItem=' + this.w10r_1.toString() + ', newQuantity=' + this.x10r_1 + ')';
  };
  protoOf(UpdateQuantity).hashCode = function () {
    var result = this.w10r_1.hashCode();
    result = imul(result, 31) + this.x10r_1 | 0;
    return result;
  };
  protoOf(UpdateQuantity).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateQuantity))
      return false;
    if (!this.w10r_1.equals(other.w10r_1))
      return false;
    if (!(this.x10r_1 === other.x10r_1))
      return false;
    return true;
  };
  function RemoveItem(cartItem) {
    this.y10r_1 = cartItem;
  }
  protoOf(RemoveItem).toString = function () {
    return 'RemoveItem(cartItem=' + this.y10r_1.toString() + ')';
  };
  protoOf(RemoveItem).hashCode = function () {
    return this.y10r_1.hashCode();
  };
  protoOf(RemoveItem).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemoveItem))
      return false;
    if (!this.y10r_1.equals(other.y10r_1))
      return false;
    return true;
  };
  function Checkout_0() {
  }
  protoOf(Checkout_0).toString = function () {
    return 'Checkout';
  };
  protoOf(Checkout_0).hashCode = function () {
    return 786869494;
  };
  protoOf(Checkout_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Checkout_0))
      return false;
    return true;
  };
  var Checkout_instance_0;
  function Checkout_getInstance_0() {
    return Checkout_instance_0;
  }
  function ClearCart() {
  }
  protoOf(ClearCart).toString = function () {
    return 'ClearCart';
  };
  protoOf(ClearCart).hashCode = function () {
    return 1247300957;
  };
  protoOf(ClearCart).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearCart))
      return false;
    return true;
  };
  var ClearCart_instance;
  function ClearCart_getInstance() {
    return ClearCart_instance;
  }
  function CartIntent() {
  }
  function ShowError_1(message) {
    this.z10r_1 = message;
  }
  protoOf(ShowError_1).toString = function () {
    return 'ShowError(message=' + toString(this.z10r_1) + ')';
  };
  protoOf(ShowError_1).hashCode = function () {
    return hashCode(this.z10r_1);
  };
  protoOf(ShowError_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowError_1))
      return false;
    if (!equals(this.z10r_1, other.z10r_1))
      return false;
    return true;
  };
  function NavigateToCheckout() {
  }
  protoOf(NavigateToCheckout).toString = function () {
    return 'NavigateToCheckout';
  };
  protoOf(NavigateToCheckout).hashCode = function () {
    return -1010386122;
  };
  protoOf(NavigateToCheckout).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateToCheckout))
      return false;
    return true;
  };
  var NavigateToCheckout_instance;
  function NavigateToCheckout_getInstance() {
    return NavigateToCheckout_instance;
  }
  function NavigateToAuth() {
  }
  protoOf(NavigateToAuth).toString = function () {
    return 'NavigateToAuth';
  };
  protoOf(NavigateToAuth).hashCode = function () {
    return 261997464;
  };
  protoOf(NavigateToAuth).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateToAuth))
      return false;
    return true;
  };
  var NavigateToAuth_instance;
  function NavigateToAuth_getInstance() {
    return NavigateToAuth_instance;
  }
  function CartSideEffect() {
  }
  function CartScreen(onBack, onNavigateToCheckout, onNavigateToAuth, onNavigateToCartNormalProductDetails, onNavigateToCartMugProductDetails, onNavigateToCartMagicMugProductDetails, onNavigateToUpdate, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1591345147);
    sourceInformation($composer_0, 'C(CartScreen)P(!1,5!1,4,3)87@3997L15,88@4056L16,89@4101L32,91@4159L44,93@4235L380,93@4209L406,103@4640L27,106@4794L8025:CartScreen.kt#5k0css');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToCheckout) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToAuth) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToCartNormalProductDetails) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToCartMugProductDetails) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToCartMagicMugProductDetails) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToUpdate) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 599187) === 599186), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1591345147, $dirty, -1, 'client.fstech.hadaya.presentation.cart.CartScreen (CartScreen.kt:86)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(CartViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, -274313659, 'CC(remember):CartScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance().f30_1) {
        var value = new SnackbarHostState();
        this_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp0_group;
      sourceInformationMarkerStart($composer_0, -274311791, 'CC(remember):CartScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_2;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = mutableStateOf(null);
        this_1.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      var itemToRemove$delegate = tmp1_group;
      sourceInformationMarkerStart($composer_0, -274309023, 'CC(remember):CartScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!($composer_0.q31(viewModel) | ($dirty & 112) === 32) | ($dirty & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_0.i31();
      var tmp_3;
      if (invalid || it_1 === Companion_getInstance().f30_1) {
        var value_1 = CartScreen$slambda_0(viewModel, snackbarHostState, onNavigateToCheckout, onNavigateToAuth, null);
        tmp0_0.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp2_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp2_group, $composer_0, 0);
      var adaptiveInfo = currentWindowAdaptiveInfo(false, $composer_0, 0, 1);
      var isDesktop = adaptiveInfo.bxm_1.xxl(840);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = fillMaxSize(Companion_instance);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_2 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_3 = $composer_2;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_0);
      var tmp0_1 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_4 = $composer_4.g30();
      if (!isInterface(tmp_4, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_1);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_5 = $composer_4;
      var $composer_6 = $composer_5;
      sourceInformationMarkerStart($composer_6, 555123962, 'C107@4843L6667,233@11524L140:CartScreen.kt#5k0css');
      var tmp_5 = BoxScopeInstance_instance.udr(fillMaxSize(Companion_instance), Companion_getInstance_11().l8t_1);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$20 = _Dp___init__impl__ms3zkb(1400);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = widthIn(tmp_5, VOID, tmp$ret$20);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_7 = $composer_6;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_7, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_8 = $composer_7;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
      var localMap_0 = $composer_8.t31();
      var materialized_0 = materialize($composer_8, modifier_2);
      var tmp0_2 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_9 = $composer_8;
      var tmp_6 = $composer_9.g30();
      if (!isInterface(tmp_6, Applier)) {
        invalidApplier();
      }
      $composer_9.b31();
      if ($composer_9.h30()) {
        $composer_9.c31(tmp0_2);
      } else {
        $composer_9.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_10 = $composer_9;
      var $composer_11 = $composer_10;
      sourceInformationMarkerStart($composer_11, -628323217, 'C134@6113L11,134@6066L70,115@5207L294,123@5529L492,108@4949L1258:CartScreen.kt#5k0css');
      var tmp_7 = TopAppBarDefaults_getInstance();
      var tmp_8 = MaterialTheme_instance.unz($composer_11, 6).ko0_1;
      var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp0_colors = tmp_7.wnz(tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_11, 1572864, 62);
      var tmp1_windowInsets = WindowInsets(0, 0, 0, 0);
      var tmp_13 = ComposableSingletons$CartScreenKt_getInstance().a10s_1;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-631501317, true, CartScreen$lambda_2(onBack), $composer_11, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_12 = $composer_11;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_12.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_2 = $composer_12.i31();
      var tmp_14;
      if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_12.j31(value_2);
        tmp_14 = value_2;
      } else {
        tmp_14 = it_2;
      }
      var tmp_15 = tmp_14;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_0 = rememberComposableLambda(-670236558, true, CartScreen$lambda_3(viewModel, state$delegate), $composer_11, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_13 = $composer_11;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_13.k31(dispatchReceiver_0);
      // Inline function 'kotlin.let' call
      var it_3 = $composer_13.i31();
      var tmp_16;
      if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = ComposableLambda$invoke$ref_1(dispatchReceiver_0);
        $composer_13.j31(value_3);
        tmp_16 = value_3;
      } else {
        tmp_16 = it_3;
      }
      var tmp_17 = tmp_16;
      var tmp_18 = _Dp___init__impl__ms3zkb(0.0);
      TopAppBar(tmp_13, null, tmp_15, tmp_17, tmp_18, tmp1_windowInsets, tmp0_colors, null, $composer_11, 3462, 146);
      if (CartScreen$lambda(state$delegate).p10r_1 || (CartScreen$lambda(state$delegate).o10r_1 && CartScreen$lambda(state$delegate).n10r_1.r())) {
        $composer_11.m30(-627183379);
        sourceInformation($composer_11, '139@6319L140');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = fillMaxSize(Companion_instance);
        var contentAlignment_0 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_0 = false;
        var $composer_14 = $composer_11;
        if (!((4 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_15 = $composer_14;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_15, 0).hashCode();
        var localMap_1 = $composer_15.t31();
        var materialized_1 = materialize($composer_15, modifier_4);
        var tmp0_3 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_16 = $composer_15;
        var tmp_19 = $composer_16.g30();
        if (!isInterface(tmp_19, Applier)) {
          invalidApplier();
        }
        $composer_16.b31();
        if ($composer_16.h30()) {
          $composer_16.c31(tmp0_3);
        } else {
          $composer_16.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_16);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_17 = $composer_16;
        var $composer_18 = $composer_17;
        sourceInformationMarkerStart($composer_18, -868549274, 'C140@6410L27:CartScreen.kt#5k0css');
        var tmp_20 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_21 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_22 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_23 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_20, tmp_21, tmp_22, tmp_23, _Dp___init__impl__ms3zkb(0.0), $composer_18, 0, 63);
        sourceInformationMarkerEnd($composer_18);
        $composer_16.e31();
        $composer_11.n30();
      } else if (CartScreen$lambda(state$delegate).n10r_1.r()) {
        $composer_11.m30(-626908130);
        sourceInformation($composer_11, '143@6536L2075');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_5 = fillMaxSize(Companion_instance);
        var contentAlignment_1 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_1 = false;
        var $composer_19 = $composer_11;
        if (!((4 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_1 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_1 = false;
        var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_20 = $composer_19;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_20, 0).hashCode();
        var localMap_2 = $composer_20.t31();
        var materialized_2 = materialize($composer_20, modifier_6);
        var tmp0_4 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_21 = $composer_20;
        var tmp_24 = $composer_21.g30();
        if (!isInterface(tmp_24, Applier)) {
          invalidApplier();
        }
        $composer_21.b31();
        if ($composer_21.h30()) {
          $composer_21.c31(tmp0_4);
        } else {
          $composer_21.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_21);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_22 = $composer_21;
        var $composer_23 = $composer_22;
        sourceInformationMarkerStart($composer_23, 1803675630, 'C144@6627L1962:CartScreen.kt#5k0css');
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_7 = null;
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = Companion_getInstance_11().x8t_1;
        var $composer_24 = $composer_23;
        if (!((3 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((3 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((3 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_3 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_24, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_25 = $composer_24;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_25, 0).hashCode();
        var localMap_3 = $composer_25.t31();
        var materialized_3 = materialize($composer_25, modifier_8);
        var tmp0_5 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_26 = $composer_25;
        var tmp_25 = $composer_26.g30();
        if (!isInterface(tmp_25, Applier)) {
          invalidApplier();
        }
        $composer_26.b31();
        if ($composer_26.h30()) {
          $composer_26.c31(tmp0_5);
        } else {
          $composer_26.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_26);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_27 = $composer_26;
        var $composer_28 = $composer_27;
        sourceInformationMarkerStart($composer_28, 318647243, 'C149@6926L11,145@6716L803,161@7548L41,163@7656L43,162@7618L223,167@7870L40,169@7977L42,170@8075L11,168@7939L194,172@8162L41,173@8232L331:CartScreen.kt#5k0css');
        var tmp_26 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$59 = _Dp___init__impl__ms3zkb(120);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_9 = background(size(tmp_26, tmp$ret$59), MaterialTheme_instance.unz($composer_28, 6).oo0_1, get_CircleShape());
        var contentAlignment_2 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_2 = false;
        var $composer_29 = $composer_28;
        if (!((4 & 1) === 0))
          modifier_9 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_2 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_2 = false;
        var measurePolicy_4 = maybeCachedBoxMeasurePolicy(contentAlignment_2, propagateMinConstraints_2);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_10 = modifier_9;
        var $composer_30 = $composer_29;
        if (!((0 & 2) === 0))
          modifier_10 = Companion_instance;
        var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_30, 0).hashCode();
        var localMap_4 = $composer_30.t31();
        var materialized_4 = materialize($composer_30, modifier_10);
        var tmp0_6 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_31 = $composer_30;
        var tmp_27 = $composer_31.g30();
        if (!isInterface(tmp_27, Applier)) {
          invalidApplier();
        }
        $composer_31.b31();
        if ($composer_31.h30()) {
          $composer_31.c31(tmp0_6);
        } else {
          $composer_31.d31();
        }
        var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_31);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
        var $composer_32 = $composer_31;
        var $composer_33 = $composer_32;
        sourceInformationMarkerStart($composer_33, 516469028, 'C158@7436L11,154@7177L312:CartScreen.kt#5k0css');
        var tmp_28 = get_ShoppingCart(Icons_getInstance().dxv_1);
        var tmp_29 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$66 = _Dp___init__impl__ms3zkb(60);
        Icon(tmp_28, null, size(tmp_29, tmp$ret$66), MaterialTheme_instance.unz($composer_33, 6).xnz_1, $composer_33, 432, 0);
        sourceInformationMarkerEnd($composer_33);
        $composer_31.e31();
        var tmp_30 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$67 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_30, tmp$ret$67), $composer_28, 6);
        var tmp_31 = stringResource(get_cart_empty_title(string_instance), $composer_28, 0);
        var tmp_32 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_33 = get_sp(22);
        var tmp_34 = Companion_getInstance_16().e7z_1;
        var tmp_35 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_36 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_37 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_31, null, tmp_32, null, tmp_33, null, tmp_34, null, tmp_35, null, null, tmp_36, tmp_37, false, 0, 0, null, null, $composer_28, 1597440, 0, 262062);
        var tmp_38 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$68 = _Dp___init__impl__ms3zkb(8);
        Spacer(height(tmp_38, tmp$ret$68), $composer_28, 6);
        var tmp_39 = stringResource(get_cart_empty_desc(string_instance), $composer_28, 0);
        var tmp_40 = MaterialTheme_instance.unz($composer_28, 6).po0_1;
        var tmp_41 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_42 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_43 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_44 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_39, null, tmp_40, null, tmp_41, null, null, null, tmp_42, null, null, tmp_43, tmp_44, false, 0, 0, null, null, $composer_28, 0, 0, 262138);
        var tmp_45 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$69 = _Dp___init__impl__ms3zkb(32);
        Spacer(height(tmp_45, tmp$ret$69), $composer_28, 6);
        var tmp_46 = fillMaxWidth(Companion_instance, 0.6);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$70 = _Dp___init__impl__ms3zkb(12);
        var tmp_47 = RoundedCornerShape(tmp$ret$70);
        Button(onBack, tmp_46, false, tmp_47, null, null, null, null, null, ComposableSingletons$CartScreenKt_getInstance().d10s_1, $composer_28, 805306416 | 14 & $dirty, 500);
        sourceInformationMarkerEnd($composer_28);
        $composer_26.e31();
        sourceInformationMarkerEnd($composer_23);
        $composer_21.e31();
        $composer_11.n30();
      } else {
        $composer_11.m30(-624780972);
        sourceInformation($composer_11, '');
        if (isDesktop) {
          $composer_11.m30(-624784196);
          sourceInformation($composer_11, '184@8698L1525');
          var tmp_48 = fillMaxSize(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$71 = _Dp___init__impl__ms3zkb(24);
          var tmp0_7 = padding_2(tmp_48, tmp$ret$71);
          var tmp_49 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$72 = _Dp___init__impl__ms3zkb(32);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_11 = tmp0_7;
          var horizontalArrangement = tmp_49.mdq(tmp$ret$72);
          var verticalAlignment = null;
          var $composer_34 = $composer_11;
          if (!((4 & 1) === 0))
            modifier_11 = Companion_instance;
          if (!((4 & 2) === 0))
            horizontalArrangement = Arrangement_getInstance().qdp_1;
          if (!((4 & 4) === 0))
            verticalAlignment = Companion_getInstance_11().t8t_1;
          var measurePolicy_5 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_34, 14 & 54 >> 3 | 112 & 54 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_12 = modifier_11;
          var $composer_35 = $composer_34;
          if (!((0 & 2) === 0))
            modifier_12 = Companion_instance;
          var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_35, 0).hashCode();
          var localMap_5 = $composer_35.t31();
          var materialized_5 = materialize($composer_35, modifier_12);
          var tmp0_8 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_36 = $composer_35;
          var tmp_50 = $composer_36.g30();
          if (!isInterface(tmp_50, Applier)) {
            invalidApplier();
          }
          $composer_36.b31();
          if ($composer_36.h30()) {
            $composer_36.c31(tmp0_8);
          } else {
            $composer_36.d31();
          }
          var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_36);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
          var $composer_37 = $composer_36;
          var $composer_38 = $composer_37;
          sourceInformationMarkerStart($composer_38, 2022011468, 'C188@8930L884,202@9872L325:CartScreen.kt#5k0css');
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_13 = fillMaxHeight(RowScopeInstance_instance.bdy(Companion_instance, 1.5));
          var verticalArrangement_1 = null;
          var horizontalAlignment_1 = null;
          var $composer_39 = $composer_38;
          if (!((6 & 1) === 0))
            modifier_13 = Companion_instance;
          if (!((6 & 2) === 0))
            verticalArrangement_1 = Arrangement_getInstance().sdp_1;
          if (!((6 & 4) === 0))
            horizontalAlignment_1 = Companion_getInstance_11().w8t_1;
          var measurePolicy_6 = columnMeasurePolicy(verticalArrangement_1, horizontalAlignment_1, $composer_39, 14 & 0 >> 3 | 112 & 0 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_14 = modifier_13;
          var $composer_40 = $composer_39;
          if (!((0 & 2) === 0))
            modifier_14 = Companion_instance;
          var compositeKeyHash_6 = get_currentCompositeKeyHashCode($composer_40, 0).hashCode();
          var localMap_6 = $composer_40.t31();
          var materialized_6 = materialize($composer_40, modifier_14);
          var tmp0_9 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_41 = $composer_40;
          var tmp_51 = $composer_41.g30();
          if (!isInterface(tmp_51, Applier)) {
            invalidApplier();
          }
          $composer_41.b31();
          if ($composer_41.h30()) {
            $composer_41.c31(tmp0_9);
          } else {
            $composer_41.d31();
          }
          var $this$ReusableComposeNode_6 = _Updater___init__impl__rbfxm8($composer_41);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, measurePolicy_6, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, localMap_6, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, compositeKeyHash_6, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_6, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, materialized_6, Companion_getInstance_12().qah_1);
          var $composer_42 = $composer_41;
          var $composer_43 = $composer_42;
          sourceInformationMarkerStart($composer_43, 953493390, 'C189@9021L50,192@9225L159,195@9433L21,196@9506L244,190@9104L680:CartScreen.kt#5k0css');
          ConnectionWarning(CartScreen$lambda(state$delegate).t10r_1, $composer_43, 0);
          var tmp_52 = CartScreen$lambda(state$delegate);
          sourceInformationMarkerStart($composer_43, 1970426425, 'CC(remember):CartScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_2 = $composer_43.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_4 = $composer_43.i31();
          var tmp_53;
          if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
            var value_4 = CartScreen$lambda_4(viewModel);
            $composer_43.j31(value_4);
            tmp_53 = value_4;
          } else {
            tmp_53 = it_4;
          }
          var tmp0_group_0 = tmp_53;
          sourceInformationMarkerEnd($composer_43);
          sourceInformationMarkerStart($composer_43, 1970432943, 'CC(remember):CartScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_5 = $composer_43.i31();
          var tmp_54;
          if (false || it_5 === Companion_getInstance().f30_1) {
            var value_5 = CartScreen$lambda_5(itemToRemove$delegate);
            $composer_43.j31(value_5);
            tmp_54 = value_5;
          } else {
            tmp_54 = it_5;
          }
          var tmp1_group_0 = tmp_54;
          sourceInformationMarkerEnd($composer_43);
          sourceInformationMarkerStart($composer_43, 1970435502, 'CC(remember):CartScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_3 = !!(!!(!!(($dirty & 7168) === 2048 | ($dirty & 57344) === 16384) | ($dirty & 458752) === 131072) | ($dirty & 3670016) === 1048576);
          // Inline function 'kotlin.let' call
          var it_6 = $composer_43.i31();
          var tmp_55;
          if (invalid_3 || it_6 === Companion_getInstance().f30_1) {
            var value_6 = CartScreen$lambda_6(onNavigateToCartNormalProductDetails, onNavigateToCartMugProductDetails, onNavigateToCartMagicMugProductDetails, onNavigateToUpdate);
            $composer_43.j31(value_6);
            tmp_55 = value_6;
          } else {
            tmp_55 = it_6;
          }
          var tmp2_group_0 = tmp_55;
          sourceInformationMarkerEnd($composer_43);
          CartItemsList(tmp_52, tmp0_group_0, tmp1_group_0, tmp2_group_0, $composer_43, 384);
          sourceInformationMarkerEnd($composer_43);
          $composer_41.e31();
          var tmp_56 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$97 = _Dp___init__impl__ms3zkb(0);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_15 = padding_1(tmp_56, VOID, tmp$ret$97);
          var contentAlignment_3 = null;
          var propagateMinConstraints_3 = false;
          var $composer_44 = $composer_38;
          if (!((6 & 1) === 0))
            modifier_15 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_3 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_3 = false;
          var measurePolicy_7 = maybeCachedBoxMeasurePolicy(contentAlignment_3, propagateMinConstraints_3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_16 = modifier_15;
          var $composer_45 = $composer_44;
          if (!((0 & 2) === 0))
            modifier_16 = Companion_instance;
          var compositeKeyHash_7 = get_currentCompositeKeyHashCode($composer_45, 0).hashCode();
          var localMap_7 = $composer_45.t31();
          var materialized_7 = materialize($composer_45, modifier_16);
          var tmp0_10 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_46 = $composer_45;
          var tmp_57 = $composer_46.g30();
          if (!isInterface(tmp_57, Applier)) {
            invalidApplier();
          }
          $composer_46.b31();
          if ($composer_46.h30()) {
            $composer_46.c31(tmp0_10);
          } else {
            $composer_46.d31();
          }
          var $this$ReusableComposeNode_7 = _Updater___init__impl__rbfxm8($composer_46);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, measurePolicy_7, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, localMap_7, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, compositeKeyHash_7, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_7, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, materialized_7, Companion_getInstance_12().qah_1);
          var $composer_47 = $composer_46;
          var $composer_48 = $composer_47;
          sourceInformationMarkerStart($composer_48, -1131133332, 'C205@10082L51,203@9962L205:CartScreen.kt#5k0css');
          var tmp_58 = CartScreen$lambda(state$delegate);
          sourceInformationMarkerStart($composer_48, -1006315811, 'CC(remember):CartScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_4 = $composer_48.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_7 = $composer_48.i31();
          var tmp_59;
          if (invalid_4 || it_7 === Companion_getInstance().f30_1) {
            var value_7 = CartScreen$lambda_7(viewModel);
            $composer_48.j31(value_7);
            tmp_59 = value_7;
          } else {
            tmp_59 = it_7;
          }
          var tmp0_group_1 = tmp_59;
          sourceInformationMarkerEnd($composer_48);
          CartSummarySection(tmp_58, tmp0_group_1, $composer_48, 0);
          sourceInformationMarkerEnd($composer_48);
          $composer_46.e31();
          sourceInformationMarkerEnd($composer_38);
          $composer_36.e31();
          $composer_11.n30();
        } else {
          $composer_11.m30(-623228554);
          sourceInformation($composer_11, '210@10277L1179');
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_17 = fillMaxSize(Companion_instance);
          var verticalArrangement_2 = null;
          var horizontalAlignment_2 = null;
          var $composer_49 = $composer_11;
          if (!((6 & 1) === 0))
            modifier_17 = Companion_instance;
          if (!((6 & 2) === 0))
            verticalArrangement_2 = Arrangement_getInstance().sdp_1;
          if (!((6 & 4) === 0))
            horizontalAlignment_2 = Companion_getInstance_11().w8t_1;
          var measurePolicy_8 = columnMeasurePolicy(verticalArrangement_2, horizontalAlignment_2, $composer_49, 14 & 6 >> 3 | 112 & 6 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_18 = modifier_17;
          var $composer_50 = $composer_49;
          if (!((0 & 2) === 0))
            modifier_18 = Companion_instance;
          var compositeKeyHash_8 = get_currentCompositeKeyHashCode($composer_50, 0).hashCode();
          var localMap_8 = $composer_50.t31();
          var materialized_8 = materialize($composer_50, modifier_18);
          var tmp0_11 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_51 = $composer_50;
          var tmp_60 = $composer_51.g30();
          if (!isInterface(tmp_60, Applier)) {
            invalidApplier();
          }
          $composer_51.b31();
          if ($composer_51.h30()) {
            $composer_51.c31(tmp0_11);
          } else {
            $composer_51.d31();
          }
          var $this$ReusableComposeNode_8 = _Updater___init__impl__rbfxm8($composer_51);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, measurePolicy_8, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, localMap_8, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, compositeKeyHash_8, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_8, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, materialized_8, Companion_getInstance_12().qah_1);
          var $composer_52 = $composer_51;
          var $composer_53 = $composer_52;
          sourceInformationMarkerStart($composer_53, -1646195445, 'C211@10349L50,212@10428L780,226@11349L51,224@11237L193:CartScreen.kt#5k0css');
          ConnectionWarning(CartScreen$lambda(state$delegate).t10r_1, $composer_53, 0);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_19 = ColumnScopeInstance_instance.yds(Companion_instance, 1.0);
          var contentAlignment_4 = null;
          var propagateMinConstraints_4 = false;
          var $composer_54 = $composer_53;
          if (!((6 & 1) === 0))
            modifier_19 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_4 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_4 = false;
          var measurePolicy_9 = maybeCachedBoxMeasurePolicy(contentAlignment_4, propagateMinConstraints_4);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_20 = modifier_19;
          var $composer_55 = $composer_54;
          if (!((0 & 2) === 0))
            modifier_20 = Companion_instance;
          var compositeKeyHash_9 = get_currentCompositeKeyHashCode($composer_55, 0).hashCode();
          var localMap_9 = $composer_55.t31();
          var materialized_9 = materialize($composer_55, modifier_20);
          var tmp0_12 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_56 = $composer_55;
          var tmp_61 = $composer_56.g30();
          if (!isInterface(tmp_61, Applier)) {
            invalidApplier();
          }
          $composer_56.b31();
          if ($composer_56.h30()) {
            $composer_56.c31(tmp0_12);
          } else {
            $composer_56.d31();
          }
          var $this$ReusableComposeNode_9 = _Updater___init__impl__rbfxm8($composer_56);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_9, measurePolicy_9, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_9, localMap_9, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_9, compositeKeyHash_9, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_9, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_9, materialized_9, Companion_getInstance_12().qah_1);
          var $composer_57 = $composer_56;
          var $composer_58 = $composer_57;
          sourceInformationMarkerStart($composer_58, 301401142, 'C215@10619L159,218@10827L21,219@10900L244,213@10498L680:CartScreen.kt#5k0css');
          var tmp_62 = CartScreen$lambda(state$delegate);
          sourceInformationMarkerStart($composer_58, -405916028, 'CC(remember):CartScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_5 = $composer_58.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_8 = $composer_58.i31();
          var tmp_63;
          if (invalid_5 || it_8 === Companion_getInstance().f30_1) {
            var value_8 = CartScreen$lambda_8(viewModel);
            $composer_58.j31(value_8);
            tmp_63 = value_8;
          } else {
            tmp_63 = it_8;
          }
          var tmp0_group_2 = tmp_63;
          sourceInformationMarkerEnd($composer_58);
          sourceInformationMarkerStart($composer_58, -405909510, 'CC(remember):CartScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_9 = $composer_58.i31();
          var tmp_64;
          if (false || it_9 === Companion_getInstance().f30_1) {
            var value_9 = CartScreen$lambda_9(itemToRemove$delegate);
            $composer_58.j31(value_9);
            tmp_64 = value_9;
          } else {
            tmp_64 = it_9;
          }
          var tmp1_group_1 = tmp_64;
          sourceInformationMarkerEnd($composer_58);
          sourceInformationMarkerStart($composer_58, -405906951, 'CC(remember):CartScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_6 = !!(!!(!!(($dirty & 7168) === 2048 | ($dirty & 57344) === 16384) | ($dirty & 458752) === 131072) | ($dirty & 3670016) === 1048576);
          // Inline function 'kotlin.let' call
          var it_10 = $composer_58.i31();
          var tmp_65;
          if (invalid_6 || it_10 === Companion_getInstance().f30_1) {
            var value_10 = CartScreen$lambda_10(onNavigateToCartNormalProductDetails, onNavigateToCartMugProductDetails, onNavigateToCartMagicMugProductDetails, onNavigateToUpdate);
            $composer_58.j31(value_10);
            tmp_65 = value_10;
          } else {
            tmp_65 = it_10;
          }
          var tmp2_group_1 = tmp_65;
          sourceInformationMarkerEnd($composer_58);
          CartItemsList(tmp_62, tmp0_group_2, tmp1_group_1, tmp2_group_1, $composer_58, 384);
          sourceInformationMarkerEnd($composer_58);
          $composer_56.e31();
          var tmp_66 = CartScreen$lambda(state$delegate);
          sourceInformationMarkerStart($composer_53, -1161450766, 'CC(remember):CartScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_7 = $composer_53.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_11 = $composer_53.i31();
          var tmp_67;
          if (invalid_7 || it_11 === Companion_getInstance().f30_1) {
            var value_11 = CartScreen$lambda_11(viewModel);
            $composer_53.j31(value_11);
            tmp_67 = value_11;
          } else {
            tmp_67 = it_11;
          }
          var tmp0_group_3 = tmp_67;
          sourceInformationMarkerEnd($composer_53);
          CartSummarySection(tmp_66, tmp0_group_3, $composer_53, 0);
          sourceInformationMarkerEnd($composer_53);
          $composer_51.e31();
          $composer_11.n30();
        }
        $composer_11.n30();
      }
      sourceInformationMarkerEnd($composer_11);
      $composer_9.e31();
      var tmp_68 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(snackbarHostState, tmp_68, null, $composer_6, 6, 4);
      if (!(CartScreen$lambda_0(itemToRemove$delegate) == null)) {
        $composer_6.m30(561717382);
        sourceInformation($composer_6, '240@11774L23,243@12004L546,256@12588L189,239@11722L1073');
        sourceInformationMarkerStart($composer_6, 572310402, 'CC(remember):CartScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_12 = $composer_6.i31();
        var tmp_69;
        if (false || it_12 === Companion_getInstance().f30_1) {
          var value_12 = CartScreen$lambda_12(itemToRemove$delegate);
          $composer_6.j31(value_12);
          tmp_69 = value_12;
        } else {
          tmp_69 = it_12;
        }
        var tmp0_group_4 = tmp_69;
        sourceInformationMarkerEnd($composer_6);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(-1610775650, true, CartScreen$lambda_13(viewModel, itemToRemove$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_59 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_8 = $composer_59.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_13 = $composer_59.i31();
        var tmp_70;
        if (invalid_8 || it_13 === Companion_getInstance().f30_1) {
          var value_13 = ComposableLambda$invoke$ref(dispatchReceiver_1);
          $composer_59.j31(value_13);
          tmp_70 = value_13;
        } else {
          tmp_70 = it_13;
        }
        var tmp_71 = tmp_70;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_2 = rememberComposableLambda(-719701028, true, CartScreen$lambda_14(itemToRemove$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_60 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_9 = $composer_60.k31(dispatchReceiver_2);
        // Inline function 'kotlin.let' call
        var it_14 = $composer_60.i31();
        var tmp_72;
        if (invalid_9 || it_14 === Companion_getInstance().f30_1) {
          var value_14 = ComposableLambda$invoke$ref(dispatchReceiver_2);
          $composer_60.j31(value_14);
          tmp_72 = value_14;
        } else {
          tmp_72 = it_14;
        }
        var tmp_73 = tmp_72;
        var tmp_74 = ComposableSingletons$CartScreenKt_getInstance().g10s_1;
        var tmp_75 = ComposableSingletons$CartScreenKt_getInstance().h10s_1;
        var tmp_76 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_77 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_78 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_79 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_80 = _Dp___init__impl__ms3zkb(0.0);
        AlertDialog(tmp0_group_4, tmp_71, null, tmp_73, null, tmp_74, tmp_75, null, tmp_76, tmp_77, tmp_78, tmp_79, tmp_80, null, $composer_6, 1772598, 0, 16276);
        $composer_6.n30();
      } else {
        $composer_6.m30(562779287);
        $composer_6.n30();
      }
      sourceInformationMarkerEnd($composer_6);
      $composer_4.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp3_safe_receiver = $composer_0.t30();
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.p3c(CartScreen$lambda_15(onBack, onNavigateToCheckout, onNavigateToAuth, onNavigateToCartNormalProductDetails, onNavigateToCartMugProductDetails, onNavigateToCartMagicMugProductDetails, onNavigateToUpdate, $changed));
    }
  }
  function ComposableSingletons$CartScreenKt$lambda$_1014174787$lambda_rbzv5($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C111@5036L37,110@5006L148:CartScreen.kt#5k0css');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1014174787, $changed, -1, 'client.fstech.hadaya.presentation.cart.ComposableSingletons$CartScreenKt.lambda$-1014174787.<anonymous> (CartScreen.kt:110)');
      }
      var tmp = stringResource(get_cart_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = Companion_getInstance_16().f7z_1;
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, tmp_2, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 1572864, 0, 262078);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartScreenKt$lambda$_1336897763$lambda_nq4rig($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C119@5404L31,117@5284L177:CartScreen.kt#5k0css');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1336897763, $changed, -1, 'client.fstech.hadaya.presentation.cart.ComposableSingletons$CartScreenKt.lambda$-1336897763.<anonymous> (CartScreen.kt:117)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartScreenKt$lambda$228534730$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C127@5754L36,128@5846L11,126@5716L239:CartScreen.kt#5k0css');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(228534730, $changed, -1, 'client.fstech.hadaya.presentation.cart.ComposableSingletons$CartScreenKt.lambda$228534730.<anonymous> (CartScreen.kt:126)');
      }
      var tmp = stringResource(get_clear_all(string_instance), $composer_0, 0);
      var tmp_0 = MaterialTheme_instance.unz($composer_0, 6).to0_1;
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = Companion_getInstance_16().e7z_1;
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, tmp_2, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 1572864, 0, 262074);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartScreenKt$lambda$1848914033$lambda($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C178@8497L35,178@8492L41:CartScreen.kt#5k0css');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1848914033, $changed, -1, 'client.fstech.hadaya.presentation.cart.ComposableSingletons$CartScreenKt.lambda$1848914033.<anonymous> (CartScreen.kt:178)');
      }
      var tmp = stringResource(get_nav_shop(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartScreenKt$lambda$_1195488319$lambda_n5c0zs($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C251@12366L33,252@12455L11,250@12328L174:CartScreen.kt#5k0css');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1195488319, $changed, -1, 'client.fstech.hadaya.presentation.cart.ComposableSingletons$CartScreenKt.lambda$-1195488319.<anonymous> (CartScreen.kt:250)');
      }
      var tmp = stringResource(get_delete(string_instance), $composer_0, 0);
      var tmp_0 = MaterialTheme_instance.unz($composer_0, 6).to0_1;
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262138);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartScreenKt$lambda$_304413697$lambda_vpc3lm($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C258@12695L33,258@12690L39:CartScreen.kt#5k0css');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-304413697, $changed, -1, 'client.fstech.hadaya.presentation.cart.ComposableSingletons$CartScreenKt.lambda$-304413697.<anonymous> (CartScreen.kt:258)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartScreenKt$lambda$171373594$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C241@11834L44,241@11829L50:CartScreen.kt#5k0css');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(171373594, $changed, -1, 'client.fstech.hadaya.presentation.cart.ComposableSingletons$CartScreenKt.lambda$171373594.<anonymous> (CartScreen.kt:241)');
      }
      var tmp = stringResource(get_remove_item_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartScreenKt$lambda$616910905$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C242@11917L46,242@11912L52:CartScreen.kt#5k0css');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(616910905, $changed, -1, 'client.fstech.hadaya.presentation.cart.ComposableSingletons$CartScreenKt.lambda$616910905.<anonymous> (CartScreen.kt:242)');
      }
      var tmp = stringResource(get_remove_item_confirm(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartScreenKt$lambda$_1687556460$lambda_q9eovz($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C273@13059L745:CartScreen.kt#5k0css');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1687556460, $changed, -1, 'client.fstech.hadaya.presentation.cart.ComposableSingletons$CartScreenKt.lambda$-1687556460.<anonymous> (CartScreen.kt:273)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
      var tmp0_modifier = padding_0(tmp, tmp$ret$0);
      var tmp1_verticalAlignment = Companion_getInstance_11().u8t_1;
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = tmp0_modifier;
      var horizontalArrangement = Arrangement_getInstance().udp_1;
      var verticalAlignment = tmp1_verticalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier = Companion_instance;
      if (!((0 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -1489915996, 'C282@13461L11,278@13271L236,284@13524L39,286@13606L44,288@13744L11,285@13580L210:CartScreen.kt#5k0css');
      var tmp_1 = get_WifiOff(Icons_getInstance().dxv_1);
      var tmp_2 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(18);
      Icon(tmp_1, null, size(tmp_2, tmp$ret$7), MaterialTheme_instance.unz($composer_5, 6).wo0_1, $composer_5, 432, 0);
      var tmp_3 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$8 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_3, tmp$ret$8), $composer_5, 6);
      var tmp0_text = stringResource(get_cart_offline_mode(string_instance), $composer_5, 0);
      var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp2_color = MaterialTheme_instance.unz($composer_5, 6).wo0_1;
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_7 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp2_color, null, tmp_4, null, tmp1_fontWeight, null, tmp_5, null, null, tmp_6, tmp_7, false, 0, 0, null, null, $composer_5, 1572864, 0, 262074);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartScreenKt$lambda$_1787213459$lambda_nw9zim($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C371@16356L46,370@16330L178:CartScreen.kt#5k0css');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1787213459, $changed, -1, 'client.fstech.hadaya.presentation.cart.ComposableSingletons$CartScreenKt.lambda$-1787213459.<anonymous> (CartScreen.kt:370)');
      }
      var tmp = stringResource(get_proceed_to_checkout(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = get_sp(18);
      var tmp_2 = Companion_getInstance_16().e7z_1;
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, tmp_2, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 1597440, 0, 262062);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartScreenKt$lambda$_594683977$lambda_hz8zpf($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C474@20319L43,475@20413L11,472@20193L335:CartScreen.kt#5k0css');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-594683977, $changed, -1, 'client.fstech.hadaya.presentation.cart.ComposableSingletons$CartScreenKt.lambda$-594683977.<anonymous> (CartScreen.kt:472)');
      }
      var tmp0_imageVector = get_DeleteOutline(Icons_getInstance().dxv_1);
      var tmp1_contentDescription = stringResource(get_remove_item_desc(string_instance), $composer_0, 0);
      var tmp2_tint = MaterialTheme_instance.unz($composer_0, 6).wo0_1;
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(18);
      var tmp3_modifier = size(tmp, tmp$ret$0);
      Icon(tmp0_imageVector, tmp1_contentDescription, tmp3_modifier, tmp2_tint, $composer_0, 384, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartScreenKt$lambda$1418972904$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C566@24595L49,568@24756L11,564@24493L310:CartScreen.kt#5k0css');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1418972904, $changed, -1, 'client.fstech.hadaya.presentation.cart.ComposableSingletons$CartScreenKt.lambda$1418972904.<anonymous> (CartScreen.kt:564)');
      }
      var tmp = get_Add(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_increase_quantity_desc(string_instance), $composer_0, 0);
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
      Icon(tmp, tmp_0, size(tmp_1, tmp$ret$0), MaterialTheme_instance.unz($composer_0, 6).no0_1, $composer_0, 384, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartScreenKt() {
    ComposableSingletons$CartScreenKt_instance = this;
    var tmp = this;
    tmp.a10s_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1014174787, false, ComposableSingletons$CartScreenKt$lambda$_1014174787$lambda_rbzv5));
    var tmp_0 = this;
    tmp_0.b10s_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1336897763, false, ComposableSingletons$CartScreenKt$lambda$_1336897763$lambda_nq4rig));
    var tmp_1 = this;
    tmp_1.c10s_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(228534730, false, ComposableSingletons$CartScreenKt$lambda$228534730$lambda));
    var tmp_2 = this;
    tmp_2.d10s_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1848914033, false, ComposableSingletons$CartScreenKt$lambda$1848914033$lambda));
    var tmp_3 = this;
    tmp_3.e10s_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1195488319, false, ComposableSingletons$CartScreenKt$lambda$_1195488319$lambda_n5c0zs));
    var tmp_4 = this;
    tmp_4.f10s_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-304413697, false, ComposableSingletons$CartScreenKt$lambda$_304413697$lambda_vpc3lm));
    var tmp_5 = this;
    tmp_5.g10s_1 = ComposableLambda$invoke$ref(composableLambdaInstance(171373594, false, ComposableSingletons$CartScreenKt$lambda$171373594$lambda));
    var tmp_6 = this;
    tmp_6.h10s_1 = ComposableLambda$invoke$ref(composableLambdaInstance(616910905, false, ComposableSingletons$CartScreenKt$lambda$616910905$lambda));
    var tmp_7 = this;
    tmp_7.i10s_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1687556460, false, ComposableSingletons$CartScreenKt$lambda$_1687556460$lambda_q9eovz));
    var tmp_8 = this;
    tmp_8.j10s_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1787213459, false, ComposableSingletons$CartScreenKt$lambda$_1787213459$lambda_nw9zim));
    var tmp_9 = this;
    tmp_9.k10s_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-594683977, false, ComposableSingletons$CartScreenKt$lambda$_594683977$lambda_hz8zpf));
    var tmp_10 = this;
    tmp_10.l10s_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1418972904, false, ComposableSingletons$CartScreenKt$lambda$1418972904$lambda));
  }
  var ComposableSingletons$CartScreenKt_instance;
  function ComposableSingletons$CartScreenKt_getInstance() {
    if (ComposableSingletons$CartScreenKt_instance == null)
      new ComposableSingletons$CartScreenKt();
    return ComposableSingletons$CartScreenKt_instance;
  }
  function ConnectionWarning(isConnected, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-20823670);
    sourceInformation($composer_0, 'C(ConnectionWarning):CartScreen.kt#5k0css');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.l31(isConnected) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-20823670, $dirty, -1, 'client.fstech.hadaya.presentation.cart.ConnectionWarning (CartScreen.kt:267)');
      }
      if (!isConnected) {
        $composer_0.m30(-1882557161);
        sourceInformation($composer_0, '270@12960L11,269@12917L897');
        var tmp0_color = MaterialTheme_instance.unz($composer_0, 6).vo0_1;
        var tmp1_modifier = fillMaxWidth(Companion_instance);
        var tmp = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_0 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_1 = _Dp___init__impl__ms3zkb(0.0);
        Surface(tmp1_modifier, null, tmp0_color, tmp, tmp_0, tmp_1, null, ComposableSingletons$CartScreenKt_getInstance().i10s_1, $composer_0, 12582918, 122);
        $composer_0.n30();
      } else {
        $composer_0.m30(-1881689192);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ConnectionWarning$lambda(isConnected, $changed));
    }
  }
  function CartItemsList(state, onUpdateQuantity, onRemove, onItemClick, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1105621831);
    sourceInformation($composer_0, 'C(CartItemsList)P(3,2,1)311@14276L344,302@14002L618:CartScreen.kt#5k0css');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onUpdateQuantity) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onRemove) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onItemClick) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1105621831, $dirty, -1, 'client.fstech.hadaya.presentation.cart.CartItemsList (CartScreen.kt:301)');
      }
      var tmp = fillMaxSize(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp0_top = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp1_bottom = _Dp___init__impl__ms3zkb(24);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp2_start = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp3_end = _Dp___init__impl__ms3zkb(16);
      var tmp_0 = PaddingValues(tmp2_start, tmp0_top, tmp3_end, tmp1_bottom);
      var tmp_1 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$4 = _Dp___init__impl__ms3zkb(16);
      var tmp_2 = tmp_1.mdq(tmp$ret$4);
      sourceInformationMarkerStart($composer_0, -1645643055, 'CC(remember):CartScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!(!!((($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(state))) | ($dirty & 112) === 32) | ($dirty & 896) === 256) | ($dirty & 7168) === 2048);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp_3;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = CartItemsList$lambda(state, onUpdateQuantity, onRemove, onItemClick);
        tmp0.j31(value);
        tmp_3 = value;
      } else {
        tmp_3 = it;
      }
      var tmp0_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      LazyColumn(tmp, null, tmp_0, false, tmp_2, null, null, false, null, tmp0_group, $composer_0, 24582, 490);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(CartItemsList$lambda_0(state, onUpdateQuantity, onRemove, onItemClick, $changed));
    }
  }
  function navigateToDetails(item, onNavigateToCartNormalProductDetails, onNavigateToCartMugProductDetails, onNavigateToCartMagicMugProductDetails, onNavigateToUpdate) {
    switch (item.yyw_1.a1_1) {
      case 0:
        onNavigateToCartNormalProductDetails(item);
        break;
      case 1:
        onNavigateToCartMugProductDetails(item);
        break;
      case 4:
        onNavigateToCartMagicMugProductDetails(item);
        break;
      case 5:
        onNavigateToCartNormalProductDetails(item);
        break;
      default:
        onNavigateToUpdate();
        break;
    }
  }
  function CartSummarySection(state, onCheckout, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1780874104);
    sourceInformation($composer_0, 'C(CartSummarySection)P(1)331@14800L11,334@14928L1610,329@14717L1821:CartScreen.kt#5k0css');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onCheckout) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1780874104, $dirty, -1, 'client.fstech.hadaya.presentation.cart.CartSummarySection (CartScreen.kt:328)');
      }
      var tmp0_modifier = fillMaxWidth(Companion_instance);
      var tmp1_color = MaterialTheme_instance.unz($composer_0, 6).mo0_1;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp2_shadowElevation = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp = _Dp___init__impl__ms3zkb(32);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$2 = _Dp___init__impl__ms3zkb(32);
      var tmp3_shape = RoundedCornerShape_0(tmp, tmp$ret$2);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _Dp___init__impl__ms3zkb(0.0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(547432723, true, CartSummarySection$lambda(state, onCheckout), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_2;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value);
        tmp_2 = value;
      } else {
        tmp_2 = it;
      }
      var tmp$ret$3 = tmp_2;
      Surface(tmp0_modifier, tmp3_shape, tmp1_color, tmp_0, tmp_1, tmp2_shadowElevation, null, tmp$ret$3, $composer_0, 12779526, 88);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(CartSummarySection$lambda_0(state, onCheckout, $changed));
    }
  }
  function CartItemRow(state, item, onUpdateQuantity, onRemove, onClick, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1546298184);
    sourceInformation($composer_0, 'C(CartItemRow)P(4!1,3,2)413@17740L11,414@17766L7107,407@17506L7367:CartScreen.kt#5k0css');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(item) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onUpdateQuantity) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onRemove) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1546298184, $dirty, -1, 'client.fstech.hadaya.presentation.cart.CartItemRow (CartScreen.kt:403)');
      }
      var language = state.s10r_1;
      var tmp;
      if (language === 'en') {
        var tmp0_elvis_lhs = item.hyw_1;
        tmp = tmp0_elvis_lhs == null ? item.iyw_1 : tmp0_elvis_lhs;
      } else {
        var tmp1_elvis_lhs = item.iyw_1;
        tmp = tmp1_elvis_lhs == null ? item.hyw_1 : tmp1_elvis_lhs;
      }
      var tmp2_elvis_lhs = tmp;
      var name = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
      var tmp_0 = clickable(fillMaxWidth(Companion_instance), VOID, VOID, VOID, VOID, onClick);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_1 = _Dp___init__impl__ms3zkb(4);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(20);
      var tmp_2 = shadow(tmp_0, tmp_1, RoundedCornerShape(tmp$ret$1));
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$2 = _Dp___init__impl__ms3zkb(20);
      var tmp_3 = RoundedCornerShape(tmp$ret$2);
      var tmp_4 = MaterialTheme_instance.unz($composer_0, 6).mo0_1;
      var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_6 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_7 = _Dp___init__impl__ms3zkb(0.0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(537433107, true, CartItemRow$lambda(item, name, onRemove, language, onUpdateQuantity), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_8;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value);
        tmp_8 = value;
      } else {
        tmp_8 = it;
      }
      var tmp$ret$3 = tmp_8;
      Surface(tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, null, tmp$ret$3, $composer_0, 12582912, 120);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(CartItemRow$lambda_0(state, item, onUpdateQuantity, onRemove, onClick, $changed));
    }
  }
  function CartScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function CartScreen$lambda_0($itemToRemove$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('itemToRemove', KMutableProperty0, true);
    return $itemToRemove$delegate.u1();
  }
  function CartScreen$lambda_1($itemToRemove$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('itemToRemove', KMutableProperty0, true);
    $itemToRemove$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_4(function_0) {
    this.m10s_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).a1v = function (value, $completion) {
    return this.m10s_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).q3 = function () {
    return this.m10s_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).hashCode = function () {
    return hashCode(this.q3());
  };
  function CartScreen$slambda$slambda($snackbarHostState, $onNavigateToCheckout, $onNavigateToAuth, resultContinuation) {
    this.v10s_1 = $snackbarHostState;
    this.w10s_1 = $onNavigateToCheckout;
    this.x10s_1 = $onNavigateToAuth;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartScreen$slambda$slambda).a10t = function (effect, $completion) {
    var tmp = this.b10t(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.a10t((!(p1 == null) ? isInterface(p1, CartSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp0_subject = this.y10s_1;
            if (tmp0_subject instanceof ShowError_1) {
              this.n9_1 = 1;
              suspendResult = this.y10s_1.z10r_1.z10i(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (equals(tmp0_subject, NavigateToCheckout_instance)) {
                this.z10s_1 = this.w10s_1();
                this.n9_1 = 3;
                continue $sm;
              } else {
                if (equals(tmp0_subject, NavigateToAuth_instance)) {
                  this.z10s_1 = this.x10s_1();
                  this.n9_1 = 3;
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.v10s_1.dqm(ARGUMENT, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.z10s_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartScreen$slambda$slambda).b10t = function (effect, completion) {
    var i = new CartScreen$slambda$slambda(this.v10s_1, this.w10s_1, this.x10s_1, completion);
    i.y10s_1 = effect;
    return i;
  };
  function CartScreen$slambda$slambda_0($snackbarHostState, $onNavigateToCheckout, $onNavigateToAuth, resultContinuation) {
    var i = new CartScreen$slambda$slambda($snackbarHostState, $onNavigateToCheckout, $onNavigateToAuth, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.a10t(effect, $completion);
    }, 1);
  }
  function CartScreen$slambda($viewModel, $snackbarHostState, $onNavigateToCheckout, $onNavigateToAuth, resultContinuation) {
    this.k10t_1 = $viewModel;
    this.l10t_1 = $snackbarHostState;
    this.m10t_1 = $onNavigateToCheckout;
    this.n10t_1 = $onNavigateToAuth;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.k10t_1.s10h().t10h();
            var tmp_1 = CartScreen$slambda$slambda_0(this.l10t_1, this.m10t_1, this.n10t_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_4(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartScreen$slambda(this.k10t_1, this.l10t_1, this.m10t_1, this.n10t_1, completion);
    i.o10t_1 = $this$LaunchedEffect;
    return i;
  };
  function CartScreen$slambda_0($viewModel, $snackbarHostState, $onNavigateToCheckout, $onNavigateToAuth, resultContinuation) {
    var i = new CartScreen$slambda($viewModel, $snackbarHostState, $onNavigateToCheckout, $onNavigateToAuth, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CartScreen$lambda_2($onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C116@5229L254:CartScreen.kt#5k0css');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-631501317, $changed, -1, 'client.fstech.hadaya.presentation.cart.CartScreen.<anonymous>.<anonymous>.<anonymous> (CartScreen.kt:116)');
        }
        IconButton($onBack, null, false, null, null, null, ComposableSingletons$CartScreenKt_getInstance().b10s_1, $composer_0, 1572864, 62);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartScreen$lambda$lambda($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ClearCart_instance);
      return Unit_instance;
    };
  }
  function CartScreen$lambda_3($viewModel, $state$delegate) {
    return function ($this$TopAppBar, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:CartScreen.kt#5k0css');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-670236558, $changed, -1, 'client.fstech.hadaya.presentation.cart.CartScreen.<anonymous>.<anonymous>.<anonymous> (CartScreen.kt:124)');
        }
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!CartScreen$lambda($state$delegate).n10r_1.r()) {
          $composer_0.m30(285728238);
          sourceInformation($composer_0, '125@5632L52,125@5611L370');
          sourceInformationMarkerStart($composer_0, 147765510, 'CC(remember):CartScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_0.q31($viewModel);
          // Inline function 'kotlin.let' call
          var it = $composer_0.i31();
          var tmp_0;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = CartScreen$lambda$lambda($viewModel);
            $composer_0.j31(value);
            tmp_0 = value;
          } else {
            tmp_0 = it;
          }
          var tmp0_group = tmp_0;
          sourceInformationMarkerEnd($composer_0);
          TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$CartScreenKt_getInstance().c10s_1, $composer_0, 805306368, 510);
          $composer_0.n30();
        } else {
          $composer_0.m30(286129936);
          $composer_0.n30();
        }
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartScreen$lambda_4($viewModel) {
    return function (item, qty) {
      $viewModel.s10h().j10i(new UpdateQuantity(item, qty));
      return Unit_instance;
    };
  }
  function CartScreen$lambda_5($itemToRemove$delegate) {
    return function (it) {
      CartScreen$lambda_1($itemToRemove$delegate, it);
      return Unit_instance;
    };
  }
  function CartScreen$lambda_6($onNavigateToCartNormalProductDetails, $onNavigateToCartMugProductDetails, $onNavigateToCartMagicMugProductDetails, $onNavigateToUpdate) {
    return function (item) {
      navigateToDetails(item, $onNavigateToCartNormalProductDetails, $onNavigateToCartMugProductDetails, $onNavigateToCartMagicMugProductDetails, $onNavigateToUpdate);
      return Unit_instance;
    };
  }
  function CartScreen$lambda_7($viewModel) {
    return function () {
      $viewModel.s10h().j10i(Checkout_instance_0);
      return Unit_instance;
    };
  }
  function CartScreen$lambda_8($viewModel) {
    return function (item, qty) {
      $viewModel.s10h().j10i(new UpdateQuantity(item, qty));
      return Unit_instance;
    };
  }
  function CartScreen$lambda_9($itemToRemove$delegate) {
    return function (it) {
      CartScreen$lambda_1($itemToRemove$delegate, it);
      return Unit_instance;
    };
  }
  function CartScreen$lambda_10($onNavigateToCartNormalProductDetails, $onNavigateToCartMugProductDetails, $onNavigateToCartMagicMugProductDetails, $onNavigateToUpdate) {
    return function (item) {
      navigateToDetails(item, $onNavigateToCartNormalProductDetails, $onNavigateToCartMugProductDetails, $onNavigateToCartMagicMugProductDetails, $onNavigateToUpdate);
      return Unit_instance;
    };
  }
  function CartScreen$lambda_11($viewModel) {
    return function () {
      $viewModel.s10h().j10i(Checkout_instance_0);
      return Unit_instance;
    };
  }
  function CartScreen$lambda_12($itemToRemove$delegate) {
    return function () {
      CartScreen$lambda_1($itemToRemove$delegate, null);
      return Unit_instance;
    };
  }
  function CartScreen$lambda$lambda_0($viewModel, $itemToRemove$delegate) {
    return function () {
      var tmp0_safe_receiver = CartScreen$lambda_0($itemToRemove$delegate);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        $viewModel.s10h().j10i(new RemoveItem(tmp0_safe_receiver));
      }
      CartScreen$lambda_1($itemToRemove$delegate, null);
      return Unit_instance;
    };
  }
  function CartScreen$lambda_13($viewModel, $itemToRemove$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C245@12080L191,244@12030L498:CartScreen.kt#5k0css');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1610775650, $changed, -1, 'client.fstech.hadaya.presentation.cart.CartScreen.<anonymous>.<anonymous> (CartScreen.kt:244)');
        }
        sourceInformationMarkerStart($composer_0, -1767170467, 'CC(remember):CartScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($viewModel);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CartScreen$lambda$lambda_0($viewModel, $itemToRemove$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$CartScreenKt_getInstance().e10s_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartScreen$lambda$lambda_1($itemToRemove$delegate) {
    return function () {
      CartScreen$lambda_1($itemToRemove$delegate, null);
      return Unit_instance;
    };
  }
  function CartScreen$lambda_14($itemToRemove$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C257@12635L23,257@12614L141:CartScreen.kt#5k0css');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-719701028, $changed, -1, 'client.fstech.hadaya.presentation.cart.CartScreen.<anonymous>.<anonymous> (CartScreen.kt:257)');
        }
        sourceInformationMarkerStart($composer_0, -142951725, 'CC(remember):CartScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CartScreen$lambda$lambda_1($itemToRemove$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$CartScreenKt_getInstance().f10s_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartScreen$lambda_15($onBack, $onNavigateToCheckout, $onNavigateToAuth, $onNavigateToCartNormalProductDetails, $onNavigateToCartMugProductDetails, $onNavigateToCartMagicMugProductDetails, $onNavigateToUpdate, $$changed) {
    return function ($composer, $force) {
      CartScreen($onBack, $onNavigateToCheckout, $onNavigateToAuth, $onNavigateToCartNormalProductDetails, $onNavigateToCartMugProductDetails, $onNavigateToCartMagicMugProductDetails, $onNavigateToUpdate, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function ConnectionWarning$lambda($isConnected, $$changed) {
    return function ($composer, $force) {
      ConnectionWarning($isConnected, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function CartItemsList$lambda$lambda(it) {
    return it.fyw_1;
  }
  function CartItemsList$lambda$lambda_0(it) {
    return null;
  }
  function CartItemsList$lambda$lambda_1($key, $items) {
    return function (index) {
      return $key($items.l1(index));
    };
  }
  function CartItemsList$lambda$lambda_2($contentType, $items) {
    return function (index) {
      return $contentType($items.l1(index));
    };
  }
  function ComposableLambda$invoke$ref_4(p0) {
    return constructCallableReference(function (p0_0, p1, p2, p3) {
      p0.v50(p0_0, p1, p2, p3);
      return Unit_instance;
    }, 4, 0, 255, VOID, [p0]);
  }
  function CartItemsList$lambda$lambda$lambda($onUpdateQuantity, $item) {
    return function (qty) {
      $onUpdateQuantity($item, qty);
      return Unit_instance;
    };
  }
  function CartItemsList$lambda$lambda$lambda_0($onRemove, $item) {
    return function () {
      $onRemove($item);
      return Unit_instance;
    };
  }
  function CartItemsList$lambda$lambda$lambda_1($onItemClick, $item) {
    return function () {
      $onItemClick($item);
      return Unit_instance;
    };
  }
  function CartItemsList$lambda$lambda_3($items, $state, $onUpdateQuantity, $onRemove, $onItemClick) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp2 = $items.l1(it);
        var $changed_0 = 14 & $dirty;
        var $composer_1 = $composer_0;
        $composer_1.m30(-2075437852);
        sourceInformation($composer_1, 'C*316@14456L38,317@14523L18,318@14569L21,313@14348L256:CartScreen.kt#5k0css');
        sourceInformationMarkerStart($composer_1, -898230363, 'CC(remember):CartScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_1.k31($onUpdateQuantity) | $composer_1.q31(tmp2));
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_2;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = CartItemsList$lambda$lambda$lambda($onUpdateQuantity, tmp2);
          $composer_1.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it_0;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_1);
        sourceInformationMarkerStart($composer_1, -898228239, 'CC(remember):CartScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = !!($composer_1.k31($onRemove) | $composer_1.q31(tmp2));
        // Inline function 'kotlin.let' call
        var it_1 = $composer_1.i31();
        var tmp_3;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = CartItemsList$lambda$lambda$lambda_0($onRemove, tmp2);
          $composer_1.j31(value_0);
          tmp_3 = value_0;
        } else {
          tmp_3 = it_1;
        }
        var tmp1_group = tmp_3;
        sourceInformationMarkerEnd($composer_1);
        sourceInformationMarkerStart($composer_1, -898226764, 'CC(remember):CartScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = !!($composer_1.k31($onItemClick) | $composer_1.q31(tmp2));
        // Inline function 'kotlin.let' call
        var it_2 = $composer_1.i31();
        var tmp_4;
        if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
          var value_1 = CartItemsList$lambda$lambda$lambda_1($onItemClick, tmp2);
          $composer_1.j31(value_1);
          tmp_4 = value_1;
        } else {
          tmp_4 = it_2;
        }
        var tmp2_group = tmp_4;
        sourceInformationMarkerEnd($composer_1);
        CartItemRow($state, tmp2, tmp0_group, tmp1_group, tmp2_group, $composer_1, 112 & $changed_0);
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartItemsList$lambda($state, $onUpdateQuantity, $onRemove, $onItemClick) {
    return function ($this$LazyColumn) {
      var tmp2 = $state.n10r_1;
      // Inline function 'androidx.compose.foundation.lazy.items' call
      var key = CartItemsList$lambda$lambda;
      var contentType = CartItemsList$lambda$lambda_0;
      var tmp = tmp2.n1();
      var tmp_0;
      if (!(key == null)) {
        tmp_0 = CartItemsList$lambda$lambda_1(key, tmp2);
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      var tmp_2 = CartItemsList$lambda$lambda_2(contentType, tmp2);
      $this$LazyColumn.di9(tmp, tmp_1, tmp_2, ComposableLambda$invoke$ref_4(composableLambdaInstance(802480018, true, CartItemsList$lambda$lambda_3(tmp2, $state, $onUpdateQuantity, $onRemove, $onItemClick))));
      return Unit_instance;
    };
  }
  function CartItemsList$lambda_0($state, $onUpdateQuantity, $onRemove, $onItemClick, $$changed) {
    return function ($composer, $force) {
      CartItemsList($state, $onUpdateQuantity, $onRemove, $onItemClick, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function CartSummarySection$lambda($state, $onCheckout) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C335@14938L1594:CartScreen.kt#5k0css');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(547432723, $changed, -1, 'client.fstech.hadaya.presentation.cart.CartSummarySection.<anonymous> (CartScreen.kt:335)');
        }
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_start = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_end = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_top = _Dp___init__impl__ms3zkb(20);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp4_bottom = _Dp___init__impl__ms3zkb(20);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = padding_1(Companion_instance, tmp1_start, tmp3_top, tmp2_end, tmp4_bottom);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -825061243, 'C343@15145L818,363@15976L41,368@16277L11,368@16233L64,364@16030L492:CartScreen.kt#5k0css');
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_1 = fillMaxWidth(Companion_instance);
        var horizontalArrangement = Arrangement_getInstance().wdp_1;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_6 = $composer_5;
        if (!((0 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_6, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_1 = $composer_8.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, -897548640, 'C349@15389L44,351@15515L11,348@15363L198,354@15604L145,360@15912L11,353@15578L371:CartScreen.kt#5k0css');
        var tmp0_text = stringResource(get_cart_total_amount(string_instance), $composer_10, 0);
        var tmp1_fontSize = get_sp(16);
        var tmp2_color = MaterialTheme_instance.unz($composer_10, 6).po0_1;
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp2_color, null, tmp1_fontSize, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_10, 24576, 0, 262122);
        var tmp3_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString($state.q10r_1)], $composer_10, 0), $state.s10r_1);
        var tmp4_fontSize = get_sp(28);
        var tmp5_fontWeight = Companion_getInstance_16().g7z_1;
        var tmp6_color = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp3_text, null, tmp6_color, null, tmp4_fontSize, null, tmp5_fontWeight, null, tmp_5, null, null, tmp_6, tmp_7, false, 0, 0, null, null, $composer_10, 1597440, 0, 262058);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_8 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$16 = _Dp___init__impl__ms3zkb(20);
        Spacer(height(tmp_8, tmp$ret$16), $composer_5, 6);
        var tmp_9 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$17 = _Dp___init__impl__ms3zkb(60);
        var tmp_10 = height(tmp_9, tmp$ret$17);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$18 = _Dp___init__impl__ms3zkb(16);
        var tmp_11 = RoundedCornerShape(tmp$ret$18);
        var tmp_12 = ButtonDefaults_getInstance();
        var tmp_13 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
        var tmp_14 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_15 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_16 = tmp_12.ao9(tmp_13, tmp_14, tmp_15, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
        Button($onCheckout, tmp_10, false, tmp_11, tmp_16, null, null, null, null, ComposableSingletons$CartScreenKt_getInstance().j10s_1, $composer_5, 805306416, 484);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_17;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_17 = Unit_instance;
        }
        tmp = tmp_17;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartSummarySection$lambda_0($state, $onCheckout, $$changed) {
    return function ($composer, $force) {
      CartSummarySection($state, $onCheckout, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function CartItemRow$lambda$lambda($item, $onUpdateQuantity) {
    return function () {
      var tmp;
      if ($item.ryw_1 > 1) {
        tmp = $onUpdateQuantity($item.ryw_1 - 1 | 0);
      }
      return Unit_instance;
    };
  }
  function CartItemRow$lambda$lambda_0($item) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C548@23647L49,546@23528L371:CartScreen.kt#5k0css');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1047126463, $changed, -1, 'client.fstech.hadaya.presentation.cart.CartItemRow.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartScreen.kt:546)');
        }
        var tmp0_imageVector = get_Remove(Icons_getInstance().dxv_1);
        var tmp1_contentDescription = stringResource(get_decrease_quantity_desc(string_instance), $composer_0, 0);
        var tmp_0;
        if ($item.ryw_1 > 1) {
          $composer_0.m30(1266192648);
          sourceInformation($composer_0, '549@23770L11');
          var tmp0_group = MaterialTheme_instance.unz($composer_0, 6).no0_1;
          $composer_0.n30();
          tmp_0 = tmp0_group;
        } else {
          $composer_0.m30(1266193320);
          $composer_0.n30();
          tmp_0 = Companion_getInstance_14().l6b_1;
        }
        var tmp2_tint = tmp_0;
        var tmp_1 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        var tmp3_modifier = size(tmp_1, tmp$ret$0);
        Icon(tmp0_imageVector, tmp1_contentDescription, tmp3_modifier, tmp2_tint, $composer_0, 384, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartItemRow$lambda$lambda_1($onUpdateQuantity, $item) {
    return function () {
      $onUpdateQuantity($item.ryw_1 + 1 | 0);
      return Unit_instance;
    };
  }
  function CartItemRow$lambda($item, $name, $onRemove, $language, $onUpdateQuantity) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C415@17776L7091:CartScreen.kt#5k0css');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(537433107, $changed, -1, 'client.fstech.hadaya.presentation.cart.CartItemRow.<anonymous> (CartScreen.kt:415)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var horizontalArrangement = null;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance;
        if (!((2 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((2 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 390 >> 3 | 112 & 390 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 2071057331, 'C452@19300L40,453@19353L5504:CartScreen.kt#5k0css');
        var tmp0_elvis_lhs = $item.syw_1;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = $item.qyw_1;
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : firstOrNull(tmp1_safe_receiver);
          var tmp_3;
          if (tmp2_safe_receiver == null) {
            tmp_3 = null;
          } else {
            // Inline function 'kotlin.takeIf' call
            var tmp_4;
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(tmp2_safe_receiver)) {
              tmp_4 = tmp2_safe_receiver;
            } else {
              tmp_4 = null;
            }
            tmp_3 = tmp_4;
          }
          tmp_2 = tmp_3;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var imageUrl = tmp_2;
        var imageModel = !($item.xyw_1 == null) ? $item.xyw_1 : imageUrl;
        if (!(imageModel == null)) {
          $composer_5.m30(2071105163);
          sourceInformation($composer_5, '428@18368L11,424@18178L520');
          var tmp_5 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$10 = _Dp___init__impl__ms3zkb(100);
          var tmp_6 = size(tmp_5, tmp$ret$10);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$11 = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_1 = background(clip(tmp_6, RoundedCornerShape(tmp$ret$11)), MaterialTheme_instance.unz($composer_5, 6).oo0_1);
          var contentAlignment = null;
          var propagateMinConstraints = false;
          var $composer_6 = $composer_5;
          if (!((6 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints = false;
          var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_7 = $composer_6;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
          var localMap_0 = $composer_7.t31();
          var materialized_0 = materialize($composer_7, modifier_2);
          var tmp0_0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_8 = $composer_7;
          var tmp_7 = $composer_8.g30();
          if (!isInterface(tmp_7, Applier)) {
            invalidApplier();
          }
          $composer_8.b31();
          if ($composer_8.h30()) {
            $composer_8.c31(tmp0_0);
          } else {
            $composer_8.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_9 = $composer_8;
          var $composer_10 = $composer_9;
          sourceInformationMarkerStart($composer_10, 1572352801, 'C430@18436L244:CartScreen.kt#5k0css');
          HadayaImage(imageModel, $name, fillMaxSize(Companion_instance), Companion_getInstance_13().r96_1, $composer_10, 3456, 0);
          sourceInformationMarkerEnd($composer_10);
          $composer_8.e31();
          $composer_5.n30();
        } else {
          $composer_5.m30(2071659226);
          sourceInformation($composer_5, '442@18926L11,438@18736L537');
          var tmp_8 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$18 = _Dp___init__impl__ms3zkb(100);
          var tmp_9 = size(tmp_8, tmp$ret$18);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$19 = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_3 = background(clip(tmp_9, RoundedCornerShape(tmp$ret$19)), MaterialTheme_instance.unz($composer_5, 6).oo0_1);
          var contentAlignment_0 = Companion_getInstance_11().o8t_1;
          var propagateMinConstraints_0 = false;
          var $composer_11 = $composer_5;
          if (!((4 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((4 & 2) === 0))
            contentAlignment_0 = Companion_getInstance_11().k8t_1;
          if (!((4 & 4) === 0))
            propagateMinConstraints_0 = false;
          var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_10 = $composer_13.g30();
          if (!isInterface(tmp_10, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_1);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_15, -1495144686, 'C448@19205L11,445@19051L204:CartScreen.kt#5k0css');
          var tmp_11 = get_ShoppingCart(Icons_getInstance().dxv_1);
          Icon(tmp_11, null, null, MaterialTheme_instance.unz($composer_15, 6).po0_1, $composer_15, 48, 4);
          sourceInformationMarkerEnd($composer_15);
          $composer_13.e31();
          $composer_5.n30();
        }
        var tmp_12 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$26 = _Dp___init__impl__ms3zkb(16);
        Spacer(width(tmp_12, tmp$ret$26), $composer_5, 6);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_5 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_16 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_2 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_16, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_17 = $composer_16;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
        var localMap_2 = $composer_17.t31();
        var materialized_2 = materialize($composer_17, modifier_6);
        var tmp0_2 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_18 = $composer_17;
        var tmp_13 = $composer_18.g30();
        if (!isInterface(tmp_13, Applier)) {
          invalidApplier();
        }
        $composer_18.b31();
        if ($composer_18.h30()) {
          $composer_18.c31(tmp0_2);
        } else {
          $composer_18.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_18);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_19 = $composer_18;
        var $composer_20 = $composer_19;
        sourceInformationMarkerStart($composer_20, -1290556783, 'C454@19410L1158,481@20586L40,483@20644L1797,521@22459L40,523@22517L52,525@22587L40,532@22874L11,528@22682L2161:CartScreen.kt#5k0css');
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_7 = fillMaxWidth(Companion_instance);
        var horizontalArrangement_0 = Arrangement_getInstance().wdp_1;
        var verticalAlignment_0 = Companion_getInstance_11().t8t_1;
        var $composer_21 = $composer_20;
        if (!((0 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment_0 = Companion_getInstance_11().t8t_1;
        var measurePolicy_3 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_21, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_22 = $composer_21;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_22, 0).hashCode();
        var localMap_3 = $composer_22.t31();
        var materialized_3 = materialize($composer_22, modifier_8);
        var tmp0_3 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_23 = $composer_22;
        var tmp_14 = $composer_23.g30();
        if (!isInterface(tmp_14, Applier)) {
          invalidApplier();
        }
        $composer_23.b31();
        if ($composer_23.h30()) {
          $composer_23.c31(tmp0_3);
        } else {
          $composer_23.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_23);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_24 = $composer_23;
        var $composer_25 = $composer_24;
        sourceInformationMarkerStart($composer_25, -1134763173, 'C459@19635L253,470@20104L11,466@19909L641:CartScreen.kt#5k0css');
        var tmp0_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp1_fontSize = get_sp(18);
        var tmp2_modifier = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        var tmp_15 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_17 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_18 = _TextOverflow___init__impl__obguoe(0);
        Text($name, tmp2_modifier, tmp_15, null, tmp1_fontSize, null, tmp0_fontWeight, null, tmp_16, null, null, tmp_17, tmp_18, false, 2, 0, null, null, $composer_25, 1597440, 24576, 245676);
        var tmp_19 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$39 = _Dp___init__impl__ms3zkb(32);
        var tmp_20 = background(size(tmp_19, tmp$ret$39), MaterialTheme_instance.unz($composer_25, 6).vo0_1, get_CircleShape());
        IconButton($onRemove, tmp_20, false, null, null, null, ComposableSingletons$CartScreenKt_getInstance().k10s_1, $composer_25, 1572864, 60);
        sourceInformationMarkerEnd($composer_25);
        $composer_23.e31();
        var tmp_21 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$40 = _Dp___init__impl__ms3zkb(8);
        Spacer(height(tmp_21, tmp$ret$40), $composer_20, 6);
        var tmp0_verticalAlignment = Companion_getInstance_11().v8t_1;
        var tmp_22 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$41 = _Dp___init__impl__ms3zkb(6);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_9 = null;
        var horizontalArrangement_1 = tmp_22.mdq(tmp$ret$41);
        var verticalAlignment_1 = tmp0_verticalAlignment;
        var $composer_26 = $composer_20;
        if (!((1 & 1) === 0))
          modifier_9 = Companion_instance;
        if (!((1 & 2) === 0))
          horizontalArrangement_1 = Arrangement_getInstance().qdp_1;
        if (!((1 & 4) === 0))
          verticalAlignment_1 = Companion_getInstance_11().t8t_1;
        var measurePolicy_4 = rowMeasurePolicy(horizontalArrangement_1, verticalAlignment_1, $composer_26, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_10 = modifier_9;
        var $composer_27 = $composer_26;
        if (!((0 & 2) === 0))
          modifier_10 = Companion_instance;
        var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_27, 0).hashCode();
        var localMap_4 = $composer_27.t31();
        var materialized_4 = materialize($composer_27, modifier_10);
        var tmp0_4 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_28 = $composer_27;
        var tmp_23 = $composer_28.g30();
        if (!isInterface(tmp_23, Applier)) {
          invalidApplier();
        }
        $composer_28.b31();
        if ($composer_28.h30()) {
          $composer_28.c31(tmp0_4);
        } else {
          $composer_28.d31();
        }
        var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_28);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
        var $composer_29 = $composer_28;
        var $composer_30 = $composer_29;
        sourceInformationMarkerStart($composer_30, -1523565152, 'C:CartScreen.kt#5k0css');
        var tmp0_elvis_lhs_0 = $item.myw_1;
        var hasDiscount = (tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0) > 0.0;
        if (hasDiscount) {
          $composer_30.m30(-1523499495);
          sourceInformation($composer_30, '490@20962L175,494@21213L11,489@20928L435,499@21422L172,503@21670L11,498@21388L527');
          var tmp_24 = get_price_egp(string_instance);
          var tmp1_elvis_lhs = $item.myw_1;
          var tmp2_text = formatNumbers(stringResource_0(tmp_24, [toTwoDecimalString(tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs)], $composer_30, 0), $language);
          var tmp3_color = MaterialTheme_instance.unz($composer_30, 6).xnz_1;
          var tmp4_fontWeight = Companion_getInstance_16().g7z_1;
          var tmp5_fontSize = get_sp(20);
          var tmp_25 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_26 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_27 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp2_text, null, tmp3_color, null, tmp5_fontSize, null, tmp4_fontWeight, null, tmp_25, null, null, tmp_26, tmp_27, false, 0, 0, null, null, $composer_30, 1597440, 0, 262058);
          var tmp_28 = get_price_egp(string_instance);
          var tmp6_elvis_lhs = $item.lyw_1;
          var tmp7_text = formatNumbers(stringResource_0(tmp_28, [toTwoDecimalString(tmp6_elvis_lhs == null ? 0.0 : tmp6_elvis_lhs)], $composer_30, 0), $language);
          var tmp8_color = MaterialTheme_instance.unz($composer_30, 6).po0_1;
          var tmp9_fontSize = get_sp(14);
          var tmp10_textDecoration = Companion_getInstance_18().c80_1;
          var tmp_29 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$48 = _Dp___init__impl__ms3zkb(2);
          var tmp11_modifier = padding_1(tmp_29, VOID, VOID, VOID, tmp$ret$48);
          var tmp_30 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_31 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_32 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp7_text, tmp11_modifier, tmp8_color, null, tmp9_fontSize, null, null, null, tmp_30, tmp10_textDecoration, null, tmp_31, tmp_32, false, 0, 0, null, null, $composer_30, 805330992, 0, 261608);
          $composer_30.n30();
        } else {
          $composer_30.m30(-1522459724);
          sourceInformation($composer_30, '510@22003L172,514@22251L11,509@21969L432');
          var tmp_33 = get_price_egp(string_instance);
          var tmp12_elvis_lhs = $item.lyw_1;
          var tmp13_text = formatNumbers(stringResource_0(tmp_33, [toTwoDecimalString(tmp12_elvis_lhs == null ? 0.0 : tmp12_elvis_lhs)], $composer_30, 0), $language);
          var tmp14_color = MaterialTheme_instance.unz($composer_30, 6).xnz_1;
          var tmp15_fontWeight = Companion_getInstance_16().g7z_1;
          var tmp16_fontSize = get_sp(20);
          var tmp_34 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_35 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_36 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp13_text, null, tmp14_color, null, tmp16_fontSize, null, tmp15_fontWeight, null, tmp_34, null, null, tmp_35, tmp_36, false, 0, 0, null, null, $composer_30, 1597440, 0, 262058);
          $composer_30.n30();
        }
        sourceInformationMarkerEnd($composer_30);
        $composer_28.e31();
        var tmp_37 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$49 = _Dp___init__impl__ms3zkb(8);
        Spacer(height(tmp_37, tmp$ret$49), $composer_20, 6);
        ItemOptionsDisplay($item, $language, null, false, false, $composer_20, 0, 28);
        var tmp_38 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$50 = _Dp___init__impl__ms3zkb(8);
        Spacer(height(tmp_38, tmp$ret$50), $composer_20, 6);
        var tmp2_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_39 = Companion_instance;
        var tmp_40 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_20, 6).oo0_1, 0.5);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$51 = _Dp___init__impl__ms3zkb(12);
        var tmp_41 = background(tmp_39, tmp_40, RoundedCornerShape(tmp$ret$51));
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_42 = _Dp___init__impl__ms3zkb(4);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$53 = _Dp___init__impl__ms3zkb(4);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_11 = padding_2(tmp_41, tmp_42, tmp$ret$53);
        var horizontalArrangement_2 = null;
        var verticalAlignment_2 = tmp2_verticalAlignment;
        var $composer_31 = $composer_20;
        if (!((2 & 1) === 0))
          modifier_11 = Companion_instance;
        if (!((2 & 2) === 0))
          horizontalArrangement_2 = Arrangement_getInstance().qdp_1;
        if (!((2 & 4) === 0))
          verticalAlignment_2 = Companion_getInstance_11().t8t_1;
        var measurePolicy_5 = rowMeasurePolicy(horizontalArrangement_2, verticalAlignment_2, $composer_31, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_12 = modifier_11;
        var $composer_32 = $composer_31;
        if (!((0 & 2) === 0))
          modifier_12 = Companion_instance;
        var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_32, 0).hashCode();
        var localMap_5 = $composer_32.t31();
        var materialized_5 = materialize($composer_32, modifier_12);
        var tmp0_5 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_33 = $composer_32;
        var tmp_43 = $composer_33.g30();
        if (!isInterface(tmp_43, Applier)) {
          invalidApplier();
        }
        $composer_33.b31();
        if ($composer_33.h30()) {
          $composer_33.c31(tmp0_5);
        } else {
          $composer_33.d31();
        }
        var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_33);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
        var $composer_34 = $composer_33;
        var $composer_35 = $composer_34;
        sourceInformationMarkerStart($composer_35, 731942067, 'C538@23156L178,544@23446L11,545@23502L419,537@23110L811,553@23942L251,560@24260L39,562@24411L11,559@24214L611:CartScreen.kt#5k0css');
        sourceInformationMarkerStart($composer_35, 1824726287, 'CC(remember):CartScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_35.q31($item) | $composer_35.k31($onUpdateQuantity));
        // Inline function 'kotlin.let' call
        var it = $composer_35.i31();
        var tmp_44;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CartItemRow$lambda$lambda($item, $onUpdateQuantity);
          $composer_35.j31(value);
          tmp_44 = value;
        } else {
          tmp_44 = it;
        }
        var tmp0_group = tmp_44;
        sourceInformationMarkerEnd($composer_35);
        var tmp_45 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$64 = _Dp___init__impl__ms3zkb(28);
        var tmp_46 = background(size(tmp_45, tmp$ret$64), MaterialTheme_instance.unz($composer_35, 6).mo0_1, get_CircleShape());
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1047126463, true, CartItemRow$lambda$lambda_0($item), $composer_35, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_36 = $composer_35;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_36.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_36.i31();
        var tmp_47;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_36.j31(value_0);
          tmp_47 = value_0;
        } else {
          tmp_47 = it_0;
        }
        var tmp$ret$65 = tmp_47;
        IconButton(tmp0_group, tmp_46, false, null, null, null, tmp$ret$65, $composer_35, 1572864, 60);
        var tmp0_text = format($item.ryw_1, $language);
        var tmp_48 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$72 = _Dp___init__impl__ms3zkb(16);
        var tmp1_modifier = padding_2(tmp_48, tmp$ret$72);
        var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp3_fontSize = get_sp(16);
        var tmp_49 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_50 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_51 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_52 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, tmp1_modifier, tmp_49, null, tmp3_fontSize, null, tmp2_fontWeight, null, tmp_50, null, null, tmp_51, tmp_52, false, 0, 0, null, null, $composer_35, 1597488, 0, 262060);
        sourceInformationMarkerStart($composer_35, 1824761476, 'CC(remember):CartScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = !!($composer_35.k31($onUpdateQuantity) | $composer_35.q31($item));
        // Inline function 'kotlin.let' call
        var it_1 = $composer_35.i31();
        var tmp_53;
        if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
          var value_1 = CartItemRow$lambda$lambda_1($onUpdateQuantity, $item);
          $composer_35.j31(value_1);
          tmp_53 = value_1;
        } else {
          tmp_53 = it_1;
        }
        var tmp1_group = tmp_53;
        sourceInformationMarkerEnd($composer_35);
        var tmp_54 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$77 = _Dp___init__impl__ms3zkb(28);
        var tmp_55 = background(size(tmp_54, tmp$ret$77), MaterialTheme_instance.unz($composer_35, 6).mo0_1, get_CircleShape());
        IconButton(tmp1_group, tmp_55, false, null, null, null, ComposableSingletons$CartScreenKt_getInstance().l10s_1, $composer_35, 1572864, 60);
        sourceInformationMarkerEnd($composer_35);
        $composer_33.e31();
        sourceInformationMarkerEnd($composer_20);
        $composer_18.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_56;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_56 = Unit_instance;
        }
        tmp = tmp_56;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartItemRow$lambda_0($state, $item, $onUpdateQuantity, $onRemove, $onClick, $$changed) {
    return function ($composer, $force) {
      CartItemRow($state, $item, $onUpdateQuantity, $onRemove, $onClick, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_cart_CartViewModel$stable;
  function CartViewModel$observeLanguage$slambda$slambda$lambda($language) {
    return function ($this$updateState) {
      return $this$updateState.v10r(VOID, VOID, VOID, VOID, VOID, $language);
    };
  }
  function CartViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation) {
    this.x10t_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartViewModel$observeLanguage$slambda$slambda).pyo = function (language, $completion) {
    var tmp = this.um9(language, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartViewModel$observeLanguage$slambda$slambda).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartViewModel$observeLanguage$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.x10t_1.x10k(CartViewModel$observeLanguage$slambda$slambda$lambda(this.y10t_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CartViewModel$observeLanguage$slambda$slambda).um9 = function (language, completion) {
    var i = new CartViewModel$observeLanguage$slambda$slambda(this.x10t_1, completion);
    i.y10t_1 = language;
    return i;
  };
  function CartViewModel$observeLanguage$slambda$slambda_0(this$0, resultContinuation) {
    var i = new CartViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (language, $completion) {
      return i.pyo(language, $completion);
    }, 1);
  }
  function CartViewModel$observeNetwork$slambda$slambda$lambda($isConnected) {
    return function ($this$updateState) {
      return $this$updateState.v10r(VOID, VOID, VOID, VOID, VOID, VOID, $isConnected);
    };
  }
  function CartViewModel$observeNetwork$slambda$slambda(this$0, resultContinuation) {
    this.h10u_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartViewModel$observeNetwork$slambda$slambda).xf4 = function (isConnected, $completion) {
    var tmp = this.yf4(isConnected, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartViewModel$observeNetwork$slambda$slambda).ja = function (p1, $completion) {
    return this.xf4((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartViewModel$observeNetwork$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.h10u_1.x10k(CartViewModel$observeNetwork$slambda$slambda$lambda(this.i10u_1));
          if (this.i10u_1) {
            syncCart(this.h10u_1);
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CartViewModel$observeNetwork$slambda$slambda).yf4 = function (isConnected, completion) {
    var i = new CartViewModel$observeNetwork$slambda$slambda(this.h10u_1, completion);
    i.i10u_1 = isConnected;
    return i;
  };
  function CartViewModel$observeNetwork$slambda$slambda_0(this$0, resultContinuation) {
    var i = new CartViewModel$observeNetwork$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (isConnected, $completion) {
      return i.xf4(isConnected, $completion);
    }, 1);
  }
  function CartViewModel$observeAuth$slambda$slambda$lambda($profile) {
    return function ($this$updateState) {
      var tmp0_isLoggedIn = !($profile == null);
      return $this$updateState.v10r(VOID, VOID, false, VOID, tmp0_isLoggedIn);
    };
  }
  function CartViewModel$observeAuth$slambda$slambda(this$0, resultContinuation) {
    this.r10u_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartViewModel$observeAuth$slambda$slambda).t10u = function (profile, $completion) {
    var tmp = this.u10u(profile, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartViewModel$observeAuth$slambda$slambda).ja = function (p1, $completion) {
    return this.t10u((p1 == null ? true : p1 instanceof Profile) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartViewModel$observeAuth$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.r10u_1.x10k(CartViewModel$observeAuth$slambda$slambda$lambda(this.s10u_1));
          if (!(this.s10u_1 == null)) {
            syncCart(this.r10u_1);
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CartViewModel$observeAuth$slambda$slambda).u10u = function (profile, completion) {
    var i = new CartViewModel$observeAuth$slambda$slambda(this.r10u_1, completion);
    i.s10u_1 = profile;
    return i;
  };
  function CartViewModel$observeAuth$slambda$slambda_0(this$0, resultContinuation) {
    var i = new CartViewModel$observeAuth$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (profile, $completion) {
      return i.t10u(profile, $completion);
    }, 1);
  }
  function CartViewModel$observeCart$slambda$slambda$slambda($items, resultContinuation) {
    this.d10v_1 = $items;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartViewModel$observeCart$slambda$slambda$slambda).f10v = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartViewModel$observeCart$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.f10v((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartViewModel$observeCart$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var sum = 0;
          var _iterator__ex2g4s = this.d10v_1.t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            var tmp_0 = sum;
            var tmp_1;
            var tmp0_elvis_lhs = element.myw_1;
            if ((tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) > 0.0) {
              tmp_1 = ensureNotNull(element.myw_1);
            } else {
              var tmp1_elvis_lhs = element.lyw_1;
              tmp_1 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
            }
            var price = tmp_1;
            sum = tmp_0 + price * element.ryw_1;
          }
          return sum;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CartViewModel$observeCart$slambda$slambda$slambda).q24 = function ($this$withContext, completion) {
    var i = new CartViewModel$observeCart$slambda$slambda$slambda(this.d10v_1, completion);
    i.e10v_1 = $this$withContext;
    return i;
  };
  function CartViewModel$observeCart$slambda$slambda$slambda_0($items, resultContinuation) {
    var i = new CartViewModel$observeCart$slambda$slambda$slambda($items, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.f10v($this$withContext, $completion);
    }, 1);
  }
  function CartViewModel$observeCart$slambda$slambda$lambda($items, $total) {
    return function ($this$updateState) {
      return $this$updateState.v10r($items, false, VOID, $total);
    };
  }
  function CartViewModel$observeCart$slambda$lambda($this$updateState) {
    return $this$updateState.v10r(VOID, true);
  }
  function CartViewModel$observeCart$slambda$slambda(this$0, resultContinuation) {
    this.o10v_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartViewModel$observeCart$slambda$slambda).q10v = function (items, $completion) {
    var tmp = this.r10v(items, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartViewModel$observeCart$slambda$slambda).ja = function (p1, $completion) {
    return this.q10v((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartViewModel$observeCart$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = Dispatchers_getInstance().i1h_1;
            suspendResult = withContext(tmp_0, CartViewModel$observeCart$slambda$slambda$slambda_0(this.p10v_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var total = suspendResult;
            this.o10v_1.x10k(CartViewModel$observeCart$slambda$slambda$lambda(this.p10v_1, total));
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartViewModel$observeCart$slambda$slambda).r10v = function (items, completion) {
    var i = new CartViewModel$observeCart$slambda$slambda(this.o10v_1, completion);
    i.p10v_1 = items;
    return i;
  };
  function CartViewModel$observeCart$slambda$slambda_0(this$0, resultContinuation) {
    var i = new CartViewModel$observeCart$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (items, $completion) {
      return i.q10v(items, $completion);
    }, 1);
  }
  function observeLanguage($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, CartViewModel$observeLanguage$slambda_0($this, null));
  }
  function observeNetwork($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, CartViewModel$observeNetwork$slambda_0($this, null));
  }
  function syncCart($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, CartViewModel$syncCart$slambda_0($this, null));
  }
  function observeAuth($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, CartViewModel$observeAuth$slambda_0($this, null));
  }
  function observeCart($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, CartViewModel$observeCart$slambda_0($this, null));
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_5(function_0) {
    this.s10v_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).a1v = function (value, $completion) {
    return this.s10v_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).q3 = function () {
    return this.s10v_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_6(function_0) {
    this.t10v_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).a1v = function (value, $completion) {
    return this.t10v_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).q3 = function () {
    return this.t10v_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_7(function_0) {
    this.u10v_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_7).a1v = function (value, $completion) {
    return this.u10v_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_7).q3 = function () {
    return this.u10v_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_7).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_7).hashCode = function () {
    return hashCode(this.q3());
  };
  function CartViewModel$observeLanguage$slambda(this$0, resultContinuation) {
    this.d10w_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartViewModel$observeLanguage$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartViewModel$observeLanguage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartViewModel$observeLanguage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.d10w_1.q10w_1.y103();
            var tmp_1 = CartViewModel$observeLanguage$slambda$slambda_0(this.d10w_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_5(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartViewModel$observeLanguage$slambda).q24 = function ($this$launch, completion) {
    var i = new CartViewModel$observeLanguage$slambda(this.d10w_1, completion);
    i.e10w_1 = $this$launch;
    return i;
  };
  function CartViewModel$observeLanguage$slambda_0(this$0, resultContinuation) {
    var i = new CartViewModel$observeLanguage$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CartViewModel$observeNetwork$slambda(this$0, resultContinuation) {
    this.a10x_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartViewModel$observeNetwork$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartViewModel$observeNetwork$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartViewModel$observeNetwork$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.a10x_1.r10w_1.y103();
            var tmp_1 = CartViewModel$observeNetwork$slambda$slambda_0(this.a10x_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_6(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartViewModel$observeNetwork$slambda).q24 = function ($this$launch, completion) {
    var i = new CartViewModel$observeNetwork$slambda(this.a10x_1, completion);
    i.b10x_1 = $this$launch;
    return i;
  };
  function CartViewModel$observeNetwork$slambda_0(this$0, resultContinuation) {
    var i = new CartViewModel$observeNetwork$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CartViewModel$syncCart$slambda(this$0, resultContinuation) {
    this.k10x_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartViewModel$syncCart$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartViewModel$syncCart$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartViewModel$syncCart$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.k10x_1.r10w_1.ynu()) {
              this.n9_1 = 1;
              suspendResult = this.k10x_1.k10w_1.r2b(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartViewModel$syncCart$slambda).q24 = function ($this$launch, completion) {
    var i = new CartViewModel$syncCart$slambda(this.k10x_1, completion);
    i.l10x_1 = $this$launch;
    return i;
  };
  function CartViewModel$syncCart$slambda_0(this$0, resultContinuation) {
    var i = new CartViewModel$syncCart$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CartViewModel$observeAuth$slambda(this$0, resultContinuation) {
    this.u10x_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartViewModel$observeAuth$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartViewModel$observeAuth$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartViewModel$observeAuth$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.u10x_1.o10w_1.ynu();
            var tmp_1 = CartViewModel$observeAuth$slambda$slambda_0(this.u10x_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_7(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartViewModel$observeAuth$slambda).q24 = function ($this$launch, completion) {
    var i = new CartViewModel$observeAuth$slambda(this.u10x_1, completion);
    i.v10x_1 = $this$launch;
    return i;
  };
  function CartViewModel$observeAuth$slambda_0(this$0, resultContinuation) {
    var i = new CartViewModel$observeAuth$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CartViewModel$observeCart$slambda(this$0, resultContinuation) {
    this.e10y_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartViewModel$observeCart$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartViewModel$observeCart$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartViewModel$observeCart$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.e10y_1.x10k(CartViewModel$observeCart$slambda$lambda);
            this.n9_1 = 1;
            var tmp_0 = this.e10y_1.j10w_1.ynu();
            suspendResult = collectLatest(tmp_0, CartViewModel$observeCart$slambda$slambda_0(this.e10y_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartViewModel$observeCart$slambda).q24 = function ($this$launch, completion) {
    var i = new CartViewModel$observeCart$slambda(this.e10y_1, completion);
    i.f10y_1 = $this$launch;
    return i;
  };
  function CartViewModel$observeCart$slambda_0(this$0, resultContinuation) {
    var i = new CartViewModel$observeCart$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function $handleIntentCOROUTINE$_1(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o10y_1 = _this__u8e3s4;
    this.p10y_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            var tmp0_subject = this.p10y_1;
            if (equals(tmp0_subject, LoadCart_instance)) {
              observeCart(this.o10y_1);
              this.n9_1 = 11;
              continue $sm;
            } else {
              if (tmp0_subject instanceof UpdateQuantity) {
                if (this.p10y_1.x10r_1 > 0) {
                  this.n9_1 = 9;
                  suspendResult = this.o10y_1.l10w_1.k103(this.p10y_1.w10r_1, this.p10y_1.x10r_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.n9_1 = 8;
                  suspendResult = this.o10y_1.m10w_1.c103(this.p10y_1.w10r_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                if (tmp0_subject instanceof RemoveItem) {
                  this.n9_1 = 7;
                  suspendResult = this.o10y_1.m10w_1.c103(this.p10y_1.y10r_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (equals(tmp0_subject, ClearCart_instance)) {
                    this.n9_1 = 6;
                    suspendResult = this.o10y_1.n10w_1.r2b(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (equals(tmp0_subject, Checkout_instance_0)) {
                      var profile = this.o10y_1.p10w_1.ynu();
                      if (!(profile == null)) {
                        if (profile.myn_1 === true) {
                          this.n9_1 = 3;
                          suspendResult = this.o10y_1.d10l(new ShowError_1(new ResourceString(get_user_banned_error(string_instance), [])), this);
                          if (suspendResult === get_COROUTINE_SUSPENDED()) {
                            return suspendResult;
                          }
                          continue $sm;
                        } else {
                          this.n9_1 = 2;
                          suspendResult = this.o10y_1.d10l(NavigateToCheckout_instance, this);
                          if (suspendResult === get_COROUTINE_SUSPENDED()) {
                            return suspendResult;
                          }
                          continue $sm;
                        }
                      } else {
                        this.n9_1 = 1;
                        suspendResult = this.o10y_1.d10l(NavigateToAuth_instance, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      }
                    } else {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
            }

            break;
          case 1:
            this.n9_1 = 5;
            continue $sm;
          case 2:
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.n9_1 = 11;
            continue $sm;
          case 6:
            this.n9_1 = 11;
            continue $sm;
          case 7:
            this.n9_1 = 11;
            continue $sm;
          case 8:
            this.n9_1 = 10;
            continue $sm;
          case 9:
            this.n9_1 = 10;
            continue $sm;
          case 10:
            this.n9_1 = 11;
            continue $sm;
          case 11:
            return Unit_instance;
          case 12:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 12) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function CartViewModel(getCartItemsUseCase, syncCartUseCase, updateCartQuantityUseCase, removeFromCartUseCase, clearCartUseCase, getCurrentUserUseCase, getCurrentUserValueUseCase, getLanguageUseCase, isConnectedUseCase) {
    BaseMviViewModel.call(this, new CartState());
    this.j10w_1 = getCartItemsUseCase;
    this.k10w_1 = syncCartUseCase;
    this.l10w_1 = updateCartQuantityUseCase;
    this.m10w_1 = removeFromCartUseCase;
    this.n10w_1 = clearCartUseCase;
    this.o10w_1 = getCurrentUserUseCase;
    this.p10w_1 = getCurrentUserValueUseCase;
    this.q10w_1 = getLanguageUseCase;
    this.r10w_1 = isConnectedUseCase;
    observeNetwork(this);
    observeCart(this);
    observeAuth(this);
    syncCart(this);
    observeLanguage(this);
  }
  protoOf(CartViewModel).q10y = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_1(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartViewModel).f10l = function (intent, $completion) {
    return this.q10y(isInterface(intent, CartIntent) ? intent : THROW_CCE(), $completion);
  };
  var client_fstech_hadaya_presentation_cart_details_CartMagicMugProductDetailsState$stable;
  var client_fstech_hadaya_presentation_cart_details_CartMagicMugProductDetailsIntent_LoadItem$stable;
  var client_fstech_hadaya_presentation_cart_details_CartMagicMugProductDetailsSideEffect_NavigateBack$stable;
  function CartMagicMugProductDetailsState(cartItem, customImageBitmap, loading, error, language) {
    cartItem = cartItem === VOID ? null : cartItem;
    customImageBitmap = customImageBitmap === VOID ? null : customImageBitmap;
    loading = loading === VOID ? false : loading;
    error = error === VOID ? null : error;
    language = language === VOID ? 'en' : language;
    this.r10y_1 = cartItem;
    this.s10y_1 = customImageBitmap;
    this.t10y_1 = loading;
    this.u10y_1 = error;
    this.v10y_1 = language;
  }
  protoOf(CartMagicMugProductDetailsState).w10y = function (cartItem, customImageBitmap, loading, error, language) {
    return new CartMagicMugProductDetailsState(cartItem, customImageBitmap, loading, error, language);
  };
  protoOf(CartMagicMugProductDetailsState).x10y = function (cartItem, customImageBitmap, loading, error, language, $super) {
    cartItem = cartItem === VOID ? this.r10y_1 : cartItem;
    customImageBitmap = customImageBitmap === VOID ? this.s10y_1 : customImageBitmap;
    loading = loading === VOID ? this.t10y_1 : loading;
    error = error === VOID ? this.u10y_1 : error;
    language = language === VOID ? this.v10y_1 : language;
    return $super === VOID ? this.w10y(cartItem, customImageBitmap, loading, error, language) : $super.w10y.call(this, cartItem, customImageBitmap, loading, error, language);
  };
  protoOf(CartMagicMugProductDetailsState).toString = function () {
    return 'CartMagicMugProductDetailsState(cartItem=' + toString_0(this.r10y_1) + ', customImageBitmap=' + toString_0(this.s10y_1) + ', loading=' + this.t10y_1 + ', error=' + toString_0(this.u10y_1) + ', language=' + this.v10y_1 + ')';
  };
  protoOf(CartMagicMugProductDetailsState).hashCode = function () {
    var result = this.r10y_1 == null ? 0 : this.r10y_1.hashCode();
    result = imul(result, 31) + (this.s10y_1 == null ? 0 : hashCode(this.s10y_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t10y_1) | 0;
    result = imul(result, 31) + (this.u10y_1 == null ? 0 : hashCode(this.u10y_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.v10y_1) | 0;
    return result;
  };
  protoOf(CartMagicMugProductDetailsState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CartMagicMugProductDetailsState))
      return false;
    if (!equals(this.r10y_1, other.r10y_1))
      return false;
    if (!equals(this.s10y_1, other.s10y_1))
      return false;
    if (!(this.t10y_1 === other.t10y_1))
      return false;
    if (!equals(this.u10y_1, other.u10y_1))
      return false;
    if (!(this.v10y_1 === other.v10y_1))
      return false;
    return true;
  };
  function LoadItem() {
  }
  function CartMagicMugProductDetailsIntent() {
  }
  function CartMagicMugProductDetailsScreen(cartItem, onBack, onNavigateToAuth, topPadding, bottomPadding, $composer, $changed, $default) {
    var topPadding_0 = {_v: new Dp(topPadding)};
    var bottomPadding_0 = {_v: new Dp(bottomPadding)};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(216024429);
    sourceInformation($composer_0, 'C(CartMagicMugProductDetailsScreen)P(1,2,3,4:c#ui.unit.Dp,0:c#ui.unit.Dp)72@3568L12,73@3623L12,74@3655L43,76@3739L105,76@3704L140:CartMagicMugProductDetailsScreen.kt#6ni00');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(cartItem) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToAuth) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.n31(_Dp___get_value__impl__geb1vb(topPadding_0._v.m5f_1)) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.n31(_Dp___get_value__impl__geb1vb(bottomPadding_0._v.m5f_1)) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
        topPadding_0._v = new Dp(tmp$ret$0);
      }
      if (!(($default & 16) === 0)) {
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(0);
        bottomPadding_0._v = new Dp(tmp$ret$1);
      }
      if (isTraceInProgress()) {
        traceEventStart(216024429, $dirty, -1, 'client.fstech.hadaya.presentation.cart.details.CartMagicMugProductDetailsScreen (CartMagicMugProductDetailsScreen.kt:71)');
      }
      // Inline function 'org.koin.compose.koinInject' call
      var qualifier = null;
      var scope = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -1168520582, 'CC(koinInject)88@2750L18,90@2787L73:Inject.kt#8jjlyv');
      if (!((3 & 1) === 0))
        qualifier = null;
      if (!((3 & 2) === 0))
        scope = currentKoinScope($composer_1, 0);
      sourceInformationMarkerStart($composer_1, -1961811197, 'CC(remember):Inject.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_1.k31(qualifier) | $composer_1.k31(scope));
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = scope.ts6(getKClass(GetProductByIdUseCase), qualifier);
        $composer_1.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp1_group = tmp;
      sourceInformationMarkerEnd($composer_1);
      sourceInformationMarkerEnd($composer_1);
      var getProductByIdUseCase = tmp1_group;
      // Inline function 'org.koin.compose.koinInject' call
      var qualifier_0 = null;
      var scope_0 = null;
      var $composer_2 = $composer_0;
      sourceInformationMarkerStart($composer_2, -1168520582, 'CC(koinInject)88@2750L18,90@2787L73:Inject.kt#8jjlyv');
      if (!((3 & 1) === 0))
        qualifier_0 = null;
      if (!((3 & 2) === 0))
        scope_0 = currentKoinScope($composer_2, 0);
      sourceInformationMarkerStart($composer_2, -1961811197, 'CC(remember):Inject.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_2.k31(qualifier_0) | $composer_2.k31(scope_0));
      // Inline function 'kotlin.let' call
      var it_0 = $composer_2.i31();
      var tmp_0;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = scope_0.ts6(getKClass(ICartRepository), qualifier_0);
        $composer_2.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group_0 = tmp_0;
      sourceInformationMarkerEnd($composer_2);
      sourceInformationMarkerEnd($composer_2);
      var cartRepository = tmp1_group_0;
      sourceInformationMarkerStart($composer_0, 1441058008, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_0.i31();
      var tmp_1;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = mutableStateOf(null);
        this_0.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var product$delegate = tmp0_group;
      var tmp_2 = cartItem.gyw_1;
      sourceInformationMarkerStart($composer_0, 1441060758, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!($composer_0.q31(cartItem) | $composer_0.q31(getProductByIdUseCase));
      // Inline function 'kotlin.let' call
      var it_2 = tmp0.i31();
      var tmp_3;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = CartMagicMugProductDetailsScreen$slambda_0(cartItem, getProductByIdUseCase, product$delegate, null);
        tmp0.j31(value_2);
        tmp_3 = value_2;
      } else {
        tmp_3 = it_2;
      }
      var tmp1_group_1 = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_2, tmp1_group_1, $composer_0, 0);
      var tmp0_safe_receiver = CartMagicMugProductDetailsScreen$lambda(product$delegate);
      var tmp_4;
      if (tmp0_safe_receiver == null) {
        $composer_0.m30(1724590070);
        $composer_0.n30();
        tmp_4 = null;
      } else {
        $composer_0.m30(1724590071);
        sourceInformation($composer_0, '*83@3925L15,84@4016L12,85@4076L16,86@4125L32,91@4486L973,91@4468L991,113@5495L607,113@5469L633,128@6171L116,128@6112L175,132@6320L106,132@6297L129,138@6462L21,139@6519L34,140@6586L34,141@6654L34,143@6724L34,144@6804L42,145@6883L34,146@6951L34,147@7020L25,149@7179L227,149@7055L351,169@7831L36788');
        // Inline function 'kotlin.let' call
        // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
        var qualifier_1 = null;
        var viewModelStoreOwner = null;
        var key = null;
        var extras = null;
        var scope_1 = null;
        var parameters = null;
        var $composer_3 = $composer_0;
        sourceInformationMarkerStart($composer_3, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
        if (!((63 & 1) === 0))
          qualifier_1 = null;
        if (!((63 & 2) === 0)) {
          var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_3, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
          var tmp_5;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.error' call
            var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
            throw IllegalStateException_init_$Create$(toString(message));
          } else {
            tmp_5 = tmp0_elvis_lhs;
          }
          viewModelStoreOwner = tmp_5;
        }
        if (!((63 & 4) === 0))
          key = null;
        if (!((63 & 8) === 0))
          extras = defaultExtras(viewModelStoreOwner);
        if (!((63 & 16) === 0))
          scope_1 = currentKoinScope($composer_3, 0);
        if (!((63 & 32) === 0))
          parameters = null;
        var tmp0_0 = resolveViewModel(getKClass(CustomProductDetailsViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier_1, scope_1, parameters);
        sourceInformationMarkerEnd($composer_3);
        var viewModel = tmp0_0;
        // Inline function 'org.koin.compose.koinInject' call
        var qualifier_2 = null;
        var scope_2 = null;
        var $composer_4 = $composer_0;
        sourceInformationMarkerStart($composer_4, -1168520582, 'CC(koinInject)88@2750L18,90@2787L73:Inject.kt#8jjlyv');
        if (!((3 & 1) === 0))
          qualifier_2 = null;
        if (!((3 & 2) === 0))
          scope_2 = currentKoinScope($composer_4, 0);
        sourceInformationMarkerStart($composer_4, -1961811197, 'CC(remember):Inject.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = !!($composer_4.k31(qualifier_2) | $composer_4.k31(scope_2));
        // Inline function 'kotlin.let' call
        var it_3 = $composer_4.i31();
        var tmp_6;
        if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
          var value_3 = scope_2.ts6(getKClass(AppViewModel), qualifier_2);
          $composer_4.j31(value_3);
          tmp_6 = value_3;
        } else {
          tmp_6 = it_3;
        }
        var tmp1_group_2 = tmp_6;
        sourceInformationMarkerEnd($composer_4);
        sourceInformationMarkerEnd($composer_4);
        var appViewModel = tmp1_group_2;
        var tmp_7 = viewModel.s10h().ajg();
        var state$delegate = collectAsState(tmp_7, null, $composer_0, 0, 1);
        sourceInformationMarkerStart($composer_0, 1572738894, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_1 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_4 = this_1.i31();
        var tmp_8;
        if (false || it_4 === Companion_getInstance().f30_1) {
          var value_4 = new SnackbarHostState();
          this_1.j31(value_4);
          tmp_8 = value_4;
        } else {
          tmp_8 = it_4;
        }
        var tmp0_group_0 = tmp_8;
        sourceInformationMarkerEnd($composer_0);
        var snackbarHostState = tmp0_group_0;
        var language = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).d10z_1;
        var tmp_9;
        if (language === 'en') {
          var tmp0_elvis_lhs_0 = tmp0_safe_receiver.ozt_1;
          tmp_9 = tmp0_elvis_lhs_0 == null ? tmp0_safe_receiver.pzt_1 : tmp0_elvis_lhs_0;
        } else {
          var tmp1_elvis_lhs = tmp0_safe_receiver.pzt_1;
          tmp_9 = tmp1_elvis_lhs == null ? tmp0_safe_receiver.ozt_1 : tmp1_elvis_lhs;
        }
        var tmp2_elvis_lhs = tmp_9;
        var name = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
        var tmp_10;
        if (language === 'en') {
          var tmp3_elvis_lhs = tmp0_safe_receiver.qzt_1;
          tmp_10 = tmp3_elvis_lhs == null ? tmp0_safe_receiver.rzt_1 : tmp3_elvis_lhs;
        } else {
          var tmp4_elvis_lhs = tmp0_safe_receiver.rzt_1;
          tmp_10 = tmp4_elvis_lhs == null ? tmp0_safe_receiver.qzt_1 : tmp4_elvis_lhs;
        }
        var tmp5_elvis_lhs = tmp_10;
        var description = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
        sourceInformationMarkerStart($composer_0, 1572751387, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        var tmp0_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = !!(!!($composer_0.q31(viewModel) | $composer_0.q31(cartItem)) | $composer_0.q31(tmp0_safe_receiver));
        // Inline function 'kotlin.let' call
        var it_5 = tmp0_1.i31();
        var tmp_11;
        if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
          var value_5 = CartMagicMugProductDetailsScreen$slambda_2(viewModel, cartItem, tmp0_safe_receiver, null);
          tmp0_1.j31(value_5);
          tmp_11 = value_5;
        } else {
          tmp_11 = it_5;
        }
        var tmp1_group_3 = tmp_11;
        sourceInformationMarkerEnd($composer_0);
        LaunchedEffect_0(tmp0_safe_receiver, tmp1_group_3, $composer_0, 0);
        sourceInformationMarkerStart($composer_0, 1572783309, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        var tmp0_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = !!(!!($composer_0.q31(viewModel) | ($dirty & 896) === 256) | ($dirty & 112) === 32);
        // Inline function 'kotlin.let' call
        var it_6 = tmp0_2.i31();
        var tmp_12;
        if (invalid_4 || it_6 === Companion_getInstance().f30_1) {
          var value_6 = CartMagicMugProductDetailsScreen$slambda_4(viewModel, snackbarHostState, onNavigateToAuth, onBack, null);
          tmp0_2.j31(value_6);
          tmp_12 = value_6;
        } else {
          tmp_12 = it_6;
        }
        var tmp2_group = tmp_12;
        sourceInformationMarkerEnd($composer_0);
        LaunchedEffect_0(viewModel, tmp2_group, $composer_0, 0);
        var tmp_13 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).a10z_1;
        var tmp_14 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).g10z_1;
        sourceInformationMarkerStart($composer_0, 1572804450, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        var tmp0_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = !!($composer_0.q31(appViewModel) | $composer_0.k31(state$delegate));
        // Inline function 'kotlin.let' call
        var it_7 = tmp0_3.i31();
        var tmp_15;
        if (invalid_5 || it_7 === Companion_getInstance().f30_1) {
          var value_7 = CartMagicMugProductDetailsScreen$slambda_6(appViewModel, state$delegate, null);
          tmp0_3.j31(value_7);
          tmp_15 = value_7;
        } else {
          tmp_15 = it_7;
        }
        var tmp3_group = tmp_15;
        sourceInformationMarkerEnd($composer_0);
        LaunchedEffect(tmp_13, tmp_14, tmp3_group, $composer_0, 0);
        sourceInformationMarkerStart($composer_0, 1572809208, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        var tmp0_4 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_6 = $composer_0.q31(appViewModel);
        // Inline function 'kotlin.let' call
        var it_8 = tmp0_4.i31();
        var tmp_16;
        if (invalid_6 || it_8 === Companion_getInstance().f30_1) {
          var value_8 = CartMagicMugProductDetailsScreen$lambda_18(appViewModel);
          tmp0_4.j31(value_8);
          tmp_16 = value_8;
        } else {
          tmp_16 = it_8;
        }
        var tmp4_group = tmp_16;
        sourceInformationMarkerEnd($composer_0);
        DisposableEffect(Unit_instance, tmp4_group, $composer_0, 6);
        var verticalScrollState = rememberScrollState(0, $composer_0, 0, 1);
        sourceInformationMarkerStart($composer_0, 1572815504, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_2 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_9 = this_2.i31();
        var tmp_17;
        if (false || it_9 === Companion_getInstance().f30_1) {
          var value_9 = mutableStateOf(false);
          this_2.j31(value_9);
          tmp_17 = value_9;
        } else {
          tmp_17 = it_9;
        }
        var tmp5_group = tmp_17;
        sourceInformationMarkerEnd($composer_0);
        var isInteractingWith3D$delegate = tmp5_group;
        sourceInformationMarkerStart($composer_0, 1572817648, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_3 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_10 = this_3.i31();
        var tmp_18;
        if (false || it_10 === Companion_getInstance().f30_1) {
          var value_10 = mutableStateOf(false);
          this_3.j31(value_10);
          tmp_18 = value_10;
        } else {
          tmp_18 = it_10;
        }
        var tmp6_group = tmp_18;
        sourceInformationMarkerEnd($composer_0);
        var showFullScreen3D$delegate = tmp6_group;
        sourceInformationMarkerStart($composer_0, 1572819824, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_4 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_11 = this_4.i31();
        var tmp_19;
        if (false || it_11 === Companion_getInstance().f30_1) {
          var value_11 = mutableStateOf(false);
          this_4.j31(value_11);
          tmp_19 = value_11;
        } else {
          tmp_19 = it_11;
        }
        var tmp7_group = tmp_19;
        sourceInformationMarkerEnd($composer_0);
        var isMediaDialogOpen$delegate = tmp7_group;
        sourceInformationMarkerStart($composer_0, 1572822064, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_5 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_12 = this_5.i31();
        var tmp_20;
        if (false || it_12 === Companion_getInstance().f30_1) {
          var value_12 = mutableStateOf(false);
          this_5.j31(value_12);
          tmp_20 = value_12;
        } else {
          tmp_20 = it_12;
        }
        var tmp8_group = tmp_20;
        sourceInformationMarkerEnd($composer_0);
        var showBirthdayPicker$delegate = tmp8_group;
        sourceInformationMarkerStart($composer_0, 1572824632, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_6 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_13 = this_6.i31();
        var tmp_21;
        if (false || it_13 === Companion_getInstance().f30_1) {
          var value_13 = mutableStateOf(null);
          this_6.j31(value_13);
          tmp_21 = value_13;
        } else {
          tmp_21 = it_13;
        }
        var tmp9_group = tmp_21;
        sourceInformationMarkerEnd($composer_0);
        var birthdayPickerTargetOptionKey$delegate = tmp9_group;
        sourceInformationMarkerStart($composer_0, 1572827152, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_7 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_14 = this_7.i31();
        var tmp_22;
        if (false || it_14 === Companion_getInstance().f30_1) {
          var value_14 = mutableStateOf(false);
          this_7.j31(value_14);
          tmp_22 = value_14;
        } else {
          tmp_22 = it_14;
        }
        var tmp10_group = tmp_22;
        sourceInformationMarkerEnd($composer_0);
        var isPickingBoxBirthday$delegate = tmp10_group;
        sourceInformationMarkerStart($composer_0, 1572829328, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_8 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_15 = this_8.i31();
        var tmp_23;
        if (false || it_15 === Companion_getInstance().f30_1) {
          var value_15 = mutableStateOf(false);
          this_8.j31(value_15);
          tmp_23 = value_15;
        } else {
          tmp_23 = it_15;
        }
        var tmp11_group = tmp_23;
        sourceInformationMarkerEnd($composer_0);
        var showDiscardDialog$delegate = tmp11_group;
        var tmp_24 = _DisplayMode___init__impl__gfd230(0);
        var birthdayPickerState = rememberDatePickerState(null, null, null, tmp_24, null, $composer_0, 0, 31);
        var tmp_25;
        var tmp_26;
        if (CartMagicMugProductDetailsScreen$lambda_1(state$delegate).a10z_1 || CartMagicMugProductDetailsScreen$lambda_4(showFullScreen3D$delegate)) {
          tmp_26 = true;
        } else {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_26 = !CartMagicMugProductDetailsScreen$lambda_1(state$delegate).g10z_1.r();
        }
        if (tmp_26) {
          tmp_25 = !CartMagicMugProductDetailsScreen$lambda_1(state$delegate).h10z_1;
        } else {
          tmp_25 = false;
        }
        var tmp_27 = tmp_25;
        sourceInformationMarkerStart($composer_0, 1572836817, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        var tmp0_5 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_7 = $composer_0.k31(state$delegate);
        // Inline function 'kotlin.let' call
        var it_16 = tmp0_5.i31();
        var tmp_28;
        if (invalid_7 || it_16 === Companion_getInstance().f30_1) {
          var value_16 = CartMagicMugProductDetailsScreen$lambda_19(showFullScreen3D$delegate, state$delegate, showDiscardDialog$delegate);
          tmp0_5.j31(value_16);
          tmp_28 = value_16;
        } else {
          tmp_28 = it_16;
        }
        var tmp12_group = tmp_28;
        sourceInformationMarkerEnd($composer_0);
        BackHandler(tmp_27, tmp12_group, $composer_0, 0, 0);
        if (CartMagicMugProductDetailsScreen$lambda_14(showDiscardDialog$delegate)) {
          $composer_0.m30(1513563798);
          sourceInformation($composer_0, '159@7496L46,160@7570L44,161@7644L94,165@7768L29,158@7453L358');
          var tmp_29 = stringResource(get_discard_order_title(string_instance), $composer_0, 0);
          var tmp_30 = stringResource(get_discard_order_msg(string_instance), $composer_0, 0);
          sourceInformationMarkerStart($composer_0, 1572851564, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          var tmp0_6 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_8 = ($dirty & 112) === 32;
          // Inline function 'kotlin.let' call
          var it_17 = tmp0_6.i31();
          var tmp_31;
          if (invalid_8 || it_17 === Companion_getInstance().f30_1) {
            var value_17 = CartMagicMugProductDetailsScreen$lambda_20(showDiscardDialog$delegate, onBack);
            tmp0_6.j31(value_17);
            tmp_31 = value_17;
          } else {
            tmp_31 = it_17;
          }
          var tmp13_group = tmp_31;
          sourceInformationMarkerEnd($composer_0);
          sourceInformationMarkerStart($composer_0, 1572855467, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var this_9 = $composer_0;
          // Inline function 'kotlin.let' call
          var it_18 = this_9.i31();
          var tmp_32;
          if (false || it_18 === Companion_getInstance().f30_1) {
            var value_18 = CartMagicMugProductDetailsScreen$lambda_21(showDiscardDialog$delegate);
            this_9.j31(value_18);
            tmp_32 = value_18;
          } else {
            tmp_32 = it_18;
          }
          var tmp14_group = tmp_32;
          sourceInformationMarkerEnd($composer_0);
          HadayaAlertDialog(tmp_29, tmp_30, null, null, tmp13_group, tmp14_group, $composer_0, 196608, 12);
          $composer_0.n30();
        } else {
          $composer_0.m30(1513930900);
          $composer_0.n30();
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = fillMaxSize(Companion_instance);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_5 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_6 = $composer_5;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_6, 0).hashCode();
        var localMap = $composer_6.t31();
        var materialized = materialize($composer_6, modifier_0);
        var tmp0_7 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_7 = $composer_6;
        var tmp_33 = $composer_7.g30();
        if (!isInterface(tmp_33, Applier)) {
          invalidApplier();
        }
        $composer_7.b31();
        if ($composer_7.h30()) {
          $composer_7.c31(tmp0_7);
        } else {
          $composer_7.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_7);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_8 = $composer_7;
        var $composer_9 = $composer_8;
        sourceInformationMarkerStart($composer_9, -473539590, 'C701@39855L63,701@39799L119,729@40997L73,730@41100L28,731@41161L150,721@40640L685,751@42289L94:CartMagicMugProductDetailsScreen.kt#6ni00');
        if (!CartMagicMugProductDetailsScreen$lambda_1(state$delegate).h10z_1) {
          $composer_9.m30(-473667001);
          sourceInformation($composer_9, '177@8174L34,178@8251L31,172@7965L336,182@8365L21743,549@30314L11,552@30479L9293,547@30166L9606');
          var tmp0_modifier = alpha(BoxScopeInstance_instance.udr(fillMaxWidth(Companion_instance, 0.8), Companion_getInstance_11().o8t_1), 0.03);
          var tmp1_painter = painterResource(get_logo(drawable_instance), $composer_9, 0);
          var tmp2_contentDescription = stringResource(get_logo_0(string_instance), $composer_9, 0);
          Image(tmp1_painter, tmp2_contentDescription, tmp0_modifier, null, null, 0.0, null, $composer_9, androidx_compose_ui_graphics_painter_Painter$stableprop_getter(), 120);
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_1 = zIndex(verticalScroll(fillMaxSize(Companion_instance), verticalScrollState, !CartMagicMugProductDetailsScreen$lambda_1(state$delegate).a10z_1 && !CartMagicMugProductDetailsScreen$lambda_2(isInteractingWith3D$delegate)), 0.0);
          var verticalArrangement = null;
          var horizontalAlignment = null;
          var $composer_10 = $composer_9;
          if (!((6 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((6 & 2) === 0))
            verticalArrangement = Arrangement_getInstance().sdp_1;
          if (!((6 & 4) === 0))
            horizontalAlignment = Companion_getInstance_11().w8t_1;
          var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_10, 14 & 0 >> 3 | 112 & 0 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_11 = $composer_10;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_11, 0).hashCode();
          var localMap_0 = $composer_11.t31();
          var materialized_0 = materialize($composer_11, modifier_2);
          var tmp0_8 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_12 = $composer_11;
          var tmp_34 = $composer_12.g30();
          if (!isInterface(tmp_34, Applier)) {
            invalidApplier();
          }
          $composer_12.b31();
          if ($composer_12.h30()) {
            $composer_12.c31(tmp0_8);
          } else {
            $composer_12.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_12);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_13 = $composer_12;
          var $composer_14 = $composer_13;
          sourceInformationMarkerStart($composer_14, -2105796917, 'C194@8980L11,189@8695L6979,307@15696L41,312@15921L26,309@15759L210,316@16043L14047:CartMagicMugProductDetailsScreen.kt#6ni00');
          var tmp_35 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$102 = _Dp___init__impl__ms3zkb(400);
          var tmp_36 = height(tmp_35, tmp$ret$102);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp0_bottomStart = _Dp___init__impl__ms3zkb(32);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp1_bottomEnd = _Dp___init__impl__ms3zkb(32);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_3 = background(clip(tmp_36, RoundedCornerShape_0(VOID, VOID, tmp1_bottomEnd, tmp0_bottomStart)), Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_14, 6).oo0_1, 0.3));
          var contentAlignment_0 = null;
          var propagateMinConstraints_0 = false;
          var $composer_15 = $composer_14;
          if (!((6 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_0 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_0 = false;
          var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_16 = $composer_15;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_16, 0).hashCode();
          var localMap_1 = $composer_16.t31();
          var materialized_1 = materialize($composer_16, modifier_4);
          var tmp0_9 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_17 = $composer_16;
          var tmp_37 = $composer_17.g30();
          if (!isInterface(tmp_37, Applier)) {
            invalidApplier();
          }
          $composer_17.b31();
          if ($composer_17.h30()) {
            $composer_17.c31(tmp0_9);
          } else {
            $composer_17.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_17);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_18 = $composer_17;
          var $composer_19 = $composer_18;
          sourceInformationMarkerStart($composer_19, -619992914, 'C198@9200L402,197@9114L1604,226@10790L3097,282@14316L11,277@14014L27,285@14488L1164,276@13967L1685:CartMagicMugProductDetailsScreen.kt#6ni00');
          var tmp_38 = fillMaxSize(Companion_instance);
          sourceInformationMarkerStart($composer_19, 534186173, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_19 = $composer_19.i31();
          var tmp_39;
          if (false || it_19 === Companion_getInstance().f30_1) {
            var tmp_40 = CartMagicMugProductDetailsScreen$slambda_8(isInteractingWith3D$delegate, null);
            var value_19 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0(tmp_40);
            $composer_19.j31(value_19);
            tmp_39 = value_19;
          } else {
            tmp_39 = it_19;
          }
          var tmp0_group_1 = tmp_39;
          sourceInformationMarkerEnd($composer_19);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_5 = pointerInput(tmp_38, Unit_instance, tmp0_group_1);
          var contentAlignment_1 = null;
          var propagateMinConstraints_1 = false;
          var $composer_20 = $composer_19;
          if (!((6 & 1) === 0))
            modifier_5 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_1 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_1 = false;
          var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_6 = modifier_5;
          var $composer_21 = $composer_20;
          if (!((0 & 2) === 0))
            modifier_6 = Companion_instance;
          var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_21, 0).hashCode();
          var localMap_2 = $composer_21.t31();
          var materialized_2 = materialize($composer_21, modifier_6);
          var tmp0_10 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_22 = $composer_21;
          var tmp_41 = $composer_22.g30();
          if (!isInterface(tmp_41, Applier)) {
            invalidApplier();
          }
          $composer_22.b31();
          if ($composer_22.h30()) {
            $composer_22.c31(tmp0_10);
          } else {
            $composer_22.d31();
          }
          var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_22);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
          var $composer_23 = $composer_22;
          var $composer_24 = $composer_23;
          sourceInformationMarkerStart($composer_24, 890757417, 'C:CartMagicMugProductDetailsScreen.kt#6ni00');
          if (!CartMagicMugProductDetailsScreen$lambda_4(showFullScreen3D$delegate)) {
            $composer_24.m30(890779519);
            sourceInformation($composer_24, '214@10117L149,208@9716L946');
            var tmp_42 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).i10z_1;
            var tmp_43 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).j10z_1;
            var tmp_44 = ProductKind_MAGIC_MUG_getInstance();
            var tmp_45 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).e10z_1;
            var tmp_46 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).f10z_1;
            sourceInformationMarkerStart($composer_24, -109799450, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_9 = !!($composer_24.q31(viewModel) | $composer_24.q31(tmp0_safe_receiver));
            // Inline function 'kotlin.let' call
            var it_20 = $composer_24.i31();
            var tmp_47;
            if (invalid_9 || it_20 === Companion_getInstance().f30_1) {
              var value_20 = CartMagicMugProductDetailsScreen$lambda_22(viewModel, tmp0_safe_receiver);
              $composer_24.j31(value_20);
              tmp_47 = value_20;
            } else {
              tmp_47 = it_20;
            }
            var tmp0_group_2 = tmp_47;
            sourceInformationMarkerEnd($composer_24);
            Model3DViewerSection(tmp_42, tmp_43, tmp_44, tmp_45, tmp_46, tmp0_group_2, fillMaxSize(Companion_instance), !CartMagicMugProductDetailsScreen$lambda_14(showDiscardDialog$delegate) && !CartMagicMugProductDetailsScreen$lambda_8(showBirthdayPicker$delegate) && !CartMagicMugProductDetailsScreen$lambda_1(state$delegate).a10z_1 && !CartMagicMugProductDetailsScreen$lambda_1(state$delegate).h10z_1 && !CartMagicMugProductDetailsScreen$lambda_6(isMediaDialogOpen$delegate), _Dp___get_value__impl__geb1vb(topPadding_0._v.m5f_1), _Dp___get_value__impl__geb1vb(bottomPadding_0._v.m5f_1), $composer_24, 1573248, 0);
            $composer_24.n30();
          } else {
            $composer_24.m30(891750129);
            $composer_24.n30();
          }
          sourceInformationMarkerEnd($composer_24);
          $composer_22.e31();
          var tmp0_$receiver = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp1_top = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp2_start = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp3_end = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_7 = padding_1(tmp0_$receiver, tmp2_start, tmp1_top, tmp3_end);
          var horizontalArrangement = Arrangement_getInstance().wdp_1;
          var verticalAlignment = null;
          var $composer_25 = $composer_19;
          if (!((4 & 1) === 0))
            modifier_7 = Companion_instance;
          if (!((4 & 2) === 0))
            horizontalArrangement = Arrangement_getInstance().qdp_1;
          if (!((4 & 4) === 0))
            verticalAlignment = Companion_getInstance_11().t8t_1;
          var measurePolicy_3 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_25, 14 & 48 >> 3 | 112 & 48 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_8 = modifier_7;
          var $composer_26 = $composer_25;
          if (!((0 & 2) === 0))
            modifier_8 = Companion_instance;
          var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_26, 0).hashCode();
          var localMap_3 = $composer_26.t31();
          var materialized_3 = materialize($composer_26, modifier_8);
          var tmp0_11 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_27 = $composer_26;
          var tmp_48 = $composer_27.g30();
          if (!isInterface(tmp_48, Applier)) {
            invalidApplier();
          }
          $composer_27.b31();
          if ($composer_27.h30()) {
            $composer_27.c31(tmp0_11);
          } else {
            $composer_27.d31();
          }
          var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_27);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
          var $composer_28 = $composer_27;
          var $composer_29 = $composer_28;
          sourceInformationMarkerStart($composer_29, -760855310, 'C233@11158L333,241@11600L11,232@11107L946,249@12083L1778:CartMagicMugProductDetailsScreen.kt#6ni00');
          sourceInformationMarkerStart($composer_29, 806739484, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_10 = !!($composer_0.k31(state$delegate) | ($dirty & 112) === 32);
          // Inline function 'kotlin.let' call
          var it_21 = $composer_29.i31();
          var tmp_49;
          if (invalid_10 || it_21 === Companion_getInstance().f30_1) {
            var value_21 = CartMagicMugProductDetailsScreen$lambda_23(state$delegate, showDiscardDialog$delegate, onBack);
            $composer_29.j31(value_21);
            tmp_49 = value_21;
          } else {
            tmp_49 = it_21;
          }
          var tmp0_group_3 = tmp_49;
          sourceInformationMarkerEnd($composer_29);
          var tmp_50 = get_CircleShape();
          var tmp_51 = MaterialTheme_instance.unz($composer_29, 6).mo0_1;
          var tmp_52 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_53 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_54 = _Dp___init__impl__ms3zkb(4);
          Surface_0(tmp0_group_3, null, false, tmp_50, tmp_51, tmp_52, tmp_53, tmp_54, null, null, ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().b110_1, $composer_29, 12582912, 6, 870);
          var tmp_55 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$139 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_9 = null;
          var horizontalArrangement_0 = tmp_55.mdq(tmp$ret$139);
          var verticalAlignment_0 = null;
          var $composer_30 = $composer_29;
          if (!((5 & 1) === 0))
            modifier_9 = Companion_instance;
          if (!((5 & 2) === 0))
            horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
          if (!((5 & 4) === 0))
            verticalAlignment_0 = Companion_getInstance_11().t8t_1;
          var measurePolicy_4 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_30, 14 & 48 >> 3 | 112 & 48 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_10 = modifier_9;
          var $composer_31 = $composer_30;
          if (!((0 & 2) === 0))
            modifier_10 = Companion_instance;
          var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_31, 0).hashCode();
          var localMap_4 = $composer_31.t31();
          var materialized_4 = materialize($composer_31, modifier_10);
          var tmp0_12 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_32 = $composer_31;
          var tmp_56 = $composer_32.g30();
          if (!isInterface(tmp_56, Applier)) {
            invalidApplier();
          }
          $composer_32.b31();
          if ($composer_32.h30()) {
            $composer_32.c31(tmp0_12);
          } else {
            $composer_32.d31();
          }
          var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_32);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
          var $composer_33 = $composer_32;
          var $composer_34 = $composer_33;
          sourceInformationMarkerStart($composer_34, 1110338774, 'C251@12228L73,253@12418L11,255@12532L589,250@12173L948,263@13209L71,265@13397L11,262@13154L677:CartMagicMugProductDetailsScreen.kt#6ni00');
          sourceInformationMarkerStart($composer_34, 1421290876, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_11 = $composer_34.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_22 = $composer_34.i31();
          var tmp_57;
          if (invalid_11 || it_22 === Companion_getInstance().f30_1) {
            var value_22 = CartMagicMugProductDetailsScreen$lambda_24(viewModel);
            $composer_34.j31(value_22);
            tmp_57 = value_22;
          } else {
            tmp_57 = it_22;
          }
          var tmp0_group_4 = tmp_57;
          sourceInformationMarkerEnd($composer_34);
          var tmp_58 = get_CircleShape();
          var tmp_59 = MaterialTheme_instance.unz($composer_34, 6).mo0_1;
          var tmp_60 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_61 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_62 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-378221986, true, CartMagicMugProductDetailsScreen$lambda_25(state$delegate), $composer_34, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_35 = $composer_34;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_12 = $composer_35.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_23 = $composer_35.i31();
          var tmp_63;
          if (invalid_12 || it_23 === Companion_getInstance().f30_1) {
            var value_23 = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_35.j31(value_23);
            tmp_63 = value_23;
          } else {
            tmp_63 = it_23;
          }
          var tmp$ret$151 = tmp_63;
          Surface_0(tmp0_group_4, null, false, tmp_58, tmp_59, tmp_60, tmp_61, tmp_62, null, null, tmp$ret$151, $composer_34, 12582912, 6, 870);
          sourceInformationMarkerStart($composer_34, 1421322266, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_13 = $composer_34.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_24 = $composer_34.i31();
          var tmp_64;
          if (invalid_13 || it_24 === Companion_getInstance().f30_1) {
            var value_24 = CartMagicMugProductDetailsScreen$lambda_26(viewModel);
            $composer_34.j31(value_24);
            tmp_64 = value_24;
          } else {
            tmp_64 = it_24;
          }
          var tmp1_group_4 = tmp_64;
          sourceInformationMarkerEnd($composer_34);
          var tmp_65 = get_CircleShape();
          var tmp_66 = MaterialTheme_instance.unz($composer_34, 6).mo0_1;
          var tmp_67 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_68 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_69 = _Dp___init__impl__ms3zkb(4);
          Surface_0(tmp1_group_4, null, false, tmp_65, tmp_66, tmp_67, tmp_68, tmp_69, null, null, ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().d110_1, $composer_34, 12582912, 6, 870);
          sourceInformationMarkerEnd($composer_34);
          $composer_32.e31();
          sourceInformationMarkerEnd($composer_29);
          $composer_27.e31();
          var tmp4_$receiver = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().s8t_1);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp5_bottom = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp6_end = _Dp___init__impl__ms3zkb(16);
          var tmp7_modifier = zIndex(padding_1(tmp4_$receiver, VOID, VOID, tmp6_end, tmp5_bottom), 2.0);
          var tmp8_color = MaterialTheme_instance.unz($composer_19, 6).eo0_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$165 = _Dp___init__impl__ms3zkb(24);
          var tmp9_shape = RoundedCornerShape(tmp$ret$165);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp10_shadowElevation = _Dp___init__impl__ms3zkb(6);
          sourceInformationMarkerStart($composer_19, 534339846, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_25 = $composer_19.i31();
          var tmp_70;
          if (false || it_25 === Companion_getInstance().f30_1) {
            var value_25 = CartMagicMugProductDetailsScreen$lambda_27(showFullScreen3D$delegate);
            $composer_19.j31(value_25);
            tmp_70 = value_25;
          } else {
            tmp_70 = it_25;
          }
          var tmp1_group_5 = tmp_70;
          sourceInformationMarkerEnd($composer_19);
          var tmp_71 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_72 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_0 = rememberComposableLambda(531353878, true, CartMagicMugProductDetailsScreen$lambda_28(language), $composer_19, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_36 = $composer_19;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_14 = $composer_36.k31(dispatchReceiver_0);
          // Inline function 'kotlin.let' call
          var it_26 = $composer_36.i31();
          var tmp_73;
          if (invalid_14 || it_26 === Companion_getInstance().f30_1) {
            var value_26 = ComposableLambda$invoke$ref(dispatchReceiver_0);
            $composer_36.j31(value_26);
            tmp_73 = value_26;
          } else {
            tmp_73 = it_26;
          }
          var tmp$ret$171 = tmp_73;
          Surface_0(tmp1_group_5, tmp7_modifier, false, tmp9_shape, tmp8_color, tmp_71, tmp_72, tmp10_shadowElevation, null, null, tmp$ret$171, $composer_19, 12582918, 6, 868);
          sourceInformationMarkerEnd($composer_19);
          $composer_17.e31();
          var tmp_74 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$178 = _Dp___init__impl__ms3zkb(24);
          Spacer(height(tmp_74, tmp$ret$178), $composer_14, 6);
          sourceInformationMarkerStart($composer_14, 902112255, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_27 = $composer_14.i31();
          var tmp_75;
          if (false || it_27 === Companion_getInstance().f30_1) {
            var value_27 = CartMagicMugProductDetailsScreen$lambda_29(isMediaDialogOpen$delegate);
            $composer_14.j31(value_27);
            tmp_75 = value_27;
          } else {
            tmp_75 = it_27;
          }
          var tmp0_group_5 = tmp_75;
          sourceInformationMarkerEnd($composer_14);
          ProductMediaGallerySection(tmp0_safe_receiver, language, tmp0_group_5, $composer_14, 384, 0);
          var tmp_76 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$183 = _Dp___init__impl__ms3zkb(24);
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_11 = padding_2(tmp_76, tmp$ret$183);
          var verticalArrangement_0 = null;
          var horizontalAlignment_0 = null;
          var $composer_37 = $composer_14;
          if (!((6 & 1) === 0))
            modifier_11 = Companion_instance;
          if (!((6 & 2) === 0))
            verticalArrangement_0 = Arrangement_getInstance().sdp_1;
          if (!((6 & 4) === 0))
            horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
          var measurePolicy_5 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_37, 14 & 6 >> 3 | 112 & 6 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_12 = modifier_11;
          var $composer_38 = $composer_37;
          if (!((0 & 2) === 0))
            modifier_12 = Companion_instance;
          var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_38, 0).hashCode();
          var localMap_5 = $composer_38.t31();
          var materialized_5 = materialize($composer_38, modifier_12);
          var tmp0_13 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_39 = $composer_38;
          var tmp_77 = $composer_39.g30();
          if (!isInterface(tmp_77, Applier)) {
            invalidApplier();
          }
          $composer_39.b31();
          if ($composer_39.h30()) {
            $composer_39.c31(tmp0_13);
          } else {
            $composer_39.d31();
          }
          var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_39);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
          var $composer_40 = $composer_39;
          var $composer_41 = $composer_40;
          sourceInformationMarkerStart($composer_41, 845916113, 'C319@16222L10,321@16362L11,317@16125L287,324@16438L41,327@16540L2388,359@18954L41,361@19122L10,361@19021L122,363@19169L41,509@28255L41,513@28443L106,511@28322L480,519@28828L41,521@28919L182,527@29127L41,530@29232L701,540@29959L41,542@30026L42:CartMagicMugProductDetailsScreen.kt#6ni00');
          var tmp0_style = MaterialTheme_instance.jog($composer_41, 6).jof_1;
          var tmp1_fontWeight = Companion_getInstance_16().f7z_1;
          var tmp2_color = MaterialTheme_instance.unz($composer_41, 6).lo0_1;
          var tmp_78 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_79 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_80 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_81 = _TextOverflow___init__impl__obguoe(0);
          Text(name, null, tmp2_color, null, tmp_78, null, tmp1_fontWeight, null, tmp_79, null, null, tmp_80, tmp_81, false, 0, 0, null, tmp0_style, $composer_41, 1572864, 0, 131002);
          var tmp_82 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$190 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_82, tmp$ret$190), $composer_41, 6);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_13 = fillMaxWidth(Companion_instance);
          var horizontalArrangement_1 = Arrangement_getInstance().wdp_1;
          var verticalAlignment_1 = Companion_getInstance_11().u8t_1;
          var $composer_42 = $composer_41;
          if (!((0 & 1) === 0))
            modifier_13 = Companion_instance;
          if (!((0 & 2) === 0))
            horizontalArrangement_1 = Arrangement_getInstance().qdp_1;
          if (!((0 & 4) === 0))
            verticalAlignment_1 = Companion_getInstance_11().t8t_1;
          var measurePolicy_6 = rowMeasurePolicy(horizontalArrangement_1, verticalAlignment_1, $composer_42, 14 & 438 >> 3 | 112 & 438 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_14 = modifier_13;
          var $composer_43 = $composer_42;
          if (!((0 & 2) === 0))
            modifier_14 = Companion_instance;
          var compositeKeyHash_6 = get_currentCompositeKeyHashCode($composer_43, 0).hashCode();
          var localMap_6 = $composer_43.t31();
          var materialized_6 = materialize($composer_43, modifier_14);
          var tmp0_14 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_44 = $composer_43;
          var tmp_83 = $composer_44.g30();
          if (!isInterface(tmp_83, Applier)) {
            invalidApplier();
          }
          $composer_44.b31();
          if ($composer_44.h30()) {
            $composer_44.c31(tmp0_14);
          } else {
            $composer_44.d31();
          }
          var $this$ReusableComposeNode_6 = _Updater___init__impl__rbfxm8($composer_44);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, measurePolicy_6, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, localMap_6, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, compositeKeyHash_6, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_6, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, materialized_6, Companion_getInstance_12().qah_1);
          var $composer_45 = $composer_44;
          var $composer_46 = $composer_45;
          sourceInformationMarkerStart($composer_46, -649657248, 'C332@16818L2084:CartMagicMugProductDetailsScreen.kt#6ni00');
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_15 = null;
          var verticalArrangement_1 = null;
          var horizontalAlignment_1 = null;
          var $composer_47 = $composer_46;
          if (!((7 & 1) === 0))
            modifier_15 = Companion_instance;
          if (!((7 & 2) === 0))
            verticalArrangement_1 = Arrangement_getInstance().sdp_1;
          if (!((7 & 4) === 0))
            horizontalAlignment_1 = Companion_getInstance_11().w8t_1;
          var measurePolicy_7 = columnMeasurePolicy(verticalArrangement_1, horizontalAlignment_1, $composer_47, 14 & 0 >> 3 | 112 & 0 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_16 = modifier_15;
          var $composer_48 = $composer_47;
          if (!((0 & 2) === 0))
            modifier_16 = Companion_instance;
          var compositeKeyHash_7 = get_currentCompositeKeyHashCode($composer_48, 0).hashCode();
          var localMap_7 = $composer_48.t31();
          var materialized_7 = materialize($composer_48, modifier_16);
          var tmp0_15 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_49 = $composer_48;
          var tmp_84 = $composer_49.g30();
          if (!isInterface(tmp_84, Applier)) {
            invalidApplier();
          }
          $composer_49.b31();
          if ($composer_49.h30()) {
            $composer_49.c31(tmp0_15);
          } else {
            $composer_49.d31();
          }
          var $this$ReusableComposeNode_7 = _Updater___init__impl__rbfxm8($composer_49);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, measurePolicy_7, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, localMap_7, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, compositeKeyHash_7, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_7, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, materialized_7, Companion_getInstance_12().qah_1);
          var $composer_50 = $composer_49;
          var $composer_51 = $composer_50;
          sourceInformationMarkerStart($composer_51, 1079086737, 'C:CartMagicMugProductDetailsScreen.kt#6ni00');
          var tmp0_safe_receiver_0 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).m10z_1;
          var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.lyz_1;
          var tmp_85 = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
          var tmp2_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).q10z_1;
          var tmp3_elvis_lhs_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.wyz_1;
          var tmp_86 = tmp_85 + (tmp3_elvis_lhs_0 == null ? 0.0 : tmp3_elvis_lhs_0);
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0;
          var _iterator__ex2g4s = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).w10z_1.y2().t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            var tmp_87 = sum;
            var tmp0_elvis_lhs_1 = element.q100_1;
            sum = tmp_87 + (tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1);
          }
          var extraOriginalPrice = tmp_86 + sum;
          var tmp4_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).m10z_1;
          var tmp5_elvis_lhs_0 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.lyz_1;
          var tmp_88 = tmp5_elvis_lhs_0 == null ? 0.0 : tmp5_elvis_lhs_0;
          var tmp6_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).q10z_1;
          var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.wyz_1;
          var tmp_89 = tmp_88 + (tmp7_elvis_lhs == null ? 0.0 : tmp7_elvis_lhs);
          // Inline function 'kotlin.collections.sumOf' call
          var sum_0 = 0;
          var _iterator__ex2g4s_0 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).w10z_1.y2().t();
          while (_iterator__ex2g4s_0.u()) {
            var element_0 = _iterator__ex2g4s_0.v();
            var tmp_90 = sum_0;
            var tmp_91;
            var tmp0_elvis_lhs_2 = element_0.r100_1;
            if ((tmp0_elvis_lhs_2 == null ? 0.0 : tmp0_elvis_lhs_2) > 0.0) {
              tmp_91 = ensureNotNull(element_0.r100_1);
            } else {
              var tmp1_elvis_lhs_1 = element_0.q100_1;
              tmp_91 = tmp1_elvis_lhs_1 == null ? 0.0 : tmp1_elvis_lhs_1;
            }
            sum_0 = tmp_90 + tmp_91;
          }
          var extraDiscountedPrice = tmp_89 + sum_0;
          var tmp8_elvis_lhs = tmp0_safe_receiver.szt_1;
          var finalOriginalPrice = (tmp8_elvis_lhs == null ? 0.0 : tmp8_elvis_lhs) + extraOriginalPrice;
          var tmp_92;
          var tmp9_elvis_lhs = tmp0_safe_receiver.tzt_1;
          if ((tmp9_elvis_lhs == null ? 0.0 : tmp9_elvis_lhs) > 0.0) {
            tmp_92 = ensureNotNull(tmp0_safe_receiver.tzt_1);
          } else {
            var tmp10_elvis_lhs = tmp0_safe_receiver.szt_1;
            tmp_92 = tmp10_elvis_lhs == null ? 0.0 : tmp10_elvis_lhs;
          }
          var finalDiscountedPrice = tmp_92 + extraDiscountedPrice;
          var tmp_93;
          var tmp11_elvis_lhs = tmp0_safe_receiver.tzt_1;
          if ((tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs) > 0.0) {
            tmp_93 = true;
          } else {
            var tmp0_16 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).w10z_1.y2();
            var tmp$ret$207;
            $l$block_0: {
              // Inline function 'kotlin.collections.any' call
              var tmp_94;
              if (isInterface(tmp0_16, Collection)) {
                tmp_94 = tmp0_16.r();
              } else {
                tmp_94 = false;
              }
              if (tmp_94) {
                tmp$ret$207 = false;
                break $l$block_0;
              }
              var _iterator__ex2g4s_1 = tmp0_16.t();
              while (_iterator__ex2g4s_1.u()) {
                var element_1 = _iterator__ex2g4s_1.v();
                var tmp0_elvis_lhs_3 = element_1.r100_1;
                if ((tmp0_elvis_lhs_3 == null ? 0.0 : tmp0_elvis_lhs_3) > 0.0) {
                  tmp$ret$207 = true;
                  break $l$block_0;
                }
              }
              tmp$ret$207 = false;
            }
            tmp_93 = tmp$ret$207;
          }
          var hasDiscount = tmp_93;
          if (hasDiscount) {
            $composer_51.m30(1079870943);
            sourceInformation($composer_51, '343@17779L79,344@17964L11,342@17726L326,347@18142L77,348@18325L11,346@18089L347');
            var tmp12_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalDiscountedPrice)], $composer_51, 0), language);
            var tmp13_fontSize = get_sp(28);
            var tmp14_color = MaterialTheme_instance.unz($composer_51, 6).xnz_1;
            var tmp15_fontWeight = Companion_getInstance_16().g7z_1;
            var tmp_95 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_96 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_97 = _TextOverflow___init__impl__obguoe(0);
            Text(tmp12_text, null, tmp14_color, null, tmp13_fontSize, null, tmp15_fontWeight, null, tmp_95, null, null, tmp_96, tmp_97, false, 0, 0, null, null, $composer_51, 1597440, 0, 262058);
            var tmp16_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_51, 0), language);
            var tmp17_fontSize = get_sp(18);
            var tmp18_color = MaterialTheme_instance.unz($composer_51, 6).po0_1;
            var tmp19_textDecoration = Companion_getInstance_18().c80_1;
            var tmp_98 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_99 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_100 = _TextOverflow___init__impl__obguoe(0);
            Text(tmp16_text, null, tmp18_color, null, tmp17_fontSize, null, null, null, tmp_98, tmp19_textDecoration, null, tmp_99, tmp_100, false, 0, 0, null, null, $composer_51, 805330944, 0, 261610);
            $composer_51.n30();
          } else {
            $composer_51.m30(1080676137);
            sourceInformation($composer_51, '352@18567L77,353@18750L11,351@18514L324');
            var tmp20_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_51, 0), language);
            var tmp21_fontSize = get_sp(28);
            var tmp22_color = MaterialTheme_instance.unz($composer_51, 6).xnz_1;
            var tmp23_fontWeight = Companion_getInstance_16().g7z_1;
            var tmp_101 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_102 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_103 = _TextOverflow___init__impl__obguoe(0);
            Text(tmp20_text, null, tmp22_color, null, tmp21_fontSize, null, tmp23_fontWeight, null, tmp_101, null, null, tmp_102, tmp_103, false, 0, 0, null, null, $composer_51, 1597440, 0, 262058);
            $composer_51.n30();
          }
          sourceInformationMarkerEnd($composer_51);
          $composer_49.e31();
          sourceInformationMarkerEnd($composer_46);
          $composer_44.e31();
          var tmp_104 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$209 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_104, tmp$ret$209), $composer_41, 6);
          $composer_41.m30(1689935152);
          sourceInformation($composer_41, '*361@19055L41');
          // Inline function 'kotlin.text.ifBlank' call
          var tmp_105;
          if (isBlank(description)) {
            tmp_105 = stringResource(get_no_description(string_instance), $composer_41, 0);
          } else {
            tmp_105 = description;
          }
          var tmp0_group_6 = tmp_105;
          $composer_41.n30();
          var tmp_106 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_107 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_108 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_109 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_110 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_group_6, null, tmp_106, null, tmp_107, null, null, null, tmp_108, null, null, tmp_109, tmp_110, false, 0, 0, null, MaterialTheme_instance.jog($composer_41, 6).oof_1, $composer_41, 0, 0, 131070);
          var tmp_111 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$212 = _Dp___init__impl__ms3zkb(24);
          Spacer(height(tmp_111, tmp$ret$212), $composer_41, 6);
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!CartMagicMugProductDetailsScreen$lambda_1(state$delegate).y10z_1.r()) {
            $composer_41.m30(848768639);
            sourceInformation($composer_41, '368@19438L38,371@19671L118,367@19376L544');
            var tmp_112 = stringResource(get_select_card(string_instance), $composer_41, 0);
            var tmp_113 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).y10z_1;
            var tmp3_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).m10z_1;
            var tmp_114 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.gyz_1;
            sourceInformationMarkerStart($composer_41, 1689955249, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_15 = $composer_41.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_28 = $composer_41.i31();
            var tmp_115;
            if (invalid_15 || it_28 === Companion_getInstance().f30_1) {
              var value_28 = CartMagicMugProductDetailsScreen$lambda_30(viewModel);
              $composer_41.j31(value_28);
              tmp_115 = value_28;
            } else {
              tmp_115 = it_28;
            }
            var tmp1_group_6 = tmp_115;
            sourceInformationMarkerEnd($composer_41);
            GiftSelectionSection(tmp_112, tmp_113, tmp_114, tmp1_group_6, language, true, $composer_41, 196608, 0);
            var tmp7_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).m10z_1;
            if ((tmp7_safe_receiver == null ? null : tmp7_safe_receiver.oyz_1) === true) {
              $composer_41.m30(849385911);
              sourceInformation($composer_41, '378@20160L102,382@20581L451,376@20026L1040');
              var tmp4_value = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).n10z_1;
              var tmp_116 = fillMaxWidth(Companion_instance);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$218 = _Dp___init__impl__ms3zkb(8);
              var tmp5_modifier = padding_1(tmp_116, VOID, tmp$ret$218);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$219 = _Dp___init__impl__ms3zkb(12);
              var tmp6_shape = RoundedCornerShape(tmp$ret$219);
              sourceInformationMarkerStart($composer_41, 1689970881, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_16 = $composer_41.q31(viewModel);
              // Inline function 'kotlin.let' call
              var it_29 = $composer_41.i31();
              var tmp_117;
              if (invalid_16 || it_29 === Companion_getInstance().f30_1) {
                var value_29 = CartMagicMugProductDetailsScreen$lambda_31(viewModel);
                $composer_41.j31(value_29);
                tmp_117 = value_29;
              } else {
                tmp_117 = it_29;
              }
              var tmp2_group_0 = tmp_117;
              sourceInformationMarkerEnd($composer_41);
              var tmp_118 = ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().e110_1;
              // Inline function 'kotlin.run' call
              var dispatchReceiver_1 = rememberComposableLambda(992088344, true, CartMagicMugProductDetailsScreen$lambda_32(state$delegate), $composer_41, 54);
              // Inline function 'androidx.compose.runtime.remember' call
              var $composer_52 = $composer_41;
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_17 = $composer_52.k31(dispatchReceiver_1);
              // Inline function 'kotlin.let' call
              var it_30 = $composer_52.i31();
              var tmp_119;
              if (invalid_17 || it_30 === Companion_getInstance().f30_1) {
                var value_30 = ComposableLambda$invoke$ref(dispatchReceiver_1);
                $composer_52.j31(value_30);
                tmp_119 = value_30;
              } else {
                tmp_119 = it_30;
              }
              var tmp_120 = tmp_119;
              OutlinedTextField(tmp4_value, tmp2_group_0, tmp5_modifier, false, false, null, tmp_118, null, null, null, null, null, tmp_120, false, null, null, null, false, 0, 0, null, tmp6_shape, null, $composer_41, 1573248, 384, 0, 6287288);
              $composer_41.n30();
            } else {
              $composer_41.m30(850415111);
              $composer_41.n30();
            }
            var tmp11_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).m10z_1;
            if ((tmp11_safe_receiver == null ? null : tmp11_safe_receiver.pyz_1) === true) {
              $composer_41.m30(850551480);
              sourceInformation($composer_41, '398@21598L176,395@21338L2,403@21898L246,393@21203L975');
              var tmp8_value = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).o10z_1;
              var tmp_121 = fillMaxWidth(Companion_instance);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$231 = _Dp___init__impl__ms3zkb(8);
              var tmp_122 = padding_1(tmp_121, VOID, tmp$ret$231);
              sourceInformationMarkerStart($composer_41, 1690016971, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              // Inline function 'kotlin.let' call
              var it_31 = $composer_41.i31();
              var tmp_123;
              if (false || it_31 === Companion_getInstance().f30_1) {
                var value_31 = CartMagicMugProductDetailsScreen$lambda_33(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
                $composer_41.j31(value_31);
                tmp_123 = value_31;
              } else {
                tmp_123 = it_31;
              }
              var tmp3_group_0 = tmp_123;
              sourceInformationMarkerEnd($composer_41);
              var tmp9_modifier = clickable(tmp_122, VOID, VOID, VOID, VOID, tmp3_group_0);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$236 = _Dp___init__impl__ms3zkb(12);
              var tmp10_shape = RoundedCornerShape(tmp$ret$236);
              sourceInformationMarkerStart($composer_41, 1690008477, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              // Inline function 'kotlin.let' call
              var it_32 = $composer_41.i31();
              var tmp_124;
              if (false || it_32 === Companion_getInstance().f30_1) {
                var value_32 = CartMagicMugProductDetailsScreen$lambda_34;
                $composer_41.j31(value_32);
                tmp_124 = value_32;
              } else {
                tmp_124 = it_32;
              }
              var tmp4_group_0 = tmp_124;
              sourceInformationMarkerEnd($composer_41);
              var tmp_125 = ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().f110_1;
              // Inline function 'kotlin.run' call
              var dispatchReceiver_2 = rememberComposableLambda(-1655760417, true, CartMagicMugProductDetailsScreen$lambda_35(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_41, 54);
              // Inline function 'androidx.compose.runtime.remember' call
              var $composer_53 = $composer_41;
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_18 = $composer_53.k31(dispatchReceiver_2);
              // Inline function 'kotlin.let' call
              var it_33 = $composer_53.i31();
              var tmp_126;
              if (invalid_18 || it_33 === Companion_getInstance().f30_1) {
                var value_33 = ComposableLambda$invoke$ref(dispatchReceiver_2);
                $composer_53.j31(value_33);
                tmp_126 = value_33;
              } else {
                tmp_126 = it_33;
              }
              var tmp_127 = tmp_126;
              OutlinedTextField(tmp8_value, tmp4_group_0, tmp9_modifier, false, true, null, tmp_125, null, null, tmp_127, null, null, null, false, null, null, null, false, 0, 0, null, tmp10_shape, null, $composer_41, 806903856, 0, 0, 6290856);
              $composer_41.n30();
            } else {
              $composer_41.m30(851518215);
              $composer_41.n30();
            }
            $composer_41.n30();
          } else {
            $composer_41.m30(851544007);
            $composer_41.n30();
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!CartMagicMugProductDetailsScreen$lambda_1(state$delegate).z10z_1.r()) {
            $composer_41.m30(851699844);
            sourceInformation($composer_41, '413@22391L37,416@22622L116,412@22329L540');
            var tmp_128 = stringResource(get_select_box(string_instance), $composer_41, 0);
            var tmp_129 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).z10z_1;
            var tmp12_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).q10z_1;
            var tmp_130 = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.ryz_1;
            sourceInformationMarkerStart($composer_41, 1690049679, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_19 = $composer_41.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_34 = $composer_41.i31();
            var tmp_131;
            if (invalid_19 || it_34 === Companion_getInstance().f30_1) {
              var value_34 = CartMagicMugProductDetailsScreen$lambda_36(viewModel);
              $composer_41.j31(value_34);
              tmp_131 = value_34;
            } else {
              tmp_131 = it_34;
            }
            var tmp5_group_0 = tmp_131;
            sourceInformationMarkerEnd($composer_41);
            GiftSelectionSection(tmp_128, tmp_129, tmp_130, tmp5_group_0, language, true, $composer_41, 196608, 0);
            var tmp16_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).q10z_1;
            if ((tmp16_safe_receiver == null ? null : tmp16_safe_receiver.zyz_1) === true) {
              $composer_41.m30(852311226);
              sourceInformation($composer_41, '424@23108L101,428@23528L450,422@22975L1037');
              var tmp13_value = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).r10z_1;
              var tmp_132 = fillMaxWidth(Companion_instance);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$253 = _Dp___init__impl__ms3zkb(8);
              var tmp14_modifier = padding_1(tmp_132, VOID, tmp$ret$253);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$254 = _Dp___init__impl__ms3zkb(12);
              var tmp15_shape = RoundedCornerShape(tmp$ret$254);
              sourceInformationMarkerStart($composer_41, 1690065216, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_20 = $composer_41.q31(viewModel);
              // Inline function 'kotlin.let' call
              var it_35 = $composer_41.i31();
              var tmp_133;
              if (invalid_20 || it_35 === Companion_getInstance().f30_1) {
                var value_35 = CartMagicMugProductDetailsScreen$lambda_37(viewModel);
                $composer_41.j31(value_35);
                tmp_133 = value_35;
              } else {
                tmp_133 = it_35;
              }
              var tmp6_group_0 = tmp_133;
              sourceInformationMarkerEnd($composer_41);
              var tmp_134 = ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().h110_1;
              // Inline function 'kotlin.run' call
              var dispatchReceiver_3 = rememberComposableLambda(-266453617, true, CartMagicMugProductDetailsScreen$lambda_38(state$delegate), $composer_41, 54);
              // Inline function 'androidx.compose.runtime.remember' call
              var $composer_54 = $composer_41;
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_21 = $composer_54.k31(dispatchReceiver_3);
              // Inline function 'kotlin.let' call
              var it_36 = $composer_54.i31();
              var tmp_135;
              if (invalid_21 || it_36 === Companion_getInstance().f30_1) {
                var value_36 = ComposableLambda$invoke$ref(dispatchReceiver_3);
                $composer_54.j31(value_36);
                tmp_135 = value_36;
              } else {
                tmp_135 = it_36;
              }
              var tmp_136 = tmp_135;
              OutlinedTextField(tmp13_value, tmp6_group_0, tmp14_modifier, false, false, null, tmp_134, null, null, null, null, null, tmp_136, false, null, null, null, false, 0, 0, null, tmp15_shape, null, $composer_41, 1573248, 384, 0, 6287288);
              $composer_41.n30();
            } else {
              $composer_41.m30(853337543);
              $composer_41.n30();
            }
            var tmp21_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).q10z_1;
            if ((tmp21_safe_receiver == null ? null : tmp21_safe_receiver.az0_1) === true) {
              $composer_41.m30(853474997);
              sourceInformation($composer_41, '444@24542L175,441@24282L2,450@24911L245,439@24148L1042');
              var tmp17_value = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).s10z_1;
              var tmp_137 = fillMaxWidth(Companion_instance);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$266 = _Dp___init__impl__ms3zkb(8);
              var tmp_138 = padding_1(tmp_137, VOID, tmp$ret$266);
              sourceInformationMarkerStart($composer_41, 1690111178, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              // Inline function 'kotlin.let' call
              var it_37 = $composer_41.i31();
              var tmp_139;
              if (false || it_37 === Companion_getInstance().f30_1) {
                var value_37 = CartMagicMugProductDetailsScreen$lambda_39(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
                $composer_41.j31(value_37);
                tmp_139 = value_37;
              } else {
                tmp_139 = it_37;
              }
              var tmp7_group_0 = tmp_139;
              sourceInformationMarkerEnd($composer_41);
              var tmp18_modifier = clickable(tmp_138, VOID, VOID, VOID, VOID, tmp7_group_0);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$271 = _Dp___init__impl__ms3zkb(12);
              var tmp19_shape = RoundedCornerShape(tmp$ret$271);
              var tmp20_isError = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).t10z_1;
              sourceInformationMarkerStart($composer_41, 1690102685, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              // Inline function 'kotlin.let' call
              var it_38 = $composer_41.i31();
              var tmp_140;
              if (false || it_38 === Companion_getInstance().f30_1) {
                var value_38 = CartMagicMugProductDetailsScreen$lambda_40;
                $composer_41.j31(value_38);
                tmp_140 = value_38;
              } else {
                tmp_140 = it_38;
              }
              var tmp8_group_0 = tmp_140;
              sourceInformationMarkerEnd($composer_41);
              var tmp_141 = ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().i110_1;
              // Inline function 'kotlin.run' call
              var dispatchReceiver_4 = rememberComposableLambda(2066493590, true, CartMagicMugProductDetailsScreen$lambda_41(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_41, 54);
              // Inline function 'androidx.compose.runtime.remember' call
              var $composer_55 = $composer_41;
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_22 = $composer_55.k31(dispatchReceiver_4);
              // Inline function 'kotlin.let' call
              var it_39 = $composer_55.i31();
              var tmp_142;
              if (invalid_22 || it_39 === Companion_getInstance().f30_1) {
                var value_39 = ComposableLambda$invoke$ref(dispatchReceiver_4);
                $composer_55.j31(value_39);
                tmp_142 = value_39;
              } else {
                tmp_142 = it_39;
              }
              var tmp_143 = tmp_142;
              OutlinedTextField(tmp17_value, tmp8_group_0, tmp18_modifier, false, true, null, tmp_141, null, null, tmp_143, null, null, null, tmp20_isError, null, null, null, false, 0, 0, null, tmp19_shape, null, $composer_41, 806903856, 0, 0, 6282664);
              $composer_41.n30();
            } else {
              $composer_41.m30(854506119);
              $composer_41.n30();
            }
            $composer_41.n30();
          } else {
            $composer_41.m30(854531911);
            $composer_41.n30();
          }
          // Inline function 'kotlin.collections.isNullOrEmpty' call
          var this_10 = tmp0_safe_receiver.lzu_1;
          if (!(this_10 == null || this_10.r())) {
            $composer_41.m30(854604110);
            sourceInformation($composer_41, '460@25396L38,463@25607L75,459@25332L481');
            var tmp_144 = stringResource(get_select_size(string_instance), $composer_41, 0);
            var tmp_145 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).u10z_1;
            sourceInformationMarkerStart($composer_41, 1690145158, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_23 = $composer_41.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_40 = $composer_41.i31();
            var tmp_146;
            if (invalid_23 || it_40 === Companion_getInstance().f30_1) {
              var value_40 = CartMagicMugProductDetailsScreen$lambda_42(viewModel);
              $composer_41.j31(value_40);
              tmp_146 = value_40;
            } else {
              tmp_146 = it_40;
            }
            var tmp9_group_0 = tmp_146;
            sourceInformationMarkerEnd($composer_41);
            OptionSelectionSection(tmp_144, tmp0_safe_receiver.lzu_1, tmp_145, tmp9_group_0, language, true, $composer_41, 196608, 0);
            $composer_41.n30();
          } else {
            $composer_41.m30(855120167);
            $composer_41.n30();
          }
          // Inline function 'kotlin.collections.isNullOrEmpty' call
          var this_11 = tmp0_safe_receiver.mzu_1;
          if (!(this_11 == null || this_11.r())) {
            $composer_41.m30(855193482);
            sourceInformation($composer_41, '471@25990L39,474@26204L76,470@25926L485');
            var tmp_147 = stringResource(get_select_color(string_instance), $composer_41, 0);
            var tmp_148 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).v10z_1;
            sourceInformationMarkerStart($composer_41, 1690164263, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_24 = $composer_41.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_41 = $composer_41.i31();
            var tmp_149;
            if (invalid_24 || it_41 === Companion_getInstance().f30_1) {
              var value_41 = CartMagicMugProductDetailsScreen$lambda_43(viewModel);
              $composer_41.j31(value_41);
              tmp_149 = value_41;
            } else {
              tmp_149 = it_41;
            }
            var tmp10_group_0 = tmp_149;
            sourceInformationMarkerEnd($composer_41);
            OptionSelectionSection(tmp_147, tmp0_safe_receiver.mzu_1, tmp_148, tmp10_group_0, language, true, $composer_41, 196608, 0);
            $composer_41.n30();
          } else {
            $composer_41.m30(855713383);
            $composer_41.n30();
          }
          var tmp22_safe_receiver = tmp0_safe_receiver.nzu_1;
          if (tmp22_safe_receiver == null) {
            $composer_41.m30(855814101);
            $composer_41.n30();
          } else {
            $composer_41.m30(855814102);
            sourceInformation($composer_41, '*484@26740L101,481@26532L440');
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s_2 = tmp22_safe_receiver.t();
            while (_iterator__ex2g4s_2.u()) {
              var element_2 = _iterator__ex2g4s_2.v();
              var tmp_150 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).w10z_1.w2(element_2.r101_1);
              sourceInformationMarkerStart($composer_41, -2024717490, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_25 = !!($composer_41.q31(viewModel) | $composer_41.q31(element_2));
              // Inline function 'kotlin.let' call
              var it_42 = $composer_41.i31();
              var tmp_151;
              if (invalid_25 || it_42 === Companion_getInstance().f30_1) {
                var value_42 = CartMagicMugProductDetailsScreen$lambda_44(viewModel, element_2);
                $composer_41.j31(value_42);
                tmp_151 = value_42;
              } else {
                tmp_151 = it_42;
              }
              var tmp0_group_7 = tmp_151;
              sourceInformationMarkerEnd($composer_41);
              OptionSelectionSection_0(element_2, tmp_150, tmp0_group_7, language, true, $composer_41, 24576, 0);
              var tmp0_safe_receiver_1 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).w10z_1.w2(element_2.r101_1);
              if (tmp0_safe_receiver_1 == null) {
                $composer_41.m30(1658593929);
                $composer_41.n30();
              } else {
                $composer_41.m30(1658593930);
                sourceInformation($composer_41, '');
                // Inline function 'kotlin.let' call
                if (tmp0_safe_receiver_1.w100_1 || tmp0_safe_receiver_1.z100_1 || tmp0_safe_receiver_1.c101_1) {
                  $composer_41.m30(-1395417923);
                  sourceInformation($composer_41, '494@27495L285,499@27845L200,490@27214L925');
                  sourceInformationMarkerStart($composer_41, -1707571971, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
                  // Inline function 'androidx.compose.runtime.cache' call
                  var invalid_26 = !!($composer_41.q31(viewModel) | $composer_41.q31(element_2));
                  // Inline function 'kotlin.let' call
                  var it_43 = $composer_41.i31();
                  var tmp_152;
                  if (invalid_26 || it_43 === Companion_getInstance().f30_1) {
                    var value_43 = CartMagicMugProductDetailsScreen$lambda_45(viewModel, element_2);
                    $composer_41.j31(value_43);
                    tmp_152 = value_43;
                  } else {
                    tmp_152 = it_43;
                  }
                  var tmp0_group_8 = tmp_152;
                  sourceInformationMarkerEnd($composer_41);
                  sourceInformationMarkerStart($composer_41, -1707560856, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
                  // Inline function 'androidx.compose.runtime.cache' call
                  var invalid_27 = $composer_41.q31(element_2);
                  // Inline function 'kotlin.let' call
                  var it_44 = $composer_41.i31();
                  var tmp_153;
                  if (invalid_27 || it_44 === Companion_getInstance().f30_1) {
                    var value_44 = CartMagicMugProductDetailsScreen$lambda_46(birthdayPickerTargetOptionKey$delegate, element_2, showBirthdayPicker$delegate);
                    $composer_41.j31(value_44);
                    tmp_153 = value_44;
                  } else {
                    tmp_153 = it_44;
                  }
                  var tmp1_group_7 = tmp_153;
                  sourceInformationMarkerEnd($composer_41);
                  SelectedOptionExtraInputs(element_2.r101_1, tmp0_safe_receiver_1, language, tmp0_group_8, tmp1_group_7, true, $composer_41, 196608, 0);
                  $composer_41.n30();
                } else {
                  $composer_41.m30(-1394459806);
                  $composer_41.n30();
                }
                $composer_41.n30();
              }
            }
            $composer_41.n30();
          }
          var tmp_154 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$309 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_154, tmp$ret$309), $composer_41, 6);
          var tmp23_value = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).x10z_1;
          var tmp24_modifier = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$310 = _Dp___init__impl__ms3zkb(12);
          var tmp25_shape = RoundedCornerShape(tmp$ret$310);
          sourceInformationMarkerStart($composer_41, 1690235941, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_28 = $composer_41.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_45 = $composer_41.i31();
          var tmp_155;
          if (invalid_28 || it_45 === Companion_getInstance().f30_1) {
            var value_45 = CartMagicMugProductDetailsScreen$lambda_47(viewModel);
            $composer_41.j31(value_45);
            tmp_155 = value_45;
          } else {
            tmp_155 = it_45;
          }
          var tmp11_group_0 = tmp_155;
          sourceInformationMarkerEnd($composer_41);
          var tmp_156 = ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().k110_1;
          OutlinedTextField(tmp23_value, tmp11_group_0, tmp24_modifier, false, false, null, tmp_156, null, null, null, null, null, null, false, null, null, null, false, 0, 0, null, tmp25_shape, null, $composer_41, 1573248, 0, 0, 6291384);
          var tmp_157 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$315 = _Dp___init__impl__ms3zkb(24);
          Spacer(height(tmp_157, tmp$ret$315), $composer_41, 6);
          AgeGroupDisplay(tmp0_safe_receiver.rzu_1, tmp0_safe_receiver.szu_1, tmp0_safe_receiver.tzu_1, null, $composer_41, 0, 8);
          var tmp_158 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$316 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_158, tmp$ret$316), $composer_41, 6);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_17 = null;
          var horizontalArrangement_2 = null;
          var verticalAlignment_2 = Companion_getInstance_11().u8t_1;
          var $composer_56 = $composer_41;
          if (!((3 & 1) === 0))
            modifier_17 = Companion_instance;
          if (!((3 & 2) === 0))
            horizontalArrangement_2 = Arrangement_getInstance().qdp_1;
          if (!((3 & 4) === 0))
            verticalAlignment_2 = Companion_getInstance_11().t8t_1;
          var measurePolicy_8 = rowMeasurePolicy(horizontalArrangement_2, verticalAlignment_2, $composer_56, 14 & 384 >> 3 | 112 & 384 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_18 = modifier_17;
          var $composer_57 = $composer_56;
          if (!((0 & 2) === 0))
            modifier_18 = Companion_instance;
          var compositeKeyHash_8 = get_currentCompositeKeyHashCode($composer_57, 0).hashCode();
          var localMap_8 = $composer_57.t31();
          var materialized_8 = materialize($composer_57, modifier_18);
          var tmp0_17 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_58 = $composer_57;
          var tmp_159 = $composer_58.g30();
          if (!isInterface(tmp_159, Applier)) {
            invalidApplier();
          }
          $composer_58.b31();
          if ($composer_58.h30()) {
            $composer_58.c31(tmp0_17);
          } else {
            $composer_58.d31();
          }
          var $this$ReusableComposeNode_8 = _Updater___init__impl__rbfxm8($composer_58);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, measurePolicy_8, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, localMap_8, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, compositeKeyHash_8, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_8, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, materialized_8, Companion_getInstance_12().qah_1);
          var $composer_59 = $composer_58;
          var $composer_60 = $composer_59;
          sourceInformationMarkerStart($composer_60, -673633860, 'C532@29438L76,533@29543L28,534@29600L307:CartMagicMugProductDetailsScreen.kt#6ni00');
          var tmp_160;
          var tmp0_elvis_lhs_4 = tmp0_safe_receiver.wzt_1;
          if ((tmp0_elvis_lhs_4 == null ? 0 : tmp0_elvis_lhs_4) > 0) {
            $composer_60.m30(-437371385);
            $composer_60.n30();
            tmp_160 = Color(new Long(-11751600, 0));
          } else {
            $composer_60.m30(-437369829);
            sourceInformation($composer_60, '531@29392L11');
            var tmp0_group_9 = MaterialTheme_instance.unz($composer_60, 6).to0_1;
            $composer_60.n30();
            tmp_160 = tmp0_group_9;
          }
          var stockColor = tmp_160;
          var tmp_161 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$323 = _Dp___init__impl__ms3zkb(8);
          Box(background(clip(size(tmp_161, tmp$ret$323), get_CircleShape()), stockColor), $composer_60, 0);
          var tmp_162 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$324 = _Dp___init__impl__ms3zkb(8);
          Spacer(width(tmp_162, tmp$ret$324), $composer_60, 6);
          var tmp_163;
          var tmp2_elvis_lhs_0 = tmp0_safe_receiver.wzt_1;
          if ((tmp2_elvis_lhs_0 == null ? 0 : tmp2_elvis_lhs_0) > 0) {
            $composer_60.m30(-437359475);
            sourceInformation($composer_60, '535@29669L57');
            var tmp_164 = get_in_stock_pattern(string_instance);
            var tmp1_elvis_lhs_2 = tmp0_safe_receiver.wzt_1;
            var tmp1_group_8 = formatNumbers(stringResource_0(tmp_164, [tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2], $composer_60, 0), language);
            $composer_60.n30();
            tmp_163 = tmp1_group_8;
          } else {
            $composer_60.m30(-437358531);
            sourceInformation($composer_60, '535@29756L39');
            var tmp2_group_1 = stringResource(get_out_of_stock(string_instance), $composer_60, 0);
            $composer_60.n30();
            tmp_163 = tmp2_group_1;
          }
          var tmp_165 = tmp_163;
          var tmp_166 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_167 = Companion_getInstance_16().e7z_1;
          var tmp_168 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_169 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_170 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_165, null, stockColor, null, tmp_166, null, tmp_167, null, tmp_168, null, null, tmp_169, tmp_170, false, 0, 0, null, null, $composer_60, 1572864, 0, 262074);
          sourceInformationMarkerEnd($composer_60);
          $composer_58.e31();
          var tmp_171 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$325 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_171, tmp$ret$325), $composer_41, 6);
          var tmp_172 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$326 = _Dp___init__impl__ms3zkb(120);
          Spacer(height(tmp_172, tmp$ret$326), $composer_41, 6);
          sourceInformationMarkerEnd($composer_41);
          $composer_39.e31();
          sourceInformationMarkerEnd($composer_14);
          $composer_12.e31();
          var tmp3_modifier = zIndex(fillMaxWidth(BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1)), 2.0);
          var tmp4_color = MaterialTheme_instance.unz($composer_9, 6).mo0_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp5_shadowElevation = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_173 = _Dp___init__impl__ms3zkb(24);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$329 = _Dp___init__impl__ms3zkb(24);
          var tmp6_shape_0 = RoundedCornerShape_0(tmp_173, tmp$ret$329);
          var tmp_174 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_175 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_5 = rememberComposableLambda(1995906730, true, CartMagicMugProductDetailsScreen$lambda_48(tmp0_safe_receiver, state$delegate, viewModel, language, cartRepository, cartItem), $composer_9, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_61 = $composer_9;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_29 = $composer_61.k31(dispatchReceiver_5);
          // Inline function 'kotlin.let' call
          var it_46 = $composer_61.i31();
          var tmp_176;
          if (invalid_29 || it_46 === Companion_getInstance().f30_1) {
            var value_46 = ComposableLambda$invoke$ref(dispatchReceiver_5);
            $composer_61.j31(value_46);
            tmp_176 = value_46;
          } else {
            tmp_176 = it_46;
          }
          var tmp$ret$330 = tmp_176;
          Surface(tmp3_modifier, tmp6_shape_0, tmp4_color, tmp_174, tmp_175, tmp5_shadowElevation, null, tmp$ret$330, $composer_9, 12779520, 88);
          $composer_9.n30();
        } else {
          $composer_9.m30(-443031282);
          $composer_9.n30();
        }
        var tmp_177 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).e10z_1;
        var tmp_178 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).g10z_1;
        sourceInformationMarkerStart($composer_9, -291383725, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_30 = $composer_9.k31(verticalScrollState);
        // Inline function 'kotlin.let' call
        var it_47 = $composer_9.i31();
        var tmp_179;
        if (invalid_30 || it_47 === Companion_getInstance().f30_1) {
          var value_47 = CartMagicMugProductDetailsScreen$slambda_10(verticalScrollState, null);
          $composer_9.j31(value_47);
          tmp_179 = value_47;
        } else {
          tmp_179 = it_47;
        }
        var tmp0_group_10 = tmp_179;
        sourceInformationMarkerEnd($composer_9);
        LaunchedEffect(tmp_177, tmp_178, tmp0_group_10, $composer_9, 0);
        if (CartMagicMugProductDetailsScreen$lambda_1(state$delegate).h10z_1) {
          $composer_9.m30(-442795744);
          sourceInformation($composer_9, '708@40138L353,717@40524L70,706@40022L590');
          var tmp_180 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).g10z_1;
          sourceInformationMarkerStart($composer_9, -291374379, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_31 = $composer_9.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_48 = $composer_9.i31();
          var tmp_181;
          if (invalid_31 || it_48 === Companion_getInstance().f30_1) {
            var value_48 = CartMagicMugProductDetailsScreen$lambda_49(viewModel);
            $composer_9.j31(value_48);
            tmp_181 = value_48;
          } else {
            tmp_181 = it_48;
          }
          var tmp1_group_9 = tmp_181;
          sourceInformationMarkerEnd($composer_9);
          sourceInformationMarkerStart($composer_9, -291362310, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_32 = $composer_9.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_49 = $composer_9.i31();
          var tmp_182;
          if (invalid_32 || it_49 === Companion_getInstance().f30_1) {
            var value_49 = CartMagicMugProductDetailsScreen$lambda_50(viewModel);
            $composer_9.j31(value_49);
            tmp_182 = value_49;
          } else {
            tmp_182 = it_49;
          }
          var tmp2_group_2 = tmp_182;
          sourceInformationMarkerEnd($composer_9);
          MagicMugImageEditorScreen(tmp_180, tmp1_group_9, tmp2_group_2, $composer_9, 0, 0);
          $composer_9.n30();
        } else {
          $composer_9.m30(-442198002);
          $composer_9.n30();
        }
        var tmp_183 = CartMagicMugProductDetailsScreen$lambda_4(showFullScreen3D$delegate);
        var tmp_184 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).i10z_1;
        var tmp_185 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).j10z_1;
        var tmp_186 = ProductKind_MAGIC_MUG_getInstance();
        var tmp_187 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).e10z_1;
        var tmp_188 = CartMagicMugProductDetailsScreen$lambda_1(state$delegate).f10z_1;
        sourceInformationMarkerStart($composer_9, -291347171, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_33 = !!($composer_9.q31(viewModel) | $composer_9.q31(tmp0_safe_receiver));
        // Inline function 'kotlin.let' call
        var it_50 = $composer_9.i31();
        var tmp_189;
        if (invalid_33 || it_50 === Companion_getInstance().f30_1) {
          var value_50 = CartMagicMugProductDetailsScreen$lambda_51(viewModel, tmp0_safe_receiver);
          $composer_9.j31(value_50);
          tmp_189 = value_50;
        } else {
          tmp_189 = it_50;
        }
        var tmp3_group_1 = tmp_189;
        sourceInformationMarkerEnd($composer_9);
        sourceInformationMarkerStart($composer_9, -291343920, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_51 = $composer_9.i31();
        var tmp_190;
        if (false || it_51 === Companion_getInstance().f30_1) {
          var value_51 = CartMagicMugProductDetailsScreen$lambda_52(showFullScreen3D$delegate);
          $composer_9.j31(value_51);
          tmp_190 = value_51;
        } else {
          tmp_190 = it_51;
        }
        var tmp4_group_1 = tmp_190;
        sourceInformationMarkerEnd($composer_9);
        sourceInformationMarkerStart($composer_9, -291341846, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_34 = $composer_9.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_52 = $composer_9.i31();
        var tmp_191;
        if (invalid_34 || it_52 === Companion_getInstance().f30_1) {
          var value_52 = CartMagicMugProductDetailsScreen$lambda_53(showFullScreen3D$delegate, viewModel);
          $composer_9.j31(value_52);
          tmp_191 = value_52;
        } else {
          tmp_191 = it_52;
        }
        var tmp5_group_1 = tmp_191;
        sourceInformationMarkerEnd($composer_9);
        FullScreen3DDialog(tmp_183, tmp_184, tmp_185, tmp_186, tmp_187, tmp_188, language, tmp3_group_1, tmp4_group_1, tmp5_group_1, $composer_9, 100666368, 0);
        if (CartMagicMugProductDetailsScreen$lambda_1(state$delegate).a10z_1) {
          $composer_9.m30(-441436704);
          sourceInformation($composer_9, '738@41383L878');
          var tmp_192 = fillMaxSize(Companion_instance);
          var tmp_193 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.5);
          var tmp_194 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_195 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_196 = _Dp___init__impl__ms3zkb(0.0);
          Surface(tmp_192, null, tmp_193, tmp_194, tmp_195, tmp_196, null, ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().o110_1, $composer_9, 12583302, 122);
          $composer_9.n30();
        } else {
          $composer_9.m30(-440562194);
          $composer_9.n30();
        }
        var tmp_197 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
        SnackbarHost(snackbarHostState, tmp_197, null, $composer_9, 6, 4);
        if (CartMagicMugProductDetailsScreen$lambda_8(showBirthdayPicker$delegate)) {
          $composer_9.m30(-440349534);
          sourceInformation($composer_9, '755@42496L136,759@42670L1566,784@44274L259,789@44552L43,754@42439L2156');
          sourceInformationMarkerStart($composer_9, -291299140, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_53 = $composer_9.i31();
          var tmp_198;
          if (false || it_53 === Companion_getInstance().f30_1) {
            var value_53 = CartMagicMugProductDetailsScreen$lambda_54(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate);
            $composer_9.j31(value_53);
            tmp_198 = value_53;
          } else {
            tmp_198 = it_53;
          }
          var tmp6_group_1 = tmp_198;
          sourceInformationMarkerEnd($composer_9);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_6 = rememberComposableLambda(1167808602, true, CartMagicMugProductDetailsScreen$lambda_55(birthdayPickerState, state$delegate, viewModel, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_9, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_62 = $composer_9;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_35 = $composer_62.k31(dispatchReceiver_6);
          // Inline function 'kotlin.let' call
          var it_54 = $composer_62.i31();
          var tmp_199;
          if (invalid_35 || it_54 === Companion_getInstance().f30_1) {
            var value_54 = ComposableLambda$invoke$ref(dispatchReceiver_6);
            $composer_62.j31(value_54);
            tmp_199 = value_54;
          } else {
            tmp_199 = it_54;
          }
          var tmp_200 = tmp_199;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_7 = rememberComposableLambda(1076498396, true, CartMagicMugProductDetailsScreen$lambda_56(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate), $composer_9, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_63 = $composer_9;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_36 = $composer_63.k31(dispatchReceiver_7);
          // Inline function 'kotlin.let' call
          var it_55 = $composer_63.i31();
          var tmp_201;
          if (invalid_36 || it_55 === Companion_getInstance().f30_1) {
            var value_55 = ComposableLambda$invoke$ref(dispatchReceiver_7);
            $composer_63.j31(value_55);
            tmp_201 = value_55;
          } else {
            tmp_201 = it_55;
          }
          var tmp_202 = tmp_201;
          var tmp_203 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_8 = rememberComposableLambda(396564017, true, CartMagicMugProductDetailsScreen$lambda_57(birthdayPickerState), $composer_9, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_64 = $composer_9;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_37 = $composer_64.k31(dispatchReceiver_8);
          // Inline function 'kotlin.let' call
          var it_56 = $composer_64.i31();
          var tmp_204;
          if (invalid_37 || it_56 === Companion_getInstance().f30_1) {
            var value_56 = ComposableLambda$invoke$ref_6(dispatchReceiver_8);
            $composer_64.j31(value_56);
            tmp_204 = value_56;
          } else {
            tmp_204 = it_56;
          }
          var tmp$ret$379 = tmp_204;
          DatePickerDialog(tmp6_group_1, tmp_200, null, tmp_202, null, tmp_203, null, null, tmp$ret$379, $composer_9, 100666422, 244);
          $composer_9.n30();
        } else {
          $composer_9.m30(-438246866);
          $composer_9.n30();
        }
        sourceInformationMarkerEnd($composer_9);
        $composer_7.e31();
        $composer_0.n30();
        tmp_4 = Unit_instance;
      }
      if (tmp_4 == null) {
        $composer_0.m30(1442369252);
        sourceInformation($composer_0, '792@44629L119');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_19 = fillMaxSize(Companion_instance);
        var contentAlignment_2 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_2 = false;
        var $composer_65 = $composer_0;
        if (!((4 & 1) === 0))
          modifier_19 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_2 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_2 = false;
        var measurePolicy_9 = maybeCachedBoxMeasurePolicy(contentAlignment_2, propagateMinConstraints_2);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_20 = modifier_19;
        var $composer_66 = $composer_65;
        if (!((0 & 2) === 0))
          modifier_20 = Companion_instance;
        var compositeKeyHash_9 = get_currentCompositeKeyHashCode($composer_66, 0).hashCode();
        var localMap_9 = $composer_66.t31();
        var materialized_9 = materialize($composer_66, modifier_20);
        var tmp0_18 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_67 = $composer_66;
        var tmp_205 = $composer_67.g30();
        if (!isInterface(tmp_205, Applier)) {
          invalidApplier();
        }
        $composer_67.b31();
        if ($composer_67.h30()) {
          $composer_67.c31(tmp0_18);
        } else {
          $composer_67.d31();
        }
        var $this$ReusableComposeNode_9 = _Updater___init__impl__rbfxm8($composer_67);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_9, measurePolicy_9, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_9, localMap_9, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_9, compositeKeyHash_9, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_9, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_9, materialized_9, Companion_getInstance_12().qah_1);
        var $composer_68 = $composer_67;
        var $composer_69 = $composer_68;
        sourceInformationMarkerStart($composer_69, -250903175, 'C793@44715L27:CartMagicMugProductDetailsScreen.kt#6ni00');
        var tmp_206 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_207 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_208 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_209 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_206, tmp_207, tmp_208, tmp_209, _Dp___init__impl__ms3zkb(0.0), $composer_69, 0, 63);
        sourceInformationMarkerEnd($composer_69);
        $composer_67.e31();
        $composer_0.n30();
      } else {
        $composer_0.m30(1441105103);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver_0 = $composer_0.t30();
    if (tmp2_safe_receiver_0 == null)
      null;
    else {
      tmp2_safe_receiver_0.p3c(CartMagicMugProductDetailsScreen$lambda_58(cartItem, onBack, onNavigateToAuth, topPadding_0, bottomPadding_0, $changed, $default));
    }
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_1404297926$lambda_5aajw4($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C244@11740L283:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1404297926, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$-1404297926.<anonymous> (CartMagicMugProductDetailsScreen.kt:244)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = padding_0(tmp, tmp$ret$0);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1567901015, 'C245@11880L31,245@11934L11,245@11817L172:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp0_imageVector = get_ArrowBack(Filled_instance_0);
      var tmp1_contentDescription = stringResource(get_back(string_instance), $composer_5, 0);
      var tmp2_tint = MaterialTheme_instance.unz($composer_5, 6).no0_1;
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
      var tmp3_modifier = size(tmp_1, tmp$ret$7);
      Icon(tmp0_imageVector, tmp1_contentDescription, tmp3_modifier, tmp2_tint, $composer_5, 384, 0);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableLambda$invoke$ref_5(p0) {
    return constructCallableReference(function (p0_0, p1, p2, p3) {
      p0.v50(p0_0, p1, p2, p3);
      return Unit_instance;
    }, 4, 0, 255, VOID, [p0]);
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_487109529$lambda_ms7qkf($this$AnimatedContent, isFav, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C258@12766L241:CartMagicMugProductDetailsScreen.kt#6ni00');
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isFav) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-487109529, $dirty, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$-487109529.<anonymous> (CartMagicMugProductDetailsScreen.kt:258)');
      }
      var tmp0_imageVector = isFav ? get_Favorite(Icons_getInstance().dxv_1) : get_FavoriteBorder(Icons_getInstance().dxv_1);
      var tmp;
      if (isFav) {
        $composer_0.m30(39184750);
        sourceInformation($composer_0, '258@12913L11');
        var tmp0_group = MaterialTheme_instance.unz($composer_0, 6).xnz_1;
        $composer_0.n30();
        tmp = tmp0_group;
      } else {
        $composer_0.m30(39186000);
        sourceInformation($composer_0, '258@12952L11');
        var tmp1_group = MaterialTheme_instance.unz($composer_0, 6).no0_1;
        $composer_0.n30();
        tmp = tmp1_group;
      }
      var tmp1_tint = tmp;
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
      var tmp2_modifier = size(tmp_0, tmp$ret$0);
      Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_0, 432, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_183941099$lambda_kkg7sg($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C268@13549L248:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-183941099, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$-183941099.<anonymous> (CartMagicMugProductDetailsScreen.kt:268)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = padding_0(tmp, tmp$ret$0);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1604605671, 'C269@13704L11,269@13630L129:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp0_imageVector = get_Share(Icons_getInstance().dxv_1);
      var tmp1_tint = MaterialTheme_instance.unz($composer_5, 6).no0_1;
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
      var tmp2_modifier = size(tmp_1, tmp$ret$7);
      Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_5, 432, 0);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$904810635$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C379@20315L45,379@20310L51:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(904810635, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$904810635.<anonymous> (CartMagicMugProductDetailsScreen.kt:379)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1508933186$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C397@21446L46,397@21441L52:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1508933186, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$1508933186.<anonymous> (CartMagicMugProductDetailsScreen.kt:397)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1796214145$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C406@22101L39:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1796214145, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$1796214145.<anonymous> (CartMagicMugProductDetailsScreen.kt:406)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1759013954$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C425@23262L45,425@23257L51:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1759013954, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$1759013954.<anonymous> (CartMagicMugProductDetailsScreen.kt:425)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_1794766791$lambda_byydkp($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C443@24390L46,443@24385L52:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1794766791, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$-1794766791.<anonymous> (CartMagicMugProductDetailsScreen.kt:443)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_595672136$lambda_yqtv8i($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C453@25113L39:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-595672136, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$-595672136.<anonymous> (CartMagicMugProductDetailsScreen.kt:453)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$920306581$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C514@28594L52,514@28589L58:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(920306581, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$920306581.<anonymous> (CartMagicMugProductDetailsScreen.kt:514)');
      }
      var tmp = stringResource(get_add_product_comment_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1797899795$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C585@32455L49,586@32571L11,583@32318L316:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1797899795, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$1797899795.<anonymous> (CartMagicMugProductDetailsScreen.kt:583)');
      }
      var tmp = get_Remove(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_decrease_quantity_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).no0_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_1358068868$lambda_9a7xtf($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C606@33791L49,607@33907L11,604@33657L313:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1358068868, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$-1358068868.<anonymous> (CartMagicMugProductDetailsScreen.kt:604)');
      }
      var tmp = get_Add(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_increase_quantity_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).no0_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableLambda$invoke$ref_6(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1306465450$lambda($this$Card, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C741@41661L534:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1306465450, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$1306465450.<anonymous> (CartMagicMugProductDetailsScreen.kt:741)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
      var tmp0_modifier = padding_0(tmp, tmp$ret$0);
      var tmp1_horizontalAlignment = Companion_getInstance_11().x8t_1;
      var tmp_0 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = tmp0_modifier;
      var verticalArrangement = tmp_0.mdq(tmp$ret$1);
      var horizontalAlignment = tmp1_horizontalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier = Companion_instance;
      if (!((0 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((0 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -699595509, 'C742@41841L27,743@41906L54,743@41984L10,743@41901L136,744@42075L59,744@42070L95:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
      CircularProgressIndicator(null, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_5, 0, 63);
      var tmp0_text = stringResource(get_adding_to_cart_dialog_title(string_instance), $composer_5, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp_6, null, tmp_7, null, tmp2_fontWeight, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131006);
      var tmp_11 = stringResource(get_adding_to_cart_dialog_msg_custom(string_instance), $composer_5, 0);
      var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_15 = Companion_getInstance_15().d7v_1;
      var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_17 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_11, null, tmp_12, null, tmp_13, null, null, null, tmp_14, null, tmp_15, tmp_16, tmp_17, false, 0, 0, null, null, $composer_5, 0, 0, 261118);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_411277150$lambda_chkwp4($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C739@41488L755:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-411277150, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$-411277150.<anonymous> (CartMagicMugProductDetailsScreen.kt:739)');
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = null;
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((5 & 1) === 0))
        modifier = Companion_instance;
      if (!((5 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((5 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -679593971, 'C740@41555L666:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(32);
      var tmp_1 = padding_0(tmp_0, tmp$ret$6);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(16);
      var tmp_2 = RoundedCornerShape(tmp$ret$7);
      Card(tmp_1, tmp_2, null, null, null, ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().n110_1, $composer_5, 196614, 28);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1942681751$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C783@44202L29,783@44197L35:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1942681751, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$1942681751.<anonymous> (CartMagicMugProductDetailsScreen.kt:783)');
      }
      var tmp = stringResource(get_ok(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1851371545$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C788@44495L33,788@44490L39:CartMagicMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1851371545, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMagicMugProductDetailsScreenKt.lambda$1851371545.<anonymous> (CartMagicMugProductDetailsScreen.kt:788)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt() {
    ComposableSingletons$CartMagicMugProductDetailsScreenKt_instance = this;
    var tmp = this;
    tmp.b110_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1404297926, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_1404297926$lambda_5aajw4));
    var tmp_0 = this;
    tmp_0.c110_1 = ComposableLambda$invoke$ref_5(composableLambdaInstance(-487109529, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_487109529$lambda_ms7qkf));
    var tmp_1 = this;
    tmp_1.d110_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-183941099, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_183941099$lambda_kkg7sg));
    var tmp_2 = this;
    tmp_2.e110_1 = ComposableLambda$invoke$ref(composableLambdaInstance(904810635, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$904810635$lambda));
    var tmp_3 = this;
    tmp_3.f110_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1508933186, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1508933186$lambda));
    var tmp_4 = this;
    tmp_4.g110_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1796214145, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1796214145$lambda));
    var tmp_5 = this;
    tmp_5.h110_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1759013954, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1759013954$lambda));
    var tmp_6 = this;
    tmp_6.i110_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1794766791, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_1794766791$lambda_byydkp));
    var tmp_7 = this;
    tmp_7.j110_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-595672136, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_595672136$lambda_yqtv8i));
    var tmp_8 = this;
    tmp_8.k110_1 = ComposableLambda$invoke$ref(composableLambdaInstance(920306581, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$920306581$lambda));
    var tmp_9 = this;
    tmp_9.l110_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1797899795, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1797899795$lambda));
    var tmp_10 = this;
    tmp_10.m110_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1358068868, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_1358068868$lambda_9a7xtf));
    var tmp_11 = this;
    tmp_11.n110_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(1306465450, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1306465450$lambda));
    var tmp_12 = this;
    tmp_12.o110_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-411277150, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$_411277150$lambda_chkwp4));
    var tmp_13 = this;
    tmp_13.p110_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1942681751, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1942681751$lambda));
    var tmp_14 = this;
    tmp_14.q110_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1851371545, false, ComposableSingletons$CartMagicMugProductDetailsScreenKt$lambda$1851371545$lambda));
  }
  var ComposableSingletons$CartMagicMugProductDetailsScreenKt_instance;
  function ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance() {
    if (ComposableSingletons$CartMagicMugProductDetailsScreenKt_instance == null)
      new ComposableSingletons$CartMagicMugProductDetailsScreenKt();
    return ComposableSingletons$CartMagicMugProductDetailsScreenKt_instance;
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0(function_0) {
    this.r110_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0).ka7 = function (_this__u8e3s4, $completion) {
    return this.r110_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0).q3 = function () {
    return this.r110_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function CartMagicMugProductDetailsScreen$lambda($product$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('product', KMutableProperty0, true);
    return $product$delegate.u1();
  }
  function CartMagicMugProductDetailsScreen$lambda_0($product$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('product', KMutableProperty0, true);
    $product$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMagicMugProductDetailsScreen$slambda($cartItem, $getProductByIdUseCase, $product$delegate, resultContinuation) {
    this.a111_1 = $cartItem;
    this.b111_1 = $getProductByIdUseCase;
    this.c111_1 = $product$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMagicMugProductDetailsScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_safe_receiver = this.a111_1.gyw_1;
            if (tmp0_safe_receiver == null) {
              this.e111_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = this.b111_1.o105(tmp0_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var ARGUMENT = suspendResult;
            CartMagicMugProductDetailsScreen$lambda_0(this.c111_1, ARGUMENT);
            var tmp_0 = this;
            tmp_0.e111_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartMagicMugProductDetailsScreen$slambda(this.a111_1, this.b111_1, this.c111_1, completion);
    i.d111_1 = $this$LaunchedEffect;
    return i;
  };
  function CartMagicMugProductDetailsScreen$slambda_0($cartItem, $getProductByIdUseCase, $product$delegate, resultContinuation) {
    var i = new CartMagicMugProductDetailsScreen$slambda($cartItem, $getProductByIdUseCase, $product$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CartMagicMugProductDetailsScreen$lambda_1($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function CartMagicMugProductDetailsScreen$lambda_2($isInteractingWith3D$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isInteractingWith3D', KMutableProperty0, true);
    return $isInteractingWith3D$delegate.u1();
  }
  function CartMagicMugProductDetailsScreen$lambda_3($isInteractingWith3D$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isInteractingWith3D', KMutableProperty0, true);
    $isInteractingWith3D$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMagicMugProductDetailsScreen$lambda_4($showFullScreen3D$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showFullScreen3D', KMutableProperty0, true);
    return $showFullScreen3D$delegate.u1();
  }
  function CartMagicMugProductDetailsScreen$lambda_5($showFullScreen3D$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showFullScreen3D', KMutableProperty0, true);
    $showFullScreen3D$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMagicMugProductDetailsScreen$lambda_6($isMediaDialogOpen$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isMediaDialogOpen', KMutableProperty0, true);
    return $isMediaDialogOpen$delegate.u1();
  }
  function CartMagicMugProductDetailsScreen$lambda_7($isMediaDialogOpen$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isMediaDialogOpen', KMutableProperty0, true);
    $isMediaDialogOpen$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMagicMugProductDetailsScreen$lambda_8($showBirthdayPicker$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    return $showBirthdayPicker$delegate.u1();
  }
  function CartMagicMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    $showBirthdayPicker$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMagicMugProductDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    return $birthdayPickerTargetOptionKey$delegate.u1();
  }
  function CartMagicMugProductDetailsScreen$lambda_11($birthdayPickerTargetOptionKey$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    $birthdayPickerTargetOptionKey$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMagicMugProductDetailsScreen$lambda_12($isPickingBoxBirthday$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    return $isPickingBoxBirthday$delegate.u1();
  }
  function CartMagicMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    $isPickingBoxBirthday$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMagicMugProductDetailsScreen$lambda_14($showDiscardDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    return $showDiscardDialog$delegate.u1();
  }
  function CartMagicMugProductDetailsScreen$lambda_15($showDiscardDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    $showDiscardDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMagicMugProductDetailsScreen$lambda_16($isSaving$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isSaving', KMutableProperty0, true);
    return $isSaving$delegate.u1();
  }
  function CartMagicMugProductDetailsScreen$lambda_17($isSaving$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isSaving', KMutableProperty0, true);
    $isSaving$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMagicMugProductDetailsScreen$slambda_1($viewModel, $cartItem, $p, resultContinuation) {
    this.n111_1 = $viewModel;
    this.o111_1 = $cartItem;
    this.p111_1 = $p;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMagicMugProductDetailsScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = delay(new Long(100, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this.n111_1.s10h();
            var tmp0_customImageUrl = this.o111_1.syw_1;
            var tmp1_designLayers = this.o111_1.tyw_1;
            tmp_0.j10i(new LoadProduct_1(this.p111_1.i100(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_designLayers, tmp0_customImageUrl), this.o111_1.jyx_1, this.o111_1.kyx_1, this.o111_1.lyx_1, this.o111_1.myx_1, this.o111_1.dyx_1, this.o111_1.gyx_1, this.o111_1.eyx_1, this.o111_1.fyx_1, this.o111_1.hyx_1, this.o111_1.iyx_1));
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartMagicMugProductDetailsScreen$slambda_1(this.n111_1, this.o111_1, this.p111_1, completion);
    i.q111_1 = $this$LaunchedEffect;
    return i;
  };
  function CartMagicMugProductDetailsScreen$slambda_2($viewModel, $cartItem, $p, resultContinuation) {
    var i = new CartMagicMugProductDetailsScreen$slambda_1($viewModel, $cartItem, $p, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_8(function_0) {
    this.r111_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_8).a1v = function (value, $completion) {
    return this.r111_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_8).q3 = function () {
    return this.r111_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_8).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_8).hashCode = function () {
    return hashCode(this.q3());
  };
  function CartMagicMugProductDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    this.a112_1 = $snackbarHostState;
    this.b112_1 = $onNavigateToAuth;
    this.c112_1 = $onBack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMagicMugProductDetailsScreen$slambda$slambda).f112 = function (effect, $completion) {
    var tmp = this.g112(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.f112((!(p1 == null) ? isInterface(p1, CustomProductDetailsSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp0_subject = this.d112_1;
            if (tmp0_subject instanceof ShowMessage_4) {
              this.n9_1 = 2;
              suspendResult = this.d112_1.i112_1.z10i(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof ShowToast_0) {
                this.n9_1 = 1;
                suspendResult = this.d112_1.h112_1.z10i(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (equals(tmp0_subject, NavigateToAuth_instance_2)) {
                  this.e112_1 = this.b112_1();
                  this.n9_1 = 4;
                  continue $sm;
                } else {
                  if (equals(tmp0_subject, NavigateBack_instance_2)) {
                    this.e112_1 = this.c112_1();
                    this.n9_1 = 4;
                    continue $sm;
                  } else {
                    var tmp_0 = this;
                    noWhenBranchMatchedException();
                  }
                }
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            var tmp_1 = this;
            showToast(ARGUMENT);
            tmp_1.e112_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            this.n9_1 = 3;
            suspendResult = this.a112_1.dqm(ARGUMENT_0, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.e112_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda$slambda).g112 = function (effect, completion) {
    var i = new CartMagicMugProductDetailsScreen$slambda$slambda(this.a112_1, this.b112_1, this.c112_1, completion);
    i.d112_1 = effect;
    return i;
  };
  function CartMagicMugProductDetailsScreen$slambda$slambda_0($snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    var i = new CartMagicMugProductDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.f112(effect, $completion);
    }, 1);
  }
  function CartMagicMugProductDetailsScreen$slambda_3($viewModel, $snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    this.r112_1 = $viewModel;
    this.s112_1 = $snackbarHostState;
    this.t112_1 = $onNavigateToAuth;
    this.u112_1 = $onBack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMagicMugProductDetailsScreen$slambda_3).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.r112_1.s10h().t10h();
            var tmp_1 = CartMagicMugProductDetailsScreen$slambda$slambda_0(this.s112_1, this.t112_1, this.u112_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_8(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_3).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartMagicMugProductDetailsScreen$slambda_3(this.r112_1, this.s112_1, this.t112_1, this.u112_1, completion);
    i.v112_1 = $this$LaunchedEffect;
    return i;
  };
  function CartMagicMugProductDetailsScreen$slambda_4($viewModel, $snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    var i = new CartMagicMugProductDetailsScreen$slambda_3($viewModel, $snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CartMagicMugProductDetailsScreen$slambda_5($appViewModel, $state$delegate, resultContinuation) {
    this.e113_1 = $appViewModel;
    this.f113_1 = $state$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMagicMugProductDetailsScreen$slambda_5).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_5).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0;
          if (CartMagicMugProductDetailsScreen$lambda_1(this.f113_1).a10z_1) {
            tmp_0 = true;
          } else {
            tmp_0 = !CartMagicMugProductDetailsScreen$lambda_1(this.f113_1).g10z_1.r();
          }
          this.e113_1.l108(tmp_0);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_5).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartMagicMugProductDetailsScreen$slambda_5(this.e113_1, this.f113_1, completion);
    i.g113_1 = $this$LaunchedEffect;
    return i;
  };
  function CartMagicMugProductDetailsScreen$slambda_6($appViewModel, $state$delegate, resultContinuation) {
    var i = new CartMagicMugProductDetailsScreen$slambda_5($appViewModel, $state$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CartMagicMugProductDetailsScreen$$inlined$let$4$1($appViewModel) {
    this.h113_1 = $appViewModel;
  }
  protoOf(CartMagicMugProductDetailsScreen$$inlined$let$4$1).s1d = function () {
    this.h113_1.l108(false);
  };
  function CartMagicMugProductDetailsScreen$lambda_18($appViewModel) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new CartMagicMugProductDetailsScreen$$inlined$let$4$1($appViewModel);
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_19($showFullScreen3D$delegate, $state$delegate, $showDiscardDialog$delegate) {
    return function () {
      var tmp;
      if (CartMagicMugProductDetailsScreen$lambda_4($showFullScreen3D$delegate)) {
        CartMagicMugProductDetailsScreen$lambda_5($showFullScreen3D$delegate, false);
        tmp = Unit_instance;
      } else {
        var tmp_0;
        if (CartMagicMugProductDetailsScreen$lambda_1($state$delegate).a10z_1) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_0 = !CartMagicMugProductDetailsScreen$lambda_1($state$delegate).g10z_1.r();
        }
        if (tmp_0) {
          CartMagicMugProductDetailsScreen$lambda_15($showDiscardDialog$delegate, true);
          tmp = Unit_instance;
        }
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_20($showDiscardDialog$delegate, $onBack) {
    return function () {
      CartMagicMugProductDetailsScreen$lambda_15($showDiscardDialog$delegate, false);
      $onBack();
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_21($showDiscardDialog$delegate) {
    return function () {
      CartMagicMugProductDetailsScreen$lambda_15($showDiscardDialog$delegate, false);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$slambda$slambda_1($isInteractingWith3D$delegate, resultContinuation) {
    this.q113_1 = $isInteractingWith3D$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMagicMugProductDetailsScreen$slambda$slambda_1).ic6 = function ($this$awaitPointerEventScope, $completion) {
    var tmp = this.jc6($this$awaitPointerEventScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda$slambda_1).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 4;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = this.r113_1.pa7(PointerEventPass_Initial_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var event = suspendResult;
            var tmp0 = event.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var tmp_0;
              if (isInterface(tmp0, Collection)) {
                tmp_0 = tmp0.r();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$0 = false;
                break l$ret$1;
              }
              var _iterator__ex2g4s = tmp0.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (element.la0_1) {
                  tmp$ret$0 = true;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = false;
            }
             while (false);
            CartMagicMugProductDetailsScreen$lambda_3(this.q113_1, tmp$ret$0);
            this.n9_1 = 1;
            continue $sm;
          case 3:
            throw this.q9_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda$slambda_1).jc6 = function ($this$awaitPointerEventScope, completion) {
    var i = new CartMagicMugProductDetailsScreen$slambda$slambda_1(this.q113_1, completion);
    i.r113_1 = $this$awaitPointerEventScope;
    return i;
  };
  function CartMagicMugProductDetailsScreen$slambda$slambda_2($isInteractingWith3D$delegate, resultContinuation) {
    var i = new CartMagicMugProductDetailsScreen$slambda$slambda_1($isInteractingWith3D$delegate, resultContinuation);
    return constructCallableReference(function ($this$awaitPointerEventScope, $completion) {
      return i.ic6($this$awaitPointerEventScope, $completion);
    }, 1);
  }
  function CartMagicMugProductDetailsScreen$slambda_7($isInteractingWith3D$delegate, resultContinuation) {
    this.a114_1 = $isInteractingWith3D$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMagicMugProductDetailsScreen$slambda_7).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_7).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_7).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.b114_1.ma7(CartMagicMugProductDetailsScreen$slambda$slambda_2(this.a114_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_7).wc6 = function ($this$pointerInput, completion) {
    var i = new CartMagicMugProductDetailsScreen$slambda_7(this.a114_1, completion);
    i.b114_1 = $this$pointerInput;
    return i;
  };
  function CartMagicMugProductDetailsScreen$slambda_8($isInteractingWith3D$delegate, resultContinuation) {
    var i = new CartMagicMugProductDetailsScreen$slambda_7($isInteractingWith3D$delegate, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function CartMagicMugProductDetailsScreen$lambda_22($viewModel, $p) {
    return function () {
      $viewModel.s10h().j10i(new LoadProduct_1($p));
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_23($state$delegate, $showDiscardDialog$delegate, $onBack) {
    return function () {
      var tmp;
      var tmp_0;
      if (CartMagicMugProductDetailsScreen$lambda_1($state$delegate).a10z_1) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_0 = !CartMagicMugProductDetailsScreen$lambda_1($state$delegate).g10z_1.r();
      }
      if (tmp_0) {
        CartMagicMugProductDetailsScreen$lambda_15($showDiscardDialog$delegate, true);
        tmp = Unit_instance;
      } else {
        tmp = $onBack();
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_24($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ToggleFavorite_instance_0);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_25($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C256@12570L517:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-378221986, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMagicMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMagicMugProductDetailsScreen.kt:256)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -2067281135, 'C257@12651L398:CartMagicMugProductDetailsScreen.kt#6ni00');
        var tmp_2 = CartMagicMugProductDetailsScreen$lambda_1($state$delegate).b10z_1;
        AnimatedContent(tmp_2, null, null, null, '', null, ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().c110_1, $composer_5, 1597440, 46);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_26($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ShareProduct_instance_0);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_27($showFullScreen3D$delegate) {
    return function () {
      CartMagicMugProductDetailsScreen$lambda_5($showFullScreen3D$delegate, true);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_28($language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C286@14518L1108:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(531353878, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMagicMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMagicMugProductDetailsScreen.kt:286)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_1 = _Dp___init__impl__ms3zkb(20);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(10);
        var tmp0_modifier = padding_2(tmp_0, tmp_1, tmp$ret$1);
        var tmp1_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_2 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$2 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = tmp0_modifier;
        var horizontalArrangement = tmp_2.mdq(tmp$ret$2);
        var verticalAlignment = tmp1_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_3 = $composer_3.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 943519870, 'C295@15120L11,291@14849L337,299@15377L10,301@15530L11,297@15219L377:CartMagicMugProductDetailsScreen.kt#6ni00');
        var tmp_4 = get_Fullscreen(Icons_getInstance().dxv_1);
        var tmp_5 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$9 = _Dp___init__impl__ms3zkb(24);
        Icon(tmp_4, null, size(tmp_5, tmp$ret$9), MaterialTheme_instance.unz($composer_5, 6).fo0_1, $composer_5, 432, 0);
        var tmp0_text = $language === 'en' ? 'Full Show' : '\u0639\u0631\u0636 \u0643\u0627\u0645\u0644';
        var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
        var tmp2_fontWeight = Companion_getInstance_16().f7z_1;
        var tmp3_color = MaterialTheme_instance.unz($composer_5, 6).fo0_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_9 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp3_color, null, tmp_6, null, tmp2_fontWeight, null, tmp_7, null, null, tmp_8, tmp_9, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131002);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_10;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_10 = Unit_instance;
        }
        tmp = tmp_10;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_29($isMediaDialogOpen$delegate) {
    return function (it) {
      CartMagicMugProductDetailsScreen$lambda_7($isMediaDialogOpen$delegate, it);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_30($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new CardSelected_1(it instanceof Card_1 ? it : null));
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_31($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new CardMessageChanged_1(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_32($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C387@20931L10,383@20623L371:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(992088344, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMagicMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMagicMugProductDetailsScreen.kt:383)');
        }
        var tmp_0 = '' + CartMagicMugProductDetailsScreen$lambda_1($state$delegate).n10z_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_33($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CartMagicMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, false);
      CartMagicMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_34(it) {
    return Unit_instance;
  }
  function CartMagicMugProductDetailsScreen$lambda$lambda($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CartMagicMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, false);
      CartMagicMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_35($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C403@21921L176,403@21900L242:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1655760417, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMagicMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMagicMugProductDetailsScreen.kt:403)');
        }
        sourceInformationMarkerStart($composer_0, -2047860305, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CartMagicMugProductDetailsScreen$lambda$lambda($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().g110_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_36($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new BoxSelected_1(it instanceof Box_0 ? it : null));
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_37($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new BoxMessageChanged_1(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_38($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C433@23877L10,429@23570L370:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-266453617, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMagicMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMagicMugProductDetailsScreen.kt:429)');
        }
        var tmp_0 = '' + CartMagicMugProductDetailsScreen$lambda_1($state$delegate).r10z_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_39($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CartMagicMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, true);
      CartMagicMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_40(it) {
    return Unit_instance;
  }
  function CartMagicMugProductDetailsScreen$lambda$lambda_0($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CartMagicMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, true);
      CartMagicMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_41($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C450@24934L175,450@24913L241:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2066493590, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMagicMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMagicMugProductDetailsScreen.kt:450)');
        }
        sourceInformationMarkerStart($composer_0, 1625450149, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CartMagicMugProductDetailsScreen$lambda$lambda_0($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().j110_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_42($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new SizeSelected_1(it));
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_43($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new ColorSelected_1(it));
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_44($viewModel, $option) {
    return function (value) {
      $viewModel.s10h().j10i(new OptionSelected_1($option.r101_1, value));
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_45($viewModel, $option) {
    return function (newValue) {
      $viewModel.s10h().j10i(new OptionSelected_1($option.r101_1, newValue));
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_46($birthdayPickerTargetOptionKey$delegate, $option, $showBirthdayPicker$delegate) {
    return function () {
      CartMagicMugProductDetailsScreen$lambda_11($birthdayPickerTargetOptionKey$delegate, $option.r101_1);
      CartMagicMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_47($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 100) {
        $viewModel.s10h().j10i(new ProductCommentChanged_1(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda$lambda_1($state$delegate, $viewModel) {
    return function () {
      var tmp;
      if (CartMagicMugProductDetailsScreen$lambda_1($state$delegate).z10y_1 > 1) {
        $viewModel.s10h().j10i(new QuantityChanged_0(CartMagicMugProductDetailsScreen$lambda_1($state$delegate).z10y_1 - 1 | 0));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda$lambda_2($viewModel, $state$delegate) {
    return function () {
      $viewModel.s10h().j10i(new QuantityChanged_0(CartMagicMugProductDetailsScreen$lambda_1($state$delegate).z10y_1 + 1 | 0));
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda$lambda_3() {
    return EmptyCoroutineContext_getInstance();
  }
  function CartMagicMugProductDetailsScreen$lambda$lambda$slambda($isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg, resultContinuation) {
    this.k114_1 = $isSaving$delegate;
    this.l114_1 = $state$delegate;
    this.m114_1 = $p;
    this.n114_1 = $cartRepository;
    this.o114_1 = $cartItem;
    this.p114_1 = $savedSuccessMsg;
    this.q114_1 = $failedToSaveMsg;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMagicMugProductDetailsScreen$lambda$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMagicMugProductDetailsScreen$lambda$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMagicMugProductDetailsScreen$lambda$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            CartMagicMugProductDetailsScreen$lambda_17(this.k114_1, true);
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.o9_1 = 3;
            var tmp0_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).m10z_1;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lyz_1;
            var tmp_0 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
            var tmp2_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).q10z_1;
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.wyz_1;
            var tmp_1 = tmp_0 + (tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs);
            var sum = 0;
            var _iterator__ex2g4s = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).w10z_1.y2().t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              var tmp_2 = sum;
              var tmp0_elvis_lhs = element.q100_1;
              sum = tmp_2 + (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
            }

            var extraOriginalPrice = tmp_1 + sum;
            var tmp4_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).m10z_1;
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.lyz_1;
            var tmp_3 = tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs;
            var tmp6_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).q10z_1;
            var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.wyz_1;
            var tmp_4 = tmp_3 + (tmp7_elvis_lhs == null ? 0.0 : tmp7_elvis_lhs);
            var sum_0 = 0;
            var _iterator__ex2g4s_0 = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).w10z_1.y2().t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              var tmp_5 = sum_0;
              var tmp_6;
              var tmp0_elvis_lhs_0 = element_0.r100_1;
              if ((tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0) > 0.0) {
                tmp_6 = ensureNotNull(element_0.r100_1);
              } else {
                var tmp1_elvis_lhs_0 = element_0.q100_1;
                tmp_6 = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
              }
              sum_0 = tmp_5 + tmp_6;
            }

            var extraDiscountedPrice = tmp_4 + sum_0;
            var tmp8_elvis_lhs = this.m114_1.szt_1;
            var finalPrice = (tmp8_elvis_lhs == null ? 0.0 : tmp8_elvis_lhs) + extraOriginalPrice;
            var tmp_7;
            var tmp9_elvis_lhs = this.m114_1.tzt_1;
            if ((tmp9_elvis_lhs == null ? 0.0 : tmp9_elvis_lhs) > 0.0) {
              tmp_7 = true;
            } else {
              var tmp0 = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).w10z_1.y2();
              var tmp$ret$0;
              l$ret$1: do {
                var tmp_8;
                if (isInterface(tmp0, Collection)) {
                  tmp_8 = tmp0.r();
                } else {
                  tmp_8 = false;
                }
                if (tmp_8) {
                  tmp$ret$0 = false;
                  break l$ret$1;
                }
                var _iterator__ex2g4s_1 = tmp0.t();
                while (_iterator__ex2g4s_1.u()) {
                  var element_1 = _iterator__ex2g4s_1.v();
                  var tmp0_elvis_lhs_1 = element_1.r100_1;
                  if ((tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1) > 0.0) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                }
                tmp$ret$0 = false;
              }
               while (false);
              tmp_7 = tmp$ret$0;
            }

            var hasAnyDiscount = tmp_7;
            var tmp_9;
            if (hasAnyDiscount) {
              var tmp_10;
              var tmp10_elvis_lhs = this.m114_1.tzt_1;
              if ((tmp10_elvis_lhs == null ? 0.0 : tmp10_elvis_lhs) > 0.0) {
                tmp_10 = ensureNotNull(this.m114_1.tzt_1);
              } else {
                var tmp11_elvis_lhs = this.m114_1.szt_1;
                tmp_10 = tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs;
              }
              tmp_9 = tmp_10 + extraDiscountedPrice;
            } else {
              tmp_9 = 0.0;
            }

            var finalDiscount = tmp_9;
            this.n9_1 = 2;
            var tmp16_quantity = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).z10y_1;
            var tmp17_productComment = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).x10z_1;
            var tmp18_selectedCard = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).m10z_1;
            var tmp_11;
            var tmp12_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).m10z_1;
            if ((tmp12_safe_receiver == null ? null : tmp12_safe_receiver.oyz_1) === true) {
              tmp_11 = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).n10z_1;
            } else {
              tmp_11 = null;
            }

            var tmp19_cardMessage = tmp_11;
            var tmp_12;
            var tmp13_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).m10z_1;
            if ((tmp13_safe_receiver == null ? null : tmp13_safe_receiver.pyz_1) === true) {
              tmp_12 = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).o10z_1;
            } else {
              tmp_12 = null;
            }

            var tmp20_cardBirthday = tmp_12;
            var tmp21_selectedBox = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).q10z_1;
            var tmp_13;
            var tmp14_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).q10z_1;
            if ((tmp14_safe_receiver == null ? null : tmp14_safe_receiver.zyz_1) === true) {
              tmp_13 = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).r10z_1;
            } else {
              tmp_13 = null;
            }

            var tmp22_boxMessage = tmp_13;
            var tmp_14;
            var tmp15_safe_receiver = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).q10z_1;
            if ((tmp15_safe_receiver == null ? null : tmp15_safe_receiver.az0_1) === true) {
              tmp_14 = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).s10z_1;
            } else {
              tmp_14 = null;
            }

            var tmp23_boxBirthday = tmp_14;
            var tmp24_selectedSize = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).u10z_1;
            var tmp25_selectedColor = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).v10z_1;
            var this_0 = CartMagicMugProductDetailsScreen$lambda_1(this.l114_1).w10z_1;
            var tmp_15;
            if (this_0.r()) {
              tmp_15 = null;
            } else {
              tmp_15 = this_0;
            }

            var tmp26_selectedOptions = tmp_15;
            suspendResult = this.n114_1.dz0(this.o114_1.jyy(VOID, VOID, VOID, VOID, VOID, VOID, finalPrice, finalDiscount, VOID, VOID, VOID, VOID, tmp16_quantity, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp18_selectedCard, tmp19_cardMessage, tmp20_cardBirthday, tmp21_selectedBox, tmp22_boxMessage, tmp23_boxBirthday, tmp24_selectedSize, tmp25_selectedColor, tmp26_selectedOptions, tmp17_productComment), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            showToast(this.p114_1);
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 4;
            var tmp_16 = this.q9_1;
            if (tmp_16 instanceof Exception) {
              var _unused_var__etf5q3 = this.q9_1;
              showToast(this.q114_1);
              this.o9_1 = 6;
              this.n9_1 = 5;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 6;
            var t = this.q9_1;
            CartMagicMugProductDetailsScreen$lambda_17(this.k114_1, false);
            throw t;
          case 5:
            this.o9_1 = 6;
            CartMagicMugProductDetailsScreen$lambda_17(this.k114_1, false);
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMagicMugProductDetailsScreen$lambda$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new CartMagicMugProductDetailsScreen$lambda$lambda$slambda(this.k114_1, this.l114_1, this.m114_1, this.n114_1, this.o114_1, this.p114_1, this.q114_1, completion);
    i.r114_1 = $this$launch;
    return i;
  };
  function CartMagicMugProductDetailsScreen$lambda$lambda$slambda_0($isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg, resultContinuation) {
    var i = new CartMagicMugProductDetailsScreen$lambda$lambda$slambda($isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CartMagicMugProductDetailsScreen$lambda$lambda_4($scope, $isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg) {
    return function () {
      launch($scope, VOID, VOID, CartMagicMugProductDetailsScreen$lambda$lambda$slambda_0($isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg, null));
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda$lambda_5($isSaving$delegate) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(334489814, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMagicMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMagicMugProductDetailsScreen.kt:671)');
        }
        if (CartMagicMugProductDetailsScreen$lambda_16($isSaving$delegate)) {
          $composer_0.m30(461975259);
          sourceInformation($composer_0, '672@38363L241');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          var tmp_2 = Companion_getInstance_14().m6b_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_3 = _Dp___init__impl__ms3zkb(2);
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_0, 438, 56);
          $composer_0.n30();
        } else {
          $composer_0.m30(462339106);
          sourceInformation($composer_0, '678@38674L1002');
          var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier = null;
          var horizontalArrangement = Arrangement_getInstance().udp_1;
          var verticalAlignment = tmp0_verticalAlignment;
          var $composer_1 = $composer_0;
          if (!((1 & 1) === 0))
            modifier = Companion_instance;
          if (!((1 & 2) === 0))
            horizontalArrangement = Arrangement_getInstance().qdp_1;
          if (!((1 & 4) === 0))
            verticalAlignment = Companion_getInstance_11().t8t_1;
          var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_0 = modifier;
          var $composer_2 = $composer_1;
          if (!((0 & 2) === 0))
            modifier_0 = Companion_instance;
          var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
          var localMap = $composer_2.t31();
          var materialized = materialize($composer_2, modifier_0);
          var tmp0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_3 = $composer_2;
          var tmp_6 = $composer_3.g30();
          if (!isInterface(tmp_6, Applier)) {
            invalidApplier();
          }
          $composer_3.b31();
          if ($composer_3.h30()) {
            $composer_3.c31(tmp0);
          } else {
            $composer_3.d31();
          }
          var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
          var $composer_4 = $composer_3;
          var $composer_5 = $composer_4;
          sourceInformationMarkerStart($composer_5, -275091763, 'C682@38914L242,687@39193L39,689@39315L31,688@39269L373:CartMagicMugProductDetailsScreen.kt#6ni00');
          var tmp_7 = get_Save(Icons_getInstance().dxv_1);
          var tmp_8 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$8 = _Dp___init__impl__ms3zkb(20);
          var tmp_9 = size(tmp_8, tmp$ret$8);
          Icon(tmp_7, null, tmp_9, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 432, 8);
          var tmp_10 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$9 = _Dp___init__impl__ms3zkb(8);
          Spacer(width(tmp_10, tmp$ret$9), $composer_5, 6);
          var tmp0_text = stringResource(get_save(string_instance), $composer_5, 0);
          var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp2_fontSize = get_sp(16);
          var tmp3_textAlign = Companion_getInstance_15().d7v_1;
          var tmp4_lineHeight = get_sp(18);
          var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_13 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, null, tmp_11, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_12, null, tmp3_textAlign, tmp4_lineHeight, tmp_13, false, 0, 0, null, null, $composer_5, 1597440, 48, 258990);
          sourceInformationMarkerEnd($composer_5);
          $composer_3.e31();
          $composer_0.n30();
        }
        var tmp_14;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_14 = Unit_instance;
        }
        tmp = tmp_14;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_48($p, $state$delegate, $viewModel, $language, $cartRepository, $cartItem) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C553@30501L9253:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1995906730, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMagicMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous> (CartMagicMugProductDetailsScreen.kt:553)');
        }
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_start = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_end = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_top = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp4_bottom = _Dp___init__impl__ms3zkb(8);
        var tmp5_modifier = fillMaxWidth(padding_1(Companion_instance, tmp1_start, tmp3_top, tmp2_end, tmp4_bottom));
        var tmp6_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_0 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$4 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = tmp5_modifier;
        var horizontalArrangement = tmp_0.mdq(tmp$ret$4);
        var verticalAlignment = tmp6_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 769672360, 'C621@34579L24,622@34644L34,623@34725L45,624@34817L41,667@38093L11,667@38049L64,627@34930L2854,670@38285L1447,626@34884L4848:CartMagicMugProductDetailsScreen.kt#6ni00');
        var tmp2_elvis_lhs = $p.wzt_1;
        if ((tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) > 0) {
          $composer_5.m30(769562526);
          sourceInformation($composer_5, '562@30997L3518');
          var tmp0_horizontalAlignment = Companion_getInstance_11().x8t_1;
          var tmp_2 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$11 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_1 = null;
          var verticalArrangement = tmp_2.mdq(tmp$ret$11);
          var horizontalAlignment = tmp0_horizontalAlignment;
          var $composer_6 = $composer_5;
          if (!((1 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((1 & 2) === 0))
            verticalArrangement = Arrangement_getInstance().sdp_1;
          if (!((1 & 4) === 0))
            horizontalAlignment = Companion_getInstance_11().w8t_1;
          var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_7 = $composer_6;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
          var localMap_0 = $composer_7.t31();
          var materialized_0 = materialize($composer_7, modifier_2);
          var tmp0_0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_8 = $composer_7;
          var tmp_3 = $composer_8.g30();
          if (!isInterface(tmp_3, Applier)) {
            invalidApplier();
          }
          $composer_8.b31();
          if ($composer_8.h30()) {
            $composer_8.c31(tmp0_0);
          } else {
            $composer_8.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_9 = $composer_8;
          var $composer_10 = $composer_9;
          sourceInformationMarkerStart($composer_10, 958722171, 'C570@31490L11,566@31234L2808,612@34124L45,613@34229L10,614@34310L11,611@34075L410:CartMagicMugProductDetailsScreen.kt#6ni00');
          var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
          var tmp_4 = Companion_instance;
          var tmp_5 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_10, 6).oo0_1, 0.5);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$18 = _Dp___init__impl__ms3zkb(12);
          var tmp_6 = background(tmp_4, tmp_5, RoundedCornerShape(tmp$ret$18));
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_7 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$20 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_3 = padding_2(tmp_6, tmp_7, tmp$ret$20);
          var horizontalArrangement_0 = null;
          var verticalAlignment_0 = tmp0_verticalAlignment;
          var $composer_11 = $composer_10;
          if (!((2 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((2 & 2) === 0))
            horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
          if (!((2 & 4) === 0))
            verticalAlignment_0 = Companion_getInstance_11().t8t_1;
          var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_11, 14 & 384 >> 3 | 112 & 384 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_8 = $composer_13.g30();
          if (!isInterface(tmp_8, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_1);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_15, 1463661912, 'C576@31868L296,575@31806L866,594@33073L11,589@32709L423,597@33231L272,596@33169L839:CartMagicMugProductDetailsScreen.kt#6ni00');
          sourceInformationMarkerStart($composer_15, -1338258343, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = !!($composer_15.k31($state$delegate) | $composer_15.q31($viewModel));
          // Inline function 'kotlin.let' call
          var it = $composer_15.i31();
          var tmp_9;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = CartMagicMugProductDetailsScreen$lambda$lambda_1($state$delegate, $viewModel);
            $composer_15.j31(value);
            tmp_9 = value;
          } else {
            tmp_9 = it;
          }
          var tmp0_group = tmp_9;
          sourceInformationMarkerEnd($composer_15);
          var tmp_10 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$31 = _Dp___init__impl__ms3zkb(36);
          var tmp_11 = size(tmp_10, tmp$ret$31);
          IconButton(tmp0_group, tmp_11, false, null, null, null, ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().l110_1, $composer_15, 1572912, 60);
          var tmp0_text = format(CartMagicMugProductDetailsScreen$lambda_1($state$delegate).z10y_1, $language);
          var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp2_fontSize = get_sp(18);
          var tmp_12 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$32 = _Dp___init__impl__ms3zkb(8);
          var tmp3_modifier = padding_2(tmp_12, tmp$ret$32);
          var tmp4_color = MaterialTheme_instance.unz($composer_15, 6).no0_1;
          var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_15 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, tmp3_modifier, tmp4_color, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_13, null, null, tmp_14, tmp_15, false, 0, 0, null, null, $composer_15, 1597488, 0, 262056);
          sourceInformationMarkerStart($composer_15, -1338214751, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = !!($composer_15.q31($viewModel) | $composer_15.k31($state$delegate));
          // Inline function 'kotlin.let' call
          var it_0 = $composer_15.i31();
          var tmp_16;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = CartMagicMugProductDetailsScreen$lambda$lambda_2($viewModel, $state$delegate);
            $composer_15.j31(value_0);
            tmp_16 = value_0;
          } else {
            tmp_16 = it_0;
          }
          var tmp1_group = tmp_16;
          sourceInformationMarkerEnd($composer_15);
          var tmp_17 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$37 = _Dp___init__impl__ms3zkb(32);
          var tmp_18 = size(tmp_17, tmp$ret$37);
          IconButton(tmp1_group, tmp_18, false, null, null, null, ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().m110_1, $composer_15, 1572912, 60);
          sourceInformationMarkerEnd($composer_15);
          $composer_13.e31();
          var tmp2_text = stringResource(get_bulk_discount_info(string_instance), $composer_10, 0);
          var tmp3_style = MaterialTheme_instance.jog($composer_10, 6).tof_1;
          var tmp4_color_0 = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
          var tmp5_fontSize = get_sp(10);
          var tmp6_fontWeight = Companion_getInstance_16().c7z_1;
          var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_21 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp2_text, null, tmp4_color_0, null, tmp5_fontSize, null, tmp6_fontWeight, null, tmp_19, null, null, tmp_20, tmp_21, false, 0, 0, null, tmp3_style, $composer_10, 1597440, 0, 130986);
          sourceInformationMarkerEnd($composer_10);
          $composer_8.e31();
          $composer_5.n30();
        } else {
          $composer_5.m30(772969116);
          $composer_5.n30();
        }
        // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
        var getContext = null;
        var $composer_16 = $composer_5;
        if (!((1 & 1) === 0)) {
          getContext = CartMagicMugProductDetailsScreen$lambda$lambda_3;
        }
        var composer = $composer_16;
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_1 = $composer_16.i31();
        var tmp_22;
        if (false || it_1 === Companion_getInstance().f30_1) {
          var value_1 = createCompositionCoroutineScope(getContext(), composer);
          $composer_16.j31(value_1);
          tmp_22 = value_1;
        } else {
          tmp_22 = it_1;
        }
        var scope = tmp_22;
        sourceInformationMarkerStart($composer_5, -1637630168, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_2 = $composer_5.i31();
        var tmp_23;
        if (false || it_2 === Companion_getInstance().f30_1) {
          var value_2 = mutableStateOf(false);
          $composer_5.j31(value_2);
          tmp_23 = value_2;
        } else {
          tmp_23 = it_2;
        }
        var tmp0_group_0 = tmp_23;
        sourceInformationMarkerEnd($composer_5);
        var isSaving$delegate = tmp0_group_0;
        var savedSuccessMsg = stringResource(get_saved_successfully(string_instance), $composer_5, 0);
        var failedToSaveMsg = stringResource(get_failed_to_save(string_instance), $composer_5, 0);
        var tmp_24 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$47 = _Dp___init__impl__ms3zkb(56);
        var tmp3_modifier_0 = heightIn(tmp_24, tmp$ret$47);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$48 = _Dp___init__impl__ms3zkb(16);
        var tmp4_shape = RoundedCornerShape(tmp$ret$48);
        var tmp_25 = ButtonDefaults_getInstance();
        var tmp_26 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
        var tmp_27 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_28 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp5_colors = tmp_25.ao9(tmp_26, tmp_27, tmp_28, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
        var tmp6_enabled = !CartMagicMugProductDetailsScreen$lambda_16(isSaving$delegate);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_29 = _Dp___init__impl__ms3zkb(4);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$50 = _Dp___init__impl__ms3zkb(4);
        var tmp7_contentPadding = PaddingValues_0(tmp_29, tmp$ret$50);
        sourceInformationMarkerStart($composer_5, -1637618196, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = !!(!!(!!(!!(!!(!!($composer_5.q31(scope) | $composer_5.k31($state$delegate)) | $composer_5.q31($p)) | $composer_5.q31($cartRepository)) | $composer_5.q31($cartItem)) | $composer_5.k31(savedSuccessMsg)) | $composer_5.k31(failedToSaveMsg));
        // Inline function 'kotlin.let' call
        var it_3 = $composer_5.i31();
        var tmp_30;
        if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
          var value_3 = CartMagicMugProductDetailsScreen$lambda$lambda_4(scope, isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, savedSuccessMsg, failedToSaveMsg);
          $composer_5.j31(value_3);
          tmp_30 = value_3;
        } else {
          tmp_30 = it_3;
        }
        var tmp1_group_0 = tmp_30;
        sourceInformationMarkerEnd($composer_5);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(334489814, true, CartMagicMugProductDetailsScreen$lambda$lambda_5(isSaving$delegate), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_17 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_17.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_17.i31();
        var tmp_31;
        if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
          var value_4 = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_17.j31(value_4);
          tmp_31 = value_4;
        } else {
          tmp_31 = it_4;
        }
        var tmp$ret$55 = tmp_31;
        Button(tmp1_group_0, tmp3_modifier_0, tmp6_enabled, tmp4_shape, tmp5_colors, null, null, tmp7_contentPadding, null, tmp$ret$55, $composer_5, 817889280, 352);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_32;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_32 = Unit_instance;
        }
        tmp = tmp_32;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$slambda_9($verticalScrollState, resultContinuation) {
    this.a115_1 = $verticalScrollState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMagicMugProductDetailsScreen$slambda_9).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_9).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_9).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.a115_1.tg7(0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMagicMugProductDetailsScreen$slambda_9).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartMagicMugProductDetailsScreen$slambda_9(this.a115_1, completion);
    i.b115_1 = $this$LaunchedEffect;
    return i;
  };
  function CartMagicMugProductDetailsScreen$slambda_10($verticalScrollState, resultContinuation) {
    var i = new CartMagicMugProductDetailsScreen$slambda_9($verticalScrollState, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CartMagicMugProductDetailsScreen$lambda_49($viewModel) {
    return function (bitmap, bytes, elements) {
      $viewModel.s10h().j10i(new CustomImageApplied_0(bitmap, bytes, elements));
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_50($viewModel) {
    return function () {
      $viewModel.s10h().j10i(CloseEditor_instance_0);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_51($viewModel, $p) {
    return function () {
      $viewModel.s10h().j10i(new LoadProduct_1($p));
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_52($showFullScreen3D$delegate) {
    return function () {
      CartMagicMugProductDetailsScreen$lambda_5($showFullScreen3D$delegate, false);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_53($showFullScreen3D$delegate, $viewModel) {
    return function () {
      CartMagicMugProductDetailsScreen$lambda_5($showFullScreen3D$delegate, false);
      $viewModel.s10h().j10i(OpenEditor_instance_0);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_54($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate) {
    return function () {
      CartMagicMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, false);
      CartMagicMugProductDetailsScreen$lambda_11($birthdayPickerTargetOptionKey$delegate, null);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda$lambda_6($birthdayPickerState, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $viewModel, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      var tmp0_safe_receiver = $birthdayPickerState.np1();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var date = toLocalDateTime(Companion_getInstance_19().kf(tmp0_safe_receiver), Companion_getInstance_20().yno_1).xn9_1.toString();
        if (!(CartMagicMugProductDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate) == null)) {
          var key = ensureNotNull(CartMagicMugProductDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate));
          var selectedValue = CartMagicMugProductDetailsScreen$lambda_1($state$delegate).w10z_1.w2(key);
          if (!(selectedValue == null)) {
            $viewModel.s10h().j10i(new OptionSelected_1(key, selectedValue.k101(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, date)));
          }
        } else if (CartMagicMugProductDetailsScreen$lambda_12($isPickingBoxBirthday$delegate)) {
          $viewModel.s10h().j10i(new BoxBirthdayChanged_1(date));
        } else {
          $viewModel.s10h().j10i(new CardBirthdayChanged_1(date));
        }
      }
      CartMagicMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, false);
      CartMagicMugProductDetailsScreen$lambda_11($birthdayPickerTargetOptionKey$delegate, null);
      CartMagicMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_55($birthdayPickerState, $state$delegate, $viewModel, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C759@42693L1500,759@42672L1562:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1167808602, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMagicMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous> (CartMagicMugProductDetailsScreen.kt:759)');
        }
        sourceInformationMarkerStart($composer_0, 1277604502, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.k31($birthdayPickerState) | $composer_0.k31($state$delegate)) | $composer_0.q31($viewModel));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CartMagicMugProductDetailsScreen$lambda$lambda_6($birthdayPickerState, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $viewModel, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().p110_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda$lambda_7($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function () {
      CartMagicMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, false);
      CartMagicMugProductDetailsScreen$lambda_11($birthdayPickerTargetOptionKey$delegate, null);
      CartMagicMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_56($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C784@44297L189,784@44276L255:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1076498396, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMagicMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous> (CartMagicMugProductDetailsScreen.kt:784)');
        }
        sourceInformationMarkerStart($composer_0, -572158855, 'CC(remember):CartMagicMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CartMagicMugProductDetailsScreen$lambda$lambda_7($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$CartMagicMugProductDetailsScreenKt_getInstance().q110_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_57($birthdayPickerState) {
    return function ($this$DatePickerDialog, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C789@44554L39:CartMagicMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(396564017, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMagicMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous> (CartMagicMugProductDetailsScreen.kt:789)');
        }
        DatePicker($birthdayPickerState, null, null, null, null, null, false, null, $composer_0, 0, 254);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMagicMugProductDetailsScreen$lambda_58($cartItem, $onBack, $onNavigateToAuth, $topPadding, $bottomPadding, $$changed, $$default) {
    return function ($composer, $force) {
      CartMagicMugProductDetailsScreen($cartItem, $onBack, $onNavigateToAuth, $topPadding._v.m5f_1, $bottomPadding._v.m5f_1, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_cart_details_CartMagicMugProductDetailsViewModel$stable;
  function CartMagicMugProductDetailsViewModel$observeLanguage$slambda$slambda$lambda($language) {
    return function ($this$updateState) {
      return $this$updateState.x10y(VOID, VOID, VOID, VOID, $language);
    };
  }
  function CartMagicMugProductDetailsViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation) {
    this.k115_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMagicMugProductDetailsViewModel$observeLanguage$slambda$slambda).pyo = function (language, $completion) {
    var tmp = this.um9(language, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMagicMugProductDetailsViewModel$observeLanguage$slambda$slambda).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMagicMugProductDetailsViewModel$observeLanguage$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.k115_1.x10k(CartMagicMugProductDetailsViewModel$observeLanguage$slambda$slambda$lambda(this.l115_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CartMagicMugProductDetailsViewModel$observeLanguage$slambda$slambda).um9 = function (language, completion) {
    var i = new CartMagicMugProductDetailsViewModel$observeLanguage$slambda$slambda(this.k115_1, completion);
    i.l115_1 = language;
    return i;
  };
  function CartMagicMugProductDetailsViewModel$observeLanguage$slambda$slambda_0(this$0, resultContinuation) {
    var i = new CartMagicMugProductDetailsViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (language, $completion) {
      return i.pyo(language, $completion);
    }, 1);
  }
  function observeLanguage_0($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, CartMagicMugProductDetailsViewModel$observeLanguage$slambda_0($this, null));
  }
  function CartMagicMugProductDetailsViewModel$observeLanguage$slambda(this$0, resultContinuation) {
    this.u115_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMagicMugProductDetailsViewModel$observeLanguage$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMagicMugProductDetailsViewModel$observeLanguage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMagicMugProductDetailsViewModel$observeLanguage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.u115_1.a116_1.y103();
            var action = CartMagicMugProductDetailsViewModel$observeLanguage$slambda$slambda_0(this.u115_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMagicMugProductDetailsViewModel$observeLanguage$slambda).q24 = function ($this$launch, completion) {
    var i = new CartMagicMugProductDetailsViewModel$observeLanguage$slambda(this.u115_1, completion);
    i.v115_1 = $this$launch;
    return i;
  };
  function CartMagicMugProductDetailsViewModel$observeLanguage$slambda_0(this$0, resultContinuation) {
    var i = new CartMagicMugProductDetailsViewModel$observeLanguage$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CartMagicMugProductDetailsViewModel$handleIntent$lambda($item) {
    return function ($this$updateState) {
      return $this$updateState.x10y($item, null, true, null);
    };
  }
  function CartMagicMugProductDetailsViewModel$handleIntent$lambda_0($bitmap) {
    return function ($this$updateState) {
      return $this$updateState.x10y(VOID, $bitmap, false);
    };
  }
  function CartMagicMugProductDetailsViewModel$handleIntent$lambda_1($this$updateState) {
    return $this$updateState.x10y(VOID, VOID, false, new ResourceString(get_failed_load_product_design(string_instance), []));
  }
  function $handleIntentCOROUTINE$_2(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l116_1 = _this__u8e3s4;
    this.m116_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_2).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            if (this.m116_1 instanceof LoadItem) {
              var item = this.m116_1.o116_1;
              this.l116_1.x10k(CartMagicMugProductDetailsViewModel$handleIntent$lambda(item));
              this.o9_1 = 3;
              if (!(item.xyw_1 == null)) {
                var tmp_0 = this;
                tmp_0.n116_1 = decodeToImageBitmap(ensureNotNull(item.xyw_1));
                this.n9_1 = 2;
                continue $sm;
              } else {
                var tmp_1;
                var this_0 = item.syw_1;
                if (!(this_0 == null || isBlank(this_0))) {
                  tmp_1 = this.l116_1.c116_1.fz1().u1();
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  this.n9_1 = 1;
                  suspendResult = this.l116_1.b116_1.h106(ensureNotNull(item.syw_1), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_2 = this;
                  tmp_2.n116_1 = null;
                  this.n9_1 = 2;
                  continue $sm;
                }
              }
            } else {
              noWhenBranchMatchedException();
            }

            break;
          case 1:
            var tmp1_safe_receiver = suspendResult;
            var tmp_3 = this;
            var tmp_4;
            if (tmp1_safe_receiver == null) {
              tmp_4 = null;
            } else {
              tmp_4 = decodeToImageBitmap(tmp1_safe_receiver);
            }

            tmp_3.n116_1 = tmp_4;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var bitmap = this.n116_1;
            this.l116_1.x10k(CartMagicMugProductDetailsViewModel$handleIntent$lambda_0(bitmap));
            this.o9_1 = 6;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_5 = this.q9_1;
            if (tmp_5 instanceof Exception) {
              var e = this.q9_1;
              this.l116_1.x10k(CartMagicMugProductDetailsViewModel$handleIntent$lambda_1);
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function CartMagicMugProductDetailsViewModel(getLanguageUseCase, downloadDesignImageUseCase, networkObserver) {
    BaseMviViewModel.call(this, new CartMagicMugProductDetailsState());
    this.a116_1 = getLanguageUseCase;
    this.b116_1 = downloadDesignImageUseCase;
    this.c116_1 = networkObserver;
    observeLanguage_0(this);
  }
  protoOf(CartMagicMugProductDetailsViewModel).p116 = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_2(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMagicMugProductDetailsViewModel).f10l = function (intent, $completion) {
    return this.p116(isInterface(intent, CartMagicMugProductDetailsIntent) ? intent : THROW_CCE(), $completion);
  };
  var client_fstech_hadaya_presentation_cart_details_CartMugProductDetailsState$stable;
  var client_fstech_hadaya_presentation_cart_details_CartMugProductDetailsIntent_LoadItem$stable;
  var client_fstech_hadaya_presentation_cart_details_CartMugProductDetailsSideEffect_NavigateBack$stable;
  function CartMugProductDetailsState(cartItem, customImageBitmap, loading, error, language) {
    cartItem = cartItem === VOID ? null : cartItem;
    customImageBitmap = customImageBitmap === VOID ? null : customImageBitmap;
    loading = loading === VOID ? false : loading;
    error = error === VOID ? null : error;
    language = language === VOID ? 'en' : language;
    this.q116_1 = cartItem;
    this.r116_1 = customImageBitmap;
    this.s116_1 = loading;
    this.t116_1 = error;
    this.u116_1 = language;
  }
  protoOf(CartMugProductDetailsState).w10y = function (cartItem, customImageBitmap, loading, error, language) {
    return new CartMugProductDetailsState(cartItem, customImageBitmap, loading, error, language);
  };
  protoOf(CartMugProductDetailsState).v116 = function (cartItem, customImageBitmap, loading, error, language, $super) {
    cartItem = cartItem === VOID ? this.q116_1 : cartItem;
    customImageBitmap = customImageBitmap === VOID ? this.r116_1 : customImageBitmap;
    loading = loading === VOID ? this.s116_1 : loading;
    error = error === VOID ? this.t116_1 : error;
    language = language === VOID ? this.u116_1 : language;
    return $super === VOID ? this.w10y(cartItem, customImageBitmap, loading, error, language) : $super.w10y.call(this, cartItem, customImageBitmap, loading, error, language);
  };
  protoOf(CartMugProductDetailsState).toString = function () {
    return 'CartMugProductDetailsState(cartItem=' + toString_0(this.q116_1) + ', customImageBitmap=' + toString_0(this.r116_1) + ', loading=' + this.s116_1 + ', error=' + toString_0(this.t116_1) + ', language=' + this.u116_1 + ')';
  };
  protoOf(CartMugProductDetailsState).hashCode = function () {
    var result = this.q116_1 == null ? 0 : this.q116_1.hashCode();
    result = imul(result, 31) + (this.r116_1 == null ? 0 : hashCode(this.r116_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s116_1) | 0;
    result = imul(result, 31) + (this.t116_1 == null ? 0 : hashCode(this.t116_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.u116_1) | 0;
    return result;
  };
  protoOf(CartMugProductDetailsState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CartMugProductDetailsState))
      return false;
    if (!equals(this.q116_1, other.q116_1))
      return false;
    if (!equals(this.r116_1, other.r116_1))
      return false;
    if (!(this.s116_1 === other.s116_1))
      return false;
    if (!equals(this.t116_1, other.t116_1))
      return false;
    if (!(this.u116_1 === other.u116_1))
      return false;
    return true;
  };
  function LoadItem_0() {
  }
  function CartMugProductDetailsIntent() {
  }
  function CartMugProductDetailsScreen(cartItem, onBack, onNavigateToAuth, topPadding, bottomPadding, $composer, $changed, $default) {
    var topPadding_0 = {_v: new Dp(topPadding)};
    var bottomPadding_0 = {_v: new Dp(bottomPadding)};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1258419071);
    sourceInformation($composer_0, 'C(CartMugProductDetailsScreen)P(1,2,3,4:c#ui.unit.Dp,0:c#ui.unit.Dp)70@3466L12,71@3521L12,72@3553L43,74@3637L105,74@3602L140:CartMugProductDetailsScreen.kt#6ni00');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(cartItem) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToAuth) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.n31(_Dp___get_value__impl__geb1vb(topPadding_0._v.m5f_1)) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.n31(_Dp___get_value__impl__geb1vb(bottomPadding_0._v.m5f_1)) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
        topPadding_0._v = new Dp(tmp$ret$0);
      }
      if (!(($default & 16) === 0)) {
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(0);
        bottomPadding_0._v = new Dp(tmp$ret$1);
      }
      if (isTraceInProgress()) {
        traceEventStart(-1258419071, $dirty, -1, 'client.fstech.hadaya.presentation.cart.details.CartMugProductDetailsScreen (CartMugProductDetailsScreen.kt:69)');
      }
      // Inline function 'org.koin.compose.koinInject' call
      var qualifier = null;
      var scope = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -1168520582, 'CC(koinInject)88@2750L18,90@2787L73:Inject.kt#8jjlyv');
      if (!((3 & 1) === 0))
        qualifier = null;
      if (!((3 & 2) === 0))
        scope = currentKoinScope($composer_1, 0);
      sourceInformationMarkerStart($composer_1, -1961811197, 'CC(remember):Inject.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_1.k31(qualifier) | $composer_1.k31(scope));
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = scope.ts6(getKClass(GetProductByIdUseCase), qualifier);
        $composer_1.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp1_group = tmp;
      sourceInformationMarkerEnd($composer_1);
      sourceInformationMarkerEnd($composer_1);
      var getProductByIdUseCase = tmp1_group;
      // Inline function 'org.koin.compose.koinInject' call
      var qualifier_0 = null;
      var scope_0 = null;
      var $composer_2 = $composer_0;
      sourceInformationMarkerStart($composer_2, -1168520582, 'CC(koinInject)88@2750L18,90@2787L73:Inject.kt#8jjlyv');
      if (!((3 & 1) === 0))
        qualifier_0 = null;
      if (!((3 & 2) === 0))
        scope_0 = currentKoinScope($composer_2, 0);
      sourceInformationMarkerStart($composer_2, -1961811197, 'CC(remember):Inject.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_2.k31(qualifier_0) | $composer_2.k31(scope_0));
      // Inline function 'kotlin.let' call
      var it_0 = $composer_2.i31();
      var tmp_0;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = scope_0.ts6(getKClass(ICartRepository), qualifier_0);
        $composer_2.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group_0 = tmp_0;
      sourceInformationMarkerEnd($composer_2);
      sourceInformationMarkerEnd($composer_2);
      var cartRepository = tmp1_group_0;
      sourceInformationMarkerStart($composer_0, 1840062028, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_0.i31();
      var tmp_1;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = mutableStateOf(null);
        this_0.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var product$delegate = tmp0_group;
      var tmp_2 = cartItem.gyw_1;
      sourceInformationMarkerStart($composer_0, 1840064778, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!($composer_0.q31(cartItem) | $composer_0.q31(getProductByIdUseCase));
      // Inline function 'kotlin.let' call
      var it_2 = tmp0.i31();
      var tmp_3;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = CartMugProductDetailsScreen$slambda_0(cartItem, getProductByIdUseCase, product$delegate, null);
        tmp0.j31(value_2);
        tmp_3 = value_2;
      } else {
        tmp_3 = it_2;
      }
      var tmp1_group_1 = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_2, tmp1_group_1, $composer_0, 0);
      var tmp0_safe_receiver = CartMugProductDetailsScreen$lambda(product$delegate);
      var tmp_4;
      if (tmp0_safe_receiver == null) {
        $composer_0.m30(1208816646);
        $composer_0.n30();
        tmp_4 = null;
      } else {
        $composer_0.m30(1208816647);
        sourceInformation($composer_0, '*81@3823L15,82@3914L12,83@3974L16,84@4023L32,89@4384L973,89@4366L991,111@5393L607,111@5367L633,126@6069L116,126@6010L175,130@6218L106,130@6195L129,136@6360L21,137@6417L34,138@6484L34,139@6552L34,141@6622L34,142@6702L42,143@6781L34,144@6849L34,145@6918L25,147@7077L227,147@6953L351,167@7729L36912');
        // Inline function 'kotlin.let' call
        // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
        var qualifier_1 = null;
        var viewModelStoreOwner = null;
        var key = null;
        var extras = null;
        var scope_1 = null;
        var parameters = null;
        var $composer_3 = $composer_0;
        sourceInformationMarkerStart($composer_3, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
        if (!((63 & 1) === 0))
          qualifier_1 = null;
        if (!((63 & 2) === 0)) {
          var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_3, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
          var tmp_5;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.error' call
            var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
            throw IllegalStateException_init_$Create$(toString(message));
          } else {
            tmp_5 = tmp0_elvis_lhs;
          }
          viewModelStoreOwner = tmp_5;
        }
        if (!((63 & 4) === 0))
          key = null;
        if (!((63 & 8) === 0))
          extras = defaultExtras(viewModelStoreOwner);
        if (!((63 & 16) === 0))
          scope_1 = currentKoinScope($composer_3, 0);
        if (!((63 & 32) === 0))
          parameters = null;
        var tmp0_0 = resolveViewModel(getKClass(CustomProductDetailsViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier_1, scope_1, parameters);
        sourceInformationMarkerEnd($composer_3);
        var viewModel = tmp0_0;
        // Inline function 'org.koin.compose.koinInject' call
        var qualifier_2 = null;
        var scope_2 = null;
        var $composer_4 = $composer_0;
        sourceInformationMarkerStart($composer_4, -1168520582, 'CC(koinInject)88@2750L18,90@2787L73:Inject.kt#8jjlyv');
        if (!((3 & 1) === 0))
          qualifier_2 = null;
        if (!((3 & 2) === 0))
          scope_2 = currentKoinScope($composer_4, 0);
        sourceInformationMarkerStart($composer_4, -1961811197, 'CC(remember):Inject.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = !!($composer_4.k31(qualifier_2) | $composer_4.k31(scope_2));
        // Inline function 'kotlin.let' call
        var it_3 = $composer_4.i31();
        var tmp_6;
        if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
          var value_3 = scope_2.ts6(getKClass(AppViewModel), qualifier_2);
          $composer_4.j31(value_3);
          tmp_6 = value_3;
        } else {
          tmp_6 = it_3;
        }
        var tmp1_group_2 = tmp_6;
        sourceInformationMarkerEnd($composer_4);
        sourceInformationMarkerEnd($composer_4);
        var appViewModel = tmp1_group_2;
        var tmp_7 = viewModel.s10h().ajg();
        var state$delegate = collectAsState(tmp_7, null, $composer_0, 0, 1);
        sourceInformationMarkerStart($composer_0, -1247111518, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_1 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_4 = this_1.i31();
        var tmp_8;
        if (false || it_4 === Companion_getInstance().f30_1) {
          var value_4 = new SnackbarHostState();
          this_1.j31(value_4);
          tmp_8 = value_4;
        } else {
          tmp_8 = it_4;
        }
        var tmp0_group_0 = tmp_8;
        sourceInformationMarkerEnd($composer_0);
        var snackbarHostState = tmp0_group_0;
        var language = CartMugProductDetailsScreen$lambda_1(state$delegate).d10z_1;
        var tmp_9;
        if (language === 'en') {
          var tmp0_elvis_lhs_0 = tmp0_safe_receiver.ozt_1;
          tmp_9 = tmp0_elvis_lhs_0 == null ? tmp0_safe_receiver.pzt_1 : tmp0_elvis_lhs_0;
        } else {
          var tmp1_elvis_lhs = tmp0_safe_receiver.pzt_1;
          tmp_9 = tmp1_elvis_lhs == null ? tmp0_safe_receiver.ozt_1 : tmp1_elvis_lhs;
        }
        var tmp2_elvis_lhs = tmp_9;
        var name = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
        var tmp_10;
        if (language === 'en') {
          var tmp3_elvis_lhs = tmp0_safe_receiver.qzt_1;
          tmp_10 = tmp3_elvis_lhs == null ? tmp0_safe_receiver.rzt_1 : tmp3_elvis_lhs;
        } else {
          var tmp4_elvis_lhs = tmp0_safe_receiver.rzt_1;
          tmp_10 = tmp4_elvis_lhs == null ? tmp0_safe_receiver.qzt_1 : tmp4_elvis_lhs;
        }
        var tmp5_elvis_lhs = tmp_10;
        var description = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
        sourceInformationMarkerStart($composer_0, -1247099025, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        var tmp0_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = !!(!!($composer_0.q31(viewModel) | $composer_0.q31(cartItem)) | $composer_0.q31(tmp0_safe_receiver));
        // Inline function 'kotlin.let' call
        var it_5 = tmp0_1.i31();
        var tmp_11;
        if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
          var value_5 = CartMugProductDetailsScreen$slambda_2(viewModel, cartItem, tmp0_safe_receiver, null);
          tmp0_1.j31(value_5);
          tmp_11 = value_5;
        } else {
          tmp_11 = it_5;
        }
        var tmp1_group_3 = tmp_11;
        sourceInformationMarkerEnd($composer_0);
        LaunchedEffect_0(tmp0_safe_receiver, tmp1_group_3, $composer_0, 0);
        sourceInformationMarkerStart($composer_0, -1247067103, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        var tmp0_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = !!(!!($composer_0.q31(viewModel) | ($dirty & 896) === 256) | ($dirty & 112) === 32);
        // Inline function 'kotlin.let' call
        var it_6 = tmp0_2.i31();
        var tmp_12;
        if (invalid_4 || it_6 === Companion_getInstance().f30_1) {
          var value_6 = CartMugProductDetailsScreen$slambda_4(viewModel, snackbarHostState, onNavigateToAuth, onBack, null);
          tmp0_2.j31(value_6);
          tmp_12 = value_6;
        } else {
          tmp_12 = it_6;
        }
        var tmp2_group = tmp_12;
        sourceInformationMarkerEnd($composer_0);
        LaunchedEffect_0(viewModel, tmp2_group, $composer_0, 0);
        var tmp_13 = CartMugProductDetailsScreen$lambda_1(state$delegate).a10z_1;
        var tmp_14 = CartMugProductDetailsScreen$lambda_1(state$delegate).g10z_1;
        sourceInformationMarkerStart($composer_0, -1247045962, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        var tmp0_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = !!($composer_0.q31(appViewModel) | $composer_0.k31(state$delegate));
        // Inline function 'kotlin.let' call
        var it_7 = tmp0_3.i31();
        var tmp_15;
        if (invalid_5 || it_7 === Companion_getInstance().f30_1) {
          var value_7 = CartMugProductDetailsScreen$slambda_6(appViewModel, state$delegate, null);
          tmp0_3.j31(value_7);
          tmp_15 = value_7;
        } else {
          tmp_15 = it_7;
        }
        var tmp3_group = tmp_15;
        sourceInformationMarkerEnd($composer_0);
        LaunchedEffect(tmp_13, tmp_14, tmp3_group, $composer_0, 0);
        sourceInformationMarkerStart($composer_0, -1247041204, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        var tmp0_4 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_6 = $composer_0.q31(appViewModel);
        // Inline function 'kotlin.let' call
        var it_8 = tmp0_4.i31();
        var tmp_16;
        if (invalid_6 || it_8 === Companion_getInstance().f30_1) {
          var value_8 = CartMugProductDetailsScreen$lambda_18(appViewModel);
          tmp0_4.j31(value_8);
          tmp_16 = value_8;
        } else {
          tmp_16 = it_8;
        }
        var tmp4_group = tmp_16;
        sourceInformationMarkerEnd($composer_0);
        DisposableEffect(Unit_instance, tmp4_group, $composer_0, 6);
        var verticalScrollState = rememberScrollState(0, $composer_0, 0, 1);
        sourceInformationMarkerStart($composer_0, -1247034908, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_2 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_9 = this_2.i31();
        var tmp_17;
        if (false || it_9 === Companion_getInstance().f30_1) {
          var value_9 = mutableStateOf(false);
          this_2.j31(value_9);
          tmp_17 = value_9;
        } else {
          tmp_17 = it_9;
        }
        var tmp5_group = tmp_17;
        sourceInformationMarkerEnd($composer_0);
        var isInteractingWith3D$delegate = tmp5_group;
        sourceInformationMarkerStart($composer_0, -1247032764, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_3 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_10 = this_3.i31();
        var tmp_18;
        if (false || it_10 === Companion_getInstance().f30_1) {
          var value_10 = mutableStateOf(false);
          this_3.j31(value_10);
          tmp_18 = value_10;
        } else {
          tmp_18 = it_10;
        }
        var tmp6_group = tmp_18;
        sourceInformationMarkerEnd($composer_0);
        var showFullScreen3D$delegate = tmp6_group;
        sourceInformationMarkerStart($composer_0, -1247030588, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_4 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_11 = this_4.i31();
        var tmp_19;
        if (false || it_11 === Companion_getInstance().f30_1) {
          var value_11 = mutableStateOf(false);
          this_4.j31(value_11);
          tmp_19 = value_11;
        } else {
          tmp_19 = it_11;
        }
        var tmp7_group = tmp_19;
        sourceInformationMarkerEnd($composer_0);
        var isMediaDialogOpen$delegate = tmp7_group;
        sourceInformationMarkerStart($composer_0, -1247028348, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_5 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_12 = this_5.i31();
        var tmp_20;
        if (false || it_12 === Companion_getInstance().f30_1) {
          var value_12 = mutableStateOf(false);
          this_5.j31(value_12);
          tmp_20 = value_12;
        } else {
          tmp_20 = it_12;
        }
        var tmp8_group = tmp_20;
        sourceInformationMarkerEnd($composer_0);
        var showBirthdayPicker$delegate = tmp8_group;
        sourceInformationMarkerStart($composer_0, -1247025780, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_6 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_13 = this_6.i31();
        var tmp_21;
        if (false || it_13 === Companion_getInstance().f30_1) {
          var value_13 = mutableStateOf(null);
          this_6.j31(value_13);
          tmp_21 = value_13;
        } else {
          tmp_21 = it_13;
        }
        var tmp9_group = tmp_21;
        sourceInformationMarkerEnd($composer_0);
        var birthdayPickerTargetOptionKey$delegate = tmp9_group;
        sourceInformationMarkerStart($composer_0, -1247023260, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_7 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_14 = this_7.i31();
        var tmp_22;
        if (false || it_14 === Companion_getInstance().f30_1) {
          var value_14 = mutableStateOf(false);
          this_7.j31(value_14);
          tmp_22 = value_14;
        } else {
          tmp_22 = it_14;
        }
        var tmp10_group = tmp_22;
        sourceInformationMarkerEnd($composer_0);
        var isPickingBoxBirthday$delegate = tmp10_group;
        sourceInformationMarkerStart($composer_0, -1247021084, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_8 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_15 = this_8.i31();
        var tmp_23;
        if (false || it_15 === Companion_getInstance().f30_1) {
          var value_15 = mutableStateOf(false);
          this_8.j31(value_15);
          tmp_23 = value_15;
        } else {
          tmp_23 = it_15;
        }
        var tmp11_group = tmp_23;
        sourceInformationMarkerEnd($composer_0);
        var showDiscardDialog$delegate = tmp11_group;
        var tmp_24 = _DisplayMode___init__impl__gfd230(0);
        var birthdayPickerState = rememberDatePickerState(null, null, null, tmp_24, null, $composer_0, 0, 31);
        var tmp_25;
        var tmp_26;
        if (CartMugProductDetailsScreen$lambda_1(state$delegate).a10z_1 || CartMugProductDetailsScreen$lambda_4(showFullScreen3D$delegate)) {
          tmp_26 = true;
        } else {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_26 = !CartMugProductDetailsScreen$lambda_1(state$delegate).g10z_1.r();
        }
        if (tmp_26) {
          tmp_25 = !CartMugProductDetailsScreen$lambda_1(state$delegate).h10z_1;
        } else {
          tmp_25 = false;
        }
        var tmp_27 = tmp_25;
        sourceInformationMarkerStart($composer_0, -1247013595, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        var tmp0_5 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_7 = $composer_0.k31(state$delegate);
        // Inline function 'kotlin.let' call
        var it_16 = tmp0_5.i31();
        var tmp_28;
        if (invalid_7 || it_16 === Companion_getInstance().f30_1) {
          var value_16 = CartMugProductDetailsScreen$lambda_19(showFullScreen3D$delegate, state$delegate, showDiscardDialog$delegate);
          tmp0_5.j31(value_16);
          tmp_28 = value_16;
        } else {
          tmp_28 = it_16;
        }
        var tmp12_group = tmp_28;
        sourceInformationMarkerEnd($composer_0);
        BackHandler(tmp_27, tmp12_group, $composer_0, 0, 0);
        if (CartMugProductDetailsScreen$lambda_14(showDiscardDialog$delegate)) {
          $composer_0.m30(-2453054);
          sourceInformation($composer_0, '157@7394L46,158@7468L44,159@7542L94,163@7666L29,156@7351L358');
          var tmp_29 = stringResource(get_discard_order_title(string_instance), $composer_0, 0);
          var tmp_30 = stringResource(get_discard_order_msg(string_instance), $composer_0, 0);
          sourceInformationMarkerStart($composer_0, -1246998848, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          var tmp0_6 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_8 = ($dirty & 112) === 32;
          // Inline function 'kotlin.let' call
          var it_17 = tmp0_6.i31();
          var tmp_31;
          if (invalid_8 || it_17 === Companion_getInstance().f30_1) {
            var value_17 = CartMugProductDetailsScreen$lambda_20(showDiscardDialog$delegate, onBack);
            tmp0_6.j31(value_17);
            tmp_31 = value_17;
          } else {
            tmp_31 = it_17;
          }
          var tmp13_group = tmp_31;
          sourceInformationMarkerEnd($composer_0);
          sourceInformationMarkerStart($composer_0, -1246994945, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var this_9 = $composer_0;
          // Inline function 'kotlin.let' call
          var it_18 = this_9.i31();
          var tmp_32;
          if (false || it_18 === Companion_getInstance().f30_1) {
            var value_18 = CartMugProductDetailsScreen$lambda_21(showDiscardDialog$delegate);
            this_9.j31(value_18);
            tmp_32 = value_18;
          } else {
            tmp_32 = it_18;
          }
          var tmp14_group = tmp_32;
          sourceInformationMarkerEnd($composer_0);
          HadayaAlertDialog(tmp_29, tmp_30, null, null, tmp13_group, tmp14_group, $composer_0, 196608, 12);
          $composer_0.n30();
        } else {
          $composer_0.m30(-2085952);
          $composer_0.n30();
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = fillMaxSize(Companion_instance);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_5 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_6 = $composer_5;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_6, 0).hashCode();
        var localMap = $composer_6.t31();
        var materialized = materialize($composer_6, modifier_0);
        var tmp0_7 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_7 = $composer_6;
        var tmp_33 = $composer_7.g30();
        if (!isInterface(tmp_33, Applier)) {
          invalidApplier();
        }
        $composer_7.b31();
        if ($composer_7.h30()) {
          $composer_7.c31(tmp0_7);
        } else {
          $composer_7.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_7);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_8 = $composer_7;
        var $composer_9 = $composer_8;
        sourceInformationMarkerStart($composer_9, 783726250, 'C701@39888L63,701@39832L119,729@41019L73,730@41122L28,731@41183L150,721@40668L679,751@42311L94:CartMugProductDetailsScreen.kt#6ni00');
        if (!CartMugProductDetailsScreen$lambda_1(state$delegate).h10z_1) {
          $composer_9.m30(783599180);
          sourceInformation($composer_9, '175@8072L34,176@8149L31,170@7863L336,180@8263L21737,547@30206L11,550@30371L9434,545@30058L9747');
          var tmp0_modifier = alpha(BoxScopeInstance_instance.udr(fillMaxWidth(Companion_instance, 0.8), Companion_getInstance_11().o8t_1), 0.03);
          var tmp1_painter = painterResource(get_logo(drawable_instance), $composer_9, 0);
          var tmp2_contentDescription = stringResource(get_logo_0(string_instance), $composer_9, 0);
          Image(tmp1_painter, tmp2_contentDescription, tmp0_modifier, null, null, 0.0, null, $composer_9, androidx_compose_ui_graphics_painter_Painter$stableprop_getter(), 120);
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_1 = zIndex(verticalScroll(fillMaxSize(Companion_instance), verticalScrollState, !CartMugProductDetailsScreen$lambda_1(state$delegate).a10z_1 && !CartMugProductDetailsScreen$lambda_2(isInteractingWith3D$delegate)), 0.0);
          var verticalArrangement = null;
          var horizontalAlignment = null;
          var $composer_10 = $composer_9;
          if (!((6 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((6 & 2) === 0))
            verticalArrangement = Arrangement_getInstance().sdp_1;
          if (!((6 & 4) === 0))
            horizontalAlignment = Companion_getInstance_11().w8t_1;
          var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_10, 14 & 0 >> 3 | 112 & 0 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_11 = $composer_10;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_11, 0).hashCode();
          var localMap_0 = $composer_11.t31();
          var materialized_0 = materialize($composer_11, modifier_2);
          var tmp0_8 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_12 = $composer_11;
          var tmp_34 = $composer_12.g30();
          if (!isInterface(tmp_34, Applier)) {
            invalidApplier();
          }
          $composer_12.b31();
          if ($composer_12.h30()) {
            $composer_12.c31(tmp0_8);
          } else {
            $composer_12.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_12);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_13 = $composer_12;
          var $composer_14 = $composer_13;
          sourceInformationMarkerStart($composer_14, -1361041283, 'C192@8878L11,187@8593L6973,305@15588L41,310@15813L26,307@15651L210,314@15935L14047:CartMugProductDetailsScreen.kt#6ni00');
          var tmp_35 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$102 = _Dp___init__impl__ms3zkb(400);
          var tmp_36 = height(tmp_35, tmp$ret$102);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp0_bottomStart = _Dp___init__impl__ms3zkb(32);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp1_bottomEnd = _Dp___init__impl__ms3zkb(32);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_3 = background(clip(tmp_36, RoundedCornerShape_0(VOID, VOID, tmp1_bottomEnd, tmp0_bottomStart)), Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_14, 6).oo0_1, 0.3));
          var contentAlignment_0 = null;
          var propagateMinConstraints_0 = false;
          var $composer_15 = $composer_14;
          if (!((6 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_0 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_0 = false;
          var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_16 = $composer_15;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_16, 0).hashCode();
          var localMap_1 = $composer_16.t31();
          var materialized_1 = materialize($composer_16, modifier_4);
          var tmp0_9 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_17 = $composer_16;
          var tmp_37 = $composer_17.g30();
          if (!isInterface(tmp_37, Applier)) {
            invalidApplier();
          }
          $composer_17.b31();
          if ($composer_17.h30()) {
            $composer_17.c31(tmp0_9);
          } else {
            $composer_17.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_17);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_18 = $composer_17;
          var $composer_19 = $composer_18;
          sourceInformationMarkerStart($composer_19, -1005987104, 'C196@9098L402,195@9012L1598,224@10682L3097,280@14208L11,275@13906L27,283@14380L1164,274@13859L1685:CartMugProductDetailsScreen.kt#6ni00');
          var tmp_38 = fillMaxSize(Companion_instance);
          sourceInformationMarkerStart($composer_19, -32454575, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_19 = $composer_19.i31();
          var tmp_39;
          if (false || it_19 === Companion_getInstance().f30_1) {
            var tmp_40 = CartMugProductDetailsScreen$slambda_8(isInteractingWith3D$delegate, null);
            var value_19 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0(tmp_40);
            $composer_19.j31(value_19);
            tmp_39 = value_19;
          } else {
            tmp_39 = it_19;
          }
          var tmp0_group_1 = tmp_39;
          sourceInformationMarkerEnd($composer_19);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_5 = pointerInput(tmp_38, Unit_instance, tmp0_group_1);
          var contentAlignment_1 = null;
          var propagateMinConstraints_1 = false;
          var $composer_20 = $composer_19;
          if (!((6 & 1) === 0))
            modifier_5 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_1 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_1 = false;
          var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_6 = modifier_5;
          var $composer_21 = $composer_20;
          if (!((0 & 2) === 0))
            modifier_6 = Companion_instance;
          var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_21, 0).hashCode();
          var localMap_2 = $composer_21.t31();
          var materialized_2 = materialize($composer_21, modifier_6);
          var tmp0_10 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_22 = $composer_21;
          var tmp_41 = $composer_22.g30();
          if (!isInterface(tmp_41, Applier)) {
            invalidApplier();
          }
          $composer_22.b31();
          if ($composer_22.h30()) {
            $composer_22.c31(tmp0_10);
          } else {
            $composer_22.d31();
          }
          var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_22);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
          var $composer_23 = $composer_22;
          var $composer_24 = $composer_23;
          sourceInformationMarkerStart($composer_24, -552905765, 'C:CartMugProductDetailsScreen.kt#6ni00');
          if (!CartMugProductDetailsScreen$lambda_4(showFullScreen3D$delegate)) {
            $composer_24.m30(-552883663);
            sourceInformation($composer_24, '212@10009L149,206@9614L940');
            var tmp_42 = CartMugProductDetailsScreen$lambda_1(state$delegate).i10z_1;
            var tmp_43 = CartMugProductDetailsScreen$lambda_1(state$delegate).j10z_1;
            var tmp_44 = ProductKind_MUG_getInstance();
            var tmp_45 = CartMugProductDetailsScreen$lambda_1(state$delegate).e10z_1;
            var tmp_46 = CartMugProductDetailsScreen$lambda_1(state$delegate).f10z_1;
            sourceInformationMarkerStart($composer_24, 2060387898, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_9 = !!($composer_24.q31(viewModel) | $composer_24.q31(tmp0_safe_receiver));
            // Inline function 'kotlin.let' call
            var it_20 = $composer_24.i31();
            var tmp_47;
            if (invalid_9 || it_20 === Companion_getInstance().f30_1) {
              var value_20 = CartMugProductDetailsScreen$lambda_22(viewModel, tmp0_safe_receiver);
              $composer_24.j31(value_20);
              tmp_47 = value_20;
            } else {
              tmp_47 = it_20;
            }
            var tmp0_group_2 = tmp_47;
            sourceInformationMarkerEnd($composer_24);
            Model3DViewerSection(tmp_42, tmp_43, tmp_44, tmp_45, tmp_46, tmp0_group_2, fillMaxSize(Companion_instance), !CartMugProductDetailsScreen$lambda_14(showDiscardDialog$delegate) && !CartMugProductDetailsScreen$lambda_8(showBirthdayPicker$delegate) && !CartMugProductDetailsScreen$lambda_1(state$delegate).a10z_1 && !CartMugProductDetailsScreen$lambda_1(state$delegate).h10z_1 && !CartMugProductDetailsScreen$lambda_6(isMediaDialogOpen$delegate), _Dp___get_value__impl__geb1vb(topPadding_0._v.m5f_1), _Dp___get_value__impl__geb1vb(bottomPadding_0._v.m5f_1), $composer_24, 1573248, 0);
            $composer_24.n30();
          } else {
            $composer_24.m30(-551918819);
            $composer_24.n30();
          }
          sourceInformationMarkerEnd($composer_24);
          $composer_22.e31();
          var tmp0_$receiver = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp1_top = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp2_start = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp3_end = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_7 = padding_1(tmp0_$receiver, tmp2_start, tmp1_top, tmp3_end);
          var horizontalArrangement = Arrangement_getInstance().wdp_1;
          var verticalAlignment = null;
          var $composer_25 = $composer_19;
          if (!((4 & 1) === 0))
            modifier_7 = Companion_instance;
          if (!((4 & 2) === 0))
            horizontalArrangement = Arrangement_getInstance().qdp_1;
          if (!((4 & 4) === 0))
            verticalAlignment = Companion_getInstance_11().t8t_1;
          var measurePolicy_3 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_25, 14 & 48 >> 3 | 112 & 48 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_8 = modifier_7;
          var $composer_26 = $composer_25;
          if (!((0 & 2) === 0))
            modifier_8 = Companion_instance;
          var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_26, 0).hashCode();
          var localMap_3 = $composer_26.t31();
          var materialized_3 = materialize($composer_26, modifier_8);
          var tmp0_11 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_27 = $composer_26;
          var tmp_48 = $composer_27.g30();
          if (!isInterface(tmp_48, Applier)) {
            invalidApplier();
          }
          $composer_27.b31();
          if ($composer_27.h30()) {
            $composer_27.c31(tmp0_11);
          } else {
            $composer_27.d31();
          }
          var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_27);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
          var $composer_28 = $composer_27;
          var $composer_29 = $composer_28;
          sourceInformationMarkerStart($composer_29, -541709602, 'C231@11050L333,239@11492L11,230@10999L946,247@11975L1778:CartMugProductDetailsScreen.kt#6ni00');
          sourceInformationMarkerStart($composer_29, 398166704, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_10 = !!($composer_0.k31(state$delegate) | ($dirty & 112) === 32);
          // Inline function 'kotlin.let' call
          var it_21 = $composer_29.i31();
          var tmp_49;
          if (invalid_10 || it_21 === Companion_getInstance().f30_1) {
            var value_21 = CartMugProductDetailsScreen$lambda_23(state$delegate, showDiscardDialog$delegate, onBack);
            $composer_29.j31(value_21);
            tmp_49 = value_21;
          } else {
            tmp_49 = it_21;
          }
          var tmp0_group_3 = tmp_49;
          sourceInformationMarkerEnd($composer_29);
          var tmp_50 = get_CircleShape();
          var tmp_51 = MaterialTheme_instance.unz($composer_29, 6).mo0_1;
          var tmp_52 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_53 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_54 = _Dp___init__impl__ms3zkb(4);
          Surface_0(tmp0_group_3, null, false, tmp_50, tmp_51, tmp_52, tmp_53, tmp_54, null, null, ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().w116_1, $composer_29, 12582912, 6, 870);
          var tmp_55 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$139 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_9 = null;
          var horizontalArrangement_0 = tmp_55.mdq(tmp$ret$139);
          var verticalAlignment_0 = null;
          var $composer_30 = $composer_29;
          if (!((5 & 1) === 0))
            modifier_9 = Companion_instance;
          if (!((5 & 2) === 0))
            horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
          if (!((5 & 4) === 0))
            verticalAlignment_0 = Companion_getInstance_11().t8t_1;
          var measurePolicy_4 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_30, 14 & 48 >> 3 | 112 & 48 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_10 = modifier_9;
          var $composer_31 = $composer_30;
          if (!((0 & 2) === 0))
            modifier_10 = Companion_instance;
          var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_31, 0).hashCode();
          var localMap_4 = $composer_31.t31();
          var materialized_4 = materialize($composer_31, modifier_10);
          var tmp0_12 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_32 = $composer_31;
          var tmp_56 = $composer_32.g30();
          if (!isInterface(tmp_56, Applier)) {
            invalidApplier();
          }
          $composer_32.b31();
          if ($composer_32.h30()) {
            $composer_32.c31(tmp0_12);
          } else {
            $composer_32.d31();
          }
          var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_32);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
          var $composer_33 = $composer_32;
          var $composer_34 = $composer_33;
          sourceInformationMarkerStart($composer_34, 1716438466, 'C249@12120L73,251@12310L11,253@12424L589,248@12065L948,261@13101L71,263@13289L11,260@13046L677:CartMugProductDetailsScreen.kt#6ni00');
          sourceInformationMarkerStart($composer_34, -1745746160, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_11 = $composer_34.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_22 = $composer_34.i31();
          var tmp_57;
          if (invalid_11 || it_22 === Companion_getInstance().f30_1) {
            var value_22 = CartMugProductDetailsScreen$lambda_24(viewModel);
            $composer_34.j31(value_22);
            tmp_57 = value_22;
          } else {
            tmp_57 = it_22;
          }
          var tmp0_group_4 = tmp_57;
          sourceInformationMarkerEnd($composer_34);
          var tmp_58 = get_CircleShape();
          var tmp_59 = MaterialTheme_instance.unz($composer_34, 6).mo0_1;
          var tmp_60 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_61 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_62 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-2102011214, true, CartMugProductDetailsScreen$lambda_25(state$delegate), $composer_34, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_35 = $composer_34;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_12 = $composer_35.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_23 = $composer_35.i31();
          var tmp_63;
          if (invalid_12 || it_23 === Companion_getInstance().f30_1) {
            var value_23 = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_35.j31(value_23);
            tmp_63 = value_23;
          } else {
            tmp_63 = it_23;
          }
          var tmp$ret$151 = tmp_63;
          Surface_0(tmp0_group_4, null, false, tmp_58, tmp_59, tmp_60, tmp_61, tmp_62, null, null, tmp$ret$151, $composer_34, 12582912, 6, 870);
          sourceInformationMarkerStart($composer_34, -1745714770, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_13 = $composer_34.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_24 = $composer_34.i31();
          var tmp_64;
          if (invalid_13 || it_24 === Companion_getInstance().f30_1) {
            var value_24 = CartMugProductDetailsScreen$lambda_26(viewModel);
            $composer_34.j31(value_24);
            tmp_64 = value_24;
          } else {
            tmp_64 = it_24;
          }
          var tmp1_group_4 = tmp_64;
          sourceInformationMarkerEnd($composer_34);
          var tmp_65 = get_CircleShape();
          var tmp_66 = MaterialTheme_instance.unz($composer_34, 6).mo0_1;
          var tmp_67 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_68 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_69 = _Dp___init__impl__ms3zkb(4);
          Surface_0(tmp1_group_4, null, false, tmp_65, tmp_66, tmp_67, tmp_68, tmp_69, null, null, ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().y116_1, $composer_34, 12582912, 6, 870);
          sourceInformationMarkerEnd($composer_34);
          $composer_32.e31();
          sourceInformationMarkerEnd($composer_29);
          $composer_27.e31();
          var tmp4_$receiver = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().s8t_1);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp5_bottom = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp6_end = _Dp___init__impl__ms3zkb(16);
          var tmp7_modifier = zIndex(padding_1(tmp4_$receiver, VOID, VOID, tmp6_end, tmp5_bottom), 2.0);
          var tmp8_color = MaterialTheme_instance.unz($composer_19, 6).eo0_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$165 = _Dp___init__impl__ms3zkb(24);
          var tmp9_shape = RoundedCornerShape(tmp$ret$165);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp10_shadowElevation = _Dp___init__impl__ms3zkb(6);
          sourceInformationMarkerStart($composer_19, -32301094, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_25 = $composer_19.i31();
          var tmp_70;
          if (false || it_25 === Companion_getInstance().f30_1) {
            var value_25 = CartMugProductDetailsScreen$lambda_27(showFullScreen3D$delegate);
            $composer_19.j31(value_25);
            tmp_70 = value_25;
          } else {
            tmp_70 = it_25;
          }
          var tmp1_group_5 = tmp_70;
          sourceInformationMarkerEnd($composer_19);
          var tmp_71 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_72 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_0 = rememberComposableLambda(-921999510, true, CartMugProductDetailsScreen$lambda_28(language), $composer_19, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_36 = $composer_19;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_14 = $composer_36.k31(dispatchReceiver_0);
          // Inline function 'kotlin.let' call
          var it_26 = $composer_36.i31();
          var tmp_73;
          if (invalid_14 || it_26 === Companion_getInstance().f30_1) {
            var value_26 = ComposableLambda$invoke$ref(dispatchReceiver_0);
            $composer_36.j31(value_26);
            tmp_73 = value_26;
          } else {
            tmp_73 = it_26;
          }
          var tmp$ret$171 = tmp_73;
          Surface_0(tmp1_group_5, tmp7_modifier, false, tmp9_shape, tmp8_color, tmp_71, tmp_72, tmp10_shadowElevation, null, null, tmp$ret$171, $composer_19, 12582918, 6, 868);
          sourceInformationMarkerEnd($composer_19);
          $composer_17.e31();
          var tmp_74 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$178 = _Dp___init__impl__ms3zkb(24);
          Spacer(height(tmp_74, tmp$ret$178), $composer_14, 6);
          sourceInformationMarkerStart($composer_14, -459336877, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_27 = $composer_14.i31();
          var tmp_75;
          if (false || it_27 === Companion_getInstance().f30_1) {
            var value_27 = CartMugProductDetailsScreen$lambda_29(isMediaDialogOpen$delegate);
            $composer_14.j31(value_27);
            tmp_75 = value_27;
          } else {
            tmp_75 = it_27;
          }
          var tmp0_group_5 = tmp_75;
          sourceInformationMarkerEnd($composer_14);
          ProductMediaGallerySection(tmp0_safe_receiver, language, tmp0_group_5, $composer_14, 384, 0);
          var tmp_76 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$183 = _Dp___init__impl__ms3zkb(24);
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_11 = padding_2(tmp_76, tmp$ret$183);
          var verticalArrangement_0 = null;
          var horizontalAlignment_0 = null;
          var $composer_37 = $composer_14;
          if (!((6 & 1) === 0))
            modifier_11 = Companion_instance;
          if (!((6 & 2) === 0))
            verticalArrangement_0 = Arrangement_getInstance().sdp_1;
          if (!((6 & 4) === 0))
            horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
          var measurePolicy_5 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_37, 14 & 6 >> 3 | 112 & 6 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_12 = modifier_11;
          var $composer_38 = $composer_37;
          if (!((0 & 2) === 0))
            modifier_12 = Companion_instance;
          var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_38, 0).hashCode();
          var localMap_5 = $composer_38.t31();
          var materialized_5 = materialize($composer_38, modifier_12);
          var tmp0_13 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_39 = $composer_38;
          var tmp_77 = $composer_39.g30();
          if (!isInterface(tmp_77, Applier)) {
            invalidApplier();
          }
          $composer_39.b31();
          if ($composer_39.h30()) {
            $composer_39.c31(tmp0_13);
          } else {
            $composer_39.d31();
          }
          var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_39);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
          var $composer_40 = $composer_39;
          var $composer_41 = $composer_40;
          sourceInformationMarkerStart($composer_41, 1697418941, 'C317@16114L10,319@16254L11,315@16017L287,322@16330L41,325@16432L2388,357@18846L41,359@19014L10,359@18913L122,361@19061L41,507@28147L41,511@28335L106,509@28214L480,517@28720L41,519@28811L182,525@29019L41,528@29124L701,538@29851L41,540@29918L42:CartMugProductDetailsScreen.kt#6ni00');
          var tmp0_style = MaterialTheme_instance.jog($composer_41, 6).jof_1;
          var tmp1_fontWeight = Companion_getInstance_16().f7z_1;
          var tmp2_color = MaterialTheme_instance.unz($composer_41, 6).lo0_1;
          var tmp_78 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_79 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_80 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_81 = _TextOverflow___init__impl__obguoe(0);
          Text(name, null, tmp2_color, null, tmp_78, null, tmp1_fontWeight, null, tmp_79, null, null, tmp_80, tmp_81, false, 0, 0, null, tmp0_style, $composer_41, 1572864, 0, 131002);
          var tmp_82 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$190 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_82, tmp$ret$190), $composer_41, 6);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_13 = fillMaxWidth(Companion_instance);
          var horizontalArrangement_1 = Arrangement_getInstance().wdp_1;
          var verticalAlignment_1 = Companion_getInstance_11().u8t_1;
          var $composer_42 = $composer_41;
          if (!((0 & 1) === 0))
            modifier_13 = Companion_instance;
          if (!((0 & 2) === 0))
            horizontalArrangement_1 = Arrangement_getInstance().qdp_1;
          if (!((0 & 4) === 0))
            verticalAlignment_1 = Companion_getInstance_11().t8t_1;
          var measurePolicy_6 = rowMeasurePolicy(horizontalArrangement_1, verticalAlignment_1, $composer_42, 14 & 438 >> 3 | 112 & 438 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_14 = modifier_13;
          var $composer_43 = $composer_42;
          if (!((0 & 2) === 0))
            modifier_14 = Companion_instance;
          var compositeKeyHash_6 = get_currentCompositeKeyHashCode($composer_43, 0).hashCode();
          var localMap_6 = $composer_43.t31();
          var materialized_6 = materialize($composer_43, modifier_14);
          var tmp0_14 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_44 = $composer_43;
          var tmp_83 = $composer_44.g30();
          if (!isInterface(tmp_83, Applier)) {
            invalidApplier();
          }
          $composer_44.b31();
          if ($composer_44.h30()) {
            $composer_44.c31(tmp0_14);
          } else {
            $composer_44.d31();
          }
          var $this$ReusableComposeNode_6 = _Updater___init__impl__rbfxm8($composer_44);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, measurePolicy_6, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, localMap_6, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, compositeKeyHash_6, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_6, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, materialized_6, Companion_getInstance_12().qah_1);
          var $composer_45 = $composer_44;
          var $composer_46 = $composer_45;
          sourceInformationMarkerStart($composer_46, 449273420, 'C330@16710L2084:CartMugProductDetailsScreen.kt#6ni00');
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_15 = null;
          var verticalArrangement_1 = null;
          var horizontalAlignment_1 = null;
          var $composer_47 = $composer_46;
          if (!((7 & 1) === 0))
            modifier_15 = Companion_instance;
          if (!((7 & 2) === 0))
            verticalArrangement_1 = Arrangement_getInstance().sdp_1;
          if (!((7 & 4) === 0))
            horizontalAlignment_1 = Companion_getInstance_11().w8t_1;
          var measurePolicy_7 = columnMeasurePolicy(verticalArrangement_1, horizontalAlignment_1, $composer_47, 14 & 0 >> 3 | 112 & 0 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_16 = modifier_15;
          var $composer_48 = $composer_47;
          if (!((0 & 2) === 0))
            modifier_16 = Companion_instance;
          var compositeKeyHash_7 = get_currentCompositeKeyHashCode($composer_48, 0).hashCode();
          var localMap_7 = $composer_48.t31();
          var materialized_7 = materialize($composer_48, modifier_16);
          var tmp0_15 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_49 = $composer_48;
          var tmp_84 = $composer_49.g30();
          if (!isInterface(tmp_84, Applier)) {
            invalidApplier();
          }
          $composer_49.b31();
          if ($composer_49.h30()) {
            $composer_49.c31(tmp0_15);
          } else {
            $composer_49.d31();
          }
          var $this$ReusableComposeNode_7 = _Updater___init__impl__rbfxm8($composer_49);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, measurePolicy_7, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, localMap_7, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, compositeKeyHash_7, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_7, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, materialized_7, Companion_getInstance_12().qah_1);
          var $composer_50 = $composer_49;
          var $composer_51 = $composer_50;
          sourceInformationMarkerStart($composer_51, -1535795971, 'C:CartMugProductDetailsScreen.kt#6ni00');
          var tmp0_safe_receiver_0 = CartMugProductDetailsScreen$lambda_1(state$delegate).m10z_1;
          var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.lyz_1;
          var tmp_85 = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
          var tmp2_safe_receiver = CartMugProductDetailsScreen$lambda_1(state$delegate).q10z_1;
          var tmp3_elvis_lhs_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.wyz_1;
          var tmp_86 = tmp_85 + (tmp3_elvis_lhs_0 == null ? 0.0 : tmp3_elvis_lhs_0);
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0;
          var _iterator__ex2g4s = CartMugProductDetailsScreen$lambda_1(state$delegate).w10z_1.y2().t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            var tmp_87 = sum;
            var tmp0_elvis_lhs_1 = element.q100_1;
            sum = tmp_87 + (tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1);
          }
          var extraOriginalPrice = tmp_86 + sum;
          var tmp4_safe_receiver = CartMugProductDetailsScreen$lambda_1(state$delegate).m10z_1;
          var tmp5_elvis_lhs_0 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.lyz_1;
          var tmp_88 = tmp5_elvis_lhs_0 == null ? 0.0 : tmp5_elvis_lhs_0;
          var tmp6_safe_receiver = CartMugProductDetailsScreen$lambda_1(state$delegate).q10z_1;
          var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.wyz_1;
          var tmp_89 = tmp_88 + (tmp7_elvis_lhs == null ? 0.0 : tmp7_elvis_lhs);
          // Inline function 'kotlin.collections.sumOf' call
          var sum_0 = 0;
          var _iterator__ex2g4s_0 = CartMugProductDetailsScreen$lambda_1(state$delegate).w10z_1.y2().t();
          while (_iterator__ex2g4s_0.u()) {
            var element_0 = _iterator__ex2g4s_0.v();
            var tmp_90 = sum_0;
            var tmp_91;
            var tmp0_elvis_lhs_2 = element_0.r100_1;
            if ((tmp0_elvis_lhs_2 == null ? 0.0 : tmp0_elvis_lhs_2) > 0.0) {
              tmp_91 = ensureNotNull(element_0.r100_1);
            } else {
              var tmp1_elvis_lhs_1 = element_0.q100_1;
              tmp_91 = tmp1_elvis_lhs_1 == null ? 0.0 : tmp1_elvis_lhs_1;
            }
            sum_0 = tmp_90 + tmp_91;
          }
          var extraDiscountedPrice = tmp_89 + sum_0;
          var tmp8_elvis_lhs = tmp0_safe_receiver.szt_1;
          var finalOriginalPrice = (tmp8_elvis_lhs == null ? 0.0 : tmp8_elvis_lhs) + extraOriginalPrice;
          var tmp_92;
          var tmp9_elvis_lhs = tmp0_safe_receiver.tzt_1;
          if ((tmp9_elvis_lhs == null ? 0.0 : tmp9_elvis_lhs) > 0.0) {
            tmp_92 = ensureNotNull(tmp0_safe_receiver.tzt_1);
          } else {
            var tmp10_elvis_lhs = tmp0_safe_receiver.szt_1;
            tmp_92 = tmp10_elvis_lhs == null ? 0.0 : tmp10_elvis_lhs;
          }
          var finalDiscountedPrice = tmp_92 + extraDiscountedPrice;
          var tmp_93;
          var tmp11_elvis_lhs = tmp0_safe_receiver.tzt_1;
          if ((tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs) > 0.0) {
            tmp_93 = true;
          } else {
            var tmp0_16 = CartMugProductDetailsScreen$lambda_1(state$delegate).w10z_1.y2();
            var tmp$ret$207;
            $l$block_0: {
              // Inline function 'kotlin.collections.any' call
              var tmp_94;
              if (isInterface(tmp0_16, Collection)) {
                tmp_94 = tmp0_16.r();
              } else {
                tmp_94 = false;
              }
              if (tmp_94) {
                tmp$ret$207 = false;
                break $l$block_0;
              }
              var _iterator__ex2g4s_1 = tmp0_16.t();
              while (_iterator__ex2g4s_1.u()) {
                var element_1 = _iterator__ex2g4s_1.v();
                var tmp0_elvis_lhs_3 = element_1.r100_1;
                if ((tmp0_elvis_lhs_3 == null ? 0.0 : tmp0_elvis_lhs_3) > 0.0) {
                  tmp$ret$207 = true;
                  break $l$block_0;
                }
              }
              tmp$ret$207 = false;
            }
            tmp_93 = tmp$ret$207;
          }
          var hasDiscount = tmp_93;
          if (hasDiscount) {
            $composer_51.m30(-1535011765);
            sourceInformation($composer_51, '341@17671L79,342@17856L11,340@17618L326,345@18034L77,346@18217L11,344@17981L347');
            var tmp12_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalDiscountedPrice)], $composer_51, 0), language);
            var tmp13_fontSize = get_sp(28);
            var tmp14_color = MaterialTheme_instance.unz($composer_51, 6).xnz_1;
            var tmp15_fontWeight = Companion_getInstance_16().g7z_1;
            var tmp_95 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_96 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_97 = _TextOverflow___init__impl__obguoe(0);
            Text(tmp12_text, null, tmp14_color, null, tmp13_fontSize, null, tmp15_fontWeight, null, tmp_95, null, null, tmp_96, tmp_97, false, 0, 0, null, null, $composer_51, 1597440, 0, 262058);
            var tmp16_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_51, 0), language);
            var tmp17_fontSize = get_sp(18);
            var tmp18_color = MaterialTheme_instance.unz($composer_51, 6).po0_1;
            var tmp19_textDecoration = Companion_getInstance_18().c80_1;
            var tmp_98 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_99 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_100 = _TextOverflow___init__impl__obguoe(0);
            Text(tmp16_text, null, tmp18_color, null, tmp17_fontSize, null, null, null, tmp_98, tmp19_textDecoration, null, tmp_99, tmp_100, false, 0, 0, null, null, $composer_51, 805330944, 0, 261610);
            $composer_51.n30();
          } else {
            $composer_51.m30(-1534206571);
            sourceInformation($composer_51, '350@18459L77,351@18642L11,349@18406L324');
            var tmp20_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_51, 0), language);
            var tmp21_fontSize = get_sp(28);
            var tmp22_color = MaterialTheme_instance.unz($composer_51, 6).xnz_1;
            var tmp23_fontWeight = Companion_getInstance_16().g7z_1;
            var tmp_101 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_102 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_103 = _TextOverflow___init__impl__obguoe(0);
            Text(tmp20_text, null, tmp22_color, null, tmp21_fontSize, null, tmp23_fontWeight, null, tmp_101, null, null, tmp_102, tmp_103, false, 0, 0, null, null, $composer_51, 1597440, 0, 262058);
            $composer_51.n30();
          }
          sourceInformationMarkerEnd($composer_51);
          $composer_49.e31();
          sourceInformationMarkerEnd($composer_46);
          $composer_44.e31();
          var tmp_104 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$209 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_104, tmp$ret$209), $composer_41, 6);
          $composer_41.m30(470476996);
          sourceInformation($composer_41, '*359@18947L41');
          // Inline function 'kotlin.text.ifBlank' call
          var tmp_105;
          if (isBlank(description)) {
            tmp_105 = stringResource(get_no_description(string_instance), $composer_41, 0);
          } else {
            tmp_105 = description;
          }
          var tmp0_group_6 = tmp_105;
          $composer_41.n30();
          var tmp_106 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_107 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_108 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_109 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_110 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_group_6, null, tmp_106, null, tmp_107, null, null, null, tmp_108, null, null, tmp_109, tmp_110, false, 0, 0, null, MaterialTheme_instance.jog($composer_41, 6).oof_1, $composer_41, 0, 0, 131070);
          var tmp_111 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$212 = _Dp___init__impl__ms3zkb(24);
          Spacer(height(tmp_111, tmp$ret$212), $composer_41, 6);
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!CartMugProductDetailsScreen$lambda_1(state$delegate).y10z_1.r()) {
            $composer_41.m30(1700271467);
            sourceInformation($composer_41, '366@19330L38,369@19563L118,365@19268L544');
            var tmp_112 = stringResource(get_select_card(string_instance), $composer_41, 0);
            var tmp_113 = CartMugProductDetailsScreen$lambda_1(state$delegate).y10z_1;
            var tmp3_safe_receiver = CartMugProductDetailsScreen$lambda_1(state$delegate).m10z_1;
            var tmp_114 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.gyz_1;
            sourceInformationMarkerStart($composer_41, 470497093, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_15 = $composer_41.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_28 = $composer_41.i31();
            var tmp_115;
            if (invalid_15 || it_28 === Companion_getInstance().f30_1) {
              var value_28 = CartMugProductDetailsScreen$lambda_30(viewModel);
              $composer_41.j31(value_28);
              tmp_115 = value_28;
            } else {
              tmp_115 = it_28;
            }
            var tmp1_group_6 = tmp_115;
            sourceInformationMarkerEnd($composer_41);
            GiftSelectionSection(tmp_112, tmp_113, tmp_114, tmp1_group_6, language, true, $composer_41, 196608, 0);
            var tmp7_safe_receiver = CartMugProductDetailsScreen$lambda_1(state$delegate).m10z_1;
            if ((tmp7_safe_receiver == null ? null : tmp7_safe_receiver.oyz_1) === true) {
              $composer_41.m30(1700888739);
              sourceInformation($composer_41, '376@20052L102,380@20473L451,374@19918L1040');
              var tmp4_value = CartMugProductDetailsScreen$lambda_1(state$delegate).n10z_1;
              var tmp_116 = fillMaxWidth(Companion_instance);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$218 = _Dp___init__impl__ms3zkb(8);
              var tmp5_modifier = padding_1(tmp_116, VOID, tmp$ret$218);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$219 = _Dp___init__impl__ms3zkb(12);
              var tmp6_shape = RoundedCornerShape(tmp$ret$219);
              sourceInformationMarkerStart($composer_41, 470512725, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_16 = $composer_41.q31(viewModel);
              // Inline function 'kotlin.let' call
              var it_29 = $composer_41.i31();
              var tmp_117;
              if (invalid_16 || it_29 === Companion_getInstance().f30_1) {
                var value_29 = CartMugProductDetailsScreen$lambda_31(viewModel);
                $composer_41.j31(value_29);
                tmp_117 = value_29;
              } else {
                tmp_117 = it_29;
              }
              var tmp2_group_0 = tmp_117;
              sourceInformationMarkerEnd($composer_41);
              var tmp_118 = ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().z116_1;
              // Inline function 'kotlin.run' call
              var dispatchReceiver_1 = rememberComposableLambda(2039439852, true, CartMugProductDetailsScreen$lambda_32(state$delegate), $composer_41, 54);
              // Inline function 'androidx.compose.runtime.remember' call
              var $composer_52 = $composer_41;
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_17 = $composer_52.k31(dispatchReceiver_1);
              // Inline function 'kotlin.let' call
              var it_30 = $composer_52.i31();
              var tmp_119;
              if (invalid_17 || it_30 === Companion_getInstance().f30_1) {
                var value_30 = ComposableLambda$invoke$ref(dispatchReceiver_1);
                $composer_52.j31(value_30);
                tmp_119 = value_30;
              } else {
                tmp_119 = it_30;
              }
              var tmp_120 = tmp_119;
              OutlinedTextField(tmp4_value, tmp2_group_0, tmp5_modifier, false, false, null, tmp_118, null, null, null, null, null, tmp_120, false, null, null, null, false, 0, 0, null, tmp6_shape, null, $composer_41, 1573248, 384, 0, 6287288);
              $composer_41.n30();
            } else {
              $composer_41.m30(1701917939);
              $composer_41.n30();
            }
            var tmp11_safe_receiver = CartMugProductDetailsScreen$lambda_1(state$delegate).m10z_1;
            if ((tmp11_safe_receiver == null ? null : tmp11_safe_receiver.pyz_1) === true) {
              $composer_41.m30(1702054308);
              sourceInformation($composer_41, '396@21490L176,393@21230L2,401@21790L246,391@21095L975');
              var tmp8_value = CartMugProductDetailsScreen$lambda_1(state$delegate).o10z_1;
              var tmp_121 = fillMaxWidth(Companion_instance);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$231 = _Dp___init__impl__ms3zkb(8);
              var tmp_122 = padding_1(tmp_121, VOID, tmp$ret$231);
              sourceInformationMarkerStart($composer_41, 470558815, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              // Inline function 'kotlin.let' call
              var it_31 = $composer_41.i31();
              var tmp_123;
              if (false || it_31 === Companion_getInstance().f30_1) {
                var value_31 = CartMugProductDetailsScreen$lambda_33(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
                $composer_41.j31(value_31);
                tmp_123 = value_31;
              } else {
                tmp_123 = it_31;
              }
              var tmp3_group_0 = tmp_123;
              sourceInformationMarkerEnd($composer_41);
              var tmp9_modifier = clickable(tmp_122, VOID, VOID, VOID, VOID, tmp3_group_0);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$236 = _Dp___init__impl__ms3zkb(12);
              var tmp10_shape = RoundedCornerShape(tmp$ret$236);
              sourceInformationMarkerStart($composer_41, 470550321, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              // Inline function 'kotlin.let' call
              var it_32 = $composer_41.i31();
              var tmp_124;
              if (false || it_32 === Companion_getInstance().f30_1) {
                var value_32 = CartMugProductDetailsScreen$lambda_34;
                $composer_41.j31(value_32);
                tmp_124 = value_32;
              } else {
                tmp_124 = it_32;
              }
              var tmp4_group_0 = tmp_124;
              sourceInformationMarkerEnd($composer_41);
              var tmp_125 = ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().a117_1;
              // Inline function 'kotlin.run' call
              var dispatchReceiver_2 = rememberComposableLambda(-2048628877, true, CartMugProductDetailsScreen$lambda_35(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_41, 54);
              // Inline function 'androidx.compose.runtime.remember' call
              var $composer_53 = $composer_41;
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_18 = $composer_53.k31(dispatchReceiver_2);
              // Inline function 'kotlin.let' call
              var it_33 = $composer_53.i31();
              var tmp_126;
              if (invalid_18 || it_33 === Companion_getInstance().f30_1) {
                var value_33 = ComposableLambda$invoke$ref(dispatchReceiver_2);
                $composer_53.j31(value_33);
                tmp_126 = value_33;
              } else {
                tmp_126 = it_33;
              }
              var tmp_127 = tmp_126;
              OutlinedTextField(tmp8_value, tmp4_group_0, tmp9_modifier, false, true, null, tmp_125, null, null, tmp_127, null, null, null, false, null, null, null, false, 0, 0, null, tmp10_shape, null, $composer_41, 806903856, 0, 0, 6290856);
              $composer_41.n30();
            } else {
              $composer_41.m30(1703021043);
              $composer_41.n30();
            }
            $composer_41.n30();
          } else {
            $composer_41.m30(1703046835);
            $composer_41.n30();
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!CartMugProductDetailsScreen$lambda_1(state$delegate).z10z_1.r()) {
            $composer_41.m30(1703202672);
            sourceInformation($composer_41, '411@22283L37,414@22514L116,410@22221L540');
            var tmp_128 = stringResource(get_select_box(string_instance), $composer_41, 0);
            var tmp_129 = CartMugProductDetailsScreen$lambda_1(state$delegate).z10z_1;
            var tmp12_safe_receiver = CartMugProductDetailsScreen$lambda_1(state$delegate).q10z_1;
            var tmp_130 = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.ryz_1;
            sourceInformationMarkerStart($composer_41, 470591523, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_19 = $composer_41.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_34 = $composer_41.i31();
            var tmp_131;
            if (invalid_19 || it_34 === Companion_getInstance().f30_1) {
              var value_34 = CartMugProductDetailsScreen$lambda_36(viewModel);
              $composer_41.j31(value_34);
              tmp_131 = value_34;
            } else {
              tmp_131 = it_34;
            }
            var tmp5_group_0 = tmp_131;
            sourceInformationMarkerEnd($composer_41);
            GiftSelectionSection(tmp_128, tmp_129, tmp_130, tmp5_group_0, language, true, $composer_41, 196608, 0);
            var tmp16_safe_receiver = CartMugProductDetailsScreen$lambda_1(state$delegate).q10z_1;
            if ((tmp16_safe_receiver == null ? null : tmp16_safe_receiver.zyz_1) === true) {
              $composer_41.m30(1703814054);
              sourceInformation($composer_41, '422@23000L101,426@23420L450,420@22867L1037');
              var tmp13_value = CartMugProductDetailsScreen$lambda_1(state$delegate).r10z_1;
              var tmp_132 = fillMaxWidth(Companion_instance);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$253 = _Dp___init__impl__ms3zkb(8);
              var tmp14_modifier = padding_1(tmp_132, VOID, tmp$ret$253);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$254 = _Dp___init__impl__ms3zkb(12);
              var tmp15_shape = RoundedCornerShape(tmp$ret$254);
              sourceInformationMarkerStart($composer_41, 470607060, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_20 = $composer_41.q31(viewModel);
              // Inline function 'kotlin.let' call
              var it_35 = $composer_41.i31();
              var tmp_133;
              if (invalid_20 || it_35 === Companion_getInstance().f30_1) {
                var value_35 = CartMugProductDetailsScreen$lambda_37(viewModel);
                $composer_41.j31(value_35);
                tmp_133 = value_35;
              } else {
                tmp_133 = it_35;
              }
              var tmp6_group_0 = tmp_133;
              sourceInformationMarkerEnd($composer_41);
              var tmp_134 = ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().c117_1;
              // Inline function 'kotlin.run' call
              var dispatchReceiver_3 = rememberComposableLambda(1022060323, true, CartMugProductDetailsScreen$lambda_38(state$delegate), $composer_41, 54);
              // Inline function 'androidx.compose.runtime.remember' call
              var $composer_54 = $composer_41;
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_21 = $composer_54.k31(dispatchReceiver_3);
              // Inline function 'kotlin.let' call
              var it_36 = $composer_54.i31();
              var tmp_135;
              if (invalid_21 || it_36 === Companion_getInstance().f30_1) {
                var value_36 = ComposableLambda$invoke$ref(dispatchReceiver_3);
                $composer_54.j31(value_36);
                tmp_135 = value_36;
              } else {
                tmp_135 = it_36;
              }
              var tmp_136 = tmp_135;
              OutlinedTextField(tmp13_value, tmp6_group_0, tmp14_modifier, false, false, null, tmp_134, null, null, null, null, null, tmp_136, false, null, null, null, false, 0, 0, null, tmp15_shape, null, $composer_41, 1573248, 384, 0, 6287288);
              $composer_41.n30();
            } else {
              $composer_41.m30(1704840371);
              $composer_41.n30();
            }
            var tmp21_safe_receiver = CartMugProductDetailsScreen$lambda_1(state$delegate).q10z_1;
            if ((tmp21_safe_receiver == null ? null : tmp21_safe_receiver.az0_1) === true) {
              $composer_41.m30(1704977825);
              sourceInformation($composer_41, '442@24434L175,439@24174L2,448@24803L245,437@24040L1042');
              var tmp17_value = CartMugProductDetailsScreen$lambda_1(state$delegate).s10z_1;
              var tmp_137 = fillMaxWidth(Companion_instance);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$266 = _Dp___init__impl__ms3zkb(8);
              var tmp_138 = padding_1(tmp_137, VOID, tmp$ret$266);
              sourceInformationMarkerStart($composer_41, 470653022, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              // Inline function 'kotlin.let' call
              var it_37 = $composer_41.i31();
              var tmp_139;
              if (false || it_37 === Companion_getInstance().f30_1) {
                var value_37 = CartMugProductDetailsScreen$lambda_39(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
                $composer_41.j31(value_37);
                tmp_139 = value_37;
              } else {
                tmp_139 = it_37;
              }
              var tmp7_group_0 = tmp_139;
              sourceInformationMarkerEnd($composer_41);
              var tmp18_modifier = clickable(tmp_138, VOID, VOID, VOID, VOID, tmp7_group_0);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$271 = _Dp___init__impl__ms3zkb(12);
              var tmp19_shape = RoundedCornerShape(tmp$ret$271);
              var tmp20_isError = CartMugProductDetailsScreen$lambda_1(state$delegate).t10z_1;
              sourceInformationMarkerStart($composer_41, 470644529, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              // Inline function 'kotlin.let' call
              var it_38 = $composer_41.i31();
              var tmp_140;
              if (false || it_38 === Companion_getInstance().f30_1) {
                var value_38 = CartMugProductDetailsScreen$lambda_40;
                $composer_41.j31(value_38);
                tmp_140 = value_38;
              } else {
                tmp_140 = it_38;
              }
              var tmp8_group_0 = tmp_140;
              sourceInformationMarkerEnd($composer_41);
              var tmp_141 = ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().d117_1;
              // Inline function 'kotlin.run' call
              var dispatchReceiver_4 = rememberComposableLambda(-2011879702, true, CartMugProductDetailsScreen$lambda_41(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_41, 54);
              // Inline function 'androidx.compose.runtime.remember' call
              var $composer_55 = $composer_41;
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_22 = $composer_55.k31(dispatchReceiver_4);
              // Inline function 'kotlin.let' call
              var it_39 = $composer_55.i31();
              var tmp_142;
              if (invalid_22 || it_39 === Companion_getInstance().f30_1) {
                var value_39 = ComposableLambda$invoke$ref(dispatchReceiver_4);
                $composer_55.j31(value_39);
                tmp_142 = value_39;
              } else {
                tmp_142 = it_39;
              }
              var tmp_143 = tmp_142;
              OutlinedTextField(tmp17_value, tmp8_group_0, tmp18_modifier, false, true, null, tmp_141, null, null, tmp_143, null, null, null, tmp20_isError, null, null, null, false, 0, 0, null, tmp19_shape, null, $composer_41, 806903856, 0, 0, 6282664);
              $composer_41.n30();
            } else {
              $composer_41.m30(1706008947);
              $composer_41.n30();
            }
            $composer_41.n30();
          } else {
            $composer_41.m30(1706034739);
            $composer_41.n30();
          }
          // Inline function 'kotlin.collections.isNullOrEmpty' call
          var this_10 = tmp0_safe_receiver.lzu_1;
          if (!(this_10 == null || this_10.r())) {
            $composer_41.m30(1706106938);
            sourceInformation($composer_41, '458@25288L38,461@25499L75,457@25224L481');
            var tmp_144 = stringResource(get_select_size(string_instance), $composer_41, 0);
            var tmp_145 = CartMugProductDetailsScreen$lambda_1(state$delegate).u10z_1;
            sourceInformationMarkerStart($composer_41, 470687002, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_23 = $composer_41.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_40 = $composer_41.i31();
            var tmp_146;
            if (invalid_23 || it_40 === Companion_getInstance().f30_1) {
              var value_40 = CartMugProductDetailsScreen$lambda_42(viewModel);
              $composer_41.j31(value_40);
              tmp_146 = value_40;
            } else {
              tmp_146 = it_40;
            }
            var tmp9_group_0 = tmp_146;
            sourceInformationMarkerEnd($composer_41);
            OptionSelectionSection(tmp_144, tmp0_safe_receiver.lzu_1, tmp_145, tmp9_group_0, language, true, $composer_41, 196608, 0);
            $composer_41.n30();
          } else {
            $composer_41.m30(1706622995);
            $composer_41.n30();
          }
          // Inline function 'kotlin.collections.isNullOrEmpty' call
          var this_11 = tmp0_safe_receiver.mzu_1;
          if (!(this_11 == null || this_11.r())) {
            $composer_41.m30(1706696310);
            sourceInformation($composer_41, '469@25882L39,472@26096L76,468@25818L485');
            var tmp_147 = stringResource(get_select_color(string_instance), $composer_41, 0);
            var tmp_148 = CartMugProductDetailsScreen$lambda_1(state$delegate).v10z_1;
            sourceInformationMarkerStart($composer_41, 470706107, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_24 = $composer_41.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_41 = $composer_41.i31();
            var tmp_149;
            if (invalid_24 || it_41 === Companion_getInstance().f30_1) {
              var value_41 = CartMugProductDetailsScreen$lambda_43(viewModel);
              $composer_41.j31(value_41);
              tmp_149 = value_41;
            } else {
              tmp_149 = it_41;
            }
            var tmp10_group_0 = tmp_149;
            sourceInformationMarkerEnd($composer_41);
            OptionSelectionSection(tmp_147, tmp0_safe_receiver.mzu_1, tmp_148, tmp10_group_0, language, true, $composer_41, 196608, 0);
            $composer_41.n30();
          } else {
            $composer_41.m30(1707216211);
            $composer_41.n30();
          }
          var tmp22_safe_receiver = tmp0_safe_receiver.nzu_1;
          if (tmp22_safe_receiver == null) {
            $composer_41.m30(1707316929);
            $composer_41.n30();
          } else {
            $composer_41.m30(1707316930);
            sourceInformation($composer_41, '*482@26632L101,479@26424L440');
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s_2 = tmp22_safe_receiver.t();
            while (_iterator__ex2g4s_2.u()) {
              var element_2 = _iterator__ex2g4s_2.v();
              var tmp_150 = CartMugProductDetailsScreen$lambda_1(state$delegate).w10z_1.w2(element_2.r101_1);
              sourceInformationMarkerStart($composer_41, -776581022, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_25 = !!($composer_41.q31(viewModel) | $composer_41.q31(element_2));
              // Inline function 'kotlin.let' call
              var it_42 = $composer_41.i31();
              var tmp_151;
              if (invalid_25 || it_42 === Companion_getInstance().f30_1) {
                var value_42 = CartMugProductDetailsScreen$lambda_44(viewModel, element_2);
                $composer_41.j31(value_42);
                tmp_151 = value_42;
              } else {
                tmp_151 = it_42;
              }
              var tmp0_group_7 = tmp_151;
              sourceInformationMarkerEnd($composer_41);
              OptionSelectionSection_0(element_2, tmp_150, tmp0_group_7, language, true, $composer_41, 24576, 0);
              var tmp0_safe_receiver_1 = CartMugProductDetailsScreen$lambda_1(state$delegate).w10z_1.w2(element_2.r101_1);
              if (tmp0_safe_receiver_1 == null) {
                $composer_41.m30(1696118773);
                $composer_41.n30();
              } else {
                $composer_41.m30(1696118774);
                sourceInformation($composer_41, '');
                // Inline function 'kotlin.let' call
                if (tmp0_safe_receiver_1.w100_1 || tmp0_safe_receiver_1.z100_1 || tmp0_safe_receiver_1.c101_1) {
                  $composer_41.m30(-1809208983);
                  sourceInformation($composer_41, '492@27387L285,497@27737L200,488@27106L925');
                  sourceInformationMarkerStart($composer_41, 1188573905, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
                  // Inline function 'androidx.compose.runtime.cache' call
                  var invalid_26 = !!($composer_41.q31(viewModel) | $composer_41.q31(element_2));
                  // Inline function 'kotlin.let' call
                  var it_43 = $composer_41.i31();
                  var tmp_152;
                  if (invalid_26 || it_43 === Companion_getInstance().f30_1) {
                    var value_43 = CartMugProductDetailsScreen$lambda_45(viewModel, element_2);
                    $composer_41.j31(value_43);
                    tmp_152 = value_43;
                  } else {
                    tmp_152 = it_43;
                  }
                  var tmp0_group_8 = tmp_152;
                  sourceInformationMarkerEnd($composer_41);
                  sourceInformationMarkerStart($composer_41, 1188585020, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
                  // Inline function 'androidx.compose.runtime.cache' call
                  var invalid_27 = $composer_41.q31(element_2);
                  // Inline function 'kotlin.let' call
                  var it_44 = $composer_41.i31();
                  var tmp_153;
                  if (invalid_27 || it_44 === Companion_getInstance().f30_1) {
                    var value_44 = CartMugProductDetailsScreen$lambda_46(birthdayPickerTargetOptionKey$delegate, element_2, showBirthdayPicker$delegate);
                    $composer_41.j31(value_44);
                    tmp_153 = value_44;
                  } else {
                    tmp_153 = it_44;
                  }
                  var tmp1_group_7 = tmp_153;
                  sourceInformationMarkerEnd($composer_41);
                  SelectedOptionExtraInputs(element_2.r101_1, tmp0_safe_receiver_1, language, tmp0_group_8, tmp1_group_7, true, $composer_41, 196608, 0);
                  $composer_41.n30();
                } else {
                  $composer_41.m30(-1808250866);
                  $composer_41.n30();
                }
                $composer_41.n30();
              }
            }
            $composer_41.n30();
          }
          var tmp_154 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$309 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_154, tmp$ret$309), $composer_41, 6);
          var tmp23_value = CartMugProductDetailsScreen$lambda_1(state$delegate).x10z_1;
          var tmp24_modifier = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$310 = _Dp___init__impl__ms3zkb(12);
          var tmp25_shape = RoundedCornerShape(tmp$ret$310);
          sourceInformationMarkerStart($composer_41, 470777785, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_28 = $composer_41.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_45 = $composer_41.i31();
          var tmp_155;
          if (invalid_28 || it_45 === Companion_getInstance().f30_1) {
            var value_45 = CartMugProductDetailsScreen$lambda_47(viewModel);
            $composer_41.j31(value_45);
            tmp_155 = value_45;
          } else {
            tmp_155 = it_45;
          }
          var tmp11_group_0 = tmp_155;
          sourceInformationMarkerEnd($composer_41);
          var tmp_156 = ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().f117_1;
          OutlinedTextField(tmp23_value, tmp11_group_0, tmp24_modifier, false, false, null, tmp_156, null, null, null, null, null, null, false, null, null, null, false, 0, 0, null, tmp25_shape, null, $composer_41, 1573248, 0, 0, 6291384);
          var tmp_157 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$315 = _Dp___init__impl__ms3zkb(24);
          Spacer(height(tmp_157, tmp$ret$315), $composer_41, 6);
          AgeGroupDisplay(tmp0_safe_receiver.rzu_1, tmp0_safe_receiver.szu_1, tmp0_safe_receiver.tzu_1, null, $composer_41, 0, 8);
          var tmp_158 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$316 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_158, tmp$ret$316), $composer_41, 6);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_17 = null;
          var horizontalArrangement_2 = null;
          var verticalAlignment_2 = Companion_getInstance_11().u8t_1;
          var $composer_56 = $composer_41;
          if (!((3 & 1) === 0))
            modifier_17 = Companion_instance;
          if (!((3 & 2) === 0))
            horizontalArrangement_2 = Arrangement_getInstance().qdp_1;
          if (!((3 & 4) === 0))
            verticalAlignment_2 = Companion_getInstance_11().t8t_1;
          var measurePolicy_8 = rowMeasurePolicy(horizontalArrangement_2, verticalAlignment_2, $composer_56, 14 & 384 >> 3 | 112 & 384 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_18 = modifier_17;
          var $composer_57 = $composer_56;
          if (!((0 & 2) === 0))
            modifier_18 = Companion_instance;
          var compositeKeyHash_8 = get_currentCompositeKeyHashCode($composer_57, 0).hashCode();
          var localMap_8 = $composer_57.t31();
          var materialized_8 = materialize($composer_57, modifier_18);
          var tmp0_17 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_58 = $composer_57;
          var tmp_159 = $composer_58.g30();
          if (!isInterface(tmp_159, Applier)) {
            invalidApplier();
          }
          $composer_58.b31();
          if ($composer_58.h30()) {
            $composer_58.c31(tmp0_17);
          } else {
            $composer_58.d31();
          }
          var $this$ReusableComposeNode_8 = _Updater___init__impl__rbfxm8($composer_58);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, measurePolicy_8, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, localMap_8, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, compositeKeyHash_8, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_8, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, materialized_8, Companion_getInstance_12().qah_1);
          var $composer_59 = $composer_58;
          var $composer_60 = $composer_59;
          sourceInformationMarkerStart($composer_60, -2038684952, 'C530@29330L76,531@29435L28,532@29492L307:CartMugProductDetailsScreen.kt#6ni00');
          var tmp_160;
          var tmp0_elvis_lhs_4 = tmp0_safe_receiver.wzt_1;
          if ((tmp0_elvis_lhs_4 == null ? 0 : tmp0_elvis_lhs_4) > 0) {
            $composer_60.m30(1873899355);
            $composer_60.n30();
            tmp_160 = Color(new Long(-11751600, 0));
          } else {
            $composer_60.m30(1873900911);
            sourceInformation($composer_60, '529@29284L11');
            var tmp0_group_9 = MaterialTheme_instance.unz($composer_60, 6).to0_1;
            $composer_60.n30();
            tmp_160 = tmp0_group_9;
          }
          var stockColor = tmp_160;
          var tmp_161 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$323 = _Dp___init__impl__ms3zkb(8);
          Box(background(clip(size(tmp_161, tmp$ret$323), get_CircleShape()), stockColor), $composer_60, 0);
          var tmp_162 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$324 = _Dp___init__impl__ms3zkb(8);
          Spacer(width(tmp_162, tmp$ret$324), $composer_60, 6);
          var tmp_163;
          var tmp2_elvis_lhs_0 = tmp0_safe_receiver.wzt_1;
          if ((tmp2_elvis_lhs_0 == null ? 0 : tmp2_elvis_lhs_0) > 0) {
            $composer_60.m30(1873911265);
            sourceInformation($composer_60, '533@29561L57');
            var tmp_164 = get_in_stock_pattern(string_instance);
            var tmp1_elvis_lhs_2 = tmp0_safe_receiver.wzt_1;
            var tmp1_group_8 = formatNumbers(stringResource_0(tmp_164, [tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2], $composer_60, 0), language);
            $composer_60.n30();
            tmp_163 = tmp1_group_8;
          } else {
            $composer_60.m30(1873912209);
            sourceInformation($composer_60, '533@29648L39');
            var tmp2_group_1 = stringResource(get_out_of_stock(string_instance), $composer_60, 0);
            $composer_60.n30();
            tmp_163 = tmp2_group_1;
          }
          var tmp_165 = tmp_163;
          var tmp_166 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_167 = Companion_getInstance_16().e7z_1;
          var tmp_168 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_169 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_170 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_165, null, stockColor, null, tmp_166, null, tmp_167, null, tmp_168, null, null, tmp_169, tmp_170, false, 0, 0, null, null, $composer_60, 1572864, 0, 262074);
          sourceInformationMarkerEnd($composer_60);
          $composer_58.e31();
          var tmp_171 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$325 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_171, tmp$ret$325), $composer_41, 6);
          var tmp_172 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$326 = _Dp___init__impl__ms3zkb(120);
          Spacer(height(tmp_172, tmp$ret$326), $composer_41, 6);
          sourceInformationMarkerEnd($composer_41);
          $composer_39.e31();
          sourceInformationMarkerEnd($composer_14);
          $composer_12.e31();
          var tmp3_modifier = zIndex(fillMaxWidth(BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1)), 2.0);
          var tmp4_color = MaterialTheme_instance.unz($composer_9, 6).mo0_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp5_shadowElevation = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_173 = _Dp___init__impl__ms3zkb(24);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$329 = _Dp___init__impl__ms3zkb(24);
          var tmp6_shape_0 = RoundedCornerShape_0(tmp_173, tmp$ret$329);
          var tmp_174 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_175 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_5 = rememberComposableLambda(-528818690, true, CartMugProductDetailsScreen$lambda_48(tmp0_safe_receiver, state$delegate, viewModel, language, cartRepository, cartItem), $composer_9, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_61 = $composer_9;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_29 = $composer_61.k31(dispatchReceiver_5);
          // Inline function 'kotlin.let' call
          var it_46 = $composer_61.i31();
          var tmp_176;
          if (invalid_29 || it_46 === Companion_getInstance().f30_1) {
            var value_46 = ComposableLambda$invoke$ref(dispatchReceiver_5);
            $composer_61.j31(value_46);
            tmp_176 = value_46;
          } else {
            tmp_176 = it_46;
          }
          var tmp$ret$330 = tmp_176;
          Surface(tmp3_modifier, tmp6_shape_0, tmp4_color, tmp_174, tmp_175, tmp5_shadowElevation, null, tmp$ret$330, $composer_9, 12779520, 88);
          $composer_9.n30();
        } else {
          $composer_9.m30(814364634);
          $composer_9.n30();
        }
        var tmp_177 = CartMugProductDetailsScreen$lambda_1(state$delegate).e10z_1;
        var tmp_178 = CartMugProductDetailsScreen$lambda_1(state$delegate).g10z_1;
        sourceInformationMarkerStart($composer_9, 1273198087, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_30 = $composer_9.k31(verticalScrollState);
        // Inline function 'kotlin.let' call
        var it_47 = $composer_9.i31();
        var tmp_179;
        if (invalid_30 || it_47 === Companion_getInstance().f30_1) {
          var value_47 = CartMugProductDetailsScreen$slambda_10(verticalScrollState, null);
          $composer_9.j31(value_47);
          tmp_179 = value_47;
        } else {
          tmp_179 = it_47;
        }
        var tmp0_group_10 = tmp_179;
        sourceInformationMarkerEnd($composer_9);
        LaunchedEffect(tmp_177, tmp_178, tmp0_group_10, $composer_9, 0);
        if (CartMugProductDetailsScreen$lambda_1(state$delegate).h10z_1) {
          $composer_9.m30(814600017);
          sourceInformation($composer_9, '708@40166L353,717@40552L70,706@40055L585');
          var tmp_180 = CartMugProductDetailsScreen$lambda_1(state$delegate).g10z_1;
          sourceInformationMarkerStart($composer_9, 1273207273, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_31 = $composer_9.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_48 = $composer_9.i31();
          var tmp_181;
          if (invalid_31 || it_48 === Companion_getInstance().f30_1) {
            var value_48 = CartMugProductDetailsScreen$lambda_49(viewModel);
            $composer_9.j31(value_48);
            tmp_181 = value_48;
          } else {
            tmp_181 = it_48;
          }
          var tmp1_group_9 = tmp_181;
          sourceInformationMarkerEnd($composer_9);
          sourceInformationMarkerStart($composer_9, 1273219342, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_32 = $composer_9.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_49 = $composer_9.i31();
          var tmp_182;
          if (invalid_32 || it_49 === Companion_getInstance().f30_1) {
            var value_49 = CartMugProductDetailsScreen$lambda_50(viewModel);
            $composer_9.j31(value_49);
            tmp_182 = value_49;
          } else {
            tmp_182 = it_49;
          }
          var tmp2_group_2 = tmp_182;
          sourceInformationMarkerEnd($composer_9);
          MugImageEditorScreen(tmp_180, tmp1_group_9, tmp2_group_2, $composer_9, 0, 0);
          $composer_9.n30();
        } else {
          $composer_9.m30(815192954);
          $composer_9.n30();
        }
        var tmp_183 = CartMugProductDetailsScreen$lambda_4(showFullScreen3D$delegate);
        var tmp_184 = CartMugProductDetailsScreen$lambda_1(state$delegate).i10z_1;
        var tmp_185 = CartMugProductDetailsScreen$lambda_1(state$delegate).j10z_1;
        var tmp_186 = ProductKind_MUG_getInstance();
        var tmp_187 = CartMugProductDetailsScreen$lambda_1(state$delegate).e10z_1;
        var tmp_188 = CartMugProductDetailsScreen$lambda_1(state$delegate).f10z_1;
        sourceInformationMarkerStart($composer_9, 1273234289, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_33 = !!($composer_9.q31(viewModel) | $composer_9.q31(tmp0_safe_receiver));
        // Inline function 'kotlin.let' call
        var it_50 = $composer_9.i31();
        var tmp_189;
        if (invalid_33 || it_50 === Companion_getInstance().f30_1) {
          var value_50 = CartMugProductDetailsScreen$lambda_51(viewModel, tmp0_safe_receiver);
          $composer_9.j31(value_50);
          tmp_189 = value_50;
        } else {
          tmp_189 = it_50;
        }
        var tmp3_group_1 = tmp_189;
        sourceInformationMarkerEnd($composer_9);
        sourceInformationMarkerStart($composer_9, 1273237540, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_51 = $composer_9.i31();
        var tmp_190;
        if (false || it_51 === Companion_getInstance().f30_1) {
          var value_51 = CartMugProductDetailsScreen$lambda_52(showFullScreen3D$delegate);
          $composer_9.j31(value_51);
          tmp_190 = value_51;
        } else {
          tmp_190 = it_51;
        }
        var tmp4_group_1 = tmp_190;
        sourceInformationMarkerEnd($composer_9);
        sourceInformationMarkerStart($composer_9, 1273239614, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_34 = $composer_9.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_52 = $composer_9.i31();
        var tmp_191;
        if (invalid_34 || it_52 === Companion_getInstance().f30_1) {
          var value_52 = CartMugProductDetailsScreen$lambda_53(showFullScreen3D$delegate, viewModel);
          $composer_9.j31(value_52);
          tmp_191 = value_52;
        } else {
          tmp_191 = it_52;
        }
        var tmp5_group_1 = tmp_191;
        sourceInformationMarkerEnd($composer_9);
        FullScreen3DDialog(tmp_183, tmp_184, tmp_185, tmp_186, tmp_187, tmp_188, language, tmp3_group_1, tmp4_group_1, tmp5_group_1, $composer_9, 100666368, 0);
        if (CartMugProductDetailsScreen$lambda_1(state$delegate).a10z_1) {
          $composer_9.m30(815948300);
          sourceInformation($composer_9, '738@41405L878');
          var tmp_192 = fillMaxSize(Companion_instance);
          var tmp_193 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.5);
          var tmp_194 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_195 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_196 = _Dp___init__impl__ms3zkb(0.0);
          Surface(tmp_192, null, tmp_193, tmp_194, tmp_195, tmp_196, null, ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().j117_1, $composer_9, 12583302, 122);
          $composer_9.n30();
        } else {
          $composer_9.m30(816822810);
          $composer_9.n30();
        }
        var tmp_197 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
        SnackbarHost(snackbarHostState, tmp_197, null, $composer_9, 6, 4);
        if (CartMugProductDetailsScreen$lambda_8(showBirthdayPicker$delegate)) {
          $composer_9.m30(817035470);
          sourceInformation($composer_9, '755@42518L136,759@42692L1566,784@44296L259,789@44574L43,754@42461L2156');
          sourceInformationMarkerStart($composer_9, 1273282320, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_53 = $composer_9.i31();
          var tmp_198;
          if (false || it_53 === Companion_getInstance().f30_1) {
            var value_53 = CartMugProductDetailsScreen$lambda_54(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate);
            $composer_9.j31(value_53);
            tmp_198 = value_53;
          } else {
            tmp_198 = it_53;
          }
          var tmp6_group_1 = tmp_198;
          sourceInformationMarkerEnd($composer_9);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_6 = rememberComposableLambda(-1868926034, true, CartMugProductDetailsScreen$lambda_55(birthdayPickerState, state$delegate, viewModel, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_9, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_62 = $composer_9;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_35 = $composer_62.k31(dispatchReceiver_6);
          // Inline function 'kotlin.let' call
          var it_54 = $composer_62.i31();
          var tmp_199;
          if (invalid_35 || it_54 === Companion_getInstance().f30_1) {
            var value_54 = ComposableLambda$invoke$ref(dispatchReceiver_6);
            $composer_62.j31(value_54);
            tmp_199 = value_54;
          } else {
            tmp_199 = it_54;
          }
          var tmp_200 = tmp_199;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_7 = rememberComposableLambda(-2038544976, true, CartMugProductDetailsScreen$lambda_56(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate), $composer_9, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_63 = $composer_9;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_36 = $composer_63.k31(dispatchReceiver_7);
          // Inline function 'kotlin.let' call
          var it_55 = $composer_63.i31();
          var tmp_201;
          if (invalid_36 || it_55 === Companion_getInstance().f30_1) {
            var value_55 = ComposableLambda$invoke$ref(dispatchReceiver_7);
            $composer_63.j31(value_55);
            tmp_201 = value_55;
          } else {
            tmp_201 = it_55;
          }
          var tmp_202 = tmp_201;
          var tmp_203 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_8 = rememberComposableLambda(430326341, true, CartMugProductDetailsScreen$lambda_57(birthdayPickerState), $composer_9, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_64 = $composer_9;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_37 = $composer_64.k31(dispatchReceiver_8);
          // Inline function 'kotlin.let' call
          var it_56 = $composer_64.i31();
          var tmp_204;
          if (invalid_37 || it_56 === Companion_getInstance().f30_1) {
            var value_56 = ComposableLambda$invoke$ref_6(dispatchReceiver_8);
            $composer_64.j31(value_56);
            tmp_204 = value_56;
          } else {
            tmp_204 = it_56;
          }
          var tmp$ret$379 = tmp_204;
          DatePickerDialog(tmp6_group_1, tmp_200, null, tmp_202, null, tmp_203, null, null, tmp$ret$379, $composer_9, 100666422, 244);
          $composer_9.n30();
        } else {
          $composer_9.m30(819138138);
          $composer_9.n30();
        }
        sourceInformationMarkerEnd($composer_9);
        $composer_7.e31();
        $composer_0.n30();
        tmp_4 = Unit_instance;
      }
      if (tmp_4 == null) {
        $composer_0.m30(1841377240);
        sourceInformation($composer_0, '792@44651L119');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_19 = fillMaxSize(Companion_instance);
        var contentAlignment_2 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_2 = false;
        var $composer_65 = $composer_0;
        if (!((4 & 1) === 0))
          modifier_19 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_2 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_2 = false;
        var measurePolicy_9 = maybeCachedBoxMeasurePolicy(contentAlignment_2, propagateMinConstraints_2);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_20 = modifier_19;
        var $composer_66 = $composer_65;
        if (!((0 & 2) === 0))
          modifier_20 = Companion_instance;
        var compositeKeyHash_9 = get_currentCompositeKeyHashCode($composer_66, 0).hashCode();
        var localMap_9 = $composer_66.t31();
        var materialized_9 = materialize($composer_66, modifier_20);
        var tmp0_18 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_67 = $composer_66;
        var tmp_205 = $composer_67.g30();
        if (!isInterface(tmp_205, Applier)) {
          invalidApplier();
        }
        $composer_67.b31();
        if ($composer_67.h30()) {
          $composer_67.c31(tmp0_18);
        } else {
          $composer_67.d31();
        }
        var $this$ReusableComposeNode_9 = _Updater___init__impl__rbfxm8($composer_67);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_9, measurePolicy_9, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_9, localMap_9, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_9, compositeKeyHash_9, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_9, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_9, materialized_9, Companion_getInstance_12().qah_1);
        var $composer_68 = $composer_67;
        var $composer_69 = $composer_68;
        sourceInformationMarkerStart($composer_69, -134169755, 'C793@44737L27:CartMugProductDetailsScreen.kt#6ni00');
        var tmp_206 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_207 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_208 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_209 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_206, tmp_207, tmp_208, tmp_209, _Dp___init__impl__ms3zkb(0.0), $composer_69, 0, 63);
        sourceInformationMarkerEnd($composer_69);
        $composer_67.e31();
        $composer_0.n30();
      } else {
        $composer_0.m30(1840109247);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver_0 = $composer_0.t30();
    if (tmp2_safe_receiver_0 == null)
      null;
    else {
      tmp2_safe_receiver_0.p3c(CartMugProductDetailsScreen$lambda_58(cartItem, onBack, onNavigateToAuth, topPadding_0, bottomPadding_0, $changed, $default));
    }
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$800182414$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C242@11632L283:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(800182414, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$800182414.<anonymous> (CartMugProductDetailsScreen.kt:242)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = padding_0(tmp, tmp$ret$0);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -192175613, 'C243@11772L31,243@11826L11,243@11709L172:CartMugProductDetailsScreen.kt#6ni00');
      var tmp0_imageVector = get_ArrowBack(Filled_instance_0);
      var tmp1_contentDescription = stringResource(get_back(string_instance), $composer_5, 0);
      var tmp2_tint = MaterialTheme_instance.unz($composer_5, 6).no0_1;
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
      var tmp3_modifier = size(tmp_1, tmp$ret$7);
      Icon(tmp0_imageVector, tmp1_contentDescription, tmp3_modifier, tmp2_tint, $composer_5, 384, 0);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$1562944507$lambda($this$AnimatedContent, isFav, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C256@12658L241:CartMugProductDetailsScreen.kt#6ni00');
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isFav) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1562944507, $dirty, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$1562944507.<anonymous> (CartMugProductDetailsScreen.kt:256)');
      }
      var tmp0_imageVector = isFav ? get_Favorite(Icons_getInstance().dxv_1) : get_FavoriteBorder(Icons_getInstance().dxv_1);
      var tmp;
      if (isFav) {
        $composer_0.m30(-1248875518);
        sourceInformation($composer_0, '256@12805L11');
        var tmp0_group = MaterialTheme_instance.unz($composer_0, 6).xnz_1;
        $composer_0.n30();
        tmp = tmp0_group;
      } else {
        $composer_0.m30(-1248874268);
        sourceInformation($composer_0, '256@12844L11');
        var tmp1_group = MaterialTheme_instance.unz($composer_0, 6).no0_1;
        $composer_0.n30();
        tmp = tmp1_group;
      }
      var tmp1_tint = tmp;
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
      var tmp2_modifier = size(tmp_0, tmp$ret$0);
      Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_0, 432, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$_2040348375$lambda_5d2eed($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C266@13441L248:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2040348375, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$-2040348375.<anonymous> (CartMugProductDetailsScreen.kt:266)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = padding_0(tmp, tmp$ret$0);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1746539987, 'C267@13596L11,267@13522L129:CartMugProductDetailsScreen.kt#6ni00');
      var tmp0_imageVector = get_Share(Icons_getInstance().dxv_1);
      var tmp1_tint = MaterialTheme_instance.unz($composer_5, 6).no0_1;
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
      var tmp2_modifier = size(tmp_1, tmp$ret$7);
      Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_5, 432, 0);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$_1934899937$lambda_nbtum9($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C377@20207L45,377@20202L51:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1934899937, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$-1934899937.<anonymous> (CartMugProductDetailsScreen.kt:377)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$354573206$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C395@21338L46,395@21333L52:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(354573206, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$354573206.<anonymous> (CartMugProductDetailsScreen.kt:395)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$_1523507819$lambda_2wc206($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C404@21993L39:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1523507819, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$-1523507819.<anonymous> (CartMugProductDetailsScreen.kt:404)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$_92550762$lambda_dnmbf7($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C423@23154L45,423@23149L51:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-92550762, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$-92550762.<anonymous> (CartMugProductDetailsScreen.kt:423)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$1067884109$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C441@24282L46,441@24277L52:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1067884109, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$1067884109.<anonymous> (CartMugProductDetailsScreen.kt:441)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$118283404$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C451@25005L39:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(118283404, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$118283404.<anonymous> (CartMugProductDetailsScreen.kt:451)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$221289641$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C512@28486L52,512@28481L58:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(221289641, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$221289641.<anonymous> (CartMugProductDetailsScreen.kt:512)');
      }
      var tmp = stringResource(get_add_product_comment_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$858457255$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C583@32347L49,584@32463L11,581@32210L316:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(858457255, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$858457255.<anonymous> (CartMugProductDetailsScreen.kt:581)');
      }
      var tmp = get_Remove(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_decrease_quantity_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).no0_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$902807888$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C604@33683L49,605@33799L11,602@33549L313:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(902807888, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$902807888.<anonymous> (CartMugProductDetailsScreen.kt:602)');
      }
      var tmp = get_Add(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_increase_quantity_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).no0_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$_2067901442$lambda_e8sv94($this$Card, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C741@41683L534:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2067901442, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$-2067901442.<anonymous> (CartMugProductDetailsScreen.kt:741)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
      var tmp0_modifier = padding_0(tmp, tmp$ret$0);
      var tmp1_horizontalAlignment = Companion_getInstance_11().x8t_1;
      var tmp_0 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = tmp0_modifier;
      var verticalArrangement = tmp_0.mdq(tmp$ret$1);
      var horizontalAlignment = tmp1_horizontalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier = Companion_instance;
      if (!((0 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((0 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1786228919, 'C742@41863L27,743@41928L54,743@42006L10,743@41923L136,744@42097L59,744@42092L95:CartMugProductDetailsScreen.kt#6ni00');
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
      CircularProgressIndicator(null, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_5, 0, 63);
      var tmp0_text = stringResource(get_adding_to_cart_dialog_title(string_instance), $composer_5, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp_6, null, tmp_7, null, tmp2_fontWeight, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131006);
      var tmp_11 = stringResource(get_adding_to_cart_dialog_msg_custom(string_instance), $composer_5, 0);
      var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_15 = Companion_getInstance_15().d7v_1;
      var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_17 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_11, null, tmp_12, null, tmp_13, null, null, null, tmp_14, null, tmp_15, tmp_16, tmp_17, false, 0, 0, null, null, $composer_5, 0, 0, 261118);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$_1505903114$lambda_ek3ccy($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C739@41510L755:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1505903114, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$-1505903114.<anonymous> (CartMugProductDetailsScreen.kt:739)');
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = null;
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((5 & 1) === 0))
        modifier = Companion_instance;
      if (!((5 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((5 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 30294457, 'C740@41577L666:CartMugProductDetailsScreen.kt#6ni00');
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(32);
      var tmp_1 = padding_0(tmp_0, tmp$ret$6);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(16);
      var tmp_2 = RoundedCornerShape(tmp$ret$7);
      Card(tmp_1, tmp_2, null, null, null, ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().i117_1, $composer_5, 196614, 28);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$1009568811$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C783@44224L29,783@44219L35:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1009568811, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$1009568811.<anonymous> (CartMugProductDetailsScreen.kt:783)');
      }
      var tmp = stringResource(get_ok(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt$lambda$839949869$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C788@44517L33,788@44512L39:CartMugProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(839949869, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartMugProductDetailsScreenKt.lambda$839949869.<anonymous> (CartMugProductDetailsScreen.kt:788)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartMugProductDetailsScreenKt() {
    ComposableSingletons$CartMugProductDetailsScreenKt_instance = this;
    var tmp = this;
    tmp.w116_1 = ComposableLambda$invoke$ref(composableLambdaInstance(800182414, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$800182414$lambda));
    var tmp_0 = this;
    tmp_0.x116_1 = ComposableLambda$invoke$ref_5(composableLambdaInstance(1562944507, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$1562944507$lambda));
    var tmp_1 = this;
    tmp_1.y116_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-2040348375, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$_2040348375$lambda_5d2eed));
    var tmp_2 = this;
    tmp_2.z116_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1934899937, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$_1934899937$lambda_nbtum9));
    var tmp_3 = this;
    tmp_3.a117_1 = ComposableLambda$invoke$ref(composableLambdaInstance(354573206, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$354573206$lambda));
    var tmp_4 = this;
    tmp_4.b117_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1523507819, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$_1523507819$lambda_2wc206));
    var tmp_5 = this;
    tmp_5.c117_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-92550762, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$_92550762$lambda_dnmbf7));
    var tmp_6 = this;
    tmp_6.d117_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1067884109, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$1067884109$lambda));
    var tmp_7 = this;
    tmp_7.e117_1 = ComposableLambda$invoke$ref(composableLambdaInstance(118283404, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$118283404$lambda));
    var tmp_8 = this;
    tmp_8.f117_1 = ComposableLambda$invoke$ref(composableLambdaInstance(221289641, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$221289641$lambda));
    var tmp_9 = this;
    tmp_9.g117_1 = ComposableLambda$invoke$ref(composableLambdaInstance(858457255, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$858457255$lambda));
    var tmp_10 = this;
    tmp_10.h117_1 = ComposableLambda$invoke$ref(composableLambdaInstance(902807888, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$902807888$lambda));
    var tmp_11 = this;
    tmp_11.i117_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(-2067901442, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$_2067901442$lambda_e8sv94));
    var tmp_12 = this;
    tmp_12.j117_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1505903114, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$_1505903114$lambda_ek3ccy));
    var tmp_13 = this;
    tmp_13.k117_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1009568811, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$1009568811$lambda));
    var tmp_14 = this;
    tmp_14.l117_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(839949869, false, ComposableSingletons$CartMugProductDetailsScreenKt$lambda$839949869$lambda));
  }
  var ComposableSingletons$CartMugProductDetailsScreenKt_instance;
  function ComposableSingletons$CartMugProductDetailsScreenKt_getInstance() {
    if (ComposableSingletons$CartMugProductDetailsScreenKt_instance == null)
      new ComposableSingletons$CartMugProductDetailsScreenKt();
    return ComposableSingletons$CartMugProductDetailsScreenKt_instance;
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0(function_0) {
    this.m117_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0).ka7 = function (_this__u8e3s4, $completion) {
    return this.m117_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0).q3 = function () {
    return this.m117_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function CartMugProductDetailsScreen$lambda($product$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('product', KMutableProperty0, true);
    return $product$delegate.u1();
  }
  function CartMugProductDetailsScreen$lambda_0($product$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('product', KMutableProperty0, true);
    $product$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMugProductDetailsScreen$slambda($cartItem, $getProductByIdUseCase, $product$delegate, resultContinuation) {
    this.v117_1 = $cartItem;
    this.w117_1 = $getProductByIdUseCase;
    this.x117_1 = $product$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMugProductDetailsScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMugProductDetailsScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMugProductDetailsScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_safe_receiver = this.v117_1.gyw_1;
            if (tmp0_safe_receiver == null) {
              this.z117_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = this.w117_1.o105(tmp0_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var ARGUMENT = suspendResult;
            CartMugProductDetailsScreen$lambda_0(this.x117_1, ARGUMENT);
            var tmp_0 = this;
            tmp_0.z117_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMugProductDetailsScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartMugProductDetailsScreen$slambda(this.v117_1, this.w117_1, this.x117_1, completion);
    i.y117_1 = $this$LaunchedEffect;
    return i;
  };
  function CartMugProductDetailsScreen$slambda_0($cartItem, $getProductByIdUseCase, $product$delegate, resultContinuation) {
    var i = new CartMugProductDetailsScreen$slambda($cartItem, $getProductByIdUseCase, $product$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CartMugProductDetailsScreen$lambda_1($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function CartMugProductDetailsScreen$lambda_2($isInteractingWith3D$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isInteractingWith3D', KMutableProperty0, true);
    return $isInteractingWith3D$delegate.u1();
  }
  function CartMugProductDetailsScreen$lambda_3($isInteractingWith3D$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isInteractingWith3D', KMutableProperty0, true);
    $isInteractingWith3D$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMugProductDetailsScreen$lambda_4($showFullScreen3D$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showFullScreen3D', KMutableProperty0, true);
    return $showFullScreen3D$delegate.u1();
  }
  function CartMugProductDetailsScreen$lambda_5($showFullScreen3D$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showFullScreen3D', KMutableProperty0, true);
    $showFullScreen3D$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMugProductDetailsScreen$lambda_6($isMediaDialogOpen$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isMediaDialogOpen', KMutableProperty0, true);
    return $isMediaDialogOpen$delegate.u1();
  }
  function CartMugProductDetailsScreen$lambda_7($isMediaDialogOpen$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isMediaDialogOpen', KMutableProperty0, true);
    $isMediaDialogOpen$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMugProductDetailsScreen$lambda_8($showBirthdayPicker$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    return $showBirthdayPicker$delegate.u1();
  }
  function CartMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    $showBirthdayPicker$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMugProductDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    return $birthdayPickerTargetOptionKey$delegate.u1();
  }
  function CartMugProductDetailsScreen$lambda_11($birthdayPickerTargetOptionKey$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    $birthdayPickerTargetOptionKey$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMugProductDetailsScreen$lambda_12($isPickingBoxBirthday$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    return $isPickingBoxBirthday$delegate.u1();
  }
  function CartMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    $isPickingBoxBirthday$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMugProductDetailsScreen$lambda_14($showDiscardDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    return $showDiscardDialog$delegate.u1();
  }
  function CartMugProductDetailsScreen$lambda_15($showDiscardDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    $showDiscardDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMugProductDetailsScreen$lambda_16($isSaving$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isSaving', KMutableProperty0, true);
    return $isSaving$delegate.u1();
  }
  function CartMugProductDetailsScreen$lambda_17($isSaving$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isSaving', KMutableProperty0, true);
    $isSaving$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartMugProductDetailsScreen$slambda_1($viewModel, $cartItem, $p, resultContinuation) {
    this.i118_1 = $viewModel;
    this.j118_1 = $cartItem;
    this.k118_1 = $p;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMugProductDetailsScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMugProductDetailsScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMugProductDetailsScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = delay(new Long(100, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this.i118_1.s10h();
            var tmp0_customImageUrl = this.j118_1.syw_1;
            var tmp1_designLayers = this.j118_1.tyw_1;
            tmp_0.j10i(new LoadProduct_1(this.k118_1.i100(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_designLayers, tmp0_customImageUrl), this.j118_1.jyx_1, this.j118_1.kyx_1, this.j118_1.lyx_1, this.j118_1.myx_1, this.j118_1.dyx_1, this.j118_1.gyx_1, this.j118_1.eyx_1, this.j118_1.fyx_1, this.j118_1.hyx_1, this.j118_1.iyx_1));
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMugProductDetailsScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartMugProductDetailsScreen$slambda_1(this.i118_1, this.j118_1, this.k118_1, completion);
    i.l118_1 = $this$LaunchedEffect;
    return i;
  };
  function CartMugProductDetailsScreen$slambda_2($viewModel, $cartItem, $p, resultContinuation) {
    var i = new CartMugProductDetailsScreen$slambda_1($viewModel, $cartItem, $p, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_9(function_0) {
    this.m118_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_9).a1v = function (value, $completion) {
    return this.m118_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_9).q3 = function () {
    return this.m118_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_9).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_9).hashCode = function () {
    return hashCode(this.q3());
  };
  function CartMugProductDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    this.v118_1 = $snackbarHostState;
    this.w118_1 = $onNavigateToAuth;
    this.x118_1 = $onBack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMugProductDetailsScreen$slambda$slambda).f112 = function (effect, $completion) {
    var tmp = this.g112(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMugProductDetailsScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.f112((!(p1 == null) ? isInterface(p1, CustomProductDetailsSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMugProductDetailsScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp0_subject = this.y118_1;
            if (tmp0_subject instanceof ShowMessage_4) {
              this.n9_1 = 2;
              suspendResult = this.y118_1.i112_1.z10i(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof ShowToast_0) {
                this.n9_1 = 1;
                suspendResult = this.y118_1.h112_1.z10i(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (equals(tmp0_subject, NavigateToAuth_instance_2)) {
                  this.z118_1 = this.w118_1();
                  this.n9_1 = 4;
                  continue $sm;
                } else {
                  if (equals(tmp0_subject, NavigateBack_instance_2)) {
                    this.z118_1 = this.x118_1();
                    this.n9_1 = 4;
                    continue $sm;
                  } else {
                    var tmp_0 = this;
                    noWhenBranchMatchedException();
                  }
                }
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            var tmp_1 = this;
            showToast(ARGUMENT);
            tmp_1.z118_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            this.n9_1 = 3;
            suspendResult = this.v118_1.dqm(ARGUMENT_0, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.z118_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMugProductDetailsScreen$slambda$slambda).g112 = function (effect, completion) {
    var i = new CartMugProductDetailsScreen$slambda$slambda(this.v118_1, this.w118_1, this.x118_1, completion);
    i.y118_1 = effect;
    return i;
  };
  function CartMugProductDetailsScreen$slambda$slambda_0($snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    var i = new CartMugProductDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.f112(effect, $completion);
    }, 1);
  }
  function CartMugProductDetailsScreen$slambda_3($viewModel, $snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    this.i119_1 = $viewModel;
    this.j119_1 = $snackbarHostState;
    this.k119_1 = $onNavigateToAuth;
    this.l119_1 = $onBack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMugProductDetailsScreen$slambda_3).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMugProductDetailsScreen$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMugProductDetailsScreen$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.i119_1.s10h().t10h();
            var tmp_1 = CartMugProductDetailsScreen$slambda$slambda_0(this.j119_1, this.k119_1, this.l119_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_9(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMugProductDetailsScreen$slambda_3).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartMugProductDetailsScreen$slambda_3(this.i119_1, this.j119_1, this.k119_1, this.l119_1, completion);
    i.m119_1 = $this$LaunchedEffect;
    return i;
  };
  function CartMugProductDetailsScreen$slambda_4($viewModel, $snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    var i = new CartMugProductDetailsScreen$slambda_3($viewModel, $snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CartMugProductDetailsScreen$slambda_5($appViewModel, $state$delegate, resultContinuation) {
    this.v119_1 = $appViewModel;
    this.w119_1 = $state$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMugProductDetailsScreen$slambda_5).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMugProductDetailsScreen$slambda_5).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMugProductDetailsScreen$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0;
          if (CartMugProductDetailsScreen$lambda_1(this.w119_1).a10z_1) {
            tmp_0 = true;
          } else {
            tmp_0 = !CartMugProductDetailsScreen$lambda_1(this.w119_1).g10z_1.r();
          }
          this.v119_1.l108(tmp_0);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CartMugProductDetailsScreen$slambda_5).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartMugProductDetailsScreen$slambda_5(this.v119_1, this.w119_1, completion);
    i.x119_1 = $this$LaunchedEffect;
    return i;
  };
  function CartMugProductDetailsScreen$slambda_6($appViewModel, $state$delegate, resultContinuation) {
    var i = new CartMugProductDetailsScreen$slambda_5($appViewModel, $state$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CartMugProductDetailsScreen$$inlined$let$4$1($appViewModel) {
    this.y119_1 = $appViewModel;
  }
  protoOf(CartMugProductDetailsScreen$$inlined$let$4$1).s1d = function () {
    this.y119_1.l108(false);
  };
  function CartMugProductDetailsScreen$lambda_18($appViewModel) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new CartMugProductDetailsScreen$$inlined$let$4$1($appViewModel);
    };
  }
  function CartMugProductDetailsScreen$lambda_19($showFullScreen3D$delegate, $state$delegate, $showDiscardDialog$delegate) {
    return function () {
      var tmp;
      if (CartMugProductDetailsScreen$lambda_4($showFullScreen3D$delegate)) {
        CartMugProductDetailsScreen$lambda_5($showFullScreen3D$delegate, false);
        tmp = Unit_instance;
      } else {
        var tmp_0;
        if (CartMugProductDetailsScreen$lambda_1($state$delegate).a10z_1) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_0 = !CartMugProductDetailsScreen$lambda_1($state$delegate).g10z_1.r();
        }
        if (tmp_0) {
          CartMugProductDetailsScreen$lambda_15($showDiscardDialog$delegate, true);
          tmp = Unit_instance;
        }
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_20($showDiscardDialog$delegate, $onBack) {
    return function () {
      CartMugProductDetailsScreen$lambda_15($showDiscardDialog$delegate, false);
      $onBack();
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_21($showDiscardDialog$delegate) {
    return function () {
      CartMugProductDetailsScreen$lambda_15($showDiscardDialog$delegate, false);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$slambda$slambda_1($isInteractingWith3D$delegate, resultContinuation) {
    this.h11a_1 = $isInteractingWith3D$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMugProductDetailsScreen$slambda$slambda_1).ic6 = function ($this$awaitPointerEventScope, $completion) {
    var tmp = this.jc6($this$awaitPointerEventScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMugProductDetailsScreen$slambda$slambda_1).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMugProductDetailsScreen$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 4;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = this.i11a_1.pa7(PointerEventPass_Initial_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var event = suspendResult;
            var tmp0 = event.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var tmp_0;
              if (isInterface(tmp0, Collection)) {
                tmp_0 = tmp0.r();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$0 = false;
                break l$ret$1;
              }
              var _iterator__ex2g4s = tmp0.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (element.la0_1) {
                  tmp$ret$0 = true;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = false;
            }
             while (false);
            CartMugProductDetailsScreen$lambda_3(this.h11a_1, tmp$ret$0);
            this.n9_1 = 1;
            continue $sm;
          case 3:
            throw this.q9_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMugProductDetailsScreen$slambda$slambda_1).jc6 = function ($this$awaitPointerEventScope, completion) {
    var i = new CartMugProductDetailsScreen$slambda$slambda_1(this.h11a_1, completion);
    i.i11a_1 = $this$awaitPointerEventScope;
    return i;
  };
  function CartMugProductDetailsScreen$slambda$slambda_2($isInteractingWith3D$delegate, resultContinuation) {
    var i = new CartMugProductDetailsScreen$slambda$slambda_1($isInteractingWith3D$delegate, resultContinuation);
    return constructCallableReference(function ($this$awaitPointerEventScope, $completion) {
      return i.ic6($this$awaitPointerEventScope, $completion);
    }, 1);
  }
  function CartMugProductDetailsScreen$slambda_7($isInteractingWith3D$delegate, resultContinuation) {
    this.r11a_1 = $isInteractingWith3D$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMugProductDetailsScreen$slambda_7).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMugProductDetailsScreen$slambda_7).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMugProductDetailsScreen$slambda_7).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.s11a_1.ma7(CartMugProductDetailsScreen$slambda$slambda_2(this.r11a_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMugProductDetailsScreen$slambda_7).wc6 = function ($this$pointerInput, completion) {
    var i = new CartMugProductDetailsScreen$slambda_7(this.r11a_1, completion);
    i.s11a_1 = $this$pointerInput;
    return i;
  };
  function CartMugProductDetailsScreen$slambda_8($isInteractingWith3D$delegate, resultContinuation) {
    var i = new CartMugProductDetailsScreen$slambda_7($isInteractingWith3D$delegate, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function CartMugProductDetailsScreen$lambda_22($viewModel, $p) {
    return function () {
      $viewModel.s10h().j10i(new LoadProduct_1($p));
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_23($state$delegate, $showDiscardDialog$delegate, $onBack) {
    return function () {
      var tmp;
      var tmp_0;
      if (CartMugProductDetailsScreen$lambda_1($state$delegate).a10z_1) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_0 = !CartMugProductDetailsScreen$lambda_1($state$delegate).g10z_1.r();
      }
      if (tmp_0) {
        CartMugProductDetailsScreen$lambda_15($showDiscardDialog$delegate, true);
        tmp = Unit_instance;
      } else {
        tmp = $onBack();
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_24($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ToggleFavorite_instance_0);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_25($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C254@12462L517:CartMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2102011214, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMugProductDetailsScreen.kt:254)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 669895357, 'C255@12543L398:CartMugProductDetailsScreen.kt#6ni00');
        var tmp_2 = CartMugProductDetailsScreen$lambda_1($state$delegate).b10z_1;
        AnimatedContent(tmp_2, null, null, null, '', null, ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().x116_1, $composer_5, 1597440, 46);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_26($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ShareProduct_instance_0);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_27($showFullScreen3D$delegate) {
    return function () {
      CartMugProductDetailsScreen$lambda_5($showFullScreen3D$delegate, true);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_28($language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C284@14410L1108:CartMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-921999510, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMugProductDetailsScreen.kt:284)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_1 = _Dp___init__impl__ms3zkb(20);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(10);
        var tmp0_modifier = padding_2(tmp_0, tmp_1, tmp$ret$1);
        var tmp1_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_2 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$2 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = tmp0_modifier;
        var horizontalArrangement = tmp_2.mdq(tmp$ret$2);
        var verticalAlignment = tmp1_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_3 = $composer_3.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -1575631702, 'C293@15012L11,289@14741L337,297@15269L10,299@15422L11,295@15111L377:CartMugProductDetailsScreen.kt#6ni00');
        var tmp_4 = get_Fullscreen(Icons_getInstance().dxv_1);
        var tmp_5 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$9 = _Dp___init__impl__ms3zkb(24);
        Icon(tmp_4, null, size(tmp_5, tmp$ret$9), MaterialTheme_instance.unz($composer_5, 6).fo0_1, $composer_5, 432, 0);
        var tmp0_text = $language === 'en' ? 'Full Show' : '\u0639\u0631\u0636 \u0643\u0627\u0645\u0644';
        var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
        var tmp2_fontWeight = Companion_getInstance_16().f7z_1;
        var tmp3_color = MaterialTheme_instance.unz($composer_5, 6).fo0_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_9 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp3_color, null, tmp_6, null, tmp2_fontWeight, null, tmp_7, null, null, tmp_8, tmp_9, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131002);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_10;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_10 = Unit_instance;
        }
        tmp = tmp_10;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_29($isMediaDialogOpen$delegate) {
    return function (it) {
      CartMugProductDetailsScreen$lambda_7($isMediaDialogOpen$delegate, it);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_30($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new CardSelected_1(it instanceof Card_1 ? it : null));
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_31($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new CardMessageChanged_1(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_32($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C385@20823L10,381@20515L371:CartMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2039439852, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMugProductDetailsScreen.kt:381)');
        }
        var tmp_0 = '' + CartMugProductDetailsScreen$lambda_1($state$delegate).n10z_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_33($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CartMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, false);
      CartMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_34(it) {
    return Unit_instance;
  }
  function CartMugProductDetailsScreen$lambda$lambda($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CartMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, false);
      CartMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_35($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C401@21813L176,401@21792L242:CartMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2048628877, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMugProductDetailsScreen.kt:401)');
        }
        sourceInformationMarkerStart($composer_0, -1637328317, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CartMugProductDetailsScreen$lambda$lambda($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().b117_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_36($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new BoxSelected_1(it instanceof Box_0 ? it : null));
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_37($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new BoxMessageChanged_1(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_38($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C431@23769L10,427@23462L370:CartMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1022060323, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMugProductDetailsScreen.kt:427)');
        }
        var tmp_0 = '' + CartMugProductDetailsScreen$lambda_1($state$delegate).r10z_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_39($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CartMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, true);
      CartMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_40(it) {
    return Unit_instance;
  }
  function CartMugProductDetailsScreen$lambda$lambda_0($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CartMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, true);
      CartMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_41($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C448@24826L175,448@24805L241:CartMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2011879702, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMugProductDetailsScreen.kt:448)');
        }
        sourceInformationMarkerStart($composer_0, -681109511, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CartMugProductDetailsScreen$lambda$lambda_0($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().e117_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_42($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new SizeSelected_1(it));
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_43($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new ColorSelected_1(it));
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_44($viewModel, $option) {
    return function (value) {
      $viewModel.s10h().j10i(new OptionSelected_1($option.r101_1, value));
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_45($viewModel, $option) {
    return function (newValue) {
      $viewModel.s10h().j10i(new OptionSelected_1($option.r101_1, newValue));
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_46($birthdayPickerTargetOptionKey$delegate, $option, $showBirthdayPicker$delegate) {
    return function () {
      CartMugProductDetailsScreen$lambda_11($birthdayPickerTargetOptionKey$delegate, $option.r101_1);
      CartMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_47($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 100) {
        $viewModel.s10h().j10i(new ProductCommentChanged_1(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda$lambda_1($state$delegate, $viewModel) {
    return function () {
      var tmp;
      if (CartMugProductDetailsScreen$lambda_1($state$delegate).z10y_1 > 1) {
        $viewModel.s10h().j10i(new QuantityChanged_0(CartMugProductDetailsScreen$lambda_1($state$delegate).z10y_1 - 1 | 0));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda$lambda_2($viewModel, $state$delegate) {
    return function () {
      $viewModel.s10h().j10i(new QuantityChanged_0(CartMugProductDetailsScreen$lambda_1($state$delegate).z10y_1 + 1 | 0));
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda$lambda_3() {
    return EmptyCoroutineContext_getInstance();
  }
  function CartMugProductDetailsScreen$lambda$lambda$slambda($isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg, resultContinuation) {
    this.b11b_1 = $isSaving$delegate;
    this.c11b_1 = $state$delegate;
    this.d11b_1 = $p;
    this.e11b_1 = $cartRepository;
    this.f11b_1 = $cartItem;
    this.g11b_1 = $savedSuccessMsg;
    this.h11b_1 = $failedToSaveMsg;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMugProductDetailsScreen$lambda$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMugProductDetailsScreen$lambda$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMugProductDetailsScreen$lambda$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            CartMugProductDetailsScreen$lambda_17(this.b11b_1, true);
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.o9_1 = 3;
            var tmp0_safe_receiver = CartMugProductDetailsScreen$lambda_1(this.c11b_1).m10z_1;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lyz_1;
            var tmp_0 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
            var tmp2_safe_receiver = CartMugProductDetailsScreen$lambda_1(this.c11b_1).q10z_1;
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.wyz_1;
            var tmp_1 = tmp_0 + (tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs);
            var sum = 0;
            var _iterator__ex2g4s = CartMugProductDetailsScreen$lambda_1(this.c11b_1).w10z_1.y2().t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              var tmp_2 = sum;
              var tmp0_elvis_lhs = element.q100_1;
              sum = tmp_2 + (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
            }

            var extraOriginalPrice = tmp_1 + sum;
            var tmp4_safe_receiver = CartMugProductDetailsScreen$lambda_1(this.c11b_1).m10z_1;
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.lyz_1;
            var tmp_3 = tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs;
            var tmp6_safe_receiver = CartMugProductDetailsScreen$lambda_1(this.c11b_1).q10z_1;
            var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.wyz_1;
            var tmp_4 = tmp_3 + (tmp7_elvis_lhs == null ? 0.0 : tmp7_elvis_lhs);
            var sum_0 = 0;
            var _iterator__ex2g4s_0 = CartMugProductDetailsScreen$lambda_1(this.c11b_1).w10z_1.y2().t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              var tmp_5 = sum_0;
              var tmp_6;
              var tmp0_elvis_lhs_0 = element_0.r100_1;
              if ((tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0) > 0.0) {
                tmp_6 = ensureNotNull(element_0.r100_1);
              } else {
                var tmp1_elvis_lhs_0 = element_0.q100_1;
                tmp_6 = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
              }
              sum_0 = tmp_5 + tmp_6;
            }

            var extraDiscountedPrice = tmp_4 + sum_0;
            var tmp8_elvis_lhs = this.d11b_1.szt_1;
            var finalPrice = (tmp8_elvis_lhs == null ? 0.0 : tmp8_elvis_lhs) + extraOriginalPrice;
            var tmp_7;
            var tmp9_elvis_lhs = this.d11b_1.tzt_1;
            if ((tmp9_elvis_lhs == null ? 0.0 : tmp9_elvis_lhs) > 0.0) {
              tmp_7 = true;
            } else {
              var tmp0 = CartMugProductDetailsScreen$lambda_1(this.c11b_1).w10z_1.y2();
              var tmp$ret$0;
              l$ret$1: do {
                var tmp_8;
                if (isInterface(tmp0, Collection)) {
                  tmp_8 = tmp0.r();
                } else {
                  tmp_8 = false;
                }
                if (tmp_8) {
                  tmp$ret$0 = false;
                  break l$ret$1;
                }
                var _iterator__ex2g4s_1 = tmp0.t();
                while (_iterator__ex2g4s_1.u()) {
                  var element_1 = _iterator__ex2g4s_1.v();
                  var tmp0_elvis_lhs_1 = element_1.r100_1;
                  if ((tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1) > 0.0) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                }
                tmp$ret$0 = false;
              }
               while (false);
              tmp_7 = tmp$ret$0;
            }

            var hasAnyDiscount = tmp_7;
            var tmp_9;
            if (hasAnyDiscount) {
              var tmp_10;
              var tmp10_elvis_lhs = this.d11b_1.tzt_1;
              if ((tmp10_elvis_lhs == null ? 0.0 : tmp10_elvis_lhs) > 0.0) {
                tmp_10 = ensureNotNull(this.d11b_1.tzt_1);
              } else {
                var tmp11_elvis_lhs = this.d11b_1.szt_1;
                tmp_10 = tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs;
              }
              tmp_9 = tmp_10 + extraDiscountedPrice;
            } else {
              tmp_9 = 0.0;
            }

            var finalDiscount = tmp_9;
            this.n9_1 = 2;
            var tmp16_quantity = CartMugProductDetailsScreen$lambda_1(this.c11b_1).z10y_1;
            var tmp17_productComment = CartMugProductDetailsScreen$lambda_1(this.c11b_1).x10z_1;
            var tmp18_selectedCard = CartMugProductDetailsScreen$lambda_1(this.c11b_1).m10z_1;
            var tmp_11;
            var tmp12_safe_receiver = CartMugProductDetailsScreen$lambda_1(this.c11b_1).m10z_1;
            if ((tmp12_safe_receiver == null ? null : tmp12_safe_receiver.oyz_1) === true) {
              tmp_11 = CartMugProductDetailsScreen$lambda_1(this.c11b_1).n10z_1;
            } else {
              tmp_11 = null;
            }

            var tmp19_cardMessage = tmp_11;
            var tmp_12;
            var tmp13_safe_receiver = CartMugProductDetailsScreen$lambda_1(this.c11b_1).m10z_1;
            if ((tmp13_safe_receiver == null ? null : tmp13_safe_receiver.pyz_1) === true) {
              tmp_12 = CartMugProductDetailsScreen$lambda_1(this.c11b_1).o10z_1;
            } else {
              tmp_12 = null;
            }

            var tmp20_cardBirthday = tmp_12;
            var tmp21_selectedBox = CartMugProductDetailsScreen$lambda_1(this.c11b_1).q10z_1;
            var tmp_13;
            var tmp14_safe_receiver = CartMugProductDetailsScreen$lambda_1(this.c11b_1).q10z_1;
            if ((tmp14_safe_receiver == null ? null : tmp14_safe_receiver.zyz_1) === true) {
              tmp_13 = CartMugProductDetailsScreen$lambda_1(this.c11b_1).r10z_1;
            } else {
              tmp_13 = null;
            }

            var tmp22_boxMessage = tmp_13;
            var tmp_14;
            var tmp15_safe_receiver = CartMugProductDetailsScreen$lambda_1(this.c11b_1).q10z_1;
            if ((tmp15_safe_receiver == null ? null : tmp15_safe_receiver.az0_1) === true) {
              tmp_14 = CartMugProductDetailsScreen$lambda_1(this.c11b_1).s10z_1;
            } else {
              tmp_14 = null;
            }

            var tmp23_boxBirthday = tmp_14;
            var tmp24_selectedSize = CartMugProductDetailsScreen$lambda_1(this.c11b_1).u10z_1;
            var tmp25_selectedColor = CartMugProductDetailsScreen$lambda_1(this.c11b_1).v10z_1;
            var this_0 = CartMugProductDetailsScreen$lambda_1(this.c11b_1).w10z_1;
            var tmp_15;
            if (this_0.r()) {
              tmp_15 = null;
            } else {
              tmp_15 = this_0;
            }

            var tmp26_selectedOptions = tmp_15;
            suspendResult = this.e11b_1.dz0(this.f11b_1.jyy(VOID, VOID, VOID, VOID, VOID, VOID, finalPrice, finalDiscount, VOID, VOID, VOID, VOID, tmp16_quantity, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp18_selectedCard, tmp19_cardMessage, tmp20_cardBirthday, tmp21_selectedBox, tmp22_boxMessage, tmp23_boxBirthday, tmp24_selectedSize, tmp25_selectedColor, tmp26_selectedOptions, tmp17_productComment), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            showToast(this.g11b_1);
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 4;
            var tmp_16 = this.q9_1;
            if (tmp_16 instanceof Exception) {
              var _unused_var__etf5q3 = this.q9_1;
              showToast(this.h11b_1);
              this.o9_1 = 6;
              this.n9_1 = 5;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 6;
            var t = this.q9_1;
            CartMugProductDetailsScreen$lambda_17(this.b11b_1, false);
            throw t;
          case 5:
            this.o9_1 = 6;
            CartMugProductDetailsScreen$lambda_17(this.b11b_1, false);
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMugProductDetailsScreen$lambda$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new CartMugProductDetailsScreen$lambda$lambda$slambda(this.b11b_1, this.c11b_1, this.d11b_1, this.e11b_1, this.f11b_1, this.g11b_1, this.h11b_1, completion);
    i.i11b_1 = $this$launch;
    return i;
  };
  function CartMugProductDetailsScreen$lambda$lambda$slambda_0($isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg, resultContinuation) {
    var i = new CartMugProductDetailsScreen$lambda$lambda$slambda($isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CartMugProductDetailsScreen$lambda$lambda_4($scope, $isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg) {
    return function () {
      launch($scope, VOID, VOID, CartMugProductDetailsScreen$lambda$lambda$slambda_0($isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg, null));
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda$lambda_5($isSaving$delegate) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:CartMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(525741866, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartMugProductDetailsScreen.kt:671)');
        }
        if (CartMugProductDetailsScreen$lambda_16($isSaving$delegate)) {
          $composer_0.m30(-1369745401);
          sourceInformation($composer_0, '672@38396L241');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          var tmp_2 = Companion_getInstance_14().m6b_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_3 = _Dp___init__impl__ms3zkb(2);
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_0, 438, 56);
          $composer_0.n30();
        } else {
          $composer_0.m30(-1369381554);
          sourceInformation($composer_0, '678@38707L1002');
          var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier = null;
          var horizontalArrangement = Arrangement_getInstance().udp_1;
          var verticalAlignment = tmp0_verticalAlignment;
          var $composer_1 = $composer_0;
          if (!((1 & 1) === 0))
            modifier = Companion_instance;
          if (!((1 & 2) === 0))
            horizontalArrangement = Arrangement_getInstance().qdp_1;
          if (!((1 & 4) === 0))
            verticalAlignment = Companion_getInstance_11().t8t_1;
          var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_0 = modifier;
          var $composer_2 = $composer_1;
          if (!((0 & 2) === 0))
            modifier_0 = Companion_instance;
          var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
          var localMap = $composer_2.t31();
          var materialized = materialize($composer_2, modifier_0);
          var tmp0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_3 = $composer_2;
          var tmp_6 = $composer_3.g30();
          if (!isInterface(tmp_6, Applier)) {
            invalidApplier();
          }
          $composer_3.b31();
          if ($composer_3.h30()) {
            $composer_3.c31(tmp0);
          } else {
            $composer_3.d31();
          }
          var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
          var $composer_4 = $composer_3;
          var $composer_5 = $composer_4;
          sourceInformationMarkerStart($composer_5, 30584313, 'C682@38947L242,687@39226L39,689@39348L31,688@39302L373:CartMugProductDetailsScreen.kt#6ni00');
          var tmp_7 = get_Save(Icons_getInstance().dxv_1);
          var tmp_8 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$8 = _Dp___init__impl__ms3zkb(20);
          var tmp_9 = size(tmp_8, tmp$ret$8);
          Icon(tmp_7, null, tmp_9, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 432, 8);
          var tmp_10 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$9 = _Dp___init__impl__ms3zkb(8);
          Spacer(width(tmp_10, tmp$ret$9), $composer_5, 6);
          var tmp0_text = stringResource(get_save(string_instance), $composer_5, 0);
          var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp2_fontSize = get_sp(16);
          var tmp3_textAlign = Companion_getInstance_15().d7v_1;
          var tmp4_lineHeight = get_sp(18);
          var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_13 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, null, tmp_11, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_12, null, tmp3_textAlign, tmp4_lineHeight, tmp_13, false, 0, 0, null, null, $composer_5, 1597440, 48, 258990);
          sourceInformationMarkerEnd($composer_5);
          $composer_3.e31();
          $composer_0.n30();
        }
        var tmp_14;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_14 = Unit_instance;
        }
        tmp = tmp_14;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_48($p, $state$delegate, $viewModel, $language, $cartRepository, $cartItem) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C551@30393L9394:CartMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-528818690, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous> (CartMugProductDetailsScreen.kt:551)');
        }
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_start = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_end = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_top = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp4_bottom = _Dp___init__impl__ms3zkb(8);
        var tmp5_modifier = fillMaxWidth(padding_1(Companion_instance, tmp1_start, tmp3_top, tmp2_end, tmp4_bottom));
        var tmp6_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_0 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$4 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = tmp5_modifier;
        var horizontalArrangement = tmp_0.mdq(tmp$ret$4);
        var verticalAlignment = tmp6_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 1066226407, 'C619@34471L24,620@34536L34,621@34617L45,622@34709L41,667@38126L11,667@38082L64,625@34822L2995,670@38318L1447,624@34776L4989:CartMugProductDetailsScreen.kt#6ni00');
        var tmp2_elvis_lhs = $p.wzt_1;
        if ((tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) > 0) {
          $composer_5.m30(1066112202);
          sourceInformation($composer_5, '560@30889L3518');
          var tmp0_horizontalAlignment = Companion_getInstance_11().x8t_1;
          var tmp_2 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$11 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_1 = null;
          var verticalArrangement = tmp_2.mdq(tmp$ret$11);
          var horizontalAlignment = tmp0_horizontalAlignment;
          var $composer_6 = $composer_5;
          if (!((1 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((1 & 2) === 0))
            verticalArrangement = Arrangement_getInstance().sdp_1;
          if (!((1 & 4) === 0))
            horizontalAlignment = Companion_getInstance_11().w8t_1;
          var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_7 = $composer_6;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
          var localMap_0 = $composer_7.t31();
          var materialized_0 = materialize($composer_7, modifier_2);
          var tmp0_0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_8 = $composer_7;
          var tmp_3 = $composer_8.g30();
          if (!isInterface(tmp_3, Applier)) {
            invalidApplier();
          }
          $composer_8.b31();
          if ($composer_8.h30()) {
            $composer_8.c31(tmp0_0);
          } else {
            $composer_8.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_9 = $composer_8;
          var $composer_10 = $composer_9;
          sourceInformationMarkerStart($composer_10, -1273495833, 'C568@31382L11,564@31126L2808,610@34016L45,611@34121L10,612@34202L11,609@33967L410:CartMugProductDetailsScreen.kt#6ni00');
          var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
          var tmp_4 = Companion_instance;
          var tmp_5 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_10, 6).oo0_1, 0.5);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$18 = _Dp___init__impl__ms3zkb(12);
          var tmp_6 = background(tmp_4, tmp_5, RoundedCornerShape(tmp$ret$18));
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_7 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$20 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_3 = padding_2(tmp_6, tmp_7, tmp$ret$20);
          var horizontalArrangement_0 = null;
          var verticalAlignment_0 = tmp0_verticalAlignment;
          var $composer_11 = $composer_10;
          if (!((2 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((2 & 2) === 0))
            horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
          if (!((2 & 4) === 0))
            verticalAlignment_0 = Companion_getInstance_11().t8t_1;
          var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_11, 14 & 384 >> 3 | 112 & 384 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_8 = $composer_13.g30();
          if (!isInterface(tmp_8, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_1);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_15, -495963964, 'C574@31760L296,573@31698L866,592@32965L11,587@32601L423,595@33123L272,594@33061L839:CartMugProductDetailsScreen.kt#6ni00');
          sourceInformationMarkerStart($composer_15, 676737901, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = !!($composer_15.k31($state$delegate) | $composer_15.q31($viewModel));
          // Inline function 'kotlin.let' call
          var it = $composer_15.i31();
          var tmp_9;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = CartMugProductDetailsScreen$lambda$lambda_1($state$delegate, $viewModel);
            $composer_15.j31(value);
            tmp_9 = value;
          } else {
            tmp_9 = it;
          }
          var tmp0_group = tmp_9;
          sourceInformationMarkerEnd($composer_15);
          var tmp_10 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$31 = _Dp___init__impl__ms3zkb(36);
          var tmp_11 = size(tmp_10, tmp$ret$31);
          IconButton(tmp0_group, tmp_11, false, null, null, null, ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().g117_1, $composer_15, 1572912, 60);
          var tmp0_text = format(CartMugProductDetailsScreen$lambda_1($state$delegate).z10y_1, $language);
          var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp2_fontSize = get_sp(18);
          var tmp_12 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$32 = _Dp___init__impl__ms3zkb(8);
          var tmp3_modifier = padding_2(tmp_12, tmp$ret$32);
          var tmp4_color = MaterialTheme_instance.unz($composer_15, 6).no0_1;
          var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_15 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, tmp3_modifier, tmp4_color, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_13, null, null, tmp_14, tmp_15, false, 0, 0, null, null, $composer_15, 1597488, 0, 262056);
          sourceInformationMarkerStart($composer_15, 676781493, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = !!($composer_15.q31($viewModel) | $composer_15.k31($state$delegate));
          // Inline function 'kotlin.let' call
          var it_0 = $composer_15.i31();
          var tmp_16;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = CartMugProductDetailsScreen$lambda$lambda_2($viewModel, $state$delegate);
            $composer_15.j31(value_0);
            tmp_16 = value_0;
          } else {
            tmp_16 = it_0;
          }
          var tmp1_group = tmp_16;
          sourceInformationMarkerEnd($composer_15);
          var tmp_17 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$37 = _Dp___init__impl__ms3zkb(32);
          var tmp_18 = size(tmp_17, tmp$ret$37);
          IconButton(tmp1_group, tmp_18, false, null, null, null, ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().h117_1, $composer_15, 1572912, 60);
          sourceInformationMarkerEnd($composer_15);
          $composer_13.e31();
          var tmp2_text = stringResource(get_bulk_discount_info(string_instance), $composer_10, 0);
          var tmp3_style = MaterialTheme_instance.jog($composer_10, 6).tof_1;
          var tmp4_color_0 = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
          var tmp5_fontSize = get_sp(10);
          var tmp6_fontWeight = Companion_getInstance_16().c7z_1;
          var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_21 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp2_text, null, tmp4_color_0, null, tmp5_fontSize, null, tmp6_fontWeight, null, tmp_19, null, null, tmp_20, tmp_21, false, 0, 0, null, tmp3_style, $composer_10, 1597440, 0, 130986);
          sourceInformationMarkerEnd($composer_10);
          $composer_8.e31();
          $composer_5.n30();
        } else {
          $composer_5.m30(1069518792);
          $composer_5.n30();
        }
        // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
        var getContext = null;
        var $composer_16 = $composer_5;
        if (!((1 & 1) === 0)) {
          getContext = CartMugProductDetailsScreen$lambda$lambda_3;
        }
        var composer = $composer_16;
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_1 = $composer_16.i31();
        var tmp_22;
        if (false || it_1 === Companion_getInstance().f30_1) {
          var value_1 = createCompositionCoroutineScope(getContext(), composer);
          $composer_16.j31(value_1);
          tmp_22 = value_1;
        } else {
          tmp_22 = it_1;
        }
        var scope = tmp_22;
        sourceInformationMarkerStart($composer_5, -104043396, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_2 = $composer_5.i31();
        var tmp_23;
        if (false || it_2 === Companion_getInstance().f30_1) {
          var value_2 = mutableStateOf(false);
          $composer_5.j31(value_2);
          tmp_23 = value_2;
        } else {
          tmp_23 = it_2;
        }
        var tmp0_group_0 = tmp_23;
        sourceInformationMarkerEnd($composer_5);
        var isSaving$delegate = tmp0_group_0;
        var savedSuccessMsg = stringResource(get_saved_successfully(string_instance), $composer_5, 0);
        var failedToSaveMsg = stringResource(get_failed_to_save(string_instance), $composer_5, 0);
        var tmp_24 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$47 = _Dp___init__impl__ms3zkb(56);
        var tmp3_modifier_0 = heightIn(tmp_24, tmp$ret$47);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$48 = _Dp___init__impl__ms3zkb(16);
        var tmp4_shape = RoundedCornerShape(tmp$ret$48);
        var tmp_25 = ButtonDefaults_getInstance();
        var tmp_26 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
        var tmp_27 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_28 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp5_colors = tmp_25.ao9(tmp_26, tmp_27, tmp_28, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
        var tmp6_enabled = !CartMugProductDetailsScreen$lambda_16(isSaving$delegate);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_29 = _Dp___init__impl__ms3zkb(4);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$50 = _Dp___init__impl__ms3zkb(4);
        var tmp7_contentPadding = PaddingValues_0(tmp_29, tmp$ret$50);
        sourceInformationMarkerStart($composer_5, -104031283, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = !!(!!(!!(!!(!!(!!($composer_5.q31(scope) | $composer_5.k31($state$delegate)) | $composer_5.q31($p)) | $composer_5.q31($cartRepository)) | $composer_5.q31($cartItem)) | $composer_5.k31(savedSuccessMsg)) | $composer_5.k31(failedToSaveMsg));
        // Inline function 'kotlin.let' call
        var it_3 = $composer_5.i31();
        var tmp_30;
        if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
          var value_3 = CartMugProductDetailsScreen$lambda$lambda_4(scope, isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, savedSuccessMsg, failedToSaveMsg);
          $composer_5.j31(value_3);
          tmp_30 = value_3;
        } else {
          tmp_30 = it_3;
        }
        var tmp1_group_0 = tmp_30;
        sourceInformationMarkerEnd($composer_5);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(525741866, true, CartMugProductDetailsScreen$lambda$lambda_5(isSaving$delegate), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_17 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_17.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_17.i31();
        var tmp_31;
        if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
          var value_4 = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_17.j31(value_4);
          tmp_31 = value_4;
        } else {
          tmp_31 = it_4;
        }
        var tmp$ret$55 = tmp_31;
        Button(tmp1_group_0, tmp3_modifier_0, tmp6_enabled, tmp4_shape, tmp5_colors, null, null, tmp7_contentPadding, null, tmp$ret$55, $composer_5, 817889280, 352);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_32;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_32 = Unit_instance;
        }
        tmp = tmp_32;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$slambda_9($verticalScrollState, resultContinuation) {
    this.r11b_1 = $verticalScrollState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMugProductDetailsScreen$slambda_9).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMugProductDetailsScreen$slambda_9).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMugProductDetailsScreen$slambda_9).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.r11b_1.tg7(0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMugProductDetailsScreen$slambda_9).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartMugProductDetailsScreen$slambda_9(this.r11b_1, completion);
    i.s11b_1 = $this$LaunchedEffect;
    return i;
  };
  function CartMugProductDetailsScreen$slambda_10($verticalScrollState, resultContinuation) {
    var i = new CartMugProductDetailsScreen$slambda_9($verticalScrollState, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CartMugProductDetailsScreen$lambda_49($viewModel) {
    return function (bitmap, bytes, elements) {
      $viewModel.s10h().j10i(new CustomImageApplied_0(bitmap, bytes, elements));
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_50($viewModel) {
    return function () {
      $viewModel.s10h().j10i(CloseEditor_instance_0);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_51($viewModel, $p) {
    return function () {
      $viewModel.s10h().j10i(new LoadProduct_1($p));
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_52($showFullScreen3D$delegate) {
    return function () {
      CartMugProductDetailsScreen$lambda_5($showFullScreen3D$delegate, false);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_53($showFullScreen3D$delegate, $viewModel) {
    return function () {
      CartMugProductDetailsScreen$lambda_5($showFullScreen3D$delegate, false);
      $viewModel.s10h().j10i(OpenEditor_instance_0);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_54($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate) {
    return function () {
      CartMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, false);
      CartMugProductDetailsScreen$lambda_11($birthdayPickerTargetOptionKey$delegate, null);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda$lambda_6($birthdayPickerState, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $viewModel, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      var tmp0_safe_receiver = $birthdayPickerState.np1();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var date = toLocalDateTime(Companion_getInstance_19().kf(tmp0_safe_receiver), Companion_getInstance_20().yno_1).xn9_1.toString();
        if (!(CartMugProductDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate) == null)) {
          var key = ensureNotNull(CartMugProductDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate));
          var selectedValue = CartMugProductDetailsScreen$lambda_1($state$delegate).w10z_1.w2(key);
          if (!(selectedValue == null)) {
            $viewModel.s10h().j10i(new OptionSelected_1(key, selectedValue.k101(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, date)));
          }
        } else if (CartMugProductDetailsScreen$lambda_12($isPickingBoxBirthday$delegate)) {
          $viewModel.s10h().j10i(new BoxBirthdayChanged_1(date));
        } else {
          $viewModel.s10h().j10i(new CardBirthdayChanged_1(date));
        }
      }
      CartMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, false);
      CartMugProductDetailsScreen$lambda_11($birthdayPickerTargetOptionKey$delegate, null);
      CartMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_55($birthdayPickerState, $state$delegate, $viewModel, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C759@42715L1500,759@42694L1562:CartMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1868926034, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous> (CartMugProductDetailsScreen.kt:759)');
        }
        sourceInformationMarkerStart($composer_0, -741586710, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.k31($birthdayPickerState) | $composer_0.k31($state$delegate)) | $composer_0.q31($viewModel));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CartMugProductDetailsScreen$lambda$lambda_6($birthdayPickerState, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $viewModel, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().k117_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda$lambda_7($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function () {
      CartMugProductDetailsScreen$lambda_9($showBirthdayPicker$delegate, false);
      CartMugProductDetailsScreen$lambda_11($birthdayPickerTargetOptionKey$delegate, null);
      CartMugProductDetailsScreen$lambda_13($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_56($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C784@44319L189,784@44298L255:CartMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2038544976, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous> (CartMugProductDetailsScreen.kt:784)');
        }
        sourceInformationMarkerStart($composer_0, -536634035, 'CC(remember):CartMugProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CartMugProductDetailsScreen$lambda$lambda_7($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$CartMugProductDetailsScreenKt_getInstance().l117_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_57($birthdayPickerState) {
    return function ($this$DatePickerDialog, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C789@44576L39:CartMugProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(430326341, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartMugProductDetailsScreen.<anonymous>.<anonymous>.<anonymous> (CartMugProductDetailsScreen.kt:789)');
        }
        DatePicker($birthdayPickerState, null, null, null, null, null, false, null, $composer_0, 0, 254);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartMugProductDetailsScreen$lambda_58($cartItem, $onBack, $onNavigateToAuth, $topPadding, $bottomPadding, $$changed, $$default) {
    return function ($composer, $force) {
      CartMugProductDetailsScreen($cartItem, $onBack, $onNavigateToAuth, $topPadding._v.m5f_1, $bottomPadding._v.m5f_1, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_cart_details_CartMugProductDetailsViewModel$stable;
  function CartMugProductDetailsViewModel$observeLanguage$slambda$slambda$lambda($language) {
    return function ($this$updateState) {
      return $this$updateState.v116(VOID, VOID, VOID, VOID, $language);
    };
  }
  function CartMugProductDetailsViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation) {
    this.b11c_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMugProductDetailsViewModel$observeLanguage$slambda$slambda).pyo = function (language, $completion) {
    var tmp = this.um9(language, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMugProductDetailsViewModel$observeLanguage$slambda$slambda).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMugProductDetailsViewModel$observeLanguage$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.b11c_1.x10k(CartMugProductDetailsViewModel$observeLanguage$slambda$slambda$lambda(this.c11c_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CartMugProductDetailsViewModel$observeLanguage$slambda$slambda).um9 = function (language, completion) {
    var i = new CartMugProductDetailsViewModel$observeLanguage$slambda$slambda(this.b11c_1, completion);
    i.c11c_1 = language;
    return i;
  };
  function CartMugProductDetailsViewModel$observeLanguage$slambda$slambda_0(this$0, resultContinuation) {
    var i = new CartMugProductDetailsViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (language, $completion) {
      return i.pyo(language, $completion);
    }, 1);
  }
  function observeLanguage_1($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, CartMugProductDetailsViewModel$observeLanguage$slambda_0($this, null));
  }
  function CartMugProductDetailsViewModel$observeLanguage$slambda(this$0, resultContinuation) {
    this.l11c_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartMugProductDetailsViewModel$observeLanguage$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMugProductDetailsViewModel$observeLanguage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartMugProductDetailsViewModel$observeLanguage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.l11c_1.r11c_1.y103();
            var action = CartMugProductDetailsViewModel$observeLanguage$slambda$slambda_0(this.l11c_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartMugProductDetailsViewModel$observeLanguage$slambda).q24 = function ($this$launch, completion) {
    var i = new CartMugProductDetailsViewModel$observeLanguage$slambda(this.l11c_1, completion);
    i.m11c_1 = $this$launch;
    return i;
  };
  function CartMugProductDetailsViewModel$observeLanguage$slambda_0(this$0, resultContinuation) {
    var i = new CartMugProductDetailsViewModel$observeLanguage$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CartMugProductDetailsViewModel$handleIntent$lambda($item) {
    return function ($this$updateState) {
      return $this$updateState.v116($item, null, true, null);
    };
  }
  function CartMugProductDetailsViewModel$handleIntent$lambda_0($bitmap) {
    return function ($this$updateState) {
      return $this$updateState.v116(VOID, $bitmap, false);
    };
  }
  function CartMugProductDetailsViewModel$handleIntent$lambda_1($this$updateState) {
    return $this$updateState.v116(VOID, VOID, false, new ResourceString(get_failed_load_product_design(string_instance), []));
  }
  function $handleIntentCOROUTINE$_3(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c11d_1 = _this__u8e3s4;
    this.d11d_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            if (this.d11d_1 instanceof LoadItem_0) {
              var item = this.d11d_1.f11d_1;
              this.c11d_1.x10k(CartMugProductDetailsViewModel$handleIntent$lambda(item));
              this.o9_1 = 3;
              if (!(item.xyw_1 == null)) {
                var tmp_0 = this;
                tmp_0.e11d_1 = decodeToImageBitmap(ensureNotNull(item.xyw_1));
                this.n9_1 = 2;
                continue $sm;
              } else {
                var tmp_1;
                var this_0 = item.syw_1;
                if (!(this_0 == null || isBlank(this_0))) {
                  tmp_1 = this.c11d_1.t11c_1.fz1().u1();
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  this.n9_1 = 1;
                  suspendResult = this.c11d_1.s11c_1.h106(ensureNotNull(item.syw_1), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_2 = this;
                  tmp_2.e11d_1 = null;
                  this.n9_1 = 2;
                  continue $sm;
                }
              }
            } else {
              noWhenBranchMatchedException();
            }

            break;
          case 1:
            var tmp1_safe_receiver = suspendResult;
            var tmp_3 = this;
            var tmp_4;
            if (tmp1_safe_receiver == null) {
              tmp_4 = null;
            } else {
              tmp_4 = decodeToImageBitmap(tmp1_safe_receiver);
            }

            tmp_3.e11d_1 = tmp_4;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var bitmap = this.e11d_1;
            this.c11d_1.x10k(CartMugProductDetailsViewModel$handleIntent$lambda_0(bitmap));
            this.o9_1 = 6;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_5 = this.q9_1;
            if (tmp_5 instanceof Exception) {
              var e = this.q9_1;
              this.c11d_1.x10k(CartMugProductDetailsViewModel$handleIntent$lambda_1);
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function CartMugProductDetailsViewModel(getLanguageUseCase, downloadDesignImageUseCase, networkObserver) {
    BaseMviViewModel.call(this, new CartMugProductDetailsState());
    this.r11c_1 = getLanguageUseCase;
    this.s11c_1 = downloadDesignImageUseCase;
    this.t11c_1 = networkObserver;
    observeLanguage_1(this);
  }
  protoOf(CartMugProductDetailsViewModel).g11d = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_3(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartMugProductDetailsViewModel).f10l = function (intent, $completion) {
    return this.g11d(isInterface(intent, CartMugProductDetailsIntent) ? intent : THROW_CCE(), $completion);
  };
  var client_fstech_hadaya_presentation_cart_details_CartNormalProductDetailsState$stable;
  var client_fstech_hadaya_presentation_cart_details_CartNormalProductDetailsIntent_LoadItem$stable;
  var client_fstech_hadaya_presentation_cart_details_CartNormalProductDetailsSideEffect_NavigateBack$stable;
  function CartNormalProductDetailsState(cartItem, loading, error, language) {
    cartItem = cartItem === VOID ? null : cartItem;
    loading = loading === VOID ? false : loading;
    error = error === VOID ? null : error;
    language = language === VOID ? 'en' : language;
    this.h11d_1 = cartItem;
    this.i11d_1 = loading;
    this.j11d_1 = error;
    this.k11d_1 = language;
  }
  protoOf(CartNormalProductDetailsState).l11d = function (cartItem, loading, error, language) {
    return new CartNormalProductDetailsState(cartItem, loading, error, language);
  };
  protoOf(CartNormalProductDetailsState).m11d = function (cartItem, loading, error, language, $super) {
    cartItem = cartItem === VOID ? this.h11d_1 : cartItem;
    loading = loading === VOID ? this.i11d_1 : loading;
    error = error === VOID ? this.j11d_1 : error;
    language = language === VOID ? this.k11d_1 : language;
    return $super === VOID ? this.l11d(cartItem, loading, error, language) : $super.l11d.call(this, cartItem, loading, error, language);
  };
  protoOf(CartNormalProductDetailsState).toString = function () {
    return 'CartNormalProductDetailsState(cartItem=' + toString_0(this.h11d_1) + ', loading=' + this.i11d_1 + ', error=' + toString_0(this.j11d_1) + ', language=' + this.k11d_1 + ')';
  };
  protoOf(CartNormalProductDetailsState).hashCode = function () {
    var result = this.h11d_1 == null ? 0 : this.h11d_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.i11d_1) | 0;
    result = imul(result, 31) + (this.j11d_1 == null ? 0 : hashCode(this.j11d_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.k11d_1) | 0;
    return result;
  };
  protoOf(CartNormalProductDetailsState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CartNormalProductDetailsState))
      return false;
    if (!equals(this.h11d_1, other.h11d_1))
      return false;
    if (!(this.i11d_1 === other.i11d_1))
      return false;
    if (!equals(this.j11d_1, other.j11d_1))
      return false;
    if (!(this.k11d_1 === other.k11d_1))
      return false;
    return true;
  };
  function LoadItem_1() {
  }
  function CartNormalProductDetailsIntent() {
  }
  function CartNormalProductDetailsScreen(cartItem, onBack, onNavigateToAuth, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(978087693);
    sourceInformation($composer_0, 'C(CartNormalProductDetailsScreen)85@4192L12,86@4247L12,87@4279L43,89@4363L105,89@4328L140:CartNormalProductDetailsScreen.kt#6ni00');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(cartItem) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToAuth) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(978087693, $dirty, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen (CartNormalProductDetailsScreen.kt:84)');
      }
      // Inline function 'org.koin.compose.koinInject' call
      var qualifier = null;
      var scope = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -1168520582, 'CC(koinInject)88@2750L18,90@2787L73:Inject.kt#8jjlyv');
      if (!((3 & 1) === 0))
        qualifier = null;
      if (!((3 & 2) === 0))
        scope = currentKoinScope($composer_1, 0);
      sourceInformationMarkerStart($composer_1, -1961811197, 'CC(remember):Inject.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_1.k31(qualifier) | $composer_1.k31(scope));
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = scope.ts6(getKClass(GetProductByIdUseCase), qualifier);
        $composer_1.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp1_group = tmp;
      sourceInformationMarkerEnd($composer_1);
      sourceInformationMarkerEnd($composer_1);
      var getProductByIdUseCase = tmp1_group;
      // Inline function 'org.koin.compose.koinInject' call
      var qualifier_0 = null;
      var scope_0 = null;
      var $composer_2 = $composer_0;
      sourceInformationMarkerStart($composer_2, -1168520582, 'CC(koinInject)88@2750L18,90@2787L73:Inject.kt#8jjlyv');
      if (!((3 & 1) === 0))
        qualifier_0 = null;
      if (!((3 & 2) === 0))
        scope_0 = currentKoinScope($composer_2, 0);
      sourceInformationMarkerStart($composer_2, -1961811197, 'CC(remember):Inject.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_2.k31(qualifier_0) | $composer_2.k31(scope_0));
      // Inline function 'kotlin.let' call
      var it_0 = $composer_2.i31();
      var tmp_0;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = scope_0.ts6(getKClass(ICartRepository), qualifier_0);
        $composer_2.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group_0 = tmp_0;
      sourceInformationMarkerEnd($composer_2);
      sourceInformationMarkerEnd($composer_2);
      var cartRepository = tmp1_group_0;
      sourceInformationMarkerStart($composer_0, -655556392, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_0.i31();
      var tmp_1;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = mutableStateOf(null);
        this_0.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var product$delegate = tmp0_group;
      var tmp_2 = cartItem.gyw_1;
      sourceInformationMarkerStart($composer_0, -655553642, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!($composer_0.q31(cartItem) | $composer_0.q31(getProductByIdUseCase));
      // Inline function 'kotlin.let' call
      var it_2 = tmp0.i31();
      var tmp_3;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = CartNormalProductDetailsScreen$slambda_0(cartItem, getProductByIdUseCase, product$delegate, null);
        tmp0.j31(value_2);
        tmp_3 = value_2;
      } else {
        tmp_3 = it_2;
      }
      var tmp1_group_1 = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_2, tmp1_group_1, $composer_0, 0);
      var tmp0_safe_receiver = CartNormalProductDetailsScreen$lambda(product$delegate);
      var tmp_4;
      if (tmp0_safe_receiver == null) {
        $composer_0.m30(1154459427);
        $composer_0.n30();
        tmp_4 = null;
      } else {
        $composer_0.m30(1154459428);
        sourceInformation($composer_0, '*96@4543L15,97@4606L16,98@4655L32,99@4722L21,108@5124L812,108@5106L830,127@5972L513,127@5946L539,144@6738L22,144@6719L41,145@6786L34,147@6856L34,148@6936L42,149@7015L34,150@7083L34,151@7149L34,152@7217L33,153@7285L25,155@7383L162,155@7320L225,163@7594L41,163@7555L80,179@8060L50290');
        // Inline function 'kotlin.let' call
        // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
        var qualifier_1 = null;
        var viewModelStoreOwner = null;
        var key = null;
        var extras = null;
        var scope_1 = null;
        var parameters = null;
        var $composer_3 = $composer_0;
        sourceInformationMarkerStart($composer_3, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
        if (!((63 & 1) === 0))
          qualifier_1 = null;
        if (!((63 & 2) === 0)) {
          var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_3, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
          var tmp_5;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.error' call
            var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
            throw IllegalStateException_init_$Create$(toString(message));
          } else {
            tmp_5 = tmp0_elvis_lhs;
          }
          viewModelStoreOwner = tmp_5;
        }
        if (!((63 & 4) === 0))
          key = null;
        if (!((63 & 8) === 0))
          extras = defaultExtras(viewModelStoreOwner);
        if (!((63 & 16) === 0))
          scope_1 = currentKoinScope($composer_3, 0);
        if (!((63 & 32) === 0))
          parameters = null;
        var tmp0_0 = resolveViewModel(getKClass(ProductDetailsViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier_1, scope_1, parameters);
        sourceInformationMarkerEnd($composer_3);
        var viewModel = tmp0_0;
        var tmp_6 = viewModel.s10h().ajg();
        var state$delegate = collectAsState(tmp_6, null, $composer_0, 0, 1);
        sourceInformationMarkerStart($composer_0, 552237678, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_1 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_3 = this_1.i31();
        var tmp_7;
        if (false || it_3 === Companion_getInstance().f30_1) {
          var value_3 = new SnackbarHostState();
          this_1.j31(value_3);
          tmp_7 = value_3;
        } else {
          tmp_7 = it_3;
        }
        var tmp0_group_0 = tmp_7;
        sourceInformationMarkerEnd($composer_0);
        var snackbarHostState = tmp0_group_0;
        var verticalScrollState = rememberScrollState(0, $composer_0, 0, 1);
        var language = CartNormalProductDetailsScreen$lambda_1(state$delegate).s11d_1;
        var tmp_8;
        if (language === 'en') {
          var tmp0_elvis_lhs_0 = tmp0_safe_receiver.ozt_1;
          tmp_8 = tmp0_elvis_lhs_0 == null ? tmp0_safe_receiver.pzt_1 : tmp0_elvis_lhs_0;
        } else {
          var tmp1_elvis_lhs = tmp0_safe_receiver.pzt_1;
          tmp_8 = tmp1_elvis_lhs == null ? tmp0_safe_receiver.ozt_1 : tmp1_elvis_lhs;
        }
        var tmp2_elvis_lhs = tmp_8;
        var name = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
        var tmp_9;
        if (language === 'en') {
          var tmp3_elvis_lhs = tmp0_safe_receiver.qzt_1;
          tmp_9 = tmp3_elvis_lhs == null ? tmp0_safe_receiver.rzt_1 : tmp3_elvis_lhs;
        } else {
          var tmp4_elvis_lhs = tmp0_safe_receiver.rzt_1;
          tmp_9 = tmp4_elvis_lhs == null ? tmp0_safe_receiver.qzt_1 : tmp4_elvis_lhs;
        }
        var tmp5_elvis_lhs = tmp_9;
        var description = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
        sourceInformationMarkerStart($composer_0, 552253466, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        var tmp0_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = !!(!!($composer_0.q31(viewModel) | $composer_0.q31(tmp0_safe_receiver)) | $composer_0.q31(cartItem));
        // Inline function 'kotlin.let' call
        var it_4 = tmp0_1.i31();
        var tmp_10;
        if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
          var value_4 = CartNormalProductDetailsScreen$slambda_2(viewModel, tmp0_safe_receiver, cartItem, null);
          tmp0_1.j31(value_4);
          tmp_10 = value_4;
        } else {
          tmp_10 = it_4;
        }
        var tmp1_group_2 = tmp_10;
        sourceInformationMarkerEnd($composer_0);
        LaunchedEffect_0(tmp0_safe_receiver, tmp1_group_2, $composer_0, 0);
        sourceInformationMarkerStart($composer_0, 552280303, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        var tmp0_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = !!($composer_0.q31(viewModel) | ($dirty & 896) === 256);
        // Inline function 'kotlin.let' call
        var it_5 = tmp0_2.i31();
        var tmp_11;
        if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
          var value_5 = CartNormalProductDetailsScreen$slambda_4(viewModel, snackbarHostState, onNavigateToAuth, null);
          tmp0_2.j31(value_5);
          tmp_11 = value_5;
        } else {
          tmp_11 = it_5;
        }
        var tmp2_group = tmp_11;
        sourceInformationMarkerEnd($composer_0);
        LaunchedEffect_0(viewModel, tmp2_group, $composer_0, 0);
        var tmp6_safe_receiver = tmp0_safe_receiver.xzt_1;
        var tmp_12;
        if (tmp6_safe_receiver == null) {
          tmp_12 = null;
        } else {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList_init_$Create$_0();
          var _iterator__ex2g4s = tmp6_safe_receiver.t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(element)) {
              destination.j1(element);
            }
          }
          tmp_12 = destination;
        }
        var tmp7_elvis_lhs = tmp_12;
        var images = tmp7_elvis_lhs == null ? emptyList() : tmp7_elvis_lhs;
        var tmp8_safe_receiver = tmp0_safe_receiver.yzt_1;
        var tmp_13;
        if (tmp8_safe_receiver == null) {
          tmp_13 = null;
        } else {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList_init_$Create$_0();
          var _iterator__ex2g4s_0 = tmp8_safe_receiver.t();
          while (_iterator__ex2g4s_0.u()) {
            var element_0 = _iterator__ex2g4s_0.v();
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(element_0)) {
              destination_0.j1(element_0);
            }
          }
          tmp_13 = destination_0;
        }
        var tmp9_elvis_lhs = tmp_13;
        var videos = tmp9_elvis_lhs == null ? emptyList() : tmp9_elvis_lhs;
        var combinedMedia = distinct(plus(images, videos));
        sourceInformationMarkerStart($composer_0, 552304324, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        var tmp0_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = $composer_0.q31(combinedMedia);
        // Inline function 'kotlin.let' call
        var it_6 = tmp0_3.i31();
        var tmp_14;
        if (invalid_4 || it_6 === Companion_getInstance().f30_1) {
          var value_6 = CartNormalProductDetailsScreen$lambda_18(combinedMedia);
          tmp0_3.j31(value_6);
          tmp_14 = value_6;
        } else {
          tmp_14 = it_6;
        }
        var tmp3_group = tmp_14;
        sourceInformationMarkerEnd($composer_0);
        var pagerState = rememberPagerState(0, 0.0, tmp3_group, $composer_0, 0, 3);
        sourceInformationMarkerStart($composer_0, 552305872, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_2 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_7 = this_2.i31();
        var tmp_15;
        if (false || it_7 === Companion_getInstance().f30_1) {
          var value_7 = mutableStateOf(false);
          this_2.j31(value_7);
          tmp_15 = value_7;
        } else {
          tmp_15 = it_7;
        }
        var tmp4_group = tmp_15;
        sourceInformationMarkerEnd($composer_0);
        var isZooming$delegate = tmp4_group;
        sourceInformationMarkerStart($composer_0, 552308112, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_3 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_8 = this_3.i31();
        var tmp_16;
        if (false || it_8 === Companion_getInstance().f30_1) {
          var value_8 = mutableStateOf(false);
          this_3.j31(value_8);
          tmp_16 = value_8;
        } else {
          tmp_16 = it_8;
        }
        var tmp5_group = tmp_16;
        sourceInformationMarkerEnd($composer_0);
        var showBirthdayPicker$delegate = tmp5_group;
        sourceInformationMarkerStart($composer_0, 552310680, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_4 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_9 = this_4.i31();
        var tmp_17;
        if (false || it_9 === Companion_getInstance().f30_1) {
          var value_9 = mutableStateOf(null);
          this_4.j31(value_9);
          tmp_17 = value_9;
        } else {
          tmp_17 = it_9;
        }
        var tmp6_group = tmp_17;
        sourceInformationMarkerEnd($composer_0);
        var birthdayPickerTargetOptionKey$delegate = tmp6_group;
        sourceInformationMarkerStart($composer_0, 552313200, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_5 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_10 = this_5.i31();
        var tmp_18;
        if (false || it_10 === Companion_getInstance().f30_1) {
          var value_10 = mutableStateOf(false);
          this_5.j31(value_10);
          tmp_18 = value_10;
        } else {
          tmp_18 = it_10;
        }
        var tmp7_group = tmp_18;
        sourceInformationMarkerEnd($composer_0);
        var isPickingBoxBirthday$delegate = tmp7_group;
        sourceInformationMarkerStart($composer_0, 552315376, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_6 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_11 = this_6.i31();
        var tmp_19;
        if (false || it_11 === Companion_getInstance().f30_1) {
          var value_11 = mutableStateOf(false);
          this_6.j31(value_11);
          tmp_19 = value_11;
        } else {
          tmp_19 = it_11;
        }
        var tmp8_group = tmp_19;
        sourceInformationMarkerEnd($composer_0);
        var showDiscardDialog$delegate = tmp8_group;
        sourceInformationMarkerStart($composer_0, 552317488, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_7 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_12 = this_7.i31();
        var tmp_20;
        if (false || it_12 === Companion_getInstance().f30_1) {
          var value_12 = mutableStateOf(false);
          this_7.j31(value_12);
          tmp_20 = value_12;
        } else {
          tmp_20 = it_12;
        }
        var tmp9_group = tmp_20;
        sourceInformationMarkerEnd($composer_0);
        var showMediaDialog$delegate = tmp9_group;
        sourceInformationMarkerStart($composer_0, 552319663, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_8 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_13 = this_8.i31();
        var tmp_21;
        if (false || it_13 === Companion_getInstance().f30_1) {
          var value_13 = mutableIntStateOf(0);
          this_8.j31(value_13);
          tmp_21 = value_13;
        } else {
          tmp_21 = it_13;
        }
        var tmp10_group = tmp_21;
        sourceInformationMarkerEnd($composer_0);
        var initialMediaIndex$delegate = tmp10_group;
        var tmp_22 = _DisplayMode___init__impl__gfd230(0);
        var birthdayPickerState = rememberDatePickerState(null, null, null, tmp_22, null, $composer_0, 0, 31);
        var tmp_23 = CartNormalProductDetailsScreen$lambda_1(state$delegate).p11d_1 || CartNormalProductDetailsScreen$lambda_12(showMediaDialog$delegate);
        sourceInformationMarkerStart($composer_0, 552325104, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_9 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_14 = this_9.i31();
        var tmp_24;
        if (false || it_14 === Companion_getInstance().f30_1) {
          var value_14 = CartNormalProductDetailsScreen$lambda_19(showMediaDialog$delegate, showDiscardDialog$delegate);
          this_9.j31(value_14);
          tmp_24 = value_14;
        } else {
          tmp_24 = it_14;
        }
        var tmp11_group = tmp_24;
        sourceInformationMarkerEnd($composer_0);
        BackHandler(tmp_23, tmp11_group, $composer_0, 48, 0);
        var tmp_25 = pagerState.zj9();
        sourceInformationMarkerStart($composer_0, 552331735, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_10 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_15 = this_10.i31();
        var tmp_26;
        if (false || it_15 === Companion_getInstance().f30_1) {
          var value_15 = CartNormalProductDetailsScreen$slambda_6(isZooming$delegate, null);
          this_10.j31(value_15);
          tmp_26 = value_15;
        } else {
          tmp_26 = it_15;
        }
        var tmp12_group = tmp_26;
        sourceInformationMarkerEnd($composer_0);
        LaunchedEffect_0(tmp_25, tmp12_group, $composer_0, 0);
        if (CartNormalProductDetailsScreen$lambda_10(showDiscardDialog$delegate)) {
          $composer_0.m30(-57501418);
          sourceInformation($composer_0, '169@7725L46,170@7799L44,171@7873L94,175@7997L29,168@7682L358');
          var tmp_27 = stringResource(get_discard_order_title(string_instance), $composer_0, 0);
          var tmp_28 = stringResource(get_discard_order_msg(string_instance), $composer_0, 0);
          sourceInformationMarkerStart($composer_0, 552340716, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
          var tmp0_4 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_5 = ($dirty & 112) === 32;
          // Inline function 'kotlin.let' call
          var it_16 = tmp0_4.i31();
          var tmp_29;
          if (invalid_5 || it_16 === Companion_getInstance().f30_1) {
            var value_16 = CartNormalProductDetailsScreen$lambda_20(showDiscardDialog$delegate, onBack);
            tmp0_4.j31(value_16);
            tmp_29 = value_16;
          } else {
            tmp_29 = it_16;
          }
          var tmp13_group = tmp_29;
          sourceInformationMarkerEnd($composer_0);
          sourceInformationMarkerStart($composer_0, 552344619, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var this_11 = $composer_0;
          // Inline function 'kotlin.let' call
          var it_17 = this_11.i31();
          var tmp_30;
          if (false || it_17 === Companion_getInstance().f30_1) {
            var value_17 = CartNormalProductDetailsScreen$lambda_21(showDiscardDialog$delegate);
            this_11.j31(value_17);
            tmp_30 = value_17;
          } else {
            tmp_30 = it_17;
          }
          var tmp14_group = tmp_30;
          sourceInformationMarkerEnd($composer_0);
          HadayaAlertDialog(tmp_27, tmp_28, null, null, tmp13_group, tmp14_group, $composer_0, 196608, 12);
          $composer_0.n30();
        } else {
          $composer_0.m30(-57134316);
          $composer_0.n30();
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = fillMaxSize(Companion_instance);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_4 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_5 = $composer_4;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_5, 0).hashCode();
        var localMap = $composer_5.t31();
        var materialized = materialize($composer_5, modifier_0);
        var tmp0_5 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_6 = $composer_5;
        var tmp_31 = $composer_6.g30();
        if (!isInterface(tmp_31, Applier)) {
          invalidApplier();
        }
        $composer_6.b31();
        if ($composer_6.h30()) {
          $composer_6.c31(tmp0_5);
        } else {
          $composer_6.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_6);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_7 = $composer_6;
        var $composer_8 = $composer_7;
        sourceInformationMarkerStart($composer_8, 729484444, 'C180@8113L47187,971@55314L140:CartNormalProductDetailsScreen.kt#6ni00');
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_1 = fillMaxSize(Companion_instance);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_9 = $composer_8;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_9, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_10 = $composer_9;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_10, 0).hashCode();
        var localMap_0 = $composer_10.t31();
        var materialized_0 = materialize($composer_10, modifier_2);
        var tmp0_6 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_11 = $composer_10;
        var tmp_32 = $composer_11.g30();
        if (!isInterface(tmp_32, Applier)) {
          invalidApplier();
        }
        $composer_11.b31();
        if ($composer_11.h30()) {
          $composer_11.c31(tmp0_6);
        } else {
          $composer_11.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_11);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_12 = $composer_11;
        var $composer_13 = $composer_12;
        sourceInformationMarkerStart($composer_13, -361749808, 'C181@8173L37543,818@45841L11,821@46006L9280,816@45734L9552:CartNormalProductDetailsScreen.kt#6ni00');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = ColumnScopeInstance_instance.yds(Companion_instance, 1.0);
        var contentAlignment_0 = null;
        var propagateMinConstraints_0 = false;
        var $composer_14 = $composer_13;
        if (!((6 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_15 = $composer_14;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_15, 0).hashCode();
        var localMap_1 = $composer_15.t31();
        var materialized_1 = materialize($composer_15, modifier_4);
        var tmp0_7 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_16 = $composer_15;
        var tmp_33 = $composer_16.g30();
        if (!isInterface(tmp_33, Applier)) {
          invalidApplier();
        }
        $composer_16.b31();
        if ($composer_16.h30()) {
          $composer_16.c31(tmp0_7);
        } else {
          $composer_16.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_16);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_17 = $composer_16;
        var $composer_18 = $composer_17;
        sourceInformationMarkerStart($composer_18, 1070469363, 'C188@8519L34,189@8600L31,183@8290L364,192@8676L37022:CartNormalProductDetailsScreen.kt#6ni00');
        var tmp0_modifier = alpha(BoxScopeInstance_instance.udr(fillMaxWidth(Companion_instance, 0.8), Companion_getInstance_11().o8t_1), 0.03);
        var tmp1_painter = painterResource(get_logo(drawable_instance), $composer_18, 0);
        var tmp2_contentDescription = stringResource(get_logo_0(string_instance), $composer_18, 0);
        Image(tmp1_painter, tmp2_contentDescription, tmp0_modifier, null, null, 0.0, null, $composer_18, androidx_compose_ui_graphics_painter_Painter$stableprop_getter(), 120);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_5 = verticalScroll(fillMaxSize(Companion_instance), verticalScrollState, !CartNormalProductDetailsScreen$lambda_1(state$delegate).p11d_1 && !CartNormalProductDetailsScreen$lambda_2(isZooming$delegate));
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = null;
        var $composer_19 = $composer_18;
        if (!((6 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_2 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_19, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_20 = $composer_19;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_20, 0).hashCode();
        var localMap_2 = $composer_20.t31();
        var materialized_2 = materialize($composer_20, modifier_6);
        var tmp0_8 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_21 = $composer_20;
        var tmp_34 = $composer_21.g30();
        if (!isInterface(tmp_34, Applier)) {
          invalidApplier();
        }
        $composer_21.b31();
        if ($composer_21.h30()) {
          $composer_21.c31(tmp0_8);
        } else {
          $composer_21.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_21);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_22 = $composer_21;
        var $composer_23 = $composer_22;
        sourceInformationMarkerStart($composer_23, -1310963168, 'C206@9376L11,201@9071L8243,408@21170L24506:CartNormalProductDetailsScreen.kt#6ni00');
        var tmp_35 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$114 = _Dp___init__impl__ms3zkb(400);
        var tmp_36 = height(tmp_35, tmp$ret$114);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp0_bottomStart = _Dp___init__impl__ms3zkb(32);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_bottomEnd = _Dp___init__impl__ms3zkb(32);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_7 = background(clip(tmp_36, RoundedCornerShape_0(VOID, VOID, tmp1_bottomEnd, tmp0_bottomStart)), Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_23, 6).oo0_1, 0.3));
        var contentAlignment_1 = null;
        var propagateMinConstraints_1 = false;
        var $composer_24 = $composer_23;
        if (!((6 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment_1 = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints_1 = false;
        var measurePolicy_3 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_25 = $composer_24;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_25, 0).hashCode();
        var localMap_3 = $composer_25.t31();
        var materialized_3 = materialize($composer_25, modifier_8);
        var tmp0_9 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_26 = $composer_25;
        var tmp_37 = $composer_26.g30();
        if (!isInterface(tmp_37, Applier)) {
          invalidApplier();
        }
        $composer_26.b31();
        if ($composer_26.h30()) {
          $composer_26.c31(tmp0_9);
        } else {
          $composer_26.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_26);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_27 = $composer_26;
        var $composer_28 = $composer_27;
        sourceInformationMarkerStart($composer_28, 1454635798, 'C212@9708L735,208@9479L964,228@10520L3361,296@14478L11,288@14020L173,287@13969L1935:CartNormalProductDetailsScreen.kt#6ni00');
        var tmp_38 = fillMaxSize(Companion_instance);
        var tmp_39 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_40 = !CartNormalProductDetailsScreen$lambda_2(isZooming$delegate);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1034780211, true, CartNormalProductDetailsScreen$lambda_22(combinedMedia, name, pagerState, isZooming$delegate), $composer_28, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_29 = $composer_28;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_6 = $composer_29.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_18 = $composer_29.i31();
        var tmp_41;
        if (invalid_6 || it_18 === Companion_getInstance().f30_1) {
          var value_18 = ComposableLambda$invoke$ref_7(dispatchReceiver);
          $composer_29.j31(value_18);
          tmp_41 = value_18;
        } else {
          tmp_41 = it_18;
        }
        var tmp$ret$123 = tmp_41;
        HorizontalPager(pagerState, tmp_38, null, null, 0, tmp_39, null, null, tmp_40, false, null, null, null, null, tmp$ret$123, $composer_28, 48, 24576, 16124);
        var tmp0_$receiver = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_top = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_start = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_end = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_9 = padding_1(tmp0_$receiver, tmp2_start, tmp1_top, tmp3_end);
        var horizontalArrangement = Arrangement_getInstance().wdp_1;
        var verticalAlignment = null;
        var $composer_30 = $composer_28;
        if (!((4 & 1) === 0))
          modifier_9 = Companion_instance;
        if (!((4 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((4 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_4 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_30, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_10 = modifier_9;
        var $composer_31 = $composer_30;
        if (!((0 & 2) === 0))
          modifier_10 = Companion_instance;
        var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_31, 0).hashCode();
        var localMap_4 = $composer_31.t31();
        var materialized_4 = materialize($composer_31, modifier_10);
        var tmp0_10 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_32 = $composer_31;
        var tmp_42 = $composer_32.g30();
        if (!isInterface(tmp_42, Applier)) {
          invalidApplier();
        }
        $composer_32.b31();
        if ($composer_32.h30()) {
          $composer_32.c31(tmp0_10);
        } else {
          $composer_32.d31();
        }
        var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_32);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
        var $composer_33 = $composer_32;
        var $composer_34 = $composer_33;
        sourceInformationMarkerStart($composer_34, -1205931995, 'C235@10919L320,234@10861L912,252@11807L2044:CartNormalProductDetailsScreen.kt#6ni00');
        sourceInformationMarkerStart($composer_34, -1978564496, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_7 = !!($composer_0.k31(state$delegate) | ($dirty & 112) === 32);
        // Inline function 'kotlin.let' call
        var it_19 = $composer_34.i31();
        var tmp_43;
        if (invalid_7 || it_19 === Companion_getInstance().f30_1) {
          var value_19 = CartNormalProductDetailsScreen$lambda_23(state$delegate, showDiscardDialog$delegate, onBack);
          $composer_34.j31(value_19);
          tmp_43 = value_19;
        } else {
          tmp_43 = it_19;
        }
        var tmp0_group_1 = tmp_43;
        sourceInformationMarkerEnd($composer_34);
        var tmp_44 = background(Companion_instance, Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.7), get_CircleShape());
        IconButton(tmp0_group_1, tmp_44, false, null, null, null, ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().k11e_1, $composer_34, 1572864, 60);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_11 = null;
        var horizontalArrangement_0 = null;
        var verticalAlignment_0 = null;
        var $composer_35 = $composer_34;
        if (!((7 & 1) === 0))
          modifier_11 = Companion_instance;
        if (!((7 & 2) === 0))
          horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
        if (!((7 & 4) === 0))
          verticalAlignment_0 = Companion_getInstance_11().t8t_1;
        var measurePolicy_5 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_35, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_12 = modifier_11;
        var $composer_36 = $composer_35;
        if (!((0 & 2) === 0))
          modifier_12 = Companion_instance;
        var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_36, 0).hashCode();
        var localMap_5 = $composer_36.t31();
        var materialized_5 = materialize($composer_36, modifier_12);
        var tmp0_11 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_37 = $composer_36;
        var tmp_45 = $composer_37.g30();
        if (!isInterface(tmp_45, Applier)) {
          invalidApplier();
        }
        $composer_37.b31();
        if ($composer_37.h30()) {
          $composer_37.c31(tmp0_11);
        } else {
          $composer_37.d31();
        }
        var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_37);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
        var $composer_38 = $composer_37;
        var $composer_39 = $composer_38;
        sourceInformationMarkerStart($composer_39, -186572801, 'C254@11911L67,257@12179L819,253@11849L1149,270@13036L39,273@13175L65,272@13113L704:CartNormalProductDetailsScreen.kt#6ni00');
        sourceInformationMarkerStart($composer_39, 1656549591, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_8 = $composer_39.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_20 = $composer_39.i31();
        var tmp_46;
        if (invalid_8 || it_20 === Companion_getInstance().f30_1) {
          var value_20 = CartNormalProductDetailsScreen$lambda_24(viewModel);
          $composer_39.j31(value_20);
          tmp_46 = value_20;
        } else {
          tmp_46 = it_20;
        }
        var tmp0_group_2 = tmp_46;
        sourceInformationMarkerEnd($composer_39);
        var tmp_47 = background(Companion_instance, Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.7), get_CircleShape());
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-1781743566, true, CartNormalProductDetailsScreen$lambda_25(state$delegate), $composer_39, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_40 = $composer_39;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_9 = $composer_40.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_21 = $composer_40.i31();
        var tmp_48;
        if (invalid_9 || it_21 === Companion_getInstance().f30_1) {
          var value_21 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_40.j31(value_21);
          tmp_48 = value_21;
        } else {
          tmp_48 = it_21;
        }
        var tmp$ret$153 = tmp_48;
        IconButton(tmp0_group_2, tmp_47, false, null, null, null, tmp$ret$153, $composer_39, 1572864, 60);
        var tmp_49 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$160 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_49, tmp$ret$160), $composer_39, 6);
        sourceInformationMarkerStart($composer_39, 1656590037, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_10 = $composer_39.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_22 = $composer_39.i31();
        var tmp_50;
        if (invalid_10 || it_22 === Companion_getInstance().f30_1) {
          var value_22 = CartNormalProductDetailsScreen$lambda_26(viewModel);
          $composer_39.j31(value_22);
          tmp_50 = value_22;
        } else {
          tmp_50 = it_22;
        }
        var tmp1_group_3 = tmp_50;
        sourceInformationMarkerEnd($composer_39);
        var tmp_51 = background(Companion_instance, Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.7), get_CircleShape());
        IconButton(tmp1_group_3, tmp_51, false, null, null, null, ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().m11e_1, $composer_39, 1572864, 60);
        sourceInformationMarkerEnd($composer_39);
        $composer_37.e31();
        sourceInformationMarkerEnd($composer_34);
        $composer_32.e31();
        var tmp_52 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$165 = _Dp___init__impl__ms3zkb(16);
        var tmp4_modifier = zIndex(padding_1(tmp_52, VOID, VOID, VOID, tmp$ret$165), 1.0);
        var tmp5_color = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_28, 6).eo0_1, 0.8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$166 = _Dp___init__impl__ms3zkb(24);
        var tmp6_shape = RoundedCornerShape(tmp$ret$166);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp7_shadowElevation = _Dp___init__impl__ms3zkb(6);
        sourceInformationMarkerStart($composer_28, 1848176729, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_11 = $composer_28.k31(pagerState);
        // Inline function 'kotlin.let' call
        var it_23 = $composer_28.i31();
        var tmp_53;
        if (invalid_11 || it_23 === Companion_getInstance().f30_1) {
          var value_23 = CartNormalProductDetailsScreen$lambda_27(initialMediaIndex$delegate, pagerState, showMediaDialog$delegate);
          $composer_28.j31(value_23);
          tmp_53 = value_23;
        } else {
          tmp_53 = it_23;
        }
        var tmp0_group_3 = tmp_53;
        sourceInformationMarkerEnd($composer_28);
        var tmp_54 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_55 = _Dp___init__impl__ms3zkb(0.0);
        Surface_0(tmp0_group_3, tmp4_modifier, false, tmp6_shape, tmp5_color, tmp_54, tmp_55, tmp7_shadowElevation, null, null, ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().n11e_1, $composer_28, 12582912, 6, 868);
        if (combinedMedia.n1() > 1) {
          $composer_28.m30(1460910166);
          sourceInformation($composer_28, '322@16042L1216');
          var tmp_56 = BoxScopeInstance_instance.udr(fillMaxWidth(Companion_instance), Companion_getInstance_11().r8t_1);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$172 = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_13 = padding_1(tmp_56, VOID, VOID, VOID, tmp$ret$172);
          var horizontalArrangement_1 = Arrangement_getInstance().udp_1;
          var verticalAlignment_1 = null;
          var $composer_41 = $composer_28;
          if (!((4 & 1) === 0))
            modifier_13 = Companion_instance;
          if (!((4 & 2) === 0))
            horizontalArrangement_1 = Arrangement_getInstance().qdp_1;
          if (!((4 & 4) === 0))
            verticalAlignment_1 = Companion_getInstance_11().t8t_1;
          var measurePolicy_6 = rowMeasurePolicy(horizontalArrangement_1, verticalAlignment_1, $composer_41, 14 & 48 >> 3 | 112 & 48 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_14 = modifier_13;
          var $composer_42 = $composer_41;
          if (!((0 & 2) === 0))
            modifier_14 = Companion_instance;
          var compositeKeyHash_6 = get_currentCompositeKeyHashCode($composer_42, 0).hashCode();
          var localMap_6 = $composer_42.t31();
          var materialized_6 = materialize($composer_42, modifier_14);
          var tmp0_12 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_43 = $composer_42;
          var tmp_57 = $composer_43.g30();
          if (!isInterface(tmp_57, Applier)) {
            invalidApplier();
          }
          $composer_43.b31();
          if ($composer_43.h30()) {
            $composer_43.c31(tmp0_12);
          } else {
            $composer_43.d31();
          }
          var $this$ReusableComposeNode_6 = _Updater___init__impl__rbfxm8($composer_43);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, measurePolicy_6, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, localMap_6, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, compositeKeyHash_6, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_6, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, materialized_6, Companion_getInstance_12().qah_1);
          var $composer_44 = $composer_43;
          var $composer_45 = $composer_44;
          sourceInformationMarkerStart($composer_45, 640809284, 'C:CartNormalProductDetailsScreen.kt#6ni00');
          $composer_45.m30(-117876065);
          sourceInformation($composer_45, '*334@16819L367');
          // Inline function 'kotlin.repeat' call
          var times = combinedMedia.n1();
          var inductionVariable = 0;
          if (inductionVariable < times)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp_58;
              if (pagerState.zj9() === index) {
                $composer_45.m30(495384258);
                sourceInformation($composer_45, '331@16629L11');
                var tmp0_group_4 = MaterialTheme_instance.unz($composer_45, 6).xnz_1;
                $composer_45.n30();
                tmp_58 = tmp0_group_4;
              } else {
                $composer_45.m30(495385163);
                $composer_45.n30();
                tmp_58 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.6);
              }
              var color = tmp_58;
              var tmp_59 = Companion_instance;
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$181 = _Dp___init__impl__ms3zkb(4);
              var tmp_60 = background(clip(padding_0(tmp_59, tmp$ret$181), get_CircleShape()), color);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$182 = _Dp___init__impl__ms3zkb(8);
              Box(size(tmp_60, tmp$ret$182), $composer_45, 0);
            }
             while (inductionVariable < times);
          $composer_45.n30();
          sourceInformationMarkerEnd($composer_45);
          $composer_43.e31();
          $composer_28.n30();
        } else {
          $composer_28.m30(1462140246);
          $composer_28.n30();
        }
        sourceInformationMarkerEnd($composer_28);
        $composer_26.e31();
        if (combinedMedia.n1() > 1) {
          $composer_23.m30(-1303690135);
          sourceInformation($composer_23, '354@17802L3173,348@17436L3539');
          var tmp_61 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$183 = _Dp___init__impl__ms3zkb(16);
          var tmp2_modifier = padding_2(tmp_61, VOID, tmp$ret$183);
          var tmp3_horizontalArrangement = Arrangement_getInstance().udp_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$184 = _Dp___init__impl__ms3zkb(16);
          var tmp4_contentPadding = PaddingValues_0(tmp$ret$184);
          sourceInformationMarkerStart($composer_23, 1620524811, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_12 = !!($composer_23.q31(combinedMedia) | $composer_23.k31(pagerState));
          // Inline function 'kotlin.let' call
          var it_24 = $composer_23.i31();
          var tmp_62;
          if (invalid_12 || it_24 === Companion_getInstance().f30_1) {
            var value_24 = CartNormalProductDetailsScreen$lambda_28(combinedMedia, pagerState, initialMediaIndex$delegate, showMediaDialog$delegate);
            $composer_23.j31(value_24);
            tmp_62 = value_24;
          } else {
            tmp_62 = it_24;
          }
          var tmp0_group_5 = tmp_62;
          sourceInformationMarkerEnd($composer_23);
          LazyRow(tmp2_modifier, null, tmp4_contentPadding, false, tmp3_horizontalArrangement, null, null, false, null, tmp0_group_5, $composer_23, 24966, 490);
          $composer_23.n30();
        } else {
          $composer_23.m30(-1300254405);
          sourceInformation($composer_23, '404@21037L41');
          var tmp_63 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$189 = _Dp___init__impl__ms3zkb(24);
          Spacer(height(tmp_63, tmp$ret$189), $composer_23, 6);
          $composer_23.n30();
        }
        var tmp_64 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$190 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_15 = padding_2(tmp_64, tmp$ret$190);
        var verticalArrangement_1 = null;
        var horizontalAlignment_1 = null;
        var $composer_46 = $composer_23;
        if (!((6 & 1) === 0))
          modifier_15 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_1 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_1 = Companion_getInstance_11().w8t_1;
        var measurePolicy_7 = columnMeasurePolicy(verticalArrangement_1, horizontalAlignment_1, $composer_46, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_16 = modifier_15;
        var $composer_47 = $composer_46;
        if (!((0 & 2) === 0))
          modifier_16 = Companion_instance;
        var compositeKeyHash_7 = get_currentCompositeKeyHashCode($composer_47, 0).hashCode();
        var localMap_7 = $composer_47.t31();
        var materialized_7 = materialize($composer_47, modifier_16);
        var tmp0_13 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_48 = $composer_47;
        var tmp_65 = $composer_48.g30();
        if (!isInterface(tmp_65, Applier)) {
          invalidApplier();
        }
        $composer_48.b31();
        if ($composer_48.h30()) {
          $composer_48.c31(tmp0_13);
        } else {
          $composer_48.d31();
        }
        var $this$ReusableComposeNode_7 = _Updater___init__impl__rbfxm8($composer_48);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, measurePolicy_7, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, localMap_7, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, compositeKeyHash_7, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_7, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, materialized_7, Companion_getInstance_12().qah_1);
        var $composer_49 = $composer_48;
        var $composer_50 = $composer_49;
        sourceInformationMarkerStart($composer_50, 15166717, 'C409@21256L710,423@21996L41,426@22106L5496,509@27632L40,514@27922L10,515@27998L11,511@27702L463,520@28195L41,741@41794L41,744@41993L428,757@42757L427,742@41864L1350,766@43243L41,768@43314L198,774@43542L41,809@45537L41,811@45608L42:CartNormalProductDetailsScreen.kt#6ni00');
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_17 = fillMaxWidth(Companion_instance);
        var horizontalArrangement_2 = Arrangement_getInstance().wdp_1;
        var verticalAlignment_2 = Companion_getInstance_11().t8t_1;
        var $composer_51 = $composer_50;
        if (!((0 & 1) === 0))
          modifier_17 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement_2 = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment_2 = Companion_getInstance_11().t8t_1;
        var measurePolicy_8 = rowMeasurePolicy(horizontalArrangement_2, verticalAlignment_2, $composer_51, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_18 = modifier_17;
        var $composer_52 = $composer_51;
        if (!((0 & 2) === 0))
          modifier_18 = Companion_instance;
        var compositeKeyHash_8 = get_currentCompositeKeyHashCode($composer_52, 0).hashCode();
        var localMap_8 = $composer_52.t31();
        var materialized_8 = materialize($composer_52, modifier_18);
        var tmp0_14 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_53 = $composer_52;
        var tmp_66 = $composer_53.g30();
        if (!isInterface(tmp_66, Applier)) {
          invalidApplier();
        }
        $composer_53.b31();
        if ($composer_53.h30()) {
          $composer_53.c31(tmp0_14);
        } else {
          $composer_53.d31();
        }
        var $this$ReusableComposeNode_8 = _Updater___init__impl__rbfxm8($composer_53);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_8, measurePolicy_8, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_8, localMap_8, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_8, compositeKeyHash_8, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_8, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_8, materialized_8, Companion_getInstance_12().qah_1);
        var $composer_54 = $composer_53;
        var $composer_55 = $composer_54;
        sourceInformationMarkerStart($composer_55, 505547384, 'C416@21654L10,418@21810L11,414@21541L395:CartNormalProductDetailsScreen.kt#6ni00');
        var tmp0_style = MaterialTheme_instance.jog($composer_55, 6).jof_1;
        var tmp1_fontWeight = Companion_getInstance_16().f7z_1;
        var tmp2_color = MaterialTheme_instance.unz($composer_55, 6).lo0_1;
        var tmp3_modifier = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        var tmp_67 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_68 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_69 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_70 = _TextOverflow___init__impl__obguoe(0);
        Text(name, tmp3_modifier, tmp2_color, null, tmp_67, null, tmp1_fontWeight, null, tmp_68, null, null, tmp_69, tmp_70, false, 0, 0, null, tmp0_style, $composer_55, 1572864, 0, 131000);
        sourceInformationMarkerEnd($composer_55);
        $composer_53.e31();
        var tmp_71 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$203 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_71, tmp$ret$203), $composer_50, 6);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_19 = null;
        var verticalArrangement_2 = null;
        var horizontalAlignment_2 = null;
        var $composer_56 = $composer_50;
        if (!((7 & 1) === 0))
          modifier_19 = Companion_instance;
        if (!((7 & 2) === 0))
          verticalArrangement_2 = Arrangement_getInstance().sdp_1;
        if (!((7 & 4) === 0))
          horizontalAlignment_2 = Companion_getInstance_11().w8t_1;
        var measurePolicy_9 = columnMeasurePolicy(verticalArrangement_2, horizontalAlignment_2, $composer_56, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_20 = modifier_19;
        var $composer_57 = $composer_56;
        if (!((0 & 2) === 0))
          modifier_20 = Companion_instance;
        var compositeKeyHash_9 = get_currentCompositeKeyHashCode($composer_57, 0).hashCode();
        var localMap_9 = $composer_57.t31();
        var materialized_9 = materialize($composer_57, modifier_20);
        var tmp0_15 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_58 = $composer_57;
        var tmp_72 = $composer_58.g30();
        if (!isInterface(tmp_72, Applier)) {
          invalidApplier();
        }
        $composer_58.b31();
        if ($composer_58.h30()) {
          $composer_58.c31(tmp0_15);
        } else {
          $composer_58.d31();
        }
        var $this$ReusableComposeNode_9 = _Updater___init__impl__rbfxm8($composer_58);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_9, measurePolicy_9, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_9, localMap_9, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_9, compositeKeyHash_9, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_9, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_9, materialized_9, Companion_getInstance_12().qah_1);
        var $composer_59 = $composer_58;
        var $composer_60 = $composer_59;
        sourceInformationMarkerStart($composer_60, -2055643456, 'C436@23049L3612:CartNormalProductDetailsScreen.kt#6ni00');
        var tmp0_safe_receiver_0 = CartNormalProductDetailsScreen$lambda_1(state$delegate).v11d_1;
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.lyz_1;
        var tmp_73 = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
        var tmp2_safe_receiver = CartNormalProductDetailsScreen$lambda_1(state$delegate).z11d_1;
        var tmp3_elvis_lhs_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.wyz_1;
        var tmp_74 = tmp_73 + (tmp3_elvis_lhs_0 == null ? 0.0 : tmp3_elvis_lhs_0);
        // Inline function 'kotlin.collections.sumOf' call
        var sum = 0;
        var _iterator__ex2g4s_1 = CartNormalProductDetailsScreen$lambda_1(state$delegate).f11e_1.y2().t();
        while (_iterator__ex2g4s_1.u()) {
          var element_1 = _iterator__ex2g4s_1.v();
          var tmp_75 = sum;
          var tmp0_elvis_lhs_1 = element_1.q100_1;
          sum = tmp_75 + (tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1);
        }
        var extraOriginalPrice = tmp_74 + sum;
        var tmp4_safe_receiver = CartNormalProductDetailsScreen$lambda_1(state$delegate).v11d_1;
        var tmp5_elvis_lhs_0 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.lyz_1;
        var tmp_76 = tmp5_elvis_lhs_0 == null ? 0.0 : tmp5_elvis_lhs_0;
        var tmp6_safe_receiver_0 = CartNormalProductDetailsScreen$lambda_1(state$delegate).z11d_1;
        var tmp7_elvis_lhs_0 = tmp6_safe_receiver_0 == null ? null : tmp6_safe_receiver_0.wyz_1;
        var tmp_77 = tmp_76 + (tmp7_elvis_lhs_0 == null ? 0.0 : tmp7_elvis_lhs_0);
        // Inline function 'kotlin.collections.sumOf' call
        var sum_0 = 0;
        var _iterator__ex2g4s_2 = CartNormalProductDetailsScreen$lambda_1(state$delegate).f11e_1.y2().t();
        while (_iterator__ex2g4s_2.u()) {
          var element_2 = _iterator__ex2g4s_2.v();
          var tmp_78 = sum_0;
          var tmp_79;
          var tmp0_elvis_lhs_2 = element_2.r100_1;
          if ((tmp0_elvis_lhs_2 == null ? 0.0 : tmp0_elvis_lhs_2) > 0.0) {
            tmp_79 = ensureNotNull(element_2.r100_1);
          } else {
            var tmp1_elvis_lhs_1 = element_2.q100_1;
            tmp_79 = tmp1_elvis_lhs_1 == null ? 0.0 : tmp1_elvis_lhs_1;
          }
          sum_0 = tmp_78 + tmp_79;
        }
        var extraDiscountedPrice = tmp_77 + sum_0;
        var tmp8_elvis_lhs = tmp0_safe_receiver.szt_1;
        var finalOriginalPrice = (tmp8_elvis_lhs == null ? 0.0 : tmp8_elvis_lhs) + extraOriginalPrice;
        var tmp_80;
        var tmp9_elvis_lhs_0 = tmp0_safe_receiver.tzt_1;
        if ((tmp9_elvis_lhs_0 == null ? 0.0 : tmp9_elvis_lhs_0) > 0.0) {
          tmp_80 = ensureNotNull(tmp0_safe_receiver.tzt_1);
        } else {
          var tmp10_elvis_lhs = tmp0_safe_receiver.szt_1;
          tmp_80 = tmp10_elvis_lhs == null ? 0.0 : tmp10_elvis_lhs;
        }
        var finalDiscountedPrice = tmp_80 + extraDiscountedPrice;
        var tmp_81;
        var tmp11_elvis_lhs = tmp0_safe_receiver.tzt_1;
        if ((tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs) > 0.0) {
          tmp_81 = true;
        } else {
          var tmp0_16 = CartNormalProductDetailsScreen$lambda_1(state$delegate).f11e_1.y2();
          var tmp$ret$214;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp_82;
            if (isInterface(tmp0_16, Collection)) {
              tmp_82 = tmp0_16.r();
            } else {
              tmp_82 = false;
            }
            if (tmp_82) {
              tmp$ret$214 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s_3 = tmp0_16.t();
            while (_iterator__ex2g4s_3.u()) {
              var element_3 = _iterator__ex2g4s_3.v();
              var tmp0_elvis_lhs_3 = element_3.r100_1;
              if ((tmp0_elvis_lhs_3 == null ? 0.0 : tmp0_elvis_lhs_3) > 0.0) {
                tmp$ret$214 = true;
                break $l$block_0;
              }
            }
            tmp$ret$214 = false;
          }
          tmp_81 = tmp$ret$214;
        }
        var hasDiscount = tmp_81;
        var tmp12_elvis_lhs = tmp0_safe_receiver.uzt_1;
        var hasDiscountPercent = (tmp12_elvis_lhs == null ? 0.0 : tmp12_elvis_lhs) > 0.0;
        var tmp13_verticalAlignment = Companion_getInstance_11().v8t_1;
        var tmp_83 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$216 = _Dp___init__impl__ms3zkb(12);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_21 = null;
        var horizontalArrangement_3 = tmp_83.mdq(tmp$ret$216);
        var verticalAlignment_3 = tmp13_verticalAlignment;
        var $composer_61 = $composer_60;
        if (!((1 & 1) === 0))
          modifier_21 = Companion_instance;
        if (!((1 & 2) === 0))
          horizontalArrangement_3 = Arrangement_getInstance().qdp_1;
        if (!((1 & 4) === 0))
          verticalAlignment_3 = Companion_getInstance_11().t8t_1;
        var measurePolicy_10 = rowMeasurePolicy(horizontalArrangement_3, verticalAlignment_3, $composer_61, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_22 = modifier_21;
        var $composer_62 = $composer_61;
        if (!((0 & 2) === 0))
          modifier_22 = Companion_instance;
        var compositeKeyHash_10 = get_currentCompositeKeyHashCode($composer_62, 0).hashCode();
        var localMap_10 = $composer_62.t31();
        var materialized_10 = materialize($composer_62, modifier_22);
        var tmp0_17 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_63 = $composer_62;
        var tmp_84 = $composer_63.g30();
        if (!isInterface(tmp_84, Applier)) {
          invalidApplier();
        }
        $composer_63.b31();
        if ($composer_63.h30()) {
          $composer_63.c31(tmp0_17);
        } else {
          $composer_63.d31();
        }
        var $this$ReusableComposeNode_10 = _Updater___init__impl__rbfxm8($composer_63);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_10, measurePolicy_10, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_10, localMap_10, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_10, compositeKeyHash_10, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_10, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_10, materialized_10, Companion_getInstance_12().qah_1);
        var $composer_64 = $composer_63;
        var $composer_65 = $composer_64;
        sourceInformationMarkerStart($composer_65, -1652177982, 'C:CartNormalProductDetailsScreen.kt#6ni00');
        if (hasDiscount) {
          $composer_65.m30(-1652222282);
          sourceInformation($composer_65, '442@23404L221,447@23779L11,441@23347L568,451@24013L219,456@24386L11,450@23956L677');
          var tmp0_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalDiscountedPrice)], $composer_65, 0), language);
          var tmp1_fontSize = get_sp(28);
          var tmp2_color_0 = MaterialTheme_instance.unz($composer_65, 6).xnz_1;
          var tmp3_fontWeight = Companion_getInstance_16().g7z_1;
          var tmp_85 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_86 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_87 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, null, tmp2_color_0, null, tmp1_fontSize, null, tmp3_fontWeight, null, tmp_85, null, null, tmp_86, tmp_87, false, 0, 0, null, null, $composer_65, 1597440, 0, 262058);
          var tmp4_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_65, 0), language);
          var tmp5_fontSize = get_sp(18);
          var tmp6_color = MaterialTheme_instance.unz($composer_65, 6).po0_1;
          var tmp7_textDecoration = Companion_getInstance_18().c80_1;
          var tmp_88 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$223 = _Dp___init__impl__ms3zkb(4);
          var tmp8_modifier = padding_1(tmp_88, VOID, VOID, VOID, tmp$ret$223);
          var tmp_89 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_90 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_91 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp4_text, tmp8_modifier, tmp6_color, null, tmp5_fontSize, null, null, null, tmp_89, tmp7_textDecoration, null, tmp_90, tmp_91, false, 0, 0, null, null, $composer_65, 805330992, 0, 261608);
          $composer_65.n30();
        } else {
          $composer_65.m30(-1650844394);
          sourceInformation($composer_65, '462@24776L219,467@25149L11,461@24719L566');
          var tmp9_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_65, 0), language);
          var tmp10_fontSize = get_sp(28);
          var tmp11_color = MaterialTheme_instance.unz($composer_65, 6).xnz_1;
          var tmp12_fontWeight = Companion_getInstance_16().g7z_1;
          var tmp_92 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_93 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_94 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp9_text, null, tmp11_color, null, tmp10_fontSize, null, tmp12_fontWeight, null, tmp_92, null, null, tmp_93, tmp_94, false, 0, 0, null, null, $composer_65, 1597440, 0, 262058);
          $composer_65.n30();
        }
        if (hasDiscountPercent) {
          $composer_65.m30(-1650123582);
          sourceInformation($composer_65, '474@25502L11,477@25728L861,473@25427L1162');
          var tmp13_color = MaterialTheme_instance.unz($composer_65, 6).to0_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$224 = _Dp___init__impl__ms3zkb(8);
          var tmp14_shape = RoundedCornerShape(tmp$ret$224);
          var tmp_95 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$225 = _Dp___init__impl__ms3zkb(6);
          var tmp15_modifier = padding_1(tmp_95, VOID, VOID, VOID, tmp$ret$225);
          var tmp_96 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_97 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_98 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_1 = rememberComposableLambda(85147779, true, CartNormalProductDetailsScreen$lambda_29(tmp0_safe_receiver, language), $composer_65, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_66 = $composer_65;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_13 = $composer_66.k31(dispatchReceiver_1);
          // Inline function 'kotlin.let' call
          var it_25 = $composer_66.i31();
          var tmp_99;
          if (invalid_13 || it_25 === Companion_getInstance().f30_1) {
            var value_25 = ComposableLambda$invoke$ref(dispatchReceiver_1);
            $composer_66.j31(value_25);
            tmp_99 = value_25;
          } else {
            tmp_99 = it_25;
          }
          var tmp$ret$226 = tmp_99;
          Surface(tmp15_modifier, tmp14_shape, tmp13_color, tmp_96, tmp_97, tmp_98, null, tmp$ret$226, $composer_65, 12582918, 120);
          $composer_65.n30();
        } else {
          $composer_65.m30(-1648969204);
          $composer_65.n30();
        }
        sourceInformationMarkerEnd($composer_65);
        $composer_63.e31();
        if (CartNormalProductDetailsScreen$lambda_1(state$delegate).o11d_1 > 1) {
          $composer_60.m30(-2051249765);
          sourceInformation($composer_60, '497@26901L44,497@26955L199,501@27242L10,502@27328L11,496@26848L690');
          var totalPrice = finalDiscountedPrice * CartNormalProductDetailsScreen$lambda_1(state$delegate).o11d_1;
          var tmp15_text = stringResource(get_total_price_label(string_instance), $composer_60, 0) + ': ' + formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(totalPrice)], $composer_60, 0), language);
          var tmp16_style = MaterialTheme_instance.jog($composer_60, 6).mof_1;
          var tmp17_color = MaterialTheme_instance.unz($composer_60, 6).co0_1;
          var tmp18_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp_100 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$233 = _Dp___init__impl__ms3zkb(4);
          var tmp19_modifier = padding_1(tmp_100, VOID, tmp$ret$233);
          var tmp_101 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_102 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_103 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_104 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp15_text, tmp19_modifier, tmp17_color, null, tmp_101, null, tmp18_fontWeight, null, tmp_102, null, null, tmp_103, tmp_104, false, 0, 0, null, tmp16_style, $composer_60, 1572912, 0, 131000);
          $composer_60.n30();
        } else {
          $composer_60.m30(-2050430032);
          $composer_60.n30();
        }
        sourceInformationMarkerEnd($composer_60);
        $composer_58.e31();
        var tmp_105 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$234 = _Dp___init__impl__ms3zkb(8);
        Spacer(height(tmp_105, tmp$ret$234), $composer_50, 6);
        // Inline function 'kotlin.takeIf' call
        var tmp_106;
        // Inline function 'kotlin.text.isNotBlank' call
        if (!isBlank(description)) {
          tmp_106 = description;
        } else {
          tmp_106 = null;
        }
        var tmp0_elvis_lhs_4 = tmp_106;
        var tmp_107;
        if (tmp0_elvis_lhs_4 == null) {
          $composer_50.m30(1247601093);
          sourceInformation($composer_50, '513@27825L41');
          var tmp0_group_6 = stringResource(get_no_description(string_instance), $composer_50, 0);
          $composer_50.n30();
          tmp_107 = tmp0_group_6;
        } else {
          $composer_50.m30(1247598675);
          $composer_50.n30();
          tmp_107 = tmp0_elvis_lhs_4;
        }
        var tmp1_text = tmp_107;
        var tmp2_style = MaterialTheme_instance.jog($composer_50, 6).oof_1;
        var tmp3_color = MaterialTheme_instance.unz($composer_50, 6).no0_1;
        var tmp4_lineHeight = get_sp(24);
        var tmp5_fontWeight = Companion_getInstance_16().c7z_1;
        var tmp_108 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_109 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_110 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp1_text, null, tmp3_color, null, tmp_108, null, tmp5_fontWeight, null, tmp_109, null, null, tmp4_lineHeight, tmp_110, false, 0, 0, null, tmp2_style, $composer_50, 1572864, 48, 128954);
        var tmp_111 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$238 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_111, tmp$ret$238), $composer_50, 6);
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!CartNormalProductDetailsScreen$lambda_1(state$delegate).i11e_1.r()) {
          $composer_50.m30(21633719);
          sourceInformation($composer_50, '525@28492L38,528@28737L112,524@28426L566,593@32976L41');
          var tmp_112 = stringResource(get_select_card(string_instance), $composer_50, 0);
          var tmp_113 = CartNormalProductDetailsScreen$lambda_1(state$delegate).i11e_1;
          var tmp6_safe_receiver_1 = CartNormalProductDetailsScreen$lambda_1(state$delegate).v11d_1;
          var tmp_114 = tmp6_safe_receiver_1 == null ? null : tmp6_safe_receiver_1.gyz_1;
          sourceInformationMarkerStart($composer_50, 1247630348, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_14 = $composer_50.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_26 = $composer_50.i31();
          var tmp_115;
          if (invalid_14 || it_26 === Companion_getInstance().f30_1) {
            var value_26 = CartNormalProductDetailsScreen$lambda_30(viewModel);
            $composer_50.j31(value_26);
            tmp_115 = value_26;
          } else {
            tmp_115 = it_26;
          }
          var tmp1_group_4 = tmp_115;
          sourceInformationMarkerEnd($composer_50);
          GiftSelectionSection(tmp_112, tmp_113, tmp_114, tmp1_group_4, language, true, $composer_50, 196608, 0);
          var tmp10_safe_receiver = CartNormalProductDetailsScreen$lambda_1(state$delegate).v11d_1;
          if ((tmp10_safe_receiver == null ? null : tmp10_safe_receiver.oyz_1) === true) {
            $composer_50.m30(22217139);
            sourceInformation($composer_50, '534@29107L41,537@29327L488,551@30329L479,535@29185L1661');
            var tmp_116 = Companion_instance;
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$244 = _Dp___init__impl__ms3zkb(12);
            Spacer(height(tmp_116, tmp$ret$244), $composer_50, 6);
            var tmp7_value = CartNormalProductDetailsScreen$lambda_1(state$delegate).w11d_1;
            var tmp_117 = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$245 = _Dp___init__impl__ms3zkb(24);
            var tmp8_modifier_0 = padding_2(tmp_117, tmp$ret$245);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$246 = _Dp___init__impl__ms3zkb(12);
            var tmp9_shape = RoundedCornerShape(tmp$ret$246);
            sourceInformationMarkerStart($composer_50, 1247649604, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_15 = $composer_50.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_27 = $composer_50.i31();
            var tmp_118;
            if (invalid_15 || it_27 === Companion_getInstance().f30_1) {
              var value_27 = CartNormalProductDetailsScreen$lambda_31(viewModel);
              $composer_50.j31(value_27);
              tmp_118 = value_27;
            } else {
              tmp_118 = it_27;
            }
            var tmp2_group_0 = tmp_118;
            sourceInformationMarkerEnd($composer_50);
            var tmp_119 = ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().o11e_1;
            var tmp_120 = ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().p11e_1;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_2 = rememberComposableLambda(389339801, true, CartNormalProductDetailsScreen$lambda_32(state$delegate), $composer_50, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_67 = $composer_50;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_16 = $composer_67.k31(dispatchReceiver_2);
            // Inline function 'kotlin.let' call
            var it_28 = $composer_67.i31();
            var tmp_121;
            if (invalid_16 || it_28 === Companion_getInstance().f30_1) {
              var value_28 = ComposableLambda$invoke$ref(dispatchReceiver_2);
              $composer_67.j31(value_28);
              tmp_121 = value_28;
            } else {
              tmp_121 = it_28;
            }
            var tmp_122 = tmp_121;
            OutlinedTextField(tmp7_value, tmp2_group_0, tmp8_modifier_0, false, false, null, tmp_119, tmp_120, null, null, null, null, tmp_122, false, null, null, null, false, 1, 0, null, tmp9_shape, null, $composer_50, 14156160, 100663680, 0, 6025016);
            $composer_50.n30();
          } else {
            $composer_50.m30(23957510);
            $composer_50.n30();
          }
          var tmp16_safe_receiver = CartNormalProductDetailsScreen$lambda_1(state$delegate).v11d_1;
          if ((tmp16_safe_receiver == null ? null : tmp16_safe_receiver.pyz_1) === true) {
            $composer_50.m30(24096421);
            sourceInformation($composer_50, '563@30996L41,570@31543L200,566@31217L3,579@32194L621,564@31074L1835');
            var tmp_123 = Companion_instance;
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$258 = _Dp___init__impl__ms3zkb(12);
            Spacer(height(tmp_123, tmp$ret$258), $composer_50, 6);
            var tmp11_value = CartNormalProductDetailsScreen$lambda_1(state$delegate).x11d_1;
            var tmp_124 = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$259 = _Dp___init__impl__ms3zkb(24);
            var tmp_125 = padding_2(tmp_124, tmp$ret$259);
            sourceInformationMarkerStart($composer_50, 1247720228, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_29 = $composer_50.i31();
            var tmp_126;
            if (false || it_29 === Companion_getInstance().f30_1) {
              var value_29 = CartNormalProductDetailsScreen$lambda_33(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
              $composer_50.j31(value_29);
              tmp_126 = value_29;
            } else {
              tmp_126 = it_29;
            }
            var tmp3_group_0 = tmp_126;
            sourceInformationMarkerEnd($composer_50);
            var tmp12_modifier = clickable(tmp_125, VOID, VOID, VOID, VOID, tmp3_group_0);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$264 = _Dp___init__impl__ms3zkb(12);
            var tmp13_shape = RoundedCornerShape(tmp$ret$264);
            var tmp14_isError = CartNormalProductDetailsScreen$lambda_1(state$delegate).y11d_1;
            var tmp_127;
            if (CartNormalProductDetailsScreen$lambda_1(state$delegate).y11d_1) {
              tmp_127 = ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().q11e_1;
            } else {
              tmp_127 = null;
            }
            var tmp15_supportingText = tmp_127;
            sourceInformationMarkerStart($composer_50, 1247709599, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_30 = $composer_50.i31();
            var tmp_128;
            if (false || it_30 === Companion_getInstance().f30_1) {
              var value_30 = CartNormalProductDetailsScreen$lambda_34;
              $composer_50.j31(value_30);
              tmp_128 = value_30;
            } else {
              tmp_128 = it_30;
            }
            var tmp4_group_0 = tmp_128;
            sourceInformationMarkerEnd($composer_50);
            var tmp_129 = ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().r11e_1;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_3 = rememberComposableLambda(-1770274016, true, CartNormalProductDetailsScreen$lambda_35(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_50, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_68 = $composer_50;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_17 = $composer_68.k31(dispatchReceiver_3);
            // Inline function 'kotlin.let' call
            var it_31 = $composer_68.i31();
            var tmp_130;
            if (invalid_17 || it_31 === Companion_getInstance().f30_1) {
              var value_31 = ComposableLambda$invoke$ref(dispatchReceiver_3);
              $composer_68.j31(value_31);
              tmp_130 = value_31;
            } else {
              tmp_130 = it_31;
            }
            var tmp_131 = tmp_130;
            OutlinedTextField(tmp11_value, tmp4_group_0, tmp12_modifier, true, true, null, tmp_129, null, null, tmp_131, null, null, tmp15_supportingText, tmp14_isError, null, null, null, false, 0, 0, null, tmp13_shape, null, $composer_50, 806906928, 0, 0, 6278560);
            $composer_50.n30();
          } else {
            $composer_50.m30(26004006);
            $composer_50.n30();
          }
          var tmp_132 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$276 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_132, tmp$ret$276), $composer_50, 6);
          $composer_50.n30();
        } else {
          $composer_50.m30(26107174);
          $composer_50.n30();
        }
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!CartNormalProductDetailsScreen$lambda_1(state$delegate).j11e_1.r()) {
          $composer_50.m30(26325135);
          sourceInformation($composer_50, '598@33216L37,601@33459L366,597@33150L818');
          var tmp_133 = stringResource(get_select_box(string_instance), $composer_50, 0);
          var tmp_134 = CartNormalProductDetailsScreen$lambda_1(state$delegate).j11e_1;
          var tmp17_safe_receiver = CartNormalProductDetailsScreen$lambda_1(state$delegate).z11d_1;
          var tmp_135 = tmp17_safe_receiver == null ? null : tmp17_safe_receiver.ryz_1;
          sourceInformationMarkerStart($composer_50, 1247781706, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_18 = $composer_50.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_32 = $composer_50.i31();
          var tmp_136;
          if (invalid_18 || it_32 === Companion_getInstance().f30_1) {
            var value_32 = CartNormalProductDetailsScreen$lambda_36(viewModel);
            $composer_50.j31(value_32);
            tmp_136 = value_32;
          } else {
            tmp_136 = it_32;
          }
          var tmp5_group_0 = tmp_136;
          sourceInformationMarkerEnd($composer_50);
          GiftSelectionSection(tmp_133, tmp_134, tmp_135, tmp5_group_0, language, true, $composer_50, 196608, 0);
          var tmp21_safe_receiver = CartNormalProductDetailsScreen$lambda_1(state$delegate).z11d_1;
          if ((tmp21_safe_receiver == null ? null : tmp21_safe_receiver.zyz_1) === true) {
            $composer_50.m30(27152246);
            sourceInformation($composer_50, '613@34082L41,616@34301L487,630@35302L478,614@34160L1658');
            var tmp_137 = Companion_instance;
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$282 = _Dp___init__impl__ms3zkb(12);
            Spacer(height(tmp_137, tmp$ret$282), $composer_50, 6);
            var tmp18_value = CartNormalProductDetailsScreen$lambda_1(state$delegate).a11e_1;
            var tmp_138 = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$283 = _Dp___init__impl__ms3zkb(24);
            var tmp19_modifier_0 = padding_2(tmp_138, tmp$ret$283);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$284 = _Dp___init__impl__ms3zkb(12);
            var tmp20_shape = RoundedCornerShape(tmp$ret$284);
            sourceInformationMarkerStart($composer_50, 1247808771, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_19 = $composer_50.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_33 = $composer_50.i31();
            var tmp_139;
            if (invalid_19 || it_33 === Companion_getInstance().f30_1) {
              var value_33 = CartNormalProductDetailsScreen$lambda_37(viewModel);
              $composer_50.j31(value_33);
              tmp_139 = value_33;
            } else {
              tmp_139 = it_33;
            }
            var tmp6_group_0 = tmp_139;
            sourceInformationMarkerEnd($composer_50);
            var tmp_140 = ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().t11e_1;
            var tmp_141 = ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().u11e_1;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_4 = rememberComposableLambda(-569036080, true, CartNormalProductDetailsScreen$lambda_38(state$delegate), $composer_50, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_69 = $composer_50;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_20 = $composer_69.k31(dispatchReceiver_4);
            // Inline function 'kotlin.let' call
            var it_34 = $composer_69.i31();
            var tmp_142;
            if (invalid_20 || it_34 === Companion_getInstance().f30_1) {
              var value_34 = ComposableLambda$invoke$ref(dispatchReceiver_4);
              $composer_69.j31(value_34);
              tmp_142 = value_34;
            } else {
              tmp_142 = it_34;
            }
            var tmp_143 = tmp_142;
            OutlinedTextField(tmp18_value, tmp6_group_0, tmp19_modifier_0, false, false, null, tmp_140, tmp_141, null, null, null, null, tmp_143, false, null, null, null, false, 1, 0, null, tmp20_shape, null, $composer_50, 14156160, 100663680, 0, 6025016);
            $composer_50.n30();
          } else {
            $composer_50.m30(28889734);
            $composer_50.n30();
          }
          var tmp27_safe_receiver = CartNormalProductDetailsScreen$lambda_1(state$delegate).z11d_1;
          if ((tmp27_safe_receiver == null ? null : tmp27_safe_receiver.az0_1) === true) {
            $composer_50.m30(29027498);
            sourceInformation($composer_50, '642@35967L41,649@36513L199,645@36187L3,658@37161L620,643@36045L1830');
            var tmp_144 = Companion_instance;
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$296 = _Dp___init__impl__ms3zkb(12);
            Spacer(height(tmp_144, tmp$ret$296), $composer_50, 6);
            var tmp22_value = CartNormalProductDetailsScreen$lambda_1(state$delegate).b11e_1;
            var tmp_145 = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$297 = _Dp___init__impl__ms3zkb(24);
            var tmp_146 = padding_2(tmp_145, tmp$ret$297);
            sourceInformationMarkerStart($composer_50, 1247879267, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_35 = $composer_50.i31();
            var tmp_147;
            if (false || it_35 === Companion_getInstance().f30_1) {
              var value_35 = CartNormalProductDetailsScreen$lambda_39(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
              $composer_50.j31(value_35);
              tmp_147 = value_35;
            } else {
              tmp_147 = it_35;
            }
            var tmp7_group_0 = tmp_147;
            sourceInformationMarkerEnd($composer_50);
            var tmp23_modifier = clickable(tmp_146, VOID, VOID, VOID, VOID, tmp7_group_0);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$302 = _Dp___init__impl__ms3zkb(12);
            var tmp24_shape = RoundedCornerShape(tmp$ret$302);
            var tmp25_isError = CartNormalProductDetailsScreen$lambda_1(state$delegate).c11e_1;
            var tmp_148;
            if (CartNormalProductDetailsScreen$lambda_1(state$delegate).c11e_1) {
              tmp_148 = ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().v11e_1;
            } else {
              tmp_148 = null;
            }
            var tmp26_supportingText = tmp_148;
            sourceInformationMarkerStart($composer_50, 1247868639, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_36 = $composer_50.i31();
            var tmp_149;
            if (false || it_36 === Companion_getInstance().f30_1) {
              var value_36 = CartNormalProductDetailsScreen$lambda_40;
              $composer_50.j31(value_36);
              tmp_149 = value_36;
            } else {
              tmp_149 = it_36;
            }
            var tmp8_group_0 = tmp_149;
            sourceInformationMarkerEnd($composer_50);
            var tmp_150 = ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().w11e_1;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_5 = rememberComposableLambda(-1488710249, true, CartNormalProductDetailsScreen$lambda_41(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_50, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_70 = $composer_50;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_21 = $composer_70.k31(dispatchReceiver_5);
            // Inline function 'kotlin.let' call
            var it_37 = $composer_70.i31();
            var tmp_151;
            if (invalid_21 || it_37 === Companion_getInstance().f30_1) {
              var value_37 = ComposableLambda$invoke$ref(dispatchReceiver_5);
              $composer_70.j31(value_37);
              tmp_151 = value_37;
            } else {
              tmp_151 = it_37;
            }
            var tmp_152 = tmp_151;
            OutlinedTextField(tmp22_value, tmp8_group_0, tmp23_modifier, true, true, null, tmp_150, null, null, tmp_152, null, null, tmp26_supportingText, tmp25_isError, null, null, null, false, 0, 0, null, tmp24_shape, null, $composer_50, 806906928, 0, 0, 6278560);
            $composer_50.n30();
          } else {
            $composer_50.m30(30930278);
            $composer_50.n30();
          }
          $composer_50.n30();
        } else {
          $composer_50.m30(30960038);
          $composer_50.n30();
        }
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_12 = tmp0_safe_receiver.lzu_1;
        if (!(this_12 == null || this_12.r())) {
          $composer_50.m30(31045071);
          sourceInformation($composer_50, '676@38101L38,679@38324L325,675@38033L759');
          var tmp_153 = stringResource(get_select_size(string_instance), $composer_50, 0);
          var tmp_154 = CartNormalProductDetailsScreen$lambda_1(state$delegate).d11e_1;
          sourceInformationMarkerStart($composer_50, 1247937345, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_22 = $composer_50.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_38 = $composer_50.i31();
          var tmp_155;
          if (invalid_22 || it_38 === Companion_getInstance().f30_1) {
            var value_38 = CartNormalProductDetailsScreen$lambda_42(viewModel);
            $composer_50.j31(value_38);
            tmp_155 = value_38;
          } else {
            tmp_155 = it_38;
          }
          var tmp9_group_0 = tmp_155;
          sourceInformationMarkerEnd($composer_50);
          OptionSelectionSection(tmp_153, tmp0_safe_receiver.lzu_1, tmp_154, tmp9_group_0, language, true, $composer_50, 196608, 0);
          $composer_50.n30();
        } else {
          $composer_50.m30(31835974);
          $composer_50.n30();
        }
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_13 = tmp0_safe_receiver.mzu_1;
        if (!(this_13 == null || this_13.r())) {
          $composer_50.m30(31922123);
          sourceInformation($composer_50, '693@38985L39,696@39211L326,692@38917L763');
          var tmp_156 = stringResource(get_select_color(string_instance), $composer_50, 0);
          var tmp_157 = CartNormalProductDetailsScreen$lambda_1(state$delegate).e11e_1;
          sourceInformationMarkerStart($composer_50, 1247965730, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_23 = $composer_50.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_39 = $composer_50.i31();
          var tmp_158;
          if (invalid_23 || it_39 === Companion_getInstance().f30_1) {
            var value_39 = CartNormalProductDetailsScreen$lambda_43(viewModel);
            $composer_50.j31(value_39);
            tmp_158 = value_39;
          } else {
            tmp_158 = it_39;
          }
          var tmp10_group_0 = tmp_158;
          sourceInformationMarkerEnd($composer_50);
          OptionSelectionSection(tmp_156, tmp0_safe_receiver.mzu_1, tmp_157, tmp10_group_0, language, true, $composer_50, 196608, 0);
          $composer_50.n30();
        } else {
          $composer_50.m30(32716870);
          $composer_50.n30();
        }
        var tmp28_safe_receiver = tmp0_safe_receiver.nzu_1;
        if (tmp28_safe_receiver == null) {
          $composer_50.m30(32829554);
          $composer_50.n30();
        } else {
          $composer_50.m30(32829555);
          sourceInformation($composer_50, '*712@40033L257,709@39813L620');
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_4 = tmp28_safe_receiver.t();
          while (_iterator__ex2g4s_4.u()) {
            var element_4 = _iterator__ex2g4s_4.v();
            var tmp_159 = CartNormalProductDetailsScreen$lambda_1(state$delegate).f11e_1.w2(element_4.r101_1);
            sourceInformationMarkerStart($composer_50, 1424386411, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_24 = !!($composer_50.q31(viewModel) | $composer_50.q31(element_4));
            // Inline function 'kotlin.let' call
            var it_40 = $composer_50.i31();
            var tmp_160;
            if (invalid_24 || it_40 === Companion_getInstance().f30_1) {
              var value_40 = CartNormalProductDetailsScreen$lambda_44(viewModel, element_4);
              $composer_50.j31(value_40);
              tmp_160 = value_40;
            } else {
              tmp_160 = it_40;
            }
            var tmp0_group_7 = tmp_160;
            sourceInformationMarkerEnd($composer_50);
            OptionSelectionSection_0(element_4, tmp_159, tmp0_group_7, language, true, $composer_50, 24576, 0);
            var tmp0_safe_receiver_1 = CartNormalProductDetailsScreen$lambda_1(state$delegate).f11e_1.w2(element_4.r101_1);
            if (tmp0_safe_receiver_1 == null) {
              $composer_50.m30(1206800294);
              $composer_50.n30();
            } else {
              $composer_50.m30(1206800295);
              sourceInformation($composer_50, '');
              // Inline function 'kotlin.let' call
              if (tmp0_safe_receiver_1.w100_1 || tmp0_safe_receiver_1.z100_1 || tmp0_safe_receiver_1.c101_1) {
                $composer_50.m30(-410950622);
                sourceInformation($composer_50, '726@40984L295,731@41348L212,722@40687L975');
                sourceInformationMarkerStart($composer_50, -290341048, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
                // Inline function 'androidx.compose.runtime.cache' call
                var invalid_25 = !!($composer_50.q31(viewModel) | $composer_50.q31(element_4));
                // Inline function 'kotlin.let' call
                var it_41 = $composer_50.i31();
                var tmp_161;
                if (invalid_25 || it_41 === Companion_getInstance().f30_1) {
                  var value_41 = CartNormalProductDetailsScreen$lambda_45(viewModel, element_4);
                  $composer_50.j31(value_41);
                  tmp_161 = value_41;
                } else {
                  tmp_161 = it_41;
                }
                var tmp0_group_8 = tmp_161;
                sourceInformationMarkerEnd($composer_50);
                sourceInformationMarkerStart($composer_50, -290329483, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
                // Inline function 'androidx.compose.runtime.cache' call
                var invalid_26 = $composer_50.q31(element_4);
                // Inline function 'kotlin.let' call
                var it_42 = $composer_50.i31();
                var tmp_162;
                if (invalid_26 || it_42 === Companion_getInstance().f30_1) {
                  var value_42 = CartNormalProductDetailsScreen$lambda_46(birthdayPickerTargetOptionKey$delegate, element_4, showBirthdayPicker$delegate);
                  $composer_50.j31(value_42);
                  tmp_162 = value_42;
                } else {
                  tmp_162 = it_42;
                }
                var tmp1_group_5 = tmp_162;
                sourceInformationMarkerEnd($composer_50);
                SelectedOptionExtraInputs(element_4.r101_1, tmp0_safe_receiver_1, language, tmp0_group_8, tmp1_group_5, true, $composer_50, 196608, 0);
                $composer_50.n30();
              } else {
                $composer_50.m30(-409936767);
                $composer_50.n30();
              }
              $composer_50.n30();
            }
          }
          $composer_50.n30();
        }
        var tmp_163 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$340 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_163, tmp$ret$340), $composer_50, 6);
        var tmp29_value = CartNormalProductDetailsScreen$lambda_1(state$delegate).g11e_1;
        var tmp30_modifier = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$341 = _Dp___init__impl__ms3zkb(12);
        var tmp31_shape = RoundedCornerShape(tmp$ret$341);
        sourceInformationMarkerStart($composer_50, 1248054856, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_27 = $composer_50.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_43 = $composer_50.i31();
        var tmp_164;
        if (invalid_27 || it_43 === Companion_getInstance().f30_1) {
          var value_43 = CartNormalProductDetailsScreen$lambda_47(viewModel);
          $composer_50.j31(value_43);
          tmp_164 = value_43;
        } else {
          tmp_164 = it_43;
        }
        var tmp11_group_0 = tmp_164;
        sourceInformationMarkerEnd($composer_50);
        var tmp_165 = ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().y11e_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_6 = rememberComposableLambda(2052721827, true, CartNormalProductDetailsScreen$lambda_48(state$delegate), $composer_50, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_71 = $composer_50;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_28 = $composer_71.k31(dispatchReceiver_6);
        // Inline function 'kotlin.let' call
        var it_44 = $composer_71.i31();
        var tmp_166;
        if (invalid_28 || it_44 === Companion_getInstance().f30_1) {
          var value_44 = ComposableLambda$invoke$ref(dispatchReceiver_6);
          $composer_71.j31(value_44);
          tmp_166 = value_44;
        } else {
          tmp_166 = it_44;
        }
        var tmp_167 = tmp_166;
        OutlinedTextField(tmp29_value, tmp11_group_0, tmp30_modifier, false, false, null, tmp_165, null, null, null, null, null, tmp_167, false, null, null, null, false, 3, 0, null, tmp31_shape, null, $composer_50, 1573248, 100663680, 0, 6025144);
        var tmp_168 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$353 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_168, tmp$ret$353), $composer_50, 6);
        AgeGroupDisplay(tmp0_safe_receiver.rzu_1, tmp0_safe_receiver.szu_1, tmp0_safe_receiver.tzu_1, null, $composer_50, 0, 8);
        var tmp_169 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$354 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_169, tmp$ret$354), $composer_50, 6);
        var tmp32_elvis_lhs = tmp0_safe_receiver.wzt_1;
        if ((tmp32_elvis_lhs == null ? 0 : tmp32_elvis_lhs) > 0) {
          $composer_50.m30(36643578);
          sourceInformation($composer_50, '777@43671L940');
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_23 = null;
          var horizontalArrangement_4 = null;
          var verticalAlignment_4 = Companion_getInstance_11().u8t_1;
          var $composer_72 = $composer_50;
          if (!((3 & 1) === 0))
            modifier_23 = Companion_instance;
          if (!((3 & 2) === 0))
            horizontalArrangement_4 = Arrangement_getInstance().qdp_1;
          if (!((3 & 4) === 0))
            verticalAlignment_4 = Companion_getInstance_11().t8t_1;
          var measurePolicy_11 = rowMeasurePolicy(horizontalArrangement_4, verticalAlignment_4, $composer_72, 14 & 384 >> 3 | 112 & 384 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_24 = modifier_23;
          var $composer_73 = $composer_72;
          if (!((0 & 2) === 0))
            modifier_24 = Companion_instance;
          var compositeKeyHash_11 = get_currentCompositeKeyHashCode($composer_73, 0).hashCode();
          var localMap_11 = $composer_73.t31();
          var materialized_11 = materialize($composer_73, modifier_24);
          var tmp0_18 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_74 = $composer_73;
          var tmp_170 = $composer_74.g30();
          if (!isInterface(tmp_170, Applier)) {
            invalidApplier();
          }
          $composer_74.b31();
          if ($composer_74.h30()) {
            $composer_74.c31(tmp0_18);
          } else {
            $composer_74.d31();
          }
          var $this$ReusableComposeNode_11 = _Updater___init__impl__rbfxm8($composer_74);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_11, measurePolicy_11, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_11, localMap_11, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_11, compositeKeyHash_11, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_11, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_11, materialized_11, Companion_getInstance_12().qah_1);
          var $composer_75 = $composer_74;
          var $composer_76 = $composer_75;
          sourceInformationMarkerStart($composer_76, 181343102, 'C778@43761L206,782@44004L39,784@44133L187,783@44080L497:CartNormalProductDetailsScreen.kt#6ni00');
          var tmp_171 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$361 = _Dp___init__impl__ms3zkb(8);
          Box(background(clip(size(tmp_171, tmp$ret$361), get_CircleShape()), Color(new Long(-11751600, 0))), $composer_76, 0);
          var tmp_172 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$362 = _Dp___init__impl__ms3zkb(8);
          Spacer(width(tmp_172, tmp$ret$362), $composer_76, 6);
          var tmp_173 = get_in_stock_pattern(string_instance);
          var tmp0_elvis_lhs_5 = tmp0_safe_receiver.wzt_1;
          var tmp1_text_0 = formatNumbers(stringResource_0(tmp_173, [tmp0_elvis_lhs_5 == null ? 0 : tmp0_elvis_lhs_5], $composer_76, 0), language);
          var tmp2_color_1 = Color(new Long(-11751600, 0));
          var tmp3_fontWeight_0 = Companion_getInstance_16().e7z_1;
          var tmp4_fontSize = get_sp(14);
          var tmp_174 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_175 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_176 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp1_text_0, null, tmp2_color_1, null, tmp4_fontSize, null, tmp3_fontWeight_0, null, tmp_174, null, null, tmp_175, tmp_176, false, 0, 0, null, null, $composer_76, 1597824, 0, 262058);
          sourceInformationMarkerEnd($composer_76);
          $composer_74.e31();
          $composer_50.n30();
        } else {
          $composer_50.m30(37641034);
          sourceInformation($composer_50, '794@44681L796');
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_25 = null;
          var horizontalArrangement_5 = null;
          var verticalAlignment_5 = Companion_getInstance_11().u8t_1;
          var $composer_77 = $composer_50;
          if (!((3 & 1) === 0))
            modifier_25 = Companion_instance;
          if (!((3 & 2) === 0))
            horizontalArrangement_5 = Arrangement_getInstance().qdp_1;
          if (!((3 & 4) === 0))
            verticalAlignment_5 = Companion_getInstance_11().t8t_1;
          var measurePolicy_12 = rowMeasurePolicy(horizontalArrangement_5, verticalAlignment_5, $composer_77, 14 & 384 >> 3 | 112 & 384 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_26 = modifier_25;
          var $composer_78 = $composer_77;
          if (!((0 & 2) === 0))
            modifier_26 = Companion_instance;
          var compositeKeyHash_12 = get_currentCompositeKeyHashCode($composer_78, 0).hashCode();
          var localMap_12 = $composer_78.t31();
          var materialized_12 = materialize($composer_78, modifier_26);
          var tmp0_19 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_79 = $composer_78;
          var tmp_177 = $composer_79.g30();
          if (!isInterface(tmp_177, Applier)) {
            invalidApplier();
          }
          $composer_79.b31();
          if ($composer_79.h30()) {
            $composer_79.c31(tmp0_19);
          } else {
            $composer_79.d31();
          }
          var $this$ReusableComposeNode_12 = _Updater___init__impl__rbfxm8($composer_79);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_12, measurePolicy_12, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_12, localMap_12, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_12, compositeKeyHash_12, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_12, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_12, materialized_12, Companion_getInstance_12().qah_1);
          var $composer_80 = $composer_79;
          var $composer_81 = $composer_80;
          sourceInformationMarkerStart($composer_81, 1888294309, 'C797@44935L11,795@44771L220,799@45028L39,801@45157L39,802@45260L11,800@45104L339:CartNormalProductDetailsScreen.kt#6ni00');
          var tmp_178 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$369 = _Dp___init__impl__ms3zkb(8);
          Box(background(clip(size(tmp_178, tmp$ret$369), get_CircleShape()), MaterialTheme_instance.unz($composer_81, 6).to0_1), $composer_81, 0);
          var tmp_179 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$370 = _Dp___init__impl__ms3zkb(8);
          Spacer(width(tmp_179, tmp$ret$370), $composer_81, 6);
          var tmp0_text_0 = stringResource(get_out_of_stock(string_instance), $composer_81, 0);
          var tmp1_color = MaterialTheme_instance.unz($composer_81, 6).to0_1;
          var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp3_fontSize = get_sp(14);
          var tmp_180 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_181 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_182 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text_0, null, tmp1_color, null, tmp3_fontSize, null, tmp2_fontWeight, null, tmp_180, null, null, tmp_181, tmp_182, false, 0, 0, null, null, $composer_81, 1597440, 0, 262058);
          sourceInformationMarkerEnd($composer_81);
          $composer_79.e31();
          $composer_50.n30();
        }
        var tmp_183 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$371 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_183, tmp$ret$371), $composer_50, 6);
        var tmp_184 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$372 = _Dp___init__impl__ms3zkb(120);
        Spacer(height(tmp_184, tmp$ret$372), $composer_50, 6);
        sourceInformationMarkerEnd($composer_50);
        $composer_48.e31();
        sourceInformationMarkerEnd($composer_23);
        $composer_21.e31();
        sourceInformationMarkerEnd($composer_18);
        $composer_16.e31();
        var tmp0_modifier_0 = fillMaxWidth(Companion_instance);
        var tmp1_color_0 = MaterialTheme_instance.unz($composer_13, 6).mo0_1;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_shadowElevation = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_185 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$375 = _Dp___init__impl__ms3zkb(24);
        var tmp3_shape = RoundedCornerShape_0(tmp_185, tmp$ret$375);
        var tmp_186 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_187 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_7 = rememberComposableLambda(-655106331, true, CartNormalProductDetailsScreen$lambda_49(tmp0_safe_receiver, state$delegate, viewModel, language, cartRepository, cartItem), $composer_13, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_82 = $composer_13;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_29 = $composer_82.k31(dispatchReceiver_7);
        // Inline function 'kotlin.let' call
        var it_45 = $composer_82.i31();
        var tmp_188;
        if (invalid_29 || it_45 === Companion_getInstance().f30_1) {
          var value_45 = ComposableLambda$invoke$ref(dispatchReceiver_7);
          $composer_82.j31(value_45);
          tmp_188 = value_45;
        } else {
          tmp_188 = it_45;
        }
        var tmp$ret$376 = tmp_188;
        Surface(tmp0_modifier_0, tmp3_shape, tmp1_color_0, tmp_186, tmp_187, tmp2_shadowElevation, null, tmp$ret$376, $composer_13, 12779526, 88);
        sourceInformationMarkerEnd($composer_13);
        $composer_11.e31();
        var tmp_189 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
        SnackbarHost(snackbarHostState, tmp_189, null, $composer_8, 6, 4);
        if (CartNormalProductDetailsScreen$lambda_12(showMediaDialog$delegate)) {
          $composer_8.m30(774932675);
          sourceInformation($composer_8, '981@55697L27,977@55507L235');
          var tmp_190 = CartNormalProductDetailsScreen$lambda_14(initialMediaIndex$delegate);
          sourceInformationMarkerStart($composer_8, -1221921745, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_46 = $composer_8.i31();
          var tmp_191;
          if (false || it_46 === Companion_getInstance().f30_1) {
            var value_46 = CartNormalProductDetailsScreen$lambda_50(showMediaDialog$delegate);
            $composer_8.j31(value_46);
            tmp_191 = value_46;
          } else {
            tmp_191 = it_46;
          }
          var tmp0_group_9 = tmp_191;
          sourceInformationMarkerEnd($composer_8);
          ProductMediaGalleryDialog(combinedMedia, name, tmp_190, tmp0_group_9, $composer_8, 3072, 0);
          $composer_8.n30();
        } else {
          $composer_8.m30(775189262);
          $composer_8.n30();
        }
        if (CartNormalProductDetailsScreen$lambda_4(showBirthdayPicker$delegate)) {
          $composer_8.m30(775305884);
          sourceInformation($composer_8, '987@55869L136,991@56043L1776,1021@57857L371,1030@58247L79,986@55812L2514');
          sourceInformationMarkerStart($composer_8, -1221916132, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_47 = $composer_8.i31();
          var tmp_192;
          if (false || it_47 === Companion_getInstance().f30_1) {
            var value_47 = CartNormalProductDetailsScreen$lambda_51(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate);
            $composer_8.j31(value_47);
            tmp_192 = value_47;
          } else {
            tmp_192 = it_47;
          }
          var tmp1_group_6 = tmp_192;
          sourceInformationMarkerEnd($composer_8);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_8 = rememberComposableLambda(1004135352, true, CartNormalProductDetailsScreen$lambda_52(birthdayPickerState, state$delegate, viewModel, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_8, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_83 = $composer_8;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_30 = $composer_83.k31(dispatchReceiver_8);
          // Inline function 'kotlin.let' call
          var it_48 = $composer_83.i31();
          var tmp_193;
          if (invalid_30 || it_48 === Companion_getInstance().f30_1) {
            var value_48 = ComposableLambda$invoke$ref(dispatchReceiver_8);
            $composer_83.j31(value_48);
            tmp_193 = value_48;
          } else {
            tmp_193 = it_48;
          }
          var tmp_194 = tmp_193;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_9 = rememberComposableLambda(834516410, true, CartNormalProductDetailsScreen$lambda_53(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate), $composer_8, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_84 = $composer_8;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_31 = $composer_84.k31(dispatchReceiver_9);
          // Inline function 'kotlin.let' call
          var it_49 = $composer_84.i31();
          var tmp_195;
          if (invalid_31 || it_49 === Companion_getInstance().f30_1) {
            var value_49 = ComposableLambda$invoke$ref(dispatchReceiver_9);
            $composer_84.j31(value_49);
            tmp_195 = value_49;
          } else {
            tmp_195 = it_49;
          }
          var tmp_196 = tmp_195;
          var tmp_197 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_10 = rememberComposableLambda(-991579569, true, CartNormalProductDetailsScreen$lambda_54(birthdayPickerState), $composer_8, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_85 = $composer_8;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_32 = $composer_85.k31(dispatchReceiver_10);
          // Inline function 'kotlin.let' call
          var it_50 = $composer_85.i31();
          var tmp_198;
          if (invalid_32 || it_50 === Companion_getInstance().f30_1) {
            var value_50 = ComposableLambda$invoke$ref_6(dispatchReceiver_10);
            $composer_85.j31(value_50);
            tmp_198 = value_50;
          } else {
            tmp_198 = it_50;
          }
          var tmp$ret$405 = tmp_198;
          DatePickerDialog(tmp1_group_6, tmp_194, null, tmp_196, null, tmp_197, null, null, tmp$ret$405, $composer_8, 100666422, 244);
          $composer_8.n30();
        } else {
          $composer_8.m30(777752590);
          $composer_8.n30();
        }
        sourceInformationMarkerEnd($composer_8);
        $composer_6.e31();
        $composer_0.n30();
        tmp_4 = Unit_instance;
      }
      if (tmp_4 == null) {
        $composer_0.m30(-653825724);
        sourceInformation($composer_0, '1035@58360L119');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_27 = fillMaxSize(Companion_instance);
        var contentAlignment_2 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_2 = false;
        var $composer_86 = $composer_0;
        if (!((4 & 1) === 0))
          modifier_27 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_2 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_2 = false;
        var measurePolicy_13 = maybeCachedBoxMeasurePolicy(contentAlignment_2, propagateMinConstraints_2);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_28 = modifier_27;
        var $composer_87 = $composer_86;
        if (!((0 & 2) === 0))
          modifier_28 = Companion_instance;
        var compositeKeyHash_13 = get_currentCompositeKeyHashCode($composer_87, 0).hashCode();
        var localMap_13 = $composer_87.t31();
        var materialized_13 = materialize($composer_87, modifier_28);
        var tmp0_20 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_88 = $composer_87;
        var tmp_199 = $composer_88.g30();
        if (!isInterface(tmp_199, Applier)) {
          invalidApplier();
        }
        $composer_88.b31();
        if ($composer_88.h30()) {
          $composer_88.c31(tmp0_20);
        } else {
          $composer_88.d31();
        }
        var $this$ReusableComposeNode_13 = _Updater___init__impl__rbfxm8($composer_88);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_13, measurePolicy_13, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_13, localMap_13, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_13, compositeKeyHash_13, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_13, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_13, materialized_13, Companion_getInstance_12().qah_1);
        var $composer_89 = $composer_88;
        var $composer_90 = $composer_89;
        sourceInformationMarkerStart($composer_90, -188826279, 'C1036@58446L27:CartNormalProductDetailsScreen.kt#6ni00');
        var tmp_200 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_201 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_202 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_203 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_200, tmp_201, tmp_202, tmp_203, _Dp___init__impl__ms3zkb(0.0), $composer_90, 0, 63);
        sourceInformationMarkerEnd($composer_90);
        $composer_88.e31();
        $composer_0.n30();
      } else {
        $composer_0.m30(-655496190);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver_0 = $composer_0.t30();
    if (tmp2_safe_receiver_0 == null)
      null;
    else {
      tmp2_safe_receiver_0.p3c(CartNormalProductDetailsScreen$lambda_55(cartItem, onBack, onNavigateToAuth, $changed));
    }
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1852822706$lambda_u9ygs4($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C247@11610L31,245@11466L273:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1852822706, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$-1852822706.<anonymous> (CartNormalProductDetailsScreen.kt:245)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, Companion_getInstance_14().i6b_1, $composer_0, 3072, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1350226315$lambda_z8zm3b($this$AnimatedContent, isFav, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C264@12712L42,262@12506L412:CartNormalProductDetailsScreen.kt#6ni00');
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isFav) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1350226315, $dirty, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$-1350226315.<anonymous> (CartNormalProductDetailsScreen.kt:262)');
      }
      var tmp = isFav ? get_Favorite(Icons_getInstance().dxv_1) : get_FavoriteBorder(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_favorites_title(string_instance), $composer_0, 0);
      var tmp_1;
      if (isFav) {
        $composer_0.m30(-487352612);
        sourceInformation($composer_0, '265@12836L11');
        var tmp0_group = MaterialTheme_instance.unz($composer_0, 6).xnz_1;
        $composer_0.n30();
        tmp_1 = tmp0_group;
      } else {
        $composer_0.m30(-487352006);
        $composer_0.n30();
        tmp_1 = Companion_getInstance_14().i6b_1;
      }
      Icon(tmp, tmp_0, null, tmp_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_645148439$lambda_fg57dn($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C279@13633L40,277@13483L296:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-645148439, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$-645148439.<anonymous> (CartNormalProductDetailsScreen.kt:277)');
      }
      var tmp = get_Share(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_share_product(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, Companion_getInstance_14().i6b_1, $composer_0, 3072, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1419979241$lambda_yvok5y($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C300@14715L1159:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1419979241, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$-1419979241.<anonymous> (CartNormalProductDetailsScreen.kt:300)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_0 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(8);
      var tmp0_modifier = padding_2(tmp, tmp_0, tmp$ret$1);
      var tmp1_verticalAlignment = Companion_getInstance_11().u8t_1;
      var tmp_1 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$2 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = tmp0_modifier;
      var horizontalArrangement = tmp_1.mdq(tmp$ret$2);
      var verticalAlignment = tmp1_verticalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier = Companion_instance;
      if (!((0 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_2 = $composer_3.g30();
      if (!isInterface(tmp_2, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -2059150911, 'C309@15352L11,305@15065L357,312@15512L39,313@15615L10,315@15770L11,311@15459L381:CartNormalProductDetailsScreen.kt#6ni00');
      var tmp_3 = get_Fullscreen(Icons_getInstance().dxv_1);
      var tmp_4 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$9 = _Dp___init__impl__ms3zkb(20);
      Icon(tmp_3, null, size(tmp_4, tmp$ret$9), MaterialTheme_instance.unz($composer_5, 6).fo0_1, $composer_5, 432, 0);
      var tmp0_text = stringResource(get_full_gallery(string_instance), $composer_5, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).rof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp3_color = MaterialTheme_instance.unz($composer_5, 6).fo0_1;
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp3_color, null, tmp_5, null, tmp2_fontWeight, null, tmp_6, null, null, tmp_7, tmp_8, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131002);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$604798156$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C546@29872L45,546@29867L51:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(604798156, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$604798156.<anonymous> (CartNormalProductDetailsScreen.kt:546)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1209376213$lambda_8auwll($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C547@29983L51,547@29978L57:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1209376213, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$-1209376213.<anonymous> (CartNormalProductDetailsScreen.kt:547)');
      }
      var tmp = stringResource(get_gift_message_placeholder(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1637262292$lambda_9ag8q9($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C577@32034L48,577@32029L54:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1637262292, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$-1637262292.<anonymous> (CartNormalProductDetailsScreen.kt:577)');
      }
      var tmp = stringResource(get_invalid_birthday_date(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$1519232579$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C568@31334L46,568@31329L52:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1519232579, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$1519232579.<anonymous> (CartNormalProductDetailsScreen.kt:568)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1428249790$lambda_rrlezv($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C584@32513L214:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1428249790, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$-1428249790.<anonymous> (CartNormalProductDetailsScreen.kt:584)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$328012867$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C625@34845L45,625@34840L51:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(328012867, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$328012867.<anonymous> (CartNormalProductDetailsScreen.kt:625)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$663166434$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C626@34956L51,626@34951L57:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(663166434, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$663166434.<anonymous> (CartNormalProductDetailsScreen.kt:626)');
      }
      var tmp = stringResource(get_gift_message_placeholder(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_270715005$lambda_xvv5fg($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C656@37001L48,656@36996L54:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-270715005, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$-270715005.<anonymous> (CartNormalProductDetailsScreen.kt:656)');
      }
      var tmp = stringResource(get_invalid_birthday_date(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1368802310$lambda_5p6q49($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C647@36304L46,647@36299L52:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1368802310, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$-1368802310.<anonymous> (CartNormalProductDetailsScreen.kt:647)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$779056441$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C663@37479L214:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(779056441, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$779056441.<anonymous> (CartNormalProductDetailsScreen.kt:663)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$1563723350$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C753@42470L52,753@42465L58:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1563723350, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$1563723350.<anonymous> (CartNormalProductDetailsScreen.kt:753)');
      }
      var tmp = stringResource(get_add_product_comment_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_565796274$lambda_v9jkmm($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C854@47976L49,855@48092L11,852@47839L316:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-565796274, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$-565796274.<anonymous> (CartNormalProductDetailsScreen.kt:852)');
      }
      var tmp = get_Remove(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_decrease_quantity_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).no0_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1183679561$lambda_gtxo4i($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C875@49306L49,876@49422L11,873@49172L313:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1183679561, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$-1183679561.<anonymous> (CartNormalProductDetailsScreen.kt:873)');
      }
      var tmp = get_Add(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_increase_quantity_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).no0_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_412337099$lambda_gce2yb($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1018@57741L29,1018@57736L35:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-412337099, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$-412337099.<anonymous> (CartNormalProductDetailsScreen.kt:1018)');
      }
      var tmp = stringResource(get_ok(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_581956041$lambda_rivgqo($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1027@58146L33,1027@58141L39:CartNormalProductDetailsScreen.kt#6ni00');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-581956041, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.ComposableSingletons$CartNormalProductDetailsScreenKt.lambda$-581956041.<anonymous> (CartNormalProductDetailsScreen.kt:1027)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CartNormalProductDetailsScreenKt() {
    ComposableSingletons$CartNormalProductDetailsScreenKt_instance = this;
    var tmp = this;
    tmp.k11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1852822706, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1852822706$lambda_u9ygs4));
    var tmp_0 = this;
    tmp_0.l11e_1 = ComposableLambda$invoke$ref_5(composableLambdaInstance(-1350226315, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1350226315$lambda_z8zm3b));
    var tmp_1 = this;
    tmp_1.m11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-645148439, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_645148439$lambda_fg57dn));
    var tmp_2 = this;
    tmp_2.n11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1419979241, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1419979241$lambda_yvok5y));
    var tmp_3 = this;
    tmp_3.o11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(604798156, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$604798156$lambda));
    var tmp_4 = this;
    tmp_4.p11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1209376213, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1209376213$lambda_8auwll));
    var tmp_5 = this;
    tmp_5.q11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1637262292, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1637262292$lambda_9ag8q9));
    var tmp_6 = this;
    tmp_6.r11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1519232579, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$1519232579$lambda));
    var tmp_7 = this;
    tmp_7.s11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1428249790, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1428249790$lambda_rrlezv));
    var tmp_8 = this;
    tmp_8.t11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(328012867, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$328012867$lambda));
    var tmp_9 = this;
    tmp_9.u11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(663166434, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$663166434$lambda));
    var tmp_10 = this;
    tmp_10.v11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-270715005, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_270715005$lambda_xvv5fg));
    var tmp_11 = this;
    tmp_11.w11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1368802310, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1368802310$lambda_5p6q49));
    var tmp_12 = this;
    tmp_12.x11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(779056441, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$779056441$lambda));
    var tmp_13 = this;
    tmp_13.y11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1563723350, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$1563723350$lambda));
    var tmp_14 = this;
    tmp_14.z11e_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-565796274, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_565796274$lambda_v9jkmm));
    var tmp_15 = this;
    tmp_15.a11f_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1183679561, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_1183679561$lambda_gtxo4i));
    var tmp_16 = this;
    tmp_16.b11f_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-412337099, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_412337099$lambda_gce2yb));
    var tmp_17 = this;
    tmp_17.c11f_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-581956041, false, ComposableSingletons$CartNormalProductDetailsScreenKt$lambda$_581956041$lambda_rivgqo));
  }
  var ComposableSingletons$CartNormalProductDetailsScreenKt_instance;
  function ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance() {
    if (ComposableSingletons$CartNormalProductDetailsScreenKt_instance == null)
      new ComposableSingletons$CartNormalProductDetailsScreenKt();
    return ComposableSingletons$CartNormalProductDetailsScreenKt_instance;
  }
  function CartNormalProductDetailsScreen$lambda($product$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('product', KMutableProperty0, true);
    return $product$delegate.u1();
  }
  function CartNormalProductDetailsScreen$lambda_0($product$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('product', KMutableProperty0, true);
    $product$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartNormalProductDetailsScreen$slambda($cartItem, $getProductByIdUseCase, $product$delegate, resultContinuation) {
    this.l11f_1 = $cartItem;
    this.m11f_1 = $getProductByIdUseCase;
    this.n11f_1 = $product$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartNormalProductDetailsScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartNormalProductDetailsScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartNormalProductDetailsScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_safe_receiver = this.l11f_1.gyw_1;
            if (tmp0_safe_receiver == null) {
              this.p11f_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = this.m11f_1.o105(tmp0_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var ARGUMENT = suspendResult;
            CartNormalProductDetailsScreen$lambda_0(this.n11f_1, ARGUMENT);
            var tmp_0 = this;
            tmp_0.p11f_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartNormalProductDetailsScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartNormalProductDetailsScreen$slambda(this.l11f_1, this.m11f_1, this.n11f_1, completion);
    i.o11f_1 = $this$LaunchedEffect;
    return i;
  };
  function CartNormalProductDetailsScreen$slambda_0($cartItem, $getProductByIdUseCase, $product$delegate, resultContinuation) {
    var i = new CartNormalProductDetailsScreen$slambda($cartItem, $getProductByIdUseCase, $product$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CartNormalProductDetailsScreen$lambda_1($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function CartNormalProductDetailsScreen$lambda_2($isZooming$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isZooming', KMutableProperty0, true);
    return $isZooming$delegate.u1();
  }
  function CartNormalProductDetailsScreen$lambda_3($isZooming$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isZooming', KMutableProperty0, true);
    $isZooming$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartNormalProductDetailsScreen$lambda_4($showBirthdayPicker$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    return $showBirthdayPicker$delegate.u1();
  }
  function CartNormalProductDetailsScreen$lambda_5($showBirthdayPicker$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    $showBirthdayPicker$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartNormalProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    return $birthdayPickerTargetOptionKey$delegate.u1();
  }
  function CartNormalProductDetailsScreen$lambda_7($birthdayPickerTargetOptionKey$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    $birthdayPickerTargetOptionKey$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartNormalProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    return $isPickingBoxBirthday$delegate.u1();
  }
  function CartNormalProductDetailsScreen$lambda_9($isPickingBoxBirthday$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    $isPickingBoxBirthday$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartNormalProductDetailsScreen$lambda_10($showDiscardDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    return $showDiscardDialog$delegate.u1();
  }
  function CartNormalProductDetailsScreen$lambda_11($showDiscardDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    $showDiscardDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartNormalProductDetailsScreen$lambda_12($showMediaDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showMediaDialog', KMutableProperty0, true);
    return $showMediaDialog$delegate.u1();
  }
  function CartNormalProductDetailsScreen$lambda_13($showMediaDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showMediaDialog', KMutableProperty0, true);
    $showMediaDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartNormalProductDetailsScreen$lambda_14($initialMediaIndex$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('initialMediaIndex', KMutableProperty0, true);
    return $initialMediaIndex$delegate.b49();
  }
  function CartNormalProductDetailsScreen$lambda_15($initialMediaIndex$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('initialMediaIndex', KMutableProperty0, true);
    $initialMediaIndex$delegate.a49(_set____db54di);
    return Unit_instance;
  }
  function CartNormalProductDetailsScreen$lambda_16($isSaving$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isSaving', KMutableProperty0, true);
    return $isSaving$delegate.u1();
  }
  function CartNormalProductDetailsScreen$lambda_17($isSaving$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isSaving', KMutableProperty0, true);
    $isSaving$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CartNormalProductDetailsScreen$slambda_1($viewModel, $p, $cartItem, resultContinuation) {
    this.y11f_1 = $viewModel;
    this.z11f_1 = $p;
    this.a11g_1 = $cartItem;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartNormalProductDetailsScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartNormalProductDetailsScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartNormalProductDetailsScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = delay(new Long(100, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y11f_1.s10h().j10i(new LoadProduct_2(this.z11f_1, this.a11g_1.jyx_1, this.a11g_1.kyx_1, this.a11g_1.lyx_1, this.a11g_1.myx_1, this.a11g_1.dyx_1, this.a11g_1.gyx_1, this.a11g_1.eyx_1, this.a11g_1.fyx_1, this.a11g_1.hyx_1, this.a11g_1.iyx_1));
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartNormalProductDetailsScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartNormalProductDetailsScreen$slambda_1(this.y11f_1, this.z11f_1, this.a11g_1, completion);
    i.b11g_1 = $this$LaunchedEffect;
    return i;
  };
  function CartNormalProductDetailsScreen$slambda_2($viewModel, $p, $cartItem, resultContinuation) {
    var i = new CartNormalProductDetailsScreen$slambda_1($viewModel, $p, $cartItem, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_10(function_0) {
    this.c11g_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_10).a1v = function (value, $completion) {
    return this.c11g_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_10).q3 = function () {
    return this.c11g_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_10).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_10).hashCode = function () {
    return hashCode(this.q3());
  };
  function CartNormalProductDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, resultContinuation) {
    this.l11g_1 = $snackbarHostState;
    this.m11g_1 = $onNavigateToAuth;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartNormalProductDetailsScreen$slambda$slambda).p11g = function (effect, $completion) {
    var tmp = this.q11g(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartNormalProductDetailsScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.p11g((!(p1 == null) ? isInterface(p1, ProductDetailsSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartNormalProductDetailsScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp0_subject = this.n11g_1;
            if (tmp0_subject instanceof ShowMessage_5) {
              this.n9_1 = 2;
              suspendResult = this.n11g_1.s11g_1.z10i(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof ShowToast_1) {
                this.n9_1 = 1;
                suspendResult = this.n11g_1.r11g_1.z10i(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (equals(tmp0_subject, NavigateToAuth_instance_3)) {
                  this.o11g_1 = this.m11g_1();
                  this.n9_1 = 4;
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            var tmp_1 = this;
            showToast(ARGUMENT);
            tmp_1.o11g_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            this.n9_1 = 3;
            suspendResult = this.l11g_1.dqm(ARGUMENT_0, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.o11g_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartNormalProductDetailsScreen$slambda$slambda).q11g = function (effect, completion) {
    var i = new CartNormalProductDetailsScreen$slambda$slambda(this.l11g_1, this.m11g_1, completion);
    i.n11g_1 = effect;
    return i;
  };
  function CartNormalProductDetailsScreen$slambda$slambda_0($snackbarHostState, $onNavigateToAuth, resultContinuation) {
    var i = new CartNormalProductDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.p11g(effect, $completion);
    }, 1);
  }
  function CartNormalProductDetailsScreen$slambda_3($viewModel, $snackbarHostState, $onNavigateToAuth, resultContinuation) {
    this.b11h_1 = $viewModel;
    this.c11h_1 = $snackbarHostState;
    this.d11h_1 = $onNavigateToAuth;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartNormalProductDetailsScreen$slambda_3).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartNormalProductDetailsScreen$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartNormalProductDetailsScreen$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.b11h_1.s10h().t10h();
            var tmp_1 = CartNormalProductDetailsScreen$slambda$slambda_0(this.c11h_1, this.d11h_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_10(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartNormalProductDetailsScreen$slambda_3).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartNormalProductDetailsScreen$slambda_3(this.b11h_1, this.c11h_1, this.d11h_1, completion);
    i.e11h_1 = $this$LaunchedEffect;
    return i;
  };
  function CartNormalProductDetailsScreen$slambda_4($viewModel, $snackbarHostState, $onNavigateToAuth, resultContinuation) {
    var i = new CartNormalProductDetailsScreen$slambda_3($viewModel, $snackbarHostState, $onNavigateToAuth, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CartNormalProductDetailsScreen$lambda_18($combinedMedia) {
    return function () {
      return $combinedMedia.n1();
    };
  }
  function CartNormalProductDetailsScreen$lambda_19($showMediaDialog$delegate, $showDiscardDialog$delegate) {
    return function () {
      var tmp;
      if (CartNormalProductDetailsScreen$lambda_12($showMediaDialog$delegate)) {
        CartNormalProductDetailsScreen$lambda_13($showMediaDialog$delegate, false);
        tmp = Unit_instance;
      } else {
        CartNormalProductDetailsScreen$lambda_11($showDiscardDialog$delegate, true);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$slambda_5($isZooming$delegate, resultContinuation) {
    this.n11h_1 = $isZooming$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartNormalProductDetailsScreen$slambda_5).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartNormalProductDetailsScreen$slambda_5).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartNormalProductDetailsScreen$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          CartNormalProductDetailsScreen$lambda_3(this.n11h_1, false);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CartNormalProductDetailsScreen$slambda_5).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CartNormalProductDetailsScreen$slambda_5(this.n11h_1, completion);
    i.o11h_1 = $this$LaunchedEffect;
    return i;
  };
  function CartNormalProductDetailsScreen$slambda_6($isZooming$delegate, resultContinuation) {
    var i = new CartNormalProductDetailsScreen$slambda_5($isZooming$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CartNormalProductDetailsScreen$lambda_20($showDiscardDialog$delegate, $onBack) {
    return function () {
      CartNormalProductDetailsScreen$lambda_11($showDiscardDialog$delegate, false);
      $onBack();
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_21($showDiscardDialog$delegate) {
    return function () {
      CartNormalProductDetailsScreen$lambda_11($showDiscardDialog$delegate, false);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda$lambda($pagerState, $page, $isZooming$delegate) {
    return function (zooming) {
      var tmp;
      if ($pagerState.zj9() === $page) {
        CartNormalProductDetailsScreen$lambda_3($isZooming$delegate, zooming);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_22($combinedMedia, $name, $pagerState, $isZooming$delegate) {
    return function ($this$HorizontalPager, page, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C219@10145L234,214@9817L596:CartNormalProductDetailsScreen.kt#6ni00');
      var $dirty = $changed;
      var tmp;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(page) ? 32 : 16);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1034780211, $dirty, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartNormalProductDetailsScreen.kt:213)');
        }
        var mediaUrl = $combinedMedia.l1(page);
        var tmp_1 = fillMaxSize(Companion_instance);
        var tmp_2 = Companion_getInstance_13().r96_1;
        sourceInformationMarkerStart($composer_0, 2008644119, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.k31($pagerState) | ($dirty & 112) === 32);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_3;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CartNormalProductDetailsScreen$lambda$lambda($pagerState, page, $isZooming$delegate);
          $composer_0.j31(value);
          tmp_3 = value;
        } else {
          tmp_3 = it;
        }
        var tmp0_group = tmp_3;
        sourceInformationMarkerEnd($composer_0);
        ZoomableMediaView(mediaUrl, $name, tmp_1, tmp_2, tmp0_group, $composer_0, 3456, 0);
        var tmp_4;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_4 = Unit_instance;
        }
        tmp_0 = tmp_4;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_7(p0) {
    return constructCallableReference(function (p0_0, p1, p2, p3) {
      p0.v50(p0_0, p1, p2, p3);
      return Unit_instance;
    }, 4, 0, 255, VOID, [p0]);
  }
  function CartNormalProductDetailsScreen$lambda_23($state$delegate, $showDiscardDialog$delegate, $onBack) {
    return function () {
      var tmp;
      if (CartNormalProductDetailsScreen$lambda_1($state$delegate).p11d_1) {
        CartNormalProductDetailsScreen$lambda_11($showDiscardDialog$delegate, true);
        tmp = Unit_instance;
      } else {
        tmp = $onBack();
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_24($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ToggleFavorite_instance_1);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_25($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C260@12366L42,258@12221L739:CartNormalProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1781743566, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartNormalProductDetailsScreen.kt:258)');
        }
        var tmp_0 = CartNormalProductDetailsScreen$lambda_1($state$delegate).q11d_1;
        var tmp_1 = stringResource(get_favorites_title(string_instance), $composer_0, 0);
        AnimatedContent(tmp_0, null, null, null, tmp_1, null, ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().l11e_1, $composer_0, 1572864, 46);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_26($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ShareProduct_instance_1);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_27($initialMediaIndex$delegate, $pagerState, $showMediaDialog$delegate) {
    return function () {
      CartNormalProductDetailsScreen$lambda_15($initialMediaIndex$delegate, $pagerState.zj9());
      CartNormalProductDetailsScreen$lambda_13($showMediaDialog$delegate, true);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda$lambda_0($key, $items) {
    return function (index) {
      return $key(index, $items.l1(index));
    };
  }
  function CartNormalProductDetailsScreen$lambda$lambda_1($items) {
    return function (index) {
      $items.l1(index);
      return null;
    };
  }
  function CartNormalProductDetailsScreen$lambda$lambda$lambda($initialMediaIndex$delegate, $index, $showMediaDialog$delegate) {
    return function () {
      CartNormalProductDetailsScreen$lambda_15($initialMediaIndex$delegate, $index);
      CartNormalProductDetailsScreen$lambda_13($showMediaDialog$delegate, true);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda$lambda_2($items, $pagerState, $initialMediaIndex$delegate, $showMediaDialog$delegate) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp4 = $items.l1(it);
        var $changed_0 = 14 & $dirty | 112 & $dirty;
        var $composer_1 = $composer_0;
        $composer_1.m30(1864049064);
        sourceInformation($composer_1, 'C*362@18347L11,368@18829L192,357@18006L2905:CartNormalProductDetailsScreen.kt#6ni00');
        var isSelected = $pagerState.zj9() === it;
        var tmp_2 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(6);
        var tmp_3 = padding_2(tmp_2, tmp$ret$1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$2 = _Dp___init__impl__ms3zkb(64);
        var tmp_4 = size(tmp_3, tmp$ret$2);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$3 = _Dp___init__impl__ms3zkb(12);
        var tmp_5 = background(clip(tmp_4, RoundedCornerShape(tmp$ret$3)), MaterialTheme_instance.unz($composer_1, 6).oo0_1);
        var tmp_6;
        if (isSelected) {
          // Inline function 'androidx.compose.ui.unit.dp' call
          tmp_6 = _Dp___init__impl__ms3zkb(2);
        } else {
          // Inline function 'androidx.compose.ui.unit.dp' call
          tmp_6 = _Dp___init__impl__ms3zkb(0);
        }
        var tmp_7 = tmp_6;
        var tmp_8;
        if (isSelected) {
          $composer_1.m30(198697140);
          sourceInformation($composer_1, '365@18602L11');
          var tmp0_group = MaterialTheme_instance.unz($composer_1, 6).xnz_1;
          $composer_1.n30();
          tmp_8 = tmp0_group;
        } else {
          $composer_1.m30(198697752);
          $composer_1.n30();
          tmp_8 = Companion_getInstance_14().t6b_1;
        }
        var tmp_9 = tmp_8;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$6 = _Dp___init__impl__ms3zkb(12);
        var tmp_10 = border(tmp_5, tmp_7, tmp_9, RoundedCornerShape(tmp$ret$6));
        sourceInformationMarkerStart($composer_1, 198704205, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = ($changed_0 & 112 ^ 48) > 32 && $composer_1.m31(it) || ($changed_0 & 48) === 32;
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_11;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = CartNormalProductDetailsScreen$lambda$lambda$lambda($initialMediaIndex$delegate, it, $showMediaDialog$delegate);
          $composer_1.j31(value);
          tmp_11 = value;
        } else {
          tmp_11 = it_0;
        }
        var tmp1_group = tmp_11;
        sourceInformationMarkerEnd($composer_1);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = clickable(tmp_10, VOID, VOID, VOID, VOID, tmp1_group);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_2 = $composer_1;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_3 = $composer_2;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
        var localMap = $composer_3.t31();
        var materialized = materialize($composer_3, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_4 = $composer_3;
        var tmp_12 = $composer_4.g30();
        if (!isInterface(tmp_12, Applier)) {
          invalidApplier();
        }
        $composer_4.b31();
        if ($composer_4.h30()) {
          $composer_4.c31(tmp0);
        } else {
          $composer_4.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_5 = $composer_4;
        var $composer_6 = $composer_5;
        sourceInformationMarkerStart($composer_6, -1399563279, 'C:CartNormalProductDetailsScreen.kt#6ni00');
        if (isVideoUrl(tmp4)) {
          $composer_6.m30(-1399563807);
          sourceInformation($composer_6, '374@19174L834');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_1 = fillMaxSize(Companion_instance);
          var contentAlignment_0 = Companion_getInstance_11().o8t_1;
          var propagateMinConstraints_0 = false;
          var $composer_7 = $composer_6;
          if (!((4 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((4 & 2) === 0))
            contentAlignment_0 = Companion_getInstance_11().k8t_1;
          if (!((4 & 4) === 0))
            propagateMinConstraints_0 = false;
          var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_8 = $composer_7;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
          var localMap_0 = $composer_8.t31();
          var materialized_0 = materialize($composer_8, modifier_2);
          var tmp0_0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_9 = $composer_8;
          var tmp_13 = $composer_9.g30();
          if (!isInterface(tmp_13, Applier)) {
            invalidApplier();
          }
          $composer_9.b31();
          if ($composer_9.h30()) {
            $composer_9.c31(tmp0_0);
          } else {
            $composer_9.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_10 = $composer_9;
          var $composer_11 = $composer_10;
          sourceInformationMarkerStart($composer_11, 708965013, 'C380@19599L219,384@19893L11,378@19442L520:CartNormalProductDetailsScreen.kt#6ni00');
          var tmp_14 = get_PlayCircle(Icons_getInstance().dxv_1);
          var tmp_15 = stringResource_0(get_video_thumbnail(string_instance), [it + 1 | 0], $composer_11, 0);
          Icon(tmp_14, tmp_15, null, MaterialTheme_instance.unz($composer_11, 6).xnz_1, $composer_11, 0, 4);
          sourceInformationMarkerEnd($composer_11);
          $composer_9.e31();
          $composer_6.n30();
        } else {
          $composer_6.m30(-1398646486);
          sourceInformation($composer_6, '388@20102L729');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_3 = fillMaxSize(Companion_instance);
          var contentAlignment_1 = null;
          var propagateMinConstraints_1 = false;
          var $composer_12 = $composer_6;
          if (!((6 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_1 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_1 = false;
          var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_13 = $composer_12;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_13, 0).hashCode();
          var localMap_1 = $composer_13.t31();
          var materialized_1 = materialize($composer_13, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_14 = $composer_13;
          var tmp_16 = $composer_14.g30();
          if (!isInterface(tmp_16, Applier)) {
            invalidApplier();
          }
          $composer_14.b31();
          if ($composer_14.h30()) {
            $composer_14.c31(tmp0_1);
          } else {
            $composer_14.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_14);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_15 = $composer_14;
          var $composer_16 = $composer_15;
          sourceInformationMarkerStart($composer_16, -1366718060, 'C391@20347L215,389@20191L594:CartNormalProductDetailsScreen.kt#6ni00');
          HadayaImage(tmp4, stringResource_0(get_thumbnail_index(string_instance), [it], $composer_16, 0), fillMaxSize(Companion_instance), Companion_getInstance_13().q96_1, $composer_16, 3456 | 14 & $changed_0 >> 6, 0);
          sourceInformationMarkerEnd($composer_16);
          $composer_14.e31();
          $composer_6.n30();
        }
        sourceInformationMarkerEnd($composer_6);
        $composer_4.e31();
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_28($combinedMedia, $pagerState, $initialMediaIndex$delegate, $showMediaDialog$delegate) {
    return function ($this$LazyRow) {
      // Inline function 'androidx.compose.foundation.lazy.itemsIndexed' call
      var items = $combinedMedia;
      var tmp = items.n1();
      var tmp_0;
      if (!(null == null)) {
        tmp_0 = CartNormalProductDetailsScreen$lambda$lambda_0(null, items);
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      var tmp_2 = CartNormalProductDetailsScreen$lambda$lambda_1(items);
      $this$LazyRow.di9(tmp, tmp_1, tmp_2, ComposableLambda$invoke$ref_4(composableLambdaInstance(2039820996, true, CartNormalProductDetailsScreen$lambda$lambda_2(items, $pagerState, $initialMediaIndex$delegate, $showMediaDialog$delegate))));
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_29($p, $language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C487@26399L11,478@25774L773:CartNormalProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(85147779, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartNormalProductDetailsScreen.kt:478)');
        }
        var tmp0_safe_receiver = $p.uzt_1;
        var tmp1_text = formatNumbers('-' + (tmp0_safe_receiver == null ? null : numberToInt(tmp0_safe_receiver)) + '%', $language);
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_1 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(4);
        var tmp2_modifier = padding_2(tmp_0, tmp_1, tmp$ret$1);
        var tmp3_fontSize = get_sp(12);
        var tmp4_color = MaterialTheme_instance.unz($composer_0, 6).uo0_1;
        var tmp5_fontWeight = Companion_getInstance_16().f7z_1;
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp1_text, tmp2_modifier, tmp4_color, null, tmp3_fontSize, null, tmp5_fontWeight, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 1597488, 0, 262056);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_30($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new CardSelected_2(it instanceof Card_1 ? it : null));
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_31($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new CardMessageChanged_2(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_32($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C556@30699L10,552@30375L391:CartNormalProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(389339801, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartNormalProductDetailsScreen.kt:552)');
        }
        var tmp_0 = '' + CartNormalProductDetailsScreen$lambda_1($state$delegate).w11d_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_33($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CartNormalProductDetailsScreen$lambda_9($isPickingBoxBirthday$delegate, false);
      CartNormalProductDetailsScreen$lambda_5($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_34(it) {
    return Unit_instance;
  }
  function CartNormalProductDetailsScreen$lambda$lambda_3($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CartNormalProductDetailsScreen$lambda_9($isPickingBoxBirthday$delegate, false);
      CartNormalProductDetailsScreen$lambda_5($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_35($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C580@32261L200,580@32240L533:CartNormalProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1770274016, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartNormalProductDetailsScreen.kt:580)');
        }
        sourceInformationMarkerStart($composer_0, -426277816, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CartNormalProductDetailsScreen$lambda$lambda_3($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().s11e_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_36($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new BoxSelected_2(it instanceof Box_0 ? it : null));
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_37($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new BoxMessageChanged_2(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_38($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C635@35671L10,631@35348L390:CartNormalProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-569036080, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartNormalProductDetailsScreen.kt:631)');
        }
        var tmp_0 = '' + CartNormalProductDetailsScreen$lambda_1($state$delegate).a11e_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_39($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CartNormalProductDetailsScreen$lambda_9($isPickingBoxBirthday$delegate, true);
      CartNormalProductDetailsScreen$lambda_5($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_40(it) {
    return Unit_instance;
  }
  function CartNormalProductDetailsScreen$lambda$lambda_4($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CartNormalProductDetailsScreen$lambda_9($isPickingBoxBirthday$delegate, true);
      CartNormalProductDetailsScreen$lambda_5($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_41($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C659@37228L199,659@37207L532:CartNormalProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1488710249, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartNormalProductDetailsScreen.kt:659)');
        }
        sourceInformationMarkerStart($composer_0, -426437378, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CartNormalProductDetailsScreen$lambda$lambda_4($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().x11e_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_42($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new SizeSelected_2(it));
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_43($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new ColorSelected_2(it));
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_44($viewModel, $option) {
    return function (value) {
      $viewModel.s10h().j10i(new OptionSelected_2($option.r101_1, value));
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_45($viewModel, $option) {
    return function (newValue) {
      $viewModel.s10h().j10i(new OptionSelected_2($option.r101_1, newValue));
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_46($birthdayPickerTargetOptionKey$delegate, $option, $showBirthdayPicker$delegate) {
    return function () {
      CartNormalProductDetailsScreen$lambda_7($birthdayPickerTargetOptionKey$delegate, $option.r101_1);
      CartNormalProductDetailsScreen$lambda_5($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_47($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 100) {
        $viewModel.s10h().j10i(new ProductCommentChanged_2(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_48($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C762@43091L10,758@42795L355:CartNormalProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2052721827, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartNormalProductDetailsScreen.kt:758)');
        }
        var tmp_0 = '' + CartNormalProductDetailsScreen$lambda_1($state$delegate).g11e_1.length + '/100';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda$lambda_5($state$delegate, $viewModel) {
    return function () {
      var tmp;
      if (CartNormalProductDetailsScreen$lambda_1($state$delegate).o11d_1 > 1) {
        $viewModel.s10h().j10i(new QuantityChanged_1(CartNormalProductDetailsScreen$lambda_1($state$delegate).o11d_1 - 1 | 0));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda$lambda_6($viewModel, $state$delegate) {
    return function () {
      $viewModel.s10h().j10i(new QuantityChanged_1(CartNormalProductDetailsScreen$lambda_1($state$delegate).o11d_1 + 1 | 0));
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda$lambda_7() {
    return EmptyCoroutineContext_getInstance();
  }
  function CartNormalProductDetailsScreen$lambda$lambda$slambda($isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg, resultContinuation) {
    this.x11h_1 = $isSaving$delegate;
    this.y11h_1 = $state$delegate;
    this.z11h_1 = $p;
    this.a11i_1 = $cartRepository;
    this.b11i_1 = $cartItem;
    this.c11i_1 = $savedSuccessMsg;
    this.d11i_1 = $failedToSaveMsg;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartNormalProductDetailsScreen$lambda$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartNormalProductDetailsScreen$lambda$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartNormalProductDetailsScreen$lambda$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            CartNormalProductDetailsScreen$lambda_17(this.x11h_1, true);
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.o9_1 = 3;
            var tmp0_safe_receiver = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).v11d_1;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lyz_1;
            var tmp_0 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
            var tmp2_safe_receiver = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).z11d_1;
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.wyz_1;
            var tmp_1 = tmp_0 + (tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs);
            var sum = 0;
            var _iterator__ex2g4s = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).f11e_1.y2().t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              var tmp_2 = sum;
              var tmp0_elvis_lhs = element.q100_1;
              sum = tmp_2 + (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
            }

            var extraOriginalPrice = tmp_1 + sum;
            var tmp4_safe_receiver = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).v11d_1;
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.lyz_1;
            var tmp_3 = tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs;
            var tmp6_safe_receiver = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).z11d_1;
            var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.wyz_1;
            var tmp_4 = tmp_3 + (tmp7_elvis_lhs == null ? 0.0 : tmp7_elvis_lhs);
            var sum_0 = 0;
            var _iterator__ex2g4s_0 = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).f11e_1.y2().t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              var tmp_5 = sum_0;
              var tmp_6;
              var tmp0_elvis_lhs_0 = element_0.r100_1;
              if ((tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0) > 0.0) {
                tmp_6 = ensureNotNull(element_0.r100_1);
              } else {
                var tmp1_elvis_lhs_0 = element_0.q100_1;
                tmp_6 = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
              }
              sum_0 = tmp_5 + tmp_6;
            }

            var extraDiscountedPrice = tmp_4 + sum_0;
            var tmp8_elvis_lhs = this.z11h_1.szt_1;
            var finalPrice = (tmp8_elvis_lhs == null ? 0.0 : tmp8_elvis_lhs) + extraOriginalPrice;
            var tmp_7;
            var tmp9_elvis_lhs = this.z11h_1.tzt_1;
            if ((tmp9_elvis_lhs == null ? 0.0 : tmp9_elvis_lhs) > 0.0) {
              tmp_7 = true;
            } else {
              var tmp0 = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).f11e_1.y2();
              var tmp$ret$0;
              l$ret$1: do {
                var tmp_8;
                if (isInterface(tmp0, Collection)) {
                  tmp_8 = tmp0.r();
                } else {
                  tmp_8 = false;
                }
                if (tmp_8) {
                  tmp$ret$0 = false;
                  break l$ret$1;
                }
                var _iterator__ex2g4s_1 = tmp0.t();
                while (_iterator__ex2g4s_1.u()) {
                  var element_1 = _iterator__ex2g4s_1.v();
                  var tmp0_elvis_lhs_1 = element_1.r100_1;
                  if ((tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1) > 0.0) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                }
                tmp$ret$0 = false;
              }
               while (false);
              tmp_7 = tmp$ret$0;
            }

            var hasAnyDiscount = tmp_7;
            var tmp_9;
            if (hasAnyDiscount) {
              var tmp_10;
              var tmp10_elvis_lhs = this.z11h_1.tzt_1;
              if ((tmp10_elvis_lhs == null ? 0.0 : tmp10_elvis_lhs) > 0.0) {
                tmp_10 = ensureNotNull(this.z11h_1.tzt_1);
              } else {
                var tmp11_elvis_lhs = this.z11h_1.szt_1;
                tmp_10 = tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs;
              }
              tmp_9 = tmp_10 + extraDiscountedPrice;
            } else {
              tmp_9 = 0.0;
            }

            var finalDiscount = tmp_9;
            this.n9_1 = 2;
            var tmp16_quantity = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).o11d_1;
            var tmp17_productComment = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).g11e_1;
            var tmp18_selectedCard = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).v11d_1;
            var tmp_11;
            var tmp12_safe_receiver = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).v11d_1;
            if ((tmp12_safe_receiver == null ? null : tmp12_safe_receiver.oyz_1) === true) {
              tmp_11 = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).w11d_1;
            } else {
              tmp_11 = null;
            }

            var tmp19_cardMessage = tmp_11;
            var tmp_12;
            var tmp13_safe_receiver = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).v11d_1;
            if ((tmp13_safe_receiver == null ? null : tmp13_safe_receiver.pyz_1) === true) {
              tmp_12 = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).x11d_1;
            } else {
              tmp_12 = null;
            }

            var tmp20_cardBirthday = tmp_12;
            var tmp21_selectedBox = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).z11d_1;
            var tmp_13;
            var tmp14_safe_receiver = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).z11d_1;
            if ((tmp14_safe_receiver == null ? null : tmp14_safe_receiver.zyz_1) === true) {
              tmp_13 = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).a11e_1;
            } else {
              tmp_13 = null;
            }

            var tmp22_boxMessage = tmp_13;
            var tmp_14;
            var tmp15_safe_receiver = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).z11d_1;
            if ((tmp15_safe_receiver == null ? null : tmp15_safe_receiver.az0_1) === true) {
              tmp_14 = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).b11e_1;
            } else {
              tmp_14 = null;
            }

            var tmp23_boxBirthday = tmp_14;
            var tmp24_selectedSize = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).d11e_1;
            var tmp25_selectedColor = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).e11e_1;
            var this_0 = CartNormalProductDetailsScreen$lambda_1(this.y11h_1).f11e_1;
            var tmp_15;
            if (this_0.r()) {
              tmp_15 = null;
            } else {
              tmp_15 = this_0;
            }

            var tmp26_selectedOptions = tmp_15;
            suspendResult = this.a11i_1.dz0(this.b11i_1.jyy(VOID, VOID, VOID, VOID, VOID, VOID, finalPrice, finalDiscount, VOID, VOID, VOID, VOID, tmp16_quantity, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp18_selectedCard, tmp19_cardMessage, tmp20_cardBirthday, tmp21_selectedBox, tmp22_boxMessage, tmp23_boxBirthday, tmp24_selectedSize, tmp25_selectedColor, tmp26_selectedOptions, tmp17_productComment), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            showToast(this.c11i_1);
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 4;
            var tmp_16 = this.q9_1;
            if (tmp_16 instanceof Exception) {
              var e = this.q9_1;
              showToast(this.d11i_1);
              this.o9_1 = 6;
              this.n9_1 = 5;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 6;
            var t = this.q9_1;
            CartNormalProductDetailsScreen$lambda_17(this.x11h_1, false);
            throw t;
          case 5:
            this.o9_1 = 6;
            CartNormalProductDetailsScreen$lambda_17(this.x11h_1, false);
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(CartNormalProductDetailsScreen$lambda$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new CartNormalProductDetailsScreen$lambda$lambda$slambda(this.x11h_1, this.y11h_1, this.z11h_1, this.a11i_1, this.b11i_1, this.c11i_1, this.d11i_1, completion);
    i.e11i_1 = $this$launch;
    return i;
  };
  function CartNormalProductDetailsScreen$lambda$lambda$slambda_0($isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg, resultContinuation) {
    var i = new CartNormalProductDetailsScreen$lambda$lambda$slambda($isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CartNormalProductDetailsScreen$lambda$lambda_8($scope, $isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg) {
    return function () {
      launch($scope, VOID, VOID, CartNormalProductDetailsScreen$lambda$lambda$slambda_0($isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, $savedSuccessMsg, $failedToSaveMsg, null));
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda$lambda_9($isSaving$delegate) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:CartNormalProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1901656337, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartNormalProductDetailsScreen.kt:940)');
        }
        if (CartNormalProductDetailsScreen$lambda_16($isSaving$delegate)) {
          $composer_0.m30(1625354432);
          sourceInformation($composer_0, '941@53877L241');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          var tmp_2 = Companion_getInstance_14().m6b_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_3 = _Dp___init__impl__ms3zkb(2);
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_0, 438, 56);
          $composer_0.n30();
        } else {
          $composer_0.m30(1625718279);
          sourceInformation($composer_0, '947@54188L1002');
          var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier = null;
          var horizontalArrangement = Arrangement_getInstance().udp_1;
          var verticalAlignment = tmp0_verticalAlignment;
          var $composer_1 = $composer_0;
          if (!((1 & 1) === 0))
            modifier = Companion_instance;
          if (!((1 & 2) === 0))
            horizontalArrangement = Arrangement_getInstance().qdp_1;
          if (!((1 & 4) === 0))
            verticalAlignment = Companion_getInstance_11().t8t_1;
          var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_0 = modifier;
          var $composer_2 = $composer_1;
          if (!((0 & 2) === 0))
            modifier_0 = Companion_instance;
          var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
          var localMap = $composer_2.t31();
          var materialized = materialize($composer_2, modifier_0);
          var tmp0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_3 = $composer_2;
          var tmp_6 = $composer_3.g30();
          if (!isInterface(tmp_6, Applier)) {
            invalidApplier();
          }
          $composer_3.b31();
          if ($composer_3.h30()) {
            $composer_3.c31(tmp0);
          } else {
            $composer_3.d31();
          }
          var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
          var $composer_4 = $composer_3;
          var $composer_5 = $composer_4;
          sourceInformationMarkerStart($composer_5, 413421746, 'C951@54428L242,956@54707L39,958@54829L31,957@54783L373:CartNormalProductDetailsScreen.kt#6ni00');
          var tmp_7 = get_Save(Icons_getInstance().dxv_1);
          var tmp_8 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$8 = _Dp___init__impl__ms3zkb(20);
          var tmp_9 = size(tmp_8, tmp$ret$8);
          Icon(tmp_7, null, tmp_9, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 432, 8);
          var tmp_10 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$9 = _Dp___init__impl__ms3zkb(8);
          Spacer(width(tmp_10, tmp$ret$9), $composer_5, 6);
          var tmp0_text = stringResource(get_save(string_instance), $composer_5, 0);
          var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp2_fontSize = get_sp(16);
          var tmp3_textAlign = Companion_getInstance_15().d7v_1;
          var tmp4_lineHeight = get_sp(18);
          var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_13 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, null, tmp_11, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_12, null, tmp3_textAlign, tmp4_lineHeight, tmp_13, false, 0, 0, null, null, $composer_5, 1597440, 48, 258990);
          sourceInformationMarkerEnd($composer_5);
          $composer_3.e31();
          $composer_0.n30();
        }
        var tmp_14;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_14 = Unit_instance;
        }
        tmp = tmp_14;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_49($p, $state$delegate, $viewModel, $language, $cartRepository, $cartItem) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C822@46028L9240:CartNormalProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-655106331, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CartNormalProductDetailsScreen.kt:822)');
        }
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_start = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_end = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_top = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp4_bottom = _Dp___init__impl__ms3zkb(8);
        var tmp5_modifier = fillMaxWidth(padding_1(Companion_instance, tmp1_start, tmp3_top, tmp2_end, tmp4_bottom));
        var tmp6_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_0 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$4 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = tmp5_modifier;
        var horizontalArrangement = tmp_0.mdq(tmp$ret$4);
        var verticalAlignment = tmp6_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -836516614, 'C890@50094L24,891@50159L34,892@50240L45,893@50332L41,936@53607L11,936@53563L64,896@50445L2853,939@53799L1447,895@50399L4847:CartNormalProductDetailsScreen.kt#6ni00');
        var tmp2_elvis_lhs = $p.wzt_1;
        if ((tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) > 0) {
          $composer_5.m30(-836626417);
          sourceInformation($composer_5, '831@46524L3506');
          var tmp0_horizontalAlignment = Companion_getInstance_11().x8t_1;
          var tmp_2 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$11 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_1 = null;
          var verticalArrangement = tmp_2.mdq(tmp$ret$11);
          var horizontalAlignment = tmp0_horizontalAlignment;
          var $composer_6 = $composer_5;
          if (!((1 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((1 & 2) === 0))
            verticalArrangement = Arrangement_getInstance().sdp_1;
          if (!((1 & 4) === 0))
            horizontalAlignment = Companion_getInstance_11().w8t_1;
          var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_7 = $composer_6;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
          var localMap_0 = $composer_7.t31();
          var materialized_0 = materialize($composer_7, modifier_2);
          var tmp0_0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_8 = $composer_7;
          var tmp_3 = $composer_8.g30();
          if (!isInterface(tmp_3, Applier)) {
            invalidApplier();
          }
          $composer_8.b31();
          if ($composer_8.h30()) {
            $composer_8.c31(tmp0_0);
          } else {
            $composer_8.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_9 = $composer_8;
          var $composer_10 = $composer_9;
          sourceInformationMarkerStart($composer_10, 543026412, 'C839@47017L11,835@46761L2796,881@49639L45,882@49744L10,883@49825L11,880@49590L410:CartNormalProductDetailsScreen.kt#6ni00');
          var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
          var tmp_4 = Companion_instance;
          var tmp_5 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_10, 6).oo0_1, 0.5);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$18 = _Dp___init__impl__ms3zkb(12);
          var tmp_6 = background(tmp_4, tmp_5, RoundedCornerShape(tmp$ret$18));
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_7 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$20 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_3 = padding_2(tmp_6, tmp_7, tmp$ret$20);
          var horizontalArrangement_0 = null;
          var verticalAlignment_0 = tmp0_verticalAlignment;
          var $composer_11 = $composer_10;
          if (!((2 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((2 & 2) === 0))
            horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
          if (!((2 & 4) === 0))
            verticalAlignment_0 = Companion_getInstance_11().t8t_1;
          var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_11, 14 & 384 >> 3 | 112 & 384 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_8 = $composer_13.g30();
          if (!isInterface(tmp_8, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_1);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_15, -1796464183, 'C845@47395L290,844@47333L860,863@48594L11,858@48230L423,866@48752L266,865@48690L833:CartNormalProductDetailsScreen.kt#6ni00');
          sourceInformationMarkerStart($composer_15, -473592370, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = !!($composer_15.k31($state$delegate) | $composer_15.q31($viewModel));
          // Inline function 'kotlin.let' call
          var it = $composer_15.i31();
          var tmp_9;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = CartNormalProductDetailsScreen$lambda$lambda_5($state$delegate, $viewModel);
            $composer_15.j31(value);
            tmp_9 = value;
          } else {
            tmp_9 = it;
          }
          var tmp0_group = tmp_9;
          sourceInformationMarkerEnd($composer_15);
          var tmp_10 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$31 = _Dp___init__impl__ms3zkb(36);
          var tmp_11 = size(tmp_10, tmp$ret$31);
          IconButton(tmp0_group, tmp_11, false, null, null, null, ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().z11e_1, $composer_15, 1572912, 60);
          var tmp0_text = format(CartNormalProductDetailsScreen$lambda_1($state$delegate).o11d_1, $language);
          var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp2_fontSize = get_sp(18);
          var tmp_12 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$32 = _Dp___init__impl__ms3zkb(8);
          var tmp3_modifier = padding_2(tmp_12, tmp$ret$32);
          var tmp4_color = MaterialTheme_instance.unz($composer_15, 6).no0_1;
          var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_15 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, tmp3_modifier, tmp4_color, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_13, null, null, tmp_14, tmp_15, false, 0, 0, null, null, $composer_15, 1597488, 0, 262056);
          sourceInformationMarkerStart($composer_15, -473548970, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = !!($composer_15.q31($viewModel) | $composer_15.k31($state$delegate));
          // Inline function 'kotlin.let' call
          var it_0 = $composer_15.i31();
          var tmp_16;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = CartNormalProductDetailsScreen$lambda$lambda_6($viewModel, $state$delegate);
            $composer_15.j31(value_0);
            tmp_16 = value_0;
          } else {
            tmp_16 = it_0;
          }
          var tmp1_group = tmp_16;
          sourceInformationMarkerEnd($composer_15);
          var tmp_17 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$37 = _Dp___init__impl__ms3zkb(32);
          var tmp_18 = size(tmp_17, tmp$ret$37);
          IconButton(tmp1_group, tmp_18, false, null, null, null, ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().a11f_1, $composer_15, 1572912, 60);
          sourceInformationMarkerEnd($composer_15);
          $composer_13.e31();
          var tmp2_text = stringResource(get_bulk_discount_info(string_instance), $composer_10, 0);
          var tmp3_style = MaterialTheme_instance.jog($composer_10, 6).tof_1;
          var tmp4_color_0 = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
          var tmp5_fontSize = get_sp(10);
          var tmp6_fontWeight = Companion_getInstance_16().c7z_1;
          var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_21 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp2_text, null, tmp4_color_0, null, tmp5_fontSize, null, tmp6_fontWeight, null, tmp_19, null, null, tmp_20, tmp_21, false, 0, 0, null, tmp3_style, $composer_10, 1597440, 0, 130986);
          sourceInformationMarkerEnd($composer_10);
          $composer_8.e31();
          $composer_5.n30();
        } else {
          $composer_5.m30(-833231359);
          $composer_5.n30();
        }
        // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
        var getContext = null;
        var $composer_16 = $composer_5;
        if (!((1 & 1) === 0)) {
          getContext = CartNormalProductDetailsScreen$lambda$lambda_7;
        }
        var composer = $composer_16;
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_1 = $composer_16.i31();
        var tmp_22;
        if (false || it_1 === Companion_getInstance().f30_1) {
          var value_1 = createCompositionCoroutineScope(getContext(), composer);
          $composer_16.j31(value_1);
          tmp_22 = value_1;
        } else {
          tmp_22 = it_1;
        }
        var scope = tmp_22;
        sourceInformationMarkerStart($composer_5, -26875101, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_2 = $composer_5.i31();
        var tmp_23;
        if (false || it_2 === Companion_getInstance().f30_1) {
          var value_2 = mutableStateOf(false);
          $composer_5.j31(value_2);
          tmp_23 = value_2;
        } else {
          tmp_23 = it_2;
        }
        var tmp0_group_0 = tmp_23;
        sourceInformationMarkerEnd($composer_5);
        var isSaving$delegate = tmp0_group_0;
        var savedSuccessMsg = stringResource(get_saved_successfully(string_instance), $composer_5, 0);
        var failedToSaveMsg = stringResource(get_failed_to_save(string_instance), $composer_5, 0);
        var tmp_24 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$47 = _Dp___init__impl__ms3zkb(56);
        var tmp3_modifier_0 = heightIn(tmp_24, tmp$ret$47);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$48 = _Dp___init__impl__ms3zkb(16);
        var tmp4_shape = RoundedCornerShape(tmp$ret$48);
        var tmp_25 = ButtonDefaults_getInstance();
        var tmp_26 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
        var tmp_27 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_28 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp5_colors = tmp_25.ao9(tmp_26, tmp_27, tmp_28, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
        var tmp6_enabled = !CartNormalProductDetailsScreen$lambda_16(isSaving$delegate);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_29 = _Dp___init__impl__ms3zkb(4);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$50 = _Dp___init__impl__ms3zkb(4);
        var tmp7_contentPadding = PaddingValues_0(tmp_29, tmp$ret$50);
        sourceInformationMarkerStart($composer_5, -26863130, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = !!(!!(!!(!!(!!(!!($composer_5.q31(scope) | $composer_5.k31($state$delegate)) | $composer_5.q31($p)) | $composer_5.q31($cartRepository)) | $composer_5.q31($cartItem)) | $composer_5.k31(savedSuccessMsg)) | $composer_5.k31(failedToSaveMsg));
        // Inline function 'kotlin.let' call
        var it_3 = $composer_5.i31();
        var tmp_30;
        if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
          var value_3 = CartNormalProductDetailsScreen$lambda$lambda_8(scope, isSaving$delegate, $state$delegate, $p, $cartRepository, $cartItem, savedSuccessMsg, failedToSaveMsg);
          $composer_5.j31(value_3);
          tmp_30 = value_3;
        } else {
          tmp_30 = it_3;
        }
        var tmp1_group_0 = tmp_30;
        sourceInformationMarkerEnd($composer_5);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1901656337, true, CartNormalProductDetailsScreen$lambda$lambda_9(isSaving$delegate), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_17 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_17.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_17.i31();
        var tmp_31;
        if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
          var value_4 = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_17.j31(value_4);
          tmp_31 = value_4;
        } else {
          tmp_31 = it_4;
        }
        var tmp$ret$55 = tmp_31;
        Button(tmp1_group_0, tmp3_modifier_0, tmp6_enabled, tmp4_shape, tmp5_colors, null, null, tmp7_contentPadding, null, tmp$ret$55, $composer_5, 817889280, 352);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_32;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_32 = Unit_instance;
        }
        tmp = tmp_32;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_50($showMediaDialog$delegate) {
    return function () {
      CartNormalProductDetailsScreen$lambda_13($showMediaDialog$delegate, false);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_51($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate) {
    return function () {
      CartNormalProductDetailsScreen$lambda_5($showBirthdayPicker$delegate, false);
      CartNormalProductDetailsScreen$lambda_7($birthdayPickerTargetOptionKey$delegate, null);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda$lambda_10($birthdayPickerState, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $viewModel, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      var tmp0_safe_receiver = $birthdayPickerState.np1();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var date = toLocalDateTime(Companion_getInstance_19().kf(tmp0_safe_receiver), Companion_getInstance_20().yno_1).xn9_1.toString();
        if (!(CartNormalProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate) == null)) {
          var key = ensureNotNull(CartNormalProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate));
          var selectedValue = CartNormalProductDetailsScreen$lambda_1($state$delegate).f11e_1.w2(key);
          if (!(selectedValue == null)) {
            $viewModel.s10h().j10i(new OptionSelected_2(key, selectedValue.k101(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, date)));
          }
        } else if (CartNormalProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate)) {
          $viewModel.s10h().j10i(new BoxBirthdayChanged_2(date));
        } else {
          $viewModel.s10h().j10i(new CardBirthdayChanged_2(date));
        }
      }
      CartNormalProductDetailsScreen$lambda_5($showBirthdayPicker$delegate, false);
      CartNormalProductDetailsScreen$lambda_7($birthdayPickerTargetOptionKey$delegate, null);
      CartNormalProductDetailsScreen$lambda_9($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_52($birthdayPickerState, $state$delegate, $viewModel, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C992@56090L1614,992@56069L1728:CartNormalProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1004135352, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen.<anonymous>.<anonymous>.<anonymous> (CartNormalProductDetailsScreen.kt:992)');
        }
        sourceInformationMarkerStart($composer_0, -1393565210, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.k31($birthdayPickerState) | $composer_0.k31($state$delegate)) | $composer_0.q31($viewModel));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CartNormalProductDetailsScreen$lambda$lambda_10($birthdayPickerState, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $viewModel, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().b11f_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda$lambda_11($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function () {
      CartNormalProductDetailsScreen$lambda_5($showBirthdayPicker$delegate, false);
      CartNormalProductDetailsScreen$lambda_7($birthdayPickerTargetOptionKey$delegate, null);
      CartNormalProductDetailsScreen$lambda_9($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_53($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1022@57904L205,1022@57883L323:CartNormalProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(834516410, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen.<anonymous>.<anonymous>.<anonymous> (CartNormalProductDetailsScreen.kt:1022)');
        }
        sourceInformationMarkerStart($composer_0, -1188612633, 'CC(remember):CartNormalProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CartNormalProductDetailsScreen$lambda$lambda_11($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$CartNormalProductDetailsScreenKt_getInstance().c11f_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_54($birthdayPickerState) {
    return function ($this$DatePickerDialog, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1031@58269L39:CartNormalProductDetailsScreen.kt#6ni00');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-991579569, $changed, -1, 'client.fstech.hadaya.presentation.cart.details.CartNormalProductDetailsScreen.<anonymous>.<anonymous>.<anonymous> (CartNormalProductDetailsScreen.kt:1031)');
        }
        DatePicker($birthdayPickerState, null, null, null, null, null, false, null, $composer_0, 0, 254);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CartNormalProductDetailsScreen$lambda_55($cartItem, $onBack, $onNavigateToAuth, $$changed) {
    return function ($composer, $force) {
      CartNormalProductDetailsScreen($cartItem, $onBack, $onNavigateToAuth, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_cart_details_CartNormalProductDetailsViewModel$stable;
  function CartNormalProductDetailsViewModel$observeLanguage$slambda$slambda$lambda($language) {
    return function ($this$updateState) {
      return $this$updateState.m11d(VOID, VOID, VOID, $language);
    };
  }
  function CartNormalProductDetailsViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation) {
    this.n11i_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartNormalProductDetailsViewModel$observeLanguage$slambda$slambda).pyo = function (language, $completion) {
    var tmp = this.um9(language, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartNormalProductDetailsViewModel$observeLanguage$slambda$slambda).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartNormalProductDetailsViewModel$observeLanguage$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.n11i_1.x10k(CartNormalProductDetailsViewModel$observeLanguage$slambda$slambda$lambda(this.o11i_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CartNormalProductDetailsViewModel$observeLanguage$slambda$slambda).um9 = function (language, completion) {
    var i = new CartNormalProductDetailsViewModel$observeLanguage$slambda$slambda(this.n11i_1, completion);
    i.o11i_1 = language;
    return i;
  };
  function CartNormalProductDetailsViewModel$observeLanguage$slambda$slambda_0(this$0, resultContinuation) {
    var i = new CartNormalProductDetailsViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (language, $completion) {
      return i.pyo(language, $completion);
    }, 1);
  }
  function observeLanguage_2($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, CartNormalProductDetailsViewModel$observeLanguage$slambda_0($this, null));
  }
  function CartNormalProductDetailsViewModel$observeLanguage$slambda(this$0, resultContinuation) {
    this.x11i_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CartNormalProductDetailsViewModel$observeLanguage$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CartNormalProductDetailsViewModel$observeLanguage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CartNormalProductDetailsViewModel$observeLanguage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.x11i_1.d11j_1.y103();
            var action = CartNormalProductDetailsViewModel$observeLanguage$slambda$slambda_0(this.x11i_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CartNormalProductDetailsViewModel$observeLanguage$slambda).q24 = function ($this$launch, completion) {
    var i = new CartNormalProductDetailsViewModel$observeLanguage$slambda(this.x11i_1, completion);
    i.y11i_1 = $this$launch;
    return i;
  };
  function CartNormalProductDetailsViewModel$observeLanguage$slambda_0(this$0, resultContinuation) {
    var i = new CartNormalProductDetailsViewModel$observeLanguage$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CartNormalProductDetailsViewModel$handleIntent$lambda($intent) {
    return function ($this$updateState) {
      return $this$updateState.m11d($intent.e11j_1);
    };
  }
  function CartNormalProductDetailsViewModel(getLanguageUseCase) {
    BaseMviViewModel.call(this, new CartNormalProductDetailsState());
    this.d11j_1 = getLanguageUseCase;
    observeLanguage_2(this);
  }
  protoOf(CartNormalProductDetailsViewModel).f11j = function (intent, $completion) {
    if (intent instanceof LoadItem_1) {
      this.x10k(CartNormalProductDetailsViewModel$handleIntent$lambda(intent));
    } else {
      noWhenBranchMatchedException();
    }
    return Unit_instance;
  };
  protoOf(CartNormalProductDetailsViewModel).f10l = function (intent, $completion) {
    return this.f11j(isInterface(intent, CartNormalProductDetailsIntent) ? intent : THROW_CCE(), $completion);
  };
  var client_fstech_hadaya_presentation_checkout_CheckoutState$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_LoadData$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_Retry$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_ToggleShippingType$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_SelectFriend$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_UpdateMyAddress$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_UpdateMyPhone$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_UpdateMyFirstName$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_UpdateMyLastName$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_UpdateMyGovernorate$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_SelectPaymentMethod$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_PlaceOrder$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_RetryShippingFetch$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_AddFriend$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_ToggleAddFriendDialog$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_UpdateCouponCode$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutIntent_ApplyCoupon$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutSideEffect_ShowError$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutSideEffect_OrderPlaced$stable;
  var client_fstech_hadaya_presentation_checkout_CheckoutSideEffect_FriendAdded$stable;
  function CheckoutState(isLoading, isError, error, friends, selectedFriend, isShippingToFriend, myAddress, myPhone, myFirstName, myLastName, myGovernorate, canChangePhone, shippingCost, isShippingLoading, shippingError, cartItems, paymentMethod, language, isPlacingOrder, isAddingFriend, showAddFriendDialog, couponCode, appliedCoupon, couponError) {
    isLoading = isLoading === VOID ? false : isLoading;
    isError = isError === VOID ? false : isError;
    error = error === VOID ? null : error;
    friends = friends === VOID ? emptyList() : friends;
    selectedFriend = selectedFriend === VOID ? null : selectedFriend;
    isShippingToFriend = isShippingToFriend === VOID ? false : isShippingToFriend;
    myAddress = myAddress === VOID ? '' : myAddress;
    myPhone = myPhone === VOID ? '' : myPhone;
    myFirstName = myFirstName === VOID ? '' : myFirstName;
    myLastName = myLastName === VOID ? '' : myLastName;
    myGovernorate = myGovernorate === VOID ? 'Other' : myGovernorate;
    canChangePhone = canChangePhone === VOID ? true : canChangePhone;
    shippingCost = shippingCost === VOID ? 0.0 : shippingCost;
    isShippingLoading = isShippingLoading === VOID ? false : isShippingLoading;
    shippingError = shippingError === VOID ? null : shippingError;
    cartItems = cartItems === VOID ? emptyList() : cartItems;
    paymentMethod = paymentMethod === VOID ? PaymentMethod_CASH_ON_DELIVERY_getInstance() : paymentMethod;
    language = language === VOID ? 'en' : language;
    isPlacingOrder = isPlacingOrder === VOID ? false : isPlacingOrder;
    isAddingFriend = isAddingFriend === VOID ? false : isAddingFriend;
    showAddFriendDialog = showAddFriendDialog === VOID ? false : showAddFriendDialog;
    couponCode = couponCode === VOID ? '' : couponCode;
    appliedCoupon = appliedCoupon === VOID ? null : appliedCoupon;
    couponError = couponError === VOID ? null : couponError;
    this.g11j_1 = isLoading;
    this.h11j_1 = isError;
    this.i11j_1 = error;
    this.j11j_1 = friends;
    this.k11j_1 = selectedFriend;
    this.l11j_1 = isShippingToFriend;
    this.m11j_1 = myAddress;
    this.n11j_1 = myPhone;
    this.o11j_1 = myFirstName;
    this.p11j_1 = myLastName;
    this.q11j_1 = myGovernorate;
    this.r11j_1 = canChangePhone;
    this.s11j_1 = shippingCost;
    this.t11j_1 = isShippingLoading;
    this.u11j_1 = shippingError;
    this.v11j_1 = cartItems;
    this.w11j_1 = paymentMethod;
    this.x11j_1 = language;
    this.y11j_1 = isPlacingOrder;
    this.z11j_1 = isAddingFriend;
    this.a11k_1 = showAddFriendDialog;
    this.b11k_1 = couponCode;
    this.c11k_1 = appliedCoupon;
    this.d11k_1 = couponError;
  }
  protoOf(CheckoutState).e11k = function (isLoading, isError, error, friends, selectedFriend, isShippingToFriend, myAddress, myPhone, myFirstName, myLastName, myGovernorate, canChangePhone, shippingCost, isShippingLoading, shippingError, cartItems, paymentMethod, language, isPlacingOrder, isAddingFriend, showAddFriendDialog, couponCode, appliedCoupon, couponError) {
    return new CheckoutState(isLoading, isError, error, friends, selectedFriend, isShippingToFriend, myAddress, myPhone, myFirstName, myLastName, myGovernorate, canChangePhone, shippingCost, isShippingLoading, shippingError, cartItems, paymentMethod, language, isPlacingOrder, isAddingFriend, showAddFriendDialog, couponCode, appliedCoupon, couponError);
  };
  protoOf(CheckoutState).f11k = function (isLoading, isError, error, friends, selectedFriend, isShippingToFriend, myAddress, myPhone, myFirstName, myLastName, myGovernorate, canChangePhone, shippingCost, isShippingLoading, shippingError, cartItems, paymentMethod, language, isPlacingOrder, isAddingFriend, showAddFriendDialog, couponCode, appliedCoupon, couponError, $super) {
    isLoading = isLoading === VOID ? this.g11j_1 : isLoading;
    isError = isError === VOID ? this.h11j_1 : isError;
    error = error === VOID ? this.i11j_1 : error;
    friends = friends === VOID ? this.j11j_1 : friends;
    selectedFriend = selectedFriend === VOID ? this.k11j_1 : selectedFriend;
    isShippingToFriend = isShippingToFriend === VOID ? this.l11j_1 : isShippingToFriend;
    myAddress = myAddress === VOID ? this.m11j_1 : myAddress;
    myPhone = myPhone === VOID ? this.n11j_1 : myPhone;
    myFirstName = myFirstName === VOID ? this.o11j_1 : myFirstName;
    myLastName = myLastName === VOID ? this.p11j_1 : myLastName;
    myGovernorate = myGovernorate === VOID ? this.q11j_1 : myGovernorate;
    canChangePhone = canChangePhone === VOID ? this.r11j_1 : canChangePhone;
    shippingCost = shippingCost === VOID ? this.s11j_1 : shippingCost;
    isShippingLoading = isShippingLoading === VOID ? this.t11j_1 : isShippingLoading;
    shippingError = shippingError === VOID ? this.u11j_1 : shippingError;
    cartItems = cartItems === VOID ? this.v11j_1 : cartItems;
    paymentMethod = paymentMethod === VOID ? this.w11j_1 : paymentMethod;
    language = language === VOID ? this.x11j_1 : language;
    isPlacingOrder = isPlacingOrder === VOID ? this.y11j_1 : isPlacingOrder;
    isAddingFriend = isAddingFriend === VOID ? this.z11j_1 : isAddingFriend;
    showAddFriendDialog = showAddFriendDialog === VOID ? this.a11k_1 : showAddFriendDialog;
    couponCode = couponCode === VOID ? this.b11k_1 : couponCode;
    appliedCoupon = appliedCoupon === VOID ? this.c11k_1 : appliedCoupon;
    couponError = couponError === VOID ? this.d11k_1 : couponError;
    return $super === VOID ? this.e11k(isLoading, isError, error, friends, selectedFriend, isShippingToFriend, myAddress, myPhone, myFirstName, myLastName, myGovernorate, canChangePhone, shippingCost, isShippingLoading, shippingError, cartItems, paymentMethod, language, isPlacingOrder, isAddingFriend, showAddFriendDialog, couponCode, appliedCoupon, couponError) : $super.e11k.call(this, isLoading, isError, error, friends, selectedFriend, isShippingToFriend, myAddress, myPhone, myFirstName, myLastName, myGovernorate, canChangePhone, shippingCost, isShippingLoading, shippingError, cartItems, paymentMethod, language, isPlacingOrder, isAddingFriend, showAddFriendDialog, couponCode, appliedCoupon, couponError);
  };
  protoOf(CheckoutState).toString = function () {
    return 'CheckoutState(isLoading=' + this.g11j_1 + ', isError=' + this.h11j_1 + ', error=' + toString_0(this.i11j_1) + ', friends=' + toString(this.j11j_1) + ', selectedFriend=' + toString_0(this.k11j_1) + ', isShippingToFriend=' + this.l11j_1 + ', myAddress=' + this.m11j_1 + ', myPhone=' + this.n11j_1 + ', myFirstName=' + this.o11j_1 + ', myLastName=' + this.p11j_1 + ', myGovernorate=' + this.q11j_1 + ', canChangePhone=' + this.r11j_1 + ', shippingCost=' + this.s11j_1 + ', isShippingLoading=' + this.t11j_1 + ', shippingError=' + toString_0(this.u11j_1) + ', cartItems=' + toString(this.v11j_1) + ', paymentMethod=' + this.w11j_1.toString() + ', language=' + this.x11j_1 + ', isPlacingOrder=' + this.y11j_1 + ', isAddingFriend=' + this.z11j_1 + ', showAddFriendDialog=' + this.a11k_1 + ', couponCode=' + this.b11k_1 + ', appliedCoupon=' + toString_0(this.c11k_1) + ', couponError=' + toString_0(this.d11k_1) + ')';
  };
  protoOf(CheckoutState).hashCode = function () {
    var result = getBooleanHashCode(this.g11j_1);
    result = imul(result, 31) + getBooleanHashCode(this.h11j_1) | 0;
    result = imul(result, 31) + (this.i11j_1 == null ? 0 : hashCode(this.i11j_1)) | 0;
    result = imul(result, 31) + hashCode(this.j11j_1) | 0;
    result = imul(result, 31) + (this.k11j_1 == null ? 0 : this.k11j_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l11j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m11j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n11j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o11j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p11j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q11j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r11j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s11j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t11j_1) | 0;
    result = imul(result, 31) + (this.u11j_1 == null ? 0 : hashCode(this.u11j_1)) | 0;
    result = imul(result, 31) + hashCode(this.v11j_1) | 0;
    result = imul(result, 31) + this.w11j_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.x11j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y11j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z11j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a11k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b11k_1) | 0;
    result = imul(result, 31) + (this.c11k_1 == null ? 0 : this.c11k_1.hashCode()) | 0;
    result = imul(result, 31) + (this.d11k_1 == null ? 0 : hashCode(this.d11k_1)) | 0;
    return result;
  };
  protoOf(CheckoutState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CheckoutState))
      return false;
    if (!(this.g11j_1 === other.g11j_1))
      return false;
    if (!(this.h11j_1 === other.h11j_1))
      return false;
    if (!equals(this.i11j_1, other.i11j_1))
      return false;
    if (!equals(this.j11j_1, other.j11j_1))
      return false;
    if (!equals(this.k11j_1, other.k11j_1))
      return false;
    if (!(this.l11j_1 === other.l11j_1))
      return false;
    if (!(this.m11j_1 === other.m11j_1))
      return false;
    if (!(this.n11j_1 === other.n11j_1))
      return false;
    if (!(this.o11j_1 === other.o11j_1))
      return false;
    if (!(this.p11j_1 === other.p11j_1))
      return false;
    if (!(this.q11j_1 === other.q11j_1))
      return false;
    if (!(this.r11j_1 === other.r11j_1))
      return false;
    if (!equals(this.s11j_1, other.s11j_1))
      return false;
    if (!(this.t11j_1 === other.t11j_1))
      return false;
    if (!equals(this.u11j_1, other.u11j_1))
      return false;
    if (!equals(this.v11j_1, other.v11j_1))
      return false;
    if (!this.w11j_1.equals(other.w11j_1))
      return false;
    if (!(this.x11j_1 === other.x11j_1))
      return false;
    if (!(this.y11j_1 === other.y11j_1))
      return false;
    if (!(this.z11j_1 === other.z11j_1))
      return false;
    if (!(this.a11k_1 === other.a11k_1))
      return false;
    if (!(this.b11k_1 === other.b11k_1))
      return false;
    if (!equals(this.c11k_1, other.c11k_1))
      return false;
    if (!equals(this.d11k_1, other.d11k_1))
      return false;
    return true;
  };
  function LoadData() {
  }
  protoOf(LoadData).toString = function () {
    return 'LoadData';
  };
  protoOf(LoadData).hashCode = function () {
    return -1701773920;
  };
  protoOf(LoadData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadData))
      return false;
    return true;
  };
  var LoadData_instance;
  function LoadData_getInstance() {
    return LoadData_instance;
  }
  function Retry() {
  }
  protoOf(Retry).toString = function () {
    return 'Retry';
  };
  protoOf(Retry).hashCode = function () {
    return -1754533704;
  };
  protoOf(Retry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Retry))
      return false;
    return true;
  };
  var Retry_instance;
  function Retry_getInstance() {
    return Retry_instance;
  }
  function ToggleShippingType() {
  }
  function SelectFriend() {
  }
  function UpdateMyAddress(address) {
    this.g11k_1 = address;
  }
  protoOf(UpdateMyAddress).toString = function () {
    return 'UpdateMyAddress(address=' + this.g11k_1 + ')';
  };
  protoOf(UpdateMyAddress).hashCode = function () {
    return getStringHashCode(this.g11k_1);
  };
  protoOf(UpdateMyAddress).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateMyAddress))
      return false;
    if (!(this.g11k_1 === other.g11k_1))
      return false;
    return true;
  };
  function UpdateMyPhone(phone) {
    this.h11k_1 = phone;
  }
  protoOf(UpdateMyPhone).toString = function () {
    return 'UpdateMyPhone(phone=' + this.h11k_1 + ')';
  };
  protoOf(UpdateMyPhone).hashCode = function () {
    return getStringHashCode(this.h11k_1);
  };
  protoOf(UpdateMyPhone).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateMyPhone))
      return false;
    if (!(this.h11k_1 === other.h11k_1))
      return false;
    return true;
  };
  function UpdateMyFirstName(firstName) {
    this.i11k_1 = firstName;
  }
  protoOf(UpdateMyFirstName).toString = function () {
    return 'UpdateMyFirstName(firstName=' + this.i11k_1 + ')';
  };
  protoOf(UpdateMyFirstName).hashCode = function () {
    return getStringHashCode(this.i11k_1);
  };
  protoOf(UpdateMyFirstName).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateMyFirstName))
      return false;
    if (!(this.i11k_1 === other.i11k_1))
      return false;
    return true;
  };
  function UpdateMyLastName(lastName) {
    this.j11k_1 = lastName;
  }
  protoOf(UpdateMyLastName).toString = function () {
    return 'UpdateMyLastName(lastName=' + this.j11k_1 + ')';
  };
  protoOf(UpdateMyLastName).hashCode = function () {
    return getStringHashCode(this.j11k_1);
  };
  protoOf(UpdateMyLastName).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateMyLastName))
      return false;
    if (!(this.j11k_1 === other.j11k_1))
      return false;
    return true;
  };
  function UpdateMyGovernorate(governorate) {
    this.k11k_1 = governorate;
  }
  protoOf(UpdateMyGovernorate).toString = function () {
    return 'UpdateMyGovernorate(governorate=' + this.k11k_1 + ')';
  };
  protoOf(UpdateMyGovernorate).hashCode = function () {
    return getStringHashCode(this.k11k_1);
  };
  protoOf(UpdateMyGovernorate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateMyGovernorate))
      return false;
    if (!(this.k11k_1 === other.k11k_1))
      return false;
    return true;
  };
  function SelectPaymentMethod(method) {
    this.l11k_1 = method;
  }
  protoOf(SelectPaymentMethod).toString = function () {
    return 'SelectPaymentMethod(method=' + this.l11k_1.toString() + ')';
  };
  protoOf(SelectPaymentMethod).hashCode = function () {
    return this.l11k_1.hashCode();
  };
  protoOf(SelectPaymentMethod).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SelectPaymentMethod))
      return false;
    if (!this.l11k_1.equals(other.l11k_1))
      return false;
    return true;
  };
  function PlaceOrder() {
  }
  protoOf(PlaceOrder).toString = function () {
    return 'PlaceOrder';
  };
  protoOf(PlaceOrder).hashCode = function () {
    return 1359726199;
  };
  protoOf(PlaceOrder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaceOrder))
      return false;
    return true;
  };
  var PlaceOrder_instance;
  function PlaceOrder_getInstance() {
    return PlaceOrder_instance;
  }
  function RetryShippingFetch() {
  }
  protoOf(RetryShippingFetch).toString = function () {
    return 'RetryShippingFetch';
  };
  protoOf(RetryShippingFetch).hashCode = function () {
    return -1585528876;
  };
  protoOf(RetryShippingFetch).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RetryShippingFetch))
      return false;
    return true;
  };
  var RetryShippingFetch_instance;
  function RetryShippingFetch_getInstance() {
    return RetryShippingFetch_instance;
  }
  function AddFriend() {
  }
  function ToggleAddFriendDialog() {
  }
  function UpdateCouponCode(code) {
    this.m11k_1 = code;
  }
  protoOf(UpdateCouponCode).toString = function () {
    return 'UpdateCouponCode(code=' + this.m11k_1 + ')';
  };
  protoOf(UpdateCouponCode).hashCode = function () {
    return getStringHashCode(this.m11k_1);
  };
  protoOf(UpdateCouponCode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateCouponCode))
      return false;
    if (!(this.m11k_1 === other.m11k_1))
      return false;
    return true;
  };
  function ApplyCoupon() {
  }
  protoOf(ApplyCoupon).toString = function () {
    return 'ApplyCoupon';
  };
  protoOf(ApplyCoupon).hashCode = function () {
    return 1283030852;
  };
  protoOf(ApplyCoupon).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ApplyCoupon))
      return false;
    return true;
  };
  var ApplyCoupon_instance;
  function ApplyCoupon_getInstance() {
    return ApplyCoupon_instance;
  }
  function CheckoutIntent() {
  }
  function ShowError_2(message) {
    this.n11k_1 = message;
  }
  protoOf(ShowError_2).toString = function () {
    return 'ShowError(message=' + toString(this.n11k_1) + ')';
  };
  protoOf(ShowError_2).hashCode = function () {
    return hashCode(this.n11k_1);
  };
  protoOf(ShowError_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowError_2))
      return false;
    if (!equals(this.n11k_1, other.n11k_1))
      return false;
    return true;
  };
  function OrderPlaced(order) {
    this.o11k_1 = order;
  }
  protoOf(OrderPlaced).toString = function () {
    return 'OrderPlaced(order=' + this.o11k_1.toString() + ')';
  };
  protoOf(OrderPlaced).hashCode = function () {
    return this.o11k_1.hashCode();
  };
  protoOf(OrderPlaced).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrderPlaced))
      return false;
    if (!this.o11k_1.equals(other.o11k_1))
      return false;
    return true;
  };
  function FriendAdded() {
  }
  protoOf(FriendAdded).toString = function () {
    return 'FriendAdded';
  };
  protoOf(FriendAdded).hashCode = function () {
    return 633345854;
  };
  protoOf(FriendAdded).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FriendAdded))
      return false;
    return true;
  };
  var FriendAdded_instance;
  function FriendAdded_getInstance() {
    return FriendAdded_instance;
  }
  function CheckoutSideEffect() {
  }
  function CheckoutScreen(onBack, onOrderSuccess, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-2018638895);
    sourceInformation($composer_0, 'C(CheckoutScreen)68@3313L15,69@3372L16,70@3417L32,71@3477L41,72@3535L24,74@3586L67,74@3565L88,78@3685L568,78@3659L594,92@4278L27,95@4414L8697:CheckoutScreen.kt#xe8pgy');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onOrderSuccess) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2018638895, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.CheckoutScreen (CheckoutScreen.kt:67)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(CheckoutViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, 1413247025, 'CC(remember):CheckoutScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance().f30_1) {
        var value = new SnackbarHostState();
        this_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp0_group;
      var verifiedPhoneMsg = stringResource(get_verified_phone(string_instance), $composer_0, 0);
      // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
      var getContext = null;
      var $composer_2 = $composer_0;
      if (!((1 & 1) === 0)) {
        getContext = CheckoutScreen$lambda_0;
      }
      var composer = $composer_2;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_0 = $composer_2.i31();
      var tmp_2;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = createCompositionCoroutineScope(getContext(), composer);
        $composer_2.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var scope_0 = tmp_2;
      sourceInformationMarkerStart($composer_0, 1413252468, 'CC(remember):CheckoutScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_0.i31();
      var tmp_3;
      if (invalid || it_1 === Companion_getInstance().f30_1) {
        var value_1 = CheckoutScreen$slambda_0(viewModel, null);
        tmp0_0.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp1_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(Unit_instance, tmp1_group, $composer_0, 6);
      sourceInformationMarkerStart($composer_0, 1413256137, 'CC(remember):CheckoutScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.q31(viewModel) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_1.i31();
      var tmp_4;
      if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = CheckoutScreen$slambda_2(viewModel, snackbarHostState, onOrderSuccess, null);
        tmp0_1.j31(value_2);
        tmp_4 = value_2;
      } else {
        tmp_4 = it_2;
      }
      var tmp2_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp2_group, $composer_0, 0);
      var adaptiveInfo = currentWindowAdaptiveInfo(false, $composer_0, 0, 1);
      var isDesktop = adaptiveInfo.bxm_1.sxl().equals(Companion_getInstance_21().vxl_1);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = fillMaxSize(Companion_instance);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_3 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_4 = $composer_3;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_4, 0).hashCode();
      var localMap = $composer_4.t31();
      var materialized = materialize($composer_4, modifier_0);
      var tmp0_2 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_5 = $composer_4;
      var tmp_5 = $composer_5.g30();
      if (!isInterface(tmp_5, Applier)) {
        invalidApplier();
      }
      $composer_5.b31();
      if ($composer_5.h30()) {
        $composer_5.c31(tmp0_2);
      } else {
        $composer_5.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_5);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_6 = $composer_5;
      var $composer_7 = $composer_6;
      sourceInformationMarkerStart($composer_7, -1951143158, 'C96@4463L8504,263@12977L128:CheckoutScreen.kt#xe8pgy');
      var tmp_6 = BoxScopeInstance_instance.udr(fillMaxSize(Companion_instance), Companion_getInstance_11().l8t_1);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$25 = _Dp___init__impl__ms3zkb(1400);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = widthIn(tmp_6, VOID, tmp$ret$25);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_8 = $composer_7;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_8, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_9 = $composer_8;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_9, 0).hashCode();
      var localMap_0 = $composer_9.t31();
      var materialized_0 = materialize($composer_9, modifier_2);
      var tmp0_3 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_10 = $composer_9;
      var tmp_7 = $composer_10.g30();
      if (!isInterface(tmp_7, Applier)) {
        invalidApplier();
      }
      $composer_10.b31();
      if ($composer_10.h30()) {
        $composer_10.c31(tmp0_3);
      } else {
        $composer_10.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_10);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_11 = $composer_10;
      var $composer_12 = $composer_11;
      sourceInformationMarkerStart($composer_12, 1288390418, 'C112@5217L11,112@5170L70,104@4831L294,97@4569L742:CheckoutScreen.kt#xe8pgy');
      var tmp_8 = TopAppBarDefaults_getInstance();
      var tmp_9 = MaterialTheme_instance.unz($composer_12, 6).ko0_1;
      var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_13 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp0_colors = tmp_8.wnz(tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_12, 1572864, 62);
      var tmp1_windowInsets = WindowInsets(0, 0, 0, 0);
      var tmp_14 = ComposableSingletons$CheckoutScreenKt_getInstance().p11k_1;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(1418893895, true, CheckoutScreen$lambda_1(onBack), $composer_12, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_13 = $composer_12;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_13.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_3 = $composer_13.i31();
      var tmp_15;
      if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_13.j31(value_3);
        tmp_15 = value_3;
      } else {
        tmp_15 = it_3;
      }
      var tmp_16 = tmp_15;
      var tmp_17 = _Dp___init__impl__ms3zkb(0.0);
      TopAppBar(tmp_14, null, tmp_16, null, tmp_17, tmp1_windowInsets, tmp0_colors, null, $composer_12, 390, 154);
      if (CheckoutScreen$lambda(state$delegate).g11j_1) {
        $composer_12.m30(1288906257);
        sourceInformation($composer_12, '117@5364L132');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = fillMaxSize(Companion_instance);
        var contentAlignment_0 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_0 = false;
        var $composer_14 = $composer_12;
        if (!((4 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_15 = $composer_14;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_15, 0).hashCode();
        var localMap_1 = $composer_15.t31();
        var materialized_1 = materialize($composer_15, modifier_4);
        var tmp0_4 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_16 = $composer_15;
        var tmp_18 = $composer_16.g30();
        if (!isInterface(tmp_18, Applier)) {
          invalidApplier();
        }
        $composer_16.b31();
        if ($composer_16.h30()) {
          $composer_16.c31(tmp0_4);
        } else {
          $composer_16.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_16);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_17 = $composer_16;
        var $composer_18 = $composer_17;
        sourceInformationMarkerStart($composer_18, -1828507430, 'C118@5451L27:CheckoutScreen.kt#xe8pgy');
        var tmp_19 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_20 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_21 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_22 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_19, tmp_20, tmp_21, tmp_22, _Dp___init__impl__ms3zkb(0.0), $composer_18, 0, 63);
        sourceInformationMarkerEnd($composer_18);
        $composer_16.e31();
        $composer_12.n30();
      } else if (CheckoutScreen$lambda(state$delegate).h11j_1) {
        $composer_12.m30(1289115476);
        sourceInformation($composer_12, '121@5553L833');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_5 = fillMaxSize(Companion_instance);
        var contentAlignment_1 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_1 = false;
        var $composer_19 = $composer_12;
        if (!((4 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_1 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_1 = false;
        var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_20 = $composer_19;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_20, 0).hashCode();
        var localMap_2 = $composer_20.t31();
        var materialized_2 = materialize($composer_20, modifier_6);
        var tmp0_5 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_21 = $composer_20;
        var tmp_23 = $composer_21.g30();
        if (!isInterface(tmp_23, Applier)) {
          invalidApplier();
        }
        $composer_21.b31();
        if ($composer_21.h30()) {
          $composer_21.c31(tmp0_5);
        } else {
          $composer_21.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_21);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_22 = $composer_21;
        var $composer_23 = $composer_22;
        sourceInformationMarkerStart($composer_23, 440096564, 'C122@5640L728:CheckoutScreen.kt#xe8pgy');
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_7 = null;
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = Companion_getInstance_11().x8t_1;
        var $composer_24 = $composer_23;
        if (!((3 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((3 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((3 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_3 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_24, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_25 = $composer_24;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_25, 0).hashCode();
        var localMap_3 = $composer_25.t31();
        var materialized_3 = materialize($composer_25, modifier_8);
        var tmp0_6 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_26 = $composer_25;
        var tmp_24 = $composer_26.g30();
        if (!isInterface(tmp_24, Applier)) {
          invalidApplier();
        }
        $composer_26.b31();
        if ($composer_26.h30()) {
          $composer_26.c31(tmp0_6);
        } else {
          $composer_26.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_26);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_27 = $composer_26;
        var $composer_28 = $composer_27;
        sourceInformationMarkerStart($composer_28, -248822903, 'C126@5916L10,123@5725L390,130@6140L41,131@6223L52,131@6206L140:CheckoutScreen.kt#xe8pgy');
        var tmp0_safe_receiver = CheckoutScreen$lambda(state$delegate).i11j_1;
        var tmp_25;
        if (tmp0_safe_receiver == null) {
          $composer_28.m30(-248795222);
          $composer_28.n30();
          tmp_25 = null;
        } else {
          $composer_28.m30(-700762313);
          sourceInformation($composer_28, '124@5772L10');
          var tmp0_group_0 = tmp0_safe_receiver.s11k($composer_28, 0);
          $composer_28.n30();
          tmp_25 = tmp0_group_0;
        }
        var tmp1_elvis_lhs = tmp_25;
        var tmp2_text = tmp1_elvis_lhs == null ? 'An error occurred while loading your profile' : tmp1_elvis_lhs;
        var tmp3_style = MaterialTheme_instance.jog($composer_28, 6).oof_1;
        var tmp4_textAlign = Companion_getInstance_15().d7v_1;
        var tmp_26 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$57 = _Dp___init__impl__ms3zkb(24);
        var tmp5_modifier = padding_0(tmp_26, tmp$ret$57);
        var tmp_27 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_28 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_29 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_30 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_31 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp2_text, tmp5_modifier, tmp_27, null, tmp_28, null, null, null, tmp_29, null, tmp4_textAlign, tmp_30, tmp_31, false, 0, 0, null, tmp3_style, $composer_28, 48, 0, 130044);
        var tmp_32 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$58 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_32, tmp$ret$58), $composer_28, 6);
        sourceInformationMarkerStart($composer_28, -700747839, 'CC(remember):CheckoutScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_28.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_28.i31();
        var tmp_33;
        if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
          var value_4 = CheckoutScreen$lambda_2(viewModel);
          $composer_28.j31(value_4);
          tmp_33 = value_4;
        } else {
          tmp_33 = it_4;
        }
        var tmp1_group_0 = tmp_33;
        sourceInformationMarkerEnd($composer_28);
        Button(tmp1_group_0, null, false, null, null, null, null, null, null, ComposableSingletons$CheckoutScreenKt_getInstance().r11k_1, $composer_28, 805306368, 510);
        sourceInformationMarkerEnd($composer_28);
        $composer_26.e31();
        sourceInformationMarkerEnd($composer_23);
        $composer_21.e31();
        $composer_12.n30();
      } else {
        $composer_12.m30(1290155774);
        sourceInformation($composer_12, '');
        if (isDesktop) {
          $composer_12.m30(1290088690);
          sourceInformation($composer_12, '138@6461L3291');
          var tmp_34 = fillMaxSize(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$63 = _Dp___init__impl__ms3zkb(24);
          var tmp0_7 = padding_2(tmp_34, tmp$ret$63);
          var tmp_35 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$64 = _Dp___init__impl__ms3zkb(32);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_9 = tmp0_7;
          var horizontalArrangement = tmp_35.mdq(tmp$ret$64);
          var verticalAlignment = null;
          var $composer_29 = $composer_12;
          if (!((4 & 1) === 0))
            modifier_9 = Companion_instance;
          if (!((4 & 2) === 0))
            horizontalArrangement = Arrangement_getInstance().qdp_1;
          if (!((4 & 4) === 0))
            verticalAlignment = Companion_getInstance_11().t8t_1;
          var measurePolicy_4 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_29, 14 & 54 >> 3 | 112 & 54 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_10 = modifier_9;
          var $composer_30 = $composer_29;
          if (!((0 & 2) === 0))
            modifier_10 = Companion_instance;
          var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_30, 0).hashCode();
          var localMap_4 = $composer_30.t31();
          var materialized_4 = materialize($composer_30, modifier_10);
          var tmp0_8 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_31 = $composer_30;
          var tmp_36 = $composer_31.g30();
          if (!isInterface(tmp_36, Applier)) {
            invalidApplier();
          }
          $composer_31.b31();
          if ($composer_31.h30()) {
            $composer_31.c31(tmp0_8);
          } else {
            $composer_31.d31();
          }
          var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_31);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
          var $composer_32 = $composer_31;
          var $composer_33 = $composer_32;
          sourceInformationMarkerStart($composer_33, 654926258, 'C147@7003L1251,143@6721L1533,173@8336L1394:CheckoutScreen.kt#xe8pgy');
          var tmp_37 = fillMaxHeight(RowScopeInstance_instance.bdy(Companion_instance, 1.5));
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_38 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$72 = _Dp___init__impl__ms3zkb(40);
          var tmp_39 = PaddingValues(VOID, tmp_38, VOID, tmp$ret$72);
          var tmp_40 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$73 = _Dp___init__impl__ms3zkb(24);
          var tmp_41 = tmp_40.mdq(tmp$ret$73);
          sourceInformationMarkerStart($composer_33, -394508077, 'CC(remember):CheckoutScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_3 = !!(!!(!!($composer_33.k31(state$delegate) | $composer_33.q31(viewModel)) | $composer_33.k31(verifiedPhoneMsg)) | $composer_33.q31(scope_0));
          // Inline function 'kotlin.let' call
          var it_5 = $composer_33.i31();
          var tmp_42;
          if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
            var value_5 = CheckoutScreen$lambda_3(viewModel, verifiedPhoneMsg, scope_0, snackbarHostState, state$delegate);
            $composer_33.j31(value_5);
            tmp_42 = value_5;
          } else {
            tmp_42 = it_5;
          }
          var tmp0_group_1 = tmp_42;
          sourceInformationMarkerEnd($composer_33);
          LazyColumn(tmp_37, null, tmp_39, false, tmp_41, null, null, false, null, tmp0_group_1, $composer_33, 24960, 490);
          var tmp_43 = fillMaxHeight(RowScopeInstance_instance.bdy(Companion_instance, 1.0));
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$78 = _Dp___init__impl__ms3zkb(8);
          var tmp0_9 = padding_1(tmp_43, VOID, tmp$ret$78);
          var tmp_44 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$79 = _Dp___init__impl__ms3zkb(24);
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_11 = tmp0_9;
          var verticalArrangement_1 = tmp_44.mdq(tmp$ret$79);
          var horizontalAlignment_1 = null;
          var $composer_34 = $composer_33;
          if (!((4 & 1) === 0))
            modifier_11 = Companion_instance;
          if (!((4 & 2) === 0))
            verticalArrangement_1 = Arrangement_getInstance().sdp_1;
          if (!((4 & 4) === 0))
            horizontalAlignment_1 = Companion_getInstance_11().w8t_1;
          var measurePolicy_5 = columnMeasurePolicy(verticalArrangement_1, horizontalAlignment_1, $composer_34, 14 & 48 >> 3 | 112 & 48 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_12 = modifier_11;
          var $composer_35 = $composer_34;
          if (!((0 & 2) === 0))
            modifier_12 = Companion_instance;
          var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_35, 0).hashCode();
          var localMap_5 = $composer_35.t31();
          var materialized_5 = materialize($composer_35, modifier_12);
          var tmp0_10 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_36 = $composer_35;
          var tmp_45 = $composer_36.g30();
          if (!isInterface(tmp_45, Applier)) {
            invalidApplier();
          }
          $composer_36.b31();
          if ($composer_36.h30()) {
            $composer_36.c31(tmp0_10);
          } else {
            $composer_36.d31();
          }
          var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_36);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
          var $composer_37 = $composer_36;
          var $composer_38 = $composer_37;
          sourceInformationMarkerStart($composer_38, 407883123, 'C180@8772L11,181@8848L856,177@8574L1130:CheckoutScreen.kt#xe8pgy');
          var tmp_46 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$86 = _Dp___init__impl__ms3zkb(16);
          var tmp_47 = RoundedCornerShape(tmp$ret$86);
          var tmp_48 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_38, 6).oo0_1, 0.3);
          var tmp_49 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_50 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_51 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_0 = rememberComposableLambda(482715585, true, CheckoutScreen$lambda_4(viewModel, state$delegate), $composer_38, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_39 = $composer_38;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_4 = $composer_39.k31(dispatchReceiver_0);
          // Inline function 'kotlin.let' call
          var it_6 = $composer_39.i31();
          var tmp_52;
          if (invalid_4 || it_6 === Companion_getInstance().f30_1) {
            var value_6 = ComposableLambda$invoke$ref(dispatchReceiver_0);
            $composer_39.j31(value_6);
            tmp_52 = value_6;
          } else {
            tmp_52 = it_6;
          }
          var tmp$ret$87 = tmp_52;
          Surface(tmp_46, tmp_47, tmp_48, tmp_49, tmp_50, tmp_51, null, tmp$ret$87, $composer_38, 12582918, 120);
          sourceInformationMarkerEnd($composer_38);
          $composer_36.e31();
          sourceInformationMarkerEnd($composer_33);
          $composer_31.e31();
          $composer_12.n30();
        } else {
          $composer_12.m30(1293393910);
          sourceInformation($composer_12, '200@9835L3090');
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_13 = fillMaxSize(Companion_instance);
          var verticalArrangement_2 = null;
          var horizontalAlignment_2 = null;
          var $composer_40 = $composer_12;
          if (!((6 & 1) === 0))
            modifier_13 = Companion_instance;
          if (!((6 & 2) === 0))
            verticalArrangement_2 = Arrangement_getInstance().sdp_1;
          if (!((6 & 4) === 0))
            horizontalAlignment_2 = Companion_getInstance_11().w8t_1;
          var measurePolicy_6 = columnMeasurePolicy(verticalArrangement_2, horizontalAlignment_2, $composer_40, 14 & 6 >> 3 | 112 & 6 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_14 = modifier_13;
          var $composer_41 = $composer_40;
          if (!((0 & 2) === 0))
            modifier_14 = Companion_instance;
          var compositeKeyHash_6 = get_currentCompositeKeyHashCode($composer_41, 0).hashCode();
          var localMap_6 = $composer_41.t31();
          var materialized_6 = materialize($composer_41, modifier_14);
          var tmp0_11 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_42 = $composer_41;
          var tmp_53 = $composer_42.g30();
          if (!isInterface(tmp_53, Applier)) {
            invalidApplier();
          }
          $composer_42.b31();
          if ($composer_42.h30()) {
            $composer_42.c31(tmp0_11);
          } else {
            $composer_42.d31();
          }
          var $this$ReusableComposeNode_6 = _Updater___init__impl__rbfxm8($composer_42);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, measurePolicy_6, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, localMap_6, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, compositeKeyHash_6, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_6, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, materialized_6, Companion_getInstance_12().qah_1);
          var $composer_43 = $composer_42;
          var $composer_44 = $composer_43;
          sourceInformationMarkerStart($composer_44, 784159520, 'C210@10353L2022,201@9903L2472,250@12524L11,253@12712L191,248@12401L502:CheckoutScreen.kt#xe8pgy');
          var tmp_54 = ColumnScopeInstance_instance.yds(Companion_instance, 1.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp0_start = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp1_end = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp2_top = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp3_bottom = _Dp___init__impl__ms3zkb(40);
          var tmp_55 = PaddingValues(tmp0_start, tmp2_top, tmp1_end, tmp3_bottom);
          var tmp_56 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$104 = _Dp___init__impl__ms3zkb(24);
          var tmp_57 = tmp_56.mdq(tmp$ret$104);
          sourceInformationMarkerStart($composer_44, -1360164431, 'CC(remember):CheckoutScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_5 = !!(!!(!!($composer_44.k31(state$delegate) | $composer_44.q31(viewModel)) | $composer_44.k31(verifiedPhoneMsg)) | $composer_44.q31(scope_0));
          // Inline function 'kotlin.let' call
          var it_7 = $composer_44.i31();
          var tmp_58;
          if (invalid_5 || it_7 === Companion_getInstance().f30_1) {
            var value_7 = CheckoutScreen$lambda_5(viewModel, verifiedPhoneMsg, scope_0, snackbarHostState, state$delegate);
            $composer_44.j31(value_7);
            tmp_58 = value_7;
          } else {
            tmp_58 = it_7;
          }
          var tmp0_group_2 = tmp_58;
          sourceInformationMarkerEnd($composer_44);
          LazyColumn(tmp_54, null, tmp_55, false, tmp_57, null, null, false, null, tmp0_group_2, $composer_44, 24576, 490);
          var tmp4_modifier = fillMaxWidth(Companion_instance);
          var tmp5_color = MaterialTheme_instance.unz($composer_44, 6).mo0_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp6_shadowElevation = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_59 = _Dp___init__impl__ms3zkb(32);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$111 = _Dp___init__impl__ms3zkb(32);
          var tmp7_shape = RoundedCornerShape_0(tmp_59, tmp$ret$111);
          var tmp_60 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_61 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_1 = rememberComposableLambda(-1761040154, true, CheckoutScreen$lambda_6(viewModel, state$delegate), $composer_44, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_45 = $composer_44;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_6 = $composer_45.k31(dispatchReceiver_1);
          // Inline function 'kotlin.let' call
          var it_8 = $composer_45.i31();
          var tmp_62;
          if (invalid_6 || it_8 === Companion_getInstance().f30_1) {
            var value_8 = ComposableLambda$invoke$ref(dispatchReceiver_1);
            $composer_45.j31(value_8);
            tmp_62 = value_8;
          } else {
            tmp_62 = it_8;
          }
          var tmp$ret$112 = tmp_62;
          Surface(tmp4_modifier, tmp7_shape, tmp5_color, tmp_60, tmp_61, tmp6_shadowElevation, null, tmp$ret$112, $composer_44, 12779526, 88);
          sourceInformationMarkerEnd($composer_44);
          $composer_42.e31();
          $composer_12.n30();
        }
        $composer_12.n30();
      }
      sourceInformationMarkerEnd($composer_12);
      $composer_10.e31();
      var tmp_63 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(snackbarHostState, tmp_63, null, $composer_7, 6, 4);
      sourceInformationMarkerEnd($composer_7);
      $composer_5.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp3_safe_receiver = $composer_0.t30();
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.p3c(CheckoutScreen$lambda_7(onBack, onOrderSuccess, $changed));
    }
  }
  function ComposableSingletons$CheckoutScreenKt$lambda$_205325943$lambda_y4oesc($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C100@4656L41,99@4626L152:CheckoutScreen.kt#xe8pgy');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-205325943, $changed, -1, 'client.fstech.hadaya.presentation.checkout.ComposableSingletons$CheckoutScreenKt.lambda$-205325943.<anonymous> (CheckoutScreen.kt:99)');
      }
      var tmp = stringResource(get_checkout_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = Companion_getInstance_16().f7z_1;
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, tmp_2, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 1572864, 0, 262078);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CheckoutScreenKt$lambda$_438164247$lambda_v5vnmy($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C108@5028L31,106@4908L177:CheckoutScreen.kt#xe8pgy');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-438164247, $changed, -1, 'client.fstech.hadaya.presentation.checkout.ComposableSingletons$CheckoutScreenKt.lambda$-438164247.<anonymous> (CheckoutScreen.kt:106)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CheckoutScreenKt$lambda$1498719549$lambda($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C132@6307L13:CheckoutScreen.kt#xe8pgy');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1498719549, $changed, -1, 'client.fstech.hadaya.presentation.checkout.ComposableSingletons$CheckoutScreenKt.lambda$1498719549.<anonymous> (CheckoutScreen.kt:132)');
      }
      var tmp = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_0 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextOverflow___init__impl__obguoe(0);
      Text('Retry', null, tmp, null, tmp_0, null, null, null, tmp_1, null, null, tmp_2, tmp_3, false, 0, 0, null, null, $composer_0, 6, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CheckoutScreenKt() {
    ComposableSingletons$CheckoutScreenKt_instance = this;
    var tmp = this;
    tmp.p11k_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-205325943, false, ComposableSingletons$CheckoutScreenKt$lambda$_205325943$lambda_y4oesc));
    var tmp_0 = this;
    tmp_0.q11k_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-438164247, false, ComposableSingletons$CheckoutScreenKt$lambda$_438164247$lambda_v5vnmy));
    var tmp_1 = this;
    tmp_1.r11k_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1498719549, false, ComposableSingletons$CheckoutScreenKt$lambda$1498719549$lambda));
  }
  var ComposableSingletons$CheckoutScreenKt_instance;
  function ComposableSingletons$CheckoutScreenKt_getInstance() {
    if (ComposableSingletons$CheckoutScreenKt_instance == null)
      new ComposableSingletons$CheckoutScreenKt();
    return ComposableSingletons$CheckoutScreenKt_instance;
  }
  function DeliverySection(state, viewModel, verifiedPhoneMsg, scope, snackbarHostState, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1249707789);
    sourceInformation($composer_0, 'C(DeliverySection)P(2,4,3)278@13333L509:CheckoutScreen.kt#xe8pgy');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(viewModel) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(verifiedPhoneMsg) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ((($changed & 4096) === 0 ? $composer_0.k31(scope) : $composer_0.q31(scope)) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(snackbarHostState) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1249707789, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.DeliverySection (CheckoutScreen.kt:277)');
      }
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = null;
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((7 & 1) === 0))
        modifier = Companion_instance;
      if (!((7 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((7 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 4853056, 'C280@13385L50,279@13350L143,283@13502L41,287@13627L34,288@13693L133,285@13553L283:CheckoutScreen.kt#xe8pgy');
      SectionHeader(stringResource(get_delivery_details_header(string_instance), $composer_5, 0), get_LocalShipping(Icons_getInstance().dxv_1), $composer_5, 0);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_0, tmp$ret$6), $composer_5, 6);
      sourceInformationMarkerStart($composer_5, 969996287, 'CC(remember):CheckoutScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it = $composer_5.i31();
      var tmp_1;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = DeliverySection$lambda(viewModel);
        $composer_5.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_5);
      sourceInformationMarkerStart($composer_5, 969998498, 'CC(remember):CheckoutScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(!!((($dirty & 7168) === 2048 || (!(($dirty & 4096) === 0) && $composer_0.q31(scope))) | ($dirty & 57344) === 16384) | ($dirty & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_5.i31();
      var tmp_2;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = DeliverySection$lambda_0(scope, snackbarHostState, verifiedPhoneMsg);
        $composer_5.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_5);
      DeliveryDetailsSection(state, tmp0_group, tmp1_group, null, $composer_5, 14 & $dirty, 8);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(DeliverySection$lambda_1(state, viewModel, verifiedPhoneMsg, scope, snackbarHostState, $changed));
    }
  }
  function PaymentSection(state, viewModel, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1333579692);
    sourceInformation($composer_0, 'C(PaymentSection)299@13935L470:CheckoutScreen.kt#xe8pgy');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(viewModel) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1333579692, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.PaymentSection (CheckoutScreen.kt:298)');
      }
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = null;
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((7 & 1) === 0))
        modifier = Companion_instance;
      if (!((7 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((7 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 865254274, 'C301@13987L48,300@13952L138,304@14099L41,308@14253L136,306@14150L249:CheckoutScreen.kt#xe8pgy');
      SectionHeader(stringResource(get_payment_method_header(string_instance), $composer_5, 0), get_CreditCard(Icons_getInstance().dxv_1), $composer_5, 0);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_0, tmp$ret$6), $composer_5, 6);
      sourceInformationMarkerStart($composer_5, 997752074, 'CC(remember):CheckoutScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it = $composer_5.i31();
      var tmp_1;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = PaymentSection$lambda(viewModel);
        $composer_5.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_5);
      PaymentMethodSection(state.w11j_1, tmp0_group, null, $composer_5, 0, 4);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(PaymentSection$lambda_0(state, viewModel, $changed));
    }
  }
  function ConfirmButton(state, viewModel, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1443130027);
    sourceInformation($composer_0, 'C(ConfirmButton)320@14523L57,324@14729L333,319@14497L565:CheckoutScreen.kt#xe8pgy');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(viewModel) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1443130027, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.ConfirmButton (CheckoutScreen.kt:318)');
      }
      var tmp = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(60);
      var tmp0_modifier = height(tmp, tmp$ret$0);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
      var tmp1_shape = RoundedCornerShape(tmp$ret$1);
      var tmp2_enabled = !state.y11j_1;
      sourceInformationMarkerStart($composer_0, 426483982, 'CC(remember):CheckoutScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ConfirmButton$lambda(viewModel);
        tmp0.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp0_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(120489829, true, ConfirmButton$lambda_0(state), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_1.i31();
      var tmp_1;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp$ret$6 = tmp_1;
      Button(tmp0_group, tmp0_modifier, tmp2_enabled, tmp1_shape, null, null, null, null, null, tmp$ret$6, $composer_0, 805306416, 496);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(ConfirmButton$lambda_1(state, viewModel, $changed));
    }
  }
  function CheckoutScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function CheckoutScreen$lambda_0() {
    return EmptyCoroutineContext_getInstance();
  }
  function CheckoutScreen$slambda($viewModel, resultContinuation) {
    this.b11l_1 = $viewModel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CheckoutScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CheckoutScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CheckoutScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.b11l_1.s10h().j10i(LoadData_instance);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CheckoutScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CheckoutScreen$slambda(this.b11l_1, completion);
    i.c11l_1 = $this$LaunchedEffect;
    return i;
  };
  function CheckoutScreen$slambda_0($viewModel, resultContinuation) {
    var i = new CheckoutScreen$slambda($viewModel, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_11(function_0) {
    this.d11l_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_11).a1v = function (value, $completion) {
    return this.d11l_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_11).q3 = function () {
    return this.d11l_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_11).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_11).hashCode = function () {
    return hashCode(this.q3());
  };
  function CheckoutScreen$slambda$slambda($snackbarHostState, $onOrderSuccess, resultContinuation) {
    this.m11l_1 = $snackbarHostState;
    this.n11l_1 = $onOrderSuccess;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CheckoutScreen$slambda$slambda).q11l = function (effect, $completion) {
    var tmp = this.r11l(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CheckoutScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.q11l((!(p1 == null) ? isInterface(p1, CheckoutSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CheckoutScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            var tmp0_subject = this.o11l_1;
            if (tmp0_subject instanceof ShowError_2) {
              this.n9_1 = 3;
              suspendResult = this.o11l_1.n11k_1.z10i(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof OrderPlaced) {
                this.p11l_1 = this.n11l_1(this.o11l_1.o11k_1);
                this.n9_1 = 5;
                continue $sm;
              } else {
                if (equals(tmp0_subject, FriendAdded_instance)) {
                  this.n9_1 = 1;
                  suspendResult = getString(get_friend_added_successfully(string_instance), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.m11l_1.dqm(ARGUMENT, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.p11l_1 = suspendResult;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            var ARGUMENT_0 = suspendResult;
            this.n9_1 = 4;
            suspendResult = this.m11l_1.dqm(ARGUMENT_0, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.p11l_1 = suspendResult;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CheckoutScreen$slambda$slambda).r11l = function (effect, completion) {
    var i = new CheckoutScreen$slambda$slambda(this.m11l_1, this.n11l_1, completion);
    i.o11l_1 = effect;
    return i;
  };
  function CheckoutScreen$slambda$slambda_0($snackbarHostState, $onOrderSuccess, resultContinuation) {
    var i = new CheckoutScreen$slambda$slambda($snackbarHostState, $onOrderSuccess, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.q11l(effect, $completion);
    }, 1);
  }
  function CheckoutScreen$slambda_1($viewModel, $snackbarHostState, $onOrderSuccess, resultContinuation) {
    this.a11m_1 = $viewModel;
    this.b11m_1 = $snackbarHostState;
    this.c11m_1 = $onOrderSuccess;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CheckoutScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CheckoutScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CheckoutScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.a11m_1.s10h().t10h();
            var tmp_1 = CheckoutScreen$slambda$slambda_0(this.b11m_1, this.c11m_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_11(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CheckoutScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CheckoutScreen$slambda_1(this.a11m_1, this.b11m_1, this.c11m_1, completion);
    i.d11m_1 = $this$LaunchedEffect;
    return i;
  };
  function CheckoutScreen$slambda_2($viewModel, $snackbarHostState, $onOrderSuccess, resultContinuation) {
    var i = new CheckoutScreen$slambda_1($viewModel, $snackbarHostState, $onOrderSuccess, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CheckoutScreen$lambda_1($onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C105@4853L254:CheckoutScreen.kt#xe8pgy');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1418893895, $changed, -1, 'client.fstech.hadaya.presentation.checkout.CheckoutScreen.<anonymous>.<anonymous>.<anonymous> (CheckoutScreen.kt:105)');
        }
        IconButton($onBack, null, false, null, null, null, ComposableSingletons$CheckoutScreenKt_getInstance().q11k_1, $composer_0, 1572864, 62);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda_2($viewModel) {
    return function () {
      $viewModel.s10h().j10i(Retry_instance);
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_8(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function CheckoutScreen$lambda$lambda($viewModel, $verifiedPhoneMsg, $scope, $snackbarHostState, $state$delegate) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C149@7072L77:CheckoutScreen.kt#xe8pgy');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-877940987, $changed, -1, 'client.fstech.hadaya.presentation.checkout.CheckoutScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CheckoutScreen.kt:149)');
        }
        DeliverySection(CheckoutScreen$lambda($state$delegate), $viewModel, $verifiedPhoneMsg, $scope, $snackbarHostState, $composer_0, 24576);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda$lambda($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(it);
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda_0($viewModel, $state$delegate) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C154@7373L34,152@7247L194:CheckoutScreen.kt#xe8pgy');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1640285692, $changed, -1, 'client.fstech.hadaya.presentation.checkout.CheckoutScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CheckoutScreen.kt:152)');
        }
        var tmp_0 = CheckoutScreen$lambda($state$delegate);
        sourceInformationMarkerStart($composer_0, 61557534, 'CC(remember):CheckoutScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($viewModel);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CheckoutScreen$lambda$lambda$lambda($viewModel);
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp0_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        GovernorateSelectorSection(tmp_0, tmp0_group, null, $composer_0, 0, 4);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda$lambda_0($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(it);
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda_1($viewModel, $state$delegate) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C158@7579L11,158@7539L67,159@7639L41,162@7826L34,160@7713L181:CheckoutScreen.kt#xe8pgy');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1868330947, $changed, -1, 'client.fstech.hadaya.presentation.checkout.CheckoutScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CheckoutScreen.kt:158)');
        }
        HorizontalDivider(null, _Dp___init__impl__ms3zkb(0.0), MaterialTheme_instance.unz($composer_0, 6).oo0_1, $composer_0, 0, 3);
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_0, tmp$ret$0), $composer_0, 6);
        var tmp_1 = CheckoutScreen$lambda($state$delegate);
        sourceInformationMarkerStart($composer_0, -169700033, 'CC(remember):CheckoutScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($viewModel);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_2;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CheckoutScreen$lambda$lambda$lambda_0($viewModel);
          $composer_0.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        CouponSection(tmp_1, tmp0_group, $composer_0, 0);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda_2($viewModel, $state$delegate) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C166@8032L11,166@7992L67,167@8092L41,168@8166L32:CheckoutScreen.kt#xe8pgy');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1081980290, $changed, -1, 'client.fstech.hadaya.presentation.checkout.CheckoutScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CheckoutScreen.kt:166)');
        }
        HorizontalDivider(null, _Dp___init__impl__ms3zkb(0.0), MaterialTheme_instance.unz($composer_0, 6).oo0_1, $composer_0, 0, 3);
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_0, tmp$ret$0), $composer_0, 6);
        PaymentSection(CheckoutScreen$lambda($state$delegate), $viewModel, $composer_0, 0);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda_3($viewModel, $verifiedPhoneMsg, $scope, $snackbarHostState, $state$delegate) {
    return function ($this$LazyColumn) {
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(-877940987, true, CheckoutScreen$lambda$lambda($viewModel, $verifiedPhoneMsg, $scope, $snackbarHostState, $state$delegate))));
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(1640285692, true, CheckoutScreen$lambda$lambda_0($viewModel, $state$delegate))));
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(-1868330947, true, CheckoutScreen$lambda$lambda_1($viewModel, $state$delegate))));
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(-1081980290, true, CheckoutScreen$lambda$lambda_2($viewModel, $state$delegate))));
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda_3($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(it);
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda_4($viewModel, $state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C182@8882L792:CheckoutScreen.kt#xe8pgy');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(482715585, $changed, -1, 'client.fstech.hadaya.presentation.checkout.CheckoutScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CheckoutScreen.kt:182)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -97199149, 'C184@9026L47,183@8963L217,187@9217L41,190@9422L34,188@9295L199,192@9531L41,193@9609L31:CheckoutScreen.kt#xe8pgy');
        SectionHeader(stringResource(get_order_summary_header(string_instance), $composer_5, 0), get_Redeem(Icons_getInstance().dxv_1), $composer_5, 0);
        var tmp_2 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_2, tmp$ret$7), $composer_5, 6);
        var tmp_3 = CheckoutScreen$lambda($state$delegate);
        sourceInformationMarkerStart($composer_5, 551067917, 'CC(remember):CheckoutScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_5.q31($viewModel);
        // Inline function 'kotlin.let' call
        var it = $composer_5.i31();
        var tmp_4;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CheckoutScreen$lambda$lambda_3($viewModel);
          $composer_5.j31(value);
          tmp_4 = value;
        } else {
          tmp_4 = it;
        }
        var tmp0_group = tmp_4;
        sourceInformationMarkerEnd($composer_5);
        OrderSummarySection(tmp_3, tmp0_group, null, $composer_5, 0, 4);
        var tmp_5 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$12 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_5, tmp$ret$12), $composer_5, 6);
        ConfirmButton(CheckoutScreen$lambda($state$delegate), $viewModel, $composer_5, 0);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda_4($viewModel, $verifiedPhoneMsg, $scope, $snackbarHostState, $state$delegate) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C212@10422L77:CheckoutScreen.kt#xe8pgy');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1203952224, $changed, -1, 'client.fstech.hadaya.presentation.checkout.CheckoutScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CheckoutScreen.kt:212)');
        }
        DeliverySection(CheckoutScreen$lambda($state$delegate), $viewModel, $verifiedPhoneMsg, $scope, $snackbarHostState, $composer_0, 24576);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda$lambda_1($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(it);
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda_5($viewModel, $state$delegate) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C217@10723L34,215@10597L194:CheckoutScreen.kt#xe8pgy');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-579606249, $changed, -1, 'client.fstech.hadaya.presentation.checkout.CheckoutScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CheckoutScreen.kt:215)');
        }
        var tmp_0 = CheckoutScreen$lambda($state$delegate);
        sourceInformationMarkerStart($composer_0, 1344148345, 'CC(remember):CheckoutScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($viewModel);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CheckoutScreen$lambda$lambda$lambda_1($viewModel);
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp0_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        GovernorateSelectorSection(tmp_0, tmp0_group, null, $composer_0, 0, 4);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda$lambda_2($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(it);
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda_6($viewModel, $state$delegate) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C221@10929L11,221@10889L67,222@10989L41,225@11176L34,223@11063L181:CheckoutScreen.kt#xe8pgy');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(515220184, $changed, -1, 'client.fstech.hadaya.presentation.checkout.CheckoutScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CheckoutScreen.kt:221)');
        }
        HorizontalDivider(null, _Dp___init__impl__ms3zkb(0.0), MaterialTheme_instance.unz($composer_0, 6).oo0_1, $composer_0, 0, 3);
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_0, tmp$ret$0), $composer_0, 6);
        var tmp_1 = CheckoutScreen$lambda($state$delegate);
        sourceInformationMarkerStart($composer_0, 1205368090, 'CC(remember):CheckoutScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($viewModel);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_2;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CheckoutScreen$lambda$lambda$lambda_2($viewModel);
          $composer_0.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        CouponSection(tmp_1, tmp0_group, $composer_0, 0);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda$lambda_3($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(it);
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda_7($viewModel, $state$delegate) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C229@11382L11,229@11342L67,230@11442L41,232@11575L47,231@11516L205,235@11754L41,238@11947L34,236@11828L187:CheckoutScreen.kt#xe8pgy');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1610046617, $changed, -1, 'client.fstech.hadaya.presentation.checkout.CheckoutScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CheckoutScreen.kt:229)');
        }
        HorizontalDivider(null, _Dp___init__impl__ms3zkb(0.0), MaterialTheme_instance.unz($composer_0, 6).oo0_1, $composer_0, 0, 3);
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_0, tmp$ret$0), $composer_0, 6);
        SectionHeader(stringResource(get_order_summary_header(string_instance), $composer_0, 0), get_Redeem(Icons_getInstance().dxv_1), $composer_0, 0);
        var tmp_1 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_1, tmp$ret$1), $composer_0, 6);
        var tmp_2 = CheckoutScreen$lambda($state$delegate);
        sourceInformationMarkerStart($composer_0, 1066592859, 'CC(remember):CheckoutScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($viewModel);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_3;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CheckoutScreen$lambda$lambda$lambda_3($viewModel);
          $composer_0.j31(value);
          tmp_3 = value;
        } else {
          tmp_3 = it;
        }
        var tmp0_group = tmp_3;
        sourceInformationMarkerEnd($composer_0);
        OrderSummarySection(tmp_2, tmp0_group, null, $composer_0, 0, 4);
        var tmp_4;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_4 = Unit_instance;
        }
        tmp = tmp_4;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda$lambda_8($viewModel, $state$delegate) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C242@12153L11,242@12113L67,243@12213L41,244@12287L32:CheckoutScreen.kt#xe8pgy');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1590094246, $changed, -1, 'client.fstech.hadaya.presentation.checkout.CheckoutScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CheckoutScreen.kt:242)');
        }
        HorizontalDivider(null, _Dp___init__impl__ms3zkb(0.0), MaterialTheme_instance.unz($composer_0, 6).oo0_1, $composer_0, 0, 3);
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_0, tmp$ret$0), $composer_0, 6);
        PaymentSection(CheckoutScreen$lambda($state$delegate), $viewModel, $composer_0, 0);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda_5($viewModel, $verifiedPhoneMsg, $scope, $snackbarHostState, $state$delegate) {
    return function ($this$LazyColumn) {
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(-1203952224, true, CheckoutScreen$lambda$lambda_4($viewModel, $verifiedPhoneMsg, $scope, $snackbarHostState, $state$delegate))));
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(-579606249, true, CheckoutScreen$lambda$lambda_5($viewModel, $state$delegate))));
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(515220184, true, CheckoutScreen$lambda$lambda_6($viewModel, $state$delegate))));
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(1610046617, true, CheckoutScreen$lambda$lambda_7($viewModel, $state$delegate))));
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(-1590094246, true, CheckoutScreen$lambda$lambda_8($viewModel, $state$delegate))));
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda_6($viewModel, $state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C254@12742L135:CheckoutScreen.kt#xe8pgy');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1761040154, $changed, -1, 'client.fstech.hadaya.presentation.checkout.CheckoutScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CheckoutScreen.kt:254)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 267170404, 'C255@12816L31:CheckoutScreen.kt#xe8pgy');
        ConfirmButton(CheckoutScreen$lambda($state$delegate), $viewModel, $composer_5, 0);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CheckoutScreen$lambda_7($onBack, $onOrderSuccess, $$changed) {
    return function ($composer, $force) {
      CheckoutScreen($onBack, $onOrderSuccess, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function DeliverySection$lambda($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(it);
      return Unit_instance;
    };
  }
  function DeliverySection$lambda$slambda($snackbarHostState, $verifiedPhoneMsg, resultContinuation) {
    this.m11m_1 = $snackbarHostState;
    this.n11m_1 = $verifiedPhoneMsg;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DeliverySection$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DeliverySection$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DeliverySection$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.m11m_1.dqm(this.n11m_1, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DeliverySection$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new DeliverySection$lambda$slambda(this.m11m_1, this.n11m_1, completion);
    i.o11m_1 = $this$launch;
    return i;
  };
  function DeliverySection$lambda$slambda_0($snackbarHostState, $verifiedPhoneMsg, resultContinuation) {
    var i = new DeliverySection$lambda$slambda($snackbarHostState, $verifiedPhoneMsg, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function DeliverySection$lambda_0($scope, $snackbarHostState, $verifiedPhoneMsg) {
    return function () {
      launch($scope, VOID, VOID, DeliverySection$lambda$slambda_0($snackbarHostState, $verifiedPhoneMsg, null));
      return Unit_instance;
    };
  }
  function DeliverySection$lambda_1($state, $viewModel, $verifiedPhoneMsg, $scope, $snackbarHostState, $$changed) {
    return function ($composer, $force) {
      DeliverySection($state, $viewModel, $verifiedPhoneMsg, $scope, $snackbarHostState, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function PaymentSection$lambda($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new SelectPaymentMethod(it));
      return Unit_instance;
    };
  }
  function PaymentSection$lambda_0($state, $viewModel, $$changed) {
    return function ($composer, $force) {
      PaymentSection($state, $viewModel, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function ConfirmButton$lambda($viewModel) {
    return function () {
      $viewModel.s10h().j10i(PlaceOrder_instance);
      return Unit_instance;
    };
  }
  function ConfirmButton$lambda_0($state) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:CheckoutScreen.kt#xe8pgy');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(120489829, $changed, -1, 'client.fstech.hadaya.presentation.checkout.ConfirmButton.<anonymous> (CheckoutScreen.kt:325)');
        }
        if ($state.y11j_1) {
          $composer_0.m30(-1080111666);
          sourceInformation($composer_0, '326@14779L79');
          var tmp0_color = Companion_getInstance_14().m6b_1;
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp1_modifier = size(tmp_0, tmp$ret$0);
          var tmp_1 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_3 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp1_modifier, tmp0_color, tmp_1, tmp_2, tmp_3, _Dp___init__impl__ms3zkb(0.0), $composer_0, 54, 60);
          $composer_0.n30();
        } else {
          $composer_0.m30(-1080014233);
          sourceInformation($composer_0, '329@14910L42,328@14888L158');
          var tmp_4 = stringResource(get_confirm_pay_btn(string_instance), $composer_0, 0);
          var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_6 = get_sp(18);
          var tmp_7 = Companion_getInstance_16().e7z_1;
          var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_10 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_4, null, tmp_5, null, tmp_6, null, tmp_7, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, null, $composer_0, 1597440, 0, 262062);
          $composer_0.n30();
        }
        var tmp_11;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_11 = Unit_instance;
        }
        tmp = tmp_11;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ConfirmButton$lambda_1($state, $viewModel, $$changed) {
    return function ($composer, $force) {
      ConfirmButton($state, $viewModel, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_checkout_CheckoutViewModel$stable;
  function CheckoutViewModel$slambda$lambda($cartItems) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $cartItems);
    };
  }
  function CheckoutViewModel$slambda$lambda_0($lang) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $lang);
    };
  }
  function fetchShippingCost($this, governorateName, $completion) {
    var tmp = new $fetchShippingCostCOROUTINE$($this, governorateName, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function validate($this, $completion) {
    var tmp = new $validateCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function isValidPhone($this, phone) {
    return isValidEgyptianMobile(phone);
  }
  function CheckoutViewModel$slambda(this$0, resultContinuation) {
    this.z11n_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CheckoutViewModel$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CheckoutViewModel$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CheckoutViewModel$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.z11n_1.t11o(LoadData_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CheckoutViewModel$slambda).q24 = function ($this$launch, completion) {
    var i = new CheckoutViewModel$slambda(this.z11n_1, completion);
    i.a11o_1 = $this$launch;
    return i;
  };
  function CheckoutViewModel$slambda_0(this$0, resultContinuation) {
    var i = new CheckoutViewModel$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CheckoutViewModel$slambda_1(this$0, resultContinuation) {
    this.c11p_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CheckoutViewModel$slambda_1).q10v = function (cartItems, $completion) {
    var tmp = this.r10v(cartItems, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CheckoutViewModel$slambda_1).ja = function (p1, $completion) {
    return this.q10v((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CheckoutViewModel$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.c11p_1.x10k(CheckoutViewModel$slambda$lambda(this.d11p_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CheckoutViewModel$slambda_1).r10v = function (cartItems, completion) {
    var i = new CheckoutViewModel$slambda_1(this.c11p_1, completion);
    i.d11p_1 = cartItems;
    return i;
  };
  function CheckoutViewModel$slambda_2(this$0, resultContinuation) {
    var i = new CheckoutViewModel$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function (cartItems, $completion) {
      return i.q10v(cartItems, $completion);
    }, 1);
  }
  function CheckoutViewModel$slambda_3(this$0, resultContinuation) {
    this.m11p_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CheckoutViewModel$slambda_3).pyo = function (lang, $completion) {
    var tmp = this.um9(lang, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CheckoutViewModel$slambda_3).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CheckoutViewModel$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.m11p_1.x10k(CheckoutViewModel$slambda$lambda_0(this.n11p_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CheckoutViewModel$slambda_3).um9 = function (lang, completion) {
    var i = new CheckoutViewModel$slambda_3(this.m11p_1, completion);
    i.n11p_1 = lang;
    return i;
  };
  function CheckoutViewModel$slambda_4(this$0, resultContinuation) {
    var i = new CheckoutViewModel$slambda_3(this$0, resultContinuation);
    return constructCallableReference(function (lang, $completion) {
      return i.pyo(lang, $completion);
    }, 1);
  }
  function CheckoutViewModel$handleIntent$lambda($currentState) {
    return function ($this$updateState) {
      var tmp0_couponCode = $currentState.b11k_1;
      var tmp1_paymentMethod = PaymentMethod_CASH_ON_DELIVERY_getInstance();
      var tmp2_isShippingToFriend = $currentState.l11j_1;
      return $this$updateState.f11k(true, false, null, VOID, null, tmp2_isShippingToFriend, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_paymentMethod, VOID, false, VOID, VOID, tmp0_couponCode, null, null);
    };
  }
  function CheckoutViewModel$handleIntent$lambda_0($this$updateState) {
    return $this$updateState.f11k(false, true, new ResourceString(get_user_not_logged_in(string_instance), []));
  }
  function CheckoutViewModel$handleIntent$lambda_1($this$updateState) {
    return $this$updateState.f11k(false, true, new ResourceString(get_user_banned_error(string_instance), []));
  }
  function CheckoutViewModel$handleIntent$lambda_2($friends, $profile, $initialGov) {
    return function ($this$updateState) {
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = $this$updateState.m11j_1;
      if (charSequenceLength(this_0) === 0) {
        var tmp0_elvis_lhs = $profile.ayn_1;
        tmp = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      } else {
        tmp = $this$updateState.m11j_1;
      }
      var tmp_0 = tmp;
      var tmp_1;
      // Inline function 'kotlin.text.isEmpty' call
      var this_1 = $this$updateState.n11j_1;
      if (charSequenceLength(this_1) === 0) {
        var tmp1_elvis_lhs = $profile.gyn_1;
        tmp_1 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      } else {
        tmp_1 = $this$updateState.n11j_1;
      }
      var tmp_2 = tmp_1;
      var tmp_3;
      // Inline function 'kotlin.text.isEmpty' call
      var this_2 = $this$updateState.o11j_1;
      if (charSequenceLength(this_2) === 0) {
        var tmp2_elvis_lhs = $profile.wym_1;
        tmp_3 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
      } else {
        tmp_3 = $this$updateState.o11j_1;
      }
      var tmp_4 = tmp_3;
      var tmp_5;
      // Inline function 'kotlin.text.isEmpty' call
      var this_3 = $this$updateState.p11j_1;
      if (charSequenceLength(this_3) === 0) {
        var tmp3_elvis_lhs = $profile.xym_1;
        tmp_5 = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      } else {
        tmp_5 = $this$updateState.p11j_1;
      }
      var tmp_6 = tmp_5;
      var tmp_7 = $this$updateState.q11j_1 === 'Other' ? $initialGov : $this$updateState.q11j_1;
      var tmp4_elvis_lhs = $profile.qyn_1;
      return $this$updateState.f11k(VOID, VOID, VOID, $friends, VOID, VOID, tmp_0, tmp_2, tmp_4, tmp_6, tmp_7, tmp4_elvis_lhs == null ? true : tmp4_elvis_lhs);
    };
  }
  function CheckoutViewModel$handleIntent$lambda_3($this$updateState) {
    return $this$updateState.f11k(false, false);
  }
  function CheckoutViewModel$handleIntent$lambda_4($e) {
    return function ($this$updateState) {
      var tmp0_elvis_lhs = $e.message;
      return $this$updateState.f11k(false, true, new DynamicString(tmp0_elvis_lhs == null ? 'Failed to load profile data' : tmp0_elvis_lhs));
    };
  }
  function CheckoutViewModel$handleIntent$lambda_5($intent) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, $intent.o11p_1);
    };
  }
  function CheckoutViewModel$handleIntent$lambda_6($intent) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, $intent.p11p_1);
    };
  }
  function CheckoutViewModel$handleIntent$lambda_7($intent) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, $intent.g11k_1);
    };
  }
  function CheckoutViewModel$handleIntent$lambda_8($intent) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.h11k_1);
    };
  }
  function CheckoutViewModel$handleIntent$lambda_9($intent) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.i11k_1);
    };
  }
  function CheckoutViewModel$handleIntent$lambda_10($intent) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.j11k_1);
    };
  }
  function CheckoutViewModel$handleIntent$lambda_11($intent) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.k11k_1);
    };
  }
  function CheckoutViewModel$handleIntent$lambda_12($intent) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.l11k_1);
    };
  }
  function CheckoutViewModel$handleIntent$lambda_13($this$updateState) {
    return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function CheckoutViewModel$handleIntent$slambda(this$0, $currentProfile, $currentState, resultContinuation) {
    this.y11p_1 = this$0;
    this.z11p_1 = $currentProfile;
    this.a11q_1 = $currentState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CheckoutViewModel$handleIntent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CheckoutViewModel$handleIntent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CheckoutViewModel$handleIntent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.b11q_1;
            this.o9_1 = 2;
            this.d11q_1 = Companion_instance_0;
            this.n9_1 = 1;
            var tmp0_$this = this.z11p_1;
            var tmp1_firstName = this.a11q_1.o11j_1;
            var tmp2_lastName = this.a11q_1.p11j_1;
            var tmp3_personalPhoneNumber = this.a11q_1.n11j_1;
            var tmp4_street = this.a11q_1.m11j_1;
            var tmp5_city = this.a11q_1.q11j_1;
            suspendResult = this.y11p_1.i11o_1.a103(tmp0_$this.uyn(VOID, VOID, tmp1_firstName, tmp2_lastName, VOID, VOID, tmp4_street, VOID, tmp5_city, VOID, VOID, VOID, tmp3_personalPhoneNumber), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            this.d11q_1;
            tmp_0.c11q_1 = _Result___init__impl__xyqfz8(tmp2);
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var e = this.q9_1;
              var tmp_2 = this;
              tmp_2.c11q_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 3) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(CheckoutViewModel$handleIntent$slambda).q24 = function ($this$launch, completion) {
    var i = new CheckoutViewModel$handleIntent$slambda(this.y11p_1, this.z11p_1, this.a11q_1, completion);
    i.b11q_1 = $this$launch;
    return i;
  };
  function CheckoutViewModel$handleIntent$slambda_0(this$0, $currentProfile, $currentState, resultContinuation) {
    var i = new CheckoutViewModel$handleIntent$slambda(this$0, $currentProfile, $currentState, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CheckoutViewModel$handleIntent$slambda_1($currentState, resultContinuation) {
    this.m11q_1 = $currentState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CheckoutViewModel$handleIntent$slambda_1).o11q = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CheckoutViewModel$handleIntent$slambda_1).ja = function (p1, $completion) {
    return this.o11q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CheckoutViewModel$handleIntent$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var sum = 0;
          var _iterator__ex2g4s = this.m11q_1.v11j_1.t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            var tmp_0 = sum;
            var tmp0_elvis_lhs = element.lyw_1;
            sum = tmp_0 + (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) * element.ryw_1;
          }
          var sub = sum;
          var sum_0 = 0;
          var _iterator__ex2g4s_0 = this.m11q_1.v11j_1.t();
          while (_iterator__ex2g4s_0.u()) {
            var element_0 = _iterator__ex2g4s_0.v();
            var tmp_1 = sum_0;
            var tmp0_elvis_lhs_0 = element_0.myw_1;
            var discountPrice = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
            var tmp_2;
            if (discountPrice > 0.0) {
              var tmp1_elvis_lhs = element_0.lyw_1;
              tmp_2 = ((tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs) - discountPrice) * element_0.ryw_1;
            } else {
              tmp_2 = 0.0;
            }
            sum_0 = tmp_1 + tmp_2;
          }
          var disc = sum_0;
          return to(sub, disc);
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CheckoutViewModel$handleIntent$slambda_1).q24 = function ($this$withContext, completion) {
    var i = new CheckoutViewModel$handleIntent$slambda_1(this.m11q_1, completion);
    i.n11q_1 = $this$withContext;
    return i;
  };
  function CheckoutViewModel$handleIntent$slambda_2($currentState, resultContinuation) {
    var i = new CheckoutViewModel$handleIntent$slambda_1($currentState, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.o11q($this$withContext, $completion);
    }, 1);
  }
  function CheckoutViewModel$handleIntent$lambda_14($this$updateState) {
    return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, false);
  }
  function CheckoutViewModel$handleIntent$lambda_15($this$updateState) {
    return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function CheckoutViewModel$handleIntent$lambda_16($this$updateState) {
    return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, false);
  }
  function CheckoutViewModel$handleIntent$lambda_17($this$updateState) {
    return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, false);
  }
  function CheckoutViewModel$handleIntent$lambda_18($intent) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.p11q_1);
    };
  }
  function CheckoutViewModel$handleIntent$lambda_19($intent) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.m11k_1, VOID, null);
    };
  }
  function CheckoutViewModel$handleIntent$lambda_20($code) {
    return function ($this$updateState) {
      return $this$updateState.f11k(true, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $code, VOID, null);
    };
  }
  function CheckoutViewModel$handleIntent$lambda_21($this$updateState) {
    var tmp0_couponError = new ResourceString(get_invalid_coupon_error(string_instance), []);
    return $this$updateState.f11k(false, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null, tmp0_couponError);
  }
  function CheckoutViewModel$handleIntent$lambda_22($this$updateState) {
    var tmp0_couponError = new ResourceString(get_coupon_already_used_error(string_instance), []);
    return $this$updateState.f11k(false, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null, tmp0_couponError);
  }
  function CheckoutViewModel$handleIntent$lambda_23($coupon) {
    return function ($this$updateState) {
      return $this$updateState.f11k(false, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $coupon, null);
    };
  }
  function CheckoutViewModel$fetchShippingCost$lambda($this$updateState) {
    return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true, null);
  }
  function CheckoutViewModel$fetchShippingCost$lambda_0($cost) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $cost, false);
    };
  }
  function CheckoutViewModel$fetchShippingCost$lambda_1($this$updateState) {
    return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, false, new ResourceString(get_no_internet_connection(string_instance), []));
  }
  function CheckoutViewModel$validate$lambda($trimmedAddress, $trimmedPhone, $trimmedFirstName, $trimmedLastName) {
    return function ($this$updateState) {
      return $this$updateState.f11k(VOID, VOID, VOID, VOID, VOID, VOID, $trimmedAddress, $trimmedPhone, $trimmedFirstName, $trimmedLastName);
    };
  }
  function $handleIntentCOROUTINE$_4(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y11q_1 = _this__u8e3s4;
    this.z11q_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_4).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 38;
            var tmp0_subject = this.z11q_1;
            if (equals(tmp0_subject, LoadData_instance)) {
              var currentState = this.y11q_1.s10h().ajg().u1();
              this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda(currentState));
              this.o9_1 = 35;
              this.n9_1 = 30;
              suspendResult = this.y11q_1.h11o_1.c102(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (equals(tmp0_subject, Retry_instance)) {
                this.n9_1 = 29;
                suspendResult = this.y11q_1.t11o(LoadData_instance, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (tmp0_subject instanceof ToggleShippingType) {
                  this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_5(this.z11q_1));
                  this.y11q_1.f11o_1.d8s('to_friend', this.z11q_1.o11p_1);
                  var state = this.y11q_1.s10h().ajg().u1();
                  var tmp_0;
                  if (this.z11q_1.o11p_1) {
                    var tmp4_safe_receiver = state.k11j_1;
                    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.az8_1;
                    tmp_0 = tmp5_elvis_lhs == null ? 'Other' : tmp5_elvis_lhs;
                  } else {
                    tmp_0 = state.q11j_1;
                  }
                  var gov = tmp_0;
                  this.n9_1 = 28;
                  suspendResult = fetchShippingCost(this.y11q_1, gov, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (tmp0_subject instanceof SelectFriend) {
                    this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_6(this.z11q_1));
                    this.n9_1 = 27;
                    var tmp6_elvis_lhs = this.z11q_1.p11p_1.az8_1;
                    suspendResult = fetchShippingCost(this.y11q_1, tmp6_elvis_lhs == null ? 'Other' : tmp6_elvis_lhs, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (tmp0_subject instanceof UpdateMyAddress) {
                      this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_7(this.z11q_1));
                      this.y11q_1.f11o_1.d8s('address', this.z11q_1.g11k_1);
                      this.n9_1 = 37;
                      continue $sm;
                    } else {
                      if (tmp0_subject instanceof UpdateMyPhone) {
                        if (this.y11q_1.s10h().ajg().u1().r11j_1) {
                          this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_8(this.z11q_1));
                          this.y11q_1.f11o_1.d8s('phone', this.z11q_1.h11k_1);
                        }
                        this.n9_1 = 37;
                        continue $sm;
                      } else {
                        if (tmp0_subject instanceof UpdateMyFirstName) {
                          this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_9(this.z11q_1));
                          this.y11q_1.f11o_1.d8s('first_name', this.z11q_1.i11k_1);
                          this.n9_1 = 37;
                          continue $sm;
                        } else {
                          if (tmp0_subject instanceof UpdateMyLastName) {
                            this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_10(this.z11q_1));
                            this.y11q_1.f11o_1.d8s('last_name', this.z11q_1.j11k_1);
                            this.n9_1 = 37;
                            continue $sm;
                          } else {
                            if (tmp0_subject instanceof UpdateMyGovernorate) {
                              this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_11(this.z11q_1));
                              this.y11q_1.f11o_1.d8s('governorate', this.z11q_1.k11k_1);
                              this.n9_1 = 26;
                              suspendResult = fetchShippingCost(this.y11q_1, this.z11q_1.k11k_1, this);
                              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                                return suspendResult;
                              }
                              continue $sm;
                            } else {
                              if (tmp0_subject instanceof SelectPaymentMethod) {
                                this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_12(this.z11q_1));
                                this.n9_1 = 37;
                                continue $sm;
                              } else {
                                if (equals(tmp0_subject, PlaceOrder_instance)) {
                                  if (this.y11q_1.s10h().ajg().u1().y11j_1)
                                    return Unit_instance;
                                  if (!this.y11q_1.p11o_1.ynu()) {
                                    this.n9_1 = 24;
                                    suspendResult = this.y11q_1.d10l(new ShowError_2(new ResourceString(get_checkout_no_internet(string_instance), [])), this);
                                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                                      return suspendResult;
                                    }
                                    continue $sm;
                                  } else {
                                    this.n9_1 = 16;
                                    suspendResult = validate(this.y11q_1, this);
                                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                                      return suspendResult;
                                    }
                                    continue $sm;
                                  }
                                } else {
                                  if (equals(tmp0_subject, RetryShippingFetch_instance)) {
                                    var state_0 = this.y11q_1.s10h().ajg().u1();
                                    var tmp_1;
                                    if (state_0.l11j_1) {
                                      var tmp32_safe_receiver = state_0.k11j_1;
                                      var tmp33_elvis_lhs = tmp32_safe_receiver == null ? null : tmp32_safe_receiver.az8_1;
                                      tmp_1 = tmp33_elvis_lhs == null ? 'Other' : tmp33_elvis_lhs;
                                    } else {
                                      tmp_1 = state_0.q11j_1;
                                    }
                                    var gov_0 = tmp_1;
                                    this.n9_1 = 15;
                                    suspendResult = fetchShippingCost(this.y11q_1, gov_0, this);
                                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                                      return suspendResult;
                                    }
                                    continue $sm;
                                  } else {
                                    if (tmp0_subject instanceof AddFriend) {
                                      this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_15);
                                      this.n9_1 = 2;
                                      continue $sm;
                                    } else {
                                      if (tmp0_subject instanceof ToggleAddFriendDialog) {
                                        this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_18(this.z11q_1));
                                        this.n9_1 = 37;
                                        continue $sm;
                                      } else {
                                        if (tmp0_subject instanceof UpdateCouponCode) {
                                          this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_19(this.z11q_1));
                                          this.y11q_1.f11o_1.d8s('coupon_code', this.z11q_1.m11k_1);
                                          this.n9_1 = 37;
                                          continue $sm;
                                        } else {
                                          if (equals(tmp0_subject, ApplyCoupon_instance)) {
                                            var this_0 = this.y11q_1.s10h().ajg().u1().b11k_1;
                                            var code = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
                                            if (isBlank(code))
                                              return Unit_instance;
                                            this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_20(code));
                                            this.n9_1 = 1;
                                            suspendResult = this.y11q_1.s11o_1.a102(code, this);
                                            if (suspendResult === get_COROUTINE_SUSPENDED()) {
                                              return suspendResult;
                                            }
                                            continue $sm;
                                          } else {
                                            noWhenBranchMatchedException();
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            break;
          case 1:
            var coupon = suspendResult;
            if (coupon == null) {
              this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_21);
            } else if (coupon.hzz_1) {
              this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_22);
            } else {
              this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_23(coupon));
            }

            this.n9_1 = 37;
            continue $sm;
          case 2:
            this.o9_1 = 14;
            this.o9_1 = 11;
            var currentProfile = this.y11q_1.g11o_1.ynu();
            if (!(currentProfile == null)) {
              var friendWithUserId = this.z11q_1.j11r_1.gz8(VOID, currentProfile.uym_1);
              this.n9_1 = 4;
              suspendResult = this.y11q_1.k11o_1.o103(friendWithUserId, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              suspendResult = this.y11q_1.d10l(new ShowError_2(new ResourceString(get_user_not_logged_in(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.n9_1 = 10;
            continue $sm;
          case 4:
            this.i11r_1 = suspendResult;
            if (!(this.z11q_1.k11r_1 == null) && !(this.i11r_1.tz7_1 == null)) {
              this.n9_1 = 5;
              suspendResult = this.y11q_1.l11o_1.w103(this.i11r_1.tz7_1, this.z11q_1.k11r_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 5:
            var imageUrl = suspendResult;
            this.n9_1 = 6;
            suspendResult = this.y11q_1.m11o_1.u103(this.i11r_1.gz8(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, imageUrl), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_16);
            this.n9_1 = 8;
            suspendResult = this.y11q_1.d10l(FriendAdded_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.n9_1 = 9;
            suspendResult = this.y11q_1.t11o(LoadData_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            this.n9_1 = 10;
            continue $sm;
          case 10:
            this.o9_1 = 38;
            this.n9_1 = 13;
            continue $sm;
          case 11:
            this.o9_1 = 14;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Exception) {
              var e = this.q9_1;
              this.n9_1 = 12;
              var tmp34_safe_receiver = e.message;
              var tmp_3;
              if (tmp34_safe_receiver == null) {
                tmp_3 = null;
              } else {
                tmp_3 = new DynamicString(tmp34_safe_receiver);
              }
              var tmp35_elvis_lhs = tmp_3;
              suspendResult = this.y11q_1.d10l(new ShowError_2(tmp35_elvis_lhs == null ? new ResourceString(get_unknown_error(string_instance), []) : tmp35_elvis_lhs), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 12:
            this.o9_1 = 38;
            this.n9_1 = 13;
            continue $sm;
          case 13:
            this.o9_1 = 38;
            this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_17);
            this.n9_1 = 37;
            continue $sm;
          case 14:
            this.o9_1 = 38;
            var t = this.q9_1;
            this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_17);
            throw t;
          case 15:
            this.n9_1 = 37;
            continue $sm;
          case 16:
            if (suspendResult) {
              this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_13);
              this.n9_1 = 17;
              continue $sm;
            } else {
              this.n9_1 = 25;
              continue $sm;
            }

          case 17:
            this.o9_1 = 23;
            this.o9_1 = 20;
            this.g11r_1 = this.y11q_1.s10h().ajg().u1();
            this.h11r_1 = this.y11q_1.g11o_1.ynu();
            if (!this.g11r_1.l11j_1 && !(this.h11r_1 == null)) {
              var hasChanges = !(this.h11r_1.wym_1 === this.g11r_1.o11j_1) || !(this.h11r_1.xym_1 === this.g11r_1.p11j_1) || !(this.h11r_1.gyn_1 === this.g11r_1.n11j_1) || !(this.h11r_1.ayn_1 === this.g11r_1.m11j_1) || !(this.h11r_1.cyn_1 === this.g11r_1.q11j_1);
              if (hasChanges) {
                var tmp_4 = get_viewModelScope(this.y11q_1);
                launch(tmp_4, VOID, VOID, CheckoutViewModel$handleIntent$slambda_0(this.y11q_1, this.h11r_1, this.g11r_1, null));
              }
            }

            var tmp_5 = this;
            var tmp_6;
            if (this.g11r_1.l11j_1) {
              var tmp7_safe_receiver = this.g11r_1.k11j_1;
              var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.vz7_1;
              tmp_6 = tmp8_elvis_lhs == null ? '' : tmp8_elvis_lhs;
            } else {
              tmp_6 = this.g11r_1.o11j_1 + ' ' + this.g11r_1.p11j_1;
            }

            tmp_5.f11r_1 = tmp_6;
            var tmp_7 = this;
            var tmp_8;
            if (this.g11r_1.l11j_1) {
              var tmp9_safe_receiver = this.g11r_1.k11j_1;
              var tmp10_elvis_lhs = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.uzz();
              tmp_8 = tmp10_elvis_lhs == null ? '' : tmp10_elvis_lhs;
            } else {
              tmp_8 = this.g11r_1.m11j_1 + ', ' + this.g11r_1.q11j_1;
            }

            tmp_7.e11r_1 = tmp_8;
            var tmp_9 = this;
            var tmp_10;
            if (this.g11r_1.l11j_1) {
              var tmp11_safe_receiver = this.g11r_1.k11j_1;
              var tmp12_elvis_lhs = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.cz8_1;
              tmp_10 = tmp12_elvis_lhs == null ? '' : tmp12_elvis_lhs;
            } else {
              tmp_10 = this.g11r_1.n11j_1;
            }

            tmp_9.d11r_1 = tmp_10;
            this.n9_1 = 18;
            var tmp_11 = Dispatchers_getInstance().i1h_1;
            suspendResult = withContext(tmp_11, CheckoutViewModel$handleIntent$slambda_2(this.g11r_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 18:
            var _destruct__k2r9zo = suspendResult;
            var subtotalResult = _destruct__k2r9zo.zh();
            var totalDiscountCalculated = _destruct__k2r9zo.ai();
            var subtotal = subtotalResult;
            var totalDiscount = totalDiscountCalculated;
            var shippingCost = this.g11r_1.s11j_1;
            var tmp13_safe_receiver = this.g11r_1.c11k_1;
            var tmp_12;
            if (tmp13_safe_receiver == null) {
              tmp_12 = null;
            } else {
              var tmp_13;
              switch (tmp13_safe_receiver.fzz_1.a1_1) {
                case 0:
                  tmp_13 = (subtotal - totalDiscount) * (tmp13_safe_receiver.gzz_1 / 100.0);
                  break;
                case 1:
                  tmp_13 = tmp13_safe_receiver.gzz_1;
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
              tmp_12 = tmp_13;
            }

            var tmp14_elvis_lhs = tmp_12;
            var couponDiscount = tmp14_elvis_lhs == null ? 0.0 : tmp14_elvis_lhs;
            totalDiscount = totalDiscount + couponDiscount;
            var tmp15_safe_receiver = this.h11r_1;
            var tmp19_userId = tmp15_safe_receiver == null ? null : tmp15_safe_receiver.uym_1;
            var tmp20_senderName = this.g11r_1.o11j_1 + ' ' + this.g11r_1.p11j_1;
            var tmp21_isForFriend = this.g11r_1.l11j_1;
            var tmp16_safe_receiver = this.g11r_1.k11j_1;
            var tmp22_friendId = tmp16_safe_receiver == null ? null : tmp16_safe_receiver.tz7_1;
            var tmp23_items = this.g11r_1.v11j_1;
            var tmp24_discount = totalDiscount;
            var tmp25_totalPrice = subtotal - totalDiscount + shippingCost;
            var tmp26_paymentMethod = this.g11r_1.w11j_1;
            var tmp17_safe_receiver = this.h11r_1;
            var tmp27_latLng = toString_0(tmp17_safe_receiver == null ? null : tmp17_safe_receiver.v101());
            var tmp28_createdAt = System_instance.fp().wp();
            var tmp29_updatedAt = System_instance.fp().wp();
            var tmp18_safe_receiver = this.g11r_1.c11k_1;
            var tmp30_couponId = tmp18_safe_receiver == null ? null : tmp18_safe_receiver.dzz_1;
            var order = new Order(null, tmp19_userId, tmp20_senderName, tmp21_isForFriend, tmp22_friendId, this.f11r_1, this.e11r_1, tmp27_latLng, this.d11r_1, tmp23_items, subtotal, tmp24_discount, shippingCost, tmp25_totalPrice, tmp26_paymentMethod, VOID, VOID, VOID, VOID, VOID, tmp28_createdAt, tmp29_updatedAt, tmp30_couponId);
            this.n9_1 = 19;
            suspendResult = this.y11q_1.d10l(new OrderPlaced(order), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 19:
            this.o9_1 = 38;
            this.n9_1 = 22;
            continue $sm;
          case 20:
            this.o9_1 = 23;
            var tmp_14 = this.q9_1;
            if (tmp_14 instanceof Exception) {
              var e_0 = this.q9_1;
              this.n9_1 = 21;
              var tmp31_elvis_lhs = e_0.message;
              suspendResult = this.y11q_1.d10l(new ShowError_2(new DynamicString(tmp31_elvis_lhs == null ? 'Failed to prepare order' : tmp31_elvis_lhs)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 21:
            this.o9_1 = 38;
            this.n9_1 = 22;
            continue $sm;
          case 22:
            this.o9_1 = 38;
            this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_14);
            this.n9_1 = 25;
            continue $sm;
          case 23:
            this.o9_1 = 38;
            var t_0 = this.q9_1;
            this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_14);
            throw t_0;
          case 24:
            this.n9_1 = 25;
            continue $sm;
          case 25:
            this.n9_1 = 37;
            continue $sm;
          case 26:
            this.n9_1 = 37;
            continue $sm;
          case 27:
            this.n9_1 = 37;
            continue $sm;
          case 28:
            this.n9_1 = 37;
            continue $sm;
          case 29:
            this.n9_1 = 37;
            continue $sm;
          case 30:
            this.a11r_1 = suspendResult;
            if (this.a11r_1 == null) {
              this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_0);
              return Unit_instance;
            }

            if (this.a11r_1.myn_1 === true) {
              this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_1);
              return Unit_instance;
            }

            var this_1 = this.y11q_1;
            this.o9_1 = 32;
            this.c11r_1 = Companion_instance_0;
            this.n9_1 = 31;
            suspendResult = this_1.j11o_1.s103(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 31:
            var tmp2 = suspendResult;
            var tmp_15 = this;
            this.c11r_1;
            tmp_15.b11r_1 = _Result___init__impl__xyqfz8(tmp2);
            this.o9_1 = 35;
            this.n9_1 = 33;
            continue $sm;
          case 32:
            this.o9_1 = 35;
            var tmp_16 = this.q9_1;
            if (tmp_16 instanceof Error) {
              var e_1 = this.q9_1;
              var tmp_17 = this;
              tmp_17.b11r_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n9_1 = 33;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 33:
            this.o9_1 = 35;
            var tmp0 = this.b11r_1;
            var tmp2_0 = emptyList();
            var tmp$ret$0;
            l$ret$1: do {
              if (_Result___get_isFailure__impl__jpiriv(tmp0)) {
                tmp$ret$0 = tmp2_0;
                break l$ret$1;
              }
              tmp$ret$0 = _Result___get_value__impl__bjfvqg(tmp0);
            }
             while (false);
            var friends = tmp$ret$0;
            var tmp1_elvis_lhs = this.a11r_1.cyn_1;
            var cityFromProfile = tmp1_elvis_lhs == null ? 'Other' : tmp1_elvis_lhs;
            var tmp0_0 = get_governorates();
            var tmp$ret$2 = Unit_instance;
            l$ret$3: do {
              var _iterator__ex2g4s = tmp0_0.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (element.l11r_1 === cityFromProfile || element.m11r_1 === cityFromProfile) {
                  tmp$ret$2 = element;
                  break l$ret$3;
                }
              }
              tmp$ret$2 = null;
            }
             while (false);
            var tmp2_safe_receiver = tmp$ret$2;
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.l11r_1;
            var initialGov = tmp3_elvis_lhs == null ? 'Other' : tmp3_elvis_lhs;
            this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_2(friends, this.a11r_1, initialGov));
            this.n9_1 = 34;
            suspendResult = fetchShippingCost(this.y11q_1, this.y11q_1.s10h().ajg().u1().q11j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 34:
            this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_3);
            this.o9_1 = 38;
            this.n9_1 = 36;
            continue $sm;
          case 35:
            this.o9_1 = 38;
            var tmp_18 = this.q9_1;
            if (tmp_18 instanceof Exception) {
              var e_2 = this.q9_1;
              this.y11q_1.x10k(CheckoutViewModel$handleIntent$lambda_4(e_2));
              this.n9_1 = 36;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 36:
            this.o9_1 = 38;
            this.n9_1 = 37;
            continue $sm;
          case 37:
            return Unit_instance;
          case 38:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_3 = $p;
        if (this.o9_1 === 38) {
          throw e_3;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_3;
        }
      }
     while (true);
  };
  function $fetchShippingCostCOROUTINE$(_this__u8e3s4, governorateName, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x11m_1 = _this__u8e3s4;
    this.y11m_1 = governorateName;
  }
  protoOf($fetchShippingCostCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.x11m_1.x10k(CheckoutViewModel$fetchShippingCost$lambda);
            this.n9_1 = 1;
            suspendResult = this.x11m_1.r11o_1.f106(this.y11m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var cost = suspendResult;
            if (!(cost == null)) {
              this.x11m_1.x10k(CheckoutViewModel$fetchShippingCost$lambda_0(cost));
            } else {
              this.x11m_1.x10k(CheckoutViewModel$fetchShippingCost$lambda_1);
            }

            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $validateCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h11n_1 = _this__u8e3s4;
  }
  protoOf($validateCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 14;
            this.q11n_1 = this.h11n_1.g11o_1.ynu();
            if (this.q11n_1 == null) {
              this.n9_1 = 13;
              suspendResult = this.h11n_1.d10l(new ShowError_2(new ResourceString(get_user_not_logged_in(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              continue $sm;
            }

          case 1:
            if (this.q11n_1.myn_1 === true) {
              this.n9_1 = 12;
              suspendResult = this.h11n_1.d10l(new ShowError_2(new ResourceString(get_user_banned_error(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            var currentState = this.h11n_1.s10h().ajg().u1();
            var tmp_0 = this;
            var this_0 = currentState.o11j_1;
            tmp_0.p11n_1 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
            var tmp_1 = this;
            var this_1 = currentState.p11j_1;
            tmp_1.o11n_1 = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
            var tmp_2 = this;
            var this_2 = currentState.m11j_1;
            tmp_2.n11n_1 = toString(trim(isCharSequence(this_2) ? this_2 : THROW_CCE()));
            var tmp_3 = this;
            var this_3 = currentState.n11j_1;
            tmp_3.l11n_1 = toString(trim(isCharSequence(this_3) ? this_3 : THROW_CCE()));
            this.h11n_1.x10k(CheckoutViewModel$validate$lambda(this.n11n_1, this.l11n_1, this.p11n_1, this.o11n_1));
            this.m11n_1 = this.h11n_1.s10h().ajg().u1();
            if (!(this.m11n_1.u11j_1 == null)) {
              this.n9_1 = 11;
              suspendResult = this.h11n_1.d10l(new ShowError_2(this.m11n_1.u11j_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            if (this.m11n_1.t11j_1) {
              return false;
            }

            if (this.m11n_1.l11j_1) {
              var selectedFriend = this.m11n_1.k11j_1;
              if (selectedFriend == null) {
                this.n9_1 = 8;
                suspendResult = this.h11n_1.d10l(new ShowError_2(new ResourceString(get_checkout_select_friend_error(string_instance), [])), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (isBlank(selectedFriend.vz7_1) || isBlank(selectedFriend.uzz()) || isBlank(selectedFriend.cz8_1)) {
                  this.n9_1 = 7;
                  suspendResult = this.h11n_1.d10l(new ShowError_2(new ResourceString(get_checkout_required_fields_error(string_instance), [])), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.j11n_1 = true;
                  this.n9_1 = 9;
                  continue $sm;
                }
              }
            } else {
              if (isBlank(this.p11n_1) || isBlank(this.o11n_1) || isBlank(this.n11n_1) || isBlank(this.l11n_1) || isBlank(this.m11n_1.q11j_1)) {
                this.n9_1 = 5;
                suspendResult = this.h11n_1.d10l(new ShowError_2(new ResourceString(get_checkout_required_fields_error(string_instance), [])), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (!isValidPhone(this.h11n_1, this.l11n_1)) {
                  this.n9_1 = 4;
                  suspendResult = this.h11n_1.d10l(new ShowError_2(new ResourceString(get_invalid_phone_format(string_instance), [])), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.k11n_1 = true;
                  this.n9_1 = 6;
                  continue $sm;
                }
              }
            }

          case 4:
            this.k11n_1 = false;
            this.n9_1 = 6;
            continue $sm;
          case 5:
            this.k11n_1 = false;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.i11n_1 = this.k11n_1;
            this.n9_1 = 10;
            continue $sm;
          case 7:
            this.j11n_1 = false;
            this.n9_1 = 9;
            continue $sm;
          case 8:
            this.j11n_1 = false;
            this.n9_1 = 9;
            continue $sm;
          case 9:
            this.i11n_1 = this.j11n_1;
            this.n9_1 = 10;
            continue $sm;
          case 10:
            return this.i11n_1;
          case 11:
            return false;
          case 12:
            return false;
          case 13:
            return false;
          case 14:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 14) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function CheckoutViewModel(savedStateHandle, getCurrentUserValueUseCase, fetchProfileUseCase, updateProfileUseCase, getFriendsUseCase, addFriendUseCase, uploadFriendAvatarUseCase, updateFriendUseCase, clearCartUseCase, getCartItemsUseCase, isConnectedUseCase, getLanguageUseCase, getShippingCostUseCase, applyCouponUseCase) {
    var tmp0_elvis_lhs = savedStateHandle.e8s('first_name');
    var tmp7_myFirstName = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = savedStateHandle.e8s('last_name');
    var tmp8_myLastName = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = savedStateHandle.e8s('address');
    var tmp9_myAddress = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
    var tmp3_elvis_lhs = savedStateHandle.e8s('phone');
    var tmp10_myPhone = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
    var tmp4_elvis_lhs = savedStateHandle.e8s('governorate');
    var tmp11_myGovernorate = tmp4_elvis_lhs == null ? 'Other' : tmp4_elvis_lhs;
    var tmp5_elvis_lhs = savedStateHandle.e8s('to_friend');
    var tmp12_isShippingToFriend = tmp5_elvis_lhs == null ? false : tmp5_elvis_lhs;
    var tmp6_elvis_lhs = savedStateHandle.e8s('coupon_code');
    var tmp13_couponCode = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
    BaseMviViewModel.call(this, new CheckoutState(VOID, VOID, VOID, VOID, VOID, tmp12_isShippingToFriend, tmp9_myAddress, tmp10_myPhone, tmp7_myFirstName, tmp8_myLastName, tmp11_myGovernorate, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp13_couponCode));
    this.f11o_1 = savedStateHandle;
    this.g11o_1 = getCurrentUserValueUseCase;
    this.h11o_1 = fetchProfileUseCase;
    this.i11o_1 = updateProfileUseCase;
    this.j11o_1 = getFriendsUseCase;
    this.k11o_1 = addFriendUseCase;
    this.l11o_1 = uploadFriendAvatarUseCase;
    this.m11o_1 = updateFriendUseCase;
    this.n11o_1 = clearCartUseCase;
    this.o11o_1 = getCartItemsUseCase;
    this.p11o_1 = isConnectedUseCase;
    this.q11o_1 = getLanguageUseCase;
    this.r11o_1 = getShippingCostUseCase;
    this.s11o_1 = applyCouponUseCase;
    var tmp = get_viewModelScope(this);
    launch(tmp, VOID, VOID, CheckoutViewModel$slambda_0(this, null));
    var tmp_0 = this.o11o_1.ynu();
    launchIn(onEach(tmp_0, CheckoutViewModel$slambda_2(this, null)), get_viewModelScope(this));
    var tmp_1 = this.q11o_1.y103();
    launchIn(onEach(tmp_1, CheckoutViewModel$slambda_4(this, null)), get_viewModelScope(this));
  }
  protoOf(CheckoutViewModel).t11o = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_4(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CheckoutViewModel).f10l = function (intent, $completion) {
    return this.t11o(isInterface(intent, CheckoutIntent) ? intent : THROW_CCE(), $completion);
  };
  function SectionHeader(title, icon, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1662628271);
    sourceInformation($composer_0, 'C(SectionHeader)P(1)29@1255L536:CheckoutComponents.kt#9i3n8u');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(title) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(icon) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1662628271, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.components.SectionHeader (CheckoutComponents.kt:28)');
      }
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = null;
      var horizontalArrangement = null;
      var verticalAlignment = Companion_getInstance_11().u8t_1;
      var $composer_1 = $composer_0;
      if (!((3 & 1) === 0))
        modifier = Companion_instance;
      if (!((3 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((3 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 384 >> 3 | 112 & 384 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 574027746, 'C33@1425L11,30@1317L346,38@1672L40,39@1721L64:CheckoutComponents.kt#9i3n8u');
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(36);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_1 = background(size(tmp_0, tmp$ret$6), MaterialTheme_instance.unz($composer_5, 6).znz_1, get_CircleShape());
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_6 = $composer_5;
      if (!((4 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((4 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((4 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_1 = $composer_8.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_0);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, 1420558540, 'C36@1600L11,36@1541L112:CheckoutComponents.kt#9i3n8u');
      var tmp0_tint = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
      var tmp_2 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$13 = _Dp___init__impl__ms3zkb(20);
      var tmp1_modifier = size(tmp_2, tmp$ret$13);
      Icon(icon, null, tmp1_modifier, tmp0_tint, $composer_10, 432 | 14 & $dirty >> 3, 0);
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      var tmp_3 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$14 = _Dp___init__impl__ms3zkb(12);
      Spacer(width(tmp_3, tmp$ret$14), $composer_5, 6);
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = get_sp(20);
      var tmp_6 = Companion_getInstance_16().f7z_1;
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextOverflow___init__impl__obguoe(0);
      Text(title, null, tmp_4, null, tmp_5, null, tmp_6, null, tmp_7, null, null, tmp_8, tmp_9, false, 0, 0, null, null, $composer_5, 1597440 | 14 & $dirty, 0, 262062);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(SectionHeader$lambda(title, icon, $changed));
    }
  }
  function OrderSummaryRow(label, value, color, isTotal, $composer, $changed, $default) {
    var color_0 = {_v: new Color_0(color)};
    var isTotal_0 = {_v: isTotal};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1972512661);
    sourceInformation($composer_0, 'C(OrderSummaryRow)P(2,3,0:c#ui.graphics.Color)145@6168L616:CheckoutComponents.kt#9i3n8u');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(label) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.p31(value) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | (($default & 4) === 0 && $composer_0.o31(_ULong___get_data__impl__fggpzb(_Color___get_value__impl__1pls5m(color_0._v.c6d_1))) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(isTotal_0._v) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      $composer_0.q30();
      sourceInformation($composer_0, '144@6113L11');
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 4) === 0)) {
          color_0._v = new Color_0(MaterialTheme_instance.unz($composer_0, 6).no0_1);
          $dirty = $dirty & -897;
        }
        if (!(($default & 8) === 0)) {
          isTotal_0._v = false;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 4) === 0))
          $dirty = $dirty & -897;
      }
      $composer_0.r30();
      if (isTraceInProgress()) {
        traceEventStart(1972512661, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.components.OrderSummaryRow (CheckoutComponents.kt:144)');
      }
      var tmp = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(4);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = padding_2(tmp, VOID, tmp$ret$0);
      var horizontalArrangement = Arrangement_getInstance().wdp_1;
      var verticalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((4 & 1) === 0))
        modifier = Companion_instance;
      if (!((4 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((4 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 54 >> 3 | 112 & 54 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -285091781, 'C149@6315L172,154@6496L282:CheckoutComponents.kt#9i3n8u');
      var tmp0_fontWeight = isTotal_0._v ? Companion_getInstance_16().e7z_1 : Companion_getInstance_16().b7z_1;
      var tmp1_fontSize = isTotal_0._v ? get_sp(18) : get_sp(14);
      var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(label, null, tmp_1, null, tmp1_fontSize, null, tmp0_fontWeight, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_5, 14 & $dirty, 0, 262062);
      var tmp2_text = toTwoDecimalString(value) + ' EGP';
      var tmp3_fontWeight = isTotal_0._v ? Companion_getInstance_16().g7z_1 : Companion_getInstance_16().c7z_1;
      var tmp4_fontSize = isTotal_0._v ? get_sp(18) : get_sp(14);
      var tmp_5;
      if (isTotal_0._v) {
        $composer_5.m30(1237742944);
        sourceInformation($composer_5, '158@6738L11');
        var tmp0_group = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
        $composer_5.n30();
        tmp_5 = tmp0_group;
      } else {
        $composer_5.m30(1237743358);
        $composer_5.n30();
        tmp_5 = color_0._v.c6d_1;
      }
      var tmp5_color = tmp_5;
      var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp2_text, null, tmp5_color, null, tmp4_fontSize, null, tmp3_fontWeight, null, tmp_6, null, null, tmp_7, tmp_8, false, 0, 0, null, null, $composer_5, 0, 0, 262058);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(OrderSummaryRow$lambda(label, value, color_0, isTotal_0, $changed, $default));
    }
  }
  function SectionHeader$lambda($title, $icon, $$changed) {
    return function ($composer, $force) {
      SectionHeader($title, $icon, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function OrderSummaryRow$lambda($label, $value, $color, $isTotal, $$changed, $$default) {
    return function ($composer, $force) {
      OrderSummaryRow($label, $value, $color._v.c6d_1, $isTotal._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function CouponSection(state, onIntent, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1593655448);
    sourceInformation($composer_0, 'C(CouponSection)P(1)19@678L1881:CouponSection.kt#9i3n8u');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onIntent) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1593655448, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.components.CouponSection (CouponSection.kt:18)');
      }
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = fillMaxWidth(Companion_instance);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -1652193677, 'C21@756L44,22@836L10,20@731L137,24@877L40,25@926L973:CouponSection.kt#9i3n8u');
      var tmp_0 = stringResource(get_coupon_code_label(string_instance), $composer_5, 0);
      var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_0, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, MaterialTheme_instance.jog($composer_5, 6).mof_1, $composer_5, 0, 0, 131070);
      var tmp_6 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(8);
      Spacer(height(tmp_6, tmp$ret$6), $composer_5, 6);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_1 = fillMaxWidth(Companion_instance);
      var horizontalArrangement = null;
      var verticalAlignment = Companion_getInstance_11().u8t_1;
      var $composer_6 = $composer_5;
      if (!((2 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((2 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((2 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_6, 14 & 390 >> 3 | 112 & 390 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_7 = $composer_8.g30();
      if (!isInterface(tmp_7, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_0);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, 867387354, 'C31@1155L49,29@1062L433,38@1508L39,40@1594L40,39@1560L329:CouponSection.kt#9i3n8u');
      var tmp0_value = state.b11k_1;
      var tmp1_modifier = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
      var tmp2_isError = !(state.d11k_1 == null);
      var tmp3_enabled = state.c11k_1 == null;
      sourceInformationMarkerStart($composer_10, -110564897, 'CC(remember):CouponSection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 112) === 32;
      // Inline function 'kotlin.let' call
      var it = $composer_10.i31();
      var tmp_8;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = CouponSection$lambda(onIntent);
        $composer_10.j31(value);
        tmp_8 = value;
      } else {
        tmp_8 = it;
      }
      var tmp0_group = tmp_8;
      sourceInformationMarkerEnd($composer_10);
      var tmp_9 = ComposableSingletons$CouponSectionKt_getInstance().o11r_1;
      OutlinedTextField(tmp0_value, tmp0_group, tmp1_modifier, tmp3_enabled, false, null, null, tmp_9, null, null, null, null, null, tmp2_isError, null, null, null, true, 0, 0, null, null, null, $composer_10, 12582912, 12582912, 0, 8249200);
      var tmp_10 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$17 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_10, tmp$ret$17), $composer_10, 6);
      var tmp_11;
      var tmp_12;
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = state.b11k_1;
      if (!isBlank(this_0)) {
        tmp_12 = state.c11k_1 == null;
      } else {
        tmp_12 = false;
      }
      if (tmp_12) {
        tmp_11 = !state.g11j_1;
      } else {
        tmp_11 = false;
      }
      var tmp4_enabled = tmp_11;
      var tmp_13 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$19 = _Dp___init__impl__ms3zkb(56);
      var tmp5_modifier = height(tmp_13, tmp$ret$19);
      sourceInformationMarkerStart($composer_10, -110550858, 'CC(remember):CouponSection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = ($dirty & 112) === 32;
      // Inline function 'kotlin.let' call
      var it_0 = $composer_10.i31();
      var tmp_14;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = CouponSection$lambda_0(onIntent);
        $composer_10.j31(value_0);
        tmp_14 = value_0;
      } else {
        tmp_14 = it_0;
      }
      var tmp1_group = tmp_14;
      sourceInformationMarkerEnd($composer_10);
      Button(tmp1_group, tmp5_modifier, tmp4_enabled, null, null, null, null, null, null, ComposableSingletons$CouponSectionKt_getInstance().p11r_1, $composer_10, 805306416, 504);
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      if (!(state.d11k_1 == null)) {
        $composer_5.m30(-1651021413);
        sourceInformation($composer_5, '50@2009L10,51@2059L11,52@2116L10,49@1962L245');
        var tmp0_text = state.d11k_1.s11k($composer_5, 0);
        var tmp1_color = MaterialTheme_instance.unz($composer_5, 6).to0_1;
        var tmp2_style = MaterialTheme_instance.jog($composer_5, 6).qof_1;
        var tmp_15 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$24 = _Dp___init__impl__ms3zkb(4);
        var tmp3_modifier = padding_1(tmp_15, VOID, tmp$ret$24);
        var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_17 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_18 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_19 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, tmp3_modifier, tmp1_color, null, tmp_16, null, null, null, tmp_17, null, null, tmp_18, tmp_19, false, 0, 0, null, tmp2_style, $composer_5, 48, 0, 131064);
        $composer_5.n30();
      } else {
        $composer_5.m30(-1650776048);
        $composer_5.n30();
      }
      if (!(state.c11k_1 == null)) {
        $composer_5.m30(-1650703477);
        sourceInformation($composer_5, '59@2311L49,61@2452L10,58@2282L261');
        var tmp4_text = stringResource(get_coupon_applied_success(string_instance), $composer_5, 0);
        var tmp5_color = Color(new Long(-11751600, 0));
        var tmp6_style = MaterialTheme_instance.jog($composer_5, 6).qof_1;
        var tmp_20 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$25 = _Dp___init__impl__ms3zkb(4);
        var tmp7_modifier = padding_1(tmp_20, VOID, tmp$ret$25);
        var tmp_21 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_22 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_23 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_24 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp4_text, tmp7_modifier, tmp5_color, null, tmp_21, null, null, null, tmp_22, null, null, tmp_23, tmp_24, false, 0, 0, null, tmp6_style, $composer_5, 432, 0, 131064);
        $composer_5.n30();
      } else {
        $composer_5.m30(-1650442736);
        $composer_5.n30();
      }
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(CouponSection$lambda_1(state, onIntent, $changed));
    }
  }
  function ComposableSingletons$CouponSectionKt$lambda$1253490037$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C33@1291L44,33@1286L50:CouponSection.kt#9i3n8u');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1253490037, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.ComposableSingletons$CouponSectionKt.lambda$1253490037.<anonymous> (CouponSection.kt:33)');
      }
      var tmp = stringResource(get_coupon_code_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CouponSectionKt$lambda$_784973346$lambda_z0lrpp($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C44@1831L43,44@1826L49:CouponSection.kt#9i3n8u');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-784973346, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.ComposableSingletons$CouponSectionKt.lambda$-784973346.<anonymous> (CouponSection.kt:44)');
      }
      var tmp = stringResource(get_apply_coupon_btn(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CouponSectionKt() {
    ComposableSingletons$CouponSectionKt_instance = this;
    var tmp = this;
    tmp.o11r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1253490037, false, ComposableSingletons$CouponSectionKt$lambda$1253490037$lambda));
    var tmp_0 = this;
    tmp_0.p11r_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-784973346, false, ComposableSingletons$CouponSectionKt$lambda$_784973346$lambda_z0lrpp));
  }
  var ComposableSingletons$CouponSectionKt_instance;
  function ComposableSingletons$CouponSectionKt_getInstance() {
    if (ComposableSingletons$CouponSectionKt_instance == null)
      new ComposableSingletons$CouponSectionKt();
    return ComposableSingletons$CouponSectionKt_instance;
  }
  function CouponSection$lambda($onIntent) {
    return function (it) {
      $onIntent(new UpdateCouponCode(it));
      return Unit_instance;
    };
  }
  function CouponSection$lambda_0($onIntent) {
    return function () {
      $onIntent(ApplyCoupon_instance);
      return Unit_instance;
    };
  }
  function CouponSection$lambda_1($state, $onIntent, $$changed) {
    return function ($composer, $force) {
      CouponSection($state, $onIntent, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function GovernorateSelectorSection(state, onIntent, modifier, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1016061782);
    sourceInformation($composer_0, 'C(GovernorateSelectorSection)P(2,1)30@1223L52,27@1084L226:DeliveryDetailsSection.kt#9i3n8u');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onIntent) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (isTraceInProgress()) {
        traceEventStart(-1016061782, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.components.GovernorateSelectorSection (DeliveryDetailsSection.kt:26)');
      }
      sourceInformationMarkerStart($composer_0, -1477787330, 'CC(remember):DeliveryDetailsSection.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 112) === 32;
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = GovernorateSelectorSection$lambda(onIntent);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      GovernorateDropdown(state.q11j_1, state.x11j_1, tmp0_group, modifier_0._v, $composer_0, 7168 & $dirty << 3, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(GovernorateSelectorSection$lambda_0(state, onIntent, modifier_0, $changed, $default));
    }
  }
  function DeliveryDetailsSection(state, onIntent, onVerifiedClick, modifier, $composer, $changed, $default) {
    var onVerifiedClick_0 = {_v: onVerifiedClick};
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1877259185);
    sourceInformation($composer_0, 'C(DeliveryDetailsSection)P(3,1,2)39@1454L2,42@1500L359:DeliveryDetailsSection.kt#9i3n8u');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onIntent) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onVerifiedClick_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        sourceInformationMarkerStart($composer_0, 159816563, 'CC(remember):DeliveryDetailsSection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = DeliveryDetailsSection$lambda;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var tmp0_group = tmp;
        sourceInformationMarkerEnd($composer_0);
        onVerifiedClick_0._v = tmp0_group;
      }
      if (!(($default & 8) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (isTraceInProgress()) {
        traceEventStart(1877259185, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.components.DeliveryDetailsSection (DeliveryDetailsSection.kt:41)');
      }
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var $changed_0 = 14 & $dirty >> 9;
      var modifier_1 = modifier_0._v;
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & $changed_0 >> 3 | 112 & $changed_0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1825039841, 'C43@1538L315:DeliveryDetailsSection.kt#9i3n8u');
      MyDetailsSection(state.o11j_1, state.p11j_1, state.m11j_1, state.n11j_1, state.r11j_1, onIntent, onVerifiedClick_0._v, $composer_5, 458752 & $dirty << 12 | 3670016 & $dirty << 12, 0);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(DeliveryDetailsSection$lambda_0(state, onIntent, onVerifiedClick_0, modifier_0, $changed, $default));
    }
  }
  function MyDetailsSection(firstName, lastName, address, phone, canChangePhone, onIntent, onVerifiedClick, $composer, $changed, $default) {
    var onVerifiedClick_0 = {_v: onVerifiedClick};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1575810331);
    sourceInformation($composer_0, 'C(MyDetailsSection)P(2,3!1,6)63@2093L2,65@2104L2107:DeliveryDetailsSection.kt#9i3n8u');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(firstName) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(lastName) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(address) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(phone) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.l31(canChangePhone) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onIntent) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(onVerifiedClick_0._v) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 599187) === 599186), $dirty & 1)) {
      if (!(($default & 64) === 0)) {
        sourceInformationMarkerStart($composer_0, 1769734119, 'CC(remember):DeliveryDetailsSection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = MyDetailsSection$lambda;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var tmp0_group = tmp;
        sourceInformationMarkerEnd($composer_0);
        onVerifiedClick_0._v = tmp0_group;
      }
      if (isTraceInProgress()) {
        traceEventStart(-1575810331, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.components.MyDetailsSection (DeliveryDetailsSection.kt:64)');
      }
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = fillMaxWidth(Companion_instance);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -1174179788, 'C68@2235L50,66@2157L308,73@2474L41,76@2601L49,74@2524L305,81@2838L41,85@2965L48,83@2889L310,90@3208L41,93@3332L46,91@3258L947:DeliveryDetailsSection.kt#9i3n8u');
      var tmp0_modifier = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$10 = _Dp___init__impl__ms3zkb(12);
      var tmp1_shape = RoundedCornerShape(tmp$ret$10);
      sourceInformationMarkerStart($composer_5, -1700444255, 'CC(remember):DeliveryDetailsSection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 458752) === 131072;
      // Inline function 'kotlin.let' call
      var it_0 = $composer_5.i31();
      var tmp_1;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = MyDetailsSection$lambda_0(onIntent);
        $composer_5.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp0_group_0 = tmp_1;
      sourceInformationMarkerEnd($composer_5);
      var tmp_2 = ComposableSingletons$DeliveryDetailsSectionKt_getInstance().q11r_1;
      OutlinedTextField(firstName, tmp0_group_0, tmp0_modifier, false, false, null, tmp_2, null, null, null, null, null, null, false, null, null, null, false, 0, 0, null, tmp1_shape, null, $composer_5, 1573248 | 14 & $dirty, 0, 0, 6291384);
      var tmp_3 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$15 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_3, tmp$ret$15), $composer_5, 6);
      var tmp2_modifier = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$16 = _Dp___init__impl__ms3zkb(12);
      var tmp3_shape = RoundedCornerShape(tmp$ret$16);
      sourceInformationMarkerStart($composer_5, -1700432544, 'CC(remember):DeliveryDetailsSection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = ($dirty & 458752) === 131072;
      // Inline function 'kotlin.let' call
      var it_1 = $composer_5.i31();
      var tmp_4;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = MyDetailsSection$lambda_1(onIntent);
        $composer_5.j31(value_1);
        tmp_4 = value_1;
      } else {
        tmp_4 = it_1;
      }
      var tmp1_group = tmp_4;
      sourceInformationMarkerEnd($composer_5);
      var tmp_5 = ComposableSingletons$DeliveryDetailsSectionKt_getInstance().r11r_1;
      OutlinedTextField(lastName, tmp1_group, tmp2_modifier, false, false, null, tmp_5, null, null, null, null, null, null, false, null, null, null, false, 0, 0, null, tmp3_shape, null, $composer_5, 1573248 | 14 & $dirty >> 3, 0, 0, 6291384);
      var tmp_6 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$21 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_6, tmp$ret$21), $composer_5, 6);
      var tmp4_modifier = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$22 = _Dp___init__impl__ms3zkb(12);
      var tmp5_shape = RoundedCornerShape(tmp$ret$22);
      sourceInformationMarkerStart($composer_5, -1700420897, 'CC(remember):DeliveryDetailsSection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = ($dirty & 458752) === 131072;
      // Inline function 'kotlin.let' call
      var it_2 = $composer_5.i31();
      var tmp_7;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = MyDetailsSection$lambda_2(onIntent);
        $composer_5.j31(value_2);
        tmp_7 = value_2;
      } else {
        tmp_7 = it_2;
      }
      var tmp2_group = tmp_7;
      sourceInformationMarkerEnd($composer_5);
      var tmp_8 = ComposableSingletons$DeliveryDetailsSectionKt_getInstance().s11r_1;
      OutlinedTextField(address, tmp2_group, tmp4_modifier, false, false, null, tmp_8, null, null, null, null, null, null, false, null, null, null, false, 0, 0, null, tmp5_shape, null, $composer_5, 1573248 | 14 & $dirty >> 6, 0, 0, 6291384);
      var tmp_9 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$27 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_9, tmp$ret$27), $composer_5, 6);
      var tmp6_readOnly = !canChangePhone;
      var tmp7_modifier = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$28 = _Dp___init__impl__ms3zkb(12);
      var tmp8_shape = RoundedCornerShape(tmp$ret$28);
      var tmp_10;
      if (!canChangePhone) {
        tmp_10 = ComposableSingletons$DeliveryDetailsSectionKt_getInstance().t11r_1;
      } else {
        tmp_10 = null;
      }
      var tmp9_supportingText = tmp_10;
      var tmp_11;
      if (!canChangePhone) {
        $composer_5.m30(-1172566890);
        sourceInformation($composer_5, '103@3854L317');
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(2000782770, true, MyDetailsSection$lambda_3(onVerifiedClick_0), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_6 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_6.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_3 = $composer_6.i31();
        var tmp_12;
        if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
          var value_3 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_6.j31(value_3);
          tmp_12 = value_3;
        } else {
          tmp_12 = it_3;
        }
        var tmp3_group = tmp_12;
        $composer_5.n30();
        tmp_11 = tmp3_group;
      } else {
        $composer_5.m30(-1172225426);
        $composer_5.n30();
        tmp_11 = null;
      }
      var tmp10_trailingIcon = tmp_11;
      sourceInformationMarkerStart($composer_5, -1700409155, 'CC(remember):DeliveryDetailsSection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = ($dirty & 458752) === 131072;
      // Inline function 'kotlin.let' call
      var it_4 = $composer_5.i31();
      var tmp_13;
      if (invalid_3 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = MyDetailsSection$lambda_4(onIntent);
        $composer_5.j31(value_4);
        tmp_13 = value_4;
      } else {
        tmp_13 = it_4;
      }
      var tmp4_group = tmp_13;
      sourceInformationMarkerEnd($composer_5);
      var tmp_14 = ComposableSingletons$DeliveryDetailsSectionKt_getInstance().v11r_1;
      OutlinedTextField(phone, tmp4_group, tmp7_modifier, canChangePhone, tmp6_readOnly, null, tmp_14, null, null, tmp10_trailingIcon, null, null, tmp9_supportingText, false, null, null, null, false, 0, 0, null, tmp8_shape, null, $composer_5, 1573248 | 14 & $dirty >> 9 | 7168 & $dirty >> 3, 0, 0, 6286752);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(MyDetailsSection$lambda_5(firstName, lastName, address, phone, canChangePhone, onIntent, onVerifiedClick_0, $changed, $default));
    }
  }
  function ComposableSingletons$DeliveryDetailsSectionKt$lambda$_1917504939$lambda_z9to8e($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C69@2314L43,69@2309L49:DeliveryDetailsSection.kt#9i3n8u');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1917504939, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.ComposableSingletons$DeliveryDetailsSectionKt.lambda$-1917504939.<anonymous> (DeliveryDetailsSection.kt:69)');
      }
      var tmp = stringResource(get_first_name_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$DeliveryDetailsSectionKt$lambda$_1560479106$lambda_b2h5fr($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C77@2679L42,77@2674L48:DeliveryDetailsSection.kt#9i3n8u');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1560479106, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.ComposableSingletons$DeliveryDetailsSectionKt.lambda$-1560479106.<anonymous> (DeliveryDetailsSection.kt:77)');
      }
      var tmp = stringResource(get_last_name_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$DeliveryDetailsSectionKt$lambda$1130484317$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C86@3042L49,86@3037L55:DeliveryDetailsSection.kt#9i3n8u');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1130484317, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.ComposableSingletons$DeliveryDetailsSectionKt.lambda$1130484317.<anonymous> (DeliveryDetailsSection.kt:86)');
      }
      var tmp = stringResource(get_delivery_address_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$DeliveryDetailsSectionKt$lambda$_2111041233$lambda_5k3f9e($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C100@3705L54,100@3700L60:DeliveryDetailsSection.kt#9i3n8u');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2111041233, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.ComposableSingletons$DeliveryDetailsSectionKt.lambda$-2111041233.<anonymous> (DeliveryDetailsSection.kt:100)');
      }
      var tmp = stringResource(get_phone_verified_call_support(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$DeliveryDetailsSectionKt$lambda$756229328$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C105@3940L191:DeliveryDetailsSection.kt#9i3n8u');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(756229328, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.ComposableSingletons$DeliveryDetailsSectionKt.lambda$756229328.<anonymous> (DeliveryDetailsSection.kt:105)');
      }
      var tmp = get_Verified(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, Color(new Long(-11751600, 0)), $composer_0, 3120, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$DeliveryDetailsSectionKt$lambda$_473519556$lambda_pb18op($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C96@3485L45,96@3480L51:DeliveryDetailsSection.kt#9i3n8u');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-473519556, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.ComposableSingletons$DeliveryDetailsSectionKt.lambda$-473519556.<anonymous> (DeliveryDetailsSection.kt:96)');
      }
      var tmp = stringResource(get_phone_number_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$DeliveryDetailsSectionKt() {
    ComposableSingletons$DeliveryDetailsSectionKt_instance = this;
    var tmp = this;
    tmp.q11r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1917504939, false, ComposableSingletons$DeliveryDetailsSectionKt$lambda$_1917504939$lambda_z9to8e));
    var tmp_0 = this;
    tmp_0.r11r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1560479106, false, ComposableSingletons$DeliveryDetailsSectionKt$lambda$_1560479106$lambda_b2h5fr));
    var tmp_1 = this;
    tmp_1.s11r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1130484317, false, ComposableSingletons$DeliveryDetailsSectionKt$lambda$1130484317$lambda));
    var tmp_2 = this;
    tmp_2.t11r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-2111041233, false, ComposableSingletons$DeliveryDetailsSectionKt$lambda$_2111041233$lambda_5k3f9e));
    var tmp_3 = this;
    tmp_3.u11r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(756229328, false, ComposableSingletons$DeliveryDetailsSectionKt$lambda$756229328$lambda));
    var tmp_4 = this;
    tmp_4.v11r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-473519556, false, ComposableSingletons$DeliveryDetailsSectionKt$lambda$_473519556$lambda_pb18op));
  }
  var ComposableSingletons$DeliveryDetailsSectionKt_instance;
  function ComposableSingletons$DeliveryDetailsSectionKt_getInstance() {
    if (ComposableSingletons$DeliveryDetailsSectionKt_instance == null)
      new ComposableSingletons$DeliveryDetailsSectionKt();
    return ComposableSingletons$DeliveryDetailsSectionKt_instance;
  }
  function GovernorateSelectorSection$lambda($onIntent) {
    return function (it) {
      $onIntent(new UpdateMyGovernorate(it));
      return Unit_instance;
    };
  }
  function GovernorateSelectorSection$lambda_0($state, $onIntent, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      GovernorateSelectorSection($state, $onIntent, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function DeliveryDetailsSection$lambda() {
    return Unit_instance;
  }
  function DeliveryDetailsSection$lambda_0($state, $onIntent, $onVerifiedClick, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      DeliveryDetailsSection($state, $onIntent, $onVerifiedClick._v, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function MyDetailsSection$lambda() {
    return Unit_instance;
  }
  function MyDetailsSection$lambda_0($onIntent) {
    return function (it) {
      $onIntent(new UpdateMyFirstName(it));
      return Unit_instance;
    };
  }
  function MyDetailsSection$lambda_1($onIntent) {
    return function (it) {
      $onIntent(new UpdateMyLastName(it));
      return Unit_instance;
    };
  }
  function MyDetailsSection$lambda_2($onIntent) {
    return function (it) {
      $onIntent(new UpdateMyAddress(it));
      return Unit_instance;
    };
  }
  function MyDetailsSection$lambda_3($onVerifiedClick) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C104@3876L277:DeliveryDetailsSection.kt#9i3n8u');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2000782770, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.MyDetailsSection.<anonymous>.<anonymous> (DeliveryDetailsSection.kt:104)');
        }
        var tmp_0 = $onVerifiedClick._v;
        IconButton(tmp_0, null, false, null, null, null, ComposableSingletons$DeliveryDetailsSectionKt_getInstance().u11r_1, $composer_0, 1572864, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function MyDetailsSection$lambda_4($onIntent) {
    return function (it) {
      $onIntent(new UpdateMyPhone(it));
      return Unit_instance;
    };
  }
  function MyDetailsSection$lambda_5($firstName, $lastName, $address, $phone, $canChangePhone, $onIntent, $onVerifiedClick, $$changed, $$default) {
    return function ($composer, $force) {
      MyDetailsSection($firstName, $lastName, $address, $phone, $canChangePhone, $onIntent, $onVerifiedClick._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function GovernorateDropdown(selectedGovernorate, language, onGovernorateSelected, modifier, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-624776824);
    sourceInformation($composer_0, 'C(GovernorateDropdown)P(3!1,2)31@1301L34,39@1611L24,41@1671L1186,37@1531L1326:GovernorateDropdown.kt#9i3n8u');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(selectedGovernorate) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onGovernorateSelected) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (isTraceInProgress()) {
        traceEventStart(-624776824, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.components.GovernorateDropdown (GovernorateDropdown.kt:30)');
      }
      sourceInformationMarkerStart($composer_0, 884899466, 'CC(remember):GovernorateDropdown.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = mutableStateOf(false);
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var expanded$delegate = tmp0_group;
      // Inline function 'kotlin.collections.find' call
      var tmp0 = get_governorates();
      var tmp$ret$5;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          if (element.l11r_1 === selectedGovernorate) {
            tmp$ret$5 = element;
            break $l$block;
          }
        }
        tmp$ret$5 = null;
      }
      var tmp0_safe_receiver = tmp$ret$5;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = language === 'ar' ? tmp0_safe_receiver.m11r_1 : tmp0_safe_receiver.l11r_1;
      }
      var tmp1_elvis_lhs = tmp_0;
      var displayGovernorate = tmp1_elvis_lhs == null ? selectedGovernorate : tmp1_elvis_lhs;
      var tmp_1 = GovernorateDropdown$lambda(expanded$delegate);
      sourceInformationMarkerStart($composer_0, 884909376, 'CC(remember):GovernorateDropdown.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_2;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = GovernorateDropdown$lambda_1(expanded$delegate);
        this_1.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      var tmp_3 = modifier_0._v;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(1627149598, true, GovernorateDropdown$lambda_2(displayGovernorate, expanded$delegate, onGovernorateSelected, language), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_1.i31();
      var tmp_4;
      if (invalid || it_1 === Companion_getInstance().f30_1) {
        var value_1 = ComposableLambda$invoke$ref_9(dispatchReceiver);
        $composer_1.j31(value_1);
        tmp_4 = value_1;
      } else {
        tmp_4 = it_1;
      }
      var tmp$ret$13 = tmp_4;
      ExposedDropdownMenuBox(tmp_1, tmp1_group, tmp_3, tmp$ret$13, $composer_0, 3120 | 896 & $dirty >> 3, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver = $composer_0.t30();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.p3c(GovernorateDropdown$lambda_3(selectedGovernorate, language, onGovernorateSelected, modifier_0, $changed, $default));
    }
  }
  function ComposableSingletons$GovernorateDropdownKt$lambda$8403384$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C45@1800L37,45@1795L43:GovernorateDropdown.kt#9i3n8u');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(8403384, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.ComposableSingletons$GovernorateDropdownKt.lambda$8403384.<anonymous> (GovernorateDropdown.kt:45)');
      }
      var tmp = stringResource(get_city_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$GovernorateDropdownKt() {
    ComposableSingletons$GovernorateDropdownKt_instance = this;
    var tmp = this;
    tmp.w11r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(8403384, false, ComposableSingletons$GovernorateDropdownKt$lambda$8403384$lambda));
  }
  var ComposableSingletons$GovernorateDropdownKt_instance;
  function ComposableSingletons$GovernorateDropdownKt_getInstance() {
    if (ComposableSingletons$GovernorateDropdownKt_instance == null)
      new ComposableSingletons$GovernorateDropdownKt();
    return ComposableSingletons$GovernorateDropdownKt_instance;
  }
  function GovernorateDropdown$lambda($expanded$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('expanded', KMutableProperty0, true);
    return $expanded$delegate.u1();
  }
  function GovernorateDropdown$lambda_0($expanded$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('expanded', KMutableProperty0, true);
    $expanded$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function GovernorateDropdown$lambda_1($expanded$delegate) {
    return function (it) {
      GovernorateDropdown$lambda_0($expanded$delegate, !GovernorateDropdown$lambda($expanded$delegate));
      return Unit_instance;
    };
  }
  function GovernorateDropdown$lambda$lambda(it) {
    return Unit_instance;
  }
  function GovernorateDropdown$lambda$lambda_0($expanded$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C52@2134L33:GovernorateDropdown.kt#9i3n8u');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1692332715, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.GovernorateDropdown.<anonymous>.<anonymous> (GovernorateDropdown.kt:52)');
        }
        var tmp_0 = ExposedDropdownMenuDefaults_getInstance();
        var tmp_1 = GovernorateDropdown$lambda($expanded$delegate);
        tmp_0.zp6(tmp_1, null, $composer_0, 384, 2);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function GovernorateDropdown$lambda$lambda_1($expanded$delegate) {
    return function () {
      GovernorateDropdown$lambda_0($expanded$delegate, false);
      return Unit_instance;
    };
  }
  function GovernorateDropdown$lambda$lambda$lambda($language, $gov) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C63@2500L63:GovernorateDropdown.kt#9i3n8u');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2092365233, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.GovernorateDropdown.<anonymous>.<anonymous>.<anonymous>.<anonymous> (GovernorateDropdown.kt:63)');
        }
        var tmp_0 = $language === 'ar' ? $gov.m11r_1 : $gov.l11r_1;
        var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function GovernorateDropdown$lambda$lambda$lambda_0($onGovernorateSelected, $gov, $expanded$delegate) {
    return function () {
      $onGovernorateSelected($gov.l11r_1);
      GovernorateDropdown$lambda_0($expanded$delegate, false);
      return Unit_instance;
    };
  }
  function GovernorateDropdown$lambda$lambda_2($onGovernorateSelected, $language, $expanded$delegate) {
    return function ($this$ExposedDropdownMenu, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C*63@2498L67,64@2597L127,62@2453L374:GovernorateDropdown.kt#9i3n8u');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1247856476, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.GovernorateDropdown.<anonymous>.<anonymous> (GovernorateDropdown.kt:61)');
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = get_governorates().t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(2092365233, true, GovernorateDropdown$lambda$lambda$lambda($language, element), $composer_0, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_1 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_1.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it = $composer_1.i31();
          var tmp_0;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_1.j31(value);
            tmp_0 = value;
          } else {
            tmp_0 = it;
          }
          var tmp_1 = tmp_0;
          sourceInformationMarkerStart($composer_0, 1902919488, 'CC(remember):GovernorateDropdown.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = !!($composer_0.k31($onGovernorateSelected) | $composer_0.k31(element));
          // Inline function 'kotlin.let' call
          var it_0 = $composer_0.i31();
          var tmp_2;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = GovernorateDropdown$lambda$lambda$lambda_0($onGovernorateSelected, element, $expanded$delegate);
            $composer_0.j31(value_0);
            tmp_2 = value_0;
          } else {
            tmp_2 = it_0;
          }
          var tmp0_group = tmp_2;
          sourceInformationMarkerEnd($composer_0);
          var tmp_3 = ExposedDropdownMenuDefaults_getInstance().yp6_1;
          DropdownMenuItem(tmp_1, tmp0_group, null, null, null, false, null, tmp_3, null, $composer_0, 6, 380);
        }
        var tmp_4;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_4 = Unit_instance;
        }
        tmp = tmp_4;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function GovernorateDropdown$lambda_2($displayGovernorate, $expanded$delegate, $onGovernorateSelected, $language) {
    return function ($this$ExposedDropdownMenuBox, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C54@2232L25,44@1768L3,51@2088L93,42@1681L586,59@2362L20,60@2393L458,57@2277L574:GovernorateDropdown.kt#9i3n8u');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31($this$ExposedDropdownMenuBox) : $composer_0.q31($this$ExposedDropdownMenuBox)) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1627149598, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.components.GovernorateDropdown.<anonymous> (GovernorateDropdown.kt:42)');
        }
        var tmp0_modifier = $this$ExposedDropdownMenuBox.rp6(fillMaxWidth(Companion_instance), Companion_getInstance_22().lp6_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
        var tmp1_shape = RoundedCornerShape(tmp$ret$0);
        var tmp_1 = ExposedDropdownMenuDefaults_getInstance();
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_8 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_13 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_14 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_15 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_16 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_17 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_18 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_19 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_20 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_21 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_22 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_23 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_24 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_25 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_26 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_27 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_28 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_29 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_30 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_31 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_32 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_33 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_34 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_35 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_36 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_37 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_38 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp2_colors = tmp_1.ap7(tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, null, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 0, 0, 805306368, 2147483647, 255);
        sourceInformationMarkerStart($composer_0, 322671041, 'CC(remember):GovernorateDropdown.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_39;
        if (false || it === Companion_getInstance().f30_1) {
          var value = GovernorateDropdown$lambda$lambda;
          $composer_0.j31(value);
          tmp_39 = value;
        } else {
          tmp_39 = it;
        }
        var tmp0_group = tmp_39;
        sourceInformationMarkerEnd($composer_0);
        var tmp_40 = ComposableSingletons$GovernorateDropdownKt_getInstance().w11r_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1692332715, true, GovernorateDropdown$lambda$lambda_0($expanded$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_41;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_41 = value_0;
        } else {
          tmp_41 = it_0;
        }
        var tmp_42 = tmp_41;
        OutlinedTextField($displayGovernorate, tmp0_group, tmp0_modifier, false, true, null, tmp_40, null, null, tmp_42, null, null, null, false, null, null, null, false, 0, 0, null, tmp1_shape, tmp2_colors, $composer_0, 806903856, 0, 0, 2096552);
        var tmp_43 = GovernorateDropdown$lambda($expanded$delegate);
        sourceInformationMarkerStart($composer_0, 322690066, 'CC(remember):GovernorateDropdown.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_44;
        if (false || it_1 === Companion_getInstance().f30_1) {
          var value_1 = GovernorateDropdown$lambda$lambda_1($expanded$delegate);
          $composer_0.j31(value_1);
          tmp_44 = value_1;
        } else {
          tmp_44 = it_1;
        }
        var tmp1_group = tmp_44;
        sourceInformationMarkerEnd($composer_0);
        var tmp_45 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_46 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_47 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(1247856476, true, GovernorateDropdown$lambda$lambda_2($onGovernorateSelected, $language, $expanded$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_2.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_2 = $composer_2.i31();
        var tmp_48;
        if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
          var value_2 = ComposableLambda$invoke$ref_6(dispatchReceiver_0);
          $composer_2.j31(value_2);
          tmp_48 = value_2;
        } else {
          tmp_48 = it_2;
        }
        var tmp$ret$16 = tmp_48;
        $this$ExposedDropdownMenuBox.pp6(tmp_43, tmp1_group, null, null, false, null, tmp_45, tmp_46, tmp_47, null, tmp$ret$16, $composer_0, 48, 6 | androidx_compose_material3_ExposedDropdownMenuBoxScope$stableprop_getter() << 3 | 112 & $dirty << 3, 1020);
        var tmp_49;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_49 = Unit_instance;
        }
        tmp_0 = tmp_49;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_9(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function GovernorateDropdown$lambda_3($selectedGovernorate, $language, $onGovernorateSelected, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      GovernorateDropdown($selectedGovernorate, $language, $onGovernorateSelected, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function OrderSummarySection(state, onIntent, modifier, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(312645639);
    sourceInformation($composer_0, 'C(OrderSummarySection)P(2,1)23@878L3129:OrderSummarySection.kt#9i3n8u');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onIntent) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (isTraceInProgress()) {
        traceEventStart(312645639, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.components.OrderSummarySection (OrderSummarySection.kt:22)');
      }
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var $changed_0 = 14 & $dirty >> 6;
      var modifier_1 = modifier_0._v;
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & $changed_0 >> 3 | 112 & $changed_0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 636599609, 'C36@1492L41,36@1468L84,48@2055L1674,85@3825L11,85@3739L113,86@3885L44,86@3861L140:OrderSummarySection.kt#9i3n8u');
      // Inline function 'kotlin.collections.sumOf' call
      var sum = 0;
      var _iterator__ex2g4s = state.v11j_1.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var tmp_0 = sum;
        var tmp0_elvis_lhs = element.lyw_1;
        sum = tmp_0 + (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) * element.ryw_1;
      }
      var subtotal = sum;
      // Inline function 'kotlin.collections.sumOf' call
      var sum_0 = 0;
      var _iterator__ex2g4s_0 = state.v11j_1.t();
      while (_iterator__ex2g4s_0.u()) {
        var element_0 = _iterator__ex2g4s_0.v();
        var tmp_1 = sum_0;
        var tmp0_elvis_lhs_0 = element_0.myw_1;
        sum_0 = tmp_1 + (tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0) * element_0.ryw_1;
      }
      var productDiscount = sum_0;
      var tmp0_safe_receiver = state.c11k_1;
      var tmp_2;
      if (tmp0_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_3;
        switch (tmp0_safe_receiver.fzz_1.a1_1) {
          case 0:
            tmp_3 = (subtotal - productDiscount) * (tmp0_safe_receiver.gzz_1 / 100.0);
            break;
          case 1:
            tmp_3 = tmp0_safe_receiver.gzz_1;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp_2 = tmp_3;
      }
      var tmp1_elvis_lhs = tmp_2;
      var couponDiscount = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
      var totalDiscount = productDiscount + couponDiscount;
      var tmp_4 = stringResource(get_order_subtotal(string_instance), $composer_5, 0);
      var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      OrderSummaryRow(tmp_4, subtotal, tmp_5, false, $composer_5, 0, 12);
      if (productDiscount > 0) {
        $composer_5.m30(637173480);
        sourceInformation($composer_5, '38@1624L41,38@1715L11,38@1600L133');
        var tmp_6 = stringResource(get_order_discount(string_instance), $composer_5, 0);
        var tmp_7 = -productDiscount;
        var tmp_8 = MaterialTheme_instance.unz($composer_5, 6).to0_1;
        OrderSummaryRow(tmp_6, tmp_7, tmp_8, false, $composer_5, 0, 8);
        $composer_5.n30();
      } else {
        $composer_5.m30(637324357);
        $composer_5.n30();
      }
      if (couponDiscount > 0) {
        $composer_5.m30(637365184);
        sourceInformation($composer_5, '42@1831L44,44@1994L11,41@1790L237');
        var tmp_9 = stringResource(get_coupon_code_label(string_instance), $composer_5, 0);
        var tmp2_safe_receiver = state.c11k_1;
        var tmp_10 = tmp_9 + (' (' + (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.ezz_1) + ')');
        var tmp_11 = -couponDiscount;
        var tmp_12 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
        OrderSummaryRow(tmp_10, tmp_11, tmp_12, false, $composer_5, 0, 8);
        $composer_5.n30();
      } else {
        $composer_5.m30(637616005);
        $composer_5.n30();
      }
      var tmp_13 = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$12 = _Dp___init__impl__ms3zkb(4);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_3 = padding_2(tmp_13, VOID, tmp$ret$12);
      var horizontalArrangement = Arrangement_getInstance().wdp_1;
      var verticalAlignment = Companion_getInstance_11().u8t_1;
      var $composer_6 = $composer_5;
      if (!((0 & 1) === 0))
        modifier_3 = Companion_instance;
      if (!((0 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_6, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_4 = modifier_3;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_4 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_4);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_14 = $composer_8.g30();
      if (!isInterface(tmp_14, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_0);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, 1432224193, 'C53@2283L46,53@2353L10,53@2278L97:OrderSummarySection.kt#9i3n8u');
      var tmp_15 = stringResource(get_order_shipping_cost(string_instance), $composer_10, 0);
      var tmp_16 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_17 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_18 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_20 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_15, null, tmp_16, null, tmp_17, null, null, null, tmp_18, null, null, tmp_19, tmp_20, false, 0, 0, null, MaterialTheme_instance.jog($composer_10, 6).pof_1, $composer_10, 0, 0, 131070);
      if (state.t11j_1) {
        $composer_10.m30(1432354795);
        sourceInformation($composer_10, '57@2473L78');
        var tmp_21 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$19 = _Dp___init__impl__ms3zkb(16);
        var tmp_22 = size(tmp_21, tmp$ret$19);
        var tmp_23 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_24 = _Dp___init__impl__ms3zkb(2);
        var tmp_25 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_26 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, _Dp___init__impl__ms3zkb(0.0), $composer_10, 390, 58);
        $composer_10.n30();
      } else if (!(state.u11j_1 == null)) {
        $composer_10.m30(1432540981);
        sourceInformation($composer_10, '60@2639L772');
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_5 = null;
        var horizontalArrangement_0 = null;
        var verticalAlignment_0 = Companion_getInstance_11().u8t_1;
        var $composer_11 = $composer_10;
        if (!((3 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((3 & 2) === 0))
          horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
        if (!((3 & 4) === 0))
          verticalAlignment_0 = Companion_getInstance_11().t8t_1;
        var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_11, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_12 = $composer_11;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
        var localMap_1 = $composer_12.t31();
        var materialized_1 = materialize($composer_12, modifier_6);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_13 = $composer_12;
        var tmp_27 = $composer_13.g30();
        if (!isInterface(tmp_27, Applier)) {
          invalidApplier();
        }
        $composer_13.b31();
        if ($composer_13.h30()) {
          $composer_13.c31(tmp0_1);
        } else {
          $composer_13.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_14 = $composer_13;
        var $composer_15 = $composer_14;
        sourceInformationMarkerStart($composer_15, 1492276029, 'C62@2778L10,63@2840L11,64@2909L10,61@2717L307,68@3099L47,67@3049L340:OrderSummarySection.kt#9i3n8u');
        var tmp0_text = state.u11j_1.s11k($composer_15, 0);
        var tmp1_color = MaterialTheme_instance.unz($composer_15, 6).to0_1;
        var tmp2_style = MaterialTheme_instance.jog($composer_15, 6).qof_1;
        var tmp_28 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$27 = _Dp___init__impl__ms3zkb(8);
        var tmp3_modifier = padding_1(tmp_28, VOID, VOID, tmp$ret$27);
        var tmp_29 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_30 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_31 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_32 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, tmp3_modifier, tmp1_color, null, tmp_29, null, null, null, tmp_30, null, null, tmp_31, tmp_32, false, 0, 0, null, tmp2_style, $composer_15, 48, 0, 131064);
        sourceInformationMarkerStart($composer_15, 1849264853, 'CC(remember):OrderSummarySection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = ($dirty & 112) === 32;
        // Inline function 'kotlin.let' call
        var it = $composer_15.i31();
        var tmp_33;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = OrderSummarySection$lambda(onIntent);
          $composer_15.j31(value);
          tmp_33 = value;
        } else {
          tmp_33 = it;
        }
        var tmp0_group = tmp_33;
        sourceInformationMarkerEnd($composer_15);
        var tmp_34 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$32 = _Dp___init__impl__ms3zkb(24);
        var tmp_35 = size(tmp_34, tmp$ret$32);
        IconButton(tmp0_group, tmp_35, false, null, null, null, ComposableSingletons$OrderSummarySectionKt_getInstance().x11r_1, $composer_15, 1572912, 60);
        sourceInformationMarkerEnd($composer_15);
        $composer_13.e31();
        $composer_10.n30();
      } else {
        $composer_10.m30(1433374478);
        sourceInformation($composer_10, '78@3588L10,76@3476L211');
        var tmp0_text_0 = '' + state.s11j_1 + ' EGP';
        var tmp1_style = MaterialTheme_instance.jog($composer_10, 6).pof_1;
        var tmp2_fontWeight = Companion_getInstance_16().c7z_1;
        var tmp_36 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_37 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_38 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_39 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_40 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text_0, null, tmp_36, null, tmp_37, null, tmp2_fontWeight, null, tmp_38, null, null, tmp_39, tmp_40, false, 0, 0, null, tmp1_style, $composer_10, 1572864, 0, 131006);
        $composer_10.n30();
      }
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      var tmp_41 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$33 = _Dp___init__impl__ms3zkb(8);
      var tmp_42 = padding_2(tmp_41, VOID, tmp$ret$33);
      HorizontalDivider(tmp_42, _Dp___init__impl__ms3zkb(0.0), MaterialTheme_instance.unz($composer_5, 6).oo0_1, $composer_5, 6, 2);
      var tmp_43 = stringResource(get_total_price_label(string_instance), $composer_5, 0);
      var tmp_44 = subtotal - totalDiscount + state.s11j_1;
      OrderSummaryRow(tmp_43, tmp_44, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), true, $composer_5, 3072, 4);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver_0 = $composer_0.t30();
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      tmp0_safe_receiver_0.p3c(OrderSummarySection$lambda_0(state, onIntent, modifier_0, $changed, $default));
    }
  }
  function ComposableSingletons$OrderSummarySectionKt$lambda$1081143108$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C71@3343L11,71@3264L99:OrderSummarySection.kt#9i3n8u');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1081143108, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.ComposableSingletons$OrderSummarySectionKt.lambda$1081143108.<anonymous> (OrderSummarySection.kt:71)');
      }
      var tmp = get_Refresh(Icons_getInstance().dxv_1);
      Icon(tmp, 'Retry', null, MaterialTheme_instance.unz($composer_0, 6).xnz_1, $composer_0, 48, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderSummarySectionKt() {
    ComposableSingletons$OrderSummarySectionKt_instance = this;
    var tmp = this;
    tmp.x11r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1081143108, false, ComposableSingletons$OrderSummarySectionKt$lambda$1081143108$lambda));
  }
  var ComposableSingletons$OrderSummarySectionKt_instance;
  function ComposableSingletons$OrderSummarySectionKt_getInstance() {
    if (ComposableSingletons$OrderSummarySectionKt_instance == null)
      new ComposableSingletons$OrderSummarySectionKt();
    return ComposableSingletons$OrderSummarySectionKt_instance;
  }
  function OrderSummarySection$lambda($onIntent) {
    return function () {
      $onIntent(RetryShippingFetch_instance);
      return Unit_instance;
    };
  }
  function OrderSummarySection$lambda_0($state, $onIntent, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      OrderSummarySection($state, $onIntent, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function PaymentMethodSection(selectedMethod, onMethodSelected, modifier, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-835146221);
    sourceInformation($composer_0, 'C(PaymentMethodSection)P(2,1)28@1166L518:PaymentMethodSection.kt#9i3n8u');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.m31(selectedMethod.a1_1) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onMethodSelected) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (isTraceInProgress()) {
        traceEventStart(-835146221, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.components.PaymentMethodSection (PaymentMethodSection.kt:27)');
      }
      var tmp0 = modifier_0._v;
      var tmp = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var $changed_0 = 48 | 14 & $dirty >> 6;
      var modifier_1 = tmp0;
      var verticalArrangement = tmp.mdq(tmp$ret$0);
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((4 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((4 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((4 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & $changed_0 >> 3 | 112 & $changed_0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0_0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -249123117, 'C31@1347L49,32@1421L55,35@1616L52,29@1255L423:PaymentMethodSection.kt#9i3n8u');
      var tmp_1 = PaymentMethod_CASH_ON_DELIVERY_getInstance();
      var tmp_2 = stringResource(get_cash_on_delivery_label(string_instance), $composer_5, 0);
      var tmp_3 = stringResource(get_cash_on_delivery_deposit_msg(string_instance), $composer_5, 0);
      var tmp_4 = get_Money(Icons_getInstance().dxv_1);
      var tmp_5 = selectedMethod.equals(PaymentMethod_CASH_ON_DELIVERY_getInstance());
      sourceInformationMarkerStart($composer_5, 1793090269, 'CC(remember):PaymentMethodSection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 112) === 32;
      // Inline function 'kotlin.let' call
      var it = $composer_5.i31();
      var tmp_6;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = PaymentMethodSection$lambda(onMethodSelected);
        $composer_5.j31(value);
        tmp_6 = value;
      } else {
        tmp_6 = it;
      }
      var tmp0_group = tmp_6;
      sourceInformationMarkerEnd($composer_5);
      PaymentMethodItem(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp0_group, $composer_5, 6, 0);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(PaymentMethodSection$lambda_0(selectedMethod, onMethodSelected, modifier_0, $changed, $default));
    }
  }
  function PaymentMethodItem(method, label, subLabel, icon, isSelected, onSelect, $composer, $changed, $default) {
    var subLabel_0 = {_v: subLabel};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1819904371);
    sourceInformation($composer_0, 'C(PaymentMethodItem)P(3,2,5)56@2351L1758,49@1888L2221:PaymentMethodSection.kt#9i3n8u');
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(label) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(subLabel_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(icon) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.l31(isSelected) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onSelect) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74897) === 74896), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        subLabel_0._v = null;
      }
      if (isTraceInProgress()) {
        traceEventStart(-1819904371, $dirty, -1, 'client.fstech.hadaya.presentation.checkout.components.PaymentMethodItem (PaymentMethodSection.kt:48)');
      }
      var tmp = clickable(fillMaxWidth(Companion_instance), VOID, VOID, VOID, VOID, onSelect);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
      var tmp_0 = RoundedCornerShape(tmp$ret$0);
      var tmp_1;
      if (isSelected) {
        $composer_0.m30(-876398017);
        sourceInformation($composer_0, '54@2086L11');
        var tmp0_group = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_0, 6).znz_1, 0.3);
        $composer_0.n30();
        tmp_1 = tmp0_group;
      } else {
        $composer_0.m30(-876395937);
        sourceInformation($composer_0, '54@2153L11');
        var tmp1_group = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_0, 6).oo0_1, 0.3);
        $composer_0.n30();
        tmp_1 = tmp1_group;
      }
      var tmp_2 = tmp_1;
      var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_4 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_5 = _Dp___init__impl__ms3zkb(0.0);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_6 = _Dp___init__impl__ms3zkb(1);
      var tmp_7;
      if (isSelected) {
        $composer_0.m30(-876392812);
        sourceInformation($composer_0, '55@2266L11');
        var tmp2_group = MaterialTheme_instance.unz($composer_0, 6).xnz_1;
        $composer_0.n30();
        tmp_7 = tmp2_group;
      } else {
        $composer_0.m30(-876391297);
        sourceInformation($composer_0, '55@2305L11');
        var tmp3_group = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_0, 6).xo0_1, 0.2);
        $composer_0.n30();
        tmp_7 = tmp3_group;
      }
      var tmp_8 = BorderStroke(tmp_6, tmp_7);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(115734248, true, PaymentMethodItem$lambda(icon, isSelected, label, subLabel_0, onSelect), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_9;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value);
        tmp_9 = value;
      } else {
        tmp_9 = it;
      }
      var tmp$ret$2 = tmp_9;
      Surface(tmp, tmp_0, tmp_2, tmp_3, tmp_4, tmp_5, tmp_8, tmp$ret$2, $composer_0, 12582912, 56);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp4_safe_receiver = $composer_0.t30();
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.p3c(PaymentMethodItem$lambda_0(method, label, subLabel_0, icon, isSelected, onSelect, $changed, $default));
    }
  }
  function PaymentMethodSection$lambda($onMethodSelected) {
    return function () {
      $onMethodSelected(PaymentMethod_CASH_ON_DELIVERY_getInstance());
      return Unit_instance;
    };
  }
  function PaymentMethodSection$lambda_0($selectedMethod, $onMethodSelected, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      PaymentMethodSection($selectedMethod, $onMethodSelected, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function PaymentMethodItem$lambda($icon, $isSelected, $label, $subLabel, $onSelect) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C57@2361L1742:PaymentMethodSection.kt#9i3n8u');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(115734248, $changed, -1, 'client.fstech.hadaya.presentation.checkout.components.PaymentMethodItem.<anonymous> (PaymentMethodSection.kt:57)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var horizontalArrangement = null;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance;
        if (!((2 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((2 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 390 >> 3 | 112 & 390 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 168249603, 'C61@2497L429,74@2952L40,76@3018L807,97@4042L11,96@3984L95,93@3851L242:PaymentMethodSection.kt#9i3n8u');
        var tmp_2 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(40);
        var tmp_3 = size(tmp_2, tmp$ret$7);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = padding_0(tmp_3, tmp$ret$8);
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_5;
        if (!((4 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_4 = $composer_8.g30();
        if (!isInterface(tmp_4, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 2010897928, 'C67@2691L221:PaymentMethodSection.kt#9i3n8u');
        var tmp_5;
        if ($isSelected) {
          $composer_10.m30(64872197);
          sourceInformation($composer_10, '70@2827L11');
          var tmp0_group = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
          $composer_10.n30();
          tmp_5 = tmp0_group;
        } else {
          $composer_10.m30(64873454);
          sourceInformation($composer_10, '70@2866L11');
          var tmp1_group = MaterialTheme_instance.unz($composer_10, 6).po0_1;
          $composer_10.n30();
          tmp_5 = tmp1_group;
        }
        Icon($icon, null, null, tmp_5, $composer_10, 48, 4);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_6 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$15 = _Dp___init__impl__ms3zkb(12);
        Spacer(width(tmp_6, tmp$ret$15), $composer_5, 6);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_3 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_11 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_1 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_11, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_12 = $composer_11;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
        var localMap_1 = $composer_12.t31();
        var materialized_1 = materialize($composer_12, modifier_4);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_13 = $composer_12;
        var tmp_7 = $composer_13.g30();
        if (!isInterface(tmp_7, Applier)) {
          invalidApplier();
        }
        $composer_13.b31();
        if ($composer_13.h30()) {
          $composer_13.c31(tmp0_1);
        } else {
          $composer_13.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_14 = $composer_13;
        var $composer_15 = $composer_14;
        sourceInformationMarkerStart($composer_15, 514277589, 'C79@3157L10,77@3075L338:PaymentMethodSection.kt#9i3n8u');
        var tmp0_style = MaterialTheme_instance.jog($composer_15, 6).oof_1;
        var tmp1_fontWeight = $isSelected ? Companion_getInstance_16().e7z_1 : Companion_getInstance_16().c7z_1;
        var tmp_8;
        if ($isSelected) {
          $composer_15.m30(-1645970697);
          sourceInformation($composer_15, '81@3326L11');
          var tmp0_group_0 = MaterialTheme_instance.unz($composer_15, 6).no0_1;
          $composer_15.n30();
          tmp_8 = tmp0_group_0;
        } else {
          $composer_15.m30(-1645969378);
          sourceInformation($composer_15, '81@3367L11');
          var tmp1_group_0 = MaterialTheme_instance.unz($composer_15, 6).po0_1;
          $composer_15.n30();
          tmp_8 = tmp1_group_0;
        }
        var tmp2_color = tmp_8;
        var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = _TextOverflow___init__impl__obguoe(0);
        Text($label, null, tmp2_color, null, tmp_9, null, tmp1_fontWeight, null, tmp_10, null, null, tmp_11, tmp_12, false, 0, 0, null, tmp0_style, $composer_15, 0, 0, 131002);
        if (!($subLabel._v == null)) {
          $composer_15.m30(514660469);
          sourceInformation($composer_15, '86@3567L10,84@3474L319');
          var tmp3_text = $subLabel._v;
          var tmp4_style = MaterialTheme_instance.jog($composer_15, 6).tof_1;
          var tmp_13;
          if ($isSelected) {
            $composer_15.m30(-1645960267);
            sourceInformation($composer_15, '87@3652L11');
            var tmp2_group = MaterialTheme_instance.unz($composer_15, 6).xnz_1;
            $composer_15.n30();
            tmp_13 = tmp2_group;
          } else {
            $composer_15.m30(-1645958816);
            sourceInformation($composer_15, '87@3691L11');
            var tmp3_group = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_15, 6).to0_1, 0.7);
            $composer_15.n30();
            tmp_13 = tmp3_group;
          }
          var tmp5_color = tmp_13;
          var tmp6_lineHeight = get_sp(14);
          var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_15 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_16 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp3_text, null, tmp5_color, null, tmp_14, null, null, null, tmp_15, null, null, tmp6_lineHeight, tmp_16, false, 0, 0, null, tmp4_style, $composer_15, 0, 48, 129018);
          $composer_15.n30();
        } else {
          $composer_15.m30(514984884);
          $composer_15.n30();
        }
        sourceInformationMarkerEnd($composer_15);
        $composer_13.e31();
        var tmp_17 = RadioButtonDefaults_instance;
        var tmp_18 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
        var tmp_19 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_20 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_21 = tmp_17.cq6(tmp_18, tmp_19, tmp_20, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
        RadioButton($isSelected, $onSelect, null, false, tmp_21, null, $composer_5, 0, 44);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_22;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_22 = Unit_instance;
        }
        tmp = tmp_22;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function PaymentMethodItem$lambda_0($method, $label, $subLabel, $icon, $isSelected, $onSelect, $$changed, $$default) {
    return function ($composer, $force) {
      PaymentMethodItem($method, $label, $subLabel._v, $icon, $isSelected, $onSelect, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ContactUsSection(modifier, buttonModifier, horizontalAlignment, showResetPassword, onResetPassword, showPrivacyPolicy, onPrivacyPolicy, isResetPasswordEnabled, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var buttonModifier_0 = {_v: buttonModifier};
    var horizontalAlignment_0 = {_v: horizontalAlignment};
    var showResetPassword_0 = {_v: showResetPassword};
    var onResetPassword_0 = {_v: onResetPassword};
    var showPrivacyPolicy_0 = {_v: showPrivacyPolicy};
    var onPrivacyPolicy_0 = {_v: onPrivacyPolicy};
    var isResetPasswordEnabled_0 = {_v: isResetPasswordEnabled};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(368869169);
    sourceInformation($composer_0, 'C(ContactUsSection)P(3!2,7,5,6,4)28@1182L2,30@1260L72,33@1403L47,35@1456L2195:ContactUsSection.kt#c1nezb');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(buttonModifier_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(horizontalAlignment_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(showResetPassword_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onResetPassword_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.l31(showPrivacyPolicy_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(onPrivacyPolicy_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.l31(isResetPasswordEnabled_0._v) ? 8388608 : 4194304);
    if ($composer_0.r31(!(($dirty & 4793491) === 4793490), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (!(($default & 2) === 0)) {
        buttonModifier_0._v = fillMaxWidth(Companion_instance);
      }
      if (!(($default & 4) === 0)) {
        horizontalAlignment_0._v = Companion_getInstance_11().x8t_1;
      }
      if (!(($default & 8) === 0)) {
        showResetPassword_0._v = false;
      }
      if (!(($default & 16) === 0)) {
        sourceInformationMarkerStart($composer_0, -1999005677, 'CC(remember):ContactUsSection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ContactUsSection$lambda;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var tmp0_group = tmp;
        sourceInformationMarkerEnd($composer_0);
        onResetPassword_0._v = tmp0_group;
      }
      if (!(($default & 32) === 0)) {
        showPrivacyPolicy_0._v = false;
      }
      if (!(($default & 64) === 0)) {
        sourceInformationMarkerStart($composer_0, -1999003111, 'CC(remember):ContactUsSection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_1 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_0 = this_1.i31();
        var tmp_0;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ContactUsSection$lambda_0;
          this_1.j31(value_0);
          tmp_0 = value_0;
        } else {
          tmp_0 = it_0;
        }
        var tmp1_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        onPrivacyPolicy_0._v = tmp1_group;
      }
      if (!(($default & 128) === 0)) {
        isResetPasswordEnabled_0._v = true;
      }
      if (isTraceInProgress()) {
        traceEventStart(368869169, $dirty, -1, 'client.fstech.hadaya.presentation.common.ContactUsSection (ContactUsSection.kt:32)');
      }
      var whatsappUrl = stringResource(get_support_whatsapp_url(string_instance), $composer_0, 0);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var $changed_0 = 14 & $dirty | 896 & $dirty;
      var modifier_1 = modifier_0._v;
      var verticalArrangement = null;
      var horizontalAlignment_1 = horizontalAlignment_0._v;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((2 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((2 & 4) === 0))
        horizontalAlignment_1 = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment_1, $composer_1, 14 & $changed_0 >> 3 | 112 & $changed_0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1789014658, 'C40@1584L37,41@1657L10,39@1559L230,61@2367L24,64@2515L84,60@2329L482,73@2821L41,76@2910L46,75@2872L368:ContactUsSection.kt#c1nezb');
      var tmp0_text = stringResource(get_contact_us(string_instance), $composer_5, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_2 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$14 = _Dp___init__impl__ms3zkb(8);
      var tmp3_modifier = padding_2(tmp_2, VOID, tmp$ret$14);
      var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_7 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, tmp3_modifier, tmp_3, null, tmp_4, null, tmp2_fontWeight, null, tmp_5, null, null, tmp_6, tmp_7, false, 0, 0, null, tmp1_style, $composer_5, 1572912, 0, 131004);
      if (showResetPassword_0._v) {
        $composer_5.m30(1789226294);
        sourceInformation($composer_5, '47@1836L419,57@2268L41');
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$15 = _Dp___init__impl__ms3zkb(12);
        var tmp4_shape = RoundedCornerShape(tmp$ret$15);
        var tmp_8 = onResetPassword_0._v;
        var tmp_9 = buttonModifier_0._v;
        var tmp_10 = isResetPasswordEnabled_0._v;
        OutlinedButton(tmp_8, tmp_9, tmp_10, tmp4_shape, null, null, null, null, null, ComposableSingletons$ContactUsSectionKt_getInstance().y11r_1, $composer_5, 805306368 | 14 & $dirty >> 12 | 112 & $dirty | 896 & $dirty >> 15, 496);
        var tmp_11 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$16 = _Dp___init__impl__ms3zkb(12);
        Spacer(height(tmp_11, tmp$ret$16), $composer_5, 6);
        $composer_5.n30();
      } else {
        $composer_5.m30(1789703911);
        $composer_5.n30();
      }
      sourceInformationMarkerStart($composer_5, -1189192045, 'CC(remember):ContactUsSection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_5.k31(whatsappUrl);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_5.i31();
      var tmp_12;
      if (invalid || it_1 === Companion_getInstance().f30_1) {
        var value_1 = ContactUsSection$lambda_1(whatsappUrl);
        $composer_5.j31(value_1);
        tmp_12 = value_1;
      } else {
        tmp_12 = it_1;
      }
      var tmp0_group_0 = tmp_12;
      sourceInformationMarkerEnd($composer_5);
      var tmp_13 = buttonModifier_0._v;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$21 = _Dp___init__impl__ms3zkb(12);
      var tmp_14 = RoundedCornerShape(tmp$ret$21);
      var tmp_15 = ButtonDefaults_getInstance();
      var tmp_16 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_17 = Color(new Long(-14298266, 0));
      var tmp_18 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_19 = tmp_15.pob(tmp_16, tmp_17, tmp_18, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24624, 13);
      OutlinedButton(tmp0_group_0, tmp_13, false, tmp_14, tmp_19, null, null, null, null, ComposableSingletons$ContactUsSectionKt_getInstance().z11r_1, $composer_5, 805306368 | 112 & $dirty, 484);
      var tmp_20 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$22 = _Dp___init__impl__ms3zkb(12);
      Spacer(height(tmp_20, tmp$ret$22), $composer_5, 6);
      sourceInformationMarkerStart($composer_5, -1189174647, 'CC(remember):ContactUsSection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_2 = $composer_5.i31();
      var tmp_21;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var value_2 = ContactUsSection$lambda_2;
        $composer_5.j31(value_2);
        tmp_21 = value_2;
      } else {
        tmp_21 = it_2;
      }
      var tmp1_group_0 = tmp_21;
      sourceInformationMarkerEnd($composer_5);
      var tmp_22 = buttonModifier_0._v;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$27 = _Dp___init__impl__ms3zkb(12);
      var tmp_23 = RoundedCornerShape(tmp$ret$27);
      OutlinedButton(tmp1_group_0, tmp_22, false, tmp_23, null, null, null, null, null, ComposableSingletons$ContactUsSectionKt_getInstance().a11s_1, $composer_5, 805306374 | 112 & $dirty, 500);
      if (showPrivacyPolicy_0._v) {
        $composer_5.m30(1790661811);
        sourceInformation($composer_5, '86@3287L41,87@3341L294');
        var tmp_24 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$28 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_24, tmp$ret$28), $composer_5, 6);
        var tmp_25 = onPrivacyPolicy_0._v;
        TextButton(tmp_25, null, false, null, null, null, null, null, null, ComposableSingletons$ContactUsSectionKt_getInstance().b11s_1, $composer_5, 805306368 | 14 & $dirty >> 18, 510);
        $composer_5.n30();
      } else {
        $composer_5.m30(1791019303);
        $composer_5.n30();
      }
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver = $composer_0.t30();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.p3c(ContactUsSection$lambda_3(modifier_0, buttonModifier_0, horizontalAlignment_0, showResetPassword_0, onResetPassword_0, showPrivacyPolicy_0, onPrivacyPolicy_0, isResetPasswordEnabled_0, $changed, $default));
    }
  }
  function ComposableSingletons$ContactUsSectionKt$lambda$234542094$lambda($this$OutlinedButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C53@2070L51,54@2138L39,55@2199L41,55@2194L47:ContactUsSection.kt#c1nezb');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(234542094, $changed, -1, 'client.fstech.hadaya.presentation.common.ComposableSingletons$ContactUsSectionKt.lambda$234542094.<anonymous> (ContactUsSection.kt:53)');
      }
      var tmp = get_Lock(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_0, tmp$ret$0), $composer_0, 6);
      var tmp_1 = stringResource(get_reset_password(string_instance), $composer_0, 0);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ContactUsSectionKt$lambda$1819461193$lambda($this$OutlinedButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C68@2624L63,69@2700L39,70@2757L43,70@2752L49:ContactUsSection.kt#c1nezb');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1819461193, $changed, -1, 'client.fstech.hadaya.presentation.common.ComposableSingletons$ContactUsSectionKt.lambda$1819461193.<anonymous> (ContactUsSection.kt:68)');
      }
      var tmp = get_Chat(Filled_instance_0);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_0, tmp$ret$0), $composer_0, 6);
      var tmp_1 = stringResource(get_whatsapp_contact(string_instance), $composer_0, 0);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ContactUsSectionKt$lambda$_1711392078$lambda_d03hcb($this$OutlinedButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C80@3067L52,81@3132L39,82@3189L40,82@3184L46:ContactUsSection.kt#c1nezb');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1711392078, $changed, -1, 'client.fstech.hadaya.presentation.common.ComposableSingletons$ContactUsSectionKt.lambda$-1711392078.<anonymous> (ContactUsSection.kt:80)');
      }
      var tmp = get_Email(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_0, tmp$ret$0), $composer_0, 6);
      var tmp_1 = stringResource(get_email_contact(string_instance), $composer_0, 0);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ContactUsSectionKt$lambda$_1013027700$lambda_4dmng3($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C89@3430L45,90@3519L10,91@3584L11,88@3397L224:ContactUsSection.kt#c1nezb');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1013027700, $changed, -1, 'client.fstech.hadaya.presentation.common.ComposableSingletons$ContactUsSectionKt.lambda$-1013027700.<anonymous> (ContactUsSection.kt:88)');
      }
      var tmp0_text = stringResource(get_privacy_policy_btn(string_instance), $composer_0, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_0, 6).rof_1;
      var tmp2_color = MaterialTheme_instance.unz($composer_0, 6).xnz_1;
      var tmp = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_0 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp2_color, null, tmp, null, null, null, tmp_0, null, null, tmp_1, tmp_2, false, 0, 0, null, tmp1_style, $composer_0, 0, 0, 131066);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ContactUsSectionKt() {
    ComposableSingletons$ContactUsSectionKt_instance = this;
    var tmp = this;
    tmp.y11r_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(234542094, false, ComposableSingletons$ContactUsSectionKt$lambda$234542094$lambda));
    var tmp_0 = this;
    tmp_0.z11r_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1819461193, false, ComposableSingletons$ContactUsSectionKt$lambda$1819461193$lambda));
    var tmp_1 = this;
    tmp_1.a11s_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1711392078, false, ComposableSingletons$ContactUsSectionKt$lambda$_1711392078$lambda_d03hcb));
    var tmp_2 = this;
    tmp_2.b11s_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1013027700, false, ComposableSingletons$ContactUsSectionKt$lambda$_1013027700$lambda_4dmng3));
  }
  var ComposableSingletons$ContactUsSectionKt_instance;
  function ComposableSingletons$ContactUsSectionKt_getInstance() {
    if (ComposableSingletons$ContactUsSectionKt_instance == null)
      new ComposableSingletons$ContactUsSectionKt();
    return ComposableSingletons$ContactUsSectionKt_instance;
  }
  function ContactUsSection$lambda() {
    return Unit_instance;
  }
  function ContactUsSection$lambda_0() {
    openUrl('https://abdallabadreldin.github.io/Hadaya_privacy_policy/');
    return Unit_instance;
  }
  function ContactUsSection$lambda_1($whatsappUrl) {
    return function () {
      openUrl($whatsappUrl);
      return Unit_instance;
    };
  }
  function ContactUsSection$lambda_2() {
    openUrl('mailto:support@hadayastores.com');
    return Unit_instance;
  }
  function ContactUsSection$lambda_3($modifier, $buttonModifier, $horizontalAlignment, $showResetPassword, $onResetPassword, $showPrivacyPolicy, $onPrivacyPolicy, $isResetPasswordEnabled, $$changed, $$default) {
    return function ($composer, $force) {
      ContactUsSection($modifier._v, $buttonModifier._v, $horizontalAlignment._v, $showResetPassword._v, $onResetPassword._v, $showPrivacyPolicy._v, $onPrivacyPolicy._v, $isResetPasswordEnabled._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function CustomizeActionButton(onClick, modifier, text, containerColor, contentColor, icon, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var text_0 = {_v: text};
    var containerColor_0 = {_v: new Color_0(containerColor)};
    var contentColor_0 = {_v: new Color_0(contentColor)};
    var icon_0 = {_v: icon};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(745095311);
    sourceInformation($composer_0, 'C(CustomizeActionButton)P(4,3,5,0:c#ui.graphics.Color,1:c#ui.graphics.Color)32@1326L108,37@1518L424,28@1165L777:CustomizeActionButton.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | (($default & 4) === 0 && $composer_0.k31(text_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | (($default & 8) === 0 && $composer_0.o31(_ULong___get_data__impl__fggpzb(_Color___get_value__impl__1pls5m(containerColor_0._v.c6d_1))) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | (($default & 16) === 0 && $composer_0.o31(_ULong___get_data__impl__fggpzb(_Color___get_value__impl__1pls5m(contentColor_0._v.c6d_1))) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | (($default & 32) === 0 && $composer_0.k31(icon_0._v) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74899) === 74898), $dirty & 1)) {
      $composer_0.q30();
      sourceInformation($composer_0, '23@923L40,24@1007L11,25@1079L11');
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 2) === 0)) {
          modifier_0._v = Companion_instance;
        }
        if (!(($default & 4) === 0)) {
          text_0._v = stringResource(get_customize_btn(string_instance), $composer_0, 0);
          $dirty = $dirty & -897;
        }
        if (!(($default & 8) === 0)) {
          containerColor_0._v = new Color_0(MaterialTheme_instance.unz($composer_0, 6).eo0_1);
          $dirty = $dirty & -7169;
        }
        if (!(($default & 16) === 0)) {
          contentColor_0._v = new Color_0(MaterialTheme_instance.unz($composer_0, 6).fo0_1);
          $dirty = $dirty & -57345;
        }
        if (!(($default & 32) === 0)) {
          icon_0._v = get_Edit(Icons_getInstance().dxv_1);
          $dirty = $dirty & -458753;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 4) === 0))
          $dirty = $dirty & -897;
        if (!(($default & 8) === 0))
          $dirty = $dirty & -7169;
        if (!(($default & 16) === 0))
          $dirty = $dirty & -57345;
        if (!(($default & 32) === 0))
          $dirty = $dirty & -458753;
      }
      $composer_0.r30();
      if (isTraceInProgress()) {
        traceEventStart(745095311, $dirty, -1, 'client.fstech.hadaya.presentation.common.CustomizeActionButton (CustomizeActionButton.kt:27)');
      }
      var tmp = modifier_0._v;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(56);
      var tmp_0 = heightIn(tmp, tmp$ret$0);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
      var tmp_1 = RoundedCornerShape(tmp$ret$1);
      var tmp_2 = ButtonDefaults_getInstance();
      var tmp_3 = containerColor_0._v;
      var tmp_4 = contentColor_0._v;
      var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_6 = tmp_2.ao9(tmp_3.c6d_1, tmp_4.c6d_1, tmp_5, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576 | 14 & $dirty >> 9 | 112 & $dirty >> 9, 12);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_7 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$3 = _Dp___init__impl__ms3zkb(8);
      var tmp_8 = PaddingValues_0(tmp_7, tmp$ret$3);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-933491585, true, CustomizeActionButton$lambda(icon_0, text_0), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_9;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
        $composer_1.j31(value);
        tmp_9 = value;
      } else {
        tmp_9 = it;
      }
      var tmp$ret$4 = tmp_9;
      Button(onClick, tmp_0, false, tmp_1, tmp_6, null, null, tmp_8, null, tmp$ret$4, $composer_0, 817889280 | 14 & $dirty, 356);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(CustomizeActionButton$lambda_0(onClick, modifier_0, text_0, containerColor_0, contentColor_0, icon_0, $changed, $default));
    }
  }
  function CustomizeActionButton$lambda($icon, $text) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C42@1691L245:CustomizeActionButton.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-933491585, $changed, -1, 'client.fstech.hadaya.presentation.common.CustomizeActionButton.<anonymous> (CustomizeActionButton.kt:38)');
        }
        if (!($icon._v == null)) {
          $composer_0.m30(265464859);
          sourceInformation($composer_0, '39@1560L70,40@1643L29');
          var tmp_0 = $icon._v;
          var tmp_1 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_2 = size(tmp_1, tmp$ret$0);
          Icon(tmp_0, null, tmp_2, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 432, 8);
          var tmp_3 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$1 = _Dp___init__impl__ms3zkb(12);
          Spacer(width(tmp_3, tmp$ret$1), $composer_0, 6);
          $composer_0.n30();
        } else {
          $composer_0.m30(265595555);
          $composer_0.n30();
        }
        var tmp0_fontWeight = Companion_getInstance_16().f7z_1;
        var tmp1_fontSize = get_sp(16);
        var tmp2_textAlign = Companion_getInstance_15().d7v_1;
        var tmp3_lineHeight = get_sp(18);
        var tmp_4 = $text._v;
        var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_4, null, tmp_5, null, tmp1_fontSize, null, tmp0_fontWeight, null, tmp_6, null, tmp2_textAlign, tmp3_lineHeight, tmp_7, true, 2, 0, null, null, $composer_0, 1597440, 27696, 234414);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomizeActionButton$lambda_0($onClick, $modifier, $text, $containerColor, $contentColor, $icon, $$changed, $$default) {
    return function ($composer, $force) {
      CustomizeActionButton($onClick, $modifier._v, $text._v, $containerColor._v.c6d_1, $contentColor._v.c6d_1, $icon._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function GiftSelectionSection(title, selectionItems, selectedItemId, onItemSelected, language, enabled, $composer, $changed, $default) {
    var enabled_0 = {_v: enabled};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(909798531);
    sourceInformation($composer_0, 'C(GiftSelectionSection)P(5,4,3,2,1)204@8812L3041:GiftSelection.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(title) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(selectionItems) : $composer_0.q31(selectionItems)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(selectedItemId) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onItemSelected) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled_0._v) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74899) === 74898), $dirty & 1)) {
      if (!(($default & 32) === 0)) {
        enabled_0._v = true;
      }
      if (isTraceInProgress()) {
        traceEventStart(909798531, $dirty, -1, 'client.fstech.hadaya.presentation.common.GiftSelectionSection (GiftSelection.kt:203)');
      }
      var tmp = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = padding_2(tmp, VOID, tmp$ret$0);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -1252784151, 'C207@8956L10,205@8890L218,215@9265L2582,212@9118L2729:GiftSelection.kt#c1nezb');
      var tmp0_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
      var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_2 = _Dp___init__impl__ms3zkb(24);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$8 = _Dp___init__impl__ms3zkb(8);
      var tmp2_modifier = padding_2(tmp_1, tmp_2, tmp$ret$8);
      var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_7 = _TextOverflow___init__impl__obguoe(0);
      Text(title, tmp2_modifier, tmp_3, null, tmp_4, null, tmp1_fontWeight, null, tmp_5, null, null, tmp_6, tmp_7, false, 0, 0, null, tmp0_style, $composer_5, 1572912 | 14 & $dirty, 0, 131004);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$9 = _Dp___init__impl__ms3zkb(24);
      var tmp_8 = PaddingValues_0(tmp$ret$9);
      var tmp_9 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$10 = _Dp___init__impl__ms3zkb(12);
      var tmp_10 = tmp_9.mdq(tmp$ret$10);
      sourceInformationMarkerStart($composer_5, -2118610749, 'CC(remember):GiftSelection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!(!!(!!(($dirty & 57344) === 16384 | ($dirty & 896) === 256) | ($dirty & 458752) === 131072) | ($dirty & 7168) === 2048) | (($dirty & 112) === 32 || (!(($dirty & 64) === 0) && $composer_0.q31(selectionItems))));
      // Inline function 'kotlin.let' call
      var it = $composer_5.i31();
      var tmp_11;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = GiftSelectionSection$lambda(selectionItems, language, selectedItemId, enabled_0, onItemSelected);
        $composer_5.j31(value);
        tmp_11 = value;
      } else {
        tmp_11 = it;
      }
      var tmp0_group = tmp_11;
      sourceInformationMarkerEnd($composer_5);
      LazyRow(null, null, tmp_8, false, tmp_10, null, null, false, null, tmp0_group, $composer_5, 24960, 491);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(GiftSelectionSection$lambda_0(title, selectionItems, selectedItemId, onItemSelected, language, enabled_0, $changed, $default));
    }
  }
  function OptionSelectionSection(title, options, selectedOption, onOptionSelected, language, enabled, $composer, $changed, $default) {
    var enabled_0 = {_v: enabled};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1937636307);
    sourceInformation($composer_0, 'C(OptionSelectionSection)P(5,3,4,2,1)372@15054L2068:GiftSelection.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(title) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(options) : $composer_0.q31(options)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(selectedOption) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onOptionSelected) ? 2048 : 1024);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled_0._v) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 66707) === 66706), $dirty & 1)) {
      if (!(($default & 32) === 0)) {
        enabled_0._v = true;
      }
      if (isTraceInProgress()) {
        traceEventStart(1937636307, $dirty, -1, 'client.fstech.hadaya.presentation.common.OptionSelectionSection (GiftSelection.kt:371)');
      }
      var tmp = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = padding_2(tmp, VOID, tmp$ret$0);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 416798150, 'C375@15198L10,373@15132L218,383@15507L1609,380@15360L1756:GiftSelection.kt#c1nezb');
      var tmp0_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
      var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_2 = _Dp___init__impl__ms3zkb(24);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$8 = _Dp___init__impl__ms3zkb(8);
      var tmp2_modifier = padding_2(tmp_1, tmp_2, tmp$ret$8);
      var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_7 = _TextOverflow___init__impl__obguoe(0);
      Text(title, tmp2_modifier, tmp_3, null, tmp_4, null, tmp1_fontWeight, null, tmp_5, null, null, tmp_6, tmp_7, false, 0, 0, null, tmp0_style, $composer_5, 1572912 | 14 & $dirty, 0, 131004);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$9 = _Dp___init__impl__ms3zkb(24);
      var tmp_8 = PaddingValues_0(tmp$ret$9);
      var tmp_9 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$10 = _Dp___init__impl__ms3zkb(12);
      var tmp_10 = tmp_9.mdq(tmp$ret$10);
      sourceInformationMarkerStart($composer_5, -540732602, 'CC(remember):GiftSelection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!(!!((($dirty & 112) === 32 || (!(($dirty & 64) === 0) && $composer_0.q31(options))) | ($dirty & 458752) === 131072) | ($dirty & 896) === 256) | ($dirty & 7168) === 2048);
      // Inline function 'kotlin.let' call
      var it = $composer_5.i31();
      var tmp_11;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = OptionSelectionSection$lambda(options, enabled_0, selectedOption, onOptionSelected);
        $composer_5.j31(value);
        tmp_11 = value;
      } else {
        tmp_11 = it;
      }
      var tmp0_group = tmp_11;
      sourceInformationMarkerEnd($composer_5);
      LazyRow(null, null, tmp_8, false, tmp_10, null, null, false, null, tmp0_group, $composer_5, 24960, 491);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(OptionSelectionSection$lambda_0(title, options, selectedOption, onOptionSelected, language, enabled_0, $changed, $default));
    }
  }
  function OptionSelectionSection_0(option, selectedOption, onOptionSelected, language, enabled, $composer, $changed, $default) {
    var enabled_0 = {_v: enabled};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1235185211);
    sourceInformation($composer_0, 'C(OptionSelectionSection)P(3,4,2,1)295@12246L88,299@12340L2496:GiftSelection.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(option) : $composer_0.q31(option)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(selectedOption) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onOptionSelected) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled_0._v) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 16) === 0)) {
        enabled_0._v = true;
      }
      if (isTraceInProgress()) {
        traceEventStart(1235185211, $dirty, -1, 'client.fstech.hadaya.presentation.common.OptionSelectionSection (GiftSelection.kt:290)');
      }
      if (option.q101_1) {
        if (isTraceInProgress()) {
          traceEventEnd();
        }
        var tmp2_safe_receiver = $composer_0.t30();
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.p3c(OptionSelectionSection$lambda_1(option, selectedOption, onOptionSelected, language, enabled_0, $changed, $default));
        }
        return Unit_instance;
      }
      var title = language === 'en' ? option.o101_1 : option.p101_1;
      if (isBlank(title) && option.s101_1.r()) {
        if (isTraceInProgress()) {
          traceEventEnd();
        }
        var tmp3_safe_receiver = $composer_0.t30();
        if (tmp3_safe_receiver == null)
          null;
        else {
          tmp3_safe_receiver.p3c(OptionSelectionSection$lambda_2(option, selectedOption, onOptionSelected, language, enabled_0, $changed, $default));
        }
        return Unit_instance;
      }
      var tmp0_remember$arg$0 = option.s101_1;
      sourceInformationMarkerStart($composer_0, 1602026227, 'CC(remember):GiftSelection.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.k31(tmp0_remember$arg$0);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        // Inline function 'kotlin.collections.sortedByDescending' call
        var this_0 = option.s101_1;
        // Inline function 'kotlin.comparisons.compareByDescending' call
        var tmp_0 = OptionSelectionSection$lambda_3;
        var tmp$ret$5 = new sam$kotlin_Comparator$0(tmp_0);
        var value = sortedWith(this_0, tmp$ret$5);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp1_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var sortedValues = tmp1_group;
      var tmp_1 = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = padding_2(tmp_1, VOID, tmp$ret$6);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_2 = $composer_3.g30();
      if (!isInterface(tmp_2, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0_0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1264258694, 'C300@12418L409,315@12984L1846,312@12837L1993:GiftSelection.kt#c1nezb');
      var tmp_3 = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_4 = _Dp___init__impl__ms3zkb(24);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$14 = _Dp___init__impl__ms3zkb(8);
      var tmp0_modifier = padding_2(tmp_3, tmp_4, tmp$ret$14);
      var tmp1_verticalAlignment = Companion_getInstance_11().u8t_1;
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_1 = tmp0_modifier;
      var horizontalArrangement = Arrangement_getInstance().wdp_1;
      var verticalAlignment = tmp1_verticalAlignment;
      var $composer_6 = $composer_5;
      if (!((0 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((0 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_6, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_2);
      var tmp0_1 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_5 = $composer_8.g30();
      if (!isInterface(tmp_5, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_1);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, 1400402418, 'C307@12735L10,305@12661L156:GiftSelection.kt#c1nezb');
      var tmp0_style = MaterialTheme_instance.jog($composer_10, 6).mof_1;
      var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextOverflow___init__impl__obguoe(0);
      Text(title, null, tmp_6, null, tmp_7, null, tmp1_fontWeight, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, tmp0_style, $composer_10, 1572864, 0, 131006);
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$21 = _Dp___init__impl__ms3zkb(24);
      var tmp_11 = PaddingValues_0(tmp$ret$21);
      var tmp_12 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$22 = _Dp___init__impl__ms3zkb(12);
      var tmp_13 = tmp_12.mdq(tmp$ret$22);
      sourceInformationMarkerStart($composer_5, -1483220569, 'CC(remember):GiftSelection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(!!(!!(!!($composer_0.q31(sortedValues) | ($dirty & 7168) === 2048) | $composer_0.q31(selectedOption)) | ($dirty & 57344) === 16384) | ($dirty & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_5.i31();
      var tmp_14;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = OptionSelectionSection$lambda_4(sortedValues, language, selectedOption, enabled_0, onOptionSelected);
        $composer_5.j31(value_0);
        tmp_14 = value_0;
      } else {
        tmp_14 = it_0;
      }
      var tmp0_group = tmp_14;
      sourceInformationMarkerEnd($composer_5);
      LazyRow(null, null, tmp_11, false, tmp_13, null, null, false, null, tmp0_group, $composer_5, 24960, 491);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp4_safe_receiver = $composer_0.t30();
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.p3c(OptionSelectionSection$lambda_5(option, selectedOption, onOptionSelected, language, enabled_0, $changed, $default));
    }
  }
  function SelectedOptionExtraInputs(optionKey, selectedOption, language, onValueUpdated, onShowBirthdayPicker, enabled, $composer, $changed, $default) {
    var enabled_0 = {_v: enabled};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1689967515);
    sourceInformation($composer_0, 'C(SelectedOptionExtraInputs)P(4,5,1,3,2)80@3671L127,80@3643L155,86@3804L4794:GiftSelection.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(selectedOption) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onValueUpdated) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onShowBirthdayPicker) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled_0._v) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74897) === 74896), $dirty & 1)) {
      if (!(($default & 32) === 0)) {
        enabled_0._v = true;
      }
      if (isTraceInProgress()) {
        traceEventStart(1689967515, $dirty, -1, 'client.fstech.hadaya.presentation.common.SelectedOptionExtraInputs (GiftSelection.kt:79)');
      }
      sourceInformationMarkerStart($composer_0, 561152858, 'CC(remember):GiftSelection.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(($dirty & 7168) === 2048 | $composer_0.q31(selectedOption));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = SelectedOptionExtraInputs$lambda(onValueUpdated, selectedOption);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var imagePicker = rememberImagePickerLauncher_0(tmp0_group, $composer_0, 0);
      var tmp_0 = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_1 = _Dp___init__impl__ms3zkb(24);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$5 = _Dp___init__impl__ms3zkb(8);
      var tmp0_0 = padding_2(tmp_0, tmp_1, tmp$ret$5);
      var tmp_2 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(12);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = tmp0_0;
      var verticalArrangement = tmp_2.mdq(tmp$ret$6);
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((4 & 1) === 0))
        modifier = Companion_instance;
      if (!((4 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((4 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 54 >> 3 | 112 & 54 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0_1 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_3 = $composer_3.g30();
      if (!isInterface(tmp_3, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0_1);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1160818051, 'C:GiftSelection.kt#c1nezb');
      if (selectedOption.z100_1) {
        $composer_5.m30(1160726135);
        sourceInformation($composer_5, '96@4263L57,97@4346L62,94@4154L502');
        var hint = language === 'en' ? selectedOption.a101_1 : selectedOption.b101_1;
        var tmp0_elvis_lhs = selectedOption.g101_1;
        var tmp1_value = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
        var tmp2_modifier = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$13 = _Dp___init__impl__ms3zkb(12);
        var tmp3_shape = RoundedCornerShape(tmp$ret$13);
        sourceInformationMarkerStart($composer_5, 591638922, 'CC(remember):GiftSelection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = !!(($dirty & 7168) === 2048 | $composer_0.q31(selectedOption));
        // Inline function 'kotlin.let' call
        var it_0 = $composer_5.i31();
        var tmp_4;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = SelectedOptionExtraInputs$lambda_0(onValueUpdated, selectedOption);
          $composer_5.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_0;
        }
        var tmp0_group_0 = tmp_4;
        sourceInformationMarkerEnd($composer_5);
        var tmp_5 = enabled_0._v;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1588921926, true, SelectedOptionExtraInputs$lambda_1(hint, language), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_6 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_6.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_6.i31();
        var tmp_6;
        if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
          var value_1 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_6.j31(value_1);
          tmp_6 = value_1;
        } else {
          tmp_6 = it_1;
        }
        var tmp_7 = tmp_6;
        var tmp_8 = ComposableSingletons$GiftSelectionKt_getInstance().c11s_1;
        OutlinedTextField(tmp1_value, tmp0_group_0, tmp2_modifier, tmp_5, false, null, tmp_7, null, tmp_8, null, null, null, null, false, null, null, null, false, 3, 0, null, tmp3_shape, null, $composer_5, 102236544 | 7168 & $dirty >> 6, 100663296, 0, 6028976);
        $composer_5.n30();
      } else {
        $composer_5.m30(1161335409);
        $composer_5.n30();
      }
      if (selectedOption.w100_1) {
        $composer_5.m30(1161403392);
        sourceInformation($composer_5, '115@5199L26,110@4942L3,112@5004L71,117@5309L189,108@4832L715');
        var hint_0 = language === 'en' ? selectedOption.x100_1 : selectedOption.y100_1;
        var tmp4_elvis_lhs = selectedOption.f101_1;
        var tmp5_value = tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs;
        var tmp_9 = fillMaxWidth(Companion_instance);
        var tmp_10 = enabled_0._v;
        sourceInformationMarkerStart($composer_5, 591668843, 'CC(remember):GiftSelection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = ($dirty & 57344) === 16384;
        // Inline function 'kotlin.let' call
        var it_2 = $composer_5.i31();
        var tmp_11;
        if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
          var value_2 = SelectedOptionExtraInputs$lambda_2(onShowBirthdayPicker);
          $composer_5.j31(value_2);
          tmp_11 = value_2;
        } else {
          tmp_11 = it_2;
        }
        var tmp1_group = tmp_11;
        sourceInformationMarkerEnd($composer_5);
        var tmp6_modifier = clickable(tmp_9, tmp_10, VOID, VOID, VOID, tmp1_group);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$29 = _Dp___init__impl__ms3zkb(12);
        var tmp7_shape = RoundedCornerShape(tmp$ret$29);
        sourceInformationMarkerStart($composer_5, 591660596, 'CC(remember):GiftSelection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_3 = $composer_5.i31();
        var tmp_12;
        if (false || it_3 === Companion_getInstance().f30_1) {
          var value_3 = SelectedOptionExtraInputs$lambda_3;
          $composer_5.j31(value_3);
          tmp_12 = value_3;
        } else {
          tmp_12 = it_3;
        }
        var tmp2_group = tmp_12;
        sourceInformationMarkerEnd($composer_5);
        var tmp_13 = enabled_0._v;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(114587261, true, SelectedOptionExtraInputs$lambda_4(hint_0, language), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_7 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = $composer_7.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_7.i31();
        var tmp_14;
        if (invalid_3 || it_4 === Companion_getInstance().f30_1) {
          var value_4 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_7.j31(value_4);
          tmp_14 = value_4;
        } else {
          tmp_14 = it_4;
        }
        var tmp_15 = tmp_14;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(-397931110, true, SelectedOptionExtraInputs$lambda_5(enabled_0, onShowBirthdayPicker), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_8 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = $composer_8.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_5 = $composer_8.i31();
        var tmp_16;
        if (invalid_4 || it_5 === Companion_getInstance().f30_1) {
          var value_5 = ComposableLambda$invoke$ref(dispatchReceiver_1);
          $composer_8.j31(value_5);
          tmp_16 = value_5;
        } else {
          tmp_16 = it_5;
        }
        var tmp_17 = tmp_16;
        OutlinedTextField(tmp5_value, tmp2_group, tmp6_modifier, tmp_13, true, null, tmp_15, null, null, tmp_17, null, null, null, false, null, null, null, false, 0, 0, null, tmp7_shape, null, $composer_5, 806903856 | 7168 & $dirty >> 6, 0, 0, 6290848);
        $composer_5.n30();
      } else {
        $composer_5.m30(1162219281);
        $composer_5.n30();
      }
      if (selectedOption.c101_1) {
        $composer_5.m30(1162350845);
        sourceInformation($composer_5, '132@5938L11,131@5875L126,129@5746L37,136@6102L2480,128@5714L2868');
        var hint_1 = language === 'en' ? selectedOption.d101_1 : selectedOption.e101_1;
        var tmp8_modifier = fillMaxWidth(Companion_instance);
        var tmp_18 = CardDefaults_instance;
        var tmp_19 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_5, 6).oo0_1, 0.5);
        var tmp_20 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_21 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp9_colors = tmp_18.loh(tmp_19, tmp_20, tmp_21, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$48 = _Dp___init__impl__ms3zkb(16);
        var tmp10_shape = RoundedCornerShape(tmp$ret$48);
        sourceInformationMarkerStart($composer_5, 591686358, 'CC(remember):GiftSelection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = !!(($dirty & 458752) === 131072 | $composer_0.q31(imagePicker));
        // Inline function 'kotlin.let' call
        var it_6 = $composer_5.i31();
        var tmp_22;
        if (invalid_5 || it_6 === Companion_getInstance().f30_1) {
          var value_6 = SelectedOptionExtraInputs$lambda_6(enabled_0, imagePicker);
          $composer_5.j31(value_6);
          tmp_22 = value_6;
        } else {
          tmp_22 = it_6;
        }
        var tmp3_group = tmp_22;
        sourceInformationMarkerEnd($composer_5);
        var tmp_23 = enabled_0._v;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_2 = rememberComposableLambda(-1598390887, true, SelectedOptionExtraInputs$lambda_7(hint_1, language, selectedOption), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_9 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_6 = $composer_9.k31(dispatchReceiver_2);
        // Inline function 'kotlin.let' call
        var it_7 = $composer_9.i31();
        var tmp_24;
        if (invalid_6 || it_7 === Companion_getInstance().f30_1) {
          var value_7 = ComposableLambda$invoke$ref_6(dispatchReceiver_2);
          $composer_9.j31(value_7);
          tmp_24 = value_7;
        } else {
          tmp_24 = it_7;
        }
        var tmp$ret$53 = tmp_24;
        Card_0(tmp3_group, tmp8_modifier, tmp_23, tmp10_shape, tmp9_colors, null, null, null, tmp$ret$53, $composer_5, 100663344 | 896 & $dirty >> 9, 224);
        $composer_5.n30();
      } else {
        $composer_5.m30(1165230001);
        $composer_5.n30();
      }
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(SelectedOptionExtraInputs$lambda_8(optionKey, selectedOption, language, onValueUpdated, onShowBirthdayPicker, enabled_0, $changed, $default));
    }
  }
  function GiftItemCard(name, imageUrls, price, description, isSelected, language, stock, onClick, $composer, $changed, $default) {
    var price_0 = {_v: price};
    var description_0 = {_v: description};
    var language_0 = {_v: language};
    var stock_0 = {_v: stock};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-374682891);
    sourceInformation($composer_0, 'C(GiftItemCard)P(4,1,6!3,7)430@17393L34,448@18021L307,460@18523L5778,442@17766L6535:GiftSelection.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(name) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(imageUrls) : $composer_0.q31(imageUrls)) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(price_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(description_0._v) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.l31(isSelected) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.k31(language_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.m31(stock_0._v) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 8388608 : 4194304);
    if ($composer_0.r31(!(($dirty & 4793491) === 4793490), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        price_0._v = null;
      }
      if (!(($default & 8) === 0)) {
        description_0._v = null;
      }
      if (!(($default & 32) === 0)) {
        language_0._v = 'en';
      }
      if (!(($default & 64) === 0)) {
        stock_0._v = 1;
      }
      if (isTraceInProgress()) {
        traceEventStart(-374682891, $dirty, -1, 'client.fstech.hadaya.presentation.common.GiftItemCard (GiftSelection.kt:429)');
      }
      sourceInformationMarkerStart($composer_0, 707002807, 'CC(remember):GiftSelection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = mutableStateOf(false);
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var showMediaDialog$delegate = tmp0_group;
      var isOutOfStock = stock_0._v <= 0;
      var tmp_0;
      if (GiftItemCard$lambda(showMediaDialog$delegate)) {
        var tmp_1;
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        if (!(imageUrls == null || imageUrls.r())) {
          tmp_1 = true;
        } else {
          // Inline function 'kotlin.text.isNullOrBlank' call
          var this_1 = description_0._v;
          tmp_1 = !(this_1 == null || isBlank(this_1));
        }
        tmp_0 = tmp_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        $composer_0.m30(442413661);
        sourceInformation($composer_0, '438@17717L27,434@17562L192');
        var tmp_2 = imageUrls == null ? emptyList() : imageUrls;
        var tmp_3 = description_0._v;
        sourceInformationMarkerStart($composer_0, 707013168, 'CC(remember):GiftSelection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_2 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_0 = this_2.i31();
        var tmp_4;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var value_0 = GiftItemCard$lambda_1(showMediaDialog$delegate);
          this_2.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_0;
        }
        var tmp1_group = tmp_4;
        sourceInformationMarkerEnd($composer_0);
        MediaGalleryDialog(tmp_2, name, tmp_3, tmp1_group, $composer_0, 3072 | 112 & $dirty << 3 | 896 & $dirty >> 3, 0);
        $composer_0.n30();
      } else {
        $composer_0.m30(442613549);
        $composer_0.n30();
      }
      var tmp_5 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$10 = _Dp___init__impl__ms3zkb(120);
      var tmp_6 = clickable(alpha(width(tmp_5, tmp$ret$10), isOutOfStock ? 0.6 : 1.0), !isOutOfStock, VOID, VOID, VOID, onClick);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$11 = _Dp___init__impl__ms3zkb(12);
      var tmp_7 = RoundedCornerShape(tmp$ret$11);
      var tmp_8 = CardDefaults_instance;
      var tmp_9;
      if (isOutOfStock) {
        $composer_0.m30(707026631);
        sourceInformation($composer_0, '450@18111L11');
        var tmp2_group = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_0, 6).oo0_1, 0.3);
        $composer_0.n30();
        tmp_9 = tmp2_group;
      } else if (isSelected) {
        $composer_0.m30(707029669);
        sourceInformation($composer_0, '452@18221L11');
        var tmp3_group = MaterialTheme_instance.unz($composer_0, 6).znz_1;
        $composer_0.n30();
        tmp_9 = tmp3_group;
      } else {
        $composer_0.m30(707032156);
        sourceInformation($composer_0, '454@18299L11');
        var tmp4_group = MaterialTheme_instance.unz($composer_0, 6).mo0_1;
        $composer_0.n30();
        tmp_9 = tmp4_group;
      }
      var tmp_10 = tmp_9;
      var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_13 = tmp_8.loh(tmp_10, tmp_11, tmp_12, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 14);
      var tmp_14;
      if (isSelected) {
        $composer_0.m30(707033900);
        sourceInformation($composer_0, '458@18421L11');
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$12 = _Dp___init__impl__ms3zkb(2);
        var tmp5_group = BorderStroke(tmp$ret$12, MaterialTheme_instance.unz($composer_0, 6).xnz_1);
        $composer_0.n30();
        tmp_14 = tmp5_group;
      } else {
        $composer_0.m30(707036849);
        sourceInformation($composer_0, '459@18489L11');
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$13 = _Dp___init__impl__ms3zkb(1);
        var tmp6_group = BorderStroke(tmp$ret$13, MaterialTheme_instance.unz($composer_0, 6).yo0_1);
        $composer_0.n30();
        tmp_14 = tmp6_group;
      }
      var tmp_15 = tmp_14;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(1456526567, true, GiftItemCard$lambda_2(imageUrls, name, isOutOfStock, isSelected, price_0, showMediaDialog$delegate, language_0), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_1.i31();
      var tmp_16;
      if (invalid || it_1 === Companion_getInstance().f30_1) {
        var value_1 = ComposableLambda$invoke$ref_6(dispatchReceiver);
        $composer_1.j31(value_1);
        tmp_16 = value_1;
      } else {
        tmp_16 = it_1;
      }
      var tmp$ret$14 = tmp_16;
      Card(tmp_6, tmp_7, tmp_13, null, tmp_15, tmp$ret$14, $composer_0, 196608, 8);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp7_safe_receiver = $composer_0.t30();
    if (tmp7_safe_receiver == null)
      null;
    else {
      tmp7_safe_receiver.p3c(GiftItemCard$lambda_3(name, imageUrls, price_0, description_0, isSelected, language_0, stock_0, onClick, $changed, $default));
    }
  }
  function ComposableSingletons$GiftSelectionKt$lambda$2089124484$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C101@4575L30:GiftSelection.kt#c1nezb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(2089124484, $changed, -1, 'client.fstech.hadaya.presentation.common.ComposableSingletons$GiftSelectionKt.lambda$2089124484.<anonymous> (GiftSelection.kt:101)');
      }
      var tmp = get_Edit(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$GiftSelectionKt$lambda$_1732111300$lambda_3z8sey($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C119@5419L39:GiftSelection.kt#c1nezb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1732111300, $changed, -1, 'client.fstech.hadaya.presentation.common.ComposableSingletons$GiftSelectionKt.lambda$-1732111300.<anonymous> (GiftSelection.kt:119)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$GiftSelectionKt$lambda$402230355$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C660@27044L32,658@26940L210:GiftSelection.kt#c1nezb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(402230355, $changed, -1, 'client.fstech.hadaya.presentation.common.ComposableSingletons$GiftSelectionKt.lambda$402230355.<anonymous> (GiftSelection.kt:658)');
      }
      var tmp = get_Close(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_close(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, Companion_getInstance_14().m6b_1, $composer_0, 3072, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$GiftSelectionKt() {
    ComposableSingletons$GiftSelectionKt_instance = this;
    var tmp = this;
    tmp.c11s_1 = ComposableLambda$invoke$ref(composableLambdaInstance(2089124484, false, ComposableSingletons$GiftSelectionKt$lambda$2089124484$lambda));
    var tmp_0 = this;
    tmp_0.d11s_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1732111300, false, ComposableSingletons$GiftSelectionKt$lambda$_1732111300$lambda_3z8sey));
    var tmp_1 = this;
    tmp_1.e11s_1 = ComposableLambda$invoke$ref(composableLambdaInstance(402230355, false, ComposableSingletons$GiftSelectionKt$lambda$402230355$lambda));
  }
  var ComposableSingletons$GiftSelectionKt_instance;
  function ComposableSingletons$GiftSelectionKt_getInstance() {
    if (ComposableSingletons$GiftSelectionKt_instance == null)
      new ComposableSingletons$GiftSelectionKt();
    return ComposableSingletons$GiftSelectionKt_instance;
  }
  function MediaGalleryDialog(media, title, description, onDismiss, $composer, $changed, $default) {
    var title_0 = {_v: title};
    var description_0 = {_v: description};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-2002134075);
    sourceInformation($composer_0, 'C(MediaGalleryDialog)P(1,3)601@24536L14,601@24517L33,602@24576L34,608@24832L5003,604@24616L5225:GiftSelection.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(media) : $composer_0.q31(media)) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(title_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(description_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismiss) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        title_0._v = null;
      }
      if (!(($default & 4) === 0)) {
        description_0._v = null;
      }
      if (isTraceInProgress()) {
        traceEventStart(-2002134075, $dirty, -1, 'client.fstech.hadaya.presentation.common.MediaGalleryDialog (GiftSelection.kt:600)');
      }
      sourceInformationMarkerStart($composer_0, 94508275, 'CC(remember):GiftSelection.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(media));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = MediaGalleryDialog$lambda(media);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var pagerState = rememberPagerState(0, 0.0, tmp0_group, $composer_0, 0, 3);
      sourceInformationMarkerStart($composer_0, 94509575, 'CC(remember):GiftSelection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_0.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = mutableStateOf(false);
        this_0.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      var userIsZooming$delegate = tmp1_group;
      var tmp0_properties = DialogProperties_init_$Create$(VOID, VOID, false);
      var tmp1_modifier = fillMaxSize(Companion_instance);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1508318517, true, MediaGalleryDialog$lambda_2(media, pagerState, description_0, onDismiss, title_0, userIsZooming$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_1.i31();
      var tmp_1;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp$ret$8 = tmp_1;
      BasicAlertDialog(onDismiss, tmp1_modifier, tmp0_properties, tmp$ret$8, $composer_0, 3504 | 14 & $dirty >> 9, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver = $composer_0.t30();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.p3c(MediaGalleryDialog$lambda_3(media, title_0, description_0, onDismiss, $changed, $default));
    }
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.f11s_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).ze = function (a, b) {
    return this.f11s_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).q3 = function () {
    return this.f11s_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function GiftSelectionSection$lambda$lambda$lambda($enabled, $onItemSelected) {
    return function () {
      if ($enabled._v)
        $onItemSelected(null);
      return Unit_instance;
    };
  }
  function GiftSelectionSection$lambda$lambda($language, $selectedItemId, $enabled, $onItemSelected) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C219@9376L44,223@9605L37,218@9335L325:GiftSelection.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1611140592, $changed, -1, 'client.fstech.hadaya.presentation.common.GiftSelectionSection.<anonymous>.<anonymous>.<anonymous>.<anonymous> (GiftSelection.kt:218)');
        }
        var tmp_0 = formatNumbers(stringResource(get_default_selection(string_instance), $composer_0, 0), $language);
        var tmp_1 = $selectedItemId == null;
        sourceInformationMarkerStart($composer_0, 2117892661, 'CC(remember):GiftSelection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.l31($enabled._v) | $composer_0.k31($onItemSelected));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_2;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = GiftSelectionSection$lambda$lambda$lambda($enabled, $onItemSelected);
          $composer_0.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        GiftItemCard(tmp_0, null, null, null, tmp_1, null, 0, tmp0_group, $composer_0, 432, 104);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function GiftSelectionSection$lambda$lambda_0(it) {
    return null;
  }
  function GiftSelectionSection$lambda$lambda_1($key, $items) {
    return function (index) {
      return $key($items.l1(index));
    };
  }
  function GiftSelectionSection$lambda$lambda_2($contentType, $items) {
    return function (index) {
      return $contentType($items.l1(index));
    };
  }
  function GiftSelectionSection$lambda$lambda$lambda_0($enabled, $stock, $isSelected, $onItemSelected, $item) {
    return function () {
      var tmp;
      if ($enabled._v && $stock > 0) {
        tmp = $isSelected ? $onItemSelected(null) : $onItemSelected($item);
      }
      return Unit_instance;
    };
  }
  function GiftSelectionSection$lambda$lambda_3($items, $selectedItemId, $language, $enabled, $onItemSelected) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp2 = $items.l1(it);
        var $composer_1 = $composer_0;
        $composer_1.m30(-1136599858);
        sourceInformation($composer_1, 'C*271@11585L220,264@11302L521:GiftSelection.kt#c1nezb');
        var tmp_2;
        if (tmp2 instanceof Card_1) {
          tmp_2 = tmp2.gyz_1;
        } else {
          if (tmp2 instanceof Box_0) {
            tmp_2 = tmp2.ryz_1;
          } else {
            tmp_2 = null;
          }
        }
        var id = tmp_2;
        var isSelected = equals($selectedItemId, id);
        var tmp_3;
        if (tmp2 instanceof Card_1) {
          tmp_3 = $language === 'en' ? tmp2.hyz_1 : tmp2.iyz_1;
        } else {
          if (tmp2 instanceof Box_0) {
            tmp_3 = $language === 'en' ? tmp2.syz_1 : tmp2.tyz_1;
          } else {
            tmp_3 = '';
          }
        }
        var name = tmp_3;
        var tmp_4;
        if (tmp2 instanceof Card_1) {
          var tmp3_elvis_lhs = tmp2.jyz_1;
          var tmp_5 = tmp3_elvis_lhs == null ? emptyList() : tmp3_elvis_lhs;
          var tmp4_elvis_lhs = tmp2.kyz_1;
          tmp_4 = plus(tmp_5, tmp4_elvis_lhs == null ? emptyList() : tmp4_elvis_lhs);
        } else {
          if (tmp2 instanceof Box_0) {
            var tmp5_elvis_lhs = tmp2.uyz_1;
            var tmp_6 = tmp5_elvis_lhs == null ? emptyList() : tmp5_elvis_lhs;
            var tmp6_elvis_lhs = tmp2.vyz_1;
            tmp_4 = plus(tmp_6, tmp6_elvis_lhs == null ? emptyList() : tmp6_elvis_lhs);
          } else {
            tmp_4 = emptyList();
          }
        }
        var combinedMedia = tmp_4;
        var tmp_7;
        if (tmp2 instanceof Card_1) {
          tmp_7 = tmp2.lyz_1;
        } else {
          if (tmp2 instanceof Box_0) {
            tmp_7 = tmp2.wyz_1;
          } else {
            tmp_7 = 0.0;
          }
        }
        var priceVal = tmp_7;
        var tmp_8;
        if (priceVal > 0.0) {
          $composer_1.m30(-1135620228);
          sourceInformation($composer_1, '250@10819L137');
          var tmp0_group = '+ ' + formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(priceVal)], $composer_1, 0), $language);
          $composer_1.n30();
          tmp_8 = tmp0_group;
        } else {
          $composer_1.m30(-1135411443);
          sourceInformation($composer_1, '255@11026L31');
          var tmp1_group = formatNumbers(stringResource(get_free(string_instance), $composer_1, 0), $language);
          $composer_1.n30();
          tmp_8 = tmp1_group;
        }
        var priceStr = tmp_8;
        var tmp_9;
        if (tmp2 instanceof Card_1) {
          tmp_9 = tmp2.myz_1;
        } else {
          if (tmp2 instanceof Box_0) {
            tmp_9 = tmp2.xyz_1;
          } else {
            tmp_9 = 1;
          }
        }
        var stock = tmp_9;
        sourceInformationMarkerStart($composer_1, 656129202, 'CC(remember):GiftSelection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!(!!(!!($composer_1.l31($enabled._v) | $composer_1.m31(stock)) | $composer_1.l31(isSelected)) | $composer_1.k31($onItemSelected)) | $composer_1.q31(tmp2));
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_10;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = GiftSelectionSection$lambda$lambda$lambda_0($enabled, stock, isSelected, $onItemSelected, tmp2);
          $composer_1.j31(value);
          tmp_10 = value;
        } else {
          tmp_10 = it_0;
        }
        var tmp2_group = tmp_10;
        sourceInformationMarkerEnd($composer_1);
        GiftItemCard(name, combinedMedia, priceStr, null, isSelected, $language, stock, tmp2_group, $composer_1, 0, 8);
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function GiftSelectionSection$lambda($selectionItems, $language, $selectedItemId, $enabled, $onItemSelected) {
    return function ($this$LazyRow) {
      $this$LazyRow.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(1611140592, true, GiftSelectionSection$lambda$lambda($language, $selectedItemId, $enabled, $onItemSelected))));
      // Inline function 'androidx.compose.foundation.lazy.items' call
      var items = $selectionItems;
      var contentType = GiftSelectionSection$lambda$lambda_0;
      var tmp = items.n1();
      var tmp_0;
      if (!(null == null)) {
        tmp_0 = GiftSelectionSection$lambda$lambda_1(null, items);
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      var tmp_2 = GiftSelectionSection$lambda$lambda_2(contentType, items);
      $this$LazyRow.di9(tmp, tmp_1, tmp_2, ComposableLambda$invoke$ref_4(composableLambdaInstance(802480018, true, GiftSelectionSection$lambda$lambda_3(items, $selectedItemId, $language, $enabled, $onItemSelected))));
      return Unit_instance;
    };
  }
  function GiftSelectionSection$lambda_0($title, $selectionItems, $selectedItemId, $onItemSelected, $language, $enabled, $$changed, $$default) {
    return function ($composer, $force) {
      GiftSelectionSection($title, $selectionItems, $selectedItemId, $onItemSelected, $language, $enabled._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function OptionSelectionSection$lambda$lambda$lambda($selectedOption, $option, $onOptionSelected) {
    return function () {
      if ($selectedOption === $option)
        $onOptionSelected(null);
      else
        $onOptionSelected($option);
      return Unit_instance;
    };
  }
  function OptionSelectionSection$lambda$lambda$lambda_0($selectedOption, $option) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C405@16642L10,402@16448L604:GiftSelection.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-369808589, $changed, -1, 'client.fstech.hadaya.presentation.common.OptionSelectionSection.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (GiftSelection.kt:402)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_1 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(12);
        var tmp0_modifier = padding_2(tmp_0, tmp_1, tmp$ret$1);
        var tmp1_style = MaterialTheme_instance.jog($composer_0, 6).pof_1;
        var tmp2_fontWeight = $selectedOption === $option ? Companion_getInstance_16().e7z_1 : Companion_getInstance_16().b7z_1;
        var tmp_2;
        if ($selectedOption === $option) {
          $composer_0.m30(1096246853);
          sourceInformation($composer_0, '408@16888L11');
          var tmp0_group = MaterialTheme_instance.unz($composer_0, 6).ao0_1;
          $composer_0.n30();
          tmp_2 = tmp0_group;
        } else {
          $composer_0.m30(1096250371);
          sourceInformation($composer_0, '410@16998L11');
          var tmp1_group = MaterialTheme_instance.unz($composer_0, 6).po0_1;
          $composer_0.n30();
          tmp_2 = tmp1_group;
        }
        var tmp3_color = tmp_2;
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextOverflow___init__impl__obguoe(0);
        Text($option, tmp0_modifier, tmp3_color, null, tmp_3, null, tmp2_fontWeight, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, tmp1_style, $composer_0, 48, 0, 131000);
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OptionSelectionSection$lambda$lambda($enabled, $selectedOption, $option, $onOptionSelected) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C388@15703L178,401@16422L652,386@15592L1482:GiftSelection.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-533991890, $changed, -1, 'client.fstech.hadaya.presentation.common.OptionSelectionSection.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (GiftSelection.kt:386)');
        }
        var tmp_0 = Companion_instance;
        var tmp_1 = $enabled._v;
        sourceInformationMarkerStart($composer_0, -2065093632, 'CC(remember):GiftSelection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.k31($selectedOption) | $composer_0.k31($option)) | $composer_0.k31($onOptionSelected));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_2;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = OptionSelectionSection$lambda$lambda$lambda($selectedOption, $option, $onOptionSelected);
          $composer_0.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        var tmp_3 = clickable(tmp_0, tmp_1, VOID, VOID, VOID, tmp0_group);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$4 = _Dp___init__impl__ms3zkb(12);
        var tmp_4 = RoundedCornerShape(tmp$ret$4);
        var tmp_5;
        if ($selectedOption === $option) {
          $composer_0.m30(-2065082434);
          sourceInformation($composer_0, '394@16046L11');
          var tmp1_group = MaterialTheme_instance.unz($composer_0, 6).znz_1;
          $composer_0.n30();
          tmp_5 = tmp1_group;
        } else {
          $composer_0.m30(-2065078752);
          sourceInformation($composer_0, '396@16146L11');
          var tmp2_group = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_0, 6).oo0_1, 0.5);
          $composer_0.n30();
          tmp_5 = tmp2_group;
        }
        var tmp_6 = tmp_5;
        var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_8 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_9 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_10;
        if ($selectedOption === $option) {
          $composer_0.m30(-2065075165);
          sourceInformation($composer_0, '398@16317L11');
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$5 = _Dp___init__impl__ms3zkb(2);
          var tmp3_group = BorderStroke(tmp$ret$5, MaterialTheme_instance.unz($composer_0, 6).xnz_1);
          $composer_0.n30();
          tmp_10 = tmp3_group;
        } else {
          $composer_0.m30(407287919);
          $composer_0.n30();
          tmp_10 = null;
        }
        var tmp_11 = tmp_10;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-369808589, true, OptionSelectionSection$lambda$lambda$lambda_0($selectedOption, $option), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_12;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_12 = value_0;
        } else {
          tmp_12 = it_0;
        }
        var tmp$ret$6 = tmp_12;
        Surface(tmp_3, tmp_4, tmp_6, tmp_7, tmp_8, tmp_9, tmp_11, tmp$ret$6, $composer_0, 12582912, 56);
        var tmp_13;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_13 = Unit_instance;
        }
        tmp = tmp_13;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OptionSelectionSection$lambda($options, $enabled, $selectedOption, $onOptionSelected) {
    return function ($this$LazyRow) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $options.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        $this$LazyRow.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(-533991890, true, OptionSelectionSection$lambda$lambda($enabled, $selectedOption, element, $onOptionSelected))));
      }
      return Unit_instance;
    };
  }
  function OptionSelectionSection$lambda_0($title, $options, $selectedOption, $onOptionSelected, $language, $enabled, $$changed, $$default) {
    return function ($composer, $force) {
      OptionSelectionSection($title, $options, $selectedOption, $onOptionSelected, $language, $enabled._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function OptionSelectionSection$lambda_1($option, $selectedOption, $onOptionSelected, $language, $enabled, $$changed, $$default) {
    return function ($composer, $force) {
      OptionSelectionSection_0($option, $selectedOption, $onOptionSelected, $language, $enabled._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function OptionSelectionSection$lambda_2($option, $selectedOption, $onOptionSelected, $language, $enabled, $$changed, $$default) {
    return function ($composer, $force) {
      OptionSelectionSection_0($option, $selectedOption, $onOptionSelected, $language, $enabled._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function OptionSelectionSection$lambda_3(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = b.t100_1;
    var tmp$ret$2 = a.t100_1;
    return compareValues(tmp, tmp$ret$2);
  }
  function OptionSelectionSection$lambda$lambda_0(it) {
    return null;
  }
  function OptionSelectionSection$lambda$lambda_1($key, $items) {
    return function (index) {
      return $key($items.l1(index));
    };
  }
  function OptionSelectionSection$lambda$lambda_2($contentType, $items) {
    return function (index) {
      return $contentType($items.l1(index));
    };
  }
  function OptionSelectionSection$lambda$lambda$lambda_1($enabled, $value, $isSelected, $onOptionSelected) {
    return function () {
      var tmp;
      var tmp_0;
      if ($enabled._v) {
        var tmp0_elvis_lhs = $value.s100_1;
        tmp_0 = (tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) > 0;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = $isSelected ? $onOptionSelected(null) : $onOptionSelected($value);
      }
      return Unit_instance;
    };
  }
  function OptionSelectionSection$lambda$lambda_3($items, $language, $selectedOption, $enabled, $onOptionSelected) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp2 = $items.l1(it);
        var $composer_1 = $composer_0;
        $composer_1.m30(-1028026606);
        sourceInformation($composer_1, 'C*334@13873L147,351@14550L238,343@14204L602:GiftSelection.kt#c1nezb');
        var name = $language === 'en' ? tmp2.m100_1 : tmp2.n100_1;
        var description = $language === 'en' ? tmp2.o100_1 : tmp2.p100_1;
        var tmp0_elvis_lhs = tmp2.q100_1;
        var priceVal = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = tmp2.r100_1;
        var discountVal = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
        var activePrice = discountVal > 0.0 ? discountVal : priceVal;
        var tmp_2;
        if (activePrice > 0.0) {
          $composer_1.m30(-1027562537);
          sourceInformation($composer_1, '326@13598L140');
          var tmp0_group = '+ ' + formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(activePrice)], $composer_1, 0), $language);
          $composer_1.n30();
          tmp_2 = tmp0_group;
        } else {
          $composer_1.m30(-1027352450);
          $composer_1.n30();
          tmp_2 = null;
        }
        var priceStr = tmp_2;
        sourceInformationMarkerStart($composer_1, 1767977803, 'CC(remember):GiftSelection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(tmp2);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_3;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var tmp0_elvis_lhs_0 = tmp2.u100_1;
          var tmp_4 = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
          var tmp1_elvis_lhs_0 = tmp2.v100_1;
          var value = plus(tmp_4, tmp1_elvis_lhs_0 == null ? emptyList() : tmp1_elvis_lhs_0);
          $composer_1.j31(value);
          tmp_3 = value;
        } else {
          tmp_3 = it_0;
        }
        var tmp1_group = tmp_3;
        sourceInformationMarkerEnd($composer_1);
        var combinedValueMedia = tmp1_group;
        var tmp2_safe_receiver = $selectedOption;
        var tmp_5;
        if (tmp2_safe_receiver == null) {
          tmp_5 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_5 = (tmp2_safe_receiver.m100_1 === tmp2.m100_1 && tmp2_safe_receiver.n100_1 === tmp2.n100_1);
        }
        var tmp3_elvis_lhs = tmp_5;
        var isSelected = tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
        var tmp4_elvis_lhs = tmp2.s100_1;
        var tmp_6 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
        sourceInformationMarkerStart($composer_1, 1767999558, 'CC(remember):GiftSelection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = !!(!!(!!($composer_1.l31($enabled._v) | $composer_1.q31(tmp2)) | $composer_1.l31(isSelected)) | $composer_1.k31($onOptionSelected));
        // Inline function 'kotlin.let' call
        var it_1 = $composer_1.i31();
        var tmp_7;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = OptionSelectionSection$lambda$lambda$lambda_1($enabled, tmp2, isSelected, $onOptionSelected);
          $composer_1.j31(value_0);
          tmp_7 = value_0;
        } else {
          tmp_7 = it_1;
        }
        var tmp2_group = tmp_7;
        sourceInformationMarkerEnd($composer_1);
        GiftItemCard(name, combinedValueMedia, priceStr, description, isSelected, $language, tmp_6, tmp2_group, $composer_1, 0, 0);
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OptionSelectionSection$lambda_4($sortedValues, $language, $selectedOption, $enabled, $onOptionSelected) {
    return function ($this$LazyRow) {
      // Inline function 'androidx.compose.foundation.lazy.items' call
      var items = $sortedValues;
      var contentType = OptionSelectionSection$lambda$lambda_0;
      var tmp = items.n1();
      var tmp_0;
      if (!(null == null)) {
        tmp_0 = OptionSelectionSection$lambda$lambda_1(null, items);
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      var tmp_2 = OptionSelectionSection$lambda$lambda_2(contentType, items);
      $this$LazyRow.di9(tmp, tmp_1, tmp_2, ComposableLambda$invoke$ref_4(composableLambdaInstance(802480018, true, OptionSelectionSection$lambda$lambda_3(items, $language, $selectedOption, $enabled, $onOptionSelected))));
      return Unit_instance;
    };
  }
  function OptionSelectionSection$lambda_5($option, $selectedOption, $onOptionSelected, $language, $enabled, $$changed, $$default) {
    return function ($composer, $force) {
      OptionSelectionSection_0($option, $selectedOption, $onOptionSelected, $language, $enabled._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function SelectedOptionExtraInputs$lambda($onValueUpdated, $selectedOption) {
    return function (bytes) {
      var tmp;
      if (!(bytes == null)) {
        tmp = $onValueUpdated($selectedOption.k101(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, bytes));
      }
      return Unit_instance;
    };
  }
  function SelectedOptionExtraInputs$lambda_0($onValueUpdated, $selectedOption) {
    return function (it) {
      $onValueUpdated($selectedOption.k101(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it));
      return Unit_instance;
    };
  }
  function SelectedOptionExtraInputs$lambda_1($hint, $language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C97@4348L58:GiftSelection.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1588921926, $changed, -1, 'client.fstech.hadaya.presentation.common.SelectedOptionExtraInputs.<anonymous>.<anonymous> (GiftSelection.kt:97)');
        }
        var tmp0_elvis_lhs = $hint;
        var tmp_0 = tmp0_elvis_lhs == null ? $language === 'en' ? 'Message' : '\u0631\u0633\u0627\u0644\u0629' : tmp0_elvis_lhs;
        var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SelectedOptionExtraInputs$lambda_2($onShowBirthdayPicker) {
    return function () {
      $onShowBirthdayPicker();
      return Unit_instance;
    };
  }
  function SelectedOptionExtraInputs$lambda_3(it) {
    return Unit_instance;
  }
  function SelectedOptionExtraInputs$lambda_4($hint, $language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C112@5006L67:GiftSelection.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(114587261, $changed, -1, 'client.fstech.hadaya.presentation.common.SelectedOptionExtraInputs.<anonymous>.<anonymous> (GiftSelection.kt:112)');
        }
        var tmp0_elvis_lhs = $hint;
        var tmp_0 = tmp0_elvis_lhs == null ? $language === 'en' ? 'Birthday' : '\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u064A\u0644\u0627\u062F' : tmp0_elvis_lhs;
        var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SelectedOptionExtraInputs$lambda$lambda($enabled, $onShowBirthdayPicker) {
    return function () {
      if ($enabled._v)
        $onShowBirthdayPicker();
      return Unit_instance;
    };
  }
  function SelectedOptionExtraInputs$lambda_5($enabled, $onShowBirthdayPicker) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C118@5352L39,118@5331L149:GiftSelection.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-397931110, $changed, -1, 'client.fstech.hadaya.presentation.common.SelectedOptionExtraInputs.<anonymous>.<anonymous> (GiftSelection.kt:118)');
        }
        sourceInformationMarkerStart($composer_0, -159705951, 'CC(remember):GiftSelection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.l31($enabled._v) | $composer_0.k31($onShowBirthdayPicker));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = SelectedOptionExtraInputs$lambda$lambda($enabled, $onShowBirthdayPicker);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$GiftSelectionKt_getInstance().d11s_1, $composer_0, 1572864, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SelectedOptionExtraInputs$lambda_6($enabled, $imagePicker) {
    return function () {
      var tmp;
      if ($enabled._v) {
        $imagePicker.g11s();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SelectedOptionExtraInputs$lambda_7($hint, $language, $selectedOption) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C137@6120L2448:GiftSelection.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1598390887, $changed, -1, 'client.fstech.hadaya.presentation.common.SelectedOptionExtraInputs.<anonymous>.<anonymous> (GiftSelection.kt:137)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = fillMaxWidth(padding_0(tmp_0, tmp$ret$0));
        var horizontalArrangement = null;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance;
        if (!((2 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((2 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 390 >> 3 | 112 & 390 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -1849234369, 'C144@6447L11,141@6303L495,153@6819L40,154@6880L1010:GiftSelection.kt#c1nezb');
        var tmp_2 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(48);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = background(size(tmp_2, tmp$ret$7), MaterialTheme_instance.unz($composer_5, 6).xnz_1, get_CircleShape());
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_5;
        if (!((4 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_3 = $composer_8.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 253288678, 'C147@6590L186:GiftSelection.kt#c1nezb');
        var tmp_4 = get_CameraAlt(Icons_getInstance().dxv_1);
        Icon(tmp_4, null, null, Companion_getInstance_14().m6b_1, $composer_10, 3120, 4);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_5 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$14 = _Dp___init__impl__ms3zkb(16);
        Spacer(width(tmp_5, tmp$ret$14), $composer_5, 6);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_3 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_11 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_1 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_11, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_12 = $composer_11;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
        var localMap_1 = $composer_12.t31();
        var materialized_1 = materialize($composer_12, modifier_4);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_13 = $composer_12;
        var tmp_6 = $composer_13.g30();
        if (!isInterface(tmp_6, Applier)) {
          invalidApplier();
        }
        $composer_13.b31();
        if ($composer_13.h30()) {
          $composer_13.c31(tmp0_1);
        } else {
          $composer_13.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_14 = $composer_13;
        var $composer_15 = $composer_14;
        sourceInformationMarkerStart($composer_15, 2108208053, 'C155@6945L224:GiftSelection.kt#c1nezb');
        var tmp0_elvis_lhs = $hint;
        var tmp1_text = tmp0_elvis_lhs == null ? $language === 'en' ? 'Upload Image' : '\u0631\u0641\u0639 \u0635\u0648\u0631\u0629' : tmp0_elvis_lhs;
        var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp3_fontSize = get_sp(16);
        var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_10 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp1_text, null, tmp_7, null, tmp3_fontSize, null, tmp2_fontWeight, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, null, $composer_15, 1597440, 0, 262062);
        if (!($selectedOption.i101_1 == null)) {
          $composer_15.m30(2108478682);
          sourceInformation($composer_15, '163@7421L11,161@7267L253');
          var tmp_11 = $language === 'en' ? 'Image selected' : '\u062A\u0645 \u0627\u062E\u062A\u064A\u0627\u0631 \u0635\u0648\u0631\u0629';
          var tmp_12 = MaterialTheme_instance.unz($composer_15, 6).xnz_1;
          var tmp_13 = get_sp(12);
          var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_15 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_16 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_11, null, tmp_12, null, tmp_13, null, null, null, tmp_14, null, null, tmp_15, tmp_16, false, 0, 0, null, null, $composer_15, 24576, 0, 262122);
          $composer_15.n30();
        } else {
          $composer_15.m30(2108791379);
          sourceInformation($composer_15, '169@7734L11,167@7582L260');
          var tmp_17 = $language === 'en' ? 'Tap to select' : '\u0627\u0636\u063A\u0637 \u0644\u0644\u0627\u062E\u062A\u064A\u0627\u0631';
          var tmp_18 = MaterialTheme_instance.unz($composer_15, 6).po0_1;
          var tmp_19 = get_sp(12);
          var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_21 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_22 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_17, null, tmp_18, null, tmp_19, null, null, null, tmp_20, null, null, tmp_21, tmp_22, false, 0, 0, null, null, $composer_15, 24576, 0, 262122);
          $composer_15.n30();
        }
        sourceInformationMarkerEnd($composer_15);
        $composer_13.e31();
        if (!($selectedOption.i101_1 == null)) {
          $composer_5.m30(-1847647759);
          sourceInformation($composer_5, '175@7980L548');
          var tmp_23 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$21 = _Dp___init__impl__ms3zkb(40);
          var tmp_24 = size(tmp_23, tmp$ret$21);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$22 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_5 = clip(tmp_24, RoundedCornerShape(tmp$ret$22));
          var contentAlignment_0 = null;
          var propagateMinConstraints_0 = false;
          var $composer_16 = $composer_5;
          if (!((6 & 1) === 0))
            modifier_5 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_0 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_0 = false;
          var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_6 = modifier_5;
          var $composer_17 = $composer_16;
          if (!((0 & 2) === 0))
            modifier_6 = Companion_instance;
          var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
          var localMap_2 = $composer_17.t31();
          var materialized_2 = materialize($composer_17, modifier_6);
          var tmp0_2 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_18 = $composer_17;
          var tmp_25 = $composer_18.g30();
          if (!isInterface(tmp_25, Applier)) {
            invalidApplier();
          }
          $composer_18.b31();
          if ($composer_18.h30()) {
            $composer_18.c31(tmp0_2);
          } else {
            $composer_18.d31();
          }
          var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_18);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
          var $composer_19 = $composer_18;
          var $composer_20 = $composer_19;
          sourceInformationMarkerStart($composer_20, 2046819381, 'C180@8198L304:GiftSelection.kt#c1nezb');
          HadayaImage($selectedOption.i101_1, null, fillMaxSize(Companion_instance), Companion_getInstance_13().q96_1, $composer_20, 3504, 0);
          sourceInformationMarkerEnd($composer_20);
          $composer_18.e31();
          $composer_5.n30();
        } else {
          $composer_5.m30(-1847075003);
          $composer_5.n30();
        }
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_26;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_26 = Unit_instance;
        }
        tmp = tmp_26;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SelectedOptionExtraInputs$lambda_8($optionKey, $selectedOption, $language, $onValueUpdated, $onShowBirthdayPicker, $enabled, $$changed, $$default) {
    return function ($composer, $force) {
      SelectedOptionExtraInputs($optionKey, $selectedOption, $language, $onValueUpdated, $onShowBirthdayPicker, $enabled._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function GiftItemCard$lambda($showMediaDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showMediaDialog', KMutableProperty0, true);
    return $showMediaDialog$delegate.u1();
  }
  function GiftItemCard$lambda_0($showMediaDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showMediaDialog', KMutableProperty0, true);
    $showMediaDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function GiftItemCard$lambda_1($showMediaDialog$delegate) {
    return function () {
      GiftItemCard$lambda_0($showMediaDialog$delegate, false);
      return Unit_instance;
    };
  }
  function GiftItemCard$lambda$lambda($showMediaDialog$delegate) {
    return function () {
      GiftItemCard$lambda_0($showMediaDialog$delegate, true);
      return Unit_instance;
    };
  }
  function GiftItemCard$lambda$lambda_0($language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C528@21442L918:GiftSelection.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1460132071, $changed, -1, 'client.fstech.hadaya.presentation.common.GiftItemCard.<anonymous>.<anonymous>.<anonymous>.<anonymous> (GiftSelection.kt:528)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_1 = _Dp___init__impl__ms3zkb(4);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(2);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = padding_2(tmp_0, tmp_1, tmp$ret$1);
        var horizontalArrangement = null;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance;
        if (!((2 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((2 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 390 >> 3 | 112 & 390 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_2 = $composer_3.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 626271031, 'C532@21671L282,538@21982L39,539@22050L284:GiftSelection.kt#c1nezb');
        var tmp0_imageVector = get_Visibility(Icons_getInstance().dxv_1);
        var tmp1_tint = Companion_getInstance_14().m6b_1;
        var tmp_3 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(12);
        var tmp2_modifier = size(tmp_3, tmp$ret$8);
        Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_5, 3504, 0);
        var tmp_4 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$9 = _Dp___init__impl__ms3zkb(2);
        Spacer(width(tmp_4, tmp$ret$9), $composer_5, 6);
        var tmp_5 = $language._v === 'en' ? 'Details' : '\u062A\u0641\u0627\u0635\u064A\u0644';
        var tmp_6 = Companion_getInstance_14().m6b_1;
        var tmp_7 = get_sp(8);
        var tmp_8 = Companion_getInstance_16().e7z_1;
        var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_11 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_5, null, tmp_6, null, tmp_7, null, tmp_8, null, tmp_9, null, null, tmp_10, tmp_11, false, 0, 0, null, null, $composer_5, 1597824, 0, 262058);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_12;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_12 = Unit_instance;
        }
        tmp = tmp_12;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function GiftItemCard$lambda_2($imageUrls, $name, $isOutOfStock, $isSelected, $price, $showMediaDialog$delegate, $language) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C461@18533L5762:GiftSelection.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1456526567, $changed, -1, 'client.fstech.hadaya.presentation.common.GiftItemCard.<anonymous> (GiftSelection.kt:461)');
        }
        var tmp0_horizontalAlignment = Companion_getInstance_11().x8t_1;
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var verticalArrangement = null;
        var horizontalAlignment = tmp0_horizontalAlignment;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance;
        if (!((2 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((2 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 390 >> 3 | 112 & 390 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -434199524, 'C469@18848L11,465@18675L4278,558@22966L40,559@23019L395:GiftSelection.kt#c1nezb');
        var tmp_2 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(104);
        var tmp_3 = size(tmp_2, tmp$ret$7);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = background(clip(tmp_3, RoundedCornerShape(tmp$ret$8)), MaterialTheme_instance.unz($composer_5, 6).oo0_1);
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_5;
        if (!((4 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_4 = $composer_8.g30();
        if (!isInterface(tmp_4, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, -1988906954, 'C:GiftSelection.kt#c1nezb');
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = $imageUrls;
        if (!(this_0 == null || this_0.r())) {
          $composer_10.m30(-1988892912);
          sourceInformation($composer_10, '476@19128L352,526@21367L26,527@21416L966,520@21054L1328');
          var firstMedia = first($imageUrls);
          var isVideo = isVideoUrl(firstMedia);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_3 = fillMaxSize(Companion_instance);
          var contentAlignment_0 = null;
          var propagateMinConstraints_0 = false;
          var $composer_11 = $composer_10;
          if (!((6 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_0 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_0 = false;
          var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_5 = $composer_13.g30();
          if (!isInterface(tmp_5, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_1);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_15, 1723070166, 'C477@19193L265:GiftSelection.kt#c1nezb');
          HadayaImage(firstMedia, $name, fillMaxSize(Companion_instance), Companion_getInstance_13().q96_1, $composer_15, 3456, 0);
          sourceInformationMarkerEnd($composer_15);
          $composer_13.e31();
          if (isVideo) {
            $composer_10.m30(-1988460338);
            sourceInformation($composer_10, '486@19541L609');
            // Inline function 'androidx.compose.foundation.layout.Box' call
            var modifier_5 = background(BoxScopeInstance_instance.vdr(Companion_instance), Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.2));
            var contentAlignment_1 = Companion_getInstance_11().o8t_1;
            var propagateMinConstraints_1 = false;
            var $composer_16 = $composer_10;
            if (!((4 & 1) === 0))
              modifier_5 = Companion_instance;
            if (!((4 & 2) === 0))
              contentAlignment_1 = Companion_getInstance_11().k8t_1;
            if (!((4 & 4) === 0))
              propagateMinConstraints_1 = false;
            var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
            // Inline function 'androidx.compose.ui.layout.Layout' call
            var modifier_6 = modifier_5;
            var $composer_17 = $composer_16;
            if (!((0 & 2) === 0))
              modifier_6 = Companion_instance;
            var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
            var localMap_2 = $composer_17.t31();
            var materialized_2 = materialize($composer_17, modifier_6);
            var tmp0_2 = Companion_getInstance_12().oah_1;
            // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
            var $composer_18 = $composer_17;
            var tmp_6 = $composer_18.g30();
            if (!isInterface(tmp_6, Applier)) {
              invalidApplier();
            }
            $composer_18.b31();
            if ($composer_18.h30()) {
              $composer_18.c31(tmp0_2);
            } else {
              $composer_18.d31();
            }
            var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_18);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
            Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
            var $composer_19 = $composer_18;
            var $composer_20 = $composer_19;
            sourceInformationMarkerStart($composer_20, -553852246, 'C492@19842L282:GiftSelection.kt#c1nezb');
            var tmp0_imageVector = get_PlayCircle(Icons_getInstance().dxv_1);
            var tmp1_tint = Companion_getInstance_14().m6b_1;
            var tmp_7 = Companion_instance;
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$28 = _Dp___init__impl__ms3zkb(32);
            var tmp2_modifier = size(tmp_7, tmp$ret$28);
            Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_20, 3504, 0);
            sourceInformationMarkerEnd($composer_20);
            $composer_18.e31();
            $composer_10.n30();
          } else {
            $composer_10.m30(-1987828961);
            $composer_10.n30();
          }
          if ($isOutOfStock) {
            $composer_10.m30(-1987765473);
            sourceInformation($composer_10, '502@20238L720');
            // Inline function 'androidx.compose.foundation.layout.Box' call
            var modifier_7 = background(BoxScopeInstance_instance.vdr(Companion_instance), Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.5));
            var contentAlignment_2 = Companion_getInstance_11().o8t_1;
            var propagateMinConstraints_2 = false;
            var $composer_21 = $composer_10;
            if (!((4 & 1) === 0))
              modifier_7 = Companion_instance;
            if (!((4 & 2) === 0))
              contentAlignment_2 = Companion_getInstance_11().k8t_1;
            if (!((4 & 4) === 0))
              propagateMinConstraints_2 = false;
            var measurePolicy_3 = maybeCachedBoxMeasurePolicy(contentAlignment_2, propagateMinConstraints_2);
            // Inline function 'androidx.compose.ui.layout.Layout' call
            var modifier_8 = modifier_7;
            var $composer_22 = $composer_21;
            if (!((0 & 2) === 0))
              modifier_8 = Companion_instance;
            var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_22, 0).hashCode();
            var localMap_3 = $composer_22.t31();
            var materialized_3 = materialize($composer_22, modifier_8);
            var tmp0_3 = Companion_getInstance_12().oah_1;
            // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
            var $composer_23 = $composer_22;
            var tmp_8 = $composer_23.g30();
            if (!isInterface(tmp_8, Applier)) {
              invalidApplier();
            }
            $composer_23.b31();
            if ($composer_23.h30()) {
              $composer_23.c31(tmp0_3);
            } else {
              $composer_23.d31();
            }
            var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_23);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
            Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
            var $composer_24 = $composer_23;
            var $composer_25 = $composer_24;
            sourceInformationMarkerStart($composer_25, 2082768324, 'C509@20584L39,508@20539L393:GiftSelection.kt#c1nezb');
            var tmp_9 = stringResource(get_out_of_stock(string_instance), $composer_25, 0);
            var tmp_10 = Companion_getInstance_14().m6b_1;
            var tmp_11 = get_sp(10);
            var tmp_12 = Companion_getInstance_16().e7z_1;
            var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_14 = Companion_getInstance_15().d7v_1;
            var tmp_15 = get_sp(12);
            var tmp_16 = _TextOverflow___init__impl__obguoe(0);
            Text(tmp_9, null, tmp_10, null, tmp_11, null, tmp_12, null, tmp_13, null, tmp_14, tmp_15, tmp_16, false, 0, 0, null, null, $composer_25, 1597824, 48, 258986);
            sourceInformationMarkerEnd($composer_25);
            $composer_23.e31();
            $composer_10.n30();
          } else {
            $composer_10.m30(-1987027425);
            $composer_10.n30();
          }
          var tmp0_color = Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.5);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$35 = _Dp___init__impl__ms3zkb(4);
          var tmp1_shape = RoundedCornerShape(tmp$ret$35);
          var tmp_17 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().s8t_1);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$36 = _Dp___init__impl__ms3zkb(4);
          var tmp_18 = padding_0(tmp_17, tmp$ret$36);
          sourceInformationMarkerStart($composer_10, 2014124733, 'CC(remember):GiftSelection.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it = $composer_10.i31();
          var tmp_19;
          if (false || it === Companion_getInstance().f30_1) {
            var value = GiftItemCard$lambda$lambda($showMediaDialog$delegate);
            $composer_10.j31(value);
            tmp_19 = value;
          } else {
            tmp_19 = it;
          }
          var tmp0_group = tmp_19;
          sourceInformationMarkerEnd($composer_10);
          var tmp2_modifier_0 = clickable(tmp_18, VOID, VOID, VOID, VOID, tmp0_group);
          var tmp_20 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_21 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_22 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-1460132071, true, GiftItemCard$lambda$lambda_0($language), $composer_10, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_26 = $composer_10;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_26.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_0 = $composer_26.i31();
          var tmp_23;
          if (invalid || it_0 === Companion_getInstance().f30_1) {
            var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_26.j31(value_0);
            tmp_23 = value_0;
          } else {
            tmp_23 = it_0;
          }
          var tmp$ret$41 = tmp_23;
          Surface(tmp2_modifier_0, tmp1_shape, tmp0_color, tmp_20, tmp_21, tmp_22, null, tmp$ret$41, $composer_10, 12583296, 120);
          $composer_10.n30();
        } else {
          $composer_10.m30(-1985575726);
          sourceInformation($composer_10, '548@22428L493');
          var tmp3_imageVector = $isOutOfStock ? get_Close(Icons_getInstance().dxv_1) : get_CheckCircle(Icons_getInstance().dxv_1);
          var tmp_24;
          if ($isOutOfStock) {
            $composer_10.m30(2014165896);
            sourceInformation($composer_10, '551@22642L11');
            var tmp1_group = MaterialTheme_instance.unz($composer_10, 6).to0_1;
            $composer_10.n30();
            tmp_24 = tmp1_group;
          } else if ($isSelected) {
            $composer_10.m30(2014168554);
            sourceInformation($composer_10, '552@22725L11');
            var tmp2_group = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
            $composer_10.n30();
            tmp_24 = tmp2_group;
          } else {
            $composer_10.m30(2014171349);
            sourceInformation($composer_10, '553@22795L11');
            var tmp3_group = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_10, 6).po0_1, 0.2);
            $composer_10.n30();
            tmp_24 = tmp3_group;
          }
          var tmp4_tint = tmp_24;
          var tmp_25 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$48 = _Dp___init__impl__ms3zkb(32);
          var tmp5_modifier = size(tmp_25, tmp$ret$48);
          Icon(tmp3_imageVector, null, tmp5_modifier, tmp4_tint, $composer_10, 432, 0);
          $composer_10.n30();
        }
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_26 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$49 = _Dp___init__impl__ms3zkb(4);
        Spacer(height(tmp_26, tmp$ret$49), $composer_5, 6);
        var tmp0_fontSize = get_sp(12);
        var tmp1_fontWeight = Companion_getInstance_16().c7z_1;
        var tmp2_overflow = Companion_getInstance_23().x7s_1;
        var tmp3_textAlign = Companion_getInstance_15().d7v_1;
        var tmp_27;
        if ($isOutOfStock) {
          $composer_5.m30(-706598739);
          sourceInformation($composer_5, '566@23349L11');
          var tmp0_group_0 = MaterialTheme_instance.unz($composer_5, 6).po0_1;
          $composer_5.n30();
          tmp_27 = tmp0_group_0;
        } else {
          $composer_5.m30(-706597848);
          $composer_5.n30();
          tmp_27 = Companion_getInstance_14().u6b_1;
        }
        var tmp4_color = tmp_27;
        var tmp_28 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_29 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        Text($name, null, tmp4_color, null, tmp0_fontSize, null, tmp1_fontWeight, null, tmp_28, null, tmp3_textAlign, tmp_29, tmp2_overflow, false, 2, 0, null, null, $composer_5, 1597440, 24960, 240554);
        if (!($price._v == null) && !$isOutOfStock) {
          $composer_5.m30(-429611835);
          sourceInformation($composer_5, '569@23481L40,573@23658L11,570@23538L295');
          var tmp_30 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$50 = _Dp___init__impl__ms3zkb(2);
          Spacer(height(tmp_30, tmp$ret$50), $composer_5, 6);
          var tmp5_text = $price._v;
          var tmp6_fontSize = get_sp(10);
          var tmp7_color = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
          var tmp8_fontWeight = Companion_getInstance_16().d7z_1;
          var tmp9_textAlign = Companion_getInstance_15().d7v_1;
          var tmp_31 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_32 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_33 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp5_text, null, tmp7_color, null, tmp6_fontSize, null, tmp8_fontWeight, null, tmp_31, null, tmp9_textAlign, tmp_32, tmp_33, false, 1, 0, null, null, $composer_5, 1597440, 24576, 244650);
          $composer_5.n30();
        } else if ($isOutOfStock) {
          $composer_5.m30(-429206169);
          sourceInformation($composer_5, '579@23890L40,581@23981L39,583@24102L11,580@23948L323');
          var tmp_34 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$51 = _Dp___init__impl__ms3zkb(2);
          Spacer(height(tmp_34, tmp$ret$51), $composer_5, 6);
          var tmp10_text = stringResource(get_out_of_stock(string_instance), $composer_5, 0);
          var tmp11_fontSize = get_sp(10);
          var tmp12_color = MaterialTheme_instance.unz($composer_5, 6).to0_1;
          var tmp13_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp14_textAlign = Companion_getInstance_15().d7v_1;
          var tmp_35 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_36 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_37 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp10_text, null, tmp12_color, null, tmp11_fontSize, null, tmp13_fontWeight, null, tmp_35, null, tmp14_textAlign, tmp_36, tmp_37, false, 1, 0, null, null, $composer_5, 1597440, 24576, 244650);
          $composer_5.n30();
        } else {
          $composer_5.m30(-428808315);
          $composer_5.n30();
        }
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_38;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_38 = Unit_instance;
        }
        tmp = tmp_38;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function GiftItemCard$lambda_3($name, $imageUrls, $price, $description, $isSelected, $language, $stock, $onClick, $$changed, $$default) {
    return function ($composer, $force) {
      GiftItemCard($name, $imageUrls, $price._v, $description._v, $isSelected, $language._v, $stock._v, $onClick, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function MediaGalleryDialog$lambda($media) {
    return function () {
      return $media.n1();
    };
  }
  function MediaGalleryDialog$lambda_0($userIsZooming$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('userIsZooming', KMutableProperty0, true);
    return $userIsZooming$delegate.u1();
  }
  function MediaGalleryDialog$lambda_1($userIsZooming$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('userIsZooming', KMutableProperty0, true);
    $userIsZooming$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function MediaGalleryDialog$lambda$lambda$lambda($userIsZooming$delegate) {
    return function (it) {
      MediaGalleryDialog$lambda_1($userIsZooming$delegate, it);
      return Unit_instance;
    };
  }
  function MediaGalleryDialog$lambda$lambda($media, $userIsZooming$delegate) {
    return function ($this$HorizontalPager, index, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C625@25557L22,621@25326L279:GiftSelection.kt#c1nezb');
      var $dirty = $changed;
      var tmp;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(index) ? 32 : 16);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1219219987, $dirty, -1, 'client.fstech.hadaya.presentation.common.MediaGalleryDialog.<anonymous>.<anonymous>.<anonymous> (GiftSelection.kt:621)');
        }
        var tmp_1 = $media.l1(index);
        var tmp_2 = fillMaxSize(Companion_instance);
        sourceInformationMarkerStart($composer_0, 855672835, 'CC(remember):GiftSelection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_3;
        if (false || it === Companion_getInstance().f30_1) {
          var value = MediaGalleryDialog$lambda$lambda$lambda($userIsZooming$delegate);
          $composer_0.j31(value);
          tmp_3 = value;
        } else {
          tmp_3 = it;
        }
        var tmp0_group = tmp_3;
        sourceInformationMarkerEnd($composer_0);
        ZoomableMediaView(tmp_1, null, tmp_2, null, tmp0_group, $composer_0, 25008, 8);
        var tmp_4;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_4 = Unit_instance;
        }
        tmp_0 = tmp_4;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function MediaGalleryDialog$lambda_2($media, $pagerState, $description, $onDismiss, $title, $userIsZooming$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C609@24846L4979:GiftSelection.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1508318517, $changed, -1, 'client.fstech.hadaya.presentation.common.MediaGalleryDialog.<anonymous> (GiftSelection.kt:609)');
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = background(fillMaxSize(Companion_instance), Companion_getInstance_14().i6b_1);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 103947782, 'C643@26273L917,667@27254L2557:GiftSelection.kt#c1nezb');
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$media.r()) {
          $composer_5.m30(103862283);
          sourceInformation($composer_5, '620@25291L336,615@25045L582');
          var tmp0_modifier = fillMaxSize(Companion_instance);
          var tmp1_userScrollEnabled = !MediaGalleryDialog$lambda_0($userIsZooming$delegate);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp2_pageSpacing = _Dp___init__impl__ms3zkb(16);
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-1219219987, true, MediaGalleryDialog$lambda$lambda($media, $userIsZooming$delegate), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_6 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_6.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it = $composer_6.i31();
          var tmp_1;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = ComposableLambda$invoke$ref_7(dispatchReceiver);
            $composer_6.j31(value);
            tmp_1 = value;
          } else {
            tmp_1 = it;
          }
          var tmp$ret$8 = tmp_1;
          HorizontalPager($pagerState, tmp0_modifier, null, null, 0, tmp2_pageSpacing, null, null, tmp1_userScrollEnabled, false, null, null, null, null, tmp$ret$8, $composer_5, 196656, 24576, 16092);
          $composer_5.n30();
        } else {
          // Inline function 'kotlin.text.isNullOrBlank' call
          var this_0 = $description._v;
          if (!(this_0 == null || isBlank(this_0))) {
            $composer_5.m30(104495396);
            sourceInformation($composer_5, '629@25707L485');
            var tmp_2 = fillMaxSize(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$16 = _Dp___init__impl__ms3zkb(24);
            // Inline function 'androidx.compose.foundation.layout.Box' call
            var modifier_1 = padding_0(tmp_2, tmp$ret$16);
            var contentAlignment_0 = Companion_getInstance_11().o8t_1;
            var propagateMinConstraints_0 = false;
            var $composer_7 = $composer_5;
            if (!((4 & 1) === 0))
              modifier_1 = Companion_instance;
            if (!((4 & 2) === 0))
              contentAlignment_0 = Companion_getInstance_11().k8t_1;
            if (!((4 & 4) === 0))
              propagateMinConstraints_0 = false;
            var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
            // Inline function 'androidx.compose.ui.layout.Layout' call
            var modifier_2 = modifier_1;
            var $composer_8 = $composer_7;
            if (!((0 & 2) === 0))
              modifier_2 = Companion_instance;
            var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
            var localMap_0 = $composer_8.t31();
            var materialized_0 = materialize($composer_8, modifier_2);
            var tmp0_0 = Companion_getInstance_12().oah_1;
            // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
            var $composer_9 = $composer_8;
            var tmp_3 = $composer_9.g30();
            if (!isInterface(tmp_3, Applier)) {
              invalidApplier();
            }
            $composer_9.b31();
            if ($composer_9.h30()) {
              $composer_9.c31(tmp0_0);
            } else {
              $composer_9.d31();
            }
            var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
            Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
            var $composer_10 = $composer_9;
            var $composer_11 = $composer_10;
            sourceInformationMarkerStart($composer_11, -1749380492, 'C636@26066L10,633@25894L276:GiftSelection.kt#c1nezb');
            var tmp0_text = $description._v;
            var tmp1_color = Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.8);
            var tmp2_style = MaterialTheme_instance.jog($composer_11, 6).oof_1;
            var tmp3_textAlign = Companion_getInstance_15().d7v_1;
            var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_7 = _TextOverflow___init__impl__obguoe(0);
            Text(tmp0_text, null, tmp1_color, null, tmp_4, null, null, null, tmp_5, null, tmp3_textAlign, tmp_6, tmp_7, false, 0, 0, null, tmp2_style, $composer_11, 384, 0, 130042);
            sourceInformationMarkerEnd($composer_11);
            $composer_9.e31();
            $composer_5.n30();
          } else {
            $composer_5.m30(104999921);
            $composer_5.n30();
          }
        }
        var tmp3_$receiver = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp4_top = _Dp___init__impl__ms3zkb(48);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp5_start = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp6_end = _Dp___init__impl__ms3zkb(16);
        var tmp7_modifier = BoxScopeInstance_instance.udr(padding_1(tmp3_$receiver, tmp5_start, tmp4_top, tmp6_end), Companion_getInstance_11().l8t_1);
        var tmp8_verticalAlignment = Companion_getInstance_11().u8t_1;
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_3 = tmp7_modifier;
        var horizontalArrangement = Arrangement_getInstance().rdp_1;
        var verticalAlignment = tmp8_verticalAlignment;
        var $composer_12 = $composer_5;
        if (!((0 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_12, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_13 = $composer_12;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_13, 0).hashCode();
        var localMap_1 = $composer_13.t31();
        var materialized_1 = materialize($composer_13, modifier_4);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_14 = $composer_13;
        var tmp_8 = $composer_14.g30();
        if (!isInterface(tmp_8, Applier)) {
          invalidApplier();
        }
        $composer_14.b31();
        if ($composer_14.h30()) {
          $composer_14.c31(tmp0_1);
        } else {
          $composer_14.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_14);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_15 = $composer_14;
        var $composer_16 = $composer_15;
        sourceInformationMarkerStart($composer_16, 973208519, 'C651@26653L519:GiftSelection.kt#c1nezb');
        var tmp_9 = background(Companion_instance, Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.3), get_CircleShape());
        IconButton($onDismiss, tmp_9, false, null, null, null, ComposableSingletons$GiftSelectionKt_getInstance().e11s_1, $composer_16, 1572864, 60);
        sourceInformationMarkerEnd($composer_16);
        $composer_14.e31();
        var tmp_10 = background_0(fillMaxWidth(BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1)), Companion_instance_1.d6c(listOf_0([new Color_0(Companion_getInstance_14().t6b_1), new Color_0(Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.7))])));
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_11 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$33 = _Dp___init__impl__ms3zkb(32);
        var tmp10_modifier = padding_2(tmp_10, tmp_11, tmp$ret$33);
        var tmp11_horizontalAlignment = Companion_getInstance_11().x8t_1;
        var tmp_12 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$34 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_5 = tmp10_modifier;
        var verticalArrangement = tmp_12.mdq(tmp$ret$34);
        var horizontalAlignment = tmp11_horizontalAlignment;
        var $composer_17 = $composer_5;
        if (!((0 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((0 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((0 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_2 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_17, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_18 = $composer_17;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_18, 0).hashCode();
        var localMap_2 = $composer_18.t31();
        var materialized_2 = materialize($composer_18, modifier_6);
        var tmp0_2 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_19 = $composer_18;
        var tmp_13 = $composer_19.g30();
        if (!isInterface(tmp_13, Applier)) {
          invalidApplier();
        }
        $composer_19.b31();
        if ($composer_19.h30()) {
          $composer_19.c31(tmp0_2);
        } else {
          $composer_19.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_19);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_20 = $composer_19;
        var $composer_21 = $composer_20;
        sourceInformationMarkerStart($composer_21, -1025630990, 'C:GiftSelection.kt#c1nezb');
        // Inline function 'kotlin.text.isNullOrBlank' call
        var this_1 = $title._v;
        if (!(this_1 == null || isBlank(this_1))) {
          $composer_21.m30(-1025626651);
          sourceInformation($composer_21, '684@28096L10,681@27949L310');
          var tmp0_text_0 = $title._v;
          var tmp1_color_0 = Companion_getInstance_14().m6b_1;
          var tmp2_style_0 = MaterialTheme_instance.jog($composer_21, 6).lof_1;
          var tmp3_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp4_textAlign = Companion_getInstance_15().d7v_1;
          var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_15 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_17 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text_0, null, tmp1_color_0, null, tmp_14, null, tmp3_fontWeight, null, tmp_15, null, tmp4_textAlign, tmp_16, tmp_17, false, 0, 0, null, tmp2_style_0, $composer_21, 1573248, 0, 129978);
          $composer_21.n30();
        } else {
          $composer_21.m30(-1025306917);
          $composer_21.n30();
        }
        var tmp_18;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$media.r()) {
          // Inline function 'kotlin.text.isNullOrBlank' call
          var this_2 = $description._v;
          tmp_18 = !(this_2 == null || isBlank(this_2));
        } else {
          tmp_18 = false;
        }
        if (tmp_18) {
          $composer_21.m30(-1025193860);
          sourceInformation($composer_21, '694@28557L10,691@28385L319');
          var tmp5_text = $description._v;
          var tmp6_color = Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.7);
          var tmp7_style = MaterialTheme_instance.jog($composer_21, 6).pof_1;
          var tmp8_textAlign = Companion_getInstance_15().d7v_1;
          var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_21 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_22 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp5_text, null, tmp6_color, null, tmp_19, null, null, null, tmp_20, null, tmp8_textAlign, tmp_21, tmp_22, false, 3, 0, null, tmp7_style, $composer_21, 384, 24576, 113658);
          $composer_21.n30();
        } else {
          $composer_21.m30(-1024865477);
          $composer_21.n30();
        }
        if ($media.n1() > 1) {
          $composer_21.m30(-1024759364);
          sourceInformation($composer_21, '702@28828L943');
          var tmp_23 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$44 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_7 = null;
          var horizontalArrangement_0 = tmp_23.mdq(tmp$ret$44);
          var verticalAlignment_0 = Companion_getInstance_11().u8t_1;
          var $composer_22 = $composer_21;
          if (!((1 & 1) === 0))
            modifier_7 = Companion_instance;
          if (!((1 & 2) === 0))
            horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
          if (!((1 & 4) === 0))
            verticalAlignment_0 = Companion_getInstance_11().t8t_1;
          var measurePolicy_3 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_22, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_8 = modifier_7;
          var $composer_23 = $composer_22;
          if (!((0 & 2) === 0))
            modifier_8 = Companion_instance;
          var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_23, 0).hashCode();
          var localMap_3 = $composer_23.t31();
          var materialized_3 = materialize($composer_23, modifier_8);
          var tmp0_3 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_24 = $composer_23;
          var tmp_24 = $composer_24.g30();
          if (!isInterface(tmp_24, Applier)) {
            invalidApplier();
          }
          $composer_24.b31();
          if ($composer_24.h30()) {
            $composer_24.c31(tmp0_3);
          } else {
            $composer_24.d31();
          }
          var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_24);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
          var $composer_25 = $composer_24;
          var $composer_26 = $composer_25;
          sourceInformationMarkerStart($composer_26, 158515944, 'C:GiftSelection.kt#c1nezb');
          $composer_26.m30(1667681403);
          sourceInformation($composer_26, '*708@29187L528');
          // Inline function 'kotlin.repeat' call
          var times = $media.n1();
          var inductionVariable = 0;
          if (inductionVariable < times)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var isSelected = $pagerState.zj9() === index;
              var tmp_25 = Companion_instance;
              var tmp_26;
              if (isSelected) {
                // Inline function 'androidx.compose.ui.unit.dp' call
                tmp_26 = _Dp___init__impl__ms3zkb(8);
              } else {
                // Inline function 'androidx.compose.ui.unit.dp' call
                tmp_26 = _Dp___init__impl__ms3zkb(6);
              }
              Box(background(clip(size(tmp_25, tmp_26), get_CircleShape()), isSelected ? Companion_getInstance_14().m6b_1 : Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.5)), $composer_26, 0);
            }
             while (inductionVariable < times);
          $composer_26.n30();
          sourceInformationMarkerEnd($composer_26);
          $composer_24.e31();
          $composer_21.n30();
        } else {
          $composer_21.m30(-1023807013);
          $composer_21.n30();
        }
        sourceInformationMarkerEnd($composer_21);
        $composer_19.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_27;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_27 = Unit_instance;
        }
        tmp = tmp_27;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function MediaGalleryDialog$lambda_3($media, $title, $description, $onDismiss, $$changed, $$default) {
    return function ($composer, $force) {
      MediaGalleryDialog($media, $title._v, $description._v, $onDismiss, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function HadayaAlertDialog(title, message, confirmText, cancelText, onConfirm, onDismiss, $composer, $changed, $default) {
    var confirmText_0 = {_v: confirmText};
    var cancelText_0 = {_v: cancelText};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-877162047);
    sourceInformation($composer_0, 'C(HadayaAlertDialog)P(5,2,1)47@1538L11,36@1175L142,41@1343L111,23@817L180,30@1014L135,21@750L844:HadayaAlertDialog.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(title) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(message) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | (($default & 4) === 0 && $composer_0.k31(confirmText_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | (($default & 8) === 0 && $composer_0.k31(cancelText_0._v) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onConfirm) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismiss) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74899) === 74898), $dirty & 1)) {
      $composer_0.q30();
      sourceInformation($composer_0, '16@598L29,17@654L33');
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 4) === 0)) {
          confirmText_0._v = stringResource(get_ok(string_instance), $composer_0, 0);
          $dirty = $dirty & -897;
        }
        if (!(($default & 8) === 0)) {
          cancelText_0._v = stringResource(get_cancel(string_instance), $composer_0, 0);
          $dirty = $dirty & -7169;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 4) === 0))
          $dirty = $dirty & -897;
        if (!(($default & 8) === 0))
          $dirty = $dirty & -7169;
      }
      $composer_0.r30();
      if (isTraceInProgress()) {
        traceEventStart(-877162047, $dirty, -1, 'client.fstech.hadaya.presentation.common.HadayaAlertDialog (HadayaAlertDialog.kt:20)');
      }
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
      var tmp0_shape = RoundedCornerShape(tmp$ret$0);
      var tmp1_containerColor = MaterialTheme_instance.unz($composer_0, 6).mo0_1;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp2_tonalElevation = _Dp___init__impl__ms3zkb(6);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-219152775, true, HadayaAlertDialog$lambda(onConfirm, confirmText_0), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp_0 = tmp;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_0 = rememberComposableLambda(-1943761097, true, HadayaAlertDialog$lambda_0(onDismiss, cancelText_0), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_2.k31(dispatchReceiver_0);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_2.i31();
      var tmp_1;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = ComposableLambda$invoke$ref(dispatchReceiver_0);
        $composer_2.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp_2 = tmp_1;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_1 = rememberComposableLambda(626597877, true, HadayaAlertDialog$lambda_1(title), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_3.k31(dispatchReceiver_1);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_3.i31();
      var tmp_3;
      if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = ComposableLambda$invoke$ref(dispatchReceiver_1);
        $composer_3.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp_4 = tmp_3;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_2 = rememberComposableLambda(-235706284, true, HadayaAlertDialog$lambda_2(message), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_4 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = $composer_4.k31(dispatchReceiver_2);
      // Inline function 'kotlin.let' call
      var it_2 = $composer_4.i31();
      var tmp_5;
      if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = ComposableLambda$invoke$ref(dispatchReceiver_2);
        $composer_4.j31(value_2);
        tmp_5 = value_2;
      } else {
        tmp_5 = it_2;
      }
      var tmp_6 = tmp_5;
      var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_8 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      AlertDialog(onDismiss, tmp_0, null, tmp_2, null, tmp_4, tmp_6, tmp0_shape, tmp1_containerColor, tmp_7, tmp_8, tmp_9, tmp2_tonalElevation, null, $composer_0, 1772592 | 14 & $dirty >> 15, 384, 11796);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(HadayaAlertDialog$lambda_3(title, message, confirmText_0, cancelText_0, onConfirm, onDismiss, $changed, $default));
    }
  }
  function HadayaAlertDialog$lambda$lambda($confirmText) {
    return function ($this$TextButton, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C38@1239L54:HadayaAlertDialog.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1579934172, $changed, -1, 'client.fstech.hadaya.presentation.common.HadayaAlertDialog.<anonymous>.<anonymous> (HadayaAlertDialog.kt:38)');
        }
        var tmp_0 = $confirmText._v;
        var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = Companion_getInstance_16().e7z_1;
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, null, tmp_1, null, tmp_2, null, tmp_3, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 1572864, 0, 262078);
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HadayaAlertDialog$lambda($onConfirm, $confirmText) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C37@1221L86,37@1189L118:HadayaAlertDialog.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-219152775, $changed, -1, 'client.fstech.hadaya.presentation.common.HadayaAlertDialog.<anonymous> (HadayaAlertDialog.kt:37)');
        }
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1579934172, true, HadayaAlertDialog$lambda$lambda($confirmText), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_1.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp$ret$0 = tmp_0;
        TextButton($onConfirm, null, false, null, null, null, null, null, null, tmp$ret$0, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HadayaAlertDialog$lambda$lambda_0($cancelText) {
    return function ($this$TextButton, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C43@1407L23:HadayaAlertDialog.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-144674150, $changed, -1, 'client.fstech.hadaya.presentation.common.HadayaAlertDialog.<anonymous>.<anonymous> (HadayaAlertDialog.kt:43)');
        }
        var tmp_0 = $cancelText._v;
        var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HadayaAlertDialog$lambda_0($onDismiss, $cancelText) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C42@1389L55,42@1357L87:HadayaAlertDialog.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1943761097, $changed, -1, 'client.fstech.hadaya.presentation.common.HadayaAlertDialog.<anonymous> (HadayaAlertDialog.kt:42)');
        }
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-144674150, true, HadayaAlertDialog$lambda$lambda_0($cancelText), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_1.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp$ret$0 = tmp_0;
        TextButton($onDismiss, null, false, null, null, null, null, null, null, tmp$ret$0, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HadayaAlertDialog$lambda_1($title) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C26@905L10,24@831L156:HadayaAlertDialog.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(626597877, $changed, -1, 'client.fstech.hadaya.presentation.common.HadayaAlertDialog.<anonymous> (HadayaAlertDialog.kt:24)');
        }
        var tmp0_style = MaterialTheme_instance.jog($composer_0, 6).mof_1;
        var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text($title, null, tmp_0, null, tmp_1, null, tmp1_fontWeight, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, tmp0_style, $composer_0, 1572864, 0, 131006);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HadayaAlertDialog$lambda_2($message) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C33@1104L10,31@1028L111:HadayaAlertDialog.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-235706284, $changed, -1, 'client.fstech.hadaya.presentation.common.HadayaAlertDialog.<anonymous> (HadayaAlertDialog.kt:31)');
        }
        var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text($message, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).pof_1, $composer_0, 0, 0, 131070);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HadayaAlertDialog$lambda_3($title, $message, $confirmText, $cancelText, $onConfirm, $onDismiss, $$changed, $$default) {
    return function ($composer, $force) {
      HadayaAlertDialog($title, $message, $confirmText._v, $cancelText._v, $onConfirm, $onDismiss, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function HadayaImage(model, contentDescription, modifier, contentScale, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var contentScale_0 = {_v: contentScale};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(848371354);
    sourceInformation($composer_0, 'C(HadayaImage)P(2!1,3)42@1800L33,43@1848L277,52@2149L24,53@2192L25,56@2281L11,55@2223L1561:HadayaImage.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(model) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(contentDescription) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(contentScale_0._v) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (!(($default & 8) === 0)) {
        contentScale_0._v = Companion_getInstance_13().r96_1;
      }
      if (isTraceInProgress()) {
        traceEventStart(848371354, $dirty, -1, 'client.fstech.hadaya.presentation.common.HadayaImage (HadayaImage.kt:41)');
      }
      sourceInformationMarkerStart($composer_0, -758909285, 'CC(remember):HadayaImage.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = mutableIntStateOf(0);
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var retryCount$delegate = tmp0_group;
      var tmp1_remember$arg$1 = HadayaImage$lambda(retryCount$delegate);
      sourceInformationMarkerStart($composer_0, -758907505, 'CC(remember):HadayaImage.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_0.k31(model) | $composer_0.m31(tmp1_remember$arg$1));
      // Inline function 'kotlin.let' call
      var it_0 = tmp0.i31();
      var tmp_0;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var tmp_1;
        if (!(model == null) ? typeof model === 'string' : false) {
          var tmp_2;
          if (HadayaImage$lambda(retryCount$delegate) > 0) {
            tmp_2 = contains(model, '?') ? model + '&retry=' + HadayaImage$lambda(retryCount$delegate) : model + '?retry=' + HadayaImage$lambda(retryCount$delegate);
          } else {
            tmp_2 = model;
          }
          tmp_1 = tmp_2;
        } else {
          tmp_1 = toString_0(model);
        }
        var value_0 = tmp_1;
        tmp0.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp2_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      var url = tmp2_group;
      var action$delegate = rememberImageAction(url, null, $composer_0, 0, 2);
      var tmp_3 = _FilterQuality___init__impl__nv51aq(0);
      var painter = rememberImagePainter(url, null, tmp_3, null, null, $composer_0, 0, 30);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_1 = background(modifier_0._v, Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_0, 6).oo0_1, 0.5));
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((4 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((4 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((4 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_4 = $composer_3.g30();
      if (!isInterface(tmp_4, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0_0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -1443768542, 'C59@2417L187:HadayaImage.kt#c1nezb');
      var tmp_5 = fillMaxSize(Companion_instance);
      var tmp_6 = contentScale_0._v;
      Image(painter, contentDescription, tmp_5, null, tmp_6, 0.0, null, $composer_5, 384 | androidx_compose_ui_graphics_painter_Painter$stableprop_getter() | 112 & $dirty | 57344 & $dirty << 3, 104);
      var tmp_7 = HadayaImage$lambda_1(action$delegate);
      if (isInterface(tmp_7, Loading)) {
        $composer_5.m30(-1443551140);
        sourceInformation($composer_5, '67@2663L58');
        var tmp_8 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$14 = _Dp___init__impl__ms3zkb(24);
        var tmp_9 = size(tmp_8, tmp$ret$14);
        var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_11 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_13 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, _Dp___init__impl__ms3zkb(0.0), $composer_5, 6, 62);
        $composer_5.n30();
      } else {
        $composer_5.m30(-1443472338);
        $composer_5.n30();
      }
      var tmp_14 = HadayaImage$lambda_1(action$delegate);
      if (isInterface(tmp_14, Failure)) {
        $composer_5.m30(-1443383492);
        sourceInformation($composer_5, '74@2999L11,71@2790L978');
        var tmp0_horizontalAlignment = Companion_getInstance_11().x8t_1;
        var tmp1_verticalArrangement = Arrangement_getInstance().udp_1;
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_3 = background(fillMaxSize(Companion_instance), Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_5, 6).oo0_1, 0.9));
        var verticalArrangement = tmp1_verticalArrangement;
        var horizontalAlignment = tmp0_horizontalAlignment;
        var $composer_6 = $composer_5;
        if (!((0 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((0 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((0 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_4);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_15 = $composer_8.g30();
        if (!isInterface(tmp_15, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_1);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, -1380649197, 'C79@3239L11,76@3078L249,83@3386L16,82@3344L410:HadayaImage.kt#c1nezb');
        var tmp0_imageVector = get_ImageNotSupported(Icons_getInstance().dxv_1);
        var tmp1_tint = MaterialTheme_instance.unz($composer_10, 6).to0_1;
        var tmp_16 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$21 = _Dp___init__impl__ms3zkb(24);
        var tmp2_modifier = size(tmp_16, tmp$ret$21);
        Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_10, 432, 0);
        sourceInformationMarkerStart($composer_10, -1152906532, 'CC(remember):HadayaImage.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_1 = $composer_10.i31();
        var tmp_17;
        if (false || it_1 === Companion_getInstance().f30_1) {
          var value_1 = HadayaImage$lambda_2(retryCount$delegate);
          $composer_10.j31(value_1);
          tmp_17 = value_1;
        } else {
          tmp_17 = it_1;
        }
        var tmp0_group_0 = tmp_17;
        sourceInformationMarkerEnd($composer_10);
        var tmp_18 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$26 = _Dp___init__impl__ms3zkb(4);
        var tmp_19 = padding_1(tmp_18, VOID, tmp$ret$26);
        IconButton(tmp0_group_0, tmp_19, false, null, null, null, ComposableSingletons$HadayaImageKt_getInstance().h11s_1, $composer_10, 1572918, 60);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        $composer_5.n30();
      } else {
        $composer_5.m30(-1442433714);
        $composer_5.n30();
      }
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp3_safe_receiver = $composer_0.t30();
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.p3c(HadayaImage$lambda_3(model, contentDescription, modifier_0, contentScale_0, $changed, $default));
    }
  }
  function ComposableSingletons$HadayaImageKt$lambda$1665107502$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C88@3616L32,89@3695L11,86@3504L232:HadayaImage.kt#c1nezb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1665107502, $changed, -1, 'client.fstech.hadaya.presentation.common.ComposableSingletons$HadayaImageKt.lambda$1665107502.<anonymous> (HadayaImage.kt:86)');
      }
      var tmp = get_Refresh(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_retry(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).xnz_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$HadayaImageKt() {
    ComposableSingletons$HadayaImageKt_instance = this;
    var tmp = this;
    tmp.h11s_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1665107502, false, ComposableSingletons$HadayaImageKt$lambda$1665107502$lambda));
  }
  var ComposableSingletons$HadayaImageKt_instance;
  function ComposableSingletons$HadayaImageKt_getInstance() {
    if (ComposableSingletons$HadayaImageKt_instance == null)
      new ComposableSingletons$HadayaImageKt();
    return ComposableSingletons$HadayaImageKt_instance;
  }
  function HadayaImage$lambda($retryCount$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('retryCount', KMutableProperty0, true);
    return $retryCount$delegate.b49();
  }
  function HadayaImage$lambda_0($retryCount$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('retryCount', KMutableProperty0, true);
    $retryCount$delegate.a49(_set____db54di);
    return Unit_instance;
  }
  function HadayaImage$lambda_1($action$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('action', KProperty0, false);
    return $action$delegate.u1();
  }
  function HadayaImage$lambda_2($retryCount$delegate) {
    return function () {
      var _unary__edvuaz = HadayaImage$lambda($retryCount$delegate);
      HadayaImage$lambda_0($retryCount$delegate, _unary__edvuaz + 1 | 0);
      return Unit_instance;
    };
  }
  function HadayaImage$lambda_3($model, $contentDescription, $modifier, $contentScale, $$changed, $$default) {
    return function ($composer, $force) {
      HadayaImage($model, $contentDescription, $modifier._v, $contentScale._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ItemOptionsDisplay(item, language, modifier, showComment, showBirthday, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var showComment_0 = {_v: showComment};
    var showBirthday_0 = {_v: showBirthday};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1268818320);
    sourceInformation($composer_0, 'C(ItemOptionsDisplay)P(!3,4)31@1181L4517:ItemOptionsDisplay.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(item) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(showComment_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.l31(showBirthday_0._v) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (!(($default & 8) === 0)) {
        showComment_0._v = true;
      }
      if (!(($default & 16) === 0)) {
        showBirthday_0._v = true;
      }
      if (isTraceInProgress()) {
        traceEventStart(1268818320, $dirty, -1, 'client.fstech.hadaya.presentation.common.ItemOptionsDisplay (ItemOptionsDisplay.kt:30)');
      }
      var tmp0 = modifier_0._v;
      var tmp = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(2);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var $changed_0 = 48 | 14 & $dirty >> 6;
      var modifier_1 = tmp0;
      var verticalArrangement = tmp.mdq(tmp$ret$0);
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((4 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((4 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((4 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & $changed_0 >> 3 | 112 & $changed_0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0_0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -1149270760, 'C:ItemOptionsDisplay.kt#c1nezb');
      if (!(item.jyx_1 == null)) {
        $composer_5.m30(-1149354678);
        sourceInformation($composer_5, '37@1368L37,38@1494L10,39@1555L11,36@1336L254');
        var tmp_1 = stringResource(get_size_label(string_instance), $composer_5, 0);
        var tmp0_safe_receiver = item.jyx_1;
        var tmp1_text = tmp_1 + ': ' + (tmp0_safe_receiver == null ? null : formatNumbers(tmp0_safe_receiver, language));
        var tmp2_style = MaterialTheme_instance.jog($composer_5, 6).tof_1;
        var tmp3_color = MaterialTheme_instance.unz($composer_5, 6).co0_1;
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp1_text, null, tmp3_color, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, tmp2_style, $composer_5, 0, 0, 131066);
        $composer_5.n30();
      } else {
        $composer_5.m30(-1149100664);
        $composer_5.n30();
      }
      if (!(item.kyx_1 == null)) {
        $composer_5.m30(-1149038168);
        sourceInformation($composer_5, '44@1687L38,45@1815L10,46@1876L11,43@1655L256');
        var tmp_6 = stringResource(get_color_label(string_instance), $composer_5, 0);
        var tmp4_safe_receiver = item.kyx_1;
        var tmp5_text = tmp_6 + ': ' + (tmp4_safe_receiver == null ? null : formatNumbers(tmp4_safe_receiver, language));
        var tmp6_style = MaterialTheme_instance.jog($composer_5, 6).tof_1;
        var tmp7_color = MaterialTheme_instance.unz($composer_5, 6).co0_1;
        var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_10 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp5_text, null, tmp7_color, null, tmp_7, null, null, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, tmp6_style, $composer_5, 0, 0, 131066);
        $composer_5.n30();
      } else {
        $composer_5.m30(-1148782232);
        $composer_5.n30();
      }
      // Inline function 'kotlin.text.isNullOrBlank' call
      var this_0 = item.qyx_1;
      if (!(this_0 == null || isBlank(this_0))) {
        $composer_5.m30(-1148711583);
        sourceInformation($composer_5, '51@2016L46,52@2151L10,53@2212L11,50@1984L263');
        var tmp_11 = stringResource(get_bracelet_name_label(string_instance), $composer_5, 0);
        var tmp8_safe_receiver = item.qyx_1;
        var tmp9_text = tmp_11 + ': ' + (tmp8_safe_receiver == null ? null : formatNumbers(tmp8_safe_receiver, language));
        var tmp10_style = MaterialTheme_instance.jog($composer_5, 6).tof_1;
        var tmp11_color = MaterialTheme_instance.unz($composer_5, 6).co0_1;
        var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_15 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp9_text, null, tmp11_color, null, tmp_12, null, null, null, tmp_13, null, null, tmp_14, tmp_15, false, 0, 0, null, tmp10_style, $composer_5, 0, 0, 131066);
        $composer_5.n30();
      } else {
        $composer_5.m30(-1148448920);
        $composer_5.n30();
      }
      var tmp12_safe_receiver = item.lyx_1;
      if (tmp12_safe_receiver == null) {
        $composer_5.m30(-1148368662);
        $composer_5.n30();
      } else {
        $composer_5.m30(-1148368661);
        sourceInformation($composer_5, '*61@2548L10,62@2609L11,59@2434L210');
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = tmp12_safe_receiver.s1().t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          // Inline function 'kotlin.collections.component1' call
          var key = element.t1();
          // Inline function 'kotlin.collections.component2' call
          var value = element.u1();
          var groupName = key;
          var name = language === 'en' ? value.m100_1 : value.n100_1;
          var tmp0_text = groupName + ': ' + formatNumbers(name, language);
          var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).tof_1;
          var tmp2_color = MaterialTheme_instance.unz($composer_5, 6).co0_1;
          var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_17 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_18 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_19 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, null, tmp2_color, null, tmp_16, null, null, null, tmp_17, null, null, tmp_18, tmp_19, false, 0, 0, null, tmp1_style, $composer_5, 0, 0, 131066);
          // Inline function 'kotlin.text.isNullOrBlank' call
          var this_1 = value.g101_1;
          if (!(this_1 == null || isBlank(this_1))) {
            $composer_5.m30(1753149052);
            sourceInformation($composer_5, '68@2837L40,69@2970L10,70@3035L11,67@2797L296');
            var tmp_20 = stringResource(get_message_label(string_instance), $composer_5, 0);
            var tmp3_safe_receiver = value.g101_1;
            var tmp4_text = '  - ' + tmp_20 + ': ' + (tmp3_safe_receiver == null ? null : formatNumbers(tmp3_safe_receiver, language));
            var tmp5_style = MaterialTheme_instance.jog($composer_5, 6).tof_1;
            var tmp6_color = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_5, 6).co0_1, 0.8);
            var tmp_21 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_22 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_23 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_24 = _TextOverflow___init__impl__obguoe(0);
            Text(tmp4_text, null, tmp6_color, null, tmp_21, null, null, null, tmp_22, null, null, tmp_23, tmp_24, false, 0, 0, null, tmp5_style, $composer_5, 0, 0, 131066);
            $composer_5.n30();
          } else {
            $composer_5.m30(1753447396);
            $composer_5.n30();
          }
          // Inline function 'kotlin.text.isNullOrBlank' call
          var this_2 = value.f101_1;
          if (!(this_2 == null || isBlank(this_2))) {
            $composer_5.m30(1753528058);
            sourceInformation($composer_5, '75@3219L41,76@3354L10,77@3419L11,74@3179L298');
            var tmp_25 = stringResource(get_birthday_label(string_instance), $composer_5, 0);
            var tmp7_safe_receiver = value.f101_1;
            var tmp8_text = '  - ' + tmp_25 + ': ' + (tmp7_safe_receiver == null ? null : formatNumbers(tmp7_safe_receiver, language));
            var tmp9_style = MaterialTheme_instance.jog($composer_5, 6).tof_1;
            var tmp10_color = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_5, 6).co0_1, 0.8);
            var tmp_26 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_27 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_28 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_29 = _TextOverflow___init__impl__obguoe(0);
            Text(tmp8_text, null, tmp10_color, null, tmp_26, null, null, null, tmp_27, null, null, tmp_28, tmp_29, false, 0, 0, null, tmp9_style, $composer_5, 0, 0, 131066);
            $composer_5.n30();
          } else {
            $composer_5.m30(1753828324);
            $composer_5.n30();
          }
          var tmp_30;
          if (!(value.i101_1 == null)) {
            tmp_30 = true;
          } else {
            // Inline function 'kotlin.collections.isNullOrEmpty' call
            var this_3 = value.h101_1;
            tmp_30 = !(this_3 == null || this_3.r());
          }
          if (tmp_30) {
            $composer_5.m30(1753940699);
            sourceInformation($composer_5, '83@3738L10,84@3803L11,81@3596L265');
            var tmp11_text = '  - ' + (language === 'en' ? 'Image provided' : '\u0635\u0648\u0631\u0629 \u0645\u0631\u0641\u0642\u0629');
            var tmp12_style = MaterialTheme_instance.jog($composer_5, 6).tof_1;
            var tmp13_color = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_5, 6).co0_1, 0.8);
            var tmp_31 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_32 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_33 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
            var tmp_34 = _TextOverflow___init__impl__obguoe(0);
            Text(tmp11_text, null, tmp13_color, null, tmp_31, null, null, null, tmp_32, null, null, tmp_33, tmp_34, false, 0, 0, null, tmp12_style, $composer_5, 0, 0, 131066);
            $composer_5.n30();
          } else {
            $composer_5.m30(1754209252);
            $composer_5.n30();
          }
        }
        $composer_5.n30();
      }
      var tmp13_safe_receiver = item.dyx_1;
      if (tmp13_safe_receiver == null) {
        $composer_5.m30(-1146794792);
        $composer_5.n30();
      } else {
        $composer_5.m30(-1146794791);
        sourceInformation($composer_5, '*91@4058L37,92@4174L10,93@4235L11,90@4026L244');
        // Inline function 'kotlin.let' call
        var cardName = language === 'en' ? tmp13_safe_receiver.hyz_1 : tmp13_safe_receiver.iyz_1;
        var tmp0_text_0 = stringResource(get_card_label(string_instance), $composer_5, 0) + ': ' + formatNumbers(cardName, language);
        var tmp1_style_0 = MaterialTheme_instance.jog($composer_5, 6).tof_1;
        var tmp2_color_0 = MaterialTheme_instance.unz($composer_5, 6).co0_1;
        var tmp_35 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_36 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_37 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_38 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text_0, null, tmp2_color_0, null, tmp_35, null, null, null, tmp_36, null, null, tmp_37, tmp_38, false, 0, 0, null, tmp1_style_0, $composer_5, 0, 0, 131066);
        $composer_5.n30();
      }
      var tmp14_safe_receiver = item.gyx_1;
      if (tmp14_safe_receiver == null) {
        $composer_5.m30(-1146404130);
        $composer_5.n30();
      } else {
        $composer_5.m30(-1146404129);
        sourceInformation($composer_5, '*99@4448L36,100@4562L10,101@4623L11,98@4416L242');
        // Inline function 'kotlin.let' call
        var boxName = language === 'en' ? tmp14_safe_receiver.syz_1 : tmp14_safe_receiver.tyz_1;
        var tmp0_text_1 = stringResource(get_box_label(string_instance), $composer_5, 0) + ': ' + formatNumbers(boxName, language);
        var tmp1_style_1 = MaterialTheme_instance.jog($composer_5, 6).tof_1;
        var tmp2_color_1 = MaterialTheme_instance.unz($composer_5, 6).co0_1;
        var tmp_39 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_40 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_41 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_42 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text_1, null, tmp2_color_1, null, tmp_39, null, null, null, tmp_40, null, null, tmp_41, tmp_42, false, 0, 0, null, tmp1_style_1, $composer_5, 0, 0, 131066);
        $composer_5.n30();
      }
      // Inline function 'kotlin.text.isNullOrBlank' call
      var this_4 = item.eyx_1;
      if (!(this_4 == null || isBlank(this_4))) {
        $composer_5.m30(-1145987768);
        sourceInformation($composer_5, '106@4762L40,107@4890L10,108@4951L11,105@4730L256');
        var tmp_43 = stringResource(get_message_label(string_instance), $composer_5, 0);
        var tmp15_safe_receiver = item.eyx_1;
        var tmp16_text = tmp_43 + ': ' + (tmp15_safe_receiver == null ? null : formatNumbers(tmp15_safe_receiver, language));
        var tmp17_style = MaterialTheme_instance.jog($composer_5, 6).tof_1;
        var tmp18_color = MaterialTheme_instance.unz($composer_5, 6).co0_1;
        var tmp_44 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_45 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_46 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_47 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp16_text, null, tmp18_color, null, tmp_44, null, null, null, tmp_45, null, null, tmp_46, tmp_47, false, 0, 0, null, tmp17_style, $composer_5, 0, 0, 131066);
        $composer_5.n30();
      } else {
        $composer_5.m30(-1145731832);
        $composer_5.n30();
      }
      var tmp_48;
      if (showBirthday_0._v) {
        // Inline function 'kotlin.text.isNullOrBlank' call
        var this_5 = item.fyx_1;
        tmp_48 = !(this_5 == null || isBlank(this_5));
      } else {
        tmp_48 = false;
      }
      if (tmp_48) {
        $composer_5.m30(-1145645466);
        sourceInformation($composer_5, '113@5107L41,114@5237L10,115@5298L11,112@5075L258');
        var tmp_49 = stringResource(get_birthday_label(string_instance), $composer_5, 0);
        var tmp19_safe_receiver = item.fyx_1;
        var tmp20_text = tmp_49 + ': ' + (tmp19_safe_receiver == null ? null : formatNumbers(tmp19_safe_receiver, language));
        var tmp21_style = MaterialTheme_instance.jog($composer_5, 6).tof_1;
        var tmp22_color = MaterialTheme_instance.unz($composer_5, 6).co0_1;
        var tmp_50 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_51 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_52 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_53 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp20_text, null, tmp22_color, null, tmp_50, null, null, null, tmp_51, null, null, tmp_52, tmp_53, false, 0, 0, null, tmp21_style, $composer_5, 0, 0, 131066);
        $composer_5.n30();
      } else {
        $composer_5.m30(-1145387608);
        $composer_5.n30();
      }
      var tmp_54;
      if (showComment_0._v) {
        // Inline function 'kotlin.text.isNullOrBlank' call
        var this_6 = item.myx_1;
        tmp_54 = !(this_6 == null || isBlank(this_6));
      } else {
        tmp_54 = false;
      }
      if (tmp_54) {
        $composer_5.m30(-1145300219);
        sourceInformation($composer_5, '120@5455L40,121@5586L10,122@5647L11,119@5423L259');
        var tmp_55 = stringResource(get_comment_label(string_instance), $composer_5, 0);
        var tmp23_safe_receiver = item.myx_1;
        var tmp24_text = tmp_55 + ': ' + (tmp23_safe_receiver == null ? null : formatNumbers(tmp23_safe_receiver, language));
        var tmp25_style = MaterialTheme_instance.jog($composer_5, 6).tof_1;
        var tmp26_color = MaterialTheme_instance.unz($composer_5, 6).co0_1;
        var tmp_56 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_57 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_58 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_59 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp24_text, null, tmp26_color, null, tmp_56, null, null, null, tmp_57, null, null, tmp_58, tmp_59, false, 0, 0, null, tmp25_style, $composer_5, 0, 0, 131066);
        $composer_5.n30();
      } else {
        $composer_5.m30(-1145041400);
        $composer_5.n30();
      }
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver_0 = $composer_0.t30();
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      tmp0_safe_receiver_0.p3c(ItemOptionsDisplay$lambda(item, language, modifier_0, showComment_0, showBirthday_0, $changed, $default));
    }
  }
  function AgeGroupDisplay(isKids, isYouth, isOld, modifier, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(592226509);
    sourceInformation($composer_0, 'C(AgeGroupDisplay)P(!1,2)137@5887L1125:ItemOptionsDisplay.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.l31(isKids) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isYouth) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.l31(isOld) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (isTraceInProgress()) {
        traceEventStart(592226509, $dirty, -1, 'client.fstech.hadaya.presentation.common.AgeGroupDisplay (ItemOptionsDisplay.kt:134)');
      }
      if (!isKids && !isYouth && !isOld) {
        if (isTraceInProgress()) {
          traceEventEnd();
        }
        var tmp0_safe_receiver = $composer_0.t30();
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.p3c(AgeGroupDisplay$lambda(isKids, isYouth, isOld, modifier_0, $changed, $default));
        }
        return Unit_instance;
      }
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = fillMaxWidth(modifier_0._v);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -1170237258, 'C139@5965L42,140@6043L10,138@5940L233,145@6207L47,146@6290L10,144@6182L195,149@6386L620:ItemOptionsDisplay.kt#c1nezb');
      var tmp0_text = stringResource(get_age_group_label(string_instance), $composer_5, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(8);
      var tmp3_modifier = padding_1(tmp_0, VOID, VOID, VOID, tmp$ret$6);
      var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, tmp3_modifier, tmp_1, null, tmp_2, null, tmp2_fontWeight, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, tmp1_style, $composer_5, 1572912, 0, 131004);
      var tmp4_text = stringResource(get_age_group_for_prefix(string_instance), $composer_5, 0);
      var tmp5_style = MaterialTheme_instance.jog($composer_5, 6).pof_1;
      var tmp_6 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(8);
      var tmp6_modifier = padding_1(tmp_6, VOID, VOID, VOID, tmp$ret$7);
      var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_11 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp4_text, tmp6_modifier, tmp_7, null, tmp_8, null, null, null, tmp_9, null, null, tmp_10, tmp_11, false, 0, 0, null, tmp5_style, $composer_5, 48, 0, 131068);
      var tmp0_0 = fillMaxWidth(Companion_instance);
      var tmp_12 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$8 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_3 = tmp0_0;
      var horizontalArrangement = tmp_12.mdq(tmp$ret$8);
      var verticalAlignment = Companion_getInstance_11().u8t_1;
      var $composer_6 = $composer_5;
      if (!((0 & 1) === 0))
        modifier_3 = Companion_instance;
      if (!((0 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_6, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_4 = modifier_3;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_4 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_4);
      var tmp0_1 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_13 = $composer_8.g30();
      if (!isInterface(tmp_13, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_1);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, 1620468706, 'C:ItemOptionsDisplay.kt#c1nezb');
      if (isKids) {
        $composer_10.m30(1620471495);
        sourceInformation($composer_10, '155@6630L37,155@6616L84');
        AgeTag(stringResource(get_kids_label(string_instance), $composer_10, 0), RowScopeInstance_instance.bdy(Companion_instance, 1.0), $composer_10, 0, 0);
        $composer_10.n30();
      } else {
        $composer_10.m30(1620582971);
        $composer_10.n30();
      }
      if (isYouth) {
        $composer_10.m30(1620612390);
        sourceInformation($composer_10, '158@6772L38,158@6758L85');
        AgeTag(stringResource(get_youth_label(string_instance), $composer_10, 0), RowScopeInstance_instance.bdy(Companion_instance, 1.0), $composer_10, 0, 0);
        $composer_10.n30();
      } else {
        $composer_10.m30(1620724827);
        $composer_10.n30();
      }
      if (isOld) {
        $composer_10.m30(1620752200);
        sourceInformation($composer_10, '161@6913L36,161@6899L83');
        AgeTag(stringResource(get_old_label(string_instance), $composer_10, 0), RowScopeInstance_instance.bdy(Companion_instance, 1.0), $composer_10, 0, 0);
        $composer_10.n30();
      } else {
        $composer_10.m30(1620862715);
        $composer_10.n30();
      }
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(AgeGroupDisplay$lambda_0(isKids, isYouth, isOld, modifier_0, $changed, $default));
    }
  }
  function AgeTag(text, modifier, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(962398897);
    sourceInformation($composer_0, 'C(AgeTag)P(1)170@7137L11,173@7243L340,169@7098L485:ItemOptionsDisplay.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(text) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (isTraceInProgress()) {
        traceEventStart(962398897, $dirty, -1, 'client.fstech.hadaya.presentation.common.AgeTag (ItemOptionsDisplay.kt:168)');
      }
      var tmp0_color = MaterialTheme_instance.unz($composer_0, 6).znz_1;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      var tmp1_shape = RoundedCornerShape(tmp$ret$0);
      var tmp = modifier_0._v;
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_2 = _Dp___init__impl__ms3zkb(0.0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(12929164, true, AgeTag$lambda(text), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_3;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value);
        tmp_3 = value;
      } else {
        tmp_3 = it;
      }
      var tmp$ret$1 = tmp_3;
      Surface(tmp, tmp1_shape, tmp0_color, tmp_0, tmp_1, tmp_2, null, tmp$ret$1, $composer_0, 12582912 | 14 & $dirty >> 3, 120);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(AgeTag$lambda_0(text, modifier_0, $changed, $default));
    }
  }
  function ItemOptionsDisplay$lambda($item, $language, $modifier, $showComment, $showBirthday, $$changed, $$default) {
    return function ($composer, $force) {
      ItemOptionsDisplay($item, $language, $modifier._v, $showComment._v, $showBirthday._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function AgeGroupDisplay$lambda($isKids, $isYouth, $isOld, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      AgeGroupDisplay($isKids, $isYouth, $isOld, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function AgeGroupDisplay$lambda_0($isKids, $isYouth, $isOld, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      AgeGroupDisplay($isKids, $isYouth, $isOld, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function AgeTag$lambda($text) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C177@7395L10,178@7453L11,174@7253L324:ItemOptionsDisplay.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(12929164, $changed, -1, 'client.fstech.hadaya.presentation.common.AgeTag.<anonymous> (ItemOptionsDisplay.kt:174)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_1 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(8);
        var tmp0_modifier = padding_2(tmp_0, tmp_1, tmp$ret$1);
        var tmp1_style = MaterialTheme_instance.jog($composer_0, 6).sof_1;
        var tmp2_color = MaterialTheme_instance.unz($composer_0, 6).ao0_1;
        var tmp3_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp4_textAlign = Companion_getInstance_15().d7v_1;
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text($text, tmp0_modifier, tmp2_color, null, tmp_2, null, tmp3_fontWeight, null, tmp_3, null, tmp4_textAlign, tmp_4, tmp_5, false, 0, 0, null, tmp1_style, $composer_0, 1572912, 0, 129976);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AgeTag$lambda_0($text, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      AgeTag($text, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function LoginRequiredScreen(message, icon, onNavigateToAuth, modifier, $composer, $changed, $default) {
    var icon_0 = {_v: icon};
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1469629743);
    sourceInformation($composer_0, 'C(LoginRequiredScreen)P(1!1,3)33@1278L21,30@1187L1584:LoginRequiredScreen.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(message) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | (($default & 2) === 0 && $composer_0.k31(icon_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToAuth) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      $composer_0.q30();
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 2) === 0)) {
          icon_0._v = get_AccountCircle(Icons_getInstance().dxv_1);
          $dirty = $dirty & -113;
        }
        if (!(($default & 8) === 0)) {
          modifier_0._v = Companion_instance;
        }
      } else {
        $composer_0.z30();
        if (!(($default & 2) === 0))
          $dirty = $dirty & -113;
      }
      $composer_0.r30();
      if (isTraceInProgress()) {
        traceEventStart(-1469629743, $dirty, -1, 'client.fstech.hadaya.presentation.common.LoginRequiredScreen (LoginRequiredScreen.kt:29)');
      }
      var tmp = fillMaxSize(modifier_0._v);
      var tmp_0 = verticalScroll(tmp, rememberScrollState(0, $composer_0, 0, 1));
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = padding_0(tmp_0, tmp$ret$0);
      var verticalArrangement = null;
      var horizontalAlignment = Companion_getInstance_11().x8t_1;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((2 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((2 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 384 >> 3 | 112 & 384 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -1214724276, 'C37@1405L38,40@1491L842,65@2343L38,72@2630L125,68@2429L336:LoginRequiredScreen.kt#c1nezb');
      Spacer(ColumnScopeInstance_instance.yds(Companion_instance, 1.0), $composer_5, 0);
      var tmp0_horizontalAlignment = Companion_getInstance_11().x8t_1;
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_3 = null;
      var verticalArrangement_0 = Arrangement_getInstance().udp_1;
      var horizontalAlignment_0 = tmp0_horizontalAlignment;
      var $composer_6 = $composer_5;
      if (!((1 & 1) === 0))
        modifier_3 = Companion_instance;
      if (!((1 & 2) === 0))
        verticalArrangement_0 = Arrangement_getInstance().sdp_1;
      if (!((1 & 4) === 0))
        horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_6, 14 & 432 >> 3 | 112 & 432 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_4 = modifier_3;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_4 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_4);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_2 = $composer_8.g30();
      if (!isInterface(tmp_2, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_0);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, -392148965, 'C48@1797L11,44@1640L209,50@1862L41,53@1985L10,51@1916L149,56@2078L41,57@2132L191:LoginRequiredScreen.kt#c1nezb');
      var tmp_3 = icon_0._v;
      var tmp_4 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$13 = _Dp___init__impl__ms3zkb(64);
      Icon(tmp_3, null, size(tmp_4, tmp$ret$13), Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_10, 6).xnz_1, 0.5), $composer_10, 432 | 14 & $dirty >> 3, 0);
      var tmp_5 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$14 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_5, tmp$ret$14), $composer_10, 6);
      var tmp0_style = MaterialTheme_instance.jog($composer_10, 6).oof_1;
      var tmp1_textAlign = Companion_getInstance_15().d7v_1;
      var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextOverflow___init__impl__obguoe(0);
      Text(message, null, tmp_6, null, tmp_7, null, null, null, tmp_8, null, tmp1_textAlign, tmp_9, tmp_10, false, 0, 0, null, tmp0_style, $composer_10, 14 & $dirty, 0, 130046);
      var tmp_11 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$15 = _Dp___init__impl__ms3zkb(24);
      Spacer(height(tmp_11, tmp$ret$15), $composer_10, 6);
      var tmp_12 = fillMaxWidth(Companion_instance, 0.7);
      Button(onNavigateToAuth, tmp_12, false, null, null, null, null, null, null, ComposableSingletons$LoginRequiredScreenKt_getInstance().i11s_1, $composer_10, 805306416 | 14 & $dirty >> 6, 508);
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      Spacer(ColumnScopeInstance_instance.yds(Companion_instance, 1.0), $composer_5, 0);
      var tmp_13 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$16 = _Dp___init__impl__ms3zkb(16);
      var tmp_14 = padding_1(tmp_13, VOID, VOID, VOID, tmp$ret$16);
      var tmp_15 = fillMaxWidth(Companion_instance, 0.7);
      sourceInformationMarkerStart($composer_5, 1207779300, 'CC(remember):LoginRequiredScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it = $composer_5.i31();
      var tmp_16;
      if (false || it === Companion_getInstance().f30_1) {
        var value = LoginRequiredScreen$lambda;
        $composer_5.j31(value);
        tmp_16 = value;
      } else {
        tmp_16 = it;
      }
      var tmp0_group = tmp_16;
      sourceInformationMarkerEnd($composer_5);
      ContactUsSection(tmp_14, tmp_15, null, false, null, true, tmp0_group, false, $composer_5, 1769526, 156);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(LoginRequiredScreen$lambda_0(message, icon_0, onNavigateToAuth, modifier_0, $changed, $default));
    }
  }
  function ComposableSingletons$LoginRequiredScreenKt$lambda$_1384069203$lambda_x7m5dx($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C61@2276L32,61@2271L38:LoginRequiredScreen.kt#c1nezb');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1384069203, $changed, -1, 'client.fstech.hadaya.presentation.common.ComposableSingletons$LoginRequiredScreenKt.lambda$-1384069203.<anonymous> (LoginRequiredScreen.kt:61)');
      }
      var tmp = stringResource(get_login(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$LoginRequiredScreenKt() {
    ComposableSingletons$LoginRequiredScreenKt_instance = this;
    var tmp = this;
    tmp.i11s_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1384069203, false, ComposableSingletons$LoginRequiredScreenKt$lambda$_1384069203$lambda_x7m5dx));
  }
  var ComposableSingletons$LoginRequiredScreenKt_instance;
  function ComposableSingletons$LoginRequiredScreenKt_getInstance() {
    if (ComposableSingletons$LoginRequiredScreenKt_instance == null)
      new ComposableSingletons$LoginRequiredScreenKt();
    return ComposableSingletons$LoginRequiredScreenKt_instance;
  }
  function LoginRequiredScreen$lambda() {
    openUrl('https://raw.githubusercontent.com/AbdallaBadreldin/privacy-policy/refs/heads/main/Hadaya_privacy%2Bpolicy.html');
    return Unit_instance;
  }
  function LoginRequiredScreen$lambda_0($message, $icon, $onNavigateToAuth, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      LoginRequiredScreen($message, $icon._v, $onNavigateToAuth, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ProductMediaGalleryDialog(media, title, initialIndex, onDismiss, $composer, $changed, $default) {
    var title_0 = {_v: title};
    var initialIndex_0 = {_v: initialIndex};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(5010230);
    sourceInformation($composer_0, 'C(ProductMediaGalleryDialog)P(1,3)133@5340L14,133@5293L61,134@5380L34,140@5636L3915,136@5420L4137:ProductMediaGallerySection.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(media) : $composer_0.q31(media)) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(title_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.m31(initialIndex_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismiss) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        title_0._v = null;
      }
      if (!(($default & 4) === 0)) {
        initialIndex_0._v = 0;
      }
      if (isTraceInProgress()) {
        traceEventStart(5010230, $dirty, -1, 'client.fstech.hadaya.presentation.common.ProductMediaGalleryDialog (ProductMediaGallerySection.kt:132)');
      }
      var tmp = initialIndex_0._v;
      sourceInformationMarkerStart($composer_0, 519870404, 'CC(remember):ProductMediaGallerySection.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(media));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ProductMediaGalleryDialog$lambda(media);
        tmp0.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp0_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      var pagerState = rememberPagerState(tmp, 0.0, tmp0_group, $composer_0, 14 & $dirty >> 6, 2);
      sourceInformationMarkerStart($composer_0, 519871704, 'CC(remember):ProductMediaGallerySection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_0.i31();
      var tmp_1;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = mutableStateOf(false);
        this_0.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp1_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var userIsZooming$delegate = tmp1_group;
      var tmp0_properties = DialogProperties_init_$Create$(VOID, VOID, false);
      var tmp1_modifier = fillMaxSize(Companion_instance);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(660052208, true, ProductMediaGalleryDialog$lambda_2(pagerState, onDismiss, title_0, media, userIsZooming$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_1.i31();
      var tmp_2;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value_1);
        tmp_2 = value_1;
      } else {
        tmp_2 = it_1;
      }
      var tmp$ret$8 = tmp_2;
      BasicAlertDialog(onDismiss, tmp1_modifier, tmp0_properties, tmp$ret$8, $composer_0, 3504 | 14 & $dirty >> 9, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver = $composer_0.t30();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.p3c(ProductMediaGalleryDialog$lambda_3(media, title_0, initialIndex_0, onDismiss, $changed, $default));
    }
  }
  function ProductMediaGallerySection(product, language, onDialogVisibilityChanged, $composer, $changed, $default) {
    var onDialogVisibilityChanged_0 = {_v: onDialogVisibilityChanged};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1256307014);
    sourceInformation($composer_0, 'C(ProductMediaGallerySection)P(2)52@2350L2,56@2535L50,60@2655L34,61@2714L33,63@2785L58,63@2753L90,78@3164L1912:ProductMediaGallerySection.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(product) : $composer_0.q31(product)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onDialogVisibilityChanged_0._v) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        sourceInformationMarkerStart($composer_0, 425234344, 'CC(remember):ProductMediaGallerySection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProductMediaGallerySection$lambda;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var tmp0_group = tmp;
        sourceInformationMarkerEnd($composer_0);
        onDialogVisibilityChanged_0._v = tmp0_group;
      }
      if (isTraceInProgress()) {
        traceEventStart(1256307014, $dirty, -1, 'client.fstech.hadaya.presentation.common.ProductMediaGallerySection (ProductMediaGallerySection.kt:53)');
      }
      var tmp0_safe_receiver = product.xzt_1;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s = tmp0_safe_receiver.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(element)) {
            destination.j1(element);
          }
        }
        tmp_0 = destination;
      }
      var tmp1_elvis_lhs = tmp_0;
      var images = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
      var tmp2_safe_receiver = product.yzt_1;
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s_0 = tmp2_safe_receiver.t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(element_0)) {
            destination_0.j1(element_0);
          }
        }
        tmp_1 = destination_0;
      }
      var tmp3_elvis_lhs = tmp_1;
      var videos = tmp3_elvis_lhs == null ? emptyList() : tmp3_elvis_lhs;
      sourceInformationMarkerStart($composer_0, 425240312, 'CC(remember):ProductMediaGallerySection.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.k31(product));
      // Inline function 'kotlin.let' call
      var it_0 = tmp0.i31();
      var tmp_2;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = distinct(plus(images, videos));
        tmp0.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      var combinedMedia = tmp1_group;
      if (combinedMedia.r()) {
        if (isTraceInProgress()) {
          traceEventEnd();
        }
        var tmp6_safe_receiver = $composer_0.t30();
        if (tmp6_safe_receiver == null)
          null;
        else {
          tmp6_safe_receiver.p3c(ProductMediaGallerySection$lambda_0(product, language, onDialogVisibilityChanged_0, $changed, $default));
        }
        return Unit_instance;
      }
      sourceInformationMarkerStart($composer_0, 425244136, 'CC(remember):ProductMediaGallerySection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_1.i31();
      var tmp_3;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = mutableStateOf(false);
        this_1.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp2_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      var showMediaDialog$delegate = tmp2_group;
      sourceInformationMarkerStart($composer_0, 425246023, 'CC(remember):ProductMediaGallerySection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_2 = this_2.i31();
      var tmp_4;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var value_2 = mutableIntStateOf(0);
        this_2.j31(value_2);
        tmp_4 = value_2;
      } else {
        tmp_4 = it_2;
      }
      var tmp3_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      var initialIndex$delegate = tmp3_group;
      var tmp_5 = ProductMediaGallerySection$lambda_1(showMediaDialog$delegate);
      sourceInformationMarkerStart($composer_0, 425248320, 'CC(remember):ProductMediaGallerySection.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = ($dirty & 896) === 256;
      // Inline function 'kotlin.let' call
      var it_3 = tmp0_0.i31();
      var tmp_6;
      if (invalid_0 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = ProductMediaGallerySection$slambda_0(onDialogVisibilityChanged_0, showMediaDialog$delegate, null);
        tmp0_0.j31(value_3);
        tmp_6 = value_3;
      } else {
        tmp_6 = it_3;
      }
      var tmp4_group = tmp_6;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_5, tmp4_group, $composer_0, 0);
      var name = language === 'en' ? product.ozt_1 : product.pzt_1;
      if (ProductMediaGallerySection$lambda_1(showMediaDialog$delegate)) {
        $composer_0.m30(297966286);
        sourceInformation($composer_0, '74@3115L27,70@2962L190');
        var tmp_7 = ProductMediaGallerySection$lambda_3(initialIndex$delegate);
        sourceInformationMarkerStart($composer_0, 425258849, 'CC(remember):ProductMediaGallerySection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_3 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_4 = this_3.i31();
        var tmp_8;
        if (false || it_4 === Companion_getInstance().f30_1) {
          var value_4 = ProductMediaGallerySection$lambda_5(showMediaDialog$delegate);
          this_3.j31(value_4);
          tmp_8 = value_4;
        } else {
          tmp_8 = it_4;
        }
        var tmp5_group = tmp_8;
        sourceInformationMarkerEnd($composer_0);
        ProductMediaGalleryDialog(combinedMedia, name, tmp_7, tmp5_group, $composer_0, 3072, 0);
        $composer_0.n30();
      } else {
        $composer_0.m30(298164252);
        $composer_0.n30();
      }
      var tmp_9 = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$32 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = padding_2(tmp_9, VOID, tmp$ret$32);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0_1 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_10 = $composer_3.g30();
      if (!isInterface(tmp_10, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0_1);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -211512817, 'C82@3389L1681,79@3242L1828:ProductMediaGallerySection.kt#c1nezb');
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$39 = _Dp___init__impl__ms3zkb(24);
      var tmp_11 = PaddingValues_0(tmp$ret$39);
      var tmp_12 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$40 = _Dp___init__impl__ms3zkb(12);
      var tmp_13 = tmp_12.mdq(tmp$ret$40);
      sourceInformationMarkerStart($composer_5, -1946481087, 'CC(remember):ProductMediaGallerySection.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_5.q31(combinedMedia);
      // Inline function 'kotlin.let' call
      var it_5 = $composer_5.i31();
      var tmp_14;
      if (invalid_1 || it_5 === Companion_getInstance().f30_1) {
        var value_5 = ProductMediaGallerySection$lambda_6(combinedMedia, initialIndex$delegate, showMediaDialog$delegate);
        $composer_5.j31(value_5);
        tmp_14 = value_5;
      } else {
        tmp_14 = it_5;
      }
      var tmp0_group_0 = tmp_14;
      sourceInformationMarkerEnd($composer_5);
      LazyRow(null, null, tmp_11, false, tmp_13, null, null, false, null, tmp0_group_0, $composer_5, 24960, 491);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp7_safe_receiver = $composer_0.t30();
    if (tmp7_safe_receiver == null)
      null;
    else {
      tmp7_safe_receiver.p3c(ProductMediaGallerySection$lambda_7(product, language, onDialogVisibilityChanged_0, $changed, $default));
    }
  }
  function ComposableSingletons$ProductMediaGallerySectionKt$lambda$1832792168$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C179@7205L32,177@7101L210:ProductMediaGallerySection.kt#c1nezb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1832792168, $changed, -1, 'client.fstech.hadaya.presentation.common.ComposableSingletons$ProductMediaGallerySectionKt.lambda$1832792168.<anonymous> (ProductMediaGallerySection.kt:177)');
      }
      var tmp = get_Close(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_close(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, Companion_getInstance_14().m6b_1, $composer_0, 3072, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductMediaGallerySectionKt() {
    ComposableSingletons$ProductMediaGallerySectionKt_instance = this;
    var tmp = this;
    tmp.j11s_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1832792168, false, ComposableSingletons$ProductMediaGallerySectionKt$lambda$1832792168$lambda));
  }
  var ComposableSingletons$ProductMediaGallerySectionKt_instance;
  function ComposableSingletons$ProductMediaGallerySectionKt_getInstance() {
    if (ComposableSingletons$ProductMediaGallerySectionKt_instance == null)
      new ComposableSingletons$ProductMediaGallerySectionKt();
    return ComposableSingletons$ProductMediaGallerySectionKt_instance;
  }
  function ProductMediaGalleryDialog$lambda($media) {
    return function () {
      return $media.n1();
    };
  }
  function ProductMediaGalleryDialog$lambda_0($userIsZooming$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('userIsZooming', KMutableProperty0, true);
    return $userIsZooming$delegate.u1();
  }
  function ProductMediaGalleryDialog$lambda_1($userIsZooming$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('userIsZooming', KMutableProperty0, true);
    $userIsZooming$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProductMediaGalleryDialog$lambda$lambda$lambda($userIsZooming$delegate) {
    return function (it) {
      ProductMediaGalleryDialog$lambda_1($userIsZooming$delegate, it);
      return Unit_instance;
    };
  }
  function ProductMediaGalleryDialog$lambda$lambda($media, $userIsZooming$delegate) {
    return function ($this$HorizontalPager, index, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C157@6309L22,153@6103L250:ProductMediaGallerySection.kt#c1nezb');
      var $dirty = $changed;
      var tmp;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(index) ? 32 : 16);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1924109193, $dirty, -1, 'client.fstech.hadaya.presentation.common.ProductMediaGalleryDialog.<anonymous>.<anonymous>.<anonymous> (ProductMediaGallerySection.kt:152)');
        }
        var url = $media.l1(index);
        var tmp_1 = fillMaxSize(Companion_instance);
        sourceInformationMarkerStart($composer_0, -2061961121, 'CC(remember):ProductMediaGallerySection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_2;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProductMediaGalleryDialog$lambda$lambda$lambda($userIsZooming$delegate);
          $composer_0.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        ZoomableMediaView(url, null, tmp_1, null, tmp0_group, $composer_0, 25008, 8);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp_0 = tmp_3;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductMediaGalleryDialog$lambda_2($pagerState, $onDismiss, $title, $media, $userIsZooming$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C141@5650L3891:ProductMediaGallerySection.kt#c1nezb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(660052208, $changed, -1, 'client.fstech.hadaya.presentation.common.ProductMediaGalleryDialog.<anonymous> (ProductMediaGallerySection.kt:141)');
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = background(fillMaxSize(Companion_instance), Companion_getInstance_14().i6b_1);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 1190385869, 'C151@6029L342,146@5803L568,162@6434L917,186@7415L2112:ProductMediaGallerySection.kt#c1nezb');
        var tmp0_modifier = fillMaxSize(Companion_instance);
        var tmp1_userScrollEnabled = !ProductMediaGalleryDialog$lambda_0($userIsZooming$delegate);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_pageSpacing = _Dp___init__impl__ms3zkb(16);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1924109193, true, ProductMediaGalleryDialog$lambda$lambda($media, $userIsZooming$delegate), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_6 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_6.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_6.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref_7(dispatchReceiver);
          $composer_6.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp$ret$7 = tmp_1;
        HorizontalPager($pagerState, tmp0_modifier, null, null, 0, tmp2_pageSpacing, null, null, tmp1_userScrollEnabled, false, null, null, null, null, tmp$ret$7, $composer_5, 196656, 24576, 16092);
        var tmp3_$receiver = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp4_top = _Dp___init__impl__ms3zkb(48);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp5_start = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp6_end = _Dp___init__impl__ms3zkb(16);
        var tmp7_modifier = BoxScopeInstance_instance.udr(padding_1(tmp3_$receiver, tmp5_start, tmp4_top, tmp6_end), Companion_getInstance_11().l8t_1);
        var tmp8_verticalAlignment = Companion_getInstance_11().u8t_1;
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_1 = tmp7_modifier;
        var horizontalArrangement = Arrangement_getInstance().rdp_1;
        var verticalAlignment = tmp8_verticalAlignment;
        var $composer_7 = $composer_5;
        if (!((0 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_7, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_8 = $composer_7;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
        var localMap_0 = $composer_8.t31();
        var materialized_0 = materialize($composer_8, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_9 = $composer_8;
        var tmp_2 = $composer_9.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_9.b31();
        if ($composer_9.h30()) {
          $composer_9.c31(tmp0_0);
        } else {
          $composer_9.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_10 = $composer_9;
        var $composer_11 = $composer_10;
        sourceInformationMarkerStart($composer_11, -2109994602, 'C170@6814L519:ProductMediaGallerySection.kt#c1nezb');
        var tmp_3 = background(Companion_instance, Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.3), get_CircleShape());
        IconButton($onDismiss, tmp_3, false, null, null, null, ComposableSingletons$ProductMediaGallerySectionKt_getInstance().j11s_1, $composer_11, 1572864, 60);
        sourceInformationMarkerEnd($composer_11);
        $composer_9.e31();
        var tmp_4 = background_0(fillMaxWidth(BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1)), Companion_instance_1.d6c(listOf_0([new Color_0(Companion_getInstance_14().t6b_1), new Color_0(Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.7))])));
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_5 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$24 = _Dp___init__impl__ms3zkb(32);
        var tmp10_modifier = padding_2(tmp_4, tmp_5, tmp$ret$24);
        var tmp11_horizontalAlignment = Companion_getInstance_11().x8t_1;
        var tmp_6 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$25 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_3 = tmp10_modifier;
        var verticalArrangement = tmp_6.mdq(tmp$ret$25);
        var horizontalAlignment = tmp11_horizontalAlignment;
        var $composer_12 = $composer_5;
        if (!((0 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((0 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((0 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_1 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_12, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_13 = $composer_12;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_13, 0).hashCode();
        var localMap_1 = $composer_13.t31();
        var materialized_1 = materialize($composer_13, modifier_4);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_14 = $composer_13;
        var tmp_7 = $composer_14.g30();
        if (!isInterface(tmp_7, Applier)) {
          invalidApplier();
        }
        $composer_14.b31();
        if ($composer_14.h30()) {
          $composer_14.c31(tmp0_1);
        } else {
          $composer_14.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_14);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_15 = $composer_14;
        var $composer_16 = $composer_15;
        sourceInformationMarkerStart($composer_16, 1119543874, 'C:ProductMediaGallerySection.kt#c1nezb');
        // Inline function 'kotlin.text.isNullOrBlank' call
        var this_0 = $title._v;
        if (!(this_0 == null || isBlank(this_0))) {
          $composer_16.m30(1119562008);
          sourceInformation($composer_16, '203@8257L10,200@8110L310');
          var tmp0_text = $title._v;
          var tmp1_color = Companion_getInstance_14().m6b_1;
          var tmp2_style = MaterialTheme_instance.jog($composer_16, 6).lof_1;
          var tmp3_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp4_textAlign = Companion_getInstance_15().d7v_1;
          var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_11 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, null, tmp1_color, null, tmp_8, null, tmp3_fontWeight, null, tmp_9, null, tmp4_textAlign, tmp_10, tmp_11, false, 0, 0, null, tmp2_style, $composer_16, 1573248, 0, 129978);
          $composer_16.n30();
        } else {
          $composer_16.m30(1119881742);
          $composer_16.n30();
        }
        if ($media.n1() > 1) {
          $composer_16.m30(1119987855);
          sourceInformation($composer_16, '211@8544L943');
          var tmp_12 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$33 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_5 = null;
          var horizontalArrangement_0 = tmp_12.mdq(tmp$ret$33);
          var verticalAlignment_0 = Companion_getInstance_11().u8t_1;
          var $composer_17 = $composer_16;
          if (!((1 & 1) === 0))
            modifier_5 = Companion_instance;
          if (!((1 & 2) === 0))
            horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
          if (!((1 & 4) === 0))
            verticalAlignment_0 = Companion_getInstance_11().t8t_1;
          var measurePolicy_2 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_17, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_6 = modifier_5;
          var $composer_18 = $composer_17;
          if (!((0 & 2) === 0))
            modifier_6 = Companion_instance;
          var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_18, 0).hashCode();
          var localMap_2 = $composer_18.t31();
          var materialized_2 = materialize($composer_18, modifier_6);
          var tmp0_2 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_19 = $composer_18;
          var tmp_13 = $composer_19.g30();
          if (!isInterface(tmp_13, Applier)) {
            invalidApplier();
          }
          $composer_19.b31();
          if ($composer_19.h30()) {
            $composer_19.c31(tmp0_2);
          } else {
            $composer_19.d31();
          }
          var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_19);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
          var $composer_20 = $composer_19;
          var $composer_21 = $composer_20;
          sourceInformationMarkerStart($composer_21, 1109887464, 'C:ProductMediaGallerySection.kt#c1nezb');
          $composer_21.m30(1836918139);
          sourceInformation($composer_21, '*217@8903L528');
          // Inline function 'kotlin.repeat' call
          var times = $media.n1();
          var inductionVariable = 0;
          if (inductionVariable < times)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var isSelected = $pagerState.zj9() === index;
              var tmp_14 = Companion_instance;
              var tmp_15;
              if (isSelected) {
                // Inline function 'androidx.compose.ui.unit.dp' call
                tmp_15 = _Dp___init__impl__ms3zkb(8);
              } else {
                // Inline function 'androidx.compose.ui.unit.dp' call
                tmp_15 = _Dp___init__impl__ms3zkb(6);
              }
              Box(background(clip(size(tmp_14, tmp_15), get_CircleShape()), isSelected ? Companion_getInstance_14().m6b_1 : Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.5)), $composer_21, 0);
            }
             while (inductionVariable < times);
          $composer_21.n30();
          sourceInformationMarkerEnd($composer_21);
          $composer_19.e31();
          $composer_16.n30();
        } else {
          $composer_16.m30(1120940206);
          $composer_16.n30();
        }
        sourceInformationMarkerEnd($composer_16);
        $composer_14.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_16;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_16 = Unit_instance;
        }
        tmp = tmp_16;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductMediaGalleryDialog$lambda_3($media, $title, $initialIndex, $onDismiss, $$changed, $$default) {
    return function ($composer, $force) {
      ProductMediaGalleryDialog($media, $title._v, $initialIndex._v, $onDismiss, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ProductMediaGallerySection$lambda(it) {
    return Unit_instance;
  }
  function ProductMediaGallerySection$lambda_0($product, $language, $onDialogVisibilityChanged, $$changed, $$default) {
    return function ($composer, $force) {
      ProductMediaGallerySection($product, $language, $onDialogVisibilityChanged._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ProductMediaGallerySection$lambda_1($showMediaDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showMediaDialog', KMutableProperty0, true);
    return $showMediaDialog$delegate.u1();
  }
  function ProductMediaGallerySection$lambda_2($showMediaDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showMediaDialog', KMutableProperty0, true);
    $showMediaDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProductMediaGallerySection$lambda_3($initialIndex$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('initialIndex', KMutableProperty0, true);
    return $initialIndex$delegate.b49();
  }
  function ProductMediaGallerySection$lambda_4($initialIndex$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('initialIndex', KMutableProperty0, true);
    $initialIndex$delegate.a49(_set____db54di);
    return Unit_instance;
  }
  function ProductMediaGallerySection$slambda($onDialogVisibilityChanged, $showMediaDialog$delegate, resultContinuation) {
    this.s11s_1 = $onDialogVisibilityChanged;
    this.t11s_1 = $showMediaDialog$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductMediaGallerySection$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductMediaGallerySection$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductMediaGallerySection$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.s11s_1._v(ProductMediaGallerySection$lambda_1(this.t11s_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ProductMediaGallerySection$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new ProductMediaGallerySection$slambda(this.s11s_1, this.t11s_1, completion);
    i.u11s_1 = $this$LaunchedEffect;
    return i;
  };
  function ProductMediaGallerySection$slambda_0($onDialogVisibilityChanged, $showMediaDialog$delegate, resultContinuation) {
    var i = new ProductMediaGallerySection$slambda($onDialogVisibilityChanged, $showMediaDialog$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function ProductMediaGallerySection$lambda_5($showMediaDialog$delegate) {
    return function () {
      ProductMediaGallerySection$lambda_2($showMediaDialog$delegate, false);
      return Unit_instance;
    };
  }
  function ProductMediaGallerySection$lambda$lambda$lambda($index, $initialIndex$delegate, $showMediaDialog$delegate) {
    return function () {
      ProductMediaGallerySection$lambda_4($initialIndex$delegate, $index);
      ProductMediaGallerySection$lambda_2($showMediaDialog$delegate, true);
      return Unit_instance;
    };
  }
  function ProductMediaGallerySection$lambda$lambda($combinedMedia, $initialIndex$delegate, $showMediaDialog$delegate) {
    return function ($this$items, index, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C90@3756L11,91@3819L127,86@3567L1479:ProductMediaGallerySection.kt#c1nezb');
      var $dirty = $changed;
      var tmp;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(index) ? 32 : 16);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1225961660, $dirty, -1, 'client.fstech.hadaya.presentation.common.ProductMediaGallerySection.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ProductMediaGallerySection.kt:84)');
        }
        var mediaUrl = $combinedMedia.l1(index);
        var isVideo = isVideoUrl(mediaUrl);
        var tmp_1 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(80);
        var tmp_2 = size(tmp_1, tmp$ret$0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(12);
        var tmp_3 = background(clip(tmp_2, RoundedCornerShape(tmp$ret$1)), MaterialTheme_instance.unz($composer_0, 6).oo0_1);
        sourceInformationMarkerStart($composer_0, 1328128507, 'CC(remember):ProductMediaGallerySection.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = ($dirty & 112) === 32;
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_4;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProductMediaGallerySection$lambda$lambda$lambda(index, $initialIndex$delegate, $showMediaDialog$delegate);
          $composer_0.j31(value);
          tmp_4 = value;
        } else {
          tmp_4 = it;
        }
        var tmp0_group = tmp_4;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = clickable(tmp_3, VOID, VOID, VOID, VOID, tmp0_group);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_5 = $composer_3.g30();
        if (!isInterface(tmp_5, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 58015440, 'C96@3987L350:ProductMediaGallerySection.kt#c1nezb');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = fillMaxSize(Companion_instance);
        var contentAlignment_0 = null;
        var propagateMinConstraints_0 = false;
        var $composer_6 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_6 = $composer_8.g30();
        if (!isInterface(tmp_6, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 1544265812, 'C97@4052L263:ProductMediaGallerySection.kt#c1nezb');
        HadayaImage(mediaUrl, null, fillMaxSize(Companion_instance), Companion_getInstance_13().q96_1, $composer_10, 3504, 0);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        if (isVideo) {
          $composer_5.m30(58384463);
          sourceInformation($composer_5, '105@4397L609');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_3 = background(BoxScopeInstance_instance.vdr(Companion_instance), Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.2));
          var contentAlignment_1 = Companion_getInstance_11().o8t_1;
          var propagateMinConstraints_1 = false;
          var $composer_11 = $composer_5;
          if (!((4 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((4 & 2) === 0))
            contentAlignment_1 = Companion_getInstance_11().k8t_1;
          if (!((4 & 4) === 0))
            propagateMinConstraints_1 = false;
          var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_7 = $composer_13.g30();
          if (!isInterface(tmp_7, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_1);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_15, 831458918, 'C111@4698L282:ProductMediaGallerySection.kt#c1nezb');
          var tmp0_imageVector = get_PlayCircle(Icons_getInstance().dxv_1);
          var tmp1_tint = Companion_getInstance_14().m6b_1;
          var tmp_8 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$24 = _Dp___init__impl__ms3zkb(32);
          var tmp2_modifier = size(tmp_8, tmp$ret$24);
          Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_15, 3504, 0);
          sourceInformationMarkerEnd($composer_15);
          $composer_13.e31();
          $composer_5.n30();
        } else {
          $composer_5.m30(59015840);
          $composer_5.n30();
        }
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_9;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_9 = Unit_instance;
        }
        tmp_0 = tmp_9;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductMediaGallerySection$lambda_6($combinedMedia, $initialIndex$delegate, $showMediaDialog$delegate) {
    return function ($this$LazyRow) {
      var tmp = $combinedMedia.n1();
      $this$LazyRow.ei9(tmp, VOID, VOID, ComposableLambda$invoke$ref_4(composableLambdaInstance(1225961660, true, ProductMediaGallerySection$lambda$lambda($combinedMedia, $initialIndex$delegate, $showMediaDialog$delegate))));
      return Unit_instance;
    };
  }
  function ProductMediaGallerySection$lambda_7($product, $language, $onDialogVisibilityChanged, $$changed, $$default) {
    return function ($composer, $force) {
      ProductMediaGallerySection($product, $language, $onDialogVisibilityChanged._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ZoomableMediaView(model, contentDescription, modifier, contentScale, onZoomChanged, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var contentScale_0 = {_v: contentScale};
    var onZoomChanged_0 = {_v: onZoomChanged};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1298690814);
    sourceInformation($composer_0, 'C(ZoomableMediaView)P(2!1,3)45@1995L2:ZoomableImage.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(model) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(contentDescription) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(contentScale_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onZoomChanged_0._v) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (!(($default & 8) === 0)) {
        contentScale_0._v = Companion_getInstance_13().r96_1;
      }
      if (!(($default & 16) === 0)) {
        sourceInformationMarkerStart($composer_0, -1793604480, 'CC(remember):ZoomableImage.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ZoomableMediaView$lambda;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var tmp0_group = tmp;
        sourceInformationMarkerEnd($composer_0);
        onZoomChanged_0._v = tmp0_group;
      }
      if (isTraceInProgress()) {
        traceEventStart(1298690814, $dirty, -1, 'client.fstech.hadaya.presentation.common.ZoomableMediaView (ZoomableImage.kt:46)');
      }
      if (isVideoUrl(model)) {
        $composer_0.m30(232924723);
        sourceInformation($composer_0, '48@2040L1729');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = modifier_0._v;
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_2);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -1314739148, 'C49@2079L105,55@2364L1395:ZoomableImage.kt#c1nezb');
        VideoPlayer(model, fillMaxSize(Companion_instance), $composer_5, 48 | 14 & $dirty, 0);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_3 = fillMaxSize(Companion_instance);
        var horizontalArrangement = null;
        var verticalAlignment = null;
        var $composer_6 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((6 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((6 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_6, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_4);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_1 = $composer_8.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 894040756, 'C60@2587L526,56@2421L710,71@3148L38,76@3369L358,72@3203L542:ZoomableImage.kt#c1nezb');
        var tmp_2 = RowScopeInstance_instance.bdy(fillMaxHeight(Companion_instance), 1.0);
        sourceInformationMarkerStart($composer_10, -1356628783, 'CC(remember):ZoomableImage.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_0 = $composer_10.i31();
        var tmp_3;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var tmp_4 = ZoomableMediaView$slambda_0(null);
          var value_0 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1(tmp_4);
          $composer_10.j31(value_0);
          tmp_3 = value_0;
        } else {
          tmp_3 = it_0;
        }
        var tmp0_group_0 = tmp_3;
        sourceInformationMarkerEnd($composer_10);
        Box(pointerInput(tmp_2, Unit_instance, tmp0_group_0), $composer_10, 0);
        Spacer(RowScopeInstance_instance.bdy(Companion_instance, 4.0), $composer_10, 0);
        var tmp_5 = RowScopeInstance_instance.bdy(fillMaxHeight(Companion_instance), 1.0);
        sourceInformationMarkerStart($composer_10, -1356603927, 'CC(remember):ZoomableImage.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_1 = $composer_10.i31();
        var tmp_6;
        if (false || it_1 === Companion_getInstance().f30_1) {
          var tmp_7 = ZoomableMediaView$slambda_2(null);
          var value_1 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1(tmp_7);
          $composer_10.j31(value_1);
          tmp_6 = value_1;
        } else {
          tmp_6 = it_1;
        }
        var tmp1_group = tmp_6;
        sourceInformationMarkerEnd($composer_10);
        Box(pointerInput(tmp_5, Unit_instance, tmp1_group), $composer_10, 0);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        $composer_0.n30();
      } else {
        $composer_0.m30(234615091);
        sourceInformation($composer_0, '88@3791L225');
        ZoomableAsyncImage(model, contentDescription, modifier_0._v, contentScale_0._v, onZoomChanged_0._v, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty | 7168 & $dirty | 57344 & $dirty, 0);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(ZoomableMediaView$lambda_0(model, contentDescription, modifier_0, contentScale_0, onZoomChanged_0, $changed, $default));
    }
  }
  function isVideoUrl(url) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var lowerUrl = url.toLowerCase();
    return contains(lowerUrl, 'youtube.com') || contains(lowerUrl, 'youtu.be') || contains(lowerUrl, 'tiktok.com') || contains(lowerUrl, 'instagram.com/reel') || contains(lowerUrl, 'instagram.com/reels') || endsWith(lowerUrl, '.mp4') || endsWith(lowerUrl, '.mov');
  }
  function ZoomableAsyncImage(model, contentDescription, modifier, contentScale, onZoomChanged, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var contentScale_0 = {_v: contentScale};
    var onZoomChanged_0 = {_v: onZoomChanged};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-2061328373);
    sourceInformation($composer_0, 'C(ZoomableAsyncImage)P(2!1,3)116@4683L2,118@4707L27,119@4752L60,120@4838L41,121@4905L24,123@4963L47,123@4935L75,130@5104L22,131@5180L1032,156@6245L518,170@6796L2913,127@5016L5305:ZoomableImage.kt#c1nezb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(model) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(contentDescription) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(contentScale_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onZoomChanged_0._v) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (!(($default & 8) === 0)) {
        contentScale_0._v = Companion_getInstance_13().r96_1;
      }
      if (!(($default & 16) === 0)) {
        sourceInformationMarkerStart($composer_0, -956636627, 'CC(remember):ZoomableImage.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ZoomableAsyncImage$lambda;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var tmp0_group = tmp;
        sourceInformationMarkerEnd($composer_0);
        onZoomChanged_0._v = tmp0_group;
      }
      if (isTraceInProgress()) {
        traceEventStart(-2061328373, $dirty, -1, 'client.fstech.hadaya.presentation.common.ZoomableAsyncImage (ZoomableImage.kt:117)');
      }
      sourceInformationMarkerStart($composer_0, -956635834, 'CC(remember):ZoomableImage.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = Animatable(1.0);
        this_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      var scale = tmp1_group;
      sourceInformationMarkerStart($composer_0, -956634361, 'CC(remember):ZoomableImage.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_2.i31();
      var tmp_1;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = new Animatable_0(new Offset(Companion_getInstance_24().g5d_1), get_VectorConverter(Companion_getInstance_24()));
        this_2.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp2_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var offset = tmp2_group;
      sourceInformationMarkerStart($composer_0, -956631628, 'CC(remember):ZoomableImage.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_2 = this_3.i31();
      var tmp_2;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var value_2 = mutableStateOf(new IntSize(Companion_getInstance_25().n5g_1));
        this_3.j31(value_2);
        tmp_2 = value_2;
      } else {
        tmp_2 = it_2;
      }
      var tmp3_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      var containerSize$delegate = tmp3_group;
      // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
      var getContext = null;
      var $composer_1 = $composer_0;
      if (!((1 & 1) === 0)) {
        getContext = ZoomableAsyncImage$lambda_2;
      }
      var composer = $composer_1;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_3 = $composer_1.i31();
      var tmp_3;
      if (false || it_3 === Companion_getInstance().f30_1) {
        var value_3 = createCompositionCoroutineScope(getContext(), composer);
        $composer_1.j31(value_3);
        tmp_3 = value_3;
      } else {
        tmp_3 = it_3;
      }
      var coroutineScope = tmp_3;
      var tmp_4 = scale.u1();
      sourceInformationMarkerStart($composer_0, -956627622, 'CC(remember):ZoomableImage.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(($dirty & 57344) === 16384 | $composer_0.q31(scale));
      // Inline function 'kotlin.let' call
      var it_4 = tmp0.i31();
      var tmp_5;
      if (invalid || it_4 === Companion_getInstance().f30_1) {
        var value_4 = ZoomableAsyncImage$slambda_0(onZoomChanged_0, scale, null);
        tmp0.j31(value_4);
        tmp_5 = value_4;
      } else {
        tmp_5 = it_4;
      }
      var tmp4_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_4, tmp4_group, $composer_0, 0);
      var tmp_6 = clipToBounds(modifier_0._v);
      sourceInformationMarkerStart($composer_0, -956623135, 'CC(remember):ZoomableImage.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_4 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_5 = this_4.i31();
      var tmp_7;
      if (false || it_5 === Companion_getInstance().f30_1) {
        var value_5 = ZoomableAsyncImage$lambda_3(containerSize$delegate);
        this_4.j31(value_5);
        tmp_7 = value_5;
      } else {
        tmp_7 = it_5;
      }
      var tmp5_group = tmp_7;
      sourceInformationMarkerEnd($composer_0);
      var tmp_8 = onSizeChanged(tmp_6, tmp5_group);
      var tmp_9 = Companion_getInstance_26().qa1_1;
      sourceInformationMarkerStart($composer_0, -956619693, 'CC(remember):ZoomableImage.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(!!($composer_0.q31(scale) | $composer_0.q31(offset)) | $composer_0.q31(coroutineScope));
      // Inline function 'kotlin.let' call
      var it_6 = tmp0_0.i31();
      var tmp_10;
      if (invalid_0 || it_6 === Companion_getInstance().f30_1) {
        var value_6 = ZoomableAsyncImage$lambda_4(scale, offset, coroutineScope, containerSize$delegate);
        tmp0_0.j31(value_6);
        tmp_10 = value_6;
      } else {
        tmp_10 = it_6;
      }
      var tmp6_group = tmp_10;
      sourceInformationMarkerEnd($composer_0);
      var tmp_11 = onPointerEvent(tmp_8, tmp_9, VOID, tmp6_group);
      sourceInformationMarkerStart($composer_0, -956586127, 'CC(remember):ZoomableImage.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(!!($composer_0.q31(coroutineScope) | $composer_0.q31(scale)) | $composer_0.q31(offset));
      // Inline function 'kotlin.let' call
      var it_7 = tmp0_1.i31();
      var tmp_12;
      if (invalid_1 || it_7 === Companion_getInstance().f30_1) {
        var tmp_13 = ZoomableAsyncImage$slambda_2(coroutineScope, scale, offset, null);
        var value_7 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2(tmp_13);
        tmp0_1.j31(value_7);
        tmp_12 = value_7;
      } else {
        tmp_12 = it_7;
      }
      var tmp7_group = tmp_12;
      sourceInformationMarkerEnd($composer_0);
      var tmp_14 = pointerInput(tmp_11, Unit_instance, tmp7_group);
      sourceInformationMarkerStart($composer_0, -956566100, 'CC(remember):ZoomableImage.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = !!(!!($composer_0.q31(scale) | $composer_0.q31(offset)) | $composer_0.q31(coroutineScope));
      // Inline function 'kotlin.let' call
      var it_8 = tmp0_2.i31();
      var tmp_15;
      if (invalid_2 || it_8 === Companion_getInstance().f30_1) {
        var tmp_16 = ZoomableAsyncImage$slambda_4(scale, offset, coroutineScope, containerSize$delegate, null);
        var value_8 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2(tmp_16);
        tmp0_2.j31(value_8);
        tmp_15 = value_8;
      } else {
        tmp_15 = it_8;
      }
      var tmp8_group = tmp_15;
      sourceInformationMarkerEnd($composer_0);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_1 = pointerInput(tmp_14, Unit_instance, tmp8_group);
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_2 = $composer_0;
      if (!((4 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((4 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((4 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_3 = $composer_2;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_2);
      var tmp0_3 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_17 = $composer_4.g30();
      if (!isInterface(tmp_17, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_3);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_5 = $composer_4;
      var $composer_6 = $composer_5;
      sourceInformationMarkerStart($composer_6, -1951086094, 'C233@9870L201,230@9771L544:ZoomableImage.kt#c1nezb');
      var tmp_18 = fillMaxSize(Companion_instance);
      sourceInformationMarkerStart($composer_6, -2002598086, 'CC(remember):ZoomableImage.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = !!($composer_6.q31(scale) | $composer_6.q31(offset));
      // Inline function 'kotlin.let' call
      var it_9 = $composer_6.i31();
      var tmp_19;
      if (invalid_3 || it_9 === Companion_getInstance().f30_1) {
        var value_9 = ZoomableAsyncImage$lambda_5(scale, offset);
        $composer_6.j31(value_9);
        tmp_19 = value_9;
      } else {
        tmp_19 = it_9;
      }
      var tmp0_group_0 = tmp_19;
      sourceInformationMarkerEnd($composer_6);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_3 = graphicsLayer(tmp_18, tmp0_group_0);
      var contentAlignment_0 = null;
      var propagateMinConstraints_0 = false;
      var $composer_7 = $composer_6;
      if (!((6 & 1) === 0))
        modifier_3 = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment_0 = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints_0 = false;
      var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_4 = modifier_3;
      var $composer_8 = $composer_7;
      if (!((0 & 2) === 0))
        modifier_4 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
      var localMap_0 = $composer_8.t31();
      var materialized_0 = materialize($composer_8, modifier_4);
      var tmp0_4 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_9 = $composer_8;
      var tmp_20 = $composer_9.g30();
      if (!isInterface(tmp_20, Applier)) {
        invalidApplier();
      }
      $composer_9.b31();
      if ($composer_9.h30()) {
        $composer_9.c31(tmp0_4);
      } else {
        $composer_9.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_10 = $composer_9;
      var $composer_11 = $composer_10;
      sourceInformationMarkerStart($composer_11, -1336042341, 'C240@10096L209:ZoomableImage.kt#c1nezb');
      HadayaImage(model, contentDescription, fillMaxSize(Companion_instance), contentScale_0._v, $composer_11, 384 | 14 & $dirty | 112 & $dirty | 7168 & $dirty, 0);
      sourceInformationMarkerEnd($composer_11);
      $composer_9.e31();
      sourceInformationMarkerEnd($composer_6);
      $composer_4.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp9_safe_receiver = $composer_0.t30();
    if (tmp9_safe_receiver == null)
      null;
    else {
      tmp9_safe_receiver.p3c(ZoomableAsyncImage$lambda_6(model, contentDescription, modifier_0, contentScale_0, onZoomChanged_0, $changed, $default));
    }
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1(function_0) {
    this.v11s_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1).ka7 = function (_this__u8e3s4, $completion) {
    return this.v11s_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1).q3 = function () {
    return this.v11s_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2(function_0) {
    this.w11s_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2).ka7 = function (_this__u8e3s4, $completion) {
    return this.w11s_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2).q3 = function () {
    return this.w11s_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_2).hashCode = function () {
    return hashCode(this.q3());
  };
  function ZoomableMediaView$lambda(it) {
    return Unit_instance;
  }
  function ZoomableMediaView$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableMediaView$slambda$slambda).ic6 = function ($this$awaitEachGesture, $completion) {
    var tmp = this.jc6($this$awaitEachGesture, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableMediaView$slambda$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableMediaView$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            suspendResult = awaitFirstDown(this.f11t_1, false, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.f11t_1.qa7(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var event = suspendResult;
            var tmp0 = event.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var tmp_0;
              if (isInterface(tmp0, Collection)) {
                tmp_0 = tmp0.r();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$0 = false;
                break l$ret$1;
              }
              var _iterator__ex2g4s = tmp0.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (element.la0_1) {
                  tmp$ret$0 = true;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = false;
            }
             while (false);
            if (tmp$ret$0) {
              this.n9_1 = 2;
              continue $sm;
            }

            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ZoomableMediaView$slambda$slambda).jc6 = function ($this$awaitEachGesture, completion) {
    var i = new ZoomableMediaView$slambda$slambda(completion);
    i.f11t_1 = $this$awaitEachGesture;
    return i;
  };
  function ZoomableMediaView$slambda$slambda_0(resultContinuation) {
    var i = new ZoomableMediaView$slambda$slambda(resultContinuation);
    return constructCallableReference(function ($this$awaitEachGesture, $completion) {
      return i.ic6($this$awaitEachGesture, $completion);
    }, 1);
  }
  function ZoomableMediaView$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableMediaView$slambda).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableMediaView$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableMediaView$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = awaitEachGesture(this.o11t_1, ZoomableMediaView$slambda$slambda_0(null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ZoomableMediaView$slambda).wc6 = function ($this$pointerInput, completion) {
    var i = new ZoomableMediaView$slambda(completion);
    i.o11t_1 = $this$pointerInput;
    return i;
  };
  function ZoomableMediaView$slambda_0(resultContinuation) {
    var i = new ZoomableMediaView$slambda(resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function ZoomableMediaView$slambda$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableMediaView$slambda$slambda_1).ic6 = function ($this$awaitEachGesture, $completion) {
    var tmp = this.jc6($this$awaitEachGesture, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableMediaView$slambda$slambda_1).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableMediaView$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            suspendResult = awaitFirstDown(this.x11t_1, false, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.x11t_1.qa7(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var event = suspendResult;
            var tmp0 = event.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var tmp_0;
              if (isInterface(tmp0, Collection)) {
                tmp_0 = tmp0.r();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$0 = false;
                break l$ret$1;
              }
              var _iterator__ex2g4s = tmp0.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (element.la0_1) {
                  tmp$ret$0 = true;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = false;
            }
             while (false);
            if (tmp$ret$0) {
              this.n9_1 = 2;
              continue $sm;
            }

            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ZoomableMediaView$slambda$slambda_1).jc6 = function ($this$awaitEachGesture, completion) {
    var i = new ZoomableMediaView$slambda$slambda_1(completion);
    i.x11t_1 = $this$awaitEachGesture;
    return i;
  };
  function ZoomableMediaView$slambda$slambda_2(resultContinuation) {
    var i = new ZoomableMediaView$slambda$slambda_1(resultContinuation);
    return constructCallableReference(function ($this$awaitEachGesture, $completion) {
      return i.ic6($this$awaitEachGesture, $completion);
    }, 1);
  }
  function ZoomableMediaView$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableMediaView$slambda_1).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableMediaView$slambda_1).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableMediaView$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = awaitEachGesture(this.g11u_1, ZoomableMediaView$slambda$slambda_2(null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ZoomableMediaView$slambda_1).wc6 = function ($this$pointerInput, completion) {
    var i = new ZoomableMediaView$slambda_1(completion);
    i.g11u_1 = $this$pointerInput;
    return i;
  };
  function ZoomableMediaView$slambda_2(resultContinuation) {
    var i = new ZoomableMediaView$slambda_1(resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function ZoomableMediaView$lambda_0($model, $contentDescription, $modifier, $contentScale, $onZoomChanged, $$changed, $$default) {
    return function ($composer, $force) {
      ZoomableMediaView($model, $contentDescription, $modifier._v, $contentScale._v, $onZoomChanged._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ZoomableAsyncImage$lambda(it) {
    return Unit_instance;
  }
  function ZoomableAsyncImage$lambda_0($containerSize$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('containerSize', KMutableProperty0, true);
    return $containerSize$delegate.u1().o5g_1;
  }
  function ZoomableAsyncImage$lambda_1($containerSize$delegate, _set____db54di) {
    getLocalDelegateReference('containerSize', KMutableProperty0, true);
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new IntSize(_set____db54di);
    $containerSize$delegate.s21(value);
    return Unit_instance;
  }
  function ZoomableAsyncImage$lambda_2() {
    return EmptyCoroutineContext_getInstance();
  }
  function ZoomableAsyncImage$slambda($onZoomChanged, $scale, resultContinuation) {
    this.p11u_1 = $onZoomChanged;
    this.q11u_1 = $scale;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableAsyncImage$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableAsyncImage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableAsyncImage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.p11u_1._v(this.q11u_1.u1() > 1.0);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ZoomableAsyncImage$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new ZoomableAsyncImage$slambda(this.p11u_1, this.q11u_1, completion);
    i.r11u_1 = $this$LaunchedEffect;
    return i;
  };
  function ZoomableAsyncImage$slambda_0($onZoomChanged, $scale, resultContinuation) {
    var i = new ZoomableAsyncImage$slambda($onZoomChanged, $scale, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function ZoomableAsyncImage$lambda_3($containerSize$delegate) {
    return function (it) {
      ZoomableAsyncImage$lambda_1($containerSize$delegate, it.o5g_1);
      return Unit_instance;
    };
  }
  function ZoomableAsyncImage$lambda$slambda($scale, $newScale, $offset, $newOffset, $maxX, $maxY, resultContinuation) {
    this.a11v_1 = $scale;
    this.b11v_1 = $newScale;
    this.c11v_1 = $offset;
    this.d11v_1 = $newOffset;
    this.e11v_1 = $maxX;
    this.f11v_1 = $maxY;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableAsyncImage$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableAsyncImage$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableAsyncImage$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.a11v_1.hec(this.b11v_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            var this_0 = this.d11v_1;
            var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
            var bits = convertToInt(shiftRight(value, 32));
            var tmp0 = coerceIn(floatFromBits(bits), -this.e11v_1, this.e11v_1);
            var this_1 = this.d11v_1;
            var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
            var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
            var val2 = coerceIn(floatFromBits(bits_0), -this.f11v_1, this.f11v_1);
            var v1 = fromInt(toRawBits(tmp0));
            var v2 = fromInt(toRawBits(val2));
            suspendResult = this.c11v_1.hec(new Offset(_Offset___init__impl__c168vi(bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0))))), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ZoomableAsyncImage$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new ZoomableAsyncImage$lambda$slambda(this.a11v_1, this.b11v_1, this.c11v_1, this.d11v_1, this.e11v_1, this.f11v_1, completion);
    i.g11v_1 = $this$launch;
    return i;
  };
  function ZoomableAsyncImage$lambda$slambda_0($scale, $newScale, $offset, $newOffset, $maxX, $maxY, resultContinuation) {
    var i = new ZoomableAsyncImage$lambda$slambda($scale, $newScale, $offset, $newOffset, $maxX, $maxY, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ZoomableAsyncImage$lambda_4($scale, $offset, $coroutineScope, $containerSize$delegate) {
    return function ($this$onPointerEvent, event) {
      var scrollDelta = first(event.ca0_1).ra0_1;
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value = _Offset___get_packedValue__impl__xh2k8q(scrollDelta);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
      // Inline function 'kotlin.math.exp' call
      var x = -floatFromBits(bits) * 0.1;
      var zoomFactor = Math.exp(x);
      var oldScale = $scale.u1();
      var newScale = coerceIn(oldScale * zoomFactor, 1.0, 5.0);
      var tmp;
      if (!(newScale === oldScale)) {
        // Inline function 'androidx.compose.ui.unit.IntSize.width' call
        var this_0 = ZoomableAsyncImage$lambda_0($containerSize$delegate);
        // Inline function 'androidx.compose.ui.util.unpackInt1' call
        var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_0);
        var maxX = convertToInt(shiftRight(value_0, 32)) * (newScale - 1) / 2.0;
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        var this_1 = ZoomableAsyncImage$lambda_0($containerSize$delegate);
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value_1 = _IntSize___get_packedValue__impl__uho7jf(this_1);
        var maxY = convertToInt(bitwiseAnd(value_1, new Long(-1, 0))) * (newScale - 1) / 2.0;
        var actualZoomFactor = newScale / oldScale;
        var newOffset = Offset__times_impl_jz1mli($offset.u1().e5d_1, actualZoomFactor);
        launch($coroutineScope, VOID, VOID, ZoomableAsyncImage$lambda$slambda_0($scale, newScale, $offset, newOffset, maxX, maxY, null));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ZoomableAsyncImage$slambda$lambda$slambda$slambda($scale, resultContinuation) {
    this.p11v_1 = $scale;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.p11v_1.gec(1.0, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new ZoomableAsyncImage$slambda$lambda$slambda$slambda(this.p11v_1, completion);
    i.q11v_1 = $this$launch;
    return i;
  };
  function ZoomableAsyncImage$slambda$lambda$slambda$slambda_0($scale, resultContinuation) {
    var i = new ZoomableAsyncImage$slambda$lambda$slambda$slambda($scale, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ZoomableAsyncImage$slambda$lambda$slambda$slambda_1($offset, resultContinuation) {
    this.z11v_1 = $offset;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.z11v_1.gec(new Offset(Companion_getInstance_24().g5d_1), VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda$slambda_1).q24 = function ($this$launch, completion) {
    var i = new ZoomableAsyncImage$slambda$lambda$slambda$slambda_1(this.z11v_1, completion);
    i.a11w_1 = $this$launch;
    return i;
  };
  function ZoomableAsyncImage$slambda$lambda$slambda$slambda_2($offset, resultContinuation) {
    var i = new ZoomableAsyncImage$slambda$lambda$slambda$slambda_1($offset, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ZoomableAsyncImage$slambda$lambda$slambda$slambda_3($scale, resultContinuation) {
    this.j11w_1 = $scale;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda$slambda_3).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.j11w_1.gec(3.0, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda$slambda_3).q24 = function ($this$launch, completion) {
    var i = new ZoomableAsyncImage$slambda$lambda$slambda$slambda_3(this.j11w_1, completion);
    i.k11w_1 = $this$launch;
    return i;
  };
  function ZoomableAsyncImage$slambda$lambda$slambda$slambda_4($scale, resultContinuation) {
    var i = new ZoomableAsyncImage$slambda$lambda$slambda$slambda_3($scale, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ZoomableAsyncImage$slambda$lambda$slambda($scale, $offset, resultContinuation) {
    this.t11w_1 = $scale;
    this.u11w_1 = $offset;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          if (this.t11w_1.u1() > 1.0) {
            launch(this.v11w_1, VOID, VOID, ZoomableAsyncImage$slambda$lambda$slambda$slambda_0(this.t11w_1, null));
            launch(this.v11w_1, VOID, VOID, ZoomableAsyncImage$slambda$lambda$slambda$slambda_2(this.u11w_1, null));
          } else {
            launch(this.v11w_1, VOID, VOID, ZoomableAsyncImage$slambda$lambda$slambda$slambda_4(this.t11w_1, null));
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ZoomableAsyncImage$slambda$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new ZoomableAsyncImage$slambda$lambda$slambda(this.t11w_1, this.u11w_1, completion);
    i.v11w_1 = $this$launch;
    return i;
  };
  function ZoomableAsyncImage$slambda$lambda$slambda_0($scale, $offset, resultContinuation) {
    var i = new ZoomableAsyncImage$slambda$lambda$slambda($scale, $offset, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ZoomableAsyncImage$slambda$lambda($coroutineScope, $scale, $offset) {
    return function (it) {
      launch($coroutineScope, VOID, VOID, ZoomableAsyncImage$slambda$lambda$slambda_0($scale, $offset, null));
      return Unit_instance;
    };
  }
  function ZoomableAsyncImage$slambda_1($coroutineScope, $scale, $offset, resultContinuation) {
    this.e11x_1 = $coroutineScope;
    this.f11x_1 = $scale;
    this.g11x_1 = $offset;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableAsyncImage$slambda_1).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableAsyncImage$slambda_1).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableAsyncImage$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = detectTapGestures(this.h11x_1, ZoomableAsyncImage$slambda$lambda(this.e11x_1, this.f11x_1, this.g11x_1), VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ZoomableAsyncImage$slambda_1).wc6 = function ($this$pointerInput, completion) {
    var i = new ZoomableAsyncImage$slambda_1(this.e11x_1, this.f11x_1, this.g11x_1, completion);
    i.h11x_1 = $this$pointerInput;
    return i;
  };
  function ZoomableAsyncImage$slambda_2($coroutineScope, $scale, $offset, resultContinuation) {
    var i = new ZoomableAsyncImage$slambda_1($coroutineScope, $scale, $offset, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function ZoomableAsyncImage$slambda$slambda$slambda($scale, $newScale, $offset, $newOffset, $maxX, $maxY, resultContinuation) {
    this.q11x_1 = $scale;
    this.r11x_1 = $newScale;
    this.s11x_1 = $offset;
    this.t11x_1 = $newOffset;
    this.u11x_1 = $maxX;
    this.v11x_1 = $maxY;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableAsyncImage$slambda$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableAsyncImage$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableAsyncImage$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.q11x_1.hec(this.r11x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            var this_0 = this.t11x_1;
            var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
            var bits = convertToInt(shiftRight(value, 32));
            var tmp0 = coerceIn(floatFromBits(bits), -this.u11x_1, this.u11x_1);
            var this_1 = this.t11x_1;
            var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
            var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
            var val2 = coerceIn(floatFromBits(bits_0), -this.v11x_1, this.v11x_1);
            var v1 = fromInt(toRawBits(tmp0));
            var v2 = fromInt(toRawBits(val2));
            suspendResult = this.s11x_1.hec(new Offset(_Offset___init__impl__c168vi(bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0))))), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ZoomableAsyncImage$slambda$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new ZoomableAsyncImage$slambda$slambda$slambda(this.q11x_1, this.r11x_1, this.s11x_1, this.t11x_1, this.u11x_1, this.v11x_1, completion);
    i.w11x_1 = $this$launch;
    return i;
  };
  function ZoomableAsyncImage$slambda$slambda$slambda_0($scale, $newScale, $offset, $newOffset, $maxX, $maxY, resultContinuation) {
    var i = new ZoomableAsyncImage$slambda$slambda$slambda($scale, $newScale, $offset, $newOffset, $maxX, $maxY, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ZoomableAsyncImage$slambda$slambda($scale, $offset, $coroutineScope, $containerSize$delegate, resultContinuation) {
    this.f11y_1 = $scale;
    this.g11y_1 = $offset;
    this.h11y_1 = $coroutineScope;
    this.i11y_1 = $containerSize$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableAsyncImage$slambda$slambda).ic6 = function ($this$awaitEachGesture, $completion) {
    var tmp = this.jc6($this$awaitEachGesture, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableAsyncImage$slambda$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableAsyncImage$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.m11y_1 = 1.0;
            this.n11y_1 = Companion_getInstance_24().g5d_1;
            this.k11y_1 = false;
            this.l11y_1 = this.j11y_1.la7().ub9();
            this.n9_1 = 1;
            suspendResult = awaitFirstDown(this.j11y_1, false, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.j11y_1.qa7(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var event = suspendResult;
            var tmp0 = event.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var tmp_0;
              if (isInterface(tmp0, Collection)) {
                tmp_0 = tmp0.r();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$0 = false;
                break l$ret$1;
              }
              var _iterator__ex2g4s = tmp0.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (element.qa2()) {
                  tmp$ret$0 = true;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = false;
            }
             while (false);
            var canceled = tmp$ret$0;
            if (!canceled) {
              var zoomChange = calculateZoom(event);
              var panChange = calculatePan(event);
              if (!this.k11y_1) {
                this.m11y_1 = this.m11y_1 * zoomChange;
                this.n11y_1 = Offset__plus_impl_c78cg0(this.n11y_1, panChange);
                var centroid = calculateCentroid(event, false);
                var panMotion = Offset__getDistance_impl_pclvxn(this.n11y_1);
                var x = 1 - this.m11y_1;
                var zoomMotion = Math.abs(x) * Offset__getDistance_impl_pclvxn(centroid);
                if (panMotion > this.l11y_1 || zoomMotion > this.l11y_1) {
                  this.k11y_1 = true;
                }
              }
              if (this.k11y_1) {
                var oldScale = this.f11y_1.u1();
                var isPinching = event.ca0_1.n1() > 1;
                if (oldScale > 1.05 || isPinching) {
                  var newScale = coerceIn(oldScale * zoomChange, 1.0, 5.0);
                  var this_0 = ZoomableAsyncImage$lambda_0(this.i11y_1);
                  var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
                  var maxX = convertToInt(shiftRight(value, 32)) * (newScale - 1) / 2.0;
                  var this_1 = ZoomableAsyncImage$lambda_0(this.i11y_1);
                  var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
                  var maxY = convertToInt(bitwiseAnd(value_0, new Long(-1, 0))) * (newScale - 1) / 2.0;
                  var zoomFactor = newScale / oldScale;
                  var newOffset = Offset__plus_impl_c78cg0(Offset__times_impl_jz1mli(this.g11y_1.u1().e5d_1, zoomFactor), panChange);
                  launch(this.h11y_1, VOID, VOID, ZoomableAsyncImage$slambda$slambda$slambda_0(this.f11y_1, newScale, this.g11y_1, newOffset, maxX, maxY, null));
                  var _iterator__ex2g4s_0 = event.ca0_1.t();
                  while (_iterator__ex2g4s_0.u()) {
                    var element_0 = _iterator__ex2g4s_0.v();
                    if (positionChanged(element_0)) {
                      element_0.ra2();
                    }
                  }
                }
              }
            }

            var tmp0_0 = event.ca0_1;
            var tmp$ret$2;
            l$ret$3: do {
              var tmp_1;
              if (isInterface(tmp0_0, Collection)) {
                tmp_1 = tmp0_0.r();
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                tmp$ret$2 = false;
                break l$ret$3;
              }
              var _iterator__ex2g4s_1 = tmp0_0.t();
              while (_iterator__ex2g4s_1.u()) {
                var element_1 = _iterator__ex2g4s_1.v();
                if (element_1.la0_1) {
                  tmp$ret$2 = true;
                  break l$ret$3;
                }
              }
              tmp$ret$2 = false;
            }
             while (false);
            if (tmp$ret$2) {
              this.n9_1 = 2;
              continue $sm;
            }

            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ZoomableAsyncImage$slambda$slambda).jc6 = function ($this$awaitEachGesture, completion) {
    var i = new ZoomableAsyncImage$slambda$slambda(this.f11y_1, this.g11y_1, this.h11y_1, this.i11y_1, completion);
    i.j11y_1 = $this$awaitEachGesture;
    return i;
  };
  function ZoomableAsyncImage$slambda$slambda_0($scale, $offset, $coroutineScope, $containerSize$delegate, resultContinuation) {
    var i = new ZoomableAsyncImage$slambda$slambda($scale, $offset, $coroutineScope, $containerSize$delegate, resultContinuation);
    return constructCallableReference(function ($this$awaitEachGesture, $completion) {
      return i.ic6($this$awaitEachGesture, $completion);
    }, 1);
  }
  function ZoomableAsyncImage$slambda_3($scale, $offset, $coroutineScope, $containerSize$delegate, resultContinuation) {
    this.w11y_1 = $scale;
    this.x11y_1 = $offset;
    this.y11y_1 = $coroutineScope;
    this.z11y_1 = $containerSize$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ZoomableAsyncImage$slambda_3).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ZoomableAsyncImage$slambda_3).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ZoomableAsyncImage$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = awaitEachGesture(this.a11z_1, ZoomableAsyncImage$slambda$slambda_0(this.w11y_1, this.x11y_1, this.y11y_1, this.z11y_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ZoomableAsyncImage$slambda_3).wc6 = function ($this$pointerInput, completion) {
    var i = new ZoomableAsyncImage$slambda_3(this.w11y_1, this.x11y_1, this.y11y_1, this.z11y_1, completion);
    i.a11z_1 = $this$pointerInput;
    return i;
  };
  function ZoomableAsyncImage$slambda_4($scale, $offset, $coroutineScope, $containerSize$delegate, resultContinuation) {
    var i = new ZoomableAsyncImage$slambda_3($scale, $offset, $coroutineScope, $containerSize$delegate, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function ZoomableAsyncImage$lambda_5($scale, $offset) {
    return function ($this$graphicsLayer) {
      $this$graphicsLayer.w66($scale.u1());
      $this$graphicsLayer.x66($scale.u1());
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_0 = $offset.u1().e5d_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp$ret$0 = floatFromBits(bits);
      $this$graphicsLayer.y66(tmp$ret$0);
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_1 = $offset.u1().e5d_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var tmp$ret$4 = floatFromBits(bits_0);
      $this$graphicsLayer.z66(tmp$ret$4);
      return Unit_instance;
    };
  }
  function ZoomableAsyncImage$lambda_6($model, $contentDescription, $modifier, $contentScale, $onZoomChanged, $$changed, $$default) {
    return function ($composer, $force) {
      ZoomableAsyncImage($model, $contentDescription, $modifier._v, $contentScale._v, $onZoomChanged._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_coupons_CouponsState$stable;
  var client_fstech_hadaya_presentation_coupons_CouponsIntent_LoadCoupons$stable;
  var client_fstech_hadaya_presentation_coupons_CouponsIntent_ChangeFilter$stable;
  var client_fstech_hadaya_presentation_coupons_CouponsSideEffect_ShowMessage$stable;
  function CouponsState(isLoading, coupons, filterType, error) {
    isLoading = isLoading === VOID ? false : isLoading;
    coupons = coupons === VOID ? emptyList() : coupons;
    filterType = filterType === VOID ? CouponFilterType_ALL_getInstance() : filterType;
    error = error === VOID ? null : error;
    this.b11z_1 = isLoading;
    this.c11z_1 = coupons;
    this.d11z_1 = filterType;
    this.e11z_1 = error;
  }
  protoOf(CouponsState).f11z = function (isLoading, coupons, filterType, error) {
    return new CouponsState(isLoading, coupons, filterType, error);
  };
  protoOf(CouponsState).g11z = function (isLoading, coupons, filterType, error, $super) {
    isLoading = isLoading === VOID ? this.b11z_1 : isLoading;
    coupons = coupons === VOID ? this.c11z_1 : coupons;
    filterType = filterType === VOID ? this.d11z_1 : filterType;
    error = error === VOID ? this.e11z_1 : error;
    return $super === VOID ? this.f11z(isLoading, coupons, filterType, error) : $super.f11z.call(this, isLoading, coupons, filterType, error);
  };
  protoOf(CouponsState).toString = function () {
    return 'CouponsState(isLoading=' + this.b11z_1 + ', coupons=' + toString(this.c11z_1) + ', filterType=' + this.d11z_1.toString() + ', error=' + toString_0(this.e11z_1) + ')';
  };
  protoOf(CouponsState).hashCode = function () {
    var result = getBooleanHashCode(this.b11z_1);
    result = imul(result, 31) + hashCode(this.c11z_1) | 0;
    result = imul(result, 31) + this.d11z_1.hashCode() | 0;
    result = imul(result, 31) + (this.e11z_1 == null ? 0 : hashCode(this.e11z_1)) | 0;
    return result;
  };
  protoOf(CouponsState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CouponsState))
      return false;
    if (!(this.b11z_1 === other.b11z_1))
      return false;
    if (!equals(this.c11z_1, other.c11z_1))
      return false;
    if (!this.d11z_1.equals(other.d11z_1))
      return false;
    if (!equals(this.e11z_1, other.e11z_1))
      return false;
    return true;
  };
  function LoadCoupons() {
  }
  protoOf(LoadCoupons).toString = function () {
    return 'LoadCoupons';
  };
  protoOf(LoadCoupons).hashCode = function () {
    return -369822507;
  };
  protoOf(LoadCoupons).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadCoupons))
      return false;
    return true;
  };
  var LoadCoupons_instance;
  function LoadCoupons_getInstance() {
    return LoadCoupons_instance;
  }
  function ChangeFilter(filterType) {
    this.h11z_1 = filterType;
  }
  protoOf(ChangeFilter).toString = function () {
    return 'ChangeFilter(filterType=' + this.h11z_1.toString() + ')';
  };
  protoOf(ChangeFilter).hashCode = function () {
    return this.h11z_1.hashCode();
  };
  protoOf(ChangeFilter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ChangeFilter))
      return false;
    if (!this.h11z_1.equals(other.h11z_1))
      return false;
    return true;
  };
  function CouponsIntent() {
  }
  var CouponFilterType_ALL_instance;
  var CouponFilterType_AVAILABLE_instance;
  var CouponFilterType_USED_instance;
  function values_4() {
    return [CouponFilterType_ALL_getInstance(), CouponFilterType_AVAILABLE_getInstance(), CouponFilterType_USED_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values_4());
    return $ENTRIES;
  }
  var CouponFilterType_entriesInitialized;
  function CouponFilterType_initEntries() {
    if (CouponFilterType_entriesInitialized)
      return Unit_instance;
    CouponFilterType_entriesInitialized = true;
    CouponFilterType_ALL_instance = new CouponFilterType('ALL', 0);
    CouponFilterType_AVAILABLE_instance = new CouponFilterType('AVAILABLE', 1);
    CouponFilterType_USED_instance = new CouponFilterType('USED', 2);
  }
  var $ENTRIES;
  function CouponFilterType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CouponFilterType_ALL_getInstance() {
    CouponFilterType_initEntries();
    return CouponFilterType_ALL_instance;
  }
  function CouponFilterType_AVAILABLE_getInstance() {
    CouponFilterType_initEntries();
    return CouponFilterType_AVAILABLE_instance;
  }
  function CouponFilterType_USED_getInstance() {
    CouponFilterType_initEntries();
    return CouponFilterType_USED_instance;
  }
  function CouponsScreen(onBack, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-322857821);
    sourceInformation($composer_0, 'C(CouponsScreen)65@2922L15,66@2981L16,67@3026L32,68@3094L7,69@3118L24,71@3169L69,71@3148L90,75@3266L293,83@3565L4599:CouponsScreen.kt#ie1wbl');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-322857821, $dirty, -1, 'client.fstech.hadaya.presentation.coupons.CouponsScreen (CouponsScreen.kt:64)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(CouponsViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, -1028714621, 'CC(remember):CouponsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance().f30_1) {
        var value = new SnackbarHostState();
        this_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp0_group;
      var tmp0_0 = get_LocalClipboard();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_2 = $composer_0;
      var clipboard = $composer_2.u31(tmp0_0);
      // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
      var getContext = null;
      var $composer_3 = $composer_0;
      if (!((1 & 1) === 0)) {
        getContext = CouponsScreen$lambda_0;
      }
      var composer = $composer_3;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_0 = $composer_3.i31();
      var tmp_2;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = createCompositionCoroutineScope(getContext(), composer);
        $composer_3.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var scope_0 = tmp_2;
      sourceInformationMarkerStart($composer_0, -1028710008, 'CC(remember):CouponsScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_1.i31();
      var tmp_3;
      if (invalid || it_1 === Companion_getInstance().f30_1) {
        var value_1 = CouponsScreen$slambda_0(viewModel, null);
        tmp0_1.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp1_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(Unit_instance, tmp1_group, $composer_0, 6);
      var tmp2_remember$arg$0 = CouponsScreen$lambda(state$delegate).c11z_1;
      var tmp3_remember$arg$1 = CouponsScreen$lambda(state$delegate).d11z_1;
      sourceInformationMarkerStart($composer_0, -1028706680, 'CC(remember):CouponsScreen.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.k31(tmp2_remember$arg$0) | $composer_0.m31(tmp3_remember$arg$1.a1_1));
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_2.i31();
      var tmp_4;
      if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
        var tmp_5;
        switch (CouponsScreen$lambda(state$delegate).d11z_1.a1_1) {
          case 0:
            tmp_5 = CouponsScreen$lambda(state$delegate).c11z_1;
            break;
          case 1:
            // Inline function 'kotlin.collections.filter' call

            var tmp0_3 = CouponsScreen$lambda(state$delegate).c11z_1;
            // Inline function 'kotlin.collections.filterTo' call

            var destination = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s = tmp0_3.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              if (!element.hzz_1) {
                destination.j1(element);
              }
            }

            tmp_5 = destination;
            break;
          case 2:
            // Inline function 'kotlin.collections.filter' call

            var tmp0_4 = CouponsScreen$lambda(state$delegate).c11z_1;
            // Inline function 'kotlin.collections.filterTo' call

            var destination_0 = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s_0 = tmp0_4.t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              if (element_0.hzz_1) {
                destination_0.j1(element_0);
              }
            }

            tmp_5 = destination_0;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var value_2 = tmp_5;
        tmp0_2.j31(value_2);
        tmp_4 = value_2;
      } else {
        tmp_4 = it_2;
      }
      var tmp4_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      var filteredCoupons = tmp4_group;
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = fillMaxSize(Companion_instance);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_4 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_5 = $composer_4;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_5, 0).hashCode();
      var localMap = $composer_5.t31();
      var materialized = materialize($composer_5, modifier_0);
      var tmp0_5 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_6 = $composer_5;
      var tmp_6 = $composer_6.g30();
      if (!isInterface(tmp_6, Applier)) {
        invalidApplier();
      }
      $composer_6.b31();
      if ($composer_6.h30()) {
        $composer_6.c31(tmp0_5);
      } else {
        $composer_6.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_6);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_7 = $composer_6;
      var $composer_8 = $composer_7;
      sourceInformationMarkerStart($composer_8, 655789062, 'C84@3614L4406,184@8030L128:CouponsScreen.kt#ie1wbl');
      var tmp_7 = BoxScopeInstance_instance.udr(fillMaxSize(Companion_instance), Companion_getInstance_11().l8t_1);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$32 = _Dp___init__impl__ms3zkb(1000);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = widthIn(tmp_7, VOID, tmp$ret$32);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_9 = $composer_8;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_9, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_10 = $composer_9;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_10, 0).hashCode();
      var localMap_0 = $composer_10.t31();
      var materialized_0 = materialize($composer_10, modifier_2);
      var tmp0_6 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_11 = $composer_10;
      var tmp_8 = $composer_11.g30();
      if (!isInterface(tmp_8, Applier)) {
        invalidApplier();
      }
      $composer_11.b31();
      if ($composer_11.h30()) {
        $composer_11.c31(tmp0_6);
      } else {
        $composer_11.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_11);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_12 = $composer_11;
      var $composer_13 = $composer_12;
      sourceInformationMarkerStart($composer_13, -375357126, 'C92@3979L294,85@3720L624,105@4474L11,106@4543L11,107@4592L282,113@4889L978,103@4358L1509:CouponsScreen.kt#ie1wbl');
      var tmp_9 = ComposableSingletons$CouponsScreenKt_getInstance().i11z_1;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-233064851, true, CouponsScreen$lambda_1(onBack), $composer_13, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_14 = $composer_13;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_14.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_3 = $composer_14.i31();
      var tmp_10;
      if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_14.j31(value_3);
        tmp_10 = value_3;
      } else {
        tmp_10 = it_3;
      }
      var tmp_11 = tmp_10;
      var tmp_12 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_13 = WindowInsets(0, 0, 0, 0);
      TopAppBar(tmp_9, null, tmp_11, null, tmp_12, tmp_13, null, null, $composer_13, 390, 218);
      var tmp_14 = CouponsScreen$lambda(state$delegate).d11z_1.a1_1;
      var tmp_15 = MaterialTheme_instance.unz($composer_13, 6).ko0_1;
      var tmp_16 = MaterialTheme_instance.unz($composer_13, 6).xnz_1;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_0 = rememberComposableLambda(-321104241, true, CouponsScreen$lambda_2(state$delegate), $composer_13, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_15 = $composer_13;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = $composer_15.k31(dispatchReceiver_0);
      // Inline function 'kotlin.let' call
      var it_4 = $composer_15.i31();
      var tmp_17;
      if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = ComposableLambda$invoke$ref_10(dispatchReceiver_0);
        $composer_15.j31(value_4);
        tmp_17 = value_4;
      } else {
        tmp_17 = it_4;
      }
      var tmp_18 = tmp_17;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_1 = rememberComposableLambda(-277126001, true, CouponsScreen$lambda_3(viewModel, state$delegate), $composer_13, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_16 = $composer_13;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = $composer_16.k31(dispatchReceiver_1);
      // Inline function 'kotlin.let' call
      var it_5 = $composer_16.i31();
      var tmp_19;
      if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
        var value_5 = ComposableLambda$invoke$ref(dispatchReceiver_1);
        $composer_16.j31(value_5);
        tmp_19 = value_5;
      } else {
        tmp_19 = it_5;
      }
      var tmp$ret$53 = tmp_19;
      TabRow(tmp_14, null, tmp_15, tmp_16, tmp_18, null, tmp$ret$53, $composer_13, 1597440, 34);
      if (CouponsScreen$lambda(state$delegate).b11z_1) {
        $composer_13.m30(-373320489);
        sourceInformation($composer_13, '133@5920L132');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = fillMaxSize(Companion_instance);
        var contentAlignment_0 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_0 = false;
        var $composer_17 = $composer_13;
        if (!((4 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_18 = $composer_17;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_18, 0).hashCode();
        var localMap_1 = $composer_18.t31();
        var materialized_1 = materialize($composer_18, modifier_4);
        var tmp0_7 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_19 = $composer_18;
        var tmp_20 = $composer_19.g30();
        if (!isInterface(tmp_20, Applier)) {
          invalidApplier();
        }
        $composer_19.b31();
        if ($composer_19.h30()) {
          $composer_19.c31(tmp0_7);
        } else {
          $composer_19.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_19);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_20 = $composer_19;
        var $composer_21 = $composer_20;
        sourceInformationMarkerStart($composer_21, 866255458, 'C134@6007L27:CouponsScreen.kt#ie1wbl');
        var tmp_21 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_22 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_23 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_24 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_21, tmp_22, tmp_23, tmp_24, _Dp___init__impl__ms3zkb(0.0), $composer_21, 0, 63);
        sourceInformationMarkerEnd($composer_21);
        $composer_19.e31();
        $composer_13.n30();
      } else if (CouponsScreen$lambda(state$delegate).c11z_1.r()) {
        $composer_13.m30(-373122399);
        sourceInformation($composer_13, '137@6119L154');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_5 = fillMaxSize(Companion_instance);
        var contentAlignment_1 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_1 = false;
        var $composer_22 = $composer_13;
        if (!((4 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_1 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_1 = false;
        var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_23 = $composer_22;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_23, 0).hashCode();
        var localMap_2 = $composer_23.t31();
        var materialized_2 = materialize($composer_23, modifier_6);
        var tmp0_8 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_24 = $composer_23;
        var tmp_25 = $composer_24.g30();
        if (!isInterface(tmp_25, Applier)) {
          invalidApplier();
        }
        $composer_24.b31();
        if ($composer_24.h30()) {
          $composer_24.c31(tmp0_8);
        } else {
          $composer_24.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_24);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_25 = $composer_24;
        var $composer_26 = $composer_25;
        sourceInformationMarkerStart($composer_26, 1717575221, 'C138@6211L43,138@6206L49:CouponsScreen.kt#ie1wbl');
        var tmp_26 = stringResource(get_no_coupons_found(string_instance), $composer_26, 0);
        var tmp_27 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_28 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_29 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_30 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_31 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_26, null, tmp_27, null, tmp_28, null, null, null, tmp_29, null, null, tmp_30, tmp_31, false, 0, 0, null, null, $composer_26, 0, 0, 262142);
        sourceInformationMarkerEnd($composer_26);
        $composer_24.e31();
        $composer_13.n30();
      } else {
        $composer_13.m30(-372884474);
        sourceInformation($composer_13, '150@6693L1303,141@6311L1685');
        var tmp_32 = fillMaxSize(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp0_start = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_end = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_top = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_bottom = _Dp___init__impl__ms3zkb(16);
        var tmp_33 = PaddingValues(tmp0_start, tmp2_top, tmp1_end, tmp3_bottom);
        var tmp_34 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$76 = _Dp___init__impl__ms3zkb(16);
        var tmp_35 = tmp_34.mdq(tmp$ret$76);
        sourceInformationMarkerStart($composer_13, -566205474, 'CC(remember):CouponsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = !!(!!($composer_13.q31(filteredCoupons) | $composer_13.q31(scope_0)) | $composer_13.q31(clipboard));
        // Inline function 'kotlin.let' call
        var it_6 = $composer_13.i31();
        var tmp_36;
        if (invalid_4 || it_6 === Companion_getInstance().f30_1) {
          var value_6 = CouponsScreen$lambda_4(filteredCoupons, scope_0, clipboard);
          $composer_13.j31(value_6);
          tmp_36 = value_6;
        } else {
          tmp_36 = it_6;
        }
        var tmp0_group_0 = tmp_36;
        sourceInformationMarkerEnd($composer_13);
        LazyColumn(tmp_32, null, tmp_33, false, tmp_35, null, null, false, null, tmp0_group_0, $composer_13, 24582, 490);
        $composer_13.n30();
      }
      sourceInformationMarkerEnd($composer_13);
      $composer_11.e31();
      var tmp_37 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(snackbarHostState, tmp_37, null, $composer_8, 6, 4);
      sourceInformationMarkerEnd($composer_8);
      $composer_6.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp5_safe_receiver = $composer_0.t30();
    if (tmp5_safe_receiver == null)
      null;
    else {
      tmp5_safe_receiver.p3c(CouponsScreen$lambda_5(onBack, $changed));
    }
  }
  function ComposableSingletons$CouponsScreenKt$lambda$_231230485$lambda_cy4xbu($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C88@3807L43,87@3777L149:CouponsScreen.kt#ie1wbl');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-231230485, $changed, -1, 'client.fstech.hadaya.presentation.coupons.ComposableSingletons$CouponsScreenKt.lambda$-231230485.<anonymous> (CouponsScreen.kt:87)');
      }
      var tmp = stringResource(get_my_coupons_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = Companion_getInstance_16().e7z_1;
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, tmp_2, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 1572864, 0, 262078);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CouponsScreenKt$lambda$1207274635$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C96@4176L31,94@4056L177:CouponsScreen.kt#ie1wbl');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1207274635, $changed, -1, 'client.fstech.hadaya.presentation.coupons.ComposableSingletons$CouponsScreenKt.lambda$1207274635.<anonymous> (CouponsScreen.kt:94)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CouponsScreenKt$lambda$_2068659506$lambda_ozu9qv($this$item, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C152@6746L13:CouponsScreen.kt#ie1wbl');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2068659506, $changed, -1, 'client.fstech.hadaya.presentation.coupons.ComposableSingletons$CouponsScreenKt.lambda$-2068659506.<anonymous> (CouponsScreen.kt:152)');
      }
      CautionCard($composer_0, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CouponsScreenKt$lambda$225915859$lambda($this$item, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C157@6895L543:CouponsScreen.kt#ie1wbl');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(225915859, $changed, -1, 'client.fstech.hadaya.presentation.coupons.ComposableSingletons$CouponsScreenKt.lambda$225915859.<anonymous> (CouponsScreen.kt:157)');
      }
      var tmp = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(32);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = padding_1(tmp, VOID, tmp$ret$0);
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((4 & 1) === 0))
        modifier = Companion_instance;
      if (!((4 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((4 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 44107479, 'C162@7163L43,163@7266L10,164@7346L11,161@7121L287:CouponsScreen.kt#ie1wbl');
      var tmp0_text = stringResource(get_no_coupons_found(string_instance), $composer_5, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).oof_1;
      var tmp2_color = MaterialTheme_instance.unz($composer_5, 6).po0_1;
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp2_color, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, tmp1_style, $composer_5, 0, 0, 131066);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CouponsScreenKt$lambda$_231962059$lambda_1use71($this$Card, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C202@8484L1025:CouponsScreen.kt#ie1wbl');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-231962059, $changed, -1, 'client.fstech.hadaya.presentation.coupons.ComposableSingletons$CouponsScreenKt.lambda$-231962059.<anonymous> (CouponsScreen.kt:202)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = padding_0(tmp, tmp$ret$0);
      var horizontalArrangement = null;
      var verticalAlignment = Companion_getInstance_11().t8t_1;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier = Companion_instance;
      if (!((2 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((2 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 390 >> 3 | 112 & 390 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -2134876658, 'C209@8729L11,206@8607L202,212@8822L40,213@8875L624:CouponsScreen.kt#ie1wbl');
      var tmp0_imageVector = get_Info(Icons_getInstance().dxv_1);
      var tmp1_tint = MaterialTheme_instance.unz($composer_5, 6).to0_1;
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
      var tmp2_modifier = size(tmp_1, tmp$ret$7);
      Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_5, 432, 0);
      var tmp_2 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$8 = _Dp___init__impl__ms3zkb(12);
      Spacer(width(tmp_2, tmp$ret$8), $composer_5, 6);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = null;
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_6 = $composer_5;
      if (!((7 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((7 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((7 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_3 = $composer_8.g30();
      if (!isInterface(tmp_3, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_0);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, -158938325, 'C215@8933L47,216@9024L10,217@9090L11,214@8900L275,220@9192L40,222@9282L49,223@9375L10,224@9439L11,221@9249L236:CouponsScreen.kt#ie1wbl');
      var tmp0_text = stringResource(get_coupon_caution_title(string_instance), $composer_10, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_10, 6).mof_1;
      var tmp2_color = MaterialTheme_instance.unz($composer_10, 6).to0_1;
      var tmp3_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_7 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp2_color, null, tmp_4, null, tmp3_fontWeight, null, tmp_5, null, null, tmp_6, tmp_7, false, 0, 0, null, tmp1_style, $composer_10, 1572864, 0, 131002);
      var tmp_8 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$15 = _Dp___init__impl__ms3zkb(4);
      Spacer(height(tmp_8, tmp$ret$15), $composer_10, 6);
      var tmp4_text = stringResource(get_coupon_caution_message(string_instance), $composer_10, 0);
      var tmp5_style = MaterialTheme_instance.jog($composer_10, 6).qof_1;
      var tmp6_color = MaterialTheme_instance.unz($composer_10, 6).po0_1;
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_12 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp4_text, null, tmp6_color, null, tmp_9, null, null, null, tmp_10, null, null, tmp_11, tmp_12, false, 0, 0, null, tmp5_style, $composer_10, 0, 0, 131066);
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CouponsScreenKt$lambda$_920344868$lambda_jyt6ni($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C317@13554L36,318@13637L11,315@13452L226:CouponsScreen.kt#ie1wbl');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-920344868, $changed, -1, 'client.fstech.hadaya.presentation.coupons.ComposableSingletons$CouponsScreenKt.lambda$-920344868.<anonymous> (CouponsScreen.kt:315)');
      }
      var tmp = get_ContentCopy(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_copy_code(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).xnz_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CouponsScreenKt() {
    ComposableSingletons$CouponsScreenKt_instance = this;
    var tmp = this;
    tmp.i11z_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-231230485, false, ComposableSingletons$CouponsScreenKt$lambda$_231230485$lambda_cy4xbu));
    var tmp_0 = this;
    tmp_0.j11z_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1207274635, false, ComposableSingletons$CouponsScreenKt$lambda$1207274635$lambda));
    var tmp_1 = this;
    tmp_1.k11z_1 = ComposableLambda$invoke$ref_8(composableLambdaInstance(-2068659506, false, ComposableSingletons$CouponsScreenKt$lambda$_2068659506$lambda_ozu9qv));
    var tmp_2 = this;
    tmp_2.l11z_1 = ComposableLambda$invoke$ref_8(composableLambdaInstance(225915859, false, ComposableSingletons$CouponsScreenKt$lambda$225915859$lambda));
    var tmp_3 = this;
    tmp_3.m11z_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(-231962059, false, ComposableSingletons$CouponsScreenKt$lambda$_231962059$lambda_1use71));
    var tmp_4 = this;
    tmp_4.n11z_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-920344868, false, ComposableSingletons$CouponsScreenKt$lambda$_920344868$lambda_jyt6ni));
  }
  var ComposableSingletons$CouponsScreenKt_instance;
  function ComposableSingletons$CouponsScreenKt_getInstance() {
    if (ComposableSingletons$CouponsScreenKt_instance == null)
      new ComposableSingletons$CouponsScreenKt();
    return ComposableSingletons$CouponsScreenKt_instance;
  }
  function CouponItem(coupon, onCopy, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1170638603);
    sourceInformation($composer_0, 'C(CouponItem)238@9681L48,249@10135L3591,236@9598L4128:CouponsScreen.kt#ie1wbl');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(coupon) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onCopy) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1170638603, $dirty, -1, 'client.fstech.hadaya.presentation.coupons.CouponItem (CouponsScreen.kt:235)');
      }
      var tmp0_modifier = fillMaxWidth(Companion_instance);
      var tmp = CardDefaults_instance;
      var tmp_0;
      if (coupon.hzz_1) {
        // Inline function 'androidx.compose.ui.unit.dp' call
        tmp_0 = _Dp___init__impl__ms3zkb(1);
      } else {
        // Inline function 'androidx.compose.ui.unit.dp' call
        tmp_0 = _Dp___init__impl__ms3zkb(4);
      }
      var tmp_1 = tmp_0;
      var tmp_2 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_4 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_5 = _Dp___init__impl__ms3zkb(0.0);
      var tmp1_elevation = tmp.pog(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_0, 1572864, 62);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$2 = _Dp___init__impl__ms3zkb(12);
      var tmp2_shape = RoundedCornerShape(tmp$ret$2);
      var tmp_6;
      if (coupon.hzz_1) {
        $composer_0.m30(-639539972);
        sourceInformation($composer_0, '242@9896L11,241@9837L118');
        var tmp_7 = CardDefaults_instance;
        var tmp_8 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_0, 6).oo0_1, 0.4);
        var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp0_group = tmp_7.loh(tmp_8, tmp_9, tmp_10, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 14);
        $composer_0.n30();
        tmp_6 = tmp0_group;
      } else {
        $composer_0.m30(-639380198);
        sourceInformation($composer_0, '246@10057L11,245@9998L120');
        var tmp_11 = CardDefaults_instance;
        var tmp_12 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_0, 6).znz_1, 0.7);
        var tmp_13 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_14 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp1_group = tmp_11.loh(tmp_12, tmp_13, tmp_14, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 14);
        $composer_0.n30();
        tmp_6 = tmp1_group;
      }
      var tmp3_colors = tmp_6;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1875467943, true, CouponItem$lambda(coupon, onCopy), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_15;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref_6(dispatchReceiver);
        $composer_1.j31(value);
        tmp_15 = value;
      } else {
        tmp_15 = it;
      }
      var tmp$ret$3 = tmp_15;
      Card(tmp0_modifier, tmp2_shape, tmp3_colors, tmp1_elevation, null, tmp$ret$3, $composer_0, 196614, 16);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver = $composer_0.t30();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.p3c(CouponItem$lambda_0(coupon, onCopy, $changed));
    }
  }
  function CautionCard($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-2059913533);
    sourceInformation($composer_0, 'C(CautionCard)196@8339L11,195@8284L140,193@8204L1311:CouponsScreen.kt#ie1wbl');
    if ($composer_0.r31(!($changed === 0), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2059913533, $changed, -1, 'client.fstech.hadaya.presentation.coupons.CautionCard (CouponsScreen.kt:192)');
      }
      var tmp0_modifier = fillMaxWidth(Companion_instance);
      var tmp = CardDefaults_instance;
      var tmp_0 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_0, 6).vo0_1, 0.1);
      var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp1_colors = tmp.loh(tmp_0, tmp_1, tmp_2, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 14);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
      var tmp2_shape = RoundedCornerShape(tmp$ret$0);
      Card(tmp0_modifier, tmp2_shape, tmp1_colors, null, null, ComposableSingletons$CouponsScreenKt_getInstance().m11z_1, $composer_0, 196614, 24);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(CautionCard$lambda($changed));
    }
  }
  function CouponsScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function CouponsScreen$lambda_0() {
    return EmptyCoroutineContext_getInstance();
  }
  function CouponsScreen$slambda($viewModel, resultContinuation) {
    this.w11z_1 = $viewModel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CouponsScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CouponsScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CouponsScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.w11z_1.s10h().j10i(LoadCoupons_instance);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CouponsScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CouponsScreen$slambda(this.w11z_1, completion);
    i.x11z_1 = $this$LaunchedEffect;
    return i;
  };
  function CouponsScreen$slambda_0($viewModel, resultContinuation) {
    var i = new CouponsScreen$slambda($viewModel, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CouponsScreen$lambda_1($onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C93@4001L254:CouponsScreen.kt#ie1wbl');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-233064851, $changed, -1, 'client.fstech.hadaya.presentation.coupons.CouponsScreen.<anonymous>.<anonymous>.<anonymous> (CouponsScreen.kt:93)');
        }
        IconButton($onBack, null, false, null, null, null, ComposableSingletons$CouponsScreenKt_getInstance().j11z_1, $composer_0, 1572864, 62);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CouponsScreen$lambda_2($state$delegate) {
    return function (tabPositions, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C110@4815L11,108@4645L211:CouponsScreen.kt#ie1wbl');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(tabPositions) : $composer_0.q31(tabPositions)) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-321104241, $dirty, -1, 'client.fstech.hadaya.presentation.coupons.CouponsScreen.<anonymous>.<anonymous>.<anonymous> (CouponsScreen.kt:108)');
        }
        var tmp_1 = TabRowDefaults_getInstance();
        var tmp_2 = TabRowDefaults_getInstance().rqq(Companion_instance, tabPositions.l1(CouponsScreen$lambda($state$delegate).d11z_1.a1_1));
        tmp_1.yqp(tmp_2, _Dp___init__impl__ms3zkb(0.0), MaterialTheme_instance.unz($composer_0, 6).xnz_1, $composer_0, 3072, 2);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp_0 = tmp_3;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_10(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function CouponsScreen$lambda$lambda($viewModel, $filterType) {
    return function () {
      $viewModel.s10h().j10i(new ChangeFilter($filterType));
      return Unit_instance;
    };
  }
  function CouponsScreen$lambda$lambda_0($filterType, $state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C119@5215L572:CouponsScreen.kt#ie1wbl');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1011213442, $changed, -1, 'client.fstech.hadaya.presentation.coupons.CouponsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CouponsScreen.kt:119)');
        }
        var tmp_0;
        switch ($filterType.a1_1) {
          case 0:
            $composer_0.m30(-1113503864);
            sourceInformation($composer_0, '121@5340L42');
            var tmp0_group = stringResource(get_all_coupons_tab(string_instance), $composer_0, 0);
            $composer_0.n30();
            tmp_0 = tmp0_group;
            break;
          case 1:
            $composer_0.m30(-1113500370);
            sourceInformation($composer_0, '122@5449L48');
            var tmp1_group = stringResource(get_available_coupons_tab(string_instance), $composer_0, 0);
            $composer_0.n30();
            tmp_0 = tmp1_group;
            break;
          case 2:
            $composer_0.m30(-1113496855);
            sourceInformation($composer_0, '123@5559L43');
            var tmp2_group = stringResource(get_used_coupons_tab(string_instance), $composer_0, 0);
            $composer_0.n30();
            tmp_0 = tmp2_group;
            break;
          default:
            $composer_0.m30(-1113506090);
            $composer_0.n30();
            noWhenBranchMatchedException();
            break;
        }
        var tmp_1 = tmp_0;
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = CouponsScreen$lambda($state$delegate).d11z_1.equals($filterType) ? Companion_getInstance_16().e7z_1 : Companion_getInstance_16().b7z_1;
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_1, null, tmp_2, null, tmp_3, null, tmp_4, null, tmp_5, null, null, tmp_6, tmp_7, false, 0, 0, null, null, $composer_0, 0, 0, 262078);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CouponsScreen$lambda_3($viewModel, $state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C*117@5082L70,118@5185L628,115@4976L859:CouponsScreen.kt#ie1wbl');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-277126001, $changed, -1, 'client.fstech.hadaya.presentation.coupons.CouponsScreen.<anonymous>.<anonymous>.<anonymous> (CouponsScreen.kt:114)');
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = get_entries().t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          var tmp_0 = CouponsScreen$lambda($state$delegate).d11z_1.equals(element);
          sourceInformationMarkerStart($composer_0, -120909154, 'CC(remember):CouponsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = !!($composer_0.q31($viewModel) | $composer_0.m31(element.a1_1));
          // Inline function 'kotlin.let' call
          var it = $composer_0.i31();
          var tmp_1;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = CouponsScreen$lambda$lambda($viewModel, element);
            $composer_0.j31(value);
            tmp_1 = value;
          } else {
            tmp_1 = it;
          }
          var tmp0_group = tmp_1;
          sourceInformationMarkerEnd($composer_0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-1011213442, true, CouponsScreen$lambda$lambda_0(element, $state$delegate), $composer_0, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_1 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = $composer_1.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_0 = $composer_1.i31();
          var tmp_2;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_1.j31(value_0);
            tmp_2 = value_0;
          } else {
            tmp_2 = it_0;
          }
          var tmp_3 = tmp_2;
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          Tab(tmp_0, tmp0_group, null, false, tmp_3, null, tmp_4, tmp_5, null, $composer_0, 24576, 492);
        }
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CouponsScreen$lambda$lambda_1(it) {
    return null;
  }
  function CouponsScreen$lambda$lambda_2($key, $items) {
    return function (index) {
      return $key($items.l1(index));
    };
  }
  function CouponsScreen$lambda$lambda_3($contentType, $items) {
    return function (index) {
      return $contentType($items.l1(index));
    };
  }
  function CouponsScreen$lambda$lambda$lambda$slambda($clipboard, $coupon, resultContinuation) {
    this.g120_1 = $clipboard;
    this.h120_1 = $coupon;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CouponsScreen$lambda$lambda$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CouponsScreen$lambda$lambda$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CouponsScreen$lambda$lambda$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.g120_1.rc1(createClipEntry(this.h120_1.ezz_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CouponsScreen$lambda$lambda$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new CouponsScreen$lambda$lambda$lambda$slambda(this.g120_1, this.h120_1, completion);
    i.i120_1 = $this$launch;
    return i;
  };
  function CouponsScreen$lambda$lambda$lambda$slambda_0($clipboard, $coupon, resultContinuation) {
    var i = new CouponsScreen$lambda$lambda$lambda$slambda($clipboard, $coupon, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CouponsScreen$lambda$lambda$lambda($scope, $clipboard, $coupon) {
    return function () {
      launch($scope, VOID, VOID, CouponsScreen$lambda$lambda$lambda$slambda_0($clipboard, $coupon, null));
      return Unit_instance;
    };
  }
  function CouponsScreen$lambda$lambda_4($items, $scope, $clipboard) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp2 = $items.l1(it);
        var $changed_0 = 14 & $dirty;
        var $composer_1 = $composer_0;
        $composer_1.m30(-1973387884);
        sourceInformation($composer_1, 'C*172@7683L217,170@7581L349:CouponsScreen.kt#ie1wbl');
        sourceInformationMarkerStart($composer_1, 767629451, 'CC(remember):CouponsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_1.q31($scope) | $composer_1.q31($clipboard)) | (($changed_0 & 112 ^ 48) > 32 && $composer_1.k31(tmp2) || ($changed_0 & 48) === 32));
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_2;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = CouponsScreen$lambda$lambda$lambda($scope, $clipboard, tmp2);
          $composer_1.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it_0;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_1);
        CouponItem(tmp2, tmp0_group, $composer_1, 14 & $changed_0 >> 3);
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CouponsScreen$lambda_4($filteredCoupons, $scope, $clipboard) {
    return function ($this$LazyColumn) {
      $this$LazyColumn.ci9(VOID, VOID, ComposableSingletons$CouponsScreenKt_getInstance().k11z_1);
      var tmp;
      if ($filteredCoupons.r()) {
        $this$LazyColumn.ci9(VOID, VOID, ComposableSingletons$CouponsScreenKt_getInstance().l11z_1);
        tmp = Unit_instance;
      } else {
        // Inline function 'androidx.compose.foundation.lazy.items' call
        var items = $filteredCoupons;
        var contentType = CouponsScreen$lambda$lambda_1;
        var tmp_0 = items.n1();
        var tmp_1;
        if (!(null == null)) {
          tmp_1 = CouponsScreen$lambda$lambda_2(null, items);
        } else {
          tmp_1 = null;
        }
        var tmp_2 = tmp_1;
        var tmp_3 = CouponsScreen$lambda$lambda_3(contentType, items);
        $this$LazyColumn.di9(tmp_0, tmp_2, tmp_3, ComposableLambda$invoke$ref_4(composableLambdaInstance(802480018, true, CouponsScreen$lambda$lambda_4(items, $scope, $clipboard))));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CouponsScreen$lambda_5($onBack, $$changed) {
    return function ($composer, $force) {
      CouponsScreen($onBack, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function CouponItem$lambda($coupon, $onCopy) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C250@10145L3575:CouponsScreen.kt#ie1wbl');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1875467943, $changed, -1, 'client.fstech.hadaya.presentation.coupons.CouponItem.<anonymous> (CouponsScreen.kt:250)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var horizontalArrangement = null;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance;
        if (!((2 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((2 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 390 >> 3 | 112 & 390 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -2011815959, 'C254@10281L3069:CouponsScreen.kt#ie1wbl');
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_1 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_6 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_2 = $composer_8.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 492063534, 'C256@10371L58,257@10473L10,255@10338L338,266@10952L63,267@11059L10,265@10919L327,272@11264L40,287@11987L60,288@12091L10,286@11954L349:CouponsScreen.kt#ie1wbl');
        var tmp0_text = stringResource_0(get_coupon_code_prefix(string_instance), [$coupon.ezz_1], $composer_10, 0);
        var tmp1_style = MaterialTheme_instance.jog($composer_10, 6).lof_1;
        var tmp2_fontWeight = Companion_getInstance_16().f7z_1;
        var tmp_3;
        if ($coupon.hzz_1) {
          $composer_10.m30(-122668797);
          $composer_10.n30();
          tmp_3 = Companion_getInstance_14().k6b_1;
        } else {
          $composer_10.m30(-122667631);
          sourceInformation($composer_10, '259@10628L11');
          var tmp0_group = MaterialTheme_instance.unz($composer_10, 6).ao0_1;
          $composer_10.n30();
          tmp_3 = tmp0_group;
        }
        var tmp3_color = tmp_3;
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp3_color, null, tmp_4, null, tmp2_fontWeight, null, tmp_5, null, null, tmp_6, tmp_7, false, 0, 0, null, tmp1_style, $composer_10, 1572864, 0, 131002);
        var tmp_8;
        switch ($coupon.fzz_1.a1_1) {
          case 0:
            tmp_8 = '' + $coupon.gzz_1 + '%';
            break;
          case 1:
            tmp_8 = '' + $coupon.gzz_1 + ' EGP';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var discountText = tmp_8;
        var tmp5_text = stringResource_0(get_coupon_discount_prefix(string_instance), [discountText], $composer_10, 0);
        var tmp6_style = MaterialTheme_instance.jog($composer_10, 6).pof_1;
        var tmp7_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp_9;
        if ($coupon.hzz_1) {
          $composer_10.m30(-122650205);
          $composer_10.n30();
          tmp_9 = Companion_getInstance_14().k6b_1;
        } else {
          $composer_10.m30(-122649050);
          sourceInformation($composer_10, '269@11209L11');
          var tmp1_group = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
          $composer_10.n30();
          tmp_9 = tmp1_group;
        }
        var tmp8_color = tmp_9;
        var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_13 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp5_text, null, tmp8_color, null, tmp_10, null, tmp7_fontWeight, null, tmp_11, null, null, tmp_12, tmp_13, false, 0, 0, null, tmp6_style, $composer_10, 1572864, 0, 131002);
        var tmp_14 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$13 = _Dp___init__impl__ms3zkb(4);
        Spacer(height(tmp_14, tmp$ret$13), $composer_10, 6);
        var tmp_15;
        try {
          var tmp9_safe_receiver = $coupon.lzz_1;
          var tmp_16;
          if (tmp9_safe_receiver == null) {
            tmp_16 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_16 = Companion_getInstance_19().sp(tmp9_safe_receiver);
          }
          var tmp10_elvis_lhs = tmp_16;
          tmp_15 = tmp10_elvis_lhs == null ? Companion_getInstance_19().kf(new Long(0, 0)) : tmp10_elvis_lhs;
        } catch ($p) {
          var tmp_17;
          if ($p instanceof Exception) {
            var _unused_var__etf5q3 = $p;
            tmp_17 = Companion_getInstance_19().kf(new Long(0, 0));
          } else {
            throw $p;
          }
          tmp_15 = tmp_17;
        }
        var createdInstant = tmp_15;
        var createdDateTime = toLocalDateTime(createdInstant, Companion_getInstance_20().unp());
        var createdDateStr = createdDateTime.xn9_1.toString() + ' ' + createdDateTime.hna() + ':' + padStart(createdDateTime.bna().toString(), 2, _Char___init__impl__6a9atx(48));
        var tmp11_text = stringResource_0(get_coupon_created_at(string_instance), [createdDateStr], $composer_10, 0);
        var tmp12_style = MaterialTheme_instance.jog($composer_10, 6).qof_1;
        var tmp_18;
        if ($coupon.hzz_1) {
          $composer_10.m30(-122618813);
          $composer_10.n30();
          tmp_18 = Companion_getInstance_14().k6b_1;
        } else {
          $composer_10.m30(-122616993);
          sourceInformation($composer_10, '289@12190L11');
          var tmp2_group = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_10, 6).ao0_1, 0.6);
          $composer_10.n30();
          tmp_18 = tmp2_group;
        }
        var tmp13_color = tmp_18;
        var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_21 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_22 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp11_text, null, tmp13_color, null, tmp_19, null, null, null, tmp_20, null, null, tmp_21, tmp_22, false, 0, 0, null, tmp12_style, $composer_10, 0, 0, 131066);
        if ($coupon.hzz_1 && !($coupon.mzz_1 == null)) {
          $composer_10.m30(494011480);
          sourceInformation($composer_10, '306@13051L54,307@13153L10,308@13221L11,305@13014L304');
          var tmp_23;
          try {
            var tmp14_safe_receiver = $coupon.mzz_1;
            var tmp_24;
            if (tmp14_safe_receiver == null) {
              tmp_24 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_24 = Companion_getInstance_19().sp(tmp14_safe_receiver);
            }
            var tmp15_elvis_lhs = tmp_24;
            tmp_23 = tmp15_elvis_lhs == null ? Companion_getInstance_19().kf(new Long(0, 0)) : tmp15_elvis_lhs;
          } catch ($p_0) {
            var tmp_25;
            if ($p_0 instanceof Exception) {
              var _unused_var__etf5q3_0 = $p_0;
              tmp_25 = Companion_getInstance_19().kf(new Long(0, 0));
            } else {
              throw $p_0;
            }
            tmp_23 = tmp_25;
          }
          var usedInstant = tmp_23;
          var usedDateTime = toLocalDateTime(usedInstant, Companion_getInstance_20().unp());
          var usedDateStr = usedDateTime.xn9_1.toString() + ' ' + usedDateTime.hna() + ':' + padStart(usedDateTime.bna().toString(), 2, _Char___init__impl__6a9atx(48));
          var tmp16_text = stringResource_0(get_coupon_used_at(string_instance), [usedDateStr], $composer_10, 0);
          var tmp17_style = MaterialTheme_instance.jog($composer_10, 6).qof_1;
          var tmp18_color = MaterialTheme_instance.unz($composer_10, 6).to0_1;
          var tmp19_fontWeight = Companion_getInstance_16().d7z_1;
          var tmp_26 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_27 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_28 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_29 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp16_text, null, tmp18_color, null, tmp_26, null, tmp19_fontWeight, null, tmp_27, null, null, tmp_28, tmp_29, false, 0, 0, null, tmp17_style, $composer_10, 1572864, 0, 131002);
          $composer_10.n30();
        } else {
          $composer_10.m30(494944611);
          $composer_10.n30();
        }
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        if (!$coupon.hzz_1) {
          $composer_5.m30(-2008834938);
          sourceInformation($composer_5, '314@13401L295');
          IconButton($onCopy, null, false, null, null, null, ComposableSingletons$CouponsScreenKt_getInstance().n11z_1, $composer_5, 1572864, 62);
          $composer_5.n30();
        } else {
          $composer_5.m30(-2008520691);
          $composer_5.n30();
        }
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_30;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_30 = Unit_instance;
        }
        tmp = tmp_30;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CouponItem$lambda_0($coupon, $onCopy, $$changed) {
    return function ($composer, $force) {
      CouponItem($coupon, $onCopy, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function CautionCard$lambda($$changed) {
    return function ($composer, $force) {
      CautionCard($composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_coupons_CouponsViewModel$stable;
  function CouponsViewModel$slambda(this$0, resultContinuation) {
    this.r120_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CouponsViewModel$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CouponsViewModel$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CouponsViewModel$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.r120_1.z120(LoadCoupons_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CouponsViewModel$slambda).q24 = function ($this$launch, completion) {
    var i = new CouponsViewModel$slambda(this.r120_1, completion);
    i.s120_1 = $this$launch;
    return i;
  };
  function CouponsViewModel$slambda_0(this$0, resultContinuation) {
    var i = new CouponsViewModel$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CouponsViewModel$handleIntent$lambda($this$updateState) {
    return $this$updateState.g11z(true);
  }
  function CouponsViewModel$handleIntent$lambda_0($coupons) {
    return function ($this$updateState) {
      return $this$updateState.g11z(false, $coupons);
    };
  }
  function CouponsViewModel$handleIntent$lambda_1($this$updateState) {
    return $this$updateState.g11z(false, VOID, VOID, new ResourceString(get_user_not_logged_in(string_instance), []));
  }
  function CouponsViewModel$handleIntent$lambda_2($e) {
    return function ($this$updateState) {
      var tmp0_elvis_lhs = $e.message;
      return $this$updateState.g11z(false, VOID, VOID, new DynamicString(tmp0_elvis_lhs == null ? 'Unknown Error' : tmp0_elvis_lhs));
    };
  }
  function CouponsViewModel$handleIntent$lambda_3($intent) {
    return function ($this$updateState) {
      return $this$updateState.g11z(VOID, VOID, $intent.h11z_1);
    };
  }
  function $handleIntentCOROUTINE$_5(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i121_1 = _this__u8e3s4;
    this.j121_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            var tmp0_subject = this.j121_1;
            if (equals(tmp0_subject, LoadCoupons_instance)) {
              this.i121_1.x10k(CouponsViewModel$handleIntent$lambda);
              this.o9_1 = 3;
              var user = this.i121_1.x120_1.ynu();
              if (!(user == null)) {
                this.n9_1 = 1;
                suspendResult = this.i121_1.y120_1.k102(user.uym_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.i121_1.x10k(CouponsViewModel$handleIntent$lambda_1);
                this.n9_1 = 2;
                continue $sm;
              }
            } else {
              if (tmp0_subject instanceof ChangeFilter) {
                this.i121_1.x10k(CouponsViewModel$handleIntent$lambda_3(this.j121_1));
                this.n9_1 = 5;
                continue $sm;
              } else {
                noWhenBranchMatchedException();
              }
            }

            break;
          case 1:
            var coupons = suspendResult;
            this.i121_1.x10k(CouponsViewModel$handleIntent$lambda_0(coupons));
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.i121_1.x10k(CouponsViewModel$handleIntent$lambda_2(e));
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function CouponsViewModel(getCurrentUserValueUseCase, getUserCouponsUseCase) {
    BaseMviViewModel.call(this, new CouponsState());
    this.x120_1 = getCurrentUserValueUseCase;
    this.y120_1 = getUserCouponsUseCase;
    var tmp = get_viewModelScope(this);
    launch(tmp, VOID, VOID, CouponsViewModel$slambda_0(this, null));
  }
  protoOf(CouponsViewModel).z120 = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_5(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CouponsViewModel).f10l = function (intent, $completion) {
    return this.z120(isInterface(intent, CouponsIntent) ? intent : THROW_CCE(), $completion);
  };
  var client_fstech_hadaya_presentation_favorites_FavoritesState$stable;
  var client_fstech_hadaya_presentation_favorites_FavoritesIntent_LoadFavorites$stable;
  var client_fstech_hadaya_presentation_favorites_FavoritesIntent_ToggleFavorite$stable;
  var client_fstech_hadaya_presentation_favorites_FavoritesSideEffect_ShowError$stable;
  function FavoritesState(favoriteProducts, isLoading, language) {
    favoriteProducts = favoriteProducts === VOID ? emptyList() : favoriteProducts;
    isLoading = isLoading === VOID ? false : isLoading;
    language = language === VOID ? 'en' : language;
    this.k121_1 = favoriteProducts;
    this.l121_1 = isLoading;
    this.m121_1 = language;
  }
  protoOf(FavoritesState).n121 = function (favoriteProducts, isLoading, language) {
    return new FavoritesState(favoriteProducts, isLoading, language);
  };
  protoOf(FavoritesState).o121 = function (favoriteProducts, isLoading, language, $super) {
    favoriteProducts = favoriteProducts === VOID ? this.k121_1 : favoriteProducts;
    isLoading = isLoading === VOID ? this.l121_1 : isLoading;
    language = language === VOID ? this.m121_1 : language;
    return $super === VOID ? this.n121(favoriteProducts, isLoading, language) : $super.n121.call(this, favoriteProducts, isLoading, language);
  };
  protoOf(FavoritesState).toString = function () {
    return 'FavoritesState(favoriteProducts=' + toString(this.k121_1) + ', isLoading=' + this.l121_1 + ', language=' + this.m121_1 + ')';
  };
  protoOf(FavoritesState).hashCode = function () {
    var result = hashCode(this.k121_1);
    result = imul(result, 31) + getBooleanHashCode(this.l121_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m121_1) | 0;
    return result;
  };
  protoOf(FavoritesState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FavoritesState))
      return false;
    if (!equals(this.k121_1, other.k121_1))
      return false;
    if (!(this.l121_1 === other.l121_1))
      return false;
    if (!(this.m121_1 === other.m121_1))
      return false;
    return true;
  };
  function LoadFavorites() {
  }
  protoOf(LoadFavorites).toString = function () {
    return 'LoadFavorites';
  };
  protoOf(LoadFavorites).hashCode = function () {
    return -835828109;
  };
  protoOf(LoadFavorites).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadFavorites))
      return false;
    return true;
  };
  var LoadFavorites_instance;
  function LoadFavorites_getInstance() {
    return LoadFavorites_instance;
  }
  function ToggleFavorite(productId) {
    this.p121_1 = productId;
  }
  protoOf(ToggleFavorite).toString = function () {
    return 'ToggleFavorite(productId=' + this.p121_1.toString() + ')';
  };
  protoOf(ToggleFavorite).hashCode = function () {
    return this.p121_1.hashCode();
  };
  protoOf(ToggleFavorite).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ToggleFavorite))
      return false;
    if (!equalsLong(this.p121_1, other.p121_1))
      return false;
    return true;
  };
  function FavoritesIntent() {
  }
  function FavoritesScreen(onBack, onNavigateToProductDetails, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1431353708);
    sourceInformation($composer_0, 'C(FavoritesScreen)57@2598L15,58@2657L16,60@2679L3183:FavoritesScreen.kt#4p8rvv');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToProductDetails) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1431353708, $dirty, -1, 'client.fstech.hadaya.presentation.favorites.FavoritesScreen (FavoritesScreen.kt:56)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(FavoritesViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = fillMaxSize(Companion_instance);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_2 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_2, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_3 = $composer_2;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_0);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_1 = $composer_4.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_0);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_5 = $composer_4;
      var $composer_6 = $composer_5;
      sourceInformationMarkerStart($composer_6, -1650493640, 'C63@2847L266,61@2731L445:FavoritesScreen.kt#4p8rvv');
      var tmp_2 = ComposableSingletons$FavoritesScreenKt_getInstance().q121_1;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(330331132, true, FavoritesScreen$lambda_0(onBack), $composer_6, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_7 = $composer_6;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_7.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_7.i31();
      var tmp_3;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_7.j31(value);
        tmp_3 = value;
      } else {
        tmp_3 = it;
      }
      var tmp_4 = tmp_3;
      var tmp_5 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_6 = WindowInsets(0, 0, 0, 0);
      TopAppBar(tmp_2, null, tmp_4, null, tmp_5, tmp_6, null, null, $composer_6, 390, 218);
      if (FavoritesScreen$lambda(state$delegate).l121_1) {
        $composer_6.m30(-1650113736);
        sourceInformation($composer_6, '75@3221L124');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = fillMaxSize(Companion_instance);
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_8 = $composer_6;
        if (!((4 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_9 = $composer_8;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_9, 0).hashCode();
        var localMap_0 = $composer_9.t31();
        var materialized_0 = materialize($composer_9, modifier_2);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_10 = $composer_9;
        var tmp_7 = $composer_10.g30();
        if (!isInterface(tmp_7, Applier)) {
          invalidApplier();
        }
        $composer_10.b31();
        if ($composer_10.h30()) {
          $composer_10.c31(tmp0_1);
        } else {
          $composer_10.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_10);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_11 = $composer_10;
        var $composer_12 = $composer_11;
        sourceInformationMarkerStart($composer_12, -513133261, 'C76@3304L27:FavoritesScreen.kt#4p8rvv');
        var tmp_8 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_9 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_11 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_8, tmp_9, tmp_10, tmp_11, _Dp___init__impl__ms3zkb(0.0), $composer_12, 0, 63);
        sourceInformationMarkerEnd($composer_12);
        $composer_10.e31();
        $composer_6.n30();
      } else if (FavoritesScreen$lambda(state$delegate).k121_1.r()) {
        $composer_6.m30(-1649905075);
        sourceInformation($composer_6, '79@3413L711');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = fillMaxSize(Companion_instance);
        var contentAlignment_0 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_0 = false;
        var $composer_13 = $composer_6;
        if (!((4 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_14 = $composer_13;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_14, 0).hashCode();
        var localMap_1 = $composer_14.t31();
        var materialized_1 = materialize($composer_14, modifier_4);
        var tmp0_2 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_15 = $composer_14;
        var tmp_12 = $composer_15.g30();
        if (!isInterface(tmp_12, Applier)) {
          invalidApplier();
        }
        $composer_15.b31();
        if ($composer_15.h30()) {
          $composer_15.c31(tmp0_2);
        } else {
          $composer_15.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_15);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_16 = $composer_15;
        var $composer_17 = $composer_16;
        sourceInformationMarkerStart($composer_17, 1116001073, 'C80@3496L614:FavoritesScreen.kt#4p8rvv');
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_5 = null;
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = Companion_getInstance_11().x8t_1;
        var $composer_18 = $composer_17;
        if (!((3 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((3 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((3 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_2 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_18, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_19 = $composer_18;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_19, 0).hashCode();
        var localMap_2 = $composer_19.t31();
        var materialized_2 = materialize($composer_19, modifier_6);
        var tmp0_3 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_20 = $composer_19;
        var tmp_13 = $composer_20.g30();
        if (!isInterface(tmp_13, Applier)) {
          invalidApplier();
        }
        $composer_20.b31();
        if ($composer_20.h30()) {
          $composer_20.c31(tmp0_3);
        } else {
          $composer_20.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_20);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_21 = $composer_20;
        var $composer_22 = $composer_21;
        sourceInformationMarkerStart($composer_22, -1101758678, 'C85@3784L11,81@3577L269,87@3867L41,89@3959L43,90@4050L10,88@3929L163:FavoritesScreen.kt#4p8rvv');
        var tmp_14 = get_Favorite(Icons_getInstance().dxv_1);
        var tmp_15 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$33 = _Dp___init__impl__ms3zkb(64);
        Icon(tmp_14, null, size(tmp_15, tmp$ret$33), Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_22, 6).co0_1, 0.3), $composer_22, 432, 0);
        var tmp_16 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$34 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_16, tmp$ret$34), $composer_22, 6);
        var tmp_17 = stringResource(get_no_favorites_yet(string_instance), $composer_22, 0);
        var tmp_18 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_21 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_22 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_17, null, tmp_18, null, tmp_19, null, null, null, tmp_20, null, null, tmp_21, tmp_22, false, 0, 0, null, MaterialTheme_instance.jog($composer_22, 6).oof_1, $composer_22, 0, 0, 131070);
        sourceInformationMarkerEnd($composer_22);
        $composer_20.e31();
        sourceInformationMarkerEnd($composer_17);
        $composer_15.e31();
        $composer_6.n30();
      } else {
        $composer_6.m30(-1649139592);
        sourceInformation($composer_6, '98@4294L1552,95@4154L1692');
        var tmp_23 = fillMaxSize(Companion_instance);
        var tmp_24 = Companion_getInstance_11().l8t_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-1404573956, true, FavoritesScreen$lambda_1(state$delegate, onNavigateToProductDetails, viewModel), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_23 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_23.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_23.i31();
        var tmp_25;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_12(dispatchReceiver_0);
          $composer_23.j31(value_0);
          tmp_25 = value_0;
        } else {
          tmp_25 = it_0;
        }
        var tmp$ret$35 = tmp_25;
        BoxWithConstraints(tmp_23, tmp_24, false, tmp$ret$35, $composer_6, 3126, 4);
        $composer_6.n30();
      }
      sourceInformationMarkerEnd($composer_6);
      $composer_4.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(FavoritesScreen$lambda_2(onBack, onNavigateToProductDetails, $changed));
    }
  }
  function ComposableSingletons$FavoritesScreenKt$lambda$338330106$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C62@2769L44,62@2764L50:FavoritesScreen.kt#4p8rvv');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(338330106, $changed, -1, 'client.fstech.hadaya.presentation.favorites.ComposableSingletons$FavoritesScreenKt.lambda$338330106.<anonymous> (FavoritesScreen.kt:62)');
      }
      var tmp = stringResource(get_favorite_products(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FavoritesScreenKt$lambda$1237267098$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C67@3028L31,65@2916L165:FavoritesScreen.kt#4p8rvv');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1237267098, $changed, -1, 'client.fstech.hadaya.presentation.favorites.ComposableSingletons$FavoritesScreenKt.lambda$1237267098.<anonymous> (FavoritesScreen.kt:65)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FavoritesScreenKt$lambda$977238868$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C186@7728L48,184@7629L211:FavoritesScreen.kt#4p8rvv');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(977238868, $changed, -1, 'client.fstech.hadaya.presentation.favorites.ComposableSingletons$FavoritesScreenKt.lambda$977238868.<anonymous> (FavoritesScreen.kt:184)');
      }
      var tmp = get_Favorite(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_remove_from_favorites(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, Companion_getInstance_14().n6b_1, $composer_0, 3072, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FavoritesScreenKt() {
    ComposableSingletons$FavoritesScreenKt_instance = this;
    var tmp = this;
    tmp.q121_1 = ComposableLambda$invoke$ref(composableLambdaInstance(338330106, false, ComposableSingletons$FavoritesScreenKt$lambda$338330106$lambda));
    var tmp_0 = this;
    tmp_0.r121_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1237267098, false, ComposableSingletons$FavoritesScreenKt$lambda$1237267098$lambda));
    var tmp_1 = this;
    tmp_1.s121_1 = ComposableLambda$invoke$ref(composableLambdaInstance(977238868, false, ComposableSingletons$FavoritesScreenKt$lambda$977238868$lambda));
  }
  var ComposableSingletons$FavoritesScreenKt_instance;
  function ComposableSingletons$FavoritesScreenKt_getInstance() {
    if (ComposableSingletons$FavoritesScreenKt_instance == null)
      new ComposableSingletons$FavoritesScreenKt();
    return ComposableSingletons$FavoritesScreenKt_instance;
  }
  function FavoriteProductItem(product, language, onClick, onToggleFavorite, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1559941304);
    sourceInformation($composer_0, 'C(FavoriteProductItem)P(3)157@6440L38,158@6485L3043,154@6285L3243:FavoritesScreen.kt#4p8rvv');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(product) : $composer_0.q31(product)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onToggleFavorite) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1559941304, $dirty, -1, 'client.fstech.hadaya.presentation.favorites.FavoriteProductItem (FavoritesScreen.kt:146)');
      }
      var tmp;
      if (language === 'en') {
        var tmp0_elvis_lhs = product.ozt_1;
        tmp = tmp0_elvis_lhs == null ? product.pzt_1 : tmp0_elvis_lhs;
      } else {
        var tmp1_elvis_lhs = product.pzt_1;
        tmp = tmp1_elvis_lhs == null ? product.ozt_1 : tmp1_elvis_lhs;
      }
      var tmp2_elvis_lhs = tmp;
      var name = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
      var tmp3_elvis_lhs = product.szt_1;
      var price = tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs;
      var tmp4_elvis_lhs = product.tzt_1;
      var discount = tmp4_elvis_lhs == null ? 0.0 : tmp4_elvis_lhs;
      var hasDiscount = discount > 0.0;
      var tmp_0 = clickable(fillMaxWidth(Companion_instance), VOID, VOID, VOID, VOID, onClick);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
      var tmp_1 = RoundedCornerShape(tmp$ret$0);
      var tmp_2 = CardDefaults_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_3 = _Dp___init__impl__ms3zkb(2);
      var tmp_4 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_5 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_6 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_7 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_8 = tmp_2.pog(tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, _Dp___init__impl__ms3zkb(0.0), $composer_0, 1572870, 62);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(1875200826, true, FavoriteProductItem$lambda(product, name, onToggleFavorite, hasDiscount, discount, price), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_9;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref_6(dispatchReceiver);
        $composer_1.j31(value);
        tmp_9 = value;
      } else {
        tmp_9 = it;
      }
      var tmp$ret$2 = tmp_9;
      Card(tmp_0, tmp_1, null, tmp_8, null, tmp$ret$2, $composer_0, 196608, 20);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(FavoriteProductItem$lambda_0(product, language, onClick, onToggleFavorite, $changed));
    }
  }
  function FavoritesScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function FavoritesScreen$lambda_0($onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C64@2865L234:FavoritesScreen.kt#4p8rvv');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(330331132, $changed, -1, 'client.fstech.hadaya.presentation.favorites.FavoritesScreen.<anonymous>.<anonymous> (FavoritesScreen.kt:64)');
        }
        IconButton($onBack, null, false, null, null, null, ComposableSingletons$FavoritesScreenKt_getInstance().r121_1, $composer_0, 1572864, 62);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FavoritesScreen$lambda$lambda$lambda(it) {
    var tmp0_elvis_lhs = it.nzt_1;
    return tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
  }
  function FavoritesScreen$lambda$lambda$lambda_0(it) {
    return null;
  }
  function FavoritesScreen$lambda$lambda$lambda_1($key, $items) {
    return function (index) {
      return $key($items.l1(index));
    };
  }
  function FavoritesScreen$lambda$lambda$lambda_2($span, $items) {
    return function ($this$items, it) {
      return $span($this$items, $items.l1(it));
    };
  }
  function FavoritesScreen$lambda$lambda$lambda_3($contentType, $items) {
    return function (index) {
      return $contentType($items.l1(index));
    };
  }
  function ComposableLambda$invoke$ref_11(p0) {
    return constructCallableReference(function (p0_0, p1, p2, p3) {
      p0.v50(p0_0, p1, p2, p3);
      return Unit_instance;
    }, 4, 0, 255, VOID, [p0]);
  }
  function FavoritesScreen$lambda$lambda$lambda$lambda($onNavigateToProductDetails, $product) {
    return function () {
      $onNavigateToProductDetails($product);
      return Unit_instance;
    };
  }
  function FavoritesScreen$lambda$lambda$lambda$lambda_0($viewModel, $product) {
    return function () {
      var tmp = $viewModel.s10h();
      var tmp0_elvis_lhs = $product.nzt_1;
      tmp.j10i(new ToggleFavorite(tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs));
      return Unit_instance;
    };
  }
  function FavoritesScreen$lambda$lambda$lambda_4($items, $onNavigateToProductDetails, $viewModel, $state$delegate) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp2 = $items.l1(it);
        var $changed_0 = 14 & $dirty;
        var $composer_1 = $composer_0;
        $composer_1.m30(558043353);
        sourceInformation($composer_1, 'C*124@5390L39,125@5478L288,121@5229L563:FavoritesScreen.kt#4p8rvv');
        var tmp_2 = FavoritesScreen$lambda($state$delegate).m121_1;
        sourceInformationMarkerStart($composer_1, -397635970, 'CC(remember):FavoritesScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_1.k31($onNavigateToProductDetails) | (($changed_0 & 112 ^ 48) > 32 && $composer_1.q31(tmp2) || ($changed_0 & 48) === 32));
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_3;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = FavoritesScreen$lambda$lambda$lambda$lambda($onNavigateToProductDetails, tmp2);
          $composer_1.j31(value);
          tmp_3 = value;
        } else {
          tmp_3 = it_0;
        }
        var tmp0_group = tmp_3;
        sourceInformationMarkerEnd($composer_1);
        sourceInformationMarkerStart($composer_1, -397632905, 'CC(remember):FavoritesScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = !!($composer_1.q31($viewModel) | (($changed_0 & 112 ^ 48) > 32 && $composer_1.q31(tmp2) || ($changed_0 & 48) === 32));
        // Inline function 'kotlin.let' call
        var it_1 = $composer_1.i31();
        var tmp_4;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = FavoritesScreen$lambda$lambda$lambda$lambda_0($viewModel, tmp2);
          $composer_1.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_1;
        }
        var tmp1_group = tmp_4;
        sourceInformationMarkerEnd($composer_1);
        FavoriteProductItem(tmp2, tmp_2, tmp0_group, tmp1_group, $composer_1, 14 & $changed_0 >> 3);
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FavoritesScreen$lambda$lambda($state$delegate, $onNavigateToProductDetails, $viewModel) {
    return function ($this$LazyVerticalGrid) {
      var tmp2 = FavoritesScreen$lambda($state$delegate).k121_1;
      // Inline function 'androidx.compose.foundation.lazy.grid.items' call
      var key = FavoritesScreen$lambda$lambda$lambda;
      var contentType = FavoritesScreen$lambda$lambda$lambda_0;
      var tmp = tmp2.n1();
      var tmp_0;
      if (!(key == null)) {
        tmp_0 = FavoritesScreen$lambda$lambda$lambda_1(key, tmp2);
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      var tmp_2;
      if (!(null == null)) {
        tmp_2 = FavoritesScreen$lambda$lambda$lambda_2(null, tmp2);
      } else {
        tmp_2 = null;
      }
      var tmp_3 = tmp_2;
      var tmp_4 = FavoritesScreen$lambda$lambda$lambda_3(contentType, tmp2);
      $this$LazyVerticalGrid.fiq(tmp, tmp_1, tmp_3, tmp_4, ComposableLambda$invoke$ref_11(composableLambdaInstance(-1117249557, true, FavoritesScreen$lambda$lambda$lambda_4(tmp2, $onNavigateToProductDetails, $viewModel, $state$delegate))));
      return Unit_instance;
    };
  }
  function FavoritesScreen$lambda_1($state$delegate, $onNavigateToProductDetails, $viewModel) {
    return function ($this$BoxWithConstraints, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C119@5117L715,106@4528L1304:FavoritesScreen.kt#4p8rvv');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$BoxWithConstraints) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1404573956, $dirty, -1, 'client.fstech.hadaya.presentation.favorites.FavoritesScreen.<anonymous>.<anonymous> (FavoritesScreen.kt:99)');
        }
        var tmp_1;
        var tmp_2 = $this$BoxWithConstraints.wds();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(1200);
        if (Dp__compareTo_impl_tlg3dl(tmp_2, tmp$ret$0) > 0) {
          tmp_1 = 5;
        } else {
          var tmp_3 = $this$BoxWithConstraints.wds();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$1 = _Dp___init__impl__ms3zkb(900);
          if (Dp__compareTo_impl_tlg3dl(tmp_3, tmp$ret$1) > 0) {
            tmp_1 = 4;
          } else {
            var tmp_4 = $this$BoxWithConstraints.wds();
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$2 = _Dp___init__impl__ms3zkb(600);
            if (Dp__compareTo_impl_tlg3dl(tmp_4, tmp$ret$2) > 0) {
              tmp_1 = 3;
            } else {
              tmp_1 = 2;
            }
          }
        }
        var columns = tmp_1;
        var tmp4_columns = new Fixed(columns);
        var tmp_5 = fillMaxSize(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$3 = _Dp___init__impl__ms3zkb(1400);
        var tmp5_modifier = widthIn(tmp_5, VOID, tmp$ret$3);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp0_start = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_end = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_top = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_bottom = _Dp___init__impl__ms3zkb(16);
        var tmp6_contentPadding = PaddingValues(tmp0_start, tmp2_top, tmp1_end, tmp3_bottom);
        var tmp_6 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(16);
        var tmp7_horizontalArrangement = tmp_6.mdq(tmp$ret$8);
        var tmp_7 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$9 = _Dp___init__impl__ms3zkb(16);
        var tmp8_verticalArrangement = tmp_7.mdq(tmp$ret$9);
        sourceInformationMarkerStart($composer_0, -1175813721, 'CC(remember):FavoritesScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.k31($state$delegate) | $composer_0.k31($onNavigateToProductDetails)) | $composer_0.q31($viewModel));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_8;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = FavoritesScreen$lambda$lambda($state$delegate, $onNavigateToProductDetails, $viewModel);
          $composer_0.j31(value);
          tmp_8 = value;
        } else {
          tmp_8 = it;
        }
        var tmp0_group = tmp_8;
        sourceInformationMarkerEnd($composer_0);
        LazyVerticalGrid(tmp4_columns, tmp5_modifier, null, tmp6_contentPadding, false, tmp8_verticalArrangement, tmp7_horizontalArrangement, null, false, null, tmp0_group, $composer_0, 1769520, 0, 916);
        var tmp_9;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_9 = Unit_instance;
        }
        tmp_0 = tmp_9;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_12(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function FavoritesScreen$lambda_2($onBack, $onNavigateToProductDetails, $$changed) {
    return function ($composer, $force) {
      FavoritesScreen($onBack, $onNavigateToProductDetails, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function FavoriteProductItem$lambda($product, $name, $onToggleFavorite, $hasDiscount, $discount, $price) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C159@6495L3027:FavoritesScreen.kt#4p8rvv');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1875200826, $changed, -1, 'client.fstech.hadaya.presentation.favorites.FavoriteProductItem.<anonymous> (FavoritesScreen.kt:159)');
        }
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = null;
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((7 & 1) === 0))
          modifier = Companion_instance;
        if (!((7 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((7 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 1444238943, 'C160@6516L1356,192@7886L1626:FavoritesScreen.kt#4p8rvv');
        var tmp_1 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$6 = _Dp___init__impl__ms3zkb(150);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = height(tmp_1, tmp$ret$6);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_2 = $composer_8.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, -565890824, 'C180@7451L407:FavoritesScreen.kt#4p8rvv');
        var tmp0_safe_receiver = $product.xzt_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
        var tmp_3;
        if (tmp1_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_4;
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(tmp1_safe_receiver)) {
            tmp_4 = tmp1_safe_receiver;
          } else {
            tmp_4 = null;
          }
          tmp_3 = tmp_4;
        }
        var imageUrl = tmp_3;
        if (!(imageUrl == null)) {
          $composer_10.m30(-565806009);
          sourceInformation($composer_10, '163@6724L349');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_3 = fillMaxSize(Companion_instance);
          var contentAlignment_0 = null;
          var propagateMinConstraints_0 = false;
          var $composer_11 = $composer_10;
          if (!((6 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_0 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_0 = false;
          var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_5 = $composer_13.g30();
          if (!isInterface(tmp_5, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_1);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_15, 1053257286, 'C164@6789L262:FavoritesScreen.kt#4p8rvv');
          HadayaImage(imageUrl, $name, fillMaxSize(Companion_instance), Companion_getInstance_13().r96_1, $composer_15, 3456, 0);
          sourceInformationMarkerEnd($composer_15);
          $composer_13.e31();
          $composer_10.n30();
        } else {
          $composer_10.m30(-565415812);
          sourceInformation($composer_10, '172@7119L296');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_5 = background(fillMaxSize(Companion_instance), Companion_getInstance_14().l6b_1);
          var contentAlignment_1 = Companion_getInstance_11().o8t_1;
          var propagateMinConstraints_1 = false;
          var $composer_16 = $composer_10;
          if (!((4 & 1) === 0))
            modifier_5 = Companion_instance;
          if (!((4 & 2) === 0))
            contentAlignment_1 = Companion_getInstance_11().k8t_1;
          if (!((4 & 4) === 0))
            propagateMinConstraints_1 = false;
          var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_6 = modifier_5;
          var $composer_17 = $composer_16;
          if (!((0 & 2) === 0))
            modifier_6 = Companion_instance;
          var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
          var localMap_2 = $composer_17.t31();
          var materialized_2 = materialize($composer_17, modifier_6);
          var tmp0_2 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_18 = $composer_17;
          var tmp_6 = $composer_18.g30();
          if (!isInterface(tmp_6, Applier)) {
            invalidApplier();
          }
          $composer_18.b31();
          if ($composer_18.h30()) {
            $composer_18.c31(tmp0_2);
          } else {
            $composer_18.d31();
          }
          var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_18);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
          var $composer_19 = $composer_18;
          var $composer_20 = $composer_19;
          sourceInformationMarkerStart($composer_20, 1810268121, 'C176@7319L74:FavoritesScreen.kt#4p8rvv');
          var tmp_7 = get_Favorite(Icons_getInstance().dxv_1);
          Icon(tmp_7, null, null, Companion_getInstance_14().k6b_1, $composer_20, 3120, 4);
          sourceInformationMarkerEnd($composer_20);
          $composer_18.e31();
          $composer_10.n30();
        }
        var tmp_8 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().m8t_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$28 = _Dp___init__impl__ms3zkb(4);
        var tmp_9 = padding_0(tmp_8, tmp$ret$28);
        IconButton($onToggleFavorite, tmp_9, false, null, null, null, ComposableSingletons$FavoritesScreenKt_getInstance().s121_1, $composer_10, 1572864, 60);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_10 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$29 = _Dp___init__impl__ms3zkb(12);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_7 = padding_0(tmp_10, tmp$ret$29);
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = null;
        var $composer_21 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_3 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_21, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_22 = $composer_21;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_22, 0).hashCode();
        var localMap_3 = $composer_22.t31();
        var materialized_3 = materialize($composer_22, modifier_8);
        var tmp0_3 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_23 = $composer_22;
        var tmp_11 = $composer_23.g30();
        if (!isInterface(tmp_11, Applier)) {
          invalidApplier();
        }
        $composer_23.b31();
        if ($composer_23.h30()) {
          $composer_23.c31(tmp0_3);
        } else {
          $composer_23.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_23);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_24 = $composer_23;
        var $composer_25 = $composer_24;
        sourceInformationMarkerStart($composer_25, -749844306, 'C193@7947L296,201@8260L40,202@8317L1181:FavoritesScreen.kt#4p8rvv');
        var tmp0_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp1_fontSize = get_sp(14);
        var tmp2_overflow = Companion_getInstance_23().x7s_1;
        var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        Text($name, null, tmp_12, null, tmp1_fontSize, null, tmp0_fontWeight, null, tmp_13, null, null, tmp_14, tmp2_overflow, false, 2, 2, null, null, $composer_25, 1597440, 221568, 208814);
        var tmp_15 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$36 = _Dp___init__impl__ms3zkb(4);
        Spacer(height(tmp_15, tmp$ret$36), $composer_25, 6);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_9 = null;
        var horizontalArrangement = null;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_26 = $composer_25;
        if (!((3 & 1) === 0))
          modifier_9 = Companion_instance;
        if (!((3 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((3 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_4 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_26, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_10 = modifier_9;
        var $composer_27 = $composer_26;
        if (!((0 & 2) === 0))
          modifier_10 = Companion_instance;
        var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_27, 0).hashCode();
        var localMap_4 = $composer_27.t31();
        var materialized_4 = materialize($composer_27, modifier_10);
        var tmp0_4 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_28 = $composer_27;
        var tmp_16 = $composer_28.g30();
        if (!isInterface(tmp_16, Applier)) {
          invalidApplier();
        }
        $composer_28.b31();
        if ($composer_28.h30()) {
          $composer_28.c31(tmp0_4);
        } else {
          $composer_28.d31();
        }
        var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_28);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
        var $composer_29 = $composer_28;
        var $composer_30 = $composer_29;
        sourceInformationMarkerStart($composer_30, 2130645336, 'C:FavoritesScreen.kt#4p8rvv');
        if ($hasDiscount) {
          $composer_30.m30(2130651163);
          sourceInformation($composer_30, '205@8475L46,206@8573L11,204@8434L288,210@8747L39,212@8852L43,211@8811L308');
          var tmp0_text = stringResource_0(get_price_egp(string_instance), [$discount], $composer_30, 0);
          var tmp1_color = MaterialTheme_instance.unz($composer_30, 6).xnz_1;
          var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp3_fontSize = get_sp(14);
          var tmp_17 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_18 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_19 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, null, tmp1_color, null, tmp3_fontSize, null, tmp2_fontWeight, null, tmp_17, null, null, tmp_18, tmp_19, false, 0, 0, null, null, $composer_30, 1597440, 0, 262058);
          var tmp_20 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$43 = _Dp___init__impl__ms3zkb(4);
          Spacer(width(tmp_20, tmp$ret$43), $composer_30, 6);
          var tmp_21 = stringResource_0(get_price_egp(string_instance), [$price], $composer_30, 0);
          var tmp_22 = Companion_getInstance_14().k6b_1;
          var tmp_23 = get_sp(11);
          var tmp_24 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_25 = Companion_getInstance_18().c80_1;
          var tmp_26 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_27 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_21, null, tmp_22, null, tmp_23, null, null, null, tmp_24, tmp_25, null, tmp_26, tmp_27, false, 0, 0, null, null, $composer_30, 805331328, 0, 261610);
          $composer_30.n30();
        } else {
          $composer_30.m30(2131396155);
          sourceInformation($composer_30, '219@9214L43,220@9309L11,218@9173L285');
          var tmp4_text = stringResource_0(get_price_egp(string_instance), [$price], $composer_30, 0);
          var tmp5_color = MaterialTheme_instance.unz($composer_30, 6).xnz_1;
          var tmp6_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp7_fontSize = get_sp(14);
          var tmp_28 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_29 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_30 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp4_text, null, tmp5_color, null, tmp7_fontSize, null, tmp6_fontWeight, null, tmp_28, null, null, tmp_29, tmp_30, false, 0, 0, null, null, $composer_30, 1597440, 0, 262058);
          $composer_30.n30();
        }
        sourceInformationMarkerEnd($composer_30);
        $composer_28.e31();
        sourceInformationMarkerEnd($composer_25);
        $composer_23.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_31;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_31 = Unit_instance;
        }
        tmp = tmp_31;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FavoriteProductItem$lambda_0($product, $language, $onClick, $onToggleFavorite, $$changed) {
    return function ($composer, $force) {
      FavoriteProductItem($product, $language, $onClick, $onToggleFavorite, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_favorites_FavoritesViewModel$stable;
  function FavoritesViewModel$observeLanguage$slambda$slambda$lambda($language) {
    return function ($this$updateState) {
      return $this$updateState.o121(VOID, VOID, $language);
    };
  }
  function FavoritesViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation) {
    this.b122_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FavoritesViewModel$observeLanguage$slambda$slambda).pyo = function (language, $completion) {
    var tmp = this.um9(language, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FavoritesViewModel$observeLanguage$slambda$slambda).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FavoritesViewModel$observeLanguage$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.b122_1.x10k(FavoritesViewModel$observeLanguage$slambda$slambda$lambda(this.c122_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(FavoritesViewModel$observeLanguage$slambda$slambda).um9 = function (language, completion) {
    var i = new FavoritesViewModel$observeLanguage$slambda$slambda(this.b122_1, completion);
    i.c122_1 = language;
    return i;
  };
  function FavoritesViewModel$observeLanguage$slambda$slambda_0(this$0, resultContinuation) {
    var i = new FavoritesViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (language, $completion) {
      return i.pyo(language, $completion);
    }, 1);
  }
  function FavoritesViewModel$observeFavorites$slambda$slambda$lambda($products) {
    return function ($this$updateState) {
      return $this$updateState.o121($products, false);
    };
  }
  function FavoritesViewModel$observeFavorites$slambda$lambda($this$updateState) {
    return $this$updateState.o121(VOID, true);
  }
  function FavoritesViewModel$observeFavorites$slambda$slambda(this$0, resultContinuation) {
    this.l122_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FavoritesViewModel$observeFavorites$slambda$slambda).n122 = function (products, $completion) {
    var tmp = this.o122(products, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FavoritesViewModel$observeFavorites$slambda$slambda).ja = function (p1, $completion) {
    return this.n122((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FavoritesViewModel$observeFavorites$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.l122_1.x10k(FavoritesViewModel$observeFavorites$slambda$slambda$lambda(this.m122_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(FavoritesViewModel$observeFavorites$slambda$slambda).o122 = function (products, completion) {
    var i = new FavoritesViewModel$observeFavorites$slambda$slambda(this.l122_1, completion);
    i.m122_1 = products;
    return i;
  };
  function FavoritesViewModel$observeFavorites$slambda$slambda_0(this$0, resultContinuation) {
    var i = new FavoritesViewModel$observeFavorites$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (products, $completion) {
      return i.n122(products, $completion);
    }, 1);
  }
  function syncFavorites($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, FavoritesViewModel$syncFavorites$slambda_0($this, null));
  }
  function observeLanguage_3($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, FavoritesViewModel$observeLanguage$slambda_0($this, null));
  }
  function observeFavorites($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, FavoritesViewModel$observeFavorites$slambda_0($this, null));
  }
  function FavoritesViewModel$syncFavorites$slambda(this$0, resultContinuation) {
    this.x122_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FavoritesViewModel$syncFavorites$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FavoritesViewModel$syncFavorites$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FavoritesViewModel$syncFavorites$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.x122_1.f123_1.r2b(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FavoritesViewModel$syncFavorites$slambda).q24 = function ($this$launch, completion) {
    var i = new FavoritesViewModel$syncFavorites$slambda(this.x122_1, completion);
    i.y122_1 = $this$launch;
    return i;
  };
  function FavoritesViewModel$syncFavorites$slambda_0(this$0, resultContinuation) {
    var i = new FavoritesViewModel$syncFavorites$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function FavoritesViewModel$observeLanguage$slambda(this$0, resultContinuation) {
    this.p123_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FavoritesViewModel$observeLanguage$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FavoritesViewModel$observeLanguage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FavoritesViewModel$observeLanguage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.p123_1.g123_1.y103();
            var action = FavoritesViewModel$observeLanguage$slambda$slambda_0(this.p123_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FavoritesViewModel$observeLanguage$slambda).q24 = function ($this$launch, completion) {
    var i = new FavoritesViewModel$observeLanguage$slambda(this.p123_1, completion);
    i.q123_1 = $this$launch;
    return i;
  };
  function FavoritesViewModel$observeLanguage$slambda_0(this$0, resultContinuation) {
    var i = new FavoritesViewModel$observeLanguage$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function FavoritesViewModel$observeFavorites$slambda(this$0, resultContinuation) {
    this.z123_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FavoritesViewModel$observeFavorites$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FavoritesViewModel$observeFavorites$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FavoritesViewModel$observeFavorites$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.z123_1.x10k(FavoritesViewModel$observeFavorites$slambda$lambda);
            this.n9_1 = 1;
            var tmp_0 = this.z123_1.d123_1.ynu();
            suspendResult = collectLatest(tmp_0, FavoritesViewModel$observeFavorites$slambda$slambda_0(this.z123_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FavoritesViewModel$observeFavorites$slambda).q24 = function ($this$launch, completion) {
    var i = new FavoritesViewModel$observeFavorites$slambda(this.z123_1, completion);
    i.a124_1 = $this$launch;
    return i;
  };
  function FavoritesViewModel$observeFavorites$slambda_0(this$0, resultContinuation) {
    var i = new FavoritesViewModel$observeFavorites$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function $handleIntentCOROUTINE$_6(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j124_1 = _this__u8e3s4;
    this.k124_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_6).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_subject = this.k124_1;
            if (equals(tmp0_subject, LoadFavorites_instance)) {
              observeFavorites(this.j124_1);
              this.n9_1 = 2;
              continue $sm;
            } else {
              if (tmp0_subject instanceof ToggleFavorite) {
                this.n9_1 = 1;
                suspendResult = this.j124_1.e123_1.vdf(this.k124_1.p121_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                noWhenBranchMatchedException();
              }
            }

            break;
          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function FavoritesViewModel(getFavoriteProductsUseCase, toggleFavoriteUseCase, syncFavoritesUseCase, getLanguageUseCase) {
    BaseMviViewModel.call(this, new FavoritesState());
    this.d123_1 = getFavoriteProductsUseCase;
    this.e123_1 = toggleFavoriteUseCase;
    this.f123_1 = syncFavoritesUseCase;
    this.g123_1 = getLanguageUseCase;
    observeFavorites(this);
    observeLanguage_3(this);
    syncFavorites(this);
  }
  protoOf(FavoritesViewModel).l124 = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_6(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FavoritesViewModel).f10l = function (intent, $completion) {
    return this.l124(isInterface(intent, FavoritesIntent) ? intent : THROW_CCE(), $completion);
  };
  function AddEditFriendDialog(friend, isProcessing, language, onDismiss, onConfirm, $composer, $changed, $default) {
    var friend_0 = {_v: friend};
    var language_0 = {_v: language};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1405566355);
    sourceInformation($composer_0, 'C(AddEditFriendDialog)P(!3,4)63@2766L47,64@2838L55,65@2913L49,66@2979L52,67@3057L62,68@3141L58,69@3229L51,70@3302L46,71@3379L46,73@3453L42,74@3522L70,76@3644L261,76@3616L289,252@11650L1875,292@13551L152,105@4581L215,112@4813L6811,103@4514L9190:FriendComponents.kt#7dj0rb');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(friend_0._v) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isProcessing) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(language_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismiss) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onConfirm) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        friend_0._v = null;
      }
      if (!(($default & 4) === 0)) {
        language_0._v = 'en';
      }
      if (isTraceInProgress()) {
        traceEventStart(1405566355, $dirty, -1, 'client.fstech.hadaya.presentation.friends.AddEditFriendDialog (FriendComponents.kt:62)');
      }
      sourceInformationMarkerStart($composer_0, 2129542722, 'CC(remember):FriendComponents.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var tmp0_safe_receiver = friend_0._v;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vz7_1;
        var value = mutableStateOf(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var name$delegate = tmp0_group;
      sourceInformationMarkerStart($composer_0, 2129545034, 'CC(remember):FriendComponents.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var tmp0_safe_receiver_0 = friend_0._v;
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.wz7_1;
        var value_0 = mutableStateOf(tmp1_elvis_lhs_0 == null ? '' : tmp1_elvis_lhs_0);
        this_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      var relationship$delegate = tmp1_group;
      sourceInformationMarkerStart($composer_0, 2129547428, 'CC(remember):FriendComponents.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_2.i31();
      var tmp_1;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var tmp0_safe_receiver_1 = friend_0._v;
        var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.yz7_1;
        var value_1 = mutableStateOf(tmp1_elvis_lhs_1 == null ? '' : tmp1_elvis_lhs_1);
        this_2.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp2_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var address$delegate = tmp2_group;
      sourceInformationMarkerStart($composer_0, 2129549543, 'CC(remember):FriendComponents.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_2 = this_3.i31();
      var tmp_2;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var tmp0_safe_receiver_2 = friend_0._v;
        var tmp1_elvis_lhs_2 = tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.az8_1;
        var value_2 = mutableStateOf(tmp1_elvis_lhs_2 == null ? 'Other' : tmp1_elvis_lhs_2);
        this_3.j31(value_2);
        tmp_2 = value_2;
      } else {
        tmp_2 = it_2;
      }
      var tmp3_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      var city$delegate = tmp3_group;
      sourceInformationMarkerStart($composer_0, 2129552049, 'CC(remember):FriendComponents.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_4 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_3 = this_4.i31();
      var tmp_3;
      if (false || it_3 === Companion_getInstance().f30_1) {
        var tmp0_safe_receiver_3 = friend_0._v;
        var tmp1_elvis_lhs_3 = tmp0_safe_receiver_3 == null ? null : tmp0_safe_receiver_3.cz8_1;
        var value_3 = mutableStateOf(tmp1_elvis_lhs_3 == null ? '' : tmp1_elvis_lhs_3);
        this_4.j31(value_3);
        tmp_3 = value_3;
      } else {
        tmp_3 = it_3;
      }
      var tmp4_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      var personalPhone$delegate = tmp4_group;
      sourceInformationMarkerStart($composer_0, 2129554733, 'CC(remember):FriendComponents.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_5 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_4 = this_5.i31();
      var tmp_4;
      if (false || it_4 === Companion_getInstance().f30_1) {
        var tmp0_safe_receiver_4 = friend_0._v;
        var tmp1_elvis_lhs_4 = tmp0_safe_receiver_4 == null ? null : tmp0_safe_receiver_4.dz8_1;
        var value_4 = mutableStateOf(tmp1_elvis_lhs_4 == null ? '' : tmp1_elvis_lhs_4);
        this_5.j31(value_4);
        tmp_4 = value_4;
      } else {
        tmp_4 = it_4;
      }
      var tmp5_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      var workPhone$delegate = tmp5_group;
      sourceInformationMarkerStart($composer_0, 2129557542, 'CC(remember):FriendComponents.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_6 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_5 = this_6.i31();
      var tmp_5;
      if (false || it_5 === Companion_getInstance().f30_1) {
        var tmp0_safe_receiver_5 = friend_0._v;
        var value_5 = mutableStateOf(tmp0_safe_receiver_5 == null ? null : tmp0_safe_receiver_5.ez8_1);
        this_6.j31(value_5);
        tmp_5 = value_5;
      } else {
        tmp_5 = it_5;
      }
      var tmp6_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      var birthdayTimestamp$delegate = tmp6_group;
      sourceInformationMarkerStart($composer_0, 2129559873, 'CC(remember):FriendComponents.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_7 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_6 = this_7.i31();
      var tmp_6;
      if (false || it_6 === Companion_getInstance().f30_1) {
        var tmp0_safe_receiver_6 = friend_0._v;
        var value_6 = mutableStateOf(tmp0_safe_receiver_6 == null ? null : tmp0_safe_receiver_6.fz8_1);
        this_7.j31(value_6);
        tmp_6 = value_6;
      } else {
        tmp_6 = it_6;
      }
      var tmp7_group = tmp_6;
      sourceInformationMarkerEnd($composer_0);
      var avatarUrl$delegate = tmp7_group;
      sourceInformationMarkerStart($composer_0, 2129562337, 'CC(remember):FriendComponents.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_8 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_7 = this_8.i31();
      var tmp_7;
      if (false || it_7 === Companion_getInstance().f30_1) {
        var value_7 = mutableStateOf(null);
        this_8.j31(value_7);
        tmp_7 = value_7;
      } else {
        tmp_7 = it_7;
      }
      var tmp8_group = tmp_7;
      sourceInformationMarkerEnd($composer_0);
      var selectedImageBytes$delegate = tmp8_group;
      sourceInformationMarkerStart($composer_0, 2129564701, 'CC(remember):FriendComponents.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_9 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_8 = this_9.i31();
      var tmp_8;
      if (false || it_8 === Companion_getInstance().f30_1) {
        var value_8 = mutableStateOf(false);
        this_9.j31(value_8);
        tmp_8 = value_8;
      } else {
        tmp_8 = it_8;
      }
      var tmp9_group = tmp_8;
      sourceInformationMarkerEnd($composer_0);
      var showDatePicker$delegate = tmp9_group;
      var tmp_9 = AddEditFriendDialog$lambda_11(birthdayTimestamp$delegate);
      var tmp_10 = _DisplayMode___init__impl__gfd230(0);
      var datePickerState = rememberDatePickerState(tmp_9, null, null, tmp_10, null, $composer_0, 0, 30);
      sourceInformationMarkerStart($composer_0, 2129571032, 'CC(remember):FriendComponents.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_10 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_9 = this_10.i31();
      var tmp_11;
      if (false || it_9 === Companion_getInstance().f30_1) {
        var value_9 = AddEditFriendDialog$lambda_19(selectedImageBytes$delegate, avatarUrl$delegate);
        this_10.j31(value_9);
        tmp_11 = value_9;
      } else {
        tmp_11 = it_9;
      }
      var tmp10_group = tmp_11;
      sourceInformationMarkerEnd($composer_0);
      var imagePicker = rememberImagePickerLauncher_0(tmp10_group, $composer_0, 6);
      if (AddEditFriendDialog$lambda_17(showDatePicker$delegate)) {
        $composer_0.m30(1592487054);
        sourceInformation($composer_0, '85@3977L3,85@3998L281,94@4297L144,98@4443L59,85@3941L561');
        sourceInformationMarkerStart($composer_0, 2129581430, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_11 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_10 = this_11.i31();
        var tmp_12;
        if (false || it_10 === Companion_getInstance().f30_1) {
          var value_10 = AddEditFriendDialog$lambda_20;
          this_11.j31(value_10);
          tmp_12 = value_10;
        } else {
          tmp_12 = it_10;
        }
        var tmp11_group = tmp_12;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(401849856, true, AddEditFriendDialog$lambda_21(datePickerState, birthdayTimestamp$delegate, showDatePicker$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_11 = $composer_1.i31();
        var tmp_13;
        if (invalid || it_11 === Companion_getInstance().f30_1) {
          var value_11 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value_11);
          tmp_13 = value_11;
        } else {
          tmp_13 = it_11;
        }
        var tmp_14 = tmp_13;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(421390978, true, AddEditFriendDialog$lambda_22(showDatePicker$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_2.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_12 = $composer_2.i31();
        var tmp_15;
        if (invalid_0 || it_12 === Companion_getInstance().f30_1) {
          var value_12 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_2.j31(value_12);
          tmp_15 = value_12;
        } else {
          tmp_15 = it_12;
        }
        var tmp_16 = tmp_15;
        var tmp_17 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(1326054743, true, AddEditFriendDialog$lambda_23(datePickerState), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_3.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_13 = $composer_3.i31();
        var tmp_18;
        if (invalid_1 || it_13 === Companion_getInstance().f30_1) {
          var value_13 = ComposableLambda$invoke$ref_6(dispatchReceiver_1);
          $composer_3.j31(value_13);
          tmp_18 = value_13;
        } else {
          tmp_18 = it_13;
        }
        var tmp$ret$62 = tmp_18;
        DatePickerDialog(tmp11_group, tmp_14, null, tmp_16, null, tmp_17, null, null, tmp$ret$62, $composer_0, 100666422, 244);
        $composer_0.n30();
      } else {
        $composer_0.m30(1593041551);
        $composer_0.n30();
      }
      // Inline function 'kotlin.run' call
      var dispatchReceiver_2 = rememberComposableLambda(2044905035, true, AddEditFriendDialog$lambda_24(friend_0, onConfirm, isProcessing, personalPhone$delegate, workPhone$delegate, name$delegate, address$delegate, relationship$delegate, city$delegate, birthdayTimestamp$delegate, avatarUrl$delegate, selectedImageBytes$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_4 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = $composer_4.k31(dispatchReceiver_2);
      // Inline function 'kotlin.let' call
      var it_14 = $composer_4.i31();
      var tmp_19;
      if (invalid_2 || it_14 === Companion_getInstance().f30_1) {
        var value_14 = ComposableLambda$invoke$ref(dispatchReceiver_2);
        $composer_4.j31(value_14);
        tmp_19 = value_14;
      } else {
        tmp_19 = it_14;
      }
      var tmp_20 = tmp_19;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_3 = rememberComposableLambda(1258907145, true, AddEditFriendDialog$lambda_25(onDismiss, isProcessing), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_5 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = $composer_5.k31(dispatchReceiver_3);
      // Inline function 'kotlin.let' call
      var it_15 = $composer_5.i31();
      var tmp_21;
      if (invalid_3 || it_15 === Companion_getInstance().f30_1) {
        var value_15 = ComposableLambda$invoke$ref(dispatchReceiver_3);
        $composer_5.j31(value_15);
        tmp_21 = value_15;
      } else {
        tmp_21 = it_15;
      }
      var tmp_22 = tmp_21;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_4 = rememberComposableLambda(472909255, true, AddEditFriendDialog$lambda_26(friend_0), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_6 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_4 = $composer_6.k31(dispatchReceiver_4);
      // Inline function 'kotlin.let' call
      var it_16 = $composer_6.i31();
      var tmp_23;
      if (invalid_4 || it_16 === Companion_getInstance().f30_1) {
        var value_16 = ComposableLambda$invoke$ref(dispatchReceiver_4);
        $composer_6.j31(value_16);
        tmp_23 = value_16;
      } else {
        tmp_23 = it_16;
      }
      var tmp_24 = tmp_23;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_5 = rememberComposableLambda(79910310, true, AddEditFriendDialog$lambda_27(imagePicker, language_0, selectedImageBytes$delegate, avatarUrl$delegate, name$delegate, relationship$delegate, address$delegate, city$delegate, birthdayTimestamp$delegate, showDatePicker$delegate, personalPhone$delegate, workPhone$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_7 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_5 = $composer_7.k31(dispatchReceiver_5);
      // Inline function 'kotlin.let' call
      var it_17 = $composer_7.i31();
      var tmp_25;
      if (invalid_5 || it_17 === Companion_getInstance().f30_1) {
        var value_17 = ComposableLambda$invoke$ref(dispatchReceiver_5);
        $composer_7.j31(value_17);
        tmp_25 = value_17;
      } else {
        tmp_25 = it_17;
      }
      var tmp_26 = tmp_25;
      var tmp_27 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_28 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_29 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_30 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_31 = _Dp___init__impl__ms3zkb(0.0);
      AlertDialog(onDismiss, tmp_20, null, tmp_22, null, tmp_24, tmp_26, null, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, null, $composer_0, 1772592 | 14 & $dirty >> 9, 0, 16276);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp12_safe_receiver = $composer_0.t30();
    if (tmp12_safe_receiver == null)
      null;
    else {
      tmp12_safe_receiver.p3c(AddEditFriendDialog$lambda_28(friend_0, isProcessing, language_0, onDismiss, onConfirm, $changed, $default));
    }
  }
  function formatTimestamp(timestamp) {
    var tmp;
    try {
      var instant = Companion_getInstance_19().kf(timestamp);
      var dateTime = toLocalDateTime(instant, Companion_getInstance_20().unp());
      var tmp_0 = dateTime.qn7();
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.text.replaceFirstChar' call
      var this_0 = dateTime.an8().z_1.toLowerCase();
      var tmp_1;
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_0) > 0) {
        // Inline function 'kotlin.text.uppercase' call
        var this_1 = charCodeAt(this_0, 0);
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$4 = toString_1(this_1).toUpperCase();
        tmp_1 = toString(tmp$ret$4) + substring(this_0, 1);
      } else {
        tmp_1 = this_0;
      }
      tmp = '' + tmp_0 + ' ' + tmp_1 + ' ' + dateTime.wn7();
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Exception) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = 'N/A';
      } else {
        throw $p;
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function ComposableSingletons$FriendComponentsKt$lambda$1764683453$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C92@4225L29,92@4220L35:FriendComponents.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1764683453, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendComponentsKt.lambda$1764683453.<anonymous> (FriendComponents.kt:92)');
      }
      var tmp = stringResource(get_ok(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendComponentsKt$lambda$1784224575$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C96@4383L33,96@4378L39:FriendComponents.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1784224575, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendComponentsKt.lambda$1784224575.<anonymous> (FriendComponents.kt:96)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendComponentsKt$lambda$1244426988$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C294@13645L33,294@13640L39:FriendComponents.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1244426988, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendComponentsKt.lambda$1244426988.<anonymous> (FriendComponents.kt:294)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendComponentsKt$lambda$388632867$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C183@8342L46,183@8337L52:FriendComponents.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(388632867, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendComponentsKt.lambda$388632867.<anonymous> (FriendComponents.kt:183)');
      }
      var tmp = stringResource(get_name_label_required(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendComponentsKt$lambda$_58091508$lambda_eb93jp($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C187@8570L45,187@8565L51:FriendComponents.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-58091508, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendComponentsKt.lambda$-58091508.<anonymous> (FriendComponents.kt:187)');
      }
      var tmp = stringResource(get_relationship_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendComponentsKt$lambda$1113117163$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C191@8787L49,191@8782L55:FriendComponents.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1113117163, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendComponentsKt.lambda$1113117163.<anonymous> (FriendComponents.kt:191)');
      }
      var tmp = stringResource(get_address_label_required(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendComponentsKt$lambda$_327918343$lambda_q5k6hj($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C207@9463L41,207@9458L47:FriendComponents.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-327918343, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendComponentsKt.lambda$-327918343.<anonymous> (FriendComponents.kt:207)');
      }
      var tmp = stringResource(get_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendComponentsKt$lambda$_1992496422$lambda_yjhhup($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C214@9889L45,212@9761L207:FriendComponents.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1992496422, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendComponentsKt.lambda$-1992496422.<anonymous> (FriendComponents.kt:212)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_pick_birthday_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendComponentsKt$lambda$_2010641462$lambda_vsubah($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C230@10636L56,230@10631L62:FriendComponents.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2010641462, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendComponentsKt.lambda$-2010641462.<anonymous> (FriendComponents.kt:230)');
      }
      var tmp = stringResource(get_phone_personal_label_required(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendComponentsKt$lambda$1547725865$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C233@10845L47,233@10840L53:FriendComponents.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1547725865, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendComponentsKt.lambda$1547725865.<anonymous> (FriendComponents.kt:233)');
      }
      var tmp = stringResource(get_invalid_phone_format(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendComponentsKt$lambda$_839432791$lambda_2e7atj($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C244@11312L43,244@11307L49:FriendComponents.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-839432791, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendComponentsKt.lambda$-839432791.<anonymous> (FriendComponents.kt:244)');
      }
      var tmp = stringResource(get_phone_work_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendComponentsKt$lambda$_1576032760$lambda_3i5txe($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C247@11500L47,247@11495L53:FriendComponents.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1576032760, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendComponentsKt.lambda$-1576032760.<anonymous> (FriendComponents.kt:247)');
      }
      var tmp = stringResource(get_invalid_phone_format(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendComponentsKt() {
    ComposableSingletons$FriendComponentsKt_instance = this;
    var tmp = this;
    tmp.m124_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1764683453, false, ComposableSingletons$FriendComponentsKt$lambda$1764683453$lambda));
    var tmp_0 = this;
    tmp_0.n124_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1784224575, false, ComposableSingletons$FriendComponentsKt$lambda$1784224575$lambda));
    var tmp_1 = this;
    tmp_1.o124_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1244426988, false, ComposableSingletons$FriendComponentsKt$lambda$1244426988$lambda));
    var tmp_2 = this;
    tmp_2.p124_1 = ComposableLambda$invoke$ref(composableLambdaInstance(388632867, false, ComposableSingletons$FriendComponentsKt$lambda$388632867$lambda));
    var tmp_3 = this;
    tmp_3.q124_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-58091508, false, ComposableSingletons$FriendComponentsKt$lambda$_58091508$lambda_eb93jp));
    var tmp_4 = this;
    tmp_4.r124_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1113117163, false, ComposableSingletons$FriendComponentsKt$lambda$1113117163$lambda));
    var tmp_5 = this;
    tmp_5.s124_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-327918343, false, ComposableSingletons$FriendComponentsKt$lambda$_327918343$lambda_q5k6hj));
    var tmp_6 = this;
    tmp_6.t124_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1992496422, false, ComposableSingletons$FriendComponentsKt$lambda$_1992496422$lambda_yjhhup));
    var tmp_7 = this;
    tmp_7.u124_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-2010641462, false, ComposableSingletons$FriendComponentsKt$lambda$_2010641462$lambda_vsubah));
    var tmp_8 = this;
    tmp_8.v124_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1547725865, false, ComposableSingletons$FriendComponentsKt$lambda$1547725865$lambda));
    var tmp_9 = this;
    tmp_9.w124_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-839432791, false, ComposableSingletons$FriendComponentsKt$lambda$_839432791$lambda_2e7atj));
    var tmp_10 = this;
    tmp_10.x124_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1576032760, false, ComposableSingletons$FriendComponentsKt$lambda$_1576032760$lambda_3i5txe));
  }
  var ComposableSingletons$FriendComponentsKt_instance;
  function ComposableSingletons$FriendComponentsKt_getInstance() {
    if (ComposableSingletons$FriendComponentsKt_instance == null)
      new ComposableSingletons$FriendComponentsKt();
    return ComposableSingletons$FriendComponentsKt_instance;
  }
  function CustomOutlinedTextField(value, onValueChange, label, modifier, maxLines, isError, supportingText, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var maxLines_0 = {_v: maxLines};
    var isError_0 = {_v: isError};
    var supportingText_0 = {_v: supportingText};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-713802333);
    sourceInformation($composer_0, 'C(CustomOutlinedTextField)P(6,4,1,3,2)309@13989L285:FriendComponents.kt#7dj0rb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(value) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onValueChange) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(label) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.m31(maxLines_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.l31(isError_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(supportingText_0._v) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 599187) === 599186), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (!(($default & 16) === 0)) {
        maxLines_0._v = 1;
      }
      if (!(($default & 32) === 0)) {
        isError_0._v = false;
      }
      if (!(($default & 64) === 0)) {
        supportingText_0._v = null;
      }
      if (isTraceInProgress()) {
        traceEventStart(-713802333, $dirty, -1, 'client.fstech.hadaya.presentation.friends.CustomOutlinedTextField (FriendComponents.kt:308)');
      }
      var tmp0_modifier = fillMaxWidth(modifier_0._v);
      var tmp1_singleLine = maxLines_0._v === 1;
      var tmp = supportingText_0._v;
      var tmp_0 = isError_0._v;
      var tmp_1 = maxLines_0._v;
      OutlinedTextField(value, onValueChange, tmp0_modifier, false, false, null, label, null, null, null, null, null, tmp, tmp_0, null, null, null, tmp1_singleLine, tmp_1, 0, null, null, null, $composer_0, 14 & $dirty | 112 & $dirty | 3670016 & $dirty << 12, 896 & $dirty >> 12 | 7168 & $dirty >> 6 | 234881024 & $dirty << 12, 0, 7983032);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(CustomOutlinedTextField$lambda(value, onValueChange, label, modifier_0, maxLines_0, isError_0, supportingText_0, $changed, $default));
    }
  }
  function AddEditFriendDialog$lambda($name$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('name', KMutableProperty0, true);
    return $name$delegate.u1();
  }
  function AddEditFriendDialog$lambda_0($name$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('name', KMutableProperty0, true);
    $name$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function AddEditFriendDialog$lambda_1($relationship$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('relationship', KMutableProperty0, true);
    return $relationship$delegate.u1();
  }
  function AddEditFriendDialog$lambda_2($relationship$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('relationship', KMutableProperty0, true);
    $relationship$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function AddEditFriendDialog$lambda_3($address$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('address', KMutableProperty0, true);
    return $address$delegate.u1();
  }
  function AddEditFriendDialog$lambda_4($address$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('address', KMutableProperty0, true);
    $address$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function AddEditFriendDialog$lambda_5($city$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('city', KMutableProperty0, true);
    return $city$delegate.u1();
  }
  function AddEditFriendDialog$lambda_6($city$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('city', KMutableProperty0, true);
    $city$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function AddEditFriendDialog$lambda_7($personalPhone$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('personalPhone', KMutableProperty0, true);
    return $personalPhone$delegate.u1();
  }
  function AddEditFriendDialog$lambda_8($personalPhone$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('personalPhone', KMutableProperty0, true);
    $personalPhone$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function AddEditFriendDialog$lambda_9($workPhone$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('workPhone', KMutableProperty0, true);
    return $workPhone$delegate.u1();
  }
  function AddEditFriendDialog$lambda_10($workPhone$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('workPhone', KMutableProperty0, true);
    $workPhone$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function AddEditFriendDialog$lambda_11($birthdayTimestamp$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('birthdayTimestamp', KMutableProperty0, true);
    return $birthdayTimestamp$delegate.u1();
  }
  function AddEditFriendDialog$lambda_12($birthdayTimestamp$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('birthdayTimestamp', KMutableProperty0, true);
    $birthdayTimestamp$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function AddEditFriendDialog$lambda_13($avatarUrl$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('avatarUrl', KMutableProperty0, true);
    return $avatarUrl$delegate.u1();
  }
  function AddEditFriendDialog$lambda_14($avatarUrl$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('avatarUrl', KMutableProperty0, true);
    $avatarUrl$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function AddEditFriendDialog$lambda_15($selectedImageBytes$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('selectedImageBytes', KMutableProperty0, true);
    return $selectedImageBytes$delegate.u1();
  }
  function AddEditFriendDialog$lambda_16($selectedImageBytes$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('selectedImageBytes', KMutableProperty0, true);
    $selectedImageBytes$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function AddEditFriendDialog$lambda_17($showDatePicker$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDatePicker', KMutableProperty0, true);
    return $showDatePicker$delegate.u1();
  }
  function AddEditFriendDialog$lambda_18($showDatePicker$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDatePicker', KMutableProperty0, true);
    $showDatePicker$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function AddEditFriendDialog$lambda_19($selectedImageBytes$delegate, $avatarUrl$delegate) {
    return function (bytes) {
      var tmp;
      if (!(bytes == null)) {
        AddEditFriendDialog$lambda_16($selectedImageBytes$delegate, bytes);
        AddEditFriendDialog$lambda_14($avatarUrl$delegate, null);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda_20() {
    return Unit_instance;
  }
  function AddEditFriendDialog$lambda$lambda($datePickerState, $birthdayTimestamp$delegate, $showDatePicker$delegate) {
    return function () {
      AddEditFriendDialog$lambda_12($birthdayTimestamp$delegate, $datePickerState.np1());
      AddEditFriendDialog$lambda_18($showDatePicker$delegate, false);
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda_21($datePickerState, $birthdayTimestamp$delegate, $showDatePicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C87@4050L137,86@4012L257:FriendComponents.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(401849856, $changed, -1, 'client.fstech.hadaya.presentation.friends.AddEditFriendDialog.<anonymous> (FriendComponents.kt:86)');
        }
        sourceInformationMarkerStart($composer_0, -369343223, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($datePickerState);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = AddEditFriendDialog$lambda$lambda($datePickerState, $birthdayTimestamp$delegate, $showDatePicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$FriendComponentsKt_getInstance().m124_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_0($showDatePicker$delegate) {
    return function () {
      AddEditFriendDialog$lambda_18($showDatePicker$delegate, false);
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda_22($showDatePicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C95@4332L26,95@4311L120:FriendComponents.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(421390978, $changed, -1, 'client.fstech.hadaya.presentation.friends.AddEditFriendDialog.<anonymous> (FriendComponents.kt:95)');
        }
        sourceInformationMarkerStart($composer_0, 1229805180, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = AddEditFriendDialog$lambda$lambda_0($showDatePicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$FriendComponentsKt_getInstance().n124_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda_23($datePickerState) {
    return function ($this$DatePickerDialog, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C99@4457L35:FriendComponents.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1326054743, $changed, -1, 'client.fstech.hadaya.presentation.friends.AddEditFriendDialog.<anonymous> (FriendComponents.kt:99)');
        }
        DatePicker($datePickerState, null, null, null, null, null, false, null, $composer_0, 0, 254);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_1($friend, $onConfirm, $personalPhone$delegate, $workPhone$delegate, $name$delegate, $address$delegate, $relationship$delegate, $city$delegate, $birthdayTimestamp$delegate, $avatarUrl$delegate, $selectedImageBytes$delegate) {
    return function () {
      var isPersonalValid = isBlank(AddEditFriendDialog$lambda_7($personalPhone$delegate)) || isValidEgyptianMobile(AddEditFriendDialog$lambda_7($personalPhone$delegate));
      var isWorkValid = isBlank(AddEditFriendDialog$lambda_9($workPhone$delegate)) || isValidEgyptianWorkPhone(AddEditFriendDialog$lambda_9($workPhone$delegate));
      var tmp;
      var tmp_0;
      var tmp_1;
      var tmp_2;
      var tmp_3;
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = AddEditFriendDialog$lambda($name$delegate);
      if (!isBlank(this_0)) {
        // Inline function 'kotlin.text.isNotBlank' call
        var this_1 = AddEditFriendDialog$lambda_3($address$delegate);
        tmp_3 = !isBlank(this_1);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        // Inline function 'kotlin.text.isNotBlank' call
        var this_2 = AddEditFriendDialog$lambda_7($personalPhone$delegate);
        tmp_2 = !isBlank(this_2);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = isPersonalValid;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = isWorkValid;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var tmp0_elvis_lhs = $friend._v;
        var resultFriend = (tmp0_elvis_lhs == null ? new Friend(VOID, '', '', null, VOID, VOID, VOID, VOID, VOID, '') : tmp0_elvis_lhs).gz8(VOID, VOID, AddEditFriendDialog$lambda($name$delegate), AddEditFriendDialog$lambda_1($relationship$delegate), VOID, AddEditFriendDialog$lambda_3($address$delegate), VOID, AddEditFriendDialog$lambda_5($city$delegate), VOID, AddEditFriendDialog$lambda_7($personalPhone$delegate), AddEditFriendDialog$lambda_9($workPhone$delegate), AddEditFriendDialog$lambda_11($birthdayTimestamp$delegate), AddEditFriendDialog$lambda_13($avatarUrl$delegate));
        tmp = $onConfirm(resultFriend, AddEditFriendDialog$lambda_15($selectedImageBytes$delegate));
      }
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_2($isProcessing, $friend) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:FriendComponents.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-812483493, $changed, -1, 'client.fstech.hadaya.presentation.friends.AddEditFriendDialog.<anonymous>.<anonymous> (FriendComponents.kt:285)');
        }
        if ($isProcessing) {
          $composer_0.m30(1739979696);
          sourceInformation($composer_0, '286@13265L79');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          var tmp_2 = Companion_getInstance_14().m6b_1;
          var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_0, 54, 60);
          $composer_0.n30();
        } else {
          $composer_0.m30(1740104130);
          sourceInformation($composer_0, '288@13390L93');
          var tmp_6;
          if ($friend._v == null) {
            $composer_0.m30(887417785);
            sourceInformation($composer_0, '288@13415L30');
            var tmp0_group = stringResource(get_add(string_instance), $composer_0, 0);
            $composer_0.n30();
            tmp_6 = tmp0_group;
          } else {
            $composer_0.m30(887418938);
            sourceInformation($composer_0, '288@13451L31');
            var tmp1_group = stringResource(get_save(string_instance), $composer_0, 0);
            $composer_0.n30();
            tmp_6 = tmp1_group;
          }
          var tmp_7 = tmp_6;
          var tmp_8 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_12 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_7, null, tmp_8, null, tmp_9, null, null, null, tmp_10, null, null, tmp_11, tmp_12, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
          $composer_0.n30();
        }
        var tmp_13;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_13 = Unit_instance;
        }
        tmp = tmp_13;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda_24($friend, $onConfirm, $isProcessing, $personalPhone$delegate, $workPhone$delegate, $name$delegate, $address$delegate, $relationship$delegate, $city$delegate, $birthdayTimestamp$delegate, $avatarUrl$delegate, $selectedImageBytes$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C254@11698L1378,284@13207L308,253@11664L1851:FriendComponents.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2044905035, $changed, -1, 'client.fstech.hadaya.presentation.friends.AddEditFriendDialog.<anonymous> (FriendComponents.kt:253)');
        }
        sourceInformationMarkerStart($composer_0, -1941280019, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.k31($friend._v) | $composer_0.k31($onConfirm));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = AddEditFriendDialog$lambda$lambda_1($friend, $onConfirm, $personalPhone$delegate, $workPhone$delegate, $name$delegate, $address$delegate, $relationship$delegate, $city$delegate, $birthdayTimestamp$delegate, $avatarUrl$delegate, $selectedImageBytes$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1;
        var tmp_2;
        var tmp_3;
        if (!$isProcessing) {
          // Inline function 'kotlin.text.isNotBlank' call
          var this_0 = AddEditFriendDialog$lambda($name$delegate);
          tmp_3 = !isBlank(this_0);
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          // Inline function 'kotlin.text.isNotBlank' call
          var this_1 = AddEditFriendDialog$lambda_3($address$delegate);
          tmp_2 = !isBlank(this_1);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          // Inline function 'kotlin.text.isNotBlank' call
          var this_2 = AddEditFriendDialog$lambda_7($personalPhone$delegate);
          tmp_1 = !isBlank(this_2);
        } else {
          tmp_1 = false;
        }
        var tmp_4 = tmp_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-812483493, true, AddEditFriendDialog$lambda$lambda_2($isProcessing, $friend), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_5;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_5 = value_0;
        } else {
          tmp_5 = it_0;
        }
        var tmp$ret$7 = tmp_5;
        Button(tmp0_group, null, tmp_4, null, null, null, null, null, null, tmp$ret$7, $composer_0, 805306368, 506);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda_25($onDismiss, $isProcessing) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C293@13565L128:FriendComponents.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1258907145, $changed, -1, 'client.fstech.hadaya.presentation.friends.AddEditFriendDialog.<anonymous> (FriendComponents.kt:293)');
        }
        var tmp_0 = !$isProcessing;
        TextButton($onDismiss, null, tmp_0, null, null, null, null, null, null, ComposableSingletons$FriendComponentsKt_getInstance().o124_1, $composer_0, 805306368, 506);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda_26($friend) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C106@4595L191:FriendComponents.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(472909255, $changed, -1, 'client.fstech.hadaya.presentation.friends.AddEditFriendDialog.<anonymous> (FriendComponents.kt:106)');
        }
        var tmp_0;
        if ($friend._v == null) {
          $composer_0.m30(-800737482);
          sourceInformation($composer_0, '107@4637L47');
          var tmp0_group = stringResource(get_add_new_friend_title(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp0_group;
        } else {
          $composer_0.m30(-800735751);
          sourceInformation($composer_0, '107@4690L82');
          var tmp1_group = stringResource(get_edit_friend_title(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp1_group;
        }
        var tmp_1 = tmp_0;
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_3($imagePicker) {
    return function () {
      $imagePicker.g11s();
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_4($imagePicker) {
    return function () {
      $imagePicker.g11s();
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_5($name$delegate) {
    return function (it) {
      AddEditFriendDialog$lambda_0($name$delegate, it);
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_6($relationship$delegate) {
    return function (it) {
      AddEditFriendDialog$lambda_2($relationship$delegate, it);
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_7($address$delegate) {
    return function (it) {
      AddEditFriendDialog$lambda_4($address$delegate, it);
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_8($city$delegate) {
    return function (it) {
      AddEditFriendDialog$lambda_6($city$delegate, it);
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_9(it) {
    return Unit_instance;
  }
  function AddEditFriendDialog$lambda$lambda$lambda($showDatePicker$delegate) {
    return function () {
      AddEditFriendDialog$lambda_18($showDatePicker$delegate, true);
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_10($showDatePicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C211@9700L25,211@9679L319:FriendComponents.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1651702972, $changed, -1, 'client.fstech.hadaya.presentation.friends.AddEditFriendDialog.<anonymous>.<anonymous>.<anonymous>.<anonymous> (FriendComponents.kt:211)');
        }
        sourceInformationMarkerStart($composer_0, -1851341771, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = AddEditFriendDialog$lambda$lambda$lambda($showDatePicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$FriendComponentsKt_getInstance().t124_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_11($showDatePicker$delegate) {
    return function () {
      AddEditFriendDialog$lambda_18($showDatePicker$delegate, true);
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_12($personalPhone$delegate) {
    return function (it) {
      AddEditFriendDialog$lambda_8($personalPhone$delegate, it);
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda$lambda_13($workPhone$delegate) {
    return function (it) {
      AddEditFriendDialog$lambda_10($workPhone$delegate, it);
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda_27($imagePicker, $language, $selectedImageBytes$delegate, $avatarUrl$delegate, $name$delegate, $relationship$delegate, $address$delegate, $city$delegate, $birthdayTimestamp$delegate, $showDatePicker$delegate, $personalPhone$delegate, $workPhone$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C114@4901L21,113@4827L6787:FriendComponents.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(79910310, $changed, -1, 'client.fstech.hadaya.presentation.friends.AddEditFriendDialog.<anonymous> (FriendComponents.kt:113)');
        }
        var tmp_0 = fillMaxWidth(Companion_instance);
        var tmp0 = verticalScroll(tmp_0, rememberScrollState(0, $composer_0, 0, 1));
        var tmp_1 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = tmp0;
        var verticalArrangement = tmp_1.mdq(tmp$ret$0);
        var horizontalAlignment = Companion_getInstance_11().x8t_1;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((0 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_2 = $composer_3.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0_0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -1973827794, 'C119@5131L3048,182@8292L13,180@8197L195,186@8512L21,184@8409L210,190@8734L16,188@8636L204,196@9012L13,193@8858L241,203@9250L1002,229@10577L22,227@10473L472,243@11257L18,241@11157L443:FriendComponents.kt#7dj0rb');
        var tmp_3 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(100);
        var tmp_4 = size(tmp_3, tmp$ret$7);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = padding_0(tmp_4, tmp$ret$8);
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_5;
        if (!((4 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_5 = $composer_8.g30();
        if (!isInterface(tmp_5, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_1);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 138046398, 'C129@5543L11,130@5610L24,125@5350L1868,166@7487L11,168@7615L24,161@7240L921:FriendComponents.kt#7dj0rb');
        var tmp_6 = background(clip(fillMaxSize(Companion_instance), get_CircleShape()), MaterialTheme_instance.unz($composer_10, 6).oo0_1);
        sourceInformationMarkerStart($composer_10, -549730686, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_10.q31($imagePicker);
        // Inline function 'kotlin.let' call
        var it = $composer_10.i31();
        var tmp_7;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = AddEditFriendDialog$lambda$lambda_3($imagePicker);
          $composer_10.j31(value);
          tmp_7 = value;
        } else {
          tmp_7 = it;
        }
        var tmp0_group = tmp_7;
        sourceInformationMarkerEnd($composer_10);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = clickable(tmp_6, VOID, VOID, VOID, VOID, tmp0_group);
        var contentAlignment_0 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_0 = false;
        var $composer_11 = $composer_10;
        if (!((4 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_12 = $composer_11;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
        var localMap_1 = $composer_12.t31();
        var materialized_1 = materialize($composer_12, modifier_4);
        var tmp0_2 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_13 = $composer_12;
        var tmp_8 = $composer_13.g30();
        if (!isInterface(tmp_8, Applier)) {
          invalidApplier();
        }
        $composer_13.b31();
        if ($composer_13.h30()) {
          $composer_13.c31(tmp0_2);
        } else {
          $composer_13.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_14 = $composer_13;
        var $composer_15 = $composer_14;
        sourceInformationMarkerStart($composer_15, 1821796147, 'C:FriendComponents.kt#7dj0rb');
        if (!(AddEditFriendDialog$lambda_15($selectedImageBytes$delegate) == null)) {
          $composer_15.m30(1821798967);
          sourceInformation($composer_15, '134@5806L463');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_5 = fillMaxSize(Companion_instance);
          var contentAlignment_1 = null;
          var propagateMinConstraints_1 = false;
          var $composer_16 = $composer_15;
          if (!((6 & 1) === 0))
            modifier_5 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_1 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_1 = false;
          var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_6 = modifier_5;
          var $composer_17 = $composer_16;
          if (!((0 & 2) === 0))
            modifier_6 = Companion_instance;
          var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
          var localMap_2 = $composer_17.t31();
          var materialized_2 = materialize($composer_17, modifier_6);
          var tmp0_3 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_18 = $composer_17;
          var tmp_9 = $composer_18.g30();
          if (!isInterface(tmp_9, Applier)) {
            invalidApplier();
          }
          $composer_18.b31();
          if ($composer_18.h30()) {
            $composer_18.c31(tmp0_3);
          } else {
            $composer_18.d31();
          }
          var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_18);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
          var $composer_19 = $composer_18;
          var $composer_20 = $composer_19;
          sourceInformationMarkerStart($composer_20, -926007336, 'C137@6013L51,135@5879L360:FriendComponents.kt#7dj0rb');
          HadayaImage(AddEditFriendDialog$lambda_15($selectedImageBytes$delegate), stringResource(get_friend_pic_selected_desc(string_instance), $composer_20, 0), fillMaxSize(Companion_instance), Companion_getInstance_13().q96_1, $composer_20, 3456, 0);
          sourceInformationMarkerEnd($composer_20);
          $composer_18.e31();
          $composer_15.n30();
        } else {
          var tmp0_safe_receiver = AddEditFriendDialog$lambda_13($avatarUrl$delegate);
          var tmp_10;
          if (tmp0_safe_receiver == null) {
            tmp_10 = null;
          } else {
            // Inline function 'kotlin.text.isNotBlank' call
            tmp_10 = !isBlank(tmp0_safe_receiver);
          }
          if (tmp_10 === true) {
            $composer_15.m30(1822355913);
            sourceInformation($composer_15, '143@6368L445');
            // Inline function 'androidx.compose.foundation.layout.Box' call
            var modifier_7 = fillMaxSize(Companion_instance);
            var contentAlignment_2 = null;
            var propagateMinConstraints_2 = false;
            var $composer_21 = $composer_15;
            if (!((6 & 1) === 0))
              modifier_7 = Companion_instance;
            if (!((6 & 2) === 0))
              contentAlignment_2 = Companion_getInstance_11().k8t_1;
            if (!((6 & 4) === 0))
              propagateMinConstraints_2 = false;
            var measurePolicy_3 = maybeCachedBoxMeasurePolicy(contentAlignment_2, propagateMinConstraints_2);
            // Inline function 'androidx.compose.ui.layout.Layout' call
            var modifier_8 = modifier_7;
            var $composer_22 = $composer_21;
            if (!((0 & 2) === 0))
              modifier_8 = Companion_instance;
            var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_22, 0).hashCode();
            var localMap_3 = $composer_22.t31();
            var materialized_3 = materialize($composer_22, modifier_8);
            var tmp0_4 = Companion_getInstance_12().oah_1;
            // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
            var $composer_23 = $composer_22;
            var tmp_11 = $composer_23.g30();
            if (!isInterface(tmp_11, Applier)) {
              invalidApplier();
            }
            $composer_23.b31();
            if ($composer_23.h30()) {
              $composer_23.c31(tmp0_4);
            } else {
              $composer_23.d31();
            }
            var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_23);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
            Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
            var $composer_24 = $composer_23;
            var $composer_25 = $composer_24;
            sourceInformationMarkerStart($composer_25, 375786067, 'C146@6566L42,144@6441L342:FriendComponents.kt#7dj0rb');
            HadayaImage(AddEditFriendDialog$lambda_13($avatarUrl$delegate), stringResource(get_friend_pic_desc(string_instance), $composer_25, 0), fillMaxSize(Companion_instance), Companion_getInstance_13().q96_1, $composer_25, 3456, 0);
            sourceInformationMarkerEnd($composer_25);
            $composer_23.e31();
            $composer_15.n30();
          } else {
            $composer_15.m30(1822854207);
            sourceInformation($composer_15, '156@7112L11,152@6875L295');
            var tmp_12 = get_Person(Icons_getInstance().dxv_1);
            var tmp_13 = Companion_instance;
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$38 = _Dp___init__impl__ms3zkb(48);
            Icon(tmp_12, null, size(tmp_13, tmp$ret$38), MaterialTheme_instance.unz($composer_15, 6).po0_1, $composer_15, 432, 0);
            $composer_15.n30();
          }
        }
        sourceInformationMarkerEnd($composer_15);
        $composer_13.e31();
        var tmp_14 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().s8t_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$39 = _Dp___init__impl__ms3zkb(28);
        var tmp_15 = background(clip(size(tmp_14, tmp$ret$39), get_CircleShape()), MaterialTheme_instance.unz($composer_10, 6).xnz_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$40 = _Dp___init__impl__ms3zkb(1);
        var tmp_16 = border(tmp_15, tmp$ret$40, Companion_getInstance_14().m6b_1, get_CircleShape());
        sourceInformationMarkerStart($composer_10, -549666526, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_10.q31($imagePicker);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_10.i31();
        var tmp_17;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = AddEditFriendDialog$lambda$lambda_4($imagePicker);
          $composer_10.j31(value_0);
          tmp_17 = value_0;
        } else {
          tmp_17 = it_0;
        }
        var tmp1_group = tmp_17;
        sourceInformationMarkerEnd($composer_10);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_9 = clickable(tmp_16, VOID, VOID, VOID, VOID, tmp1_group);
        var contentAlignment_3 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_3 = false;
        var $composer_26 = $composer_10;
        if (!((4 & 1) === 0))
          modifier_9 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_3 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_3 = false;
        var measurePolicy_4 = maybeCachedBoxMeasurePolicy(contentAlignment_3, propagateMinConstraints_3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_10 = modifier_9;
        var $composer_27 = $composer_26;
        if (!((0 & 2) === 0))
          modifier_10 = Companion_instance;
        var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_27, 0).hashCode();
        var localMap_4 = $composer_27.t31();
        var materialized_4 = materialize($composer_27, modifier_10);
        var tmp0_5 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_28 = $composer_27;
        var tmp_18 = $composer_28.g30();
        if (!isInterface(tmp_18, Applier)) {
          invalidApplier();
        }
        $composer_28.b31();
        if ($composer_28.h30()) {
          $composer_28.c31(tmp0_5);
        } else {
          $composer_28.d31();
        }
        var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_28);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
        var $composer_29 = $composer_28;
        var $composer_30 = $composer_29;
        sourceInformationMarkerStart($composer_30, 1197154448, 'C173@7938L42,174@8031L11,171@7749L390:FriendComponents.kt#7dj0rb');
        var tmp0_imageVector = AddEditFriendDialog$lambda_13($avatarUrl$delegate) == null && AddEditFriendDialog$lambda_15($selectedImageBytes$delegate) == null ? get_CameraAlt(Icons_getInstance().dxv_1) : get_Edit(Icons_getInstance().dxv_1);
        var tmp1_contentDescription = stringResource(get_change_pic_desc(string_instance), $composer_30, 0);
        var tmp2_tint = MaterialTheme_instance.unz($composer_30, 6).ynz_1;
        var tmp_19 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$51 = _Dp___init__impl__ms3zkb(14);
        var tmp3_modifier = size(tmp_19, tmp$ret$51);
        Icon(tmp0_imageVector, tmp1_contentDescription, tmp3_modifier, tmp2_tint, $composer_30, 384, 0);
        sourceInformationMarkerEnd($composer_30);
        $composer_28.e31();
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_20 = AddEditFriendDialog$lambda($name$delegate);
        sourceInformationMarkerStart($composer_5, 1460443485, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_1 = $composer_5.i31();
        var tmp_21;
        if (false || it_1 === Companion_getInstance().f30_1) {
          var value_1 = AddEditFriendDialog$lambda$lambda_5($name$delegate);
          $composer_5.j31(value_1);
          tmp_21 = value_1;
        } else {
          tmp_21 = it_1;
        }
        var tmp0_group_0 = tmp_21;
        sourceInformationMarkerEnd($composer_5);
        var tmp_22 = ComposableSingletons$FriendComponentsKt_getInstance().p124_1;
        CustomOutlinedTextField(tmp_20, tmp0_group_0, tmp_22, null, 0, false, null, $composer_5, 432, 120);
        var tmp_23 = AddEditFriendDialog$lambda_1($relationship$delegate);
        sourceInformationMarkerStart($composer_5, 1460450533, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_2 = $composer_5.i31();
        var tmp_24;
        if (false || it_2 === Companion_getInstance().f30_1) {
          var value_2 = AddEditFriendDialog$lambda$lambda_6($relationship$delegate);
          $composer_5.j31(value_2);
          tmp_24 = value_2;
        } else {
          tmp_24 = it_2;
        }
        var tmp1_group_0 = tmp_24;
        sourceInformationMarkerEnd($composer_5);
        var tmp_25 = ComposableSingletons$FriendComponentsKt_getInstance().q124_1;
        CustomOutlinedTextField(tmp_23, tmp1_group_0, tmp_25, null, 0, false, null, $composer_5, 432, 120);
        var tmp_26 = AddEditFriendDialog$lambda_3($address$delegate);
        sourceInformationMarkerStart($composer_5, 1460457632, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_3 = $composer_5.i31();
        var tmp_27;
        if (false || it_3 === Companion_getInstance().f30_1) {
          var value_3 = AddEditFriendDialog$lambda$lambda_7($address$delegate);
          $composer_5.j31(value_3);
          tmp_27 = value_3;
        } else {
          tmp_27 = it_3;
        }
        var tmp2_group = tmp_27;
        sourceInformationMarkerEnd($composer_5);
        var tmp_28 = ComposableSingletons$FriendComponentsKt_getInstance().r124_1;
        CustomOutlinedTextField(tmp_26, tmp2_group, tmp_28, null, 0, false, null, $composer_5, 432, 120);
        var tmp_29 = AddEditFriendDialog$lambda_5($city$delegate);
        var tmp_30 = $language._v;
        sourceInformationMarkerStart($composer_5, 1460466525, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_4 = $composer_5.i31();
        var tmp_31;
        if (false || it_4 === Companion_getInstance().f30_1) {
          var value_4 = AddEditFriendDialog$lambda$lambda_8($city$delegate);
          $composer_5.j31(value_4);
          tmp_31 = value_4;
        } else {
          tmp_31 = it_4;
        }
        var tmp3_group = tmp_31;
        sourceInformationMarkerEnd($composer_5);
        GovernorateDropdown(tmp_29, tmp_30, tmp3_group, fillMaxWidth(Companion_instance), $composer_5, 3456, 0);
        var tmp0_safe_receiver_0 = AddEditFriendDialog$lambda_11($birthdayTimestamp$delegate);
        var tmp_32;
        if (tmp0_safe_receiver_0 == null) {
          tmp_32 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_32 = formatTimestamp(tmp0_safe_receiver_0);
        }
        var tmp1_elvis_lhs = tmp_32;
        var birthdayDisplay = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_11 = fillMaxWidth(Companion_instance);
        var contentAlignment_4 = null;
        var propagateMinConstraints_4 = false;
        var $composer_31 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_11 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment_4 = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints_4 = false;
        var measurePolicy_5 = maybeCachedBoxMeasurePolicy(contentAlignment_4, propagateMinConstraints_4);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_12 = modifier_11;
        var $composer_32 = $composer_31;
        if (!((0 & 2) === 0))
          modifier_12 = Companion_instance;
        var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_32, 0).hashCode();
        var localMap_5 = $composer_32.t31();
        var materialized_5 = materialize($composer_32, modifier_12);
        var tmp0_6 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_33 = $composer_32;
        var tmp_33 = $composer_33.g30();
        if (!isInterface(tmp_33, Applier)) {
          invalidApplier();
        }
        $composer_33.b31();
        if ($composer_33.h30()) {
          $composer_33.c31(tmp0_6);
        } else {
          $composer_33.d31();
        }
        var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_33);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
        var $composer_34 = $composer_33;
        var $composer_35 = $composer_34;
        sourceInformationMarkerStart($composer_35, -606861002, 'C206@9420L2,210@9649L375,204@9312L713,220@10208L25,219@10131L103:FriendComponents.kt#7dj0rb');
        var tmp0_modifier = fillMaxWidth(Companion_instance);
        sourceInformationMarkerStart($composer_35, -1682141611, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_5 = $composer_35.i31();
        var tmp_34;
        if (false || it_5 === Companion_getInstance().f30_1) {
          var value_5 = AddEditFriendDialog$lambda$lambda_9;
          $composer_35.j31(value_5);
          tmp_34 = value_5;
        } else {
          tmp_34 = it_5;
        }
        var tmp0_group_1 = tmp_34;
        sourceInformationMarkerEnd($composer_35);
        var tmp_35 = ComposableSingletons$FriendComponentsKt_getInstance().s124_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1651702972, true, AddEditFriendDialog$lambda$lambda_10($showDatePicker$delegate), $composer_35, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_36 = $composer_35;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_36.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_6 = $composer_36.i31();
        var tmp_36;
        if (invalid_1 || it_6 === Companion_getInstance().f30_1) {
          var value_6 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_36.j31(value_6);
          tmp_36 = value_6;
        } else {
          tmp_36 = it_6;
        }
        var tmp_37 = tmp_36;
        OutlinedTextField(birthdayDisplay, tmp0_group_1, tmp0_modifier, false, true, null, tmp_35, null, null, tmp_37, null, null, null, false, null, null, null, false, 0, 0, null, null, null, $composer_35, 806904240, 0, 0, 8388008);
        var tmp_38 = BoxScopeInstance_instance.vdr(Companion_instance);
        sourceInformationMarkerStart($composer_35, -1682116372, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_7 = $composer_35.i31();
        var tmp_39;
        if (false || it_7 === Companion_getInstance().f30_1) {
          var value_7 = AddEditFriendDialog$lambda$lambda_11($showDatePicker$delegate);
          $composer_35.j31(value_7);
          tmp_39 = value_7;
        } else {
          tmp_39 = it_7;
        }
        var tmp1_group_1 = tmp_39;
        sourceInformationMarkerEnd($composer_35);
        Box(clickable(tmp_38, VOID, VOID, VOID, VOID, tmp1_group_1), $composer_35, 0);
        sourceInformationMarkerEnd($composer_35);
        $composer_33.e31();
        var tmp_40;
        // Inline function 'kotlin.text.isNotBlank' call
        var this_0 = AddEditFriendDialog$lambda_7($personalPhone$delegate);
        if (!isBlank(this_0)) {
          tmp_40 = !isValidEgyptianMobile(AddEditFriendDialog$lambda_7($personalPhone$delegate));
        } else {
          tmp_40 = false;
        }
        var isPersonalPhoneError = tmp_40;
        var tmp_41 = AddEditFriendDialog$lambda_7($personalPhone$delegate);
        sourceInformationMarkerStart($composer_5, 1460516614, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_8 = $composer_5.i31();
        var tmp_42;
        if (false || it_8 === Companion_getInstance().f30_1) {
          var value_8 = AddEditFriendDialog$lambda$lambda_12($personalPhone$delegate);
          $composer_5.j31(value_8);
          tmp_42 = value_8;
        } else {
          tmp_42 = it_8;
        }
        var tmp4_group = tmp_42;
        sourceInformationMarkerEnd($composer_5);
        var tmp_43 = ComposableSingletons$FriendComponentsKt_getInstance().u124_1;
        var tmp_44;
        if (isPersonalPhoneError) {
          tmp_44 = ComposableSingletons$FriendComponentsKt_getInstance().v124_1;
        } else {
          tmp_44 = null;
        }
        CustomOutlinedTextField(tmp_41, tmp4_group, tmp_43, null, 0, isPersonalPhoneError, tmp_44, $composer_5, 432, 24);
        var tmp_45;
        // Inline function 'kotlin.text.isNotBlank' call
        var this_1 = AddEditFriendDialog$lambda_9($workPhone$delegate);
        if (!isBlank(this_1)) {
          tmp_45 = !isValidEgyptianWorkPhone(AddEditFriendDialog$lambda_9($workPhone$delegate));
        } else {
          tmp_45 = false;
        }
        var isWorkPhoneError = tmp_45;
        var tmp_46 = AddEditFriendDialog$lambda_9($workPhone$delegate);
        sourceInformationMarkerStart($composer_5, 1460538370, 'CC(remember):FriendComponents.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_9 = $composer_5.i31();
        var tmp_47;
        if (false || it_9 === Companion_getInstance().f30_1) {
          var value_9 = AddEditFriendDialog$lambda$lambda_13($workPhone$delegate);
          $composer_5.j31(value_9);
          tmp_47 = value_9;
        } else {
          tmp_47 = it_9;
        }
        var tmp5_group = tmp_47;
        sourceInformationMarkerEnd($composer_5);
        var tmp_48 = ComposableSingletons$FriendComponentsKt_getInstance().w124_1;
        var tmp_49;
        if (isWorkPhoneError) {
          tmp_49 = ComposableSingletons$FriendComponentsKt_getInstance().x124_1;
        } else {
          tmp_49 = null;
        }
        CustomOutlinedTextField(tmp_46, tmp5_group, tmp_48, null, 0, isWorkPhoneError, tmp_49, $composer_5, 432, 24);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_50;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_50 = Unit_instance;
        }
        tmp = tmp_50;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AddEditFriendDialog$lambda_28($friend, $isProcessing, $language, $onDismiss, $onConfirm, $$changed, $$default) {
    return function ($composer, $force) {
      AddEditFriendDialog($friend._v, $isProcessing, $language._v, $onDismiss, $onConfirm, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function CustomOutlinedTextField$lambda($value, $onValueChange, $label, $modifier, $maxLines, $isError, $supportingText, $$changed, $$default) {
    return function ($composer, $force) {
      CustomOutlinedTextField($value, $onValueChange, $label, $modifier._v, $maxLines._v, $isError._v, $supportingText._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_friends_FriendsState$stable;
  var client_fstech_hadaya_presentation_friends_FriendsIntent_LoadFriends$stable;
  var client_fstech_hadaya_presentation_friends_FriendsIntent_AddFriend$stable;
  var client_fstech_hadaya_presentation_friends_FriendsIntent_UpdateFriend$stable;
  var client_fstech_hadaya_presentation_friends_FriendsIntent_DeleteFriend$stable;
  var client_fstech_hadaya_presentation_friends_FriendsIntent_ToggleAddFriendDialog$stable;
  var client_fstech_hadaya_presentation_friends_FriendsIntent_ShowEditFriendDialog$stable;
  var client_fstech_hadaya_presentation_friends_FriendsIntent_ShowDeleteFriendDialog$stable;
  var client_fstech_hadaya_presentation_friends_FriendsSideEffect_ShowError$stable;
  var client_fstech_hadaya_presentation_friends_FriendsSideEffect_FriendAdded$stable;
  var client_fstech_hadaya_presentation_friends_FriendsSideEffect_FriendUpdated$stable;
  var client_fstech_hadaya_presentation_friends_FriendsSideEffect_FriendDeleted$stable;
  function FriendsState(friends, isLoading, isAddingFriend, isUpdatingFriend, isDeletingFriend, showAddFriendDialog, language, friendToEdit, friendToDelete) {
    friends = friends === VOID ? emptyList() : friends;
    isLoading = isLoading === VOID ? false : isLoading;
    isAddingFriend = isAddingFriend === VOID ? false : isAddingFriend;
    isUpdatingFriend = isUpdatingFriend === VOID ? false : isUpdatingFriend;
    isDeletingFriend = isDeletingFriend === VOID ? false : isDeletingFriend;
    showAddFriendDialog = showAddFriendDialog === VOID ? false : showAddFriendDialog;
    language = language === VOID ? 'en' : language;
    friendToEdit = friendToEdit === VOID ? null : friendToEdit;
    friendToDelete = friendToDelete === VOID ? null : friendToDelete;
    this.y124_1 = friends;
    this.z124_1 = isLoading;
    this.a125_1 = isAddingFriend;
    this.b125_1 = isUpdatingFriend;
    this.c125_1 = isDeletingFriend;
    this.d125_1 = showAddFriendDialog;
    this.e125_1 = language;
    this.f125_1 = friendToEdit;
    this.g125_1 = friendToDelete;
  }
  protoOf(FriendsState).h125 = function (friends, isLoading, isAddingFriend, isUpdatingFriend, isDeletingFriend, showAddFriendDialog, language, friendToEdit, friendToDelete) {
    return new FriendsState(friends, isLoading, isAddingFriend, isUpdatingFriend, isDeletingFriend, showAddFriendDialog, language, friendToEdit, friendToDelete);
  };
  protoOf(FriendsState).i125 = function (friends, isLoading, isAddingFriend, isUpdatingFriend, isDeletingFriend, showAddFriendDialog, language, friendToEdit, friendToDelete, $super) {
    friends = friends === VOID ? this.y124_1 : friends;
    isLoading = isLoading === VOID ? this.z124_1 : isLoading;
    isAddingFriend = isAddingFriend === VOID ? this.a125_1 : isAddingFriend;
    isUpdatingFriend = isUpdatingFriend === VOID ? this.b125_1 : isUpdatingFriend;
    isDeletingFriend = isDeletingFriend === VOID ? this.c125_1 : isDeletingFriend;
    showAddFriendDialog = showAddFriendDialog === VOID ? this.d125_1 : showAddFriendDialog;
    language = language === VOID ? this.e125_1 : language;
    friendToEdit = friendToEdit === VOID ? this.f125_1 : friendToEdit;
    friendToDelete = friendToDelete === VOID ? this.g125_1 : friendToDelete;
    return $super === VOID ? this.h125(friends, isLoading, isAddingFriend, isUpdatingFriend, isDeletingFriend, showAddFriendDialog, language, friendToEdit, friendToDelete) : $super.h125.call(this, friends, isLoading, isAddingFriend, isUpdatingFriend, isDeletingFriend, showAddFriendDialog, language, friendToEdit, friendToDelete);
  };
  protoOf(FriendsState).toString = function () {
    return 'FriendsState(friends=' + toString(this.y124_1) + ', isLoading=' + this.z124_1 + ', isAddingFriend=' + this.a125_1 + ', isUpdatingFriend=' + this.b125_1 + ', isDeletingFriend=' + this.c125_1 + ', showAddFriendDialog=' + this.d125_1 + ', language=' + this.e125_1 + ', friendToEdit=' + toString_0(this.f125_1) + ', friendToDelete=' + toString_0(this.g125_1) + ')';
  };
  protoOf(FriendsState).hashCode = function () {
    var result = hashCode(this.y124_1);
    result = imul(result, 31) + getBooleanHashCode(this.z124_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a125_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b125_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c125_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d125_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e125_1) | 0;
    result = imul(result, 31) + (this.f125_1 == null ? 0 : this.f125_1.hashCode()) | 0;
    result = imul(result, 31) + (this.g125_1 == null ? 0 : this.g125_1.hashCode()) | 0;
    return result;
  };
  protoOf(FriendsState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FriendsState))
      return false;
    if (!equals(this.y124_1, other.y124_1))
      return false;
    if (!(this.z124_1 === other.z124_1))
      return false;
    if (!(this.a125_1 === other.a125_1))
      return false;
    if (!(this.b125_1 === other.b125_1))
      return false;
    if (!(this.c125_1 === other.c125_1))
      return false;
    if (!(this.d125_1 === other.d125_1))
      return false;
    if (!(this.e125_1 === other.e125_1))
      return false;
    if (!equals(this.f125_1, other.f125_1))
      return false;
    if (!equals(this.g125_1, other.g125_1))
      return false;
    return true;
  };
  function LoadFriends() {
  }
  protoOf(LoadFriends).toString = function () {
    return 'LoadFriends';
  };
  protoOf(LoadFriends).hashCode = function () {
    return 821632621;
  };
  protoOf(LoadFriends).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadFriends))
      return false;
    return true;
  };
  var LoadFriends_instance;
  function LoadFriends_getInstance() {
    return LoadFriends_instance;
  }
  function AddFriend_0(friend, imageBytes) {
    imageBytes = imageBytes === VOID ? null : imageBytes;
    this.j125_1 = friend;
    this.k125_1 = imageBytes;
  }
  protoOf(AddFriend_0).toString = function () {
    return 'AddFriend(friend=' + this.j125_1.toString() + ', imageBytes=' + toString_0(this.k125_1) + ')';
  };
  protoOf(AddFriend_0).hashCode = function () {
    var result = this.j125_1.hashCode();
    result = imul(result, 31) + (this.k125_1 == null ? 0 : hashCode(this.k125_1)) | 0;
    return result;
  };
  protoOf(AddFriend_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddFriend_0))
      return false;
    if (!this.j125_1.equals(other.j125_1))
      return false;
    if (!equals(this.k125_1, other.k125_1))
      return false;
    return true;
  };
  function UpdateFriend(friend, imageBytes) {
    imageBytes = imageBytes === VOID ? null : imageBytes;
    this.l125_1 = friend;
    this.m125_1 = imageBytes;
  }
  protoOf(UpdateFriend).toString = function () {
    return 'UpdateFriend(friend=' + this.l125_1.toString() + ', imageBytes=' + toString_0(this.m125_1) + ')';
  };
  protoOf(UpdateFriend).hashCode = function () {
    var result = this.l125_1.hashCode();
    result = imul(result, 31) + (this.m125_1 == null ? 0 : hashCode(this.m125_1)) | 0;
    return result;
  };
  protoOf(UpdateFriend).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateFriend))
      return false;
    if (!this.l125_1.equals(other.l125_1))
      return false;
    if (!equals(this.m125_1, other.m125_1))
      return false;
    return true;
  };
  function DeleteFriend(friendId) {
    this.n125_1 = friendId;
  }
  protoOf(DeleteFriend).toString = function () {
    return 'DeleteFriend(friendId=' + this.n125_1 + ')';
  };
  protoOf(DeleteFriend).hashCode = function () {
    return getStringHashCode(this.n125_1);
  };
  protoOf(DeleteFriend).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeleteFriend))
      return false;
    if (!(this.n125_1 === other.n125_1))
      return false;
    return true;
  };
  function ToggleAddFriendDialog_0(show) {
    this.o125_1 = show;
  }
  protoOf(ToggleAddFriendDialog_0).toString = function () {
    return 'ToggleAddFriendDialog(show=' + this.o125_1 + ')';
  };
  protoOf(ToggleAddFriendDialog_0).hashCode = function () {
    return getBooleanHashCode(this.o125_1);
  };
  protoOf(ToggleAddFriendDialog_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ToggleAddFriendDialog_0))
      return false;
    if (!(this.o125_1 === other.o125_1))
      return false;
    return true;
  };
  function ShowEditFriendDialog(friend) {
    this.p125_1 = friend;
  }
  protoOf(ShowEditFriendDialog).toString = function () {
    return 'ShowEditFriendDialog(friend=' + toString_0(this.p125_1) + ')';
  };
  protoOf(ShowEditFriendDialog).hashCode = function () {
    return this.p125_1 == null ? 0 : this.p125_1.hashCode();
  };
  protoOf(ShowEditFriendDialog).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowEditFriendDialog))
      return false;
    if (!equals(this.p125_1, other.p125_1))
      return false;
    return true;
  };
  function ShowDeleteFriendDialog(friend) {
    this.q125_1 = friend;
  }
  protoOf(ShowDeleteFriendDialog).toString = function () {
    return 'ShowDeleteFriendDialog(friend=' + toString_0(this.q125_1) + ')';
  };
  protoOf(ShowDeleteFriendDialog).hashCode = function () {
    return this.q125_1 == null ? 0 : this.q125_1.hashCode();
  };
  protoOf(ShowDeleteFriendDialog).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowDeleteFriendDialog))
      return false;
    if (!equals(this.q125_1, other.q125_1))
      return false;
    return true;
  };
  function FriendsIntent() {
  }
  function ShowError_3(message) {
    this.r125_1 = message;
  }
  protoOf(ShowError_3).toString = function () {
    return 'ShowError(message=' + toString(this.r125_1) + ')';
  };
  protoOf(ShowError_3).hashCode = function () {
    return hashCode(this.r125_1);
  };
  protoOf(ShowError_3).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowError_3))
      return false;
    if (!equals(this.r125_1, other.r125_1))
      return false;
    return true;
  };
  function FriendAdded_0() {
  }
  protoOf(FriendAdded_0).toString = function () {
    return 'FriendAdded';
  };
  protoOf(FriendAdded_0).hashCode = function () {
    return -162443572;
  };
  protoOf(FriendAdded_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FriendAdded_0))
      return false;
    return true;
  };
  var FriendAdded_instance_0;
  function FriendAdded_getInstance_0() {
    return FriendAdded_instance_0;
  }
  function FriendUpdated() {
  }
  protoOf(FriendUpdated).toString = function () {
    return 'FriendUpdated';
  };
  protoOf(FriendUpdated).hashCode = function () {
    return -575796345;
  };
  protoOf(FriendUpdated).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FriendUpdated))
      return false;
    return true;
  };
  var FriendUpdated_instance;
  function FriendUpdated_getInstance() {
    return FriendUpdated_instance;
  }
  function FriendDeleted() {
  }
  protoOf(FriendDeleted).toString = function () {
    return 'FriendDeleted';
  };
  protoOf(FriendDeleted).hashCode = function () {
    return 1209096933;
  };
  protoOf(FriendDeleted).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FriendDeleted))
      return false;
    return true;
  };
  var FriendDeleted_instance;
  function FriendDeleted_getInstance() {
    return FriendDeleted_instance;
  }
  function FriendsSideEffect() {
  }
  function FriendsScreen(onBack, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-527801317);
    sourceInformation($composer_0, 'C(FriendsScreen)65@2880L15,66@2939L16,67@2984L32,69@3048L719,69@3022L745,85@3843L342,85@3797L35,94@4210L322,104@4534L2067,85@3773L2828:FriendsScreen.kt#7dj0rb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-527801317, $dirty, -1, 'client.fstech.hadaya.presentation.friends.FriendsScreen (FriendsScreen.kt:64)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(FriendsViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, -410918661, 'CC(remember):FriendsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance().f30_1) {
        var value = new SnackbarHostState();
        this_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp0_group;
      sourceInformationMarkerStart($composer_0, -410915926, 'CC(remember):FriendsScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_0.i31();
      var tmp_2;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = FriendsScreen$slambda_0(viewModel, snackbarHostState, null);
        tmp0_0.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp1_group, $composer_0, 0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-2096457513, true, FriendsScreen$lambda_0(onBack), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_2.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_2.i31();
      var tmp_3;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_2.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp_4 = tmp_3;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_0 = rememberComposableLambda(1865866645, true, FriendsScreen$lambda_1(snackbarHostState), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_3.k31(dispatchReceiver_0);
      // Inline function 'kotlin.let' call
      var it_2 = $composer_3.i31();
      var tmp_5;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = ComposableLambda$invoke$ref(dispatchReceiver_0);
        $composer_3.j31(value_2);
        tmp_5 = value_2;
      } else {
        tmp_5 = it_2;
      }
      var tmp_6 = tmp_5;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_1 = rememberComposableLambda(-447938572, true, FriendsScreen$lambda_2(viewModel), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_4 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = $composer_4.k31(dispatchReceiver_1);
      // Inline function 'kotlin.let' call
      var it_3 = $composer_4.i31();
      var tmp_7;
      if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = ComposableLambda$invoke$ref(dispatchReceiver_1);
        $composer_4.j31(value_3);
        tmp_7 = value_3;
      } else {
        tmp_7 = it_3;
      }
      var tmp_8 = tmp_7;
      var tmp_9 = _FabPosition___init__impl__9ib2hj(0);
      var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      // Inline function 'kotlin.run' call
      var dispatchReceiver_2 = rememberComposableLambda(-350628308, true, FriendsScreen$lambda_3(state$delegate, viewModel), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_5 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = $composer_5.k31(dispatchReceiver_2);
      // Inline function 'kotlin.let' call
      var it_4 = $composer_5.i31();
      var tmp_12;
      if (invalid_3 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = ComposableLambda$invoke$ref_2(dispatchReceiver_2);
        $composer_5.j31(value_4);
        tmp_12 = value_4;
      } else {
        tmp_12 = it_4;
      }
      var tmp$ret$31 = tmp_12;
      Scaffold(null, tmp_4, null, tmp_6, tmp_8, tmp_9, tmp_10, tmp_11, null, tmp$ret$31, $composer_0, 805334064, 485);
      if (FriendsScreen$lambda(state$delegate).d125_1) {
        $composer_0.m30(150058490);
        sourceInformation($composer_0, '154@6781L74,155@6881L115,151@6648L349');
        var tmp_13 = FriendsScreen$lambda(state$delegate).a125_1;
        var tmp_14 = FriendsScreen$lambda(state$delegate).e125_1;
        sourceInformationMarkerStart($composer_0, -410797115, 'CC(remember):FriendsScreen.kt#9igjgp');
        var tmp0_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = $composer_0.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_5 = tmp0_1.i31();
        var tmp_15;
        if (invalid_4 || it_5 === Companion_getInstance().f30_1) {
          var value_5 = FriendsScreen$lambda_4(viewModel);
          tmp0_1.j31(value_5);
          tmp_15 = value_5;
        } else {
          tmp_15 = it_5;
        }
        var tmp2_group = tmp_15;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -410793874, 'CC(remember):FriendsScreen.kt#9igjgp');
        var tmp0_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = $composer_0.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_6 = tmp0_2.i31();
        var tmp_16;
        if (invalid_5 || it_6 === Companion_getInstance().f30_1) {
          var value_6 = FriendsScreen$lambda_5(viewModel);
          tmp0_2.j31(value_6);
          tmp_16 = value_6;
        } else {
          tmp_16 = it_6;
        }
        var tmp3_group = tmp_16;
        sourceInformationMarkerEnd($composer_0);
        AddEditFriendDialog(null, tmp_13, tmp_14, tmp2_group, tmp3_group, $composer_0, 0, 1);
        $composer_0.n30();
      } else {
        $composer_0.m30(150409255);
        $composer_0.n30();
      }
      if (!(FriendsScreen$lambda(state$delegate).f125_1 == null)) {
        $composer_0.m30(150460343);
        sourceInformation($composer_0, '165@7227L72,166@7325L132,161@7051L416');
        var tmp_17 = FriendsScreen$lambda(state$delegate).f125_1;
        var tmp_18 = FriendsScreen$lambda(state$delegate).b125_1;
        var tmp_19 = FriendsScreen$lambda(state$delegate).e125_1;
        sourceInformationMarkerStart($composer_0, -410782845, 'CC(remember):FriendsScreen.kt#9igjgp');
        var tmp0_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_6 = $composer_0.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_7 = tmp0_3.i31();
        var tmp_20;
        if (invalid_6 || it_7 === Companion_getInstance().f30_1) {
          var value_7 = FriendsScreen$lambda_6(viewModel);
          tmp0_3.j31(value_7);
          tmp_20 = value_7;
        } else {
          tmp_20 = it_7;
        }
        var tmp4_group = tmp_20;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -410779649, 'CC(remember):FriendsScreen.kt#9igjgp');
        var tmp0_4 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_7 = $composer_0.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_8 = tmp0_4.i31();
        var tmp_21;
        if (invalid_7 || it_8 === Companion_getInstance().f30_1) {
          var value_8 = FriendsScreen$lambda_7(viewModel);
          tmp0_4.j31(value_8);
          tmp_21 = value_8;
        } else {
          tmp_21 = it_8;
        }
        var tmp5_group = tmp_21;
        sourceInformationMarkerEnd($composer_0);
        AddEditFriendDialog(tmp_17, tmp_18, tmp_19, tmp4_group, tmp5_group, $composer_0, 0, 0);
        $composer_0.n30();
      } else {
        $composer_0.m30(150875495);
        $composer_0.n30();
      }
      if (!(FriendsScreen$lambda(state$delegate).g125_1 == null)) {
        $composer_0.m30(150964217);
        sourceInformation($composer_0, '174@7567L186,190@8122L626,206@8778L301,182@7852L240,173@7523L1566');
        sourceInformationMarkerStart($composer_0, -410771851, 'CC(remember):FriendsScreen.kt#9igjgp');
        var tmp0_5 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_8 = $composer_0.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_9 = tmp0_5.i31();
        var tmp_22;
        if (invalid_8 || it_9 === Companion_getInstance().f30_1) {
          var value_9 = FriendsScreen$lambda_8(viewModel);
          tmp0_5.j31(value_9);
          tmp_22 = value_9;
        } else {
          tmp_22 = it_9;
        }
        var tmp6_group = tmp_22;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_3 = rememberComposableLambda(-2065334032, true, FriendsScreen$lambda_9(state$delegate, viewModel), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_6 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_9 = $composer_6.k31(dispatchReceiver_3);
        // Inline function 'kotlin.let' call
        var it_10 = $composer_6.i31();
        var tmp_23;
        if (invalid_9 || it_10 === Companion_getInstance().f30_1) {
          var value_10 = ComposableLambda$invoke$ref(dispatchReceiver_3);
          $composer_6.j31(value_10);
          tmp_23 = value_10;
        } else {
          tmp_23 = it_10;
        }
        var tmp_24 = tmp_23;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_4 = rememberComposableLambda(1684760690, true, FriendsScreen$lambda_10(viewModel, state$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_7 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_10 = $composer_7.k31(dispatchReceiver_4);
        // Inline function 'kotlin.let' call
        var it_11 = $composer_7.i31();
        var tmp_25;
        if (invalid_10 || it_11 === Companion_getInstance().f30_1) {
          var value_11 = ComposableLambda$invoke$ref(dispatchReceiver_4);
          $composer_7.j31(value_11);
          tmp_25 = value_11;
        } else {
          tmp_25 = it_11;
        }
        var tmp_26 = tmp_25;
        var tmp_27 = ComposableSingletons$FriendsScreenKt_getInstance().w125_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_5 = rememberComposableLambda(867451829, true, FriendsScreen$lambda_11(state$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_8 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_11 = $composer_8.k31(dispatchReceiver_5);
        // Inline function 'kotlin.let' call
        var it_12 = $composer_8.i31();
        var tmp_28;
        if (invalid_11 || it_12 === Companion_getInstance().f30_1) {
          var value_12 = ComposableLambda$invoke$ref(dispatchReceiver_5);
          $composer_8.j31(value_12);
          tmp_28 = value_12;
        } else {
          tmp_28 = it_12;
        }
        var tmp_29 = tmp_28;
        var tmp_30 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_31 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_32 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_33 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_34 = _Dp___init__impl__ms3zkb(0.0);
        AlertDialog(tmp6_group, tmp_24, null, tmp_26, null, tmp_27, tmp_29, null, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, null, $composer_0, 1772592, 0, 16276);
        $composer_0.n30();
      } else {
        $composer_0.m30(152484519);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp7_safe_receiver = $composer_0.t30();
    if (tmp7_safe_receiver == null)
      null;
    else {
      tmp7_safe_receiver.p3c(FriendsScreen$lambda_12(onBack, $changed));
    }
  }
  function ComposableSingletons$FriendsScreenKt$lambda$_1853140581$lambda_hvippw($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C86@3878L40,86@3873L46:FriendsScreen.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1853140581, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendsScreenKt.lambda$-1853140581.<anonymous> (FriendsScreen.kt:86)');
      }
      var tmp = stringResource(get_friends_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendsScreenKt$lambda$_926184901$lambda_27vnfq($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C90@4105L31,88@4001L153:FriendsScreen.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-926184901, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendsScreenKt.lambda$-926184901.<anonymous> (FriendsScreen.kt:88)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendsScreenKt$lambda$_1004437326$lambda_lw8pio($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C102@4473L42,102@4428L88:FriendsScreen.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1004437326, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendsScreenKt.lambda$-1004437326.<anonymous> (FriendsScreen.kt:102)');
      }
      var tmp = get_Add(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_add_friend_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendsScreenKt$lambda$826032303$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C211@9013L33,211@9008L39:FriendsScreen.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(826032303, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendsScreenKt.lambda$826032303.<anonymous> (FriendsScreen.kt:211)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendsScreenKt$lambda$1139888116$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C181@7782L46,181@7777L52:FriendsScreen.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1139888116, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendsScreenKt.lambda$1139888116.<anonymous> (FriendsScreen.kt:181)');
      }
      var tmp = stringResource(get_delete_friend_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendsScreenKt$lambda$2023097268$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C319@13401L31,320@13479L11,317@13306L214:FriendsScreen.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(2023097268, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendsScreenKt.lambda$2023097268.<anonymous> (FriendsScreen.kt:317)');
      }
      var tmp = get_Edit(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_edit(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).xnz_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendsScreenKt$lambda$_519297621$lambda_iazywu($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C326@13705L33,324@13608L194:FriendsScreen.kt#7dj0rb');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-519297621, $changed, -1, 'client.fstech.hadaya.presentation.friends.ComposableSingletons$FriendsScreenKt.lambda$-519297621.<anonymous> (FriendsScreen.kt:324)');
      }
      var tmp = get_Delete(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_delete(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, Companion_getInstance_14().n6b_1, $composer_0, 3072, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FriendsScreenKt() {
    ComposableSingletons$FriendsScreenKt_instance = this;
    var tmp = this;
    tmp.s125_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1853140581, false, ComposableSingletons$FriendsScreenKt$lambda$_1853140581$lambda_hvippw));
    var tmp_0 = this;
    tmp_0.t125_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-926184901, false, ComposableSingletons$FriendsScreenKt$lambda$_926184901$lambda_27vnfq));
    var tmp_1 = this;
    tmp_1.u125_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1004437326, false, ComposableSingletons$FriendsScreenKt$lambda$_1004437326$lambda_lw8pio));
    var tmp_2 = this;
    tmp_2.v125_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(826032303, false, ComposableSingletons$FriendsScreenKt$lambda$826032303$lambda));
    var tmp_3 = this;
    tmp_3.w125_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1139888116, false, ComposableSingletons$FriendsScreenKt$lambda$1139888116$lambda));
    var tmp_4 = this;
    tmp_4.x125_1 = ComposableLambda$invoke$ref(composableLambdaInstance(2023097268, false, ComposableSingletons$FriendsScreenKt$lambda$2023097268$lambda));
    var tmp_5 = this;
    tmp_5.y125_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-519297621, false, ComposableSingletons$FriendsScreenKt$lambda$_519297621$lambda_iazywu));
  }
  var ComposableSingletons$FriendsScreenKt_instance;
  function ComposableSingletons$FriendsScreenKt_getInstance() {
    if (ComposableSingletons$FriendsScreenKt_instance == null)
      new ComposableSingletons$FriendsScreenKt();
    return ComposableSingletons$FriendsScreenKt_instance;
  }
  function FriendCard(friend, language, onEdit, onDelete, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-2108797293);
    sourceInformation($composer_0, 'C(FriendCard)P(!2,3)227@9316L4534,225@9226L4624:FriendsScreen.kt#7dj0rb');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(friend) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onEdit) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onDelete) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2108797293, $dirty, -1, 'client.fstech.hadaya.presentation.friends.FriendCard (FriendsScreen.kt:224)');
      }
      var tmp = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
      var tmp_0 = RoundedCornerShape(tmp$ret$0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(457726469, true, FriendCard$lambda(friend, language, onEdit, onDelete), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_1;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref_6(dispatchReceiver);
        $composer_1.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp$ret$1 = tmp_1;
      Card(tmp, tmp_0, null, null, null, tmp$ret$1, $composer_0, 196614, 28);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(FriendCard$lambda_0(friend, language, onEdit, onDelete, $changed));
    }
  }
  function FriendsScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_12(function_0) {
    this.z125_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_12).a1v = function (value, $completion) {
    return this.z125_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_12).q3 = function () {
    return this.z125_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_12).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_12).hashCode = function () {
    return hashCode(this.q3());
  };
  function FriendsScreen$slambda$slambda($snackbarHostState, resultContinuation) {
    this.i126_1 = $snackbarHostState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FriendsScreen$slambda$slambda).l126 = function (effect, $completion) {
    var tmp = this.m126(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FriendsScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.l126((!(p1 == null) ? isInterface(p1, FriendsSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FriendsScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 10;
            var tmp0_subject = this.j126_1;
            if (tmp0_subject instanceof ShowError_3) {
              this.n9_1 = 7;
              suspendResult = this.j126_1.r125_1.z10i(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (equals(tmp0_subject, FriendAdded_instance_0)) {
                this.n9_1 = 5;
                suspendResult = getString(get_friend_added_successfully(string_instance), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (equals(tmp0_subject, FriendUpdated_instance)) {
                  this.n9_1 = 3;
                  suspendResult = getString(get_friend_updated_successfully(string_instance), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (equals(tmp0_subject, FriendDeleted_instance)) {
                    this.n9_1 = 1;
                    suspendResult = getString(get_friend_deleted_successfully(string_instance), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    var tmp_0 = this;
                    noWhenBranchMatchedException();
                  }
                }
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.i126_1.dqm(ARGUMENT, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.k126_1 = suspendResult;
            this.n9_1 = 9;
            continue $sm;
          case 3:
            var ARGUMENT_0 = suspendResult;
            this.n9_1 = 4;
            suspendResult = this.i126_1.dqm(ARGUMENT_0, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.k126_1 = suspendResult;
            this.n9_1 = 9;
            continue $sm;
          case 5:
            var ARGUMENT_1 = suspendResult;
            this.n9_1 = 6;
            suspendResult = this.i126_1.dqm(ARGUMENT_1, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.k126_1 = suspendResult;
            this.n9_1 = 9;
            continue $sm;
          case 7:
            var ARGUMENT_2 = suspendResult;
            this.n9_1 = 8;
            suspendResult = this.i126_1.dqm(ARGUMENT_2, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.k126_1 = suspendResult;
            this.n9_1 = 9;
            continue $sm;
          case 9:
            return Unit_instance;
          case 10:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 10) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FriendsScreen$slambda$slambda).m126 = function (effect, completion) {
    var i = new FriendsScreen$slambda$slambda(this.i126_1, completion);
    i.j126_1 = effect;
    return i;
  };
  function FriendsScreen$slambda$slambda_0($snackbarHostState, resultContinuation) {
    var i = new FriendsScreen$slambda$slambda($snackbarHostState, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.l126(effect, $completion);
    }, 1);
  }
  function FriendsScreen$slambda($viewModel, $snackbarHostState, resultContinuation) {
    this.v126_1 = $viewModel;
    this.w126_1 = $snackbarHostState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FriendsScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FriendsScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FriendsScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.v126_1.s10h().t10h();
            var tmp_1 = FriendsScreen$slambda$slambda_0(this.w126_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_12(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FriendsScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new FriendsScreen$slambda(this.v126_1, this.w126_1, completion);
    i.x126_1 = $this$LaunchedEffect;
    return i;
  };
  function FriendsScreen$slambda_0($viewModel, $snackbarHostState, resultContinuation) {
    var i = new FriendsScreen$slambda($viewModel, $snackbarHostState, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function FriendsScreen$lambda$lambda($onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C87@3954L214:FriendsScreen.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1185758691, $changed, -1, 'client.fstech.hadaya.presentation.friends.FriendsScreen.<anonymous>.<anonymous> (FriendsScreen.kt:87)');
        }
        IconButton($onBack, null, false, null, null, null, ComposableSingletons$FriendsScreenKt_getInstance().t125_1, $composer_0, 1572864, 62);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda_0($onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C86@3940L238,86@3853L326:FriendsScreen.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2096457513, $changed, -1, 'client.fstech.hadaya.presentation.friends.FriendsScreen.<anonymous> (FriendsScreen.kt:86)');
        }
        var tmp_0 = ComposableSingletons$FriendsScreenKt_getInstance().s125_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1185758691, true, FriendsScreen$lambda$lambda($onBack), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp_2 = tmp_1;
        var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
        TopAppBar(tmp_0, null, tmp_2, null, tmp_3, null, null, null, $composer_0, 390, 250);
        var tmp_4;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_4 = Unit_instance;
        }
        tmp = tmp_4;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda_1($snackbarHostState) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C85@3799L31:FriendsScreen.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1865866645, $changed, -1, 'client.fstech.hadaya.presentation.friends.FriendsScreen.<anonymous> (FriendsScreen.kt:85)');
        }
        SnackbarHost($snackbarHostState, null, null, $composer_0, 6, 6);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda$lambda_0($viewModel) {
    return function () {
      $viewModel.s10h().j10i(new ToggleAddFriendDialog_0(true));
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda_2($viewModel) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C95@4251L161,95@4220L306:FriendsScreen.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-447938572, $changed, -1, 'client.fstech.hadaya.presentation.friends.FriendsScreen.<anonymous> (FriendsScreen.kt:95)');
        }
        sourceInformationMarkerStart($composer_0, -972236619, 'CC(remember):FriendsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($viewModel);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = FriendsScreen$lambda$lambda_0($viewModel);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        FloatingActionButton(tmp0_group, null, null, tmp_1, tmp_2, null, null, ComposableSingletons$FriendsScreenKt_getInstance().u125_1, $composer_0, 12582912, 126);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda$lambda$lambda(it) {
    return null;
  }
  function FriendsScreen$lambda$lambda$lambda_0($key, $items) {
    return function (index) {
      return $key($items.l1(index));
    };
  }
  function FriendsScreen$lambda$lambda$lambda_1($contentType, $items) {
    return function (index) {
      return $contentType($items.l1(index));
    };
  }
  function FriendsScreen$lambda$lambda$lambda$lambda($viewModel, $friend) {
    return function () {
      $viewModel.s10h().j10i(new ShowEditFriendDialog($friend));
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda$lambda$lambda$lambda_0($viewModel, $friend) {
    return function () {
      $viewModel.s10h().j10i(new ShowDeleteFriendDialog($friend));
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda$lambda$lambda_2($items, $viewModel, $state$delegate) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp2 = $items.l1(it);
        var $changed_0 = 14 & $dirty;
        var $composer_1 = $composer_0;
        $composer_1.m30(504243968);
        sourceInformation($composer_1, 'C*128@5816L306,135@6167L308,125@5655L850:FriendsScreen.kt#7dj0rb');
        var tmp_2 = FriendsScreen$lambda($state$delegate).e125_1;
        sourceInformationMarkerStart($composer_1, 709007203, 'CC(remember):FriendsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_1.q31($viewModel) | (($changed_0 & 112 ^ 48) > 32 && $composer_1.k31(tmp2) || ($changed_0 & 48) === 32));
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_3;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = FriendsScreen$lambda$lambda$lambda$lambda($viewModel, tmp2);
          $composer_1.j31(value);
          tmp_3 = value;
        } else {
          tmp_3 = it_0;
        }
        var tmp0_group = tmp_3;
        sourceInformationMarkerEnd($composer_1);
        sourceInformationMarkerStart($composer_1, 709018437, 'CC(remember):FriendsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = !!($composer_1.q31($viewModel) | (($changed_0 & 112 ^ 48) > 32 && $composer_1.k31(tmp2) || ($changed_0 & 48) === 32));
        // Inline function 'kotlin.let' call
        var it_1 = $composer_1.i31();
        var tmp_4;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = FriendsScreen$lambda$lambda$lambda$lambda_0($viewModel, tmp2);
          $composer_1.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_1;
        }
        var tmp1_group = tmp_4;
        sourceInformationMarkerEnd($composer_1);
        FriendCard(tmp2, tmp_2, tmp0_group, tmp1_group, $composer_1, 14 & $changed_0 >> 3);
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda$lambda_1($state$delegate, $viewModel) {
    return function ($this$LazyColumn) {
      // Inline function 'androidx.compose.foundation.lazy.items' call
      var items = FriendsScreen$lambda($state$delegate).y124_1;
      var contentType = FriendsScreen$lambda$lambda$lambda;
      var tmp = items.n1();
      var tmp_0;
      if (!(null == null)) {
        tmp_0 = FriendsScreen$lambda$lambda$lambda_0(null, items);
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      var tmp_2 = FriendsScreen$lambda$lambda$lambda_1(contentType, items);
      $this$LazyColumn.di9(tmp, tmp_1, tmp_2, ComposableLambda$invoke$ref_4(composableLambdaInstance(802480018, true, FriendsScreen$lambda$lambda$lambda_2(items, $viewModel, $state$delegate))));
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda_3($state$delegate, $viewModel) {
    return function (padding_0, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C105@4555L2040:FriendsScreen.kt#7dj0rb');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31(padding_0) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-350628308, $dirty, -1, 'client.fstech.hadaya.presentation.friends.FriendsScreen.<anonymous> (FriendsScreen.kt:105)');
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = padding(fillMaxSize(Companion_instance), padding_0);
        var contentAlignment = Companion_getInstance_11().l8t_1;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((4 & 1) === 0))
          modifier = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -1066045487, 'C106@4665L1920:FriendsScreen.kt#7dj0rb');
        var tmp_2 = fillMaxSize(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$6 = _Dp___init__impl__ms3zkb(1000);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_1 = widthIn(tmp_2, VOID, tmp$ret$6);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_6 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_3 = $composer_8.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, -754900388, 'C:FriendsScreen.kt#7dj0rb');
        if (FriendsScreen$lambda($state$delegate).z124_1) {
          $composer_10.m30(-754930490);
          sourceInformation($composer_10, '108@4791L140');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_3 = fillMaxSize(Companion_instance);
          var contentAlignment_0 = Companion_getInstance_11().o8t_1;
          var propagateMinConstraints_0 = false;
          var $composer_11 = $composer_10;
          if (!((4 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((4 & 2) === 0))
            contentAlignment_0 = Companion_getInstance_11().k8t_1;
          if (!((4 & 4) === 0))
            propagateMinConstraints_0 = false;
          var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_4 = $composer_13.g30();
          if (!isInterface(tmp_4, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_1);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_15, 1547151455, 'C109@4882L27:FriendsScreen.kt#7dj0rb');
          var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_6 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_8 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(null, tmp_5, tmp_6, tmp_7, tmp_8, _Dp___init__impl__ms3zkb(0.0), $composer_15, 0, 63);
          sourceInformationMarkerEnd($composer_15);
          $composer_13.e31();
          $composer_10.n30();
        } else if (FriendsScreen$lambda($state$delegate).y124_1.r()) {
          $composer_10.m30(-754712684);
          sourceInformation($composer_10, '112@5006L286');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_5 = fillMaxSize(Companion_instance);
          var contentAlignment_1 = Companion_getInstance_11().o8t_1;
          var propagateMinConstraints_1 = false;
          var $composer_16 = $composer_10;
          if (!((4 & 1) === 0))
            modifier_5 = Companion_instance;
          if (!((4 & 2) === 0))
            contentAlignment_1 = Companion_getInstance_11().k8t_1;
          if (!((4 & 4) === 0))
            propagateMinConstraints_1 = false;
          var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_6 = modifier_5;
          var $composer_17 = $composer_16;
          if (!((0 & 2) === 0))
            modifier_6 = Companion_instance;
          var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
          var localMap_2 = $composer_17.t31();
          var materialized_2 = materialize($composer_17, modifier_6);
          var tmp0_2 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_18 = $composer_17;
          var tmp_9 = $composer_18.g30();
          if (!isInterface(tmp_9, Applier)) {
            invalidApplier();
          }
          $composer_18.b31();
          if ($composer_18.h30()) {
            $composer_18.c31(tmp0_2);
          } else {
            $composer_18.d31();
          }
          var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_18);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
          var $composer_19 = $composer_18;
          var $composer_20 = $composer_19;
          sourceInformationMarkerStart($composer_20, -343619900, 'C114@5131L41,115@5224L10,113@5097L173:FriendsScreen.kt#7dj0rb');
          var tmp_10 = stringResource(get_no_friends_yet(string_instance), $composer_20, 0);
          var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_15 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_10, null, tmp_11, null, tmp_12, null, null, null, tmp_13, null, null, tmp_14, tmp_15, false, 0, 0, null, MaterialTheme_instance.jog($composer_20, 6).oof_1, $composer_20, 0, 0, 131070);
          sourceInformationMarkerEnd($composer_20);
          $composer_18.e31();
          $composer_10.n30();
        } else {
          $composer_10.m30(-754354541);
          sourceInformation($composer_10, '123@5568L985,119@5338L1215');
          var tmp_16 = fillMaxSize(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$25 = _Dp___init__impl__ms3zkb(16);
          var tmp_17 = PaddingValues_1(tmp$ret$25);
          var tmp_18 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$26 = _Dp___init__impl__ms3zkb(12);
          var tmp_19 = tmp_18.mdq(tmp$ret$26);
          sourceInformationMarkerStart($composer_10, 529863105, 'CC(remember):FriendsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = !!($composer_10.k31($state$delegate) | $composer_10.q31($viewModel));
          // Inline function 'kotlin.let' call
          var it = $composer_10.i31();
          var tmp_20;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = FriendsScreen$lambda$lambda_1($state$delegate, $viewModel);
            $composer_10.j31(value);
            tmp_20 = value;
          } else {
            tmp_20 = it;
          }
          var tmp0_group = tmp_20;
          sourceInformationMarkerEnd($composer_10);
          LazyColumn(tmp_16, null, tmp_17, false, tmp_19, null, null, false, null, tmp0_group, $composer_10, 24966, 490);
          $composer_10.n30();
        }
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_21;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_21 = Unit_instance;
        }
        tmp_0 = tmp_21;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda_4($viewModel) {
    return function () {
      $viewModel.s10h().j10i(new ToggleAddFriendDialog_0(false));
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda_5($viewModel) {
    return function (friend, bytes) {
      $viewModel.s10h().j10i(new AddFriend_0(friend, bytes));
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda_6($viewModel) {
    return function () {
      $viewModel.s10h().j10i(new ShowEditFriendDialog(null));
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda_7($viewModel) {
    return function (updatedFriend, bytes) {
      $viewModel.s10h().j10i(new UpdateFriend(updatedFriend, bytes));
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda_8($viewModel) {
    return function () {
      $viewModel.s10h().j10i(new ShowDeleteFriendDialog(null));
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda$lambda_2($viewModel, $state$delegate) {
    return function () {
      var tmp0_safe_receiver = FriendsScreen$lambda($state$delegate).g125_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tz7_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        $viewModel.s10h().j10i(new DeleteFriend(tmp1_safe_receiver));
      }
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda$lambda_3($state$delegate) {
    return function ($this$TextButton, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:FriendsScreen.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1370904877, $changed, -1, 'client.fstech.hadaya.presentation.friends.FriendsScreen.<anonymous>.<anonymous> (FriendsScreen.kt:199)');
        }
        if (FriendsScreen$lambda($state$delegate).c125_1) {
          $composer_0.m30(-216774069);
          sourceInformation($composer_0, '200@8524L58');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_0, 6, 62);
          $composer_0.n30();
        } else {
          $composer_0.m30(-216662965);
          sourceInformation($composer_0, '202@8641L33,202@8636L58');
          var tmp_6 = stringResource(get_delete(string_instance), $composer_0, 0);
          var tmp_7 = Companion_getInstance_14().n6b_1;
          var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_11 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_6, null, tmp_7, null, tmp_8, null, null, null, tmp_9, null, null, tmp_10, tmp_11, false, 0, 0, null, null, $composer_0, 384, 0, 262138);
          $composer_0.n30();
        }
        var tmp_12;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_12 = Unit_instance;
        }
        tmp = tmp_12;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda_9($state$delegate, $viewModel) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C192@8182L192,198@8448L286,191@8140L594:FriendsScreen.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2065334032, $changed, -1, 'client.fstech.hadaya.presentation.friends.FriendsScreen.<anonymous> (FriendsScreen.kt:191)');
        }
        sourceInformationMarkerStart($composer_0, -511111888, 'CC(remember):FriendsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.k31($state$delegate) | $composer_0.q31($viewModel));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = FriendsScreen$lambda$lambda_2($viewModel, $state$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1 = !FriendsScreen$lambda($state$delegate).c125_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1370904877, true, FriendsScreen$lambda$lambda_3($state$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_2;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_2 = value_0;
        } else {
          tmp_2 = it_0;
        }
        var tmp$ret$4 = tmp_2;
        TextButton(tmp0_group, null, tmp_1, null, null, null, null, null, null, tmp$ret$4, $composer_0, 805306368, 506);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda$lambda_4($viewModel) {
    return function () {
      $viewModel.s10h().j10i(new ShowDeleteFriendDialog(null));
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda_10($viewModel, $state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C208@8838L74,207@8796L269:FriendsScreen.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1684760690, $changed, -1, 'client.fstech.hadaya.presentation.friends.FriendsScreen.<anonymous> (FriendsScreen.kt:207)');
        }
        sourceInformationMarkerStart($composer_0, -147645508, 'CC(remember):FriendsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($viewModel);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = FriendsScreen$lambda$lambda_4($viewModel);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1 = !FriendsScreen$lambda($state$delegate).c125_1;
        TextButton(tmp0_group, null, tmp_1, null, null, null, null, null, null, ComposableSingletons$FriendsScreenKt_getInstance().v125_1, $composer_0, 805306368, 506);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda_11($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C184@7896L164,183@7870L208:FriendsScreen.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(867451829, $changed, -1, 'client.fstech.hadaya.presentation.friends.FriendsScreen.<anonymous> (FriendsScreen.kt:183)');
        }
        var tmp_0 = get_delete_friend_confirm_pattern(string_instance);
        var tmp0_safe_receiver = FriendsScreen$lambda($state$delegate).g125_1;
        // Inline function 'kotlin.text.orEmpty' call
        var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vz7_1;
        var tmp$ret$0 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
        var tmp_1 = stringResource_0(tmp_0, [tmp$ret$0], $composer_0, 0);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FriendsScreen$lambda_12($onBack, $$changed) {
    return function ($composer, $force) {
      FriendsScreen($onBack, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function FriendCard$lambda($friend, $language, $onEdit, $onDelete) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C228@9326L4518:FriendsScreen.kt#7dj0rb');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(457726469, $changed, -1, 'client.fstech.hadaya.presentation.friends.FriendCard.<anonymous> (FriendsScreen.kt:228)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var horizontalArrangement = null;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance;
        if (!((2 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((2 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 390 >> 3 | 112 & 390 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 1923019546, 'C235@9609L11,231@9450L1107,257@10570L40,258@10623L2594,315@13230L604:FriendsScreen.kt#7dj0rb');
        var tmp_2 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(56);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = background(clip(size(tmp_2, tmp$ret$7), get_CircleShape()), MaterialTheme_instance.unz($composer_5, 6).oo0_1);
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_5;
        if (!((4 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_3 = $composer_8.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 516345951, 'C:FriendsScreen.kt#7dj0rb');
        var tmp0_safe_receiver = $friend.fz8_1;
        var tmp_4;
        if (tmp0_safe_receiver == null) {
          tmp_4 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_5;
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(tmp0_safe_receiver)) {
            tmp_5 = tmp0_safe_receiver;
          } else {
            tmp_5 = null;
          }
          tmp_4 = tmp_5;
        }
        var avatarUrl = tmp_4;
        if (!(avatarUrl == null)) {
          $composer_10.m30(516432998);
          sourceInformation($composer_10, '240@9844L389');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_3 = fillMaxSize(Companion_instance);
          var contentAlignment_0 = null;
          var propagateMinConstraints_0 = false;
          var $composer_11 = $composer_10;
          if (!((6 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_0 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_0 = false;
          var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_6 = $composer_13.g30();
          if (!isInterface(tmp_6, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_1);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_15, -647848379, 'C243@10018L42,241@9909L302:FriendsScreen.kt#7dj0rb');
          HadayaImage(avatarUrl, stringResource(get_friend_pic_desc(string_instance), $composer_15, 0), fillMaxSize(Companion_instance), Companion_getInstance_13().q96_1, $composer_15, 3456, 0);
          sourceInformationMarkerEnd($composer_15);
          $composer_13.e31();
          $composer_10.n30();
        } else {
          $composer_10.m30(516860085);
          sourceInformation($composer_10, '253@10484L11,249@10279L246');
          var tmp_7 = get_Person(Icons_getInstance().dxv_1);
          var tmp_8 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$23 = _Dp___init__impl__ms3zkb(32);
          Icon(tmp_7, null, size(tmp_8, tmp$ret$23), MaterialTheme_instance.unz($composer_10, 6).xnz_1, $composer_10, 432, 0);
          $composer_10.n30();
        }
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_9 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$24 = _Dp___init__impl__ms3zkb(16);
        Spacer(width(tmp_9, tmp$ret$24), $composer_5, 6);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_5 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_16 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_2 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_16, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_17 = $composer_16;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
        var localMap_2 = $composer_17.t31();
        var materialized_2 = materialize($composer_17, modifier_6);
        var tmp0_2 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_18 = $composer_17;
        var tmp_10 = $composer_18.g30();
        if (!isInterface(tmp_10, Applier)) {
          invalidApplier();
        }
        $composer_18.b31();
        if ($composer_18.h30()) {
          $composer_18.c31(tmp0_2);
        } else {
          $composer_18.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_18);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_19 = $composer_18;
        var $composer_20 = $composer_19;
        sourceInformationMarkerStart($composer_20, 706149385, 'C259@10680L65,262@10908L10,260@10762L185:FriendsScreen.kt#7dj0rb');
        var tmp0_text = $friend.vz7_1;
        var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp2_fontSize = get_sp(18);
        var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_14 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp_11, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_12, null, null, tmp_13, tmp_14, false, 0, 0, null, null, $composer_20, 1597440, 0, 262062);
        var tmp3_elvis_lhs = $friend.wz7_1;
        var tmp_15;
        if (tmp3_elvis_lhs == null) {
          $composer_20.m30(1823896052);
          sourceInformation($composer_20, '261@10811L53');
          var tmp0_group = stringResource(get_relationship_not_specified(string_instance), $composer_20, 0);
          $composer_20.n30();
          tmp_15 = tmp0_group;
        } else {
          $composer_20.m30(1823895339);
          $composer_20.n30();
          tmp_15 = tmp3_elvis_lhs;
        }
        var tmp_16 = tmp_15;
        var tmp_17 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_18 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_21 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_16, null, tmp_17, null, tmp_18, null, null, null, tmp_19, null, null, tmp_20, tmp_21, false, 0, 0, null, MaterialTheme_instance.jog($composer_20, 6).pof_1, $composer_20, 0, 0, 131070);
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.text.isNullOrBlank' call
        var this_1 = $friend.xz7_1;
        if (!(this_1 == null || isBlank(this_1))) {
          this_0.q($friend.xz7_1 + ' ');
        }
        // Inline function 'kotlin.text.isNullOrBlank' call
        var this_2 = $friend.yz7_1;
        if (!(this_2 == null || isBlank(this_2))) {
          this_0.q($friend.yz7_1 + ' ');
        }
        // Inline function 'kotlin.text.isNullOrBlank' call
        var this_3 = $friend.zz7_1;
        if (!(this_3 == null || isBlank(this_3))) {
          this_0.q($friend.zz7_1 + ' ');
        }
        // Inline function 'kotlin.text.isNullOrBlank' call
        var this_4 = $friend.az8_1;
        if (!(this_4 == null || isBlank(this_4))) {
          // Inline function 'kotlin.collections.find' call
          var tmp0_3 = get_governorates();
          var tmp$ret$39;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0_3.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              if (element.l11r_1 === $friend.az8_1) {
                tmp$ret$39 = element;
                break $l$block;
              }
            }
            tmp$ret$39 = null;
          }
          var tmp0_safe_receiver_0 = tmp$ret$39;
          var tmp_22;
          if (tmp0_safe_receiver_0 == null) {
            tmp_22 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_22 = $language === 'ar' ? tmp0_safe_receiver_0.m11r_1 : tmp0_safe_receiver_0.l11r_1;
          }
          var tmp1_elvis_lhs = tmp_22;
          var cityName = tmp1_elvis_lhs == null ? $friend.az8_1 : tmp1_elvis_lhs;
          this_0.q(cityName + ' ');
        }
        // Inline function 'kotlin.text.isNullOrBlank' call
        var this_5 = $friend.bz8_1;
        if (!(this_5 == null || isBlank(this_5))) {
          this_0.q($friend.bz8_1);
        }
        // Inline function 'kotlin.text.trim' call
        var this_6 = this_0.toString();
        var displayAddress = toString(trim(isCharSequence(this_6) ? this_6 : THROW_CCE()));
        // Inline function 'kotlin.text.isNotBlank' call
        if (!isBlank(displayAddress)) {
          $composer_20.m30(707286929);
          sourceInformation($composer_20, '283@11992L10,281@11900L178');
          var tmp4_style = MaterialTheme_instance.jog($composer_20, 6).qof_1;
          var tmp5_color = Companion_getInstance_14().k6b_1;
          var tmp_23 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_24 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_25 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_26 = _TextOverflow___init__impl__obguoe(0);
          Text(displayAddress, null, tmp5_color, null, tmp_23, null, null, null, tmp_24, null, null, tmp_25, tmp_26, false, 0, 0, null, tmp4_style, $composer_20, 384, 0, 131066);
          $composer_20.n30();
        } else {
          $composer_20.m30(707475843);
          $composer_20.n30();
        }
        var tmp6_safe_receiver = $friend.ez8_1;
        if (tmp6_safe_receiver == null) {
          $composer_20.m30(707525721);
          $composer_20.n30();
        } else {
          $composer_20.m30(707525722);
          sourceInformation($composer_20, '*291@12267L59,292@12374L10,290@12237L179');
          // Inline function 'kotlin.let' call
          var dateStr = formatTimestamp(tmp6_safe_receiver);
          var tmp_27 = stringResource_0(get_birthday_prefix_pattern(string_instance), [dateStr], $composer_20, 0);
          var tmp_28 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_29 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_30 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_31 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_32 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_27, null, tmp_28, null, tmp_29, null, null, null, tmp_30, null, null, tmp_31, tmp_32, false, 0, 0, null, MaterialTheme_instance.jog($composer_20, 6).qof_1, $composer_20, 0, 0, 131070);
          $composer_20.n30();
        }
        // Inline function 'kotlin.text.isNotBlank' call
        var this_7 = $friend.cz8_1;
        if (!isBlank(this_7)) {
          $composer_20.m30(707883741);
          sourceInformation($composer_20, '298@12549L166,302@12763L10,297@12519L286');
          var tmp_33 = stringResource_0(get_phone_personal_prefix_pattern(string_instance), [$friend.cz8_1], $composer_20, 0);
          var tmp_34 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_35 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_36 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_37 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_38 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_33, null, tmp_34, null, tmp_35, null, null, null, tmp_36, null, null, tmp_37, tmp_38, false, 0, 0, null, MaterialTheme_instance.jog($composer_20, 6).qof_1, $composer_20, 0, 0, 131070);
          $composer_20.n30();
        } else {
          $composer_20.m30(708197027);
          $composer_20.n30();
        }
        // Inline function 'kotlin.text.isNullOrBlank' call
        var this_8 = $friend.dz8_1;
        if (!(this_8 == null || isBlank(this_8))) {
          $composer_20.m30(708268389);
          sourceInformation($composer_20, '307@12937L158,311@13143L10,306@12907L278');
          var tmp_39 = stringResource_0(get_phone_work_prefix_pattern(string_instance), [$friend.dz8_1], $composer_20, 0);
          var tmp_40 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_41 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_42 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_43 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_44 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_39, null, tmp_40, null, tmp_41, null, null, null, tmp_42, null, null, tmp_43, tmp_44, false, 0, 0, null, MaterialTheme_instance.jog($composer_20, 6).qof_1, $composer_20, 0, 0, 131070);
          $composer_20.n30();
        } else {
          $composer_20.m30(708573987);
          $composer_20.n30();
        }
        sourceInformationMarkerEnd($composer_20);
        $composer_18.e31();
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_7 = null;
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = null;
        var $composer_21 = $composer_5;
        if (!((7 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((7 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((7 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_3 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_21, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_22 = $composer_21;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_22, 0).hashCode();
        var localMap_3 = $composer_22.t31();
        var materialized_3 = materialize($composer_22, modifier_8);
        var tmp0_4 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_23 = $composer_22;
        var tmp_45 = $composer_23.g30();
        if (!isInterface(tmp_45, Applier)) {
          invalidApplier();
        }
        $composer_23.b31();
        if ($composer_23.h30()) {
          $composer_23.c31(tmp0_4);
        } else {
          $composer_23.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_23);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_24 = $composer_23;
        var $composer_25 = $composer_24;
        sourceInformationMarkerStart($composer_25, 2020054104, 'C316@13255L283,323@13555L265:FriendsScreen.kt#7dj0rb');
        IconButton($onEdit, null, false, null, null, null, ComposableSingletons$FriendsScreenKt_getInstance().x125_1, $composer_25, 1572864, 62);
        IconButton($onDelete, null, false, null, null, null, ComposableSingletons$FriendsScreenKt_getInstance().y125_1, $composer_25, 1572864, 62);
        sourceInformationMarkerEnd($composer_25);
        $composer_23.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_46;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_46 = Unit_instance;
        }
        tmp = tmp_46;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FriendCard$lambda_0($friend, $language, $onEdit, $onDelete, $$changed) {
    return function ($composer, $force) {
      FriendCard($friend, $language, $onEdit, $onDelete, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_friends_FriendsViewModel$stable;
  function FriendsViewModel$slambda$lambda($lang) {
    return function ($this$updateState) {
      return $this$updateState.i125(VOID, VOID, VOID, VOID, VOID, VOID, $lang);
    };
  }
  function FriendsViewModel$slambda(this$0, resultContinuation) {
    this.g127_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FriendsViewModel$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FriendsViewModel$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FriendsViewModel$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.g127_1.u127(LoadFriends_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FriendsViewModel$slambda).q24 = function ($this$launch, completion) {
    var i = new FriendsViewModel$slambda(this.g127_1, completion);
    i.h127_1 = $this$launch;
    return i;
  };
  function FriendsViewModel$slambda_0(this$0, resultContinuation) {
    var i = new FriendsViewModel$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function FriendsViewModel$slambda_1(this$0, resultContinuation) {
    this.d128_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FriendsViewModel$slambda_1).pyo = function (lang, $completion) {
    var tmp = this.um9(lang, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FriendsViewModel$slambda_1).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FriendsViewModel$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.d128_1.x10k(FriendsViewModel$slambda$lambda(this.e128_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(FriendsViewModel$slambda_1).um9 = function (lang, completion) {
    var i = new FriendsViewModel$slambda_1(this.d128_1, completion);
    i.e128_1 = lang;
    return i;
  };
  function FriendsViewModel$slambda_2(this$0, resultContinuation) {
    var i = new FriendsViewModel$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function (lang, $completion) {
      return i.pyo(lang, $completion);
    }, 1);
  }
  function FriendsViewModel$handleIntent$lambda($this$updateState) {
    return $this$updateState.i125(VOID, true);
  }
  function FriendsViewModel$handleIntent$lambda_0($friends) {
    return function ($this$updateState) {
      return $this$updateState.i125($friends, false);
    };
  }
  function FriendsViewModel$handleIntent$lambda_1($this$updateState) {
    return $this$updateState.i125(VOID, false);
  }
  function FriendsViewModel$handleIntent$lambda_2($this$updateState) {
    return $this$updateState.i125(VOID, VOID, true);
  }
  function FriendsViewModel$handleIntent$lambda_3($this$updateState) {
    return $this$updateState.i125(VOID, VOID, VOID, VOID, VOID, false);
  }
  function FriendsViewModel$handleIntent$lambda_4($this$updateState) {
    return $this$updateState.i125(VOID, VOID, false);
  }
  function FriendsViewModel$handleIntent$lambda_5($this$updateState) {
    return $this$updateState.i125(VOID, VOID, VOID, true);
  }
  function FriendsViewModel$handleIntent$lambda_6($this$updateState) {
    return $this$updateState.i125(VOID, VOID, VOID, VOID, VOID, VOID, VOID, null);
  }
  function FriendsViewModel$handleIntent$lambda_7($this$updateState) {
    return $this$updateState.i125(VOID, VOID, VOID, false);
  }
  function FriendsViewModel$handleIntent$lambda_8($this$updateState) {
    return $this$updateState.i125(VOID, VOID, VOID, VOID, true);
  }
  function FriendsViewModel$handleIntent$lambda_9($this$updateState) {
    return $this$updateState.i125(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null);
  }
  function FriendsViewModel$handleIntent$lambda_10($this$updateState) {
    return $this$updateState.i125(VOID, VOID, VOID, VOID, false);
  }
  function FriendsViewModel$handleIntent$lambda_11($intent) {
    return function ($this$updateState) {
      return $this$updateState.i125(VOID, VOID, VOID, VOID, VOID, $intent.o125_1);
    };
  }
  function FriendsViewModel$handleIntent$lambda_12($intent) {
    return function ($this$updateState) {
      return $this$updateState.i125(VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.p125_1);
    };
  }
  function FriendsViewModel$handleIntent$lambda_13($intent) {
    return function ($this$updateState) {
      return $this$updateState.i125(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.q125_1);
    };
  }
  function $handleIntentCOROUTINE$_7(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n128_1 = _this__u8e3s4;
    this.o128_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_7).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 41;
            var tmp0_subject = this.o128_1;
            if (equals(tmp0_subject, LoadFriends_instance)) {
              this.n128_1.x10k(FriendsViewModel$handleIntent$lambda);
              this.o9_1 = 37;
              this.n9_1 = 36;
              suspendResult = this.n128_1.m127_1.s103(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof AddFriend_0) {
                this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_2);
                this.n9_1 = 23;
                continue $sm;
              } else {
                if (tmp0_subject instanceof UpdateFriend) {
                  this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_5);
                  this.n9_1 = 11;
                  continue $sm;
                } else {
                  if (tmp0_subject instanceof DeleteFriend) {
                    this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_8);
                    this.n9_1 = 1;
                    continue $sm;
                  } else {
                    if (tmp0_subject instanceof ToggleAddFriendDialog_0) {
                      this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_11(this.o128_1));
                      this.n9_1 = 40;
                      continue $sm;
                    } else {
                      if (tmp0_subject instanceof ShowEditFriendDialog) {
                        this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_12(this.o128_1));
                        this.n9_1 = 40;
                        continue $sm;
                      } else {
                        if (tmp0_subject instanceof ShowDeleteFriendDialog) {
                          this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_13(this.o128_1));
                          this.n9_1 = 40;
                          continue $sm;
                        } else {
                          noWhenBranchMatchedException();
                        }
                      }
                    }
                  }
                }
              }
            }

            break;
          case 1:
            this.o9_1 = 10;
            this.o9_1 = 7;
            var tmp0 = this.n128_1.s10h().ajg().u1().y124_1;
            var tmp$ret$6 = Unit_instance;
            l$ret$7: do {
              var _iterator__ex2g4s = tmp0.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (element.tz7_1 === this.o128_1.n125_1) {
                  tmp$ret$6 = element;
                  break l$ret$7;
                }
              }
              tmp$ret$6 = null;
            }
             while (false);
            var friendToDelete = tmp$ret$6;
            var tmp10_safe_receiver = friendToDelete == null ? null : friendToDelete.fz8_1;
            if (tmp10_safe_receiver == null) {
              this.s128_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = this.n128_1.r127_1.pyo(tmp10_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            var tmp_0 = this;
            tmp_0.s128_1 = Unit_instance;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            suspendResult = this.n128_1.q127_1.pyo(this.o128_1.n125_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_9);
            this.n9_1 = 5;
            suspendResult = this.n128_1.d10l(FriendDeleted_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.n9_1 = 6;
            suspendResult = this.n128_1.u127(LoadFriends_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.o9_1 = 41;
            this.n9_1 = 9;
            continue $sm;
          case 7:
            this.o9_1 = 10;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Exception) {
              var e = this.q9_1;
              this.n9_1 = 8;
              var tmp11_safe_receiver = e.message;
              var tmp_2;
              if (tmp11_safe_receiver == null) {
                tmp_2 = null;
              } else {
                tmp_2 = new DynamicString(tmp11_safe_receiver);
              }
              var tmp12_elvis_lhs = tmp_2;
              suspendResult = this.n128_1.d10l(new ShowError_3(tmp12_elvis_lhs == null ? new ResourceString(get_unknown_error(string_instance), []) : tmp12_elvis_lhs), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 8:
            this.o9_1 = 41;
            this.n9_1 = 9;
            continue $sm;
          case 9:
            this.o9_1 = 41;
            this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_10);
            this.n9_1 = 40;
            continue $sm;
          case 10:
            this.o9_1 = 41;
            var t = this.q9_1;
            this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_10);
            throw t;
          case 11:
            this.o9_1 = 22;
            this.o9_1 = 19;
            var tmp0_0 = this.n128_1.s10h().ajg().u1().y124_1;
            var tmp$ret$2 = Unit_instance;
            l$ret$3: do {
              var _iterator__ex2g4s_0 = tmp0_0.t();
              while (_iterator__ex2g4s_0.u()) {
                var element_0 = _iterator__ex2g4s_0.v();
                if (element_0.tz7_1 == this.o128_1.l125_1.tz7_1) {
                  tmp$ret$2 = element_0;
                  break l$ret$3;
                }
              }
              tmp$ret$2 = null;
            }
             while (false);
            var oldFriend = tmp$ret$2;
            this.q128_1 = this.o128_1.l125_1;
            if (!(this.o128_1.m125_1 == null) && !(this.o128_1.l125_1.tz7_1 == null)) {
              var tmp6_safe_receiver = oldFriend == null ? null : oldFriend.fz8_1;
              if (tmp6_safe_receiver == null) {
                this.r128_1 = null;
                this.n9_1 = 13;
                continue $sm;
              } else {
                this.n9_1 = 12;
                suspendResult = this.n128_1.r127_1.pyo(tmp6_safe_receiver, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              this.n9_1 = 15;
              continue $sm;
            }

          case 12:
            var tmp_3 = this;
            tmp_3.r128_1 = Unit_instance;
            this.n9_1 = 13;
            continue $sm;
          case 13:
            this.n9_1 = 14;
            suspendResult = this.n128_1.o127_1.w103(this.o128_1.l125_1.tz7_1, this.o128_1.m125_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 14:
            var imageUrl = suspendResult;
            this.q128_1 = this.q128_1.gz8(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, imageUrl);
            this.n9_1 = 15;
            continue $sm;
          case 15:
            this.n9_1 = 16;
            suspendResult = this.n128_1.p127_1.u103(this.q128_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 16:
            this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_6);
            this.n9_1 = 17;
            suspendResult = this.n128_1.d10l(FriendUpdated_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 17:
            this.n9_1 = 18;
            suspendResult = this.n128_1.u127(LoadFriends_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 18:
            this.o9_1 = 41;
            this.n9_1 = 21;
            continue $sm;
          case 19:
            this.o9_1 = 22;
            var tmp_4 = this.q9_1;
            if (tmp_4 instanceof Exception) {
              var e_0 = this.q9_1;
              this.n9_1 = 20;
              var tmp7_safe_receiver = e_0.message;
              var tmp_5;
              if (tmp7_safe_receiver == null) {
                tmp_5 = null;
              } else {
                tmp_5 = new DynamicString(tmp7_safe_receiver);
              }
              var tmp8_elvis_lhs = tmp_5;
              suspendResult = this.n128_1.d10l(new ShowError_3(tmp8_elvis_lhs == null ? new ResourceString(get_unknown_error(string_instance), []) : tmp8_elvis_lhs), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 20:
            this.o9_1 = 41;
            this.n9_1 = 21;
            continue $sm;
          case 21:
            this.o9_1 = 41;
            this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_7);
            this.n9_1 = 40;
            continue $sm;
          case 22:
            this.o9_1 = 41;
            var t_0 = this.q9_1;
            this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_7);
            throw t_0;
          case 23:
            this.o9_1 = 35;
            this.o9_1 = 32;
            var currentUser = this.n128_1.s127_1.ynu();
            if (!(currentUser == null)) {
              var friendWithUserId = this.o128_1.j125_1.gz8(VOID, currentUser.uym_1);
              this.n9_1 = 25;
              suspendResult = this.n128_1.n127_1.o103(friendWithUserId, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 24;
              suspendResult = this.n128_1.d10l(new ShowError_3(new ResourceString(get_user_not_logged_in(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 24:
            this.n9_1 = 31;
            continue $sm;
          case 25:
            this.p128_1 = suspendResult;
            if (!(this.p128_1.tz7_1 == null) && !(this.o128_1.k125_1 == null)) {
              this.n9_1 = 26;
              suspendResult = this.n128_1.o127_1.w103(this.p128_1.tz7_1, this.o128_1.k125_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 28;
              continue $sm;
            }

          case 26:
            var imageUrl_0 = suspendResult;
            this.n9_1 = 27;
            suspendResult = this.n128_1.p127_1.u103(this.p128_1.gz8(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, imageUrl_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 27:
            this.n9_1 = 28;
            continue $sm;
          case 28:
            this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_3);
            this.n9_1 = 29;
            suspendResult = this.n128_1.d10l(FriendAdded_instance_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 29:
            this.n9_1 = 30;
            suspendResult = this.n128_1.u127(LoadFriends_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 30:
            this.n9_1 = 31;
            continue $sm;
          case 31:
            this.o9_1 = 41;
            this.n9_1 = 34;
            continue $sm;
          case 32:
            this.o9_1 = 35;
            var tmp_6 = this.q9_1;
            if (tmp_6 instanceof Exception) {
              var e_1 = this.q9_1;
              this.n9_1 = 33;
              var tmp3_safe_receiver = e_1.message;
              var tmp_7;
              if (tmp3_safe_receiver == null) {
                tmp_7 = null;
              } else {
                tmp_7 = new DynamicString(tmp3_safe_receiver);
              }
              var tmp4_elvis_lhs = tmp_7;
              suspendResult = this.n128_1.d10l(new ShowError_3(tmp4_elvis_lhs == null ? new ResourceString(get_unknown_error(string_instance), []) : tmp4_elvis_lhs), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 33:
            this.o9_1 = 41;
            this.n9_1 = 34;
            continue $sm;
          case 34:
            this.o9_1 = 41;
            this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_4);
            this.n9_1 = 40;
            continue $sm;
          case 35:
            this.o9_1 = 41;
            var t_1 = this.q9_1;
            this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_4);
            throw t_1;
          case 36:
            var friends = suspendResult;
            this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_0(friends));
            this.o9_1 = 41;
            this.n9_1 = 39;
            continue $sm;
          case 37:
            this.o9_1 = 41;
            var tmp_8 = this.q9_1;
            if (tmp_8 instanceof Exception) {
              var e_2 = this.q9_1;
              this.n128_1.x10k(FriendsViewModel$handleIntent$lambda_1);
              this.n9_1 = 38;
              var tmp1_safe_receiver = e_2.message;
              var tmp_9;
              if (tmp1_safe_receiver == null) {
                tmp_9 = null;
              } else {
                tmp_9 = new DynamicString(tmp1_safe_receiver);
              }
              var tmp2_elvis_lhs = tmp_9;
              suspendResult = this.n128_1.d10l(new ShowError_3(tmp2_elvis_lhs == null ? new ResourceString(get_unknown_error(string_instance), []) : tmp2_elvis_lhs), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 38:
            this.n9_1 = 39;
            continue $sm;
          case 39:
            this.o9_1 = 41;
            this.n9_1 = 40;
            continue $sm;
          case 40:
            return Unit_instance;
          case 41:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_3 = $p;
        if (this.o9_1 === 41) {
          throw e_3;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_3;
        }
      }
     while (true);
  };
  function FriendsViewModel(getFriendsUseCase, addFriendUseCase, uploadFriendAvatarUseCase, updateFriendUseCase, deleteFriendUseCase, deleteFriendAvatarUseCase, getCurrentUserValueUseCase, authRepository) {
    BaseMviViewModel.call(this, new FriendsState());
    this.m127_1 = getFriendsUseCase;
    this.n127_1 = addFriendUseCase;
    this.o127_1 = uploadFriendAvatarUseCase;
    this.p127_1 = updateFriendUseCase;
    this.q127_1 = deleteFriendUseCase;
    this.r127_1 = deleteFriendAvatarUseCase;
    this.s127_1 = getCurrentUserValueUseCase;
    this.t127_1 = authRepository;
    var tmp = get_viewModelScope(this);
    launch(tmp, VOID, VOID, FriendsViewModel$slambda_0(this, null));
    var tmp_0 = this.t127_1.n8m();
    launchIn(onEach(tmp_0, FriendsViewModel$slambda_2(this, null)), get_viewModelScope(this));
  }
  protoOf(FriendsViewModel).u127 = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_7(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FriendsViewModel).f10l = function (intent, $completion) {
    return this.u127(isInterface(intent, FriendsIntent) ? intent : THROW_CCE(), $completion);
  };
  function EditCustomMagicMugScreen(cartItemId, onBack, onNavigateToEditor, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1860053425);
    sourceInformation($composer_0, 'C(EditCustomMagicMugScreen)41@1850L20,42@1915L15,43@1974L16,44@2019L32,46@2078L88,46@2057L109,49@2183L24,50@2238L569,50@2212L595,67@2884L824,67@2838L35,89@3710L831,67@2814L1727:EditMagicMugDesignScreen.kt#mu900e');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(cartItemId) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToEditor) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1860053425, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.EditCustomMagicMugScreen (EditMagicMugDesignScreen.kt:40)');
      }
      PreventScreenshots($composer_0, 0);
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(EditMugDesignViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, -804937041, 'CC(remember):EditMagicMugDesignScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance().f30_1) {
        var value = new SnackbarHostState();
        this_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp0_group;
      sourceInformationMarkerStart($composer_0, -804935097, 'CC(remember):EditMagicMugDesignScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_0.q31(viewModel) | ($dirty & 14) === 4);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_0.i31();
      var tmp_2;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = EditCustomMagicMugScreen$slambda_0(viewModel, cartItemId, null);
        tmp0_0.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(Unit_instance, tmp1_group, $composer_0, 6);
      // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
      var getContext = null;
      var $composer_2 = $composer_0;
      if (!((1 & 1) === 0)) {
        getContext = EditCustomMagicMugScreen$lambda_0;
      }
      var composer = $composer_2;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_1 = $composer_2.i31();
      var tmp_3;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = createCompositionCoroutineScope(getContext(), composer);
        $composer_2.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var scope_0 = tmp_3;
      sourceInformationMarkerStart($composer_0, -804929496, 'CC(remember):EditMagicMugDesignScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(!!(!!($composer_0.q31(viewModel) | $composer_0.q31(scope_0)) | ($dirty & 112) === 32) | ($dirty & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_1.i31();
      var tmp_4;
      if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = EditCustomMagicMugScreen$slambda_2(viewModel, scope_0, onBack, onNavigateToEditor, snackbarHostState, null);
        tmp0_1.j31(value_2);
        tmp_4 = value_2;
      } else {
        tmp_4 = it_2;
      }
      var tmp2_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp2_group, $composer_0, 0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(764151315, true, EditCustomMagicMugScreen$lambda_1(state$delegate, onBack), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_3.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_3 = $composer_3.i31();
      var tmp_5;
      if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_3.j31(value_3);
        tmp_5 = value_3;
      } else {
        tmp_5 = it_3;
      }
      var tmp_6 = tmp_5;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_0 = rememberComposableLambda(-1005320299, true, EditCustomMagicMugScreen$lambda_2(snackbarHostState), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_4 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = $composer_4.k31(dispatchReceiver_0);
      // Inline function 'kotlin.let' call
      var it_4 = $composer_4.i31();
      var tmp_7;
      if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = ComposableLambda$invoke$ref(dispatchReceiver_0);
        $composer_4.j31(value_4);
        tmp_7 = value_4;
      } else {
        tmp_7 = it_4;
      }
      var tmp_8 = tmp_7;
      var tmp_9 = _FabPosition___init__impl__9ib2hj(0);
      var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      // Inline function 'kotlin.run' call
      var dispatchReceiver_1 = rememberComposableLambda(-235724002, true, EditCustomMagicMugScreen$lambda_3(viewModel, state$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_5 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = $composer_5.k31(dispatchReceiver_1);
      // Inline function 'kotlin.let' call
      var it_5 = $composer_5.i31();
      var tmp_12;
      if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
        var value_5 = ComposableLambda$invoke$ref_2(dispatchReceiver_1);
        $composer_5.j31(value_5);
        tmp_12 = value_5;
      } else {
        tmp_12 = it_5;
      }
      var tmp$ret$33 = tmp_12;
      Scaffold(null, tmp_6, null, tmp_8, null, tmp_9, tmp_10, tmp_11, null, tmp$ret$33, $composer_0, 805309488, 501);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp3_safe_receiver = $composer_0.t30();
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.p3c(EditCustomMagicMugScreen$lambda_4(cartItemId, onBack, onNavigateToEditor, $changed));
    }
  }
  function ComposableSingletons$EditMagicMugDesignScreenKt$lambda$1149264266$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C76@3289L31,74@3169L177:EditMagicMugDesignScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1149264266, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$EditMagicMugDesignScreenKt.lambda$1149264266.<anonymous> (EditMagicMugDesignScreen.kt:74)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$EditMagicMugDesignScreenKt() {
    ComposableSingletons$EditMagicMugDesignScreenKt_instance = this;
    var tmp = this;
    tmp.t128_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1149264266, false, ComposableSingletons$EditMagicMugDesignScreenKt$lambda$1149264266$lambda));
  }
  var ComposableSingletons$EditMagicMugDesignScreenKt_instance;
  function ComposableSingletons$EditMagicMugDesignScreenKt_getInstance() {
    if (ComposableSingletons$EditMagicMugDesignScreenKt_instance == null)
      new ComposableSingletons$EditMagicMugDesignScreenKt();
    return ComposableSingletons$EditMagicMugDesignScreenKt_instance;
  }
  function EditCustomMagicMugScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function EditCustomMagicMugScreen$slambda($viewModel, $cartItemId, resultContinuation) {
    this.c129_1 = $viewModel;
    this.d129_1 = $cartItemId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditCustomMagicMugScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(EditCustomMagicMugScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditCustomMagicMugScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.c129_1.s10h().j10i(new LoadCartItem(this.d129_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(EditCustomMagicMugScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new EditCustomMagicMugScreen$slambda(this.c129_1, this.d129_1, completion);
    i.e129_1 = $this$LaunchedEffect;
    return i;
  };
  function EditCustomMagicMugScreen$slambda_0($viewModel, $cartItemId, resultContinuation) {
    var i = new EditCustomMagicMugScreen$slambda($viewModel, $cartItemId, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function EditCustomMagicMugScreen$lambda_0() {
    return EmptyCoroutineContext_getInstance();
  }
  function EditCustomMagicMugScreen$slambda$slambda$slambda($snackbarHostState, $effect, resultContinuation) {
    this.n129_1 = $snackbarHostState;
    this.o129_1 = $effect;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditCustomMagicMugScreen$slambda$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(EditCustomMagicMugScreen$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditCustomMagicMugScreen$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.o129_1.q129_1.z10i(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.n129_1.dqm(ARGUMENT, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditCustomMagicMugScreen$slambda$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new EditCustomMagicMugScreen$slambda$slambda$slambda(this.n129_1, this.o129_1, completion);
    i.p129_1 = $this$launch;
    return i;
  };
  function EditCustomMagicMugScreen$slambda$slambda$slambda_0($snackbarHostState, $effect, resultContinuation) {
    var i = new EditCustomMagicMugScreen$slambda$slambda$slambda($snackbarHostState, $effect, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_13(function_0) {
    this.r129_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_13).a1v = function (value, $completion) {
    return this.r129_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_13).q3 = function () {
    return this.r129_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_13).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_13).hashCode = function () {
    return hashCode(this.q3());
  };
  function EditCustomMagicMugScreen$slambda$slambda($scope, $onBack, $onNavigateToEditor, $snackbarHostState, resultContinuation) {
    this.a12a_1 = $scope;
    this.b12a_1 = $onBack;
    this.c12a_1 = $onNavigateToEditor;
    this.d12a_1 = $snackbarHostState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditCustomMagicMugScreen$slambda$slambda).f12a = function (effect, $completion) {
    var tmp = this.g12a(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(EditCustomMagicMugScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.f12a((!(p1 == null) ? isInterface(p1, EditMugDesignSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditCustomMagicMugScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0_subject = this.e12a_1;
          if (tmp0_subject instanceof ShowMessage_0) {
            launch(this.a12a_1, VOID, VOID, EditCustomMagicMugScreen$slambda$slambda$slambda_0(this.d12a_1, this.e12a_1, null));
          } else {
            if (equals(tmp0_subject, NavigateBack_instance))
              this.b12a_1();
            else {
              if (tmp0_subject instanceof NavigateToEditor)
                this.c12a_1(this.e12a_1.h12a_1);
              else {
                if (!(tmp0_subject instanceof Model3D_1)) {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(EditCustomMagicMugScreen$slambda$slambda).g12a = function (effect, completion) {
    var i = new EditCustomMagicMugScreen$slambda$slambda(this.a12a_1, this.b12a_1, this.c12a_1, this.d12a_1, completion);
    i.e12a_1 = effect;
    return i;
  };
  function EditCustomMagicMugScreen$slambda$slambda_0($scope, $onBack, $onNavigateToEditor, $snackbarHostState, resultContinuation) {
    var i = new EditCustomMagicMugScreen$slambda$slambda($scope, $onBack, $onNavigateToEditor, $snackbarHostState, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.f12a(effect, $completion);
    }, 1);
  }
  function EditCustomMagicMugScreen$slambda_1($viewModel, $scope, $onBack, $onNavigateToEditor, $snackbarHostState, resultContinuation) {
    this.q12a_1 = $viewModel;
    this.r12a_1 = $scope;
    this.s12a_1 = $onBack;
    this.t12a_1 = $onNavigateToEditor;
    this.u12a_1 = $snackbarHostState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditCustomMagicMugScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(EditCustomMagicMugScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditCustomMagicMugScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.q12a_1.s10h().t10h();
            var tmp_1 = EditCustomMagicMugScreen$slambda$slambda_0(this.r12a_1, this.s12a_1, this.t12a_1, this.u12a_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_13(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditCustomMagicMugScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new EditCustomMagicMugScreen$slambda_1(this.q12a_1, this.r12a_1, this.s12a_1, this.t12a_1, this.u12a_1, completion);
    i.v12a_1 = $this$LaunchedEffect;
    return i;
  };
  function EditCustomMagicMugScreen$slambda_2($viewModel, $scope, $onBack, $onNavigateToEditor, $snackbarHostState, resultContinuation) {
    var i = new EditCustomMagicMugScreen$slambda_1($viewModel, $scope, $onBack, $onNavigateToEditor, $snackbarHostState, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function EditCustomMagicMugScreen$lambda$lambda($title) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C71@3044L11:EditMagicMugDesignScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-312359382, $changed, -1, 'client.fstech.hadaya.presentation.model3d.EditCustomMagicMugScreen.<anonymous>.<anonymous> (EditMagicMugDesignScreen.kt:71)');
        }
        var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text($title, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function EditCustomMagicMugScreen$lambda$lambda_0($onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C73@3114L254:EditMagicMugDesignScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1186024984, $changed, -1, 'client.fstech.hadaya.presentation.model3d.EditCustomMagicMugScreen.<anonymous>.<anonymous> (EditMagicMugDesignScreen.kt:73)');
        }
        IconButton($onBack, null, false, null, null, null, ComposableSingletons$EditMagicMugDesignScreenKt_getInstance().t128_1, $composer_0, 1572864, 62);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function EditCustomMagicMugScreen$lambda$lambda_1($state$delegate) {
    return function ($this$TopAppBar, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:EditMagicMugDesignScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2045974753, $changed, -1, 'client.fstech.hadaya.presentation.model3d.EditCustomMagicMugScreen.<anonymous>.<anonymous> (EditMagicMugDesignScreen.kt:81)');
        }
        if (EditCustomMagicMugScreen$lambda($state$delegate).a12b_1) {
          $composer_0.m30(-1752919206);
          sourceInformation($composer_0, '82@3484L153');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
          var tmp_2 = padding_1(tmp_1, VOID, VOID, tmp$ret$1);
          var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_4 = _Dp___init__impl__ms3zkb(2);
          var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_6 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, _Dp___init__impl__ms3zkb(0.0), $composer_0, 390, 58);
          $composer_0.n30();
        } else {
          $composer_0.m30(-1752726045);
          $composer_0.n30();
        }
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function EditCustomMagicMugScreen$lambda_1($state$delegate, $onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:EditMagicMugDesignScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(764151315, $changed, -1, 'client.fstech.hadaya.presentation.model3d.EditCustomMagicMugScreen.<anonymous> (EditMagicMugDesignScreen.kt:68)');
        }
        if (!EditCustomMagicMugScreen$lambda($state$delegate).z12a_1.j12b_1) {
          $composer_0.m30(1505225931);
          sourceInformation($composer_0, '69@2956L38,71@3042L15,72@3092L294,80@3414L263,70@3007L685');
          var title = stringResource(get__3d_preview(string_instance), $composer_0, 0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-312359382, true, EditCustomMagicMugScreen$lambda$lambda(title), $composer_0, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_1 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_1.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it = $composer_1.i31();
          var tmp_0;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_1.j31(value);
            tmp_0 = value;
          } else {
            tmp_0 = it;
          }
          var tmp_1 = tmp_0;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_0 = rememberComposableLambda(-1186024984, true, EditCustomMagicMugScreen$lambda$lambda_0($onBack), $composer_0, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_2 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = $composer_2.k31(dispatchReceiver_0);
          // Inline function 'kotlin.let' call
          var it_0 = $composer_2.i31();
          var tmp_2;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = ComposableLambda$invoke$ref(dispatchReceiver_0);
            $composer_2.j31(value_0);
            tmp_2 = value_0;
          } else {
            tmp_2 = it_0;
          }
          var tmp_3 = tmp_2;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_1 = rememberComposableLambda(-2045974753, true, EditCustomMagicMugScreen$lambda$lambda_1($state$delegate), $composer_0, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_3 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_1 = $composer_3.k31(dispatchReceiver_1);
          // Inline function 'kotlin.let' call
          var it_1 = $composer_3.i31();
          var tmp_4;
          if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
            var value_1 = ComposableLambda$invoke$ref_1(dispatchReceiver_1);
            $composer_3.j31(value_1);
            tmp_4 = value_1;
          } else {
            tmp_4 = it_1;
          }
          var tmp_5 = tmp_4;
          var tmp_6 = _Dp___init__impl__ms3zkb(0.0);
          TopAppBar(tmp_1, null, tmp_3, tmp_5, tmp_6, null, null, null, $composer_0, 3462, 242);
          $composer_0.n30();
        } else {
          $composer_0.m30(1505967823);
          $composer_0.n30();
        }
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function EditCustomMagicMugScreen$lambda_2($snackbarHostState) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C67@2840L31:EditMagicMugDesignScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1005320299, $changed, -1, 'client.fstech.hadaya.presentation.model3d.EditCustomMagicMugScreen.<anonymous> (EditMagicMugDesignScreen.kt:67)');
        }
        SnackbarHost($snackbarHostState, null, null, $composer_0, 6, 6);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function EditCustomMagicMugScreen$lambda$lambda_2($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new Model3D_0(it));
      return Unit_instance;
    };
  }
  function EditCustomMagicMugScreen$lambda_3($viewModel, $state$delegate) {
    return function (padding_0, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C91@3732L803:EditMagicMugDesignScreen.kt#mu900e');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31(padding_0) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-235724002, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.EditCustomMagicMugScreen.<anonymous> (EditMagicMugDesignScreen.kt:91)');
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = fillMaxSize(padding(Companion_instance, padding_0));
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((4 & 1) === 0))
          modifier = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -2124642668, 'C:EditMagicMugDesignScreen.kt#mu900e');
        if (EditCustomMagicMugScreen$lambda($state$delegate).w12a_1 || EditCustomMagicMugScreen$lambda($state$delegate).z12a_1.c12b_1) {
          $composer_5.m30(-2124612785);
          sourceInformation($composer_5, '96@3929L27');
          var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(null, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_5, 0, 63);
          $composer_5.n30();
        } else if (!(EditCustomMagicMugScreen$lambda($state$delegate).x12a_1 == null)) {
          $composer_5.m30(-2124523753);
          sourceInformation($composer_5, '98@4019L19');
          var tmp_6 = ensureNotNull(EditCustomMagicMugScreen$lambda($state$delegate).x12a_1);
          var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_11 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_6, null, tmp_7, null, tmp_8, null, null, null, tmp_9, null, null, tmp_10, tmp_11, false, 0, 0, null, null, $composer_5, 0, 0, 262142);
          $composer_5.n30();
        } else if (!(EditCustomMagicMugScreen$lambda($state$delegate).z12a_1.d12b_1 == null)) {
          $composer_5.m30(-2124428769);
          sourceInformation($composer_5, '100@4146L10,100@4114L43');
          var tmp_12 = ensureNotNull(EditCustomMagicMugScreen$lambda($state$delegate).z12a_1.d12b_1).s11k($composer_5, 0);
          var tmp_13 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_15 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_17 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_12, null, tmp_13, null, tmp_14, null, null, null, tmp_15, null, null, tmp_16, tmp_17, false, 0, 0, null, null, $composer_5, 0, 0, 262142);
          $composer_5.n30();
        } else {
          $composer_5.m30(-2124339954);
          sourceInformation($composer_5, '105@4298L63,103@4196L315');
          var tmp_18 = EditCustomMagicMugScreen$lambda($state$delegate).z12a_1;
          sourceInformationMarkerStart($composer_5, -761260169, 'CC(remember):EditMagicMugDesignScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_5.q31($viewModel);
          // Inline function 'kotlin.let' call
          var it = $composer_5.i31();
          var tmp_19;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = EditCustomMagicMugScreen$lambda$lambda_2($viewModel);
            $composer_5.j31(value);
            tmp_19 = value;
          } else {
            tmp_19 = it;
          }
          var tmp0_group = tmp_19;
          sourceInformationMarkerEnd($composer_5);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$10 = _Dp___init__impl__ms3zkb(0);
          var tmp_20 = PaddingValues_1(tmp$ret$10);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_21 = _Dp___init__impl__ms3zkb(64);
          ModelMugScreenContent(tmp_18, tmp0_group, tmp_20, true, tmp_21, _Dp___init__impl__ms3zkb(0.0), $composer_5, 28032, 32);
          $composer_5.n30();
        }
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_22;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_22 = Unit_instance;
        }
        tmp_0 = tmp_22;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function EditCustomMagicMugScreen$lambda_4($cartItemId, $onBack, $onNavigateToEditor, $$changed) {
    return function ($composer, $force) {
      EditCustomMagicMugScreen($cartItemId, $onBack, $onNavigateToEditor, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_model3d_EditMugDesignState$stable;
  var client_fstech_hadaya_presentation_model3d_EditMugDesignIntent_LoadCartItem$stable;
  var client_fstech_hadaya_presentation_model3d_EditMugDesignIntent_Model3D$stable;
  var client_fstech_hadaya_presentation_model3d_EditMugDesignIntent_UpdateMugDesign$stable;
  var client_fstech_hadaya_presentation_model3d_EditMugDesignSideEffect_ShowMessage$stable;
  var client_fstech_hadaya_presentation_model3d_EditMugDesignSideEffect_NavigateBack$stable;
  var client_fstech_hadaya_presentation_model3d_EditMugDesignSideEffect_NavigateToEditor$stable;
  var client_fstech_hadaya_presentation_model3d_EditMugDesignSideEffect_Model3D$stable;
  function EditMugDesignState(loading, error, cartItem, model3DState, isUpdating, language) {
    loading = loading === VOID ? false : loading;
    error = error === VOID ? null : error;
    cartItem = cartItem === VOID ? null : cartItem;
    model3DState = model3DState === VOID ? new Model3DState() : model3DState;
    isUpdating = isUpdating === VOID ? false : isUpdating;
    language = language === VOID ? 'en' : language;
    this.w12a_1 = loading;
    this.x12a_1 = error;
    this.y12a_1 = cartItem;
    this.z12a_1 = model3DState;
    this.a12b_1 = isUpdating;
    this.b12b_1 = language;
  }
  protoOf(EditMugDesignState).c12c = function (loading, error, cartItem, model3DState, isUpdating, language) {
    return new EditMugDesignState(loading, error, cartItem, model3DState, isUpdating, language);
  };
  protoOf(EditMugDesignState).d12c = function (loading, error, cartItem, model3DState, isUpdating, language, $super) {
    loading = loading === VOID ? this.w12a_1 : loading;
    error = error === VOID ? this.x12a_1 : error;
    cartItem = cartItem === VOID ? this.y12a_1 : cartItem;
    model3DState = model3DState === VOID ? this.z12a_1 : model3DState;
    isUpdating = isUpdating === VOID ? this.a12b_1 : isUpdating;
    language = language === VOID ? this.b12b_1 : language;
    return $super === VOID ? this.c12c(loading, error, cartItem, model3DState, isUpdating, language) : $super.c12c.call(this, loading, error, cartItem, model3DState, isUpdating, language);
  };
  protoOf(EditMugDesignState).toString = function () {
    return 'EditMugDesignState(loading=' + this.w12a_1 + ', error=' + this.x12a_1 + ', cartItem=' + toString_0(this.y12a_1) + ', model3DState=' + this.z12a_1.toString() + ', isUpdating=' + this.a12b_1 + ', language=' + this.b12b_1 + ')';
  };
  protoOf(EditMugDesignState).hashCode = function () {
    var result = getBooleanHashCode(this.w12a_1);
    result = imul(result, 31) + (this.x12a_1 == null ? 0 : getStringHashCode(this.x12a_1)) | 0;
    result = imul(result, 31) + (this.y12a_1 == null ? 0 : this.y12a_1.hashCode()) | 0;
    result = imul(result, 31) + this.z12a_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a12b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b12b_1) | 0;
    return result;
  };
  protoOf(EditMugDesignState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EditMugDesignState))
      return false;
    if (!(this.w12a_1 === other.w12a_1))
      return false;
    if (!(this.x12a_1 == other.x12a_1))
      return false;
    if (!equals(this.y12a_1, other.y12a_1))
      return false;
    if (!this.z12a_1.equals(other.z12a_1))
      return false;
    if (!(this.a12b_1 === other.a12b_1))
      return false;
    if (!(this.b12b_1 === other.b12b_1))
      return false;
    return true;
  };
  function LoadCartItem(cartItemId) {
    this.e12c_1 = cartItemId;
  }
  protoOf(LoadCartItem).toString = function () {
    return 'LoadCartItem(cartItemId=' + this.e12c_1 + ')';
  };
  protoOf(LoadCartItem).hashCode = function () {
    return getStringHashCode(this.e12c_1);
  };
  protoOf(LoadCartItem).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadCartItem))
      return false;
    if (!(this.e12c_1 === other.e12c_1))
      return false;
    return true;
  };
  function Model3D_0(intent) {
    this.f12c_1 = intent;
  }
  protoOf(Model3D_0).toString = function () {
    return 'Model3D(intent=' + toString(this.f12c_1) + ')';
  };
  protoOf(Model3D_0).hashCode = function () {
    return hashCode(this.f12c_1);
  };
  protoOf(Model3D_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Model3D_0))
      return false;
    if (!equals(this.f12c_1, other.f12c_1))
      return false;
    return true;
  };
  function UpdateMugDesign(snapshotBitmap) {
    snapshotBitmap = snapshotBitmap === VOID ? null : snapshotBitmap;
    this.g12c_1 = snapshotBitmap;
  }
  protoOf(UpdateMugDesign).toString = function () {
    return 'UpdateMugDesign(snapshotBitmap=' + toString_0(this.g12c_1) + ')';
  };
  protoOf(UpdateMugDesign).hashCode = function () {
    return this.g12c_1 == null ? 0 : hashCode(this.g12c_1);
  };
  protoOf(UpdateMugDesign).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateMugDesign))
      return false;
    if (!equals(this.g12c_1, other.g12c_1))
      return false;
    return true;
  };
  function EditMugDesignIntent() {
  }
  function ShowMessage_0(message) {
    this.q129_1 = message;
  }
  protoOf(ShowMessage_0).toString = function () {
    return 'ShowMessage(message=' + toString(this.q129_1) + ')';
  };
  protoOf(ShowMessage_0).hashCode = function () {
    return hashCode(this.q129_1);
  };
  protoOf(ShowMessage_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowMessage_0))
      return false;
    if (!equals(this.q129_1, other.q129_1))
      return false;
    return true;
  };
  function NavigateBack() {
  }
  protoOf(NavigateBack).toString = function () {
    return 'NavigateBack';
  };
  protoOf(NavigateBack).hashCode = function () {
    return -1975964853;
  };
  protoOf(NavigateBack).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateBack))
      return false;
    return true;
  };
  var NavigateBack_instance;
  function NavigateBack_getInstance() {
    return NavigateBack_instance;
  }
  function NavigateToEditor() {
  }
  function Model3D_1() {
  }
  function EditMugDesignSideEffect() {
  }
  function EditMugDesignScreen(cartItemId, onBack, onNavigateToEditor, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(114644132);
    sourceInformation($composer_0, 'C(EditMugDesignScreen)46@2088L20,47@2153L15,48@2212L16,49@2257L32,51@2343L63,53@2433L88,53@2412L109,56@2538L24,57@2593L634,57@2567L660,74@3233L2108:EditMugDesignScreen.kt#mu900e');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(cartItemId) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToEditor) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(114644132, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.EditMugDesignScreen (EditMugDesignScreen.kt:45)');
      }
      PreventScreenshots($composer_0, 0);
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(EditMugDesignViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, -1496129756, 'CC(remember):EditMugDesignScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance().f30_1) {
        var value = new SnackbarHostState();
        this_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp0_group;
      sourceInformationMarkerStart($composer_0, -1496126973, 'CC(remember):EditMugDesignScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_0.i31();
      var tmp_2;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = EditMugDesignScreen$lambda_0(viewModel);
        tmp0_0.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      var onIntent = tmp1_group;
      sourceInformationMarkerStart($composer_0, -1496124068, 'CC(remember):EditMugDesignScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.q31(viewModel) | ($dirty & 14) === 4);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_1.i31();
      var tmp_3;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = EditMugDesignScreen$slambda_0(viewModel, cartItemId, null);
        tmp0_1.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp2_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(Unit_instance, tmp2_group, $composer_0, 6);
      // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
      var getContext = null;
      var $composer_2 = $composer_0;
      if (!((1 & 1) === 0)) {
        getContext = EditMugDesignScreen$lambda_1;
      }
      var composer = $composer_2;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_2 = $composer_2.i31();
      var tmp_4;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var value_2 = createCompositionCoroutineScope(getContext(), composer);
        $composer_2.j31(value_2);
        tmp_4 = value_2;
      } else {
        tmp_4 = it_2;
      }
      var scope_0 = tmp_4;
      sourceInformationMarkerStart($composer_0, -1496118402, 'CC(remember):EditMugDesignScreen.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(!!(!!($composer_0.q31(viewModel) | $composer_0.q31(scope_0)) | ($dirty & 112) === 32) | ($dirty & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_3 = tmp0_2.i31();
      var tmp_5;
      if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = EditMugDesignScreen$slambda_2(viewModel, scope_0, onBack, onNavigateToEditor, snackbarHostState, null);
        tmp0_2.j31(value_3);
        tmp_5 = value_3;
      } else {
        tmp_5 = it_3;
      }
      var tmp3_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp3_group, $composer_0, 0);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = fillMaxSize(Companion_instance);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_3 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_4 = $composer_3;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_4, 0).hashCode();
      var localMap = $composer_4.t31();
      var materialized = materialize($composer_4, modifier_0);
      var tmp0_3 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_5 = $composer_4;
      var tmp_6 = $composer_5.g30();
      if (!isInterface(tmp_6, Applier)) {
        invalidApplier();
      }
      $composer_5.b31();
      if ($composer_5.h30()) {
        $composer_5.c31(tmp0_3);
      } else {
        $composer_5.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_5);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_6 = $composer_5;
      var $composer_7 = $composer_6;
      sourceInformationMarkerStart($composer_7, -748309644, 'C75@3282L1915,120@5207L128:EditMugDesignScreen.kt#mu900e');
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = fillMaxSize(Companion_instance);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_8 = $composer_7;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_8, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_9 = $composer_8;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_9, 0).hashCode();
      var localMap_0 = $composer_9.t31();
      var materialized_0 = materialize($composer_9, modifier_2);
      var tmp0_4 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_10 = $composer_9;
      var tmp_7 = $composer_10.g30();
      if (!isInterface(tmp_7, Applier)) {
        invalidApplier();
      }
      $composer_10.b31();
      if ($composer_10.h30()) {
        $composer_10.c31(tmp0_4);
      } else {
        $composer_10.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_10);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_11 = $composer_10;
      var $composer_12 = $composer_11;
      sourceInformationMarkerStart($composer_12, -681492086, 'C99@4331L856:EditMugDesignScreen.kt#mu900e');
      if (!EditMugDesignScreen$lambda(state$delegate).z12a_1.j12b_1) {
        $composer_12.m30(-681484430);
        sourceInformation($composer_12, '77@3404L38,79@3498L15,80@3552L322,88@3906L319,78@3459L845');
        var title = stringResource(get__3d_preview(string_instance), $composer_12, 0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1688354697, true, EditMugDesignScreen$lambda_2(title), $composer_12, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_13 = $composer_12;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_13.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_13.i31();
        var tmp_8;
        if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
          var value_4 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_13.j31(value_4);
          tmp_8 = value_4;
        } else {
          tmp_8 = it_4;
        }
        var tmp_9 = tmp_8;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-1139814475, true, EditMugDesignScreen$lambda_3(onBack), $composer_12, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_14 = $composer_12;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = $composer_14.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_5 = $composer_14.i31();
        var tmp_10;
        if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
          var value_5 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_14.j31(value_5);
          tmp_10 = value_5;
        } else {
          tmp_10 = it_5;
        }
        var tmp_11 = tmp_10;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(1937210540, true, EditMugDesignScreen$lambda_4(state$delegate), $composer_12, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_15 = $composer_12;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = $composer_15.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_6 = $composer_15.i31();
        var tmp_12;
        if (invalid_4 || it_6 === Companion_getInstance().f30_1) {
          var value_6 = ComposableLambda$invoke$ref_1(dispatchReceiver_1);
          $composer_15.j31(value_6);
          tmp_12 = value_6;
        } else {
          tmp_12 = it_6;
        }
        var tmp_13 = tmp_12;
        var tmp_14 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_15 = WindowInsets(0, 0, 0, 0);
        TopAppBar(tmp_9, null, tmp_11, tmp_13, tmp_14, tmp_15, null, null, $composer_12, 3462, 210);
        $composer_12.n30();
      } else {
        $composer_12.m30(-680577246);
        $composer_12.n30();
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_3 = fillMaxSize(Companion_instance);
      var contentAlignment_0 = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints_0 = false;
      var $composer_16 = $composer_12;
      if (!((4 & 1) === 0))
        modifier_3 = Companion_instance;
      if (!((4 & 2) === 0))
        contentAlignment_0 = Companion_getInstance_11().k8t_1;
      if (!((4 & 4) === 0))
        propagateMinConstraints_0 = false;
      var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_4 = modifier_3;
      var $composer_17 = $composer_16;
      if (!((0 & 2) === 0))
        modifier_4 = Companion_instance;
      var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
      var localMap_1 = $composer_17.t31();
      var materialized_1 = materialize($composer_17, modifier_4);
      var tmp0_5 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_18 = $composer_17;
      var tmp_16 = $composer_18.g30();
      if (!isInterface(tmp_16, Applier)) {
        invalidApplier();
      }
      $composer_18.b31();
      if ($composer_18.h30()) {
        $composer_18.c31(tmp0_5);
      } else {
        $composer_18.d31();
      }
      var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_18);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
      var $composer_19 = $composer_18;
      var $composer_20 = $composer_19;
      sourceInformationMarkerStart($composer_20, -1956477745, 'C:EditMugDesignScreen.kt#mu900e');
      if (EditMugDesignScreen$lambda(state$delegate).w12a_1 || EditMugDesignScreen$lambda(state$delegate).z12a_1.c12b_1) {
        $composer_20.m30(-1956449319);
        sourceInformation($composer_20, '103@4526L27');
        var tmp_17 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_18 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_19 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_20 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_17, tmp_18, tmp_19, tmp_20, _Dp___init__impl__ms3zkb(0.0), $composer_20, 0, 63);
        $composer_20.n30();
      } else if (!(EditMugDesignScreen$lambda(state$delegate).x12a_1 == null)) {
        $composer_20.m30(-1956352351);
        sourceInformation($composer_20, '105@4624L19');
        var tmp_21 = ensureNotNull(EditMugDesignScreen$lambda(state$delegate).x12a_1);
        var tmp_22 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_23 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_24 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_25 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_26 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_21, null, tmp_22, null, tmp_23, null, null, null, tmp_24, null, null, tmp_25, tmp_26, false, 0, 0, null, null, $composer_20, 0, 0, 262142);
        $composer_20.n30();
      } else if (!(EditMugDesignScreen$lambda(state$delegate).z12a_1.d12b_1 == null)) {
        $composer_20.m30(-1956249431);
        sourceInformation($composer_20, '107@4759L10,107@4727L43');
        var tmp_27 = ensureNotNull(EditMugDesignScreen$lambda(state$delegate).z12a_1.d12b_1).s11k($composer_20, 0);
        var tmp_28 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_29 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_30 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_31 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_32 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_27, null, tmp_28, null, tmp_29, null, null, null, tmp_30, null, null, tmp_31, tmp_32, false, 0, 0, null, null, $composer_20, 0, 0, 262142);
        $composer_20.n30();
      } else {
        $composer_20.m30(-1956151967);
        sourceInformation($composer_20, '111@4926L63,109@4816L339');
        var tmp_33 = EditMugDesignScreen$lambda(state$delegate).z12a_1;
        sourceInformationMarkerStart($composer_20, 1460922885, 'CC(remember):EditMugDesignScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = $composer_20.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_7 = $composer_20.i31();
        var tmp_34;
        if (invalid_5 || it_7 === Companion_getInstance().f30_1) {
          var value_7 = EditMugDesignScreen$lambda_5(viewModel);
          $composer_20.j31(value_7);
          tmp_34 = value_7;
        } else {
          tmp_34 = it_7;
        }
        var tmp0_group_0 = tmp_34;
        sourceInformationMarkerEnd($composer_20);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$66 = _Dp___init__impl__ms3zkb(0);
        var tmp_35 = PaddingValues_1(tmp$ret$66);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_36 = _Dp___init__impl__ms3zkb(64);
        ModelMugScreenContent(tmp_33, tmp0_group_0, tmp_35, true, tmp_36, _Dp___init__impl__ms3zkb(0.0), $composer_20, 28032, 32);
        $composer_20.n30();
      }
      sourceInformationMarkerEnd($composer_20);
      $composer_18.e31();
      sourceInformationMarkerEnd($composer_12);
      $composer_10.e31();
      var tmp_37 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(snackbarHostState, tmp_37, null, $composer_7, 6, 4);
      sourceInformationMarkerEnd($composer_7);
      $composer_5.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp4_safe_receiver = $composer_0.t30();
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.p3c(EditMugDesignScreen$lambda_6(cartItemId, onBack, onNavigateToEditor, $changed));
    }
  }
  function ComposableSingletons$EditMugDesignScreenKt$lambda$821261271$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C84@3765L31,82@3637L189:EditMugDesignScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(821261271, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$EditMugDesignScreenKt.lambda$821261271.<anonymous> (EditMugDesignScreen.kt:82)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$EditMugDesignScreenKt() {
    ComposableSingletons$EditMugDesignScreenKt_instance = this;
    var tmp = this;
    tmp.h12c_1 = ComposableLambda$invoke$ref(composableLambdaInstance(821261271, false, ComposableSingletons$EditMugDesignScreenKt$lambda$821261271$lambda));
  }
  var ComposableSingletons$EditMugDesignScreenKt_instance;
  function ComposableSingletons$EditMugDesignScreenKt_getInstance() {
    if (ComposableSingletons$EditMugDesignScreenKt_instance == null)
      new ComposableSingletons$EditMugDesignScreenKt();
    return ComposableSingletons$EditMugDesignScreenKt_instance;
  }
  function EditMugDesignScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function EditMugDesignScreen$lambda_0($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new Model3D_0(it));
      return Unit_instance;
    };
  }
  function EditMugDesignScreen$slambda($viewModel, $cartItemId, resultContinuation) {
    this.q12c_1 = $viewModel;
    this.r12c_1 = $cartItemId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditMugDesignScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(EditMugDesignScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditMugDesignScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.q12c_1.s10h().j10i(new LoadCartItem(this.r12c_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(EditMugDesignScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new EditMugDesignScreen$slambda(this.q12c_1, this.r12c_1, completion);
    i.s12c_1 = $this$LaunchedEffect;
    return i;
  };
  function EditMugDesignScreen$slambda_0($viewModel, $cartItemId, resultContinuation) {
    var i = new EditMugDesignScreen$slambda($viewModel, $cartItemId, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function EditMugDesignScreen$lambda_1() {
    return EmptyCoroutineContext_getInstance();
  }
  function EditMugDesignScreen$slambda$slambda$slambda($snackbarHostState, $effect, resultContinuation) {
    this.b12d_1 = $snackbarHostState;
    this.c12d_1 = $effect;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditMugDesignScreen$slambda$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(EditMugDesignScreen$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditMugDesignScreen$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.c12d_1.q129_1.z10i(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.b12d_1.dqm(ARGUMENT, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditMugDesignScreen$slambda$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new EditMugDesignScreen$slambda$slambda$slambda(this.b12d_1, this.c12d_1, completion);
    i.d12d_1 = $this$launch;
    return i;
  };
  function EditMugDesignScreen$slambda$slambda$slambda_0($snackbarHostState, $effect, resultContinuation) {
    var i = new EditMugDesignScreen$slambda$slambda$slambda($snackbarHostState, $effect, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_14(function_0) {
    this.e12d_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_14).a1v = function (value, $completion) {
    return this.e12d_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_14).q3 = function () {
    return this.e12d_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_14).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_14).hashCode = function () {
    return hashCode(this.q3());
  };
  function EditMugDesignScreen$slambda$slambda($scope, $onBack, $onNavigateToEditor, $snackbarHostState, resultContinuation) {
    this.n12d_1 = $scope;
    this.o12d_1 = $onBack;
    this.p12d_1 = $onNavigateToEditor;
    this.q12d_1 = $snackbarHostState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditMugDesignScreen$slambda$slambda).f12a = function (effect, $completion) {
    var tmp = this.g12a(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(EditMugDesignScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.f12a((!(p1 == null) ? isInterface(p1, EditMugDesignSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditMugDesignScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0_subject = this.r12d_1;
          if (tmp0_subject instanceof ShowMessage_0) {
            launch(this.n12d_1, VOID, VOID, EditMugDesignScreen$slambda$slambda$slambda_0(this.q12d_1, this.r12d_1, null));
          } else {
            if (equals(tmp0_subject, NavigateBack_instance))
              this.o12d_1();
            else {
              if (tmp0_subject instanceof NavigateToEditor)
                this.p12d_1(this.r12d_1.h12a_1);
              else {
                if (!(tmp0_subject instanceof Model3D_1)) {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(EditMugDesignScreen$slambda$slambda).g12a = function (effect, completion) {
    var i = new EditMugDesignScreen$slambda$slambda(this.n12d_1, this.o12d_1, this.p12d_1, this.q12d_1, completion);
    i.r12d_1 = effect;
    return i;
  };
  function EditMugDesignScreen$slambda$slambda_0($scope, $onBack, $onNavigateToEditor, $snackbarHostState, resultContinuation) {
    var i = new EditMugDesignScreen$slambda$slambda($scope, $onBack, $onNavigateToEditor, $snackbarHostState, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.f12a(effect, $completion);
    }, 1);
  }
  function EditMugDesignScreen$slambda_1($viewModel, $scope, $onBack, $onNavigateToEditor, $snackbarHostState, resultContinuation) {
    this.a12e_1 = $viewModel;
    this.b12e_1 = $scope;
    this.c12e_1 = $onBack;
    this.d12e_1 = $onNavigateToEditor;
    this.e12e_1 = $snackbarHostState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditMugDesignScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(EditMugDesignScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditMugDesignScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.a12e_1.s10h().t10h();
            var tmp_1 = EditMugDesignScreen$slambda$slambda_0(this.b12e_1, this.c12e_1, this.d12e_1, this.e12e_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_14(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditMugDesignScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new EditMugDesignScreen$slambda_1(this.a12e_1, this.b12e_1, this.c12e_1, this.d12e_1, this.e12e_1, completion);
    i.f12e_1 = $this$LaunchedEffect;
    return i;
  };
  function EditMugDesignScreen$slambda_2($viewModel, $scope, $onBack, $onNavigateToEditor, $snackbarHostState, resultContinuation) {
    var i = new EditMugDesignScreen$slambda_1($viewModel, $scope, $onBack, $onNavigateToEditor, $snackbarHostState, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function EditMugDesignScreen$lambda_2($title) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C79@3500L11:EditMugDesignScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1688354697, $changed, -1, 'client.fstech.hadaya.presentation.model3d.EditMugDesignScreen.<anonymous>.<anonymous>.<anonymous> (EditMugDesignScreen.kt:79)');
        }
        var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text($title, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function EditMugDesignScreen$lambda_3($onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C81@3578L274:EditMugDesignScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1139814475, $changed, -1, 'client.fstech.hadaya.presentation.model3d.EditMugDesignScreen.<anonymous>.<anonymous>.<anonymous> (EditMugDesignScreen.kt:81)');
        }
        IconButton($onBack, null, false, null, null, null, ComposableSingletons$EditMugDesignScreenKt_getInstance().h12c_1, $composer_0, 1572864, 62);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function EditMugDesignScreen$lambda_4($state$delegate) {
    return function ($this$TopAppBar, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:EditMugDesignScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1937210540, $changed, -1, 'client.fstech.hadaya.presentation.model3d.EditMugDesignScreen.<anonymous>.<anonymous>.<anonymous> (EditMugDesignScreen.kt:89)');
        }
        if (EditMugDesignScreen$lambda($state$delegate).a12b_1) {
          $composer_0.m30(-36303875);
          sourceInformation($composer_0, '90@3984L193');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
          var tmp_2 = padding_1(tmp_1, VOID, VOID, tmp$ret$1);
          var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_4 = _Dp___init__impl__ms3zkb(2);
          var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_6 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, _Dp___init__impl__ms3zkb(0.0), $composer_0, 390, 58);
          $composer_0.n30();
        } else {
          $composer_0.m30(-36064586);
          $composer_0.n30();
        }
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function EditMugDesignScreen$lambda_5($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new Model3D_0(it));
      return Unit_instance;
    };
  }
  function EditMugDesignScreen$lambda_6($cartItemId, $onBack, $onNavigateToEditor, $$changed) {
    return function ($composer, $force) {
      EditMugDesignScreen($cartItemId, $onBack, $onNavigateToEditor, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_model3d_EditMugDesignViewModel$stable;
  function EditMugDesignViewModel$observeLanguage$slambda$slambda$lambda($language) {
    return function ($this$updateState) {
      return $this$updateState.d12c(VOID, VOID, VOID, VOID, VOID, $language);
    };
  }
  function EditMugDesignViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation) {
    this.o12e_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditMugDesignViewModel$observeLanguage$slambda$slambda).pyo = function (language, $completion) {
    var tmp = this.um9(language, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(EditMugDesignViewModel$observeLanguage$slambda$slambda).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditMugDesignViewModel$observeLanguage$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.o12e_1.x10k(EditMugDesignViewModel$observeLanguage$slambda$slambda$lambda(this.p12e_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(EditMugDesignViewModel$observeLanguage$slambda$slambda).um9 = function (language, completion) {
    var i = new EditMugDesignViewModel$observeLanguage$slambda$slambda(this.o12e_1, completion);
    i.p12e_1 = language;
    return i;
  };
  function EditMugDesignViewModel$observeLanguage$slambda$slambda_0(this$0, resultContinuation) {
    var i = new EditMugDesignViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (language, $completion) {
      return i.pyo(language, $completion);
    }, 1);
  }
  function observeLanguage_4($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, EditMugDesignViewModel$observeLanguage$slambda_0($this, null));
  }
  function EditMugDesignViewModel$observeLanguage$slambda(this$0, resultContinuation) {
    this.y12e_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditMugDesignViewModel$observeLanguage$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(EditMugDesignViewModel$observeLanguage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditMugDesignViewModel$observeLanguage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.y12e_1.j12f_1.y103();
            var action = EditMugDesignViewModel$observeLanguage$slambda$slambda_0(this.y12e_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditMugDesignViewModel$observeLanguage$slambda).q24 = function ($this$launch, completion) {
    var i = new EditMugDesignViewModel$observeLanguage$slambda(this.y12e_1, completion);
    i.z12e_1 = $this$launch;
    return i;
  };
  function EditMugDesignViewModel$observeLanguage$slambda_0(this$0, resultContinuation) {
    var i = new EditMugDesignViewModel$observeLanguage$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function EditMugDesignViewModel$handleIntent$lambda($this$updateState) {
    return $this$updateState.d12c(true, null);
  }
  function EditMugDesignViewModel$handleIntent$lambda_0($item) {
    return function ($this$updateState) {
      var tmp20_cartItem = $item;
      var tmp6_$this = $this$updateState.z12a_1;
      var tmp7_initialLayers = $item.tyw_1;
      var tmp8_initialCustomImageUrl = $item.syw_1;
      var tmp9_pickedImageBytes = $item.xyw_1;
      var tmp10_selectedSize = $item.jyx_1;
      var tmp11_selectedColor = $item.kyx_1;
      var tmp0_elvis_lhs = $item.lyx_1;
      var tmp12_selectedOptions = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
      var tmp1_elvis_lhs = $item.myx_1;
      var tmp13_productComment = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      var tmp14_selectedCard = $item.dyx_1;
      var tmp15_selectedBox = $item.gyx_1;
      var tmp2_elvis_lhs = $item.eyx_1;
      var tmp16_cardMessage = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
      var tmp3_elvis_lhs = $item.fyx_1;
      var tmp17_cardBirthday = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      var tmp4_elvis_lhs = $item.hyx_1;
      var tmp18_boxMessage = tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = $item.iyx_1;
      var tmp19_boxBirthday = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
      var tmp21_model3DState = tmp6_$this.n12f(VOID, VOID, VOID, tmp9_pickedImageBytes, VOID, VOID, VOID, VOID, VOID, tmp7_initialLayers, tmp8_initialCustomImageUrl, tmp14_selectedCard, tmp16_cardMessage, tmp17_cardBirthday, VOID, tmp15_selectedBox, tmp18_boxMessage, tmp19_boxBirthday, VOID, tmp10_selectedSize, tmp11_selectedColor, tmp12_selectedOptions, tmp13_productComment);
      return $this$updateState.d12c(false, VOID, tmp20_cartItem, tmp21_model3DState);
    };
  }
  function EditMugDesignViewModel$handleIntent$lambda_1($product) {
    return function ($this$updateState) {
      return $this$updateState.d12c(VOID, VOID, VOID, $this$updateState.z12a_1.n12f(false, VOID, $product));
    };
  }
  function EditMugDesignViewModel$handleIntent$lambda_2($this$updateState) {
    return $this$updateState.d12c(false, 'Product not found');
  }
  function EditMugDesignViewModel$handleIntent$lambda_3($this$updateState) {
    return $this$updateState.d12c(false, 'Failed to load cart item');
  }
  function EditMugDesignViewModel$handleIntent$lambda_4($this$updateState) {
    return $this$updateState.d12c(VOID, VOID, VOID, VOID, true);
  }
  function EditMugDesignViewModel$handleIntent$slambda($m3dState, resultContinuation) {
    this.w12f_1 = $m3dState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditMugDesignViewModel$handleIntent$slambda).y12f = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(EditMugDesignViewModel$handleIntent$slambda).ja = function (p1, $completion) {
    return this.y12f((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditMugDesignViewModel$handleIntent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var this_0 = this.w12f_1.h12b_1;
          var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.t();
          while (_iterator__ex2g4s.u()) {
            var item = _iterator__ex2g4s.v();
            var tmp0_id = item.z12f_1;
            var tmp1_imageBytes = item.i12g_1 == null ? toByteArray(resize(item.a12g_1, 1024)) : null;
            var this_1 = item.b12g_1;
            var value = _Offset___get_packedValue__impl__xh2k8q(this_1);
            var bits = convertToInt(shiftRight(value, 32));
            var tmp2_x = floatFromBits(bits);
            var this_2 = item.b12g_1;
            var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_2);
            var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
            var tmp3_y = floatFromBits(bits_0);
            var tmp4_scaleX = item.c12g_1;
            var tmp5_scaleY = item.d12g_1;
            var tmp6_rotation = item.e12g_1;
            var tmp7_filter = item.f12g_1.z_1;
            var tmp8_flipX = item.g12g_1;
            var tmp9_flipY = item.h12g_1;
            var tmp10_text = item.i12g_1;
            var tmp11_textColor = fromInt(toArgb(item.j12g_1));
            var tmp12_fontFamily = item.k12g_1;
            var tmp13_width = item.a12g_1.h5e();
            var tmp14_height = item.a12g_1.i5e();
            destination.j1(new DesignLayer(tmp0_id, '', tmp2_x, tmp3_y, tmp4_scaleX, tmp5_scaleY, tmp6_rotation, tmp7_filter, tmp8_flipX, tmp9_flipY, tmp10_text, tmp11_textColor, tmp12_fontFamily, tmp1_imageBytes, VOID, tmp13_width, tmp14_height));
          }
          return destination;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(EditMugDesignViewModel$handleIntent$slambda).q24 = function ($this$withContext, completion) {
    var i = new EditMugDesignViewModel$handleIntent$slambda(this.w12f_1, completion);
    i.x12f_1 = $this$withContext;
    return i;
  };
  function EditMugDesignViewModel$handleIntent$slambda_0($m3dState, resultContinuation) {
    var i = new EditMugDesignViewModel$handleIntent$slambda($m3dState, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.y12f($this$withContext, $completion);
    }, 1);
  }
  function EditMugDesignViewModel$handleIntent$lambda_5($this$updateState) {
    return $this$updateState.d12c(VOID, VOID, VOID, VOID, false);
  }
  function EditMugDesignViewModel$handleIntent$lambda_6($m3dIntent) {
    return function ($this$updateState) {
      var tmp0_$this = $this$updateState.z12a_1;
      var tmp1_imageBitmap = $m3dIntent.m12g_1;
      var tmp2_pickedImageBytes = $m3dIntent.n12g_1;
      var tmp3_editorElements = $m3dIntent.o12g_1;
      return $this$updateState.d12c(VOID, VOID, VOID, tmp0_$this.n12f(VOID, VOID, VOID, tmp2_pickedImageBytes, tmp1_imageBitmap, tmp3_editorElements, VOID, false));
    };
  }
  function EditMugDesignViewModel$handleIntent$lambda_7($this$updateState) {
    return $this$updateState.d12c(VOID, VOID, VOID, $this$updateState.z12a_1.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true));
  }
  function EditMugDesignViewModel$handleIntent$lambda_8($this$updateState) {
    return $this$updateState.d12c(VOID, VOID, VOID, $this$updateState.z12a_1.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, false));
  }
  function EditMugDesignViewModel$handleIntent$lambda_9($m3dIntent) {
    return function ($this$updateState) {
      return $this$updateState.d12c(VOID, VOID, VOID, $this$updateState.z12a_1.n12f(VOID, VOID, VOID, VOID, VOID, $m3dIntent.p12g_1));
    };
  }
  function EditMugDesignViewModel$handleIntent$lambda_10($this$updateState) {
    return $this$updateState.d12c(VOID, VOID, VOID, $this$updateState.z12a_1.n12f(VOID, VOID, VOID, null, null, emptyList()));
  }
  function $handleIntentCOROUTINE$_8(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y12g_1 = _this__u8e3s4;
    this.z12g_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_8).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 21;
            var tmp0_subject = this.z12g_1;
            if (tmp0_subject instanceof LoadCartItem) {
              var cartItemId = this.z12g_1.e12c_1;
              this.y12g_1.x10k(EditMugDesignViewModel$handleIntent$lambda);
              this.o9_1 = 18;
              this.n9_1 = 12;
              suspendResult = this.y12g_1.e12f_1.f103(cartItemId, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof UpdateMugDesign) {
                var currentState = this.y12g_1.s10h().ajg().u1();
                var tmp_0 = this;
                var tmp2_elvis_lhs = currentState.y12a_1;
                var tmp_1;
                if (tmp2_elvis_lhs == null) {
                  return Unit_instance;
                } else {
                  tmp_1 = tmp2_elvis_lhs;
                }
                tmp_0.f12h_1 = tmp_1;
                this.j12h_1 = currentState.z12a_1;
                this.h12h_1 = this.z12g_1.g12c_1;
                this.y12g_1.x10k(EditMugDesignViewModel$handleIntent$lambda_4);
                this.n9_1 = 1;
                continue $sm;
              } else {
                if (tmp0_subject instanceof Model3D_0) {
                  var tmp_2 = this;
                  var m3dIntent = this.z12g_1.f12c_1;
                  var currentM3DState = this.y12g_1.s10h().ajg().u1().z12a_1;
                  if (m3dIntent instanceof CustomImageApplied) {
                    this.y12g_1.x10k(EditMugDesignViewModel$handleIntent$lambda_6(m3dIntent));
                  } else {
                    if (m3dIntent instanceof OpenEditor) {
                      this.y12g_1.x10k(EditMugDesignViewModel$handleIntent$lambda_7);
                    } else {
                      if (m3dIntent instanceof CloseEditor) {
                        this.y12g_1.x10k(EditMugDesignViewModel$handleIntent$lambda_8);
                      } else {
                        if (m3dIntent instanceof UpdateElements) {
                          this.y12g_1.x10k(EditMugDesignViewModel$handleIntent$lambda_9(m3dIntent));
                        } else {
                          if (m3dIntent instanceof RemoveCustomization) {
                            this.y12g_1.x10k(EditMugDesignViewModel$handleIntent$lambda_10);
                          }
                        }
                      }
                    }
                  }
                  tmp_2.a12h_1 = Unit_instance;
                  this.n9_1 = 20;
                  continue $sm;
                } else {
                  var tmp_3 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            this.o9_1 = 11;
            this.o9_1 = 8;
            this.n9_1 = 2;
            var tmp_4 = Dispatchers_getInstance().i1h_1;
            suspendResult = withContext(tmp_4, EditMugDesignViewModel$handleIntent$slambda_0(this.j12h_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.e12h_1 = suspendResult;
            var tmp_5 = this;
            var tmp3_safe_receiver = this.h12h_1;
            var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toByteArray(tmp3_safe_receiver);
            tmp_5.g12h_1 = tmp4_elvis_lhs == null ? this.j12h_1.f12b_1 : tmp4_elvis_lhs;
            var tmp5_safe_receiver = this.y12g_1.i12f_1.ynu();
            var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.uym_1;
            var userId = tmp6_elvis_lhs == null ? 'anonymous' : tmp6_elvis_lhs;
            var timestamp = System_instance.fp().wp();
            if (!(this.g12h_1 == null) && this.y12g_1.k12f_1.fz1().u1()) {
              var fileName = 'custom_designs/' + userId + '/final_' + timestamp.toString() + '.png';
              this.n9_1 = 3;
              suspendResult = this.y12g_1.h12f_1.k105(this.g12h_1, fileName, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_6 = this;
              tmp_6.i12h_1 = null;
              this.n9_1 = 4;
              continue $sm;
            }

          case 3:
            this.i12h_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            var customImageUrl = this.i12h_1;
            var tmp_7;
            if (customImageUrl == null) {
              var tmp7_safe_receiver = this.h12h_1;
              var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : resize(tmp7_safe_receiver, 512);
              var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : toJpegByteArray(tmp8_safe_receiver, 80);
              tmp_7 = tmp9_elvis_lhs == null ? this.g12h_1 : tmp9_elvis_lhs;
            } else {
              tmp_7 = null;
            }

            var localSnapshotBytes = tmp_7;
            var updatedItem = this.f12h_1.jyy(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, customImageUrl, this.e12h_1, VOID, VOID, VOID, localSnapshotBytes);
            this.n9_1 = 5;
            suspendResult = this.y12g_1.f12f_1.dz0(updatedItem, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.n9_1 = 6;
            suspendResult = this.y12g_1.d10l(new ShowMessage_0(new ResourceString(get_design_updated_cart(string_instance), [])), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.n9_1 = 7;
            suspendResult = this.y12g_1.d10l(NavigateBack_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.o9_1 = 21;
            this.n9_1 = 10;
            continue $sm;
          case 8:
            this.o9_1 = 11;
            var tmp_8 = this.q9_1;
            if (tmp_8 instanceof Exception) {
              var e = this.q9_1;
              var tmp10_safe_receiver = e.message;
              var tmp0_elvis_lhs = tmp10_safe_receiver == null ? null : take(tmp10_safe_receiver, 200);
              var msg = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
              this.n9_1 = 9;
              suspendResult = this.y12g_1.d10l(new ShowMessage_0(new ResourceString(get_update_failed_e_message(string_instance), [msg])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 9:
            this.o9_1 = 21;
            this.n9_1 = 10;
            continue $sm;
          case 10:
            this.o9_1 = 21;
            var tmp_9 = this;
            this.y12g_1.x10k(EditMugDesignViewModel$handleIntent$lambda_5);
            tmp_9.a12h_1 = Unit_instance;
            this.n9_1 = 20;
            continue $sm;
          case 11:
            this.o9_1 = 21;
            var t = this.q9_1;
            this.y12g_1.x10k(EditMugDesignViewModel$handleIntent$lambda_5);
            throw t;
          case 12:
            var item = suspendResult;
            if (!(item == null)) {
              this.y12g_1.x10k(EditMugDesignViewModel$handleIntent$lambda_0(item));
              var tmp1_safe_receiver = item.gyw_1;
              if (tmp1_safe_receiver == null) {
                this.d12h_1 = null;
                this.n9_1 = 16;
                continue $sm;
              } else {
                this.o9_1 = 14;
                this.n9_1 = 13;
                suspendResult = this.y12g_1.l12f_1.yzi(tmp1_safe_receiver, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_10 = this;
              this.y12g_1.x10k(EditMugDesignViewModel$handleIntent$lambda_2);
              tmp_10.c12h_1 = Unit_instance;
              this.n9_1 = 17;
              continue $sm;
            }

          case 13:
            var product = suspendResult;
            this.y12g_1.x10k(EditMugDesignViewModel$handleIntent$lambda_1(product));
            this.o9_1 = 18;
            this.n9_1 = 15;
            continue $sm;
          case 14:
            this.o9_1 = 18;
            var tmp_11 = this.q9_1;
            if (tmp_11 instanceof Exception) {
              var e_0 = this.q9_1;
              this.n9_1 = 15;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 15:
            this.o9_1 = 18;
            var tmp_12 = this;
            tmp_12.d12h_1 = Unit_instance;
            this.n9_1 = 16;
            continue $sm;
          case 16:
            this.c12h_1 = this.d12h_1;
            this.n9_1 = 17;
            continue $sm;
          case 17:
            this.b12h_1 = this.c12h_1;
            this.o9_1 = 21;
            this.n9_1 = 19;
            continue $sm;
          case 18:
            this.o9_1 = 21;
            var tmp_13 = this.q9_1;
            if (tmp_13 instanceof Exception) {
              var e_1 = this.q9_1;
              var tmp_14 = this;
              this.y12g_1.x10k(EditMugDesignViewModel$handleIntent$lambda_3);
              tmp_14.b12h_1 = Unit_instance;
              this.n9_1 = 19;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 19:
            this.o9_1 = 21;
            this.a12h_1 = this.b12h_1;
            this.n9_1 = 20;
            continue $sm;
          case 20:
            return Unit_instance;
          case 21:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_2 = $p;
        if (this.o9_1 === 21) {
          throw e_2;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_2;
        }
      }
     while (true);
  };
  function EditMugDesignViewModel(getCartItemByIdUseCase, cartRepository, downloadDesignImageUseCase, uploadDesignImageUseCase, getCurrentUserValueUseCase, getLanguageUseCase, networkObserver, productRepository, authRepository) {
    BaseMviViewModel.call(this, new EditMugDesignState());
    this.e12f_1 = getCartItemByIdUseCase;
    this.f12f_1 = cartRepository;
    this.g12f_1 = downloadDesignImageUseCase;
    this.h12f_1 = uploadDesignImageUseCase;
    this.i12f_1 = getCurrentUserValueUseCase;
    this.j12f_1 = getLanguageUseCase;
    this.k12f_1 = networkObserver;
    this.l12f_1 = productRepository;
    this.m12f_1 = authRepository;
    observeLanguage_4(this);
  }
  protoOf(EditMugDesignViewModel).k12h = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_8(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(EditMugDesignViewModel).f10l = function (intent, $completion) {
    return this.k12h(isInterface(intent, EditMugDesignIntent) ? intent : THROW_CCE(), $completion);
  };
  function get_SepiaMatrix() {
    _init_properties_ModelMugContract_kt__btiswo();
    return SepiaMatrix;
  }
  var SepiaMatrix;
  function get_GrayscaleMatrix() {
    _init_properties_ModelMugContract_kt__btiswo();
    return GrayscaleMatrix;
  }
  var GrayscaleMatrix;
  function get_InvertMatrix() {
    _init_properties_ModelMugContract_kt__btiswo();
    return InvertMatrix;
  }
  var InvertMatrix;
  var client_fstech_hadaya_presentation_model3d_Model3DState$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_LoadProduct$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_ImagePicked$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_CustomImageApplied$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_UpdateElements$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_AddToCart$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_RemoveCustomization$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_OpenEditor$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_CloseEditor$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_CardSelected$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_CardMessageChanged$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_CardBirthdayChanged$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_BoxSelected$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_BoxMessageChanged$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_BoxBirthdayChanged$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_SizeSelected$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_ColorSelected$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_OptionSelected$stable;
  var client_fstech_hadaya_presentation_model3d_ModelMugIntent_ProductCommentChanged$stable;
  var client_fstech_hadaya_presentation_model3d_Model3DSideEffect_ShowMessage$stable;
  var client_fstech_hadaya_presentation_model3d_Model3DSideEffect_NavigateBack$stable;
  var client_fstech_hadaya_presentation_model3d_Model3DSideEffect_NavigateToAuth$stable;
  var client_fstech_hadaya_presentation_model3d_EditorImageElement$stable;
  function EditorImageElement(id, bitmap, position, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamilyName, isPlaceholder) {
    position = position === VOID ? Companion_getInstance_24().g5d_1 : position;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    rotation = rotation === VOID ? 0.0 : rotation;
    filter = filter === VOID ? FilterType_None_getInstance() : filter;
    flipX = flipX === VOID ? false : flipX;
    flipY = flipY === VOID ? false : flipY;
    text = text === VOID ? null : text;
    textColor = textColor === VOID ? Companion_getInstance_14().i6b_1 : textColor;
    fontFamilyName = fontFamilyName === VOID ? 'Default' : fontFamilyName;
    isPlaceholder = isPlaceholder === VOID ? false : isPlaceholder;
    this.z12f_1 = id;
    this.a12g_1 = bitmap;
    this.b12g_1 = position;
    this.c12g_1 = scaleX;
    this.d12g_1 = scaleY;
    this.e12g_1 = rotation;
    this.f12g_1 = filter;
    this.g12g_1 = flipX;
    this.h12g_1 = flipY;
    this.i12g_1 = text;
    this.j12g_1 = textColor;
    this.k12g_1 = fontFamilyName;
    this.l12g_1 = isPlaceholder;
  }
  protoOf(EditorImageElement).l12h = function (id, bitmap, position, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamilyName, isPlaceholder) {
    return new EditorImageElement(id, bitmap, position, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamilyName, isPlaceholder);
  };
  protoOf(EditorImageElement).m12h = function (id, bitmap, position, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamilyName, isPlaceholder, $super) {
    id = id === VOID ? this.z12f_1 : id;
    bitmap = bitmap === VOID ? this.a12g_1 : bitmap;
    position = position === VOID ? this.b12g_1 : position;
    scaleX = scaleX === VOID ? this.c12g_1 : scaleX;
    scaleY = scaleY === VOID ? this.d12g_1 : scaleY;
    rotation = rotation === VOID ? this.e12g_1 : rotation;
    filter = filter === VOID ? this.f12g_1 : filter;
    flipX = flipX === VOID ? this.g12g_1 : flipX;
    flipY = flipY === VOID ? this.h12g_1 : flipY;
    text = text === VOID ? this.i12g_1 : text;
    textColor = textColor === VOID ? this.j12g_1 : textColor;
    fontFamilyName = fontFamilyName === VOID ? this.k12g_1 : fontFamilyName;
    isPlaceholder = isPlaceholder === VOID ? this.l12g_1 : isPlaceholder;
    return $super === VOID ? this.l12h(id, bitmap, position, scaleX, scaleY, rotation, filter, flipX, flipY, text, textColor, fontFamilyName, isPlaceholder) : $super.l12h.call(this, id, bitmap, new Offset(position), scaleX, scaleY, rotation, filter, flipX, flipY, text, new Color_0(textColor), fontFamilyName, isPlaceholder);
  };
  protoOf(EditorImageElement).toString = function () {
    return 'EditorImageElement(id=' + this.z12f_1.toString() + ', bitmap=' + toString(this.a12g_1) + ', position=' + Offset__toString_impl_4ffbou(this.b12g_1) + ', scaleX=' + this.c12g_1 + ', scaleY=' + this.d12g_1 + ', rotation=' + this.e12g_1 + ', filter=' + this.f12g_1.toString() + ', flipX=' + this.g12g_1 + ', flipY=' + this.h12g_1 + ', text=' + this.i12g_1 + ', textColor=' + Color__toString_impl_hpzmaq(this.j12g_1) + ', fontFamilyName=' + this.k12g_1 + ', isPlaceholder=' + this.l12g_1 + ')';
  };
  protoOf(EditorImageElement).hashCode = function () {
    var result = this.z12f_1.hashCode();
    result = imul(result, 31) + hashCode(this.a12g_1) | 0;
    result = imul(result, 31) + Offset__hashCode_impl_hbql41(this.b12g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c12g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d12g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e12g_1) | 0;
    result = imul(result, 31) + this.f12g_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g12g_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h12g_1) | 0;
    result = imul(result, 31) + (this.i12g_1 == null ? 0 : getStringHashCode(this.i12g_1)) | 0;
    result = imul(result, 31) + Color__hashCode_impl_vjyivj(this.j12g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k12g_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l12g_1) | 0;
    return result;
  };
  protoOf(EditorImageElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EditorImageElement))
      return false;
    if (!equalsLong(this.z12f_1, other.z12f_1))
      return false;
    if (!equals(this.a12g_1, other.a12g_1))
      return false;
    if (!equals(this.b12g_1, other.b12g_1))
      return false;
    if (!equals(this.c12g_1, other.c12g_1))
      return false;
    if (!equals(this.d12g_1, other.d12g_1))
      return false;
    if (!equals(this.e12g_1, other.e12g_1))
      return false;
    if (!this.f12g_1.equals(other.f12g_1))
      return false;
    if (!(this.g12g_1 === other.g12g_1))
      return false;
    if (!(this.h12g_1 === other.h12g_1))
      return false;
    if (!(this.i12g_1 == other.i12g_1))
      return false;
    if (!equals(this.j12g_1, other.j12g_1))
      return false;
    if (!(this.k12g_1 === other.k12g_1))
      return false;
    if (!(this.l12g_1 === other.l12g_1))
      return false;
    return true;
  };
  var FilterType_None_instance;
  var FilterType_Sepia_instance;
  var FilterType_Grayscale_instance;
  var FilterType_Invert_instance;
  function values_5() {
    return [FilterType_None_getInstance(), FilterType_Sepia_getInstance(), FilterType_Grayscale_getInstance(), FilterType_Invert_getInstance()];
  }
  function get_entries_0() {
    if ($ENTRIES_0 == null)
      $ENTRIES_0 = enumEntries(values_5());
    return $ENTRIES_0;
  }
  var FilterType_entriesInitialized;
  function FilterType_initEntries() {
    if (FilterType_entriesInitialized)
      return Unit_instance;
    FilterType_entriesInitialized = true;
    FilterType_None_instance = new FilterType('None', 0);
    FilterType_Sepia_instance = new FilterType('Sepia', 1);
    FilterType_Grayscale_instance = new FilterType('Grayscale', 2);
    FilterType_Invert_instance = new FilterType('Invert', 3);
  }
  var $ENTRIES_0;
  function FilterType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function createSimpleSnapshot(elements, scale) {
    scale = scale === VOID ? 1.0 : scale;
    _init_properties_ModelMugContract_kt__btiswo();
    return createSnapshotWithBackground(elements, Companion_getInstance_14().m6b_1, scale);
  }
  function Model3DState(loading, error, product, pickedImageBytes, imageBitmap, editorElements, isAddingToCart, showEditor, language, initialLayers, initialCustomImageUrl, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, availableCards, availableBoxes, pendingAddToCart) {
    loading = loading === VOID ? true : loading;
    error = error === VOID ? null : error;
    product = product === VOID ? null : product;
    pickedImageBytes = pickedImageBytes === VOID ? null : pickedImageBytes;
    imageBitmap = imageBitmap === VOID ? null : imageBitmap;
    editorElements = editorElements === VOID ? emptyList() : editorElements;
    isAddingToCart = isAddingToCart === VOID ? false : isAddingToCart;
    showEditor = showEditor === VOID ? false : showEditor;
    language = language === VOID ? 'en' : language;
    initialLayers = initialLayers === VOID ? null : initialLayers;
    initialCustomImageUrl = initialCustomImageUrl === VOID ? null : initialCustomImageUrl;
    selectedCard = selectedCard === VOID ? null : selectedCard;
    cardMessage = cardMessage === VOID ? '' : cardMessage;
    cardBirthday = cardBirthday === VOID ? '' : cardBirthday;
    cardBirthdayError = cardBirthdayError === VOID ? false : cardBirthdayError;
    selectedBox = selectedBox === VOID ? null : selectedBox;
    boxMessage = boxMessage === VOID ? '' : boxMessage;
    boxBirthday = boxBirthday === VOID ? '' : boxBirthday;
    boxBirthdayError = boxBirthdayError === VOID ? false : boxBirthdayError;
    selectedSize = selectedSize === VOID ? null : selectedSize;
    selectedColor = selectedColor === VOID ? null : selectedColor;
    selectedOptions = selectedOptions === VOID ? emptyMap() : selectedOptions;
    productComment = productComment === VOID ? '' : productComment;
    availableCards = availableCards === VOID ? emptyList() : availableCards;
    availableBoxes = availableBoxes === VOID ? emptyList() : availableBoxes;
    pendingAddToCart = pendingAddToCart === VOID ? false : pendingAddToCart;
    this.c12b_1 = loading;
    this.d12b_1 = error;
    this.e12b_1 = product;
    this.f12b_1 = pickedImageBytes;
    this.g12b_1 = imageBitmap;
    this.h12b_1 = editorElements;
    this.i12b_1 = isAddingToCart;
    this.j12b_1 = showEditor;
    this.k12b_1 = language;
    this.l12b_1 = initialLayers;
    this.m12b_1 = initialCustomImageUrl;
    this.n12b_1 = selectedCard;
    this.o12b_1 = cardMessage;
    this.p12b_1 = cardBirthday;
    this.q12b_1 = cardBirthdayError;
    this.r12b_1 = selectedBox;
    this.s12b_1 = boxMessage;
    this.t12b_1 = boxBirthday;
    this.u12b_1 = boxBirthdayError;
    this.v12b_1 = selectedSize;
    this.w12b_1 = selectedColor;
    this.x12b_1 = selectedOptions;
    this.y12b_1 = productComment;
    this.z12b_1 = availableCards;
    this.a12c_1 = availableBoxes;
    this.b12c_1 = pendingAddToCart;
  }
  protoOf(Model3DState).n12h = function (loading, error, product, pickedImageBytes, imageBitmap, editorElements, isAddingToCart, showEditor, language, initialLayers, initialCustomImageUrl, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, availableCards, availableBoxes, pendingAddToCart) {
    return new Model3DState(loading, error, product, pickedImageBytes, imageBitmap, editorElements, isAddingToCart, showEditor, language, initialLayers, initialCustomImageUrl, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, availableCards, availableBoxes, pendingAddToCart);
  };
  protoOf(Model3DState).n12f = function (loading, error, product, pickedImageBytes, imageBitmap, editorElements, isAddingToCart, showEditor, language, initialLayers, initialCustomImageUrl, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, availableCards, availableBoxes, pendingAddToCart, $super) {
    loading = loading === VOID ? this.c12b_1 : loading;
    error = error === VOID ? this.d12b_1 : error;
    product = product === VOID ? this.e12b_1 : product;
    pickedImageBytes = pickedImageBytes === VOID ? this.f12b_1 : pickedImageBytes;
    imageBitmap = imageBitmap === VOID ? this.g12b_1 : imageBitmap;
    editorElements = editorElements === VOID ? this.h12b_1 : editorElements;
    isAddingToCart = isAddingToCart === VOID ? this.i12b_1 : isAddingToCart;
    showEditor = showEditor === VOID ? this.j12b_1 : showEditor;
    language = language === VOID ? this.k12b_1 : language;
    initialLayers = initialLayers === VOID ? this.l12b_1 : initialLayers;
    initialCustomImageUrl = initialCustomImageUrl === VOID ? this.m12b_1 : initialCustomImageUrl;
    selectedCard = selectedCard === VOID ? this.n12b_1 : selectedCard;
    cardMessage = cardMessage === VOID ? this.o12b_1 : cardMessage;
    cardBirthday = cardBirthday === VOID ? this.p12b_1 : cardBirthday;
    cardBirthdayError = cardBirthdayError === VOID ? this.q12b_1 : cardBirthdayError;
    selectedBox = selectedBox === VOID ? this.r12b_1 : selectedBox;
    boxMessage = boxMessage === VOID ? this.s12b_1 : boxMessage;
    boxBirthday = boxBirthday === VOID ? this.t12b_1 : boxBirthday;
    boxBirthdayError = boxBirthdayError === VOID ? this.u12b_1 : boxBirthdayError;
    selectedSize = selectedSize === VOID ? this.v12b_1 : selectedSize;
    selectedColor = selectedColor === VOID ? this.w12b_1 : selectedColor;
    selectedOptions = selectedOptions === VOID ? this.x12b_1 : selectedOptions;
    productComment = productComment === VOID ? this.y12b_1 : productComment;
    availableCards = availableCards === VOID ? this.z12b_1 : availableCards;
    availableBoxes = availableBoxes === VOID ? this.a12c_1 : availableBoxes;
    pendingAddToCart = pendingAddToCart === VOID ? this.b12c_1 : pendingAddToCart;
    return $super === VOID ? this.n12h(loading, error, product, pickedImageBytes, imageBitmap, editorElements, isAddingToCart, showEditor, language, initialLayers, initialCustomImageUrl, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, availableCards, availableBoxes, pendingAddToCart) : $super.n12h.call(this, loading, error, product, pickedImageBytes, imageBitmap, editorElements, isAddingToCart, showEditor, language, initialLayers, initialCustomImageUrl, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, availableCards, availableBoxes, pendingAddToCart);
  };
  protoOf(Model3DState).toString = function () {
    return 'Model3DState(loading=' + this.c12b_1 + ', error=' + toString_0(this.d12b_1) + ', product=' + toString_0(this.e12b_1) + ', pickedImageBytes=' + toString_0(this.f12b_1) + ', imageBitmap=' + toString_0(this.g12b_1) + ', editorElements=' + toString(this.h12b_1) + ', isAddingToCart=' + this.i12b_1 + ', showEditor=' + this.j12b_1 + ', language=' + this.k12b_1 + ', initialLayers=' + toString_0(this.l12b_1) + ', initialCustomImageUrl=' + this.m12b_1 + ', selectedCard=' + toString_0(this.n12b_1) + ', cardMessage=' + this.o12b_1 + ', cardBirthday=' + this.p12b_1 + ', cardBirthdayError=' + this.q12b_1 + ', selectedBox=' + toString_0(this.r12b_1) + ', boxMessage=' + this.s12b_1 + ', boxBirthday=' + this.t12b_1 + ', boxBirthdayError=' + this.u12b_1 + ', selectedSize=' + this.v12b_1 + ', selectedColor=' + this.w12b_1 + ', selectedOptions=' + toString(this.x12b_1) + ', productComment=' + this.y12b_1 + ', availableCards=' + toString(this.z12b_1) + ', availableBoxes=' + toString(this.a12c_1) + ', pendingAddToCart=' + this.b12c_1 + ')';
  };
  protoOf(Model3DState).hashCode = function () {
    var result = getBooleanHashCode(this.c12b_1);
    result = imul(result, 31) + (this.d12b_1 == null ? 0 : hashCode(this.d12b_1)) | 0;
    result = imul(result, 31) + (this.e12b_1 == null ? 0 : this.e12b_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f12b_1 == null ? 0 : hashCode(this.f12b_1)) | 0;
    result = imul(result, 31) + (this.g12b_1 == null ? 0 : hashCode(this.g12b_1)) | 0;
    result = imul(result, 31) + hashCode(this.h12b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i12b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j12b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k12b_1) | 0;
    result = imul(result, 31) + (this.l12b_1 == null ? 0 : hashCode(this.l12b_1)) | 0;
    result = imul(result, 31) + (this.m12b_1 == null ? 0 : getStringHashCode(this.m12b_1)) | 0;
    result = imul(result, 31) + (this.n12b_1 == null ? 0 : this.n12b_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.o12b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p12b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q12b_1) | 0;
    result = imul(result, 31) + (this.r12b_1 == null ? 0 : this.r12b_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.s12b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t12b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u12b_1) | 0;
    result = imul(result, 31) + (this.v12b_1 == null ? 0 : getStringHashCode(this.v12b_1)) | 0;
    result = imul(result, 31) + (this.w12b_1 == null ? 0 : getStringHashCode(this.w12b_1)) | 0;
    result = imul(result, 31) + hashCode(this.x12b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y12b_1) | 0;
    result = imul(result, 31) + hashCode(this.z12b_1) | 0;
    result = imul(result, 31) + hashCode(this.a12c_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b12c_1) | 0;
    return result;
  };
  protoOf(Model3DState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Model3DState))
      return false;
    if (!(this.c12b_1 === other.c12b_1))
      return false;
    if (!equals(this.d12b_1, other.d12b_1))
      return false;
    if (!equals(this.e12b_1, other.e12b_1))
      return false;
    if (!equals(this.f12b_1, other.f12b_1))
      return false;
    if (!equals(this.g12b_1, other.g12b_1))
      return false;
    if (!equals(this.h12b_1, other.h12b_1))
      return false;
    if (!(this.i12b_1 === other.i12b_1))
      return false;
    if (!(this.j12b_1 === other.j12b_1))
      return false;
    if (!(this.k12b_1 === other.k12b_1))
      return false;
    if (!equals(this.l12b_1, other.l12b_1))
      return false;
    if (!(this.m12b_1 == other.m12b_1))
      return false;
    if (!equals(this.n12b_1, other.n12b_1))
      return false;
    if (!(this.o12b_1 === other.o12b_1))
      return false;
    if (!(this.p12b_1 === other.p12b_1))
      return false;
    if (!(this.q12b_1 === other.q12b_1))
      return false;
    if (!equals(this.r12b_1, other.r12b_1))
      return false;
    if (!(this.s12b_1 === other.s12b_1))
      return false;
    if (!(this.t12b_1 === other.t12b_1))
      return false;
    if (!(this.u12b_1 === other.u12b_1))
      return false;
    if (!(this.v12b_1 == other.v12b_1))
      return false;
    if (!(this.w12b_1 == other.w12b_1))
      return false;
    if (!equals(this.x12b_1, other.x12b_1))
      return false;
    if (!(this.y12b_1 === other.y12b_1))
      return false;
    if (!equals(this.z12b_1, other.z12b_1))
      return false;
    if (!equals(this.a12c_1, other.a12c_1))
      return false;
    if (!(this.b12c_1 === other.b12c_1))
      return false;
    return true;
  };
  function LoadProduct(productId, product, initialLayers, customImageUrl, kind, initialImageBytes, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday) {
    product = product === VOID ? null : product;
    initialLayers = initialLayers === VOID ? null : initialLayers;
    customImageUrl = customImageUrl === VOID ? null : customImageUrl;
    kind = kind === VOID ? null : kind;
    initialImageBytes = initialImageBytes === VOID ? null : initialImageBytes;
    initialSize = initialSize === VOID ? null : initialSize;
    initialColor = initialColor === VOID ? null : initialColor;
    initialOptions = initialOptions === VOID ? null : initialOptions;
    initialComment = initialComment === VOID ? null : initialComment;
    initialCard = initialCard === VOID ? null : initialCard;
    initialBox = initialBox === VOID ? null : initialBox;
    initialCardMessage = initialCardMessage === VOID ? null : initialCardMessage;
    initialCardBirthday = initialCardBirthday === VOID ? null : initialCardBirthday;
    initialBoxMessage = initialBoxMessage === VOID ? null : initialBoxMessage;
    initialBoxBirthday = initialBoxBirthday === VOID ? null : initialBoxBirthday;
    this.o12h_1 = productId;
    this.p12h_1 = product;
    this.q12h_1 = initialLayers;
    this.r12h_1 = customImageUrl;
    this.s12h_1 = kind;
    this.t12h_1 = initialImageBytes;
    this.u12h_1 = initialSize;
    this.v12h_1 = initialColor;
    this.w12h_1 = initialOptions;
    this.x12h_1 = initialComment;
    this.y12h_1 = initialCard;
    this.z12h_1 = initialBox;
    this.a12i_1 = initialCardMessage;
    this.b12i_1 = initialCardBirthday;
    this.c12i_1 = initialBoxMessage;
    this.d12i_1 = initialBoxBirthday;
  }
  protoOf(LoadProduct).toString = function () {
    return 'LoadProduct(productId=' + toString_0(this.o12h_1) + ', product=' + toString_0(this.p12h_1) + ', initialLayers=' + toString_0(this.q12h_1) + ', customImageUrl=' + this.r12h_1 + ', kind=' + toString_0(this.s12h_1) + ', initialImageBytes=' + toString_0(this.t12h_1) + ', initialSize=' + this.u12h_1 + ', initialColor=' + this.v12h_1 + ', initialOptions=' + toString_0(this.w12h_1) + ', initialComment=' + this.x12h_1 + ', initialCard=' + toString_0(this.y12h_1) + ', initialBox=' + toString_0(this.z12h_1) + ', initialCardMessage=' + this.a12i_1 + ', initialCardBirthday=' + this.b12i_1 + ', initialBoxMessage=' + this.c12i_1 + ', initialBoxBirthday=' + this.d12i_1 + ')';
  };
  protoOf(LoadProduct).hashCode = function () {
    var result = this.o12h_1 == null ? 0 : this.o12h_1.hashCode();
    result = imul(result, 31) + (this.p12h_1 == null ? 0 : this.p12h_1.hashCode()) | 0;
    result = imul(result, 31) + (this.q12h_1 == null ? 0 : hashCode(this.q12h_1)) | 0;
    result = imul(result, 31) + (this.r12h_1 == null ? 0 : getStringHashCode(this.r12h_1)) | 0;
    result = imul(result, 31) + (this.s12h_1 == null ? 0 : this.s12h_1.hashCode()) | 0;
    result = imul(result, 31) + (this.t12h_1 == null ? 0 : hashCode(this.t12h_1)) | 0;
    result = imul(result, 31) + (this.u12h_1 == null ? 0 : getStringHashCode(this.u12h_1)) | 0;
    result = imul(result, 31) + (this.v12h_1 == null ? 0 : getStringHashCode(this.v12h_1)) | 0;
    result = imul(result, 31) + (this.w12h_1 == null ? 0 : hashCode(this.w12h_1)) | 0;
    result = imul(result, 31) + (this.x12h_1 == null ? 0 : getStringHashCode(this.x12h_1)) | 0;
    result = imul(result, 31) + (this.y12h_1 == null ? 0 : this.y12h_1.hashCode()) | 0;
    result = imul(result, 31) + (this.z12h_1 == null ? 0 : this.z12h_1.hashCode()) | 0;
    result = imul(result, 31) + (this.a12i_1 == null ? 0 : getStringHashCode(this.a12i_1)) | 0;
    result = imul(result, 31) + (this.b12i_1 == null ? 0 : getStringHashCode(this.b12i_1)) | 0;
    result = imul(result, 31) + (this.c12i_1 == null ? 0 : getStringHashCode(this.c12i_1)) | 0;
    result = imul(result, 31) + (this.d12i_1 == null ? 0 : getStringHashCode(this.d12i_1)) | 0;
    return result;
  };
  protoOf(LoadProduct).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadProduct))
      return false;
    if (!equals(this.o12h_1, other.o12h_1))
      return false;
    if (!equals(this.p12h_1, other.p12h_1))
      return false;
    if (!equals(this.q12h_1, other.q12h_1))
      return false;
    if (!(this.r12h_1 == other.r12h_1))
      return false;
    if (!equals(this.s12h_1, other.s12h_1))
      return false;
    if (!equals(this.t12h_1, other.t12h_1))
      return false;
    if (!(this.u12h_1 == other.u12h_1))
      return false;
    if (!(this.v12h_1 == other.v12h_1))
      return false;
    if (!equals(this.w12h_1, other.w12h_1))
      return false;
    if (!(this.x12h_1 == other.x12h_1))
      return false;
    if (!equals(this.y12h_1, other.y12h_1))
      return false;
    if (!equals(this.z12h_1, other.z12h_1))
      return false;
    if (!(this.a12i_1 == other.a12i_1))
      return false;
    if (!(this.b12i_1 == other.b12i_1))
      return false;
    if (!(this.c12i_1 == other.c12i_1))
      return false;
    if (!(this.d12i_1 == other.d12i_1))
      return false;
    return true;
  };
  function ImagePicked() {
  }
  function CustomImageApplied(bitmap, bytes, elements) {
    this.m12g_1 = bitmap;
    this.n12g_1 = bytes;
    this.o12g_1 = elements;
  }
  protoOf(CustomImageApplied).toString = function () {
    return 'CustomImageApplied(bitmap=' + toString(this.m12g_1) + ', bytes=' + toString(this.n12g_1) + ', elements=' + toString(this.o12g_1) + ')';
  };
  protoOf(CustomImageApplied).hashCode = function () {
    var result = hashCode(this.m12g_1);
    result = imul(result, 31) + hashCode(this.n12g_1) | 0;
    result = imul(result, 31) + hashCode(this.o12g_1) | 0;
    return result;
  };
  protoOf(CustomImageApplied).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CustomImageApplied))
      return false;
    if (!equals(this.m12g_1, other.m12g_1))
      return false;
    if (!equals(this.n12g_1, other.n12g_1))
      return false;
    if (!equals(this.o12g_1, other.o12g_1))
      return false;
    return true;
  };
  function UpdateElements() {
  }
  function AddToCart() {
  }
  protoOf(AddToCart).toString = function () {
    return 'AddToCart';
  };
  protoOf(AddToCart).hashCode = function () {
    return 962889472;
  };
  protoOf(AddToCart).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddToCart))
      return false;
    return true;
  };
  var AddToCart_instance;
  function AddToCart_getInstance() {
    return AddToCart_instance;
  }
  function RemoveCustomization() {
  }
  protoOf(RemoveCustomization).toString = function () {
    return 'RemoveCustomization';
  };
  protoOf(RemoveCustomization).hashCode = function () {
    return 892192627;
  };
  protoOf(RemoveCustomization).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemoveCustomization))
      return false;
    return true;
  };
  var RemoveCustomization_instance;
  function RemoveCustomization_getInstance() {
    return RemoveCustomization_instance;
  }
  function OpenEditor() {
  }
  protoOf(OpenEditor).toString = function () {
    return 'OpenEditor';
  };
  protoOf(OpenEditor).hashCode = function () {
    return -1009641965;
  };
  protoOf(OpenEditor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OpenEditor))
      return false;
    return true;
  };
  var OpenEditor_instance;
  function OpenEditor_getInstance() {
    return OpenEditor_instance;
  }
  function CloseEditor() {
  }
  protoOf(CloseEditor).toString = function () {
    return 'CloseEditor';
  };
  protoOf(CloseEditor).hashCode = function () {
    return 607815497;
  };
  protoOf(CloseEditor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CloseEditor))
      return false;
    return true;
  };
  var CloseEditor_instance;
  function CloseEditor_getInstance() {
    return CloseEditor_instance;
  }
  function CardSelected(card) {
    this.e12i_1 = card;
  }
  protoOf(CardSelected).toString = function () {
    return 'CardSelected(card=' + toString_0(this.e12i_1) + ')';
  };
  protoOf(CardSelected).hashCode = function () {
    return this.e12i_1 == null ? 0 : this.e12i_1.hashCode();
  };
  protoOf(CardSelected).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CardSelected))
      return false;
    if (!equals(this.e12i_1, other.e12i_1))
      return false;
    return true;
  };
  function CardMessageChanged(message) {
    this.f12i_1 = message;
  }
  protoOf(CardMessageChanged).toString = function () {
    return 'CardMessageChanged(message=' + this.f12i_1 + ')';
  };
  protoOf(CardMessageChanged).hashCode = function () {
    return getStringHashCode(this.f12i_1);
  };
  protoOf(CardMessageChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CardMessageChanged))
      return false;
    if (!(this.f12i_1 === other.f12i_1))
      return false;
    return true;
  };
  function CardBirthdayChanged(birthday) {
    this.g12i_1 = birthday;
  }
  protoOf(CardBirthdayChanged).toString = function () {
    return 'CardBirthdayChanged(birthday=' + this.g12i_1 + ')';
  };
  protoOf(CardBirthdayChanged).hashCode = function () {
    return getStringHashCode(this.g12i_1);
  };
  protoOf(CardBirthdayChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CardBirthdayChanged))
      return false;
    if (!(this.g12i_1 === other.g12i_1))
      return false;
    return true;
  };
  function BoxSelected(box) {
    this.h12i_1 = box;
  }
  protoOf(BoxSelected).toString = function () {
    return 'BoxSelected(box=' + toString_0(this.h12i_1) + ')';
  };
  protoOf(BoxSelected).hashCode = function () {
    return this.h12i_1 == null ? 0 : this.h12i_1.hashCode();
  };
  protoOf(BoxSelected).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxSelected))
      return false;
    if (!equals(this.h12i_1, other.h12i_1))
      return false;
    return true;
  };
  function BoxMessageChanged(message) {
    this.i12i_1 = message;
  }
  protoOf(BoxMessageChanged).toString = function () {
    return 'BoxMessageChanged(message=' + this.i12i_1 + ')';
  };
  protoOf(BoxMessageChanged).hashCode = function () {
    return getStringHashCode(this.i12i_1);
  };
  protoOf(BoxMessageChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxMessageChanged))
      return false;
    if (!(this.i12i_1 === other.i12i_1))
      return false;
    return true;
  };
  function BoxBirthdayChanged(birthday) {
    this.j12i_1 = birthday;
  }
  protoOf(BoxBirthdayChanged).toString = function () {
    return 'BoxBirthdayChanged(birthday=' + this.j12i_1 + ')';
  };
  protoOf(BoxBirthdayChanged).hashCode = function () {
    return getStringHashCode(this.j12i_1);
  };
  protoOf(BoxBirthdayChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxBirthdayChanged))
      return false;
    if (!(this.j12i_1 === other.j12i_1))
      return false;
    return true;
  };
  function SizeSelected(size) {
    this.k12i_1 = size;
  }
  protoOf(SizeSelected).toString = function () {
    return 'SizeSelected(size=' + this.k12i_1 + ')';
  };
  protoOf(SizeSelected).hashCode = function () {
    return this.k12i_1 == null ? 0 : getStringHashCode(this.k12i_1);
  };
  protoOf(SizeSelected).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeSelected))
      return false;
    if (!(this.k12i_1 == other.k12i_1))
      return false;
    return true;
  };
  function ColorSelected(color) {
    this.l12i_1 = color;
  }
  protoOf(ColorSelected).toString = function () {
    return 'ColorSelected(color=' + this.l12i_1 + ')';
  };
  protoOf(ColorSelected).hashCode = function () {
    return this.l12i_1 == null ? 0 : getStringHashCode(this.l12i_1);
  };
  protoOf(ColorSelected).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorSelected))
      return false;
    if (!(this.l12i_1 == other.l12i_1))
      return false;
    return true;
  };
  function OptionSelected(key, value) {
    this.m12i_1 = key;
    this.n12i_1 = value;
  }
  protoOf(OptionSelected).toString = function () {
    return 'OptionSelected(key=' + this.m12i_1 + ', value=' + toString_0(this.n12i_1) + ')';
  };
  protoOf(OptionSelected).hashCode = function () {
    var result = getStringHashCode(this.m12i_1);
    result = imul(result, 31) + (this.n12i_1 == null ? 0 : this.n12i_1.hashCode()) | 0;
    return result;
  };
  protoOf(OptionSelected).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OptionSelected))
      return false;
    if (!(this.m12i_1 === other.m12i_1))
      return false;
    if (!equals(this.n12i_1, other.n12i_1))
      return false;
    return true;
  };
  function ProductCommentChanged(comment) {
    this.o12i_1 = comment;
  }
  protoOf(ProductCommentChanged).toString = function () {
    return 'ProductCommentChanged(comment=' + this.o12i_1 + ')';
  };
  protoOf(ProductCommentChanged).hashCode = function () {
    return getStringHashCode(this.o12i_1);
  };
  protoOf(ProductCommentChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductCommentChanged))
      return false;
    if (!(this.o12i_1 === other.o12i_1))
      return false;
    return true;
  };
  function ModelMugIntent() {
  }
  function ShowMessage_1(message) {
    this.p12i_1 = message;
  }
  protoOf(ShowMessage_1).toString = function () {
    return 'ShowMessage(message=' + toString(this.p12i_1) + ')';
  };
  protoOf(ShowMessage_1).hashCode = function () {
    return hashCode(this.p12i_1);
  };
  protoOf(ShowMessage_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowMessage_1))
      return false;
    if (!equals(this.p12i_1, other.p12i_1))
      return false;
    return true;
  };
  function NavigateBack_0() {
  }
  protoOf(NavigateBack_0).toString = function () {
    return 'NavigateBack';
  };
  protoOf(NavigateBack_0).hashCode = function () {
    return -1521036412;
  };
  protoOf(NavigateBack_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateBack_0))
      return false;
    return true;
  };
  var NavigateBack_instance_0;
  function NavigateBack_getInstance_0() {
    return NavigateBack_instance_0;
  }
  function NavigateToAuth_0() {
  }
  protoOf(NavigateToAuth_0).toString = function () {
    return 'NavigateToAuth';
  };
  protoOf(NavigateToAuth_0).hashCode = function () {
    return -899856864;
  };
  protoOf(NavigateToAuth_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateToAuth_0))
      return false;
    return true;
  };
  var NavigateToAuth_instance_0;
  function NavigateToAuth_getInstance_0() {
    return NavigateToAuth_instance_0;
  }
  function Model3DSideEffect() {
  }
  function createSnapshotWithBackground(elements, backgroundColor, scale) {
    scale = scale === VOID ? 1.0 : scale;
    _init_properties_ModelMugContract_kt__btiswo();
    var width = coerceAtLeast(numberToInt(2100 * scale), 1);
    var height = coerceAtLeast(numberToInt(950 * scale), 1);
    var bitmap = ImageBitmap(width, height);
    var canvas = Canvas(bitmap);
    var canvasDrawScope = new CanvasDrawScope();
    var tmp2 = Density(1.0);
    var tmp4 = LayoutDirection_Ltr_getInstance();
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(width));
    var v2 = fromInt(toRawBits(height));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.graphics.drawscope.CanvasDrawScope.draw' call
    var size = _Size___init__impl__aywn0g(tmp$ret$1);
    var _destruct__k2r9zo = canvasDrawScope.h6o_1;
    var prevDensity = _destruct__k2r9zo.zh();
    var prevLayoutDirection = _destruct__k2r9zo.ai();
    var prevCanvas = _destruct__k2r9zo.hr();
    var prevSize = _destruct__k2r9zo.j6p();
    // Inline function 'kotlin.apply' call
    var this_0 = canvasDrawScope.h6o_1;
    this_0.f6p_1 = tmp2;
    this_0.g6p_1 = tmp4;
    this_0.h6p_1 = canvas;
    this_0.i6p_1 = size;
    canvas.t6d();
    canvasDrawScope.b6q(backgroundColor);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = elements.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'androidx.compose.ui.graphics.drawscope.withTransform' call
      // Inline function 'kotlin.with' call
      var $this$with = canvasDrawScope.v6p();
      var previousSize = $this$with.o5d();
      $this$with.x5u().t6d();
      try {
        var $this$withTransform = $this$with.p6p();
        $this$withTransform.b5d(width / 2.0, height / 2.0);
        // Inline function 'androidx.compose.ui.geometry.Offset.x' call
        var this_1 = element.b12g_1;
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value = _Offset___get_packedValue__impl__xh2k8q(this_1);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(shiftRight(value, 32));
        var tmp = floatFromBits(bits) * scale;
        // Inline function 'androidx.compose.ui.geometry.Offset.y' call
        var this_2 = element.b12g_1;
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_2);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
        var tmp$ret$16 = floatFromBits(bits_0);
        $this$withTransform.b5d(tmp, tmp$ret$16 * scale);
        $this$withTransform.t6q(element.e12g_1, Companion_getInstance_24().g5d_1);
        $this$withTransform.u6q(element.c12g_1 * (element.g12g_1 ? -1.0 : 1.0) * scale, element.d12g_1 * (element.h12g_1 ? -1.0 : 1.0) * scale, Companion_getInstance_24().g5d_1);
        var tmp1_image = element.a12g_1;
        var tmp0 = (-element.a12g_1.h5e() | 0) / 2 | 0;
        // Inline function 'androidx.compose.ui.unit.IntOffset' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val2 = (-element.a12g_1.i5e() | 0) / 2 | 0;
        var tmp$ret$22 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
        var tmp2_dstOffset = _IntOffset___init__impl__rq8h7b(tmp$ret$22);
        var tmp3_filterQuality = Companion_getInstance_27().u6g_1;
        var tmp_0;
        switch (element.f12g_1.a1_1) {
          case 0:
            tmp_0 = null;
            break;
          case 1:
            tmp_0 = Companion_instance_2.j6g(_ColorMatrix___init__impl__3gytx1(get_SepiaMatrix()));
            break;
          case 2:
            tmp_0 = Companion_instance_2.j6g(_ColorMatrix___init__impl__3gytx1(get_GrayscaleMatrix()));
            break;
          case 3:
            tmp_0 = Companion_instance_2.j6g(_ColorMatrix___init__impl__3gytx1(get_InvertMatrix()));
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var tmp4_colorFilter = tmp_0;
        canvasDrawScope.d6q(tmp1_image, VOID, VOID, tmp2_dstOffset, VOID, VOID, VOID, tmp4_colorFilter, VOID, tmp3_filterQuality);
      }finally {
        $this$with.x5u().u6d();
        $this$with.o6p(previousSize);
      }
    }
    canvas.u6d();
    // Inline function 'kotlin.apply' call
    var this_3 = canvasDrawScope.h6o_1;
    this_3.f6p_1 = prevDensity;
    this_3.g6p_1 = prevLayoutDirection;
    this_3.h6p_1 = prevCanvas;
    this_3.i6p_1 = prevSize;
    return bitmap;
  }
  function FilterType_None_getInstance() {
    FilterType_initEntries();
    return FilterType_None_instance;
  }
  function FilterType_Sepia_getInstance() {
    FilterType_initEntries();
    return FilterType_Sepia_instance;
  }
  function FilterType_Grayscale_getInstance() {
    FilterType_initEntries();
    return FilterType_Grayscale_instance;
  }
  function FilterType_Invert_getInstance() {
    FilterType_initEntries();
    return FilterType_Invert_instance;
  }
  var properties_initialized_ModelMugContract_kt_if39va;
  function _init_properties_ModelMugContract_kt__btiswo() {
    if (!properties_initialized_ModelMugContract_kt_if39va) {
      properties_initialized_ModelMugContract_kt_if39va = true;
      // Inline function 'kotlin.floatArrayOf' call
      SepiaMatrix = new Float32Array([0.393, 0.769, 0.189, 0.0, 0.0, 0.349, 0.686, 0.168, 0.0, 0.0, 0.272, 0.534, 0.131, 0.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0]);
      // Inline function 'kotlin.floatArrayOf' call
      GrayscaleMatrix = new Float32Array([0.2126, 0.7152, 0.0722, 0.0, 0.0, 0.2126, 0.7152, 0.0722, 0.0, 0.0, 0.2126, 0.7152, 0.0722, 0.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0]);
      // Inline function 'kotlin.floatArrayOf' call
      InvertMatrix = new Float32Array([-1.0, 0.0, 0.0, 0.0, 1.0, 0.0, -1.0, 0.0, 0.0, 1.0, 0.0, 0.0, -1.0, 0.0, 1.0, 0.0, 0.0, 0.0, 1.0, 0.0]);
      client_fstech_hadaya_presentation_model3d_Model3DState$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_LoadProduct$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_ImagePicked$stable = 8;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_CustomImageApplied$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_UpdateElements$stable = 8;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_AddToCart$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_RemoveCustomization$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_OpenEditor$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_CloseEditor$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_CardSelected$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_CardMessageChanged$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_CardBirthdayChanged$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_BoxSelected$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_BoxMessageChanged$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_BoxBirthdayChanged$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_SizeSelected$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_ColorSelected$stable = 0;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_OptionSelected$stable = 8;
      client_fstech_hadaya_presentation_model3d_ModelMugIntent_ProductCommentChanged$stable = 0;
      client_fstech_hadaya_presentation_model3d_Model3DSideEffect_ShowMessage$stable = 8;
      client_fstech_hadaya_presentation_model3d_Model3DSideEffect_NavigateBack$stable = 0;
      client_fstech_hadaya_presentation_model3d_Model3DSideEffect_NavigateToAuth$stable = 0;
      client_fstech_hadaya_presentation_model3d_EditorImageElement$stable = 8;
    }
  }
  function ModelMugScreen(onBack, onNavigateToAuth, productId, product, initialImageBytes, initialLayers, customImageUrl, snackbarHostState, showAddToCart, modifier, $composer, $changed, $default) {
    var productId_0 = {_v: productId};
    var product_0 = {_v: product};
    var initialImageBytes_0 = {_v: initialImageBytes};
    var initialLayers_0 = {_v: initialLayers};
    var customImageUrl_0 = {_v: customImageUrl};
    var snackbarHostState_0 = {_v: snackbarHostState};
    var showAddToCart_0 = {_v: showAddToCart};
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-203051367);
    sourceInformation($composer_0, 'C(ModelMugScreen)P(4,5,7,6,1,2!1,9,8)30@1261L32,34@1383L31,35@1431L32,36@1508L60,37@1608L69,38@1721L16,39@1783L34,45@2154L331,45@2069L416,57@2517L660,57@2491L686,73@3183L3262:ModelMugScreen.kt#mu900e');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToAuth) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(productId_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ((($changed & 4096) === 0 ? $composer_0.k31(product_0._v) : $composer_0.q31(product_0._v)) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ((($changed & 32768) === 0 ? $composer_0.k31(initialImageBytes_0._v) : $composer_0.q31(initialImageBytes_0._v)) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ((($changed & 262144) === 0 ? $composer_0.k31(initialLayers_0._v) : $composer_0.q31(initialLayers_0._v)) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(customImageUrl_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.k31(snackbarHostState_0._v) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.l31(showAddToCart_0._v) ? 67108864 : 33554432);
    if (!(($default & 512) === 0))
      $dirty = $dirty | 805306368;
    else if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 536870912 : 268435456);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        productId_0._v = null;
      }
      if (!(($default & 8) === 0)) {
        product_0._v = null;
      }
      if (!(($default & 16) === 0)) {
        initialImageBytes_0._v = null;
      }
      if (!(($default & 32) === 0)) {
        initialLayers_0._v = null;
      }
      if (!(($default & 64) === 0)) {
        customImageUrl_0._v = null;
      }
      if (!(($default & 128) === 0)) {
        sourceInformationMarkerStart($composer_0, -1858825575, 'CC(remember):ModelMugScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = new SnackbarHostState();
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var tmp0_group = tmp;
        sourceInformationMarkerEnd($composer_0);
        snackbarHostState_0._v = tmp0_group;
      }
      if (!(($default & 256) === 0)) {
        showAddToCart_0._v = true;
      }
      if (!(($default & 512) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (isTraceInProgress()) {
        traceEventStart(-203051367, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.ModelMugScreen (ModelMugScreen.kt:33)');
      }
      var back = stringResource(get_back(string_instance), $composer_0, 0);
      var login = stringResource(get_login(string_instance), $composer_0, 0);
      var please_login_to_add_items_to_cart = stringResource(get_please_login_to_add_items_to_cart(string_instance), $composer_0, 0);
      var tmp0_safe_receiver = productId_0._v;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp2_safe_receiver = product_0._v;
        var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.nzt_1;
        tmp_0 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = tmp_0;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((59 & 1) === 0))
        qualifier = null;
      if (!((59 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp_1;
      }
      if (!((59 & 4) === 0))
        key = null;
      if (!((59 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((59 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((59 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(ModelMugViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_2 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_2, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, -1858808869, 'CC(remember):ModelMugScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_0.i31();
      var tmp_3;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = ModelMugScreen$lambda_0(viewModel);
        tmp0_0.j31(value_0);
        tmp_3 = value_0;
      } else {
        tmp_3 = it_0;
      }
      var tmp1_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      var onIntent = tmp1_group;
      var language = ModelMugScreen$lambda(state$delegate).k12b_1;
      var tmp_4;
      if (language === 'en') {
        var tmp4_safe_receiver = ModelMugScreen$lambda(state$delegate).e12b_1;
        var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.ozt_1;
        var tmp_5;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = ModelMugScreen$lambda(state$delegate).e12b_1;
          tmp_5 = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.pzt_1;
        } else {
          tmp_5 = tmp5_elvis_lhs;
        }
        tmp_4 = tmp_5;
      } else {
        var tmp7_safe_receiver = ModelMugScreen$lambda(state$delegate).e12b_1;
        var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.pzt_1;
        var tmp_6;
        if (tmp8_elvis_lhs == null) {
          var tmp9_safe_receiver = ModelMugScreen$lambda(state$delegate).e12b_1;
          tmp_6 = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.ozt_1;
        } else {
          tmp_6 = tmp8_elvis_lhs;
        }
        tmp_4 = tmp_6;
      }
      var tmp10_elvis_lhs = tmp_4;
      var tmp_7;
      if (tmp10_elvis_lhs == null) {
        $composer_0.m30(-1858801308);
        sourceInformation($composer_0, '42@2019L43');
        var tmp2_group = stringResource(get_design_your_item(string_instance), $composer_0, 0);
        $composer_0.n30();
        tmp_7 = tmp2_group;
      } else {
        $composer_0.m30(-1858806020);
        $composer_0.n30();
        tmp_7 = tmp10_elvis_lhs;
      }
      var name = tmp_7;
      var tmp_8 = [productId_0._v, product_0._v, initialImageBytes_0._v, initialLayers_0._v, customImageUrl_0._v];
      sourceInformationMarkerStart($composer_0, -1858796700, 'CC(remember):ModelMugScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(!!(!!(!!(!!($composer_0.q31(viewModel) | ($dirty & 896) === 256) | (($dirty & 7168) === 2048 || (!(($dirty & 4096) === 0) && $composer_0.q31(product_0._v)))) | (($dirty & 458752) === 131072 || (!(($dirty & 262144) === 0) && $composer_0.q31(initialLayers_0._v)))) | ($dirty & 3670016) === 1048576) | (($dirty & 57344) === 16384 || (!(($dirty & 32768) === 0) && $composer_0.q31(initialImageBytes_0._v))));
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_1.i31();
      var tmp_9;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = ModelMugScreen$slambda_0(viewModel, productId_0, product_0, initialLayers_0, customImageUrl_0, initialImageBytes_0, null);
        tmp0_1.j31(value_1);
        tmp_9 = value_1;
      } else {
        tmp_9 = it_1;
      }
      var tmp3_group = tmp_9;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_1(tmp_8, tmp3_group, $composer_0, 0);
      sourceInformationMarkerStart($composer_0, -1858784755, 'CC(remember):ModelMugScreen.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(!!(!!(!!(!!($composer_0.q31(viewModel) | ($dirty & 29360128) === 8388608) | ($dirty & 14) === 4) | $composer_0.k31(please_login_to_add_items_to_cart)) | $composer_0.k31(login)) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_2.i31();
      var tmp_10;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = ModelMugScreen$slambda_2(viewModel, snackbarHostState_0, onBack, please_login_to_add_items_to_cart, login, onNavigateToAuth, null);
        tmp0_2.j31(value_2);
        tmp_10 = value_2;
      } else {
        tmp_10 = it_2;
      }
      var tmp4_group = tmp_10;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp4_group, $composer_0, 0);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_1 = fillMaxSize(modifier_0._v);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_2 = $composer_0;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_3 = $composer_2;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_2);
      var tmp0_3 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_11 = $composer_4.g30();
      if (!isInterface(tmp_11, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_3);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_5 = $composer_4;
      var $composer_6 = $composer_5;
      sourceInformationMarkerStart($composer_6, -148535011, 'C74@3232L1449,142@6311L128:ModelMugScreen.kt#mu900e');
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_3 = fillMaxSize(Companion_instance);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_7 = $composer_6;
      if (!((6 & 1) === 0))
        modifier_3 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_7, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_4 = modifier_3;
      var $composer_8 = $composer_7;
      if (!((0 & 2) === 0))
        modifier_4 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
      var localMap_0 = $composer_8.t31();
      var materialized_0 = materialize($composer_8, modifier_4);
      var tmp0_4 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_9 = $composer_8;
      var tmp_12 = $composer_9.g30();
      if (!isInterface(tmp_12, Applier)) {
        invalidApplier();
      }
      $composer_9.b31();
      if ($composer_9.h30()) {
        $composer_9.c31(tmp0_4);
      } else {
        $composer_9.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_10 = $composer_9;
      var $composer_11 = $composer_10;
      sourceInformationMarkerStart($composer_11, 12375815, 'C103@4539L34,101@4457L214:ModelMugScreen.kt#mu900e');
      if (!ModelMugScreen$lambda(state$delegate).j12b_1) {
        $composer_11.m30(12390880);
        sourceInformation($composer_11, '77@3368L14,78@3421L201,83@3654L697,76@3329L1101');
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(2050361452, true, ModelMugScreen$lambda_1(name), $composer_11, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_12 = $composer_11;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_12.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_3 = $composer_12.i31();
        var tmp_13;
        if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
          var value_3 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_12.j31(value_3);
          tmp_13 = value_3;
        } else {
          tmp_13 = it_3;
        }
        var tmp_14 = tmp_13;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-1572772950, true, ModelMugScreen$lambda_2(onBack, back), $composer_11, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_13 = $composer_11;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = $composer_13.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_13.i31();
        var tmp_15;
        if (invalid_3 || it_4 === Companion_getInstance().f30_1) {
          var value_4 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_13.j31(value_4);
          tmp_15 = value_4;
        } else {
          tmp_15 = it_4;
        }
        var tmp_16 = tmp_15;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(1357162145, true, ModelMugScreen$lambda_3(showAddToCart_0, onIntent, state$delegate), $composer_11, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_14 = $composer_11;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = $composer_14.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_5 = $composer_14.i31();
        var tmp_17;
        if (invalid_4 || it_5 === Companion_getInstance().f30_1) {
          var value_5 = ComposableLambda$invoke$ref_1(dispatchReceiver_1);
          $composer_14.j31(value_5);
          tmp_17 = value_5;
        } else {
          tmp_17 = it_5;
        }
        var tmp_18 = tmp_17;
        var tmp_19 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_20 = WindowInsets(0, 0, 0, 0);
        TopAppBar(tmp_14, null, tmp_16, tmp_18, tmp_19, tmp_20, null, null, $composer_11, 3462, 210);
        $composer_11.n30();
      } else {
        $composer_11.m30(13479693);
        $composer_11.n30();
      }
      var tmp_21 = ModelMugScreen$lambda(state$delegate);
      sourceInformationMarkerStart($composer_11, 277532567, 'CC(remember):ModelMugScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_5 = $composer_11.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_6 = $composer_11.i31();
      var tmp_22;
      if (invalid_5 || it_6 === Companion_getInstance().f30_1) {
        var value_6 = ModelMugScreen$lambda_4(viewModel);
        $composer_11.j31(value_6);
        tmp_22 = value_6;
      } else {
        tmp_22 = it_6;
      }
      var tmp0_group_0 = tmp_22;
      sourceInformationMarkerEnd($composer_11);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$55 = _Dp___init__impl__ms3zkb(0);
      var tmp_23 = PaddingValues_1(tmp$ret$55);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_24 = _Dp___init__impl__ms3zkb(64);
      ModelMugScreenContent(tmp_21, tmp0_group_0, tmp_23, false, tmp_24, _Dp___init__impl__ms3zkb(0.0), $composer_11, 24960, 40);
      sourceInformationMarkerEnd($composer_11);
      $composer_9.e31();
      if (!ModelMugScreen$lambda(state$delegate).j12b_1 && ModelMugScreen$lambda(state$delegate).d12b_1 == null && !ModelMugScreen$lambda(state$delegate).c12b_1) {
        $composer_6.m30(-147075687);
        sourceInformation($composer_6, '110@4769L1522');
        var tmp_25 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().s8t_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$57 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_5 = padding_0(tmp_25, tmp$ret$57);
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = Companion_getInstance_11().y8t_1;
        var $composer_15 = $composer_6;
        if (!((2 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((2 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((2 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_1 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_15, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_16 = $composer_15;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_16, 0).hashCode();
        var localMap_1 = $composer_16.t31();
        var materialized_1 = materialize($composer_16, modifier_6);
        var tmp0_5 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_17 = $composer_16;
        var tmp_26 = $composer_17.g30();
        if (!isInterface(tmp_26, Applier)) {
          invalidApplier();
        }
        $composer_17.b31();
        if ($composer_17.h30()) {
          $composer_17.c31(tmp0_5);
        } else {
          $composer_17.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_17);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_18 = $composer_17;
        var $composer_19 = $composer_18;
        sourceInformationMarkerStart($composer_19, -746924316, 'C136@6108L39,136@6077L200:ModelMugScreen.kt#mu900e');
        if (!(ModelMugScreen$lambda(state$delegate).g12b_1 == null)) {
          $composer_19.m30(-746901253);
          sourceInformation($composer_19, '118@5096L48,119@5201L11,120@5282L11,117@5035L521,127@5577L40,129@5699L39,130@5795L11,128@5638L343,134@6002L40');
          sourceInformationMarkerStart($composer_19, -162639264, 'CC(remember):ModelMugScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_6 = $composer_19.k31(onIntent);
          // Inline function 'kotlin.let' call
          var it_7 = $composer_19.i31();
          var tmp_27;
          if (invalid_6 || it_7 === Companion_getInstance().f30_1) {
            var value_7 = ModelMugScreen$lambda_5(onIntent);
            $composer_19.j31(value_7);
            tmp_27 = value_7;
          } else {
            tmp_27 = it_7;
          }
          var tmp0_group_1 = tmp_27;
          sourceInformationMarkerEnd($composer_19);
          var tmp_28 = MaterialTheme_instance.unz($composer_19, 6).vo0_1;
          var tmp_29 = MaterialTheme_instance.unz($composer_19, 6).to0_1;
          SmallFloatingActionButton(tmp0_group_1, null, null, tmp_28, tmp_29, null, null, ComposableSingletons$ModelMugScreenKt_getInstance().r12i_1, $composer_19, 12582912, 102);
          var tmp_30 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$68 = _Dp___init__impl__ms3zkb(8);
          Spacer(height(tmp_30, tmp$ret$68), $composer_19, 6);
          sourceInformationMarkerStart($composer_19, -162619977, 'CC(remember):ModelMugScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_7 = $composer_19.k31(onIntent);
          // Inline function 'kotlin.let' call
          var it_8 = $composer_19.i31();
          var tmp_31;
          if (invalid_7 || it_8 === Companion_getInstance().f30_1) {
            var value_8 = ModelMugScreen$lambda_6(onIntent);
            $composer_19.j31(value_8);
            tmp_31 = value_8;
          } else {
            tmp_31 = it_8;
          }
          var tmp1_group_0 = tmp_31;
          sourceInformationMarkerEnd($composer_19);
          var tmp_32 = MaterialTheme_instance.unz($composer_19, 6).eo0_1;
          var tmp_33 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          SmallFloatingActionButton(tmp1_group_0, null, null, tmp_32, tmp_33, null, null, ComposableSingletons$ModelMugScreenKt_getInstance().s12i_1, $composer_19, 12582912, 118);
          var tmp_34 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$73 = _Dp___init__impl__ms3zkb(8);
          Spacer(height(tmp_34, tmp$ret$73), $composer_19, 6);
          $composer_19.n30();
        } else {
          $composer_19.m30(-745895086);
          $composer_19.n30();
        }
        sourceInformationMarkerStart($composer_19, -162606889, 'CC(remember):ModelMugScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_8 = $composer_19.k31(onIntent);
        // Inline function 'kotlin.let' call
        var it_9 = $composer_19.i31();
        var tmp_35;
        if (invalid_8 || it_9 === Companion_getInstance().f30_1) {
          var value_9 = ModelMugScreen$lambda_7(onIntent);
          $composer_19.j31(value_9);
          tmp_35 = value_9;
        } else {
          tmp_35 = it_9;
        }
        var tmp2_group_0 = tmp_35;
        sourceInformationMarkerEnd($composer_19);
        var tmp_36 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_37 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        FloatingActionButton(tmp2_group_0, null, null, tmp_36, tmp_37, null, null, ComposableSingletons$ModelMugScreenKt_getInstance().t12i_1, $composer_19, 12582912, 126);
        sourceInformationMarkerEnd($composer_19);
        $composer_17.e31();
        $composer_6.n30();
      } else {
        $composer_6.m30(-145589981);
        $composer_6.n30();
      }
      var tmp_38 = snackbarHostState_0._v;
      var tmp_39 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(tmp_38, tmp_39, null, $composer_6, 14 & $dirty >> 21, 4);
      sourceInformationMarkerEnd($composer_6);
      $composer_4.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp5_safe_receiver = $composer_0.t30();
    if (tmp5_safe_receiver == null)
      null;
    else {
      tmp5_safe_receiver.p3c(ModelMugScreen$lambda_8(onBack, onNavigateToAuth, productId_0, product_0, initialImageBytes_0, initialLayers_0, customImageUrl_0, snackbarHostState_0, showAddToCart_0, modifier_0, $changed, $default));
    }
  }
  function ComposableSingletons$ModelMugScreenKt$lambda$_1069797219$lambda_sc6buy($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C93@4200L38,93@4195L44:ModelMugScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1069797219, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$ModelMugScreenKt.lambda$-1069797219.<anonymous> (ModelMugScreen.kt:93)');
      }
      var tmp = stringResource(get_add_to_cart(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenKt$lambda$403850958$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C124@5469L39,122@5348L186:ModelMugScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(403850958, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$ModelMugScreenKt.lambda$403850958.<anonymous> (ModelMugScreen.kt:122)');
      }
      var tmp = get_Backspace(AutoMirrored_getInstance().cxv_1);
      var tmp_0 = stringResource(get_remove_image(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenKt$lambda$1024278149$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C132@5920L38,132@5874L85:ModelMugScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1024278149, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$ModelMugScreenKt.lambda$1024278149.<anonymous> (ModelMugScreen.kt:132)');
      }
      var tmp = get_Edit(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_edit_design(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenKt$lambda$_797509326$lambda_ocfv6x($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C137@6222L36,137@6171L88:ModelMugScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-797509326, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$ModelMugScreenKt.lambda$-797509326.<anonymous> (ModelMugScreen.kt:137)');
      }
      var tmp = get_AddAPhoto(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_add_image(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenKt() {
    ComposableSingletons$ModelMugScreenKt_instance = this;
    var tmp = this;
    tmp.q12i_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1069797219, false, ComposableSingletons$ModelMugScreenKt$lambda$_1069797219$lambda_sc6buy));
    var tmp_0 = this;
    tmp_0.r12i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(403850958, false, ComposableSingletons$ModelMugScreenKt$lambda$403850958$lambda));
    var tmp_1 = this;
    tmp_1.s12i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1024278149, false, ComposableSingletons$ModelMugScreenKt$lambda$1024278149$lambda));
    var tmp_2 = this;
    tmp_2.t12i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-797509326, false, ComposableSingletons$ModelMugScreenKt$lambda$_797509326$lambda_ocfv6x));
  }
  var ComposableSingletons$ModelMugScreenKt_instance;
  function ComposableSingletons$ModelMugScreenKt_getInstance() {
    if (ComposableSingletons$ModelMugScreenKt_instance == null)
      new ComposableSingletons$ModelMugScreenKt();
    return ComposableSingletons$ModelMugScreenKt_instance;
  }
  function ModelMugScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function ModelMugScreen$lambda_0($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(it);
      return Unit_instance;
    };
  }
  function ModelMugScreen$slambda($viewModel, $productId, $product, $initialLayers, $customImageUrl, $initialImageBytes, resultContinuation) {
    this.c12j_1 = $viewModel;
    this.d12j_1 = $productId;
    this.e12j_1 = $product;
    this.f12j_1 = $initialLayers;
    this.g12j_1 = $customImageUrl;
    this.h12j_1 = $initialImageBytes;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ModelMugScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ModelMugScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ModelMugScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.c12j_1.s10h().j10i(new LoadProduct(this.d12j_1._v, this.e12j_1._v, this.f12j_1._v, this.g12j_1._v, VOID, this.h12j_1._v));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ModelMugScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new ModelMugScreen$slambda(this.c12j_1, this.d12j_1, this.e12j_1, this.f12j_1, this.g12j_1, this.h12j_1, completion);
    i.i12j_1 = $this$LaunchedEffect;
    return i;
  };
  function ModelMugScreen$slambda_0($viewModel, $productId, $product, $initialLayers, $customImageUrl, $initialImageBytes, resultContinuation) {
    var i = new ModelMugScreen$slambda($viewModel, $productId, $product, $initialLayers, $customImageUrl, $initialImageBytes, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_15(function_0) {
    this.j12j_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_15).a1v = function (value, $completion) {
    return this.j12j_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_15).q3 = function () {
    return this.j12j_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_15).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_15).hashCode = function () {
    return hashCode(this.q3());
  };
  function ModelMugScreen$slambda$slambda($snackbarHostState, $onBack, $please_login_to_add_items_to_cart, $login, $onNavigateToAuth, resultContinuation) {
    this.s12j_1 = $snackbarHostState;
    this.t12j_1 = $onBack;
    this.u12j_1 = $please_login_to_add_items_to_cart;
    this.v12j_1 = $login;
    this.w12j_1 = $onNavigateToAuth;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ModelMugScreen$slambda$slambda).a12k = function (effect, $completion) {
    var tmp = this.b12k(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ModelMugScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.a12k((!(p1 == null) ? isInterface(p1, Model3DSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ModelMugScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp0_subject = this.x12j_1;
            if (tmp0_subject instanceof ShowMessage_1) {
              this.z12j_1 = this.s12j_1._v;
              this.n9_1 = 2;
              suspendResult = this.x12j_1.p12i_1.z10i(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (equals(tmp0_subject, NavigateBack_instance_0)) {
                this.y12j_1 = this.t12j_1();
                this.n9_1 = 4;
                continue $sm;
              } else {
                if (equals(tmp0_subject, NavigateToAuth_instance_0)) {
                  this.n9_1 = 1;
                  suspendResult = this.s12j_1._v.dqm(this.u12j_1, this.v12j_1, VOID, VOID, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            var result = suspendResult;
            var tmp_1 = this;
            if (result.equals(SnackbarResult_ActionPerformed_getInstance())) {
              this.w12j_1();
            }

            tmp_1.y12j_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.n9_1 = 3;
            suspendResult = this.z12j_1.dqm(ARGUMENT, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.y12j_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ModelMugScreen$slambda$slambda).b12k = function (effect, completion) {
    var i = new ModelMugScreen$slambda$slambda(this.s12j_1, this.t12j_1, this.u12j_1, this.v12j_1, this.w12j_1, completion);
    i.x12j_1 = effect;
    return i;
  };
  function ModelMugScreen$slambda$slambda_0($snackbarHostState, $onBack, $please_login_to_add_items_to_cart, $login, $onNavigateToAuth, resultContinuation) {
    var i = new ModelMugScreen$slambda$slambda($snackbarHostState, $onBack, $please_login_to_add_items_to_cart, $login, $onNavigateToAuth, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.a12k(effect, $completion);
    }, 1);
  }
  function ModelMugScreen$slambda_1($viewModel, $snackbarHostState, $onBack, $please_login_to_add_items_to_cart, $login, $onNavigateToAuth, resultContinuation) {
    this.k12k_1 = $viewModel;
    this.l12k_1 = $snackbarHostState;
    this.m12k_1 = $onBack;
    this.n12k_1 = $please_login_to_add_items_to_cart;
    this.o12k_1 = $login;
    this.p12k_1 = $onNavigateToAuth;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ModelMugScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ModelMugScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ModelMugScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.k12k_1.s10h().t10h();
            var tmp_1 = ModelMugScreen$slambda$slambda_0(this.l12k_1, this.m12k_1, this.n12k_1, this.o12k_1, this.p12k_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_15(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ModelMugScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new ModelMugScreen$slambda_1(this.k12k_1, this.l12k_1, this.m12k_1, this.n12k_1, this.o12k_1, this.p12k_1, completion);
    i.q12k_1 = $this$LaunchedEffect;
    return i;
  };
  function ModelMugScreen$slambda_2($viewModel, $snackbarHostState, $onBack, $please_login_to_add_items_to_cart, $login, $onNavigateToAuth, resultContinuation) {
    var i = new ModelMugScreen$slambda_1($viewModel, $snackbarHostState, $onBack, $please_login_to_add_items_to_cart, $login, $onNavigateToAuth, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function ModelMugScreen$lambda_1($name) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C77@3370L10:ModelMugScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2050361452, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ModelMugScreen.<anonymous>.<anonymous>.<anonymous> (ModelMugScreen.kt:77)');
        }
        var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text($name, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreen$lambda$lambda($back) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C80@3506L68:ModelMugScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1139573812, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ModelMugScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ModelMugScreen.kt:80)');
        }
        var tmp_0 = get_ArrowBack(Filled_instance_0);
        Icon(tmp_0, $back, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreen$lambda_2($onBack, $back) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C79@3476L124,79@3447L153:ModelMugScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1572772950, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ModelMugScreen.<anonymous>.<anonymous>.<anonymous> (ModelMugScreen.kt:79)');
        }
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1139573812, true, ModelMugScreen$lambda$lambda($back), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp$ret$0 = tmp_0;
        IconButton($onBack, null, false, null, null, null, tmp$ret$0, $composer_0, 1572864, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreen$lambda$lambda_0($onIntent) {
    return function () {
      $onIntent(AddToCart_instance);
      return Unit_instance;
    };
  }
  function ModelMugScreen$lambda_3($showAddToCart, $onIntent, $state$delegate) {
    return function ($this$TopAppBar, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:ModelMugScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1357162145, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ModelMugScreen.<anonymous>.<anonymous>.<anonymous> (ModelMugScreen.kt:84)');
        }
        if ($showAddToCart._v) {
          $composer_0.m30(-1604598677);
          sourceInformation($composer_0, '');
          if (ModelMugScreen$lambda($state$delegate).i12b_1) {
            $composer_0.m30(-1604555432);
            sourceInformation($composer_0, '86@3789L169');
            var tmp_0 = Companion_instance;
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
            var tmp_1 = size(tmp_0, tmp$ret$0);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
            var tmp_2 = padding_1(tmp_1, VOID, VOID, tmp$ret$1);
            var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp_4 = _Dp___init__impl__ms3zkb(2);
            var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_6 = _StrokeCap___init__impl__kfgr27(0);
            CircularProgressIndicator(tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, _Dp___init__impl__ms3zkb(0.0), $composer_0, 390, 58);
            $composer_0.n30();
          } else {
            $composer_0.m30(-1604315988);
            sourceInformation($composer_0, '90@4049L106,90@4028L245');
            sourceInformationMarkerStart($composer_0, -1437223893, 'CC(remember):ModelMugScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid = $composer_0.k31($onIntent);
            // Inline function 'kotlin.let' call
            var it = $composer_0.i31();
            var tmp_7;
            if (invalid || it === Companion_getInstance().f30_1) {
              var value = ModelMugScreen$lambda$lambda_0($onIntent);
              $composer_0.j31(value);
              tmp_7 = value;
            } else {
              tmp_7 = it;
            }
            var tmp0_group = tmp_7;
            sourceInformationMarkerEnd($composer_0);
            TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$ModelMugScreenKt_getInstance().q12i_1, $composer_0, 805306368, 510);
            $composer_0.n30();
          }
          $composer_0.n30();
        } else {
          $composer_0.m30(-1603993247);
          $composer_0.n30();
        }
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreen$lambda_4($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(it);
      return Unit_instance;
    };
  }
  function ModelMugScreen$lambda_5($onIntent) {
    return function () {
      $onIntent(RemoveCustomization_instance);
      return Unit_instance;
    };
  }
  function ModelMugScreen$lambda_6($onIntent) {
    return function () {
      $onIntent(OpenEditor_instance);
      return Unit_instance;
    };
  }
  function ModelMugScreen$lambda_7($onIntent) {
    return function () {
      $onIntent(OpenEditor_instance);
      return Unit_instance;
    };
  }
  function ModelMugScreen$lambda_8($onBack, $onNavigateToAuth, $productId, $product, $initialImageBytes, $initialLayers, $customImageUrl, $snackbarHostState, $showAddToCart, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      ModelMugScreen($onBack, $onNavigateToAuth, $productId._v, $product._v, $initialImageBytes._v, $initialLayers._v, $customImageUrl._v, $snackbarHostState._v, $showAddToCart._v, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_model3d_ModelMugViewModel$stable;
  function ModelMugViewModel$observeLanguage$slambda$slambda$lambda($language) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $language);
    };
  }
  function ModelMugViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation) {
    this.z12k_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ModelMugViewModel$observeLanguage$slambda$slambda).pyo = function (language, $completion) {
    var tmp = this.um9(language, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ModelMugViewModel$observeLanguage$slambda$slambda).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ModelMugViewModel$observeLanguage$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.z12k_1.x10k(ModelMugViewModel$observeLanguage$slambda$slambda$lambda(this.a12l_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ModelMugViewModel$observeLanguage$slambda$slambda).um9 = function (language, completion) {
    var i = new ModelMugViewModel$observeLanguage$slambda$slambda(this.z12k_1, completion);
    i.a12l_1 = language;
    return i;
  };
  function ModelMugViewModel$observeLanguage$slambda$slambda_0(this$0, resultContinuation) {
    var i = new ModelMugViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (language, $completion) {
      return i.pyo(language, $completion);
    }, 1);
  }
  function ModelMugViewModel$observeCurrentUser$slambda$slambda$lambda($this$updateState) {
    return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, false);
  }
  function ModelMugViewModel$observeCurrentUser$slambda$slambda(this$0, resultContinuation) {
    this.j12l_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ModelMugViewModel$observeCurrentUser$slambda$slambda).t10u = function (user, $completion) {
    var tmp = this.u10u(user, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ModelMugViewModel$observeCurrentUser$slambda$slambda).ja = function (p1, $completion) {
    return this.t10u((p1 == null ? true : p1 instanceof Profile) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ModelMugViewModel$observeCurrentUser$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (!(this.k12l_1 == null) && this.j12l_1.s10h().ajg().u1().b12c_1) {
              this.j12l_1.x10k(ModelMugViewModel$observeCurrentUser$slambda$slambda$lambda);
              this.n9_1 = 1;
              suspendResult = handleAddToCart(this.j12l_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ModelMugViewModel$observeCurrentUser$slambda$slambda).u10u = function (user, completion) {
    var i = new ModelMugViewModel$observeCurrentUser$slambda$slambda(this.j12l_1, completion);
    i.k12l_1 = user;
    return i;
  };
  function ModelMugViewModel$observeCurrentUser$slambda$slambda_0(this$0, resultContinuation) {
    var i = new ModelMugViewModel$observeCurrentUser$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (user, $completion) {
      return i.t10u(user, $completion);
    }, 1);
  }
  function ModelMugViewModel$handleAddToCart$slambda$slambda($hasCustomization, $state, $currentProduct, resultContinuation) {
    this.t12l_1 = $hasCustomization;
    this.u12l_1 = $state;
    this.v12l_1 = $currentProduct;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ModelMugViewModel$handleAddToCart$slambda$slambda).x12l = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ModelMugViewModel$handleAddToCart$slambda$slambda).ja = function (p1, $completion) {
    return this.x12l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ModelMugViewModel$handleAddToCart$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0;
          if (this.t12l_1) {
            var this_0 = this.u12l_1.h12b_1;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              var tmp0_id = item.z12f_1;
              var tmp1_imageBytes = item.i12g_1 == null ? toByteArray(resize(item.a12g_1, 1024)) : null;
              var this_1 = item.b12g_1;
              var value = _Offset___get_packedValue__impl__xh2k8q(this_1);
              var bits = convertToInt(shiftRight(value, 32));
              var tmp2_x = floatFromBits(bits);
              var this_2 = item.b12g_1;
              var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_2);
              var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
              var tmp3_y = floatFromBits(bits_0);
              var tmp4_scaleX = item.c12g_1;
              var tmp5_scaleY = item.d12g_1;
              var tmp6_rotation = item.e12g_1;
              var tmp7_filter = item.f12g_1.z_1;
              var tmp8_flipX = item.g12g_1;
              var tmp9_flipY = item.h12g_1;
              var tmp10_text = item.i12g_1;
              var tmp11_textColor = fromInt(toArgb(item.j12g_1));
              var tmp12_fontFamily = item.k12g_1;
              var tmp13_width = item.a12g_1.h5e();
              var tmp14_height = item.a12g_1.i5e();
              destination.j1(new DesignLayer(tmp0_id, '', tmp2_x, tmp3_y, tmp4_scaleX, tmp5_scaleY, tmp6_rotation, tmp7_filter, tmp8_flipX, tmp9_flipY, tmp10_text, tmp11_textColor, tmp12_fontFamily, tmp1_imageBytes, VOID, tmp13_width, tmp14_height));
            }
            tmp_0 = destination;
          } else {
            tmp_0 = this.v12l_1.fzu_1;
          }
          return tmp_0;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ModelMugViewModel$handleAddToCart$slambda$slambda).q24 = function ($this$withContext, completion) {
    var i = new ModelMugViewModel$handleAddToCart$slambda$slambda(this.t12l_1, this.u12l_1, this.v12l_1, completion);
    i.w12l_1 = $this$withContext;
    return i;
  };
  function ModelMugViewModel$handleAddToCart$slambda$slambda_0($hasCustomization, $state, $currentProduct, resultContinuation) {
    var i = new ModelMugViewModel$handleAddToCart$slambda$slambda($hasCustomization, $state, $currentProduct, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.x12l($this$withContext, $completion);
    }, 1);
  }
  function ModelMugViewModel$handleAddToCart$slambda$slambda_1($state, resultContinuation) {
    this.g12m_1 = $state;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ModelMugViewModel$handleAddToCart$slambda$slambda_1).i12m = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ModelMugViewModel$handleAddToCart$slambda$slambda_1).ja = function (p1, $completion) {
    return this.i12m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ModelMugViewModel$handleAddToCart$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0;
          if (!this.g12m_1.h12b_1.r()) {
            tmp_0 = createSimpleSnapshot(this.g12m_1.h12b_1);
          } else {
            tmp_0 = null;
          }
          return tmp_0;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ModelMugViewModel$handleAddToCart$slambda$slambda_1).q24 = function ($this$withContext, completion) {
    var i = new ModelMugViewModel$handleAddToCart$slambda$slambda_1(this.g12m_1, completion);
    i.h12m_1 = $this$withContext;
    return i;
  };
  function ModelMugViewModel$handleAddToCart$slambda$slambda_2($state, resultContinuation) {
    var i = new ModelMugViewModel$handleAddToCart$slambda$slambda_1($state, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.i12m($this$withContext, $completion);
    }, 1);
  }
  function ModelMugViewModel$handleAddToCart$slambda$lambda($this$updateState) {
    var tmp0_editorElements = emptyList();
    return $this$updateState.n12f(VOID, VOID, VOID, null, null, tmp0_editorElements, false, VOID, VOID, VOID, VOID, null, '', '', false, null);
  }
  function ModelMugViewModel$handleAddToCart$slambda$lambda_0($this$updateState) {
    return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, false);
  }
  function observeLanguage_5($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, ModelMugViewModel$observeLanguage$slambda_0($this, null));
  }
  function observeCurrentUser($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, ModelMugViewModel$observeCurrentUser$slambda_0($this, null));
  }
  function handleAddToCart($this, $completion) {
    var tmp = new $handleAddToCartCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function recompositeInitialDesign($this, elements) {
    var result = createSimpleSnapshot(elements);
    $this.x10k(ModelMugViewModel$recompositeInitialDesign$lambda(result));
  }
  function ModelMugViewModel$observeLanguage$slambda(this$0, resultContinuation) {
    this.e12n_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ModelMugViewModel$observeLanguage$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ModelMugViewModel$observeLanguage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ModelMugViewModel$observeLanguage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.e12n_1.o12n_1.y103();
            var action = ModelMugViewModel$observeLanguage$slambda$slambda_0(this.e12n_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ModelMugViewModel$observeLanguage$slambda).q24 = function ($this$launch, completion) {
    var i = new ModelMugViewModel$observeLanguage$slambda(this.e12n_1, completion);
    i.f12n_1 = $this$launch;
    return i;
  };
  function ModelMugViewModel$observeLanguage$slambda_0(this$0, resultContinuation) {
    var i = new ModelMugViewModel$observeLanguage$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ModelMugViewModel$observeCurrentUser$slambda(this$0, resultContinuation) {
    this.a12o_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ModelMugViewModel$observeCurrentUser$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ModelMugViewModel$observeCurrentUser$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ModelMugViewModel$observeCurrentUser$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.a12o_1.r12n_1.oyv();
            var action = ModelMugViewModel$observeCurrentUser$slambda$slambda_0(this.a12o_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ModelMugViewModel$observeCurrentUser$slambda).q24 = function ($this$launch, completion) {
    var i = new ModelMugViewModel$observeCurrentUser$slambda(this.a12o_1, completion);
    i.b12o_1 = $this$launch;
    return i;
  };
  function ModelMugViewModel$observeCurrentUser$slambda_0(this$0, resultContinuation) {
    var i = new ModelMugViewModel$observeCurrentUser$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ModelMugViewModel$handleIntent$lambda($intent, $initialProduct) {
    return function ($this$updateState) {
      var tmp7_initialLayers = $intent.q12h_1;
      var tmp8_initialCustomImageUrl = $intent.r12h_1;
      var tmp9_pickedImageBytes = $intent.t12h_1;
      var tmp0_safe_receiver = $intent.t12h_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = decodeToImageBitmap(tmp0_safe_receiver);
      }
      var tmp10_imageBitmap = tmp;
      var tmp11_editorElements = emptyList();
      var tmp12_selectedSize = $intent.u12h_1;
      var tmp13_selectedColor = $intent.v12h_1;
      var tmp1_elvis_lhs = $intent.w12h_1;
      var tmp14_selectedOptions = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = $intent.x12h_1;
      var tmp15_productComment = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
      var tmp16_selectedCard = $intent.y12h_1;
      var tmp17_selectedBox = $intent.z12h_1;
      var tmp3_elvis_lhs = $intent.a12i_1;
      var tmp18_cardMessage = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      var tmp4_elvis_lhs = $intent.b12i_1;
      var tmp19_cardBirthday = tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = $intent.c12i_1;
      var tmp20_boxMessage = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
      var tmp6_elvis_lhs = $intent.d12i_1;
      var tmp21_boxBirthday = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
      var tmp22_availableCards = emptyList();
      var tmp23_availableBoxes = emptyList();
      return $this$updateState.n12f(true, null, $initialProduct, tmp9_pickedImageBytes, tmp10_imageBitmap, tmp11_editorElements, VOID, VOID, VOID, tmp7_initialLayers, tmp8_initialCustomImageUrl, tmp16_selectedCard, tmp18_cardMessage, tmp19_cardBirthday, VOID, tmp17_selectedBox, tmp20_boxMessage, tmp21_boxBirthday, VOID, tmp12_selectedSize, tmp13_selectedColor, tmp14_selectedOptions, tmp15_productComment, tmp22_availableCards, tmp23_availableBoxes);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_0($this$updateState) {
    return $this$updateState.n12f(false, new ResourceString(get_no_internet_custom_mug(string_instance), []));
  }
  function ModelMugViewModel$handleIntent$lambda_1($activeProduct, $cards, $boxes) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, $activeProduct, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $cards, $boxes);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_2($hasImageElements, $mainImage, $finalProduct, $restoredElements) {
    return function ($this$updateState) {
      var tmp;
      if ($hasImageElements) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs = $mainImage;
        tmp = tmp0_elvis_lhs == null ? $this$updateState.g12b_1 : tmp0_elvis_lhs;
      }
      var tmp1_imageBitmap = tmp;
      return $this$updateState.n12f(false, VOID, $finalProduct, VOID, tmp1_imageBitmap, $restoredElements, VOID, false);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_3($this$updateState) {
    return $this$updateState.n12f(false, new ResourceString(get_failed_load_product(string_instance), []));
  }
  function ModelMugViewModel$handleIntent$lambda_4($intent) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, $intent.p12g_1);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_5($intent) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, VOID, $intent.c12o_1, decodeToImageBitmap($intent.c12o_1), VOID, VOID, true);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_6($intent) {
    return function ($this$updateState) {
      var tmp0_imageBitmap = $intent.m12g_1;
      var tmp1_pickedImageBytes = $intent.n12g_1;
      var tmp2_editorElements = $intent.o12g_1;
      return $this$updateState.n12f(VOID, VOID, VOID, tmp1_pickedImageBytes, tmp0_imageBitmap, tmp2_editorElements, VOID, false);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_7($this$updateState) {
    return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function ModelMugViewModel$handleIntent$lambda_8($this$updateState) {
    return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, false);
  }
  function ModelMugViewModel$handleIntent$lambda_9($intent) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.e12i_1);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_10($intent) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.f12i_1);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_11($intent) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.g12i_1, false);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_12($intent) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.h12i_1);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_13($intent) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.i12i_1);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_14($intent) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.j12i_1, false);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_15($intent) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.k12i_1);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_16($intent) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.l12i_1);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_17(this$0, $intent) {
    return function ($this$updateState) {
      var currentOptions = toMutableMap(this$0.s10h().ajg().u1().x12b_1);
      if ($intent.n12i_1 == null) {
        currentOptions.a3($intent.m12i_1);
      } else {
        var valueWithGroup = $intent.n12i_1;
        // Inline function 'kotlin.collections.set' call
        var key = $intent.m12i_1;
        currentOptions.z2(key, valueWithGroup);
      }
      return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, currentOptions);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_18($intent) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.o12i_1);
    };
  }
  function ModelMugViewModel$handleIntent$lambda_19($this$updateState) {
    return $this$updateState.n12f(VOID, VOID, VOID, null, null, emptyList());
  }
  function ModelMugViewModel$handleAddToCart$lambda($this$updateState) {
    return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function ModelMugViewModel$handleAddToCart$lambda_0($this$updateState) {
    return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function ModelMugViewModel$handleAddToCart$lambda_1($this$updateState) {
    return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function ModelMugViewModel$handleAddToCart$lambda_2($this$updateState) {
    return $this$updateState.n12f(VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function ModelMugViewModel$handleAddToCart$slambda($currentUser, $state, $currentProduct, this$0, resultContinuation) {
    this.l12o_1 = $currentUser;
    this.m12o_1 = $state;
    this.n12o_1 = $currentProduct;
    this.o12o_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ModelMugViewModel$handleAddToCart$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ModelMugViewModel$handleAddToCart$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ModelMugViewModel$handleAddToCart$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            this.o9_1 = 9;
            this.r12o_1 = this.l12o_1.uym_1;
            var tmp_0 = this;
            var tmp_1;
            if (!(this.m12o_1.f12b_1 == null)) {
              tmp_1 = true;
            } else {
              tmp_1 = !this.m12o_1.h12b_1.r();
            }

            tmp_0.x12o_1 = tmp_1;
            this.n9_1 = 1;
            var tmp_2 = Dispatchers_getInstance().i1h_1;
            suspendResult = withContext(tmp_2, ModelMugViewModel$handleAddToCart$slambda$slambda_0(this.x12o_1, this.m12o_1, this.n12o_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.s12o_1 = suspendResult;
            var tmp_3 = this;
            var tmp_4;
            if (this.x12o_1) {
              var tmp0_elvis_lhs = this.n12o_1.bzu_1;
              tmp_4 = tmp0_elvis_lhs == null ? ProductKind_MUG_getInstance() : tmp0_elvis_lhs;
            } else {
              var tmp1_elvis_lhs = this.n12o_1.bzu_1;
              tmp_4 = tmp1_elvis_lhs == null ? ProductKind_NORMAL_getInstance() : tmp1_elvis_lhs;
            }

            tmp_3.q12o_1 = tmp_4;
            this.n9_1 = 2;
            var tmp_5 = Dispatchers_getInstance().i1h_1;
            suspendResult = withContext(tmp_5, ModelMugViewModel$handleAddToCart$slambda$slambda_2(this.m12o_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.u12o_1 = suspendResult;
            var tmp_6 = this;
            var tmp2_safe_receiver = this.u12o_1;
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toByteArray(tmp2_safe_receiver);
            tmp_6.t12o_1 = tmp3_elvis_lhs == null ? this.m12o_1.f12b_1 : tmp3_elvis_lhs;
            if (!(this.t12o_1 == null) && this.o12o_1.p12n_1.fz1().u1()) {
              this.o9_1 = 4;
              var fileName = 'custom_designs/' + this.r12o_1 + '/design_' + randomUUID() + '.png';
              this.n9_1 = 3;
              suspendResult = this.o12o_1.m12n_1.k105(this.t12o_1, fileName, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_7 = this;
              tmp_7.v12o_1 = null;
              this.n9_1 = 6;
              continue $sm;
            }

          case 3:
            this.w12o_1 = suspendResult;
            this.o9_1 = 9;
            this.n9_1 = 5;
            continue $sm;
          case 4:
            this.o9_1 = 9;
            var tmp_8 = this.q9_1;
            if (tmp_8 instanceof Exception) {
              var e = this.q9_1;
              var tmp_9 = this;
              tmp_9.w12o_1 = null;
              this.n9_1 = 5;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 5:
            this.o9_1 = 9;
            this.v12o_1 = this.w12o_1;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var customImageUrl = this.v12o_1;
            var tmp_10;
            if (customImageUrl == null) {
              var tmp4_safe_receiver = this.u12o_1;
              var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : resize(tmp4_safe_receiver, 512);
              var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : toJpegByteArray(tmp5_safe_receiver, 80);
              tmp_10 = tmp6_elvis_lhs == null ? this.t12o_1 : tmp6_elvis_lhs;
            } else {
              tmp_10 = null;
            }

            var localSnapshotBytes = tmp_10;
            var tmp7_safe_receiver = this.m12o_1.n12b_1;
            var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.lyz_1;
            var tmp_11 = tmp8_elvis_lhs == null ? 0.0 : tmp8_elvis_lhs;
            var tmp9_safe_receiver = this.m12o_1.r12b_1;
            var tmp10_elvis_lhs = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.wyz_1;
            var tmp_12 = tmp_11 + (tmp10_elvis_lhs == null ? 0.0 : tmp10_elvis_lhs);
            var sum = 0;
            var _iterator__ex2g4s = this.m12o_1.x12b_1.y2().t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              var tmp_13 = sum;
              var tmp0_elvis_lhs_0 = element.q100_1;
              sum = tmp_13 + (tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0);
            }

            var extraPrice = tmp_12 + sum;
            var tmp11_elvis_lhs = this.n12o_1.szt_1;
            var finalPrice = (tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs) + extraPrice;
            var tmp_14;
            var tmp13_elvis_lhs = this.n12o_1.tzt_1;
            if ((tmp13_elvis_lhs == null ? 0.0 : tmp13_elvis_lhs) > 0.0) {
              var tmp12_elvis_lhs = this.n12o_1.tzt_1;
              tmp_14 = (tmp12_elvis_lhs == null ? 0.0 : tmp12_elvis_lhs) + extraPrice;
            } else {
              tmp_14 = 0.0;
            }

            var finalDiscount = tmp_14;
            this.n9_1 = 7;
            var tmp21_productId = this.n12o_1.nzt_1;
            var tmp22_nameArabic = this.n12o_1.pzt_1;
            var tmp23_nameEnglish = this.n12o_1.ozt_1;
            var tmp24_descriptionEnglish = this.n12o_1.qzt_1;
            var tmp25_descriptionArabic = this.n12o_1.rzt_1;
            var tmp14_elvis_lhs = this.n12o_1.uzt_1;
            var tmp26_discountPercent = tmp14_elvis_lhs == null ? 0.0 : tmp14_elvis_lhs;
            var tmp27_rating = this.n12o_1.vzt_1;
            var tmp28_stock = this.n12o_1.wzt_1;
            var tmp29_imageUrl = this.n12o_1.xzt_1;
            var tmp30_videoUrl = this.n12o_1.yzt_1;
            var tmp31_createdAt = this.n12o_1.zzt_1;
            var tmp32_category = toString_0(this.n12o_1.czu_1);
            var tmp15_elvis_lhs = this.n12o_1.dzu_1;
            var tmp33_categoryNameEnglish = tmp15_elvis_lhs == null ? '' : tmp15_elvis_lhs;
            var tmp16_elvis_lhs = this.n12o_1.ezu_1;
            var tmp34_categoryNameArabic = tmp16_elvis_lhs == null ? '' : tmp16_elvis_lhs;
            var tmp35_selectedCard = this.m12o_1.n12b_1;
            var tmp_15;
            var tmp17_safe_receiver = this.m12o_1.n12b_1;
            if ((tmp17_safe_receiver == null ? null : tmp17_safe_receiver.oyz_1) === true) {
              tmp_15 = this.m12o_1.o12b_1;
            } else {
              tmp_15 = null;
            }

            var tmp36_cardMessage = tmp_15;
            var tmp_16;
            var tmp18_safe_receiver = this.m12o_1.n12b_1;
            if ((tmp18_safe_receiver == null ? null : tmp18_safe_receiver.pyz_1) === true) {
              tmp_16 = this.m12o_1.p12b_1;
            } else {
              tmp_16 = null;
            }

            var tmp37_cardBirthday = tmp_16;
            var tmp38_selectedBox = this.m12o_1.r12b_1;
            var tmp_17;
            var tmp19_safe_receiver = this.m12o_1.r12b_1;
            if ((tmp19_safe_receiver == null ? null : tmp19_safe_receiver.zyz_1) === true) {
              tmp_17 = this.m12o_1.s12b_1;
            } else {
              tmp_17 = null;
            }

            var tmp39_boxMessage = tmp_17;
            var tmp_18;
            var tmp20_safe_receiver = this.m12o_1.r12b_1;
            if ((tmp20_safe_receiver == null ? null : tmp20_safe_receiver.az0_1) === true) {
              tmp_18 = this.m12o_1.t12b_1;
            } else {
              tmp_18 = null;
            }

            var tmp40_boxBirthday = tmp_18;
            var tmp41_selectedSize = this.m12o_1.v12b_1;
            var tmp42_selectedColor = this.m12o_1.w12b_1;
            var this_0 = this.m12o_1.x12b_1;
            var tmp_19;
            if (this_0.r()) {
              tmp_19 = null;
            } else {
              tmp_19 = this_0;
            }

            var tmp43_selectedOptions = tmp_19;
            var this_1 = this.m12o_1.y12b_1;
            var tmp_20;
            if (!isBlank(this_1)) {
              tmp_20 = this_1;
            } else {
              tmp_20 = null;
            }

            var tmp44_productComment = tmp_20;
            suspendResult = this.o12o_1.k12n_1.c103(new CartItem(VOID, tmp21_productId, tmp23_nameEnglish, tmp22_nameArabic, tmp24_descriptionEnglish, tmp25_descriptionArabic, finalPrice, finalDiscount, tmp26_discountPercent, tmp27_rating, tmp28_stock, tmp29_imageUrl, 1, customImageUrl, this.s12o_1, this.r12o_1, tmp31_createdAt, tmp30_videoUrl, localSnapshotBytes, this.q12o_1, tmp32_category, tmp33_categoryNameEnglish, tmp34_categoryNameArabic, VOID, tmp35_selectedCard, tmp36_cardMessage, tmp37_cardBirthday, tmp38_selectedBox, tmp39_boxMessage, tmp40_boxBirthday, tmp41_selectedSize, tmp42_selectedColor, tmp43_selectedOptions, tmp44_productComment), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.o12o_1.x10k(ModelMugViewModel$handleAddToCart$slambda$lambda);
            this.n9_1 = 8;
            suspendResult = this.o12o_1.d10l(new ShowMessage_1(new ResourceString(get_added_to_cart(string_instance), [])), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.o9_1 = 12;
            this.n9_1 = 11;
            continue $sm;
          case 9:
            this.o9_1 = 12;
            var tmp_21 = this.q9_1;
            if (tmp_21 instanceof Exception) {
              var e_0 = this.q9_1;
              this.o12o_1.x10k(ModelMugViewModel$handleAddToCart$slambda$lambda_0);
              var tmp45_safe_receiver = e_0.message;
              var tmp46_elvis_lhs = tmp45_safe_receiver == null ? null : take(tmp45_safe_receiver, 200);
              var msg = tmp46_elvis_lhs == null ? '' : tmp46_elvis_lhs;
              this.n9_1 = 10;
              suspendResult = this.o12o_1.d10l(new ShowMessage_1(new ResourceString(get_failed_add_to_cart(string_instance), [msg])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 10:
            this.n9_1 = 11;
            continue $sm;
          case 11:
            this.o9_1 = 12;
            return Unit_instance;
          case 12:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 12) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(ModelMugViewModel$handleAddToCart$slambda).q24 = function ($this$launch, completion) {
    var i = new ModelMugViewModel$handleAddToCart$slambda(this.l12o_1, this.m12o_1, this.n12o_1, this.o12o_1, completion);
    i.p12o_1 = $this$launch;
    return i;
  };
  function ModelMugViewModel$handleAddToCart$slambda_0($currentUser, $state, $currentProduct, this$0, resultContinuation) {
    var i = new ModelMugViewModel$handleAddToCart$slambda($currentUser, $state, $currentProduct, this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ModelMugViewModel$recompositeInitialDesign$lambda($result) {
    return function ($this$updateState) {
      return $this$updateState.n12f(VOID, VOID, VOID, VOID, $result);
    };
  }
  function ModelMugViewModel$onCleared$lambda($this$updateState) {
    var tmp0_editorElements = emptyList();
    return $this$updateState.n12f(VOID, VOID, null, null, null, tmp0_editorElements);
  }
  function $handleIntentCOROUTINE$_9(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g12p_1 = _this__u8e3s4;
    this.h12p_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_9).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 22;
            var tmp0_subject = this.h12p_1;
            if (tmp0_subject instanceof LoadProduct) {
              if (this.g12p_1.s10h().ajg().u1().i12b_1)
                return Unit_instance;
              var currentProduct = this.g12p_1.s10h().ajg().u1().e12b_1;
              var tmp_0 = this;
              var tmp1_elvis_lhs = this.h12p_1.p12h_1;
              var tmp_1;
              if (tmp1_elvis_lhs == null) {
                var tmp2_safe_receiver = this.h12p_1.s12h_1;
                var tmp_2;
                if (tmp2_safe_receiver == null) {
                  tmp_2 = null;
                } else {
                  var tmp_3;
                  if (currentProduct == null) {
                    tmp_3 = null;
                  } else {
                    var tmp1_elvis_lhs_0 = this.h12p_1.o12h_1;
                    var tmp_4 = tmp1_elvis_lhs_0 == null ? currentProduct.nzt_1 : tmp1_elvis_lhs_0;
                    var tmp2_elvis_lhs = this.h12p_1.q12h_1;
                    var tmp_5 = tmp2_elvis_lhs == null ? currentProduct.fzu_1 : tmp2_elvis_lhs;
                    var tmp3_elvis_lhs = this.h12p_1.r12h_1;
                    tmp_3 = currentProduct.i100(tmp_4, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_safe_receiver, VOID, VOID, VOID, tmp_5, tmp3_elvis_lhs == null ? currentProduct.gzu_1 : tmp3_elvis_lhs);
                  }
                  var tmp4_elvis_lhs = tmp_3;
                  var tmp_6;
                  if (tmp4_elvis_lhs == null) {
                    var tmp5_elvis_lhs = this.h12p_1.o12h_1;
                    tmp_6 = new Product(tmp5_elvis_lhs == null ? new Long(0, 0) : tmp5_elvis_lhs, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_safe_receiver, VOID, VOID, VOID, this.h12p_1.q12h_1, this.h12p_1.r12h_1);
                  } else {
                    tmp_6 = tmp4_elvis_lhs;
                  }
                  tmp_2 = tmp_6;
                }
                tmp_1 = tmp_2;
              } else {
                tmp_1 = tmp1_elvis_lhs;
              }
              var tmp3_elvis_lhs_0 = tmp_1;
              tmp_0.w12p_1 = tmp3_elvis_lhs_0 == null ? currentProduct : tmp3_elvis_lhs_0;
              this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda(this.h12p_1, this.w12p_1));
              this.o9_1 = 19;
              var tmp_7;
              if (!(this.h12p_1.t12h_1 == null)) {
                tmp_7 = true;
              } else {
                var tmp4_safe_receiver = this.h12p_1.q12h_1;
                var tmp_8;
                if (tmp4_safe_receiver == null) {
                  tmp_8 = null;
                } else {
                  var tmp$ret$0;
                  l$ret$1: do {
                    var tmp_9;
                    if (isInterface(tmp4_safe_receiver, Collection)) {
                      tmp_9 = tmp4_safe_receiver.r();
                    } else {
                      tmp_9 = false;
                    }
                    if (tmp_9) {
                      tmp$ret$0 = false;
                      break l$ret$1;
                    }
                    var _iterator__ex2g4s = tmp4_safe_receiver.t();
                    while (_iterator__ex2g4s.u()) {
                      var element = _iterator__ex2g4s.v();
                      if (!(element.eyy_1 == null)) {
                        tmp$ret$0 = true;
                        break l$ret$1;
                      }
                    }
                    tmp$ret$0 = false;
                  }
                   while (false);
                  tmp_8 = tmp$ret$0;
                }
                tmp_7 = tmp_8 === true;
              }
              var hasLocalData = tmp_7;
              if (!this.g12p_1.p12n_1.fz1().u1() && !hasLocalData && (!(this.h12p_1.q12h_1 == null) || !(this.h12p_1.r12h_1 == null))) {
                this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_0);
                return Unit_instance;
              }
              this.n9_1 = 2;
              var tmp5_elvis_lhs_0 = this.h12p_1.o12h_1;
              suspendResult = this.g12p_1.q12n_1.yzi(tmp5_elvis_lhs_0 == null ? new Long(0, 0) : tmp5_elvis_lhs_0, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof UpdateElements) {
                if (this.g12p_1.s10h().ajg().u1().i12b_1)
                  return Unit_instance;
                this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_4(this.h12p_1));
                recompositeInitialDesign(this.g12p_1, this.h12p_1.p12g_1);
                this.n9_1 = 21;
                continue $sm;
              } else {
                if (tmp0_subject instanceof ImagePicked) {
                  this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_5(this.h12p_1));
                  this.n9_1 = 21;
                  continue $sm;
                } else {
                  if (tmp0_subject instanceof CustomImageApplied) {
                    this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_6(this.h12p_1));
                    this.n9_1 = 21;
                    continue $sm;
                  } else {
                    if (equals(tmp0_subject, OpenEditor_instance)) {
                      this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_7);
                      this.n9_1 = 21;
                      continue $sm;
                    } else {
                      if (equals(tmp0_subject, CloseEditor_instance)) {
                        this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_8);
                        this.n9_1 = 21;
                        continue $sm;
                      } else {
                        if (tmp0_subject instanceof CardSelected) {
                          this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_9(this.h12p_1));
                          this.n9_1 = 21;
                          continue $sm;
                        } else {
                          if (tmp0_subject instanceof CardMessageChanged) {
                            this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_10(this.h12p_1));
                            this.n9_1 = 21;
                            continue $sm;
                          } else {
                            if (tmp0_subject instanceof CardBirthdayChanged) {
                              this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_11(this.h12p_1));
                              this.n9_1 = 21;
                              continue $sm;
                            } else {
                              if (tmp0_subject instanceof BoxSelected) {
                                this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_12(this.h12p_1));
                                this.n9_1 = 21;
                                continue $sm;
                              } else {
                                if (tmp0_subject instanceof BoxMessageChanged) {
                                  this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_13(this.h12p_1));
                                  this.n9_1 = 21;
                                  continue $sm;
                                } else {
                                  if (tmp0_subject instanceof BoxBirthdayChanged) {
                                    this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_14(this.h12p_1));
                                    this.n9_1 = 21;
                                    continue $sm;
                                  } else {
                                    if (tmp0_subject instanceof SizeSelected) {
                                      this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_15(this.h12p_1));
                                      this.n9_1 = 21;
                                      continue $sm;
                                    } else {
                                      if (tmp0_subject instanceof ColorSelected) {
                                        this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_16(this.h12p_1));
                                        this.n9_1 = 21;
                                        continue $sm;
                                      } else {
                                        if (tmp0_subject instanceof OptionSelected) {
                                          this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_17(this.g12p_1, this.h12p_1));
                                          this.n9_1 = 21;
                                          continue $sm;
                                        } else {
                                          if (tmp0_subject instanceof ProductCommentChanged) {
                                            this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_18(this.h12p_1));
                                            this.n9_1 = 21;
                                            continue $sm;
                                          } else {
                                            if (equals(tmp0_subject, AddToCart_instance)) {
                                              if (this.g12p_1.s10h().ajg().u1().i12b_1)
                                                return Unit_instance;
                                              this.n9_1 = 1;
                                              suspendResult = handleAddToCart(this.g12p_1, this);
                                              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                                                return suspendResult;
                                              }
                                              continue $sm;
                                            } else {
                                              if (equals(tmp0_subject, RemoveCustomization_instance)) {
                                                this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_19);
                                                this.n9_1 = 21;
                                                continue $sm;
                                              } else {
                                                noWhenBranchMatchedException();
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            break;
          case 1:
            this.n9_1 = 21;
            continue $sm;
          case 2:
            var fullProduct = suspendResult;
            var tmp_10 = this;
            tmp_10.j12p_1 = fullProduct == null ? this.w12p_1 : fullProduct;
            if (!(this.j12p_1 == null)) {
              var tmp_11;
              var this_0 = this.j12p_1.jzu_1;
              if (!(this_0 == null || this_0.r())) {
                tmp_11 = true;
              } else {
                var this_1 = this.j12p_1.kzu_1;
                tmp_11 = !(this_1 == null || this_1.r());
              }
              if (tmp_11) {
                var this_2 = this.j12p_1.jzu_1;
                if (!(this_2 == null || this_2.r())) {
                  this.n9_1 = 3;
                  suspendResult = this.g12p_1.q12n_1.xzk(this.j12p_1.jzu_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.v12p_1 = emptyList();
                  this.n9_1 = 4;
                  continue $sm;
                }
              } else {
                this.n9_1 = 7;
                continue $sm;
              }
            } else {
              this.n9_1 = 8;
              continue $sm;
            }

          case 3:
            var tmp_12 = this;
            var tmp0 = suspendResult;
            var destination = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s_0 = tmp0.t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              if (!element_0.nyz_1) {
                destination.j1(element_0);
              }
            }

            tmp_12.v12p_1 = destination;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.t12p_1 = this.v12p_1;
            var this_3 = this.j12p_1.kzu_1;
            if (!(this_3 == null || this_3.r())) {
              this.n9_1 = 5;
              suspendResult = this.g12p_1.q12n_1.yzk(this.j12p_1.kzu_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.u12p_1 = emptyList();
              this.n9_1 = 6;
              continue $sm;
            }

          case 5:
            var tmp_13 = this;
            var tmp0_0 = suspendResult;
            var destination_0 = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s_1 = tmp0_0.t();
            while (_iterator__ex2g4s_1.u()) {
              var element_1 = _iterator__ex2g4s_1.v();
              if (!element_1.yyz_1) {
                destination_0.j1(element_1);
              }
            }

            tmp_13.u12p_1 = destination_0;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var boxes = this.u12p_1;
            this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_1(this.j12p_1, this.t12p_1, boxes));
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.n9_1 = 8;
            continue $sm;
          case 8:
            var tmp7_elvis_lhs = this.h12p_1.r12h_1;
            var tmp_14;
            if (tmp7_elvis_lhs == null) {
              var tmp8_safe_receiver = this.j12p_1;
              tmp_14 = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.gzu_1;
            } else {
              tmp_14 = tmp7_elvis_lhs;
            }

            var tmp9_safe_receiver = tmp_14;
            var tmp_15;
            if (tmp9_safe_receiver == null) {
              tmp_15 = null;
            } else {
              var tmp_16;
              if (!isBlank(tmp9_safe_receiver)) {
                tmp_16 = tmp9_safe_receiver;
              } else {
                tmp_16 = null;
              }
              tmp_15 = tmp_16;
            }

            var effectiveImageUrl = tmp_15;
            if (effectiveImageUrl == null) {
              this.r12p_1 = null;
              this.n9_1 = 11;
              continue $sm;
            } else {
              if (this.g12p_1.p12n_1.fz1().u1()) {
                this.n9_1 = 9;
                suspendResult = this.g12p_1.l12n_1.h106(effectiveImageUrl, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_17 = this;
                tmp_17.s12p_1 = null;
                this.n9_1 = 10;
                continue $sm;
              }
            }

          case 9:
            var tmp0_safe_receiver = suspendResult;
            var tmp_18 = this;
            var tmp_19;
            if (tmp0_safe_receiver == null) {
              tmp_19 = null;
            } else {
              tmp_19 = decodeToImageBitmap(tmp0_safe_receiver);
            }

            tmp_18.s12p_1 = tmp_19;
            this.n9_1 = 10;
            continue $sm;
          case 10:
            this.r12p_1 = this.s12p_1;
            this.n9_1 = 11;
            continue $sm;
          case 11:
            this.i12p_1 = this.r12p_1;
            var tmp11_safe_receiver = this.h12p_1.q12h_1;
            if (tmp11_safe_receiver == null) {
              this.k12p_1 = null;
              this.n9_1 = 18;
              continue $sm;
            } else {
              this.l12p_1 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp11_safe_receiver, 10));
              this.q12p_1 = tmp11_safe_receiver.t();
              this.n9_1 = 12;
              continue $sm;
            }

          case 12:
            if (!this.q12p_1.u()) {
              this.n9_1 = 17;
              continue $sm;
            }

            var item = this.q12p_1.v();
            this.m12p_1 = item;
            if (this.m12p_1.byy_1 == null) {
              var tmp0_safe_receiver_0 = this.m12p_1.eyy_1;
              var tmp_20;
              if (tmp0_safe_receiver_0 == null) {
                tmp_20 = null;
              } else {
                tmp_20 = decodeToImageBitmap(tmp0_safe_receiver_0);
              }
              var tmp1_elvis_lhs_1 = tmp_20;
              if (tmp1_elvis_lhs_1 == null) {
                var tmp_21;
                var this_4 = this.m12p_1.syx_1;
                if (charSequenceLength(this_4) > 0) {
                  tmp_21 = this.g12p_1.p12n_1.fz1().u1();
                } else {
                  tmp_21 = false;
                }
                if (tmp_21) {
                  this.n9_1 = 13;
                  suspendResult = this.g12p_1.l12n_1.h106(this.m12p_1.syx_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.p12p_1 = null;
                  this.n9_1 = 14;
                  continue $sm;
                }
              } else {
                this.o12p_1 = tmp1_elvis_lhs_1;
                this.n9_1 = 15;
                continue $sm;
              }
            } else {
              var tmp_22 = this;
              tmp_22.n12p_1 = null;
              this.n9_1 = 16;
              continue $sm;
            }

          case 13:
            var tmp2_safe_receiver_0 = suspendResult;
            var tmp_23 = this;
            var tmp_24;
            if (tmp2_safe_receiver_0 == null) {
              tmp_24 = null;
            } else {
              tmp_24 = decodeToImageBitmap(tmp2_safe_receiver_0);
            }

            tmp_23.p12p_1 = tmp_24;
            this.n9_1 = 14;
            continue $sm;
          case 14:
            this.o12p_1 = this.p12p_1;
            this.n9_1 = 15;
            continue $sm;
          case 15:
            this.n12p_1 = this.o12p_1;
            this.n9_1 = 16;
            continue $sm;
          case 16:
            var tmp3_elvis_lhs_1 = this.n12p_1;
            var bitmap = tmp3_elvis_lhs_1 == null ? ImageBitmap(coerceAtLeast(this.m12p_1.gyy_1, 1), coerceAtLeast(this.m12p_1.hyy_1, 1)) : tmp3_elvis_lhs_1;
            var tmp0_1 = this.m12p_1.tyx_1;
            var val2 = this.m12p_1.uyx_1;
            var v1 = fromInt(toRawBits(tmp0_1));
            var v2 = fromInt(toRawBits(val2));
            var tmp_25 = _Offset___init__impl__c168vi(bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0))));
            var tmp0_2 = get_entries_0();
            var tmp$ret$2 = Unit_instance;
            l$ret$3: do {
              var _iterator__ex2g4s_2 = tmp0_2.t();
              while (_iterator__ex2g4s_2.u()) {
                var element_2 = _iterator__ex2g4s_2.v();
                if (element_2.z_1 === this.m12p_1.yyx_1) {
                  tmp$ret$2 = element_2;
                  break l$ret$3;
                }
              }
              tmp$ret$2 = null;
            }
             while (false);
            var tmp4_elvis_lhs_0 = tmp$ret$2;
            var tmp_26 = tmp4_elvis_lhs_0 == null ? FilterType_None_getInstance() : tmp4_elvis_lhs_0;
            var tmp5_elvis_lhs_1 = this.m12p_1.cyy_1;
            var this_5 = tmp5_elvis_lhs_1 == null ? new Long(-16777216, 0) : tmp5_elvis_lhs_1;
            var tmp_27 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(this_5));
            var tmp6_elvis_lhs = this.m12p_1.dyy_1;
            var ARGUMENT = new EditorImageElement(this.m12p_1.ryx_1, bitmap, tmp_25, this.m12p_1.vyx_1, this.m12p_1.wyx_1, this.m12p_1.xyx_1, tmp_26, this.m12p_1.zyx_1, this.m12p_1.ayy_1, this.m12p_1.byy_1, tmp_27, tmp6_elvis_lhs == null ? 'Default' : tmp6_elvis_lhs, !(this.m12p_1.byy_1 == null));
            this.l12p_1.j1(ARGUMENT);
            this.n9_1 = 12;
            continue $sm;
          case 17:
            this.k12p_1 = this.l12p_1;
            this.n9_1 = 18;
            continue $sm;
          case 18:
            var tmp12_elvis_lhs = this.k12p_1;
            var restoredElements = tmp12_elvis_lhs == null ? emptyList() : tmp12_elvis_lhs;
            var tmp$ret$4;
            l$ret$5: do {
              var tmp_28;
              if (isInterface(restoredElements, Collection)) {
                tmp_28 = restoredElements.r();
              } else {
                tmp_28 = false;
              }
              if (tmp_28) {
                tmp$ret$4 = false;
                break l$ret$5;
              }
              var _iterator__ex2g4s_3 = restoredElements.t();
              while (_iterator__ex2g4s_3.u()) {
                var element_3 = _iterator__ex2g4s_3.v();
                if (element_3.i12g_1 == null && !element_3.l12g_1) {
                  tmp$ret$4 = true;
                  break l$ret$5;
                }
              }
              tmp$ret$4 = false;
            }
             while (false);
            var hasImageElements = tmp$ret$4;
            var currentProductInState = this.g12p_1.s10h().ajg().u1().e12b_1;
            var tmp13_safe_receiver = this.j12p_1;
            var tmp_29;
            if (tmp13_safe_receiver == null) {
              tmp_29 = null;
            } else {
              var tmp14_elvis_lhs = this.h12p_1.s12h_1;
              var tmp15_elvis_lhs = tmp14_elvis_lhs == null ? this.j12p_1.bzu_1 : tmp14_elvis_lhs;
              var tmp_30;
              if (tmp15_elvis_lhs == null) {
                tmp_30 = currentProductInState == null ? null : currentProductInState.bzu_1;
              } else {
                tmp_30 = tmp15_elvis_lhs;
              }
              tmp_29 = tmp13_safe_receiver.i100(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_30);
            }

            var finalProduct = tmp_29;
            this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_2(hasImageElements, this.i12p_1, finalProduct, restoredElements));
            var tmp_31;
            if (!restoredElements.r()) {
              tmp_31 = hasImageElements || (this.i12p_1 == null && this.g12p_1.s10h().ajg().u1().g12b_1 == null);
            } else {
              tmp_31 = false;
            }

            if (tmp_31) {
              recompositeInitialDesign(this.g12p_1, restoredElements);
            }

            this.o9_1 = 22;
            this.n9_1 = 20;
            continue $sm;
          case 19:
            this.o9_1 = 22;
            var tmp_32 = this.q9_1;
            if (tmp_32 instanceof Exception) {
              var e = this.q9_1;
              this.g12p_1.x10k(ModelMugViewModel$handleIntent$lambda_3);
              this.n9_1 = 20;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 20:
            this.o9_1 = 22;
            this.n9_1 = 21;
            continue $sm;
          case 21:
            return Unit_instance;
          case 22:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 22) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $handleAddToCartCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r12m_1 = _this__u8e3s4;
  }
  protoOf($handleAddToCartCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 11;
            if (!this.r12m_1.p12n_1.fz1().u1()) {
              this.n9_1 = 10;
              suspendResult = this.r12m_1.d10l(new ShowMessage_1(new ResourceString(get_connect_internet_to_add_cart(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              continue $sm;
            }

          case 1:
            this.t12m_1 = this.r12m_1.s10h().ajg().u1();
            this.u12m_1 = this.r12m_1.n12n_1.ynu();
            if (this.u12m_1 == null) {
              this.r12m_1.x10k(ModelMugViewModel$handleAddToCart$lambda);
              this.n9_1 = 9;
              suspendResult = this.r12m_1.d10l(NavigateToAuth_instance_0, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            var tmp0_elvis_lhs = this.t12m_1.e12b_1;
            if (tmp0_elvis_lhs == null) {
              var $this$run = this.r12m_1;
              this.n9_1 = 3;
              suspendResult = $this$run.d10l(new ShowMessage_1(new ResourceString(get_product_info_missing(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.v12m_1 = tmp0_elvis_lhs;
              this.n9_1 = 4;
              continue $sm;
            }

          case 3:
            var tmp_0 = this;
            return Unit_instance;
          case 4:
            this.s12m_1 = this.v12m_1;
            var tmp_1;
            var tmp1_safe_receiver = this.t12m_1.n12b_1;
            if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.pyz_1) === true) {
              tmp_1 = isBlank(this.t12m_1.p12b_1);
            } else {
              tmp_1 = false;
            }

            if (tmp_1) {
              this.r12m_1.x10k(ModelMugViewModel$handleAddToCart$lambda_0);
              this.n9_1 = 8;
              suspendResult = this.r12m_1.d10l(new ShowMessage_1(new ResourceString(get_invalid_birthday_date(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 5:
            var tmp_2;
            var tmp2_safe_receiver = this.t12m_1.r12b_1;
            if ((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.az0_1) === true) {
              tmp_2 = isBlank(this.t12m_1.t12b_1);
            } else {
              tmp_2 = false;
            }

            if (tmp_2) {
              this.r12m_1.x10k(ModelMugViewModel$handleAddToCart$lambda_1);
              this.n9_1 = 7;
              suspendResult = this.r12m_1.d10l(new ShowMessage_1(new ResourceString(get_invalid_birthday_date(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 6:
            this.r12m_1.x10k(ModelMugViewModel$handleAddToCart$lambda_2);
            var tmp_3 = get_viewModelScope(this.r12m_1);
            launch(tmp_3, VOID, VOID, ModelMugViewModel$handleAddToCart$slambda_0(this.u12m_1, this.t12m_1, this.s12m_1, this.r12m_1, null));
            return Unit_instance;
          case 7:
            return Unit_instance;
          case 8:
            return Unit_instance;
          case 9:
            return Unit_instance;
          case 10:
            return Unit_instance;
          case 11:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 11) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ModelMugViewModel(addToCartUseCase, downloadDesignImageUseCase, uploadDesignImageUseCase, getCurrentUserValueUseCase, getLanguageUseCase, networkObserver, productRepository, authRepository) {
    BaseMviViewModel.call(this, new Model3DState());
    this.k12n_1 = addToCartUseCase;
    this.l12n_1 = downloadDesignImageUseCase;
    this.m12n_1 = uploadDesignImageUseCase;
    this.n12n_1 = getCurrentUserValueUseCase;
    this.o12n_1 = getLanguageUseCase;
    this.p12n_1 = networkObserver;
    this.q12n_1 = productRepository;
    this.r12n_1 = authRepository;
    observeLanguage_5(this);
    observeCurrentUser(this);
  }
  protoOf(ModelMugViewModel).x12p = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_9(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ModelMugViewModel).f10l = function (intent, $completion) {
    return this.x12p(isInterface(intent, ModelMugIntent) ? intent : THROW_CCE(), $completion);
  };
  protoOf(ModelMugViewModel).d8r = function () {
    protoOf(BaseMviViewModel).d8r.call(this);
    this.x10k(ModelMugViewModel$onCleared$lambda);
  };
  function MugDesignerEditorScreen(cartItemId, onBack, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-477473327);
    sourceInformation($composer_0, 'C(MugDesignerEditorScreen)20@698L20,21@763L15,22@822L16,24@871L88,24@844L115,28@991L210,28@965L236,37@1207L1300:MugDesignerEditorScreen.kt#mu900e');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(cartItemId) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-477473327, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.MugDesignerEditorScreen (MugDesignerEditorScreen.kt:19)');
      }
      PreventScreenshots($composer_0, 0);
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(EditMugDesignViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, 709641737, 'CC(remember):MugDesignerEditorScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_0.q31(viewModel) | ($dirty & 14) === 4);
      // Inline function 'kotlin.let' call
      var it = tmp0_0.i31();
      var tmp_1;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = MugDesignerEditorScreen$slambda_0(viewModel, cartItemId, null);
        tmp0_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(cartItemId, tmp0_group, $composer_0, 14 & $dirty);
      sourceInformationMarkerStart($composer_0, 709645699, 'CC(remember):MugDesignerEditorScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.q31(viewModel) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_1.i31();
      var tmp_2;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = MugDesignerEditorScreen$slambda_2(viewModel, onBack, null);
        tmp0_1.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp1_group, $composer_0, 0);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = fillMaxSize(Companion_instance);
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_2 = $composer_0;
      if (!((4 & 1) === 0))
        modifier = Companion_instance;
      if (!((4 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((4 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_3 = $composer_2;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_0);
      var tmp0_2 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_3 = $composer_4.g30();
      if (!isInterface(tmp_3, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_2);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_5 = $composer_4;
      var $composer_6 = $composer_5;
      sourceInformationMarkerStart($composer_6, -1511348396, 'C:MugDesignerEditorScreen.kt#mu900e');
      if (MugDesignerEditorScreen$lambda(state$delegate).w12a_1 || MugDesignerEditorScreen$lambda(state$delegate).z12a_1.c12b_1) {
        $composer_6.m30(-1511335656);
        sourceInformation($composer_6, '39@1356L27');
        var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_5 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_7 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_4, tmp_5, tmp_6, tmp_7, _Dp___init__impl__ms3zkb(0.0), $composer_6, 0, 63);
        $composer_6.n30();
      } else if (!(MugDesignerEditorScreen$lambda(state$delegate).x12a_1 == null)) {
        $composer_6.m30(-1511254560);
        sourceInformation($composer_6, '41@1438L19');
        var tmp_8 = ensureNotNull(MugDesignerEditorScreen$lambda(state$delegate).x12a_1);
        var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_13 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_8, null, tmp_9, null, tmp_10, null, null, null, tmp_11, null, null, tmp_12, tmp_13, false, 0, 0, null, null, $composer_6, 0, 0, 262142);
        $composer_6.n30();
      } else if (!(MugDesignerEditorScreen$lambda(state$delegate).z12a_1.d12b_1 == null)) {
        $composer_6.m30(-1511167512);
        sourceInformation($composer_6, '43@1557L10,43@1525L43');
        var tmp_14 = ensureNotNull(MugDesignerEditorScreen$lambda(state$delegate).z12a_1.d12b_1).s11k($composer_6, 0);
        var tmp_15 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_17 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_18 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_19 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_14, null, tmp_15, null, tmp_16, null, null, null, tmp_17, null, null, tmp_18, tmp_19, false, 0, 0, null, null, $composer_6, 0, 0, 262142);
        $composer_6.n30();
      } else {
        $composer_6.m30(-1511068746);
        sourceInformation($composer_6, '47@1714L728,45@1598L893');
        var tmp_20 = MugDesignerEditorScreen$lambda(state$delegate).z12a_1.h12b_1;
        sourceInformationMarkerStart($composer_6, 1198185807, 'CC(remember):MugDesignerEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_6.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_6.i31();
        var tmp_21;
        if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
          var value_1 = MugDesignerEditorScreen$lambda_0(viewModel);
          $composer_6.j31(value_1);
          tmp_21 = value_1;
        } else {
          tmp_21 = it_1;
        }
        var tmp0_group_0 = tmp_21;
        sourceInformationMarkerEnd($composer_6);
        MugImageEditorScreen(tmp_20, tmp0_group_0, onBack, $composer_6, 896 & $dirty << 3, 0);
        $composer_6.n30();
      }
      sourceInformationMarkerEnd($composer_6);
      $composer_4.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver = $composer_0.t30();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.p3c(MugDesignerEditorScreen$lambda_1(cartItemId, onBack, $changed));
    }
  }
  function MugDesignerEditorScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function MugDesignerEditorScreen$slambda($viewModel, $cartItemId, resultContinuation) {
    this.g12q_1 = $viewModel;
    this.h12q_1 = $cartItemId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MugDesignerEditorScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MugDesignerEditorScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(MugDesignerEditorScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.g12q_1.s10h().j10i(new LoadCartItem(this.h12q_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(MugDesignerEditorScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new MugDesignerEditorScreen$slambda(this.g12q_1, this.h12q_1, completion);
    i.i12q_1 = $this$LaunchedEffect;
    return i;
  };
  function MugDesignerEditorScreen$slambda_0($viewModel, $cartItemId, resultContinuation) {
    var i = new MugDesignerEditorScreen$slambda($viewModel, $cartItemId, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_16(function_0) {
    this.j12q_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_16).a1v = function (value, $completion) {
    return this.j12q_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_16).q3 = function () {
    return this.j12q_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_16).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_16).hashCode = function () {
    return hashCode(this.q3());
  };
  function MugDesignerEditorScreen$slambda$slambda($onBack, resultContinuation) {
    this.s12q_1 = $onBack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MugDesignerEditorScreen$slambda$slambda).f12a = function (effect, $completion) {
    var tmp = this.g12a(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MugDesignerEditorScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.f12a((!(p1 == null) ? isInterface(p1, EditMugDesignSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(MugDesignerEditorScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0_subject = this.t12q_1;
          if (equals(tmp0_subject, NavigateBack_instance))
            this.s12q_1();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(MugDesignerEditorScreen$slambda$slambda).g12a = function (effect, completion) {
    var i = new MugDesignerEditorScreen$slambda$slambda(this.s12q_1, completion);
    i.t12q_1 = effect;
    return i;
  };
  function MugDesignerEditorScreen$slambda$slambda_0($onBack, resultContinuation) {
    var i = new MugDesignerEditorScreen$slambda$slambda($onBack, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.f12a(effect, $completion);
    }, 1);
  }
  function MugDesignerEditorScreen$slambda_1($viewModel, $onBack, resultContinuation) {
    this.c12r_1 = $viewModel;
    this.d12r_1 = $onBack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MugDesignerEditorScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MugDesignerEditorScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(MugDesignerEditorScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.c12r_1.s10h().t10h();
            var tmp_1 = MugDesignerEditorScreen$slambda$slambda_0(this.d12r_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_16(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(MugDesignerEditorScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new MugDesignerEditorScreen$slambda_1(this.c12r_1, this.d12r_1, completion);
    i.e12r_1 = $this$LaunchedEffect;
    return i;
  };
  function MugDesignerEditorScreen$slambda_2($viewModel, $onBack, resultContinuation) {
    var i = new MugDesignerEditorScreen$slambda_1($viewModel, $onBack, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function MugDesignerEditorScreen$lambda_0($viewModel) {
    return function (bitmap, bytes, elements) {
      $viewModel.s10h().j10i(new Model3D_0(new CustomImageApplied(bitmap, bytes, elements)));
      $viewModel.s10h().j10i(new UpdateMugDesign(bitmap));
      return Unit_instance;
    };
  }
  function MugDesignerEditorScreen$lambda_1($cartItemId, $onBack, $$changed) {
    return function ($composer, $force) {
      MugDesignerEditorScreen($cartItemId, $onBack, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function get_SepiaMatrix_0() {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    return SepiaMatrix_0;
  }
  var SepiaMatrix_0;
  function get_GrayscaleMatrix_0() {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    return GrayscaleMatrix_0;
  }
  var GrayscaleMatrix_0;
  function get_InvertMatrix_0() {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    return InvertMatrix_0;
  }
  var InvertMatrix_0;
  function MugImageEditorScreen(initialElements, onDone, onCancel, $composer, $changed, $default) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    var initialElements_0 = {_v: initialElements};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1651698349);
    sourceInformation($composer_0, 'C(MugImageEditorScreen)P(!1,2)137@6441L128:MugImageEditorScreen.kt#mu900e');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(initialElements_0._v) : $composer_0.q31(initialElements_0._v)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onDone) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onCancel) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        initialElements_0._v = emptyList();
      }
      if (isTraceInProgress()) {
        traceEventStart(-1651698349, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.MugImageEditorScreen (MugImageEditorScreen.kt:136)');
      }
      BaseMugImageEditorScreen(initialElements_0._v, onDone, onCancel, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(MugImageEditorScreen$lambda(initialElements_0, onDone, onCancel, $changed, $default));
    }
  }
  function MagicMugImageEditorScreen(initialElements, onDone, onCancel, $composer, $changed, $default) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    var initialElements_0 = {_v: initialElements};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1344454082);
    sourceInformation($composer_0, 'C(MagicMugImageEditorScreen)P(!1,2)151@6843L128:MugImageEditorScreen.kt#mu900e');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(initialElements_0._v) : $composer_0.q31(initialElements_0._v)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onDone) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onCancel) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        initialElements_0._v = emptyList();
      }
      if (isTraceInProgress()) {
        traceEventStart(1344454082, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.MagicMugImageEditorScreen (MugImageEditorScreen.kt:150)');
      }
      BaseMugImageEditorScreen(initialElements_0._v, onDone, onCancel, $composer_0, 14 & $dirty | 112 & $dirty | 896 & $dirty, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(MagicMugImageEditorScreen$lambda(initialElements_0, onDone, onCancel, $changed, $default));
    }
  }
  function BaseMugImageEditorScreen(initialElements, onDone, onCancel, $composer, $changed, $default) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    var initialElements_0 = {_v: initialElements};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1264677118);
    sourceInformation($composer_0, 'C(BaseMugImageEditorScreen)P(!1,2)184@7655L20,185@7693L119,191@7843L34,192@7902L34,193@7953L24,195@8000L188,205@8194L32,206@8249L40,207@8314L33,208@8374L34,209@8431L54,210@8513L34,211@8571L53,212@8658L40,214@8731L7,215@8762L22,217@8804L22,218@8843L20,219@8882L22,220@8921L20,221@8962L24,222@9007L24,223@9051L23,224@9093L22,225@9136L20,228@9190L573,244@9788L1437,283@11330L361,283@11298L393,294@11740L1190,294@11712L1218,329@13012L27800,329@12936L27876:MugImageEditorScreen.kt#mu900e');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(initialElements_0._v) : $composer_0.q31(initialElements_0._v)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onDone) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onCancel) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        initialElements_0._v = emptyList();
      }
      if (isTraceInProgress()) {
        traceEventStart(-1264677118, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen (MugImageEditorScreen.kt:183)');
      }
      PreventScreenshots($composer_0, 0);
      sourceInformationMarkerStart($composer_0, 121042681, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        // Inline function 'kotlin.apply' call
        var this_1 = mutableStateListOf_0();
        this_1.e10(initialElements_0._v);
        var value = this_1;
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var images = tmp0_group;
      sourceInformationMarkerStart($composer_0, 121047396, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_2.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = mutableStateOf(false);
        this_2.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      var showDiscardDialog$delegate = tmp1_group;
      sourceInformationMarkerStart($composer_0, 121049284, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_3.i31();
      var tmp_1;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = mutableStateOf(false);
        this_3.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp2_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var isProcessing$delegate = tmp2_group;
      // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
      var getContext = null;
      var $composer_1 = $composer_0;
      if (!((1 & 1) === 0)) {
        getContext = BaseMugImageEditorScreen$lambda_3;
      }
      var composer = $composer_1;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_2 = $composer_1.i31();
      var tmp_2;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var value_2 = createCompositionCoroutineScope(getContext(), composer);
        $composer_1.j31(value_2);
        tmp_2 = value_2;
      } else {
        tmp_2 = it_2;
      }
      var scope = tmp_2;
      sourceInformationMarkerStart($composer_0, 121052574, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 896) === 256;
      // Inline function 'kotlin.let' call
      var it_3 = tmp0.i31();
      var tmp_3;
      if (invalid || it_3 === Companion_getInstance().f30_1) {
        var value_3 = BaseMugImageEditorScreen$lambda_4(images, onCancel, isProcessing$delegate, showDiscardDialog$delegate);
        tmp0.j31(value_3);
        tmp_3 = value_3;
      } else {
        tmp_3 = it_3;
      }
      var tmp3_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      var handleBack = tmp3_group;
      BackHandler(false, handleBack, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, 121060394, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_4 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_4 = this_4.i31();
      var tmp_4;
      if (false || it_4 === Companion_getInstance().f30_1) {
        var value_4 = mutableStateOf(null);
        this_4.j31(value_4);
        tmp_4 = value_4;
      } else {
        tmp_4 = it_4;
      }
      var tmp4_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      var selectedId$delegate = tmp4_group;
      sourceInformationMarkerStart($composer_0, 121062467, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_5 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_5 = this_5.i31();
      var tmp_5;
      if (false || it_5 === Companion_getInstance().f30_1) {
        var value_5 = mutableStateOf(true);
        this_5.j31(value_5);
        tmp_5 = value_5;
      } else {
        tmp_5 = it_5;
      }
      var tmp5_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      var showSettings$delegate = tmp5_group;
      sourceInformationMarkerStart($composer_0, 121064388, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_6 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_6 = this_6.i31();
      var tmp_6;
      if (false || it_6 === Companion_getInstance().f30_1) {
        var value_6 = mutableStateOf(false);
        this_6.j31(value_6);
        tmp_6 = value_6;
      } else {
        tmp_6 = it_6;
      }
      var tmp6_group = tmp_6;
      sourceInformationMarkerEnd($composer_0);
      var showTextDialog$delegate = tmp6_group;
      sourceInformationMarkerStart($composer_0, 121066232, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_7 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_7 = this_7.i31();
      var tmp_7;
      if (false || it_7 === Companion_getInstance().f30_1) {
        var value_7 = mutableStateOf(null);
        this_7.j31(value_7);
        tmp_7 = value_7;
      } else {
        tmp_7 = it_7;
      }
      var tmp7_group = tmp_7;
      sourceInformationMarkerEnd($composer_0);
      var textToEdit$delegate = tmp7_group;
      sourceInformationMarkerStart($composer_0, 121068836, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_8 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_8 = this_8.i31();
      var tmp_8;
      if (false || it_8 === Companion_getInstance().f30_1) {
        var value_8 = mutableStateOf(false);
        this_8.j31(value_8);
        tmp_8 = value_8;
      } else {
        tmp_8 = it_8;
      }
      var tmp8_group = tmp_8;
      sourceInformationMarkerEnd($composer_0);
      var showColorPicker$delegate = tmp8_group;
      sourceInformationMarkerStart($composer_0, 121070711, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_9 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_9 = this_9.i31();
      var tmp_9;
      if (false || it_9 === Companion_getInstance().f30_1) {
        var value_9 = mutableStateOf(null);
        this_9.j31(value_9);
        tmp_9 = value_9;
      } else {
        tmp_9 = it_9;
      }
      var tmp9_group = tmp_9;
      sourceInformationMarkerEnd($composer_0);
      var colorToEdit$delegate = tmp9_group;
      sourceInformationMarkerStart($composer_0, 121073482, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_10 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_10 = this_10.i31();
      var tmp_10;
      if (false || it_10 === Companion_getInstance().f30_1) {
        var value_10 = mutableStateOf(new Color_0(Companion_getInstance_14().i6b_1));
        this_10.j31(value_10);
        tmp_10 = value_10;
      } else {
        tmp_10 = it_10;
      }
      var tmp10_group = tmp_10;
      sourceInformationMarkerEnd($composer_0);
      var initialColorForPicker$delegate = tmp10_group;
      var tmp0_0 = get_LocalDensity();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_2 = $composer_0;
      var density = $composer_2.u31(tmp0_0);
      var textMeasurer = rememberTextMeasurer(0, $composer_0, 0, 1);
      var tajawal = getTajawalFontFamily($composer_0, 0);
      var cairo = getCairoFontFamily($composer_0, 0);
      var almarai = getAlmaraiFontFamily($composer_0, 0);
      var amiri = getAmiriFontFamily($composer_0, 0);
      var vazirmatn = getVazirmatnFontFamily($composer_0, 0);
      var readexPro = getReadexProFontFamily($composer_0, 0);
      var notoSans = getNotoSansFontFamily($composer_0, 0);
      var ibmPlex = getIBMPlexFontFamily($composer_0, 0);
      var emojiFont = getEmojiFontFamily($composer_0, 0);
      sourceInformationMarkerStart($composer_0, 121091039, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(!!(!!(!!(!!(!!(!!($composer_0.k31(tajawal) | $composer_0.k31(cairo)) | $composer_0.k31(almarai)) | $composer_0.k31(amiri)) | $composer_0.k31(vazirmatn)) | $composer_0.k31(readexPro)) | $composer_0.k31(notoSans)) | $composer_0.k31(ibmPlex));
      // Inline function 'kotlin.let' call
      var it_11 = tmp0_1.i31();
      var tmp_11;
      if (invalid_0 || it_11 === Companion_getInstance().f30_1) {
        var value_11 = BaseMugImageEditorScreen$lambda_19(tajawal, cairo, almarai, amiri, vazirmatn, readexPro, notoSans, ibmPlex);
        tmp0_1.j31(value_11);
        tmp_11 = value_11;
      } else {
        tmp_11 = it_11;
      }
      var tmp11_group = tmp_11;
      sourceInformationMarkerEnd($composer_0);
      var getFontFamily = tmp11_group;
      sourceInformationMarkerStart($composer_0, 121111039, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(!!(!!($composer_0.k31(textMeasurer) | $composer_0.k31(density)) | $composer_0.k31(getFontFamily)) | $composer_0.k31(emojiFont));
      // Inline function 'kotlin.let' call
      var it_12 = tmp0_2.i31();
      var tmp_12;
      if (invalid_1 || it_12 === Companion_getInstance().f30_1) {
        var value_12 = BaseMugImageEditorScreen$lambda_20(getFontFamily, emojiFont, textMeasurer, density);
        tmp0_2.j31(value_12);
        tmp_12 = value_12;
      } else {
        tmp_12 = it_12;
      }
      var tmp12_group = tmp_12;
      sourceInformationMarkerEnd($composer_0);
      var textToBitmap = tmp12_group;
      var tmp_13 = initialElements_0._v;
      sourceInformationMarkerStart($composer_0, 121159307, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      var tmp0_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = !!((($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(initialElements_0._v))) | $composer_0.k31(textToBitmap));
      // Inline function 'kotlin.let' call
      var it_13 = tmp0_3.i31();
      var tmp_14;
      if (invalid_2 || it_13 === Companion_getInstance().f30_1) {
        var value_13 = BaseMugImageEditorScreen$slambda_0(initialElements_0, images, textToBitmap, null);
        tmp0_3.j31(value_13);
        tmp_14 = value_13;
      } else {
        tmp_14 = it_13;
      }
      var tmp13_group = tmp_14;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_13, tmp13_group, $composer_0, 14 & $dirty);
      sourceInformationMarkerStart($composer_0, 121173256, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      var tmp0_4 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = $composer_0.q31(scope);
      // Inline function 'kotlin.let' call
      var it_14 = tmp0_4.i31();
      var tmp_15;
      if (invalid_3 || it_14 === Companion_getInstance().f30_1) {
        var value_14 = BaseMugImageEditorScreen$lambda_21(scope, isProcessing$delegate, images, selectedId$delegate);
        tmp0_4.j31(value_14);
        tmp_15 = value_14;
      } else {
        tmp_15 = it_14;
      }
      var tmp14_group = tmp_15;
      sourceInformationMarkerEnd($composer_0);
      var launcher = rememberImagePickerLauncher(tmp14_group, $composer_0, 0);
      var tmp_16 = get_LocalLayoutDirection().h3c(LayoutDirection_Ltr_getInstance());
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(1313235906, true, BaseMugImageEditorScreen$lambda_22(handleBack, scope, onDone, isProcessing$delegate, images, selectedId$delegate, showSettings$delegate, textToBitmap, textToEdit$delegate, showTextDialog$delegate, initialColorForPicker$delegate, colorToEdit$delegate, showColorPicker$delegate, getFontFamily, density, launcher), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_4 = $composer_3.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_15 = $composer_3.i31();
      var tmp_17;
      if (invalid_4 || it_15 === Companion_getInstance().f30_1) {
        var value_15 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_3.j31(value_15);
        tmp_17 = value_15;
      } else {
        tmp_17 = it_15;
      }
      var tmp$ret$68 = tmp_17;
      CompositionLocalProvider(tmp_16, tmp$ret$68, $composer_0, 48 | androidx_compose_runtime_ProvidedValue$stableprop_getter());
      if (BaseMugImageEditorScreen$lambda_9(showTextDialog$delegate)) {
        $composer_0.m30(-509624130);
        sourceInformation($composer_0, '706@40865L51,707@40940L34,708@41000L65,709@41090L68,712@41212L26,753@44351L987,769@45368L96,713@41260L123,714@41404L2917,711@41168L4306');
        sourceInformationMarkerStart($composer_0, 122104117, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_11 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_16 = this_11.i31();
        var tmp_18;
        if (false || it_16 === Companion_getInstance().f30_1) {
          var tmp0_safe_receiver = BaseMugImageEditorScreen$lambda_11(textToEdit$delegate);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i12g_1;
          var value_16 = mutableStateOf(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
          this_11.j31(value_16);
          tmp_18 = value_16;
        } else {
          tmp_18 = it_16;
        }
        var tmp15_group = tmp_18;
        sourceInformationMarkerEnd($composer_0);
        var textValue$delegate = tmp15_group;
        sourceInformationMarkerStart($composer_0, 122106500, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_12 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_17 = this_12.i31();
        var tmp_19;
        if (false || it_17 === Companion_getInstance().f30_1) {
          var value_17 = mutableStateOf(false);
          this_12.j31(value_17);
          tmp_19 = value_17;
        } else {
          tmp_19 = it_17;
        }
        var tmp16_group = tmp_19;
        sourceInformationMarkerEnd($composer_0);
        var isError$delegate = tmp16_group;
        sourceInformationMarkerStart($composer_0, 122108451, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_13 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_18 = this_13.i31();
        var tmp_20;
        if (false || it_18 === Companion_getInstance().f30_1) {
          var tmp0_safe_receiver_0 = BaseMugImageEditorScreen$lambda_11(textToEdit$delegate);
          var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.j12g_1;
          var tmp_21;
          var tmp_22 = tmp1_elvis_lhs_0;
          if ((tmp_22 == null ? null : new Color_0(tmp_22)) == null) {
            tmp_21 = Companion_getInstance_14().i6b_1;
          } else {
            tmp_21 = tmp1_elvis_lhs_0;
          }
          var value_18 = mutableStateOf(new Color_0(tmp_21));
          this_13.j31(value_18);
          tmp_20 = value_18;
        } else {
          tmp_20 = it_18;
        }
        var tmp17_group = tmp_20;
        sourceInformationMarkerEnd($composer_0);
        var textColor$delegate = tmp17_group;
        sourceInformationMarkerStart($composer_0, 122111334, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_14 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_19 = this_14.i31();
        var tmp_23;
        if (false || it_19 === Companion_getInstance().f30_1) {
          var tmp0_safe_receiver_1 = BaseMugImageEditorScreen$lambda_11(textToEdit$delegate);
          var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.k12g_1;
          var value_19 = mutableStateOf(tmp1_elvis_lhs_1 == null ? 'tajawal' : tmp1_elvis_lhs_1);
          this_14.j31(value_19);
          tmp_23 = value_19;
        } else {
          tmp_23 = it_19;
        }
        var tmp18_group = tmp_23;
        sourceInformationMarkerEnd($composer_0);
        var fontName$delegate = tmp18_group;
        sourceInformationMarkerStart($composer_0, 122115196, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_15 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_20 = this_15.i31();
        var tmp_24;
        if (false || it_20 === Companion_getInstance().f30_1) {
          var value_20 = BaseMugImageEditorScreen$lambda_31(showTextDialog$delegate);
          this_15.j31(value_20);
          tmp_24 = value_20;
        } else {
          tmp_24 = it_20;
        }
        var tmp19_group = tmp_24;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-1139190763, true, BaseMugImageEditorScreen$lambda_32(textToBitmap, images, textValue$delegate, textColor$delegate, fontName$delegate, textToEdit$delegate, selectedId$delegate, showTextDialog$delegate, isError$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_4 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = $composer_4.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_21 = $composer_4.i31();
        var tmp_25;
        if (invalid_5 || it_21 === Companion_getInstance().f30_1) {
          var value_21 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_4.j31(value_21);
          tmp_25 = value_21;
        } else {
          tmp_25 = it_21;
        }
        var tmp_26 = tmp_25;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(-568918957, true, BaseMugImageEditorScreen$lambda_33(showTextDialog$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_5 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_6 = $composer_5.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_22 = $composer_5.i31();
        var tmp_27;
        if (invalid_6 || it_22 === Companion_getInstance().f30_1) {
          var value_22 = ComposableLambda$invoke$ref(dispatchReceiver_1);
          $composer_5.j31(value_22);
          tmp_27 = value_22;
        } else {
          tmp_27 = it_22;
        }
        var tmp_28 = tmp_27;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_2 = rememberComposableLambda(1352849, true, BaseMugImageEditorScreen$lambda_34(textToEdit$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_6 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_7 = $composer_6.k31(dispatchReceiver_2);
        // Inline function 'kotlin.let' call
        var it_23 = $composer_6.i31();
        var tmp_29;
        if (invalid_7 || it_23 === Companion_getInstance().f30_1) {
          var value_23 = ComposableLambda$invoke$ref(dispatchReceiver_2);
          $composer_6.j31(value_23);
          tmp_29 = value_23;
        } else {
          tmp_29 = it_23;
        }
        var tmp_30 = tmp_29;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_3 = rememberComposableLambda(286488752, true, BaseMugImageEditorScreen$lambda_35(getFontFamily, emojiFont, textValue$delegate, isError$delegate, textColor$delegate, fontName$delegate, initialColorForPicker$delegate, colorToEdit$delegate, showColorPicker$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_7 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_8 = $composer_7.k31(dispatchReceiver_3);
        // Inline function 'kotlin.let' call
        var it_24 = $composer_7.i31();
        var tmp_31;
        if (invalid_8 || it_24 === Companion_getInstance().f30_1) {
          var value_24 = ComposableLambda$invoke$ref(dispatchReceiver_3);
          $composer_7.j31(value_24);
          tmp_31 = value_24;
        } else {
          tmp_31 = it_24;
        }
        var tmp_32 = tmp_31;
        var tmp_33 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_34 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_35 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_36 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_37 = _Dp___init__impl__ms3zkb(0.0);
        AlertDialog(tmp19_group, tmp_26, null, tmp_28, null, tmp_30, tmp_32, null, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, null, $composer_0, 1772598, 0, 16276);
        $composer_0.n30();
      } else {
        $composer_0.m30(-505163168);
        $composer_0.n30();
      }
      if (BaseMugImageEditorScreen$lambda(showDiscardDialog$delegate)) {
        $composer_0.m30(-505114746);
        sourceInformation($composer_0, '775@45563L29,778@45777L221,783@46028L99,774@45519L618');
        sourceInformationMarkerStart($composer_0, 122254431, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_16 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_25 = this_16.i31();
        var tmp_38;
        if (false || it_25 === Companion_getInstance().f30_1) {
          var value_25 = BaseMugImageEditorScreen$lambda_36(showDiscardDialog$delegate);
          this_16.j31(value_25);
          tmp_38 = value_25;
        } else {
          tmp_38 = it_25;
        }
        var tmp20_group = tmp_38;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_4 = rememberComposableLambda(-220990068, true, BaseMugImageEditorScreen$lambda_37(onCancel, showDiscardDialog$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_8 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_9 = $composer_8.k31(dispatchReceiver_4);
        // Inline function 'kotlin.let' call
        var it_26 = $composer_8.i31();
        var tmp_39;
        if (invalid_9 || it_26 === Companion_getInstance().f30_1) {
          var value_26 = ComposableLambda$invoke$ref(dispatchReceiver_4);
          $composer_8.j31(value_26);
          tmp_39 = value_26;
        } else {
          tmp_39 = it_26;
        }
        var tmp_40 = tmp_39;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_5 = rememberComposableLambda(-1945598390, true, BaseMugImageEditorScreen$lambda_38(showDiscardDialog$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_9 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_10 = $composer_9.k31(dispatchReceiver_5);
        // Inline function 'kotlin.let' call
        var it_27 = $composer_9.i31();
        var tmp_41;
        if (invalid_10 || it_27 === Companion_getInstance().f30_1) {
          var value_27 = ComposableLambda$invoke$ref(dispatchReceiver_5);
          $composer_9.j31(value_27);
          tmp_41 = value_27;
        } else {
          tmp_41 = it_27;
        }
        var tmp_42 = tmp_41;
        var tmp_43 = ComposableSingletons$MugImageEditorScreenKt_getInstance().r12r_1;
        var tmp_44 = ComposableSingletons$MugImageEditorScreenKt_getInstance().s12r_1;
        var tmp_45 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_46 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_47 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_48 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_49 = _Dp___init__impl__ms3zkb(0.0);
        AlertDialog(tmp20_group, tmp_40, null, tmp_42, null, tmp_43, tmp_44, null, tmp_45, tmp_46, tmp_47, tmp_48, tmp_49, null, $composer_0, 1772598, 0, 16276);
        $composer_0.n30();
      } else {
        $composer_0.m30(-504505472);
        $composer_0.n30();
      }
      if (BaseMugImageEditorScreen$lambda_13(showColorPicker$delegate)) {
        $composer_0.m30(-504473573);
        sourceInformation($composer_0, '788@46260L27,788@46301L27,788@46180L149');
        var tmp_50 = BaseMugImageEditorScreen$lambda_17(initialColorForPicker$delegate);
        sourceInformationMarkerStart($composer_0, 122276733, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_17 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_28 = this_17.i31();
        var tmp_51;
        if (false || it_28 === Companion_getInstance().f30_1) {
          var value_28 = BaseMugImageEditorScreen$lambda_39(colorToEdit$delegate);
          this_17.j31(value_28);
          tmp_51 = value_28;
        } else {
          tmp_51 = it_28;
        }
        var tmp21_group = tmp_51;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 122278045, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_18 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_29 = this_18.i31();
        var tmp_52;
        if (false || it_29 === Companion_getInstance().f30_1) {
          var value_29 = BaseMugImageEditorScreen$lambda_40(showColorPicker$delegate);
          this_18.j31(value_29);
          tmp_52 = value_29;
        } else {
          tmp_52 = it_29;
        }
        var tmp22_group = tmp_52;
        sourceInformationMarkerEnd($composer_0);
        SimpleColorPickerDialog(tmp_50, tmp21_group, tmp22_group, $composer_0, 432);
        $composer_0.n30();
      } else {
        $composer_0.m30(-504315008);
        $composer_0.n30();
      }
      if (BaseMugImageEditorScreen$lambda_1(isProcessing$delegate)) {
        $composer_0.m30(-504283481);
        sourceInformation($composer_0, '792@46491L2,792@46369L233');
        var tmp_53 = zIndex(background(fillMaxSize(Companion_instance), Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.5)), 1000.0);
        sourceInformationMarkerStart($composer_0, 122284100, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_19 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_30 = this_19.i31();
        var tmp_54;
        if (false || it_30 === Companion_getInstance().f30_1) {
          var value_30 = BaseMugImageEditorScreen$lambda_41;
          this_19.j31(value_30);
          tmp_54 = value_30;
        } else {
          tmp_54 = it_30;
        }
        var tmp23_group = tmp_54;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = clickable(tmp_53, false, VOID, VOID, VOID, tmp23_group);
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_10 = $composer_0;
        if (!((4 & 1) === 0))
          modifier = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_11 = $composer_10;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_11, 0).hashCode();
        var localMap = $composer_11.t31();
        var materialized = materialize($composer_11, modifier_0);
        var tmp0_5 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_12 = $composer_11;
        var tmp_55 = $composer_12.g30();
        if (!isInterface(tmp_55, Applier)) {
          invalidApplier();
        }
        $composer_12.b31();
        if ($composer_12.h30()) {
          $composer_12.c31(tmp0_5);
        } else {
          $composer_12.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_12);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_13 = $composer_12;
        var $composer_14 = $composer_13;
        sourceInformationMarkerStart($composer_14, 581909497, 'C793@46546L46:MugImageEditorScreen.kt#mu900e');
        var tmp_56 = Companion_getInstance_14().m6b_1;
        var tmp_57 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_58 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_59 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_56, tmp_57, tmp_58, tmp_59, _Dp___init__impl__ms3zkb(0.0), $composer_14, 48, 61);
        sourceInformationMarkerEnd($composer_14);
        $composer_12.e31();
        $composer_0.n30();
      } else {
        $composer_0.m30(-504044192);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp24_safe_receiver = $composer_0.t30();
    if (tmp24_safe_receiver == null)
      null;
    else {
      tmp24_safe_receiver.p3c(BaseMugImageEditorScreen$lambda_42(initialElements_0, onDone, onCancel, $changed, $default));
    }
  }
  function toEmojiAnnotatedString(_this__u8e3s4, selectedFont, emojiFont) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    var builder = new Builder_0();
    var textRegex = Regex_init_$Create$('[\\u0000-\\u007F\\u00A0-\\u00FF\\u0600-\\u06FF\\u0750-\\u077F\\u08A0-\\u08FF\\uFB50-\\uFDFF\\uFE70-\\uFEFF\\u2000-\\u206F]+');
    var lastIndex = 0;
    // Inline function 'kotlin.sequences.forEach' call
    var _iterator__ex2g4s = textRegex.ce(_this__u8e3s4).t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (element.fe().x1_1 > lastIndex) {
        // Inline function 'androidx.compose.ui.text.withStyle' call
        var style = SpanStyle_init_$Create$(VOID, VOID, VOID, VOID, VOID, emojiFont);
        var index = builder.l7q(style);
        try {
          builder.f7q(substring_0(_this__u8e3s4, lastIndex, element.fe().x1_1));
        }finally {
          builder.o7q(index);
        }
      }
      // Inline function 'androidx.compose.ui.text.withStyle' call
      var style_0 = SpanStyle_init_$Create$(VOID, VOID, VOID, VOID, VOID, selectedFont);
      var index_0 = builder.l7q(style_0);
      try {
        builder.f7q(element.u1());
      }finally {
        builder.o7q(index_0);
      }
      lastIndex = element.fe().y1_1 + 1 | 0;
    }
    if (lastIndex < _this__u8e3s4.length) {
      // Inline function 'androidx.compose.ui.text.withStyle' call
      var style_1 = SpanStyle_init_$Create$(VOID, VOID, VOID, VOID, VOID, emojiFont);
      var index_1 = builder.l7q(style_1);
      try {
        builder.f7q(substring(_this__u8e3s4, lastIndex));
      }finally {
        builder.o7q(index_1);
      }
    }
    if (_this__u8e3s4.length === 0)
      return AnnotatedString_init_$Create$('');
    return builder.p7q();
  }
  function hasArabic(_this__u8e3s4) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.text.any' call
      var inductionVariable = 0;
      while (inductionVariable < charSequenceLength(_this__u8e3s4)) {
        var element = charSequenceGet(_this__u8e3s4, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        var tmp;
        var tmp_0;
        // Inline function 'kotlin.code' call
        var containsArg = Char__toInt_impl_vasixd(element);
        if (1536 <= containsArg ? containsArg <= 1791 : false) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.code' call
          var containsArg_0 = Char__toInt_impl_vasixd(element);
          tmp_0 = 1872 <= containsArg_0 ? containsArg_0 <= 1919 : false;
        }
        if (tmp_0) {
          tmp = true;
        } else {
          // Inline function 'kotlin.code' call
          var containsArg_1 = Char__toInt_impl_vasixd(element);
          tmp = 2208 <= containsArg_1 ? containsArg_1 <= 2303 : false;
        }
        if (tmp) {
          tmp$ret$0 = true;
          break $l$block;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$1128859202$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C335@13206L45,335@13201L51:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1128859202, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$1128859202.<anonymous> (MugImageEditorScreen.kt:335)');
      }
      var tmp = stringResource(get_mug_designer_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$1768968020$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C338@13433L31:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1768968020, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$1768968020.<anonymous> (MugImageEditorScreen.kt:338)');
      }
      var tmp = get_Close(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$288077031$lambda($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C361@14603L36,361@14598L42:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(288077031, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$288077031.<anonymous> (MugImageEditorScreen.kt:361)');
      }
      var tmp = stringResource(get_apply_btn(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$180210044$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C388@16253L72:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(180210044, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$180210044.<anonymous> (MugImageEditorScreen.kt:388)');
      }
      var tmp = get_VisibilityOff(Icons_getInstance().dxv_1);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(18);
      var tmp_1 = size(tmp_0, tmp$ret$0);
      Icon(tmp, null, tmp_1, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 432, 8);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$206701024$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C393@16870L11,393@16816L105:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(206701024, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$206701024.<anonymous> (MugImageEditorScreen.kt:393)');
      }
      var tmp0_imageVector = get_Delete(Icons_getInstance().dxv_1);
      var tmp1_tint = MaterialTheme_instance.unz($composer_0, 6).to0_1;
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(18);
      var tmp2_modifier = size(tmp, tmp$ret$0);
      Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_0, 432, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$_360715483$lambda_o6t93j($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C522@29882L69:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-360715483, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$-360715483.<anonymous> (MugImageEditorScreen.kt:522)');
      }
      var tmp = get_Visibility(Icons_getInstance().dxv_1);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(20);
      var tmp_1 = size(tmp_0, tmp$ret$0);
      Icon(tmp, null, tmp_1, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 432, 8);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$_1544066546$lambda_bn13y1($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C525@30241L11,525@30187L105:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1544066546, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$-1544066546.<anonymous> (MugImageEditorScreen.kt:525)');
      }
      var tmp0_imageVector = get_Delete(Icons_getInstance().dxv_1);
      var tmp1_tint = MaterialTheme_instance.unz($composer_0, 6).to0_1;
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(20);
      var tmp2_modifier = size(tmp, tmp$ret$0);
      Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_0, 432, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$2125247544$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C767@45286L35,767@45281L41:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(2125247544, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$2125247544.<anonymous> (MugImageEditorScreen.kt:767)');
      }
      var tmp = stringResource(get_done_btn(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$_1599447946$lambda_s3jc4c($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C769@45426L33,769@45421L39:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1599447946, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$-1599447946.<anonymous> (MugImageEditorScreen.kt:769)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$_1147209697$lambda_24s0uw($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C720@41758L49,720@41753L55:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1147209697, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$-1147209697.<anonymous> (MugImageEditorScreen.kt:720)');
      }
      var tmp = stringResource(get_enter_text_placeholder(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$1578096879$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C780@45886L38,780@45948L11,780@45881L85:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1578096879, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$1578096879.<anonymous> (MugImageEditorScreen.kt:780)');
      }
      var tmp = stringResource(get_discard_btn(string_instance), $composer_0, 0);
      var tmp_0 = MaterialTheme_instance.unz($composer_0, 6).to0_1;
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262138);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$_146511443$lambda_18ypy7($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C783@46089L33,783@46084L39:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-146511443, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$-146511443.<anonymous> (MugImageEditorScreen.kt:783)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$624760584$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C776@45621L47,776@45616L53:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(624760584, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$624760584.<anonymous> (MugImageEditorScreen.kt:776)');
      }
      var tmp = stringResource(get_discard_design_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$_237543577$lambda_2md011($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C777@45699L45,777@45694L51:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-237543577, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$-237543577.<anonymous> (MugImageEditorScreen.kt:777)');
      }
      var tmp = stringResource(get_discard_design_msg(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$_53172771$lambda_mz2wsf($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C887@51751L35,887@51746L41:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-53172771, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$-53172771.<anonymous> (MugImageEditorScreen.kt:887)');
      }
      var tmp = stringResource(get_done_btn(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$1841161115$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C888@51858L33,888@51853L39:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1841161115, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$1841161115.<anonymous> (MugImageEditorScreen.kt:888)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt$lambda$_1507622538$lambda_fg0vxn($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C847@48157L40,847@48152L46:MugImageEditorScreen.kt#mu900e');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1507622538, $changed, -1, 'client.fstech.hadaya.presentation.model3d.ComposableSingletons$MugImageEditorScreenKt.lambda$-1507622538.<anonymous> (MugImageEditorScreen.kt:847)');
      }
      var tmp = stringResource(get_color_setting(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$MugImageEditorScreenKt() {
    ComposableSingletons$MugImageEditorScreenKt_instance = this;
    var tmp = this;
    tmp.f12r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1128859202, false, ComposableSingletons$MugImageEditorScreenKt$lambda$1128859202$lambda));
    var tmp_0 = this;
    tmp_0.g12r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1768968020, false, ComposableSingletons$MugImageEditorScreenKt$lambda$1768968020$lambda));
    var tmp_1 = this;
    tmp_1.h12r_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(288077031, false, ComposableSingletons$MugImageEditorScreenKt$lambda$288077031$lambda));
    var tmp_2 = this;
    tmp_2.i12r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(180210044, false, ComposableSingletons$MugImageEditorScreenKt$lambda$180210044$lambda));
    var tmp_3 = this;
    tmp_3.j12r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(206701024, false, ComposableSingletons$MugImageEditorScreenKt$lambda$206701024$lambda));
    var tmp_4 = this;
    tmp_4.k12r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-360715483, false, ComposableSingletons$MugImageEditorScreenKt$lambda$_360715483$lambda_o6t93j));
    var tmp_5 = this;
    tmp_5.l12r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1544066546, false, ComposableSingletons$MugImageEditorScreenKt$lambda$_1544066546$lambda_bn13y1));
    var tmp_6 = this;
    tmp_6.m12r_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(2125247544, false, ComposableSingletons$MugImageEditorScreenKt$lambda$2125247544$lambda));
    var tmp_7 = this;
    tmp_7.n12r_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1599447946, false, ComposableSingletons$MugImageEditorScreenKt$lambda$_1599447946$lambda_s3jc4c));
    var tmp_8 = this;
    tmp_8.o12r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1147209697, false, ComposableSingletons$MugImageEditorScreenKt$lambda$_1147209697$lambda_24s0uw));
    var tmp_9 = this;
    tmp_9.p12r_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1578096879, false, ComposableSingletons$MugImageEditorScreenKt$lambda$1578096879$lambda));
    var tmp_10 = this;
    tmp_10.q12r_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-146511443, false, ComposableSingletons$MugImageEditorScreenKt$lambda$_146511443$lambda_18ypy7));
    var tmp_11 = this;
    tmp_11.r12r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(624760584, false, ComposableSingletons$MugImageEditorScreenKt$lambda$624760584$lambda));
    var tmp_12 = this;
    tmp_12.s12r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-237543577, false, ComposableSingletons$MugImageEditorScreenKt$lambda$_237543577$lambda_2md011));
    var tmp_13 = this;
    tmp_13.t12r_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-53172771, false, ComposableSingletons$MugImageEditorScreenKt$lambda$_53172771$lambda_mz2wsf));
    var tmp_14 = this;
    tmp_14.u12r_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1841161115, false, ComposableSingletons$MugImageEditorScreenKt$lambda$1841161115$lambda));
    var tmp_15 = this;
    tmp_15.v12r_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1507622538, false, ComposableSingletons$MugImageEditorScreenKt$lambda$_1507622538$lambda_fg0vxn));
  }
  var ComposableSingletons$MugImageEditorScreenKt_instance;
  function ComposableSingletons$MugImageEditorScreenKt_getInstance() {
    if (ComposableSingletons$MugImageEditorScreenKt_instance == null)
      new ComposableSingletons$MugImageEditorScreenKt();
    return ComposableSingletons$MugImageEditorScreenKt_instance;
  }
  function EditorTooltip(tooltip, content, $composer, $changed) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(91587717);
    sourceInformation($composer_0, 'C(EditorTooltip)P(1)165@7166L33,166@7219L82,171@7319L22,172@7348L25,164@7111L262:MugImageEditorScreen.kt#mu900e');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(tooltip) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(91587717, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.EditorTooltip (MugImageEditorScreen.kt:163)');
      }
      var tmp = TooltipDefaults_getInstance();
      var tmp_0 = tmp.zr2(_Dp___init__impl__ms3zkb(0.0), $composer_0, 48, 1);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(985349680, true, EditorTooltip$lambda(tooltip), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_1;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref_13(dispatchReceiver);
        $composer_1.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp_2 = tmp_1;
      var tmp_3 = rememberTooltipState(false, false, null, $composer_0, 0, 7);
      // Inline function 'kotlin.run' call
      var dispatchReceiver_0 = rememberComposableLambda(1091916360, true, EditorTooltip$lambda_0(content), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_2.k31(dispatchReceiver_0);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_2.i31();
      var tmp_4;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = ComposableLambda$invoke$ref(dispatchReceiver_0);
        $composer_2.j31(value_0);
        tmp_4 = value_0;
      } else {
        tmp_4 = it_0;
      }
      var tmp$ret$7 = tmp_4;
      TooltipBox(tmp_0, tmp_2, tmp_3, null, null, false, false, false, tmp$ret$7, $composer_0, 100663344, 248);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(EditorTooltip$lambda_1(tooltip, content, $changed));
    }
  }
  function SimpleColorPickerDialog(initialColor, onColorSelected, onDismiss, $composer, $changed) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1482341054);
    sourceInformation($composer_0, 'C(SimpleColorPickerDialog)P(0:c#ui.graphics.Color)804@46767L603,826@47387L45,827@47455L46,828@47519L45,887@51651L140,888@51817L79,848@48217L3408,845@48083L3819:MugImageEditorScreen.kt#mu900e');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.o31(_ULong___get_data__impl__fggpzb(_Color___get_value__impl__1pls5m(initialColor))) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onColorSelected) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismiss) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1482341054, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.SimpleColorPickerDialog (MugImageEditorScreen.kt:803)');
      }
      sourceInformationMarkerStart($composer_0, 1399394557, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 14) === 4;
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var r = _Color___get_red__impl__cwrsk6(initialColor);
        var g = _Color___get_green__impl__bta9rs(initialColor);
        var b = _Color___get_blue__impl__xwez13(initialColor);
        // Inline function 'kotlin.comparisons.maxOf' call
        var max = Math.max(r, g, b);
        // Inline function 'kotlin.comparisons.minOf' call
        var min = Math.min(r, g, b);
        var delta = max - min;
        var h = 0.0;
        if (delta > 0) {
          h = max === r ? (g - b) / delta % 6.0 : max === g ? (b - r) / delta + 2.0 : (r - g) / delta + 4.0;
          h = h * 60.0;
          if (h < 0)
            h = h + 360.0;
        }
        var s = max === 0.0 ? 0.0 : delta / max;
        var v = max;
        var value = new Triple(h, s, v);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var initialHsv = tmp0_group;
      sourceInformationMarkerStart($composer_0, 1399413839, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_0.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = mutableStateOf(initialHsv.er_1);
        this_0.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      var hue$delegate = tmp1_group;
      sourceInformationMarkerStart($composer_0, 1399416016, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_1.i31();
      var tmp_1;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = mutableStateOf(initialHsv.fr_1);
        this_1.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp2_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var saturation$delegate = tmp2_group;
      sourceInformationMarkerStart($composer_0, 1399418063, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_2 = this_2.i31();
      var tmp_2;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var value_2 = mutableStateOf(initialHsv.gr_1);
        this_2.j31(value_2);
        tmp_2 = value_2;
      } else {
        tmp_2 = it_2;
      }
      var tmp3_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      var value$delegate = tmp3_group;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1001323014, true, SimpleColorPickerDialog$lambda_5(onColorSelected, onDismiss, hue$delegate, saturation$delegate, value$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_3 = $composer_1.i31();
      var tmp_3;
      if (invalid_0 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value_3);
        tmp_3 = value_3;
      } else {
        tmp_3 = it_3;
      }
      var tmp_4 = tmp_3;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_0 = rememberComposableLambda(893010872, true, SimpleColorPickerDialog$lambda_6(onDismiss), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_2.k31(dispatchReceiver_0);
      // Inline function 'kotlin.let' call
      var it_4 = $composer_2.i31();
      var tmp_5;
      if (invalid_1 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = ComposableLambda$invoke$ref(dispatchReceiver_0);
        $composer_2.j31(value_4);
        tmp_5 = value_4;
      } else {
        tmp_5 = it_4;
      }
      var tmp_6 = tmp_5;
      var tmp_7 = ComposableSingletons$MugImageEditorScreenKt_getInstance().v12r_1;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_1 = rememberComposableLambda(-560455595, true, SimpleColorPickerDialog$lambda_7(saturation$delegate, value$delegate, hue$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = $composer_3.k31(dispatchReceiver_1);
      // Inline function 'kotlin.let' call
      var it_5 = $composer_3.i31();
      var tmp_8;
      if (invalid_2 || it_5 === Companion_getInstance().f30_1) {
        var value_5 = ComposableLambda$invoke$ref(dispatchReceiver_1);
        $composer_3.j31(value_5);
        tmp_8 = value_5;
      } else {
        tmp_8 = it_5;
      }
      var tmp_9 = tmp_8;
      var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_13 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_14 = _Dp___init__impl__ms3zkb(0.0);
      AlertDialog(onDismiss, tmp_4, null, tmp_6, null, tmp_7, tmp_9, null, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, null, $composer_0, 1772592 | 14 & $dirty >> 6, 0, 16276);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp4_safe_receiver = $composer_0.t30();
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.p3c(SimpleColorPickerDialog$lambda_8(initialColor, onColorSelected, onDismiss, $changed));
    }
  }
  function MugImageEditorScreen$lambda($initialElements, $onDone, $onCancel, $$changed, $$default) {
    return function ($composer, $force) {
      MugImageEditorScreen($initialElements._v, $onDone, $onCancel, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function MagicMugImageEditorScreen$lambda($initialElements, $onDone, $onCancel, $$changed, $$default) {
    return function ($composer, $force) {
      MagicMugImageEditorScreen($initialElements._v, $onDone, $onCancel, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda($showDiscardDialog$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    return $showDiscardDialog$delegate.u1();
  }
  function BaseMugImageEditorScreen$lambda_0($showDiscardDialog$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    $showDiscardDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_1($isProcessing$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isProcessing', KMutableProperty0, true);
    return $isProcessing$delegate.u1();
  }
  function BaseMugImageEditorScreen$lambda_2($isProcessing$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isProcessing', KMutableProperty0, true);
    $isProcessing$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_3() {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    return EmptyCoroutineContext_getInstance();
  }
  function BaseMugImageEditorScreen$lambda_4($images, $onCancel, $isProcessing$delegate, $showDiscardDialog$delegate) {
    return function () {
      var tmp;
      if (!BaseMugImageEditorScreen$lambda_1($isProcessing$delegate)) {
        var tmp_0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$images.r()) {
          BaseMugImageEditorScreen$lambda_0($showDiscardDialog$delegate, true);
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = $onCancel();
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda_5($selectedId$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('selectedId', KMutableProperty0, true);
    return $selectedId$delegate.u1();
  }
  function BaseMugImageEditorScreen$lambda_6($selectedId$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('selectedId', KMutableProperty0, true);
    $selectedId$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_7($showSettings$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showSettings', KMutableProperty0, true);
    return $showSettings$delegate.u1();
  }
  function BaseMugImageEditorScreen$lambda_8($showSettings$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showSettings', KMutableProperty0, true);
    $showSettings$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_9($showTextDialog$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showTextDialog', KMutableProperty0, true);
    return $showTextDialog$delegate.u1();
  }
  function BaseMugImageEditorScreen$lambda_10($showTextDialog$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showTextDialog', KMutableProperty0, true);
    $showTextDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_11($textToEdit$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('textToEdit', KMutableProperty0, true);
    return $textToEdit$delegate.u1();
  }
  function BaseMugImageEditorScreen$lambda_12($textToEdit$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('textToEdit', KMutableProperty0, true);
    $textToEdit$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_13($showColorPicker$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showColorPicker', KMutableProperty0, true);
    return $showColorPicker$delegate.u1();
  }
  function BaseMugImageEditorScreen$lambda_14($showColorPicker$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showColorPicker', KMutableProperty0, true);
    $showColorPicker$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_15($colorToEdit$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('colorToEdit', KMutableProperty0, true);
    return $colorToEdit$delegate.u1();
  }
  function BaseMugImageEditorScreen$lambda_16($colorToEdit$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('colorToEdit', KMutableProperty0, true);
    $colorToEdit$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_17($initialColorForPicker$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('initialColorForPicker', KMutableProperty0, true);
    return $initialColorForPicker$delegate.u1().c6d_1;
  }
  function BaseMugImageEditorScreen$lambda_18($initialColorForPicker$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    getLocalDelegateReference('initialColorForPicker', KMutableProperty0, true);
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new Color_0(_set____db54di);
    $initialColorForPicker$delegate.s21(value);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_19($tajawal, $cairo, $almarai, $amiri, $vazirmatn, $readexPro, $notoSans, $ibmPlex) {
    return function (name) {
      switch (name) {
        case 'tajawal':
          return $tajawal;
        case 'cairo':
          return $cairo;
        case 'almarai':
          return $almarai;
        case 'amiri':
          return $amiri;
        case 'vazirmatn':
          return $vazirmatn;
        case 'readex_pro':
          return $readexPro;
        case 'noto_sans_arabic':
          return $notoSans;
        case 'ibm_plex_sans_arabic':
          return $ibmPlex;
        default:
          return $tajawal;
      }
    };
  }
  function BaseMugImageEditorScreen$lambda_20($getFontFamily, $emojiFont, $textMeasurer, $density) {
    return function (text, color, fontFamilyName) {
      var selectedFont = $getFontFamily(fontFamilyName);
      var annotatedString = toEmojiAnnotatedString(text, selectedFont, $emojiFont);
      var isArabic = hasArabic(text);
      var direction = isArabic ? LayoutDirection_Rtl_getInstance() : LayoutDirection_Ltr_getInstance();
      var style = TextStyle_init_$Create$(color.c6d_1, get_sp(100), VOID, VOID, Companion_getInstance_28().p7z_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_29().r7u_1);
      var measuredText = $textMeasurer.m81(annotatedString, style, VOID, VOID, VOID, VOID, VOID, direction);
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = measuredText.g80_1;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp$ret$0 = convertToInt(shiftRight(value, 32));
      var width = coerceAtLeast(tmp$ret$0, 1);
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_1 = measuredText.g80_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var height = coerceAtLeast(tmp$ret$2, 1);
      var bitmap = ImageBitmap(width, height);
      var canvas = Canvas(bitmap);
      var canvasDrawScope = new CanvasDrawScope();
      var tmp2 = $density;
      // Inline function 'androidx.compose.ui.geometry.Size' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1 = fromInt(toRawBits(width));
      var v2 = fromInt(toRawBits(height));
      var tmp$ret$5 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.graphics.drawscope.CanvasDrawScope.draw' call
      var size = _Size___init__impl__aywn0g(tmp$ret$5);
      var _destruct__k2r9zo = canvasDrawScope.h6o_1;
      var prevDensity = _destruct__k2r9zo.zh();
      var prevLayoutDirection = _destruct__k2r9zo.ai();
      var prevCanvas = _destruct__k2r9zo.hr();
      var prevSize = _destruct__k2r9zo.j6p();
      // Inline function 'kotlin.apply' call
      var this_2 = canvasDrawScope.h6o_1;
      this_2.f6p_1 = tmp2;
      this_2.g6p_1 = direction;
      this_2.h6p_1 = canvas;
      this_2.i6p_1 = size;
      canvas.t6d();
      drawText(canvasDrawScope, measuredText);
      canvas.u6d();
      // Inline function 'kotlin.apply' call
      var this_3 = canvasDrawScope.h6o_1;
      this_3.f6p_1 = prevDensity;
      this_3.g6p_1 = prevLayoutDirection;
      this_3.h6p_1 = prevCanvas;
      this_3.i6p_1 = prevSize;
      return bitmap;
    };
  }
  function BaseMugImageEditorScreen$slambda($initialElements, $images, $textToBitmap, resultContinuation) {
    this.e12s_1 = $initialElements;
    this.f12s_1 = $images;
    this.g12s_1 = $textToBitmap;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BaseMugImageEditorScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BaseMugImageEditorScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BaseMugImageEditorScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var index = 0;
          var _iterator__ex2g4s = this.e12s_1._v.t();
          while (_iterator__ex2g4s.u()) {
            var item = _iterator__ex2g4s.v();
            var _unary__edvuaz = index;
            index = _unary__edvuaz + 1 | 0;
            var index_0 = checkIndexOverflow(_unary__edvuaz);
            if (!(item.i12g_1 == null) && item.l12g_1) {
              this.f12s_1.mi(index_0, item.m12h(VOID, this.g12s_1(item.i12g_1, new Color_0(item.j12g_1), item.k12g_1), VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, false));
            }
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(BaseMugImageEditorScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new BaseMugImageEditorScreen$slambda(this.e12s_1, this.f12s_1, this.g12s_1, completion);
    i.h12s_1 = $this$LaunchedEffect;
    return i;
  };
  function BaseMugImageEditorScreen$slambda_0($initialElements, $images, $textToBitmap, resultContinuation) {
    var i = new BaseMugImageEditorScreen$slambda($initialElements, $images, $textToBitmap, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function BaseMugImageEditorScreen$lambda$slambda$slambda($bytes, resultContinuation) {
    this.q12s_1 = $bytes;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BaseMugImageEditorScreen$lambda$slambda$slambda).s12s = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BaseMugImageEditorScreen$lambda$slambda$slambda).ja = function (p1, $completion) {
    return this.s12s((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BaseMugImageEditorScreen$lambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var rawBitmap = decodeToImageBitmap(this.q12s_1);
          var bitmap = resize(rawBitmap, 2048);
          var designWidth = 2100.0;
          var designHeight = 950.0;
          var targetWidth = designWidth * 0.5;
          var targetHeight = designHeight * 0.5;
          var tmp0 = targetWidth / bitmap.h5e();
          var b = targetHeight / bitmap.i5e();
          var scale = coerceAtMost(Math.min(tmp0, b), 1.0);
          var tmp0_id = Default_getInstance_0().ci();
          var tmp1_position = Companion_getInstance_24().g5d_1;
          return new EditorImageElement(tmp0_id, bitmap, tmp1_position, scale, scale);
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(BaseMugImageEditorScreen$lambda$slambda$slambda).q24 = function ($this$withContext, completion) {
    var i = new BaseMugImageEditorScreen$lambda$slambda$slambda(this.q12s_1, completion);
    i.r12s_1 = $this$withContext;
    return i;
  };
  function BaseMugImageEditorScreen$lambda$slambda$slambda_0($bytes, resultContinuation) {
    var i = new BaseMugImageEditorScreen$lambda$slambda$slambda($bytes, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.s12s($this$withContext, $completion);
    }, 1);
  }
  function BaseMugImageEditorScreen$lambda$slambda($images, $bytes, $selectedId$delegate, $isProcessing$delegate, resultContinuation) {
    this.b12t_1 = $images;
    this.c12t_1 = $bytes;
    this.d12t_1 = $selectedId$delegate;
    this.e12t_1 = $isProcessing$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BaseMugImageEditorScreen$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BaseMugImageEditorScreen$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BaseMugImageEditorScreen$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.n9_1 = 1;
            suspendResult = yield_0(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 5;
            this.n9_1 = 3;
            var tmp_0 = Dispatchers_getInstance().i1h_1;
            suspendResult = withContext(tmp_0, BaseMugImageEditorScreen$lambda$slambda$slambda_0(this.c12t_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var newImg = suspendResult;
            this.b12t_1.zz(newImg);
            BaseMugImageEditorScreen$lambda_6(this.d12t_1, newImg.z12f_1);
            this.o9_1 = 6;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.o9_1 = 6;
            BaseMugImageEditorScreen$lambda_2(this.e12t_1, false);
            return Unit_instance;
          case 5:
            this.o9_1 = 6;
            var t = this.q9_1;
            BaseMugImageEditorScreen$lambda_2(this.e12t_1, false);
            throw t;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BaseMugImageEditorScreen$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new BaseMugImageEditorScreen$lambda$slambda(this.b12t_1, this.c12t_1, this.d12t_1, this.e12t_1, completion);
    i.f12t_1 = $this$launch;
    return i;
  };
  function BaseMugImageEditorScreen$lambda$slambda_0($images, $bytes, $selectedId$delegate, $isProcessing$delegate, resultContinuation) {
    var i = new BaseMugImageEditorScreen$lambda$slambda($images, $bytes, $selectedId$delegate, $isProcessing$delegate, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function BaseMugImageEditorScreen$lambda_21($scope, $isProcessing$delegate, $images, $selectedId$delegate) {
    return function (bytes) {
      BaseMugImageEditorScreen$lambda_2($isProcessing$delegate, true);
      launch($scope, VOID, VOID, BaseMugImageEditorScreen$lambda$slambda_0($images, bytes, $selectedId$delegate, $isProcessing$delegate, null));
      return Unit_instance;
    };
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3(function_0) {
    this.g12t_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3).ka7 = function (_this__u8e3s4, $completion) {
    return this.g12t_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3).q3 = function () {
    return this.g12t_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3).hashCode = function () {
    return hashCode(this.q3());
  };
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda($handleBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C338@13398L68:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1756597066, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:338)');
        }
        IconButton($handleBack, null, false, null, null, null, ComposableSingletons$MugImageEditorScreenKt_getInstance().g12r_1, $composer_0, 1572864, 62);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda($handleBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C337@13333L33,337@13368L124,337@13319L173:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1620024192, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:337)');
        }
        var tmp_0 = stringResource(get_cancel(string_instance), $composer_0, 0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1756597066, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda($handleBack), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp$ret$0 = tmp_1;
        EditorTooltip(tmp_0, tmp$ret$0, $composer_0, 48);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda$slambda($images, resultContinuation) {
    this.p12t_1 = $images;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda$slambda).r12t = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda$slambda).ja = function (p1, $completion) {
    return this.r12t((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var res = createSimpleSnapshot(this.p12t_1);
          return to(res, toByteArray(res));
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda$slambda).q24 = function ($this$withContext, completion) {
    var i = new BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda$slambda(this.p12t_1, completion);
    i.q12t_1 = $this$withContext;
    return i;
  };
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda$slambda_0($images, resultContinuation) {
    var i = new BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda$slambda($images, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.r12t($this$withContext, $completion);
    }, 1);
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda($onDone, $images, $isProcessing$delegate, resultContinuation) {
    this.a12u_1 = $onDone;
    this.b12u_1 = $images;
    this.c12u_1 = $isProcessing$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.n9_1 = 1;
            suspendResult = yield_0(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 5;
            this.n9_1 = 3;
            var tmp_0 = Dispatchers_getInstance().i1h_1;
            suspendResult = withContext(tmp_0, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda$slambda_0(this.b12u_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var _destruct__k2r9zo = suspendResult;
            var result = _destruct__k2r9zo.zh();
            var bytes = _destruct__k2r9zo.ai();
            this.a12u_1(result, bytes, this.b12u_1.s5c());
            this.o9_1 = 6;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.o9_1 = 6;
            BaseMugImageEditorScreen$lambda_2(this.c12u_1, false);
            return Unit_instance;
          case 5:
            this.o9_1 = 6;
            var t = this.q9_1;
            BaseMugImageEditorScreen$lambda_2(this.c12u_1, false);
            throw t;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda(this.a12u_1, this.b12u_1, this.c12u_1, completion);
    i.d12u_1 = $this$launch;
    return i;
  };
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda_0($onDone, $images, $isProcessing$delegate, resultContinuation) {
    var i = new BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda($onDone, $images, $isProcessing$delegate, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_0($scope, $isProcessing$delegate, $onDone, $images) {
    return function () {
      BaseMugImageEditorScreen$lambda_2($isProcessing$delegate, true);
      launch($scope, VOID, VOID, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$slambda_0($onDone, $images, $isProcessing$delegate, null));
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda_0($scope, $onDone, $isProcessing$delegate, $images) {
    return function ($this$TopAppBar, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C343@13618L801,342@13572L1094:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1806378231, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:342)');
        }
        var tmp0_enabled = !BaseMugImageEditorScreen$lambda_1($isProcessing$delegate);
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
        var tmp1_modifier = padding_1(tmp_0, VOID, VOID, tmp$ret$0);
        sourceInformationMarkerStart($composer_0, 762695512, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.q31($scope) | $composer_0.k31($onDone));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_0($scope, $isProcessing$delegate, $onDone, $images);
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp0_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        Button(tmp0_group, tmp1_modifier, tmp0_enabled, null, null, null, null, null, null, ComposableSingletons$MugImageEditorScreenKt_getInstance().h12r_1, $composer_0, 805306416, 504);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda($handleBack, $scope, $onDone, $isProcessing$delegate, $images) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C336@13293L221,341@13546L1142,334@13160L1546:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1362557318, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous> (MugImageEditorScreen.kt:334)');
        }
        var tmp_0 = ComposableSingletons$MugImageEditorScreenKt_getInstance().f12r_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1620024192, true, BaseMugImageEditorScreen$lambda$lambda$lambda($handleBack), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp_2 = tmp_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(1806378231, true, BaseMugImageEditorScreen$lambda$lambda$lambda_0($scope, $onDone, $isProcessing$delegate, $images), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_2.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_2.i31();
        var tmp_3;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver_0);
          $composer_2.j31(value_0);
          tmp_3 = value_0;
        } else {
          tmp_3 = it_0;
        }
        var tmp_4 = tmp_3;
        var tmp_5 = _Dp___init__impl__ms3zkb(0.0);
        TopAppBar(tmp_0, null, tmp_2, tmp_4, tmp_5, null, null, null, $composer_0, 3462, 242);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_1($showSettings$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_8($showSettings$delegate, false);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$lambda($selectedId$delegate) {
    return function (it) {
      return it.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate));
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_2($images, $selectedId$delegate) {
    return function () {
      removeAll($images, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$lambda($selectedId$delegate));
      BaseMugImageEditorScreen$lambda_6($selectedId$delegate, null);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_3($currentSelected, $textToEdit$delegate, $showTextDialog$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_12($textToEdit$delegate, $currentSelected);
      BaseMugImageEditorScreen$lambda_10($showTextDialog$delegate, true);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_4($currentSelected) {
    return function ($this$TextButton, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C401@17602L10,401@17539L84,402@17668L28,403@17741L63:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(989013798, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:401)');
        }
        var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text($currentSelected.i12g_1, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 1, 0, null, MaterialTheme_instance.jog($composer_0, 6).qof_1, $composer_0, 0, 24576, 114686);
        var tmp_5 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(4);
        Spacer(width(tmp_5, tmp$ret$0), $composer_0, 6);
        var tmp_6 = get_Edit(Icons_getInstance().dxv_1);
        var tmp_7 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(12);
        var tmp_8 = size(tmp_7, tmp$ret$1);
        Icon(tmp_6, null, tmp_8, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 432, 8);
        var tmp_9;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_9 = Unit_instance;
        }
        tmp = tmp_9;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_5($images, $textToBitmap, $currentSelected, $color, $selectedId$delegate) {
    return function () {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        var bitmap = $textToBitmap($currentSelected.i12g_1, new Color_0($color), $currentSelected.k12g_1);
        $images.mi(i, $images.l1(i).m12h(VOID, bitmap, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $color));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$lambda_0($images, $textToBitmap, $currentSelected, $selectedId$delegate) {
    return function (newColor) {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        var bitmap = $textToBitmap($currentSelected.i12g_1, newColor, $currentSelected.k12g_1);
        $images.mi(i, $images.l1(i).m12h(VOID, bitmap, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, newColor.c6d_1));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_6($currentSelected, $initialColorForPicker$delegate, $images, $textToBitmap, $selectedId$delegate, $colorToEdit$delegate, $showColorPicker$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_18($initialColorForPicker$delegate, $currentSelected.j12g_1);
      BaseMugImageEditorScreen$lambda_16($colorToEdit$delegate, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$lambda_0($images, $textToBitmap, $currentSelected, $selectedId$delegate));
      BaseMugImageEditorScreen$lambda_14($showColorPicker$delegate, true);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_7($images, $textToBitmap, $currentSelected, $font, $selectedId$delegate) {
    return function () {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        var bitmap = $textToBitmap($currentSelected.i12g_1, new Color_0($currentSelected.j12g_1), $font);
        $images.mi(i, $images.l1(i).m12h(VOID, bitmap, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $font));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_8($getFontFamily, $font) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C441@21827L10,441@21794L89:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(687759434, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:441)');
        }
        var tmp0_style = MaterialTheme_instance.jog($composer_0, 6).tof_1;
        var tmp1_fontFamily = $getFontFamily($font);
        var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text($font, null, tmp_0, null, tmp_1, null, null, tmp1_fontFamily, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, tmp0_style, $composer_0, 0, 0, 130942);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_9($images, $filter, $selectedId$delegate) {
    return function () {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        $images.mi(i, $images.l1(i).m12h(VOID, VOID, VOID, VOID, VOID, VOID, $filter));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_10($filter) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C453@22989L10,453@22949L62:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-933259336, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:453)');
        }
        var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text($filter.z_1, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 0, 0, 131070);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_11($images, $selectedId$delegate) {
    return function () {
      // Inline function 'kotlin.collections.find' call
      var tmp0 = $images;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          if (element.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var item = tmp$ret$1;
      var tmp;
      if (!(item == null)) {
        $images.g10(item);
        $images.ni(0, item);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$lambda_1($this$graphicsLayer) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    $this$graphicsLayer.f67(180.0);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_12($iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C465@23934L20,465@23852L103:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-443133815, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:465)');
        }
        var tmp_0 = get_Layers(Icons_getInstance().dxv_1);
        var tmp_1 = size(Companion_instance, $iconSize);
        sourceInformationMarkerStart($composer_0, -649829923, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_2;
        if (false || it === Companion_getInstance().f30_1) {
          var value = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$lambda_1;
          $composer_0.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        var tmp_3 = graphicsLayer(tmp_1, tmp0_group);
        Icon(tmp_0, null, tmp_3, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 432, 8);
        var tmp_4;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_4 = Unit_instance;
        }
        tmp = tmp_4;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_13($images, $selectedId$delegate) {
    return function () {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        $images.mi(i, $images.l1(i).m12h(VOID, VOID, Companion_getInstance_24().g5d_1));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_14($iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C468@24250L79:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1972436942, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:468)');
        }
        var tmp_0 = get_CenterFocusStrong(Icons_getInstance().dxv_1);
        var tmp_1 = size(Companion_instance, $iconSize);
        Icon(tmp_0, null, tmp_1, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 432, 8);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_15($images, $selectedId$delegate) {
    return function () {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        var img = $images.l1(i);
        var tmp0_0 = 2100.0 / img.a12g_1.h5e();
        // Inline function 'kotlin.comparisons.minOf' call
        var b = 950.0 / img.a12g_1.i5e();
        var tmp$ret$2 = Math.min(tmp0_0, b);
        var scale = coerceIn(tmp$ret$2, 0.05, 5.0);
        var tmp0_position = Companion_getInstance_24().g5d_1;
        $images.mi(i, img.m12h(VOID, VOID, tmp0_position, scale, scale, 0.0));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_16($iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C471@24781L71:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-591276655, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:471)');
        }
        var tmp_0 = get_FitScreen(Icons_getInstance().dxv_1);
        var tmp_1 = size(Companion_instance, $iconSize);
        Icon(tmp_0, null, tmp_1, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 432, 8);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_17($images, $selectedId$delegate) {
    return function () {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        $images.mi(i, $images.l1(i).m12h(VOID, VOID, VOID, VOID, VOID, VOID, VOID, !$images.l1(i).g12g_1));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_18($iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C474@25149L66:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(789883632, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:474)');
        }
        var tmp_0 = get_Flip(Icons_getInstance().dxv_1);
        var tmp_1 = size(Companion_instance, $iconSize);
        Icon(tmp_0, null, tmp_1, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 432, 8);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_19($images, $selectedId$delegate) {
    return function () {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        $images.mi(i, $images.l1(i).m12h(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, !$images.l1(i).h12g_1));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$lambda_2($this$graphicsLayer) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    $this$graphicsLayer.f67(90.0);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_20($iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C477@25577L19,477@25512L100:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2123923377, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:477)');
        }
        var tmp_0 = get_Flip(Icons_getInstance().dxv_1);
        var tmp_1 = Companion_instance;
        sourceInformationMarkerStart($composer_0, -980896254, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_2;
        if (false || it === Companion_getInstance().f30_1) {
          var value = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$lambda_2;
          $composer_0.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_0);
        var tmp_3 = size(graphicsLayer(tmp_1, tmp0_group), $iconSize);
        Icon(tmp_0, null, tmp_3, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 432, 8);
        var tmp_4;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_4 = Unit_instance;
        }
        tmp = tmp_4;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_21($images, $selectedId$delegate) {
    return function () {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        var img = $images.l1(i);
        var tmp0_position = Companion_getInstance_24().g5d_1;
        $images.mi(i, img.m12h(VOID, VOID, tmp0_position, 0.5, 0.5, 0.0, VOID, false, false));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_22($iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C480@26001L69:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-742763090, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:480)');
        }
        var tmp_0 = get_Refresh(Icons_getInstance().dxv_1);
        var tmp_1 = size(Companion_instance, $iconSize);
        Icon(tmp_0, null, tmp_1, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 432, 8);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_23($images, $selectedId$delegate) {
    return function () {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        $images.mi(i, $images.l1(i).m12h(VOID, VOID, VOID, VOID, VOID, $images.l1(i).e12g_1 - 90.0));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_24($iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C483@26378L84:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(638397197, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:483)');
        }
        var tmp_0 = get_RotateLeft(Filled_instance_0);
        var tmp_1 = size(Companion_instance, $iconSize);
        Icon(tmp_0, null, tmp_1, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 432, 8);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_25($images, $selectedId$delegate) {
    return function () {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        $images.mi(i, $images.l1(i).m12h(VOID, VOID, VOID, VOID, VOID, $images.l1(i).e12g_1 + 90.0));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_26($iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C486@26770L85:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2019557484, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:486)');
        }
        var tmp_0 = get_RotateRight(Filled_instance_0);
        var tmp_1 = size(Companion_instance, $iconSize);
        Icon(tmp_0, null, tmp_1, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 432, 8);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_27($images, $selectedId$delegate) {
    return function (it) {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        $images.mi(i, $images.l1(i).m12h(VOID, VOID, VOID, it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_28($images, $selectedId$delegate) {
    return function (it) {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        $images.mi(i, $images.l1(i).m12h(VOID, VOID, VOID, VOID, it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_29($images, $selectedId$delegate) {
    return function (it) {
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (item.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var i = tmp$ret$0;
      var tmp;
      if (!(i === -1)) {
        $images.mi(i, $images.l1(i).m12h(VOID, VOID, VOID, VOID, VOID, it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda_1($currentSelected, $textToBitmap, $showSettings$delegate, $images, $selectedId$delegate, $textToEdit$delegate, $showTextDialog$delegate, $initialColorForPicker$delegate, $colorToEdit$delegate, $showColorPicker$delegate, $getFontFamily) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C382@15636L21,378@15383L13344:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(827875160, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:378)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_1 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(4);
        var tmp_2 = padding_2(tmp_0, tmp_1, tmp$ret$1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$2 = _Dp___init__impl__ms3zkb(220);
        var tmp_3 = heightIn(tmp_2, VOID, tmp$ret$2);
        var tmp0 = verticalScroll(tmp_3, rememberScrollState(0, $composer_0, 0, 1));
        var tmp_4 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$3 = _Dp___init__impl__ms3zkb(4);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = tmp0;
        var verticalArrangement = tmp_4.mdq(tmp$ret$3);
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((4 & 1) === 0))
          modifier = Companion_instance;
        if (!((4 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((4 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_5 = $composer_3.g30();
        if (!isInterface(tmp_5, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0_0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 555330565, 'C385@15805L1188,459@23294L11,459@23208L113,461@23411L21,461@23355L3572,490@27047L11,490@26961L113,492@27108L505,496@27646L506,500@28185L512:MugImageEditorScreen.kt#mu900e');
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_1 = fillMaxWidth(Companion_instance);
        var horizontalArrangement = Arrangement_getInstance().wdp_1;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_6 = $composer_5;
        if (!((0 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_6, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_6 = $composer_8.g30();
        if (!isInterface(tmp_6, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_1);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 1477889843, 'C386@15981L637,392@16676L63,392@16655L304:MugImageEditorScreen.kt#mu900e');
        var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_7 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$16 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_3 = null;
        var horizontalArrangement_0 = tmp_7.mdq(tmp$ret$16);
        var verticalAlignment_0 = tmp0_verticalAlignment;
        var $composer_11 = $composer_10;
        if (!((1 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((1 & 2) === 0))
          horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
        if (!((1 & 4) === 0))
          verticalAlignment_0 = Companion_getInstance_11().t8t_1;
        var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_11, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_12 = $composer_11;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
        var localMap_1 = $composer_12.t31();
        var materialized_1 = materialize($composer_12, modifier_4);
        var tmp0_2 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_13 = $composer_12;
        var tmp_8 = $composer_13.g30();
        if (!isInterface(tmp_8, Applier)) {
          invalidApplier();
        }
        $composer_13.b31();
        if ($composer_13.h30()) {
          $composer_13.c31(tmp0_2);
        } else {
          $composer_13.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_14 = $composer_13;
        var $composer_15 = $composer_14;
        sourceInformationMarkerStart($composer_15, 1451345540, 'C387@16148L24,387@16127L240,390@16558L10,390@16408L172:MugImageEditorScreen.kt#mu900e');
        sourceInformationMarkerStart($composer_15, 1155196498, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_15.i31();
        var tmp_9;
        if (false || it === Companion_getInstance().f30_1) {
          var value = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_1($showSettings$delegate);
          $composer_15.j31(value);
          tmp_9 = value;
        } else {
          tmp_9 = it;
        }
        var tmp0_group = tmp_9;
        sourceInformationMarkerEnd($composer_15);
        var tmp_10 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$27 = _Dp___init__impl__ms3zkb(28);
        var tmp_11 = size(tmp_10, tmp$ret$27);
        IconButton(tmp0_group, tmp_11, false, null, null, null, ComposableSingletons$MugImageEditorScreenKt_getInstance().i12r_1, $composer_15, 1572918, 60);
        var tmp_12;
        if (!($currentSelected.i12g_1 == null)) {
          $composer_15.m30(1155206082);
          sourceInformation($composer_15, '390@16447L40');
          var tmp1_group = stringResource(get_text_settings(string_instance), $composer_15, 0);
          $composer_15.n30();
          tmp_12 = tmp1_group;
        } else {
          $composer_15.m30(1155207555);
          sourceInformation($composer_15, '390@16493L41');
          var tmp2_group = stringResource(get_image_settings(string_instance), $composer_15, 0);
          $composer_15.n30();
          tmp_12 = tmp2_group;
        }
        var tmp_13 = tmp_12;
        var tmp_14 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_15 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_17 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_18 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_13, null, tmp_14, null, tmp_15, null, null, null, tmp_16, null, null, tmp_17, tmp_18, false, 0, 0, null, MaterialTheme_instance.jog($composer_15, 6).nof_1, $composer_15, 0, 0, 131070);
        sourceInformationMarkerEnd($composer_15);
        $composer_13.e31();
        sourceInformationMarkerStart($composer_10, -1891967459, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_0 = $composer_10.i31();
        var tmp_19;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var value_0 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_2($images, $selectedId$delegate);
          $composer_10.j31(value_0);
          tmp_19 = value_0;
        } else {
          tmp_19 = it_0;
        }
        var tmp0_group_0 = tmp_19;
        sourceInformationMarkerEnd($composer_10);
        var tmp_20 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$32 = _Dp___init__impl__ms3zkb(28);
        var tmp_21 = size(tmp_20, tmp$ret$32);
        IconButton(tmp0_group_0, tmp_21, false, null, null, null, ComposableSingletons$MugImageEditorScreenKt_getInstance().j12r_1, $composer_10, 1572918, 60);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        if (!($currentSelected.i12g_1 == null)) {
          $composer_5.m30(556331399);
          sourceInformation($composer_5, '398@17099L785,406@17921L2603,431@20561L1451');
          var tmp0_verticalAlignment_0 = Companion_getInstance_11().u8t_1;
          var tmp_22 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$33 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_5 = null;
          var horizontalArrangement_1 = tmp_22.mdq(tmp$ret$33);
          var verticalAlignment_1 = tmp0_verticalAlignment_0;
          var $composer_16 = $composer_5;
          if (!((1 & 1) === 0))
            modifier_5 = Companion_instance;
          if (!((1 & 2) === 0))
            horizontalArrangement_1 = Arrangement_getInstance().qdp_1;
          if (!((1 & 4) === 0))
            verticalAlignment_1 = Companion_getInstance_11().t8t_1;
          var measurePolicy_2 = rowMeasurePolicy(horizontalArrangement_1, verticalAlignment_1, $composer_16, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_6 = modifier_5;
          var $composer_17 = $composer_16;
          if (!((0 & 2) === 0))
            modifier_6 = Companion_instance;
          var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
          var localMap_2 = $composer_17.t31();
          var materialized_2 = materialize($composer_17, modifier_6);
          var tmp0_3 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_18 = $composer_17;
          var tmp_23 = $composer_18.g30();
          if (!isInterface(tmp_23, Applier)) {
            invalidApplier();
          }
          $composer_18.b31();
          if ($composer_18.h30()) {
            $composer_18.c31(tmp0_3);
          } else {
            $composer_18.d31();
          }
          var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_18);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
          var $composer_19 = $composer_18;
          var $composer_20 = $composer_19;
          sourceInformationMarkerStart($composer_20, -1092360857, 'C399@17250L40,399@17314L10,399@17245L91,400@17398L55,400@17493L353,400@17377L469:MugImageEditorScreen.kt#mu900e');
          var tmp_24 = stringResource(get_content_label(string_instance), $composer_20, 0);
          var tmp_25 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_26 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_27 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_28 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_29 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_24, null, tmp_25, null, tmp_26, null, null, null, tmp_27, null, null, tmp_28, tmp_29, false, 0, 0, null, MaterialTheme_instance.jog($composer_20, 6).tof_1, $composer_20, 0, 0, 131070);
          sourceInformationMarkerStart($composer_20, -1005064422, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_20.q31($currentSelected);
          // Inline function 'kotlin.let' call
          var it_1 = $composer_20.i31();
          var tmp_30;
          if (invalid || it_1 === Companion_getInstance().f30_1) {
            var value_1 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_3($currentSelected, $textToEdit$delegate, $showTextDialog$delegate);
            $composer_20.j31(value_1);
            tmp_30 = value_1;
          } else {
            tmp_30 = it_1;
          }
          var tmp0_group_1 = tmp_30;
          sourceInformationMarkerEnd($composer_20);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$44 = _Dp___init__impl__ms3zkb(0);
          var tmp_31 = PaddingValues_1(tmp$ret$44);
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(989013798, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_4($currentSelected), $composer_20, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_21 = $composer_20;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = $composer_21.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_2 = $composer_21.i31();
          var tmp_32;
          if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
            var value_2 = ComposableLambda$invoke$ref_1(dispatchReceiver);
            $composer_21.j31(value_2);
            tmp_32 = value_2;
          } else {
            tmp_32 = it_2;
          }
          var tmp$ret$45 = tmp_32;
          TextButton(tmp0_group_1, null, false, null, null, null, null, tmp_31, null, tmp$ret$45, $composer_20, 817889280, 382);
          sourceInformationMarkerEnd($composer_20);
          $composer_18.e31();
          var tmp2_verticalAlignment = Companion_getInstance_11().u8t_1;
          var tmp_33 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$52 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_7 = null;
          var horizontalArrangement_2 = tmp_33.mdq(tmp$ret$52);
          var verticalAlignment_2 = tmp2_verticalAlignment;
          var $composer_22 = $composer_5;
          if (!((1 & 1) === 0))
            modifier_7 = Companion_instance;
          if (!((1 & 2) === 0))
            horizontalArrangement_2 = Arrangement_getInstance().qdp_1;
          if (!((1 & 4) === 0))
            verticalAlignment_2 = Companion_getInstance_11().t8t_1;
          var measurePolicy_3 = rowMeasurePolicy(horizontalArrangement_2, verticalAlignment_2, $composer_22, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_8 = modifier_7;
          var $composer_23 = $composer_22;
          if (!((0 & 2) === 0))
            modifier_8 = Companion_instance;
          var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_23, 0).hashCode();
          var localMap_3 = $composer_23.t31();
          var materialized_3 = materialize($composer_23, modifier_8);
          var tmp0_4 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_24 = $composer_23;
          var tmp_34 = $composer_24.g30();
          if (!isInterface(tmp_34, Applier)) {
            invalidApplier();
          }
          $composer_24.b31();
          if ($composer_24.h30()) {
            $composer_24.c31(tmp0_4);
          } else {
            $composer_24.d31();
          }
          var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_24);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
          var $composer_25 = $composer_24;
          var $composer_26 = $composer_25;
          sourceInformationMarkerStart($composer_26, 208444676, 'C407@18072L40,407@18136L10,407@18067L91,408@18229L21,408@18199L2287:MugImageEditorScreen.kt#mu900e');
          var tmp_35 = stringResource(get_color_setting(string_instance), $composer_26, 0);
          var tmp_36 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_37 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_38 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_39 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_40 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_35, null, tmp_36, null, tmp_37, null, null, null, tmp_38, null, null, tmp_39, tmp_40, false, 0, 0, null, MaterialTheme_instance.jog($composer_26, 6).tof_1, $composer_26, 0, 0, 131070);
          var tmp_41 = Companion_instance;
          var tmp0_5 = horizontalScroll(tmp_41, rememberScrollState(0, $composer_26, 0, 1));
          var tmp_42 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$59 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_9 = tmp0_5;
          var horizontalArrangement_3 = tmp_42.mdq(tmp$ret$59);
          var verticalAlignment_3 = null;
          var $composer_27 = $composer_26;
          if (!((4 & 1) === 0))
            modifier_9 = Companion_instance;
          if (!((4 & 2) === 0))
            horizontalArrangement_3 = Arrangement_getInstance().qdp_1;
          if (!((4 & 4) === 0))
            verticalAlignment_3 = Companion_getInstance_11().t8t_1;
          var measurePolicy_4 = rowMeasurePolicy(horizontalArrangement_3, verticalAlignment_3, $composer_27, 14 & 48 >> 3 | 112 & 48 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_10 = modifier_9;
          var $composer_28 = $composer_27;
          if (!((0 & 2) === 0))
            modifier_10 = Companion_instance;
          var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_28, 0).hashCode();
          var localMap_4 = $composer_28.t31();
          var materialized_4 = materialize($composer_28, modifier_10);
          var tmp0_6 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_29 = $composer_28;
          var tmp_43 = $composer_29.g30();
          if (!isInterface(tmp_43, Applier)) {
            invalidApplier();
          }
          $composer_29.b31();
          if ($composer_29.h30()) {
            $composer_29.c31(tmp0_6);
          } else {
            $composer_29.d31();
          }
          var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_29);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
          var $composer_30 = $composer_29;
          var $composer_31 = $composer_30;
          sourceInformationMarkerStart($composer_31, -477907346, 'C418@19484L835,418@19308L1136:MugImageEditorScreen.kt#mu900e');
          $composer_31.m30(-985246299);
          sourceInformation($composer_31, '*410@18634L11,410@18678L538,410@18501L716');
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = listOf_0([new Color_0(Companion_getInstance_14().i6b_1), new Color_0(Companion_getInstance_14().n6b_1), new Color_0(Companion_getInstance_14().p6b_1), new Color_0(Companion_getInstance_14().o6b_1), new Color_0(Companion_getInstance_14().q6b_1), new Color_0(Companion_getInstance_14().m6b_1)]).t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            var color = element.c6d_1;
            var tmp_44 = Companion_instance;
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$68 = _Dp___init__impl__ms3zkb(22);
            var tmp_45 = background(size(tmp_44, tmp$ret$68), color, get_CircleShape());
            var tmp_46;
            if (equals($currentSelected.j12g_1, color)) {
              // Inline function 'androidx.compose.ui.unit.dp' call
              tmp_46 = _Dp___init__impl__ms3zkb(2);
            } else {
              // Inline function 'androidx.compose.ui.unit.dp' call
              tmp_46 = _Dp___init__impl__ms3zkb(0);
            }
            var tmp_47 = border(tmp_45, tmp_46, MaterialTheme_instance.unz($composer_31, 6).xnz_1, get_CircleShape());
            sourceInformationMarkerStart($composer_31, -1582430698, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_1 = !!(!!($composer_31.k31($textToBitmap) | $composer_31.q31($currentSelected)) | $composer_31.o31(_ULong___get_data__impl__fggpzb(_Color___get_value__impl__1pls5m(color))));
            // Inline function 'kotlin.let' call
            var it_3 = $composer_31.i31();
            var tmp_48;
            if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
              var value_3 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_5($images, $textToBitmap, $currentSelected, color, $selectedId$delegate);
              $composer_31.j31(value_3);
              tmp_48 = value_3;
            } else {
              tmp_48 = it_3;
            }
            var tmp0_group_2 = tmp_48;
            sourceInformationMarkerEnd($composer_31);
            Box(clickable(tmp_47, VOID, VOID, VOID, VOID, tmp0_group_2), $composer_31, 0);
          }
          $composer_31.n30();
          var tmp_49 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$75 = _Dp___init__impl__ms3zkb(22);
          var tmp_50 = background_0(size(tmp_49, tmp$ret$75), Companion_instance_1.h6c(listOf_0([new Color_0(Companion_getInstance_14().n6b_1), new Color_0(Companion_getInstance_14().q6b_1), new Color_0(Companion_getInstance_14().o6b_1), new Color_0(Companion_getInstance_14().r6b_1), new Color_0(Companion_getInstance_14().p6b_1), new Color_0(Companion_getInstance_14().s6b_1), new Color_0(Companion_getInstance_14().n6b_1)])), get_CircleShape());
          sourceInformationMarkerStart($composer_31, -985212693, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_2 = !!($composer_31.q31($currentSelected) | $composer_31.k31($textToBitmap));
          // Inline function 'kotlin.let' call
          var it_4 = $composer_31.i31();
          var tmp_51;
          if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
            var value_4 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_6($currentSelected, $initialColorForPicker$delegate, $images, $textToBitmap, $selectedId$delegate, $colorToEdit$delegate, $showColorPicker$delegate);
            $composer_31.j31(value_4);
            tmp_51 = value_4;
          } else {
            tmp_51 = it_4;
          }
          var tmp0_group_3 = tmp_51;
          sourceInformationMarkerEnd($composer_31);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_11 = clickable(tmp_50, VOID, VOID, VOID, VOID, tmp0_group_3);
          var contentAlignment = Companion_getInstance_11().o8t_1;
          var propagateMinConstraints = false;
          var $composer_32 = $composer_31;
          if (!((4 & 1) === 0))
            modifier_11 = Companion_instance;
          if (!((4 & 2) === 0))
            contentAlignment = Companion_getInstance_11().k8t_1;
          if (!((4 & 4) === 0))
            propagateMinConstraints = false;
          var measurePolicy_5 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_12 = modifier_11;
          var $composer_33 = $composer_32;
          if (!((0 & 2) === 0))
            modifier_12 = Companion_instance;
          var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_33, 0).hashCode();
          var localMap_5 = $composer_33.t31();
          var materialized_5 = materialize($composer_33, modifier_12);
          var tmp0_7 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_34 = $composer_33;
          var tmp_52 = $composer_34.g30();
          if (!isInterface(tmp_52, Applier)) {
            invalidApplier();
          }
          $composer_34.b31();
          if ($composer_34.h30()) {
            $composer_34.c31(tmp0_7);
          } else {
            $composer_34.d31();
          }
          var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_34);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
          var $composer_35 = $composer_34;
          var $composer_36 = $composer_35;
          sourceInformationMarkerStart($composer_36, 523089007, 'C428@20360L82:MugImageEditorScreen.kt#mu900e');
          var tmp_53 = get_Add(Icons_getInstance().dxv_1);
          var tmp_54 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$86 = _Dp___init__impl__ms3zkb(10);
          Icon(tmp_53, null, size(tmp_54, tmp$ret$86), Companion_getInstance_14().m6b_1, $composer_36, 3504, 0);
          sourceInformationMarkerEnd($composer_36);
          $composer_34.e31();
          sourceInformationMarkerEnd($composer_31);
          $composer_29.e31();
          sourceInformationMarkerEnd($composer_26);
          $composer_24.e31();
          var tmp4_verticalAlignment = Companion_getInstance_11().u8t_1;
          var tmp_55 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$87 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_13 = null;
          var horizontalArrangement_4 = tmp_55.mdq(tmp$ret$87);
          var verticalAlignment_4 = tmp4_verticalAlignment;
          var $composer_37 = $composer_5;
          if (!((1 & 1) === 0))
            modifier_13 = Companion_instance;
          if (!((1 & 2) === 0))
            horizontalArrangement_4 = Arrangement_getInstance().qdp_1;
          if (!((1 & 4) === 0))
            verticalAlignment_4 = Companion_getInstance_11().t8t_1;
          var measurePolicy_6 = rowMeasurePolicy(horizontalArrangement_4, verticalAlignment_4, $composer_37, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_14 = modifier_13;
          var $composer_38 = $composer_37;
          if (!((0 & 2) === 0))
            modifier_14 = Companion_instance;
          var compositeKeyHash_6 = get_currentCompositeKeyHashCode($composer_38, 0).hashCode();
          var localMap_6 = $composer_38.t31();
          var materialized_6 = materialize($composer_38, modifier_14);
          var tmp0_8 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_39 = $composer_38;
          var tmp_56 = $composer_39.g30();
          if (!isInterface(tmp_56, Applier)) {
            invalidApplier();
          }
          $composer_39.b31();
          if ($composer_39.h30()) {
            $composer_39.c31(tmp0_8);
          } else {
            $composer_39.d31();
          }
          var $this$ReusableComposeNode_6 = _Updater___init__impl__rbfxm8($composer_39);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, measurePolicy_6, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, localMap_6, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, compositeKeyHash_6, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_6, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, materialized_6, Companion_getInstance_12().qah_1);
          var $composer_40 = $composer_39;
          var $composer_41 = $composer_40;
          sourceInformationMarkerStart($composer_41, 1041339525, 'C432@20712L39,432@20775L10,432@20707L90,433@20868L21,433@20838L1136:MugImageEditorScreen.kt#mu900e');
          var tmp_57 = stringResource(get_font_setting(string_instance), $composer_41, 0);
          var tmp_58 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_59 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_60 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_61 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_62 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_57, null, tmp_58, null, tmp_59, null, null, null, tmp_60, null, null, tmp_61, tmp_62, false, 0, 0, null, MaterialTheme_instance.jog($composer_41, 6).tof_1, $composer_41, 0, 0, 131070);
          var tmp_63 = Companion_instance;
          var tmp0_9 = horizontalScroll(tmp_63, rememberScrollState(0, $composer_41, 0, 1));
          var tmp_64 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$94 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_15 = tmp0_9;
          var horizontalArrangement_5 = tmp_64.mdq(tmp$ret$94);
          var verticalAlignment_5 = null;
          var $composer_42 = $composer_41;
          if (!((4 & 1) === 0))
            modifier_15 = Companion_instance;
          if (!((4 & 2) === 0))
            horizontalArrangement_5 = Arrangement_getInstance().qdp_1;
          if (!((4 & 4) === 0))
            verticalAlignment_5 = Companion_getInstance_11().t8t_1;
          var measurePolicy_7 = rowMeasurePolicy(horizontalArrangement_5, verticalAlignment_5, $composer_42, 14 & 48 >> 3 | 112 & 48 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_16 = modifier_15;
          var $composer_43 = $composer_42;
          if (!((0 & 2) === 0))
            modifier_16 = Companion_instance;
          var compositeKeyHash_7 = get_currentCompositeKeyHashCode($composer_43, 0).hashCode();
          var localMap_7 = $composer_43.t31();
          var materialized_7 = materialize($composer_43, modifier_16);
          var tmp0_10 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_44 = $composer_43;
          var tmp_65 = $composer_44.g30();
          if (!isInterface(tmp_65, Applier)) {
            invalidApplier();
          }
          $composer_44.b31();
          if ($composer_44.h30()) {
            $composer_44.c31(tmp0_10);
          } else {
            $composer_44.d31();
          }
          var $this$ReusableComposeNode_7 = _Updater___init__impl__rbfxm8($composer_44);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, measurePolicy_7, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, localMap_7, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, compositeKeyHash_7, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_7, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_7, materialized_7, Companion_getInstance_12().qah_1);
          var $composer_45 = $composer_44;
          var $composer_46 = $composer_45;
          sourceInformationMarkerStart($composer_46, 354987534, 'C:MugImageEditorScreen.kt#mu900e');
          $composer_46.m30(-1789660449);
          sourceInformation($composer_46, '*435@21246L536,441@21792L93,435@21174L712');
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_0 = listOf_0(['tajawal', 'cairo', 'noto_sans_arabic', 'vazirmatn', 'ibm_plex_sans_arabic', 'readex_pro', 'amiri', 'almarai']).t();
          while (_iterator__ex2g4s_0.u()) {
            var element_0 = _iterator__ex2g4s_0.v();
            var tmp_66 = $currentSelected.k12g_1 === element_0;
            sourceInformationMarkerStart($composer_46, 2053790511, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_3 = !!(!!($composer_46.k31($textToBitmap) | $composer_46.q31($currentSelected)) | $composer_46.k31(element_0));
            // Inline function 'kotlin.let' call
            var it_5 = $composer_46.i31();
            var tmp_67;
            if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
              var value_5 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_7($images, $textToBitmap, $currentSelected, element_0, $selectedId$delegate);
              $composer_46.j31(value_5);
              tmp_67 = value_5;
            } else {
              tmp_67 = it_5;
            }
            var tmp0_group_4 = tmp_67;
            sourceInformationMarkerEnd($composer_46);
            // Inline function 'kotlin.run' call
            var dispatchReceiver_0 = rememberComposableLambda(687759434, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_8($getFontFamily, element_0), $composer_46, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_47 = $composer_46;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_4 = $composer_47.k31(dispatchReceiver_0);
            // Inline function 'kotlin.let' call
            var it_6 = $composer_47.i31();
            var tmp_68;
            if (invalid_4 || it_6 === Companion_getInstance().f30_1) {
              var value_6 = ComposableLambda$invoke$ref(dispatchReceiver_0);
              $composer_47.j31(value_6);
              tmp_68 = value_6;
            } else {
              tmp_68 = it_6;
            }
            var tmp_69 = tmp_68;
            FilterChip(tmp_66, tmp0_group_4, tmp_69, null, false, null, null, null, null, null, null, null, $composer_46, 384, 0, 4088);
          }
          $composer_46.n30();
          sourceInformationMarkerEnd($composer_46);
          $composer_44.e31();
          sourceInformationMarkerEnd($composer_41);
          $composer_39.e31();
          $composer_5.n30();
        } else {
          $composer_5.m30(561198182);
          sourceInformation($composer_5, '446@22090L1050');
          var tmp6_verticalAlignment = Companion_getInstance_11().u8t_1;
          var tmp_70 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$114 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_17 = null;
          var horizontalArrangement_6 = tmp_70.mdq(tmp$ret$114);
          var verticalAlignment_6 = tmp6_verticalAlignment;
          var $composer_48 = $composer_5;
          if (!((1 & 1) === 0))
            modifier_17 = Companion_instance;
          if (!((1 & 2) === 0))
            horizontalArrangement_6 = Arrangement_getInstance().qdp_1;
          if (!((1 & 4) === 0))
            verticalAlignment_6 = Companion_getInstance_11().t8t_1;
          var measurePolicy_8 = rowMeasurePolicy(horizontalArrangement_6, verticalAlignment_6, $composer_48, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_18 = modifier_17;
          var $composer_49 = $composer_48;
          if (!((0 & 2) === 0))
            modifier_18 = Companion_instance;
          var compositeKeyHash_8 = get_currentCompositeKeyHashCode($composer_49, 0).hashCode();
          var localMap_8 = $composer_49.t31();
          var materialized_8 = materialize($composer_49, modifier_18);
          var tmp0_11 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_50 = $composer_49;
          var tmp_71 = $composer_50.g30();
          if (!isInterface(tmp_71, Applier)) {
            invalidApplier();
          }
          $composer_50.b31();
          if ($composer_50.h30()) {
            $composer_50.c31(tmp0_11);
          } else {
            $composer_50.d31();
          }
          var $this$ReusableComposeNode_8 = _Updater___init__impl__rbfxm8($composer_50);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, measurePolicy_8, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, localMap_8, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, compositeKeyHash_8, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_8, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, materialized_8, Companion_getInstance_12().qah_1);
          var $composer_51 = $composer_50;
          var $composer_52 = $composer_51;
          sourceInformationMarkerStart($composer_52, -1934996025, 'C447@22241L40,447@22305L10,447@22236L91,448@22398L21,448@22368L734:MugImageEditorScreen.kt#mu900e');
          var tmp_72 = stringResource(get_filters_label(string_instance), $composer_52, 0);
          var tmp_73 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_74 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_75 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_76 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_77 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_72, null, tmp_73, null, tmp_74, null, null, null, tmp_75, null, null, tmp_76, tmp_77, false, 0, 0, null, MaterialTheme_instance.jog($composer_52, 6).tof_1, $composer_52, 0, 0, 131070);
          var tmp_78 = Companion_instance;
          var tmp0_12 = horizontalScroll(tmp_78, rememberScrollState(0, $composer_52, 0, 1));
          var tmp_79 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$121 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_19 = tmp0_12;
          var horizontalArrangement_7 = tmp_79.mdq(tmp$ret$121);
          var verticalAlignment_7 = null;
          var $composer_53 = $composer_52;
          if (!((4 & 1) === 0))
            modifier_19 = Companion_instance;
          if (!((4 & 2) === 0))
            horizontalArrangement_7 = Arrangement_getInstance().qdp_1;
          if (!((4 & 4) === 0))
            verticalAlignment_7 = Companion_getInstance_11().t8t_1;
          var measurePolicy_9 = rowMeasurePolicy(horizontalArrangement_7, verticalAlignment_7, $composer_53, 14 & 48 >> 3 | 112 & 48 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_20 = modifier_19;
          var $composer_54 = $composer_53;
          if (!((0 & 2) === 0))
            modifier_20 = Companion_instance;
          var compositeKeyHash_9 = get_currentCompositeKeyHashCode($composer_54, 0).hashCode();
          var localMap_9 = $composer_54.t31();
          var materialized_9 = materialize($composer_54, modifier_20);
          var tmp0_13 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_55 = $composer_54;
          var tmp_80 = $composer_55.g30();
          if (!isInterface(tmp_80, Applier)) {
            invalidApplier();
          }
          $composer_55.b31();
          if ($composer_55.h30()) {
            $composer_55.c31(tmp0_13);
          } else {
            $composer_55.d31();
          }
          var $this$ReusableComposeNode_9 = _Updater___init__impl__rbfxm8($composer_55);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_9, measurePolicy_9, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_9, localMap_9, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_9, compositeKeyHash_9, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_9, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_9, materialized_9, Companion_getInstance_12().qah_1);
          var $composer_56 = $composer_55;
          var $composer_57 = $composer_56;
          sourceInformationMarkerStart($composer_57, 1203353905, 'C:MugImageEditorScreen.kt#mu900e');
          $composer_57.m30(-1900844193);
          sourceInformation($composer_57, '*450@22673L264,453@22947L66,450@22607L407');
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_1 = get_entries_0().t();
          while (_iterator__ex2g4s_1.u()) {
            var element_1 = _iterator__ex2g4s_1.v();
            var tmp_81 = $currentSelected.f12g_1.equals(element_1);
            sourceInformationMarkerStart($composer_57, -967086707, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_5 = $composer_57.m31(element_1.a1_1);
            // Inline function 'kotlin.let' call
            var it_7 = $composer_57.i31();
            var tmp_82;
            if (invalid_5 || it_7 === Companion_getInstance().f30_1) {
              var value_7 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_9($images, element_1, $selectedId$delegate);
              $composer_57.j31(value_7);
              tmp_82 = value_7;
            } else {
              tmp_82 = it_7;
            }
            var tmp0_group_5 = tmp_82;
            sourceInformationMarkerEnd($composer_57);
            // Inline function 'kotlin.run' call
            var dispatchReceiver_1 = rememberComposableLambda(-933259336, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_10(element_1), $composer_57, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_58 = $composer_57;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_6 = $composer_58.k31(dispatchReceiver_1);
            // Inline function 'kotlin.let' call
            var it_8 = $composer_58.i31();
            var tmp_83;
            if (invalid_6 || it_8 === Companion_getInstance().f30_1) {
              var value_8 = ComposableLambda$invoke$ref(dispatchReceiver_1);
              $composer_58.j31(value_8);
              tmp_83 = value_8;
            } else {
              tmp_83 = it_8;
            }
            var tmp_84 = tmp_83;
            FilterChip(tmp_81, tmp0_group_5, tmp_84, null, false, null, null, null, null, null, null, null, $composer_57, 384, 0, 4088);
          }
          $composer_57.n30();
          sourceInformationMarkerEnd($composer_57);
          $composer_55.e31();
          sourceInformationMarkerEnd($composer_52);
          $composer_50.e31();
          $composer_5.n30();
        }
        var tmp_85 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$141 = _Dp___init__impl__ms3zkb(2);
        var tmp_86 = padding_2(tmp_85, VOID, tmp$ret$141);
        HorizontalDivider(tmp_86, _Dp___init__impl__ms3zkb(0.0), MaterialTheme_instance.unz($composer_5, 6).yo0_1, $composer_5, 6, 2);
        var tmp_87 = fillMaxWidth(Companion_instance);
        var tmp0_14 = horizontalScroll(tmp_87, rememberScrollState(0, $composer_5, 0, 1));
        var tmp_88 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$142 = _Dp___init__impl__ms3zkb(6);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_21 = tmp0_14;
        var horizontalArrangement_8 = tmp_88.mdq(tmp$ret$142);
        var verticalAlignment_8 = null;
        var $composer_59 = $composer_5;
        if (!((4 & 1) === 0))
          modifier_21 = Companion_instance;
        if (!((4 & 2) === 0))
          horizontalArrangement_8 = Arrangement_getInstance().qdp_1;
        if (!((4 & 4) === 0))
          verticalAlignment_8 = Companion_getInstance_11().t8t_1;
        var measurePolicy_10 = rowMeasurePolicy(horizontalArrangement_8, verticalAlignment_8, $composer_59, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_22 = modifier_21;
        var $composer_60 = $composer_59;
        if (!((0 & 2) === 0))
          modifier_22 = Companion_instance;
        var compositeKeyHash_10 = get_currentCompositeKeyHashCode($composer_60, 0).hashCode();
        var localMap_10 = $composer_60.t31();
        var materialized_10 = materialize($composer_60, modifier_22);
        var tmp0_15 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_61 = $composer_60;
        var tmp_89 = $composer_61.g30();
        if (!isInterface(tmp_89, Applier)) {
          invalidApplier();
        }
        $composer_61.b31();
        if ($composer_61.h30()) {
          $composer_61.c31(tmp0_15);
        } else {
          $composer_61.d31();
        }
        var $this$ReusableComposeNode_10 = _Updater___init__impl__rbfxm8($composer_61);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_10, measurePolicy_10, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_10, localMap_10, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_10, compositeKeyHash_10, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_10, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_10, materialized_10, Companion_getInstance_12().qah_1);
        var $composer_62 = $composer_61;
        var $composer_63 = $composer_62;
        sourceInformationMarkerStart($composer_63, -285317932, 'C464@23659L114,464@23810L183,464@23638L355,467@24051L120,467@24208L159,467@24030L337,470@24425L277,470@24739L151,470@24404L486,473@24948L122,473@25107L146,473@24927L326,476@25311L122,476@25470L180,476@25290L360,479@25708L214,479@25959L149,479@25687L421,482@26166L133,482@26336L164,482@26145L355,485@26558L133,485@26728L165,485@26537L356:MugImageEditorScreen.kt#mu900e');
        // Inline function 'androidx.compose.ui.unit.dp' call
        var iconSize = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var btnSize = _Dp___init__impl__ms3zkb(32);
        sourceInformationMarkerStart($composer_63, -701939431, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_9 = $composer_63.i31();
        var tmp_90;
        if (false || it_9 === Companion_getInstance().f30_1) {
          var value_9 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_11($images, $selectedId$delegate);
          $composer_63.j31(value_9);
          tmp_90 = value_9;
        } else {
          tmp_90 = it_9;
        }
        var tmp0_group_6 = tmp_90;
        sourceInformationMarkerEnd($composer_63);
        var tmp_91 = size(Companion_instance, btnSize);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_2 = rememberComposableLambda(-443133815, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_12(iconSize), $composer_63, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_64 = $composer_63;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_7 = $composer_64.k31(dispatchReceiver_2);
        // Inline function 'kotlin.let' call
        var it_10 = $composer_64.i31();
        var tmp_92;
        if (invalid_7 || it_10 === Companion_getInstance().f30_1) {
          var value_10 = ComposableLambda$invoke$ref(dispatchReceiver_2);
          $composer_64.j31(value_10);
          tmp_92 = value_10;
        } else {
          tmp_92 = it_10;
        }
        var tmp$ret$155 = tmp_92;
        IconButton(tmp0_group_6, tmp_91, false, null, null, null, tmp$ret$155, $composer_63, 1572918, 60);
        sourceInformationMarkerStart($composer_63, -701926881, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_11 = $composer_63.i31();
        var tmp_93;
        if (false || it_11 === Companion_getInstance().f30_1) {
          var value_11 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_13($images, $selectedId$delegate);
          $composer_63.j31(value_11);
          tmp_93 = value_11;
        } else {
          tmp_93 = it_11;
        }
        var tmp1_group_0 = tmp_93;
        sourceInformationMarkerEnd($composer_63);
        var tmp_94 = size(Companion_instance, btnSize);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_3 = rememberComposableLambda(-1972436942, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_14(iconSize), $composer_63, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_65 = $composer_63;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_8 = $composer_65.k31(dispatchReceiver_3);
        // Inline function 'kotlin.let' call
        var it_12 = $composer_65.i31();
        var tmp_95;
        if (invalid_8 || it_12 === Companion_getInstance().f30_1) {
          var value_12 = ComposableLambda$invoke$ref(dispatchReceiver_3);
          $composer_65.j31(value_12);
          tmp_95 = value_12;
        } else {
          tmp_95 = it_12;
        }
        var tmp$ret$166 = tmp_95;
        IconButton(tmp1_group_0, tmp_94, false, null, null, null, tmp$ret$166, $composer_63, 1572918, 60);
        sourceInformationMarkerStart($composer_63, -701914756, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_13 = $composer_63.i31();
        var tmp_96;
        if (false || it_13 === Companion_getInstance().f30_1) {
          var value_13 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_15($images, $selectedId$delegate);
          $composer_63.j31(value_13);
          tmp_96 = value_13;
        } else {
          tmp_96 = it_13;
        }
        var tmp2_group_0 = tmp_96;
        sourceInformationMarkerEnd($composer_63);
        var tmp_97 = size(Companion_instance, btnSize);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_4 = rememberComposableLambda(-591276655, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_16(iconSize), $composer_63, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_66 = $composer_63;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_9 = $composer_66.k31(dispatchReceiver_4);
        // Inline function 'kotlin.let' call
        var it_14 = $composer_66.i31();
        var tmp_98;
        if (invalid_9 || it_14 === Companion_getInstance().f30_1) {
          var value_14 = ComposableLambda$invoke$ref(dispatchReceiver_4);
          $composer_66.j31(value_14);
          tmp_98 = value_14;
        } else {
          tmp_98 = it_14;
        }
        var tmp$ret$177 = tmp_98;
        IconButton(tmp2_group_0, tmp_97, false, null, null, null, tmp$ret$177, $composer_63, 1572918, 60);
        sourceInformationMarkerStart($composer_63, -701898175, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_15 = $composer_63.i31();
        var tmp_99;
        if (false || it_15 === Companion_getInstance().f30_1) {
          var value_15 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_17($images, $selectedId$delegate);
          $composer_63.j31(value_15);
          tmp_99 = value_15;
        } else {
          tmp_99 = it_15;
        }
        var tmp3_group = tmp_99;
        sourceInformationMarkerEnd($composer_63);
        var tmp_100 = size(Companion_instance, btnSize);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_5 = rememberComposableLambda(789883632, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_18(iconSize), $composer_63, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_67 = $composer_63;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_10 = $composer_67.k31(dispatchReceiver_5);
        // Inline function 'kotlin.let' call
        var it_16 = $composer_67.i31();
        var tmp_101;
        if (invalid_10 || it_16 === Companion_getInstance().f30_1) {
          var value_16 = ComposableLambda$invoke$ref(dispatchReceiver_5);
          $composer_67.j31(value_16);
          tmp_101 = value_16;
        } else {
          tmp_101 = it_16;
        }
        var tmp$ret$188 = tmp_101;
        IconButton(tmp3_group, tmp_100, false, null, null, null, tmp$ret$188, $composer_63, 1572918, 60);
        sourceInformationMarkerStart($composer_63, -701886559, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_17 = $composer_63.i31();
        var tmp_102;
        if (false || it_17 === Companion_getInstance().f30_1) {
          var value_17 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_19($images, $selectedId$delegate);
          $composer_63.j31(value_17);
          tmp_102 = value_17;
        } else {
          tmp_102 = it_17;
        }
        var tmp4_group = tmp_102;
        sourceInformationMarkerEnd($composer_63);
        var tmp_103 = size(Companion_instance, btnSize);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_6 = rememberComposableLambda(-2123923377, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_20(iconSize), $composer_63, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_68 = $composer_63;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_11 = $composer_68.k31(dispatchReceiver_6);
        // Inline function 'kotlin.let' call
        var it_18 = $composer_68.i31();
        var tmp_104;
        if (invalid_11 || it_18 === Companion_getInstance().f30_1) {
          var value_18 = ComposableLambda$invoke$ref(dispatchReceiver_6);
          $composer_68.j31(value_18);
          tmp_104 = value_18;
        } else {
          tmp_104 = it_18;
        }
        var tmp$ret$199 = tmp_104;
        IconButton(tmp4_group, tmp_103, false, null, null, null, tmp$ret$199, $composer_63, 1572918, 60);
        sourceInformationMarkerStart($composer_63, -701873763, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_19 = $composer_63.i31();
        var tmp_105;
        if (false || it_19 === Companion_getInstance().f30_1) {
          var value_19 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_21($images, $selectedId$delegate);
          $composer_63.j31(value_19);
          tmp_105 = value_19;
        } else {
          tmp_105 = it_19;
        }
        var tmp5_group = tmp_105;
        sourceInformationMarkerEnd($composer_63);
        var tmp_106 = size(Companion_instance, btnSize);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_7 = rememberComposableLambda(-742763090, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_22(iconSize), $composer_63, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_69 = $composer_63;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_12 = $composer_69.k31(dispatchReceiver_7);
        // Inline function 'kotlin.let' call
        var it_20 = $composer_69.i31();
        var tmp_107;
        if (invalid_12 || it_20 === Companion_getInstance().f30_1) {
          var value_20 = ComposableLambda$invoke$ref(dispatchReceiver_7);
          $composer_69.j31(value_20);
          tmp_107 = value_20;
        } else {
          tmp_107 = it_20;
        }
        var tmp$ret$210 = tmp_107;
        IconButton(tmp5_group, tmp_106, false, null, null, null, tmp$ret$210, $composer_63, 1572918, 60);
        sourceInformationMarkerStart($composer_63, -701859188, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_21 = $composer_63.i31();
        var tmp_108;
        if (false || it_21 === Companion_getInstance().f30_1) {
          var value_21 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_23($images, $selectedId$delegate);
          $composer_63.j31(value_21);
          tmp_108 = value_21;
        } else {
          tmp_108 = it_21;
        }
        var tmp6_group = tmp_108;
        sourceInformationMarkerEnd($composer_63);
        var tmp_109 = size(Companion_instance, btnSize);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_8 = rememberComposableLambda(638397197, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_24(iconSize), $composer_63, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_70 = $composer_63;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_13 = $composer_70.k31(dispatchReceiver_8);
        // Inline function 'kotlin.let' call
        var it_22 = $composer_70.i31();
        var tmp_110;
        if (invalid_13 || it_22 === Companion_getInstance().f30_1) {
          var value_22 = ComposableLambda$invoke$ref(dispatchReceiver_8);
          $composer_70.j31(value_22);
          tmp_110 = value_22;
        } else {
          tmp_110 = it_22;
        }
        var tmp$ret$221 = tmp_110;
        IconButton(tmp6_group, tmp_109, false, null, null, null, tmp$ret$221, $composer_63, 1572918, 60);
        sourceInformationMarkerStart($composer_63, -701846644, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_23 = $composer_63.i31();
        var tmp_111;
        if (false || it_23 === Companion_getInstance().f30_1) {
          var value_23 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_25($images, $selectedId$delegate);
          $composer_63.j31(value_23);
          tmp_111 = value_23;
        } else {
          tmp_111 = it_23;
        }
        var tmp7_group = tmp_111;
        sourceInformationMarkerEnd($composer_63);
        var tmp_112 = size(Companion_instance, btnSize);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_9 = rememberComposableLambda(2019557484, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_26(iconSize), $composer_63, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_71 = $composer_63;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_14 = $composer_71.k31(dispatchReceiver_9);
        // Inline function 'kotlin.let' call
        var it_24 = $composer_71.i31();
        var tmp_113;
        if (invalid_14 || it_24 === Companion_getInstance().f30_1) {
          var value_24 = ComposableLambda$invoke$ref(dispatchReceiver_9);
          $composer_71.j31(value_24);
          tmp_113 = value_24;
        } else {
          tmp_113 = it_24;
        }
        var tmp$ret$232 = tmp_113;
        IconButton(tmp7_group, tmp_112, false, null, null, null, tmp$ret$232, $composer_63, 1572918, 60);
        sourceInformationMarkerEnd($composer_63);
        $composer_61.e31();
        var tmp_114 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$239 = _Dp___init__impl__ms3zkb(2);
        var tmp_115 = padding_2(tmp_114, VOID, tmp$ret$239);
        HorizontalDivider(tmp_115, _Dp___init__impl__ms3zkb(0.0), MaterialTheme_instance.unz($composer_5, 6).yo0_1, $composer_5, 6, 2);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_23 = null;
        var horizontalArrangement_9 = null;
        var verticalAlignment_9 = Companion_getInstance_11().u8t_1;
        var $composer_72 = $composer_5;
        if (!((3 & 1) === 0))
          modifier_23 = Companion_instance;
        if (!((3 & 2) === 0))
          horizontalArrangement_9 = Arrangement_getInstance().qdp_1;
        if (!((3 & 4) === 0))
          verticalAlignment_9 = Companion_getInstance_11().t8t_1;
        var measurePolicy_11 = rowMeasurePolicy(horizontalArrangement_9, verticalAlignment_9, $composer_72, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_24 = modifier_23;
        var $composer_73 = $composer_72;
        if (!((0 & 2) === 0))
          modifier_24 = Companion_instance;
        var compositeKeyHash_11 = get_currentCompositeKeyHashCode($composer_73, 0).hashCode();
        var localMap_11 = $composer_73.t31();
        var materialized_11 = materialize($composer_73, modifier_24);
        var tmp0_16 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_74 = $composer_73;
        var tmp_116 = $composer_74.g30();
        if (!isInterface(tmp_116, Applier)) {
          invalidApplier();
        }
        $composer_74.b31();
        if ($composer_74.h30()) {
          $composer_74.c31(tmp0_16);
        } else {
          $composer_74.d31();
        }
        var $this$ReusableComposeNode_11 = _Updater___init__impl__rbfxm8($composer_74);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_11, measurePolicy_11, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_11, localMap_11, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_11, compositeKeyHash_11, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_11, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_11, materialized_11, Companion_getInstance_12().qah_1);
        var $composer_75 = $composer_74;
        var $composer_76 = $composer_75;
        sourceInformationMarkerStart($composer_76, -684123296, 'C493@27203L38,493@27299L10,493@27198L123,494@27413L109,494@27358L221:MugImageEditorScreen.kt#mu900e');
        var tmp_117 = stringResource(get_width_label(string_instance), $composer_76, 0);
        var tmp_118 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$246 = _Dp___init__impl__ms3zkb(36);
        var tmp_119 = width(tmp_118, tmp$ret$246);
        var tmp_120 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_121 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_122 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_123 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_124 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_117, tmp_119, tmp_120, null, tmp_121, null, null, null, tmp_122, null, null, tmp_123, tmp_124, false, 0, 0, null, MaterialTheme_instance.jog($composer_76, 6).tof_1, $composer_76, 48, 0, 131068);
        var tmp0_value = $currentSelected.c12g_1;
        var tmp1_valueRange = rangeTo(0.05, 5.0);
        var tmp2_modifier = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        sourceInformationMarkerStart($composer_76, 532127443, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_25 = $composer_76.i31();
        var tmp_125;
        if (false || it_25 === Companion_getInstance().f30_1) {
          var value_25 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_27($images, $selectedId$delegate);
          $composer_76.j31(value_25);
          tmp_125 = value_25;
        } else {
          tmp_125 = it_25;
        }
        var tmp0_group_7 = tmp_125;
        sourceInformationMarkerEnd($composer_76);
        Slider(tmp0_value, tmp0_group_7, tmp2_modifier, false, tmp1_valueRange, 0, null, null, null, $composer_76, 48, 488);
        sourceInformationMarkerEnd($composer_76);
        $composer_74.e31();
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_25 = null;
        var horizontalArrangement_10 = null;
        var verticalAlignment_10 = Companion_getInstance_11().u8t_1;
        var $composer_77 = $composer_5;
        if (!((3 & 1) === 0))
          modifier_25 = Companion_instance;
        if (!((3 & 2) === 0))
          horizontalArrangement_10 = Arrangement_getInstance().qdp_1;
        if (!((3 & 4) === 0))
          verticalAlignment_10 = Companion_getInstance_11().t8t_1;
        var measurePolicy_12 = rowMeasurePolicy(horizontalArrangement_10, verticalAlignment_10, $composer_77, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_26 = modifier_25;
        var $composer_78 = $composer_77;
        if (!((0 & 2) === 0))
          modifier_26 = Companion_instance;
        var compositeKeyHash_12 = get_currentCompositeKeyHashCode($composer_78, 0).hashCode();
        var localMap_12 = $composer_78.t31();
        var materialized_12 = materialize($composer_78, modifier_26);
        var tmp0_17 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_79 = $composer_78;
        var tmp_126 = $composer_79.g30();
        if (!isInterface(tmp_126, Applier)) {
          invalidApplier();
        }
        $composer_79.b31();
        if ($composer_79.h30()) {
          $composer_79.c31(tmp0_17);
        } else {
          $composer_79.d31();
        }
        var $this$ReusableComposeNode_12 = _Updater___init__impl__rbfxm8($composer_79);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_12, measurePolicy_12, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_12, localMap_12, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_12, compositeKeyHash_12, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_12, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_12, materialized_12, Companion_getInstance_12().qah_1);
        var $composer_80 = $composer_79;
        var $composer_81 = $composer_80;
        sourceInformationMarkerStart($composer_81, -1082836032, 'C497@27741L39,497@27838L10,497@27736L124,498@27952L109,498@27897L221:MugImageEditorScreen.kt#mu900e');
        var tmp_127 = stringResource(get_height_label(string_instance), $composer_81, 0);
        var tmp_128 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$257 = _Dp___init__impl__ms3zkb(36);
        var tmp_129 = width(tmp_128, tmp$ret$257);
        var tmp_130 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_131 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_132 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_133 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_134 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_127, tmp_129, tmp_130, null, tmp_131, null, null, null, tmp_132, null, null, tmp_133, tmp_134, false, 0, 0, null, MaterialTheme_instance.jog($composer_81, 6).tof_1, $composer_81, 48, 0, 131068);
        var tmp0_value_0 = $currentSelected.d12g_1;
        var tmp1_valueRange_0 = rangeTo(0.05, 5.0);
        var tmp2_modifier_0 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        sourceInformationMarkerStart($composer_81, 1766191762, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_26 = $composer_81.i31();
        var tmp_135;
        if (false || it_26 === Companion_getInstance().f30_1) {
          var value_26 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_28($images, $selectedId$delegate);
          $composer_81.j31(value_26);
          tmp_135 = value_26;
        } else {
          tmp_135 = it_26;
        }
        var tmp0_group_8 = tmp_135;
        sourceInformationMarkerEnd($composer_81);
        Slider(tmp0_value_0, tmp0_group_8, tmp2_modifier_0, false, tmp1_valueRange_0, 0, null, null, null, $composer_81, 48, 488);
        sourceInformationMarkerEnd($composer_81);
        $composer_79.e31();
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_27 = null;
        var horizontalArrangement_11 = null;
        var verticalAlignment_11 = Companion_getInstance_11().u8t_1;
        var $composer_82 = $composer_5;
        if (!((3 & 1) === 0))
          modifier_27 = Companion_instance;
        if (!((3 & 2) === 0))
          horizontalArrangement_11 = Arrangement_getInstance().qdp_1;
        if (!((3 & 4) === 0))
          verticalAlignment_11 = Companion_getInstance_11().t8t_1;
        var measurePolicy_13 = rowMeasurePolicy(horizontalArrangement_11, verticalAlignment_11, $composer_82, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_28 = modifier_27;
        var $composer_83 = $composer_82;
        if (!((0 & 2) === 0))
          modifier_28 = Companion_instance;
        var compositeKeyHash_13 = get_currentCompositeKeyHashCode($composer_83, 0).hashCode();
        var localMap_13 = $composer_83.t31();
        var materialized_13 = materialize($composer_83, modifier_28);
        var tmp0_18 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_84 = $composer_83;
        var tmp_136 = $composer_84.g30();
        if (!isInterface(tmp_136, Applier)) {
          invalidApplier();
        }
        $composer_84.b31();
        if ($composer_84.h30()) {
          $composer_84.c31(tmp0_18);
        } else {
          $composer_84.d31();
        }
        var $this$ReusableComposeNode_13 = _Updater___init__impl__rbfxm8($composer_84);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_13, measurePolicy_13, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_13, localMap_13, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_13, compositeKeyHash_13, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_13, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_13, materialized_13, Companion_getInstance_12().qah_1);
        var $composer_85 = $composer_84;
        var $composer_86 = $composer_85;
        sourceInformationMarkerStart($composer_86, -1481548613, 'C501@28280L39,501@28377L10,501@28275L124,502@28493L111,502@28436L227:MugImageEditorScreen.kt#mu900e');
        var tmp_137 = stringResource(get_rotate_label(string_instance), $composer_86, 0);
        var tmp_138 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$268 = _Dp___init__impl__ms3zkb(36);
        var tmp_139 = width(tmp_138, tmp$ret$268);
        var tmp_140 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_141 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_142 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_143 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_144 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_137, tmp_139, tmp_140, null, tmp_141, null, null, null, tmp_142, null, null, tmp_143, tmp_144, false, 0, 0, null, MaterialTheme_instance.jog($composer_86, 6).tof_1, $composer_86, 48, 0, 131068);
        var tmp0_value_1 = $currentSelected.e12g_1;
        var tmp1_valueRange_1 = rangeTo(-180.0, 180.0);
        var tmp2_modifier_1 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        sourceInformationMarkerStart($composer_86, -1294711181, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_27 = $composer_86.i31();
        var tmp_145;
        if (false || it_27 === Companion_getInstance().f30_1) {
          var value_27 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_29($images, $selectedId$delegate);
          $composer_86.j31(value_27);
          tmp_145 = value_27;
        } else {
          tmp_145 = it_27;
        }
        var tmp0_group_9 = tmp_145;
        sourceInformationMarkerEnd($composer_86);
        Slider(tmp0_value_1, tmp0_group_9, tmp2_modifier_1, false, tmp1_valueRange_1, 0, null, null, null, $composer_86, 48, 488);
        sourceInformationMarkerEnd($composer_86);
        $composer_84.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_146;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_146 = Unit_instance;
        }
        tmp = tmp_146;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_30($showSettings$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_8($showSettings$delegate, true);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$lambda_3($selectedId$delegate) {
    return function (it) {
      return it.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate));
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_31($images, $selectedId$delegate) {
    return function () {
      removeAll($images, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda$lambda_3($selectedId$delegate));
      BaseMugImageEditorScreen$lambda_6($selectedId$delegate, null);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda_2($showSettings$delegate, $images, $selectedId$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C516@29410L954:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(18694375, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:516)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_1 = _Dp___init__impl__ms3zkb(12);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(4);
        var tmp0 = padding_2(tmp_0, tmp_1, tmp$ret$1);
        var tmp_2 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$2 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = tmp0;
        var horizontalArrangement = tmp_2.mdq(tmp$ret$2);
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_3 = $composer_3.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0_0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -1182403513, 'C521@29782L23,521@29761L228,524@30047L63,524@30026L304:MugImageEditorScreen.kt#mu900e');
        sourceInformationMarkerStart($composer_5, 931689402, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_5.i31();
        var tmp_4;
        if (false || it === Companion_getInstance().f30_1) {
          var value = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_30($showSettings$delegate);
          $composer_5.j31(value);
          tmp_4 = value;
        } else {
          tmp_4 = it;
        }
        var tmp0_group = tmp_4;
        sourceInformationMarkerEnd($composer_5);
        var tmp_5 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$13 = _Dp___init__impl__ms3zkb(32);
        var tmp_6 = size(tmp_5, tmp$ret$13);
        IconButton(tmp0_group, tmp_6, false, null, null, null, ComposableSingletons$MugImageEditorScreenKt_getInstance().k12r_1, $composer_5, 1572918, 60);
        sourceInformationMarkerStart($composer_5, 931697922, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_0 = $composer_5.i31();
        var tmp_7;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var value_0 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_31($images, $selectedId$delegate);
          $composer_5.j31(value_0);
          tmp_7 = value_0;
        } else {
          tmp_7 = it_0;
        }
        var tmp1_group = tmp_7;
        sourceInformationMarkerEnd($composer_5);
        var tmp_8 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$18 = _Dp___init__impl__ms3zkb(32);
        var tmp_9 = size(tmp_8, tmp$ret$18);
        IconButton(tmp1_group, tmp_9, false, null, null, null, ComposableSingletons$MugImageEditorScreenKt_getInstance().l12r_1, $composer_5, 1572918, 60);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_10;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_10 = Unit_instance;
        }
        tmp = tmp_10;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda_0($images, $selectedId$delegate, $showSettings$delegate, $textToBitmap, $textToEdit$delegate, $showTextDialog$delegate, $initialColorForPicker$delegate, $colorToEdit$delegate, $showColorPicker$delegate, $getFontFamily) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1002097607, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous> (MugImageEditorScreen.kt:367)');
        }
        // Inline function 'kotlin.collections.find' call
        var tmp0 = $images;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            if (element.z12f_1.equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate))) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var currentSelected = tmp$ret$1;
        if (!(currentSelected == null)) {
          $composer_0.m30(-827260942);
          sourceInformation($composer_0, '');
          if (BaseMugImageEditorScreen$lambda_7($showSettings$delegate)) {
            $composer_0.m30(-827250433);
            sourceInformation($composer_0, '376@15280L11,377@15353L13400,370@14933L13820');
            var tmp_0 = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp_1 = _Dp___init__impl__ms3zkb(8);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$4 = _Dp___init__impl__ms3zkb(8);
            var tmp0_modifier = padding_2(tmp_0, tmp_1, tmp$ret$4);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$5 = _Dp___init__impl__ms3zkb(12);
            var tmp1_shape = RoundedCornerShape(tmp$ret$5);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp2_tonalElevation = _Dp___init__impl__ms3zkb(8);
            var tmp3_color = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_0, 6).oo0_1, 0.95);
            var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
            // Inline function 'kotlin.run' call
            var dispatchReceiver = rememberComposableLambda(827875160, true, BaseMugImageEditorScreen$lambda$lambda$lambda_1(currentSelected, $textToBitmap, $showSettings$delegate, $images, $selectedId$delegate, $textToEdit$delegate, $showTextDialog$delegate, $initialColorForPicker$delegate, $colorToEdit$delegate, $showColorPicker$delegate, $getFontFamily), $composer_0, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_1 = $composer_0;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid = $composer_1.k31(dispatchReceiver);
            // Inline function 'kotlin.let' call
            var it = $composer_1.i31();
            var tmp_4;
            if (invalid || it === Companion_getInstance().f30_1) {
              var value = ComposableLambda$invoke$ref(dispatchReceiver);
              $composer_1.j31(value);
              tmp_4 = value;
            } else {
              tmp_4 = it;
            }
            var tmp$ret$7 = tmp_4;
            Surface(tmp0_modifier, tmp1_shape, tmp3_color, tmp_2, tmp2_tonalElevation, tmp_3, null, tmp$ret$7, $composer_0, 12607494, 104);
            $composer_0.n30();
          } else {
            $composer_0.m30(-813890146);
            sourceInformation($composer_0, '508@28873L1547');
            // Inline function 'androidx.compose.foundation.layout.Box' call
            var modifier = fillMaxWidth(Companion_instance);
            var contentAlignment = Companion_getInstance_11().o8t_1;
            var propagateMinConstraints = false;
            var $composer_2 = $composer_0;
            if (!((4 & 1) === 0))
              modifier = Companion_instance;
            if (!((4 & 2) === 0))
              contentAlignment = Companion_getInstance_11().k8t_1;
            if (!((4 & 4) === 0))
              propagateMinConstraints = false;
            var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
            // Inline function 'androidx.compose.ui.layout.Layout' call
            var modifier_0 = modifier;
            var $composer_3 = $composer_2;
            if (!((0 & 2) === 0))
              modifier_0 = Companion_instance;
            var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
            var localMap = $composer_3.t31();
            var materialized = materialize($composer_3, modifier_0);
            var tmp0_0 = Companion_getInstance_12().oah_1;
            // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
            var $composer_4 = $composer_3;
            var tmp_5 = $composer_4.g30();
            if (!isInterface(tmp_5, Applier)) {
              invalidApplier();
            }
            $composer_4.b31();
            if ($composer_4.h30()) {
              $composer_4.c31(tmp0_0);
            } else {
              $composer_4.d31();
            }
            var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
            Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
            Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
            var $composer_5 = $composer_4;
            var $composer_6 = $composer_5;
            sourceInformationMarkerStart($composer_6, -1817598415, 'C514@29299L11,515@29376L1018,509@28980L1414:MugImageEditorScreen.kt#mu900e');
            var tmp_6 = Companion_instance;
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp_7 = _Dp___init__impl__ms3zkb(8);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$21 = _Dp___init__impl__ms3zkb(8);
            var tmp0_modifier_0 = padding_2(tmp_6, tmp_7, tmp$ret$21);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$22 = _Dp___init__impl__ms3zkb(24);
            var tmp1_shape_0 = RoundedCornerShape(tmp$ret$22);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp2_tonalElevation_0 = _Dp___init__impl__ms3zkb(8);
            var tmp3_color_0 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_6, 6).oo0_1, 0.95);
            var tmp_8 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_9 = _Dp___init__impl__ms3zkb(0.0);
            // Inline function 'kotlin.run' call
            var dispatchReceiver_0 = rememberComposableLambda(18694375, true, BaseMugImageEditorScreen$lambda$lambda$lambda_2($showSettings$delegate, $images, $selectedId$delegate), $composer_6, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_7 = $composer_6;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_0 = $composer_7.k31(dispatchReceiver_0);
            // Inline function 'kotlin.let' call
            var it_0 = $composer_7.i31();
            var tmp_10;
            if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
              var value_0 = ComposableLambda$invoke$ref(dispatchReceiver_0);
              $composer_7.j31(value_0);
              tmp_10 = value_0;
            } else {
              tmp_10 = it_0;
            }
            var tmp$ret$24 = tmp_10;
            Surface(tmp0_modifier_0, tmp1_shape_0, tmp3_color_0, tmp_8, tmp2_tonalElevation_0, tmp_9, null, tmp$ret$24, $composer_6, 12607494, 104);
            sourceInformationMarkerEnd($composer_6);
            $composer_4.e31();
            $composer_0.n30();
          }
          $composer_0.n30();
        } else {
          $composer_0.m30(-812276069);
          $composer_0.n30();
        }
        var tmp_11;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_11 = Unit_instance;
        }
        tmp = tmp_11;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$slambda$lambda($selectedId$delegate) {
    return function (it) {
      BaseMugImageEditorScreen$lambda_6($selectedId$delegate, null);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$slambda($selectedId$delegate, resultContinuation) {
    this.m12u_1 = $selectedId$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BaseMugImageEditorScreen$lambda$lambda$slambda).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = detectTapGestures(this.n12u_1, VOID, VOID, VOID, BaseMugImageEditorScreen$lambda$lambda$slambda$lambda(this.m12u_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$slambda).wc6 = function ($this$pointerInput, completion) {
    var i = new BaseMugImageEditorScreen$lambda$lambda$slambda(this.m12u_1, completion);
    i.n12u_1 = $this$pointerInput;
    return i;
  };
  function BaseMugImageEditorScreen$lambda$lambda$slambda_0($selectedId$delegate, resultContinuation) {
    var i = new BaseMugImageEditorScreen$lambda$lambda$slambda($selectedId$delegate, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_32($img, $scaleFit) {
    return function ($this$graphicsLayer) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_0 = $img.b12g_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp$ret$0 = floatFromBits(bits);
      $this$graphicsLayer.y66(tmp$ret$0 * $scaleFit);
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_1 = $img.b12g_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var tmp$ret$4 = floatFromBits(bits_0);
      $this$graphicsLayer.z66(tmp$ret$4 * $scaleFit);
      $this$graphicsLayer.w66($img.c12g_1 * ($img.g12g_1 ? -1.0 : 1.0));
      $this$graphicsLayer.x66($img.d12g_1 * ($img.h12g_1 ? -1.0 : 1.0));
      $this$graphicsLayer.f67($img.e12g_1);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$slambda$lambda($img, $images, $selectedId$delegate) {
    return function (it) {
      BaseMugImageEditorScreen$lambda_6($selectedId$delegate, $img.z12f_1);
      // Inline function 'kotlin.collections.find' call
      var tmp0 = $images;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          if (equalsLong(element.z12f_1, $img.z12f_1)) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var item = tmp$ret$1;
      var tmp;
      var tmp_0;
      if (!(item == null)) {
        var tmp0_safe_receiver = lastOrNull($images);
        tmp_0 = !equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z12f_1, $img.z12f_1);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        $images.g10(item);
        $images.zz(item);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$slambda($img, $images, $selectedId$delegate, resultContinuation) {
    this.w12u_1 = $img;
    this.x12u_1 = $images;
    this.y12u_1 = $selectedId$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$slambda).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = detectTapGestures(this.z12u_1, VOID, VOID, VOID, BaseMugImageEditorScreen$lambda$lambda$lambda$slambda$lambda(this.w12u_1, this.x12u_1, this.y12u_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$slambda).wc6 = function ($this$pointerInput, completion) {
    var i = new BaseMugImageEditorScreen$lambda$lambda$lambda$slambda(this.w12u_1, this.x12u_1, this.y12u_1, completion);
    i.z12u_1 = $this$pointerInput;
    return i;
  };
  function BaseMugImageEditorScreen$lambda$lambda$lambda$slambda_0($img, $images, $selectedId$delegate, resultContinuation) {
    var i = new BaseMugImageEditorScreen$lambda$lambda$lambda$slambda($img, $images, $selectedId$delegate, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$slambda$lambda_0($img, $images, $scaleFit, $selectedId$delegate) {
    return function (_unused_var__etf5q3, pan, zoom, rotation) {
      var tmp;
      if (!equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate), $img.z12f_1)) {
        BaseMugImageEditorScreen$lambda_6($selectedId$delegate, $img.z12f_1);
        tmp = Unit_instance;
      }
      var tmp0 = $images;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          if (equalsLong(item.z12f_1, $img.z12f_1)) {
            tmp$ret$0 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$0 = -1;
      }
      var index_0 = tmp$ret$0;
      var tmp_0;
      if (!(index_0 === -1)) {
        var currentImg = $images.l1(index_0);
        var angleRad = currentImg.e12g_1 * (3.141592653589793 / 180.0);
        // Inline function 'kotlin.math.cos' call
        var c = Math.cos(angleRad);
        // Inline function 'kotlin.math.sin' call
        var s = Math.sin(angleRad);
        // Inline function 'androidx.compose.ui.geometry.Offset.x' call
        var this_0 = pan.e5d_1;
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(shiftRight(value, 32));
        var lx = floatFromBits(bits) * currentImg.c12g_1 * (currentImg.g12g_1 ? -1.0 : 1.0);
        // Inline function 'androidx.compose.ui.geometry.Offset.y' call
        var this_1 = pan.e5d_1;
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
        var ly = floatFromBits(bits_0) * currentImg.d12g_1 * (currentImg.h12g_1 ? -1.0 : 1.0);
        var px = lx * c - ly * s;
        var py = lx * s + ly * c;
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var v1 = fromInt(toRawBits(px));
        var v2 = fromInt(toRawBits(py));
        var tmp$ret$13 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        var tmp$ret$12 = _Offset___init__impl__c168vi(tmp$ret$13);
        $images.mi(index_0, currentImg.m12h(VOID, VOID, Offset__plus_impl_c78cg0(currentImg.b12g_1, Offset__div_impl_eaxtg1(tmp$ret$12, $scaleFit)), coerceIn(currentImg.c12g_1 * zoom, 0.05, 5.0), coerceIn(currentImg.d12g_1 * zoom, 0.05, 5.0), currentImg.e12g_1 + rotation));
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$slambda_1($img, $images, $scaleFit, $selectedId$delegate, resultContinuation) {
    this.i12v_1 = $img;
    this.j12v_1 = $images;
    this.k12v_1 = $scaleFit;
    this.l12v_1 = $selectedId$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$slambda_1).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$slambda_1).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = detectTransformGestures(this.m12v_1, VOID, BaseMugImageEditorScreen$lambda$lambda$lambda$slambda$lambda_0(this.i12v_1, this.j12v_1, this.k12v_1, this.l12v_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BaseMugImageEditorScreen$lambda$lambda$lambda$slambda_1).wc6 = function ($this$pointerInput, completion) {
    var i = new BaseMugImageEditorScreen$lambda$lambda$lambda$slambda_1(this.i12v_1, this.j12v_1, this.k12v_1, this.l12v_1, completion);
    i.m12v_1 = $this$pointerInput;
    return i;
  };
  function BaseMugImageEditorScreen$lambda$lambda$lambda$slambda_2($img, $images, $scaleFit, $selectedId$delegate, resultContinuation) {
    var i = new BaseMugImageEditorScreen$lambda$lambda$lambda$slambda_1($img, $images, $scaleFit, $selectedId$delegate, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_33($designWidth, $scaleFit, $designHeight) {
    return function ($this$Canvas) {
      var holeWidth = $designWidth * $scaleFit;
      var holeHeight = $designHeight * $scaleFit;
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_0 = $this$Canvas.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var left = (floatFromBits(bits) - holeWidth) / 2;
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_1 = $this$Canvas.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var top = (floatFromBits(bits_0) - holeHeight) / 2;
      var extra = 10000.0;
      var tmp = Color__copy$default_impl_ectz3s(Companion_getInstance_14().k6b_1, 0.5);
      var tmp0 = -extra;
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2 = -extra;
      var v1 = fromInt(toRawBits(tmp0));
      var v2 = fromInt(toRawBits(val2));
      var tmp$ret$9 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      var tmp_0 = _Offset___init__impl__c168vi(tmp$ret$9);
      var tmp0_0 = left + extra;
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_2 = $this$Canvas.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_1 = _Size___get_packedValue__impl__7rlt1o(this_2);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.geometry.Size' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2_0 = floatFromBits(bits_1) + 2 * extra;
      var v1_0 = fromInt(toRawBits(tmp0_0));
      var v2_0 = fromInt(toRawBits(val2_0));
      var tmp$ret$15 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
      var tmp$ret$14 = _Size___init__impl__aywn0g(tmp$ret$15);
      $this$Canvas.b6q(tmp, tmp_0, tmp$ret$14);
      var tmp_1 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().k6b_1, 0.5);
      var tmp0_1 = left + holeWidth;
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2_1 = -extra;
      var v1_1 = fromInt(toRawBits(tmp0_1));
      var v2_1 = fromInt(toRawBits(val2_1));
      var tmp$ret$17 = bitwiseOr(shiftLeft(v1_1, 32), bitwiseAnd(v2_1, new Long(-1, 0)));
      var tmp_2 = _Offset___init__impl__c168vi(tmp$ret$17);
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_3 = $this$Canvas.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_2 = _Size___get_packedValue__impl__7rlt1o(this_3);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(shiftRight(value_2, 32));
      var tmp0_2 = floatFromBits(bits_2) - (left + holeWidth) + extra;
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_4 = $this$Canvas.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_3 = _Size___get_packedValue__impl__7rlt1o(this_4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_3 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.geometry.Size' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2_2 = floatFromBits(bits_3) + 2 * extra;
      var v1_2 = fromInt(toRawBits(tmp0_2));
      var v2_2 = fromInt(toRawBits(val2_2));
      var tmp$ret$27 = bitwiseOr(shiftLeft(v1_2, 32), bitwiseAnd(v2_2, new Long(-1, 0)));
      var tmp$ret$26 = _Size___init__impl__aywn0g(tmp$ret$27);
      $this$Canvas.b6q(tmp_1, tmp_2, tmp$ret$26);
      var tmp_3 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().k6b_1, 0.5);
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2_3 = -extra;
      var v1_3 = fromInt(toRawBits(left));
      var v2_3 = fromInt(toRawBits(val2_3));
      var tmp$ret$29 = bitwiseOr(shiftLeft(v1_3, 32), bitwiseAnd(v2_3, new Long(-1, 0)));
      var tmp_4 = _Offset___init__impl__c168vi(tmp$ret$29);
      // Inline function 'androidx.compose.ui.geometry.Size' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2_4 = top + extra;
      var v1_4 = fromInt(toRawBits(holeWidth));
      var v2_4 = fromInt(toRawBits(val2_4));
      var tmp$ret$31 = bitwiseOr(shiftLeft(v1_4, 32), bitwiseAnd(v2_4, new Long(-1, 0)));
      var tmp$ret$30 = _Size___init__impl__aywn0g(tmp$ret$31);
      $this$Canvas.b6q(tmp_3, tmp_4, tmp$ret$30);
      var tmp_5 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().k6b_1, 0.5);
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2_5 = top + holeHeight;
      var v1_5 = fromInt(toRawBits(left));
      var v2_5 = fromInt(toRawBits(val2_5));
      var tmp$ret$33 = bitwiseOr(shiftLeft(v1_5, 32), bitwiseAnd(v2_5, new Long(-1, 0)));
      var tmp_6 = _Offset___init__impl__c168vi(tmp$ret$33);
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_5 = $this$Canvas.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_4 = _Size___get_packedValue__impl__7rlt1o(this_5);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.geometry.Size' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2_6 = floatFromBits(bits_4) - (top + holeHeight) + extra;
      var v1_6 = fromInt(toRawBits(holeWidth));
      var v2_6 = fromInt(toRawBits(val2_6));
      var tmp$ret$39 = bitwiseOr(shiftLeft(v1_6, 32), bitwiseAnd(v2_6, new Long(-1, 0)));
      var tmp$ret$38 = _Size___init__impl__aywn0g(tmp$ret$39);
      $this$Canvas.b6q(tmp_5, tmp_6, tmp$ret$38);
      var tmp_7 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.3);
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1_7 = fromInt(toRawBits(left));
      var v2_7 = fromInt(toRawBits(top));
      var tmp$ret$41 = bitwiseOr(shiftLeft(v1_7, 32), bitwiseAnd(v2_7, new Long(-1, 0)));
      var tmp_8 = _Offset___init__impl__c168vi(tmp$ret$41);
      // Inline function 'androidx.compose.ui.geometry.Size' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1_8 = fromInt(toRawBits(holeWidth));
      var v2_8 = fromInt(toRawBits(holeHeight));
      var tmp$ret$43 = bitwiseOr(shiftLeft(v1_8, 32), bitwiseAnd(v2_8, new Long(-1, 0)));
      var tmp_9 = _Size___init__impl__aywn0g(tmp$ret$43);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$44 = _Dp___init__impl__ms3zkb(1);
      $this$Canvas.b6q(tmp_7, tmp_8, tmp_9, VOID, new Stroke($this$Canvas.v5e(tmp$ret$44)));
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda_3($density, $images, $selectedId$delegate) {
    return function ($this$BoxWithConstraints, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C548@31042L283,558@31520L780,576@32322L6708:MugImageEditorScreen.kt#mu900e');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$BoxWithConstraints) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(185282229, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:545)');
        }
        var designWidth = 2100.0;
        var designHeight = 950.0;
        var tmp0_remember$arg$0 = _Constraints___get_maxWidth__impl__uuyqc($this$BoxWithConstraints.vds());
        var tmp1_remember$arg$1 = _Constraints___get_maxHeight__impl__dt3e8z($this$BoxWithConstraints.vds());
        sourceInformationMarkerStart($composer_0, 1962567248, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.m31(tmp0_remember$arg$0) | $composer_0.m31(tmp1_remember$arg$1));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var tmp0 = _Constraints___get_maxWidth__impl__uuyqc($this$BoxWithConstraints.vds()) / designWidth;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = _Constraints___get_maxHeight__impl__dt3e8z($this$BoxWithConstraints.vds()) / designHeight;
          var value = Math.min(tmp0, b);
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp2_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        var scaleFit = tmp2_group;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var this_0 = designWidth * scaleFit / $density.u5e();
        var displayWidth = _Dp___init__impl__ms3zkb(this_0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var this_1 = designHeight * scaleFit / $density.u5e();
        var displayHeight = _Dp___init__impl__ms3zkb(this_1);
        var tmp_2 = $this$BoxWithConstraints.udr(Companion_instance, Companion_getInstance_11().l8t_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(4);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = padding_1(tmp_2, VOID, tmp$ret$7);
        var verticalArrangement = null;
        var horizontalAlignment = Companion_getInstance_11().x8t_1;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance;
        if (!((2 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((2 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_3 = $composer_3.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0_0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -416794201, 'C565@31842L42,567@31985L10,564@31801L232,572@32231L10,569@32058L220:MugImageEditorScreen.kt#mu900e');
        var tmp_4 = stringResource(get_full_wrap_label(string_instance), $composer_5, 0);
        var tmp_5 = Companion_getInstance_14().m6b_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_9 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_4, null, tmp_5, null, tmp_6, null, null, null, tmp_7, null, null, tmp_8, tmp_9, false, 0, 0, null, MaterialTheme_instance.jog($composer_5, 6).sof_1, $composer_5, 384, 0, 131066);
        var tmp_10 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.7);
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_14 = _TextOverflow___init__impl__obguoe(0);
        Text('2100 * 950', null, tmp_10, null, tmp_11, null, null, null, tmp_12, null, null, tmp_13, tmp_14, false, 0, 0, null, MaterialTheme_instance.jog($composer_5, 6).tof_1, $composer_5, 390, 0, 131066);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = clipToBounds(fillMaxSize(Companion_instance));
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_0;
        if (!((4 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_15 = $composer_8.g30();
        if (!isInterface(tmp_15, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_1);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 738833009, 'C580@32509L169,659@37892L1116,659@37839L1169:MugImageEditorScreen.kt#mu900e');
        Box(background(size_0(Companion_instance, displayWidth, displayHeight), Companion_getInstance_14().m6b_1), $composer_10, 0);
        $composer_10.m30(-807445603);
        sourceInformation($composer_10, '');
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = $images.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          $composer_10.o30(1064914217, element.z12f_1);
          sourceInformation($composer_10, '596@33365L472,603@33900L608,613@34571L1928,592@33120L4637');
          var isSelected = equals(BaseMugImageEditorScreen$lambda_5($selectedId$delegate), element.z12f_1);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var this_2 = element.a12g_1.h5e() * scaleFit / $density.u5e();
          var imgWidth = _Dp___init__impl__ms3zkb(this_2);
          var bitmapAspectRatio = element.a12g_1.h5e() / element.a12g_1.i5e();
          var tmp_16 = aspectRatio(width(Companion_instance, imgWidth), bitmapAspectRatio);
          sourceInformationMarkerStart($composer_10, 1064929146, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = !!($composer_10.q31(element) | $composer_10.n31(scaleFit));
          // Inline function 'kotlin.let' call
          var it_0 = $composer_10.i31();
          var tmp_17;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_32(element, scaleFit);
            $composer_10.j31(value_0);
            tmp_17 = value_0;
          } else {
            tmp_17 = it_0;
          }
          var tmp0_group = tmp_17;
          sourceInformationMarkerEnd($composer_10);
          var tmp_18 = graphicsLayer(tmp_16, tmp0_group);
          sourceInformationMarkerStart($composer_10, 1064946402, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_1 = $composer_10.q31(element);
          // Inline function 'kotlin.let' call
          var it_1 = $composer_10.i31();
          var tmp_19;
          if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
            var tmp_20 = BaseMugImageEditorScreen$lambda$lambda$lambda$slambda_0(element, $images, $selectedId$delegate, null);
            var value_1 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3(tmp_20);
            $composer_10.j31(value_1);
            tmp_19 = value_1;
          } else {
            tmp_19 = it_1;
          }
          var tmp1_group = tmp_19;
          sourceInformationMarkerEnd($composer_10);
          var tmp_21 = pointerInput(tmp_18, element.z12f_1, tmp1_group);
          sourceInformationMarkerStart($composer_10, 1064969194, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_2 = !!($composer_10.q31(element) | $composer_10.n31(scaleFit));
          // Inline function 'kotlin.let' call
          var it_2 = $composer_10.i31();
          var tmp_22;
          if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
            var tmp_23 = BaseMugImageEditorScreen$lambda$lambda$lambda$slambda_2(element, $images, scaleFit, $selectedId$delegate, null);
            var value_2 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3(tmp_23);
            $composer_10.j31(value_2);
            tmp_22 = value_2;
          } else {
            tmp_22 = it_2;
          }
          var tmp2_group_0 = tmp_22;
          sourceInformationMarkerEnd($composer_10);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_3 = pointerInput(tmp_21, element.z12f_1, tmp2_group_0);
          var contentAlignment_0 = null;
          var propagateMinConstraints_0 = false;
          var $composer_11 = $composer_10;
          if (!((6 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_0 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_0 = false;
          var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_2 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_24 = $composer_13.g30();
          if (!isInterface(tmp_24, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_2);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_10, 1984524149, 'C639@36572L932:MugImageEditorScreen.kt#mu900e');
          var tmp1_bitmap = element.a12g_1;
          var tmp2_contentScale = Companion_getInstance_13().r96_1;
          var tmp3_filterQuality = Companion_getInstance_27().u6g_1;
          var tmp_25;
          switch (element.f12g_1.a1_1) {
            case 0:
              tmp_25 = null;
              break;
            case 1:
              tmp_25 = Companion_instance_2.j6g(_ColorMatrix___init__impl__3gytx1(get_SepiaMatrix_0()));
              break;
            case 2:
              tmp_25 = Companion_instance_2.j6g(_ColorMatrix___init__impl__3gytx1(get_GrayscaleMatrix_0()));
              break;
            case 3:
              tmp_25 = Companion_instance_2.j6g(_ColorMatrix___init__impl__3gytx1(get_InvertMatrix_0()));
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          var tmp4_colorFilter = tmp_25;
          var tmp5_modifier = fillMaxSize(Companion_instance);
          Image_0(tmp1_bitmap, null, tmp5_modifier, null, tmp2_contentScale, 0.0, tmp4_colorFilter, tmp3_filterQuality, $composer_10, 25008, 40);
          if (isSelected) {
            $composer_10.m30(1985470733);
            sourceInformation($composer_10, '653@37664L11,653@37599L86');
            var tmp_26 = fillMaxSize(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$41 = _Dp___init__impl__ms3zkb(2);
            Box(border(tmp_26, tmp$ret$41, MaterialTheme_instance.unz($composer_10, 6).xnz_1), $composer_10, 0);
            $composer_10.n30();
          } else {
            $composer_10.m30(1985630259);
            $composer_10.n30();
          }
          sourceInformationMarkerEnd($composer_10);
          $composer_13.e31();
          $composer_10.p30();
        }
        $composer_10.n30();
        var tmp_27 = zIndex(fillMaxSize(Companion_instance), 2.0);
        sourceInformationMarkerStart($composer_10, -807283797, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = $composer_10.n31(scaleFit);
        // Inline function 'kotlin.let' call
        var it_3 = $composer_10.i31();
        var tmp_28;
        if (invalid_3 || it_3 === Companion_getInstance().f30_1) {
          var value_3 = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_33(designWidth, scaleFit, designHeight);
          $composer_10.j31(value_3);
          tmp_28 = value_3;
        } else {
          tmp_28 = it_3;
        }
        var tmp0_group_0 = tmp_28;
        sourceInformationMarkerEnd($composer_10);
        Canvas_0(tmp_27, tmp0_group_0, $composer_10, 6);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_29;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_29 = Unit_instance;
        }
        tmp_0 = tmp_29;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_34($textToEdit$delegate, $showTextDialog$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_12($textToEdit$delegate, null);
      BaseMugImageEditorScreen$lambda_10($showTextDialog$delegate, true);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_35($iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C686@39865L72:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-495448441, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:686)');
        }
        var tmp_0 = get_TextFields(Icons_getInstance().dxv_1);
        var tmp_1 = size(Companion_instance, $iconSize);
        Icon(tmp_0, null, tmp_1, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 8);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda_4($fabSize, $textToEdit$delegate, $showTextDialog$delegate, $iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C685@39750L44,685@39831L136,685@39719L248:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-371717883, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:685)');
        }
        sourceInformationMarkerStart($composer_0, -738597999, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_34($textToEdit$delegate, $showTextDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1 = size(Companion_instance, $fabSize);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-495448441, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_35($iconSize), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_4;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_0;
        }
        var tmp$ret$4 = tmp_4;
        FloatingActionButton(tmp0_group, tmp_1, null, tmp_2, tmp_3, null, null, tmp$ret$4, $composer_0, 12582918, 124);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_36($launcher) {
    return function () {
      $launcher.n12v();
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_37($iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C691@40238L74:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1735552304, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:691)');
        }
        var tmp_0 = get_PhotoLibrary(Icons_getInstance().dxv_1);
        var tmp_1 = size(Companion_instance, $iconSize);
        Icon(tmp_0, null, tmp_1, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 8);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda_5($launcher, $fabSize, $iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C690@40139L28,690@40204L138,690@40108L234:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(381534254, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:690)');
        }
        sourceInformationMarkerStart($composer_0, 1582199914, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($launcher);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_36($launcher);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1 = size(Companion_instance, $fabSize);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1735552304, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_37($iconSize), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_4;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_0;
        }
        var tmp$ret$4 = tmp_4;
        FloatingActionButton(tmp0_group, tmp_1, null, tmp_2, tmp_3, null, null, tmp$ret$4, $composer_0, 12582912, 124);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_38($launcher) {
    return function () {
      $launcher.o12v();
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_39($iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C696@40613L73:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2047658511, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:696)');
        }
        var tmp_0 = get_PhotoCamera(Icons_getInstance().dxv_1);
        var tmp_1 = size(Companion_instance, $iconSize);
        Icon(tmp_0, null, tmp_1, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 8);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda_6($launcher, $fabSize, $iconSize) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C695@40515L27,695@40579L137,695@40484L232:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(693640461, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:695)');
        }
        sourceInformationMarkerStart($composer_0, 868554120, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($launcher);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_38($launcher);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1 = size(Companion_instance, $fabSize);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(2047658511, true, BaseMugImageEditorScreen$lambda$lambda$lambda$lambda_39($iconSize), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_4;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_0;
        }
        var tmp$ret$4 = tmp_4;
        FloatingActionButton(tmp0_group, tmp_1, null, tmp_2, tmp_3, null, null, tmp$ret$4, $composer_0, 12582912, 124);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda_1($selectedId$delegate, $density, $images, $textToEdit$delegate, $showTextDialog$delegate, $launcher) {
    return function (padding_0, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C534@30510L10286:MugImageEditorScreen.kt#mu900e');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31(padding_0) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(935278353, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous> (MugImageEditorScreen.kt:534)');
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = padding(fillMaxSize(Companion_instance), padding_0);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 475052106, 'C543@30854L43,544@30916L8132,539@30656L8392,675@39105L1677:MugImageEditorScreen.kt#mu900e');
        var tmp_2 = background(fillMaxSize(Companion_instance), Color(new Long(-15066598, 0)));
        sourceInformationMarkerStart($composer_5, -400321482, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_5.i31();
        var tmp_3;
        if (false || it === Companion_getInstance().f30_1) {
          var tmp_4 = BaseMugImageEditorScreen$lambda$lambda$slambda_0($selectedId$delegate, null);
          var value = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_3(tmp_4);
          $composer_5.j31(value);
          tmp_3 = value;
        } else {
          tmp_3 = it;
        }
        var tmp0_group = tmp_3;
        sourceInformationMarkerEnd($composer_5);
        var tmp_5 = pointerInput(tmp_2, Unit_instance, tmp0_group);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(185282229, true, BaseMugImageEditorScreen$lambda$lambda$lambda_3($density, $images, $selectedId$delegate), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_6 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_6.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_6.i31();
        var tmp_6;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_12(dispatchReceiver);
          $composer_6.j31(value_0);
          tmp_6 = value_0;
        } else {
          tmp_6 = it_0;
        }
        var tmp$ret$10 = tmp_6;
        BoxWithConstraints(tmp_5, null, false, tmp$ret$10, $composer_5, 3072, 6);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = fillMaxSize(Companion_instance);
        var contentAlignment_0 = null;
        var propagateMinConstraints_0 = false;
        var $composer_7 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_8 = $composer_7;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
        var localMap_0 = $composer_8.t31();
        var materialized_0 = materialize($composer_8, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_9 = $composer_8;
        var tmp_7 = $composer_9.g30();
        if (!isInterface(tmp_7, Applier)) {
          invalidApplier();
        }
        $composer_9.b31();
        if ($composer_9.h30()) {
          $composer_9.c31(tmp0_0);
        } else {
          $composer_9.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_10 = $composer_9;
        var $composer_11 = $composer_10;
        sourceInformationMarkerStart($composer_11, 2129397578, 'C677@39208L1556:MugImageEditorScreen.kt#mu900e');
        var tmp_8 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().s8t_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_9 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$24 = _Dp___init__impl__ms3zkb(16);
        var tmp0_1 = padding_1(tmp_8, VOID, VOID, tmp_9, tmp$ret$24);
        var tmp_10 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$25 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_3 = tmp0_1;
        var verticalArrangement = tmp_10.mdq(tmp$ret$25);
        var horizontalAlignment = null;
        var $composer_12 = $composer_11;
        if (!((4 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((4 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((4 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_1 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_12, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_13 = $composer_12;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_13, 0).hashCode();
        var localMap_1 = $composer_13.t31();
        var materialized_1 = materialize($composer_13, modifier_4);
        var tmp0_2 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_14 = $composer_13;
        var tmp_11 = $composer_14.g30();
        if (!isInterface(tmp_11, Applier)) {
          invalidApplier();
        }
        $composer_14.b31();
        if ($composer_14.h30()) {
          $composer_14.c31(tmp0_2);
        } else {
          $composer_14.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_14);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_15 = $composer_14;
        var $composer_16 = $composer_15;
        sourceInformationMarkerStart($composer_16, -1235662588, 'C684@39644L43,684@39689L304,684@39630L363,689@40032L44,689@40078L290,689@40018L350,694@40407L45,694@40454L288,694@40393L349:MugImageEditorScreen.kt#mu900e');
        var tmp_12;
        if (!(BaseMugImageEditorScreen$lambda_5($selectedId$delegate) == null)) {
          // Inline function 'androidx.compose.ui.unit.dp' call
          tmp_12 = _Dp___init__impl__ms3zkb(40);
        } else {
          // Inline function 'androidx.compose.ui.unit.dp' call
          tmp_12 = _Dp___init__impl__ms3zkb(56);
        }
        var fabSize = tmp_12;
        var tmp_13;
        if (!(BaseMugImageEditorScreen$lambda_5($selectedId$delegate) == null)) {
          // Inline function 'androidx.compose.ui.unit.dp' call
          tmp_13 = _Dp___init__impl__ms3zkb(20);
        } else {
          // Inline function 'androidx.compose.ui.unit.dp' call
          tmp_13 = _Dp___init__impl__ms3zkb(24);
        }
        var iconSize = tmp_13;
        var tmp_14 = stringResource(get_tooltip_add_text(string_instance), $composer_16, 0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-371717883, true, BaseMugImageEditorScreen$lambda$lambda$lambda_4(fabSize, $textToEdit$delegate, $showTextDialog$delegate, iconSize), $composer_16, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_17 = $composer_16;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_17.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_17.i31();
        var tmp_15;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_1 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_17.j31(value_1);
          tmp_15 = value_1;
        } else {
          tmp_15 = it_1;
        }
        var tmp$ret$36 = tmp_15;
        EditorTooltip(tmp_14, tmp$ret$36, $composer_16, 48);
        var tmp_16 = stringResource(get_tooltip_add_photo(string_instance), $composer_16, 0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(381534254, true, BaseMugImageEditorScreen$lambda$lambda$lambda_5($launcher, fabSize, iconSize), $composer_16, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_18 = $composer_16;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_18.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_2 = $composer_18.i31();
        var tmp_17;
        if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
          var value_2 = ComposableLambda$invoke$ref(dispatchReceiver_1);
          $composer_18.j31(value_2);
          tmp_17 = value_2;
        } else {
          tmp_17 = it_2;
        }
        var tmp$ret$43 = tmp_17;
        EditorTooltip(tmp_16, tmp$ret$43, $composer_16, 48);
        var tmp_18 = stringResource(get_tooltip_take_photo(string_instance), $composer_16, 0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_2 = rememberComposableLambda(693640461, true, BaseMugImageEditorScreen$lambda$lambda$lambda_6($launcher, fabSize, iconSize), $composer_16, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_19 = $composer_16;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_19.k31(dispatchReceiver_2);
        // Inline function 'kotlin.let' call
        var it_3 = $composer_19.i31();
        var tmp_19;
        if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
          var value_3 = ComposableLambda$invoke$ref(dispatchReceiver_2);
          $composer_19.j31(value_3);
          tmp_19 = value_3;
        } else {
          tmp_19 = it_3;
        }
        var tmp$ret$50 = tmp_19;
        EditorTooltip(tmp_18, tmp$ret$50, $composer_16, 48);
        sourceInformationMarkerEnd($composer_16);
        $composer_14.e31();
        sourceInformationMarkerEnd($composer_11);
        $composer_9.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_20;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_20 = Unit_instance;
        }
        tmp_0 = tmp_20;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda_22($handleBack, $scope, $onDone, $isProcessing$delegate, $images, $selectedId$delegate, $showSettings$delegate, $textToBitmap, $textToEdit$delegate, $showTextDialog$delegate, $initialColorForPicker$delegate, $colorToEdit$delegate, $showColorPicker$delegate, $getFontFamily, $density, $launcher) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C333@13142L1578,366@14746L15728,533@30485L10321,330@13022L27784:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1313235906, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous> (MugImageEditorScreen.kt:330)');
        }
        var tmp0_modifier = fillMaxSize(Companion_instance);
        var tmp1_containerColor = Companion_getInstance_14().i6b_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1362557318, true, BaseMugImageEditorScreen$lambda$lambda($handleBack, $scope, $onDone, $isProcessing$delegate, $images), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp_1 = tmp_0;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(1002097607, true, BaseMugImageEditorScreen$lambda$lambda_0($images, $selectedId$delegate, $showSettings$delegate, $textToBitmap, $textToEdit$delegate, $showTextDialog$delegate, $initialColorForPicker$delegate, $colorToEdit$delegate, $showColorPicker$delegate, $getFontFamily), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_2.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_2.i31();
        var tmp_2;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_2.j31(value_0);
          tmp_2 = value_0;
        } else {
          tmp_2 = it_0;
        }
        var tmp_3 = tmp_2;
        var tmp_4 = _FabPosition___init__impl__9ib2hj(0);
        var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(935278353, true, BaseMugImageEditorScreen$lambda$lambda_1($selectedId$delegate, $density, $images, $textToEdit$delegate, $showTextDialog$delegate, $launcher), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_3.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_3.i31();
        var tmp_6;
        if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
          var value_1 = ComposableLambda$invoke$ref_2(dispatchReceiver_1);
          $composer_3.j31(value_1);
          tmp_6 = value_1;
        } else {
          tmp_6 = it_1;
        }
        var tmp$ret$14 = tmp_6;
        Scaffold(tmp0_modifier, tmp_1, tmp_3, null, null, tmp_4, tmp1_containerColor, tmp_5, null, tmp$ret$14, $composer_0, 806879670, 440);
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda_23($textValue$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('textValue', KMutableProperty0, true);
    return $textValue$delegate.u1();
  }
  function BaseMugImageEditorScreen$lambda_24($textValue$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('textValue', KMutableProperty0, true);
    $textValue$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_25($isError$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isError', KMutableProperty0, true);
    return $isError$delegate.u1();
  }
  function BaseMugImageEditorScreen$lambda_26($isError$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isError', KMutableProperty0, true);
    $isError$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_27($textColor$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('textColor', KMutableProperty0, true);
    return $textColor$delegate.u1().c6d_1;
  }
  function BaseMugImageEditorScreen$lambda_28($textColor$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    getLocalDelegateReference('textColor', KMutableProperty0, true);
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new Color_0(_set____db54di);
    $textColor$delegate.s21(value);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_29($fontName$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('fontName', KMutableProperty0, true);
    return $fontName$delegate.u1();
  }
  function BaseMugImageEditorScreen$lambda_30($fontName$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('fontName', KMutableProperty0, true);
    $fontName$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_31($showTextDialog$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_10($showTextDialog$delegate, false);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda_2($textToBitmap, $images, $textValue$delegate, $textColor$delegate, $fontName$delegate, $textToEdit$delegate, $selectedId$delegate, $showTextDialog$delegate, $isError$delegate) {
    return function () {
      var tmp;
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = BaseMugImageEditorScreen$lambda_23($textValue$delegate);
      if (!isBlank(this_0)) {
        var bitmap = $textToBitmap(BaseMugImageEditorScreen$lambda_23($textValue$delegate), new Color_0(BaseMugImageEditorScreen$lambda_27($textColor$delegate)), BaseMugImageEditorScreen$lambda_29($fontName$delegate));
        if (BaseMugImageEditorScreen$lambda_11($textToEdit$delegate) == null) {
          var tmp0_id = Default_getInstance_0().ci();
          var tmp1_text = BaseMugImageEditorScreen$lambda_23($textValue$delegate);
          var tmp2_textColor = BaseMugImageEditorScreen$lambda_27($textColor$delegate);
          var tmp3_fontFamilyName = BaseMugImageEditorScreen$lambda_29($fontName$delegate);
          var newElem = new EditorImageElement(tmp0_id, bitmap, VOID, 2.0, 2.0, VOID, VOID, VOID, VOID, tmp1_text, tmp2_textColor, tmp3_fontFamilyName);
          $images.zz(newElem);
          BaseMugImageEditorScreen$lambda_6($selectedId$delegate, newElem.z12f_1);
        } else {
          var tmp0 = $images;
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.indexOfFirst' call
            var index = 0;
            var _iterator__ex2g4s = tmp0.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              if (equalsLong(item.z12f_1, ensureNotNull(BaseMugImageEditorScreen$lambda_11($textToEdit$delegate)).z12f_1)) {
                tmp$ret$1 = index;
                break $l$block;
              }
              index = index + 1 | 0;
            }
            tmp$ret$1 = -1;
          }
          var i = tmp$ret$1;
          if (!(i === -1)) {
            $images.mi(i, $images.l1(i).m12h(VOID, bitmap, VOID, VOID, VOID, VOID, VOID, VOID, VOID, BaseMugImageEditorScreen$lambda_23($textValue$delegate), BaseMugImageEditorScreen$lambda_27($textColor$delegate), BaseMugImageEditorScreen$lambda_29($fontName$delegate)));
          }
        }
        BaseMugImageEditorScreen$lambda_10($showTextDialog$delegate, false);
        tmp = Unit_instance;
      } else {
        BaseMugImageEditorScreen$lambda_26($isError$delegate, true);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda_32($textToBitmap, $images, $textValue$delegate, $textColor$delegate, $fontName$delegate, $textToEdit$delegate, $selectedId$delegate, $showTextDialog$delegate, $isError$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C754@44390L887,754@44369L955:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1139190763, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous> (MugImageEditorScreen.kt:754)');
        }
        sourceInformationMarkerStart($composer_0, 454339372, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($textToBitmap);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = BaseMugImageEditorScreen$lambda$lambda_2($textToBitmap, $images, $textValue$delegate, $textColor$delegate, $fontName$delegate, $textToEdit$delegate, $selectedId$delegate, $showTextDialog$delegate, $isError$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$MugImageEditorScreenKt_getInstance().m12r_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda_3($showTextDialog$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_10($showTextDialog$delegate, false);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda_33($showTextDialog$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C769@45391L26,769@45370L92:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-568918957, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous> (MugImageEditorScreen.kt:769)');
        }
        sourceInformationMarkerStart($composer_0, -1270270323, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = BaseMugImageEditorScreen$lambda$lambda_3($showTextDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$MugImageEditorScreenKt_getInstance().n12r_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda_34($textToEdit$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C713@41262L119:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1352849, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous> (MugImageEditorScreen.kt:713)');
        }
        var tmp_0;
        if (BaseMugImageEditorScreen$lambda_11($textToEdit$delegate) == null) {
          $composer_0.m30(1300088922);
          sourceInformation($composer_0, '713@41291L41');
          var tmp0_group = stringResource(get_add_text_title(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp0_group;
        } else {
          $composer_0.m30(1300090427);
          sourceInformation($composer_0, '713@41338L42');
          var tmp1_group = stringResource(get_edit_text_title(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp1_group;
        }
        var tmp_1 = tmp_0;
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function sam$androidx_compose_ui_text_input_VisualTransformation$0(function_0) {
    this.p12v_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_text_input_VisualTransformation$0).n8d = function (text) {
    return this.p12v_1(text);
  };
  protoOf(sam$androidx_compose_ui_text_input_VisualTransformation$0).q3 = function () {
    return this.p12v_1;
  };
  protoOf(sam$androidx_compose_ui_text_input_VisualTransformation$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, VisualTransformation) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_text_input_VisualTransformation$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function BaseMugImageEditorScreen$lambda$lambda_4($getFontFamily, $emojiFont, $fontName$delegate) {
    return function (text) {
      return new TransformedText(toEmojiAnnotatedString(text.h7q_1, $getFontFamily(BaseMugImageEditorScreen$lambda_29($fontName$delegate)), $emojiFont), Companion_getInstance_30().q8c_1);
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda_5($textValue$delegate, $isError$delegate) {
    return function (it) {
      BaseMugImageEditorScreen$lambda_24($textValue$delegate, it);
      var tmp;
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(it)) {
        BaseMugImageEditorScreen$lambda_26($isError$delegate, false);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda_6($isError$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1910917007, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:732)');
        }
        if (BaseMugImageEditorScreen$lambda_25($isError$delegate)) {
          $composer_0.m30(1854759535);
          sourceInformation($composer_0, '732@42419L47,732@42490L11,732@42414L94');
          var tmp_0 = stringResource(get_text_cannot_be_empty(string_instance), $composer_0, 0);
          var tmp_1 = MaterialTheme_instance.unz($composer_0, 6).to0_1;
          var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_5 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_0, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 0, 0, 262138);
          $composer_0.n30();
        } else {
          $composer_0.m30(1663061073);
          $composer_0.n30();
        }
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda_7($color, $textColor$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_28($textColor$delegate, $color);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda$lambda_7($textColor$delegate) {
    return function (it) {
      BaseMugImageEditorScreen$lambda_28($textColor$delegate, it.c6d_1);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda_8($textColor$delegate, $initialColorForPicker$delegate, $colorToEdit$delegate, $showColorPicker$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_18($initialColorForPicker$delegate, BaseMugImageEditorScreen$lambda_27($textColor$delegate));
      BaseMugImageEditorScreen$lambda_16($colorToEdit$delegate, BaseMugImageEditorScreen$lambda$lambda$lambda_7($textColor$delegate));
      BaseMugImageEditorScreen$lambda_14($showColorPicker$delegate, true);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda_9($font, $fontName$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_30($fontName$delegate, $font);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda_10($font, $getFontFamily) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C748@44194L44:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-67793630, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:748)');
        }
        var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_2 = $getFontFamily($font);
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text($font, null, tmp_0, null, tmp_1, null, null, tmp_2, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 0, 0, 262014);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda_35($getFontFamily, $emojiFont, $textValue$delegate, $isError$delegate, $textColor$delegate, $fontName$delegate, $initialColorForPicker$delegate, $colorToEdit$delegate, $showColorPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C715@41422L2885:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(286488752, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous> (MugImageEditorScreen.kt:715)');
        }
        var tmp_0 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = null;
        var verticalArrangement = tmp_0.mdq(tmp$ret$0);
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((5 & 1) === 0))
          modifier = Companion_instance;
        if (!((5 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((5 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -791068379, 'C726@42089L267,718@41595L56,732@42399L111,716@41501L1031,734@42558L40,734@42622L10,734@42553L91,735@42695L21,735@42665L1020,745@43711L39,745@43774L10,745@43706L90,746@43847L21,746@43817L472:MugImageEditorScreen.kt#mu900e');
        var tmp0_value = BaseMugImageEditorScreen$lambda_23($textValue$delegate);
        var tmp1_modifier = fillMaxWidth(Companion_instance);
        var tmp2_isError = BaseMugImageEditorScreen$lambda_25($isError$delegate);
        var tmp3_textStyle = TextStyle_init_$Create$(BaseMugImageEditorScreen$lambda_27($textColor$delegate), VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_29().r7u_1);
        sourceInformationMarkerStart($composer_5, 944329285, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_5.k31($getFontFamily) | $composer_5.k31($emojiFont));
        // Inline function 'kotlin.let' call
        var it = $composer_5.i31();
        var tmp_2;
        if (invalid || it === Companion_getInstance().f30_1) {
          var tmp_3 = BaseMugImageEditorScreen$lambda$lambda_4($getFontFamily, $emojiFont, $fontName$delegate);
          var value = new sam$androidx_compose_ui_text_input_VisualTransformation$0(tmp_3);
          $composer_5.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_5);
        sourceInformationMarkerStart($composer_5, 944313266, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_0 = $composer_5.i31();
        var tmp_4;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var value_0 = BaseMugImageEditorScreen$lambda$lambda_5($textValue$delegate, $isError$delegate);
          $composer_5.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_0;
        }
        var tmp1_group = tmp_4;
        sourceInformationMarkerEnd($composer_5);
        var tmp_5 = ComposableSingletons$MugImageEditorScreenKt_getInstance().o12r_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1910917007, true, BaseMugImageEditorScreen$lambda$lambda_6($isError$delegate), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_6 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_6.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_6.i31();
        var tmp_6;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_1 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_6.j31(value_1);
          tmp_6 = value_1;
        } else {
          tmp_6 = it_1;
        }
        var tmp_7 = tmp_6;
        TextField(tmp0_value, tmp1_group, tmp1_modifier, false, false, tmp3_textStyle, null, tmp_5, null, null, null, null, tmp_7, tmp2_isError, tmp0_group, null, null, false, 0, 0, null, null, null, $composer_5, 12583344, 384, 0, 8359768);
        var tmp_8 = stringResource(get_color_setting(string_instance), $composer_5, 0);
        var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_13 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_8, null, tmp_9, null, tmp_10, null, null, null, tmp_11, null, null, tmp_12, tmp_13, false, 0, 0, null, MaterialTheme_instance.jog($composer_5, 6).tof_1, $composer_5, 0, 0, 131070);
        var tmp_14 = Companion_instance;
        var tmp0_0 = horizontalScroll(tmp_14, rememberScrollState(0, $composer_5, 0, 1));
        var tmp_15 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$22 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_1 = tmp0_0;
        var horizontalArrangement = tmp_15.mdq(tmp$ret$22);
        var verticalAlignment = null;
        var $composer_7 = $composer_5;
        if (!((4 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((4 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((4 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_7, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_8 = $composer_7;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
        var localMap_0 = $composer_8.t31();
        var materialized_0 = materialize($composer_8, modifier_2);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_9 = $composer_8;
        var tmp_16 = $composer_9.g30();
        if (!isInterface(tmp_16, Applier)) {
          invalidApplier();
        }
        $composer_9.b31();
        if ($composer_9.h30()) {
          $composer_9.c31(tmp0_1);
        } else {
          $composer_9.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_10 = $composer_9;
        var $composer_11 = $composer_10;
        sourceInformationMarkerStart($composer_11, 1514715979, 'C739@43337L201,739@43161L502:MugImageEditorScreen.kt#mu900e');
        $composer_11.m30(-1752251466);
        sourceInformation($composer_11, '*737@43044L11,737@43088L21,737@42927L183');
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = listOf_0([new Color_0(Companion_getInstance_14().i6b_1), new Color_0(Companion_getInstance_14().n6b_1), new Color_0(Companion_getInstance_14().p6b_1), new Color_0(Companion_getInstance_14().o6b_1), new Color_0(Companion_getInstance_14().q6b_1), new Color_0(Companion_getInstance_14().m6b_1)]).t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          var color = element.c6d_1;
          var tmp_17 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$31 = _Dp___init__impl__ms3zkb(32);
          var tmp_18 = background(size(tmp_17, tmp$ret$31), color, get_CircleShape());
          var tmp_19;
          if (equals(BaseMugImageEditorScreen$lambda_27($textColor$delegate), color)) {
            // Inline function 'androidx.compose.ui.unit.dp' call
            tmp_19 = _Dp___init__impl__ms3zkb(2);
          } else {
            // Inline function 'androidx.compose.ui.unit.dp' call
            tmp_19 = _Dp___init__impl__ms3zkb(0);
          }
          var tmp_20 = border(tmp_18, tmp_19, MaterialTheme_instance.unz($composer_11, 6).xnz_1, get_CircleShape());
          sourceInformationMarkerStart($composer_11, -1716143009, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_1 = $composer_11.o31(_ULong___get_data__impl__fggpzb(_Color___get_value__impl__1pls5m(color)));
          // Inline function 'kotlin.let' call
          var it_2 = $composer_11.i31();
          var tmp_21;
          if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
            var value_2 = BaseMugImageEditorScreen$lambda$lambda_7(color, $textColor$delegate);
            $composer_11.j31(value_2);
            tmp_21 = value_2;
          } else {
            tmp_21 = it_2;
          }
          var tmp0_group_0 = tmp_21;
          sourceInformationMarkerEnd($composer_11);
          Box(clickable(tmp_20, VOID, VOID, VOID, VOID, tmp0_group_0), $composer_11, 0);
        }
        $composer_11.n30();
        var tmp_22 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$38 = _Dp___init__impl__ms3zkb(32);
        var tmp_23 = background_0(size(tmp_22, tmp$ret$38), Companion_instance_1.h6c(listOf_0([new Color_0(Companion_getInstance_14().n6b_1), new Color_0(Companion_getInstance_14().q6b_1), new Color_0(Companion_getInstance_14().o6b_1), new Color_0(Companion_getInstance_14().r6b_1), new Color_0(Companion_getInstance_14().p6b_1), new Color_0(Companion_getInstance_14().s6b_1), new Color_0(Companion_getInstance_14().n6b_1)])), get_CircleShape());
        sourceInformationMarkerStart($composer_11, -1752236897, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_3 = $composer_11.i31();
        var tmp_24;
        if (false || it_3 === Companion_getInstance().f30_1) {
          var value_3 = BaseMugImageEditorScreen$lambda$lambda_8($textColor$delegate, $initialColorForPicker$delegate, $colorToEdit$delegate, $showColorPicker$delegate);
          $composer_11.j31(value_3);
          tmp_24 = value_3;
        } else {
          tmp_24 = it_3;
        }
        var tmp0_group_1 = tmp_24;
        sourceInformationMarkerEnd($composer_11);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = clickable(tmp_23, VOID, VOID, VOID, VOID, tmp0_group_1);
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_12 = $composer_11;
        if (!((4 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_13 = $composer_12;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_13, 0).hashCode();
        var localMap_1 = $composer_13.t31();
        var materialized_1 = materialize($composer_13, modifier_4);
        var tmp0_2 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_14 = $composer_13;
        var tmp_25 = $composer_14.g30();
        if (!isInterface(tmp_25, Applier)) {
          invalidApplier();
        }
        $composer_14.b31();
        if ($composer_14.h30()) {
          $composer_14.c31(tmp0_2);
        } else {
          $composer_14.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_14);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_15 = $composer_14;
        var $composer_16 = $composer_15;
        sourceInformationMarkerStart($composer_16, 432178785, 'C743@43579L82:MugImageEditorScreen.kt#mu900e');
        var tmp_26 = get_Add(Icons_getInstance().dxv_1);
        var tmp_27 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$49 = _Dp___init__impl__ms3zkb(16);
        Icon(tmp_26, null, size(tmp_27, tmp$ret$49), Companion_getInstance_14().m6b_1, $composer_16, 3504, 0);
        sourceInformationMarkerEnd($composer_16);
        $composer_14.e31();
        sourceInformationMarkerEnd($composer_11);
        $composer_9.e31();
        var tmp_28 = stringResource(get_font_setting(string_instance), $composer_5, 0);
        var tmp_29 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_30 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_31 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_32 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_33 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_28, null, tmp_29, null, tmp_30, null, null, null, tmp_31, null, null, tmp_32, tmp_33, false, 0, 0, null, MaterialTheme_instance.jog($composer_5, 6).tof_1, $composer_5, 0, 0, 131070);
        var tmp_34 = Companion_instance;
        var tmp0_3 = horizontalScroll(tmp_34, rememberScrollState(0, $composer_5, 0, 1));
        var tmp_35 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$50 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_5 = tmp0_3;
        var horizontalArrangement_0 = tmp_35.mdq(tmp$ret$50);
        var verticalAlignment_0 = null;
        var $composer_17 = $composer_5;
        if (!((4 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((4 & 2) === 0))
          horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
        if (!((4 & 4) === 0))
          verticalAlignment_0 = Companion_getInstance_11().t8t_1;
        var measurePolicy_2 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_17, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_18 = $composer_17;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_18, 0).hashCode();
        var localMap_2 = $composer_18.t31();
        var materialized_2 = materialize($composer_18, modifier_6);
        var tmp0_4 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_19 = $composer_18;
        var tmp_36 = $composer_19.g30();
        if (!isInterface(tmp_36, Applier)) {
          invalidApplier();
        }
        $composer_19.b31();
        if ($composer_19.h30()) {
          $composer_19.c31(tmp0_4);
        } else {
          $composer_19.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_19);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_20 = $composer_19;
        var $composer_21 = $composer_20;
        sourceInformationMarkerStart($composer_21, -91338266, 'C:MugImageEditorScreen.kt#mu900e');
        $composer_21.m30(828341255);
        sourceInformation($composer_21, '*748@44163L19,748@44192L48,748@44113L128');
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = listOf_0(['tajawal', 'cairo', 'noto_sans_arabic', 'vazirmatn', 'ibm_plex_sans_arabic', 'readex_pro', 'amiri', 'almarai']).t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          var tmp_37 = BaseMugImageEditorScreen$lambda_29($fontName$delegate) === element_0;
          sourceInformationMarkerStart($composer_21, 1278430722, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_2 = $composer_21.k31(element_0);
          // Inline function 'kotlin.let' call
          var it_4 = $composer_21.i31();
          var tmp_38;
          if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
            var value_4 = BaseMugImageEditorScreen$lambda$lambda_9(element_0, $fontName$delegate);
            $composer_21.j31(value_4);
            tmp_38 = value_4;
          } else {
            tmp_38 = it_4;
          }
          var tmp0_group_2 = tmp_38;
          sourceInformationMarkerEnd($composer_21);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_0 = rememberComposableLambda(-67793630, true, BaseMugImageEditorScreen$lambda$lambda_10(element_0, $getFontFamily), $composer_21, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_22 = $composer_21;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_3 = $composer_22.k31(dispatchReceiver_0);
          // Inline function 'kotlin.let' call
          var it_5 = $composer_22.i31();
          var tmp_39;
          if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
            var value_5 = ComposableLambda$invoke$ref(dispatchReceiver_0);
            $composer_22.j31(value_5);
            tmp_39 = value_5;
          } else {
            tmp_39 = it_5;
          }
          var tmp_40 = tmp_39;
          FilterChip(tmp_37, tmp0_group_2, tmp_40, null, false, null, null, null, null, null, null, null, $composer_21, 384, 0, 4088);
        }
        $composer_21.n30();
        sourceInformationMarkerEnd($composer_21);
        $composer_19.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_41;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_41 = Unit_instance;
        }
        tmp = tmp_41;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda_36($showDiscardDialog$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_0($showDiscardDialog$delegate, false);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda_11($onCancel, $showDiscardDialog$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_0($showDiscardDialog$delegate, false);
      $onCancel();
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda_37($onCancel, $showDiscardDialog$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C779@45816L41,779@45795L189:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-220990068, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous> (MugImageEditorScreen.kt:779)');
        }
        sourceInformationMarkerStart($composer_0, -1918056555, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($onCancel);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = BaseMugImageEditorScreen$lambda$lambda_11($onCancel, $showDiscardDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$MugImageEditorScreenKt_getInstance().p12r_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda$lambda_12($showDiscardDialog$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_0($showDiscardDialog$delegate, false);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda_38($showDiscardDialog$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C783@46051L29,783@46030L95:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1945598390, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BaseMugImageEditorScreen.<anonymous> (MugImageEditorScreen.kt:783)');
        }
        sourceInformationMarkerStart($composer_0, -1409278265, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = BaseMugImageEditorScreen$lambda$lambda_12($showDiscardDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$MugImageEditorScreenKt_getInstance().q12r_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda_39($colorToEdit$delegate) {
    return function (it) {
      var tmp0_safe_receiver = BaseMugImageEditorScreen$lambda_15($colorToEdit$delegate);
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(it);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda_40($showColorPicker$delegate) {
    return function () {
      BaseMugImageEditorScreen$lambda_14($showColorPicker$delegate, false);
      return Unit_instance;
    };
  }
  function BaseMugImageEditorScreen$lambda_41() {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    return Unit_instance;
  }
  function BaseMugImageEditorScreen$lambda_42($initialElements, $onDone, $onCancel, $$changed, $$default) {
    return function ($composer, $force) {
      BaseMugImageEditorScreen($initialElements._v, $onDone, $onCancel, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function EditorTooltip$lambda$lambda($tooltip) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C168@7264L13:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1103810018, $changed, -1, 'client.fstech.hadaya.presentation.model3d.EditorTooltip.<anonymous>.<anonymous> (MugImageEditorScreen.kt:168)');
        }
        var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text($tooltip, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function EditorTooltip$lambda($tooltip) {
    return function ($this$TooltipBox, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C167@7246L45,167@7233L58:MugImageEditorScreen.kt#mu900e');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31($this$TooltipBox) : $composer_0.q31($this$TooltipBox)) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(985349680, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.EditorTooltip.<anonymous> (MugImageEditorScreen.kt:167)');
        }
        var tmp_1 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_4 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_5 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1103810018, true, EditorTooltip$lambda$lambda($tooltip), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_6;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value);
          tmp_6 = value;
        } else {
          tmp_6 = it;
        }
        var tmp$ret$0 = tmp_6;
        PlainTooltip($this$TooltipBox, null, null, tmp_1, null, tmp_2, tmp_3, tmp_4, tmp_5, tmp$ret$0, $composer_0, 805306368 | 14 & $dirty, 255);
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp_0 = tmp_7;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_13(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function EditorTooltip$lambda_0($content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C173@7358L9:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1091916360, $changed, -1, 'client.fstech.hadaya.presentation.model3d.EditorTooltip.<anonymous> (MugImageEditorScreen.kt:173)');
        }
        $content($composer_0, 0);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function EditorTooltip$lambda_1($tooltip, $content, $$changed) {
    return function ($composer, $force) {
      EditorTooltip($tooltip, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function SimpleColorPickerDialog$lambda($hue$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('hue', KMutableProperty0, true);
    return $hue$delegate.u1();
  }
  function SimpleColorPickerDialog$lambda_0($hue$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('hue', KMutableProperty0, true);
    $hue$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function SimpleColorPickerDialog$lambda_1($saturation$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('saturation', KMutableProperty0, true);
    return $saturation$delegate.u1();
  }
  function SimpleColorPickerDialog$lambda_2($saturation$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('saturation', KMutableProperty0, true);
    $saturation$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function SimpleColorPickerDialog$lambda_3($value$delegate) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('value', KMutableProperty0, true);
    return $value$delegate.u1();
  }
  function SimpleColorPickerDialog$lambda_4($value$delegate, _set____db54di) {
    _init_properties_MugImageEditorScreen_kt__l1nhhx();
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('value', KMutableProperty0, true);
    $value$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function SimpleColorPickerDialog$hsvToColor(h, s, v) {
    var c = v * s;
    // Inline function 'kotlin.math.abs' call
    var x = h / 60.0 % 2 - 1;
    var x_0 = c * (1 - Math.abs(x));
    var m = v - c;
    var _destruct__k2r9zo = h < 60 ? new Triple(c, x_0, 0.0) : h < 120 ? new Triple(x_0, c, 0.0) : h < 180 ? new Triple(0.0, c, x_0) : h < 240 ? new Triple(0.0, x_0, c) : h < 300 ? new Triple(x_0, 0.0, c) : new Triple(c, 0.0, x_0);
    var r_res = _destruct__k2r9zo.zh();
    var g_res = _destruct__k2r9zo.ai();
    var b_res = _destruct__k2r9zo.hr();
    return Color_1(r_res + m, g_res + m, b_res + m);
  }
  function SimpleColorPickerDialog$lambda$lambda($onColorSelected, $onDismiss, $hue$delegate, $saturation$delegate, $value$delegate) {
    return function () {
      $onColorSelected(new Color_0(SimpleColorPickerDialog$hsvToColor(SimpleColorPickerDialog$lambda($hue$delegate), SimpleColorPickerDialog$lambda_1($saturation$delegate), SimpleColorPickerDialog$lambda_3($value$delegate))));
      $onDismiss();
      return Unit_instance;
    };
  }
  function SimpleColorPickerDialog$lambda_5($onColorSelected, $onDismiss, $hue$delegate, $saturation$delegate, $value$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C887@51674L68,887@51653L136:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1001323014, $changed, -1, 'client.fstech.hadaya.presentation.model3d.SimpleColorPickerDialog.<anonymous> (MugImageEditorScreen.kt:887)');
        }
        sourceInformationMarkerStart($composer_0, -198741346, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.k31($onColorSelected) | $composer_0.k31($onDismiss));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = SimpleColorPickerDialog$lambda$lambda($onColorSelected, $onDismiss, $hue$delegate, $saturation$delegate, $value$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$MugImageEditorScreenKt_getInstance().t12r_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SimpleColorPickerDialog$lambda_6($onDismiss) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C888@51819L75:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(893010872, $changed, -1, 'client.fstech.hadaya.presentation.model3d.SimpleColorPickerDialog.<anonymous> (MugImageEditorScreen.kt:888)');
        }
        TextButton($onDismiss, null, false, null, null, null, null, null, null, ComposableSingletons$MugImageEditorScreenKt_getInstance().u12r_1, $composer_0, 805306368, 510);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4(function_0) {
    this.q12v_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4).ka7 = function (_this__u8e3s4, $completion) {
    return this.q12v_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4).q3 = function () {
    return this.q12v_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4).hashCode = function () {
    return hashCode(this.q3());
  };
  function SimpleColorPickerDialog$lambda$slambda$lambda($this_pointerInput, $saturation$delegate, $value$delegate) {
    return function (change, _unused_var__etf5q3) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_0 = change.ka0_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp = floatFromBits(bits);
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = $this_pointerInput.q95();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      var tmp$ret$4 = convertToInt(shiftRight(value_0, 32));
      SimpleColorPickerDialog$lambda_2($saturation$delegate, coerceIn(tmp / tmp$ret$4, 0.0, 1.0));
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_2 = change.ka0_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_1 = _Offset___get_packedValue__impl__xh2k8q(this_2);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
      var tmp_0 = floatFromBits(bits_0);
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_3 = $this_pointerInput.q95();
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_2 = _IntSize___get_packedValue__impl__uho7jf(this_3);
      var tmp$ret$10 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      SimpleColorPickerDialog$lambda_4($value$delegate, coerceIn(1.0 - tmp_0 / tmp$ret$10, 0.0, 1.0));
      return Unit_instance;
    };
  }
  function SimpleColorPickerDialog$lambda$slambda($saturation$delegate, $value$delegate, resultContinuation) {
    this.z12v_1 = $saturation$delegate;
    this.a12w_1 = $value$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SimpleColorPickerDialog$lambda$slambda).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SimpleColorPickerDialog$lambda$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SimpleColorPickerDialog$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = detectDragGestures(this.b12w_1, VOID, VOID, VOID, SimpleColorPickerDialog$lambda$slambda$lambda(this.b12w_1, this.z12v_1, this.a12w_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SimpleColorPickerDialog$lambda$slambda).wc6 = function ($this$pointerInput, completion) {
    var i = new SimpleColorPickerDialog$lambda$slambda(this.z12v_1, this.a12w_1, completion);
    i.b12w_1 = $this$pointerInput;
    return i;
  };
  function SimpleColorPickerDialog$lambda$slambda_0($saturation$delegate, $value$delegate, resultContinuation) {
    var i = new SimpleColorPickerDialog$lambda$slambda($saturation$delegate, $value$delegate, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function SimpleColorPickerDialog$lambda$slambda$lambda_0($this_pointerInput, $saturation$delegate, $value$delegate) {
    return function (offset) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_0 = offset.e5d_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp = floatFromBits(bits);
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = $this_pointerInput.q95();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      var tmp$ret$4 = convertToInt(shiftRight(value_0, 32));
      SimpleColorPickerDialog$lambda_2($saturation$delegate, coerceIn(tmp / tmp$ret$4, 0.0, 1.0));
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_2 = offset.e5d_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_1 = _Offset___get_packedValue__impl__xh2k8q(this_2);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
      var tmp_0 = floatFromBits(bits_0);
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_3 = $this_pointerInput.q95();
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_2 = _IntSize___get_packedValue__impl__uho7jf(this_3);
      var tmp$ret$10 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      SimpleColorPickerDialog$lambda_4($value$delegate, coerceIn(1.0 - tmp_0 / tmp$ret$10, 0.0, 1.0));
      return Unit_instance;
    };
  }
  function SimpleColorPickerDialog$lambda$slambda_1($saturation$delegate, $value$delegate, resultContinuation) {
    this.k12w_1 = $saturation$delegate;
    this.l12w_1 = $value$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SimpleColorPickerDialog$lambda$slambda_1).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SimpleColorPickerDialog$lambda$slambda_1).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SimpleColorPickerDialog$lambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = detectTapGestures(this.m12w_1, VOID, VOID, VOID, SimpleColorPickerDialog$lambda$slambda$lambda_0(this.m12w_1, this.k12w_1, this.l12w_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SimpleColorPickerDialog$lambda$slambda_1).wc6 = function ($this$pointerInput, completion) {
    var i = new SimpleColorPickerDialog$lambda$slambda_1(this.k12w_1, this.l12w_1, completion);
    i.m12w_1 = $this$pointerInput;
    return i;
  };
  function SimpleColorPickerDialog$lambda$slambda_2($saturation$delegate, $value$delegate, resultContinuation) {
    var i = new SimpleColorPickerDialog$lambda$slambda_1($saturation$delegate, $value$delegate, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function SimpleColorPickerDialog$lambda$lambda$lambda($hue$delegate, $saturation$delegate, $value$delegate) {
    return function ($this$Canvas) {
      var hueColor = SimpleColorPickerDialog$hsvToColor(SimpleColorPickerDialog$lambda($hue$delegate), 1.0, 1.0);
      $this$Canvas.b6q(hueColor);
      var tmp = Companion_instance_1;
      var tmp_0 = listOf_0([new Color_0(Companion_getInstance_14().m6b_1), new Color_0(Companion_getInstance_14().t6b_1)]);
      var tmp_1 = Companion_getInstance_24().g5d_1;
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_0 = $this$Canvas.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val1 = floatFromBits(bits);
      var v1 = fromInt(toRawBits(val1));
      var v2 = fromInt(toRawBits(0.0));
      var tmp$ret$5 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      var tmp$ret$4 = _Offset___init__impl__c168vi(tmp$ret$5);
      $this$Canvas.a6q(tmp.x6b(tmp_0, tmp_1, tmp$ret$4));
      var tmp_2 = Companion_instance_1;
      var tmp_3 = listOf_0([new Color_0(Companion_getInstance_14().t6b_1), new Color_0(Companion_getInstance_14().i6b_1)]);
      var tmp_4 = Companion_getInstance_24().g5d_1;
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_1 = $this$Canvas.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2 = floatFromBits(bits_0);
      var v1_0 = fromInt(toRawBits(0.0));
      var v2_0 = fromInt(toRawBits(val2));
      var tmp$ret$11 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
      var tmp$ret$10 = _Offset___init__impl__c168vi(tmp$ret$11);
      $this$Canvas.a6q(tmp_2.x6b(tmp_3, tmp_4, tmp$ret$10));
      var tmp_5 = SimpleColorPickerDialog$lambda_1($saturation$delegate);
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_2 = $this$Canvas.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_1 = _Size___get_packedValue__impl__7rlt1o(this_2);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(shiftRight(value_1, 32));
      var selX = tmp_5 * floatFromBits(bits_1);
      var tmp_6 = 1.0 - SimpleColorPickerDialog$lambda_3($value$delegate);
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_3 = $this$Canvas.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_2 = _Size___get_packedValue__impl__7rlt1o(this_3);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      var selY = tmp_6 * floatFromBits(bits_2);
      var tmp_7 = SimpleColorPickerDialog$lambda_3($value$delegate) > 0.5 ? Companion_getInstance_14().i6b_1 : Companion_getInstance_14().m6b_1;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$20 = _Dp___init__impl__ms3zkb(8);
      var tmp_8 = $this$Canvas.v5e(tmp$ret$20);
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1_1 = fromInt(toRawBits(selX));
      var v2_1 = fromInt(toRawBits(selY));
      var tmp$ret$22 = bitwiseOr(shiftLeft(v1_1, 32), bitwiseAnd(v2_1, new Long(-1, 0)));
      var tmp_9 = _Offset___init__impl__c168vi(tmp$ret$22);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$23 = _Dp___init__impl__ms3zkb(2);
      $this$Canvas.h6q(tmp_7, tmp_8, tmp_9, VOID, new Stroke($this$Canvas.v5e(tmp$ret$23)));
      return Unit_instance;
    };
  }
  function SimpleColorPickerDialog$lambda$lambda_0($hue$delegate, $saturation$delegate, $value$delegate) {
    return function ($this$BoxWithConstraints, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C855@48920L756,855@48878L798:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1300423689, $changed, -1, 'client.fstech.hadaya.presentation.model3d.SimpleColorPickerDialog.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:855)');
        }
        var tmp_0 = fillMaxSize(Companion_instance);
        sourceInformationMarkerStart($composer_0, -128315203, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (false || it === Companion_getInstance().f30_1) {
          var value = SimpleColorPickerDialog$lambda$lambda$lambda($hue$delegate, $saturation$delegate, $value$delegate);
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp0_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        Canvas_0(tmp_0, tmp0_group, $composer_0, 54);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SimpleColorPickerDialog$lambda$slambda$lambda_1($this_pointerInput, $hue$delegate) {
    return function (change, _unused_var__etf5q3) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_0 = change.ka0_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp = floatFromBits(bits);
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = $this_pointerInput.q95();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      var tmp$ret$4 = convertToInt(shiftRight(value_0, 32));
      SimpleColorPickerDialog$lambda_0($hue$delegate, coerceIn(tmp / tmp$ret$4, 0.0, 1.0) * 360.0);
      return Unit_instance;
    };
  }
  function SimpleColorPickerDialog$lambda$slambda_3($hue$delegate, resultContinuation) {
    this.v12w_1 = $hue$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SimpleColorPickerDialog$lambda$slambda_3).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SimpleColorPickerDialog$lambda$slambda_3).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SimpleColorPickerDialog$lambda$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = detectDragGestures(this.w12w_1, VOID, VOID, VOID, SimpleColorPickerDialog$lambda$slambda$lambda_1(this.w12w_1, this.v12w_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SimpleColorPickerDialog$lambda$slambda_3).wc6 = function ($this$pointerInput, completion) {
    var i = new SimpleColorPickerDialog$lambda$slambda_3(this.v12w_1, completion);
    i.w12w_1 = $this$pointerInput;
    return i;
  };
  function SimpleColorPickerDialog$lambda$slambda_4($hue$delegate, resultContinuation) {
    var i = new SimpleColorPickerDialog$lambda$slambda_3($hue$delegate, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function SimpleColorPickerDialog$lambda$slambda$lambda_2($this_pointerInput, $hue$delegate) {
    return function (offset) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_0 = offset.e5d_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp = floatFromBits(bits);
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = $this_pointerInput.q95();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      var tmp$ret$4 = convertToInt(shiftRight(value_0, 32));
      SimpleColorPickerDialog$lambda_0($hue$delegate, coerceIn(tmp / tmp$ret$4, 0.0, 1.0) * 360.0);
      return Unit_instance;
    };
  }
  function SimpleColorPickerDialog$lambda$slambda_5($hue$delegate, resultContinuation) {
    this.f12x_1 = $hue$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SimpleColorPickerDialog$lambda$slambda_5).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SimpleColorPickerDialog$lambda$slambda_5).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SimpleColorPickerDialog$lambda$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = detectTapGestures(this.g12x_1, VOID, VOID, VOID, SimpleColorPickerDialog$lambda$slambda$lambda_2(this.g12x_1, this.f12x_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SimpleColorPickerDialog$lambda$slambda_5).wc6 = function ($this$pointerInput, completion) {
    var i = new SimpleColorPickerDialog$lambda$slambda_5(this.f12x_1, completion);
    i.g12x_1 = $this$pointerInput;
    return i;
  };
  function SimpleColorPickerDialog$lambda$slambda_6($hue$delegate, resultContinuation) {
    var i = new SimpleColorPickerDialog$lambda$slambda_5($hue$delegate, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function SimpleColorPickerDialog$lambda$lambda$lambda_0($hue$delegate) {
    return function ($this$Canvas) {
      var hues = listOf_0([new Color_0(Companion_getInstance_14().n6b_1), new Color_0(Companion_getInstance_14().q6b_1), new Color_0(Companion_getInstance_14().o6b_1), new Color_0(Companion_getInstance_14().r6b_1), new Color_0(Companion_getInstance_14().p6b_1), new Color_0(Companion_getInstance_14().s6b_1), new Color_0(Companion_getInstance_14().n6b_1)]);
      var tmp = Companion_instance_1;
      var tmp_0 = Companion_getInstance_24().g5d_1;
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_0 = $this$Canvas.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val1 = floatFromBits(bits);
      var v1 = fromInt(toRawBits(val1));
      var v2 = fromInt(toRawBits(0.0));
      var tmp$ret$5 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      var tmp$ret$4 = _Offset___init__impl__c168vi(tmp$ret$5);
      $this$Canvas.a6q(tmp.x6b(hues, tmp_0, tmp$ret$4));
      var tmp_1 = SimpleColorPickerDialog$lambda($hue$delegate) / 360.0;
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_1 = $this$Canvas.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(shiftRight(value_0, 32));
      var selX = tmp_1 * floatFromBits(bits_0);
      var tmp_2 = Companion_getInstance_14().m6b_1;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$10 = _Dp___init__impl__ms3zkb(12);
      var tmp_3 = $this$Canvas.v5e(tmp$ret$10);
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_2 = $this$Canvas.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_1 = _Size___get_packedValue__impl__7rlt1o(this_2);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2 = floatFromBits(bits_1) / 2;
      var v1_0 = fromInt(toRawBits(selX));
      var v2_0 = fromInt(toRawBits(val2));
      var tmp$ret$16 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
      var tmp_4 = _Offset___init__impl__c168vi(tmp$ret$16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$17 = _Dp___init__impl__ms3zkb(3);
      $this$Canvas.h6q(tmp_2, tmp_3, tmp_4, VOID, new Stroke($this$Canvas.v5e(tmp$ret$17)));
      return Unit_instance;
    };
  }
  function SimpleColorPickerDialog$lambda$lambda_1($hue$delegate) {
    return function ($this$BoxWithConstraints, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C870@50181L499,870@50139L541:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2115603918, $changed, -1, 'client.fstech.hadaya.presentation.model3d.SimpleColorPickerDialog.<anonymous>.<anonymous>.<anonymous> (MugImageEditorScreen.kt:870)');
        }
        var tmp_0 = fillMaxSize(Companion_instance);
        sourceInformationMarkerStart($composer_0, -1575831643, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (false || it === Companion_getInstance().f30_1) {
          var value = SimpleColorPickerDialog$lambda$lambda$lambda_0($hue$delegate);
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp0_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        Canvas_0(tmp_0, tmp0_group, $composer_0, 54);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SimpleColorPickerDialog$lambda_7($saturation$delegate, $value$delegate, $hue$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C849@48231L3384:MugImageEditorScreen.kt#mu900e');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-560455595, $changed, -1, 'client.fstech.hadaya.presentation.model3d.SimpleColorPickerDialog.<anonymous> (MugImageEditorScreen.kt:849)');
        }
        var tmp_0 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = null;
        var verticalArrangement = tmp_0.mdq(tmp$ret$0);
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((5 & 1) === 0))
          modifier = Companion_instance;
        if (!((5 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((5 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 67568806, 'C852@48476L169,853@48690L147,854@48856L838,850@48307L1387,867@49862L102,868@50009L89,869@50117L581,865@49711L987,877@50715L886:MugImageEditorScreen.kt#mu900e');
        var tmp_2 = aspectRatio(fillMaxWidth(Companion_instance), 1.2);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(12);
        var tmp_3 = clip(tmp_2, RoundedCornerShape(tmp$ret$7));
        sourceInformationMarkerStart($composer_5, -1937480728, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_5.i31();
        var tmp_4;
        if (false || it === Companion_getInstance().f30_1) {
          var tmp_5 = SimpleColorPickerDialog$lambda$slambda_0($saturation$delegate, $value$delegate, null);
          var value = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4(tmp_5);
          $composer_5.j31(value);
          tmp_4 = value;
        } else {
          tmp_4 = it;
        }
        var tmp0_group = tmp_4;
        sourceInformationMarkerEnd($composer_5);
        var tmp_6 = pointerInput(tmp_3, Unit_instance, tmp0_group);
        sourceInformationMarkerStart($composer_5, -1937473902, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_0 = $composer_5.i31();
        var tmp_7;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var tmp_8 = SimpleColorPickerDialog$lambda$slambda_2($saturation$delegate, $value$delegate, null);
          var value_0 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4(tmp_8);
          $composer_5.j31(value_0);
          tmp_7 = value_0;
        } else {
          tmp_7 = it_0;
        }
        var tmp1_group = tmp_7;
        sourceInformationMarkerEnd($composer_5);
        var tmp_9 = pointerInput(tmp_6, Unit_instance, tmp1_group);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1300423689, true, SimpleColorPickerDialog$lambda$lambda_0($hue$delegate, $saturation$delegate, $value$delegate), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_6 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_6.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_6.i31();
        var tmp_10;
        if (invalid || it_1 === Companion_getInstance().f30_1) {
          var value_1 = ComposableLambda$invoke$ref_12(dispatchReceiver);
          $composer_6.j31(value_1);
          tmp_10 = value_1;
        } else {
          tmp_10 = it_1;
        }
        var tmp$ret$16 = tmp_10;
        BoxWithConstraints(tmp_9, null, false, tmp$ret$16, $composer_5, 3072, 6);
        var tmp_11 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$23 = _Dp___init__impl__ms3zkb(32);
        var tmp_12 = clip(height(tmp_11, tmp$ret$23), get_CircleShape());
        sourceInformationMarkerStart($composer_5, -1937436443, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_2 = $composer_5.i31();
        var tmp_13;
        if (false || it_2 === Companion_getInstance().f30_1) {
          var tmp_14 = SimpleColorPickerDialog$lambda$slambda_4($hue$delegate, null);
          var value_2 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4(tmp_14);
          $composer_5.j31(value_2);
          tmp_13 = value_2;
        } else {
          tmp_13 = it_2;
        }
        var tmp2_group = tmp_13;
        sourceInformationMarkerEnd($composer_5);
        var tmp_15 = pointerInput(tmp_12, Unit_instance, tmp2_group);
        sourceInformationMarkerStart($composer_5, -1937431752, 'CC(remember):MugImageEditorScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_3 = $composer_5.i31();
        var tmp_16;
        if (false || it_3 === Companion_getInstance().f30_1) {
          var tmp_17 = SimpleColorPickerDialog$lambda$slambda_6($hue$delegate, null);
          var value_3 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_4(tmp_17);
          $composer_5.j31(value_3);
          tmp_16 = value_3;
        } else {
          tmp_16 = it_3;
        }
        var tmp3_group = tmp_16;
        sourceInformationMarkerEnd($composer_5);
        var tmp_18 = pointerInput(tmp_15, Unit_instance, tmp3_group);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-2115603918, true, SimpleColorPickerDialog$lambda$lambda_1($hue$delegate), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_7 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_7.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_7.i31();
        var tmp_19;
        if (invalid_0 || it_4 === Companion_getInstance().f30_1) {
          var value_4 = ComposableLambda$invoke$ref_12(dispatchReceiver_0);
          $composer_7.j31(value_4);
          tmp_19 = value_4;
        } else {
          tmp_19 = it_4;
        }
        var tmp$ret$32 = tmp_19;
        BoxWithConstraints(tmp_18, null, false, tmp$ret$32, $composer_5, 3072, 6);
        var tmp0_modifier = fillMaxWidth(Companion_instance);
        var tmp1_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_20 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$39 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_1 = tmp0_modifier;
        var horizontalArrangement = tmp_20.mdq(tmp$ret$39);
        var verticalAlignment = tmp1_verticalAlignment;
        var $composer_8 = $composer_5;
        if (!((0 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_8, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_9 = $composer_8;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_9, 0).hashCode();
        var localMap_0 = $composer_9.t31();
        var materialized_0 = materialize($composer_9, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_10 = $composer_9;
        var tmp_21 = $composer_10.g30();
        if (!isInterface(tmp_21, Applier)) {
          invalidApplier();
        }
        $composer_10.b31();
        if ($composer_10.h30()) {
          $composer_10.c31(tmp0_0);
        } else {
          $composer_10.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_10);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_11 = $composer_10;
        var $composer_12 = $composer_11;
        sourceInformationMarkerStart($composer_12, 1262508807, 'C879@51067L11,879@50952L163,880@51136L447:MugImageEditorScreen.kt#mu900e');
        var currentColor = SimpleColorPickerDialog$hsvToColor(SimpleColorPickerDialog$lambda($hue$delegate), SimpleColorPickerDialog$lambda_1($saturation$delegate), SimpleColorPickerDialog$lambda_3($value$delegate));
        var tmp_22 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$46 = _Dp___init__impl__ms3zkb(60);
        var tmp_23 = size(tmp_22, tmp$ret$46);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$47 = _Dp___init__impl__ms3zkb(12);
        var tmp_24 = background(tmp_23, currentColor, RoundedCornerShape(tmp$ret$47));
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_25 = _Dp___init__impl__ms3zkb(1);
        var tmp_26 = MaterialTheme_instance.unz($composer_12, 6).xo0_1;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$49 = _Dp___init__impl__ms3zkb(12);
        Box(border(tmp_24, tmp_25, tmp_26, RoundedCornerShape(tmp$ret$49)), $composer_12, 0);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_3 = null;
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = null;
        var $composer_13 = $composer_12;
        if (!((7 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((7 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((7 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_1 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_13, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_14 = $composer_13;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_14, 0).hashCode();
        var localMap_1 = $composer_14.t31();
        var materialized_1 = materialize($composer_14, modifier_4);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_15 = $composer_14;
        var tmp_27 = $composer_15.g30();
        if (!isInterface(tmp_27, Applier)) {
          invalidApplier();
        }
        $composer_15.b31();
        if ($composer_15.h30()) {
          $composer_15.c31(tmp0_1);
        } else {
          $composer_15.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_15);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_16 = $composer_15;
        var $composer_17 = $composer_16;
        sourceInformationMarkerStart($composer_17, -2097831018, 'C881@51324L10,881@51169L177,882@51488L10,882@51532L11,882@51371L190:MugImageEditorScreen.kt#mu900e');
        var tmp_28 = 'RGB: ' + numberToInt(_Color___get_red__impl__cwrsk6(currentColor) * 255) + ', ' + numberToInt(_Color___get_green__impl__bta9rs(currentColor) * 255) + ', ' + numberToInt(_Color___get_blue__impl__xwez13(currentColor) * 255);
        var tmp_29 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_30 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_31 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_32 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_33 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_28, null, tmp_29, null, tmp_30, null, null, null, tmp_31, null, null, tmp_32, tmp_33, false, 0, 0, null, MaterialTheme_instance.jog($composer_17, 6).pof_1, $composer_17, 0, 0, 131070);
        var tmp0_text = 'HSV: ' + numberToInt(SimpleColorPickerDialog$lambda($hue$delegate)) + '\xB0, ' + numberToInt(SimpleColorPickerDialog$lambda_1($saturation$delegate) * 100) + '%, ' + numberToInt(SimpleColorPickerDialog$lambda_3($value$delegate) * 100) + '%';
        var tmp1_style = MaterialTheme_instance.jog($composer_17, 6).qof_1;
        var tmp2_color = MaterialTheme_instance.unz($composer_17, 6).po0_1;
        var tmp_34 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_35 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_36 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_37 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp2_color, null, tmp_34, null, null, null, tmp_35, null, null, tmp_36, tmp_37, false, 0, 0, null, tmp1_style, $composer_17, 0, 0, 131066);
        sourceInformationMarkerEnd($composer_17);
        $composer_15.e31();
        sourceInformationMarkerEnd($composer_12);
        $composer_10.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_38;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_38 = Unit_instance;
        }
        tmp = tmp_38;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SimpleColorPickerDialog$lambda_8($initialColor, $onColorSelected, $onDismiss, $$changed) {
    return function ($composer, $force) {
      SimpleColorPickerDialog($initialColor, $onColorSelected, $onDismiss, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var properties_initialized_MugImageEditorScreen_kt_2i686h;
  function _init_properties_MugImageEditorScreen_kt__l1nhhx() {
    if (!properties_initialized_MugImageEditorScreen_kt_2i686h) {
      properties_initialized_MugImageEditorScreen_kt_2i686h = true;
      // Inline function 'kotlin.floatArrayOf' call
      SepiaMatrix_0 = new Float32Array([0.393, 0.769, 0.189, 0.0, 0.0, 0.349, 0.686, 0.168, 0.0, 0.0, 0.272, 0.534, 0.131, 0.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0]);
      // Inline function 'kotlin.floatArrayOf' call
      GrayscaleMatrix_0 = new Float32Array([0.2126, 0.7152, 0.0722, 0.0, 0.0, 0.2126, 0.7152, 0.0722, 0.0, 0.0, 0.2126, 0.7152, 0.0722, 0.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0]);
      // Inline function 'kotlin.floatArrayOf' call
      InvertMatrix_0 = new Float32Array([-1.0, 0.0, 0.0, 0.0, 1.0, 0.0, -1.0, 0.0, 0.0, 1.0, 0.0, 0.0, -1.0, 0.0, 1.0, 0.0, 0.0, 0.0, 1.0, 0.0]);
    }
  }
  function Model3DViewerSection(loading, error, productKind, imageBitmap, imageBytes, onRetry, modifier, visible, clipTop, clipBottom, $composer, $changed, $default) {
    var imageBytes_0 = {_v: imageBytes};
    var modifier_0 = {_v: modifier};
    var visible_0 = {_v: visible};
    var clipTop_0 = {_v: clipTop};
    var clipBottom_0 = {_v: clipBottom};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1480798367);
    sourceInformation($composer_0, 'C(Model3DViewerSection)P(5,2,8,3,4,7,6,9,1)44@1724L1753:Model3DViewerSection.kt#1kmb0q');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.l31(loading) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(error) : $composer_0.q31(error)) ? 32 : 16);
    if (($changed & 384) === 0) {
      var tmp;
      var tmp_0 = $composer_0;
      if (tmp_0.m31(productKind == null ? -1 : productKind.a1_1)) {
        tmp = 256;
      } else {
        tmp = 128;
      }
      $dirty = $dirty | tmp;
    }
    if (($changed & 3072) === 0)
      $dirty = $dirty | ((($changed & 4096) === 0 ? $composer_0.k31(imageBitmap) : $composer_0.q31(imageBitmap)) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ((($changed & 32768) === 0 ? $composer_0.k31(imageBytes_0._v) : $composer_0.q31(imageBytes_0._v)) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onRetry) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.l31(visible_0._v) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.n31(clipTop_0._v) ? 67108864 : 33554432);
    if (!(($default & 512) === 0))
      $dirty = $dirty | 805306368;
    else if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.n31(clipBottom_0._v) ? 536870912 : 268435456);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378), $dirty & 1)) {
      if (!(($default & 16) === 0)) {
        imageBytes_0._v = null;
      }
      if (!(($default & 64) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (!(($default & 128) === 0)) {
        visible_0._v = true;
      }
      if (!(($default & 256) === 0)) {
        clipTop_0._v = 0.0;
      }
      if (!(($default & 512) === 0)) {
        clipBottom_0._v = 0.0;
      }
      if (isTraceInProgress()) {
        traceEventStart(1480798367, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.components.Model3DViewerSection (Model3DViewerSection.kt:43)');
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_1 = fillMaxWidth(modifier_0._v);
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((4 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((4 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((4 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -201921244, 'C:Model3DViewerSection.kt#1kmb0q');
      if (visible_0._v) {
        $composer_5.m30(-201937148);
        sourceInformation($composer_5, '56@2172L373');
        var modelName;
        switch (productKind == null ? -1 : productKind.a1_1) {
          case 1:
            modelName = 'mug_texture_30.glb';
            break;
          case 4:
            modelName = 'magic_mug.glb';
            break;
          case 2:
            modelName = 'tshirt.glb';
            break;
          case 3:
            modelName = 'notebook.glb';
            break;
          default:
            modelName = 'mug.glb';
            break;
        }
        var tmp_2 = fillMaxSize(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_3 = _Dp___init__impl__ms3zkb(60);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(80);
        ModelViewer(modelName, padding_1(tmp_2, VOID, tmp_3, VOID, tmp$ret$7), imageBitmap, imageBytes_0._v, equals(productKind, ProductKind_MAGIC_MUG_getInstance()), clipTop_0._v, clipBottom_0._v, $composer_5, 48 | 896 & $dirty >> 3 | 7168 & $dirty >> 3 | 458752 & $dirty >> 9 | 3670016 & $dirty >> 9, 0);
        $composer_5.n30();
      } else {
        $composer_5.m30(-201255799);
        $composer_5.n30();
      }
      if (loading && visible_0._v) {
        $composer_5.m30(-201221482);
        sourceInformation($composer_5, '67@2602L27');
        var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_5 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_7 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_4, tmp_5, tmp_6, tmp_7, _Dp___init__impl__ms3zkb(0.0), $composer_5, 0, 63);
        $composer_5.n30();
      } else {
        $composer_5.m30(-201172471);
        $composer_5.n30();
      }
      if (!(error == null) && visible_0._v) {
        $composer_5.m30(-201109200);
        sourceInformation($composer_5, '70@2692L769');
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_3 = null;
        var verticalArrangement = null;
        var horizontalAlignment = Companion_getInstance_11().x8t_1;
        var $composer_6 = $composer_5;
        if (!((3 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((3 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((3 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_4);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_8 = $composer_8.g30();
        if (!isInterface(tmp_8, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, -783380435, 'C75@2959L11,71@2769L229,77@3015L41,79@3105L10,80@3159L10,78@3073L195,83@3285L41,84@3343L104:Model3DViewerSection.kt#1kmb0q');
        var tmp_9 = get_WifiOff(Icons_getInstance().dxv_1);
        var tmp_10 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$14 = _Dp___init__impl__ms3zkb(64);
        Icon(tmp_9, null, size(tmp_10, tmp$ret$14), MaterialTheme_instance.unz($composer_10, 6).co0_1, $composer_10, 432, 0);
        var tmp_11 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$15 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_11, tmp$ret$15), $composer_10, 6);
        var tmp0_text = error.s11k($composer_10, 14 & $dirty >> 3);
        var tmp1_style = MaterialTheme_instance.jog($composer_10, 6).mof_1;
        var tmp_12 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$16 = _Dp___init__impl__ms3zkb(32);
        var tmp2_modifier = padding_2(tmp_12, tmp$ret$16);
        var tmp_13 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_15 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_17 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, tmp2_modifier, tmp_13, null, tmp_14, null, null, null, tmp_15, null, null, tmp_16, tmp_17, false, 0, 0, null, tmp1_style, $composer_10, 48, 0, 131068);
        var tmp_18 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$17 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_18, tmp$ret$17), $composer_10, 6);
        Button(onRetry, null, false, null, null, null, null, null, null, ComposableSingletons$Model3DViewerSectionKt_getInstance().h12x_1, $composer_10, 805306368 | 14 & $dirty >> 15, 510);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        $composer_5.n30();
      } else {
        $composer_5.m30(-200347127);
        $composer_5.n30();
      }
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(Model3DViewerSection$lambda(loading, error, productKind, imageBitmap, imageBytes_0, onRetry, modifier_0, visible_0, clipTop_0, clipBottom_0, $changed, $default));
    }
  }
  function ComposableSingletons$Model3DViewerSectionKt$lambda$_396235840$lambda_p5asea($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C85@3396L32,85@3391L38:Model3DViewerSection.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-396235840, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$Model3DViewerSectionKt.lambda$-396235840.<anonymous> (Model3DViewerSection.kt:85)');
      }
      var tmp = stringResource(get_retry(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$Model3DViewerSectionKt() {
    ComposableSingletons$Model3DViewerSectionKt_instance = this;
    var tmp = this;
    tmp.h12x_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-396235840, false, ComposableSingletons$Model3DViewerSectionKt$lambda$_396235840$lambda_p5asea));
  }
  var ComposableSingletons$Model3DViewerSectionKt_instance;
  function ComposableSingletons$Model3DViewerSectionKt_getInstance() {
    if (ComposableSingletons$Model3DViewerSectionKt_instance == null)
      new ComposableSingletons$Model3DViewerSectionKt();
    return ComposableSingletons$Model3DViewerSectionKt_instance;
  }
  function Model3DViewerSection$lambda($loading, $error, $productKind, $imageBitmap, $imageBytes, $onRetry, $modifier, $visible, $clipTop, $clipBottom, $$changed, $$default) {
    return function ($composer, $force) {
      Model3DViewerSection($loading, $error, $productKind, $imageBitmap, $imageBytes._v, $onRetry, $modifier._v, $visible._v, $clipTop._v, $clipBottom._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ModelMugScreenContent(state, onIntent, padding_0, isFullScreen, topPadding, bottomPadding, $composer, $changed, $default) {
    var isFullScreen_0 = {_v: isFullScreen};
    var topPadding_0 = {_v: new Dp(topPadding)};
    var bottomPadding_0 = {_v: new Dp(bottomPadding)};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1888987713);
    sourceInformation($composer_0, 'C(ModelMugScreenContent)P(4,2,3,1,5:c#ui.unit.Dp,0:c#ui.unit.Dp)38@1638L42,39@1711L34,40@1787L42,41@1862L34,42@1927L25,45@2010L21,49@2153L14924:ModelMugScreenContent.kt#1kmb0q');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onIntent) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(padding_0) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.l31(isFullScreen_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.n31(_Dp___get_value__impl__geb1vb(topPadding_0._v.m5f_1)) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.n31(_Dp___get_value__impl__geb1vb(bottomPadding_0._v.m5f_1)) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74899) === 74898), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        isFullScreen_0._v = false;
      }
      if (!(($default & 16) === 0)) {
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
        topPadding_0._v = new Dp(tmp$ret$0);
      }
      if (!(($default & 32) === 0)) {
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(0);
        bottomPadding_0._v = new Dp(tmp$ret$1);
      }
      if (isTraceInProgress()) {
        traceEventStart(1888987713, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.components.ModelMugScreenContent (ModelMugScreenContent.kt:37)');
      }
      sourceInformationMarkerStart($composer_0, -1453964405, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = mutableStateOf(false);
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var showDeleteConfirmation$delegate = tmp0_group;
      sourceInformationMarkerStart($composer_0, -1453962077, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = mutableStateOf(false);
        this_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      var showBirthdayPicker$delegate = tmp1_group;
      sourceInformationMarkerStart($composer_0, -1453959637, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_2.i31();
      var tmp_1;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = mutableStateOf(null);
        this_2.j31(value_1);
        tmp_1 = value_1;
      } else {
        tmp_1 = it_1;
      }
      var tmp2_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var birthdayPickerTargetOptionKey$delegate = tmp2_group;
      sourceInformationMarkerStart($composer_0, -1453957245, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_2 = this_3.i31();
      var tmp_2;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var value_2 = mutableStateOf(false);
        this_3.j31(value_2);
        tmp_2 = value_2;
      } else {
        tmp_2 = it_2;
      }
      var tmp3_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      var isPickingBoxBirthday$delegate = tmp3_group;
      var tmp_3 = _DisplayMode___init__impl__gfd230(0);
      var birthdayPickerState = rememberDatePickerState(null, null, null, tmp_3, null, $composer_0, 0, 31);
      var language = state.k12b_1;
      var scrollState = rememberScrollState(0, $composer_0, 0, 1);
      var isOverlayActive = ModelMugScreenContent$lambda_1(showBirthdayPicker$delegate) || ModelMugScreenContent$lambda(showDeleteConfirmation$delegate) || state.i12b_1 || state.j12b_1;
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = background(fillMaxSize(padding(Companion_instance, padding_0)), Companion_getInstance_14().m6b_1).d8v(isFullScreen_0._v ? Companion_instance : verticalScroll(Companion_instance, scrollState));
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_4 = $composer_3.g30();
      if (!isInterface(tmp_4, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1505780476, 'C56@2387L1166:ModelMugScreenContent.kt#1kmb0q');
      var tmp_5 = ColumnScopeInstance_instance.yds(fillMaxWidth(Companion_instance), isFullScreen_0._v ? 1.0 : 0.0);
      var tmp_6;
      if (isFullScreen_0._v) {
        tmp_6 = Companion_instance;
      } else {
        var tmp_7 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$24 = _Dp___init__impl__ms3zkb(550);
        tmp_6 = height(tmp_7, tmp$ret$24);
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_1 = tmp_5.d8v(tmp_6);
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_6 = $composer_5;
      if (!((4 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((4 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((4 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_8 = $composer_8.g30();
      if (!isInterface(tmp_8, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_0);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, 165522317, 'C69@2941L399,63@2662L881:ModelMugScreenContent.kt#1kmb0q');
      var tmp0_safe_receiver = state.e12b_1;
      var tmp_9 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bzu_1;
      sourceInformationMarkerStart($composer_10, 559537204, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(($dirty & 112) === 32 | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(state))));
      // Inline function 'kotlin.let' call
      var it_3 = $composer_10.i31();
      var tmp_10;
      if (invalid || it_3 === Companion_getInstance().f30_1) {
        var value_3 = ModelMugScreenContent$lambda_7(onIntent, state);
        $composer_10.j31(value_3);
        tmp_10 = value_3;
      } else {
        tmp_10 = it_3;
      }
      var tmp0_group_0 = tmp_10;
      sourceInformationMarkerEnd($composer_10);
      Model3DViewerSection(state.c12b_1, state.d12b_1, tmp_9, state.g12b_1, state.f12b_1, tmp0_group_0, fillMaxSize(Companion_instance), !isOverlayActive, _Dp___get_value__impl__geb1vb(topPadding_0._v.m5f_1), _Dp___get_value__impl__geb1vb(bottomPadding_0._v.m5f_1), $composer_10, 1572864, 0);
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      if (!isFullScreen_0._v && !state.c12b_1 && state.d12b_1 == null) {
        $composer_5.m30(1506968271);
        sourceInformation($composer_5, '344@17019L42');
        var product = state.e12b_1;
        if (!(product == null)) {
          $composer_5.m30(1507039292);
          sourceInformation($composer_5, '271@13243L41,274@13406L176,283@13886L374,272@13301L977');
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!state.z12b_1.r()) {
            $composer_5.m30(1506789928);
            sourceInformation($composer_5, '92@3832L38,95@4041L88,91@3778L418');
            var tmp_11 = stringResource(get_select_card(string_instance), $composer_5, 0);
            var tmp0_safe_receiver_0 = state.n12b_1;
            var tmp_12 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.gyz_1;
            sourceInformationMarkerStart($composer_5, -644124765, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_0 = ($dirty & 112) === 32;
            // Inline function 'kotlin.let' call
            var it_4 = $composer_5.i31();
            var tmp_13;
            if (invalid_0 || it_4 === Companion_getInstance().f30_1) {
              var value_4 = ModelMugScreenContent$lambda_8(onIntent);
              $composer_5.j31(value_4);
              tmp_13 = value_4;
            } else {
              tmp_13 = it_4;
            }
            var tmp0_group_1 = tmp_13;
            sourceInformationMarkerEnd($composer_5);
            GiftSelectionSection(tmp_11, state.z12b_1, tmp_12, tmp0_group_1, language, false, $composer_5, 0, 32);
            var tmp4_safe_receiver = state.n12b_1;
            if ((tmp4_safe_receiver == null ? null : tmp4_safe_receiver.oyz_1) === true) {
              $composer_5.m30(1507225509);
              sourceInformation($composer_5, '100@4287L41,103@4471L204,113@5117L426,101@4353L1216');
              var tmp_14 = Companion_instance;
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$40 = _Dp___init__impl__ms3zkb(12);
              Spacer(height(tmp_14, tmp$ret$40), $composer_5, 6);
              var tmp1_value = state.o12b_1;
              var tmp_15 = fillMaxWidth(Companion_instance);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$41 = _Dp___init__impl__ms3zkb(24);
              var tmp2_modifier = padding_2(tmp_15, tmp$ret$41);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$42 = _Dp___init__impl__ms3zkb(12);
              var tmp3_shape = RoundedCornerShape(tmp$ret$42);
              sourceInformationMarkerStart($composer_5, -644110889, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_1 = ($dirty & 112) === 32;
              // Inline function 'kotlin.let' call
              var it_5 = $composer_5.i31();
              var tmp_16;
              if (invalid_1 || it_5 === Companion_getInstance().f30_1) {
                var value_5 = ModelMugScreenContent$lambda_9(onIntent);
                $composer_5.j31(value_5);
                tmp_16 = value_5;
              } else {
                tmp_16 = it_5;
              }
              var tmp1_group_0 = tmp_16;
              sourceInformationMarkerEnd($composer_5);
              var tmp_17 = ComposableSingletons$ModelMugScreenContentKt_getInstance().i12x_1;
              var tmp_18 = ComposableSingletons$ModelMugScreenContentKt_getInstance().j12x_1;
              // Inline function 'kotlin.run' call
              var dispatchReceiver = rememberComposableLambda(20624664, true, ModelMugScreenContent$lambda_10(state), $composer_5, 54);
              // Inline function 'androidx.compose.runtime.remember' call
              var $composer_11 = $composer_5;
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_2 = $composer_11.k31(dispatchReceiver);
              // Inline function 'kotlin.let' call
              var it_6 = $composer_11.i31();
              var tmp_19;
              if (invalid_2 || it_6 === Companion_getInstance().f30_1) {
                var value_6 = ComposableLambda$invoke$ref(dispatchReceiver);
                $composer_11.j31(value_6);
                tmp_19 = value_6;
              } else {
                tmp_19 = it_6;
              }
              var tmp_20 = tmp_19;
              OutlinedTextField(tmp1_value, tmp1_group_0, tmp2_modifier, false, false, null, tmp_17, tmp_18, null, null, null, null, tmp_20, false, null, null, null, false, 1, 0, null, tmp3_shape, null, $composer_5, 14156160, 100663680, 0, 6025016);
              $composer_5.n30();
            } else {
              $composer_5.m30(1508503639);
              $composer_5.n30();
            }
            var tmp11_safe_receiver = state.n12b_1;
            if ((tmp11_safe_receiver == null ? null : tmp11_safe_receiver.pyz_1) === true) {
              $composer_5.m30(1508616231);
              sourceInformation($composer_5, '125@5683L41,132@6146L162,128@5868L3,141@6687L381,126@5749L1406');
              var tmp_21 = Companion_instance;
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$54 = _Dp___init__impl__ms3zkb(12);
              Spacer(height(tmp_21, tmp$ret$54), $composer_5, 6);
              var tmp5_value = state.p12b_1;
              var tmp_22 = fillMaxWidth(Companion_instance);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$55 = _Dp___init__impl__ms3zkb(24);
              var tmp_23 = padding_2(tmp_22, tmp$ret$55);
              sourceInformationMarkerStart($composer_5, -644057331, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              // Inline function 'kotlin.let' call
              var it_7 = $composer_5.i31();
              var tmp_24;
              if (false || it_7 === Companion_getInstance().f30_1) {
                var value_7 = ModelMugScreenContent$lambda_11(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
                $composer_5.j31(value_7);
                tmp_24 = value_7;
              } else {
                tmp_24 = it_7;
              }
              var tmp2_group_0 = tmp_24;
              sourceInformationMarkerEnd($composer_5);
              var tmp6_modifier = clickable(tmp_23, VOID, VOID, VOID, VOID, tmp2_group_0);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$60 = _Dp___init__impl__ms3zkb(12);
              var tmp7_shape = RoundedCornerShape(tmp$ret$60);
              var tmp8_isError = state.q12b_1;
              var tmp_25;
              if (state.q12b_1) {
                tmp_25 = ComposableSingletons$ModelMugScreenContentKt_getInstance().k12x_1;
              } else {
                tmp_25 = null;
              }
              var tmp9_supportingText = tmp_25;
              var tmp10_enabled = !state.i12b_1;
              sourceInformationMarkerStart($composer_5, -644066386, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              // Inline function 'kotlin.let' call
              var it_8 = $composer_5.i31();
              var tmp_26;
              if (false || it_8 === Companion_getInstance().f30_1) {
                var value_8 = ModelMugScreenContent$lambda_12;
                $composer_5.j31(value_8);
                tmp_26 = value_8;
              } else {
                tmp_26 = it_8;
              }
              var tmp3_group_0 = tmp_26;
              sourceInformationMarkerEnd($composer_5);
              var tmp_27 = ComposableSingletons$ModelMugScreenContentKt_getInstance().l12x_1;
              // Inline function 'kotlin.run' call
              var dispatchReceiver_0 = rememberComposableLambda(1535912817, true, ModelMugScreenContent$lambda_13(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_5, 54);
              // Inline function 'androidx.compose.runtime.remember' call
              var $composer_12 = $composer_5;
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_3 = $composer_12.k31(dispatchReceiver_0);
              // Inline function 'kotlin.let' call
              var it_9 = $composer_12.i31();
              var tmp_28;
              if (invalid_3 || it_9 === Companion_getInstance().f30_1) {
                var value_9 = ComposableLambda$invoke$ref(dispatchReceiver_0);
                $composer_12.j31(value_9);
                tmp_28 = value_9;
              } else {
                tmp_28 = it_9;
              }
              var tmp_29 = tmp_28;
              OutlinedTextField(tmp5_value, tmp3_group_0, tmp6_modifier, tmp10_enabled, true, null, tmp_27, null, null, tmp_29, null, null, tmp9_supportingText, tmp8_isError, null, null, null, false, 0, 0, null, tmp7_shape, null, $composer_5, 806903856, 0, 0, 6278560);
              $composer_5.n30();
            } else {
              $composer_5.m30(1510076951);
              $composer_5.n30();
            }
            $composer_5.n30();
          } else {
            $composer_5.m30(1510094807);
            $composer_5.n30();
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!state.a12c_1.r()) {
            $composer_5.m30(1510257526);
            sourceInformation($composer_5, '156@7328L37,159@7535L86,155@7274L414');
            var tmp_30 = stringResource(get_select_box(string_instance), $composer_5, 0);
            var tmp12_safe_receiver = state.r12b_1;
            var tmp_31 = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.ryz_1;
            sourceInformationMarkerStart($composer_5, -644012959, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_4 = ($dirty & 112) === 32;
            // Inline function 'kotlin.let' call
            var it_10 = $composer_5.i31();
            var tmp_32;
            if (invalid_4 || it_10 === Companion_getInstance().f30_1) {
              var value_10 = ModelMugScreenContent$lambda_14(onIntent);
              $composer_5.j31(value_10);
              tmp_32 = value_10;
            } else {
              tmp_32 = it_10;
            }
            var tmp4_group = tmp_32;
            sourceInformationMarkerEnd($composer_5);
            GiftSelectionSection(tmp_30, state.a12c_1, tmp_31, tmp4_group, language, false, $composer_5, 0, 32);
            var tmp16_safe_receiver = state.r12b_1;
            if ((tmp16_safe_receiver == null ? null : tmp16_safe_receiver.zyz_1) === true) {
              $composer_5.m30(1510688488);
              sourceInformation($composer_5, '164@7778L41,167@7961L203,177@8606L425,165@7844L1213');
              var tmp_33 = Companion_instance;
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$77 = _Dp___init__impl__ms3zkb(12);
              Spacer(height(tmp_33, tmp$ret$77), $composer_5, 6);
              var tmp13_value = state.s12b_1;
              var tmp_34 = fillMaxWidth(Companion_instance);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$78 = _Dp___init__impl__ms3zkb(24);
              var tmp14_modifier = padding_2(tmp_34, tmp$ret$78);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$79 = _Dp___init__impl__ms3zkb(12);
              var tmp15_shape = RoundedCornerShape(tmp$ret$79);
              sourceInformationMarkerStart($composer_5, -643999210, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_5 = ($dirty & 112) === 32;
              // Inline function 'kotlin.let' call
              var it_11 = $composer_5.i31();
              var tmp_35;
              if (invalid_5 || it_11 === Companion_getInstance().f30_1) {
                var value_11 = ModelMugScreenContent$lambda_15(onIntent);
                $composer_5.j31(value_11);
                tmp_35 = value_11;
              } else {
                tmp_35 = it_11;
              }
              var tmp5_group = tmp_35;
              sourceInformationMarkerEnd($composer_5);
              var tmp_36 = ComposableSingletons$ModelMugScreenContentKt_getInstance().n12x_1;
              var tmp_37 = ComposableSingletons$ModelMugScreenContentKt_getInstance().o12x_1;
              // Inline function 'kotlin.run' call
              var dispatchReceiver_1 = rememberComposableLambda(-1613491775, true, ModelMugScreenContent$lambda_16(state), $composer_5, 54);
              // Inline function 'androidx.compose.runtime.remember' call
              var $composer_13 = $composer_5;
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_6 = $composer_13.k31(dispatchReceiver_1);
              // Inline function 'kotlin.let' call
              var it_12 = $composer_13.i31();
              var tmp_38;
              if (invalid_6 || it_12 === Companion_getInstance().f30_1) {
                var value_12 = ComposableLambda$invoke$ref(dispatchReceiver_1);
                $composer_13.j31(value_12);
                tmp_38 = value_12;
              } else {
                tmp_38 = it_12;
              }
              var tmp_39 = tmp_38;
              OutlinedTextField(tmp13_value, tmp5_group, tmp14_modifier, false, false, null, tmp_36, tmp_37, null, null, null, null, tmp_39, false, null, null, null, false, 1, 0, null, tmp15_shape, null, $composer_5, 14156160, 100663680, 0, 6025016);
              $composer_5.n30();
            } else {
              $composer_5.m30(1511963735);
              $composer_5.n30();
            }
            var tmp23_safe_receiver = state.r12b_1;
            if ((tmp23_safe_receiver == null ? null : tmp23_safe_receiver.az0_1) === true) {
              $composer_5.m30(1512075180);
              sourceInformation($composer_5, '189@9170L41,196@9632L161,192@9354L3,205@10170L380,190@9236L1401');
              var tmp_40 = Companion_instance;
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$91 = _Dp___init__impl__ms3zkb(12);
              Spacer(height(tmp_40, tmp$ret$91), $composer_5, 6);
              var tmp17_value = state.t12b_1;
              var tmp_41 = fillMaxWidth(Companion_instance);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$92 = _Dp___init__impl__ms3zkb(24);
              var tmp_42 = padding_2(tmp_41, tmp$ret$92);
              sourceInformationMarkerStart($composer_5, -643945780, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              // Inline function 'kotlin.let' call
              var it_13 = $composer_5.i31();
              var tmp_43;
              if (false || it_13 === Companion_getInstance().f30_1) {
                var value_13 = ModelMugScreenContent$lambda_17(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
                $composer_5.j31(value_13);
                tmp_43 = value_13;
              } else {
                tmp_43 = it_13;
              }
              var tmp6_group = tmp_43;
              sourceInformationMarkerEnd($composer_5);
              var tmp18_modifier = clickable(tmp_42, VOID, VOID, VOID, VOID, tmp6_group);
              // Inline function 'androidx.compose.ui.unit.dp' call
              var tmp$ret$97 = _Dp___init__impl__ms3zkb(12);
              var tmp19_shape = RoundedCornerShape(tmp$ret$97);
              var tmp20_isError = state.u12b_1;
              var tmp_44;
              if (state.u12b_1) {
                tmp_44 = ComposableSingletons$ModelMugScreenContentKt_getInstance().p12x_1;
              } else {
                tmp_44 = null;
              }
              var tmp21_supportingText = tmp_44;
              var tmp22_enabled = !state.i12b_1;
              sourceInformationMarkerStart($composer_5, -643954834, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              // Inline function 'kotlin.let' call
              var it_14 = $composer_5.i31();
              var tmp_45;
              if (false || it_14 === Companion_getInstance().f30_1) {
                var value_14 = ModelMugScreenContent$lambda_18;
                $composer_5.j31(value_14);
                tmp_45 = value_14;
              } else {
                tmp_45 = it_14;
              }
              var tmp7_group = tmp_45;
              sourceInformationMarkerEnd($composer_5);
              var tmp_46 = ComposableSingletons$ModelMugScreenContentKt_getInstance().q12x_1;
              // Inline function 'kotlin.run' call
              var dispatchReceiver_2 = rememberComposableLambda(-1415490086, true, ModelMugScreenContent$lambda_19(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_5, 54);
              // Inline function 'androidx.compose.runtime.remember' call
              var $composer_14 = $composer_5;
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_7 = $composer_14.k31(dispatchReceiver_2);
              // Inline function 'kotlin.let' call
              var it_15 = $composer_14.i31();
              var tmp_47;
              if (invalid_7 || it_15 === Companion_getInstance().f30_1) {
                var value_15 = ComposableLambda$invoke$ref(dispatchReceiver_2);
                $composer_14.j31(value_15);
                tmp_47 = value_15;
              } else {
                tmp_47 = it_15;
              }
              var tmp_48 = tmp_47;
              OutlinedTextField(tmp17_value, tmp7_group, tmp18_modifier, tmp22_enabled, true, null, tmp_46, null, null, tmp_48, null, null, tmp21_supportingText, tmp20_isError, null, null, null, false, 0, 0, null, tmp19_shape, null, $composer_5, 806903856, 0, 0, 6278560);
              $composer_5.n30();
            } else {
              $composer_5.m30(1513531095);
              $composer_5.n30();
            }
            $composer_5.n30();
          } else {
            $composer_5.m30(1513548951);
            $composer_5.n30();
          }
          // Inline function 'kotlin.collections.isNullOrEmpty' call
          var this_4 = product.lzu_1;
          if (!(this_4 == null || this_4.r())) {
            $composer_5.m30(1513614950);
            sourceInformation($composer_5, '220@10809L38,223@11002L45,219@10753L361');
            var tmp_49 = stringResource(get_select_size(string_instance), $composer_5, 0);
            sourceInformationMarkerStart($composer_5, -643902056, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_8 = ($dirty & 112) === 32;
            // Inline function 'kotlin.let' call
            var it_16 = $composer_5.i31();
            var tmp_50;
            if (invalid_8 || it_16 === Companion_getInstance().f30_1) {
              var value_16 = ModelMugScreenContent$lambda_20(onIntent);
              $composer_5.j31(value_16);
              tmp_50 = value_16;
            } else {
              tmp_50 = it_16;
            }
            var tmp8_group = tmp_50;
            sourceInformationMarkerEnd($composer_5);
            OptionSelectionSection(tmp_49, product.lzu_1, state.v12b_1, tmp8_group, language, false, $composer_5, 0, 32);
            $composer_5.n30();
          } else {
            $composer_5.m30(1514000311);
            $composer_5.n30();
          }
          // Inline function 'kotlin.collections.isNullOrEmpty' call
          var this_5 = product.mzu_1;
          if (!(this_5 == null || this_5.r())) {
            $composer_5.m30(1514067426);
            sourceInformation($composer_5, '230@11265L39,233@11461L46,229@11209L365');
            var tmp_51 = stringResource(get_select_color(string_instance), $composer_5, 0);
            sourceInformationMarkerStart($composer_5, -643887367, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_9 = ($dirty & 112) === 32;
            // Inline function 'kotlin.let' call
            var it_17 = $composer_5.i31();
            var tmp_52;
            if (invalid_9 || it_17 === Companion_getInstance().f30_1) {
              var value_17 = ModelMugScreenContent$lambda_21(onIntent);
              $composer_5.j31(value_17);
              tmp_52 = value_17;
            } else {
              tmp_52 = it_17;
            }
            var tmp9_group = tmp_52;
            sourceInformationMarkerEnd($composer_5);
            OptionSelectionSection(tmp_51, product.mzu_1, state.w12b_1, tmp9_group, language, false, $composer_5, 0, 32);
            $composer_5.n30();
          } else {
            $composer_5.m30(1514456631);
            $composer_5.n30();
          }
          var tmp24_safe_receiver = product.nzu_1;
          if (tmp24_safe_receiver == null) {
            $composer_5.m30(1514550498);
            $composer_5.n30();
          } else {
            $composer_5.m30(1514550499);
            sourceInformation($composer_5, '*242@11861L291,239@11677L542');
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s = tmp24_safe_receiver.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              var tmp_53 = state.x12b_1.w2(element.r101_1);
              sourceInformationMarkerStart($composer_5, 1141375050, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_10 = !!(($dirty & 112) === 32 | $composer_0.q31(element));
              // Inline function 'kotlin.let' call
              var it_18 = $composer_5.i31();
              var tmp_54;
              if (invalid_10 || it_18 === Companion_getInstance().f30_1) {
                var value_18 = ModelMugScreenContent$lambda_22(onIntent, element);
                $composer_5.j31(value_18);
                tmp_54 = value_18;
              } else {
                tmp_54 = it_18;
              }
              var tmp0_group_2 = tmp_54;
              sourceInformationMarkerEnd($composer_5);
              OptionSelectionSection_0(element, tmp_53, tmp0_group_2, language, false, $composer_5, 0, 16);
              var tmp0_safe_receiver_1 = state.x12b_1.w2(element.r101_1);
              if (tmp0_safe_receiver_1 == null) {
                $composer_5.m30(1023318742);
                $composer_5.n30();
              } else {
                $composer_5.m30(1023318743);
                sourceInformation($composer_5, '');
                // Inline function 'kotlin.let' call
                if (tmp0_safe_receiver_1.w100_1 || tmp0_safe_receiver_1.z100_1 || tmp0_safe_receiver_1.c101_1) {
                  $composer_5.m30(-1487887864);
                  sourceInformation($composer_5, '258@12686L145,261@12888L176,254@12437L722');
                  sourceInformationMarkerStart($composer_5, 783295905, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
                  // Inline function 'androidx.compose.runtime.cache' call
                  var invalid_11 = !!(($dirty & 112) === 32 | $composer_0.q31(element));
                  // Inline function 'kotlin.let' call
                  var it_19 = $composer_5.i31();
                  var tmp_55;
                  if (invalid_11 || it_19 === Companion_getInstance().f30_1) {
                    var value_19 = ModelMugScreenContent$lambda_23(onIntent, element);
                    $composer_5.j31(value_19);
                    tmp_55 = value_19;
                  } else {
                    tmp_55 = it_19;
                  }
                  var tmp0_group_3 = tmp_55;
                  sourceInformationMarkerEnd($composer_5);
                  sourceInformationMarkerStart($composer_5, 783302400, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
                  // Inline function 'androidx.compose.runtime.cache' call
                  var invalid_12 = $composer_5.q31(element);
                  // Inline function 'kotlin.let' call
                  var it_20 = $composer_5.i31();
                  var tmp_56;
                  if (invalid_12 || it_20 === Companion_getInstance().f30_1) {
                    var value_20 = ModelMugScreenContent$lambda_24(element, birthdayPickerTargetOptionKey$delegate, showBirthdayPicker$delegate);
                    $composer_5.j31(value_20);
                    tmp_56 = value_20;
                  } else {
                    tmp_56 = it_20;
                  }
                  var tmp1_group_1 = tmp_56;
                  sourceInformationMarkerEnd($composer_5);
                  SelectedOptionExtraInputs(element.r101_1, tmp0_safe_receiver_1, language, tmp0_group_3, tmp1_group_1, !state.i12b_1, $composer_5, 0, 0);
                  $composer_5.n30();
                } else {
                  $composer_5.m30(-1487140206);
                  $composer_5.n30();
                }
                $composer_5.n30();
              }
            }
            $composer_5.n30();
          }
          var tmp_57 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$135 = _Dp___init__impl__ms3zkb(16);
          Spacer(height(tmp_57, tmp$ret$135), $composer_5, 6);
          var tmp25_value = state.y12b_1;
          var tmp_58 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$136 = _Dp___init__impl__ms3zkb(24);
          var tmp26_modifier = padding_2(tmp_58, tmp$ret$136);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$137 = _Dp___init__impl__ms3zkb(12);
          var tmp27_shape = RoundedCornerShape(tmp$ret$137);
          sourceInformationMarkerStart($composer_5, -643824997, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_13 = ($dirty & 112) === 32;
          // Inline function 'kotlin.let' call
          var it_21 = $composer_5.i31();
          var tmp_59;
          if (invalid_13 || it_21 === Companion_getInstance().f30_1) {
            var value_21 = ModelMugScreenContent$lambda_25(onIntent);
            $composer_5.j31(value_21);
            tmp_59 = value_21;
          } else {
            tmp_59 = it_21;
          }
          var tmp10_group = tmp_59;
          sourceInformationMarkerEnd($composer_5);
          var tmp_60 = ComposableSingletons$ModelMugScreenContentKt_getInstance().s12x_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_3 = rememberComposableLambda(-396011442, true, ModelMugScreenContent$lambda_26(state), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_15 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_14 = $composer_15.k31(dispatchReceiver_3);
          // Inline function 'kotlin.let' call
          var it_22 = $composer_15.i31();
          var tmp_61;
          if (invalid_14 || it_22 === Companion_getInstance().f30_1) {
            var value_22 = ComposableLambda$invoke$ref(dispatchReceiver_3);
            $composer_15.j31(value_22);
            tmp_61 = value_22;
          } else {
            tmp_61 = it_22;
          }
          var tmp_62 = tmp_61;
          OutlinedTextField(tmp25_value, tmp10_group, tmp26_modifier, false, false, null, tmp_60, null, null, null, null, null, tmp_62, false, null, null, null, false, 3, 0, null, tmp27_shape, null, $composer_5, 1573248, 100663680, 0, 6025144);
          if (ModelMugScreenContent$lambda_1(showBirthdayPicker$delegate)) {
            $composer_5.m30(1517245639);
            sourceInformation($composer_5, '295@14403L147,299@14592L1828,330@16462L402,339@16887L87,294@14342L2632');
            sourceInformationMarkerStart($composer_5, -643793122, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_23 = $composer_5.i31();
            var tmp_63;
            if (false || it_23 === Companion_getInstance().f30_1) {
              var value_23 = ModelMugScreenContent$lambda_27(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate);
              $composer_5.j31(value_23);
              tmp_63 = value_23;
            } else {
              tmp_63 = it_23;
            }
            var tmp11_group = tmp_63;
            sourceInformationMarkerEnd($composer_5);
            // Inline function 'kotlin.run' call
            var dispatchReceiver_4 = rememberComposableLambda(-373627442, true, ModelMugScreenContent$lambda_28(birthdayPickerState, state, onIntent, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_5, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_16 = $composer_5;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_15 = $composer_16.k31(dispatchReceiver_4);
            // Inline function 'kotlin.let' call
            var it_24 = $composer_16.i31();
            var tmp_64;
            if (invalid_15 || it_24 === Companion_getInstance().f30_1) {
              var value_24 = ComposableLambda$invoke$ref(dispatchReceiver_4);
              $composer_16.j31(value_24);
              tmp_64 = value_24;
            } else {
              tmp_64 = it_24;
            }
            var tmp_65 = tmp_64;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_5 = rememberComposableLambda(2028655244, true, ModelMugScreenContent$lambda_29(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate), $composer_5, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_17 = $composer_5;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_16 = $composer_17.k31(dispatchReceiver_5);
            // Inline function 'kotlin.let' call
            var it_25 = $composer_17.i31();
            var tmp_66;
            if (invalid_16 || it_25 === Companion_getInstance().f30_1) {
              var value_25 = ComposableLambda$invoke$ref(dispatchReceiver_5);
              $composer_17.j31(value_25);
              tmp_66 = value_25;
            } else {
              tmp_66 = it_25;
            }
            var tmp_67 = tmp_66;
            var tmp_68 = _Dp___init__impl__ms3zkb(0.0);
            // Inline function 'kotlin.run' call
            var dispatchReceiver_6 = rememberComposableLambda(2070313175, true, ModelMugScreenContent$lambda_30(birthdayPickerState), $composer_5, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_18 = $composer_5;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_17 = $composer_18.k31(dispatchReceiver_6);
            // Inline function 'kotlin.let' call
            var it_26 = $composer_18.i31();
            var tmp_69;
            if (invalid_17 || it_26 === Companion_getInstance().f30_1) {
              var value_26 = ComposableLambda$invoke$ref_6(dispatchReceiver_6);
              $composer_18.j31(value_26);
              tmp_69 = value_26;
            } else {
              tmp_69 = it_26;
            }
            var tmp$ret$167 = tmp_69;
            DatePickerDialog(tmp11_group, tmp_65, null, tmp_67, null, tmp_68, null, null, tmp$ret$167, $composer_5, 100666422, 244);
            $composer_5.n30();
          } else {
            $composer_5.m30(1519813431);
            $composer_5.n30();
          }
          $composer_5.n30();
        } else {
          $composer_5.m30(1519827319);
          $composer_5.n30();
        }
        var tmp_70 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$174 = _Dp___init__impl__ms3zkb(100);
        Spacer(height(tmp_70, tmp$ret$174), $composer_5, 6);
        $composer_5.n30();
      } else {
        $composer_5.m30(1519891799);
        $composer_5.n30();
      }
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      var tmp_71;
      if (state.j12b_1) {
        tmp_71 = true;
      } else {
        var tmp_72;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!state.h12b_1.r()) {
          tmp_72 = state.g12b_1 == null;
        } else {
          tmp_72 = false;
        }
        tmp_71 = tmp_72;
      }
      if (tmp_71) {
        $composer_0.m30(-2107788259);
        sourceInformation($composer_0, '350@17269L211,357@17504L60');
        sourceInformationMarkerStart($composer_0, -1453464044, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
        var tmp0_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_18 = ($dirty & 112) === 32;
        // Inline function 'kotlin.let' call
        var it_27 = tmp0_1.i31();
        var tmp_73;
        if (invalid_18 || it_27 === Companion_getInstance().f30_1) {
          var value_27 = ModelMugScreenContent$lambda_31(onIntent);
          tmp0_1.j31(value_27);
          tmp_73 = value_27;
        } else {
          tmp_73 = it_27;
        }
        var tmp4_group_0 = tmp_73;
        sourceInformationMarkerEnd($composer_0);
        var onDone = tmp4_group_0;
        sourceInformationMarkerStart($composer_0, -1453456675, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
        var tmp0_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_19 = ($dirty & 112) === 32;
        // Inline function 'kotlin.let' call
        var it_28 = tmp0_2.i31();
        var tmp_74;
        if (invalid_19 || it_28 === Companion_getInstance().f30_1) {
          var value_28 = ModelMugScreenContent$lambda_32(onIntent);
          tmp0_2.j31(value_28);
          tmp_74 = value_28;
        } else {
          tmp_74 = it_28;
        }
        var tmp5_group_0 = tmp_74;
        sourceInformationMarkerEnd($composer_0);
        var onCancel = tmp5_group_0;
        var tmp0_safe_receiver_2 = state.e12b_1;
        if (equals(tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.bzu_1, ProductKind_MAGIC_MUG_getInstance())) {
          $composer_0.m30(-2107360924);
          sourceInformation($composer_0, '362@17638L165');
          MagicMugImageEditorScreen(state.h12b_1, onDone, onCancel, $composer_0, 0, 0);
          $composer_0.n30();
        } else {
          $composer_0.m30(-2107167639);
          sourceInformation($composer_0, '368@17833L160');
          MugImageEditorScreen(state.h12b_1, onDone, onCancel, $composer_0, 0, 0);
          $composer_0.n30();
        }
        $composer_0.n30();
      } else {
        $composer_0.m30(-2106984863);
        $composer_0.n30();
      }
      if (ModelMugScreenContent$lambda(showDeleteConfirmation$delegate)) {
        $composer_0.m30(-2106923235);
        sourceInformation($composer_0, '378@18097L34,381@18315L423,392@18768L168,377@18053L884');
        sourceInformationMarkerStart($composer_0, -1453437725, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_6 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_29 = this_6.i31();
        var tmp_75;
        if (false || it_29 === Companion_getInstance().f30_1) {
          var value_29 = ModelMugScreenContent$lambda_33(showDeleteConfirmation$delegate);
          this_6.j31(value_29);
          tmp_75 = value_29;
        } else {
          tmp_75 = it_29;
        }
        var tmp6_group_0 = tmp_75;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_7 = rememberComposableLambda(-120789129, true, ModelMugScreenContent$lambda_34(onIntent, showDeleteConfirmation$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_19 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_20 = $composer_19.k31(dispatchReceiver_7);
        // Inline function 'kotlin.let' call
        var it_30 = $composer_19.i31();
        var tmp_76;
        if (invalid_20 || it_30 === Companion_getInstance().f30_1) {
          var value_30 = ComposableLambda$invoke$ref(dispatchReceiver_7);
          $composer_19.j31(value_30);
          tmp_76 = value_30;
        } else {
          tmp_76 = it_30;
        }
        var tmp_77 = tmp_76;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_8 = rememberComposableLambda(163196409, true, ModelMugScreenContent$lambda_35(showDeleteConfirmation$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_20 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_21 = $composer_20.k31(dispatchReceiver_8);
        // Inline function 'kotlin.let' call
        var it_31 = $composer_20.i31();
        var tmp_78;
        if (invalid_21 || it_31 === Companion_getInstance().f30_1) {
          var value_31 = ComposableLambda$invoke$ref(dispatchReceiver_8);
          $composer_20.j31(value_31);
          tmp_78 = value_31;
        } else {
          tmp_78 = it_31;
        }
        var tmp_79 = tmp_78;
        var tmp_80 = ComposableSingletons$ModelMugScreenContentKt_getInstance().x12x_1;
        var tmp_81 = ComposableSingletons$ModelMugScreenContentKt_getInstance().y12x_1;
        var tmp_82 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_83 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_84 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_85 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_86 = _Dp___init__impl__ms3zkb(0.0);
        AlertDialog(tmp6_group_0, tmp_77, null, tmp_79, null, tmp_80, tmp_81, null, tmp_82, tmp_83, tmp_84, tmp_85, tmp_86, null, $composer_0, 1772598, 0, 16276);
        $composer_0.n30();
      } else {
        $composer_0.m30(-2106058335);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp7_safe_receiver = $composer_0.t30();
    if (tmp7_safe_receiver == null)
      null;
    else {
      tmp7_safe_receiver.p3c(ModelMugScreenContent$lambda_36(state, onIntent, padding_0, isFullScreen_0, topPadding_0, bottomPadding_0, $changed, $default));
    }
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$_1769275579$lambda_2oa2e0($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C108@4720L45,108@4715L51:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1769275579, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$-1769275579.<anonymous> (ModelMugScreenContent.kt:108)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$583582662$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C109@4819L51,109@4814L57:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(583582662, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$583582662.<anonymous> (ModelMugScreenContent.kt:109)');
      }
      var tmp = stringResource(get_gift_message_placeholder(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$1813360520$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C139@6551L48,139@6546L54:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1813360520, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$1813360520.<anonymous> (ModelMugScreenContent.kt:139)');
      }
      var tmp = stringResource(get_invalid_birthday_date(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$_1035602$lambda_ot1oll($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C130@5961L46,130@5956L52:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1035602, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$-1035602.<anonymous> (ModelMugScreenContent.kt:130)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$_958065777$lambda_zbtmye($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C146@6944L60:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-958065777, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$-958065777.<anonymous> (ModelMugScreenContent.kt:146)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$574260398$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C172@8209L45,172@8204L51:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(574260398, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$574260398.<anonymous> (ModelMugScreenContent.kt:172)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$_1776734993$lambda_gz839k($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C173@8308L51,173@8303L57:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1776734993, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$-1776734993.<anonymous> (ModelMugScreenContent.kt:173)');
      }
      var tmp = stringResource(get_gift_message_placeholder(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$_1692506007$lambda_v1wxoy($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C203@10034L48,203@10029L54:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1692506007, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$-1692506007.<anonymous> (ModelMugScreenContent.kt:203)');
      }
      var tmp = stringResource(get_invalid_birthday_date(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$_954170921$lambda_s1scew($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C194@9447L46,194@9442L52:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-954170921, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$-954170921.<anonymous> (ModelMugScreenContent.kt:194)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$_1537167752$lambda_um68o2($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C210@10426L60:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1537167752, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$-1537167752.<anonymous> (ModelMugScreenContent.kt:210)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$_841172229$lambda_wdndfw($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C279@13619L52,279@13614L58:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-841172229, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$-841172229.<anonymous> (ModelMugScreenContent.kt:279)');
      }
      var tmp = stringResource(get_add_product_comment_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$1035910961$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C327@16334L29,327@16329L35:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1035910961, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$1035910961.<anonymous> (ModelMugScreenContent.kt:327)');
      }
      var tmp = stringResource(get_ok(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$_856773649$lambda_py9hm5($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C336@16774L33,336@16769L39:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-856773649, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$-856773649.<anonymous> (ModelMugScreenContent.kt:336)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$1734049639$lambda($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C389@18672L33,389@18667L39:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1734049639, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$1734049639.<anonymous> (ModelMugScreenContent.kt:389)');
      }
      var tmp = stringResource(get_delete(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$_1072810058$lambda_ezql82($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C394@18870L33,394@18865L39:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1072810058, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$-1072810058.<anonymous> (ModelMugScreenContent.kt:394)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$447181947$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C379@18160L46,379@18155L52:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(447181947, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$447181947.<anonymous> (ModelMugScreenContent.kt:379)');
      }
      var tmp = stringResource(get_remove_design_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt$lambda$_1558308932$lambda_bxtshw($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C380@18237L45,380@18232L51:ModelMugScreenContent.kt#1kmb0q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1558308932, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ComposableSingletons$ModelMugScreenContentKt.lambda$-1558308932.<anonymous> (ModelMugScreenContent.kt:380)');
      }
      var tmp = stringResource(get_remove_design_desc(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ModelMugScreenContentKt() {
    ComposableSingletons$ModelMugScreenContentKt_instance = this;
    var tmp = this;
    tmp.i12x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1769275579, false, ComposableSingletons$ModelMugScreenContentKt$lambda$_1769275579$lambda_2oa2e0));
    var tmp_0 = this;
    tmp_0.j12x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(583582662, false, ComposableSingletons$ModelMugScreenContentKt$lambda$583582662$lambda));
    var tmp_1 = this;
    tmp_1.k12x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1813360520, false, ComposableSingletons$ModelMugScreenContentKt$lambda$1813360520$lambda));
    var tmp_2 = this;
    tmp_2.l12x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1035602, false, ComposableSingletons$ModelMugScreenContentKt$lambda$_1035602$lambda_ot1oll));
    var tmp_3 = this;
    tmp_3.m12x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-958065777, false, ComposableSingletons$ModelMugScreenContentKt$lambda$_958065777$lambda_zbtmye));
    var tmp_4 = this;
    tmp_4.n12x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(574260398, false, ComposableSingletons$ModelMugScreenContentKt$lambda$574260398$lambda));
    var tmp_5 = this;
    tmp_5.o12x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1776734993, false, ComposableSingletons$ModelMugScreenContentKt$lambda$_1776734993$lambda_gz839k));
    var tmp_6 = this;
    tmp_6.p12x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1692506007, false, ComposableSingletons$ModelMugScreenContentKt$lambda$_1692506007$lambda_v1wxoy));
    var tmp_7 = this;
    tmp_7.q12x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-954170921, false, ComposableSingletons$ModelMugScreenContentKt$lambda$_954170921$lambda_s1scew));
    var tmp_8 = this;
    tmp_8.r12x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1537167752, false, ComposableSingletons$ModelMugScreenContentKt$lambda$_1537167752$lambda_um68o2));
    var tmp_9 = this;
    tmp_9.s12x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-841172229, false, ComposableSingletons$ModelMugScreenContentKt$lambda$_841172229$lambda_wdndfw));
    var tmp_10 = this;
    tmp_10.t12x_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1035910961, false, ComposableSingletons$ModelMugScreenContentKt$lambda$1035910961$lambda));
    var tmp_11 = this;
    tmp_11.u12x_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-856773649, false, ComposableSingletons$ModelMugScreenContentKt$lambda$_856773649$lambda_py9hm5));
    var tmp_12 = this;
    tmp_12.v12x_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1734049639, false, ComposableSingletons$ModelMugScreenContentKt$lambda$1734049639$lambda));
    var tmp_13 = this;
    tmp_13.w12x_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1072810058, false, ComposableSingletons$ModelMugScreenContentKt$lambda$_1072810058$lambda_ezql82));
    var tmp_14 = this;
    tmp_14.x12x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(447181947, false, ComposableSingletons$ModelMugScreenContentKt$lambda$447181947$lambda));
    var tmp_15 = this;
    tmp_15.y12x_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1558308932, false, ComposableSingletons$ModelMugScreenContentKt$lambda$_1558308932$lambda_bxtshw));
  }
  var ComposableSingletons$ModelMugScreenContentKt_instance;
  function ComposableSingletons$ModelMugScreenContentKt_getInstance() {
    if (ComposableSingletons$ModelMugScreenContentKt_instance == null)
      new ComposableSingletons$ModelMugScreenContentKt();
    return ComposableSingletons$ModelMugScreenContentKt_instance;
  }
  function ModelMugScreenContent$lambda($showDeleteConfirmation$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDeleteConfirmation', KMutableProperty0, true);
    return $showDeleteConfirmation$delegate.u1();
  }
  function ModelMugScreenContent$lambda_0($showDeleteConfirmation$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDeleteConfirmation', KMutableProperty0, true);
    $showDeleteConfirmation$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ModelMugScreenContent$lambda_1($showBirthdayPicker$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    return $showBirthdayPicker$delegate.u1();
  }
  function ModelMugScreenContent$lambda_2($showBirthdayPicker$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    $showBirthdayPicker$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ModelMugScreenContent$lambda_3($birthdayPickerTargetOptionKey$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    return $birthdayPickerTargetOptionKey$delegate.u1();
  }
  function ModelMugScreenContent$lambda_4($birthdayPickerTargetOptionKey$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    $birthdayPickerTargetOptionKey$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ModelMugScreenContent$lambda_5($isPickingBoxBirthday$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    return $isPickingBoxBirthday$delegate.u1();
  }
  function ModelMugScreenContent$lambda_6($isPickingBoxBirthday$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    $isPickingBoxBirthday$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ModelMugScreenContent$lambda_7($onIntent, $state) {
    return function () {
      var tmp0_safe_receiver = $state.e12b_1;
      $onIntent(new LoadProduct(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.nzt_1, $state.e12b_1, $state.l12b_1, $state.m12b_1));
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_8($onIntent) {
    return function (it) {
      $onIntent(new CardSelected(it instanceof Card_1 ? it : null));
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_9($onIntent) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        tmp = $onIntent(new CardMessageChanged(it));
      }
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_10($state) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C118@5458L10,114@5151L362:ModelMugScreenContent.kt#1kmb0q');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(20624664, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ModelMugScreenContent.<anonymous>.<anonymous> (ModelMugScreenContent.kt:114)');
        }
        var tmp_0 = '' + $state.o12b_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_11($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      ModelMugScreenContent$lambda_6($isPickingBoxBirthday$delegate, false);
      ModelMugScreenContent$lambda_2($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_12(it) {
    return Unit_instance;
  }
  function ModelMugScreenContent$lambda$lambda($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      ModelMugScreenContent$lambda_6($isPickingBoxBirthday$delegate, false);
      ModelMugScreenContent$lambda_2($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_13($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C142@6742L162,142@6721L317:ModelMugScreenContent.kt#1kmb0q');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1535912817, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ModelMugScreenContent.<anonymous>.<anonymous> (ModelMugScreenContent.kt:142)');
        }
        sourceInformationMarkerStart($composer_0, -1456530765, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ModelMugScreenContent$lambda$lambda($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$ModelMugScreenContentKt_getInstance().m12x_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_14($onIntent) {
    return function (it) {
      $onIntent(new BoxSelected(it instanceof Box_0 ? it : null));
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_15($onIntent) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        tmp = $onIntent(new BoxMessageChanged(it));
      }
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_16($state) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C182@8946L10,178@8640L361:ModelMugScreenContent.kt#1kmb0q');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1613491775, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ModelMugScreenContent.<anonymous>.<anonymous> (ModelMugScreenContent.kt:178)');
        }
        var tmp_0 = '' + $state.s12b_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_17($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      ModelMugScreenContent$lambda_6($isPickingBoxBirthday$delegate, true);
      ModelMugScreenContent$lambda_2($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_18(it) {
    return Unit_instance;
  }
  function ModelMugScreenContent$lambda$lambda_0($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      ModelMugScreenContent$lambda_6($isPickingBoxBirthday$delegate, true);
      ModelMugScreenContent$lambda_2($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_19($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C206@10225L161,206@10204L316:ModelMugScreenContent.kt#1kmb0q');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1415490086, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ModelMugScreenContent.<anonymous>.<anonymous> (ModelMugScreenContent.kt:206)');
        }
        sourceInformationMarkerStart($composer_0, 1218662107, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ModelMugScreenContent$lambda$lambda_0($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$ModelMugScreenContentKt_getInstance().r12x_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_20($onIntent) {
    return function (it) {
      $onIntent(new SizeSelected(it));
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_21($onIntent) {
    return function (it) {
      $onIntent(new ColorSelected(it));
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_22($onIntent, $option) {
    return function (value) {
      $onIntent(new OptionSelected($option.r101_1, value));
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_23($onIntent, $option) {
    return function (newValue) {
      $onIntent(new OptionSelected($option.r101_1, newValue));
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_24($option, $birthdayPickerTargetOptionKey$delegate, $showBirthdayPicker$delegate) {
    return function () {
      ModelMugScreenContent$lambda_4($birthdayPickerTargetOptionKey$delegate, $option.r101_1);
      ModelMugScreenContent$lambda_2($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_25($onIntent) {
    return function (it) {
      var tmp;
      if (it.length <= 100) {
        tmp = $onIntent(new ProductCommentChanged(it));
      }
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_26($state) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C288@14191L10,284@13912L326:ModelMugScreenContent.kt#1kmb0q');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-396011442, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ModelMugScreenContent.<anonymous>.<anonymous> (ModelMugScreenContent.kt:284)');
        }
        var tmp_0 = '' + $state.y12b_1.length + '/100';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_27($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate) {
    return function () {
      ModelMugScreenContent$lambda_2($showBirthdayPicker$delegate, false);
      ModelMugScreenContent$lambda_4($birthdayPickerTargetOptionKey$delegate, null);
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda$lambda_1($birthdayPickerState, $state, $onIntent, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      var tmp0_safe_receiver = $birthdayPickerState.np1();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var date = toLocalDateTime(Companion_getInstance_19().kf(tmp0_safe_receiver), Companion_getInstance_20().yno_1).xn9_1.toString();
        if (!(ModelMugScreenContent$lambda_3($birthdayPickerTargetOptionKey$delegate) == null)) {
          var key = ensureNotNull(ModelMugScreenContent$lambda_3($birthdayPickerTargetOptionKey$delegate));
          var selectedValue = $state.x12b_1.w2(key);
          if (!(selectedValue == null)) {
            $onIntent(new OptionSelected(key, selectedValue.k101(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, date)));
          }
        } else if (ModelMugScreenContent$lambda_5($isPickingBoxBirthday$delegate)) {
          $onIntent(new BoxBirthdayChanged(date));
        } else {
          $onIntent(new CardBirthdayChanged(date));
        }
      }
      ModelMugScreenContent$lambda_2($showBirthdayPicker$delegate, false);
      ModelMugScreenContent$lambda_4($birthdayPickerTargetOptionKey$delegate, null);
      ModelMugScreenContent$lambda_6($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_28($birthdayPickerState, $state, $onIntent, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C300@14643L1650,300@14622L1772:ModelMugScreenContent.kt#1kmb0q');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-373627442, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ModelMugScreenContent.<anonymous>.<anonymous> (ModelMugScreenContent.kt:300)');
        }
        sourceInformationMarkerStart($composer_0, 1721284384, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.k31($birthdayPickerState) | $composer_0.q31($state)) | $composer_0.k31($onIntent));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ModelMugScreenContent$lambda$lambda_1($birthdayPickerState, $state, $onIntent, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$ModelMugScreenContentKt_getInstance().t12x_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda$lambda_2($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function () {
      ModelMugScreenContent$lambda_2($showBirthdayPicker$delegate, false);
      ModelMugScreenContent$lambda_4($birthdayPickerTargetOptionKey$delegate, null);
      ModelMugScreenContent$lambda_6($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_29($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C331@16513L220,331@16492L346:ModelMugScreenContent.kt#1kmb0q');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2028655244, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ModelMugScreenContent.<anonymous>.<anonymous> (ModelMugScreenContent.kt:331)');
        }
        sourceInformationMarkerStart($composer_0, -377461048, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ModelMugScreenContent$lambda$lambda_2($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$ModelMugScreenContentKt_getInstance().u12x_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_30($birthdayPickerState) {
    return function ($this$DatePickerDialog, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C340@16913L39:ModelMugScreenContent.kt#1kmb0q');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2070313175, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ModelMugScreenContent.<anonymous>.<anonymous> (ModelMugScreenContent.kt:340)');
        }
        DatePicker($birthdayPickerState, null, null, null, null, null, false, null, $composer_0, 0, 254);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_31($onIntent) {
    return function (bitmap, bytes, elements) {
      $onIntent(new CustomImageApplied(bitmap, bytes, elements));
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_32($onIntent) {
    return function () {
      $onIntent(CloseEditor_instance);
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_33($showDeleteConfirmation$delegate) {
    return function () {
      ModelMugScreenContent$lambda_0($showDeleteConfirmation$delegate, false);
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda$lambda_3($onIntent, $showDeleteConfirmation$delegate) {
    return function () {
      $onIntent(RemoveCustomization_instance);
      ModelMugScreenContent$lambda_0($showDeleteConfirmation$delegate, false);
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_34($onIntent, $showDeleteConfirmation$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C383@18371L147,387@18608L11,387@18564L62,382@18333L391:ModelMugScreenContent.kt#1kmb0q');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-120789129, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ModelMugScreenContent.<anonymous> (ModelMugScreenContent.kt:382)');
        }
        sourceInformationMarkerStart($composer_0, -114234038, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($onIntent);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ModelMugScreenContent$lambda$lambda_3($onIntent, $showDeleteConfirmation$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1 = ButtonDefaults_getInstance();
        var tmp_2 = MaterialTheme_instance.unz($composer_0, 6).to0_1;
        var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_5 = tmp_1.ao9(tmp_2, tmp_3, tmp_4, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 14);
        Button(tmp0_group, null, false, null, tmp_5, null, null, null, null, ComposableSingletons$ModelMugScreenContentKt_getInstance().v12x_1, $composer_0, 805306368, 494);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda$lambda_4($showDeleteConfirmation$delegate) {
    return function () {
      ModelMugScreenContent$lambda_0($showDeleteConfirmation$delegate, false);
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_35($showDeleteConfirmation$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C393@18807L34,393@18786L136:ModelMugScreenContent.kt#1kmb0q');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(163196409, $changed, -1, 'client.fstech.hadaya.presentation.model3d.components.ModelMugScreenContent.<anonymous> (ModelMugScreenContent.kt:393)');
        }
        sourceInformationMarkerStart($composer_0, -2082039621, 'CC(remember):ModelMugScreenContent.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ModelMugScreenContent$lambda$lambda_4($showDeleteConfirmation$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$ModelMugScreenContentKt_getInstance().w12x_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ModelMugScreenContent$lambda_36($state, $onIntent, $padding, $isFullScreen, $topPadding, $bottomPadding, $$changed, $$default) {
    return function ($composer, $force) {
      ModelMugScreenContent($state, $onIntent, $padding, $isFullScreen._v, $topPadding._v.m5f_1, $bottomPadding._v.m5f_1, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_mvi_BaseMviViewModel$stable;
  function BaseMviViewModel$container$o$intent$slambda(this$0, $intent, resultContinuation) {
    this.h12y_1 = this$0;
    this.i12y_1 = $intent;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BaseMviViewModel$container$o$intent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BaseMviViewModel$container$o$intent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BaseMviViewModel$container$o$intent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.h12y_1.f10l(this.i12y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BaseMviViewModel$container$o$intent$slambda).q24 = function ($this$launch, completion) {
    var i = new BaseMviViewModel$container$o$intent$slambda(this.h12y_1, this.i12y_1, completion);
    i.j12y_1 = $this$launch;
    return i;
  };
  function BaseMviViewModel$container$o$intent$slambda_0(this$0, $intent, resultContinuation) {
    var i = new BaseMviViewModel$container$o$intent$slambda(this$0, $intent, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function BaseMviViewModel$container$1(this$0) {
    this.m12y_1 = this$0;
    this.k12y_1 = asStateFlow(this$0.p10h_1);
    this.l12y_1 = asSharedFlow(this$0.q10h_1);
  }
  protoOf(BaseMviViewModel$container$1).ajg = function () {
    return this.k12y_1;
  };
  protoOf(BaseMviViewModel$container$1).t10h = function () {
    return this.l12y_1;
  };
  protoOf(BaseMviViewModel$container$1).j10i = function (intent) {
    var tmp = get_viewModelScope(this.m12y_1);
    launch(tmp, VOID, VOID, BaseMviViewModel$container$o$intent$slambda_0(this.m12y_1, intent, null));
  };
  function BaseMviViewModel(initialState) {
    ViewModel_init_$Init$(this);
    this.p10h_1 = MutableStateFlow(initialState);
    this.q10h_1 = MutableSharedFlow();
    var tmp = this;
    tmp.r10h_1 = new BaseMviViewModel$container$1(this);
  }
  protoOf(BaseMviViewModel).s10h = function () {
    return this.r10h_1;
  };
  protoOf(BaseMviViewModel).x10k = function (reducer) {
    this.p10h_1.s21(reducer(this.p10h_1.u1()));
  };
  protoOf(BaseMviViewModel).d10l = function (sideEffect, $completion) {
    return this.q10h_1.a1v(sideEffect, $completion);
  };
  var client_fstech_hadaya_presentation_order_OrderState$stable;
  var client_fstech_hadaya_presentation_order_OrderIntent_SetOrder$stable;
  var client_fstech_hadaya_presentation_order_OrderIntent_UpdateComment$stable;
  var client_fstech_hadaya_presentation_order_OrderIntent_ConfirmOrder$stable;
  var client_fstech_hadaya_presentation_order_OrderSideEffect_ShowError$stable;
  var client_fstech_hadaya_presentation_order_OrderSideEffect_NavigateToHome$stable;
  function OrderState(order, userComment, isPlacingOrder, orderPlacedSuccessfully, placedOrderId, language) {
    userComment = userComment === VOID ? '' : userComment;
    isPlacingOrder = isPlacingOrder === VOID ? false : isPlacingOrder;
    orderPlacedSuccessfully = orderPlacedSuccessfully === VOID ? false : orderPlacedSuccessfully;
    placedOrderId = placedOrderId === VOID ? null : placedOrderId;
    language = language === VOID ? 'en' : language;
    this.n12y_1 = order;
    this.o12y_1 = userComment;
    this.p12y_1 = isPlacingOrder;
    this.q12y_1 = orderPlacedSuccessfully;
    this.r12y_1 = placedOrderId;
    this.s12y_1 = language;
  }
  protoOf(OrderState).t12y = function (order, userComment, isPlacingOrder, orderPlacedSuccessfully, placedOrderId, language) {
    return new OrderState(order, userComment, isPlacingOrder, orderPlacedSuccessfully, placedOrderId, language);
  };
  protoOf(OrderState).u12y = function (order, userComment, isPlacingOrder, orderPlacedSuccessfully, placedOrderId, language, $super) {
    order = order === VOID ? this.n12y_1 : order;
    userComment = userComment === VOID ? this.o12y_1 : userComment;
    isPlacingOrder = isPlacingOrder === VOID ? this.p12y_1 : isPlacingOrder;
    orderPlacedSuccessfully = orderPlacedSuccessfully === VOID ? this.q12y_1 : orderPlacedSuccessfully;
    placedOrderId = placedOrderId === VOID ? this.r12y_1 : placedOrderId;
    language = language === VOID ? this.s12y_1 : language;
    return $super === VOID ? this.t12y(order, userComment, isPlacingOrder, orderPlacedSuccessfully, placedOrderId, language) : $super.t12y.call(this, order, userComment, isPlacingOrder, orderPlacedSuccessfully, placedOrderId, language);
  };
  protoOf(OrderState).toString = function () {
    return 'OrderState(order=' + this.n12y_1.toString() + ', userComment=' + this.o12y_1 + ', isPlacingOrder=' + this.p12y_1 + ', orderPlacedSuccessfully=' + this.q12y_1 + ', placedOrderId=' + toString_0(this.r12y_1) + ', language=' + this.s12y_1 + ')';
  };
  protoOf(OrderState).hashCode = function () {
    var result = this.n12y_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.o12y_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p12y_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q12y_1) | 0;
    result = imul(result, 31) + (this.r12y_1 == null ? 0 : this.r12y_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.s12y_1) | 0;
    return result;
  };
  protoOf(OrderState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrderState))
      return false;
    if (!this.n12y_1.equals(other.n12y_1))
      return false;
    if (!(this.o12y_1 === other.o12y_1))
      return false;
    if (!(this.p12y_1 === other.p12y_1))
      return false;
    if (!(this.q12y_1 === other.q12y_1))
      return false;
    if (!equals(this.r12y_1, other.r12y_1))
      return false;
    if (!(this.s12y_1 === other.s12y_1))
      return false;
    return true;
  };
  function SetOrder(order) {
    this.v12y_1 = order;
  }
  protoOf(SetOrder).toString = function () {
    return 'SetOrder(order=' + this.v12y_1.toString() + ')';
  };
  protoOf(SetOrder).hashCode = function () {
    return this.v12y_1.hashCode();
  };
  protoOf(SetOrder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetOrder))
      return false;
    if (!this.v12y_1.equals(other.v12y_1))
      return false;
    return true;
  };
  function UpdateComment(comment) {
    this.w12y_1 = comment;
  }
  protoOf(UpdateComment).toString = function () {
    return 'UpdateComment(comment=' + this.w12y_1 + ')';
  };
  protoOf(UpdateComment).hashCode = function () {
    return getStringHashCode(this.w12y_1);
  };
  protoOf(UpdateComment).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateComment))
      return false;
    if (!(this.w12y_1 === other.w12y_1))
      return false;
    return true;
  };
  function ConfirmOrder() {
  }
  protoOf(ConfirmOrder).toString = function () {
    return 'ConfirmOrder';
  };
  protoOf(ConfirmOrder).hashCode = function () {
    return -141412898;
  };
  protoOf(ConfirmOrder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConfirmOrder))
      return false;
    return true;
  };
  var ConfirmOrder_instance;
  function ConfirmOrder_getInstance() {
    return ConfirmOrder_instance;
  }
  function OrderIntent() {
  }
  function ShowError_4(message) {
    this.x12y_1 = message;
  }
  protoOf(ShowError_4).toString = function () {
    return 'ShowError(message=' + toString(this.x12y_1) + ')';
  };
  protoOf(ShowError_4).hashCode = function () {
    return hashCode(this.x12y_1);
  };
  protoOf(ShowError_4).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowError_4))
      return false;
    if (!equals(this.x12y_1, other.x12y_1))
      return false;
    return true;
  };
  function NavigateToHome_0() {
  }
  protoOf(NavigateToHome_0).toString = function () {
    return 'NavigateToHome';
  };
  protoOf(NavigateToHome_0).hashCode = function () {
    return 1694748815;
  };
  protoOf(NavigateToHome_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateToHome_0))
      return false;
    return true;
  };
  var NavigateToHome_instance_0;
  function NavigateToHome_getInstance_0() {
    return NavigateToHome_instance_0;
  }
  function OrderSideEffect() {
  }
  function OrderScreen(order, onBack, onNavigateHome, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1258132588);
    sourceInformation($composer_0, 'C(OrderScreen)P(2)68@3052L23,68@3038L37,69@3119L16,70@3164L32,72@3227L71,72@3202L96,76@3330L304,76@3304L330,85@3684L63,85@3640L107,89@3753L3378:OrderScreen.kt#ucz02q');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(order) : $composer_0.q31(order)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateHome) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1258132588, $dirty, -1, 'client.fstech.hadaya.presentation.order.OrderScreen (OrderScreen.kt:67)');
      }
      sourceInformationMarkerStart($composer_0, 2115365035, 'CC(remember):OrderScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(order));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = OrderScreen$lambda(order);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = tmp0_group;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((31 & 1) === 0))
        qualifier = null;
      if (!((31 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp_0;
      }
      if (!((31 & 4) === 0))
        key = null;
      if (!((31 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((31 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((31 & 32) === 0))
        parameters = null;
      var tmp0_0 = resolveViewModel(getKClass(OrderViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0_0;
      var tmp_1 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_1, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, 2115368628, 'CC(remember):OrderScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_0.i31();
      var tmp_2;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = new SnackbarHostState();
        this_0.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp1_group;
      sourceInformationMarkerStart($composer_0, 2115370683, 'CC(remember):OrderScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.q31(viewModel) | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(order))));
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_1.i31();
      var tmp_3;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = OrderScreen$slambda_0(viewModel, order, null);
        tmp0_1.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp2_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(order.lzc_1, tmp2_group, $composer_0, 0);
      sourceInformationMarkerStart($composer_0, 2115374212, 'CC(remember):OrderScreen.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!($composer_0.q31(viewModel) | ($dirty & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_2.i31();
      var tmp_4;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = OrderScreen$slambda_2(viewModel, snackbarHostState, onNavigateHome, null);
        tmp0_2.j31(value_2);
        tmp_4 = value_2;
      } else {
        tmp_4 = it_2;
      }
      var tmp3_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp3_group, $composer_0, 0);
      var tmp_5 = OrderScreen$lambda_0(state$delegate).p12y_1;
      sourceInformationMarkerStart($composer_0, 2115385299, 'CC(remember):OrderScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_3 = this_1.i31();
      var tmp_6;
      if (false || it_3 === Companion_getInstance().f30_1) {
        var value_3 = OrderScreen$lambda_1;
        this_1.j31(value_3);
        tmp_6 = value_3;
      } else {
        tmp_6 = it_3;
      }
      var tmp4_group = tmp_6;
      sourceInformationMarkerEnd($composer_0);
      BackHandler(tmp_5, tmp4_group, $composer_0, 48, 0);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = fillMaxSize(Companion_instance);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_2 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_3 = $composer_2;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_0);
      var tmp0_3 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_7 = $composer_4.g30();
      if (!isInterface(tmp_7, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_3);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_5 = $composer_4;
      var $composer_6 = $composer_5;
      sourceInformationMarkerStart($composer_6, 197132314, 'C90@3802L1447,164@6997L128:OrderScreen.kt#ucz02q');
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = fillMaxSize(Companion_instance);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_7 = $composer_6;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_7, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_8 = $composer_7;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
      var localMap_0 = $composer_8.t31();
      var materialized_0 = materialize($composer_8, modifier_2);
      var tmp0_4 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_9 = $composer_8;
      var tmp_8 = $composer_9.g30();
      if (!isInterface(tmp_8, Applier)) {
        invalidApplier();
      }
      $composer_9.b31();
      if ($composer_9.h30()) {
        $composer_9.c31(tmp0_4);
      } else {
        $composer_9.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_10 = $composer_9;
      var $composer_11 = $composer_10;
      sourceInformationMarkerStart($composer_11, -570520218, 'C92@3893L277,99@4205L389,91@3858L807:OrderScreen.kt#ucz02q');
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(1894781148, true, OrderScreen$lambda_2(state$delegate), $composer_11, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_12 = $composer_11;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = $composer_12.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_4 = $composer_12.i31();
      var tmp_9;
      if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_12.j31(value_4);
        tmp_9 = value_4;
      } else {
        tmp_9 = it_4;
      }
      var tmp_10 = tmp_9;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_0 = rememberComposableLambda(1230788830, true, OrderScreen$lambda_3(state$delegate, onBack), $composer_11, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_13 = $composer_11;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = $composer_13.k31(dispatchReceiver_0);
      // Inline function 'kotlin.let' call
      var it_5 = $composer_13.i31();
      var tmp_11;
      if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
        var value_5 = ComposableLambda$invoke$ref(dispatchReceiver_0);
        $composer_13.j31(value_5);
        tmp_11 = value_5;
      } else {
        tmp_11 = it_5;
      }
      var tmp_12 = tmp_11;
      var tmp_13 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_14 = WindowInsets(0, 0, 0, 0);
      TopAppBar(tmp_10, null, tmp_12, null, tmp_13, tmp_14, null, null, $composer_11, 390, 218);
      if (OrderScreen$lambda_0(state$delegate).q12y_1) {
        $composer_11.m30(-569707058);
        sourceInformation($composer_11, '113@4732L188');
        OrderSuccessContent(OrderScreen$lambda_0(state$delegate).r12y_1, OrderScreen$lambda_0(state$delegate).s12y_1, onNavigateHome, $composer_11, 896 & $dirty);
        $composer_11.n30();
      } else {
        $composer_11.m30(-569480417);
        sourceInformation($composer_11, '121@5051L61,122@5151L56,119@4958L267');
        var tmp_15 = OrderScreen$lambda_0(state$delegate);
        sourceInformationMarkerStart($composer_11, -988198347, 'CC(remember):OrderScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = $composer_11.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_6 = $composer_11.i31();
        var tmp_16;
        if (invalid_4 || it_6 === Companion_getInstance().f30_1) {
          var value_6 = OrderScreen$lambda_4(viewModel);
          $composer_11.j31(value_6);
          tmp_16 = value_6;
        } else {
          tmp_16 = it_6;
        }
        var tmp0_group_0 = tmp_16;
        sourceInformationMarkerEnd($composer_11);
        sourceInformationMarkerStart($composer_11, -988195152, 'CC(remember):OrderScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = $composer_11.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_7 = $composer_11.i31();
        var tmp_17;
        if (invalid_5 || it_7 === Companion_getInstance().f30_1) {
          var value_7 = OrderScreen$lambda_5(viewModel);
          $composer_11.j31(value_7);
          tmp_17 = value_7;
        } else {
          tmp_17 = it_7;
        }
        var tmp1_group_0 = tmp_17;
        sourceInformationMarkerEnd($composer_11);
        OrderReviewContent(tmp_15, tmp0_group_0, tmp1_group_0, $composer_11, 0);
        $composer_11.n30();
      }
      sourceInformationMarkerEnd($composer_11);
      $composer_9.e31();
      if (OrderScreen$lambda_0(state$delegate).p12y_1) {
        $composer_6.m30(198553198);
        sourceInformation($composer_6, '129@5342L3,134@5524L1453,128@5299L1678');
        sourceInformationMarkerStart($composer_6, -1933257583, 'CC(remember):OrderScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_8 = $composer_6.i31();
        var tmp_18;
        if (false || it_8 === Companion_getInstance().f30_1) {
          var value_8 = OrderScreen$lambda_6;
          $composer_6.j31(value_8);
          tmp_18 = value_8;
        } else {
          tmp_18 = it_8;
        }
        var tmp0_group_1 = tmp_18;
        sourceInformationMarkerEnd($composer_6);
        var tmp_19 = DialogProperties_init_$Create$(false, false);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(-1575359268, true, OrderScreen$lambda_7(state$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_14 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_6 = $composer_14.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_9 = $composer_14.i31();
        var tmp_20;
        if (invalid_6 || it_9 === Companion_getInstance().f30_1) {
          var value_9 = ComposableLambda$invoke$ref(dispatchReceiver_1);
          $composer_14.j31(value_9);
          tmp_20 = value_9;
        } else {
          tmp_20 = it_9;
        }
        var tmp$ret$60 = tmp_20;
        Dialog(tmp0_group_1, tmp_19, tmp$ret$60, $composer_6, 438, 0);
        $composer_6.n30();
      } else {
        $composer_6.m30(200188820);
        $composer_6.n30();
      }
      var tmp_21 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(snackbarHostState, tmp_21, null, $composer_6, 6, 4);
      sourceInformationMarkerEnd($composer_6);
      $composer_4.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp5_safe_receiver = $composer_0.t30();
    if (tmp5_safe_receiver == null)
      null;
    else {
      tmp5_safe_receiver.p3c(OrderScreen$lambda_8(order, onBack, onNavigateHome, $changed));
    }
  }
  function ComposableSingletons$OrderScreenKt$lambda$_2077253252$lambda_93ybam($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C103@4435L93,101@4315L239:OrderScreen.kt#ucz02q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2077253252, $changed, -1, 'client.fstech.hadaya.presentation.order.ComposableSingletons$OrderScreenKt.lambda$-2077253252.<anonymous> (OrderScreen.kt:101)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderScreenKt$lambda$_952082522$lambda_y1snsa($this$item, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C185@7490L47,186@7577L10,184@7461L200:OrderScreen.kt#ucz02q');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-952082522, $changed, -1, 'client.fstech.hadaya.presentation.order.ComposableSingletons$OrderScreenKt.lambda$-952082522.<anonymous> (OrderScreen.kt:184)');
      }
      var tmp0_text = stringResource(get_order_summary_header(string_instance), $composer_0, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_0, 6).kof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_0 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp, null, tmp_0, null, tmp2_fontWeight, null, tmp_1, null, null, tmp_2, tmp_3, false, 0, 0, null, tmp1_style, $composer_0, 1572864, 0, 131006);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderScreenKt$lambda$_695110508$lambda_jsq94k($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C232@9479L53,232@9474L59:OrderScreen.kt#ucz02q');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-695110508, $changed, -1, 'client.fstech.hadaya.presentation.order.ComposableSingletons$OrderScreenKt.lambda$-695110508.<anonymous> (OrderScreen.kt:232)');
      }
      var tmp = stringResource(get_add_comment_optional_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderScreenKt$lambda$_1193515507$lambda_l8ku2a($this$item, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C240@9699L47,241@9786L10,239@9670L197:OrderScreen.kt#ucz02q');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1193515507, $changed, -1, 'client.fstech.hadaya.presentation.order.ComposableSingletons$OrderScreenKt.lambda$-1193515507.<anonymous> (OrderScreen.kt:239)');
      }
      var tmp0_text = stringResource(get_ordered_items_header(string_instance), $composer_0, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_0, 6).lof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_0 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp, null, tmp_0, null, tmp2_fontWeight, null, tmp_1, null, null, tmp_2, tmp_3, false, 0, 0, null, tmp1_style, $composer_0, 1572864, 0, 131006);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderScreenKt$lambda$1753318219$lambda($this$item, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C296@11865L53,297@11958L10,298@12018L11,295@11836L349:OrderScreen.kt#ucz02q');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1753318219, $changed, -1, 'client.fstech.hadaya.presentation.order.ComposableSingletons$OrderScreenKt.lambda$1753318219.<anonymous> (OrderScreen.kt:295)');
      }
      var tmp0_text = stringResource(get_order_execution_disclaimer(string_instance), $composer_0, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_0, 6).qof_1;
      var tmp2_color = MaterialTheme_instance.unz($composer_0, 6).po0_1;
      var tmp3_textAlign = Companion_getInstance_15().d7v_1;
      var tmp = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      var tmp4_modifier = padding_2(tmp, tmp$ret$0);
      var tmp_0 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, tmp4_modifier, tmp2_color, null, tmp_0, null, null, null, tmp_1, null, tmp3_textAlign, tmp_2, tmp_3, false, 0, 0, null, tmp1_style, $composer_0, 48, 0, 130040);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderScreenKt$lambda$_1490074563$lambda_ys7p58($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C370@14467L43,369@14445L159:OrderScreen.kt#ucz02q');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1490074563, $changed, -1, 'client.fstech.hadaya.presentation.order.ComposableSingletons$OrderScreenKt.lambda$-1490074563.<anonymous> (OrderScreen.kt:369)');
      }
      var tmp = stringResource(get_back_to_home_btn(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = get_sp(18);
      var tmp_2 = Companion_getInstance_16().e7z_1;
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, tmp_2, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 1597440, 0, 262062);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderScreenKt() {
    ComposableSingletons$OrderScreenKt_instance = this;
    var tmp = this;
    tmp.y12y_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-2077253252, false, ComposableSingletons$OrderScreenKt$lambda$_2077253252$lambda_93ybam));
    var tmp_0 = this;
    tmp_0.z12y_1 = ComposableLambda$invoke$ref_8(composableLambdaInstance(-952082522, false, ComposableSingletons$OrderScreenKt$lambda$_952082522$lambda_y1snsa));
    var tmp_1 = this;
    tmp_1.a12z_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-695110508, false, ComposableSingletons$OrderScreenKt$lambda$_695110508$lambda_jsq94k));
    var tmp_2 = this;
    tmp_2.b12z_1 = ComposableLambda$invoke$ref_8(composableLambdaInstance(-1193515507, false, ComposableSingletons$OrderScreenKt$lambda$_1193515507$lambda_l8ku2a));
    var tmp_3 = this;
    tmp_3.c12z_1 = ComposableLambda$invoke$ref_8(composableLambdaInstance(1753318219, false, ComposableSingletons$OrderScreenKt$lambda$1753318219$lambda));
    var tmp_4 = this;
    tmp_4.d12z_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1490074563, false, ComposableSingletons$OrderScreenKt$lambda$_1490074563$lambda_ys7p58));
  }
  var ComposableSingletons$OrderScreenKt_instance;
  function ComposableSingletons$OrderScreenKt_getInstance() {
    if (ComposableSingletons$OrderScreenKt_instance == null)
      new ComposableSingletons$OrderScreenKt();
    return ComposableSingletons$OrderScreenKt_instance;
  }
  function OrderSuccessContent(orderId, language, onNavigateHome, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(609812195);
    sourceInformation($composer_0, 'C(OrderSuccessContent)P(2)331@13012L1608:OrderScreen.kt#ucz02q');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(orderId) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateHome) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(609812195, $dirty, -1, 'client.fstech.hadaya.presentation.order.OrderSuccessContent (OrderScreen.kt:330)');
      }
      var tmp = fillMaxSize(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
      var tmp0_modifier = padding_0(tmp, tmp$ret$0);
      var tmp1_horizontalAlignment = Companion_getInstance_11().x8t_1;
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = tmp0_modifier;
      var verticalArrangement = Arrangement_getInstance().udp_1;
      var horizontalAlignment = tmp1_horizontalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier = Companion_instance;
      if (!((0 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((0 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1846517843, 'C340@13366L11,336@13203L192,342@13404L41,344@13472L34,345@13542L10,343@13454L165,349@13646L66,348@13628L136,363@14217L41,364@14267L347:OrderScreen.kt#ucz02q');
      var tmp_1 = get_CheckCircle(Icons_getInstance().dxv_1);
      var tmp_2 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(100);
      Icon(tmp_1, null, size(tmp_2, tmp$ret$7), MaterialTheme_instance.unz($composer_5, 6).xnz_1, $composer_5, 432, 0);
      var tmp_3 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$8 = _Dp___init__impl__ms3zkb(24);
      Spacer(height(tmp_3, tmp$ret$8), $composer_5, 6);
      var tmp0_text = stringResource(get_success(string_instance), $composer_5, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).jof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp_4, null, tmp_5, null, tmp2_fontWeight, null, tmp_6, null, null, tmp_7, tmp_8, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131006);
      var tmp_9 = stringResource(get_your_order_has_been_placed_successfully(string_instance), $composer_5, 0);
      var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_13 = Companion_getInstance_15().d7v_1;
      var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_15 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_9, null, tmp_10, null, tmp_11, null, null, null, tmp_12, null, tmp_13, tmp_14, tmp_15, false, 0, 0, null, null, $composer_5, 0, 0, 261118);
      if (!(orderId == null)) {
        $composer_5.m30(1847073207);
        sourceInformation($composer_5, '353@13808L40,355@13883L70,358@14055L10,359@14117L11,354@13861L337');
        var tmp_16 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$9 = _Dp___init__impl__ms3zkb(8);
        Spacer(height(tmp_16, tmp$ret$9), $composer_5, 6);
        var tmp3_text = formatNumbers(stringResource_0(get_order_id_prefix_pattern(string_instance), [orderId.toString()], $composer_5, 0), language);
        var tmp4_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
        var tmp5_color = MaterialTheme_instance.unz($composer_5, 6).co0_1;
        var tmp6_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp_17 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_18 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_20 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp3_text, null, tmp5_color, null, tmp_17, null, tmp6_fontWeight, null, tmp_18, null, null, tmp_19, tmp_20, false, 0, 0, null, tmp4_style, $composer_5, 1572864, 0, 131002);
        $composer_5.n30();
      } else {
        $composer_5.m30(1847471061);
        $composer_5.n30();
      }
      var tmp_21 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$10 = _Dp___init__impl__ms3zkb(32);
      Spacer(height(tmp_21, tmp$ret$10), $composer_5, 6);
      var tmp_22 = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$11 = _Dp___init__impl__ms3zkb(56);
      var tmp_23 = height(tmp_22, tmp$ret$11);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$12 = _Dp___init__impl__ms3zkb(12);
      var tmp_24 = RoundedCornerShape(tmp$ret$12);
      Button(onNavigateHome, tmp_23, false, tmp_24, null, null, null, null, null, ComposableSingletons$OrderScreenKt_getInstance().d12z_1, $composer_5, 805306416 | 14 & $dirty >> 6, 500);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(OrderSuccessContent$lambda(orderId, language, onNavigateHome, $changed));
    }
  }
  function OrderReviewContent(state, onCommentChange, onConfirmOrder, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(439799899);
    sourceInformation($composer_0, 'C(OrderReviewContent)P(2)182@7432L5458,177@7272L5618:OrderScreen.kt#ucz02q');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onCommentChange) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onConfirmOrder) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(439799899, $dirty, -1, 'client.fstech.hadaya.presentation.order.OrderReviewContent (OrderScreen.kt:176)');
      }
      var tmp = fillMaxSize(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
      var tmp_0 = padding_0(tmp, tmp$ret$0);
      var tmp_1 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
      var tmp_2 = tmp_1.mdq(tmp$ret$1);
      sourceInformationMarkerStart($composer_0, 1740922509, 'CC(remember):OrderScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!((($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(state))) | ($dirty & 112) === 32) | ($dirty & 896) === 256);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp_3;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = OrderReviewContent$lambda(state, onCommentChange, onConfirmOrder);
        tmp0.j31(value);
        tmp_3 = value;
      } else {
        tmp_3 = it;
      }
      var tmp0_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      LazyColumn(tmp_0, null, null, false, tmp_2, null, null, false, null, tmp0_group, $composer_0, 24582, 494);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(OrderReviewContent$lambda_0(state, onCommentChange, onConfirmOrder, $changed));
    }
  }
  function InfoRow(label, value, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1343149476);
    sourceInformation($composer_0, 'C(InfoRow)380@14684L230:OrderScreen.kt#ucz02q');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(label) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(value) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1343149476, $dirty, -1, 'client.fstech.hadaya.presentation.order.InfoRow (OrderScreen.kt:379)');
      }
      var tmp = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(4);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = padding_2(tmp, VOID, tmp$ret$0);
      var horizontalArrangement = null;
      var verticalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((6 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 624821590, 'C381@14759L90,382@14858L50:OrderScreen.kt#ucz02q');
      var tmp0_text = label + ': ';
      var tmp1_fontWeight = Companion_getInstance_16().c7z_1;
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(100);
      var tmp2_modifier = width(tmp_1, tmp$ret$7);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, tmp2_modifier, tmp_2, null, tmp_3, null, tmp1_fontWeight, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_5, 1572912, 0, 262076);
      var tmp_7 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
      var tmp_8 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_12 = _TextOverflow___init__impl__obguoe(0);
      Text(value, tmp_7, tmp_8, null, tmp_9, null, null, null, tmp_10, null, null, tmp_11, tmp_12, false, 0, 0, null, null, $composer_5, 14 & $dirty >> 3, 0, 262140);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(InfoRow$lambda(label, value, $changed));
    }
  }
  function OrderItemRow(item, language, $composer, $changed, $default) {
    var language_0 = {_v: language};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1979323819);
    sourceInformation($composer_0, 'C(OrderItemRow)414@15782L40,415@15857L19,416@15883L1676,411@15660L1899:OrderScreen.kt#ucz02q');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(item) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(language_0._v) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        language_0._v = 'en';
      }
      if (isTraceInProgress()) {
        traceEventStart(-1979323819, $dirty, -1, 'client.fstech.hadaya.presentation.order.OrderItemRow (OrderScreen.kt:410)');
      }
      var tmp = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      var tmp_0 = RoundedCornerShape(tmp$ret$0);
      var tmp_1 = CardDefaults_instance;
      var tmp_2 = Companion_getInstance_14().m6b_1;
      var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = tmp_1.loh(tmp_2, tmp_3, tmp_4, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24582, 14);
      var tmp_6 = CardDefaults_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_7 = _Dp___init__impl__ms3zkb(2);
      var tmp_8 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_9 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_10 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_11 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_12 = tmp_6.pog(tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, _Dp___init__impl__ms3zkb(0.0), $composer_0, 1572870, 62);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-630283577, true, OrderItemRow$lambda(item, language_0), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_13;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref_6(dispatchReceiver);
        $composer_1.j31(value);
        tmp_13 = value;
      } else {
        tmp_13 = it;
      }
      var tmp$ret$2 = tmp_13;
      Card(tmp, tmp_0, tmp_5, tmp_12, null, tmp$ret$2, $composer_0, 196614, 16);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(OrderItemRow$lambda_0(item, language_0, $changed, $default));
    }
  }
  function PriceRow(label, value, color, language, $composer, $changed, $default) {
    var color_0 = {_v: new Color_0(color)};
    var language_0 = {_v: language};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(324712539);
    sourceInformation($composer_0, 'C(PriceRow)P(1,3,0:c#ui.graphics.Color)393@15056L524:OrderScreen.kt#ucz02q');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(label) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.p31(value) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.o31(_ULong___get_data__impl__fggpzb(_Color___get_value__impl__1pls5m(color_0._v.c6d_1))) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(language_0._v) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        color_0._v = new Color_0(Companion_getInstance_14().u6b_1);
      }
      if (!(($default & 8) === 0)) {
        language_0._v = 'en';
      }
      if (isTraceInProgress()) {
        traceEventStart(324712539, $dirty, -1, 'client.fstech.hadaya.presentation.order.PriceRow (OrderScreen.kt:392)');
      }
      var tmp = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(2);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = padding_2(tmp, VOID, tmp$ret$0);
      var horizontalArrangement = Arrangement_getInstance().wdp_1;
      var verticalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((4 & 1) === 0))
        modifier = Companion_instance;
      if (!((4 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((4 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 54 >> 3 | 112 & 54 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -231219495, 'C397@15244L10,397@15203L63,403@15516L10,398@15275L299:OrderScreen.kt#ucz02q');
      var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextOverflow___init__impl__obguoe(0);
      Text(label, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, MaterialTheme_instance.jog($composer_5, 6).pof_1, $composer_5, 14 & $dirty, 0, 131070);
      var tmp_6;
      if (value < 0) {
        $composer_5.m30(-561644733);
        sourceInformation($composer_5, '399@15316L44');
        var tmp0_group = stringResource_0(get_price_egp(string_instance), [-value], $composer_5, 0);
        $composer_5.n30();
        tmp_6 = tmp0_group;
      } else {
        $composer_5.m30(-561643088);
        sourceInformation($composer_5, '399@15366L89');
        var tmp1_group = stringResource_0(get_price_egp(string_instance), [value], $composer_5, 0);
        $composer_5.n30();
        tmp_6 = tmp1_group;
      }
      var tmp0_text = formatNumbers(tmp_6, language_0._v);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).pof_1;
      var tmp_7 = color_0._v;
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_11 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp_7.c6d_1, null, tmp_8, null, null, null, tmp_9, null, null, tmp_10, tmp_11, false, 0, 0, null, tmp1_style, $composer_5, 896 & $dirty, 0, 131066);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(PriceRow$lambda(label, value, color_0, language_0, $changed, $default));
    }
  }
  function OrderScreen$lambda($order) {
    return function () {
      return parametersOf([$order]);
    };
  }
  function OrderScreen$lambda_0($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function OrderScreen$slambda($viewModel, $order, resultContinuation) {
    this.m12z_1 = $viewModel;
    this.n12z_1 = $order;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OrderScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OrderScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.m12z_1.s10h().j10i(new SetOrder(this.n12z_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(OrderScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new OrderScreen$slambda(this.m12z_1, this.n12z_1, completion);
    i.o12z_1 = $this$LaunchedEffect;
    return i;
  };
  function OrderScreen$slambda_0($viewModel, $order, resultContinuation) {
    var i = new OrderScreen$slambda($viewModel, $order, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_17(function_0) {
    this.p12z_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_17).a1v = function (value, $completion) {
    return this.p12z_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_17).q3 = function () {
    return this.p12z_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_17).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_17).hashCode = function () {
    return hashCode(this.q3());
  };
  function OrderScreen$slambda$slambda($snackbarHostState, $onNavigateHome, resultContinuation) {
    this.y12z_1 = $snackbarHostState;
    this.z12z_1 = $onNavigateHome;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OrderScreen$slambda$slambda).c130 = function (effect, $completion) {
    var tmp = this.d130(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.c130((!(p1 == null) ? isInterface(p1, OrderSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OrderScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp0_subject = this.a130_1;
            if (tmp0_subject instanceof ShowError_4) {
              this.n9_1 = 1;
              suspendResult = this.a130_1.x12y_1.z10i(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (equals(tmp0_subject, NavigateToHome_instance_0)) {
                this.b130_1 = this.z12z_1();
                this.n9_1 = 3;
                continue $sm;
              } else {
                var tmp_0 = this;
                noWhenBranchMatchedException();
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.y12z_1.dqm(ARGUMENT, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.b130_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(OrderScreen$slambda$slambda).d130 = function (effect, completion) {
    var i = new OrderScreen$slambda$slambda(this.y12z_1, this.z12z_1, completion);
    i.a130_1 = effect;
    return i;
  };
  function OrderScreen$slambda$slambda_0($snackbarHostState, $onNavigateHome, resultContinuation) {
    var i = new OrderScreen$slambda$slambda($snackbarHostState, $onNavigateHome, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.c130(effect, $completion);
    }, 1);
  }
  function OrderScreen$slambda_1($viewModel, $snackbarHostState, $onNavigateHome, resultContinuation) {
    this.m130_1 = $viewModel;
    this.n130_1 = $snackbarHostState;
    this.o130_1 = $onNavigateHome;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OrderScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OrderScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.m130_1.s10h().t10h();
            var tmp_1 = OrderScreen$slambda$slambda_0(this.n130_1, this.o130_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_17(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(OrderScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new OrderScreen$slambda_1(this.m130_1, this.n130_1, this.o130_1, completion);
    i.p130_1 = $this$LaunchedEffect;
    return i;
  };
  function OrderScreen$slambda_2($viewModel, $snackbarHostState, $onNavigateHome, resultContinuation) {
    var i = new OrderScreen$slambda_1($viewModel, $snackbarHostState, $onNavigateHome, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function OrderScreen$lambda_1() {
    return Unit_instance;
  }
  function OrderScreen$lambda_2($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C93@3915L237:OrderScreen.kt#ucz02q');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1894781148, $changed, -1, 'client.fstech.hadaya.presentation.order.OrderScreen.<anonymous>.<anonymous>.<anonymous> (OrderScreen.kt:93)');
        }
        var tmp_0;
        if (OrderScreen$lambda_0($state$delegate).q12y_1) {
          $composer_0.m30(-181447447);
          sourceInformation($composer_0, '94@3980L45');
          var tmp0_group = stringResource(get_order_placed_title(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp0_group;
        } else {
          $composer_0.m30(-181445761);
          sourceInformation($composer_0, '94@4031L99');
          var tmp1_group = stringResource(get_review_order_title(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp1_group;
        }
        var tmp_1 = tmp_0;
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderScreen$lambda$lambda($onBack, $state$delegate) {
    return function () {
      if (!OrderScreen$lambda_0($state$delegate).p12y_1)
        $onBack();
      return Unit_instance;
    };
  }
  function OrderScreen$lambda_3($state$delegate, $onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C100@4248L39,100@4227L349:OrderScreen.kt#ucz02q');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1230788830, $changed, -1, 'client.fstech.hadaya.presentation.order.OrderScreen.<anonymous>.<anonymous>.<anonymous> (OrderScreen.kt:100)');
        }
        sourceInformationMarkerStart($composer_0, 1672060645, 'CC(remember):OrderScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.k31($state$delegate) | $composer_0.k31($onBack));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = OrderScreen$lambda$lambda($onBack, $state$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$OrderScreenKt_getInstance().y12y_1, $composer_0, 1572864, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderScreen$lambda_4($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new UpdateComment(it));
      return Unit_instance;
    };
  }
  function OrderScreen$lambda_5($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ConfirmOrder_instance);
      return Unit_instance;
    };
  }
  function OrderScreen$lambda_6() {
    return Unit_instance;
  }
  function OrderScreen$lambda$lambda_0($state$delegate) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C140@5819L1126:OrderScreen.kt#ucz02q');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(151809194, $changed, -1, 'client.fstech.hadaya.presentation.order.OrderScreen.<anonymous>.<anonymous>.<anonymous> (OrderScreen.kt:140)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
        var tmp0_modifier = padding_0(tmp_0, tmp$ret$0);
        var tmp1_horizontalAlignment = Companion_getInstance_11().x8t_1;
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = tmp0_modifier;
        var verticalArrangement = Arrangement_getInstance().udp_1;
        var horizontalAlignment = tmp1_horizontalAlignment;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((0 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -1960829856, 'C145@6076L27,146@6128L41,149@6364L10,147@6194L334,153@6553L40,156@6818L10,154@6618L305:OrderScreen.kt#ucz02q');
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_5, 0, 63);
        var tmp_6 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_6, tmp$ret$7), $composer_5, 6);
        var tmp0_text = OrderScreen$lambda_0($state$delegate).s12y_1 === 'en' ? 'Placing your order...' : '\u062C\u0627\u0631\u064A \u0625\u062A\u0645\u0627\u0645 \u0637\u0644\u0628\u0643...';
        var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
        var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp3_textAlign = Companion_getInstance_15().d7v_1;
        var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_11 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp_7, null, tmp_8, null, tmp2_fontWeight, null, tmp_9, null, tmp3_textAlign, tmp_10, tmp_11, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 129982);
        var tmp_12 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(8);
        Spacer(height(tmp_12, tmp$ret$8), $composer_5, 6);
        var tmp4_text = OrderScreen$lambda_0($state$delegate).s12y_1 === 'en' ? "Please wait and don't close the app." : '\u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631 \u0648\u0639\u062F\u0645 \u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u062A\u0637\u0628\u064A\u0642.';
        var tmp5_style = MaterialTheme_instance.jog($composer_5, 6).pof_1;
        var tmp6_textAlign = Companion_getInstance_15().d7v_1;
        var tmp_13 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_15 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_17 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp4_text, null, tmp_13, null, tmp_14, null, null, null, tmp_15, null, tmp6_textAlign, tmp_16, tmp_17, false, 0, 0, null, tmp5_style, $composer_5, 0, 0, 130046);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_18;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_18 = Unit_instance;
        }
        tmp = tmp_18;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderScreen$lambda_7($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C138@5758L11,138@5716L62,139@5797L1166,135@5542L1421:OrderScreen.kt#ucz02q');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1575359268, $changed, -1, 'client.fstech.hadaya.presentation.order.OrderScreen.<anonymous>.<anonymous> (OrderScreen.kt:135)');
        }
        var tmp_0 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        var tmp_1 = padding_0(tmp_0, tmp$ret$0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
        var tmp_2 = RoundedCornerShape(tmp$ret$1);
        var tmp_3 = CardDefaults_instance;
        var tmp_4 = MaterialTheme_instance.unz($composer_0, 6).mo0_1;
        var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_7 = tmp_3.loh(tmp_4, tmp_5, tmp_6, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 14);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(151809194, true, OrderScreen$lambda$lambda_0($state$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_8;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref_6(dispatchReceiver);
          $composer_1.j31(value);
          tmp_8 = value;
        } else {
          tmp_8 = it;
        }
        var tmp$ret$2 = tmp_8;
        Card(tmp_1, tmp_2, tmp_7, null, null, tmp$ret$2, $composer_0, 196614, 24);
        var tmp_9;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_9 = Unit_instance;
        }
        tmp = tmp_9;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderScreen$lambda_8($order, $onBack, $onNavigateHome, $$changed) {
    return function ($composer, $force) {
      OrderScreen($order, $onBack, $onNavigateHome, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function OrderSuccessContent$lambda($orderId, $language, $onNavigateHome, $$changed) {
    return function ($composer, $force) {
      OrderSuccessContent($orderId, $language, $onNavigateHome, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function OrderReviewContent$lambda$lambda$lambda($state) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C197@7949L1335:OrderScreen.kt#ucz02q');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1372530589, $changed, -1, 'client.fstech.hadaya.presentation.order.OrderReviewContent.<anonymous>.<anonymous>.<anonymous>.<anonymous> (OrderScreen.kt:197)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -2029138664, 'C201@8168L10,198@8014L198,203@8233L40,205@8335L46,204@8294L167,208@8482L204,213@8748L49,212@8707L165,217@8934L45,216@8893L159,221@9114L48,220@9073L193:OrderScreen.kt#ucz02q');
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = Companion_getInstance_16().e7z_1;
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text('Receiver Information', null, tmp_2, null, tmp_3, null, tmp_4, null, tmp_5, null, null, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_5, 6).mof_1, $composer_5, 1572870, 0, 131006);
        var tmp_8 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(8);
        Spacer(height(tmp_8, tmp$ret$7), $composer_5, 6);
        InfoRow(stringResource(get_receiver_name_label(string_instance), $composer_5, 0), $state.n12y_1.qzc_1, $composer_5, 0);
        InfoRow($state.s12y_1 === 'en' ? 'Governorate' : '\u0627\u0644\u0645\u062D\u0627\u0641\u0638\u0629', '', $composer_5, 48);
        InfoRow(stringResource(get_delivery_address_label(string_instance), $composer_5, 0), $state.n12y_1.rzc_1, $composer_5, 0);
        InfoRow(stringResource(get_phone_number_label(string_instance), $composer_5, 0), $state.n12y_1.tzc_1, $composer_5, 0);
        InfoRow(stringResource(get_payment_method_header(string_instance), $composer_5, 0), replace($state.n12y_1.zzc_1.z_1, '_', ' '), $composer_5, 0);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_9;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_9 = Unit_instance;
        }
        tmp = tmp_9;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderReviewContent$lambda$lambda($state) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C195@7889L11,195@7847L69,196@7931L1367,192@7700L1598:OrderScreen.kt#ucz02q');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(154618063, $changed, -1, 'client.fstech.hadaya.presentation.order.OrderReviewContent.<anonymous>.<anonymous>.<anonymous> (OrderScreen.kt:192)');
        }
        var tmp_0 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
        var tmp_1 = RoundedCornerShape(tmp$ret$0);
        var tmp_2 = CardDefaults_instance;
        var tmp_3 = MaterialTheme_instance.unz($composer_0, 6).oo0_1;
        var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_6 = tmp_2.loh(tmp_3, tmp_4, tmp_5, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 14);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1372530589, true, OrderReviewContent$lambda$lambda$lambda($state), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_7;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref_6(dispatchReceiver);
          $composer_1.j31(value);
          tmp_7 = value;
        } else {
          tmp_7 = it;
        }
        var tmp$ret$1 = tmp_7;
        Card(tmp_0, tmp_1, tmp_6, null, null, tmp$ret$1, $composer_0, 196614, 24);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderReviewContent$lambda$lambda_0($state, $onCommentChange) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C229@9337L294:OrderScreen.kt#ucz02q');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-519448722, $changed, -1, 'client.fstech.hadaya.presentation.order.OrderReviewContent.<anonymous>.<anonymous>.<anonymous> (OrderScreen.kt:229)');
        }
        var tmp0_value = $state.o12y_1;
        var tmp1_modifier = fillMaxWidth(Companion_instance);
        var tmp_0 = ComposableSingletons$OrderScreenKt_getInstance().a12z_1;
        OutlinedTextField(tmp0_value, $onCommentChange, tmp1_modifier, false, false, null, tmp_0, null, null, null, null, null, null, false, null, null, null, false, 0, 3, null, null, null, $composer_0, 1573248, 805306368, 0, 7864248);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderReviewContent$lambda$lambda_1(it) {
    return null;
  }
  function OrderReviewContent$lambda$lambda_2($key, $items) {
    return function (index) {
      return $key($items.l1(index));
    };
  }
  function OrderReviewContent$lambda$lambda_3($contentType, $items) {
    return function (index) {
      return $contentType($items.l1(index));
    };
  }
  function OrderReviewContent$lambda$lambda_4($items, $state) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp2 = $items.l1(it);
        var $changed_0 = 14 & $dirty;
        var $composer_1 = $composer_0;
        $composer_1.m30(-456822368);
        sourceInformation($composer_1, 'C*247@9934L34:OrderScreen.kt#ucz02q');
        OrderItemRow(tmp2, $state.s12y_1, $composer_1, 14 & $changed_0 >> 3, 0);
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderReviewContent$lambda$lambda_5($state) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C251@10007L19,252@10039L1758:OrderScreen.kt#ucz02q');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1867582292, $changed, -1, 'client.fstech.hadaya.presentation.order.OrderReviewContent.<anonymous>.<anonymous>.<anonymous> (OrderScreen.kt:251)');
        }
        var tmp_0 = _Dp___init__impl__ms3zkb(0.0);
        HorizontalDivider(null, tmp_0, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 7);
        var tmp_1 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = padding_2(tmp_1, VOID, tmp$ret$0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_2 = $composer_3.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 1962843316, 'C254@10164L41,253@10126L194,259@10375L46,258@10337L203,271@10898L40,272@10955L828:OrderScreen.kt#ucz02q');
        var tmp_3 = stringResource(get_order_subtotal(string_instance), $composer_5, 0);
        PriceRow(tmp_3, $state.n12y_1.vzc_1, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $state.s12y_1, $composer_5, 0, 4);
        var tmp_4 = stringResource(get_order_shipping_cost(string_instance), $composer_5, 0);
        PriceRow(tmp_4, $state.n12y_1.xzc_1, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $state.s12y_1, $composer_5, 0, 4);
        if ($state.n12y_1.wzc_1 > 0) {
          $composer_5.m30(1963258374);
          sourceInformation($composer_5, '265@10651L41,264@10609L254');
          PriceRow(stringResource(get_order_discount(string_instance), $composer_5, 0), -$state.n12y_1.wzc_1, Companion_getInstance_14().n6b_1, $state.s12y_1, $composer_5, 384, 0);
          $composer_5.n30();
        } else {
          $composer_5.m30(1963540908);
          $composer_5.n30();
        }
        var tmp_5 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(8);
        Spacer(height(tmp_5, tmp$ret$7), $composer_5, 6);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_1 = fillMaxWidth(Companion_instance);
        var horizontalArrangement = Arrangement_getInstance().wdp_1;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_6 = $composer_5;
        if (!((0 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_6, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_6 = $composer_8.g30();
        if (!isInterface(tmp_6, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 2022452533, 'C278@11223L44,277@11193L192,283@11436L60,288@11724L11,282@11406L359:OrderScreen.kt#ucz02q');
        var tmp0_text = stringResource(get_order_total_price(string_instance), $composer_10, 0);
        var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp2_fontSize = get_sp(20);
        var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_10 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp_7, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, null, $composer_10, 1597440, 0, 262062);
        var tmp3_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [$state.n12y_1.yzc_1], $composer_10, 0), $state.s12y_1);
        var tmp4_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp5_fontSize = get_sp(20);
        var tmp6_color = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_13 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp3_text, null, tmp6_color, null, tmp5_fontSize, null, tmp4_fontWeight, null, tmp_11, null, null, tmp_12, tmp_13, false, 0, 0, null, null, $composer_10, 1597440, 0, 262058);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_14;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_14 = Unit_instance;
        }
        tmp = tmp_14;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderReviewContent$lambda$lambda$lambda_0($state) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:OrderScreen.kt#ucz02q');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1474729990, $changed, -1, 'client.fstech.hadaya.presentation.order.OrderReviewContent.<anonymous>.<anonymous>.<anonymous>.<anonymous> (OrderScreen.kt:311)');
        }
        if ($state.p12y_1) {
          $composer_0.m30(-460593383);
          sourceInformation($composer_0, '312@12519L79');
          var tmp0_color = Companion_getInstance_14().m6b_1;
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp1_modifier = size(tmp_0, tmp$ret$0);
          var tmp_1 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_3 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp1_modifier, tmp0_color, tmp_1, tmp_2, tmp_3, _Dp___init__impl__ms3zkb(0.0), $composer_0, 54, 60);
          $composer_0.n30();
        } else {
          $composer_0.m30(-460486278);
          sourceInformation($composer_0, '315@12674L50,314@12644L198');
          var tmp_4 = stringResource(get_confirm_place_order_btn(string_instance), $composer_0, 0);
          var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_6 = get_sp(18);
          var tmp_7 = Companion_getInstance_16().e7z_1;
          var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_10 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_4, null, tmp_5, null, tmp_6, null, tmp_7, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, null, $composer_0, 1597440, 0, 262062);
          $composer_0.n30();
        }
        var tmp_11;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_11 = Unit_instance;
        }
        tmp = tmp_11;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderReviewContent$lambda$lambda_6($state, $onConfirmOrder) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C310@12453L421,305@12224L650:OrderScreen.kt#ucz02q');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1079251434, $changed, -1, 'client.fstech.hadaya.presentation.order.OrderReviewContent.<anonymous>.<anonymous>.<anonymous> (OrderScreen.kt:305)');
        }
        var tmp_0 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(56);
        var tmp0_modifier = height(tmp_0, tmp$ret$0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(12);
        var tmp1_shape = RoundedCornerShape(tmp$ret$1);
        var tmp2_enabled = !$state.p12y_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1474729990, true, OrderReviewContent$lambda$lambda$lambda_0($state), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_1.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp$ret$2 = tmp_1;
        Button($onConfirmOrder, tmp0_modifier, tmp2_enabled, tmp1_shape, null, null, null, null, null, tmp$ret$2, $composer_0, 805306416, 496);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderReviewContent$lambda($state, $onCommentChange, $onConfirmOrder) {
    return function ($this$LazyColumn) {
      $this$LazyColumn.ci9(VOID, VOID, ComposableSingletons$OrderScreenKt_getInstance().z12y_1);
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(154618063, true, OrderReviewContent$lambda$lambda($state))));
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(-519448722, true, OrderReviewContent$lambda$lambda_0($state, $onCommentChange))));
      $this$LazyColumn.ci9(VOID, VOID, ComposableSingletons$OrderScreenKt_getInstance().b12z_1);
      // Inline function 'androidx.compose.foundation.lazy.items' call
      var items = $state.n12y_1.uzc_1;
      var contentType = OrderReviewContent$lambda$lambda_1;
      var tmp = items.n1();
      var tmp_0;
      if (!(null == null)) {
        tmp_0 = OrderReviewContent$lambda$lambda_2(null, items);
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      var tmp_2 = OrderReviewContent$lambda$lambda_3(contentType, items);
      $this$LazyColumn.di9(tmp, tmp_1, tmp_2, ComposableLambda$invoke$ref_4(composableLambdaInstance(802480018, true, OrderReviewContent$lambda$lambda_4(items, $state))));
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(-1867582292, true, OrderReviewContent$lambda$lambda_5($state))));
      $this$LazyColumn.ci9(VOID, VOID, ComposableSingletons$OrderScreenKt_getInstance().c12z_1);
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(1079251434, true, OrderReviewContent$lambda$lambda_6($state, $onConfirmOrder))));
      return Unit_instance;
    };
  }
  function OrderReviewContent$lambda_0($state, $onCommentChange, $onConfirmOrder, $$changed) {
    return function ($composer, $force) {
      OrderReviewContent($state, $onCommentChange, $onConfirmOrder, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function InfoRow$lambda($label, $value, $$changed) {
    return function ($composer, $force) {
      InfoRow($label, $value, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function OrderItemRow$lambda($item, $language) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C417@15893L1660:OrderScreen.kt#ucz02q');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-630283577, $changed, -1, 'client.fstech.hadaya.presentation.order.OrderItemRow.<anonymous> (OrderScreen.kt:417)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var horizontalArrangement = null;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance;
        if (!((2 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((2 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 390 >> 3 | 112 & 390 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 1669965198, 'C424@16209L307,432@16529L40,433@16582L711,450@17328L131,449@17306L237:OrderScreen.kt#ucz02q');
        var tmp0_elvis_lhs = $item.syw_1;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = $item.qyw_1;
          tmp_2 = tmp1_safe_receiver == null ? null : firstOrNull(tmp1_safe_receiver);
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var imageUrl = tmp_2;
        var imageModel = !($item.xyw_1 == null) ? $item.xyw_1 : imageUrl;
        var tmp_3 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(60);
        var tmp_4 = size(tmp_3, tmp$ret$7);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(4);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = padding_0(tmp_4, tmp$ret$8);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_5 = $composer_8.g30();
        if (!isInterface(tmp_5, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, -165284078, 'C425@16278L224:OrderScreen.kt#ucz02q');
        HadayaImage(imageModel, null, fillMaxSize(Companion_instance), Companion_getInstance_13().r96_1, $composer_10, 3504, 0);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_6 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$15 = _Dp___init__impl__ms3zkb(12);
        Spacer(width(tmp_6, tmp$ret$15), $composer_5, 6);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_3 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_11 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_1 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_11, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_12 = $composer_11;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
        var localMap_1 = $composer_12.t31();
        var materialized_1 = materialize($composer_12, modifier_4);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_13 = $composer_12;
        var tmp_7 = $composer_13.g30();
        if (!isInterface(tmp_7, Applier)) {
          invalidApplier();
        }
        $composer_13.b31();
        if ($composer_13.h30()) {
          $composer_13.c31(tmp0_1);
        } else {
          $composer_13.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_14 = $composer_13;
        var $composer_15 = $composer_14;
        sourceInformationMarkerStart($composer_15, 486534914, 'C437@16849L105,442@16997L151,445@17172L10,441@16971L239,447@17227L52:OrderScreen.kt#ucz02q');
        var tmp_8;
        if ($language._v === 'en') {
          var tmp0_elvis_lhs_0 = $item.hyw_1;
          tmp_8 = tmp0_elvis_lhs_0 == null ? $item.iyw_1 : tmp0_elvis_lhs_0;
        } else {
          var tmp1_elvis_lhs = $item.iyw_1;
          tmp_8 = tmp1_elvis_lhs == null ? $item.hyw_1 : tmp1_elvis_lhs;
        }
        var tmp2_elvis_lhs = tmp_8;
        var tmp_9;
        if (tmp2_elvis_lhs == null) {
          $composer_15.m30(-1646868829);
          sourceInformation($composer_15, '436@16798L34');
          var tmp0_group = stringResource(get_product(string_instance), $composer_15, 0);
          $composer_15.n30();
          tmp_9 = tmp0_group;
        } else {
          $composer_15.m30(-1646872797);
          $composer_15.n30();
          tmp_9 = tmp2_elvis_lhs;
        }
        var name = tmp_9;
        var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = Companion_getInstance_16().e7z_1;
        var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_15 = _TextOverflow___init__impl__obguoe(0);
        Text(name, null, tmp_10, null, tmp_11, null, tmp_12, null, tmp_13, null, null, tmp_14, tmp_15, false, 0, 0, null, null, $composer_15, 1572864, 0, 262078);
        var tmp_16 = stringResource_0(get_order_quantity_pattern(string_instance), [format($item.ryw_1, $language._v)], $composer_15, 0);
        var tmp_17 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_18 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_21 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_16, null, tmp_17, null, tmp_18, null, null, null, tmp_19, null, null, tmp_20, tmp_21, false, 0, 0, null, MaterialTheme_instance.jog($composer_15, 6).qof_1, $composer_15, 0, 0, 131070);
        var tmp_22 = $language._v;
        ItemOptionsDisplay($item, tmp_22, null, false, false, $composer_15, 0, 28);
        sourceInformationMarkerEnd($composer_15);
        $composer_13.e31();
        var tmp_23 = get_price_egp(string_instance);
        var tmp2_elvis_lhs_0 = $item.lyw_1;
        var tmp_24 = formatNumbers(stringResource_0(tmp_23, [(tmp2_elvis_lhs_0 == null ? 0.0 : tmp2_elvis_lhs_0) * $item.ryw_1], $composer_5, 0), $language._v);
        var tmp_25 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_26 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_27 = Companion_getInstance_16().e7z_1;
        var tmp_28 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_29 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_30 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_24, null, tmp_25, null, tmp_26, null, tmp_27, null, tmp_28, null, null, tmp_29, tmp_30, false, 0, 0, null, null, $composer_5, 1572864, 0, 262078);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_31;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_31 = Unit_instance;
        }
        tmp = tmp_31;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderItemRow$lambda_0($item, $language, $$changed, $$default) {
    return function ($composer, $force) {
      OrderItemRow($item, $language._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function PriceRow$lambda($label, $value, $color, $language, $$changed, $$default) {
    return function ($composer, $force) {
      PriceRow($label, $value, $color._v.c6d_1, $language._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_order_OrderViewModel$stable;
  function OrderViewModel$handleIntent$lambda($intent, this$0) {
    return function ($this$updateState) {
      var tmp1_order = $intent.v12y_1;
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = $this$updateState.o12y_1;
      if (charSequenceLength(this_0) === 0) {
        var tmp0_elvis_lhs = this$0.u130_1.e8s('user_comment');
        tmp = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      } else {
        tmp = $this$updateState.o12y_1;
      }
      var tmp2_userComment = tmp;
      return $this$updateState.u12y(tmp1_order, tmp2_userComment, false, false);
    };
  }
  function OrderViewModel$handleIntent$lambda_0($intent) {
    return function ($this$updateState) {
      return $this$updateState.u12y(VOID, $intent.w12y_1);
    };
  }
  function OrderViewModel$handleIntent$lambda_1($this$updateState) {
    return $this$updateState.u12y(VOID, VOID, true);
  }
  function OrderViewModel$handleIntent$lambda_2($placedOrder) {
    return function ($this$updateState) {
      return $this$updateState.u12y(VOID, VOID, false, true, $placedOrder.lzc_1);
    };
  }
  function OrderViewModel$handleIntent$lambda_3($this$updateState) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = $this$updateState.n12y_1.uzc_1.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp = sum;
      var tmp0_elvis_lhs = element.myw_1;
      var discountPrice = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
      var tmp_0;
      if (discountPrice > 0.0) {
        var tmp1_elvis_lhs = element.lyw_1;
        tmp_0 = ((tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs) - discountPrice) * element.ryw_1;
      } else {
        tmp_0 = 0.0;
      }
      sum = tmp + tmp_0;
    }
    var productDiscount = sum;
    var tmp0_$this = $this$updateState.n12y_1;
    var tmp1_totalPrice = $this$updateState.n12y_1.vzc_1 - productDiscount + $this$updateState.n12y_1.xzc_1;
    var updatedOrder = tmp0_$this.jzd(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, productDiscount, VOID, tmp1_totalPrice, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null);
    return $this$updateState.u12y(updatedOrder, VOID, false);
  }
  function OrderViewModel$handleIntent$lambda_4($this$updateState) {
    return $this$updateState.u12y(VOID, VOID, false);
  }
  function $handleIntentCOROUTINE$_10(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i131_1 = _this__u8e3s4;
    this.j131_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_10).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 14;
            var tmp0_subject = this.j131_1;
            if (tmp0_subject instanceof SetOrder) {
              this.i131_1.x10k(OrderViewModel$handleIntent$lambda(this.j131_1, this.i131_1));
              this.n9_1 = 13;
              continue $sm;
            } else {
              if (tmp0_subject instanceof UpdateComment) {
                this.i131_1.x10k(OrderViewModel$handleIntent$lambda_0(this.j131_1));
                this.i131_1.u130_1.d8s('user_comment', this.j131_1.w12y_1);
                this.n9_1 = 13;
                continue $sm;
              } else {
                if (equals(tmp0_subject, ConfirmOrder_instance)) {
                  if (this.i131_1.s10h().ajg().u1().p12y_1)
                    return Unit_instance;
                  if (!this.i131_1.z130_1.ynu()) {
                    this.n9_1 = 12;
                    suspendResult = this.i131_1.d10l(new ShowError_4(new ResourceString(get_network_error(string_instance), [])), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.n9_1 = 1;
                    continue $sm;
                  }
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            this.n131_1 = this.i131_1.x130_1.ynu();
            if (this.n131_1 == null) {
              this.n9_1 = 11;
              suspendResult = this.i131_1.d10l(new ShowError_4(new ResourceString(get_user_not_logged_in(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            this.i131_1.x10k(OrderViewModel$handleIntent$lambda_1);
            this.o9_1 = 7;
            var orderToPlace = this.i131_1.s10h().ajg().u1().n12y_1.jzd(VOID, this.n131_1.uym_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.i131_1.s10h().ajg().u1().o12y_1, VOID, VOID, VOID, VOID, VOID, getPlatform().m());
            this.n9_1 = 3;
            suspendResult = this.i131_1.v130_1.l105(orderToPlace, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.k131_1 = suspendResult;
            var this_0 = this.i131_1;
            this.o9_1 = 5;
            this.m131_1 = Companion_instance_0;
            this.n9_1 = 4;
            suspendResult = this_0.w130_1.r2b(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var tmp_0 = this;
            this.m131_1;
            tmp_0.l131_1 = _Result___init__impl__xyqfz8(Unit_instance);
            this.o9_1 = 7;
            this.n9_1 = 6;
            continue $sm;
          case 5:
            this.o9_1 = 7;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var e = this.q9_1;
              var tmp_2 = this;
              tmp_2.l131_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.n9_1 = 6;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 6:
            this.o9_1 = 7;
            this.i131_1.x10k(OrderViewModel$handleIntent$lambda_2(this.k131_1));
            this.o9_1 = 14;
            this.n9_1 = 10;
            continue $sm;
          case 7:
            this.o9_1 = 14;
            var tmp_3 = this.q9_1;
            if (tmp_3 instanceof CouponAlreadyUsedException) {
              var _unused_var__etf5q3 = this.q9_1;
              this.i131_1.x10k(OrderViewModel$handleIntent$lambda_3);
              this.n9_1 = 8;
              suspendResult = this.i131_1.d10l(new ShowError_4(new ResourceString(get_coupon_already_used_error(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_4 = this.q9_1;
              if (tmp_4 instanceof Exception) {
                var e_0 = this.q9_1;
                this.i131_1.x10k(OrderViewModel$handleIntent$lambda_4);
                this.n9_1 = 9;
                var tmp1_elvis_lhs = e_0.message;
                suspendResult = this.i131_1.d10l(new ShowError_4(new DynamicString(tmp1_elvis_lhs == null ? 'Failed to place order' : tmp1_elvis_lhs)), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                throw this.q9_1;
              }
            }

          case 8:
            this.n9_1 = 10;
            continue $sm;
          case 9:
            this.n9_1 = 10;
            continue $sm;
          case 10:
            this.o9_1 = 14;
            this.n9_1 = 13;
            continue $sm;
          case 11:
            return Unit_instance;
          case 12:
            return Unit_instance;
          case 13:
            return Unit_instance;
          case 14:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 14) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  function OrderViewModel(initialOrder, savedStateHandle, placeOrderUseCase, clearCartUseCase, getCurrentUserValueUseCase, getLanguageUseCase, isConnectedUseCase) {
    var tmp1_language = getLanguageUseCase.ynu();
    var tmp0_elvis_lhs = savedStateHandle.e8s('user_comment');
    var tmp2_userComment = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    BaseMviViewModel.call(this, new OrderState(initialOrder, tmp2_userComment, VOID, VOID, VOID, tmp1_language));
    this.u130_1 = savedStateHandle;
    this.v130_1 = placeOrderUseCase;
    this.w130_1 = clearCartUseCase;
    this.x130_1 = getCurrentUserValueUseCase;
    this.y130_1 = getLanguageUseCase;
    this.z130_1 = isConnectedUseCase;
  }
  protoOf(OrderViewModel).o131 = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_10(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderViewModel).f10l = function (intent, $completion) {
    return this.o131(isInterface(intent, OrderIntent) ? intent : THROW_CCE(), $completion);
  };
  var client_fstech_hadaya_presentation_order_details_OrderDetailsState$stable;
  var client_fstech_hadaya_presentation_order_details_OrderDetailsIntent_ReAddToCart$stable;
  var client_fstech_hadaya_presentation_order_details_OrderDetailsIntent_RequestReturn$stable;
  var client_fstech_hadaya_presentation_order_details_OrderDetailsIntent_ToggleFavorite$stable;
  var client_fstech_hadaya_presentation_order_details_OrderDetailsIntent_ToggleStockReminder$stable;
  var client_fstech_hadaya_presentation_order_details_OrderDetailsSideEffect_ShowMessage$stable;
  var client_fstech_hadaya_presentation_order_details_OrderDetailsSideEffect_ShowStockDialog$stable;
  var client_fstech_hadaya_presentation_order_details_OrderDetailsSideEffect_NavigateBack$stable;
  function OrderDetailsState(order, isLoading, language, reAddingItems) {
    isLoading = isLoading === VOID ? false : isLoading;
    language = language === VOID ? 'en' : language;
    reAddingItems = reAddingItems === VOID ? emptySet() : reAddingItems;
    this.p131_1 = order;
    this.q131_1 = isLoading;
    this.r131_1 = language;
    this.s131_1 = reAddingItems;
  }
  protoOf(OrderDetailsState).t131 = function (order, isLoading, language, reAddingItems) {
    return new OrderDetailsState(order, isLoading, language, reAddingItems);
  };
  protoOf(OrderDetailsState).u131 = function (order, isLoading, language, reAddingItems, $super) {
    order = order === VOID ? this.p131_1 : order;
    isLoading = isLoading === VOID ? this.q131_1 : isLoading;
    language = language === VOID ? this.r131_1 : language;
    reAddingItems = reAddingItems === VOID ? this.s131_1 : reAddingItems;
    return $super === VOID ? this.t131(order, isLoading, language, reAddingItems) : $super.t131.call(this, order, isLoading, language, reAddingItems);
  };
  protoOf(OrderDetailsState).toString = function () {
    return 'OrderDetailsState(order=' + this.p131_1.toString() + ', isLoading=' + this.q131_1 + ', language=' + this.r131_1 + ', reAddingItems=' + toString(this.s131_1) + ')';
  };
  protoOf(OrderDetailsState).hashCode = function () {
    var result = this.p131_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.q131_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r131_1) | 0;
    result = imul(result, 31) + hashCode(this.s131_1) | 0;
    return result;
  };
  protoOf(OrderDetailsState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrderDetailsState))
      return false;
    if (!this.p131_1.equals(other.p131_1))
      return false;
    if (!(this.q131_1 === other.q131_1))
      return false;
    if (!(this.r131_1 === other.r131_1))
      return false;
    if (!equals(this.s131_1, other.s131_1))
      return false;
    return true;
  };
  function ReAddToCart(item) {
    this.v131_1 = item;
  }
  protoOf(ReAddToCart).toString = function () {
    return 'ReAddToCart(item=' + this.v131_1.toString() + ')';
  };
  protoOf(ReAddToCart).hashCode = function () {
    return this.v131_1.hashCode();
  };
  protoOf(ReAddToCart).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReAddToCart))
      return false;
    if (!this.v131_1.equals(other.v131_1))
      return false;
    return true;
  };
  function RequestReturn(reason) {
    this.w131_1 = reason;
  }
  protoOf(RequestReturn).toString = function () {
    return 'RequestReturn(reason=' + this.w131_1 + ')';
  };
  protoOf(RequestReturn).hashCode = function () {
    return getStringHashCode(this.w131_1);
  };
  protoOf(RequestReturn).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestReturn))
      return false;
    if (!(this.w131_1 === other.w131_1))
      return false;
    return true;
  };
  function ToggleFavorite_0(productId) {
    this.x131_1 = productId;
  }
  protoOf(ToggleFavorite_0).toString = function () {
    return 'ToggleFavorite(productId=' + this.x131_1.toString() + ')';
  };
  protoOf(ToggleFavorite_0).hashCode = function () {
    return this.x131_1.hashCode();
  };
  protoOf(ToggleFavorite_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ToggleFavorite_0))
      return false;
    if (!equalsLong(this.x131_1, other.x131_1))
      return false;
    return true;
  };
  function ToggleStockReminder(productId) {
    this.y131_1 = productId;
  }
  protoOf(ToggleStockReminder).toString = function () {
    return 'ToggleStockReminder(productId=' + this.y131_1.toString() + ')';
  };
  protoOf(ToggleStockReminder).hashCode = function () {
    return this.y131_1.hashCode();
  };
  protoOf(ToggleStockReminder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ToggleStockReminder))
      return false;
    if (!equalsLong(this.y131_1, other.y131_1))
      return false;
    return true;
  };
  function OrderDetailsIntent() {
  }
  function ShowMessage_2(message) {
    this.z131_1 = message;
  }
  protoOf(ShowMessage_2).toString = function () {
    return 'ShowMessage(message=' + this.z131_1 + ')';
  };
  protoOf(ShowMessage_2).hashCode = function () {
    return getStringHashCode(this.z131_1);
  };
  protoOf(ShowMessage_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowMessage_2))
      return false;
    if (!(this.z131_1 === other.z131_1))
      return false;
    return true;
  };
  function ShowStockDialog(productId, productName) {
    this.a132_1 = productId;
    this.b132_1 = productName;
  }
  protoOf(ShowStockDialog).toString = function () {
    return 'ShowStockDialog(productId=' + this.a132_1.toString() + ', productName=' + this.b132_1 + ')';
  };
  protoOf(ShowStockDialog).hashCode = function () {
    var result = this.a132_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.b132_1) | 0;
    return result;
  };
  protoOf(ShowStockDialog).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowStockDialog))
      return false;
    if (!equalsLong(this.a132_1, other.a132_1))
      return false;
    if (!(this.b132_1 === other.b132_1))
      return false;
    return true;
  };
  function NavigateBack_1() {
  }
  protoOf(NavigateBack_1).toString = function () {
    return 'NavigateBack';
  };
  protoOf(NavigateBack_1).hashCode = function () {
    return -867881119;
  };
  protoOf(NavigateBack_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateBack_1))
      return false;
    return true;
  };
  var NavigateBack_instance_1;
  function NavigateBack_getInstance_1() {
    return NavigateBack_instance_1;
  }
  function OrderDetailsSideEffect() {
  }
  function OrderDetailsScreen(order, onBack, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1101955469);
    sourceInformation($composer_0, 'C(OrderDetailsScreen)P(1)79@3663L23,79@3649L37,80@3730L16,81@3775L32,83@3854L25,83@3837L42,84@3921L22,84@3904L39,85@3971L54,87@4057L429,87@4031L455,99@4492L13927:OrderDetailsScreen.kt#endgyt');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(order) : $composer_0.q31(order)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1101955469, $dirty, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen (OrderDetailsScreen.kt:78)');
      }
      sourceInformationMarkerStart($composer_0, 1877720458, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(order));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = OrderDetailsScreen$lambda(order);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = tmp0_group;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((31 & 1) === 0))
        qualifier = null;
      if (!((31 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp_0;
      }
      if (!((31 & 4) === 0))
        key = null;
      if (!((31 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((31 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((31 & 32) === 0))
        parameters = null;
      var tmp0_0 = resolveViewModel(getKClass(OrderDetailsViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0_0;
      var tmp_1 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_1, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, 1877724051, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_0.i31();
      var tmp_2;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = new SnackbarHostState();
        this_0.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp1_group;
      sourceInformationMarkerStart($composer_0, 1877726572, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_1 = this_1.i31();
      var tmp_3;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = OrderDetailsScreen$lambda_3;
        this_1.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp2_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      var showReturnDialog$delegate = rememberSaveable_0([], tmp2_group, $composer_0, 48);
      sourceInformationMarkerStart($composer_0, 1877728713, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_2 = this_2.i31();
      var tmp_4;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var value_2 = OrderDetailsScreen$lambda_6;
        this_2.j31(value_2);
        tmp_4 = value_2;
      } else {
        tmp_4 = it_2;
      }
      var tmp3_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      var returnReason$delegate = rememberSaveable_0([], tmp3_group, $composer_0, 48);
      sourceInformationMarkerStart($composer_0, 1877730345, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_3 = this_3.i31();
      var tmp_5;
      if (false || it_3 === Companion_getInstance().f30_1) {
        var value_3 = mutableStateOf(null);
        this_3.j31(value_3);
        tmp_5 = value_3;
      } else {
        tmp_5 = it_3;
      }
      var tmp4_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      var stockDialogData$delegate = tmp4_group;
      sourceInformationMarkerStart($composer_0, 1877733472, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.q31(viewModel) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_4 = tmp0_1.i31();
      var tmp_6;
      if (invalid_0 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = OrderDetailsScreen$slambda_0(viewModel, snackbarHostState, onBack, stockDialogData$delegate, null);
        tmp0_1.j31(value_4);
        tmp_6 = value_4;
      } else {
        tmp_6 = it_4;
      }
      var tmp5_group = tmp_6;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp5_group, $composer_0, 0);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = fillMaxSize(Companion_instance);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_2 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_3 = $composer_2;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_0);
      var tmp0_2 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_7 = $composer_4.g30();
      if (!isInterface(tmp_7, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_2);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_5 = $composer_4;
      var $composer_6 = $composer_5;
      sourceInformationMarkerStart($composer_6, 1898164550, 'C100@4541L10268,389@18285L128:OrderDetailsScreen.kt#endgyt');
      var tmp_8 = BoxScopeInstance_instance.udr(fillMaxSize(Companion_instance), Companion_getInstance_11().l8t_1);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$32 = _Dp___init__impl__ms3zkb(1000);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = widthIn(tmp_8, VOID, tmp$ret$32);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_7 = $composer_6;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_7, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_8 = $composer_7;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
      var localMap_0 = $composer_8.t31();
      var materialized_0 = materialize($composer_8, modifier_2);
      var tmp0_3 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_9 = $composer_8;
      var tmp_9 = $composer_9.g30();
      if (!isInterface(tmp_9, Applier)) {
        invalidApplier();
      }
      $composer_9.b31();
      if ($composer_9.h30()) {
        $composer_9.c31(tmp0_3);
      } else {
        $composer_9.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_10 = $composer_9;
      var $composer_11 = $composer_10;
      sourceInformationMarkerStart($composer_11, 1231922756, 'C103@4773L294,101@4647L491,123@5498L9301,114@5152L9647:OrderDetailsScreen.kt#endgyt');
      var tmp_10 = ComposableSingletons$OrderDetailsScreenKt_getInstance().c132_1;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-737162051, true, OrderDetailsScreen$lambda_9(onBack), $composer_11, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_12 = $composer_11;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_12.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_5 = $composer_12.i31();
      var tmp_11;
      if (invalid_1 || it_5 === Companion_getInstance().f30_1) {
        var value_5 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_12.j31(value_5);
        tmp_11 = value_5;
      } else {
        tmp_11 = it_5;
      }
      var tmp_12 = tmp_11;
      var tmp_13 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_14 = WindowInsets(0, 0, 0, 0);
      TopAppBar(tmp_10, null, tmp_12, null, tmp_13, tmp_14, null, null, $composer_11, 390, 218);
      var tmp_15 = fillMaxSize(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp0_start = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp1_end = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp2_top = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp3_bottom = _Dp___init__impl__ms3zkb(100);
      var tmp_16 = PaddingValues(tmp0_start, tmp2_top, tmp1_end, tmp3_bottom);
      var tmp_17 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$50 = _Dp___init__impl__ms3zkb(16);
      var tmp_18 = tmp_17.mdq(tmp$ret$50);
      sourceInformationMarkerStart($composer_11, -652970836, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = !!(!!($composer_11.k31(state$delegate) | $composer_11.q31(viewModel)) | $composer_11.k31(showReturnDialog$delegate));
      // Inline function 'kotlin.let' call
      var it_6 = $composer_11.i31();
      var tmp_19;
      if (invalid_2 || it_6 === Companion_getInstance().f30_1) {
        var value_6 = OrderDetailsScreen$lambda_10(state$delegate, viewModel, showReturnDialog$delegate);
        $composer_11.j31(value_6);
        tmp_19 = value_6;
      } else {
        tmp_19 = it_6;
      }
      var tmp0_group_0 = tmp_19;
      sourceInformationMarkerEnd($composer_11);
      LazyColumn(tmp_15, null, tmp_16, false, tmp_18, null, null, false, null, tmp0_group_0, $composer_11, 24582, 490);
      sourceInformationMarkerEnd($composer_11);
      $composer_9.e31();
      if (OrderDetailsScreen$lambda_1(showReturnDialog$delegate)) {
        $composer_6.m30(1908000229);
        sourceInformation($composer_6, '309@14903L28,320@15467L690,337@16191L178,311@15045L388,308@14855L1528');
        sourceInformationMarkerStart($composer_6, -1462471799, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = $composer_6.k31(showReturnDialog$delegate);
        // Inline function 'kotlin.let' call
        var it_7 = $composer_6.i31();
        var tmp_20;
        if (invalid_3 || it_7 === Companion_getInstance().f30_1) {
          var value_7 = OrderDetailsScreen$lambda_11(showReturnDialog$delegate);
          $composer_6.j31(value_7);
          tmp_20 = value_7;
        } else {
          tmp_20 = it_7;
        }
        var tmp0_group_1 = tmp_20;
        sourceInformationMarkerEnd($composer_6);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-561150918, true, OrderDetailsScreen$lambda_12(returnReason$delegate, viewModel, showReturnDialog$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_13 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = $composer_13.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_8 = $composer_13.i31();
        var tmp_21;
        if (invalid_4 || it_8 === Companion_getInstance().f30_1) {
          var value_8 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_13.j31(value_8);
          tmp_21 = value_8;
        } else {
          tmp_21 = it_8;
        }
        var tmp_22 = tmp_21;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(2008974140, true, OrderDetailsScreen$lambda_13(showReturnDialog$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_14 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = $composer_14.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_9 = $composer_14.i31();
        var tmp_23;
        if (invalid_5 || it_9 === Companion_getInstance().f30_1) {
          var value_9 = ComposableLambda$invoke$ref(dispatchReceiver_1);
          $composer_14.j31(value_9);
          tmp_23 = value_9;
        } else {
          tmp_23 = it_9;
        }
        var tmp_24 = tmp_23;
        var tmp_25 = ComposableSingletons$OrderDetailsScreenKt_getInstance().j132_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_2 = rememberComposableLambda(1569194431, true, OrderDetailsScreen$lambda_14(returnReason$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_15 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_6 = $composer_15.k31(dispatchReceiver_2);
        // Inline function 'kotlin.let' call
        var it_10 = $composer_15.i31();
        var tmp_26;
        if (invalid_6 || it_10 === Companion_getInstance().f30_1) {
          var value_10 = ComposableLambda$invoke$ref(dispatchReceiver_2);
          $composer_15.j31(value_10);
          tmp_26 = value_10;
        } else {
          tmp_26 = it_10;
        }
        var tmp_27 = tmp_26;
        var tmp_28 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_29 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_30 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_31 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_32 = _Dp___init__impl__ms3zkb(0.0);
        AlertDialog(tmp0_group_1, tmp_22, null, tmp_24, null, tmp_25, tmp_27, null, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, null, $composer_6, 1772592, 0, 16276);
        $composer_6.n30();
      } else {
        $composer_6.m30(1909491701);
        $composer_6.n30();
      }
      var tmp0_safe_receiver = OrderDetailsScreen$lambda_7(stockDialogData$delegate);
      if (tmp0_safe_receiver == null) {
        $composer_6.m30(1909567681);
        $composer_6.n30();
      } else {
        $composer_6.m30(1909567682);
        sourceInformation($composer_6, '*347@16514L26,357@17126L647,372@17807L176,348@16566L71,349@16662L430,346@16466L1531');
        // Inline function 'kotlin.let' call
        var productId = tmp0_safe_receiver.zh();
        var productName = tmp0_safe_receiver.ai();
        sourceInformationMarkerStart($composer_6, 1465720860, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_11 = $composer_6.i31();
        var tmp_33;
        if (false || it_11 === Companion_getInstance().f30_1) {
          var value_11 = OrderDetailsScreen$lambda_15(stockDialogData$delegate);
          $composer_6.j31(value_11);
          tmp_33 = value_11;
        } else {
          tmp_33 = it_11;
        }
        var tmp0_group_2 = tmp_33;
        sourceInformationMarkerEnd($composer_6);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_3 = rememberComposableLambda(707757050, true, OrderDetailsScreen$lambda_16(viewModel, productId, stockDialogData$delegate, state$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_16 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_7 = $composer_16.k31(dispatchReceiver_3);
        // Inline function 'kotlin.let' call
        var it_12 = $composer_16.i31();
        var tmp_34;
        if (invalid_7 || it_12 === Companion_getInstance().f30_1) {
          var value_12 = ComposableLambda$invoke$ref(dispatchReceiver_3);
          $composer_16.j31(value_12);
          tmp_34 = value_12;
        } else {
          tmp_34 = it_12;
        }
        var tmp_35 = tmp_34;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_4 = rememberComposableLambda(-2051813576, true, OrderDetailsScreen$lambda_17(stockDialogData$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_17 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_8 = $composer_17.k31(dispatchReceiver_4);
        // Inline function 'kotlin.let' call
        var it_13 = $composer_17.i31();
        var tmp_36;
        if (invalid_8 || it_13 === Companion_getInstance().f30_1) {
          var value_13 = ComposableLambda$invoke$ref(dispatchReceiver_4);
          $composer_17.j31(value_13);
          tmp_36 = value_13;
        } else {
          tmp_36 = it_13;
        }
        var tmp_37 = tmp_36;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_5 = rememberComposableLambda(-516416906, true, OrderDetailsScreen$lambda_18(state$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_18 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_9 = $composer_18.k31(dispatchReceiver_5);
        // Inline function 'kotlin.let' call
        var it_14 = $composer_18.i31();
        var tmp_38;
        if (invalid_9 || it_14 === Companion_getInstance().f30_1) {
          var value_14 = ComposableLambda$invoke$ref(dispatchReceiver_5);
          $composer_18.j31(value_14);
          tmp_38 = value_14;
        } else {
          tmp_38 = it_14;
        }
        var tmp_39 = tmp_38;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_6 = rememberComposableLambda(-1896202219, true, OrderDetailsScreen$lambda_19(productName, state$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_19 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_10 = $composer_19.k31(dispatchReceiver_6);
        // Inline function 'kotlin.let' call
        var it_15 = $composer_19.i31();
        var tmp_40;
        if (invalid_10 || it_15 === Companion_getInstance().f30_1) {
          var value_15 = ComposableLambda$invoke$ref(dispatchReceiver_6);
          $composer_19.j31(value_15);
          tmp_40 = value_15;
        } else {
          tmp_40 = it_15;
        }
        var tmp_41 = tmp_40;
        var tmp_42 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_43 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_44 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_45 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_46 = _Dp___init__impl__ms3zkb(0.0);
        AlertDialog(tmp0_group_2, tmp_35, null, tmp_37, null, tmp_39, tmp_41, null, tmp_42, tmp_43, tmp_44, tmp_45, tmp_46, null, $composer_6, 1772598, 0, 16276);
        $composer_6.n30();
      }
      if (OrderDetailsScreen$lambda_0(state$delegate).q131_1) {
        $composer_6.m30(1911130888);
        sourceInformation($composer_6, '381@18052L213');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = background(fillMaxSize(Companion_instance), Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.3));
        var contentAlignment_0 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_0 = false;
        var $composer_20 = $composer_6;
        if (!((4 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_21 = $composer_20;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_21, 0).hashCode();
        var localMap_1 = $composer_21.t31();
        var materialized_1 = materialize($composer_21, modifier_4);
        var tmp0_4 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_22 = $composer_21;
        var tmp_47 = $composer_22.g30();
        if (!isInterface(tmp_47, Applier)) {
          invalidApplier();
        }
        $composer_22.b31();
        if ($composer_22.h30()) {
          $composer_22.c31(tmp0_4);
        } else {
          $composer_22.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_22);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_23 = $composer_22;
        var $composer_24 = $composer_23;
        sourceInformationMarkerStart($composer_24, 1732611731, 'C385@18224L27:OrderDetailsScreen.kt#endgyt');
        var tmp_48 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_49 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_50 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_51 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_48, tmp_49, tmp_50, tmp_51, _Dp___init__impl__ms3zkb(0.0), $composer_24, 0, 63);
        sourceInformationMarkerEnd($composer_24);
        $composer_22.e31();
        $composer_6.n30();
      } else {
        $composer_6.m30(1911358645);
        $composer_6.n30();
      }
      var tmp_52 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(snackbarHostState, tmp_52, null, $composer_6, 6, 4);
      sourceInformationMarkerEnd($composer_6);
      $composer_4.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp6_safe_receiver = $composer_0.t30();
    if (tmp6_safe_receiver == null)
      null;
    else {
      tmp6_safe_receiver.p3c(OrderDetailsScreen$lambda_20(order, onBack, $changed));
    }
  }
  function ComposableSingletons$OrderDetailsScreenKt$lambda$_2033616965$lambda_c85sac($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C102@4689L46,102@4684L52:OrderDetailsScreen.kt#endgyt');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2033616965, $changed, -1, 'client.fstech.hadaya.presentation.order_details.ComposableSingletons$OrderDetailsScreenKt.lambda$-2033616965.<anonymous> (OrderDetailsScreen.kt:102)');
      }
      var tmp = stringResource(get_order_details_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderDetailsScreenKt$lambda$2031425627$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C107@4970L31,105@4850L177:OrderDetailsScreen.kt#endgyt');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(2031425627, $changed, -1, 'client.fstech.hadaya.presentation.order_details.ComposableSingletons$OrderDetailsScreenKt.lambda$2031425627.<anonymous> (OrderDetailsScreen.kt:105)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderDetailsScreenKt$lambda$1608597867$lambda($this$item, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C207@9900L47,208@9995L10,206@9863L229:OrderDetailsScreen.kt#endgyt');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1608597867, $changed, -1, 'client.fstech.hadaya.presentation.order_details.ComposableSingletons$OrderDetailsScreenKt.lambda$1608597867.<anonymous> (OrderDetailsScreen.kt:206)');
      }
      var tmp0_text = stringResource(get_ordered_items_header(string_instance), $composer_0, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_0, 6).lof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_0 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp, null, tmp_0, null, tmp2_fontWeight, null, tmp_1, null, null, tmp_2, tmp_3, false, 0, 0, null, tmp1_style, $composer_0, 1572864, 0, 131006);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderDetailsScreenKt$lambda$797940099$lambda($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C283@13694L43,283@13689L49:OrderDetailsScreen.kt#endgyt');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(797940099, $changed, -1, 'client.fstech.hadaya.presentation.order_details.ComposableSingletons$OrderDetailsScreenKt.lambda$797940099.<anonymous> (OrderDetailsScreen.kt:283)');
      }
      var tmp = stringResource(get_return_order_btn(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderDetailsScreenKt$lambda$476466778$lambda($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C297@14471L63,298@14567L28,299@14633L55,299@14628L61:OrderDetailsScreen.kt#endgyt');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(476466778, $changed, -1, 'client.fstech.hadaya.presentation.order_details.ComposableSingletons$OrderDetailsScreenKt.lambda$476466778.<anonymous> (OrderDetailsScreen.kt:297)');
      }
      var tmp = get_Chat(Filled_instance_0);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_0, tmp$ret$0), $composer_0, 6);
      var tmp_1 = stringResource(get_contact_support_whatsapp_btn(string_instance), $composer_0, 0);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderDetailsScreenKt$lambda$_723330761$lambda_3mlv8z($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C334@16080L36,334@16075L42:OrderDetailsScreen.kt#endgyt');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-723330761, $changed, -1, 'client.fstech.hadaya.presentation.order_details.ComposableSingletons$OrderDetailsScreenKt.lambda$-723330761.<anonymous> (OrderDetailsScreen.kt:334)');
      }
      var tmp = stringResource(get_apply_btn(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderDetailsScreenKt$lambda$1846794297$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C339@16295L33,339@16290L39:OrderDetailsScreen.kt#endgyt');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1846794297, $changed, -1, 'client.fstech.hadaya.presentation.order_details.ComposableSingletons$OrderDetailsScreenKt.lambda$1846794297.<anonymous> (OrderDetailsScreen.kt:339)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderDetailsScreenKt$lambda$284131902$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C310@14964L53,310@14959L59:OrderDetailsScreen.kt#endgyt');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(284131902, $changed, -1, 'client.fstech.hadaya.presentation.order_details.ComposableSingletons$OrderDetailsScreenKt.lambda$284131902.<anonymous> (OrderDetailsScreen.kt:310)');
      }
      var tmp = stringResource(get_return_reason_dialog_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderDetailsScreenKt$lambda$2030177080$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C316@15300L52,316@15295L58:OrderDetailsScreen.kt#endgyt');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(2030177080, $changed, -1, 'client.fstech.hadaya.presentation.order_details.ComposableSingletons$OrderDetailsScreenKt.lambda$2030177080.<anonymous> (OrderDetailsScreen.kt:316)');
      }
      var tmp = stringResource(get_return_reason_placeholder(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderDetailsScreenKt$lambda$2003991259$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C374@17909L33,374@17904L39:OrderDetailsScreen.kt#endgyt');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(2003991259, $changed, -1, 'client.fstech.hadaya.presentation.order_details.ComposableSingletons$OrderDetailsScreenKt.lambda$2003991259.<anonymous> (OrderDetailsScreen.kt:374)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderDetailsScreenKt$lambda$_1602187906$lambda_jdpxbt($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C455@20817L41,456@20905L11,453@20711L237:OrderDetailsScreen.kt#endgyt');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1602187906, $changed, -1, 'client.fstech.hadaya.presentation.order_details.ComposableSingletons$OrderDetailsScreenKt.lambda$-1602187906.<anonymous> (OrderDetailsScreen.kt:453)');
      }
      var tmp = get_AddShoppingCart(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_re_add_to_cart(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).co0_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderDetailsScreenKt() {
    ComposableSingletons$OrderDetailsScreenKt_instance = this;
    var tmp = this;
    tmp.c132_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-2033616965, false, ComposableSingletons$OrderDetailsScreenKt$lambda$_2033616965$lambda_c85sac));
    var tmp_0 = this;
    tmp_0.d132_1 = ComposableLambda$invoke$ref(composableLambdaInstance(2031425627, false, ComposableSingletons$OrderDetailsScreenKt$lambda$2031425627$lambda));
    var tmp_1 = this;
    tmp_1.e132_1 = ComposableLambda$invoke$ref_8(composableLambdaInstance(1608597867, false, ComposableSingletons$OrderDetailsScreenKt$lambda$1608597867$lambda));
    var tmp_2 = this;
    tmp_2.f132_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(797940099, false, ComposableSingletons$OrderDetailsScreenKt$lambda$797940099$lambda));
    var tmp_3 = this;
    tmp_3.g132_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(476466778, false, ComposableSingletons$OrderDetailsScreenKt$lambda$476466778$lambda));
    var tmp_4 = this;
    tmp_4.h132_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-723330761, false, ComposableSingletons$OrderDetailsScreenKt$lambda$_723330761$lambda_3mlv8z));
    var tmp_5 = this;
    tmp_5.i132_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1846794297, false, ComposableSingletons$OrderDetailsScreenKt$lambda$1846794297$lambda));
    var tmp_6 = this;
    tmp_6.j132_1 = ComposableLambda$invoke$ref(composableLambdaInstance(284131902, false, ComposableSingletons$OrderDetailsScreenKt$lambda$284131902$lambda));
    var tmp_7 = this;
    tmp_7.k132_1 = ComposableLambda$invoke$ref(composableLambdaInstance(2030177080, false, ComposableSingletons$OrderDetailsScreenKt$lambda$2030177080$lambda));
    var tmp_8 = this;
    tmp_8.l132_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(2003991259, false, ComposableSingletons$OrderDetailsScreenKt$lambda$2003991259$lambda));
    var tmp_9 = this;
    tmp_9.m132_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1602187906, false, ComposableSingletons$OrderDetailsScreenKt$lambda$_1602187906$lambda_jdpxbt));
  }
  var ComposableSingletons$OrderDetailsScreenKt_instance;
  function ComposableSingletons$OrderDetailsScreenKt_getInstance() {
    if (ComposableSingletons$OrderDetailsScreenKt_instance == null)
      new ComposableSingletons$OrderDetailsScreenKt();
    return ComposableSingletons$OrderDetailsScreenKt_instance;
  }
  function PastOrderItemRow(item, language, isReAdding, onReAdd, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1120751082);
    sourceInformation($composer_0, 'C(PastOrderItemRow)P(1,2)406@18679L40,407@18754L19,408@18780L2216,403@18556L2440:OrderDetailsScreen.kt#endgyt');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(item) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.l31(isReAdding) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onReAdd) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1120751082, $dirty, -1, 'client.fstech.hadaya.presentation.order_details.PastOrderItemRow (OrderDetailsScreen.kt:402)');
      }
      var tmp = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
      var tmp_0 = RoundedCornerShape(tmp$ret$0);
      var tmp_1 = CardDefaults_instance;
      var tmp_2 = Companion_getInstance_14().m6b_1;
      var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = tmp_1.loh(tmp_2, tmp_3, tmp_4, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24582, 14);
      var tmp_6 = CardDefaults_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_7 = _Dp___init__impl__ms3zkb(2);
      var tmp_8 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_9 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_10 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_11 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_12 = tmp_6.pog(tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, _Dp___init__impl__ms3zkb(0.0), $composer_0, 1572870, 62);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-987318044, true, PastOrderItemRow$lambda(item, language, isReAdding, onReAdd), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_13;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref_6(dispatchReceiver);
        $composer_1.j31(value);
        tmp_13 = value;
      } else {
        tmp_13 = it;
      }
      var tmp$ret$2 = tmp_13;
      Card(tmp, tmp_0, tmp_5, tmp_12, null, tmp$ret$2, $composer_0, 196614, 16);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(PastOrderItemRow$lambda_0(item, language, isReAdding, onReAdd, $changed));
    }
  }
  function OrderDetailsScreen$lambda($order) {
    return function () {
      return parametersOf([$order]);
    };
  }
  function OrderDetailsScreen$lambda_0($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function OrderDetailsScreen$lambda_1($showReturnDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showReturnDialog', KMutableProperty0, true);
    return $showReturnDialog$delegate.u1();
  }
  function OrderDetailsScreen$lambda_2($showReturnDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showReturnDialog', KMutableProperty0, true);
    $showReturnDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function OrderDetailsScreen$lambda_3() {
    return mutableStateOf(false);
  }
  function OrderDetailsScreen$lambda_4($returnReason$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('returnReason', KMutableProperty0, true);
    return $returnReason$delegate.u1();
  }
  function OrderDetailsScreen$lambda_5($returnReason$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('returnReason', KMutableProperty0, true);
    $returnReason$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function OrderDetailsScreen$lambda_6() {
    return mutableStateOf('');
  }
  function OrderDetailsScreen$lambda_7($stockDialogData$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('stockDialogData', KMutableProperty0, true);
    return $stockDialogData$delegate.u1();
  }
  function OrderDetailsScreen$lambda_8($stockDialogData$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('stockDialogData', KMutableProperty0, true);
    $stockDialogData$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_18(function_0) {
    this.n132_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_18).a1v = function (value, $completion) {
    return this.n132_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_18).q3 = function () {
    return this.n132_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_18).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_18).hashCode = function () {
    return hashCode(this.q3());
  };
  function OrderDetailsScreen$slambda$slambda($snackbarHostState, $onBack, $stockDialogData$delegate, resultContinuation) {
    this.w132_1 = $snackbarHostState;
    this.x132_1 = $onBack;
    this.y132_1 = $stockDialogData$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OrderDetailsScreen$slambda$slambda).b133 = function (effect, $completion) {
    var tmp = this.c133(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderDetailsScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.b133((!(p1 == null) ? isInterface(p1, OrderDetailsSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OrderDetailsScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_subject = this.z132_1;
            if (tmp0_subject instanceof ShowMessage_2) {
              this.n9_1 = 1;
              suspendResult = this.w132_1.dqm(this.z132_1.z131_1, VOID, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof ShowStockDialog) {
                var tmp_0 = this;
                OrderDetailsScreen$lambda_8(this.y132_1, new Pair(this.z132_1.a132_1, this.z132_1.b132_1));
                tmp_0.a133_1 = Unit_instance;
                this.n9_1 = 2;
                continue $sm;
              } else {
                if (equals(tmp0_subject, NavigateBack_instance_1)) {
                  this.a133_1 = this.x132_1();
                  this.n9_1 = 2;
                  continue $sm;
                } else {
                  var tmp_1 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            this.a133_1 = suspendResult;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(OrderDetailsScreen$slambda$slambda).c133 = function (effect, completion) {
    var i = new OrderDetailsScreen$slambda$slambda(this.w132_1, this.x132_1, this.y132_1, completion);
    i.z132_1 = effect;
    return i;
  };
  function OrderDetailsScreen$slambda$slambda_0($snackbarHostState, $onBack, $stockDialogData$delegate, resultContinuation) {
    var i = new OrderDetailsScreen$slambda$slambda($snackbarHostState, $onBack, $stockDialogData$delegate, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.b133(effect, $completion);
    }, 1);
  }
  function OrderDetailsScreen$slambda($viewModel, $snackbarHostState, $onBack, $stockDialogData$delegate, resultContinuation) {
    this.l133_1 = $viewModel;
    this.m133_1 = $snackbarHostState;
    this.n133_1 = $onBack;
    this.o133_1 = $stockDialogData$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OrderDetailsScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderDetailsScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OrderDetailsScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.l133_1.s10h().t10h();
            var tmp_1 = OrderDetailsScreen$slambda$slambda_0(this.m133_1, this.n133_1, this.o133_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_18(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(OrderDetailsScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new OrderDetailsScreen$slambda(this.l133_1, this.m133_1, this.n133_1, this.o133_1, completion);
    i.p133_1 = $this$LaunchedEffect;
    return i;
  };
  function OrderDetailsScreen$slambda_0($viewModel, $snackbarHostState, $onBack, $stockDialogData$delegate, resultContinuation) {
    var i = new OrderDetailsScreen$slambda($viewModel, $snackbarHostState, $onBack, $stockDialogData$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function OrderDetailsScreen$lambda_9($onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C104@4795L254:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-737162051, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous>.<anonymous> (OrderDetailsScreen.kt:104)');
        }
        IconButton($onBack, null, false, null, null, null, ComposableSingletons$OrderDetailsScreenKt_getInstance().d132_1, $composer_0, 1572864, 62);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda$lambda($state$delegate) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C130@5832L2748:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1678417584, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (OrderDetailsScreen.kt:130)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -1190194512, 'C131@5905L893,148@6828L41,151@6948L46,150@6899L191,155@7168L49,154@7119L189,159@7386L45,158@7337L183,173@8417L48,172@8368L186:OrderDetailsScreen.kt#endgyt');
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_1 = fillMaxWidth(Companion_instance);
        var horizontalArrangement = Arrangement_getInstance().wdp_1;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_6 = $composer_5;
        if (!((0 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_6, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_2 = $composer_8.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 93788472, 'C137@6252L284,136@6203L487,145@6723L45:OrderDetailsScreen.kt#endgyt');
        var tmp_3 = get_order_id_prefix_pattern(string_instance);
        var tmp0_safe_receiver = OrderDetailsScreen$lambda_0($state$delegate).p131_1.lzc_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
        var tmp_4;
        if (tmp1_elvis_lhs == null) {
          $composer_10.m30(557222398);
          sourceInformation($composer_10, '140@6458L40');
          var tmp0_group = stringResource(get_not_available(string_instance), $composer_10, 0);
          $composer_10.n30();
          tmp_4 = tmp0_group;
        } else {
          $composer_10.m30(557220104);
          $composer_10.n30();
          tmp_4 = tmp1_elvis_lhs;
        }
        var tmp2_text = stringResource_0(tmp_3, [tmp_4], $composer_10, 0);
        var tmp3_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp4_fontSize = get_sp(18);
        var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_8 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp2_text, null, tmp_5, null, tmp4_fontSize, null, tmp3_fontWeight, null, tmp_6, null, null, tmp_7, tmp_8, false, 0, 0, null, null, $composer_10, 1597440, 0, 262062);
        OrderStatusBadge(OrderDetailsScreen$lambda_0($state$delegate).p131_1.azd_1, $composer_10, 0);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_9 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$13 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_9, tmp$ret$13), $composer_5, 6);
        InfoRow(stringResource(get_receiver_name_label(string_instance), $composer_5, 0), OrderDetailsScreen$lambda_0($state$delegate).p131_1.qzc_1, $composer_5, 0);
        InfoRow(stringResource(get_delivery_address_label(string_instance), $composer_5, 0), OrderDetailsScreen$lambda_0($state$delegate).p131_1.rzc_1, $composer_5, 0);
        InfoRow(stringResource(get_phone_number_label(string_instance), $composer_5, 0), OrderDetailsScreen$lambda_0($state$delegate).p131_1.tzc_1, $composer_5, 0);
        var tmp_10;
        switch (OrderDetailsScreen$lambda_0($state$delegate).p131_1.zzc_1.a1_1) {
          case 0:
            $composer_5.m30(-1700907317);
            sourceInformation($composer_5, '164@7675L49');
            var tmp0_group_0 = stringResource(get_cash_on_delivery_label(string_instance), $composer_5, 0);
            $composer_5.n30();
            tmp_10 = tmp0_group_0;
            break;
          case 3:
            $composer_5.m30(-1700904001);
            sourceInformation($composer_5, '165@7779L37');
            var tmp1_group = stringResource(get_visa_label(string_instance), $composer_5, 0);
            $composer_5.n30();
            tmp_10 = tmp1_group;
            break;
          case 4:
            $composer_5.m30(-1700900859);
            sourceInformation($composer_5, '166@7877L43');
            var tmp2_group = stringResource(get_mastercard_label(string_instance), $composer_5, 0);
            $composer_5.n30();
            tmp_10 = tmp2_group;
            break;
          case 5:
            $composer_5.m30(-1700897564);
            sourceInformation($composer_5, '167@7980L42');
            var tmp3_group = stringResource(get_apple_pay_label(string_instance), $composer_5, 0);
            $composer_5.n30();
            tmp_10 = tmp3_group;
            break;
          case 6:
            $composer_5.m30(-1700894267);
            sourceInformation($composer_5, '168@8083L43');
            var tmp4_group = stringResource(get_google_pay_label(string_instance), $composer_5, 0);
            $composer_5.n30();
            tmp_10 = tmp4_group;
            break;
          case 1:
            $composer_5.m30(-1700891043);
            sourceInformation($composer_5, '169@8184L35');
            var tmp5_group = stringResource(get_instapay(string_instance), $composer_5, 0);
            $composer_5.n30();
            tmp_10 = tmp5_group;
            break;
          case 2:
            $composer_5.m30(-1700888101);
            sourceInformation($composer_5, '170@8276L33');
            var tmp6_group = stringResource(get_wallet(string_instance), $composer_5, 0);
            $composer_5.n30();
            tmp_10 = tmp6_group;
            break;
          default:
            $composer_5.m30(-1700909833);
            $composer_5.n30();
            noWhenBranchMatchedException();
            break;
        }
        var paymentMethodText = tmp_10;
        InfoRow(stringResource(get_payment_method_header(string_instance), $composer_5, 0), paymentMethodText, $composer_5, 0);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_11;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_11 = Unit_instance;
        }
        tmp = tmp_11;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda($state$delegate) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C128@5756L11,128@5714L69,129@5806L2796,125@5543L3059:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1658432130, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (OrderDetailsScreen.kt:125)');
        }
        var tmp_0 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
        var tmp_1 = RoundedCornerShape(tmp$ret$0);
        var tmp_2 = CardDefaults_instance;
        var tmp_3 = MaterialTheme_instance.unz($composer_0, 6).oo0_1;
        var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_6 = tmp_2.loh(tmp_3, tmp_4, tmp_5, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 14);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1678417584, true, OrderDetailsScreen$lambda$lambda$lambda($state$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_7;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref_6(dispatchReceiver);
          $composer_1.j31(value);
          tmp_7 = value;
        } else {
          tmp_7 = it;
        }
        var tmp$ret$1 = tmp_7;
        Card(tmp_0, tmp_1, tmp_6, null, null, tmp$ret$1, $composer_0, 196614, 24);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda$lambda_0($state$delegate) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C199@9701L10,196@9478L274:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(440761365, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (OrderDetailsScreen.kt:196)');
        }
        var tmp0_elvis_lhs = OrderDetailsScreen$lambda_0($state$delegate).p131_1.czd_1;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          $composer_0.m30(-1630087465);
          sourceInformation($composer_0, '197@9543L34');
          var tmp0_group = stringResource(get_not_set(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp0_group;
        } else {
          $composer_0.m30(-1630088302);
          $composer_0.n30();
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp_1 = tmp_0;
        var tmp_2 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
        var tmp_3 = padding_0(tmp_2, tmp$ret$0);
        var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_8 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_1, tmp_3, tmp_4, null, tmp_5, null, null, null, tmp_6, null, null, tmp_7, tmp_8, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).pof_1, $composer_0, 48, 0, 131068);
        var tmp_9;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_9 = Unit_instance;
        }
        tmp = tmp_9;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda_0($state$delegate) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C183@8771L45,185@8926L10,182@8737L237,191@9276L11,190@9201L220,195@9448L330,187@8999L779:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-540184889, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (OrderDetailsScreen.kt:182)');
        }
        var tmp_0 = stringResource(get_user_comment_label(string_instance), $composer_0, 0);
        var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = Companion_getInstance_16().e7z_1;
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, null, tmp_1, null, tmp_2, null, tmp_3, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).mof_1, $composer_0, 1572864, 0, 131006);
        var tmp_7 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
        var tmp_8 = padding_1(tmp_7, VOID, tmp$ret$0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(8);
        var tmp_9 = RoundedCornerShape(tmp$ret$1);
        var tmp_10 = CardDefaults_instance;
        var tmp_11 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_0, 6).oo0_1, 0.5);
        var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_13 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_14 = tmp_10.loh(tmp_11, tmp_12, tmp_13, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 14);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(440761365, true, OrderDetailsScreen$lambda$lambda$lambda_0($state$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_15;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref_6(dispatchReceiver);
          $composer_1.j31(value);
          tmp_15 = value;
        } else {
          tmp_15 = it;
        }
        var tmp$ret$2 = tmp_15;
        Card(tmp_8, tmp_9, tmp_14, null, null, tmp$ret$2, $composer_0, 196614, 24);
        var tmp_16;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_16 = Unit_instance;
        }
        tmp = tmp_16;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda_1(it) {
    return null;
  }
  function OrderDetailsScreen$lambda$lambda_2($key, $items) {
    return function (index) {
      return $key($items.l1(index));
    };
  }
  function OrderDetailsScreen$lambda$lambda_3($contentType, $items) {
    return function (index) {
      return $contentType($items.l1(index));
    };
  }
  function OrderDetailsScreen$lambda$lambda$lambda_1($viewModel, $item) {
    return function () {
      $viewModel.s10h().j10i(new ReAddToCart($item));
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda_4($items, $viewModel, $state$delegate) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp2 = $items.l1(it);
        var $changed_0 = 14 & $dirty;
        var $composer_1 = $composer_0;
        $composer_1.m30(-2093361164);
        sourceInformation($composer_1, 'C*218@10399L68,214@10183L306:OrderDetailsScreen.kt#endgyt');
        var tmp_2 = OrderDetailsScreen$lambda_0($state$delegate).r131_1;
        var tmp_3 = OrderDetailsScreen$lambda_0($state$delegate).s131_1.m1(tmp2.fyw_1);
        sourceInformationMarkerStart($composer_1, -1591541759, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_1.q31($viewModel) | $composer_1.q31(tmp2));
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_4;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = OrderDetailsScreen$lambda$lambda$lambda_1($viewModel, tmp2);
          $composer_1.j31(value);
          tmp_4 = value;
        } else {
          tmp_4 = it_0;
        }
        var tmp0_group = tmp_4;
        sourceInformationMarkerEnd($composer_1);
        PastOrderItemRow(tmp2, tmp_2, tmp_3, tmp0_group, $composer_1, 14 & $changed_0 >> 3);
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda_5($state$delegate) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C223@10552L19,224@10592L2106:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1815547830, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (OrderDetailsScreen.kt:223)');
        }
        var tmp_0 = _Dp___init__impl__ms3zkb(0.0);
        HorizontalDivider(null, tmp_0, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 7);
        var tmp_1 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = padding_2(tmp_1, VOID, tmp$ret$0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_2 = $composer_3.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -256373238, 'C226@10733L41,225@10687L226,231@10984L46,230@10938L235,243@11603L40,244@11668L1008:OrderDetailsScreen.kt#endgyt');
        var tmp_3 = stringResource(get_order_subtotal(string_instance), $composer_5, 0);
        var tmp_4 = OrderDetailsScreen$lambda_0($state$delegate).p131_1.vzc_1;
        PriceRow(tmp_3, tmp_4, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), OrderDetailsScreen$lambda_0($state$delegate).r131_1, $composer_5, 0, 4);
        var tmp_5 = stringResource(get_order_shipping_cost(string_instance), $composer_5, 0);
        var tmp_6 = OrderDetailsScreen$lambda_0($state$delegate).p131_1.xzc_1;
        PriceRow(tmp_5, tmp_6, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), OrderDetailsScreen$lambda_0($state$delegate).r131_1, $composer_5, 0, 4);
        if (OrderDetailsScreen$lambda_0($state$delegate).p131_1.wzc_1 > 0) {
          $composer_5.m30(-255887376);
          sourceInformation($composer_5, '237@11308L41,236@11258L294');
          PriceRow(stringResource(get_order_discount(string_instance), $composer_5, 0), -OrderDetailsScreen$lambda_0($state$delegate).p131_1.wzc_1, Companion_getInstance_14().n6b_1, OrderDetailsScreen$lambda_0($state$delegate).r131_1, $composer_5, 384, 0);
          $composer_5.n30();
        } else {
          $composer_5.m30(-255551026);
          $composer_5.n30();
        }
        var tmp_7 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(8);
        Spacer(height(tmp_7, tmp$ret$7), $composer_5, 6);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_1 = fillMaxWidth(Companion_instance);
        var horizontalArrangement = Arrangement_getInstance().wdp_1;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_6 = $composer_5;
        if (!((0 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_6, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_8 = $composer_8.g30();
        if (!isInterface(tmp_8, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 174214483, 'C250@11984L44,249@11946L224,255@12237L166,261@12601L11,254@12199L451:OrderDetailsScreen.kt#endgyt');
        var tmp0_text = stringResource(get_order_total_price(string_instance), $composer_10, 0);
        var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp2_fontSize = get_sp(20);
        var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp_9, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_10, null, null, tmp_11, tmp_12, false, 0, 0, null, null, $composer_10, 1597440, 0, 262062);
        var tmp3_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [OrderDetailsScreen$lambda_0($state$delegate).p131_1.yzc_1], $composer_10, 0), OrderDetailsScreen$lambda_0($state$delegate).r131_1);
        var tmp4_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp5_fontSize = get_sp(20);
        var tmp6_color = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
        var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_15 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp3_text, null, tmp6_color, null, tmp5_fontSize, null, tmp4_fontWeight, null, tmp_13, null, null, tmp_14, tmp_15, false, 0, 0, null, null, $composer_10, 1597440, 0, 262058);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_16;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_16 = Unit_instance;
        }
        tmp = tmp_16;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda$lambda_2($showReturnDialog$delegate) {
    return function () {
      OrderDetailsScreen$lambda_2($showReturnDialog$delegate, true);
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda$lambda_3($supportUrl) {
    return function () {
      openUrl($supportUrl);
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda_6($showReturnDialog$delegate, $state$delegate) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-944726231, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (OrderDetailsScreen.kt:268)');
        }
        var now = System_instance.fp().wp();
        var tmp0_elvis_lhs = OrderDetailsScreen$lambda_0($state$delegate).p131_1.fzd_1;
        var createdMillis = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
        var diff = subtract(now, createdMillis);
        // Inline function 'kotlin.Long.times' call
        var this_0 = new Long(14, 0);
        // Inline function 'kotlin.Long.times' call
        var this_1 = multiply(this_0, fromInt(24));
        // Inline function 'kotlin.Long.times' call
        var this_2 = multiply(this_1, fromInt(60));
        // Inline function 'kotlin.Long.times' call
        var this_3 = multiply(this_2, fromInt(60));
        var fourteenDaysInMillis = multiply(this_3, fromInt(1000));
        var canRequestReturn = compare(diff, fourteenDaysInMillis) < 0 && OrderDetailsScreen$lambda_0($state$delegate).p131_1.azd_1.equals(OrderStatus_RECEIVED_getInstance());
        if (OrderDetailsScreen$lambda_0($state$delegate).p131_1.azd_1.equals(OrderStatus_RECEIVED_getInstance())) {
          $composer_0.m30(582062312);
          sourceInformation($composer_0, '');
          if (canRequestReturn) {
            $composer_0.m30(582106301);
            sourceInformation($composer_0, '280@13539L11,280@13495L62,278@13342L27,277@13292L476');
            var tmp1_modifier = fillMaxWidth(Companion_instance);
            var tmp_0 = ButtonDefaults_getInstance();
            var tmp_1 = MaterialTheme_instance.unz($composer_0, 6).to0_1;
            var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp2_colors = tmp_0.ao9(tmp_1, tmp_2, tmp_3, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 14);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$4 = _Dp___init__impl__ms3zkb(12);
            var tmp3_shape = RoundedCornerShape(tmp$ret$4);
            sourceInformationMarkerStart($composer_0, -1643789212, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid = $composer_0.k31($showReturnDialog$delegate);
            // Inline function 'kotlin.let' call
            var it = $composer_0.i31();
            var tmp_4;
            if (invalid || it === Companion_getInstance().f30_1) {
              var value = OrderDetailsScreen$lambda$lambda$lambda_2($showReturnDialog$delegate);
              $composer_0.j31(value);
              tmp_4 = value;
            } else {
              tmp_4 = it;
            }
            var tmp0_group = tmp_4;
            sourceInformationMarkerEnd($composer_0);
            Button(tmp0_group, tmp1_modifier, false, tmp3_shape, tmp2_colors, null, null, null, null, ComposableSingletons$OrderDetailsScreenKt_getInstance().f132_1, $composer_0, 805306416, 484);
            $composer_0.n30();
          } else {
            $composer_0.m30(582624776);
            sourceInformation($composer_0, '286@13847L47,290@14143L196,288@13973L44,287@13923L796');
            var supportUrl = stringResource(get_support_whatsapp_url(string_instance), $composer_0, 0);
            var tmp4_modifier = fillMaxWidth(Companion_instance);
            var tmp_5 = ButtonDefaults_getInstance();
            var tmp_6 = Color(new Long(-14298266, 0));
            var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp_8 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
            var tmp5_colors = tmp_5.ao9(tmp_6, tmp_7, tmp_8, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24582, 14);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$9 = _Dp___init__impl__ms3zkb(12);
            var tmp6_shape = RoundedCornerShape(tmp$ret$9);
            sourceInformationMarkerStart($composer_0, -1643769003, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_0 = $composer_0.k31(supportUrl);
            // Inline function 'kotlin.let' call
            var it_0 = $composer_0.i31();
            var tmp_9;
            if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
              var value_0 = OrderDetailsScreen$lambda$lambda$lambda_3(supportUrl);
              $composer_0.j31(value_0);
              tmp_9 = value_0;
            } else {
              tmp_9 = it_0;
            }
            var tmp1_group = tmp_9;
            sourceInformationMarkerEnd($composer_0);
            Button(tmp1_group, tmp4_modifier, false, tmp6_shape, tmp5_colors, null, null, null, null, ComposableSingletons$OrderDetailsScreenKt_getInstance().g132_1, $composer_0, 805306416, 484);
            $composer_0.n30();
          }
          $composer_0.n30();
        } else {
          $composer_0.m30(583554745);
          $composer_0.n30();
        }
        var tmp_10;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_10 = Unit_instance;
        }
        tmp = tmp_10;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda_10($state$delegate, $viewModel, $showReturnDialog$delegate) {
    return function ($this$LazyColumn) {
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(1658432130, true, OrderDetailsScreen$lambda$lambda($state$delegate))));
      var tmp;
      // Inline function 'kotlin.text.isNullOrBlank' call
      var this_0 = OrderDetailsScreen$lambda_0($state$delegate).p131_1.czd_1;
      if (!(this_0 == null || isBlank(this_0))) {
        $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(-540184889, true, OrderDetailsScreen$lambda$lambda_0($state$delegate))));
        tmp = Unit_instance;
      }
      $this$LazyColumn.ci9(VOID, VOID, ComposableSingletons$OrderDetailsScreenKt_getInstance().e132_1);
      // Inline function 'androidx.compose.foundation.lazy.items' call
      var items = OrderDetailsScreen$lambda_0($state$delegate).p131_1.uzc_1;
      var contentType = OrderDetailsScreen$lambda$lambda_1;
      var tmp_0 = items.n1();
      var tmp_1;
      if (!(null == null)) {
        tmp_1 = OrderDetailsScreen$lambda$lambda_2(null, items);
      } else {
        tmp_1 = null;
      }
      var tmp_2 = tmp_1;
      var tmp_3 = OrderDetailsScreen$lambda$lambda_3(contentType, items);
      $this$LazyColumn.di9(tmp_0, tmp_2, tmp_3, ComposableLambda$invoke$ref_4(composableLambdaInstance(802480018, true, OrderDetailsScreen$lambda$lambda_4(items, $viewModel, $state$delegate))));
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(-1815547830, true, OrderDetailsScreen$lambda$lambda_5($state$delegate))));
      $this$LazyColumn.ci9(VOID, VOID, ComposableLambda$invoke$ref_8(composableLambdaInstance(-944726231, true, OrderDetailsScreen$lambda$lambda_6($showReturnDialog$delegate, $state$delegate))));
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda_11($showReturnDialog$delegate) {
    return function () {
      OrderDetailsScreen$lambda_2($showReturnDialog$delegate, false);
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda_7($viewModel, $returnReason$delegate, $showReturnDialog$delegate) {
    return function () {
      var tmp;
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = OrderDetailsScreen$lambda_4($returnReason$delegate);
      if (!isBlank(this_0)) {
        $viewModel.s10h().j10i(new RequestReturn(OrderDetailsScreen$lambda_4($returnReason$delegate)));
        OrderDetailsScreen$lambda_2($showReturnDialog$delegate, false);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda_12($returnReason$delegate, $viewModel, $showReturnDialog$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C322@15535L430,321@15489L650:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-561150918, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous> (OrderDetailsScreen.kt:321)');
        }
        sourceInformationMarkerStart($composer_0, 1899849704, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.k31($returnReason$delegate) | $composer_0.q31($viewModel)) | $composer_0.k31($showReturnDialog$delegate));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = OrderDetailsScreen$lambda$lambda_7($viewModel, $returnReason$delegate, $showReturnDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.text.isNotBlank' call
        var this_0 = OrderDetailsScreen$lambda_4($returnReason$delegate);
        var tmp_1 = !isBlank(this_0);
        TextButton(tmp0_group, null, tmp_1, null, null, null, null, null, null, ComposableSingletons$OrderDetailsScreenKt_getInstance().h132_1, $composer_0, 805306368, 506);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda_8($showReturnDialog$delegate) {
    return function () {
      OrderDetailsScreen$lambda_2($showReturnDialog$delegate, false);
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda_13($showReturnDialog$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C338@16234L28,338@16213L138:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2008974140, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous> (OrderDetailsScreen.kt:338)');
        }
        sourceInformationMarkerStart($composer_0, -2111133256, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($showReturnDialog$delegate);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = OrderDetailsScreen$lambda$lambda_8($showReturnDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$OrderDetailsScreenKt_getInstance().i132_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda_9($returnReason$delegate) {
    return function (it) {
      OrderDetailsScreen$lambda_5($returnReason$delegate, it);
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda_14($returnReason$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C314@15172L21,312@15067L348:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1569194431, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous> (OrderDetailsScreen.kt:312)');
        }
        var tmp_0 = OrderDetailsScreen$lambda_4($returnReason$delegate);
        sourceInformationMarkerStart($composer_0, 462331380, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($returnReason$delegate);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = OrderDetailsScreen$lambda$lambda_9($returnReason$delegate);
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp0_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        var tmp_2 = fillMaxWidth(Companion_instance);
        var tmp_3 = ComposableSingletons$OrderDetailsScreenKt_getInstance().k132_1;
        OutlinedTextField(tmp_0, tmp0_group, tmp_2, false, false, null, null, tmp_3, null, null, null, null, null, false, null, null, null, false, 0, 3, null, null, null, $composer_0, 12583296, 805306368, 0, 7864184);
        var tmp_4;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_4 = Unit_instance;
        }
        tmp = tmp_4;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda_15($stockDialogData$delegate) {
    return function () {
      OrderDetailsScreen$lambda_8($stockDialogData$delegate, null);
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda_10($viewModel, $productId, $stockDialogData$delegate) {
    return function () {
      $viewModel.s10h().j10i(new ToggleFavorite_0($productId));
      $viewModel.s10h().j10i(new ToggleStockReminder($productId));
      OrderDetailsScreen$lambda_8($stockDialogData$delegate, null);
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda_11($state$delegate) {
    return function ($this$TextButton, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C369@17660L73:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(468594589, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (OrderDetailsScreen.kt:369)');
        }
        var tmp_0 = OrderDetailsScreen$lambda_0($state$delegate).r131_1 === 'en' ? 'Add to Wishlist' : '\u0625\u0636\u0627\u0641\u0629 \u0644\u0644\u0623\u0645\u0646\u064A\u0627\u062A';
        var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda_16($viewModel, $productId, $stockDialogData$delegate, $state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C359@17194L417,368@17634L121,358@17148L607:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(707757050, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous>.<anonymous> (OrderDetailsScreen.kt:358)');
        }
        sourceInformationMarkerStart($composer_0, 1549694875, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.q31($viewModel) | $composer_0.o31($productId));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = OrderDetailsScreen$lambda$lambda_10($viewModel, $productId, $stockDialogData$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(468594589, true, OrderDetailsScreen$lambda$lambda_11($state$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_1;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_0;
        }
        var tmp$ret$4 = tmp_1;
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, tmp$ret$4, $composer_0, 805306368, 510);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda$lambda_12($stockDialogData$delegate) {
    return function () {
      OrderDetailsScreen$lambda_8($stockDialogData$delegate, null);
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda_17($stockDialogData$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C373@17850L26,373@17829L136:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2051813576, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous>.<anonymous> (OrderDetailsScreen.kt:373)');
        }
        sourceInformationMarkerStart($composer_0, -402856270, 'CC(remember):OrderDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = OrderDetailsScreen$lambda$lambda_12($stockDialogData$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$OrderDetailsScreenKt_getInstance().l132_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda_18($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C348@16568L67:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-516416906, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous>.<anonymous> (OrderDetailsScreen.kt:348)');
        }
        var tmp_0 = OrderDetailsScreen$lambda_0($state$delegate).r131_1 === 'en' ? 'Out of Stock' : '\u0646\u0641\u0630\u062A \u0627\u0644\u0643\u0645\u064A\u0629';
        var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda_19($productName, $state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C350@16684L390:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1896202219, $changed, -1, 'client.fstech.hadaya.presentation.order_details.OrderDetailsScreen.<anonymous>.<anonymous>.<anonymous> (OrderDetailsScreen.kt:350)');
        }
        var tmp_0 = OrderDetailsScreen$lambda_0($state$delegate).r131_1 === 'en' ? 'Sorry, ' + $productName + " is currently out of stock. Would you like to add it to your wishlist to be notified when it's back?" : '\u0639\u0630\u0631\u0627\u064B\u060C ' + $productName + ' \u0646\u0641\u0630 \u0645\u0646 \u0627\u0644\u0645\u062E\u0632\u0646 \u062D\u0627\u0644\u064A\u0627\u064B. \u0647\u0644 \u062A\u0648\u062F \u0625\u0636\u0627\u0641\u062A\u0647 \u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0623\u0645\u0646\u064A\u0627\u062A \u0644\u064A\u062A\u0645 \u0625\u062E\u0637\u0627\u0631\u0643 \u0639\u0646\u062F \u062A\u0648\u0641\u0631\u0647 \u0645\u062C\u062F\u062F\u0627\u064B\u061F';
        var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderDetailsScreen$lambda_20($order, $onBack, $$changed) {
    return function ($composer, $force) {
      OrderDetailsScreen($order, $onBack, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function PastOrderItemRow$lambda($item, $language, $isReAdding, $onReAdd) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C409@18790L2200:OrderDetailsScreen.kt#endgyt');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-987318044, $changed, -1, 'client.fstech.hadaya.presentation.order_details.PastOrderItemRow.<anonymous> (OrderDetailsScreen.kt:409)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var horizontalArrangement = null;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance;
        if (!((2 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((2 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 390 >> 3 | 112 & 390 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -1736533763, 'C416@19106L307,424@19426L40,425@19479L1036:OrderDetailsScreen.kt#endgyt');
        var tmp0_elvis_lhs = $item.syw_1;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = $item.qyw_1;
          tmp_2 = tmp1_safe_receiver == null ? null : firstOrNull(tmp1_safe_receiver);
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var imageUrl = tmp_2;
        var imageModel = !($item.xyw_1 == null) ? $item.xyw_1 : imageUrl;
        var tmp_3 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(70);
        var tmp_4 = size(tmp_3, tmp$ret$7);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(4);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = padding_0(tmp_4, tmp$ret$8);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_5 = $composer_8.g30();
        if (!isInterface(tmp_5, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 1743464681, 'C417@19175L224:OrderDetailsScreen.kt#endgyt');
        HadayaImage(imageModel, null, fillMaxSize(Companion_instance), Companion_getInstance_13().r96_1, $composer_10, 3504, 0);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_6 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$15 = _Dp___init__impl__ms3zkb(12);
        Spacer(width(tmp_6, tmp$ret$15), $composer_5, 6);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_3 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_11 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_1 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_11, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_12 = $composer_11;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
        var localMap_1 = $composer_12.t31();
        var materialized_1 = materialize($composer_12, modifier_4);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_13 = $composer_12;
        var tmp_7 = $composer_13.g30();
        if (!isInterface(tmp_7, Applier)) {
          invalidApplier();
        }
        $composer_13.b31();
        if ($composer_13.h30()) {
          $composer_13.c31(tmp0_1);
        } else {
          $composer_13.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_14 = $composer_13;
        var $composer_15 = $composer_14;
        sourceInformationMarkerStart($composer_15, 363919124, 'C429@19746L139,435@19931L41,436@20053L10,434@19902L189,438@20108L52,440@20203L143,445@20464L11,439@20177L324:OrderDetailsScreen.kt#endgyt');
        var tmp_8;
        if ($language === 'en') {
          var tmp0_elvis_lhs_0 = $item.hyw_1;
          tmp_8 = tmp0_elvis_lhs_0 == null ? $item.iyw_1 : tmp0_elvis_lhs_0;
        } else {
          var tmp1_elvis_lhs = $item.iyw_1;
          tmp_8 = tmp1_elvis_lhs == null ? $item.hyw_1 : tmp1_elvis_lhs;
        }
        var tmp2_elvis_lhs = tmp_8;
        var tmp_9;
        if (tmp2_elvis_lhs == null) {
          $composer_15.m30(565932812);
          sourceInformation($composer_15, '428@19695L34');
          var tmp0_group = stringResource(get_product(string_instance), $composer_15, 0);
          $composer_15.n30();
          tmp_9 = tmp0_group;
        } else {
          $composer_15.m30(565928844);
          $composer_15.n30();
          tmp_9 = tmp2_elvis_lhs;
        }
        var name = tmp_9;
        var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = Companion_getInstance_16().e7z_1;
        var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_15 = _TextOverflow___init__impl__obguoe(0);
        Text(name, null, tmp_10, null, tmp_11, null, tmp_12, null, tmp_13, null, null, tmp_14, tmp_15, false, 2, 0, null, null, $composer_15, 1572864, 24576, 245694);
        var tmp_16 = stringResource(get_quantity_label(string_instance), $composer_15, 0) + ': ' + format($item.ryw_1, $language);
        var tmp_17 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_18 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_21 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_16, null, tmp_17, null, tmp_18, null, null, null, tmp_19, null, null, tmp_20, tmp_21, false, 0, 0, null, MaterialTheme_instance.jog($composer_15, 6).qof_1, $composer_15, 0, 0, 131070);
        ItemOptionsDisplay($item, $language, null, false, false, $composer_15, 0, 28);
        var tmp_22 = get_price_egp(string_instance);
        var tmp3_elvis_lhs = $item.lyw_1;
        var tmp4_text = formatNumbers(stringResource_0(tmp_22, [(tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs) * $item.ryw_1], $composer_15, 0), $language);
        var tmp5_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp6_color = MaterialTheme_instance.unz($composer_15, 6).xnz_1;
        var tmp_23 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_24 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_25 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_26 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp4_text, null, tmp6_color, null, tmp_23, null, tmp5_fontWeight, null, tmp_24, null, null, tmp_25, tmp_26, false, 0, 0, null, null, $composer_15, 1572864, 0, 262074);
        sourceInformationMarkerEnd($composer_15);
        $composer_13.e31();
        if ($isReAdding) {
          $composer_5.m30(-1734988600);
          sourceInformation($composer_5, '450@20563L58');
          var tmp_27 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$22 = _Dp___init__impl__ms3zkb(24);
          var tmp_28 = size(tmp_27, tmp$ret$22);
          var tmp_29 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_30 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_31 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_32 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, _Dp___init__impl__ms3zkb(0.0), $composer_5, 6, 62);
          $composer_5.n30();
        } else {
          $composer_5.m30(-1734885649);
          sourceInformation($composer_5, '452@20659L307');
          IconButton($onReAdd, null, false, null, null, null, ComposableSingletons$OrderDetailsScreenKt_getInstance().m132_1, $composer_5, 1572864, 62);
          $composer_5.n30();
        }
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_33;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_33 = Unit_instance;
        }
        tmp = tmp_33;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function PastOrderItemRow$lambda_0($item, $language, $isReAdding, $onReAdd, $$changed) {
    return function ($composer, $force) {
      PastOrderItemRow($item, $language, $isReAdding, $onReAdd, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_order_details_OrderDetailsViewModel$stable;
  function OrderDetailsViewModel$handleIntent$lambda($itemId) {
    return function ($this$updateState) {
      return $this$updateState.u131(VOID, VOID, VOID, plus_1($this$updateState.s131_1, $itemId));
    };
  }
  function OrderDetailsViewModel$handleIntent$lambda_0($itemId) {
    return function ($this$updateState) {
      return $this$updateState.u131(VOID, VOID, VOID, minus($this$updateState.s131_1, $itemId));
    };
  }
  function OrderDetailsViewModel$handleIntent$slambda(this$0, $intent, resultContinuation) {
    this.y133_1 = this$0;
    this.z133_1 = $intent;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OrderDetailsViewModel$handleIntent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderDetailsViewModel$handleIntent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OrderDetailsViewModel$handleIntent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.y133_1.k134_1.vdf(this.z133_1.x131_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.y133_1.d10l(new ShowMessage_2('Updated favorites'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.n9_1 = 4;
              suspendResult = this.y133_1.d10l(new ShowMessage_2('Failed to update favorites'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(OrderDetailsViewModel$handleIntent$slambda).q24 = function ($this$launch, completion) {
    var i = new OrderDetailsViewModel$handleIntent$slambda(this.y133_1, this.z133_1, completion);
    i.a134_1 = $this$launch;
    return i;
  };
  function OrderDetailsViewModel$handleIntent$slambda_0(this$0, $intent, resultContinuation) {
    var i = new OrderDetailsViewModel$handleIntent$slambda(this$0, $intent, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function OrderDetailsViewModel$handleIntent$slambda_1(this$0, $intent, resultContinuation) {
    this.u134_1 = this$0;
    this.v134_1 = $intent;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OrderDetailsViewModel$handleIntent$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderDetailsViewModel$handleIntent$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OrderDetailsViewModel$handleIntent$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.u134_1.l134_1.vdf(this.v134_1.y131_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.u134_1.d10l(new ShowMessage_2('Reminder updated'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.n9_1 = 4;
              suspendResult = this.u134_1.d10l(new ShowMessage_2('Failed to update reminder'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(OrderDetailsViewModel$handleIntent$slambda_1).q24 = function ($this$launch, completion) {
    var i = new OrderDetailsViewModel$handleIntent$slambda_1(this.u134_1, this.v134_1, completion);
    i.w134_1 = $this$launch;
    return i;
  };
  function OrderDetailsViewModel$handleIntent$slambda_2(this$0, $intent, resultContinuation) {
    var i = new OrderDetailsViewModel$handleIntent$slambda_1(this$0, $intent, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function OrderDetailsViewModel$handleIntent$lambda_1($this$updateState) {
    return $this$updateState.u131(VOID, true);
  }
  function OrderDetailsViewModel$handleIntent$lambda_2($this$updateState) {
    return $this$updateState.u131($this$updateState.p131_1.jzd(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, OrderStatus_RETURN_REQUESTED_getInstance()));
  }
  function OrderDetailsViewModel$handleIntent$lambda_3($this$updateState) {
    return $this$updateState.u131(VOID, false);
  }
  function $handleIntentCOROUTINE$_11(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f135_1 = _this__u8e3s4;
    this.g135_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_11).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 25;
            var tmp0_subject = this.g135_1;
            if (tmp0_subject instanceof ReAddToCart) {
              this.h135_1 = this.g135_1.v131_1.fyw_1;
              this.j135_1 = this.g135_1.v131_1.gyw_1;
              this.f135_1.x10k(OrderDetailsViewModel$handleIntent$lambda(this.h135_1));
              this.n9_1 = 11;
              continue $sm;
            } else {
              if (tmp0_subject instanceof ToggleFavorite_0) {
                var tmp_0 = this;
                var tmp_1 = get_viewModelScope(this.f135_1);
                tmp_0.i135_1 = launch(tmp_1, VOID, VOID, OrderDetailsViewModel$handleIntent$slambda_0(this.f135_1, this.g135_1, null));
                this.n9_1 = 23;
                continue $sm;
              } else {
                if (tmp0_subject instanceof ToggleStockReminder) {
                  var tmp_2 = this;
                  var tmp_3 = get_viewModelScope(this.f135_1);
                  tmp_2.i135_1 = launch(tmp_3, VOID, VOID, OrderDetailsViewModel$handleIntent$slambda_2(this.f135_1, this.g135_1, null));
                  this.n9_1 = 23;
                  continue $sm;
                } else {
                  if (tmp0_subject instanceof RequestReturn) {
                    if (!this.f135_1.i134_1.ynu()) {
                      this.n9_1 = 10;
                      suspendResult = this.f135_1.d10l(new ShowMessage_2('No internet connection'), this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      this.n9_1 = 1;
                      continue $sm;
                    }
                  } else {
                    var tmp_4 = this;
                    noWhenBranchMatchedException();
                  }
                }
              }
            }

            break;
          case 1:
            this.f135_1.x10k(OrderDetailsViewModel$handleIntent$lambda_1);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 9;
            this.o9_1 = 6;
            var currentOrder = this.f135_1.s10h().ajg().u1().p131_1;
            this.n9_1 = 3;
            var tmp5_elvis_lhs = currentOrder.lzc_1;
            suspendResult = this.f135_1.h134_1.r102(tmp5_elvis_lhs == null ? new Long(0, 0) : tmp5_elvis_lhs, this.g135_1.w131_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.f135_1.x10k(OrderDetailsViewModel$handleIntent$lambda_2);
            this.n9_1 = 4;
            suspendResult = this.f135_1.d10l(new ShowMessage_2('Return request submitted'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.n9_1 = 5;
            suspendResult = this.f135_1.d10l(NavigateBack_instance_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.o9_1 = 25;
            this.n9_1 = 8;
            continue $sm;
          case 6:
            this.o9_1 = 9;
            var tmp_5 = this.q9_1;
            if (tmp_5 instanceof Exception) {
              var e = this.q9_1;
              this.n9_1 = 7;
              var tmp6_elvis_lhs = e.message;
              suspendResult = this.f135_1.d10l(new ShowMessage_2(tmp6_elvis_lhs == null ? 'Failed to submit return request' : tmp6_elvis_lhs), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 7:
            this.o9_1 = 25;
            this.n9_1 = 8;
            continue $sm;
          case 8:
            this.o9_1 = 25;
            var tmp_6 = this;
            this.f135_1.x10k(OrderDetailsViewModel$handleIntent$lambda_3);
            tmp_6.i135_1 = Unit_instance;
            this.n9_1 = 23;
            continue $sm;
          case 9:
            this.o9_1 = 25;
            var t = this.q9_1;
            this.f135_1.x10k(OrderDetailsViewModel$handleIntent$lambda_3);
            throw t;
          case 10:
            return Unit_instance;
          case 11:
            this.n9_1 = 12;
            continue $sm;
          case 12:
            this.o9_1 = 24;
            this.o9_1 = 20;
            if (!(this.j135_1 == null)) {
              this.n9_1 = 13;
              suspendResult = this.f135_1.j134_1.o105(this.j135_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 15;
              continue $sm;
            }

          case 13:
            var product = suspendResult;
            var tmp_7;
            if (!(product == null)) {
              var tmp3_elvis_lhs = product.wzt_1;
              tmp_7 = (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) <= 0;
            } else {
              tmp_7 = false;
            }

            if (tmp_7) {
              var tmp_8;
              if (this.f135_1.s10h().ajg().u1().r131_1 === 'en') {
                var tmp1_elvis_lhs = product.ozt_1;
                tmp_8 = tmp1_elvis_lhs == null ? 'Product' : tmp1_elvis_lhs;
              } else {
                var tmp2_elvis_lhs = product.pzt_1;
                tmp_8 = tmp2_elvis_lhs == null ? '\u0645\u0646\u062A\u062C' : tmp2_elvis_lhs;
              }
              var productName = tmp_8;
              this.n9_1 = 18;
              suspendResult = this.f135_1.d10l(new ShowStockDialog(this.j135_1, productName), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 14;
              continue $sm;
            }

          case 14:
            this.n9_1 = 15;
            continue $sm;
          case 15:
            var newItem = this.g135_1.v131_1.jyy(randomUUID());
            this.n9_1 = 16;
            suspendResult = this.f135_1.f134_1.c103(newItem, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 16:
            this.n9_1 = 17;
            suspendResult = this.f135_1.d10l(new ShowMessage_2('Added to cart'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 17:
            this.o9_1 = 25;
            this.n9_1 = 22;
            continue $sm;
          case 18:
            this.o9_1 = 25;
            this.n9_1 = 19;
            continue $sm;
          case 19:
            this.o9_1 = 25;
            this.f135_1.x10k(OrderDetailsViewModel$handleIntent$lambda_0(this.h135_1));
            return Unit_instance;
          case 20:
            this.o9_1 = 24;
            var tmp_9 = this.q9_1;
            if (tmp_9 instanceof Exception) {
              var e_0 = this.q9_1;
              this.n9_1 = 21;
              var tmp4_elvis_lhs = e_0.message;
              suspendResult = this.f135_1.d10l(new ShowMessage_2(tmp4_elvis_lhs == null ? 'Failed to add to cart' : tmp4_elvis_lhs), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 21:
            this.o9_1 = 25;
            this.n9_1 = 22;
            continue $sm;
          case 22:
            this.o9_1 = 25;
            var tmp_10 = this;
            this.f135_1.x10k(OrderDetailsViewModel$handleIntent$lambda_0(this.h135_1));
            tmp_10.i135_1 = Unit_instance;
            this.n9_1 = 23;
            continue $sm;
          case 23:
            return Unit_instance;
          case 24:
            this.o9_1 = 25;
            var t_0 = this.q9_1;
            this.f135_1.x10k(OrderDetailsViewModel$handleIntent$lambda_0(this.h135_1));
            throw t_0;
          case 25:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 25) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  function OrderDetailsViewModel(initialOrder, addToCartUseCase, getLanguageUseCase, requestReturnUseCase, isConnectedUseCase, getProductByIdUseCase, toggleFavoriteUseCase, toggleStockReminderUseCase) {
    BaseMviViewModel.call(this, new OrderDetailsState(initialOrder, VOID, getLanguageUseCase.ynu()));
    this.f134_1 = addToCartUseCase;
    this.g134_1 = getLanguageUseCase;
    this.h134_1 = requestReturnUseCase;
    this.i134_1 = isConnectedUseCase;
    this.j134_1 = getProductByIdUseCase;
    this.k134_1 = toggleFavoriteUseCase;
    this.l134_1 = toggleStockReminderUseCase;
  }
  protoOf(OrderDetailsViewModel).k135 = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_11(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderDetailsViewModel).f10l = function (intent, $completion) {
    return this.k135(isInterface(intent, OrderDetailsIntent) ? intent : THROW_CCE(), $completion);
  };
  var client_fstech_hadaya_presentation_order_history_OrderHistoryState$stable;
  var client_fstech_hadaya_presentation_order_history_OrderHistoryIntent_LoadOrders$stable;
  var client_fstech_hadaya_presentation_order_history_OrderHistoryIntent_FilterChanged$stable;
  var client_fstech_hadaya_presentation_order_history_OrderHistorySideEffect_ShowError$stable;
  function OrderHistoryState(isLoading, orders, filteredOrders, selectedFilter, error) {
    isLoading = isLoading === VOID ? false : isLoading;
    orders = orders === VOID ? emptyList() : orders;
    filteredOrders = filteredOrders === VOID ? emptyList() : filteredOrders;
    selectedFilter = selectedFilter === VOID ? OrderFilter_ALL_getInstance() : selectedFilter;
    error = error === VOID ? null : error;
    this.l135_1 = isLoading;
    this.m135_1 = orders;
    this.n135_1 = filteredOrders;
    this.o135_1 = selectedFilter;
    this.p135_1 = error;
  }
  protoOf(OrderHistoryState).q135 = function (isLoading, orders, filteredOrders, selectedFilter, error) {
    return new OrderHistoryState(isLoading, orders, filteredOrders, selectedFilter, error);
  };
  protoOf(OrderHistoryState).r135 = function (isLoading, orders, filteredOrders, selectedFilter, error, $super) {
    isLoading = isLoading === VOID ? this.l135_1 : isLoading;
    orders = orders === VOID ? this.m135_1 : orders;
    filteredOrders = filteredOrders === VOID ? this.n135_1 : filteredOrders;
    selectedFilter = selectedFilter === VOID ? this.o135_1 : selectedFilter;
    error = error === VOID ? this.p135_1 : error;
    return $super === VOID ? this.q135(isLoading, orders, filteredOrders, selectedFilter, error) : $super.q135.call(this, isLoading, orders, filteredOrders, selectedFilter, error);
  };
  protoOf(OrderHistoryState).toString = function () {
    return 'OrderHistoryState(isLoading=' + this.l135_1 + ', orders=' + toString(this.m135_1) + ', filteredOrders=' + toString(this.n135_1) + ', selectedFilter=' + this.o135_1.toString() + ', error=' + this.p135_1 + ')';
  };
  protoOf(OrderHistoryState).hashCode = function () {
    var result = getBooleanHashCode(this.l135_1);
    result = imul(result, 31) + hashCode(this.m135_1) | 0;
    result = imul(result, 31) + hashCode(this.n135_1) | 0;
    result = imul(result, 31) + this.o135_1.hashCode() | 0;
    result = imul(result, 31) + (this.p135_1 == null ? 0 : getStringHashCode(this.p135_1)) | 0;
    return result;
  };
  protoOf(OrderHistoryState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrderHistoryState))
      return false;
    if (!(this.l135_1 === other.l135_1))
      return false;
    if (!equals(this.m135_1, other.m135_1))
      return false;
    if (!equals(this.n135_1, other.n135_1))
      return false;
    if (!this.o135_1.equals(other.o135_1))
      return false;
    if (!(this.p135_1 == other.p135_1))
      return false;
    return true;
  };
  function LoadOrders() {
  }
  protoOf(LoadOrders).toString = function () {
    return 'LoadOrders';
  };
  protoOf(LoadOrders).hashCode = function () {
    return 2074813952;
  };
  protoOf(LoadOrders).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadOrders))
      return false;
    return true;
  };
  var LoadOrders_instance;
  function LoadOrders_getInstance() {
    return LoadOrders_instance;
  }
  function FilterChanged(filter) {
    this.s135_1 = filter;
  }
  protoOf(FilterChanged).toString = function () {
    return 'FilterChanged(filter=' + this.s135_1.toString() + ')';
  };
  protoOf(FilterChanged).hashCode = function () {
    return this.s135_1.hashCode();
  };
  protoOf(FilterChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FilterChanged))
      return false;
    if (!this.s135_1.equals(other.s135_1))
      return false;
    return true;
  };
  function OrderHistoryIntent() {
  }
  function ShowError_5(message) {
    this.t135_1 = message;
  }
  protoOf(ShowError_5).toString = function () {
    return 'ShowError(message=' + this.t135_1 + ')';
  };
  protoOf(ShowError_5).hashCode = function () {
    return getStringHashCode(this.t135_1);
  };
  protoOf(ShowError_5).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowError_5))
      return false;
    if (!(this.t135_1 === other.t135_1))
      return false;
    return true;
  };
  function OrderHistorySideEffect() {
  }
  var OrderFilter_ALL_instance;
  var OrderFilter_ORDERS_instance;
  var OrderFilter_RETURNS_instance;
  function values_6() {
    return [OrderFilter_ALL_getInstance(), OrderFilter_ORDERS_getInstance(), OrderFilter_RETURNS_getInstance()];
  }
  function get_entries_1() {
    if ($ENTRIES_1 == null)
      $ENTRIES_1 = enumEntries(values_6());
    return $ENTRIES_1;
  }
  var OrderFilter_entriesInitialized;
  function OrderFilter_initEntries() {
    if (OrderFilter_entriesInitialized)
      return Unit_instance;
    OrderFilter_entriesInitialized = true;
    OrderFilter_ALL_instance = new OrderFilter('ALL', 0);
    OrderFilter_ORDERS_instance = new OrderFilter('ORDERS', 1);
    OrderFilter_RETURNS_instance = new OrderFilter('RETURNS', 2);
  }
  var $ENTRIES_1;
  function OrderFilter(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function OrderFilter_ALL_getInstance() {
    OrderFilter_initEntries();
    return OrderFilter_ALL_instance;
  }
  function OrderFilter_ORDERS_getInstance() {
    OrderFilter_initEntries();
    return OrderFilter_ORDERS_instance;
  }
  function OrderFilter_RETURNS_getInstance() {
    OrderFilter_initEntries();
    return OrderFilter_RETURNS_instance;
  }
  function OrderHistoryScreen(onBack, onNavigateToOrderDetails, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(577933996);
    sourceInformation($composer_0, 'C(OrderHistoryScreen)59@2614L15,60@2673L16,61@2718L32,63@2824L7,64@2869L404,64@2836L437,76@3305L220,76@3279L246,84@3531L4275:OrderHistoryScreen.kt#47ti7r');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToOrderDetails) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(577933996, $dirty, -1, 'client.fstech.hadaya.presentation.order_history.OrderHistoryScreen (OrderHistoryScreen.kt:58)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(OrderHistoryViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, 1343796844, 'CC(remember):OrderHistoryScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance().f30_1) {
        var value = new SnackbarHostState();
        this_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp0_group;
      var tmp0_0 = get_LocalLifecycleOwner();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_2 = $composer_0;
      var lifecycleOwner = $composer_2.u31(tmp0_0);
      sourceInformationMarkerStart($composer_0, 1343802048, 'CC(remember):OrderHistoryScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_0.q31(viewModel) | $composer_0.q31(lifecycleOwner));
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_1.i31();
      var tmp_2;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = OrderHistoryScreen$lambda_0(lifecycleOwner, viewModel);
        tmp0_1.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      DisposableEffect(lifecycleOwner, tmp1_group, $composer_0, 0);
      sourceInformationMarkerStart($composer_0, 1343815816, 'CC(remember):OrderHistoryScreen.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_2.i31();
      var tmp_3;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = OrderHistoryScreen$slambda_0(viewModel, snackbarHostState, null);
        tmp0_2.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp2_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp2_group, $composer_0, 0);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = fillMaxSize(Companion_instance);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_3 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_4 = $composer_3;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_4, 0).hashCode();
      var localMap = $composer_4.t31();
      var materialized = materialize($composer_4, modifier_0);
      var tmp0_3 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_5 = $composer_4;
      var tmp_4 = $composer_5.g30();
      if (!isInterface(tmp_4, Applier)) {
        invalidApplier();
      }
      $composer_5.b31();
      if ($composer_5.h30()) {
        $composer_5.c31(tmp0_3);
      } else {
        $composer_5.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_5);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_6 = $composer_5;
      var $composer_7 = $composer_6;
      sourceInformationMarkerStart($composer_7, -803536347, 'C85@3580L4062,166@7656L140:OrderHistoryScreen.kt#47ti7r');
      var tmp_5 = BoxScopeInstance_instance.udr(fillMaxSize(Companion_instance), Companion_getInstance_11().l8t_1);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$21 = _Dp___init__impl__ms3zkb(1000);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = widthIn(tmp_5, VOID, tmp$ret$21);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_8 = $composer_7;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_8, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_9 = $composer_8;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_9, 0).hashCode();
      var localMap_0 = $composer_9.t31();
      var materialized_0 = materialize($composer_9, modifier_2);
      var tmp0_4 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_10 = $composer_9;
      var tmp_6 = $composer_10.g30();
      if (!isInterface(tmp_6, Applier)) {
        invalidApplier();
      }
      $composer_10.b31();
      if ($composer_10.h30()) {
        $composer_10.c31(tmp0_4);
      } else {
        $composer_10.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_10);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_11 = $composer_10;
      var $composer_12 = $composer_11;
      sourceInformationMarkerStart($composer_12, -909791891, 'C88@3812L356,86@3686L553:OrderHistoryScreen.kt#47ti7r');
      var tmp_7 = ComposableSingletons$OrderHistoryScreenKt_getInstance().u135_1;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(2020387830, true, OrderHistoryScreen$lambda_1(onBack), $composer_12, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_13 = $composer_12;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_13.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_2 = $composer_13.i31();
      var tmp_8;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_13.j31(value_2);
        tmp_8 = value_2;
      } else {
        tmp_8 = it_2;
      }
      var tmp_9 = tmp_8;
      var tmp_10 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_11 = WindowInsets(0, 0, 0, 0);
      TopAppBar(tmp_7, null, tmp_9, null, tmp_10, tmp_11, null, null, $composer_12, 390, 218);
      if (OrderHistoryScreen$lambda(state$delegate).l135_1 && OrderHistoryScreen$lambda(state$delegate).m135_1.r()) {
        $composer_12.m30(-909299922);
        sourceInformation($composer_12, '102@4318L132');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = fillMaxSize(Companion_instance);
        var contentAlignment_0 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_0 = false;
        var $composer_14 = $composer_12;
        if (!((4 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_15 = $composer_14;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_15, 0).hashCode();
        var localMap_1 = $composer_15.t31();
        var materialized_1 = materialize($composer_15, modifier_4);
        var tmp0_5 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_16 = $composer_15;
        var tmp_12 = $composer_16.g30();
        if (!isInterface(tmp_12, Applier)) {
          invalidApplier();
        }
        $composer_16.b31();
        if ($composer_16.h30()) {
          $composer_16.c31(tmp0_5);
        } else {
          $composer_16.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_16);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_17 = $composer_16;
        var $composer_18 = $composer_17;
        sourceInformationMarkerStart($composer_18, -898944647, 'C103@4405L27:OrderHistoryScreen.kt#47ti7r');
        var tmp_13 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_14 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_15 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_16 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_13, tmp_14, tmp_15, tmp_16, _Dp___init__impl__ms3zkb(0.0), $composer_18, 0, 63);
        sourceInformationMarkerEnd($composer_18);
        $composer_16.e31();
        $composer_12.n30();
      } else {
        $composer_12.m30(-909038468);
        sourceInformation($composer_12, '106@4488L3122');
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_5 = fillMaxSize(Companion_instance);
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = null;
        var $composer_19 = $composer_12;
        if (!((6 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_2 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_19, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_20 = $composer_19;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_20, 0).hashCode();
        var localMap_2 = $composer_20.t31();
        var materialized_2 = materialize($composer_20, modifier_6);
        var tmp0_6 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_21 = $composer_20;
        var tmp_17 = $composer_21.g30();
        if (!isInterface(tmp_17, Applier)) {
          invalidApplier();
        }
        $composer_21.b31();
        if ($composer_21.h30()) {
          $composer_21.c31(tmp0_6);
        } else {
          $composer_21.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_21);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_22 = $composer_21;
        var $composer_23 = $composer_22;
        sourceInformationMarkerStart($composer_23, -1062683819, 'C110@4771L11,112@4859L1390,107@4556L1693:OrderHistoryScreen.kt#47ti7r');
        var tmp_18 = OrderHistoryScreen$lambda(state$delegate).o135_1.a1_1;
        var tmp_19 = Companion_getInstance_14().t6b_1;
        var tmp_20 = MaterialTheme_instance.unz($composer_23, 6).xnz_1;
        var tmp_21 = ComposableSingletons$OrderHistoryScreenKt_getInstance().w135_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-75602770, true, OrderHistoryScreen$lambda_2(viewModel, state$delegate), $composer_23, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_24 = $composer_23;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_24.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_3 = $composer_24.i31();
        var tmp_22;
        if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
          var value_3 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_24.j31(value_3);
          tmp_22 = value_3;
        } else {
          tmp_22 = it_3;
        }
        var tmp$ret$47 = tmp_22;
        SecondaryTabRow(tmp_18, null, tmp_19, tmp_20, null, tmp_21, tmp$ret$47, $composer_23, 1769856, 18);
        if (OrderHistoryScreen$lambda(state$delegate).n135_1.r() && !OrderHistoryScreen$lambda(state$delegate).l135_1) {
          $composer_23.m30(-1061009169);
          sourceInformation($composer_23, '138@6361L197');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_7 = fillMaxSize(Companion_instance);
          var contentAlignment_1 = Companion_getInstance_11().o8t_1;
          var propagateMinConstraints_1 = false;
          var $composer_25 = $composer_23;
          if (!((4 & 1) === 0))
            modifier_7 = Companion_instance;
          if (!((4 & 2) === 0))
            contentAlignment_1 = Companion_getInstance_11().k8t_1;
          if (!((4 & 4) === 0))
            propagateMinConstraints_1 = false;
          var measurePolicy_3 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_8 = modifier_7;
          var $composer_26 = $composer_25;
          if (!((0 & 2) === 0))
            modifier_8 = Companion_instance;
          var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_26, 0).hashCode();
          var localMap_3 = $composer_26.t31();
          var materialized_3 = materialize($composer_26, modifier_8);
          var tmp0_7 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_27 = $composer_26;
          var tmp_23 = $composer_27.g30();
          if (!isInterface(tmp_23, Applier)) {
            invalidApplier();
          }
          $composer_27.b31();
          if ($composer_27.h30()) {
            $composer_27.c31(tmp0_7);
          } else {
            $composer_27.d31();
          }
          var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_27);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
          var $composer_28 = $composer_27;
          var $composer_29 = $composer_28;
          sourceInformationMarkerStart($composer_29, 1886905098, 'C139@6465L42,139@6460L68:OrderHistoryScreen.kt#47ti7r');
          var tmp_24 = stringResource(get_no_orders_found(string_instance), $composer_29, 0);
          var tmp_25 = Companion_getInstance_14().k6b_1;
          var tmp_26 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_27 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_28 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_29 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_24, null, tmp_25, null, tmp_26, null, null, null, tmp_27, null, null, tmp_28, tmp_29, false, 0, 0, null, null, $composer_29, 384, 0, 262138);
          sourceInformationMarkerEnd($composer_29);
          $composer_27.e31();
          $composer_23.n30();
        } else {
          $composer_23.m30(-1060729146);
          sourceInformation($composer_23, '151@7109L453,142@6620L942');
          var tmp_30 = fillMaxSize(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp0_start = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp1_end = _Dp___init__impl__ms3zkb(16);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp2_top = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp3_bottom = _Dp___init__impl__ms3zkb(16);
          var tmp_31 = PaddingValues(tmp0_start, tmp2_top, tmp1_end, tmp3_bottom);
          var tmp_32 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$64 = _Dp___init__impl__ms3zkb(12);
          var tmp_33 = tmp_32.mdq(tmp$ret$64);
          sourceInformationMarkerStart($composer_23, 1351272315, 'CC(remember):OrderHistoryScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_3 = !!($composer_0.k31(state$delegate) | ($dirty & 112) === 32);
          // Inline function 'kotlin.let' call
          var it_4 = $composer_23.i31();
          var tmp_34;
          if (invalid_3 || it_4 === Companion_getInstance().f30_1) {
            var value_4 = OrderHistoryScreen$lambda_3(state$delegate, onNavigateToOrderDetails);
            $composer_23.j31(value_4);
            tmp_34 = value_4;
          } else {
            tmp_34 = it_4;
          }
          var tmp0_group_0 = tmp_34;
          sourceInformationMarkerEnd($composer_23);
          LazyColumn(tmp_30, null, tmp_31, false, tmp_33, null, null, false, null, tmp0_group_0, $composer_23, 24582, 490);
          $composer_23.n30();
        }
        sourceInformationMarkerEnd($composer_23);
        $composer_21.e31();
        $composer_12.n30();
      }
      sourceInformationMarkerEnd($composer_12);
      $composer_10.e31();
      var tmp_35 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(snackbarHostState, tmp_35, null, $composer_7, 6, 4);
      sourceInformationMarkerEnd($composer_7);
      $composer_5.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp3_safe_receiver = $composer_0.t30();
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.p3c(OrderHistoryScreen$lambda_4(onBack, onNavigateToOrderDetails, $changed));
    }
  }
  function ComposableSingletons$OrderHistoryScreenKt$lambda$_1875073036$lambda_syl9zf($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C87@3728L46,87@3723L52:OrderHistoryScreen.kt#47ti7r');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1875073036, $changed, -1, 'client.fstech.hadaya.presentation.order_history.ComposableSingletons$OrderHistoryScreenKt.lambda$-1875073036.<anonymous> (OrderHistoryScreen.kt:87)');
      }
      var tmp = stringResource(get_order_history_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderHistoryScreenKt$lambda$1015478420$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C92@4009L93,90@3889L239:OrderHistoryScreen.kt#47ti7r');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1015478420, $changed, -1, 'client.fstech.hadaya.presentation.order_history.ComposableSingletons$OrderHistoryScreenKt.lambda$1015478420.<anonymous> (OrderHistoryScreen.kt:90)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderHistoryScreenKt$lambda$_1901238547$lambda_7hgfvt($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C:OrderHistoryScreen.kt#47ti7r');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1901238547, $changed, -1, 'client.fstech.hadaya.presentation.order_history.ComposableSingletons$OrderHistoryScreenKt.lambda$-1901238547.<anonymous> (OrderHistoryScreen.kt:111)');
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$OrderHistoryScreenKt() {
    ComposableSingletons$OrderHistoryScreenKt_instance = this;
    var tmp = this;
    tmp.u135_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1875073036, false, ComposableSingletons$OrderHistoryScreenKt$lambda$_1875073036$lambda_syl9zf));
    var tmp_0 = this;
    tmp_0.v135_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1015478420, false, ComposableSingletons$OrderHistoryScreenKt$lambda$1015478420$lambda));
    var tmp_1 = this;
    tmp_1.w135_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1901238547, false, ComposableSingletons$OrderHistoryScreenKt$lambda$_1901238547$lambda_7hgfvt));
  }
  var ComposableSingletons$OrderHistoryScreenKt_instance;
  function ComposableSingletons$OrderHistoryScreenKt_getInstance() {
    if (ComposableSingletons$OrderHistoryScreenKt_instance == null)
      new ComposableSingletons$OrderHistoryScreenKt();
    return ComposableSingletons$OrderHistoryScreenKt_instance;
  }
  function OrderHistoryItem(order, onClick, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1531086536);
    sourceInformation($composer_0, 'C(OrderHistoryItem)P(1)182@8090L11,182@8048L69,183@8124L2232,178@7898L2458:OrderHistoryScreen.kt#47ti7r');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(order) : $composer_0.q31(order)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1531086536, $dirty, -1, 'client.fstech.hadaya.presentation.order_history.OrderHistoryItem (OrderHistoryScreen.kt:177)');
      }
      var tmp0_modifier = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
      var tmp1_shape = RoundedCornerShape(tmp$ret$0);
      var tmp = CardDefaults_instance;
      var tmp_0 = MaterialTheme_instance.unz($composer_0, 6).oo0_1;
      var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp2_colors = tmp.loh(tmp_0, tmp_1, tmp_2, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 14);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1278029261, true, OrderHistoryItem$lambda(order), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_3;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref_6(dispatchReceiver);
        $composer_1.j31(value);
        tmp_3 = value;
      } else {
        tmp_3 = it;
      }
      var tmp$ret$1 = tmp_3;
      Card_0(onClick, tmp0_modifier, false, tmp1_shape, tmp2_colors, null, null, null, tmp$ret$1, $composer_0, 100663344 | 14 & $dirty >> 3, 228);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(OrderHistoryItem$lambda_0(order, onClick, $changed));
    }
  }
  function OrderStatusBadge(status, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(613370584);
    sourceInformation($composer_0, 'C(OrderStatusBadge)276@12065L264,272@11875L454:OrderHistoryScreen.kt#47ti7r');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.m31(status.a1_1) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(613370584, $dirty, -1, 'client.fstech.hadaya.presentation.order_history.OrderStatusBadge (OrderHistoryScreen.kt:245)');
      }
      var tmp;
      switch (status.a1_1) {
        case 0:
          tmp = Color(new Long(-14575885, 0));
          break;
        case 1:
          tmp = Color(new Long(-26624, 0));
          break;
        case 2:
          tmp = Color(new Long(-6543440, 0));
          break;
        case 3:
          tmp = Color(new Long(-769226, 0));
          break;
        case 4:
          tmp = Color(new Long(-11751600, 0));
          break;
        case 5:
          tmp = Color(new Long(-1499549, 0));
          break;
        case 6:
          tmp = Color(new Long(-10011977, 0));
          break;
        case 7:
          tmp = Color(new Long(-9079435, 0));
          break;
        case 8:
          tmp = Color(new Long(-16738680, 0));
          break;
        case 9:
          tmp = Companion_getInstance_14().k6b_1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var color = tmp;
      var tmp_0;
      switch (status.a1_1) {
        case 0:
          $composer_0.m30(1038633096);
          sourceInformation($composer_0, '260@11040L48');
          var tmp0_group = stringResource(get_order_status_received(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp0_group;
          break;
        case 1:
          $composer_0.m30(1038635721);
          sourceInformation($composer_0, '261@11122L49');
          var tmp1_group = stringResource(get_order_status_preparing(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp1_group;
          break;
        case 2:
          $composer_0.m30(1038638410);
          sourceInformation($composer_0, '262@11206L50');
          var tmp2_group = stringResource(get_order_status_on_the_way(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp2_group;
          break;
        case 3:
          $composer_0.m30(1038640998);
          sourceInformation($composer_0, '263@11287L46');
          var tmp3_group = stringResource(get_order_status_failed(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp3_group;
          break;
        case 4:
          $composer_0.m30(1038643561);
          sourceInformation($composer_0, '264@11367L49');
          var tmp4_group = stringResource(get_order_status_completed(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp4_group;
          break;
        case 5:
          $composer_0.m30(1038646448);
          sourceInformation($composer_0, '265@11457L56');
          var tmp5_group = stringResource(get_order_status_return_requested(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp5_group;
          break;
        case 6:
          $composer_0.m30(1038649519);
          sourceInformation($composer_0, '266@11553L55');
          var tmp6_group = stringResource(get_order_status_return_delivery(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp6_group;
          break;
        case 7:
          $composer_0.m30(1038652328);
          sourceInformation($composer_0, '267@11641L48');
          var tmp7_group = stringResource(get_order_status_returned(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp7_group;
          break;
        case 8:
          $composer_0.m30(1038655118);
          sourceInformation($composer_0, '268@11728L54');
          var tmp8_group = stringResource(get_order_status_money_returned(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp8_group;
          break;
        case 9:
          $composer_0.m30(1038657896);
          sourceInformation($composer_0, '269@11815L48');
          var tmp9_group = stringResource(get_order_status_archived(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp9_group;
          break;
        default:
          $composer_0.m30(1038632389);
          $composer_0.n30();
          noWhenBranchMatchedException();
          break;
      }
      var statusText = tmp_0;
      var tmp2_color = Color__copy$default_impl_ectz3s(color, 0.1);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
      var tmp3_shape = RoundedCornerShape(tmp$ret$0);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(1);
      var tmp4_border = BorderStroke(tmp$ret$1, Color__copy$default_impl_ectz3s(color, 0.5));
      var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_2 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1209161507, true, OrderStatusBadge$lambda(statusText, color), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_4;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value);
        tmp_4 = value;
      } else {
        tmp_4 = it;
      }
      var tmp$ret$2 = tmp_4;
      Surface(null, tmp3_shape, tmp2_color, tmp_1, tmp_2, tmp_3, tmp4_border, tmp$ret$2, $composer_0, 12582912, 57);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp10_safe_receiver = $composer_0.t30();
    if (tmp10_safe_receiver == null)
      null;
    else {
      tmp10_safe_receiver.p3c(OrderStatusBadge$lambda_0(status, $changed));
    }
  }
  function OrderHistoryScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function sam$androidx_lifecycle_LifecycleEventObserver$0(function_0) {
    this.x135_1 = function_0;
  }
  protoOf(sam$androidx_lifecycle_LifecycleEventObserver$0).j70 = function (source, event) {
    return this.x135_1(source, event);
  };
  protoOf(sam$androidx_lifecycle_LifecycleEventObserver$0).q3 = function () {
    return this.x135_1;
  };
  protoOf(sam$androidx_lifecycle_LifecycleEventObserver$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, LifecycleEventObserver) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_lifecycle_LifecycleEventObserver$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function OrderHistoryScreen$lambda$lambda($viewModel) {
    return function (_unused_var__etf5q3, event) {
      var tmp;
      if (event.equals(Event_ON_RESUME_getInstance())) {
        $viewModel.s10h().j10i(LoadOrders_instance);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderHistoryScreen$$inlined$cache$1$2($lifecycleOwner, $observer) {
    this.y135_1 = $lifecycleOwner;
    this.z135_1 = $observer;
  }
  protoOf(OrderHistoryScreen$$inlined$cache$1$2).s1d = function () {
    this.y135_1.w7m().u70(this.z135_1);
  };
  function OrderHistoryScreen$lambda_0($lifecycleOwner, $viewModel) {
    return function ($this$DisposableEffect) {
      var tmp = OrderHistoryScreen$lambda$lambda($viewModel);
      var observer = new sam$androidx_lifecycle_LifecycleEventObserver$0(tmp);
      $lifecycleOwner.w7m().t70(observer);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new OrderHistoryScreen$$inlined$cache$1$2($lifecycleOwner, observer);
    };
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_19(function_0) {
    this.a136_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_19).a1v = function (value, $completion) {
    return this.a136_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_19).q3 = function () {
    return this.a136_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_19).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_19).hashCode = function () {
    return hashCode(this.q3());
  };
  function OrderHistoryScreen$slambda$slambda($snackbarHostState, resultContinuation) {
    this.j136_1 = $snackbarHostState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OrderHistoryScreen$slambda$slambda).m136 = function (effect, $completion) {
    var tmp = this.n136(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderHistoryScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.m136((!(p1 == null) ? isInterface(p1, OrderHistorySideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OrderHistoryScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.k136_1 instanceof ShowError_5) {
              this.n9_1 = 1;
              suspendResult = this.j136_1.dqm(this.k136_1.t135_1, VOID, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_0 = this;
              noWhenBranchMatchedException();
            }

            break;
          case 1:
            this.l136_1 = suspendResult;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(OrderHistoryScreen$slambda$slambda).n136 = function (effect, completion) {
    var i = new OrderHistoryScreen$slambda$slambda(this.j136_1, completion);
    i.k136_1 = effect;
    return i;
  };
  function OrderHistoryScreen$slambda$slambda_0($snackbarHostState, resultContinuation) {
    var i = new OrderHistoryScreen$slambda$slambda($snackbarHostState, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.m136(effect, $completion);
    }, 1);
  }
  function OrderHistoryScreen$slambda($viewModel, $snackbarHostState, resultContinuation) {
    this.w136_1 = $viewModel;
    this.x136_1 = $snackbarHostState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OrderHistoryScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderHistoryScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OrderHistoryScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.w136_1.s10h().t10h();
            var tmp_1 = OrderHistoryScreen$slambda$slambda_0(this.x136_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_19(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(OrderHistoryScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new OrderHistoryScreen$slambda(this.w136_1, this.x136_1, completion);
    i.y136_1 = $this$LaunchedEffect;
    return i;
  };
  function OrderHistoryScreen$slambda_0($viewModel, $snackbarHostState, resultContinuation) {
    var i = new OrderHistoryScreen$slambda($viewModel, $snackbarHostState, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function OrderHistoryScreen$lambda_1($onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C89@3834L316:OrderHistoryScreen.kt#47ti7r');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2020387830, $changed, -1, 'client.fstech.hadaya.presentation.order_history.OrderHistoryScreen.<anonymous>.<anonymous>.<anonymous> (OrderHistoryScreen.kt:89)');
        }
        IconButton($onBack, null, false, null, null, null, ComposableSingletons$OrderHistoryScreenKt_getInstance().v135_1, $composer_0, 1572864, 62);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderHistoryScreen$lambda$lambda_0($viewModel, $filter) {
    return function () {
      $viewModel.s10h().j10i(new FilterChanged($filter));
      return Unit_instance;
    };
  }
  function OrderHistoryScreen$lambda$lambda_1($filter, $state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C124@5506L615:OrderHistoryScreen.kt#47ti7r');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-893053085, $changed, -1, 'client.fstech.hadaya.presentation.order_history.OrderHistoryScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (OrderHistoryScreen.kt:124)');
        }
        var tmp_0;
        switch ($filter.a1_1) {
          case 0:
            $composer_0.m30(769450152);
            sourceInformation($composer_0, '126@5639L37');
            var tmp0_group = stringResource(get_filter_all(string_instance), $composer_0, 0);
            $composer_0.n30();
            tmp_0 = tmp0_group;
            break;
          case 1:
            $composer_0.m30(769453611);
            sourceInformation($composer_0, '127@5747L40');
            var tmp1_group = stringResource(get_filter_orders(string_instance), $composer_0, 0);
            $composer_0.n30();
            tmp_0 = tmp1_group;
            break;
          case 2:
            $composer_0.m30(769457196);
            sourceInformation($composer_0, '128@5859L41');
            var tmp2_group = stringResource(get_filter_returns(string_instance), $composer_0, 0);
            $composer_0.n30();
            tmp_0 = tmp2_group;
            break;
          default:
            $composer_0.m30(769447849);
            $composer_0.n30();
            noWhenBranchMatchedException();
            break;
        }
        var tmp_1 = tmp_0;
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = OrderHistoryScreen$lambda($state$delegate).o135_1.equals($filter) ? Companion_getInstance_16().e7z_1 : Companion_getInstance_16().b7z_1;
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_1, null, tmp_2, null, tmp_3, null, tmp_4, null, tmp_5, null, null, tmp_6, tmp_7, false, 0, 0, null, null, $composer_0, 0, 0, 262078);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderHistoryScreen$lambda_2($viewModel, $state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C*116@5091L328,123@5464L695,114@4961L1232:OrderHistoryScreen.kt#47ti7r');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-75602770, $changed, -1, 'client.fstech.hadaya.presentation.order_history.OrderHistoryScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (OrderHistoryScreen.kt:113)');
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = get_entries_1().t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          var tmp_0 = OrderHistoryScreen$lambda($state$delegate).o135_1.equals(element);
          sourceInformationMarkerStart($composer_0, -1437208123, 'CC(remember):OrderHistoryScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = !!($composer_0.q31($viewModel) | $composer_0.m31(element.a1_1));
          // Inline function 'kotlin.let' call
          var it = $composer_0.i31();
          var tmp_1;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = OrderHistoryScreen$lambda$lambda_0($viewModel, element);
            $composer_0.j31(value);
            tmp_1 = value;
          } else {
            tmp_1 = it;
          }
          var tmp0_group = tmp_1;
          sourceInformationMarkerEnd($composer_0);
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-893053085, true, OrderHistoryScreen$lambda$lambda_1(element, $state$delegate), $composer_0, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_1 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = $composer_1.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_0 = $composer_1.i31();
          var tmp_2;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_1.j31(value_0);
            tmp_2 = value_0;
          } else {
            tmp_2 = it_0;
          }
          var tmp_3 = tmp_2;
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          Tab(tmp_0, tmp0_group, null, false, tmp_3, null, tmp_4, tmp_5, null, $composer_0, 24576, 492);
        }
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderHistoryScreen$lambda$lambda_2(it) {
    return null;
  }
  function OrderHistoryScreen$lambda$lambda_3($key, $items) {
    return function (index) {
      return $key($items.l1(index));
    };
  }
  function OrderHistoryScreen$lambda$lambda_4($contentType, $items) {
    return function (index) {
      return $contentType($items.l1(index));
    };
  }
  function OrderHistoryScreen$lambda$lambda$lambda($onNavigateToOrderDetails, $order) {
    return function () {
      $onNavigateToOrderDetails($order);
      return Unit_instance;
    };
  }
  function OrderHistoryScreen$lambda$lambda_5($items, $onNavigateToOrderDetails) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp2 = $items.l1(it);
        var $changed_0 = 14 & $dirty;
        var $composer_1 = $composer_0;
        $composer_1.m30(1751776534);
        sourceInformation($composer_1, 'C*155@7341L119,153@7218L280:OrderHistoryScreen.kt#47ti7r');
        sourceInformationMarkerStart($composer_1, 749249356, 'CC(remember):OrderHistoryScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_1.k31($onNavigateToOrderDetails) | (($changed_0 & 112 ^ 48) > 32 && $composer_1.q31(tmp2) || ($changed_0 & 48) === 32));
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_2;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = OrderHistoryScreen$lambda$lambda$lambda($onNavigateToOrderDetails, tmp2);
          $composer_1.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it_0;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_1);
        OrderHistoryItem(tmp2, tmp0_group, $composer_1, 14 & $changed_0 >> 3);
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderHistoryScreen$lambda_3($state$delegate, $onNavigateToOrderDetails) {
    return function ($this$LazyColumn) {
      // Inline function 'androidx.compose.foundation.lazy.items' call
      var items = OrderHistoryScreen$lambda($state$delegate).n135_1;
      var contentType = OrderHistoryScreen$lambda$lambda_2;
      var tmp = items.n1();
      var tmp_0;
      if (!(null == null)) {
        tmp_0 = OrderHistoryScreen$lambda$lambda_3(null, items);
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      var tmp_2 = OrderHistoryScreen$lambda$lambda_4(contentType, items);
      $this$LazyColumn.di9(tmp, tmp_1, tmp_2, ComposableLambda$invoke$ref_4(composableLambdaInstance(802480018, true, OrderHistoryScreen$lambda$lambda_5(items, $onNavigateToOrderDetails))));
      return Unit_instance;
    };
  }
  function OrderHistoryScreen$lambda_4($onBack, $onNavigateToOrderDetails, $$changed) {
    return function ($composer, $force) {
      OrderHistoryScreen($onBack, $onNavigateToOrderDetails, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function OrderHistoryItem$lambda($order) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C184@8134L2216:OrderHistoryScreen.kt#47ti7r');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1278029261, $changed, -1, 'client.fstech.hadaya.presentation.order_history.OrderHistoryItem.<anonymous> (OrderHistoryScreen.kt:184)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 914217441, 'C185@8191L578,201@8783L40,212@9294L10,208@9105L259,216@9378L41,218@9433L907:OrderHistoryScreen.kt#47ti7r');
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_1 = fillMaxWidth(Companion_instance);
        var horizontalArrangement = Arrangement_getInstance().wdp_1;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_6 = $composer_5;
        if (!((0 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_6, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_2 = $composer_8.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, -2040515728, 'C191@8442L151,190@8409L290,198@8716L39:OrderHistoryScreen.kt#47ti7r');
        var tmp_3 = get_order_id_prefix_pattern(string_instance);
        var tmp0_safe_receiver = $order.lzc_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
        var tmp2_text = stringResource_0(tmp_3, [tmp1_elvis_lhs == null ? 'N/A' : tmp1_elvis_lhs], $composer_10, 0);
        var tmp3_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp4_fontSize = get_sp(16);
        var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp2_text, null, tmp_4, null, tmp4_fontSize, null, tmp3_fontWeight, null, tmp_5, null, null, tmp_6, tmp_7, false, 0, 0, null, null, $composer_10, 1597440, 0, 262062);
        OrderStatusBadge($order.azd_1, $composer_10, 0);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_8 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$13 = _Dp___init__impl__ms3zkb(8);
        Spacer(height(tmp_8, tmp$ret$13), $composer_5, 6);
        var tmp0_safe_receiver_0 = $order.fzd_1;
        var tmp_9;
        if (tmp0_safe_receiver_0 == null) {
          tmp_9 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_9 = Companion_getInstance_19().kf(tmp0_safe_receiver_0);
        }
        var tmp1_elvis_lhs_0 = tmp_9;
        var instant = tmp1_elvis_lhs_0 == null ? Companion_getInstance_19().kf(new Long(0, 0)) : tmp1_elvis_lhs_0;
        var dateTime = toLocalDateTime(instant, Companion_getInstance_20().unp());
        var tmp2_text_0 = dateTime.xn9_1.toString() + ' ' + dateTime.hna() + ':' + padStart(dateTime.bna().toString(), 2, _Char___init__impl__6a9atx(48));
        var tmp3_style = MaterialTheme_instance.jog($composer_5, 6).qof_1;
        var tmp4_color = Companion_getInstance_14().k6b_1;
        var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_13 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp2_text_0, null, tmp4_color, null, tmp_10, null, null, null, tmp_11, null, null, tmp_12, tmp_13, false, 0, 0, null, tmp3_style, $composer_5, 384, 0, 131066);
        var tmp_14 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$16 = _Dp___init__impl__ms3zkb(12);
        Spacer(height(tmp_14, tmp$ret$16), $composer_5, 6);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_3 = fillMaxWidth(Companion_instance);
        var horizontalArrangement_0 = Arrangement_getInstance().wdp_1;
        var verticalAlignment_0 = null;
        var $composer_11 = $composer_5;
        if (!((4 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((4 & 2) === 0))
          horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
        if (!((4 & 4) === 0))
          verticalAlignment_0 = Companion_getInstance_11().t8t_1;
        var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_11, 14 & 54 >> 3 | 112 & 54 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_12 = $composer_11;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
        var localMap_1 = $composer_12.t31();
        var materialized_1 = materialize($composer_12, modifier_4);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_13 = $composer_12;
        var tmp_15 = $composer_13.g30();
        if (!isInterface(tmp_15, Applier)) {
          invalidApplier();
        }
        $composer_13.b31();
        if ($composer_13.h30()) {
          $composer_13.c31(tmp0_1);
        } else {
          $composer_13.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_14 = $composer_13;
        var $composer_15 = $composer_14;
        sourceInformationMarkerStart($composer_15, 561402814, 'C222@9587L473,234@10103L54,236@10251L11,233@10077L249:OrderHistoryScreen.kt#47ti7r');
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_5 = null;
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = null;
        var $composer_16 = $composer_15;
        if (!((7 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((7 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((7 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_2 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_16, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_17 = $composer_16;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
        var localMap_2 = $composer_17.t31();
        var materialized_2 = materialize($composer_17, modifier_6);
        var tmp0_2 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_18 = $composer_17;
        var tmp_16 = $composer_18.g30();
        if (!isInterface(tmp_16, Applier)) {
          invalidApplier();
        }
        $composer_18.b31();
        if ($composer_18.h30()) {
          $composer_18.c31(tmp0_2);
        } else {
          $composer_18.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_18);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_19 = $composer_18;
        var $composer_20 = $composer_19;
        sourceInformationMarkerStart($composer_20, 679709901, 'C224@9646L70,225@9764L10,223@9616L191,229@9955L10,227@9828L214:OrderHistoryScreen.kt#47ti7r');
        var tmp_17 = stringResource_0(get_order_items_count_pattern(string_instance), [$order.uzc_1.n1()], $composer_20, 0);
        var tmp_18 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_21 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_22 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_17, null, tmp_18, null, tmp_19, null, null, null, tmp_20, null, null, tmp_21, tmp_22, false, 0, 0, null, MaterialTheme_instance.jog($composer_20, 6).pof_1, $composer_20, 0, 0, 131070);
        var tmp0_text = replace($order.zzc_1.z_1, '_', ' ');
        var tmp1_style = MaterialTheme_instance.jog($composer_20, 6).tof_1;
        var tmp2_color = Companion_getInstance_14().k6b_1;
        var tmp_23 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_24 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_25 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_26 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp2_color, null, tmp_23, null, null, null, tmp_24, null, null, tmp_25, tmp_26, false, 0, 0, null, tmp1_style, $composer_20, 384, 0, 131066);
        sourceInformationMarkerEnd($composer_20);
        $composer_18.e31();
        var tmp0_text_0 = stringResource_0(get_price_egp(string_instance), [$order.yzc_1], $composer_15, 0);
        var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp2_color_0 = MaterialTheme_instance.unz($composer_15, 6).xnz_1;
        var tmp3_fontSize = get_sp(16);
        var tmp_27 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_28 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_29 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text_0, null, tmp2_color_0, null, tmp3_fontSize, null, tmp1_fontWeight, null, tmp_27, null, null, tmp_28, tmp_29, false, 0, 0, null, null, $composer_15, 1597440, 0, 262058);
        sourceInformationMarkerEnd($composer_15);
        $composer_13.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_30;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_30 = Unit_instance;
        }
        tmp = tmp_30;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderHistoryItem$lambda_0($order, $onClick, $$changed) {
    return function ($composer, $force) {
      OrderHistoryItem($order, $onClick, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function OrderStatusBadge$lambda($statusText, $color) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C280@12223L10,277@12075L248:OrderHistoryScreen.kt#47ti7r');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1209161507, $changed, -1, 'client.fstech.hadaya.presentation.order_history.OrderStatusBadge.<anonymous> (OrderHistoryScreen.kt:277)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_1 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(2);
        var tmp0_modifier = padding_2(tmp_0, tmp_1, tmp$ret$1);
        var tmp1_style = MaterialTheme_instance.jog($composer_0, 6).tof_1;
        var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text($statusText, tmp0_modifier, $color, null, tmp_2, null, tmp2_fontWeight, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, tmp1_style, $composer_0, 1572912, 0, 131000);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OrderStatusBadge$lambda_0($status, $$changed) {
    return function ($composer, $force) {
      OrderStatusBadge($status, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_order_history_OrderHistoryViewModel$stable;
  function applyFilter($this, orders, filter) {
    var tmp;
    switch (filter.a1_1) {
      case 0:
        tmp = orders;
        break;
      case 1:
        // Inline function 'kotlin.collections.filter' call

        // Inline function 'kotlin.collections.filterTo' call

        var destination = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s = orders.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          if (!element.azd_1.equals(OrderStatus_RETURN_REQUESTED_getInstance()) && !element.azd_1.equals(OrderStatus_RETURN_DELIVERY_getInstance()) && !element.azd_1.equals(OrderStatus_RETURNED_getInstance()) && !element.azd_1.equals(OrderStatus_MONEY_RETURNED_getInstance())) {
            destination.j1(element);
          }
        }

        tmp = destination;
        break;
      case 2:
        // Inline function 'kotlin.collections.filter' call

        // Inline function 'kotlin.collections.filterTo' call

        var destination_0 = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s_0 = orders.t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          if (element_0.azd_1.equals(OrderStatus_RETURN_REQUESTED_getInstance()) || element_0.azd_1.equals(OrderStatus_RETURN_DELIVERY_getInstance()) || element_0.azd_1.equals(OrderStatus_RETURNED_getInstance()) || element_0.azd_1.equals(OrderStatus_MONEY_RETURNED_getInstance())) {
            destination_0.j1(element_0);
          }
        }

        tmp = destination_0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function sam$kotlin_Comparator$0_0(function_0) {
    this.z136_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).ze = function (a, b) {
    return this.z136_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).q3 = function () {
    return this.z136_1;
  };
  protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function OrderHistoryViewModel$slambda(this$0, resultContinuation) {
    this.i137_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OrderHistoryViewModel$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderHistoryViewModel$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OrderHistoryViewModel$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.i137_1.q137(LoadOrders_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(OrderHistoryViewModel$slambda).q24 = function ($this$launch, completion) {
    var i = new OrderHistoryViewModel$slambda(this.i137_1, completion);
    i.j137_1 = $this$launch;
    return i;
  };
  function OrderHistoryViewModel$slambda_0(this$0, resultContinuation) {
    var i = new OrderHistoryViewModel$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function OrderHistoryViewModel$handleIntent$lambda($this$updateState) {
    return $this$updateState.r135(true, VOID, VOID, VOID, null);
  }
  function OrderHistoryViewModel$handleIntent$lambda_0(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = b.fzd_1;
    var tmp$ret$2 = a.fzd_1;
    return compareValues(tmp, tmp$ret$2);
  }
  function OrderHistoryViewModel$handleIntent$lambda_1($orders, this$0) {
    return function ($this$updateState) {
      return $this$updateState.r135(false, $orders, applyFilter(this$0, $orders, $this$updateState.o135_1));
    };
  }
  function OrderHistoryViewModel$handleIntent$lambda_2($this$updateState) {
    return $this$updateState.r135(false, VOID, VOID, VOID, 'User not logged in');
  }
  function OrderHistoryViewModel$handleIntent$lambda_3($e) {
    return function ($this$updateState) {
      var tmp0_elvis_lhs = $e.message;
      return $this$updateState.r135(false, VOID, VOID, VOID, tmp0_elvis_lhs == null ? 'Failed to load orders' : tmp0_elvis_lhs);
    };
  }
  function OrderHistoryViewModel$handleIntent$lambda_4($intent, this$0) {
    return function ($this$updateState) {
      var tmp0_selectedFilter = $intent.s135_1;
      var tmp1_filteredOrders = applyFilter(this$0, $this$updateState.m135_1, $intent.s135_1);
      return $this$updateState.r135(VOID, VOID, tmp1_filteredOrders, tmp0_selectedFilter);
    };
  }
  function $handleIntentCOROUTINE$_12(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z137_1 = _this__u8e3s4;
    this.a138_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_12).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            var tmp0_subject = this.a138_1;
            if (equals(tmp0_subject, LoadOrders_instance)) {
              this.z137_1.x10k(OrderHistoryViewModel$handleIntent$lambda);
              this.o9_1 = 3;
              var profile = this.z137_1.p137_1.ynu();
              if (!(profile == null)) {
                this.n9_1 = 1;
                suspendResult = this.z137_1.o137_1.f104(profile.uym_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.z137_1.x10k(OrderHistoryViewModel$handleIntent$lambda_2);
                this.n9_1 = 2;
                continue $sm;
              }
            } else {
              if (tmp0_subject instanceof FilterChanged) {
                this.z137_1.x10k(OrderHistoryViewModel$handleIntent$lambda_4(this.a138_1, this.z137_1));
                this.n9_1 = 6;
                continue $sm;
              } else {
                noWhenBranchMatchedException();
              }
            }

            break;
          case 1:
            var this_0 = suspendResult;
            var tmp_0 = OrderHistoryViewModel$handleIntent$lambda_0;
            var orders = sortedWith(this_0, new sam$kotlin_Comparator$0_0(tmp_0));
            this.z137_1.x10k(OrderHistoryViewModel$handleIntent$lambda_1(orders, this.z137_1));
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 7;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 7;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Exception) {
              var e = this.q9_1;
              this.z137_1.x10k(OrderHistoryViewModel$handleIntent$lambda_3(e));
              this.n9_1 = 4;
              var tmp1_elvis_lhs = e.message;
              suspendResult = this.z137_1.d10l(new ShowError_5(tmp1_elvis_lhs == null ? 'Failed to load orders' : tmp1_elvis_lhs), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 7;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 7) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function OrderHistoryViewModel(getOrderHistoryUseCase, getCurrentUserValueUseCase) {
    BaseMviViewModel.call(this, new OrderHistoryState());
    this.o137_1 = getOrderHistoryUseCase;
    this.p137_1 = getCurrentUserValueUseCase;
    var tmp = get_viewModelScope(this);
    launch(tmp, VOID, VOID, OrderHistoryViewModel$slambda_0(this, null));
  }
  protoOf(OrderHistoryViewModel).q137 = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_12(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OrderHistoryViewModel).f10l = function (intent, $completion) {
    return this.q137(isInterface(intent, OrderHistoryIntent) ? intent : THROW_CCE(), $completion);
  };
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsState$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_LoadProduct$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_AddToCart$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_ToggleStockReminder$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_QuantityChanged$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_ToggleFavorite$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_KindChanged$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_TargetAudienceChanged$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_CardSelected$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_CardMessageChanged$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_CardBirthdayChanged$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_BoxSelected$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_BoxMessageChanged$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_BoxBirthdayChanged$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_SizeSelected$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_ColorSelected$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_OptionSelected$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_ProductCommentChanged$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_BraceletNameChanged$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_ShareProduct$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsSideEffect_ShowMessage$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsSideEffect_ShowToast$stable;
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsSideEffect_NavigateToAuth$stable;
  function BeadsProductDetailsState(product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, braceletName, availableCards, availableBoxes) {
    product = product === VOID ? null : product;
    quantity = quantity === VOID ? 1 : quantity;
    isAddingToCart = isAddingToCart === VOID ? false : isAddingToCart;
    isFavorite = isFavorite === VOID ? false : isFavorite;
    isStockReminderSet = isStockReminderSet === VOID ? false : isStockReminderSet;
    language = language === VOID ? 'en' : language;
    selectedKind = selectedKind === VOID ? ProductKind_BEADS_getInstance() : selectedKind;
    selectedAudience = selectedAudience === VOID ? TargetAudience_BOTH_getInstance() : selectedAudience;
    selectedCard = selectedCard === VOID ? null : selectedCard;
    cardMessage = cardMessage === VOID ? '' : cardMessage;
    cardBirthday = cardBirthday === VOID ? '' : cardBirthday;
    cardBirthdayError = cardBirthdayError === VOID ? false : cardBirthdayError;
    selectedBox = selectedBox === VOID ? null : selectedBox;
    boxMessage = boxMessage === VOID ? '' : boxMessage;
    boxBirthday = boxBirthday === VOID ? '' : boxBirthday;
    boxBirthdayError = boxBirthdayError === VOID ? false : boxBirthdayError;
    selectedSize = selectedSize === VOID ? null : selectedSize;
    selectedColor = selectedColor === VOID ? null : selectedColor;
    selectedOptions = selectedOptions === VOID ? emptyMap() : selectedOptions;
    productComment = productComment === VOID ? '' : productComment;
    braceletName = braceletName === VOID ? '' : braceletName;
    availableCards = availableCards === VOID ? emptyList() : availableCards;
    availableBoxes = availableBoxes === VOID ? emptyList() : availableBoxes;
    this.b138_1 = product;
    this.c138_1 = quantity;
    this.d138_1 = isAddingToCart;
    this.e138_1 = isFavorite;
    this.f138_1 = isStockReminderSet;
    this.g138_1 = language;
    this.h138_1 = selectedKind;
    this.i138_1 = selectedAudience;
    this.j138_1 = selectedCard;
    this.k138_1 = cardMessage;
    this.l138_1 = cardBirthday;
    this.m138_1 = cardBirthdayError;
    this.n138_1 = selectedBox;
    this.o138_1 = boxMessage;
    this.p138_1 = boxBirthday;
    this.q138_1 = boxBirthdayError;
    this.r138_1 = selectedSize;
    this.s138_1 = selectedColor;
    this.t138_1 = selectedOptions;
    this.u138_1 = productComment;
    this.v138_1 = braceletName;
    this.w138_1 = availableCards;
    this.x138_1 = availableBoxes;
  }
  protoOf(BeadsProductDetailsState).y138 = function (product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, braceletName, availableCards, availableBoxes) {
    return new BeadsProductDetailsState(product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, braceletName, availableCards, availableBoxes);
  };
  protoOf(BeadsProductDetailsState).z138 = function (product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, braceletName, availableCards, availableBoxes, $super) {
    product = product === VOID ? this.b138_1 : product;
    quantity = quantity === VOID ? this.c138_1 : quantity;
    isAddingToCart = isAddingToCart === VOID ? this.d138_1 : isAddingToCart;
    isFavorite = isFavorite === VOID ? this.e138_1 : isFavorite;
    isStockReminderSet = isStockReminderSet === VOID ? this.f138_1 : isStockReminderSet;
    language = language === VOID ? this.g138_1 : language;
    selectedKind = selectedKind === VOID ? this.h138_1 : selectedKind;
    selectedAudience = selectedAudience === VOID ? this.i138_1 : selectedAudience;
    selectedCard = selectedCard === VOID ? this.j138_1 : selectedCard;
    cardMessage = cardMessage === VOID ? this.k138_1 : cardMessage;
    cardBirthday = cardBirthday === VOID ? this.l138_1 : cardBirthday;
    cardBirthdayError = cardBirthdayError === VOID ? this.m138_1 : cardBirthdayError;
    selectedBox = selectedBox === VOID ? this.n138_1 : selectedBox;
    boxMessage = boxMessage === VOID ? this.o138_1 : boxMessage;
    boxBirthday = boxBirthday === VOID ? this.p138_1 : boxBirthday;
    boxBirthdayError = boxBirthdayError === VOID ? this.q138_1 : boxBirthdayError;
    selectedSize = selectedSize === VOID ? this.r138_1 : selectedSize;
    selectedColor = selectedColor === VOID ? this.s138_1 : selectedColor;
    selectedOptions = selectedOptions === VOID ? this.t138_1 : selectedOptions;
    productComment = productComment === VOID ? this.u138_1 : productComment;
    braceletName = braceletName === VOID ? this.v138_1 : braceletName;
    availableCards = availableCards === VOID ? this.w138_1 : availableCards;
    availableBoxes = availableBoxes === VOID ? this.x138_1 : availableBoxes;
    return $super === VOID ? this.y138(product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, braceletName, availableCards, availableBoxes) : $super.y138.call(this, product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, braceletName, availableCards, availableBoxes);
  };
  protoOf(BeadsProductDetailsState).toString = function () {
    return 'BeadsProductDetailsState(product=' + toString_0(this.b138_1) + ', quantity=' + this.c138_1 + ', isAddingToCart=' + this.d138_1 + ', isFavorite=' + this.e138_1 + ', isStockReminderSet=' + this.f138_1 + ', language=' + this.g138_1 + ', selectedKind=' + this.h138_1.toString() + ', selectedAudience=' + this.i138_1.toString() + ', selectedCard=' + toString_0(this.j138_1) + ', cardMessage=' + this.k138_1 + ', cardBirthday=' + this.l138_1 + ', cardBirthdayError=' + this.m138_1 + ', selectedBox=' + toString_0(this.n138_1) + ', boxMessage=' + this.o138_1 + ', boxBirthday=' + this.p138_1 + ', boxBirthdayError=' + this.q138_1 + ', selectedSize=' + this.r138_1 + ', selectedColor=' + this.s138_1 + ', selectedOptions=' + toString(this.t138_1) + ', productComment=' + this.u138_1 + ', braceletName=' + this.v138_1 + ', availableCards=' + toString(this.w138_1) + ', availableBoxes=' + toString(this.x138_1) + ')';
  };
  protoOf(BeadsProductDetailsState).hashCode = function () {
    var result = this.b138_1 == null ? 0 : this.b138_1.hashCode();
    result = imul(result, 31) + this.c138_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d138_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e138_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f138_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g138_1) | 0;
    result = imul(result, 31) + this.h138_1.hashCode() | 0;
    result = imul(result, 31) + this.i138_1.hashCode() | 0;
    result = imul(result, 31) + (this.j138_1 == null ? 0 : this.j138_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.k138_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l138_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m138_1) | 0;
    result = imul(result, 31) + (this.n138_1 == null ? 0 : this.n138_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.o138_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p138_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q138_1) | 0;
    result = imul(result, 31) + (this.r138_1 == null ? 0 : getStringHashCode(this.r138_1)) | 0;
    result = imul(result, 31) + (this.s138_1 == null ? 0 : getStringHashCode(this.s138_1)) | 0;
    result = imul(result, 31) + hashCode(this.t138_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u138_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v138_1) | 0;
    result = imul(result, 31) + hashCode(this.w138_1) | 0;
    result = imul(result, 31) + hashCode(this.x138_1) | 0;
    return result;
  };
  protoOf(BeadsProductDetailsState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BeadsProductDetailsState))
      return false;
    if (!equals(this.b138_1, other.b138_1))
      return false;
    if (!(this.c138_1 === other.c138_1))
      return false;
    if (!(this.d138_1 === other.d138_1))
      return false;
    if (!(this.e138_1 === other.e138_1))
      return false;
    if (!(this.f138_1 === other.f138_1))
      return false;
    if (!(this.g138_1 === other.g138_1))
      return false;
    if (!this.h138_1.equals(other.h138_1))
      return false;
    if (!this.i138_1.equals(other.i138_1))
      return false;
    if (!equals(this.j138_1, other.j138_1))
      return false;
    if (!(this.k138_1 === other.k138_1))
      return false;
    if (!(this.l138_1 === other.l138_1))
      return false;
    if (!(this.m138_1 === other.m138_1))
      return false;
    if (!equals(this.n138_1, other.n138_1))
      return false;
    if (!(this.o138_1 === other.o138_1))
      return false;
    if (!(this.p138_1 === other.p138_1))
      return false;
    if (!(this.q138_1 === other.q138_1))
      return false;
    if (!(this.r138_1 == other.r138_1))
      return false;
    if (!(this.s138_1 == other.s138_1))
      return false;
    if (!equals(this.t138_1, other.t138_1))
      return false;
    if (!(this.u138_1 === other.u138_1))
      return false;
    if (!(this.v138_1 === other.v138_1))
      return false;
    if (!equals(this.w138_1, other.w138_1))
      return false;
    if (!equals(this.x138_1, other.x138_1))
      return false;
    return true;
  };
  function LoadProduct_0(product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, initialBraceletName) {
    initialSize = initialSize === VOID ? null : initialSize;
    initialColor = initialColor === VOID ? null : initialColor;
    initialOptions = initialOptions === VOID ? null : initialOptions;
    initialComment = initialComment === VOID ? null : initialComment;
    initialCard = initialCard === VOID ? null : initialCard;
    initialBox = initialBox === VOID ? null : initialBox;
    initialCardMessage = initialCardMessage === VOID ? null : initialCardMessage;
    initialCardBirthday = initialCardBirthday === VOID ? null : initialCardBirthday;
    initialBoxMessage = initialBoxMessage === VOID ? null : initialBoxMessage;
    initialBoxBirthday = initialBoxBirthday === VOID ? null : initialBoxBirthday;
    initialBraceletName = initialBraceletName === VOID ? null : initialBraceletName;
    this.a139_1 = product;
    this.b139_1 = initialSize;
    this.c139_1 = initialColor;
    this.d139_1 = initialOptions;
    this.e139_1 = initialComment;
    this.f139_1 = initialCard;
    this.g139_1 = initialBox;
    this.h139_1 = initialCardMessage;
    this.i139_1 = initialCardBirthday;
    this.j139_1 = initialBoxMessage;
    this.k139_1 = initialBoxBirthday;
    this.l139_1 = initialBraceletName;
  }
  protoOf(LoadProduct_0).toString = function () {
    return 'LoadProduct(product=' + this.a139_1.toString() + ', initialSize=' + this.b139_1 + ', initialColor=' + this.c139_1 + ', initialOptions=' + toString_0(this.d139_1) + ', initialComment=' + this.e139_1 + ', initialCard=' + toString_0(this.f139_1) + ', initialBox=' + toString_0(this.g139_1) + ', initialCardMessage=' + this.h139_1 + ', initialCardBirthday=' + this.i139_1 + ', initialBoxMessage=' + this.j139_1 + ', initialBoxBirthday=' + this.k139_1 + ', initialBraceletName=' + this.l139_1 + ')';
  };
  protoOf(LoadProduct_0).hashCode = function () {
    var result = this.a139_1.hashCode();
    result = imul(result, 31) + (this.b139_1 == null ? 0 : getStringHashCode(this.b139_1)) | 0;
    result = imul(result, 31) + (this.c139_1 == null ? 0 : getStringHashCode(this.c139_1)) | 0;
    result = imul(result, 31) + (this.d139_1 == null ? 0 : hashCode(this.d139_1)) | 0;
    result = imul(result, 31) + (this.e139_1 == null ? 0 : getStringHashCode(this.e139_1)) | 0;
    result = imul(result, 31) + (this.f139_1 == null ? 0 : this.f139_1.hashCode()) | 0;
    result = imul(result, 31) + (this.g139_1 == null ? 0 : this.g139_1.hashCode()) | 0;
    result = imul(result, 31) + (this.h139_1 == null ? 0 : getStringHashCode(this.h139_1)) | 0;
    result = imul(result, 31) + (this.i139_1 == null ? 0 : getStringHashCode(this.i139_1)) | 0;
    result = imul(result, 31) + (this.j139_1 == null ? 0 : getStringHashCode(this.j139_1)) | 0;
    result = imul(result, 31) + (this.k139_1 == null ? 0 : getStringHashCode(this.k139_1)) | 0;
    result = imul(result, 31) + (this.l139_1 == null ? 0 : getStringHashCode(this.l139_1)) | 0;
    return result;
  };
  protoOf(LoadProduct_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadProduct_0))
      return false;
    if (!this.a139_1.equals(other.a139_1))
      return false;
    if (!(this.b139_1 == other.b139_1))
      return false;
    if (!(this.c139_1 == other.c139_1))
      return false;
    if (!equals(this.d139_1, other.d139_1))
      return false;
    if (!(this.e139_1 == other.e139_1))
      return false;
    if (!equals(this.f139_1, other.f139_1))
      return false;
    if (!equals(this.g139_1, other.g139_1))
      return false;
    if (!(this.h139_1 == other.h139_1))
      return false;
    if (!(this.i139_1 == other.i139_1))
      return false;
    if (!(this.j139_1 == other.j139_1))
      return false;
    if (!(this.k139_1 == other.k139_1))
      return false;
    if (!(this.l139_1 == other.l139_1))
      return false;
    return true;
  };
  function AddToCart_0() {
  }
  protoOf(AddToCart_0).toString = function () {
    return 'AddToCart';
  };
  protoOf(AddToCart_0).hashCode = function () {
    return 2035782754;
  };
  protoOf(AddToCart_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddToCart_0))
      return false;
    return true;
  };
  var AddToCart_instance_0;
  function AddToCart_getInstance_0() {
    return AddToCart_instance_0;
  }
  function ToggleStockReminder_0() {
  }
  protoOf(ToggleStockReminder_0).toString = function () {
    return 'ToggleStockReminder';
  };
  protoOf(ToggleStockReminder_0).hashCode = function () {
    return -120828070;
  };
  protoOf(ToggleStockReminder_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ToggleStockReminder_0))
      return false;
    return true;
  };
  var ToggleStockReminder_instance;
  function ToggleStockReminder_getInstance() {
    return ToggleStockReminder_instance;
  }
  function QuantityChanged(quantity) {
    this.m139_1 = quantity;
  }
  protoOf(QuantityChanged).toString = function () {
    return 'QuantityChanged(quantity=' + this.m139_1 + ')';
  };
  protoOf(QuantityChanged).hashCode = function () {
    return this.m139_1;
  };
  protoOf(QuantityChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof QuantityChanged))
      return false;
    if (!(this.m139_1 === other.m139_1))
      return false;
    return true;
  };
  function ToggleFavorite_1() {
  }
  protoOf(ToggleFavorite_1).toString = function () {
    return 'ToggleFavorite';
  };
  protoOf(ToggleFavorite_1).hashCode = function () {
    return -2037294934;
  };
  protoOf(ToggleFavorite_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ToggleFavorite_1))
      return false;
    return true;
  };
  var ToggleFavorite_instance;
  function ToggleFavorite_getInstance() {
    return ToggleFavorite_instance;
  }
  function KindChanged() {
  }
  function TargetAudienceChanged() {
  }
  function CardSelected_0(card) {
    this.n139_1 = card;
  }
  protoOf(CardSelected_0).toString = function () {
    return 'CardSelected(card=' + toString_0(this.n139_1) + ')';
  };
  protoOf(CardSelected_0).hashCode = function () {
    return this.n139_1 == null ? 0 : this.n139_1.hashCode();
  };
  protoOf(CardSelected_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CardSelected_0))
      return false;
    if (!equals(this.n139_1, other.n139_1))
      return false;
    return true;
  };
  function CardMessageChanged_0(message) {
    this.o139_1 = message;
  }
  protoOf(CardMessageChanged_0).toString = function () {
    return 'CardMessageChanged(message=' + this.o139_1 + ')';
  };
  protoOf(CardMessageChanged_0).hashCode = function () {
    return getStringHashCode(this.o139_1);
  };
  protoOf(CardMessageChanged_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CardMessageChanged_0))
      return false;
    if (!(this.o139_1 === other.o139_1))
      return false;
    return true;
  };
  function CardBirthdayChanged_0(birthday) {
    this.p139_1 = birthday;
  }
  protoOf(CardBirthdayChanged_0).toString = function () {
    return 'CardBirthdayChanged(birthday=' + this.p139_1 + ')';
  };
  protoOf(CardBirthdayChanged_0).hashCode = function () {
    return getStringHashCode(this.p139_1);
  };
  protoOf(CardBirthdayChanged_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CardBirthdayChanged_0))
      return false;
    if (!(this.p139_1 === other.p139_1))
      return false;
    return true;
  };
  function BoxSelected_0(box) {
    this.q139_1 = box;
  }
  protoOf(BoxSelected_0).toString = function () {
    return 'BoxSelected(box=' + toString_0(this.q139_1) + ')';
  };
  protoOf(BoxSelected_0).hashCode = function () {
    return this.q139_1 == null ? 0 : this.q139_1.hashCode();
  };
  protoOf(BoxSelected_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxSelected_0))
      return false;
    if (!equals(this.q139_1, other.q139_1))
      return false;
    return true;
  };
  function BoxMessageChanged_0(message) {
    this.r139_1 = message;
  }
  protoOf(BoxMessageChanged_0).toString = function () {
    return 'BoxMessageChanged(message=' + this.r139_1 + ')';
  };
  protoOf(BoxMessageChanged_0).hashCode = function () {
    return getStringHashCode(this.r139_1);
  };
  protoOf(BoxMessageChanged_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxMessageChanged_0))
      return false;
    if (!(this.r139_1 === other.r139_1))
      return false;
    return true;
  };
  function BoxBirthdayChanged_0(birthday) {
    this.s139_1 = birthday;
  }
  protoOf(BoxBirthdayChanged_0).toString = function () {
    return 'BoxBirthdayChanged(birthday=' + this.s139_1 + ')';
  };
  protoOf(BoxBirthdayChanged_0).hashCode = function () {
    return getStringHashCode(this.s139_1);
  };
  protoOf(BoxBirthdayChanged_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxBirthdayChanged_0))
      return false;
    if (!(this.s139_1 === other.s139_1))
      return false;
    return true;
  };
  function SizeSelected_0(size) {
    this.t139_1 = size;
  }
  protoOf(SizeSelected_0).toString = function () {
    return 'SizeSelected(size=' + this.t139_1 + ')';
  };
  protoOf(SizeSelected_0).hashCode = function () {
    return this.t139_1 == null ? 0 : getStringHashCode(this.t139_1);
  };
  protoOf(SizeSelected_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeSelected_0))
      return false;
    if (!(this.t139_1 == other.t139_1))
      return false;
    return true;
  };
  function ColorSelected_0(color) {
    this.u139_1 = color;
  }
  protoOf(ColorSelected_0).toString = function () {
    return 'ColorSelected(color=' + this.u139_1 + ')';
  };
  protoOf(ColorSelected_0).hashCode = function () {
    return this.u139_1 == null ? 0 : getStringHashCode(this.u139_1);
  };
  protoOf(ColorSelected_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorSelected_0))
      return false;
    if (!(this.u139_1 == other.u139_1))
      return false;
    return true;
  };
  function OptionSelected_0(key, value) {
    this.v139_1 = key;
    this.w139_1 = value;
  }
  protoOf(OptionSelected_0).toString = function () {
    return 'OptionSelected(key=' + this.v139_1 + ', value=' + toString_0(this.w139_1) + ')';
  };
  protoOf(OptionSelected_0).hashCode = function () {
    var result = getStringHashCode(this.v139_1);
    result = imul(result, 31) + (this.w139_1 == null ? 0 : this.w139_1.hashCode()) | 0;
    return result;
  };
  protoOf(OptionSelected_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OptionSelected_0))
      return false;
    if (!(this.v139_1 === other.v139_1))
      return false;
    if (!equals(this.w139_1, other.w139_1))
      return false;
    return true;
  };
  function ProductCommentChanged_0(comment) {
    this.x139_1 = comment;
  }
  protoOf(ProductCommentChanged_0).toString = function () {
    return 'ProductCommentChanged(comment=' + this.x139_1 + ')';
  };
  protoOf(ProductCommentChanged_0).hashCode = function () {
    return getStringHashCode(this.x139_1);
  };
  protoOf(ProductCommentChanged_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductCommentChanged_0))
      return false;
    if (!(this.x139_1 === other.x139_1))
      return false;
    return true;
  };
  function BraceletNameChanged(name) {
    this.y139_1 = name;
  }
  protoOf(BraceletNameChanged).toString = function () {
    return 'BraceletNameChanged(name=' + this.y139_1 + ')';
  };
  protoOf(BraceletNameChanged).hashCode = function () {
    return getStringHashCode(this.y139_1);
  };
  protoOf(BraceletNameChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BraceletNameChanged))
      return false;
    if (!(this.y139_1 === other.y139_1))
      return false;
    return true;
  };
  function ShareProduct() {
  }
  protoOf(ShareProduct).toString = function () {
    return 'ShareProduct';
  };
  protoOf(ShareProduct).hashCode = function () {
    return -710054358;
  };
  protoOf(ShareProduct).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShareProduct))
      return false;
    return true;
  };
  var ShareProduct_instance;
  function ShareProduct_getInstance() {
    return ShareProduct_instance;
  }
  function BeadsProductDetailsIntent() {
  }
  function ShowMessage_3(message) {
    this.z139_1 = message;
  }
  protoOf(ShowMessage_3).toString = function () {
    return 'ShowMessage(message=' + toString(this.z139_1) + ')';
  };
  protoOf(ShowMessage_3).hashCode = function () {
    return hashCode(this.z139_1);
  };
  protoOf(ShowMessage_3).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowMessage_3))
      return false;
    if (!equals(this.z139_1, other.z139_1))
      return false;
    return true;
  };
  function ShowToast(message) {
    this.a13a_1 = message;
  }
  protoOf(ShowToast).toString = function () {
    return 'ShowToast(message=' + toString(this.a13a_1) + ')';
  };
  protoOf(ShowToast).hashCode = function () {
    return hashCode(this.a13a_1);
  };
  protoOf(ShowToast).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowToast))
      return false;
    if (!equals(this.a13a_1, other.a13a_1))
      return false;
    return true;
  };
  function NavigateToAuth_1() {
  }
  protoOf(NavigateToAuth_1).toString = function () {
    return 'NavigateToAuth';
  };
  protoOf(NavigateToAuth_1).hashCode = function () {
    return -1727011198;
  };
  protoOf(NavigateToAuth_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateToAuth_1))
      return false;
    return true;
  };
  var NavigateToAuth_instance_1;
  function NavigateToAuth_getInstance_1() {
    return NavigateToAuth_instance_1;
  }
  function BeadsProductDetailsSideEffect() {
  }
  function BeadsProductDetailsScreen(product, onBack, onNavigateToAuth, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, initialBraceletName, $composer, $changed, $changed1, $default) {
    var initialSize_0 = {_v: initialSize};
    var initialColor_0 = {_v: initialColor};
    var initialOptions_0 = {_v: initialOptions};
    var initialComment_0 = {_v: initialComment};
    var initialCard_0 = {_v: initialCard};
    var initialBox_0 = {_v: initialBox};
    var initialCardMessage_0 = {_v: initialCardMessage};
    var initialCardBirthday_0 = {_v: initialCardBirthday};
    var initialBoxMessage_0 = {_v: initialBoxMessage};
    var initialBoxBirthday_0 = {_v: initialBoxBirthday};
    var initialBraceletName_0 = {_v: initialBraceletName};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1598033346);
    sourceInformation($composer_0, 'C(BeadsProductDetailsScreen)P(13,11,12,10,7,9,8,4!1,6,5,2)113@5376L42,114@5462L16,115@5507L32,116@5570L21,126@6091L709,126@6067L733,145@6832L488,145@6806L514,162@7581L22,162@7562L41,163@7625L34,165@7691L34,166@7767L42,167@7842L34,168@7906L34,169@7968L34,170@8032L33,171@8096L25,173@8190L138,173@8127L201,181@8373L33,181@8334L72,197@8783L49975:BeadsProductDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(product) : $composer_0.q31(product)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToAuth) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(initialSize_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(initialColor_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ((($changed & 262144) === 0 ? $composer_0.k31(initialOptions_0._v) : $composer_0.q31(initialOptions_0._v)) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(initialComment_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ((($changed & 16777216) === 0 ? $composer_0.k31(initialCard_0._v) : $composer_0.q31(initialCard_0._v)) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ((($changed & 134217728) === 0 ? $composer_0.k31(initialBox_0._v) : $composer_0.q31(initialBox_0._v)) ? 67108864 : 33554432);
    if (!(($default & 512) === 0))
      $dirty = $dirty | 805306368;
    else if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.k31(initialCardMessage_0._v) ? 536870912 : 268435456);
    if (!(($default & 1024) === 0))
      $dirty1 = $dirty1 | 6;
    else if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(initialCardBirthday_0._v) ? 4 : 2);
    if (!(($default & 2048) === 0))
      $dirty1 = $dirty1 | 48;
    else if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(initialBoxMessage_0._v) ? 32 : 16);
    if (!(($default & 4096) === 0))
      $dirty1 = $dirty1 | 384;
    else if (($changed1 & 384) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(initialBoxBirthday_0._v) ? 256 : 128);
    if (!(($default & 8192) === 0))
      $dirty1 = $dirty1 | 3072;
    else if (($changed1 & 3072) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(initialBraceletName_0._v) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        initialSize_0._v = null;
      }
      if (!(($default & 16) === 0)) {
        initialColor_0._v = null;
      }
      if (!(($default & 32) === 0)) {
        initialOptions_0._v = null;
      }
      if (!(($default & 64) === 0)) {
        initialComment_0._v = null;
      }
      if (!(($default & 128) === 0)) {
        initialCard_0._v = null;
      }
      if (!(($default & 256) === 0)) {
        initialBox_0._v = null;
      }
      if (!(($default & 512) === 0)) {
        initialCardMessage_0._v = null;
      }
      if (!(($default & 1024) === 0)) {
        initialCardBirthday_0._v = null;
      }
      if (!(($default & 2048) === 0)) {
        initialBoxMessage_0._v = null;
      }
      if (!(($default & 4096) === 0)) {
        initialBoxBirthday_0._v = null;
      }
      if (!(($default & 8192) === 0)) {
        initialBraceletName_0._v = null;
      }
      if (isTraceInProgress()) {
        traceEventStart(-1598033346, $dirty, $dirty1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen (BeadsProductDetailsScreen.kt:112)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = toString_0(product.nzt_1);
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((59 & 1) === 0))
        qualifier = null;
      if (!((59 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((59 & 4) === 0))
        key = null;
      if (!((59 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((59 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((59 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(BeadsProductDetailsViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, 1888271486, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance().f30_1) {
        var value = new SnackbarHostState();
        this_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp0_group;
      var verticalScrollState = rememberScrollState(0, $composer_0, 0, 1);
      var language = BeadsProductDetailsScreen$lambda(state$delegate).g138_1;
      var tmp0_elvis_lhs_0 = BeadsProductDetailsScreen$lambda(state$delegate).b138_1;
      var activeProduct = tmp0_elvis_lhs_0 == null ? product : tmp0_elvis_lhs_0;
      var tmp_2;
      if (language === 'en') {
        var tmp1_elvis_lhs = activeProduct.ozt_1;
        tmp_2 = tmp1_elvis_lhs == null ? activeProduct.pzt_1 : tmp1_elvis_lhs;
      } else {
        var tmp2_elvis_lhs = activeProduct.pzt_1;
        tmp_2 = tmp2_elvis_lhs == null ? activeProduct.ozt_1 : tmp2_elvis_lhs;
      }
      var tmp3_elvis_lhs = tmp_2;
      var name = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      var tmp_3;
      if (language === 'en') {
        var tmp4_elvis_lhs = activeProduct.qzt_1;
        tmp_3 = tmp4_elvis_lhs == null ? activeProduct.rzt_1 : tmp4_elvis_lhs;
      } else {
        var tmp5_elvis_lhs = activeProduct.rzt_1;
        tmp_3 = tmp5_elvis_lhs == null ? activeProduct.qzt_1 : tmp5_elvis_lhs;
      }
      var tmp6_elvis_lhs = tmp_3;
      var description = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
      sourceInformationMarkerStart($composer_0, 1888290851, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!(!!(!!(!!(!!(!!(!!(!!(!!(!!(!!($composer_0.q31(viewModel) | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(product)))) | ($dirty & 7168) === 2048) | ($dirty & 57344) === 16384) | (($dirty & 458752) === 131072 || (!(($dirty & 262144) === 0) && $composer_0.q31(initialOptions_0._v)))) | ($dirty & 3670016) === 1048576) | (($dirty & 29360128) === 8388608 || (!(($dirty & 16777216) === 0) && $composer_0.q31(initialCard_0._v)))) | (($dirty & 234881024) === 67108864 || (!(($dirty & 134217728) === 0) && $composer_0.q31(initialBox_0._v)))) | ($dirty & 1879048192) === 536870912) | ($dirty1 & 14) === 4) | ($dirty1 & 112) === 32) | ($dirty1 & 896) === 256) | ($dirty1 & 7168) === 2048);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_0.i31();
      var tmp_4;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = BeadsProductDetailsScreen$slambda_0(viewModel, product, initialSize_0, initialColor_0, initialOptions_0, initialComment_0, initialCard_0, initialBox_0, initialCardMessage_0, initialCardBirthday_0, initialBoxMessage_0, initialBoxBirthday_0, initialBraceletName_0, null);
        tmp0_0.j31(value_0);
        tmp_4 = value_0;
      } else {
        tmp_4 = it_0;
      }
      var tmp1_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(product, tmp1_group, $composer_0, 14 & $dirty);
      sourceInformationMarkerStart($composer_0, 1888314342, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.q31(viewModel) | ($dirty & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_1.i31();
      var tmp_5;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = BeadsProductDetailsScreen$slambda_2(viewModel, snackbarHostState, onNavigateToAuth, null);
        tmp0_1.j31(value_1);
        tmp_5 = value_1;
      } else {
        tmp_5 = it_1;
      }
      var tmp2_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp2_group, $composer_0, 0);
      var tmp7_safe_receiver = activeProduct.xzt_1;
      var tmp_6;
      if (tmp7_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s = tmp7_safe_receiver.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(element)) {
            destination.j1(element);
          }
        }
        tmp_6 = destination;
      }
      var tmp8_elvis_lhs = tmp_6;
      var images = tmp8_elvis_lhs == null ? emptyList() : tmp8_elvis_lhs;
      var tmp9_safe_receiver = activeProduct.yzt_1;
      var tmp_7;
      if (tmp9_safe_receiver == null) {
        tmp_7 = null;
      } else {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s_0 = tmp9_safe_receiver.t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(element_0)) {
            destination_0.j1(element_0);
          }
        }
        tmp_7 = destination_0;
      }
      var tmp10_elvis_lhs = tmp_7;
      var videos = tmp10_elvis_lhs == null ? emptyList() : tmp10_elvis_lhs;
      var combinedMedia = distinct(plus(images, videos));
      sourceInformationMarkerStart($composer_0, 1888337844, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_0.q31(combinedMedia);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_2.i31();
      var tmp_8;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = BeadsProductDetailsScreen$lambda_0(combinedMedia);
        tmp0_2.j31(value_2);
        tmp_8 = value_2;
      } else {
        tmp_8 = it_2;
      }
      var tmp3_group = tmp_8;
      sourceInformationMarkerEnd($composer_0);
      var pagerState = rememberPagerState(0, 0.0, tmp3_group, $composer_0, 0, 3);
      sourceInformationMarkerStart($composer_0, 1888339264, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_3 = this_1.i31();
      var tmp_9;
      if (false || it_3 === Companion_getInstance().f30_1) {
        var value_3 = mutableStateOf(false);
        this_1.j31(value_3);
        tmp_9 = value_3;
      } else {
        tmp_9 = it_3;
      }
      var tmp4_group = tmp_9;
      sourceInformationMarkerEnd($composer_0);
      var isZooming$delegate = tmp4_group;
      sourceInformationMarkerStart($composer_0, 1888341376, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_4 = this_2.i31();
      var tmp_10;
      if (false || it_4 === Companion_getInstance().f30_1) {
        var value_4 = mutableStateOf(false);
        this_2.j31(value_4);
        tmp_10 = value_4;
      } else {
        tmp_10 = it_4;
      }
      var tmp5_group = tmp_10;
      sourceInformationMarkerEnd($composer_0);
      var showBirthdayPicker$delegate = tmp5_group;
      sourceInformationMarkerStart($composer_0, 1888343816, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_5 = this_3.i31();
      var tmp_11;
      if (false || it_5 === Companion_getInstance().f30_1) {
        var value_5 = mutableStateOf(null);
        this_3.j31(value_5);
        tmp_11 = value_5;
      } else {
        tmp_11 = it_5;
      }
      var tmp6_group = tmp_11;
      sourceInformationMarkerEnd($composer_0);
      var birthdayPickerTargetOptionKey$delegate = tmp6_group;
      sourceInformationMarkerStart($composer_0, 1888346208, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_4 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_6 = this_4.i31();
      var tmp_12;
      if (false || it_6 === Companion_getInstance().f30_1) {
        var value_6 = mutableStateOf(false);
        this_4.j31(value_6);
        tmp_12 = value_6;
      } else {
        tmp_12 = it_6;
      }
      var tmp7_group = tmp_12;
      sourceInformationMarkerEnd($composer_0);
      var isPickingBoxBirthday$delegate = tmp7_group;
      sourceInformationMarkerStart($composer_0, 1888348256, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_5 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_7 = this_5.i31();
      var tmp_13;
      if (false || it_7 === Companion_getInstance().f30_1) {
        var value_7 = mutableStateOf(false);
        this_5.j31(value_7);
        tmp_13 = value_7;
      } else {
        tmp_13 = it_7;
      }
      var tmp8_group = tmp_13;
      sourceInformationMarkerEnd($composer_0);
      var showDiscardDialog$delegate = tmp8_group;
      sourceInformationMarkerStart($composer_0, 1888350240, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_6 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_8 = this_6.i31();
      var tmp_14;
      if (false || it_8 === Companion_getInstance().f30_1) {
        var value_8 = mutableStateOf(false);
        this_6.j31(value_8);
        tmp_14 = value_8;
      } else {
        tmp_14 = it_8;
      }
      var tmp9_group = tmp_14;
      sourceInformationMarkerEnd($composer_0);
      var showMediaDialog$delegate = tmp9_group;
      sourceInformationMarkerStart($composer_0, 1888352287, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_7 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_9 = this_7.i31();
      var tmp_15;
      if (false || it_9 === Companion_getInstance().f30_1) {
        var value_9 = mutableIntStateOf(0);
        this_7.j31(value_9);
        tmp_15 = value_9;
      } else {
        tmp_15 = it_9;
      }
      var tmp10_group = tmp_15;
      sourceInformationMarkerEnd($composer_0);
      var initialMediaIndex$delegate = tmp10_group;
      var tmp_16 = _DisplayMode___init__impl__gfd230(0);
      var birthdayPickerState = rememberDatePickerState(null, null, null, tmp_16, null, $composer_0, 0, 31);
      var tmp_17 = BeadsProductDetailsScreen$lambda(state$delegate).d138_1 || BeadsProductDetailsScreen$lambda_11(showMediaDialog$delegate);
      sourceInformationMarkerStart($composer_0, 1888357448, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_8 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_10 = this_8.i31();
      var tmp_18;
      if (false || it_10 === Companion_getInstance().f30_1) {
        var value_10 = BeadsProductDetailsScreen$lambda_15(showMediaDialog$delegate, showDiscardDialog$delegate);
        this_8.j31(value_10);
        tmp_18 = value_10;
      } else {
        tmp_18 = it_10;
      }
      var tmp11_group = tmp_18;
      sourceInformationMarkerEnd($composer_0);
      BackHandler(tmp_17, tmp11_group, $composer_0, 48, 0);
      var tmp_19 = pagerState.zj9();
      sourceInformationMarkerStart($composer_0, 1888363199, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_9 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_11 = this_9.i31();
      var tmp_20;
      if (false || it_11 === Companion_getInstance().f30_1) {
        var value_11 = BeadsProductDetailsScreen$slambda_4(isZooming$delegate, null);
        this_9.j31(value_11);
        tmp_20 = value_11;
      } else {
        tmp_20 = it_11;
      }
      var tmp12_group = tmp_20;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_19, tmp12_group, $composer_0, 0);
      if (BeadsProductDetailsScreen$lambda_9(showDiscardDialog$delegate)) {
        $composer_0.m30(-1590211890);
        sourceInformation($composer_0, '187@8484L46,188@8554L44,189@8624L82,193@8732L29,186@8445L326');
        var tmp_21 = stringResource(get_discard_order_title(string_instance), $composer_0, 0);
        var tmp_22 = stringResource(get_discard_order_msg(string_instance), $composer_0, 0);
        sourceInformationMarkerStart($composer_0, 1888371280, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        var tmp0_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = ($dirty & 112) === 32;
        // Inline function 'kotlin.let' call
        var it_12 = tmp0_3.i31();
        var tmp_23;
        if (invalid_2 || it_12 === Companion_getInstance().f30_1) {
          var value_12 = BeadsProductDetailsScreen$lambda_16(onBack, showDiscardDialog$delegate);
          tmp0_3.j31(value_12);
          tmp_23 = value_12;
        } else {
          tmp_23 = it_12;
        }
        var tmp13_group = tmp_23;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 1888374683, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_10 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_13 = this_10.i31();
        var tmp_24;
        if (false || it_13 === Companion_getInstance().f30_1) {
          var value_13 = BeadsProductDetailsScreen$lambda_17(showDiscardDialog$delegate);
          this_10.j31(value_13);
          tmp_24 = value_13;
        } else {
          tmp_24 = it_13;
        }
        var tmp14_group = tmp_24;
        sourceInformationMarkerEnd($composer_0);
        HadayaAlertDialog(tmp_21, tmp_22, null, null, tmp13_group, tmp14_group, $composer_0, 196608, 12);
        $composer_0.n30();
      } else {
        $composer_0.m30(-1589883228);
        $composer_0.n30();
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = fillMaxSize(Companion_instance);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_2 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_3 = $composer_2;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_0);
      var tmp0_4 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_25 = $composer_4.g30();
      if (!isInterface(tmp_25, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_4);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_5 = $composer_4;
      var $composer_6 = $composer_5;
      sourceInformationMarkerStart($composer_6, -388638849, 'C198@8832L45530,1050@55950L128:BeadsProductDetailsScreen.kt#8gd4xm');
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = fillMaxSize(Companion_instance);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_7 = $composer_6;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_7, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_8 = $composer_7;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
      var localMap_0 = $composer_8.t31();
      var materialized_0 = materialize($composer_8, modifier_2);
      var tmp0_5 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_9 = $composer_8;
      var tmp_26 = $composer_9.g30();
      if (!isInterface(tmp_26, Applier)) {
        invalidApplier();
      }
      $composer_9.b31();
      if ($composer_9.h30()) {
        $composer_9.c31(tmp0_5);
      } else {
        $composer_9.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_10 = $composer_9;
      var $composer_11 = $composer_10;
      sourceInformationMarkerStart($composer_11, -1610339791, 'C199@8888L36438,854@45439L11,857@45592L8760,852@45340L9012:BeadsProductDetailsScreen.kt#8gd4xm');
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_3 = ColumnScopeInstance_instance.yds(Companion_instance, 1.0);
      var contentAlignment_0 = null;
      var propagateMinConstraints_0 = false;
      var $composer_12 = $composer_11;
      if (!((6 & 1) === 0))
        modifier_3 = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment_0 = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints_0 = false;
      var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_4 = modifier_3;
      var $composer_13 = $composer_12;
      if (!((0 & 2) === 0))
        modifier_4 = Companion_instance;
      var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_13, 0).hashCode();
      var localMap_1 = $composer_13.t31();
      var materialized_1 = materialize($composer_13, modifier_4);
      var tmp0_6 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_14 = $composer_13;
      var tmp_27 = $composer_14.g30();
      if (!isInterface(tmp_27, Applier)) {
        invalidApplier();
      }
      $composer_14.b31();
      if ($composer_14.h30()) {
        $composer_14.c31(tmp0_6);
      } else {
        $composer_14.d31();
      }
      var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_14);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
      var $composer_15 = $composer_14;
      var $composer_16 = $composer_15;
      sourceInformationMarkerStart($composer_16, 336987313, 'C205@9151L34,206@9228L31,200@8942L336,209@9296L36016:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp0_modifier = alpha(BoxScopeInstance_instance.udr(fillMaxWidth(Companion_instance, 0.8), Companion_getInstance_11().o8t_1), 0.03);
      var tmp1_painter = painterResource(get_logo(drawable_instance), $composer_16, 0);
      var tmp2_contentDescription = stringResource(get_logo_0(string_instance), $composer_16, 0);
      Image(tmp1_painter, tmp2_contentDescription, tmp0_modifier, null, null, 0.0, null, $composer_16, androidx_compose_ui_graphics_painter_Painter$stableprop_getter(), 120);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_5 = verticalScroll(fillMaxSize(Companion_instance), verticalScrollState, !BeadsProductDetailsScreen$lambda(state$delegate).d138_1 && !BeadsProductDetailsScreen$lambda_1(isZooming$delegate));
      var verticalArrangement_0 = null;
      var horizontalAlignment_0 = null;
      var $composer_17 = $composer_16;
      if (!((6 & 1) === 0))
        modifier_5 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement_0 = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
      var measurePolicy_2 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_17, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_6 = modifier_5;
      var $composer_18 = $composer_17;
      if (!((0 & 2) === 0))
        modifier_6 = Companion_instance;
      var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_18, 0).hashCode();
      var localMap_2 = $composer_18.t31();
      var materialized_2 = materialize($composer_18, modifier_6);
      var tmp0_7 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_19 = $composer_18;
      var tmp_28 = $composer_19.g30();
      if (!isInterface(tmp_28, Applier)) {
        invalidApplier();
      }
      $composer_19.b31();
      if ($composer_19.h30()) {
        $composer_19.c31(tmp0_7);
      } else {
        $composer_19.d31();
      }
      var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_19);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
      var $composer_20 = $composer_19;
      var $composer_21 = $composer_20;
      sourceInformationMarkerStart($composer_21, 514759948, 'C222@9898L11,217@9613L7566,418@20658L24636:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp_29 = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$94 = _Dp___init__impl__ms3zkb(400);
      var tmp_30 = height(tmp_29, tmp$ret$94);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp0_bottomStart = _Dp___init__impl__ms3zkb(32);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp1_bottomEnd = _Dp___init__impl__ms3zkb(32);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_7 = background(clip(tmp_30, RoundedCornerShape_0(VOID, VOID, tmp1_bottomEnd, tmp0_bottomStart)), Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_21, 6).oo0_1, 0.3));
      var contentAlignment_1 = null;
      var propagateMinConstraints_1 = false;
      var $composer_22 = $composer_21;
      if (!((6 & 1) === 0))
        modifier_7 = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment_1 = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints_1 = false;
      var measurePolicy_3 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_8 = modifier_7;
      var $composer_23 = $composer_22;
      if (!((0 & 2) === 0))
        modifier_8 = Companion_instance;
      var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_23, 0).hashCode();
      var localMap_3 = $composer_23.t31();
      var materialized_3 = materialize($composer_23, modifier_8);
      var tmp0_8 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_24 = $composer_23;
      var tmp_31 = $composer_24.g30();
      if (!isInterface(tmp_31, Applier)) {
        invalidApplier();
      }
      $composer_24.b31();
      if ($composer_24.h30()) {
        $composer_24.c31(tmp0_8);
      } else {
        $composer_24.d31();
      }
      var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_24);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
      var $composer_25 = $composer_24;
      var $composer_26 = $composer_25;
      sourceInformationMarkerStart($composer_26, -928913141, 'C228@10206L683,224@9993L896,243@10915L3159,310@14573L11,302@14147L161,301@14100L1811:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp_32 = fillMaxSize(Companion_instance);
      var tmp_33 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_34 = !BeadsProductDetailsScreen$lambda_1(isZooming$delegate);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1397401155, true, BeadsProductDetailsScreen$lambda_18(combinedMedia, name, pagerState, isZooming$delegate), $composer_26, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_27 = $composer_26;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = $composer_27.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_14 = $composer_27.i31();
      var tmp_35;
      if (invalid_3 || it_14 === Companion_getInstance().f30_1) {
        var value_14 = ComposableLambda$invoke$ref_7(dispatchReceiver);
        $composer_27.j31(value_14);
        tmp_35 = value_14;
      } else {
        tmp_35 = it_14;
      }
      var tmp$ret$103 = tmp_35;
      HorizontalPager(pagerState, tmp_32, null, null, 0, tmp_33, null, null, tmp_34, false, null, null, null, null, tmp$ret$103, $composer_26, 48, 24576, 16124);
      var tmp0_$receiver = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp1_top = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp2_start = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp3_end = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_9 = padding_1(tmp0_$receiver, tmp2_start, tmp1_top, tmp3_end);
      var horizontalArrangement = Arrangement_getInstance().wdp_1;
      var verticalAlignment = null;
      var $composer_28 = $composer_26;
      if (!((4 & 1) === 0))
        modifier_9 = Companion_instance;
      if (!((4 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((4 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy_4 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_28, 14 & 48 >> 3 | 112 & 48 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_10 = modifier_9;
      var $composer_29 = $composer_28;
      if (!((0 & 2) === 0))
        modifier_10 = Companion_instance;
      var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_29, 0).hashCode();
      var localMap_4 = $composer_29.t31();
      var materialized_4 = materialize($composer_29, modifier_10);
      var tmp0_9 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_30 = $composer_29;
      var tmp_36 = $composer_30.g30();
      if (!isInterface(tmp_36, Applier)) {
        invalidApplier();
      }
      $composer_30.b31();
      if ($composer_30.h30()) {
        $composer_30.c31(tmp0_9);
      } else {
        $composer_30.d31();
      }
      var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_30);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
      var $composer_31 = $composer_30;
      var $composer_32 = $composer_31;
      sourceInformationMarkerStart($composer_32, 1400037667, 'C250@11286L296,249@11232L848,267@12110L1938:BeadsProductDetailsScreen.kt#8gd4xm');
      sourceInformationMarkerStart($composer_32, -1340311608, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_4 = !!($composer_0.k31(state$delegate) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_15 = $composer_32.i31();
      var tmp_37;
      if (invalid_4 || it_15 === Companion_getInstance().f30_1) {
        var value_15 = BeadsProductDetailsScreen$lambda_19(onBack, state$delegate, showDiscardDialog$delegate);
        $composer_32.j31(value_15);
        tmp_37 = value_15;
      } else {
        tmp_37 = it_15;
      }
      var tmp0_group_0 = tmp_37;
      sourceInformationMarkerEnd($composer_32);
      var tmp_38 = background(Companion_instance, Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.7), get_CircleShape());
      IconButton(tmp0_group_0, tmp_38, false, null, null, null, ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().b13a_1, $composer_32, 1572864, 60);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_11 = null;
      var horizontalArrangement_0 = null;
      var verticalAlignment_0 = null;
      var $composer_33 = $composer_32;
      if (!((7 & 1) === 0))
        modifier_11 = Companion_instance;
      if (!((7 & 2) === 0))
        horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
      if (!((7 & 4) === 0))
        verticalAlignment_0 = Companion_getInstance_11().t8t_1;
      var measurePolicy_5 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_33, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_12 = modifier_11;
      var $composer_34 = $composer_33;
      if (!((0 & 2) === 0))
        modifier_12 = Companion_instance;
      var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_34, 0).hashCode();
      var localMap_5 = $composer_34.t31();
      var materialized_5 = materialize($composer_34, modifier_12);
      var tmp0_10 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_35 = $composer_34;
      var tmp_39 = $composer_35.g30();
      if (!isInterface(tmp_39, Applier)) {
        invalidApplier();
      }
      $composer_35.b31();
      if ($composer_35.h30()) {
        $composer_35.c31(tmp0_10);
      } else {
        $composer_35.d31();
      }
      var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_35);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
      var $composer_36 = $composer_35;
      var $composer_37 = $composer_36;
      sourceInformationMarkerStart($composer_37, 1929995313, 'C269@12206L72,272@12467L775,268@12148L1094,285@13276L39,288@13407L70,287@13349L669:BeadsProductDetailsScreen.kt#8gd4xm');
      sourceInformationMarkerStart($composer_37, 893541964, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_5 = $composer_37.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_16 = $composer_37.i31();
      var tmp_40;
      if (invalid_5 || it_16 === Companion_getInstance().f30_1) {
        var value_16 = BeadsProductDetailsScreen$lambda_20(viewModel);
        $composer_37.j31(value_16);
        tmp_40 = value_16;
      } else {
        tmp_40 = it_16;
      }
      var tmp0_group_1 = tmp_40;
      sourceInformationMarkerEnd($composer_37);
      var tmp_41 = background(Companion_instance, Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.7), get_CircleShape());
      // Inline function 'kotlin.run' call
      var dispatchReceiver_0 = rememberComposableLambda(-1208596574, true, BeadsProductDetailsScreen$lambda_21(state$delegate), $composer_37, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_38 = $composer_37;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_6 = $composer_38.k31(dispatchReceiver_0);
      // Inline function 'kotlin.let' call
      var it_17 = $composer_38.i31();
      var tmp_42;
      if (invalid_6 || it_17 === Companion_getInstance().f30_1) {
        var value_17 = ComposableLambda$invoke$ref(dispatchReceiver_0);
        $composer_38.j31(value_17);
        tmp_42 = value_17;
      } else {
        tmp_42 = it_17;
      }
      var tmp$ret$133 = tmp_42;
      IconButton(tmp0_group_1, tmp_41, false, null, null, null, tmp$ret$133, $composer_37, 1572864, 60);
      var tmp_43 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$140 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_43, tmp$ret$140), $composer_37, 6);
      sourceInformationMarkerStart($composer_37, 893580394, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_7 = $composer_37.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_18 = $composer_37.i31();
      var tmp_44;
      if (invalid_7 || it_18 === Companion_getInstance().f30_1) {
        var value_18 = BeadsProductDetailsScreen$lambda_22(viewModel);
        $composer_37.j31(value_18);
        tmp_44 = value_18;
      } else {
        tmp_44 = it_18;
      }
      var tmp1_group_0 = tmp_44;
      sourceInformationMarkerEnd($composer_37);
      var tmp_45 = background(Companion_instance, Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.7), get_CircleShape());
      IconButton(tmp1_group_0, tmp_45, false, null, null, null, ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().d13a_1, $composer_37, 1572864, 60);
      sourceInformationMarkerEnd($composer_37);
      $composer_35.e31();
      sourceInformationMarkerEnd($composer_32);
      $composer_30.e31();
      var tmp_46 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$145 = _Dp___init__impl__ms3zkb(16);
      var tmp4_modifier = zIndex(padding_1(tmp_46, VOID, VOID, VOID, tmp$ret$145), 1.0);
      var tmp5_color = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_26, 6).eo0_1, 0.8);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$146 = _Dp___init__impl__ms3zkb(24);
      var tmp6_shape = RoundedCornerShape(tmp$ret$146);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp7_shadowElevation = _Dp___init__impl__ms3zkb(6);
      sourceInformationMarkerStart($composer_26, 108708317, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_8 = $composer_26.k31(pagerState);
      // Inline function 'kotlin.let' call
      var it_19 = $composer_26.i31();
      var tmp_47;
      if (invalid_8 || it_19 === Companion_getInstance().f30_1) {
        var value_19 = BeadsProductDetailsScreen$lambda_23(pagerState, initialMediaIndex$delegate, showMediaDialog$delegate);
        $composer_26.j31(value_19);
        tmp_47 = value_19;
      } else {
        tmp_47 = it_19;
      }
      var tmp0_group_2 = tmp_47;
      sourceInformationMarkerEnd($composer_26);
      var tmp_48 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_49 = _Dp___init__impl__ms3zkb(0.0);
      Surface_0(tmp0_group_2, tmp4_modifier, false, tmp6_shape, tmp5_color, tmp_48, tmp_49, tmp7_shadowElevation, null, null, ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().e13a_1, $composer_26, 12582912, 6, 868);
      if (combinedMedia.n1() > 1) {
        $composer_26.m30(-923174050);
        sourceInformation($composer_26, '335@15995L1136');
        var tmp_50 = BoxScopeInstance_instance.udr(fillMaxWidth(Companion_instance), Companion_getInstance_11().r8t_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$152 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_13 = padding_1(tmp_50, VOID, VOID, VOID, tmp$ret$152);
        var horizontalArrangement_1 = Arrangement_getInstance().udp_1;
        var verticalAlignment_1 = null;
        var $composer_39 = $composer_26;
        if (!((4 & 1) === 0))
          modifier_13 = Companion_instance;
        if (!((4 & 2) === 0))
          horizontalArrangement_1 = Arrangement_getInstance().qdp_1;
        if (!((4 & 4) === 0))
          verticalAlignment_1 = Companion_getInstance_11().t8t_1;
        var measurePolicy_6 = rowMeasurePolicy(horizontalArrangement_1, verticalAlignment_1, $composer_39, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_14 = modifier_13;
        var $composer_40 = $composer_39;
        if (!((0 & 2) === 0))
          modifier_14 = Companion_instance;
        var compositeKeyHash_6 = get_currentCompositeKeyHashCode($composer_40, 0).hashCode();
        var localMap_6 = $composer_40.t31();
        var materialized_6 = materialize($composer_40, modifier_14);
        var tmp0_11 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_41 = $composer_40;
        var tmp_51 = $composer_41.g30();
        if (!isInterface(tmp_51, Applier)) {
          invalidApplier();
        }
        $composer_41.b31();
        if ($composer_41.h30()) {
          $composer_41.c31(tmp0_11);
        } else {
          $composer_41.d31();
        }
        var $this$ReusableComposeNode_6 = _Updater___init__impl__rbfxm8($composer_41);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, measurePolicy_6, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, localMap_6, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, compositeKeyHash_6, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_6, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, materialized_6, Companion_getInstance_12().qah_1);
        var $composer_42 = $composer_41;
        var $composer_43 = $composer_42;
        sourceInformationMarkerStart($composer_43, 744388868, 'C:BeadsProductDetailsScreen.kt#8gd4xm');
        $composer_43.m30(-1084366113);
        sourceInformation($composer_43, '*347@16724L343');
        // Inline function 'kotlin.repeat' call
        var times = combinedMedia.n1();
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp_52;
            if (pagerState.zj9() === index) {
              $composer_43.m30(-1358002510);
              sourceInformation($composer_43, '344@16546L11');
              var tmp0_group_3 = MaterialTheme_instance.unz($composer_43, 6).xnz_1;
              $composer_43.n30();
              tmp_52 = tmp0_group_3;
            } else {
              $composer_43.m30(-1358001613);
              $composer_43.n30();
              tmp_52 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.6);
            }
            var color = tmp_52;
            var tmp_53 = Companion_instance;
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$161 = _Dp___init__impl__ms3zkb(4);
            var tmp_54 = background(clip(padding_0(tmp_53, tmp$ret$161), get_CircleShape()), color);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$162 = _Dp___init__impl__ms3zkb(8);
            Box(size(tmp_54, tmp$ret$162), $composer_43, 0);
          }
           while (inductionVariable < times);
        $composer_43.n30();
        sourceInformationMarkerEnd($composer_43);
        $composer_41.e31();
        $composer_26.n30();
      } else {
        $composer_26.m30(-922028538);
        $composer_26.n30();
      }
      sourceInformationMarkerEnd($composer_26);
      $composer_24.e31();
      if (combinedMedia.n1() > 1) {
        $composer_21.m30(521335884);
        sourceInformation($composer_21, '366@17606L2913,360@17255L3264');
        var tmp_55 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$163 = _Dp___init__impl__ms3zkb(16);
        var tmp2_modifier = padding_2(tmp_55, VOID, tmp$ret$163);
        var tmp_56 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$164 = _Dp___init__impl__ms3zkb(12);
        var tmp3_horizontalArrangement = tmp_56.mdq(tmp$ret$164);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$165 = _Dp___init__impl__ms3zkb(24);
        var tmp4_contentPadding = PaddingValues_0(tmp$ret$165);
        sourceInformationMarkerStart($composer_21, -537361161, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_9 = !!($composer_21.q31(combinedMedia) | $composer_21.k31(pagerState));
        // Inline function 'kotlin.let' call
        var it_20 = $composer_21.i31();
        var tmp_57;
        if (invalid_9 || it_20 === Companion_getInstance().f30_1) {
          var value_20 = BeadsProductDetailsScreen$lambda_24(combinedMedia, pagerState, initialMediaIndex$delegate, showMediaDialog$delegate);
          $composer_21.j31(value_20);
          tmp_57 = value_20;
        } else {
          tmp_57 = it_20;
        }
        var tmp0_group_4 = tmp_57;
        sourceInformationMarkerEnd($composer_21);
        LazyRow(tmp2_modifier, null, tmp4_contentPadding, false, tmp3_horizontalArrangement, null, null, false, null, tmp0_group_4, $composer_21, 24966, 490);
        $composer_21.n30();
      } else {
        $composer_21.m30(524503123);
        sourceInformation($composer_21, '415@20573L41');
        var tmp_58 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$170 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_58, tmp$ret$170), $composer_21, 6);
        $composer_21.n30();
      }
      var tmp_59 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$171 = _Dp___init__impl__ms3zkb(24);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_15 = padding_2(tmp_59, tmp$ret$171);
      var verticalArrangement_1 = null;
      var horizontalAlignment_1 = null;
      var $composer_44 = $composer_21;
      if (!((6 & 1) === 0))
        modifier_15 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement_1 = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment_1 = Companion_getInstance_11().w8t_1;
      var measurePolicy_7 = columnMeasurePolicy(verticalArrangement_1, horizontalAlignment_1, $composer_44, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_16 = modifier_15;
      var $composer_45 = $composer_44;
      if (!((0 & 2) === 0))
        modifier_16 = Companion_instance;
      var compositeKeyHash_7 = get_currentCompositeKeyHashCode($composer_45, 0).hashCode();
      var localMap_7 = $composer_45.t31();
      var materialized_7 = materialize($composer_45, modifier_16);
      var tmp0_12 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_46 = $composer_45;
      var tmp_60 = $composer_46.g30();
      if (!isInterface(tmp_60, Applier)) {
        invalidApplier();
      }
      $composer_46.b31();
      if ($composer_46.h30()) {
        $composer_46.c31(tmp0_12);
      } else {
        $composer_46.d31();
      }
      var $this$ReusableComposeNode_7 = _Updater___init__impl__rbfxm8($composer_46);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_7, measurePolicy_7, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_7, localMap_7, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_7, compositeKeyHash_7, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_7, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_7, materialized_7, Companion_getInstance_12().qah_1);
      var $composer_47 = $composer_46;
      var $composer_48 = $composer_47;
      sourceInformationMarkerStart($composer_48, -792489533, 'C419@20740L662,433@21428L41,435@21495L5276,518@26797L40,525@27333L318,532@27689L22,533@27755L22,537@27993L403,523@27214L1208,547@28448L41,552@28723L10,553@28795L11,549@28515L435,558@28976L41,779@41679L41,782@41866L401,795@42583L399,780@41745L1263,804@43033L41,806@43100L218,812@43344L41,847@45231L41:BeadsProductDetailsScreen.kt#8gd4xm');
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_17 = fillMaxWidth(Companion_instance);
      var horizontalArrangement_2 = Arrangement_getInstance().wdp_1;
      var verticalAlignment_2 = Companion_getInstance_11().t8t_1;
      var $composer_49 = $composer_48;
      if (!((0 & 1) === 0))
        modifier_17 = Companion_instance;
      if (!((0 & 2) === 0))
        horizontalArrangement_2 = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment_2 = Companion_getInstance_11().t8t_1;
      var measurePolicy_8 = rowMeasurePolicy(horizontalArrangement_2, verticalAlignment_2, $composer_49, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_18 = modifier_17;
      var $composer_50 = $composer_49;
      if (!((0 & 2) === 0))
        modifier_18 = Companion_instance;
      var compositeKeyHash_8 = get_currentCompositeKeyHashCode($composer_50, 0).hashCode();
      var localMap_8 = $composer_50.t31();
      var materialized_8 = materialize($composer_50, modifier_18);
      var tmp0_13 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_51 = $composer_50;
      var tmp_61 = $composer_51.g30();
      if (!isInterface(tmp_61, Applier)) {
        invalidApplier();
      }
      $composer_51.b31();
      if ($composer_51.h30()) {
        $composer_51.c31(tmp0_13);
      } else {
        $composer_51.d31();
      }
      var $this$ReusableComposeNode_8 = _Updater___init__impl__rbfxm8($composer_51);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_8, measurePolicy_8, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_8, localMap_8, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_8, compositeKeyHash_8, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_8, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_8, materialized_8, Companion_getInstance_12().qah_1);
      var $composer_52 = $composer_51;
      var $composer_53 = $composer_52;
      sourceInformationMarkerStart($composer_53, 1650746784, 'C426@21110L10,428@21258L11,424@21005L371:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp0_style = MaterialTheme_instance.jog($composer_53, 6).jof_1;
      var tmp1_fontWeight = Companion_getInstance_16().f7z_1;
      var tmp2_color = MaterialTheme_instance.unz($composer_53, 6).lo0_1;
      var tmp3_modifier = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
      var tmp_62 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_63 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_64 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_65 = _TextOverflow___init__impl__obguoe(0);
      Text(name, tmp3_modifier, tmp2_color, null, tmp_62, null, tmp1_fontWeight, null, tmp_63, null, null, tmp_64, tmp_65, false, 0, 0, null, tmp0_style, $composer_53, 1572864, 0, 131000);
      sourceInformationMarkerEnd($composer_53);
      $composer_51.e31();
      var tmp_66 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$184 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_66, tmp$ret$184), $composer_48, 6);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_19 = null;
      var verticalArrangement_2 = null;
      var horizontalAlignment_2 = null;
      var $composer_54 = $composer_48;
      if (!((7 & 1) === 0))
        modifier_19 = Companion_instance;
      if (!((7 & 2) === 0))
        verticalArrangement_2 = Arrangement_getInstance().sdp_1;
      if (!((7 & 4) === 0))
        horizontalAlignment_2 = Companion_getInstance_11().w8t_1;
      var measurePolicy_9 = columnMeasurePolicy(verticalArrangement_2, horizontalAlignment_2, $composer_54, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_20 = modifier_19;
      var $composer_55 = $composer_54;
      if (!((0 & 2) === 0))
        modifier_20 = Companion_instance;
      var compositeKeyHash_9 = get_currentCompositeKeyHashCode($composer_55, 0).hashCode();
      var localMap_9 = $composer_55.t31();
      var materialized_9 = materialize($composer_55, modifier_20);
      var tmp0_14 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_56 = $composer_55;
      var tmp_67 = $composer_56.g30();
      if (!isInterface(tmp_67, Applier)) {
        invalidApplier();
      }
      $composer_56.b31();
      if ($composer_56.h30()) {
        $composer_56.c31(tmp0_14);
      } else {
        $composer_56.d31();
      }
      var $this$ReusableComposeNode_9 = _Updater___init__impl__rbfxm8($composer_56);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_9, measurePolicy_9, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_9, localMap_9, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_9, compositeKeyHash_9, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_9, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_9, materialized_9, Companion_getInstance_12().qah_1);
      var $composer_57 = $composer_56;
      var $composer_58 = $composer_57;
      sourceInformationMarkerStart($composer_58, 949778468, 'C445@22482L3404:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp0_safe_receiver = BeadsProductDetailsScreen$lambda(state$delegate).j138_1;
      var tmp1_elvis_lhs_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lyz_1;
      var tmp_68 = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
      var tmp2_safe_receiver = BeadsProductDetailsScreen$lambda(state$delegate).n138_1;
      var tmp3_elvis_lhs_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.wyz_1;
      var tmp_69 = tmp_68 + (tmp3_elvis_lhs_0 == null ? 0.0 : tmp3_elvis_lhs_0);
      // Inline function 'kotlin.collections.sumOf' call
      var sum = 0;
      var _iterator__ex2g4s_1 = BeadsProductDetailsScreen$lambda(state$delegate).t138_1.y2().t();
      while (_iterator__ex2g4s_1.u()) {
        var element_1 = _iterator__ex2g4s_1.v();
        var tmp_70 = sum;
        var tmp0_elvis_lhs_1 = element_1.q100_1;
        sum = tmp_70 + (tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1);
      }
      var extraOriginalPrice = tmp_69 + sum;
      var tmp4_safe_receiver = BeadsProductDetailsScreen$lambda(state$delegate).j138_1;
      var tmp5_elvis_lhs_0 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.lyz_1;
      var tmp_71 = tmp5_elvis_lhs_0 == null ? 0.0 : tmp5_elvis_lhs_0;
      var tmp6_safe_receiver = BeadsProductDetailsScreen$lambda(state$delegate).n138_1;
      var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.wyz_1;
      var tmp_72 = tmp_71 + (tmp7_elvis_lhs == null ? 0.0 : tmp7_elvis_lhs);
      // Inline function 'kotlin.collections.sumOf' call
      var sum_0 = 0;
      var _iterator__ex2g4s_2 = BeadsProductDetailsScreen$lambda(state$delegate).t138_1.y2().t();
      while (_iterator__ex2g4s_2.u()) {
        var element_2 = _iterator__ex2g4s_2.v();
        var tmp_73 = sum_0;
        var tmp_74;
        var tmp0_elvis_lhs_2 = element_2.r100_1;
        if ((tmp0_elvis_lhs_2 == null ? 0.0 : tmp0_elvis_lhs_2) > 0.0) {
          tmp_74 = ensureNotNull(element_2.r100_1);
        } else {
          var tmp1_elvis_lhs_1 = element_2.q100_1;
          tmp_74 = tmp1_elvis_lhs_1 == null ? 0.0 : tmp1_elvis_lhs_1;
        }
        sum_0 = tmp_73 + tmp_74;
      }
      var extraDiscountedPrice = tmp_72 + sum_0;
      var tmp8_elvis_lhs_0 = activeProduct.szt_1;
      var finalOriginalPrice = (tmp8_elvis_lhs_0 == null ? 0.0 : tmp8_elvis_lhs_0) + extraOriginalPrice;
      var tmp_75;
      var tmp9_elvis_lhs = activeProduct.tzt_1;
      if ((tmp9_elvis_lhs == null ? 0.0 : tmp9_elvis_lhs) > 0.0) {
        tmp_75 = ensureNotNull(activeProduct.tzt_1);
      } else {
        var tmp10_elvis_lhs_0 = activeProduct.szt_1;
        tmp_75 = tmp10_elvis_lhs_0 == null ? 0.0 : tmp10_elvis_lhs_0;
      }
      var finalDiscountedPrice = tmp_75 + extraDiscountedPrice;
      var tmp_76;
      var tmp11_elvis_lhs = activeProduct.tzt_1;
      if ((tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs) > 0.0) {
        tmp_76 = true;
      } else {
        var tmp0_15 = BeadsProductDetailsScreen$lambda(state$delegate).t138_1.y2();
        var tmp$ret$195;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_77;
          if (isInterface(tmp0_15, Collection)) {
            tmp_77 = tmp0_15.r();
          } else {
            tmp_77 = false;
          }
          if (tmp_77) {
            tmp$ret$195 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s_3 = tmp0_15.t();
          while (_iterator__ex2g4s_3.u()) {
            var element_3 = _iterator__ex2g4s_3.v();
            var tmp0_elvis_lhs_3 = element_3.r100_1;
            if ((tmp0_elvis_lhs_3 == null ? 0.0 : tmp0_elvis_lhs_3) > 0.0) {
              tmp$ret$195 = true;
              break $l$block_0;
            }
          }
          tmp$ret$195 = false;
        }
        tmp_76 = tmp$ret$195;
      }
      var hasDiscount = tmp_76;
      var tmp12_elvis_lhs = activeProduct.uzt_1;
      var hasDiscountPercent = (tmp12_elvis_lhs == null ? 0.0 : tmp12_elvis_lhs) > 0.0;
      var tmp13_verticalAlignment = Companion_getInstance_11().v8t_1;
      var tmp_78 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$197 = _Dp___init__impl__ms3zkb(12);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_21 = null;
      var horizontalArrangement_3 = tmp_78.mdq(tmp$ret$197);
      var verticalAlignment_3 = tmp13_verticalAlignment;
      var $composer_59 = $composer_58;
      if (!((1 & 1) === 0))
        modifier_21 = Companion_instance;
      if (!((1 & 2) === 0))
        horizontalArrangement_3 = Arrangement_getInstance().qdp_1;
      if (!((1 & 4) === 0))
        verticalAlignment_3 = Companion_getInstance_11().t8t_1;
      var measurePolicy_10 = rowMeasurePolicy(horizontalArrangement_3, verticalAlignment_3, $composer_59, 14 & 432 >> 3 | 112 & 432 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_22 = modifier_21;
      var $composer_60 = $composer_59;
      if (!((0 & 2) === 0))
        modifier_22 = Companion_instance;
      var compositeKeyHash_10 = get_currentCompositeKeyHashCode($composer_60, 0).hashCode();
      var localMap_10 = $composer_60.t31();
      var materialized_10 = materialize($composer_60, modifier_22);
      var tmp0_16 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_61 = $composer_60;
      var tmp_79 = $composer_61.g30();
      if (!isInterface(tmp_79, Applier)) {
        invalidApplier();
      }
      $composer_61.b31();
      if ($composer_61.h30()) {
        $composer_61.c31(tmp0_16);
      } else {
        $composer_61.d31();
      }
      var $this$ReusableComposeNode_10 = _Updater___init__impl__rbfxm8($composer_61);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_10, measurePolicy_10, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_10, localMap_10, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_10, compositeKeyHash_10, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_10, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_10, materialized_10, Companion_getInstance_12().qah_1);
      var $composer_62 = $composer_61;
      var $composer_63 = $composer_62;
      sourceInformationMarkerStart($composer_63, 1969105422, 'C:BeadsProductDetailsScreen.kt#8gd4xm');
      if (hasDiscount) {
        $composer_63.m30(1969064470);
        sourceInformation($composer_63, '451@22813L209,456@23168L11,450@22760L536,460@23386L207,465@23739L11,459@23333L641');
        var tmp0_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalDiscountedPrice)], $composer_63, 0), language);
        var tmp1_fontSize = get_sp(28);
        var tmp2_color_0 = MaterialTheme_instance.unz($composer_63, 6).xnz_1;
        var tmp3_fontWeight = Companion_getInstance_16().g7z_1;
        var tmp_80 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_81 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_82 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp2_color_0, null, tmp1_fontSize, null, tmp3_fontWeight, null, tmp_80, null, null, tmp_81, tmp_82, false, 0, 0, null, null, $composer_63, 1597440, 0, 262058);
        var tmp4_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_63, 0), language);
        var tmp5_fontSize = get_sp(18);
        var tmp6_color = MaterialTheme_instance.unz($composer_63, 6).po0_1;
        var tmp7_textDecoration = Companion_getInstance_18().c80_1;
        var tmp_83 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$204 = _Dp___init__impl__ms3zkb(4);
        var tmp8_modifier = padding_1(tmp_83, VOID, VOID, VOID, tmp$ret$204);
        var tmp_84 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_85 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_86 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp4_text, tmp8_modifier, tmp6_color, null, tmp5_fontSize, null, null, null, tmp_84, tmp7_textDecoration, null, tmp_85, tmp_86, false, 0, 0, null, null, $composer_63, 805330992, 0, 261608);
        $composer_63.n30();
      } else {
        $composer_63.m30(1970360518);
        sourceInformation($composer_63, '471@24105L207,476@24458L11,470@24052L534');
        var tmp9_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_63, 0), language);
        var tmp10_fontSize = get_sp(28);
        var tmp11_color = MaterialTheme_instance.unz($composer_63, 6).xnz_1;
        var tmp12_fontWeight = Companion_getInstance_16().g7z_1;
        var tmp_87 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_88 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_89 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp9_text, null, tmp11_color, null, tmp10_fontSize, null, tmp12_fontWeight, null, tmp_87, null, null, tmp_88, tmp_89, false, 0, 0, null, null, $composer_63, 1597440, 0, 262058);
        $composer_63.n30();
      }
      if (hasDiscountPercent) {
        $composer_63.m30(1971036938);
        sourceInformation($composer_63, '483@24787L11,486@25001L821,482@24716L1106');
        var tmp13_color = MaterialTheme_instance.unz($composer_63, 6).to0_1;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$205 = _Dp___init__impl__ms3zkb(8);
        var tmp14_shape = RoundedCornerShape(tmp$ret$205);
        var tmp_90 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$206 = _Dp___init__impl__ms3zkb(6);
        var tmp15_modifier = padding_1(tmp_90, VOID, VOID, VOID, tmp$ret$206);
        var tmp_91 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_92 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_93 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(1430649203, true, BeadsProductDetailsScreen$lambda_25(activeProduct, language), $composer_63, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_64 = $composer_63;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_10 = $composer_64.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_21 = $composer_64.i31();
        var tmp_94;
        if (invalid_10 || it_21 === Companion_getInstance().f30_1) {
          var value_21 = ComposableLambda$invoke$ref(dispatchReceiver_1);
          $composer_64.j31(value_21);
          tmp_94 = value_21;
        } else {
          tmp_94 = it_21;
        }
        var tmp$ret$207 = tmp_94;
        Surface(tmp15_modifier, tmp14_shape, tmp13_color, tmp_91, tmp_92, tmp_93, null, tmp$ret$207, $composer_63, 12582918, 120);
        $composer_63.n30();
      } else {
        $composer_63.m30(1972133532);
        $composer_63.n30();
      }
      sourceInformationMarkerEnd($composer_63);
      $composer_61.e31();
      if (BeadsProductDetailsScreen$lambda(state$delegate).c138_1 > 1) {
        $composer_58.m30(954014555);
        sourceInformation($composer_58, '506@26110L44,506@26164L187,510@26435L10,511@26517L11,505@26061L654');
        var totalPrice = finalDiscountedPrice * BeadsProductDetailsScreen$lambda(state$delegate).c138_1;
        var tmp15_text = stringResource(get_total_price_label(string_instance), $composer_58, 0) + ': ' + formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(totalPrice)], $composer_58, 0), language);
        var tmp16_style = MaterialTheme_instance.jog($composer_58, 6).mof_1;
        var tmp17_color = MaterialTheme_instance.unz($composer_58, 6).co0_1;
        var tmp18_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp_95 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$214 = _Dp___init__impl__ms3zkb(4);
        var tmp19_modifier = padding_1(tmp_95, VOID, tmp$ret$214);
        var tmp_96 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_97 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_98 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_99 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp15_text, tmp19_modifier, tmp17_color, null, tmp_96, null, tmp18_fontWeight, null, tmp_97, null, null, tmp_98, tmp_99, false, 0, 0, null, tmp16_style, $composer_58, 1572912, 0, 131000);
        $composer_58.n30();
      } else {
        $composer_58.m30(954788160);
        $composer_58.n30();
      }
      sourceInformationMarkerEnd($composer_58);
      $composer_56.e31();
      var tmp_100 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$215 = _Dp___init__impl__ms3zkb(8);
      Spacer(height(tmp_100, tmp$ret$215), $composer_48, 6);
      var tmp_101;
      if (language === 'en') {
        var tmp0_elvis_lhs_4 = activeProduct.vzu_1;
        tmp_101 = tmp0_elvis_lhs_4 == null ? activeProduct.wzu_1 : tmp0_elvis_lhs_4;
      } else {
        var tmp1_elvis_lhs_2 = activeProduct.wzu_1;
        tmp_101 = tmp1_elvis_lhs_2 == null ? activeProduct.vzu_1 : tmp1_elvis_lhs_2;
      }
      var tmp2_elvis_lhs_0 = tmp_101;
      var tmp_102;
      if (tmp2_elvis_lhs_0 == null) {
        $composer_48.m30(-1549407715);
        sourceInformation($composer_48, '520@27040L49');
        var tmp0_group_5 = stringResource(get_enter_text_placeholder(string_instance), $composer_48, 0);
        $composer_48.n30();
        tmp_102 = tmp0_group_5;
      } else {
        $composer_48.m30(-1549412613);
        $composer_48.n30();
        tmp_102 = tmp2_elvis_lhs_0;
      }
      var braceletHint = tmp_102;
      var tmp3_elvis_lhs_1 = activeProduct.uzu_1;
      var maxChars = tmp3_elvis_lhs_1 == null ? 15 : tmp3_elvis_lhs_1;
      var tmp4_value = BeadsProductDetailsScreen$lambda(state$delegate).v138_1;
      var tmp5_modifier = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$216 = _Dp___init__impl__ms3zkb(12);
      var tmp6_shape_0 = RoundedCornerShape(tmp$ret$216);
      sourceInformationMarkerStart($composer_48, -1549398070, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_11 = !!($composer_48.m31(maxChars) | $composer_48.q31(viewModel));
      // Inline function 'kotlin.let' call
      var it_22 = $composer_48.i31();
      var tmp_103;
      if (invalid_11 || it_22 === Companion_getInstance().f30_1) {
        var value_22 = BeadsProductDetailsScreen$lambda_26(maxChars, viewModel);
        $composer_48.j31(value_22);
        tmp_103 = value_22;
      } else {
        tmp_103 = it_22;
      }
      var tmp1_group_1 = tmp_103;
      sourceInformationMarkerEnd($composer_48);
      // Inline function 'kotlin.run' call
      var dispatchReceiver_2 = rememberComposableLambda(1364927430, true, BeadsProductDetailsScreen$lambda_27(braceletHint), $composer_48, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_65 = $composer_48;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_12 = $composer_65.k31(dispatchReceiver_2);
      // Inline function 'kotlin.let' call
      var it_23 = $composer_65.i31();
      var tmp_104;
      if (invalid_12 || it_23 === Companion_getInstance().f30_1) {
        var value_23 = ComposableLambda$invoke$ref(dispatchReceiver_2);
        $composer_65.j31(value_23);
        tmp_104 = value_23;
      } else {
        tmp_104 = it_23;
      }
      var tmp_105 = tmp_104;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_3 = rememberComposableLambda(1861109029, true, BeadsProductDetailsScreen$lambda_28(braceletHint), $composer_48, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_66 = $composer_48;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_13 = $composer_66.k31(dispatchReceiver_3);
      // Inline function 'kotlin.let' call
      var it_24 = $composer_66.i31();
      var tmp_106;
      if (invalid_13 || it_24 === Companion_getInstance().f30_1) {
        var value_24 = ComposableLambda$invoke$ref(dispatchReceiver_3);
        $composer_66.j31(value_24);
        tmp_106 = value_24;
      } else {
        tmp_106 = it_24;
      }
      var tmp_107 = tmp_106;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_4 = rememberComposableLambda(-2042235501, true, BeadsProductDetailsScreen$lambda_29(maxChars, state$delegate), $composer_48, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_67 = $composer_48;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_14 = $composer_67.k31(dispatchReceiver_4);
      // Inline function 'kotlin.let' call
      var it_25 = $composer_67.i31();
      var tmp_108;
      if (invalid_14 || it_25 === Companion_getInstance().f30_1) {
        var value_25 = ComposableLambda$invoke$ref(dispatchReceiver_4);
        $composer_67.j31(value_25);
        tmp_108 = value_25;
      } else {
        tmp_108 = it_25;
      }
      var tmp_109 = tmp_108;
      OutlinedTextField(tmp4_value, tmp1_group_1, tmp5_modifier, false, false, null, tmp_105, tmp_107, null, null, null, null, tmp_109, false, null, null, null, false, 1, 0, null, tmp6_shape_0, null, $composer_48, 14156160, 100663680, 0, 6025016);
      var tmp_110 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$242 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_110, tmp$ret$242), $composer_48, 6);
      // Inline function 'kotlin.takeIf' call
      var tmp_111;
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(description)) {
        tmp_111 = description;
      } else {
        tmp_111 = null;
      }
      var tmp7_elvis_lhs_0 = tmp_111;
      var tmp_112;
      if (tmp7_elvis_lhs_0 == null) {
        $composer_48.m30(-1549356843);
        sourceInformation($composer_48, '551@28630L41');
        var tmp2_group_0 = stringResource(get_no_description(string_instance), $composer_48, 0);
        $composer_48.n30();
        tmp_112 = tmp2_group_0;
      } else {
        $composer_48.m30(-1549359137);
        $composer_48.n30();
        tmp_112 = tmp7_elvis_lhs_0;
      }
      var tmp8_text = tmp_112;
      var tmp9_style = MaterialTheme_instance.jog($composer_48, 6).oof_1;
      var tmp10_color = MaterialTheme_instance.unz($composer_48, 6).no0_1;
      var tmp11_lineHeight = get_sp(24);
      var tmp12_fontWeight_0 = Companion_getInstance_16().c7z_1;
      var tmp_113 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_114 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_115 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp8_text, null, tmp10_color, null, tmp_113, null, tmp12_fontWeight_0, null, tmp_114, null, null, tmp11_lineHeight, tmp_115, false, 0, 0, null, tmp9_style, $composer_48, 1572864, 48, 128954);
      var tmp_116 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$246 = _Dp___init__impl__ms3zkb(24);
      Spacer(height(tmp_116, tmp$ret$246), $composer_48, 6);
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!BeadsProductDetailsScreen$lambda(state$delegate).w138_1.r()) {
        $composer_48.m30(-784834208);
        sourceInformation($composer_48, '562@29174L38,565@29407L349,561@29112L727,635@33549L41');
        var tmp_117 = stringResource(get_select_card(string_instance), $composer_48, 0);
        var tmp_118 = BeadsProductDetailsScreen$lambda(state$delegate).w138_1;
        var tmp13_safe_receiver = BeadsProductDetailsScreen$lambda(state$delegate).j138_1;
        var tmp_119 = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.gyz_1;
        sourceInformationMarkerStart($composer_48, -1549331671, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_15 = $composer_48.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_26 = $composer_48.i31();
        var tmp_120;
        if (invalid_15 || it_26 === Companion_getInstance().f30_1) {
          var value_26 = BeadsProductDetailsScreen$lambda_30(viewModel);
          $composer_48.j31(value_26);
          tmp_120 = value_26;
        } else {
          tmp_120 = it_26;
        }
        var tmp3_group_0 = tmp_120;
        sourceInformationMarkerEnd($composer_48);
        GiftSelectionSection(tmp_117, tmp_118, tmp_119, tmp3_group_0, language, false, $composer_48, 0, 32);
        var tmp17_safe_receiver = BeadsProductDetailsScreen$lambda(state$delegate).j138_1;
        if ((tmp17_safe_receiver == null ? null : tmp17_safe_receiver.oyz_1) === true) {
          $composer_48.m30(-784099322);
          sourceInformation($composer_48, '576@29946L41,579@30154L461,593@31077L451,577@30020L1542');
          var tmp_121 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$252 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_121, tmp$ret$252), $composer_48, 6);
          var tmp14_value = BeadsProductDetailsScreen$lambda(state$delegate).k138_1;
          var tmp15_modifier_0 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$253 = _Dp___init__impl__ms3zkb(12);
          var tmp16_shape = RoundedCornerShape(tmp$ret$253);
          sourceInformationMarkerStart($composer_48, -1549307655, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_16 = $composer_48.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_27 = $composer_48.i31();
          var tmp_122;
          if (invalid_16 || it_27 === Companion_getInstance().f30_1) {
            var value_27 = BeadsProductDetailsScreen$lambda_31(viewModel);
            $composer_48.j31(value_27);
            tmp_122 = value_27;
          } else {
            tmp_122 = it_27;
          }
          var tmp4_group_0 = tmp_122;
          sourceInformationMarkerEnd($composer_48);
          var tmp_123 = ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().f13a_1;
          var tmp_124 = ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().g13a_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_5 = rememberComposableLambda(1310557321, true, BeadsProductDetailsScreen$lambda_32(state$delegate), $composer_48, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_68 = $composer_48;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_17 = $composer_68.k31(dispatchReceiver_5);
          // Inline function 'kotlin.let' call
          var it_28 = $composer_68.i31();
          var tmp_125;
          if (invalid_17 || it_28 === Companion_getInstance().f30_1) {
            var value_28 = ComposableLambda$invoke$ref(dispatchReceiver_5);
            $composer_68.j31(value_28);
            tmp_125 = value_28;
          } else {
            tmp_125 = it_28;
          }
          var tmp_126 = tmp_125;
          OutlinedTextField(tmp14_value, tmp4_group_0, tmp15_modifier_0, false, false, null, tmp_123, tmp_124, null, null, null, null, tmp_126, false, null, null, null, false, 1, 0, null, tmp16_shape, null, $composer_48, 14156160, 100663680, 0, 6025016);
          $composer_48.n30();
        } else {
          $composer_48.m30(-782484842);
          $composer_48.n30();
        }
        var tmp24_safe_receiver = BeadsProductDetailsScreen$lambda(state$delegate).j138_1;
        if ((tmp24_safe_receiver == null ? null : tmp24_safe_receiver.pyz_1) === true) {
          $composer_48.m30(-782353960);
          sourceInformation($composer_48, '605@31700L41,612@32191L188,608@31909L3,621@32806L581,606@31774L1716');
          var tmp_127 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$265 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_127, tmp$ret$265), $composer_48, 6);
          var tmp18_value = BeadsProductDetailsScreen$lambda(state$delegate).l138_1;
          var tmp_128 = fillMaxWidth(Companion_instance);
          sourceInformationMarkerStart($composer_48, -1549242744, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_29 = $composer_48.i31();
          var tmp_129;
          if (false || it_29 === Companion_getInstance().f30_1) {
            var value_29 = BeadsProductDetailsScreen$lambda_33(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
            $composer_48.j31(value_29);
            tmp_129 = value_29;
          } else {
            tmp_129 = it_29;
          }
          var tmp5_group_0 = tmp_129;
          sourceInformationMarkerEnd($composer_48);
          var tmp19_modifier_0 = clickable(tmp_128, VOID, VOID, VOID, VOID, tmp5_group_0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$270 = _Dp___init__impl__ms3zkb(12);
          var tmp20_shape = RoundedCornerShape(tmp$ret$270);
          var tmp21_isError = BeadsProductDetailsScreen$lambda(state$delegate).m138_1;
          var tmp_130;
          if (BeadsProductDetailsScreen$lambda(state$delegate).m138_1) {
            tmp_130 = ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().h13a_1;
          } else {
            tmp_130 = null;
          }
          var tmp22_supportingText = tmp_130;
          var tmp23_enabled = !BeadsProductDetailsScreen$lambda(state$delegate).d138_1;
          sourceInformationMarkerStart($composer_48, -1549251953, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_30 = $composer_48.i31();
          var tmp_131;
          if (false || it_30 === Companion_getInstance().f30_1) {
            var value_30 = BeadsProductDetailsScreen$lambda_34;
            $composer_48.j31(value_30);
            tmp_131 = value_30;
          } else {
            tmp_131 = it_30;
          }
          var tmp6_group_0 = tmp_131;
          sourceInformationMarkerEnd($composer_48);
          var tmp_132 = ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().i13a_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_6 = rememberComposableLambda(-800079984, true, BeadsProductDetailsScreen$lambda_35(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_48, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_69 = $composer_48;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_18 = $composer_69.k31(dispatchReceiver_6);
          // Inline function 'kotlin.let' call
          var it_31 = $composer_69.i31();
          var tmp_133;
          if (invalid_18 || it_31 === Companion_getInstance().f30_1) {
            var value_31 = ComposableLambda$invoke$ref(dispatchReceiver_6);
            $composer_69.j31(value_31);
            tmp_133 = value_31;
          } else {
            tmp_133 = it_31;
          }
          var tmp_134 = tmp_133;
          OutlinedTextField(tmp18_value, tmp6_group_0, tmp19_modifier_0, tmp23_enabled, true, null, tmp_132, null, null, tmp_134, null, null, tmp22_supportingText, tmp21_isError, null, null, null, false, 0, 0, null, tmp20_shape, null, $composer_48, 806903856, 0, 0, 6278560);
          $composer_48.n30();
        } else {
          $composer_48.m30(-780572266);
          $composer_48.n30();
        }
        var tmp_135 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$282 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_135, tmp$ret$282), $composer_48, 6);
        $composer_48.n30();
      } else {
        $composer_48.m30(-780477034);
        $composer_48.n30();
      }
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!BeadsProductDetailsScreen$lambda(state$delegate).x138_1.r()) {
        $composer_48.m30(-780274604);
        sourceInformation($composer_48, '640@33773L37,643@34004L347,639@33711L723');
        var tmp_136 = stringResource(get_select_box(string_instance), $composer_48, 0);
        var tmp_137 = BeadsProductDetailsScreen$lambda(state$delegate).x138_1;
        var tmp25_safe_receiver = BeadsProductDetailsScreen$lambda(state$delegate).n138_1;
        var tmp_138 = tmp25_safe_receiver == null ? null : tmp25_safe_receiver.ryz_1;
        sourceInformationMarkerStart($composer_48, -1549184569, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_19 = $composer_48.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_32 = $composer_48.i31();
        var tmp_139;
        if (invalid_19 || it_32 === Companion_getInstance().f30_1) {
          var value_32 = BeadsProductDetailsScreen$lambda_36(viewModel);
          $composer_48.j31(value_32);
          tmp_139 = value_32;
        } else {
          tmp_139 = it_32;
        }
        var tmp7_group_0 = tmp_139;
        sourceInformationMarkerEnd($composer_48);
        GiftSelectionSection(tmp_136, tmp_137, tmp_138, tmp7_group_0, language, false, $composer_48, 0, 32);
        var tmp29_safe_receiver = BeadsProductDetailsScreen$lambda(state$delegate).n138_1;
        if ((tmp29_safe_receiver == null ? null : tmp29_safe_receiver.zyz_1) === true) {
          $composer_48.m30(-779542167);
          sourceInformation($composer_48, '654@34540L41,657@34747L460,671@35669L450,655@34614L1539');
          var tmp_140 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$288 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_140, tmp$ret$288), $composer_48, 6);
          var tmp26_value = BeadsProductDetailsScreen$lambda(state$delegate).o138_1;
          var tmp27_modifier = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$289 = _Dp___init__impl__ms3zkb(12);
          var tmp28_shape = RoundedCornerShape(tmp$ret$289);
          sourceInformationMarkerStart($composer_48, -1549160680, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_20 = $composer_48.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_33 = $composer_48.i31();
          var tmp_141;
          if (invalid_20 || it_33 === Companion_getInstance().f30_1) {
            var value_33 = BeadsProductDetailsScreen$lambda_37(viewModel);
            $composer_48.j31(value_33);
            tmp_141 = value_33;
          } else {
            tmp_141 = it_33;
          }
          var tmp8_group_0 = tmp_141;
          sourceInformationMarkerEnd($composer_48);
          var tmp_142 = ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().k13a_1;
          var tmp_143 = ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().l13a_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_7 = rememberComposableLambda(1011824448, true, BeadsProductDetailsScreen$lambda_38(state$delegate), $composer_48, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_70 = $composer_48;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_21 = $composer_70.k31(dispatchReceiver_7);
          // Inline function 'kotlin.let' call
          var it_34 = $composer_70.i31();
          var tmp_144;
          if (invalid_21 || it_34 === Companion_getInstance().f30_1) {
            var value_34 = ComposableLambda$invoke$ref(dispatchReceiver_7);
            $composer_70.j31(value_34);
            tmp_144 = value_34;
          } else {
            tmp_144 = it_34;
          }
          var tmp_145 = tmp_144;
          OutlinedTextField(tmp26_value, tmp8_group_0, tmp27_modifier, false, false, null, tmp_142, tmp_143, null, null, null, null, tmp_145, false, null, null, null, false, 1, 0, null, tmp28_shape, null, $composer_48, 14156160, 100663680, 0, 6025016);
          $composer_48.n30();
        } else {
          $composer_48.m30(-777930570);
          $composer_48.n30();
        }
        var tmp36_safe_receiver = BeadsProductDetailsScreen$lambda(state$delegate).n138_1;
        if ((tmp36_safe_receiver == null ? null : tmp36_safe_receiver.az0_1) === true) {
          $composer_48.m30(-777800835);
          sourceInformation($composer_48, '683@36290L41,690@36780L187,686@36498L3,699@37392L580,684@36364L1711');
          var tmp_146 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$301 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_146, tmp$ret$301), $composer_48, 6);
          var tmp30_value = BeadsProductDetailsScreen$lambda(state$delegate).p138_1;
          var tmp_147 = fillMaxWidth(Companion_instance);
          sourceInformationMarkerStart($composer_48, -1549095897, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_35 = $composer_48.i31();
          var tmp_148;
          if (false || it_35 === Companion_getInstance().f30_1) {
            var value_35 = BeadsProductDetailsScreen$lambda_39(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
            $composer_48.j31(value_35);
            tmp_148 = value_35;
          } else {
            tmp_148 = it_35;
          }
          var tmp9_group_0 = tmp_148;
          sourceInformationMarkerEnd($composer_48);
          var tmp31_modifier = clickable(tmp_147, VOID, VOID, VOID, VOID, tmp9_group_0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$306 = _Dp___init__impl__ms3zkb(12);
          var tmp32_shape = RoundedCornerShape(tmp$ret$306);
          var tmp33_isError = BeadsProductDetailsScreen$lambda(state$delegate).q138_1;
          var tmp_149;
          if (BeadsProductDetailsScreen$lambda(state$delegate).q138_1) {
            tmp_149 = ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().m13a_1;
          } else {
            tmp_149 = null;
          }
          var tmp34_supportingText = tmp_149;
          var tmp35_enabled = !BeadsProductDetailsScreen$lambda(state$delegate).d138_1;
          sourceInformationMarkerStart($composer_48, -1549105105, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_36 = $composer_48.i31();
          var tmp_150;
          if (false || it_36 === Companion_getInstance().f30_1) {
            var value_36 = BeadsProductDetailsScreen$lambda_40;
            $composer_48.j31(value_36);
            tmp_150 = value_36;
          } else {
            tmp_150 = it_36;
          }
          var tmp10_group_0 = tmp_150;
          sourceInformationMarkerEnd($composer_48);
          var tmp_151 = ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().n13a_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_8 = rememberComposableLambda(-86061945, true, BeadsProductDetailsScreen$lambda_41(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_48, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_71 = $composer_48;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_22 = $composer_71.k31(dispatchReceiver_8);
          // Inline function 'kotlin.let' call
          var it_37 = $composer_71.i31();
          var tmp_152;
          if (invalid_22 || it_37 === Companion_getInstance().f30_1) {
            var value_37 = ComposableLambda$invoke$ref(dispatchReceiver_8);
            $composer_71.j31(value_37);
            tmp_152 = value_37;
          } else {
            tmp_152 = it_37;
          }
          var tmp_153 = tmp_152;
          OutlinedTextField(tmp30_value, tmp10_group_0, tmp31_modifier, tmp35_enabled, true, null, tmp_151, null, null, tmp_153, null, null, tmp34_supportingText, tmp33_isError, null, null, null, false, 0, 0, null, tmp32_shape, null, $composer_48, 806903856, 0, 0, 6278560);
          $composer_48.n30();
        } else {
          $composer_48.m30(-776023946);
          $composer_48.n30();
        }
        $composer_48.n30();
      } else {
        $composer_48.m30(-775998154);
        $composer_48.n30();
      }
      // Inline function 'kotlin.collections.isNullOrEmpty' call
      var this_11 = activeProduct.lzu_1;
      if (!(this_11 == null || this_11.r())) {
        $composer_48.m30(-775908006);
        sourceInformation($composer_48, '717@38293L38,720@38516L306,716@38229L676');
        var tmp_154 = stringResource(get_select_size(string_instance), $composer_48, 0);
        var tmp_155 = BeadsProductDetailsScreen$lambda(state$delegate).r138_1;
        sourceInformationMarkerStart($composer_48, -1549040226, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_23 = $composer_48.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_38 = $composer_48.i31();
        var tmp_156;
        if (invalid_23 || it_38 === Companion_getInstance().f30_1) {
          var value_38 = BeadsProductDetailsScreen$lambda_42(viewModel);
          $composer_48.j31(value_38);
          tmp_156 = value_38;
        } else {
          tmp_156 = it_38;
        }
        var tmp11_group_0 = tmp_156;
        sourceInformationMarkerEnd($composer_48);
        OptionSelectionSection(tmp_154, activeProduct.lzu_1, tmp_155, tmp11_group_0, language, false, $composer_48, 0, 32);
        $composer_48.n30();
      } else {
        $composer_48.m30(-775204554);
        $composer_48.n30();
      }
      // Inline function 'kotlin.collections.isNullOrEmpty' call
      var this_12 = activeProduct.mzu_1;
      if (!(this_12 == null || this_12.r())) {
        $composer_48.m30(-775113290);
        sourceInformation($composer_48, '733@39094L39,736@39320L307,732@39030L680');
        var tmp_157 = stringResource(get_select_color(string_instance), $composer_48, 0);
        var tmp_158 = BeadsProductDetailsScreen$lambda(state$delegate).s138_1;
        sourceInformationMarkerStart($composer_48, -1549014497, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_24 = $composer_48.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_39 = $composer_48.i31();
        var tmp_159;
        if (invalid_24 || it_39 === Companion_getInstance().f30_1) {
          var value_39 = BeadsProductDetailsScreen$lambda_43(viewModel);
          $composer_48.j31(value_39);
          tmp_159 = value_39;
        } else {
          tmp_159 = it_39;
        }
        var tmp12_group_0 = tmp_159;
        sourceInformationMarkerEnd($composer_48);
        OptionSelectionSection(tmp_157, activeProduct.mzu_1, tmp_158, tmp12_group_0, language, false, $composer_48, 0, 32);
        $composer_48.n30();
      } else {
        $composer_48.m30(-774405994);
        $composer_48.n30();
      }
      var tmp37_safe_receiver = activeProduct.nzu_1;
      if (tmp37_safe_receiver == null) {
        $composer_48.m30(-774289869);
        $composer_48.n30();
      } else {
        $composer_48.m30(-774289868);
        sourceInformation($composer_48, '*751@40051L246,748@39843L537');
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_4 = tmp37_safe_receiver.t();
        while (_iterator__ex2g4s_4.u()) {
          var element_4 = _iterator__ex2g4s_4.v();
          var tmp_160 = BeadsProductDetailsScreen$lambda(state$delegate).t138_1.w2(element_4.r101_1);
          sourceInformationMarkerStart($composer_48, -829053232, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_25 = !!($composer_48.q31(viewModel) | $composer_48.q31(element_4));
          // Inline function 'kotlin.let' call
          var it_40 = $composer_48.i31();
          var tmp_161;
          if (invalid_25 || it_40 === Companion_getInstance().f30_1) {
            var value_40 = BeadsProductDetailsScreen$lambda_44(viewModel, element_4);
            $composer_48.j31(value_40);
            tmp_161 = value_40;
          } else {
            tmp_161 = it_40;
          }
          var tmp0_group_6 = tmp_161;
          sourceInformationMarkerEnd($composer_48);
          OptionSelectionSection_0(element_4, tmp_160, tmp0_group_6, language, false, $composer_48, 0, 16);
          var tmp0_safe_receiver_0 = BeadsProductDetailsScreen$lambda(state$delegate).t138_1.w2(element_4.r101_1);
          if (tmp0_safe_receiver_0 == null) {
            $composer_48.m30(69572488);
            $composer_48.n30();
          } else {
            $composer_48.m30(69572489);
            sourceInformation($composer_48, '');
            // Inline function 'kotlin.let' call
            if (tmp0_safe_receiver_0.w100_1 || tmp0_safe_receiver_0.z100_1 || tmp0_safe_receiver_0.c101_1) {
              $composer_48.m30(992674716);
              sourceInformation($composer_48, '764@40903L284,769@41252L200,760@40622L941');
              sourceInformationMarkerStart($composer_48, 1140409901, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_26 = !!($composer_48.q31(viewModel) | $composer_48.q31(element_4));
              // Inline function 'kotlin.let' call
              var it_41 = $composer_48.i31();
              var tmp_162;
              if (invalid_26 || it_41 === Companion_getInstance().f30_1) {
                var value_41 = BeadsProductDetailsScreen$lambda_45(viewModel, element_4);
                $composer_48.j31(value_41);
                tmp_162 = value_41;
              } else {
                tmp_162 = it_41;
              }
              var tmp0_group_7 = tmp_162;
              sourceInformationMarkerEnd($composer_48);
              sourceInformationMarkerStart($composer_48, 1140420985, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_27 = $composer_48.q31(element_4);
              // Inline function 'kotlin.let' call
              var it_42 = $composer_48.i31();
              var tmp_163;
              if (invalid_27 || it_42 === Companion_getInstance().f30_1) {
                var value_42 = BeadsProductDetailsScreen$lambda_46(element_4, birthdayPickerTargetOptionKey$delegate, showBirthdayPicker$delegate);
                $composer_48.j31(value_42);
                tmp_163 = value_42;
              } else {
                tmp_163 = it_42;
              }
              var tmp1_group_2 = tmp_163;
              sourceInformationMarkerEnd($composer_48);
              SelectedOptionExtraInputs(element_4.r101_1, tmp0_safe_receiver_0, language, tmp0_group_7, tmp1_group_2, !BeadsProductDetailsScreen$lambda(state$delegate).d138_1, $composer_48, 0, 0);
              $composer_48.n30();
            } else {
              $composer_48.m30(993648209);
              $composer_48.n30();
            }
            $composer_48.n30();
          }
        }
        $composer_48.n30();
      }
      var tmp_164 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$344 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_164, tmp$ret$344), $composer_48, 6);
      var tmp38_value = BeadsProductDetailsScreen$lambda(state$delegate).u138_1;
      var tmp39_modifier = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$345 = _Dp___init__impl__ms3zkb(12);
      var tmp40_shape = RoundedCornerShape(tmp$ret$345);
      sourceInformationMarkerStart($composer_48, -1548932931, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_28 = $composer_48.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_43 = $composer_48.i31();
      var tmp_165;
      if (invalid_28 || it_43 === Companion_getInstance().f30_1) {
        var value_43 = BeadsProductDetailsScreen$lambda_47(viewModel);
        $composer_48.j31(value_43);
        tmp_165 = value_43;
      } else {
        tmp_165 = it_43;
      }
      var tmp13_group_0 = tmp_165;
      sourceInformationMarkerEnd($composer_48);
      var tmp_166 = ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().p13a_1;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_9 = rememberComposableLambda(203394506, true, BeadsProductDetailsScreen$lambda_48(state$delegate), $composer_48, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_72 = $composer_48;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_29 = $composer_72.k31(dispatchReceiver_9);
      // Inline function 'kotlin.let' call
      var it_44 = $composer_72.i31();
      var tmp_167;
      if (invalid_29 || it_44 === Companion_getInstance().f30_1) {
        var value_44 = ComposableLambda$invoke$ref(dispatchReceiver_9);
        $composer_72.j31(value_44);
        tmp_167 = value_44;
      } else {
        tmp_167 = it_44;
      }
      var tmp_168 = tmp_167;
      OutlinedTextField(tmp38_value, tmp13_group_0, tmp39_modifier, false, false, null, tmp_166, null, null, null, null, null, tmp_168, false, null, null, null, false, 3, 0, null, tmp40_shape, null, $composer_48, 1573248, 100663680, 0, 6025144);
      var tmp_169 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$357 = _Dp___init__impl__ms3zkb(24);
      Spacer(height(tmp_169, tmp$ret$357), $composer_48, 6);
      AgeGroupDisplay(activeProduct.rzu_1, activeProduct.szu_1, activeProduct.tzu_1, null, $composer_48, 0, 8);
      var tmp_170 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$358 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_170, tmp$ret$358), $composer_48, 6);
      var tmp41_elvis_lhs = activeProduct.wzt_1;
      if ((tmp41_elvis_lhs == null ? 0 : tmp41_elvis_lhs) > 0) {
        $composer_48.m30(-770695294);
        sourceInformation($composer_48, '815@43477L892');
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_23 = null;
        var horizontalArrangement_4 = null;
        var verticalAlignment_4 = Companion_getInstance_11().u8t_1;
        var $composer_73 = $composer_48;
        if (!((3 & 1) === 0))
          modifier_23 = Companion_instance;
        if (!((3 & 2) === 0))
          horizontalArrangement_4 = Arrangement_getInstance().qdp_1;
        if (!((3 & 4) === 0))
          verticalAlignment_4 = Companion_getInstance_11().t8t_1;
        var measurePolicy_11 = rowMeasurePolicy(horizontalArrangement_4, verticalAlignment_4, $composer_73, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_24 = modifier_23;
        var $composer_74 = $composer_73;
        if (!((0 & 2) === 0))
          modifier_24 = Companion_instance;
        var compositeKeyHash_11 = get_currentCompositeKeyHashCode($composer_74, 0).hashCode();
        var localMap_11 = $composer_74.t31();
        var materialized_11 = materialize($composer_74, modifier_24);
        var tmp0_17 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_75 = $composer_74;
        var tmp_171 = $composer_75.g30();
        if (!isInterface(tmp_171, Applier)) {
          invalidApplier();
        }
        $composer_75.b31();
        if ($composer_75.h30()) {
          $composer_75.c31(tmp0_17);
        } else {
          $composer_75.d31();
        }
        var $this$ReusableComposeNode_11 = _Updater___init__impl__rbfxm8($composer_75);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_11, measurePolicy_11, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_11, localMap_11, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_11, compositeKeyHash_11, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_11, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_11, materialized_11, Companion_getInstance_12().qah_1);
        var $composer_76 = $composer_75;
        var $composer_77 = $composer_76;
        sourceInformationMarkerStart($composer_77, -1653168842, 'C816@43563L194,820@43790L39,822@43911L187,821@43862L477:BeadsProductDetailsScreen.kt#8gd4xm');
        var tmp_172 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$365 = _Dp___init__impl__ms3zkb(8);
        Box(background(clip(size(tmp_172, tmp$ret$365), get_CircleShape()), Color(new Long(-11751600, 0))), $composer_77, 0);
        var tmp_173 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$366 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_173, tmp$ret$366), $composer_77, 6);
        var tmp_174 = get_in_stock_pattern(string_instance);
        var tmp0_elvis_lhs_5 = activeProduct.wzt_1;
        var tmp1_text = formatNumbers(stringResource_0(tmp_174, [tmp0_elvis_lhs_5 == null ? 0 : tmp0_elvis_lhs_5], $composer_77, 0), language);
        var tmp2_color_1 = Color(new Long(-11751600, 0));
        var tmp3_fontWeight_0 = Companion_getInstance_16().e7z_1;
        var tmp4_fontSize = get_sp(14);
        var tmp_175 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_176 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_177 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp1_text, null, tmp2_color_1, null, tmp4_fontSize, null, tmp3_fontWeight_0, null, tmp_175, null, null, tmp_176, tmp_177, false, 0, 0, null, null, $composer_77, 1597824, 0, 262058);
        sourceInformationMarkerEnd($composer_77);
        $composer_75.e31();
        $composer_48.n30();
      } else {
        $composer_48.m30(-769753390);
        sourceInformation($composer_48, '832@44431L748');
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_25 = null;
        var horizontalArrangement_5 = null;
        var verticalAlignment_5 = Companion_getInstance_11().u8t_1;
        var $composer_78 = $composer_48;
        if (!((3 & 1) === 0))
          modifier_25 = Companion_instance;
        if (!((3 & 2) === 0))
          horizontalArrangement_5 = Arrangement_getInstance().qdp_1;
        if (!((3 & 4) === 0))
          verticalAlignment_5 = Companion_getInstance_11().t8t_1;
        var measurePolicy_12 = rowMeasurePolicy(horizontalArrangement_5, verticalAlignment_5, $composer_78, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_26 = modifier_25;
        var $composer_79 = $composer_78;
        if (!((0 & 2) === 0))
          modifier_26 = Companion_instance;
        var compositeKeyHash_12 = get_currentCompositeKeyHashCode($composer_79, 0).hashCode();
        var localMap_12 = $composer_79.t31();
        var materialized_12 = materialize($composer_79, modifier_26);
        var tmp0_18 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_80 = $composer_79;
        var tmp_178 = $composer_80.g30();
        if (!isInterface(tmp_178, Applier)) {
          invalidApplier();
        }
        $composer_80.b31();
        if ($composer_80.h30()) {
          $composer_80.c31(tmp0_18);
        } else {
          $composer_80.d31();
        }
        var $this$ReusableComposeNode_12 = _Updater___init__impl__rbfxm8($composer_80);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_12, measurePolicy_12, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_12, localMap_12, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_12, compositeKeyHash_12, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_12, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_12, materialized_12, Companion_getInstance_12().qah_1);
        var $composer_81 = $composer_80;
        var $composer_82 = $composer_81;
        sourceInformationMarkerStart($composer_82, 1471943133, 'C835@44673L11,833@44517L208,837@44758L39,839@44879L39,840@44978L11,838@44830L319:BeadsProductDetailsScreen.kt#8gd4xm');
        var tmp_179 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$373 = _Dp___init__impl__ms3zkb(8);
        Box(background(clip(size(tmp_179, tmp$ret$373), get_CircleShape()), MaterialTheme_instance.unz($composer_82, 6).to0_1), $composer_82, 0);
        var tmp_180 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$374 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_180, tmp$ret$374), $composer_82, 6);
        var tmp0_text_0 = stringResource(get_out_of_stock(string_instance), $composer_82, 0);
        var tmp1_color = MaterialTheme_instance.unz($composer_82, 6).to0_1;
        var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp3_fontSize = get_sp(14);
        var tmp_181 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_182 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_183 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text_0, null, tmp1_color, null, tmp3_fontSize, null, tmp2_fontWeight, null, tmp_181, null, null, tmp_182, tmp_183, false, 0, 0, null, null, $composer_82, 1597440, 0, 262058);
        sourceInformationMarkerEnd($composer_82);
        $composer_80.e31();
        $composer_48.n30();
      }
      var tmp_184 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$375 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_184, tmp$ret$375), $composer_48, 6);
      sourceInformationMarkerEnd($composer_48);
      $composer_46.e31();
      sourceInformationMarkerEnd($composer_21);
      $composer_19.e31();
      sourceInformationMarkerEnd($composer_16);
      $composer_14.e31();
      var tmp0_modifier_0 = fillMaxWidth(Companion_instance);
      var tmp1_color_0 = MaterialTheme_instance.unz($composer_11, 6).mo0_1;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp2_shadowElevation = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_185 = _Dp___init__impl__ms3zkb(24);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$378 = _Dp___init__impl__ms3zkb(24);
      var tmp3_shape = RoundedCornerShape_0(tmp_185, tmp$ret$378);
      var tmp_186 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_187 = _Dp___init__impl__ms3zkb(0.0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver_10 = rememberComposableLambda(-1654154539, true, BeadsProductDetailsScreen$lambda_49(activeProduct, state$delegate, viewModel, language), $composer_11, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_83 = $composer_11;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_30 = $composer_83.k31(dispatchReceiver_10);
      // Inline function 'kotlin.let' call
      var it_45 = $composer_83.i31();
      var tmp_188;
      if (invalid_30 || it_45 === Companion_getInstance().f30_1) {
        var value_45 = ComposableLambda$invoke$ref(dispatchReceiver_10);
        $composer_83.j31(value_45);
        tmp_188 = value_45;
      } else {
        tmp_188 = it_45;
      }
      var tmp$ret$379 = tmp_188;
      Surface(tmp0_modifier_0, tmp3_shape, tmp1_color_0, tmp_186, tmp_187, tmp2_shadowElevation, null, tmp$ret$379, $composer_11, 12779526, 88);
      sourceInformationMarkerEnd($composer_11);
      $composer_9.e31();
      if (BeadsProductDetailsScreen$lambda(state$delegate).d138_1) {
        $composer_6.m30(-344937096);
        sourceInformation($composer_6, '1016@54412L1518');
        var tmp_189 = fillMaxSize(Companion_instance);
        var tmp_190 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.5);
        var tmp_191 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_192 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_193 = _Dp___init__impl__ms3zkb(0.0);
        Surface(tmp_189, null, tmp_190, tmp_191, tmp_192, tmp_193, null, ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().u13a_1, $composer_6, 12583302, 122);
        $composer_6.n30();
      } else {
        $composer_6.m30(-343455234);
        $composer_6.n30();
      }
      var tmp_194 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(snackbarHostState, tmp_194, null, $composer_6, 6, 4);
      if (BeadsProductDetailsScreen$lambda_11(showMediaDialog$delegate)) {
        $composer_6.m30(-343280177);
        sourceInformation($composer_6, '1060@56297L27,1056@56123L215');
        var tmp_195 = BeadsProductDetailsScreen$lambda_13(initialMediaIndex$delegate);
        sourceInformationMarkerStart($composer_6, 1235858239, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_46 = $composer_6.i31();
        var tmp_196;
        if (false || it_46 === Companion_getInstance().f30_1) {
          var value_46 = BeadsProductDetailsScreen$lambda_50(showMediaDialog$delegate);
          $composer_6.j31(value_46);
          tmp_196 = value_46;
        } else {
          tmp_196 = it_46;
        }
        var tmp0_group_8 = tmp_196;
        sourceInformationMarkerEnd($composer_6);
        ProductMediaGalleryDialog(combinedMedia, name, tmp_195, tmp0_group_8, $composer_6, 3072, 0);
        $composer_6.n30();
      } else {
        $composer_6.m30(-343050498);
        $composer_6.n30();
      }
      if (BeadsProductDetailsScreen$lambda_3(showBirthdayPicker$delegate)) {
        $composer_6.m30(-342943300);
        sourceInformation($composer_6, '1066@56449L124,1070@56607L1676,1100@58317L339,1109@58671L71,1065@56396L2346');
        sourceInformationMarkerStart($composer_6, 1235863200, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_47 = $composer_6.i31();
        var tmp_197;
        if (false || it_47 === Companion_getInstance().f30_1) {
          var value_47 = BeadsProductDetailsScreen$lambda_51(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate);
          $composer_6.j31(value_47);
          tmp_197 = value_47;
        } else {
          tmp_197 = it_47;
        }
        var tmp1_group_3 = tmp_197;
        sourceInformationMarkerEnd($composer_6);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_11 = rememberComposableLambda(-273508631, true, BeadsProductDetailsScreen$lambda_52(birthdayPickerState, state$delegate, viewModel, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_84 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_31 = $composer_84.k31(dispatchReceiver_11);
        // Inline function 'kotlin.let' call
        var it_48 = $composer_84.i31();
        var tmp_198;
        if (invalid_31 || it_48 === Companion_getInstance().f30_1) {
          var value_48 = ComposableLambda$invoke$ref(dispatchReceiver_11);
          $composer_84.j31(value_48);
          tmp_198 = value_48;
        } else {
          tmp_198 = it_48;
        }
        var tmp_199 = tmp_198;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_12 = rememberComposableLambda(995089387, true, BeadsProductDetailsScreen$lambda_53(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_85 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_32 = $composer_85.k31(dispatchReceiver_12);
        // Inline function 'kotlin.let' call
        var it_49 = $composer_85.i31();
        var tmp_200;
        if (invalid_32 || it_49 === Companion_getInstance().f30_1) {
          var value_49 = ComposableLambda$invoke$ref(dispatchReceiver_12);
          $composer_85.j31(value_49);
          tmp_200 = value_49;
        } else {
          tmp_200 = it_49;
        }
        var tmp_201 = tmp_200;
        var tmp_202 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_13 = rememberComposableLambda(-540651520, true, BeadsProductDetailsScreen$lambda_54(birthdayPickerState), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_86 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_33 = $composer_86.k31(dispatchReceiver_13);
        // Inline function 'kotlin.let' call
        var it_50 = $composer_86.i31();
        var tmp_203;
        if (invalid_33 || it_50 === Companion_getInstance().f30_1) {
          var value_50 = ComposableLambda$invoke$ref_6(dispatchReceiver_13);
          $composer_86.j31(value_50);
          tmp_203 = value_50;
        } else {
          tmp_203 = it_50;
        }
        var tmp$ret$408 = tmp_203;
        DatePickerDialog(tmp1_group_3, tmp_199, null, tmp_201, null, tmp_202, null, null, tmp$ret$408, $composer_6, 100666422, 244);
        $composer_6.n30();
      } else {
        $composer_6.m30(-340665730);
        $composer_6.n30();
      }
      sourceInformationMarkerEnd($composer_6);
      $composer_4.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp15_safe_receiver = $composer_0.t30();
    if (tmp15_safe_receiver == null)
      null;
    else {
      tmp15_safe_receiver.p3c(BeadsProductDetailsScreen$lambda_55(product, onBack, onNavigateToAuth, initialSize_0, initialColor_0, initialOptions_0, initialComment_0, initialCard_0, initialBox_0, initialCardMessage_0, initialCardBirthday_0, initialBoxMessage_0, initialBoxBirthday_0, initialBraceletName_0, $changed, $changed1, $default));
    }
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_301171522$lambda_o1p0or($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C262@11929L31,260@11793L257:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-301171522, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$-301171522.<anonymous> (BeadsProductDetailsScreen.kt:260)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, Companion_getInstance_14().i6b_1, $composer_0, 3072, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_1538801051$lambda_1gmwv5($this$AnimatedContent, isFav, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C279@12972L42,277@12774L396:BeadsProductDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isFav) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1538801051, $dirty, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$-1538801051.<anonymous> (BeadsProductDetailsScreen.kt:277)');
      }
      var tmp = isFav ? get_Favorite(Icons_getInstance().dxv_1) : get_FavoriteBorder(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_favorites_title(string_instance), $composer_0, 0);
      var tmp_1;
      if (isFav) {
        $composer_0.m30(-1319047988);
        sourceInformation($composer_0, '280@13092L11');
        var tmp0_group = MaterialTheme_instance.unz($composer_0, 6).xnz_1;
        $composer_0.n30();
        tmp_1 = tmp0_group;
      } else {
        $composer_0.m30(-1319047382);
        $composer_0.n30();
        tmp_1 = Companion_getInstance_14().i6b_1;
      }
      Icon(tmp, tmp_0, null, tmp_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$888632025$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C294@13846L40,292@13704L280:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(888632025, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$888632025.<anonymous> (BeadsProductDetailsScreen.kt:292)');
      }
      var tmp = get_Share(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_share_product(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, Companion_getInstance_14().i6b_1, $composer_0, 3072, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_776712953$lambda_mi0c8s($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C314@14794L1091:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-776712953, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$-776712953.<anonymous> (BeadsProductDetailsScreen.kt:314)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_0 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(8);
      var tmp0_modifier = padding_2(tmp, tmp_0, tmp$ret$1);
      var tmp1_verticalAlignment = Companion_getInstance_11().u8t_1;
      var tmp_1 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$2 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = tmp0_modifier;
      var horizontalArrangement = tmp_1.mdq(tmp$ret$2);
      var verticalAlignment = tmp1_verticalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier = Companion_instance;
      if (!((0 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_2 = $composer_3.g30();
      if (!isInterface(tmp_2, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -1641614851, 'C323@15395L11,319@15124L337,326@15543L39,327@15642L10,329@15789L11,325@15494L361:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp_3 = get_Fullscreen(Icons_getInstance().dxv_1);
      var tmp_4 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$9 = _Dp___init__impl__ms3zkb(20);
      Icon(tmp_3, null, size(tmp_4, tmp$ret$9), MaterialTheme_instance.unz($composer_5, 6).fo0_1, $composer_5, 432, 0);
      var tmp0_text = stringResource(get_full_gallery(string_instance), $composer_5, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).rof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp3_color = MaterialTheme_instance.unz($composer_5, 6).fo0_1;
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp3_color, null, tmp_5, null, tmp2_fontWeight, null, tmp_6, null, null, tmp_7, tmp_8, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131002);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_1152869572$lambda_56fzzf($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C588@30668L45,588@30663L51:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1152869572, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$-1152869572.<anonymous> (BeadsProductDetailsScreen.kt:588)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_1245423845$lambda_i66e6v($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C589@30775L51,589@30770L57:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1245423845, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$-1245423845.<anonymous> (BeadsProductDetailsScreen.kt:589)');
      }
      var tmp = stringResource(get_gift_message_placeholder(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_1780207104$lambda_oikzq5($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C619@32654L48,619@32649L54:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1780207104, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$-1780207104.<anonymous> (BeadsProductDetailsScreen.kt:619)');
      }
      var tmp = stringResource(get_invalid_birthday_date(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_254083277$lambda_czpvmp($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C610@32018L46,610@32013L52:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-254083277, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$-254083277.<anonymous> (BeadsProductDetailsScreen.kt:610)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_419937614$lambda_po4o5b($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C626@33105L202:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-419937614, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$-419937614.<anonymous> (BeadsProductDetailsScreen.kt:626)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$185560371$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C666@35260L45,666@35255L51:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(185560371, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$185560371.<anonymous> (BeadsProductDetailsScreen.kt:666)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$1435217234$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C667@35367L51,667@35362L57:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1435217234, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$1435217234.<anonymous> (BeadsProductDetailsScreen.kt:667)');
      }
      var tmp = stringResource(get_gift_message_placeholder(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_1599385034$lambda_1og4iw($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C697@37240L48,697@37235L54:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1599385034, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$-1599385034.<anonymous> (BeadsProductDetailsScreen.kt:697)');
      }
      var tmp = stringResource(get_invalid_birthday_date(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$630763370$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C688@36607L46,688@36602L52:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(630763370, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$630763370.<anonymous> (BeadsProductDetailsScreen.kt:688)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$158535465$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C704@37690L202:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(158535465, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$158535465.<anonymous> (BeadsProductDetailsScreen.kt:704)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$1721891645$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C791@42312L52,791@42307L58:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1721891645, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$1721891645.<anonymous> (BeadsProductDetailsScreen.kt:791)');
      }
      var tmp = stringResource(get_add_product_comment_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$2004710334$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C889@47388L49,890@47500L11,887@47259L300:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(2004710334, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$2004710334.<anonymous> (BeadsProductDetailsScreen.kt:887)');
      }
      var tmp = get_Remove(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_decrease_quantity_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).no0_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$64840359$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C910@48639L49,911@48751L11,908@48513L297:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(64840359, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$64840359.<anonymous> (BeadsProductDetailsScreen.kt:908)');
      }
      var tmp = get_Add(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_increase_quantity_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).no0_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_98542391$lambda_b3lwm($this$AnimatedContent, isAdding, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C:BeadsProductDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isAdding) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-98542391, $dirty, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$-98542391.<anonymous> (BeadsProductDetailsScreen.kt:982)');
      }
      if (isAdding) {
        $composer_0.m30(2081329904);
        sourceInformation($composer_0, '983@52788L257');
        var tmp = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
        var tmp_0 = size(tmp, tmp$ret$0);
        var tmp_1 = Companion_getInstance_14().m6b_1;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_2 = _Dp___init__impl__ms3zkb(2);
        var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_4 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, _Dp___init__impl__ms3zkb(0.0), $composer_0, 438, 56);
        $composer_0.n30();
      } else {
        $composer_0.m30(2081723356);
        sourceInformation($composer_0, '989@53123L1085');
        var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = null;
        var horizontalArrangement = Arrangement_getInstance().udp_1;
        var verticalAlignment = tmp0_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((1 & 1) === 0))
          modifier = Companion_instance;
        if (!((1 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((1 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_5 = $composer_3.g30();
        if (!isInterface(tmp_5, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 197088811, 'C993@53379L266,998@53686L39,1000@53816L38,999@53766L404:BeadsProductDetailsScreen.kt#8gd4xm');
        var tmp_6 = get_ShoppingCart(Icons_getInstance().dxv_1);
        var tmp_7 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(20);
        var tmp_8 = size(tmp_7, tmp$ret$8);
        Icon(tmp_6, null, tmp_8, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 432, 8);
        var tmp_9 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$9 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_9, tmp$ret$9), $composer_5, 6);
        var tmp0_text = stringResource(get_add_to_cart(string_instance), $composer_5, 0);
        var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp2_fontSize = get_sp(16);
        var tmp3_textAlign = Companion_getInstance_15().d7v_1;
        var tmp4_lineHeight = get_sp(18);
        var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp_10, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_11, null, tmp3_textAlign, tmp4_lineHeight, tmp_12, false, 0, 0, null, null, $composer_5, 1597440, 48, 258990);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_979709950$lambda_5y366u($this$Card, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1028@54958L918:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-979709950, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$-979709950.<anonymous> (BeadsProductDetailsScreen.kt:1028)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
      var tmp0_modifier = padding_0(tmp, tmp$ret$0);
      var tmp1_horizontalAlignment = Companion_getInstance_11().x8t_1;
      var tmp_0 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = tmp0_modifier;
      var verticalArrangement = tmp_0.mdq(tmp$ret$1);
      var horizontalAlignment = tmp1_horizontalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier = Companion_instance;
      if (!((0 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((0 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -118915239, 'C1033@55244L27,1035@55338L54,1036@55448L10,1034@55300L262,1040@55629L52,1041@55737L10,1039@55591L259:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
      CircularProgressIndicator(null, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_5, 0, 63);
      var tmp0_text = stringResource(get_adding_to_cart_dialog_title(string_instance), $composer_5, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp_6, null, tmp_7, null, tmp2_fontWeight, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131006);
      var tmp3_text = stringResource(get_adding_to_cart_dialog_msg(string_instance), $composer_5, 0);
      var tmp4_style = MaterialTheme_instance.jog($composer_5, 6).pof_1;
      var tmp5_textAlign = Companion_getInstance_15().d7v_1;
      var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_15 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp3_text, null, tmp_11, null, tmp_12, null, null, null, tmp_13, null, tmp5_textAlign, tmp_14, tmp_15, false, 0, 0, null, tmp4_style, $composer_5, 0, 0, 130046);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_785478662$lambda_nz5tpk($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1020@54559L1357:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-785478662, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$-785478662.<anonymous> (BeadsProductDetailsScreen.kt:1020)');
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = null;
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((5 & 1) === 0))
        modifier = Companion_instance;
      if (!((5 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((5 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -457367021, 'C1023@54745L11,1022@54674L116,1021@54622L1276:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp_0 = CardDefaults_instance;
      var tmp_1 = MaterialTheme_instance.unz($composer_5, 6).mo0_1;
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp0_colors = tmp_0.loh(tmp_1, tmp_2, tmp_3, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(16);
      var tmp1_shape = RoundedCornerShape(tmp$ret$6);
      var tmp_4 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(32);
      var tmp2_modifier = padding_0(tmp_4, tmp$ret$7);
      Card(tmp2_modifier, tmp1_shape, tmp0_colors, null, null, ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().t13a_1, $composer_5, 196614, 24);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$59769574$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1097@58213L29,1097@58208L35:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(59769574, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$59769574.<anonymous> (BeadsProductDetailsScreen.kt:1097)');
      }
      var tmp = stringResource(get_ok(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt$lambda$1328367592$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1106@58582L33,1106@58577L39:BeadsProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1328367592, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$BeadsProductDetailsScreenKt.lambda$1328367592.<anonymous> (BeadsProductDetailsScreen.kt:1106)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$BeadsProductDetailsScreenKt() {
    ComposableSingletons$BeadsProductDetailsScreenKt_instance = this;
    var tmp = this;
    tmp.b13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-301171522, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_301171522$lambda_o1p0or));
    var tmp_0 = this;
    tmp_0.c13a_1 = ComposableLambda$invoke$ref_5(composableLambdaInstance(-1538801051, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_1538801051$lambda_1gmwv5));
    var tmp_1 = this;
    tmp_1.d13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(888632025, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$888632025$lambda));
    var tmp_2 = this;
    tmp_2.e13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-776712953, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_776712953$lambda_mi0c8s));
    var tmp_3 = this;
    tmp_3.f13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1152869572, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_1152869572$lambda_56fzzf));
    var tmp_4 = this;
    tmp_4.g13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1245423845, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_1245423845$lambda_i66e6v));
    var tmp_5 = this;
    tmp_5.h13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1780207104, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_1780207104$lambda_oikzq5));
    var tmp_6 = this;
    tmp_6.i13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-254083277, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_254083277$lambda_czpvmp));
    var tmp_7 = this;
    tmp_7.j13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-419937614, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_419937614$lambda_po4o5b));
    var tmp_8 = this;
    tmp_8.k13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(185560371, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$185560371$lambda));
    var tmp_9 = this;
    tmp_9.l13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1435217234, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$1435217234$lambda));
    var tmp_10 = this;
    tmp_10.m13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1599385034, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_1599385034$lambda_1og4iw));
    var tmp_11 = this;
    tmp_11.n13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(630763370, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$630763370$lambda));
    var tmp_12 = this;
    tmp_12.o13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(158535465, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$158535465$lambda));
    var tmp_13 = this;
    tmp_13.p13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1721891645, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$1721891645$lambda));
    var tmp_14 = this;
    tmp_14.q13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(2004710334, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$2004710334$lambda));
    var tmp_15 = this;
    tmp_15.r13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(64840359, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$64840359$lambda));
    var tmp_16 = this;
    tmp_16.s13a_1 = ComposableLambda$invoke$ref_5(composableLambdaInstance(-98542391, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_98542391$lambda_b3lwm));
    var tmp_17 = this;
    tmp_17.t13a_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(-979709950, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_979709950$lambda_5y366u));
    var tmp_18 = this;
    tmp_18.u13a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-785478662, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$_785478662$lambda_nz5tpk));
    var tmp_19 = this;
    tmp_19.v13a_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(59769574, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$59769574$lambda));
    var tmp_20 = this;
    tmp_20.w13a_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1328367592, false, ComposableSingletons$BeadsProductDetailsScreenKt$lambda$1328367592$lambda));
  }
  var ComposableSingletons$BeadsProductDetailsScreenKt_instance;
  function ComposableSingletons$BeadsProductDetailsScreenKt_getInstance() {
    if (ComposableSingletons$BeadsProductDetailsScreenKt_instance == null)
      new ComposableSingletons$BeadsProductDetailsScreenKt();
    return ComposableSingletons$BeadsProductDetailsScreenKt_instance;
  }
  function BeadsProductDetailsScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function BeadsProductDetailsScreen$slambda($viewModel, $product, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, $initialBraceletName, resultContinuation) {
    this.f13b_1 = $viewModel;
    this.g13b_1 = $product;
    this.h13b_1 = $initialSize;
    this.i13b_1 = $initialColor;
    this.j13b_1 = $initialOptions;
    this.k13b_1 = $initialComment;
    this.l13b_1 = $initialCard;
    this.m13b_1 = $initialBox;
    this.n13b_1 = $initialCardMessage;
    this.o13b_1 = $initialCardBirthday;
    this.p13b_1 = $initialBoxMessage;
    this.q13b_1 = $initialBoxBirthday;
    this.r13b_1 = $initialBraceletName;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BeadsProductDetailsScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BeadsProductDetailsScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.f13b_1.s10h().j10i(new LoadProduct_0(this.g13b_1, this.h13b_1._v, this.i13b_1._v, this.j13b_1._v, this.k13b_1._v, this.l13b_1._v, this.m13b_1._v, this.n13b_1._v, this.o13b_1._v, this.p13b_1._v, this.q13b_1._v, this.r13b_1._v));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(BeadsProductDetailsScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new BeadsProductDetailsScreen$slambda(this.f13b_1, this.g13b_1, this.h13b_1, this.i13b_1, this.j13b_1, this.k13b_1, this.l13b_1, this.m13b_1, this.n13b_1, this.o13b_1, this.p13b_1, this.q13b_1, this.r13b_1, completion);
    i.s13b_1 = $this$LaunchedEffect;
    return i;
  };
  function BeadsProductDetailsScreen$slambda_0($viewModel, $product, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, $initialBraceletName, resultContinuation) {
    var i = new BeadsProductDetailsScreen$slambda($viewModel, $product, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, $initialBraceletName, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_20(function_0) {
    this.t13b_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_20).a1v = function (value, $completion) {
    return this.t13b_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_20).q3 = function () {
    return this.t13b_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_20).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_20).hashCode = function () {
    return hashCode(this.q3());
  };
  function BeadsProductDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, resultContinuation) {
    this.c13c_1 = $snackbarHostState;
    this.d13c_1 = $onNavigateToAuth;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BeadsProductDetailsScreen$slambda$slambda).g13c = function (effect, $completion) {
    var tmp = this.h13c(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.g13c((!(p1 == null) ? isInterface(p1, BeadsProductDetailsSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BeadsProductDetailsScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp0_subject = this.e13c_1;
            if (tmp0_subject instanceof ShowMessage_3) {
              this.n9_1 = 2;
              suspendResult = this.e13c_1.z139_1.z10i(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof ShowToast) {
                this.n9_1 = 1;
                suspendResult = this.e13c_1.a13a_1.z10i(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (equals(tmp0_subject, NavigateToAuth_instance_1)) {
                  this.f13c_1 = this.d13c_1();
                  this.n9_1 = 4;
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            var tmp_1 = this;
            showToast(ARGUMENT);
            tmp_1.f13c_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            this.n9_1 = 3;
            suspendResult = this.c13c_1.dqm(ARGUMENT_0, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.f13c_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BeadsProductDetailsScreen$slambda$slambda).h13c = function (effect, completion) {
    var i = new BeadsProductDetailsScreen$slambda$slambda(this.c13c_1, this.d13c_1, completion);
    i.e13c_1 = effect;
    return i;
  };
  function BeadsProductDetailsScreen$slambda$slambda_0($snackbarHostState, $onNavigateToAuth, resultContinuation) {
    var i = new BeadsProductDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.g13c(effect, $completion);
    }, 1);
  }
  function BeadsProductDetailsScreen$slambda_1($viewModel, $snackbarHostState, $onNavigateToAuth, resultContinuation) {
    this.q13c_1 = $viewModel;
    this.r13c_1 = $snackbarHostState;
    this.s13c_1 = $onNavigateToAuth;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BeadsProductDetailsScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BeadsProductDetailsScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.q13c_1.s10h().t10h();
            var tmp_1 = BeadsProductDetailsScreen$slambda$slambda_0(this.r13c_1, this.s13c_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_20(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BeadsProductDetailsScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new BeadsProductDetailsScreen$slambda_1(this.q13c_1, this.r13c_1, this.s13c_1, completion);
    i.t13c_1 = $this$LaunchedEffect;
    return i;
  };
  function BeadsProductDetailsScreen$slambda_2($viewModel, $snackbarHostState, $onNavigateToAuth, resultContinuation) {
    var i = new BeadsProductDetailsScreen$slambda_1($viewModel, $snackbarHostState, $onNavigateToAuth, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function BeadsProductDetailsScreen$lambda_0($combinedMedia) {
    return function () {
      return $combinedMedia.n1();
    };
  }
  function BeadsProductDetailsScreen$lambda_1($isZooming$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isZooming', KMutableProperty0, true);
    return $isZooming$delegate.u1();
  }
  function BeadsProductDetailsScreen$lambda_2($isZooming$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isZooming', KMutableProperty0, true);
    $isZooming$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BeadsProductDetailsScreen$lambda_3($showBirthdayPicker$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    return $showBirthdayPicker$delegate.u1();
  }
  function BeadsProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    $showBirthdayPicker$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BeadsProductDetailsScreen$lambda_5($birthdayPickerTargetOptionKey$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    return $birthdayPickerTargetOptionKey$delegate.u1();
  }
  function BeadsProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    $birthdayPickerTargetOptionKey$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BeadsProductDetailsScreen$lambda_7($isPickingBoxBirthday$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    return $isPickingBoxBirthday$delegate.u1();
  }
  function BeadsProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    $isPickingBoxBirthday$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BeadsProductDetailsScreen$lambda_9($showDiscardDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    return $showDiscardDialog$delegate.u1();
  }
  function BeadsProductDetailsScreen$lambda_10($showDiscardDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    $showDiscardDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BeadsProductDetailsScreen$lambda_11($showMediaDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showMediaDialog', KMutableProperty0, true);
    return $showMediaDialog$delegate.u1();
  }
  function BeadsProductDetailsScreen$lambda_12($showMediaDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showMediaDialog', KMutableProperty0, true);
    $showMediaDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function BeadsProductDetailsScreen$lambda_13($initialMediaIndex$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('initialMediaIndex', KMutableProperty0, true);
    return $initialMediaIndex$delegate.b49();
  }
  function BeadsProductDetailsScreen$lambda_14($initialMediaIndex$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('initialMediaIndex', KMutableProperty0, true);
    $initialMediaIndex$delegate.a49(_set____db54di);
    return Unit_instance;
  }
  function BeadsProductDetailsScreen$lambda_15($showMediaDialog$delegate, $showDiscardDialog$delegate) {
    return function () {
      var tmp;
      if (BeadsProductDetailsScreen$lambda_11($showMediaDialog$delegate)) {
        BeadsProductDetailsScreen$lambda_12($showMediaDialog$delegate, false);
        tmp = Unit_instance;
      } else {
        BeadsProductDetailsScreen$lambda_10($showDiscardDialog$delegate, true);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$slambda_3($isZooming$delegate, resultContinuation) {
    this.c13d_1 = $isZooming$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BeadsProductDetailsScreen$slambda_3).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsScreen$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BeadsProductDetailsScreen$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          BeadsProductDetailsScreen$lambda_2(this.c13d_1, false);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(BeadsProductDetailsScreen$slambda_3).q24 = function ($this$LaunchedEffect, completion) {
    var i = new BeadsProductDetailsScreen$slambda_3(this.c13d_1, completion);
    i.d13d_1 = $this$LaunchedEffect;
    return i;
  };
  function BeadsProductDetailsScreen$slambda_4($isZooming$delegate, resultContinuation) {
    var i = new BeadsProductDetailsScreen$slambda_3($isZooming$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function BeadsProductDetailsScreen$lambda_16($onBack, $showDiscardDialog$delegate) {
    return function () {
      BeadsProductDetailsScreen$lambda_10($showDiscardDialog$delegate, false);
      $onBack();
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_17($showDiscardDialog$delegate) {
    return function () {
      BeadsProductDetailsScreen$lambda_10($showDiscardDialog$delegate, false);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda$lambda($pagerState, $page, $isZooming$delegate) {
    return function (zooming) {
      var tmp;
      if ($pagerState.zj9() === $page) {
        BeadsProductDetailsScreen$lambda_2($isZooming$delegate, zooming);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_18($combinedMedia, $name, $pagerState, $isZooming$delegate) {
    return function ($this$HorizontalPager, page, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C235@10615L218,230@10307L556:BeadsProductDetailsScreen.kt#8gd4xm');
      var $dirty = $changed;
      var tmp;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(page) ? 32 : 16);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1397401155, $dirty, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:229)');
        }
        var mediaUrl = $combinedMedia.l1(page);
        var tmp_1 = fillMaxSize(Companion_instance);
        var tmp_2 = Companion_getInstance_13().r96_1;
        sourceInformationMarkerStart($composer_0, 1422266999, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.k31($pagerState) | ($dirty & 112) === 32);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_3;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = BeadsProductDetailsScreen$lambda$lambda($pagerState, page, $isZooming$delegate);
          $composer_0.j31(value);
          tmp_3 = value;
        } else {
          tmp_3 = it;
        }
        var tmp0_group = tmp_3;
        sourceInformationMarkerEnd($composer_0);
        ZoomableMediaView(mediaUrl, $name, tmp_1, tmp_2, tmp0_group, $composer_0, 3456, 0);
        var tmp_4;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_4 = Unit_instance;
        }
        tmp_0 = tmp_4;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_19($onBack, $state$delegate, $showDiscardDialog$delegate) {
    return function () {
      var tmp;
      if (BeadsProductDetailsScreen$lambda($state$delegate).d138_1) {
        BeadsProductDetailsScreen$lambda_10($showDiscardDialog$delegate, true);
        tmp = Unit_instance;
      } else {
        tmp = $onBack();
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_20($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ToggleFavorite_instance);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_21($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C275@12642L42,273@12505L703:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1208596574, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:273)');
        }
        var tmp_0 = BeadsProductDetailsScreen$lambda($state$delegate).e138_1;
        var tmp_1 = stringResource(get_favorites_title(string_instance), $composer_0, 0);
        AnimatedContent(tmp_0, null, null, null, tmp_1, null, ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().c13a_1, $composer_0, 1572864, 46);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_22($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ShareProduct_instance);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_23($pagerState, $initialMediaIndex$delegate, $showMediaDialog$delegate) {
    return function () {
      BeadsProductDetailsScreen$lambda_14($initialMediaIndex$delegate, $pagerState.zj9());
      BeadsProductDetailsScreen$lambda_12($showMediaDialog$delegate, true);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda$lambda_0($key, $items) {
    return function (index) {
      return $key(index, $items.l1(index));
    };
  }
  function BeadsProductDetailsScreen$lambda$lambda_1($items) {
    return function (index) {
      $items.l1(index);
      return null;
    };
  }
  function BeadsProductDetailsScreen$lambda$lambda$lambda($index, $initialMediaIndex$delegate, $showMediaDialog$delegate) {
    return function () {
      BeadsProductDetailsScreen$lambda_14($initialMediaIndex$delegate, $index);
      BeadsProductDetailsScreen$lambda_12($showMediaDialog$delegate, true);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda$lambda_2($items, $pagerState, $initialMediaIndex$delegate, $showMediaDialog$delegate) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp4 = $items.l1(it);
        var $changed_0 = 14 & $dirty | 112 & $dirty;
        var $composer_1 = $composer_0;
        $composer_1.m30(675169964);
        sourceInformation($composer_1, 'C*373@18051L11,379@18509L180,369@17798L2665:BeadsProductDetailsScreen.kt#8gd4xm');
        var isSelected = $pagerState.zj9() === it;
        var tmp_2 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(64);
        var tmp_3 = size(tmp_2, tmp$ret$1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$2 = _Dp___init__impl__ms3zkb(12);
        var tmp_4 = background(clip(tmp_3, RoundedCornerShape(tmp$ret$2)), MaterialTheme_instance.unz($composer_1, 6).oo0_1);
        var tmp_5;
        if (isSelected) {
          // Inline function 'androidx.compose.ui.unit.dp' call
          tmp_5 = _Dp___init__impl__ms3zkb(2);
        } else {
          // Inline function 'androidx.compose.ui.unit.dp' call
          tmp_5 = _Dp___init__impl__ms3zkb(0);
        }
        var tmp_6 = tmp_5;
        var tmp_7;
        if (isSelected) {
          $composer_1.m30(-1225130204);
          sourceInformation($composer_1, '376@18294L11');
          var tmp0_group = MaterialTheme_instance.unz($composer_1, 6).xnz_1;
          $composer_1.n30();
          tmp_7 = tmp0_group;
        } else {
          $composer_1.m30(-1225129592);
          $composer_1.n30();
          tmp_7 = Companion_getInstance_14().t6b_1;
        }
        var tmp_8 = tmp_7;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$5 = _Dp___init__impl__ms3zkb(12);
        var tmp_9 = border(tmp_4, tmp_6, tmp_8, RoundedCornerShape(tmp$ret$5));
        sourceInformationMarkerStart($composer_1, -1225123535, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = ($changed_0 & 112 ^ 48) > 32 && $composer_1.m31(it) || ($changed_0 & 48) === 32;
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_10;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = BeadsProductDetailsScreen$lambda$lambda$lambda(it, $initialMediaIndex$delegate, $showMediaDialog$delegate);
          $composer_1.j31(value);
          tmp_10 = value;
        } else {
          tmp_10 = it_0;
        }
        var tmp1_group = tmp_10;
        sourceInformationMarkerEnd($composer_1);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = clickable(tmp_9, VOID, VOID, VOID, VOID, tmp1_group);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_2 = $composer_1;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_3 = $composer_2;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
        var localMap = $composer_3.t31();
        var materialized = materialize($composer_3, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_4 = $composer_3;
        var tmp_11 = $composer_4.g30();
        if (!isInterface(tmp_11, Applier)) {
          invalidApplier();
        }
        $composer_4.b31();
        if ($composer_4.h30()) {
          $composer_4.c31(tmp0);
        } else {
          $composer_4.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_5 = $composer_4;
        var $composer_6 = $composer_5;
        sourceInformationMarkerStart($composer_6, 1252977385, 'C:BeadsProductDetailsScreen.kt#8gd4xm');
        if (isVideoUrl(tmp4)) {
          $composer_6.m30(1252978345);
          sourceInformation($composer_6, '385@18830L786');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_1 = fillMaxSize(Companion_instance);
          var contentAlignment_0 = Companion_getInstance_11().o8t_1;
          var propagateMinConstraints_0 = false;
          var $composer_7 = $composer_6;
          if (!((4 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((4 & 2) === 0))
            contentAlignment_0 = Companion_getInstance_11().k8t_1;
          if (!((4 & 4) === 0))
            propagateMinConstraints_0 = false;
          var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_8 = $composer_7;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
          var localMap_0 = $composer_8.t31();
          var materialized_0 = materialize($composer_8, modifier_2);
          var tmp0_0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_9 = $composer_8;
          var tmp_12 = $composer_9.g30();
          if (!isInterface(tmp_12, Applier)) {
            invalidApplier();
          }
          $composer_9.b31();
          if ($composer_9.h30()) {
            $composer_9.c31(tmp0_0);
          } else {
            $composer_9.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_10 = $composer_9;
          var $composer_11 = $composer_10;
          sourceInformationMarkerStart($composer_11, 11105345, 'C391@19231L207,395@19509L11,389@19082L492:BeadsProductDetailsScreen.kt#8gd4xm');
          var tmp_13 = get_PlayCircle(Icons_getInstance().dxv_1);
          var tmp_14 = stringResource_0(get_video_thumbnail(string_instance), [it + 1 | 0], $composer_11, 0);
          Icon(tmp_13, tmp_14, null, MaterialTheme_instance.unz($composer_11, 6).xnz_1, $composer_11, 0, 4);
          sourceInformationMarkerEnd($composer_11);
          $composer_9.e31();
          $composer_6.n30();
        } else {
          $composer_6.m30(1253840362);
          sourceInformation($composer_6, '399@19702L689');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_3 = fillMaxSize(Companion_instance);
          var contentAlignment_1 = null;
          var propagateMinConstraints_1 = false;
          var $composer_12 = $composer_6;
          if (!((6 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_1 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_1 = false;
          var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_13 = $composer_12;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_13, 0).hashCode();
          var localMap_1 = $composer_13.t31();
          var materialized_1 = materialize($composer_13, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_14 = $composer_13;
          var tmp_15 = $composer_14.g30();
          if (!isInterface(tmp_15, Applier)) {
            invalidApplier();
          }
          $composer_14.b31();
          if ($composer_14.h30()) {
            $composer_14.c31(tmp0_1);
          } else {
            $composer_14.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_14);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_15 = $composer_14;
          var $composer_16 = $composer_15;
          sourceInformationMarkerStart($composer_16, -1617489852, 'C402@19935L203,400@19787L562:BeadsProductDetailsScreen.kt#8gd4xm');
          HadayaImage(tmp4, stringResource_0(get_thumbnail_index(string_instance), [it], $composer_16, 0), fillMaxSize(Companion_instance), Companion_getInstance_13().q96_1, $composer_16, 3456 | 14 & $changed_0 >> 6, 0);
          sourceInformationMarkerEnd($composer_16);
          $composer_14.e31();
          $composer_6.n30();
        }
        sourceInformationMarkerEnd($composer_6);
        $composer_4.e31();
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_24($combinedMedia, $pagerState, $initialMediaIndex$delegate, $showMediaDialog$delegate) {
    return function ($this$LazyRow) {
      // Inline function 'androidx.compose.foundation.lazy.itemsIndexed' call
      var items = $combinedMedia;
      var tmp = items.n1();
      var tmp_0;
      if (!(null == null)) {
        tmp_0 = BeadsProductDetailsScreen$lambda$lambda_0(null, items);
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      var tmp_2 = BeadsProductDetailsScreen$lambda$lambda_1(items);
      $this$LazyRow.di9(tmp, tmp_1, tmp_2, ComposableLambda$invoke$ref_4(composableLambdaInstance(2039820996, true, BeadsProductDetailsScreen$lambda$lambda_2(items, $pagerState, $initialMediaIndex$delegate, $showMediaDialog$delegate))));
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_25($activeProduct, $language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C496@25644L11,487@25043L741:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1430649203, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:487)');
        }
        var tmp0_safe_receiver = $activeProduct.uzt_1;
        var tmp1_text = formatNumbers('-' + (tmp0_safe_receiver == null ? null : numberToInt(tmp0_safe_receiver)) + '%', $language);
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_1 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(4);
        var tmp2_modifier = padding_2(tmp_0, tmp_1, tmp$ret$1);
        var tmp3_fontSize = get_sp(12);
        var tmp4_color = MaterialTheme_instance.unz($composer_0, 6).uo0_1;
        var tmp5_fontWeight = Companion_getInstance_16().f7z_1;
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp1_text, tmp2_modifier, tmp4_color, null, tmp3_fontSize, null, tmp5_fontWeight, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 1597488, 0, 262056);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_26($maxChars, $viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= $maxChars) {
        $viewModel.s10h().j10i(new BraceletNameChanged(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_27($braceletHint) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C532@27691L18:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1364927430, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:532)');
        }
        var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text($braceletHint, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_28($braceletHint) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C533@27757L18:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1861109029, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:533)');
        }
        var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextOverflow___init__impl__obguoe(0);
        Text($braceletHint, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_29($maxChars, $state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C542@28311L10,538@28027L339:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2042235501, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:538)');
        }
        var tmp_0 = '' + BeadsProductDetailsScreen$lambda($state$delegate).v138_1.length + '/' + $maxChars;
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_30($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new CardSelected_0(it instanceof Card_1 ? it : null));
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_31($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new CardMessageChanged_0(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_32($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C598@31427L10,594@31119L371:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1310557321, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:594)');
        }
        var tmp_0 = '' + BeadsProductDetailsScreen$lambda($state$delegate).k138_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_33($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      BeadsProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate, false);
      BeadsProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_34(it) {
    return Unit_instance;
  }
  function BeadsProductDetailsScreen$lambda$lambda_3($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      BeadsProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate, false);
      BeadsProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_35($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C622@32869L188,622@32848L501:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-800079984, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:622)');
        }
        sourceInformationMarkerStart($composer_0, -77716436, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = BeadsProductDetailsScreen$lambda$lambda_3($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().j13a_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_36($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new BoxSelected_0(it instanceof Box_0 ? it : null));
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_37($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new BoxMessageChanged_0(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_38($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C676@36018L10,672@35711L370:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1011824448, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:672)');
        }
        var tmp_0 = '' + BeadsProductDetailsScreen$lambda($state$delegate).o138_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_39($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      BeadsProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate, true);
      BeadsProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_40(it) {
    return Unit_instance;
  }
  function BeadsProductDetailsScreen$lambda$lambda_4($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      BeadsProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate, true);
      BeadsProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_41($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C700@37455L187,700@37434L500:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-86061945, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:700)');
        }
        sourceInformationMarkerStart($composer_0, -1101148318, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = BeadsProductDetailsScreen$lambda$lambda_4($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().o13a_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_42($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new SizeSelected_0(it));
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_43($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new ColorSelected_0(it));
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_44($viewModel, $option) {
    return function (value) {
      $viewModel.s10h().j10i(new OptionSelected_0($option.r101_1, value));
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_45($viewModel, $option) {
    return function (newValue) {
      $viewModel.s10h().j10i(new OptionSelected_0($option.r101_1, newValue));
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_46($option, $birthdayPickerTargetOptionKey$delegate, $showBirthdayPicker$delegate) {
    return function () {
      BeadsProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate, $option.r101_1);
      BeadsProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_47($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 100) {
        $viewModel.s10h().j10i(new ProductCommentChanged_0(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_48($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C800@42897L10,796@42617L335:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(203394506, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:796)');
        }
        var tmp_0 = '' + BeadsProductDetailsScreen$lambda($state$delegate).u138_1.length + '/100';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda$lambda_5($viewModel, $state$delegate) {
    return function () {
      var tmp;
      if (BeadsProductDetailsScreen$lambda($state$delegate).c138_1 > 1) {
        $viewModel.s10h().j10i(new QuantityChanged(BeadsProductDetailsScreen$lambda($state$delegate).c138_1 - 1 | 0));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda$lambda_6($viewModel, $state$delegate) {
    return function () {
      $viewModel.s10h().j10i(new QuantityChanged(BeadsProductDetailsScreen$lambda($state$delegate).c138_1 + 1 | 0));
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda$lambda_7($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ToggleStockReminder_instance);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda$lambda_8($state$delegate) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C940@50264L1212:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1025451759, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:940)');
        }
        var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = null;
        var horizontalArrangement = Arrangement_getInstance().udp_1;
        var verticalAlignment = tmp0_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((1 & 1) === 0))
          modifier = Companion_instance;
        if (!((1 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((1 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 943636370, 'C944@50488L308,949@50829L39,950@50901L545:BeadsProductDetailsScreen.kt#8gd4xm');
        var tmp_1 = BeadsProductDetailsScreen$lambda($state$delegate).f138_1 ? get_NotificationsActive(Icons_getInstance().dxv_1) : get_NotificationsNone(Icons_getInstance().dxv_1);
        var tmp_2 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$6 = _Dp___init__impl__ms3zkb(20);
        var tmp_3 = size(tmp_2, tmp$ret$6);
        Icon(tmp_1, null, tmp_3, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 432, 8);
        var tmp_4 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_4, tmp$ret$7), $composer_5, 6);
        var tmp_5;
        if (BeadsProductDetailsScreen$lambda($state$delegate).f138_1) {
          $composer_5.m30(-1909206886);
          sourceInformation($composer_5, '952@51013L39');
          var tmp0_group = stringResource(get_reminder_set(string_instance), $composer_5, 0);
          $composer_5.n30();
          tmp_5 = tmp0_group;
        } else {
          $composer_5.m30(-1909203017);
          sourceInformation($composer_5, '954@51134L36');
          var tmp1_group = stringResource(get_remind_me(string_instance), $composer_5, 0);
          $composer_5.n30();
          tmp_5 = tmp1_group;
        }
        var tmp0_text = tmp_5;
        var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp2_fontSize = get_sp(16);
        var tmp3_textAlign = Companion_getInstance_15().d7v_1;
        var tmp4_lineHeight = get_sp(18);
        var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_8 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp_6, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_7, null, tmp3_textAlign, tmp4_lineHeight, tmp_8, false, 0, 0, null, null, $composer_5, 1597440, 48, 258990);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_9;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_9 = Unit_instance;
        }
        tmp = tmp_9;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda$lambda_9($viewModel) {
    return function () {
      $viewModel.s10h().j10i(AddToCart_instance_0);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda$lambda$lambda_0($this$AnimatedContent) {
    return togetherWith(fadeIn(tween(300)), fadeOut(tween(300)));
  }
  function BeadsProductDetailsScreen$lambda$lambda_10($state$delegate) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C975@52346L233,980@52621L38,973@52212L2060:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1713611718, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:973)');
        }
        var tmp_0 = BeadsProductDetailsScreen$lambda($state$delegate).d138_1;
        sourceInformationMarkerStart($composer_0, 1808392111, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (false || it === Companion_getInstance().f30_1) {
          var value = BeadsProductDetailsScreen$lambda$lambda$lambda_0;
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp0_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        var tmp_2 = stringResource(get_add_to_cart(string_instance), $composer_0, 0);
        AnimatedContent(tmp_0, null, tmp0_group, null, tmp_2, null, ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().s13a_1, $composer_0, 1573248, 42);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_49($activeProduct, $state$delegate, $viewModel, $language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C858@45610L8728:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1654154539, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:858)');
        }
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_start = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_end = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_top = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp4_bottom = _Dp___init__impl__ms3zkb(8);
        var tmp5_modifier = fillMaxWidth(padding_1(Companion_instance, tmp1_start, tmp3_top, tmp2_end, tmp4_bottom));
        var tmp6_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_0 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$4 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = tmp5_modifier;
        var horizontalArrangement = tmp_0.mdq(tmp$ret$4);
        var verticalAlignment = tmp6_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 1903133419, 'C:BeadsProductDetailsScreen.kt#8gd4xm');
        var tmp2_elvis_lhs = $activeProduct.wzt_1;
        if ((tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) > 0) {
          $composer_5.m30(1903037845);
          sourceInformation($composer_5, '866@46023L3292');
          var tmp0_horizontalAlignment = Companion_getInstance_11().x8t_1;
          var tmp_2 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$11 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_1 = null;
          var verticalArrangement = tmp_2.mdq(tmp$ret$11);
          var horizontalAlignment = tmp0_horizontalAlignment;
          var $composer_6 = $composer_5;
          if (!((1 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((1 & 2) === 0))
            verticalArrangement = Arrangement_getInstance().sdp_1;
          if (!((1 & 4) === 0))
            horizontalAlignment = Companion_getInstance_11().w8t_1;
          var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_7 = $composer_6;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
          var localMap_0 = $composer_7.t31();
          var materialized_0 = materialize($composer_7, modifier_2);
          var tmp0_0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_8 = $composer_7;
          var tmp_3 = $composer_8.g30();
          if (!isInterface(tmp_3, Applier)) {
            invalidApplier();
          }
          $composer_8.b31();
          if ($composer_8.h30()) {
            $composer_8.c31(tmp0_0);
          } else {
            $composer_8.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_9 = $composer_8;
          var $composer_10 = $composer_9;
          sourceInformationMarkerStart($composer_10, -1324168322, 'C874@46484L11,870@46244L2630,916@48948L45,917@49049L10,918@49126L11,915@48903L386:BeadsProductDetailsScreen.kt#8gd4xm');
          var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
          var tmp_4 = Companion_instance;
          var tmp_5 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_10, 6).oo0_1, 0.5);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$18 = _Dp___init__impl__ms3zkb(12);
          var tmp_6 = background(tmp_4, tmp_5, RoundedCornerShape(tmp$ret$18));
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_7 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$20 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_3 = padding_2(tmp_6, tmp_7, tmp$ret$20);
          var horizontalArrangement_0 = null;
          var verticalAlignment_0 = tmp0_verticalAlignment;
          var $composer_11 = $composer_10;
          if (!((2 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((2 & 2) === 0))
            horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
          if (!((2 & 4) === 0))
            verticalAlignment_0 = Companion_getInstance_11().t8t_1;
          var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_11, 14 & 384 >> 3 | 112 & 384 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_8 = $composer_13.g30();
          if (!isInterface(tmp_8, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_1);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_15, -968261993, 'C880@46838L279,879@46780L813,898@47970L11,893@47626L399,901@48116L255,900@48058L786:BeadsProductDetailsScreen.kt#8gd4xm');
          sourceInformationMarkerStart($composer_15, 2046975795, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = !!($composer_15.k31($state$delegate) | $composer_15.q31($viewModel));
          // Inline function 'kotlin.let' call
          var it = $composer_15.i31();
          var tmp_9;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = BeadsProductDetailsScreen$lambda$lambda_5($viewModel, $state$delegate);
            $composer_15.j31(value);
            tmp_9 = value;
          } else {
            tmp_9 = it;
          }
          var tmp0_group = tmp_9;
          sourceInformationMarkerEnd($composer_15);
          var tmp_10 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$31 = _Dp___init__impl__ms3zkb(36);
          var tmp_11 = size(tmp_10, tmp$ret$31);
          IconButton(tmp0_group, tmp_11, false, null, null, null, ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().q13a_1, $composer_15, 1572912, 60);
          var tmp0_text = format(BeadsProductDetailsScreen$lambda($state$delegate).c138_1, $language);
          var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp2_fontSize = get_sp(18);
          var tmp_12 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$32 = _Dp___init__impl__ms3zkb(8);
          var tmp3_modifier = padding_2(tmp_12, tmp$ret$32);
          var tmp4_color = MaterialTheme_instance.unz($composer_15, 6).no0_1;
          var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_15 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, tmp3_modifier, tmp4_color, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_13, null, null, tmp_14, tmp_15, false, 0, 0, null, null, $composer_15, 1597488, 0, 262056);
          sourceInformationMarkerStart($composer_15, 2047016667, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = !!($composer_15.q31($viewModel) | $composer_15.k31($state$delegate));
          // Inline function 'kotlin.let' call
          var it_0 = $composer_15.i31();
          var tmp_16;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = BeadsProductDetailsScreen$lambda$lambda_6($viewModel, $state$delegate);
            $composer_15.j31(value_0);
            tmp_16 = value_0;
          } else {
            tmp_16 = it_0;
          }
          var tmp1_group = tmp_16;
          sourceInformationMarkerEnd($composer_15);
          var tmp_17 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$37 = _Dp___init__impl__ms3zkb(32);
          var tmp_18 = size(tmp_17, tmp$ret$37);
          IconButton(tmp1_group, tmp_18, false, null, null, null, ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().r13a_1, $composer_15, 1572912, 60);
          sourceInformationMarkerEnd($composer_15);
          $composer_13.e31();
          var tmp2_text = stringResource(get_bulk_discount_info(string_instance), $composer_10, 0);
          var tmp3_style = MaterialTheme_instance.jog($composer_10, 6).tof_1;
          var tmp4_color_0 = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
          var tmp5_fontSize = get_sp(10);
          var tmp6_fontWeight = Companion_getInstance_16().c7z_1;
          var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_21 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp2_text, null, tmp4_color_0, null, tmp5_fontSize, null, tmp6_fontWeight, null, tmp_19, null, null, tmp_20, tmp_21, false, 0, 0, null, tmp3_style, $composer_10, 1597440, 0, 130986);
          sourceInformationMarkerEnd($composer_10);
          $composer_8.e31();
          $composer_5.n30();
        } else {
          $composer_5.m30(1906223281);
          $composer_5.n30();
        }
        var tmp3_elvis_lhs = $activeProduct.wzt_1;
        if ((tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) <= 0) {
          $composer_5.m30(1906347777);
          sourceInformation($composer_5, '927@49468L77,932@49810L301,939@50234L1268,926@49422L2080');
          sourceInformationMarkerStart($composer_5, -492693986, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_1 = $composer_5.q31($viewModel);
          // Inline function 'kotlin.let' call
          var it_1 = $composer_5.i31();
          var tmp_22;
          if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
            var value_1 = BeadsProductDetailsScreen$lambda$lambda_7($viewModel);
            $composer_5.j31(value_1);
            tmp_22 = value_1;
          } else {
            tmp_22 = it_1;
          }
          var tmp0_group_0 = tmp_22;
          sourceInformationMarkerEnd($composer_5);
          var tmp_23 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$42 = _Dp___init__impl__ms3zkb(56);
          var tmp_24 = heightIn(tmp_23, tmp$ret$42);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$43 = _Dp___init__impl__ms3zkb(16);
          var tmp_25 = RoundedCornerShape(tmp$ret$43);
          var tmp_26 = ButtonDefaults_getInstance();
          var tmp_27;
          if (BeadsProductDetailsScreen$lambda($state$delegate).f138_1) {
            $composer_5.m30(-492678150);
            sourceInformation($composer_5, '934@49953L11');
            var tmp1_group_0 = MaterialTheme_instance.unz($composer_5, 6).co0_1;
            $composer_5.n30();
            tmp_27 = tmp1_group_0;
          } else {
            $composer_5.m30(-492674664);
            sourceInformation($composer_5, '936@50062L11');
            var tmp2_group = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
            $composer_5.n30();
            tmp_27 = tmp2_group;
          }
          var tmp_28 = tmp_27;
          var tmp_29 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_30 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_31 = tmp_26.ao9(tmp_28, tmp_29, tmp_30, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_32 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$45 = _Dp___init__impl__ms3zkb(8);
          var tmp_33 = PaddingValues_0(tmp_32, tmp$ret$45);
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(1025451759, true, BeadsProductDetailsScreen$lambda$lambda_8($state$delegate), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_16 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_2 = $composer_16.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_2 = $composer_16.i31();
          var tmp_34;
          if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
            var value_2 = ComposableLambda$invoke$ref_1(dispatchReceiver);
            $composer_16.j31(value_2);
            tmp_34 = value_2;
          } else {
            tmp_34 = it_2;
          }
          var tmp$ret$46 = tmp_34;
          Button(tmp0_group_0, tmp_24, false, tmp_25, tmp_31, null, null, tmp_33, null, tmp$ret$46, $composer_5, 817889280, 356);
          $composer_5.n30();
        } else {
          $composer_5.m30(1908509531);
          sourceInformation($composer_5, '969@51978L11,969@51934L64,964@51602L67,972@52182L2116,963@51556L2742');
          var tmp_35 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$53 = _Dp___init__impl__ms3zkb(56);
          var tmp4_modifier = heightIn(tmp_35, tmp$ret$53);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$54 = _Dp___init__impl__ms3zkb(16);
          var tmp5_shape = RoundedCornerShape(tmp$ret$54);
          var tmp_36 = ButtonDefaults_getInstance();
          var tmp_37 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
          var tmp_38 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_39 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp6_colors = tmp_36.ao9(tmp_37, tmp_38, tmp_39, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
          var tmp7_enabled = !BeadsProductDetailsScreen$lambda($state$delegate).d138_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_40 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$56 = _Dp___init__impl__ms3zkb(4);
          var tmp8_contentPadding = PaddingValues_0(tmp_40, tmp$ret$56);
          sourceInformationMarkerStart($composer_5, -492625708, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_3 = $composer_5.q31($viewModel);
          // Inline function 'kotlin.let' call
          var it_3 = $composer_5.i31();
          var tmp_41;
          if (invalid_3 || it_3 === Companion_getInstance().f30_1) {
            var value_3 = BeadsProductDetailsScreen$lambda$lambda_9($viewModel);
            $composer_5.j31(value_3);
            tmp_41 = value_3;
          } else {
            tmp_41 = it_3;
          }
          var tmp3_group = tmp_41;
          sourceInformationMarkerEnd($composer_5);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_0 = rememberComposableLambda(1713611718, true, BeadsProductDetailsScreen$lambda$lambda_10($state$delegate), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_17 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_4 = $composer_17.k31(dispatchReceiver_0);
          // Inline function 'kotlin.let' call
          var it_4 = $composer_17.i31();
          var tmp_42;
          if (invalid_4 || it_4 === Companion_getInstance().f30_1) {
            var value_4 = ComposableLambda$invoke$ref_1(dispatchReceiver_0);
            $composer_17.j31(value_4);
            tmp_42 = value_4;
          } else {
            tmp_42 = it_4;
          }
          var tmp$ret$61 = tmp_42;
          Button(tmp3_group, tmp4_modifier, tmp7_enabled, tmp5_shape, tmp6_colors, null, null, tmp8_contentPadding, null, tmp$ret$61, $composer_5, 817889280, 352);
          $composer_5.n30();
        }
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_43;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_43 = Unit_instance;
        }
        tmp = tmp_43;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_50($showMediaDialog$delegate) {
    return function () {
      BeadsProductDetailsScreen$lambda_12($showMediaDialog$delegate, false);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_51($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate) {
    return function () {
      BeadsProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, false);
      BeadsProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate, null);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda$lambda_11($birthdayPickerState, $viewModel, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      var tmp0_safe_receiver = $birthdayPickerState.np1();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var date = toLocalDateTime(Companion_getInstance_19().kf(tmp0_safe_receiver), Companion_getInstance_20().yno_1).xn9_1.toString();
        if (!(BeadsProductDetailsScreen$lambda_5($birthdayPickerTargetOptionKey$delegate) == null)) {
          var key = ensureNotNull(BeadsProductDetailsScreen$lambda_5($birthdayPickerTargetOptionKey$delegate));
          var selectedValue = BeadsProductDetailsScreen$lambda($state$delegate).t138_1.w2(key);
          if (!(selectedValue == null)) {
            $viewModel.s10h().j10i(new OptionSelected_0(key, selectedValue.k101(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, date)));
          }
        } else if (BeadsProductDetailsScreen$lambda_7($isPickingBoxBirthday$delegate)) {
          $viewModel.s10h().j10i(new BoxBirthdayChanged_0(date));
        } else {
          $viewModel.s10h().j10i(new CardBirthdayChanged_0(date));
        }
      }
      BeadsProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, false);
      BeadsProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate, null);
      BeadsProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_52($birthdayPickerState, $state$delegate, $viewModel, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1071@56650L1530,1071@56629L1636:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-273508631, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:1071)');
        }
        sourceInformationMarkerStart($composer_0, -848786429, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.k31($birthdayPickerState) | $composer_0.k31($state$delegate)) | $composer_0.q31($viewModel));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = BeadsProductDetailsScreen$lambda$lambda_11($birthdayPickerState, $viewModel, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().v13a_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda$lambda_12($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function () {
      BeadsProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, false);
      BeadsProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate, null);
      BeadsProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_53($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1101@58360L189,1101@58339L299:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(995089387, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:1101)');
        }
        sourceInformationMarkerStart($composer_0, -1496804536, 'CC(remember):BeadsProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = BeadsProductDetailsScreen$lambda$lambda_12($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$BeadsProductDetailsScreenKt_getInstance().w13a_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_54($birthdayPickerState) {
    return function ($this$DatePickerDialog, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1110@58689L39:BeadsProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-540651520, $changed, -1, 'client.fstech.hadaya.presentation.product_details.BeadsProductDetailsScreen.<anonymous>.<anonymous> (BeadsProductDetailsScreen.kt:1110)');
        }
        DatePicker($birthdayPickerState, null, null, null, null, null, false, null, $composer_0, 0, 254);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BeadsProductDetailsScreen$lambda_55($product, $onBack, $onNavigateToAuth, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, $initialBraceletName, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      BeadsProductDetailsScreen($product, $onBack, $onNavigateToAuth, $initialSize._v, $initialColor._v, $initialOptions._v, $initialComment._v, $initialCard._v, $initialBox._v, $initialCardMessage._v, $initialCardBirthday._v, $initialBoxMessage._v, $initialBoxBirthday._v, $initialBraceletName._v, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_product_details_BeadsProductDetailsViewModel$stable;
  function BeadsProductDetailsViewModel$observeLanguage$slambda$slambda$lambda($language) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, $language);
    };
  }
  function BeadsProductDetailsViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation) {
    this.m13d_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BeadsProductDetailsViewModel$observeLanguage$slambda$slambda).pyo = function (language, $completion) {
    var tmp = this.um9(language, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsViewModel$observeLanguage$slambda$slambda).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BeadsProductDetailsViewModel$observeLanguage$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.m13d_1.x10k(BeadsProductDetailsViewModel$observeLanguage$slambda$slambda$lambda(this.n13d_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(BeadsProductDetailsViewModel$observeLanguage$slambda$slambda).um9 = function (language, completion) {
    var i = new BeadsProductDetailsViewModel$observeLanguage$slambda$slambda(this.m13d_1, completion);
    i.n13d_1 = language;
    return i;
  };
  function BeadsProductDetailsViewModel$observeLanguage$slambda$slambda_0(this$0, resultContinuation) {
    var i = new BeadsProductDetailsViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (language, $completion) {
      return i.pyo(language, $completion);
    }, 1);
  }
  function BeadsProductDetailsViewModel$observeFavorite$slambda$slambda$lambda($isFavorite) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, $isFavorite);
    };
  }
  function BeadsProductDetailsViewModel$observeFavorite$slambda$slambda(this$0, resultContinuation) {
    this.w13d_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BeadsProductDetailsViewModel$observeFavorite$slambda$slambda).xf4 = function (isFavorite, $completion) {
    var tmp = this.yf4(isFavorite, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsViewModel$observeFavorite$slambda$slambda).ja = function (p1, $completion) {
    return this.xf4((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BeadsProductDetailsViewModel$observeFavorite$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.w13d_1.x10k(BeadsProductDetailsViewModel$observeFavorite$slambda$slambda$lambda(this.x13d_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(BeadsProductDetailsViewModel$observeFavorite$slambda$slambda).yf4 = function (isFavorite, completion) {
    var i = new BeadsProductDetailsViewModel$observeFavorite$slambda$slambda(this.w13d_1, completion);
    i.x13d_1 = isFavorite;
    return i;
  };
  function BeadsProductDetailsViewModel$observeFavorite$slambda$slambda_0(this$0, resultContinuation) {
    var i = new BeadsProductDetailsViewModel$observeFavorite$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (isFavorite, $completion) {
      return i.xf4(isFavorite, $completion);
    }, 1);
  }
  function BeadsProductDetailsViewModel$observeStockReminder$slambda$slambda$lambda($isSet) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, $isSet);
    };
  }
  function BeadsProductDetailsViewModel$observeStockReminder$slambda$slambda(this$0, resultContinuation) {
    this.g13e_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BeadsProductDetailsViewModel$observeStockReminder$slambda$slambda).xf4 = function (isSet, $completion) {
    var tmp = this.yf4(isSet, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsViewModel$observeStockReminder$slambda$slambda).ja = function (p1, $completion) {
    return this.xf4((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BeadsProductDetailsViewModel$observeStockReminder$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.g13e_1.x10k(BeadsProductDetailsViewModel$observeStockReminder$slambda$slambda$lambda(this.h13e_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(BeadsProductDetailsViewModel$observeStockReminder$slambda$slambda).yf4 = function (isSet, completion) {
    var i = new BeadsProductDetailsViewModel$observeStockReminder$slambda$slambda(this.g13e_1, completion);
    i.h13e_1 = isSet;
    return i;
  };
  function BeadsProductDetailsViewModel$observeStockReminder$slambda$slambda_0(this$0, resultContinuation) {
    var i = new BeadsProductDetailsViewModel$observeStockReminder$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (isSet, $completion) {
      return i.xf4(isSet, $completion);
    }, 1);
  }
  function BeadsProductDetailsViewModel$handleIntent$slambda$lambda($activeProduct, $cards, $boxes) {
    return function ($this$updateState) {
      return $this$updateState.z138($activeProduct, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $cards, $boxes);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$slambda$lambda_0($this$updateState) {
    return $this$updateState.z138(VOID, VOID, false);
  }
  function BeadsProductDetailsViewModel$handleIntent$slambda$lambda_1($this$updateState) {
    return $this$updateState.z138(VOID, VOID, false);
  }
  function observeLanguage_6($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, BeadsProductDetailsViewModel$observeLanguage$slambda_0($this, null));
  }
  function observeFavorite($this, productId) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, BeadsProductDetailsViewModel$observeFavorite$slambda_0($this, productId, null));
  }
  function observeStockReminder($this, productId) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, BeadsProductDetailsViewModel$observeStockReminder$slambda_0($this, productId, null));
  }
  function BeadsProductDetailsViewModel$observeLanguage$slambda(this$0, resultContinuation) {
    this.q13e_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BeadsProductDetailsViewModel$observeLanguage$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsViewModel$observeLanguage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BeadsProductDetailsViewModel$observeLanguage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.q13e_1.y13e_1.y103();
            var action = BeadsProductDetailsViewModel$observeLanguage$slambda$slambda_0(this.q13e_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BeadsProductDetailsViewModel$observeLanguage$slambda).q24 = function ($this$launch, completion) {
    var i = new BeadsProductDetailsViewModel$observeLanguage$slambda(this.q13e_1, completion);
    i.r13e_1 = $this$launch;
    return i;
  };
  function BeadsProductDetailsViewModel$observeLanguage$slambda_0(this$0, resultContinuation) {
    var i = new BeadsProductDetailsViewModel$observeLanguage$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function BeadsProductDetailsViewModel$observeFavorite$slambda(this$0, $productId, resultContinuation) {
    this.l13f_1 = this$0;
    this.m13f_1 = $productId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BeadsProductDetailsViewModel$observeFavorite$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsViewModel$observeFavorite$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BeadsProductDetailsViewModel$observeFavorite$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.l13f_1.z13e_1.tz6(this.m13f_1);
            suspendResult = collectLatest(tmp_0, BeadsProductDetailsViewModel$observeFavorite$slambda$slambda_0(this.l13f_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BeadsProductDetailsViewModel$observeFavorite$slambda).q24 = function ($this$launch, completion) {
    var i = new BeadsProductDetailsViewModel$observeFavorite$slambda(this.l13f_1, this.m13f_1, completion);
    i.n13f_1 = $this$launch;
    return i;
  };
  function BeadsProductDetailsViewModel$observeFavorite$slambda_0(this$0, $productId, resultContinuation) {
    var i = new BeadsProductDetailsViewModel$observeFavorite$slambda(this$0, $productId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function BeadsProductDetailsViewModel$observeStockReminder$slambda(this$0, $productId, resultContinuation) {
    this.w13f_1 = this$0;
    this.x13f_1 = $productId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BeadsProductDetailsViewModel$observeStockReminder$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsViewModel$observeStockReminder$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BeadsProductDetailsViewModel$observeStockReminder$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.w13f_1.b13f_1.czr(this.x13f_1);
            suspendResult = collectLatest(tmp_0, BeadsProductDetailsViewModel$observeStockReminder$slambda$slambda_0(this.w13f_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BeadsProductDetailsViewModel$observeStockReminder$slambda).q24 = function ($this$launch, completion) {
    var i = new BeadsProductDetailsViewModel$observeStockReminder$slambda(this.w13f_1, this.x13f_1, completion);
    i.y13f_1 = $this$launch;
    return i;
  };
  function BeadsProductDetailsViewModel$observeStockReminder$slambda_0(this$0, $productId, resultContinuation) {
    var i = new BeadsProductDetailsViewModel$observeStockReminder$slambda(this$0, $productId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda($intent) {
    return function ($this$updateState) {
      var tmp9_product = $intent.a139_1;
      var tmp0_elvis_lhs = $intent.a139_1.bzu_1;
      var tmp10_selectedKind = tmp0_elvis_lhs == null ? ProductKind_BEADS_getInstance() : tmp0_elvis_lhs;
      var tmp1_elvis_lhs = $intent.a139_1.izu_1;
      var tmp11_selectedAudience = tmp1_elvis_lhs == null ? TargetAudience_BOTH_getInstance() : tmp1_elvis_lhs;
      var tmp12_selectedSize = $intent.b139_1;
      var tmp13_selectedColor = $intent.c139_1;
      var tmp2_elvis_lhs = $intent.d139_1;
      var tmp14_selectedOptions = tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs;
      var tmp3_elvis_lhs = $intent.e139_1;
      var tmp15_productComment = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      var tmp16_selectedCard = $intent.f139_1;
      var tmp17_selectedBox = $intent.g139_1;
      var tmp4_elvis_lhs = $intent.h139_1;
      var tmp18_cardMessage = tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = $intent.i139_1;
      var tmp19_cardBirthday = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
      var tmp6_elvis_lhs = $intent.j139_1;
      var tmp20_boxMessage = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
      var tmp7_elvis_lhs = $intent.k139_1;
      var tmp21_boxBirthday = tmp7_elvis_lhs == null ? '' : tmp7_elvis_lhs;
      var tmp8_elvis_lhs = $intent.l139_1;
      var tmp22_braceletName = tmp8_elvis_lhs == null ? '' : tmp8_elvis_lhs;
      var tmp23_availableCards = emptyList();
      var tmp24_availableBoxes = emptyList();
      return $this$updateState.z138(tmp9_product, VOID, VOID, VOID, VOID, VOID, tmp10_selectedKind, tmp11_selectedAudience, tmp16_selectedCard, tmp18_cardMessage, tmp19_cardBirthday, VOID, tmp17_selectedBox, tmp20_boxMessage, tmp21_boxBirthday, VOID, tmp12_selectedSize, tmp13_selectedColor, tmp14_selectedOptions, tmp15_productComment, tmp22_braceletName, tmp23_availableCards, tmp24_availableBoxes);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$slambda(this$0, $intent, resultContinuation) {
    this.h13g_1 = this$0;
    this.i13g_1 = $intent;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BeadsProductDetailsViewModel$handleIntent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsViewModel$handleIntent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BeadsProductDetailsViewModel$handleIntent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            var currentUser = this.h13g_1.x13e_1.ynu();
            this.o13g_1 = this.i13g_1.a139_1;
            this.n9_1 = 1;
            var tmp0_elvis_lhs = this.o13g_1.nzt_1;
            var tmp_0 = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
            suspendResult = this.h13g_1.c13f_1.zzk(tmp_0, currentUser == null ? null : currentUser.uym_1, getPlatform().m(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            var tmp2_elvis_lhs = this.o13g_1.nzt_1;
            suspendResult = this.h13g_1.c13f_1.yzi(tmp2_elvis_lhs == null ? new Long(0, 0) : tmp2_elvis_lhs, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var fullProduct = suspendResult;
            var tmp_1 = this;
            tmp_1.l13g_1 = fullProduct == null ? this.o13g_1 : fullProduct;
            var tmp_2;
            var this_0 = this.l13g_1.jzu_1;
            if (!(this_0 == null || this_0.r())) {
              tmp_2 = true;
            } else {
              var this_1 = this.l13g_1.kzu_1;
              tmp_2 = !(this_1 == null || this_1.r());
            }

            if (tmp_2) {
              var this_2 = this.l13g_1.jzu_1;
              if (!(this_2 == null || this_2.r())) {
                this.n9_1 = 3;
                suspendResult = this.h13g_1.c13f_1.xzk(this.l13g_1.jzu_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n13g_1 = emptyList();
                this.n9_1 = 4;
                continue $sm;
              }
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 3:
            var tmp_3 = this;
            var tmp0 = suspendResult;
            var destination = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s = tmp0.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              if (!element.nyz_1) {
                destination.j1(element);
              }
            }

            tmp_3.n13g_1 = destination;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.k13g_1 = this.n13g_1;
            var this_3 = this.l13g_1.kzu_1;
            if (!(this_3 == null || this_3.r())) {
              this.n9_1 = 5;
              suspendResult = this.h13g_1.c13f_1.yzk(this.l13g_1.kzu_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.m13g_1 = emptyList();
              this.n9_1 = 6;
              continue $sm;
            }

          case 5:
            var tmp_4 = this;
            var tmp0_0 = suspendResult;
            var destination_0 = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s_0 = tmp0_0.t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              if (!element_0.yyz_1) {
                destination_0.j1(element_0);
              }
            }

            tmp_4.m13g_1 = destination_0;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var boxes = this.m13g_1;
            this.h13g_1.x10k(BeadsProductDetailsViewModel$handleIntent$slambda$lambda(this.l13g_1, this.k13g_1, boxes));
            this.n9_1 = 7;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(BeadsProductDetailsViewModel$handleIntent$slambda).q24 = function ($this$launch, completion) {
    var i = new BeadsProductDetailsViewModel$handleIntent$slambda(this.h13g_1, this.i13g_1, completion);
    i.j13g_1 = $this$launch;
    return i;
  };
  function BeadsProductDetailsViewModel$handleIntent$slambda_0(this$0, $intent, resultContinuation) {
    var i = new BeadsProductDetailsViewModel$handleIntent$slambda(this$0, $intent, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function BeadsProductDetailsViewModel$handleIntent$slambda_1(this$0, $productId, resultContinuation) {
    this.x13g_1 = this$0;
    this.y13g_1 = $productId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BeadsProductDetailsViewModel$handleIntent$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsViewModel$handleIntent$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BeadsProductDetailsViewModel$handleIntent$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.x13g_1.a13f_1.vdf(this.y13g_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.x13g_1.d10l(new ShowMessage_3(new DynamicString('Reminder updated')), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.n9_1 = 4;
              suspendResult = this.x13g_1.d10l(new ShowMessage_3(new DynamicString('Failed to update reminder')), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(BeadsProductDetailsViewModel$handleIntent$slambda_1).q24 = function ($this$launch, completion) {
    var i = new BeadsProductDetailsViewModel$handleIntent$slambda_1(this.x13g_1, this.y13g_1, completion);
    i.z13g_1 = $this$launch;
    return i;
  };
  function BeadsProductDetailsViewModel$handleIntent$slambda_2(this$0, $productId, resultContinuation) {
    var i = new BeadsProductDetailsViewModel$handleIntent$slambda_1(this$0, $productId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_0($this$updateState) {
    return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_1($this$updateState) {
    return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_2($this$updateState) {
    return $this$updateState.z138(VOID, VOID, true);
  }
  function BeadsProductDetailsViewModel$handleIntent$slambda_3(this$0, $currentProduct, $state, $currentUser, $finalPrice, $finalDiscount, resultContinuation) {
    this.i13h_1 = this$0;
    this.j13h_1 = $currentProduct;
    this.k13h_1 = $state;
    this.l13h_1 = $currentUser;
    this.m13h_1 = $finalPrice;
    this.n13h_1 = $finalDiscount;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BeadsProductDetailsViewModel$handleIntent$slambda_3).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsViewModel$handleIntent$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BeadsProductDetailsViewModel$handleIntent$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.o9_1 = 3;
            this.n9_1 = 1;
            var tmp0_elvis_lhs = this.j13h_1.ozt_1;
            var tmp14_nameEnglish = tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
            var tmp1_elvis_lhs = this.j13h_1.pzt_1;
            var tmp15_nameArabic = tmp1_elvis_lhs == null ? 'Unknown' : tmp1_elvis_lhs;
            var tmp16_productId = this.j13h_1.nzt_1;
            var tmp2_elvis_lhs = this.j13h_1.qzt_1;
            var tmp17_descriptionEnglish = tmp2_elvis_lhs == null ? 'Unknown' : tmp2_elvis_lhs;
            var tmp3_elvis_lhs = this.j13h_1.rzt_1;
            var tmp18_descriptionArabic = tmp3_elvis_lhs == null ? 'Unknown' : tmp3_elvis_lhs;
            var tmp4_elvis_lhs = this.j13h_1.uzt_1;
            var tmp19_discountPercent = tmp4_elvis_lhs == null ? 0.0 : tmp4_elvis_lhs;
            var tmp5_elvis_lhs = this.j13h_1.vzt_1;
            var tmp20_rating = tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs;
            var tmp6_elvis_lhs = this.j13h_1.wzt_1;
            var tmp21_stock = tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs;
            var tmp22_imageUrl = this.j13h_1.xzt_1;
            var tmp23_videoUrl = this.j13h_1.yzt_1;
            var tmp24_createdAt = this.j13h_1.zzt_1;
            var tmp25_quantity = this.k13h_1.c138_1;
            var tmp26_userId = this.l13h_1.uym_1;
            var tmp27_kind = this.k13h_1.h138_1;
            var tmp7_elvis_lhs = this.j13h_1.czu_1;
            var tmp28_category = tmp7_elvis_lhs == null ? '' : tmp7_elvis_lhs;
            var tmp8_elvis_lhs = this.j13h_1.dzu_1;
            var tmp29_categoryNameEnglish = tmp8_elvis_lhs == null ? '' : tmp8_elvis_lhs;
            var tmp9_elvis_lhs = this.j13h_1.ezu_1;
            var tmp30_categoryNameArabic = tmp9_elvis_lhs == null ? '' : tmp9_elvis_lhs;
            var tmp31_designLayers = this.j13h_1.fzu_1;
            var tmp32_targetAudience = this.k13h_1.i138_1;
            var tmp33_selectedCard = this.k13h_1.j138_1;
            var tmp_0;
            var tmp10_safe_receiver = this.k13h_1.j138_1;
            if ((tmp10_safe_receiver == null ? null : tmp10_safe_receiver.oyz_1) === true) {
              tmp_0 = this.k13h_1.k138_1;
            } else {
              tmp_0 = null;
            }

            var tmp34_cardMessage = tmp_0;
            var tmp_1;
            var tmp11_safe_receiver = this.k13h_1.j138_1;
            if ((tmp11_safe_receiver == null ? null : tmp11_safe_receiver.pyz_1) === true) {
              tmp_1 = this.k13h_1.l138_1;
            } else {
              tmp_1 = null;
            }

            var tmp35_cardBirthday = tmp_1;
            var tmp36_selectedBox = this.k13h_1.n138_1;
            var tmp_2;
            var tmp12_safe_receiver = this.k13h_1.n138_1;
            if ((tmp12_safe_receiver == null ? null : tmp12_safe_receiver.zyz_1) === true) {
              tmp_2 = this.k13h_1.o138_1;
            } else {
              tmp_2 = null;
            }

            var tmp37_boxMessage = tmp_2;
            var tmp_3;
            var tmp13_safe_receiver = this.k13h_1.n138_1;
            if ((tmp13_safe_receiver == null ? null : tmp13_safe_receiver.az0_1) === true) {
              tmp_3 = this.k13h_1.p138_1;
            } else {
              tmp_3 = null;
            }

            var tmp38_boxBirthday = tmp_3;
            var tmp39_selectedSize = this.k13h_1.r138_1;
            var tmp40_selectedColor = this.k13h_1.s138_1;
            var this_0 = this.k13h_1.t138_1;
            var tmp_4;
            if (this_0.r()) {
              tmp_4 = null;
            } else {
              tmp_4 = this_0;
            }

            var tmp41_selectedOptions = tmp_4;
            var this_1 = this.k13h_1.u138_1;
            var tmp_5;
            if (!isBlank(this_1)) {
              tmp_5 = this_1;
            } else {
              tmp_5 = null;
            }

            var tmp42_productComment = tmp_5;
            var this_2 = this.k13h_1.v138_1;
            var tmp_6;
            if (!isBlank(this_2)) {
              tmp_6 = this_2;
            } else {
              tmp_6 = null;
            }

            var tmp43_braceletName = tmp_6;
            var tmp44_isKids = this.j13h_1.rzu_1;
            var tmp45_isYouth = this.j13h_1.szu_1;
            var tmp46_isOld = this.j13h_1.tzu_1;
            suspendResult = this.i13h_1.w13e_1.c103(new CartItem(VOID, tmp16_productId, tmp14_nameEnglish, tmp15_nameArabic, tmp17_descriptionEnglish, tmp18_descriptionArabic, this.m13h_1, this.n13h_1, tmp19_discountPercent, tmp20_rating, tmp21_stock, tmp22_imageUrl, tmp25_quantity, VOID, tmp31_designLayers, tmp26_userId, tmp24_createdAt, tmp23_videoUrl, VOID, tmp27_kind, tmp28_category, tmp29_categoryNameEnglish, tmp30_categoryNameArabic, tmp32_targetAudience, tmp33_selectedCard, tmp34_cardMessage, tmp35_cardBirthday, tmp36_selectedBox, tmp37_boxMessage, tmp38_boxBirthday, tmp39_selectedSize, tmp40_selectedColor, tmp41_selectedOptions, tmp42_productComment, tmp44_isKids, tmp45_isYouth, tmp46_isOld, tmp43_braceletName), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.i13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$slambda$lambda_0);
            this.n9_1 = 2;
            suspendResult = this.i13h_1.d10l(new ShowToast(new ResourceString(get_added_to_cart(string_instance), [])), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_7 = this.q9_1;
            if (tmp_7 instanceof Exception) {
              var e = this.q9_1;
              this.i13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$slambda$lambda_1);
              this.n9_1 = 4;
              var tmp_8 = get_failed_add_to_cart(string_instance);
              var tmp47_elvis_lhs = e.message;
              suspendResult = this.i13h_1.d10l(new ShowMessage_3(new ResourceString(tmp_8, [tmp47_elvis_lhs == null ? '' : tmp47_elvis_lhs])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(BeadsProductDetailsViewModel$handleIntent$slambda_3).q24 = function ($this$launch, completion) {
    var i = new BeadsProductDetailsViewModel$handleIntent$slambda_3(this.i13h_1, this.j13h_1, this.k13h_1, this.l13h_1, this.m13h_1, this.n13h_1, completion);
    i.o13h_1 = $this$launch;
    return i;
  };
  function BeadsProductDetailsViewModel$handleIntent$slambda_4(this$0, $currentProduct, $state, $currentUser, $finalPrice, $finalDiscount, resultContinuation) {
    var i = new BeadsProductDetailsViewModel$handleIntent$slambda_3(this$0, $currentProduct, $state, $currentUser, $finalPrice, $finalDiscount, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_3($intent) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, $intent.m139_1);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_4($intent) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, $intent.p13h_1);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_5($intent) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.q13h_1);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_6($intent) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.n139_1);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_7($intent) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.o139_1);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_8($intent) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.p139_1, false);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_9($intent) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.q139_1);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_10($intent) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.r139_1);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_11($intent) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.s139_1, false);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_12($intent) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.t139_1);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_13($intent) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.u139_1);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_14(this$0, $intent) {
    return function ($this$updateState) {
      var currentOptions = toMutableMap(this$0.s10h().ajg().u1().t138_1);
      if ($intent.w139_1 == null) {
        currentOptions.a3($intent.v139_1);
      } else {
        var valueWithGroup = $intent.w139_1;
        // Inline function 'kotlin.collections.set' call
        var key = $intent.v139_1;
        currentOptions.z2(key, valueWithGroup);
      }
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, currentOptions);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_15($intent) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.x139_1);
    };
  }
  function BeadsProductDetailsViewModel$handleIntent$lambda_16($intent) {
    return function ($this$updateState) {
      return $this$updateState.z138(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.y139_1);
    };
  }
  function $handleIntentCOROUTINE$_13(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z13h_1 = _this__u8e3s4;
    this.a13i_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_13).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 16;
            var tmp0_subject = this.a13i_1;
            if (tmp0_subject instanceof LoadProduct_0) {
              var tmp_0 = this;
              if (this.z13h_1.s10h().ajg().u1().d138_1)
                return Unit_instance;
              this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda(this.a13i_1));
              var tmp1_elvis_lhs = this.a13i_1.a139_1.nzt_1;
              observeFavorite(this.z13h_1, tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs);
              var tmp2_elvis_lhs = this.a13i_1.a139_1.nzt_1;
              observeStockReminder(this.z13h_1, tmp2_elvis_lhs == null ? new Long(0, 0) : tmp2_elvis_lhs);
              var tmp_1 = get_viewModelScope(this.z13h_1);
              tmp_0.b13i_1 = launch(tmp_1, VOID, VOID, BeadsProductDetailsViewModel$handleIntent$slambda_0(this.z13h_1, this.a13i_1, null));
              this.n9_1 = 17;
              continue $sm;
            } else {
              if (equals(tmp0_subject, ToggleFavorite_instance)) {
                var currentUser = this.z13h_1.x13e_1.ynu();
                if (currentUser == null) {
                  this.n9_1 = 15;
                  suspendResult = this.z13h_1.d10l(NavigateToAuth_instance_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.n9_1 = 13;
                  continue $sm;
                }
              } else {
                if (equals(tmp0_subject, ToggleStockReminder_instance)) {
                  var currentUser_0 = this.z13h_1.x13e_1.ynu();
                  if (currentUser_0 == null) {
                    this.n9_1 = 12;
                    suspendResult = this.z13h_1.d10l(NavigateToAuth_instance_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.n9_1 = 11;
                    continue $sm;
                  }
                } else {
                  if (tmp0_subject instanceof AddToCart_0) {
                    if (this.z13h_1.s10h().ajg().u1().d138_1)
                      return Unit_instance;
                    this.d13i_1 = this.z13h_1.s10h().ajg().u1();
                    var tmp_2 = this;
                    var tmp8_elvis_lhs = this.d13i_1.b138_1;
                    var tmp_3;
                    if (tmp8_elvis_lhs == null) {
                      return Unit_instance;
                    } else {
                      tmp_3 = tmp8_elvis_lhs;
                    }
                    tmp_2.e13i_1 = tmp_3;
                    var tmp_4;
                    var tmp9_safe_receiver = this.d13i_1.j138_1;
                    if ((tmp9_safe_receiver == null ? null : tmp9_safe_receiver.pyz_1) === true) {
                      tmp_4 = isBlank(this.d13i_1.l138_1);
                    } else {
                      tmp_4 = false;
                    }
                    if (tmp_4) {
                      this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_0);
                      this.n9_1 = 10;
                      suspendResult = this.z13h_1.d10l(new ShowMessage_3(new ResourceString(get_invalid_birthday_date(string_instance), [])), this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      this.n9_1 = 1;
                      continue $sm;
                    }
                  } else {
                    if (tmp0_subject instanceof QuantityChanged) {
                      var tmp_5 = this;
                      this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_3(this.a13i_1));
                      tmp_5.b13i_1 = Unit_instance;
                      this.n9_1 = 17;
                      continue $sm;
                    } else {
                      if (tmp0_subject instanceof KindChanged) {
                        var tmp_6 = this;
                        this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_4(this.a13i_1));
                        tmp_6.b13i_1 = Unit_instance;
                        this.n9_1 = 17;
                        continue $sm;
                      } else {
                        if (tmp0_subject instanceof TargetAudienceChanged) {
                          var tmp_7 = this;
                          this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_5(this.a13i_1));
                          tmp_7.b13i_1 = Unit_instance;
                          this.n9_1 = 17;
                          continue $sm;
                        } else {
                          if (tmp0_subject instanceof CardSelected_0) {
                            var tmp_8 = this;
                            this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_6(this.a13i_1));
                            tmp_8.b13i_1 = Unit_instance;
                            this.n9_1 = 17;
                            continue $sm;
                          } else {
                            if (tmp0_subject instanceof CardMessageChanged_0) {
                              var tmp_9 = this;
                              this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_7(this.a13i_1));
                              tmp_9.b13i_1 = Unit_instance;
                              this.n9_1 = 17;
                              continue $sm;
                            } else {
                              if (tmp0_subject instanceof CardBirthdayChanged_0) {
                                var tmp_10 = this;
                                this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_8(this.a13i_1));
                                tmp_10.b13i_1 = Unit_instance;
                                this.n9_1 = 17;
                                continue $sm;
                              } else {
                                if (tmp0_subject instanceof BoxSelected_0) {
                                  var tmp_11 = this;
                                  this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_9(this.a13i_1));
                                  tmp_11.b13i_1 = Unit_instance;
                                  this.n9_1 = 17;
                                  continue $sm;
                                } else {
                                  if (tmp0_subject instanceof BoxMessageChanged_0) {
                                    var tmp_12 = this;
                                    this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_10(this.a13i_1));
                                    tmp_12.b13i_1 = Unit_instance;
                                    this.n9_1 = 17;
                                    continue $sm;
                                  } else {
                                    if (tmp0_subject instanceof BoxBirthdayChanged_0) {
                                      var tmp_13 = this;
                                      this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_11(this.a13i_1));
                                      tmp_13.b13i_1 = Unit_instance;
                                      this.n9_1 = 17;
                                      continue $sm;
                                    } else {
                                      if (tmp0_subject instanceof SizeSelected_0) {
                                        var tmp_14 = this;
                                        this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_12(this.a13i_1));
                                        tmp_14.b13i_1 = Unit_instance;
                                        this.n9_1 = 17;
                                        continue $sm;
                                      } else {
                                        if (tmp0_subject instanceof ColorSelected_0) {
                                          var tmp_15 = this;
                                          this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_13(this.a13i_1));
                                          tmp_15.b13i_1 = Unit_instance;
                                          this.n9_1 = 17;
                                          continue $sm;
                                        } else {
                                          if (tmp0_subject instanceof OptionSelected_0) {
                                            var tmp_16 = this;
                                            this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_14(this.z13h_1, this.a13i_1));
                                            tmp_16.b13i_1 = Unit_instance;
                                            this.n9_1 = 17;
                                            continue $sm;
                                          } else {
                                            if (tmp0_subject instanceof ProductCommentChanged_0) {
                                              var tmp_17 = this;
                                              this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_15(this.a13i_1));
                                              tmp_17.b13i_1 = Unit_instance;
                                              this.n9_1 = 17;
                                              continue $sm;
                                            } else {
                                              if (tmp0_subject instanceof BraceletNameChanged) {
                                                var tmp_18 = this;
                                                this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_16(this.a13i_1));
                                                tmp_18.b13i_1 = Unit_instance;
                                                this.n9_1 = 17;
                                                continue $sm;
                                              } else {
                                                if (equals(tmp0_subject, ShareProduct_instance)) {
                                                  var tmp_19 = this;
                                                  var state = this.z13h_1.s10h().ajg().u1();
                                                  var tmp23_elvis_lhs = state.b138_1;
                                                  var tmp_20;
                                                  if (tmp23_elvis_lhs == null) {
                                                    return Unit_instance;
                                                  } else {
                                                    tmp_20 = tmp23_elvis_lhs;
                                                  }
                                                  var product = tmp_20;
                                                  var language = state.g138_1;
                                                  var name = language === 'en' ? product.ozt_1 : product.pzt_1;
                                                  var description = language === 'en' ? product.qzt_1 : product.rzt_1;
                                                  var url = 'https://hadaya-ea700.web.app/product/' + toString_0(product.nzt_1);
                                                  var tmp_21 = name == null ? '' : name;
                                                  shareProduct(tmp_21, description == null ? '' : description, url);
                                                  tmp_19.b13i_1 = Unit_instance;
                                                  this.n9_1 = 17;
                                                  continue $sm;
                                                } else {
                                                  var tmp_22 = this;
                                                  noWhenBranchMatchedException();
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            break;
          case 1:
            var tmp_23;
            var tmp10_safe_receiver = this.d13i_1.n138_1;
            if ((tmp10_safe_receiver == null ? null : tmp10_safe_receiver.az0_1) === true) {
              tmp_23 = isBlank(this.d13i_1.p138_1);
            } else {
              tmp_23 = false;
            }

            if (tmp_23) {
              this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_1);
              this.n9_1 = 9;
              suspendResult = this.z13h_1.d10l(new ShowMessage_3(new ResourceString(get_invalid_birthday_date(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            if (!(this.d13i_1.j138_1 == null) && ensureNotNull(this.d13i_1.j138_1).myz_1 <= 0) {
              this.n9_1 = 8;
              suspendResult = this.z13h_1.d10l(new ShowMessage_3(new ResourceString(get_out_of_stock(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            if (!(this.d13i_1.n138_1 == null) && ensureNotNull(this.d13i_1.n138_1).xyz_1 <= 0) {
              this.n9_1 = 7;
              suspendResult = this.z13h_1.d10l(new ShowMessage_3(new ResourceString(get_out_of_stock(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            this.c13i_1 = this.z13h_1.x13e_1.ynu();
            if (this.c13i_1 == null) {
              this.n9_1 = 6;
              suspendResult = this.z13h_1.d10l(NavigateToAuth_instance_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 5:
            var tmp11_safe_receiver = this.d13i_1.j138_1;
            var tmp12_elvis_lhs = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.lyz_1;
            var tmp_24 = tmp12_elvis_lhs == null ? 0.0 : tmp12_elvis_lhs;
            var tmp13_safe_receiver = this.d13i_1.n138_1;
            var tmp14_elvis_lhs = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.wyz_1;
            var tmp_25 = tmp_24 + (tmp14_elvis_lhs == null ? 0.0 : tmp14_elvis_lhs);
            var sum = 0;
            var _iterator__ex2g4s = this.d13i_1.t138_1.y2().t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              var tmp_26 = sum;
              var tmp0_elvis_lhs = element.q100_1;
              sum = tmp_26 + (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
            }

            var extraOriginalPrice = tmp_25 + sum;
            var tmp15_safe_receiver = this.d13i_1.j138_1;
            var tmp16_elvis_lhs = tmp15_safe_receiver == null ? null : tmp15_safe_receiver.lyz_1;
            var tmp_27 = tmp16_elvis_lhs == null ? 0.0 : tmp16_elvis_lhs;
            var tmp17_safe_receiver = this.d13i_1.n138_1;
            var tmp18_elvis_lhs = tmp17_safe_receiver == null ? null : tmp17_safe_receiver.wyz_1;
            var tmp_28 = tmp_27 + (tmp18_elvis_lhs == null ? 0.0 : tmp18_elvis_lhs);
            var sum_0 = 0;
            var _iterator__ex2g4s_0 = this.d13i_1.t138_1.y2().t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              var tmp_29 = sum_0;
              var tmp_30;
              var tmp0_elvis_lhs_0 = element_0.r100_1;
              if ((tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0) > 0.0) {
                tmp_30 = ensureNotNull(element_0.r100_1);
              } else {
                var tmp1_elvis_lhs_0 = element_0.q100_1;
                tmp_30 = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
              }
              sum_0 = tmp_29 + tmp_30;
            }

            var extraDiscountedPrice = tmp_28 + sum_0;
            var tmp19_elvis_lhs = this.e13i_1.szt_1;
            var finalPrice = (tmp19_elvis_lhs == null ? 0.0 : tmp19_elvis_lhs) + extraOriginalPrice;
            var tmp_31;
            var tmp20_elvis_lhs = this.e13i_1.tzt_1;
            if ((tmp20_elvis_lhs == null ? 0.0 : tmp20_elvis_lhs) > 0.0) {
              tmp_31 = true;
            } else {
              var tmp0 = this.d13i_1.t138_1.y2();
              var tmp$ret$0;
              l$ret$1: do {
                var tmp_32;
                if (isInterface(tmp0, Collection)) {
                  tmp_32 = tmp0.r();
                } else {
                  tmp_32 = false;
                }
                if (tmp_32) {
                  tmp$ret$0 = false;
                  break l$ret$1;
                }
                var _iterator__ex2g4s_1 = tmp0.t();
                while (_iterator__ex2g4s_1.u()) {
                  var element_1 = _iterator__ex2g4s_1.v();
                  var tmp0_elvis_lhs_1 = element_1.r100_1;
                  if ((tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1) > 0.0) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                }
                tmp$ret$0 = false;
              }
               while (false);
              tmp_31 = tmp$ret$0;
            }

            var hasAnyDiscount = tmp_31;
            var tmp_33;
            if (hasAnyDiscount) {
              var tmp_34;
              var tmp21_elvis_lhs = this.e13i_1.tzt_1;
              if ((tmp21_elvis_lhs == null ? 0.0 : tmp21_elvis_lhs) > 0.0) {
                tmp_34 = ensureNotNull(this.e13i_1.tzt_1);
              } else {
                var tmp22_elvis_lhs = this.e13i_1.szt_1;
                tmp_34 = tmp22_elvis_lhs == null ? 0.0 : tmp22_elvis_lhs;
              }
              tmp_33 = tmp_34 + extraDiscountedPrice;
            } else {
              tmp_33 = 0.0;
            }

            var finalDiscount = tmp_33;
            this.z13h_1.x10k(BeadsProductDetailsViewModel$handleIntent$lambda_2);
            var tmp_35 = this;
            var tmp_36 = get_viewModelScope(this.z13h_1);
            tmp_35.b13i_1 = launch(tmp_36, VOID, VOID, BeadsProductDetailsViewModel$handleIntent$slambda_4(this.z13h_1, this.e13i_1, this.d13i_1, this.c13i_1, finalPrice, finalDiscount, null));
            this.n9_1 = 17;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            return Unit_instance;
          case 8:
            return Unit_instance;
          case 9:
            return Unit_instance;
          case 10:
            return Unit_instance;
          case 11:
            var tmp6_safe_receiver = this.z13h_1.s10h().ajg().u1().b138_1;
            var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.nzt_1;
            var tmp_37;
            if (tmp7_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_37 = tmp7_elvis_lhs;
            }

            var productId = tmp_37;
            var tmp_38 = this;
            var tmp_39 = get_viewModelScope(this.z13h_1);
            tmp_38.b13i_1 = launch(tmp_39, VOID, VOID, BeadsProductDetailsViewModel$handleIntent$slambda_2(this.z13h_1, productId, null));
            this.n9_1 = 17;
            continue $sm;
          case 12:
            return Unit_instance;
          case 13:
            var tmp3_safe_receiver = this.z13h_1.s10h().ajg().u1().b138_1;
            var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.nzt_1;
            var tmp_40;
            if (tmp4_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_40 = tmp4_elvis_lhs;
            }

            var productId_0 = tmp_40;
            this.n9_1 = 14;
            suspendResult = this.z13h_1.z13e_1.vz6(productId_0 == null ? new Long(0, 0) : productId_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 14:
            var tmp_41 = this;
            tmp_41.b13i_1 = Unit_instance;
            this.n9_1 = 17;
            continue $sm;
          case 15:
            return Unit_instance;
          case 16:
            throw this.q9_1;
          case 17:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 16) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function BeadsProductDetailsViewModel(addToCartUseCase, getCurrentUserValueUseCase, getLanguageUseCase, favoriteRepository, toggleStockReminderUseCase, stockReminderRepository, productRepository) {
    BaseMviViewModel.call(this, new BeadsProductDetailsState());
    this.w13e_1 = addToCartUseCase;
    this.x13e_1 = getCurrentUserValueUseCase;
    this.y13e_1 = getLanguageUseCase;
    this.z13e_1 = favoriteRepository;
    this.a13f_1 = toggleStockReminderUseCase;
    this.b13f_1 = stockReminderRepository;
    this.c13f_1 = productRepository;
    observeLanguage_6(this);
  }
  protoOf(BeadsProductDetailsViewModel).f13i = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_13(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BeadsProductDetailsViewModel).f10l = function (intent, $completion) {
    return this.f13i(isInterface(intent, BeadsProductDetailsIntent) ? intent : THROW_CCE(), $completion);
  };
  function CustomMagicMugDetailsScreen(product, onBack, onNavigateToAuth, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, topPadding, bottomPadding, $composer, $changed, $changed1, $default) {
    var initialSize_0 = {_v: initialSize};
    var initialColor_0 = {_v: initialColor};
    var initialOptions_0 = {_v: initialOptions};
    var initialComment_0 = {_v: initialComment};
    var initialCard_0 = {_v: initialCard};
    var initialBox_0 = {_v: initialBox};
    var initialCardMessage_0 = {_v: initialCardMessage};
    var initialCardBirthday_0 = {_v: initialCardBirthday};
    var initialBoxMessage_0 = {_v: initialBoxMessage};
    var initialBoxBirthday_0 = {_v: initialBoxBirthday};
    var topPadding_0 = {_v: new Dp(topPadding)};
    var bottomPadding_0 = {_v: new Dp(bottomPadding)};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(336862151);
    sourceInformation($composer_0, 'C(CustomMagicMugDetailsScreen)P(13,11,12,10,7,9,8,4,1,6,5,3,2,14:c#ui.unit.Dp,0:c#ui.unit.Dp)123@5969L42,124@6083L12,125@6139L16,126@6184L32,127@6247L21,137@6768L689,137@6744L713,156@7489L563,156@7463L589,171@8117L108,171@8058L167,175@8254L90,175@8231L113,181@8377L34,182@8440L34,183@8504L34,185@8570L34,186@8646L42,187@8721L34,188@8785L34,189@8850L25,191@9005L203,191@8881L327,211@9585L39149:CustomMagicMugDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(product) : $composer_0.q31(product)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToAuth) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(initialSize_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(initialColor_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ((($changed & 262144) === 0 ? $composer_0.k31(initialOptions_0._v) : $composer_0.q31(initialOptions_0._v)) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(initialComment_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ((($changed & 16777216) === 0 ? $composer_0.k31(initialCard_0._v) : $composer_0.q31(initialCard_0._v)) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ((($changed & 134217728) === 0 ? $composer_0.k31(initialBox_0._v) : $composer_0.q31(initialBox_0._v)) ? 67108864 : 33554432);
    if (!(($default & 512) === 0))
      $dirty = $dirty | 805306368;
    else if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.k31(initialCardMessage_0._v) ? 536870912 : 268435456);
    if (!(($default & 1024) === 0))
      $dirty1 = $dirty1 | 6;
    else if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(initialCardBirthday_0._v) ? 4 : 2);
    if (!(($default & 2048) === 0))
      $dirty1 = $dirty1 | 48;
    else if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(initialBoxMessage_0._v) ? 32 : 16);
    if (!(($default & 4096) === 0))
      $dirty1 = $dirty1 | 384;
    else if (($changed1 & 384) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(initialBoxBirthday_0._v) ? 256 : 128);
    if (!(($default & 8192) === 0))
      $dirty1 = $dirty1 | 3072;
    else if (($changed1 & 3072) === 0)
      $dirty1 = $dirty1 | ($composer_0.n31(_Dp___get_value__impl__geb1vb(topPadding_0._v.m5f_1)) ? 2048 : 1024);
    if (!(($default & 16384) === 0))
      $dirty1 = $dirty1 | 24576;
    else if (($changed1 & 24576) === 0)
      $dirty1 = $dirty1 | ($composer_0.n31(_Dp___get_value__impl__geb1vb(bottomPadding_0._v.m5f_1)) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        initialSize_0._v = null;
      }
      if (!(($default & 16) === 0)) {
        initialColor_0._v = null;
      }
      if (!(($default & 32) === 0)) {
        initialOptions_0._v = null;
      }
      if (!(($default & 64) === 0)) {
        initialComment_0._v = null;
      }
      if (!(($default & 128) === 0)) {
        initialCard_0._v = null;
      }
      if (!(($default & 256) === 0)) {
        initialBox_0._v = null;
      }
      if (!(($default & 512) === 0)) {
        initialCardMessage_0._v = null;
      }
      if (!(($default & 1024) === 0)) {
        initialCardBirthday_0._v = null;
      }
      if (!(($default & 2048) === 0)) {
        initialBoxMessage_0._v = null;
      }
      if (!(($default & 4096) === 0)) {
        initialBoxBirthday_0._v = null;
      }
      if (!(($default & 8192) === 0)) {
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
        topPadding_0._v = new Dp(tmp$ret$0);
      }
      if (!(($default & 16384) === 0)) {
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(0);
        bottomPadding_0._v = new Dp(tmp$ret$1);
      }
      if (isTraceInProgress()) {
        traceEventStart(336862151, $dirty, $dirty1, 'client.fstech.hadaya.presentation.product_details.CustomMagicMugDetailsScreen (CustomMagicMugDetailsScreen.kt:122)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = toString_0(product.nzt_1);
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((59 & 1) === 0))
        qualifier = null;
      if (!((59 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((59 & 4) === 0))
        key = null;
      if (!((59 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((59 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((59 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(CustomProductDetailsViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      // Inline function 'org.koin.compose.koinInject' call
      var qualifier_0 = null;
      var scope_0 = null;
      var $composer_2 = $composer_0;
      sourceInformationMarkerStart($composer_2, -1168520582, 'CC(koinInject)88@2750L18,90@2787L73:Inject.kt#8jjlyv');
      if (!((3 & 1) === 0))
        qualifier_0 = null;
      if (!((3 & 2) === 0))
        scope_0 = currentKoinScope($composer_2, 0);
      sourceInformationMarkerStart($composer_2, -1961811197, 'CC(remember):Inject.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_2.k31(qualifier_0) | $composer_2.k31(scope_0));
      // Inline function 'kotlin.let' call
      var it = $composer_2.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = scope_0.ts6(getKClass(AppViewModel), qualifier_0);
        $composer_2.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_2);
      sourceInformationMarkerEnd($composer_2);
      var appViewModel = tmp1_group;
      var tmp_1 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_1, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, 1602009831, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_0.i31();
      var tmp_2;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = new SnackbarHostState();
        this_0.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp0_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp0_group;
      var verticalScrollState = rememberScrollState(0, $composer_0, 0, 1);
      var language = CustomMagicMugDetailsScreen$lambda(state$delegate).d10z_1;
      var tmp0_elvis_lhs_0 = CustomMagicMugDetailsScreen$lambda(state$delegate).y10y_1;
      var activeProduct = tmp0_elvis_lhs_0 == null ? product : tmp0_elvis_lhs_0;
      var tmp_3;
      if (language === 'en') {
        var tmp1_elvis_lhs = activeProduct.ozt_1;
        tmp_3 = tmp1_elvis_lhs == null ? activeProduct.pzt_1 : tmp1_elvis_lhs;
      } else {
        var tmp2_elvis_lhs = activeProduct.pzt_1;
        tmp_3 = tmp2_elvis_lhs == null ? activeProduct.ozt_1 : tmp2_elvis_lhs;
      }
      var tmp3_elvis_lhs = tmp_3;
      var name = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      var tmp_4;
      if (language === 'en') {
        var tmp4_elvis_lhs = activeProduct.qzt_1;
        tmp_4 = tmp4_elvis_lhs == null ? activeProduct.rzt_1 : tmp4_elvis_lhs;
      } else {
        var tmp5_elvis_lhs = activeProduct.rzt_1;
        tmp_4 = tmp5_elvis_lhs == null ? activeProduct.qzt_1 : tmp5_elvis_lhs;
      }
      var tmp6_elvis_lhs = tmp_4;
      var description = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
      sourceInformationMarkerStart($composer_0, 1602029176, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(!!(!!(!!(!!(!!(!!(!!(!!(!!(!!($composer_0.q31(viewModel) | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(product)))) | ($dirty & 7168) === 2048) | ($dirty & 57344) === 16384) | (($dirty & 458752) === 131072 || (!(($dirty & 262144) === 0) && $composer_0.q31(initialOptions_0._v)))) | ($dirty & 3670016) === 1048576) | (($dirty & 29360128) === 8388608 || (!(($dirty & 16777216) === 0) && $composer_0.q31(initialCard_0._v)))) | (($dirty & 234881024) === 67108864 || (!(($dirty & 134217728) === 0) && $composer_0.q31(initialBox_0._v)))) | ($dirty & 1879048192) === 536870912) | ($dirty1 & 14) === 4) | ($dirty1 & 112) === 32) | ($dirty1 & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_0.i31();
      var tmp_5;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = CustomMagicMugDetailsScreen$slambda_0(viewModel, product, initialSize_0, initialColor_0, initialOptions_0, initialComment_0, initialCard_0, initialBox_0, initialCardMessage_0, initialCardBirthday_0, initialBoxMessage_0, initialBoxBirthday_0, null);
        tmp0_0.j31(value_1);
        tmp_5 = value_1;
      } else {
        tmp_5 = it_1;
      }
      var tmp1_group_0 = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(product, tmp1_group_0, $composer_0, 14 & $dirty);
      sourceInformationMarkerStart($composer_0, 1602052122, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(!!($composer_0.q31(viewModel) | ($dirty & 896) === 256) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_1.i31();
      var tmp_6;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = CustomMagicMugDetailsScreen$slambda_2(viewModel, snackbarHostState, onNavigateToAuth, onBack, null);
        tmp0_1.j31(value_2);
        tmp_6 = value_2;
      } else {
        tmp_6 = it_2;
      }
      var tmp2_group = tmp_6;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp2_group, $composer_0, 0);
      var tmp_7 = CustomMagicMugDetailsScreen$lambda(state$delegate).a10z_1;
      var tmp_8 = CustomMagicMugDetailsScreen$lambda(state$delegate).g10z_1;
      sourceInformationMarkerStart($composer_0, 1602071763, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = !!($composer_0.q31(appViewModel) | $composer_0.k31(state$delegate));
      // Inline function 'kotlin.let' call
      var it_3 = tmp0_2.i31();
      var tmp_9;
      if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = CustomMagicMugDetailsScreen$slambda_4(appViewModel, state$delegate, null);
        tmp0_2.j31(value_3);
        tmp_9 = value_3;
      } else {
        tmp_9 = it_3;
      }
      var tmp3_group = tmp_9;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect(tmp_7, tmp_8, tmp3_group, $composer_0, 0);
      sourceInformationMarkerStart($composer_0, 1602076129, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      var tmp0_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = $composer_0.q31(appViewModel);
      // Inline function 'kotlin.let' call
      var it_4 = tmp0_3.i31();
      var tmp_10;
      if (invalid_3 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = CustomMagicMugDetailsScreen$lambda_0(appViewModel);
        tmp0_3.j31(value_4);
        tmp_10 = value_4;
      } else {
        tmp_10 = it_4;
      }
      var tmp4_group = tmp_10;
      sourceInformationMarkerEnd($composer_0);
      DisposableEffect(Unit_instance, tmp4_group, $composer_0, 6);
      sourceInformationMarkerStart($composer_0, 1602080009, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_5 = this_1.i31();
      var tmp_11;
      if (false || it_5 === Companion_getInstance().f30_1) {
        var value_5 = mutableStateOf(false);
        this_1.j31(value_5);
        tmp_11 = value_5;
      } else {
        tmp_11 = it_5;
      }
      var tmp5_group = tmp_11;
      sourceInformationMarkerEnd($composer_0);
      var isInteractingWith3D$delegate = tmp5_group;
      sourceInformationMarkerStart($composer_0, 1602082025, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_6 = this_2.i31();
      var tmp_12;
      if (false || it_6 === Companion_getInstance().f30_1) {
        var value_6 = mutableStateOf(false);
        this_2.j31(value_6);
        tmp_12 = value_6;
      } else {
        tmp_12 = it_6;
      }
      var tmp6_group = tmp_12;
      sourceInformationMarkerEnd($composer_0);
      var showFullScreen3D$delegate = tmp6_group;
      sourceInformationMarkerStart($composer_0, 1602084073, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_7 = this_3.i31();
      var tmp_13;
      if (false || it_7 === Companion_getInstance().f30_1) {
        var value_7 = mutableStateOf(false);
        this_3.j31(value_7);
        tmp_13 = value_7;
      } else {
        tmp_13 = it_7;
      }
      var tmp7_group = tmp_13;
      sourceInformationMarkerEnd($composer_0);
      var isMediaDialogOpen$delegate = tmp7_group;
      sourceInformationMarkerStart($composer_0, 1602086185, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_4 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_8 = this_4.i31();
      var tmp_14;
      if (false || it_8 === Companion_getInstance().f30_1) {
        var value_8 = mutableStateOf(false);
        this_4.j31(value_8);
        tmp_14 = value_8;
      } else {
        tmp_14 = it_8;
      }
      var tmp8_group = tmp_14;
      sourceInformationMarkerEnd($composer_0);
      var showBirthdayPicker$delegate = tmp8_group;
      sourceInformationMarkerStart($composer_0, 1602088625, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_5 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_9 = this_5.i31();
      var tmp_15;
      if (false || it_9 === Companion_getInstance().f30_1) {
        var value_9 = mutableStateOf(null);
        this_5.j31(value_9);
        tmp_15 = value_9;
      } else {
        tmp_15 = it_9;
      }
      var tmp9_group = tmp_15;
      sourceInformationMarkerEnd($composer_0);
      var birthdayPickerTargetOptionKey$delegate = tmp9_group;
      sourceInformationMarkerStart($composer_0, 1602091017, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_6 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_10 = this_6.i31();
      var tmp_16;
      if (false || it_10 === Companion_getInstance().f30_1) {
        var value_10 = mutableStateOf(false);
        this_6.j31(value_10);
        tmp_16 = value_10;
      } else {
        tmp_16 = it_10;
      }
      var tmp10_group = tmp_16;
      sourceInformationMarkerEnd($composer_0);
      var isPickingBoxBirthday$delegate = tmp10_group;
      sourceInformationMarkerStart($composer_0, 1602093065, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_7 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_11 = this_7.i31();
      var tmp_17;
      if (false || it_11 === Companion_getInstance().f30_1) {
        var value_11 = mutableStateOf(false);
        this_7.j31(value_11);
        tmp_17 = value_11;
      } else {
        tmp_17 = it_11;
      }
      var tmp11_group = tmp_17;
      sourceInformationMarkerEnd($composer_0);
      var showDiscardDialog$delegate = tmp11_group;
      var tmp_18 = _DisplayMode___init__impl__gfd230(0);
      var birthdayPickerState = rememberDatePickerState(null, null, null, tmp_18, null, $composer_0, 0, 31);
      var tmp_19;
      var tmp_20;
      if (CustomMagicMugDetailsScreen$lambda(state$delegate).a10z_1 || CustomMagicMugDetailsScreen$lambda_3(showFullScreen3D$delegate)) {
        tmp_20 = true;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_20 = !CustomMagicMugDetailsScreen$lambda(state$delegate).g10z_1.r();
      }
      if (tmp_20) {
        tmp_19 = !CustomMagicMugDetailsScreen$lambda(state$delegate).h10z_1;
      } else {
        tmp_19 = false;
      }
      var tmp_21 = tmp_19;
      sourceInformationMarkerStart($composer_0, 1602100274, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      var tmp0_4 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_4 = $composer_0.k31(state$delegate);
      // Inline function 'kotlin.let' call
      var it_12 = tmp0_4.i31();
      var tmp_22;
      if (invalid_4 || it_12 === Companion_getInstance().f30_1) {
        var value_12 = CustomMagicMugDetailsScreen$lambda_15(showFullScreen3D$delegate, state$delegate, showDiscardDialog$delegate);
        tmp0_4.j31(value_12);
        tmp_22 = value_12;
      } else {
        tmp_22 = it_12;
      }
      var tmp12_group = tmp_22;
      sourceInformationMarkerEnd($composer_0);
      BackHandler(tmp_21, tmp12_group, $composer_0, 0, 0);
      if (CustomMagicMugDetailsScreen$lambda_13(showDiscardDialog$delegate)) {
        $composer_0.m30(-1874264603);
        sourceInformation($composer_0, '201@9286L46,202@9356L44,203@9426L82,207@9534L29,200@9247L326');
        var tmp_23 = stringResource(get_discard_order_title(string_instance), $composer_0, 0);
        var tmp_24 = stringResource(get_discard_order_msg(string_instance), $composer_0, 0);
        sourceInformationMarkerStart($composer_0, 1602113625, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        var tmp0_5 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = ($dirty & 112) === 32;
        // Inline function 'kotlin.let' call
        var it_13 = tmp0_5.i31();
        var tmp_25;
        if (invalid_5 || it_13 === Companion_getInstance().f30_1) {
          var value_13 = CustomMagicMugDetailsScreen$lambda_16(onBack, showDiscardDialog$delegate);
          tmp0_5.j31(value_13);
          tmp_25 = value_13;
        } else {
          tmp_25 = it_13;
        }
        var tmp13_group = tmp_25;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 1602117028, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_8 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_14 = this_8.i31();
        var tmp_26;
        if (false || it_14 === Companion_getInstance().f30_1) {
          var value_14 = CustomMagicMugDetailsScreen$lambda_17(showDiscardDialog$delegate);
          this_8.j31(value_14);
          tmp_26 = value_14;
        } else {
          tmp_26 = it_14;
        }
        var tmp14_group = tmp_26;
        sourceInformationMarkerEnd($composer_0);
        HadayaAlertDialog(tmp_23, tmp_24, null, null, tmp13_group, tmp14_group, $composer_0, 196608, 12);
        $composer_0.n30();
      } else {
        $composer_0.m30(-1873935941);
        $composer_0.n30();
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = fillMaxSize(Companion_instance);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_3 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_4 = $composer_3;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_4, 0).hashCode();
      var localMap = $composer_4.t31();
      var materialized = materialize($composer_4, modifier_0);
      var tmp0_6 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_5 = $composer_4;
      var tmp_27 = $composer_5.g30();
      if (!isInterface(tmp_27, Applier)) {
        invalidApplier();
      }
      $composer_5.b31();
      if ($composer_5.h30()) {
        $composer_5.c31(tmp0_6);
      } else {
        $composer_5.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_5);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_6 = $composer_5;
      var $composer_7 = $composer_6;
      sourceInformationMarkerStart($composer_7, -967518548, 'C852@43559L55,852@43503L111,880@44593L79,881@44698L28,882@44755L138,872@44268L635,913@46141L128:CustomMagicMugDetailsScreen.kt#8gd4xm');
      if (!CustomMagicMugDetailsScreen$lambda(state$delegate).h10z_1) {
        $composer_7.m30(-967658700);
        sourceInformation($composer_7, '219@9896L34,220@9969L31,214@9707L308,224@10071L24193,690@34454L11,693@34607L8877,688@34314L9170');
        var tmp0_modifier = alpha(BoxScopeInstance_instance.udr(fillMaxWidth(Companion_instance, 0.8), Companion_getInstance_11().o8t_1), 0.03);
        var tmp1_painter = painterResource(get_logo(drawable_instance), $composer_7, 0);
        var tmp2_contentDescription = stringResource(get_logo_0(string_instance), $composer_7, 0);
        Image(tmp1_painter, tmp2_contentDescription, tmp0_modifier, null, null, 0.0, null, $composer_7, androidx_compose_ui_graphics_painter_Painter$stableprop_getter(), 120);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_1 = zIndex(verticalScroll(fillMaxSize(Companion_instance), verticalScrollState, !CustomMagicMugDetailsScreen$lambda(state$delegate).a10z_1 && !CustomMagicMugDetailsScreen$lambda_1(isInteractingWith3D$delegate)), 0.0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_8 = $composer_7;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_8, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_9 = $composer_8;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_9, 0).hashCode();
        var localMap_0 = $composer_9.t31();
        var materialized_0 = materialize($composer_9, modifier_2);
        var tmp0_7 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_10 = $composer_9;
        var tmp_28 = $composer_10.g30();
        if (!isInterface(tmp_28, Applier)) {
          invalidApplier();
        }
        $composer_10.b31();
        if ($composer_10.h30()) {
          $composer_10.c31(tmp0_7);
        } else {
          $composer_10.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_10);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_11 = $composer_10;
        var $composer_12 = $composer_11;
        sourceInformationMarkerStart($composer_12, 2143864564, 'C239@10708L11,234@10443L7466,375@17927L41,380@18148L26,377@17986L206,384@18258L15873,682@34149L41,684@34208L42:CustomMagicMugDetailsScreen.kt#8gd4xm');
        var tmp_29 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$82 = _Dp___init__impl__ms3zkb(400);
        var tmp_30 = height(tmp_29, tmp$ret$82);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp0_bottomStart = _Dp___init__impl__ms3zkb(32);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_bottomEnd = _Dp___init__impl__ms3zkb(32);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = background(clip(tmp_30, RoundedCornerShape_0(VOID, VOID, tmp1_bottomEnd, tmp0_bottomStart)), Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_12, 6).oo0_1, 0.3));
        var contentAlignment_0 = null;
        var propagateMinConstraints_0 = false;
        var $composer_13 = $composer_12;
        if (!((6 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_14 = $composer_13;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_14, 0).hashCode();
        var localMap_1 = $composer_14.t31();
        var materialized_1 = materialize($composer_14, modifier_4);
        var tmp0_8 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_15 = $composer_14;
        var tmp_31 = $composer_15.g30();
        if (!isInterface(tmp_31, Applier)) {
          invalidApplier();
        }
        $composer_15.b31();
        if ($composer_15.h30()) {
          $composer_15.c31(tmp0_8);
        } else {
          $composer_15.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_15);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_16 = $composer_15;
        var $composer_17 = $composer_16;
        sourceInformationMarkerStart($composer_17, -695117340, 'C244@10941L402,242@10830L1727,276@12621L3625,350@16643L11,345@16361L27,353@16803L1088,344@16318L1573:CustomMagicMugDetailsScreen.kt#8gd4xm');
        var tmp_32 = fillMaxSize(Companion_instance);
        sourceInformationMarkerStart($composer_17, -992257572, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_15 = $composer_17.i31();
        var tmp_33;
        if (false || it_15 === Companion_getInstance().f30_1) {
          var tmp_34 = CustomMagicMugDetailsScreen$slambda_6(isInteractingWith3D$delegate, null);
          var value_15 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5(tmp_34);
          $composer_17.j31(value_15);
          tmp_33 = value_15;
        } else {
          tmp_33 = it_15;
        }
        var tmp0_group_0 = tmp_33;
        sourceInformationMarkerEnd($composer_17);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_5 = pointerInput(tmp_32, Unit_instance, tmp0_group_0);
        var contentAlignment_1 = null;
        var propagateMinConstraints_1 = false;
        var $composer_18 = $composer_17;
        if (!((6 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment_1 = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints_1 = false;
        var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_19 = $composer_18;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_19, 0).hashCode();
        var localMap_2 = $composer_19.t31();
        var materialized_2 = materialize($composer_19, modifier_6);
        var tmp0_9 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_20 = $composer_19;
        var tmp_35 = $composer_20.g30();
        if (!isInterface(tmp_35, Applier)) {
          invalidApplier();
        }
        $composer_20.b31();
        if ($composer_20.h30()) {
          $composer_20.c31(tmp0_9);
        } else {
          $composer_20.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_20);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_21 = $composer_20;
        var $composer_22 = $composer_21;
        sourceInformationMarkerStart($composer_22, 346362024, 'C:CustomMagicMugDetailsScreen.kt#8gd4xm');
        if (!CustomMagicMugDetailsScreen$lambda_3(showFullScreen3D$delegate)) {
          $composer_22.m30(346384126);
          sourceInformation($composer_22, '260@11822L311,254@11445L1064');
          var tmp_36 = CustomMagicMugDetailsScreen$lambda(state$delegate).i10z_1;
          var tmp_37 = CustomMagicMugDetailsScreen$lambda(state$delegate).j10z_1;
          var tmp_38 = ProductKind_MAGIC_MUG_getInstance();
          var tmp_39 = CustomMagicMugDetailsScreen$lambda(state$delegate).e10z_1;
          var tmp_40 = CustomMagicMugDetailsScreen$lambda(state$delegate).f10z_1;
          sourceInformationMarkerStart($composer_22, -1512834757, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_6 = !!($composer_0.q31(viewModel) | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(product))));
          // Inline function 'kotlin.let' call
          var it_16 = $composer_22.i31();
          var tmp_41;
          if (invalid_6 || it_16 === Companion_getInstance().f30_1) {
            var value_16 = CustomMagicMugDetailsScreen$lambda_18(viewModel, product);
            $composer_22.j31(value_16);
            tmp_41 = value_16;
          } else {
            tmp_41 = it_16;
          }
          var tmp0_group_1 = tmp_41;
          sourceInformationMarkerEnd($composer_22);
          Model3DViewerSection(tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, tmp0_group_1, fillMaxSize(Companion_instance), !CustomMagicMugDetailsScreen$lambda_13(showDiscardDialog$delegate) && !CustomMagicMugDetailsScreen$lambda_7(showBirthdayPicker$delegate) && !CustomMagicMugDetailsScreen$lambda(state$delegate).a10z_1 && !CustomMagicMugDetailsScreen$lambda(state$delegate).h10z_1 && !CustomMagicMugDetailsScreen$lambda_5(isMediaDialogOpen$delegate), _Dp___get_value__impl__geb1vb(topPadding_0._v.m5f_1), _Dp___get_value__impl__geb1vb(bottomPadding_0._v.m5f_1), $composer_22, 1573248, 0);
          $composer_22.n30();
        } else {
          $composer_22.m30(347460446);
          $composer_22.n30();
        }
        sourceInformationMarkerEnd($composer_22);
        $composer_20.e31();
        var tmp0_$receiver = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_top = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_start = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_end = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_7 = padding_1(tmp0_$receiver, tmp2_start, tmp1_top, tmp3_end);
        var horizontalArrangement = Arrangement_getInstance().wdp_1;
        var verticalAlignment = null;
        var $composer_23 = $composer_17;
        if (!((4 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((4 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((4 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_3 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_23, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_24 = $composer_23;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_24, 0).hashCode();
        var localMap_3 = $composer_24.t31();
        var materialized_3 = materialize($composer_24, modifier_8);
        var tmp0_10 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_25 = $composer_24;
        var tmp_42 = $composer_25.g30();
        if (!isInterface(tmp_42, Applier)) {
          invalidApplier();
        }
        $composer_25.b31();
        if ($composer_25.h30()) {
          $composer_25.c31(tmp0_10);
        } else {
          $composer_25.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_25);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_26 = $composer_25;
        var $composer_27 = $composer_26;
        sourceInformationMarkerStart($composer_27, 123570927, 'C283@12961L309,291@13371L11,282@12914L1064,304@14004L2220:CustomMagicMugDetailsScreen.kt#8gd4xm');
        sourceInformationMarkerStart($composer_27, 1250910651, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_7 = !!($composer_0.k31(state$delegate) | ($dirty & 112) === 32);
        // Inline function 'kotlin.let' call
        var it_17 = $composer_27.i31();
        var tmp_43;
        if (invalid_7 || it_17 === Companion_getInstance().f30_1) {
          var value_17 = CustomMagicMugDetailsScreen$lambda_19(onBack, state$delegate, showDiscardDialog$delegate);
          $composer_27.j31(value_17);
          tmp_43 = value_17;
        } else {
          tmp_43 = it_17;
        }
        var tmp0_group_2 = tmp_43;
        sourceInformationMarkerEnd($composer_27);
        var tmp_44 = get_CircleShape();
        var tmp_45 = MaterialTheme_instance.unz($composer_27, 6).mo0_1;
        var tmp_46 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_47 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_48 = _Dp___init__impl__ms3zkb(4);
        Surface_0(tmp0_group_2, null, false, tmp_44, tmp_45, tmp_46, tmp_47, tmp_48, null, null, ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().g13i_1, $composer_27, 12582912, 6, 870);
        var tmp_49 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$119 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_9 = null;
        var horizontalArrangement_0 = tmp_49.mdq(tmp$ret$119);
        var verticalAlignment_0 = null;
        var $composer_28 = $composer_27;
        if (!((5 & 1) === 0))
          modifier_9 = Companion_instance;
        if (!((5 & 2) === 0))
          horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
        if (!((5 & 4) === 0))
          verticalAlignment_0 = Companion_getInstance_11().t8t_1;
        var measurePolicy_4 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_28, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_10 = modifier_9;
        var $composer_29 = $composer_28;
        if (!((0 & 2) === 0))
          modifier_10 = Companion_instance;
        var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_29, 0).hashCode();
        var localMap_4 = $composer_29.t31();
        var materialized_4 = materialize($composer_29, modifier_10);
        var tmp0_11 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_30 = $composer_29;
        var tmp_50 = $composer_30.g30();
        if (!isInterface(tmp_50, Applier)) {
          invalidApplier();
        }
        $composer_30.b31();
        if ($composer_30.h30()) {
          $composer_30.c31(tmp0_11);
        } else {
          $composer_30.d31();
        }
        var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_30);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
        var $composer_31 = $composer_30;
        var $composer_32 = $composer_31;
        sourceInformationMarkerStart($composer_32, -638047931, 'C306@14141L73,308@14323L11,310@14429L901,305@14090L1240,326@15410L71,328@15590L11,325@15359L839:CustomMagicMugDetailsScreen.kt#8gd4xm');
        sourceInformationMarkerStart($composer_32, 1503438059, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_8 = $composer_32.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_18 = $composer_32.i31();
        var tmp_51;
        if (invalid_8 || it_18 === Companion_getInstance().f30_1) {
          var value_18 = CustomMagicMugDetailsScreen$lambda_20(viewModel);
          $composer_32.j31(value_18);
          tmp_51 = value_18;
        } else {
          tmp_51 = it_18;
        }
        var tmp0_group_3 = tmp_51;
        sourceInformationMarkerEnd($composer_32);
        var tmp_52 = get_CircleShape();
        var tmp_53 = MaterialTheme_instance.unz($composer_32, 6).mo0_1;
        var tmp_54 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_55 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_56 = _Dp___init__impl__ms3zkb(4);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1136689495, true, CustomMagicMugDetailsScreen$lambda_21(state$delegate), $composer_32, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_33 = $composer_32;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_9 = $composer_33.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_19 = $composer_33.i31();
        var tmp_57;
        if (invalid_9 || it_19 === Companion_getInstance().f30_1) {
          var value_19 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_33.j31(value_19);
          tmp_57 = value_19;
        } else {
          tmp_57 = it_19;
        }
        var tmp$ret$131 = tmp_57;
        Surface_0(tmp0_group_3, null, false, tmp_52, tmp_53, tmp_54, tmp_55, tmp_56, null, null, tmp$ret$131, $composer_32, 12582912, 6, 870);
        sourceInformationMarkerStart($composer_32, 1503478665, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_10 = $composer_32.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_20 = $composer_32.i31();
        var tmp_58;
        if (invalid_10 || it_20 === Companion_getInstance().f30_1) {
          var value_20 = CustomMagicMugDetailsScreen$lambda_22(viewModel);
          $composer_32.j31(value_20);
          tmp_58 = value_20;
        } else {
          tmp_58 = it_20;
        }
        var tmp1_group_1 = tmp_58;
        sourceInformationMarkerEnd($composer_32);
        var tmp_59 = get_CircleShape();
        var tmp_60 = MaterialTheme_instance.unz($composer_32, 6).mo0_1;
        var tmp_61 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_62 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_63 = _Dp___init__impl__ms3zkb(4);
        Surface_0(tmp1_group_1, null, false, tmp_59, tmp_60, tmp_61, tmp_62, tmp_63, null, null, ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().i13i_1, $composer_32, 12582912, 6, 870);
        sourceInformationMarkerEnd($composer_32);
        $composer_30.e31();
        sourceInformationMarkerEnd($composer_27);
        $composer_25.e31();
        var tmp4_$receiver = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().s8t_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp5_bottom = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp6_end = _Dp___init__impl__ms3zkb(16);
        var tmp7_modifier = zIndex(padding_1(tmp4_$receiver, VOID, VOID, tmp6_end, tmp5_bottom), 2.0);
        var tmp8_color = MaterialTheme_instance.unz($composer_17, 6).eo0_1;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$145 = _Dp___init__impl__ms3zkb(24);
        var tmp9_shape = RoundedCornerShape(tmp$ret$145);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp10_shadowElevation = _Dp___init__impl__ms3zkb(6);
        sourceInformationMarkerStart($composer_17, -992084507, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_21 = $composer_17.i31();
        var tmp_64;
        if (false || it_21 === Companion_getInstance().f30_1) {
          var value_21 = CustomMagicMugDetailsScreen$lambda_23(showFullScreen3D$delegate);
          $composer_17.j31(value_21);
          tmp_64 = value_21;
        } else {
          tmp_64 = it_21;
        }
        var tmp1_group_2 = tmp_64;
        sourceInformationMarkerEnd($composer_17);
        var tmp_65 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_66 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(1349469599, true, CustomMagicMugDetailsScreen$lambda_24(language), $composer_17, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_34 = $composer_17;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_11 = $composer_34.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_22 = $composer_34.i31();
        var tmp_67;
        if (invalid_11 || it_22 === Companion_getInstance().f30_1) {
          var value_22 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_34.j31(value_22);
          tmp_67 = value_22;
        } else {
          tmp_67 = it_22;
        }
        var tmp$ret$151 = tmp_67;
        Surface_0(tmp1_group_2, tmp7_modifier, false, tmp9_shape, tmp8_color, tmp_65, tmp_66, tmp10_shadowElevation, null, null, tmp$ret$151, $composer_17, 12582918, 6, 868);
        sourceInformationMarkerEnd($composer_17);
        $composer_15.e31();
        var tmp_68 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$158 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_68, tmp$ret$158), $composer_12, 6);
        sourceInformationMarkerStart($composer_12, 1870495018, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_23 = $composer_12.i31();
        var tmp_69;
        if (false || it_23 === Companion_getInstance().f30_1) {
          var value_23 = CustomMagicMugDetailsScreen$lambda_25(isMediaDialogOpen$delegate);
          $composer_12.j31(value_23);
          tmp_69 = value_23;
        } else {
          tmp_69 = it_23;
        }
        var tmp0_group_4 = tmp_69;
        sourceInformationMarkerEnd($composer_12);
        ProductMediaGallerySection(activeProduct, language, tmp0_group_4, $composer_12, 384, 0);
        var tmp_70 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$163 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_11 = padding_2(tmp_70, tmp$ret$163);
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = null;
        var $composer_35 = $composer_12;
        if (!((6 & 1) === 0))
          modifier_11 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_5 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_35, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_12 = modifier_11;
        var $composer_36 = $composer_35;
        if (!((0 & 2) === 0))
          modifier_12 = Companion_instance;
        var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_36, 0).hashCode();
        var localMap_5 = $composer_36.t31();
        var materialized_5 = materialize($composer_36, modifier_12);
        var tmp0_12 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_37 = $composer_36;
        var tmp_71 = $composer_37.g30();
        if (!isInterface(tmp_71, Applier)) {
          invalidApplier();
        }
        $composer_37.b31();
        if ($composer_37.h30()) {
          $composer_37.c31(tmp0_12);
        } else {
          $composer_37.d31();
        }
        var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_37);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
        var $composer_38 = $composer_37;
        var $composer_39 = $composer_38;
        sourceInformationMarkerStart($composer_39, 1813063177, 'C387@18425L10,389@18557L11,385@18336L267,392@18625L41,395@18719L2910,442@21651L41,445@21771L69,444@21714L208,449@21944L41,452@22156L10,450@22006L192,455@22220L41,639@32155L41,642@32330L220,640@32217L570,652@32809L41,654@32872L202,660@33096L41,663@33193L856,678@34071L41:CustomMagicMugDetailsScreen.kt#8gd4xm');
        var tmp0_style = MaterialTheme_instance.jog($composer_39, 6).jof_1;
        var tmp1_fontWeight = Companion_getInstance_16().f7z_1;
        var tmp2_color = MaterialTheme_instance.unz($composer_39, 6).lo0_1;
        var tmp_72 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_73 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_74 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_75 = _TextOverflow___init__impl__obguoe(0);
        Text(name, null, tmp2_color, null, tmp_72, null, tmp1_fontWeight, null, tmp_73, null, null, tmp_74, tmp_75, false, 0, 0, null, tmp0_style, $composer_39, 1572864, 0, 131002);
        var tmp_76 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$170 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_76, tmp$ret$170), $composer_39, 6);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_13 = fillMaxWidth(Companion_instance);
        var horizontalArrangement_1 = Arrangement_getInstance().wdp_1;
        var verticalAlignment_1 = Companion_getInstance_11().u8t_1;
        var $composer_40 = $composer_39;
        if (!((0 & 1) === 0))
          modifier_13 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement_1 = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment_1 = Companion_getInstance_11().t8t_1;
        var measurePolicy_6 = rowMeasurePolicy(horizontalArrangement_1, verticalAlignment_1, $composer_40, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_14 = modifier_13;
        var $composer_41 = $composer_40;
        if (!((0 & 2) === 0))
          modifier_14 = Companion_instance;
        var compositeKeyHash_6 = get_currentCompositeKeyHashCode($composer_41, 0).hashCode();
        var localMap_6 = $composer_41.t31();
        var materialized_6 = materialize($composer_41, modifier_14);
        var tmp0_13 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_42 = $composer_41;
        var tmp_77 = $composer_42.g30();
        if (!isInterface(tmp_77, Applier)) {
          invalidApplier();
        }
        $composer_42.b31();
        if ($composer_42.h30()) {
          $composer_42.c31(tmp0_13);
        } else {
          $composer_42.d31();
        }
        var $this$ReusableComposeNode_6 = _Updater___init__impl__rbfxm8($composer_42);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, measurePolicy_6, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, localMap_6, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, compositeKeyHash_6, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_6, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, materialized_6, Companion_getInstance_12().qah_1);
        var $composer_43 = $composer_42;
        var $composer_44 = $composer_43;
        sourceInformationMarkerStart($composer_44, -939961849, 'C400@18977L2630:CustomMagicMugDetailsScreen.kt#8gd4xm');
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_15 = null;
        var verticalArrangement_1 = null;
        var horizontalAlignment_1 = null;
        var $composer_45 = $composer_44;
        if (!((7 & 1) === 0))
          modifier_15 = Companion_instance;
        if (!((7 & 2) === 0))
          verticalArrangement_1 = Arrangement_getInstance().sdp_1;
        if (!((7 & 4) === 0))
          horizontalAlignment_1 = Companion_getInstance_11().w8t_1;
        var measurePolicy_7 = columnMeasurePolicy(verticalArrangement_1, horizontalAlignment_1, $composer_45, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_16 = modifier_15;
        var $composer_46 = $composer_45;
        if (!((0 & 2) === 0))
          modifier_16 = Companion_instance;
        var compositeKeyHash_7 = get_currentCompositeKeyHashCode($composer_46, 0).hashCode();
        var localMap_7 = $composer_46.t31();
        var materialized_7 = materialize($composer_46, modifier_16);
        var tmp0_14 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_47 = $composer_46;
        var tmp_78 = $composer_47.g30();
        if (!isInterface(tmp_78, Applier)) {
          invalidApplier();
        }
        $composer_47.b31();
        if ($composer_47.h30()) {
          $composer_47.c31(tmp0_14);
        } else {
          $composer_47.d31();
        }
        var $this$ReusableComposeNode_7 = _Updater___init__impl__rbfxm8($composer_47);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, measurePolicy_7, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, localMap_7, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, compositeKeyHash_7, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_7, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, materialized_7, Companion_getInstance_12().qah_1);
        var $composer_48 = $composer_47;
        var $composer_49 = $composer_48;
        sourceInformationMarkerStart($composer_49, 1528387292, 'C:CustomMagicMugDetailsScreen.kt#8gd4xm');
        var tmp0_safe_receiver = CustomMagicMugDetailsScreen$lambda(state$delegate).m10z_1;
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lyz_1;
        var tmp_79 = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
        var tmp2_safe_receiver = CustomMagicMugDetailsScreen$lambda(state$delegate).q10z_1;
        var tmp3_elvis_lhs_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.wyz_1;
        var tmp_80 = tmp_79 + (tmp3_elvis_lhs_0 == null ? 0.0 : tmp3_elvis_lhs_0);
        // Inline function 'kotlin.collections.sumOf' call
        var sum = 0;
        var _iterator__ex2g4s = CustomMagicMugDetailsScreen$lambda(state$delegate).w10z_1.y2().t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          var tmp_81 = sum;
          var tmp0_elvis_lhs_1 = element.q100_1;
          sum = tmp_81 + (tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1);
        }
        var extraOriginalPrice = tmp_80 + sum;
        var tmp4_safe_receiver = CustomMagicMugDetailsScreen$lambda(state$delegate).m10z_1;
        var tmp5_elvis_lhs_0 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.lyz_1;
        var tmp_82 = tmp5_elvis_lhs_0 == null ? 0.0 : tmp5_elvis_lhs_0;
        var tmp6_safe_receiver = CustomMagicMugDetailsScreen$lambda(state$delegate).q10z_1;
        var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.wyz_1;
        var tmp_83 = tmp_82 + (tmp7_elvis_lhs == null ? 0.0 : tmp7_elvis_lhs);
        // Inline function 'kotlin.collections.sumOf' call
        var sum_0 = 0;
        var _iterator__ex2g4s_0 = CustomMagicMugDetailsScreen$lambda(state$delegate).w10z_1.y2().t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          var tmp_84 = sum_0;
          var tmp_85;
          var tmp0_elvis_lhs_2 = element_0.r100_1;
          if ((tmp0_elvis_lhs_2 == null ? 0.0 : tmp0_elvis_lhs_2) > 0.0) {
            tmp_85 = ensureNotNull(element_0.r100_1);
          } else {
            var tmp1_elvis_lhs_1 = element_0.q100_1;
            tmp_85 = tmp1_elvis_lhs_1 == null ? 0.0 : tmp1_elvis_lhs_1;
          }
          sum_0 = tmp_84 + tmp_85;
        }
        var extraDiscountedPrice = tmp_83 + sum_0;
        var tmp8_elvis_lhs = activeProduct.szt_1;
        var finalOriginalPrice = (tmp8_elvis_lhs == null ? 0.0 : tmp8_elvis_lhs) + extraOriginalPrice;
        var tmp_86;
        var tmp9_elvis_lhs = activeProduct.tzt_1;
        if ((tmp9_elvis_lhs == null ? 0.0 : tmp9_elvis_lhs) > 0.0) {
          tmp_86 = ensureNotNull(activeProduct.tzt_1);
        } else {
          var tmp10_elvis_lhs = activeProduct.szt_1;
          tmp_86 = tmp10_elvis_lhs == null ? 0.0 : tmp10_elvis_lhs;
        }
        var finalDiscountedPrice = tmp_86 + extraDiscountedPrice;
        var tmp_87;
        var tmp11_elvis_lhs = activeProduct.tzt_1;
        if ((tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs) > 0.0) {
          tmp_87 = true;
        } else {
          var tmp0_15 = CustomMagicMugDetailsScreen$lambda(state$delegate).w10z_1.y2();
          var tmp$ret$187;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp_88;
            if (isInterface(tmp0_15, Collection)) {
              tmp_88 = tmp0_15.r();
            } else {
              tmp_88 = false;
            }
            if (tmp_88) {
              tmp$ret$187 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s_1 = tmp0_15.t();
            while (_iterator__ex2g4s_1.u()) {
              var element_1 = _iterator__ex2g4s_1.v();
              var tmp0_elvis_lhs_3 = element_1.r100_1;
              if ((tmp0_elvis_lhs_3 == null ? 0.0 : tmp0_elvis_lhs_3) > 0.0) {
                tmp$ret$187 = true;
                break $l$block_0;
              }
            }
            tmp$ret$187 = false;
          }
          tmp_87 = tmp$ret$187;
        }
        var hasDiscount = tmp_87;
        if (hasDiscount) {
          $composer_49.m30(1529204668);
          sourceInformation($composer_49, '411@19966L197,416@20301L11,410@19917L504,420@20503L195,425@20836L11,419@20454L525');
          var tmp12_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalDiscountedPrice)], $composer_49, 0), language);
          var tmp13_fontSize = get_sp(28);
          var tmp14_color = MaterialTheme_instance.unz($composer_49, 6).xnz_1;
          var tmp15_fontWeight = Companion_getInstance_16().g7z_1;
          var tmp_89 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_90 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_91 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp12_text, null, tmp14_color, null, tmp13_fontSize, null, tmp15_fontWeight, null, tmp_89, null, null, tmp_90, tmp_91, false, 0, 0, null, null, $composer_49, 1597440, 0, 262058);
          var tmp16_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_49, 0), language);
          var tmp17_fontSize = get_sp(18);
          var tmp18_color = MaterialTheme_instance.unz($composer_49, 6).po0_1;
          var tmp19_textDecoration = Companion_getInstance_18().c80_1;
          var tmp_92 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_93 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_94 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp16_text, null, tmp18_color, null, tmp17_fontSize, null, null, null, tmp_92, tmp19_textDecoration, null, tmp_93, tmp_94, false, 0, 0, null, null, $composer_49, 805330944, 0, 261610);
          $composer_49.n30();
        } else {
          $composer_49.m30(1530341996);
          sourceInformation($composer_49, '430@21098L195,435@21431L11,429@21049L502');
          var tmp20_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_49, 0), language);
          var tmp21_fontSize = get_sp(28);
          var tmp22_color = MaterialTheme_instance.unz($composer_49, 6).xnz_1;
          var tmp23_fontWeight = Companion_getInstance_16().g7z_1;
          var tmp_95 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_96 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_97 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp20_text, null, tmp22_color, null, tmp21_fontSize, null, tmp23_fontWeight, null, tmp_95, null, null, tmp_96, tmp_97, false, 0, 0, null, null, $composer_49, 1597440, 0, 262058);
          $composer_49.n30();
        }
        sourceInformationMarkerEnd($composer_49);
        $composer_47.e31();
        sourceInformationMarkerEnd($composer_44);
        $composer_42.e31();
        var tmp_98 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$189 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_98, tmp$ret$189), $composer_39, 6);
        sourceInformationMarkerStart($composer_39, 1305506111, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_12 = $composer_39.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_24 = $composer_39.i31();
        var tmp_99;
        if (invalid_12 || it_24 === Companion_getInstance().f30_1) {
          var value_24 = CustomMagicMugDetailsScreen$lambda_26(viewModel);
          $composer_39.j31(value_24);
          tmp_99 = value_24;
        } else {
          tmp_99 = it_24;
        }
        var tmp0_group_5 = tmp_99;
        sourceInformationMarkerEnd($composer_39);
        var tmp_100 = fillMaxWidth(Companion_instance);
        var tmp_101 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_102 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        CustomizeActionButton(tmp0_group_5, tmp_100, null, tmp_101, tmp_102, null, $composer_39, 48, 60);
        var tmp_103 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$194 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_103, tmp$ret$194), $composer_39, 6);
        $composer_39.m30(1305515183);
        sourceInformation($composer_39, '*451@22065L41');
        // Inline function 'kotlin.text.ifBlank' call
        var tmp_104;
        if (isBlank(description)) {
          tmp_104 = stringResource(get_no_description(string_instance), $composer_39, 0);
        } else {
          tmp_104 = description;
        }
        var tmp1_group_3 = tmp_104;
        $composer_39.n30();
        var tmp_105 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_106 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_107 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_108 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_109 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp1_group_3, null, tmp_105, null, tmp_106, null, null, null, tmp_107, null, null, tmp_108, tmp_109, false, 0, 0, null, MaterialTheme_instance.jog($composer_39, 6).oof_1, $composer_39, 0, 0, 131070);
        var tmp_110 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$197 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_110, tmp$ret$197), $composer_39, 6);
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!CustomMagicMugDetailsScreen$lambda(state$delegate).y10z_1.r()) {
          $composer_39.m30(1816692439);
          sourceInformation($composer_39, '460@22473L38,463@22694L326,459@22415L680');
          var tmp_111 = stringResource(get_select_card(string_instance), $composer_39, 0);
          var tmp_112 = CustomMagicMugDetailsScreen$lambda(state$delegate).y10z_1;
          var tmp3_safe_receiver = CustomMagicMugDetailsScreen$lambda(state$delegate).m10z_1;
          var tmp_113 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.gyz_1;
          sourceInformationMarkerStart($composer_39, 1305535904, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_13 = $composer_39.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_25 = $composer_39.i31();
          var tmp_114;
          if (invalid_13 || it_25 === Companion_getInstance().f30_1) {
            var value_25 = CustomMagicMugDetailsScreen$lambda_27(viewModel);
            $composer_39.j31(value_25);
            tmp_114 = value_25;
          } else {
            tmp_114 = it_25;
          }
          var tmp2_group_0 = tmp_114;
          sourceInformationMarkerEnd($composer_39);
          GiftSelectionSection(tmp_111, tmp_112, tmp_113, tmp2_group_0, language, false, $composer_39, 0, 32);
          var tmp7_safe_receiver = CustomMagicMugDetailsScreen$lambda(state$delegate).m10z_1;
          if ((tmp7_safe_receiver == null ? null : tmp7_safe_receiver.oyz_1) === true) {
            $composer_39.m30(1817427294);
            sourceInformation($composer_39, '475@23319L248,483@23870L423,473@23193L1130');
            var tmp4_value = CustomMagicMugDetailsScreen$lambda(state$delegate).n10z_1;
            var tmp_115 = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$203 = _Dp___init__impl__ms3zkb(8);
            var tmp5_modifier = padding_1(tmp_115, VOID, tmp$ret$203);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$204 = _Dp___init__impl__ms3zkb(12);
            var tmp6_shape = RoundedCornerShape(tmp$ret$204);
            sourceInformationMarkerStart($composer_39, 1305555826, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_14 = $composer_39.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_26 = $composer_39.i31();
            var tmp_116;
            if (invalid_14 || it_26 === Companion_getInstance().f30_1) {
              var value_26 = CustomMagicMugDetailsScreen$lambda_28(viewModel);
              $composer_39.j31(value_26);
              tmp_116 = value_26;
            } else {
              tmp_116 = it_26;
            }
            var tmp3_group_0 = tmp_116;
            sourceInformationMarkerEnd($composer_39);
            var tmp_117 = ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().j13i_1;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_1 = rememberComposableLambda(1384714461, true, CustomMagicMugDetailsScreen$lambda_29(state$delegate), $composer_39, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_50 = $composer_39;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_15 = $composer_50.k31(dispatchReceiver_1);
            // Inline function 'kotlin.let' call
            var it_27 = $composer_50.i31();
            var tmp_118;
            if (invalid_15 || it_27 === Companion_getInstance().f30_1) {
              var value_27 = ComposableLambda$invoke$ref(dispatchReceiver_1);
              $composer_50.j31(value_27);
              tmp_118 = value_27;
            } else {
              tmp_118 = it_27;
            }
            var tmp_119 = tmp_118;
            OutlinedTextField(tmp4_value, tmp3_group_0, tmp5_modifier, false, false, null, tmp_117, null, null, null, null, null, tmp_119, false, null, null, null, false, 0, 0, null, tmp6_shape, null, $composer_39, 1573248, 384, 0, 6287288);
            $composer_39.n30();
          } else {
            $composer_39.m30(1818539016);
            $composer_39.n30();
          }
          var tmp11_safe_receiver = CustomMagicMugDetailsScreen$lambda(state$delegate).m10z_1;
          if ((tmp11_safe_receiver == null ? null : tmp11_safe_receiver.pyz_1) === true) {
            $composer_39.m30(1818669650);
            sourceInformation($composer_39, '500@24860L176,496@24575L2,505@25152L312,494@24448L1046');
            var tmp8_value = CustomMagicMugDetailsScreen$lambda(state$delegate).o10z_1;
            var tmp_120 = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$216 = _Dp___init__impl__ms3zkb(8);
            var tmp_121 = padding_1(tmp_120, VOID, tmp$ret$216);
            sourceInformationMarkerStart($composer_39, 1305605066, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_28 = $composer_39.i31();
            var tmp_122;
            if (false || it_28 === Companion_getInstance().f30_1) {
              var value_28 = CustomMagicMugDetailsScreen$lambda_30(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
              $composer_39.j31(value_28);
              tmp_122 = value_28;
            } else {
              tmp_122 = it_28;
            }
            var tmp4_group_0 = tmp_122;
            sourceInformationMarkerEnd($composer_39);
            var tmp9_modifier = clickable(tmp_121, VOID, VOID, VOID, VOID, tmp4_group_0);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$221 = _Dp___init__impl__ms3zkb(12);
            var tmp10_shape = RoundedCornerShape(tmp$ret$221);
            sourceInformationMarkerStart($composer_39, 1305595772, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_29 = $composer_39.i31();
            var tmp_123;
            if (false || it_29 === Companion_getInstance().f30_1) {
              var value_29 = CustomMagicMugDetailsScreen$lambda_31;
              $composer_39.j31(value_29);
              tmp_123 = value_29;
            } else {
              tmp_123 = it_29;
            }
            var tmp5_group_0 = tmp_123;
            sourceInformationMarkerEnd($composer_39);
            var tmp_124 = ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().k13i_1;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_2 = rememberComposableLambda(-1273403530, true, CustomMagicMugDetailsScreen$lambda_32(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_39, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_51 = $composer_39;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_16 = $composer_51.k31(dispatchReceiver_2);
            // Inline function 'kotlin.let' call
            var it_30 = $composer_51.i31();
            var tmp_125;
            if (invalid_16 || it_30 === Companion_getInstance().f30_1) {
              var value_30 = ComposableLambda$invoke$ref(dispatchReceiver_2);
              $composer_51.j31(value_30);
              tmp_125 = value_30;
            } else {
              tmp_125 = it_30;
            }
            var tmp_126 = tmp_125;
            OutlinedTextField(tmp8_value, tmp5_group_0, tmp9_modifier, false, true, null, tmp_124, null, null, tmp_126, null, null, null, false, null, null, null, false, 0, 0, null, tmp10_shape, null, $composer_39, 806903856, 0, 0, 6290856);
            $composer_39.n30();
          } else {
            $composer_39.m30(1819700648);
            $composer_39.n30();
          }
          $composer_39.n30();
        } else {
          $composer_39.m30(1819722472);
          $composer_39.n30();
        }
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!CustomMagicMugDetailsScreen$lambda(state$delegate).z10z_1.r()) {
          $composer_39.m30(1819880014);
          sourceInformation($composer_39, '517@25687L37,520@25906L246,516@25629L598');
          var tmp_127 = stringResource(get_select_box(string_instance), $composer_39, 0);
          var tmp_128 = CustomMagicMugDetailsScreen$lambda(state$delegate).z10z_1;
          var tmp12_safe_receiver = CustomMagicMugDetailsScreen$lambda(state$delegate).q10z_1;
          var tmp_129 = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.ryz_1;
          sourceInformationMarkerStart($composer_39, 1305638608, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_17 = $composer_39.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_31 = $composer_39.i31();
          var tmp_130;
          if (invalid_17 || it_31 === Companion_getInstance().f30_1) {
            var value_31 = CustomMagicMugDetailsScreen$lambda_33(viewModel);
            $composer_39.j31(value_31);
            tmp_130 = value_31;
          } else {
            tmp_130 = it_31;
          }
          var tmp6_group_0 = tmp_130;
          sourceInformationMarkerEnd($composer_39);
          GiftSelectionSection(tmp_127, tmp_128, tmp_129, tmp6_group_0, language, false, $composer_39, 0, 32);
          var tmp16_safe_receiver = CustomMagicMugDetailsScreen$lambda(state$delegate).q10z_1;
          if ((tmp16_safe_receiver == null ? null : tmp16_safe_receiver.zyz_1) === true) {
            $composer_39.m30(1820534145);
            sourceInformation($composer_39, '531@26450L247,539@27000L422,529@26325L1127');
            var tmp13_value = CustomMagicMugDetailsScreen$lambda(state$delegate).r10z_1;
            var tmp_131 = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$238 = _Dp___init__impl__ms3zkb(8);
            var tmp14_modifier = padding_1(tmp_131, VOID, tmp$ret$238);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$239 = _Dp___init__impl__ms3zkb(12);
            var tmp15_shape = RoundedCornerShape(tmp$ret$239);
            sourceInformationMarkerStart($composer_39, 1305656017, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_18 = $composer_39.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_32 = $composer_39.i31();
            var tmp_132;
            if (invalid_18 || it_32 === Companion_getInstance().f30_1) {
              var value_32 = CustomMagicMugDetailsScreen$lambda_34(viewModel);
              $composer_39.j31(value_32);
              tmp_132 = value_32;
            } else {
              tmp_132 = it_32;
            }
            var tmp7_group_0 = tmp_132;
            sourceInformationMarkerEnd($composer_39);
            var tmp_133 = ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().m13i_1;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_3 = rememberComposableLambda(-835518010, true, CustomMagicMugDetailsScreen$lambda_35(state$delegate), $composer_39, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_52 = $composer_39;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_19 = $composer_52.k31(dispatchReceiver_3);
            // Inline function 'kotlin.let' call
            var it_33 = $composer_52.i31();
            var tmp_134;
            if (invalid_19 || it_33 === Companion_getInstance().f30_1) {
              var value_33 = ComposableLambda$invoke$ref(dispatchReceiver_3);
              $composer_52.j31(value_33);
              tmp_134 = value_33;
            } else {
              tmp_134 = it_33;
            }
            var tmp_135 = tmp_134;
            OutlinedTextField(tmp13_value, tmp7_group_0, tmp14_modifier, false, false, null, tmp_133, null, null, null, null, null, tmp_135, false, null, null, null, false, 0, 0, null, tmp15_shape, null, $composer_39, 1573248, 384, 0, 6287288);
            $composer_39.n30();
          } else {
            $composer_39.m30(1821642984);
            $composer_39.n30();
          }
          var tmp21_safe_receiver = CustomMagicMugDetailsScreen$lambda(state$delegate).q10z_1;
          if ((tmp21_safe_receiver == null ? null : tmp21_safe_receiver.az0_1) === true) {
            $composer_39.m30(1821774579);
            sourceInformation($composer_39, '556@27987L175,552@27702L2,562@28344L311,550@27576L1109');
            var tmp17_value = CustomMagicMugDetailsScreen$lambda(state$delegate).s10z_1;
            var tmp_136 = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$251 = _Dp___init__impl__ms3zkb(8);
            var tmp_137 = padding_1(tmp_136, VOID, tmp$ret$251);
            sourceInformationMarkerStart($composer_39, 1305705129, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_34 = $composer_39.i31();
            var tmp_138;
            if (false || it_34 === Companion_getInstance().f30_1) {
              var value_34 = CustomMagicMugDetailsScreen$lambda_36(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
              $composer_39.j31(value_34);
              tmp_138 = value_34;
            } else {
              tmp_138 = it_34;
            }
            var tmp8_group_0 = tmp_138;
            sourceInformationMarkerEnd($composer_39);
            var tmp18_modifier = clickable(tmp_137, VOID, VOID, VOID, VOID, tmp8_group_0);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$256 = _Dp___init__impl__ms3zkb(12);
            var tmp19_shape = RoundedCornerShape(tmp$ret$256);
            var tmp20_isError = CustomMagicMugDetailsScreen$lambda(state$delegate).t10z_1;
            sourceInformationMarkerStart($composer_39, 1305695836, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_35 = $composer_39.i31();
            var tmp_139;
            if (false || it_35 === Companion_getInstance().f30_1) {
              var value_35 = CustomMagicMugDetailsScreen$lambda_37;
              $composer_39.j31(value_35);
              tmp_139 = value_35;
            } else {
              tmp_139 = it_35;
            }
            var tmp9_group_0 = tmp_139;
            sourceInformationMarkerEnd($composer_39);
            var tmp_140 = ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().n13i_1;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_4 = rememberComposableLambda(218633759, true, CustomMagicMugDetailsScreen$lambda_38(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_39, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_53 = $composer_39;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_20 = $composer_53.k31(dispatchReceiver_4);
            // Inline function 'kotlin.let' call
            var it_36 = $composer_53.i31();
            var tmp_141;
            if (invalid_20 || it_36 === Companion_getInstance().f30_1) {
              var value_36 = ComposableLambda$invoke$ref(dispatchReceiver_4);
              $composer_53.j31(value_36);
              tmp_141 = value_36;
            } else {
              tmp_141 = it_36;
            }
            var tmp_142 = tmp_141;
            OutlinedTextField(tmp17_value, tmp9_group_0, tmp18_modifier, false, true, null, tmp_140, null, null, tmp_142, null, null, null, tmp20_isError, null, null, null, false, 0, 0, null, tmp19_shape, null, $composer_39, 806903856, 0, 0, 6282664);
            $composer_39.n30();
          } else {
            $composer_39.m30(1822866120);
            $composer_39.n30();
          }
          $composer_39.n30();
        } else {
          $composer_39.m30(1822887944);
          $composer_39.n30();
        }
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_9 = activeProduct.lzu_1;
        if (!(this_9 == null || this_9.r())) {
          $composer_39.m30(1822972419);
          sourceInformation($composer_39, '574@28883L38,577@29094L283,573@28823L629');
          var tmp_143 = stringResource(get_select_size(string_instance), $composer_39, 0);
          var tmp_144 = CustomMagicMugDetailsScreen$lambda(state$delegate).u10z_1;
          sourceInformationMarkerStart($composer_39, 1305740661, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_21 = $composer_39.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_37 = $composer_39.i31();
          var tmp_145;
          if (invalid_21 || it_37 === Companion_getInstance().f30_1) {
            var value_37 = CustomMagicMugDetailsScreen$lambda_39(viewModel);
            $composer_39.j31(value_37);
            tmp_145 = value_37;
          } else {
            tmp_145 = it_37;
          }
          var tmp10_group_0 = tmp_145;
          sourceInformationMarkerEnd($composer_39);
          OptionSelectionSection(tmp_143, activeProduct.lzu_1, tmp_144, tmp10_group_0, language, false, $composer_39, 0, 32);
          $composer_39.n30();
        } else {
          $composer_39.m30(1823623016);
          $composer_39.n30();
        }
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_10 = activeProduct.mzu_1;
        if (!(this_10 == null || this_10.r())) {
          $composer_39.m30(1823708607);
          sourceInformation($composer_39, '590@29625L39,593@29839L284,589@29565L633');
          var tmp_146 = stringResource(get_select_color(string_instance), $composer_39, 0);
          var tmp_147 = CustomMagicMugDetailsScreen$lambda(state$delegate).v10z_1;
          sourceInformationMarkerStart($composer_39, 1305764502, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_22 = $composer_39.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_38 = $composer_39.i31();
          var tmp_148;
          if (invalid_22 || it_38 === Companion_getInstance().f30_1) {
            var value_38 = CustomMagicMugDetailsScreen$lambda_40(viewModel);
            $composer_39.j31(value_38);
            tmp_148 = value_38;
          } else {
            tmp_148 = it_38;
          }
          var tmp11_group_0 = tmp_148;
          sourceInformationMarkerEnd($composer_39);
          OptionSelectionSection(tmp_146, activeProduct.mzu_1, tmp_147, tmp11_group_0, language, false, $composer_39, 0, 32);
          $composer_39.n30();
        } else {
          $composer_39.m30(1824363048);
          $composer_39.n30();
        }
        var tmp22_safe_receiver = activeProduct.nzu_1;
        if (tmp22_safe_receiver == null) {
          $composer_39.m30(1824475205);
          $composer_39.n30();
        } else {
          $composer_39.m30(1824475206);
          sourceInformation($composer_39, '*608@30515L349,605@30319L620');
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_2 = tmp22_safe_receiver.t();
          while (_iterator__ex2g4s_2.u()) {
            var element_2 = _iterator__ex2g4s_2.v();
            var tmp_149 = CustomMagicMugDetailsScreen$lambda(state$delegate).w10z_1.w2(element_2.r101_1);
            sourceInformationMarkerStart($composer_39, -1262155063, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_23 = !!($composer_39.q31(viewModel) | $composer_39.q31(element_2));
            // Inline function 'kotlin.let' call
            var it_39 = $composer_39.i31();
            var tmp_150;
            if (invalid_23 || it_39 === Companion_getInstance().f30_1) {
              var value_39 = CustomMagicMugDetailsScreen$lambda_41(viewModel, element_2);
              $composer_39.j31(value_39);
              tmp_150 = value_39;
            } else {
              tmp_150 = it_39;
            }
            var tmp0_group_6 = tmp_150;
            sourceInformationMarkerEnd($composer_39);
            OptionSelectionSection_0(element_2, tmp_149, tmp0_group_6, language, false, $composer_39, 0, 16);
            var tmp0_safe_receiver_0 = CustomMagicMugDetailsScreen$lambda(state$delegate).w10z_1.w2(element_2.r101_1);
            if (tmp0_safe_receiver_0 == null) {
              $composer_39.m30(-471597507);
              $composer_39.n30();
            } else {
              $composer_39.m30(-471597506);
              sourceInformation($composer_39, '');
              // Inline function 'kotlin.let' call
              if (tmp0_safe_receiver_0.w100_1 || tmp0_safe_receiver_0.z100_1 || tmp0_safe_receiver_0.c101_1) {
                $composer_39.m30(1408344695);
                sourceInformation($composer_39, '624@31434L269,629@31764L188,620@31169L886');
                sourceInformationMarkerStart($composer_39, 1153818018, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
                // Inline function 'androidx.compose.runtime.cache' call
                var invalid_24 = !!($composer_39.q31(viewModel) | $composer_39.q31(element_2));
                // Inline function 'kotlin.let' call
                var it_40 = $composer_39.i31();
                var tmp_151;
                if (invalid_24 || it_40 === Companion_getInstance().f30_1) {
                  var value_40 = CustomMagicMugDetailsScreen$lambda_42(viewModel, element_2);
                  $composer_39.j31(value_40);
                  tmp_151 = value_40;
                } else {
                  tmp_151 = it_40;
                }
                var tmp0_group_7 = tmp_151;
                sourceInformationMarkerEnd($composer_39);
                sourceInformationMarkerStart($composer_39, 1153828497, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
                // Inline function 'androidx.compose.runtime.cache' call
                var invalid_25 = $composer_39.q31(element_2);
                // Inline function 'kotlin.let' call
                var it_41 = $composer_39.i31();
                var tmp_152;
                if (invalid_25 || it_41 === Companion_getInstance().f30_1) {
                  var value_41 = CustomMagicMugDetailsScreen$lambda_43(element_2, birthdayPickerTargetOptionKey$delegate, showBirthdayPicker$delegate);
                  $composer_39.j31(value_41);
                  tmp_152 = value_41;
                } else {
                  tmp_152 = it_41;
                }
                var tmp1_group_4 = tmp_152;
                sourceInformationMarkerEnd($composer_39);
                SelectedOptionExtraInputs(element_2.r101_1, tmp0_safe_receiver_0, language, tmp0_group_7, tmp1_group_4, !CustomMagicMugDetailsScreen$lambda(state$delegate).a10z_1, $composer_39, 0, 0);
                $composer_39.n30();
              } else {
                $composer_39.m30(1409257645);
                $composer_39.n30();
              }
              $composer_39.n30();
            }
          }
          $composer_39.n30();
        }
        var tmp_153 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$294 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_153, tmp$ret$294), $composer_39, 6);
        var tmp23_value = CustomMagicMugDetailsScreen$lambda(state$delegate).x10z_1;
        var tmp24_modifier = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$295 = _Dp___init__impl__ms3zkb(12);
        var tmp25_shape = RoundedCornerShape(tmp$ret$295);
        sourceInformationMarkerStart($composer_39, 1305844150, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_26 = $composer_39.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_42 = $composer_39.i31();
        var tmp_154;
        if (invalid_26 || it_42 === Companion_getInstance().f30_1) {
          var value_42 = CustomMagicMugDetailsScreen$lambda_44(viewModel);
          $composer_39.j31(value_42);
          tmp_154 = value_42;
        } else {
          tmp_154 = it_42;
        }
        var tmp12_group_0 = tmp_154;
        sourceInformationMarkerEnd($composer_39);
        var tmp_155 = ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().p13i_1;
        OutlinedTextField(tmp23_value, tmp12_group_0, tmp24_modifier, false, false, null, tmp_155, null, null, null, null, null, null, false, null, null, null, false, 0, 0, null, tmp25_shape, null, $composer_39, 1573248, 0, 0, 6291384);
        var tmp_156 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$300 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_156, tmp$ret$300), $composer_39, 6);
        AgeGroupDisplay(activeProduct.rzu_1, activeProduct.szu_1, activeProduct.tzu_1, null, $composer_39, 0, 8);
        var tmp_157 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$301 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_157, tmp$ret$301), $composer_39, 6);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_17 = null;
        var horizontalArrangement_2 = null;
        var verticalAlignment_2 = Companion_getInstance_11().u8t_1;
        var $composer_54 = $composer_39;
        if (!((3 & 1) === 0))
          modifier_17 = Companion_instance;
        if (!((3 & 2) === 0))
          horizontalArrangement_2 = Arrangement_getInstance().qdp_1;
        if (!((3 & 4) === 0))
          verticalAlignment_2 = Companion_getInstance_11().t8t_1;
        var measurePolicy_8 = rowMeasurePolicy(horizontalArrangement_2, verticalAlignment_2, $composer_54, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_18 = modifier_17;
        var $composer_55 = $composer_54;
        if (!((0 & 2) === 0))
          modifier_18 = Companion_instance;
        var compositeKeyHash_8 = get_currentCompositeKeyHashCode($composer_55, 0).hashCode();
        var localMap_8 = $composer_55.t31();
        var materialized_8 = materialize($composer_55, modifier_18);
        var tmp0_16 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_56 = $composer_55;
        var tmp_158 = $composer_56.g30();
        if (!isInterface(tmp_158, Applier)) {
          invalidApplier();
        }
        $composer_56.b31();
        if ($composer_56.h30()) {
          $composer_56.c31(tmp0_16);
        } else {
          $composer_56.d31();
        }
        var $this$ReusableComposeNode_8 = _Updater___init__impl__rbfxm8($composer_56);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_8, measurePolicy_8, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_8, localMap_8, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_8, compositeKeyHash_8, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_8, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_8, materialized_8, Companion_getInstance_12().qah_1);
        var $composer_57 = $composer_56;
        var $composer_58 = $composer_57;
        sourceInformationMarkerStart($composer_58, -1463594032, 'C667@33460L76,668@33561L28,669@33614L413:CustomMagicMugDetailsScreen.kt#8gd4xm');
        var tmp_159;
        var tmp0_elvis_lhs_4 = activeProduct.wzt_1;
        if ((tmp0_elvis_lhs_4 == null ? 0 : tmp0_elvis_lhs_4) > 0) {
          $composer_58.m30(1892452720);
          $composer_58.n30();
          tmp_159 = Color(new Long(-11751600, 0));
        } else {
          $composer_58.m30(1892454276);
          sourceInformation($composer_58, '666@33418L11');
          var tmp0_group_8 = MaterialTheme_instance.unz($composer_58, 6).to0_1;
          $composer_58.n30();
          tmp_159 = tmp0_group_8;
        }
        var stockColor = tmp_159;
        var tmp_160 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$308 = _Dp___init__impl__ms3zkb(8);
        Box(background(clip(size(tmp_160, tmp$ret$308), get_CircleShape()), stockColor), $composer_58, 0);
        var tmp_161 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$309 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_161, tmp$ret$309), $composer_58, 6);
        var tmp_162;
        var tmp2_elvis_lhs_0 = activeProduct.wzt_1;
        if ((tmp2_elvis_lhs_0 == null ? 0 : tmp2_elvis_lhs_0) > 0) {
          $composer_58.m30(1892467894);
          sourceInformation($composer_58, '670@33691L163');
          var tmp_163 = get_in_stock_pattern(string_instance);
          var tmp1_elvis_lhs_2 = activeProduct.wzt_1;
          var tmp1_group_5 = formatNumbers(stringResource_0(tmp_163, [tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2], $composer_58, 0), language);
          $composer_58.n30();
          tmp_162 = tmp1_group_5;
        } else {
          $composer_58.m30(1892468838);
          sourceInformation($composer_58, '673@33884L39');
          var tmp2_group_1 = stringResource(get_out_of_stock(string_instance), $composer_58, 0);
          $composer_58.n30();
          tmp_162 = tmp2_group_1;
        }
        var tmp_164 = tmp_162;
        var tmp_165 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_166 = Companion_getInstance_16().e7z_1;
        var tmp_167 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_168 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_169 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_164, null, stockColor, null, tmp_165, null, tmp_166, null, tmp_167, null, null, tmp_168, tmp_169, false, 0, 0, null, null, $composer_58, 1572864, 0, 262074);
        sourceInformationMarkerEnd($composer_58);
        $composer_56.e31();
        var tmp_170 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$310 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_170, tmp$ret$310), $composer_39, 6);
        sourceInformationMarkerEnd($composer_39);
        $composer_37.e31();
        var tmp_171 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$311 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_171, tmp$ret$311), $composer_12, 6);
        var tmp_172 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$312 = _Dp___init__impl__ms3zkb(120);
        Spacer(height(tmp_172, tmp$ret$312), $composer_12, 6);
        sourceInformationMarkerEnd($composer_12);
        $composer_10.e31();
        var tmp3_modifier = zIndex(fillMaxWidth(BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1)), 2.0);
        var tmp4_color = MaterialTheme_instance.unz($composer_7, 6).mo0_1;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp5_shadowElevation = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_173 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$315 = _Dp___init__impl__ms3zkb(24);
        var tmp6_shape_0 = RoundedCornerShape_0(tmp_173, tmp$ret$315);
        var tmp_174 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_175 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_5 = rememberComposableLambda(717772939, true, CustomMagicMugDetailsScreen$lambda_45(activeProduct, state$delegate, viewModel, language), $composer_7, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_59 = $composer_7;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_27 = $composer_59.k31(dispatchReceiver_5);
        // Inline function 'kotlin.let' call
        var it_43 = $composer_59.i31();
        var tmp_176;
        if (invalid_27 || it_43 === Companion_getInstance().f30_1) {
          var value_43 = ComposableLambda$invoke$ref(dispatchReceiver_5);
          $composer_59.j31(value_43);
          tmp_176 = value_43;
        } else {
          tmp_176 = it_43;
        }
        var tmp$ret$316 = tmp_176;
        Surface(tmp3_modifier, tmp6_shape_0, tmp4_color, tmp_174, tmp_175, tmp5_shadowElevation, null, tmp$ret$316, $composer_7, 12779520, 88);
        $composer_7.n30();
      } else {
        $composer_7.m30(-935141343);
        $composer_7.n30();
      }
      var tmp_177 = CustomMagicMugDetailsScreen$lambda(state$delegate).e10z_1;
      var tmp_178 = CustomMagicMugDetailsScreen$lambda(state$delegate).g10z_1;
      sourceInformationMarkerStart($composer_7, -1277089704, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_28 = $composer_7.k31(verticalScrollState);
      // Inline function 'kotlin.let' call
      var it_44 = $composer_7.i31();
      var tmp_179;
      if (invalid_28 || it_44 === Companion_getInstance().f30_1) {
        var value_44 = CustomMagicMugDetailsScreen$slambda_8(verticalScrollState, null);
        $composer_7.j31(value_44);
        tmp_179 = value_44;
      } else {
        tmp_179 = it_44;
      }
      var tmp0_group_9 = tmp_179;
      sourceInformationMarkerEnd($composer_7);
      LaunchedEffect(tmp_177, tmp_178, tmp0_group_9, $composer_7, 0);
      if (CustomMagicMugDetailsScreen$lambda(state$delegate).h10z_1) {
        $composer_7.m30(-934927381);
        sourceInformation($composer_7, '859@43814L321,868@44164L70,857@43706L542');
        var tmp_180 = CustomMagicMugDetailsScreen$lambda(state$delegate).g10z_1;
        sourceInformationMarkerStart($composer_7, -1277081278, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_29 = $composer_7.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_45 = $composer_7.i31();
        var tmp_181;
        if (invalid_29 || it_45 === Companion_getInstance().f30_1) {
          var value_45 = CustomMagicMugDetailsScreen$lambda_46(viewModel);
          $composer_7.j31(value_45);
          tmp_181 = value_45;
        } else {
          tmp_181 = it_45;
        }
        var tmp1_group_6 = tmp_181;
        sourceInformationMarkerEnd($composer_7);
        sourceInformationMarkerStart($composer_7, -1277070329, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_30 = $composer_7.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_46 = $composer_7.i31();
        var tmp_182;
        if (invalid_30 || it_46 === Companion_getInstance().f30_1) {
          var value_46 = CustomMagicMugDetailsScreen$lambda_47(viewModel);
          $composer_7.j31(value_46);
          tmp_182 = value_46;
        } else {
          tmp_182 = it_46;
        }
        var tmp2_group_2 = tmp_182;
        sourceInformationMarkerEnd($composer_7);
        MagicMugImageEditorScreen(tmp_180, tmp1_group_6, tmp2_group_2, $composer_7, 0, 0);
        $composer_7.n30();
      } else {
        $composer_7.m30(-934383455);
        $composer_7.n30();
      }
      var tmp_183 = CustomMagicMugDetailsScreen$lambda_3(showFullScreen3D$delegate);
      var tmp_184 = CustomMagicMugDetailsScreen$lambda(state$delegate).i10z_1;
      var tmp_185 = CustomMagicMugDetailsScreen$lambda(state$delegate).j10z_1;
      var tmp_186 = ProductKind_MAGIC_MUG_getInstance();
      var tmp_187 = CustomMagicMugDetailsScreen$lambda(state$delegate).e10z_1;
      var tmp_188 = CustomMagicMugDetailsScreen$lambda(state$delegate).f10z_1;
      sourceInformationMarkerStart($composer_7, -1277056592, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_31 = !!($composer_0.q31(viewModel) | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(product))));
      // Inline function 'kotlin.let' call
      var it_47 = $composer_7.i31();
      var tmp_189;
      if (invalid_31 || it_47 === Companion_getInstance().f30_1) {
        var value_47 = CustomMagicMugDetailsScreen$lambda_48(viewModel, product);
        $composer_7.j31(value_47);
        tmp_189 = value_47;
      } else {
        tmp_189 = it_47;
      }
      var tmp3_group_1 = tmp_189;
      sourceInformationMarkerEnd($composer_7);
      sourceInformationMarkerStart($composer_7, -1277053283, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_48 = $composer_7.i31();
      var tmp_190;
      if (false || it_48 === Companion_getInstance().f30_1) {
        var value_48 = CustomMagicMugDetailsScreen$lambda_49(showFullScreen3D$delegate);
        $composer_7.j31(value_48);
        tmp_190 = value_48;
      } else {
        tmp_190 = it_48;
      }
      var tmp4_group_1 = tmp_190;
      sourceInformationMarkerEnd($composer_7);
      sourceInformationMarkerStart($composer_7, -1277051349, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_32 = $composer_7.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_49 = $composer_7.i31();
      var tmp_191;
      if (invalid_32 || it_49 === Companion_getInstance().f30_1) {
        var value_49 = CustomMagicMugDetailsScreen$lambda_50(viewModel, showFullScreen3D$delegate);
        $composer_7.j31(value_49);
        tmp_191 = value_49;
      } else {
        tmp_191 = it_49;
      }
      var tmp5_group_1 = tmp_191;
      sourceInformationMarkerEnd($composer_7);
      FullScreen3DDialog(tmp_183, tmp_184, tmp_185, tmp_186, tmp_187, tmp_188, language, tmp3_group_1, tmp4_group_1, tmp5_group_1, $composer_7, 100666368, 0);
      if (CustomMagicMugDetailsScreen$lambda(state$delegate).a10z_1) {
        $composer_7.m30(-933670951);
        sourceInformation($composer_7, '889@44953L1168');
        var tmp_192 = fillMaxSize(Companion_instance);
        var tmp_193 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.5);
        var tmp_194 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_195 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_196 = _Dp___init__impl__ms3zkb(0.0);
        Surface(tmp_192, null, tmp_193, tmp_194, tmp_195, tmp_196, null, ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().u13i_1, $composer_7, 12583302, 122);
        $composer_7.n30();
      } else {
        $composer_7.m30(-932525439);
        $composer_7.n30();
      }
      var tmp_197 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(snackbarHostState, tmp_197, null, $composer_7, 6, 4);
      if (CustomMagicMugDetailsScreen$lambda_7(showBirthdayPicker$delegate)) {
        $composer_7.m30(-932279640);
        sourceInformation($composer_7, '920@46370L124,924@46528L1705,953@48267L393,964@48675L43,919@46317L2401');
        sourceInformationMarkerStart($composer_7, -1276999683, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_50 = $composer_7.i31();
        var tmp_198;
        if (false || it_50 === Companion_getInstance().f30_1) {
          var value_50 = CustomMagicMugDetailsScreen$lambda_51(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate);
          $composer_7.j31(value_50);
          tmp_198 = value_50;
        } else {
          tmp_198 = it_50;
        }
        var tmp6_group_1 = tmp_198;
        sourceInformationMarkerEnd($composer_7);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_6 = rememberComposableLambda(-811033381, true, CustomMagicMugDetailsScreen$lambda_52(birthdayPickerState, state$delegate, viewModel, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_7, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_60 = $composer_7;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_33 = $composer_60.k31(dispatchReceiver_6);
        // Inline function 'kotlin.let' call
        var it_51 = $composer_60.i31();
        var tmp_199;
        if (invalid_33 || it_51 === Companion_getInstance().f30_1) {
          var value_51 = ComposableLambda$invoke$ref(dispatchReceiver_6);
          $composer_60.j31(value_51);
          tmp_199 = value_51;
        } else {
          tmp_199 = it_51;
        }
        var tmp_200 = tmp_199;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_7 = rememberComposableLambda(575283353, true, CustomMagicMugDetailsScreen$lambda_53(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate), $composer_7, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_61 = $composer_7;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_34 = $composer_61.k31(dispatchReceiver_7);
        // Inline function 'kotlin.let' call
        var it_52 = $composer_61.i31();
        var tmp_201;
        if (invalid_34 || it_52 === Companion_getInstance().f30_1) {
          var value_52 = ComposableLambda$invoke$ref(dispatchReceiver_7);
          $composer_61.j31(value_52);
          tmp_201 = value_52;
        } else {
          tmp_201 = it_52;
        }
        var tmp_202 = tmp_201;
        var tmp_203 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_8 = rememberComposableLambda(-690440092, true, CustomMagicMugDetailsScreen$lambda_54(birthdayPickerState), $composer_7, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_62 = $composer_7;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_35 = $composer_62.k31(dispatchReceiver_8);
        // Inline function 'kotlin.let' call
        var it_53 = $composer_62.i31();
        var tmp_204;
        if (invalid_35 || it_53 === Companion_getInstance().f30_1) {
          var value_53 = ComposableLambda$invoke$ref_6(dispatchReceiver_8);
          $composer_62.j31(value_53);
          tmp_204 = value_53;
        } else {
          tmp_204 = it_53;
        }
        var tmp$ret$365 = tmp_204;
        DatePickerDialog(tmp6_group_1, tmp_200, null, tmp_202, null, tmp_203, null, null, tmp$ret$365, $composer_7, 100666422, 244);
        $composer_7.n30();
      } else {
        $composer_7.m30(-929949215);
        $composer_7.n30();
      }
      sourceInformationMarkerEnd($composer_7);
      $composer_5.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp15_safe_receiver = $composer_0.t30();
    if (tmp15_safe_receiver == null)
      null;
    else {
      tmp15_safe_receiver.p3c(CustomMagicMugDetailsScreen$lambda_55(product, onBack, onNavigateToAuth, initialSize_0, initialColor_0, initialOptions_0, initialComment_0, initialCard_0, initialBox_0, initialCardMessage_0, initialCardBirthday_0, initialBoxMessage_0, initialBoxBirthday_0, topPadding_0, bottomPadding_0, $changed, $changed1, $default));
    }
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_926202885$lambda_526trw($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C294@13499L453:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-926202885, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$-926202885.<anonymous> (CustomMagicMugDetailsScreen.kt:294)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = padding_0(tmp, tmp$ret$0);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1653325264, 'C297@13708L31,298@13798L11,295@13572L350:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp0_imageVector = get_ArrowBack(Filled_instance_0);
      var tmp1_contentDescription = stringResource(get_back(string_instance), $composer_5, 0);
      var tmp2_tint = MaterialTheme_instance.unz($composer_5, 6).no0_1;
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
      var tmp3_modifier = size(tmp_1, tmp$ret$7);
      Icon(tmp0_imageVector, tmp1_contentDescription, tmp3_modifier, tmp2_tint, $composer_5, 384, 0);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$338522606$lambda($this$AnimatedContent, isFav, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C316@14769L459:CustomMagicMugDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isFav) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(338522606, $dirty, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$338522606.<anonymous> (CustomMagicMugDetailsScreen.kt:316)');
      }
      var tmp0_imageVector = isFav ? get_Favorite(Icons_getInstance().dxv_1) : get_FavoriteBorder(Icons_getInstance().dxv_1);
      var tmp;
      if (isFav) {
        $composer_0.m30(-1097279147);
        sourceInformation($composer_0, '319@15049L11');
        var tmp0_group = MaterialTheme_instance.unz($composer_0, 6).xnz_1;
        $composer_0.n30();
        tmp = tmp0_group;
      } else {
        $composer_0.m30(-1097277897);
        sourceInformation($composer_0, '319@15088L11');
        var tmp1_group = MaterialTheme_instance.unz($composer_0, 6).no0_1;
        $composer_0.n30();
        tmp = tmp1_group;
      }
      var tmp1_tint = tmp;
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
      var tmp2_modifier = size(tmp_0, tmp$ret$0);
      Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_0, 432, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_2103760640$lambda_wt1hfd($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C331@15730L438:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2103760640, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$-2103760640.<anonymous> (CustomMagicMugDetailsScreen.kt:331)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = padding_0(tmp, tmp$ret$0);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1116252002, 'C335@16002L11,332@15807L327:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp0_imageVector = get_Share(Icons_getInstance().dxv_1);
      var tmp1_tint = MaterialTheme_instance.unz($composer_5, 6).no0_1;
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
      var tmp2_modifier = size(tmp_1, tmp$ret$7);
      Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_5, 432, 0);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_839010230$lambda_wl4zwk($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C480@23616L45,480@23611L51:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-839010230, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$-839010230.<anonymous> (CustomMagicMugDetailsScreen.kt:480)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$493400051$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C498@24675L46,498@24670L52:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(493400051, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$493400051.<anonymous> (CustomMagicMugDetailsScreen.kt:498)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_1533353196$lambda_jan86z($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C509@25389L39:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1533353196, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$-1533353196.<anonymous> (CustomMagicMugDetailsScreen.kt:509)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$1058767347$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C536@26746L45,536@26741L51:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1058767347, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$1058767347.<anonymous> (CustomMagicMugDetailsScreen.kt:536)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$1604793180$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C554@27802L46,554@27797L52:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1604793180, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$1604793180.<anonymous> (CustomMagicMugDetailsScreen.kt:554)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_484892099$lambda_uytb7v($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C566@28580L39:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-484892099, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$-484892099.<anonymous> (CustomMagicMugDetailsScreen.kt:566)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_1860149888$lambda_c3u4cn($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C647@32591L52,647@32586L58:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1860149888, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$-1860149888.<anonymous> (CustomMagicMugDetailsScreen.kt:647)');
      }
      var tmp = stringResource(get_add_product_comment_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$1993826242$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C726@36463L49,727@36575L11,724@36334L300:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1993826242, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$1993826242.<anonymous> (CustomMagicMugDetailsScreen.kt:724)');
      }
      var tmp = get_Remove(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_decrease_quantity_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).no0_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$793841913$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C747@37715L49,748@37827L11,745@37589L297:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(793841913, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$793841913.<anonymous> (CustomMagicMugDetailsScreen.kt:745)');
      }
      var tmp = get_Add(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_increase_quantity_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).no0_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$518541591$lambda($this$AnimatedContent, isAdding, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C:CustomMagicMugDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isAdding) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(518541591, $dirty, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$518541591.<anonymous> (CustomMagicMugDetailsScreen.kt:820)');
      }
      if (isAdding) {
        $composer_0.m30(-1124756510);
        sourceInformation($composer_0, '821@41920L257');
        var tmp = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
        var tmp_0 = size(tmp, tmp$ret$0);
        var tmp_1 = Companion_getInstance_14().m6b_1;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_2 = _Dp___init__impl__ms3zkb(2);
        var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_4 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, _Dp___init__impl__ms3zkb(0.0), $composer_0, 438, 56);
        $composer_0.n30();
      } else {
        $composer_0.m30(-1124363058);
        sourceInformation($composer_0, '827@42255L1085');
        var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = null;
        var horizontalArrangement = Arrangement_getInstance().udp_1;
        var verticalAlignment = tmp0_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((1 & 1) === 0))
          modifier = Companion_instance;
        if (!((1 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((1 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_5 = $composer_3.g30();
        if (!isInterface(tmp_5, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 103296525, 'C831@42511L266,836@42818L39,838@42948L38,837@42898L404:CustomMagicMugDetailsScreen.kt#8gd4xm');
        var tmp_6 = get_ShoppingCart(Icons_getInstance().dxv_1);
        var tmp_7 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(20);
        var tmp_8 = size(tmp_7, tmp$ret$8);
        Icon(tmp_6, null, tmp_8, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 432, 8);
        var tmp_9 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$9 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_9, tmp$ret$9), $composer_5, 6);
        var tmp0_text = stringResource(get_add_to_cart(string_instance), $composer_5, 0);
        var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp2_fontSize = get_sp(16);
        var tmp3_textAlign = Companion_getInstance_15().d7v_1;
        var tmp4_lineHeight = get_sp(18);
        var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp_10, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_11, null, tmp3_textAlign, tmp4_lineHeight, tmp_12, false, 0, 0, null, null, $composer_5, 1597440, 48, 258990);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$614998667$lambda($this$Card, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C892@45219L848:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(614998667, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$614998667.<anonymous> (CustomMagicMugDetailsScreen.kt:892)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
      var tmp0_modifier = padding_0(tmp, tmp$ret$0);
      var tmp1_horizontalAlignment = Companion_getInstance_11().x8t_1;
      var tmp_0 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = tmp0_modifier;
      var verticalArrangement = tmp_0.mdq(tmp$ret$1);
      var horizontalAlignment = tmp1_horizontalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier = Companion_instance;
      if (!((0 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((0 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1581843338, 'C897@45505L27,899@45599L54,900@45709L10,898@45561L262,904@45890L59,903@45852L189:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
      CircularProgressIndicator(null, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_5, 0, 63);
      var tmp0_text = stringResource(get_adding_to_cart_dialog_title(string_instance), $composer_5, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp_6, null, tmp_7, null, tmp2_fontWeight, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131006);
      var tmp_11 = stringResource(get_adding_to_cart_dialog_msg_custom(string_instance), $composer_5, 0);
      var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_15 = Companion_getInstance_15().d7v_1;
      var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_17 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_11, null, tmp_12, null, tmp_13, null, null, null, tmp_14, null, tmp_15, tmp_16, tmp_17, false, 0, 0, null, null, $composer_5, 0, 0, 261118);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$509813139$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C890@45054L1053:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(509813139, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$509813139.<anonymous> (CustomMagicMugDetailsScreen.kt:890)');
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = null;
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((5 & 1) === 0))
        modifier = Companion_instance;
      if (!((5 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((5 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 8144830, 'C891@45117L972:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(32);
      var tmp_1 = padding_0(tmp_0, tmp$ret$6);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(16);
      var tmp_2 = RoundedCornerShape(tmp$ret$7);
      Card(tmp_1, tmp_2, null, null, null, ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().t13i_1, $composer_5, 196614, 28);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_2084416578$lambda_b0kr0b($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C951@48183L29,951@48178L35:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2084416578, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$-2084416578.<anonymous> (CustomMagicMugDetailsScreen.kt:951)');
      }
      var tmp = stringResource(get_ok(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_698099844$lambda_sspu8t($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C960@48561L33,959@48527L93:CustomMagicMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-698099844, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMagicMugDetailsScreenKt.lambda$-698099844.<anonymous> (CustomMagicMugDetailsScreen.kt:959)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMagicMugDetailsScreenKt() {
    ComposableSingletons$CustomMagicMugDetailsScreenKt_instance = this;
    var tmp = this;
    tmp.g13i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-926202885, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_926202885$lambda_526trw));
    var tmp_0 = this;
    tmp_0.h13i_1 = ComposableLambda$invoke$ref_5(composableLambdaInstance(338522606, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$338522606$lambda));
    var tmp_1 = this;
    tmp_1.i13i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-2103760640, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_2103760640$lambda_wt1hfd));
    var tmp_2 = this;
    tmp_2.j13i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-839010230, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_839010230$lambda_wl4zwk));
    var tmp_3 = this;
    tmp_3.k13i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(493400051, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$493400051$lambda));
    var tmp_4 = this;
    tmp_4.l13i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1533353196, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_1533353196$lambda_jan86z));
    var tmp_5 = this;
    tmp_5.m13i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1058767347, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$1058767347$lambda));
    var tmp_6 = this;
    tmp_6.n13i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1604793180, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$1604793180$lambda));
    var tmp_7 = this;
    tmp_7.o13i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-484892099, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_484892099$lambda_uytb7v));
    var tmp_8 = this;
    tmp_8.p13i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1860149888, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_1860149888$lambda_c3u4cn));
    var tmp_9 = this;
    tmp_9.q13i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1993826242, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$1993826242$lambda));
    var tmp_10 = this;
    tmp_10.r13i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(793841913, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$793841913$lambda));
    var tmp_11 = this;
    tmp_11.s13i_1 = ComposableLambda$invoke$ref_5(composableLambdaInstance(518541591, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$518541591$lambda));
    var tmp_12 = this;
    tmp_12.t13i_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(614998667, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$614998667$lambda));
    var tmp_13 = this;
    tmp_13.u13i_1 = ComposableLambda$invoke$ref(composableLambdaInstance(509813139, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$509813139$lambda));
    var tmp_14 = this;
    tmp_14.v13i_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-2084416578, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_2084416578$lambda_b0kr0b));
    var tmp_15 = this;
    tmp_15.w13i_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-698099844, false, ComposableSingletons$CustomMagicMugDetailsScreenKt$lambda$_698099844$lambda_sspu8t));
  }
  var ComposableSingletons$CustomMagicMugDetailsScreenKt_instance;
  function ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance() {
    if (ComposableSingletons$CustomMagicMugDetailsScreenKt_instance == null)
      new ComposableSingletons$CustomMagicMugDetailsScreenKt();
    return ComposableSingletons$CustomMagicMugDetailsScreenKt_instance;
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5(function_0) {
    this.x13i_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5).ka7 = function (_this__u8e3s4, $completion) {
    return this.x13i_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5).q3 = function () {
    return this.x13i_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_5).hashCode = function () {
    return hashCode(this.q3());
  };
  function CustomMagicMugDetailsScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function CustomMagicMugDetailsScreen$slambda($viewModel, $product, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, resultContinuation) {
    this.g13j_1 = $viewModel;
    this.h13j_1 = $product;
    this.i13j_1 = $initialSize;
    this.j13j_1 = $initialColor;
    this.k13j_1 = $initialOptions;
    this.l13j_1 = $initialComment;
    this.m13j_1 = $initialCard;
    this.n13j_1 = $initialBox;
    this.o13j_1 = $initialCardMessage;
    this.p13j_1 = $initialCardBirthday;
    this.q13j_1 = $initialBoxMessage;
    this.r13j_1 = $initialBoxBirthday;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMagicMugDetailsScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMagicMugDetailsScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = delay(new Long(100, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g13j_1.s10h().j10i(new LoadProduct_1(this.h13j_1, this.i13j_1._v, this.j13j_1._v, this.k13j_1._v, this.l13j_1._v, this.m13j_1._v, this.n13j_1._v, this.o13j_1._v, this.p13j_1._v, this.q13j_1._v, this.r13j_1._v));
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CustomMagicMugDetailsScreen$slambda(this.g13j_1, this.h13j_1, this.i13j_1, this.j13j_1, this.k13j_1, this.l13j_1, this.m13j_1, this.n13j_1, this.o13j_1, this.p13j_1, this.q13j_1, this.r13j_1, completion);
    i.s13j_1 = $this$LaunchedEffect;
    return i;
  };
  function CustomMagicMugDetailsScreen$slambda_0($viewModel, $product, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, resultContinuation) {
    var i = new CustomMagicMugDetailsScreen$slambda($viewModel, $product, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_21(function_0) {
    this.t13j_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_21).a1v = function (value, $completion) {
    return this.t13j_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_21).q3 = function () {
    return this.t13j_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_21).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_21).hashCode = function () {
    return hashCode(this.q3());
  };
  function CustomMagicMugDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    this.c13k_1 = $snackbarHostState;
    this.d13k_1 = $onNavigateToAuth;
    this.e13k_1 = $onBack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMagicMugDetailsScreen$slambda$slambda).f112 = function (effect, $completion) {
    var tmp = this.g112(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMagicMugDetailsScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.f112((!(p1 == null) ? isInterface(p1, CustomProductDetailsSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp0_subject = this.f13k_1;
            if (tmp0_subject instanceof ShowMessage_4) {
              this.n9_1 = 2;
              suspendResult = this.f13k_1.i112_1.z10i(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof ShowToast_0) {
                this.n9_1 = 1;
                suspendResult = this.f13k_1.h112_1.z10i(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (equals(tmp0_subject, NavigateToAuth_instance_2)) {
                  this.g13k_1 = this.d13k_1();
                  this.n9_1 = 4;
                  continue $sm;
                } else {
                  if (equals(tmp0_subject, NavigateBack_instance_2)) {
                    this.g13k_1 = this.e13k_1();
                    this.n9_1 = 4;
                    continue $sm;
                  } else {
                    var tmp_0 = this;
                    noWhenBranchMatchedException();
                  }
                }
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            var tmp_1 = this;
            showToast(ARGUMENT);
            tmp_1.g13k_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            this.n9_1 = 3;
            suspendResult = this.c13k_1.dqm(ARGUMENT_0, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.g13k_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda$slambda).g112 = function (effect, completion) {
    var i = new CustomMagicMugDetailsScreen$slambda$slambda(this.c13k_1, this.d13k_1, this.e13k_1, completion);
    i.f13k_1 = effect;
    return i;
  };
  function CustomMagicMugDetailsScreen$slambda$slambda_0($snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    var i = new CustomMagicMugDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.f112(effect, $completion);
    }, 1);
  }
  function CustomMagicMugDetailsScreen$slambda_1($viewModel, $snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    this.p13k_1 = $viewModel;
    this.q13k_1 = $snackbarHostState;
    this.r13k_1 = $onNavigateToAuth;
    this.s13k_1 = $onBack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMagicMugDetailsScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMagicMugDetailsScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.p13k_1.s10h().t10h();
            var tmp_1 = CustomMagicMugDetailsScreen$slambda$slambda_0(this.q13k_1, this.r13k_1, this.s13k_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_21(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CustomMagicMugDetailsScreen$slambda_1(this.p13k_1, this.q13k_1, this.r13k_1, this.s13k_1, completion);
    i.t13k_1 = $this$LaunchedEffect;
    return i;
  };
  function CustomMagicMugDetailsScreen$slambda_2($viewModel, $snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    var i = new CustomMagicMugDetailsScreen$slambda_1($viewModel, $snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CustomMagicMugDetailsScreen$slambda_3($appViewModel, $state$delegate, resultContinuation) {
    this.c13l_1 = $appViewModel;
    this.d13l_1 = $state$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMagicMugDetailsScreen$slambda_3).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMagicMugDetailsScreen$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0;
          if (CustomMagicMugDetailsScreen$lambda(this.d13l_1).a10z_1) {
            tmp_0 = true;
          } else {
            tmp_0 = !CustomMagicMugDetailsScreen$lambda(this.d13l_1).g10z_1.r();
          }
          this.c13l_1.l108(tmp_0);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda_3).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CustomMagicMugDetailsScreen$slambda_3(this.c13l_1, this.d13l_1, completion);
    i.e13l_1 = $this$LaunchedEffect;
    return i;
  };
  function CustomMagicMugDetailsScreen$slambda_4($appViewModel, $state$delegate, resultContinuation) {
    var i = new CustomMagicMugDetailsScreen$slambda_3($appViewModel, $state$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CustomMagicMugDetailsScreen$$inlined$cache$4$1($appViewModel) {
    this.f13l_1 = $appViewModel;
  }
  protoOf(CustomMagicMugDetailsScreen$$inlined$cache$4$1).s1d = function () {
    this.f13l_1.l108(false);
  };
  function CustomMagicMugDetailsScreen$lambda_0($appViewModel) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new CustomMagicMugDetailsScreen$$inlined$cache$4$1($appViewModel);
    };
  }
  function CustomMagicMugDetailsScreen$lambda_1($isInteractingWith3D$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isInteractingWith3D', KMutableProperty0, true);
    return $isInteractingWith3D$delegate.u1();
  }
  function CustomMagicMugDetailsScreen$lambda_2($isInteractingWith3D$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isInteractingWith3D', KMutableProperty0, true);
    $isInteractingWith3D$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMagicMugDetailsScreen$lambda_3($showFullScreen3D$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showFullScreen3D', KMutableProperty0, true);
    return $showFullScreen3D$delegate.u1();
  }
  function CustomMagicMugDetailsScreen$lambda_4($showFullScreen3D$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showFullScreen3D', KMutableProperty0, true);
    $showFullScreen3D$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMagicMugDetailsScreen$lambda_5($isMediaDialogOpen$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isMediaDialogOpen', KMutableProperty0, true);
    return $isMediaDialogOpen$delegate.u1();
  }
  function CustomMagicMugDetailsScreen$lambda_6($isMediaDialogOpen$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isMediaDialogOpen', KMutableProperty0, true);
    $isMediaDialogOpen$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMagicMugDetailsScreen$lambda_7($showBirthdayPicker$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    return $showBirthdayPicker$delegate.u1();
  }
  function CustomMagicMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    $showBirthdayPicker$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMagicMugDetailsScreen$lambda_9($birthdayPickerTargetOptionKey$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    return $birthdayPickerTargetOptionKey$delegate.u1();
  }
  function CustomMagicMugDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    $birthdayPickerTargetOptionKey$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMagicMugDetailsScreen$lambda_11($isPickingBoxBirthday$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    return $isPickingBoxBirthday$delegate.u1();
  }
  function CustomMagicMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    $isPickingBoxBirthday$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMagicMugDetailsScreen$lambda_13($showDiscardDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    return $showDiscardDialog$delegate.u1();
  }
  function CustomMagicMugDetailsScreen$lambda_14($showDiscardDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    $showDiscardDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMagicMugDetailsScreen$lambda_15($showFullScreen3D$delegate, $state$delegate, $showDiscardDialog$delegate) {
    return function () {
      var tmp;
      if (CustomMagicMugDetailsScreen$lambda_3($showFullScreen3D$delegate)) {
        CustomMagicMugDetailsScreen$lambda_4($showFullScreen3D$delegate, false);
        tmp = Unit_instance;
      } else {
        var tmp_0;
        if (CustomMagicMugDetailsScreen$lambda($state$delegate).a10z_1) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_0 = !CustomMagicMugDetailsScreen$lambda($state$delegate).g10z_1.r();
        }
        if (tmp_0) {
          CustomMagicMugDetailsScreen$lambda_14($showDiscardDialog$delegate, true);
          tmp = Unit_instance;
        }
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_16($onBack, $showDiscardDialog$delegate) {
    return function () {
      CustomMagicMugDetailsScreen$lambda_14($showDiscardDialog$delegate, false);
      $onBack();
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_17($showDiscardDialog$delegate) {
    return function () {
      CustomMagicMugDetailsScreen$lambda_14($showDiscardDialog$delegate, false);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$slambda$slambda_1($isInteractingWith3D$delegate, resultContinuation) {
    this.o13l_1 = $isInteractingWith3D$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMagicMugDetailsScreen$slambda$slambda_1).ic6 = function ($this$awaitPointerEventScope, $completion) {
    var tmp = this.jc6($this$awaitPointerEventScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMagicMugDetailsScreen$slambda$slambda_1).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 4;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = this.p13l_1.pa7(PointerEventPass_Initial_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var event = suspendResult;
            var tmp0 = event.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var tmp_0;
              if (isInterface(tmp0, Collection)) {
                tmp_0 = tmp0.r();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$0 = false;
                break l$ret$1;
              }
              var _iterator__ex2g4s = tmp0.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (element.la0_1) {
                  tmp$ret$0 = true;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = false;
            }
             while (false);
            CustomMagicMugDetailsScreen$lambda_2(this.o13l_1, tmp$ret$0);
            this.n9_1 = 1;
            continue $sm;
          case 3:
            throw this.q9_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda$slambda_1).jc6 = function ($this$awaitPointerEventScope, completion) {
    var i = new CustomMagicMugDetailsScreen$slambda$slambda_1(this.o13l_1, completion);
    i.p13l_1 = $this$awaitPointerEventScope;
    return i;
  };
  function CustomMagicMugDetailsScreen$slambda$slambda_2($isInteractingWith3D$delegate, resultContinuation) {
    var i = new CustomMagicMugDetailsScreen$slambda$slambda_1($isInteractingWith3D$delegate, resultContinuation);
    return constructCallableReference(function ($this$awaitPointerEventScope, $completion) {
      return i.ic6($this$awaitPointerEventScope, $completion);
    }, 1);
  }
  function CustomMagicMugDetailsScreen$slambda_5($isInteractingWith3D$delegate, resultContinuation) {
    this.y13l_1 = $isInteractingWith3D$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMagicMugDetailsScreen$slambda_5).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMagicMugDetailsScreen$slambda_5).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.z13l_1.ma7(CustomMagicMugDetailsScreen$slambda$slambda_2(this.y13l_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda_5).wc6 = function ($this$pointerInput, completion) {
    var i = new CustomMagicMugDetailsScreen$slambda_5(this.y13l_1, completion);
    i.z13l_1 = $this$pointerInput;
    return i;
  };
  function CustomMagicMugDetailsScreen$slambda_6($isInteractingWith3D$delegate, resultContinuation) {
    var i = new CustomMagicMugDetailsScreen$slambda_5($isInteractingWith3D$delegate, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function CustomMagicMugDetailsScreen$lambda_18($viewModel, $product) {
    return function () {
      $viewModel.s10h().j10i(new LoadProduct_1($product));
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_19($onBack, $state$delegate, $showDiscardDialog$delegate) {
    return function () {
      var tmp;
      var tmp_0;
      if (CustomMagicMugDetailsScreen$lambda($state$delegate).a10z_1) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_0 = !CustomMagicMugDetailsScreen$lambda($state$delegate).g10z_1.r();
      }
      if (tmp_0) {
        CustomMagicMugDetailsScreen$lambda_14($showDiscardDialog$delegate, true);
        tmp = Unit_instance;
      } else {
        tmp = $onBack();
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_20($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ToggleFavorite_instance_0);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_21($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C311@14463L837:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1136689495, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMagicMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMagicMugDetailsScreen.kt:311)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 1556591996, 'C312@14540L726:CustomMagicMugDetailsScreen.kt#8gd4xm');
        var tmp_2 = CustomMagicMugDetailsScreen$lambda($state$delegate).b10z_1;
        AnimatedContent(tmp_2, null, null, null, '', null, ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().h13i_1, $composer_5, 1597440, 46);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_22($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ShareProduct_instance_0);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_23($showFullScreen3D$delegate) {
    return function () {
      CustomMagicMugDetailsScreen$lambda_4($showFullScreen3D$delegate, true);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_24($language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C354@16829L1040:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1349469599, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMagicMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMagicMugDetailsScreen.kt:354)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_1 = _Dp___init__impl__ms3zkb(20);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(10);
        var tmp0_modifier = padding_2(tmp_0, tmp_1, tmp$ret$1);
        var tmp1_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_2 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$2 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = tmp0_modifier;
        var horizontalArrangement = tmp_2.mdq(tmp$ret$2);
        var verticalAlignment = tmp1_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_3 = $composer_3.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -2135253559, 'C363@17395L11,359@17140L317,367@17636L10,369@17781L11,365@17486L357:CustomMagicMugDetailsScreen.kt#8gd4xm');
        var tmp_4 = get_Fullscreen(Icons_getInstance().dxv_1);
        var tmp_5 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$9 = _Dp___init__impl__ms3zkb(24);
        Icon(tmp_4, null, size(tmp_5, tmp$ret$9), MaterialTheme_instance.unz($composer_5, 6).fo0_1, $composer_5, 432, 0);
        var tmp0_text = $language === 'en' ? 'Full Show' : '\u0639\u0631\u0636 \u0643\u0627\u0645\u0644';
        var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
        var tmp2_fontWeight = Companion_getInstance_16().f7z_1;
        var tmp3_color = MaterialTheme_instance.unz($composer_5, 6).fo0_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_9 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp3_color, null, tmp_6, null, tmp2_fontWeight, null, tmp_7, null, null, tmp_8, tmp_9, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131002);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_10;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_10 = Unit_instance;
        }
        tmp = tmp_10;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_25($isMediaDialogOpen$delegate) {
    return function (it) {
      CustomMagicMugDetailsScreen$lambda_6($isMediaDialogOpen$delegate, it);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_26($viewModel) {
    return function () {
      $viewModel.s10h().j10i(OpenEditor_instance_0);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_27($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new CardSelected_1(it instanceof Card_1 ? it : null));
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_28($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new CardMessageChanged_1(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_29($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C488@24200L10,484@23908L351:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1384714461, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMagicMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMagicMugDetailsScreen.kt:484)');
        }
        var tmp_0 = '' + CustomMagicMugDetailsScreen$lambda($state$delegate).n10z_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_30($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CustomMagicMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, false);
      CustomMagicMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_31(it) {
    return Unit_instance;
  }
  function CustomMagicMugDetailsScreen$lambda$lambda($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CustomMagicMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, false);
      CustomMagicMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_32($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C506@25211L174,506@25190L240:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1273403530, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMagicMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMagicMugDetailsScreen.kt:506)');
        }
        sourceInformationMarkerStart($composer_0, 324889092, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CustomMagicMugDetailsScreen$lambda$lambda($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().l13i_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_33($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new BoxSelected_1(it instanceof Box_0 ? it : null));
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_34($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new BoxMessageChanged_1(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_35($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C544@27329L10,540@27038L350:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-835518010, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMagicMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMagicMugDetailsScreen.kt:540)');
        }
        var tmp_0 = '' + CustomMagicMugDetailsScreen$lambda($state$delegate).r10z_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_36($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CustomMagicMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, true);
      CustomMagicMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_37(it) {
    return Unit_instance;
  }
  function CustomMagicMugDetailsScreen$lambda$lambda_0($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CustomMagicMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, true);
      CustomMagicMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_38($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C563@28403L173,563@28382L239:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(218633759, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMagicMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMagicMugDetailsScreen.kt:563)');
        }
        sourceInformationMarkerStart($composer_0, -346353044, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CustomMagicMugDetailsScreen$lambda$lambda_0($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().o13i_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_39($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new SizeSelected_1(it));
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_40($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new ColorSelected_1(it));
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_41($viewModel, $option) {
    return function (value) {
      $viewModel.s10h().j10i(new OptionSelected_1($option.r101_1, value));
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_42($viewModel, $option) {
    return function (newValue) {
      $viewModel.s10h().j10i(new OptionSelected_1($option.r101_1, newValue));
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_43($option, $birthdayPickerTargetOptionKey$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CustomMagicMugDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate, $option.r101_1);
      CustomMagicMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_44($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 100) {
        $viewModel.s10h().j10i(new ProductCommentChanged_1(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda$lambda_1($viewModel, $state$delegate) {
    return function () {
      var tmp;
      if (CustomMagicMugDetailsScreen$lambda($state$delegate).z10y_1 > 1) {
        $viewModel.s10h().j10i(new QuantityChanged_0(CustomMagicMugDetailsScreen$lambda($state$delegate).z10y_1 - 1 | 0));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda$lambda_2($viewModel, $state$delegate) {
    return function () {
      $viewModel.s10h().j10i(new QuantityChanged_0(CustomMagicMugDetailsScreen$lambda($state$delegate).z10y_1 + 1 | 0));
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda$lambda_3($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ToggleStockReminder_instance_0);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda$lambda_4($state$delegate) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C778@39395L1212:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1161096625, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMagicMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMagicMugDetailsScreen.kt:778)');
        }
        var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = null;
        var horizontalArrangement = Arrangement_getInstance().udp_1;
        var verticalAlignment = tmp0_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((1 & 1) === 0))
          modifier = Companion_instance;
        if (!((1 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((1 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 2145758936, 'C782@39619L308,787@39960L39,788@40032L545:CustomMagicMugDetailsScreen.kt#8gd4xm');
        var tmp_1 = CustomMagicMugDetailsScreen$lambda($state$delegate).c10z_1 ? get_NotificationsActive(Icons_getInstance().dxv_1) : get_NotificationsNone(Icons_getInstance().dxv_1);
        var tmp_2 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$6 = _Dp___init__impl__ms3zkb(20);
        var tmp_3 = size(tmp_2, tmp$ret$6);
        Icon(tmp_1, null, tmp_3, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 432, 8);
        var tmp_4 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_4, tmp$ret$7), $composer_5, 6);
        var tmp_5;
        if (CustomMagicMugDetailsScreen$lambda($state$delegate).c10z_1) {
          $composer_5.m30(1039065236);
          sourceInformation($composer_5, '790@40144L39');
          var tmp0_group = stringResource(get_reminder_set(string_instance), $composer_5, 0);
          $composer_5.n30();
          tmp_5 = tmp0_group;
        } else {
          $composer_5.m30(1039069105);
          sourceInformation($composer_5, '792@40265L36');
          var tmp1_group = stringResource(get_remind_me(string_instance), $composer_5, 0);
          $composer_5.n30();
          tmp_5 = tmp1_group;
        }
        var tmp0_text = tmp_5;
        var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp2_fontSize = get_sp(16);
        var tmp3_textAlign = Companion_getInstance_15().d7v_1;
        var tmp4_lineHeight = get_sp(18);
        var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_8 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp_6, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_7, null, tmp3_textAlign, tmp4_lineHeight, tmp_8, false, 0, 0, null, null, $composer_5, 1597440, 48, 258990);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_9;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_9 = Unit_instance;
        }
        tmp = tmp_9;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda$lambda_5($viewModel) {
    return function () {
      $viewModel.s10h().j10i(AddToCart_instance_1);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda$lambda$lambda($this$AnimatedContent) {
    return togetherWith(fadeIn(tween(300)), fadeOut(tween(300)));
  }
  function CustomMagicMugDetailsScreen$lambda$lambda_6($state$delegate) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C813@41478L233,818@41753L38,811@41344L2060:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1323988806, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMagicMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMagicMugDetailsScreen.kt:811)');
        }
        var tmp_0 = CustomMagicMugDetailsScreen$lambda($state$delegate).a10z_1;
        sourceInformationMarkerStart($composer_0, -1042917469, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CustomMagicMugDetailsScreen$lambda$lambda$lambda;
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp0_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        var tmp_2 = stringResource(get_add_to_cart(string_instance), $composer_0, 0);
        AnimatedContent(tmp_0, null, tmp0_group, null, tmp_2, null, ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().s13i_1, $composer_0, 1573248, 42);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_45($activeProduct, $state$delegate, $viewModel, $language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C694@34625L8845:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(717772939, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMagicMugDetailsScreen.<anonymous>.<anonymous> (CustomMagicMugDetailsScreen.kt:694)');
        }
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_start = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_end = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_top = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp4_bottom = _Dp___init__impl__ms3zkb(8);
        var tmp5_modifier = fillMaxWidth(padding_1(Companion_instance, tmp1_start, tmp3_top, tmp2_end, tmp4_bottom));
        var tmp6_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_0 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$4 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = tmp5_modifier;
        var horizontalArrangement = tmp_0.mdq(tmp$ret$4);
        var verticalAlignment = tmp6_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 774382803, 'C:CustomMagicMugDetailsScreen.kt#8gd4xm');
        var tmp2_elvis_lhs = $activeProduct.wzt_1;
        if ((tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) > 0) {
          $composer_5.m30(774285493);
          sourceInformation($composer_5, '703@35097L3294');
          var tmp0_horizontalAlignment = Companion_getInstance_11().x8t_1;
          var tmp_2 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$11 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_1 = null;
          var verticalArrangement = tmp_2.mdq(tmp$ret$11);
          var horizontalAlignment = tmp0_horizontalAlignment;
          var $composer_6 = $composer_5;
          if (!((1 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((1 & 2) === 0))
            verticalArrangement = Arrangement_getInstance().sdp_1;
          if (!((1 & 4) === 0))
            horizontalAlignment = Companion_getInstance_11().w8t_1;
          var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_7 = $composer_6;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
          var localMap_0 = $composer_7.t31();
          var materialized_0 = materialize($composer_7, modifier_2);
          var tmp0_0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_8 = $composer_7;
          var tmp_3 = $composer_8.g30();
          if (!isInterface(tmp_3, Applier)) {
            invalidApplier();
          }
          $composer_8.b31();
          if ($composer_8.h30()) {
            $composer_8.c31(tmp0_0);
          } else {
            $composer_8.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_9 = $composer_8;
          var $composer_10 = $composer_9;
          sourceInformationMarkerStart($composer_10, 1946305788, 'C711@35558L11,707@35318L2632,753@38024L45,754@38125L10,755@38202L11,752@37979L386:CustomMagicMugDetailsScreen.kt#8gd4xm');
          var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
          var tmp_4 = Companion_instance;
          var tmp_5 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_10, 6).oo0_1, 0.5);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$18 = _Dp___init__impl__ms3zkb(12);
          var tmp_6 = background(tmp_4, tmp_5, RoundedCornerShape(tmp$ret$18));
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_7 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$20 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_3 = padding_2(tmp_6, tmp_7, tmp$ret$20);
          var horizontalArrangement_0 = null;
          var verticalAlignment_0 = tmp0_verticalAlignment;
          var $composer_11 = $composer_10;
          if (!((2 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((2 & 2) === 0))
            horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
          if (!((2 & 4) === 0))
            verticalAlignment_0 = Companion_getInstance_11().t8t_1;
          var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_11, 14 & 384 >> 3 | 112 & 384 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_8 = $composer_13.g30();
          if (!isInterface(tmp_8, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_1);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_15, 1342135245, 'C717@35912L280,716@35854L814,735@37045L11,730@36701L399,738@37191L256,737@37133L787:CustomMagicMugDetailsScreen.kt#8gd4xm');
          sourceInformationMarkerStart($composer_15, 874578748, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = !!($composer_15.k31($state$delegate) | $composer_15.q31($viewModel));
          // Inline function 'kotlin.let' call
          var it = $composer_15.i31();
          var tmp_9;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = CustomMagicMugDetailsScreen$lambda$lambda_1($viewModel, $state$delegate);
            $composer_15.j31(value);
            tmp_9 = value;
          } else {
            tmp_9 = it;
          }
          var tmp0_group = tmp_9;
          sourceInformationMarkerEnd($composer_15);
          var tmp_10 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$31 = _Dp___init__impl__ms3zkb(36);
          var tmp_11 = size(tmp_10, tmp$ret$31);
          IconButton(tmp0_group, tmp_11, false, null, null, null, ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().q13i_1, $composer_15, 1572912, 60);
          var tmp0_text = format(CustomMagicMugDetailsScreen$lambda($state$delegate).z10y_1, $language);
          var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp2_fontSize = get_sp(18);
          var tmp_12 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$32 = _Dp___init__impl__ms3zkb(8);
          var tmp3_modifier = padding_2(tmp_12, tmp$ret$32);
          var tmp4_color = MaterialTheme_instance.unz($composer_15, 6).no0_1;
          var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_15 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, tmp3_modifier, tmp4_color, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_13, null, null, tmp_14, tmp_15, false, 0, 0, null, null, $composer_15, 1597488, 0, 262056);
          sourceInformationMarkerStart($composer_15, 874619652, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = !!($composer_15.q31($viewModel) | $composer_15.k31($state$delegate));
          // Inline function 'kotlin.let' call
          var it_0 = $composer_15.i31();
          var tmp_16;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = CustomMagicMugDetailsScreen$lambda$lambda_2($viewModel, $state$delegate);
            $composer_15.j31(value_0);
            tmp_16 = value_0;
          } else {
            tmp_16 = it_0;
          }
          var tmp1_group = tmp_16;
          sourceInformationMarkerEnd($composer_15);
          var tmp_17 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$37 = _Dp___init__impl__ms3zkb(32);
          var tmp_18 = size(tmp_17, tmp$ret$37);
          IconButton(tmp1_group, tmp_18, false, null, null, null, ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().r13i_1, $composer_15, 1572912, 60);
          sourceInformationMarkerEnd($composer_15);
          $composer_13.e31();
          var tmp2_text = stringResource(get_bulk_discount_info(string_instance), $composer_10, 0);
          var tmp3_style = MaterialTheme_instance.jog($composer_10, 6).tof_1;
          var tmp4_color_0 = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
          var tmp5_fontSize = get_sp(10);
          var tmp6_fontWeight = Companion_getInstance_16().c7z_1;
          var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_21 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp2_text, null, tmp4_color_0, null, tmp5_fontSize, null, tmp6_fontWeight, null, tmp_19, null, null, tmp_20, tmp_21, false, 0, 0, null, tmp3_style, $composer_10, 1597440, 0, 130986);
          sourceInformationMarkerEnd($composer_10);
          $composer_8.e31();
          $composer_5.n30();
        } else {
          $composer_5.m30(777472851);
          $composer_5.n30();
        }
        var tmp3_elvis_lhs = $activeProduct.wzt_1;
        if ((tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) <= 0) {
          $composer_5.m30(777650946);
          sourceInformation($composer_5, '765@38598L78,770@38941L301,777@39365L1268,764@38552L2081');
          sourceInformationMarkerStart($composer_5, 1826201085, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_1 = $composer_5.q31($viewModel);
          // Inline function 'kotlin.let' call
          var it_1 = $composer_5.i31();
          var tmp_22;
          if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
            var value_1 = CustomMagicMugDetailsScreen$lambda$lambda_3($viewModel);
            $composer_5.j31(value_1);
            tmp_22 = value_1;
          } else {
            tmp_22 = it_1;
          }
          var tmp0_group_0 = tmp_22;
          sourceInformationMarkerEnd($composer_5);
          var tmp_23 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$42 = _Dp___init__impl__ms3zkb(56);
          var tmp_24 = heightIn(tmp_23, tmp$ret$42);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$43 = _Dp___init__impl__ms3zkb(16);
          var tmp_25 = RoundedCornerShape(tmp$ret$43);
          var tmp_26 = ButtonDefaults_getInstance();
          var tmp_27;
          if (CustomMagicMugDetailsScreen$lambda($state$delegate).c10z_1) {
            $composer_5.m30(1826216952);
            sourceInformation($composer_5, '772@39084L11');
            var tmp1_group_0 = MaterialTheme_instance.unz($composer_5, 6).co0_1;
            $composer_5.n30();
            tmp_27 = tmp1_group_0;
          } else {
            $composer_5.m30(1826220438);
            sourceInformation($composer_5, '774@39193L11');
            var tmp2_group = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
            $composer_5.n30();
            tmp_27 = tmp2_group;
          }
          var tmp_28 = tmp_27;
          var tmp_29 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_30 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_31 = tmp_26.ao9(tmp_28, tmp_29, tmp_30, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_32 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$45 = _Dp___init__impl__ms3zkb(8);
          var tmp_33 = PaddingValues_0(tmp_32, tmp$ret$45);
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(1161096625, true, CustomMagicMugDetailsScreen$lambda$lambda_4($state$delegate), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_16 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_2 = $composer_16.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_2 = $composer_16.i31();
          var tmp_34;
          if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
            var value_2 = ComposableLambda$invoke$ref_1(dispatchReceiver);
            $composer_16.j31(value_2);
            tmp_34 = value_2;
          } else {
            tmp_34 = it_2;
          }
          var tmp$ret$46 = tmp_34;
          Button(tmp0_group_0, tmp_24, false, tmp_25, tmp_31, null, null, tmp_33, null, tmp$ret$46, $composer_5, 817889280, 356);
          $composer_5.n30();
        } else {
          $composer_5.m30(779813692);
          sourceInformation($composer_5, '807@41110L11,807@41066L64,802@40733L68,810@41314L2116,801@40687L2743');
          var tmp_35 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$53 = _Dp___init__impl__ms3zkb(56);
          var tmp4_modifier = heightIn(tmp_35, tmp$ret$53);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$54 = _Dp___init__impl__ms3zkb(16);
          var tmp5_shape = RoundedCornerShape(tmp$ret$54);
          var tmp_36 = ButtonDefaults_getInstance();
          var tmp_37 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
          var tmp_38 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_39 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp6_colors = tmp_36.ao9(tmp_37, tmp_38, tmp_39, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
          var tmp7_enabled = !CustomMagicMugDetailsScreen$lambda($state$delegate).a10z_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_40 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$56 = _Dp___init__impl__ms3zkb(4);
          var tmp8_contentPadding = PaddingValues_0(tmp_40, tmp$ret$56);
          sourceInformationMarkerStart($composer_5, 1826269395, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_3 = $composer_5.q31($viewModel);
          // Inline function 'kotlin.let' call
          var it_3 = $composer_5.i31();
          var tmp_41;
          if (invalid_3 || it_3 === Companion_getInstance().f30_1) {
            var value_3 = CustomMagicMugDetailsScreen$lambda$lambda_5($viewModel);
            $composer_5.j31(value_3);
            tmp_41 = value_3;
          } else {
            tmp_41 = it_3;
          }
          var tmp3_group = tmp_41;
          sourceInformationMarkerEnd($composer_5);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_0 = rememberComposableLambda(-1323988806, true, CustomMagicMugDetailsScreen$lambda$lambda_6($state$delegate), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_17 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_4 = $composer_17.k31(dispatchReceiver_0);
          // Inline function 'kotlin.let' call
          var it_4 = $composer_17.i31();
          var tmp_42;
          if (invalid_4 || it_4 === Companion_getInstance().f30_1) {
            var value_4 = ComposableLambda$invoke$ref_1(dispatchReceiver_0);
            $composer_17.j31(value_4);
            tmp_42 = value_4;
          } else {
            tmp_42 = it_4;
          }
          var tmp$ret$61 = tmp_42;
          Button(tmp3_group, tmp4_modifier, tmp7_enabled, tmp5_shape, tmp6_colors, null, null, tmp8_contentPadding, null, tmp$ret$61, $composer_5, 817889280, 352);
          $composer_5.n30();
        }
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_43;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_43 = Unit_instance;
        }
        tmp = tmp_43;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$slambda_7($verticalScrollState, resultContinuation) {
    this.i13m_1 = $verticalScrollState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMagicMugDetailsScreen$slambda_7).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMagicMugDetailsScreen$slambda_7).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda_7).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.i13m_1.tg7(0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomMagicMugDetailsScreen$slambda_7).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CustomMagicMugDetailsScreen$slambda_7(this.i13m_1, completion);
    i.j13m_1 = $this$LaunchedEffect;
    return i;
  };
  function CustomMagicMugDetailsScreen$slambda_8($verticalScrollState, resultContinuation) {
    var i = new CustomMagicMugDetailsScreen$slambda_7($verticalScrollState, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CustomMagicMugDetailsScreen$lambda_46($viewModel) {
    return function (bitmap, bytes, elements) {
      $viewModel.s10h().j10i(new CustomImageApplied_0(bitmap, bytes, elements));
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_47($viewModel) {
    return function () {
      $viewModel.s10h().j10i(CloseEditor_instance_0);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_48($viewModel, $product) {
    return function () {
      $viewModel.s10h().j10i(new LoadProduct_1($product));
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_49($showFullScreen3D$delegate) {
    return function () {
      CustomMagicMugDetailsScreen$lambda_4($showFullScreen3D$delegate, false);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_50($viewModel, $showFullScreen3D$delegate) {
    return function () {
      CustomMagicMugDetailsScreen$lambda_4($showFullScreen3D$delegate, false);
      $viewModel.s10h().j10i(OpenEditor_instance_0);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_51($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate) {
    return function () {
      CustomMagicMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, false);
      CustomMagicMugDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate, null);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda$lambda_7($birthdayPickerState, $viewModel, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      var tmp0_safe_receiver = $birthdayPickerState.np1();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var date = toLocalDateTime(Companion_getInstance_19().kf(tmp0_safe_receiver), Companion_getInstance_20().yno_1).xn9_1.toString();
        if (!(CustomMagicMugDetailsScreen$lambda_9($birthdayPickerTargetOptionKey$delegate) == null)) {
          var key = ensureNotNull(CustomMagicMugDetailsScreen$lambda_9($birthdayPickerTargetOptionKey$delegate));
          var selectedValue = CustomMagicMugDetailsScreen$lambda($state$delegate).w10z_1.w2(key);
          if (!(selectedValue == null)) {
            $viewModel.s10h().j10i(new OptionSelected_1(key, selectedValue.k101(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, date)));
          }
        } else if (CustomMagicMugDetailsScreen$lambda_11($isPickingBoxBirthday$delegate)) {
          $viewModel.s10h().j10i(new BoxBirthdayChanged_1(date));
        } else {
          $viewModel.s10h().j10i(new CardBirthdayChanged_1(date));
        }
      }
      CustomMagicMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, false);
      CustomMagicMugDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate, null);
      CustomMagicMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_52($birthdayPickerState, $state$delegate, $viewModel, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C925@46571L1603,925@46550L1665:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-811033381, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMagicMugDetailsScreen.<anonymous>.<anonymous> (CustomMagicMugDetailsScreen.kt:925)');
        }
        sourceInformationMarkerStart($composer_0, -2013995586, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.k31($birthdayPickerState) | $composer_0.k31($state$delegate)) | $composer_0.q31($viewModel));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CustomMagicMugDetailsScreen$lambda$lambda_7($birthdayPickerState, $viewModel, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().v13i_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda$lambda_8($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function () {
      CustomMagicMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, false);
      CustomMagicMugDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate, null);
      CustomMagicMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_53($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C954@48310L189,954@48289L353:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(575283353, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMagicMugDetailsScreen.<anonymous>.<anonymous> (CustomMagicMugDetailsScreen.kt:954)');
        }
        sourceInformationMarkerStart($composer_0, -1203477386, 'CC(remember):CustomMagicMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CustomMagicMugDetailsScreen$lambda$lambda_8($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$CustomMagicMugDetailsScreenKt_getInstance().w13i_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_54($birthdayPickerState) {
    return function ($this$DatePickerDialog, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C964@48677L39:CustomMagicMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-690440092, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMagicMugDetailsScreen.<anonymous>.<anonymous> (CustomMagicMugDetailsScreen.kt:964)');
        }
        DatePicker($birthdayPickerState, null, null, null, null, null, false, null, $composer_0, 0, 254);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMagicMugDetailsScreen$lambda_55($product, $onBack, $onNavigateToAuth, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, $topPadding, $bottomPadding, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      CustomMagicMugDetailsScreen($product, $onBack, $onNavigateToAuth, $initialSize._v, $initialColor._v, $initialOptions._v, $initialComment._v, $initialCard._v, $initialBox._v, $initialCardMessage._v, $initialCardBirthday._v, $initialBoxMessage._v, $initialBoxBirthday._v, $topPadding._v.m5f_1, $bottomPadding._v.m5f_1, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen(product, onBack, onNavigateToAuth, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, topPadding, bottomPadding, $composer, $changed, $changed1, $default) {
    var initialSize_0 = {_v: initialSize};
    var initialColor_0 = {_v: initialColor};
    var initialOptions_0 = {_v: initialOptions};
    var initialComment_0 = {_v: initialComment};
    var initialCard_0 = {_v: initialCard};
    var initialBox_0 = {_v: initialBox};
    var initialCardMessage_0 = {_v: initialCardMessage};
    var initialCardBirthday_0 = {_v: initialCardBirthday};
    var initialBoxMessage_0 = {_v: initialBoxMessage};
    var initialBoxBirthday_0 = {_v: initialBoxBirthday};
    var topPadding_0 = {_v: new Dp(topPadding)};
    var bottomPadding_0 = {_v: new Dp(bottomPadding)};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(2018304685);
    sourceInformation($composer_0, 'C(CustomMugDetailsScreen)P(13,11,12,10,7,9,8,4,1,6,5,3,2,14:c#ui.unit.Dp,0:c#ui.unit.Dp)123@5959L42,124@6073L12,125@6129L16,126@6174L32,127@6237L21,137@6758L689,137@6734L713,156@7479L563,156@7453L589,171@8107L108,171@8048L167,175@8244L90,175@8221L113,181@8367L34,182@8430L34,183@8494L34,185@8560L34,186@8636L42,187@8711L34,188@8775L34,189@8840L25,191@8995L203,191@8871L327,211@9575L39076:CustomMugDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(product) : $composer_0.q31(product)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToAuth) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(initialSize_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(initialColor_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ((($changed & 262144) === 0 ? $composer_0.k31(initialOptions_0._v) : $composer_0.q31(initialOptions_0._v)) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(initialComment_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ((($changed & 16777216) === 0 ? $composer_0.k31(initialCard_0._v) : $composer_0.q31(initialCard_0._v)) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ((($changed & 134217728) === 0 ? $composer_0.k31(initialBox_0._v) : $composer_0.q31(initialBox_0._v)) ? 67108864 : 33554432);
    if (!(($default & 512) === 0))
      $dirty = $dirty | 805306368;
    else if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.k31(initialCardMessage_0._v) ? 536870912 : 268435456);
    if (!(($default & 1024) === 0))
      $dirty1 = $dirty1 | 6;
    else if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(initialCardBirthday_0._v) ? 4 : 2);
    if (!(($default & 2048) === 0))
      $dirty1 = $dirty1 | 48;
    else if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(initialBoxMessage_0._v) ? 32 : 16);
    if (!(($default & 4096) === 0))
      $dirty1 = $dirty1 | 384;
    else if (($changed1 & 384) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(initialBoxBirthday_0._v) ? 256 : 128);
    if (!(($default & 8192) === 0))
      $dirty1 = $dirty1 | 3072;
    else if (($changed1 & 3072) === 0)
      $dirty1 = $dirty1 | ($composer_0.n31(_Dp___get_value__impl__geb1vb(topPadding_0._v.m5f_1)) ? 2048 : 1024);
    if (!(($default & 16384) === 0))
      $dirty1 = $dirty1 | 24576;
    else if (($changed1 & 24576) === 0)
      $dirty1 = $dirty1 | ($composer_0.n31(_Dp___get_value__impl__geb1vb(bottomPadding_0._v.m5f_1)) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        initialSize_0._v = null;
      }
      if (!(($default & 16) === 0)) {
        initialColor_0._v = null;
      }
      if (!(($default & 32) === 0)) {
        initialOptions_0._v = null;
      }
      if (!(($default & 64) === 0)) {
        initialComment_0._v = null;
      }
      if (!(($default & 128) === 0)) {
        initialCard_0._v = null;
      }
      if (!(($default & 256) === 0)) {
        initialBox_0._v = null;
      }
      if (!(($default & 512) === 0)) {
        initialCardMessage_0._v = null;
      }
      if (!(($default & 1024) === 0)) {
        initialCardBirthday_0._v = null;
      }
      if (!(($default & 2048) === 0)) {
        initialBoxMessage_0._v = null;
      }
      if (!(($default & 4096) === 0)) {
        initialBoxBirthday_0._v = null;
      }
      if (!(($default & 8192) === 0)) {
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
        topPadding_0._v = new Dp(tmp$ret$0);
      }
      if (!(($default & 16384) === 0)) {
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(0);
        bottomPadding_0._v = new Dp(tmp$ret$1);
      }
      if (isTraceInProgress()) {
        traceEventStart(2018304685, $dirty, $dirty1, 'client.fstech.hadaya.presentation.product_details.CustomMugDetailsScreen (CustomMugDetailsScreen.kt:122)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = toString_0(product.nzt_1);
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((59 & 1) === 0))
        qualifier = null;
      if (!((59 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((59 & 4) === 0))
        key = null;
      if (!((59 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((59 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((59 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(CustomProductDetailsViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      // Inline function 'org.koin.compose.koinInject' call
      var qualifier_0 = null;
      var scope_0 = null;
      var $composer_2 = $composer_0;
      sourceInformationMarkerStart($composer_2, -1168520582, 'CC(koinInject)88@2750L18,90@2787L73:Inject.kt#8jjlyv');
      if (!((3 & 1) === 0))
        qualifier_0 = null;
      if (!((3 & 2) === 0))
        scope_0 = currentKoinScope($composer_2, 0);
      sourceInformationMarkerStart($composer_2, -1961811197, 'CC(remember):Inject.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_2.k31(qualifier_0) | $composer_2.k31(scope_0));
      // Inline function 'kotlin.let' call
      var it = $composer_2.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = scope_0.ts6(getKClass(AppViewModel), qualifier_0);
        $composer_2.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_2);
      sourceInformationMarkerEnd($composer_2);
      var appViewModel = tmp1_group;
      var tmp_1 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_1, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, -1734385747, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_0.i31();
      var tmp_2;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = new SnackbarHostState();
        this_0.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp0_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp0_group;
      var verticalScrollState = rememberScrollState(0, $composer_0, 0, 1);
      var language = CustomMugDetailsScreen$lambda(state$delegate).d10z_1;
      var tmp0_elvis_lhs_0 = CustomMugDetailsScreen$lambda(state$delegate).y10y_1;
      var activeProduct = tmp0_elvis_lhs_0 == null ? product : tmp0_elvis_lhs_0;
      var tmp_3;
      if (language === 'en') {
        var tmp1_elvis_lhs = activeProduct.ozt_1;
        tmp_3 = tmp1_elvis_lhs == null ? activeProduct.pzt_1 : tmp1_elvis_lhs;
      } else {
        var tmp2_elvis_lhs = activeProduct.pzt_1;
        tmp_3 = tmp2_elvis_lhs == null ? activeProduct.ozt_1 : tmp2_elvis_lhs;
      }
      var tmp3_elvis_lhs = tmp_3;
      var name = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      var tmp_4;
      if (language === 'en') {
        var tmp4_elvis_lhs = activeProduct.qzt_1;
        tmp_4 = tmp4_elvis_lhs == null ? activeProduct.rzt_1 : tmp4_elvis_lhs;
      } else {
        var tmp5_elvis_lhs = activeProduct.rzt_1;
        tmp_4 = tmp5_elvis_lhs == null ? activeProduct.qzt_1 : tmp5_elvis_lhs;
      }
      var tmp6_elvis_lhs = tmp_4;
      var description = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
      sourceInformationMarkerStart($composer_0, -1734366402, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(!!(!!(!!(!!(!!(!!(!!(!!(!!(!!($composer_0.q31(viewModel) | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(product)))) | ($dirty & 7168) === 2048) | ($dirty & 57344) === 16384) | (($dirty & 458752) === 131072 || (!(($dirty & 262144) === 0) && $composer_0.q31(initialOptions_0._v)))) | ($dirty & 3670016) === 1048576) | (($dirty & 29360128) === 8388608 || (!(($dirty & 16777216) === 0) && $composer_0.q31(initialCard_0._v)))) | (($dirty & 234881024) === 67108864 || (!(($dirty & 134217728) === 0) && $composer_0.q31(initialBox_0._v)))) | ($dirty & 1879048192) === 536870912) | ($dirty1 & 14) === 4) | ($dirty1 & 112) === 32) | ($dirty1 & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_0.i31();
      var tmp_5;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = CustomMugDetailsScreen$slambda_0(viewModel, product, initialSize_0, initialColor_0, initialOptions_0, initialComment_0, initialCard_0, initialBox_0, initialCardMessage_0, initialCardBirthday_0, initialBoxMessage_0, initialBoxBirthday_0, null);
        tmp0_0.j31(value_1);
        tmp_5 = value_1;
      } else {
        tmp_5 = it_1;
      }
      var tmp1_group_0 = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(product, tmp1_group_0, $composer_0, 14 & $dirty);
      sourceInformationMarkerStart($composer_0, -1734343456, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(!!($composer_0.q31(viewModel) | ($dirty & 896) === 256) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_1.i31();
      var tmp_6;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = CustomMugDetailsScreen$slambda_2(viewModel, snackbarHostState, onNavigateToAuth, onBack, null);
        tmp0_1.j31(value_2);
        tmp_6 = value_2;
      } else {
        tmp_6 = it_2;
      }
      var tmp2_group = tmp_6;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp2_group, $composer_0, 0);
      var tmp_7 = CustomMugDetailsScreen$lambda(state$delegate).a10z_1;
      var tmp_8 = CustomMugDetailsScreen$lambda(state$delegate).g10z_1;
      sourceInformationMarkerStart($composer_0, -1734323815, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = !!($composer_0.q31(appViewModel) | $composer_0.k31(state$delegate));
      // Inline function 'kotlin.let' call
      var it_3 = tmp0_2.i31();
      var tmp_9;
      if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = CustomMugDetailsScreen$slambda_4(appViewModel, state$delegate, null);
        tmp0_2.j31(value_3);
        tmp_9 = value_3;
      } else {
        tmp_9 = it_3;
      }
      var tmp3_group = tmp_9;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect(tmp_7, tmp_8, tmp3_group, $composer_0, 0);
      sourceInformationMarkerStart($composer_0, -1734319449, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      var tmp0_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = $composer_0.q31(appViewModel);
      // Inline function 'kotlin.let' call
      var it_4 = tmp0_3.i31();
      var tmp_10;
      if (invalid_3 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = CustomMugDetailsScreen$lambda_0(appViewModel);
        tmp0_3.j31(value_4);
        tmp_10 = value_4;
      } else {
        tmp_10 = it_4;
      }
      var tmp4_group = tmp_10;
      sourceInformationMarkerEnd($composer_0);
      DisposableEffect(Unit_instance, tmp4_group, $composer_0, 6);
      sourceInformationMarkerStart($composer_0, -1734315569, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_5 = this_1.i31();
      var tmp_11;
      if (false || it_5 === Companion_getInstance().f30_1) {
        var value_5 = mutableStateOf(false);
        this_1.j31(value_5);
        tmp_11 = value_5;
      } else {
        tmp_11 = it_5;
      }
      var tmp5_group = tmp_11;
      sourceInformationMarkerEnd($composer_0);
      var isInteractingWith3D$delegate = tmp5_group;
      sourceInformationMarkerStart($composer_0, -1734313553, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_6 = this_2.i31();
      var tmp_12;
      if (false || it_6 === Companion_getInstance().f30_1) {
        var value_6 = mutableStateOf(false);
        this_2.j31(value_6);
        tmp_12 = value_6;
      } else {
        tmp_12 = it_6;
      }
      var tmp6_group = tmp_12;
      sourceInformationMarkerEnd($composer_0);
      var showFullScreen3D$delegate = tmp6_group;
      sourceInformationMarkerStart($composer_0, -1734311505, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_7 = this_3.i31();
      var tmp_13;
      if (false || it_7 === Companion_getInstance().f30_1) {
        var value_7 = mutableStateOf(false);
        this_3.j31(value_7);
        tmp_13 = value_7;
      } else {
        tmp_13 = it_7;
      }
      var tmp7_group = tmp_13;
      sourceInformationMarkerEnd($composer_0);
      var isMediaDialogOpen$delegate = tmp7_group;
      sourceInformationMarkerStart($composer_0, -1734309393, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_4 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_8 = this_4.i31();
      var tmp_14;
      if (false || it_8 === Companion_getInstance().f30_1) {
        var value_8 = mutableStateOf(false);
        this_4.j31(value_8);
        tmp_14 = value_8;
      } else {
        tmp_14 = it_8;
      }
      var tmp8_group = tmp_14;
      sourceInformationMarkerEnd($composer_0);
      var showBirthdayPicker$delegate = tmp8_group;
      sourceInformationMarkerStart($composer_0, -1734306953, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_5 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_9 = this_5.i31();
      var tmp_15;
      if (false || it_9 === Companion_getInstance().f30_1) {
        var value_9 = mutableStateOf(null);
        this_5.j31(value_9);
        tmp_15 = value_9;
      } else {
        tmp_15 = it_9;
      }
      var tmp9_group = tmp_15;
      sourceInformationMarkerEnd($composer_0);
      var birthdayPickerTargetOptionKey$delegate = tmp9_group;
      sourceInformationMarkerStart($composer_0, -1734304561, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_6 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_10 = this_6.i31();
      var tmp_16;
      if (false || it_10 === Companion_getInstance().f30_1) {
        var value_10 = mutableStateOf(false);
        this_6.j31(value_10);
        tmp_16 = value_10;
      } else {
        tmp_16 = it_10;
      }
      var tmp10_group = tmp_16;
      sourceInformationMarkerEnd($composer_0);
      var isPickingBoxBirthday$delegate = tmp10_group;
      sourceInformationMarkerStart($composer_0, -1734302513, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_7 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_11 = this_7.i31();
      var tmp_17;
      if (false || it_11 === Companion_getInstance().f30_1) {
        var value_11 = mutableStateOf(false);
        this_7.j31(value_11);
        tmp_17 = value_11;
      } else {
        tmp_17 = it_11;
      }
      var tmp11_group = tmp_17;
      sourceInformationMarkerEnd($composer_0);
      var showDiscardDialog$delegate = tmp11_group;
      var tmp_18 = _DisplayMode___init__impl__gfd230(0);
      var birthdayPickerState = rememberDatePickerState(null, null, null, tmp_18, null, $composer_0, 0, 31);
      var tmp_19;
      var tmp_20;
      if (CustomMugDetailsScreen$lambda(state$delegate).a10z_1 || CustomMugDetailsScreen$lambda_3(showFullScreen3D$delegate)) {
        tmp_20 = true;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_20 = !CustomMugDetailsScreen$lambda(state$delegate).g10z_1.r();
      }
      if (tmp_20) {
        tmp_19 = !CustomMugDetailsScreen$lambda(state$delegate).h10z_1;
      } else {
        tmp_19 = false;
      }
      var tmp_21 = tmp_19;
      sourceInformationMarkerStart($composer_0, -1734295304, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      var tmp0_4 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_4 = $composer_0.k31(state$delegate);
      // Inline function 'kotlin.let' call
      var it_12 = tmp0_4.i31();
      var tmp_22;
      if (invalid_4 || it_12 === Companion_getInstance().f30_1) {
        var value_12 = CustomMugDetailsScreen$lambda_15(showFullScreen3D$delegate, state$delegate, showDiscardDialog$delegate);
        tmp0_4.j31(value_12);
        tmp_22 = value_12;
      } else {
        tmp_22 = it_12;
      }
      var tmp12_group = tmp_22;
      sourceInformationMarkerEnd($composer_0);
      BackHandler(tmp_21, tmp12_group, $composer_0, 0, 0);
      if (CustomMugDetailsScreen$lambda_13(showDiscardDialog$delegate)) {
        $composer_0.m30(2071654879);
        sourceInformation($composer_0, '201@9276L46,202@9346L44,203@9416L82,207@9524L29,200@9237L326');
        var tmp_23 = stringResource(get_discard_order_title(string_instance), $composer_0, 0);
        var tmp_24 = stringResource(get_discard_order_msg(string_instance), $composer_0, 0);
        sourceInformationMarkerStart($composer_0, -1734281953, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        var tmp0_5 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = ($dirty & 112) === 32;
        // Inline function 'kotlin.let' call
        var it_13 = tmp0_5.i31();
        var tmp_25;
        if (invalid_5 || it_13 === Companion_getInstance().f30_1) {
          var value_13 = CustomMugDetailsScreen$lambda_16(onBack, showDiscardDialog$delegate);
          tmp0_5.j31(value_13);
          tmp_25 = value_13;
        } else {
          tmp_25 = it_13;
        }
        var tmp13_group = tmp_25;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, -1734278550, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_8 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_14 = this_8.i31();
        var tmp_26;
        if (false || it_14 === Companion_getInstance().f30_1) {
          var value_14 = CustomMugDetailsScreen$lambda_17(showDiscardDialog$delegate);
          this_8.j31(value_14);
          tmp_26 = value_14;
        } else {
          tmp_26 = it_14;
        }
        var tmp14_group = tmp_26;
        sourceInformationMarkerEnd($composer_0);
        HadayaAlertDialog(tmp_23, tmp_24, null, null, tmp13_group, tmp14_group, $composer_0, 196608, 12);
        $composer_0.n30();
      } else {
        $composer_0.m30(2071983541);
        $composer_0.n30();
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = fillMaxSize(Companion_instance);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_3 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_4 = $composer_3;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_4, 0).hashCode();
      var localMap = $composer_4.t31();
      var materialized = materialize($composer_4, modifier_0);
      var tmp0_6 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_5 = $composer_4;
      var tmp_27 = $composer_5.g30();
      if (!isInterface(tmp_27, Applier)) {
        invalidApplier();
      }
      $composer_5.b31();
      if ($composer_5.h30()) {
        $composer_5.c31(tmp0_6);
      } else {
        $composer_5.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_5);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_6 = $composer_5;
      var $composer_7 = $composer_6;
      sourceInformationMarkerStart($composer_7, 1990771887, 'C849@43487L55,849@43431L111,877@44510L79,878@44615L28,879@44672L138,869@44191L629,910@46058L128:CustomMugDetailsScreen.kt#8gd4xm');
      if (!CustomMugDetailsScreen$lambda(state$delegate).h10z_1) {
        $composer_7.m30(1990632076);
        sourceInformation($composer_7, '219@9886L34,220@9959L31,214@9697L308,224@10061L24131,687@34382L11,690@34535L8877,685@34242L9170');
        var tmp0_modifier = alpha(BoxScopeInstance_instance.udr(fillMaxWidth(Companion_instance, 0.8), Companion_getInstance_11().o8t_1), 0.03);
        var tmp1_painter = painterResource(get_logo(drawable_instance), $composer_7, 0);
        var tmp2_contentDescription = stringResource(get_logo_0(string_instance), $composer_7, 0);
        Image(tmp1_painter, tmp2_contentDescription, tmp0_modifier, null, null, 0.0, null, $composer_7, androidx_compose_ui_graphics_painter_Painter$stableprop_getter(), 120);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_1 = zIndex(verticalScroll(fillMaxSize(Companion_instance), verticalScrollState, !CustomMugDetailsScreen$lambda(state$delegate).a10z_1 && !CustomMugDetailsScreen$lambda_1(isInteractingWith3D$delegate)), 0.0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_8 = $composer_7;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_8, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_9 = $composer_8;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_9, 0).hashCode();
        var localMap_0 = $composer_9.t31();
        var materialized_0 = materialize($composer_9, modifier_2);
        var tmp0_7 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_10 = $composer_9;
        var tmp_28 = $composer_10.g30();
        if (!isInterface(tmp_28, Applier)) {
          invalidApplier();
        }
        $composer_10.b31();
        if ($composer_10.h30()) {
          $composer_10.c31(tmp0_7);
        } else {
          $composer_10.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_10);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_11 = $composer_10;
        var $composer_12 = $composer_11;
        sourceInformationMarkerStart($composer_12, 1491527564, 'C239@10698L11,234@10433L7460,375@17911L41,380@18132L26,377@17970L206,384@18242L15936:CustomMugDetailsScreen.kt#8gd4xm');
        var tmp_29 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$82 = _Dp___init__impl__ms3zkb(400);
        var tmp_30 = height(tmp_29, tmp$ret$82);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp0_bottomStart = _Dp___init__impl__ms3zkb(32);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_bottomEnd = _Dp___init__impl__ms3zkb(32);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = background(clip(tmp_30, RoundedCornerShape_0(VOID, VOID, tmp1_bottomEnd, tmp0_bottomStart)), Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_12, 6).oo0_1, 0.3));
        var contentAlignment_0 = null;
        var propagateMinConstraints_0 = false;
        var $composer_13 = $composer_12;
        if (!((6 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_14 = $composer_13;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_14, 0).hashCode();
        var localMap_1 = $composer_14.t31();
        var materialized_1 = materialize($composer_14, modifier_4);
        var tmp0_8 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_15 = $composer_14;
        var tmp_31 = $composer_15.g30();
        if (!isInterface(tmp_31, Applier)) {
          invalidApplier();
        }
        $composer_15.b31();
        if ($composer_15.h30()) {
          $composer_15.c31(tmp0_8);
        } else {
          $composer_15.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_15);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_16 = $composer_15;
        var $composer_17 = $composer_16;
        sourceInformationMarkerStart($composer_17, 1879847108, 'C244@10931L402,242@10820L1721,276@12605L3625,350@16627L11,345@16345L27,353@16787L1088,344@16302L1573:CustomMugDetailsScreen.kt#8gd4xm');
        var tmp_32 = fillMaxSize(Companion_instance);
        sourceInformationMarkerStart($composer_17, 2000299778, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_15 = $composer_17.i31();
        var tmp_33;
        if (false || it_15 === Companion_getInstance().f30_1) {
          var tmp_34 = CustomMugDetailsScreen$slambda_6(isInteractingWith3D$delegate, null);
          var value_15 = new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6(tmp_34);
          $composer_17.j31(value_15);
          tmp_33 = value_15;
        } else {
          tmp_33 = it_15;
        }
        var tmp0_group_0 = tmp_33;
        sourceInformationMarkerEnd($composer_17);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_5 = pointerInput(tmp_32, Unit_instance, tmp0_group_0);
        var contentAlignment_1 = null;
        var propagateMinConstraints_1 = false;
        var $composer_18 = $composer_17;
        if (!((6 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment_1 = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints_1 = false;
        var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_19 = $composer_18;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_19, 0).hashCode();
        var localMap_2 = $composer_19.t31();
        var materialized_2 = materialize($composer_19, modifier_6);
        var tmp0_9 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_20 = $composer_19;
        var tmp_35 = $composer_20.g30();
        if (!isInterface(tmp_35, Applier)) {
          invalidApplier();
        }
        $composer_20.b31();
        if ($composer_20.h30()) {
          $composer_20.c31(tmp0_9);
        } else {
          $composer_20.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_20);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_21 = $composer_20;
        var $composer_22 = $composer_21;
        sourceInformationMarkerStart($composer_22, 1790277384, 'C:CustomMugDetailsScreen.kt#8gd4xm');
        if (!CustomMugDetailsScreen$lambda_3(showFullScreen3D$delegate)) {
          $composer_22.m30(1790299486);
          sourceInformation($composer_22, '260@11806L311,254@11435L1058');
          var tmp_36 = CustomMugDetailsScreen$lambda(state$delegate).i10z_1;
          var tmp_37 = CustomMugDetailsScreen$lambda(state$delegate).j10z_1;
          var tmp_38 = ProductKind_MUG_getInstance();
          var tmp_39 = CustomMugDetailsScreen$lambda(state$delegate).e10z_1;
          var tmp_40 = CustomMugDetailsScreen$lambda(state$delegate).f10z_1;
          sourceInformationMarkerStart($composer_22, -219331039, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_6 = !!($composer_0.q31(viewModel) | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(product))));
          // Inline function 'kotlin.let' call
          var it_16 = $composer_22.i31();
          var tmp_41;
          if (invalid_6 || it_16 === Companion_getInstance().f30_1) {
            var value_16 = CustomMugDetailsScreen$lambda_18(viewModel, product);
            $composer_22.j31(value_16);
            tmp_41 = value_16;
          } else {
            tmp_41 = it_16;
          }
          var tmp0_group_1 = tmp_41;
          sourceInformationMarkerEnd($composer_22);
          Model3DViewerSection(tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, tmp0_group_1, fillMaxSize(Companion_instance), !CustomMugDetailsScreen$lambda_13(showDiscardDialog$delegate) && !CustomMugDetailsScreen$lambda_7(showBirthdayPicker$delegate) && !CustomMugDetailsScreen$lambda(state$delegate).a10z_1 && !CustomMugDetailsScreen$lambda(state$delegate).h10z_1 && !CustomMugDetailsScreen$lambda_5(isMediaDialogOpen$delegate), _Dp___get_value__impl__geb1vb(topPadding_0._v.m5f_1), _Dp___get_value__impl__geb1vb(bottomPadding_0._v.m5f_1), $composer_22, 1573248, 0);
          $composer_22.n30();
        } else {
          $composer_22.m30(1791370040);
          $composer_22.n30();
        }
        sourceInformationMarkerEnd($composer_22);
        $composer_20.e31();
        var tmp0_$receiver = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_top = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_start = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_end = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_7 = padding_1(tmp0_$receiver, tmp2_start, tmp1_top, tmp3_end);
        var horizontalArrangement = Arrangement_getInstance().wdp_1;
        var verticalAlignment = null;
        var $composer_23 = $composer_17;
        if (!((4 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((4 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((4 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_3 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_23, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_24 = $composer_23;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_24, 0).hashCode();
        var localMap_3 = $composer_24.t31();
        var materialized_3 = materialize($composer_24, modifier_8);
        var tmp0_10 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_25 = $composer_24;
        var tmp_42 = $composer_25.g30();
        if (!isInterface(tmp_42, Applier)) {
          invalidApplier();
        }
        $composer_25.b31();
        if ($composer_25.h30()) {
          $composer_25.c31(tmp0_10);
        } else {
          $composer_25.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_25);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_26 = $composer_25;
        var $composer_27 = $composer_26;
        sourceInformationMarkerStart($composer_27, -1135243383, 'C283@12945L309,291@13355L11,282@12898L1064,304@13988L2220:CustomMugDetailsScreen.kt#8gd4xm');
        sourceInformationMarkerStart($composer_27, 379019745, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_7 = !!($composer_0.k31(state$delegate) | ($dirty & 112) === 32);
        // Inline function 'kotlin.let' call
        var it_17 = $composer_27.i31();
        var tmp_43;
        if (invalid_7 || it_17 === Companion_getInstance().f30_1) {
          var value_17 = CustomMugDetailsScreen$lambda_19(onBack, state$delegate, showDiscardDialog$delegate);
          $composer_27.j31(value_17);
          tmp_43 = value_17;
        } else {
          tmp_43 = it_17;
        }
        var tmp0_group_2 = tmp_43;
        sourceInformationMarkerEnd($composer_27);
        var tmp_44 = get_CircleShape();
        var tmp_45 = MaterialTheme_instance.unz($composer_27, 6).mo0_1;
        var tmp_46 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_47 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_48 = _Dp___init__impl__ms3zkb(4);
        Surface_0(tmp0_group_2, null, false, tmp_44, tmp_45, tmp_46, tmp_47, tmp_48, null, null, ComposableSingletons$CustomMugDetailsScreenKt_getInstance().k13m_1, $composer_27, 12582912, 6, 870);
        var tmp_49 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$119 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_9 = null;
        var horizontalArrangement_0 = tmp_49.mdq(tmp$ret$119);
        var verticalAlignment_0 = null;
        var $composer_28 = $composer_27;
        if (!((5 & 1) === 0))
          modifier_9 = Companion_instance;
        if (!((5 & 2) === 0))
          horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
        if (!((5 & 4) === 0))
          verticalAlignment_0 = Companion_getInstance_11().t8t_1;
        var measurePolicy_4 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_28, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_10 = modifier_9;
        var $composer_29 = $composer_28;
        if (!((0 & 2) === 0))
          modifier_10 = Companion_instance;
        var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_29, 0).hashCode();
        var localMap_4 = $composer_29.t31();
        var materialized_4 = materialize($composer_29, modifier_10);
        var tmp0_11 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_30 = $composer_29;
        var tmp_50 = $composer_30.g30();
        if (!isInterface(tmp_50, Applier)) {
          invalidApplier();
        }
        $composer_30.b31();
        if ($composer_30.h30()) {
          $composer_30.c31(tmp0_11);
        } else {
          $composer_30.d31();
        }
        var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_30);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
        var $composer_31 = $composer_30;
        var $composer_32 = $composer_31;
        sourceInformationMarkerStart($composer_32, -1872323873, 'C306@14125L73,308@14307L11,310@14413L901,305@14074L1240,326@15394L71,328@15574L11,325@15343L839:CustomMugDetailsScreen.kt#8gd4xm');
        sourceInformationMarkerStart($composer_32, 355244049, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_8 = $composer_32.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_18 = $composer_32.i31();
        var tmp_51;
        if (invalid_8 || it_18 === Companion_getInstance().f30_1) {
          var value_18 = CustomMugDetailsScreen$lambda_20(viewModel);
          $composer_32.j31(value_18);
          tmp_51 = value_18;
        } else {
          tmp_51 = it_18;
        }
        var tmp0_group_3 = tmp_51;
        sourceInformationMarkerEnd($composer_32);
        var tmp_52 = get_CircleShape();
        var tmp_53 = MaterialTheme_instance.unz($composer_32, 6).mo0_1;
        var tmp_54 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_55 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_56 = _Dp___init__impl__ms3zkb(4);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-576717763, true, CustomMugDetailsScreen$lambda_21(state$delegate), $composer_32, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_33 = $composer_32;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_9 = $composer_33.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_19 = $composer_33.i31();
        var tmp_57;
        if (invalid_9 || it_19 === Companion_getInstance().f30_1) {
          var value_19 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_33.j31(value_19);
          tmp_57 = value_19;
        } else {
          tmp_57 = it_19;
        }
        var tmp$ret$131 = tmp_57;
        Surface_0(tmp0_group_3, null, false, tmp_52, tmp_53, tmp_54, tmp_55, tmp_56, null, null, tmp$ret$131, $composer_32, 12582912, 6, 870);
        sourceInformationMarkerStart($composer_32, 355284655, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_10 = $composer_32.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_20 = $composer_32.i31();
        var tmp_58;
        if (invalid_10 || it_20 === Companion_getInstance().f30_1) {
          var value_20 = CustomMugDetailsScreen$lambda_22(viewModel);
          $composer_32.j31(value_20);
          tmp_58 = value_20;
        } else {
          tmp_58 = it_20;
        }
        var tmp1_group_1 = tmp_58;
        sourceInformationMarkerEnd($composer_32);
        var tmp_59 = get_CircleShape();
        var tmp_60 = MaterialTheme_instance.unz($composer_32, 6).mo0_1;
        var tmp_61 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_62 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_63 = _Dp___init__impl__ms3zkb(4);
        Surface_0(tmp1_group_1, null, false, tmp_59, tmp_60, tmp_61, tmp_62, tmp_63, null, null, ComposableSingletons$CustomMugDetailsScreenKt_getInstance().m13m_1, $composer_32, 12582912, 6, 870);
        sourceInformationMarkerEnd($composer_32);
        $composer_30.e31();
        sourceInformationMarkerEnd($composer_27);
        $composer_25.e31();
        var tmp4_$receiver = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().s8t_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp5_bottom = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp6_end = _Dp___init__impl__ms3zkb(16);
        var tmp7_modifier = zIndex(padding_1(tmp4_$receiver, VOID, VOID, tmp6_end, tmp5_bottom), 2.0);
        var tmp8_color = MaterialTheme_instance.unz($composer_17, 6).eo0_1;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$145 = _Dp___init__impl__ms3zkb(24);
        var tmp9_shape = RoundedCornerShape(tmp$ret$145);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp10_shadowElevation = _Dp___init__impl__ms3zkb(6);
        sourceInformationMarkerStart($composer_17, 2000472651, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_21 = $composer_17.i31();
        var tmp_64;
        if (false || it_21 === Companion_getInstance().f30_1) {
          var value_21 = CustomMugDetailsScreen$lambda_23(showFullScreen3D$delegate);
          $composer_17.j31(value_21);
          tmp_64 = value_21;
        } else {
          tmp_64 = it_21;
        }
        var tmp1_group_2 = tmp_64;
        sourceInformationMarkerEnd($composer_17);
        var tmp_65 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_66 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-1109263739, true, CustomMugDetailsScreen$lambda_24(language), $composer_17, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_34 = $composer_17;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_11 = $composer_34.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_22 = $composer_34.i31();
        var tmp_67;
        if (invalid_11 || it_22 === Companion_getInstance().f30_1) {
          var value_22 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_34.j31(value_22);
          tmp_67 = value_22;
        } else {
          tmp_67 = it_22;
        }
        var tmp$ret$151 = tmp_67;
        Surface_0(tmp1_group_2, tmp7_modifier, false, tmp9_shape, tmp8_color, tmp_65, tmp_66, tmp10_shadowElevation, null, null, tmp$ret$151, $composer_17, 12582918, 6, 868);
        sourceInformationMarkerEnd($composer_17);
        $composer_15.e31();
        var tmp_68 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$158 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_68, tmp$ret$158), $composer_12, 6);
        sourceInformationMarkerStart($composer_12, -1337136880, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_23 = $composer_12.i31();
        var tmp_69;
        if (false || it_23 === Companion_getInstance().f30_1) {
          var value_23 = CustomMugDetailsScreen$lambda_25(isMediaDialogOpen$delegate);
          $composer_12.j31(value_23);
          tmp_69 = value_23;
        } else {
          tmp_69 = it_23;
        }
        var tmp0_group_4 = tmp_69;
        sourceInformationMarkerEnd($composer_12);
        ProductMediaGallerySection(activeProduct, language, tmp0_group_4, $composer_12, 384, 0);
        var tmp_70 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$163 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_11 = padding_2(tmp_70, tmp$ret$163);
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = null;
        var $composer_35 = $composer_12;
        if (!((6 & 1) === 0))
          modifier_11 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_5 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_35, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_12 = modifier_11;
        var $composer_36 = $composer_35;
        if (!((0 & 2) === 0))
          modifier_12 = Companion_instance;
        var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_36, 0).hashCode();
        var localMap_5 = $composer_36.t31();
        var materialized_5 = materialize($composer_36, modifier_12);
        var tmp0_12 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_37 = $composer_36;
        var tmp_71 = $composer_37.g30();
        if (!isInterface(tmp_71, Applier)) {
          invalidApplier();
        }
        $composer_37.b31();
        if ($composer_37.h30()) {
          $composer_37.c31(tmp0_12);
        } else {
          $composer_37.d31();
        }
        var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_37);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
        var $composer_38 = $composer_37;
        var $composer_39 = $composer_38;
        sourceInformationMarkerStart($composer_39, 855495011, 'C387@18409L10,389@18541L11,385@18320L267,392@18609L41,395@18703L2910,442@21635L41,445@21755L69,444@21698L208,449@21928L41,452@22140L10,450@21990L192,455@22204L41,639@32139L41,642@32314L220,640@32201L570,652@32793L41,654@32856L202,660@33080L41,663@33177L856,678@34055L41,680@34118L42:CustomMugDetailsScreen.kt#8gd4xm');
        var tmp0_style = MaterialTheme_instance.jog($composer_39, 6).jof_1;
        var tmp1_fontWeight = Companion_getInstance_16().f7z_1;
        var tmp2_color = MaterialTheme_instance.unz($composer_39, 6).lo0_1;
        var tmp_72 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_73 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_74 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_75 = _TextOverflow___init__impl__obguoe(0);
        Text(name, null, tmp2_color, null, tmp_72, null, tmp1_fontWeight, null, tmp_73, null, null, tmp_74, tmp_75, false, 0, 0, null, tmp0_style, $composer_39, 1572864, 0, 131002);
        var tmp_76 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$170 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_76, tmp$ret$170), $composer_39, 6);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_13 = fillMaxWidth(Companion_instance);
        var horizontalArrangement_1 = Arrangement_getInstance().wdp_1;
        var verticalAlignment_1 = Companion_getInstance_11().u8t_1;
        var $composer_40 = $composer_39;
        if (!((0 & 1) === 0))
          modifier_13 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement_1 = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment_1 = Companion_getInstance_11().t8t_1;
        var measurePolicy_6 = rowMeasurePolicy(horizontalArrangement_1, verticalAlignment_1, $composer_40, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_14 = modifier_13;
        var $composer_41 = $composer_40;
        if (!((0 & 2) === 0))
          modifier_14 = Companion_instance;
        var compositeKeyHash_6 = get_currentCompositeKeyHashCode($composer_41, 0).hashCode();
        var localMap_6 = $composer_41.t31();
        var materialized_6 = materialize($composer_41, modifier_14);
        var tmp0_13 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_42 = $composer_41;
        var tmp_77 = $composer_42.g30();
        if (!isInterface(tmp_77, Applier)) {
          invalidApplier();
        }
        $composer_42.b31();
        if ($composer_42.h30()) {
          $composer_42.c31(tmp0_13);
        } else {
          $composer_42.d31();
        }
        var $this$ReusableComposeNode_6 = _Updater___init__impl__rbfxm8($composer_42);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, measurePolicy_6, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, localMap_6, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, compositeKeyHash_6, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_6, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, materialized_6, Companion_getInstance_12().qah_1);
        var $composer_43 = $composer_42;
        var $composer_44 = $composer_43;
        sourceInformationMarkerStart($composer_44, -787651935, 'C400@18961L2630:CustomMugDetailsScreen.kt#8gd4xm');
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_15 = null;
        var verticalArrangement_1 = null;
        var horizontalAlignment_1 = null;
        var $composer_45 = $composer_44;
        if (!((7 & 1) === 0))
          modifier_15 = Companion_instance;
        if (!((7 & 2) === 0))
          verticalArrangement_1 = Arrangement_getInstance().sdp_1;
        if (!((7 & 4) === 0))
          horizontalAlignment_1 = Companion_getInstance_11().w8t_1;
        var measurePolicy_7 = columnMeasurePolicy(verticalArrangement_1, horizontalAlignment_1, $composer_45, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_16 = modifier_15;
        var $composer_46 = $composer_45;
        if (!((0 & 2) === 0))
          modifier_16 = Companion_instance;
        var compositeKeyHash_7 = get_currentCompositeKeyHashCode($composer_46, 0).hashCode();
        var localMap_7 = $composer_46.t31();
        var materialized_7 = materialize($composer_46, modifier_16);
        var tmp0_14 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_47 = $composer_46;
        var tmp_78 = $composer_47.g30();
        if (!isInterface(tmp_78, Applier)) {
          invalidApplier();
        }
        $composer_47.b31();
        if ($composer_47.h30()) {
          $composer_47.c31(tmp0_14);
        } else {
          $composer_47.d31();
        }
        var $this$ReusableComposeNode_7 = _Updater___init__impl__rbfxm8($composer_47);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, measurePolicy_7, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, localMap_7, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, compositeKeyHash_7, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_7, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, materialized_7, Companion_getInstance_12().qah_1);
        var $composer_48 = $composer_47;
        var $composer_49 = $composer_48;
        sourceInformationMarkerStart($composer_49, -1000275210, 'C:CustomMugDetailsScreen.kt#8gd4xm');
        var tmp0_safe_receiver = CustomMugDetailsScreen$lambda(state$delegate).m10z_1;
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lyz_1;
        var tmp_79 = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
        var tmp2_safe_receiver = CustomMugDetailsScreen$lambda(state$delegate).q10z_1;
        var tmp3_elvis_lhs_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.wyz_1;
        var tmp_80 = tmp_79 + (tmp3_elvis_lhs_0 == null ? 0.0 : tmp3_elvis_lhs_0);
        // Inline function 'kotlin.collections.sumOf' call
        var sum = 0;
        var _iterator__ex2g4s = CustomMugDetailsScreen$lambda(state$delegate).w10z_1.y2().t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          var tmp_81 = sum;
          var tmp0_elvis_lhs_1 = element.q100_1;
          sum = tmp_81 + (tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1);
        }
        var extraOriginalPrice = tmp_80 + sum;
        var tmp4_safe_receiver = CustomMugDetailsScreen$lambda(state$delegate).m10z_1;
        var tmp5_elvis_lhs_0 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.lyz_1;
        var tmp_82 = tmp5_elvis_lhs_0 == null ? 0.0 : tmp5_elvis_lhs_0;
        var tmp6_safe_receiver = CustomMugDetailsScreen$lambda(state$delegate).q10z_1;
        var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.wyz_1;
        var tmp_83 = tmp_82 + (tmp7_elvis_lhs == null ? 0.0 : tmp7_elvis_lhs);
        // Inline function 'kotlin.collections.sumOf' call
        var sum_0 = 0;
        var _iterator__ex2g4s_0 = CustomMugDetailsScreen$lambda(state$delegate).w10z_1.y2().t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          var tmp_84 = sum_0;
          var tmp_85;
          var tmp0_elvis_lhs_2 = element_0.r100_1;
          if ((tmp0_elvis_lhs_2 == null ? 0.0 : tmp0_elvis_lhs_2) > 0.0) {
            tmp_85 = ensureNotNull(element_0.r100_1);
          } else {
            var tmp1_elvis_lhs_1 = element_0.q100_1;
            tmp_85 = tmp1_elvis_lhs_1 == null ? 0.0 : tmp1_elvis_lhs_1;
          }
          sum_0 = tmp_84 + tmp_85;
        }
        var extraDiscountedPrice = tmp_83 + sum_0;
        var tmp8_elvis_lhs = activeProduct.szt_1;
        var finalOriginalPrice = (tmp8_elvis_lhs == null ? 0.0 : tmp8_elvis_lhs) + extraOriginalPrice;
        var tmp_86;
        var tmp9_elvis_lhs = activeProduct.tzt_1;
        if ((tmp9_elvis_lhs == null ? 0.0 : tmp9_elvis_lhs) > 0.0) {
          tmp_86 = ensureNotNull(activeProduct.tzt_1);
        } else {
          var tmp10_elvis_lhs = activeProduct.szt_1;
          tmp_86 = tmp10_elvis_lhs == null ? 0.0 : tmp10_elvis_lhs;
        }
        var finalDiscountedPrice = tmp_86 + extraDiscountedPrice;
        var tmp_87;
        var tmp11_elvis_lhs = activeProduct.tzt_1;
        if ((tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs) > 0.0) {
          tmp_87 = true;
        } else {
          var tmp0_15 = CustomMugDetailsScreen$lambda(state$delegate).w10z_1.y2();
          var tmp$ret$187;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp_88;
            if (isInterface(tmp0_15, Collection)) {
              tmp_88 = tmp0_15.r();
            } else {
              tmp_88 = false;
            }
            if (tmp_88) {
              tmp$ret$187 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s_1 = tmp0_15.t();
            while (_iterator__ex2g4s_1.u()) {
              var element_1 = _iterator__ex2g4s_1.v();
              var tmp0_elvis_lhs_3 = element_1.r100_1;
              if ((tmp0_elvis_lhs_3 == null ? 0.0 : tmp0_elvis_lhs_3) > 0.0) {
                tmp$ret$187 = true;
                break $l$block_0;
              }
            }
            tmp$ret$187 = false;
          }
          tmp_87 = tmp$ret$187;
        }
        var hasDiscount = tmp_87;
        if (hasDiscount) {
          $composer_49.m30(-999457834);
          sourceInformation($composer_49, '411@19950L197,416@20285L11,410@19901L504,420@20487L195,425@20820L11,419@20438L525');
          var tmp12_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalDiscountedPrice)], $composer_49, 0), language);
          var tmp13_fontSize = get_sp(28);
          var tmp14_color = MaterialTheme_instance.unz($composer_49, 6).xnz_1;
          var tmp15_fontWeight = Companion_getInstance_16().g7z_1;
          var tmp_89 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_90 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_91 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp12_text, null, tmp14_color, null, tmp13_fontSize, null, tmp15_fontWeight, null, tmp_89, null, null, tmp_90, tmp_91, false, 0, 0, null, null, $composer_49, 1597440, 0, 262058);
          var tmp16_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_49, 0), language);
          var tmp17_fontSize = get_sp(18);
          var tmp18_color = MaterialTheme_instance.unz($composer_49, 6).po0_1;
          var tmp19_textDecoration = Companion_getInstance_18().c80_1;
          var tmp_92 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_93 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_94 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp16_text, null, tmp18_color, null, tmp17_fontSize, null, null, null, tmp_92, tmp19_textDecoration, null, tmp_93, tmp_94, false, 0, 0, null, null, $composer_49, 805330944, 0, 261610);
          $composer_49.n30();
        } else {
          $composer_49.m30(-998320506);
          sourceInformation($composer_49, '430@21082L195,435@21415L11,429@21033L502');
          var tmp20_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_49, 0), language);
          var tmp21_fontSize = get_sp(28);
          var tmp22_color = MaterialTheme_instance.unz($composer_49, 6).xnz_1;
          var tmp23_fontWeight = Companion_getInstance_16().g7z_1;
          var tmp_95 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_96 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_97 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp20_text, null, tmp22_color, null, tmp21_fontSize, null, tmp23_fontWeight, null, tmp_95, null, null, tmp_96, tmp_97, false, 0, 0, null, null, $composer_49, 1597440, 0, 262058);
          $composer_49.n30();
        }
        sourceInformationMarkerEnd($composer_49);
        $composer_47.e31();
        sourceInformationMarkerEnd($composer_44);
        $composer_42.e31();
        var tmp_98 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$189 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_98, tmp$ret$189), $composer_39, 6);
        sourceInformationMarkerStart($composer_39, -1219235227, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_12 = $composer_39.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_24 = $composer_39.i31();
        var tmp_99;
        if (invalid_12 || it_24 === Companion_getInstance().f30_1) {
          var value_24 = CustomMugDetailsScreen$lambda_26(viewModel);
          $composer_39.j31(value_24);
          tmp_99 = value_24;
        } else {
          tmp_99 = it_24;
        }
        var tmp0_group_5 = tmp_99;
        sourceInformationMarkerEnd($composer_39);
        var tmp_100 = fillMaxWidth(Companion_instance);
        var tmp_101 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_102 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        CustomizeActionButton(tmp0_group_5, tmp_100, null, tmp_101, tmp_102, null, $composer_39, 48, 60);
        var tmp_103 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$194 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_103, tmp$ret$194), $composer_39, 6);
        $composer_39.m30(-1219226155);
        sourceInformation($composer_39, '*451@22049L41');
        // Inline function 'kotlin.text.ifBlank' call
        var tmp_104;
        if (isBlank(description)) {
          tmp_104 = stringResource(get_no_description(string_instance), $composer_39, 0);
        } else {
          tmp_104 = description;
        }
        var tmp1_group_3 = tmp_104;
        $composer_39.n30();
        var tmp_105 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_106 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_107 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_108 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_109 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp1_group_3, null, tmp_105, null, tmp_106, null, null, null, tmp_107, null, null, tmp_108, tmp_109, false, 0, 0, null, MaterialTheme_instance.jog($composer_39, 6).oof_1, $composer_39, 0, 0, 131070);
        var tmp_110 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$197 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_110, tmp$ret$197), $composer_39, 6);
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!CustomMugDetailsScreen$lambda(state$delegate).y10z_1.r()) {
          $composer_39.m30(859122289);
          sourceInformation($composer_39, '460@22457L38,463@22678L326,459@22399L680');
          var tmp_111 = stringResource(get_select_card(string_instance), $composer_39, 0);
          var tmp_112 = CustomMugDetailsScreen$lambda(state$delegate).y10z_1;
          var tmp3_safe_receiver = CustomMugDetailsScreen$lambda(state$delegate).m10z_1;
          var tmp_113 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.gyz_1;
          sourceInformationMarkerStart($composer_39, -1219205434, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_13 = $composer_39.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_25 = $composer_39.i31();
          var tmp_114;
          if (invalid_13 || it_25 === Companion_getInstance().f30_1) {
            var value_25 = CustomMugDetailsScreen$lambda_27(viewModel);
            $composer_39.j31(value_25);
            tmp_114 = value_25;
          } else {
            tmp_114 = it_25;
          }
          var tmp2_group_0 = tmp_114;
          sourceInformationMarkerEnd($composer_39);
          GiftSelectionSection(tmp_111, tmp_112, tmp_113, tmp2_group_0, language, false, $composer_39, 0, 32);
          var tmp7_safe_receiver = CustomMugDetailsScreen$lambda(state$delegate).m10z_1;
          if ((tmp7_safe_receiver == null ? null : tmp7_safe_receiver.oyz_1) === true) {
            $composer_39.m30(859857144);
            sourceInformation($composer_39, '475@23303L248,483@23854L423,473@23177L1130');
            var tmp4_value = CustomMugDetailsScreen$lambda(state$delegate).n10z_1;
            var tmp_115 = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$203 = _Dp___init__impl__ms3zkb(8);
            var tmp5_modifier = padding_1(tmp_115, VOID, tmp$ret$203);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$204 = _Dp___init__impl__ms3zkb(12);
            var tmp6_shape = RoundedCornerShape(tmp$ret$204);
            sourceInformationMarkerStart($composer_39, -1219185512, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_14 = $composer_39.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_26 = $composer_39.i31();
            var tmp_116;
            if (invalid_14 || it_26 === Companion_getInstance().f30_1) {
              var value_26 = CustomMugDetailsScreen$lambda_28(viewModel);
              $composer_39.j31(value_26);
              tmp_116 = value_26;
            } else {
              tmp_116 = it_26;
            }
            var tmp3_group_0 = tmp_116;
            sourceInformationMarkerEnd($composer_39);
            var tmp_117 = ComposableSingletons$CustomMugDetailsScreenKt_getInstance().n13m_1;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_1 = rememberComposableLambda(2049383235, true, CustomMugDetailsScreen$lambda_29(state$delegate), $composer_39, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_50 = $composer_39;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_15 = $composer_50.k31(dispatchReceiver_1);
            // Inline function 'kotlin.let' call
            var it_27 = $composer_50.i31();
            var tmp_118;
            if (invalid_15 || it_27 === Companion_getInstance().f30_1) {
              var value_27 = ComposableLambda$invoke$ref(dispatchReceiver_1);
              $composer_50.j31(value_27);
              tmp_118 = value_27;
            } else {
              tmp_118 = it_27;
            }
            var tmp_119 = tmp_118;
            OutlinedTextField(tmp4_value, tmp3_group_0, tmp5_modifier, false, false, null, tmp_117, null, null, null, null, null, tmp_119, false, null, null, null, false, 0, 0, null, tmp6_shape, null, $composer_39, 1573248, 384, 0, 6287288);
            $composer_39.n30();
          } else {
            $composer_39.m30(860968866);
            $composer_39.n30();
          }
          var tmp11_safe_receiver = CustomMugDetailsScreen$lambda(state$delegate).m10z_1;
          if ((tmp11_safe_receiver == null ? null : tmp11_safe_receiver.pyz_1) === true) {
            $composer_39.m30(861099500);
            sourceInformation($composer_39, '500@24844L176,496@24559L2,505@25136L312,494@24432L1046');
            var tmp8_value = CustomMugDetailsScreen$lambda(state$delegate).o10z_1;
            var tmp_120 = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$216 = _Dp___init__impl__ms3zkb(8);
            var tmp_121 = padding_1(tmp_120, VOID, tmp$ret$216);
            sourceInformationMarkerStart($composer_39, -1219136272, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_28 = $composer_39.i31();
            var tmp_122;
            if (false || it_28 === Companion_getInstance().f30_1) {
              var value_28 = CustomMugDetailsScreen$lambda_30(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
              $composer_39.j31(value_28);
              tmp_122 = value_28;
            } else {
              tmp_122 = it_28;
            }
            var tmp4_group_0 = tmp_122;
            sourceInformationMarkerEnd($composer_39);
            var tmp9_modifier = clickable(tmp_121, VOID, VOID, VOID, VOID, tmp4_group_0);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$221 = _Dp___init__impl__ms3zkb(12);
            var tmp10_shape = RoundedCornerShape(tmp$ret$221);
            sourceInformationMarkerStart($composer_39, -1219145566, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_29 = $composer_39.i31();
            var tmp_123;
            if (false || it_29 === Companion_getInstance().f30_1) {
              var value_29 = CustomMugDetailsScreen$lambda_31;
              $composer_39.j31(value_29);
              tmp_123 = value_29;
            } else {
              tmp_123 = it_29;
            }
            var tmp5_group_0 = tmp_123;
            sourceInformationMarkerEnd($composer_39);
            var tmp_124 = ComposableSingletons$CustomMugDetailsScreenKt_getInstance().o13m_1;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_2 = rememberComposableLambda(696069404, true, CustomMugDetailsScreen$lambda_32(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_39, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_51 = $composer_39;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_16 = $composer_51.k31(dispatchReceiver_2);
            // Inline function 'kotlin.let' call
            var it_30 = $composer_51.i31();
            var tmp_125;
            if (invalid_16 || it_30 === Companion_getInstance().f30_1) {
              var value_30 = ComposableLambda$invoke$ref(dispatchReceiver_2);
              $composer_51.j31(value_30);
              tmp_125 = value_30;
            } else {
              tmp_125 = it_30;
            }
            var tmp_126 = tmp_125;
            OutlinedTextField(tmp8_value, tmp5_group_0, tmp9_modifier, false, true, null, tmp_124, null, null, tmp_126, null, null, null, false, null, null, null, false, 0, 0, null, tmp10_shape, null, $composer_39, 806903856, 0, 0, 6290856);
            $composer_39.n30();
          } else {
            $composer_39.m30(862130498);
            $composer_39.n30();
          }
          $composer_39.n30();
        } else {
          $composer_39.m30(862152322);
          $composer_39.n30();
        }
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!CustomMugDetailsScreen$lambda(state$delegate).z10z_1.r()) {
          $composer_39.m30(862309864);
          sourceInformation($composer_39, '517@25671L37,520@25890L246,516@25613L598');
          var tmp_127 = stringResource(get_select_box(string_instance), $composer_39, 0);
          var tmp_128 = CustomMugDetailsScreen$lambda(state$delegate).z10z_1;
          var tmp12_safe_receiver = CustomMugDetailsScreen$lambda(state$delegate).q10z_1;
          var tmp_129 = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.ryz_1;
          sourceInformationMarkerStart($composer_39, -1219102730, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_17 = $composer_39.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_31 = $composer_39.i31();
          var tmp_130;
          if (invalid_17 || it_31 === Companion_getInstance().f30_1) {
            var value_31 = CustomMugDetailsScreen$lambda_33(viewModel);
            $composer_39.j31(value_31);
            tmp_130 = value_31;
          } else {
            tmp_130 = it_31;
          }
          var tmp6_group_0 = tmp_130;
          sourceInformationMarkerEnd($composer_39);
          GiftSelectionSection(tmp_127, tmp_128, tmp_129, tmp6_group_0, language, false, $composer_39, 0, 32);
          var tmp16_safe_receiver = CustomMugDetailsScreen$lambda(state$delegate).q10z_1;
          if ((tmp16_safe_receiver == null ? null : tmp16_safe_receiver.zyz_1) === true) {
            $composer_39.m30(862963995);
            sourceInformation($composer_39, '531@26434L247,539@26984L422,529@26309L1127');
            var tmp13_value = CustomMugDetailsScreen$lambda(state$delegate).r10z_1;
            var tmp_131 = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$238 = _Dp___init__impl__ms3zkb(8);
            var tmp14_modifier = padding_1(tmp_131, VOID, tmp$ret$238);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$239 = _Dp___init__impl__ms3zkb(12);
            var tmp15_shape = RoundedCornerShape(tmp$ret$239);
            sourceInformationMarkerStart($composer_39, -1219085321, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_18 = $composer_39.q31(viewModel);
            // Inline function 'kotlin.let' call
            var it_32 = $composer_39.i31();
            var tmp_132;
            if (invalid_18 || it_32 === Companion_getInstance().f30_1) {
              var value_32 = CustomMugDetailsScreen$lambda_34(viewModel);
              $composer_39.j31(value_32);
              tmp_132 = value_32;
            } else {
              tmp_132 = it_32;
            }
            var tmp7_group_0 = tmp_132;
            sourceInformationMarkerEnd($composer_39);
            var tmp_133 = ComposableSingletons$CustomMugDetailsScreenKt_getInstance().q13m_1;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_3 = rememberComposableLambda(1234463596, true, CustomMugDetailsScreen$lambda_35(state$delegate), $composer_39, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_52 = $composer_39;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_19 = $composer_52.k31(dispatchReceiver_3);
            // Inline function 'kotlin.let' call
            var it_33 = $composer_52.i31();
            var tmp_134;
            if (invalid_19 || it_33 === Companion_getInstance().f30_1) {
              var value_33 = ComposableLambda$invoke$ref(dispatchReceiver_3);
              $composer_52.j31(value_33);
              tmp_134 = value_33;
            } else {
              tmp_134 = it_33;
            }
            var tmp_135 = tmp_134;
            OutlinedTextField(tmp13_value, tmp7_group_0, tmp14_modifier, false, false, null, tmp_133, null, null, null, null, null, tmp_135, false, null, null, null, false, 0, 0, null, tmp15_shape, null, $composer_39, 1573248, 384, 0, 6287288);
            $composer_39.n30();
          } else {
            $composer_39.m30(864072834);
            $composer_39.n30();
          }
          var tmp21_safe_receiver = CustomMugDetailsScreen$lambda(state$delegate).q10z_1;
          if ((tmp21_safe_receiver == null ? null : tmp21_safe_receiver.az0_1) === true) {
            $composer_39.m30(864204429);
            sourceInformation($composer_39, '556@27971L175,552@27686L2,562@28328L311,550@27560L1109');
            var tmp17_value = CustomMugDetailsScreen$lambda(state$delegate).s10z_1;
            var tmp_136 = fillMaxWidth(Companion_instance);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$251 = _Dp___init__impl__ms3zkb(8);
            var tmp_137 = padding_1(tmp_136, VOID, tmp$ret$251);
            sourceInformationMarkerStart($composer_39, -1219036209, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_34 = $composer_39.i31();
            var tmp_138;
            if (false || it_34 === Companion_getInstance().f30_1) {
              var value_34 = CustomMugDetailsScreen$lambda_36(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
              $composer_39.j31(value_34);
              tmp_138 = value_34;
            } else {
              tmp_138 = it_34;
            }
            var tmp8_group_0 = tmp_138;
            sourceInformationMarkerEnd($composer_39);
            var tmp18_modifier = clickable(tmp_137, VOID, VOID, VOID, VOID, tmp8_group_0);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$256 = _Dp___init__impl__ms3zkb(12);
            var tmp19_shape = RoundedCornerShape(tmp$ret$256);
            var tmp20_isError = CustomMugDetailsScreen$lambda(state$delegate).t10z_1;
            sourceInformationMarkerStart($composer_39, -1219045502, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_35 = $composer_39.i31();
            var tmp_139;
            if (false || it_35 === Companion_getInstance().f30_1) {
              var value_35 = CustomMugDetailsScreen$lambda_37;
              $composer_39.j31(value_35);
              tmp_139 = value_35;
            } else {
              tmp_139 = it_35;
            }
            var tmp9_group_0 = tmp_139;
            sourceInformationMarkerEnd($composer_39);
            var tmp_140 = ComposableSingletons$CustomMugDetailsScreenKt_getInstance().r13m_1;
            // Inline function 'kotlin.run' call
            var dispatchReceiver_4 = rememberComposableLambda(2074962693, true, CustomMugDetailsScreen$lambda_38(isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_39, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_53 = $composer_39;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_20 = $composer_53.k31(dispatchReceiver_4);
            // Inline function 'kotlin.let' call
            var it_36 = $composer_53.i31();
            var tmp_141;
            if (invalid_20 || it_36 === Companion_getInstance().f30_1) {
              var value_36 = ComposableLambda$invoke$ref(dispatchReceiver_4);
              $composer_53.j31(value_36);
              tmp_141 = value_36;
            } else {
              tmp_141 = it_36;
            }
            var tmp_142 = tmp_141;
            OutlinedTextField(tmp17_value, tmp9_group_0, tmp18_modifier, false, true, null, tmp_140, null, null, tmp_142, null, null, null, tmp20_isError, null, null, null, false, 0, 0, null, tmp19_shape, null, $composer_39, 806903856, 0, 0, 6282664);
            $composer_39.n30();
          } else {
            $composer_39.m30(865295970);
            $composer_39.n30();
          }
          $composer_39.n30();
        } else {
          $composer_39.m30(865317794);
          $composer_39.n30();
        }
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_9 = activeProduct.lzu_1;
        if (!(this_9 == null || this_9.r())) {
          $composer_39.m30(865402269);
          sourceInformation($composer_39, '574@28867L38,577@29078L283,573@28807L629');
          var tmp_143 = stringResource(get_select_size(string_instance), $composer_39, 0);
          var tmp_144 = CustomMugDetailsScreen$lambda(state$delegate).u10z_1;
          sourceInformationMarkerStart($composer_39, -1219000677, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_21 = $composer_39.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_37 = $composer_39.i31();
          var tmp_145;
          if (invalid_21 || it_37 === Companion_getInstance().f30_1) {
            var value_37 = CustomMugDetailsScreen$lambda_39(viewModel);
            $composer_39.j31(value_37);
            tmp_145 = value_37;
          } else {
            tmp_145 = it_37;
          }
          var tmp10_group_0 = tmp_145;
          sourceInformationMarkerEnd($composer_39);
          OptionSelectionSection(tmp_143, activeProduct.lzu_1, tmp_144, tmp10_group_0, language, false, $composer_39, 0, 32);
          $composer_39.n30();
        } else {
          $composer_39.m30(866052866);
          $composer_39.n30();
        }
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_10 = activeProduct.mzu_1;
        if (!(this_10 == null || this_10.r())) {
          $composer_39.m30(866138457);
          sourceInformation($composer_39, '590@29609L39,593@29823L284,589@29549L633');
          var tmp_146 = stringResource(get_select_color(string_instance), $composer_39, 0);
          var tmp_147 = CustomMugDetailsScreen$lambda(state$delegate).v10z_1;
          sourceInformationMarkerStart($composer_39, -1218976836, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_22 = $composer_39.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_38 = $composer_39.i31();
          var tmp_148;
          if (invalid_22 || it_38 === Companion_getInstance().f30_1) {
            var value_38 = CustomMugDetailsScreen$lambda_40(viewModel);
            $composer_39.j31(value_38);
            tmp_148 = value_38;
          } else {
            tmp_148 = it_38;
          }
          var tmp11_group_0 = tmp_148;
          sourceInformationMarkerEnd($composer_39);
          OptionSelectionSection(tmp_146, activeProduct.mzu_1, tmp_147, tmp11_group_0, language, false, $composer_39, 0, 32);
          $composer_39.n30();
        } else {
          $composer_39.m30(866792898);
          $composer_39.n30();
        }
        var tmp22_safe_receiver = activeProduct.nzu_1;
        if (tmp22_safe_receiver == null) {
          $composer_39.m30(866905055);
          $composer_39.n30();
        } else {
          $composer_39.m30(866905056);
          sourceInformation($composer_39, '*608@30499L349,605@30303L620');
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_2 = tmp22_safe_receiver.t();
          while (_iterator__ex2g4s_2.u()) {
            var element_2 = _iterator__ex2g4s_2.v();
            var tmp_149 = CustomMugDetailsScreen$lambda(state$delegate).w10z_1.w2(element_2.r101_1);
            sourceInformationMarkerStart($composer_39, 747403887, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_23 = !!($composer_39.q31(viewModel) | $composer_39.q31(element_2));
            // Inline function 'kotlin.let' call
            var it_39 = $composer_39.i31();
            var tmp_150;
            if (invalid_23 || it_39 === Companion_getInstance().f30_1) {
              var value_39 = CustomMugDetailsScreen$lambda_41(viewModel, element_2);
              $composer_39.j31(value_39);
              tmp_150 = value_39;
            } else {
              tmp_150 = it_39;
            }
            var tmp0_group_6 = tmp_150;
            sourceInformationMarkerEnd($composer_39);
            OptionSelectionSection_0(element_2, tmp_149, tmp0_group_6, language, false, $composer_39, 0, 16);
            var tmp0_safe_receiver_0 = CustomMugDetailsScreen$lambda(state$delegate).w10z_1.w2(element_2.r101_1);
            if (tmp0_safe_receiver_0 == null) {
              $composer_39.m30(1695187799);
              $composer_39.n30();
            } else {
              $composer_39.m30(1695187800);
              sourceInformation($composer_39, '');
              // Inline function 'kotlin.let' call
              if (tmp0_safe_receiver_0.w100_1 || tmp0_safe_receiver_0.z100_1 || tmp0_safe_receiver_0.c101_1) {
                $composer_39.m30(1480423505);
                sourceInformation($composer_39, '624@31418L269,629@31748L188,620@31153L886');
                sourceInformationMarkerStart($composer_39, 186311816, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
                // Inline function 'androidx.compose.runtime.cache' call
                var invalid_24 = !!($composer_39.q31(viewModel) | $composer_39.q31(element_2));
                // Inline function 'kotlin.let' call
                var it_40 = $composer_39.i31();
                var tmp_151;
                if (invalid_24 || it_40 === Companion_getInstance().f30_1) {
                  var value_40 = CustomMugDetailsScreen$lambda_42(viewModel, element_2);
                  $composer_39.j31(value_40);
                  tmp_151 = value_40;
                } else {
                  tmp_151 = it_40;
                }
                var tmp0_group_7 = tmp_151;
                sourceInformationMarkerEnd($composer_39);
                sourceInformationMarkerStart($composer_39, 186322295, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
                // Inline function 'androidx.compose.runtime.cache' call
                var invalid_25 = $composer_39.q31(element_2);
                // Inline function 'kotlin.let' call
                var it_41 = $composer_39.i31();
                var tmp_152;
                if (invalid_25 || it_41 === Companion_getInstance().f30_1) {
                  var value_41 = CustomMugDetailsScreen$lambda_43(element_2, birthdayPickerTargetOptionKey$delegate, showBirthdayPicker$delegate);
                  $composer_39.j31(value_41);
                  tmp_152 = value_41;
                } else {
                  tmp_152 = it_41;
                }
                var tmp1_group_4 = tmp_152;
                sourceInformationMarkerEnd($composer_39);
                SelectedOptionExtraInputs(element_2.r101_1, tmp0_safe_receiver_0, language, tmp0_group_7, tmp1_group_4, !CustomMugDetailsScreen$lambda(state$delegate).a10z_1, $composer_39, 0, 0);
                $composer_39.n30();
              } else {
                $composer_39.m30(1481336455);
                $composer_39.n30();
              }
              $composer_39.n30();
            }
          }
          $composer_39.n30();
        }
        var tmp_153 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$294 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_153, tmp$ret$294), $composer_39, 6);
        var tmp23_value = CustomMugDetailsScreen$lambda(state$delegate).x10z_1;
        var tmp24_modifier = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$295 = _Dp___init__impl__ms3zkb(12);
        var tmp25_shape = RoundedCornerShape(tmp$ret$295);
        sourceInformationMarkerStart($composer_39, -1218897188, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_26 = $composer_39.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_42 = $composer_39.i31();
        var tmp_154;
        if (invalid_26 || it_42 === Companion_getInstance().f30_1) {
          var value_42 = CustomMugDetailsScreen$lambda_44(viewModel);
          $composer_39.j31(value_42);
          tmp_154 = value_42;
        } else {
          tmp_154 = it_42;
        }
        var tmp12_group_0 = tmp_154;
        sourceInformationMarkerEnd($composer_39);
        var tmp_155 = ComposableSingletons$CustomMugDetailsScreenKt_getInstance().t13m_1;
        OutlinedTextField(tmp23_value, tmp12_group_0, tmp24_modifier, false, false, null, tmp_155, null, null, null, null, null, null, false, null, null, null, false, 0, 0, null, tmp25_shape, null, $composer_39, 1573248, 0, 0, 6291384);
        var tmp_156 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$300 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_156, tmp$ret$300), $composer_39, 6);
        AgeGroupDisplay(activeProduct.rzu_1, activeProduct.szu_1, activeProduct.tzu_1, null, $composer_39, 0, 8);
        var tmp_157 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$301 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_157, tmp$ret$301), $composer_39, 6);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_17 = null;
        var horizontalArrangement_2 = null;
        var verticalAlignment_2 = Companion_getInstance_11().u8t_1;
        var $composer_54 = $composer_39;
        if (!((3 & 1) === 0))
          modifier_17 = Companion_instance;
        if (!((3 & 2) === 0))
          horizontalArrangement_2 = Arrangement_getInstance().qdp_1;
        if (!((3 & 4) === 0))
          verticalAlignment_2 = Companion_getInstance_11().t8t_1;
        var measurePolicy_8 = rowMeasurePolicy(horizontalArrangement_2, verticalAlignment_2, $composer_54, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_18 = modifier_17;
        var $composer_55 = $composer_54;
        if (!((0 & 2) === 0))
          modifier_18 = Companion_instance;
        var compositeKeyHash_8 = get_currentCompositeKeyHashCode($composer_55, 0).hashCode();
        var localMap_8 = $composer_55.t31();
        var materialized_8 = materialize($composer_55, modifier_18);
        var tmp0_16 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_56 = $composer_55;
        var tmp_158 = $composer_56.g30();
        if (!isInterface(tmp_158, Applier)) {
          invalidApplier();
        }
        $composer_56.b31();
        if ($composer_56.h30()) {
          $composer_56.c31(tmp0_16);
        } else {
          $composer_56.d31();
        }
        var $this$ReusableComposeNode_8 = _Updater___init__impl__rbfxm8($composer_56);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_8, measurePolicy_8, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_8, localMap_8, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_8, compositeKeyHash_8, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_8, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_8, materialized_8, Companion_getInstance_12().qah_1);
        var $composer_57 = $composer_56;
        var $composer_58 = $composer_57;
        sourceInformationMarkerStart($composer_58, 7638314, 'C667@33444L76,668@33545L28,669@33598L413:CustomMugDetailsScreen.kt#8gd4xm');
        var tmp_159;
        var tmp0_elvis_lhs_4 = activeProduct.wzt_1;
        if ((tmp0_elvis_lhs_4 == null ? 0 : tmp0_elvis_lhs_4) > 0) {
          $composer_58.m30(-138298154);
          $composer_58.n30();
          tmp_159 = Color(new Long(-11751600, 0));
        } else {
          $composer_58.m30(-138296598);
          sourceInformation($composer_58, '666@33402L11');
          var tmp0_group_8 = MaterialTheme_instance.unz($composer_58, 6).to0_1;
          $composer_58.n30();
          tmp_159 = tmp0_group_8;
        }
        var stockColor = tmp_159;
        var tmp_160 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$308 = _Dp___init__impl__ms3zkb(8);
        Box(background(clip(size(tmp_160, tmp$ret$308), get_CircleShape()), stockColor), $composer_58, 0);
        var tmp_161 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$309 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_161, tmp$ret$309), $composer_58, 6);
        var tmp_162;
        var tmp2_elvis_lhs_0 = activeProduct.wzt_1;
        if ((tmp2_elvis_lhs_0 == null ? 0 : tmp2_elvis_lhs_0) > 0) {
          $composer_58.m30(-138282980);
          sourceInformation($composer_58, '670@33675L163');
          var tmp_163 = get_in_stock_pattern(string_instance);
          var tmp1_elvis_lhs_2 = activeProduct.wzt_1;
          var tmp1_group_5 = formatNumbers(stringResource_0(tmp_163, [tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2], $composer_58, 0), language);
          $composer_58.n30();
          tmp_162 = tmp1_group_5;
        } else {
          $composer_58.m30(-138282036);
          sourceInformation($composer_58, '673@33868L39');
          var tmp2_group_1 = stringResource(get_out_of_stock(string_instance), $composer_58, 0);
          $composer_58.n30();
          tmp_162 = tmp2_group_1;
        }
        var tmp_164 = tmp_162;
        var tmp_165 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_166 = Companion_getInstance_16().e7z_1;
        var tmp_167 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_168 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_169 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_164, null, stockColor, null, tmp_165, null, tmp_166, null, tmp_167, null, null, tmp_168, tmp_169, false, 0, 0, null, null, $composer_58, 1572864, 0, 262074);
        sourceInformationMarkerEnd($composer_58);
        $composer_56.e31();
        var tmp_170 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$310 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_170, tmp$ret$310), $composer_39, 6);
        var tmp_171 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$311 = _Dp___init__impl__ms3zkb(120);
        Spacer(height(tmp_171, tmp$ret$311), $composer_39, 6);
        sourceInformationMarkerEnd($composer_39);
        $composer_37.e31();
        sourceInformationMarkerEnd($composer_12);
        $composer_10.e31();
        var tmp3_modifier = zIndex(fillMaxWidth(BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1)), 2.0);
        var tmp4_color = MaterialTheme_instance.unz($composer_7, 6).mo0_1;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp5_shadowElevation = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_172 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$314 = _Dp___init__impl__ms3zkb(24);
        var tmp6_shape_0 = RoundedCornerShape_0(tmp_172, tmp$ret$314);
        var tmp_173 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_174 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_5 = rememberComposableLambda(-142769039, true, CustomMugDetailsScreen$lambda_45(activeProduct, state$delegate, viewModel, language), $composer_7, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_59 = $composer_7;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_27 = $composer_59.k31(dispatchReceiver_5);
        // Inline function 'kotlin.let' call
        var it_43 = $composer_59.i31();
        var tmp_175;
        if (invalid_27 || it_43 === Companion_getInstance().f30_1) {
          var value_43 = ComposableLambda$invoke$ref(dispatchReceiver_5);
          $composer_59.j31(value_43);
          tmp_175 = value_43;
        } else {
          tmp_175 = it_43;
        }
        var tmp$ret$315 = tmp_175;
        Surface(tmp3_modifier, tmp6_shape_0, tmp4_color, tmp_173, tmp_174, tmp5_shadowElevation, null, tmp$ret$315, $composer_7, 12779520, 88);
        $composer_7.n30();
      } else {
        $composer_7.m30(2023089851);
        $composer_7.n30();
      }
      var tmp_176 = CustomMugDetailsScreen$lambda(state$delegate).e10z_1;
      var tmp_177 = CustomMugDetailsScreen$lambda(state$delegate).g10z_1;
      sourceInformationMarkerStart($composer_7, 203810430, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_28 = $composer_7.k31(verticalScrollState);
      // Inline function 'kotlin.let' call
      var it_44 = $composer_7.i31();
      var tmp_178;
      if (invalid_28 || it_44 === Companion_getInstance().f30_1) {
        var value_44 = CustomMugDetailsScreen$slambda_8(verticalScrollState, null);
        $composer_7.j31(value_44);
        tmp_178 = value_44;
      } else {
        tmp_178 = it_44;
      }
      var tmp0_group_9 = tmp_178;
      sourceInformationMarkerEnd($composer_7);
      LaunchedEffect(tmp_176, tmp_177, tmp0_group_9, $composer_7, 0);
      if (CustomMugDetailsScreen$lambda(state$delegate).h10z_1) {
        $composer_7.m30(2023303658);
        sourceInformation($composer_7, '856@43737L321,865@44087L70,854@43634L537');
        var tmp_179 = CustomMugDetailsScreen$lambda(state$delegate).g10z_1;
        sourceInformationMarkerStart($composer_7, 203818696, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_29 = $composer_7.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_45 = $composer_7.i31();
        var tmp_180;
        if (invalid_29 || it_45 === Companion_getInstance().f30_1) {
          var value_45 = CustomMugDetailsScreen$lambda_46(viewModel);
          $composer_7.j31(value_45);
          tmp_180 = value_45;
        } else {
          tmp_180 = it_45;
        }
        var tmp1_group_6 = tmp_180;
        sourceInformationMarkerEnd($composer_7);
        sourceInformationMarkerStart($composer_7, 203829645, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_30 = $composer_7.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_46 = $composer_7.i31();
        var tmp_181;
        if (invalid_30 || it_46 === Companion_getInstance().f30_1) {
          var value_46 = CustomMugDetailsScreen$lambda_47(viewModel);
          $composer_7.j31(value_46);
          tmp_181 = value_46;
        } else {
          tmp_181 = it_46;
        }
        var tmp2_group_2 = tmp_181;
        sourceInformationMarkerEnd($composer_7);
        MugImageEditorScreen(tmp_179, tmp1_group_6, tmp2_group_2, $composer_7, 0, 0);
        $composer_7.n30();
      } else {
        $composer_7.m30(2023842779);
        $composer_7.n30();
      }
      var tmp_182 = CustomMugDetailsScreen$lambda_3(showFullScreen3D$delegate);
      var tmp_183 = CustomMugDetailsScreen$lambda(state$delegate).i10z_1;
      var tmp_184 = CustomMugDetailsScreen$lambda(state$delegate).j10z_1;
      var tmp_185 = ProductKind_MUG_getInstance();
      var tmp_186 = CustomMugDetailsScreen$lambda(state$delegate).e10z_1;
      var tmp_187 = CustomMugDetailsScreen$lambda(state$delegate).f10z_1;
      sourceInformationMarkerStart($composer_7, 203843190, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_31 = !!($composer_0.q31(viewModel) | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(product))));
      // Inline function 'kotlin.let' call
      var it_47 = $composer_7.i31();
      var tmp_188;
      if (invalid_31 || it_47 === Companion_getInstance().f30_1) {
        var value_47 = CustomMugDetailsScreen$lambda_48(viewModel, product);
        $composer_7.j31(value_47);
        tmp_188 = value_47;
      } else {
        tmp_188 = it_47;
      }
      var tmp3_group_1 = tmp_188;
      sourceInformationMarkerEnd($composer_7);
      sourceInformationMarkerStart($composer_7, 203846499, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_48 = $composer_7.i31();
      var tmp_189;
      if (false || it_48 === Companion_getInstance().f30_1) {
        var value_48 = CustomMugDetailsScreen$lambda_49(showFullScreen3D$delegate);
        $composer_7.j31(value_48);
        tmp_189 = value_48;
      } else {
        tmp_189 = it_48;
      }
      var tmp4_group_1 = tmp_189;
      sourceInformationMarkerEnd($composer_7);
      sourceInformationMarkerStart($composer_7, 203848433, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_32 = $composer_7.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_49 = $composer_7.i31();
      var tmp_190;
      if (invalid_32 || it_49 === Companion_getInstance().f30_1) {
        var value_49 = CustomMugDetailsScreen$lambda_50(viewModel, showFullScreen3D$delegate);
        $composer_7.j31(value_49);
        tmp_190 = value_49;
      } else {
        tmp_190 = it_49;
      }
      var tmp5_group_1 = tmp_190;
      sourceInformationMarkerEnd($composer_7);
      FullScreen3DDialog(tmp_182, tmp_183, tmp_184, tmp_185, tmp_186, tmp_187, language, tmp3_group_1, tmp4_group_1, tmp5_group_1, $composer_7, 100666368, 0);
      if (CustomMugDetailsScreen$lambda(state$delegate).a10z_1) {
        $composer_7.m30(2024549331);
        sourceInformation($composer_7, '886@44870L1168');
        var tmp_191 = fillMaxSize(Companion_instance);
        var tmp_192 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.5);
        var tmp_193 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_194 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_195 = _Dp___init__impl__ms3zkb(0.0);
        Surface(tmp_191, null, tmp_192, tmp_193, tmp_194, tmp_195, null, ComposableSingletons$CustomMugDetailsScreenKt_getInstance().y13m_1, $composer_7, 12583302, 122);
        $composer_7.n30();
      } else {
        $composer_7.m30(2025694843);
        $composer_7.n30();
      }
      var tmp_196 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(snackbarHostState, tmp_196, null, $composer_7, 6, 4);
      if (CustomMugDetailsScreen$lambda_7(showBirthdayPicker$delegate)) {
        $composer_7.m30(2025940642);
        sourceInformation($composer_7, '917@46287L124,921@46445L1705,950@48184L393,961@48592L43,916@46234L2401');
        sourceInformationMarkerStart($composer_7, 203900099, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_50 = $composer_7.i31();
        var tmp_197;
        if (false || it_50 === Companion_getInstance().f30_1) {
          var value_50 = CustomMugDetailsScreen$lambda_51(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate);
          $composer_7.j31(value_50);
          tmp_197 = value_50;
        } else {
          tmp_197 = it_50;
        }
        var tmp6_group_1 = tmp_197;
        sourceInformationMarkerEnd($composer_7);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_6 = rememberComposableLambda(-1060639551, true, CustomMugDetailsScreen$lambda_52(birthdayPickerState, state$delegate, viewModel, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_7, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_60 = $composer_7;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_33 = $composer_60.k31(dispatchReceiver_6);
        // Inline function 'kotlin.let' call
        var it_51 = $composer_60.i31();
        var tmp_198;
        if (invalid_33 || it_51 === Companion_getInstance().f30_1) {
          var value_51 = ComposableLambda$invoke$ref(dispatchReceiver_6);
          $composer_60.j31(value_51);
          tmp_198 = value_51;
        } else {
          tmp_198 = it_51;
        }
        var tmp_199 = tmp_198;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_7 = rememberComposableLambda(952722943, true, CustomMugDetailsScreen$lambda_53(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate), $composer_7, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_61 = $composer_7;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_34 = $composer_61.k31(dispatchReceiver_7);
        // Inline function 'kotlin.let' call
        var it_52 = $composer_61.i31();
        var tmp_200;
        if (invalid_34 || it_52 === Companion_getInstance().f30_1) {
          var value_52 = ComposableLambda$invoke$ref(dispatchReceiver_7);
          $composer_61.j31(value_52);
          tmp_200 = value_52;
        } else {
          tmp_200 = it_52;
        }
        var tmp_201 = tmp_200;
        var tmp_202 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_8 = rememberComposableLambda(1859268490, true, CustomMugDetailsScreen$lambda_54(birthdayPickerState), $composer_7, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_62 = $composer_7;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_35 = $composer_62.k31(dispatchReceiver_8);
        // Inline function 'kotlin.let' call
        var it_53 = $composer_62.i31();
        var tmp_203;
        if (invalid_35 || it_53 === Companion_getInstance().f30_1) {
          var value_53 = ComposableLambda$invoke$ref_6(dispatchReceiver_8);
          $composer_62.j31(value_53);
          tmp_203 = value_53;
        } else {
          tmp_203 = it_53;
        }
        var tmp$ret$364 = tmp_203;
        DatePickerDialog(tmp6_group_1, tmp_199, null, tmp_201, null, tmp_202, null, null, tmp$ret$364, $composer_7, 100666422, 244);
        $composer_7.n30();
      } else {
        $composer_7.m30(2028271067);
        $composer_7.n30();
      }
      sourceInformationMarkerEnd($composer_7);
      $composer_5.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp15_safe_receiver = $composer_0.t30();
    if (tmp15_safe_receiver == null)
      null;
    else {
      tmp15_safe_receiver.p3c(CustomMugDetailsScreen$lambda_55(product, onBack, onNavigateToAuth, initialSize_0, initialColor_0, initialOptions_0, initialComment_0, initialCard_0, initialBox_0, initialCardMessage_0, initialCardBirthday_0, initialBoxMessage_0, initialBoxBirthday_0, topPadding_0, bottomPadding_0, $changed, $changed1, $default));
    }
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$_1566901279$lambda_y3yyj3($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C294@13483L453:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1566901279, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$-1566901279.<anonymous> (CustomMugDetailsScreen.kt:294)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = padding_0(tmp, tmp$ret$0);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -1770503254, 'C297@13692L31,298@13782L11,295@13556L350:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp0_imageVector = get_ArrowBack(Filled_instance_0);
      var tmp1_contentDescription = stringResource(get_back(string_instance), $composer_5, 0);
      var tmp2_tint = MaterialTheme_instance.unz($composer_5, 6).no0_1;
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
      var tmp3_modifier = size(tmp_1, tmp$ret$7);
      Icon(tmp0_imageVector, tmp1_contentDescription, tmp3_modifier, tmp2_tint, $composer_5, 384, 0);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$229469588$lambda($this$AnimatedContent, isFav, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C316@14753L459:CustomMugDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isFav) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(229469588, $dirty, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$229469588.<anonymous> (CustomMugDetailsScreen.kt:316)');
      }
      var tmp0_imageVector = isFav ? get_Favorite(Icons_getInstance().dxv_1) : get_FavoriteBorder(Icons_getInstance().dxv_1);
      var tmp;
      if (isFav) {
        $composer_0.m30(1476952955);
        sourceInformation($composer_0, '319@15033L11');
        var tmp0_group = MaterialTheme_instance.unz($composer_0, 6).xnz_1;
        $composer_0.n30();
        tmp = tmp0_group;
      } else {
        $composer_0.m30(1476954205);
        sourceInformation($composer_0, '319@15072L11');
        var tmp1_group = MaterialTheme_instance.unz($composer_0, 6).no0_1;
        $composer_0.n30();
        tmp = tmp1_group;
      }
      var tmp1_tint = tmp;
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
      var tmp2_modifier = size(tmp_0, tmp$ret$0);
      Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_0, 432, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$1957655334$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C331@15714L438:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1957655334, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$1957655334.<anonymous> (CustomMugDetailsScreen.kt:331)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = padding_0(tmp, tmp$ret$0);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 754938620, 'C335@15986L11,332@15791L327:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp0_imageVector = get_Share(Icons_getInstance().dxv_1);
      var tmp1_tint = MaterialTheme_instance.unz($composer_5, 6).no0_1;
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
      var tmp2_modifier = size(tmp_1, tmp$ret$7);
      Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_5, 432, 0);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$1662301936$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C480@23600L45,480@23595L51:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1662301936, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$1662301936.<anonymous> (CustomMugDetailsScreen.kt:480)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$601390553$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C498@24659L46,498@24654L52:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(601390553, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$601390553.<anonymous> (CustomMugDetailsScreen.kt:498)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$_57084358$lambda_csar37($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C509@25373L39:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-57084358, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$-57084358.<anonymous> (CustomMugDetailsScreen.kt:509)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$_1383477287$lambda_quudu3($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C536@26730L45,536@26725L51:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1383477287, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$-1383477287.<anonymous> (CustomMugDetailsScreen.kt:536)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$1282900098$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C554@27786L46,554@27781L52:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1282900098, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$1282900098.<anonymous> (CustomMugDetailsScreen.kt:554)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$_151296861$lambda_kcwmbu($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C566@28564L39:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-151296861, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$-151296861.<anonymous> (CustomMugDetailsScreen.kt:566)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$_908834906$lambda_4e5yrk($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C647@32575L52,647@32570L58:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-908834906, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$-908834906.<anonymous> (CustomMugDetailsScreen.kt:647)');
      }
      var tmp = stringResource(get_add_product_comment_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$_1074080664$lambda_d07h2f($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C723@36391L49,724@36503L11,721@36262L300:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1074080664, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$-1074080664.<anonymous> (CustomMugDetailsScreen.kt:721)');
      }
      var tmp = get_Remove(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_decrease_quantity_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).no0_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$273632863$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C744@37643L49,745@37755L11,742@37517L297:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(273632863, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$273632863.<anonymous> (CustomMugDetailsScreen.kt:742)');
      }
      var tmp = get_Add(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_increase_quantity_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, MaterialTheme_instance.unz($composer_0, 6).no0_1, $composer_0, 0, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$_107709443$lambda_fpgnq4($this$AnimatedContent, isAdding, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C:CustomMugDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isAdding) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-107709443, $dirty, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$-107709443.<anonymous> (CustomMugDetailsScreen.kt:817)');
      }
      if (isAdding) {
        $composer_0.m30(-431376580);
        sourceInformation($composer_0, '818@41848L257');
        var tmp = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
        var tmp_0 = size(tmp, tmp$ret$0);
        var tmp_1 = Companion_getInstance_14().m6b_1;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_2 = _Dp___init__impl__ms3zkb(2);
        var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_4 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, _Dp___init__impl__ms3zkb(0.0), $composer_0, 438, 56);
        $composer_0.n30();
      } else {
        $composer_0.m30(-430983128);
        sourceInformation($composer_0, '824@42183L1085');
        var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = null;
        var horizontalArrangement = Arrangement_getInstance().udp_1;
        var verticalAlignment = tmp0_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((1 & 1) === 0))
          modifier = Companion_instance;
        if (!((1 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((1 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_5 = $composer_3.g30();
        if (!isInterface(tmp_5, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 1580689255, 'C828@42439L266,833@42746L39,835@42876L38,834@42826L404:CustomMugDetailsScreen.kt#8gd4xm');
        var tmp_6 = get_ShoppingCart(Icons_getInstance().dxv_1);
        var tmp_7 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(20);
        var tmp_8 = size(tmp_7, tmp$ret$8);
        Icon(tmp_6, null, tmp_8, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 432, 8);
        var tmp_9 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$9 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_9, tmp$ret$9), $composer_5, 6);
        var tmp0_text = stringResource(get_add_to_cart(string_instance), $composer_5, 0);
        var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp2_fontSize = get_sp(16);
        var tmp3_textAlign = Companion_getInstance_15().d7v_1;
        var tmp4_lineHeight = get_sp(18);
        var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp_10, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_11, null, tmp3_textAlign, tmp4_lineHeight, tmp_12, false, 0, 0, null, null, $composer_5, 1597440, 48, 258990);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$1186057841$lambda($this$Card, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C889@45136L848:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1186057841, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$1186057841.<anonymous> (CustomMugDetailsScreen.kt:889)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
      var tmp0_modifier = padding_0(tmp, tmp$ret$0);
      var tmp1_horizontalAlignment = Companion_getInstance_11().x8t_1;
      var tmp_0 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = tmp0_modifier;
      var verticalArrangement = tmp_0.mdq(tmp$ret$1);
      var horizontalAlignment = tmp1_horizontalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier = Companion_instance;
      if (!((0 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((0 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 767466084, 'C894@45422L27,896@45516L54,897@45626L10,895@45478L262,901@45807L59,900@45769L189:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
      CircularProgressIndicator(null, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_5, 0, 63);
      var tmp0_text = stringResource(get_adding_to_cart_dialog_title(string_instance), $composer_5, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp_6, null, tmp_7, null, tmp2_fontWeight, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131006);
      var tmp_11 = stringResource(get_adding_to_cart_dialog_msg_custom(string_instance), $composer_5, 0);
      var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_15 = Companion_getInstance_15().d7v_1;
      var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_17 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_11, null, tmp_12, null, tmp_13, null, null, null, tmp_14, null, tmp_15, tmp_16, tmp_17, false, 0, 0, null, null, $composer_5, 0, 0, 261118);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$_2008647815$lambda_xdyipm($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C887@44971L1053:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2008647815, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$-2008647815.<anonymous> (CustomMugDetailsScreen.kt:887)');
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = null;
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((5 & 1) === 0))
        modifier = Companion_instance;
      if (!((5 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((5 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -469942120, 'C888@45034L972:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(32);
      var tmp_1 = padding_0(tmp_0, tmp$ret$6);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(16);
      var tmp_2 = RoundedCornerShape(tmp$ret$7);
      Card(tmp_1, tmp_2, null, null, null, ComposableSingletons$CustomMugDetailsScreenKt_getInstance().x13m_1, $composer_5, 196614, 28);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$801854308$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C948@48100L29,948@48095L35:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(801854308, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$801854308.<anonymous> (CustomMugDetailsScreen.kt:948)');
      }
      var tmp = stringResource(get_ok(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt$lambda$_1479750494$lambda_qz1gq5($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C957@48478L33,956@48444L93:CustomMugDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1479750494, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$CustomMugDetailsScreenKt.lambda$-1479750494.<anonymous> (CustomMugDetailsScreen.kt:956)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugDetailsScreenKt() {
    ComposableSingletons$CustomMugDetailsScreenKt_instance = this;
    var tmp = this;
    tmp.k13m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1566901279, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$_1566901279$lambda_y3yyj3));
    var tmp_0 = this;
    tmp_0.l13m_1 = ComposableLambda$invoke$ref_5(composableLambdaInstance(229469588, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$229469588$lambda));
    var tmp_1 = this;
    tmp_1.m13m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1957655334, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$1957655334$lambda));
    var tmp_2 = this;
    tmp_2.n13m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1662301936, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$1662301936$lambda));
    var tmp_3 = this;
    tmp_3.o13m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(601390553, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$601390553$lambda));
    var tmp_4 = this;
    tmp_4.p13m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-57084358, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$_57084358$lambda_csar37));
    var tmp_5 = this;
    tmp_5.q13m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1383477287, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$_1383477287$lambda_quudu3));
    var tmp_6 = this;
    tmp_6.r13m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1282900098, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$1282900098$lambda));
    var tmp_7 = this;
    tmp_7.s13m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-151296861, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$_151296861$lambda_kcwmbu));
    var tmp_8 = this;
    tmp_8.t13m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-908834906, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$_908834906$lambda_4e5yrk));
    var tmp_9 = this;
    tmp_9.u13m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1074080664, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$_1074080664$lambda_d07h2f));
    var tmp_10 = this;
    tmp_10.v13m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(273632863, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$273632863$lambda));
    var tmp_11 = this;
    tmp_11.w13m_1 = ComposableLambda$invoke$ref_5(composableLambdaInstance(-107709443, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$_107709443$lambda_fpgnq4));
    var tmp_12 = this;
    tmp_12.x13m_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(1186057841, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$1186057841$lambda));
    var tmp_13 = this;
    tmp_13.y13m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-2008647815, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$_2008647815$lambda_xdyipm));
    var tmp_14 = this;
    tmp_14.z13m_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(801854308, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$801854308$lambda));
    var tmp_15 = this;
    tmp_15.a13n_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1479750494, false, ComposableSingletons$CustomMugDetailsScreenKt$lambda$_1479750494$lambda_qz1gq5));
  }
  var ComposableSingletons$CustomMugDetailsScreenKt_instance;
  function ComposableSingletons$CustomMugDetailsScreenKt_getInstance() {
    if (ComposableSingletons$CustomMugDetailsScreenKt_instance == null)
      new ComposableSingletons$CustomMugDetailsScreenKt();
    return ComposableSingletons$CustomMugDetailsScreenKt_instance;
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6(function_0) {
    this.b13n_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6).ka7 = function (_this__u8e3s4, $completion) {
    return this.b13n_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6).q3 = function () {
    return this.b13n_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0_6).hashCode = function () {
    return hashCode(this.q3());
  };
  function CustomMugDetailsScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function CustomMugDetailsScreen$slambda($viewModel, $product, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, resultContinuation) {
    this.k13n_1 = $viewModel;
    this.l13n_1 = $product;
    this.m13n_1 = $initialSize;
    this.n13n_1 = $initialColor;
    this.o13n_1 = $initialOptions;
    this.p13n_1 = $initialComment;
    this.q13n_1 = $initialCard;
    this.r13n_1 = $initialBox;
    this.s13n_1 = $initialCardMessage;
    this.t13n_1 = $initialCardBirthday;
    this.u13n_1 = $initialBoxMessage;
    this.v13n_1 = $initialBoxBirthday;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMugDetailsScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMugDetailsScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMugDetailsScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = delay(new Long(100, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.k13n_1.s10h().j10i(new LoadProduct_1(this.l13n_1, this.m13n_1._v, this.n13n_1._v, this.o13n_1._v, this.p13n_1._v, this.q13n_1._v, this.r13n_1._v, this.s13n_1._v, this.t13n_1._v, this.u13n_1._v, this.v13n_1._v));
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomMugDetailsScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CustomMugDetailsScreen$slambda(this.k13n_1, this.l13n_1, this.m13n_1, this.n13n_1, this.o13n_1, this.p13n_1, this.q13n_1, this.r13n_1, this.s13n_1, this.t13n_1, this.u13n_1, this.v13n_1, completion);
    i.w13n_1 = $this$LaunchedEffect;
    return i;
  };
  function CustomMugDetailsScreen$slambda_0($viewModel, $product, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, resultContinuation) {
    var i = new CustomMugDetailsScreen$slambda($viewModel, $product, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_22(function_0) {
    this.x13n_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_22).a1v = function (value, $completion) {
    return this.x13n_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_22).q3 = function () {
    return this.x13n_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_22).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_22).hashCode = function () {
    return hashCode(this.q3());
  };
  function CustomMugDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    this.g13o_1 = $snackbarHostState;
    this.h13o_1 = $onNavigateToAuth;
    this.i13o_1 = $onBack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMugDetailsScreen$slambda$slambda).f112 = function (effect, $completion) {
    var tmp = this.g112(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMugDetailsScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.f112((!(p1 == null) ? isInterface(p1, CustomProductDetailsSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMugDetailsScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp0_subject = this.j13o_1;
            if (tmp0_subject instanceof ShowMessage_4) {
              this.n9_1 = 2;
              suspendResult = this.j13o_1.i112_1.z10i(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof ShowToast_0) {
                this.n9_1 = 1;
                suspendResult = this.j13o_1.h112_1.z10i(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (equals(tmp0_subject, NavigateToAuth_instance_2)) {
                  this.k13o_1 = this.h13o_1();
                  this.n9_1 = 4;
                  continue $sm;
                } else {
                  if (equals(tmp0_subject, NavigateBack_instance_2)) {
                    this.k13o_1 = this.i13o_1();
                    this.n9_1 = 4;
                    continue $sm;
                  } else {
                    var tmp_0 = this;
                    noWhenBranchMatchedException();
                  }
                }
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            var tmp_1 = this;
            showToast(ARGUMENT);
            tmp_1.k13o_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            this.n9_1 = 3;
            suspendResult = this.g13o_1.dqm(ARGUMENT_0, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.k13o_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomMugDetailsScreen$slambda$slambda).g112 = function (effect, completion) {
    var i = new CustomMugDetailsScreen$slambda$slambda(this.g13o_1, this.h13o_1, this.i13o_1, completion);
    i.j13o_1 = effect;
    return i;
  };
  function CustomMugDetailsScreen$slambda$slambda_0($snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    var i = new CustomMugDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.f112(effect, $completion);
    }, 1);
  }
  function CustomMugDetailsScreen$slambda_1($viewModel, $snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    this.t13o_1 = $viewModel;
    this.u13o_1 = $snackbarHostState;
    this.v13o_1 = $onNavigateToAuth;
    this.w13o_1 = $onBack;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMugDetailsScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMugDetailsScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMugDetailsScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.t13o_1.s10h().t10h();
            var tmp_1 = CustomMugDetailsScreen$slambda$slambda_0(this.u13o_1, this.v13o_1, this.w13o_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_22(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomMugDetailsScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CustomMugDetailsScreen$slambda_1(this.t13o_1, this.u13o_1, this.v13o_1, this.w13o_1, completion);
    i.x13o_1 = $this$LaunchedEffect;
    return i;
  };
  function CustomMugDetailsScreen$slambda_2($viewModel, $snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation) {
    var i = new CustomMugDetailsScreen$slambda_1($viewModel, $snackbarHostState, $onNavigateToAuth, $onBack, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CustomMugDetailsScreen$slambda_3($appViewModel, $state$delegate, resultContinuation) {
    this.g13p_1 = $appViewModel;
    this.h13p_1 = $state$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMugDetailsScreen$slambda_3).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMugDetailsScreen$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMugDetailsScreen$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0;
          if (CustomMugDetailsScreen$lambda(this.h13p_1).a10z_1) {
            tmp_0 = true;
          } else {
            tmp_0 = !CustomMugDetailsScreen$lambda(this.h13p_1).g10z_1.r();
          }
          this.g13p_1.l108(tmp_0);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CustomMugDetailsScreen$slambda_3).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CustomMugDetailsScreen$slambda_3(this.g13p_1, this.h13p_1, completion);
    i.i13p_1 = $this$LaunchedEffect;
    return i;
  };
  function CustomMugDetailsScreen$slambda_4($appViewModel, $state$delegate, resultContinuation) {
    var i = new CustomMugDetailsScreen$slambda_3($appViewModel, $state$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CustomMugDetailsScreen$$inlined$cache$4$1($appViewModel) {
    this.j13p_1 = $appViewModel;
  }
  protoOf(CustomMugDetailsScreen$$inlined$cache$4$1).s1d = function () {
    this.j13p_1.l108(false);
  };
  function CustomMugDetailsScreen$lambda_0($appViewModel) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new CustomMugDetailsScreen$$inlined$cache$4$1($appViewModel);
    };
  }
  function CustomMugDetailsScreen$lambda_1($isInteractingWith3D$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isInteractingWith3D', KMutableProperty0, true);
    return $isInteractingWith3D$delegate.u1();
  }
  function CustomMugDetailsScreen$lambda_2($isInteractingWith3D$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isInteractingWith3D', KMutableProperty0, true);
    $isInteractingWith3D$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMugDetailsScreen$lambda_3($showFullScreen3D$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showFullScreen3D', KMutableProperty0, true);
    return $showFullScreen3D$delegate.u1();
  }
  function CustomMugDetailsScreen$lambda_4($showFullScreen3D$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showFullScreen3D', KMutableProperty0, true);
    $showFullScreen3D$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMugDetailsScreen$lambda_5($isMediaDialogOpen$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isMediaDialogOpen', KMutableProperty0, true);
    return $isMediaDialogOpen$delegate.u1();
  }
  function CustomMugDetailsScreen$lambda_6($isMediaDialogOpen$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isMediaDialogOpen', KMutableProperty0, true);
    $isMediaDialogOpen$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMugDetailsScreen$lambda_7($showBirthdayPicker$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    return $showBirthdayPicker$delegate.u1();
  }
  function CustomMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    $showBirthdayPicker$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMugDetailsScreen$lambda_9($birthdayPickerTargetOptionKey$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    return $birthdayPickerTargetOptionKey$delegate.u1();
  }
  function CustomMugDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    $birthdayPickerTargetOptionKey$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMugDetailsScreen$lambda_11($isPickingBoxBirthday$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    return $isPickingBoxBirthday$delegate.u1();
  }
  function CustomMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    $isPickingBoxBirthday$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMugDetailsScreen$lambda_13($showDiscardDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    return $showDiscardDialog$delegate.u1();
  }
  function CustomMugDetailsScreen$lambda_14($showDiscardDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    $showDiscardDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMugDetailsScreen$lambda_15($showFullScreen3D$delegate, $state$delegate, $showDiscardDialog$delegate) {
    return function () {
      var tmp;
      if (CustomMugDetailsScreen$lambda_3($showFullScreen3D$delegate)) {
        CustomMugDetailsScreen$lambda_4($showFullScreen3D$delegate, false);
        tmp = Unit_instance;
      } else {
        var tmp_0;
        if (CustomMugDetailsScreen$lambda($state$delegate).a10z_1) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_0 = !CustomMugDetailsScreen$lambda($state$delegate).g10z_1.r();
        }
        if (tmp_0) {
          CustomMugDetailsScreen$lambda_14($showDiscardDialog$delegate, true);
          tmp = Unit_instance;
        }
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_16($onBack, $showDiscardDialog$delegate) {
    return function () {
      CustomMugDetailsScreen$lambda_14($showDiscardDialog$delegate, false);
      $onBack();
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_17($showDiscardDialog$delegate) {
    return function () {
      CustomMugDetailsScreen$lambda_14($showDiscardDialog$delegate, false);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$slambda$slambda_1($isInteractingWith3D$delegate, resultContinuation) {
    this.s13p_1 = $isInteractingWith3D$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMugDetailsScreen$slambda$slambda_1).ic6 = function ($this$awaitPointerEventScope, $completion) {
    var tmp = this.jc6($this$awaitPointerEventScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMugDetailsScreen$slambda$slambda_1).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMugDetailsScreen$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 4;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = this.t13p_1.pa7(PointerEventPass_Initial_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var event = suspendResult;
            var tmp0 = event.ca0_1;
            var tmp$ret$0;
            l$ret$1: do {
              var tmp_0;
              if (isInterface(tmp0, Collection)) {
                tmp_0 = tmp0.r();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$0 = false;
                break l$ret$1;
              }
              var _iterator__ex2g4s = tmp0.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (element.la0_1) {
                  tmp$ret$0 = true;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = false;
            }
             while (false);
            CustomMugDetailsScreen$lambda_2(this.s13p_1, tmp$ret$0);
            this.n9_1 = 1;
            continue $sm;
          case 3:
            throw this.q9_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomMugDetailsScreen$slambda$slambda_1).jc6 = function ($this$awaitPointerEventScope, completion) {
    var i = new CustomMugDetailsScreen$slambda$slambda_1(this.s13p_1, completion);
    i.t13p_1 = $this$awaitPointerEventScope;
    return i;
  };
  function CustomMugDetailsScreen$slambda$slambda_2($isInteractingWith3D$delegate, resultContinuation) {
    var i = new CustomMugDetailsScreen$slambda$slambda_1($isInteractingWith3D$delegate, resultContinuation);
    return constructCallableReference(function ($this$awaitPointerEventScope, $completion) {
      return i.ic6($this$awaitPointerEventScope, $completion);
    }, 1);
  }
  function CustomMugDetailsScreen$slambda_5($isInteractingWith3D$delegate, resultContinuation) {
    this.c13q_1 = $isInteractingWith3D$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMugDetailsScreen$slambda_5).vc6 = function ($this$pointerInput, $completion) {
    var tmp = this.wc6($this$pointerInput, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMugDetailsScreen$slambda_5).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMugDetailsScreen$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.d13q_1.ma7(CustomMugDetailsScreen$slambda$slambda_2(this.c13q_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomMugDetailsScreen$slambda_5).wc6 = function ($this$pointerInput, completion) {
    var i = new CustomMugDetailsScreen$slambda_5(this.c13q_1, completion);
    i.d13q_1 = $this$pointerInput;
    return i;
  };
  function CustomMugDetailsScreen$slambda_6($isInteractingWith3D$delegate, resultContinuation) {
    var i = new CustomMugDetailsScreen$slambda_5($isInteractingWith3D$delegate, resultContinuation);
    return constructCallableReference(function ($this$pointerInput, $completion) {
      return i.vc6($this$pointerInput, $completion);
    }, 1);
  }
  function CustomMugDetailsScreen$lambda_18($viewModel, $product) {
    return function () {
      $viewModel.s10h().j10i(new LoadProduct_1($product));
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_19($onBack, $state$delegate, $showDiscardDialog$delegate) {
    return function () {
      var tmp;
      var tmp_0;
      if (CustomMugDetailsScreen$lambda($state$delegate).a10z_1) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_0 = !CustomMugDetailsScreen$lambda($state$delegate).g10z_1.r();
      }
      if (tmp_0) {
        CustomMugDetailsScreen$lambda_14($showDiscardDialog$delegate, true);
        tmp = Unit_instance;
      } else {
        tmp = $onBack();
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_20($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ToggleFavorite_instance_0);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_21($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C311@14447L837:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-576717763, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMugDetailsScreen.kt:311)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = padding_0(tmp_0, tmp$ret$0);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 1929017430, 'C312@14524L726:CustomMugDetailsScreen.kt#8gd4xm');
        var tmp_2 = CustomMugDetailsScreen$lambda($state$delegate).b10z_1;
        AnimatedContent(tmp_2, null, null, null, '', null, ComposableSingletons$CustomMugDetailsScreenKt_getInstance().l13m_1, $composer_5, 1597440, 46);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_22($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ShareProduct_instance_0);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_23($showFullScreen3D$delegate) {
    return function () {
      CustomMugDetailsScreen$lambda_4($showFullScreen3D$delegate, true);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_24($language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C354@16813L1040:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1109263739, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMugDetailsScreen.kt:354)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_1 = _Dp___init__impl__ms3zkb(20);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(10);
        var tmp0_modifier = padding_2(tmp_0, tmp_1, tmp$ret$1);
        var tmp1_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_2 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$2 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = tmp0_modifier;
        var horizontalArrangement = tmp_2.mdq(tmp$ret$2);
        var verticalAlignment = tmp1_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_3 = $composer_3.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 133751843, 'C363@17379L11,359@17124L317,367@17620L10,369@17765L11,365@17470L357:CustomMugDetailsScreen.kt#8gd4xm');
        var tmp_4 = get_Fullscreen(Icons_getInstance().dxv_1);
        var tmp_5 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$9 = _Dp___init__impl__ms3zkb(24);
        Icon(tmp_4, null, size(tmp_5, tmp$ret$9), MaterialTheme_instance.unz($composer_5, 6).fo0_1, $composer_5, 432, 0);
        var tmp0_text = $language === 'en' ? 'Full Show' : '\u0639\u0631\u0636 \u0643\u0627\u0645\u0644';
        var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
        var tmp2_fontWeight = Companion_getInstance_16().f7z_1;
        var tmp3_color = MaterialTheme_instance.unz($composer_5, 6).fo0_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_9 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp3_color, null, tmp_6, null, tmp2_fontWeight, null, tmp_7, null, null, tmp_8, tmp_9, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131002);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_10;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_10 = Unit_instance;
        }
        tmp = tmp_10;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_25($isMediaDialogOpen$delegate) {
    return function (it) {
      CustomMugDetailsScreen$lambda_6($isMediaDialogOpen$delegate, it);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_26($viewModel) {
    return function () {
      $viewModel.s10h().j10i(OpenEditor_instance_0);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_27($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new CardSelected_1(it instanceof Card_1 ? it : null));
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_28($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new CardMessageChanged_1(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_29($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C488@24184L10,484@23892L351:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2049383235, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMugDetailsScreen.kt:484)');
        }
        var tmp_0 = '' + CustomMugDetailsScreen$lambda($state$delegate).n10z_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_30($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CustomMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, false);
      CustomMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_31(it) {
    return Unit_instance;
  }
  function CustomMugDetailsScreen$lambda$lambda($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CustomMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, false);
      CustomMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_32($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C506@25195L174,506@25174L240:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(696069404, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMugDetailsScreen.kt:506)');
        }
        sourceInformationMarkerStart($composer_0, -1092198870, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CustomMugDetailsScreen$lambda$lambda($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$CustomMugDetailsScreenKt_getInstance().p13m_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_33($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new BoxSelected_1(it instanceof Box_0 ? it : null));
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_34($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new BoxMessageChanged_1(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_35($state$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C544@27313L10,540@27022L350:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1234463596, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMugDetailsScreen.kt:540)');
        }
        var tmp_0 = '' + CustomMugDetailsScreen$lambda($state$delegate).r10z_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, MaterialTheme_instance.jog($composer_0, 6).tof_1, $composer_0, 48, 0, 130044);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_36($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CustomMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, true);
      CustomMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_37(it) {
    return Unit_instance;
  }
  function CustomMugDetailsScreen$lambda$lambda_0($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CustomMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, true);
      CustomMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_38($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C563@28387L173,563@28366L239:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2074962693, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMugDetailsScreen.kt:563)');
        }
        sourceInformationMarkerStart($composer_0, 1174324690, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CustomMugDetailsScreen$lambda$lambda_0($isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$CustomMugDetailsScreenKt_getInstance().s13m_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_39($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new SizeSelected_1(it));
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_40($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new ColorSelected_1(it));
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_41($viewModel, $option) {
    return function (value) {
      $viewModel.s10h().j10i(new OptionSelected_1($option.r101_1, value));
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_42($viewModel, $option) {
    return function (newValue) {
      $viewModel.s10h().j10i(new OptionSelected_1($option.r101_1, newValue));
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_43($option, $birthdayPickerTargetOptionKey$delegate, $showBirthdayPicker$delegate) {
    return function () {
      CustomMugDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate, $option.r101_1);
      CustomMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_44($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 100) {
        $viewModel.s10h().j10i(new ProductCommentChanged_1(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda$lambda_1($viewModel, $state$delegate) {
    return function () {
      var tmp;
      if (CustomMugDetailsScreen$lambda($state$delegate).z10y_1 > 1) {
        $viewModel.s10h().j10i(new QuantityChanged_0(CustomMugDetailsScreen$lambda($state$delegate).z10y_1 - 1 | 0));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda$lambda_2($viewModel, $state$delegate) {
    return function () {
      $viewModel.s10h().j10i(new QuantityChanged_0(CustomMugDetailsScreen$lambda($state$delegate).z10y_1 + 1 | 0));
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda$lambda_3($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ToggleStockReminder_instance_0);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda$lambda_4($state$delegate) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C775@39323L1212:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1782919447, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMugDetailsScreen.kt:775)');
        }
        var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = null;
        var horizontalArrangement = Arrangement_getInstance().udp_1;
        var verticalAlignment = tmp0_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((1 & 1) === 0))
          modifier = Companion_instance;
        if (!((1 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((1 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -168765774, 'C779@39547L308,784@39888L39,785@39960L545:CustomMugDetailsScreen.kt#8gd4xm');
        var tmp_1 = CustomMugDetailsScreen$lambda($state$delegate).c10z_1 ? get_NotificationsActive(Icons_getInstance().dxv_1) : get_NotificationsNone(Icons_getInstance().dxv_1);
        var tmp_2 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$6 = _Dp___init__impl__ms3zkb(20);
        var tmp_3 = size(tmp_2, tmp$ret$6);
        Icon(tmp_1, null, tmp_3, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 432, 8);
        var tmp_4 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_4, tmp$ret$7), $composer_5, 6);
        var tmp_5;
        if (CustomMugDetailsScreen$lambda($state$delegate).c10z_1) {
          $composer_5.m30(-1806543494);
          sourceInformation($composer_5, '787@40072L39');
          var tmp0_group = stringResource(get_reminder_set(string_instance), $composer_5, 0);
          $composer_5.n30();
          tmp_5 = tmp0_group;
        } else {
          $composer_5.m30(-1806539625);
          sourceInformation($composer_5, '789@40193L36');
          var tmp1_group = stringResource(get_remind_me(string_instance), $composer_5, 0);
          $composer_5.n30();
          tmp_5 = tmp1_group;
        }
        var tmp0_text = tmp_5;
        var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp2_fontSize = get_sp(16);
        var tmp3_textAlign = Companion_getInstance_15().d7v_1;
        var tmp4_lineHeight = get_sp(18);
        var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_8 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp_6, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_7, null, tmp3_textAlign, tmp4_lineHeight, tmp_8, false, 0, 0, null, null, $composer_5, 1597440, 48, 258990);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_9;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_9 = Unit_instance;
        }
        tmp = tmp_9;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda$lambda_5($viewModel) {
    return function () {
      $viewModel.s10h().j10i(AddToCart_instance_1);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda$lambda$lambda($this$AnimatedContent) {
    return togetherWith(fadeIn(tween(300)), fadeOut(tween(300)));
  }
  function CustomMugDetailsScreen$lambda$lambda_6($state$delegate) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C810@41406L233,815@41681L38,808@41272L2060:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2016498528, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMugDetailsScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMugDetailsScreen.kt:808)');
        }
        var tmp_0 = CustomMugDetailsScreen$lambda($state$delegate).a10z_1;
        sourceInformationMarkerStart($composer_0, 824840393, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CustomMugDetailsScreen$lambda$lambda$lambda;
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp0_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        var tmp_2 = stringResource(get_add_to_cart(string_instance), $composer_0, 0);
        AnimatedContent(tmp_0, null, tmp0_group, null, tmp_2, null, ComposableSingletons$CustomMugDetailsScreenKt_getInstance().w13m_1, $composer_0, 1573248, 42);
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_45($activeProduct, $state$delegate, $viewModel, $language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C691@34553L8845:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-142769039, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMugDetailsScreen.<anonymous>.<anonymous> (CustomMugDetailsScreen.kt:691)');
        }
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_start = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_end = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_top = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp4_bottom = _Dp___init__impl__ms3zkb(8);
        var tmp5_modifier = fillMaxWidth(padding_1(Companion_instance, tmp1_start, tmp3_top, tmp2_end, tmp4_bottom));
        var tmp6_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_0 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$4 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = tmp5_modifier;
        var horizontalArrangement = tmp_0.mdq(tmp$ret$4);
        var verticalAlignment = tmp6_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 187030061, 'C:CustomMugDetailsScreen.kt#8gd4xm');
        var tmp2_elvis_lhs = $activeProduct.wzt_1;
        if ((tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) > 0) {
          $composer_5.m30(186932751);
          sourceInformation($composer_5, '700@35025L3294');
          var tmp0_horizontalAlignment = Companion_getInstance_11().x8t_1;
          var tmp_2 = Arrangement_getInstance();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$11 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_1 = null;
          var verticalArrangement = tmp_2.mdq(tmp$ret$11);
          var horizontalAlignment = tmp0_horizontalAlignment;
          var $composer_6 = $composer_5;
          if (!((1 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((1 & 2) === 0))
            verticalArrangement = Arrangement_getInstance().sdp_1;
          if (!((1 & 4) === 0))
            horizontalAlignment = Companion_getInstance_11().w8t_1;
          var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 432 >> 3 | 112 & 432 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_7 = $composer_6;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
          var localMap_0 = $composer_7.t31();
          var materialized_0 = materialize($composer_7, modifier_2);
          var tmp0_0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_8 = $composer_7;
          var tmp_3 = $composer_8.g30();
          if (!isInterface(tmp_3, Applier)) {
            invalidApplier();
          }
          $composer_8.b31();
          if ($composer_8.h30()) {
            $composer_8.c31(tmp0_0);
          } else {
            $composer_8.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_9 = $composer_8;
          var $composer_10 = $composer_9;
          sourceInformationMarkerStart($composer_10, 316338454, 'C708@35486L11,704@35246L2632,750@37952L45,751@38053L10,752@38130L11,749@37907L386:CustomMugDetailsScreen.kt#8gd4xm');
          var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
          var tmp_4 = Companion_instance;
          var tmp_5 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_10, 6).oo0_1, 0.5);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$18 = _Dp___init__impl__ms3zkb(12);
          var tmp_6 = background(tmp_4, tmp_5, RoundedCornerShape(tmp$ret$18));
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_7 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$20 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_3 = padding_2(tmp_6, tmp_7, tmp$ret$20);
          var horizontalArrangement_0 = null;
          var verticalAlignment_0 = tmp0_verticalAlignment;
          var $composer_11 = $composer_10;
          if (!((2 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((2 & 2) === 0))
            horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
          if (!((2 & 4) === 0))
            verticalAlignment_0 = Companion_getInstance_11().t8t_1;
          var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_11, 14 & 384 >> 3 | 112 & 384 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_8 = $composer_13.g30();
          if (!isInterface(tmp_8, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_1);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_15, 1734195943, 'C714@35840L280,713@35782L814,732@36973L11,727@36629L399,735@37119L256,734@37061L787:CustomMugDetailsScreen.kt#8gd4xm');
          sourceInformationMarkerStart($composer_15, -498247454, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = !!($composer_15.k31($state$delegate) | $composer_15.q31($viewModel));
          // Inline function 'kotlin.let' call
          var it = $composer_15.i31();
          var tmp_9;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = CustomMugDetailsScreen$lambda$lambda_1($viewModel, $state$delegate);
            $composer_15.j31(value);
            tmp_9 = value;
          } else {
            tmp_9 = it;
          }
          var tmp0_group = tmp_9;
          sourceInformationMarkerEnd($composer_15);
          var tmp_10 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$31 = _Dp___init__impl__ms3zkb(36);
          var tmp_11 = size(tmp_10, tmp$ret$31);
          IconButton(tmp0_group, tmp_11, false, null, null, null, ComposableSingletons$CustomMugDetailsScreenKt_getInstance().u13m_1, $composer_15, 1572912, 60);
          var tmp0_text = format(CustomMugDetailsScreen$lambda($state$delegate).z10y_1, $language);
          var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp2_fontSize = get_sp(18);
          var tmp_12 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$32 = _Dp___init__impl__ms3zkb(8);
          var tmp3_modifier = padding_2(tmp_12, tmp$ret$32);
          var tmp4_color = MaterialTheme_instance.unz($composer_15, 6).no0_1;
          var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_15 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, tmp3_modifier, tmp4_color, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_13, null, null, tmp_14, tmp_15, false, 0, 0, null, null, $composer_15, 1597488, 0, 262056);
          sourceInformationMarkerStart($composer_15, -498206550, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = !!($composer_15.q31($viewModel) | $composer_15.k31($state$delegate));
          // Inline function 'kotlin.let' call
          var it_0 = $composer_15.i31();
          var tmp_16;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = CustomMugDetailsScreen$lambda$lambda_2($viewModel, $state$delegate);
            $composer_15.j31(value_0);
            tmp_16 = value_0;
          } else {
            tmp_16 = it_0;
          }
          var tmp1_group = tmp_16;
          sourceInformationMarkerEnd($composer_15);
          var tmp_17 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$37 = _Dp___init__impl__ms3zkb(32);
          var tmp_18 = size(tmp_17, tmp$ret$37);
          IconButton(tmp1_group, tmp_18, false, null, null, null, ComposableSingletons$CustomMugDetailsScreenKt_getInstance().v13m_1, $composer_15, 1572912, 60);
          sourceInformationMarkerEnd($composer_15);
          $composer_13.e31();
          var tmp2_text = stringResource(get_bulk_discount_info(string_instance), $composer_10, 0);
          var tmp3_style = MaterialTheme_instance.jog($composer_10, 6).tof_1;
          var tmp4_color_0 = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
          var tmp5_fontSize = get_sp(10);
          var tmp6_fontWeight = Companion_getInstance_16().c7z_1;
          var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_21 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp2_text, null, tmp4_color_0, null, tmp5_fontSize, null, tmp6_fontWeight, null, tmp_19, null, null, tmp_20, tmp_21, false, 0, 0, null, tmp3_style, $composer_10, 1597440, 0, 130986);
          sourceInformationMarkerEnd($composer_10);
          $composer_8.e31();
          $composer_5.n30();
        } else {
          $composer_5.m30(190120109);
          $composer_5.n30();
        }
        var tmp3_elvis_lhs = $activeProduct.wzt_1;
        if ((tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) <= 0) {
          $composer_5.m30(190298204);
          sourceInformation($composer_5, '762@38526L78,767@38869L301,774@39293L1268,761@38480L2081');
          sourceInformationMarkerStart($composer_5, -1794976413, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_1 = $composer_5.q31($viewModel);
          // Inline function 'kotlin.let' call
          var it_1 = $composer_5.i31();
          var tmp_22;
          if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
            var value_1 = CustomMugDetailsScreen$lambda$lambda_3($viewModel);
            $composer_5.j31(value_1);
            tmp_22 = value_1;
          } else {
            tmp_22 = it_1;
          }
          var tmp0_group_0 = tmp_22;
          sourceInformationMarkerEnd($composer_5);
          var tmp_23 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$42 = _Dp___init__impl__ms3zkb(56);
          var tmp_24 = heightIn(tmp_23, tmp$ret$42);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$43 = _Dp___init__impl__ms3zkb(16);
          var tmp_25 = RoundedCornerShape(tmp$ret$43);
          var tmp_26 = ButtonDefaults_getInstance();
          var tmp_27;
          if (CustomMugDetailsScreen$lambda($state$delegate).c10z_1) {
            $composer_5.m30(-1794960546);
            sourceInformation($composer_5, '769@39012L11');
            var tmp1_group_0 = MaterialTheme_instance.unz($composer_5, 6).co0_1;
            $composer_5.n30();
            tmp_27 = tmp1_group_0;
          } else {
            $composer_5.m30(-1794957060);
            sourceInformation($composer_5, '771@39121L11');
            var tmp2_group = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
            $composer_5.n30();
            tmp_27 = tmp2_group;
          }
          var tmp_28 = tmp_27;
          var tmp_29 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_30 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_31 = tmp_26.ao9(tmp_28, tmp_29, tmp_30, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_32 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$45 = _Dp___init__impl__ms3zkb(8);
          var tmp_33 = PaddingValues_0(tmp_32, tmp$ret$45);
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(1782919447, true, CustomMugDetailsScreen$lambda$lambda_4($state$delegate), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_16 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_2 = $composer_16.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_2 = $composer_16.i31();
          var tmp_34;
          if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
            var value_2 = ComposableLambda$invoke$ref_1(dispatchReceiver);
            $composer_16.j31(value_2);
            tmp_34 = value_2;
          } else {
            tmp_34 = it_2;
          }
          var tmp$ret$46 = tmp_34;
          Button(tmp0_group_0, tmp_24, false, tmp_25, tmp_31, null, null, tmp_33, null, tmp$ret$46, $composer_5, 817889280, 356);
          $composer_5.n30();
        } else {
          $composer_5.m30(192460950);
          sourceInformation($composer_5, '804@41038L11,804@40994L64,799@40661L68,807@41242L2116,798@40615L2743');
          var tmp_35 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$53 = _Dp___init__impl__ms3zkb(56);
          var tmp4_modifier = heightIn(tmp_35, tmp$ret$53);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$54 = _Dp___init__impl__ms3zkb(16);
          var tmp5_shape = RoundedCornerShape(tmp$ret$54);
          var tmp_36 = ButtonDefaults_getInstance();
          var tmp_37 = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
          var tmp_38 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_39 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp6_colors = tmp_36.ao9(tmp_37, tmp_38, tmp_39, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
          var tmp7_enabled = !CustomMugDetailsScreen$lambda($state$delegate).a10z_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_40 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$56 = _Dp___init__impl__ms3zkb(4);
          var tmp8_contentPadding = PaddingValues_0(tmp_40, tmp$ret$56);
          sourceInformationMarkerStart($composer_5, -1794908103, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_3 = $composer_5.q31($viewModel);
          // Inline function 'kotlin.let' call
          var it_3 = $composer_5.i31();
          var tmp_41;
          if (invalid_3 || it_3 === Companion_getInstance().f30_1) {
            var value_3 = CustomMugDetailsScreen$lambda$lambda_5($viewModel);
            $composer_5.j31(value_3);
            tmp_41 = value_3;
          } else {
            tmp_41 = it_3;
          }
          var tmp3_group = tmp_41;
          sourceInformationMarkerEnd($composer_5);
          // Inline function 'kotlin.run' call
          var dispatchReceiver_0 = rememberComposableLambda(2016498528, true, CustomMugDetailsScreen$lambda$lambda_6($state$delegate), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_17 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_4 = $composer_17.k31(dispatchReceiver_0);
          // Inline function 'kotlin.let' call
          var it_4 = $composer_17.i31();
          var tmp_42;
          if (invalid_4 || it_4 === Companion_getInstance().f30_1) {
            var value_4 = ComposableLambda$invoke$ref_1(dispatchReceiver_0);
            $composer_17.j31(value_4);
            tmp_42 = value_4;
          } else {
            tmp_42 = it_4;
          }
          var tmp$ret$61 = tmp_42;
          Button(tmp3_group, tmp4_modifier, tmp7_enabled, tmp5_shape, tmp6_colors, null, null, tmp8_contentPadding, null, tmp$ret$61, $composer_5, 817889280, 352);
          $composer_5.n30();
        }
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_43;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_43 = Unit_instance;
        }
        tmp = tmp_43;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$slambda_7($verticalScrollState, resultContinuation) {
    this.m13q_1 = $verticalScrollState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomMugDetailsScreen$slambda_7).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomMugDetailsScreen$slambda_7).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomMugDetailsScreen$slambda_7).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.m13q_1.tg7(0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomMugDetailsScreen$slambda_7).q24 = function ($this$LaunchedEffect, completion) {
    var i = new CustomMugDetailsScreen$slambda_7(this.m13q_1, completion);
    i.n13q_1 = $this$LaunchedEffect;
    return i;
  };
  function CustomMugDetailsScreen$slambda_8($verticalScrollState, resultContinuation) {
    var i = new CustomMugDetailsScreen$slambda_7($verticalScrollState, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function CustomMugDetailsScreen$lambda_46($viewModel) {
    return function (bitmap, bytes, elements) {
      $viewModel.s10h().j10i(new CustomImageApplied_0(bitmap, bytes, elements));
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_47($viewModel) {
    return function () {
      $viewModel.s10h().j10i(CloseEditor_instance_0);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_48($viewModel, $product) {
    return function () {
      $viewModel.s10h().j10i(new LoadProduct_1($product));
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_49($showFullScreen3D$delegate) {
    return function () {
      CustomMugDetailsScreen$lambda_4($showFullScreen3D$delegate, false);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_50($viewModel, $showFullScreen3D$delegate) {
    return function () {
      CustomMugDetailsScreen$lambda_4($showFullScreen3D$delegate, false);
      $viewModel.s10h().j10i(OpenEditor_instance_0);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_51($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate) {
    return function () {
      CustomMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, false);
      CustomMugDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate, null);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda$lambda_7($birthdayPickerState, $viewModel, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      var tmp0_safe_receiver = $birthdayPickerState.np1();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var date = toLocalDateTime(Companion_getInstance_19().kf(tmp0_safe_receiver), Companion_getInstance_20().yno_1).xn9_1.toString();
        if (!(CustomMugDetailsScreen$lambda_9($birthdayPickerTargetOptionKey$delegate) == null)) {
          var key = ensureNotNull(CustomMugDetailsScreen$lambda_9($birthdayPickerTargetOptionKey$delegate));
          var selectedValue = CustomMugDetailsScreen$lambda($state$delegate).w10z_1.w2(key);
          if (!(selectedValue == null)) {
            $viewModel.s10h().j10i(new OptionSelected_1(key, selectedValue.k101(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, date)));
          }
        } else if (CustomMugDetailsScreen$lambda_11($isPickingBoxBirthday$delegate)) {
          $viewModel.s10h().j10i(new BoxBirthdayChanged_1(date));
        } else {
          $viewModel.s10h().j10i(new CardBirthdayChanged_1(date));
        }
      }
      CustomMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, false);
      CustomMugDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate, null);
      CustomMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_52($birthdayPickerState, $state$delegate, $viewModel, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C922@46488L1603,922@46467L1665:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1060639551, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMugDetailsScreen.<anonymous>.<anonymous> (CustomMugDetailsScreen.kt:922)');
        }
        sourceInformationMarkerStart($composer_0, -1367356380, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.k31($birthdayPickerState) | $composer_0.k31($state$delegate)) | $composer_0.q31($viewModel));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CustomMugDetailsScreen$lambda$lambda_7($birthdayPickerState, $viewModel, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$CustomMugDetailsScreenKt_getInstance().z13m_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda$lambda_8($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function () {
      CustomMugDetailsScreen$lambda_8($showBirthdayPicker$delegate, false);
      CustomMugDetailsScreen$lambda_10($birthdayPickerTargetOptionKey$delegate, null);
      CustomMugDetailsScreen$lambda_12($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_53($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C951@48227L189,951@48206L353:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(952722943, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMugDetailsScreen.<anonymous>.<anonymous> (CustomMugDetailsScreen.kt:951)');
        }
        sourceInformationMarkerStart($composer_0, 738715740, 'CC(remember):CustomMugDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = CustomMugDetailsScreen$lambda$lambda_8($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$CustomMugDetailsScreenKt_getInstance().a13n_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_54($birthdayPickerState) {
    return function ($this$DatePickerDialog, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C961@48594L39:CustomMugDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1859268490, $changed, -1, 'client.fstech.hadaya.presentation.product_details.CustomMugDetailsScreen.<anonymous>.<anonymous> (CustomMugDetailsScreen.kt:961)');
        }
        DatePicker($birthdayPickerState, null, null, null, null, null, false, null, $composer_0, 0, 254);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugDetailsScreen$lambda_55($product, $onBack, $onNavigateToAuth, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, $topPadding, $bottomPadding, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      CustomMugDetailsScreen($product, $onBack, $onNavigateToAuth, $initialSize._v, $initialColor._v, $initialOptions._v, $initialComment._v, $initialCard._v, $initialBox._v, $initialCardMessage._v, $initialCardBirthday._v, $initialBoxMessage._v, $initialBoxBirthday._v, $topPadding._v.m5f_1, $bottomPadding._v.m5f_1, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsState$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_LoadProduct$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_AddToCart$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_ToggleStockReminder$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_QuantityChanged$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_ToggleFavorite$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_OpenEditor$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_CloseEditor$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_CustomImageApplied$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_UpdateElements$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_RemoveCustomization$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_KindChanged$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_TargetAudienceChanged$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_CardSelected$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_CardMessageChanged$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_CardBirthdayChanged$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_BoxSelected$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_BoxMessageChanged$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_BoxBirthdayChanged$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_SizeSelected$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_ColorSelected$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_OptionSelected$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_ProductCommentChanged$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_ShareProduct$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsSideEffect_ShowMessage$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsSideEffect_ShowToast$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsSideEffect_NavigateToAuth$stable;
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsSideEffect_NavigateBack$stable;
  function CustomProductDetailsState(product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, imageBitmap, pickedImageBytes, editorElements, showEditor, loading, error, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, availableCards, availableBoxes, pendingAddToCart) {
    product = product === VOID ? null : product;
    quantity = quantity === VOID ? 1 : quantity;
    isAddingToCart = isAddingToCart === VOID ? false : isAddingToCart;
    isFavorite = isFavorite === VOID ? false : isFavorite;
    isStockReminderSet = isStockReminderSet === VOID ? false : isStockReminderSet;
    language = language === VOID ? 'en' : language;
    imageBitmap = imageBitmap === VOID ? null : imageBitmap;
    pickedImageBytes = pickedImageBytes === VOID ? null : pickedImageBytes;
    editorElements = editorElements === VOID ? emptyList() : editorElements;
    showEditor = showEditor === VOID ? false : showEditor;
    loading = loading === VOID ? false : loading;
    error = error === VOID ? null : error;
    selectedKind = selectedKind === VOID ? ProductKind_MUG_getInstance() : selectedKind;
    selectedAudience = selectedAudience === VOID ? TargetAudience_BOTH_getInstance() : selectedAudience;
    selectedCard = selectedCard === VOID ? null : selectedCard;
    cardMessage = cardMessage === VOID ? '' : cardMessage;
    cardBirthday = cardBirthday === VOID ? '' : cardBirthday;
    cardBirthdayError = cardBirthdayError === VOID ? false : cardBirthdayError;
    selectedBox = selectedBox === VOID ? null : selectedBox;
    boxMessage = boxMessage === VOID ? '' : boxMessage;
    boxBirthday = boxBirthday === VOID ? '' : boxBirthday;
    boxBirthdayError = boxBirthdayError === VOID ? false : boxBirthdayError;
    selectedSize = selectedSize === VOID ? null : selectedSize;
    selectedColor = selectedColor === VOID ? null : selectedColor;
    selectedOptions = selectedOptions === VOID ? emptyMap() : selectedOptions;
    productComment = productComment === VOID ? '' : productComment;
    availableCards = availableCards === VOID ? emptyList() : availableCards;
    availableBoxes = availableBoxes === VOID ? emptyList() : availableBoxes;
    pendingAddToCart = pendingAddToCart === VOID ? false : pendingAddToCart;
    this.y10y_1 = product;
    this.z10y_1 = quantity;
    this.a10z_1 = isAddingToCart;
    this.b10z_1 = isFavorite;
    this.c10z_1 = isStockReminderSet;
    this.d10z_1 = language;
    this.e10z_1 = imageBitmap;
    this.f10z_1 = pickedImageBytes;
    this.g10z_1 = editorElements;
    this.h10z_1 = showEditor;
    this.i10z_1 = loading;
    this.j10z_1 = error;
    this.k10z_1 = selectedKind;
    this.l10z_1 = selectedAudience;
    this.m10z_1 = selectedCard;
    this.n10z_1 = cardMessage;
    this.o10z_1 = cardBirthday;
    this.p10z_1 = cardBirthdayError;
    this.q10z_1 = selectedBox;
    this.r10z_1 = boxMessage;
    this.s10z_1 = boxBirthday;
    this.t10z_1 = boxBirthdayError;
    this.u10z_1 = selectedSize;
    this.v10z_1 = selectedColor;
    this.w10z_1 = selectedOptions;
    this.x10z_1 = productComment;
    this.y10z_1 = availableCards;
    this.z10z_1 = availableBoxes;
    this.a110_1 = pendingAddToCart;
  }
  protoOf(CustomProductDetailsState).o13q = function (product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, imageBitmap, pickedImageBytes, editorElements, showEditor, loading, error, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, availableCards, availableBoxes, pendingAddToCart) {
    return new CustomProductDetailsState(product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, imageBitmap, pickedImageBytes, editorElements, showEditor, loading, error, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, availableCards, availableBoxes, pendingAddToCart);
  };
  protoOf(CustomProductDetailsState).p13q = function (product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, imageBitmap, pickedImageBytes, editorElements, showEditor, loading, error, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, availableCards, availableBoxes, pendingAddToCart, $super) {
    product = product === VOID ? this.y10y_1 : product;
    quantity = quantity === VOID ? this.z10y_1 : quantity;
    isAddingToCart = isAddingToCart === VOID ? this.a10z_1 : isAddingToCart;
    isFavorite = isFavorite === VOID ? this.b10z_1 : isFavorite;
    isStockReminderSet = isStockReminderSet === VOID ? this.c10z_1 : isStockReminderSet;
    language = language === VOID ? this.d10z_1 : language;
    imageBitmap = imageBitmap === VOID ? this.e10z_1 : imageBitmap;
    pickedImageBytes = pickedImageBytes === VOID ? this.f10z_1 : pickedImageBytes;
    editorElements = editorElements === VOID ? this.g10z_1 : editorElements;
    showEditor = showEditor === VOID ? this.h10z_1 : showEditor;
    loading = loading === VOID ? this.i10z_1 : loading;
    error = error === VOID ? this.j10z_1 : error;
    selectedKind = selectedKind === VOID ? this.k10z_1 : selectedKind;
    selectedAudience = selectedAudience === VOID ? this.l10z_1 : selectedAudience;
    selectedCard = selectedCard === VOID ? this.m10z_1 : selectedCard;
    cardMessage = cardMessage === VOID ? this.n10z_1 : cardMessage;
    cardBirthday = cardBirthday === VOID ? this.o10z_1 : cardBirthday;
    cardBirthdayError = cardBirthdayError === VOID ? this.p10z_1 : cardBirthdayError;
    selectedBox = selectedBox === VOID ? this.q10z_1 : selectedBox;
    boxMessage = boxMessage === VOID ? this.r10z_1 : boxMessage;
    boxBirthday = boxBirthday === VOID ? this.s10z_1 : boxBirthday;
    boxBirthdayError = boxBirthdayError === VOID ? this.t10z_1 : boxBirthdayError;
    selectedSize = selectedSize === VOID ? this.u10z_1 : selectedSize;
    selectedColor = selectedColor === VOID ? this.v10z_1 : selectedColor;
    selectedOptions = selectedOptions === VOID ? this.w10z_1 : selectedOptions;
    productComment = productComment === VOID ? this.x10z_1 : productComment;
    availableCards = availableCards === VOID ? this.y10z_1 : availableCards;
    availableBoxes = availableBoxes === VOID ? this.z10z_1 : availableBoxes;
    pendingAddToCart = pendingAddToCart === VOID ? this.a110_1 : pendingAddToCart;
    return $super === VOID ? this.o13q(product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, imageBitmap, pickedImageBytes, editorElements, showEditor, loading, error, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, availableCards, availableBoxes, pendingAddToCart) : $super.o13q.call(this, product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, imageBitmap, pickedImageBytes, editorElements, showEditor, loading, error, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, availableCards, availableBoxes, pendingAddToCart);
  };
  protoOf(CustomProductDetailsState).toString = function () {
    return 'CustomProductDetailsState(product=' + toString_0(this.y10y_1) + ', quantity=' + this.z10y_1 + ', isAddingToCart=' + this.a10z_1 + ', isFavorite=' + this.b10z_1 + ', isStockReminderSet=' + this.c10z_1 + ', language=' + this.d10z_1 + ', imageBitmap=' + toString_0(this.e10z_1) + ', pickedImageBytes=' + toString_0(this.f10z_1) + ', editorElements=' + toString(this.g10z_1) + ', showEditor=' + this.h10z_1 + ', loading=' + this.i10z_1 + ', error=' + toString_0(this.j10z_1) + ', selectedKind=' + this.k10z_1.toString() + ', selectedAudience=' + this.l10z_1.toString() + ', selectedCard=' + toString_0(this.m10z_1) + ', cardMessage=' + this.n10z_1 + ', cardBirthday=' + this.o10z_1 + ', cardBirthdayError=' + this.p10z_1 + ', selectedBox=' + toString_0(this.q10z_1) + ', boxMessage=' + this.r10z_1 + ', boxBirthday=' + this.s10z_1 + ', boxBirthdayError=' + this.t10z_1 + ', selectedSize=' + this.u10z_1 + ', selectedColor=' + this.v10z_1 + ', selectedOptions=' + toString(this.w10z_1) + ', productComment=' + this.x10z_1 + ', availableCards=' + toString(this.y10z_1) + ', availableBoxes=' + toString(this.z10z_1) + ', pendingAddToCart=' + this.a110_1 + ')';
  };
  protoOf(CustomProductDetailsState).hashCode = function () {
    var result = this.y10y_1 == null ? 0 : this.y10y_1.hashCode();
    result = imul(result, 31) + this.z10y_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a10z_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b10z_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c10z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d10z_1) | 0;
    result = imul(result, 31) + (this.e10z_1 == null ? 0 : hashCode(this.e10z_1)) | 0;
    result = imul(result, 31) + (this.f10z_1 == null ? 0 : hashCode(this.f10z_1)) | 0;
    result = imul(result, 31) + hashCode(this.g10z_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h10z_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i10z_1) | 0;
    result = imul(result, 31) + (this.j10z_1 == null ? 0 : hashCode(this.j10z_1)) | 0;
    result = imul(result, 31) + this.k10z_1.hashCode() | 0;
    result = imul(result, 31) + this.l10z_1.hashCode() | 0;
    result = imul(result, 31) + (this.m10z_1 == null ? 0 : this.m10z_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.n10z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o10z_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p10z_1) | 0;
    result = imul(result, 31) + (this.q10z_1 == null ? 0 : this.q10z_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.r10z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s10z_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t10z_1) | 0;
    result = imul(result, 31) + (this.u10z_1 == null ? 0 : getStringHashCode(this.u10z_1)) | 0;
    result = imul(result, 31) + (this.v10z_1 == null ? 0 : getStringHashCode(this.v10z_1)) | 0;
    result = imul(result, 31) + hashCode(this.w10z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x10z_1) | 0;
    result = imul(result, 31) + hashCode(this.y10z_1) | 0;
    result = imul(result, 31) + hashCode(this.z10z_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a110_1) | 0;
    return result;
  };
  protoOf(CustomProductDetailsState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CustomProductDetailsState))
      return false;
    if (!equals(this.y10y_1, other.y10y_1))
      return false;
    if (!(this.z10y_1 === other.z10y_1))
      return false;
    if (!(this.a10z_1 === other.a10z_1))
      return false;
    if (!(this.b10z_1 === other.b10z_1))
      return false;
    if (!(this.c10z_1 === other.c10z_1))
      return false;
    if (!(this.d10z_1 === other.d10z_1))
      return false;
    if (!equals(this.e10z_1, other.e10z_1))
      return false;
    if (!equals(this.f10z_1, other.f10z_1))
      return false;
    if (!equals(this.g10z_1, other.g10z_1))
      return false;
    if (!(this.h10z_1 === other.h10z_1))
      return false;
    if (!(this.i10z_1 === other.i10z_1))
      return false;
    if (!equals(this.j10z_1, other.j10z_1))
      return false;
    if (!this.k10z_1.equals(other.k10z_1))
      return false;
    if (!this.l10z_1.equals(other.l10z_1))
      return false;
    if (!equals(this.m10z_1, other.m10z_1))
      return false;
    if (!(this.n10z_1 === other.n10z_1))
      return false;
    if (!(this.o10z_1 === other.o10z_1))
      return false;
    if (!(this.p10z_1 === other.p10z_1))
      return false;
    if (!equals(this.q10z_1, other.q10z_1))
      return false;
    if (!(this.r10z_1 === other.r10z_1))
      return false;
    if (!(this.s10z_1 === other.s10z_1))
      return false;
    if (!(this.t10z_1 === other.t10z_1))
      return false;
    if (!(this.u10z_1 == other.u10z_1))
      return false;
    if (!(this.v10z_1 == other.v10z_1))
      return false;
    if (!equals(this.w10z_1, other.w10z_1))
      return false;
    if (!(this.x10z_1 === other.x10z_1))
      return false;
    if (!equals(this.y10z_1, other.y10z_1))
      return false;
    if (!equals(this.z10z_1, other.z10z_1))
      return false;
    if (!(this.a110_1 === other.a110_1))
      return false;
    return true;
  };
  function LoadProduct_1(product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday) {
    initialSize = initialSize === VOID ? null : initialSize;
    initialColor = initialColor === VOID ? null : initialColor;
    initialOptions = initialOptions === VOID ? null : initialOptions;
    initialComment = initialComment === VOID ? null : initialComment;
    initialCard = initialCard === VOID ? null : initialCard;
    initialBox = initialBox === VOID ? null : initialBox;
    initialCardMessage = initialCardMessage === VOID ? null : initialCardMessage;
    initialCardBirthday = initialCardBirthday === VOID ? null : initialCardBirthday;
    initialBoxMessage = initialBoxMessage === VOID ? null : initialBoxMessage;
    initialBoxBirthday = initialBoxBirthday === VOID ? null : initialBoxBirthday;
    this.q13q_1 = product;
    this.r13q_1 = initialSize;
    this.s13q_1 = initialColor;
    this.t13q_1 = initialOptions;
    this.u13q_1 = initialComment;
    this.v13q_1 = initialCard;
    this.w13q_1 = initialBox;
    this.x13q_1 = initialCardMessage;
    this.y13q_1 = initialCardBirthday;
    this.z13q_1 = initialBoxMessage;
    this.a13r_1 = initialBoxBirthday;
  }
  protoOf(LoadProduct_1).toString = function () {
    return 'LoadProduct(product=' + this.q13q_1.toString() + ', initialSize=' + this.r13q_1 + ', initialColor=' + this.s13q_1 + ', initialOptions=' + toString_0(this.t13q_1) + ', initialComment=' + this.u13q_1 + ', initialCard=' + toString_0(this.v13q_1) + ', initialBox=' + toString_0(this.w13q_1) + ', initialCardMessage=' + this.x13q_1 + ', initialCardBirthday=' + this.y13q_1 + ', initialBoxMessage=' + this.z13q_1 + ', initialBoxBirthday=' + this.a13r_1 + ')';
  };
  protoOf(LoadProduct_1).hashCode = function () {
    var result = this.q13q_1.hashCode();
    result = imul(result, 31) + (this.r13q_1 == null ? 0 : getStringHashCode(this.r13q_1)) | 0;
    result = imul(result, 31) + (this.s13q_1 == null ? 0 : getStringHashCode(this.s13q_1)) | 0;
    result = imul(result, 31) + (this.t13q_1 == null ? 0 : hashCode(this.t13q_1)) | 0;
    result = imul(result, 31) + (this.u13q_1 == null ? 0 : getStringHashCode(this.u13q_1)) | 0;
    result = imul(result, 31) + (this.v13q_1 == null ? 0 : this.v13q_1.hashCode()) | 0;
    result = imul(result, 31) + (this.w13q_1 == null ? 0 : this.w13q_1.hashCode()) | 0;
    result = imul(result, 31) + (this.x13q_1 == null ? 0 : getStringHashCode(this.x13q_1)) | 0;
    result = imul(result, 31) + (this.y13q_1 == null ? 0 : getStringHashCode(this.y13q_1)) | 0;
    result = imul(result, 31) + (this.z13q_1 == null ? 0 : getStringHashCode(this.z13q_1)) | 0;
    result = imul(result, 31) + (this.a13r_1 == null ? 0 : getStringHashCode(this.a13r_1)) | 0;
    return result;
  };
  protoOf(LoadProduct_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadProduct_1))
      return false;
    if (!this.q13q_1.equals(other.q13q_1))
      return false;
    if (!(this.r13q_1 == other.r13q_1))
      return false;
    if (!(this.s13q_1 == other.s13q_1))
      return false;
    if (!equals(this.t13q_1, other.t13q_1))
      return false;
    if (!(this.u13q_1 == other.u13q_1))
      return false;
    if (!equals(this.v13q_1, other.v13q_1))
      return false;
    if (!equals(this.w13q_1, other.w13q_1))
      return false;
    if (!(this.x13q_1 == other.x13q_1))
      return false;
    if (!(this.y13q_1 == other.y13q_1))
      return false;
    if (!(this.z13q_1 == other.z13q_1))
      return false;
    if (!(this.a13r_1 == other.a13r_1))
      return false;
    return true;
  };
  function AddToCart_1() {
  }
  protoOf(AddToCart_1).toString = function () {
    return 'AddToCart';
  };
  protoOf(AddToCart_1).hashCode = function () {
    return -1609603370;
  };
  protoOf(AddToCart_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddToCart_1))
      return false;
    return true;
  };
  var AddToCart_instance_1;
  function AddToCart_getInstance_1() {
    return AddToCart_instance_1;
  }
  function ToggleStockReminder_1() {
  }
  protoOf(ToggleStockReminder_1).toString = function () {
    return 'ToggleStockReminder';
  };
  protoOf(ToggleStockReminder_1).hashCode = function () {
    return 2030477518;
  };
  protoOf(ToggleStockReminder_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ToggleStockReminder_1))
      return false;
    return true;
  };
  var ToggleStockReminder_instance_0;
  function ToggleStockReminder_getInstance_0() {
    return ToggleStockReminder_instance_0;
  }
  function QuantityChanged_0(quantity) {
    this.b13r_1 = quantity;
  }
  protoOf(QuantityChanged_0).toString = function () {
    return 'QuantityChanged(quantity=' + this.b13r_1 + ')';
  };
  protoOf(QuantityChanged_0).hashCode = function () {
    return this.b13r_1;
  };
  protoOf(QuantityChanged_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof QuantityChanged_0))
      return false;
    if (!(this.b13r_1 === other.b13r_1))
      return false;
    return true;
  };
  function ToggleFavorite_2() {
  }
  protoOf(ToggleFavorite_2).toString = function () {
    return 'ToggleFavorite';
  };
  protoOf(ToggleFavorite_2).hashCode = function () {
    return 434040502;
  };
  protoOf(ToggleFavorite_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ToggleFavorite_2))
      return false;
    return true;
  };
  var ToggleFavorite_instance_0;
  function ToggleFavorite_getInstance_0() {
    return ToggleFavorite_instance_0;
  }
  function OpenEditor_0() {
  }
  protoOf(OpenEditor_0).toString = function () {
    return 'OpenEditor';
  };
  protoOf(OpenEditor_0).hashCode = function () {
    return 847458557;
  };
  protoOf(OpenEditor_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OpenEditor_0))
      return false;
    return true;
  };
  var OpenEditor_instance_0;
  function OpenEditor_getInstance_0() {
    return OpenEditor_instance_0;
  }
  function CloseEditor_0() {
  }
  protoOf(CloseEditor_0).toString = function () {
    return 'CloseEditor';
  };
  protoOf(CloseEditor_0).hashCode = function () {
    return -1951610465;
  };
  protoOf(CloseEditor_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CloseEditor_0))
      return false;
    return true;
  };
  var CloseEditor_instance_0;
  function CloseEditor_getInstance_0() {
    return CloseEditor_instance_0;
  }
  function CustomImageApplied_0(bitmap, bytes, elements) {
    this.c13r_1 = bitmap;
    this.d13r_1 = bytes;
    this.e13r_1 = elements;
  }
  protoOf(CustomImageApplied_0).toString = function () {
    return 'CustomImageApplied(bitmap=' + toString(this.c13r_1) + ', bytes=' + toString(this.d13r_1) + ', elements=' + toString(this.e13r_1) + ')';
  };
  protoOf(CustomImageApplied_0).hashCode = function () {
    var result = hashCode(this.c13r_1);
    result = imul(result, 31) + hashCode(this.d13r_1) | 0;
    result = imul(result, 31) + hashCode(this.e13r_1) | 0;
    return result;
  };
  protoOf(CustomImageApplied_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CustomImageApplied_0))
      return false;
    if (!equals(this.c13r_1, other.c13r_1))
      return false;
    if (!equals(this.d13r_1, other.d13r_1))
      return false;
    if (!equals(this.e13r_1, other.e13r_1))
      return false;
    return true;
  };
  function UpdateElements_0() {
  }
  function RemoveCustomization_0() {
  }
  protoOf(RemoveCustomization_0).toString = function () {
    return 'RemoveCustomization';
  };
  protoOf(RemoveCustomization_0).hashCode = function () {
    return 2117817289;
  };
  protoOf(RemoveCustomization_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemoveCustomization_0))
      return false;
    return true;
  };
  var RemoveCustomization_instance_0;
  function RemoveCustomization_getInstance_0() {
    return RemoveCustomization_instance_0;
  }
  function KindChanged_0() {
  }
  function TargetAudienceChanged_0() {
  }
  function CardSelected_1(card) {
    this.f13r_1 = card;
  }
  protoOf(CardSelected_1).toString = function () {
    return 'CardSelected(card=' + toString_0(this.f13r_1) + ')';
  };
  protoOf(CardSelected_1).hashCode = function () {
    return this.f13r_1 == null ? 0 : this.f13r_1.hashCode();
  };
  protoOf(CardSelected_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CardSelected_1))
      return false;
    if (!equals(this.f13r_1, other.f13r_1))
      return false;
    return true;
  };
  function CardMessageChanged_1(message) {
    this.g13r_1 = message;
  }
  protoOf(CardMessageChanged_1).toString = function () {
    return 'CardMessageChanged(message=' + this.g13r_1 + ')';
  };
  protoOf(CardMessageChanged_1).hashCode = function () {
    return getStringHashCode(this.g13r_1);
  };
  protoOf(CardMessageChanged_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CardMessageChanged_1))
      return false;
    if (!(this.g13r_1 === other.g13r_1))
      return false;
    return true;
  };
  function CardBirthdayChanged_1(birthday) {
    this.h13r_1 = birthday;
  }
  protoOf(CardBirthdayChanged_1).toString = function () {
    return 'CardBirthdayChanged(birthday=' + this.h13r_1 + ')';
  };
  protoOf(CardBirthdayChanged_1).hashCode = function () {
    return getStringHashCode(this.h13r_1);
  };
  protoOf(CardBirthdayChanged_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CardBirthdayChanged_1))
      return false;
    if (!(this.h13r_1 === other.h13r_1))
      return false;
    return true;
  };
  function BoxSelected_1(box) {
    this.i13r_1 = box;
  }
  protoOf(BoxSelected_1).toString = function () {
    return 'BoxSelected(box=' + toString_0(this.i13r_1) + ')';
  };
  protoOf(BoxSelected_1).hashCode = function () {
    return this.i13r_1 == null ? 0 : this.i13r_1.hashCode();
  };
  protoOf(BoxSelected_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxSelected_1))
      return false;
    if (!equals(this.i13r_1, other.i13r_1))
      return false;
    return true;
  };
  function BoxMessageChanged_1(message) {
    this.j13r_1 = message;
  }
  protoOf(BoxMessageChanged_1).toString = function () {
    return 'BoxMessageChanged(message=' + this.j13r_1 + ')';
  };
  protoOf(BoxMessageChanged_1).hashCode = function () {
    return getStringHashCode(this.j13r_1);
  };
  protoOf(BoxMessageChanged_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxMessageChanged_1))
      return false;
    if (!(this.j13r_1 === other.j13r_1))
      return false;
    return true;
  };
  function BoxBirthdayChanged_1(birthday) {
    this.k13r_1 = birthday;
  }
  protoOf(BoxBirthdayChanged_1).toString = function () {
    return 'BoxBirthdayChanged(birthday=' + this.k13r_1 + ')';
  };
  protoOf(BoxBirthdayChanged_1).hashCode = function () {
    return getStringHashCode(this.k13r_1);
  };
  protoOf(BoxBirthdayChanged_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxBirthdayChanged_1))
      return false;
    if (!(this.k13r_1 === other.k13r_1))
      return false;
    return true;
  };
  function SizeSelected_1(size) {
    this.l13r_1 = size;
  }
  protoOf(SizeSelected_1).toString = function () {
    return 'SizeSelected(size=' + this.l13r_1 + ')';
  };
  protoOf(SizeSelected_1).hashCode = function () {
    return this.l13r_1 == null ? 0 : getStringHashCode(this.l13r_1);
  };
  protoOf(SizeSelected_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeSelected_1))
      return false;
    if (!(this.l13r_1 == other.l13r_1))
      return false;
    return true;
  };
  function ColorSelected_1(color) {
    this.m13r_1 = color;
  }
  protoOf(ColorSelected_1).toString = function () {
    return 'ColorSelected(color=' + this.m13r_1 + ')';
  };
  protoOf(ColorSelected_1).hashCode = function () {
    return this.m13r_1 == null ? 0 : getStringHashCode(this.m13r_1);
  };
  protoOf(ColorSelected_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorSelected_1))
      return false;
    if (!(this.m13r_1 == other.m13r_1))
      return false;
    return true;
  };
  function OptionSelected_1(key, value) {
    this.n13r_1 = key;
    this.o13r_1 = value;
  }
  protoOf(OptionSelected_1).toString = function () {
    return 'OptionSelected(key=' + this.n13r_1 + ', value=' + toString_0(this.o13r_1) + ')';
  };
  protoOf(OptionSelected_1).hashCode = function () {
    var result = getStringHashCode(this.n13r_1);
    result = imul(result, 31) + (this.o13r_1 == null ? 0 : this.o13r_1.hashCode()) | 0;
    return result;
  };
  protoOf(OptionSelected_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OptionSelected_1))
      return false;
    if (!(this.n13r_1 === other.n13r_1))
      return false;
    if (!equals(this.o13r_1, other.o13r_1))
      return false;
    return true;
  };
  function ProductCommentChanged_1(comment) {
    this.p13r_1 = comment;
  }
  protoOf(ProductCommentChanged_1).toString = function () {
    return 'ProductCommentChanged(comment=' + this.p13r_1 + ')';
  };
  protoOf(ProductCommentChanged_1).hashCode = function () {
    return getStringHashCode(this.p13r_1);
  };
  protoOf(ProductCommentChanged_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductCommentChanged_1))
      return false;
    if (!(this.p13r_1 === other.p13r_1))
      return false;
    return true;
  };
  function ShareProduct_0() {
  }
  protoOf(ShareProduct_0).toString = function () {
    return 'ShareProduct';
  };
  protoOf(ShareProduct_0).hashCode = function () {
    return 2134972214;
  };
  protoOf(ShareProduct_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShareProduct_0))
      return false;
    return true;
  };
  var ShareProduct_instance_0;
  function ShareProduct_getInstance_0() {
    return ShareProduct_instance_0;
  }
  function CustomProductDetailsIntent() {
  }
  function ShowMessage_4(message) {
    this.i112_1 = message;
  }
  protoOf(ShowMessage_4).toString = function () {
    return 'ShowMessage(message=' + toString(this.i112_1) + ')';
  };
  protoOf(ShowMessage_4).hashCode = function () {
    return hashCode(this.i112_1);
  };
  protoOf(ShowMessage_4).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowMessage_4))
      return false;
    if (!equals(this.i112_1, other.i112_1))
      return false;
    return true;
  };
  function ShowToast_0(message) {
    this.h112_1 = message;
  }
  protoOf(ShowToast_0).toString = function () {
    return 'ShowToast(message=' + toString(this.h112_1) + ')';
  };
  protoOf(ShowToast_0).hashCode = function () {
    return hashCode(this.h112_1);
  };
  protoOf(ShowToast_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowToast_0))
      return false;
    if (!equals(this.h112_1, other.h112_1))
      return false;
    return true;
  };
  function NavigateToAuth_2() {
  }
  protoOf(NavigateToAuth_2).toString = function () {
    return 'NavigateToAuth';
  };
  protoOf(NavigateToAuth_2).hashCode = function () {
    return 4953742;
  };
  protoOf(NavigateToAuth_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateToAuth_2))
      return false;
    return true;
  };
  var NavigateToAuth_instance_2;
  function NavigateToAuth_getInstance_2() {
    return NavigateToAuth_instance_2;
  }
  function NavigateBack_2() {
  }
  protoOf(NavigateBack_2).toString = function () {
    return 'NavigateBack';
  };
  protoOf(NavigateBack_2).hashCode = function () {
    return -304453774;
  };
  protoOf(NavigateBack_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateBack_2))
      return false;
    return true;
  };
  var NavigateBack_instance_2;
  function NavigateBack_getInstance_2() {
    return NavigateBack_instance_2;
  }
  function CustomProductDetailsSideEffect() {
  }
  var client_fstech_hadaya_presentation_product_details_CustomProductDetailsViewModel$stable;
  function CustomProductDetailsViewModel$observeLanguage$slambda$slambda$lambda($language) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, $language);
    };
  }
  function CustomProductDetailsViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation) {
    this.y13r_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$observeLanguage$slambda$slambda).pyo = function (language, $completion) {
    var tmp = this.um9(language, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$observeLanguage$slambda$slambda).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$observeLanguage$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.y13r_1.x10k(CustomProductDetailsViewModel$observeLanguage$slambda$slambda$lambda(this.z13r_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$observeLanguage$slambda$slambda).um9 = function (language, completion) {
    var i = new CustomProductDetailsViewModel$observeLanguage$slambda$slambda(this.y13r_1, completion);
    i.z13r_1 = language;
    return i;
  };
  function CustomProductDetailsViewModel$observeLanguage$slambda$slambda_0(this$0, resultContinuation) {
    var i = new CustomProductDetailsViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (language, $completion) {
      return i.pyo(language, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$observeCurrentUser$slambda$slambda$lambda($this$updateState) {
    return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, false);
  }
  function CustomProductDetailsViewModel$observeCurrentUser$slambda$slambda(this$0, resultContinuation) {
    this.i13s_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$observeCurrentUser$slambda$slambda).t10u = function (user, $completion) {
    var tmp = this.u10u(user, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$observeCurrentUser$slambda$slambda).ja = function (p1, $completion) {
    return this.t10u((p1 == null ? true : p1 instanceof Profile) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$observeCurrentUser$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (!(this.j13s_1 == null) && this.i13s_1.s10h().ajg().u1().a110_1) {
              this.i13s_1.x10k(CustomProductDetailsViewModel$observeCurrentUser$slambda$slambda$lambda);
              this.n9_1 = 1;
              suspendResult = handleAddToCart_0(this.i13s_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$observeCurrentUser$slambda$slambda).u10u = function (user, completion) {
    var i = new CustomProductDetailsViewModel$observeCurrentUser$slambda$slambda(this.i13s_1, completion);
    i.j13s_1 = user;
    return i;
  };
  function CustomProductDetailsViewModel$observeCurrentUser$slambda$slambda_0(this$0, resultContinuation) {
    var i = new CustomProductDetailsViewModel$observeCurrentUser$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (user, $completion) {
      return i.t10u(user, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$observeFavorite$slambda$slambda$lambda($isFavorite) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, $isFavorite);
    };
  }
  function CustomProductDetailsViewModel$observeFavorite$slambda$slambda(this$0, resultContinuation) {
    this.s13s_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$observeFavorite$slambda$slambda).xf4 = function (isFavorite, $completion) {
    var tmp = this.yf4(isFavorite, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$observeFavorite$slambda$slambda).ja = function (p1, $completion) {
    return this.xf4((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$observeFavorite$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.s13s_1.x10k(CustomProductDetailsViewModel$observeFavorite$slambda$slambda$lambda(this.t13s_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$observeFavorite$slambda$slambda).yf4 = function (isFavorite, completion) {
    var i = new CustomProductDetailsViewModel$observeFavorite$slambda$slambda(this.s13s_1, completion);
    i.t13s_1 = isFavorite;
    return i;
  };
  function CustomProductDetailsViewModel$observeFavorite$slambda$slambda_0(this$0, resultContinuation) {
    var i = new CustomProductDetailsViewModel$observeFavorite$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (isFavorite, $completion) {
      return i.xf4(isFavorite, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$observeStockReminder$slambda$slambda$lambda($isSet) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, $isSet);
    };
  }
  function CustomProductDetailsViewModel$observeStockReminder$slambda$slambda(this$0, resultContinuation) {
    this.c13t_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$observeStockReminder$slambda$slambda).xf4 = function (isSet, $completion) {
    var tmp = this.yf4(isSet, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$observeStockReminder$slambda$slambda).ja = function (p1, $completion) {
    return this.xf4((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$observeStockReminder$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.c13t_1.x10k(CustomProductDetailsViewModel$observeStockReminder$slambda$slambda$lambda(this.d13t_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$observeStockReminder$slambda$slambda).yf4 = function (isSet, completion) {
    var i = new CustomProductDetailsViewModel$observeStockReminder$slambda$slambda(this.c13t_1, completion);
    i.d13t_1 = isSet;
    return i;
  };
  function CustomProductDetailsViewModel$observeStockReminder$slambda$slambda_0(this$0, resultContinuation) {
    var i = new CustomProductDetailsViewModel$observeStockReminder$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (isSet, $completion) {
      return i.xf4(isSet, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$handleIntent$slambda$lambda($activeProduct, $cards, $boxes) {
    return function ($this$updateState) {
      return $this$updateState.p13q($activeProduct, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $cards, $boxes);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$slambda$slambda($bytes, resultContinuation) {
    this.m13t_1 = $bytes;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda$slambda).o13t = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda$slambda).ja = function (p1, $completion) {
    return this.o13t((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return resize(decodeToImageBitmap(this.m13t_1), 2048);
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda$slambda).q24 = function ($this$withContext, completion) {
    var i = new CustomProductDetailsViewModel$handleIntent$slambda$slambda(this.m13t_1, completion);
    i.n13t_1 = $this$withContext;
    return i;
  };
  function CustomProductDetailsViewModel$handleIntent$slambda$slambda_0($bytes, resultContinuation) {
    var i = new CustomProductDetailsViewModel$handleIntent$slambda$slambda($bytes, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.o13t($this$withContext, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$handleIntent$slambda$lambda_0($newElements) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $newElements, true, false);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$slambda$lambda_1($this$updateState) {
    return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true, false);
  }
  function CustomProductDetailsViewModel$handleAddToCart$slambda$slambda($hasCustomization, $state, $currentProduct, resultContinuation) {
    this.x13t_1 = $hasCustomization;
    this.y13t_1 = $state;
    this.z13t_1 = $currentProduct;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$handleAddToCart$slambda$slambda).x12l = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$handleAddToCart$slambda$slambda).ja = function (p1, $completion) {
    return this.x12l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$handleAddToCart$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0;
          if (this.x13t_1) {
            var this_0 = this.y13t_1.g10z_1;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              var tmp0_id = item.z12f_1;
              var tmp1_imageBytes = item.i12g_1 == null ? toByteArray(resize(item.a12g_1, 1024)) : null;
              var this_1 = item.b12g_1;
              var value = _Offset___get_packedValue__impl__xh2k8q(this_1);
              var bits = convertToInt(shiftRight(value, 32));
              var tmp2_x = floatFromBits(bits);
              var this_2 = item.b12g_1;
              var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_2);
              var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
              var tmp3_y = floatFromBits(bits_0);
              var tmp4_scaleX = item.c12g_1;
              var tmp5_scaleY = item.d12g_1;
              var tmp6_rotation = item.e12g_1;
              var tmp7_filter = item.f12g_1.z_1;
              var tmp8_flipX = item.g12g_1;
              var tmp9_flipY = item.h12g_1;
              var tmp10_text = item.i12g_1;
              var tmp11_textColor = fromInt(toArgb(item.j12g_1));
              var tmp12_fontFamily = item.k12g_1;
              var tmp13_width = item.a12g_1.h5e();
              var tmp14_height = item.a12g_1.i5e();
              destination.j1(new DesignLayer(tmp0_id, '', tmp2_x, tmp3_y, tmp4_scaleX, tmp5_scaleY, tmp6_rotation, tmp7_filter, tmp8_flipX, tmp9_flipY, tmp10_text, tmp11_textColor, tmp12_fontFamily, tmp1_imageBytes, VOID, tmp13_width, tmp14_height));
            }
            tmp_0 = destination;
          } else {
            tmp_0 = this.z13t_1.fzu_1;
          }
          return tmp_0;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$handleAddToCart$slambda$slambda).q24 = function ($this$withContext, completion) {
    var i = new CustomProductDetailsViewModel$handleAddToCart$slambda$slambda(this.x13t_1, this.y13t_1, this.z13t_1, completion);
    i.a13u_1 = $this$withContext;
    return i;
  };
  function CustomProductDetailsViewModel$handleAddToCart$slambda$slambda_0($hasCustomization, $state, $currentProduct, resultContinuation) {
    var i = new CustomProductDetailsViewModel$handleAddToCart$slambda$slambda($hasCustomization, $state, $currentProduct, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.x12l($this$withContext, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$handleAddToCart$slambda$slambda_1($state, resultContinuation) {
    this.j13u_1 = $state;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$handleAddToCart$slambda$slambda_1).l13u = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$handleAddToCart$slambda$slambda_1).ja = function (p1, $completion) {
    return this.l13u((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$handleAddToCart$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0;
          if (!this.j13u_1.g10z_1.r()) {
            tmp_0 = toByteArray(resize(createSimpleSnapshot(this.j13u_1.g10z_1), 1024));
          } else {
            tmp_0 = this.j13u_1.f10z_1;
          }
          return tmp_0;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$handleAddToCart$slambda$slambda_1).q24 = function ($this$withContext, completion) {
    var i = new CustomProductDetailsViewModel$handleAddToCart$slambda$slambda_1(this.j13u_1, completion);
    i.k13u_1 = $this$withContext;
    return i;
  };
  function CustomProductDetailsViewModel$handleAddToCart$slambda$slambda_2($state, resultContinuation) {
    var i = new CustomProductDetailsViewModel$handleAddToCart$slambda$slambda_1($state, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.l13u($this$withContext, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$handleAddToCart$slambda$lambda($this$updateState) {
    var tmp0_editorElements = emptyList();
    var tmp1_selectedOptions = emptyMap();
    return $this$updateState.p13q(VOID, VOID, false, VOID, VOID, VOID, null, null, tmp0_editorElements, VOID, VOID, VOID, VOID, VOID, null, '', '', false, null, VOID, VOID, VOID, null, null, tmp1_selectedOptions, '');
  }
  function CustomProductDetailsViewModel$handleAddToCart$slambda$lambda_0($this$updateState) {
    return $this$updateState.p13q(VOID, VOID, false);
  }
  function observeLanguage_7($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, CustomProductDetailsViewModel$observeLanguage$slambda_0($this, null));
  }
  function observeCurrentUser_0($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, CustomProductDetailsViewModel$observeCurrentUser$slambda_0($this, null));
  }
  function observeFavorite_0($this, productId) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, CustomProductDetailsViewModel$observeFavorite$slambda_0($this, productId, null));
  }
  function observeStockReminder_0($this, productId) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, CustomProductDetailsViewModel$observeStockReminder$slambda_0($this, productId, null));
  }
  function handleAddToCart_0($this, $completion) {
    var tmp = new $handleAddToCartCOROUTINE$_0($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function recompositeInitialDesign_0($this, elements) {
    var result = createSimpleSnapshot(elements);
    $this.x10k(CustomProductDetailsViewModel$recompositeInitialDesign$lambda(result));
  }
  function CustomProductDetailsViewModel$observeLanguage$slambda(this$0, resultContinuation) {
    this.g13v_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$observeLanguage$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$observeLanguage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$observeLanguage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.g13v_1.o13v_1.y103();
            var action = CustomProductDetailsViewModel$observeLanguage$slambda$slambda_0(this.g13v_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$observeLanguage$slambda).q24 = function ($this$launch, completion) {
    var i = new CustomProductDetailsViewModel$observeLanguage$slambda(this.g13v_1, completion);
    i.h13v_1 = $this$launch;
    return i;
  };
  function CustomProductDetailsViewModel$observeLanguage$slambda_0(this$0, resultContinuation) {
    var i = new CustomProductDetailsViewModel$observeLanguage$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$observeCurrentUser$slambda(this$0, resultContinuation) {
    this.f13w_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$observeCurrentUser$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$observeCurrentUser$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$observeCurrentUser$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.f13w_1.w13v_1.oyv();
            var action = CustomProductDetailsViewModel$observeCurrentUser$slambda$slambda_0(this.f13w_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$observeCurrentUser$slambda).q24 = function ($this$launch, completion) {
    var i = new CustomProductDetailsViewModel$observeCurrentUser$slambda(this.f13w_1, completion);
    i.g13w_1 = $this$launch;
    return i;
  };
  function CustomProductDetailsViewModel$observeCurrentUser$slambda_0(this$0, resultContinuation) {
    var i = new CustomProductDetailsViewModel$observeCurrentUser$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$observeFavorite$slambda(this$0, $productId, resultContinuation) {
    this.p13w_1 = this$0;
    this.q13w_1 = $productId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$observeFavorite$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$observeFavorite$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$observeFavorite$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.p13w_1.p13v_1.tz6(this.q13w_1);
            suspendResult = collectLatest(tmp_0, CustomProductDetailsViewModel$observeFavorite$slambda$slambda_0(this.p13w_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$observeFavorite$slambda).q24 = function ($this$launch, completion) {
    var i = new CustomProductDetailsViewModel$observeFavorite$slambda(this.p13w_1, this.q13w_1, completion);
    i.r13w_1 = $this$launch;
    return i;
  };
  function CustomProductDetailsViewModel$observeFavorite$slambda_0(this$0, $productId, resultContinuation) {
    var i = new CustomProductDetailsViewModel$observeFavorite$slambda(this$0, $productId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$observeStockReminder$slambda(this$0, $productId, resultContinuation) {
    this.a13x_1 = this$0;
    this.b13x_1 = $productId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$observeStockReminder$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$observeStockReminder$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$observeStockReminder$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.a13x_1.u13v_1.czr(this.b13x_1);
            suspendResult = collectLatest(tmp_0, CustomProductDetailsViewModel$observeStockReminder$slambda$slambda_0(this.a13x_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$observeStockReminder$slambda).q24 = function ($this$launch, completion) {
    var i = new CustomProductDetailsViewModel$observeStockReminder$slambda(this.a13x_1, this.b13x_1, completion);
    i.c13x_1 = $this$launch;
    return i;
  };
  function CustomProductDetailsViewModel$observeStockReminder$slambda_0(this$0, $productId, resultContinuation) {
    var i = new CustomProductDetailsViewModel$observeStockReminder$slambda(this$0, $productId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$handleIntent$lambda($product, $intent) {
    return function ($this$updateState) {
      var tmp0_elvis_lhs = $product.bzu_1;
      var tmp8_selectedKind = tmp0_elvis_lhs == null ? ProductKind_MUG_getInstance() : tmp0_elvis_lhs;
      var tmp1_elvis_lhs = $product.izu_1;
      var tmp9_selectedAudience = tmp1_elvis_lhs == null ? TargetAudience_BOTH_getInstance() : tmp1_elvis_lhs;
      var tmp10_editorElements = emptyList();
      var tmp11_selectedSize = $intent.r13q_1;
      var tmp12_selectedColor = $intent.s13q_1;
      var tmp2_elvis_lhs = $intent.t13q_1;
      var tmp13_selectedOptions = tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs;
      var tmp3_elvis_lhs = $intent.u13q_1;
      var tmp14_productComment = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      var tmp15_selectedCard = $intent.v13q_1;
      var tmp16_selectedBox = $intent.w13q_1;
      var tmp4_elvis_lhs = $intent.x13q_1;
      var tmp17_cardMessage = tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = $intent.y13q_1;
      var tmp18_cardBirthday = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
      var tmp6_elvis_lhs = $intent.z13q_1;
      var tmp19_boxMessage = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
      var tmp7_elvis_lhs = $intent.a13r_1;
      var tmp20_boxBirthday = tmp7_elvis_lhs == null ? '' : tmp7_elvis_lhs;
      var tmp21_availableCards = emptyList();
      var tmp22_availableBoxes = emptyList();
      return $this$updateState.p13q($product, VOID, VOID, VOID, VOID, VOID, null, null, tmp10_editorElements, VOID, true, null, tmp8_selectedKind, tmp9_selectedAudience, tmp15_selectedCard, tmp17_cardMessage, tmp18_cardBirthday, false, tmp16_selectedBox, tmp19_boxMessage, tmp20_boxBirthday, false, tmp11_selectedSize, tmp12_selectedColor, tmp13_selectedOptions, tmp14_productComment, tmp21_availableCards, tmp22_availableBoxes);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$slambda(this$0, $product, resultContinuation) {
    this.l13x_1 = this$0;
    this.m13x_1 = $product;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            var currentUser = this.l13x_1.n13v_1.ynu();
            this.n9_1 = 1;
            var tmp0_elvis_lhs = this.m13x_1.nzt_1;
            var tmp_0 = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
            suspendResult = this.l13x_1.v13v_1.zzk(tmp_0, currentUser == null ? null : currentUser.uym_1, getPlatform().m(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            var tmp2_elvis_lhs = this.m13x_1.nzt_1;
            suspendResult = this.l13x_1.v13v_1.yzi(tmp2_elvis_lhs == null ? new Long(0, 0) : tmp2_elvis_lhs, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var fullProduct = suspendResult;
            var tmp_1 = this;
            tmp_1.p13x_1 = fullProduct == null ? this.m13x_1 : fullProduct;
            var tmp_2;
            var this_0 = this.p13x_1.jzu_1;
            if (!(this_0 == null || this_0.r())) {
              tmp_2 = true;
            } else {
              var this_1 = this.p13x_1.kzu_1;
              tmp_2 = !(this_1 == null || this_1.r());
            }

            if (tmp_2) {
              var this_2 = this.p13x_1.jzu_1;
              if (!(this_2 == null || this_2.r())) {
                this.n9_1 = 3;
                suspendResult = this.l13x_1.v13v_1.xzk(this.p13x_1.jzu_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.r13x_1 = emptyList();
                this.n9_1 = 4;
                continue $sm;
              }
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 3:
            var tmp_3 = this;
            var tmp0 = suspendResult;
            var destination = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s = tmp0.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              if (!element.nyz_1) {
                destination.j1(element);
              }
            }

            tmp_3.r13x_1 = destination;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.o13x_1 = this.r13x_1;
            var this_3 = this.p13x_1.kzu_1;
            if (!(this_3 == null || this_3.r())) {
              this.n9_1 = 5;
              suspendResult = this.l13x_1.v13v_1.yzk(this.p13x_1.kzu_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.q13x_1 = emptyList();
              this.n9_1 = 6;
              continue $sm;
            }

          case 5:
            var tmp_4 = this;
            var tmp0_0 = suspendResult;
            var destination_0 = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s_0 = tmp0_0.t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              if (!element_0.yyz_1) {
                destination_0.j1(element_0);
              }
            }

            tmp_4.q13x_1 = destination_0;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var boxes = this.q13x_1;
            this.l13x_1.x10k(CustomProductDetailsViewModel$handleIntent$slambda$lambda(this.p13x_1, this.o13x_1, boxes));
            this.n9_1 = 7;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda).q24 = function ($this$launch, completion) {
    var i = new CustomProductDetailsViewModel$handleIntent$slambda(this.l13x_1, this.m13x_1, completion);
    i.n13x_1 = $this$launch;
    return i;
  };
  function CustomProductDetailsViewModel$handleIntent$slambda_0(this$0, $product, resultContinuation) {
    var i = new CustomProductDetailsViewModel$handleIntent$slambda(this$0, $product, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$handleIntent$slambda_1($product, this$0, resultContinuation) {
    this.a13y_1 = $product;
    this.b13y_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda_1).p13y = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda_1).ja = function (p1, $completion) {
    return this.p13y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 16;
            var tmp0_safe_receiver = this.a13y_1.gzu_1;
            if (tmp0_safe_receiver == null) {
              this.n13y_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              if (this.b13y_1.s13v_1.fz1().u1()) {
                this.n9_1 = 1;
                suspendResult = this.b13y_1.q13v_1.h106(tmp0_safe_receiver, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.o13y_1 = null;
                this.n9_1 = 2;
                continue $sm;
              }
            }

          case 1:
            var tmp0_safe_receiver_0 = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (tmp0_safe_receiver_0 == null) {
              tmp_1 = null;
            } else {
              tmp_1 = decodeToImageBitmap(tmp0_safe_receiver_0);
            }

            tmp_0.o13y_1 = tmp_1;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n13y_1 = this.o13y_1;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.f13y_1 = this.n13y_1;
            var tmp1_safe_receiver = this.a13y_1.fzu_1;
            if (tmp1_safe_receiver == null) {
              this.g13y_1 = null;
              this.n9_1 = 10;
              continue $sm;
            } else {
              this.h13y_1 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp1_safe_receiver, 10));
              this.m13y_1 = tmp1_safe_receiver.t();
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            if (!this.m13y_1.u()) {
              this.n9_1 = 9;
              continue $sm;
            }

            var item = this.m13y_1.v();
            this.i13y_1 = item;
            if (this.i13y_1.byy_1 == null) {
              var tmp0_safe_receiver_1 = this.i13y_1.eyy_1;
              var tmp_2;
              if (tmp0_safe_receiver_1 == null) {
                tmp_2 = null;
              } else {
                tmp_2 = decodeToImageBitmap(tmp0_safe_receiver_1);
              }
              var tmp1_elvis_lhs = tmp_2;
              if (tmp1_elvis_lhs == null) {
                var tmp_3;
                var this_0 = this.i13y_1.syx_1;
                if (charSequenceLength(this_0) > 0) {
                  tmp_3 = this.b13y_1.s13v_1.fz1().u1();
                } else {
                  tmp_3 = false;
                }
                if (tmp_3) {
                  this.n9_1 = 5;
                  suspendResult = this.b13y_1.q13v_1.h106(this.i13y_1.syx_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.l13y_1 = null;
                  this.n9_1 = 6;
                  continue $sm;
                }
              } else {
                this.k13y_1 = tmp1_elvis_lhs;
                this.n9_1 = 7;
                continue $sm;
              }
            } else {
              var tmp_4 = this;
              tmp_4.j13y_1 = null;
              this.n9_1 = 8;
              continue $sm;
            }

          case 5:
            var tmp2_safe_receiver = suspendResult;
            var tmp_5 = this;
            var tmp_6;
            if (tmp2_safe_receiver == null) {
              tmp_6 = null;
            } else {
              tmp_6 = decodeToImageBitmap(tmp2_safe_receiver);
            }

            tmp_5.l13y_1 = tmp_6;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.k13y_1 = this.l13y_1;
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.j13y_1 = this.k13y_1;
            this.n9_1 = 8;
            continue $sm;
          case 8:
            var tmp3_elvis_lhs = this.j13y_1;
            var bitmap = tmp3_elvis_lhs == null ? ImageBitmap(coerceAtLeast(this.i13y_1.gyy_1, 1), coerceAtLeast(this.i13y_1.hyy_1, 1)) : tmp3_elvis_lhs;
            var tmp0 = this.i13y_1.tyx_1;
            var val2 = this.i13y_1.uyx_1;
            var v1 = fromInt(toRawBits(tmp0));
            var v2 = fromInt(toRawBits(val2));
            var tmp_7 = _Offset___init__impl__c168vi(bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0))));
            var tmp0_0 = get_entries_0();
            var tmp$ret$0 = Unit_instance;
            l$ret$1: do {
              var _iterator__ex2g4s = tmp0_0.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (element.z_1 === this.i13y_1.yyx_1) {
                  tmp$ret$0 = element;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = null;
            }
             while (false);
            var tmp4_elvis_lhs = tmp$ret$0;
            var tmp_8 = tmp4_elvis_lhs == null ? FilterType_None_getInstance() : tmp4_elvis_lhs;
            var tmp5_elvis_lhs = this.i13y_1.cyy_1;
            var this_1 = tmp5_elvis_lhs == null ? new Long(-16777216, 0) : tmp5_elvis_lhs;
            var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(this_1));
            var tmp6_elvis_lhs = this.i13y_1.dyy_1;
            var ARGUMENT = new EditorImageElement(this.i13y_1.ryx_1, bitmap, tmp_7, this.i13y_1.vyx_1, this.i13y_1.wyx_1, this.i13y_1.xyx_1, tmp_8, this.i13y_1.zyx_1, this.i13y_1.ayy_1, this.i13y_1.byy_1, tmp_9, tmp6_elvis_lhs == null ? 'Default' : tmp6_elvis_lhs, !(this.i13y_1.byy_1 == null));
            this.h13y_1.j1(ARGUMENT);
            this.n9_1 = 4;
            continue $sm;
          case 9:
            this.g13y_1 = this.h13y_1;
            this.n9_1 = 10;
            continue $sm;
          case 10:
            var tmp2_elvis_lhs = this.g13y_1;
            this.e13y_1 = tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
            this.d13y_1 = null;
            var tmp0_1 = this.e13y_1;
            var tmp$ret$2;
            l$ret$3: do {
              var tmp_10;
              if (isInterface(tmp0_1, Collection)) {
                tmp_10 = tmp0_1.r();
              } else {
                tmp_10 = false;
              }
              if (tmp_10) {
                tmp$ret$2 = false;
                break l$ret$3;
              }
              var _iterator__ex2g4s_0 = tmp0_1.t();
              while (_iterator__ex2g4s_0.u()) {
                var element_0 = _iterator__ex2g4s_0.v();
                if (element_0.i12g_1 == null && !element_0.l12g_1) {
                  tmp$ret$2 = true;
                  break l$ret$3;
                }
              }
              tmp$ret$2 = false;
            }
             while (false);
            var hasImageElements = tmp$ret$2;
            var tmp_11;
            if (this.f13y_1 == null && !hasImageElements) {
              var this_2 = this.a13y_1.ozu_1;
              tmp_11 = !(this_2 == null || this_2.r());
            } else {
              tmp_11 = false;
            }

            if (tmp_11) {
              var tmp0_2 = this.a13y_1.ozu_1;
              var tmp$ret$4;
              l$ret$5: do {
                var _iterator__ex2g4s_1 = tmp0_2.t();
                while (_iterator__ex2g4s_1.u()) {
                  var element_1 = _iterator__ex2g4s_1.v();
                  if (!isBlank(element_1)) {
                    tmp$ret$4 = element_1;
                    break l$ret$5;
                  }
                }
                tmp$ret$4 = null;
              }
               while (false);
              var templateUrl = tmp$ret$4;
              if (!(templateUrl == null) && this.b13y_1.s13v_1.fz1().u1()) {
                this.o9_1 = 12;
                this.n9_1 = 11;
                suspendResult = this.b13y_1.q13v_1.h106(templateUrl, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 14;
                continue $sm;
              }
            } else {
              this.n9_1 = 15;
              continue $sm;
            }

          case 11:
            var tmp3_safe_receiver = suspendResult;
            var tmp_12 = this;
            var tmp_13;
            if (tmp3_safe_receiver == null) {
              tmp_13 = null;
            } else {
              tmp_13 = decodeToImageBitmap(tmp3_safe_receiver);
            }

            tmp_12.d13y_1 = tmp_13;
            this.o9_1 = 16;
            this.n9_1 = 13;
            continue $sm;
          case 12:
            this.o9_1 = 16;
            var tmp_14 = this.q9_1;
            if (tmp_14 instanceof Exception) {
              var e = this.q9_1;
              println('error showing templates: ' + e.message);
              this.n9_1 = 13;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 13:
            this.o9_1 = 16;
            this.n9_1 = 14;
            continue $sm;
          case 14:
            this.n9_1 = 15;
            continue $sm;
          case 15:
            return new Triple(this.f13y_1, this.e13y_1, this.d13y_1);
          case 16:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 16) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda_1).q24 = function ($this$withContext, completion) {
    var i = new CustomProductDetailsViewModel$handleIntent$slambda_1(this.a13y_1, this.b13y_1, completion);
    i.c13y_1 = $this$withContext;
    return i;
  };
  function CustomProductDetailsViewModel$handleIntent$slambda_2($product, this$0, resultContinuation) {
    var i = new CustomProductDetailsViewModel$handleIntent$slambda_1($product, this$0, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.p13y($this$withContext, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_0($finalImageBitmap, $restoredElements) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, $finalImageBitmap, VOID, $restoredElements, VOID, false);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_1($e) {
    return function ($this$updateState) {
      var tmp0_safe_receiver = $e.message;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = new DynamicString(tmp0_safe_receiver);
      }
      var tmp1_elvis_lhs = tmp;
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, false, tmp1_elvis_lhs == null ? new ResourceString(get_failed_load_product_design(string_instance), []) : tmp1_elvis_lhs);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$slambda_3(this$0, $productId, resultContinuation) {
    this.y13y_1 = this$0;
    this.z13y_1 = $productId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda_3).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.y13y_1.t13v_1.vdf(this.z13y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.y13y_1.d10l(new ShowMessage_4(new DynamicString('Reminder updated')), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.n9_1 = 4;
              suspendResult = this.y13y_1.d10l(new ShowMessage_4(new DynamicString('Failed to update reminder')), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda_3).q24 = function ($this$launch, completion) {
    var i = new CustomProductDetailsViewModel$handleIntent$slambda_3(this.y13y_1, this.z13y_1, completion);
    i.a13z_1 = $this$launch;
    return i;
  };
  function CustomProductDetailsViewModel$handleIntent$slambda_4(this$0, $productId, resultContinuation) {
    var i = new CustomProductDetailsViewModel$handleIntent$slambda_3(this$0, $productId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_2($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, $intent.b13r_1);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_3($this$updateState) {
    return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function CustomProductDetailsViewModel$handleIntent$slambda_5($templates, this$0, resultContinuation) {
    this.j13z_1 = $templates;
    this.k13z_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda_5).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda_5).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            var tmp_0 = this;
            tmp_0.m13z_1 = ArrayList_init_$Create$_0();
            this.o9_1 = 7;
            this.p13z_1 = this.j13z_1.t();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!this.p13z_1.u()) {
              this.n9_1 = 6;
              continue $sm;
            }

            this.o13z_1 = this.p13z_1.v();
            if (isBlank(this.o13z_1)) {
              this.n9_1 = 1;
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            suspendResult = this.k13z_1.q13v_1.h106(this.o13z_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp0_elvis_lhs = suspendResult;
            if (tmp0_elvis_lhs == null) {
              this.n9_1 = 1;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.n13z_1 = tmp0_elvis_lhs;
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            var bytes = this.n13z_1;
            this.n9_1 = 5;
            var tmp_2 = Dispatchers_getInstance().i1h_1;
            suspendResult = withContext(tmp_2, CustomProductDetailsViewModel$handleIntent$slambda$slambda_0(bytes, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var bitmap = suspendResult;
            var designWidth = 2100.0;
            var designHeight = 950.0;
            var scaleX = designWidth / bitmap.h5e();
            var scaleY = designHeight / bitmap.i5e();
            var tmp1_id = Default_getInstance_0().ci();
            var tmp2_position = Companion_getInstance_24().g5d_1;
            this.m13z_1.j1(new EditorImageElement(tmp1_id, bitmap, tmp2_position, scaleX, scaleY));
            this.n9_1 = 1;
            continue $sm;
          case 6:
            this.k13z_1.x10k(CustomProductDetailsViewModel$handleIntent$slambda$lambda_0(this.m13z_1));
            if (!this.m13z_1.r()) {
              recompositeInitialDesign_0(this.k13z_1, this.m13z_1);
            }

            this.o9_1 = 8;
            this.n9_1 = 9;
            continue $sm;
          case 7:
            this.o9_1 = 8;
            var tmp_3 = this.q9_1;
            if (tmp_3 instanceof Exception) {
              var e = this.q9_1;
              this.k13z_1.x10k(CustomProductDetailsViewModel$handleIntent$slambda$lambda_1);
              this.n9_1 = 9;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 8:
            throw this.q9_1;
          case 9:
            this.o9_1 = 8;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 8) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$handleIntent$slambda_5).q24 = function ($this$launch, completion) {
    var i = new CustomProductDetailsViewModel$handleIntent$slambda_5(this.j13z_1, this.k13z_1, completion);
    i.l13z_1 = $this$launch;
    return i;
  };
  function CustomProductDetailsViewModel$handleIntent$slambda_6($templates, this$0, resultContinuation) {
    var i = new CustomProductDetailsViewModel$handleIntent$slambda_5($templates, this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_4($this$updateState) {
    return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_5($this$updateState) {
    return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, false);
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_6($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, $intent.c13r_1, $intent.d13r_1, $intent.e13r_1, false);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_7($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.q13z_1);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_8($this$updateState) {
    var tmp0_editorElements = emptyList();
    return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, null, null, tmp0_editorElements);
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_9($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.r13z_1);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_10($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.s13z_1);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_11($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.f13r_1);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_12($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.g13r_1);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_13($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.h13r_1, false);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_14($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.i13r_1);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_15($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.j13r_1);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_16($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.k13r_1, false);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_17($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.l13r_1);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_18($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.m13r_1);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_19(this$0, $intent) {
    return function ($this$updateState) {
      var currentOptions = toMutableMap(this$0.s10h().ajg().u1().w10z_1);
      if ($intent.o13r_1 == null) {
        currentOptions.a3($intent.n13r_1);
      } else {
        var valueWithGroup = $intent.o13r_1;
        // Inline function 'kotlin.collections.set' call
        var key = $intent.n13r_1;
        currentOptions.z2(key, valueWithGroup);
      }
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, currentOptions);
    };
  }
  function CustomProductDetailsViewModel$handleIntent$lambda_20($intent) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.p13r_1);
    };
  }
  function CustomProductDetailsViewModel$handleAddToCart$lambda($this$updateState) {
    return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function CustomProductDetailsViewModel$handleAddToCart$lambda_0($this$updateState) {
    return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function CustomProductDetailsViewModel$handleAddToCart$lambda_1($this$updateState) {
    return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function CustomProductDetailsViewModel$handleAddToCart$lambda_2($this$updateState) {
    return $this$updateState.p13q(VOID, VOID, true);
  }
  function CustomProductDetailsViewModel$handleAddToCart$slambda($currentUser, $state, this$0, $currentProduct, resultContinuation) {
    this.b140_1 = $currentUser;
    this.c140_1 = $state;
    this.d140_1 = this$0;
    this.e140_1 = $currentProduct;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CustomProductDetailsViewModel$handleAddToCart$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel$handleAddToCart$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CustomProductDetailsViewModel$handleAddToCart$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            this.o9_1 = 9;
            this.g140_1 = this.b140_1.uym_1;
            var tmp_0;
            if (!(this.c140_1.f10z_1 == null)) {
              tmp_0 = true;
            } else {
              tmp_0 = !this.c140_1.g10z_1.r();
            }

            var hasCustomization = tmp_0;
            this.n9_1 = 1;
            var tmp_1 = Dispatchers_getInstance().i1h_1;
            suspendResult = withContext(tmp_1, CustomProductDetailsViewModel$handleAddToCart$slambda$slambda_0(hasCustomization, this.c140_1, this.e140_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.h140_1 = suspendResult;
            this.n9_1 = 2;
            var tmp_2 = Dispatchers_getInstance().i1h_1;
            suspendResult = withContext(tmp_2, CustomProductDetailsViewModel$handleAddToCart$slambda$slambda_2(this.c140_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.i140_1 = suspendResult;
            if (!(this.i140_1 == null) && this.d140_1.s13v_1.fz1().u1()) {
              this.o9_1 = 4;
              var fileName = 'custom_designs/' + this.g140_1 + '/design_' + randomUUID() + '.png';
              this.n9_1 = 3;
              suspendResult = this.d140_1.r13v_1.k105(this.i140_1, fileName, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_3 = this;
              tmp_3.j140_1 = null;
              this.n9_1 = 6;
              continue $sm;
            }

          case 3:
            this.k140_1 = suspendResult;
            this.o9_1 = 9;
            this.n9_1 = 5;
            continue $sm;
          case 4:
            this.o9_1 = 9;
            var tmp_4 = this.q9_1;
            if (tmp_4 instanceof Exception) {
              var e = this.q9_1;
              var tmp_5 = this;
              tmp_5.k140_1 = null;
              this.n9_1 = 5;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 5:
            this.o9_1 = 9;
            this.j140_1 = this.k140_1;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var customImageUrl = this.j140_1;
            var tmp0_safe_receiver = this.c140_1.m10z_1;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lyz_1;
            var tmp_6 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
            var tmp2_safe_receiver = this.c140_1.q10z_1;
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.wyz_1;
            var tmp_7 = tmp_6 + (tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs);
            var sum = 0;
            var _iterator__ex2g4s = this.c140_1.w10z_1.y2().t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              var tmp_8 = sum;
              var tmp0_elvis_lhs = element.q100_1;
              sum = tmp_8 + (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
            }

            var extraOriginalPrice = tmp_7 + sum;
            var tmp4_safe_receiver = this.c140_1.m10z_1;
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.lyz_1;
            var tmp_9 = tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs;
            var tmp6_safe_receiver = this.c140_1.q10z_1;
            var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.wyz_1;
            var tmp_10 = tmp_9 + (tmp7_elvis_lhs == null ? 0.0 : tmp7_elvis_lhs);
            var sum_0 = 0;
            var _iterator__ex2g4s_0 = this.c140_1.w10z_1.y2().t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              var tmp_11 = sum_0;
              var tmp_12;
              var tmp0_elvis_lhs_0 = element_0.r100_1;
              if ((tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0) > 0.0) {
                tmp_12 = ensureNotNull(element_0.r100_1);
              } else {
                var tmp1_elvis_lhs_0 = element_0.q100_1;
                tmp_12 = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
              }
              sum_0 = tmp_11 + tmp_12;
            }

            var extraDiscountedPrice = tmp_10 + sum_0;
            var tmp8_elvis_lhs = this.e140_1.szt_1;
            var finalPrice = (tmp8_elvis_lhs == null ? 0.0 : tmp8_elvis_lhs) + extraOriginalPrice;
            var tmp_13;
            var tmp9_elvis_lhs = this.e140_1.tzt_1;
            if ((tmp9_elvis_lhs == null ? 0.0 : tmp9_elvis_lhs) > 0.0) {
              tmp_13 = true;
            } else {
              var tmp0 = this.c140_1.w10z_1.y2();
              var tmp$ret$0;
              l$ret$1: do {
                var tmp_14;
                if (isInterface(tmp0, Collection)) {
                  tmp_14 = tmp0.r();
                } else {
                  tmp_14 = false;
                }
                if (tmp_14) {
                  tmp$ret$0 = false;
                  break l$ret$1;
                }
                var _iterator__ex2g4s_1 = tmp0.t();
                while (_iterator__ex2g4s_1.u()) {
                  var element_1 = _iterator__ex2g4s_1.v();
                  var tmp0_elvis_lhs_1 = element_1.r100_1;
                  if ((tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1) > 0.0) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                }
                tmp$ret$0 = false;
              }
               while (false);
              tmp_13 = tmp$ret$0;
            }

            var hasAnyDiscount = tmp_13;
            var tmp_15;
            if (hasAnyDiscount) {
              var tmp_16;
              var tmp10_elvis_lhs = this.e140_1.tzt_1;
              if ((tmp10_elvis_lhs == null ? 0.0 : tmp10_elvis_lhs) > 0.0) {
                tmp_16 = ensureNotNull(this.e140_1.tzt_1);
              } else {
                var tmp11_elvis_lhs = this.e140_1.szt_1;
                tmp_16 = tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs;
              }
              tmp_15 = tmp_16 + extraDiscountedPrice;
            } else {
              tmp_15 = 0.0;
            }

            var finalDiscount = tmp_15;
            this.n9_1 = 7;
            var tmp25_id = randomUUID();
            var tmp26_productId = this.e140_1.nzt_1;
            var tmp12_elvis_lhs = this.e140_1.ozt_1;
            var tmp27_nameEnglish = tmp12_elvis_lhs == null ? 'Unknown' : tmp12_elvis_lhs;
            var tmp13_elvis_lhs = this.e140_1.pzt_1;
            var tmp28_nameArabic = tmp13_elvis_lhs == null ? 'Unknown' : tmp13_elvis_lhs;
            var tmp14_elvis_lhs = this.e140_1.qzt_1;
            var tmp29_descriptionEnglish = tmp14_elvis_lhs == null ? 'Unknown' : tmp14_elvis_lhs;
            var tmp15_elvis_lhs = this.e140_1.rzt_1;
            var tmp30_descriptionArabic = tmp15_elvis_lhs == null ? 'Unknown' : tmp15_elvis_lhs;
            var tmp16_elvis_lhs = this.e140_1.uzt_1;
            var tmp31_discountPercent = tmp16_elvis_lhs == null ? 0.0 : tmp16_elvis_lhs;
            var tmp17_elvis_lhs = this.e140_1.vzt_1;
            var tmp32_rating = tmp17_elvis_lhs == null ? 0.0 : tmp17_elvis_lhs;
            var tmp18_elvis_lhs = this.e140_1.wzt_1;
            var tmp33_stock = tmp18_elvis_lhs == null ? 0 : tmp18_elvis_lhs;
            var tmp34_imageUrl = this.e140_1.xzt_1;
            var tmp35_videoUrl = this.e140_1.yzt_1;
            var tmp36_createdAt = this.e140_1.zzt_1;
            var tmp37_quantity = this.c140_1.z10y_1;
            var tmp38_customImageBytes = customImageUrl == null ? this.i140_1 : null;
            var tmp39_kind = this.c140_1.k10z_1;
            var tmp40_category = toString_0(this.e140_1.czu_1);
            var tmp19_elvis_lhs = this.e140_1.dzu_1;
            var tmp41_categoryNameEnglish = tmp19_elvis_lhs == null ? '' : tmp19_elvis_lhs;
            var tmp20_elvis_lhs = this.e140_1.ezu_1;
            var tmp42_categoryNameArabic = tmp20_elvis_lhs == null ? '' : tmp20_elvis_lhs;
            var tmp43_targetAudience = this.c140_1.l10z_1;
            var tmp44_selectedCard = this.c140_1.m10z_1;
            var tmp_17;
            var tmp21_safe_receiver = this.c140_1.m10z_1;
            if ((tmp21_safe_receiver == null ? null : tmp21_safe_receiver.oyz_1) === true) {
              tmp_17 = this.c140_1.n10z_1;
            } else {
              tmp_17 = null;
            }

            var tmp45_cardMessage = tmp_17;
            var tmp_18;
            var tmp22_safe_receiver = this.c140_1.m10z_1;
            if ((tmp22_safe_receiver == null ? null : tmp22_safe_receiver.pyz_1) === true) {
              tmp_18 = this.c140_1.o10z_1;
            } else {
              tmp_18 = null;
            }

            var tmp46_cardBirthday = tmp_18;
            var tmp47_selectedBox = this.c140_1.q10z_1;
            var tmp_19;
            var tmp23_safe_receiver = this.c140_1.q10z_1;
            if ((tmp23_safe_receiver == null ? null : tmp23_safe_receiver.zyz_1) === true) {
              tmp_19 = this.c140_1.r10z_1;
            } else {
              tmp_19 = null;
            }

            var tmp48_boxMessage = tmp_19;
            var tmp_20;
            var tmp24_safe_receiver = this.c140_1.q10z_1;
            if ((tmp24_safe_receiver == null ? null : tmp24_safe_receiver.az0_1) === true) {
              tmp_20 = this.c140_1.s10z_1;
            } else {
              tmp_20 = null;
            }

            var tmp49_boxBirthday = tmp_20;
            var tmp50_selectedSize = this.c140_1.u10z_1;
            var tmp51_selectedColor = this.c140_1.v10z_1;
            var this_0 = this.c140_1.w10z_1;
            var tmp_21;
            if (this_0.r()) {
              tmp_21 = null;
            } else {
              tmp_21 = this_0;
            }

            var tmp52_selectedOptions = tmp_21;
            var this_1 = this.c140_1.x10z_1;
            var tmp_22;
            if (!isBlank(this_1)) {
              tmp_22 = this_1;
            } else {
              tmp_22 = null;
            }

            var tmp53_productComment = tmp_22;
            var tmp54_isKids = this.e140_1.rzu_1;
            var tmp55_isYouth = this.e140_1.szu_1;
            var tmp56_isOld = this.e140_1.tzu_1;
            suspendResult = this.d140_1.m13v_1.c103(new CartItem(tmp25_id, tmp26_productId, tmp27_nameEnglish, tmp28_nameArabic, tmp29_descriptionEnglish, tmp30_descriptionArabic, finalPrice, finalDiscount, tmp31_discountPercent, tmp32_rating, tmp33_stock, tmp34_imageUrl, tmp37_quantity, customImageUrl, this.h140_1, this.g140_1, tmp36_createdAt, tmp35_videoUrl, tmp38_customImageBytes, tmp39_kind, tmp40_category, tmp41_categoryNameEnglish, tmp42_categoryNameArabic, tmp43_targetAudience, tmp44_selectedCard, tmp45_cardMessage, tmp46_cardBirthday, tmp47_selectedBox, tmp48_boxMessage, tmp49_boxBirthday, tmp50_selectedSize, tmp51_selectedColor, tmp52_selectedOptions, tmp53_productComment, tmp54_isKids, tmp55_isYouth, tmp56_isOld), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.d140_1.x10k(CustomProductDetailsViewModel$handleAddToCart$slambda$lambda);
            this.n9_1 = 8;
            suspendResult = this.d140_1.d10l(new ShowToast_0(new ResourceString(get_added_to_cart(string_instance), [])), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.o9_1 = 12;
            this.n9_1 = 11;
            continue $sm;
          case 9:
            this.o9_1 = 12;
            var tmp_23 = this.q9_1;
            if (tmp_23 instanceof Exception) {
              var e_0 = this.q9_1;
              this.d140_1.x10k(CustomProductDetailsViewModel$handleAddToCart$slambda$lambda_0);
              this.n9_1 = 10;
              var tmp_24 = get_failed_add_to_cart(string_instance);
              var tmp57_elvis_lhs = e_0.message;
              suspendResult = this.d140_1.d10l(new ShowMessage_4(new ResourceString(tmp_24, [tmp57_elvis_lhs == null ? '' : tmp57_elvis_lhs])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 10:
            this.n9_1 = 11;
            continue $sm;
          case 11:
            this.o9_1 = 12;
            return Unit_instance;
          case 12:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 12) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(CustomProductDetailsViewModel$handleAddToCart$slambda).q24 = function ($this$launch, completion) {
    var i = new CustomProductDetailsViewModel$handleAddToCart$slambda(this.b140_1, this.c140_1, this.d140_1, this.e140_1, completion);
    i.f140_1 = $this$launch;
    return i;
  };
  function CustomProductDetailsViewModel$handleAddToCart$slambda_0($currentUser, $state, this$0, $currentProduct, resultContinuation) {
    var i = new CustomProductDetailsViewModel$handleAddToCart$slambda($currentUser, $state, this$0, $currentProduct, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CustomProductDetailsViewModel$recompositeInitialDesign$lambda($result) {
    return function ($this$updateState) {
      return $this$updateState.p13q(VOID, VOID, VOID, VOID, VOID, VOID, $result);
    };
  }
  function $handleIntentCOROUTINE$_14(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t140_1 = _this__u8e3s4;
    this.u140_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_14).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 11;
            var tmp0_subject = this.u140_1;
            if (tmp0_subject instanceof LoadProduct_1) {
              if (this.t140_1.s10h().ajg().u1().a10z_1)
                return Unit_instance;
              var product = this.u140_1.q13q_1;
              this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda(product, this.u140_1));
              var tmp1_elvis_lhs = product.nzt_1;
              observeFavorite_0(this.t140_1, tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs);
              var tmp2_elvis_lhs = product.nzt_1;
              observeStockReminder_0(this.t140_1, tmp2_elvis_lhs == null ? new Long(0, 0) : tmp2_elvis_lhs);
              var tmp_0 = get_viewModelScope(this.t140_1);
              launch(tmp_0, VOID, VOID, CustomProductDetailsViewModel$handleIntent$slambda_0(this.t140_1, product, null));
              this.o9_1 = 8;
              this.n9_1 = 7;
              var tmp_1 = Dispatchers_getInstance().i1h_1;
              suspendResult = withContext(tmp_1, CustomProductDetailsViewModel$handleIntent$slambda_2(product, this.t140_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (equals(tmp0_subject, ToggleFavorite_instance_0)) {
                var currentUser = this.t140_1.n13v_1.ynu();
                if (currentUser == null) {
                  this.n9_1 = 6;
                  suspendResult = this.t140_1.d10l(NavigateToAuth_instance_2, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.n9_1 = 4;
                  continue $sm;
                }
              } else {
                if (equals(tmp0_subject, ToggleStockReminder_instance_0)) {
                  var currentUser_0 = this.t140_1.n13v_1.ynu();
                  if (currentUser_0 == null) {
                    this.n9_1 = 3;
                    suspendResult = this.t140_1.d10l(NavigateToAuth_instance_2, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.n9_1 = 2;
                    continue $sm;
                  }
                } else {
                  if (equals(tmp0_subject, AddToCart_instance_1)) {
                    if (this.t140_1.s10h().ajg().u1().a10z_1)
                      return Unit_instance;
                    this.n9_1 = 1;
                    suspendResult = handleAddToCart_0(this.t140_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (tmp0_subject instanceof QuantityChanged_0) {
                      var tmp_2 = this;
                      this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_2(this.u140_1));
                      tmp_2.v140_1 = Unit_instance;
                      this.n9_1 = 10;
                      continue $sm;
                    } else {
                      if (equals(tmp0_subject, OpenEditor_instance_0)) {
                        var tmp_3 = this;
                        var state = this.t140_1.s10h().ajg().u1();
                        var tmp9_safe_receiver = state.y10y_1;
                        var templates = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.ozu_1;
                        var tmp0 = state.g10z_1;
                        var tmp$ret$2;
                        l$ret$3: do {
                          var tmp_4;
                          if (isInterface(tmp0, Collection)) {
                            tmp_4 = tmp0.r();
                          } else {
                            tmp_4 = false;
                          }
                          if (tmp_4) {
                            tmp$ret$2 = false;
                            break l$ret$3;
                          }
                          var _iterator__ex2g4s = tmp0.t();
                          while (_iterator__ex2g4s.u()) {
                            var element = _iterator__ex2g4s.v();
                            if (element.i12g_1 == null) {
                              tmp$ret$2 = true;
                              break l$ret$3;
                            }
                          }
                          tmp$ret$2 = false;
                        }
                         while (false);
                        var hasImageElements = tmp$ret$2;
                        var tmp_5;
                        var tmp_6;
                        if (!hasImageElements) {
                          tmp_6 = !(templates == null || templates.r());
                        } else {
                          tmp_6 = false;
                        }
                        if (tmp_6) {
                          this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_3);
                          var tmp_7 = get_viewModelScope(this.t140_1);
                          tmp_5 = launch(tmp_7, VOID, VOID, CustomProductDetailsViewModel$handleIntent$slambda_6(templates, this.t140_1, null));
                        } else {
                          this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_4);
                          tmp_5 = Unit_instance;
                        }
                        tmp_3.v140_1 = tmp_5;
                        this.n9_1 = 10;
                        continue $sm;
                      } else {
                        if (equals(tmp0_subject, CloseEditor_instance_0)) {
                          var tmp_8 = this;
                          this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_5);
                          tmp_8.v140_1 = Unit_instance;
                          this.n9_1 = 10;
                          continue $sm;
                        } else {
                          if (tmp0_subject instanceof CustomImageApplied_0) {
                            var tmp_9 = this;
                            this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_6(this.u140_1));
                            tmp_9.v140_1 = Unit_instance;
                            this.n9_1 = 10;
                            continue $sm;
                          } else {
                            if (tmp0_subject instanceof UpdateElements_0) {
                              var tmp_10 = this;
                              if (this.t140_1.s10h().ajg().u1().a10z_1)
                                return Unit_instance;
                              this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_7(this.u140_1));
                              recompositeInitialDesign_0(this.t140_1, this.u140_1.q13z_1);
                              tmp_10.v140_1 = Unit_instance;
                              this.n9_1 = 10;
                              continue $sm;
                            } else {
                              if (equals(tmp0_subject, RemoveCustomization_instance_0)) {
                                var tmp_11 = this;
                                this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_8);
                                tmp_11.v140_1 = Unit_instance;
                                this.n9_1 = 10;
                                continue $sm;
                              } else {
                                if (tmp0_subject instanceof KindChanged_0) {
                                  var tmp_12 = this;
                                  this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_9(this.u140_1));
                                  tmp_12.v140_1 = Unit_instance;
                                  this.n9_1 = 10;
                                  continue $sm;
                                } else {
                                  if (tmp0_subject instanceof TargetAudienceChanged_0) {
                                    var tmp_13 = this;
                                    this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_10(this.u140_1));
                                    tmp_13.v140_1 = Unit_instance;
                                    this.n9_1 = 10;
                                    continue $sm;
                                  } else {
                                    if (tmp0_subject instanceof CardSelected_1) {
                                      var tmp_14 = this;
                                      this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_11(this.u140_1));
                                      tmp_14.v140_1 = Unit_instance;
                                      this.n9_1 = 10;
                                      continue $sm;
                                    } else {
                                      if (tmp0_subject instanceof CardMessageChanged_1) {
                                        var tmp_15 = this;
                                        this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_12(this.u140_1));
                                        tmp_15.v140_1 = Unit_instance;
                                        this.n9_1 = 10;
                                        continue $sm;
                                      } else {
                                        if (tmp0_subject instanceof CardBirthdayChanged_1) {
                                          var tmp_16 = this;
                                          this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_13(this.u140_1));
                                          tmp_16.v140_1 = Unit_instance;
                                          this.n9_1 = 10;
                                          continue $sm;
                                        } else {
                                          if (tmp0_subject instanceof BoxSelected_1) {
                                            var tmp_17 = this;
                                            this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_14(this.u140_1));
                                            tmp_17.v140_1 = Unit_instance;
                                            this.n9_1 = 10;
                                            continue $sm;
                                          } else {
                                            if (tmp0_subject instanceof BoxMessageChanged_1) {
                                              var tmp_18 = this;
                                              this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_15(this.u140_1));
                                              tmp_18.v140_1 = Unit_instance;
                                              this.n9_1 = 10;
                                              continue $sm;
                                            } else {
                                              if (tmp0_subject instanceof BoxBirthdayChanged_1) {
                                                var tmp_19 = this;
                                                this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_16(this.u140_1));
                                                tmp_19.v140_1 = Unit_instance;
                                                this.n9_1 = 10;
                                                continue $sm;
                                              } else {
                                                if (tmp0_subject instanceof SizeSelected_1) {
                                                  var tmp_20 = this;
                                                  this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_17(this.u140_1));
                                                  tmp_20.v140_1 = Unit_instance;
                                                  this.n9_1 = 10;
                                                  continue $sm;
                                                } else {
                                                  if (tmp0_subject instanceof ColorSelected_1) {
                                                    var tmp_21 = this;
                                                    this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_18(this.u140_1));
                                                    tmp_21.v140_1 = Unit_instance;
                                                    this.n9_1 = 10;
                                                    continue $sm;
                                                  } else {
                                                    if (tmp0_subject instanceof OptionSelected_1) {
                                                      var tmp_22 = this;
                                                      this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_19(this.t140_1, this.u140_1));
                                                      tmp_22.v140_1 = Unit_instance;
                                                      this.n9_1 = 10;
                                                      continue $sm;
                                                    } else {
                                                      if (tmp0_subject instanceof ProductCommentChanged_1) {
                                                        var tmp_23 = this;
                                                        this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_20(this.u140_1));
                                                        tmp_23.v140_1 = Unit_instance;
                                                        this.n9_1 = 10;
                                                        continue $sm;
                                                      } else {
                                                        if (equals(tmp0_subject, ShareProduct_instance_0)) {
                                                          var tmp_24 = this;
                                                          var state_0 = this.t140_1.s10h().ajg().u1();
                                                          var tmp10_elvis_lhs = state_0.y10y_1;
                                                          var tmp_25;
                                                          if (tmp10_elvis_lhs == null) {
                                                            return Unit_instance;
                                                          } else {
                                                            tmp_25 = tmp10_elvis_lhs;
                                                          }
                                                          var product_0 = tmp_25;
                                                          var language = state_0.d10z_1;
                                                          var name = language === 'en' ? product_0.ozt_1 : product_0.pzt_1;
                                                          var description = language === 'en' ? product_0.qzt_1 : product_0.rzt_1;
                                                          var url = 'https://hadaya-ea700.web.app/product/' + toString_0(product_0.nzt_1);
                                                          var tmp_26 = name == null ? '' : name;
                                                          shareProduct(tmp_26, description == null ? '' : description, url);
                                                          tmp_24.v140_1 = Unit_instance;
                                                          this.n9_1 = 10;
                                                          continue $sm;
                                                        } else {
                                                          var tmp_27 = this;
                                                          noWhenBranchMatchedException();
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            break;
          case 1:
            var tmp_28 = this;
            tmp_28.v140_1 = Unit_instance;
            this.n9_1 = 10;
            continue $sm;
          case 2:
            var tmp7_safe_receiver = this.t140_1.s10h().ajg().u1().y10y_1;
            var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.nzt_1;
            var tmp_29;
            if (tmp8_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_29 = tmp8_elvis_lhs;
            }

            var productId = tmp_29;
            var tmp_30 = this;
            var tmp_31 = get_viewModelScope(this.t140_1);
            tmp_30.v140_1 = launch(tmp_31, VOID, VOID, CustomProductDetailsViewModel$handleIntent$slambda_4(this.t140_1, productId, null));
            this.n9_1 = 10;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            var tmp5_safe_receiver = this.t140_1.s10h().ajg().u1().y10y_1;
            var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.nzt_1;
            var tmp_32;
            if (tmp6_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_32 = tmp6_elvis_lhs;
            }

            var productId_0 = tmp_32;
            this.n9_1 = 5;
            suspendResult = this.t140_1.p13v_1.vz6(productId_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var tmp_33 = this;
            tmp_33.v140_1 = Unit_instance;
            this.n9_1 = 10;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            var _destruct__k2r9zo = suspendResult;
            var mainImage = _destruct__k2r9zo.zh();
            var restoredElements = _destruct__k2r9zo.ai();
            var templateBitmap = _destruct__k2r9zo.hr();
            var tmp$ret$0;
            l$ret$1: do {
              var tmp_34;
              if (isInterface(restoredElements, Collection)) {
                tmp_34 = restoredElements.r();
              } else {
                tmp_34 = false;
              }
              if (tmp_34) {
                tmp$ret$0 = false;
                break l$ret$1;
              }
              var _iterator__ex2g4s_0 = restoredElements.t();
              while (_iterator__ex2g4s_0.u()) {
                var element_0 = _iterator__ex2g4s_0.v();
                if (element_0.i12g_1 == null && !element_0.l12g_1) {
                  tmp$ret$0 = true;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = false;
            }
             while (false);
            var hasImageElements_0 = tmp$ret$0;
            var tmp_35;
            if (hasImageElements_0) {
              tmp_35 = null;
            } else {
              var tmp4_elvis_lhs = mainImage == null ? templateBitmap : mainImage;
              tmp_35 = tmp4_elvis_lhs == null ? this.t140_1.s10h().ajg().u1().e10z_1 : tmp4_elvis_lhs;
            }

            var finalImageBitmap = tmp_35;
            this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_0(finalImageBitmap, restoredElements));
            var tmp_36;
            if (!restoredElements.r()) {
              tmp_36 = hasImageElements_0 || (mainImage == null && templateBitmap == null && finalImageBitmap == null);
            } else {
              tmp_36 = false;
            }

            if (tmp_36) {
              recompositeInitialDesign_0(this.t140_1, restoredElements);
            }

            this.o9_1 = 11;
            this.n9_1 = 9;
            continue $sm;
          case 8:
            this.o9_1 = 11;
            var tmp_37 = this.q9_1;
            if (tmp_37 instanceof Exception) {
              var e = this.q9_1;
              this.t140_1.x10k(CustomProductDetailsViewModel$handleIntent$lambda_1(e));
              this.n9_1 = 9;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 9:
            var tmp_38 = this;
            this.o9_1 = 11;
            tmp_38.v140_1 = Unit_instance;
            this.n9_1 = 10;
            continue $sm;
          case 10:
            return Unit_instance;
          case 11:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 11) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $handleAddToCartCOROUTINE$_0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u13u_1 = _this__u8e3s4;
  }
  protoOf($handleAddToCartCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 11;
            this.w13u_1 = this.u13u_1.s10h().ajg().u1();
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.w13u_1.y10y_1;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.v13u_1 = tmp_1;
            var tmp_2;
            var tmp1_safe_receiver = this.w13u_1.m10z_1;
            if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.pyz_1) === true) {
              tmp_2 = isBlank(this.w13u_1.o10z_1);
            } else {
              tmp_2 = false;
            }

            if (tmp_2) {
              this.u13u_1.x10k(CustomProductDetailsViewModel$handleAddToCart$lambda);
              this.n9_1 = 10;
              suspendResult = this.u13u_1.d10l(new ShowMessage_4(new ResourceString(get_invalid_birthday_date(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              continue $sm;
            }

          case 1:
            var tmp_3;
            var tmp2_safe_receiver = this.w13u_1.q10z_1;
            if ((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.az0_1) === true) {
              tmp_3 = isBlank(this.w13u_1.s10z_1);
            } else {
              tmp_3 = false;
            }

            if (tmp_3) {
              this.u13u_1.x10k(CustomProductDetailsViewModel$handleAddToCart$lambda_0);
              this.n9_1 = 9;
              suspendResult = this.u13u_1.d10l(new ShowMessage_4(new ResourceString(get_invalid_birthday_date(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            if (!(this.w13u_1.m10z_1 == null) && ensureNotNull(this.w13u_1.m10z_1).myz_1 <= 0) {
              this.n9_1 = 8;
              suspendResult = this.u13u_1.d10l(new ShowMessage_4(new ResourceString(get_out_of_stock(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            if (!(this.w13u_1.q10z_1 == null) && ensureNotNull(this.w13u_1.q10z_1).xyz_1 <= 0) {
              this.n9_1 = 7;
              suspendResult = this.u13u_1.d10l(new ShowMessage_4(new ResourceString(get_out_of_stock(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            this.x13u_1 = this.u13u_1.n13v_1.ynu();
            if (this.x13u_1 == null) {
              this.u13u_1.x10k(CustomProductDetailsViewModel$handleAddToCart$lambda_1);
              this.n9_1 = 6;
              suspendResult = this.u13u_1.d10l(NavigateToAuth_instance_2, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 5:
            this.u13u_1.x10k(CustomProductDetailsViewModel$handleAddToCart$lambda_2);
            var tmp_4 = get_viewModelScope(this.u13u_1);
            launch(tmp_4, VOID, VOID, CustomProductDetailsViewModel$handleAddToCart$slambda_0(this.x13u_1, this.w13u_1, this.u13u_1, this.v13u_1, null));
            return Unit_instance;
          case 6:
            return Unit_instance;
          case 7:
            return Unit_instance;
          case 8:
            return Unit_instance;
          case 9:
            return Unit_instance;
          case 10:
            return Unit_instance;
          case 11:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 11) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function CustomProductDetailsViewModel(addToCartUseCase, getCurrentUserValueUseCase, getLanguageUseCase, favoriteRepository, downloadDesignImageUseCase, uploadDesignImageUseCase, networkObserver, toggleStockReminderUseCase, stockReminderRepository, productRepository, authRepository) {
    BaseMviViewModel.call(this, new CustomProductDetailsState());
    this.m13v_1 = addToCartUseCase;
    this.n13v_1 = getCurrentUserValueUseCase;
    this.o13v_1 = getLanguageUseCase;
    this.p13v_1 = favoriteRepository;
    this.q13v_1 = downloadDesignImageUseCase;
    this.r13v_1 = uploadDesignImageUseCase;
    this.s13v_1 = networkObserver;
    this.t13v_1 = toggleStockReminderUseCase;
    this.u13v_1 = stockReminderRepository;
    this.v13v_1 = productRepository;
    this.w13v_1 = authRepository;
    observeLanguage_7(this);
    observeCurrentUser_0(this);
  }
  protoOf(CustomProductDetailsViewModel).w140 = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_14(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CustomProductDetailsViewModel).f10l = function (intent, $completion) {
    return this.w140(isInterface(intent, CustomProductDetailsIntent) ? intent : THROW_CCE(), $completion);
  };
  var client_fstech_hadaya_presentation_product_details_ProductDetailsState$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_LoadProduct$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_AddToCart$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_ToggleStockReminder$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_QuantityChanged$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_ToggleFavorite$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_KindChanged$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_TargetAudienceChanged$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_CardSelected$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_CardMessageChanged$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_CardBirthdayChanged$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_BoxSelected$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_BoxMessageChanged$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_BoxBirthdayChanged$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_SizeSelected$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_ColorSelected$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_OptionSelected$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_ProductCommentChanged$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_BraceletNameChanged$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_ShareProduct$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsSideEffect_ShowMessage$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsSideEffect_ShowToast$stable;
  var client_fstech_hadaya_presentation_product_details_ProductDetailsSideEffect_NavigateToAuth$stable;
  function ProductDetailsState(product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, braceletName, availableCards, availableBoxes) {
    product = product === VOID ? null : product;
    quantity = quantity === VOID ? 1 : quantity;
    isAddingToCart = isAddingToCart === VOID ? false : isAddingToCart;
    isFavorite = isFavorite === VOID ? false : isFavorite;
    isStockReminderSet = isStockReminderSet === VOID ? false : isStockReminderSet;
    language = language === VOID ? 'en' : language;
    selectedKind = selectedKind === VOID ? ProductKind_NORMAL_getInstance() : selectedKind;
    selectedAudience = selectedAudience === VOID ? TargetAudience_BOTH_getInstance() : selectedAudience;
    selectedCard = selectedCard === VOID ? null : selectedCard;
    cardMessage = cardMessage === VOID ? '' : cardMessage;
    cardBirthday = cardBirthday === VOID ? '' : cardBirthday;
    cardBirthdayError = cardBirthdayError === VOID ? false : cardBirthdayError;
    selectedBox = selectedBox === VOID ? null : selectedBox;
    boxMessage = boxMessage === VOID ? '' : boxMessage;
    boxBirthday = boxBirthday === VOID ? '' : boxBirthday;
    boxBirthdayError = boxBirthdayError === VOID ? false : boxBirthdayError;
    selectedSize = selectedSize === VOID ? null : selectedSize;
    selectedColor = selectedColor === VOID ? null : selectedColor;
    selectedOptions = selectedOptions === VOID ? emptyMap() : selectedOptions;
    productComment = productComment === VOID ? '' : productComment;
    braceletName = braceletName === VOID ? '' : braceletName;
    availableCards = availableCards === VOID ? emptyList() : availableCards;
    availableBoxes = availableBoxes === VOID ? emptyList() : availableBoxes;
    this.n11d_1 = product;
    this.o11d_1 = quantity;
    this.p11d_1 = isAddingToCart;
    this.q11d_1 = isFavorite;
    this.r11d_1 = isStockReminderSet;
    this.s11d_1 = language;
    this.t11d_1 = selectedKind;
    this.u11d_1 = selectedAudience;
    this.v11d_1 = selectedCard;
    this.w11d_1 = cardMessage;
    this.x11d_1 = cardBirthday;
    this.y11d_1 = cardBirthdayError;
    this.z11d_1 = selectedBox;
    this.a11e_1 = boxMessage;
    this.b11e_1 = boxBirthday;
    this.c11e_1 = boxBirthdayError;
    this.d11e_1 = selectedSize;
    this.e11e_1 = selectedColor;
    this.f11e_1 = selectedOptions;
    this.g11e_1 = productComment;
    this.h11e_1 = braceletName;
    this.i11e_1 = availableCards;
    this.j11e_1 = availableBoxes;
  }
  protoOf(ProductDetailsState).y138 = function (product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, braceletName, availableCards, availableBoxes) {
    return new ProductDetailsState(product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, braceletName, availableCards, availableBoxes);
  };
  protoOf(ProductDetailsState).x140 = function (product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, braceletName, availableCards, availableBoxes, $super) {
    product = product === VOID ? this.n11d_1 : product;
    quantity = quantity === VOID ? this.o11d_1 : quantity;
    isAddingToCart = isAddingToCart === VOID ? this.p11d_1 : isAddingToCart;
    isFavorite = isFavorite === VOID ? this.q11d_1 : isFavorite;
    isStockReminderSet = isStockReminderSet === VOID ? this.r11d_1 : isStockReminderSet;
    language = language === VOID ? this.s11d_1 : language;
    selectedKind = selectedKind === VOID ? this.t11d_1 : selectedKind;
    selectedAudience = selectedAudience === VOID ? this.u11d_1 : selectedAudience;
    selectedCard = selectedCard === VOID ? this.v11d_1 : selectedCard;
    cardMessage = cardMessage === VOID ? this.w11d_1 : cardMessage;
    cardBirthday = cardBirthday === VOID ? this.x11d_1 : cardBirthday;
    cardBirthdayError = cardBirthdayError === VOID ? this.y11d_1 : cardBirthdayError;
    selectedBox = selectedBox === VOID ? this.z11d_1 : selectedBox;
    boxMessage = boxMessage === VOID ? this.a11e_1 : boxMessage;
    boxBirthday = boxBirthday === VOID ? this.b11e_1 : boxBirthday;
    boxBirthdayError = boxBirthdayError === VOID ? this.c11e_1 : boxBirthdayError;
    selectedSize = selectedSize === VOID ? this.d11e_1 : selectedSize;
    selectedColor = selectedColor === VOID ? this.e11e_1 : selectedColor;
    selectedOptions = selectedOptions === VOID ? this.f11e_1 : selectedOptions;
    productComment = productComment === VOID ? this.g11e_1 : productComment;
    braceletName = braceletName === VOID ? this.h11e_1 : braceletName;
    availableCards = availableCards === VOID ? this.i11e_1 : availableCards;
    availableBoxes = availableBoxes === VOID ? this.j11e_1 : availableBoxes;
    return $super === VOID ? this.y138(product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, braceletName, availableCards, availableBoxes) : $super.y138.call(this, product, quantity, isAddingToCart, isFavorite, isStockReminderSet, language, selectedKind, selectedAudience, selectedCard, cardMessage, cardBirthday, cardBirthdayError, selectedBox, boxMessage, boxBirthday, boxBirthdayError, selectedSize, selectedColor, selectedOptions, productComment, braceletName, availableCards, availableBoxes);
  };
  protoOf(ProductDetailsState).toString = function () {
    return 'ProductDetailsState(product=' + toString_0(this.n11d_1) + ', quantity=' + this.o11d_1 + ', isAddingToCart=' + this.p11d_1 + ', isFavorite=' + this.q11d_1 + ', isStockReminderSet=' + this.r11d_1 + ', language=' + this.s11d_1 + ', selectedKind=' + this.t11d_1.toString() + ', selectedAudience=' + this.u11d_1.toString() + ', selectedCard=' + toString_0(this.v11d_1) + ', cardMessage=' + this.w11d_1 + ', cardBirthday=' + this.x11d_1 + ', cardBirthdayError=' + this.y11d_1 + ', selectedBox=' + toString_0(this.z11d_1) + ', boxMessage=' + this.a11e_1 + ', boxBirthday=' + this.b11e_1 + ', boxBirthdayError=' + this.c11e_1 + ', selectedSize=' + this.d11e_1 + ', selectedColor=' + this.e11e_1 + ', selectedOptions=' + toString(this.f11e_1) + ', productComment=' + this.g11e_1 + ', braceletName=' + this.h11e_1 + ', availableCards=' + toString(this.i11e_1) + ', availableBoxes=' + toString(this.j11e_1) + ')';
  };
  protoOf(ProductDetailsState).hashCode = function () {
    var result = this.n11d_1 == null ? 0 : this.n11d_1.hashCode();
    result = imul(result, 31) + this.o11d_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p11d_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q11d_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r11d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s11d_1) | 0;
    result = imul(result, 31) + this.t11d_1.hashCode() | 0;
    result = imul(result, 31) + this.u11d_1.hashCode() | 0;
    result = imul(result, 31) + (this.v11d_1 == null ? 0 : this.v11d_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.w11d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x11d_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y11d_1) | 0;
    result = imul(result, 31) + (this.z11d_1 == null ? 0 : this.z11d_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.a11e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b11e_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c11e_1) | 0;
    result = imul(result, 31) + (this.d11e_1 == null ? 0 : getStringHashCode(this.d11e_1)) | 0;
    result = imul(result, 31) + (this.e11e_1 == null ? 0 : getStringHashCode(this.e11e_1)) | 0;
    result = imul(result, 31) + hashCode(this.f11e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g11e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h11e_1) | 0;
    result = imul(result, 31) + hashCode(this.i11e_1) | 0;
    result = imul(result, 31) + hashCode(this.j11e_1) | 0;
    return result;
  };
  protoOf(ProductDetailsState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductDetailsState))
      return false;
    if (!equals(this.n11d_1, other.n11d_1))
      return false;
    if (!(this.o11d_1 === other.o11d_1))
      return false;
    if (!(this.p11d_1 === other.p11d_1))
      return false;
    if (!(this.q11d_1 === other.q11d_1))
      return false;
    if (!(this.r11d_1 === other.r11d_1))
      return false;
    if (!(this.s11d_1 === other.s11d_1))
      return false;
    if (!this.t11d_1.equals(other.t11d_1))
      return false;
    if (!this.u11d_1.equals(other.u11d_1))
      return false;
    if (!equals(this.v11d_1, other.v11d_1))
      return false;
    if (!(this.w11d_1 === other.w11d_1))
      return false;
    if (!(this.x11d_1 === other.x11d_1))
      return false;
    if (!(this.y11d_1 === other.y11d_1))
      return false;
    if (!equals(this.z11d_1, other.z11d_1))
      return false;
    if (!(this.a11e_1 === other.a11e_1))
      return false;
    if (!(this.b11e_1 === other.b11e_1))
      return false;
    if (!(this.c11e_1 === other.c11e_1))
      return false;
    if (!(this.d11e_1 == other.d11e_1))
      return false;
    if (!(this.e11e_1 == other.e11e_1))
      return false;
    if (!equals(this.f11e_1, other.f11e_1))
      return false;
    if (!(this.g11e_1 === other.g11e_1))
      return false;
    if (!(this.h11e_1 === other.h11e_1))
      return false;
    if (!equals(this.i11e_1, other.i11e_1))
      return false;
    if (!equals(this.j11e_1, other.j11e_1))
      return false;
    return true;
  };
  function LoadProduct_2(product, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, initialBraceletName) {
    initialSize = initialSize === VOID ? null : initialSize;
    initialColor = initialColor === VOID ? null : initialColor;
    initialOptions = initialOptions === VOID ? null : initialOptions;
    initialComment = initialComment === VOID ? null : initialComment;
    initialCard = initialCard === VOID ? null : initialCard;
    initialBox = initialBox === VOID ? null : initialBox;
    initialCardMessage = initialCardMessage === VOID ? null : initialCardMessage;
    initialCardBirthday = initialCardBirthday === VOID ? null : initialCardBirthday;
    initialBoxMessage = initialBoxMessage === VOID ? null : initialBoxMessage;
    initialBoxBirthday = initialBoxBirthday === VOID ? null : initialBoxBirthday;
    initialBraceletName = initialBraceletName === VOID ? null : initialBraceletName;
    this.y140_1 = product;
    this.z140_1 = initialSize;
    this.a141_1 = initialColor;
    this.b141_1 = initialOptions;
    this.c141_1 = initialComment;
    this.d141_1 = initialCard;
    this.e141_1 = initialBox;
    this.f141_1 = initialCardMessage;
    this.g141_1 = initialCardBirthday;
    this.h141_1 = initialBoxMessage;
    this.i141_1 = initialBoxBirthday;
    this.j141_1 = initialBraceletName;
  }
  protoOf(LoadProduct_2).toString = function () {
    return 'LoadProduct(product=' + this.y140_1.toString() + ', initialSize=' + this.z140_1 + ', initialColor=' + this.a141_1 + ', initialOptions=' + toString_0(this.b141_1) + ', initialComment=' + this.c141_1 + ', initialCard=' + toString_0(this.d141_1) + ', initialBox=' + toString_0(this.e141_1) + ', initialCardMessage=' + this.f141_1 + ', initialCardBirthday=' + this.g141_1 + ', initialBoxMessage=' + this.h141_1 + ', initialBoxBirthday=' + this.i141_1 + ', initialBraceletName=' + this.j141_1 + ')';
  };
  protoOf(LoadProduct_2).hashCode = function () {
    var result = this.y140_1.hashCode();
    result = imul(result, 31) + (this.z140_1 == null ? 0 : getStringHashCode(this.z140_1)) | 0;
    result = imul(result, 31) + (this.a141_1 == null ? 0 : getStringHashCode(this.a141_1)) | 0;
    result = imul(result, 31) + (this.b141_1 == null ? 0 : hashCode(this.b141_1)) | 0;
    result = imul(result, 31) + (this.c141_1 == null ? 0 : getStringHashCode(this.c141_1)) | 0;
    result = imul(result, 31) + (this.d141_1 == null ? 0 : this.d141_1.hashCode()) | 0;
    result = imul(result, 31) + (this.e141_1 == null ? 0 : this.e141_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f141_1 == null ? 0 : getStringHashCode(this.f141_1)) | 0;
    result = imul(result, 31) + (this.g141_1 == null ? 0 : getStringHashCode(this.g141_1)) | 0;
    result = imul(result, 31) + (this.h141_1 == null ? 0 : getStringHashCode(this.h141_1)) | 0;
    result = imul(result, 31) + (this.i141_1 == null ? 0 : getStringHashCode(this.i141_1)) | 0;
    result = imul(result, 31) + (this.j141_1 == null ? 0 : getStringHashCode(this.j141_1)) | 0;
    return result;
  };
  protoOf(LoadProduct_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadProduct_2))
      return false;
    if (!this.y140_1.equals(other.y140_1))
      return false;
    if (!(this.z140_1 == other.z140_1))
      return false;
    if (!(this.a141_1 == other.a141_1))
      return false;
    if (!equals(this.b141_1, other.b141_1))
      return false;
    if (!(this.c141_1 == other.c141_1))
      return false;
    if (!equals(this.d141_1, other.d141_1))
      return false;
    if (!equals(this.e141_1, other.e141_1))
      return false;
    if (!(this.f141_1 == other.f141_1))
      return false;
    if (!(this.g141_1 == other.g141_1))
      return false;
    if (!(this.h141_1 == other.h141_1))
      return false;
    if (!(this.i141_1 == other.i141_1))
      return false;
    if (!(this.j141_1 == other.j141_1))
      return false;
    return true;
  };
  function AddToCart_2() {
  }
  protoOf(AddToCart_2).toString = function () {
    return 'AddToCart';
  };
  protoOf(AddToCart_2).hashCode = function () {
    return -1361493755;
  };
  protoOf(AddToCart_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddToCart_2))
      return false;
    return true;
  };
  var AddToCart_instance_2;
  function AddToCart_getInstance_2() {
    return AddToCart_instance_2;
  }
  function ToggleStockReminder_2() {
  }
  protoOf(ToggleStockReminder_2).toString = function () {
    return 'ToggleStockReminder';
  };
  protoOf(ToggleStockReminder_2).hashCode = function () {
    return 1992608829;
  };
  protoOf(ToggleStockReminder_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ToggleStockReminder_2))
      return false;
    return true;
  };
  var ToggleStockReminder_instance_1;
  function ToggleStockReminder_getInstance_1() {
    return ToggleStockReminder_instance_1;
  }
  function QuantityChanged_1(quantity) {
    this.k141_1 = quantity;
  }
  protoOf(QuantityChanged_1).toString = function () {
    return 'QuantityChanged(quantity=' + this.k141_1 + ')';
  };
  protoOf(QuantityChanged_1).hashCode = function () {
    return this.k141_1;
  };
  protoOf(QuantityChanged_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof QuantityChanged_1))
      return false;
    if (!(this.k141_1 === other.k141_1))
      return false;
    return true;
  };
  function ToggleFavorite_3() {
  }
  protoOf(ToggleFavorite_3).toString = function () {
    return 'ToggleFavorite';
  };
  protoOf(ToggleFavorite_3).hashCode = function () {
    return 828447207;
  };
  protoOf(ToggleFavorite_3).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ToggleFavorite_3))
      return false;
    return true;
  };
  var ToggleFavorite_instance_1;
  function ToggleFavorite_getInstance_1() {
    return ToggleFavorite_instance_1;
  }
  function KindChanged_1() {
  }
  function TargetAudienceChanged_1() {
  }
  function CardSelected_2(card) {
    this.l141_1 = card;
  }
  protoOf(CardSelected_2).toString = function () {
    return 'CardSelected(card=' + toString_0(this.l141_1) + ')';
  };
  protoOf(CardSelected_2).hashCode = function () {
    return this.l141_1 == null ? 0 : this.l141_1.hashCode();
  };
  protoOf(CardSelected_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CardSelected_2))
      return false;
    if (!equals(this.l141_1, other.l141_1))
      return false;
    return true;
  };
  function CardMessageChanged_2(message) {
    this.m141_1 = message;
  }
  protoOf(CardMessageChanged_2).toString = function () {
    return 'CardMessageChanged(message=' + this.m141_1 + ')';
  };
  protoOf(CardMessageChanged_2).hashCode = function () {
    return getStringHashCode(this.m141_1);
  };
  protoOf(CardMessageChanged_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CardMessageChanged_2))
      return false;
    if (!(this.m141_1 === other.m141_1))
      return false;
    return true;
  };
  function CardBirthdayChanged_2(birthday) {
    this.n141_1 = birthday;
  }
  protoOf(CardBirthdayChanged_2).toString = function () {
    return 'CardBirthdayChanged(birthday=' + this.n141_1 + ')';
  };
  protoOf(CardBirthdayChanged_2).hashCode = function () {
    return getStringHashCode(this.n141_1);
  };
  protoOf(CardBirthdayChanged_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CardBirthdayChanged_2))
      return false;
    if (!(this.n141_1 === other.n141_1))
      return false;
    return true;
  };
  function BoxSelected_2(box) {
    this.o141_1 = box;
  }
  protoOf(BoxSelected_2).toString = function () {
    return 'BoxSelected(box=' + toString_0(this.o141_1) + ')';
  };
  protoOf(BoxSelected_2).hashCode = function () {
    return this.o141_1 == null ? 0 : this.o141_1.hashCode();
  };
  protoOf(BoxSelected_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxSelected_2))
      return false;
    if (!equals(this.o141_1, other.o141_1))
      return false;
    return true;
  };
  function BoxMessageChanged_2(message) {
    this.p141_1 = message;
  }
  protoOf(BoxMessageChanged_2).toString = function () {
    return 'BoxMessageChanged(message=' + this.p141_1 + ')';
  };
  protoOf(BoxMessageChanged_2).hashCode = function () {
    return getStringHashCode(this.p141_1);
  };
  protoOf(BoxMessageChanged_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxMessageChanged_2))
      return false;
    if (!(this.p141_1 === other.p141_1))
      return false;
    return true;
  };
  function BoxBirthdayChanged_2(birthday) {
    this.q141_1 = birthday;
  }
  protoOf(BoxBirthdayChanged_2).toString = function () {
    return 'BoxBirthdayChanged(birthday=' + this.q141_1 + ')';
  };
  protoOf(BoxBirthdayChanged_2).hashCode = function () {
    return getStringHashCode(this.q141_1);
  };
  protoOf(BoxBirthdayChanged_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxBirthdayChanged_2))
      return false;
    if (!(this.q141_1 === other.q141_1))
      return false;
    return true;
  };
  function SizeSelected_2(size) {
    this.r141_1 = size;
  }
  protoOf(SizeSelected_2).toString = function () {
    return 'SizeSelected(size=' + this.r141_1 + ')';
  };
  protoOf(SizeSelected_2).hashCode = function () {
    return this.r141_1 == null ? 0 : getStringHashCode(this.r141_1);
  };
  protoOf(SizeSelected_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeSelected_2))
      return false;
    if (!(this.r141_1 == other.r141_1))
      return false;
    return true;
  };
  function ColorSelected_2(color) {
    this.s141_1 = color;
  }
  protoOf(ColorSelected_2).toString = function () {
    return 'ColorSelected(color=' + this.s141_1 + ')';
  };
  protoOf(ColorSelected_2).hashCode = function () {
    return this.s141_1 == null ? 0 : getStringHashCode(this.s141_1);
  };
  protoOf(ColorSelected_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorSelected_2))
      return false;
    if (!(this.s141_1 == other.s141_1))
      return false;
    return true;
  };
  function OptionSelected_2(key, value) {
    this.t141_1 = key;
    this.u141_1 = value;
  }
  protoOf(OptionSelected_2).toString = function () {
    return 'OptionSelected(key=' + this.t141_1 + ', value=' + toString_0(this.u141_1) + ')';
  };
  protoOf(OptionSelected_2).hashCode = function () {
    var result = getStringHashCode(this.t141_1);
    result = imul(result, 31) + (this.u141_1 == null ? 0 : this.u141_1.hashCode()) | 0;
    return result;
  };
  protoOf(OptionSelected_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OptionSelected_2))
      return false;
    if (!(this.t141_1 === other.t141_1))
      return false;
    if (!equals(this.u141_1, other.u141_1))
      return false;
    return true;
  };
  function ProductCommentChanged_2(comment) {
    this.v141_1 = comment;
  }
  protoOf(ProductCommentChanged_2).toString = function () {
    return 'ProductCommentChanged(comment=' + this.v141_1 + ')';
  };
  protoOf(ProductCommentChanged_2).hashCode = function () {
    return getStringHashCode(this.v141_1);
  };
  protoOf(ProductCommentChanged_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductCommentChanged_2))
      return false;
    if (!(this.v141_1 === other.v141_1))
      return false;
    return true;
  };
  function BraceletNameChanged_0() {
  }
  function ShareProduct_1() {
  }
  protoOf(ShareProduct_1).toString = function () {
    return 'ShareProduct';
  };
  protoOf(ShareProduct_1).hashCode = function () {
    return 1929796263;
  };
  protoOf(ShareProduct_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShareProduct_1))
      return false;
    return true;
  };
  var ShareProduct_instance_1;
  function ShareProduct_getInstance_1() {
    return ShareProduct_instance_1;
  }
  function ProductDetailsIntent() {
  }
  function ShowMessage_5(message) {
    this.s11g_1 = message;
  }
  protoOf(ShowMessage_5).toString = function () {
    return 'ShowMessage(message=' + toString(this.s11g_1) + ')';
  };
  protoOf(ShowMessage_5).hashCode = function () {
    return hashCode(this.s11g_1);
  };
  protoOf(ShowMessage_5).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowMessage_5))
      return false;
    if (!equals(this.s11g_1, other.s11g_1))
      return false;
    return true;
  };
  function ShowToast_1(message) {
    this.r11g_1 = message;
  }
  protoOf(ShowToast_1).toString = function () {
    return 'ShowToast(message=' + toString(this.r11g_1) + ')';
  };
  protoOf(ShowToast_1).hashCode = function () {
    return hashCode(this.r11g_1);
  };
  protoOf(ShowToast_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowToast_1))
      return false;
    if (!equals(this.r11g_1, other.r11g_1))
      return false;
    return true;
  };
  function NavigateToAuth_3() {
  }
  protoOf(NavigateToAuth_3).toString = function () {
    return 'NavigateToAuth';
  };
  protoOf(NavigateToAuth_3).hashCode = function () {
    return -411909825;
  };
  protoOf(NavigateToAuth_3).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NavigateToAuth_3))
      return false;
    return true;
  };
  var NavigateToAuth_instance_3;
  function NavigateToAuth_getInstance_3() {
    return NavigateToAuth_instance_3;
  }
  function ProductDetailsSideEffect() {
  }
  function ProductDetailsScreen(product, onBack, onNavigateToAuth, initialSize, initialColor, initialOptions, initialComment, initialCard, initialBox, initialCardMessage, initialCardBirthday, initialBoxMessage, initialBoxBirthday, $composer, $changed, $changed1, $default) {
    var initialSize_0 = {_v: initialSize};
    var initialColor_0 = {_v: initialColor};
    var initialOptions_0 = {_v: initialOptions};
    var initialComment_0 = {_v: initialComment};
    var initialCard_0 = {_v: initialCard};
    var initialBox_0 = {_v: initialBox};
    var initialCardMessage_0 = {_v: initialCardMessage};
    var initialCardBirthday_0 = {_v: initialCardBirthday};
    var initialBoxMessage_0 = {_v: initialBoxMessage};
    var initialBoxBirthday_0 = {_v: initialBoxBirthday};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-2126249779);
    sourceInformation($composer_0, 'C(ProductDetailsScreen)P(12,10,11,9,6,8,7,3!1,5,4,2)115@5501L42,116@5587L16,117@5632L32,118@5695L21,128@6211L27,131@6389L900,131@6365L924,152@7321L473,152@7295L499,169@8055L22,169@8036L41,170@8099L34,172@8165L34,173@8241L42,174@8316L34,175@8380L34,176@8442L34,177@8506L33,178@8570L25,180@8664L138,180@8601L201,188@8847L33,188@8808L72,204@9257L10717:ProductDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(product) : $composer_0.q31(product)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToAuth) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(initialSize_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(initialColor_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ((($changed & 262144) === 0 ? $composer_0.k31(initialOptions_0._v) : $composer_0.q31(initialOptions_0._v)) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(initialComment_0._v) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ((($changed & 16777216) === 0 ? $composer_0.k31(initialCard_0._v) : $composer_0.q31(initialCard_0._v)) ? 8388608 : 4194304);
    if (!(($default & 256) === 0))
      $dirty = $dirty | 100663296;
    else if (($changed & 100663296) === 0)
      $dirty = $dirty | ((($changed & 134217728) === 0 ? $composer_0.k31(initialBox_0._v) : $composer_0.q31(initialBox_0._v)) ? 67108864 : 33554432);
    if (!(($default & 512) === 0))
      $dirty = $dirty | 805306368;
    else if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.k31(initialCardMessage_0._v) ? 536870912 : 268435456);
    if (!(($default & 1024) === 0))
      $dirty1 = $dirty1 | 6;
    else if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(initialCardBirthday_0._v) ? 4 : 2);
    if (!(($default & 2048) === 0))
      $dirty1 = $dirty1 | 48;
    else if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(initialBoxMessage_0._v) ? 32 : 16);
    if (!(($default & 4096) === 0))
      $dirty1 = $dirty1 | 384;
    else if (($changed1 & 384) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(initialBoxBirthday_0._v) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 147) === 146), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        initialSize_0._v = null;
      }
      if (!(($default & 16) === 0)) {
        initialColor_0._v = null;
      }
      if (!(($default & 32) === 0)) {
        initialOptions_0._v = null;
      }
      if (!(($default & 64) === 0)) {
        initialComment_0._v = null;
      }
      if (!(($default & 128) === 0)) {
        initialCard_0._v = null;
      }
      if (!(($default & 256) === 0)) {
        initialBox_0._v = null;
      }
      if (!(($default & 512) === 0)) {
        initialCardMessage_0._v = null;
      }
      if (!(($default & 1024) === 0)) {
        initialCardBirthday_0._v = null;
      }
      if (!(($default & 2048) === 0)) {
        initialBoxMessage_0._v = null;
      }
      if (!(($default & 4096) === 0)) {
        initialBoxBirthday_0._v = null;
      }
      if (isTraceInProgress()) {
        traceEventStart(-2126249779, $dirty, $dirty1, 'client.fstech.hadaya.presentation.product_details.ProductDetailsScreen (ProductDetailsScreen.kt:114)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = toString_0(product.nzt_1);
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((59 & 1) === 0))
        qualifier = null;
      if (!((59 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((59 & 4) === 0))
        key = null;
      if (!((59 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((59 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((59 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(ProductDetailsViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, 1078418669, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance().f30_1) {
        var value = new SnackbarHostState();
        this_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp0_group;
      var verticalScrollState = rememberScrollState(0, $composer_0, 0, 1);
      var language = ProductDetailsScreen$lambda(state$delegate).s11d_1;
      var tmp0_elvis_lhs_0 = ProductDetailsScreen$lambda(state$delegate).n11d_1;
      var activeProduct = tmp0_elvis_lhs_0 == null ? product : tmp0_elvis_lhs_0;
      var tmp_2;
      if (language === 'en') {
        var tmp1_elvis_lhs = activeProduct.ozt_1;
        tmp_2 = tmp1_elvis_lhs == null ? activeProduct.pzt_1 : tmp1_elvis_lhs;
      } else {
        var tmp2_elvis_lhs = activeProduct.pzt_1;
        tmp_2 = tmp2_elvis_lhs == null ? activeProduct.ozt_1 : tmp2_elvis_lhs;
      }
      var tmp3_elvis_lhs = tmp_2;
      var name = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      var tmp_3;
      if (language === 'en') {
        var tmp4_elvis_lhs = activeProduct.qzt_1;
        tmp_3 = tmp4_elvis_lhs == null ? activeProduct.rzt_1 : tmp4_elvis_lhs;
      } else {
        var tmp5_elvis_lhs = activeProduct.rzt_1;
        tmp_3 = tmp5_elvis_lhs == null ? activeProduct.qzt_1 : tmp5_elvis_lhs;
      }
      var tmp6_elvis_lhs = tmp_3;
      var description = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
      var adaptiveInfo = currentWindowAdaptiveInfo(false, $composer_0, 0, 1);
      var isDesktop = adaptiveInfo.bxm_1.xxl(840);
      sourceInformationMarkerStart($composer_0, 1078443761, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!(!!(!!(!!(!!(!!(!!(!!(!!(!!($composer_0.q31(viewModel) | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(product)))) | ($dirty & 7168) === 2048) | ($dirty & 57344) === 16384) | (($dirty & 458752) === 131072 || (!(($dirty & 262144) === 0) && $composer_0.q31(initialOptions_0._v)))) | ($dirty & 3670016) === 1048576) | (($dirty & 29360128) === 8388608 || (!(($dirty & 16777216) === 0) && $composer_0.q31(initialCard_0._v)))) | (($dirty & 234881024) === 67108864 || (!(($dirty & 134217728) === 0) && $composer_0.q31(initialBox_0._v)))) | ($dirty & 1879048192) === 536870912) | ($dirty1 & 14) === 4) | ($dirty1 & 112) === 32) | ($dirty1 & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_0.i31();
      var tmp_4;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = ProductDetailsScreen$slambda_0(viewModel, product, initialSize_0, initialColor_0, initialOptions_0, initialComment_0, initialCard_0, initialBox_0, initialCardMessage_0, initialCardBirthday_0, initialBoxMessage_0, initialBoxBirthday_0, null);
        tmp0_0.j31(value_0);
        tmp_4 = value_0;
      } else {
        tmp_4 = it_0;
      }
      var tmp1_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(product, tmp1_group, $composer_0, 14 & $dirty);
      sourceInformationMarkerStart($composer_0, 1078473158, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.q31(viewModel) | ($dirty & 896) === 256);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_1.i31();
      var tmp_5;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = ProductDetailsScreen$slambda_2(viewModel, snackbarHostState, onNavigateToAuth, null);
        tmp0_1.j31(value_1);
        tmp_5 = value_1;
      } else {
        tmp_5 = it_1;
      }
      var tmp2_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(viewModel, tmp2_group, $composer_0, 0);
      var tmp7_safe_receiver = activeProduct.xzt_1;
      var tmp_6;
      if (tmp7_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s = tmp7_safe_receiver.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(element)) {
            destination.j1(element);
          }
        }
        tmp_6 = destination;
      }
      var tmp8_elvis_lhs = tmp_6;
      var images = tmp8_elvis_lhs == null ? emptyList() : tmp8_elvis_lhs;
      var tmp9_safe_receiver = activeProduct.yzt_1;
      var tmp_7;
      if (tmp9_safe_receiver == null) {
        tmp_7 = null;
      } else {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s_0 = tmp9_safe_receiver.t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(element_0)) {
            destination_0.j1(element_0);
          }
        }
        tmp_7 = destination_0;
      }
      var tmp10_elvis_lhs = tmp_7;
      var videos = tmp10_elvis_lhs == null ? emptyList() : tmp10_elvis_lhs;
      var combinedMedia = distinct(plus(images, videos));
      sourceInformationMarkerStart($composer_0, 1078496195, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_0.q31(combinedMedia);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_2.i31();
      var tmp_8;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = ProductDetailsScreen$lambda_0(combinedMedia);
        tmp0_2.j31(value_2);
        tmp_8 = value_2;
      } else {
        tmp_8 = it_2;
      }
      var tmp3_group = tmp_8;
      sourceInformationMarkerEnd($composer_0);
      var pagerState = rememberPagerState(0, 0.0, tmp3_group, $composer_0, 0, 3);
      sourceInformationMarkerStart($composer_0, 1078497615, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_3 = this_1.i31();
      var tmp_9;
      if (false || it_3 === Companion_getInstance().f30_1) {
        var value_3 = mutableStateOf(false);
        this_1.j31(value_3);
        tmp_9 = value_3;
      } else {
        tmp_9 = it_3;
      }
      var tmp4_group = tmp_9;
      sourceInformationMarkerEnd($composer_0);
      var isZooming$delegate = tmp4_group;
      sourceInformationMarkerStart($composer_0, 1078499727, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_4 = this_2.i31();
      var tmp_10;
      if (false || it_4 === Companion_getInstance().f30_1) {
        var value_4 = mutableStateOf(false);
        this_2.j31(value_4);
        tmp_10 = value_4;
      } else {
        tmp_10 = it_4;
      }
      var tmp5_group = tmp_10;
      sourceInformationMarkerEnd($composer_0);
      var showBirthdayPicker$delegate = tmp5_group;
      sourceInformationMarkerStart($composer_0, 1078502167, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_5 = this_3.i31();
      var tmp_11;
      if (false || it_5 === Companion_getInstance().f30_1) {
        var value_5 = mutableStateOf(null);
        this_3.j31(value_5);
        tmp_11 = value_5;
      } else {
        tmp_11 = it_5;
      }
      var tmp6_group = tmp_11;
      sourceInformationMarkerEnd($composer_0);
      var birthdayPickerTargetOptionKey$delegate = tmp6_group;
      sourceInformationMarkerStart($composer_0, 1078504559, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_4 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_6 = this_4.i31();
      var tmp_12;
      if (false || it_6 === Companion_getInstance().f30_1) {
        var value_6 = mutableStateOf(false);
        this_4.j31(value_6);
        tmp_12 = value_6;
      } else {
        tmp_12 = it_6;
      }
      var tmp7_group = tmp_12;
      sourceInformationMarkerEnd($composer_0);
      var isPickingBoxBirthday$delegate = tmp7_group;
      sourceInformationMarkerStart($composer_0, 1078506607, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_5 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_7 = this_5.i31();
      var tmp_13;
      if (false || it_7 === Companion_getInstance().f30_1) {
        var value_7 = mutableStateOf(false);
        this_5.j31(value_7);
        tmp_13 = value_7;
      } else {
        tmp_13 = it_7;
      }
      var tmp8_group = tmp_13;
      sourceInformationMarkerEnd($composer_0);
      var showDiscardDialog$delegate = tmp8_group;
      sourceInformationMarkerStart($composer_0, 1078508591, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_6 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_8 = this_6.i31();
      var tmp_14;
      if (false || it_8 === Companion_getInstance().f30_1) {
        var value_8 = mutableStateOf(false);
        this_6.j31(value_8);
        tmp_14 = value_8;
      } else {
        tmp_14 = it_8;
      }
      var tmp9_group = tmp_14;
      sourceInformationMarkerEnd($composer_0);
      var showMediaDialog$delegate = tmp9_group;
      sourceInformationMarkerStart($composer_0, 1078510638, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_7 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_9 = this_7.i31();
      var tmp_15;
      if (false || it_9 === Companion_getInstance().f30_1) {
        var value_9 = mutableIntStateOf(0);
        this_7.j31(value_9);
        tmp_15 = value_9;
      } else {
        tmp_15 = it_9;
      }
      var tmp10_group = tmp_15;
      sourceInformationMarkerEnd($composer_0);
      var initialMediaIndex$delegate = tmp10_group;
      var tmp_16 = _DisplayMode___init__impl__gfd230(0);
      var birthdayPickerState = rememberDatePickerState(null, null, null, tmp_16, null, $composer_0, 0, 31);
      var tmp_17 = ProductDetailsScreen$lambda(state$delegate).p11d_1 || ProductDetailsScreen$lambda_11(showMediaDialog$delegate);
      sourceInformationMarkerStart($composer_0, 1078515799, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_8 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_10 = this_8.i31();
      var tmp_18;
      if (false || it_10 === Companion_getInstance().f30_1) {
        var value_10 = ProductDetailsScreen$lambda_15(showMediaDialog$delegate, showDiscardDialog$delegate);
        this_8.j31(value_10);
        tmp_18 = value_10;
      } else {
        tmp_18 = it_10;
      }
      var tmp11_group = tmp_18;
      sourceInformationMarkerEnd($composer_0);
      BackHandler(tmp_17, tmp11_group, $composer_0, 48, 0);
      var tmp_19 = pagerState.zj9();
      sourceInformationMarkerStart($composer_0, 1078521550, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_9 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_11 = this_9.i31();
      var tmp_20;
      if (false || it_11 === Companion_getInstance().f30_1) {
        var value_11 = ProductDetailsScreen$slambda_4(isZooming$delegate, null);
        this_9.j31(value_11);
        tmp_20 = value_11;
      } else {
        tmp_20 = it_11;
      }
      var tmp12_group = tmp_20;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(tmp_19, tmp12_group, $composer_0, 0);
      if (ProductDetailsScreen$lambda_9(showDiscardDialog$delegate)) {
        $composer_0.m30(-925499233);
        sourceInformation($composer_0, '194@8958L46,195@9028L44,196@9098L82,200@9206L29,193@8919L326');
        var tmp_21 = stringResource(get_discard_order_title(string_instance), $composer_0, 0);
        var tmp_22 = stringResource(get_discard_order_msg(string_instance), $composer_0, 0);
        sourceInformationMarkerStart($composer_0, 1078529631, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        var tmp0_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = ($dirty & 112) === 32;
        // Inline function 'kotlin.let' call
        var it_12 = tmp0_3.i31();
        var tmp_23;
        if (invalid_2 || it_12 === Companion_getInstance().f30_1) {
          var value_12 = ProductDetailsScreen$lambda_16(onBack, showDiscardDialog$delegate);
          tmp0_3.j31(value_12);
          tmp_23 = value_12;
        } else {
          tmp_23 = it_12;
        }
        var tmp13_group = tmp_23;
        sourceInformationMarkerEnd($composer_0);
        sourceInformationMarkerStart($composer_0, 1078533034, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_10 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_13 = this_10.i31();
        var tmp_24;
        if (false || it_13 === Companion_getInstance().f30_1) {
          var value_13 = ProductDetailsScreen$lambda_17(showDiscardDialog$delegate);
          this_10.j31(value_13);
          tmp_24 = value_13;
        } else {
          tmp_24 = it_13;
        }
        var tmp14_group = tmp_24;
        sourceInformationMarkerEnd($composer_0);
        HadayaAlertDialog(tmp_21, tmp_22, null, null, tmp13_group, tmp14_group, $composer_0, 196608, 12);
        $composer_0.n30();
      } else {
        $composer_0.m30(-925170571);
        $composer_0.n30();
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = fillMaxSize(Companion_instance);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_2 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_3 = $composer_2;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_0);
      var tmp0_4 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_25 = $composer_4.g30();
      if (!isInterface(tmp_25, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_4);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_5 = $composer_4;
      var $composer_6 = $composer_5;
      sourceInformationMarkerStart($composer_6, -1370138634, 'C383@17181L128:ProductDetailsScreen.kt#8gd4xm');
      if (isDesktop) {
        $composer_6.m30(-1370349776);
        sourceInformation($composer_6, '206@9335L3347');
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_1 = fillMaxSize(Companion_instance);
        var horizontalArrangement = null;
        var verticalAlignment = null;
        var $composer_7 = $composer_6;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((6 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_7, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_8 = $composer_7;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
        var localMap_0 = $composer_8.t31();
        var materialized_0 = materialize($composer_8, modifier_2);
        var tmp0_5 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_9 = $composer_8;
        var tmp_26 = $composer_9.g30();
        if (!isInterface(tmp_26, Applier)) {
          invalidApplier();
        }
        $composer_9.b31();
        if ($composer_9.h30()) {
          $composer_9.c31(tmp0_5);
        } else {
          $composer_9.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_10 = $composer_9;
        var $composer_11 = $composer_10;
        sourceInformationMarkerStart($composer_11, 184639547, 'C208@9436L1705,249@11388L11,245@11213L1455:ProductDetailsScreen.kt#8gd4xm');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = fillMaxHeight(RowScopeInstance_instance.bdy(Companion_instance, 1.2));
        var contentAlignment_0 = null;
        var propagateMinConstraints_0 = false;
        var $composer_12 = $composer_11;
        if (!((6 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_13 = $composer_12;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_13, 0).hashCode();
        var localMap_1 = $composer_13.t31();
        var materialized_1 = materialize($composer_13, modifier_4);
        var tmp0_6 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_14 = $composer_13;
        var tmp_27 = $composer_14.g30();
        if (!isInterface(tmp_27, Applier)) {
          invalidApplier();
        }
        $composer_14.b31();
        if ($composer_14.h30()) {
          $composer_14.c31(tmp0_6);
        } else {
          $composer_14.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_14);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_15 = $composer_14;
        var $composer_16 = $composer_15;
        sourceInformationMarkerStart($composer_16, 1267012214, 'C214@9741L34,215@9822L31,209@9512L364,221@10037L21,218@9898L1225:ProductDetailsScreen.kt#8gd4xm');
        var tmp0_modifier = alpha(BoxScopeInstance_instance.udr(fillMaxWidth(Companion_instance, 0.8), Companion_getInstance_11().o8t_1), 0.03);
        var tmp1_painter = painterResource(get_logo(drawable_instance), $composer_16, 0);
        var tmp2_contentDescription = stringResource(get_logo_0(string_instance), $composer_16, 0);
        Image(tmp1_painter, tmp2_contentDescription, tmp0_modifier, null, null, 0.0, null, $composer_16, androidx_compose_ui_graphics_painter_Painter$stableprop_getter(), 120);
        var tmp_28 = fillMaxSize(Companion_instance);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_5 = verticalScroll(tmp_28, rememberScrollState(0, $composer_16, 0, 1));
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_17 = $composer_16;
        if (!((6 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_2 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_17, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_18 = $composer_17;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_18, 0).hashCode();
        var localMap_2 = $composer_18.t31();
        var materialized_2 = materialize($composer_18, modifier_6);
        var tmp0_7 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_19 = $composer_18;
        var tmp_29 = $composer_19.g30();
        if (!isInterface(tmp_29, Applier)) {
          invalidApplier();
        }
        $composer_19.b31();
        if ($composer_19.h30()) {
          $composer_19.c31(tmp0_7);
        } else {
          $composer_19.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_19);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_20 = $composer_19;
        var $composer_21 = $composer_20;
        sourceInformationMarkerStart($composer_21, -1710634346, 'C228@10377L18,229@10440L153,233@10632L163,238@10903L67,239@11010L65,223@10108L993:ProductDetailsScreen.kt#8gd4xm');
        var tmp_30 = ProductDetailsScreen$lambda_1(isZooming$delegate);
        sourceInformationMarkerStart($composer_21, -1994836770, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_14 = $composer_21.i31();
        var tmp_31;
        if (false || it_14 === Companion_getInstance().f30_1) {
          var value_14 = ProductDetailsScreen$lambda_18(isZooming$delegate);
          $composer_21.j31(value_14);
          tmp_31 = value_14;
        } else {
          tmp_31 = it_14;
        }
        var tmp0_group_0 = tmp_31;
        sourceInformationMarkerEnd($composer_21);
        sourceInformationMarkerStart($composer_21, -1994834619, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_15 = $composer_21.i31();
        var tmp_32;
        if (false || it_15 === Companion_getInstance().f30_1) {
          var value_15 = ProductDetailsScreen$lambda_19(initialMediaIndex$delegate, showMediaDialog$delegate);
          $composer_21.j31(value_15);
          tmp_32 = value_15;
        } else {
          tmp_32 = it_15;
        }
        var tmp1_group_0 = tmp_32;
        sourceInformationMarkerEnd($composer_21);
        sourceInformationMarkerStart($composer_21, -1994828465, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = !!($composer_0.k31(state$delegate) | ($dirty & 112) === 32);
        // Inline function 'kotlin.let' call
        var it_16 = $composer_21.i31();
        var tmp_33;
        if (invalid_3 || it_16 === Companion_getInstance().f30_1) {
          var value_16 = ProductDetailsScreen$lambda_20(onBack, state$delegate, showDiscardDialog$delegate);
          $composer_21.j31(value_16);
          tmp_33 = value_16;
        } else {
          tmp_33 = it_16;
        }
        var tmp2_group_0 = tmp_33;
        sourceInformationMarkerEnd($composer_21);
        var tmp_34 = ProductDetailsScreen$lambda(state$delegate).q11d_1;
        sourceInformationMarkerStart($composer_21, -1994819889, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = $composer_21.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_17 = $composer_21.i31();
        var tmp_35;
        if (invalid_4 || it_17 === Companion_getInstance().f30_1) {
          var value_17 = ProductDetailsScreen$lambda_21(viewModel);
          $composer_21.j31(value_17);
          tmp_35 = value_17;
        } else {
          tmp_35 = it_17;
        }
        var tmp3_group_0 = tmp_35;
        sourceInformationMarkerEnd($composer_21);
        sourceInformationMarkerStart($composer_21, -1994816467, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = $composer_21.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_18 = $composer_21.i31();
        var tmp_36;
        if (invalid_5 || it_18 === Companion_getInstance().f30_1) {
          var value_18 = ProductDetailsScreen$lambda_22(viewModel);
          $composer_21.j31(value_18);
          tmp_36 = value_18;
        } else {
          tmp_36 = it_18;
        }
        var tmp4_group_0 = tmp_36;
        sourceInformationMarkerEnd($composer_21);
        ProductMediaGallery(combinedMedia, pagerState, tmp_30, name, tmp0_group_0, tmp1_group_0, tmp2_group_0, tmp_34, tmp3_group_0, tmp4_group_0, $composer_21, 221184);
        sourceInformationMarkerEnd($composer_21);
        $composer_19.e31();
        sourceInformationMarkerEnd($composer_16);
        $composer_14.e31();
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_7 = background(fillMaxHeight(RowScopeInstance_instance.bdy(Companion_instance, 1.0)), MaterialTheme_instance.unz($composer_11, 6).mo0_1);
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = null;
        var $composer_22 = $composer_11;
        if (!((6 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_3 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_22, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_23 = $composer_22;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_23, 0).hashCode();
        var localMap_3 = $composer_23.t31();
        var materialized_3 = materialize($composer_23, modifier_8);
        var tmp0_8 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_24 = $composer_23;
        var tmp_37 = $composer_24.g30();
        if (!isInterface(tmp_37, Applier)) {
          invalidApplier();
        }
        $composer_24.b31();
        if ($composer_24.h30()) {
          $composer_24.c31(tmp0_8);
        } else {
          $composer_24.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_24);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_25 = $composer_24;
        var $composer_26 = $composer_25;
        sourceInformationMarkerStart($composer_26, 1507967296, 'C251@11449L898,273@12426L224:ProductDetailsScreen.kt#8gd4xm');
        var tmp_38 = verticalScroll(ColumnScopeInstance_instance.yds(Companion_instance, 1.0), verticalScrollState);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$120 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_9 = padding_0(tmp_38, tmp$ret$120);
        var verticalArrangement_1 = null;
        var horizontalAlignment_1 = null;
        var $composer_27 = $composer_26;
        if (!((6 & 1) === 0))
          modifier_9 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_1 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_1 = Companion_getInstance_11().w8t_1;
        var measurePolicy_4 = columnMeasurePolicy(verticalArrangement_1, horizontalAlignment_1, $composer_27, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_10 = modifier_9;
        var $composer_28 = $composer_27;
        if (!((0 & 2) === 0))
          modifier_10 = Companion_instance;
        var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_28, 0).hashCode();
        var localMap_4 = $composer_28.t31();
        var materialized_4 = materialize($composer_28, modifier_10);
        var tmp0_9 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_29 = $composer_28;
        var tmp_39 = $composer_29.g30();
        if (!isInterface(tmp_39, Applier)) {
          invalidApplier();
        }
        $composer_29.b31();
        if ($composer_29.h30()) {
          $composer_29.c31(tmp0_9);
        } else {
          $composer_29.d31();
        }
        var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_29);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
        var $composer_30 = $composer_29;
        var $composer_31 = $composer_30;
        sourceInformationMarkerStart($composer_31, -1581019596, 'C264@12067L232,257@11698L627:ProductDetailsScreen.kt#8gd4xm');
        var tmp_40 = ProductDetailsScreen$lambda(state$delegate);
        sourceInformationMarkerStart($composer_31, -882273212, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_19 = $composer_31.i31();
        var tmp_41;
        if (false || it_19 === Companion_getInstance().f30_1) {
          var value_19 = ProductDetailsScreen$lambda_23(birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
          $composer_31.j31(value_19);
          tmp_41 = value_19;
        } else {
          tmp_41 = it_19;
        }
        var tmp0_group_1 = tmp_41;
        sourceInformationMarkerEnd($composer_31);
        ProductInfoContent(activeProduct, tmp_40, name, description, language, viewModel, tmp0_group_1, $composer_31, 1572864);
        sourceInformationMarkerEnd($composer_31);
        $composer_29.e31();
        ProductActionBar(activeProduct, ProductDetailsScreen$lambda(state$delegate), language, viewModel, $composer_26, 0);
        sourceInformationMarkerEnd($composer_26);
        $composer_24.e31();
        sourceInformationMarkerEnd($composer_11);
        $composer_9.e31();
        $composer_6.n30();
      } else {
        $composer_6.m30(-1367014548);
        sourceInformation($composer_6, '283@12741L2842');
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_11 = fillMaxSize(Companion_instance);
        var verticalArrangement_2 = null;
        var horizontalAlignment_2 = null;
        var $composer_32 = $composer_6;
        if (!((6 & 1) === 0))
          modifier_11 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_2 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_2 = Companion_getInstance_11().w8t_1;
        var measurePolicy_5 = columnMeasurePolicy(verticalArrangement_2, horizontalAlignment_2, $composer_32, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_12 = modifier_11;
        var $composer_33 = $composer_32;
        if (!((0 & 2) === 0))
          modifier_12 = Companion_instance;
        var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_33, 0).hashCode();
        var localMap_5 = $composer_33.t31();
        var materialized_5 = materialize($composer_33, modifier_12);
        var tmp0_10 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_34 = $composer_33;
        var tmp_42 = $composer_34.g30();
        if (!isInterface(tmp_42, Applier)) {
          invalidApplier();
        }
        $composer_34.b31();
        if ($composer_34.h30()) {
          $composer_34.c31(tmp0_10);
        } else {
          $composer_34.d31();
        }
        var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_34);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
        var $composer_35 = $composer_34;
        var $composer_36 = $composer_35;
        sourceInformationMarkerStart($composer_36, -127116634, 'C284@12801L2546,339@15365L204:ProductDetailsScreen.kt#8gd4xm');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_13 = ColumnScopeInstance_instance.yds(Companion_instance, 1.0);
        var contentAlignment_1 = null;
        var propagateMinConstraints_1 = false;
        var $composer_37 = $composer_36;
        if (!((6 & 1) === 0))
          modifier_13 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment_1 = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints_1 = false;
        var measurePolicy_6 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_14 = modifier_13;
        var $composer_38 = $composer_37;
        if (!((0 & 2) === 0))
          modifier_14 = Companion_instance;
        var compositeKeyHash_6 = get_currentCompositeKeyHashCode($composer_38, 0).hashCode();
        var localMap_6 = $composer_38.t31();
        var materialized_6 = materialize($composer_38, modifier_14);
        var tmp0_11 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_39 = $composer_38;
        var tmp_43 = $composer_39.g30();
        if (!isInterface(tmp_43, Applier)) {
          invalidApplier();
        }
        $composer_39.b31();
        if ($composer_39.h30()) {
          $composer_39.c31(tmp0_11);
        } else {
          $composer_39.d31();
        }
        var $this$ReusableComposeNode_6 = _Updater___init__impl__rbfxm8($composer_39);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, measurePolicy_6, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, localMap_6, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, compositeKeyHash_6, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_6, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_6, materialized_6, Companion_getInstance_12().qah_1);
        var $composer_40 = $composer_39;
        var $composer_41 = $composer_40;
        sourceInformationMarkerStart($composer_41, 1700865174, 'C290@13088L34,291@13169L31,285@12859L364,294@13245L2084:ProductDetailsScreen.kt#8gd4xm');
        var tmp0_modifier_0 = alpha(BoxScopeInstance_instance.udr(fillMaxWidth(Companion_instance, 0.8), Companion_getInstance_11().o8t_1), 0.03);
        var tmp1_painter_0 = painterResource(get_logo(drawable_instance), $composer_41, 0);
        var tmp2_contentDescription_0 = stringResource(get_logo_0(string_instance), $composer_41, 0);
        Image(tmp1_painter_0, tmp2_contentDescription_0, tmp0_modifier_0, null, null, 0.0, null, $composer_41, androidx_compose_ui_graphics_painter_Painter$stableprop_getter(), 120);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_15 = verticalScroll(fillMaxSize(Companion_instance), verticalScrollState, !ProductDetailsScreen$lambda(state$delegate).p11d_1 && !ProductDetailsScreen$lambda_1(isZooming$delegate));
        var verticalArrangement_3 = null;
        var horizontalAlignment_3 = null;
        var $composer_42 = $composer_41;
        if (!((6 & 1) === 0))
          modifier_15 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_3 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_3 = Companion_getInstance_11().w8t_1;
        var measurePolicy_7 = columnMeasurePolicy(verticalArrangement_3, horizontalAlignment_3, $composer_42, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_16 = modifier_15;
        var $composer_43 = $composer_42;
        if (!((0 & 2) === 0))
          modifier_16 = Companion_instance;
        var compositeKeyHash_7 = get_currentCompositeKeyHashCode($composer_43, 0).hashCode();
        var localMap_7 = $composer_43.t31();
        var materialized_7 = materialize($composer_43, modifier_16);
        var tmp0_12 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_44 = $composer_43;
        var tmp_44 = $composer_44.g30();
        if (!isInterface(tmp_44, Applier)) {
          invalidApplier();
        }
        $composer_44.b31();
        if ($composer_44.h30()) {
          $composer_44.c31(tmp0_12);
        } else {
          $composer_44.d31();
        }
        var $this$ReusableComposeNode_7 = _Updater___init__impl__rbfxm8($composer_44);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, measurePolicy_7, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, localMap_7, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, compositeKeyHash_7, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_7, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_7, materialized_7, Companion_getInstance_12().qah_1);
        var $composer_45 = $composer_44;
        var $composer_46 = $composer_45;
        sourceInformationMarkerStart($composer_46, 951263457, 'C307@13863L18,308@13926L153,312@14118L163,317@14389L67,318@14496L65,302@13594L993,321@14613L41,330@15049L232,323@14680L627:ProductDetailsScreen.kt#8gd4xm');
        var tmp_45 = ProductDetailsScreen$lambda_1(isZooming$delegate);
        sourceInformationMarkerStart($composer_46, 169240163, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_20 = $composer_46.i31();
        var tmp_46;
        if (false || it_20 === Companion_getInstance().f30_1) {
          var value_20 = ProductDetailsScreen$lambda_24(isZooming$delegate);
          $composer_46.j31(value_20);
          tmp_46 = value_20;
        } else {
          tmp_46 = it_20;
        }
        var tmp0_group_2 = tmp_46;
        sourceInformationMarkerEnd($composer_46);
        sourceInformationMarkerStart($composer_46, 169242314, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_21 = $composer_46.i31();
        var tmp_47;
        if (false || it_21 === Companion_getInstance().f30_1) {
          var value_21 = ProductDetailsScreen$lambda_25(initialMediaIndex$delegate, showMediaDialog$delegate);
          $composer_46.j31(value_21);
          tmp_47 = value_21;
        } else {
          tmp_47 = it_21;
        }
        var tmp1_group_1 = tmp_47;
        sourceInformationMarkerEnd($composer_46);
        sourceInformationMarkerStart($composer_46, 169248468, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_6 = !!($composer_0.k31(state$delegate) | ($dirty & 112) === 32);
        // Inline function 'kotlin.let' call
        var it_22 = $composer_46.i31();
        var tmp_48;
        if (invalid_6 || it_22 === Companion_getInstance().f30_1) {
          var value_22 = ProductDetailsScreen$lambda_26(onBack, state$delegate, showDiscardDialog$delegate);
          $composer_46.j31(value_22);
          tmp_48 = value_22;
        } else {
          tmp_48 = it_22;
        }
        var tmp2_group_1 = tmp_48;
        sourceInformationMarkerEnd($composer_46);
        var tmp_49 = ProductDetailsScreen$lambda(state$delegate).q11d_1;
        sourceInformationMarkerStart($composer_46, 169257044, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_7 = $composer_46.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_23 = $composer_46.i31();
        var tmp_50;
        if (invalid_7 || it_23 === Companion_getInstance().f30_1) {
          var value_23 = ProductDetailsScreen$lambda_27(viewModel);
          $composer_46.j31(value_23);
          tmp_50 = value_23;
        } else {
          tmp_50 = it_23;
        }
        var tmp3_group_1 = tmp_50;
        sourceInformationMarkerEnd($composer_46);
        sourceInformationMarkerStart($composer_46, 169260466, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_8 = $composer_46.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_24 = $composer_46.i31();
        var tmp_51;
        if (invalid_8 || it_24 === Companion_getInstance().f30_1) {
          var value_24 = ProductDetailsScreen$lambda_28(viewModel);
          $composer_46.j31(value_24);
          tmp_51 = value_24;
        } else {
          tmp_51 = it_24;
        }
        var tmp4_group_1 = tmp_51;
        sourceInformationMarkerEnd($composer_46);
        ProductMediaGallery(combinedMedia, pagerState, tmp_45, name, tmp0_group_2, tmp1_group_1, tmp2_group_1, tmp_49, tmp3_group_1, tmp4_group_1, $composer_46, 221184);
        var tmp_52 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$169 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_52, tmp$ret$169), $composer_46, 6);
        var tmp_53 = ProductDetailsScreen$lambda(state$delegate);
        sourceInformationMarkerStart($composer_46, 169278329, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_25 = $composer_46.i31();
        var tmp_54;
        if (false || it_25 === Companion_getInstance().f30_1) {
          var value_25 = ProductDetailsScreen$lambda_29(birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate, showBirthdayPicker$delegate);
          $composer_46.j31(value_25);
          tmp_54 = value_25;
        } else {
          tmp_54 = it_25;
        }
        var tmp5_group_0 = tmp_54;
        sourceInformationMarkerEnd($composer_46);
        ProductInfoContent(activeProduct, tmp_53, name, description, language, viewModel, tmp5_group_0, $composer_46, 1572864);
        sourceInformationMarkerEnd($composer_46);
        $composer_44.e31();
        sourceInformationMarkerEnd($composer_41);
        $composer_39.e31();
        ProductActionBar(activeProduct, ProductDetailsScreen$lambda(state$delegate), language, viewModel, $composer_36, 0);
        sourceInformationMarkerEnd($composer_36);
        $composer_34.e31();
        $composer_6.n30();
      }
      if (ProductDetailsScreen$lambda(state$delegate).p11d_1) {
        $composer_6.m30(-1364148939);
        sourceInformation($composer_6, '349@15643L1518');
        var tmp_55 = fillMaxSize(Companion_instance);
        var tmp_56 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.5);
        var tmp_57 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_58 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_59 = _Dp___init__impl__ms3zkb(0.0);
        Surface(tmp_55, null, tmp_56, tmp_57, tmp_58, tmp_59, null, ComposableSingletons$ProductDetailsScreenKt_getInstance().x141_1, $composer_6, 12583302, 122);
        $composer_6.n30();
      } else {
        $composer_6.m30(-1362667077);
        $composer_6.n30();
      }
      var tmp_60 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(snackbarHostState, tmp_60, null, $composer_6, 6, 4);
      if (ProductDetailsScreen$lambda_11(showMediaDialog$delegate)) {
        $composer_6.m30(-1362492020);
        sourceInformation($composer_6, '393@17528L27,389@17354L215');
        var tmp_61 = ProductDetailsScreen$lambda_13(initialMediaIndex$delegate);
        sourceInformationMarkerStart($composer_6, 1618622434, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_26 = $composer_6.i31();
        var tmp_62;
        if (false || it_26 === Companion_getInstance().f30_1) {
          var value_26 = ProductDetailsScreen$lambda_30(showMediaDialog$delegate);
          $composer_6.j31(value_26);
          tmp_62 = value_26;
        } else {
          tmp_62 = it_26;
        }
        var tmp0_group_3 = tmp_62;
        sourceInformationMarkerEnd($composer_6);
        ProductMediaGalleryDialog(combinedMedia, name, tmp_61, tmp0_group_3, $composer_6, 3072, 0);
        $composer_6.n30();
      } else {
        $composer_6.m30(-1362262341);
        $composer_6.n30();
      }
      if (ProductDetailsScreen$lambda_3(showBirthdayPicker$delegate)) {
        $composer_6.m30(-1362155608);
        sourceInformation($composer_6, '399@17680L124,403@17838L1661,433@19533L339,442@19887L71,398@17627L2331');
        sourceInformationMarkerStart($composer_6, 1618627395, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_27 = $composer_6.i31();
        var tmp_63;
        if (false || it_27 === Companion_getInstance().f30_1) {
          var value_27 = ProductDetailsScreen$lambda_31(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate);
          $composer_6.j31(value_27);
          tmp_63 = value_27;
        } else {
          tmp_63 = it_27;
        }
        var tmp1_group_2 = tmp_63;
        sourceInformationMarkerEnd($composer_6);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1567829023, true, ProductDetailsScreen$lambda_32(birthdayPickerState, state$delegate, viewModel, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate, showBirthdayPicker$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_47 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_9 = $composer_47.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_28 = $composer_47.i31();
        var tmp_64;
        if (invalid_9 || it_28 === Companion_getInstance().f30_1) {
          var value_28 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_47.j31(value_28);
          tmp_64 = value_28;
        } else {
          tmp_64 = it_28;
        }
        var tmp_65 = tmp_64;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-1277484385, true, ProductDetailsScreen$lambda_33(showBirthdayPicker$delegate, birthdayPickerTargetOptionKey$delegate, isPickingBoxBirthday$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_48 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_10 = $composer_48.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_29 = $composer_48.i31();
        var tmp_66;
        if (invalid_10 || it_29 === Companion_getInstance().f30_1) {
          var value_29 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_48.j31(value_29);
          tmp_66 = value_29;
        } else {
          tmp_66 = it_29;
        }
        var tmp_67 = tmp_66;
        var tmp_68 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(-614642198, true, ProductDetailsScreen$lambda_34(birthdayPickerState), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_49 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_11 = $composer_49.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_30 = $composer_49.i31();
        var tmp_69;
        if (invalid_11 || it_30 === Companion_getInstance().f30_1) {
          var value_30 = ComposableLambda$invoke$ref_6(dispatchReceiver_1);
          $composer_49.j31(value_30);
          tmp_69 = value_30;
        } else {
          tmp_69 = it_30;
        }
        var tmp$ret$196 = tmp_69;
        DatePickerDialog(tmp1_group_2, tmp_65, null, tmp_67, null, tmp_68, null, null, tmp$ret$196, $composer_6, 100666422, 244);
        $composer_6.n30();
      } else {
        $composer_6.m30(-1359892453);
        $composer_6.n30();
      }
      sourceInformationMarkerEnd($composer_6);
      $composer_4.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp15_safe_receiver = $composer_0.t30();
    if (tmp15_safe_receiver == null)
      null;
    else {
      tmp15_safe_receiver.p3c(ProductDetailsScreen$lambda_35(product, onBack, onNavigateToAuth, initialSize_0, initialColor_0, initialOptions_0, initialComment_0, initialCard_0, initialBox_0, initialCardMessage_0, initialCardBirthday_0, initialBoxMessage_0, initialBoxBirthday_0, $changed, $changed1, $default));
    }
  }
  function ProductMediaGallery(combinedMedia, pagerState, isZooming, name, onZoomChanged, onMediaClick, onBack, isFavorite, onToggleFavorite, onShare, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1428938827);
    sourceInformation($composer_0, 'C(ProductMediaGallery)P(!1,9,2,3,8,5,4!1,7)462@20338L5768:ProductDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(combinedMedia) : $composer_0.q31(combinedMedia)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(pagerState) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.l31(isZooming) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(name) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onZoomChanged) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onMediaClick) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.l31(isFavorite) ? 8388608 : 4194304);
    if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.q31(onToggleFavorite) ? 67108864 : 33554432);
    if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.q31(onShare) ? 536870912 : 268435456);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1428938827, $dirty, -1, 'client.fstech.hadaya.presentation.product_details.ProductMediaGallery (ProductDetailsScreen.kt:461)');
      }
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = null;
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((7 & 1) === 0))
        modifier = Companion_instance;
      if (!((7 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((7 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 304834109, 'C468@20580L11,463@20355L4248:ProductDetailsScreen.kt#8gd4xm');
      var tmp_0 = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(400);
      var tmp_1 = height(tmp_0, tmp$ret$6);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp0_bottomStart = _Dp___init__impl__ms3zkb(32);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp1_bottomEnd = _Dp___init__impl__ms3zkb(32);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_1 = background(clip(tmp_1, RoundedCornerShape_0(VOID, VOID, tmp1_bottomEnd, tmp0_bottomStart)), Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_5, 6).oo0_1, 0.3));
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_6 = $composer_5;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_2 = $composer_8.g30();
      if (!isInterface(tmp_2, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_0);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, 574276590, 'C474@20816L370,470@20651L535,486@21231L1763,530@23259L11,528@23077L40,527@23042L902:ProductDetailsScreen.kt#8gd4xm');
      var tmp_3 = fillMaxSize(Companion_instance);
      var tmp_4 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_5 = !isZooming;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1012463378, true, ProductMediaGallery$lambda(combinedMedia, name, onZoomChanged), $composer_10, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_11 = $composer_10;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_11.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_11.i31();
      var tmp_6;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref_7(dispatchReceiver);
        $composer_11.j31(value);
        tmp_6 = value;
      } else {
        tmp_6 = it;
      }
      var tmp$ret$15 = tmp_6;
      HorizontalPager(pagerState, tmp_3, null, null, 0, tmp_4, null, null, tmp_5, false, null, null, null, null, tmp$ret$15, $composer_10, 48 | 14 & $dirty >> 3, 24576, 16124);
      var tmp0_$receiver = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp1_top = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp2_start = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp3_end = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_3 = padding_1(tmp0_$receiver, tmp2_start, tmp1_top, tmp3_end);
      var horizontalArrangement = Arrangement_getInstance().wdp_1;
      var verticalAlignment = null;
      var $composer_12 = $composer_10;
      if (!((4 & 1) === 0))
        modifier_3 = Companion_instance;
      if (!((4 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((4 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_12, 14 & 48 >> 3 | 112 & 48 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_4 = modifier_3;
      var $composer_13 = $composer_12;
      if (!((0 & 2) === 0))
        modifier_4 = Companion_instance;
      var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_13, 0).hashCode();
      var localMap_1 = $composer_13.t31();
      var materialized_1 = materialize($composer_13, modifier_4);
      var tmp0_1 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_14 = $composer_13;
      var tmp_7 = $composer_14.g30();
      if (!isInterface(tmp_7, Applier)) {
        invalidApplier();
      }
      $composer_14.b31();
      if ($composer_14.h30()) {
        $composer_14.c31(tmp0_1);
      } else {
        $composer_14.d31();
      }
      var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_14);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
      var $composer_15 = $composer_14;
      var $composer_16 = $composer_15;
      sourceInformationMarkerStart($composer_16, 2014329496, 'C492@21476L413,503@21907L1073:ProductDetailsScreen.kt#8gd4xm');
      var tmp_8 = background(Companion_instance, Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.7), get_CircleShape());
      IconButton(onBack, tmp_8, false, null, null, null, ComposableSingletons$ProductDetailsScreenKt_getInstance().a142_1, $composer_16, 1572864 | 14 & $dirty >> 18, 60);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_5 = null;
      var horizontalArrangement_0 = null;
      var verticalAlignment_0 = null;
      var $composer_17 = $composer_16;
      if (!((7 & 1) === 0))
        modifier_5 = Companion_instance;
      if (!((7 & 2) === 0))
        horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
      if (!((7 & 4) === 0))
        verticalAlignment_0 = Companion_getInstance_11().t8t_1;
      var measurePolicy_2 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_17, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_6 = modifier_5;
      var $composer_18 = $composer_17;
      if (!((0 & 2) === 0))
        modifier_6 = Companion_instance;
      var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_18, 0).hashCode();
      var localMap_2 = $composer_18.t31();
      var materialized_2 = materialize($composer_18, modifier_6);
      var tmp0_2 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_19 = $composer_18;
      var tmp_9 = $composer_19.g30();
      if (!isInterface(tmp_9, Applier)) {
        invalidApplier();
      }
      $composer_19.b31();
      if ($composer_19.h30()) {
        $composer_19.c31(tmp0_2);
      } else {
        $composer_19.d31();
      }
      var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_19);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
      var $composer_20 = $composer_19;
      var $composer_21 = $composer_20;
      sourceInformationMarkerStart($composer_21, -1403711497, 'C507@22119L465,504@21933L651,516@22605L39,517@22665L297:ProductDetailsScreen.kt#8gd4xm');
      var tmp_10 = background(Companion_instance, Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.7), get_CircleShape());
      // Inline function 'kotlin.run' call
      var dispatchReceiver_0 = rememberComposableLambda(-367212247, true, ProductMediaGallery$lambda_0(isFavorite), $composer_21, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_22 = $composer_21;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_22.k31(dispatchReceiver_0);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_22.i31();
      var tmp_11;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = ComposableLambda$invoke$ref(dispatchReceiver_0);
        $composer_22.j31(value_0);
        tmp_11 = value_0;
      } else {
        tmp_11 = it_0;
      }
      var tmp$ret$37 = tmp_11;
      IconButton(onToggleFavorite, tmp_10, false, null, null, null, tmp$ret$37, $composer_21, 1572864 | 14 & $dirty >> 24, 60);
      var tmp_12 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$44 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_12, tmp$ret$44), $composer_21, 6);
      var tmp_13 = background(Companion_instance, Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.7), get_CircleShape());
      IconButton(onShare, tmp_13, false, null, null, null, ComposableSingletons$ProductDetailsScreenKt_getInstance().c142_1, $composer_21, 1572864 | 14 & $dirty >> 27, 60);
      sourceInformationMarkerEnd($composer_21);
      $composer_19.e31();
      sourceInformationMarkerEnd($composer_16);
      $composer_14.e31();
      var tmp_14 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$45 = _Dp___init__impl__ms3zkb(16);
      var tmp4_modifier = zIndex(padding_1(tmp_14, VOID, VOID, VOID, tmp$ret$45), 1.0);
      var tmp5_color = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_10, 6).eo0_1, 0.8);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$46 = _Dp___init__impl__ms3zkb(24);
      var tmp6_shape = RoundedCornerShape(tmp$ret$46);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp7_shadowElevation = _Dp___init__impl__ms3zkb(6);
      sourceInformationMarkerStart($composer_10, 1958261431, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(($dirty & 458752) === 131072 | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_10.i31();
      var tmp_15;
      if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = ProductMediaGallery$lambda_1(onMediaClick, pagerState);
        $composer_10.j31(value_1);
        tmp_15 = value_1;
      } else {
        tmp_15 = it_1;
      }
      var tmp0_group = tmp_15;
      sourceInformationMarkerEnd($composer_10);
      var tmp_16 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_17 = _Dp___init__impl__ms3zkb(0.0);
      Surface_0(tmp0_group, tmp4_modifier, false, tmp6_shape, tmp5_color, tmp_16, tmp_17, tmp7_shadowElevation, null, null, ComposableSingletons$ProductDetailsScreenKt_getInstance().d142_1, $composer_10, 12582912, 6, 868);
      if (combinedMedia.n1() > 1) {
        $composer_10.m30(577510354);
        sourceInformation($composer_10, '546@24034L545');
        var tmp_18 = BoxScopeInstance_instance.udr(fillMaxWidth(Companion_instance), Companion_getInstance_11().r8t_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$52 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_7 = padding_1(tmp_18, VOID, VOID, VOID, tmp$ret$52);
        var horizontalArrangement_1 = Arrangement_getInstance().udp_1;
        var verticalAlignment_1 = null;
        var $composer_23 = $composer_10;
        if (!((4 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((4 & 2) === 0))
          horizontalArrangement_1 = Arrangement_getInstance().qdp_1;
        if (!((4 & 4) === 0))
          verticalAlignment_1 = Companion_getInstance_11().t8t_1;
        var measurePolicy_3 = rowMeasurePolicy(horizontalArrangement_1, verticalAlignment_1, $composer_23, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_24 = $composer_23;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_24, 0).hashCode();
        var localMap_3 = $composer_24.t31();
        var materialized_3 = materialize($composer_24, modifier_8);
        var tmp0_3 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_25 = $composer_24;
        var tmp_19 = $composer_25.g30();
        if (!isInterface(tmp_19, Applier)) {
          invalidApplier();
        }
        $composer_25.b31();
        if ($composer_25.h30()) {
          $composer_25.c31(tmp0_3);
        } else {
          $composer_25.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_25);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_26 = $composer_25;
        var $composer_27 = $composer_26;
        sourceInformationMarkerStart($composer_27, -1510526701, 'C:ProductDetailsScreen.kt#8gd4xm');
        $composer_27.m30(-187274000);
        sourceInformation($composer_27, '*552@24454L85');
        // Inline function 'kotlin.repeat' call
        var times = combinedMedia.n1();
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp_20;
            if (pagerState.zj9() === index) {
              $composer_27.m30(520060935);
              sourceInformation($composer_27, '551@24374L11');
              var tmp0_group_0 = MaterialTheme_instance.unz($composer_27, 6).xnz_1;
              $composer_27.n30();
              tmp_20 = tmp0_group_0;
            } else {
              $composer_27.m30(520061746);
              $composer_27.n30();
              tmp_20 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.6);
            }
            var color = tmp_20;
            var tmp_21 = Companion_instance;
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$61 = _Dp___init__impl__ms3zkb(4);
            var tmp_22 = background(clip(padding_0(tmp_21, tmp$ret$61), get_CircleShape()), color);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$62 = _Dp___init__impl__ms3zkb(8);
            Box(size(tmp_22, tmp$ret$62), $composer_27, 0);
          }
           while (inductionVariable < times);
        $composer_27.n30();
        sourceInformationMarkerEnd($composer_27);
        $composer_25.e31();
        $composer_10.n30();
      } else {
        $composer_10.m30(578064851);
        $composer_10.n30();
      }
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      if (combinedMedia.n1() > 1) {
        $composer_5.m30(308987240);
        sourceInformation($composer_5, '564@24914L1176,560@24677L1413');
        var tmp_23 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$63 = _Dp___init__impl__ms3zkb(16);
        var tmp2_modifier = padding_2(tmp_23, VOID, tmp$ret$63);
        var tmp_24 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$64 = _Dp___init__impl__ms3zkb(12);
        var tmp3_horizontalArrangement = tmp_24.mdq(tmp$ret$64);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$65 = _Dp___init__impl__ms3zkb(24);
        var tmp4_contentPadding = PaddingValues_0(tmp$ret$65);
        sourceInformationMarkerStart($composer_5, -267119987, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = !!(!!((($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(combinedMedia))) | ($dirty & 112) === 32) | ($dirty & 458752) === 131072);
        // Inline function 'kotlin.let' call
        var it_2 = $composer_5.i31();
        var tmp_25;
        if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
          var value_2 = ProductMediaGallery$lambda_2(combinedMedia, pagerState, onMediaClick);
          $composer_5.j31(value_2);
          tmp_25 = value_2;
        } else {
          tmp_25 = it_2;
        }
        var tmp0_group_1 = tmp_25;
        sourceInformationMarkerEnd($composer_5);
        LazyRow(tmp2_modifier, null, tmp4_contentPadding, false, tmp3_horizontalArrangement, null, null, false, null, tmp0_group_1, $composer_5, 24966, 490);
        $composer_5.n30();
      } else {
        $composer_5.m30(310355053);
        $composer_5.n30();
      }
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ProductMediaGallery$lambda_3(combinedMedia, pagerState, isZooming, name, onZoomChanged, onMediaClick, onBack, isFavorite, onToggleFavorite, onShare, $changed));
    }
  }
  function ProductInfoContent(activeProduct, state, name, description, language, viewModel, onShowBirthdayPicker, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(4329664);
    sourceInformation($composer_0, 'C(ProductInfoContent)P(!1,5,3!2,6)597@26372L9448:ProductDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(activeProduct) : $composer_0.q31(activeProduct)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(name) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(description) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(viewModel) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(onShowBirthdayPicker) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 599187) === 599186), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(4329664, $dirty, -1, 'client.fstech.hadaya.presentation.product_details.ProductInfoContent (ProductDetailsScreen.kt:596)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = padding_2(tmp, tmp$ret$0);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 373548589, 'C598@26478L10,598@26438L101,599@26548L41,602@26626L1718,619@28354L40,620@28504L10,620@28548L11,620@28403L199,621@28611L41,708@34087L41,711@34226L100,716@34562L109,709@34137L544,718@34690L41,719@34740L108,720@34857L41:ProductDetailsScreen.kt#8gd4xm');
      var tmp0_style = MaterialTheme_instance.jog($composer_5, 6).jof_1;
      var tmp1_fontWeight = Companion_getInstance_16().f7z_1;
      var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextOverflow___init__impl__obguoe(0);
      Text(name, null, tmp_1, null, tmp_2, null, tmp1_fontWeight, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, tmp0_style, $composer_5, 1572864 | 14 & $dirty >> 6, 0, 131006);
      var tmp_6 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_6, tmp$ret$7), $composer_5, 6);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = null;
      var verticalArrangement_0 = null;
      var horizontalAlignment_0 = null;
      var $composer_6 = $composer_5;
      if (!((7 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((7 & 2) === 0))
        verticalArrangement_0 = Arrangement_getInstance().sdp_1;
      if (!((7 & 4) === 0))
        horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_6, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_7 = $composer_8.g30();
      if (!isInterface(tmp_7, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_0);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, 190347872, 'C609@27417L917:ProductDetailsScreen.kt#8gd4xm');
      var tmp0_safe_receiver = state.v11d_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lyz_1;
      var tmp_8 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
      var tmp2_safe_receiver = state.z11d_1;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.wyz_1;
      var tmp_9 = tmp_8 + (tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs);
      // Inline function 'kotlin.collections.sumOf' call
      var sum = 0;
      var _iterator__ex2g4s = state.f11e_1.y2().t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var tmp_10 = sum;
        var tmp0_elvis_lhs = element.q100_1;
        sum = tmp_10 + (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
      }
      var extraOriginalPrice = tmp_9 + sum;
      var tmp4_safe_receiver = state.v11d_1;
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.lyz_1;
      var tmp_11 = tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs;
      var tmp6_safe_receiver = state.z11d_1;
      var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.wyz_1;
      var tmp_12 = tmp_11 + (tmp7_elvis_lhs == null ? 0.0 : tmp7_elvis_lhs);
      // Inline function 'kotlin.collections.sumOf' call
      var sum_0 = 0;
      var _iterator__ex2g4s_0 = state.f11e_1.y2().t();
      while (_iterator__ex2g4s_0.u()) {
        var element_0 = _iterator__ex2g4s_0.v();
        var tmp_13 = sum_0;
        var tmp_14;
        var tmp0_elvis_lhs_0 = element_0.r100_1;
        if ((tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0) > 0.0) {
          tmp_14 = ensureNotNull(element_0.r100_1);
        } else {
          var tmp1_elvis_lhs_0 = element_0.q100_1;
          tmp_14 = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
        }
        sum_0 = tmp_13 + tmp_14;
      }
      var extraDiscountedPrice = tmp_12 + sum_0;
      var tmp8_elvis_lhs = activeProduct.szt_1;
      var finalOriginalPrice = (tmp8_elvis_lhs == null ? 0.0 : tmp8_elvis_lhs) + extraOriginalPrice;
      var tmp_15;
      var tmp9_elvis_lhs = activeProduct.tzt_1;
      if ((tmp9_elvis_lhs == null ? 0.0 : tmp9_elvis_lhs) > 0.0) {
        tmp_15 = ensureNotNull(activeProduct.tzt_1);
      } else {
        var tmp10_elvis_lhs = activeProduct.szt_1;
        tmp_15 = tmp10_elvis_lhs == null ? 0.0 : tmp10_elvis_lhs;
      }
      var finalDiscountedPrice = tmp_15 + extraDiscountedPrice;
      var tmp_16;
      var tmp11_elvis_lhs = activeProduct.tzt_1;
      if ((tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs) > 0.0) {
        tmp_16 = true;
      } else {
        var tmp0_1 = state.f11e_1.y2();
        var tmp$ret$18;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_17;
          if (isInterface(tmp0_1, Collection)) {
            tmp_17 = tmp0_1.r();
          } else {
            tmp_17 = false;
          }
          if (tmp_17) {
            tmp$ret$18 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s_1 = tmp0_1.t();
          while (_iterator__ex2g4s_1.u()) {
            var element_1 = _iterator__ex2g4s_1.v();
            var tmp0_elvis_lhs_1 = element_1.r100_1;
            if ((tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1) > 0.0) {
              tmp$ret$18 = true;
              break $l$block_0;
            }
          }
          tmp$ret$18 = false;
        }
        tmp_16 = tmp$ret$18;
      }
      var hasDiscount = tmp_16;
      var tmp12_verticalAlignment = Companion_getInstance_11().v8t_1;
      var tmp_18 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$20 = _Dp___init__impl__ms3zkb(12);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_3 = null;
      var horizontalArrangement = tmp_18.mdq(tmp$ret$20);
      var verticalAlignment = tmp12_verticalAlignment;
      var $composer_11 = $composer_10;
      if (!((1 & 1) === 0))
        modifier_3 = Companion_instance;
      if (!((1 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((1 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_11, 14 & 432 >> 3 | 112 & 432 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_4 = modifier_3;
      var $composer_12 = $composer_11;
      if (!((0 & 2) === 0))
        modifier_4 = Companion_instance;
      var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
      var localMap_1 = $composer_12.t31();
      var materialized_1 = materialize($composer_12, modifier_4);
      var tmp0_2 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_13 = $composer_12;
      var tmp_19 = $composer_13.g30();
      if (!isInterface(tmp_19, Applier)) {
        invalidApplier();
      }
      $composer_13.b31();
      if ($composer_13.h30()) {
        $composer_13.c31(tmp0_2);
      } else {
        $composer_13.d31();
      }
      var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
      var $composer_14 = $composer_13;
      var $composer_15 = $composer_14;
      sourceInformationMarkerStart($composer_15, -1425788323, 'C:ProductDetailsScreen.kt#8gd4xm');
      if (hasDiscount) {
        $composer_15.m30(-1425779582);
        sourceInformation($composer_15, '611@27574L79,611@27719L11,611@27569L201,612@27796L77,612@27939L11,612@27791L266');
        var tmp0_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalDiscountedPrice)], $composer_15, 0), language);
        var tmp1_fontSize = get_sp(28);
        var tmp2_color = MaterialTheme_instance.unz($composer_15, 6).xnz_1;
        var tmp3_fontWeight = Companion_getInstance_16().g7z_1;
        var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_21 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_22 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp2_color, null, tmp1_fontSize, null, tmp3_fontWeight, null, tmp_20, null, null, tmp_21, tmp_22, false, 0, 0, null, null, $composer_15, 1597440, 0, 262058);
        var tmp4_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_15, 0), language);
        var tmp5_fontSize = get_sp(18);
        var tmp6_color = MaterialTheme_instance.unz($composer_15, 6).po0_1;
        var tmp7_textDecoration = Companion_getInstance_18().c80_1;
        var tmp_23 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$27 = _Dp___init__impl__ms3zkb(4);
        var tmp8_modifier = padding_1(tmp_23, VOID, VOID, VOID, tmp$ret$27);
        var tmp_24 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_25 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_26 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp4_text, tmp8_modifier, tmp6_color, null, tmp5_fontSize, null, null, null, tmp_24, tmp7_textDecoration, null, tmp_25, tmp_26, false, 0, 0, null, null, $composer_15, 805330992, 0, 261608);
        $composer_15.n30();
      } else {
        $composer_15.m30(-1425238229);
        sourceInformation($composer_15, '614@28108L77,614@28251L11,614@28103L199');
        var tmp9_text = formatNumbers(stringResource_0(get_price_egp(string_instance), [toTwoDecimalString(finalOriginalPrice)], $composer_15, 0), language);
        var tmp10_fontSize = get_sp(28);
        var tmp11_color = MaterialTheme_instance.unz($composer_15, 6).xnz_1;
        var tmp12_fontWeight = Companion_getInstance_16().g7z_1;
        var tmp_27 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_28 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_29 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp9_text, null, tmp11_color, null, tmp10_fontSize, null, tmp12_fontWeight, null, tmp_27, null, null, tmp_28, tmp_29, false, 0, 0, null, null, $composer_15, 1597440, 0, 262058);
        $composer_15.n30();
      }
      sourceInformationMarkerEnd($composer_15);
      $composer_13.e31();
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      var tmp_30 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$28 = _Dp___init__impl__ms3zkb(8);
      Spacer(height(tmp_30, tmp$ret$28), $composer_5, 6);
      $composer_5.m30(-403537717);
      sourceInformation($composer_5, '*620@28437L41');
      // Inline function 'kotlin.text.ifBlank' call
      var tmp_31;
      if (isBlank(description)) {
        tmp_31 = stringResource(get_no_description(string_instance), $composer_5, 0);
      } else {
        tmp_31 = description;
      }
      var tmp0_group = tmp_31;
      $composer_5.n30();
      var tmp3_style = MaterialTheme_instance.jog($composer_5, 6).oof_1;
      var tmp4_color = MaterialTheme_instance.unz($composer_5, 6).no0_1;
      var tmp5_fontWeight = Companion_getInstance_16().c7z_1;
      var tmp_32 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_33 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_34 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_35 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_group, null, tmp4_color, null, tmp_32, null, tmp5_fontWeight, null, tmp_33, null, null, tmp_34, tmp_35, false, 0, 0, null, tmp3_style, $composer_5, 1572864, 0, 131002);
      var tmp_36 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$31 = _Dp___init__impl__ms3zkb(24);
      Spacer(height(tmp_36, tmp$ret$31), $composer_5, 6);
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!state.i11e_1.r()) {
        $composer_5.m30(375584389);
        sourceInformation($composer_5, '626@28783L38,629@28968L112,625@28737L394,655@30599L41');
        var tmp_37 = stringResource(get_select_card(string_instance), $composer_5, 0);
        var tmp6_safe_receiver_0 = state.v11d_1;
        var tmp_38 = tmp6_safe_receiver_0 == null ? null : tmp6_safe_receiver_0.gyz_1;
        sourceInformationMarkerStart($composer_5, -403520346, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it = $composer_5.i31();
        var tmp_39;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProductInfoContent$lambda(viewModel);
          $composer_5.j31(value);
          tmp_39 = value;
        } else {
          tmp_39 = it;
        }
        var tmp1_group = tmp_39;
        sourceInformationMarkerEnd($composer_5);
        GiftSelectionSection(tmp_37, state.i11e_1, tmp_38, tmp1_group, language, false, $composer_5, 57344 & $dirty, 32);
        var tmp10_safe_receiver = state.v11d_1;
        if ((tmp10_safe_receiver == null ? null : tmp10_safe_receiver.oyz_1) === true) {
          $composer_5.m30(376005834);
          sourceInformation($composer_5, '633@29205L41,636@29365L96,640@29724L105,634@29263L584');
          var tmp_40 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$37 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_40, tmp$ret$37), $composer_5, 6);
          var tmp7_value = state.w11d_1;
          var tmp_41 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$38 = _Dp___init__impl__ms3zkb(24);
          var tmp8_modifier_0 = padding_2(tmp_41, tmp$ret$38);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$39 = _Dp___init__impl__ms3zkb(12);
          var tmp9_shape = RoundedCornerShape(tmp$ret$39);
          sourceInformationMarkerStart($composer_5, -403507658, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = $composer_0.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_0 = $composer_5.i31();
          var tmp_42;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = ProductInfoContent$lambda_0(viewModel);
            $composer_5.j31(value_0);
            tmp_42 = value_0;
          } else {
            tmp_42 = it_0;
          }
          var tmp2_group = tmp_42;
          sourceInformationMarkerEnd($composer_5);
          var tmp_43 = ComposableSingletons$ProductDetailsScreenKt_getInstance().e142_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-945988781, true, ProductInfoContent$lambda_1(state), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_16 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_1 = $composer_16.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_1 = $composer_16.i31();
          var tmp_44;
          if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
            var value_1 = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_16.j31(value_1);
            tmp_44 = value_1;
          } else {
            tmp_44 = it_1;
          }
          var tmp_45 = tmp_44;
          OutlinedTextField(tmp7_value, tmp2_group, tmp8_modifier_0, false, false, null, tmp_43, null, null, null, null, null, tmp_45, false, null, null, null, false, 0, 0, null, tmp9_shape, null, $composer_5, 1573248, 384, 0, 6287288);
          $composer_5.n30();
        } else {
          $composer_5.m30(376653548);
          $composer_5.n30();
        }
        var tmp14_safe_receiver = state.v11d_1;
        if ((tmp14_safe_receiver == null ? null : tmp14_safe_receiver.pyz_1) === true) {
          $composer_5.m30(376730800);
          sourceInformation($composer_5, '644@29936L41,650@30318L37,647@30097L3,652@30447L107,645@29994L578');
          var tmp_46 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$51 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_46, tmp$ret$51), $composer_5, 6);
          var tmp11_value = state.x11d_1;
          var tmp_47 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$52 = _Dp___init__impl__ms3zkb(24);
          var tmp_48 = padding_2(tmp_47, tmp$ret$52);
          sourceInformationMarkerStart($composer_5, -403477221, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_2 = ($dirty & 3670016) === 1048576;
          // Inline function 'kotlin.let' call
          var it_2 = $composer_5.i31();
          var tmp_49;
          if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
            var value_2 = ProductInfoContent$lambda_2(onShowBirthdayPicker);
            $composer_5.j31(value_2);
            tmp_49 = value_2;
          } else {
            tmp_49 = it_2;
          }
          var tmp3_group = tmp_49;
          sourceInformationMarkerEnd($composer_5);
          var tmp12_modifier = clickable(tmp_48, VOID, VOID, VOID, VOID, tmp3_group);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$57 = _Dp___init__impl__ms3zkb(12);
          var tmp13_shape = RoundedCornerShape(tmp$ret$57);
          sourceInformationMarkerStart($composer_5, -403484327, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_3 = $composer_5.i31();
          var tmp_50;
          if (false || it_3 === Companion_getInstance().f30_1) {
            var value_3 = ProductInfoContent$lambda_3;
            $composer_5.j31(value_3);
            tmp_50 = value_3;
          } else {
            tmp_50 = it_3;
          }
          var tmp4_group = tmp_50;
          sourceInformationMarkerEnd($composer_5);
          var tmp_51 = ComposableSingletons$ProductDetailsScreenKt_getInstance().f142_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_0 = rememberComposableLambda(732230810, true, ProductInfoContent$lambda_4(onShowBirthdayPicker), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_17 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_3 = $composer_17.k31(dispatchReceiver_0);
          // Inline function 'kotlin.let' call
          var it_4 = $composer_17.i31();
          var tmp_52;
          if (invalid_3 || it_4 === Companion_getInstance().f30_1) {
            var value_4 = ComposableLambda$invoke$ref(dispatchReceiver_0);
            $composer_17.j31(value_4);
            tmp_52 = value_4;
          } else {
            tmp_52 = it_4;
          }
          var tmp_53 = tmp_52;
          OutlinedTextField(tmp11_value, tmp4_group, tmp12_modifier, false, true, null, tmp_51, null, null, tmp_53, null, null, null, false, null, null, null, false, 0, 0, null, tmp13_shape, null, $composer_5, 806903856, 0, 0, 6290856);
          $composer_5.n30();
        } else {
          $composer_5.m30(377372748);
          $composer_5.n30();
        }
        var tmp_54 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$69 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_54, tmp$ret$69), $composer_5, 6);
        $composer_5.n30();
      } else {
        $composer_5.m30(377436236);
        $composer_5.n30();
      }
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!state.j11e_1.r()) {
        $composer_5.m30(377542535);
        sourceInformation($composer_5, '660@30759L37,663@30942L110,659@30713L390');
        var tmp_55 = stringResource(get_select_box(string_instance), $composer_5, 0);
        var tmp15_safe_receiver = state.z11d_1;
        var tmp_56 = tmp15_safe_receiver == null ? null : tmp15_safe_receiver.ryz_1;
        sourceInformationMarkerStart($composer_5, -403457180, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = $composer_0.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_5 = $composer_5.i31();
        var tmp_57;
        if (invalid_4 || it_5 === Companion_getInstance().f30_1) {
          var value_5 = ProductInfoContent$lambda_5(viewModel);
          $composer_5.j31(value_5);
          tmp_57 = value_5;
        } else {
          tmp_57 = it_5;
        }
        var tmp5_group = tmp_57;
        sourceInformationMarkerEnd($composer_5);
        GiftSelectionSection(tmp_55, state.j11e_1, tmp_56, tmp5_group, language, false, $composer_5, 57344 & $dirty, 32);
        var tmp19_safe_receiver = state.z11d_1;
        if ((tmp19_safe_receiver == null ? null : tmp19_safe_receiver.zyz_1) === true) {
          $composer_5.m30(377960973);
          sourceInformation($composer_5, '667@31176L41,670@31335L95,674@31693L104,668@31234L581');
          var tmp_58 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$75 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_58, tmp$ret$75), $composer_5, 6);
          var tmp16_value = state.a11e_1;
          var tmp_59 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$76 = _Dp___init__impl__ms3zkb(24);
          var tmp17_modifier = padding_2(tmp_59, tmp$ret$76);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$77 = _Dp___init__impl__ms3zkb(12);
          var tmp18_shape = RoundedCornerShape(tmp$ret$77);
          sourceInformationMarkerStart($composer_5, -403444619, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_5 = $composer_0.q31(viewModel);
          // Inline function 'kotlin.let' call
          var it_6 = $composer_5.i31();
          var tmp_60;
          if (invalid_5 || it_6 === Companion_getInstance().f30_1) {
            var value_6 = ProductInfoContent$lambda_6(viewModel);
            $composer_5.j31(value_6);
            tmp_60 = value_6;
          } else {
            tmp_60 = it_6;
          }
          var tmp6_group = tmp_60;
          sourceInformationMarkerEnd($composer_5);
          var tmp_61 = ComposableSingletons$ProductDetailsScreenKt_getInstance().h142_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_1 = rememberComposableLambda(2128642122, true, ProductInfoContent$lambda_7(state), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_18 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_6 = $composer_18.k31(dispatchReceiver_1);
          // Inline function 'kotlin.let' call
          var it_7 = $composer_18.i31();
          var tmp_62;
          if (invalid_6 || it_7 === Companion_getInstance().f30_1) {
            var value_7 = ComposableLambda$invoke$ref(dispatchReceiver_1);
            $composer_18.j31(value_7);
            tmp_62 = value_7;
          } else {
            tmp_62 = it_7;
          }
          var tmp_63 = tmp_62;
          OutlinedTextField(tmp16_value, tmp6_group, tmp17_modifier, false, false, null, tmp_61, null, null, null, null, null, tmp_63, false, null, null, null, false, 0, 0, null, tmp18_shape, null, $composer_5, 1573248, 384, 0, 6287288);
          $composer_5.n30();
        } else {
          $composer_5.m30(378605804);
          $composer_5.n30();
        }
        var tmp23_safe_receiver = state.z11d_1;
        if ((tmp23_safe_receiver == null ? null : tmp23_safe_receiver.az0_1) === true) {
          $composer_5.m30(378681971);
          sourceInformation($composer_5, '678@31903L41,684@32284L36,681@32063L3,686@32412L106,679@31961L575');
          var tmp_64 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$89 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_64, tmp$ret$89), $composer_5, 6);
          var tmp20_value = state.b11e_1;
          var tmp_65 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$90 = _Dp___init__impl__ms3zkb(24);
          var tmp_66 = padding_2(tmp_65, tmp$ret$90);
          sourceInformationMarkerStart($composer_5, -403414310, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_7 = ($dirty & 3670016) === 1048576;
          // Inline function 'kotlin.let' call
          var it_8 = $composer_5.i31();
          var tmp_67;
          if (invalid_7 || it_8 === Companion_getInstance().f30_1) {
            var value_8 = ProductInfoContent$lambda_8(onShowBirthdayPicker);
            $composer_5.j31(value_8);
            tmp_67 = value_8;
          } else {
            tmp_67 = it_8;
          }
          var tmp7_group = tmp_67;
          sourceInformationMarkerEnd($composer_5);
          var tmp21_modifier = clickable(tmp_66, VOID, VOID, VOID, VOID, tmp7_group);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$95 = _Dp___init__impl__ms3zkb(12);
          var tmp22_shape = RoundedCornerShape(tmp$ret$95);
          sourceInformationMarkerStart($composer_5, -403421415, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_9 = $composer_5.i31();
          var tmp_68;
          if (false || it_9 === Companion_getInstance().f30_1) {
            var value_9 = ProductInfoContent$lambda_9;
            $composer_5.j31(value_9);
            tmp_68 = value_9;
          } else {
            tmp_68 = it_9;
          }
          var tmp8_group = tmp_68;
          sourceInformationMarkerEnd($composer_5);
          var tmp_69 = ComposableSingletons$ProductDetailsScreenKt_getInstance().i142_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_2 = rememberComposableLambda(-10034223, true, ProductInfoContent$lambda_10(onShowBirthdayPicker), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_19 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_8 = $composer_19.k31(dispatchReceiver_2);
          // Inline function 'kotlin.let' call
          var it_10 = $composer_19.i31();
          var tmp_70;
          if (invalid_8 || it_10 === Companion_getInstance().f30_1) {
            var value_10 = ComposableLambda$invoke$ref(dispatchReceiver_2);
            $composer_19.j31(value_10);
            tmp_70 = value_10;
          } else {
            tmp_70 = it_10;
          }
          var tmp_71 = tmp_70;
          OutlinedTextField(tmp20_value, tmp8_group, tmp21_modifier, false, true, null, tmp_69, null, null, tmp_71, null, null, null, false, null, null, null, false, 0, 0, null, tmp22_shape, null, $composer_5, 806903856, 0, 0, 6290856);
          $composer_5.n30();
        } else {
          $composer_5.m30(379321036);
          $composer_5.n30();
        }
        $composer_5.n30();
      } else {
        $composer_5.m30(379330956);
        $composer_5.n30();
      }
      // Inline function 'kotlin.collections.isNullOrEmpty' call
      var this_0 = activeProduct.lzu_1;
      if (!(this_0 == null || this_0.r())) {
        $composer_5.m30(379391003);
        sourceInformation($composer_5, '692@32657L38,692@32784L69,692@32626L249');
        var tmp_72 = stringResource(get_select_size(string_instance), $composer_5, 0);
        sourceInformationMarkerStart($composer_5, -403398277, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_9 = $composer_0.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_11 = $composer_5.i31();
        var tmp_73;
        if (invalid_9 || it_11 === Companion_getInstance().f30_1) {
          var value_11 = ProductInfoContent$lambda_11(viewModel);
          $composer_5.j31(value_11);
          tmp_73 = value_11;
        } else {
          tmp_73 = it_11;
        }
        var tmp9_group = tmp_73;
        sourceInformationMarkerEnd($composer_5);
        OptionSelectionSection(tmp_72, activeProduct.lzu_1, state.d11e_1, tmp9_group, language, false, $composer_5, 57344 & $dirty, 32);
        $composer_5.n30();
      } else {
        $composer_5.m30(379653356);
        $composer_5.n30();
      }
      // Inline function 'kotlin.collections.isNullOrEmpty' call
      var this_1 = activeProduct.mzu_1;
      if (!(this_1 == null || this_1.r())) {
        $composer_5.m30(379714519);
        sourceInformation($composer_5, '696@32983L39,696@33113L70,696@32952L253');
        var tmp_74 = stringResource(get_select_color(string_instance), $composer_5, 0);
        sourceInformationMarkerStart($composer_5, -403387748, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_10 = $composer_0.q31(viewModel);
        // Inline function 'kotlin.let' call
        var it_12 = $composer_5.i31();
        var tmp_75;
        if (invalid_10 || it_12 === Companion_getInstance().f30_1) {
          var value_12 = ProductInfoContent$lambda_12(viewModel);
          $composer_5.j31(value_12);
          tmp_75 = value_12;
        } else {
          tmp_75 = it_12;
        }
        var tmp10_group = tmp_75;
        sourceInformationMarkerEnd($composer_5);
        OptionSelectionSection(tmp_74, activeProduct.mzu_1, state.e11e_1, tmp10_group, language, false, $composer_5, 57344 & $dirty, 32);
        $composer_5.n30();
      } else {
        $composer_5.m30(379980716);
        $composer_5.n30();
      }
      var tmp24_safe_receiver = activeProduct.nzu_1;
      if (tmp24_safe_receiver == null) {
        $composer_5.m30(380048760);
        $composer_5.n30();
      } else {
        $composer_5.m30(380048761);
        sourceInformation($composer_5, '*700@33401L95,700@33290L228');
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_2 = tmp24_safe_receiver.t();
        while (_iterator__ex2g4s_2.u()) {
          var element_2 = _iterator__ex2g4s_2.v();
          var tmp_76 = state.f11e_1.w2(element_2.r101_1);
          sourceInformationMarkerStart($composer_5, -701784029, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_11 = !!($composer_0.q31(viewModel) | $composer_0.q31(element_2));
          // Inline function 'kotlin.let' call
          var it_13 = $composer_5.i31();
          var tmp_77;
          if (invalid_11 || it_13 === Companion_getInstance().f30_1) {
            var value_13 = ProductInfoContent$lambda_13(viewModel, element_2);
            $composer_5.j31(value_13);
            tmp_77 = value_13;
          } else {
            tmp_77 = it_13;
          }
          var tmp0_group_0 = tmp_77;
          sourceInformationMarkerEnd($composer_5);
          OptionSelectionSection_0(element_2, tmp_76, tmp0_group_0, language, false, $composer_5, 7168 & $dirty >> 3, 16);
          var tmp0_safe_receiver_0 = state.f11e_1.w2(element_2.r101_1);
          if (tmp0_safe_receiver_0 == null) {
            $composer_5.m30(-280292152);
            $composer_5.n30();
          } else {
            $composer_5.m30(-280292151);
            sourceInformation($composer_5, '');
            // Inline function 'kotlin.let' call
            if (tmp0_safe_receiver_0.w100_1 || tmp0_safe_receiver_0.z100_1 || tmp0_safe_receiver_0.c101_1) {
              $composer_5.m30(-1354371620);
              sourceInformation($composer_5, '703@33832L101,703@33958L43,703@33712L323');
              sourceInformationMarkerStart($composer_5, 1203240864, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_12 = !!($composer_0.q31(viewModel) | $composer_0.q31(element_2));
              // Inline function 'kotlin.let' call
              var it_14 = $composer_5.i31();
              var tmp_78;
              if (invalid_12 || it_14 === Companion_getInstance().f30_1) {
                var value_14 = ProductInfoContent$lambda_14(viewModel, element_2);
                $composer_5.j31(value_14);
                tmp_78 = value_14;
              } else {
                tmp_78 = it_14;
              }
              var tmp0_group_1 = tmp_78;
              sourceInformationMarkerEnd($composer_5);
              sourceInformationMarkerStart($composer_5, 1203244838, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
              // Inline function 'androidx.compose.runtime.cache' call
              var invalid_13 = !!(($dirty & 3670016) === 1048576 | $composer_0.q31(element_2));
              // Inline function 'kotlin.let' call
              var it_15 = $composer_5.i31();
              var tmp_79;
              if (invalid_13 || it_15 === Companion_getInstance().f30_1) {
                var value_15 = ProductInfoContent$lambda_15(onShowBirthdayPicker, element_2);
                $composer_5.j31(value_15);
                tmp_79 = value_15;
              } else {
                tmp_79 = it_15;
              }
              var tmp1_group_0 = tmp_79;
              sourceInformationMarkerEnd($composer_5);
              SelectedOptionExtraInputs(element_2.r101_1, tmp0_safe_receiver_0, language, tmp0_group_1, tmp1_group_0, !state.p11d_1, $composer_5, 896 & $dirty >> 6, 0);
              $composer_5.n30();
            } else {
              $composer_5.m30(-1354022777);
              $composer_5.n30();
            }
            $composer_5.n30();
          }
        }
        $composer_5.n30();
      }
      var tmp_80 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$133 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_80, tmp$ret$133), $composer_5, 6);
      var tmp25_value = state.g11e_1;
      var tmp26_modifier = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$134 = _Dp___init__impl__ms3zkb(12);
      var tmp27_shape = RoundedCornerShape(tmp$ret$134);
      sourceInformationMarkerStart($composer_5, -403352102, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_14 = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_16 = $composer_5.i31();
      var tmp_81;
      if (invalid_14 || it_16 === Companion_getInstance().f30_1) {
        var value_16 = ProductInfoContent$lambda_16(viewModel);
        $composer_5.j31(value_16);
        tmp_81 = value_16;
      } else {
        tmp_81 = it_16;
      }
      var tmp11_group = tmp_81;
      sourceInformationMarkerEnd($composer_5);
      var tmp_82 = ComposableSingletons$ProductDetailsScreenKt_getInstance().k142_1;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_3 = rememberComposableLambda(1288063453, true, ProductInfoContent$lambda_17(state), $composer_5, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_20 = $composer_5;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_15 = $composer_20.k31(dispatchReceiver_3);
      // Inline function 'kotlin.let' call
      var it_17 = $composer_20.i31();
      var tmp_83;
      if (invalid_15 || it_17 === Companion_getInstance().f30_1) {
        var value_17 = ComposableLambda$invoke$ref(dispatchReceiver_3);
        $composer_20.j31(value_17);
        tmp_83 = value_17;
      } else {
        tmp_83 = it_17;
      }
      var tmp_84 = tmp_83;
      OutlinedTextField(tmp25_value, tmp11_group, tmp26_modifier, false, false, null, tmp_82, null, null, null, null, null, tmp_84, false, null, null, null, false, 3, 0, null, tmp27_shape, null, $composer_5, 1573248, 100663680, 0, 6025144);
      var tmp_85 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$146 = _Dp___init__impl__ms3zkb(24);
      Spacer(height(tmp_85, tmp$ret$146), $composer_5, 6);
      AgeGroupDisplay(activeProduct.rzu_1, activeProduct.szu_1, activeProduct.tzu_1, null, $composer_5, 0, 8);
      var tmp_86 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$147 = _Dp___init__impl__ms3zkb(16);
      Spacer(height(tmp_86, tmp$ret$147), $composer_5, 6);
      var tmp28_elvis_lhs = activeProduct.wzt_1;
      if ((tmp28_elvis_lhs == null ? 0 : tmp28_elvis_lhs) > 0) {
        $composer_5.m30(381709679);
        sourceInformation($composer_5, '723@34958L421');
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_5 = null;
        var horizontalArrangement_0 = null;
        var verticalAlignment_0 = Companion_getInstance_11().u8t_1;
        var $composer_21 = $composer_5;
        if (!((3 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((3 & 2) === 0))
          horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
        if (!((3 & 4) === 0))
          verticalAlignment_0 = Companion_getInstance_11().t8t_1;
        var measurePolicy_2 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_21, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_22 = $composer_21;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_22, 0).hashCode();
        var localMap_2 = $composer_22.t31();
        var materialized_2 = materialize($composer_22, modifier_6);
        var tmp0_3 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_23 = $composer_22;
        var tmp_87 = $composer_23.g30();
        if (!isInterface(tmp_87, Applier)) {
          invalidApplier();
        }
        $composer_23.b31();
        if ($composer_23.h30()) {
          $composer_23.c31(tmp0_3);
        } else {
          $composer_23.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_23);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_24 = $composer_23;
        var $composer_25 = $composer_24;
        sourceInformationMarkerStart($composer_25, -1619933693, 'C724@35028L83,725@35128L39,726@35196L69,726@35184L181:ProductDetailsScreen.kt#8gd4xm');
        var tmp_88 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$154 = _Dp___init__impl__ms3zkb(8);
        Box(background(clip(size(tmp_88, tmp$ret$154), get_CircleShape()), Color(new Long(-11751600, 0))), $composer_25, 0);
        var tmp_89 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$155 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_89, tmp$ret$155), $composer_25, 6);
        var tmp_90 = get_in_stock_pattern(string_instance);
        var tmp0_elvis_lhs_2 = activeProduct.wzt_1;
        var tmp1_text = formatNumbers(stringResource_0(tmp_90, [tmp0_elvis_lhs_2 == null ? 0 : tmp0_elvis_lhs_2], $composer_25, 0), language);
        var tmp2_color_0 = Color(new Long(-11751600, 0));
        var tmp3_fontWeight_0 = Companion_getInstance_16().e7z_1;
        var tmp4_fontSize = get_sp(14);
        var tmp_91 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_92 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_93 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp1_text, null, tmp2_color_0, null, tmp4_fontSize, null, tmp3_fontWeight_0, null, tmp_91, null, null, tmp_92, tmp_93, false, 0, 0, null, null, $composer_25, 1597824, 0, 262058);
        sourceInformationMarkerEnd($composer_25);
        $composer_23.e31();
        $composer_5.n30();
      } else {
        $composer_5.m30(382156265);
        sourceInformation($composer_5, '729@35409L395');
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_7 = null;
        var horizontalArrangement_1 = null;
        var verticalAlignment_1 = Companion_getInstance_11().u8t_1;
        var $composer_26 = $composer_5;
        if (!((3 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((3 & 2) === 0))
          horizontalArrangement_1 = Arrangement_getInstance().qdp_1;
        if (!((3 & 4) === 0))
          verticalAlignment_1 = Companion_getInstance_11().t8t_1;
        var measurePolicy_3 = rowMeasurePolicy(horizontalArrangement_1, verticalAlignment_1, $composer_26, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_27 = $composer_26;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_27, 0).hashCode();
        var localMap_3 = $composer_27.t31();
        var materialized_3 = materialize($composer_27, modifier_8);
        var tmp0_4 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_28 = $composer_27;
        var tmp_94 = $composer_28.g30();
        if (!isInterface(tmp_94, Applier)) {
          invalidApplier();
        }
        $composer_28.b31();
        if ($composer_28.h30()) {
          $composer_28.c31(tmp0_4);
        } else {
          $composer_28.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_28);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_29 = $composer_28;
        var $composer_30 = $composer_29;
        sourceInformationMarkerStart($composer_30, -1534469324, 'C730@35557L11,730@35479L97,731@35593L39,732@35661L39,732@35724L11,732@35649L141:ProductDetailsScreen.kt#8gd4xm');
        var tmp_95 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$162 = _Dp___init__impl__ms3zkb(8);
        Box(background(clip(size(tmp_95, tmp$ret$162), get_CircleShape()), MaterialTheme_instance.unz($composer_30, 6).to0_1), $composer_30, 0);
        var tmp_96 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$163 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_96, tmp$ret$163), $composer_30, 6);
        var tmp0_text_0 = stringResource(get_out_of_stock(string_instance), $composer_30, 0);
        var tmp1_color = MaterialTheme_instance.unz($composer_30, 6).to0_1;
        var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp3_fontSize = get_sp(14);
        var tmp_97 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_98 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_99 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text_0, null, tmp1_color, null, tmp3_fontSize, null, tmp2_fontWeight, null, tmp_97, null, null, tmp_98, tmp_99, false, 0, 0, null, null, $composer_30, 1597440, 0, 262058);
        sourceInformationMarkerEnd($composer_30);
        $composer_28.e31();
        $composer_5.n30();
      }
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver_1 = $composer_0.t30();
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      tmp0_safe_receiver_1.p3c(ProductInfoContent$lambda_18(activeProduct, state, name, description, language, viewModel, onShowBirthdayPicker, $changed));
    }
  }
  function ProductActionBar(activeProduct, state, language, viewModel, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-611720704);
    sourceInformation($composer_0, 'C(ProductActionBar)P(!1,2)747@36070L11,750@36199L2536,745@35987L2748:ProductDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(activeProduct) : $composer_0.q31(activeProduct)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(viewModel) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-611720704, $dirty, -1, 'client.fstech.hadaya.presentation.product_details.ProductActionBar (ProductDetailsScreen.kt:744)');
      }
      var tmp0_modifier = fillMaxWidth(Companion_instance);
      var tmp1_color = MaterialTheme_instance.unz($composer_0, 6).mo0_1;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp2_shadowElevation = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp = _Dp___init__impl__ms3zkb(24);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$2 = _Dp___init__impl__ms3zkb(24);
      var tmp3_shape = RoundedCornerShape_0(tmp, tmp$ret$2);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _Dp___init__impl__ms3zkb(0.0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-2057975845, true, ProductActionBar$lambda(activeProduct, state, viewModel, language), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_2;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value);
        tmp_2 = value;
      } else {
        tmp_2 = it;
      }
      var tmp$ret$3 = tmp_2;
      Surface(tmp0_modifier, tmp3_shape, tmp1_color, tmp_0, tmp_1, tmp2_shadowElevation, null, tmp$ret$3, $composer_0, 12779526, 88);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ProductActionBar$lambda_0(activeProduct, state, language, viewModel, $changed));
    }
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$2135974514$lambda($this$Card, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C361@16189L918:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(2135974514, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$2135974514.<anonymous> (ProductDetailsScreen.kt:361)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
      var tmp0_modifier = padding_0(tmp, tmp$ret$0);
      var tmp1_horizontalAlignment = Companion_getInstance_11().x8t_1;
      var tmp_0 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = tmp0_modifier;
      var verticalArrangement = tmp_0.mdq(tmp$ret$1);
      var horizontalAlignment = tmp1_horizontalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier = Companion_instance;
      if (!((0 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((0 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 259667901, 'C366@16475L27,368@16569L54,369@16679L10,367@16531L262,373@16860L52,374@16968L10,372@16822L259:ProductDetailsScreen.kt#8gd4xm');
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
      CircularProgressIndicator(null, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_5, 0, 63);
      var tmp0_text = stringResource(get_adding_to_cart_dialog_title(string_instance), $composer_5, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp_6, null, tmp_7, null, tmp2_fontWeight, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131006);
      var tmp3_text = stringResource(get_adding_to_cart_dialog_msg(string_instance), $composer_5, 0);
      var tmp4_style = MaterialTheme_instance.jog($composer_5, 6).pof_1;
      var tmp5_textAlign = Companion_getInstance_15().d7v_1;
      var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_15 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp3_text, null, tmp_11, null, tmp_12, null, null, null, tmp_13, null, tmp5_textAlign, tmp_14, tmp_15, false, 0, 0, null, tmp4_style, $composer_5, 0, 0, 130046);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$_756337286$lambda_kpj79z($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C353@15790L1357:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-756337286, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$-756337286.<anonymous> (ProductDetailsScreen.kt:353)');
      }
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = null;
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_1 = $composer_0;
      if (!((5 & 1) === 0))
        modifier = Companion_instance;
      if (!((5 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((5 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 741792839, 'C356@15976L11,355@15905L116,354@15853L1276:ProductDetailsScreen.kt#8gd4xm');
      var tmp_0 = CardDefaults_instance;
      var tmp_1 = MaterialTheme_instance.unz($composer_5, 6).mo0_1;
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp0_colors = tmp_0.loh(tmp_1, tmp_2, tmp_3, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 24576, 14);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$6 = _Dp___init__impl__ms3zkb(16);
      var tmp1_shape = RoundedCornerShape(tmp$ret$6);
      var tmp_4 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(32);
      var tmp2_modifier = padding_0(tmp_4, tmp$ret$7);
      Card(tmp2_modifier, tmp1_shape, tmp0_colors, null, null, ComposableSingletons$ProductDetailsScreenKt_getInstance().w141_1, $composer_5, 196614, 24);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$_1675716028$lambda_qmy4s1($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C430@19429L29,430@19424L35:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1675716028, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$-1675716028.<anonymous> (ProductDetailsScreen.kt:430)');
      }
      var tmp = stringResource(get_ok(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$_1385371390$lambda_l83bjm($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C439@19798L33,439@19793L39:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1385371390, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$-1385371390.<anonymous> (ProductDetailsScreen.kt:439)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$944822669$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C498@21774L31,496@21662L209:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(944822669, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$944822669.<anonymous> (ProductDetailsScreen.kt:496)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, Companion_getInstance_14().i6b_1, $composer_0, 3072, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$2083160390$lambda($this$AnimatedContent, isFav, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C509@22226L310:ProductDetailsScreen.kt#8gd4xm');
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(isFav) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(2083160390, $dirty, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$2083160390.<anonymous> (ProductDetailsScreen.kt:509)');
      }
      var tmp = isFav ? get_Favorite(Icons_getInstance().dxv_1) : get_FavoriteBorder(Icons_getInstance().dxv_1);
      var tmp_0;
      if (isFav) {
        $composer_0.m30(462384301);
        sourceInformation($composer_0, '512@22470L11');
        var tmp0_group = MaterialTheme_instance.unz($composer_0, 6).xnz_1;
        $composer_0.n30();
        tmp_0 = tmp0_group;
      } else {
        $composer_0.m30(462384907);
        $composer_0.n30();
        tmp_0 = Companion_getInstance_14().i6b_1;
      }
      Icon(tmp, null, null, tmp_0, $composer_0, 48, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$_452348590$lambda_im8lry($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C521@22868L72:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-452348590, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$-452348590.<anonymous> (ProductDetailsScreen.kt:521)');
      }
      var tmp = get_Share(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, Companion_getInstance_14().i6b_1, $composer_0, 3120, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$268607972$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C534@23432L498:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(268607972, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$268607972.<anonymous> (ProductDetailsScreen.kt:534)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_0 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(8);
      var tmp0_modifier = padding_2(tmp, tmp_0, tmp$ret$1);
      var tmp1_verticalAlignment = Companion_getInstance_11().u8t_1;
      var tmp_1 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$2 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = tmp0_modifier;
      var horizontalArrangement = tmp_1.mdq(tmp$ret$2);
      var verticalAlignment = tmp1_verticalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier = Companion_instance;
      if (!((0 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_2 = $composer_3.g30();
      if (!isInterface(tmp_2, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -1515576399, 'C539@23702L69,540@23797L39,540@23860L10,540@23792L120:ProductDetailsScreen.kt#8gd4xm');
      var tmp_3 = get_Fullscreen(Icons_getInstance().dxv_1);
      var tmp_4 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$9 = _Dp___init__impl__ms3zkb(20);
      var tmp_5 = size(tmp_4, tmp$ret$9);
      Icon(tmp_3, null, tmp_5, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 432, 8);
      var tmp0_text = stringResource(get_full_gallery(string_instance), $composer_5, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_5, 6).rof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp_6, null, tmp_7, null, tmp2_fontWeight, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, tmp1_style, $composer_5, 1572864, 0, 131006);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$_1749719738$lambda_ir0fbu($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C637@29498L45,637@29493L51:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1749719738, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$-1749719738.<anonymous> (ProductDetailsScreen.kt:637)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$_3871875$lambda_xsksun($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C649@30174L46,649@30169L52:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-3871875, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$-3871875.<anonymous> (ProductDetailsScreen.kt:649)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$785280828$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C652@30511L39:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(785280828, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$785280828.<anonymous> (ProductDetailsScreen.kt:652)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$_1457661571$lambda_dbl6wl($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C671@31467L45,671@31462L51:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1457661571, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$-1457661571.<anonymous> (ProductDetailsScreen.kt:671)');
      }
      var tmp = stringResource(get_card_message_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$1264889332$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C683@32140L46,683@32135L52:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1264889332, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$1264889332.<anonymous> (ProductDetailsScreen.kt:683)');
      }
      var tmp = stringResource(get_card_birthday_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$_568574477$lambda_r2yuz5($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C686@32475L39:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-568574477, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$-568574477.<anonymous> (ProductDetailsScreen.kt:686)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$_1680700592$lambda_d6hlcq($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C712@34355L52,712@34350L58:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1680700592, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$-1680700592.<anonymous> (ProductDetailsScreen.kt:712)');
      }
      var tmp = stringResource(get_add_product_comment_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$1628910778$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C762@36906L32:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1628910778, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$1628910778.<anonymous> (ProductDetailsScreen.kt:762)');
      }
      var tmp = get_Remove(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt$lambda$_372155677$lambda_r7g6yz($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C766@37279L29:ProductDetailsScreen.kt#8gd4xm');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-372155677, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ComposableSingletons$ProductDetailsScreenKt.lambda$-372155677.<anonymous> (ProductDetailsScreen.kt:766)');
      }
      var tmp = get_Add(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProductDetailsScreenKt() {
    ComposableSingletons$ProductDetailsScreenKt_instance = this;
    var tmp = this;
    tmp.w141_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(2135974514, false, ComposableSingletons$ProductDetailsScreenKt$lambda$2135974514$lambda));
    var tmp_0 = this;
    tmp_0.x141_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-756337286, false, ComposableSingletons$ProductDetailsScreenKt$lambda$_756337286$lambda_kpj79z));
    var tmp_1 = this;
    tmp_1.y141_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1675716028, false, ComposableSingletons$ProductDetailsScreenKt$lambda$_1675716028$lambda_qmy4s1));
    var tmp_2 = this;
    tmp_2.z141_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1385371390, false, ComposableSingletons$ProductDetailsScreenKt$lambda$_1385371390$lambda_l83bjm));
    var tmp_3 = this;
    tmp_3.a142_1 = ComposableLambda$invoke$ref(composableLambdaInstance(944822669, false, ComposableSingletons$ProductDetailsScreenKt$lambda$944822669$lambda));
    var tmp_4 = this;
    tmp_4.b142_1 = ComposableLambda$invoke$ref_5(composableLambdaInstance(2083160390, false, ComposableSingletons$ProductDetailsScreenKt$lambda$2083160390$lambda));
    var tmp_5 = this;
    tmp_5.c142_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-452348590, false, ComposableSingletons$ProductDetailsScreenKt$lambda$_452348590$lambda_im8lry));
    var tmp_6 = this;
    tmp_6.d142_1 = ComposableLambda$invoke$ref(composableLambdaInstance(268607972, false, ComposableSingletons$ProductDetailsScreenKt$lambda$268607972$lambda));
    var tmp_7 = this;
    tmp_7.e142_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1749719738, false, ComposableSingletons$ProductDetailsScreenKt$lambda$_1749719738$lambda_ir0fbu));
    var tmp_8 = this;
    tmp_8.f142_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-3871875, false, ComposableSingletons$ProductDetailsScreenKt$lambda$_3871875$lambda_xsksun));
    var tmp_9 = this;
    tmp_9.g142_1 = ComposableLambda$invoke$ref(composableLambdaInstance(785280828, false, ComposableSingletons$ProductDetailsScreenKt$lambda$785280828$lambda));
    var tmp_10 = this;
    tmp_10.h142_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1457661571, false, ComposableSingletons$ProductDetailsScreenKt$lambda$_1457661571$lambda_dbl6wl));
    var tmp_11 = this;
    tmp_11.i142_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1264889332, false, ComposableSingletons$ProductDetailsScreenKt$lambda$1264889332$lambda));
    var tmp_12 = this;
    tmp_12.j142_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-568574477, false, ComposableSingletons$ProductDetailsScreenKt$lambda$_568574477$lambda_r2yuz5));
    var tmp_13 = this;
    tmp_13.k142_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1680700592, false, ComposableSingletons$ProductDetailsScreenKt$lambda$_1680700592$lambda_d6hlcq));
    var tmp_14 = this;
    tmp_14.l142_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1628910778, false, ComposableSingletons$ProductDetailsScreenKt$lambda$1628910778$lambda));
    var tmp_15 = this;
    tmp_15.m142_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-372155677, false, ComposableSingletons$ProductDetailsScreenKt$lambda$_372155677$lambda_r7g6yz));
  }
  var ComposableSingletons$ProductDetailsScreenKt_instance;
  function ComposableSingletons$ProductDetailsScreenKt_getInstance() {
    if (ComposableSingletons$ProductDetailsScreenKt_instance == null)
      new ComposableSingletons$ProductDetailsScreenKt();
    return ComposableSingletons$ProductDetailsScreenKt_instance;
  }
  function ProductDetailsScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function ProductDetailsScreen$slambda($viewModel, $product, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, resultContinuation) {
    this.v142_1 = $viewModel;
    this.w142_1 = $product;
    this.x142_1 = $initialSize;
    this.y142_1 = $initialColor;
    this.z142_1 = $initialOptions;
    this.a143_1 = $initialComment;
    this.b143_1 = $initialCard;
    this.c143_1 = $initialBox;
    this.d143_1 = $initialCardMessage;
    this.e143_1 = $initialCardBirthday;
    this.f143_1 = $initialBoxMessage;
    this.g143_1 = $initialBoxBirthday;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductDetailsScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = delay(new Long(100, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            println('Human debug ProductDetailsScreen');
            this.v142_1.s10h().j10i(new LoadProduct_2(this.w142_1, this.x142_1._v, this.y142_1._v, this.z142_1._v, this.a143_1._v, this.b143_1._v, this.c143_1._v, this.d143_1._v, this.e143_1._v, this.f143_1._v, this.g143_1._v));
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProductDetailsScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new ProductDetailsScreen$slambda(this.v142_1, this.w142_1, this.x142_1, this.y142_1, this.z142_1, this.a143_1, this.b143_1, this.c143_1, this.d143_1, this.e143_1, this.f143_1, this.g143_1, completion);
    i.h143_1 = $this$LaunchedEffect;
    return i;
  };
  function ProductDetailsScreen$slambda_0($viewModel, $product, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, resultContinuation) {
    var i = new ProductDetailsScreen$slambda($viewModel, $product, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_23(function_0) {
    this.i143_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_23).a1v = function (value, $completion) {
    return this.i143_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_23).q3 = function () {
    return this.i143_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_23).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_23).hashCode = function () {
    return hashCode(this.q3());
  };
  function ProductDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, resultContinuation) {
    this.r143_1 = $snackbarHostState;
    this.s143_1 = $onNavigateToAuth;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductDetailsScreen$slambda$slambda).p11g = function (effect, $completion) {
    var tmp = this.q11g(effect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsScreen$slambda$slambda).ja = function (p1, $completion) {
    return this.p11g((!(p1 == null) ? isInterface(p1, ProductDetailsSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsScreen$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp0_subject = this.t143_1;
            if (tmp0_subject instanceof ShowMessage_5) {
              this.n9_1 = 2;
              suspendResult = this.t143_1.s11g_1.z10i(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject instanceof ShowToast_1) {
                this.n9_1 = 1;
                suspendResult = this.t143_1.r11g_1.z10i(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (equals(tmp0_subject, NavigateToAuth_instance_3)) {
                  this.u143_1 = this.s143_1();
                  this.n9_1 = 4;
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            var tmp_1 = this;
            showToast(ARGUMENT);
            tmp_1.u143_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            this.n9_1 = 3;
            suspendResult = this.r143_1.dqm(ARGUMENT_0, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.u143_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProductDetailsScreen$slambda$slambda).q11g = function (effect, completion) {
    var i = new ProductDetailsScreen$slambda$slambda(this.r143_1, this.s143_1, completion);
    i.t143_1 = effect;
    return i;
  };
  function ProductDetailsScreen$slambda$slambda_0($snackbarHostState, $onNavigateToAuth, resultContinuation) {
    var i = new ProductDetailsScreen$slambda$slambda($snackbarHostState, $onNavigateToAuth, resultContinuation);
    return constructCallableReference(function (effect, $completion) {
      return i.p11g(effect, $completion);
    }, 1);
  }
  function ProductDetailsScreen$slambda_1($viewModel, $snackbarHostState, $onNavigateToAuth, resultContinuation) {
    this.d144_1 = $viewModel;
    this.e144_1 = $snackbarHostState;
    this.f144_1 = $onNavigateToAuth;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductDetailsScreen$slambda_1).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsScreen$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsScreen$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.d144_1.s10h().t10h();
            var tmp_1 = ProductDetailsScreen$slambda$slambda_0(this.e144_1, this.f144_1, null);
            suspendResult = tmp_0.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0_23(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProductDetailsScreen$slambda_1).q24 = function ($this$LaunchedEffect, completion) {
    var i = new ProductDetailsScreen$slambda_1(this.d144_1, this.e144_1, this.f144_1, completion);
    i.g144_1 = $this$LaunchedEffect;
    return i;
  };
  function ProductDetailsScreen$slambda_2($viewModel, $snackbarHostState, $onNavigateToAuth, resultContinuation) {
    var i = new ProductDetailsScreen$slambda_1($viewModel, $snackbarHostState, $onNavigateToAuth, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function ProductDetailsScreen$lambda_0($combinedMedia) {
    return function () {
      return $combinedMedia.n1();
    };
  }
  function ProductDetailsScreen$lambda_1($isZooming$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isZooming', KMutableProperty0, true);
    return $isZooming$delegate.u1();
  }
  function ProductDetailsScreen$lambda_2($isZooming$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isZooming', KMutableProperty0, true);
    $isZooming$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProductDetailsScreen$lambda_3($showBirthdayPicker$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    return $showBirthdayPicker$delegate.u1();
  }
  function ProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showBirthdayPicker', KMutableProperty0, true);
    $showBirthdayPicker$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProductDetailsScreen$lambda_5($birthdayPickerTargetOptionKey$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    return $birthdayPickerTargetOptionKey$delegate.u1();
  }
  function ProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('birthdayPickerTargetOptionKey', KMutableProperty0, true);
    $birthdayPickerTargetOptionKey$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProductDetailsScreen$lambda_7($isPickingBoxBirthday$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    return $isPickingBoxBirthday$delegate.u1();
  }
  function ProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isPickingBoxBirthday', KMutableProperty0, true);
    $isPickingBoxBirthday$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProductDetailsScreen$lambda_9($showDiscardDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    return $showDiscardDialog$delegate.u1();
  }
  function ProductDetailsScreen$lambda_10($showDiscardDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDiscardDialog', KMutableProperty0, true);
    $showDiscardDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProductDetailsScreen$lambda_11($showMediaDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showMediaDialog', KMutableProperty0, true);
    return $showMediaDialog$delegate.u1();
  }
  function ProductDetailsScreen$lambda_12($showMediaDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showMediaDialog', KMutableProperty0, true);
    $showMediaDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProductDetailsScreen$lambda_13($initialMediaIndex$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('initialMediaIndex', KMutableProperty0, true);
    return $initialMediaIndex$delegate.b49();
  }
  function ProductDetailsScreen$lambda_14($initialMediaIndex$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('initialMediaIndex', KMutableProperty0, true);
    $initialMediaIndex$delegate.a49(_set____db54di);
    return Unit_instance;
  }
  function ProductDetailsScreen$lambda_15($showMediaDialog$delegate, $showDiscardDialog$delegate) {
    return function () {
      var tmp;
      if (ProductDetailsScreen$lambda_11($showMediaDialog$delegate)) {
        ProductDetailsScreen$lambda_12($showMediaDialog$delegate, false);
        tmp = Unit_instance;
      } else {
        ProductDetailsScreen$lambda_10($showDiscardDialog$delegate, true);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$slambda_3($isZooming$delegate, resultContinuation) {
    this.p144_1 = $isZooming$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductDetailsScreen$slambda_3).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsScreen$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsScreen$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          ProductDetailsScreen$lambda_2(this.p144_1, false);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ProductDetailsScreen$slambda_3).q24 = function ($this$LaunchedEffect, completion) {
    var i = new ProductDetailsScreen$slambda_3(this.p144_1, completion);
    i.q144_1 = $this$LaunchedEffect;
    return i;
  };
  function ProductDetailsScreen$slambda_4($isZooming$delegate, resultContinuation) {
    var i = new ProductDetailsScreen$slambda_3($isZooming$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function ProductDetailsScreen$lambda_16($onBack, $showDiscardDialog$delegate) {
    return function () {
      ProductDetailsScreen$lambda_10($showDiscardDialog$delegate, false);
      $onBack();
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_17($showDiscardDialog$delegate) {
    return function () {
      ProductDetailsScreen$lambda_10($showDiscardDialog$delegate, false);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_18($isZooming$delegate) {
    return function (it) {
      ProductDetailsScreen$lambda_2($isZooming$delegate, it);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_19($initialMediaIndex$delegate, $showMediaDialog$delegate) {
    return function (index) {
      ProductDetailsScreen$lambda_14($initialMediaIndex$delegate, index);
      ProductDetailsScreen$lambda_12($showMediaDialog$delegate, true);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_20($onBack, $state$delegate, $showDiscardDialog$delegate) {
    return function () {
      var tmp;
      if (ProductDetailsScreen$lambda($state$delegate).p11d_1) {
        ProductDetailsScreen$lambda_10($showDiscardDialog$delegate, true);
        tmp = Unit_instance;
      } else {
        tmp = $onBack();
      }
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_21($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ToggleFavorite_instance_1);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_22($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ShareProduct_instance_1);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_23($birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function (key, isBox) {
      ProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate, key);
      ProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate, isBox);
      ProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_24($isZooming$delegate) {
    return function (it) {
      ProductDetailsScreen$lambda_2($isZooming$delegate, it);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_25($initialMediaIndex$delegate, $showMediaDialog$delegate) {
    return function (index) {
      ProductDetailsScreen$lambda_14($initialMediaIndex$delegate, index);
      ProductDetailsScreen$lambda_12($showMediaDialog$delegate, true);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_26($onBack, $state$delegate, $showDiscardDialog$delegate) {
    return function () {
      var tmp;
      if (ProductDetailsScreen$lambda($state$delegate).p11d_1) {
        ProductDetailsScreen$lambda_10($showDiscardDialog$delegate, true);
        tmp = Unit_instance;
      } else {
        tmp = $onBack();
      }
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_27($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ToggleFavorite_instance_1);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_28($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ShareProduct_instance_1);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_29($birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function (key, isBox) {
      ProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate, key);
      ProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate, isBox);
      ProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, true);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_30($showMediaDialog$delegate) {
    return function () {
      ProductDetailsScreen$lambda_12($showMediaDialog$delegate, false);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_31($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate) {
    return function () {
      ProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, false);
      ProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate, null);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda$lambda($birthdayPickerState, $viewModel, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function () {
      var tmp0_safe_receiver = $birthdayPickerState.np1();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var date = toLocalDateTime(Companion_getInstance_19().kf(tmp0_safe_receiver), Companion_getInstance_20().yno_1).xn9_1.toString();
        if (!(ProductDetailsScreen$lambda_5($birthdayPickerTargetOptionKey$delegate) == null)) {
          var key = ensureNotNull(ProductDetailsScreen$lambda_5($birthdayPickerTargetOptionKey$delegate));
          var selectedValue = ProductDetailsScreen$lambda($state$delegate).f11e_1.w2(key);
          if (!(selectedValue == null)) {
            $viewModel.s10h().j10i(new OptionSelected_2(key, selectedValue.k101(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, date)));
          }
        } else if (ProductDetailsScreen$lambda_7($isPickingBoxBirthday$delegate)) {
          $viewModel.s10h().j10i(new BoxBirthdayChanged_2(date));
        } else {
          $viewModel.s10h().j10i(new CardBirthdayChanged_2(date));
        }
      }
      ProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, false);
      ProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate, null);
      ProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_32($birthdayPickerState, $state$delegate, $viewModel, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C404@17881L1515,404@17860L1621:ProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1567829023, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ProductDetailsScreen.<anonymous>.<anonymous> (ProductDetailsScreen.kt:404)');
        }
        sourceInformationMarkerStart($composer_0, 849832684, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!($composer_0.k31($birthdayPickerState) | $composer_0.k31($state$delegate)) | $composer_0.q31($viewModel));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProductDetailsScreen$lambda$lambda($birthdayPickerState, $viewModel, $birthdayPickerTargetOptionKey$delegate, $state$delegate, $isPickingBoxBirthday$delegate, $showBirthdayPicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$ProductDetailsScreenKt_getInstance().y141_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda$lambda_0($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function () {
      ProductDetailsScreen$lambda_4($showBirthdayPicker$delegate, false);
      ProductDetailsScreen$lambda_6($birthdayPickerTargetOptionKey$delegate, null);
      ProductDetailsScreen$lambda_8($isPickingBoxBirthday$delegate, false);
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_33($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C434@19576L189,434@19555L299:ProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1277484385, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ProductDetailsScreen.<anonymous>.<anonymous> (ProductDetailsScreen.kt:434)');
        }
        sourceInformationMarkerStart($composer_0, 698154236, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProductDetailsScreen$lambda$lambda_0($showBirthdayPicker$delegate, $birthdayPickerTargetOptionKey$delegate, $isPickingBoxBirthday$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$ProductDetailsScreenKt_getInstance().z141_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_34($birthdayPickerState) {
    return function ($this$DatePickerDialog, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C443@19905L39:ProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-614642198, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ProductDetailsScreen.<anonymous>.<anonymous> (ProductDetailsScreen.kt:443)');
        }
        DatePicker($birthdayPickerState, null, null, null, null, null, false, null, $composer_0, 0, 254);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductDetailsScreen$lambda_35($product, $onBack, $onNavigateToAuth, $initialSize, $initialColor, $initialOptions, $initialComment, $initialCard, $initialBox, $initialCardMessage, $initialCardBirthday, $initialBoxMessage, $initialBoxBirthday, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      ProductDetailsScreen($product, $onBack, $onNavigateToAuth, $initialSize._v, $initialColor._v, $initialOptions._v, $initialComment._v, $initialCard._v, $initialBox._v, $initialCardMessage._v, $initialCardBirthday._v, $initialBoxMessage._v, $initialBoxBirthday._v, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  function ProductMediaGallery$lambda($combinedMedia, $name, $onZoomChanged) {
    return function ($this$HorizontalPager, page, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C476@20893L279:ProductDetailsScreen.kt#8gd4xm');
      var $dirty = $changed;
      var tmp;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(page) ? 32 : 16);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1012463378, $dirty, -1, 'client.fstech.hadaya.presentation.product_details.ProductMediaGallery.<anonymous>.<anonymous>.<anonymous> (ProductDetailsScreen.kt:475)');
        }
        var mediaUrl = $combinedMedia.l1(page);
        ZoomableMediaView(mediaUrl, $name, fillMaxSize(Companion_instance), Companion_getInstance_13().r96_1, $onZoomChanged, $composer_0, 3456, 0);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp_0 = tmp_1;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductMediaGallery$lambda_0($isFavorite) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C508@22145L417:ProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-367212247, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ProductMediaGallery.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ProductDetailsScreen.kt:508)');
        }
        AnimatedContent($isFavorite, null, null, null, null, null, ComposableSingletons$ProductDetailsScreenKt_getInstance().b142_1, $composer_0, 1572864, 62);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductMediaGallery$lambda_1($onMediaClick, $pagerState) {
    return function () {
      $onMediaClick($pagerState.zj9());
      return Unit_instance;
    };
  }
  function ProductMediaGallery$lambda$lambda($key, $items) {
    return function (index) {
      return $key(index, $items.l1(index));
    };
  }
  function ProductMediaGallery$lambda$lambda_0($items) {
    return function (index) {
      $items.l1(index);
      return null;
    };
  }
  function ProductMediaGallery$lambda$lambda$lambda($onMediaClick, $index) {
    return function () {
      $onMediaClick($index);
      return Unit_instance;
    };
  }
  function ProductMediaGallery$lambda$lambda_1($items, $pagerState, $onMediaClick) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp4 = $items.l1(it);
        var $changed_0 = 14 & $dirty | 112 & $dirty;
        var $composer_1 = $composer_0;
        $composer_1.m30(1179987860);
        sourceInformation($composer_1, 'C*569@25217L11,571@25477L23,567@25070L988:ProductDetailsScreen.kt#8gd4xm');
        var isSelected = $pagerState.zj9() === it;
        var tmp_2 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(64);
        var tmp_3 = size(tmp_2, tmp$ret$1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$2 = _Dp___init__impl__ms3zkb(12);
        var tmp_4 = background(clip(tmp_3, RoundedCornerShape(tmp$ret$2)), MaterialTheme_instance.unz($composer_1, 6).oo0_1);
        var tmp_5;
        if (isSelected) {
          // Inline function 'androidx.compose.ui.unit.dp' call
          tmp_5 = _Dp___init__impl__ms3zkb(2);
        } else {
          // Inline function 'androidx.compose.ui.unit.dp' call
          tmp_5 = _Dp___init__impl__ms3zkb(0);
        }
        var tmp_6 = tmp_5;
        var tmp_7;
        if (isSelected) {
          $composer_1.m30(-1485945739);
          sourceInformation($composer_1, '570@25359L11');
          var tmp0_group = MaterialTheme_instance.unz($composer_1, 6).xnz_1;
          $composer_1.n30();
          tmp_7 = tmp0_group;
        } else {
          $composer_1.m30(-1485945127);
          $composer_1.n30();
          tmp_7 = Companion_getInstance_14().t6b_1;
        }
        var tmp_8 = tmp_7;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$5 = _Dp___init__impl__ms3zkb(12);
        var tmp_9 = border(tmp_4, tmp_6, tmp_8, RoundedCornerShape(tmp$ret$5));
        sourceInformationMarkerStart($composer_1, -1485942331, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_1.k31($onMediaClick) | (($changed_0 & 112 ^ 48) > 32 && $composer_1.m31(it) || ($changed_0 & 48) === 32));
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_10;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = ProductMediaGallery$lambda$lambda$lambda($onMediaClick, it);
          $composer_1.j31(value);
          tmp_10 = value;
        } else {
          tmp_10 = it_0;
        }
        var tmp1_group = tmp_10;
        sourceInformationMarkerEnd($composer_1);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = clickable(tmp_9, VOID, VOID, VOID, VOID, tmp1_group);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_2 = $composer_1;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_3 = $composer_2;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
        var localMap = $composer_3.t31();
        var materialized = materialize($composer_3, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_4 = $composer_3;
        var tmp_11 = $composer_4.g30();
        if (!isInterface(tmp_11, Applier)) {
          invalidApplier();
        }
        $composer_4.b31();
        if ($composer_4.h30()) {
          $composer_4.c31(tmp0);
        } else {
          $composer_4.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_5 = $composer_4;
        var $composer_6 = $composer_5;
        sourceInformationMarkerStart($composer_6, -1298176728, 'C:ProductDetailsScreen.kt#8gd4xm');
        if (isVideoUrl(tmp4)) {
          $composer_6.m30(-1298157540);
          sourceInformation($composer_6, '574@25605L218');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_1 = fillMaxSize(Companion_instance);
          var contentAlignment_0 = Companion_getInstance_11().o8t_1;
          var propagateMinConstraints_0 = false;
          var $composer_7 = $composer_6;
          if (!((4 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((4 & 2) === 0))
            contentAlignment_0 = Companion_getInstance_11().k8t_1;
          if (!((4 & 4) === 0))
            propagateMinConstraints_0 = false;
          var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_8 = $composer_7;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
          var localMap_0 = $composer_8.t31();
          var materialized_0 = materialize($composer_8, modifier_2);
          var tmp0_0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_9 = $composer_8;
          var tmp_12 = $composer_9.g30();
          if (!isInterface(tmp_12, Applier)) {
            invalidApplier();
          }
          $composer_9.b31();
          if ($composer_9.h30()) {
            $composer_9.c31(tmp0_0);
          } else {
            $composer_9.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_10 = $composer_9;
          var $composer_11 = $composer_10;
          sourceInformationMarkerStart($composer_11, 1394979232, 'C575@25773L11,575@25715L78:ProductDetailsScreen.kt#8gd4xm');
          var tmp_13 = get_PlayCircle(Icons_getInstance().dxv_1);
          Icon(tmp_13, null, null, MaterialTheme_instance.unz($composer_11, 6).xnz_1, $composer_11, 48, 4);
          sourceInformationMarkerEnd($composer_11);
          $composer_9.e31();
          $composer_6.n30();
        } else {
          $composer_6.m30(-1297882663);
          sourceInformation($composer_6, '578@25885L125');
          HadayaImage(tmp4, null, fillMaxSize(Companion_instance), Companion_getInstance_13().q96_1, $composer_6, 3504 | 14 & $changed_0 >> 6, 0);
          $composer_6.n30();
        }
        sourceInformationMarkerEnd($composer_6);
        $composer_4.e31();
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductMediaGallery$lambda_2($combinedMedia, $pagerState, $onMediaClick) {
    return function ($this$LazyRow) {
      // Inline function 'androidx.compose.foundation.lazy.itemsIndexed' call
      var items = $combinedMedia;
      var tmp = items.n1();
      var tmp_0;
      if (!(null == null)) {
        tmp_0 = ProductMediaGallery$lambda$lambda(null, items);
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      var tmp_2 = ProductMediaGallery$lambda$lambda_0(items);
      $this$LazyRow.di9(tmp, tmp_1, tmp_2, ComposableLambda$invoke$ref_4(composableLambdaInstance(2039820996, true, ProductMediaGallery$lambda$lambda_1(items, $pagerState, $onMediaClick))));
      return Unit_instance;
    };
  }
  function ProductMediaGallery$lambda_3($combinedMedia, $pagerState, $isZooming, $name, $onZoomChanged, $onMediaClick, $onBack, $isFavorite, $onToggleFavorite, $onShare, $$changed) {
    return function ($composer, $force) {
      ProductMediaGallery($combinedMedia, $pagerState, $isZooming, $name, $onZoomChanged, $onMediaClick, $onBack, $isFavorite, $onToggleFavorite, $onShare, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new CardSelected_2(it instanceof Card_1 ? it : null));
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_0($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new CardMessageChanged_2(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_1($state) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C640@29726L101:ProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-945988781, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ProductInfoContent.<anonymous>.<anonymous> (ProductDetailsScreen.kt:640)');
        }
        var tmp_0 = '' + $state.w11d_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, null, $composer_0, 48, 0, 261116);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_2($onShowBirthdayPicker) {
    return function () {
      $onShowBirthdayPicker(null, false);
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_3(it) {
    return Unit_instance;
  }
  function ProductInfoContent$lambda$lambda($onShowBirthdayPicker) {
    return function () {
      $onShowBirthdayPicker(null, false);
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_4($onShowBirthdayPicker) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C652@30470L37,652@30449L103:ProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(732230810, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ProductInfoContent.<anonymous>.<anonymous> (ProductDetailsScreen.kt:652)');
        }
        sourceInformationMarkerStart($composer_0, -700827361, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($onShowBirthdayPicker);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProductInfoContent$lambda$lambda($onShowBirthdayPicker);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$ProductDetailsScreenKt_getInstance().g142_1, $composer_0, 1572864, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_5($viewModel) {
    return function (it) {
      var tmp = $viewModel.s10h();
      tmp.j10i(new BoxSelected_2(it instanceof Box_0 ? it : null));
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_6($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 20) {
        $viewModel.s10h().j10i(new BoxMessageChanged_2(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_7($state) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C674@31695L100:ProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(2128642122, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ProductInfoContent.<anonymous>.<anonymous> (ProductDetailsScreen.kt:674)');
        }
        var tmp_0 = '' + $state.a11e_1.length + '/20';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, null, $composer_0, 48, 0, 261116);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_8($onShowBirthdayPicker) {
    return function () {
      $onShowBirthdayPicker(null, true);
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_9(it) {
    return Unit_instance;
  }
  function ProductInfoContent$lambda$lambda_0($onShowBirthdayPicker) {
    return function () {
      $onShowBirthdayPicker(null, true);
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_10($onShowBirthdayPicker) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C686@32435L36,686@32414L102:ProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-10034223, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ProductInfoContent.<anonymous>.<anonymous> (ProductDetailsScreen.kt:686)');
        }
        sourceInformationMarkerStart($composer_0, -1052952939, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($onShowBirthdayPicker);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProductInfoContent$lambda$lambda_0($onShowBirthdayPicker);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$ProductDetailsScreenKt_getInstance().j142_1, $composer_0, 1572864, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_11($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new SizeSelected_2(it));
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_12($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new ColorSelected_2(it));
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_13($viewModel, $option) {
    return function (value) {
      $viewModel.s10h().j10i(new OptionSelected_2($option.r101_1, value));
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_14($viewModel, $option) {
    return function (newValue) {
      $viewModel.s10h().j10i(new OptionSelected_2($option.r101_1, newValue));
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_15($onShowBirthdayPicker, $option) {
    return function () {
      $onShowBirthdayPicker($option.r101_1, false);
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_16($viewModel) {
    return function (it) {
      var tmp;
      if (it.length <= 100) {
        $viewModel.s10h().j10i(new ProductCommentChanged_2(it));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_17($state) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C716@34564L105:ProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1288063453, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ProductInfoContent.<anonymous>.<anonymous> (ProductDetailsScreen.kt:716)');
        }
        var tmp_0 = '' + $state.g11e_1.length + '/100';
        var tmp_1 = fillMaxWidth(Companion_instance);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = Companion_getInstance_15().g7v_1;
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, tmp_1, tmp_2, null, tmp_3, null, null, null, tmp_4, null, tmp_5, tmp_6, tmp_7, false, 0, 0, null, null, $composer_0, 48, 0, 261116);
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductInfoContent$lambda_18($activeProduct, $state, $name, $description, $language, $viewModel, $onShowBirthdayPicker, $$changed) {
    return function ($composer, $force) {
      ProductInfoContent($activeProduct, $state, $name, $description, $language, $viewModel, $onShowBirthdayPicker, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function ProductActionBar$lambda$lambda($state, $viewModel) {
    return function () {
      var tmp;
      if ($state.o11d_1 > 1) {
        $viewModel.s10h().j10i(new QuantityChanged_1($state.o11d_1 - 1 | 0));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductActionBar$lambda$lambda_0($viewModel, $state) {
    return function () {
      $viewModel.s10h().j10i(new QuantityChanged_1($state.o11d_1 + 1 | 0));
      return Unit_instance;
    };
  }
  function ProductActionBar$lambda$lambda_1($activeProduct, $viewModel) {
    return function () {
      var tmp;
      var tmp0_elvis_lhs = $activeProduct.wzt_1;
      if ((tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) > 0) {
        $viewModel.s10h().j10i(AddToCart_instance_2);
        tmp = Unit_instance;
      } else {
        $viewModel.s10h().j10i(ToggleStockReminder_instance_1);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductActionBar$lambda$lambda_2($state, $activeProduct) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:ProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-560861945, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ProductActionBar.<anonymous>.<anonymous>.<anonymous> (ProductDetailsScreen.kt:780)');
        }
        if ($state.p11d_1) {
          $composer_0.m30(-1215374716);
          sourceInformation($composer_0, '781@37882L79');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          var tmp_2 = Companion_getInstance_14().m6b_1;
          var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_0, 54, 60);
          $composer_0.n30();
        } else {
          $composer_0.m30(-1215232085);
          sourceInformation($composer_0, '791@38532L16,792@38569L39,793@38629L58');
          var tmp_6;
          var tmp0_elvis_lhs = $activeProduct.wzt_1;
          if ((tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) > 0) {
            $composer_0.m30(-2117409491);
            sourceInformation($composer_0, '783@38054L38');
            var tmp0_group = stringResource(get_add_to_cart(string_instance), $composer_0, 0);
            $composer_0.n30();
            tmp_6 = tmp0_group;
          } else {
            if ($state.r11d_1) {
              $composer_0.m30(-2117406482);
              sourceInformation($composer_0, '784@38148L39');
              var tmp1_group = stringResource(get_reminder_set(string_instance), $composer_0, 0);
              $composer_0.n30();
              tmp_6 = tmp1_group;
            } else {
              $composer_0.m30(-2117404405);
              sourceInformation($composer_0, '785@38213L36');
              var tmp2_group = stringResource(get_remind_me(string_instance), $composer_0, 0);
              $composer_0.n30();
              tmp_6 = tmp2_group;
            }
          }
          var text = tmp_6;
          var tmp_7;
          var tmp1_elvis_lhs = $activeProduct.wzt_1;
          if ((tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) > 0) {
            tmp_7 = get_ShoppingCart(Icons_getInstance().dxv_1);
          } else {
            if ($state.r11d_1) {
              tmp_7 = get_NotificationsActive(Icons_getInstance().dxv_1);
            } else {
              tmp_7 = get_NotificationsNone(Icons_getInstance().dxv_1);
            }
          }
          var icon = tmp_7;
          Icon(icon, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
          var tmp_8 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$1 = _Dp___init__impl__ms3zkb(8);
          Spacer(width(tmp_8, tmp$ret$1), $composer_0, 6);
          var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp3_fontSize = get_sp(16);
          var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_12 = _TextOverflow___init__impl__obguoe(0);
          Text(text, null, tmp_9, null, tmp3_fontSize, null, tmp2_fontWeight, null, tmp_10, null, null, tmp_11, tmp_12, false, 0, 0, null, null, $composer_0, 1597440, 0, 262062);
          $composer_0.n30();
        }
        var tmp_13;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_13 = Unit_instance;
        }
        tmp = tmp_13;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductActionBar$lambda($activeProduct, $state, $viewModel, $language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C751@36209L2520:ProductDetailsScreen.kt#8gd4xm');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2057975845, $changed, -1, 'client.fstech.hadaya.presentation.product_details.ProductActionBar.<anonymous> (ProductDetailsScreen.kt:751)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        var tmp0_modifier = fillMaxWidth(padding_0(tmp_0, tmp$ret$0));
        var tmp1_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_1 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = tmp0_modifier;
        var horizontalArrangement = tmp_1.mdq(tmp$ret$1);
        var verticalAlignment = tmp1_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_2 = $composer_3.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -958622282, 'C772@37410L229,779@37816L903,771@37376L1343:ProductDetailsScreen.kt#8gd4xm');
        var tmp2_elvis_lhs = $activeProduct.wzt_1;
        if ((tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) > 0) {
          $composer_5.m30(-958612890);
          sourceInformation($composer_5, '759@36617L11,757@36479L869');
          var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
          var tmp_3 = Companion_instance;
          var tmp_4 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_5, 6).oo0_1, 0.5);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$8 = _Dp___init__impl__ms3zkb(12);
          var tmp_5 = background(tmp_3, tmp_4, RoundedCornerShape(tmp$ret$8));
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$9 = _Dp___init__impl__ms3zkb(4);
          // Inline function 'androidx.compose.foundation.layout.Row' call
          var modifier_1 = padding_0(tmp_5, tmp$ret$9);
          var horizontalArrangement_0 = null;
          var verticalAlignment_0 = tmp0_verticalAlignment;
          var $composer_6 = $composer_5;
          if (!((2 & 1) === 0))
            modifier_1 = Companion_instance;
          if (!((2 & 2) === 0))
            horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
          if (!((2 & 4) === 0))
            verticalAlignment_0 = Companion_getInstance_11().t8t_1;
          var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_6, 14 & 384 >> 3 | 112 & 384 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_2 = modifier_1;
          var $composer_7 = $composer_6;
          if (!((0 & 2) === 0))
            modifier_2 = Companion_instance;
          var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
          var localMap_0 = $composer_7.t31();
          var materialized_0 = materialize($composer_7, modifier_2);
          var tmp0_0 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_8 = $composer_7;
          var tmp_6 = $composer_8.g30();
          if (!isInterface(tmp_6, Applier)) {
            invalidApplier();
          }
          $composer_8.b31();
          if ($composer_8.h30()) {
            $composer_8.c31(tmp0_0);
          } else {
            $composer_8.d31();
          }
          var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
          var $composer_9 = $composer_8;
          var $composer_10 = $composer_9;
          sourceInformationMarkerStart($composer_10, 539528450, 'C761@36766L112,761@36745L215,764@36981L140,765@37163L88,765@37142L188:ProductDetailsScreen.kt#8gd4xm');
          sourceInformationMarkerStart($composer_10, 1679972328, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = !!($composer_10.q31($state) | $composer_10.q31($viewModel));
          // Inline function 'kotlin.let' call
          var it = $composer_10.i31();
          var tmp_7;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = ProductActionBar$lambda$lambda($state, $viewModel);
            $composer_10.j31(value);
            tmp_7 = value;
          } else {
            tmp_7 = it;
          }
          var tmp0_group = tmp_7;
          sourceInformationMarkerEnd($composer_10);
          IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$ProductDetailsScreenKt_getInstance().l142_1, $composer_10, 1572864, 62);
          var tmp0_text = format($state.o11d_1, $language);
          var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp2_fontSize = get_sp(18);
          var tmp_8 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$20 = _Dp___init__impl__ms3zkb(8);
          var tmp3_modifier = padding_2(tmp_8, tmp$ret$20);
          var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_12 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, tmp3_modifier, tmp_9, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_10, null, null, tmp_11, tmp_12, false, 0, 0, null, null, $composer_10, 1597488, 0, 262060);
          sourceInformationMarkerStart($composer_10, 1679985008, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = !!($composer_10.q31($viewModel) | $composer_10.q31($state));
          // Inline function 'kotlin.let' call
          var it_0 = $composer_10.i31();
          var tmp_13;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = ProductActionBar$lambda$lambda_0($viewModel, $state);
            $composer_10.j31(value_0);
            tmp_13 = value_0;
          } else {
            tmp_13 = it_0;
          }
          var tmp1_group = tmp_13;
          sourceInformationMarkerEnd($composer_10);
          IconButton(tmp1_group, null, false, null, null, null, ComposableSingletons$ProductDetailsScreenKt_getInstance().m142_1, $composer_10, 1572864, 62);
          sourceInformationMarkerEnd($composer_10);
          $composer_8.e31();
          $composer_5.n30();
        } else {
          $composer_5.m30(-957763893);
          $composer_5.n30();
        }
        var tmp_14 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$25 = _Dp___init__impl__ms3zkb(56);
        var tmp3_modifier_0 = height(tmp_14, tmp$ret$25);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$26 = _Dp___init__impl__ms3zkb(16);
        var tmp4_shape = RoundedCornerShape(tmp$ret$26);
        var tmp5_enabled = !$state.p11d_1;
        sourceInformationMarkerStart($composer_5, 523295484, 'CC(remember):ProductDetailsScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = !!($composer_5.q31($activeProduct) | $composer_5.q31($viewModel));
        // Inline function 'kotlin.let' call
        var it_1 = $composer_5.i31();
        var tmp_15;
        if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
          var value_1 = ProductActionBar$lambda$lambda_1($activeProduct, $viewModel);
          $composer_5.j31(value_1);
          tmp_15 = value_1;
        } else {
          tmp_15 = it_1;
        }
        var tmp0_group_0 = tmp_15;
        sourceInformationMarkerEnd($composer_5);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-560861945, true, ProductActionBar$lambda$lambda_2($state, $activeProduct), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_11 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_11.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_2 = $composer_11.i31();
        var tmp_16;
        if (invalid_2 || it_2 === Companion_getInstance().f30_1) {
          var value_2 = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_11.j31(value_2);
          tmp_16 = value_2;
        } else {
          tmp_16 = it_2;
        }
        var tmp$ret$31 = tmp_16;
        Button(tmp0_group_0, tmp3_modifier_0, tmp5_enabled, tmp4_shape, null, null, null, null, null, tmp$ret$31, $composer_5, 805306368, 496);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_17;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_17 = Unit_instance;
        }
        tmp = tmp_17;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductActionBar$lambda_0($activeProduct, $state, $language, $viewModel, $$changed) {
    return function ($composer, $force) {
      ProductActionBar($activeProduct, $state, $language, $viewModel, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_product_details_ProductDetailsViewModel$stable;
  function ProductDetailsViewModel$observeLanguage$slambda$slambda$lambda($language) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, $language);
    };
  }
  function ProductDetailsViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation) {
    this.z144_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductDetailsViewModel$observeLanguage$slambda$slambda).pyo = function (language, $completion) {
    var tmp = this.um9(language, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsViewModel$observeLanguage$slambda$slambda).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsViewModel$observeLanguage$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.z144_1.x10k(ProductDetailsViewModel$observeLanguage$slambda$slambda$lambda(this.a145_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ProductDetailsViewModel$observeLanguage$slambda$slambda).um9 = function (language, completion) {
    var i = new ProductDetailsViewModel$observeLanguage$slambda$slambda(this.z144_1, completion);
    i.a145_1 = language;
    return i;
  };
  function ProductDetailsViewModel$observeLanguage$slambda$slambda_0(this$0, resultContinuation) {
    var i = new ProductDetailsViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (language, $completion) {
      return i.pyo(language, $completion);
    }, 1);
  }
  function ProductDetailsViewModel$observeFavorite$slambda$slambda$lambda($isFavorite) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, $isFavorite);
    };
  }
  function ProductDetailsViewModel$observeFavorite$slambda$slambda(this$0, resultContinuation) {
    this.j145_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductDetailsViewModel$observeFavorite$slambda$slambda).xf4 = function (isFavorite, $completion) {
    var tmp = this.yf4(isFavorite, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsViewModel$observeFavorite$slambda$slambda).ja = function (p1, $completion) {
    return this.xf4((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsViewModel$observeFavorite$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.j145_1.x10k(ProductDetailsViewModel$observeFavorite$slambda$slambda$lambda(this.k145_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ProductDetailsViewModel$observeFavorite$slambda$slambda).yf4 = function (isFavorite, completion) {
    var i = new ProductDetailsViewModel$observeFavorite$slambda$slambda(this.j145_1, completion);
    i.k145_1 = isFavorite;
    return i;
  };
  function ProductDetailsViewModel$observeFavorite$slambda$slambda_0(this$0, resultContinuation) {
    var i = new ProductDetailsViewModel$observeFavorite$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (isFavorite, $completion) {
      return i.xf4(isFavorite, $completion);
    }, 1);
  }
  function ProductDetailsViewModel$observeStockReminder$slambda$slambda$lambda($isSet) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, $isSet);
    };
  }
  function ProductDetailsViewModel$observeStockReminder$slambda$slambda(this$0, resultContinuation) {
    this.t145_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductDetailsViewModel$observeStockReminder$slambda$slambda).xf4 = function (isSet, $completion) {
    var tmp = this.yf4(isSet, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsViewModel$observeStockReminder$slambda$slambda).ja = function (p1, $completion) {
    return this.xf4((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsViewModel$observeStockReminder$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.t145_1.x10k(ProductDetailsViewModel$observeStockReminder$slambda$slambda$lambda(this.u145_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ProductDetailsViewModel$observeStockReminder$slambda$slambda).yf4 = function (isSet, completion) {
    var i = new ProductDetailsViewModel$observeStockReminder$slambda$slambda(this.t145_1, completion);
    i.u145_1 = isSet;
    return i;
  };
  function ProductDetailsViewModel$observeStockReminder$slambda$slambda_0(this$0, resultContinuation) {
    var i = new ProductDetailsViewModel$observeStockReminder$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (isSet, $completion) {
      return i.xf4(isSet, $completion);
    }, 1);
  }
  function ProductDetailsViewModel$handleIntent$slambda$lambda($activeProduct, $cards, $boxes) {
    return function ($this$updateState) {
      return $this$updateState.x140($activeProduct, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $cards, $boxes);
    };
  }
  function ProductDetailsViewModel$handleIntent$slambda$lambda_0($this$updateState) {
    return $this$updateState.x140(VOID, VOID, false);
  }
  function ProductDetailsViewModel$handleIntent$slambda$lambda_1($this$updateState) {
    return $this$updateState.x140(VOID, VOID, false);
  }
  function observeLanguage_8($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, ProductDetailsViewModel$observeLanguage$slambda_0($this, null));
  }
  function observeFavorite_1($this, productId) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, ProductDetailsViewModel$observeFavorite$slambda_0($this, productId, null));
  }
  function observeStockReminder_1($this, productId) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, ProductDetailsViewModel$observeStockReminder$slambda_0($this, productId, null));
  }
  function ProductDetailsViewModel$observeLanguage$slambda(this$0, resultContinuation) {
    this.d146_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductDetailsViewModel$observeLanguage$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsViewModel$observeLanguage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsViewModel$observeLanguage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.d146_1.l146_1.y103();
            var action = ProductDetailsViewModel$observeLanguage$slambda$slambda_0(this.d146_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProductDetailsViewModel$observeLanguage$slambda).q24 = function ($this$launch, completion) {
    var i = new ProductDetailsViewModel$observeLanguage$slambda(this.d146_1, completion);
    i.e146_1 = $this$launch;
    return i;
  };
  function ProductDetailsViewModel$observeLanguage$slambda_0(this$0, resultContinuation) {
    var i = new ProductDetailsViewModel$observeLanguage$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProductDetailsViewModel$observeFavorite$slambda(this$0, $productId, resultContinuation) {
    this.y146_1 = this$0;
    this.z146_1 = $productId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductDetailsViewModel$observeFavorite$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsViewModel$observeFavorite$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsViewModel$observeFavorite$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.y146_1.m146_1.tz6(this.z146_1);
            suspendResult = collectLatest(tmp_0, ProductDetailsViewModel$observeFavorite$slambda$slambda_0(this.y146_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProductDetailsViewModel$observeFavorite$slambda).q24 = function ($this$launch, completion) {
    var i = new ProductDetailsViewModel$observeFavorite$slambda(this.y146_1, this.z146_1, completion);
    i.a147_1 = $this$launch;
    return i;
  };
  function ProductDetailsViewModel$observeFavorite$slambda_0(this$0, $productId, resultContinuation) {
    var i = new ProductDetailsViewModel$observeFavorite$slambda(this$0, $productId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProductDetailsViewModel$observeStockReminder$slambda(this$0, $productId, resultContinuation) {
    this.j147_1 = this$0;
    this.k147_1 = $productId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductDetailsViewModel$observeStockReminder$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsViewModel$observeStockReminder$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsViewModel$observeStockReminder$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.j147_1.o146_1.czr(this.k147_1);
            suspendResult = collectLatest(tmp_0, ProductDetailsViewModel$observeStockReminder$slambda$slambda_0(this.j147_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProductDetailsViewModel$observeStockReminder$slambda).q24 = function ($this$launch, completion) {
    var i = new ProductDetailsViewModel$observeStockReminder$slambda(this.j147_1, this.k147_1, completion);
    i.l147_1 = $this$launch;
    return i;
  };
  function ProductDetailsViewModel$observeStockReminder$slambda_0(this$0, $productId, resultContinuation) {
    var i = new ProductDetailsViewModel$observeStockReminder$slambda(this$0, $productId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProductDetailsViewModel$handleIntent$lambda($intent) {
    return function ($this$updateState) {
      var tmp9_product = $intent.y140_1;
      var tmp0_elvis_lhs = $intent.y140_1.bzu_1;
      var tmp10_selectedKind = tmp0_elvis_lhs == null ? ProductKind_NORMAL_getInstance() : tmp0_elvis_lhs;
      var tmp1_elvis_lhs = $intent.y140_1.izu_1;
      var tmp11_selectedAudience = tmp1_elvis_lhs == null ? TargetAudience_BOTH_getInstance() : tmp1_elvis_lhs;
      var tmp12_selectedSize = $intent.z140_1;
      var tmp13_selectedColor = $intent.a141_1;
      var tmp2_elvis_lhs = $intent.b141_1;
      var tmp14_selectedOptions = tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs;
      var tmp3_elvis_lhs = $intent.c141_1;
      var tmp15_productComment = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      var tmp16_selectedCard = $intent.d141_1;
      var tmp17_selectedBox = $intent.e141_1;
      var tmp4_elvis_lhs = $intent.f141_1;
      var tmp18_cardMessage = tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = $intent.g141_1;
      var tmp19_cardBirthday = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
      var tmp6_elvis_lhs = $intent.h141_1;
      var tmp20_boxMessage = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
      var tmp7_elvis_lhs = $intent.i141_1;
      var tmp21_boxBirthday = tmp7_elvis_lhs == null ? '' : tmp7_elvis_lhs;
      var tmp8_elvis_lhs = $intent.j141_1;
      var tmp22_braceletName = tmp8_elvis_lhs == null ? '' : tmp8_elvis_lhs;
      var tmp23_availableCards = emptyList();
      var tmp24_availableBoxes = emptyList();
      return $this$updateState.x140(tmp9_product, VOID, VOID, VOID, VOID, VOID, tmp10_selectedKind, tmp11_selectedAudience, tmp16_selectedCard, tmp18_cardMessage, tmp19_cardBirthday, VOID, tmp17_selectedBox, tmp20_boxMessage, tmp21_boxBirthday, VOID, tmp12_selectedSize, tmp13_selectedColor, tmp14_selectedOptions, tmp15_productComment, tmp22_braceletName, tmp23_availableCards, tmp24_availableBoxes);
    };
  }
  function ProductDetailsViewModel$handleIntent$slambda(this$0, $intent, resultContinuation) {
    this.u147_1 = this$0;
    this.v147_1 = $intent;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductDetailsViewModel$handleIntent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsViewModel$handleIntent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsViewModel$handleIntent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            var currentUser = this.u147_1.k146_1.ynu();
            this.b148_1 = this.v147_1.y140_1;
            this.n9_1 = 1;
            var tmp0_elvis_lhs = this.b148_1.nzt_1;
            var tmp_0 = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
            suspendResult = this.u147_1.p146_1.zzk(tmp_0, currentUser == null ? null : currentUser.uym_1, getPlatform().m(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            var tmp2_elvis_lhs = this.b148_1.nzt_1;
            suspendResult = this.u147_1.p146_1.yzi(tmp2_elvis_lhs == null ? new Long(0, 0) : tmp2_elvis_lhs, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var fullProduct = suspendResult;
            var tmp_1 = this;
            tmp_1.y147_1 = fullProduct == null ? this.b148_1 : fullProduct;
            var tmp_2;
            var this_0 = this.y147_1.jzu_1;
            if (!(this_0 == null || this_0.r())) {
              tmp_2 = true;
            } else {
              var this_1 = this.y147_1.kzu_1;
              tmp_2 = !(this_1 == null || this_1.r());
            }

            if (tmp_2) {
              var this_2 = this.y147_1.jzu_1;
              if (!(this_2 == null || this_2.r())) {
                this.n9_1 = 3;
                suspendResult = this.u147_1.p146_1.xzk(this.y147_1.jzu_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.a148_1 = emptyList();
                this.n9_1 = 4;
                continue $sm;
              }
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 3:
            var tmp_3 = this;
            var tmp0 = suspendResult;
            var destination = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s = tmp0.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              if (!element.nyz_1) {
                destination.j1(element);
              }
            }

            tmp_3.a148_1 = destination;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.x147_1 = this.a148_1;
            var this_3 = this.y147_1.kzu_1;
            if (!(this_3 == null || this_3.r())) {
              this.n9_1 = 5;
              suspendResult = this.u147_1.p146_1.yzk(this.y147_1.kzu_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.z147_1 = emptyList();
              this.n9_1 = 6;
              continue $sm;
            }

          case 5:
            var tmp_4 = this;
            var tmp0_0 = suspendResult;
            var destination_0 = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s_0 = tmp0_0.t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              if (!element_0.yyz_1) {
                destination_0.j1(element_0);
              }
            }

            tmp_4.z147_1 = destination_0;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var boxes = this.z147_1;
            this.u147_1.x10k(ProductDetailsViewModel$handleIntent$slambda$lambda(this.y147_1, this.x147_1, boxes));
            this.n9_1 = 7;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProductDetailsViewModel$handleIntent$slambda).q24 = function ($this$launch, completion) {
    var i = new ProductDetailsViewModel$handleIntent$slambda(this.u147_1, this.v147_1, completion);
    i.w147_1 = $this$launch;
    return i;
  };
  function ProductDetailsViewModel$handleIntent$slambda_0(this$0, $intent, resultContinuation) {
    var i = new ProductDetailsViewModel$handleIntent$slambda(this$0, $intent, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProductDetailsViewModel$handleIntent$slambda_1(this$0, $productId, resultContinuation) {
    this.k148_1 = this$0;
    this.l148_1 = $productId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductDetailsViewModel$handleIntent$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsViewModel$handleIntent$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsViewModel$handleIntent$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.k148_1.n146_1.vdf(this.l148_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.k148_1.d10l(new ShowMessage_5(new DynamicString('Reminder updated')), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              this.n9_1 = 4;
              suspendResult = this.k148_1.d10l(new ShowMessage_5(new DynamicString('Failed to update reminder')), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(ProductDetailsViewModel$handleIntent$slambda_1).q24 = function ($this$launch, completion) {
    var i = new ProductDetailsViewModel$handleIntent$slambda_1(this.k148_1, this.l148_1, completion);
    i.m148_1 = $this$launch;
    return i;
  };
  function ProductDetailsViewModel$handleIntent$slambda_2(this$0, $productId, resultContinuation) {
    var i = new ProductDetailsViewModel$handleIntent$slambda_1(this$0, $productId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProductDetailsViewModel$handleIntent$lambda_0($this$updateState) {
    return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function ProductDetailsViewModel$handleIntent$lambda_1($this$updateState) {
    return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function ProductDetailsViewModel$handleIntent$lambda_2($this$updateState) {
    return $this$updateState.x140(VOID, VOID, true);
  }
  function ProductDetailsViewModel$handleIntent$slambda_3(this$0, $currentProduct, $state, $currentUser, $finalPrice, $finalDiscount, resultContinuation) {
    this.v148_1 = this$0;
    this.w148_1 = $currentProduct;
    this.x148_1 = $state;
    this.y148_1 = $currentUser;
    this.z148_1 = $finalPrice;
    this.a149_1 = $finalDiscount;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProductDetailsViewModel$handleIntent$slambda_3).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsViewModel$handleIntent$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsViewModel$handleIntent$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.o9_1 = 3;
            this.n9_1 = 1;
            var tmp0_elvis_lhs = this.w148_1.ozt_1;
            var tmp14_nameEnglish = tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
            var tmp1_elvis_lhs = this.w148_1.pzt_1;
            var tmp15_nameArabic = tmp1_elvis_lhs == null ? 'Unknown' : tmp1_elvis_lhs;
            var tmp16_productId = this.w148_1.nzt_1;
            var tmp2_elvis_lhs = this.w148_1.qzt_1;
            var tmp17_descriptionEnglish = tmp2_elvis_lhs == null ? 'Unknown' : tmp2_elvis_lhs;
            var tmp3_elvis_lhs = this.w148_1.rzt_1;
            var tmp18_descriptionArabic = tmp3_elvis_lhs == null ? 'Unknown' : tmp3_elvis_lhs;
            var tmp4_elvis_lhs = this.w148_1.uzt_1;
            var tmp19_discountPercent = tmp4_elvis_lhs == null ? 0.0 : tmp4_elvis_lhs;
            var tmp5_elvis_lhs = this.w148_1.vzt_1;
            var tmp20_rating = tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs;
            var tmp6_elvis_lhs = this.w148_1.wzt_1;
            var tmp21_stock = tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs;
            var tmp22_imageUrl = this.w148_1.xzt_1;
            var tmp23_videoUrl = this.w148_1.yzt_1;
            var tmp24_createdAt = this.w148_1.zzt_1;
            var tmp25_quantity = this.x148_1.o11d_1;
            var tmp26_userId = this.y148_1.uym_1;
            var tmp27_kind = this.x148_1.t11d_1;
            var tmp7_elvis_lhs = this.w148_1.czu_1;
            var tmp28_category = tmp7_elvis_lhs == null ? '' : tmp7_elvis_lhs;
            var tmp8_elvis_lhs = this.w148_1.dzu_1;
            var tmp29_categoryNameEnglish = tmp8_elvis_lhs == null ? '' : tmp8_elvis_lhs;
            var tmp9_elvis_lhs = this.w148_1.ezu_1;
            var tmp30_categoryNameArabic = tmp9_elvis_lhs == null ? '' : tmp9_elvis_lhs;
            var tmp31_designLayers = this.w148_1.fzu_1;
            var tmp32_targetAudience = this.x148_1.u11d_1;
            var tmp33_selectedCard = this.x148_1.v11d_1;
            var tmp_0;
            var tmp10_safe_receiver = this.x148_1.v11d_1;
            if ((tmp10_safe_receiver == null ? null : tmp10_safe_receiver.oyz_1) === true) {
              tmp_0 = this.x148_1.w11d_1;
            } else {
              tmp_0 = null;
            }

            var tmp34_cardMessage = tmp_0;
            var tmp_1;
            var tmp11_safe_receiver = this.x148_1.v11d_1;
            if ((tmp11_safe_receiver == null ? null : tmp11_safe_receiver.pyz_1) === true) {
              tmp_1 = this.x148_1.x11d_1;
            } else {
              tmp_1 = null;
            }

            var tmp35_cardBirthday = tmp_1;
            var tmp36_selectedBox = this.x148_1.z11d_1;
            var tmp_2;
            var tmp12_safe_receiver = this.x148_1.z11d_1;
            if ((tmp12_safe_receiver == null ? null : tmp12_safe_receiver.zyz_1) === true) {
              tmp_2 = this.x148_1.a11e_1;
            } else {
              tmp_2 = null;
            }

            var tmp37_boxMessage = tmp_2;
            var tmp_3;
            var tmp13_safe_receiver = this.x148_1.z11d_1;
            if ((tmp13_safe_receiver == null ? null : tmp13_safe_receiver.az0_1) === true) {
              tmp_3 = this.x148_1.b11e_1;
            } else {
              tmp_3 = null;
            }

            var tmp38_boxBirthday = tmp_3;
            var tmp39_selectedSize = this.x148_1.d11e_1;
            var tmp40_selectedColor = this.x148_1.e11e_1;
            var this_0 = this.x148_1.f11e_1;
            var tmp_4;
            if (this_0.r()) {
              tmp_4 = null;
            } else {
              tmp_4 = this_0;
            }

            var tmp41_selectedOptions = tmp_4;
            var this_1 = this.x148_1.g11e_1;
            var tmp_5;
            if (!isBlank(this_1)) {
              tmp_5 = this_1;
            } else {
              tmp_5 = null;
            }

            var tmp42_productComment = tmp_5;
            var this_2 = this.x148_1.h11e_1;
            var tmp_6;
            if (!isBlank(this_2)) {
              tmp_6 = this_2;
            } else {
              tmp_6 = null;
            }

            var tmp43_braceletName = tmp_6;
            var tmp44_isKids = this.w148_1.rzu_1;
            var tmp45_isYouth = this.w148_1.szu_1;
            var tmp46_isOld = this.w148_1.tzu_1;
            suspendResult = this.v148_1.j146_1.c103(new CartItem(VOID, tmp16_productId, tmp14_nameEnglish, tmp15_nameArabic, tmp17_descriptionEnglish, tmp18_descriptionArabic, this.z148_1, this.a149_1, tmp19_discountPercent, tmp20_rating, tmp21_stock, tmp22_imageUrl, tmp25_quantity, VOID, tmp31_designLayers, tmp26_userId, tmp24_createdAt, tmp23_videoUrl, VOID, tmp27_kind, tmp28_category, tmp29_categoryNameEnglish, tmp30_categoryNameArabic, tmp32_targetAudience, tmp33_selectedCard, tmp34_cardMessage, tmp35_cardBirthday, tmp36_selectedBox, tmp37_boxMessage, tmp38_boxBirthday, tmp39_selectedSize, tmp40_selectedColor, tmp41_selectedOptions, tmp42_productComment, tmp44_isKids, tmp45_isYouth, tmp46_isOld, tmp43_braceletName), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.v148_1.x10k(ProductDetailsViewModel$handleIntent$slambda$lambda_0);
            this.n9_1 = 2;
            suspendResult = this.v148_1.d10l(new ShowToast_1(new ResourceString(get_added_to_cart(string_instance), [])), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_7 = this.q9_1;
            if (tmp_7 instanceof Exception) {
              var e = this.q9_1;
              this.v148_1.x10k(ProductDetailsViewModel$handleIntent$slambda$lambda_1);
              this.n9_1 = 4;
              var tmp_8 = get_failed_add_to_cart(string_instance);
              var tmp47_elvis_lhs = e.message;
              suspendResult = this.v148_1.d10l(new ShowMessage_5(new ResourceString(tmp_8, [tmp47_elvis_lhs == null ? '' : tmp47_elvis_lhs])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 6;
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(ProductDetailsViewModel$handleIntent$slambda_3).q24 = function ($this$launch, completion) {
    var i = new ProductDetailsViewModel$handleIntent$slambda_3(this.v148_1, this.w148_1, this.x148_1, this.y148_1, this.z148_1, this.a149_1, completion);
    i.b149_1 = $this$launch;
    return i;
  };
  function ProductDetailsViewModel$handleIntent$slambda_4(this$0, $currentProduct, $state, $currentUser, $finalPrice, $finalDiscount, resultContinuation) {
    var i = new ProductDetailsViewModel$handleIntent$slambda_3(this$0, $currentProduct, $state, $currentUser, $finalPrice, $finalDiscount, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProductDetailsViewModel$handleIntent$lambda_3($intent) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, $intent.k141_1);
    };
  }
  function ProductDetailsViewModel$handleIntent$lambda_4($intent) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, $intent.c149_1);
    };
  }
  function ProductDetailsViewModel$handleIntent$lambda_5($intent) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.d149_1);
    };
  }
  function ProductDetailsViewModel$handleIntent$lambda_6($intent) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.l141_1);
    };
  }
  function ProductDetailsViewModel$handleIntent$lambda_7($intent) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.m141_1);
    };
  }
  function ProductDetailsViewModel$handleIntent$lambda_8($intent) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.n141_1, false);
    };
  }
  function ProductDetailsViewModel$handleIntent$lambda_9($intent) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.o141_1);
    };
  }
  function ProductDetailsViewModel$handleIntent$lambda_10($intent) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.p141_1);
    };
  }
  function ProductDetailsViewModel$handleIntent$lambda_11($intent) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.q141_1, false);
    };
  }
  function ProductDetailsViewModel$handleIntent$lambda_12($intent) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.r141_1);
    };
  }
  function ProductDetailsViewModel$handleIntent$lambda_13($intent) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.s141_1);
    };
  }
  function ProductDetailsViewModel$handleIntent$lambda_14(this$0, $intent) {
    return function ($this$updateState) {
      var currentOptions = toMutableMap(this$0.s10h().ajg().u1().f11e_1);
      if ($intent.u141_1 == null) {
        currentOptions.a3($intent.t141_1);
      } else {
        var valueWithGroup = $intent.u141_1;
        // Inline function 'kotlin.collections.set' call
        var key = $intent.t141_1;
        currentOptions.z2(key, valueWithGroup);
      }
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, currentOptions);
    };
  }
  function ProductDetailsViewModel$handleIntent$lambda_15($intent) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.v141_1);
    };
  }
  function ProductDetailsViewModel$handleIntent$lambda_16($intent) {
    return function ($this$updateState) {
      return $this$updateState.x140(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.e149_1);
    };
  }
  function ProductDetailsViewModel$onCleared$lambda($this$updateState) {
    var tmp0_availableCards = emptyList();
    var tmp1_availableBoxes = emptyList();
    return $this$updateState.x140(null, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null, VOID, VOID, VOID, null, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_availableCards, tmp1_availableBoxes);
  }
  function $handleIntentCOROUTINE$_15(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n149_1 = _this__u8e3s4;
    this.o149_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_15).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 16;
            var tmp0_subject = this.o149_1;
            if (tmp0_subject instanceof LoadProduct_2) {
              var tmp_0 = this;
              if (this.n149_1.s10h().ajg().u1().p11d_1)
                return Unit_instance;
              this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda(this.o149_1));
              var tmp1_elvis_lhs = this.o149_1.y140_1.nzt_1;
              observeFavorite_1(this.n149_1, tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs);
              var tmp2_elvis_lhs = this.o149_1.y140_1.nzt_1;
              observeStockReminder_1(this.n149_1, tmp2_elvis_lhs == null ? new Long(0, 0) : tmp2_elvis_lhs);
              var tmp_1 = get_viewModelScope(this.n149_1);
              tmp_0.p149_1 = launch(tmp_1, VOID, VOID, ProductDetailsViewModel$handleIntent$slambda_0(this.n149_1, this.o149_1, null));
              this.n9_1 = 17;
              continue $sm;
            } else {
              if (equals(tmp0_subject, ToggleFavorite_instance_1)) {
                var currentUser = this.n149_1.k146_1.ynu();
                if (currentUser == null) {
                  this.n9_1 = 15;
                  suspendResult = this.n149_1.d10l(NavigateToAuth_instance_3, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.n9_1 = 13;
                  continue $sm;
                }
              } else {
                if (equals(tmp0_subject, ToggleStockReminder_instance_1)) {
                  var currentUser_0 = this.n149_1.k146_1.ynu();
                  if (currentUser_0 == null) {
                    this.n9_1 = 12;
                    suspendResult = this.n149_1.d10l(NavigateToAuth_instance_3, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.n9_1 = 11;
                    continue $sm;
                  }
                } else {
                  if (tmp0_subject instanceof AddToCart_2) {
                    if (this.n149_1.s10h().ajg().u1().p11d_1)
                      return Unit_instance;
                    this.r149_1 = this.n149_1.s10h().ajg().u1();
                    var tmp_2 = this;
                    var tmp8_elvis_lhs = this.r149_1.n11d_1;
                    var tmp_3;
                    if (tmp8_elvis_lhs == null) {
                      return Unit_instance;
                    } else {
                      tmp_3 = tmp8_elvis_lhs;
                    }
                    tmp_2.s149_1 = tmp_3;
                    var tmp_4;
                    var tmp9_safe_receiver = this.r149_1.v11d_1;
                    if ((tmp9_safe_receiver == null ? null : tmp9_safe_receiver.pyz_1) === true) {
                      tmp_4 = isBlank(this.r149_1.x11d_1);
                    } else {
                      tmp_4 = false;
                    }
                    if (tmp_4) {
                      this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_0);
                      this.n9_1 = 10;
                      suspendResult = this.n149_1.d10l(new ShowMessage_5(new ResourceString(get_invalid_birthday_date(string_instance), [])), this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      this.n9_1 = 1;
                      continue $sm;
                    }
                  } else {
                    if (tmp0_subject instanceof QuantityChanged_1) {
                      var tmp_5 = this;
                      this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_3(this.o149_1));
                      tmp_5.p149_1 = Unit_instance;
                      this.n9_1 = 17;
                      continue $sm;
                    } else {
                      if (tmp0_subject instanceof KindChanged_1) {
                        var tmp_6 = this;
                        this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_4(this.o149_1));
                        tmp_6.p149_1 = Unit_instance;
                        this.n9_1 = 17;
                        continue $sm;
                      } else {
                        if (tmp0_subject instanceof TargetAudienceChanged_1) {
                          var tmp_7 = this;
                          this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_5(this.o149_1));
                          tmp_7.p149_1 = Unit_instance;
                          this.n9_1 = 17;
                          continue $sm;
                        } else {
                          if (tmp0_subject instanceof CardSelected_2) {
                            var tmp_8 = this;
                            this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_6(this.o149_1));
                            tmp_8.p149_1 = Unit_instance;
                            this.n9_1 = 17;
                            continue $sm;
                          } else {
                            if (tmp0_subject instanceof CardMessageChanged_2) {
                              var tmp_9 = this;
                              this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_7(this.o149_1));
                              tmp_9.p149_1 = Unit_instance;
                              this.n9_1 = 17;
                              continue $sm;
                            } else {
                              if (tmp0_subject instanceof CardBirthdayChanged_2) {
                                var tmp_10 = this;
                                this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_8(this.o149_1));
                                tmp_10.p149_1 = Unit_instance;
                                this.n9_1 = 17;
                                continue $sm;
                              } else {
                                if (tmp0_subject instanceof BoxSelected_2) {
                                  var tmp_11 = this;
                                  this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_9(this.o149_1));
                                  tmp_11.p149_1 = Unit_instance;
                                  this.n9_1 = 17;
                                  continue $sm;
                                } else {
                                  if (tmp0_subject instanceof BoxMessageChanged_2) {
                                    var tmp_12 = this;
                                    this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_10(this.o149_1));
                                    tmp_12.p149_1 = Unit_instance;
                                    this.n9_1 = 17;
                                    continue $sm;
                                  } else {
                                    if (tmp0_subject instanceof BoxBirthdayChanged_2) {
                                      var tmp_13 = this;
                                      this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_11(this.o149_1));
                                      tmp_13.p149_1 = Unit_instance;
                                      this.n9_1 = 17;
                                      continue $sm;
                                    } else {
                                      if (tmp0_subject instanceof SizeSelected_2) {
                                        var tmp_14 = this;
                                        this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_12(this.o149_1));
                                        tmp_14.p149_1 = Unit_instance;
                                        this.n9_1 = 17;
                                        continue $sm;
                                      } else {
                                        if (tmp0_subject instanceof ColorSelected_2) {
                                          var tmp_15 = this;
                                          this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_13(this.o149_1));
                                          tmp_15.p149_1 = Unit_instance;
                                          this.n9_1 = 17;
                                          continue $sm;
                                        } else {
                                          if (tmp0_subject instanceof OptionSelected_2) {
                                            var tmp_16 = this;
                                            this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_14(this.n149_1, this.o149_1));
                                            tmp_16.p149_1 = Unit_instance;
                                            this.n9_1 = 17;
                                            continue $sm;
                                          } else {
                                            if (tmp0_subject instanceof ProductCommentChanged_2) {
                                              var tmp_17 = this;
                                              this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_15(this.o149_1));
                                              tmp_17.p149_1 = Unit_instance;
                                              this.n9_1 = 17;
                                              continue $sm;
                                            } else {
                                              if (tmp0_subject instanceof BraceletNameChanged_0) {
                                                var tmp_18 = this;
                                                this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_16(this.o149_1));
                                                tmp_18.p149_1 = Unit_instance;
                                                this.n9_1 = 17;
                                                continue $sm;
                                              } else {
                                                if (equals(tmp0_subject, ShareProduct_instance_1)) {
                                                  var tmp_19 = this;
                                                  var state = this.n149_1.s10h().ajg().u1();
                                                  var tmp23_elvis_lhs = state.n11d_1;
                                                  var tmp_20;
                                                  if (tmp23_elvis_lhs == null) {
                                                    return Unit_instance;
                                                  } else {
                                                    tmp_20 = tmp23_elvis_lhs;
                                                  }
                                                  var product = tmp_20;
                                                  var language = state.s11d_1;
                                                  var name = language === 'en' ? product.ozt_1 : product.pzt_1;
                                                  var description = language === 'en' ? product.qzt_1 : product.rzt_1;
                                                  var url = 'https://hadaya-ea700.web.app/product/' + toString_0(product.nzt_1);
                                                  var tmp_21 = name == null ? '' : name;
                                                  shareProduct(tmp_21, description == null ? '' : description, url);
                                                  tmp_19.p149_1 = Unit_instance;
                                                  this.n9_1 = 17;
                                                  continue $sm;
                                                } else {
                                                  var tmp_22 = this;
                                                  noWhenBranchMatchedException();
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            break;
          case 1:
            var tmp_23;
            var tmp10_safe_receiver = this.r149_1.z11d_1;
            if ((tmp10_safe_receiver == null ? null : tmp10_safe_receiver.az0_1) === true) {
              tmp_23 = isBlank(this.r149_1.b11e_1);
            } else {
              tmp_23 = false;
            }

            if (tmp_23) {
              this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_1);
              this.n9_1 = 9;
              suspendResult = this.n149_1.d10l(new ShowMessage_5(new ResourceString(get_invalid_birthday_date(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            if (!(this.r149_1.v11d_1 == null) && ensureNotNull(this.r149_1.v11d_1).myz_1 <= 0) {
              this.n9_1 = 8;
              suspendResult = this.n149_1.d10l(new ShowMessage_5(new ResourceString(get_out_of_stock(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            if (!(this.r149_1.z11d_1 == null) && ensureNotNull(this.r149_1.z11d_1).xyz_1 <= 0) {
              this.n9_1 = 7;
              suspendResult = this.n149_1.d10l(new ShowMessage_5(new ResourceString(get_out_of_stock(string_instance), [])), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            this.q149_1 = this.n149_1.k146_1.ynu();
            if (this.q149_1 == null) {
              this.n9_1 = 6;
              suspendResult = this.n149_1.d10l(NavigateToAuth_instance_3, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 5:
            var tmp11_safe_receiver = this.r149_1.v11d_1;
            var tmp12_elvis_lhs = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.lyz_1;
            var tmp_24 = tmp12_elvis_lhs == null ? 0.0 : tmp12_elvis_lhs;
            var tmp13_safe_receiver = this.r149_1.z11d_1;
            var tmp14_elvis_lhs = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.wyz_1;
            var tmp_25 = tmp_24 + (tmp14_elvis_lhs == null ? 0.0 : tmp14_elvis_lhs);
            var sum = 0;
            var _iterator__ex2g4s = this.r149_1.f11e_1.y2().t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              var tmp_26 = sum;
              var tmp0_elvis_lhs = element.q100_1;
              sum = tmp_26 + (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
            }

            var extraOriginalPrice = tmp_25 + sum;
            var tmp15_safe_receiver = this.r149_1.v11d_1;
            var tmp16_elvis_lhs = tmp15_safe_receiver == null ? null : tmp15_safe_receiver.lyz_1;
            var tmp_27 = tmp16_elvis_lhs == null ? 0.0 : tmp16_elvis_lhs;
            var tmp17_safe_receiver = this.r149_1.z11d_1;
            var tmp18_elvis_lhs = tmp17_safe_receiver == null ? null : tmp17_safe_receiver.wyz_1;
            var tmp_28 = tmp_27 + (tmp18_elvis_lhs == null ? 0.0 : tmp18_elvis_lhs);
            var sum_0 = 0;
            var _iterator__ex2g4s_0 = this.r149_1.f11e_1.y2().t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              var tmp_29 = sum_0;
              var tmp_30;
              var tmp0_elvis_lhs_0 = element_0.r100_1;
              if ((tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0) > 0.0) {
                tmp_30 = ensureNotNull(element_0.r100_1);
              } else {
                var tmp1_elvis_lhs_0 = element_0.q100_1;
                tmp_30 = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
              }
              sum_0 = tmp_29 + tmp_30;
            }

            var extraDiscountedPrice = tmp_28 + sum_0;
            var tmp19_elvis_lhs = this.s149_1.szt_1;
            var finalPrice = (tmp19_elvis_lhs == null ? 0.0 : tmp19_elvis_lhs) + extraOriginalPrice;
            var tmp_31;
            var tmp20_elvis_lhs = this.s149_1.tzt_1;
            if ((tmp20_elvis_lhs == null ? 0.0 : tmp20_elvis_lhs) > 0.0) {
              tmp_31 = true;
            } else {
              var tmp0 = this.r149_1.f11e_1.y2();
              var tmp$ret$0;
              l$ret$1: do {
                var tmp_32;
                if (isInterface(tmp0, Collection)) {
                  tmp_32 = tmp0.r();
                } else {
                  tmp_32 = false;
                }
                if (tmp_32) {
                  tmp$ret$0 = false;
                  break l$ret$1;
                }
                var _iterator__ex2g4s_1 = tmp0.t();
                while (_iterator__ex2g4s_1.u()) {
                  var element_1 = _iterator__ex2g4s_1.v();
                  var tmp0_elvis_lhs_1 = element_1.r100_1;
                  if ((tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1) > 0.0) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                }
                tmp$ret$0 = false;
              }
               while (false);
              tmp_31 = tmp$ret$0;
            }

            var hasAnyDiscount = tmp_31;
            var tmp_33;
            if (hasAnyDiscount) {
              var tmp_34;
              var tmp21_elvis_lhs = this.s149_1.tzt_1;
              if ((tmp21_elvis_lhs == null ? 0.0 : tmp21_elvis_lhs) > 0.0) {
                tmp_34 = ensureNotNull(this.s149_1.tzt_1);
              } else {
                var tmp22_elvis_lhs = this.s149_1.szt_1;
                tmp_34 = tmp22_elvis_lhs == null ? 0.0 : tmp22_elvis_lhs;
              }
              tmp_33 = tmp_34 + extraDiscountedPrice;
            } else {
              tmp_33 = 0.0;
            }

            var finalDiscount = tmp_33;
            this.n149_1.x10k(ProductDetailsViewModel$handleIntent$lambda_2);
            var tmp_35 = this;
            var tmp_36 = get_viewModelScope(this.n149_1);
            tmp_35.p149_1 = launch(tmp_36, VOID, VOID, ProductDetailsViewModel$handleIntent$slambda_4(this.n149_1, this.s149_1, this.r149_1, this.q149_1, finalPrice, finalDiscount, null));
            this.n9_1 = 17;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            return Unit_instance;
          case 8:
            return Unit_instance;
          case 9:
            return Unit_instance;
          case 10:
            return Unit_instance;
          case 11:
            var tmp6_safe_receiver = this.n149_1.s10h().ajg().u1().n11d_1;
            var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.nzt_1;
            var tmp_37;
            if (tmp7_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_37 = tmp7_elvis_lhs;
            }

            var productId = tmp_37;
            var tmp_38 = this;
            var tmp_39 = get_viewModelScope(this.n149_1);
            tmp_38.p149_1 = launch(tmp_39, VOID, VOID, ProductDetailsViewModel$handleIntent$slambda_2(this.n149_1, productId, null));
            this.n9_1 = 17;
            continue $sm;
          case 12:
            return Unit_instance;
          case 13:
            var tmp3_safe_receiver = this.n149_1.s10h().ajg().u1().n11d_1;
            var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.nzt_1;
            var tmp_40;
            if (tmp4_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_40 = tmp4_elvis_lhs;
            }

            var productId_0 = tmp_40;
            this.n9_1 = 14;
            suspendResult = this.n149_1.m146_1.vz6(productId_0 == null ? new Long(0, 0) : productId_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 14:
            var tmp_41 = this;
            tmp_41.p149_1 = Unit_instance;
            this.n9_1 = 17;
            continue $sm;
          case 15:
            return Unit_instance;
          case 16:
            throw this.q9_1;
          case 17:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 16) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ProductDetailsViewModel(addToCartUseCase, getCurrentUserValueUseCase, getLanguageUseCase, favoriteRepository, toggleStockReminderUseCase, stockReminderRepository, productRepository) {
    BaseMviViewModel.call(this, new ProductDetailsState());
    this.j146_1 = addToCartUseCase;
    this.k146_1 = getCurrentUserValueUseCase;
    this.l146_1 = getLanguageUseCase;
    this.m146_1 = favoriteRepository;
    this.n146_1 = toggleStockReminderUseCase;
    this.o146_1 = stockReminderRepository;
    this.p146_1 = productRepository;
    observeLanguage_8(this);
  }
  protoOf(ProductDetailsViewModel).t149 = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_15(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProductDetailsViewModel).f10l = function (intent, $completion) {
    return this.t149(isInterface(intent, ProductDetailsIntent) ? intent : THROW_CCE(), $completion);
  };
  protoOf(ProductDetailsViewModel).d8r = function () {
    protoOf(BaseMviViewModel).d8r.call(this);
    this.x10k(ProductDetailsViewModel$onCleared$lambda);
  };
  function FullScreen3DDialog(show, loading, error, productKind, imageBitmap, imageBytes, language, onRetry, onDismiss, onOpenEditor, $composer, $changed, $default) {
    var imageBytes_0 = {_v: imageBytes};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(115166181);
    sourceInformation($composer_0, 'C(FullScreen3DDialog)P(9,4!1,8!3,7)53@2094L95,58@2318L2876,55@2195L2999:FullScreen3DDialog.kt#z3kkla');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.l31(show) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(loading) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ((($changed & 512) === 0 ? $composer_0.k31(error) : $composer_0.q31(error)) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.m31(productKind.a1_1) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ((($changed & 32768) === 0 ? $composer_0.k31(imageBitmap) : $composer_0.q31(imageBitmap)) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ((($changed & 262144) === 0 ? $composer_0.k31(imageBytes_0._v) : $composer_0.q31(imageBytes_0._v)) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.q31(onRetry) ? 8388608 : 4194304);
    if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismiss) ? 67108864 : 33554432);
    if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.q31(onOpenEditor) ? 536870912 : 268435456);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378), $dirty & 1)) {
      if (!(($default & 32) === 0)) {
        imageBytes_0._v = null;
      }
      if (isTraceInProgress()) {
        traceEventStart(115166181, $dirty, -1, 'client.fstech.hadaya.presentation.product_details.components.FullScreen3DDialog (FullScreen3DDialog.kt:50)');
      }
      if (!show) {
        if (isTraceInProgress()) {
          traceEventEnd();
        }
        var tmp1_safe_receiver = $composer_0.t30();
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.p3c(FullScreen3DDialog$lambda(show, loading, error, productKind, imageBitmap, imageBytes_0, language, onRetry, onDismiss, onOpenEditor, $changed, $default));
        }
        return Unit_instance;
      }
      sourceInformationMarkerStart($composer_0, -994438972, 'CC(remember):FullScreen3DDialog.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!((($dirty & 57344) === 16384 || (!(($dirty & 32768) === 0) && $composer_0.k31(imageBitmap))) | (($dirty & 458752) === 131072 || (!(($dirty & 262144) === 0) && $composer_0.k31(imageBytes_0._v))));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = mutableStateOf(!(imageBitmap == null) || !(imageBytes_0._v == null));
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var showDesign$delegate = tmp0_group;
      var tmp_0 = DialogProperties_init_$Create$(VOID, VOID, false);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-747200530, true, FullScreen3DDialog$lambda_2(loading, error, productKind, imageBitmap, imageBytes_0, onRetry, show, onDismiss, onOpenEditor, showDesign$delegate, language), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_1.i31();
      var tmp_1;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp$ret$4 = tmp_1;
      Dialog(onDismiss, tmp_0, tmp$ret$4, $composer_0, 432 | 14 & $dirty >> 24, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver = $composer_0.t30();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.p3c(FullScreen3DDialog$lambda_3(show, loading, error, productKind, imageBitmap, imageBytes_0, language, onRetry, onDismiss, onOpenEditor, $changed, $default));
    }
  }
  function ComposableSingletons$FullScreen3DDialogKt$lambda$1413777431$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C83@3319L182:FullScreen3DDialog.kt#z3kkla');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1413777431, $changed, -1, 'client.fstech.hadaya.presentation.product_details.components.ComposableSingletons$FullScreen3DDialogKt.lambda$1413777431.<anonymous> (FullScreen3DDialog.kt:83)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      Icon(tmp, null, null, Companion_getInstance_14().i6b_1, $composer_0, 3120, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$FullScreen3DDialogKt() {
    ComposableSingletons$FullScreen3DDialogKt_instance = this;
    var tmp = this;
    tmp.u149_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1413777431, false, ComposableSingletons$FullScreen3DDialogKt$lambda$1413777431$lambda));
  }
  var ComposableSingletons$FullScreen3DDialogKt_instance;
  function ComposableSingletons$FullScreen3DDialogKt_getInstance() {
    if (ComposableSingletons$FullScreen3DDialogKt_instance == null)
      new ComposableSingletons$FullScreen3DDialogKt();
    return ComposableSingletons$FullScreen3DDialogKt_instance;
  }
  function FullScreen3DDialog$lambda($show, $loading, $error, $productKind, $imageBitmap, $imageBytes, $language, $onRetry, $onDismiss, $onOpenEditor, $$changed, $$default) {
    return function ($composer, $force) {
      FullScreen3DDialog($show, $loading, $error, $productKind, $imageBitmap, $imageBytes._v, $language, $onRetry, $onDismiss, $onOpenEditor, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function FullScreen3DDialog$lambda_0($showDesign$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDesign', KMutableProperty0, true);
    return $showDesign$delegate.u1();
  }
  function FullScreen3DDialog$lambda_1($showDesign$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDesign', KMutableProperty0, true);
    $showDesign$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function FullScreen3DDialog$lambda$lambda$lambda($showDesign$delegate) {
    return function () {
      FullScreen3DDialog$lambda_1($showDesign$delegate, !FullScreen3DDialog$lambda_0($showDesign$delegate));
      return Unit_instance;
    };
  }
  function FullScreen3DDialog$lambda$lambda$lambda_0($language, $showDesign$delegate) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C111@4580L216:FullScreen3DDialog.kt#z3kkla');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-118452111, $changed, -1, 'client.fstech.hadaya.presentation.product_details.components.FullScreen3DDialog.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (FullScreen3DDialog.kt:111)');
        }
        var tmp_0 = FullScreen3DDialog$lambda_0($showDesign$delegate) ? $language === 'en' ? 'Original' : '\u0627\u0644\u0623\u0635\u0644\u064A' : $language === 'en' ? 'Final' : '\u0627\u0644\u0646\u0647\u0627\u0626\u064A';
        var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FullScreen3DDialog$lambda$lambda($loading, $error, $productKind, $imageBitmap, $imageBytes, $onRetry, $show, $onDismiss, $onOpenEditor, $showDesign$delegate, $language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C63@2465L2713:FullScreen3DDialog.kt#z3kkla');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(381625203, $changed, -1, 'client.fstech.hadaya.presentation.product_details.components.FullScreen3DDialog.<anonymous>.<anonymous> (FullScreen3DDialog.kt:63)');
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = fillMaxSize(Companion_instance);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -1599693672, 'C64@2522L433,76@3014L505,91@3572L1592:FullScreen3DDialog.kt#z3kkla');
        var tmp_1 = FullScreen3DDialog$lambda_0($showDesign$delegate) ? $imageBitmap : null;
        var tmp_2 = FullScreen3DDialog$lambda_0($showDesign$delegate) ? $imageBytes._v : null;
        var tmp_3 = fillMaxSize(Companion_instance);
        Model3DViewerSection($loading, $error, $productKind, tmp_1, tmp_2, $onRetry, tmp_3, $show, 0.0, 0.0, $composer_5, 1572864, 768);
        var tmp_4 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$6 = _Dp___init__impl__ms3zkb(16);
        var tmp_5 = background(BoxScopeInstance_instance.udr(padding_0(tmp_4, tmp$ret$6), Companion_getInstance_11().k8t_1), Color__copy$default_impl_ectz3s(Companion_getInstance_14().m6b_1, 0.7), get_CircleShape());
        IconButton($onDismiss, tmp_5, false, null, null, null, ComposableSingletons$FullScreen3DDialogKt_getInstance().u149_1, $composer_5, 1572864, 60);
        var tmp_6 = fillMaxWidth(BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1));
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
        var tmp0_0 = padding_0(tmp_6, tmp$ret$7);
        var tmp_7 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_1 = tmp0_0;
        var horizontalArrangement = tmp_7.mdq(tmp$ret$8);
        var verticalAlignment = null;
        var $composer_6 = $composer_5;
        if (!((4 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((4 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((4 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_6, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_8 = $composer_8.g30();
        if (!isInterface(tmp_8, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_1);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 800417637, 'C:FullScreen3DDialog.kt#z3kkla');
        if ($imageBitmap == null) {
          $composer_10.m30(800409142);
          sourceInformation($composer_10, '99@3916L159');
          var tmp_9 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
          var tmp_10 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          CustomizeActionButton($onOpenEditor, tmp_9, null, tmp_10, tmp_11, null, $composer_10, 0, 60);
          $composer_10.n30();
        } else {
          $composer_10.m30(800646354);
          sourceInformation($composer_10, '106@4227L28,110@4550L272,105@4181L641,118@4887L237');
          var tmp_12 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$15 = _Dp___init__impl__ms3zkb(56);
          var tmp0_modifier = height(tmp_12, tmp$ret$15);
          var tmp_13;
          if (!FullScreen3DDialog$lambda_0($showDesign$delegate)) {
            $composer_10.m30(-1775279541);
            sourceInformation($composer_10, '108@4400L14');
            var tmp0_group = ButtonDefaults_getInstance().ho6($composer_10, 6);
            $composer_10.n30();
            tmp_13 = tmp0_group;
          } else {
            $composer_10.m30(-1775278410);
            sourceInformation($composer_10, '108@4435L25');
            var tmp1_group = ButtonDefaults_getInstance().noa($composer_10, 6);
            $composer_10.n30();
            tmp_13 = tmp1_group;
          }
          var tmp1_colors = tmp_13;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$16 = _Dp___init__impl__ms3zkb(16);
          var tmp2_shape = RoundedCornerShape(tmp$ret$16);
          sourceInformationMarkerStart($composer_10, -1775285063, 'CC(remember):FullScreen3DDialog.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_10.k31($showDesign$delegate);
          // Inline function 'kotlin.let' call
          var it = $composer_10.i31();
          var tmp_14;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = FullScreen3DDialog$lambda$lambda$lambda($showDesign$delegate);
            $composer_10.j31(value);
            tmp_14 = value;
          } else {
            tmp_14 = it;
          }
          var tmp2_group = tmp_14;
          sourceInformationMarkerEnd($composer_10);
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-118452111, true, FullScreen3DDialog$lambda$lambda$lambda_0($language, $showDesign$delegate), $composer_10, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_11 = $composer_10;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = $composer_11.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_0 = $composer_11.i31();
          var tmp_15;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver);
            $composer_11.j31(value_0);
            tmp_15 = value_0;
          } else {
            tmp_15 = it_0;
          }
          var tmp$ret$21 = tmp_15;
          Button(tmp2_group, tmp0_modifier, false, tmp2_shape, tmp1_colors, null, null, null, null, tmp$ret$21, $composer_10, 805306368, 484);
          var tmp_16 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
          var tmp_17 = $language === 'en' ? 'Edit' : '\u062A\u0639\u062F\u064A\u0644';
          var tmp_18 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_19 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          CustomizeActionButton($onOpenEditor, tmp_16, tmp_17, tmp_18, tmp_19, null, $composer_10, 0, 56);
          $composer_10.n30();
        }
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_20;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_20 = Unit_instance;
        }
        tmp = tmp_20;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FullScreen3DDialog$lambda_2($loading, $error, $productKind, $imageBitmap, $imageBytes, $onRetry, $show, $onDismiss, $onOpenEditor, $showDesign$delegate, $language) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C61@2418L11,62@2451L2737,59@2328L2860:FullScreen3DDialog.kt#z3kkla');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-747200530, $changed, -1, 'client.fstech.hadaya.presentation.product_details.components.FullScreen3DDialog.<anonymous> (FullScreen3DDialog.kt:59)');
        }
        var tmp_0 = fillMaxSize(Companion_instance);
        var tmp_1 = MaterialTheme_instance.unz($composer_0, 6).ko0_1;
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_4 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(381625203, true, FullScreen3DDialog$lambda$lambda($loading, $error, $productKind, $imageBitmap, $imageBytes, $onRetry, $show, $onDismiss, $onOpenEditor, $showDesign$delegate, $language), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_5;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value);
          tmp_5 = value;
        } else {
          tmp_5 = it;
        }
        var tmp$ret$0 = tmp_5;
        Surface(tmp_0, null, tmp_1, tmp_2, tmp_3, tmp_4, null, tmp$ret$0, $composer_0, 12582918, 122);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FullScreen3DDialog$lambda_3($show, $loading, $error, $productKind, $imageBitmap, $imageBytes, $language, $onRetry, $onDismiss, $onOpenEditor, $$changed, $$default) {
    return function ($composer, $force) {
      FullScreen3DDialog($show, $loading, $error, $productKind, $imageBitmap, $imageBytes._v, $language, $onRetry, $onDismiss, $onOpenEditor, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_profile_ProfileState$stable;
  var client_fstech_hadaya_presentation_profile_ProfileIntent_LogoutClicked$stable;
  var client_fstech_hadaya_presentation_profile_ProfileIntent_DeleteAccountClicked$stable;
  var client_fstech_hadaya_presentation_profile_ProfileSideEffect_NavigateToAuth$stable;
  var client_fstech_hadaya_presentation_profile_ProfileSideEffect_ShowError$stable;
  function ProfileScreen(onBack, onLogout, onNavigateToFriends, onNavigateToOrderHistory, onNavigateToFavorites, onNavigateToCoupons, onNavigateToStockReminders, onNavigateToAccountManagement, $composer, $changed, $default) {
    var onNavigateToAccountManagement_0 = {_v: onNavigateToAccountManagement};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1834144525);
    sourceInformation($composer_0, 'C(ProfileScreen)P(!2,5,6,4,3,7)111@5350L2,113@5399L12,114@5462L16,116@5567L16,117@5600L24,118@5653L32,119@5714L42,120@5791L34,121@5856L42,122@5934L34,123@5999L42,124@6065L31,125@6124L31,126@6178L31,127@6236L31,128@6298L31,129@6360L42,130@6434L34,131@6497L42,132@6569L42,135@6652L34,136@6712L31,137@6768L31,138@6821L31,139@6877L31,140@6935L31,141@6989L31,142@7050L31,143@7102L31,144@7157L31,145@7218L31,146@7275L31,147@7331L42,148@7399L42,149@7462L34,150@7523L34,151@7584L25,153@7650L723,153@7615L758,171@8431L145,171@8400L176,178@8628L228,178@8600L256,187@8886L45,188@8966L50,189@9050L49,190@9132L48,191@9213L48,192@9293L47,193@9368L43,194@9448L52,195@9530L41,197@9577L35861:ProfileScreen.kt#2kgzgj');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onLogout) ? 32 : 16);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToOrderHistory) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToFavorites) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToCoupons) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToStockReminders) ? 1048576 : 524288);
    if (!(($default & 128) === 0))
      $dirty = $dirty | 12582912;
    else if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToAccountManagement_0._v) ? 8388608 : 4194304);
    if ($composer_0.r31(!(($dirty & 4793363) === 4793362), $dirty & 1)) {
      if (!(($default & 128) === 0)) {
        sourceInformationMarkerStart($composer_0, -1676287051, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_0 = $composer_0;
        // Inline function 'kotlin.let' call
        var it = this_0.i31();
        var tmp;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda;
          this_0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var tmp0_group = tmp;
        sourceInformationMarkerEnd($composer_0);
        onNavigateToAccountManagement_0._v = tmp0_group;
      }
      if (isTraceInProgress()) {
        traceEventStart(-1834144525, $dirty, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen (ProfileScreen.kt:112)');
      }
      // Inline function 'org.koin.compose.koinInject' call
      var qualifier = null;
      var scope = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -1168520582, 'CC(koinInject)88@2750L18,90@2787L73:Inject.kt#8jjlyv');
      if (!((3 & 1) === 0))
        qualifier = null;
      if (!((3 & 2) === 0))
        scope = currentKoinScope($composer_1, 0);
      sourceInformationMarkerStart($composer_1, -1961811197, 'CC(remember):Inject.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_1.k31(qualifier) | $composer_1.k31(scope));
      // Inline function 'kotlin.let' call
      var it_0 = $composer_1.i31();
      var tmp_0;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = scope.ts6(getKClass(IAuthRepository), qualifier);
        $composer_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_1);
      sourceInformationMarkerEnd($composer_1);
      var authRepository = tmp1_group;
      var tmp_1 = authRepository.oyv();
      var profileState = collectAsState(tmp_1, null, $composer_0, 0, 1);
      var profile = profileState.u1();
      var tmp_2 = authRepository.n8m();
      var currentLanguage$delegate = collectAsState(tmp_2, null, $composer_0, 0, 1);
      // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
      var getContext = null;
      var $composer_2 = $composer_0;
      if (!((1 & 1) === 0)) {
        getContext = ProfileScreen$lambda_1;
      }
      var composer = $composer_2;
      // Inline function 'androidx.compose.runtime.cache' call
      // Inline function 'kotlin.let' call
      var it_1 = $composer_2.i31();
      var tmp_3;
      if (false || it_1 === Companion_getInstance().f30_1) {
        var value_1 = createCompositionCoroutineScope(getContext(), composer);
        $composer_2.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var scope_0 = tmp_3;
      sourceInformationMarkerStart($composer_0, -1676277325, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_2 = this_1.i31();
      var tmp_4;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var value_2 = new SnackbarHostState();
        this_1.j31(value_2);
        tmp_4 = value_2;
      } else {
        tmp_4 = it_2;
      }
      var tmp1_group_0 = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp1_group_0;
      sourceInformationMarkerStart($composer_0, -1676275363, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_3 = this_2.i31();
      var tmp_5;
      if (false || it_3 === Companion_getInstance().f30_1) {
        var value_3 = mutableStateOf(false);
        this_2.j31(value_3);
        tmp_5 = value_3;
      } else {
        tmp_5 = it_3;
      }
      var tmp2_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      var showDeleteDialog$delegate = tmp2_group;
      sourceInformationMarkerStart($composer_0, -1676272907, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_4 = this_3.i31();
      var tmp_6;
      if (false || it_4 === Companion_getInstance().f30_1) {
        var value_4 = mutableStateOf(false);
        this_3.j31(value_4);
        tmp_6 = value_4;
      } else {
        tmp_6 = it_4;
      }
      var tmp3_group = tmp_6;
      sourceInformationMarkerEnd($composer_0);
      var showDeleteAvatarDialog$delegate = tmp3_group;
      sourceInformationMarkerStart($composer_0, -1676270819, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_4 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_5 = this_4.i31();
      var tmp_7;
      if (false || it_5 === Companion_getInstance().f30_1) {
        var value_5 = mutableStateOf(false);
        this_4.j31(value_5);
        tmp_7 = value_5;
      } else {
        tmp_7 = it_5;
      }
      var tmp4_group = tmp_7;
      sourceInformationMarkerEnd($composer_0);
      var showPasswordDialog$delegate = tmp4_group;
      sourceInformationMarkerStart($composer_0, -1676268331, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_5 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_6 = this_5.i31();
      var tmp_8;
      if (false || it_6 === Companion_getInstance().f30_1) {
        var value_6 = mutableStateOf(false);
        this_5.j31(value_6);
        tmp_8 = value_6;
      } else {
        tmp_8 = it_6;
      }
      var tmp5_group = tmp_8;
      sourceInformationMarkerEnd($composer_0);
      var showResetPasswordDialog$delegate = tmp5_group;
      sourceInformationMarkerStart($composer_0, -1676266243, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_6 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_7 = this_6.i31();
      var tmp_9;
      if (false || it_7 === Companion_getInstance().f30_1) {
        var value_7 = mutableStateOf(false);
        this_6.j31(value_7);
        tmp_9 = value_7;
      } else {
        tmp_9 = it_7;
      }
      var tmp6_group = tmp_9;
      sourceInformationMarkerEnd($composer_0);
      var showLanguageDialog$delegate = tmp6_group;
      sourceInformationMarkerStart($composer_0, -1676264142, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_7 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_8 = this_7.i31();
      var tmp_10;
      if (false || it_8 === Companion_getInstance().f30_1) {
        var value_8 = mutableStateOf('');
        this_7.j31(value_8);
        tmp_10 = value_8;
      } else {
        tmp_10 = it_8;
      }
      var tmp7_group = tmp_10;
      sourceInformationMarkerEnd($composer_0);
      var newPassword$delegate = tmp7_group;
      sourceInformationMarkerStart($composer_0, -1676262254, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_8 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_9 = this_8.i31();
      var tmp_11;
      if (false || it_9 === Companion_getInstance().f30_1) {
        var value_9 = mutableStateOf('');
        this_8.j31(value_9);
        tmp_11 = value_9;
      } else {
        tmp_11 = it_9;
      }
      var tmp8_group = tmp_11;
      sourceInformationMarkerEnd($composer_0);
      var confirmPassword$delegate = tmp8_group;
      sourceInformationMarkerStart($composer_0, -1676260526, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_9 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_10 = this_9.i31();
      var tmp_12;
      if (false || it_10 === Companion_getInstance().f30_1) {
        var value_10 = mutableStateOf('');
        this_9.j31(value_10);
        tmp_12 = value_10;
      } else {
        tmp_12 = it_10;
      }
      var tmp9_group = tmp_12;
      sourceInformationMarkerEnd($composer_0);
      var resetEmail$delegate = tmp9_group;
      sourceInformationMarkerStart($composer_0, -1676258670, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_10 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_11 = this_10.i31();
      var tmp_13;
      if (false || it_11 === Companion_getInstance().f30_1) {
        var value_11 = mutableStateOf('');
        this_10.j31(value_11);
        tmp_13 = value_11;
      } else {
        tmp_13 = it_11;
      }
      var tmp10_group = tmp_13;
      sourceInformationMarkerEnd($composer_0);
      var deletePassword$delegate = tmp10_group;
      sourceInformationMarkerStart($composer_0, -1676256686, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_11 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_12 = this_11.i31();
      var tmp_14;
      if (false || it_12 === Companion_getInstance().f30_1) {
        var value_12 = mutableStateOf('');
        this_11.j31(value_12);
        tmp_14 = value_12;
      } else {
        tmp_14 = it_12;
      }
      var tmp11_group = tmp_14;
      sourceInformationMarkerEnd($composer_0);
      var deleteEmailConfirm$delegate = tmp11_group;
      sourceInformationMarkerStart($composer_0, -1676254691, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_12 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_13 = this_12.i31();
      var tmp_15;
      if (false || it_13 === Companion_getInstance().f30_1) {
        var value_13 = mutableStateOf(false);
        this_12.j31(value_13);
        tmp_15 = value_13;
      } else {
        tmp_15 = it_13;
      }
      var tmp12_group = tmp_15;
      sourceInformationMarkerEnd($composer_0);
      var isUpdatingPassword$delegate = tmp12_group;
      sourceInformationMarkerStart($composer_0, -1676252331, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_13 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_14 = this_13.i31();
      var tmp_16;
      if (false || it_14 === Companion_getInstance().f30_1) {
        var value_14 = mutableStateOf(false);
        this_13.j31(value_14);
        tmp_16 = value_14;
      } else {
        tmp_16 = it_14;
      }
      var tmp13_group = tmp_16;
      sourceInformationMarkerEnd($composer_0);
      var isResettingPassword$delegate = tmp13_group;
      sourceInformationMarkerStart($composer_0, -1676250307, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_14 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_15 = this_14.i31();
      var tmp_17;
      if (false || it_15 === Companion_getInstance().f30_1) {
        var value_15 = mutableStateOf(false);
        this_14.j31(value_15);
        tmp_17 = value_15;
      } else {
        tmp_17 = it_15;
      }
      var tmp14_group = tmp_17;
      sourceInformationMarkerEnd($composer_0);
      var isUpdatingAvatar$delegate = tmp14_group;
      sourceInformationMarkerStart($composer_0, -1676248003, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_15 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_16 = this_15.i31();
      var tmp_18;
      if (false || it_16 === Companion_getInstance().f30_1) {
        var value_16 = mutableStateOf(false);
        this_15.j31(value_16);
        tmp_18 = value_16;
      } else {
        tmp_18 = it_16;
      }
      var tmp15_group = tmp_18;
      sourceInformationMarkerEnd($composer_0);
      var isDeletingAccount$delegate = tmp15_group;
      sourceInformationMarkerStart($composer_0, -1676245355, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_16 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_17 = this_16.i31();
      var tmp_19;
      if (false || it_17 === Companion_getInstance().f30_1) {
        var value_17 = mutableStateOf(false);
        this_16.j31(value_17);
        tmp_19 = value_17;
      } else {
        tmp_19 = it_17;
      }
      var tmp16_group = tmp_19;
      sourceInformationMarkerEnd($composer_0);
      var isEditing$delegate = tmp16_group;
      sourceInformationMarkerStart($composer_0, -1676243438, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_17 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_18 = this_17.i31();
      var tmp_20;
      if (false || it_18 === Companion_getInstance().f30_1) {
        var value_18 = mutableStateOf('');
        this_17.j31(value_18);
        tmp_20 = value_18;
      } else {
        tmp_20 = it_18;
      }
      var tmp17_group = tmp_20;
      sourceInformationMarkerEnd($composer_0);
      var editFirstName$delegate = tmp17_group;
      sourceInformationMarkerStart($composer_0, -1676241646, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_18 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_19 = this_18.i31();
      var tmp_21;
      if (false || it_19 === Companion_getInstance().f30_1) {
        var value_19 = mutableStateOf('');
        this_18.j31(value_19);
        tmp_21 = value_19;
      } else {
        tmp_21 = it_19;
      }
      var tmp18_group = tmp_21;
      sourceInformationMarkerEnd($composer_0);
      var editLastName$delegate = tmp18_group;
      sourceInformationMarkerStart($composer_0, -1676239950, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_19 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_20 = this_19.i31();
      var tmp_22;
      if (false || it_20 === Companion_getInstance().f30_1) {
        var value_20 = mutableStateOf('');
        this_19.j31(value_20);
        tmp_22 = value_20;
      } else {
        tmp_22 = it_20;
      }
      var tmp19_group = tmp_22;
      sourceInformationMarkerEnd($composer_0);
      var editEmail$delegate = tmp19_group;
      sourceInformationMarkerStart($composer_0, -1676238158, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_20 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_21 = this_20.i31();
      var tmp_23;
      if (false || it_21 === Companion_getInstance().f30_1) {
        var value_21 = mutableStateOf('');
        this_20.j31(value_21);
        tmp_23 = value_21;
      } else {
        tmp_23 = it_21;
      }
      var tmp20_group = tmp_23;
      sourceInformationMarkerEnd($composer_0);
      var editBirthday$delegate = tmp20_group;
      sourceInformationMarkerStart($composer_0, -1676236302, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_21 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_22 = this_21.i31();
      var tmp_24;
      if (false || it_22 === Companion_getInstance().f30_1) {
        var value_22 = mutableStateOf('');
        this_21.j31(value_22);
        tmp_24 = value_22;
      } else {
        tmp_24 = it_22;
      }
      var tmp21_group = tmp_24;
      sourceInformationMarkerEnd($composer_0);
      var editBuildingNo$delegate = tmp21_group;
      sourceInformationMarkerStart($composer_0, -1676234574, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_22 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_23 = this_22.i31();
      var tmp_25;
      if (false || it_23 === Companion_getInstance().f30_1) {
        var value_23 = mutableStateOf('');
        this_22.j31(value_23);
        tmp_25 = value_23;
      } else {
        tmp_25 = it_23;
      }
      var tmp22_group = tmp_25;
      sourceInformationMarkerEnd($composer_0);
      var editStreet$delegate = tmp22_group;
      sourceInformationMarkerStart($composer_0, -1676232622, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_23 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_24 = this_23.i31();
      var tmp_26;
      if (false || it_24 === Companion_getInstance().f30_1) {
        var value_24 = mutableStateOf('');
        this_23.j31(value_24);
        tmp_26 = value_24;
      } else {
        tmp_26 = it_24;
      }
      var tmp23_group = tmp_26;
      sourceInformationMarkerEnd($composer_0);
      var editNeighbourhood$delegate = tmp23_group;
      sourceInformationMarkerStart($composer_0, -1676230958, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_24 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_25 = this_24.i31();
      var tmp_27;
      if (false || it_25 === Companion_getInstance().f30_1) {
        var value_25 = mutableStateOf('');
        this_24.j31(value_25);
        tmp_27 = value_25;
      } else {
        tmp_27 = it_25;
      }
      var tmp24_group = tmp_27;
      sourceInformationMarkerEnd($composer_0);
      var editCity$delegate = tmp24_group;
      sourceInformationMarkerStart($composer_0, -1676229198, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_25 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_26 = this_25.i31();
      var tmp_28;
      if (false || it_26 === Companion_getInstance().f30_1) {
        var value_26 = mutableStateOf('');
        this_25.j31(value_26);
        tmp_28 = value_26;
      } else {
        tmp_28 = it_26;
      }
      var tmp25_group = tmp_28;
      sourceInformationMarkerEnd($composer_0);
      var editCountry$delegate = tmp25_group;
      sourceInformationMarkerStart($composer_0, -1676227246, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_26 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_27 = this_26.i31();
      var tmp_29;
      if (false || it_27 === Companion_getInstance().f30_1) {
        var value_27 = mutableStateOf('');
        this_26.j31(value_27);
        tmp_29 = value_27;
      } else {
        tmp_29 = it_27;
      }
      var tmp26_group = tmp_29;
      sourceInformationMarkerEnd($composer_0);
      var editPersonalPhone$delegate = tmp26_group;
      sourceInformationMarkerStart($composer_0, -1676225422, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_27 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_28 = this_27.i31();
      var tmp_30;
      if (false || it_28 === Companion_getInstance().f30_1) {
        var value_28 = mutableStateOf('');
        this_27.j31(value_28);
        tmp_30 = value_28;
      } else {
        tmp_30 = it_28;
      }
      var tmp27_group = tmp_30;
      sourceInformationMarkerEnd($composer_0);
      var editWorkPhone$delegate = tmp27_group;
      sourceInformationMarkerStart($composer_0, -1676223619, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_28 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_29 = this_28.i31();
      var tmp_31;
      if (false || it_29 === Companion_getInstance().f30_1) {
        var value_29 = mutableStateOf(null);
        this_28.j31(value_29);
        tmp_31 = value_29;
      } else {
        tmp_31 = it_29;
      }
      var tmp28_group = tmp_31;
      sourceInformationMarkerEnd($composer_0);
      var editLatitude$delegate = tmp28_group;
      sourceInformationMarkerStart($composer_0, -1676221443, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_29 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_30 = this_29.i31();
      var tmp_32;
      if (false || it_30 === Companion_getInstance().f30_1) {
        var value_30 = mutableStateOf(null);
        this_29.j31(value_30);
        tmp_32 = value_30;
      } else {
        tmp_32 = it_30;
      }
      var tmp29_group = tmp_32;
      sourceInformationMarkerEnd($composer_0);
      var editLongitude$delegate = tmp29_group;
      sourceInformationMarkerStart($composer_0, -1676219435, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_30 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_31 = this_30.i31();
      var tmp_33;
      if (false || it_31 === Companion_getInstance().f30_1) {
        var value_31 = mutableStateOf(false);
        this_30.j31(value_31);
        tmp_33 = value_31;
      } else {
        tmp_33 = it_31;
      }
      var tmp30_group = tmp_33;
      sourceInformationMarkerEnd($composer_0);
      var isSaving$delegate = tmp30_group;
      sourceInformationMarkerStart($composer_0, -1676217483, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_31 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_32 = this_31.i31();
      var tmp_34;
      if (false || it_32 === Companion_getInstance().f30_1) {
        var value_32 = mutableStateOf(false);
        this_31.j31(value_32);
        tmp_34 = value_32;
      } else {
        tmp_34 = it_32;
      }
      var tmp31_group = tmp_34;
      sourceInformationMarkerEnd($composer_0);
      var showDatePicker$delegate = tmp31_group;
      var tmp_35 = _DisplayMode___init__impl__gfd230(0);
      var datePickerState = rememberDatePickerState(null, null, null, tmp_35, null, $composer_0, 0, 31);
      var tmp_36 = ProfileScreen$lambda_30(isEditing$delegate);
      sourceInformationMarkerStart($composer_0, -1676212730, 'CC(remember):ProfileScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_0.k31(profile);
      // Inline function 'kotlin.let' call
      var it_33 = tmp0.i31();
      var tmp_37;
      if (invalid_0 || it_33 === Companion_getInstance().f30_1) {
        var value_33 = ProfileScreen$slambda_0(profile, isEditing$delegate, editFirstName$delegate, editLastName$delegate, editEmail$delegate, editBirthday$delegate, editBuildingNo$delegate, editStreet$delegate, editNeighbourhood$delegate, editCity$delegate, editCountry$delegate, editPersonalPhone$delegate, editWorkPhone$delegate, editLatitude$delegate, editLongitude$delegate, null);
        tmp0.j31(value_33);
        tmp_37 = value_33;
      } else {
        tmp_37 = it_33;
      }
      var tmp32_group = tmp_37;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect(profile, tmp_36, tmp32_group, $composer_0, 0);
      sourceInformationMarkerStart($composer_0, -1676188316, 'CC(remember):ProfileScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_32 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_34 = this_32.i31();
      var tmp_38;
      if (false || it_34 === Companion_getInstance().f30_1) {
        var value_34 = ProfileScreen$lambda_62(editLatitude$delegate, editLongitude$delegate);
        this_32.j31(value_34);
        tmp_38 = value_34;
      } else {
        tmp_38 = it_34;
      }
      var tmp33_group = tmp_38;
      sourceInformationMarkerEnd($composer_0);
      var locationPicker = rememberLocationPickerLauncher(tmp33_group, $composer_0, 6);
      sourceInformationMarkerStart($composer_0, -1676181929, 'CC(remember):ProfileScreen.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!($composer_0.q31(scope_0) | $composer_0.q31(authRepository));
      // Inline function 'kotlin.let' call
      var it_35 = tmp0_0.i31();
      var tmp_39;
      if (invalid_1 || it_35 === Companion_getInstance().f30_1) {
        var value_35 = ProfileScreen$lambda_63(scope_0, authRepository, isUpdatingAvatar$delegate);
        tmp0_0.j31(value_35);
        tmp_39 = value_35;
      } else {
        tmp_39 = it_35;
      }
      var tmp34_group = tmp_39;
      sourceInformationMarkerEnd($composer_0);
      var imagePicker = rememberImagePickerLauncher_0(tmp34_group, $composer_0, 0);
      var invalid_phone_work = stringResource(get_invalid_phone_work(string_instance), $composer_0, 0);
      var invalid_birthday_format = stringResource(get_invalid_birthday_format(string_instance), $composer_0, 0);
      var invalid_phone_personal = stringResource(get_invalid_phone_personal(string_instance), $composer_0, 0);
      var delete_account_failed = stringResource(get_delete_account_failed(string_instance), $composer_0, 0);
      var password_length_error = stringResource(get_password_length_error(string_instance), $composer_0, 0);
      var passwords_dont_match = stringResource(get_passwords_dont_match(string_instance), $composer_0, 0);
      var password_updated = stringResource(get_password_updated(string_instance), $composer_0, 0);
      var failed_to_update_password = stringResource(get_failed_to_update_password(string_instance), $composer_0, 0);
      var verified_phone_msg = stringResource(get_verified_phone(string_instance), $composer_0, 0);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier = fillMaxSize(Companion_instance);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_3 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_4 = $composer_3;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_4, 0).hashCode();
      var localMap = $composer_4.t31();
      var materialized = materialize($composer_4, modifier_0);
      var tmp0_1 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_5 = $composer_4;
      var tmp_40 = $composer_5.g30();
      if (!isInterface(tmp_40, Applier)) {
        invalidApplier();
      }
      $composer_5.b31();
      if ($composer_5.h30()) {
        $composer_5.c31(tmp0_1);
      } else {
        $composer_5.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_5);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_6 = $composer_5;
      var $composer_7 = $composer_6;
      sourceInformationMarkerStart($composer_7, -1357680936, 'C198@9626L35681,824@45316L116:ProfileScreen.kt#2kgzgj');
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = fillMaxSize(Companion_instance);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_8 = $composer_7;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_8, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_9 = $composer_8;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_9, 0).hashCode();
      var localMap_0 = $composer_9.t31();
      var materialized_0 = materialize($composer_9, modifier_2);
      var tmp0_2 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_10 = $composer_9;
      var tmp_41 = $composer_10.g30();
      if (!isInterface(tmp_41, Applier)) {
        invalidApplier();
      }
      $composer_10.b31();
      if ($composer_10.h30()) {
        $composer_10.c31(tmp0_2);
      } else {
        $composer_10.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_10);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_11 = $composer_10;
      var $composer_12 = $composer_11;
      sourceInformationMarkerStart($composer_12, -150009043, 'C201@9815L294,209@10137L5299,199@9682L5825:ProfileScreen.kt#2kgzgj');
      var tmp_42 = ComposableSingletons$ProfileScreenKt_getInstance().v149_1;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1838595088, true, ProfileScreen$lambda_64(onBack), $composer_12, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_13 = $composer_12;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = $composer_13.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_36 = $composer_13.i31();
      var tmp_43;
      if (invalid_2 || it_36 === Companion_getInstance().f30_1) {
        var value_36 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_13.j31(value_36);
        tmp_43 = value_36;
      } else {
        tmp_43 = it_36;
      }
      var tmp_44 = tmp_43;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_0 = rememberComposableLambda(1058708071, true, ProfileScreen$lambda_65(profile, scope_0, invalid_birthday_format, invalid_phone_personal, invalid_phone_work, authRepository, isEditing$delegate, editBirthday$delegate, snackbarHostState, editPersonalPhone$delegate, editWorkPhone$delegate, isSaving$delegate, editFirstName$delegate, editLastName$delegate, editBuildingNo$delegate, editStreet$delegate, editNeighbourhood$delegate, editCity$delegate, editCountry$delegate, editLatitude$delegate, editLongitude$delegate), $composer_12, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_14 = $composer_12;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = $composer_14.k31(dispatchReceiver_0);
      // Inline function 'kotlin.let' call
      var it_37 = $composer_14.i31();
      var tmp_45;
      if (invalid_3 || it_37 === Companion_getInstance().f30_1) {
        var value_37 = ComposableLambda$invoke$ref_1(dispatchReceiver_0);
        $composer_14.j31(value_37);
        tmp_45 = value_37;
      } else {
        tmp_45 = it_37;
      }
      var tmp_46 = tmp_45;
      var tmp_47 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_48 = WindowInsets(0, 0, 0, 0);
      CenterAlignedTopAppBar(tmp_42, null, tmp_44, tmp_46, tmp_47, tmp_48, null, null, $composer_12, 3462, 210);
      if (profile == null) {
        $composer_12.m30(-145290596);
        sourceInformation($composer_12, '314@15611L49,313@15560L271');
        LoginRequiredScreen(stringResource(get_login_required_profile(string_instance), $composer_12, 0), get_Person(Icons_getInstance().dxv_1), onLogout, fillMaxSize(Companion_instance), $composer_12, 3072 | 896 & $dirty << 3, 0);
        $composer_12.n30();
      } else {
        $composer_12.m30(-144080635);
        sourceInformation($composer_12, '320@15869L29414');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = fillMaxWidth(ColumnScopeInstance_instance.yds(Companion_instance, 1.0));
        var contentAlignment_0 = Companion_getInstance_11().l8t_1;
        var propagateMinConstraints_0 = false;
        var $composer_15 = $composer_12;
        if (!((4 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_16 = $composer_15;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_16, 0).hashCode();
        var localMap_1 = $composer_16.t31();
        var materialized_1 = materialize($composer_16, modifier_4);
        var tmp0_3 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_17 = $composer_16;
        var tmp_49 = $composer_17.g30();
        if (!isInterface(tmp_49, Applier)) {
          invalidApplier();
        }
        $composer_17.b31();
        if ($composer_17.h30()) {
          $composer_17.c31(tmp0_3);
        } else {
          $composer_17.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_17);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_18 = $composer_17;
        var $composer_19 = $composer_18;
        sourceInformationMarkerStart($composer_19, 709890451, 'C322@16063L21,321@15982L29283:ProfileScreen.kt#2kgzgj');
        var tmp_50 = fillMaxSize(Companion_instance);
        var tmp_51 = verticalScroll(tmp_50, rememberScrollState(0, $composer_19, 0, 1));
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$182 = _Dp___init__impl__ms3zkb(800);
        var tmp0_$receiver = widthIn(tmp_51, VOID, tmp$ret$182);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_start = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_end = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_top = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp4_bottom = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_5 = padding_1(tmp0_$receiver, tmp1_start, tmp3_top, tmp2_end, tmp4_bottom);
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = Companion_getInstance_11().x8t_1;
        var $composer_20 = $composer_19;
        if (!((2 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((2 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((2 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_2 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_20, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_21 = $composer_20;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_21, 0).hashCode();
        var localMap_2 = $composer_21.t31();
        var materialized_2 = materialize($composer_21, modifier_6);
        var tmp0_4 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_22 = $composer_21;
        var tmp_52 = $composer_22.g30();
        if (!isInterface(tmp_52, Applier)) {
          invalidApplier();
        }
        $composer_22.b31();
        if ($composer_22.h30()) {
          $composer_22.c31(tmp0_4);
        } else {
          $composer_22.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_22);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_23 = $composer_22;
        var $composer_24 = $composer_23;
        sourceInformationMarkerStart($composer_24, -357422148, 'C329@16481L4506,407@21013L41,657@37089L41,663@37451L11,663@37407L66,659@37156L603,670@37785L41,676@38144L11,676@38100L65,672@37852L602,683@38480L41,690@38877L11,691@38969L11,689@38800L230,685@38547L777,699@39350L41,706@39740L11,707@39831L11,705@39663L228,701@39417L768,715@40211L41,718@40332L29,721@40515L465,717@40278L702,732@41006L41,735@41127L72,734@41073L537,744@41636L41,746@41703L463,756@42192L41,779@43273L27,782@43531L11,782@43481L68,778@43219L614,789@43859L41,792@43976L220,791@43926L597,804@44549L41,806@44616L66,808@44708L41,812@44916L159,810@44775L401,819@45202L41:ProfileScreen.kt#2kgzgj');
        var tmp0_safe_receiver = profile.fyn_1;
        var tmp_53;
        if (tmp0_safe_receiver == null) {
          tmp_53 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_54;
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(tmp0_safe_receiver)) {
            tmp_54 = tmp0_safe_receiver;
          } else {
            tmp_54 = null;
          }
          tmp_53 = tmp_54;
        }
        var avatarUrl = tmp_53;
        var tmp_55 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$196 = _Dp___init__impl__ms3zkb(130);
        var tmp_56 = size(tmp_55, tmp$ret$196);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$197 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_7 = padding_0(tmp_56, tmp$ret$197);
        var contentAlignment_1 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_1 = false;
        var $composer_25 = $composer_24;
        if (!((4 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_1 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_1 = false;
        var measurePolicy_3 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_26 = $composer_25;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_26, 0).hashCode();
        var localMap_3 = $composer_26.t31();
        var materialized_3 = materialize($composer_26, modifier_8);
        var tmp0_5 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_27 = $composer_26;
        var tmp_57 = $composer_27.g30();
        if (!isInterface(tmp_57, Applier)) {
          invalidApplier();
        }
        $composer_27.b31();
        if ($composer_27.h30()) {
          $composer_27.c31(tmp0_5);
        } else {
          $composer_27.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_27);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_28 = $composer_27;
        var $composer_29 = $composer_28;
        sourceInformationMarkerStart($composer_29, 456270395, 'C335@16833L11,336@16937L24,333@16682L2216:ProfileScreen.kt#2kgzgj');
        var tmp_58 = background(clip(fillMaxSize(Companion_instance), get_CircleShape()), MaterialTheme_instance.unz($composer_29, 6).oo0_1);
        var tmp_59 = !ProfileScreen$lambda_26(isUpdatingAvatar$delegate);
        sourceInformationMarkerStart($composer_29, 291816969, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_4 = $composer_29.q31(imagePicker);
        // Inline function 'kotlin.let' call
        var it_38 = $composer_29.i31();
        var tmp_60;
        if (invalid_4 || it_38 === Companion_getInstance().f30_1) {
          var value_38 = ProfileScreen$lambda_66(imagePicker);
          $composer_29.j31(value_38);
          tmp_60 = value_38;
        } else {
          tmp_60 = it_38;
        }
        var tmp0_group_0 = tmp_60;
        sourceInformationMarkerEnd($composer_29);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_9 = clickable(tmp_58, tmp_59, VOID, VOID, VOID, tmp0_group_0);
        var contentAlignment_2 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_2 = false;
        var $composer_30 = $composer_29;
        if (!((4 & 1) === 0))
          modifier_9 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_2 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_2 = false;
        var measurePolicy_4 = maybeCachedBoxMeasurePolicy(contentAlignment_2, propagateMinConstraints_2);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_10 = modifier_9;
        var $composer_31 = $composer_30;
        if (!((0 & 2) === 0))
          modifier_10 = Companion_instance;
        var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_31, 0).hashCode();
        var localMap_4 = $composer_31.t31();
        var materialized_4 = materialize($composer_31, modifier_10);
        var tmp0_6 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_32 = $composer_31;
        var tmp_61 = $composer_32.g30();
        if (!isInterface(tmp_61, Applier)) {
          invalidApplier();
        }
        $composer_32.b31();
        if ($composer_32.h30()) {
          $composer_32.c31(tmp0_6);
        } else {
          $composer_32.d31();
        }
        var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_32);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
        var $composer_33 = $composer_32;
        var $composer_34 = $composer_33;
        sourceInformationMarkerStart($composer_34, -1625207605, 'C:ProfileScreen.kt#2kgzgj');
        if (!(avatarUrl == null)) {
          $composer_34.m30(-1625221959);
          sourceInformation($composer_34, '340@17156L502');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_11 = fillMaxSize(Companion_instance);
          var contentAlignment_3 = null;
          var propagateMinConstraints_3 = false;
          var $composer_35 = $composer_34;
          if (!((6 & 1) === 0))
            modifier_11 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_3 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_3 = false;
          var measurePolicy_5 = maybeCachedBoxMeasurePolicy(contentAlignment_3, propagateMinConstraints_3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_12 = modifier_11;
          var $composer_36 = $composer_35;
          if (!((0 & 2) === 0))
            modifier_12 = Companion_instance;
          var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_36, 0).hashCode();
          var localMap_5 = $composer_36.t31();
          var materialized_5 = materialize($composer_36, modifier_12);
          var tmp0_7 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_37 = $composer_36;
          var tmp_62 = $composer_37.g30();
          if (!isInterface(tmp_62, Applier)) {
            invalidApplier();
          }
          $composer_37.b31();
          if ($composer_37.h30()) {
            $composer_37.c31(tmp0_7);
          } else {
            $composer_37.d31();
          }
          var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_37);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
          var $composer_38 = $composer_37;
          var $composer_39 = $composer_38;
          sourceInformationMarkerStart($composer_39, 872579162, 'C343@17378L43,341@17237L383:ProfileScreen.kt#2kgzgj');
          HadayaImage(avatarUrl, stringResource(get_profile_pic_desc(string_instance), $composer_39, 0), fillMaxSize(Companion_instance), Companion_getInstance_13().q96_1, $composer_39, 3456, 0);
          sourceInformationMarkerEnd($composer_39);
          $composer_37.e31();
          $composer_34.n30();
        } else {
          $composer_34.m30(-1624651776);
          sourceInformation($composer_34, '353@18005L11,349@17736L335');
          var tmp_63 = get_Person(Icons_getInstance().dxv_1);
          var tmp_64 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$220 = _Dp___init__impl__ms3zkb(64);
          Icon(tmp_63, null, size(tmp_64, tmp$ret$220), MaterialTheme_instance.unz($composer_34, 6).po0_1, $composer_34, 432, 0);
          $composer_34.n30();
        }
        if (ProfileScreen$lambda_26(isUpdatingAvatar$delegate)) {
          $composer_34.m30(-1624183180);
          sourceInformation($composer_34, '358@18199L635');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_13 = background(fillMaxSize(Companion_instance), Color__copy$default_impl_ectz3s(Companion_getInstance_14().i6b_1, 0.3));
          var contentAlignment_4 = Companion_getInstance_11().o8t_1;
          var propagateMinConstraints_4 = false;
          var $composer_40 = $composer_34;
          if (!((4 & 1) === 0))
            modifier_13 = Companion_instance;
          if (!((4 & 2) === 0))
            contentAlignment_4 = Companion_getInstance_11().k8t_1;
          if (!((4 & 4) === 0))
            propagateMinConstraints_4 = false;
          var measurePolicy_6 = maybeCachedBoxMeasurePolicy(contentAlignment_4, propagateMinConstraints_4);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_14 = modifier_13;
          var $composer_41 = $composer_40;
          if (!((0 & 2) === 0))
            modifier_14 = Companion_instance;
          var compositeKeyHash_6 = get_currentCompositeKeyHashCode($composer_41, 0).hashCode();
          var localMap_6 = $composer_41.t31();
          var materialized_6 = materialize($composer_41, modifier_14);
          var tmp0_8 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_42 = $composer_41;
          var tmp_65 = $composer_42.g30();
          if (!isInterface(tmp_65, Applier)) {
            invalidApplier();
          }
          $composer_42.b31();
          if ($composer_42.h30()) {
            $composer_42.c31(tmp0_8);
          } else {
            $composer_42.d31();
          }
          var $this$ReusableComposeNode_6 = _Updater___init__impl__rbfxm8($composer_42);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, measurePolicy_6, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, localMap_6, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, compositeKeyHash_6, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_6, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_6, materialized_6, Companion_getInstance_12().qah_1);
          var $composer_43 = $composer_42;
          var $composer_44 = $composer_43;
          sourceInformationMarkerStart($composer_44, 1194783487, 'C363@18523L273:ProfileScreen.kt#2kgzgj');
          var tmp_66 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$227 = _Dp___init__impl__ms3zkb(32);
          var tmp_67 = size(tmp_66, tmp$ret$227);
          var tmp_68 = Companion_getInstance_14().m6b_1;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_69 = _Dp___init__impl__ms3zkb(3);
          var tmp_70 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_71 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_67, tmp_68, tmp_69, tmp_70, tmp_71, _Dp___init__impl__ms3zkb(0.0), $composer_44, 438, 56);
          sourceInformationMarkerEnd($composer_44);
          $composer_42.e31();
          $composer_34.n30();
        } else {
          $composer_34.m30(-1623503753);
          $composer_34.n30();
        }
        sourceInformationMarkerEnd($composer_34);
        $composer_32.e31();
        if (!ProfileScreen$lambda_26(isUpdatingAvatar$delegate)) {
          $composer_29.m30(458450903);
          sourceInformation($composer_29, '393@20288L11,394@20360L24,390@20063L868');
          if (!(avatarUrl == null)) {
            $composer_29.m30(458475796);
            sourceInformation($composer_29, '377@19285L11,378@19359L33,374@19046L917');
            var tmp_72 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().q8t_1);
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$229 = _Dp___init__impl__ms3zkb(32);
            var tmp_73 = background(clip(size(tmp_72, tmp$ret$229), get_CircleShape()), MaterialTheme_instance.unz($composer_29, 6).to0_1);
            sourceInformationMarkerStart($composer_29, 291894482, 'CC(remember):ProfileScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_39 = $composer_29.i31();
            var tmp_74;
            if (false || it_39 === Companion_getInstance().f30_1) {
              var value_39 = ProfileScreen$lambda_67(showDeleteAvatarDialog$delegate);
              $composer_29.j31(value_39);
              tmp_74 = value_39;
            } else {
              tmp_74 = it_39;
            }
            var tmp1_group_1 = tmp_74;
            sourceInformationMarkerEnd($composer_29);
            // Inline function 'androidx.compose.foundation.layout.Box' call
            var modifier_15 = clickable(tmp_73, VOID, VOID, VOID, VOID, tmp1_group_1);
            var contentAlignment_5 = Companion_getInstance_11().o8t_1;
            var propagateMinConstraints_5 = false;
            var $composer_45 = $composer_29;
            if (!((4 & 1) === 0))
              modifier_15 = Companion_instance;
            if (!((4 & 2) === 0))
              contentAlignment_5 = Companion_getInstance_11().k8t_1;
            if (!((4 & 4) === 0))
              propagateMinConstraints_5 = false;
            var measurePolicy_7 = maybeCachedBoxMeasurePolicy(contentAlignment_5, propagateMinConstraints_5);
            // Inline function 'androidx.compose.ui.layout.Layout' call
            var modifier_16 = modifier_15;
            var $composer_46 = $composer_45;
            if (!((0 & 2) === 0))
              modifier_16 = Companion_instance;
            var compositeKeyHash_7 = get_currentCompositeKeyHashCode($composer_46, 0).hashCode();
            var localMap_7 = $composer_46.t31();
            var materialized_7 = materialize($composer_46, modifier_16);
            var tmp0_9 = Companion_getInstance_12().oah_1;
            // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
            var $composer_47 = $composer_46;
            var tmp_75 = $composer_47.g30();
            if (!isInterface(tmp_75, Applier)) {
              invalidApplier();
            }
            $composer_47.b31();
            if ($composer_47.h30()) {
              $composer_47.c31(tmp0_9);
            } else {
              $composer_47.d31();
            }
            var $this$ReusableComposeNode_7 = _Updater___init__impl__rbfxm8($composer_47);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_7, measurePolicy_7, Companion_getInstance_12().tah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_7, localMap_7, Companion_getInstance_12().sah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_7, compositeKeyHash_7, Companion_getInstance_12().wah_1);
            Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_7, Companion_getInstance_12().xah_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode_7, materialized_7, Companion_getInstance_12().qah_1);
            var $composer_48 = $composer_47;
            var $composer_49 = $composer_48;
            sourceInformationMarkerStart($composer_49, 540173559, 'C383@19687L33,384@19787L11,381@19550L375:ProfileScreen.kt#2kgzgj');
            var tmp0_imageVector = get_Delete(Icons_getInstance().dxv_1);
            var tmp1_contentDescription = stringResource(get_delete(string_instance), $composer_49, 0);
            var tmp2_tint = MaterialTheme_instance.unz($composer_49, 6).uo0_1;
            var tmp_76 = Companion_instance;
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$240 = _Dp___init__impl__ms3zkb(16);
            var tmp3_modifier = size(tmp_76, tmp$ret$240);
            Icon(tmp0_imageVector, tmp1_contentDescription, tmp3_modifier, tmp2_tint, $composer_49, 384, 0);
            sourceInformationMarkerEnd($composer_49);
            $composer_47.e31();
            $composer_29.n30();
          } else {
            $composer_29.m30(459426225);
            $composer_29.n30();
          }
          var tmp_77 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().s8t_1);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$241 = _Dp___init__impl__ms3zkb(32);
          var tmp_78 = background(clip(size(tmp_77, tmp$ret$241), get_CircleShape()), MaterialTheme_instance.unz($composer_29, 6).xnz_1);
          sourceInformationMarkerStart($composer_29, 291926505, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_5 = $composer_29.q31(imagePicker);
          // Inline function 'kotlin.let' call
          var it_40 = $composer_29.i31();
          var tmp_79;
          if (invalid_5 || it_40 === Companion_getInstance().f30_1) {
            var value_40 = ProfileScreen$lambda_68(imagePicker);
            $composer_29.j31(value_40);
            tmp_79 = value_40;
          } else {
            tmp_79 = it_40;
          }
          var tmp2_group_0 = tmp_79;
          sourceInformationMarkerEnd($composer_29);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_17 = clickable(tmp_78, VOID, VOID, VOID, VOID, tmp2_group_0);
          var contentAlignment_6 = Companion_getInstance_11().o8t_1;
          var propagateMinConstraints_6 = false;
          var $composer_50 = $composer_29;
          if (!((4 & 1) === 0))
            modifier_17 = Companion_instance;
          if (!((4 & 2) === 0))
            contentAlignment_6 = Companion_getInstance_11().k8t_1;
          if (!((4 & 4) === 0))
            propagateMinConstraints_6 = false;
          var measurePolicy_8 = maybeCachedBoxMeasurePolicy(contentAlignment_6, propagateMinConstraints_6);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_18 = modifier_17;
          var $composer_51 = $composer_50;
          if (!((0 & 2) === 0))
            modifier_18 = Companion_instance;
          var compositeKeyHash_8 = get_currentCompositeKeyHashCode($composer_51, 0).hashCode();
          var localMap_8 = $composer_51.t31();
          var materialized_8 = materialize($composer_51, modifier_18);
          var tmp0_10 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_52 = $composer_51;
          var tmp_80 = $composer_52.g30();
          if (!isInterface(tmp_80, Applier)) {
            invalidApplier();
          }
          $composer_52.b31();
          if ($composer_52.h30()) {
            $composer_52.c31(tmp0_10);
          } else {
            $composer_52.d31();
          }
          var $this$ReusableComposeNode_8 = _Updater___init__impl__rbfxm8($composer_52);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, measurePolicy_8, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, localMap_8, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, compositeKeyHash_8, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_8, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_8, materialized_8, Companion_getInstance_12().qah_1);
          var $composer_53 = $composer_52;
          var $composer_54 = $composer_53;
          sourceInformationMarkerStart($composer_54, -1352624604, 'C399@20657L45,400@20765L11,397@20530L367:ProfileScreen.kt#2kgzgj');
          var tmp0_imageVector_0 = get_Edit(Icons_getInstance().dxv_1);
          var tmp1_contentDescription_0 = stringResource(get_change_avatar_desc(string_instance), $composer_54, 0);
          var tmp2_tint_0 = MaterialTheme_instance.unz($composer_54, 6).ynz_1;
          var tmp_81 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$252 = _Dp___init__impl__ms3zkb(16);
          var tmp3_modifier_0 = size(tmp_81, tmp$ret$252);
          Icon(tmp0_imageVector_0, tmp1_contentDescription_0, tmp3_modifier_0, tmp2_tint_0, $composer_54, 384, 0);
          sourceInformationMarkerEnd($composer_54);
          $composer_52.e31();
          $composer_29.n30();
        } else {
          $composer_29.m30(460382513);
          $composer_29.n30();
        }
        sourceInformationMarkerEnd($composer_29);
        $composer_27.e31();
        var tmp_82 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$253 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_82, tmp$ret$253), $composer_24, 6);
        if (ProfileScreen$lambda_30(isEditing$delegate)) {
          $composer_24.m30(-353290066);
          sourceInformation($composer_24, '412@21247L22,410@21125L388,417@21542L41,420@21733L21,418@21612L385,425@22026L41,428@22214L3,426@22096L458,435@22583L41,442@23011L823,465@24594L422,440@22890L2127,473@25046L41,476@25239L23,474@25116L391,481@25536L41,484@25725L19,482@25606L378,489@26013L41,492@26209L26,490@26083L399,497@26511L41,501@26782L17,498@26581L316,504@26926L41,507@27116L20,505@26996L381,512@27406L41,520@27941L26,527@28469L405,518@27815L1921,549@29765L41,556@30207L22,554@30085L740,565@30854L41,571@31344L27,582@32045L11,583@32139L11,584@32233L11,585@32327L11,586@32418L11,587@32520L11,588@32627L11,589@32727L11,581@31968L812,568@31123L3,573@31469L430,566@30924L1886');
          var tmp1_value = ProfileScreen$lambda_32(editFirstName$delegate);
          var tmp2_modifier = fillMaxWidth(Companion_instance);
          sourceInformationMarkerStart($composer_24, 1928259341, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_41 = $composer_24.i31();
          var tmp_83;
          if (false || it_41 === Companion_getInstance().f30_1) {
            var value_41 = ProfileScreen$lambda_69(editFirstName$delegate);
            $composer_24.j31(value_41);
            tmp_83 = value_41;
          } else {
            tmp_83 = it_41;
          }
          var tmp0_group_1 = tmp_83;
          sourceInformationMarkerEnd($composer_24);
          var tmp_84 = ComposableSingletons$ProfileScreenKt_getInstance().a14a_1;
          OutlinedTextField(tmp1_value, tmp0_group_1, tmp2_modifier, false, false, null, tmp_84, null, null, null, null, null, null, false, null, null, null, true, 0, 0, null, null, null, $composer_24, 1573296, 12582912, 0, 8257464);
          var tmp_85 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$258 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_85, tmp$ret$258), $composer_24, 6);
          var tmp3_value = ProfileScreen$lambda_34(editLastName$delegate);
          var tmp4_modifier = fillMaxWidth(Companion_instance);
          sourceInformationMarkerStart($composer_24, 1928274892, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_42 = $composer_24.i31();
          var tmp_86;
          if (false || it_42 === Companion_getInstance().f30_1) {
            var value_42 = ProfileScreen$lambda_70(editLastName$delegate);
            $composer_24.j31(value_42);
            tmp_86 = value_42;
          } else {
            tmp_86 = it_42;
          }
          var tmp1_group_2 = tmp_86;
          sourceInformationMarkerEnd($composer_24);
          var tmp_87 = ComposableSingletons$ProfileScreenKt_getInstance().b14a_1;
          OutlinedTextField(tmp3_value, tmp1_group_2, tmp4_modifier, false, false, null, tmp_87, null, null, null, null, null, null, false, null, null, null, true, 0, 0, null, null, null, $composer_24, 1573296, 12582912, 0, 8257464);
          var tmp_88 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$263 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_88, tmp$ret$263), $composer_24, 6);
          var tmp5_value = ProfileScreen$lambda_36(editEmail$delegate);
          var tmp6_modifier = fillMaxWidth(Companion_instance);
          sourceInformationMarkerStart($composer_24, 1928290266, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_43 = $composer_24.i31();
          var tmp_89;
          if (false || it_43 === Companion_getInstance().f30_1) {
            var value_43 = ProfileScreen$lambda_71;
            $composer_24.j31(value_43);
            tmp_89 = value_43;
          } else {
            tmp_89 = it_43;
          }
          var tmp2_group_1 = tmp_89;
          sourceInformationMarkerEnd($composer_24);
          var tmp_90 = ComposableSingletons$ProfileScreenKt_getInstance().c14a_1;
          OutlinedTextField(tmp5_value, tmp2_group_1, tmp6_modifier, false, true, null, tmp_90, null, null, null, null, null, null, false, null, null, null, true, 0, 0, null, null, null, $composer_24, 1600944, 12582912, 0, 8257440);
          var tmp_91 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$268 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_91, tmp$ret$268), $composer_24, 6);
          var tmp_92;
          // Inline function 'kotlin.text.isNotBlank' call
          var this_33 = ProfileScreen$lambda_38(editBirthday$delegate);
          if (!isBlank(this_33)) {
            tmp_92 = !Regex_init_$Create$('^\\d{4}-\\d{2}-\\d{2}$').zd(ProfileScreen$lambda_38(editBirthday$delegate));
          } else {
            tmp_92 = false;
          }
          var isBirthdayError = tmp_92;
          var tmp7_value = ProfileScreen$lambda_38(editBirthday$delegate);
          var tmp8_modifier = fillMaxWidth(Companion_instance);
          var tmp9_keyboardOptions = new KeyboardOptions(VOID, VOID, Companion_getInstance_31().y8b_1);
          var tmp_93;
          if (isBirthdayError) {
            tmp_93 = ComposableSingletons$ProfileScreenKt_getInstance().d14a_1;
          } else {
            tmp_93 = null;
          }
          var tmp10_supportingText = tmp_93;
          sourceInformationMarkerStart($composer_24, 1928316590, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_44 = $composer_24.i31();
          var tmp_94;
          if (false || it_44 === Companion_getInstance().f30_1) {
            var value_44 = ProfileScreen$lambda_72(editBirthday$delegate);
            $composer_24.j31(value_44);
            tmp_94 = value_44;
          } else {
            tmp_94 = it_44;
          }
          var tmp3_group_0 = tmp_94;
          sourceInformationMarkerEnd($composer_24);
          var tmp_95 = ComposableSingletons$ProfileScreenKt_getInstance().e14a_1;
          var tmp_96 = ComposableSingletons$ProfileScreenKt_getInstance().f14a_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_1 = rememberComposableLambda(1423683883, true, ProfileScreen$lambda_73(showDatePicker$delegate), $composer_24, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_55 = $composer_24;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_6 = $composer_55.k31(dispatchReceiver_1);
          // Inline function 'kotlin.let' call
          var it_45 = $composer_55.i31();
          var tmp_97;
          if (invalid_6 || it_45 === Companion_getInstance().f30_1) {
            var value_45 = ComposableLambda$invoke$ref(dispatchReceiver_1);
            $composer_55.j31(value_45);
            tmp_97 = value_45;
          } else {
            tmp_97 = it_45;
          }
          var tmp_98 = tmp_97;
          OutlinedTextField(tmp7_value, tmp3_group_0, tmp8_modifier, false, false, null, tmp_95, tmp_96, tmp_98, null, null, null, tmp10_supportingText, isBirthdayError, null, tmp9_keyboardOptions, null, true, 0, 0, null, null, null, $composer_24, 114819504, 12779520, 0, 8212024);
          var tmp_99 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$281 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_99, tmp$ret$281), $composer_24, 6);
          var tmp11_value = ProfileScreen$lambda_40(editBuildingNo$delegate);
          var tmp12_modifier = fillMaxWidth(Companion_instance);
          sourceInformationMarkerStart($composer_24, 1928387086, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_46 = $composer_24.i31();
          var tmp_100;
          if (false || it_46 === Companion_getInstance().f30_1) {
            var value_46 = ProfileScreen$lambda_74(editBuildingNo$delegate);
            $composer_24.j31(value_46);
            tmp_100 = value_46;
          } else {
            tmp_100 = it_46;
          }
          var tmp4_group_0 = tmp_100;
          sourceInformationMarkerEnd($composer_24);
          var tmp_101 = ComposableSingletons$ProfileScreenKt_getInstance().h14a_1;
          OutlinedTextField(tmp11_value, tmp4_group_0, tmp12_modifier, false, false, null, tmp_101, null, null, null, null, null, null, false, null, null, null, true, 0, 0, null, null, null, $composer_24, 1573296, 12582912, 0, 8257464);
          var tmp_102 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$286 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_102, tmp$ret$286), $composer_24, 6);
          var tmp13_value = ProfileScreen$lambda_42(editStreet$delegate);
          var tmp14_modifier = fillMaxWidth(Companion_instance);
          sourceInformationMarkerStart($composer_24, 1928402634, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_47 = $composer_24.i31();
          var tmp_103;
          if (false || it_47 === Companion_getInstance().f30_1) {
            var value_47 = ProfileScreen$lambda_75(editStreet$delegate);
            $composer_24.j31(value_47);
            tmp_103 = value_47;
          } else {
            tmp_103 = it_47;
          }
          var tmp5_group_0 = tmp_103;
          sourceInformationMarkerEnd($composer_24);
          var tmp_104 = ComposableSingletons$ProfileScreenKt_getInstance().i14a_1;
          OutlinedTextField(tmp13_value, tmp5_group_0, tmp14_modifier, false, false, null, tmp_104, null, null, null, null, null, null, false, null, null, null, true, 0, 0, null, null, null, $composer_24, 1573296, 12582912, 0, 8257464);
          var tmp_105 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$291 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_105, tmp$ret$291), $composer_24, 6);
          var tmp15_value = ProfileScreen$lambda_44(editNeighbourhood$delegate);
          var tmp16_modifier = fillMaxWidth(Companion_instance);
          sourceInformationMarkerStart($composer_24, 1928418129, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_48 = $composer_24.i31();
          var tmp_106;
          if (false || it_48 === Companion_getInstance().f30_1) {
            var value_48 = ProfileScreen$lambda_76(editNeighbourhood$delegate);
            $composer_24.j31(value_48);
            tmp_106 = value_48;
          } else {
            tmp_106 = it_48;
          }
          var tmp6_group_0 = tmp_106;
          sourceInformationMarkerEnd($composer_24);
          var tmp_107 = ComposableSingletons$ProfileScreenKt_getInstance().j14a_1;
          OutlinedTextField(tmp15_value, tmp6_group_0, tmp16_modifier, false, false, null, tmp_107, null, null, null, null, null, null, false, null, null, null, true, 0, 0, null, null, null, $composer_24, 1573296, 12582912, 0, 8257464);
          var tmp_108 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$296 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_108, tmp$ret$296), $composer_24, 6);
          var tmp_109 = ProfileScreen$lambda_46(editCity$delegate);
          var tmp_110 = ProfileScreen$lambda_0(currentLanguage$delegate);
          sourceInformationMarkerStart($composer_24, 1928436456, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_49 = $composer_24.i31();
          var tmp_111;
          if (false || it_49 === Companion_getInstance().f30_1) {
            var value_49 = ProfileScreen$lambda_77(editCity$delegate);
            $composer_24.j31(value_49);
            tmp_111 = value_49;
          } else {
            tmp_111 = it_49;
          }
          var tmp7_group_0 = tmp_111;
          sourceInformationMarkerEnd($composer_24);
          GovernorateDropdown(tmp_109, tmp_110, tmp7_group_0, fillMaxWidth(Companion_instance), $composer_24, 3456, 0);
          var tmp_112 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$301 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_112, tmp$ret$301), $composer_24, 6);
          var tmp17_value = ProfileScreen$lambda_48(editCountry$delegate);
          var tmp18_modifier = fillMaxWidth(Companion_instance);
          sourceInformationMarkerStart($composer_24, 1928447147, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_50 = $composer_24.i31();
          var tmp_113;
          if (false || it_50 === Companion_getInstance().f30_1) {
            var value_50 = ProfileScreen$lambda_78(editCountry$delegate);
            $composer_24.j31(value_50);
            tmp_113 = value_50;
          } else {
            tmp_113 = it_50;
          }
          var tmp8_group_0 = tmp_113;
          sourceInformationMarkerEnd($composer_24);
          var tmp_114 = ComposableSingletons$ProfileScreenKt_getInstance().k14a_1;
          OutlinedTextField(tmp17_value, tmp8_group_0, tmp18_modifier, false, false, null, tmp_114, null, null, null, null, null, null, false, null, null, null, true, 0, 0, null, null, null, $composer_24, 1573296, 12582912, 0, 8257464);
          var tmp_115 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$306 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_115, tmp$ret$306), $composer_24, 6);
          var tmp_116;
          // Inline function 'kotlin.text.isNotBlank' call
          var this_34 = ProfileScreen$lambda_50(editPersonalPhone$delegate);
          if (!isBlank(this_34)) {
            tmp_116 = !isValidEgyptianMobile(ProfileScreen$lambda_50(editPersonalPhone$delegate));
          } else {
            tmp_116 = false;
          }
          var isPersonalPhoneError = tmp_116;
          var canChangePhone = profile.qyn_1 === true;
          var tmp19_value = ProfileScreen$lambda_50(editPersonalPhone$delegate);
          var tmp20_modifier = fillMaxWidth(Companion_instance);
          var tmp21_keyboardOptions = new KeyboardOptions(VOID, VOID, Companion_getInstance_31().z8b_1);
          var tmp_117;
          if (!canChangePhone) {
            $composer_24.m30(-345843618);
            sourceInformation($composer_24, '535@28982L709');
            // Inline function 'kotlin.run' call
            var dispatchReceiver_2 = rememberComposableLambda(1360171008, true, ProfileScreen$lambda_79(scope_0, verified_phone_msg, snackbarHostState), $composer_24, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_56 = $composer_24;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_7 = $composer_56.k31(dispatchReceiver_2);
            // Inline function 'kotlin.let' call
            var it_51 = $composer_56.i31();
            var tmp_118;
            if (invalid_7 || it_51 === Companion_getInstance().f30_1) {
              var value_51 = ComposableLambda$invoke$ref(dispatchReceiver_2);
              $composer_56.j31(value_51);
              tmp_118 = value_51;
            } else {
              tmp_118 = it_51;
            }
            var tmp9_group_0 = tmp_118;
            $composer_24.n30();
            tmp_117 = tmp9_group_0;
          } else {
            $composer_24.m30(-345087002);
            $composer_24.n30();
            tmp_117 = null;
          }
          var tmp22_trailingIcon = tmp_117;
          sourceInformationMarkerStart($composer_24, 1928473553, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_52 = $composer_24.i31();
          var tmp_119;
          if (false || it_52 === Companion_getInstance().f30_1) {
            var value_52 = ProfileScreen$lambda_80(editPersonalPhone$delegate);
            $composer_24.j31(value_52);
            tmp_119 = value_52;
          } else {
            tmp_119 = it_52;
          }
          var tmp10_group_0 = tmp_119;
          sourceInformationMarkerEnd($composer_24);
          var tmp_120 = ComposableSingletons$ProfileScreenKt_getInstance().m14a_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_3 = rememberComposableLambda(735493847, true, ProfileScreen$lambda_81(isPersonalPhoneError, canChangePhone), $composer_24, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_57 = $composer_24;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_8 = $composer_57.k31(dispatchReceiver_3);
          // Inline function 'kotlin.let' call
          var it_53 = $composer_57.i31();
          var tmp_121;
          if (invalid_8 || it_53 === Companion_getInstance().f30_1) {
            var value_53 = ComposableLambda$invoke$ref(dispatchReceiver_3);
            $composer_57.j31(value_53);
            tmp_121 = value_53;
          } else {
            tmp_121 = it_53;
          }
          var tmp_122 = tmp_121;
          OutlinedTextField(tmp19_value, tmp10_group_0, tmp20_modifier, canChangePhone, false, null, tmp_120, null, null, tmp22_trailingIcon, null, null, tmp_122, isPersonalPhoneError, null, tmp21_keyboardOptions, null, true, 0, 0, null, null, null, $composer_24, 1573296, 12779904, 0, 8211888);
          var tmp_123 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$326 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_123, tmp$ret$326), $composer_24, 6);
          var tmp_124;
          // Inline function 'kotlin.text.isNotBlank' call
          var this_35 = ProfileScreen$lambda_52(editWorkPhone$delegate);
          if (!isBlank(this_35)) {
            tmp_124 = !isValidEgyptianWorkPhone(ProfileScreen$lambda_52(editWorkPhone$delegate));
          } else {
            tmp_124 = false;
          }
          var isWorkPhoneError = tmp_124;
          var tmp23_value = ProfileScreen$lambda_52(editWorkPhone$delegate);
          var tmp24_modifier = fillMaxWidth(Companion_instance);
          var tmp25_keyboardOptions = new KeyboardOptions(VOID, VOID, Companion_getInstance_31().z8b_1);
          var tmp_125;
          if (isWorkPhoneError) {
            tmp_125 = ComposableSingletons$ProfileScreenKt_getInstance().n14a_1;
          } else {
            tmp_125 = null;
          }
          var tmp26_supportingText = tmp_125;
          sourceInformationMarkerStart($composer_24, 1928546061, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_54 = $composer_24.i31();
          var tmp_126;
          if (false || it_54 === Companion_getInstance().f30_1) {
            var value_54 = ProfileScreen$lambda_82(editWorkPhone$delegate);
            $composer_24.j31(value_54);
            tmp_126 = value_54;
          } else {
            tmp_126 = it_54;
          }
          var tmp11_group_0 = tmp_126;
          sourceInformationMarkerEnd($composer_24);
          var tmp_127 = ComposableSingletons$ProfileScreenKt_getInstance().o14a_1;
          OutlinedTextField(tmp23_value, tmp11_group_0, tmp24_modifier, false, false, null, tmp_127, null, null, null, null, null, tmp26_supportingText, isWorkPhoneError, null, tmp25_keyboardOptions, null, true, 0, 0, null, null, null, $composer_24, 1573296, 12779520, 0, 8212408);
          var tmp_128 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$332 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_128, tmp$ret$332), $composer_24, 6);
          var tmp36_value = !(ProfileScreen$lambda_54(editLatitude$delegate) == null) && !(ProfileScreen$lambda_56(editLongitude$delegate) == null) ? '' + ProfileScreen$lambda_54(editLatitude$delegate) + ', ' + ProfileScreen$lambda_56(editLongitude$delegate) : '';
          var tmp_129 = fillMaxWidth(Companion_instance);
          sourceInformationMarkerStart($composer_24, 1928582450, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_9 = $composer_24.q31(locationPicker);
          // Inline function 'kotlin.let' call
          var it_55 = $composer_24.i31();
          var tmp_130;
          if (invalid_9 || it_55 === Companion_getInstance().f30_1) {
            var value_55 = ProfileScreen$lambda_83(locationPicker);
            $composer_24.j31(value_55);
            tmp_130 = value_55;
          } else {
            tmp_130 = it_55;
          }
          var tmp12_group_0 = tmp_130;
          sourceInformationMarkerEnd($composer_24);
          var tmp37_modifier = clickable(tmp_129, VOID, VOID, VOID, VOID, tmp12_group_0);
          var tmp27_$this = OutlinedTextFieldDefaults_getInstance();
          var tmp28_focusedTextColor = MaterialTheme_instance.unz($composer_24, 6).no0_1;
          var tmp29_unfocusedTextColor = MaterialTheme_instance.unz($composer_24, 6).no0_1;
          var tmp30_focusedBorderColor = MaterialTheme_instance.unz($composer_24, 6).xo0_1;
          var tmp31_unfocusedBorderColor = MaterialTheme_instance.unz($composer_24, 6).xo0_1;
          var tmp32_focusedLabelColor = MaterialTheme_instance.unz($composer_24, 6).po0_1;
          var tmp33_unfocusedLabelColor = MaterialTheme_instance.unz($composer_24, 6).po0_1;
          var tmp34_focusedTrailingIconColor = MaterialTheme_instance.unz($composer_24, 6).xnz_1;
          var tmp35_unfocusedTrailingIconColor = MaterialTheme_instance.unz($composer_24, 6).xnz_1;
          var tmp_131 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_132 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_133 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_134 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_135 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_136 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_137 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_138 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_139 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_140 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_141 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_142 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_143 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_144 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_145 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_146 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_147 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_148 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_149 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_150 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_151 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_152 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_153 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_154 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_155 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_156 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_157 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_158 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_159 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_160 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_161 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_162 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_163 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp38_colors = tmp27_$this.np9(tmp28_focusedTextColor, tmp29_unfocusedTextColor, tmp_131, tmp_132, tmp_133, tmp_134, tmp_135, tmp_136, tmp_137, tmp_138, null, tmp30_focusedBorderColor, tmp31_unfocusedBorderColor, tmp_139, tmp_140, tmp_141, tmp_142, tmp_143, tmp_144, tmp34_focusedTrailingIconColor, tmp35_unfocusedTrailingIconColor, tmp_145, tmp_146, tmp32_focusedLabelColor, tmp33_unfocusedLabelColor, tmp_147, tmp_148, tmp_149, tmp_150, tmp_151, tmp_152, tmp_153, tmp_154, tmp_155, tmp_156, tmp_157, tmp_158, tmp_159, tmp_160, tmp_161, tmp_162, tmp_163, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_24, 0, 0, 0, 0, 3072, 2120738812, 4095);
          sourceInformationMarkerStart($composer_24, 1928575354, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_56 = $composer_24.i31();
          var tmp_164;
          if (false || it_56 === Companion_getInstance().f30_1) {
            var value_56 = ProfileScreen$lambda_84;
            $composer_24.j31(value_56);
            tmp_164 = value_56;
          } else {
            tmp_164 = it_56;
          }
          var tmp13_group_0 = tmp_164;
          sourceInformationMarkerEnd($composer_24);
          var tmp_165 = ComposableSingletons$ProfileScreenKt_getInstance().p14a_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver_4 = rememberComposableLambda(1590071960, true, ProfileScreen$lambda_85(locationPicker), $composer_24, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_58 = $composer_24;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_10 = $composer_58.k31(dispatchReceiver_4);
          // Inline function 'kotlin.let' call
          var it_57 = $composer_58.i31();
          var tmp_166;
          if (invalid_10 || it_57 === Companion_getInstance().f30_1) {
            var value_57 = ComposableLambda$invoke$ref(dispatchReceiver_4);
            $composer_58.j31(value_57);
            tmp_166 = value_57;
          } else {
            tmp_166 = it_57;
          }
          var tmp_167 = tmp_166;
          OutlinedTextField(tmp36_value, tmp13_group_0, tmp37_modifier, false, true, null, tmp_165, null, null, tmp_167, null, null, null, false, null, null, null, false, 0, 0, null, null, tmp38_colors, $composer_24, 806903856, 0, 0, 4193704);
          $composer_24.n30();
        } else {
          $composer_24.m30(-341870162);
          sourceInformation($composer_24, '594@32929L43,597@33161L20,593@32872L309,599@33267L42,602@33497L20,598@33210L307,604@33603L38,607@33825L31,603@33546L310,609@33942L41,612@34178L20,608@33885L313,629@35350L49,632@35621L20,628@35293L348,634@35727L56,638@36017L20,633@35670L367,640@36123L43,644@36395L20,639@36066L349,646@36501L50,651@36901L136,645@36444L593');
          var tmp_168 = stringResource(get_first_name_label(string_instance), $composer_24, 0);
          var tmp39_elvis_lhs = profile.wym_1;
          var tmp_169;
          if (tmp39_elvis_lhs == null) {
            $composer_24.m30(1928636569);
            sourceInformation($composer_24, '595@33035L34');
            var tmp14_group_0 = stringResource(get_not_set(string_instance), $composer_24, 0);
            $composer_24.n30();
            tmp_169 = tmp14_group_0;
          } else {
            $composer_24.m30(1928635918);
            $composer_24.n30();
            tmp_169 = tmp39_elvis_lhs;
          }
          var tmp_170 = tmp_169;
          var tmp_171 = get_Person(Icons_getInstance().dxv_1);
          sourceInformationMarkerStart($composer_24, 1928640587, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_58 = $composer_24.i31();
          var tmp_172;
          if (false || it_58 === Companion_getInstance().f30_1) {
            var value_58 = ProfileScreen$lambda_86(isEditing$delegate);
            $composer_24.j31(value_58);
            tmp_172 = value_58;
          } else {
            tmp_172 = it_58;
          }
          var tmp15_group_0 = tmp_172;
          sourceInformationMarkerEnd($composer_24);
          ProfileInfoItem(tmp_168, tmp_170, tmp_171, tmp15_group_0, $composer_24, 3072);
          var tmp_173 = stringResource(get_last_name_label(string_instance), $composer_24, 0);
          var tmp40_elvis_lhs = profile.xym_1;
          var tmp_174;
          if (tmp40_elvis_lhs == null) {
            $composer_24.m30(1928647321);
            sourceInformation($composer_24, '600@33371L34');
            var tmp16_group_0 = stringResource(get_not_set(string_instance), $composer_24, 0);
            $composer_24.n30();
            tmp_174 = tmp16_group_0;
          } else {
            $composer_24.m30(1928646701);
            $composer_24.n30();
            tmp_174 = tmp40_elvis_lhs;
          }
          var tmp_175 = tmp_174;
          var tmp_176 = get_Person(Icons_getInstance().dxv_1);
          sourceInformationMarkerStart($composer_24, 1928651339, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_59 = $composer_24.i31();
          var tmp_177;
          if (false || it_59 === Companion_getInstance().f30_1) {
            var value_59 = ProfileScreen$lambda_87(isEditing$delegate);
            $composer_24.j31(value_59);
            tmp_177 = value_59;
          } else {
            tmp_177 = it_59;
          }
          var tmp17_group_0 = tmp_177;
          sourceInformationMarkerEnd($composer_24);
          ProfileInfoItem(tmp_173, tmp_175, tmp_176, tmp17_group_0, $composer_24, 3072);
          var tmp_178 = stringResource(get_email_label(string_instance), $composer_24, 0);
          var tmp41_elvis_lhs = profile.vym_1;
          var tmp_179;
          if (tmp41_elvis_lhs == null) {
            $composer_24.m30(1928657849);
            sourceInformation($composer_24, '605@33700L34');
            var tmp18_group_0 = stringResource(get_not_set(string_instance), $composer_24, 0);
            $composer_24.n30();
            tmp_179 = tmp18_group_0;
          } else {
            $composer_24.m30(1928657322);
            $composer_24.n30();
            tmp_179 = tmp41_elvis_lhs;
          }
          var tmp_180 = tmp_179;
          var tmp_181 = get_Email(Icons_getInstance().dxv_1);
          sourceInformationMarkerStart($composer_24, 1928661846, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_60 = $composer_24.i31();
          var tmp_182;
          if (false || it_60 === Companion_getInstance().f30_1) {
            var value_60 = ProfileScreen$lambda_88;
            $composer_24.j31(value_60);
            tmp_182 = value_60;
          } else {
            tmp_182 = it_60;
          }
          var tmp19_group_0 = tmp_182;
          sourceInformationMarkerEnd($composer_24);
          ProfileInfoItem(tmp_178, tmp_180, tmp_181, tmp19_group_0, $composer_24, 3072);
          var tmp_183 = stringResource(get_birthday_label(string_instance), $composer_24, 0);
          var tmp42_elvis_lhs = profile.yym_1;
          var tmp_184;
          if (tmp42_elvis_lhs == null) {
            $composer_24.m30(1928668889);
            sourceInformation($composer_24, '610@34045L34');
            var tmp20_group_0 = stringResource(get_not_set(string_instance), $composer_24, 0);
            $composer_24.n30();
            tmp_184 = tmp20_group_0;
          } else {
            $composer_24.m30(1928668269);
            $composer_24.n30();
            tmp_184 = tmp42_elvis_lhs;
          }
          var tmp_185 = tmp_184;
          var tmp_186 = get_CalendarToday(Icons_getInstance().dxv_1);
          sourceInformationMarkerStart($composer_24, 1928673131, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_61 = $composer_24.i31();
          var tmp_187;
          if (false || it_61 === Companion_getInstance().f30_1) {
            var value_61 = ProfileScreen$lambda_89(isEditing$delegate);
            $composer_24.j31(value_61);
            tmp_187 = value_61;
          } else {
            tmp_187 = it_61;
          }
          var tmp21_group_0 = tmp_187;
          sourceInformationMarkerEnd($composer_24);
          ProfileInfoItem(tmp_183, tmp_185, tmp_186, tmp21_group_0, $composer_24, 3072);
          // Inline function 'kotlin.text.buildString' call
          // Inline function 'kotlin.apply' call
          var this_36 = StringBuilder_init_$Create$();
          // Inline function 'kotlin.text.isNullOrBlank' call
          var this_37 = profile.zym_1;
          if (!(this_37 == null || isBlank(this_37))) {
            this_36.q(profile.zym_1 + ' ');
          }
          // Inline function 'kotlin.text.isNullOrBlank' call
          var this_38 = profile.ayn_1;
          if (!(this_38 == null || isBlank(this_38))) {
            this_36.q(profile.ayn_1 + ' ');
          }
          // Inline function 'kotlin.text.isNullOrBlank' call
          var this_39 = profile.byn_1;
          if (!(this_39 == null || isBlank(this_39))) {
            this_36.q(profile.byn_1 + ' ');
          }
          // Inline function 'kotlin.text.isNullOrBlank' call
          var this_40 = profile.cyn_1;
          if (!(this_40 == null || isBlank(this_40))) {
            // Inline function 'kotlin.collections.find' call
            var tmp0_11 = get_governorates();
            var tmp$ret$372;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0_11.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (element.l11r_1 === profile.cyn_1) {
                  tmp$ret$372 = element;
                  break $l$block;
                }
              }
              tmp$ret$372 = null;
            }
            var tmp0_safe_receiver_0 = tmp$ret$372;
            var tmp_188;
            if (tmp0_safe_receiver_0 == null) {
              tmp_188 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_188 = ProfileScreen$lambda_0(currentLanguage$delegate) === 'ar' ? tmp0_safe_receiver_0.m11r_1 : tmp0_safe_receiver_0.l11r_1;
            }
            var tmp1_elvis_lhs = tmp_188;
            var cityName = tmp1_elvis_lhs == null ? profile.cyn_1 : tmp1_elvis_lhs;
            this_36.q(cityName + ' ');
          }
          // Inline function 'kotlin.text.isNullOrBlank' call
          var this_41 = profile.dyn_1;
          if (!(this_41 == null || isBlank(this_41))) {
            this_36.q(profile.dyn_1);
          }
          // Inline function 'kotlin.text.trim' call
          var this_42 = this_36.toString();
          var displayAddress = toString(trim(isCharSequence(this_42) ? this_42 : THROW_CCE()));
          var tmp_189 = stringResource(get_address_label_required(string_instance), $composer_24, 0);
          var tmp_190;
          if (isBlank(displayAddress)) {
            $composer_24.m30(1928714521);
            sourceInformation($composer_24, '630@35471L34');
            var tmp22_group_0 = stringResource(get_not_set(string_instance), $composer_24, 0);
            $composer_24.n30();
            tmp_190 = tmp22_group_0;
          } else {
            $composer_24.m30(1928715781);
            $composer_24.n30();
            tmp_190 = displayAddress;
          }
          var tmp_191 = tmp_190;
          var tmp_192 = get_LocationOn(Icons_getInstance().dxv_1);
          sourceInformationMarkerStart($composer_24, 1928719307, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_62 = $composer_24.i31();
          var tmp_193;
          if (false || it_62 === Companion_getInstance().f30_1) {
            var value_62 = ProfileScreen$lambda_90(isEditing$delegate);
            $composer_24.j31(value_62);
            tmp_193 = value_62;
          } else {
            tmp_193 = it_62;
          }
          var tmp23_group_0 = tmp_193;
          sourceInformationMarkerEnd($composer_24);
          ProfileInfoItem(tmp_189, tmp_191, tmp_192, tmp23_group_0, $composer_24, 3072);
          var tmp_194 = stringResource(get_phone_personal_label_required(string_instance), $composer_24, 0);
          var tmp43_elvis_lhs = profile.gyn_1;
          var tmp_195;
          if (tmp43_elvis_lhs == null) {
            $composer_24.m30(1928727993);
            sourceInformation($composer_24, '636@35892L34');
            var tmp24_group_0 = stringResource(get_not_set(string_instance), $composer_24, 0);
            $composer_24.n30();
            tmp_195 = tmp24_group_0;
          } else {
            $composer_24.m30(1928725916);
            $composer_24.n30();
            tmp_195 = tmp43_elvis_lhs;
          }
          var tmp_196 = tmp_195;
          var tmp_197 = get_Phone(Icons_getInstance().dxv_1);
          sourceInformationMarkerStart($composer_24, 1928731979, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_63 = $composer_24.i31();
          var tmp_198;
          if (false || it_63 === Companion_getInstance().f30_1) {
            var value_63 = ProfileScreen$lambda_91(isEditing$delegate);
            $composer_24.j31(value_63);
            tmp_198 = value_63;
          } else {
            tmp_198 = it_63;
          }
          var tmp25_group_0 = tmp_198;
          sourceInformationMarkerEnd($composer_24);
          ProfileInfoItem(tmp_194, tmp_196, tmp_197, tmp25_group_0, $composer_24, 3072);
          var tmp_199 = stringResource(get_phone_work_label(string_instance), $composer_24, 0);
          var tmp44_elvis_lhs = profile.hyn_1;
          var tmp_200;
          if (tmp44_elvis_lhs == null) {
            $composer_24.m30(1928740121);
            sourceInformation($composer_24, '642@36271L34');
            var tmp26_group_0 = stringResource(get_not_set(string_instance), $composer_24, 0);
            $composer_24.n30();
            tmp_200 = tmp26_group_0;
          } else {
            $composer_24.m30(1928738168);
            $composer_24.n30();
            tmp_200 = tmp44_elvis_lhs;
          }
          var tmp_201 = tmp_200;
          var tmp_202 = get_Work(Icons_getInstance().dxv_1);
          sourceInformationMarkerStart($composer_24, 1928744075, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_64 = $composer_24.i31();
          var tmp_203;
          if (false || it_64 === Companion_getInstance().f30_1) {
            var value_64 = ProfileScreen$lambda_92(isEditing$delegate);
            $composer_24.j31(value_64);
            tmp_203 = value_64;
          } else {
            tmp_203 = it_64;
          }
          var tmp27_group_0 = tmp_203;
          sourceInformationMarkerEnd($composer_24);
          ProfileInfoItem(tmp_199, tmp_201, tmp_202, tmp27_group_0, $composer_24, 3072);
          var tmp_204 = stringResource(get_location_lat_long_label(string_instance), $composer_24, 0);
          var tmp_205;
          if (!(profile.iyn_1 == null) && !(profile.jyn_1 == null)) {
            $composer_24.m30(1928752322);
            $composer_24.n30();
            tmp_205 = '' + profile.iyn_1 + ', ' + profile.jyn_1;
          } else {
            $composer_24.m30(1928753951);
            sourceInformation($composer_24, '647@36701L104');
            var tmp28_group_0 = stringResource(get_not_set(string_instance), $composer_24, 0);
            $composer_24.n30();
            tmp_205 = tmp28_group_0;
          }
          var tmp_206 = tmp_205;
          var tmp_207 = get_MyLocation(Icons_getInstance().dxv_1);
          sourceInformationMarkerStart($composer_24, 1928760383, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_11 = $composer_24.q31(locationPicker);
          // Inline function 'kotlin.let' call
          var it_65 = $composer_24.i31();
          var tmp_208;
          if (invalid_11 || it_65 === Companion_getInstance().f30_1) {
            var value_65 = ProfileScreen$lambda_93(locationPicker, isEditing$delegate);
            $composer_24.j31(value_65);
            tmp_208 = value_65;
          } else {
            tmp_208 = it_65;
          }
          var tmp29_group_0 = tmp_208;
          sourceInformationMarkerEnd($composer_24);
          ProfileInfoItem(tmp_204, tmp_206, tmp_207, tmp29_group_0, $composer_24, 0);
          $composer_24.n30();
        }
        var tmp_209 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$394 = _Dp___init__impl__ms3zkb(32);
        Spacer(height(tmp_209, tmp$ret$394), $composer_24, 6);
        var tmp_210 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$395 = _Dp___init__impl__ms3zkb(12);
        var tmp_211 = RoundedCornerShape(tmp$ret$395);
        var tmp_212 = ButtonDefaults_getInstance();
        var tmp_213 = MaterialTheme_instance.unz($composer_24, 6).co0_1;
        var tmp_214 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_215 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_216 = tmp_212.ao9(tmp_213, tmp_214, tmp_215, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_24, 24576, 14);
        Button(onNavigateToOrderHistory, tmp_210, false, tmp_211, tmp_216, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().r14a_1, $composer_24, 805306416 | 14 & $dirty >> 9, 484);
        var tmp_217 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$396 = _Dp___init__impl__ms3zkb(12);
        Spacer(height(tmp_217, tmp$ret$396), $composer_24, 6);
        var tmp_218 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$397 = _Dp___init__impl__ms3zkb(12);
        var tmp_219 = RoundedCornerShape(tmp$ret$397);
        var tmp_220 = ButtonDefaults_getInstance();
        var tmp_221 = MaterialTheme_instance.unz($composer_24, 6).go0_1;
        var tmp_222 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_223 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_224 = tmp_220.ao9(tmp_221, tmp_222, tmp_223, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_24, 24576, 14);
        Button(onNavigateToFavorites, tmp_218, false, tmp_219, tmp_224, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().s14a_1, $composer_24, 805306416 | 14 & $dirty >> 12, 484);
        var tmp_225 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$398 = _Dp___init__impl__ms3zkb(12);
        Spacer(height(tmp_225, tmp$ret$398), $composer_24, 6);
        var tmp_226 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$399 = _Dp___init__impl__ms3zkb(12);
        var tmp_227 = RoundedCornerShape(tmp$ret$399);
        var tmp_228 = ButtonDefaults_getInstance();
        var tmp_229 = MaterialTheme_instance.unz($composer_24, 6).io0_1;
        var tmp_230 = MaterialTheme_instance.unz($composer_24, 6).jo0_1;
        var tmp_231 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_232 = tmp_228.ao9(tmp_229, tmp_230, tmp_231, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_24, 24576, 12);
        Button(onNavigateToStockReminders, tmp_226, false, tmp_227, tmp_232, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().t14a_1, $composer_24, 805306416 | 14 & $dirty >> 18, 484);
        var tmp_233 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$400 = _Dp___init__impl__ms3zkb(12);
        Spacer(height(tmp_233, tmp$ret$400), $composer_24, 6);
        var tmp_234 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$401 = _Dp___init__impl__ms3zkb(12);
        var tmp_235 = RoundedCornerShape(tmp$ret$401);
        var tmp_236 = ButtonDefaults_getInstance();
        var tmp_237 = MaterialTheme_instance.unz($composer_24, 6).znz_1;
        var tmp_238 = MaterialTheme_instance.unz($composer_24, 6).ao0_1;
        var tmp_239 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_240 = tmp_236.ao9(tmp_237, tmp_238, tmp_239, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_24, 24576, 12);
        Button(onNavigateToCoupons, tmp_234, false, tmp_235, tmp_240, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().u14a_1, $composer_24, 805306416 | 14 & $dirty >> 15, 484);
        var tmp_241 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$402 = _Dp___init__impl__ms3zkb(12);
        Spacer(height(tmp_241, tmp$ret$402), $composer_24, 6);
        sourceInformationMarkerStart($composer_24, 1928870068, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_66 = $composer_24.i31();
        var tmp_242;
        if (false || it_66 === Companion_getInstance().f30_1) {
          var value_66 = ProfileScreen$lambda_94(showLanguageDialog$delegate);
          $composer_24.j31(value_66);
          tmp_242 = value_66;
        } else {
          tmp_242 = it_66;
        }
        var tmp30_group_0 = tmp_242;
        sourceInformationMarkerEnd($composer_24);
        var tmp_243 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$407 = _Dp___init__impl__ms3zkb(12);
        var tmp_244 = RoundedCornerShape(tmp$ret$407);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_5 = rememberComposableLambda(-1309798491, true, ProfileScreen$lambda_95(currentLanguage$delegate), $composer_24, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_59 = $composer_24;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_12 = $composer_59.k31(dispatchReceiver_5);
        // Inline function 'kotlin.let' call
        var it_67 = $composer_59.i31();
        var tmp_245;
        if (invalid_12 || it_67 === Companion_getInstance().f30_1) {
          var value_67 = ComposableLambda$invoke$ref_1(dispatchReceiver_5);
          $composer_59.j31(value_67);
          tmp_245 = value_67;
        } else {
          tmp_245 = it_67;
        }
        var tmp$ret$408 = tmp_245;
        OutlinedButton(tmp30_group_0, tmp_243, false, tmp_244, null, null, null, null, null, tmp$ret$408, $composer_24, 805306422, 500);
        var tmp_246 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$415 = _Dp___init__impl__ms3zkb(12);
        Spacer(height(tmp_246, tmp$ret$415), $composer_24, 6);
        sourceInformationMarkerStart($composer_24, 1928895551, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_68 = $composer_24.i31();
        var tmp_247;
        if (false || it_68 === Companion_getInstance().f30_1) {
          var value_68 = ProfileScreen$lambda_96;
          $composer_24.j31(value_68);
          tmp_247 = value_68;
        } else {
          tmp_247 = it_68;
        }
        var tmp31_group_0 = tmp_247;
        sourceInformationMarkerEnd($composer_24);
        var tmp_248 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$420 = _Dp___init__impl__ms3zkb(12);
        var tmp_249 = RoundedCornerShape(tmp$ret$420);
        OutlinedButton(tmp31_group_0, tmp_248, false, tmp_249, null, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().v14a_1, $composer_24, 805306422, 500);
        var tmp_250 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$421 = _Dp___init__impl__ms3zkb(12);
        Spacer(height(tmp_250, tmp$ret$421), $composer_24, 6);
        var tmp_251 = onNavigateToAccountManagement_0._v;
        var tmp_252 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$422 = _Dp___init__impl__ms3zkb(12);
        var tmp_253 = RoundedCornerShape(tmp$ret$422);
        OutlinedButton(tmp_251, tmp_252, false, tmp_253, null, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().w14a_1, $composer_24, 805306416 | 14 & $dirty >> 21, 500);
        var tmp_254 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$423 = _Dp___init__impl__ms3zkb(12);
        Spacer(height(tmp_254, tmp$ret$423), $composer_24, 6);
        if (profile.tyn_1 === 'email') {
          $composer_24.m30(-332598682);
          sourceInformation($composer_24, '760@42380L207,759@42322L703,773@43055L41,775@43126L41');
          sourceInformationMarkerStart($composer_24, 1928935782, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_69 = $composer_24.i31();
          var tmp_255;
          if (false || it_69 === Companion_getInstance().f30_1) {
            var value_69 = ProfileScreen$lambda_97(newPassword$delegate, confirmPassword$delegate, showPasswordDialog$delegate);
            $composer_24.j31(value_69);
            tmp_255 = value_69;
          } else {
            tmp_255 = it_69;
          }
          var tmp32_group_0 = tmp_255;
          sourceInformationMarkerEnd($composer_24);
          var tmp_256 = fillMaxWidth(Companion_instance);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$428 = _Dp___init__impl__ms3zkb(12);
          var tmp_257 = RoundedCornerShape(tmp$ret$428);
          OutlinedButton(tmp32_group_0, tmp_256, false, tmp_257, null, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().x14a_1, $composer_24, 805306422, 500);
          var tmp_258 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$429 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_258, tmp$ret$429), $composer_24, 6);
          var tmp_259 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$430 = _Dp___init__impl__ms3zkb(12);
          Spacer(height(tmp_259, tmp$ret$430), $composer_24, 6);
          $composer_24.n30();
        } else {
          $composer_24.m30(-331732821);
          $composer_24.n30();
        }
        sourceInformationMarkerStart($composer_24, 1928964178, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_70 = $composer_24.i31();
        var tmp_260;
        if (false || it_70 === Companion_getInstance().f30_1) {
          var value_70 = ProfileScreen$lambda_98(showDeleteDialog$delegate);
          $composer_24.j31(value_70);
          tmp_260 = value_70;
        } else {
          tmp_260 = it_70;
        }
        var tmp33_group_0 = tmp_260;
        sourceInformationMarkerEnd($composer_24);
        var tmp_261 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$435 = _Dp___init__impl__ms3zkb(12);
        var tmp_262 = RoundedCornerShape(tmp$ret$435);
        var tmp_263 = ButtonDefaults_getInstance();
        var tmp_264 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_265 = MaterialTheme_instance.unz($composer_24, 6).to0_1;
        var tmp_266 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_267 = tmp_263.pob(tmp_264, tmp_265, tmp_266, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_24, 24576, 13);
        OutlinedButton(tmp33_group_0, tmp_261, false, tmp_262, tmp_267, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().y14a_1, $composer_24, 805306422, 484);
        var tmp_268 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$436 = _Dp___init__impl__ms3zkb(12);
        Spacer(height(tmp_268, tmp$ret$436), $composer_24, 6);
        sourceInformationMarkerStart($composer_24, 1928986867, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_13 = !!(!!($composer_0.q31(scope_0) | $composer_0.q31(authRepository)) | ($dirty & 112) === 32);
        // Inline function 'kotlin.let' call
        var it_71 = $composer_24.i31();
        var tmp_269;
        if (invalid_13 || it_71 === Companion_getInstance().f30_1) {
          var value_71 = ProfileScreen$lambda_99(scope_0, authRepository, onLogout);
          $composer_24.j31(value_71);
          tmp_269 = value_71;
        } else {
          tmp_269 = it_71;
        }
        var tmp34_group_0 = tmp_269;
        sourceInformationMarkerEnd($composer_24);
        var tmp_270 = fillMaxWidth(Companion_instance);
        TextButton(tmp34_group_0, tmp_270, false, null, null, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().z14a_1, $composer_24, 805306416, 508);
        var tmp_271 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$441 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_271, tmp$ret$441), $composer_24, 6);
        var tmp_272 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$442 = _Dp___init__impl__ms3zkb(24);
        var tmp_273 = padding_2(tmp_272, tmp$ret$442);
        var tmp_274 = _Dp___init__impl__ms3zkb(0.0);
        HorizontalDivider(tmp_273, tmp_274, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_24, 6, 6);
        var tmp_275 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$443 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_275, tmp$ret$443), $composer_24, 6);
        var tmp_276 = profile.tyn_1 === 'email';
        sourceInformationMarkerStart($composer_24, 1929016886, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_14 = $composer_24.k31(profile);
        // Inline function 'kotlin.let' call
        var it_72 = $composer_24.i31();
        var tmp_277;
        if (invalid_14 || it_72 === Companion_getInstance().f30_1) {
          var value_72 = ProfileScreen$lambda_100(profile, resetEmail$delegate, showResetPasswordDialog$delegate);
          $composer_24.j31(value_72);
          tmp_277 = value_72;
        } else {
          tmp_277 = it_72;
        }
        var tmp35_group = tmp_277;
        sourceInformationMarkerEnd($composer_24);
        ContactUsSection(null, null, null, tmp_276, tmp35_group, false, null, !ProfileScreen$lambda_24(isResettingPassword$delegate), $composer_24, 0, 103);
        var tmp_278 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$448 = _Dp___init__impl__ms3zkb(24);
        Spacer(height(tmp_278, tmp$ret$448), $composer_24, 6);
        sourceInformationMarkerEnd($composer_24);
        $composer_22.e31();
        sourceInformationMarkerEnd($composer_19);
        $composer_17.e31();
        $composer_12.n30();
      }
      sourceInformationMarkerEnd($composer_12);
      $composer_10.e31();
      var tmp_279 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(snackbarHostState, tmp_279, null, $composer_7, 6, 4);
      sourceInformationMarkerEnd($composer_7);
      $composer_5.e31();
      if (ProfileScreen$lambda_60(showDatePicker$delegate)) {
        $composer_0.m30(-385472674);
        sourceInformation($composer_0, '830@45510L26,830@45554L498,842@46070L144,846@46216L59,830@45474L801');
        sourceInformationMarkerStart($composer_0, -1675001907, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_43 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_73 = this_43.i31();
        var tmp_280;
        if (false || it_73 === Companion_getInstance().f30_1) {
          var value_73 = ProfileScreen$lambda_101(showDatePicker$delegate);
          this_43.j31(value_73);
          tmp_280 = value_73;
        } else {
          tmp_280 = it_73;
        }
        var tmp35_group_0 = tmp_280;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_6 = rememberComposableLambda(1834336166, true, ProfileScreen$lambda_102(datePickerState, editBirthday$delegate, showDatePicker$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_60 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_15 = $composer_60.k31(dispatchReceiver_6);
        // Inline function 'kotlin.let' call
        var it_74 = $composer_60.i31();
        var tmp_281;
        if (invalid_15 || it_74 === Companion_getInstance().f30_1) {
          var value_74 = ComposableLambda$invoke$ref(dispatchReceiver_6);
          $composer_60.j31(value_74);
          tmp_281 = value_74;
        } else {
          tmp_281 = it_74;
        }
        var tmp_282 = tmp_281;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_7 = rememberComposableLambda(966408804, true, ProfileScreen$lambda_103(showDatePicker$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_61 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_16 = $composer_61.k31(dispatchReceiver_7);
        // Inline function 'kotlin.let' call
        var it_75 = $composer_61.i31();
        var tmp_283;
        if (invalid_16 || it_75 === Companion_getInstance().f30_1) {
          var value_75 = ComposableLambda$invoke$ref(dispatchReceiver_7);
          $composer_61.j31(value_75);
          tmp_283 = value_75;
        } else {
          tmp_283 = it_75;
        }
        var tmp_284 = tmp_283;
        var tmp_285 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_8 = rememberComposableLambda(250229679, true, ProfileScreen$lambda_104(datePickerState), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_62 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_17 = $composer_62.k31(dispatchReceiver_8);
        // Inline function 'kotlin.let' call
        var it_76 = $composer_62.i31();
        var tmp_286;
        if (invalid_17 || it_76 === Companion_getInstance().f30_1) {
          var value_76 = ComposableLambda$invoke$ref_6(dispatchReceiver_8);
          $composer_62.j31(value_76);
          tmp_286 = value_76;
        } else {
          tmp_286 = it_76;
        }
        var tmp$ret$467 = tmp_286;
        DatePickerDialog(tmp35_group_0, tmp_282, null, tmp_284, null, tmp_285, null, null, tmp$ret$467, $composer_0, 100666422, 244);
        $composer_0.n30();
      } else {
        $composer_0.m30(-384687537);
        $composer_0.n30();
      }
      if (ProfileScreen$lambda_2(showDeleteDialog$delegate)) {
        $composer_0.m30(-384540194);
        sourceInformation($composer_0, '855@46452L52,886@48303L1460,919@49793L366,857@46602L1671,854@46408L3752');
        var provider = profile == null ? null : profile.tyn_1;
        var isGoogleUser = provider === 'google';
        sourceInformationMarkerStart($composer_0, -1674971737, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_44 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_77 = this_44.i31();
        var tmp_287;
        if (false || it_77 === Companion_getInstance().f30_1) {
          var value_77 = ProfileScreen$lambda_105(isDeletingAccount$delegate, showDeleteDialog$delegate);
          this_44.j31(value_77);
          tmp_287 = value_77;
        } else {
          tmp_287 = it_77;
        }
        var tmp36_group = tmp_287;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_9 = rememberComposableLambda(-494406487, true, ProfileScreen$lambda_106(isGoogleUser, profile, scope_0, authRepository, onLogout, delete_account_failed, deleteEmailConfirm$delegate, deletePassword$delegate, isDeletingAccount$delegate, snackbarHostState, showDeleteDialog$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_63 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_18 = $composer_63.k31(dispatchReceiver_9);
        // Inline function 'kotlin.let' call
        var it_78 = $composer_63.i31();
        var tmp_288;
        if (invalid_18 || it_78 === Companion_getInstance().f30_1) {
          var value_78 = ComposableLambda$invoke$ref(dispatchReceiver_9);
          $composer_63.j31(value_78);
          tmp_288 = value_78;
        } else {
          tmp_288 = it_78;
        }
        var tmp_289 = tmp_288;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_10 = rememberComposableLambda(1832755883, true, ProfileScreen$lambda_107(deletePassword$delegate, deleteEmailConfirm$delegate, showDeleteDialog$delegate, isDeletingAccount$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_64 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_19 = $composer_64.k31(dispatchReceiver_10);
        // Inline function 'kotlin.let' call
        var it_79 = $composer_64.i31();
        var tmp_290;
        if (invalid_19 || it_79 === Companion_getInstance().f30_1) {
          var value_79 = ComposableLambda$invoke$ref(dispatchReceiver_10);
          $composer_64.j31(value_79);
          tmp_290 = value_79;
        } else {
          tmp_290 = it_79;
        }
        var tmp_291 = tmp_290;
        var tmp_292 = ComposableSingletons$ProfileScreenKt_getInstance().d14b_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_11 = rememberComposableLambda(1028532142, true, ProfileScreen$lambda_108(isGoogleUser, profile, deletePassword$delegate, isDeletingAccount$delegate, deleteEmailConfirm$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_65 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_20 = $composer_65.k31(dispatchReceiver_11);
        // Inline function 'kotlin.let' call
        var it_80 = $composer_65.i31();
        var tmp_293;
        if (invalid_20 || it_80 === Companion_getInstance().f30_1) {
          var value_80 = ComposableLambda$invoke$ref(dispatchReceiver_11);
          $composer_65.j31(value_80);
          tmp_293 = value_80;
        } else {
          tmp_293 = it_80;
        }
        var tmp_294 = tmp_293;
        var tmp_295 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_296 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_297 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_298 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_299 = _Dp___init__impl__ms3zkb(0.0);
        AlertDialog(tmp36_group, tmp_289, null, tmp_291, null, tmp_292, tmp_294, null, tmp_295, tmp_296, tmp_297, tmp_298, tmp_299, null, $composer_0, 1772598, 0, 16276);
        $composer_0.n30();
      } else {
        $composer_0.m30(-380833617);
        $composer_0.n30();
      }
      if (ProfileScreen$lambda_4(showDeleteAvatarDialog$delegate)) {
        $composer_0.m30(-380769819);
        sourceInformation($composer_0, '934@50254L34,937@50469L487,950@50986L168,933@50210L954');
        sourceInformationMarkerStart($composer_0, -1674850091, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_45 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_81 = this_45.i31();
        var tmp_300;
        if (false || it_81 === Companion_getInstance().f30_1) {
          var value_81 = ProfileScreen$lambda_109(showDeleteAvatarDialog$delegate);
          this_45.j31(value_81);
          tmp_300 = value_81;
        } else {
          tmp_300 = it_81;
        }
        var tmp37_group = tmp_300;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_12 = rememberComposableLambda(-1178636792, true, ProfileScreen$lambda_110(scope_0, authRepository, showDeleteAvatarDialog$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_66 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_21 = $composer_66.k31(dispatchReceiver_12);
        // Inline function 'kotlin.let' call
        var it_82 = $composer_66.i31();
        var tmp_301;
        if (invalid_21 || it_82 === Companion_getInstance().f30_1) {
          var value_82 = ComposableLambda$invoke$ref(dispatchReceiver_12);
          $composer_66.j31(value_82);
          tmp_301 = value_82;
        } else {
          tmp_301 = it_82;
        }
        var tmp_302 = tmp_301;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_13 = rememberComposableLambda(1148525578, true, ProfileScreen$lambda_111(showDeleteAvatarDialog$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_67 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_22 = $composer_67.k31(dispatchReceiver_13);
        // Inline function 'kotlin.let' call
        var it_83 = $composer_67.i31();
        var tmp_303;
        if (invalid_22 || it_83 === Companion_getInstance().f30_1) {
          var value_83 = ComposableLambda$invoke$ref(dispatchReceiver_13);
          $composer_67.j31(value_83);
          tmp_303 = value_83;
        } else {
          tmp_303 = it_83;
        }
        var tmp_304 = tmp_303;
        var tmp_305 = ComposableSingletons$ProfileScreenKt_getInstance().i14b_1;
        var tmp_306 = ComposableSingletons$ProfileScreenKt_getInstance().j14b_1;
        var tmp_307 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_308 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_309 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_310 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_311 = _Dp___init__impl__ms3zkb(0.0);
        AlertDialog(tmp37_group, tmp_302, null, tmp_304, null, tmp_305, tmp_306, null, tmp_307, tmp_308, tmp_309, tmp_310, tmp_311, null, $composer_0, 1772598, 0, 16276);
        $composer_0.n30();
      } else {
        $composer_0.m30(-379837649);
        $composer_0.n30();
      }
      if (ProfileScreen$lambda_6(showPasswordDialog$delegate)) {
        $composer_0.m30(-379701838);
        sourceInformation($composer_0, '960@51254L55,984@52690L1661,1019@54381L233,962@51408L1252,959@51210L3405');
        sourceInformationMarkerStart($composer_0, -1674818070, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_46 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_84 = this_46.i31();
        var tmp_312;
        if (false || it_84 === Companion_getInstance().f30_1) {
          var value_84 = ProfileScreen$lambda_112(isUpdatingPassword$delegate, showPasswordDialog$delegate);
          this_46.j31(value_84);
          tmp_312 = value_84;
        } else {
          tmp_312 = it_84;
        }
        var tmp38_group = tmp_312;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_14 = rememberComposableLambda(-1862867097, true, ProfileScreen$lambda_113(scope_0, password_length_error, passwords_dont_match, authRepository, password_updated, failed_to_update_password, newPassword$delegate, snackbarHostState, confirmPassword$delegate, isUpdatingPassword$delegate, showPasswordDialog$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_68 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_23 = $composer_68.k31(dispatchReceiver_14);
        // Inline function 'kotlin.let' call
        var it_85 = $composer_68.i31();
        var tmp_313;
        if (invalid_23 || it_85 === Companion_getInstance().f30_1) {
          var value_85 = ComposableLambda$invoke$ref(dispatchReceiver_14);
          $composer_68.j31(value_85);
          tmp_313 = value_85;
        } else {
          tmp_313 = it_85;
        }
        var tmp_314 = tmp_313;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_15 = rememberComposableLambda(464295273, true, ProfileScreen$lambda_114(showPasswordDialog$delegate, isUpdatingPassword$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_69 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_24 = $composer_69.k31(dispatchReceiver_15);
        // Inline function 'kotlin.let' call
        var it_86 = $composer_69.i31();
        var tmp_315;
        if (invalid_24 || it_86 === Companion_getInstance().f30_1) {
          var value_86 = ComposableLambda$invoke$ref(dispatchReceiver_15);
          $composer_69.j31(value_86);
          tmp_315 = value_86;
        } else {
          tmp_315 = it_86;
        }
        var tmp_316 = tmp_315;
        var tmp_317 = ComposableSingletons$ProfileScreenKt_getInstance().l14b_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_16 = rememberComposableLambda(-339928468, true, ProfileScreen$lambda_115(newPassword$delegate, confirmPassword$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_70 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_25 = $composer_70.k31(dispatchReceiver_16);
        // Inline function 'kotlin.let' call
        var it_87 = $composer_70.i31();
        var tmp_318;
        if (invalid_25 || it_87 === Companion_getInstance().f30_1) {
          var value_87 = ComposableLambda$invoke$ref(dispatchReceiver_16);
          $composer_70.j31(value_87);
          tmp_318 = value_87;
        } else {
          tmp_318 = it_87;
        }
        var tmp_319 = tmp_318;
        var tmp_320 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_321 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_322 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_323 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_324 = _Dp___init__impl__ms3zkb(0.0);
        AlertDialog(tmp38_group, tmp_314, null, tmp_316, null, tmp_317, tmp_319, null, tmp_320, tmp_321, tmp_322, tmp_323, tmp_324, null, $composer_0, 1772598, 0, 16276);
        $composer_0.n30();
      } else {
        $composer_0.m30(-376414257);
        $composer_0.n30();
      }
      if (ProfileScreen$lambda_8(showResetPasswordDialog$delegate)) {
        $composer_0.m30(-376292644);
        sourceInformation($composer_0, '1030@54710L61,1046@55582L1601,1081@57213L239,1032@54865L687,1029@54666L2787');
        sourceInformationMarkerStart($composer_0, -1674707472, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_47 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_88 = this_47.i31();
        var tmp_325;
        if (false || it_88 === Companion_getInstance().f30_1) {
          var value_88 = ProfileScreen$lambda_116(isResettingPassword$delegate, showResetPasswordDialog$delegate);
          this_47.j31(value_88);
          tmp_325 = value_88;
        } else {
          tmp_325 = it_88;
        }
        var tmp39_group = tmp_325;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_17 = rememberComposableLambda(1747869894, true, ProfileScreen$lambda_117(scope_0, authRepository, snackbarHostState, isResettingPassword$delegate, resetEmail$delegate, showResetPasswordDialog$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_71 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_26 = $composer_71.k31(dispatchReceiver_17);
        // Inline function 'kotlin.let' call
        var it_89 = $composer_71.i31();
        var tmp_326;
        if (invalid_26 || it_89 === Companion_getInstance().f30_1) {
          var value_89 = ComposableLambda$invoke$ref(dispatchReceiver_17);
          $composer_71.j31(value_89);
          tmp_326 = value_89;
        } else {
          tmp_326 = it_89;
        }
        var tmp_327 = tmp_326;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_18 = rememberComposableLambda(-219935032, true, ProfileScreen$lambda_118(showResetPasswordDialog$delegate, isResettingPassword$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_72 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_27 = $composer_72.k31(dispatchReceiver_18);
        // Inline function 'kotlin.let' call
        var it_90 = $composer_72.i31();
        var tmp_328;
        if (invalid_27 || it_90 === Companion_getInstance().f30_1) {
          var value_90 = ComposableLambda$invoke$ref(dispatchReceiver_18);
          $composer_72.j31(value_90);
          tmp_328 = value_90;
        } else {
          tmp_328 = it_90;
        }
        var tmp_329 = tmp_328;
        var tmp_330 = ComposableSingletons$ProfileScreenKt_getInstance().p14b_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_19 = rememberComposableLambda(-1024158773, true, ProfileScreen$lambda_119(resetEmail$delegate, isResettingPassword$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_73 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_28 = $composer_73.k31(dispatchReceiver_19);
        // Inline function 'kotlin.let' call
        var it_91 = $composer_73.i31();
        var tmp_331;
        if (invalid_28 || it_91 === Companion_getInstance().f30_1) {
          var value_91 = ComposableLambda$invoke$ref(dispatchReceiver_19);
          $composer_73.j31(value_91);
          tmp_331 = value_91;
        } else {
          tmp_331 = it_91;
        }
        var tmp_332 = tmp_331;
        var tmp_333 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_334 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_335 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_336 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_337 = _Dp___init__impl__ms3zkb(0.0);
        AlertDialog(tmp39_group, tmp_327, null, tmp_329, null, tmp_330, tmp_332, null, tmp_333, tmp_334, tmp_335, tmp_336, tmp_337, null, $composer_0, 1772598, 0, 16276);
        $composer_0.n30();
      } else {
        $composer_0.m30(-373598961);
        $composer_0.n30();
      }
      if (ProfileScreen$lambda_10(showLanguageDialog$delegate)) {
        $composer_0.m30(-373537550);
        sourceInformation($composer_0, '1092@57543L30,1110@58339L164,1094@57674L635,1091@57499L1005');
        sourceInformationMarkerStart($composer_0, -1674616847, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_48 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_92 = this_48.i31();
        var tmp_338;
        if (false || it_92 === Companion_getInstance().f30_1) {
          var value_92 = ProfileScreen$lambda_120(showLanguageDialog$delegate);
          this_48.j31(value_92);
          tmp_338 = value_92;
        } else {
          tmp_338 = it_92;
        }
        var tmp40_group = tmp_338;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_20 = rememberComposableLambda(1063639589, true, ProfileScreen$lambda_121(showLanguageDialog$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_74 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_29 = $composer_74.k31(dispatchReceiver_20);
        // Inline function 'kotlin.let' call
        var it_93 = $composer_74.i31();
        var tmp_339;
        if (invalid_29 || it_93 === Companion_getInstance().f30_1) {
          var value_93 = ComposableLambda$invoke$ref(dispatchReceiver_20);
          $composer_74.j31(value_93);
          tmp_339 = value_93;
        } else {
          tmp_339 = it_93;
        }
        var tmp_340 = tmp_339;
        var tmp_341 = ComposableSingletons$ProfileScreenKt_getInstance().s14b_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_21 = rememberComposableLambda(-1708389078, true, ProfileScreen$lambda_122(authRepository, currentLanguage$delegate, showLanguageDialog$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_75 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_30 = $composer_75.k31(dispatchReceiver_21);
        // Inline function 'kotlin.let' call
        var it_94 = $composer_75.i31();
        var tmp_342;
        if (invalid_30 || it_94 === Companion_getInstance().f30_1) {
          var value_94 = ComposableLambda$invoke$ref(dispatchReceiver_21);
          $composer_75.j31(value_94);
          tmp_342 = value_94;
        } else {
          tmp_342 = it_94;
        }
        var tmp_343 = tmp_342;
        var tmp_344 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_345 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_346 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_347 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_348 = _Dp___init__impl__ms3zkb(0.0);
        AlertDialog(tmp40_group, tmp_340, null, null, null, tmp_341, tmp_343, null, tmp_344, tmp_345, tmp_346, tmp_347, tmp_348, null, $composer_0, 1769526, 0, 16284);
        $composer_0.n30();
      } else {
        $composer_0.m30(-372556369);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp41_safe_receiver = $composer_0.t30();
    if (tmp41_safe_receiver == null)
      null;
    else {
      tmp41_safe_receiver.p3c(ProfileScreen$lambda_123(onBack, onLogout, onNavigateToFriends, onNavigateToOrderHistory, onNavigateToFavorites, onNavigateToCoupons, onNavigateToStockReminders, onNavigateToAccountManagement_0, $changed, $default));
    }
  }
  function ComposableSingletons$ProfileScreenKt$lambda$1449302450$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C200@9737L40,200@9732L46:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1449302450, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$1449302450.<anonymous> (ProfileScreen.kt:200)');
      }
      var tmp = stringResource(get_profile_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$79740178$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C205@10012L31,203@9892L177:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(79740178, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$79740178.<anonymous> (ProfileScreen.kt:203)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1495513211$lambda_4nzca4($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C215@10404L43,213@10293L234:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1495513211, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1495513211.<anonymous> (ProfileScreen.kt:213)');
      }
      var tmp = get_SupportAgent(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_whatsapp_contact(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, Color(new Long(-14298266, 0)), $composer_0, 3072, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$1301823410$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C296@14912L33,294@14792L187:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1301823410, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$1301823410.<anonymous> (ProfileScreen.kt:294)');
      }
      var tmp = get_Close(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_cancel(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1180836092$lambda_rqjeao($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C303@15267L39,301@15148L192:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1180836092, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1180836092.<anonymous> (ProfileScreen.kt:301)');
      }
      var tmp = get_Edit(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_edit_profile(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$667459970$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C413@21318L43,413@21313L49:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(667459970, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$667459970.<anonymous> (ProfileScreen.kt:413)');
      }
      var tmp = stringResource(get_first_name_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1110601877$lambda_u38th6($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C421@21803L42,421@21798L48:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1110601877, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1110601877.<anonymous> (ProfileScreen.kt:421)');
      }
      var tmp = stringResource(get_last_name_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$1999290250$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C429@22266L38,429@22261L44:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1999290250, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$1999290250.<anonymous> (ProfileScreen.kt:429)');
      }
      var tmp = stringResource(get_email_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1318692364$lambda_mmv0dh($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C463@24443L56,463@24438L62:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1318692364, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1318692364.<anonymous> (ProfileScreen.kt:463)');
      }
      var tmp = stringResource(get_invalid_format_use_yyyy_mm_dd(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$814215081$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C456@23883L52,456@23878L58:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(814215081, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$814215081.<anonymous> (ProfileScreen.kt:456)');
      }
      var tmp = stringResource(get_birthday_yyyy_mm_dd_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1028534166$lambda_odo6rq($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C459@24112L49,459@24107L55:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1028534166, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1028534166.<anonymous> (ProfileScreen.kt:459)');
      }
      var tmp = stringResource(get_yyyy_mm_dd_placeholder(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1297516471$lambda_dy42k3($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C469@24866L36,467@24722L222:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1297516471, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1297516471.<anonymous> (ProfileScreen.kt:467)');
      }
      var tmp = get_CalendarMonth(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_pick_date(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_370860088$lambda_xoxn16($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C477@25311L44,477@25306L50:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-370860088, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-370860088.<anonymous> (ProfileScreen.kt:477)');
      }
      var tmp = stringResource(get_building_no_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1555935257$lambda_hckevd($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C485@25793L39,485@25788L45:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1555935257, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1555935257.<anonymous> (ProfileScreen.kt:485)');
      }
      var tmp = stringResource(get_street_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$1553956870$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C493@26284L46,493@26279L52:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1553956870, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$1553956870.<anonymous> (ProfileScreen.kt:493)');
      }
      var tmp = stringResource(get_neighbourhood_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$368881701$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C508@27185L40,508@27180L46:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(368881701, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$368881701.<anonymous> (ProfileScreen.kt:508)');
      }
      var tmp = stringResource(get_country_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$1921714078$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C541@29340L271:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1921714078, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$1921714078.<anonymous> (ProfileScreen.kt:541)');
      }
      var tmp = get_Verified(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, Color(new Long(-11751600, 0)), $composer_0, 3120, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_816193468$lambda_6gedjc($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C521@28016L56,521@28011L62:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-816193468, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-816193468.<anonymous> (ProfileScreen.kt:521)');
      }
      var tmp = stringResource(get_phone_personal_label_required(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$849182745$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C563@30723L54,563@30718L60:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(849182745, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$849182745.<anonymous> (ProfileScreen.kt:563)');
      }
      var tmp = stringResource(get_invalid_phone_number_format(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_2001268637$lambda_b9pncv($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C557@30278L43,557@30273L49:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2001268637, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-2001268637.<anonymous> (ProfileScreen.kt:557)');
      }
      var tmp = stringResource(get_phone_work_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$1167060091$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C569@31175L50,569@31170L56:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1167060091, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$1167060091.<anonymous> (ProfileScreen.kt:569)');
      }
      var tmp = stringResource(get_location_lat_long_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1162760390$lambda_cagqz5($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C577@31740L45,575@31599L228:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1162760390, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1162760390.<anonymous> (ProfileScreen.kt:575)');
      }
      var tmp = get_MyLocation(Icons_getInstance().dxv_1);
      var tmp_0 = stringResource(get_pick_location_desc(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$639588327$lambda($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C665@37530L54,666@37613L39,667@37686L46,667@37681L52:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(639588327, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$639588327.<anonymous> (ProfileScreen.kt:665)');
      }
      var tmp = get_History(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_0, tmp$ret$0), $composer_0, 6);
      var tmp_1 = stringResource(get_order_history_title(string_instance), $composer_0, 0);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$1677005456$lambda($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C678@38222L55,679@38306L39,680@38379L48,680@38374L54:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1677005456, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$1677005456.<anonymous> (ProfileScreen.kt:678)');
      }
      var tmp = get_Favorite(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_0, tmp$ret$0), $composer_0, 6);
      var tmp_1 = stringResource(get_favorite_products_btn(string_instance), $composer_0, 0);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1714746001$lambda_gatd6t($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C694@39087L66,695@39182L39,696@39255L42,696@39250L48:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1714746001, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1714746001.<anonymous> (ProfileScreen.kt:694)');
      }
      var tmp = get_NotificationsActive(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_0, tmp$ret$0), $composer_0, 6);
      var tmp_1 = stringResource(get_stock_reminders(string_instance), $composer_0, 0);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_811530162$lambda_d1gusd($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C710@39948L65,711@40042L39,712@40115L43,712@40110L49:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-811530162, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-811530162.<anonymous> (ProfileScreen.kt:710)');
      }
      var tmp = get_ConfirmationNumber(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_0, tmp$ret$0), $composer_0, 6);
      var tmp_1 = stringResource(get_my_coupons_title(string_instance), $composer_0, 0);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$922014414$lambda($this$OutlinedButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C739@41383L53,740@41465L39,741@41538L45,741@41533L51:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(922014414, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$922014414.<anonymous> (ProfileScreen.kt:739)');
      }
      var tmp = get_Policy(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_0, tmp$ret$0), $composer_0, 6);
      var tmp_1 = stringResource(get_privacy_policy_btn(string_instance), $composer_0, 0);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$1825230253$lambda($this$OutlinedButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C751@41970L51,752@42050L39,753@42118L22:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1825230253, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$1825230253.<anonymous> (ProfileScreen.kt:751)');
      }
      var tmp = get_Lock(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_0, tmp$ret$0), $composer_0, 6);
      var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextOverflow___init__impl__obguoe(0);
      Text('Manage Account', null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 6, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1110907117$lambda_kusa34($this$OutlinedButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C768@42787L51,769@42871L39,770@42948L46,770@42943L52:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1110907117, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1110907117.<anonymous> (ProfileScreen.kt:768)');
      }
      var tmp = get_Lock(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_0, tmp$ret$0), $composer_0, 6);
      var tmp_1 = stringResource(get_change_password_btn(string_instance), $composer_0, 0);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1566521204$lambda_jysmqo($this$OutlinedButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C784@43606L53,785@43688L39,786@43761L45,786@43756L51:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1566521204, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1566521204.<anonymous> (ProfileScreen.kt:784)');
      }
      var tmp = get_Delete(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_0, tmp$ret$0), $composer_0, 6);
      var tmp_1 = stringResource(get_delete_account_btn(string_instance), $composer_0, 0);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1193752518$lambda_gubruk($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C799@44289L68,800@44386L39,801@44459L37,801@44454L43:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1193752518, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1193752518.<anonymous> (ProfileScreen.kt:799)');
      }
      var tmp = get_ExitToApp(Filled_instance_0);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_0, tmp$ret$0), $composer_0, 6);
      var tmp_1 = stringResource(get_logout_btn(string_instance), $composer_0, 0);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_1, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$698565641$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C840@45998L29,840@45993L35:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(698565641, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$698565641.<anonymous> (ProfileScreen.kt:840)');
      }
      var tmp = stringResource(get_ok(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_169361721$lambda_pjg2mk($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C844@46156L33,844@46151L39:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-169361721, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-169361721.<anonymous> (ProfileScreen.kt:844)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_558485208$lambda_bf7x1r($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C927@50093L33,927@50088L39:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-558485208, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-558485208.<anonymous> (ProfileScreen.kt:927)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_135049043$lambda_adtfs3($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C856@46533L45,856@46528L51:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-135049043, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-135049043.<anonymous> (ProfileScreen.kt:856)');
      }
      var tmp = stringResource(get_delete_account_btn(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1239310503$lambda_f5vjll($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C864@47003L41,864@46998L47:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1239310503, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1239310503.<anonymous> (ProfileScreen.kt:864)');
      }
      var tmp = stringResource(get_password_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1087746078$lambda_49oucw($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C875@47702L38,875@47697L44:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1087746078, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1087746078.<anonymous> (ProfileScreen.kt:875)');
      }
      var tmp = stringResource(get_email_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$725089413$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C947@50890L33,947@50885L39:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(725089413, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$725089413.<anonymous> (ProfileScreen.kt:947)');
      }
      var tmp = stringResource(get_delete(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1242715513$lambda_s8mbmd($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C952@51088L33,952@51083L39:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1242715513, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1242715513.<anonymous> (ProfileScreen.kt:952)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_819279348$lambda_yokxf($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C935@50317L33,935@50312L39:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-819279348, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-819279348.<anonymous> (ProfileScreen.kt:935)');
      }
      var tmp = stringResource(get_delete(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$344301837$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C936@50376L61:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(344301837, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$344301837.<anonymous> (ProfileScreen.kt:936)');
      }
      var tmp = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_0 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextOverflow___init__impl__obguoe(0);
      Text('Are you sure you want to delete your profile picture?', null, tmp, null, tmp_0, null, null, null, tmp_1, null, null, tmp_2, tmp_3, false, 0, 0, null, null, $composer_0, 6, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1926945818$lambda_vfzpn9($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1023@54548L33,1023@54543L39:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1926945818, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1926945818.<anonymous> (ProfileScreen.kt:1023)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1503509653$lambda_uel8dl($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C961@51338L46,961@51333L52:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1503509653, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1503509653.<anonymous> (ProfileScreen.kt:961)');
      }
      var tmp = stringResource(get_change_password_btn(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_929369860$lambda_dydte4($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C967@51670L45,967@51665L51:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-929369860, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-929369860.<anonymous> (ProfileScreen.kt:967)');
      }
      var tmp = stringResource(get_new_password_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1992499981$lambda_pcfj2f($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C976@52244L49,976@52239L55:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1992499981, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1992499981.<anonymous> (ProfileScreen.kt:976)');
      }
      var tmp = stringResource(get_confirm_password_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$1683791173$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1085@57386L33,1085@57381L39:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1683791173, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$1683791173.<anonymous> (ProfileScreen.kt:1085)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$2107227338$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1031@54800L41,1031@54795L47:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(2107227338, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$2107227338.<anonymous> (ProfileScreen.kt:1031)');
      }
      var tmp = stringResource(get_reset_password(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1613600165$lambda_1n78t7($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1038@55204L38,1038@55199L44:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1613600165, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1613600165.<anonymous> (ProfileScreen.kt:1038)');
      }
      var tmp = stringResource(get_email_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$_1327601502$lambda_5ox8kh($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1112@58437L33,1112@58432L39:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1327601502, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$-1327601502.<anonymous> (ProfileScreen.kt:1112)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt$lambda$1422997033$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C1093@57602L48,1093@57597L54:ProfileScreen.kt#2kgzgj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1422997033, $changed, -1, 'client.fstech.hadaya.presentation.profile.ComposableSingletons$ProfileScreenKt.lambda$1422997033.<anonymous> (ProfileScreen.kt:1093)');
      }
      var tmp = stringResource(get_select_language_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ProfileScreenKt() {
    ComposableSingletons$ProfileScreenKt_instance = this;
    var tmp = this;
    tmp.v149_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1449302450, false, ComposableSingletons$ProfileScreenKt$lambda$1449302450$lambda));
    var tmp_0 = this;
    tmp_0.w149_1 = ComposableLambda$invoke$ref(composableLambdaInstance(79740178, false, ComposableSingletons$ProfileScreenKt$lambda$79740178$lambda));
    var tmp_1 = this;
    tmp_1.x149_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1495513211, false, ComposableSingletons$ProfileScreenKt$lambda$_1495513211$lambda_4nzca4));
    var tmp_2 = this;
    tmp_2.y149_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1301823410, false, ComposableSingletons$ProfileScreenKt$lambda$1301823410$lambda));
    var tmp_3 = this;
    tmp_3.z149_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1180836092, false, ComposableSingletons$ProfileScreenKt$lambda$_1180836092$lambda_rqjeao));
    var tmp_4 = this;
    tmp_4.a14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(667459970, false, ComposableSingletons$ProfileScreenKt$lambda$667459970$lambda));
    var tmp_5 = this;
    tmp_5.b14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1110601877, false, ComposableSingletons$ProfileScreenKt$lambda$_1110601877$lambda_u38th6));
    var tmp_6 = this;
    tmp_6.c14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1999290250, false, ComposableSingletons$ProfileScreenKt$lambda$1999290250$lambda));
    var tmp_7 = this;
    tmp_7.d14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1318692364, false, ComposableSingletons$ProfileScreenKt$lambda$_1318692364$lambda_mmv0dh));
    var tmp_8 = this;
    tmp_8.e14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(814215081, false, ComposableSingletons$ProfileScreenKt$lambda$814215081$lambda));
    var tmp_9 = this;
    tmp_9.f14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1028534166, false, ComposableSingletons$ProfileScreenKt$lambda$_1028534166$lambda_odo6rq));
    var tmp_10 = this;
    tmp_10.g14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1297516471, false, ComposableSingletons$ProfileScreenKt$lambda$_1297516471$lambda_dy42k3));
    var tmp_11 = this;
    tmp_11.h14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-370860088, false, ComposableSingletons$ProfileScreenKt$lambda$_370860088$lambda_xoxn16));
    var tmp_12 = this;
    tmp_12.i14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1555935257, false, ComposableSingletons$ProfileScreenKt$lambda$_1555935257$lambda_hckevd));
    var tmp_13 = this;
    tmp_13.j14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1553956870, false, ComposableSingletons$ProfileScreenKt$lambda$1553956870$lambda));
    var tmp_14 = this;
    tmp_14.k14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(368881701, false, ComposableSingletons$ProfileScreenKt$lambda$368881701$lambda));
    var tmp_15 = this;
    tmp_15.l14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1921714078, false, ComposableSingletons$ProfileScreenKt$lambda$1921714078$lambda));
    var tmp_16 = this;
    tmp_16.m14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-816193468, false, ComposableSingletons$ProfileScreenKt$lambda$_816193468$lambda_6gedjc));
    var tmp_17 = this;
    tmp_17.n14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(849182745, false, ComposableSingletons$ProfileScreenKt$lambda$849182745$lambda));
    var tmp_18 = this;
    tmp_18.o14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-2001268637, false, ComposableSingletons$ProfileScreenKt$lambda$_2001268637$lambda_b9pncv));
    var tmp_19 = this;
    tmp_19.p14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1167060091, false, ComposableSingletons$ProfileScreenKt$lambda$1167060091$lambda));
    var tmp_20 = this;
    tmp_20.q14a_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1162760390, false, ComposableSingletons$ProfileScreenKt$lambda$_1162760390$lambda_cagqz5));
    var tmp_21 = this;
    tmp_21.r14a_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(639588327, false, ComposableSingletons$ProfileScreenKt$lambda$639588327$lambda));
    var tmp_22 = this;
    tmp_22.s14a_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1677005456, false, ComposableSingletons$ProfileScreenKt$lambda$1677005456$lambda));
    var tmp_23 = this;
    tmp_23.t14a_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1714746001, false, ComposableSingletons$ProfileScreenKt$lambda$_1714746001$lambda_gatd6t));
    var tmp_24 = this;
    tmp_24.u14a_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-811530162, false, ComposableSingletons$ProfileScreenKt$lambda$_811530162$lambda_d1gusd));
    var tmp_25 = this;
    tmp_25.v14a_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(922014414, false, ComposableSingletons$ProfileScreenKt$lambda$922014414$lambda));
    var tmp_26 = this;
    tmp_26.w14a_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1825230253, false, ComposableSingletons$ProfileScreenKt$lambda$1825230253$lambda));
    var tmp_27 = this;
    tmp_27.x14a_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1110907117, false, ComposableSingletons$ProfileScreenKt$lambda$_1110907117$lambda_kusa34));
    var tmp_28 = this;
    tmp_28.y14a_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1566521204, false, ComposableSingletons$ProfileScreenKt$lambda$_1566521204$lambda_jysmqo));
    var tmp_29 = this;
    tmp_29.z14a_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1193752518, false, ComposableSingletons$ProfileScreenKt$lambda$_1193752518$lambda_gubruk));
    var tmp_30 = this;
    tmp_30.a14b_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(698565641, false, ComposableSingletons$ProfileScreenKt$lambda$698565641$lambda));
    var tmp_31 = this;
    tmp_31.b14b_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-169361721, false, ComposableSingletons$ProfileScreenKt$lambda$_169361721$lambda_pjg2mk));
    var tmp_32 = this;
    tmp_32.c14b_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-558485208, false, ComposableSingletons$ProfileScreenKt$lambda$_558485208$lambda_bf7x1r));
    var tmp_33 = this;
    tmp_33.d14b_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-135049043, false, ComposableSingletons$ProfileScreenKt$lambda$_135049043$lambda_adtfs3));
    var tmp_34 = this;
    tmp_34.e14b_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1239310503, false, ComposableSingletons$ProfileScreenKt$lambda$_1239310503$lambda_f5vjll));
    var tmp_35 = this;
    tmp_35.f14b_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1087746078, false, ComposableSingletons$ProfileScreenKt$lambda$_1087746078$lambda_49oucw));
    var tmp_36 = this;
    tmp_36.g14b_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(725089413, false, ComposableSingletons$ProfileScreenKt$lambda$725089413$lambda));
    var tmp_37 = this;
    tmp_37.h14b_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1242715513, false, ComposableSingletons$ProfileScreenKt$lambda$_1242715513$lambda_s8mbmd));
    var tmp_38 = this;
    tmp_38.i14b_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-819279348, false, ComposableSingletons$ProfileScreenKt$lambda$_819279348$lambda_yokxf));
    var tmp_39 = this;
    tmp_39.j14b_1 = ComposableLambda$invoke$ref(composableLambdaInstance(344301837, false, ComposableSingletons$ProfileScreenKt$lambda$344301837$lambda));
    var tmp_40 = this;
    tmp_40.k14b_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1926945818, false, ComposableSingletons$ProfileScreenKt$lambda$_1926945818$lambda_vfzpn9));
    var tmp_41 = this;
    tmp_41.l14b_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1503509653, false, ComposableSingletons$ProfileScreenKt$lambda$_1503509653$lambda_uel8dl));
    var tmp_42 = this;
    tmp_42.m14b_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-929369860, false, ComposableSingletons$ProfileScreenKt$lambda$_929369860$lambda_dydte4));
    var tmp_43 = this;
    tmp_43.n14b_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1992499981, false, ComposableSingletons$ProfileScreenKt$lambda$_1992499981$lambda_pcfj2f));
    var tmp_44 = this;
    tmp_44.o14b_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1683791173, false, ComposableSingletons$ProfileScreenKt$lambda$1683791173$lambda));
    var tmp_45 = this;
    tmp_45.p14b_1 = ComposableLambda$invoke$ref(composableLambdaInstance(2107227338, false, ComposableSingletons$ProfileScreenKt$lambda$2107227338$lambda));
    var tmp_46 = this;
    tmp_46.q14b_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1613600165, false, ComposableSingletons$ProfileScreenKt$lambda$_1613600165$lambda_1n78t7));
    var tmp_47 = this;
    tmp_47.r14b_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1327601502, false, ComposableSingletons$ProfileScreenKt$lambda$_1327601502$lambda_5ox8kh));
    var tmp_48 = this;
    tmp_48.s14b_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1422997033, false, ComposableSingletons$ProfileScreenKt$lambda$1422997033$lambda));
  }
  var ComposableSingletons$ProfileScreenKt_instance;
  function ComposableSingletons$ProfileScreenKt_getInstance() {
    if (ComposableSingletons$ProfileScreenKt_instance == null)
      new ComposableSingletons$ProfileScreenKt();
    return ComposableSingletons$ProfileScreenKt_instance;
  }
  function ProfileInfoItem(label, value, icon, onClick, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1665100576);
    sourceInformation($composer_0, 'C(ProfileInfoItem)P(1,3)1136@59099L820:ProfileScreen.kt#2kgzgj');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(label) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(value) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(icon) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1665100576, $dirty, -1, 'client.fstech.hadaya.presentation.profile.ProfileInfoItem (ProfileScreen.kt:1135)');
      }
      var tmp0_$receiver = clickable(fillMaxWidth(Companion_instance), VOID, VOID, VOID, VOID, onClick);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp1_vertical = _Dp___init__impl__ms3zkb(12);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp2_horizontal = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = padding_2(tmp0_$receiver, tmp2_horizontal, tmp1_vertical);
      var horizontalArrangement = null;
      var verticalAlignment = Companion_getInstance_11().u8t_1;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier = Companion_instance;
      if (!((2 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((2 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 384 >> 3 | 112 & 384 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp = $composer_3.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -1228113239, 'C1144@59403L11,1141@59307L170,1147@59486L40,1148@59535L378:ProfileScreen.kt#2kgzgj');
      var tmp0_tint = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
      var tmp_0 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$8 = _Dp___init__impl__ms3zkb(24);
      var tmp1_modifier = size(tmp_0, tmp$ret$8);
      Icon(icon, null, tmp1_modifier, tmp0_tint, $composer_5, 432 | 14 & $dirty >> 6, 0);
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$9 = _Dp___init__impl__ms3zkb(16);
      Spacer(width(tmp_1, tmp$ret$9), $composer_5, 6);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = null;
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_6 = $composer_5;
      if (!((7 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((7 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((7 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_2 = $composer_8.g30();
      if (!isInterface(tmp_2, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_0);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, -256130494, 'C1151@59630L10,1152@59692L11,1149@59556L178,1156@59821L10,1154@59747L156:ProfileScreen.kt#2kgzgj');
      var tmp0_style = MaterialTheme_instance.jog($composer_10, 6).sof_1;
      var tmp1_color = MaterialTheme_instance.unz($composer_10, 6).po0_1;
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(label, null, tmp1_color, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, tmp0_style, $composer_10, 14 & $dirty, 0, 131066);
      var tmp2_style = MaterialTheme_instance.jog($composer_10, 6).oof_1;
      var tmp3_fontWeight = Companion_getInstance_16().c7z_1;
      var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_11 = _TextOverflow___init__impl__obguoe(0);
      Text(value, null, tmp_7, null, tmp_8, null, tmp3_fontWeight, null, tmp_9, null, null, tmp_10, tmp_11, false, 0, 0, null, tmp2_style, $composer_10, 1572864 | 14 & $dirty >> 3, 0, 131006);
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ProfileInfoItem$lambda(label, value, icon, onClick, $changed));
    }
  }
  function LanguageOption(label, code, isSelected, onClick, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(6870263);
    sourceInformation($composer_0, 'C(LanguageOption)P(2)1122@58628L353:ProfileScreen.kt#2kgzgj');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(label) ? 4 : 2);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.l31(isSelected) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1155) === 1154), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(6870263, $dirty, -1, 'client.fstech.hadaya.presentation.profile.LanguageOption (ProfileScreen.kt:1121)');
      }
      var tmp = clickable(fillMaxWidth(Companion_instance), VOID, VOID, VOID, VOID, onClick);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = padding_2(tmp, VOID, tmp$ret$0);
      var horizontalArrangement = null;
      var verticalAlignment = Companion_getInstance_11().u8t_1;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier = Companion_instance;
      if (!((2 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((2 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 384 >> 3 | 112 & 384 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 829904220, 'C1126@58803L53,1127@58865L39,1128@58954L10,1128@58913L62:ProfileScreen.kt#2kgzgj');
      RadioButton(isSelected, onClick, null, false, null, null, $composer_5, 14 & $dirty >> 6 | 112 & $dirty >> 6, 60);
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(8);
      Spacer(width(tmp_1, tmp$ret$7), $composer_5, 6);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(label, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, MaterialTheme_instance.jog($composer_5, 6).oof_1, $composer_5, 14 & $dirty, 0, 131070);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(LanguageOption$lambda(label, code, isSelected, onClick, $changed));
    }
  }
  function ProfileScreen$lambda() {
    return Unit_instance;
  }
  function ProfileScreen$lambda_0($currentLanguage$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('currentLanguage', KProperty0, false);
    return $currentLanguage$delegate.u1();
  }
  function ProfileScreen$lambda_1() {
    return EmptyCoroutineContext_getInstance();
  }
  function ProfileScreen$lambda_2($showDeleteDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDeleteDialog', KMutableProperty0, true);
    return $showDeleteDialog$delegate.u1();
  }
  function ProfileScreen$lambda_3($showDeleteDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDeleteDialog', KMutableProperty0, true);
    $showDeleteDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_4($showDeleteAvatarDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDeleteAvatarDialog', KMutableProperty0, true);
    return $showDeleteAvatarDialog$delegate.u1();
  }
  function ProfileScreen$lambda_5($showDeleteAvatarDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDeleteAvatarDialog', KMutableProperty0, true);
    $showDeleteAvatarDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_6($showPasswordDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showPasswordDialog', KMutableProperty0, true);
    return $showPasswordDialog$delegate.u1();
  }
  function ProfileScreen$lambda_7($showPasswordDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showPasswordDialog', KMutableProperty0, true);
    $showPasswordDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_8($showResetPasswordDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showResetPasswordDialog', KMutableProperty0, true);
    return $showResetPasswordDialog$delegate.u1();
  }
  function ProfileScreen$lambda_9($showResetPasswordDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showResetPasswordDialog', KMutableProperty0, true);
    $showResetPasswordDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_10($showLanguageDialog$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showLanguageDialog', KMutableProperty0, true);
    return $showLanguageDialog$delegate.u1();
  }
  function ProfileScreen$lambda_11($showLanguageDialog$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showLanguageDialog', KMutableProperty0, true);
    $showLanguageDialog$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_12($newPassword$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('newPassword', KMutableProperty0, true);
    return $newPassword$delegate.u1();
  }
  function ProfileScreen$lambda_13($newPassword$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('newPassword', KMutableProperty0, true);
    $newPassword$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_14($confirmPassword$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('confirmPassword', KMutableProperty0, true);
    return $confirmPassword$delegate.u1();
  }
  function ProfileScreen$lambda_15($confirmPassword$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('confirmPassword', KMutableProperty0, true);
    $confirmPassword$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_16($resetEmail$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('resetEmail', KMutableProperty0, true);
    return $resetEmail$delegate.u1();
  }
  function ProfileScreen$lambda_17($resetEmail$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('resetEmail', KMutableProperty0, true);
    $resetEmail$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_18($deletePassword$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('deletePassword', KMutableProperty0, true);
    return $deletePassword$delegate.u1();
  }
  function ProfileScreen$lambda_19($deletePassword$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('deletePassword', KMutableProperty0, true);
    $deletePassword$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_20($deleteEmailConfirm$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('deleteEmailConfirm', KMutableProperty0, true);
    return $deleteEmailConfirm$delegate.u1();
  }
  function ProfileScreen$lambda_21($deleteEmailConfirm$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('deleteEmailConfirm', KMutableProperty0, true);
    $deleteEmailConfirm$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_22($isUpdatingPassword$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isUpdatingPassword', KMutableProperty0, true);
    return $isUpdatingPassword$delegate.u1();
  }
  function ProfileScreen$lambda_23($isUpdatingPassword$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isUpdatingPassword', KMutableProperty0, true);
    $isUpdatingPassword$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_24($isResettingPassword$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isResettingPassword', KMutableProperty0, true);
    return $isResettingPassword$delegate.u1();
  }
  function ProfileScreen$lambda_25($isResettingPassword$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isResettingPassword', KMutableProperty0, true);
    $isResettingPassword$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_26($isUpdatingAvatar$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isUpdatingAvatar', KMutableProperty0, true);
    return $isUpdatingAvatar$delegate.u1();
  }
  function ProfileScreen$lambda_27($isUpdatingAvatar$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isUpdatingAvatar', KMutableProperty0, true);
    $isUpdatingAvatar$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_28($isDeletingAccount$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isDeletingAccount', KMutableProperty0, true);
    return $isDeletingAccount$delegate.u1();
  }
  function ProfileScreen$lambda_29($isDeletingAccount$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isDeletingAccount', KMutableProperty0, true);
    $isDeletingAccount$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_30($isEditing$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isEditing', KMutableProperty0, true);
    return $isEditing$delegate.u1();
  }
  function ProfileScreen$lambda_31($isEditing$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isEditing', KMutableProperty0, true);
    $isEditing$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_32($editFirstName$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('editFirstName', KMutableProperty0, true);
    return $editFirstName$delegate.u1();
  }
  function ProfileScreen$lambda_33($editFirstName$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('editFirstName', KMutableProperty0, true);
    $editFirstName$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_34($editLastName$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('editLastName', KMutableProperty0, true);
    return $editLastName$delegate.u1();
  }
  function ProfileScreen$lambda_35($editLastName$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('editLastName', KMutableProperty0, true);
    $editLastName$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_36($editEmail$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('editEmail', KMutableProperty0, true);
    return $editEmail$delegate.u1();
  }
  function ProfileScreen$lambda_37($editEmail$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('editEmail', KMutableProperty0, true);
    $editEmail$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_38($editBirthday$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('editBirthday', KMutableProperty0, true);
    return $editBirthday$delegate.u1();
  }
  function ProfileScreen$lambda_39($editBirthday$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('editBirthday', KMutableProperty0, true);
    $editBirthday$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_40($editBuildingNo$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('editBuildingNo', KMutableProperty0, true);
    return $editBuildingNo$delegate.u1();
  }
  function ProfileScreen$lambda_41($editBuildingNo$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('editBuildingNo', KMutableProperty0, true);
    $editBuildingNo$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_42($editStreet$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('editStreet', KMutableProperty0, true);
    return $editStreet$delegate.u1();
  }
  function ProfileScreen$lambda_43($editStreet$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('editStreet', KMutableProperty0, true);
    $editStreet$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_44($editNeighbourhood$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('editNeighbourhood', KMutableProperty0, true);
    return $editNeighbourhood$delegate.u1();
  }
  function ProfileScreen$lambda_45($editNeighbourhood$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('editNeighbourhood', KMutableProperty0, true);
    $editNeighbourhood$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_46($editCity$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('editCity', KMutableProperty0, true);
    return $editCity$delegate.u1();
  }
  function ProfileScreen$lambda_47($editCity$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('editCity', KMutableProperty0, true);
    $editCity$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_48($editCountry$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('editCountry', KMutableProperty0, true);
    return $editCountry$delegate.u1();
  }
  function ProfileScreen$lambda_49($editCountry$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('editCountry', KMutableProperty0, true);
    $editCountry$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_50($editPersonalPhone$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('editPersonalPhone', KMutableProperty0, true);
    return $editPersonalPhone$delegate.u1();
  }
  function ProfileScreen$lambda_51($editPersonalPhone$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('editPersonalPhone', KMutableProperty0, true);
    $editPersonalPhone$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_52($editWorkPhone$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('editWorkPhone', KMutableProperty0, true);
    return $editWorkPhone$delegate.u1();
  }
  function ProfileScreen$lambda_53($editWorkPhone$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('editWorkPhone', KMutableProperty0, true);
    $editWorkPhone$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_54($editLatitude$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('editLatitude', KMutableProperty0, true);
    return $editLatitude$delegate.u1();
  }
  function ProfileScreen$lambda_55($editLatitude$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('editLatitude', KMutableProperty0, true);
    $editLatitude$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_56($editLongitude$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('editLongitude', KMutableProperty0, true);
    return $editLongitude$delegate.u1();
  }
  function ProfileScreen$lambda_57($editLongitude$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('editLongitude', KMutableProperty0, true);
    $editLongitude$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_58($isSaving$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('isSaving', KMutableProperty0, true);
    return $isSaving$delegate.u1();
  }
  function ProfileScreen$lambda_59($isSaving$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('isSaving', KMutableProperty0, true);
    $isSaving$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$lambda_60($showDatePicker$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showDatePicker', KMutableProperty0, true);
    return $showDatePicker$delegate.u1();
  }
  function ProfileScreen$lambda_61($showDatePicker$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showDatePicker', KMutableProperty0, true);
    $showDatePicker$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ProfileScreen$slambda($profile, $isEditing$delegate, $editFirstName$delegate, $editLastName$delegate, $editEmail$delegate, $editBirthday$delegate, $editBuildingNo$delegate, $editStreet$delegate, $editNeighbourhood$delegate, $editCity$delegate, $editCountry$delegate, $editPersonalPhone$delegate, $editWorkPhone$delegate, $editLatitude$delegate, $editLongitude$delegate, resultContinuation) {
    this.b14c_1 = $profile;
    this.c14c_1 = $isEditing$delegate;
    this.d14c_1 = $editFirstName$delegate;
    this.e14c_1 = $editLastName$delegate;
    this.f14c_1 = $editEmail$delegate;
    this.g14c_1 = $editBirthday$delegate;
    this.h14c_1 = $editBuildingNo$delegate;
    this.i14c_1 = $editStreet$delegate;
    this.j14c_1 = $editNeighbourhood$delegate;
    this.k14c_1 = $editCity$delegate;
    this.l14c_1 = $editCountry$delegate;
    this.m14c_1 = $editPersonalPhone$delegate;
    this.n14c_1 = $editWorkPhone$delegate;
    this.o14c_1 = $editLatitude$delegate;
    this.p14c_1 = $editLongitude$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          if (ProfileScreen$lambda_30(this.c14c_1) && !(this.b14c_1 == null)) {
            var tmp0_elvis_lhs = this.b14c_1.wym_1;
            ProfileScreen$lambda_33(this.d14c_1, tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
            var tmp1_elvis_lhs = this.b14c_1.xym_1;
            ProfileScreen$lambda_35(this.e14c_1, tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
            var tmp2_elvis_lhs = this.b14c_1.vym_1;
            ProfileScreen$lambda_37(this.f14c_1, tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
            var tmp3_elvis_lhs = this.b14c_1.yym_1;
            ProfileScreen$lambda_39(this.g14c_1, tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs);
            var tmp4_elvis_lhs = this.b14c_1.zym_1;
            ProfileScreen$lambda_41(this.h14c_1, tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs);
            var tmp5_elvis_lhs = this.b14c_1.ayn_1;
            ProfileScreen$lambda_43(this.i14c_1, tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs);
            var tmp6_elvis_lhs = this.b14c_1.byn_1;
            ProfileScreen$lambda_45(this.j14c_1, tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs);
            var tmp7_elvis_lhs = this.b14c_1.cyn_1;
            ProfileScreen$lambda_47(this.k14c_1, tmp7_elvis_lhs == null ? '' : tmp7_elvis_lhs);
            var tmp8_elvis_lhs = this.b14c_1.dyn_1;
            ProfileScreen$lambda_49(this.l14c_1, tmp8_elvis_lhs == null ? '' : tmp8_elvis_lhs);
            var tmp9_elvis_lhs = this.b14c_1.gyn_1;
            ProfileScreen$lambda_51(this.m14c_1, tmp9_elvis_lhs == null ? '' : tmp9_elvis_lhs);
            var tmp10_elvis_lhs = this.b14c_1.hyn_1;
            ProfileScreen$lambda_53(this.n14c_1, tmp10_elvis_lhs == null ? '' : tmp10_elvis_lhs);
            ProfileScreen$lambda_55(this.o14c_1, this.b14c_1.iyn_1);
            ProfileScreen$lambda_57(this.p14c_1, this.b14c_1.jyn_1);
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ProfileScreen$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new ProfileScreen$slambda(this.b14c_1, this.c14c_1, this.d14c_1, this.e14c_1, this.f14c_1, this.g14c_1, this.h14c_1, this.i14c_1, this.j14c_1, this.k14c_1, this.l14c_1, this.m14c_1, this.n14c_1, this.o14c_1, this.p14c_1, completion);
    i.q14c_1 = $this$LaunchedEffect;
    return i;
  };
  function ProfileScreen$slambda_0($profile, $isEditing$delegate, $editFirstName$delegate, $editLastName$delegate, $editEmail$delegate, $editBirthday$delegate, $editBuildingNo$delegate, $editStreet$delegate, $editNeighbourhood$delegate, $editCity$delegate, $editCountry$delegate, $editPersonalPhone$delegate, $editWorkPhone$delegate, $editLatitude$delegate, $editLongitude$delegate, resultContinuation) {
    var i = new ProfileScreen$slambda($profile, $isEditing$delegate, $editFirstName$delegate, $editLastName$delegate, $editEmail$delegate, $editBirthday$delegate, $editBuildingNo$delegate, $editStreet$delegate, $editNeighbourhood$delegate, $editCity$delegate, $editCountry$delegate, $editPersonalPhone$delegate, $editWorkPhone$delegate, $editLatitude$delegate, $editLongitude$delegate, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function ProfileScreen$lambda_62($editLatitude$delegate, $editLongitude$delegate) {
    return function (latLng) {
      var tmp;
      if (!(latLng == null)) {
        ProfileScreen$lambda_55($editLatitude$delegate, latLng.r14c_1);
        ProfileScreen$lambda_57($editLongitude$delegate, latLng.s14c_1);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$slambda($authRepository, $bytes, $isUpdatingAvatar$delegate, resultContinuation) {
    this.b14d_1 = $authRepository;
    this.c14d_1 = $bytes;
    this.d14d_1 = $isUpdatingAvatar$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            ProfileScreen$lambda_27(this.d14d_1, true);
            this.n9_1 = 1;
            suspendResult = this.b14d_1.zyv(this.c14d_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            ProfileScreen$lambda_27(this.d14d_1, false);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProfileScreen$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new ProfileScreen$lambda$slambda(this.b14d_1, this.c14d_1, this.d14d_1, completion);
    i.e14d_1 = $this$launch;
    return i;
  };
  function ProfileScreen$lambda$slambda_0($authRepository, $bytes, $isUpdatingAvatar$delegate, resultContinuation) {
    var i = new ProfileScreen$lambda$slambda($authRepository, $bytes, $isUpdatingAvatar$delegate, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProfileScreen$lambda_63($scope, $authRepository, $isUpdatingAvatar$delegate) {
    return function (bytes) {
      var tmp;
      if (!(bytes == null)) {
        launch($scope, VOID, VOID, ProfileScreen$lambda$slambda_0($authRepository, bytes, $isUpdatingAvatar$delegate, null));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_64($onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C202@9837L254:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1838595088, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous>.<anonymous>.<anonymous> (ProfileScreen.kt:202)');
        }
        IconButton($onBack, null, false, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().w149_1, $composer_0, 1572864, 62);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda() {
    openUrl('https://wa.me/201501166734');
    return Unit_instance;
  }
  function ProfileScreen$lambda$lambda$slambda($snackbarHostState, $invalid_birthday_format, resultContinuation) {
    this.n14d_1 = $snackbarHostState;
    this.o14d_1 = $invalid_birthday_format;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$lambda$lambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$lambda$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.n14d_1.dqm(this.o14d_1, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda).q24 = function ($this$launch, completion) {
    var i = new ProfileScreen$lambda$lambda$slambda(this.n14d_1, this.o14d_1, completion);
    i.p14d_1 = $this$launch;
    return i;
  };
  function ProfileScreen$lambda$lambda$slambda_0($snackbarHostState, $invalid_birthday_format, resultContinuation) {
    var i = new ProfileScreen$lambda$lambda$slambda($snackbarHostState, $invalid_birthday_format, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProfileScreen$lambda$lambda$slambda_1($snackbarHostState, $invalid_phone_personal, resultContinuation) {
    this.y14d_1 = $snackbarHostState;
    this.z14d_1 = $invalid_phone_personal;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$lambda$lambda$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.y14d_1.dqm(this.z14d_1, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_1).q24 = function ($this$launch, completion) {
    var i = new ProfileScreen$lambda$lambda$slambda_1(this.y14d_1, this.z14d_1, completion);
    i.a14e_1 = $this$launch;
    return i;
  };
  function ProfileScreen$lambda$lambda$slambda_2($snackbarHostState, $invalid_phone_personal, resultContinuation) {
    var i = new ProfileScreen$lambda$lambda$slambda_1($snackbarHostState, $invalid_phone_personal, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProfileScreen$lambda$lambda$slambda_3($snackbarHostState, $invalid_phone_work, resultContinuation) {
    this.j14e_1 = $snackbarHostState;
    this.k14e_1 = $invalid_phone_work;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$lambda$lambda$slambda_3).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.j14e_1.dqm(this.k14e_1, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_3).q24 = function ($this$launch, completion) {
    var i = new ProfileScreen$lambda$lambda$slambda_3(this.j14e_1, this.k14e_1, completion);
    i.l14e_1 = $this$launch;
    return i;
  };
  function ProfileScreen$lambda$lambda$slambda_4($snackbarHostState, $invalid_phone_work, resultContinuation) {
    var i = new ProfileScreen$lambda$lambda$slambda_3($snackbarHostState, $invalid_phone_work, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProfileScreen$lambda$lambda$slambda_5($profile, $authRepository, $isSaving$delegate, $editFirstName$delegate, $editLastName$delegate, $editBirthday$delegate, $editBuildingNo$delegate, $editStreet$delegate, $editNeighbourhood$delegate, $editCity$delegate, $editCountry$delegate, $editPersonalPhone$delegate, $editWorkPhone$delegate, $editLatitude$delegate, $editLongitude$delegate, $isEditing$delegate, resultContinuation) {
    this.u14e_1 = $profile;
    this.v14e_1 = $authRepository;
    this.w14e_1 = $isSaving$delegate;
    this.x14e_1 = $editFirstName$delegate;
    this.y14e_1 = $editLastName$delegate;
    this.z14e_1 = $editBirthday$delegate;
    this.a14f_1 = $editBuildingNo$delegate;
    this.b14f_1 = $editStreet$delegate;
    this.c14f_1 = $editNeighbourhood$delegate;
    this.d14f_1 = $editCity$delegate;
    this.e14f_1 = $editCountry$delegate;
    this.f14f_1 = $editPersonalPhone$delegate;
    this.g14f_1 = $editWorkPhone$delegate;
    this.h14f_1 = $editLatitude$delegate;
    this.i14f_1 = $editLongitude$delegate;
    this.j14f_1 = $isEditing$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$lambda$lambda$slambda_5).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_5).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            ProfileScreen$lambda_59(this.w14e_1, true);
            var updatedProfile = this.u14e_1.uyn(VOID, VOID, ProfileScreen$lambda_32(this.x14e_1), ProfileScreen$lambda_34(this.y14e_1), ProfileScreen$lambda_38(this.z14e_1), ProfileScreen$lambda_40(this.a14f_1), ProfileScreen$lambda_42(this.b14f_1), ProfileScreen$lambda_44(this.c14f_1), ProfileScreen$lambda_46(this.d14f_1), ProfileScreen$lambda_48(this.e14f_1), VOID, VOID, ProfileScreen$lambda_50(this.f14f_1), ProfileScreen$lambda_52(this.g14f_1), ProfileScreen$lambda_54(this.h14f_1), ProfileScreen$lambda_56(this.i14f_1));
            this.n9_1 = 1;
            suspendResult = this.v14e_1.byw(updatedProfile, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var profileSuccess = suspendResult;
            if (profileSuccess) {
              ProfileScreen$lambda_31(this.j14f_1, false);
            }

            ProfileScreen$lambda_59(this.w14e_1, false);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_5).q24 = function ($this$launch, completion) {
    var i = new ProfileScreen$lambda$lambda$slambda_5(this.u14e_1, this.v14e_1, this.w14e_1, this.x14e_1, this.y14e_1, this.z14e_1, this.a14f_1, this.b14f_1, this.c14f_1, this.d14f_1, this.e14f_1, this.f14f_1, this.g14f_1, this.h14f_1, this.i14f_1, this.j14f_1, completion);
    i.k14f_1 = $this$launch;
    return i;
  };
  function ProfileScreen$lambda$lambda$slambda_6($profile, $authRepository, $isSaving$delegate, $editFirstName$delegate, $editLastName$delegate, $editBirthday$delegate, $editBuildingNo$delegate, $editStreet$delegate, $editNeighbourhood$delegate, $editCity$delegate, $editCountry$delegate, $editPersonalPhone$delegate, $editWorkPhone$delegate, $editLatitude$delegate, $editLongitude$delegate, $isEditing$delegate, resultContinuation) {
    var i = new ProfileScreen$lambda$lambda$slambda_5($profile, $authRepository, $isSaving$delegate, $editFirstName$delegate, $editLastName$delegate, $editBirthday$delegate, $editBuildingNo$delegate, $editStreet$delegate, $editNeighbourhood$delegate, $editCity$delegate, $editCountry$delegate, $editPersonalPhone$delegate, $editWorkPhone$delegate, $editLatitude$delegate, $editLongitude$delegate, $isEditing$delegate, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProfileScreen$lambda$lambda_0($scope, $editBirthday$delegate, $snackbarHostState, $invalid_birthday_format, $editPersonalPhone$delegate, $invalid_phone_personal, $editWorkPhone$delegate, $invalid_phone_work, $profile, $authRepository, $isSaving$delegate, $editFirstName$delegate, $editLastName$delegate, $editBuildingNo$delegate, $editStreet$delegate, $editNeighbourhood$delegate, $editCity$delegate, $editCountry$delegate, $editLatitude$delegate, $editLongitude$delegate, $isEditing$delegate) {
    return function () {
      var birthdayRegex = Regex_init_$Create$('^\\d{4}-\\d{2}-\\d{2}$');
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = ProfileScreen$lambda_38($editBirthday$delegate);
      if (!isBlank(this_0)) {
        tmp_0 = !birthdayRegex.zd(ProfileScreen$lambda_38($editBirthday$delegate));
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        launch($scope, VOID, VOID, ProfileScreen$lambda$lambda$slambda_0($snackbarHostState, $invalid_birthday_format, null));
        return Unit_instance;
      }
      var tmp_1;
      var tmp_2;
      // Inline function 'kotlin.text.isNotBlank' call
      var this_1 = ProfileScreen$lambda_50($editPersonalPhone$delegate);
      if (!isBlank(this_1)) {
        tmp_2 = !isValidEgyptianMobile(ProfileScreen$lambda_50($editPersonalPhone$delegate));
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        launch($scope, VOID, VOID, ProfileScreen$lambda$lambda$slambda_2($snackbarHostState, $invalid_phone_personal, null));
        return Unit_instance;
      }
      var tmp_3;
      var tmp_4;
      // Inline function 'kotlin.text.isNotBlank' call
      var this_2 = ProfileScreen$lambda_52($editWorkPhone$delegate);
      if (!isBlank(this_2)) {
        tmp_4 = !isValidEgyptianWorkPhone(ProfileScreen$lambda_52($editWorkPhone$delegate));
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        launch($scope, VOID, VOID, ProfileScreen$lambda$lambda$slambda_4($snackbarHostState, $invalid_phone_work, null));
        return Unit_instance;
      }
      launch($scope, VOID, VOID, ProfileScreen$lambda$lambda$slambda_6($profile, $authRepository, $isSaving$delegate, $editFirstName$delegate, $editLastName$delegate, $editBirthday$delegate, $editBuildingNo$delegate, $editStreet$delegate, $editNeighbourhood$delegate, $editCity$delegate, $editCountry$delegate, $editPersonalPhone$delegate, $editWorkPhone$delegate, $editLatitude$delegate, $editLongitude$delegate, $isEditing$delegate, null));
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_1($isSaving$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-149863045, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ProfileScreen.kt:287)');
        }
        if (ProfileScreen$lambda_58($isSaving$delegate)) {
          $composer_0.m30(2010503413);
          sourceInformation($composer_0, '287@14353L58');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_0, 6, 62);
          $composer_0.n30();
        } else {
          $composer_0.m30(2010506612);
          sourceInformation($composer_0, '290@14569L31,288@14449L185');
          var tmp_6 = get_Check(Icons_getInstance().dxv_1);
          var tmp_7 = stringResource(get_save(string_instance), $composer_0, 0);
          Icon(tmp_6, tmp_7, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
          $composer_0.n30();
        }
        var tmp_8;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_8 = Unit_instance;
        }
        tmp = tmp_8;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_2($isEditing$delegate) {
    return function () {
      ProfileScreen$lambda_31($isEditing$delegate, false);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_3($isEditing$delegate) {
    return function () {
      ProfileScreen$lambda_31($isEditing$delegate, true);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_65($profile, $scope, $invalid_birthday_format, $invalid_phone_personal, $invalid_phone_work, $authRepository, $isEditing$delegate, $editBirthday$delegate, $snackbarHostState, $editPersonalPhone$delegate, $editWorkPhone$delegate, $isSaving$delegate, $editFirstName$delegate, $editLastName$delegate, $editBuildingNo$delegate, $editStreet$delegate, $editNeighbourhood$delegate, $editCity$delegate, $editCountry$delegate, $editLatitude$delegate, $editLongitude$delegate) {
    return function ($this$CenterAlignedTopAppBar, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C210@10180L85,210@10159L390:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1058708071, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous>.<anonymous>.<anonymous> (ProfileScreen.kt:210)');
        }
        sourceInformationMarkerStart($composer_0, -488791460, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda;
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().x149_1, $composer_0, 1572870, 62);
        if (!($profile == null)) {
          $composer_0.m30(2027888640);
          sourceInformation($composer_0, '');
          if (ProfileScreen$lambda_30($isEditing$delegate)) {
            $composer_0.m30(2027916168);
            sourceInformation($composer_0, '222@10716L3537,286@14305L359,221@10662L4002,293@14714L21,293@14693L316');
            sourceInformationMarkerStart($composer_0, -488770856, 'CC(remember):ProfileScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid = !!(!!(!!(!!(!!($composer_0.q31($scope) | $composer_0.k31($invalid_birthday_format)) | $composer_0.k31($invalid_phone_personal)) | $composer_0.k31($invalid_phone_work)) | $composer_0.k31($profile)) | $composer_0.q31($authRepository));
            // Inline function 'kotlin.let' call
            var it_0 = $composer_0.i31();
            var tmp_1;
            if (invalid || it_0 === Companion_getInstance().f30_1) {
              var value_0 = ProfileScreen$lambda$lambda_0($scope, $editBirthday$delegate, $snackbarHostState, $invalid_birthday_format, $editPersonalPhone$delegate, $invalid_phone_personal, $editWorkPhone$delegate, $invalid_phone_work, $profile, $authRepository, $isSaving$delegate, $editFirstName$delegate, $editLastName$delegate, $editBuildingNo$delegate, $editStreet$delegate, $editNeighbourhood$delegate, $editCity$delegate, $editCountry$delegate, $editLatitude$delegate, $editLongitude$delegate, $isEditing$delegate);
              $composer_0.j31(value_0);
              tmp_1 = value_0;
            } else {
              tmp_1 = it_0;
            }
            var tmp1_group = tmp_1;
            sourceInformationMarkerEnd($composer_0);
            var tmp_2 = !ProfileScreen$lambda_58($isSaving$delegate);
            // Inline function 'kotlin.run' call
            var dispatchReceiver = rememberComposableLambda(-149863045, true, ProfileScreen$lambda$lambda_1($isSaving$delegate), $composer_0, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_1 = $composer_0;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_0 = $composer_1.k31(dispatchReceiver);
            // Inline function 'kotlin.let' call
            var it_1 = $composer_1.i31();
            var tmp_3;
            if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
              var value_1 = ComposableLambda$invoke$ref(dispatchReceiver);
              $composer_1.j31(value_1);
              tmp_3 = value_1;
            } else {
              tmp_3 = it_1;
            }
            var tmp$ret$8 = tmp_3;
            IconButton(tmp1_group, null, tmp_2, null, null, null, tmp$ret$8, $composer_0, 1572864, 58);
            sourceInformationMarkerStart($composer_0, -488646436, 'CC(remember):ProfileScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_2 = $composer_0.i31();
            var tmp_4;
            if (false || it_2 === Companion_getInstance().f30_1) {
              var value_2 = ProfileScreen$lambda$lambda_2($isEditing$delegate);
              $composer_0.j31(value_2);
              tmp_4 = value_2;
            } else {
              tmp_4 = it_2;
            }
            var tmp2_group = tmp_4;
            sourceInformationMarkerEnd($composer_0);
            var tmp_5 = !ProfileScreen$lambda_58($isSaving$delegate);
            IconButton(tmp2_group, null, tmp_5, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().y149_1, $composer_0, 1572870, 58);
            $composer_0.n30();
          } else {
            $composer_0.m30(2032164408);
            sourceInformation($composer_0, '300@15092L20,300@15071L299');
            sourceInformationMarkerStart($composer_0, -488634341, 'CC(remember):ProfileScreen.kt#9igjgp');
            // Inline function 'androidx.compose.runtime.cache' call
            // Inline function 'kotlin.let' call
            var it_3 = $composer_0.i31();
            var tmp_6;
            if (false || it_3 === Companion_getInstance().f30_1) {
              var value_3 = ProfileScreen$lambda$lambda_3($isEditing$delegate);
              $composer_0.j31(value_3);
              tmp_6 = value_3;
            } else {
              tmp_6 = it_3;
            }
            var tmp3_group = tmp_6;
            sourceInformationMarkerEnd($composer_0);
            IconButton(tmp3_group, null, false, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().z149_1, $composer_0, 1572870, 62);
            $composer_0.n30();
          }
          $composer_0.n30();
        } else {
          $composer_0.m30(2032527387);
          $composer_0.n30();
        }
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_66($imagePicker) {
    return function () {
      $imagePicker.g11s();
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_67($showDeleteAvatarDialog$delegate) {
    return function () {
      ProfileScreen$lambda_5($showDeleteAvatarDialog$delegate, true);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_68($imagePicker) {
    return function () {
      $imagePicker.g11s();
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_69($editFirstName$delegate) {
    return function (it) {
      ProfileScreen$lambda_33($editFirstName$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_70($editLastName$delegate) {
    return function (it) {
      ProfileScreen$lambda_35($editLastName$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_71(it) {
    return Unit_instance;
  }
  function ProfileScreen$lambda_72($editBirthday$delegate) {
    return function (input) {
      // Inline function 'kotlin.text.filter' call
      // Inline function 'kotlin.text.filterTo' call
      var destination = StringBuilder_init_$Create$();
      var inductionVariable = 0;
      var last = charSequenceLength(input);
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var element = charSequenceGet(input, index);
          if (isDigit(element)) {
            destination.s(element);
          }
        }
         while (inductionVariable < last);
      var digitsOnly = destination.toString();
      var tmp;
      if (digitsOnly.length <= 8) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        var inductionVariable_0 = 0;
        var last_0 = charSequenceLength(digitsOnly) - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this_0.s(charCodeAt(digitsOnly, i));
            if ((i === 3 || i === 5) && !(i === get_lastIndex(digitsOnly))) {
              this_0.q('-');
            }
          }
           while (inductionVariable_0 <= last_0);
        var formatted = this_0.toString();
        ProfileScreen$lambda_39($editBirthday$delegate, formatted);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_4($showDatePicker$delegate) {
    return function () {
      ProfileScreen$lambda_61($showDatePicker$delegate, true);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_73($showDatePicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C466@24653L25,466@24632L350:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1423683883, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ProfileScreen.kt:466)');
        }
        sourceInformationMarkerStart($composer_0, -1934353948, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_4($showDatePicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().g14a_1, $composer_0, 1572870, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_74($editBuildingNo$delegate) {
    return function (it) {
      ProfileScreen$lambda_41($editBuildingNo$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_75($editStreet$delegate) {
    return function (it) {
      ProfileScreen$lambda_43($editStreet$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_76($editNeighbourhood$delegate) {
    return function (it) {
      ProfileScreen$lambda_45($editNeighbourhood$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_77($editCity$delegate) {
    return function (it) {
      ProfileScreen$lambda_47($editCity$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_78($editCountry$delegate) {
    return function (it) {
      ProfileScreen$lambda_49($editCountry$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda$slambda_7($snackbarHostState, $verified_phone_msg, resultContinuation) {
    this.t14f_1 = $snackbarHostState;
    this.u14f_1 = $verified_phone_msg;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$lambda$lambda$slambda_7).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_7).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_7).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.t14f_1.dqm(this.u14f_1, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_7).q24 = function ($this$launch, completion) {
    var i = new ProfileScreen$lambda$lambda$slambda_7(this.t14f_1, this.u14f_1, completion);
    i.v14f_1 = $this$launch;
    return i;
  };
  function ProfileScreen$lambda$lambda$slambda_8($snackbarHostState, $verified_phone_msg, resultContinuation) {
    var i = new ProfileScreen$lambda$lambda$slambda_7($snackbarHostState, $verified_phone_msg, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProfileScreen$lambda$lambda_5($scope, $snackbarHostState, $verified_phone_msg) {
    return function () {
      launch($scope, VOID, VOID, ProfileScreen$lambda$lambda$slambda_8($snackbarHostState, $verified_phone_msg, null));
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_79($scope, $verified_phone_msg, $snackbarHostState) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C536@29045L247,536@29024L629:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1360171008, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ProfileScreen.kt:536)');
        }
        sourceInformationMarkerStart($composer_0, 1454282967, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.q31($scope) | $composer_0.k31($verified_phone_msg));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_5($scope, $snackbarHostState, $verified_phone_msg);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().l14a_1, $composer_0, 1572864, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_80($editPersonalPhone$delegate) {
    return function (it) {
      ProfileScreen$lambda_51($editPersonalPhone$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_81($isPersonalPhoneError, $canChangePhone) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(735493847, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ProfileScreen.kt:528)');
        }
        if ($isPersonalPhoneError) {
          $composer_0.m30(-1825880385);
          sourceInformation($composer_0, '529@28580L54,529@28575L60');
          var tmp_0 = stringResource(get_invalid_phone_number_format(string_instance), $composer_0, 0);
          var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_5 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_0, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
          $composer_0.n30();
        } else if (!$canChangePhone) {
          $composer_0.m30(-1825714721);
          sourceInformation($composer_0, '531@28747L54,531@28742L60');
          var tmp_6 = stringResource(get_phone_verified_call_support(string_instance), $composer_0, 0);
          var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_11 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_6, null, tmp_7, null, tmp_8, null, null, null, tmp_9, null, null, tmp_10, tmp_11, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
          $composer_0.n30();
        } else {
          $composer_0.m30(-1825580181);
          $composer_0.n30();
        }
        var tmp_12;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_12 = Unit_instance;
        }
        tmp = tmp_12;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_82($editWorkPhone$delegate) {
    return function (it) {
      ProfileScreen$lambda_53($editWorkPhone$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_83($locationPicker) {
    return function () {
      $locationPicker.g11s();
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_84(it) {
    return Unit_instance;
  }
  function ProfileScreen$lambda$lambda_6($locationPicker) {
    return function () {
      $locationPicker.g11s();
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_85($locationPicker) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C574@31528L27,574@31507L358:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1590071960, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ProfileScreen.kt:574)');
        }
        sourceInformationMarkerStart($composer_0, -949201901, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($locationPicker);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_6($locationPicker);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        IconButton(tmp0_group, null, false, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().q14a_1, $composer_0, 1572864, 62);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_86($isEditing$delegate) {
    return function () {
      ProfileScreen$lambda_31($isEditing$delegate, true);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_87($isEditing$delegate) {
    return function () {
      ProfileScreen$lambda_31($isEditing$delegate, true);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_88() {
    return Unit_instance;
  }
  function ProfileScreen$lambda_89($isEditing$delegate) {
    return function () {
      ProfileScreen$lambda_31($isEditing$delegate, true);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_90($isEditing$delegate) {
    return function () {
      ProfileScreen$lambda_31($isEditing$delegate, true);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_91($isEditing$delegate) {
    return function () {
      ProfileScreen$lambda_31($isEditing$delegate, true);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_92($isEditing$delegate) {
    return function () {
      ProfileScreen$lambda_31($isEditing$delegate, true);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_93($locationPicker, $isEditing$delegate) {
    return function () {
      ProfileScreen$lambda_31($isEditing$delegate, true);
      $locationPicker.g11s();
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_94($showLanguageDialog$delegate) {
    return function () {
      ProfileScreen$lambda_11($showLanguageDialog$delegate, true);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_95($currentLanguage$delegate) {
    return function ($this$OutlinedButton, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C722@40545L55,723@40629L39,725@40735L189,724@40697L257:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1309798491, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ProfileScreen.kt:722)');
        }
        var tmp_0 = get_Language(Icons_getInstance().dxv_1);
        Icon(tmp_0, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
        var tmp_1 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_1, tmp$ret$0), $composer_0, 6);
        var tmp_2 = get_change_language_btn_pattern(string_instance);
        // Inline function 'kotlin.text.uppercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = ProfileScreen$lambda_0($currentLanguage$delegate).toUpperCase();
        var tmp_3 = stringResource_0(tmp_2, [tmp$ret$1], $composer_0, 0);
        var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_8 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_3, null, tmp_4, null, tmp_5, null, null, null, tmp_6, null, null, tmp_7, tmp_8, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_9;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_9 = Unit_instance;
        }
        tmp = tmp_9;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_96() {
    openUrl('https://abdallabadreldin.github.io/Hadaya_privacy_policy/');
    return Unit_instance;
  }
  function ProfileScreen$lambda_97($newPassword$delegate, $confirmPassword$delegate, $showPasswordDialog$delegate) {
    return function () {
      ProfileScreen$lambda_13($newPassword$delegate, '');
      ProfileScreen$lambda_15($confirmPassword$delegate, '');
      ProfileScreen$lambda_7($showPasswordDialog$delegate, true);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_98($showDeleteDialog$delegate) {
    return function () {
      ProfileScreen$lambda_3($showDeleteDialog$delegate, true);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$slambda_1($authRepository, $onLogout, resultContinuation) {
    this.e14g_1 = $authRepository;
    this.f14g_1 = $onLogout;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$lambda$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$lambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$lambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.e14g_1.uyv(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f14g_1();
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProfileScreen$lambda$slambda_1).q24 = function ($this$launch, completion) {
    var i = new ProfileScreen$lambda$slambda_1(this.e14g_1, this.f14g_1, completion);
    i.g14g_1 = $this$launch;
    return i;
  };
  function ProfileScreen$lambda$slambda_2($authRepository, $onLogout, resultContinuation) {
    var i = new ProfileScreen$lambda$slambda_1($authRepository, $onLogout, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProfileScreen$lambda_99($scope, $authRepository, $onLogout) {
    return function () {
      launch($scope, VOID, VOID, ProfileScreen$lambda$slambda_2($authRepository, $onLogout, null));
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_100($profile, $resetEmail$delegate, $showResetPasswordDialog$delegate) {
    return function () {
      var tmp0_elvis_lhs = $profile.vym_1;
      ProfileScreen$lambda_17($resetEmail$delegate, tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
      ProfileScreen$lambda_9($showResetPasswordDialog$delegate, true);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_101($showDatePicker$delegate) {
    return function () {
      ProfileScreen$lambda_61($showDatePicker$delegate, false);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_7($datePickerState, $editBirthday$delegate, $showDatePicker$delegate) {
    return function () {
      var tmp0_safe_receiver = $datePickerState.np1();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var date = toLocalDateTime(Companion_getInstance_19().kf(tmp0_safe_receiver), Companion_getInstance_20().unp()).xn9_1;
        ProfileScreen$lambda_39($editBirthday$delegate, date.toString());
      }
      ProfileScreen$lambda_61($showDatePicker$delegate, false);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_102($datePickerState, $editBirthday$delegate, $showDatePicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C832@45606L367,831@45568L474:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1834336166, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:831)');
        }
        sourceInformationMarkerStart($composer_0, 1860466197, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.k31($datePickerState);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_7($datePickerState, $editBirthday$delegate, $showDatePicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().a14b_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_8($showDatePicker$delegate) {
    return function () {
      ProfileScreen$lambda_61($showDatePicker$delegate, false);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_103($showDatePicker$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C843@46105L26,843@46084L120:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(966408804, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:843)');
        }
        sourceInformationMarkerStart($composer_0, 1005925854, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_8($showDatePicker$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().b14b_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_104($datePickerState) {
    return function ($this$DatePickerDialog, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C847@46230L35:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(250229679, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:847)');
        }
        DatePicker($datePickerState, null, null, null, null, null, false, null, $composer_0, 0, 254);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_105($isDeletingAccount$delegate, $showDeleteDialog$delegate) {
    return function () {
      var tmp;
      if (!ProfileScreen$lambda_28($isDeletingAccount$delegate)) {
        ProfileScreen$lambda_3($showDeleteDialog$delegate, false);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda$slambda_9($authRepository, $isGoogleUser, $onLogout, $snackbarHostState, $delete_account_failed, $isDeletingAccount$delegate, $deletePassword$delegate, $showDeleteDialog$delegate, resultContinuation) {
    this.p14g_1 = $authRepository;
    this.q14g_1 = $isGoogleUser;
    this.r14g_1 = $onLogout;
    this.s14g_1 = $snackbarHostState;
    this.t14g_1 = $delete_account_failed;
    this.u14g_1 = $isDeletingAccount$delegate;
    this.v14g_1 = $deletePassword$delegate;
    this.w14g_1 = $showDeleteDialog$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$lambda$lambda$slambda_9).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_9).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_9).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            ProfileScreen$lambda_29(this.u14g_1, true);
            this.n9_1 = 1;
            suspendResult = this.p14g_1.vyv(this.q14g_1 ? null : ProfileScreen$lambda_18(this.v14g_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var success = suspendResult;
            ProfileScreen$lambda_29(this.u14g_1, false);
            if (success) {
              var tmp_0 = this;
              ProfileScreen$lambda_3(this.w14g_1, false);
              this.r14g_1();
              tmp_0.y14g_1 = Unit_instance;
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = this.s14g_1.dqm(this.t14g_1, VOID, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.y14g_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_9).q24 = function ($this$launch, completion) {
    var i = new ProfileScreen$lambda$lambda$slambda_9(this.p14g_1, this.q14g_1, this.r14g_1, this.s14g_1, this.t14g_1, this.u14g_1, this.v14g_1, this.w14g_1, completion);
    i.x14g_1 = $this$launch;
    return i;
  };
  function ProfileScreen$lambda$lambda$slambda_10($authRepository, $isGoogleUser, $onLogout, $snackbarHostState, $delete_account_failed, $isDeletingAccount$delegate, $deletePassword$delegate, $showDeleteDialog$delegate, resultContinuation) {
    var i = new ProfileScreen$lambda$lambda$slambda_9($authRepository, $isGoogleUser, $onLogout, $snackbarHostState, $delete_account_failed, $isDeletingAccount$delegate, $deletePassword$delegate, $showDeleteDialog$delegate, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProfileScreen$lambda$lambda_9($scope, $authRepository, $isGoogleUser, $onLogout, $snackbarHostState, $delete_account_failed, $isDeletingAccount$delegate, $deletePassword$delegate, $showDeleteDialog$delegate) {
    return function () {
      launch($scope, VOID, VOID, ProfileScreen$lambda$lambda$slambda_10($authRepository, $isGoogleUser, $onLogout, $snackbarHostState, $delete_account_failed, $isDeletingAccount$delegate, $deletePassword$delegate, $showDeleteDialog$delegate, null));
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_10($isDeletingAccount$delegate) {
    return function ($this$TextButton, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1409319718, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous>.<anonymous> (ProfileScreen.kt:910)');
        }
        if (ProfileScreen$lambda_28($isDeletingAccount$delegate)) {
          $composer_0.m30(1738451411);
          sourceInformation($composer_0, '912@49573L11,911@49463L153');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          var tmp_2 = MaterialTheme_instance.unz($composer_0, 6).to0_1;
          var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_0, 6, 60);
          $composer_0.n30();
        } else {
          $composer_0.m30(1738653221);
          sourceInformation($composer_0, '915@49675L33,915@49670L39');
          var tmp_6 = stringResource(get_delete(string_instance), $composer_0, 0);
          var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_11 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_6, null, tmp_7, null, tmp_8, null, null, null, tmp_9, null, null, tmp_10, tmp_11, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
          $composer_0.n30();
        }
        var tmp_12;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_12 = Unit_instance;
        }
        tmp = tmp_12;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_106($isGoogleUser, $profile, $scope, $authRepository, $onLogout, $delete_account_failed, $deleteEmailConfirm$delegate, $deletePassword$delegate, $isDeletingAccount$delegate, $snackbarHostState, $showDeleteDialog$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C907@49292L11,907@49246L64,893@48562L638,909@49392L357,892@48520L1229:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-494406487, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:887)');
        }
        var tmp_0;
        if ($isGoogleUser) {
          tmp_0 = ProfileScreen$lambda_20($deleteEmailConfirm$delegate) === $profile.vym_1;
        } else {
          // Inline function 'kotlin.text.isNotBlank' call
          var this_0 = ProfileScreen$lambda_18($deletePassword$delegate);
          tmp_0 = !isBlank(this_0);
        }
        var canDelete = tmp_0;
        var tmp_1 = ButtonDefaults_getInstance();
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = MaterialTheme_instance.unz($composer_0, 6).to0_1;
        var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp0_colors = tmp_1.fod(tmp_2, tmp_3, tmp_4, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 13);
        var tmp1_enabled = !ProfileScreen$lambda_28($isDeletingAccount$delegate) && canDelete;
        sourceInformationMarkerStart($composer_0, 1616744775, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!(!!(!!($composer_0.q31($scope) | $composer_0.q31($authRepository)) | $composer_0.l31($isGoogleUser)) | $composer_0.k31($onLogout)) | $composer_0.k31($delete_account_failed));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_5;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_9($scope, $authRepository, $isGoogleUser, $onLogout, $snackbarHostState, $delete_account_failed, $isDeletingAccount$delegate, $deletePassword$delegate, $showDeleteDialog$delegate);
          $composer_0.j31(value);
          tmp_5 = value;
        } else {
          tmp_5 = it;
        }
        var tmp0_group = tmp_5;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1409319718, true, ProfileScreen$lambda$lambda_10($isDeletingAccount$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_6;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_6 = value_0;
        } else {
          tmp_6 = it_0;
        }
        var tmp$ret$5 = tmp_6;
        TextButton(tmp0_group, null, tmp1_enabled, null, tmp0_colors, null, null, null, null, tmp$ret$5, $composer_0, 805306368, 490);
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_11($deletePassword$delegate, $deleteEmailConfirm$delegate, $showDeleteDialog$delegate) {
    return function () {
      ProfileScreen$lambda_19($deletePassword$delegate, '');
      ProfileScreen$lambda_21($deleteEmailConfirm$delegate, '');
      ProfileScreen$lambda_3($showDeleteDialog$delegate, false);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_107($deletePassword$delegate, $deleteEmailConfirm$delegate, $showDeleteDialog$delegate, $isDeletingAccount$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C921@49853L164,920@49811L334:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1832755883, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:920)');
        }
        sourceInformationMarkerStart($composer_0, 341814287, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_11($deletePassword$delegate, $deleteEmailConfirm$delegate, $showDeleteDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1 = !ProfileScreen$lambda_28($isDeletingAccount$delegate);
        TextButton(tmp0_group, null, tmp_1, null, null, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().c14b_1, $composer_0, 805306374, 506);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_12($deletePassword$delegate) {
    return function (it) {
      ProfileScreen$lambda_19($deletePassword$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_13($deleteEmailConfirm$delegate) {
    return function (it) {
      ProfileScreen$lambda_21($deleteEmailConfirm$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_14($profile) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C876@47789L25:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-674839871, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous>.<anonymous>.<anonymous> (ProfileScreen.kt:876)');
        }
        var tmp0_elvis_lhs = $profile.vym_1;
        var tmp_0 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
        var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_108($isGoogleUser, $profile, $deletePassword$delegate, $isDeletingAccount$delegate, $deleteEmailConfirm$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C858@46620L1639:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1028532142, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:858)');
        }
        var tmp_0 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = null;
        var verticalArrangement = tmp_0.mdq(tmp$ret$0);
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((5 & 1) === 0))
          modifier = Companion_instance;
        if (!((5 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((5 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 673318873, 'C859@46704L49,859@46699L55:ProfileScreen.kt#2kgzgj');
        var tmp_2 = stringResource(get_delete_account_confirm(string_instance), $composer_5, 0);
        var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_7 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_2, null, tmp_3, null, tmp_4, null, null, null, tmp_5, null, null, tmp_6, tmp_7, false, 0, 0, null, null, $composer_5, 0, 0, 262142);
        if (!$isGoogleUser) {
          $composer_5.m30(673410849);
          sourceInformation($composer_5, '863@46935L23,861@46820L637');
          var tmp0_value = ProfileScreen$lambda_18($deletePassword$delegate);
          var tmp1_modifier = fillMaxWidth(Companion_instance);
          var tmp2_visualTransformation = new PasswordVisualTransformation();
          var tmp3_keyboardOptions = new KeyboardOptions(VOID, VOID, Companion_getInstance_31().c8c_1);
          var tmp4_enabled = !ProfileScreen$lambda_28($isDeletingAccount$delegate);
          sourceInformationMarkerStart($composer_5, -1640841989, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it = $composer_5.i31();
          var tmp_8;
          if (false || it === Companion_getInstance().f30_1) {
            var value = ProfileScreen$lambda$lambda_12($deletePassword$delegate);
            $composer_5.j31(value);
            tmp_8 = value;
          } else {
            tmp_8 = it;
          }
          var tmp0_group = tmp_8;
          sourceInformationMarkerEnd($composer_5);
          var tmp_9 = ComposableSingletons$ProfileScreenKt_getInstance().e14b_1;
          OutlinedTextField(tmp0_value, tmp0_group, tmp1_modifier, tmp4_enabled, false, null, tmp_9, null, null, null, null, null, null, false, tmp2_visualTransformation, tmp3_keyboardOptions, null, true, 0, 0, null, null, null, $composer_5, 1573296, 12779520, 0, 8208304);
          $composer_5.n30();
        } else {
          $composer_5.m30(674098522);
          sourceInformation($composer_5, '874@47630L27,876@47787L29,872@47511L708');
          var tmp5_value = ProfileScreen$lambda_20($deleteEmailConfirm$delegate);
          var tmp6_modifier = fillMaxWidth(Companion_instance);
          var tmp7_keyboardOptions = new KeyboardOptions(VOID, VOID, Companion_getInstance_31().b8c_1);
          var tmp8_enabled = !ProfileScreen$lambda_28($isDeletingAccount$delegate);
          var tmp_10;
          // Inline function 'kotlin.text.isNotBlank' call
          var this_0 = ProfileScreen$lambda_20($deleteEmailConfirm$delegate);
          if (!isBlank(this_0)) {
            tmp_10 = !(ProfileScreen$lambda_20($deleteEmailConfirm$delegate) === $profile.vym_1);
          } else {
            tmp_10 = false;
          }
          var tmp9_isError = tmp_10;
          sourceInformationMarkerStart($composer_5, -1640819745, 'CC(remember):ProfileScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          // Inline function 'kotlin.let' call
          var it_0 = $composer_5.i31();
          var tmp_11;
          if (false || it_0 === Companion_getInstance().f30_1) {
            var value_0 = ProfileScreen$lambda$lambda_13($deleteEmailConfirm$delegate);
            $composer_5.j31(value_0);
            tmp_11 = value_0;
          } else {
            tmp_11 = it_0;
          }
          var tmp1_group = tmp_11;
          sourceInformationMarkerEnd($composer_5);
          var tmp_12 = ComposableSingletons$ProfileScreenKt_getInstance().f14b_1;
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-674839871, true, ProfileScreen$lambda$lambda_14($profile), $composer_5, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_6 = $composer_5;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_6.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_1 = $composer_6.i31();
          var tmp_13;
          if (invalid || it_1 === Companion_getInstance().f30_1) {
            var value_1 = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_6.j31(value_1);
            tmp_13 = value_1;
          } else {
            tmp_13 = it_1;
          }
          var tmp_14 = tmp_13;
          OutlinedTextField(tmp5_value, tmp1_group, tmp6_modifier, tmp8_enabled, false, null, tmp_12, tmp_14, null, null, null, null, null, tmp9_isError, null, tmp7_keyboardOptions, null, true, 0, 0, null, null, null, $composer_5, 14156208, 12779520, 0, 8216368);
          $composer_5.n30();
        }
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_15;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_15 = Unit_instance;
        }
        tmp = tmp_15;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_109($showDeleteAvatarDialog$delegate) {
    return function () {
      ProfileScreen$lambda_5($showDeleteAvatarDialog$delegate, false);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda$slambda_11($authRepository, $showDeleteAvatarDialog$delegate, resultContinuation) {
    this.h14h_1 = $authRepository;
    this.i14h_1 = $showDeleteAvatarDialog$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$lambda$lambda$slambda_11).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_11).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_11).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.h14h_1.ayw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            ProfileScreen$lambda_5(this.i14h_1, false);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_11).q24 = function ($this$launch, completion) {
    var i = new ProfileScreen$lambda$lambda$slambda_11(this.h14h_1, this.i14h_1, completion);
    i.j14h_1 = $this$launch;
    return i;
  };
  function ProfileScreen$lambda$lambda$slambda_12($authRepository, $showDeleteAvatarDialog$delegate, resultContinuation) {
    var i = new ProfileScreen$lambda$lambda$slambda_11($authRepository, $showDeleteAvatarDialog$delegate, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProfileScreen$lambda$lambda_15($scope, $authRepository, $showDeleteAvatarDialog$delegate) {
    return function () {
      launch($scope, VOID, VOID, ProfileScreen$lambda$lambda$slambda_12($authRepository, $showDeleteAvatarDialog$delegate, null));
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_110($scope, $authRepository, $showDeleteAvatarDialog$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C939@50529L205,945@50826L11,945@50780L64,938@50487L455:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1178636792, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:938)');
        }
        sourceInformationMarkerStart($composer_0, 1201411157, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.q31($scope) | $composer_0.q31($authRepository));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_15($scope, $authRepository, $showDeleteAvatarDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1 = ButtonDefaults_getInstance();
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = MaterialTheme_instance.unz($composer_0, 6).to0_1;
        var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_5 = tmp_1.fod(tmp_2, tmp_3, tmp_4, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 13);
        TextButton(tmp0_group, null, false, null, tmp_5, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().g14b_1, $composer_0, 805306368, 494);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_16($showDeleteAvatarDialog$delegate) {
    return function () {
      ProfileScreen$lambda_5($showDeleteAvatarDialog$delegate, false);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_111($showDeleteAvatarDialog$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C951@51025L34,951@51004L136:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1148525578, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:951)');
        }
        sourceInformationMarkerStart($composer_0, -73513332, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_16($showDeleteAvatarDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().h14b_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_112($isUpdatingPassword$delegate, $showPasswordDialog$delegate) {
    return function () {
      var tmp;
      if (!ProfileScreen$lambda_22($isUpdatingPassword$delegate)) {
        ProfileScreen$lambda_7($showPasswordDialog$delegate, false);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda$slambda_13($snackbarHostState, $password_length_error, resultContinuation) {
    this.s14h_1 = $snackbarHostState;
    this.t14h_1 = $password_length_error;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$lambda$lambda$slambda_13).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_13).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_13).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.s14h_1.dqm(this.t14h_1, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_13).q24 = function ($this$launch, completion) {
    var i = new ProfileScreen$lambda$lambda$slambda_13(this.s14h_1, this.t14h_1, completion);
    i.u14h_1 = $this$launch;
    return i;
  };
  function ProfileScreen$lambda$lambda$slambda_14($snackbarHostState, $password_length_error, resultContinuation) {
    var i = new ProfileScreen$lambda$lambda$slambda_13($snackbarHostState, $password_length_error, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProfileScreen$lambda$lambda$slambda_15($snackbarHostState, $passwords_dont_match, resultContinuation) {
    this.d14i_1 = $snackbarHostState;
    this.e14i_1 = $passwords_dont_match;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$lambda$lambda$slambda_15).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_15).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_15).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.d14i_1.dqm(this.e14i_1, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_15).q24 = function ($this$launch, completion) {
    var i = new ProfileScreen$lambda$lambda$slambda_15(this.d14i_1, this.e14i_1, completion);
    i.f14i_1 = $this$launch;
    return i;
  };
  function ProfileScreen$lambda$lambda$slambda_16($snackbarHostState, $passwords_dont_match, resultContinuation) {
    var i = new ProfileScreen$lambda$lambda$slambda_15($snackbarHostState, $passwords_dont_match, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProfileScreen$lambda$lambda$slambda_17($authRepository, $snackbarHostState, $password_updated, $failed_to_update_password, $isUpdatingPassword$delegate, $newPassword$delegate, $showPasswordDialog$delegate, resultContinuation) {
    this.o14i_1 = $authRepository;
    this.p14i_1 = $snackbarHostState;
    this.q14i_1 = $password_updated;
    this.r14i_1 = $failed_to_update_password;
    this.s14i_1 = $isUpdatingPassword$delegate;
    this.t14i_1 = $newPassword$delegate;
    this.u14i_1 = $showPasswordDialog$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$lambda$lambda$slambda_17).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_17).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_17).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            ProfileScreen$lambda_23(this.s14i_1, true);
            this.n9_1 = 1;
            suspendResult = this.o14i_1.cyw(ProfileScreen$lambda_12(this.t14i_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var success = suspendResult;
            ProfileScreen$lambda_23(this.s14i_1, false);
            if (success) {
              ProfileScreen$lambda_7(this.u14i_1, false);
              this.n9_1 = 3;
              suspendResult = this.p14i_1.dqm(this.q14i_1, VOID, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = this.p14i_1.dqm(this.r14i_1, VOID, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.w14i_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.w14i_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_17).q24 = function ($this$launch, completion) {
    var i = new ProfileScreen$lambda$lambda$slambda_17(this.o14i_1, this.p14i_1, this.q14i_1, this.r14i_1, this.s14i_1, this.t14i_1, this.u14i_1, completion);
    i.v14i_1 = $this$launch;
    return i;
  };
  function ProfileScreen$lambda$lambda$slambda_18($authRepository, $snackbarHostState, $password_updated, $failed_to_update_password, $isUpdatingPassword$delegate, $newPassword$delegate, $showPasswordDialog$delegate, resultContinuation) {
    var i = new ProfileScreen$lambda$lambda$slambda_17($authRepository, $snackbarHostState, $password_updated, $failed_to_update_password, $isUpdatingPassword$delegate, $newPassword$delegate, $showPasswordDialog$delegate, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProfileScreen$lambda$lambda_17($scope, $newPassword$delegate, $snackbarHostState, $password_length_error, $confirmPassword$delegate, $passwords_dont_match, $authRepository, $password_updated, $failed_to_update_password, $isUpdatingPassword$delegate, $showPasswordDialog$delegate) {
    return function () {
      var tmp;
      if (ProfileScreen$lambda_12($newPassword$delegate).length < 6) {
        launch($scope, VOID, VOID, ProfileScreen$lambda$lambda$slambda_14($snackbarHostState, $password_length_error, null));
        return Unit_instance;
      }
      var tmp_0;
      if (!(ProfileScreen$lambda_12($newPassword$delegate) === ProfileScreen$lambda_14($confirmPassword$delegate))) {
        launch($scope, VOID, VOID, ProfileScreen$lambda$lambda$slambda_16($snackbarHostState, $passwords_dont_match, null));
        return Unit_instance;
      }
      launch($scope, VOID, VOID, ProfileScreen$lambda$lambda$slambda_18($authRepository, $snackbarHostState, $password_updated, $failed_to_update_password, $isUpdatingPassword$delegate, $newPassword$delegate, $showPasswordDialog$delegate, null));
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_18($isUpdatingPassword$delegate) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1774238889, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous>.<anonymous> (ProfileScreen.kt:1009)');
        }
        if (ProfileScreen$lambda_22($isUpdatingPassword$delegate)) {
          $composer_0.m30(1811822530);
          sourceInformation($composer_0, '1012@54157L11,1010@54019L185');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          var tmp_2 = MaterialTheme_instance.unz($composer_0, 6).ynz_1;
          var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_0, 6, 60);
          $composer_0.n30();
        } else {
          $composer_0.m30(1812055092);
          sourceInformation($composer_0, '1015@54263L33,1015@54258L39');
          var tmp_6 = stringResource(get_update(string_instance), $composer_0, 0);
          var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_11 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_6, null, tmp_7, null, tmp_8, null, null, null, tmp_9, null, null, tmp_10, tmp_11, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
          $composer_0.n30();
        }
        var tmp_12;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_12 = Unit_instance;
        }
        tmp = tmp_12;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_113($scope, $password_length_error, $passwords_dont_match, $authRepository, $password_updated, $failed_to_update_password, $newPassword$delegate, $snackbarHostState, $confirmPassword$delegate, $isUpdatingPassword$delegate, $showPasswordDialog$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C986@52746L1071,1008@53947L390,985@52708L1629:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1862867097, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:985)');
        }
        sourceInformationMarkerStart($composer_0, 786085078, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!(!!(!!(!!($composer_0.q31($scope) | $composer_0.k31($password_length_error)) | $composer_0.k31($passwords_dont_match)) | $composer_0.q31($authRepository)) | $composer_0.k31($password_updated)) | $composer_0.k31($failed_to_update_password));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_17($scope, $newPassword$delegate, $snackbarHostState, $password_length_error, $confirmPassword$delegate, $passwords_dont_match, $authRepository, $password_updated, $failed_to_update_password, $isUpdatingPassword$delegate, $showPasswordDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1;
        var tmp_2;
        if (!ProfileScreen$lambda_22($isUpdatingPassword$delegate)) {
          // Inline function 'kotlin.text.isNotBlank' call
          var this_0 = ProfileScreen$lambda_12($newPassword$delegate);
          tmp_2 = !isBlank(this_0);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          // Inline function 'kotlin.text.isNotBlank' call
          var this_1 = ProfileScreen$lambda_14($confirmPassword$delegate);
          tmp_1 = !isBlank(this_1);
        } else {
          tmp_1 = false;
        }
        var tmp_3 = tmp_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1774238889, true, ProfileScreen$lambda$lambda_18($isUpdatingPassword$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_4;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_0;
        }
        var tmp$ret$6 = tmp_4;
        Button(tmp0_group, null, tmp_3, null, null, null, null, null, null, tmp$ret$6, $composer_0, 805306368, 506);
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp = tmp_5;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_19($showPasswordDialog$delegate) {
    return function () {
      ProfileScreen$lambda_7($showPasswordDialog$delegate, false);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_114($showPasswordDialog$delegate, $isUpdatingPassword$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1021@54441L30,1020@54399L201:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(464295273, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:1020)');
        }
        sourceInformationMarkerStart($composer_0, -488839481, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_19($showPasswordDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1 = !ProfileScreen$lambda_22($isUpdatingPassword$delegate);
        TextButton(tmp0_group, null, tmp_1, null, null, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().k14b_1, $composer_0, 805306374, 506);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_20($newPassword$delegate) {
    return function (it) {
      ProfileScreen$lambda_13($newPassword$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_21($confirmPassword$delegate) {
    return function (it) {
      ProfileScreen$lambda_15($confirmPassword$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_115($newPassword$delegate, $confirmPassword$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C963@51426L1220:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-339928468, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:963)');
        }
        var tmp_0 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = null;
        var verticalArrangement = tmp_0.mdq(tmp$ret$0);
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((5 & 1) === 0))
          modifier = Companion_instance;
        if (!((5 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((5 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 692847006, 'C966@51609L20,964@51505L545,975@52179L24,973@52071L557:ProfileScreen.kt#2kgzgj');
        var tmp0_value = ProfileScreen$lambda_12($newPassword$delegate);
        var tmp1_modifier = fillMaxWidth(Companion_instance);
        var tmp2_visualTransformation = new PasswordVisualTransformation();
        var tmp3_keyboardOptions = new KeyboardOptions(VOID, VOID, Companion_getInstance_31().c8c_1);
        sourceInformationMarkerStart($composer_5, 1823467446, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_5.i31();
        var tmp_2;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_20($newPassword$delegate);
          $composer_5.j31(value);
          tmp_2 = value;
        } else {
          tmp_2 = it;
        }
        var tmp0_group = tmp_2;
        sourceInformationMarkerEnd($composer_5);
        var tmp_3 = ComposableSingletons$ProfileScreenKt_getInstance().m14b_1;
        OutlinedTextField(tmp0_value, tmp0_group, tmp1_modifier, false, false, null, tmp_3, null, null, null, null, null, null, false, tmp2_visualTransformation, tmp3_keyboardOptions, null, true, 0, 0, null, null, null, $composer_5, 1573296, 12779520, 0, 8208312);
        var tmp4_value = ProfileScreen$lambda_14($confirmPassword$delegate);
        var tmp5_modifier = fillMaxWidth(Companion_instance);
        var tmp6_visualTransformation = new PasswordVisualTransformation();
        var tmp7_keyboardOptions = new KeyboardOptions(VOID, VOID, Companion_getInstance_31().c8c_1);
        sourceInformationMarkerStart($composer_5, 1823485690, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_0 = $composer_5.i31();
        var tmp_4;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ProfileScreen$lambda$lambda_21($confirmPassword$delegate);
          $composer_5.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_0;
        }
        var tmp1_group = tmp_4;
        sourceInformationMarkerEnd($composer_5);
        var tmp_5 = ComposableSingletons$ProfileScreenKt_getInstance().n14b_1;
        OutlinedTextField(tmp4_value, tmp1_group, tmp5_modifier, false, false, null, tmp_5, null, null, null, null, null, null, false, tmp6_visualTransformation, tmp7_keyboardOptions, null, true, 0, 0, null, null, null, $composer_5, 1573296, 12779520, 0, 8208312);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_116($isResettingPassword$delegate, $showResetPasswordDialog$delegate) {
    return function () {
      var tmp;
      if (!ProfileScreen$lambda_24($isResettingPassword$delegate)) {
        ProfileScreen$lambda_9($showResetPasswordDialog$delegate, false);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda$slambda_19($authRepository, $snackbarHostState, $isResettingPassword$delegate, $resetEmail$delegate, $showResetPasswordDialog$delegate, resultContinuation) {
    this.f14j_1 = $authRepository;
    this.g14j_1 = $snackbarHostState;
    this.h14j_1 = $isResettingPassword$delegate;
    this.i14j_1 = $resetEmail$delegate;
    this.j14j_1 = $showResetPasswordDialog$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProfileScreen$lambda$lambda$slambda_19).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_19).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_19).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            ProfileScreen$lambda_25(this.h14j_1, true);
            this.l14j_1 = Unit_instance;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 8;
            this.o9_1 = 5;
            this.n9_1 = 2;
            suspendResult = this.f14j_1.syv(ProfileScreen$lambda_16(this.i14j_1), getOrigin(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = getString(get_password_reset_sent(string_instance), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            this.n9_1 = 4;
            suspendResult = this.g14j_1.dqm(ARGUMENT, VOID, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var tmp_0 = this;
            ProfileScreen$lambda_9(this.j14j_1, false);
            tmp_0.l14j_1 = Unit_instance;
            this.o9_1 = 9;
            this.n9_1 = 7;
            continue $sm;
          case 5:
            this.o9_1 = 8;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Exception) {
              var e = this.q9_1;
              this.n9_1 = 6;
              suspendResult = this.g14j_1.dqm('Failed to send reset link: ' + e.message, VOID, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 6:
            this.l14j_1 = suspendResult;
            this.o9_1 = 9;
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.l14j_1;
            this.o9_1 = 9;
            ProfileScreen$lambda_25(this.h14j_1, false);
            return Unit_instance;
          case 8:
            this.o9_1 = 9;
            var t = this.q9_1;
            ProfileScreen$lambda_25(this.h14j_1, false);
            throw t;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 9) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(ProfileScreen$lambda$lambda$slambda_19).q24 = function ($this$launch, completion) {
    var i = new ProfileScreen$lambda$lambda$slambda_19(this.f14j_1, this.g14j_1, this.h14j_1, this.i14j_1, this.j14j_1, completion);
    i.k14j_1 = $this$launch;
    return i;
  };
  function ProfileScreen$lambda$lambda$slambda_20($authRepository, $snackbarHostState, $isResettingPassword$delegate, $resetEmail$delegate, $showResetPasswordDialog$delegate, resultContinuation) {
    var i = new ProfileScreen$lambda$lambda$slambda_19($authRepository, $snackbarHostState, $isResettingPassword$delegate, $resetEmail$delegate, $showResetPasswordDialog$delegate, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ProfileScreen$lambda$lambda_22($scope, $authRepository, $snackbarHostState, $isResettingPassword$delegate, $resetEmail$delegate, $showResetPasswordDialog$delegate) {
    return function () {
      launch($scope, VOID, VOID, ProfileScreen$lambda$lambda$slambda_20($authRepository, $snackbarHostState, $isResettingPassword$delegate, $resetEmail$delegate, $showResetPasswordDialog$delegate, null));
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_23($isResettingPassword$delegate) {
    return function ($this$Button, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1836498102, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous>.<anonymous> (ProfileScreen.kt:1071)');
        }
        if (ProfileScreen$lambda_24($isResettingPassword$delegate)) {
          $composer_0.m30(1821594083);
          sourceInformation($composer_0, '1074@56976L11,1072@56838L185');
          var tmp_0 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$0 = _Dp___init__impl__ms3zkb(24);
          var tmp_1 = size(tmp_0, tmp$ret$0);
          var tmp_2 = MaterialTheme_instance.unz($composer_0, 6).ynz_1;
          var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_5 = _StrokeCap___init__impl__kfgr27(0);
          CircularProgressIndicator(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, _Dp___init__impl__ms3zkb(0.0), $composer_0, 6, 60);
          $composer_0.n30();
        } else {
          $composer_0.m30(1821827048);
          sourceInformation($composer_0, '1077@57082L46,1077@57077L52');
          var tmp_6 = stringResource(get_send_reset_link_btn(string_instance), $composer_0, 0);
          var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_11 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp_6, null, tmp_7, null, tmp_8, null, null, null, tmp_9, null, null, tmp_10, tmp_11, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
          $composer_0.n30();
        }
        var tmp_12;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_12 = Unit_instance;
        }
        tmp = tmp_12;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_117($scope, $authRepository, $snackbarHostState, $isResettingPassword$delegate, $resetEmail$delegate, $showResetPasswordDialog$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1048@55638L1029,1070@56765L404,1047@55600L1569:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1747869894, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:1047)');
        }
        sourceInformationMarkerStart($composer_0, 370758219, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.q31($scope) | $composer_0.q31($authRepository));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_22($scope, $authRepository, $snackbarHostState, $isResettingPassword$delegate, $resetEmail$delegate, $showResetPasswordDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1;
        if (!ProfileScreen$lambda_24($isResettingPassword$delegate)) {
          // Inline function 'kotlin.text.isNotBlank' call
          var this_0 = ProfileScreen$lambda_16($resetEmail$delegate);
          tmp_1 = !isBlank(this_0);
        } else {
          tmp_1 = false;
        }
        var tmp_2 = tmp_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1836498102, true, ProfileScreen$lambda$lambda_23($isResettingPassword$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_3;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_1.j31(value_0);
          tmp_3 = value_0;
        } else {
          tmp_3 = it_0;
        }
        var tmp$ret$5 = tmp_3;
        Button(tmp0_group, null, tmp_2, null, null, null, null, null, null, tmp$ret$5, $composer_0, 805306368, 506);
        var tmp_4;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_4 = Unit_instance;
        }
        tmp = tmp_4;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_24($showResetPasswordDialog$delegate) {
    return function () {
      ProfileScreen$lambda_9($showResetPasswordDialog$delegate, false);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_118($showResetPasswordDialog$delegate, $isResettingPassword$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1083@57273L35,1082@57231L207:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-219935032, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:1082)');
        }
        sourceInformationMarkerStart($composer_0, -904166293, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_24($showResetPasswordDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1 = !ProfileScreen$lambda_24($isResettingPassword$delegate);
        TextButton(tmp0_group, null, tmp_1, null, null, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().o14b_1, $composer_0, 805306374, 506);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_25($resetEmail$delegate) {
    return function (it) {
      ProfileScreen$lambda_17($resetEmail$delegate, it);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_119($resetEmail$delegate, $isResettingPassword$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1033@54883L655:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1024158773, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:1033)');
        }
        var tmp_0 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = null;
        var verticalArrangement = tmp_0.mdq(tmp$ret$0);
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((5 & 1) === 0))
          modifier = Companion_instance;
        if (!((5 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((5 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 702600052, 'C1034@54962L58,1037@55144L19,1035@55041L479:ProfileScreen.kt#2kgzgj');
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextOverflow___init__impl__obguoe(0);
        Text('Enter your email to receive a password reset link.', null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, null, $composer_5, 6, 0, 262142);
        var tmp0_value = ProfileScreen$lambda_16($resetEmail$delegate);
        var tmp1_modifier = fillMaxWidth(Companion_instance);
        var tmp2_keyboardOptions = new KeyboardOptions(VOID, VOID, Companion_getInstance_31().b8c_1);
        var tmp3_enabled = !ProfileScreen$lambda_24($isResettingPassword$delegate);
        sourceInformationMarkerStart($composer_5, 1408143124, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_5.i31();
        var tmp_7;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_25($resetEmail$delegate);
          $composer_5.j31(value);
          tmp_7 = value;
        } else {
          tmp_7 = it;
        }
        var tmp0_group = tmp_7;
        sourceInformationMarkerEnd($composer_5);
        var tmp_8 = ComposableSingletons$ProfileScreenKt_getInstance().q14b_1;
        OutlinedTextField(tmp0_value, tmp0_group, tmp1_modifier, tmp3_enabled, false, null, tmp_8, null, null, null, null, null, null, false, null, tmp2_keyboardOptions, null, true, 0, 0, null, null, null, $composer_5, 1573296, 12779520, 0, 8224688);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_9;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_9 = Unit_instance;
        }
        tmp = tmp_9;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_120($showLanguageDialog$delegate) {
    return function () {
      ProfileScreen$lambda_11($showLanguageDialog$delegate, false);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_26($showLanguageDialog$delegate) {
    return function () {
      ProfileScreen$lambda_11($showLanguageDialog$delegate, false);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_121($showLanguageDialog$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1111@58378L30,1111@58357L132:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1063639589, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:1111)');
        }
        sourceInformationMarkerStart($composer_0, -44570141, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_26($showLanguageDialog$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$ProfileScreenKt_getInstance().r14b_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_27($authRepository, $showLanguageDialog$delegate) {
    return function () {
      $authRepository.eyw('en');
      ProfileScreen$lambda_11($showLanguageDialog$delegate, false);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda$lambda_28($authRepository, $showLanguageDialog$delegate) {
    return function () {
      $authRepository.eyw('ar');
      ProfileScreen$lambda_11($showLanguageDialog$delegate, false);
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_122($authRepository, $currentLanguage$delegate, $showLanguageDialog$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C1095@57692L603:ProfileScreen.kt#2kgzgj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1708389078, $changed, -1, 'client.fstech.hadaya.presentation.profile.ProfileScreen.<anonymous> (ProfileScreen.kt:1095)');
        }
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = null;
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((7 & 1) === 0))
          modifier = Companion_instance;
        if (!((7 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((7 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 712370551, 'C1097@57761L43,1098@57858L131,1096@57721L268,1103@58050L42,1104@58146L131,1102@58010L267:ProfileScreen.kt#2kgzgj');
        var tmp_1 = stringResource(get_language_english(string_instance), $composer_5, 0);
        var tmp_2 = ProfileScreen$lambda_0($currentLanguage$delegate) === 'en';
        sourceInformationMarkerStart($composer_5, 992814979, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_5.q31($authRepository);
        // Inline function 'kotlin.let' call
        var it = $composer_5.i31();
        var tmp_3;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProfileScreen$lambda$lambda_27($authRepository, $showLanguageDialog$delegate);
          $composer_5.j31(value);
          tmp_3 = value;
        } else {
          tmp_3 = it;
        }
        var tmp0_group = tmp_3;
        sourceInformationMarkerEnd($composer_5);
        LanguageOption(tmp_1, 'en', tmp_2, tmp0_group, $composer_5, 48);
        var tmp_4 = stringResource(get_language_arabic(string_instance), $composer_5, 0);
        var tmp_5 = ProfileScreen$lambda_0($currentLanguage$delegate) === 'ar';
        sourceInformationMarkerStart($composer_5, 992824195, 'CC(remember):ProfileScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_5.q31($authRepository);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_5.i31();
        var tmp_6;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ProfileScreen$lambda$lambda_28($authRepository, $showLanguageDialog$delegate);
          $composer_5.j31(value_0);
          tmp_6 = value_0;
        } else {
          tmp_6 = it_0;
        }
        var tmp1_group = tmp_6;
        sourceInformationMarkerEnd($composer_5);
        LanguageOption(tmp_4, 'ar', tmp_5, tmp1_group, $composer_5, 48);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProfileScreen$lambda_123($onBack, $onLogout, $onNavigateToFriends, $onNavigateToOrderHistory, $onNavigateToFavorites, $onNavigateToCoupons, $onNavigateToStockReminders, $onNavigateToAccountManagement, $$changed, $$default) {
    return function ($composer, $force) {
      ProfileScreen($onBack, $onLogout, $onNavigateToFriends, $onNavigateToOrderHistory, $onNavigateToFavorites, $onNavigateToCoupons, $onNavigateToStockReminders, $onNavigateToAccountManagement._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ProfileInfoItem$lambda($label, $value, $icon, $onClick, $$changed) {
    return function ($composer, $force) {
      ProfileInfoItem($label, $value, $icon, $onClick, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function LanguageOption$lambda($label, $code, $isSelected, $onClick, $$changed) {
    return function ($composer, $force) {
      LanguageOption($label, $code, $isSelected, $onClick, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_reminders_StockRemindersState$stable;
  var client_fstech_hadaya_presentation_reminders_StockRemindersIntent_LoadReminders$stable;
  var client_fstech_hadaya_presentation_reminders_StockRemindersIntent_RemoveReminder$stable;
  var client_fstech_hadaya_presentation_reminders_StockRemindersSideEffect_ShowError$stable;
  function StockRemindersState(products, isLoading, language) {
    products = products === VOID ? emptyList() : products;
    isLoading = isLoading === VOID ? false : isLoading;
    language = language === VOID ? 'en' : language;
    this.m14j_1 = products;
    this.n14j_1 = isLoading;
    this.o14j_1 = language;
  }
  protoOf(StockRemindersState).n121 = function (products, isLoading, language) {
    return new StockRemindersState(products, isLoading, language);
  };
  protoOf(StockRemindersState).p14j = function (products, isLoading, language, $super) {
    products = products === VOID ? this.m14j_1 : products;
    isLoading = isLoading === VOID ? this.n14j_1 : isLoading;
    language = language === VOID ? this.o14j_1 : language;
    return $super === VOID ? this.n121(products, isLoading, language) : $super.n121.call(this, products, isLoading, language);
  };
  protoOf(StockRemindersState).toString = function () {
    return 'StockRemindersState(products=' + toString(this.m14j_1) + ', isLoading=' + this.n14j_1 + ', language=' + this.o14j_1 + ')';
  };
  protoOf(StockRemindersState).hashCode = function () {
    var result = hashCode(this.m14j_1);
    result = imul(result, 31) + getBooleanHashCode(this.n14j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o14j_1) | 0;
    return result;
  };
  protoOf(StockRemindersState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StockRemindersState))
      return false;
    if (!equals(this.m14j_1, other.m14j_1))
      return false;
    if (!(this.n14j_1 === other.n14j_1))
      return false;
    if (!(this.o14j_1 === other.o14j_1))
      return false;
    return true;
  };
  function LoadReminders() {
  }
  protoOf(LoadReminders).toString = function () {
    return 'LoadReminders';
  };
  protoOf(LoadReminders).hashCode = function () {
    return -1024933619;
  };
  protoOf(LoadReminders).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadReminders))
      return false;
    return true;
  };
  var LoadReminders_instance;
  function LoadReminders_getInstance() {
    return LoadReminders_instance;
  }
  function RemoveReminder(productId) {
    this.q14j_1 = productId;
  }
  protoOf(RemoveReminder).toString = function () {
    return 'RemoveReminder(productId=' + this.q14j_1.toString() + ')';
  };
  protoOf(RemoveReminder).hashCode = function () {
    return this.q14j_1.hashCode();
  };
  protoOf(RemoveReminder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemoveReminder))
      return false;
    if (!equalsLong(this.q14j_1, other.q14j_1))
      return false;
    return true;
  };
  function StockRemindersIntent() {
  }
  function StockRemindersScreen(onBack, onNavigateToProductDetails, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(580544686);
    sourceInformation($composer_0, 'C(StockRemindersScreen)61@2810L15,62@2869L16,63@2913L43,65@2962L4086:StockRemindersScreen.kt#ik69yj');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToProductDetails) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(580544686, $dirty, -1, 'client.fstech.hadaya.presentation.reminders.StockRemindersScreen (StockRemindersScreen.kt:60)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(StockRemindersViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      sourceInformationMarkerStart($composer_0, -442297095, 'CC(remember):StockRemindersScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance().f30_1) {
        var value = mutableStateOf(null);
        this_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var productToRemove$delegate = tmp0_group;
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = fillMaxSize(Companion_instance);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_2 = $composer_0;
      if (!((6 & 1) === 0))
        modifier = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_2, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_3 = $composer_2;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_0);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_2 = $composer_4.g30();
      if (!isInterface(tmp_2, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_0);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_5 = $composer_4;
      var $composer_6 = $composer_5;
      sourceInformationMarkerStart($composer_6, 1837243023, 'C68@3128L266,66@3014L443:StockRemindersScreen.kt#ik69yj');
      var tmp_3 = ComposableSingletons$StockRemindersScreenKt_getInstance().r14j_1;
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1598148802, true, StockRemindersScreen$lambda_2(onBack), $composer_6, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_7 = $composer_6;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_7.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_7.i31();
      var tmp_4;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_7.j31(value_0);
        tmp_4 = value_0;
      } else {
        tmp_4 = it_0;
      }
      var tmp_5 = tmp_4;
      var tmp_6 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_7 = WindowInsets(0, 0, 0, 0);
      TopAppBar(tmp_3, null, tmp_5, null, tmp_6, tmp_7, null, null, $composer_6, 390, 218);
      if (StockRemindersScreen$lambda(state$delegate).n14j_1) {
        $composer_6.m30(1837592950);
        sourceInformation($composer_6, '80@3502L124');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = fillMaxSize(Companion_instance);
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_8 = $composer_6;
        if (!((4 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_9 = $composer_8;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_9, 0).hashCode();
        var localMap_0 = $composer_9.t31();
        var materialized_0 = materialize($composer_9, modifier_2);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_10 = $composer_9;
        var tmp_8 = $composer_10.g30();
        if (!isInterface(tmp_8, Applier)) {
          invalidApplier();
        }
        $composer_10.b31();
        if ($composer_10.h30()) {
          $composer_10.c31(tmp0_1);
        } else {
          $composer_10.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_10);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_11 = $composer_10;
        var $composer_12 = $composer_11;
        sourceInformationMarkerStart($composer_12, 992212465, 'C81@3585L27:StockRemindersScreen.kt#ik69yj');
        var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_10 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_12 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_9, tmp_10, tmp_11, tmp_12, _Dp___init__impl__ms3zkb(0.0), $composer_12, 0, 63);
        sourceInformationMarkerEnd($composer_12);
        $composer_10.e31();
        $composer_6.n30();
      } else if (StockRemindersScreen$lambda(state$delegate).m14j_1.r()) {
        $composer_6.m30(1837793954);
        sourceInformation($composer_6, '84@3686L720');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_3 = fillMaxSize(Companion_instance);
        var contentAlignment_0 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_0 = false;
        var $composer_13 = $composer_6;
        if (!((4 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_14 = $composer_13;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_14, 0).hashCode();
        var localMap_1 = $composer_14.t31();
        var materialized_1 = materialize($composer_14, modifier_4);
        var tmp0_2 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_15 = $composer_14;
        var tmp_13 = $composer_15.g30();
        if (!isInterface(tmp_13, Applier)) {
          invalidApplier();
        }
        $composer_15.b31();
        if ($composer_15.h30()) {
          $composer_15.c31(tmp0_2);
        } else {
          $composer_15.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_15);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_16 = $composer_15;
        var $composer_17 = $composer_16;
        sourceInformationMarkerStart($composer_17, -604912186, 'C85@3769L623:StockRemindersScreen.kt#ik69yj');
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_5 = null;
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = Companion_getInstance_11().x8t_1;
        var $composer_18 = $composer_17;
        if (!((3 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((3 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((3 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_2 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_18, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_19 = $composer_18;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_19, 0).hashCode();
        var localMap_2 = $composer_19.t31();
        var materialized_2 = materialize($composer_19, modifier_6);
        var tmp0_3 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_20 = $composer_19;
        var tmp_14 = $composer_20.g30();
        if (!isInterface(tmp_14, Applier)) {
          invalidApplier();
        }
        $composer_20.b31();
        if ($composer_20.h30()) {
          $composer_20.c31(tmp0_3);
        } else {
          $composer_20.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_20);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_21 = $composer_20;
        var $composer_22 = $composer_21;
        sourceInformationMarkerStart($composer_22, -675686849, 'C90@4066L11,86@3850L278,92@4149L41,94@4241L43,95@4332L10,93@4211L163:StockRemindersScreen.kt#ik69yj');
        var tmp_15 = get_NotificationsNone(Icons_getInstance().dxv_1);
        var tmp_16 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$37 = _Dp___init__impl__ms3zkb(64);
        Icon(tmp_15, null, size(tmp_16, tmp$ret$37), Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_22, 6).co0_1, 0.3), $composer_22, 432, 0);
        var tmp_17 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$38 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_17, tmp$ret$38), $composer_22, 6);
        var tmp_18 = stringResource(get_no_reminders_yet(string_instance), $composer_22, 0);
        var tmp_19 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_21 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_22 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_23 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_18, null, tmp_19, null, tmp_20, null, null, null, tmp_21, null, null, tmp_22, tmp_23, false, 0, 0, null, MaterialTheme_instance.jog($composer_22, 6).oof_1, $composer_22, 0, 0, 131070);
        sourceInformationMarkerEnd($composer_22);
        $composer_20.e31();
        sourceInformationMarkerEnd($composer_17);
        $composer_15.e31();
        $composer_6.n30();
      } else {
        $composer_6.m30(1838558259);
        sourceInformation($composer_6, '103@4576L1235,100@4436L1375');
        var tmp_24 = fillMaxSize(Companion_instance);
        var tmp_25 = Companion_getInstance_11().l8t_1;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(1692525118, true, StockRemindersScreen$lambda_3(state$delegate, onNavigateToProductDetails, productToRemove$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_23 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_23.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_23.i31();
        var tmp_26;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_1 = ComposableLambda$invoke$ref_12(dispatchReceiver_0);
          $composer_23.j31(value_1);
          tmp_26 = value_1;
        } else {
          tmp_26 = it_1;
        }
        var tmp$ret$39 = tmp_26;
        BoxWithConstraints(tmp_24, tmp_25, false, tmp$ret$39, $composer_6, 3126, 4);
        $composer_6.n30();
      }
      if (!(StockRemindersScreen$lambda_0(productToRemove$delegate) == null)) {
        $composer_6.m30(1839978028);
        sourceInformation($composer_6, '137@5922L26,140@6151L657,157@6842L176,136@5874L1158');
        sourceInformationMarkerStart($composer_6, 197902290, 'CC(remember):StockRemindersScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_2 = $composer_6.i31();
        var tmp_27;
        if (false || it_2 === Companion_getInstance().f30_1) {
          var value_2 = StockRemindersScreen$lambda_4(productToRemove$delegate);
          $composer_6.j31(value_2);
          tmp_27 = value_2;
        } else {
          tmp_27 = it_2;
        }
        var tmp0_group_0 = tmp_27;
        sourceInformationMarkerEnd($composer_6);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(511533742, true, StockRemindersScreen$lambda_5(viewModel, productToRemove$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_24 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_24.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_3 = $composer_24.i31();
        var tmp_28;
        if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
          var value_3 = ComposableLambda$invoke$ref(dispatchReceiver_1);
          $composer_24.j31(value_3);
          tmp_28 = value_3;
        } else {
          tmp_28 = it_3;
        }
        var tmp_29 = tmp_28;
        // Inline function 'kotlin.run' call
        var dispatchReceiver_2 = rememberComposableLambda(-802296144, true, StockRemindersScreen$lambda_6(productToRemove$delegate), $composer_6, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_25 = $composer_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_25.k31(dispatchReceiver_2);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_25.i31();
        var tmp_30;
        if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
          var value_4 = ComposableLambda$invoke$ref(dispatchReceiver_2);
          $composer_25.j31(value_4);
          tmp_30 = value_4;
        } else {
          tmp_30 = it_4;
        }
        var tmp_31 = tmp_30;
        var tmp_32 = ComposableSingletons$StockRemindersScreenKt_getInstance().v14j_1;
        var tmp_33 = ComposableSingletons$StockRemindersScreenKt_getInstance().w14j_1;
        var tmp_34 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_35 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_36 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_37 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_38 = _Dp___init__impl__ms3zkb(0.0);
        AlertDialog(tmp0_group_0, tmp_29, null, tmp_31, null, tmp_32, tmp_33, null, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, null, $composer_6, 1772598, 0, 16276);
        $composer_6.n30();
      } else {
        $composer_6.m30(1841113930);
        $composer_6.n30();
      }
      sourceInformationMarkerEnd($composer_6);
      $composer_4.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(StockRemindersScreen$lambda_7(onBack, onNavigateToProductDetails, $changed));
    }
  }
  function ComposableSingletons$StockRemindersScreenKt$lambda$682973116$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C67@3052L42,67@3047L48:StockRemindersScreen.kt#ik69yj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(682973116, $changed, -1, 'client.fstech.hadaya.presentation.reminders.ComposableSingletons$StockRemindersScreenKt.lambda$682973116.<anonymous> (StockRemindersScreen.kt:67)');
      }
      var tmp = stringResource(get_stock_reminders(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$StockRemindersScreenKt$lambda$_1088569252$lambda_fpk4pc($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C72@3309L31,70@3197L165:StockRemindersScreen.kt#ik69yj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1088569252, $changed, -1, 'client.fstech.hadaya.presentation.reminders.ComposableSingletons$StockRemindersScreenKt.lambda$-1088569252.<anonymous> (StockRemindersScreen.kt:70)');
      }
      var tmp = get_ArrowBack(Filled_instance_0);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$StockRemindersScreenKt$lambda$_219012053$lambda_ybx8p3($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C152@6640L33,153@6725L11,151@6606L162:StockRemindersScreen.kt#ik69yj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-219012053, $changed, -1, 'client.fstech.hadaya.presentation.reminders.ComposableSingletons$StockRemindersScreenKt.lambda$-219012053.<anonymous> (StockRemindersScreen.kt:151)');
      }
      var tmp = stringResource(get_delete(string_instance), $composer_0, 0);
      var tmp_0 = MaterialTheme_instance.unz($composer_0, 6).to0_1;
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262138);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$StockRemindersScreenKt$lambda$_1532841939$lambda_tv0khz($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C159@6944L33,159@6939L39:StockRemindersScreen.kt#ik69yj');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1532841939, $changed, -1, 'client.fstech.hadaya.presentation.reminders.ComposableSingletons$StockRemindersScreenKt.lambda$-1532841939.<anonymous> (StockRemindersScreen.kt:159)');
      }
      var tmp = stringResource(get_cancel(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$StockRemindersScreenKt$lambda$_2116126030$lambda_k4ad6y($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C138@5981L48,138@5976L54:StockRemindersScreen.kt#ik69yj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2116126030, $changed, -1, 'client.fstech.hadaya.presentation.reminders.ComposableSingletons$StockRemindersScreenKt.lambda$-2116126030.<anonymous> (StockRemindersScreen.kt:138)');
      }
      var tmp = stringResource(get_remove_reminder_title(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$StockRemindersScreenKt$lambda$_625557325$lambda_yk6fvc($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C139@6064L50,139@6059L56:StockRemindersScreen.kt#ik69yj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-625557325, $changed, -1, 'client.fstech.hadaya.presentation.reminders.ComposableSingletons$StockRemindersScreenKt.lambda$-625557325.<anonymous> (StockRemindersScreen.kt:139)');
      }
      var tmp = stringResource(get_remove_reminder_confirm(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$StockRemindersScreenKt$lambda$915873790$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C216@9016L11,213@8855L202:StockRemindersScreen.kt#ik69yj');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(915873790, $changed, -1, 'client.fstech.hadaya.presentation.reminders.ComposableSingletons$StockRemindersScreenKt.lambda$915873790.<anonymous> (StockRemindersScreen.kt:213)');
      }
      var tmp = get_NotificationsActive(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, MaterialTheme_instance.unz($composer_0, 6).xnz_1, $composer_0, 48, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$StockRemindersScreenKt() {
    ComposableSingletons$StockRemindersScreenKt_instance = this;
    var tmp = this;
    tmp.r14j_1 = ComposableLambda$invoke$ref(composableLambdaInstance(682973116, false, ComposableSingletons$StockRemindersScreenKt$lambda$682973116$lambda));
    var tmp_0 = this;
    tmp_0.s14j_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1088569252, false, ComposableSingletons$StockRemindersScreenKt$lambda$_1088569252$lambda_fpk4pc));
    var tmp_1 = this;
    tmp_1.t14j_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-219012053, false, ComposableSingletons$StockRemindersScreenKt$lambda$_219012053$lambda_ybx8p3));
    var tmp_2 = this;
    tmp_2.u14j_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1532841939, false, ComposableSingletons$StockRemindersScreenKt$lambda$_1532841939$lambda_tv0khz));
    var tmp_3 = this;
    tmp_3.v14j_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-2116126030, false, ComposableSingletons$StockRemindersScreenKt$lambda$_2116126030$lambda_k4ad6y));
    var tmp_4 = this;
    tmp_4.w14j_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-625557325, false, ComposableSingletons$StockRemindersScreenKt$lambda$_625557325$lambda_yk6fvc));
    var tmp_5 = this;
    tmp_5.x14j_1 = ComposableLambda$invoke$ref(composableLambdaInstance(915873790, false, ComposableSingletons$StockRemindersScreenKt$lambda$915873790$lambda));
  }
  var ComposableSingletons$StockRemindersScreenKt_instance;
  function ComposableSingletons$StockRemindersScreenKt_getInstance() {
    if (ComposableSingletons$StockRemindersScreenKt_instance == null)
      new ComposableSingletons$StockRemindersScreenKt();
    return ComposableSingletons$StockRemindersScreenKt_instance;
  }
  function RemindedProductItem(product, language, onClick, onRemoveReminder, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1798847350);
    sourceInformation($composer_0, 'C(RemindedProductItem)P(3)182@7546L38,183@7591L2218,179@7391L2418:StockRemindersScreen.kt#ik69yj');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(product) : $composer_0.q31(product)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(language) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onRemoveReminder) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1798847350, $dirty, -1, 'client.fstech.hadaya.presentation.reminders.RemindedProductItem (StockRemindersScreen.kt:173)');
      }
      var tmp;
      if (language === 'en') {
        var tmp0_elvis_lhs = product.ozt_1;
        tmp = tmp0_elvis_lhs == null ? product.pzt_1 : tmp0_elvis_lhs;
      } else {
        var tmp1_elvis_lhs = product.pzt_1;
        tmp = tmp1_elvis_lhs == null ? product.ozt_1 : tmp1_elvis_lhs;
      }
      var tmp2_elvis_lhs = tmp;
      var name = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
      var tmp3_elvis_lhs = product.szt_1;
      var price = tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs;
      var tmp_0 = clickable(fillMaxWidth(Companion_instance), VOID, VOID, VOID, VOID, onClick);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
      var tmp_1 = RoundedCornerShape(tmp$ret$0);
      var tmp_2 = CardDefaults_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_3 = _Dp___init__impl__ms3zkb(2);
      var tmp_4 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_5 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_6 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_7 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_8 = tmp_2.pog(tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, _Dp___init__impl__ms3zkb(0.0), $composer_0, 1572870, 62);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(1876250584, true, RemindedProductItem$lambda(product, name, onRemoveReminder, price), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_9;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref_6(dispatchReceiver);
        $composer_1.j31(value);
        tmp_9 = value;
      } else {
        tmp_9 = it;
      }
      var tmp$ret$2 = tmp_9;
      Card(tmp_0, tmp_1, null, tmp_8, null, tmp$ret$2, $composer_0, 196608, 20);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(RemindedProductItem$lambda_0(product, language, onClick, onRemoveReminder, $changed));
    }
  }
  function StockRemindersScreen$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function StockRemindersScreen$lambda_0($productToRemove$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('productToRemove', KMutableProperty0, true);
    return $productToRemove$delegate.u1();
  }
  function StockRemindersScreen$lambda_1($productToRemove$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('productToRemove', KMutableProperty0, true);
    $productToRemove$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function StockRemindersScreen$lambda_2($onBack) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C69@3146L234:StockRemindersScreen.kt#ik69yj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1598148802, $changed, -1, 'client.fstech.hadaya.presentation.reminders.StockRemindersScreen.<anonymous>.<anonymous> (StockRemindersScreen.kt:69)');
        }
        IconButton($onBack, null, false, null, null, null, ComposableSingletons$StockRemindersScreenKt_getInstance().s14j_1, $composer_0, 1572864, 62);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function StockRemindersScreen$lambda$lambda$lambda(it) {
    var tmp0_elvis_lhs = it.nzt_1;
    return tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
  }
  function StockRemindersScreen$lambda$lambda$lambda_0(it) {
    return null;
  }
  function StockRemindersScreen$lambda$lambda$lambda_1($key, $items) {
    return function (index) {
      return $key($items.l1(index));
    };
  }
  function StockRemindersScreen$lambda$lambda$lambda_2($span, $items) {
    return function ($this$items, it) {
      return $span($this$items, $items.l1(it));
    };
  }
  function StockRemindersScreen$lambda$lambda$lambda_3($contentType, $items) {
    return function (index) {
      return $contentType($items.l1(index));
    };
  }
  function StockRemindersScreen$lambda$lambda$lambda$lambda($onNavigateToProductDetails, $product) {
    return function () {
      $onNavigateToProductDetails($product);
      return Unit_instance;
    };
  }
  function StockRemindersScreen$lambda$lambda$lambda$lambda_0($product, $productToRemove$delegate) {
    return function () {
      StockRemindersScreen$lambda_1($productToRemove$delegate, $product);
      return Unit_instance;
    };
  }
  function StockRemindersScreen$lambda$lambda$lambda_4($items, $onNavigateToProductDetails, $state$delegate, $productToRemove$delegate) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp2 = $items.l1(it);
        var $changed_0 = 14 & $dirty;
        var $composer_1 = $composer_0;
        $composer_1.m30(1549296826);
        sourceInformation($composer_1, 'C*127@5614L39,128@5702L29,124@5453L304:StockRemindersScreen.kt#ik69yj');
        var tmp_2 = StockRemindersScreen$lambda($state$delegate).o14j_1;
        sourceInformationMarkerStart($composer_1, 188529536, 'CC(remember):StockRemindersScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_1.k31($onNavigateToProductDetails) | (($changed_0 & 112 ^ 48) > 32 && $composer_1.q31(tmp2) || ($changed_0 & 48) === 32));
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_3;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = StockRemindersScreen$lambda$lambda$lambda$lambda($onNavigateToProductDetails, tmp2);
          $composer_1.j31(value);
          tmp_3 = value;
        } else {
          tmp_3 = it_0;
        }
        var tmp0_group = tmp_3;
        sourceInformationMarkerEnd($composer_1);
        sourceInformationMarkerStart($composer_1, 188532342, 'CC(remember):StockRemindersScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = ($changed_0 & 112 ^ 48) > 32 && $composer_1.q31(tmp2) || ($changed_0 & 48) === 32;
        // Inline function 'kotlin.let' call
        var it_1 = $composer_1.i31();
        var tmp_4;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = StockRemindersScreen$lambda$lambda$lambda$lambda_0(tmp2, $productToRemove$delegate);
          $composer_1.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_1;
        }
        var tmp1_group = tmp_4;
        sourceInformationMarkerEnd($composer_1);
        RemindedProductItem(tmp2, tmp_2, tmp0_group, tmp1_group, $composer_1, 14 & $changed_0 >> 3);
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function StockRemindersScreen$lambda$lambda($state$delegate, $onNavigateToProductDetails, $productToRemove$delegate) {
    return function ($this$LazyVerticalGrid) {
      var tmp2 = StockRemindersScreen$lambda($state$delegate).m14j_1;
      // Inline function 'androidx.compose.foundation.lazy.grid.items' call
      var key = StockRemindersScreen$lambda$lambda$lambda;
      var contentType = StockRemindersScreen$lambda$lambda$lambda_0;
      var tmp = tmp2.n1();
      var tmp_0;
      if (!(key == null)) {
        tmp_0 = StockRemindersScreen$lambda$lambda$lambda_1(key, tmp2);
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      var tmp_2;
      if (!(null == null)) {
        tmp_2 = StockRemindersScreen$lambda$lambda$lambda_2(null, tmp2);
      } else {
        tmp_2 = null;
      }
      var tmp_3 = tmp_2;
      var tmp_4 = StockRemindersScreen$lambda$lambda$lambda_3(contentType, tmp2);
      $this$LazyVerticalGrid.fiq(tmp, tmp_1, tmp_3, tmp_4, ComposableLambda$invoke$ref_11(composableLambdaInstance(-1117249557, true, StockRemindersScreen$lambda$lambda$lambda_4(tmp2, $onNavigateToProductDetails, $state$delegate, $productToRemove$delegate))));
      return Unit_instance;
    };
  }
  function StockRemindersScreen$lambda_3($state$delegate, $onNavigateToProductDetails, $productToRemove$delegate) {
    return function ($this$BoxWithConstraints, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C122@5349L448,111@4810L987:StockRemindersScreen.kt#ik69yj');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$BoxWithConstraints) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1692525118, $dirty, -1, 'client.fstech.hadaya.presentation.reminders.StockRemindersScreen.<anonymous>.<anonymous> (StockRemindersScreen.kt:104)');
        }
        var tmp_1;
        var tmp_2 = $this$BoxWithConstraints.wds();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(1200);
        if (Dp__compareTo_impl_tlg3dl(tmp_2, tmp$ret$0) > 0) {
          tmp_1 = 5;
        } else {
          var tmp_3 = $this$BoxWithConstraints.wds();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$1 = _Dp___init__impl__ms3zkb(900);
          if (Dp__compareTo_impl_tlg3dl(tmp_3, tmp$ret$1) > 0) {
            tmp_1 = 4;
          } else {
            var tmp_4 = $this$BoxWithConstraints.wds();
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$2 = _Dp___init__impl__ms3zkb(600);
            if (Dp__compareTo_impl_tlg3dl(tmp_4, tmp$ret$2) > 0) {
              tmp_1 = 3;
            } else {
              tmp_1 = 2;
            }
          }
        }
        var columns = tmp_1;
        var tmp4_columns = new Fixed(columns);
        var tmp_5 = fillMaxSize(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$3 = _Dp___init__impl__ms3zkb(1400);
        var tmp5_modifier = widthIn(tmp_5, VOID, tmp$ret$3);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp0_start = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_end = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_top = _Dp___init__impl__ms3zkb(8);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_bottom = _Dp___init__impl__ms3zkb(16);
        var tmp6_contentPadding = PaddingValues(tmp0_start, tmp2_top, tmp1_end, tmp3_bottom);
        var tmp_6 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(16);
        var tmp7_horizontalArrangement = tmp_6.mdq(tmp$ret$8);
        var tmp_7 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$9 = _Dp___init__impl__ms3zkb(16);
        var tmp8_verticalArrangement = tmp_7.mdq(tmp$ret$9);
        sourceInformationMarkerStart($composer_0, -1275941602, 'CC(remember):StockRemindersScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.k31($state$delegate) | $composer_0.k31($onNavigateToProductDetails));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_8;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = StockRemindersScreen$lambda$lambda($state$delegate, $onNavigateToProductDetails, $productToRemove$delegate);
          $composer_0.j31(value);
          tmp_8 = value;
        } else {
          tmp_8 = it;
        }
        var tmp0_group = tmp_8;
        sourceInformationMarkerEnd($composer_0);
        LazyVerticalGrid(tmp4_columns, tmp5_modifier, null, tmp6_contentPadding, false, tmp8_verticalArrangement, tmp7_horizontalArrangement, null, false, null, tmp0_group, $composer_0, 1769520, 0, 916);
        var tmp_9;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_9 = Unit_instance;
        }
        tmp_0 = tmp_9;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function StockRemindersScreen$lambda_4($productToRemove$delegate) {
    return function () {
      StockRemindersScreen$lambda_1($productToRemove$delegate, null);
      return Unit_instance;
    };
  }
  function StockRemindersScreen$lambda$lambda_0($viewModel, $productToRemove$delegate) {
    return function () {
      var tmp0_safe_receiver = StockRemindersScreen$lambda_0($productToRemove$delegate);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var tmp = $viewModel.s10h();
        var tmp0_elvis_lhs = tmp0_safe_receiver.nzt_1;
        tmp.j10i(new RemoveReminder(tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs));
      }
      StockRemindersScreen$lambda_1($productToRemove$delegate, null);
      return Unit_instance;
    };
  }
  function StockRemindersScreen$lambda_5($viewModel, $productToRemove$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C142@6219L338,141@6173L617:StockRemindersScreen.kt#ik69yj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(511533742, $changed, -1, 'client.fstech.hadaya.presentation.reminders.StockRemindersScreen.<anonymous>.<anonymous> (StockRemindersScreen.kt:141)');
        }
        sourceInformationMarkerStart($composer_0, 1957656832, 'CC(remember):StockRemindersScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($viewModel);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = StockRemindersScreen$lambda$lambda_0($viewModel, $productToRemove$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$StockRemindersScreenKt_getInstance().t14j_1, $composer_0, 805306368, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function StockRemindersScreen$lambda$lambda_1($productToRemove$delegate) {
    return function () {
      StockRemindersScreen$lambda_1($productToRemove$delegate, null);
      return Unit_instance;
    };
  }
  function StockRemindersScreen$lambda_6($productToRemove$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C158@6885L26,158@6864L136:StockRemindersScreen.kt#ik69yj');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-802296144, $changed, -1, 'client.fstech.hadaya.presentation.reminders.StockRemindersScreen.<anonymous>.<anonymous> (StockRemindersScreen.kt:158)');
        }
        sourceInformationMarkerStart($composer_0, 2087520298, 'CC(remember):StockRemindersScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (false || it === Companion_getInstance().f30_1) {
          var value = StockRemindersScreen$lambda$lambda_1($productToRemove$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        TextButton(tmp0_group, null, false, null, null, null, null, null, null, ComposableSingletons$StockRemindersScreenKt_getInstance().u14j_1, $composer_0, 805306374, 510);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function StockRemindersScreen$lambda_7($onBack, $onNavigateToProductDetails, $$changed) {
    return function ($composer, $force) {
      StockRemindersScreen($onBack, $onNavigateToProductDetails, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function RemindedProductItem$lambda($product, $name, $onRemoveReminder, $price) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C184@7601L2202:StockRemindersScreen.kt#ik69yj');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1876250584, $changed, -1, 'client.fstech.hadaya.presentation.reminders.RemindedProductItem.<anonymous> (StockRemindersScreen.kt:184)');
        }
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = null;
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((7 & 1) === 0))
          modifier = Companion_instance;
        if (!((7 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((7 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -1929025082, 'C185@7622L1467,221@9103L690:StockRemindersScreen.kt#ik69yj');
        var tmp_1 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$6 = _Dp___init__impl__ms3zkb(150);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = height(tmp_1, tmp$ret$6);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_2 = $composer_8.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 969871747, 'C209@8677L398:StockRemindersScreen.kt#ik69yj');
        var tmp0_safe_receiver = $product.xzt_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
        var tmp_3;
        if (tmp1_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_4;
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(tmp1_safe_receiver)) {
            tmp_4 = tmp1_safe_receiver;
          } else {
            tmp_4 = null;
          }
          tmp_3 = tmp_4;
        }
        var imageUrl = tmp_3;
        if (!(imageUrl == null)) {
          $composer_10.m30(969953152);
          sourceInformation($composer_10, '188@7830L350');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_3 = fillMaxSize(Companion_instance);
          var contentAlignment_0 = null;
          var propagateMinConstraints_0 = false;
          var $composer_11 = $composer_10;
          if (!((6 & 1) === 0))
            modifier_3 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_0 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_0 = false;
          var measurePolicy_1 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_4 = modifier_3;
          var $composer_12 = $composer_11;
          if (!((0 & 2) === 0))
            modifier_4 = Companion_instance;
          var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
          var localMap_1 = $composer_12.t31();
          var materialized_1 = materialize($composer_12, modifier_4);
          var tmp0_1 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_13 = $composer_12;
          var tmp_5 = $composer_13.g30();
          if (!isInterface(tmp_5, Applier)) {
            invalidApplier();
          }
          $composer_13.b31();
          if ($composer_13.h30()) {
            $composer_13.c31(tmp0_1);
          } else {
            $composer_13.d31();
          }
          var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
          var $composer_14 = $composer_13;
          var $composer_15 = $composer_14;
          sourceInformationMarkerStart($composer_15, -1498652575, 'C189@7895L263:StockRemindersScreen.kt#ik69yj');
          HadayaImage(imageUrl, $name, fillMaxSize(Companion_instance), Companion_getInstance_13().q96_1, $composer_15, 3456, 0);
          sourceInformationMarkerEnd($composer_15);
          $composer_13.e31();
          $composer_10.n30();
        } else {
          $composer_10.m30(970347999);
          sourceInformation($composer_10, '197@8226L415');
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_5 = background(fillMaxSize(Companion_instance), Companion_getInstance_14().l6b_1);
          var contentAlignment_1 = Companion_getInstance_11().o8t_1;
          var propagateMinConstraints_1 = false;
          var $composer_16 = $composer_10;
          if (!((4 & 1) === 0))
            modifier_5 = Companion_instance;
          if (!((4 & 2) === 0))
            contentAlignment_1 = Companion_getInstance_11().k8t_1;
          if (!((4 & 4) === 0))
            propagateMinConstraints_1 = false;
          var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_6 = modifier_5;
          var $composer_17 = $composer_16;
          if (!((0 & 2) === 0))
            modifier_6 = Companion_instance;
          var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
          var localMap_2 = $composer_17.t31();
          var materialized_2 = materialize($composer_17, modifier_6);
          var tmp0_2 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_18 = $composer_17;
          var tmp_6 = $composer_18.g30();
          if (!isInterface(tmp_6, Applier)) {
            invalidApplier();
          }
          $composer_18.b31();
          if ($composer_18.h30()) {
            $composer_18.c31(tmp0_2);
          } else {
            $composer_18.d31();
          }
          var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_18);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
          var $composer_19 = $composer_18;
          var $composer_20 = $composer_19;
          sourceInformationMarkerStart($composer_20, -1422144016, 'C201@8426L193:StockRemindersScreen.kt#ik69yj');
          var tmp_7 = get_NotificationsNone(Icons_getInstance().dxv_1);
          Icon(tmp_7, null, null, Companion_getInstance_14().k6b_1, $composer_20, 3120, 4);
          sourceInformationMarkerEnd($composer_20);
          $composer_18.e31();
          $composer_10.n30();
        }
        var tmp_8 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().m8t_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$28 = _Dp___init__impl__ms3zkb(4);
        var tmp_9 = padding_0(tmp_8, tmp$ret$28);
        IconButton($onRemoveReminder, tmp_9, false, null, null, null, ComposableSingletons$StockRemindersScreenKt_getInstance().x14j_1, $composer_10, 1572864, 60);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_10 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$29 = _Dp___init__impl__ms3zkb(12);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_7 = padding_0(tmp_10, tmp$ret$29);
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = null;
        var $composer_21 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_3 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_21, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_22 = $composer_21;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_22, 0).hashCode();
        var localMap_3 = $composer_22.t31();
        var materialized_3 = materialize($composer_22, modifier_8);
        var tmp0_3 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_23 = $composer_22;
        var tmp_11 = $composer_23.g30();
        if (!isInterface(tmp_11, Applier)) {
          invalidApplier();
        }
        $composer_23.b31();
        if ($composer_23.h30()) {
          $composer_23.c31(tmp0_3);
        } else {
          $composer_23.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_23);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_24 = $composer_23;
        var $composer_25 = $composer_24;
        sourceInformationMarkerStart($composer_25, 852539728, 'C222@9164L296,230@9477L40,232@9567L43,233@9654L11,231@9534L245:StockRemindersScreen.kt#ik69yj');
        var tmp0_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp1_fontSize = get_sp(14);
        var tmp2_overflow = Companion_getInstance_23().x7s_1;
        var tmp_12 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        Text($name, null, tmp_12, null, tmp1_fontSize, null, tmp0_fontWeight, null, tmp_13, null, null, tmp_14, tmp2_overflow, false, 2, 2, null, null, $composer_25, 1597440, 221568, 208814);
        var tmp_15 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$36 = _Dp___init__impl__ms3zkb(4);
        Spacer(height(tmp_15, tmp$ret$36), $composer_25, 6);
        var tmp3_text = stringResource_0(get_price_egp(string_instance), [$price], $composer_25, 0);
        var tmp4_color = MaterialTheme_instance.unz($composer_25, 6).xnz_1;
        var tmp5_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp6_fontSize = get_sp(14);
        var tmp_16 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_17 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_18 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp3_text, null, tmp4_color, null, tmp6_fontSize, null, tmp5_fontWeight, null, tmp_16, null, null, tmp_17, tmp_18, false, 0, 0, null, null, $composer_25, 1597440, 0, 262058);
        sourceInformationMarkerEnd($composer_25);
        $composer_23.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_19;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_19 = Unit_instance;
        }
        tmp = tmp_19;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function RemindedProductItem$lambda_0($product, $language, $onClick, $onRemoveReminder, $$changed) {
    return function ($composer, $force) {
      RemindedProductItem($product, $language, $onClick, $onRemoveReminder, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_reminders_StockRemindersViewModel$stable;
  function StockRemindersViewModel$observeLanguage$slambda$slambda$lambda($lang) {
    return function ($this$updateState) {
      return $this$updateState.p14j(VOID, VOID, $lang);
    };
  }
  function StockRemindersViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation) {
    this.g14k_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StockRemindersViewModel$observeLanguage$slambda$slambda).pyo = function (lang, $completion) {
    var tmp = this.um9(lang, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockRemindersViewModel$observeLanguage$slambda$slambda).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StockRemindersViewModel$observeLanguage$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.g14k_1.x10k(StockRemindersViewModel$observeLanguage$slambda$slambda$lambda(this.h14k_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(StockRemindersViewModel$observeLanguage$slambda$slambda).um9 = function (lang, completion) {
    var i = new StockRemindersViewModel$observeLanguage$slambda$slambda(this.g14k_1, completion);
    i.h14k_1 = lang;
    return i;
  };
  function StockRemindersViewModel$observeLanguage$slambda$slambda_0(this$0, resultContinuation) {
    var i = new StockRemindersViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (lang, $completion) {
      return i.pyo(lang, $completion);
    }, 1);
  }
  function StockRemindersViewModel$loadReminders$slambda$slambda$lambda($remindedProducts) {
    return function ($this$updateState) {
      return $this$updateState.p14j($remindedProducts, false);
    };
  }
  function StockRemindersViewModel$loadReminders$slambda$lambda($this$updateState) {
    return $this$updateState.p14j(VOID, true);
  }
  function StockRemindersViewModel$loadReminders$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StockRemindersViewModel$loadReminders$slambda$slambda).s14k = function (reminderIds, allProducts, $completion) {
    var tmp = this.t14k(reminderIds, allProducts, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockRemindersViewModel$loadReminders$slambda$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE();
    return this.s14k(tmp, (!(p2 == null) ? isInterface(p2, KtList) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(StockRemindersViewModel$loadReminders$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0 = this.r14k_1;
          var destination = ArrayList_init_$Create$_0();
          var _iterator__ex2g4s = tmp0.t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            if (contains_0(this.q14k_1, element.nzt_1)) {
              destination.j1(element);
            }
          }
          return destination;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(StockRemindersViewModel$loadReminders$slambda$slambda).t14k = function (reminderIds, allProducts, completion) {
    var i = new StockRemindersViewModel$loadReminders$slambda$slambda(completion);
    i.q14k_1 = reminderIds;
    i.r14k_1 = allProducts;
    return i;
  };
  function StockRemindersViewModel$loadReminders$slambda$slambda_0(resultContinuation) {
    var i = new StockRemindersViewModel$loadReminders$slambda$slambda(resultContinuation);
    return constructCallableReference(function (reminderIds, allProducts, $completion) {
      return i.s14k(reminderIds, allProducts, $completion);
    }, 2);
  }
  function StockRemindersViewModel$loadReminders$slambda$slambda_1(this$0, resultContinuation) {
    this.c14l_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StockRemindersViewModel$loadReminders$slambda$slambda_1).n122 = function (remindedProducts, $completion) {
    var tmp = this.o122(remindedProducts, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockRemindersViewModel$loadReminders$slambda$slambda_1).ja = function (p1, $completion) {
    return this.n122((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StockRemindersViewModel$loadReminders$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.c14l_1.x10k(StockRemindersViewModel$loadReminders$slambda$slambda$lambda(this.d14l_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(StockRemindersViewModel$loadReminders$slambda$slambda_1).o122 = function (remindedProducts, completion) {
    var i = new StockRemindersViewModel$loadReminders$slambda$slambda_1(this.c14l_1, completion);
    i.d14l_1 = remindedProducts;
    return i;
  };
  function StockRemindersViewModel$loadReminders$slambda$slambda_2(this$0, resultContinuation) {
    var i = new StockRemindersViewModel$loadReminders$slambda$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function (remindedProducts, $completion) {
      return i.n122(remindedProducts, $completion);
    }, 1);
  }
  function observeLanguage_9($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, StockRemindersViewModel$observeLanguage$slambda_0($this, null));
  }
  function loadReminders($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, StockRemindersViewModel$loadReminders$slambda_0($this, null));
  }
  function StockRemindersViewModel$observeLanguage$slambda(this$0, resultContinuation) {
    this.m14l_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StockRemindersViewModel$observeLanguage$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockRemindersViewModel$observeLanguage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StockRemindersViewModel$observeLanguage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.m14l_1.v14l_1.y103();
            var action = StockRemindersViewModel$observeLanguage$slambda$slambda_0(this.m14l_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(StockRemindersViewModel$observeLanguage$slambda).q24 = function ($this$launch, completion) {
    var i = new StockRemindersViewModel$observeLanguage$slambda(this.m14l_1, completion);
    i.n14l_1 = $this$launch;
    return i;
  };
  function StockRemindersViewModel$observeLanguage$slambda_0(this$0, resultContinuation) {
    var i = new StockRemindersViewModel$observeLanguage$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function StockRemindersViewModel$loadReminders$slambda(this$0, resultContinuation) {
    this.e14m_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StockRemindersViewModel$loadReminders$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockRemindersViewModel$loadReminders$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StockRemindersViewModel$loadReminders$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.e14m_1.x10k(StockRemindersViewModel$loadReminders$slambda$lambda);
            this.n9_1 = 1;
            var tmp_0 = this.e14m_1.s14l_1.ynu();
            var tmp_1 = this.e14m_1.u14l_1.ynu();
            var tmp_2 = combine(tmp_0, tmp_1, StockRemindersViewModel$loadReminders$slambda$slambda_0(null));
            suspendResult = collectLatest(tmp_2, StockRemindersViewModel$loadReminders$slambda$slambda_2(this.e14m_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(StockRemindersViewModel$loadReminders$slambda).q24 = function ($this$launch, completion) {
    var i = new StockRemindersViewModel$loadReminders$slambda(this.e14m_1, completion);
    i.f14m_1 = $this$launch;
    return i;
  };
  function StockRemindersViewModel$loadReminders$slambda_0(this$0, resultContinuation) {
    var i = new StockRemindersViewModel$loadReminders$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function $handleIntentCOROUTINE$_16(_this__u8e3s4, intent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o14m_1 = _this__u8e3s4;
    this.p14m_1 = intent;
  }
  protoOf($handleIntentCOROUTINE$_16).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_subject = this.p14m_1;
            if (equals(tmp0_subject, LoadReminders_instance)) {
              loadReminders(this.o14m_1);
              this.n9_1 = 2;
              continue $sm;
            } else {
              if (tmp0_subject instanceof RemoveReminder) {
                this.n9_1 = 1;
                suspendResult = this.o14m_1.t14l_1.vdf(this.p14m_1.q14j_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                noWhenBranchMatchedException();
              }
            }

            break;
          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function StockRemindersViewModel(getStockRemindersUseCase, toggleStockReminderUseCase, getProductsUseCase, getLanguageUseCase) {
    BaseMviViewModel.call(this, new StockRemindersState());
    this.s14l_1 = getStockRemindersUseCase;
    this.t14l_1 = toggleStockReminderUseCase;
    this.u14l_1 = getProductsUseCase;
    this.v14l_1 = getLanguageUseCase;
    observeLanguage_9(this);
    loadReminders(this);
  }
  protoOf(StockRemindersViewModel).q14m = function (intent, $completion) {
    var tmp = new $handleIntentCOROUTINE$_16(this, intent, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StockRemindersViewModel).f10l = function (intent, $completion) {
    return this.q14m(isInterface(intent, StockRemindersIntent) ? intent : THROW_CCE(), $completion);
  };
  function CustomMugScreen(product, language, onBack, onAddToCart, $composer, $changed, $default) {
    var product_0 = {_v: product};
    var language_0 = {_v: language};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1309165116);
    sourceInformation($composer_0, 'C(CustomMugScreen)P(3!1,2)79@3587L41,80@3638L41,81@3689L41,84@3757L31,85@3814L40,86@3874L47,87@3952L46,89@4050L94,89@4022L122,106@4487L11,107@4516L16090,105@4438L16168:CustomMugScreen.kt#2a4il0');
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(product_0._v) : $composer_0.q31(product_0._v)) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(language_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onAddToCart) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        product_0._v = null;
      }
      if (!(($default & 2) === 0)) {
        language_0._v = 'en';
      }
      if (isTraceInProgress()) {
        traceEventStart(1309165116, $dirty, -1, 'client.fstech.hadaya.presentation.shopping.CustomMugScreen (CustomMugScreen.kt:70)');
      }
      var tmp0_safe_receiver = product_0._v;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_0;
        if (language_0._v === 'en') {
          var tmp0_elvis_lhs = tmp0_safe_receiver.ozt_1;
          tmp_0 = tmp0_elvis_lhs == null ? tmp0_safe_receiver.pzt_1 : tmp0_elvis_lhs;
        } else {
          var tmp1_elvis_lhs = tmp0_safe_receiver.pzt_1;
          tmp_0 = tmp1_elvis_lhs == null ? tmp0_safe_receiver.ozt_1 : tmp1_elvis_lhs;
        }
        tmp = tmp_0;
      }
      var tmp1_elvis_lhs_0 = tmp;
      var tmp_1;
      if (tmp1_elvis_lhs_0 == null) {
        $composer_0.m30(-317731356);
        sourceInformation($composer_0, '73@3326L40');
        var tmp0_group = stringResource(get_design_studio(string_instance), $composer_0, 0);
        $composer_0.n30();
        tmp_1 = tmp0_group;
      } else {
        $composer_0.m30(-317735169);
        $composer_0.n30();
        tmp_1 = tmp1_elvis_lhs_0;
      }
      var name = tmp_1;
      var tmp2_safe_receiver = product_0._v;
      var tmp_2;
      if (tmp2_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_3;
        if (language_0._v === 'en') {
          var tmp0_elvis_lhs_0 = tmp2_safe_receiver.qzt_1;
          tmp_3 = tmp0_elvis_lhs_0 == null ? tmp2_safe_receiver.rzt_1 : tmp0_elvis_lhs_0;
        } else {
          var tmp1_elvis_lhs_1 = tmp2_safe_receiver.rzt_1;
          tmp_3 = tmp1_elvis_lhs_1 == null ? tmp2_safe_receiver.qzt_1 : tmp1_elvis_lhs_1;
        }
        tmp_2 = tmp_3;
      }
      var tmp3_elvis_lhs = tmp_2;
      var description = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      var sizes = listOf_0([stringResource(get_mug_size_11_oz(string_instance), $composer_0, 0), stringResource(get_mug_size_15_oz(string_instance), $composer_0, 0), stringResource(get_mug_size_20_oz(string_instance), $composer_0, 0)]);
      sourceInformationMarkerStart($composer_0, -317717573, 'CC(remember):CustomMugScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_4;
      if (false || it === Companion_getInstance().f30_1) {
        var value = mutableStateOf('');
        this_0.j31(value);
        tmp_4 = value;
      } else {
        tmp_4 = it;
      }
      var tmp1_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      var mugText$delegate = tmp1_group;
      sourceInformationMarkerStart($composer_0, -317715740, 'CC(remember):CustomMugScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_5;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = mutableStateOf(new Color_0(Companion_getInstance_14().m6b_1));
        this_1.j31(value_0);
        tmp_5 = value_0;
      } else {
        tmp_5 = it_0;
      }
      var tmp2_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      var selectedColor$delegate = tmp2_group;
      var tmp3_remember$arg$0 = sizes.l1(0);
      sourceInformationMarkerStart($composer_0, -317713813, 'CC(remember):CustomMugScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.k31(tmp3_remember$arg$0);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0.i31();
      var tmp_6;
      if (invalid || it_1 === Companion_getInstance().f30_1) {
        var value_1 = mutableStateOf(sizes.l1(0));
        tmp0.j31(value_1);
        tmp_6 = value_1;
      } else {
        tmp_6 = it_1;
      }
      var tmp4_group = tmp_6;
      sourceInformationMarkerEnd($composer_0);
      var mugSize$delegate = tmp4_group;
      sourceInformationMarkerStart($composer_0, -317711318, 'CC(remember):CustomMugScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_2 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_2 = this_2.i31();
      var tmp_7;
      if (false || it_2 === Companion_getInstance().f30_1) {
        var value_2 = mutableStateOf(null);
        this_2.j31(value_2);
        tmp_7 = value_2;
      } else {
        tmp_7 = it_2;
      }
      var tmp5_group = tmp_7;
      sourceInformationMarkerEnd($composer_0);
      var selectedImageBytes$delegate = tmp5_group;
      sourceInformationMarkerStart($composer_0, -317708134, 'CC(remember):CustomMugScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_3 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_3 = this_3.i31();
      var tmp_8;
      if (false || it_3 === Companion_getInstance().f30_1) {
        var value_3 = CustomMugScreen$lambda_7(selectedImageBytes$delegate);
        this_3.j31(value_3);
        tmp_8 = value_3;
      } else {
        tmp_8 = it_3;
      }
      var tmp6_group = tmp_8;
      sourceInformationMarkerEnd($composer_0);
      var imagePicker = rememberImagePickerLauncher_0(tmp6_group, $composer_0, 6);
      var colors = listOf_0([new Color_0(Companion_getInstance_14().m6b_1), new Color_0(Color(new Long(-14803426, 0))), new Color_0(Color(new Long(-1689274, 0))), new Color_0(Color(new Long(-16743504, 0))), new Color_0(Color(new Long(-13984369, 0))), new Color_0(Color(new Long(-1457046, 0))), new Color_0(Color(new Long(-25954, 0)))]);
      var tmp_9 = _FabPosition___init__impl__9ib2hj(0);
      var tmp_10 = MaterialTheme_instance.unz($composer_0, 6).ko0_1;
      var tmp_11 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1057389427, true, CustomMugScreen$lambda_8(onBack, product_0, selectedColor$delegate, selectedImageBytes$delegate, mugText$delegate, name, description, imagePicker, colors, sizes, mugSize$delegate, onAddToCart), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_4 = $composer_1.i31();
      var tmp_12;
      if (invalid_0 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = ComposableLambda$invoke$ref_2(dispatchReceiver);
        $composer_1.j31(value_4);
        tmp_12 = value_4;
      } else {
        tmp_12 = it_4;
      }
      var tmp$ret$24 = tmp_12;
      Scaffold(null, null, null, null, null, tmp_9, tmp_10, tmp_11, null, tmp$ret$24, $composer_0, 805306368, 447);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp7_safe_receiver = $composer_0.t30();
    if (tmp7_safe_receiver == null)
      null;
    else {
      tmp7_safe_receiver.p3c(CustomMugScreen$lambda_9(product_0, language_0, onBack, onAddToCart, $changed, $default));
    }
  }
  function ComposableSingletons$CustomMugScreenKt$lambda$1526558603$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C144@5999L31,142@5878L178:CustomMugScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1526558603, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$CustomMugScreenKt.lambda$1526558603.<anonymous> (CustomMugScreen.kt:142)');
      }
      var tmp = get_ArrowBack(AutoMirrored_getInstance().cxv_1);
      var tmp_0 = stringResource(get_back(string_instance), $composer_0, 0);
      Icon(tmp, tmp_0, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 0, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugScreenKt$lambda$1002341000$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C152@6291L819:CustomMugScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1002341000, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$CustomMugScreenKt.lambda$1002341000.<anonymous> (CustomMugScreen.kt:152)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_0 = _Dp___init__impl__ms3zkb(12);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(6);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = padding_2(tmp, tmp_0, tmp$ret$1);
      var horizontalArrangement = null;
      var verticalAlignment = Companion_getInstance_11().u8t_1;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier = Companion_instance;
      if (!((2 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((2 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 390 >> 3 | 112 & 390 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1232573260, 'C158@6636L38,156@6521L248,161@6798L39,163@6904L38,162@6866L218:CustomMugScreen.kt#2a4il0');
      var tmp_2 = get_ViewInAr(Icons_getInstance().dxv_1);
      var tmp_3 = stringResource(get__3d_preview(string_instance), $composer_5, 0);
      var tmp_4 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$8 = _Dp___init__impl__ms3zkb(16);
      var tmp_5 = size(tmp_4, tmp$ret$8);
      Icon(tmp_2, tmp_3, tmp_5, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 384, 8);
      var tmp_6 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$9 = _Dp___init__impl__ms3zkb(6);
      Spacer(width(tmp_6, tmp$ret$9), $composer_5, 6);
      var tmp0_text = stringResource(get__3d_preview(string_instance), $composer_5, 0);
      var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp2_fontSize = get_sp(12);
      var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp_7, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, null, $composer_5, 1597440, 0, 262062);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugScreenKt$lambda$405083741$lambda($this$Card, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C284@12500L1648:CustomMugScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(405083741, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$CustomMugScreenKt.lambda$405083741.<anonymous> (CustomMugScreen.kt:284)');
      }
      var tmp = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = fillMaxWidth(padding_0(tmp, tmp$ret$0));
      var horizontalArrangement = null;
      var verticalAlignment = Companion_getInstance_11().u8t_1;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier = Companion_instance;
      if (!((2 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((2 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 390 >> 3 | 112 & 390 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 275746719, 'C291@12911L11,288@12731L627,300@13391L40,301@13464L654:CustomMugScreen.kt#2a4il0');
      var tmp_1 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$7 = _Dp___init__impl__ms3zkb(48);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_1 = background(size(tmp_1, tmp$ret$7), MaterialTheme_instance.unz($composer_5, 6).xnz_1, get_CircleShape());
      var contentAlignment = Companion_getInstance_11().o8t_1;
      var propagateMinConstraints = false;
      var $composer_6 = $composer_5;
      if (!((4 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((4 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((4 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_2 = $composer_8.g30();
      if (!isInterface(tmp_2, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_0);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, 347605638, 'C294@13090L234:CustomMugScreen.kt#2a4il0');
      var tmp_3 = get_CameraAlt(Icons_getInstance().dxv_1);
      Icon(tmp_3, null, null, Companion_getInstance_14().m6b_1, $composer_10, 3120, 4);
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      var tmp_4 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$14 = _Dp___init__impl__ms3zkb(16);
      Spacer(width(tmp_4, tmp$ret$14), $composer_5, 6);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_3 = null;
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_11 = $composer_5;
      if (!((7 & 1) === 0))
        modifier_3 = Companion_instance;
      if (!((7 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((7 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_1 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_11, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_4 = modifier_3;
      var $composer_12 = $composer_11;
      if (!((0 & 2) === 0))
        modifier_4 = Companion_instance;
      var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
      var localMap_1 = $composer_12.t31();
      var materialized_1 = materialize($composer_12, modifier_4);
      var tmp0_1 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_13 = $composer_12;
      var tmp_5 = $composer_13.g30();
      if (!isInterface(tmp_5, Applier)) {
        invalidApplier();
      }
      $composer_13.b31();
      if ($composer_13.h30()) {
        $composer_13.c31(tmp0_1);
      } else {
        $composer_13.d31();
      }
      var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
      var $composer_14 = $composer_13;
      var $composer_15 = $composer_14;
      sourceInformationMarkerStart($composer_15, 1455870017, 'C303@13555L47,302@13509L259,308@13851L45,309@13960L11,307@13805L279:CustomMugScreen.kt#2a4il0');
      var tmp0_text = stringResource(get_upload_texture_image(string_instance), $composer_15, 0);
      var tmp1_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp2_fontSize = get_sp(16);
      var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp_6, null, tmp2_fontSize, null, tmp1_fontWeight, null, tmp_7, null, null, tmp_8, tmp_9, false, 0, 0, null, null, $composer_15, 1597440, 0, 262062);
      var tmp_10 = stringResource(get_tap_to_select_file(string_instance), $composer_15, 0);
      var tmp_11 = MaterialTheme_instance.unz($composer_15, 6).po0_1;
      var tmp_12 = get_sp(12);
      var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_15 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp_10, null, tmp_11, null, tmp_12, null, null, null, tmp_13, null, null, tmp_14, tmp_15, false, 0, 0, null, null, $composer_15, 24576, 0, 262122);
      sourceInformationMarkerEnd($composer_15);
      $composer_13.e31();
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugScreenKt$lambda$1736234328$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C320@14407L42,320@14402L48:CustomMugScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1736234328, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$CustomMugScreenKt.lambda$1736234328.<anonymous> (CustomMugScreen.kt:320)');
      }
      var tmp = stringResource(get_add_custom_text(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugScreenKt$lambda$2003779225$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C322@14567L49,322@14562L55:CustomMugScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(2003779225, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$CustomMugScreenKt.lambda$2003779225.<anonymous> (CustomMugScreen.kt:322)');
      }
      var tmp = stringResource(get_edit_text_place_holder(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugScreenKt$lambda$_2023643174$lambda_uus1zh($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C327@14879L11,324@14697L235:CustomMugScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-2023643174, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$CustomMugScreenKt.lambda$-2023643174.<anonymous> (CustomMugScreen.kt:324)');
      }
      var tmp = get_Edit(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, MaterialTheme_instance.unz($composer_0, 6).xnz_1, $composer_0, 48, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$CustomMugScreenKt() {
    ComposableSingletons$CustomMugScreenKt_instance = this;
    var tmp = this;
    tmp.r14m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1526558603, false, ComposableSingletons$CustomMugScreenKt$lambda$1526558603$lambda));
    var tmp_0 = this;
    tmp_0.s14m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1002341000, false, ComposableSingletons$CustomMugScreenKt$lambda$1002341000$lambda));
    var tmp_1 = this;
    tmp_1.t14m_1 = ComposableLambda$invoke$ref_6(composableLambdaInstance(405083741, false, ComposableSingletons$CustomMugScreenKt$lambda$405083741$lambda));
    var tmp_2 = this;
    tmp_2.u14m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1736234328, false, ComposableSingletons$CustomMugScreenKt$lambda$1736234328$lambda));
    var tmp_3 = this;
    tmp_3.v14m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(2003779225, false, ComposableSingletons$CustomMugScreenKt$lambda$2003779225$lambda));
    var tmp_4 = this;
    tmp_4.w14m_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-2023643174, false, ComposableSingletons$CustomMugScreenKt$lambda$_2023643174$lambda_uus1zh));
  }
  var ComposableSingletons$CustomMugScreenKt_instance;
  function ComposableSingletons$CustomMugScreenKt_getInstance() {
    if (ComposableSingletons$CustomMugScreenKt_instance == null)
      new ComposableSingletons$CustomMugScreenKt();
    return ComposableSingletons$CustomMugScreenKt_instance;
  }
  function luminance(_this__u8e3s4) {
    var r = _Color___get_red__impl__cwrsk6(_this__u8e3s4);
    var g = _Color___get_green__impl__bta9rs(_this__u8e3s4);
    var b = _Color___get_blue__impl__xwez13(_this__u8e3s4);
    return 0.299 * r + 0.587 * g + 0.114 * b;
  }
  function CustomMugScreen$lambda($mugText$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('mugText', KMutableProperty0, true);
    return $mugText$delegate.u1();
  }
  function CustomMugScreen$lambda_0($mugText$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('mugText', KMutableProperty0, true);
    $mugText$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMugScreen$lambda_1($selectedColor$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('selectedColor', KMutableProperty0, true);
    return $selectedColor$delegate.u1().c6d_1;
  }
  function CustomMugScreen$lambda_2($selectedColor$delegate, _set____db54di) {
    getLocalDelegateReference('selectedColor', KMutableProperty0, true);
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new Color_0(_set____db54di);
    $selectedColor$delegate.s21(value);
    return Unit_instance;
  }
  function CustomMugScreen$lambda_3($mugSize$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('mugSize', KMutableProperty0, true);
    return $mugSize$delegate.u1();
  }
  function CustomMugScreen$lambda_4($mugSize$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('mugSize', KMutableProperty0, true);
    $mugSize$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMugScreen$lambda_5($selectedImageBytes$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('selectedImageBytes', KMutableProperty0, true);
    return $selectedImageBytes$delegate.u1();
  }
  function CustomMugScreen$lambda_6($selectedImageBytes$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('selectedImageBytes', KMutableProperty0, true);
    $selectedImageBytes$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function CustomMugScreen$lambda_7($selectedImageBytes$delegate) {
    return function (bytes) {
      var tmp;
      if (!(bytes == null)) {
        CustomMugScreen$lambda_6($selectedImageBytes$delegate, bytes);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugScreen$lambda$lambda$lambda($imagePicker) {
    return function () {
      $imagePicker.g11s();
      return Unit_instance;
    };
  }
  function CustomMugScreen$lambda$lambda$lambda_0($mugText$delegate) {
    return function (it) {
      CustomMugScreen$lambda_0($mugText$delegate, it);
      return Unit_instance;
    };
  }
  function CustomMugScreen$lambda$lambda$lambda_1($color, $selectedColor$delegate) {
    return function () {
      CustomMugScreen$lambda_2($selectedColor$delegate, $color);
      return Unit_instance;
    };
  }
  function CustomMugScreen$lambda$lambda$lambda_2($size, $mugSize$delegate) {
    return function () {
      CustomMugScreen$lambda_4($mugSize$delegate, $size);
      return Unit_instance;
    };
  }
  function CustomMugScreen$lambda$lambda$lambda_3($size, $mugSize$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C394@18712L500:CustomMugScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1558673012, $changed, -1, 'client.fstech.hadaya.presentation.shopping.CustomMugScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMugScreen.kt:394)');
        }
        var tmp_0 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(12);
        var tmp0_modifier = padding_2(tmp_0, VOID, tmp$ret$0);
        var tmp1_textAlign = Companion_getInstance_15().d7v_1;
        var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp_1;
        if (CustomMugScreen$lambda_3($mugSize$delegate) === $size) {
          $composer_0.m30(1058836305);
          $composer_0.n30();
          tmp_1 = Companion_getInstance_14().m6b_1;
        } else {
          $composer_0.m30(1058837493);
          sourceInformation($composer_0, '399@19149L11');
          var tmp0_group = MaterialTheme_instance.unz($composer_0, 6).no0_1;
          $composer_0.n30();
          tmp_1 = tmp0_group;
        }
        var tmp3_color = tmp_1;
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text($size, tmp0_modifier, tmp3_color, null, tmp_2, null, tmp2_fontWeight, null, tmp_3, null, tmp1_textAlign, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 1572912, 0, 261048);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugScreen$lambda$lambda$lambda$lambda($onAddToCart, $mugText$delegate, $selectedColor$delegate, $mugSize$delegate, $selectedImageBytes$delegate) {
    return function () {
      $onAddToCart(CustomMugScreen$lambda($mugText$delegate), new Color_0(CustomMugScreen$lambda_1($selectedColor$delegate)), CustomMugScreen$lambda_3($mugSize$delegate), CustomMugScreen$lambda_5($selectedImageBytes$delegate));
      return Unit_instance;
    };
  }
  function CustomMugScreen$lambda$lambda$lambda_4($onAddToCart, $mugSize$delegate, $mugText$delegate, $selectedColor$delegate, $selectedImageBytes$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C415@19774L306,426@20262L49,427@20372L11,414@19713L823:CustomMugScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-959884755, $changed, -1, 'client.fstech.hadaya.presentation.shopping.CustomMugScreen.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (CustomMugScreen.kt:414)');
        }
        sourceInformationMarkerStart($composer_0, 968722175, 'CC(remember):CustomMugScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.k31($onAddToCart) | $composer_0.k31($mugSize$delegate));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CustomMugScreen$lambda$lambda$lambda$lambda($onAddToCart, $mugText$delegate, $selectedColor$delegate, $mugSize$delegate, $selectedImageBytes$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp0_group = tmp_0;
        sourceInformationMarkerEnd($composer_0);
        var tmp_1 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$4 = _Dp___init__impl__ms3zkb(24);
        CustomizeActionButton(tmp0_group, padding_0(tmp_1, tmp$ret$4), stringResource(get_add_custom_mug_to_cart(string_instance), $composer_0, 0), MaterialTheme_instance.unz($composer_0, 6).xnz_1, Companion_getInstance_14().m6b_1, get_ShoppingCart(Icons_getInstance().dxv_1), $composer_0, 24624, 0);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugScreen$lambda$lambda($name, $description, $imagePicker, $colors, $sizes, $mugSize$delegate, $mugText$delegate, $selectedColor$delegate, $onAddToCart, $selectedImageBytes$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C240@10446L10130:CustomMugScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1334606946, $changed, -1, 'client.fstech.hadaya.presentation.shopping.CustomMugScreen.<anonymous>.<anonymous>.<anonymous> (CustomMugScreen.kt:240)');
        }
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = fillMaxSize(Companion_instance);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -228590975, 'C247@10759L21,243@10548L8814,410@19550L11,413@19687L871,408@19435L1123:CustomMugScreen.kt#2a4il0');
        var tmp_1 = ColumnScopeInstance_instance.yds(Companion_instance, 1.0);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_2 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
        var tmp_3 = padding_2(tmp_1, tmp_2, tmp$ret$7);
        var tmp0_0 = verticalScroll(tmp_3, rememberScrollState(0, $composer_5, 0, 1));
        var tmp_4 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$8 = _Dp___init__impl__ms3zkb(24);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_1 = tmp0_0;
        var verticalArrangement_0 = tmp_4.mdq(tmp$ret$8);
        var horizontalAlignment_0 = null;
        var $composer_6 = $composer_5;
        if (!((4 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((4 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((4 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_0 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_6, 14 & 48 >> 3 | 112 & 48 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_5 = $composer_8.g30();
        if (!isInterface(tmp_5, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_1);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, -559105302, 'C256@11203L11,251@10949L397,264@11571L11,260@11372L249,280@12305L11,279@12230L150,277@12090L24,276@12046L2128,332@15165L11,333@15255L11,331@15090L221,319@14346L16,317@14238L1099,338@15406L1660,369@17134L2206:CustomMugScreen.kt#2a4il0');
        var tmp_6 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$15 = _Dp___init__impl__ms3zkb(40);
        var tmp_7 = width(tmp_6, tmp$ret$15);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$16 = _Dp___init__impl__ms3zkb(4);
        Box(ColumnScopeInstance_instance.zds(background(clip(height(tmp_7, tmp$ret$16), get_CircleShape()), Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_10, 6).po0_1, 0.2)), Companion_getInstance_11().x8t_1), $composer_10, 0);
        var tmp0_fontSize = get_sp(24);
        var tmp1_fontWeight = Companion_getInstance_16().f7z_1;
        var tmp2_color = MaterialTheme_instance.unz($composer_10, 6).lo0_1;
        var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_10 = _TextOverflow___init__impl__obguoe(0);
        Text($name, null, tmp2_color, null, tmp0_fontSize, null, tmp1_fontWeight, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, null, $composer_10, 1597440, 0, 262058);
        // Inline function 'kotlin.text.isNotBlank' call
        var this_0 = $description;
        if (!isBlank(this_0)) {
          $composer_10.m30(-558605831);
          sourceInformation($composer_10, '270@11819L10,271@11896L11,268@11707L247');
          var tmp3_style = MaterialTheme_instance.jog($composer_10, 6).pof_1;
          var tmp4_color = MaterialTheme_instance.unz($composer_10, 6).po0_1;
          var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_14 = _TextOverflow___init__impl__obguoe(0);
          Text($description, null, tmp4_color, null, tmp_11, null, null, null, tmp_12, null, null, tmp_13, tmp_14, false, 0, 0, null, tmp3_style, $composer_10, 0, 0, 131066);
          $composer_10.n30();
        } else {
          $composer_10.m30(-558342672);
          $composer_10.n30();
        }
        var tmp5_modifier = fillMaxWidth(Companion_instance);
        var tmp_15 = CardDefaults_instance;
        var tmp_16 = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_10, 6).oo0_1, 0.5);
        var tmp_17 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_18 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp6_colors = tmp_15.loh(tmp_16, tmp_17, tmp_18, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_10, 24576, 14);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$18 = _Dp___init__impl__ms3zkb(16);
        var tmp7_shape = RoundedCornerShape(tmp$ret$18);
        sourceInformationMarkerStart($composer_10, -18007510, 'CC(remember):CustomMugScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_10.q31($imagePicker);
        // Inline function 'kotlin.let' call
        var it = $composer_10.i31();
        var tmp_19;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = CustomMugScreen$lambda$lambda$lambda($imagePicker);
          $composer_10.j31(value);
          tmp_19 = value;
        } else {
          tmp_19 = it;
        }
        var tmp0_group = tmp_19;
        sourceInformationMarkerEnd($composer_10);
        Card_0(tmp0_group, tmp5_modifier, false, tmp7_shape, tmp6_colors, null, null, null, ComposableSingletons$CustomMugScreenKt_getInstance().t14m_1, $composer_10, 100663344, 228);
        var tmp8_value = CustomMugScreen$lambda($mugText$delegate);
        var tmp9_modifier = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$23 = _Dp___init__impl__ms3zkb(12);
        var tmp10_shape = RoundedCornerShape(tmp$ret$23);
        var tmp_20 = OutlinedTextFieldDefaults_getInstance();
        var tmp_21 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_22 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_23 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_24 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_25 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_26 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_27 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_28 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_29 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_30 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_31 = MaterialTheme_instance.unz($composer_10, 6).xnz_1;
        var tmp_32 = MaterialTheme_instance.unz($composer_10, 6).oo0_1;
        var tmp_33 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_34 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_35 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_36 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_37 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_38 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_39 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_40 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_41 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_42 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_43 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_44 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_45 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_46 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_47 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_48 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_49 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_50 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_51 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_52 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_53 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_54 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_55 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_56 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_57 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_58 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_59 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_60 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_61 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp11_colors = tmp_20.np9(tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, null, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, tmp_43, tmp_44, tmp_45, tmp_46, tmp_47, tmp_48, tmp_49, tmp_50, tmp_51, tmp_52, tmp_53, tmp_54, tmp_55, tmp_56, tmp_57, tmp_58, tmp_59, tmp_60, tmp_61, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_10, 0, 0, 0, 0, 3072, 2147477503, 4095);
        sourceInformationMarkerStart($composer_10, -17935326, 'CC(remember):CustomMugScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_0 = $composer_10.i31();
        var tmp_62;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var value_0 = CustomMugScreen$lambda$lambda$lambda_0($mugText$delegate);
          $composer_10.j31(value_0);
          tmp_62 = value_0;
        } else {
          tmp_62 = it_0;
        }
        var tmp1_group = tmp_62;
        sourceInformationMarkerEnd($composer_10);
        var tmp_63 = ComposableSingletons$CustomMugScreenKt_getInstance().u14m_1;
        var tmp_64 = ComposableSingletons$CustomMugScreenKt_getInstance().v14m_1;
        var tmp_65 = ComposableSingletons$CustomMugScreenKt_getInstance().w14m_1;
        OutlinedTextField(tmp8_value, tmp1_group, tmp9_modifier, false, false, null, tmp_63, tmp_64, tmp_65, null, null, null, null, false, null, null, null, false, 0, 0, null, tmp10_shape, tmp11_colors, $composer_10, 114819504, 0, 0, 2096696);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_3 = fillMaxWidth(Companion_instance);
        var verticalArrangement_1 = null;
        var horizontalAlignment_1 = null;
        var $composer_11 = $composer_10;
        if (!((6 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_1 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_1 = Companion_getInstance_11().w8t_1;
        var measurePolicy_1 = columnMeasurePolicy(verticalArrangement_1, horizontalAlignment_1, $composer_11, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_12 = $composer_11;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
        var localMap_1 = $composer_12.t31();
        var materialized_1 = materialize($composer_12, modifier_4);
        var tmp0_2 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_13 = $composer_12;
        var tmp_66 = $composer_13.g30();
        if (!isInterface(tmp_66, Applier)) {
          invalidApplier();
        }
        $composer_13.b31();
        if ($composer_13.h30()) {
          $composer_13.c31(tmp0_2);
        } else {
          $composer_13.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_14 = $composer_13;
        var $composer_15 = $composer_14;
        sourceInformationMarkerStart($composer_15, -434995122, 'C340@15517L37,339@15479L294,345@15802L1238:CustomMugScreen.kt#2a4il0');
        var tmp0_text = stringResource(get_base_color(string_instance), $composer_15, 0);
        var tmp1_fontWeight_0 = Companion_getInstance_16().e7z_1;
        var tmp2_fontSize = get_sp(16);
        var tmp_67 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$34 = _Dp___init__impl__ms3zkb(12);
        var tmp3_modifier = padding_1(tmp_67, VOID, VOID, VOID, tmp$ret$34);
        var tmp_68 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_69 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_70 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_71 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, tmp3_modifier, tmp_68, null, tmp2_fontSize, null, tmp1_fontWeight_0, null, tmp_69, null, null, tmp_70, tmp_71, false, 0, 0, null, null, $composer_15, 1597488, 0, 262060);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_5 = fillMaxWidth(Companion_instance);
        var horizontalArrangement = Arrangement_getInstance().wdp_1;
        var verticalAlignment = null;
        var $composer_16 = $composer_15;
        if (!((4 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((4 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((4 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_2 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_16, 14 & 54 >> 3 | 112 & 54 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_17 = $composer_16;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
        var localMap_2 = $composer_17.t31();
        var materialized_2 = materialize($composer_17, modifier_6);
        var tmp0_3 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_18 = $composer_17;
        var tmp_72 = $composer_18.g30();
        if (!isInterface(tmp_72, Applier)) {
          invalidApplier();
        }
        $composer_18.b31();
        if ($composer_18.h30()) {
          $composer_18.c31(tmp0_3);
        } else {
          $composer_18.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_18);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_19 = $composer_18;
        var $composer_20 = $composer_19;
        sourceInformationMarkerStart($composer_20, 875296013, 'C:CustomMugScreen.kt#2a4il0');
        $composer_20.m30(-1218690417);
        sourceInformation($composer_20, '*362@16913L25,350@16082L894');
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = $colors.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          var color = element.c6d_1;
          var tmp_73 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$43 = _Dp___init__impl__ms3zkb(42);
          var tmp_74 = background(clip(size(tmp_73, tmp$ret$43), get_CircleShape()), color);
          var tmp_75;
          if (equals(CustomMugScreen$lambda_1($selectedColor$delegate), color)) {
            // Inline function 'androidx.compose.ui.unit.dp' call
            tmp_75 = _Dp___init__impl__ms3zkb(3);
          } else {
            // Inline function 'androidx.compose.ui.unit.dp' call
            tmp_75 = _Dp___init__impl__ms3zkb(1);
          }
          var tmp_76 = tmp_75;
          var tmp_77;
          if (equals(CustomMugScreen$lambda_1($selectedColor$delegate), color)) {
            $composer_20.m30(-2062167917);
            sourceInformation($composer_20, '357@16581L11');
            var tmp0_group_0 = MaterialTheme_instance.unz($composer_20, 6).xnz_1;
            $composer_20.n30();
            tmp_77 = tmp0_group_0;
          } else {
            $composer_20.m30(-2062166876);
            $composer_20.n30();
            tmp_77 = Color__copy$default_impl_ectz3s(Companion_getInstance_14().l6b_1, 0.5);
          }
          var tmp_78 = border(tmp_74, tmp_76, tmp_77, get_CircleShape());
          sourceInformationMarkerStart($composer_20, -2062157659, 'CC(remember):CustomMugScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = $composer_20.o31(_ULong___get_data__impl__fggpzb(_Color___get_value__impl__1pls5m(color)));
          // Inline function 'kotlin.let' call
          var it_1 = $composer_20.i31();
          var tmp_79;
          if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
            var value_1 = CustomMugScreen$lambda$lambda$lambda_1(color, $selectedColor$delegate);
            $composer_20.j31(value_1);
            tmp_79 = value_1;
          } else {
            tmp_79 = it_1;
          }
          var tmp1_group_0 = tmp_79;
          sourceInformationMarkerEnd($composer_20);
          Box(clickable(tmp_78, VOID, VOID, VOID, VOID, tmp1_group_0), $composer_20, 0);
        }
        $composer_20.n30();
        sourceInformationMarkerEnd($composer_20);
        $composer_18.e31();
        sourceInformationMarkerEnd($composer_15);
        $composer_13.e31();
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_7 = fillMaxWidth(Companion_instance);
        var verticalArrangement_2 = null;
        var horizontalAlignment_2 = null;
        var $composer_21 = $composer_10;
        if (!((6 & 1) === 0))
          modifier_7 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_2 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_2 = Companion_getInstance_11().w8t_1;
        var measurePolicy_3 = columnMeasurePolicy(verticalArrangement_2, horizontalAlignment_2, $composer_21, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_8 = modifier_7;
        var $composer_22 = $composer_21;
        if (!((0 & 2) === 0))
          modifier_8 = Companion_instance;
        var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_22, 0).hashCode();
        var localMap_3 = $composer_22.t31();
        var materialized_3 = materialize($composer_22, modifier_8);
        var tmp0_4 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_23 = $composer_22;
        var tmp_80 = $composer_23.g30();
        if (!isInterface(tmp_80, Applier)) {
          invalidApplier();
        }
        $composer_23.b31();
        if ($composer_23.h30()) {
          $composer_23.c31(tmp0_4);
        } else {
          $composer_23.d31();
        }
        var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_23);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
        var $composer_24 = $composer_23;
        var $composer_25 = $composer_24;
        sourceInformationMarkerStart($composer_25, -718787933, 'C371@17245L35,370@17207L292,376@17528L1786:CustomMugScreen.kt#2a4il0');
        var tmp0_text_0 = stringResource(get_mug_size(string_instance), $composer_25, 0);
        var tmp1_fontWeight_1 = Companion_getInstance_16().e7z_1;
        var tmp2_fontSize_0 = get_sp(16);
        var tmp_81 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$56 = _Dp___init__impl__ms3zkb(12);
        var tmp3_modifier_0 = padding_1(tmp_81, VOID, VOID, VOID, tmp$ret$56);
        var tmp_82 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_83 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_84 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_85 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text_0, tmp3_modifier_0, tmp_82, null, tmp2_fontSize_0, null, tmp1_fontWeight_1, null, tmp_83, null, null, tmp_84, tmp_85, false, 0, 0, null, null, $composer_25, 1597488, 0, 262060);
        var tmp0_5 = fillMaxWidth(Companion_instance);
        var tmp_86 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$57 = _Dp___init__impl__ms3zkb(12);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_9 = tmp0_5;
        var horizontalArrangement_0 = tmp_86.mdq(tmp$ret$57);
        var verticalAlignment_0 = null;
        var $composer_26 = $composer_25;
        if (!((4 & 1) === 0))
          modifier_9 = Companion_instance;
        if (!((4 & 2) === 0))
          horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
        if (!((4 & 4) === 0))
          verticalAlignment_0 = Companion_getInstance_11().t8t_1;
        var measurePolicy_4 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_26, 14 & 54 >> 3 | 112 & 54 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_10 = modifier_9;
        var $composer_27 = $composer_26;
        if (!((0 & 2) === 0))
          modifier_10 = Companion_instance;
        var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_27, 0).hashCode();
        var localMap_4 = $composer_27.t31();
        var materialized_4 = materialize($composer_27, modifier_10);
        var tmp0_6 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_28 = $composer_27;
        var tmp_87 = $composer_28.g30();
        if (!isInterface(tmp_87, Applier)) {
          invalidApplier();
        }
        $composer_28.b31();
        if ($composer_28.h30()) {
          $composer_28.c31(tmp0_6);
        } else {
          $composer_28.d31();
        }
        var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_28);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
        var $composer_29 = $composer_28;
        var $composer_30 = $composer_29;
        sourceInformationMarkerStart($composer_30, 58758723, 'C:CustomMugScreen.kt#2a4il0');
        $composer_30.m30(1525916282);
        sourceInformation($composer_30, '*384@17989L18,393@18670L580,381@17809L1441');
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = $sizes.t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          var tmp_88 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
          sourceInformationMarkerStart($composer_30, -949526141, 'CC(remember):CustomMugScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_1 = !!($composer_30.k31($mugSize$delegate) | $composer_30.k31(element_0));
          // Inline function 'kotlin.let' call
          var it_2 = $composer_30.i31();
          var tmp_89;
          if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
            var value_2 = CustomMugScreen$lambda$lambda$lambda_2(element_0, $mugSize$delegate);
            $composer_30.j31(value_2);
            tmp_89 = value_2;
          } else {
            tmp_89 = it_2;
          }
          var tmp0_group_1 = tmp_89;
          sourceInformationMarkerEnd($composer_30);
          var tmp_90 = clickable(tmp_88, VOID, VOID, VOID, VOID, tmp0_group_1);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$70 = _Dp___init__impl__ms3zkb(12);
          var tmp_91 = RoundedCornerShape(tmp$ret$70);
          var tmp_92;
          if (CustomMugScreen$lambda_3($mugSize$delegate) === element_0) {
            $composer_30.m30(-949520072);
            sourceInformation($composer_30, '386@18167L11');
            var tmp1_group_1 = MaterialTheme_instance.unz($composer_30, 6).xnz_1;
            $composer_30.n30();
            tmp_92 = tmp1_group_1;
          } else {
            $composer_30.m30(-949518247);
            sourceInformation($composer_30, '386@18206L11');
            var tmp2_group = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_30, 6).oo0_1, 0.5);
            $composer_30.n30();
            tmp_92 = tmp2_group;
          }
          var tmp_93 = tmp_92;
          var tmp_94 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_95 = _Dp___init__impl__ms3zkb(0.0);
          var tmp_96 = _Dp___init__impl__ms3zkb(0.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp_97 = _Dp___init__impl__ms3zkb(1);
          var tmp_98;
          if (CustomMugScreen$lambda_3($mugSize$delegate) === element_0) {
            $composer_30.m30(-949507912);
            sourceInformation($composer_30, '391@18547L11');
            var tmp3_group = MaterialTheme_instance.unz($composer_30, 6).xnz_1;
            $composer_30.n30();
            tmp_98 = tmp3_group;
          } else {
            $composer_30.m30(-949507300);
            $composer_30.n30();
            tmp_98 = Companion_getInstance_14().t6b_1;
          }
          var tmp_99 = BorderStroke(tmp_97, tmp_98);
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-1558673012, true, CustomMugScreen$lambda$lambda$lambda_3(element_0, $mugSize$delegate), $composer_30, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_31 = $composer_30;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_2 = $composer_31.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it_3 = $composer_31.i31();
          var tmp_100;
          if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
            var value_3 = ComposableLambda$invoke$ref(dispatchReceiver);
            $composer_31.j31(value_3);
            tmp_100 = value_3;
          } else {
            tmp_100 = it_3;
          }
          var tmp$ret$72 = tmp_100;
          Surface(tmp_90, tmp_91, tmp_93, tmp_94, tmp_95, tmp_96, tmp_99, tmp$ret$72, $composer_30, 12582912, 56);
        }
        $composer_30.n30();
        sourceInformationMarkerEnd($composer_30);
        $composer_28.e31();
        sourceInformationMarkerEnd($composer_25);
        $composer_23.e31();
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_101 = fillMaxWidth(Companion_instance);
        var tmp_102 = MaterialTheme_instance.unz($composer_5, 6).mo0_1;
        var tmp_103 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_104 = _Dp___init__impl__ms3zkb(4);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_105 = _Dp___init__impl__ms3zkb(8);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(-959884755, true, CustomMugScreen$lambda$lambda$lambda_4($onAddToCart, $mugSize$delegate, $mugText$delegate, $selectedColor$delegate, $selectedImageBytes$delegate), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_32 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = $composer_32.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_32.i31();
        var tmp_106;
        if (invalid_3 || it_4 === Companion_getInstance().f30_1) {
          var value_4 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_32.j31(value_4);
          tmp_106 = value_4;
        } else {
          tmp_106 = it_4;
        }
        var tmp$ret$81 = tmp_106;
        Surface(tmp_101, null, tmp_102, tmp_103, tmp_104, tmp_105, null, tmp$ret$81, $composer_5, 12804102, 74);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_107;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_107 = Unit_instance;
        }
        tmp = tmp_107;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugScreen$lambda_8($onBack, $product, $selectedColor$delegate, $selectedImageBytes$delegate, $mugText$delegate, $name, $description, $imagePicker, $colors, $sizes, $mugSize$delegate, $onAddToCart) {
    return function (padding_0, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C108@4537L16063:CustomMugScreen.kt#2a4il0');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31(padding_0) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1057389427, $dirty, -1, 'client.fstech.hadaya.presentation.shopping.CustomMugScreen.<anonymous> (CustomMugScreen.kt:108)');
        }
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = padding(fillMaxSize(Companion_instance), padding_0);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 0 >> 3 | 112 & 0 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_1 = $composer_3.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 578214159, 'C121@4993L11,122@5067L11,114@4701L5373,236@10276L11,239@10428L10162,232@10121L10469:CustomMugScreen.kt#2a4il0');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = background_0(ColumnScopeInstance_instance.yds(fillMaxWidth(Companion_instance), 0.45), Companion_instance_1.d6c(listOf_0([new Color_0(MaterialTheme_instance.unz($composer_5, 6).oo0_1), new Color_0(MaterialTheme_instance.unz($composer_5, 6).ko0_1)])));
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_2 = $composer_8.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, -1432205055, 'C128@5235L1915,172@7208L2852:CustomMugScreen.kt#2a4il0');
        var tmp0_$receiver = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp1_top = _Dp___init__impl__ms3zkb(48);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp2_start = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_end = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier_3 = padding_1(tmp0_$receiver, tmp2_start, tmp1_top, tmp3_end);
        var horizontalArrangement = Arrangement_getInstance().wdp_1;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_11 = $composer_10;
        if (!((0 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((0 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((0 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy_1 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_11, 14 & 432 >> 3 | 112 & 432 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_12 = $composer_11;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
        var localMap_1 = $composer_12.t31();
        var materialized_1 = materialize($composer_12, modifier_4);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_13 = $composer_12;
        var tmp_3 = $composer_13.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_13.b31();
        if ($composer_13.h30()) {
          $composer_13.c31(tmp0_1);
        } else {
          $composer_13.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_14 = $composer_13;
        var $composer_15 = $composer_14;
        sourceInformationMarkerStart($composer_15, 1706245022, 'C138@5724L11,135@5572L506,149@6155L11,148@6100L1032:CustomMugScreen.kt#2a4il0');
        var tmp_4 = background(Companion_instance, Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_15, 6).mo0_1, 0.7), get_CircleShape());
        IconButton($onBack, tmp_4, false, null, null, null, ComposableSingletons$CustomMugScreenKt_getInstance().r14m_1, $composer_15, 1572864, 60);
        var tmp0_color = MaterialTheme_instance.unz($composer_15, 6).znz_1;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$21 = _Dp___init__impl__ms3zkb(20);
        var tmp1_shape = RoundedCornerShape(tmp$ret$21);
        var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_6 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_7 = _Dp___init__impl__ms3zkb(0.0);
        Surface(null, tmp1_shape, tmp0_color, tmp_5, tmp_6, tmp_7, null, ComposableSingletons$CustomMugScreenKt_getInstance().s14m_1, $composer_15, 12582912, 121);
        sourceInformationMarkerEnd($composer_15);
        $composer_13.e31();
        var tmp_8 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().o8t_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$22 = _Dp___init__impl__ms3zkb(40);
        var tmp_9 = padding_1(tmp_8, VOID, tmp$ret$22);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$23 = _Dp___init__impl__ms3zkb(260);
        var tmp_10 = size(tmp_9, tmp$ret$23);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$24 = _Dp___init__impl__ms3zkb(24);
        var tmp_11 = background(clip(shadow(tmp_10, tmp$ret$24, get_CircleShape()), get_CircleShape()), CustomMugScreen$lambda_1($selectedColor$delegate));
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$25 = _Dp___init__impl__ms3zkb(1);
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_5 = border(tmp_11, tmp$ret$25, Color__copy$default_impl_ectz3s(Companion_getInstance_14().l6b_1, 0.3), get_CircleShape());
        var contentAlignment_0 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_0 = false;
        var $composer_16 = $composer_10;
        if (!((4 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_0 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_0 = false;
        var measurePolicy_2 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_17 = $composer_16;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
        var localMap_2 = $composer_17.t31();
        var materialized_2 = materialize($composer_17, modifier_6);
        var tmp0_2 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_18 = $composer_17;
        var tmp_12 = $composer_18.g30();
        if (!isInterface(tmp_12, Applier)) {
          invalidApplier();
        }
        $composer_18.b31();
        if ($composer_18.h30()) {
          $composer_18.c31(tmp0_2);
        } else {
          $composer_18.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_18);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_19 = $composer_18;
        var $composer_20 = $composer_19;
        sourceInformationMarkerStart($composer_20, 1808591102, 'C:CustomMugScreen.kt#2a4il0');
        var tmp0_safe_receiver = $product._v;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ozu_1;
        var tmp_13;
        if (tmp1_safe_receiver == null) {
          tmp_13 = null;
        } else {
          var tmp$ret$32;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp1_safe_receiver.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              // Inline function 'kotlin.text.isNotBlank' call
              if (!isBlank(element)) {
                tmp$ret$32 = element;
                break $l$block;
              }
            }
            tmp$ret$32 = null;
          }
          tmp_13 = tmp$ret$32;
        }
        var templateImage = tmp_13;
        var tmp2_elvis_lhs = CustomMugScreen$lambda_5($selectedImageBytes$delegate);
        var displayImage = tmp2_elvis_lhs == null ? templateImage : tmp2_elvis_lhs;
        if (!(displayImage == null)) {
          $composer_20.m30(1808733360);
          sourceInformation($composer_20, '187@7936L659');
          var tmp_14 = aspectRatio(fillMaxWidth(Companion_instance, 0.6), 1.0);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$35 = _Dp___init__impl__ms3zkb(8);
          // Inline function 'androidx.compose.foundation.layout.Box' call
          var modifier_7 = clip(tmp_14, RoundedCornerShape(tmp$ret$35));
          var contentAlignment_1 = null;
          var propagateMinConstraints_1 = false;
          var $composer_21 = $composer_20;
          if (!((6 & 1) === 0))
            modifier_7 = Companion_instance;
          if (!((6 & 2) === 0))
            contentAlignment_1 = Companion_getInstance_11().k8t_1;
          if (!((6 & 4) === 0))
            propagateMinConstraints_1 = false;
          var measurePolicy_3 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_8 = modifier_7;
          var $composer_22 = $composer_21;
          if (!((0 & 2) === 0))
            modifier_8 = Companion_instance;
          var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_22, 0).hashCode();
          var localMap_3 = $composer_22.t31();
          var materialized_3 = materialize($composer_22, modifier_8);
          var tmp0_3 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_23 = $composer_22;
          var tmp_15 = $composer_23.g30();
          if (!isInterface(tmp_15, Applier)) {
            invalidApplier();
          }
          $composer_23.b31();
          if ($composer_23.h30()) {
            $composer_23.c31(tmp0_3);
          } else {
            $composer_23.d31();
          }
          var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_23);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
          var $composer_24 = $composer_23;
          var $composer_25 = $composer_24;
          sourceInformationMarkerStart($composer_25, -1466688564, 'C195@8330L39,193@8210L359:CustomMugScreen.kt#2a4il0');
          HadayaImage(displayImage, stringResource(get_texture_desc(string_instance), $composer_25, 0), fillMaxSize(Companion_instance), Companion_getInstance_13().q96_1, $composer_25, 3456, 0);
          sourceInformationMarkerEnd($composer_25);
          $composer_23.e31();
          $composer_20.n30();
        } else {
          $composer_20.m30(1809448809);
          sourceInformation($composer_20, '202@8649L922');
          // Inline function 'androidx.compose.foundation.layout.Column' call
          var modifier_9 = null;
          var verticalArrangement_0 = null;
          var horizontalAlignment_0 = Companion_getInstance_11().x8t_1;
          var $composer_26 = $composer_20;
          if (!((3 & 1) === 0))
            modifier_9 = Companion_instance;
          if (!((3 & 2) === 0))
            verticalArrangement_0 = Arrangement_getInstance().sdp_1;
          if (!((3 & 4) === 0))
            horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
          var measurePolicy_4 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_26, 14 & 384 >> 3 | 112 & 384 >> 3);
          // Inline function 'androidx.compose.ui.layout.Layout' call
          var modifier_10 = modifier_9;
          var $composer_27 = $composer_26;
          if (!((0 & 2) === 0))
            modifier_10 = Companion_instance;
          var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_27, 0).hashCode();
          var localMap_4 = $composer_27.t31();
          var materialized_4 = materialize($composer_27, modifier_10);
          var tmp0_4 = Companion_getInstance_12().oah_1;
          // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
          var $composer_28 = $composer_27;
          var tmp_16 = $composer_28.g30();
          if (!isInterface(tmp_16, Applier)) {
            invalidApplier();
          }
          $composer_28.b31();
          if ($composer_28.h30()) {
            $composer_28.c31(tmp0_4);
          } else {
            $composer_28.d31();
          }
          var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_28);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
          Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
          Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
          var $composer_29 = $composer_28;
          var $composer_30 = $composer_29;
          sourceInformationMarkerStart($composer_30, 1888839603, 'C203@8738L338,209@9105L40,211@9212L49,210@9174L371:CustomMugScreen.kt#2a4il0');
          var tmp_17 = get_ViewInAr(Icons_getInstance().dxv_1);
          var tmp_18 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$48 = _Dp___init__impl__ms3zkb(64);
          Icon(tmp_17, null, size(tmp_18, tmp$ret$48), luminance(CustomMugScreen$lambda_1($selectedColor$delegate)) > 0.5 ? Companion_getInstance_14().j6b_1 : Companion_getInstance_14().m6b_1, $composer_30, 432, 0);
          var tmp_19 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$49 = _Dp___init__impl__ms3zkb(8);
          Spacer(height(tmp_19, tmp$ret$49), $composer_30, 6);
          var tmp0_text = stringResource(get_mug_interactive_engine(string_instance), $composer_30, 0);
          var tmp1_textAlign = Companion_getInstance_15().d7v_1;
          var tmp2_color = luminance(CustomMugScreen$lambda_1($selectedColor$delegate)) > 0.5 ? Companion_getInstance_14().j6b_1 : Companion_getInstance_14().m6b_1;
          var tmp3_fontSize = get_sp(12);
          var tmp_20 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_21 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_22 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp0_text, null, tmp2_color, null, tmp3_fontSize, null, null, null, tmp_20, null, tmp1_textAlign, tmp_21, tmp_22, false, 0, 0, null, null, $composer_30, 24576, 0, 261098);
          sourceInformationMarkerEnd($composer_30);
          $composer_28.e31();
          $composer_20.n30();
        }
        // Inline function 'kotlin.text.isNotBlank' call
        var this_0 = CustomMugScreen$lambda($mugText$delegate);
        if (!isBlank(this_0)) {
          $composer_20.m30(1810465330);
          sourceInformation($composer_20, '220@9667L353');
          var tmp3_text = CustomMugScreen$lambda($mugText$delegate);
          var tmp4_fontWeight = Companion_getInstance_16().e7z_1;
          var tmp5_fontSize = get_sp(24);
          var tmp6_color = luminance(CustomMugScreen$lambda_1($selectedColor$delegate)) > 0.5 ? Companion_getInstance_14().i6b_1 : Companion_getInstance_14().m6b_1;
          var tmp_23 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$51 = _Dp___init__impl__ms3zkb(100);
          var tmp7_modifier = padding_1(tmp_23, VOID, tmp$ret$51);
          var tmp_24 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_25 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
          var tmp_26 = _TextOverflow___init__impl__obguoe(0);
          Text(tmp3_text, tmp7_modifier, tmp6_color, null, tmp5_fontSize, null, tmp4_fontWeight, null, tmp_24, null, null, tmp_25, tmp_26, false, 0, 0, null, null, $composer_20, 1597488, 0, 262056);
          $composer_20.n30();
        } else {
          $composer_20.m30(1810826387);
          $composer_20.n30();
        }
        sourceInformationMarkerEnd($composer_20);
        $composer_18.e31();
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp0_modifier = ColumnScopeInstance_instance.yds(fillMaxWidth(Companion_instance), 0.55);
        var tmp1_color = MaterialTheme_instance.unz($composer_5, 6).mo0_1;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp_27 = _Dp___init__impl__ms3zkb(32);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$53 = _Dp___init__impl__ms3zkb(32);
        var tmp2_shape = RoundedCornerShape_0(tmp_27, tmp$ret$53);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp3_shadowElevation = _Dp___init__impl__ms3zkb(8);
        var tmp_28 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_29 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1334606946, true, CustomMugScreen$lambda$lambda($name, $description, $imagePicker, $colors, $sizes, $mugSize$delegate, $mugText$delegate, $selectedColor$delegate, $onAddToCart, $selectedImageBytes$delegate), $composer_5, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_31 = $composer_5;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_31.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_31.i31();
        var tmp_30;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_31.j31(value);
          tmp_30 = value;
        } else {
          tmp_30 = it;
        }
        var tmp$ret$55 = tmp_30;
        Surface(tmp0_modifier, tmp2_shape, tmp1_color, tmp_28, tmp_29, tmp3_shadowElevation, null, tmp$ret$55, $composer_5, 12779520, 88);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_31;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_31 = Unit_instance;
        }
        tmp_0 = tmp_31;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CustomMugScreen$lambda_9($product, $language, $onBack, $onAddToCart, $$changed, $$default) {
    return function ($composer, $force) {
      CustomMugScreen($product._v, $language._v, $onBack, $onAddToCart, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var client_fstech_hadaya_presentation_shopping_ShoppingState$stable;
  var client_fstech_hadaya_presentation_shopping_ShoppingIntent_LoadProducts$stable;
  var client_fstech_hadaya_presentation_shopping_ShoppingIntent_SearchChanged$stable;
  var client_fstech_hadaya_presentation_shopping_ShoppingIntent_PriceFilterChanged$stable;
  var client_fstech_hadaya_presentation_shopping_ShoppingIntent_AgeFilterChanged$stable;
  var client_fstech_hadaya_presentation_shopping_ShoppingIntent_CustomFilterChanged$stable;
  var client_fstech_hadaya_presentation_shopping_ShoppingIntent_RatingFilterChanged$stable;
  var client_fstech_hadaya_presentation_shopping_ShoppingIntent_SortOrderChanged$stable;
  var client_fstech_hadaya_presentation_shopping_ShoppingIntent_RefreshData$stable;
  var client_fstech_hadaya_presentation_shopping_ShoppingIntent_ToggleFavorite$stable;
  var client_fstech_hadaya_presentation_shopping_ShoppingIntent_ToggleLanguage$stable;
  var client_fstech_hadaya_presentation_shopping_ShoppingSideEffect_ShowError$stable;
  function ShoppingState(products, filteredProducts, searchQuery, minPrice, maxPrice, minRating, sortOrder, isLoading, customMugPrice, banners, language, favoriteProductIds, cartItemsCount, isConnected, showKids, showYouth, showOld, showStandard, onlyCustomProducts, showWithTemplates, showWithoutTemplates) {
    products = products === VOID ? emptyList() : products;
    filteredProducts = filteredProducts === VOID ? emptyList() : filteredProducts;
    searchQuery = searchQuery === VOID ? '' : searchQuery;
    minPrice = minPrice === VOID ? 0.0 : minPrice;
    maxPrice = maxPrice === VOID ? 1.7976931348623157E308 : maxPrice;
    minRating = minRating === VOID ? 0.0 : minRating;
    sortOrder = sortOrder === VOID ? ProductSortOrder_NEWEST_getInstance() : sortOrder;
    isLoading = isLoading === VOID ? false : isLoading;
    customMugPrice = customMugPrice === VOID ? null : customMugPrice;
    banners = banners === VOID ? emptyList() : banners;
    language = language === VOID ? 'en' : language;
    favoriteProductIds = favoriteProductIds === VOID ? emptySet() : favoriteProductIds;
    cartItemsCount = cartItemsCount === VOID ? 0 : cartItemsCount;
    isConnected = isConnected === VOID ? true : isConnected;
    showKids = showKids === VOID ? false : showKids;
    showYouth = showYouth === VOID ? false : showYouth;
    showOld = showOld === VOID ? false : showOld;
    showStandard = showStandard === VOID ? false : showStandard;
    onlyCustomProducts = onlyCustomProducts === VOID ? false : onlyCustomProducts;
    showWithTemplates = showWithTemplates === VOID ? false : showWithTemplates;
    showWithoutTemplates = showWithoutTemplates === VOID ? false : showWithoutTemplates;
    this.x14m_1 = products;
    this.y14m_1 = filteredProducts;
    this.z14m_1 = searchQuery;
    this.a14n_1 = minPrice;
    this.b14n_1 = maxPrice;
    this.c14n_1 = minRating;
    this.d14n_1 = sortOrder;
    this.e14n_1 = isLoading;
    this.f14n_1 = customMugPrice;
    this.g14n_1 = banners;
    this.h14n_1 = language;
    this.i14n_1 = favoriteProductIds;
    this.j14n_1 = cartItemsCount;
    this.k14n_1 = isConnected;
    this.l14n_1 = showKids;
    this.m14n_1 = showYouth;
    this.n14n_1 = showOld;
    this.o14n_1 = showStandard;
    this.p14n_1 = onlyCustomProducts;
    this.q14n_1 = showWithTemplates;
    this.r14n_1 = showWithoutTemplates;
  }
  protoOf(ShoppingState).s14n = function (products, filteredProducts, searchQuery, minPrice, maxPrice, minRating, sortOrder, isLoading, customMugPrice, banners, language, favoriteProductIds, cartItemsCount, isConnected, showKids, showYouth, showOld, showStandard, onlyCustomProducts, showWithTemplates, showWithoutTemplates) {
    return new ShoppingState(products, filteredProducts, searchQuery, minPrice, maxPrice, minRating, sortOrder, isLoading, customMugPrice, banners, language, favoriteProductIds, cartItemsCount, isConnected, showKids, showYouth, showOld, showStandard, onlyCustomProducts, showWithTemplates, showWithoutTemplates);
  };
  protoOf(ShoppingState).t14n = function (products, filteredProducts, searchQuery, minPrice, maxPrice, minRating, sortOrder, isLoading, customMugPrice, banners, language, favoriteProductIds, cartItemsCount, isConnected, showKids, showYouth, showOld, showStandard, onlyCustomProducts, showWithTemplates, showWithoutTemplates, $super) {
    products = products === VOID ? this.x14m_1 : products;
    filteredProducts = filteredProducts === VOID ? this.y14m_1 : filteredProducts;
    searchQuery = searchQuery === VOID ? this.z14m_1 : searchQuery;
    minPrice = minPrice === VOID ? this.a14n_1 : minPrice;
    maxPrice = maxPrice === VOID ? this.b14n_1 : maxPrice;
    minRating = minRating === VOID ? this.c14n_1 : minRating;
    sortOrder = sortOrder === VOID ? this.d14n_1 : sortOrder;
    isLoading = isLoading === VOID ? this.e14n_1 : isLoading;
    customMugPrice = customMugPrice === VOID ? this.f14n_1 : customMugPrice;
    banners = banners === VOID ? this.g14n_1 : banners;
    language = language === VOID ? this.h14n_1 : language;
    favoriteProductIds = favoriteProductIds === VOID ? this.i14n_1 : favoriteProductIds;
    cartItemsCount = cartItemsCount === VOID ? this.j14n_1 : cartItemsCount;
    isConnected = isConnected === VOID ? this.k14n_1 : isConnected;
    showKids = showKids === VOID ? this.l14n_1 : showKids;
    showYouth = showYouth === VOID ? this.m14n_1 : showYouth;
    showOld = showOld === VOID ? this.n14n_1 : showOld;
    showStandard = showStandard === VOID ? this.o14n_1 : showStandard;
    onlyCustomProducts = onlyCustomProducts === VOID ? this.p14n_1 : onlyCustomProducts;
    showWithTemplates = showWithTemplates === VOID ? this.q14n_1 : showWithTemplates;
    showWithoutTemplates = showWithoutTemplates === VOID ? this.r14n_1 : showWithoutTemplates;
    return $super === VOID ? this.s14n(products, filteredProducts, searchQuery, minPrice, maxPrice, minRating, sortOrder, isLoading, customMugPrice, banners, language, favoriteProductIds, cartItemsCount, isConnected, showKids, showYouth, showOld, showStandard, onlyCustomProducts, showWithTemplates, showWithoutTemplates) : $super.s14n.call(this, products, filteredProducts, searchQuery, minPrice, maxPrice, minRating, sortOrder, isLoading, customMugPrice, banners, language, favoriteProductIds, cartItemsCount, isConnected, showKids, showYouth, showOld, showStandard, onlyCustomProducts, showWithTemplates, showWithoutTemplates);
  };
  protoOf(ShoppingState).toString = function () {
    return 'ShoppingState(products=' + toString(this.x14m_1) + ', filteredProducts=' + toString(this.y14m_1) + ', searchQuery=' + this.z14m_1 + ', minPrice=' + this.a14n_1 + ', maxPrice=' + this.b14n_1 + ', minRating=' + this.c14n_1 + ', sortOrder=' + this.d14n_1.toString() + ', isLoading=' + this.e14n_1 + ', customMugPrice=' + this.f14n_1 + ', banners=' + toString(this.g14n_1) + ', language=' + this.h14n_1 + ', favoriteProductIds=' + toString(this.i14n_1) + ', cartItemsCount=' + this.j14n_1 + ', isConnected=' + this.k14n_1 + ', showKids=' + this.l14n_1 + ', showYouth=' + this.m14n_1 + ', showOld=' + this.n14n_1 + ', showStandard=' + this.o14n_1 + ', onlyCustomProducts=' + this.p14n_1 + ', showWithTemplates=' + this.q14n_1 + ', showWithoutTemplates=' + this.r14n_1 + ')';
  };
  protoOf(ShoppingState).hashCode = function () {
    var result = hashCode(this.x14m_1);
    result = imul(result, 31) + hashCode(this.y14m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z14m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a14n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b14n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c14n_1) | 0;
    result = imul(result, 31) + this.d14n_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e14n_1) | 0;
    result = imul(result, 31) + (this.f14n_1 == null ? 0 : getNumberHashCode(this.f14n_1)) | 0;
    result = imul(result, 31) + hashCode(this.g14n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h14n_1) | 0;
    result = imul(result, 31) + hashCode(this.i14n_1) | 0;
    result = imul(result, 31) + this.j14n_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k14n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l14n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m14n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n14n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o14n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p14n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q14n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r14n_1) | 0;
    return result;
  };
  protoOf(ShoppingState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShoppingState))
      return false;
    if (!equals(this.x14m_1, other.x14m_1))
      return false;
    if (!equals(this.y14m_1, other.y14m_1))
      return false;
    if (!(this.z14m_1 === other.z14m_1))
      return false;
    if (!equals(this.a14n_1, other.a14n_1))
      return false;
    if (!equals(this.b14n_1, other.b14n_1))
      return false;
    if (!equals(this.c14n_1, other.c14n_1))
      return false;
    if (!this.d14n_1.equals(other.d14n_1))
      return false;
    if (!(this.e14n_1 === other.e14n_1))
      return false;
    if (!equals(this.f14n_1, other.f14n_1))
      return false;
    if (!equals(this.g14n_1, other.g14n_1))
      return false;
    if (!(this.h14n_1 === other.h14n_1))
      return false;
    if (!equals(this.i14n_1, other.i14n_1))
      return false;
    if (!(this.j14n_1 === other.j14n_1))
      return false;
    if (!(this.k14n_1 === other.k14n_1))
      return false;
    if (!(this.l14n_1 === other.l14n_1))
      return false;
    if (!(this.m14n_1 === other.m14n_1))
      return false;
    if (!(this.n14n_1 === other.n14n_1))
      return false;
    if (!(this.o14n_1 === other.o14n_1))
      return false;
    if (!(this.p14n_1 === other.p14n_1))
      return false;
    if (!(this.q14n_1 === other.q14n_1))
      return false;
    if (!(this.r14n_1 === other.r14n_1))
      return false;
    return true;
  };
  function LoadProducts() {
  }
  protoOf(LoadProducts).toString = function () {
    return 'LoadProducts';
  };
  protoOf(LoadProducts).hashCode = function () {
    return -157530598;
  };
  protoOf(LoadProducts).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadProducts))
      return false;
    return true;
  };
  var LoadProducts_instance;
  function LoadProducts_getInstance() {
    return LoadProducts_instance;
  }
  function SearchChanged(query) {
    this.u14n_1 = query;
  }
  protoOf(SearchChanged).toString = function () {
    return 'SearchChanged(query=' + this.u14n_1 + ')';
  };
  protoOf(SearchChanged).hashCode = function () {
    return getStringHashCode(this.u14n_1);
  };
  protoOf(SearchChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SearchChanged))
      return false;
    if (!(this.u14n_1 === other.u14n_1))
      return false;
    return true;
  };
  function PriceFilterChanged(min, max) {
    this.v14n_1 = min;
    this.w14n_1 = max;
  }
  protoOf(PriceFilterChanged).toString = function () {
    return 'PriceFilterChanged(min=' + this.v14n_1 + ', max=' + this.w14n_1 + ')';
  };
  protoOf(PriceFilterChanged).hashCode = function () {
    var result = getNumberHashCode(this.v14n_1);
    result = imul(result, 31) + getNumberHashCode(this.w14n_1) | 0;
    return result;
  };
  protoOf(PriceFilterChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PriceFilterChanged))
      return false;
    if (!equals(this.v14n_1, other.v14n_1))
      return false;
    if (!equals(this.w14n_1, other.w14n_1))
      return false;
    return true;
  };
  function AgeFilterChanged(kids, youth, old) {
    this.x14n_1 = kids;
    this.y14n_1 = youth;
    this.z14n_1 = old;
  }
  protoOf(AgeFilterChanged).toString = function () {
    return 'AgeFilterChanged(kids=' + this.x14n_1 + ', youth=' + this.y14n_1 + ', old=' + this.z14n_1 + ')';
  };
  protoOf(AgeFilterChanged).hashCode = function () {
    var result = getBooleanHashCode(this.x14n_1);
    result = imul(result, 31) + getBooleanHashCode(this.y14n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z14n_1) | 0;
    return result;
  };
  protoOf(AgeFilterChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AgeFilterChanged))
      return false;
    if (!(this.x14n_1 === other.x14n_1))
      return false;
    if (!(this.y14n_1 === other.y14n_1))
      return false;
    if (!(this.z14n_1 === other.z14n_1))
      return false;
    return true;
  };
  function CustomFilterChanged(showStandard, onlyCustom, withTemplates, withoutTemplates) {
    withTemplates = withTemplates === VOID ? false : withTemplates;
    withoutTemplates = withoutTemplates === VOID ? false : withoutTemplates;
    this.a14o_1 = showStandard;
    this.b14o_1 = onlyCustom;
    this.c14o_1 = withTemplates;
    this.d14o_1 = withoutTemplates;
  }
  protoOf(CustomFilterChanged).toString = function () {
    return 'CustomFilterChanged(showStandard=' + this.a14o_1 + ', onlyCustom=' + this.b14o_1 + ', withTemplates=' + this.c14o_1 + ', withoutTemplates=' + this.d14o_1 + ')';
  };
  protoOf(CustomFilterChanged).hashCode = function () {
    var result = getBooleanHashCode(this.a14o_1);
    result = imul(result, 31) + getBooleanHashCode(this.b14o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c14o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d14o_1) | 0;
    return result;
  };
  protoOf(CustomFilterChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CustomFilterChanged))
      return false;
    if (!(this.a14o_1 === other.a14o_1))
      return false;
    if (!(this.b14o_1 === other.b14o_1))
      return false;
    if (!(this.c14o_1 === other.c14o_1))
      return false;
    if (!(this.d14o_1 === other.d14o_1))
      return false;
    return true;
  };
  function RatingFilterChanged() {
  }
  function SortOrderChanged(sortOrder) {
    this.e14o_1 = sortOrder;
  }
  protoOf(SortOrderChanged).toString = function () {
    return 'SortOrderChanged(sortOrder=' + this.e14o_1.toString() + ')';
  };
  protoOf(SortOrderChanged).hashCode = function () {
    return this.e14o_1.hashCode();
  };
  protoOf(SortOrderChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SortOrderChanged))
      return false;
    if (!this.e14o_1.equals(other.e14o_1))
      return false;
    return true;
  };
  function RefreshData() {
  }
  protoOf(RefreshData).toString = function () {
    return 'RefreshData';
  };
  protoOf(RefreshData).hashCode = function () {
    return 399214965;
  };
  protoOf(RefreshData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RefreshData))
      return false;
    return true;
  };
  var RefreshData_instance;
  function RefreshData_getInstance() {
    return RefreshData_instance;
  }
  function ToggleFavorite_4(productId) {
    this.f14o_1 = productId;
  }
  protoOf(ToggleFavorite_4).toString = function () {
    return 'ToggleFavorite(productId=' + this.f14o_1.toString() + ')';
  };
  protoOf(ToggleFavorite_4).hashCode = function () {
    return this.f14o_1.hashCode();
  };
  protoOf(ToggleFavorite_4).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ToggleFavorite_4))
      return false;
    if (!equalsLong(this.f14o_1, other.f14o_1))
      return false;
    return true;
  };
  function ToggleLanguage() {
  }
  protoOf(ToggleLanguage).toString = function () {
    return 'ToggleLanguage';
  };
  protoOf(ToggleLanguage).hashCode = function () {
    return 247661692;
  };
  protoOf(ToggleLanguage).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ToggleLanguage))
      return false;
    return true;
  };
  var ToggleLanguage_instance;
  function ToggleLanguage_getInstance() {
    return ToggleLanguage_instance;
  }
  function ShoppingIntent() {
  }
  function ShowError_6(message) {
    this.g14o_1 = message;
  }
  protoOf(ShowError_6).toString = function () {
    return 'ShowError(message=' + this.g14o_1 + ')';
  };
  protoOf(ShowError_6).hashCode = function () {
    return getStringHashCode(this.g14o_1);
  };
  protoOf(ShowError_6).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShowError_6))
      return false;
    if (!(this.g14o_1 === other.g14o_1))
      return false;
    return true;
  };
  function ShoppingSideEffect() {
  }
  var ProductSortOrder_PRICE_LOW_HIGH_instance;
  var ProductSortOrder_PRICE_HIGH_LOW_instance;
  var ProductSortOrder_NAME_ASC_instance;
  var ProductSortOrder_NAME_DESC_instance;
  var ProductSortOrder_NEWEST_instance;
  var ProductSortOrder_OLDEST_instance;
  function values_7() {
    return [ProductSortOrder_PRICE_LOW_HIGH_getInstance(), ProductSortOrder_PRICE_HIGH_LOW_getInstance(), ProductSortOrder_NAME_ASC_getInstance(), ProductSortOrder_NAME_DESC_getInstance(), ProductSortOrder_NEWEST_getInstance(), ProductSortOrder_OLDEST_getInstance()];
  }
  function get_entries_2() {
    if ($ENTRIES_2 == null)
      $ENTRIES_2 = enumEntries(values_7());
    return $ENTRIES_2;
  }
  var ProductSortOrder_entriesInitialized;
  function ProductSortOrder_initEntries() {
    if (ProductSortOrder_entriesInitialized)
      return Unit_instance;
    ProductSortOrder_entriesInitialized = true;
    ProductSortOrder_PRICE_LOW_HIGH_instance = new ProductSortOrder('PRICE_LOW_HIGH', 0);
    ProductSortOrder_PRICE_HIGH_LOW_instance = new ProductSortOrder('PRICE_HIGH_LOW', 1);
    ProductSortOrder_NAME_ASC_instance = new ProductSortOrder('NAME_ASC', 2);
    ProductSortOrder_NAME_DESC_instance = new ProductSortOrder('NAME_DESC', 3);
    ProductSortOrder_NEWEST_instance = new ProductSortOrder('NEWEST', 4);
    ProductSortOrder_OLDEST_instance = new ProductSortOrder('OLDEST', 5);
  }
  var $ENTRIES_2;
  function ProductSortOrder(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ProductSortOrder_PRICE_LOW_HIGH_getInstance() {
    ProductSortOrder_initEntries();
    return ProductSortOrder_PRICE_LOW_HIGH_instance;
  }
  function ProductSortOrder_PRICE_HIGH_LOW_getInstance() {
    ProductSortOrder_initEntries();
    return ProductSortOrder_PRICE_HIGH_LOW_instance;
  }
  function ProductSortOrder_NAME_ASC_getInstance() {
    ProductSortOrder_initEntries();
    return ProductSortOrder_NAME_ASC_instance;
  }
  function ProductSortOrder_NAME_DESC_getInstance() {
    ProductSortOrder_initEntries();
    return ProductSortOrder_NAME_DESC_instance;
  }
  function ProductSortOrder_NEWEST_getInstance() {
    ProductSortOrder_initEntries();
    return ProductSortOrder_NEWEST_instance;
  }
  function ProductSortOrder_OLDEST_getInstance() {
    ProductSortOrder_initEntries();
    return ProductSortOrder_OLDEST_instance;
  }
  function ShoppingRoot(onNavigateToProfile, onNavigateToProductDetails, onNavigateToCart, onNavigateToCustomMug, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1949587268);
    sourceInformation($composer_0, 'C(ShoppingRoot)P(3,2)123@5920L15,124@5979L16,125@6033L7,126@6069L32,128@6128L274,128@6107L295,141@6525L64,142@6611L58,143@6698L65,144@6792L61,145@6883L67,146@6980L151,151@7164L228,156@7424L195,167@7806L670,138@6408L2069:ShoppingScreen.kt#2a4il0');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToProfile) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToProductDetails) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToCart) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1949587268, $dirty, -1, 'client.fstech.hadaya.presentation.shopping.ShoppingRoot (ShoppingScreen.kt:122)');
      }
      // Inline function 'org.koin.compose.viewmodel.koinViewModel' call
      var qualifier = null;
      var viewModelStoreOwner = null;
      var key = null;
      var extras = null;
      var scope = null;
      var parameters = null;
      var $composer_1 = $composer_0;
      sourceInformationMarkerStart($composer_1, -924953623, 'CC(koinViewModel)P(3,5,1!1,4)48@1587L7,51@1782L18:ViewModel.kt#7bazx');
      if (!((63 & 1) === 0))
        qualifier = null;
      if (!((63 & 2) === 0)) {
        var tmp0_elvis_lhs = LocalViewModelStoreOwner_getInstance().zxk($composer_1, androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No ViewModelStoreOwner was provided via LocalViewModelStoreOwner';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        viewModelStoreOwner = tmp;
      }
      if (!((63 & 4) === 0))
        key = null;
      if (!((63 & 8) === 0))
        extras = defaultExtras(viewModelStoreOwner);
      if (!((63 & 16) === 0))
        scope = currentKoinScope($composer_1, 0);
      if (!((63 & 32) === 0))
        parameters = null;
      var tmp0 = resolveViewModel(getKClass(ShoppingViewModel), viewModelStoreOwner.g8r(), key, extras, qualifier, scope, parameters);
      sourceInformationMarkerEnd($composer_1);
      var viewModel = tmp0;
      var tmp_0 = viewModel.s10h().ajg();
      var state$delegate = collectAsState(tmp_0, null, $composer_0, 0, 1);
      var tmp0_0 = get_LocalUriHandler();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_2 = $composer_0;
      var uriHandler = $composer_2.u31(tmp0_0);
      sourceInformationMarkerStart($composer_0, -947611460, 'CC(remember):ShoppingScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp_1;
      if (false || it === Companion_getInstance().f30_1) {
        var value = new SnackbarHostState();
        this_0.j31(value);
        tmp_1 = value;
      } else {
        tmp_1 = it;
      }
      var tmp0_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      var snackbarHostState = tmp0_group;
      sourceInformationMarkerStart($composer_0, -947609330, 'CC(remember):ShoppingScreen.kt#9igjgp');
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_1.i31();
      var tmp_2;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = ShoppingRoot$slambda_0(viewModel, snackbarHostState, null);
        tmp0_1.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      LaunchedEffect_0(Unit_instance, tmp1_group, $composer_0, 6);
      var tmp_3 = ShoppingRoot$lambda(state$delegate);
      sourceInformationMarkerStart($composer_0, -947596836, 'CC(remember):ShoppingScreen.kt#9igjgp');
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_2.i31();
      var tmp_4;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = ShoppingRoot$lambda_0(viewModel);
        tmp0_2.j31(value_1);
        tmp_4 = value_1;
      } else {
        tmp_4 = it_1;
      }
      var tmp2_group = tmp_4;
      sourceInformationMarkerEnd($composer_0);
      sourceInformationMarkerStart($composer_0, -947594090, 'CC(remember):ShoppingScreen.kt#9igjgp');
      var tmp0_3 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0_3.i31();
      var tmp_5;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = ShoppingRoot$lambda_1(viewModel);
        tmp0_3.j31(value_2);
        tmp_5 = value_2;
      } else {
        tmp_5 = it_2;
      }
      var tmp3_group = tmp_5;
      sourceInformationMarkerEnd($composer_0);
      sourceInformationMarkerStart($composer_0, -947591299, 'CC(remember):ShoppingScreen.kt#9igjgp');
      var tmp0_4 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_3 = tmp0_4.i31();
      var tmp_6;
      if (invalid_2 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = ShoppingRoot$lambda_2(viewModel);
        tmp0_4.j31(value_3);
        tmp_6 = value_3;
      } else {
        tmp_6 = it_3;
      }
      var tmp4_group = tmp_6;
      sourceInformationMarkerEnd($composer_0);
      sourceInformationMarkerStart($composer_0, -947588295, 'CC(remember):ShoppingScreen.kt#9igjgp');
      var tmp0_5 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_4 = tmp0_5.i31();
      var tmp_7;
      if (invalid_3 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = ShoppingRoot$lambda_3(viewModel);
        tmp0_5.j31(value_4);
        tmp_7 = value_4;
      } else {
        tmp_7 = it_4;
      }
      var tmp5_group = tmp_7;
      sourceInformationMarkerEnd($composer_0);
      sourceInformationMarkerStart($composer_0, -947585377, 'CC(remember):ShoppingScreen.kt#9igjgp');
      var tmp0_6 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_4 = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_5 = tmp0_6.i31();
      var tmp_8;
      if (invalid_4 || it_5 === Companion_getInstance().f30_1) {
        var value_5 = ShoppingRoot$lambda_4(viewModel);
        tmp0_6.j31(value_5);
        tmp_8 = value_5;
      } else {
        tmp_8 = it_5;
      }
      var tmp6_group = tmp_8;
      sourceInformationMarkerEnd($composer_0);
      sourceInformationMarkerStart($composer_0, -947582189, 'CC(remember):ShoppingScreen.kt#9igjgp');
      var tmp0_7 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_5 = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_6 = tmp0_7.i31();
      var tmp_9;
      if (invalid_5 || it_6 === Companion_getInstance().f30_1) {
        var value_6 = ShoppingRoot$lambda_5(viewModel);
        tmp0_7.j31(value_6);
        tmp_9 = value_6;
      } else {
        tmp_9 = it_6;
      }
      var tmp7_group = tmp_9;
      sourceInformationMarkerEnd($composer_0);
      sourceInformationMarkerStart($composer_0, -947576224, 'CC(remember):ShoppingScreen.kt#9igjgp');
      var tmp0_8 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_6 = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_7 = tmp0_8.i31();
      var tmp_10;
      if (invalid_6 || it_7 === Companion_getInstance().f30_1) {
        var value_7 = ShoppingRoot$lambda_6(viewModel);
        tmp0_8.j31(value_7);
        tmp_10 = value_7;
      } else {
        tmp_10 = it_7;
      }
      var tmp8_group = tmp_10;
      sourceInformationMarkerEnd($composer_0);
      sourceInformationMarkerStart($composer_0, -947567937, 'CC(remember):ShoppingScreen.kt#9igjgp');
      var tmp0_9 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_7 = $composer_0.q31(viewModel);
      // Inline function 'kotlin.let' call
      var it_8 = tmp0_9.i31();
      var tmp_11;
      if (invalid_7 || it_8 === Companion_getInstance().f30_1) {
        var value_8 = ShoppingRoot$lambda_7(viewModel);
        tmp0_9.j31(value_8);
        tmp_11 = value_8;
      } else {
        tmp_11 = it_8;
      }
      var tmp9_group = tmp_11;
      sourceInformationMarkerEnd($composer_0);
      sourceInformationMarkerStart($composer_0, -947555238, 'CC(remember):ShoppingScreen.kt#9igjgp');
      var tmp0_10 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_8 = !!(!!($composer_0.q31(uriHandler) | $composer_0.k31(state$delegate)) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_9 = tmp0_10.i31();
      var tmp_12;
      if (invalid_8 || it_9 === Companion_getInstance().f30_1) {
        var value_9 = ShoppingRoot$lambda_8(uriHandler, onNavigateToProductDetails, state$delegate);
        tmp0_10.j31(value_9);
        tmp_12 = value_9;
      } else {
        tmp_12 = it_9;
      }
      var tmp10_group = tmp_12;
      sourceInformationMarkerEnd($composer_0);
      ShoppingContent(tmp_3, snackbarHostState, tmp2_group, tmp3_group, tmp4_group, tmp5_group, tmp6_group, tmp7_group, tmp8_group, tmp9_group, onNavigateToProfile, onNavigateToProductDetails, onNavigateToCart, tmp10_group, null, $composer_0, 48, 14 & $dirty | 112 & $dirty | 896 & $dirty, 16384);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp11_safe_receiver = $composer_0.t30();
    if (tmp11_safe_receiver == null)
      null;
    else {
      tmp11_safe_receiver.p3c(ShoppingRoot$lambda_9(onNavigateToProfile, onNavigateToProductDetails, onNavigateToCart, onNavigateToCustomMug, $changed));
    }
  }
  function ShoppingContent(state, snackbarHostState, onSearchQueryChange, onRefresh, onToggleFavorite, onToggleLanguage, onSortOrderChange, onAgeFilterChange, onCustomFilterChange, onPriceFilterChange, onNavigateToProfile, onNavigateToProductDetails, onNavigateToCart, onBannerClick, modifier, $composer, $changed, $changed1, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-81772511);
    sourceInformation($composer_0, 'C(ShoppingContent)P(14,13,9,8,11,12,10,1,3,7,6,5,4,2)201@9218L41,202@9287L34,203@9343L31,204@9412L7,206@9448L27,215@9891L41,209@9610L328,223@10240L39,217@9967L318,233@10482L6999:ShoppingScreen.kt#2a4il0');
    var $dirty = $changed;
    var $dirty1 = $changed1;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(snackbarHostState) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onSearchQueryChange) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onRefresh) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onToggleFavorite) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onToggleLanguage) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(onSortOrderChange) ? 1048576 : 524288);
    if (($changed & 12582912) === 0)
      $dirty = $dirty | ($composer_0.q31(onAgeFilterChange) ? 8388608 : 4194304);
    if (($changed & 100663296) === 0)
      $dirty = $dirty | ($composer_0.q31(onCustomFilterChange) ? 67108864 : 33554432);
    if (($changed & 805306368) === 0)
      $dirty = $dirty | ($composer_0.q31(onPriceFilterChange) ? 536870912 : 268435456);
    if (($changed1 & 6) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(onNavigateToProfile) ? 4 : 2);
    if (($changed1 & 48) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(onNavigateToProductDetails) ? 32 : 16);
    if (($changed1 & 384) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(onNavigateToCart) ? 256 : 128);
    if (($changed1 & 3072) === 0)
      $dirty1 = $dirty1 | ($composer_0.q31(onBannerClick) ? 2048 : 1024);
    if (!(($default & 16384) === 0))
      $dirty1 = $dirty1 | 24576;
    else if (($changed1 & 24576) === 0)
      $dirty1 = $dirty1 | ($composer_0.k31(modifier_0._v) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 306783379) === 306783378) || !(($dirty1 & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 16384) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (isTraceInProgress()) {
        traceEventStart(-81772511, $dirty, $dirty1, 'client.fstech.hadaya.presentation.shopping.ShoppingContent (ShoppingScreen.kt:200)');
      }
      sourceInformationMarkerStart($composer_0, -1273949782, 'CC(remember):ShoppingScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = mutableStateOf(GiftTab_BOTH_getInstance());
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var selectedTab$delegate = tmp0_group;
      sourceInformationMarkerStart($composer_0, -1273947581, 'CC(remember):ShoppingScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = mutableStateOf(false);
        this_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      var showFilterSheet$delegate = tmp1_group;
      var sheetState = rememberModalBottomSheetState(false, null, $composer_0, 0, 3);
      var tmp0 = get_LocalUriHandler();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var uriHandler = $composer_1.u31(tmp0);
      var adaptiveInfo = currentWindowAdaptiveInfo(false, $composer_0, 0, 1);
      var isDesktop = adaptiveInfo.bxm_1.sxl().equals(Companion_getInstance_21().vxl_1);
      var tmp_1;
      switch (ShoppingContent$lambda(selectedTab$delegate).a1_1) {
        case 0:
          $composer_0.m30(-1273934318);
          $composer_0.n30();
          tmp_1 = get_BlueGradientStart();
          break;
        case 1:
          $composer_0.m30(-1273932017);
          sourceInformation($composer_0, '212@9762L11');
          var tmp2_group = MaterialTheme_instance.unz($composer_0, 6).oo0_1;
          $composer_0.n30();
          tmp_1 = tmp2_group;
          break;
        case 2:
          $composer_0.m30(-1273930606);
          $composer_0.n30();
          tmp_1 = get_PinkGradientStart();
          break;
        default:
          $composer_0.m30(-1273935711);
          $composer_0.n30();
          noWhenBranchMatchedException();
          break;
      }
      var tmp_2 = tmp_1;
      var tmp_3 = tween(500);
      var tmp_4 = stringResource(get_gradient_start(string_instance), $composer_0, 0);
      var gradientStartColor$delegate = animateColorAsState(tmp_2, tmp_3, tmp_4, null, $composer_0, 48, 8);
      var tmp_5;
      switch (ShoppingContent$lambda(selectedTab$delegate).a1_1) {
        case 0:
          $composer_0.m30(-1273922896);
          $composer_0.n30();
          tmp_5 = get_BlueGradientEnd();
          break;
        case 1:
          $composer_0.m30(-1273920661);
          sourceInformation($composer_0, '220@10117L11');
          var tmp3_group = MaterialTheme_instance.unz($composer_0, 6).ko0_1;
          $composer_0.n30();
          tmp_5 = tmp3_group;
          break;
        case 2:
          $composer_0.m30(-1273919376);
          $composer_0.n30();
          tmp_5 = get_PinkGradientEnd();
          break;
        default:
          $composer_0.m30(-1273924295);
          $composer_0.n30();
          noWhenBranchMatchedException();
          break;
      }
      var tmp_6 = tmp_5;
      var tmp_7 = tween(500);
      var tmp_8 = stringResource(get_gradient_end(string_instance), $composer_0, 0);
      var gradientEndColor$delegate = animateColorAsState(tmp_6, tmp_7, tmp_8, null, $composer_0, 48, 8);
      var backgroundBrush = Companion_instance_1.d6c(listOf_0([new Color_0(Color__copy$default_impl_ectz3s(ShoppingContent$lambda_3(gradientStartColor$delegate), 0.8)), new Color_0(Color__copy$default_impl_ectz3s(ShoppingContent$lambda_4(gradientEndColor$delegate), 0.6))]));
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_1 = fillMaxSize(modifier_0._v);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_2 = $composer_0;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_3 = $composer_2;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_9 = $composer_4.g30();
      if (!isInterface(tmp_9, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_0);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_5 = $composer_4;
      var $composer_6 = $composer_5;
      sourceInformationMarkerStart($composer_6, 375779616, 'C234@10531L6833,343@17377L94:ShoppingScreen.kt#2a4il0');
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_3 = background_0(fillMaxSize(Companion_instance), backgroundBrush);
      var contentAlignment_0 = null;
      var propagateMinConstraints_0 = false;
      var $composer_7 = $composer_6;
      if (!((6 & 1) === 0))
        modifier_3 = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment_0 = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints_0 = false;
      var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment_0, propagateMinConstraints_0);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_4 = modifier_3;
      var $composer_8 = $composer_7;
      if (!((0 & 2) === 0))
        modifier_4 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
      var localMap_0 = $composer_8.t31();
      var materialized_0 = materialize($composer_8, modifier_4);
      var tmp0_1 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_9 = $composer_8;
      var tmp_10 = $composer_9.g30();
      if (!isInterface(tmp_10, Applier)) {
        invalidApplier();
      }
      $composer_9.b31();
      if ($composer_9.h30()) {
        $composer_9.c31(tmp0_1);
      } else {
        $composer_9.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_10 = $composer_9;
      var $composer_11 = $composer_10;
      sourceInformationMarkerStart($composer_11, 1763165032, 'C235@10616L6734:ShoppingScreen.kt#2a4il0');
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_5 = fillMaxSize(Companion_instance);
      var verticalArrangement = null;
      var horizontalAlignment = null;
      var $composer_12 = $composer_11;
      if (!((6 & 1) === 0))
        modifier_5 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy_1 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_12, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_6 = modifier_5;
      var $composer_13 = $composer_12;
      if (!((0 & 2) === 0))
        modifier_6 = Companion_instance;
      var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_13, 0).hashCode();
      var localMap_1 = $composer_13.t31();
      var materialized_1 = materialize($composer_13, modifier_6);
      var tmp0_2 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_14 = $composer_13;
      var tmp_11 = $composer_14.g30();
      if (!isInterface(tmp_11, Applier)) {
        invalidApplier();
      }
      $composer_14.b31();
      if ($composer_14.h30()) {
        $composer_14.c31(tmp0_2);
      } else {
        $composer_14.d31();
      }
      var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_14);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
      var $composer_15 = $composer_14;
      var $composer_16 = $composer_15;
      sourceInformationMarkerStart($composer_16, -705267388, 'C265@12720L51,237@10723L735,249@11494L1173,236@10680L2178,270@12914L1631,297@14602L2730:ShoppingScreen.kt#2a4il0');
      var tmp_12 = TopAppBarDefaults_getInstance();
      var tmp_13 = Companion_getInstance_14().t6b_1;
      var tmp_14 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_15 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_16 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_17 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp0_colors = tmp_12.wnz(tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_16, 1572870, 62);
      var tmp1_windowInsets = WindowInsets(0, 0, 0, 0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1952990625, true, ShoppingContent$lambda_5(uriHandler), $composer_16, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_17 = $composer_16;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_17.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_17.i31();
      var tmp_18;
      if (invalid || it_1 === Companion_getInstance().f30_1) {
        var value_1 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_17.j31(value_1);
        tmp_18 = value_1;
      } else {
        tmp_18 = it_1;
      }
      var tmp_19 = tmp_18;
      // Inline function 'kotlin.run' call
      var dispatchReceiver_0 = rememberComposableLambda(-167913132, true, ShoppingContent$lambda_6(onToggleLanguage, onNavigateToCart, onNavigateToProfile, state), $composer_16, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_18 = $composer_16;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_18.k31(dispatchReceiver_0);
      // Inline function 'kotlin.let' call
      var it_2 = $composer_18.i31();
      var tmp_20;
      if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = ComposableLambda$invoke$ref_1(dispatchReceiver_0);
        $composer_18.j31(value_2);
        tmp_20 = value_2;
      } else {
        tmp_20 = it_2;
      }
      var tmp_21 = tmp_20;
      var tmp_22 = _Dp___init__impl__ms3zkb(0.0);
      TopAppBar(tmp_19, null, null, tmp_21, tmp_22, tmp1_windowInsets, tmp0_colors, null, $composer_16, 3078, 150);
      var tmp_23 = fillMaxWidth(Companion_instance);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp_24 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$42 = _Dp___init__impl__ms3zkb(8);
      var tmp2_modifier = padding_2(tmp_23, tmp_24, tmp$ret$42);
      var tmp3_verticalAlignment = Companion_getInstance_11().u8t_1;
      var tmp_25 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$43 = _Dp___init__impl__ms3zkb(8);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_7 = tmp2_modifier;
      var horizontalArrangement = tmp_25.mdq(tmp$ret$43);
      var verticalAlignment = tmp3_verticalAlignment;
      var $composer_19 = $composer_16;
      if (!((0 & 1) === 0))
        modifier_7 = Companion_instance;
      if (!((0 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy_2 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_19, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_8 = modifier_7;
      var $composer_20 = $composer_19;
      if (!((0 & 2) === 0))
        modifier_8 = Companion_instance;
      var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_20, 0).hashCode();
      var localMap_2 = $composer_20.t31();
      var materialized_2 = materialize($composer_20, modifier_8);
      var tmp0_3 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_21 = $composer_20;
      var tmp_26 = $composer_21.g30();
      if (!isInterface(tmp_26, Applier)) {
        invalidApplier();
      }
      $composer_21.b31();
      if ($composer_21.h30()) {
        $composer_21.c31(tmp0_3);
      } else {
        $composer_21.d31();
      }
      var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_21);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
      var $composer_22 = $composer_21;
      var $composer_23 = $composer_22;
      sourceInformationMarkerStart($composer_23, -1158381244, 'C282@13807L11,282@13868L11,282@13762L208,275@13219L824:ShoppingScreen.kt#2a4il0');
      var tmp0_value = state.z14m_1;
      var tmp1_modifier = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$50 = _Dp___init__impl__ms3zkb(24);
      var tmp2_shape = RoundedCornerShape(tmp$ret$50);
      var tmp_27 = OutlinedTextFieldDefaults_getInstance();
      var tmp_28 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_29 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_30 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_31 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_32 = MaterialTheme_instance.unz($composer_23, 6).mo0_1;
      var tmp_33 = MaterialTheme_instance.unz($composer_23, 6).mo0_1;
      var tmp_34 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_35 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_36 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_37 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_38 = Companion_getInstance_14().t6b_1;
      var tmp_39 = Companion_getInstance_14().t6b_1;
      var tmp_40 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_41 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_42 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_43 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_44 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_45 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_46 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_47 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_48 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_49 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_50 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_51 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_52 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_53 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_54 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_55 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_56 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_57 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_58 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_59 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_60 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_61 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_62 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_63 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_64 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_65 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_66 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_67 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_68 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp3_colors = tmp_27.np9(tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, null, tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, tmp_43, tmp_44, tmp_45, tmp_46, tmp_47, tmp_48, tmp_49, tmp_50, tmp_51, tmp_52, tmp_53, tmp_54, tmp_55, tmp_56, tmp_57, tmp_58, tmp_59, tmp_60, tmp_61, tmp_62, tmp_63, tmp_64, tmp_65, tmp_66, tmp_67, tmp_68, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_23, 0, 432, 0, 0, 3072, 2147477455, 4095);
      var tmp_69 = ComposableSingletons$ShoppingScreenKt_getInstance().j14o_1;
      var tmp_70 = ComposableSingletons$ShoppingScreenKt_getInstance().k14o_1;
      OutlinedTextField(tmp0_value, onSearchQueryChange, tmp1_modifier, false, false, null, null, tmp_69, tmp_70, null, null, null, null, false, null, null, null, true, 0, 0, null, tmp2_shape, tmp3_colors, $composer_23, 113246208 | 112 & $dirty >> 3, 12582912, 0, 1965688);
      if (!isDesktop) {
        $composer_23.m30(-1157549019);
        sourceInformation($composer_23, '288@14169L26,289@14304L11,287@14115L382');
        sourceInformationMarkerStart($composer_23, -37338015, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_3 = $composer_23.i31();
        var tmp_71;
        if (false || it_3 === Companion_getInstance().f30_1) {
          var value_3 = ShoppingContent$lambda_7(showFilterSheet$delegate);
          $composer_23.j31(value_3);
          tmp_71 = value_3;
        } else {
          tmp_71 = it_3;
        }
        var tmp0_group_0 = tmp_71;
        sourceInformationMarkerEnd($composer_23);
        var tmp_72 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$55 = _Dp___init__impl__ms3zkb(48);
        var tmp_73 = background(clip(size(tmp_72, tmp$ret$55), get_CircleShape()), MaterialTheme_instance.unz($composer_23, 6).mo0_1);
        IconButton(tmp0_group_0, tmp_73, false, null, null, null, ComposableSingletons$ShoppingScreenKt_getInstance().l14o_1, $composer_23, 1572870, 60);
        $composer_23.n30();
      } else {
        $composer_23.m30(-1157128101);
        $composer_23.n30();
      }
      sourceInformationMarkerEnd($composer_23);
      $composer_21.e31();
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_9 = fillMaxSize(Companion_instance);
      var horizontalArrangement_0 = null;
      var verticalAlignment_0 = null;
      var $composer_24 = $composer_16;
      if (!((6 & 1) === 0))
        modifier_9 = Companion_instance;
      if (!((6 & 2) === 0))
        horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
      if (!((6 & 4) === 0))
        verticalAlignment_0 = Companion_getInstance_11().t8t_1;
      var measurePolicy_3 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_24, 14 & 6 >> 3 | 112 & 6 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_10 = modifier_9;
      var $composer_25 = $composer_24;
      if (!((0 & 2) === 0))
        modifier_10 = Companion_instance;
      var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_25, 0).hashCode();
      var localMap_3 = $composer_25.t31();
      var materialized_3 = materialize($composer_25, modifier_10);
      var tmp0_4 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_26 = $composer_25;
      var tmp_74 = $composer_26.g30();
      if (!isInterface(tmp_74, Applier)) {
        invalidApplier();
      }
      $composer_26.b31();
      if ($composer_26.h30()) {
        $composer_26.c31(tmp0_4);
      } else {
        $composer_26.d31();
      }
      var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_26);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
      var $composer_27 = $composer_26;
      var $composer_28 = $composer_27;
      sourceInformationMarkerStart($composer_28, -1189649518, 'C313@15416L1894:ShoppingScreen.kt#2a4il0');
      if (isDesktop) {
        $composer_28.m30(-1189694624);
        sourceInformation($composer_28, '302@14892L472,299@14712L652');
        var tmp_75 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$62 = _Dp___init__impl__ms3zkb(300);
        var tmp_76 = fillMaxHeight(width(tmp_75, tmp$ret$62));
        var tmp_77 = Companion_getInstance_14().t6b_1;
        var tmp_78 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_79 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_80 = _Dp___init__impl__ms3zkb(0.0);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_1 = rememberComposableLambda(1747995188, true, ShoppingContent$lambda_8(state, onSortOrderChange, onAgeFilterChange, onCustomFilterChange, onPriceFilterChange), $composer_28, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_29 = $composer_28;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = $composer_29.k31(dispatchReceiver_1);
        // Inline function 'kotlin.let' call
        var it_4 = $composer_29.i31();
        var tmp_81;
        if (invalid_1 || it_4 === Companion_getInstance().f30_1) {
          var value_4 = ComposableLambda$invoke$ref(dispatchReceiver_1);
          $composer_29.j31(value_4);
          tmp_81 = value_4;
        } else {
          tmp_81 = it_4;
        }
        var tmp$ret$63 = tmp_81;
        Surface(tmp_76, null, tmp_77, tmp_78, tmp_79, tmp_80, null, tmp$ret$63, $composer_28, 12583302, 122);
        $composer_28.n30();
      } else {
        $composer_28.m30(-1189014236);
        $composer_28.n30();
      }
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_11 = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
      var verticalArrangement_0 = null;
      var horizontalAlignment_0 = null;
      var $composer_30 = $composer_28;
      if (!((6 & 1) === 0))
        modifier_11 = Companion_instance;
      if (!((6 & 2) === 0))
        verticalArrangement_0 = Arrangement_getInstance().sdp_1;
      if (!((6 & 4) === 0))
        horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
      var measurePolicy_4 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_30, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_12 = modifier_11;
      var $composer_31 = $composer_30;
      if (!((0 & 2) === 0))
        modifier_12 = Companion_instance;
      var compositeKeyHash_4 = get_currentCompositeKeyHashCode($composer_31, 0).hashCode();
      var localMap_4 = $composer_31.t31();
      var materialized_4 = materialize($composer_31, modifier_12);
      var tmp0_5 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_32 = $composer_31;
      var tmp_82 = $composer_32.g30();
      if (!isInterface(tmp_82, Applier)) {
        invalidApplier();
      }
      $composer_32.b31();
      if ($composer_32.h30()) {
        $composer_32.c31(tmp0_5);
      } else {
        $composer_32.d31();
      }
      var $this$ReusableComposeNode_4 = _Updater___init__impl__rbfxm8($composer_32);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_4, measurePolicy_4, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_4, localMap_4, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_4, compositeKeyHash_4, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_4, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_4, materialized_4, Companion_getInstance_12().qah_1);
      var $composer_33 = $composer_32;
      var $composer_34 = $composer_33;
      sourceInformationMarkerStart($composer_34, 539105100, 'C318@15799L11,320@15927L556,315@15521L962:ShoppingScreen.kt#2a4il0');
      var tmp_83;
      switch (ShoppingContent$lambda(selectedTab$delegate).a1_1) {
        case 0:
          tmp_83 = 0;
          break;
        case 1:
          tmp_83 = 1;
          break;
        case 2:
          tmp_83 = 2;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var tmp1_selectedTabIndex = tmp_83;
      var tmp2_containerColor = Companion_getInstance_14().t6b_1;
      var tmp3_contentColor = MaterialTheme_instance.unz($composer_34, 6).no0_1;
      var tmp_84 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$76 = _Dp___init__impl__ms3zkb(8);
      var tmp4_modifier = padding_1(tmp_84, VOID, VOID, VOID, tmp$ret$76);
      // Inline function 'kotlin.run' call
      var dispatchReceiver_2 = rememberComposableLambda(597639836, true, ShoppingContent$lambda_9(selectedTab$delegate), $composer_34, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_35 = $composer_34;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = $composer_35.k31(dispatchReceiver_2);
      // Inline function 'kotlin.let' call
      var it_5 = $composer_35.i31();
      var tmp_85;
      if (invalid_2 || it_5 === Companion_getInstance().f30_1) {
        var value_5 = ComposableLambda$invoke$ref(dispatchReceiver_2);
        $composer_35.j31(value_5);
        tmp_85 = value_5;
      } else {
        tmp_85 = it_5;
      }
      var tmp$ret$77 = tmp_85;
      SecondaryTabRow(tmp1_selectedTabIndex, tmp4_modifier, tmp2_containerColor, tmp3_contentColor, null, null, tmp$ret$77, $composer_34, 1573296, 48);
      if (state.e14n_1 && state.x14m_1.r()) {
        $composer_34.m30(540127758);
        sourceInformation($composer_34, '328@16636L96');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_13 = fillMaxSize(Companion_instance);
        var contentAlignment_1 = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints_1 = false;
        var $composer_36 = $composer_34;
        if (!((4 & 1) === 0))
          modifier_13 = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment_1 = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints_1 = false;
        var measurePolicy_5 = maybeCachedBoxMeasurePolicy(contentAlignment_1, propagateMinConstraints_1);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_14 = modifier_13;
        var $composer_37 = $composer_36;
        if (!((0 & 2) === 0))
          modifier_14 = Companion_instance;
        var compositeKeyHash_5 = get_currentCompositeKeyHashCode($composer_37, 0).hashCode();
        var localMap_5 = $composer_37.t31();
        var materialized_5 = materialize($composer_37, modifier_14);
        var tmp0_6 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_38 = $composer_37;
        var tmp_86 = $composer_38.g30();
        if (!isInterface(tmp_86, Applier)) {
          invalidApplier();
        }
        $composer_38.b31();
        if ($composer_38.h30()) {
          $composer_38.c31(tmp0_6);
        } else {
          $composer_38.d31();
        }
        var $this$ReusableComposeNode_5 = _Updater___init__impl__rbfxm8($composer_38);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, measurePolicy_5, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, localMap_5, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, compositeKeyHash_5, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_5, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_5, materialized_5, Companion_getInstance_12().qah_1);
        var $composer_39 = $composer_38;
        var $composer_40 = $composer_39;
        sourceInformationMarkerStart($composer_40, 2018603091, 'C328@16703L27:ShoppingScreen.kt#2a4il0');
        var tmp_87 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_88 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_89 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_90 = _StrokeCap___init__impl__kfgr27(0);
        CircularProgressIndicator(null, tmp_87, tmp_88, tmp_89, tmp_90, _Dp___init__impl__ms3zkb(0.0), $composer_40, 0, 63);
        sourceInformationMarkerEnd($composer_40);
        $composer_38.e31();
        $composer_34.n30();
      } else {
        $composer_34.m30(540303466);
        sourceInformation($composer_34, '330@16802L452');
        ProductsGrid(state, ShoppingContent$lambda(selectedTab$delegate), onRefresh, onToggleFavorite, onNavigateToProductDetails, onBannerClick, $composer_34, 14 & $dirty | 896 & $dirty >> 3 | 7168 & $dirty >> 3 | 57344 & $dirty1 << 9 | 458752 & $dirty1 << 6);
        $composer_34.n30();
      }
      sourceInformationMarkerEnd($composer_34);
      $composer_32.e31();
      sourceInformationMarkerEnd($composer_28);
      $composer_26.e31();
      sourceInformationMarkerEnd($composer_16);
      $composer_14.e31();
      sourceInformationMarkerEnd($composer_11);
      $composer_9.e31();
      var tmp_91 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().r8t_1);
      SnackbarHost(snackbarHostState, tmp_91, null, $composer_6, 14 & $dirty >> 3, 4);
      sourceInformationMarkerEnd($composer_6);
      $composer_4.e31();
      if (ShoppingContent$lambda_1(showFilterSheet$delegate) && !isDesktop) {
        $composer_0.m30(-829483113);
        sourceInformation($composer_0, '347@17576L27,347@17630L344,347@17540L434');
        sourceInformationMarkerStart($composer_0, -1273682340, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var this_2 = $composer_0;
        // Inline function 'kotlin.let' call
        var it_6 = this_2.i31();
        var tmp_92;
        if (false || it_6 === Companion_getInstance().f30_1) {
          var value_6 = ShoppingContent$lambda_10(showFilterSheet$delegate);
          this_2.j31(value_6);
          tmp_92 = value_6;
        } else {
          tmp_92 = it_6;
        }
        var tmp4_group = tmp_92;
        sourceInformationMarkerEnd($composer_0);
        var tmp_93 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_94 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_95 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_96 = _Dp___init__impl__ms3zkb(0.0);
        var tmp_97 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        // Inline function 'kotlin.run' call
        var dispatchReceiver_3 = rememberComposableLambda(-1747353318, true, ShoppingContent$lambda_11(state, onSortOrderChange, onAgeFilterChange, onCustomFilterChange, onPriceFilterChange), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_41 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_3 = $composer_41.k31(dispatchReceiver_3);
        // Inline function 'kotlin.let' call
        var it_7 = $composer_41.i31();
        var tmp_98;
        if (invalid_3 || it_7 === Companion_getInstance().f30_1) {
          var value_7 = ComposableLambda$invoke$ref_6(dispatchReceiver_3);
          $composer_41.j31(value_7);
          tmp_98 = value_7;
        } else {
          tmp_98 = it_7;
        }
        var tmp$ret$94 = tmp_98;
        ModalBottomSheet(tmp4_group, null, sheetState, tmp_93, false, null, tmp_94, tmp_95, tmp_96, tmp_97, null, null, null, tmp$ret$94, $composer_0, 6, 3072, 8186);
        $composer_0.n30();
      } else {
        $composer_0.m30(-829042975);
        $composer_0.n30();
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp5_safe_receiver = $composer_0.t30();
    if (tmp5_safe_receiver == null)
      null;
    else {
      tmp5_safe_receiver.p3c(ShoppingContent$lambda_12(state, snackbarHostState, onSearchQueryChange, onRefresh, onToggleFavorite, onToggleLanguage, onSortOrderChange, onAgeFilterChange, onCustomFilterChange, onPriceFilterChange, onNavigateToProfile, onNavigateToProductDetails, onNavigateToCart, onBannerClick, modifier_0, $changed, $changed1, $default));
    }
  }
  var GiftTab_MENS_instance;
  var GiftTab_BOTH_instance;
  var GiftTab_GIRLS_instance;
  var GiftTab_entriesInitialized;
  function GiftTab_initEntries() {
    if (GiftTab_entriesInitialized)
      return Unit_instance;
    GiftTab_entriesInitialized = true;
    GiftTab_MENS_instance = new GiftTab('MENS', 0);
    GiftTab_BOTH_instance = new GiftTab('BOTH', 1);
    GiftTab_GIRLS_instance = new GiftTab('GIRLS', 2);
  }
  function GiftTab(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ComposableLambda$invoke$ref_14(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function ComposableSingletons$ShoppingScreenKt$lambda$87782703$lambda($this$BadgedBox, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C258@12372L38:ShoppingScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(87782703, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$ShoppingScreenKt.lambda$87782703.<anonymous> (ShoppingScreen.kt:258)');
      }
      var tmp = get_ShoppingCart(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ShoppingScreenKt$lambda$536520682$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C262@12579L32:ShoppingScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(536520682, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$ShoppingScreenKt.lambda$536520682.<anonymous> (ShoppingScreen.kt:262)');
      }
      var tmp = get_Person(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 48, 12);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ShoppingScreenKt$lambda$846055360$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C278@13407L45,278@13402L71:ShoppingScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(846055360, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$ShoppingScreenKt.lambda$846055360.<anonymous> (ShoppingScreen.kt:278)');
      }
      var tmp = stringResource(get_search_placeholder(string_instance), $composer_0, 0);
      var tmp_0 = Companion_getInstance_14().k6b_1;
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 384, 0, 262138);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ShoppingScreenKt$lambda$_848020897$lambda_f5xyn($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C280@13581L51:ShoppingScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-848020897, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$ShoppingScreenKt.lambda$-848020897.<anonymous> (ShoppingScreen.kt:280)');
      }
      var tmp = get_Search(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, Companion_getInstance_14().k6b_1, $composer_0, 3120, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ShoppingScreenKt$lambda$_408319744$lambda_o9v4r($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C291@14447L11,291@14389L78:ShoppingScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-408319744, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$ShoppingScreenKt.lambda$-408319744.<anonymous> (ShoppingScreen.kt:291)');
      }
      var tmp = get_FilterList(Icons_getInstance().dxv_1);
      Icon(tmp, null, null, MaterialTheme_instance.unz($composer_0, 6).xnz_1, $composer_0, 48, 4);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ShoppingScreenKt$lambda$903137142$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C321@16061L38,321@16056L44:ShoppingScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(903137142, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$ShoppingScreenKt.lambda$903137142.<anonymous> (ShoppingScreen.kt:321)');
      }
      var tmp = stringResource(get_men_s_gifts(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ShoppingScreenKt$lambda$1674782687$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C322@16236L36,322@16231L42:ShoppingScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1674782687, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$ShoppingScreenKt.lambda$1674782687.<anonymous> (ShoppingScreen.kt:322)');
      }
      var tmp = stringResource(get_all_gifts(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ShoppingScreenKt$lambda$1988232318$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C323@16411L38,323@16406L44:ShoppingScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1988232318, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$ShoppingScreenKt.lambda$1988232318.<anonymous> (ShoppingScreen.kt:323)');
      }
      var tmp = stringResource(get_girls_gifts(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ShoppingScreenKt$lambda$1032677925$lambda($this$TextButton, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C451@22470L44,451@22465L50:ShoppingScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1032677925, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$ShoppingScreenKt.lambda$1032677925.<anonymous> (ShoppingScreen.kt:451)');
      }
      var tmp = stringResource(get_reset_filters_btn(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ShoppingScreenKt$lambda$_1018973999$lambda_hmzvaf($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C505@26167L42,505@26162L48:ShoppingScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1018973999, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$ShoppingScreenKt.lambda$-1018973999.<anonymous> (ShoppingScreen.kt:505)');
      }
      var tmp = stringResource(get_min_price_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ShoppingScreenKt$lambda$460312058$lambda($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C506@26520L42,506@26515L48:ShoppingScreen.kt#2a4il0');
    if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(460312058, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ComposableSingletons$ShoppingScreenKt.lambda$460312058.<anonymous> (ShoppingScreen.kt:506)');
      }
      var tmp = stringResource(get_max_price_label(string_instance), $composer_0, 0);
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp, null, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ShoppingScreenKt() {
    ComposableSingletons$ShoppingScreenKt_instance = this;
    var tmp = this;
    tmp.h14o_1 = ComposableLambda$invoke$ref_14(composableLambdaInstance(87782703, false, ComposableSingletons$ShoppingScreenKt$lambda$87782703$lambda));
    var tmp_0 = this;
    tmp_0.i14o_1 = ComposableLambda$invoke$ref(composableLambdaInstance(536520682, false, ComposableSingletons$ShoppingScreenKt$lambda$536520682$lambda));
    var tmp_1 = this;
    tmp_1.j14o_1 = ComposableLambda$invoke$ref(composableLambdaInstance(846055360, false, ComposableSingletons$ShoppingScreenKt$lambda$846055360$lambda));
    var tmp_2 = this;
    tmp_2.k14o_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-848020897, false, ComposableSingletons$ShoppingScreenKt$lambda$_848020897$lambda_f5xyn));
    var tmp_3 = this;
    tmp_3.l14o_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-408319744, false, ComposableSingletons$ShoppingScreenKt$lambda$_408319744$lambda_o9v4r));
    var tmp_4 = this;
    tmp_4.m14o_1 = ComposableLambda$invoke$ref(composableLambdaInstance(903137142, false, ComposableSingletons$ShoppingScreenKt$lambda$903137142$lambda));
    var tmp_5 = this;
    tmp_5.n14o_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1674782687, false, ComposableSingletons$ShoppingScreenKt$lambda$1674782687$lambda));
    var tmp_6 = this;
    tmp_6.o14o_1 = ComposableLambda$invoke$ref(composableLambdaInstance(1988232318, false, ComposableSingletons$ShoppingScreenKt$lambda$1988232318$lambda));
    var tmp_7 = this;
    tmp_7.p14o_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(1032677925, false, ComposableSingletons$ShoppingScreenKt$lambda$1032677925$lambda));
    var tmp_8 = this;
    tmp_8.q14o_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1018973999, false, ComposableSingletons$ShoppingScreenKt$lambda$_1018973999$lambda_hmzvaf));
    var tmp_9 = this;
    tmp_9.r14o_1 = ComposableLambda$invoke$ref(composableLambdaInstance(460312058, false, ComposableSingletons$ShoppingScreenKt$lambda$460312058$lambda));
  }
  var ComposableSingletons$ShoppingScreenKt_instance;
  function ComposableSingletons$ShoppingScreenKt_getInstance() {
    if (ComposableSingletons$ShoppingScreenKt_instance == null)
      new ComposableSingletons$ShoppingScreenKt();
    return ComposableSingletons$ShoppingScreenKt_instance;
  }
  function FilterContent(state, onSortOrderChange, onAgeFilterChange, onCustomFilterChange, onPriceFilterChange, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1834624412);
    sourceInformation($composer_0, 'C(FilterContent)P(4,3)432@21206L54,433@21285L102,434@21410L21,436@21437L5196:ShoppingScreen.kt#2a4il0');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onSortOrderChange) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onAgeFilterChange) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onCustomFilterChange) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onPriceFilterChange) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1834624412, $dirty, -1, 'client.fstech.hadaya.presentation.shopping.FilterContent (ShoppingScreen.kt:431)');
      }
      sourceInformationMarkerStart($composer_0, 2137478418, 'CC(remember):ShoppingScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = mutableStateOf(state.a14n_1.toString());
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var tempMinPrice$delegate = tmp0_group;
      sourceInformationMarkerStart($composer_0, 2137480994, 'CC(remember):ShoppingScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_0;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = mutableStateOf(state.b14n_1 === 1.7976931348623157E308 ? '' : state.b14n_1.toString());
        this_1.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp1_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      var tempMaxPrice$delegate = tmp1_group;
      var scrollState = rememberScrollState(0, $composer_0, 0, 1);
      var tmp_1 = verticalScroll(fillMaxWidth(Companion_instance), scrollState);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$8 = _Dp___init__impl__ms3zkb(24);
      var tmp0 = padding_0(tmp_1, tmp$ret$8);
      var tmp_2 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$9 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier = tmp0;
      var verticalArrangement = tmp_2.mdq(tmp$ret$9);
      var horizontalAlignment = null;
      var $composer_1 = $composer_0;
      if (!((4 & 1) === 0))
        modifier = Companion_instance;
      if (!((4 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((4 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 48 >> 3 | 112 & 48 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_3 = $composer_3.g30();
      if (!isInterface(tmp_3, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0_0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 806039584, 'C440@21606L921,454@22549L42,454@22615L10,454@22537L135,455@22708L37,455@22791L57,455@22681L168,456@22885L38,456@22970L56,456@22858L169,457@23063L36,457@23144L58,457@23036L167,460@23261L50,462@23385L107,459@23221L281,465@23551L47,467@23678L101,464@23511L278,485@24594L63,486@24678L40,486@24742L10,486@24666L133,502@25635L63,503@25719L44,503@25787L10,503@25707L137,504@25853L774:ShoppingScreen.kt#2a4il0');
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_1 = fillMaxWidth(Companion_instance);
      var horizontalArrangement = Arrangement_getInstance().wdp_1;
      var verticalAlignment = Companion_getInstance_11().u8t_1;
      var $composer_6 = $composer_5;
      if (!((0 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((0 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_6, 14 & 438 >> 3 | 112 & 438 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_7 = $composer_6;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
      var localMap_0 = $composer_7.t31();
      var materialized_0 = materialize($composer_7, modifier_2);
      var tmp0_1 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_8 = $composer_7;
      var tmp_4 = $composer_8.g30();
      if (!isInterface(tmp_4, Applier)) {
        invalidApplier();
      }
      $composer_8.b31();
      if ($composer_8.h30()) {
        $composer_8.c31(tmp0_1);
      } else {
        $composer_8.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_9 = $composer_8;
      var $composer_10 = $composer_9;
      sourceInformationMarkerStart($composer_10, -415347734, 'C441@21758L360,445@22152L309,445@22131L386:ShoppingScreen.kt#2a4il0');
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_3 = null;
      var verticalArrangement_0 = null;
      var horizontalAlignment_0 = null;
      var $composer_11 = $composer_10;
      if (!((7 & 1) === 0))
        modifier_3 = Companion_instance;
      if (!((7 & 2) === 0))
        verticalArrangement_0 = Arrangement_getInstance().sdp_1;
      if (!((7 & 4) === 0))
        horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
      var measurePolicy_1 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_11, 14 & 0 >> 3 | 112 & 0 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_4 = modifier_3;
      var $composer_12 = $composer_11;
      if (!((0 & 2) === 0))
        modifier_4 = Companion_instance;
      var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_12, 0).hashCode();
      var localMap_1 = $composer_12.t31();
      var materialized_1 = materialize($composer_12, modifier_4);
      var tmp0_2 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_13 = $composer_12;
      var tmp_5 = $composer_13.g30();
      if (!isInterface(tmp_5, Applier)) {
        invalidApplier();
      }
      $composer_13.b31();
      if ($composer_13.h30()) {
        $composer_13.c31(tmp0_2);
      } else {
        $composer_13.d31();
      }
      var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_13);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
      var $composer_14 = $composer_13;
      var $composer_15 = $composer_14;
      sourceInformationMarkerStart($composer_15, 1241308502, 'C442@21795L37,442@21856L10,442@21783L125,443@21971L41,443@22038L10,443@22084L11,443@21925L179:ShoppingScreen.kt#2a4il0');
      var tmp0_text = stringResource(get_filter_btn(string_instance), $composer_15, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_15, 6).lof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp_6 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_10 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp_6, null, tmp_7, null, tmp2_fontWeight, null, tmp_8, null, null, tmp_9, tmp_10, false, 0, 0, null, tmp1_style, $composer_15, 1572864, 0, 131006);
      var tmp3_text = '' + state.y14m_1.n1() + ' ' + stringResource(get_products_found(string_instance), $composer_15, 0);
      var tmp4_style = MaterialTheme_instance.jog($composer_15, 6).sof_1;
      var tmp5_color = MaterialTheme_instance.unz($composer_15, 6).xnz_1;
      var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_14 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp3_text, null, tmp5_color, null, tmp_11, null, null, null, tmp_12, null, null, tmp_13, tmp_14, false, 0, 0, null, tmp4_style, $composer_15, 0, 0, 131066);
      sourceInformationMarkerEnd($composer_15);
      $composer_13.e31();
      sourceInformationMarkerStart($composer_10, -983217481, 'CC(remember):ShoppingScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!(!!(($dirty & 112) === 32 | ($dirty & 896) === 256) | ($dirty & 7168) === 2048) | ($dirty & 57344) === 16384);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_10.i31();
      var tmp_15;
      if (invalid || it_1 === Companion_getInstance().f30_1) {
        var value_1 = FilterContent$lambda_3(onSortOrderChange, onAgeFilterChange, onCustomFilterChange, onPriceFilterChange, tempMinPrice$delegate, tempMaxPrice$delegate);
        $composer_10.j31(value_1);
        tmp_15 = value_1;
      } else {
        tmp_15 = it_1;
      }
      var tmp0_group_0 = tmp_15;
      sourceInformationMarkerEnd($composer_10);
      TextButton(tmp0_group_0, null, false, null, null, null, null, null, null, ComposableSingletons$ShoppingScreenKt_getInstance().p14o_1, $composer_10, 805306368, 510);
      sourceInformationMarkerEnd($composer_10);
      $composer_8.e31();
      var tmp0_text_0 = stringResource(get_age_group_label(string_instance), $composer_5, 0);
      var tmp1_style_0 = MaterialTheme_instance.jog($composer_5, 6).mof_1;
      var tmp2_fontWeight_0 = Companion_getInstance_16().d7z_1;
      var tmp_16 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_17 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_18 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_19 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_20 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text_0, null, tmp_16, null, tmp_17, null, tmp2_fontWeight_0, null, tmp_18, null, null, tmp_19, tmp_20, false, 0, 0, null, tmp1_style_0, $composer_5, 1572864, 0, 131006);
      var tmp_21 = stringResource(get_kids_label(string_instance), $composer_5, 0);
      sourceInformationMarkerStart($composer_5, -1913628417, 'CC(remember):ShoppingScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(($dirty & 896) === 256 | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(state))));
      // Inline function 'kotlin.let' call
      var it_2 = $composer_5.i31();
      var tmp_22;
      if (invalid_0 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = FilterContent$lambda_4(onAgeFilterChange, state);
        $composer_5.j31(value_2);
        tmp_22 = value_2;
      } else {
        tmp_22 = it_2;
      }
      var tmp0_group_1 = tmp_22;
      sourceInformationMarkerEnd($composer_5);
      AgeFilterOptionRow(tmp_21, state.l14n_1, tmp0_group_1, $composer_5, 0);
      var tmp_23 = stringResource(get_youth_label(string_instance), $composer_5, 0);
      sourceInformationMarkerStart($composer_5, -1913622690, 'CC(remember):ShoppingScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(($dirty & 896) === 256 | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(state))));
      // Inline function 'kotlin.let' call
      var it_3 = $composer_5.i31();
      var tmp_24;
      if (invalid_1 || it_3 === Companion_getInstance().f30_1) {
        var value_3 = FilterContent$lambda_5(onAgeFilterChange, state);
        $composer_5.j31(value_3);
        tmp_24 = value_3;
      } else {
        tmp_24 = it_3;
      }
      var tmp1_group_0 = tmp_24;
      sourceInformationMarkerEnd($composer_5);
      AgeFilterOptionRow(tmp_23, state.m14n_1, tmp1_group_0, $composer_5, 0);
      var tmp_25 = stringResource(get_old_label(string_instance), $composer_5, 0);
      sourceInformationMarkerStart($composer_5, -1913617120, 'CC(remember):ShoppingScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_2 = !!(($dirty & 896) === 256 | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(state))));
      // Inline function 'kotlin.let' call
      var it_4 = $composer_5.i31();
      var tmp_26;
      if (invalid_2 || it_4 === Companion_getInstance().f30_1) {
        var value_4 = FilterContent$lambda_6(onAgeFilterChange, state);
        $composer_5.j31(value_4);
        tmp_26 = value_4;
      } else {
        tmp_26 = it_4;
      }
      var tmp2_group = tmp_26;
      sourceInformationMarkerEnd($composer_5);
      AgeFilterOptionRow(tmp_25, state.n14n_1, tmp2_group, $composer_5, 0);
      var tmp_27 = stringResource(get_standard_products_label(string_instance), $composer_5, 0);
      sourceInformationMarkerStart($composer_5, -1913609359, 'CC(remember):ShoppingScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_3 = !!(($dirty & 7168) === 2048 | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(state))));
      // Inline function 'kotlin.let' call
      var it_5 = $composer_5.i31();
      var tmp_28;
      if (invalid_3 || it_5 === Companion_getInstance().f30_1) {
        var value_5 = FilterContent$lambda_7(onCustomFilterChange, state);
        $composer_5.j31(value_5);
        tmp_28 = value_5;
      } else {
        tmp_28 = it_5;
      }
      var tmp3_group = tmp_28;
      sourceInformationMarkerEnd($composer_5);
      AgeFilterOptionRow(tmp_27, state.o14n_1, tmp3_group, $composer_5, 0);
      var tmp_29 = stringResource(get_custom_products_only(string_instance), $composer_5, 0);
      sourceInformationMarkerStart($composer_5, -1913599989, 'CC(remember):ShoppingScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_4 = !!(($dirty & 7168) === 2048 | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(state))));
      // Inline function 'kotlin.let' call
      var it_6 = $composer_5.i31();
      var tmp_30;
      if (invalid_4 || it_6 === Companion_getInstance().f30_1) {
        var value_6 = FilterContent$lambda_8(onCustomFilterChange, state);
        $composer_5.j31(value_6);
        tmp_30 = value_6;
      } else {
        tmp_30 = it_6;
      }
      var tmp4_group = tmp_30;
      sourceInformationMarkerEnd($composer_5);
      AgeFilterOptionRow(tmp_29, state.p14n_1, tmp4_group, $composer_5, 0);
      if (state.p14n_1) {
        $composer_5.m30(808112305);
        sourceInformation($composer_5, '471@23843L723');
        var tmp_31 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$52 = _Dp___init__impl__ms3zkb(32);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_5 = padding_1(tmp_31, tmp$ret$52);
        var verticalArrangement_1 = null;
        var horizontalAlignment_1 = null;
        var $composer_16 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_5 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_1 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_1 = Companion_getInstance_11().w8t_1;
        var measurePolicy_2 = columnMeasurePolicy(verticalArrangement_1, horizontalAlignment_1, $composer_16, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_6 = modifier_5;
        var $composer_17 = $composer_16;
        if (!((0 & 2) === 0))
          modifier_6 = Companion_instance;
        var compositeKeyHash_2 = get_currentCompositeKeyHashCode($composer_17, 0).hashCode();
        var localMap_2 = $composer_17.t31();
        var materialized_2 = materialize($composer_17, modifier_6);
        var tmp0_3 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_18 = $composer_17;
        var tmp_32 = $composer_18.g30();
        if (!isInterface(tmp_32, Applier)) {
          invalidApplier();
        }
        $composer_18.b31();
        if ($composer_18.h30()) {
          $composer_18.c31(tmp0_3);
        } else {
          $composer_18.d31();
        }
        var $this$ReusableComposeNode_2 = _Updater___init__impl__rbfxm8($composer_18);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, measurePolicy_2, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, localMap_2, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, compositeKeyHash_2, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_2, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_2, materialized_2, Companion_getInstance_12().qah_1);
        var $composer_19 = $composer_18;
        var $composer_20 = $composer_19;
        sourceInformationMarkerStart($composer_20, -909982866, 'C473@23960L47,475@24102L102,472@23912L310,478@24287L50,480@24435L99,477@24239L313:ShoppingScreen.kt#2a4il0');
        var tmp_33 = stringResource(get_with_templates_label(string_instance), $composer_20, 0);
        sourceInformationMarkerStart($composer_20, -999180069, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_5 = !!(($dirty & 7168) === 2048 | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(state))));
        // Inline function 'kotlin.let' call
        var it_7 = $composer_20.i31();
        var tmp_34;
        if (invalid_5 || it_7 === Companion_getInstance().f30_1) {
          var value_7 = FilterContent$lambda_9(onCustomFilterChange, state);
          $composer_20.j31(value_7);
          tmp_34 = value_7;
        } else {
          tmp_34 = it_7;
        }
        var tmp0_group_2 = tmp_34;
        sourceInformationMarkerEnd($composer_20);
        AgeFilterOptionRow(tmp_33, state.q14n_1, tmp0_group_2, $composer_20, 0);
        var tmp_35 = stringResource(get_without_templates_label(string_instance), $composer_20, 0);
        sourceInformationMarkerStart($composer_20, -999169416, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_6 = !!(($dirty & 7168) === 2048 | (($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(state))));
        // Inline function 'kotlin.let' call
        var it_8 = $composer_20.i31();
        var tmp_36;
        if (invalid_6 || it_8 === Companion_getInstance().f30_1) {
          var value_8 = FilterContent$lambda_10(onCustomFilterChange, state);
          $composer_20.j31(value_8);
          tmp_36 = value_8;
        } else {
          tmp_36 = it_8;
        }
        var tmp1_group_1 = tmp_36;
        sourceInformationMarkerEnd($composer_20);
        AgeFilterOptionRow(tmp_35, state.r14n_1, tmp1_group_1, $composer_20, 0);
        sourceInformationMarkerEnd($composer_20);
        $composer_18.e31();
        $composer_5.n30();
      } else {
        $composer_5.m30(808830172);
        $composer_5.n30();
      }
      var tmp_37 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$67 = _Dp___init__impl__ms3zkb(8);
      var tmp_38 = padding_2(tmp_37, VOID, tmp$ret$67);
      var tmp_39 = _Dp___init__impl__ms3zkb(0.0);
      HorizontalDivider(tmp_38, tmp_39, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 6, 6);
      var tmp3_text_0 = stringResource(get_sort_by_label(string_instance), $composer_5, 0);
      var tmp4_style_0 = MaterialTheme_instance.jog($composer_5, 6).mof_1;
      var tmp5_fontWeight = Companion_getInstance_16().d7z_1;
      var tmp_40 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_41 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_42 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_43 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_44 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp3_text_0, null, tmp_40, null, tmp_41, null, tmp5_fontWeight, null, tmp_42, null, null, tmp_43, tmp_44, false, 0, 0, null, tmp4_style_0, $composer_5, 1572864, 0, 131006);
      $composer_5.m30(-1913562338);
      sourceInformation($composer_5, '*498@25573L28,488@24864L751');
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = get_entries_2().t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var tmp_45;
        switch (element.a1_1) {
          case 4:
            $composer_5.m30(1146358860);
            sourceInformation($composer_5, '490@24964L38');
            var tmp0_group_3 = stringResource(get_sort_newest(string_instance), $composer_5, 0);
            $composer_5.n30();
            tmp_45 = tmp0_group_3;
            break;
          case 0:
            $composer_5.m30(1146361876);
            sourceInformation($composer_5, '491@25058L46');
            var tmp1_group_2 = stringResource(get_sort_price_low_high(string_instance), $composer_5, 0);
            $composer_5.n30();
            tmp_45 = tmp1_group_2;
            break;
          case 1:
            $composer_5.m30(1146365140);
            sourceInformation($composer_5, '492@25160L46');
            var tmp2_group_0 = stringResource(get_sort_price_high_low(string_instance), $composer_5, 0);
            $composer_5.n30();
            tmp_45 = tmp2_group_0;
            break;
          case 2:
            $composer_5.m30(1146368206);
            sourceInformation($composer_5, '493@25256L40');
            var tmp3_group_0 = stringResource(get_sort_name_asc(string_instance), $composer_5, 0);
            $composer_5.n30();
            tmp_45 = tmp3_group_0;
            break;
          case 3:
            $composer_5.m30(1146371119);
            sourceInformation($composer_5, '494@25347L41');
            var tmp4_group_0 = stringResource(get_sort_name_desc(string_instance), $composer_5, 0);
            $composer_5.n30();
            tmp_45 = tmp4_group_0;
            break;
          case 5:
            $composer_5.m30(1146373964);
            sourceInformation($composer_5, '495@25436L38');
            var tmp5_group = stringResource(get_sort_oldest(string_instance), $composer_5, 0);
            $composer_5.n30();
            tmp_45 = tmp5_group;
            break;
          default:
            $composer_5.m30(1146357459);
            $composer_5.n30();
            noWhenBranchMatchedException();
            break;
        }
        var tmp_46 = tmp_45;
        var tmp_47 = state.d14n_1.equals(element);
        sourceInformationMarkerStart($composer_5, 1146378338, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_7 = !!(($dirty & 112) === 32 | $composer_0.m31(element.a1_1));
        // Inline function 'kotlin.let' call
        var it_9 = $composer_5.i31();
        var tmp_48;
        if (invalid_7 || it_9 === Companion_getInstance().f30_1) {
          var value_9 = FilterContent$lambda_11(onSortOrderChange, element);
          $composer_5.j31(value_9);
          tmp_48 = value_9;
        } else {
          tmp_48 = it_9;
        }
        var tmp6_group = tmp_48;
        sourceInformationMarkerEnd($composer_5);
        SortOptionRow(tmp_46, tmp_47, tmp6_group, $composer_5, 0);
      }
      $composer_5.n30();
      var tmp_49 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$74 = _Dp___init__impl__ms3zkb(8);
      var tmp_50 = padding_2(tmp_49, VOID, tmp$ret$74);
      var tmp_51 = _Dp___init__impl__ms3zkb(0.0);
      HorizontalDivider(tmp_50, tmp_51, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_5, 6, 6);
      var tmp6_text = stringResource(get_price_range_label(string_instance), $composer_5, 0);
      var tmp7_style = MaterialTheme_instance.jog($composer_5, 6).mof_1;
      var tmp8_fontWeight = Companion_getInstance_16().d7z_1;
      var tmp_52 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_53 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_54 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_55 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_56 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp6_text, null, tmp_52, null, tmp_53, null, tmp8_fontWeight, null, tmp_54, null, null, tmp_55, tmp_56, false, 0, 0, null, tmp7_style, $composer_5, 1572864, 0, 131006);
      var tmp_57 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$75 = _Dp___init__impl__ms3zkb(16);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_7 = null;
      var horizontalArrangement_0 = tmp_57.mdq(tmp$ret$75);
      var verticalAlignment_0 = null;
      var $composer_21 = $composer_5;
      if (!((5 & 1) === 0))
        modifier_7 = Companion_instance;
      if (!((5 & 2) === 0))
        horizontalArrangement_0 = Arrangement_getInstance().qdp_1;
      if (!((5 & 4) === 0))
        verticalAlignment_0 = Companion_getInstance_11().t8t_1;
      var measurePolicy_3 = rowMeasurePolicy(horizontalArrangement_0, verticalAlignment_0, $composer_21, 14 & 48 >> 3 | 112 & 48 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_8 = modifier_7;
      var $composer_22 = $composer_21;
      if (!((0 & 2) === 0))
        modifier_8 = Companion_instance;
      var compositeKeyHash_3 = get_currentCompositeKeyHashCode($composer_22, 0).hashCode();
      var localMap_3 = $composer_22.t31();
      var materialized_3 = materialize($composer_22, modifier_8);
      var tmp0_4 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_23 = $composer_22;
      var tmp_58 = $composer_23.g30();
      if (!isInterface(tmp_58, Applier)) {
        invalidApplier();
      }
      $composer_23.b31();
      if ($composer_23.h30()) {
        $composer_23.c31(tmp0_4);
      } else {
        $composer_23.d31();
      }
      var $this$ReusableComposeNode_3 = _Updater___init__impl__rbfxm8($composer_23);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_3, measurePolicy_3, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_3, localMap_3, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_3, compositeKeyHash_3, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_3, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_3, materialized_3, Companion_getInstance_12().qah_1);
      var $composer_24 = $composer_23;
      var $composer_25 = $composer_24;
      sourceInformationMarkerStart($composer_25, -974378589, 'C505@25980L170,505@25924L340,506@26333L170,506@26277L340:ShoppingScreen.kt#2a4il0');
      var tmp0_value = FilterContent$lambda(tempMinPrice$delegate);
      var tmp1_modifier = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
      sourceInformationMarkerStart($composer_25, -585619627, 'CC(remember):ShoppingScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_8 = ($dirty & 57344) === 16384;
      // Inline function 'kotlin.let' call
      var it_10 = $composer_25.i31();
      var tmp_59;
      if (invalid_8 || it_10 === Companion_getInstance().f30_1) {
        var value_10 = FilterContent$lambda_12(onPriceFilterChange, tempMinPrice$delegate, tempMaxPrice$delegate);
        $composer_25.j31(value_10);
        tmp_59 = value_10;
      } else {
        tmp_59 = it_10;
      }
      var tmp0_group_4 = tmp_59;
      sourceInformationMarkerEnd($composer_25);
      var tmp_60 = ComposableSingletons$ShoppingScreenKt_getInstance().q14o_1;
      OutlinedTextField(tmp0_value, tmp0_group_4, tmp1_modifier, false, false, null, tmp_60, null, null, null, null, null, null, false, null, null, null, true, 0, 0, null, null, null, $composer_25, 1572864, 12582912, 0, 8257464);
      var tmp2_value = FilterContent$lambda_1(tempMaxPrice$delegate);
      var tmp3_modifier = RowScopeInstance_instance.bdy(Companion_instance, 1.0);
      sourceInformationMarkerStart($composer_25, -585608331, 'CC(remember):ShoppingScreen.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_9 = ($dirty & 57344) === 16384;
      // Inline function 'kotlin.let' call
      var it_11 = $composer_25.i31();
      var tmp_61;
      if (invalid_9 || it_11 === Companion_getInstance().f30_1) {
        var value_11 = FilterContent$lambda_13(onPriceFilterChange, tempMaxPrice$delegate, tempMinPrice$delegate);
        $composer_25.j31(value_11);
        tmp_61 = value_11;
      } else {
        tmp_61 = it_11;
      }
      var tmp1_group_3 = tmp_61;
      sourceInformationMarkerEnd($composer_25);
      var tmp_62 = ComposableSingletons$ShoppingScreenKt_getInstance().r14o_1;
      OutlinedTextField(tmp2_value, tmp1_group_3, tmp3_modifier, false, false, null, tmp_62, null, null, null, null, null, null, false, null, null, null, true, 0, 0, null, null, null, $composer_25, 1572864, 12582912, 0, 8257464);
      sourceInformationMarkerEnd($composer_25);
      $composer_23.e31();
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver = $composer_0.t30();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.p3c(FilterContent$lambda_14(state, onSortOrderChange, onAgeFilterChange, onCustomFilterChange, onPriceFilterChange, $changed));
    }
  }
  function ProductsGrid(state, selectedTab, onRefresh, onToggleFavorite, onNavigateToProductDetails, onBannerClick, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1643394171);
    sourceInformation($composer_0, 'C(ProductsGrid)P(5,4,2,3,1)368@18288L2596,368@18234L2650:ShoppingScreen.kt#2a4il0');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.m31(selectedTab.a1_1) ? 32 : 16);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onToggleFavorite) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onNavigateToProductDetails) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onBannerClick) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74771) === 74770), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1643394171, $dirty, -1, 'client.fstech.hadaya.presentation.shopping.ProductsGrid (ShoppingScreen.kt:367)');
      }
      var tmp = fillMaxSize(Companion_instance);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(1874881243, true, ProductsGrid$lambda(state, selectedTab, onBannerClick, onToggleFavorite, onNavigateToProductDetails), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref_12(dispatchReceiver);
        $composer_1.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp$ret$0 = tmp_0;
      BoxWithConstraints(tmp, null, false, tmp$ret$0, $composer_0, 3078, 6);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ProductsGrid$lambda_0(state, selectedTab, onRefresh, onToggleFavorite, onNavigateToProductDetails, onBannerClick, $changed));
    }
  }
  function AgeFilterOptionRow(label, checked, onCheckedChange, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-151803068);
    sourceInformation($composer_0, 'C(AgeFilterOptionRow)P(1)523@27602L29,523@27553L348:ShoppingScreen.kt#2a4il0');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(label) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(checked) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onCheckedChange) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-151803068, $dirty, -1, 'client.fstech.hadaya.presentation.shopping.AgeFilterOptionRow (ShoppingScreen.kt:522)');
      }
      var tmp = fillMaxWidth(Companion_instance);
      sourceInformationMarkerStart($composer_0, 146144449, 'CC(remember):ShoppingScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(($dirty & 896) === 256 | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = AgeFilterOptionRow$lambda(onCheckedChange, checked);
        tmp0.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp0_group = tmp_0;
      sourceInformationMarkerEnd($composer_0);
      var tmp_1 = clickable(tmp, VOID, VOID, VOID, VOID, tmp0_group);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$4 = _Dp___init__impl__ms3zkb(8);
      var tmp0_modifier = padding_2(tmp_1, VOID, tmp$ret$4);
      var tmp1_verticalAlignment = Companion_getInstance_11().u8t_1;
      var tmp_2 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$5 = _Dp___init__impl__ms3zkb(12);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = tmp0_modifier;
      var horizontalArrangement = tmp_2.mdq(tmp$ret$5);
      var verticalAlignment = tmp1_verticalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier = Companion_instance;
      if (!((0 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_3 = $composer_3.g30();
      if (!isInterface(tmp_3, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0_0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 1418476197, 'C524@27769L62,524@27874L10,524@27833L62:ShoppingScreen.kt#2a4il0');
      Checkbox(checked, onCheckedChange, null, false, null, null, $composer_5, 14 & $dirty >> 3 | 112 & $dirty >> 3, 60);
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_7 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_8 = _TextOverflow___init__impl__obguoe(0);
      Text(label, null, tmp_4, null, tmp_5, null, null, null, tmp_6, null, null, tmp_7, tmp_8, false, 0, 0, null, MaterialTheme_instance.jog($composer_5, 6).oof_1, $composer_5, 14 & $dirty, 0, 131070);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(AgeFilterOptionRow$lambda_0(label, checked, onCheckedChange, $changed));
    }
  }
  function SortOptionRow(label, selected, onClick, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1489995746);
    sourceInformation($composer_0, 'C(SortOptionRow)P(!1,2)530@27996L326:ShoppingScreen.kt#2a4il0');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(label) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(selected) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1489995746, $dirty, -1, 'client.fstech.hadaya.presentation.shopping.SortOptionRow (ShoppingScreen.kt:529)');
      }
      var tmp = clickable(fillMaxWidth(Companion_instance), VOID, VOID, VOID, VOID, onClick);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(8);
      var tmp0_modifier = padding_2(tmp, VOID, tmp$ret$0);
      var tmp1_verticalAlignment = Companion_getInstance_11().u8t_1;
      var tmp_0 = Arrangement_getInstance();
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$1 = _Dp___init__impl__ms3zkb(12);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier = tmp0_modifier;
      var horizontalArrangement = tmp_0.mdq(tmp$ret$1);
      var verticalAlignment = tmp1_verticalAlignment;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier = Companion_instance;
      if (!((0 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((0 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 432 >> 3 | 112 & 432 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_0);
      var tmp0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_1 = $composer_3.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, -925633366, 'C531@28201L51,531@28295L10,531@28254L62:ShoppingScreen.kt#2a4il0');
      RadioButton(selected, onClick, null, false, null, null, $composer_5, 14 & $dirty >> 3 | 112 & $dirty >> 3, 60);
      var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_6 = _TextOverflow___init__impl__obguoe(0);
      Text(label, null, tmp_2, null, tmp_3, null, null, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, MaterialTheme_instance.jog($composer_5, 6).oof_1, $composer_5, 14 & $dirty, 0, 131070);
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(SortOptionRow$lambda(label, selected, onClick, $changed));
    }
  }
  function BannerCarousel(state, banners, onBannerClick, modifier, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1368623683);
    sourceInformation($composer_0, 'C(BannerCarousel)P(3!1,2)538@28554L16,538@28523L48,539@28576L1047:ShoppingScreen.kt#2a4il0');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(state) : $composer_0.q31(state)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(banners) : $composer_0.q31(banners)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onBannerClick) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (isTraceInProgress()) {
        traceEventStart(1368623683, $dirty, -1, 'client.fstech.hadaya.presentation.shopping.BannerCarousel (ShoppingScreen.kt:536)');
      }
      if (banners.r()) {
        if (isTraceInProgress()) {
          traceEventEnd();
        }
        var tmp1_safe_receiver = $composer_0.t30();
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.p3c(BannerCarousel$lambda(state, banners, onBannerClick, modifier_0, $changed, $default));
        }
        return Unit_instance;
      }
      sourceInformationMarkerStart($composer_0, 987373715, 'CC(remember):ShoppingScreen.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 112) === 32 || (!(($dirty & 64) === 0) && $composer_0.q31(banners));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = BannerCarousel$lambda_0(banners);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var pagerState = rememberPagerState(0, 0.0, tmp0_group, $composer_0, 0, 3);
      // Inline function 'androidx.compose.foundation.layout.Column' call
      var modifier_1 = fillMaxWidth(modifier_0._v);
      var verticalArrangement = null;
      var horizontalAlignment = Companion_getInstance_11().x8t_1;
      var $composer_1 = $composer_0;
      if (!((2 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((2 & 2) === 0))
        verticalArrangement = Arrangement_getInstance().sdp_1;
      if (!((2 & 4) === 0))
        horizontalAlignment = Companion_getInstance_11().w8t_1;
      var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 384 >> 3 | 112 & 384 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_2 = $composer_1;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
      var localMap = $composer_2.t31();
      var materialized = materialize($composer_2, modifier_2);
      var tmp0_0 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_3 = $composer_2;
      var tmp_0 = $composer_3.g30();
      if (!isInterface(tmp_0, Applier)) {
        invalidApplier();
      }
      $composer_3.b31();
      if ($composer_3.h30()) {
        $composer_3.c31(tmp0_0);
      } else {
        $composer_3.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_4 = $composer_3;
      var $composer_5 = $composer_4;
      sourceInformationMarkerStart($composer_5, 780116290, 'C540@28837L392,540@28681L548,545@29238L40,546@29287L330:ShoppingScreen.kt#2a4il0');
      var tmp_1 = aspectRatio(fillMaxWidth(Companion_instance), equals(modifier_0._v, Companion_instance) ? 2.5 : 4.0);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$10 = _Dp___init__impl__ms3zkb(20);
      var tmp_2 = clip(tmp_1, RoundedCornerShape(tmp$ret$10));
      var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-2045109510, true, BannerCarousel$lambda_1(banners, state, onBannerClick), $composer_5, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_6 = $composer_5;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_6.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_6.i31();
      var tmp_4;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = ComposableLambda$invoke$ref_7(dispatchReceiver);
        $composer_6.j31(value_0);
        tmp_4 = value_0;
      } else {
        tmp_4 = it_0;
      }
      var tmp$ret$11 = tmp_4;
      HorizontalPager(pagerState, tmp_2, null, null, 0, tmp_3, null, null, false, false, null, null, null, null, tmp$ret$11, $composer_5, 0, 24576, 16380);
      var tmp_5 = Companion_instance;
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$18 = _Dp___init__impl__ms3zkb(8);
      Spacer(height(tmp_5, tmp$ret$18), $composer_5, 6);
      // Inline function 'androidx.compose.foundation.layout.Row' call
      var modifier_3 = null;
      var horizontalArrangement = Arrangement_getInstance().udp_1;
      var verticalAlignment = null;
      var $composer_7 = $composer_5;
      if (!((5 & 1) === 0))
        modifier_3 = Companion_instance;
      if (!((5 & 2) === 0))
        horizontalArrangement = Arrangement_getInstance().qdp_1;
      if (!((5 & 4) === 0))
        verticalAlignment = Companion_getInstance_11().t8t_1;
      var measurePolicy_0 = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_7, 14 & 48 >> 3 | 112 & 48 >> 3);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_4 = modifier_3;
      var $composer_8 = $composer_7;
      if (!((0 & 2) === 0))
        modifier_4 = Companion_instance;
      var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_8, 0).hashCode();
      var localMap_0 = $composer_8.t31();
      var materialized_0 = materialize($composer_8, modifier_4);
      var tmp0_1 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_9 = $composer_8;
      var tmp_6 = $composer_9.g30();
      if (!isInterface(tmp_6, Applier)) {
        invalidApplier();
      }
      $composer_9.b31();
      if ($composer_9.h30()) {
        $composer_9.c31(tmp0_1);
      } else {
        $composer_9.d31();
      }
      var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_9);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
      var $composer_10 = $composer_9;
      var $composer_11 = $composer_10;
      sourceInformationMarkerStart($composer_11, -1690310992, 'C:ShoppingScreen.kt#2a4il0');
      $composer_11.m30(84021171);
      sourceInformation($composer_11, '*546@29528L85');
      // Inline function 'kotlin.repeat' call
      var times = banners.n1();
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp_7;
          if (pagerState.zj9() === index) {
            $composer_11.m30(-653561900);
            sourceInformation($composer_11, '546@29440L11');
            var tmp0_group_0 = MaterialTheme_instance.unz($composer_11, 6).xnz_1;
            $composer_11.n30();
            tmp_7 = tmp0_group_0;
          } else {
            $composer_11.m30(-653560097);
            sourceInformation($composer_11, '546@29479L11');
            var tmp1_group = Color__copy$default_impl_ectz3s(MaterialTheme_instance.unz($composer_11, 6).po0_1, 0.3);
            $composer_11.n30();
            tmp_7 = tmp1_group;
          }
          var color = tmp_7;
          var tmp_8 = Companion_instance;
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$27 = _Dp___init__impl__ms3zkb(2);
          var tmp_9 = background(clip(padding_0(tmp_8, tmp$ret$27), get_CircleShape()), color);
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$28 = _Dp___init__impl__ms3zkb(6);
          Box(size(tmp_9, tmp$ret$28), $composer_11, 0);
        }
         while (inductionVariable < times);
      $composer_11.n30();
      sourceInformationMarkerEnd($composer_11);
      $composer_9.e31();
      sourceInformationMarkerEnd($composer_5);
      $composer_3.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver = $composer_0.t30();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.p3c(BannerCarousel$lambda_2(state, banners, onBannerClick, modifier_0, $changed, $default));
    }
  }
  function ProductItem(lang, product, isFavorite, onToggleFavorite, onClick, modifier, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1695624707);
    sourceInformation($composer_0, 'C(ProductItem)P(1,5!1,4,3)553@30080L11,553@30038L62,553@30102L1182,553@29926L1358:ShoppingScreen.kt#2a4il0');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(lang) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(product) : $composer_0.q31(product)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.l31(isFavorite) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onToggleFavorite) ? 2048 : 1024);
    if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onClick) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74899) === 74898), $dirty & 1)) {
      if (!(($default & 32) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (isTraceInProgress()) {
        traceEventStart(1695624707, $dirty, -1, 'client.fstech.hadaya.presentation.shopping.ProductItem (ShoppingScreen.kt:551)');
      }
      var tmp;
      if (lang === 'en') {
        var tmp0_elvis_lhs = product.ozt_1;
        tmp = tmp0_elvis_lhs == null ? product.pzt_1 : tmp0_elvis_lhs;
      } else {
        var tmp1_elvis_lhs = product.pzt_1;
        tmp = tmp1_elvis_lhs == null ? product.ozt_1 : tmp1_elvis_lhs;
      }
      var tmp2_elvis_lhs = tmp;
      var name = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
      var tmp_0 = clickable(modifier_0._v, VOID, VOID, VOID, VOID, onClick);
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
      var tmp_1 = RoundedCornerShape(tmp$ret$0);
      var tmp_2 = CardDefaults_instance;
      var tmp_3 = MaterialTheme_instance.unz($composer_0, 6).mo0_1;
      var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_5 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_6 = tmp_2.loh(tmp_3, tmp_4, tmp_5, _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0))), $composer_0, 24576, 14);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1293345327, true, ProductItem$lambda(product, name, onToggleFavorite, lang, isFavorite), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_7;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref_6(dispatchReceiver);
        $composer_1.j31(value);
        tmp_7 = value;
      } else {
        tmp_7 = it;
      }
      var tmp$ret$1 = tmp_7;
      Card(tmp_0, tmp_1, tmp_6, null, null, tmp$ret$1, $composer_0, 196608, 24);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ProductItem$lambda_0(lang, product, isFavorite, onToggleFavorite, onClick, modifier_0, $changed, $default));
    }
  }
  function ShoppingRoot$lambda($state$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('state', KProperty0, false);
    return $state$delegate.u1();
  }
  function ShoppingRoot$slambda$slambda($snackbarHostState, resultContinuation) {
    this.a14p_1 = $snackbarHostState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingRoot$slambda$slambda).d14p = function (sideEffect, $completion) {
    var tmp = this.e14p(sideEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingRoot$slambda$slambda).ja = function (p1, $completion) {
    return this.d14p((!(p1 == null) ? isInterface(p1, ShoppingSideEffect) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingRoot$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.b14p_1 instanceof ShowError_6) {
              this.n9_1 = 1;
              suspendResult = this.a14p_1.dqm(this.b14p_1.g14o_1, VOID, VOID, VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_0 = this;
              noWhenBranchMatchedException();
            }

            break;
          case 1:
            this.c14p_1 = suspendResult;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ShoppingRoot$slambda$slambda).e14p = function (sideEffect, completion) {
    var i = new ShoppingRoot$slambda$slambda(this.a14p_1, completion);
    i.b14p_1 = sideEffect;
    return i;
  };
  function ShoppingRoot$slambda$slambda_0($snackbarHostState, resultContinuation) {
    var i = new ShoppingRoot$slambda$slambda($snackbarHostState, resultContinuation);
    return constructCallableReference(function (sideEffect, $completion) {
      return i.d14p(sideEffect, $completion);
    }, 1);
  }
  function ShoppingRoot$slambda($viewModel, $snackbarHostState, resultContinuation) {
    this.n14p_1 = $viewModel;
    this.o14p_1 = $snackbarHostState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingRoot$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingRoot$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingRoot$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.n14p_1.s10h().t10h();
            var action = ShoppingRoot$slambda$slambda_0(this.o14p_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ShoppingRoot$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new ShoppingRoot$slambda(this.n14p_1, this.o14p_1, completion);
    i.p14p_1 = $this$LaunchedEffect;
    return i;
  };
  function ShoppingRoot$slambda_0($viewModel, $snackbarHostState, resultContinuation) {
    var i = new ShoppingRoot$slambda($viewModel, $snackbarHostState, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function ShoppingRoot$lambda_0($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new SearchChanged(it));
      return Unit_instance;
    };
  }
  function ShoppingRoot$lambda_1($viewModel) {
    return function () {
      $viewModel.s10h().j10i(RefreshData_instance);
      return Unit_instance;
    };
  }
  function ShoppingRoot$lambda_2($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new ToggleFavorite_4(it));
      return Unit_instance;
    };
  }
  function ShoppingRoot$lambda_3($viewModel) {
    return function () {
      $viewModel.s10h().j10i(ToggleLanguage_instance);
      return Unit_instance;
    };
  }
  function ShoppingRoot$lambda_4($viewModel) {
    return function (it) {
      $viewModel.s10h().j10i(new SortOrderChanged(it));
      return Unit_instance;
    };
  }
  function ShoppingRoot$lambda_5($viewModel) {
    return function (kids, youth, old) {
      $viewModel.s10h().j10i(new AgeFilterChanged(kids, youth, old));
      return Unit_instance;
    };
  }
  function ShoppingRoot$lambda_6($viewModel) {
    return function (standard, onlyCustom, withTemplates, withoutTemplates) {
      $viewModel.s10h().j10i(new CustomFilterChanged(standard, onlyCustom, withTemplates, withoutTemplates));
      return Unit_instance;
    };
  }
  function ShoppingRoot$lambda_7($viewModel) {
    return function (min, max) {
      $viewModel.s10h().j10i(new PriceFilterChanged(min, max));
      return Unit_instance;
    };
  }
  function ShoppingRoot$lambda_8($uriHandler, $onNavigateToProductDetails, $state$delegate) {
    return function (banner) {
      var tmp;
      // Inline function 'kotlin.text.isNullOrBlank' call
      var this_0 = banner.jzy_1;
      if (!(this_0 == null || isBlank(this_0))) {
        $uriHandler.qdd(banner.jzy_1);
        tmp = Unit_instance;
      } else {
        if (banner.kzy_1.equals(ProductKind_MUG_getInstance())) {
          // Inline function 'kotlin.collections.find' call
          var tmp0 = ShoppingRoot$lambda($state$delegate).x14m_1;
          var tmp$ret$2;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              if (equals(element.nzt_1, banner.lzy_1)) {
                tmp$ret$2 = element;
                break $l$block;
              }
            }
            tmp$ret$2 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$2;
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            var tmp1_elvis_lhs = banner.lzy_1;
            tmp_0 = new Product(tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, ProductKind_MUG_getInstance());
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var product = tmp_0;
          tmp = $onNavigateToProductDetails(product);
        } else {
          if (!(banner.lzy_1 == null)) {
            // Inline function 'kotlin.collections.find' call
            var tmp0_0 = ShoppingRoot$lambda($state$delegate).x14m_1;
            var tmp$ret$5;
            $l$block_0: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s_0 = tmp0_0.t();
              while (_iterator__ex2g4s_0.u()) {
                var element_0 = _iterator__ex2g4s_0.v();
                if (equals(element_0.nzt_1, banner.lzy_1)) {
                  tmp$ret$5 = element_0;
                  break $l$block_0;
                }
              }
              tmp$ret$5 = null;
            }
            var tmp2_elvis_lhs = tmp$ret$5;
            var product_0 = tmp2_elvis_lhs == null ? new Product(banner.lzy_1) : tmp2_elvis_lhs;
            tmp = $onNavigateToProductDetails(product_0);
          }
        }
      }
      return Unit_instance;
    };
  }
  function ShoppingRoot$lambda_9($onNavigateToProfile, $onNavigateToProductDetails, $onNavigateToCart, $onNavigateToCustomMug, $$changed) {
    return function ($composer, $force) {
      ShoppingRoot($onNavigateToProfile, $onNavigateToProductDetails, $onNavigateToCart, $onNavigateToCustomMug, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda($selectedTab$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('selectedTab', KMutableProperty0, true);
    return $selectedTab$delegate.u1();
  }
  function ShoppingContent$lambda_0($selectedTab$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('selectedTab', KMutableProperty0, true);
    $selectedTab$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ShoppingContent$lambda_1($showFilterSheet$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('showFilterSheet', KMutableProperty0, true);
    return $showFilterSheet$delegate.u1();
  }
  function ShoppingContent$lambda_2($showFilterSheet$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('showFilterSheet', KMutableProperty0, true);
    $showFilterSheet$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function ShoppingContent$lambda_3($gradientStartColor$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('gradientStartColor', KProperty0, false);
    return $gradientStartColor$delegate.u1().c6d_1;
  }
  function ShoppingContent$lambda_4($gradientEndColor$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('gradientEndColor', KProperty0, false);
    return $gradientEndColor$delegate.u1().c6d_1;
  }
  function ShoppingContent$lambda$lambda($uriHandler) {
    return function () {
      $uriHandler.qdd('https://abdallabadreldin.github.io/hadaya_special_links/');
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda_5($uriHandler) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C240@10900L150,238@10753L679:ShoppingScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1952990625, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ShoppingContent.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ShoppingScreen.kt:238)');
        }
        var tmp0_verticalAlignment = Companion_getInstance_11().u8t_1;
        var tmp_0 = Companion_instance;
        sourceInformationMarkerStart($composer_0, 76723541, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($uriHandler);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ShoppingContent$lambda$lambda($uriHandler);
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp0_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = clickable(tmp_0, VOID, VOID, VOID, VOID, tmp0_group);
        var horizontalArrangement = null;
        var verticalAlignment = tmp0_verticalAlignment;
        var $composer_1 = $composer_0;
        if (!((2 & 1) === 0))
          modifier = Companion_instance;
        if (!((2 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((2 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_2 = $composer_3.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 256696873, 'C244@11131L34,244@11115L111,245@11259L39,246@11336L35,246@11331L71:ShoppingScreen.kt#2a4il0');
        var tmp_3 = painterResource(get_logo(drawable_instance), $composer_5, 0);
        var tmp_4 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$10 = _Dp___init__impl__ms3zkb(32);
        var tmp_5 = size(tmp_4, tmp$ret$10);
        Image(tmp_3, null, tmp_5, null, null, 0.0, null, $composer_5, 432 | androidx_compose_ui_graphics_painter_Painter$stableprop_getter(), 120);
        var tmp_6 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$11 = _Dp___init__impl__ms3zkb(8);
        Spacer(width(tmp_6, tmp$ret$11), $composer_5, 6);
        var tmp_7 = stringResource(get_app_name(string_instance), $composer_5, 0);
        var tmp_8 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_10 = Companion_getInstance_16().e7z_1;
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_12 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_13 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_7, null, tmp_8, null, tmp_9, null, tmp_10, null, tmp_11, null, null, tmp_12, tmp_13, false, 0, 0, null, null, $composer_5, 1572864, 0, 262078);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_14;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_14 = Unit_instance;
        }
        tmp = tmp_14;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda$lambda_0($state) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C251@11597L504:ShoppingScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1067854862, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ShoppingContent.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ShoppingScreen.kt:251)');
        }
        // Inline function 'androidx.compose.foundation.layout.Row' call
        var modifier = null;
        var horizontalArrangement = null;
        var verticalAlignment = Companion_getInstance_11().u8t_1;
        var $composer_1 = $composer_0;
        if (!((3 & 1) === 0))
          modifier = Companion_instance;
        if (!((3 & 2) === 0))
          horizontalArrangement = Arrangement_getInstance().qdp_1;
        if (!((3 & 4) === 0))
          verticalAlignment = Companion_getInstance_11().t8t_1;
        var measurePolicy = rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer_1, 14 & 384 >> 3 | 112 & 384 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -865451983, 'C252@11743L11,252@11687L109,253@11971L10,253@12047L11,253@11833L234:ShoppingScreen.kt#2a4il0');
        var tmp0_imageVector = get_Language(Icons_getInstance().dxv_1);
        var tmp1_tint = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
        var tmp_1 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$6 = _Dp___init__impl__ms3zkb(20);
        var tmp2_modifier = size(tmp_1, tmp$ret$6);
        Icon(tmp0_imageVector, null, tmp2_modifier, tmp1_tint, $composer_5, 432, 0);
        var tmp_2;
        if ($state.h14n_1 === 'en') {
          $composer_5.m30(-27912200);
          sourceInformation($composer_5, '253@11873L34');
          var tmp0_group = stringResource(get_lang_ar(string_instance), $composer_5, 0);
          $composer_5.n30();
          tmp_2 = tmp0_group;
        } else {
          $composer_5.m30(-27910920);
          sourceInformation($composer_5, '253@11913L34');
          var tmp1_group = stringResource(get_lang_en(string_instance), $composer_5, 0);
          $composer_5.n30();
          tmp_2 = tmp1_group;
        }
        var tmp3_text = tmp_2;
        var tmp4_style = MaterialTheme_instance.jog($composer_5, 6).sof_1;
        var tmp5_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp6_color = MaterialTheme_instance.unz($composer_5, 6).xnz_1;
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp3_text, null, tmp6_color, null, tmp_3, null, tmp5_fontWeight, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, tmp4_style, $composer_5, 1572864, 0, 131002);
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_7;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_7 = Unit_instance;
        }
        tmp = tmp_7;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda$lambda$lambda$lambda($state) {
    return function ($this$Badge, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C257@12291L37:ShoppingScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1334816199, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ShoppingContent.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ShoppingScreen.kt:257)');
        }
        var tmp_0 = $state.j14n_1.toString();
        var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp_0, null, tmp_1, null, tmp_2, null, null, null, tmp_3, null, null, tmp_4, tmp_5, false, 0, 0, null, null, $composer_0, 0, 0, 262142);
        var tmp_6;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_6 = Unit_instance;
        }
        tmp = tmp_6;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda$lambda$lambda($state) {
    return function ($this$BadgedBox, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:ShoppingScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1883436273, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ShoppingContent.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ShoppingScreen.kt:257)');
        }
        if ($state.j14n_1 > 0) {
          $composer_0.m30(1801027808);
          sourceInformation($composer_0, '257@12289L41,257@12283L47');
          var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
          // Inline function 'kotlin.run' call
          var dispatchReceiver = rememberComposableLambda(-1334816199, true, ShoppingContent$lambda$lambda$lambda$lambda($state), $composer_0, 54);
          // Inline function 'androidx.compose.runtime.remember' call
          var $composer_1 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = $composer_1.k31(dispatchReceiver);
          // Inline function 'kotlin.let' call
          var it = $composer_1.i31();
          var tmp_2;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
            $composer_1.j31(value);
            tmp_2 = value;
          } else {
            tmp_2 = it;
          }
          var tmp$ret$0 = tmp_2;
          Badge(null, tmp_0, tmp_1, tmp$ret$0, $composer_0, 3072, 7);
          $composer_0.n30();
        } else {
          $composer_0.m30(-2667631);
          $composer_0.n30();
        }
        var tmp_3;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda$lambda_1($state) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C257@12251L81,257@12233L211:ShoppingScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(970213481, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ShoppingContent.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ShoppingScreen.kt:257)');
        }
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(1883436273, true, ShoppingContent$lambda$lambda$lambda($state), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref_14(dispatchReceiver);
          $composer_1.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp_1 = tmp_0;
        BadgedBox(tmp_1, null, ComposableSingletons$ShoppingScreenKt_getInstance().h14o_1, $composer_0, 390, 2);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda_6($onToggleLanguage, $onNavigateToCart, $onNavigateToProfile, $state) {
    return function ($this$TopAppBar, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C250@11563L568,250@11524L607,256@12199L275,256@12160L314,261@12503L138:ShoppingScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-167913132, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ShoppingContent.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ShoppingScreen.kt:250)');
        }
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1067854862, true, ShoppingContent$lambda$lambda_0($state), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp$ret$0 = tmp_0;
        IconButton($onToggleLanguage, null, false, null, null, null, tmp$ret$0, $composer_0, 1572864, 62);
        // Inline function 'kotlin.run' call
        var dispatchReceiver_0 = rememberComposableLambda(970213481, true, ShoppingContent$lambda$lambda_1($state), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_2.k31(dispatchReceiver_0);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_2.i31();
        var tmp_1;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ComposableLambda$invoke$ref(dispatchReceiver_0);
          $composer_2.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_0;
        }
        var tmp$ret$7 = tmp_1;
        IconButton($onNavigateToCart, null, false, null, null, null, tmp$ret$7, $composer_0, 1572864, 62);
        IconButton($onNavigateToProfile, null, false, null, null, null, ComposableSingletons$ShoppingScreenKt_getInstance().i14o_1, $composer_0, 1572864, 62);
        var tmp_2;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_2 = Unit_instance;
        }
        tmp = tmp_2;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda_7($showFilterSheet$delegate) {
    return function () {
      ShoppingContent$lambda_2($showFilterSheet$delegate, true);
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda_8($state, $onSortOrderChange, $onAgeFilterChange, $onCustomFilterChange, $onPriceFilterChange) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C303@14926L408:ShoppingScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1747995188, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ShoppingContent.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ShoppingScreen.kt:303)');
        }
        FilterContent($state, $onSortOrderChange, $onAgeFilterChange, $onCustomFilterChange, $onPriceFilterChange, $composer_0, 0);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda$lambda_2($selectedTab$delegate) {
    return function () {
      ShoppingContent$lambda_0($selectedTab$delegate, GiftTab_MENS_getInstance());
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda$lambda_3($selectedTab$delegate) {
    return function () {
      ShoppingContent$lambda_0($selectedTab$delegate, GiftTab_BOTH_getInstance());
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda$lambda_4($selectedTab$delegate) {
    return function () {
      ShoppingContent$lambda_0($selectedTab$delegate, GiftTab_GIRLS_getInstance());
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda_9($selectedTab$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C321@16015L30,321@15961L142,322@16190L30,322@16136L140,323@16364L31,323@16309L144:ShoppingScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(597639836, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ShoppingContent.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ShoppingScreen.kt:321)');
        }
        var tmp_0 = ShoppingContent$lambda($selectedTab$delegate).equals(GiftTab_MENS_getInstance());
        sourceInformationMarkerStart($composer_0, -1193732422, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (false || it === Companion_getInstance().f30_1) {
          var value = ShoppingContent$lambda$lambda_2($selectedTab$delegate);
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp0_group = tmp_1;
        sourceInformationMarkerEnd($composer_0);
        var tmp_2 = ComposableSingletons$ShoppingScreenKt_getInstance().m14o_1;
        var tmp_3 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_4 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        Tab(tmp_0, tmp0_group, null, false, tmp_2, null, tmp_3, tmp_4, null, $composer_0, 24624, 492);
        var tmp_5 = ShoppingContent$lambda($selectedTab$delegate).equals(GiftTab_BOTH_getInstance());
        sourceInformationMarkerStart($composer_0, -1193726822, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_6;
        if (false || it_0 === Companion_getInstance().f30_1) {
          var value_0 = ShoppingContent$lambda$lambda_3($selectedTab$delegate);
          $composer_0.j31(value_0);
          tmp_6 = value_0;
        } else {
          tmp_6 = it_0;
        }
        var tmp1_group = tmp_6;
        sourceInformationMarkerEnd($composer_0);
        var tmp_7 = ComposableSingletons$ShoppingScreenKt_getInstance().n14o_1;
        var tmp_8 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        Tab(tmp_5, tmp1_group, null, false, tmp_7, null, tmp_8, tmp_9, null, $composer_0, 24624, 492);
        var tmp_10 = ShoppingContent$lambda($selectedTab$delegate).equals(GiftTab_GIRLS_getInstance());
        sourceInformationMarkerStart($composer_0, -1193721253, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_11;
        if (false || it_1 === Companion_getInstance().f30_1) {
          var value_1 = ShoppingContent$lambda$lambda_4($selectedTab$delegate);
          $composer_0.j31(value_1);
          tmp_11 = value_1;
        } else {
          tmp_11 = it_1;
        }
        var tmp2_group = tmp_11;
        sourceInformationMarkerEnd($composer_0);
        var tmp_12 = ComposableSingletons$ShoppingScreenKt_getInstance().o14o_1;
        var tmp_13 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_14 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        Tab(tmp_10, tmp2_group, null, false, tmp_12, null, tmp_13, tmp_14, null, $composer_0, 24624, 492);
        var tmp_15;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_15 = Unit_instance;
        }
        tmp = tmp_15;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda_10($showFilterSheet$delegate) {
    return function () {
      ShoppingContent$lambda_2($showFilterSheet$delegate, false);
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda_11($state, $onSortOrderChange, $onAgeFilterChange, $onCustomFilterChange, $onPriceFilterChange) {
    return function ($this$ModalBottomSheet, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C348@17648L312:ShoppingScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1747353318, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ShoppingContent.<anonymous> (ShoppingScreen.kt:348)');
        }
        FilterContent($state, $onSortOrderChange, $onAgeFilterChange, $onCustomFilterChange, $onPriceFilterChange, $composer_0, 0);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ShoppingContent$lambda_12($state, $snackbarHostState, $onSearchQueryChange, $onRefresh, $onToggleFavorite, $onToggleLanguage, $onSortOrderChange, $onAgeFilterChange, $onCustomFilterChange, $onPriceFilterChange, $onNavigateToProfile, $onNavigateToProductDetails, $onNavigateToCart, $onBannerClick, $modifier, $$changed, $$changed1, $$default) {
    return function ($composer, $force) {
      ShoppingContent($state, $snackbarHostState, $onSearchQueryChange, $onRefresh, $onToggleFavorite, $onToggleLanguage, $onSortOrderChange, $onAgeFilterChange, $onCustomFilterChange, $onPriceFilterChange, $onNavigateToProfile, $onNavigateToProductDetails, $onNavigateToCart, $onBannerClick, $modifier._v, $composer, updateChangedFlags($$changed | 1), updateChangedFlags($$changed1), $$default);
      return Unit_instance;
    };
  }
  function FilterContent$lambda($tempMinPrice$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('tempMinPrice', KMutableProperty0, true);
    return $tempMinPrice$delegate.u1();
  }
  function FilterContent$lambda_0($tempMinPrice$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('tempMinPrice', KMutableProperty0, true);
    $tempMinPrice$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function FilterContent$lambda_1($tempMaxPrice$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('tempMaxPrice', KMutableProperty0, true);
    return $tempMaxPrice$delegate.u1();
  }
  function FilterContent$lambda_2($tempMaxPrice$delegate, _set____db54di) {
    // Inline function 'androidx.compose.runtime.setValue' call
    getLocalDelegateReference('tempMaxPrice', KMutableProperty0, true);
    $tempMaxPrice$delegate.s21(_set____db54di);
    return Unit_instance;
  }
  function FilterContent$lambda_3($onSortOrderChange, $onAgeFilterChange, $onCustomFilterChange, $onPriceFilterChange, $tempMinPrice$delegate, $tempMaxPrice$delegate) {
    return function () {
      $onSortOrderChange(ProductSortOrder_NEWEST_getInstance());
      $onAgeFilterChange(false, false, false);
      $onCustomFilterChange(false, false, false, false);
      $onPriceFilterChange(0.0, 1.7976931348623157E308);
      FilterContent$lambda_0($tempMinPrice$delegate, '0.0');
      FilterContent$lambda_2($tempMaxPrice$delegate, '');
      return Unit_instance;
    };
  }
  function FilterContent$lambda_4($onAgeFilterChange, $state) {
    return function (it) {
      $onAgeFilterChange(it, $state.m14n_1, $state.n14n_1);
      return Unit_instance;
    };
  }
  function FilterContent$lambda_5($onAgeFilterChange, $state) {
    return function (it) {
      $onAgeFilterChange($state.l14n_1, it, $state.n14n_1);
      return Unit_instance;
    };
  }
  function FilterContent$lambda_6($onAgeFilterChange, $state) {
    return function (it) {
      $onAgeFilterChange($state.l14n_1, $state.m14n_1, it);
      return Unit_instance;
    };
  }
  function FilterContent$lambda_7($onCustomFilterChange, $state) {
    return function (it) {
      $onCustomFilterChange(it, $state.p14n_1, $state.q14n_1, $state.r14n_1);
      return Unit_instance;
    };
  }
  function FilterContent$lambda_8($onCustomFilterChange, $state) {
    return function (it) {
      $onCustomFilterChange($state.o14n_1, it, $state.q14n_1, $state.r14n_1);
      return Unit_instance;
    };
  }
  function FilterContent$lambda_9($onCustomFilterChange, $state) {
    return function (it) {
      $onCustomFilterChange($state.o14n_1, $state.p14n_1, it, $state.r14n_1);
      return Unit_instance;
    };
  }
  function FilterContent$lambda_10($onCustomFilterChange, $state) {
    return function (it) {
      $onCustomFilterChange($state.o14n_1, $state.p14n_1, $state.q14n_1, it);
      return Unit_instance;
    };
  }
  function FilterContent$lambda_11($onSortOrderChange, $order) {
    return function () {
      $onSortOrderChange($order);
      return Unit_instance;
    };
  }
  function FilterContent$lambda_12($onPriceFilterChange, $tempMinPrice$delegate, $tempMaxPrice$delegate) {
    return function (it) {
      var tmp;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(it)) {
          var element = charSequenceGet(it, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          if (!(isDigit(element) || element === _Char___init__impl__6a9atx(46))) {
            tmp$ret$0 = false;
            break $l$block;
          }
        }
        tmp$ret$0 = true;
      }
      if (tmp$ret$0) {
        FilterContent$lambda_0($tempMinPrice$delegate, it);
        var tmp0_elvis_lhs = toDoubleOrNull(it);
        var tmp_0 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = toDoubleOrNull(FilterContent$lambda_1($tempMaxPrice$delegate));
        tmp = $onPriceFilterChange(tmp_0, tmp1_elvis_lhs == null ? 1.7976931348623157E308 : tmp1_elvis_lhs);
      }
      return Unit_instance;
    };
  }
  function FilterContent$lambda_13($onPriceFilterChange, $tempMaxPrice$delegate, $tempMinPrice$delegate) {
    return function (it) {
      var tmp;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(it)) {
          var element = charSequenceGet(it, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          if (!(isDigit(element) || element === _Char___init__impl__6a9atx(46))) {
            tmp$ret$0 = false;
            break $l$block;
          }
        }
        tmp$ret$0 = true;
      }
      if (tmp$ret$0) {
        FilterContent$lambda_2($tempMaxPrice$delegate, it);
        var tmp0_elvis_lhs = toDoubleOrNull(FilterContent$lambda($tempMinPrice$delegate));
        var tmp_0 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = toDoubleOrNull(it);
        tmp = $onPriceFilterChange(tmp_0, tmp1_elvis_lhs == null ? 1.7976931348623157E308 : tmp1_elvis_lhs);
      }
      return Unit_instance;
    };
  }
  function FilterContent$lambda_14($state, $onSortOrderChange, $onAgeFilterChange, $onCustomFilterChange, $onPriceFilterChange, $$changed) {
    return function ($composer, $force) {
      FilterContent($state, $onSortOrderChange, $onAgeFilterChange, $onCustomFilterChange, $onPriceFilterChange, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function ProductsGrid$lambda$lambda$lambda($this$item) {
    return new GridItemSpan_0(GridItemSpan($this$item.git()));
  }
  function ComposableLambda$invoke$ref_15(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function ProductsGrid$lambda$lambda$lambda_0($state, $onBannerClick) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C400@19657L85:ShoppingScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-522763609, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ProductsGrid.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ShoppingScreen.kt:400)');
        }
        BannerCarousel($state, $state.g14n_1, $onBannerClick, null, $composer_0, 0, 8);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductsGrid$lambda$lambda$lambda_1($this$item) {
    return new GridItemSpan_0(GridItemSpan($this$item.git()));
  }
  function ProductsGrid$lambda$lambda$lambda$lambda$lambda(it) {
    var tmp0_elvis_lhs = it.nzt_1;
    return tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
  }
  function ProductsGrid$lambda$lambda$lambda$lambda$lambda_0(it) {
    return null;
  }
  function ProductsGrid$lambda$lambda$lambda$lambda$lambda_1($key, $items) {
    return function (index) {
      return $key($items.l1(index));
    };
  }
  function ProductsGrid$lambda$lambda$lambda$lambda$lambda_2($contentType, $items) {
    return function (index) {
      return $contentType($items.l1(index));
    };
  }
  function ProductsGrid$lambda$lambda$lambda$lambda$lambda$lambda($onToggleFavorite, $product) {
    return function () {
      var tmp0_elvis_lhs = $product.nzt_1;
      $onToggleFavorite(tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs);
      return Unit_instance;
    };
  }
  function ProductsGrid$lambda$lambda$lambda$lambda$lambda$lambda_0($onNavigateToProductDetails, $product) {
    return function () {
      $onNavigateToProductDetails($product);
      return Unit_instance;
    };
  }
  function ProductsGrid$lambda$lambda$lambda$lambda$lambda_3($items, $state, $onToggleFavorite, $onNavigateToProductDetails, $itemWidth) {
    return function ($this$items, it, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$items) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(it) ? 32 : 16);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
        var tmp2 = $items.l1(it);
        var $changed_0 = 14 & $dirty;
        var $composer_1 = $composer_0;
        $composer_1.m30(1868981634);
        sourceInformation($composer_1, 'C*412@20567L38,413@20649L39,408@20299L489:ShoppingScreen.kt#2a4il0');
        var tmp0_elvis_lhs = tmp2.nzt_1;
        var tmp_2 = $state.i14n_1.m1(tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs);
        sourceInformationMarkerStart($composer_1, -1048080802, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_1.k31($onToggleFavorite) | (($changed_0 & 112 ^ 48) > 32 && $composer_1.q31(tmp2) || ($changed_0 & 48) === 32));
        // Inline function 'kotlin.let' call
        var it_0 = $composer_1.i31();
        var tmp_3;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = ProductsGrid$lambda$lambda$lambda$lambda$lambda$lambda($onToggleFavorite, tmp2);
          $composer_1.j31(value);
          tmp_3 = value;
        } else {
          tmp_3 = it_0;
        }
        var tmp0_group = tmp_3;
        sourceInformationMarkerEnd($composer_1);
        sourceInformationMarkerStart($composer_1, -1048078177, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = !!($composer_1.k31($onNavigateToProductDetails) | (($changed_0 & 112 ^ 48) > 32 && $composer_1.q31(tmp2) || ($changed_0 & 48) === 32));
        // Inline function 'kotlin.let' call
        var it_1 = $composer_1.i31();
        var tmp_4;
        if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
          var value_0 = ProductsGrid$lambda$lambda$lambda$lambda$lambda$lambda_0($onNavigateToProductDetails, tmp2);
          $composer_1.j31(value_0);
          tmp_4 = value_0;
        } else {
          tmp_4 = it_1;
        }
        var tmp1_group = tmp_4;
        sourceInformationMarkerEnd($composer_1);
        ProductItem($state.h14n_1, tmp2, tmp_2, tmp0_group, tmp1_group, width(Companion_instance, $itemWidth), $composer_1, 112 & $changed_0, 0);
        $composer_1.n30();
        tmp_1 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductsGrid$lambda$lambda$lambda$lambda($products, $state, $onToggleFavorite, $onNavigateToProductDetails, $itemWidth) {
    return function ($this$LazyRow) {
      var tmp2 = $products;
      // Inline function 'androidx.compose.foundation.lazy.items' call
      var key = ProductsGrid$lambda$lambda$lambda$lambda$lambda;
      var contentType = ProductsGrid$lambda$lambda$lambda$lambda$lambda_0;
      var tmp = tmp2.n1();
      var tmp_0;
      if (!(key == null)) {
        tmp_0 = ProductsGrid$lambda$lambda$lambda$lambda$lambda_1(key, tmp2);
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      var tmp_2 = ProductsGrid$lambda$lambda$lambda$lambda$lambda_2(contentType, tmp2);
      $this$LazyRow.di9(tmp, tmp_1, tmp_2, ComposableLambda$invoke$ref_4(composableLambdaInstance(802480018, true, ProductsGrid$lambda$lambda$lambda$lambda$lambda_3(tmp2, $state, $onToggleFavorite, $onNavigateToProductDetails, $itemWidth))));
      return Unit_instance;
    };
  }
  function ProductsGrid$lambda$lambda$lambda_2($categoryName, $products, $state, $onToggleFavorite, $onNavigateToProductDetails, $itemWidth) {
    return function ($this$item, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C405@20012L10,405@19911L200,406@20193L643,406@20132L704:ShoppingScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1838105580, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ProductsGrid.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ShoppingScreen.kt:405)');
        }
        var tmp0_elvis_lhs = $categoryName;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          $composer_0.m30(1187905373);
          sourceInformation($composer_0, '405@19939L49');
          var tmp0_group = stringResource(get_category_general_gifts(string_instance), $composer_0, 0);
          $composer_0.n30();
          tmp_0 = tmp0_group;
        } else {
          $composer_0.m30(1187904877);
          $composer_0.n30();
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp1_text = tmp_0;
        var tmp2_style = MaterialTheme_instance.jog($composer_0, 6).lof_1;
        var tmp3_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp_1 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(16);
        var tmp4_modifier = padding_2(tmp_1, VOID, tmp$ret$0);
        var tmp_2 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_4 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_5 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_6 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp1_text, tmp4_modifier, tmp_2, null, tmp_3, null, tmp3_fontWeight, null, tmp_4, null, null, tmp_5, tmp_6, false, 0, 0, null, tmp2_style, $composer_0, 1572912, 0, 131004);
        var tmp_7 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$1 = _Dp___init__impl__ms3zkb(16);
        var tmp_8 = tmp_7.mdq(tmp$ret$1);
        sourceInformationMarkerStart($composer_0, 1187914095, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!(!!(!!($composer_0.q31($products) | $composer_0.q31($state)) | $composer_0.k31($onToggleFavorite)) | $composer_0.k31($onNavigateToProductDetails)) | $composer_0.n31(_Dp___get_value__impl__geb1vb($itemWidth)));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_9;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ProductsGrid$lambda$lambda$lambda$lambda($products, $state, $onToggleFavorite, $onNavigateToProductDetails, $itemWidth);
          $composer_0.j31(value);
          tmp_9 = value;
        } else {
          tmp_9 = it;
        }
        var tmp1_group = tmp_9;
        sourceInformationMarkerEnd($composer_0);
        LazyRow(null, null, null, false, tmp_8, null, null, false, null, tmp1_group, $composer_0, 24576, 495);
        var tmp_10;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_10 = Unit_instance;
        }
        tmp = tmp_10;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductsGrid$lambda$lambda($allProductsByCategory, $state, $onBannerClick, $onToggleFavorite, $onNavigateToProductDetails, $itemWidth) {
    return function ($this$LazyVerticalGrid) {
      var tmp = ProductsGrid$lambda$lambda$lambda;
      $this$LazyVerticalGrid.eiq(VOID, tmp, VOID, ComposableLambda$invoke$ref_15(composableLambdaInstance(-522763609, true, ProductsGrid$lambda$lambda$lambda_0($state, $onBannerClick))));
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = $allProductsByCategory.s1().t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlin.collections.component1' call
        var categoryName = element.t1();
        // Inline function 'kotlin.collections.component2' call
        var products = element.u1();
        var tmp_0 = ProductsGrid$lambda$lambda$lambda_1;
        $this$LazyVerticalGrid.eiq(VOID, tmp_0, VOID, ComposableLambda$invoke$ref_15(composableLambdaInstance(1838105580, true, ProductsGrid$lambda$lambda$lambda_2(categoryName, products, $state, $onToggleFavorite, $onNavigateToProductDetails, $itemWidth))));
      }
      return Unit_instance;
    };
  }
  function ProductsGrid$lambda($state, $selectedTab, $onBannerClick, $onToggleFavorite, $onNavigateToProductDetails) {
    return function ($this$BoxWithConstraints, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C377@18563L491,388@19092L179,398@19582L1296,392@19281L1597:ShoppingScreen.kt#2a4il0');
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31($this$BoxWithConstraints) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1874881243, $dirty, -1, 'client.fstech.hadaya.presentation.shopping.ProductsGrid.<anonymous> (ShoppingScreen.kt:369)');
        }
        var tmp_1;
        var tmp_2 = $this$BoxWithConstraints.wds();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$0 = _Dp___init__impl__ms3zkb(1200);
        if (Dp__compareTo_impl_tlg3dl(tmp_2, tmp$ret$0) > 0) {
          tmp_1 = 5;
        } else {
          var tmp_3 = $this$BoxWithConstraints.wds();
          // Inline function 'androidx.compose.ui.unit.dp' call
          var tmp$ret$1 = _Dp___init__impl__ms3zkb(900);
          if (Dp__compareTo_impl_tlg3dl(tmp_3, tmp$ret$1) > 0) {
            tmp_1 = 4;
          } else {
            var tmp_4 = $this$BoxWithConstraints.wds();
            // Inline function 'androidx.compose.ui.unit.dp' call
            var tmp$ret$2 = _Dp___init__impl__ms3zkb(600);
            if (Dp__compareTo_impl_tlg3dl(tmp_4, tmp$ret$2) > 0) {
              tmp_1 = 3;
            } else {
              tmp_1 = 2;
            }
          }
        }
        var columns = tmp_1;
        var tmp0 = $this$BoxWithConstraints.wds();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp0_0 = _Dp___init__impl__ms3zkb(16);
        // Inline function 'androidx.compose.ui.unit.Dp.times' call
        var other = columns + 1 | 0;
        // Inline function 'androidx.compose.ui.unit.Dp.minus' call
        var other_0 = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(tmp0_0) * other);
        // Inline function 'androidx.compose.ui.unit.Dp.div' call
        var this_0 = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(tmp0) - _Dp___get_value__impl__geb1vb(other_0));
        var itemWidth = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(this_0) / columns);
        var tmp0_remember$arg$1 = $state.y14m_1;
        sourceInformationMarkerStart($composer_0, -2125380506, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!($composer_0.m31($selectedTab.a1_1) | $composer_0.k31(tmp0_remember$arg$1));
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_5;
        if (invalid || it === Companion_getInstance().f30_1) {
          // Inline function 'kotlin.collections.filter' call
          var tmp0_1 = $state.y14m_1;
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList_init_$Create$_0();
          var _iterator__ex2g4s = tmp0_1.t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            var tmp0_elvis_lhs = element.izu_1;
            var audience = tmp0_elvis_lhs == null ? TargetAudience_BOTH_getInstance() : tmp0_elvis_lhs;
            var tmp_6;
            switch ($selectedTab.a1_1) {
              case 1:
                tmp_6 = true;
                break;
              case 0:
                tmp_6 = audience.equals(TargetAudience_MENS_getInstance()) || audience.equals(TargetAudience_BOTH_getInstance());
                break;
              case 2:
                tmp_6 = audience.equals(TargetAudience_GIRLS_getInstance()) || audience.equals(TargetAudience_BOTH_getInstance());
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
            if (tmp_6) {
              destination.j1(element);
            }
          }
          var value = destination;
          $composer_0.j31(value);
          tmp_5 = value;
        } else {
          tmp_5 = it;
        }
        var tmp1_group = tmp_5;
        sourceInformationMarkerEnd($composer_0);
        var tabFilteredProducts = tmp1_group;
        var tmp2_remember$arg$1 = $state.h14n_1;
        sourceInformationMarkerStart($composer_0, -2125363890, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = !!($composer_0.k31(tabFilteredProducts) | $composer_0.k31(tmp2_remember$arg$1));
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_7;
        if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
          // Inline function 'kotlin.collections.groupBy' call
          // Inline function 'kotlin.collections.groupByTo' call
          var destination_0 = LinkedHashMap_init_$Create$_0();
          var _iterator__ex2g4s_0 = tabFilteredProducts.t();
          while (_iterator__ex2g4s_0.u()) {
            var element_0 = _iterator__ex2g4s_0.v();
            var key = $state.h14n_1 === 'ar' ? element_0.ezu_1 : element_0.dzu_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var value_0 = destination_0.w2(key);
            var tmp_8;
            if (value_0 == null) {
              var answer = ArrayList_init_$Create$_0();
              destination_0.z2(key, answer);
              tmp_8 = answer;
            } else {
              tmp_8 = value_0;
            }
            var list = tmp_8;
            list.j1(element_0);
          }
          var value_1 = destination_0;
          $composer_0.j31(value_1);
          tmp_7 = value_1;
        } else {
          tmp_7 = it_0;
        }
        var tmp3_group = tmp_7;
        sourceInformationMarkerEnd($composer_0);
        var allProductsByCategory = tmp3_group;
        var tmp0_columns = new Fixed(columns);
        var tmp1_modifier = fillMaxSize(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$23 = _Dp___init__impl__ms3zkb(16);
        var tmp2_contentPadding = PaddingValues_1(tmp$ret$23);
        var tmp_9 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$24 = _Dp___init__impl__ms3zkb(16);
        var tmp3_horizontalArrangement = tmp_9.mdq(tmp$ret$24);
        var tmp_10 = Arrangement_getInstance();
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$25 = _Dp___init__impl__ms3zkb(16);
        var tmp4_verticalArrangement = tmp_10.mdq(tmp$ret$25);
        sourceInformationMarkerStart($composer_0, -2125347093, 'CC(remember):ShoppingScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = !!(!!(!!(!!(!!($composer_0.q31($state) | $composer_0.k31($onBannerClick)) | $composer_0.q31(allProductsByCategory)) | $composer_0.k31($onToggleFavorite)) | $composer_0.k31($onNavigateToProductDetails)) | $composer_0.n31(_Dp___get_value__impl__geb1vb(itemWidth)));
        // Inline function 'kotlin.let' call
        var it_1 = $composer_0.i31();
        var tmp_11;
        if (invalid_1 || it_1 === Companion_getInstance().f30_1) {
          var value_2 = ProductsGrid$lambda$lambda(allProductsByCategory, $state, $onBannerClick, $onToggleFavorite, $onNavigateToProductDetails, itemWidth);
          $composer_0.j31(value_2);
          tmp_11 = value_2;
        } else {
          tmp_11 = it_1;
        }
        var tmp4_group = tmp_11;
        sourceInformationMarkerEnd($composer_0);
        LazyVerticalGrid(tmp0_columns, tmp1_modifier, null, tmp2_contentPadding, false, tmp4_verticalArrangement, tmp3_horizontalArrangement, null, false, null, tmp4_group, $composer_0, 1772592, 0, 916);
        var tmp_12;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_12 = Unit_instance;
        }
        tmp_0 = tmp_12;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductsGrid$lambda_0($state, $selectedTab, $onRefresh, $onToggleFavorite, $onNavigateToProductDetails, $onBannerClick, $$changed) {
    return function ($composer, $force) {
      ProductsGrid($state, $selectedTab, $onRefresh, $onToggleFavorite, $onNavigateToProductDetails, $onBannerClick, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function AgeFilterOptionRow$lambda($onCheckedChange, $checked) {
    return function () {
      $onCheckedChange(!$checked);
      return Unit_instance;
    };
  }
  function AgeFilterOptionRow$lambda_0($label, $checked, $onCheckedChange, $$changed) {
    return function ($composer, $force) {
      AgeFilterOptionRow($label, $checked, $onCheckedChange, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function SortOptionRow$lambda($label, $selected, $onClick, $$changed) {
    return function ($composer, $force) {
      SortOptionRow($label, $selected, $onClick, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function BannerCarousel$lambda($state, $banners, $onBannerClick, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      BannerCarousel($state, $banners, $onBannerClick, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function BannerCarousel$lambda_0($banners) {
    return function () {
      return $banners.n1();
    };
  }
  function BannerCarousel$lambda$lambda($onBannerClick, $banner) {
    return function () {
      $onBannerClick($banner);
      return Unit_instance;
    };
  }
  function BannerCarousel$lambda_1($banners, $state, $onBannerClick) {
    return function ($this$HorizontalPager, page, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C:ShoppingScreen.kt#2a4il0');
      var $dirty = $changed;
      var tmp;
      if (($changed & 48) === 0) {
        $dirty = $dirty | ($composer_0.m31(page) ? 32 : 16);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 145) === 144), $dirty & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2045109510, $dirty, -1, 'client.fstech.hadaya.presentation.shopping.BannerCarousel.<anonymous>.<anonymous> (ShoppingScreen.kt:541)');
        }
        var banner = $banners.l1(page);
        var tmp0_safe_receiver = $state.h14n_1 === 'en' ? banner.gzy_1 : banner.fzy_1;
        var tmp_1;
        if (tmp0_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_2;
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(tmp0_safe_receiver)) {
            tmp_2 = tmp0_safe_receiver;
          } else {
            tmp_2 = null;
          }
          tmp_1 = tmp_2;
        }
        var bannerUrl = tmp_1;
        if (!(bannerUrl == null)) {
          $composer_0.m30(1744789660);
          sourceInformation($composer_0, '543@29159L25,543@29057L162');
          var tmp_3 = fillMaxSize(Companion_instance);
          sourceInformationMarkerStart($composer_0, 1744792787, 'CC(remember):ShoppingScreen.kt#9igjgp');
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid = !!($composer_0.k31($onBannerClick) | $composer_0.k31(banner));
          // Inline function 'kotlin.let' call
          var it = $composer_0.i31();
          var tmp_4;
          if (invalid || it === Companion_getInstance().f30_1) {
            var value = BannerCarousel$lambda$lambda($onBannerClick, banner);
            $composer_0.j31(value);
            tmp_4 = value;
          } else {
            tmp_4 = it;
          }
          var tmp0_group = tmp_4;
          sourceInformationMarkerEnd($composer_0);
          HadayaImage(bannerUrl, null, clickable(tmp_3, VOID, VOID, VOID, VOID, tmp0_group), Companion_getInstance_13().q96_1, $composer_0, 3120, 0);
          $composer_0.n30();
        } else {
          $composer_0.m30(-1745939704);
          $composer_0.n30();
        }
        var tmp_5;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_5 = Unit_instance;
        }
        tmp_0 = tmp_5;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BannerCarousel$lambda_2($state, $banners, $onBannerClick, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      BannerCarousel($state, $banners, $onBannerClick, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ProductItem$lambda$lambda($isFavorite) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C559@30617L169:ShoppingScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-797475721, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ProductItem.<anonymous>.<anonymous>.<anonymous>.<anonymous> (ShoppingScreen.kt:559)');
        }
        var tmp_0 = $isFavorite ? get_Favorite(Icons_getInstance().dxv_1) : get_FavoriteBorder(Icons_getInstance().dxv_1);
        Icon(tmp_0, null, null, $isFavorite ? Companion_getInstance_14().n6b_1 : Companion_getInstance_14().k6b_1, $composer_0, 48, 4);
        var tmp_1;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductItem$lambda($product, $name, $onToggleFavorite, $lang, $isFavorite) {
    return function ($this$Card, $composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C554@30112L1166:ShoppingScreen.kt#2a4il0');
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-1293345327, $changed, -1, 'client.fstech.hadaya.presentation.shopping.ProductItem.<anonymous> (ShoppingScreen.kt:554)');
        }
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier = fillMaxWidth(Companion_instance);
        var verticalArrangement = null;
        var horizontalAlignment = null;
        var $composer_1 = $composer_0;
        if (!((6 & 1) === 0))
          modifier = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_1, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, -168417827, 'C555@30169L649,562@30831L437:ShoppingScreen.kt#2a4il0');
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier_1 = aspectRatio(fillMaxWidth(Companion_instance), 1.0);
        var contentAlignment = null;
        var propagateMinConstraints = false;
        var $composer_6 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((6 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((6 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy_0 = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_1 = $composer_8.g30();
        if (!isInterface(tmp_1, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, -1742601539, 'C558@30595L209,558@30497L307:ShoppingScreen.kt#2a4il0');
        var tmp0_safe_receiver = $product.xzt_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
        var tmp_2;
        if (tmp1_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_3;
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(tmp1_safe_receiver)) {
            tmp_3 = tmp1_safe_receiver;
          } else {
            tmp_3 = null;
          }
          tmp_2 = tmp_3;
        }
        var imageUrl = tmp_2;
        if (!(imageUrl == null)) {
          $composer_10.m30(-1164588431);
          sourceInformation($composer_10, '557@30356L124');
          HadayaImage(imageUrl, $name, fillMaxSize(Companion_instance), Companion_getInstance_13().r96_1, $composer_10, 3456, 0);
          $composer_10.n30();
        } else {
          $composer_10.m30(-1742383827);
          $composer_10.n30();
        }
        var tmp_4 = BoxScopeInstance_instance.udr(Companion_instance, Companion_getInstance_11().m8t_1);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$15 = _Dp___init__impl__ms3zkb(4);
        var tmp_5 = padding_0(tmp_4, tmp$ret$15);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-797475721, true, ProductItem$lambda$lambda($isFavorite), $composer_10, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_11 = $composer_10;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_11.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_11.i31();
        var tmp_6;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_11.j31(value);
          tmp_6 = value;
        } else {
          tmp_6 = it;
        }
        var tmp$ret$16 = tmp_6;
        IconButton($onToggleFavorite, tmp_5, false, null, null, null, tmp$ret$16, $composer_10, 1572864, 60);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        var tmp_7 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$23 = _Dp___init__impl__ms3zkb(12);
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_3 = padding_0(tmp_7, tmp$ret$23);
        var verticalArrangement_0 = null;
        var horizontalAlignment_0 = null;
        var $composer_12 = $composer_5;
        if (!((6 & 1) === 0))
          modifier_3 = Companion_instance;
        if (!((6 & 2) === 0))
          verticalArrangement_0 = Arrangement_getInstance().sdp_1;
        if (!((6 & 4) === 0))
          horizontalAlignment_0 = Companion_getInstance_11().w8t_1;
        var measurePolicy_1 = columnMeasurePolicy(verticalArrangement_0, horizontalAlignment_0, $composer_12, 14 & 6 >> 3 | 112 & 6 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_4 = modifier_3;
        var $composer_13 = $composer_12;
        if (!((0 & 2) === 0))
          modifier_4 = Companion_instance;
        var compositeKeyHash_1 = get_currentCompositeKeyHashCode($composer_13, 0).hashCode();
        var localMap_1 = $composer_13.t31();
        var materialized_1 = materialize($composer_13, modifier_4);
        var tmp0_1 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_14 = $composer_13;
        var tmp_8 = $composer_14.g30();
        if (!isInterface(tmp_8, Applier)) {
          invalidApplier();
        }
        $composer_14.b31();
        if ($composer_14.h30()) {
          $composer_14.c31(tmp0_1);
        } else {
          $composer_14.d31();
        }
        var $this$ReusableComposeNode_1 = _Updater___init__impl__rbfxm8($composer_14);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, measurePolicy_1, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, localMap_1, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, compositeKeyHash_1, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_1, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_1, materialized_1, Companion_getInstance_12().qah_1);
        var $composer_15 = $composer_14;
        var $composer_16 = $composer_15;
        sourceInformationMarkerStart($composer_16, 1488229140, 'C563@30892L158,564@31079L58,564@31181L11,564@31067L187:ShoppingScreen.kt#2a4il0');
        var tmp0_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp1_fontSize = get_sp(14);
        var tmp2_overflow = Companion_getInstance_23().x7s_1;
        var tmp_9 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_11 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        Text($name, null, tmp_9, null, tmp1_fontSize, null, tmp0_fontWeight, null, tmp_10, null, null, tmp_11, tmp2_overflow, false, 2, 2, null, null, $composer_16, 1597440, 221568, 208814);
        var tmp_12 = get_price_egp(string_instance);
        var tmp3_elvis_lhs = $product.szt_1;
        var tmp4_text = formatNumbers(stringResource_0(tmp_12, [tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs], $composer_16, 0), $lang);
        var tmp5_color = MaterialTheme_instance.unz($composer_16, 6).xnz_1;
        var tmp6_fontWeight = Companion_getInstance_16().f7z_1;
        var tmp7_fontSize = get_sp(16);
        var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_15 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp4_text, null, tmp5_color, null, tmp7_fontSize, null, tmp6_fontWeight, null, tmp_13, null, null, tmp_14, tmp_15, false, 0, 0, null, null, $composer_16, 1597440, 0, 262058);
        sourceInformationMarkerEnd($composer_16);
        $composer_14.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_16;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_16 = Unit_instance;
        }
        tmp = tmp_16;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ProductItem$lambda_0($lang, $product, $isFavorite, $onToggleFavorite, $onClick, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      ProductItem($lang, $product, $isFavorite, $onToggleFavorite, $onClick, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function GiftTab_MENS_getInstance() {
    GiftTab_initEntries();
    return GiftTab_MENS_instance;
  }
  function GiftTab_BOTH_getInstance() {
    GiftTab_initEntries();
    return GiftTab_BOTH_instance;
  }
  function GiftTab_GIRLS_getInstance() {
    GiftTab_initEntries();
    return GiftTab_GIRLS_instance;
  }
  var client_fstech_hadaya_presentation_shopping_ShoppingViewModel$stable;
  function ShoppingViewModel$observeConnection$slambda$slambda$lambda($connected) {
    return function ($this$updateState) {
      return $this$updateState.t14n(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $connected);
    };
  }
  function ShoppingViewModel$observeConnection$slambda$slambda(this$0, resultContinuation) {
    this.y14p_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$observeConnection$slambda$slambda).xf4 = function (connected, $completion) {
    var tmp = this.yf4(connected, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$observeConnection$slambda$slambda).ja = function (p1, $completion) {
    return this.xf4((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$observeConnection$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.y14p_1.x10k(ShoppingViewModel$observeConnection$slambda$slambda$lambda(this.z14p_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ShoppingViewModel$observeConnection$slambda$slambda).yf4 = function (connected, completion) {
    var i = new ShoppingViewModel$observeConnection$slambda$slambda(this.y14p_1, completion);
    i.z14p_1 = connected;
    return i;
  };
  function ShoppingViewModel$observeConnection$slambda$slambda_0(this$0, resultContinuation) {
    var i = new ShoppingViewModel$observeConnection$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (connected, $completion) {
      return i.xf4(connected, $completion);
    }, 1);
  }
  function ShoppingViewModel$observeCart$slambda$slambda$lambda($cartItems) {
    return function ($this$updateState) {
      // Inline function 'kotlin.collections.sumOf' call
      var sum = 0;
      var _iterator__ex2g4s = $cartItems.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var tmp = sum;
        sum = tmp + element.ryw_1 | 0;
      }
      var tmp$ret$0 = sum;
      return $this$updateState.t14n(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
    };
  }
  function ShoppingViewModel$observeCart$slambda$slambda(this$0, resultContinuation) {
    this.i14q_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$observeCart$slambda$slambda).q10v = function (cartItems, $completion) {
    var tmp = this.r10v(cartItems, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$observeCart$slambda$slambda).ja = function (p1, $completion) {
    return this.q10v((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$observeCart$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.i14q_1.x10k(ShoppingViewModel$observeCart$slambda$slambda$lambda(this.j14q_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ShoppingViewModel$observeCart$slambda$slambda).r10v = function (cartItems, completion) {
    var i = new ShoppingViewModel$observeCart$slambda$slambda(this.i14q_1, completion);
    i.j14q_1 = cartItems;
    return i;
  };
  function ShoppingViewModel$observeCart$slambda$slambda_0(this$0, resultContinuation) {
    var i = new ShoppingViewModel$observeCart$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (cartItems, $completion) {
      return i.q10v(cartItems, $completion);
    }, 1);
  }
  function ShoppingViewModel$observeFavorites$slambda$slambda$lambda($favorites) {
    return function ($this$updateState) {
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0 = $favorites;
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var tmp0_safe_receiver = element.nzt_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.j1(tmp0_safe_receiver);
        }
      }
      return $this$updateState.t14n(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, toSet(destination));
    };
  }
  function ShoppingViewModel$observeFavorites$slambda$slambda(this$0, resultContinuation) {
    this.s14q_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$observeFavorites$slambda$slambda).n122 = function (favorites, $completion) {
    var tmp = this.o122(favorites, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$observeFavorites$slambda$slambda).ja = function (p1, $completion) {
    return this.n122((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$observeFavorites$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.s14q_1.x10k(ShoppingViewModel$observeFavorites$slambda$slambda$lambda(this.t14q_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ShoppingViewModel$observeFavorites$slambda$slambda).o122 = function (favorites, completion) {
    var i = new ShoppingViewModel$observeFavorites$slambda$slambda(this.s14q_1, completion);
    i.t14q_1 = favorites;
    return i;
  };
  function ShoppingViewModel$observeFavorites$slambda$slambda_0(this$0, resultContinuation) {
    var i = new ShoppingViewModel$observeFavorites$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (favorites, $completion) {
      return i.n122(favorites, $completion);
    }, 1);
  }
  function ShoppingViewModel$observeLanguage$slambda$slambda$lambda($language) {
    return function ($this$updateState) {
      return $this$updateState.t14n(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $language);
    };
  }
  function ShoppingViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation) {
    this.c14r_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$observeLanguage$slambda$slambda).pyo = function (language, $completion) {
    var tmp = this.um9(language, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$observeLanguage$slambda$slambda).ja = function (p1, $completion) {
    return this.pyo((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$observeLanguage$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.c14r_1.x10k(ShoppingViewModel$observeLanguage$slambda$slambda$lambda(this.d14r_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ShoppingViewModel$observeLanguage$slambda$slambda).um9 = function (language, completion) {
    var i = new ShoppingViewModel$observeLanguage$slambda$slambda(this.c14r_1, completion);
    i.d14r_1 = language;
    return i;
  };
  function ShoppingViewModel$observeLanguage$slambda$slambda_0(this$0, resultContinuation) {
    var i = new ShoppingViewModel$observeLanguage$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (language, $completion) {
      return i.pyo(language, $completion);
    }, 1);
  }
  function ShoppingViewModel$observeAuthChanges$slambda$slambda(this$0, resultContinuation) {
    this.m14r_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$observeAuthChanges$slambda$slambda).t10u = function (it, $completion) {
    var tmp = this.u10u(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$observeAuthChanges$slambda$slambda).ja = function (p1, $completion) {
    return this.t10u((p1 == null ? true : p1 instanceof Profile) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$observeAuthChanges$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            suspendResult = this.m14r_1.s14r_1.e102(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.m14r_1.t14r_1.e102(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.m14r_1.z14r_1.r2b(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ShoppingViewModel$observeAuthChanges$slambda$slambda).u10u = function (it, completion) {
    var i = new ShoppingViewModel$observeAuthChanges$slambda$slambda(this.m14r_1, completion);
    i.n14r_1 = it;
    return i;
  };
  function ShoppingViewModel$observeAuthChanges$slambda$slambda_0(this$0, resultContinuation) {
    var i = new ShoppingViewModel$observeAuthChanges$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.t10u(it, $completion);
    }, 1);
  }
  function ShoppingViewModel$refreshData$slambda$lambda($this$updateState) {
    return $this$updateState.t14n(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function ShoppingViewModel$refreshData$slambda$lambda_0($this$updateState) {
    return $this$updateState.t14n(VOID, VOID, VOID, VOID, VOID, VOID, VOID, false);
  }
  function ShoppingViewModel$loadProducts$slambda$slambda$lambda($customMug, $products, $banners) {
    return function ($this$updateState) {
      var tmp0_safe_receiver = $customMug;
      var tmp1_customMugPrice = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.szt_1;
      return $this$updateState.t14n($products, VOID, VOID, VOID, VOID, VOID, VOID, false, tmp1_customMugPrice, $banners);
    };
  }
  function ShoppingViewModel$loadProducts$slambda$lambda($this$updateState) {
    return $this$updateState.t14n(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function ShoppingViewModel$loadProducts$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$loadProducts$slambda$slambda).m14s = function (products, banners, $completion) {
    var tmp = this.n14s(products, banners, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$loadProducts$slambda$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE();
    return this.m14s(tmp, (!(p2 == null) ? isInterface(p2, KtList) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$loadProducts$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return to(this.k14s_1, this.l14s_1);
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ShoppingViewModel$loadProducts$slambda$slambda).n14s = function (products, banners, completion) {
    var i = new ShoppingViewModel$loadProducts$slambda$slambda(completion);
    i.k14s_1 = products;
    i.l14s_1 = banners;
    return i;
  };
  function ShoppingViewModel$loadProducts$slambda$slambda_0(resultContinuation) {
    var i = new ShoppingViewModel$loadProducts$slambda$slambda(resultContinuation);
    return constructCallableReference(function (products, banners, $completion) {
      return i.m14s(products, banners, $completion);
    }, 2);
  }
  function ShoppingViewModel$loadProducts$slambda$slambda_1(this$0, resultContinuation) {
    this.w14s_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$loadProducts$slambda$slambda_1).y14s = function (_destruct__k2r9zo, $completion) {
    var tmp = this.z14s(_destruct__k2r9zo, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$loadProducts$slambda$slambda_1).ja = function (p1, $completion) {
    return this.y14s(p1 instanceof Pair ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$loadProducts$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var products = this.x14s_1.zh();
          var banners = this.x14s_1.ai();
          var tmp$ret$0 = Unit_instance;
          l$ret$1: do {
            var _iterator__ex2g4s = products.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              if (equals(element.bzu_1, ProductKind_MUG_getInstance())) {
                tmp$ret$0 = element;
                break l$ret$1;
              }
            }
            tmp$ret$0 = null;
          }
           while (false);
          var customMug = tmp$ret$0;
          this.w14s_1.x10k(ShoppingViewModel$loadProducts$slambda$slambda$lambda(customMug, products, banners));
          applyFilters(this.w14s_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ShoppingViewModel$loadProducts$slambda$slambda_1).z14s = function (_destruct__k2r9zo, completion) {
    var i = new ShoppingViewModel$loadProducts$slambda$slambda_1(this.w14s_1, completion);
    i.x14s_1 = _destruct__k2r9zo;
    return i;
  };
  function ShoppingViewModel$loadProducts$slambda$slambda_2(this$0, resultContinuation) {
    var i = new ShoppingViewModel$loadProducts$slambda$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function (_destruct__k2r9zo, $completion) {
      return i.y14s(_destruct__k2r9zo, $completion);
    }, 1);
  }
  function observeConnection($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, ShoppingViewModel$observeConnection$slambda_0($this, null));
  }
  function observeCart_0($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, ShoppingViewModel$observeCart$slambda_0($this, null));
  }
  function observeFavorites_0($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, ShoppingViewModel$observeFavorites$slambda_0($this, null));
  }
  function observeLanguage_10($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, ShoppingViewModel$observeLanguage$slambda_0($this, null));
  }
  function observeAuthChanges($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, ShoppingViewModel$observeAuthChanges$slambda_0($this, null));
  }
  function refreshData($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, ShoppingViewModel$refreshData$slambda_0($this, null));
  }
  function loadProducts($this) {
    var tmp = get_viewModelScope($this);
    launch(tmp, VOID, VOID, ShoppingViewModel$loadProducts$slambda_0($this, null));
  }
  function applyFilters($this) {
    var currentState = $this.s10h().ajg().u1();
    // Inline function 'kotlin.text.trim' call
    var this_0 = currentState.z14m_1;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE())).toLowerCase();
    // Inline function 'kotlin.text.split' call
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = Regex_init_$Create$('\\s+').ge(tmp0, 0);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = tmp0_0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element)) {
        destination.j1(element);
      }
    }
    var queryWords = destination;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_1 = currentState.x14m_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_0 = tmp0_1.t();
    while (_iterator__ex2g4s_0.u()) {
      var element_0 = _iterator__ex2g4s_0.v();
      var tmp$ret$10;
      $l$block: {
        if (element_0.qzu_1) {
          tmp$ret$10 = false;
          break $l$block;
        }
        var tmp;
        if (queryWords.r()) {
          tmp = true;
        } else {
          // Inline function 'kotlin.text.buildString' call
          // Inline function 'kotlin.apply' call
          var this_1 = StringBuilder_init_$Create$();
          var tmp0_safe_receiver = element_0.ozt_1;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_0 = tmp0_safe_receiver.toLowerCase();
          }
          var tmp1_elvis_lhs = tmp_0;
          this_1.q(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
          this_1.q(' ');
          var tmp2_safe_receiver = element_0.pzt_1;
          var tmp_1;
          if (tmp2_safe_receiver == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_1 = tmp2_safe_receiver.toLowerCase();
          }
          var tmp3_elvis_lhs = tmp_1;
          this_1.q(tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs);
          this_1.q(' ');
          var tmp4_safe_receiver = element_0.qzt_1;
          var tmp_2;
          if (tmp4_safe_receiver == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_2 = tmp4_safe_receiver.toLowerCase();
          }
          var tmp5_elvis_lhs = tmp_2;
          this_1.q(tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs);
          this_1.q(' ');
          var tmp6_safe_receiver = element_0.rzt_1;
          var tmp_3;
          if (tmp6_safe_receiver == null) {
            tmp_3 = null;
          } else {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_3 = tmp6_safe_receiver.toLowerCase();
          }
          var tmp7_elvis_lhs = tmp_3;
          this_1.q(tmp7_elvis_lhs == null ? '' : tmp7_elvis_lhs);
          this_1.q(' ');
          var tmp8_safe_receiver = element_0.dzu_1;
          var tmp_4;
          if (tmp8_safe_receiver == null) {
            tmp_4 = null;
          } else {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_4 = tmp8_safe_receiver.toLowerCase();
          }
          var tmp9_elvis_lhs = tmp_4;
          this_1.q(tmp9_elvis_lhs == null ? '' : tmp9_elvis_lhs);
          this_1.q(' ');
          var tmp10_safe_receiver = element_0.ezu_1;
          var tmp_5;
          if (tmp10_safe_receiver == null) {
            tmp_5 = null;
          } else {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_5 = tmp10_safe_receiver.toLowerCase();
          }
          var tmp11_elvis_lhs = tmp_5;
          this_1.q(tmp11_elvis_lhs == null ? '' : tmp11_elvis_lhs);
          var searchableText = this_1.toString();
          var tmp$ret$26;
          $l$block_1: {
            // Inline function 'kotlin.collections.all' call
            var tmp_6;
            if (isInterface(queryWords, Collection)) {
              tmp_6 = queryWords.r();
            } else {
              tmp_6 = false;
            }
            if (tmp_6) {
              tmp$ret$26 = true;
              break $l$block_1;
            }
            var _iterator__ex2g4s_1 = queryWords.t();
            while (_iterator__ex2g4s_1.u()) {
              var element_1 = _iterator__ex2g4s_1.v();
              if (!contains(searchableText, element_1)) {
                tmp$ret$26 = false;
                break $l$block_1;
              }
            }
            tmp$ret$26 = true;
          }
          tmp = tmp$ret$26;
        }
        var matchesSearch = tmp;
        var containsLower = currentState.a14n_1;
        var containsUpper = currentState.b14n_1;
        var tmp0_elvis_lhs = element_0.szt_1;
        var containsArg = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
        var matchesPrice = containsLower <= containsArg ? containsArg <= containsUpper : false;
        var tmp1_elvis_lhs_0 = element_0.vzt_1;
        var matchesRating = (tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0) >= currentState.c14n_1;
        var matchesAge = !currentState.l14n_1 && !currentState.m14n_1 && !currentState.n14n_1 ? true : currentState.l14n_1 && element_0.rzu_1 ? true : currentState.m14n_1 && element_0.szu_1 ? true : currentState.n14n_1 && element_0.tzu_1 ? true : false;
        var isCustomKind = !equals(element_0.bzu_1, ProductKind_NORMAL_getInstance());
        var tmp_7;
        if (!currentState.o14n_1 && !currentState.p14n_1) {
          tmp_7 = true;
        } else {
          var matchesStandard = currentState.o14n_1 && !isCustomKind;
          var tmp_8;
          if (currentState.p14n_1 && isCustomKind) {
            // Inline function 'kotlin.collections.isNullOrEmpty' call
            var this_2 = element_0.ozu_1;
            var hasTemplates = !(this_2 == null || this_2.r());
            tmp_8 = currentState.q14n_1 && currentState.r14n_1 ? true : currentState.q14n_1 ? hasTemplates : currentState.r14n_1 ? !hasTemplates : true;
          } else {
            tmp_8 = false;
          }
          var matchesCustomOnly = tmp_8;
          tmp_7 = matchesStandard || matchesCustomOnly;
        }
        var matchesCustom = tmp_7;
        tmp$ret$10 = (matchesSearch && matchesPrice && matchesRating && matchesAge && matchesCustom);
      }
      if (tmp$ret$10) {
        destination_0.j1(element_0);
      }
    }
    var filtered = {_v: destination_0};
    var tmp_9;
    switch (currentState.d14n_1.a1_1) {
      case 0:
        // Inline function 'kotlin.collections.sortedBy' call

        var this_3 = filtered._v;
        // Inline function 'kotlin.comparisons.compareBy' call

        var tmp_10 = ShoppingViewModel$applyFilters$lambda;
        var tmp$ret$30 = new sam$kotlin_Comparator$0_1(tmp_10);
        tmp_9 = sortedWith(this_3, tmp$ret$30);
        break;
      case 1:
        // Inline function 'kotlin.collections.sortedByDescending' call

        var this_4 = filtered._v;
        // Inline function 'kotlin.comparisons.compareByDescending' call

        var tmp_11 = ShoppingViewModel$applyFilters$lambda_0;
        var tmp$ret$32 = new sam$kotlin_Comparator$0_1(tmp_11);
        tmp_9 = sortedWith(this_4, tmp$ret$32);
        break;
      case 2:
        // Inline function 'kotlin.collections.sortedBy' call

        var this_5 = filtered._v;
        // Inline function 'kotlin.comparisons.compareBy' call

        var tmp_12 = ShoppingViewModel$applyFilters$lambda_1(currentState);
        var tmp$ret$34 = new sam$kotlin_Comparator$0_1(tmp_12);
        tmp_9 = sortedWith(this_5, tmp$ret$34);
        break;
      case 3:
        // Inline function 'kotlin.collections.sortedByDescending' call

        var this_6 = filtered._v;
        // Inline function 'kotlin.comparisons.compareByDescending' call

        var tmp_13 = ShoppingViewModel$applyFilters$lambda_2(currentState);
        var tmp$ret$36 = new sam$kotlin_Comparator$0_1(tmp_13);
        tmp_9 = sortedWith(this_6, tmp$ret$36);
        break;
      case 4:
        // Inline function 'kotlin.collections.sortedByDescending' call

        var this_7 = filtered._v;
        // Inline function 'kotlin.comparisons.compareByDescending' call

        var tmp_14 = ShoppingViewModel$applyFilters$lambda_3;
        var tmp$ret$38 = new sam$kotlin_Comparator$0_1(tmp_14);
        tmp_9 = sortedWith(this_7, tmp$ret$38);
        break;
      case 5:
        // Inline function 'kotlin.collections.sortedBy' call

        var this_8 = filtered._v;
        // Inline function 'kotlin.comparisons.compareBy' call

        var tmp_15 = ShoppingViewModel$applyFilters$lambda_4;
        var tmp$ret$40 = new sam$kotlin_Comparator$0_1(tmp_15);
        tmp_9 = sortedWith(this_8, tmp$ret$40);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    filtered._v = tmp_9;
    $this.x10k(ShoppingViewModel$applyFilters$lambda_5(filtered));
  }
  function sam$kotlin_Comparator$0_1(function_0) {
    this.a14t_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_1).ze = function (a, b) {
    return this.a14t_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).q3 = function () {
    return this.a14t_1;
  };
  protoOf(sam$kotlin_Comparator$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function ShoppingViewModel$observeConnection$slambda(this$0, resultContinuation) {
    this.j14t_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$observeConnection$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$observeConnection$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$observeConnection$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.j14t_1.b14s_1.y103();
            var action = ShoppingViewModel$observeConnection$slambda$slambda_0(this.j14t_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ShoppingViewModel$observeConnection$slambda).q24 = function ($this$launch, completion) {
    var i = new ShoppingViewModel$observeConnection$slambda(this.j14t_1, completion);
    i.k14t_1 = $this$launch;
    return i;
  };
  function ShoppingViewModel$observeConnection$slambda_0(this$0, resultContinuation) {
    var i = new ShoppingViewModel$observeConnection$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ShoppingViewModel$observeCart$slambda(this$0, resultContinuation) {
    this.t14t_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$observeCart$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$observeCart$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$observeCart$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.t14t_1.v14r_1.ynu();
            suspendResult = collectLatest(tmp_0, ShoppingViewModel$observeCart$slambda$slambda_0(this.t14t_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ShoppingViewModel$observeCart$slambda).q24 = function ($this$launch, completion) {
    var i = new ShoppingViewModel$observeCart$slambda(this.t14t_1, completion);
    i.u14t_1 = $this$launch;
    return i;
  };
  function ShoppingViewModel$observeCart$slambda_0(this$0, resultContinuation) {
    var i = new ShoppingViewModel$observeCart$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ShoppingViewModel$observeFavorites$slambda(this$0, resultContinuation) {
    this.d14u_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$observeFavorites$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$observeFavorites$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$observeFavorites$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.d14u_1.x14r_1.ynu();
            suspendResult = collectLatest(tmp_0, ShoppingViewModel$observeFavorites$slambda$slambda_0(this.d14u_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ShoppingViewModel$observeFavorites$slambda).q24 = function ($this$launch, completion) {
    var i = new ShoppingViewModel$observeFavorites$slambda(this.d14u_1, completion);
    i.e14u_1 = $this$launch;
    return i;
  };
  function ShoppingViewModel$observeFavorites$slambda_0(this$0, resultContinuation) {
    var i = new ShoppingViewModel$observeFavorites$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ShoppingViewModel$observeLanguage$slambda(this$0, resultContinuation) {
    this.n14u_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$observeLanguage$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$observeLanguage$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$observeLanguage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.n14u_1.u14r_1.y103();
            var action = ShoppingViewModel$observeLanguage$slambda$slambda_0(this.n14u_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ShoppingViewModel$observeLanguage$slambda).q24 = function ($this$launch, completion) {
    var i = new ShoppingViewModel$observeLanguage$slambda(this.n14u_1, completion);
    i.o14u_1 = $this$launch;
    return i;
  };
  function ShoppingViewModel$observeLanguage$slambda_0(this$0, resultContinuation) {
    var i = new ShoppingViewModel$observeLanguage$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ShoppingViewModel$observeAuthChanges$slambda(this$0, resultContinuation) {
    this.x14u_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$observeAuthChanges$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$observeAuthChanges$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$observeAuthChanges$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.x14u_1.w14r_1.ynu();
            var action = ShoppingViewModel$observeAuthChanges$slambda$slambda_0(this.x14u_1, null);
            this.n9_1 = 1;
            suspendResult = collectLatest(isInterface(tmp0, Flow) ? tmp0 : THROW_CCE(), action, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throw IllegalStateException_init_$Create$('SharedFlow never completes, this call should never return.');
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ShoppingViewModel$observeAuthChanges$slambda).q24 = function ($this$launch, completion) {
    var i = new ShoppingViewModel$observeAuthChanges$slambda(this.x14u_1, completion);
    i.y14u_1 = $this$launch;
    return i;
  };
  function ShoppingViewModel$observeAuthChanges$slambda_0(this$0, resultContinuation) {
    var i = new ShoppingViewModel$observeAuthChanges$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ShoppingViewModel$handleIntent$lambda($intent) {
    return function ($this$updateState) {
      return $this$updateState.t14n(VOID, VOID, $intent.u14n_1);
    };
  }
  function ShoppingViewModel$handleIntent$lambda_0($intent) {
    return function ($this$updateState) {
      return $this$updateState.t14n(VOID, VOID, VOID, $intent.v14n_1, $intent.w14n_1);
    };
  }
  function ShoppingViewModel$handleIntent$lambda_1($intent) {
    return function ($this$updateState) {
      return $this$updateState.t14n(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.x14n_1, $intent.y14n_1, $intent.z14n_1);
    };
  }
  function ShoppingViewModel$handleIntent$lambda_2($intent) {
    return function ($this$updateState) {
      return $this$updateState.t14n(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $intent.a14o_1, $intent.b14o_1, $intent.c14o_1, $intent.d14o_1);
    };
  }
  function ShoppingViewModel$handleIntent$lambda_3($intent) {
    return function ($this$updateState) {
      return $this$updateState.t14n(VOID, VOID, VOID, VOID, VOID, $intent.z14u_1);
    };
  }
  function ShoppingViewModel$handleIntent$lambda_4($intent) {
    return function ($this$updateState) {
      return $this$updateState.t14n(VOID, VOID, VOID, VOID, VOID, VOID, $intent.e14o_1);
    };
  }
  function ShoppingViewModel$handleIntent$slambda(this$0, $intent, resultContinuation) {
    this.i14v_1 = this$0;
    this.j14v_1 = $intent;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$handleIntent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$handleIntent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$handleIntent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.i14v_1.y14r_1.vdf(this.j14v_1.f14o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ShoppingViewModel$handleIntent$slambda).q24 = function ($this$launch, completion) {
    var i = new ShoppingViewModel$handleIntent$slambda(this.i14v_1, this.j14v_1, completion);
    i.k14v_1 = $this$launch;
    return i;
  };
  function ShoppingViewModel$handleIntent$slambda_0(this$0, $intent, resultContinuation) {
    var i = new ShoppingViewModel$handleIntent$slambda(this$0, $intent, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ShoppingViewModel$refreshData$slambda(this$0, resultContinuation) {
    this.t14v_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$refreshData$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$refreshData$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$refreshData$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            if (this.t14v_1.b14s_1.ynu()) {
              this.t14v_1.x10k(ShoppingViewModel$refreshData$slambda$lambda);
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = getString(get_no_internet_connection(string_instance), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = new ShowError_6(ARGUMENT);
            this.n9_1 = 2;
            suspendResult = this.t14v_1.d10l(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 10;
            continue $sm;
          case 3:
            this.o9_1 = 11;
            this.o9_1 = 6;
            this.n9_1 = 4;
            suspendResult = this.t14v_1.s14r_1.e102(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.n9_1 = 5;
            suspendResult = this.t14v_1.t14r_1.e102(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.o9_1 = 12;
            this.n9_1 = 9;
            continue $sm;
          case 6:
            this.o9_1 = 11;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var e = this.q9_1;
              this.n9_1 = 7;
              suspendResult = getString(get_unexpected_error(string_instance), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 7:
            var ARGUMENT_1 = suspendResult;
            var ARGUMENT_2 = new ShowError_6(ARGUMENT_1);
            this.n9_1 = 8;
            suspendResult = this.t14v_1.d10l(ARGUMENT_2, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.o9_1 = 12;
            this.n9_1 = 9;
            continue $sm;
          case 9:
            this.o9_1 = 12;
            this.t14v_1.x10k(ShoppingViewModel$refreshData$slambda$lambda_0);
            this.n9_1 = 10;
            continue $sm;
          case 10:
            return Unit_instance;
          case 11:
            this.o9_1 = 12;
            var t = this.q9_1;
            this.t14v_1.x10k(ShoppingViewModel$refreshData$slambda$lambda_0);
            throw t;
          case 12:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 12) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(ShoppingViewModel$refreshData$slambda).q24 = function ($this$launch, completion) {
    var i = new ShoppingViewModel$refreshData$slambda(this.t14v_1, completion);
    i.u14v_1 = $this$launch;
    return i;
  };
  function ShoppingViewModel$refreshData$slambda_0(this$0, resultContinuation) {
    var i = new ShoppingViewModel$refreshData$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ShoppingViewModel$loadProducts$slambda(this$0, resultContinuation) {
    this.d14w_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ShoppingViewModel$loadProducts$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ShoppingViewModel$loadProducts$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ShoppingViewModel$loadProducts$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.d14w_1.x10k(ShoppingViewModel$loadProducts$slambda$lambda);
            this.n9_1 = 1;
            var tmp_0 = this.d14w_1.s14r_1.ynu();
            var tmp_1 = this.d14w_1.t14r_1.ynu();
            var tmp_2 = combine(tmp_0, tmp_1, ShoppingViewModel$loadProducts$slambda$slambda_0(null));
            suspendResult = collectLatest(tmp_2, ShoppingViewModel$loadProducts$slambda$slambda_2(this.d14w_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ShoppingViewModel$loadProducts$slambda).q24 = function ($this$launch, completion) {
    var i = new ShoppingViewModel$loadProducts$slambda(this.d14w_1, completion);
    i.e14w_1 = $this$launch;
    return i;
  };
  function ShoppingViewModel$loadProducts$slambda_0(this$0, resultContinuation) {
    var i = new ShoppingViewModel$loadProducts$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ShoppingViewModel$applyFilters$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp0_elvis_lhs = a.szt_1;
    var tmp = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp0_elvis_lhs_0 = b.szt_1;
    var tmp$ret$2 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
    return compareValues(tmp, tmp$ret$2);
  }
  function ShoppingViewModel$applyFilters$lambda_0(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp0_elvis_lhs = b.szt_1;
    var tmp = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp0_elvis_lhs_0 = a.szt_1;
    var tmp$ret$2 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
    return compareValues(tmp, tmp$ret$2);
  }
  function ShoppingViewModel$applyFilters$lambda_1($currentState) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp;
      if ($currentState.h14n_1 === 'en') {
        var tmp0_elvis_lhs = a.ozt_1;
        tmp = tmp0_elvis_lhs == null ? a.pzt_1 : tmp0_elvis_lhs;
      } else {
        var tmp1_elvis_lhs = a.pzt_1;
        tmp = tmp1_elvis_lhs == null ? a.ozt_1 : tmp1_elvis_lhs;
      }
      var tmp2_elvis_lhs = tmp;
      var tmp_0 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
      var tmp_1;
      if ($currentState.h14n_1 === 'en') {
        var tmp0_elvis_lhs_0 = b.ozt_1;
        tmp_1 = tmp0_elvis_lhs_0 == null ? b.pzt_1 : tmp0_elvis_lhs_0;
      } else {
        var tmp1_elvis_lhs_0 = b.pzt_1;
        tmp_1 = tmp1_elvis_lhs_0 == null ? b.ozt_1 : tmp1_elvis_lhs_0;
      }
      var tmp2_elvis_lhs_0 = tmp_1;
      var tmp$ret$2 = tmp2_elvis_lhs_0 == null ? '' : tmp2_elvis_lhs_0;
      return compareValues(tmp_0, tmp$ret$2);
    };
  }
  function ShoppingViewModel$applyFilters$lambda_2($currentState) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp;
      if ($currentState.h14n_1 === 'en') {
        var tmp0_elvis_lhs = b.ozt_1;
        tmp = tmp0_elvis_lhs == null ? b.pzt_1 : tmp0_elvis_lhs;
      } else {
        var tmp1_elvis_lhs = b.pzt_1;
        tmp = tmp1_elvis_lhs == null ? b.ozt_1 : tmp1_elvis_lhs;
      }
      var tmp2_elvis_lhs = tmp;
      var tmp_0 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
      var tmp_1;
      if ($currentState.h14n_1 === 'en') {
        var tmp0_elvis_lhs_0 = a.ozt_1;
        tmp_1 = tmp0_elvis_lhs_0 == null ? a.pzt_1 : tmp0_elvis_lhs_0;
      } else {
        var tmp1_elvis_lhs_0 = a.pzt_1;
        tmp_1 = tmp1_elvis_lhs_0 == null ? a.ozt_1 : tmp1_elvis_lhs_0;
      }
      var tmp2_elvis_lhs_0 = tmp_1;
      var tmp$ret$2 = tmp2_elvis_lhs_0 == null ? '' : tmp2_elvis_lhs_0;
      return compareValues(tmp_0, tmp$ret$2);
    };
  }
  function ShoppingViewModel$applyFilters$lambda_3(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp0_elvis_lhs = b.zzt_1;
    var tmp = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    var tmp0_elvis_lhs_0 = a.zzt_1;
    var tmp$ret$2 = tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0;
    return compareValues(tmp, tmp$ret$2);
  }
  function ShoppingViewModel$applyFilters$lambda_4(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp0_elvis_lhs = a.zzt_1;
    var tmp = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    var tmp0_elvis_lhs_0 = b.zzt_1;
    var tmp$ret$2 = tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0;
    return compareValues(tmp, tmp$ret$2);
  }
  function ShoppingViewModel$applyFilters$lambda_5($filtered) {
    return function ($this$updateState) {
      return $this$updateState.t14n(VOID, $filtered._v);
    };
  }
  function ShoppingViewModel(getProductsUseCase, getBannersUseCase, getLanguageUseCase, getCartItemsUseCase, getCurrentUserUseCase, getFavoriteProductsUseCase, toggleFavoriteUseCase, syncFavoritesUseCase, setLanguageUseCase, isConnectedUseCase) {
    BaseMviViewModel.call(this, new ShoppingState());
    this.s14r_1 = getProductsUseCase;
    this.t14r_1 = getBannersUseCase;
    this.u14r_1 = getLanguageUseCase;
    this.v14r_1 = getCartItemsUseCase;
    this.w14r_1 = getCurrentUserUseCase;
    this.x14r_1 = getFavoriteProductsUseCase;
    this.y14r_1 = toggleFavoriteUseCase;
    this.z14r_1 = syncFavoritesUseCase;
    this.a14s_1 = setLanguageUseCase;
    this.b14s_1 = isConnectedUseCase;
    this.s10h().j10i(LoadProducts_instance);
    observeLanguage_10(this);
    observeAuthChanges(this);
    observeFavorites_0(this);
    observeCart_0(this);
    observeConnection(this);
  }
  protoOf(ShoppingViewModel).f14w = function (intent, $completion) {
    if (equals(intent, LoadProducts_instance)) {
      loadProducts(this);
    } else {
      if (intent instanceof SearchChanged) {
        this.x10k(ShoppingViewModel$handleIntent$lambda(intent));
        applyFilters(this);
      } else {
        if (intent instanceof PriceFilterChanged) {
          this.x10k(ShoppingViewModel$handleIntent$lambda_0(intent));
          applyFilters(this);
        } else {
          if (intent instanceof AgeFilterChanged) {
            this.x10k(ShoppingViewModel$handleIntent$lambda_1(intent));
            applyFilters(this);
          } else {
            if (intent instanceof CustomFilterChanged) {
              this.x10k(ShoppingViewModel$handleIntent$lambda_2(intent));
              applyFilters(this);
            } else {
              if (intent instanceof RatingFilterChanged) {
                this.x10k(ShoppingViewModel$handleIntent$lambda_3(intent));
                applyFilters(this);
              } else {
                if (intent instanceof SortOrderChanged) {
                  this.x10k(ShoppingViewModel$handleIntent$lambda_4(intent));
                  applyFilters(this);
                } else {
                  if (equals(intent, RefreshData_instance)) {
                    refreshData(this);
                  } else {
                    if (intent instanceof ToggleFavorite_4) {
                      var tmp = get_viewModelScope(this);
                      launch(tmp, VOID, VOID, ShoppingViewModel$handleIntent$slambda_0(this, intent, null));
                    } else {
                      if (equals(intent, ToggleLanguage_instance)) {
                        var newLang = this.s10h().ajg().u1().h14n_1 === 'en' ? 'ar' : 'en';
                        this.a14s_1.a104(newLang);
                      } else {
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return Unit_instance;
  };
  protoOf(ShoppingViewModel).f10l = function (intent, $completion) {
    return this.f14w(isInterface(intent, ShoppingIntent) ? intent : THROW_CCE(), $completion);
  };
  function get_RedPrimary() {
    _init_properties_Color_kt__6h0l1r();
    return RedPrimary;
  }
  var RedPrimary;
  function get_RedDark() {
    _init_properties_Color_kt__6h0l1r();
    return RedDark;
  }
  var RedDark;
  function get_RedLight() {
    _init_properties_Color_kt__6h0l1r();
    return RedLight;
  }
  var RedLight;
  function get_BlueGradientStart() {
    _init_properties_Color_kt__6h0l1r();
    return BlueGradientStart;
  }
  var BlueGradientStart;
  function get_BlueGradientEnd() {
    _init_properties_Color_kt__6h0l1r();
    return BlueGradientEnd;
  }
  var BlueGradientEnd;
  function get_PinkGradientStart() {
    _init_properties_Color_kt__6h0l1r();
    return PinkGradientStart;
  }
  var PinkGradientStart;
  function get_PinkGradientEnd() {
    _init_properties_Color_kt__6h0l1r();
    return PinkGradientEnd;
  }
  var PinkGradientEnd;
  function get_BackgroundNeutral() {
    _init_properties_Color_kt__6h0l1r();
    return BackgroundNeutral;
  }
  var BackgroundNeutral;
  function get_SurfaceNeutral() {
    _init_properties_Color_kt__6h0l1r();
    return SurfaceNeutral;
  }
  var SurfaceNeutral;
  function get_TextPrimary() {
    _init_properties_Color_kt__6h0l1r();
    return TextPrimary;
  }
  var TextPrimary;
  function get_TextSecondary() {
    _init_properties_Color_kt__6h0l1r();
    return TextSecondary;
  }
  var TextSecondary;
  function get_GrayLight() {
    _init_properties_Color_kt__6h0l1r();
    return GrayLight;
  }
  var GrayLight;
  function get_BackgroundDark() {
    _init_properties_Color_kt__6h0l1r();
    return BackgroundDark;
  }
  var BackgroundDark;
  function get_SurfaceDark() {
    _init_properties_Color_kt__6h0l1r();
    return SurfaceDark;
  }
  var SurfaceDark;
  function get_TextPrimaryDark() {
    _init_properties_Color_kt__6h0l1r();
    return TextPrimaryDark;
  }
  var TextPrimaryDark;
  function get_TextSecondaryDark() {
    _init_properties_Color_kt__6h0l1r();
    return TextSecondaryDark;
  }
  var TextSecondaryDark;
  function get_GrayDark() {
    _init_properties_Color_kt__6h0l1r();
    return GrayDark;
  }
  var GrayDark;
  var properties_initialized_Color_kt_bdybnx;
  function _init_properties_Color_kt__6h0l1r() {
    if (!properties_initialized_Color_kt_bdybnx) {
      properties_initialized_Color_kt_bdybnx = true;
      RedPrimary = Color(new Long(-1689274, 0));
      RedDark = Color(new Long(-4124129, 0));
      RedLight = Color(new Long(-38037, 0));
      BlueGradientStart = Color(new Long(-16730917, 0));
      BlueGradientEnd = Color(new Long(-16743504, 0));
      PinkGradientStart = Color(new Long(-25954, 0));
      PinkGradientEnd = Color(new Long(-77841, 0));
      BackgroundNeutral = Color(new Long(-460294, 0));
      SurfaceNeutral = Color(new Long(-1, 0));
      TextPrimary = Color(new Long(-13947582, 0));
      TextSecondary = Color(new Long(-7497298, 0));
      GrayLight = Color(new Long(-1182988, 0));
      BackgroundDark = Color(new Long(-15592942, 0));
      SurfaceDark = Color(new Long(-14803426, 0));
      TextPrimaryDark = Color(new Long(-1182988, 0));
      TextSecondaryDark = Color(new Long(-7497298, 0));
      GrayDark = Color(new Long(-13947582, 0));
    }
  }
  function get_LightColorScheme() {
    _init_properties_Theme_kt__w31tqv();
    return LightColorScheme;
  }
  var LightColorScheme;
  function get_DarkColorScheme() {
    _init_properties_Theme_kt__w31tqv();
    return DarkColorScheme;
  }
  var DarkColorScheme;
  function HadayaTheme(darkTheme, language, content, $composer, $changed, $default) {
    _init_properties_Theme_kt__w31tqv();
    var darkTheme_0 = {_v: darkTheme};
    var language_0 = {_v: language};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(260128011);
    sourceInformation($composer_0, 'C(HadayaTheme)P(1,2)48@1609L23,50@1714L146,50@1642L218:Theme.kt#ufjm3h');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | (($default & 1) === 0 && $composer_0.l31(darkTheme_0._v) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(language_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      $composer_0.q30();
      sourceInformation($composer_0, '42@1328L21');
      if (($changed & 1) === 0 || $composer_0.j30()) {
        if (!(($default & 1) === 0)) {
          darkTheme_0._v = isSystemInDarkTheme($composer_0, 0);
          $dirty = $dirty & -15;
        }
        if (!(($default & 2) === 0)) {
          language_0._v = 'en';
        }
      } else {
        $composer_0.z30();
        if (!(($default & 1) === 0))
          $dirty = $dirty & -15;
      }
      $composer_0.r30();
      if (isTraceInProgress()) {
        traceEventStart(260128011, $dirty, -1, 'client.fstech.hadaya.presentation.theme.HadayaTheme (Theme.kt:45)');
      }
      var layoutDirection = language_0._v === 'ar' ? LayoutDirection_Rtl_getInstance() : LayoutDirection_Ltr_getInstance();
      var colorScheme = darkTheme_0._v ? get_DarkColorScheme() : get_LightColorScheme();
      var typography = getTypography(language_0._v, $composer_0, 14 & $dirty >> 3);
      var tmp = get_LocalLayoutDirection().h3c(layoutDirection);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(1012068811, true, HadayaTheme$lambda(colorScheme, typography, content), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_1.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp$ret$0 = tmp_0;
      CompositionLocalProvider(tmp, tmp$ret$0, $composer_0, 48 | androidx_compose_runtime_ProvidedValue$stableprop_getter());
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(HadayaTheme$lambda_0(darkTheme_0, language_0, content, $changed, $default));
    }
  }
  function HadayaTheme$lambda($colorScheme, $typography, $content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C51@1724L130:Theme.kt#ufjm3h');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(1012068811, $changed, -1, 'client.fstech.hadaya.presentation.theme.HadayaTheme.<anonymous> (Theme.kt:51)');
        }
        MaterialTheme($colorScheme, null, $typography, $content, $composer_0, 0, 2);
        var tmp_0;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HadayaTheme$lambda_0($darkTheme, $language, $content, $$changed, $$default) {
    return function ($composer, $force) {
      HadayaTheme($darkTheme._v, $language._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var properties_initialized_Theme_kt_uwj6hl;
  function _init_properties_Theme_kt__w31tqv() {
    if (!properties_initialized_Theme_kt_uwj6hl) {
      properties_initialized_Theme_kt_uwj6hl = true;
      var tmp0_primary = get_RedPrimary();
      var tmp1_onPrimary = Companion_getInstance_14().m6b_1;
      var tmp2_secondary = get_RedLight();
      var tmp3_onSecondary = Companion_getInstance_14().m6b_1;
      var tmp4_tertiary = get_RedDark();
      var tmp5_background = get_BackgroundNeutral();
      var tmp6_surface = get_SurfaceNeutral();
      var tmp7_onBackground = get_TextPrimary();
      var tmp8_onSurface = get_TextPrimary();
      var tmp9_surfaceVariant = get_GrayLight();
      var tmp10_onSurfaceVariant = get_TextSecondary();
      LightColorScheme = lightColorScheme(tmp0_primary, tmp1_onPrimary, VOID, VOID, VOID, tmp2_secondary, tmp3_onSecondary, VOID, VOID, tmp4_tertiary, VOID, VOID, VOID, tmp5_background, tmp7_onBackground, tmp6_surface, tmp8_onSurface, tmp9_surfaceVariant, tmp10_onSurfaceVariant);
      var tmp0_primary_0 = get_RedPrimary();
      var tmp1_onPrimary_0 = Companion_getInstance_14().m6b_1;
      var tmp2_secondary_0 = get_RedLight();
      var tmp3_onSecondary_0 = Companion_getInstance_14().m6b_1;
      var tmp4_tertiary_0 = get_RedDark();
      var tmp5_background_0 = get_BackgroundDark();
      var tmp6_surface_0 = get_SurfaceDark();
      var tmp7_onBackground_0 = get_TextPrimaryDark();
      var tmp8_onSurface_0 = get_TextPrimaryDark();
      var tmp9_surfaceVariant_0 = get_GrayDark();
      var tmp10_onSurfaceVariant_0 = get_TextSecondaryDark();
      DarkColorScheme = darkColorScheme(tmp0_primary_0, tmp1_onPrimary_0, VOID, VOID, VOID, tmp2_secondary_0, tmp3_onSecondary_0, VOID, VOID, tmp4_tertiary_0, VOID, VOID, VOID, tmp5_background_0, tmp7_onBackground_0, tmp6_surface_0, tmp8_onSurface_0, tmp9_surfaceVariant_0, tmp10_onSurfaceVariant_0);
    }
  }
  function getTypography(language, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 439411160, 'C(getTypography)103@2742L20,106@2850L3566:Type.kt#ufjm3h');
    if (isTraceInProgress()) {
      traceEventStart(439411160, $changed, -1, 'client.fstech.hadaya.presentation.theme.getTypography (Type.kt:101)');
    }
    var isArabic = language === 'ar';
    var fontFamily = getCairoFontFamily($composer_0, 0);
    var direction = isArabic ? Companion_getInstance_29().q7u_1 : Companion_getInstance_29().p7u_1;
    sourceInformationMarkerStart($composer_0, 1367340230, 'CC(remember):Type.kt#9igjgp');
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!($composer_0.k31(fontFamily) | $composer_0.m31(_TextDirection___get_value__impl__ka7r45(direction)));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var tmp0_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp1_fontSize = get_sp(32);
      var tmp2_lineHeight = get_sp(40);
      var tmp3_letterSpacing = get_sp(0);
      var tmp_0 = TextStyle_init_$Create$(VOID, tmp1_fontSize, tmp0_fontWeight, VOID, VOID, fontFamily, VOID, tmp3_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, direction, tmp2_lineHeight);
      var tmp4_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp5_fontSize = get_sp(28);
      var tmp6_lineHeight = get_sp(36);
      var tmp7_letterSpacing = get_sp(0);
      var tmp_1 = TextStyle_init_$Create$(VOID, tmp5_fontSize, tmp4_fontWeight, VOID, VOID, fontFamily, VOID, tmp7_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, direction, tmp6_lineHeight);
      var tmp8_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp9_fontSize = get_sp(24);
      var tmp10_lineHeight = get_sp(32);
      var tmp11_letterSpacing = get_sp(0);
      var tmp_2 = TextStyle_init_$Create$(VOID, tmp9_fontSize, tmp8_fontWeight, VOID, VOID, fontFamily, VOID, tmp11_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, direction, tmp10_lineHeight);
      var tmp12_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp13_fontSize = get_sp(22);
      var tmp14_lineHeight = get_sp(28);
      var tmp15_letterSpacing = get_sp(0);
      var tmp_3 = TextStyle_init_$Create$(VOID, tmp13_fontSize, tmp12_fontWeight, VOID, VOID, fontFamily, VOID, tmp15_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, direction, tmp14_lineHeight);
      var tmp16_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp17_fontSize = get_sp(18);
      var tmp18_lineHeight = get_sp(24);
      var tmp19_letterSpacing = get_sp_0(0.15);
      var tmp_4 = TextStyle_init_$Create$(VOID, tmp17_fontSize, tmp16_fontWeight, VOID, VOID, fontFamily, VOID, tmp19_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, direction, tmp18_lineHeight);
      var tmp20_fontWeight = Companion_getInstance_16().c7z_1;
      var tmp21_fontSize = get_sp(14);
      var tmp22_lineHeight = get_sp(20);
      var tmp23_letterSpacing = get_sp_0(0.1);
      var tmp_5 = TextStyle_init_$Create$(VOID, tmp21_fontSize, tmp20_fontWeight, VOID, VOID, fontFamily, VOID, tmp23_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, direction, tmp22_lineHeight);
      var tmp24_fontWeight = Companion_getInstance_16().b7z_1;
      var tmp25_fontSize = get_sp(16);
      var tmp26_lineHeight = get_sp(24);
      var tmp27_letterSpacing = get_sp_0(0.5);
      var tmp_6 = TextStyle_init_$Create$(VOID, tmp25_fontSize, tmp24_fontWeight, VOID, VOID, fontFamily, VOID, tmp27_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, direction, tmp26_lineHeight);
      var tmp28_fontWeight = Companion_getInstance_16().b7z_1;
      var tmp29_fontSize = get_sp(14);
      var tmp30_lineHeight = get_sp(20);
      var tmp31_letterSpacing = get_sp_0(0.25);
      var tmp_7 = TextStyle_init_$Create$(VOID, tmp29_fontSize, tmp28_fontWeight, VOID, VOID, fontFamily, VOID, tmp31_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, direction, tmp30_lineHeight);
      var tmp32_fontWeight = Companion_getInstance_16().b7z_1;
      var tmp33_fontSize = get_sp(12);
      var tmp34_lineHeight = get_sp(16);
      var tmp35_letterSpacing = get_sp_0(0.4);
      var tmp_8 = TextStyle_init_$Create$(VOID, tmp33_fontSize, tmp32_fontWeight, VOID, VOID, fontFamily, VOID, tmp35_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, direction, tmp34_lineHeight);
      var tmp36_fontWeight = Companion_getInstance_16().c7z_1;
      var tmp37_fontSize = get_sp(14);
      var tmp38_lineHeight = get_sp(20);
      var tmp39_letterSpacing = get_sp_0(0.1);
      var tmp_9 = TextStyle_init_$Create$(VOID, tmp37_fontSize, tmp36_fontWeight, VOID, VOID, fontFamily, VOID, tmp39_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, direction, tmp38_lineHeight);
      var tmp40_fontWeight = Companion_getInstance_16().c7z_1;
      var tmp41_fontSize = get_sp(12);
      var tmp42_lineHeight = get_sp(16);
      var tmp43_letterSpacing = get_sp_0(0.5);
      var tmp_10 = TextStyle_init_$Create$(VOID, tmp41_fontSize, tmp40_fontWeight, VOID, VOID, fontFamily, VOID, tmp43_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, direction, tmp42_lineHeight);
      var tmp44_fontWeight = Companion_getInstance_16().c7z_1;
      var tmp45_fontSize = get_sp(11);
      var tmp46_lineHeight = get_sp(16);
      var tmp47_letterSpacing = get_sp_0(0.5);
      var value = Typography_init_$Create$(VOID, VOID, VOID, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, TextStyle_init_$Create$(VOID, tmp45_fontSize, tmp44_fontWeight, VOID, VOID, fontFamily, VOID, tmp47_letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, direction, tmp46_lineHeight));
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp1_group = tmp;
    sourceInformationMarkerEnd($composer_0);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp1_group;
  }
  function getCairoFontFamily($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 1423533063, 'C(getCairoFontFamily)31@881L47,32@938L42,33@990L14:Type.kt#ufjm3h');
    if (isTraceInProgress()) {
      traceEventStart(1423533063, $changed, -1, 'client.fstech.hadaya.presentation.theme.getCairoFontFamily (Type.kt:29)');
    }
    var tmp = get_cairo_regular(font_instance);
    var tmp_0 = Companion_getInstance_16().b7z_1;
    var tmp_1 = _FontStyle___init__impl__jcnduf(0);
    var tmp_2 = Font(tmp, tmp_0, tmp_1, null, $composer_0, 48, 12);
    var tmp_3 = get_cairo_bold(font_instance);
    var tmp_4 = Companion_getInstance_16().e7z_1;
    var tmp_5 = _FontStyle___init__impl__jcnduf(0);
    var tmp0 = FontFamily([tmp_2, Font(tmp_3, tmp_4, tmp_5, null, $composer_0, 48, 12), getEmojiFont($composer_0, 0)]);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function getEmojiFont($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, -294617135, 'C(getEmojiFont)25@745L50:Type.kt#ufjm3h');
    if (isTraceInProgress()) {
      traceEventStart(-294617135, $changed, -1, 'client.fstech.hadaya.presentation.theme.getEmojiFont (Type.kt:24)');
    }
    var tmp = get_noto_color_emoji(font_instance);
    var tmp_0 = Companion_getInstance_16().b7z_1;
    var tmp_1 = _FontStyle___init__impl__jcnduf(0);
    var tmp0 = Font(tmp, tmp_0, tmp_1, null, $composer_0, 48, 12);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function getTajawalFontFamily($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 1750704785, 'C(getTajawalFontFamily)40@1099L49,41@1158L44,42@1212L14:Type.kt#ufjm3h');
    if (isTraceInProgress()) {
      traceEventStart(1750704785, $changed, -1, 'client.fstech.hadaya.presentation.theme.getTajawalFontFamily (Type.kt:38)');
    }
    var tmp = get_tajawal_regular(font_instance);
    var tmp_0 = Companion_getInstance_16().b7z_1;
    var tmp_1 = _FontStyle___init__impl__jcnduf(0);
    var tmp_2 = Font(tmp, tmp_0, tmp_1, null, $composer_0, 48, 12);
    var tmp_3 = get_tajawal_bold(font_instance);
    var tmp_4 = Companion_getInstance_16().e7z_1;
    var tmp_5 = _FontStyle___init__impl__jcnduf(0);
    var tmp0 = FontFamily([tmp_2, Font(tmp_3, tmp_4, tmp_5, null, $composer_0, 48, 12), getEmojiFont($composer_0, 0)]);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function getAlmaraiFontFamily($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 2033663028, 'C(getAlmaraiFontFamily)49@1321L49,50@1380L44,51@1434L14:Type.kt#ufjm3h');
    if (isTraceInProgress()) {
      traceEventStart(2033663028, $changed, -1, 'client.fstech.hadaya.presentation.theme.getAlmaraiFontFamily (Type.kt:47)');
    }
    var tmp = get_almarai_regular(font_instance);
    var tmp_0 = Companion_getInstance_16().b7z_1;
    var tmp_1 = _FontStyle___init__impl__jcnduf(0);
    var tmp_2 = Font(tmp, tmp_0, tmp_1, null, $composer_0, 48, 12);
    var tmp_3 = get_almarai_bold(font_instance);
    var tmp_4 = Companion_getInstance_16().e7z_1;
    var tmp_5 = _FontStyle___init__impl__jcnduf(0);
    var tmp0 = FontFamily([tmp_2, Font(tmp_3, tmp_4, tmp_5, null, $composer_0, 48, 12), getEmojiFont($composer_0, 0)]);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function getAmiriFontFamily($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 1794406683, 'C(getAmiriFontFamily)58@1541L47,59@1598L42,60@1650L14:Type.kt#ufjm3h');
    if (isTraceInProgress()) {
      traceEventStart(1794406683, $changed, -1, 'client.fstech.hadaya.presentation.theme.getAmiriFontFamily (Type.kt:56)');
    }
    var tmp = get_amiri_regular(font_instance);
    var tmp_0 = Companion_getInstance_16().b7z_1;
    var tmp_1 = _FontStyle___init__impl__jcnduf(0);
    var tmp_2 = Font(tmp, tmp_0, tmp_1, null, $composer_0, 48, 12);
    var tmp_3 = get_amiri_bold(font_instance);
    var tmp_4 = Companion_getInstance_16().e7z_1;
    var tmp_5 = _FontStyle___init__impl__jcnduf(0);
    var tmp0 = FontFamily([tmp_2, Font(tmp_3, tmp_4, tmp_5, null, $composer_0, 48, 12), getEmojiFont($composer_0, 0)]);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function getVazirmatnFontFamily($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 302350313, 'C(getVazirmatnFontFamily)67@1761L51,68@1822L46,69@1878L14:Type.kt#ufjm3h');
    if (isTraceInProgress()) {
      traceEventStart(302350313, $changed, -1, 'client.fstech.hadaya.presentation.theme.getVazirmatnFontFamily (Type.kt:65)');
    }
    var tmp = get_vazirmatn_regular(font_instance);
    var tmp_0 = Companion_getInstance_16().b7z_1;
    var tmp_1 = _FontStyle___init__impl__jcnduf(0);
    var tmp_2 = Font(tmp, tmp_0, tmp_1, null, $composer_0, 48, 12);
    var tmp_3 = get_vazirmatn_bold(font_instance);
    var tmp_4 = Companion_getInstance_16().e7z_1;
    var tmp_5 = _FontStyle___init__impl__jcnduf(0);
    var tmp0 = FontFamily([tmp_2, Font(tmp_3, tmp_4, tmp_5, null, $composer_0, 48, 12), getEmojiFont($composer_0, 0)]);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function getReadexProFontFamily($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 1810563755, 'C(getReadexProFontFamily)76@1989L52,77@2051L47,78@2108L14:Type.kt#ufjm3h');
    if (isTraceInProgress()) {
      traceEventStart(1810563755, $changed, -1, 'client.fstech.hadaya.presentation.theme.getReadexProFontFamily (Type.kt:74)');
    }
    var tmp = get_readex_pro_regular(font_instance);
    var tmp_0 = Companion_getInstance_16().b7z_1;
    var tmp_1 = _FontStyle___init__impl__jcnduf(0);
    var tmp_2 = Font(tmp, tmp_0, tmp_1, null, $composer_0, 48, 12);
    var tmp_3 = get_readex_pro_bold(font_instance);
    var tmp_4 = Companion_getInstance_16().e7z_1;
    var tmp_5 = _FontStyle___init__impl__jcnduf(0);
    var tmp0 = FontFamily([tmp_2, Font(tmp_3, tmp_4, tmp_5, null, $composer_0, 48, 12), getEmojiFont($composer_0, 0)]);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function getNotoSansFontFamily($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 1094777968, 'C(getNotoSansFontFamily)85@2218L58,86@2286L53,87@2349L14:Type.kt#ufjm3h');
    if (isTraceInProgress()) {
      traceEventStart(1094777968, $changed, -1, 'client.fstech.hadaya.presentation.theme.getNotoSansFontFamily (Type.kt:83)');
    }
    var tmp = get_noto_sans_arabic_regular(font_instance);
    var tmp_0 = Companion_getInstance_16().b7z_1;
    var tmp_1 = _FontStyle___init__impl__jcnduf(0);
    var tmp_2 = Font(tmp, tmp_0, tmp_1, null, $composer_0, 48, 12);
    var tmp_3 = get_noto_sans_arabic_bold(font_instance);
    var tmp_4 = Companion_getInstance_16().e7z_1;
    var tmp_5 = _FontStyle___init__impl__jcnduf(0);
    var tmp0 = FontFamily([tmp_2, Font(tmp_3, tmp_4, tmp_5, null, $composer_0, 48, 12), getEmojiFont($composer_0, 0)]);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function getIBMPlexFontFamily($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, -984486996, 'C(getIBMPlexFontFamily)94@2458L62,95@2530L57,96@2597L14:Type.kt#ufjm3h');
    if (isTraceInProgress()) {
      traceEventStart(-984486996, $changed, -1, 'client.fstech.hadaya.presentation.theme.getIBMPlexFontFamily (Type.kt:92)');
    }
    var tmp = get_ibm_plex_sans_arabic_regular(font_instance);
    var tmp_0 = Companion_getInstance_16().b7z_1;
    var tmp_1 = _FontStyle___init__impl__jcnduf(0);
    var tmp_2 = Font(tmp, tmp_0, tmp_1, null, $composer_0, 48, 12);
    var tmp_3 = get_ibm_plex_sans_arabic_bold(font_instance);
    var tmp_4 = Companion_getInstance_16().e7z_1;
    var tmp_5 = _FontStyle___init__impl__jcnduf(0);
    var tmp0 = FontFamily([tmp_2, Font(tmp_3, tmp_4, tmp_5, null, $composer_0, 48, 12), getEmojiFont($composer_0, 0)]);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function getEmojiFontFamily($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, -1622163639, 'C(getEmojiFontFamily)20@676L14:Type.kt#ufjm3h');
    if (isTraceInProgress()) {
      traceEventStart(-1622163639, $changed, -1, 'client.fstech.hadaya.presentation.theme.getEmojiFontFamily (Type.kt:19)');
    }
    var tmp0 = FontFamily([getEmojiFont($composer_0, 0)]);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  function UpdateScreen($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1873830627);
    sourceInformation($composer_0, 'C(UpdateScreen)36@1627L7,39@1714L11,40@1743L2424,38@1640L2527:UpdateScreen.kt#kkuf05');
    if ($composer_0.r31(!($changed === 0), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(1873830627, $changed, -1, 'client.fstech.hadaya.presentation.update.UpdateScreen (UpdateScreen.kt:35)');
      }
      var tmp0 = get_LocalUriHandler();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var uriHandler = $composer_1.u31(tmp0);
      var tmp = fillMaxSize(Companion_instance);
      var tmp_0 = MaterialTheme_instance.unz($composer_0, 6).ko0_1;
      var tmp_1 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_2 = _Dp___init__impl__ms3zkb(0.0);
      var tmp_3 = _Dp___init__impl__ms3zkb(0.0);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-2042787224, true, UpdateScreen$lambda(uriHandler), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_2.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it = $composer_2.i31();
      var tmp_4;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_2.j31(value);
        tmp_4 = value;
      } else {
        tmp_4 = it;
      }
      var tmp$ret$1 = tmp_4;
      Surface(tmp, null, tmp_0, tmp_1, tmp_2, tmp_3, null, tmp$ret$1, $composer_0, 12582918, 122);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(UpdateScreen$lambda_0($changed));
    }
  }
  function ComposableSingletons$UpdateScreenKt$lambda$_1571872172$lambda_ipymst($this$Button, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformation($composer_0, 'C92@3932L41,93@4021L10,91@3895L224:UpdateScreen.kt#kkuf05');
    if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(-1571872172, $changed, -1, 'client.fstech.hadaya.presentation.update.ComposableSingletons$UpdateScreenKt.lambda$-1571872172.<anonymous> (UpdateScreen.kt:91)');
      }
      var tmp0_text = stringResource(get_update_app_btn(string_instance), $composer_0, 0);
      var tmp1_style = MaterialTheme_instance.jog($composer_0, 6).mof_1;
      var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
      var tmp = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_0 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextOverflow___init__impl__obguoe(0);
      Text(tmp0_text, null, tmp, null, tmp_0, null, tmp2_fontWeight, null, tmp_1, null, null, tmp_2, tmp_3, false, 0, 0, null, tmp1_style, $composer_0, 1572864, 0, 131006);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$UpdateScreenKt() {
    ComposableSingletons$UpdateScreenKt_instance = this;
    var tmp = this;
    tmp.g14w_1 = ComposableLambda$invoke$ref_1(composableLambdaInstance(-1571872172, false, ComposableSingletons$UpdateScreenKt$lambda$_1571872172$lambda_ipymst));
  }
  var ComposableSingletons$UpdateScreenKt_instance;
  function ComposableSingletons$UpdateScreenKt_getInstance() {
    if (ComposableSingletons$UpdateScreenKt_instance == null)
      new ComposableSingletons$UpdateScreenKt();
    return ComposableSingletons$UpdateScreenKt_instance;
  }
  function UpdateScreen$lambda$lambda($uriHandler) {
    return function () {
      var platform = getPlatform().m();
      var tmp;
      if (contains(platform, 'Android', true)) {
        tmp = 'https://play.google.com/store/apps/details?id=client.fstech.hadaya';
      } else {
        tmp = 'https://apps.apple.com/app/idYOUR_APP_ID';
      }
      var url = tmp;
      $uriHandler.qdd(url);
      return Unit_instance;
    };
  }
  function UpdateScreen$lambda($uriHandler) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      sourceInformation($composer_0, 'C41@1753L2408:UpdateScreen.kt#kkuf05');
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        if (isTraceInProgress()) {
          traceEventStart(-2042787224, $changed, -1, 'client.fstech.hadaya.presentation.update.UpdateScreen.<anonymous> (UpdateScreen.kt:41)');
        }
        // Inline function 'androidx.compose.foundation.layout.Box' call
        var modifier = fillMaxSize(Companion_instance);
        var contentAlignment = Companion_getInstance_11().o8t_1;
        var propagateMinConstraints = false;
        var $composer_1 = $composer_0;
        if (!((4 & 1) === 0))
          modifier = Companion_instance;
        if (!((4 & 2) === 0))
          contentAlignment = Companion_getInstance_11().k8t_1;
        if (!((4 & 4) === 0))
          propagateMinConstraints = false;
        var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_0 = modifier;
        var $composer_2 = $composer_1;
        if (!((0 & 2) === 0))
          modifier_0 = Companion_instance;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var localMap = $composer_2.t31();
        var materialized = materialize($composer_2, modifier_0);
        var tmp0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_3 = $composer_2;
        var tmp_0 = $composer_3.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(tmp0);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
        var $composer_4 = $composer_3;
        var $composer_5 = $composer_4;
        sourceInformationMarkerStart($composer_5, 1399760273, 'C42@1843L2308:UpdateScreen.kt#kkuf05');
        var tmp_1 = fillMaxSize(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$6 = _Dp___init__impl__ms3zkb(600);
        var tmp_2 = widthIn(tmp_1, VOID, tmp$ret$6);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$7 = _Dp___init__impl__ms3zkb(24);
        var tmp0_modifier = padding_0(tmp_2, tmp$ret$7);
        var tmp1_horizontalAlignment = Companion_getInstance_11().x8t_1;
        // Inline function 'androidx.compose.foundation.layout.Column' call
        var modifier_1 = tmp0_modifier;
        var verticalArrangement = Arrangement_getInstance().udp_1;
        var horizontalAlignment = tmp1_horizontalAlignment;
        var $composer_6 = $composer_5;
        if (!((0 & 1) === 0))
          modifier_1 = Companion_instance;
        if (!((0 & 2) === 0))
          verticalArrangement = Arrangement_getInstance().sdp_1;
        if (!((0 & 4) === 0))
          horizontalAlignment = Companion_getInstance_11().w8t_1;
        var measurePolicy_0 = columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer_6, 14 & 438 >> 3 | 112 & 438 >> 3);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier_2 = modifier_1;
        var $composer_7 = $composer_6;
        if (!((0 & 2) === 0))
          modifier_2 = Companion_instance;
        var compositeKeyHash_0 = get_currentCompositeKeyHashCode($composer_7, 0).hashCode();
        var localMap_0 = $composer_7.t31();
        var materialized_0 = materialize($composer_7, modifier_2);
        var tmp0_0 = Companion_getInstance_12().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $composer_8 = $composer_7;
        var tmp_3 = $composer_8.g30();
        if (!isInterface(tmp_3, Applier)) {
          invalidApplier();
        }
        $composer_8.b31();
        if ($composer_8.h30()) {
          $composer_8.c31(tmp0_0);
        } else {
          $composer_8.d31();
        }
        var $this$ReusableComposeNode_0 = _Updater___init__impl__rbfxm8($composer_8);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, measurePolicy_0, Companion_getInstance_12().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, localMap_0, Companion_getInstance_12().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, compositeKeyHash_0, Companion_getInstance_12().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode_0, Companion_getInstance_12().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode_0, materialized_0, Companion_getInstance_12().qah_1);
        var $composer_9 = $composer_8;
        var $composer_10 = $composer_9;
        sourceInformationMarkerStart($composer_10, 1466573925, 'C54@2369L11,50@2159L247,57@2424L41,60@2516L43,61@2603L10,59@2483L263,66@2764L41,69@2856L42,70@2942L10,68@2823L287,76@3128L41,79@3225L502,89@3841L6,78@3187L950:UpdateScreen.kt#kkuf05');
        var tmp_4 = get_SystemUpdate(Icons_getInstance().dxv_1);
        var tmp_5 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$14 = _Dp___init__impl__ms3zkb(100);
        Icon(tmp_4, null, size(tmp_5, tmp$ret$14), MaterialTheme_instance.unz($composer_10, 6).xnz_1, $composer_10, 432, 0);
        var tmp_6 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$15 = _Dp___init__impl__ms3zkb(32);
        Spacer(height(tmp_6, tmp$ret$15), $composer_10, 6);
        var tmp0_text = stringResource(get_update_app_title(string_instance), $composer_10, 0);
        var tmp1_style = MaterialTheme_instance.jog($composer_10, 6).jof_1;
        var tmp2_fontWeight = Companion_getInstance_16().e7z_1;
        var tmp3_textAlign = Companion_getInstance_15().d7v_1;
        var tmp_7 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
        var tmp_8 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_9 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_10 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_11 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp0_text, null, tmp_7, null, tmp_8, null, tmp2_fontWeight, null, tmp_9, null, tmp3_textAlign, tmp_10, tmp_11, false, 0, 0, null, tmp1_style, $composer_10, 1572864, 0, 129982);
        var tmp_12 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$16 = _Dp___init__impl__ms3zkb(16);
        Spacer(height(tmp_12, tmp$ret$16), $composer_10, 6);
        var tmp4_text = stringResource(get_update_app_desc(string_instance), $composer_10, 0);
        var tmp5_style = MaterialTheme_instance.jog($composer_10, 6).oof_1;
        var tmp6_color = Companion_getInstance_14().k6b_1;
        var tmp7_textAlign = Companion_getInstance_15().d7v_1;
        var tmp8_lineHeight = get_sp(24);
        var tmp_13 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_14 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
        var tmp_15 = _TextOverflow___init__impl__obguoe(0);
        Text(tmp4_text, null, tmp6_color, null, tmp_13, null, null, null, tmp_14, null, tmp7_textAlign, tmp8_lineHeight, tmp_15, false, 0, 0, null, tmp5_style, $composer_10, 384, 48, 127994);
        var tmp_16 = Companion_instance;
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$17 = _Dp___init__impl__ms3zkb(48);
        Spacer(height(tmp_16, tmp$ret$17), $composer_10, 6);
        sourceInformationMarkerStart($composer_10, 1987004122, 'CC(remember):UpdateScreen.kt#9igjgp');
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_10.q31($uriHandler);
        // Inline function 'kotlin.let' call
        var it = $composer_10.i31();
        var tmp_17;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = UpdateScreen$lambda$lambda($uriHandler);
          $composer_10.j31(value);
          tmp_17 = value;
        } else {
          tmp_17 = it;
        }
        var tmp0_group = tmp_17;
        sourceInformationMarkerEnd($composer_10);
        var tmp_18 = fillMaxWidth(Companion_instance);
        // Inline function 'androidx.compose.ui.unit.dp' call
        var tmp$ret$22 = _Dp___init__impl__ms3zkb(56);
        var tmp_19 = height(tmp_18, tmp$ret$22);
        var tmp_20 = MaterialTheme_instance.epk($composer_10, 6).tq8_1;
        Button(tmp0_group, tmp_19, false, tmp_20, null, null, null, null, null, ComposableSingletons$UpdateScreenKt_getInstance().g14w_1, $composer_10, 805306416, 500);
        sourceInformationMarkerEnd($composer_10);
        $composer_8.e31();
        sourceInformationMarkerEnd($composer_5);
        $composer_3.e31();
        var tmp_21;
        if (isTraceInProgress()) {
          traceEventEnd();
          tmp_21 = Unit_instance;
        }
        tmp = tmp_21;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function UpdateScreen$lambda_0($$changed) {
    return function ($composer, $force) {
      UpdateScreen($composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function toNativeByteArray(_this__u8e3s4) {
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.n1();
    var tmp_1 = new Int8Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = _this__u8e3s4.l1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  }
  function toSerializableList(bytes) {
    if (bytes == null)
      return null;
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size = bytes.length;
    var list = ArrayList_init_$Create$(size);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$4 = bytes[index];
        list.j1(tmp$ret$4);
      }
       while (inductionVariable < size);
    return list;
  }
  function getAsyncImageLoader(context) {
    var platform = getPlatform();
    // Inline function 'coil3.Builder.components' call
    var this_0 = Builder_init_$Create$(context);
    // Inline function 'kotlin.apply' call
    var this_1 = Builder_init_$Create$_0();
    // Inline function 'coil3.Builder.add' call
    var factory = KtorNetworkFetcherFactory(HttpClient());
    this_1.mxc(factory, getKClass(Uri));
    var tmp = this_0.lxd(this_1.g3d()).gxe(new DebugLogger());
    // Inline function 'kotlin.apply' call
    var this_2 = tmp.mxd(getAsyncImageLoader$lambda(context));
    if (platform.h14w()) {
      this_2.nxd(getAsyncImageLoader$lambda_0);
    }
    return crossfade(this_2.fxe(CachePolicy_ENABLED_getInstance()).exe(platform.h14w() ? CachePolicy_ENABLED_getInstance() : CachePolicy_DISABLED_getInstance()).oxd(CachePolicy_ENABLED_getInstance()), true).g3d();
  }
  function getAsyncImageLoader$lambda($context) {
    return function () {
      return (new Builder_1()).sxi($context, 0.25).g3d();
    };
  }
  function getAsyncImageLoader$lambda_0() {
    var tmp = (new Builder_2()).yxf(Companion_getInstance_32().gvs(getCacheDir()).pvt('image_cache'));
    // Inline function 'kotlin.Long.times' call
    var this_0 = new Long(512, 0);
    // Inline function 'kotlin.Long.times' call
    var this_1 = multiply(this_0, fromInt(1024));
    var tmp$ret$1 = multiply(this_1, fromInt(1024));
    return tmp.zxf(tmp$ret$1).g3d();
  }
  function get_governorates() {
    _init_properties_Governorates_kt__uqw6ev();
    return governorates;
  }
  var governorates;
  var client_fstech_hadaya_util_Governorate$stable;
  function Governorate(nameEnglish, nameArabic, shippingCost) {
    this.l11r_1 = nameEnglish;
    this.m11r_1 = nameArabic;
    this.n11r_1 = shippingCost;
  }
  protoOf(Governorate).toString = function () {
    return 'Governorate(nameEnglish=' + this.l11r_1 + ', nameArabic=' + this.m11r_1 + ', shippingCost=' + this.n11r_1 + ')';
  };
  protoOf(Governorate).hashCode = function () {
    var result = getStringHashCode(this.l11r_1);
    result = imul(result, 31) + getStringHashCode(this.m11r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n11r_1) | 0;
    return result;
  };
  protoOf(Governorate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Governorate))
      return false;
    if (!(this.l11r_1 === other.l11r_1))
      return false;
    if (!(this.m11r_1 === other.m11r_1))
      return false;
    if (!equals(this.n11r_1, other.n11r_1))
      return false;
    return true;
  };
  var properties_initialized_Governorates_kt_kn84g7;
  function _init_properties_Governorates_kt__uqw6ev() {
    if (!properties_initialized_Governorates_kt_kn84g7) {
      properties_initialized_Governorates_kt_kn84g7 = true;
      governorates = listOf_0([new Governorate('Alexandria', '\u0627\u0644\u0625\u0633\u0643\u0646\u062F\u0631\u064A\u0629', 60.0), new Governorate('Aswan', '\u0623\u0633\u0648\u0627\u0646', 90.0), new Governorate('Asyut', '\u0623\u0633\u064A\u0648\u0637', 80.0), new Governorate('Beheira', '\u0627\u0644\u0628\u062D\u064A\u0631\u0629', 70.0), new Governorate('Beni Suef', '\u0628\u0646\u064A \u0633\u0648\u064A\u0641', 70.0), new Governorate('Cairo', '\u0627\u0644\u0642\u0627\u0647\u0631\u0629', 50.0), new Governorate('Dakahlia', '\u0627\u0644\u062F\u0642\u0647\u0644\u064A\u0629', 70.0), new Governorate('Damietta', '\u062F\u0645\u064A\u0627\u0637', 70.0), new Governorate('Faiyum', '\u0627\u0644\u0641\u064A\u0648\u0645', 70.0), new Governorate('Gharbia', '\u0627\u0644\u063A\u0631\u0628\u064A\u0629', 70.0), new Governorate('Giza', '\u0627\u0644\u062C\u064A\u0632\u0629', 50.0), new Governorate('Ismailia', '\u0627\u0644\u0625\u0633\u0645\u0627\u0639\u064A\u0644\u064A\u0629', 70.0), new Governorate('Kafr El-Sheikh', '\u0643\u0641\u0631 \u0627\u0644\u0634\u064A\u062E', 70.0), new Governorate('Luxor', '\u0627\u0644\u0623\u0642\u0635\u0631', 90.0), new Governorate('Marsa Matruh', '\u0645\u0631\u0633\u0649 \u0645\u0637\u0631\u0648\u062D', 90.0), new Governorate('Minya', '\u0627\u0644\u0645\u0646\u064A\u0627', 80.0), new Governorate('Monufia', '\u0627\u0644\u0645\u0646\u0648\u0641\u064A\u0629', 70.0), new Governorate('New Valley', '\u0627\u0644\u0648\u0627\u062F\u064A \u0627\u0644\u062C\u062F\u064A\u062F', 90.0), new Governorate('North Sinai', '\u0634\u0645\u0627\u0644 \u0633\u064A\u0646\u0627\u0621', 90.0), new Governorate('Port Said', '\u0628\u0648\u0631\u0633\u0639\u064A\u062F', 70.0), new Governorate('Qalyubia', '\u0627\u0644\u0642\u0644\u064A\u0648\u0628\u064A\u0629', 70.0), new Governorate('Qena', '\u0642\u0646\u0627', 80.0), new Governorate('Red Sea', '\u0627\u0644\u0628\u062D\u0631 \u0627\u0644\u0623\u062D\u0645\u0631', 80.0), new Governorate('Sharqia', '\u0627\u0644\u0634\u0631\u0642\u064A\u0629', 70.0), new Governorate('Sohag', '\u0633\u0648\u0647\u0627\u062C', 80.0), new Governorate('South Sinai', '\u062C\u0646\u0648\u0628 \u0633\u064A\u0646\u0627\u0621', 90.0), new Governorate('Suez', '\u0627\u0644\u0633\u0648\u064A\u0633', 70.0), new Governorate('Other', '\u0623\u062E\u0631\u0649', 100.0)]);
      client_fstech_hadaya_util_Governorate$stable = 0;
    }
  }
  var client_fstech_hadaya_util_LatLng_$serializer$stable;
  var client_fstech_hadaya_util_LatLng$stable;
  function Companion_38() {
  }
  var Companion_instance_44;
  function Companion_getInstance_73() {
    return Companion_instance_44;
  }
  function $serializer_32() {
    $serializer_instance_32 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('client.fstech.hadaya.util.LatLng', this, 2);
    tmp0_serialDesc.a7c('latitude', false);
    tmp0_serialDesc.a7c('longitude', false);
    this.i14w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_32).j14w = function (encoder, value) {
    var tmp0_desc = this.i14w_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.a76(tmp0_desc, 0, value.r14c_1);
    tmp1_output.a76(tmp0_desc, 1, value.s14c_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_32).z70 = function (encoder, value) {
    return this.j14w(encoder, value instanceof LatLng ? value : THROW_CCE());
  };
  protoOf($serializer_32).a71 = function (decoder) {
    var tmp0_desc = this.i14w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_input = decoder.n74(tmp0_desc);
    if (tmp6_input.d75()) {
      tmp4_local0 = tmp6_input.v74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.v74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.v74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.v74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.o74(tmp0_desc);
    return LatLng_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_32).y70 = function () {
    return this.i14w_1;
  };
  protoOf($serializer_32).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
  };
  var $serializer_instance_32;
  function $serializer_getInstance_32() {
    if ($serializer_instance_32 == null)
      new $serializer_32();
    return $serializer_instance_32;
  }
  function LatLng_init_$Init$(seen0, latitude, longitude, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_32().i14w_1);
    }
    $this.r14c_1 = latitude;
    $this.s14c_1 = longitude;
    return $this;
  }
  function LatLng_init_$Create$(seen0, latitude, longitude, serializationConstructorMarker) {
    return LatLng_init_$Init$(seen0, latitude, longitude, serializationConstructorMarker, objectCreate(protoOf(LatLng)));
  }
  function LatLng(latitude, longitude) {
    this.r14c_1 = latitude;
    this.s14c_1 = longitude;
  }
  protoOf(LatLng).toString = function () {
    return 'LatLng(latitude=' + this.r14c_1 + ', longitude=' + this.s14c_1 + ')';
  };
  protoOf(LatLng).hashCode = function () {
    var result = getNumberHashCode(this.r14c_1);
    result = imul(result, 31) + getNumberHashCode(this.s14c_1) | 0;
    return result;
  };
  protoOf(LatLng).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LatLng))
      return false;
    if (!equals(this.r14c_1, other.r14c_1))
      return false;
    if (!equals(this.s14c_1, other.s14c_1))
      return false;
    return true;
  };
  function NetworkObserver() {
  }
  function formatNumbers(_this__u8e3s4, language) {
    if (!(language === 'ar'))
      return _this__u8e3s4;
    var westernArabic = listOf_0([new Char(_Char___init__impl__6a9atx(48)), new Char(_Char___init__impl__6a9atx(49)), new Char(_Char___init__impl__6a9atx(50)), new Char(_Char___init__impl__6a9atx(51)), new Char(_Char___init__impl__6a9atx(52)), new Char(_Char___init__impl__6a9atx(53)), new Char(_Char___init__impl__6a9atx(54)), new Char(_Char___init__impl__6a9atx(55)), new Char(_Char___init__impl__6a9atx(56)), new Char(_Char___init__impl__6a9atx(57))]);
    var easternArabic = listOf_0([new Char(_Char___init__impl__6a9atx(1632)), new Char(_Char___init__impl__6a9atx(1633)), new Char(_Char___init__impl__6a9atx(1634)), new Char(_Char___init__impl__6a9atx(1635)), new Char(_Char___init__impl__6a9atx(1636)), new Char(_Char___init__impl__6a9atx(1637)), new Char(_Char___init__impl__6a9atx(1638)), new Char(_Char___init__impl__6a9atx(1639)), new Char(_Char___init__impl__6a9atx(1640)), new Char(_Char___init__impl__6a9atx(1641))]);
    var result = _this__u8e3s4;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = westernArabic.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var tmp0 = checkIndexOverflow(_unary__edvuaz);
      var char = item.f2_1;
      result = replace_0(result, char, easternArabic.l1(tmp0).f2_1);
    }
    return result;
  }
  function toTwoDecimalString(_this__u8e3s4) {
    var rounded = roundToLong(_this__u8e3s4 * 100);
    // Inline function 'kotlin.Long.div' call
    var integerPart = divide(rounded, fromInt(100));
    // Inline function 'kotlin.Long.rem' call
    var decimalPart = modulo(rounded, fromInt(100));
    return integerPart.toString() + '.' + padStart(decimalPart.toString(), 2, _Char___init__impl__6a9atx(48));
  }
  function format(_this__u8e3s4, language) {
    return formatNumbers(toString(_this__u8e3s4), language);
  }
  var client_fstech_hadaya_util_UiText_DynamicString$stable;
  var client_fstech_hadaya_util_UiText_ResourceString$stable;
  function DynamicString(value) {
    this.k14w_1 = value;
  }
  protoOf(DynamicString).toString = function () {
    return 'DynamicString(value=' + this.k14w_1 + ')';
  };
  protoOf(DynamicString).hashCode = function () {
    return getStringHashCode(this.k14w_1);
  };
  protoOf(DynamicString).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DynamicString))
      return false;
    if (!(this.k14w_1 === other.k14w_1))
      return false;
    return true;
  };
  function ResourceString(resource, args) {
    this.l14w_1 = resource;
    this.m14w_1 = args;
  }
  protoOf(ResourceString).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ResourceString))
      return false;
    if (!this.l14w_1.equals(other.l14w_1))
      return false;
    return contentEquals(this.m14w_1, other.m14w_1);
  };
  protoOf(ResourceString).hashCode = function () {
    var result = this.l14w_1.hashCode();
    result = imul(31, result) + contentHashCode(this.m14w_1) | 0;
    return result;
  };
  function $asStringNonComposableCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v14w_1 = _this__u8e3s4;
  }
  protoOf($asStringNonComposableCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0_subject = this.v14w_1;
            if (tmp0_subject instanceof DynamicString) {
              this.w14w_1 = this.v14w_1.k14w_1;
              this.n9_1 = 3;
              continue $sm;
            } else {
              if (tmp0_subject instanceof ResourceString) {
                this.n9_1 = 1;
                suspendResult = getString_0(this.v14w_1.l14w_1, this.v14w_1.m14w_1.slice(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_0 = this;
                noWhenBranchMatchedException();
              }
            }

            break;
          case 1:
            this.w14w_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            throw this.q9_1;
          case 3:
            return this.w14w_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function UiText() {
  }
  function isValidEgyptianMobile(phone) {
    var regex = Regex_init_$Create$('^01[0124578]\\d{7,8}$');
    return regex.zd(phone);
  }
  function isValidEgyptianWorkPhone(phone) {
    var regex = Regex_init_$Create$('^0\\d{7,10}$');
    return regex.zd(phone);
  }
  var client_fstech_hadaya_WebAnalyticsHelper$stable;
  function escape($this, s) {
    return replace(replace(s, '"', '\\"'), '\n', '\\n');
  }
  function WebAnalyticsHelper() {
    this.x14w_1 = 'G-P25PQ2QR72';
  }
  protoOf(WebAnalyticsHelper).uyi = function (title, location, path) {
    var json = '{"page_title":"' + escape(this, title) + '","page_location":"' + escape(this, location) + '","page_path":"' + escape(this, path) + '","send_to":"' + this.x14w_1 + '"}';
    trackGAEventJson('event', 'page_view', json);
  };
  var client_fstech_hadaya_JsPlatform$stable;
  var client_fstech_hadaya_LanguageSwitcher$stable;
  var client_fstech_hadaya_JsNetworkObserver$stable;
  function randomUUID() {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = window;
    return toString(tmp$ret$0.crypto.randomUUID());
  }
  function LanguageSwitcher() {
  }
  protoOf(LanguageSwitcher).qyl = function (isoCode) {
    var current = localStorage.getItem('language');
    if (current === isoCode)
      return Unit_instance;
    localStorage.setItem('language', isoCode);
    var tmp0_safe_receiver = document.documentElement;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.setAttribute('lang', isoCode);
    }
    window.location.reload();
  };
  protoOf(LanguageSwitcher).nyv = function () {
    var tmp0_elvis_lhs = localStorage.getItem('language');
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? take(window.navigator.language, 2) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'en' : tmp1_elvis_lhs;
  };
  function JsNetworkObserver$lambda(this$0) {
    return function (it) {
      this$0.y14w_1.s21(true);
      return Unit_instance;
    };
  }
  function JsNetworkObserver$lambda_0(this$0) {
    return function (it) {
      this$0.y14w_1.s21(false);
      return Unit_instance;
    };
  }
  function JsNetworkObserver() {
    this.y14w_1 = MutableStateFlow(window.navigator.onLine);
    this.z14w_1 = asStateFlow(this.y14w_1);
    var tmp = window;
    tmp.addEventListener('online', JsNetworkObserver$lambda(this));
    var tmp_0 = window;
    tmp_0.addEventListener('offline', JsNetworkObserver$lambda_0(this));
  }
  protoOf(JsNetworkObserver).fz1 = function () {
    return this.z14w_1;
  };
  function getPlatform() {
    return new JsPlatform();
  }
  function showToast(message) {
    window.alert(message);
  }
  function setSessionPersistence(keepLogin) {
    localStorage.setItem('keep_login', keepLogin.toString());
  }
  function getOrigin() {
    return window.location.origin;
  }
  function shareProduct(name, description, url) {
    // Inline function 'kotlin.js.asDynamic' call
    var nav = window.navigator;
    if (nav.share != null) {
      nav.share({title: name, text: description, url: url});
    } else {
      window.alert('Share: ' + name + '\n' + description + '\n' + url);
    }
  }
  function getCacheDir() {
    return '/cache';
  }
  function JsPlatform() {
    this.a14x_1 = navigator.userAgent;
    this.b14x_1 = listOf_0(['Chrome', 'Firefox', 'Safari', 'Edge']);
    var tmp = this;
    var tmp0_safe_receiver = findAnyOf(this.a14x_1, this.b14x_1, VOID, true);
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      var startIndex = tmp0_safe_receiver.zh();
      tmp_0 = substringBefore(substring(this.a14x_1, startIndex), ' ');
    }
    var tmp1_elvis_lhs = tmp_0;
    tmp.c14x_1 = tmp1_elvis_lhs == null ? 'Web (JS)' : tmp1_elvis_lhs;
    this.d14x_1 = new Long(1, 0);
    this.e14x_1 = false;
  }
  protoOf(JsPlatform).m = function () {
    return this.c14x_1;
  };
  protoOf(JsPlatform).c106 = function () {
    return this.d14x_1;
  };
  protoOf(JsPlatform).h14w = function () {
    return this.e14x_1;
  };
  function openUrl(url) {
    window.open(url, '_blank');
  }
  function createClipEntry(text) {
    return Companion_instance_3.qc0(text);
  }
  function triggerGoogleLogin(clientId, onTokenReceived) {
    // Inline function 'kotlin.js.asDynamic' call
    var win = window;
    var google = win.google;
    if (google != null && google.accounts != null && google.accounts.id != null) {
      if (win._gsiInitialized != true) {
        google.accounts.id.initialize({client_id: clientId, callback: function (response) {
          onTokenReceived(response.credential);
        }});
        win._gsiInitialized = true;
      }
      google.accounts.id.prompt();
    } else {
      window.alert('Google Login not loaded yet. Please try again in a moment.');
    }
  }
  var client_fstech_hadaya_data_local_SupabaseSessionManager$stable;
  function SupabaseSessionManager$json$lambda($this$Json) {
    $this$Json.fmh_1 = true;
    $this$Json.dmh_1 = true;
    return Unit_instance;
  }
  function SupabaseSessionManager() {
    var tmp = this;
    tmp.f14x_1 = Json(VOID, SupabaseSessionManager$json$lambda);
  }
  protoOf(SupabaseSessionManager).iw7 = function (session, $completion) {
    var keepLogin = localStorage.getItem('keep_login') === 'true';
    // Inline function 'kotlinx.serialization.json.Json.encodeToString' call
    var this_0 = this.f14x_1;
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.c75();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(UserSession), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var sessionStr = this_0.b72(tmp$ret$1, session);
    if (keepLogin) {
      localStorage.setItem('supabase_session', sessionStr);
      sessionStorage.removeItem('supabase_session');
    } else {
      sessionStorage.setItem('supabase_session', sessionStr);
      localStorage.removeItem('supabase_session');
    }
    return Unit_instance;
  };
  protoOf(SupabaseSessionManager).gwb = function ($completion) {
    var tmp0_elvis_lhs = localStorage.getItem('supabase_session');
    var sessionStr = tmp0_elvis_lhs == null ? sessionStorage.getItem('supabase_session') : tmp0_elvis_lhs;
    var tmp;
    try {
      var tmp_0;
      if (sessionStr == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
        var this_0 = this.f14x_1;
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.c75();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(UserSession), arrayOf([]), false));
        var tmp$ret$3 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        tmp_0 = this_0.c72(tmp$ret$3, sessionStr);
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Exception) {
        var e = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  };
  protoOf(SupabaseSessionManager).dwc = function ($completion) {
    localStorage.removeItem('supabase_session');
    sessionStorage.removeItem('supabase_session');
    return Unit_instance;
  };
  function platformModule() {
    return module_0(VOID, platformModule$lambda);
  }
  function platformModule$lambda($this$module) {
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition = platformModule$lambda$lambda;
    var scopeQualifier = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind = Kind_Singleton_getInstance();
    var secondaryTypes = emptyList();
    var def = new BeanDefinition(scopeQualifier, getKClass(AppDatabase), null, definition, kind, secondaryTypes);
    var factory = new SingleInstanceFactory(def);
    $this$module.ns5(factory);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory);
    }
    new KoinDefinition($this$module, factory);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_0 = platformModule$lambda$lambda_0;
    var scopeQualifier_0 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_0 = Kind_Singleton_getInstance();
    var secondaryTypes_0 = emptyList();
    var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(NetworkObserver), null, definition_0, kind_0, secondaryTypes_0);
    var factory_0 = new SingleInstanceFactory(def_0);
    $this$module.ns5(factory_0);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_0);
    }
    new KoinDefinition($this$module, factory_0);
    // Inline function 'org.koin.core.module.Module.single' call
    // Inline function 'org.koin.core.module._singleInstanceFactory' call
    var definition_1 = platformModule$lambda$lambda_1;
    var scopeQualifier_1 = Companion_getInstance_4().ss3_1;
    // Inline function 'org.koin.core.definition._createDefinition' call
    var kind_1 = Kind_Singleton_getInstance();
    var secondaryTypes_1 = emptyList();
    var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(IAnalyticsHelper), null, definition_1, kind_1, secondaryTypes_1);
    var factory_1 = new SingleInstanceFactory(def_1);
    $this$module.ns5(factory_1);
    if (false || $this$module.hs5_1) {
      $this$module.ps5(factory_1);
    }
    new KoinDefinition($this$module, factory_1);
    return Unit_instance;
  }
  function platformModule$lambda$lambda($this$single, it) {
    return new MemoryAppDatabase();
  }
  function platformModule$lambda$lambda_0($this$single, it) {
    return new JsNetworkObserver();
  }
  function platformModule$lambda$lambda_1($this$single, it) {
    return new WebAnalyticsHelper();
  }
  function VideoPlayer(url, modifier, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-948158449);
    sourceInformation($composer_0, 'C(VideoPlayer)P(1)12@329L72:VideoPlayer.kt#c1nezb');
    var $dirty = $changed;
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 17) === 16), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (isTraceInProgress()) {
        traceEventStart(-948158449, $dirty, -1, 'client.fstech.hadaya.presentation.common.VideoPlayer (VideoPlayer.kt:10)');
      }
      var tmp = modifier_0._v;
      var tmp_0 = _Color___init__impl__r6cqi2(_ULong___init__impl__c78o9k(new Long(0, 0)));
      var tmp_1 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_2 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_3 = _TextUnit___init__impl__r5fj1s(new Long(0, 0));
      var tmp_4 = _TextOverflow___init__impl__obguoe(0);
      Text('Video player not supported on this platform', tmp, tmp_0, null, tmp_1, null, null, null, tmp_2, null, null, tmp_3, tmp_4, false, 0, 0, null, null, $composer_0, 6 | 112 & $dirty, 0, 262140);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(VideoPlayer$lambda(url, modifier_0, $changed, $default));
    }
  }
  function VideoPlayer$lambda($url, $modifier, $$changed, $$default) {
    return function ($composer, $force) {
      VideoPlayer($url, $modifier._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function resize(_this__u8e3s4, maxDim) {
    var bitmap = asSkiaBitmap(_this__u8e3s4);
    var width = bitmap.h5e();
    var height = bitmap.i5e();
    var ratio = width / height;
    var newWidth;
    var newHeight;
    if (width > height) {
      newWidth = maxDim;
      newHeight = numberToInt(maxDim / ratio);
    } else {
      newHeight = maxDim;
      newWidth = numberToInt(maxDim * ratio);
    }
    var newBitmap = Bitmap_init_$Create$();
    newBitmap.u5i(newWidth, newHeight);
    var canvas = Canvas_init_$Create$(newBitmap);
    canvas.j5k(Companion_getInstance_33().d5q(bitmap), Companion_instance_4.c5u(width, height), Companion_instance_4.c5u(newWidth, newHeight));
    return toComposeImageBitmap(Companion_getInstance_33().d5q(newBitmap));
  }
  function toByteArray(_this__u8e3s4) {
    var tmp0_safe_receiver = Companion_getInstance_33().d5q(asSkiaBitmap(_this__u8e3s4)).g5q(EncodedImageFormat_PNG_getInstance());
    var tmp1_elvis_lhs = toSerializableList(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w5m());
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function toJpegByteArray(_this__u8e3s4, quality) {
    quality = quality === VOID ? 80 : quality;
    var tmp0_safe_receiver = Companion_getInstance_33().d5q(asSkiaBitmap(_this__u8e3s4)).f5q(EncodedImageFormat_JPEG_getInstance(), quality);
    var tmp1_elvis_lhs = toSerializableList(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w5m());
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function decodeToImageBitmap(bytes) {
    return toComposeImageBitmap(Companion_getInstance_33().e5q(toNativeByteArray(bytes)));
  }
  function BackHandler(enabled, onBack, $composer, $changed, $default) {
    var enabled_0 = {_v: enabled};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1044680127);
    sourceInformation($composer_0, 'C(BackHandler):Model3DPlatformInterface.kt#mu900e');
    if ($composer_0.r31(!(($changed & 1) === 0), $changed & 1)) {
      if (!(($default & 1) === 0)) {
        enabled_0._v = true;
      }
      if (isTraceInProgress()) {
        traceEventStart(1044680127, $changed, -1, 'client.fstech.hadaya.presentation.model3d.BackHandler (Model3DPlatformInterface.kt:222)');
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(BackHandler$lambda(enabled_0, onBack, $changed, $default));
    }
  }
  function ModelViewer(modelResName, modifier, image, imageBytes, isBlack, clipTop, clipBottom, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var image_0 = {_v: image};
    var imageBytes_0 = {_v: imageBytes};
    var isBlack_0 = {_v: isBlack};
    var clipTop_0 = {_v: clipTop};
    var clipBottom_0 = {_v: clipBottom};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-959667667);
    sourceInformation($composer_0, 'C(ModelViewer)P(5,6,2,3,4,1)147@5463L96,152@5593L513,163@6125L2332,151@5565L2987:Model3DPlatformInterface.kt#mu900e');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modelResName) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(image_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ((($changed & 4096) === 0 ? $composer_0.k31(imageBytes_0._v) : $composer_0.q31(imageBytes_0._v)) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.l31(isBlack_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.n31(clipTop_0._v) ? 131072 : 65536);
    if (!(($default & 64) === 0))
      $dirty = $dirty | 1572864;
    else if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.n31(clipBottom_0._v) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 599187) === 599186), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (!(($default & 4) === 0)) {
        image_0._v = null;
      }
      if (!(($default & 8) === 0)) {
        imageBytes_0._v = null;
      }
      if (!(($default & 16) === 0)) {
        isBlack_0._v = false;
      }
      if (!(($default & 32) === 0)) {
        clipTop_0._v = 0.0;
      }
      if (!(($default & 64) === 0)) {
        clipBottom_0._v = 0.0;
      }
      if (isTraceInProgress()) {
        traceEventStart(-959667667, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.ModelViewer (Model3DPlatformInterface.kt:146)');
      }
      sourceInformationMarkerStart($composer_0, 1177347373, 'CC(remember):Model3DPlatformInterface.kt#9igjgp');
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_0.k31(image_0._v) | (($dirty & 7168) === 2048 || (!(($dirty & 4096) === 0) && $composer_0.k31(imageBytes_0._v))));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance().f30_1) {
        var tmp0_elvis_lhs = imageBytes_0._v;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          var tmp_1 = image_0._v;
          var tmp1_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, ImageBitmap_0) : false) ? tmp_1 : null;
          tmp_0 = tmp1_safe_receiver == null ? null : toByteArray(tmp1_safe_receiver);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var value = tmp_0;
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var finalImageBytes = tmp0_group;
      sourceInformationMarkerStart($composer_0, 1177351950, 'CC(remember):Model3DPlatformInterface.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_0.i31();
      var tmp_2;
      if (false || it_0 === Companion_getInstance().f30_1) {
        var value_0 = ModelViewer$lambda;
        this_0.j31(value_0);
        tmp_2 = value_0;
      } else {
        tmp_2 = it_0;
      }
      var tmp1_group = tmp_2;
      sourceInformationMarkerEnd($composer_0);
      sourceInformationMarkerStart($composer_0, 1177370793, 'CC(remember):Model3DPlatformInterface.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!(!!(($dirty & 14) === 4 | $composer_0.q31(finalImageBytes)) | ($dirty & 57344) === 16384);
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_0.i31();
      var tmp_3;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = ModelViewer$lambda_0(modelResName, finalImageBytes, isBlack_0);
        tmp0_0.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp2_group = tmp_3;
      sourceInformationMarkerEnd($composer_0);
      HtmlView(tmp1_group, tmp2_group, modifier_0._v, clipTop_0._v, clipBottom_0._v, $composer_0, 6 | 896 & $dirty << 3 | 7168 & $dirty >> 6 | 57344 & $dirty >> 6, 0);
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp3_safe_receiver = $composer_0.t30();
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.p3c(ModelViewer$lambda_1(modelResName, modifier_0, image_0, imageBytes_0, isBlack_0, clipTop_0, clipBottom_0, $changed, $default));
    }
  }
  function rememberImagePickerLauncher(onImagePicked, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 605016588, 'C(rememberImagePickerLauncher)25@979L2278:Model3DPlatformInterface.kt#mu900e');
    if (isTraceInProgress()) {
      traceEventStart(605016588, $changed, -1, 'client.fstech.hadaya.presentation.model3d.rememberImagePickerLauncher (Model3DPlatformInterface.kt:24)');
    }
    sourceInformationMarkerStart($composer_0, 1600361682, 'CC(remember):Model3DPlatformInterface.kt#9igjgp');
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = new rememberImagePickerLauncher$1(onImagePicked);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp1_group = tmp;
    sourceInformationMarkerEnd($composer_0);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp1_group;
  }
  function HtmlView(factory, update, modifier, clipTop, clipBottom, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var clipTop_0 = {_v: clipTop};
    var clipBottom_0 = {_v: clipBottom};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1699872634);
    sourceInformation($composer_0, 'C(HtmlView)P(2,4,3,1)91@3627L7,92@3661L22,95@3747L1248,94@3693L1540:Model3DPlatformInterface.kt#mu900e');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(factory) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(update) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.n31(clipTop_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.n31(clipBottom_0._v) ? 16384 : 8192);
    if ($composer_0.r31(!(($dirty & 9363) === 9362), $dirty & 1)) {
      if (!(($default & 4) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (!(($default & 8) === 0)) {
        clipTop_0._v = 0.0;
      }
      if (!(($default & 16) === 0)) {
        clipBottom_0._v = 0.0;
      }
      if (isTraceInProgress()) {
        traceEventStart(-1699872634, $dirty, -1, 'client.fstech.hadaya.presentation.model3d.HtmlView (Model3DPlatformInterface.kt:90)');
      }
      var tmp0 = get_LocalDensity();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var density = $composer_1.u31(tmp0).u5e();
      sourceInformationMarkerStart($composer_0, -1490021188, 'CC(remember):Model3DPlatformInterface.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance().f30_1) {
        var value = factory();
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp0_group = tmp;
      sourceInformationMarkerEnd($composer_0);
      var element = tmp0_group;
      var tmp_0 = modifier_0._v;
      sourceInformationMarkerStart($composer_0, -1490017210, 'CC(remember):Model3DPlatformInterface.kt#9igjgp');
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(!!(!!(($dirty & 7168) === 2048 | $composer_0.n31(density)) | ($dirty & 57344) === 16384) | $composer_0.q31(element));
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_0.i31();
      var tmp_1;
      if (invalid || it_0 === Companion_getInstance().f30_1) {
        var value_0 = HtmlView$lambda(clipTop_0, density, clipBottom_0, element);
        tmp0_0.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp1_group = tmp_1;
      sourceInformationMarkerEnd($composer_0);
      // Inline function 'androidx.compose.foundation.layout.Box' call
      var modifier_1 = onGloballyPositioned(tmp_0, tmp1_group);
      var contentAlignment = null;
      var propagateMinConstraints = false;
      var $composer_2 = $composer_0;
      if (!((6 & 1) === 0))
        modifier_1 = Companion_instance;
      if (!((6 & 2) === 0))
        contentAlignment = Companion_getInstance_11().k8t_1;
      if (!((6 & 4) === 0))
        propagateMinConstraints = false;
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment, propagateMinConstraints);
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_2 = modifier_1;
      var $composer_3 = $composer_2;
      if (!((0 & 2) === 0))
        modifier_2 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_3, 0).hashCode();
      var localMap = $composer_3.t31();
      var materialized = materialize($composer_3, modifier_2);
      var tmp0_1 = Companion_getInstance_12().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_4 = $composer_3;
      var tmp_2 = $composer_4.g30();
      if (!isInterface(tmp_2, Applier)) {
        invalidApplier();
      }
      $composer_4.b31();
      if ($composer_4.h30()) {
        $composer_4.c31(tmp0_1);
      } else {
        $composer_4.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_4);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_12().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_12().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_12().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_12().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_12().qah_1);
      var $composer_5 = $composer_4;
      var $composer_6 = $composer_5;
      sourceInformationMarkerStart($composer_6, -1306186816, 'C125@5038L130,125@5012L156,131@5188L39,131@5177L50:Model3DPlatformInterface.kt#mu900e');
      sourceInformationMarkerStart($composer_6, 1758981006, 'CC(remember):Model3DPlatformInterface.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_6.q31(element);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_6.i31();
      var tmp_3;
      if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
        var value_1 = HtmlView$lambda_0(element);
        $composer_6.j31(value_1);
        tmp_3 = value_1;
      } else {
        tmp_3 = it_1;
      }
      var tmp0_group_0 = tmp_3;
      sourceInformationMarkerEnd($composer_6);
      DisposableEffect(element, tmp0_group_0, $composer_6, 0);
      sourceInformationMarkerStart($composer_6, 1758985715, 'CC(remember):Model3DPlatformInterface.kt#9igjgp');
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!(($dirty & 112) === 32 | $composer_0.q31(element));
      // Inline function 'kotlin.let' call
      var it_2 = $composer_6.i31();
      var tmp_4;
      if (invalid_1 || it_2 === Companion_getInstance().f30_1) {
        var value_2 = HtmlView$lambda_1(update, element);
        $composer_6.j31(value_2);
        tmp_4 = value_2;
      } else {
        tmp_4 = it_2;
      }
      var tmp1_group_0 = tmp_4;
      sourceInformationMarkerEnd($composer_6);
      SideEffect(tmp1_group_0, $composer_6, 0);
      sourceInformationMarkerEnd($composer_6);
      $composer_4.e31();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp2_safe_receiver = $composer_0.t30();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.p3c(HtmlView$lambda_2(factory, update, modifier_0, clipTop_0, clipBottom_0, $changed, $default));
    }
  }
  function BackHandler$lambda($enabled, $onBack, $$changed, $$default) {
    return function ($composer, $force) {
      BackHandler($enabled._v, $onBack, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function ModelViewer$lambda() {
    var tmp = document.createElement('model-viewer');
    var modelViewer = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    modelViewer.setAttribute('auto-rotate', '');
    modelViewer.setAttribute('camera-controls', '');
    modelViewer.setAttribute('shadow-intensity', '1');
    modelViewer.setAttribute('environment-image', 'neutral');
    modelViewer.setAttribute('exposure', '1.0');
    modelViewer.style.width = '100%';
    modelViewer.style.height = '100%';
    return modelViewer;
  }
  function ModelViewer$lambda_0($modelResName, $finalImageBytes, $isBlack) {
    return function (element) {
      // Inline function 'kotlin.js.asDynamic' call
      var mv_0 = element;
      var tmp;
      if (mv_0.src != $modelResName) {
        console.log('Loading model in <model-viewer>:', $modelResName);
        tmp = mv_0.src = $modelResName;
      }
      var applyChanges = function (mv, imageBytes, isBlack) {
        const updateMaterial = () => {
          const material = mv.model && mv.model.materials ? mv.model.materials[0] : null;
          if (!material)
            return; // Apply Color
          const color = isBlack ? [0.05, 0.05, 0.05, 1.0] : [1.0, 1.0, 1.0, 1.0];
          material.pbrMetallicRoughness.setBaseColorFactor(color); // Apply Texture
          if (imageBytes) {
            const uint8Array = new Uint8Array(imageBytes.buffer, imageBytes.byteOffset, imageBytes.byteLength);
            const blob = new Blob([uint8Array], {type: 'image/png'});
            const url = URL.createObjectURL(blob);
            mv.createTexture(url).then((texture) => {
              material.pbrMetallicRoughness.baseColorTexture.setTexture(texture);
              material.setAlphaMode('BLEND');
              URL.revokeObjectURL(url);
            }).catch((e) => {
              console.error('Texture Load Error:', e);
              URL.revokeObjectURL(url);
            });
          } else {
            material.pbrMetallicRoughness.baseColorTexture.setTexture(null);
            material.setAlphaMode('OPAQUE');
          }
        };
        if (mv.model) {
          updateMaterial();
        } else {
          mv.addEventListener('load', updateMaterial, {once: true});
        }
      };
      var tmp0_safe_receiver = $finalImageBytes;
      var nativeBytes = tmp0_safe_receiver == null ? null : toNativeByteArray(tmp0_safe_receiver);
      applyChanges(mv_0, nativeBytes, $isBlack._v);
      return Unit_instance;
    };
  }
  function ModelViewer$lambda_1($modelResName, $modifier, $image, $imageBytes, $isBlack, $clipTop, $clipBottom, $$changed, $$default) {
    return function ($composer, $force) {
      ModelViewer($modelResName, $modifier._v, $image._v, $imageBytes._v, $isBlack._v, $clipTop._v, $clipBottom._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function rememberImagePickerLauncher$o$launchGallery$lambda$lambda($reader, $onImagePicked) {
    return function (it) {
      var tmp = $reader.result;
      var arrayBuffer = tmp instanceof ArrayBuffer ? tmp : THROW_CCE();
      var int8Array = new Int8Array(arrayBuffer);
      var bytes = new Int8Array(int8Array.length);
      var inductionVariable = 0;
      var last = int8Array.length;
      var tmp_0;
      if (inductionVariable < last) {
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'org.khronos.webgl.get' call
          // Inline function 'kotlin.js.asDynamic' call
          bytes[i] = int8Array[i];
        }
         while (inductionVariable < last);
        tmp_0 = Unit_instance;
      }
      $onImagePicked(ensureNotNull(toSerializableList(bytes)));
      return Unit_instance;
    };
  }
  function rememberImagePickerLauncher$o$launchGallery$lambda($input, $onImagePicked) {
    return function (it) {
      var files = $input.files;
      var tmp;
      if (!(files == null) && files.length > 0) {
        // Inline function 'org.w3c.files.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = files[0];
        var file = ensureNotNull(tmp$ret$0);
        var reader = new FileReader();
        reader.onload = rememberImagePickerLauncher$o$launchGallery$lambda$lambda(reader, $onImagePicked);
        reader.readAsArrayBuffer(file);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function rememberImagePickerLauncher$o$launchCamera$lambda$lambda($reader, $onImagePicked) {
    return function (it) {
      var tmp = $reader.result;
      var arrayBuffer = tmp instanceof ArrayBuffer ? tmp : THROW_CCE();
      var int8Array = new Int8Array(arrayBuffer);
      var bytes = new Int8Array(int8Array.length);
      var inductionVariable = 0;
      var last = int8Array.length;
      var tmp_0;
      if (inductionVariable < last) {
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'org.khronos.webgl.get' call
          // Inline function 'kotlin.js.asDynamic' call
          bytes[i] = int8Array[i];
        }
         while (inductionVariable < last);
        tmp_0 = Unit_instance;
      }
      $onImagePicked(ensureNotNull(toSerializableList(bytes)));
      return Unit_instance;
    };
  }
  function rememberImagePickerLauncher$o$launchCamera$lambda($input, $onImagePicked) {
    return function (it) {
      var files = $input.files;
      var tmp;
      if (!(files == null) && files.length > 0) {
        // Inline function 'org.w3c.files.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = files[0];
        var file = ensureNotNull(tmp$ret$0);
        var reader = new FileReader();
        reader.onload = rememberImagePickerLauncher$o$launchCamera$lambda$lambda(reader, $onImagePicked);
        reader.readAsArrayBuffer(file);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function rememberImagePickerLauncher$1($onImagePicked) {
    this.g14x_1 = $onImagePicked;
  }
  protoOf(rememberImagePickerLauncher$1).n12v = function () {
    var tmp = document.createElement('input');
    var input = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = rememberImagePickerLauncher$o$launchGallery$lambda(input, this.g14x_1);
    input.click();
  };
  protoOf(rememberImagePickerLauncher$1).o12v = function () {
    var tmp = document.createElement('input');
    var input = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
    input.type = 'file';
    input.accept = 'image/*';
    input.setAttribute('capture', 'environment');
    input.onchange = rememberImagePickerLauncher$o$launchCamera$lambda(input, this.g14x_1);
    input.click();
  };
  function HtmlView$lambda($clipTop, $density, $clipBottom, $element) {
    return function (coordinates) {
      var position = positionInWindow(coordinates);
      var size = coordinates.q95();
      var tmp;
      if ($clipTop._v > 0) {
        var tmp_0 = $clipTop._v * $density;
        // Inline function 'androidx.compose.ui.geometry.Offset.y' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value = _Offset___get_packedValue__impl__xh2k8q(position);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
        var overlap = tmp_0 - floatFromBits(bits);
        tmp = overlap > 0 ? overlap / $density : 0.0;
      } else {
        tmp = 0.0;
      }
      var topInset = tmp;
      var tmp_1;
      if ($clipBottom._v > 0) {
        // Inline function 'androidx.compose.ui.geometry.Offset.y' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_0 = _Offset___get_packedValue__impl__xh2k8q(position);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
        var tmp_2 = floatFromBits(bits_0);
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value_1 = _IntSize___get_packedValue__impl__uho7jf(size);
        var overlap_0 = tmp_2 + convertToInt(bitwiseAnd(value_1, new Long(-1, 0))) - $clipBottom._v * $density;
        tmp_1 = overlap_0 > 0 ? overlap_0 / $density : 0.0;
      } else {
        tmp_1 = 0.0;
      }
      var bottomInset = tmp_1;
      $element.style.position = 'absolute';
      var tmp_3 = $element.style;
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_2 = _Offset___get_packedValue__impl__xh2k8q(position);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(shiftRight(value_2, 32));
      tmp_3.left = '' + floatFromBits(bits_1) / $density + 'px';
      var tmp_4 = $element.style;
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_3 = _Offset___get_packedValue__impl__xh2k8q(position);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
      tmp_4.top = '' + floatFromBits(bits_2) / $density + 'px';
      var tmp_5 = $element.style;
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_4 = _IntSize___get_packedValue__impl__uho7jf(size);
      tmp_5.width = '' + convertToInt(shiftRight(value_4, 32)) / $density + 'px';
      var tmp_6 = $element.style;
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_5 = _IntSize___get_packedValue__impl__uho7jf(size);
      tmp_6.height = '' + convertToInt(bitwiseAnd(value_5, new Long(-1, 0))) / $density + 'px';
      $element.style.display = 'block';
      $element.style.zIndex = '0';
      $element.style.setProperty('pointer-events', 'auto');
      var tmp_7;
      if (topInset > 0 || bottomInset > 0) {
        $element.style.setProperty('clip-path', 'inset(' + topInset + 'px 0px ' + bottomInset + 'px 0px)');
        tmp_7 = Unit_instance;
      } else {
        $element.style.setProperty('clip-path', 'none');
        tmp_7 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HtmlView$$inlined$Box$1$1($element) {
    this.h14x_1 = $element;
  }
  protoOf(HtmlView$$inlined$Box$1$1).s1d = function () {
    this.h14x_1.remove();
  };
  function HtmlView$lambda_0($element) {
    return function ($this$DisposableEffect) {
      var tmp0_safe_receiver = document.body;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild($element);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new HtmlView$$inlined$Box$1$1($element);
    };
  }
  function HtmlView$lambda_1($update, $element) {
    return function () {
      $update($element);
      return Unit_instance;
    };
  }
  function HtmlView$lambda_2($factory, $update, $modifier, $clipTop, $clipBottom, $$changed, $$default) {
    return function ($composer, $force) {
      HtmlView($factory, $update, $modifier._v, $clipTop._v, $clipBottom._v, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function rememberImagePickerLauncher_0(onResult, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, -1833841861, 'C(rememberImagePickerLauncher)16@564L1211:ImagePicker.js.kt#2kgzgj');
    if (isTraceInProgress()) {
      traceEventStart(-1833841861, $changed, -1, 'client.fstech.hadaya.presentation.profile.rememberImagePickerLauncher (ImagePicker.js.kt:15)');
    }
    sourceInformationMarkerStart($composer_0, -1385432682, 'CC(remember):ImagePicker.js.kt#9igjgp');
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = new rememberImagePickerLauncher$1_0(onResult);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp1_group = tmp;
    sourceInformationMarkerEnd($composer_0);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp1_group;
  }
  function rememberImagePickerLauncher$o$launch$lambda$lambda($reader, $onResult) {
    return function (it) {
      var tmp = $reader.result;
      var arrayBuffer = tmp instanceof ArrayBuffer ? tmp : THROW_CCE();
      var int8Array = new Int8Array(arrayBuffer);
      var bytes = new Int8Array(int8Array.length);
      var inductionVariable = 0;
      var last = int8Array.length;
      var tmp_0;
      if (inductionVariable < last) {
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'org.khronos.webgl.get' call
          // Inline function 'kotlin.js.asDynamic' call
          bytes[i] = int8Array[i];
        }
         while (inductionVariable < last);
        tmp_0 = Unit_instance;
      }
      $onResult(toSerializableList(bytes));
      return Unit_instance;
    };
  }
  function rememberImagePickerLauncher$o$launch$lambda($input, $onResult) {
    return function (event) {
      var files = $input.files;
      var tmp;
      if (!(files == null) && files.length > 0) {
        // Inline function 'org.w3c.files.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = files[0];
        var file = ensureNotNull(tmp$ret$0);
        var reader = new FileReader();
        reader.onload = rememberImagePickerLauncher$o$launch$lambda$lambda(reader, $onResult);
        reader.readAsArrayBuffer(file);
        tmp = Unit_instance;
      } else {
        $onResult(null);
        tmp = Unit_instance;
      }
      return tmp;
    };
  }
  function rememberImagePickerLauncher$1_0($onResult) {
    this.i14x_1 = $onResult;
  }
  protoOf(rememberImagePickerLauncher$1_0).g11s = function () {
    var tmp = document.createElement('input');
    var input = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = rememberImagePickerLauncher$o$launch$lambda(input, this.i14x_1);
    input.click();
  };
  var client_fstech_hadaya_util_JsLocationService$stable;
  function rememberLocationPickerLauncher(onLocationPicked, $composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 1606125543, 'C(rememberLocationPickerLauncher)9@322L660:LocationService.js.kt#6xrusq');
    if (isTraceInProgress()) {
      traceEventStart(1606125543, $changed, -1, 'client.fstech.hadaya.util.rememberLocationPickerLauncher (LocationService.js.kt:8)');
    }
    sourceInformationMarkerStart($composer_0, 1593391707, 'CC(remember):LocationService.js.kt#9igjgp');
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = new rememberLocationPickerLauncher$1(onLocationPicked);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp1_group = tmp;
    sourceInformationMarkerEnd($composer_0);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp1_group;
  }
  function rememberLocationPickerLauncher$o$launch$lambda($onLocationPicked) {
    return function (position) {
      $onLocationPicked(new LatLng(position.coords.latitude, position.coords.longitude));
      return Unit_instance;
    };
  }
  function rememberLocationPickerLauncher$o$launch$lambda_0($onLocationPicked) {
    return function (it) {
      $onLocationPicked(null);
      return Unit_instance;
    };
  }
  function rememberLocationPickerLauncher$1($onLocationPicked) {
    this.j14x_1 = $onLocationPicked;
  }
  protoOf(rememberLocationPickerLauncher$1).g11s = function () {
    var tmp = navigator.geolocation;
    var tmp_0 = rememberLocationPickerLauncher$o$launch$lambda(this.j14x_1);
    tmp.getCurrentPosition(tmp_0, rememberLocationPickerLauncher$o$launch$lambda_0(this.j14x_1));
  };
  function PreventScreenshots($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(874877994);
    sourceInformation($composer_0, 'C(PreventScreenshots):SecurityUtils.kt#6xrusq');
    if ($composer_0.r31(!($changed === 0), $changed & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(874877994, $changed, -1, 'client.fstech.hadaya.util.PreventScreenshots (SecurityUtils.kt:5)');
      }
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(PreventScreenshots$lambda($changed));
    }
  }
  function PreventScreenshots$lambda($$changed) {
    return function ($composer, $force) {
      PreventScreenshots($composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  //region block: post-declaration
  protoOf(NotificationRepositoryImpl).yzb = notifyAdmin$default;
  protoOf($serializer).u7c = typeParametersSerializers;
  protoOf($serializer_0).u7c = typeParametersSerializers;
  protoOf($serializer_1).u7c = typeParametersSerializers;
  protoOf($serializer_2).u7c = typeParametersSerializers;
  protoOf($serializer_3).u7c = typeParametersSerializers;
  protoOf($serializer_4).u7c = typeParametersSerializers;
  protoOf($serializer_5).u7c = typeParametersSerializers;
  protoOf($serializer_6).u7c = typeParametersSerializers;
  protoOf($serializer_7).u7c = typeParametersSerializers;
  protoOf($serializer_8).u7c = typeParametersSerializers;
  protoOf($serializer_9).u7c = typeParametersSerializers;
  protoOf($serializer_10).u7c = typeParametersSerializers;
  protoOf($serializer_11).u7c = typeParametersSerializers;
  protoOf($serializer_12).u7c = typeParametersSerializers;
  protoOf($serializer_13).u7c = typeParametersSerializers;
  protoOf($serializer_14).u7c = typeParametersSerializers;
  protoOf($serializer_15).u7c = typeParametersSerializers;
  protoOf($serializer_16).u7c = typeParametersSerializers;
  protoOf($serializer_17).u7c = typeParametersSerializers;
  protoOf($serializer_18).u7c = typeParametersSerializers;
  protoOf($serializer_19).u7c = typeParametersSerializers;
  protoOf($serializer_20).u7c = typeParametersSerializers;
  protoOf($serializer_21).u7c = typeParametersSerializers;
  protoOf($serializer_22).u7c = typeParametersSerializers;
  protoOf($serializer_23).u7c = typeParametersSerializers;
  protoOf($serializer_24).u7c = typeParametersSerializers;
  protoOf($serializer_25).u7c = typeParametersSerializers;
  protoOf($serializer_26).u7c = typeParametersSerializers;
  protoOf($serializer_27).u7c = typeParametersSerializers;
  protoOf($serializer_28).u7c = typeParametersSerializers;
  protoOf($serializer_29).u7c = typeParametersSerializers;
  protoOf($serializer_30).u7c = typeParametersSerializers;
  protoOf($serializer_31).u7c = typeParametersSerializers;
  protoOf(AuthNavigatorImpl).g10h = openAuthentication$default;
  protoOf($serializer_32).u7c = typeParametersSerializers;
  protoOf(DynamicString).s11k = asString;
  protoOf(DynamicString).z10i = asStringNonComposable;
  protoOf(ResourceString).s11k = asString;
  protoOf(ResourceString).z10i = asStringNonComposable;
  //endregion
  //region block: init
  hadaya_client_web_shared_generated_resources_Res_drawable$stable = 0;
  hadaya_client_web_shared_generated_resources_Res_string$stable = 0;
  hadaya_client_web_shared_generated_resources_Res_array$stable = 0;
  hadaya_client_web_shared_generated_resources_Res_plurals$stable = 0;
  hadaya_client_web_shared_generated_resources_Res_font$stable = 0;
  hadaya_client_web_shared_generated_resources_Res$stable = 0;
  drawable_instance = new drawable();
  string_instance = new string();
  font_instance = new font();
  client_fstech_hadaya_shared_BuildConfig$stable = 0;
  client_fstech_hadaya_data_local_datastore_LanguageStorage$stable = 0;
  client_fstech_hadaya_data_repository_AuthRepositoryImpl$stable = 8;
  client_fstech_hadaya_data_repository_CartRepositoryImpl$stable = 0;
  client_fstech_hadaya_data_repository_CouponRepositoryImpl$stable = 8;
  client_fstech_hadaya_data_repository_FavoriteRepositoryImpl$stable = 0;
  client_fstech_hadaya_data_repository_FriendRepositoryImpl$stable = 0;
  client_fstech_hadaya_data_repository_NotificationRepositoryImpl$stable = 8;
  client_fstech_hadaya_data_repository_OrderRepositoryImpl$stable = 0;
  client_fstech_hadaya_data_repository_ProductViewRequest_$serializer$stable = 0;
  client_fstech_hadaya_data_repository_ProductViewRequest$stable = 0;
  client_fstech_hadaya_data_repository_ProductRepositoryImpl$stable = 0;
  Companion_instance_5 = new Companion();
  client_fstech_hadaya_data_repository_DoubleOrNullSerializer$stable = 0;
  client_fstech_hadaya_data_repository_SettingsRepositoryImpl_AppSetting_$serializer$stable = 0;
  client_fstech_hadaya_data_repository_SettingsRepositoryImpl$stable = 8;
  Companion_instance_6 = new Companion_0();
  client_fstech_hadaya_data_repository_StockReminderRepositoryImpl$stable = 0;
  client_fstech_hadaya_data_repository_StorageRepositoryImpl$stable = 8;
  client_fstech_hadaya_data_source_local_AppDatabase$stable = 8;
  client_fstech_hadaya_data_source_local_Converters$stable = 8;
  client_fstech_hadaya_data_source_local_MemoryCartDao$stable = 8;
  client_fstech_hadaya_data_source_local_MemoryProductDao$stable = 8;
  client_fstech_hadaya_data_source_local_MemoryBannerDao$stable = 8;
  client_fstech_hadaya_data_source_local_MemoryFavoriteDao$stable = 0;
  client_fstech_hadaya_data_source_local_MemoryAppDatabase$stable = 0;
  client_fstech_hadaya_domain_model_Banner_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_Banner$stable = 0;
  client_fstech_hadaya_domain_model_Box_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_Box$stable = 0;
  Companion_instance_8 = new Companion_2();
  client_fstech_hadaya_domain_model_Card_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_Card$stable = 0;
  Companion_instance_9 = new Companion_3();
  client_fstech_hadaya_domain_model_DesignLayer_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_DesignLayer$stable = 8;
  client_fstech_hadaya_domain_model_CartItem_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_CartItem$stable = 8;
  client_fstech_hadaya_domain_model_Category_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_Category$stable = 0;
  client_fstech_hadaya_domain_model_Coupon_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_Coupon$stable = 0;
  client_fstech_hadaya_domain_model_CouponAlreadyUsedException$stable = 8;
  client_fstech_hadaya_domain_model_FavoriteProduct_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_FavoriteProduct$stable = 0;
  Companion_instance_14 = new Companion_8();
  client_fstech_hadaya_domain_model_FlexibleListSerializer$stable = 0;
  client_fstech_hadaya_domain_model_Friend_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_Friend$stable = 0;
  Companion_instance_15 = new Companion_9();
  client_fstech_hadaya_domain_model_Notification_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_Notification$stable = 0;
  Companion_instance_16 = new Companion_10();
  client_fstech_hadaya_domain_model_Order_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_Order$stable = 8;
  client_fstech_hadaya_domain_model_OptionValue_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_OptionValue$stable = 8;
  client_fstech_hadaya_domain_model_ProductOption_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_ProductOption$stable = 8;
  client_fstech_hadaya_domain_model_Product_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_Product$stable = 0;
  client_fstech_hadaya_domain_model_Profile_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_Profile$stable = 0;
  Companion_instance_25 = new Companion_19();
  client_fstech_hadaya_domain_model_StockReminder_$serializer$stable = 0;
  client_fstech_hadaya_domain_model_StockReminder$stable = 0;
  Companion_instance_26 = new Companion_20();
  client_fstech_hadaya_domain_usecase_ApplyCouponUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_CreateWelcomeCouponUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_FetchProfileUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_GetBannersUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_GetCurrentUserUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_GetCurrentUserValueUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_GetFavoriteProductsUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_GetProductsUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_GetUserCouponsUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_HandleRecoveryLinkUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_LoginUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_LoginWithGoogleUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_MarkCouponAsUsedUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_NotifyAdminUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_RegisterUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_ResetPasswordUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_UpdateFcmTokenUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_UpdatePasswordUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_UpdateProfileUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_cart_AddToCartUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_cart_ClearCartUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_cart_GetCartItemByIdUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_cart_GetCartItemsUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_cart_RemoveFromCartUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_cart_SyncCartUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_cart_UpdateCartQuantityUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_favorites_SyncFavoritesUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_favorites_ToggleFavoriteUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_friends_AddFriendUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_friends_DeleteFriendAvatarUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_friends_DeleteFriendUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_friends_GetFriendsUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_friends_UpdateFriendUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_friends_UploadFriendAvatarUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_language_GetLanguageUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_language_SetLanguageUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_network_IsConnectedUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_order_GetOrderByIdUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_order_GetOrderHistoryUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_order_PlaceOrderUseCase$stable = 0;
  client_fstech_hadaya_domain_usecase_order_RequestReturnUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_products_GetProductByIdUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_products_GetStockRemindersUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_products_ToggleStockReminderUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_settings_CheckUpdateUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_settings_GetShippingCostUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_storage_DownloadDesignImageUseCase$stable = 8;
  client_fstech_hadaya_domain_usecase_storage_UploadDesignImageUseCase$stable = 8;
  client_fstech_hadaya_presentation_AppViewModel$stable = 8;
  Companion_instance_31 = new Companion_25();
  Companion_instance_32 = new Companion_26();
  Companion_instance_34 = new Companion_28();
  Companion_instance_35 = new Companion_29();
  Companion_instance_36 = new Companion_30();
  Companion_instance_37 = new Companion_31();
  Companion_instance_38 = new Companion_32();
  Companion_instance_39 = new Companion_33();
  Companion_instance_40 = new Companion_34();
  Companion_instance_41 = new Companion_35();
  Companion_instance_42 = new Companion_36();
  Companion_instance_43 = new Companion_37();
  client_fstech_hadaya_presentation_accountmanagement_AccountManagementState$stable = 0;
  client_fstech_hadaya_presentation_accountmanagement_AccountManagementIntent_DeleteAccount$stable = 0;
  client_fstech_hadaya_presentation_accountmanagement_AccountManagementIntent_DeleteAccountWithToken$stable = 0;
  client_fstech_hadaya_presentation_accountmanagement_AccountManagementSideEffect_ShowError$stable = 8;
  client_fstech_hadaya_presentation_accountmanagement_AccountManagementSideEffect_NavigateToSuccess$stable = 0;
  client_fstech_hadaya_presentation_accountmanagement_AccountManagementViewModel$stable = 8;
  NavigateToSuccess_instance = new NavigateToSuccess();
  client_fstech_hadaya_presentation_auth_AuthState$stable = 8;
  client_fstech_hadaya_presentation_auth_AuthPage_Login$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthPage_Register$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthPage_ForgetPassword$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthPage_SetPassword$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthIntent_EmailChanged$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthIntent_PasswordChanged$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthIntent_ConfirmPasswordChanged$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthIntent_RecoveryUrlReceived$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthIntent_LoginClicked$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthIntent_GoogleLoginClicked$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthIntent_RegisterClicked$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthIntent_ForgetPasswordClicked$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthIntent_SetPasswordClicked$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthIntent_TogglePrivacyPolicy$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthIntent_ToggleKeepLogin$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthIntent_NavigateTo$stable = 8;
  client_fstech_hadaya_presentation_auth_AuthSideEffect_NavigateToHome$stable = 0;
  client_fstech_hadaya_presentation_auth_AuthSideEffect_ShowError$stable = 8;
  client_fstech_hadaya_presentation_auth_AuthSideEffect_ShowMessage$stable = 8;
  LoginClicked_instance = new LoginClicked();
  RegisterClicked_instance = new RegisterClicked();
  ForgetPasswordClicked_instance = new ForgetPasswordClicked();
  SetPasswordClicked_instance = new SetPasswordClicked();
  NavigateToHome_instance = new NavigateToHome();
  Login_instance = new Login();
  Register_instance = new Register();
  ForgetPassword_instance = new ForgetPassword();
  SetPassword_instance = new SetPassword();
  client_fstech_hadaya_presentation_auth_AuthNavigatorImpl$stable = 8;
  client_fstech_hadaya_presentation_auth_AuthViewModel$stable = 8;
  client_fstech_hadaya_presentation_cart_CartState$stable = 8;
  client_fstech_hadaya_presentation_cart_CartIntent_LoadCart$stable = 0;
  client_fstech_hadaya_presentation_cart_CartIntent_UpdateQuantity$stable = 8;
  client_fstech_hadaya_presentation_cart_CartIntent_RemoveItem$stable = 8;
  client_fstech_hadaya_presentation_cart_CartIntent_Checkout$stable = 0;
  client_fstech_hadaya_presentation_cart_CartIntent_ClearCart$stable = 0;
  client_fstech_hadaya_presentation_cart_CartSideEffect_ShowError$stable = 8;
  client_fstech_hadaya_presentation_cart_CartSideEffect_NavigateToCheckout$stable = 0;
  client_fstech_hadaya_presentation_cart_CartSideEffect_NavigateToAuth$stable = 0;
  LoadCart_instance = new LoadCart();
  Checkout_instance_0 = new Checkout_0();
  ClearCart_instance = new ClearCart();
  NavigateToCheckout_instance = new NavigateToCheckout();
  NavigateToAuth_instance = new NavigateToAuth();
  client_fstech_hadaya_presentation_cart_CartViewModel$stable = 8;
  client_fstech_hadaya_presentation_cart_details_CartMagicMugProductDetailsState$stable = 8;
  client_fstech_hadaya_presentation_cart_details_CartMagicMugProductDetailsIntent_LoadItem$stable = 8;
  client_fstech_hadaya_presentation_cart_details_CartMagicMugProductDetailsSideEffect_NavigateBack$stable = 0;
  client_fstech_hadaya_presentation_cart_details_CartMagicMugProductDetailsViewModel$stable = 8;
  client_fstech_hadaya_presentation_cart_details_CartMugProductDetailsState$stable = 8;
  client_fstech_hadaya_presentation_cart_details_CartMugProductDetailsIntent_LoadItem$stable = 8;
  client_fstech_hadaya_presentation_cart_details_CartMugProductDetailsSideEffect_NavigateBack$stable = 0;
  client_fstech_hadaya_presentation_cart_details_CartMugProductDetailsViewModel$stable = 8;
  client_fstech_hadaya_presentation_cart_details_CartNormalProductDetailsState$stable = 8;
  client_fstech_hadaya_presentation_cart_details_CartNormalProductDetailsIntent_LoadItem$stable = 8;
  client_fstech_hadaya_presentation_cart_details_CartNormalProductDetailsSideEffect_NavigateBack$stable = 0;
  client_fstech_hadaya_presentation_cart_details_CartNormalProductDetailsViewModel$stable = 8;
  client_fstech_hadaya_presentation_checkout_CheckoutState$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_LoadData$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_Retry$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_ToggleShippingType$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_SelectFriend$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_UpdateMyAddress$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_UpdateMyPhone$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_UpdateMyFirstName$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_UpdateMyLastName$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_UpdateMyGovernorate$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_SelectPaymentMethod$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_PlaceOrder$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_RetryShippingFetch$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_AddFriend$stable = 8;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_ToggleAddFriendDialog$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_UpdateCouponCode$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutIntent_ApplyCoupon$stable = 0;
  client_fstech_hadaya_presentation_checkout_CheckoutSideEffect_ShowError$stable = 8;
  client_fstech_hadaya_presentation_checkout_CheckoutSideEffect_OrderPlaced$stable = 8;
  client_fstech_hadaya_presentation_checkout_CheckoutSideEffect_FriendAdded$stable = 0;
  LoadData_instance = new LoadData();
  Retry_instance = new Retry();
  PlaceOrder_instance = new PlaceOrder();
  RetryShippingFetch_instance = new RetryShippingFetch();
  ApplyCoupon_instance = new ApplyCoupon();
  FriendAdded_instance = new FriendAdded();
  client_fstech_hadaya_presentation_checkout_CheckoutViewModel$stable = 8;
  client_fstech_hadaya_presentation_coupons_CouponsState$stable = 0;
  client_fstech_hadaya_presentation_coupons_CouponsIntent_LoadCoupons$stable = 0;
  client_fstech_hadaya_presentation_coupons_CouponsIntent_ChangeFilter$stable = 0;
  client_fstech_hadaya_presentation_coupons_CouponsSideEffect_ShowMessage$stable = 8;
  LoadCoupons_instance = new LoadCoupons();
  client_fstech_hadaya_presentation_coupons_CouponsViewModel$stable = 8;
  client_fstech_hadaya_presentation_favorites_FavoritesState$stable = 8;
  client_fstech_hadaya_presentation_favorites_FavoritesIntent_LoadFavorites$stable = 0;
  client_fstech_hadaya_presentation_favorites_FavoritesIntent_ToggleFavorite$stable = 0;
  client_fstech_hadaya_presentation_favorites_FavoritesSideEffect_ShowError$stable = 0;
  LoadFavorites_instance = new LoadFavorites();
  client_fstech_hadaya_presentation_favorites_FavoritesViewModel$stable = 8;
  client_fstech_hadaya_presentation_friends_FriendsState$stable = 8;
  client_fstech_hadaya_presentation_friends_FriendsIntent_LoadFriends$stable = 0;
  client_fstech_hadaya_presentation_friends_FriendsIntent_AddFriend$stable = 8;
  client_fstech_hadaya_presentation_friends_FriendsIntent_UpdateFriend$stable = 8;
  client_fstech_hadaya_presentation_friends_FriendsIntent_DeleteFriend$stable = 0;
  client_fstech_hadaya_presentation_friends_FriendsIntent_ToggleAddFriendDialog$stable = 0;
  client_fstech_hadaya_presentation_friends_FriendsIntent_ShowEditFriendDialog$stable = 0;
  client_fstech_hadaya_presentation_friends_FriendsIntent_ShowDeleteFriendDialog$stable = 0;
  client_fstech_hadaya_presentation_friends_FriendsSideEffect_ShowError$stable = 8;
  client_fstech_hadaya_presentation_friends_FriendsSideEffect_FriendAdded$stable = 0;
  client_fstech_hadaya_presentation_friends_FriendsSideEffect_FriendUpdated$stable = 0;
  client_fstech_hadaya_presentation_friends_FriendsSideEffect_FriendDeleted$stable = 0;
  LoadFriends_instance = new LoadFriends();
  FriendAdded_instance_0 = new FriendAdded_0();
  FriendUpdated_instance = new FriendUpdated();
  FriendDeleted_instance = new FriendDeleted();
  client_fstech_hadaya_presentation_friends_FriendsViewModel$stable = 8;
  client_fstech_hadaya_presentation_model3d_EditMugDesignState$stable = 8;
  client_fstech_hadaya_presentation_model3d_EditMugDesignIntent_LoadCartItem$stable = 0;
  client_fstech_hadaya_presentation_model3d_EditMugDesignIntent_Model3D$stable = 8;
  client_fstech_hadaya_presentation_model3d_EditMugDesignIntent_UpdateMugDesign$stable = 8;
  client_fstech_hadaya_presentation_model3d_EditMugDesignSideEffect_ShowMessage$stable = 8;
  client_fstech_hadaya_presentation_model3d_EditMugDesignSideEffect_NavigateBack$stable = 0;
  client_fstech_hadaya_presentation_model3d_EditMugDesignSideEffect_NavigateToEditor$stable = 0;
  client_fstech_hadaya_presentation_model3d_EditMugDesignSideEffect_Model3D$stable = 8;
  NavigateBack_instance = new NavigateBack();
  client_fstech_hadaya_presentation_model3d_EditMugDesignViewModel$stable = 8;
  AddToCart_instance = new AddToCart();
  RemoveCustomization_instance = new RemoveCustomization();
  OpenEditor_instance = new OpenEditor();
  CloseEditor_instance = new CloseEditor();
  NavigateBack_instance_0 = new NavigateBack_0();
  NavigateToAuth_instance_0 = new NavigateToAuth_0();
  client_fstech_hadaya_presentation_model3d_ModelMugViewModel$stable = 8;
  client_fstech_hadaya_presentation_mvi_BaseMviViewModel$stable = 8;
  client_fstech_hadaya_presentation_order_OrderState$stable = 8;
  client_fstech_hadaya_presentation_order_OrderIntent_SetOrder$stable = 8;
  client_fstech_hadaya_presentation_order_OrderIntent_UpdateComment$stable = 0;
  client_fstech_hadaya_presentation_order_OrderIntent_ConfirmOrder$stable = 0;
  client_fstech_hadaya_presentation_order_OrderSideEffect_ShowError$stable = 8;
  client_fstech_hadaya_presentation_order_OrderSideEffect_NavigateToHome$stable = 0;
  ConfirmOrder_instance = new ConfirmOrder();
  NavigateToHome_instance_0 = new NavigateToHome_0();
  client_fstech_hadaya_presentation_order_OrderViewModel$stable = 8;
  client_fstech_hadaya_presentation_order_details_OrderDetailsState$stable = 0;
  client_fstech_hadaya_presentation_order_details_OrderDetailsIntent_ReAddToCart$stable = 8;
  client_fstech_hadaya_presentation_order_details_OrderDetailsIntent_RequestReturn$stable = 0;
  client_fstech_hadaya_presentation_order_details_OrderDetailsIntent_ToggleFavorite$stable = 0;
  client_fstech_hadaya_presentation_order_details_OrderDetailsIntent_ToggleStockReminder$stable = 0;
  client_fstech_hadaya_presentation_order_details_OrderDetailsSideEffect_ShowMessage$stable = 0;
  client_fstech_hadaya_presentation_order_details_OrderDetailsSideEffect_ShowStockDialog$stable = 0;
  client_fstech_hadaya_presentation_order_details_OrderDetailsSideEffect_NavigateBack$stable = 0;
  NavigateBack_instance_1 = new NavigateBack_1();
  client_fstech_hadaya_presentation_order_details_OrderDetailsViewModel$stable = 8;
  client_fstech_hadaya_presentation_order_history_OrderHistoryState$stable = 0;
  client_fstech_hadaya_presentation_order_history_OrderHistoryIntent_LoadOrders$stable = 0;
  client_fstech_hadaya_presentation_order_history_OrderHistoryIntent_FilterChanged$stable = 0;
  client_fstech_hadaya_presentation_order_history_OrderHistorySideEffect_ShowError$stable = 0;
  LoadOrders_instance = new LoadOrders();
  client_fstech_hadaya_presentation_order_history_OrderHistoryViewModel$stable = 8;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsState$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_LoadProduct$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_AddToCart$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_ToggleStockReminder$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_QuantityChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_ToggleFavorite$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_KindChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_TargetAudienceChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_CardSelected$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_CardMessageChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_CardBirthdayChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_BoxSelected$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_BoxMessageChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_BoxBirthdayChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_SizeSelected$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_ColorSelected$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_OptionSelected$stable = 8;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_ProductCommentChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_BraceletNameChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsIntent_ShareProduct$stable = 0;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsSideEffect_ShowMessage$stable = 8;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsSideEffect_ShowToast$stable = 8;
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsSideEffect_NavigateToAuth$stable = 0;
  AddToCart_instance_0 = new AddToCart_0();
  ToggleStockReminder_instance = new ToggleStockReminder_0();
  ToggleFavorite_instance = new ToggleFavorite_1();
  ShareProduct_instance = new ShareProduct();
  NavigateToAuth_instance_1 = new NavigateToAuth_1();
  client_fstech_hadaya_presentation_product_details_BeadsProductDetailsViewModel$stable = 8;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsState$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_LoadProduct$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_AddToCart$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_ToggleStockReminder$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_QuantityChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_ToggleFavorite$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_OpenEditor$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_CloseEditor$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_CustomImageApplied$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_UpdateElements$stable = 8;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_RemoveCustomization$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_KindChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_TargetAudienceChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_CardSelected$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_CardMessageChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_CardBirthdayChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_BoxSelected$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_BoxMessageChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_BoxBirthdayChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_SizeSelected$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_ColorSelected$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_OptionSelected$stable = 8;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_ProductCommentChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsIntent_ShareProduct$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsSideEffect_ShowMessage$stable = 8;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsSideEffect_ShowToast$stable = 8;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsSideEffect_NavigateToAuth$stable = 0;
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsSideEffect_NavigateBack$stable = 0;
  AddToCart_instance_1 = new AddToCart_1();
  ToggleStockReminder_instance_0 = new ToggleStockReminder_1();
  ToggleFavorite_instance_0 = new ToggleFavorite_2();
  OpenEditor_instance_0 = new OpenEditor_0();
  CloseEditor_instance_0 = new CloseEditor_0();
  RemoveCustomization_instance_0 = new RemoveCustomization_0();
  ShareProduct_instance_0 = new ShareProduct_0();
  NavigateToAuth_instance_2 = new NavigateToAuth_2();
  NavigateBack_instance_2 = new NavigateBack_2();
  client_fstech_hadaya_presentation_product_details_CustomProductDetailsViewModel$stable = 8;
  client_fstech_hadaya_presentation_product_details_ProductDetailsState$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_LoadProduct$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_AddToCart$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_ToggleStockReminder$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_QuantityChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_ToggleFavorite$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_KindChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_TargetAudienceChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_CardSelected$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_CardMessageChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_CardBirthdayChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_BoxSelected$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_BoxMessageChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_BoxBirthdayChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_SizeSelected$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_ColorSelected$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_OptionSelected$stable = 8;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_ProductCommentChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_BraceletNameChanged$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsIntent_ShareProduct$stable = 0;
  client_fstech_hadaya_presentation_product_details_ProductDetailsSideEffect_ShowMessage$stable = 8;
  client_fstech_hadaya_presentation_product_details_ProductDetailsSideEffect_ShowToast$stable = 8;
  client_fstech_hadaya_presentation_product_details_ProductDetailsSideEffect_NavigateToAuth$stable = 0;
  AddToCart_instance_2 = new AddToCart_2();
  ToggleStockReminder_instance_1 = new ToggleStockReminder_2();
  ToggleFavorite_instance_1 = new ToggleFavorite_3();
  ShareProduct_instance_1 = new ShareProduct_1();
  NavigateToAuth_instance_3 = new NavigateToAuth_3();
  client_fstech_hadaya_presentation_product_details_ProductDetailsViewModel$stable = 8;
  client_fstech_hadaya_presentation_profile_ProfileState$stable = 0;
  client_fstech_hadaya_presentation_profile_ProfileIntent_LogoutClicked$stable = 0;
  client_fstech_hadaya_presentation_profile_ProfileIntent_DeleteAccountClicked$stable = 0;
  client_fstech_hadaya_presentation_profile_ProfileSideEffect_NavigateToAuth$stable = 0;
  client_fstech_hadaya_presentation_profile_ProfileSideEffect_ShowError$stable = 0;
  client_fstech_hadaya_presentation_reminders_StockRemindersState$stable = 8;
  client_fstech_hadaya_presentation_reminders_StockRemindersIntent_LoadReminders$stable = 0;
  client_fstech_hadaya_presentation_reminders_StockRemindersIntent_RemoveReminder$stable = 0;
  client_fstech_hadaya_presentation_reminders_StockRemindersSideEffect_ShowError$stable = 0;
  LoadReminders_instance = new LoadReminders();
  client_fstech_hadaya_presentation_reminders_StockRemindersViewModel$stable = 8;
  client_fstech_hadaya_presentation_shopping_ShoppingState$stable = 0;
  client_fstech_hadaya_presentation_shopping_ShoppingIntent_LoadProducts$stable = 0;
  client_fstech_hadaya_presentation_shopping_ShoppingIntent_SearchChanged$stable = 0;
  client_fstech_hadaya_presentation_shopping_ShoppingIntent_PriceFilterChanged$stable = 0;
  client_fstech_hadaya_presentation_shopping_ShoppingIntent_AgeFilterChanged$stable = 0;
  client_fstech_hadaya_presentation_shopping_ShoppingIntent_CustomFilterChanged$stable = 0;
  client_fstech_hadaya_presentation_shopping_ShoppingIntent_RatingFilterChanged$stable = 0;
  client_fstech_hadaya_presentation_shopping_ShoppingIntent_SortOrderChanged$stable = 0;
  client_fstech_hadaya_presentation_shopping_ShoppingIntent_RefreshData$stable = 0;
  client_fstech_hadaya_presentation_shopping_ShoppingIntent_ToggleFavorite$stable = 0;
  client_fstech_hadaya_presentation_shopping_ShoppingIntent_ToggleLanguage$stable = 0;
  client_fstech_hadaya_presentation_shopping_ShoppingSideEffect_ShowError$stable = 0;
  LoadProducts_instance = new LoadProducts();
  RefreshData_instance = new RefreshData();
  ToggleLanguage_instance = new ToggleLanguage();
  client_fstech_hadaya_presentation_shopping_ShoppingViewModel$stable = 8;
  client_fstech_hadaya_util_LatLng_$serializer$stable = 0;
  client_fstech_hadaya_util_LatLng$stable = 0;
  Companion_instance_44 = new Companion_38();
  client_fstech_hadaya_util_UiText_DynamicString$stable = 0;
  client_fstech_hadaya_util_UiText_ResourceString$stable = 8;
  client_fstech_hadaya_WebAnalyticsHelper$stable = 0;
  client_fstech_hadaya_JsPlatform$stable = 8;
  client_fstech_hadaya_LanguageSwitcher$stable = 0;
  client_fstech_hadaya_JsNetworkObserver$stable = 0;
  client_fstech_hadaya_data_local_SupabaseSessionManager$stable = 8;
  client_fstech_hadaya_util_JsLocationService$stable = 0;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = initKoin;
  _.$_$.b = AppViewModel;
  _.$_$.c = Auth_0;
  _.$_$.d = BeadsProductDetails;
  _.$_$.e = CartMagicMugProductDetails;
  _.$_$.f = CartMugProductDetails;
  _.$_$.g = CartNormalProductDetails;
  _.$_$.h = CustomMagicMugDetails;
  _.$_$.i = CustomMugDetails;
  _.$_$.j = DeleteAccountStandalone;
  _.$_$.k = Model3D;
  _.$_$.l = OrderDetails;
  _.$_$.m = PastOrderDetails;
  _.$_$.n = ProductDetails;
  _.$_$.o = App;
  _.$_$.p = IAnalyticsHelper;
  _.$_$.q = AccountManagement_getInstance;
  _.$_$.r = Cart_getInstance;
  _.$_$.s = Coupons_getInstance;
  _.$_$.t = DeleteAccountSuccess_getInstance;
  _.$_$.u = Favorites_getInstance;
  _.$_$.v = Friends_getInstance;
  _.$_$.w = OrderHistory_getInstance;
  _.$_$.x = Profile_getInstance;
  _.$_$.y = ResetPasswordSuccess_getInstance;
  _.$_$.z = Shopping_getInstance;
  _.$_$.a1 = StockReminders_getInstance;
  //endregion
  return _;
}));

//# sourceMappingURL=Hadaya_client_web-shared.js.map
